(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode('.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  margin-left: -8px;\n  position: absolute;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  box-sizing: content-box;\n  position: absolute;\n  border: 8px solid transparent;\n  height: 0;\n  width: 1px;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  content: "";\n  z-index: -1;\n  border-width: 8px;\n  left: -8px;\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle {\n  top: 0;\n  margin-top: -8px;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {\n  border-top: none;\n  border-bottom-color: #f0f0f0;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {\n  top: -1px;\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  bottom: 0;\n  margin-bottom: -8px;\n}\n\n.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  border-bottom: none;\n  border-top-color: #fff;\n}\n\n.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  bottom: -1px;\n  border-top-color: #aeaeae;\n}\n\n.react-datepicker-wrapper {\n  display: inline-block;\n  padding: 0;\n  border: 0;\n}\n\n.react-datepicker {\n  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n  font-size: 0.8rem;\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  display: inline-block;\n  position: relative;\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n  left: 35px;\n}\n\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n\n.react-datepicker--time-only .react-datepicker__time {\n  border-radius: 0.3rem;\n}\n\n.react-datepicker--time-only .react-datepicker__time-box {\n  border-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 1;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] {\n  margin-top: 10px;\n}\n\n.react-datepicker-popper[data-placement="bottom-end"] .react-datepicker__triangle, .react-datepicker-popper[data-placement="top-end"] .react-datepicker__triangle {\n  left: auto;\n  right: 50px;\n}\n\n.react-datepicker-popper[data-placement^="top"] {\n  margin-bottom: 10px;\n}\n\n.react-datepicker-popper[data-placement^="right"] {\n  margin-left: 8px;\n}\n\n.react-datepicker-popper[data-placement^="right"] .react-datepicker__triangle {\n  left: auto;\n  right: 42px;\n}\n\n.react-datepicker-popper[data-placement^="left"] {\n  margin-right: 8px;\n}\n\n.react-datepicker-popper[data-placement^="left"] .react-datepicker__triangle {\n  left: 42px;\n  right: auto;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #f0f0f0;\n  border-bottom: 1px solid #aeaeae;\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  padding-top: 8px;\n  position: relative;\n}\n\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  margin-top: 0;\n  color: #000;\n  font-weight: bold;\n  font-size: 0.944rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  background: none;\n  line-height: 1.7rem;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 10px;\n  width: 0;\n  padding: 0;\n  border: 0.45rem solid transparent;\n  z-index: 1;\n  height: 10px;\n  width: 10px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation--previous {\n  left: 10px;\n  border-right-color: #ccc;\n}\n\n.react-datepicker__navigation--previous:hover {\n  border-right-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__navigation--next {\n  right: 10px;\n  border-left-color: #ccc;\n}\n\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 80px;\n}\n\n.react-datepicker__navigation--next:hover {\n  border-left-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n  border-top-color: #ccc;\n}\n\n.react-datepicker__navigation--years-previous:hover {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n  border-bottom-color: #ccc;\n}\n\n.react-datepicker__navigation--years-upcoming:hover {\n  border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__year-container {\n  margin: 0.4rem;\n  text-align: center;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.react-datepicker__year-container-text {\n  display: inline-block;\n  cursor: pointer;\n  flex: 1 0 30%;\n  width: 12px;\n  padding: 2px;\n}\n\n.react-datepicker__month {\n  margin: 0.4rem;\n  text-align: center;\n}\n\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__input-time-container {\n  clear: both;\n  width: 100%;\n  float: left;\n  margin: 5px 0 10px 15px;\n  text-align: left;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__caption {\n  display: inline-block;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container {\n  display: inline-block;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {\n  width: 85px;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"]::-webkit-inner-spin-button,\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"] {\n  -moz-appearance: textfield;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {\n  margin-left: 5px;\n  display: inline-block;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #aeaeae;\n  width: 85px;\n}\n\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -72px;\n  top: 0;\n}\n\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 85px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  height: calc(195px + (1.7rem / 2));\n  overflow-y: scroll;\n  padding-right: 0px;\n  padding-left: 0px;\n  width: 100%;\n  box-sizing: content-box;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  height: 30px;\n  padding: 5px 10px;\n  white-space: nowrap;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #216ba5;\n  color: white;\n  font-weight: bold;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #216ba5;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n  color: #ccc;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ccc;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #000;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__month--selected, .react-datepicker__month--in-selecting-range, .react-datepicker__month--in-range,\n.react-datepicker__quarter--selected,\n.react-datepicker__quarter--in-selecting-range,\n.react-datepicker__quarter--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n\n.react-datepicker__month--selected:hover, .react-datepicker__month--in-selecting-range:hover, .react-datepicker__month--in-range:hover,\n.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter--in-selecting-range:hover,\n.react-datepicker__quarter--in-range:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__month--disabled,\n.react-datepicker__quarter--disabled {\n  color: #ccc;\n  pointer-events: none;\n}\n\n.react-datepicker__month--disabled:hover,\n.react-datepicker__quarter--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text,\n.react-datepicker__quarter-text {\n  cursor: pointer;\n}\n\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day--today,\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today {\n  font-weight: bold;\n}\n\n.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted,\n.react-datepicker__quarter-text--highlighted {\n  border-radius: 0.3rem;\n  background-color: #3dcc4a;\n  color: #fff;\n}\n\n.react-datepicker__day--highlighted:hover,\n.react-datepicker__month-text--highlighted:hover,\n.react-datepicker__quarter-text--highlighted:hover {\n  background-color: #32be3f;\n}\n\n.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1,\n.react-datepicker__quarter-text--highlighted-custom-1 {\n  color: magenta;\n}\n\n.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2,\n.react-datepicker__quarter-text--highlighted-custom-2 {\n  color: green;\n}\n\n.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n\n.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #2a87d0;\n  color: #fff;\n}\n\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day--in-selecting-range ,\n.react-datepicker__month-text--in-selecting-range ,\n.react-datepicker__quarter-text--in-selecting-range {\n  background-color: rgba(33, 107, 165, 0.5);\n}\n\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range , .react-datepicker__month--selecting-range\n.react-datepicker__month-text--in-range , .react-datepicker__month--selecting-range\n.react-datepicker__quarter-text--in-range {\n  background-color: #f0f0f0;\n  color: #000;\n}\n\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled {\n  cursor: default;\n  color: #ccc;\n}\n\n.react-datepicker__day--disabled:hover,\n.react-datepicker__month-text--disabled:hover,\n.react-datepicker__quarter-text--disabled:hover {\n  background-color: transparent;\n}\n\n.react-datepicker__month-text.react-datepicker__month--selected:hover, .react-datepicker__month-text.react-datepicker__month--in-range:hover, .react-datepicker__month-text.react-datepicker__quarter--selected:hover, .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n  background-color: #216ba5;\n}\n\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover {\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n}\n\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  border-top-color: #ccc;\n  float: right;\n  margin-left: 20px;\n  top: 8px;\n  position: relative;\n  border-width: 0.45rem;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #f0f0f0;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid #aeaeae;\n}\n\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ccc;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  padding: 0px 6px 0px 0px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.react-datepicker__close-icon::after {\n  cursor: pointer;\n  background-color: #216ba5;\n  color: #fff;\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n  padding: 2px;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n  content: "\\00d7";\n}\n\n.react-datepicker__today-button {\n  background: #f0f0f0;\n  border-top: 1px solid #aeaeae;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  z-index: 2147483647;\n}\n\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.44rem;\n}\n\n.react-datepicker__portal .react-datepicker__navigation {\n  border: 0.81rem solid transparent;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous {\n  border-right-color: #ccc;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous:hover {\n  border-right-color: #b3b3b3;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next {\n  border-left-color: #ccc;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next:hover {\n  border-left-color: #b3b3b3;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: #e6e6e6;\n  cursor: default;\n}'));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key2, value) => key2 in obj ? __defProp(obj, key2, { enumerable: true, configurable: true, writable: true, value }) : obj[key2] = value;
var __publicField = (obj, key2, value) => __defNormalProp(obj, typeof key2 !== "symbol" ? key2 + "" : key2, value);
var _a, _b, _c, _d, _e, _f, _g, _h, _i;
import { jsx as jsx$1, jsxs, Fragment as Fragment$1 } from "react/jsx-runtime";
import * as React$2 from "react";
import React__default, { Component, useState, useRef, useEffect, useMemo, memo, Fragment, Children as Children$1, useContext, createElement as createElement$2, useImperativeHandle, useCallback, useReducer, forwardRef, cloneElement, createContext as createContext$1, useLayoutEffect, PureComponent, createRef } from "react";
import ReactDOM, { createPortal, flushSync, findDOMNode } from "react-dom";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs$1(x3) {
  return x3 && x3.__esModule && Object.prototype.hasOwnProperty.call(x3, "default") ? x3["default"] : x3;
}
function getAugmentedNamespace(n2) {
  if (n2.__esModule) return n2;
  var f2 = n2.default;
  if (typeof f2 == "function") {
    var a4 = function a5() {
      if (this instanceof a5) {
        return Reflect.construct(f2, arguments, this.constructor);
      }
      return f2.apply(this, arguments);
    };
    a4.prototype = f2.prototype;
  } else a4 = {};
  Object.defineProperty(a4, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k3) {
    var d4 = Object.getOwnPropertyDescriptor(n2, k3);
    Object.defineProperty(a4, k3, d4.get ? d4 : {
      enumerable: true,
      get: function() {
        return n2[k3];
      }
    });
  });
  return a4;
}
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module2) {
  (function() {
    var hasOwn2 = {}.hasOwnProperty;
    function classNames2() {
      var classes = "";
      for (var i3 = 0; i3 < arguments.length; i3++) {
        var arg = arguments[i3];
        if (arg) {
          classes = appendClass(classes, parseValue(arg));
        }
      }
      return classes;
    }
    function parseValue(arg) {
      if (typeof arg === "string" || typeof arg === "number") {
        return arg;
      }
      if (typeof arg !== "object") {
        return "";
      }
      if (Array.isArray(arg)) {
        return classNames2.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
        return arg.toString();
      }
      var classes = "";
      for (var key2 in arg) {
        if (hasOwn2.call(arg, key2) && arg[key2]) {
          classes = appendClass(classes, key2);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + " " + newClass;
      }
      return value + newClass;
    }
    if (module2.exports) {
      classNames2.default = classNames2;
      module2.exports = classNames2;
    } else {
      window.classNames = classNames2;
    }
  })();
})(classnames);
var classnamesExports = classnames.exports;
const classNames = /* @__PURE__ */ getDefaultExportFromCjs$1(classnamesExports);
function getDefaultExportFromCjs(x3) {
  return x3 && x3.__esModule && Object.prototype.hasOwnProperty.call(x3, "default") ? x3["default"] : x3;
}
var browser$1 = { exports: {} };
var process$1 = browser$1.exports = {};
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    if (typeof setTimeout === "function") {
      cachedSetTimeout = setTimeout;
    } else {
      cachedSetTimeout = defaultSetTimout;
    }
  } catch (e5) {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    if (typeof clearTimeout === "function") {
      cachedClearTimeout = clearTimeout;
    } else {
      cachedClearTimeout = defaultClearTimeout;
    }
  } catch (e5) {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    return setTimeout(fun, 0);
  }
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }
  try {
    return cachedSetTimeout(fun, 0);
  } catch (e5) {
    try {
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e6) {
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}
function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    return clearTimeout(marker);
  }
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }
  try {
    return cachedClearTimeout(marker);
  } catch (e5) {
    try {
      return cachedClearTimeout.call(null, marker);
    } catch (e6) {
      return cachedClearTimeout.call(this, marker);
    }
  }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }
  draining = false;
  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }
  if (queue.length) {
    drainQueue();
  }
}
function drainQueue() {
  if (draining) {
    return;
  }
  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;
  while (len) {
    currentQueue = queue;
    queue = [];
    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }
    queueIndex = -1;
    len = queue.length;
  }
  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}
process$1.nextTick = function(fun) {
  var args = new Array(arguments.length - 1);
  if (arguments.length > 1) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      args[i3 - 1] = arguments[i3];
    }
  }
  queue.push(new Item$2(fun, args));
  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
};
function Item$2(fun, array) {
  this.fun = fun;
  this.array = array;
}
Item$2.prototype.run = function() {
  this.fun.apply(null, this.array);
};
process$1.title = "browser";
process$1.browser = true;
process$1.env = {};
process$1.argv = [];
process$1.version = "";
process$1.versions = {};
function noop$3() {
}
process$1.on = noop$3;
process$1.addListener = noop$3;
process$1.once = noop$3;
process$1.off = noop$3;
process$1.removeListener = noop$3;
process$1.removeAllListeners = noop$3;
process$1.emit = noop$3;
process$1.prependListener = noop$3;
process$1.prependOnceListener = noop$3;
process$1.listeners = function(name2) {
  return [];
};
process$1.binding = function(name2) {
  throw new Error("process.binding is not supported");
};
process$1.cwd = function() {
  return "/";
};
process$1.chdir = function(dir) {
  throw new Error("process.chdir is not supported");
};
process$1.umask = function() {
  return 0;
};
var browserExports = browser$1.exports;
const process$1$1 = /* @__PURE__ */ getDefaultExportFromCjs(browserExports);
var propTypes$1 = { exports: {} };
var reactIs$2 = { exports: {} };
var reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b3 = "function" === typeof Symbol && Symbol.for, c3 = b3 ? Symbol.for("react.element") : 60103, d4 = b3 ? Symbol.for("react.portal") : 60106, e5 = b3 ? Symbol.for("react.fragment") : 60107, f2 = b3 ? Symbol.for("react.strict_mode") : 60108, g2 = b3 ? Symbol.for("react.profiler") : 60114, h4 = b3 ? Symbol.for("react.provider") : 60109, k3 = b3 ? Symbol.for("react.context") : 60110, l2 = b3 ? Symbol.for("react.async_mode") : 60111, m4 = b3 ? Symbol.for("react.concurrent_mode") : 60111, n2 = b3 ? Symbol.for("react.forward_ref") : 60112, p2 = b3 ? Symbol.for("react.suspense") : 60113, q3 = b3 ? Symbol.for("react.suspense_list") : 60120, r2 = b3 ? Symbol.for("react.memo") : 60115, t3 = b3 ? Symbol.for("react.lazy") : 60116, v2 = b3 ? Symbol.for("react.block") : 60121, w3 = b3 ? Symbol.for("react.fundamental") : 60117, x3 = b3 ? Symbol.for("react.responder") : 60118, y4 = b3 ? Symbol.for("react.scope") : 60119;
  function z3(a4) {
    if ("object" === typeof a4 && null !== a4) {
      var u3 = a4.$$typeof;
      switch (u3) {
        case c3:
          switch (a4 = a4.type, a4) {
            case l2:
            case m4:
            case e5:
            case g2:
            case f2:
            case p2:
              return a4;
            default:
              switch (a4 = a4 && a4.$$typeof, a4) {
                case k3:
                case n2:
                case t3:
                case r2:
                case h4:
                  return a4;
                default:
                  return u3;
              }
          }
        case d4:
          return u3;
      }
    }
  }
  function A2(a4) {
    return z3(a4) === m4;
  }
  reactIs_production_min$1.AsyncMode = l2;
  reactIs_production_min$1.ConcurrentMode = m4;
  reactIs_production_min$1.ContextConsumer = k3;
  reactIs_production_min$1.ContextProvider = h4;
  reactIs_production_min$1.Element = c3;
  reactIs_production_min$1.ForwardRef = n2;
  reactIs_production_min$1.Fragment = e5;
  reactIs_production_min$1.Lazy = t3;
  reactIs_production_min$1.Memo = r2;
  reactIs_production_min$1.Portal = d4;
  reactIs_production_min$1.Profiler = g2;
  reactIs_production_min$1.StrictMode = f2;
  reactIs_production_min$1.Suspense = p2;
  reactIs_production_min$1.isAsyncMode = function(a4) {
    return A2(a4) || z3(a4) === l2;
  };
  reactIs_production_min$1.isConcurrentMode = A2;
  reactIs_production_min$1.isContextConsumer = function(a4) {
    return z3(a4) === k3;
  };
  reactIs_production_min$1.isContextProvider = function(a4) {
    return z3(a4) === h4;
  };
  reactIs_production_min$1.isElement = function(a4) {
    return "object" === typeof a4 && null !== a4 && a4.$$typeof === c3;
  };
  reactIs_production_min$1.isForwardRef = function(a4) {
    return z3(a4) === n2;
  };
  reactIs_production_min$1.isFragment = function(a4) {
    return z3(a4) === e5;
  };
  reactIs_production_min$1.isLazy = function(a4) {
    return z3(a4) === t3;
  };
  reactIs_production_min$1.isMemo = function(a4) {
    return z3(a4) === r2;
  };
  reactIs_production_min$1.isPortal = function(a4) {
    return z3(a4) === d4;
  };
  reactIs_production_min$1.isProfiler = function(a4) {
    return z3(a4) === g2;
  };
  reactIs_production_min$1.isStrictMode = function(a4) {
    return z3(a4) === f2;
  };
  reactIs_production_min$1.isSuspense = function(a4) {
    return z3(a4) === p2;
  };
  reactIs_production_min$1.isValidElementType = function(a4) {
    return "string" === typeof a4 || "function" === typeof a4 || a4 === e5 || a4 === m4 || a4 === g2 || a4 === f2 || a4 === p2 || a4 === q3 || "object" === typeof a4 && null !== a4 && (a4.$$typeof === t3 || a4.$$typeof === r2 || a4.$$typeof === h4 || a4.$$typeof === k3 || a4.$$typeof === n2 || a4.$$typeof === w3 || a4.$$typeof === x3 || a4.$$typeof === y4 || a4.$$typeof === v2);
  };
  reactIs_production_min$1.typeOf = z3;
  return reactIs_production_min$1;
}
var reactIs_development$1 = {};
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  if (process$1$1.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type2) {
        return typeof type2 === "string" || typeof type2 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type2 = object.type;
              switch (type2) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$1.AsyncMode = AsyncMode;
      reactIs_development$1.ConcurrentMode = ConcurrentMode;
      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element2;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment2;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal2;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement2;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf;
    })();
  }
  return reactIs_development$1;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs$2.exports;
  hasRequiredReactIs = 1;
  if (process$1$1.env.NODE_ENV === "production") {
    reactIs$2.exports = requireReactIs_production_min$1();
  } else {
    reactIs$2.exports = requireReactIs_development$1();
  }
  return reactIs$2.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols4 = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject2(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i3 = 0; i3 < 10; i3++) {
        test2["_" + String.fromCharCode(i3)] = i3;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
        return test2[n2];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from2;
    var to2 = toObject2(target);
    var symbols2;
    for (var s4 = 1; s4 < arguments.length; s4++) {
      from2 = Object(arguments[s4]);
      for (var key2 in from2) {
        if (hasOwnProperty2.call(from2, key2)) {
          to2[key2] = from2[key2];
        }
      }
      if (getOwnPropertySymbols4) {
        symbols2 = getOwnPropertySymbols4(from2);
        for (var i3 = 0; i3 < symbols2.length; i3++) {
          if (propIsEnumerable.call(from2, symbols2[i3])) {
            to2[symbols2[i3]] = from2[symbols2[i3]];
          }
        }
      }
    }
    return to2;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has$e;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has$e;
  hasRequiredHas = 1;
  has$e = Function.call.bind(Object.prototype.hasOwnProperty);
  return has$e;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process$1$1.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text) {
      var message2 = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x3) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process$1$1.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error2;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error2 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error2 = ex;
          }
          if (error2 && !(error2 instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error2 + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
            loggedTypeFailures[error2.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error2.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process$1$1.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs2 = requireReactIs();
  var assign2 = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process$1$1.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message2 = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x3) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is3(x3, y4) {
      if (x3 === y4) {
        return x3 !== 0 || 1 / x3 === 1 / y4;
      } else {
        return x3 !== x3 && y4 !== y4;
      }
    }
    function PropTypeError(message2, data) {
      this.message = message2;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate2) {
      if (process$1$1.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props2, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process$1$1.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props2[propName] == null) {
          if (isRequired) {
            if (props2[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate2(props2, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate2(props2, propName, componentName, location, propFullName, secret) {
        var propValue = props2[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate2(props2, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props2[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i3 = 0; i3 < propValue.length; i3++) {
          var error2 = typeChecker(propValue, i3, componentName, location, propFullName + "[" + i3 + "]", ReactPropTypesSecret);
          if (error2 instanceof Error) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createElementTypeChecker() {
      function validate2(props2, propName, componentName, location, propFullName) {
        var propValue = props2[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createElementTypeTypeChecker() {
      function validate2(props2, propName, componentName, location, propFullName) {
        var propValue = props2[propName];
        if (!ReactIs2.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate2(props2, propName, componentName, location, propFullName) {
        if (!(props2[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props2[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process$1$1.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate2(props2, propName, componentName, location, propFullName) {
        var propValue = props2[propName];
        for (var i3 = 0; i3 < expectedValues.length; i3++) {
          if (is3(propValue, expectedValues[i3])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key2, value) {
          var type2 = getPreciseType(value);
          if (type2 === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate2);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate2(props2, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props2[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key2 in propValue) {
          if (has2(propValue, key2)) {
            var error2 = typeChecker(propValue, key2, componentName, location, propFullName + "." + key2, ReactPropTypesSecret);
            if (error2 instanceof Error) {
              return error2;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process$1$1.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i3 = 0; i3 < arrayOfTypeCheckers.length; i3++) {
        var checker = arrayOfTypeCheckers[i3];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i3 + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate2(props2, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i4 = 0; i4 < arrayOfTypeCheckers.length; i4++) {
          var checker2 = arrayOfTypeCheckers[i4];
          var checkerResult = checker2(props2, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate2);
    }
    function createNodeChecker() {
      function validate2(props2, propName, componentName, location, propFullName) {
        if (!isNode(props2[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function invalidValidatorError(componentName, location, propFullName, key2, type2) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key2 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type2 + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate2(props2, propName, componentName, location, propFullName) {
        var propValue = props2[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key2 in shapeTypes) {
          var checker = shapeTypes[key2];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key2, getPreciseType(checker));
          }
          var error2 = checker(propValue, key2, componentName, location, propFullName + "." + key2, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate2(props2, propName, componentName, location, propFullName) {
        var propValue = props2[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props2[propName], shapeTypes);
        for (var key2 in allKeys) {
          var checker = shapeTypes[key2];
          if (has2(shapeTypes, key2) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key2, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key2 + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props2[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error2 = checker(propValue, key2, componentName, location, propFullName + "." + key2, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator2 = iteratorFn.call(propValue);
            var step2;
            if (iteratorFn !== propValue.entries) {
              while (!(step2 = iterator2.next()).done) {
                if (!isNode(step2.value)) {
                  return false;
                }
              }
            } else {
              while (!(step2 = iterator2.next()).done) {
                var entry = step2.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol2(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol2(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type2 = getPreciseType(value);
      switch (type2) {
        case "array":
        case "object":
          return "an " + type2;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type2;
        default:
          return type2;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim2(props2, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim2.isRequired = shim2;
    function getShim() {
      return shim2;
    }
    var ReactPropTypes = {
      array: shim2,
      bigint: shim2,
      bool: shim2,
      func: shim2,
      number: shim2,
      object: shim2,
      string: shim2,
      symbol: shim2,
      any: shim2,
      arrayOf: getShim,
      element: shim2,
      elementType: shim2,
      instanceOf: getShim,
      node: shim2,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process$1$1.env.NODE_ENV !== "production") {
  var ReactIs$2 = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes$1.exports = requireFactoryWithTypeCheckers()(ReactIs$2.isElement, throwOnDirectAccess);
} else {
  propTypes$1.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes$1.exports;
const PropTypes$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(propTypesExports);
var lib$o = {};
var isFunction_1$1 = isFunction$c;
var toString$a = Object.prototype.toString;
function isFunction$c(fn2) {
  if (!fn2) {
    return false;
  }
  var string3 = toString$a.call(fn2);
  return string3 === "[object Function]" || typeof fn2 === "function" && string3 !== "[object RegExp]" || typeof window !== "undefined" && // IE8 and below
  (fn2 === window.setTimeout || fn2 === window.alert || fn2 === window.confirm || fn2 === window.prompt);
}
const isFunction$d = /* @__PURE__ */ getDefaultExportFromCjs$1(isFunction_1$1);
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var isobject = function isObject(val) {
  return val != null && typeof val === "object" && Array.isArray(val) === false;
};
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var isObject$p = isobject;
function isObjectObject(o2) {
  return isObject$p(o2) === true && Object.prototype.toString.call(o2) === "[object Object]";
}
var isPlainObject$a = function isPlainObject(o2) {
  var ctor, prot;
  if (isObjectObject(o2) === false) return false;
  ctor = o2.constructor;
  if (typeof ctor !== "function") return false;
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;
  if (prot.hasOwnProperty("isPrototypeOf") === false) {
    return false;
  }
  return true;
};
const isPlainObject$b = /* @__PURE__ */ getDefaultExportFromCjs$1(isPlainObject$a);
const defaultChannel = "__THEMING__";
function createBroadcast(initialState2) {
  var listeners = {};
  var id2 = 1;
  var _state = initialState2;
  function getState() {
    return _state;
  }
  function setState(state) {
    _state = state;
    var keys4 = Object.keys(listeners);
    var i3 = 0;
    var len = keys4.length;
    for (; i3 < len; i3++) {
      if (listeners[keys4[i3]]) {
        listeners[keys4[i3]](state);
      }
    }
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error("listener must be a function.");
    }
    var currentId = id2;
    listeners[currentId] = listener;
    id2 += 1;
    return currentId;
  }
  function unsubscribe(id3) {
    delete listeners[id3];
  }
  return { getState, setState, subscribe, unsubscribe };
}
var _extends$5 = Object.assign || function(target) {
  for (var i3 = 1; i3 < arguments.length; i3++) {
    var source = arguments[i3];
    for (var key2 in source) {
      if (Object.prototype.hasOwnProperty.call(source, key2)) {
        target[key2] = source[key2];
      }
    }
  }
  return target;
};
var _createClass$3 = /* @__PURE__ */ function() {
  function defineProperties4(target, props2) {
    for (var i3 = 0; i3 < props2.length; i3++) {
      var descriptor2 = props2[i3];
      descriptor2.enumerable = descriptor2.enumerable || false;
      descriptor2.configurable = true;
      if ("value" in descriptor2) descriptor2.writable = true;
      Object.defineProperty(target, descriptor2.key, descriptor2);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties4(Constructor.prototype, protoProps);
    if (staticProps) defineProperties4(Constructor, staticProps);
    return Constructor;
  };
}();
function _defineProperty$7(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$3(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function createThemeProvider() {
  var _class, _temp2;
  var CHANNEL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultChannel;
  return _temp2 = _class = function(_React$Component) {
    _inherits$3(ThemeProvider2, _React$Component);
    function ThemeProvider2() {
      var _ref;
      var _temp, _this, _ret;
      _classCallCheck$3(this, ThemeProvider2);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn$3(this, (_ref = ThemeProvider2.__proto__ || Object.getPrototypeOf(ThemeProvider2)).call.apply(_ref, [this].concat(args))), _this), _this.broadcast = createBroadcast(_this.getTheme()), _this.setOuterTheme = function(theme2) {
        _this.outerTheme = theme2;
      }, _temp), _possibleConstructorReturn$3(_this, _ret);
    }
    _createClass$3(ThemeProvider2, [{
      key: "getTheme",
      // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
      value: function getTheme(passedTheme) {
        var theme2 = passedTheme || this.props.theme;
        if (isFunction$d(theme2)) {
          var mergedTheme = theme2(this.outerTheme);
          if (!isPlainObject$b(mergedTheme)) {
            throw new Error("[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!");
          }
          return mergedTheme;
        }
        if (!isPlainObject$b(theme2)) {
          throw new Error("[ThemeProvider] Please make your theme prop a plain object");
        }
        if (!this.outerTheme) {
          return theme2;
        }
        return _extends$5({}, this.outerTheme, theme2);
      }
    }, {
      key: "getChildContext",
      value: function getChildContext() {
        return _defineProperty$7({}, CHANNEL, this.broadcast);
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.context[CHANNEL]) {
          this.subscriptionId = this.context[CHANNEL].subscribe(this.setOuterTheme);
        }
      }
      // set broadcast state by merging outer theme with own
    }, {
      key: "componentWillMount",
      value: function componentWillMount() {
        if (this.context[CHANNEL]) {
          this.setOuterTheme(this.context[CHANNEL].getState());
          this.broadcast.setState(this.getTheme());
        }
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.theme !== nextProps.theme) {
          this.broadcast.setState(this.getTheme(nextProps.theme));
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.subscriptionId !== void 0) {
          this.context[CHANNEL].unsubscribe(this.subscriptionId);
          delete this.subscriptionId;
        }
      }
    }, {
      key: "render",
      value: function render() {
        if (!this.props.children) {
          return null;
        }
        return React__default.Children.only(this.props.children);
      }
    }]);
    return ThemeProvider2;
  }(React__default.Component), _class.propTypes = {
    children: PropTypes$1.element,
    theme: PropTypes$1.oneOfType([PropTypes$1.shape({}), PropTypes$1.func]).isRequired
  }, _class.childContextTypes = _defineProperty$7({}, CHANNEL, PropTypes$1.object.isRequired), _class.contextTypes = _defineProperty$7({}, CHANNEL, PropTypes$1.object), _temp2;
}
function _defineProperty$6(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function createThemeListener() {
  var CHANNEL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultChannel;
  var contextTypes2 = _defineProperty$6({}, CHANNEL, PropTypes$1.object.isRequired);
  function initial(context) {
    if (!context[CHANNEL]) {
      throw new Error("[" + this.displayName + "] Please use ThemeProvider to be able to use WithTheme");
    }
    return context[CHANNEL].getState();
  }
  function subscribe(context, cb) {
    if (context[CHANNEL]) {
      return context[CHANNEL].subscribe(cb);
    }
  }
  function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
  return {
    contextTypes: contextTypes2,
    initial,
    subscribe,
    unsubscribe
  };
}
var _extends$4 = Object.assign || function(target) {
  for (var i3 = 1; i3 < arguments.length; i3++) {
    var source = arguments[i3];
    for (var key2 in source) {
      if (Object.prototype.hasOwnProperty.call(source, key2)) {
        target[key2] = source[key2];
      }
    }
  }
  return target;
};
var _createClass$2 = /* @__PURE__ */ function() {
  function defineProperties4(target, props2) {
    for (var i3 = 0; i3 < props2.length; i3++) {
      var descriptor2 = props2[i3];
      descriptor2.enumerable = descriptor2.enumerable || false;
      descriptor2.configurable = true;
      if ("value" in descriptor2) descriptor2.writable = true;
      Object.defineProperty(target, descriptor2.key, descriptor2);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties4(Constructor.prototype, protoProps);
    if (staticProps) defineProperties4(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$2(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var getDisplayName$3 = function getDisplayName(Component2) {
  return Component2.displayName || Component2.name || "Component";
};
function createWithTheme() {
  var CHANNEL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultChannel;
  var themeListener2 = createThemeListener(CHANNEL);
  return function(Component2) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
      _inherits$2(WithTheme, _React$Component);
      function WithTheme(props2, context) {
        _classCallCheck$2(this, WithTheme);
        var _this = _possibleConstructorReturn$2(this, (WithTheme.__proto__ || Object.getPrototypeOf(WithTheme)).call(this, props2, context));
        _this.state = { theme: themeListener2.initial(context) };
        _this.setTheme = function(theme2) {
          return _this.setState({ theme: theme2 });
        };
        return _this;
      }
      _createClass$2(WithTheme, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.unsubscribe = themeListener2.subscribe(this.context, this.setTheme);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (typeof this.unsubscribe === "function") {
            this.unsubscribe();
          }
        }
      }, {
        key: "render",
        value: function render() {
          var theme2 = this.state.theme;
          return React__default.createElement(Component2, _extends$4({ theme: theme2 }, this.props));
        }
      }]);
      return WithTheme;
    }(React__default.Component), _class.displayName = "WithTheme(" + getDisplayName$3(Component2) + ")", _class.contextTypes = themeListener2.contextTypes, _temp;
  };
}
var channel = defaultChannel;
var withTheme = createWithTheme();
var ThemeProvider = createThemeProvider();
var themeListener = createThemeListener();
function createTheming() {
  var customChannel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultChannel;
  return {
    channel: customChannel,
    withTheme: createWithTheme(customChannel),
    ThemeProvider: createThemeProvider(customChannel),
    themeListener: createThemeListener(customChannel)
  };
}
const index$o = {
  channel: defaultChannel,
  withTheme,
  ThemeProvider,
  themeListener,
  createTheming
};
const esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ThemeProvider,
  channel,
  createTheming,
  default: index$o,
  themeListener,
  withTheme
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$6 = /* @__PURE__ */ getAugmentedNamespace(esm);
var JssProvider$1 = {};
var jss = {};
var lib$n = {};
var getDynamicStyles = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _typeof4 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  exports["default"] = getDynamicStyles2;
  function getDynamicStyles2(styles2) {
    var to2 = null;
    for (var key2 in styles2) {
      var value = styles2[key2];
      var type2 = typeof value === "undefined" ? "undefined" : _typeof4(value);
      if (type2 === "function") {
        if (!to2) to2 = {};
        to2[key2] = value;
      } else if (type2 === "object" && value !== null && !Array.isArray(value)) {
        var extracted = getDynamicStyles2(value);
        if (extracted) {
          if (!to2) to2 = {};
          to2[key2] = extracted;
        }
      }
    }
    return to2;
  }
})(getDynamicStyles);
var toCssValue = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = toCssValue2;
  var join2 = function join3(value, by) {
    var result2 = "";
    for (var i3 = 0; i3 < value.length; i3++) {
      if (value[i3] === "!important") break;
      if (result2) result2 += by;
      result2 += value[i3];
    }
    return result2;
  };
  function toCssValue2(value) {
    var ignoreImportant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!Array.isArray(value)) return value;
    var cssValue = "";
    if (Array.isArray(value[0])) {
      for (var i3 = 0; i3 < value.length; i3++) {
        if (value[i3] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += join2(value[i3], " ");
      }
    } else cssValue = join2(value, ", ");
    if (!ignoreImportant && value[value.length - 1] === "!important") {
      cssValue += " !important";
    }
    return cssValue;
  }
})(toCssValue);
var SheetsRegistry = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var SheetsRegistry2 = function() {
    function SheetsRegistry3() {
      _classCallCheck4(this, SheetsRegistry3);
      this.registry = [];
    }
    _createClass2(SheetsRegistry3, [{
      key: "add",
      /**
       * Register a Style Sheet.
       */
      value: function add2(sheet) {
        var registry = this.registry;
        var index2 = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index2 >= this.index) {
          registry.push(sheet);
          return;
        }
        for (var i3 = 0; i3 < registry.length; i3++) {
          if (registry[i3].options.index > index2) {
            registry.splice(i3, 0, sheet);
            return;
          }
        }
      }
      /**
       * Reset the registry.
       */
    }, {
      key: "reset",
      value: function reset2() {
        this.registry = [];
      }
      /**
       * Remove a Style Sheet.
       */
    }, {
      key: "remove",
      value: function remove(sheet) {
        var index2 = this.registry.indexOf(sheet);
        this.registry.splice(index2, 1);
      }
      /**
       * Convert all attached sheets to a CSS string.
       */
    }, {
      key: "toString",
      value: function toString2(options) {
        return this.registry.filter(function(sheet) {
          return sheet.attached;
        }).map(function(sheet) {
          return sheet.toString(options);
        }).join("\n");
      }
    }, {
      key: "index",
      /**
       * Current highest index number.
       */
      get: function get2() {
        return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
      }
    }]);
    return SheetsRegistry3;
  }();
  exports["default"] = SheetsRegistry2;
})(SheetsRegistry);
var SheetsManager = {};
var warning$3 = function() {
};
if (process$1$1.env.NODE_ENV !== "production") {
  warning$3 = function(condition, format3, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key2 = 2; key2 < len; key2++) {
      args[key2 - 2] = arguments[key2];
    }
    if (format3 === void 0) {
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    }
    if (format3.length < 10 || /^[s\W]*$/.test(format3)) {
      throw new Error(
        "The warning format should be able to uniquely identify this warning. Please, use a more descriptive format than: " + format3
      );
    }
    if (!condition) {
      var argIndex = 0;
      var message2 = "Warning: " + format3.replace(/%s/g, function() {
        return args[argIndex++];
      });
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x3) {
      }
    }
  };
}
var browser = warning$3;
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _warning3 = browser;
  var _warning22 = _interopRequireDefault2(_warning3);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var SheetsManager2 = function() {
    function SheetsManager3() {
      _classCallCheck4(this, SheetsManager3);
      this.sheets = [];
      this.refs = [];
      this.keys = [];
    }
    _createClass2(SheetsManager3, [{
      key: "get",
      value: function get2(key2) {
        var index2 = this.keys.indexOf(key2);
        return this.sheets[index2];
      }
    }, {
      key: "add",
      value: function add2(key2, sheet) {
        var sheets2 = this.sheets, refs = this.refs, keys4 = this.keys;
        var index2 = sheets2.indexOf(sheet);
        if (index2 !== -1) return index2;
        sheets2.push(sheet);
        refs.push(0);
        keys4.push(key2);
        return sheets2.length - 1;
      }
    }, {
      key: "manage",
      value: function manage(key2) {
        var index2 = this.keys.indexOf(key2);
        var sheet = this.sheets[index2];
        if (this.refs[index2] === 0) sheet.attach();
        this.refs[index2]++;
        if (!this.keys[index2]) this.keys.splice(index2, 0, key2);
        return sheet;
      }
    }, {
      key: "unmanage",
      value: function unmanage(key2) {
        var index2 = this.keys.indexOf(key2);
        if (index2 === -1) {
          (0, _warning22["default"])(false, "SheetsManager: can't find sheet to unmanage");
          return;
        }
        if (this.refs[index2] > 0) {
          this.refs[index2]--;
          if (this.refs[index2] === 0) this.sheets[index2].detach();
        }
      }
    }, {
      key: "size",
      get: function get2() {
        return this.keys.length;
      }
    }]);
    return SheetsManager3;
  }();
  exports["default"] = SheetsManager2;
})(SheetsManager);
var RuleList = {};
var createRule = {};
var StyleRule = {};
var toCss = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = toCss2;
  var _toCssValue = toCssValue;
  var _toCssValue2 = _interopRequireDefault2(_toCssValue);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function indentStr(str, indent) {
    var result2 = "";
    for (var index2 = 0; index2 < indent; index2++) {
      result2 += "  ";
    }
    return result2 + str;
  }
  function toCss2(selector, style2) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var result2 = "";
    if (!style2) return result2;
    var _options$indent = options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style2.fallbacks;
    indent++;
    if (fallbacks) {
      if (Array.isArray(fallbacks)) {
        for (var index2 = 0; index2 < fallbacks.length; index2++) {
          var fallback = fallbacks[index2];
          for (var prop in fallback) {
            var value = fallback[prop];
            if (value != null) {
              result2 += "\n" + indentStr(prop + ": " + (0, _toCssValue2["default"])(value) + ";", indent);
            }
          }
        }
      } else {
        for (var _prop in fallbacks) {
          var _value = fallbacks[_prop];
          if (_value != null) {
            result2 += "\n" + indentStr(_prop + ": " + (0, _toCssValue2["default"])(_value) + ";", indent);
          }
        }
      }
    }
    for (var _prop2 in style2) {
      var _value2 = style2[_prop2];
      if (_value2 != null && _prop2 !== "fallbacks") {
        result2 += "\n" + indentStr(_prop2 + ": " + (0, _toCssValue2["default"])(_value2) + ";", indent);
      }
    }
    if (!result2 && !options.allowEmpty) return result2;
    indent--;
    result2 = indentStr(selector + " {" + result2 + "\n", indent) + indentStr("}", indent);
    return result2;
  }
})(toCss);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _typeof4 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _warning3 = browser;
  var _warning22 = _interopRequireDefault2(_warning3);
  var _toCss = toCss;
  var _toCss2 = _interopRequireDefault2(_toCss);
  var _toCssValue = toCssValue;
  var _toCssValue2 = _interopRequireDefault2(_toCssValue);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var StyleRule2 = function() {
    function StyleRule3(key2, style2, options) {
      _classCallCheck4(this, StyleRule3);
      this.type = "style";
      this.isProcessed = false;
      var sheet = options.sheet, Renderer = options.Renderer, selector = options.selector;
      this.key = key2;
      this.options = options;
      this.style = style2;
      if (selector) this.selectorText = selector;
      this.renderer = sheet ? sheet.renderer : new Renderer();
    }
    _createClass2(StyleRule3, [{
      key: "prop",
      /**
       * Get or set a style property.
       */
      value: function prop(name2, value) {
        if (value === void 0) return this.style[name2];
        if (this.style[name2] === value) return this;
        value = this.options.jss.plugins.onChangeValue(value, name2, this);
        var isEmpty2 = value == null || value === false;
        var isDefined = name2 in this.style;
        if (isEmpty2 && !isDefined) return this;
        var remove = isEmpty2 && isDefined;
        if (remove) delete this.style[name2];
        else this.style[name2] = value;
        if (this.renderable) {
          if (remove) this.renderer.removeProperty(this.renderable, name2);
          else this.renderer.setProperty(this.renderable, name2, value);
          return this;
        }
        var sheet = this.options.sheet;
        if (sheet && sheet.attached) {
          (0, _warning22["default"])(false, 'Rule is not linked. Missing sheet option "link: true".');
        }
        return this;
      }
      /**
       * Apply rule to an element inline.
       */
    }, {
      key: "applyTo",
      value: function applyTo(renderable) {
        var json = this.toJSON();
        for (var prop in json) {
          this.renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
      }
      /**
       * Returns JSON representation of the rule.
       * Fallbacks are not supported.
       * Useful for inline styles.
       */
    }, {
      key: "toJSON",
      value: function toJSON2() {
        var json = {};
        for (var prop in this.style) {
          var value = this.style[prop];
          if ((typeof value === "undefined" ? "undefined" : _typeof4(value)) !== "object") json[prop] = value;
          else if (Array.isArray(value)) json[prop] = (0, _toCssValue2["default"])(value);
        }
        return json;
      }
      /**
       * Generates a CSS string.
       */
    }, {
      key: "toString",
      value: function toString2(options) {
        var sheet = this.options.sheet;
        var link2 = sheet ? sheet.options.link : false;
        var opts = link2 ? _extends2({}, options, { allowEmpty: true }) : options;
        return (0, _toCss2["default"])(this.selector, this.style, opts);
      }
    }, {
      key: "selector",
      set: function set2(selector) {
        if (selector === this.selectorText) return;
        this.selectorText = selector;
        if (!this.renderable) return;
        var hasChanged = this.renderer.setSelector(this.renderable, selector);
        if (!hasChanged && this.renderable) {
          var renderable = this.renderer.replaceRule(this.renderable, this);
          if (renderable) this.renderable = renderable;
        }
      },
      get: function get2() {
        return this.selectorText;
      }
    }]);
    return StyleRule3;
  }();
  exports["default"] = StyleRule2;
})(StyleRule);
var cloneStyle = {};
var isObservable = {};
const global$7 = globalThis || void 0 || self;
function symbolObservablePonyfill(root2) {
  var result2;
  var Symbol2 = root2.Symbol;
  if (typeof Symbol2 === "function") {
    if (Symbol2.observable) {
      result2 = Symbol2.observable;
    } else {
      result2 = Symbol2("observable");
      Symbol2.observable = result2;
    }
  } else {
    result2 = "@@observable";
  }
  return result2;
}
var root$c;
if (typeof self !== "undefined") {
  root$c = self;
} else if (typeof window !== "undefined") {
  root$c = window;
} else if (typeof global$7 !== "undefined") {
  root$c = global$7;
} else if (typeof module !== "undefined") {
  root$c = module;
} else {
  root$c = Function("return this")();
}
var result = symbolObservablePonyfill(root$c);
const es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: result
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$5 = /* @__PURE__ */ getAugmentedNamespace(es);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _symbolObservable = require$$0$5;
  var _symbolObservable2 = _interopRequireDefault2(_symbolObservable);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = function(value) {
    return value && value[_symbolObservable2["default"]] && value === value[_symbolObservable2["default"]]();
  };
})(isObservable);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _typeof4 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  exports["default"] = cloneStyle2;
  var _isObservable = isObservable;
  var _isObservable2 = _interopRequireDefault2(_isObservable);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var isArray4 = Array.isArray;
  function cloneStyle2(style2) {
    if (style2 == null) return style2;
    var typeOfStyle = typeof style2 === "undefined" ? "undefined" : _typeof4(style2);
    if (typeOfStyle === "string" || typeOfStyle === "number" || typeOfStyle === "function") {
      return style2;
    }
    if (isArray4(style2)) return style2.map(cloneStyle2);
    if ((0, _isObservable2["default"])(style2)) return style2;
    var newStyle = {};
    for (var name2 in style2) {
      var value = style2[name2];
      if ((typeof value === "undefined" ? "undefined" : _typeof4(value)) === "object") {
        newStyle[name2] = cloneStyle2(value);
        continue;
      }
      newStyle[name2] = value;
    }
    return newStyle;
  }
})(cloneStyle);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = createRule2;
  var _warning3 = browser;
  var _warning22 = _interopRequireDefault2(_warning3);
  var _StyleRule = StyleRule;
  var _StyleRule2 = _interopRequireDefault2(_StyleRule);
  var _cloneStyle = cloneStyle;
  var _cloneStyle2 = _interopRequireDefault2(_cloneStyle);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function createRule2() {
    var name2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "unnamed";
    var decl = arguments[1];
    var options = arguments[2];
    var jss2 = options.jss;
    var declCopy = (0, _cloneStyle2["default"])(decl);
    var rule = jss2.plugins.onCreateRule(name2, declCopy, options);
    if (rule) return rule;
    if (name2[0] === "@") {
      (0, _warning22["default"])(false, "[JSS] Unknown at-rule %s", name2);
    }
    return new _StyleRule2["default"](name2, declCopy, options);
  }
})(createRule);
var linkRule = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = linkRule2;
  function linkRule2(rule, cssRule) {
    rule.renderable = cssRule;
    if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
  }
})(linkRule);
var _escape$2 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var CSS = commonjsGlobal.CSS;
  var env = process$1$1.env.NODE_ENV;
  var escapeRegex2 = /([[\].#*$><+~=|^:(),"'`])/g;
  exports["default"] = function(str) {
    if (env === "production") return str;
    if (!CSS || !CSS.escape) {
      return str.replace(escapeRegex2, "\\$1");
    }
    return CSS.escape(str);
  };
})(_escape$2);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _createRule = createRule;
  var _createRule2 = _interopRequireDefault2(_createRule);
  var _linkRule = linkRule;
  var _linkRule2 = _interopRequireDefault2(_linkRule);
  var _StyleRule = StyleRule;
  var _StyleRule2 = _interopRequireDefault2(_StyleRule);
  var _escape2 = _escape$2;
  var _escape22 = _interopRequireDefault2(_escape2);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var RuleList2 = function() {
    function RuleList3(options) {
      var _this = this;
      _classCallCheck4(this, RuleList3);
      this.map = {};
      this.raw = {};
      this.index = [];
      this.update = function(name2, data) {
        var _options = _this.options, plugins2 = _options.jss.plugins, sheet = _options.sheet;
        if (typeof name2 === "string") {
          plugins2.onUpdate(data, _this.get(name2), sheet);
        } else {
          for (var index2 = 0; index2 < _this.index.length; index2++) {
            plugins2.onUpdate(name2, _this.index[index2], sheet);
          }
        }
      };
      this.options = options;
      this.classes = options.classes;
    }
    _createClass2(RuleList3, [{
      key: "add",
      value: function add2(name2, decl, options) {
        var _options2 = this.options, parent3 = _options2.parent, sheet = _options2.sheet, jss2 = _options2.jss, Renderer = _options2.Renderer, generateClassName2 = _options2.generateClassName;
        options = _extends2({
          classes: this.classes,
          parent: parent3,
          sheet,
          jss: jss2,
          Renderer,
          generateClassName: generateClassName2
        }, options);
        if (!options.selector && this.classes[name2]) {
          options.selector = "." + (0, _escape22["default"])(this.classes[name2]);
        }
        this.raw[name2] = decl;
        var rule = (0, _createRule2["default"])(name2, decl, options);
        var className = void 0;
        if (!options.selector && rule instanceof _StyleRule2["default"]) {
          className = generateClassName2(rule, sheet);
          rule.selector = "." + (0, _escape22["default"])(className);
        }
        this.register(rule, className);
        var index2 = options.index === void 0 ? this.index.length : options.index;
        this.index.splice(index2, 0, rule);
        return rule;
      }
      /**
       * Get a rule.
       */
    }, {
      key: "get",
      value: function get2(name2) {
        return this.map[name2];
      }
      /**
       * Delete a rule.
       */
    }, {
      key: "remove",
      value: function remove(rule) {
        this.unregister(rule);
        this.index.splice(this.indexOf(rule), 1);
      }
      /**
       * Get index of a rule.
       */
    }, {
      key: "indexOf",
      value: function indexOf2(rule) {
        return this.index.indexOf(rule);
      }
      /**
       * Run `onProcessRule()` plugins on every rule.
       */
    }, {
      key: "process",
      value: function process2() {
        var plugins2 = this.options.jss.plugins;
        this.index.slice(0).forEach(plugins2.onProcessRule, plugins2);
      }
      /**
       * Register a rule in `.map` and `.classes` maps.
       */
    }, {
      key: "register",
      value: function register(rule, className) {
        this.map[rule.key] = rule;
        if (rule instanceof _StyleRule2["default"]) {
          this.map[rule.selector] = rule;
          if (className) this.classes[rule.key] = className;
        }
      }
      /**
       * Unregister a rule.
       */
    }, {
      key: "unregister",
      value: function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof _StyleRule2["default"]) {
          delete this.map[rule.selector];
          delete this.classes[rule.key];
        }
      }
      /**
       * Update the function values with a new data.
       */
    }, {
      key: "link",
      /**
       * Link renderable rules with CSSRuleList.
       */
      value: function link2(cssRules) {
        var map2 = this.options.sheet.renderer.getUnescapedKeysMap(this.index);
        for (var i3 = 0; i3 < cssRules.length; i3++) {
          var cssRule = cssRules[i3];
          var _key = this.options.sheet.renderer.getKey(cssRule);
          if (map2[_key]) _key = map2[_key];
          var rule = this.map[_key];
          if (rule) (0, _linkRule2["default"])(rule, cssRule);
        }
      }
      /**
       * Convert rules to a CSS string.
       */
    }, {
      key: "toString",
      value: function toString2(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link2 = sheet ? sheet.options.link : false;
        for (var index2 = 0; index2 < this.index.length; index2++) {
          var rule = this.index[index2];
          var css = rule.toString(options);
          if (!css && !link2) continue;
          if (str) str += "\n";
          str += css;
        }
        return str;
      }
    }]);
    return RuleList3;
  }();
  exports["default"] = RuleList2;
})(RuleList);
var sheets = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _SheetsRegistry = SheetsRegistry;
  var _SheetsRegistry2 = _interopRequireDefault2(_SheetsRegistry);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = new _SheetsRegistry2["default"]();
})(sheets);
var createGenerateClassName = {};
var StyleSheet = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _linkRule = linkRule;
  var _linkRule2 = _interopRequireDefault2(_linkRule);
  var _RuleList = RuleList;
  var _RuleList2 = _interopRequireDefault2(_RuleList);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var StyleSheet2 = function() {
    function StyleSheet3(styles2, options) {
      var _this = this;
      _classCallCheck4(this, StyleSheet3);
      this.update = function(name2, data) {
        if (typeof name2 === "string") {
          _this.rules.update(name2, data);
        } else {
          _this.rules.update(name2);
        }
        return _this;
      };
      this.attached = false;
      this.deployed = false;
      this.linked = false;
      this.classes = {};
      this.options = _extends2({}, options, {
        sheet: this,
        parent: this,
        classes: this.classes
      });
      this.renderer = new options.Renderer(this);
      this.rules = new _RuleList2["default"](this.options);
      for (var _name in styles2) {
        this.rules.add(_name, styles2[_name]);
      }
      this.rules.process();
    }
    _createClass2(StyleSheet3, [{
      key: "attach",
      value: function attach() {
        if (this.attached) return this;
        if (!this.deployed) this.deploy();
        this.renderer.attach();
        if (!this.linked && this.options.link) this.link();
        this.attached = true;
        return this;
      }
      /**
       * Remove renderable from render tree.
       */
    }, {
      key: "detach",
      value: function detach() {
        if (!this.attached) return this;
        this.renderer.detach();
        this.attached = false;
        return this;
      }
      /**
       * Add a rule to the current stylesheet.
       * Will insert a rule also after the stylesheet has been rendered first time.
       */
    }, {
      key: "addRule",
      value: function addRule(name2, decl, options) {
        var queue2 = this.queue;
        if (this.attached && !queue2) this.queue = [];
        var rule = this.rules.add(name2, decl, options);
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
          if (!this.deployed) return rule;
          if (queue2) queue2.push(rule);
          else {
            this.insertRule(rule);
            if (this.queue) {
              this.queue.forEach(this.insertRule, this);
              this.queue = void 0;
            }
          }
          return rule;
        }
        this.deployed = false;
        return rule;
      }
      /**
       * Insert rule into the StyleSheet
       */
    }, {
      key: "insertRule",
      value: function insertRule(rule) {
        var renderable = this.renderer.insertRule(rule);
        if (renderable && this.options.link) (0, _linkRule2["default"])(rule, renderable);
      }
      /**
       * Create and add rules.
       * Will render also after Style Sheet was rendered the first time.
       */
    }, {
      key: "addRules",
      value: function addRules(styles2, options) {
        var added = [];
        for (var _name2 in styles2) {
          added.push(this.addRule(_name2, styles2[_name2], options));
        }
        return added;
      }
      /**
       * Get a rule by name.
       */
    }, {
      key: "getRule",
      value: function getRule(name2) {
        return this.rules.get(name2);
      }
      /**
       * Delete a rule by name.
       * Returns `true`: if rule has been deleted from the DOM.
       */
    }, {
      key: "deleteRule",
      value: function deleteRule(name2) {
        var rule = this.rules.get(name2);
        if (!rule) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable) {
          return this.renderer.deleteRule(rule.renderable);
        }
        return true;
      }
      /**
       * Get index of a rule.
       */
    }, {
      key: "indexOf",
      value: function indexOf2(rule) {
        return this.rules.indexOf(rule);
      }
      /**
       * Deploy pure CSS string to a renderable.
       */
    }, {
      key: "deploy",
      value: function deploy() {
        this.renderer.deploy();
        this.deployed = true;
        return this;
      }
      /**
       * Link renderable CSS rules from sheet with their corresponding models.
       */
    }, {
      key: "link",
      value: function link2() {
        var cssRules = this.renderer.getRules();
        if (cssRules) this.rules.link(cssRules);
        this.linked = true;
        return this;
      }
      /**
       * Update the function values with a new data.
       */
    }, {
      key: "toString",
      /**
       * Convert rules to a CSS string.
       */
      value: function toString2(options) {
        return this.rules.toString(options);
      }
    }]);
    return StyleSheet3;
  }();
  exports["default"] = StyleSheet2;
})(StyleSheet);
var moduleId = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var ns2 = "2f1acc6c3a606b082e5eef5e54414ffb";
  if (commonjsGlobal[ns2] == null) commonjsGlobal[ns2] = 0;
  exports["default"] = commonjsGlobal[ns2]++;
})(moduleId);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _warning3 = browser;
  var _warning22 = _interopRequireDefault2(_warning3);
  var _StyleSheet = StyleSheet;
  _interopRequireDefault2(_StyleSheet);
  var _moduleId = moduleId;
  var _moduleId2 = _interopRequireDefault2(_moduleId);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var maxRules = 1e10;
  var env = process$1$1.env.NODE_ENV;
  exports["default"] = function() {
    var ruleCounter = 0;
    var defaultPrefix = env === "production" ? "c" : "";
    return function(rule, sheet) {
      ruleCounter += 1;
      if (ruleCounter > maxRules) {
        (0, _warning22["default"])(false, "[JSS] You might have a memory leak. Rule counter is at %s.", ruleCounter);
      }
      var prefix2 = defaultPrefix;
      var jssId = "";
      if (sheet) {
        prefix2 = sheet.options.classNamePrefix || defaultPrefix;
        if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
      }
      if (env === "production") {
        return "" + prefix2 + _moduleId2["default"] + jssId + ruleCounter;
      }
      return prefix2 + rule.key + "-" + _moduleId2["default"] + (jssId && "-" + jssId) + "-" + ruleCounter;
    };
  };
})(createGenerateClassName);
var Jss = {};
var _typeof$7 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var isBrowser$1 = (typeof window === "undefined" ? "undefined" : _typeof$7(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof$7(document)) === "object" && document.nodeType === 9;
const module$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: isBrowser$1,
  isBrowser: isBrowser$1
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$4 = /* @__PURE__ */ getAugmentedNamespace(module$1);
var PluginsRegistry = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _warning3 = browser;
  var _warning22 = _interopRequireDefault2(_warning3);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var PluginsRegistry2 = function() {
    function PluginsRegistry3() {
      _classCallCheck4(this, PluginsRegistry3);
      this.hooks = {
        onCreateRule: [],
        onProcessRule: [],
        onProcessStyle: [],
        onProcessSheet: [],
        onChangeValue: [],
        onUpdate: []
        /**
         * Call `onCreateRule` hooks and return an object if returned by a hook.
         */
      };
    }
    _createClass2(PluginsRegistry3, [{
      key: "onCreateRule",
      value: function onCreateRule(name2, decl, options) {
        for (var i3 = 0; i3 < this.hooks.onCreateRule.length; i3++) {
          var rule = this.hooks.onCreateRule[i3](name2, decl, options);
          if (rule) return rule;
        }
        return null;
      }
      /**
       * Call `onProcessRule` hooks.
       */
    }, {
      key: "onProcessRule",
      value: function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for (var i3 = 0; i3 < this.hooks.onProcessRule.length; i3++) {
          this.hooks.onProcessRule[i3](rule, sheet);
        }
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
      }
      /**
       * Call `onProcessStyle` hooks.
       */
    }, {
      key: "onProcessStyle",
      value: function onProcessStyle(style2, rule, sheet) {
        var nextStyle = style2;
        for (var i3 = 0; i3 < this.hooks.onProcessStyle.length; i3++) {
          nextStyle = this.hooks.onProcessStyle[i3](nextStyle, rule, sheet);
          rule.style = nextStyle;
        }
      }
      /**
       * Call `onProcessSheet` hooks.
       */
    }, {
      key: "onProcessSheet",
      value: function onProcessSheet(sheet) {
        for (var i3 = 0; i3 < this.hooks.onProcessSheet.length; i3++) {
          this.hooks.onProcessSheet[i3](sheet);
        }
      }
      /**
       * Call `onUpdate` hooks.
       */
    }, {
      key: "onUpdate",
      value: function onUpdate2(data, rule, sheet) {
        for (var i3 = 0; i3 < this.hooks.onUpdate.length; i3++) {
          this.hooks.onUpdate[i3](data, rule, sheet);
        }
      }
      /**
       * Call `onChangeValue` hooks.
       */
    }, {
      key: "onChangeValue",
      value: function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for (var i3 = 0; i3 < this.hooks.onChangeValue.length; i3++) {
          processedValue = this.hooks.onChangeValue[i3](processedValue, prop, rule);
        }
        return processedValue;
      }
      /**
       * Register a plugin.
       * If function is passed, it is a shortcut for `{onProcessRule}`.
       */
    }, {
      key: "use",
      value: function use(plugin) {
        for (var name2 in plugin) {
          if (this.hooks[name2]) this.hooks[name2].push(plugin[name2]);
          else (0, _warning22["default"])(false, '[JSS] Unknown hook "%s".', name2);
        }
      }
    }]);
    return PluginsRegistry3;
  }();
  exports["default"] = PluginsRegistry2;
})(PluginsRegistry);
var rules$1 = {};
var SimpleRule = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var SimpleRule2 = function() {
    function SimpleRule3(key2, value, options) {
      _classCallCheck4(this, SimpleRule3);
      this.type = "simple";
      this.isProcessed = false;
      this.key = key2;
      this.value = value;
      this.options = options;
    }
    _createClass2(SimpleRule3, [{
      key: "toString",
      value: function toString2(options) {
        if (Array.isArray(this.value)) {
          var str = "";
          for (var index2 = 0; index2 < this.value.length; index2++) {
            str += this.key + " " + this.value[index2] + ";";
            if (this.value[index2 + 1]) str += "\n";
          }
          return str;
        }
        return this.key + " " + this.value + ";";
      }
    }]);
    return SimpleRule3;
  }();
  exports["default"] = SimpleRule2;
})(SimpleRule);
var KeyframesRule = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _RuleList = RuleList;
  var _RuleList2 = _interopRequireDefault2(_RuleList);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var KeyframesRule2 = function() {
    function KeyframesRule3(key2, frames, options) {
      _classCallCheck4(this, KeyframesRule3);
      this.type = "keyframes";
      this.isProcessed = false;
      this.key = key2;
      this.options = options;
      this.rules = new _RuleList2["default"](_extends2({}, options, { parent: this }));
      for (var name2 in frames) {
        this.rules.add(name2, frames[name2], _extends2({}, this.options, {
          parent: this,
          selector: name2
        }));
      }
      this.rules.process();
    }
    _createClass2(KeyframesRule3, [{
      key: "toString",
      value: function toString2() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { indent: 1 };
        var inner2 = this.rules.toString(options);
        if (inner2) inner2 += "\n";
        return this.key + " {\n" + inner2 + "}";
      }
    }]);
    return KeyframesRule3;
  }();
  exports["default"] = KeyframesRule2;
})(KeyframesRule);
var ConditionalRule = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _RuleList = RuleList;
  var _RuleList2 = _interopRequireDefault2(_RuleList);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var ConditionalRule2 = function() {
    function ConditionalRule3(key2, styles2, options) {
      _classCallCheck4(this, ConditionalRule3);
      this.type = "conditional";
      this.isProcessed = false;
      this.key = key2;
      this.options = options;
      this.rules = new _RuleList2["default"](_extends2({}, options, { parent: this }));
      for (var name2 in styles2) {
        this.rules.add(name2, styles2[name2]);
      }
      this.rules.process();
    }
    _createClass2(ConditionalRule3, [{
      key: "getRule",
      value: function getRule(name2) {
        return this.rules.get(name2);
      }
      /**
       * Get index of a rule.
       */
    }, {
      key: "indexOf",
      value: function indexOf2(rule) {
        return this.rules.indexOf(rule);
      }
      /**
       * Create and register rule, run plugins.
       */
    }, {
      key: "addRule",
      value: function addRule(name2, style2, options) {
        var rule = this.rules.add(name2, style2, options);
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
      }
      /**
       * Generates a CSS string.
       */
    }, {
      key: "toString",
      value: function toString2() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { indent: 1 };
        var inner2 = this.rules.toString(options);
        return inner2 ? this.key + " {\n" + inner2 + "\n}" : "";
      }
    }]);
    return ConditionalRule3;
  }();
  exports["default"] = ConditionalRule2;
})(ConditionalRule);
var FontFaceRule = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _toCss = toCss;
  var _toCss2 = _interopRequireDefault2(_toCss);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var FontFaceRule2 = function() {
    function FontFaceRule3(key2, style2, options) {
      _classCallCheck4(this, FontFaceRule3);
      this.type = "font-face";
      this.isProcessed = false;
      this.key = key2;
      this.style = style2;
      this.options = options;
    }
    _createClass2(FontFaceRule3, [{
      key: "toString",
      value: function toString2(options) {
        if (Array.isArray(this.style)) {
          var str = "";
          for (var index2 = 0; index2 < this.style.length; index2++) {
            str += (0, _toCss2["default"])(this.key, this.style[index2]);
            if (this.style[index2 + 1]) str += "\n";
          }
          return str;
        }
        return (0, _toCss2["default"])(this.key, this.style, options);
      }
    }]);
    return FontFaceRule3;
  }();
  exports["default"] = FontFaceRule2;
})(FontFaceRule);
var ViewportRule = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _toCss = toCss;
  var _toCss2 = _interopRequireDefault2(_toCss);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var ViewportRule2 = function() {
    function ViewportRule3(key2, style2, options) {
      _classCallCheck4(this, ViewportRule3);
      this.type = "viewport";
      this.isProcessed = false;
      this.key = key2;
      this.style = style2;
      this.options = options;
    }
    _createClass2(ViewportRule3, [{
      key: "toString",
      value: function toString2(options) {
        return (0, _toCss2["default"])(this.key, this.style, options);
      }
    }]);
    return ViewportRule3;
  }();
  exports["default"] = ViewportRule2;
})(ViewportRule);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _SimpleRule = SimpleRule;
  var _SimpleRule2 = _interopRequireDefault2(_SimpleRule);
  var _KeyframesRule = KeyframesRule;
  var _KeyframesRule2 = _interopRequireDefault2(_KeyframesRule);
  var _ConditionalRule = ConditionalRule;
  var _ConditionalRule2 = _interopRequireDefault2(_ConditionalRule);
  var _FontFaceRule = FontFaceRule;
  var _FontFaceRule2 = _interopRequireDefault2(_FontFaceRule);
  var _ViewportRule = ViewportRule;
  var _ViewportRule2 = _interopRequireDefault2(_ViewportRule);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var classes = {
    "@charset": _SimpleRule2["default"],
    "@import": _SimpleRule2["default"],
    "@namespace": _SimpleRule2["default"],
    "@keyframes": _KeyframesRule2["default"],
    "@media": _ConditionalRule2["default"],
    "@supports": _ConditionalRule2["default"],
    "@font-face": _FontFaceRule2["default"],
    "@viewport": _ViewportRule2["default"],
    "@-ms-viewport": _ViewportRule2["default"]
    /**
     * Generate plugins which will register all rules.
     */
  };
  var plugins2 = Object.keys(classes).map(function(key2) {
    var re2 = new RegExp("^" + key2);
    var RuleClass = classes[key2];
    var onCreateRule = function onCreateRule2(name2, decl, options) {
      return re2.test(name2) ? new RuleClass(name2, decl, options) : null;
    };
    return { onCreateRule };
  });
  exports["default"] = plugins2;
})(rules$1);
var observables = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _StyleRule = StyleRule;
  var _StyleRule2 = _interopRequireDefault2(_StyleRule);
  var _createRule = createRule;
  var _createRule2 = _interopRequireDefault2(_createRule);
  var _isObservable = isObservable;
  var _isObservable2 = _interopRequireDefault2(_isObservable);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = {
    onCreateRule: function onCreateRule(name2, decl, options) {
      if (!(0, _isObservable2["default"])(decl)) return null;
      var style$ = decl;
      var rule = (0, _createRule2["default"])(name2, {}, options);
      style$.subscribe(function(style2) {
        for (var prop in style2) {
          rule.prop(prop, style2[prop]);
        }
      });
      return rule;
    },
    onProcessRule: function onProcessRule(rule) {
      if (!(rule instanceof _StyleRule2["default"])) return;
      var styleRule = rule;
      var style2 = styleRule.style;
      var _loop = function _loop2(prop2) {
        var value = style2[prop2];
        if (!(0, _isObservable2["default"])(value)) return "continue";
        delete style2[prop2];
        value.subscribe({
          next: function next3(nextValue) {
            styleRule.prop(prop2, nextValue);
          }
        });
      };
      for (var prop in style2) {
        var _ret = _loop(prop);
        if (_ret === "continue") continue;
      }
    }
  };
})(observables);
var functions = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _RuleList = RuleList;
  var _RuleList2 = _interopRequireDefault2(_RuleList);
  var _StyleRule = StyleRule;
  var _StyleRule2 = _interopRequireDefault2(_StyleRule);
  var _createRule = createRule;
  var _createRule2 = _interopRequireDefault2(_createRule);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var now2 = Date.now();
  var fnValuesNs = "fnValues" + now2;
  var fnStyleNs = "fnStyle" + ++now2;
  exports["default"] = {
    onCreateRule: function onCreateRule(name2, decl, options) {
      if (typeof decl !== "function") return null;
      var rule = (0, _createRule2["default"])(name2, {}, options);
      rule[fnStyleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style2, rule) {
      var fn2 = {};
      for (var prop in style2) {
        var value = style2[prop];
        if (typeof value !== "function") continue;
        delete style2[prop];
        fn2[prop] = value;
      }
      rule = rule;
      rule[fnValuesNs] = fn2;
      return style2;
    },
    onUpdate: function onUpdate2(data, rule) {
      if (rule.rules instanceof _RuleList2["default"]) {
        rule.rules.update(data);
        return;
      }
      if (!(rule instanceof _StyleRule2["default"])) return;
      rule = rule;
      if (rule[fnValuesNs]) {
        for (var prop in rule[fnValuesNs]) {
          rule.prop(prop, rule[fnValuesNs][prop](data));
        }
      }
      rule = rule;
      var fnStyle = rule[fnStyleNs];
      if (fnStyle) {
        var style2 = fnStyle(data);
        for (var _prop in style2) {
          rule.prop(_prop, style2[_prop]);
        }
      }
    }
  };
})(functions);
var DomRenderer = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _warning3 = browser;
  var _warning22 = _interopRequireDefault2(_warning3);
  var _sheets = sheets;
  var _sheets2 = _interopRequireDefault2(_sheets);
  var _StyleRule = StyleRule;
  var _StyleRule2 = _interopRequireDefault2(_StyleRule);
  var _toCssValue = toCssValue;
  var _toCssValue2 = _interopRequireDefault2(_toCssValue);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var memoize2 = function memoize3(fn2) {
    var value = void 0;
    return function() {
      if (!value) value = fn2();
      return value;
    };
  };
  function getPropertyValue(cssRule, prop) {
    try {
      return cssRule.style.getPropertyValue(prop);
    } catch (err) {
      return "";
    }
  }
  function setProperty3(cssRule, prop, value) {
    try {
      var cssValue = value;
      if (Array.isArray(value)) {
        cssValue = (0, _toCssValue2["default"])(value, true);
        if (value[value.length - 1] === "!important") {
          cssRule.style.setProperty(prop, cssValue, "important");
          return true;
        }
      }
      cssRule.style.setProperty(prop, cssValue);
    } catch (err) {
      return false;
    }
    return true;
  }
  function removeProperty(cssRule, prop) {
    try {
      cssRule.style.removeProperty(prop);
    } catch (err) {
      (0, _warning22["default"])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
    }
  }
  var CSSRuleTypes = {
    STYLE_RULE: 1,
    KEYFRAMES_RULE: 7
    /**
     * Get the CSS Rule key.
     */
  };
  var getKey = /* @__PURE__ */ function() {
    var extractKey = function extractKey2(cssText) {
      var from2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      return cssText.substr(from2, cssText.indexOf("{") - 1);
    };
    return function(cssRule) {
      if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
      if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
        var name2 = cssRule.name;
        if (name2) return "@keyframes " + name2;
        var cssText = cssRule.cssText;
        return "@" + extractKey(cssText, cssText.indexOf("keyframes"));
      }
      return extractKey(cssRule.cssText);
    };
  }();
  function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText;
    return cssRule.selectorText === selectorText;
  }
  var getHead = memoize2(function() {
    return document.head || document.getElementsByTagName("head")[0];
  });
  var getUnescapedKeysMap = /* @__PURE__ */ function() {
    var style2 = void 0;
    var isAttached = false;
    return function(rules2) {
      var map2 = {};
      if (!style2) style2 = document.createElement("style");
      for (var i3 = 0; i3 < rules2.length; i3++) {
        var rule = rules2[i3];
        if (!(rule instanceof _StyleRule2["default"])) continue;
        var selector = rule.selector;
        if (selector && selector.indexOf("\\") !== -1) {
          if (!isAttached) {
            getHead().appendChild(style2);
            isAttached = true;
          }
          style2.textContent = selector + " {}";
          var _style = style2, sheet = _style.sheet;
          if (sheet) {
            var cssRules = sheet.cssRules;
            if (cssRules) map2[cssRules[0].selectorText] = rule.key;
          }
        }
      }
      if (isAttached) {
        getHead().removeChild(style2);
        isAttached = false;
      }
      return map2;
    };
  }();
  function findHigherSheet(registry, options) {
    for (var i3 = 0; i3 < registry.length; i3++) {
      var sheet = registry[i3];
      if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
        return sheet;
      }
    }
    return null;
  }
  function findHighestSheet(registry, options) {
    for (var i3 = registry.length - 1; i3 >= 0; i3--) {
      var sheet = registry[i3];
      if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
        return sheet;
      }
    }
    return null;
  }
  function findCommentNode(text) {
    var head = getHead();
    for (var i3 = 0; i3 < head.childNodes.length; i3++) {
      var node3 = head.childNodes[i3];
      if (node3.nodeType === 8 && node3.nodeValue.trim() === text) {
        return node3;
      }
    }
    return null;
  }
  function findPrevNode(options) {
    var registry = _sheets2["default"].registry;
    if (registry.length > 0) {
      var sheet = findHigherSheet(registry, options);
      if (sheet) return sheet.renderer.element;
      sheet = findHighestSheet(registry, options);
      if (sheet) return sheet.renderer.element.nextElementSibling;
    }
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
      var comment = findCommentNode(insertionPoint);
      if (comment) return comment.nextSibling;
      (0, _warning22["default"])(insertionPoint === "jss", '[JSS] Insertion point "%s" not found.', insertionPoint);
    }
    return null;
  }
  function insertStyle(style2, options) {
    var insertionPoint = options.insertionPoint;
    var prevNode = findPrevNode(options);
    if (prevNode) {
      var parentNode = prevNode.parentNode;
      if (parentNode) parentNode.insertBefore(style2, prevNode);
      return;
    }
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
      var insertionPointElement = insertionPoint;
      var _parentNode = insertionPointElement.parentNode;
      if (_parentNode) _parentNode.insertBefore(style2, insertionPointElement.nextSibling);
      else (0, _warning22["default"])(false, "[JSS] Insertion point is not in the DOM.");
      return;
    }
    getHead().insertBefore(style2, prevNode);
  }
  var getNonce = memoize2(function() {
    var node3 = document.querySelector('meta[property="csp-nonce"]');
    return node3 ? node3.getAttribute("content") : null;
  });
  var DomRenderer2 = function() {
    function DomRenderer3(sheet) {
      _classCallCheck4(this, DomRenderer3);
      this.getPropertyValue = getPropertyValue;
      this.setProperty = setProperty3;
      this.removeProperty = removeProperty;
      this.setSelector = setSelector;
      this.getKey = getKey;
      this.getUnescapedKeysMap = getUnescapedKeysMap;
      this.hasInsertedRules = false;
      if (sheet) _sheets2["default"].add(sheet);
      this.sheet = sheet;
      var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta2 = _ref.meta, element = _ref.element;
      this.element = element || document.createElement("style");
      this.element.setAttribute("data-jss", "");
      if (media) this.element.setAttribute("media", media);
      if (meta2) this.element.setAttribute("data-meta", meta2);
      var nonce = getNonce();
      if (nonce) this.element.setAttribute("nonce", nonce);
    }
    _createClass2(DomRenderer3, [{
      key: "attach",
      value: function attach() {
        if (this.element.parentNode || !this.sheet) return;
        if (this.hasInsertedRules) {
          this.deploy();
          this.hasInsertedRules = false;
        }
        insertStyle(this.element, this.sheet.options);
      }
      /**
       * Remove style element from render tree.
       */
    }, {
      key: "detach",
      value: function detach() {
        this.element.parentNode.removeChild(this.element);
      }
      /**
       * Inject CSS string into element.
       */
    }, {
      key: "deploy",
      value: function deploy() {
        if (!this.sheet) return;
        this.element.textContent = "\n" + this.sheet.toString() + "\n";
      }
      /**
       * Insert a rule into element.
       */
    }, {
      key: "insertRule",
      value: function insertRule(rule, index2) {
        var sheet = this.element.sheet;
        var cssRules = sheet.cssRules;
        var str = rule.toString();
        if (!index2) index2 = cssRules.length;
        if (!str) return false;
        try {
          sheet.insertRule(str, index2);
        } catch (err) {
          (0, _warning22["default"])(false, "[JSS] Can not insert an unsupported rule \n\r%s", rule);
          return false;
        }
        this.hasInsertedRules = true;
        return cssRules[index2];
      }
      /**
       * Delete a rule.
       */
    }, {
      key: "deleteRule",
      value: function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index2 = this.indexOf(cssRule);
        if (index2 === -1) return false;
        sheet.deleteRule(index2);
        return true;
      }
      /**
       * Get index of a CSS Rule.
       */
    }, {
      key: "indexOf",
      value: function indexOf2(cssRule) {
        var cssRules = this.element.sheet.cssRules;
        for (var _index = 0; _index < cssRules.length; _index++) {
          if (cssRule === cssRules[_index]) return _index;
        }
        return -1;
      }
      /**
       * Generate a new CSS rule and replace the existing one.
       */
    }, {
      key: "replaceRule",
      value: function replaceRule(cssRule, rule) {
        var index2 = this.indexOf(cssRule);
        var newCssRule = this.insertRule(rule, index2);
        this.element.sheet.deleteRule(index2);
        return newCssRule;
      }
      /**
       * Get all rules elements.
       */
    }, {
      key: "getRules",
      value: function getRules2() {
        return this.element.sheet.cssRules;
      }
    }]);
    return DomRenderer3;
  }();
  exports["default"] = DomRenderer2;
})(DomRenderer);
var VirtualRenderer = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var VirtualRenderer2 = function() {
    function VirtualRenderer3() {
      _classCallCheck4(this, VirtualRenderer3);
    }
    _createClass2(VirtualRenderer3, [{
      key: "setProperty",
      value: function setProperty3() {
        return true;
      }
    }, {
      key: "getPropertyValue",
      value: function getPropertyValue() {
        return "";
      }
    }, {
      key: "removeProperty",
      value: function removeProperty() {
      }
    }, {
      key: "setSelector",
      value: function setSelector() {
        return true;
      }
    }, {
      key: "getKey",
      value: function getKey() {
        return "";
      }
    }, {
      key: "attach",
      value: function attach() {
      }
    }, {
      key: "detach",
      value: function detach() {
      }
    }, {
      key: "deploy",
      value: function deploy() {
      }
    }, {
      key: "insertRule",
      value: function insertRule() {
        return false;
      }
    }, {
      key: "deleteRule",
      value: function deleteRule() {
        return true;
      }
    }, {
      key: "replaceRule",
      value: function replaceRule() {
        return false;
      }
    }, {
      key: "getRules",
      value: function getRules2() {
      }
    }, {
      key: "indexOf",
      value: function indexOf2() {
        return -1;
      }
    }]);
    return VirtualRenderer3;
  }();
  exports["default"] = VirtualRenderer2;
})(VirtualRenderer);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _typeof4 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _extends2 = Object.assign || function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _isInBrowser = require$$0$4;
  var _isInBrowser2 = _interopRequireDefault2(_isInBrowser);
  var _StyleSheet = StyleSheet;
  var _StyleSheet2 = _interopRequireDefault2(_StyleSheet);
  var _PluginsRegistry = PluginsRegistry;
  var _PluginsRegistry2 = _interopRequireDefault2(_PluginsRegistry);
  var _rules = rules$1;
  var _rules2 = _interopRequireDefault2(_rules);
  var _observables = observables;
  var _observables2 = _interopRequireDefault2(_observables);
  var _functions = functions;
  var _functions2 = _interopRequireDefault2(_functions);
  var _sheets = sheets;
  var _sheets2 = _interopRequireDefault2(_sheets);
  var _StyleRule = StyleRule;
  var _StyleRule2 = _interopRequireDefault2(_StyleRule);
  var _createGenerateClassName = createGenerateClassName;
  var _createGenerateClassName2 = _interopRequireDefault2(_createGenerateClassName);
  var _createRule2 = createRule;
  var _createRule3 = _interopRequireDefault2(_createRule2);
  var _DomRenderer = DomRenderer;
  var _DomRenderer2 = _interopRequireDefault2(_DomRenderer);
  var _VirtualRenderer = VirtualRenderer;
  var _VirtualRenderer2 = _interopRequireDefault2(_VirtualRenderer);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var defaultPlugins = _rules2["default"].concat([_observables2["default"], _functions2["default"]]);
  var instanceCounter = 0;
  var Jss2 = function() {
    function Jss3(options) {
      _classCallCheck4(this, Jss3);
      this.id = instanceCounter++;
      this.version = "9.8.7";
      this.plugins = new _PluginsRegistry2["default"]();
      this.options = {
        createGenerateClassName: _createGenerateClassName2["default"],
        Renderer: _isInBrowser2["default"] ? _DomRenderer2["default"] : _VirtualRenderer2["default"],
        plugins: []
      };
      this.generateClassName = (0, _createGenerateClassName2["default"])();
      this.use.apply(this, defaultPlugins);
      this.setup(options);
    }
    _createClass2(Jss3, [{
      key: "setup",
      value: function setup() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (options.createGenerateClassName) {
          this.options.createGenerateClassName = options.createGenerateClassName;
          this.generateClassName = options.createGenerateClassName();
        }
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if (options.virtual || options.Renderer) {
          this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2["default"] : _DomRenderer2["default"]);
        }
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
      }
      /**
       * Create a Style Sheet.
       */
    }, {
      key: "createStyleSheet",
      value: function createStyleSheet(styles2) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var index2 = options.index;
        if (typeof index2 !== "number") {
          index2 = _sheets2["default"].index === 0 ? 0 : _sheets2["default"].index + 1;
        }
        var sheet = new _StyleSheet2["default"](styles2, _extends2({}, options, {
          jss: this,
          generateClassName: options.generateClassName || this.generateClassName,
          insertionPoint: this.options.insertionPoint,
          Renderer: this.options.Renderer,
          index: index2
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
      }
      /**
       * Detach the Style Sheet and remove it from the registry.
       */
    }, {
      key: "removeStyleSheet",
      value: function removeStyleSheet(sheet) {
        sheet.detach();
        _sheets2["default"].remove(sheet);
        return this;
      }
      /**
       * Create a rule without a Style Sheet.
       */
    }, {
      key: "createRule",
      value: function createRule2(name2) {
        var style2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if ((typeof name2 === "undefined" ? "undefined" : _typeof4(name2)) === "object") {
          options = style2;
          style2 = name2;
          name2 = void 0;
        }
        var ruleOptions = options;
        ruleOptions.jss = this;
        ruleOptions.Renderer = this.options.Renderer;
        if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        var rule = (0, _createRule3["default"])(name2, style2, ruleOptions);
        if (!ruleOptions.selector && rule instanceof _StyleRule2["default"]) {
          rule.selector = "." + ruleOptions.generateClassName(rule);
        }
        this.plugins.onProcessRule(rule);
        return rule;
      }
      /**
       * Register plugin. Passed function will be invoked with a rule instance.
       */
    }, {
      key: "use",
      value: function use() {
        var _this = this;
        for (var _len = arguments.length, plugins2 = Array(_len), _key = 0; _key < _len; _key++) {
          plugins2[_key] = arguments[_key];
        }
        plugins2.forEach(function(plugin) {
          if (_this.options.plugins.indexOf(plugin) === -1) {
            _this.options.plugins.push(plugin);
            _this.plugins.use(plugin);
          }
        });
        return this;
      }
    }]);
    return Jss3;
  }();
  exports["default"] = Jss2;
})(Jss);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = void 0;
  var _getDynamicStyles = getDynamicStyles;
  Object.defineProperty(exports, "getDynamicStyles", {
    enumerable: true,
    get: function get2() {
      return _interopRequireDefault2(_getDynamicStyles)["default"];
    }
  });
  var _toCssValue = toCssValue;
  Object.defineProperty(exports, "toCssValue", {
    enumerable: true,
    get: function get2() {
      return _interopRequireDefault2(_toCssValue)["default"];
    }
  });
  var _SheetsRegistry = SheetsRegistry;
  Object.defineProperty(exports, "SheetsRegistry", {
    enumerable: true,
    get: function get2() {
      return _interopRequireDefault2(_SheetsRegistry)["default"];
    }
  });
  var _SheetsManager = SheetsManager;
  Object.defineProperty(exports, "SheetsManager", {
    enumerable: true,
    get: function get2() {
      return _interopRequireDefault2(_SheetsManager)["default"];
    }
  });
  var _RuleList = RuleList;
  Object.defineProperty(exports, "RuleList", {
    enumerable: true,
    get: function get2() {
      return _interopRequireDefault2(_RuleList)["default"];
    }
  });
  var _sheets = sheets;
  Object.defineProperty(exports, "sheets", {
    enumerable: true,
    get: function get2() {
      return _interopRequireDefault2(_sheets)["default"];
    }
  });
  var _createGenerateClassName = createGenerateClassName;
  Object.defineProperty(exports, "createGenerateClassName", {
    enumerable: true,
    get: function get2() {
      return _interopRequireDefault2(_createGenerateClassName)["default"];
    }
  });
  var _Jss = Jss;
  var _Jss2 = _interopRequireDefault2(_Jss);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var create5 = exports.create = function create6(options) {
    return new _Jss2["default"](options);
  };
  exports["default"] = create5();
})(lib$n);
var lib$m = {};
var lib$l = {};
var parse$4 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _warning3 = browser;
  var _warning22 = _interopRequireDefault2(_warning3);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var semiWithNl = /;\n/;
  exports["default"] = function(cssText) {
    var style2 = {};
    var split = cssText.split(semiWithNl);
    for (var i3 = 0; i3 < split.length; i3++) {
      var decl = (split[i3] || "").trim();
      if (!decl) continue;
      var colonIndex = decl.indexOf(":");
      if (colonIndex === -1) {
        (0, _warning22["default"])(false, 'Malformed CSS string "%s"', decl);
        continue;
      }
      var prop = decl.substr(0, colonIndex).trim();
      var value = decl.substr(colonIndex + 1).trim();
      style2[prop] = value;
    }
    return style2;
  };
})(parse$4);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _parse = parse$4;
  var _parse2 = _interopRequireDefault2(_parse);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var onProcessRule = function onProcessRule2(rule) {
    if (typeof rule.style === "string") {
      rule.style = (0, _parse2["default"])(rule.style);
    }
  };
  exports["default"] = function() {
    return { onProcessRule };
  };
})(lib$l);
var lib$k = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  exports["default"] = jssGlobal;
  var _jss = lib$n;
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var propKey = "@global";
  var prefixKey = "@global ";
  var GlobalContainerRule = function() {
    function GlobalContainerRule2(key2, styles2, options) {
      _classCallCheck4(this, GlobalContainerRule2);
      this.type = "global";
      this.key = key2;
      this.options = options;
      this.rules = new _jss.RuleList(_extends2({}, options, {
        parent: this
      }));
      for (var selector in styles2) {
        this.rules.add(selector, styles2[selector], { selector });
      }
      this.rules.process();
    }
    _createClass2(GlobalContainerRule2, [{
      key: "getRule",
      value: function getRule(name2) {
        return this.rules.get(name2);
      }
      /**
       * Create and register rule, run plugins.
       */
    }, {
      key: "addRule",
      value: function addRule(name2, style2, options) {
        var rule = this.rules.add(name2, style2, options);
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
      }
      /**
       * Get index of a rule.
       */
    }, {
      key: "indexOf",
      value: function indexOf2(rule) {
        return this.rules.indexOf(rule);
      }
      /**
       * Generates a CSS string.
       */
    }, {
      key: "toString",
      value: function toString2() {
        return this.rules.toString();
      }
    }]);
    return GlobalContainerRule2;
  }();
  var GlobalPrefixedRule = function() {
    function GlobalPrefixedRule2(name2, style2, options) {
      _classCallCheck4(this, GlobalPrefixedRule2);
      this.name = name2;
      this.options = options;
      var selector = name2.substr(prefixKey.length);
      this.rule = options.jss.createRule(selector, style2, _extends2({}, options, {
        parent: this,
        selector
      }));
    }
    _createClass2(GlobalPrefixedRule2, [{
      key: "toString",
      value: function toString2(options) {
        return this.rule.toString(options);
      }
    }]);
    return GlobalPrefixedRule2;
  }();
  var separatorRegExp2 = /\s*,\s*/g;
  function addScope(selector, scope2) {
    var parts = selector.split(separatorRegExp2);
    var scoped = "";
    for (var i3 = 0; i3 < parts.length; i3++) {
      scoped += scope2 + " " + parts[i3].trim();
      if (parts[i3 + 1]) scoped += ", ";
    }
    return scoped;
  }
  function handleNestedGlobalContainerRule(rule) {
    var options = rule.options, style2 = rule.style;
    var rules2 = style2[propKey];
    if (!rules2) return;
    for (var name2 in rules2) {
      options.sheet.addRule(name2, rules2[name2], _extends2({}, options, {
        selector: addScope(name2, rule.selector)
      }));
    }
    delete style2[propKey];
  }
  function handlePrefixedGlobalRule(rule) {
    var options = rule.options, style2 = rule.style;
    for (var prop in style2) {
      if (prop.substr(0, propKey.length) !== propKey) continue;
      var selector = addScope(prop.substr(propKey.length), rule.selector);
      options.sheet.addRule(selector, style2[prop], _extends2({}, options, {
        selector
      }));
      delete style2[prop];
    }
  }
  function jssGlobal() {
    function onCreateRule(name2, styles2, options) {
      if (name2 === propKey) {
        return new GlobalContainerRule(name2, styles2, options);
      }
      if (name2[0] === "@" && name2.substr(0, prefixKey.length) === prefixKey) {
        return new GlobalPrefixedRule(name2, styles2, options);
      }
      var parent3 = options.parent;
      if (parent3) {
        if (parent3.type === "global" || parent3.options.parent.type === "global") {
          options.global = true;
        }
      }
      if (options.global) options.selector = name2;
      return null;
    }
    function onProcessRule(rule) {
      if (rule.type !== "style") return;
      handleNestedGlobalContainerRule(rule);
      handlePrefixedGlobalRule(rule);
    }
    return { onCreateRule, onProcessRule };
  }
})(lib$k);
var lib$j = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _typeof4 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  exports["default"] = jssExtend;
  var _warning3 = browser;
  var _warning22 = _interopRequireDefault2(_warning3);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var isObject3 = function isObject4(obj) {
    return obj && (typeof obj === "undefined" ? "undefined" : _typeof4(obj)) === "object" && !Array.isArray(obj);
  };
  var valueNs = "extendCurrValue" + Date.now();
  function mergeExtend(style2, rule, sheet, newStyle) {
    var extendType = _typeof4(style2.extend);
    if (extendType === "string") {
      if (!sheet) return;
      var refRule = sheet.getRule(style2.extend);
      if (!refRule) return;
      if (refRule === rule) {
        (0, _warning22["default"])(false, "[JSS] A rule tries to extend itself \r\n%s", rule);
        return;
      }
      var parent3 = refRule.options.parent;
      if (parent3) {
        var originalStyle = parent3.rules.raw[style2.extend];
        extend3(originalStyle, rule, sheet, newStyle);
      }
      return;
    }
    if (Array.isArray(style2.extend)) {
      for (var index2 = 0; index2 < style2.extend.length; index2++) {
        extend3(style2.extend[index2], rule, sheet, newStyle);
      }
      return;
    }
    for (var prop in style2.extend) {
      if (prop === "extend") {
        extend3(style2.extend.extend, rule, sheet, newStyle);
        continue;
      }
      if (isObject3(style2.extend[prop])) {
        if (!(prop in newStyle)) newStyle[prop] = {};
        extend3(style2.extend[prop], rule, sheet, newStyle[prop]);
        continue;
      }
      newStyle[prop] = style2.extend[prop];
    }
  }
  function mergeRest(style2, rule, sheet, newStyle) {
    for (var prop in style2) {
      if (prop === "extend") continue;
      if (isObject3(newStyle[prop]) && isObject3(style2[prop])) {
        extend3(style2[prop], rule, sheet, newStyle[prop]);
        continue;
      }
      if (isObject3(style2[prop])) {
        newStyle[prop] = extend3(style2[prop], rule, sheet);
        continue;
      }
      newStyle[prop] = style2[prop];
    }
  }
  function extend3(style2, rule, sheet) {
    var newStyle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    mergeExtend(style2, rule, sheet, newStyle);
    mergeRest(style2, rule, sheet, newStyle);
    return newStyle;
  }
  function jssExtend() {
    function onProcessStyle(style2, rule, sheet) {
      if ("extend" in style2) return extend3(style2, rule, sheet);
      return style2;
    }
    function onChangeValue(value, prop, rule) {
      if (prop !== "extend") return value;
      if (value == null || value === false) {
        for (var key2 in rule[valueNs]) {
          rule.prop(key2, null);
        }
        rule[valueNs] = null;
        return null;
      }
      for (var _key in value) {
        rule.prop(_key, value[_key]);
      }
      rule[valueNs] = value;
      return null;
    }
    return { onProcessStyle, onChangeValue };
  }
})(lib$j);
var lib$i = {};
Object.defineProperty(lib$i, "__esModule", {
  value: true
});
var _extends$3 = Object.assign || function(target) {
  for (var i3 = 1; i3 < arguments.length; i3++) {
    var source = arguments[i3];
    for (var key2 in source) {
      if (Object.prototype.hasOwnProperty.call(source, key2)) {
        target[key2] = source[key2];
      }
    }
  }
  return target;
};
lib$i.default = jssNested;
var _warning$1 = browser;
var _warning2$1 = _interopRequireDefault$e(_warning$1);
function _interopRequireDefault$e(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
function jssNested() {
  function getReplaceRef(container) {
    return function(match5, key2) {
      var rule = container.getRule(key2);
      if (rule) return rule.selector;
      (0, _warning2$1.default)(false, "[JSS] Could not find the referenced rule %s in %s.", key2, container.options.meta || container);
      return key2;
    };
  }
  var hasAnd = function hasAnd2(str) {
    return str.indexOf("&") !== -1;
  };
  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result2 = "";
    for (var i3 = 0; i3 < parentSelectors.length; i3++) {
      var parent3 = parentSelectors[i3];
      for (var j2 = 0; j2 < nestedSelectors.length; j2++) {
        var nested = nestedSelectors[j2];
        if (result2) result2 += ", ";
        result2 += hasAnd(nested) ? nested.replace(parentRegExp, parent3) : parent3 + " " + nested;
      }
    }
    return result2;
  }
  function getOptions(rule, container, options) {
    if (options) return _extends$3({}, options, { index: options.index + 1 });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === void 0 ? 1 : nestingLevel + 1;
    return _extends$3({}, rule.options, {
      nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }
  function onProcessStyle(style2, rule) {
    if (rule.type !== "style") return style2;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style2) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === "@";
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(rule, container, options);
      if (isNested) {
        var selector = replaceParentRefs(
          prop,
          rule.selector
          // Lazily create the ref replacer function just once for
          // all nested rules within the sheet.
        );
        if (!replaceRef) replaceRef = getReplaceRef(
          container
          // Replace all $refs.
        );
        selector = selector.replace(refRegExp, replaceRef);
        container.addRule(selector, style2[prop], _extends$3({}, options, { selector }));
      } else if (isNestedConditional) {
        container.addRule(prop, null, options).addRule(rule.key, style2[prop], { selector: rule.selector });
      }
      delete style2[prop];
    }
    return style2;
  }
  return { onProcessStyle };
}
var lib$h = {};
Object.defineProperty(lib$h, "__esModule", {
  value: true
});
lib$h.default = jssCompose;
var _warning = browser;
var _warning2 = _interopRequireDefault$d(_warning);
function _interopRequireDefault$d(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function registerClass(rule, className) {
  if (!className) return true;
  if (Array.isArray(className)) {
    for (var index2 = 0; index2 < className.length; index2++) {
      var isSetted = registerClass(rule, className[index2]);
      if (!isSetted) return false;
    }
    return true;
  }
  if (className.indexOf(" ") > -1) {
    return registerClass(rule, className.split(" "));
  }
  var parent3 = rule.options.parent;
  if (className[0] === "$") {
    var refRule = parent3.getRule(className.substr(1));
    if (!refRule) {
      (0, _warning2.default)(false, "[JSS] Referenced rule is not defined. \r\n%s", rule);
      return false;
    }
    if (refRule === rule) {
      (0, _warning2.default)(false, "[JSS] Cyclic composition detected. \r\n%s", rule);
      return false;
    }
    parent3.classes[rule.key] += " " + parent3.classes[refRule.key];
    return true;
  }
  rule.options.parent.classes[rule.key] += " " + className;
  return true;
}
function jssCompose() {
  function onProcessStyle(style2, rule) {
    if (!style2.composes) return style2;
    registerClass(rule, style2.composes);
    delete style2.composes;
    return style2;
  }
  return { onProcessStyle };
}
var lib$g = {};
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache$1 = {};
function toHyphenLower(match5) {
  return "-" + match5.toLowerCase();
}
function hyphenateStyleName(name2) {
  if (cache$1.hasOwnProperty(name2)) {
    return cache$1[name2];
  }
  var hName = name2.replace(uppercasePattern, toHyphenLower);
  return cache$1[name2] = msPattern.test(hName) ? "-" + hName : hName;
}
const hyphenateStyleName$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hyphenateStyleName
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$3 = /* @__PURE__ */ getAugmentedNamespace(hyphenateStyleName$1);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = camelCase;
  var _hyphenateStyleName = require$$0$3;
  var _hyphenateStyleName2 = _interopRequireDefault2(_hyphenateStyleName);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function convertCase(style2) {
    var converted = {};
    for (var prop in style2) {
      converted[(0, _hyphenateStyleName2["default"])(prop)] = style2[prop];
    }
    if (style2.fallbacks) {
      if (Array.isArray(style2.fallbacks)) converted.fallbacks = style2.fallbacks.map(convertCase);
      else converted.fallbacks = convertCase(style2.fallbacks);
    }
    return converted;
  }
  function camelCase() {
    function onProcessStyle(style2) {
      if (Array.isArray(style2)) {
        for (var index2 = 0; index2 < style2.length; index2++) {
          style2[index2] = convertCase(style2[index2]);
        }
        return style2;
      }
      return convertCase(style2);
    }
    function onChangeValue(value, prop, rule) {
      var hyphenatedProp = (0, _hyphenateStyleName2["default"])(prop);
      if (prop === hyphenatedProp) return value;
      rule.prop(hyphenatedProp, value);
      return null;
    }
    return { onProcessStyle, onChangeValue };
  }
})(lib$g);
var lib$f = {};
var defaultUnits = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = {
    "animation-delay": "ms",
    "animation-duration": "ms",
    "background-position": "px",
    "background-position-x": "px",
    "background-position-y": "px",
    "background-size": "px",
    border: "px",
    "border-bottom": "px",
    "border-bottom-left-radius": "px",
    "border-bottom-right-radius": "px",
    "border-bottom-width": "px",
    "border-left": "px",
    "border-left-width": "px",
    "border-radius": "px",
    "border-right": "px",
    "border-right-width": "px",
    "border-spacing": "px",
    "border-top": "px",
    "border-top-left-radius": "px",
    "border-top-right-radius": "px",
    "border-top-width": "px",
    "border-width": "px",
    "border-after-width": "px",
    "border-before-width": "px",
    "border-end-width": "px",
    "border-horizontal-spacing": "px",
    "border-start-width": "px",
    "border-vertical-spacing": "px",
    bottom: "px",
    "box-shadow": "px",
    "column-gap": "px",
    "column-rule": "px",
    "column-rule-width": "px",
    "column-width": "px",
    "flex-basis": "px",
    "font-size": "px",
    "font-size-delta": "px",
    height: "px",
    left: "px",
    "letter-spacing": "px",
    "logical-height": "px",
    "logical-width": "px",
    margin: "px",
    "margin-after": "px",
    "margin-before": "px",
    "margin-bottom": "px",
    "margin-left": "px",
    "margin-right": "px",
    "margin-top": "px",
    "max-height": "px",
    "max-width": "px",
    "margin-end": "px",
    "margin-start": "px",
    "mask-position-x": "px",
    "mask-position-y": "px",
    "mask-size": "px",
    "max-logical-height": "px",
    "max-logical-width": "px",
    "min-height": "px",
    "min-width": "px",
    "min-logical-height": "px",
    "min-logical-width": "px",
    motion: "px",
    "motion-offset": "px",
    outline: "px",
    "outline-offset": "px",
    "outline-width": "px",
    padding: "px",
    "padding-bottom": "px",
    "padding-left": "px",
    "padding-right": "px",
    "padding-top": "px",
    "padding-after": "px",
    "padding-before": "px",
    "padding-end": "px",
    "padding-start": "px",
    "perspective-origin-x": "%",
    "perspective-origin-y": "%",
    perspective: "px",
    right: "px",
    "shape-margin": "px",
    size: "px",
    "text-indent": "px",
    "text-stroke": "px",
    "text-stroke-width": "px",
    top: "px",
    "transform-origin": "%",
    "transform-origin-x": "%",
    "transform-origin-y": "%",
    "transform-origin-z": "%",
    "transition-delay": "ms",
    "transition-duration": "ms",
    "vertical-align": "px",
    width: "px",
    "word-spacing": "px",
    // Not existing properties.
    // Used to avoid issues with jss-expand intergration.
    "box-shadow-x": "px",
    "box-shadow-y": "px",
    "box-shadow-blur": "px",
    "box-shadow-spread": "px",
    "font-line-height": "px",
    "text-shadow-x": "px",
    "text-shadow-y": "px",
    "text-shadow-blur": "px"
  };
})(defaultUnits);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _typeof4 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  exports["default"] = defaultUnit;
  var _defaultUnits = defaultUnits;
  var _defaultUnits2 = _interopRequireDefault2(_defaultUnits);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace2 = function replace3(str) {
      return str[1].toUpperCase();
    };
    var newObj = {};
    for (var key2 in obj) {
      newObj[key2] = obj[key2];
      newObj[key2.replace(regExp, replace2)] = obj[key2];
    }
    return newObj;
  }
  var units = addCamelCasedVersion(_defaultUnits2["default"]);
  function iterate(prop, value, options) {
    if (!value) return value;
    var convertedValue = value;
    var type2 = typeof value === "undefined" ? "undefined" : _typeof4(value);
    if (type2 === "object" && Array.isArray(value)) type2 = "array";
    switch (type2) {
      case "object":
        if (prop === "fallbacks") {
          for (var innerProp in value) {
            value[innerProp] = iterate(innerProp, value[innerProp], options);
          }
          break;
        }
        for (var _innerProp in value) {
          value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
        }
        break;
      case "array":
        for (var i3 = 0; i3 < value.length; i3++) {
          value[i3] = iterate(prop, value[i3], options);
        }
        break;
      case "number":
        if (value !== 0) {
          convertedValue = value + (options[prop] || units[prop] || "");
        }
        break;
    }
    return convertedValue;
  }
  function defaultUnit() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var camelCasedOptions = addCamelCasedVersion(options);
    function onProcessStyle(style2, rule) {
      if (rule.type !== "style") return style2;
      for (var prop in style2) {
        style2[prop] = iterate(prop, style2[prop], camelCasedOptions);
      }
      return style2;
    }
    function onChangeValue(value, prop) {
      return iterate(prop, value, camelCasedOptions);
    }
    return { onProcessStyle, onChangeValue };
  }
})(lib$f);
var lib$e = {};
var props = {};
Object.defineProperty(props, "__esModule", {
  value: true
});
props.propArray = {
  "background-size": true,
  "background-position": true,
  border: true,
  "border-bottom": true,
  "border-left": true,
  "border-top": true,
  "border-right": true,
  "border-radius": true,
  "border-image": true,
  "border-width": true,
  "border-style": true,
  "border-color": true,
  "box-shadow": true,
  flex: true,
  margin: true,
  padding: true,
  outline: true,
  "transform-origin": true,
  transform: true,
  transition: true
  /**
   * A scheme for converting arrays to regular styles inside of objects.
   * For e.g.: "{position: [0, 0]}" => "background-position: 0 0;".
   */
};
props.propArrayInObj = {
  position: true,
  // background-position
  size: true
  // background-size
  /**
   * A scheme for parsing and building correct styles from passed objects.
   */
};
props.propObj = {
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  background: {
    attachment: null,
    color: null,
    image: null,
    position: null,
    repeat: null
  },
  border: {
    width: null,
    style: null,
    color: null
  },
  "border-top": {
    width: null,
    style: null,
    color: null
  },
  "border-right": {
    width: null,
    style: null,
    color: null
  },
  "border-bottom": {
    width: null,
    style: null,
    color: null
  },
  "border-left": {
    width: null,
    style: null,
    color: null
  },
  outline: {
    width: null,
    style: null,
    color: null
  },
  "list-style": {
    type: null,
    position: null,
    image: null
  },
  transition: {
    property: null,
    duration: null,
    "timing-function": null,
    timingFunction: null,
    // Needed for avoiding comilation issues with jss-camel-case
    delay: null
  },
  animation: {
    name: null,
    duration: null,
    "timing-function": null,
    timingFunction: null,
    // Needed to avoid compilation issues with jss-camel-case
    delay: null,
    "iteration-count": null,
    iterationCount: null,
    // Needed to avoid compilation issues with jss-camel-case
    direction: null,
    "fill-mode": null,
    fillMode: null,
    // Needed to avoid compilation issues with jss-camel-case
    "play-state": null,
    playState: null
    // Needed to avoid compilation issues with jss-camel-case
  },
  "box-shadow": {
    x: 0,
    y: 0,
    blur: 0,
    spread: 0,
    color: null,
    inset: null
  },
  "text-shadow": {
    x: 0,
    y: 0,
    blur: null,
    color: null
  }
  /**
   * A scheme for converting non-standart properties inside object.
   * For e.g.: include 'border-radius' property inside 'border' object.
   */
};
props.customPropObj = {
  border: {
    radius: "border-radius",
    image: "border-image",
    width: "border-width",
    style: "border-style",
    color: "border-color"
  },
  background: {
    size: "background-size",
    image: "background-image"
  },
  font: {
    style: "font-style",
    variant: "font-variant",
    weight: "font-weight",
    stretch: "font-stretch",
    size: "font-size",
    family: "font-family",
    lineHeight: "line-height",
    // Needed to avoid compilation issues with jss-camel-case
    "line-height": "line-height"
  },
  flex: {
    grow: "flex-grow",
    basis: "flex-basis",
    direction: "flex-direction",
    wrap: "flex-wrap",
    flow: "flex-flow",
    shrink: "flex-shrink"
  },
  align: {
    self: "align-self",
    items: "align-items",
    content: "align-content"
  },
  grid: {
    "template-columns": "grid-template-columns",
    templateColumns: "grid-template-columns",
    "template-rows": "grid-template-rows",
    templateRows: "grid-template-rows",
    "template-areas": "grid-template-areas",
    templateAreas: "grid-template-areas",
    template: "grid-template",
    "auto-columns": "grid-auto-columns",
    autoColumns: "grid-auto-columns",
    "auto-rows": "grid-auto-rows",
    autoRows: "grid-auto-rows",
    "auto-flow": "grid-auto-flow",
    autoFlow: "grid-auto-flow",
    row: "grid-row",
    column: "grid-column",
    "row-start": "grid-row-start",
    rowStart: "grid-row-start",
    "row-end": "grid-row-end",
    rowEnd: "grid-row-end",
    "column-start": "grid-column-start",
    columnStart: "grid-column-start",
    "column-end": "grid-column-end",
    columnEnd: "grid-column-end",
    area: "grid-area",
    gap: "grid-gap",
    "row-gap": "grid-row-gap",
    rowGap: "grid-row-gap",
    "column-gap": "grid-column-gap",
    columnGap: "grid-column-gap"
  }
};
Object.defineProperty(lib$e, "__esModule", {
  value: true
});
var _typeof$6 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
lib$e.default = jssExpand;
var _props = props;
function _defineProperty$5(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function mapValuesByProp(value, prop, rule) {
  return value.map(function(item) {
    return objectToArray(item, prop, rule, false, true);
  });
}
function processArray(value, prop, scheme, rule) {
  if (scheme[prop] == null) return value;
  if (value.length === 0) return [];
  if (Array.isArray(value[0])) return processArray(value[0], prop, scheme);
  if (_typeof$6(value[0]) === "object") {
    return mapValuesByProp(value, prop, rule);
  }
  return [value];
}
function objectToArray(value, prop, rule, isFallback, isInArray) {
  if (!(_props.propObj[prop] || _props.customPropObj[prop])) return [];
  var result2 = [];
  if (_props.customPropObj[prop]) {
    value = customPropsToStyle(value, rule, _props.customPropObj[prop], isFallback);
  }
  if (Object.keys(value).length) {
    for (var baseProp in _props.propObj[prop]) {
      if (value[baseProp]) {
        if (Array.isArray(value[baseProp])) {
          result2.push(_props.propArrayInObj[baseProp] === null ? value[baseProp] : value[baseProp].join(" "));
        } else result2.push(value[baseProp]);
        continue;
      }
      if (_props.propObj[prop][baseProp] != null) {
        result2.push(_props.propObj[prop][baseProp]);
      }
    }
  }
  if (!result2.length || isInArray) return result2;
  return [result2];
}
function customPropsToStyle(value, rule, customProps, isFallback) {
  for (var prop in customProps) {
    var propName = customProps[prop];
    if (typeof value[prop] !== "undefined" && (isFallback || !rule.prop(propName))) {
      var appendedValue = styleDetector(_defineProperty$5({}, propName, value[prop]), rule)[propName];
      if (isFallback) rule.style.fallbacks[propName] = appendedValue;
      else rule.style[propName] = appendedValue;
    }
    delete value[prop];
  }
  return value;
}
function styleDetector(style2, rule, isFallback) {
  for (var prop in style2) {
    var value = style2[prop];
    if (Array.isArray(value)) {
      if (!Array.isArray(value[0])) {
        if (prop === "fallbacks") {
          for (var index2 = 0; index2 < style2.fallbacks.length; index2++) {
            style2.fallbacks[index2] = styleDetector(style2.fallbacks[index2], rule, true);
          }
          continue;
        }
        style2[prop] = processArray(value, prop, _props.propArray);
        if (!style2[prop].length) delete style2[prop];
      }
    } else if ((typeof value === "undefined" ? "undefined" : _typeof$6(value)) === "object") {
      if (prop === "fallbacks") {
        style2.fallbacks = styleDetector(style2.fallbacks, rule, true);
        continue;
      }
      style2[prop] = objectToArray(value, prop, rule, isFallback);
      if (!style2[prop].length) delete style2[prop];
    } else if (style2[prop] === "") delete style2[prop];
  }
  return style2;
}
function jssExpand() {
  function onProcessStyle(style2, rule) {
    if (!style2 || rule.type !== "style") return style2;
    if (Array.isArray(style2)) {
      for (var index2 = 0; index2 < style2.length; index2++) {
        style2[index2] = styleDetector(style2[index2], rule);
      }
      return style2;
    }
    return styleDetector(style2, rule);
  }
  return { onProcessStyle };
}
var lib$d = {};
var lib$c = {};
var prefix = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _isInBrowser = require$$0$4;
  var _isInBrowser2 = _interopRequireDefault2(_isInBrowser);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var js = "";
  var css = "";
  if (_isInBrowser2["default"]) {
    var jsCssMap = {
      Moz: "-moz-",
      // IE did it wrong again ...
      ms: "-ms-",
      O: "-o-",
      Webkit: "-webkit-"
    };
    var style2 = document.createElement("p").style;
    var testProp = "Transform";
    for (var key2 in jsCssMap) {
      if (key2 + testProp in style2) {
        js = key2;
        css = jsCssMap[key2];
        break;
      }
    }
  }
  exports["default"] = { js, css };
})(prefix);
var supportedProperty = {};
var camelize = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = camelize2;
  var regExp = /[-\s]+(.)?/g;
  function camelize2(str) {
    return str.replace(regExp, toUpper);
  }
  function toUpper(match5, c3) {
    return c3 ? c3.toUpperCase() : "";
  }
})(camelize);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = supportedProperty2;
  var _isInBrowser = require$$0$4;
  var _isInBrowser2 = _interopRequireDefault2(_isInBrowser);
  var _prefix = prefix;
  var _prefix2 = _interopRequireDefault2(_prefix);
  var _camelize = camelize;
  var _camelize2 = _interopRequireDefault2(_camelize);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var el2 = void 0;
  var cache2 = {};
  if (_isInBrowser2["default"]) {
    el2 = document.createElement("p");
    var computed = window.getComputedStyle(document.documentElement, "");
    for (var key2 in computed) {
      if (!isNaN(key2)) cache2[computed[key2]] = computed[key2];
    }
  }
  function supportedProperty2(prop) {
    if (!el2) return prop;
    if (cache2[prop] != null) return cache2[prop];
    if ((0, _camelize2["default"])(prop) in el2.style) {
      cache2[prop] = prop;
    } else if (_prefix2["default"].js + (0, _camelize2["default"])("-" + prop) in el2.style) {
      cache2[prop] = _prefix2["default"].css + prop;
    } else {
      cache2[prop] = false;
    }
    return cache2[prop];
  }
})(supportedProperty);
var supportedValue = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = supportedValue2;
  var _isInBrowser = require$$0$4;
  var _isInBrowser2 = _interopRequireDefault2(_isInBrowser);
  var _prefix = prefix;
  var _prefix2 = _interopRequireDefault2(_prefix);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var cache2 = {};
  var el2 = void 0;
  if (_isInBrowser2["default"]) el2 = document.createElement("p");
  function supportedValue2(property2, value) {
    if (!el2) return value;
    if (typeof value !== "string" || !isNaN(parseInt(value, 10))) return value;
    var cacheKey = property2 + value;
    if (cache2[cacheKey] != null) return cache2[cacheKey];
    try {
      el2.style[property2] = value;
    } catch (err) {
      cache2[cacheKey] = false;
      return false;
    }
    if (el2.style[property2] !== "") {
      cache2[cacheKey] = value;
    } else {
      value = _prefix2["default"].css + value;
      if (value === "-ms-flex") value = "-ms-flexbox";
      el2.style[property2] = value;
      if (el2.style[property2] !== "") cache2[cacheKey] = value;
    }
    if (!cache2[cacheKey]) cache2[cacheKey] = false;
    el2.style[property2] = "";
    return cache2[cacheKey];
  }
})(supportedValue);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.supportedValue = exports.supportedProperty = exports.prefix = void 0;
  var _prefix = prefix;
  var _prefix2 = _interopRequireDefault2(_prefix);
  var _supportedProperty = supportedProperty;
  var _supportedProperty2 = _interopRequireDefault2(_supportedProperty);
  var _supportedValue = supportedValue;
  var _supportedValue2 = _interopRequireDefault2(_supportedValue);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = {
    prefix: _prefix2["default"],
    supportedProperty: _supportedProperty2["default"],
    supportedValue: _supportedValue2["default"]
  };
  /**
   * CSS Vendor prefix detection and property feature testing.
   *
   * @copyright Oleg Slobodskoi 2015
   * @website https://github.com/jsstyles/css-vendor
   * @license MIT
   */
  exports.prefix = _prefix2["default"];
  exports.supportedProperty = _supportedProperty2["default"];
  exports.supportedValue = _supportedValue2["default"];
})(lib$c);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = jssVendorPrefixer;
  var _cssVendor = lib$c;
  var vendor = _interopRequireWildcard(_cssVendor);
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key2 in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key2)) newObj[key2] = obj[key2];
        }
      }
      newObj["default"] = obj;
      return newObj;
    }
  }
  function jssVendorPrefixer() {
    function onProcessRule(rule) {
      if (rule.type === "keyframes") {
        rule.key = "@" + vendor.prefix.css + rule.key.substr(1);
      }
    }
    function onProcessStyle(style2, rule) {
      if (rule.type !== "style") return style2;
      for (var prop in style2) {
        var value = style2[prop];
        var changeProp = false;
        var supportedProp = vendor.supportedProperty(prop);
        if (supportedProp && supportedProp !== prop) changeProp = true;
        var changeValue = false;
        var supportedValue2 = vendor.supportedValue(supportedProp, value);
        if (supportedValue2 && supportedValue2 !== value) changeValue = true;
        if (changeProp || changeValue) {
          if (changeProp) delete style2[prop];
          style2[supportedProp || prop] = supportedValue2 || value;
        }
      }
      return style2;
    }
    function onChangeValue(value, prop) {
      return vendor.supportedValue(prop, value);
    }
    return { onProcessRule, onProcessStyle, onChangeValue };
  }
})(lib$d);
var lib$b = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = jssPropsSort;
  function jssPropsSort() {
    function sort(prop0, prop1) {
      return prop0.length - prop1.length;
    }
    function onProcessStyle(style2, rule) {
      if (rule.type !== "style") return style2;
      var newStyle = {};
      var props2 = Object.keys(style2).sort(sort);
      for (var prop in props2) {
        newStyle[props2[prop]] = style2[props2[prop]];
      }
      return newStyle;
    }
    return { onProcessStyle };
  }
})(lib$b);
Object.defineProperty(lib$m, "__esModule", {
  value: true
});
var _jssTemplate = lib$l;
var _jssTemplate2 = _interopRequireDefault$c(_jssTemplate);
var _jssGlobal = lib$k;
var _jssGlobal2 = _interopRequireDefault$c(_jssGlobal);
var _jssExtend = lib$j;
var _jssExtend2 = _interopRequireDefault$c(_jssExtend);
var _jssNested = lib$i;
var _jssNested2 = _interopRequireDefault$c(_jssNested);
var _jssCompose = lib$h;
var _jssCompose2 = _interopRequireDefault$c(_jssCompose);
var _jssCamelCase = lib$g;
var _jssCamelCase2 = _interopRequireDefault$c(_jssCamelCase);
var _jssDefaultUnit = lib$f;
var _jssDefaultUnit2 = _interopRequireDefault$c(_jssDefaultUnit);
var _jssExpand = lib$e;
var _jssExpand2 = _interopRequireDefault$c(_jssExpand);
var _jssVendorPrefixer = lib$d;
var _jssVendorPrefixer2 = _interopRequireDefault$c(_jssVendorPrefixer);
var _jssPropsSort = lib$b;
var _jssPropsSort2 = _interopRequireDefault$c(_jssPropsSort);
function _interopRequireDefault$c(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
lib$m.default = function() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return {
    plugins: [(0, _jssTemplate2.default)(options.template), (0, _jssGlobal2.default)(options.global), (0, _jssExtend2.default)(options.extend), (0, _jssNested2.default)(options.nested), (0, _jssCompose2.default)(options.compose), (0, _jssCamelCase2.default)(options.camelCase), (0, _jssDefaultUnit2.default)(options.defaultUnit), (0, _jssExpand2.default)(options.expand), (0, _jssVendorPrefixer2.default)(options.vendorPrefixer), (0, _jssPropsSort2.default)(options.propsSort)]
  };
};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createGenerateClassNameDefault = exports.SheetsManager = exports.getDynamicStyles = exports.SheetsRegistry = void 0;
  var _jss = lib$n;
  Object.defineProperty(exports, "SheetsRegistry", {
    enumerable: true,
    get: function get2() {
      return _jss.SheetsRegistry;
    }
  });
  Object.defineProperty(exports, "getDynamicStyles", {
    enumerable: true,
    get: function get2() {
      return _jss.getDynamicStyles;
    }
  });
  Object.defineProperty(exports, "SheetsManager", {
    enumerable: true,
    get: function get2() {
      return _jss.SheetsManager;
    }
  });
  Object.defineProperty(exports, "createGenerateClassNameDefault", {
    enumerable: true,
    get: function get2() {
      return _jss.createGenerateClassName;
    }
  });
  var _jssPresetDefault = lib$m;
  var _jssPresetDefault2 = _interopRequireDefault2(_jssPresetDefault);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _jss.create)((0, _jssPresetDefault2["default"])());
})(jss);
var ns = {};
Object.defineProperty(ns, "__esModule", {
  value: true
});
ns.jss = "64a55d578f856d258dc345b094a2a2b3";
ns.sheetsRegistry = "d4bd0baacbc52bbd48bbb9eb24344ecd";
ns.managers = "b768b78919504fba9de2c03545c5cd3a";
ns.sheetOptions = "6fc570d6bd61383819d0f9e7407c452d";
var contextTypes = {};
var propTypes = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _propTypes = propTypesExports;
  exports["default"] = {
    jss: (0, _propTypes.shape)({
      options: (0, _propTypes.shape)({
        createGenerateClassName: _propTypes.func.isRequired
      }).isRequired,
      createStyleSheet: _propTypes.func.isRequired,
      removeStyleSheet: _propTypes.func.isRequired
    }),
    registry: (0, _propTypes.shape)({
      add: _propTypes.func.isRequired,
      toString: _propTypes.func.isRequired
    })
  };
})(propTypes);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _ns$jss$ns$sheetOptio;
  var _propTypes = propTypesExports;
  var _ns = ns;
  var ns$1 = _interopRequireWildcard(_ns);
  var _propTypes2 = propTypes;
  var _propTypes3 = _interopRequireDefault2(_propTypes2);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key2 in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key2)) newObj[key2] = obj[key2];
        }
      }
      newObj["default"] = obj;
      return newObj;
    }
  }
  function _defineProperty2(obj, key2, value) {
    if (key2 in obj) {
      Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key2] = value;
    }
    return obj;
  }
  exports["default"] = (_ns$jss$ns$sheetOptio = {}, _defineProperty2(_ns$jss$ns$sheetOptio, ns$1.jss, _propTypes3["default"].jss), _defineProperty2(_ns$jss$ns$sheetOptio, ns$1.sheetOptions, _propTypes.object), _defineProperty2(_ns$jss$ns$sheetOptio, ns$1.sheetsRegistry, _propTypes3["default"].registry), _defineProperty2(_ns$jss$ns$sheetOptio, ns$1.managers, _propTypes.object), _ns$jss$ns$sheetOptio);
})(contextTypes);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _react2 = React__default;
  var _propTypes = propTypesExports;
  var _jss = jss;
  var _ns = ns;
  var ns$1 = _interopRequireWildcard(_ns);
  var _contextTypes = contextTypes;
  var _contextTypes2 = _interopRequireDefault2(_contextTypes);
  var _propTypes2 = propTypes;
  var _propTypes3 = _interopRequireDefault2(_propTypes2);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key2 in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key2)) newObj[key2] = obj[key2];
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  function _defineProperty2(obj, key2, value) {
    if (key2 in obj) {
      Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key2] = value;
    }
    return obj;
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn4(self2, call2) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
  }
  function _inherits4(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var JssProvider2 = function(_Component) {
    _inherits4(JssProvider3, _Component);
    function JssProvider3() {
      _classCallCheck4(this, JssProvider3);
      return _possibleConstructorReturn4(this, (JssProvider3.__proto__ || Object.getPrototypeOf(JssProvider3)).apply(this, arguments));
    }
    _createClass2(JssProvider3, [{
      key: "getChildContext",
      // JssProvider can be nested. We allow to overwrite any context prop at any level.
      // 1. Check if there is a value passed over props.
      // 2. If value was passed, we set it on the child context.
      // 3. If value was not passed, we proxy parent context (default context behaviour).
      value: function getChildContext() {
        var _props2 = this.props, registry = _props2.registry, classNamePrefix = _props2.classNamePrefix, localJss = _props2.jss, generateClassName2 = _props2.generateClassName, disableStylesGeneration = _props2.disableStylesGeneration;
        var sheetOptions = this.context[ns$1.sheetOptions] || {};
        var context = _defineProperty2({}, ns$1.sheetOptions, sheetOptions);
        if (registry) {
          context[ns$1.sheetsRegistry] = registry;
          if (registry !== this.registry) {
            this.managers = {};
            this.registry = registry;
          }
        }
        context[ns$1.managers] = this.managers;
        if (generateClassName2) {
          sheetOptions.generateClassName = generateClassName2;
        } else if (!sheetOptions.generateClassName) {
          if (!this.generateClassName) {
            var createGenerateClassName2 = _jss.createGenerateClassNameDefault;
            if (localJss && localJss.options.createGenerateClassName) {
              createGenerateClassName2 = localJss.options.createGenerateClassName;
            }
            this.generateClassName = createGenerateClassName2();
          }
          sheetOptions.generateClassName = this.generateClassName;
        }
        if (classNamePrefix) sheetOptions.classNamePrefix = classNamePrefix;
        if (localJss) context[ns$1.jss] = localJss;
        if (disableStylesGeneration !== void 0) {
          sheetOptions.disableStylesGeneration = disableStylesGeneration;
        }
        return context;
      }
    }, {
      key: "render",
      value: function render() {
        return _react2.Children.only(this.props.children);
      }
    }]);
    return JssProvider3;
  }(_react2.Component);
  JssProvider2.propTypes = _extends2({}, _propTypes3["default"], {
    generateClassName: _propTypes.func,
    classNamePrefix: _propTypes.string,
    disableStylesGeneration: _propTypes.bool,
    children: _propTypes.node.isRequired
  });
  JssProvider2.childContextTypes = _contextTypes2["default"];
  JssProvider2.contextTypes = _contextTypes2["default"];
  exports["default"] = JssProvider2;
})(JssProvider$1);
const JssProvider = /* @__PURE__ */ getDefaultExportFromCjs$1(JssProvider$1);
var injectSheet$1 = {};
var REACT_STATICS$1 = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS$1 = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var defineProperty$9 = Object.defineProperty;
var getOwnPropertyNames$1 = Object.getOwnPropertyNames;
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var getPrototypeOf$3 = Object.getPrototypeOf;
var objectPrototype$1 = getPrototypeOf$3 && getPrototypeOf$3(Object);
function hoistNonReactStatics$1(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== "string") {
    if (objectPrototype$1) {
      var inheritedComponent = getPrototypeOf$3(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype$1) {
        hoistNonReactStatics$1(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys4 = getOwnPropertyNames$1(sourceComponent);
    if (getOwnPropertySymbols$1) {
      keys4 = keys4.concat(getOwnPropertySymbols$1(sourceComponent));
    }
    for (var i3 = 0; i3 < keys4.length; ++i3) {
      var key2 = keys4[i3];
      if (!REACT_STATICS$1[key2] && !KNOWN_STATICS$1[key2] && (!blacklist || !blacklist[key2])) {
        var descriptor2 = getOwnPropertyDescriptor$1(sourceComponent, key2);
        try {
          defineProperty$9(targetComponent, key2, descriptor2);
        } catch (e5) {
        }
      }
    }
    return targetComponent;
  }
  return targetComponent;
}
var hoistNonReactStatics_cjs$1 = hoistNonReactStatics$1;
var createHoc = {};
var compose$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  exports["default"] = function(staticClasses, dynamicClasses) {
    var combinedClasses = _extends2({}, staticClasses);
    for (var name2 in dynamicClasses) {
      combinedClasses[name2] = staticClasses[name2] ? staticClasses[name2] + " " + dynamicClasses[name2] : dynamicClasses[name2];
    }
    return combinedClasses;
  };
})(compose$1);
var getDisplayName$2 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = function(Component2) {
    return Component2.displayName || Component2.name || "Component";
  };
})(getDisplayName$2);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties4(target, props2) {
      for (var i3 = 0; i3 < props2.length; i3++) {
        var descriptor2 = props2[i3];
        descriptor2.enumerable = descriptor2.enumerable || false;
        descriptor2.configurable = true;
        if ("value" in descriptor2) descriptor2.writable = true;
        Object.defineProperty(target, descriptor2.key, descriptor2);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties4(Constructor.prototype, protoProps);
      if (staticProps) defineProperties4(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _extends2 = Object.assign || function(target) {
    for (var i3 = 1; i3 < arguments.length; i3++) {
      var source = arguments[i3];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _react2 = React__default;
  var _react22 = _interopRequireDefault2(_react2);
  var _propTypes = propTypesExports;
  var _propTypes2 = _interopRequireDefault2(_propTypes);
  var _theming = require$$0$6;
  var _theming2 = _interopRequireDefault2(_theming);
  var _jss = jss;
  var _jss2 = _interopRequireDefault2(_jss);
  var _compose = compose$1;
  var _compose2 = _interopRequireDefault2(_compose);
  var _getDisplayName3 = getDisplayName$2;
  var _getDisplayName22 = _interopRequireDefault2(_getDisplayName3);
  var _ns = ns;
  var ns$1 = _interopRequireWildcard(_ns);
  var _contextTypes = contextTypes;
  var _contextTypes2 = _interopRequireDefault2(_contextTypes);
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key2 in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key2)) newObj[key2] = obj[key2];
        }
      }
      newObj["default"] = obj;
      return newObj;
    }
  }
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn4(self2, call2) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
  }
  function _inherits4(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  function _objectWithoutProperties2(obj, keys4) {
    var target = {};
    for (var i3 in obj) {
      if (keys4.indexOf(i3) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i3)) continue;
      target[i3] = obj[i3];
    }
    return target;
  }
  var env = process$1$1.env.NODE_ENV;
  var dynamicStylesNs = Math.random();
  var getStyles = function getStyles2(stylesOrCreator, theme2) {
    if (typeof stylesOrCreator !== "function") {
      return stylesOrCreator;
    }
    return stylesOrCreator(theme2);
  };
  var toMap = function toMap2(arr) {
    return arr.reduce(function(map2, prop) {
      map2[prop] = true;
      return map2;
    }, {});
  };
  var defaultInjectProps = {
    sheet: false,
    classes: true,
    theme: true
  };
  var managersCounter = 0;
  exports["default"] = function(stylesOrCreator, InnerComponent) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var isThemingEnabled = typeof stylesOrCreator === "function";
    var _options$theming = options.theming, theming = _options$theming === void 0 ? _theming2["default"] : _options$theming, inject = options.inject, optionsJss = options.jss, sheetOptions = _objectWithoutProperties2(options, ["theming", "inject", "jss"]);
    var injectMap = inject ? toMap(inject) : defaultInjectProps;
    var themeListener2 = theming.themeListener;
    var displayName = (0, _getDisplayName22["default"])(InnerComponent);
    var defaultClassNamePrefix = env === "production" ? void 0 : displayName + "-";
    var noTheme = {};
    var managerId = managersCounter++;
    var manager = new _jss.SheetsManager();
    var defaultProps2 = _extends2({}, InnerComponent.defaultProps);
    delete defaultProps2.classes;
    var Jss2 = function(_Component) {
      _inherits4(Jss3, _Component);
      function Jss3(props2, context) {
        _classCallCheck4(this, Jss3);
        var _this = _possibleConstructorReturn4(this, (Jss3.__proto__ || Object.getPrototypeOf(Jss3)).call(this, props2, context));
        _initialiseProps.call(_this);
        var theme2 = isThemingEnabled ? themeListener2.initial(context) : noTheme;
        _this.state = _this.createState({ theme: theme2 }, props2);
        return _this;
      }
      _createClass2(Jss3, [{
        key: "componentWillMount",
        value: function componentWillMount() {
          this.manage(this.state);
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if (isThemingEnabled) {
            this.unsubscribeId = themeListener2.subscribe(this.context, this.setTheme);
          }
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps, nextContext) {
          this.context = nextContext;
          var dynamicSheet = this.state.dynamicSheet;
          if (dynamicSheet) dynamicSheet.update(nextProps);
        }
      }, {
        key: "componentWillUpdate",
        value: function componentWillUpdate(nextProps, nextState) {
          if (isThemingEnabled && this.state.theme !== nextState.theme) {
            var newState = this.createState(nextState, nextProps);
            this.manage(newState);
            this.manager.unmanage(this.state.theme);
            this.setState(newState);
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
          if (prevState.dynamicSheet !== this.state.dynamicSheet) {
            this.jss.removeStyleSheet(prevState.dynamicSheet);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.unsubscribeId) {
            themeListener2.unsubscribe(this.context, this.unsubscribeId);
          }
          this.manager.unmanage(this.state.theme);
          if (this.state.dynamicSheet) {
            this.state.dynamicSheet.detach();
          }
        }
      }, {
        key: "createState",
        value: function createState(_ref, _ref2) {
          var theme2 = _ref.theme, dynamicSheet = _ref.dynamicSheet;
          var userClasses = _ref2.classes;
          var contextSheetOptions = this.context[ns$1.sheetOptions];
          if (contextSheetOptions && contextSheetOptions.disableStylesGeneration) {
            return { theme: theme2, dynamicSheet, classes: {} };
          }
          var classNamePrefix = defaultClassNamePrefix;
          var staticSheet = this.manager.get(theme2);
          if (contextSheetOptions && contextSheetOptions.classNamePrefix) {
            classNamePrefix = contextSheetOptions.classNamePrefix + classNamePrefix;
          }
          if (!staticSheet) {
            var styles2 = getStyles(stylesOrCreator, theme2);
            staticSheet = this.jss.createStyleSheet(styles2, _extends2({}, sheetOptions, contextSheetOptions, {
              meta: displayName + ", " + (isThemingEnabled ? "Themed" : "Unthemed") + ", Static",
              classNamePrefix
            }));
            this.manager.add(theme2, staticSheet);
            staticSheet[dynamicStylesNs] = (0, _jss.getDynamicStyles)(styles2);
          }
          var dynamicStyles = staticSheet[dynamicStylesNs];
          if (dynamicStyles) {
            dynamicSheet = this.jss.createStyleSheet(dynamicStyles, _extends2({}, sheetOptions, contextSheetOptions, {
              meta: displayName + ", " + (isThemingEnabled ? "Themed" : "Unthemed") + ", Dynamic",
              classNamePrefix,
              link: true
            }));
          }
          var defaultClasses = InnerComponent.defaultProps ? InnerComponent.defaultProps.classes : {};
          var jssClasses = dynamicSheet ? (0, _compose2["default"])(staticSheet.classes, dynamicSheet.classes) : staticSheet.classes;
          var classes = _extends2({}, defaultClasses, jssClasses, userClasses);
          return { theme: theme2, dynamicSheet, classes };
        }
      }, {
        key: "manage",
        value: function manage(_ref3) {
          var theme2 = _ref3.theme, dynamicSheet = _ref3.dynamicSheet;
          var contextSheetOptions = this.context[ns$1.sheetOptions];
          if (contextSheetOptions && contextSheetOptions.disableStylesGeneration) {
            return;
          }
          var registry = this.context[ns$1.sheetsRegistry];
          var staticSheet = this.manager.manage(theme2);
          if (registry) registry.add(staticSheet);
          if (dynamicSheet) {
            dynamicSheet.update(this.props).attach();
            if (registry) registry.add(dynamicSheet);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _state = this.state, theme2 = _state.theme, dynamicSheet = _state.dynamicSheet, classes = _state.classes;
          var _props2 = this.props, innerRef = _props2.innerRef, props2 = _objectWithoutProperties2(_props2, ["innerRef"]);
          var sheet = dynamicSheet || this.manager.get(theme2);
          if (injectMap.sheet && !props2.sheet) props2.sheet = sheet;
          if (isThemingEnabled && injectMap.theme && !props2.theme) props2.theme = theme2;
          if (injectMap.classes) props2.classes = classes;
          return _react22["default"].createElement(InnerComponent, _extends2({ ref: innerRef }, props2));
        }
      }, {
        key: "jss",
        get: function get2() {
          return this.context[ns$1.jss] || optionsJss || _jss2["default"];
        }
      }, {
        key: "manager",
        get: function get2() {
          var managers = this.context[ns$1.managers];
          if (managers) {
            if (!managers[managerId]) {
              managers[managerId] = new _jss.SheetsManager();
            }
            return managers[managerId];
          }
          return manager;
        }
      }]);
      return Jss3;
    }(_react2.Component);
    Jss2.displayName = "Jss(" + displayName + ")";
    Jss2.InnerComponent = InnerComponent;
    Jss2.contextTypes = _extends2({}, _contextTypes2["default"], isThemingEnabled && themeListener2.contextTypes);
    Jss2.propTypes = {
      innerRef: _propTypes2["default"].func
    };
    Jss2.defaultProps = defaultProps2;
    var _initialiseProps = function _initialiseProps2() {
      var _this2 = this;
      this.setTheme = function(theme2) {
        return _this2.setState({ theme: theme2 });
      };
    };
    return Jss2;
  };
})(createHoc);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = injectSheet2;
  var _hoistNonReactStatics = hoistNonReactStatics_cjs$1;
  var _hoistNonReactStatics2 = _interopRequireDefault2(_hoistNonReactStatics);
  var _createHoc = createHoc;
  var _createHoc2 = _interopRequireDefault2(_createHoc);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var indexCounter = -1e5;
  var NoRenderer = function NoRenderer2(_ref) {
    var children = _ref.children;
    return children || null;
  };
  function injectSheet2(stylesOrSheet) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (options.index === void 0) {
      options.index = indexCounter++;
    }
    return function() {
      var InnerComponent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NoRenderer;
      var Jss2 = (0, _createHoc2["default"])(stylesOrSheet, InnerComponent, options);
      return (0, _hoistNonReactStatics2["default"])(Jss2, InnerComponent, { inner: true });
    };
  }
})(injectSheet$1);
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _theming = require$$0$6;
  Object.defineProperty(exports, "ThemeProvider", {
    enumerable: true,
    get: function get2() {
      return _theming.ThemeProvider;
    }
  });
  Object.defineProperty(exports, "withTheme", {
    enumerable: true,
    get: function get2() {
      return _theming.withTheme;
    }
  });
  Object.defineProperty(exports, "createTheming", {
    enumerable: true,
    get: function get2() {
      return _theming.createTheming;
    }
  });
  var _JssProvider = JssProvider$1;
  Object.defineProperty(exports, "JssProvider", {
    enumerable: true,
    get: function get2() {
      return _interopRequireDefault2(_JssProvider)["default"];
    }
  });
  var _jss = jss;
  Object.defineProperty(exports, "jss", {
    enumerable: true,
    get: function get2() {
      return _interopRequireDefault2(_jss)["default"];
    }
  });
  Object.defineProperty(exports, "SheetsRegistry", {
    enumerable: true,
    get: function get2() {
      return _jss.SheetsRegistry;
    }
  });
  Object.defineProperty(exports, "createGenerateClassName", {
    enumerable: true,
    get: function get2() {
      return _jss.createGenerateClassNameDefault;
    }
  });
  var _injectSheet = injectSheet$1;
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function get2() {
      return _interopRequireDefault2(_injectSheet)["default"];
    }
  });
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
})(lib$o);
const injectSheet = /* @__PURE__ */ getDefaultExportFromCjs$1(lib$o);
var FUNC_ERROR_TEXT$3 = "Expected a function";
var MAX_SAFE_INTEGER$3 = 9007199254740991;
var argsTag$4 = "[object Arguments]", funcTag$3 = "[object Function]", genTag$2 = "[object GeneratorFunction]";
var freeGlobal$3 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf$2 = typeof self == "object" && self && self.Object === Object && self;
var root$b = freeGlobal$3 || freeSelf$2 || Function("return this")();
function apply$4(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
function arrayPush$4(array, values) {
  var index2 = -1, length = values.length, offset2 = array.length;
  while (++index2 < length) {
    array[offset2 + index2] = values[index2];
  }
  return array;
}
var objectProto$k = Object.prototype;
var hasOwnProperty$j = objectProto$k.hasOwnProperty;
var objectToString$3 = objectProto$k.toString;
var Symbol$a = root$b.Symbol, propertyIsEnumerable$2 = objectProto$k.propertyIsEnumerable, spreadableSymbol$1 = Symbol$a ? Symbol$a.isConcatSpreadable : void 0;
var nativeMax$2 = Math.max;
function baseFlatten$5(array, depth, predicate, isStrict, result2) {
  var index2 = -1, length = array.length;
  predicate || (predicate = isFlattenable$2);
  result2 || (result2 = []);
  while (++index2 < length) {
    var value = array[index2];
    if (predicate(value)) {
      {
        arrayPush$4(result2, value);
      }
    } else {
      result2[result2.length] = value;
    }
  }
  return result2;
}
function baseRest$9(func, start2) {
  start2 = nativeMax$2(start2 === void 0 ? func.length - 1 : start2, 0);
  return function() {
    var args = arguments, index2 = -1, length = nativeMax$2(args.length - start2, 0), array = Array(length);
    while (++index2 < length) {
      array[index2] = args[start2 + index2];
    }
    index2 = -1;
    var otherArgs = Array(start2 + 1);
    while (++index2 < start2) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start2] = array;
    return apply$4(func, this, otherArgs);
  };
}
function createFlow(fromRight) {
  return baseRest$9(function(funcs) {
    funcs = baseFlatten$5(funcs);
    var length = funcs.length, index2 = length;
    {
      funcs.reverse();
    }
    while (index2--) {
      if (typeof funcs[index2] != "function") {
        throw new TypeError(FUNC_ERROR_TEXT$3);
      }
    }
    return function() {
      var index3 = 0, result2 = length ? funcs[index3].apply(this, arguments) : arguments[0];
      while (++index3 < length) {
        result2 = funcs[index3].call(this, result2);
      }
      return result2;
    };
  });
}
function isFlattenable$2(value) {
  return isArray$q(value) || isArguments$9(value) || !!(spreadableSymbol$1 && value && value[spreadableSymbol$1]);
}
function isArguments$9(value) {
  return isArrayLikeObject$5(value) && hasOwnProperty$j.call(value, "callee") && (!propertyIsEnumerable$2.call(value, "callee") || objectToString$3.call(value) == argsTag$4);
}
var isArray$q = Array.isArray;
function isArrayLike$8(value) {
  return value != null && isLength$4(value.length) && !isFunction$b(value);
}
function isArrayLikeObject$5(value) {
  return isObjectLike$e(value) && isArrayLike$8(value);
}
function isFunction$b(value) {
  var tag2 = isObject$o(value) ? objectToString$3.call(value) : "";
  return tag2 == funcTag$3 || tag2 == genTag$2;
}
function isLength$4(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$3;
}
function isObject$o(value) {
  var type2 = typeof value;
  return !!value && (type2 == "object" || type2 == "function");
}
function isObjectLike$e(value) {
  return !!value && typeof value == "object";
}
var flowRight = createFlow();
var lodash_flowright = flowRight;
const compose = /* @__PURE__ */ getDefaultExportFromCjs$1(lodash_flowright);
const withDeprecated = (config) => (WrappedComponent) => (props2) => {
  const message2 = `!!! [DEPRECATION] - 'atomic ${config.obsolete}' is deprecated. Please use '${config.new}' instead !!!`;
  console.warn(message2);
  return /* @__PURE__ */ jsx$1(WrappedComponent, { ...props2 });
};
const styles$3d = {
  root: {
    appearance: "none",
    textAlign: "left",
    backgroundColor: "inherit",
    border: "none",
    cursor: "pointer",
    outline: "none",
    "&[disabled]": {
      cursor: "default",
      opacity: "0.5"
    }
  }
};
const Button$2 = ({
  children,
  onClick,
  classes,
  disabled,
  className,
  dataCy,
  ...otherprops
}) => /* @__PURE__ */ jsx$1(
  "button",
  {
    "data-cy": dataCy || "atomic-button",
    onClick,
    className: classNames(classes.root, className),
    disabled,
    ...otherprops,
    children
  }
);
Button$2.propTypes = {
  children: PropTypes$1.node.isRequired,
  onClick: PropTypes$1.func.isRequired,
  classes: PropTypes$1.object.isRequired,
  disabled: PropTypes$1.bool,
  className: PropTypes$1.string,
  dataCy: PropTypes$1.string
};
Button$2.defaultProps = {
  disabled: false,
  className: null,
  dataCy: ""
};
const COMPONENT_CONFIG = {
  obsolete: "<Button />",
  new: "<Pushbutton /> in surface"
};
const Button$3 = compose(
  withDeprecated(COMPONENT_CONFIG),
  injectSheet(styles$3d)
)(Button$2);
const styles$3c = {
  root: {
    width: 16,
    height: 16,
    boxShadow: "0 0 0 1px currentColor",
    "&::before": {
      content: '""',
      display: "block",
      width: "calc(100% - 4px)",
      height: "calc(100% - 4px)",
      position: "relative",
      top: 2,
      left: 2,
      backgroundColor: "transparent"
    }
  },
  checked: {
    "&::before": {
      backgroundColor: "currentColor"
    }
  },
  checkbox: {
    borderRadius: 2,
    "&::before": {
      borderRadius: 2
    }
  },
  radio: {
    borderRadius: "50%",
    "&::before": {
      borderRadius: "50%"
    }
  }
};
const Checkbox = ({ classes, className, checked, onClick, boxStyle }) => /* @__PURE__ */ jsx$1(
  "div",
  {
    "data-cy": "atomic-checkbox",
    className: classNames(classes.root, className, {
      [classes.checked]: checked,
      [classes.checkbox]: boxStyle === "checkbox",
      [classes.radio]: boxStyle === "radio"
    }),
    onClick
  }
);
Checkbox.propTypes = {
  classes: PropTypes$1.object.isRequired,
  className: PropTypes$1.string,
  checked: PropTypes$1.bool,
  onClick: PropTypes$1.func.isRequired,
  boxStyle: PropTypes$1.oneOf(["checkbox", "radio"])
};
Checkbox.defaultProps = {
  className: null,
  checked: false,
  boxStyle: "checkbox"
};
const index$n = injectSheet(styles$3c)(Checkbox);
const theme = {
  // Colors
  bgColorBrandPrimary: "#E5E5E5",
  colorBrandPrimary: "#2e128b",
  indigo1: "#2E058D",
  indigo2: "#4B35D2",
  indigo3: "#5246F7",
  indigo4: "#586FEF",
  indigoPastel1: "#867EF9",
  indigoPastel2: "#E1DEFF",
  indigoPastel3: "#EEEDFD",
  teal1: "#30CECA",
  teal2: "#6BEDD8",
  grey1: "#34323A",
  grey2: "#736F7F",
  grey3: "#8F8B9B",
  grey4: "#B4B1BD",
  grey5: "#D0CED5",
  grey6: "#E5E3EB",
  grey7: "#ECEBF2",
  grey8: "#F2F1F5",
  grey9: "#FBFBFB",
  greyTable: "#F8F8F8",
  blue50: "#F0F4FF",
  blue100: "#e5ecfd",
  blue200: "#b2ddff",
  blue300: "#7dc9ff",
  blue400: "#40aaff",
  blue500: "#1483ff",
  blue600: "#0643D0",
  blue700: "#0047ff",
  blue800: "#0643D0",
  blue900: "#0037c7",
  blue950: "#0a2261",
  warningRed: "#E8544D",
  cautionOrange: "#F5A125",
  cautionOrangeDark: "#E59113",
  validGreen: "#54C063",
  validGreenDark: "#41AF50",
  white1: "#FFFFFF",
  // Shadows
  indigoShadow1: "0px 3px 20px rgba(75, 53, 210, 0.1)",
  indigoShadow2: "0px 3px 20px rgba(75, 53, 210, 0.2)",
  indigoShadowLight: "0px 3px 20px rgba(75, 53, 210, 0.05)",
  indigoShadowHover: "0px 10px 25px rgba(75, 53, 210, 0.25)",
  redShadow1: "0px 3px 20px rgba(232, 84, 77, 0.2)",
  // Disabled Colors Mapping
  disabled: {
    indigo3: "#9790FA",
    grey3: "#BCB9C3",
    warningRed: "#F19894"
  },
  // fixed sizes used across clients
  headerHeight: "70px"
};
const styles$3b = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100vw",
    height: "100vh",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 4
  },
  overlay: {
    width: "100vw",
    height: "100vh",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 4 + 1,
    backgroundColor: theme.grey3,
    opacity: 0.2
  },
  prompt: {
    zIndex: 4 + 2,
    backgroundColor: "white"
  },
  body: {
    padding: "20px"
  },
  title: {
    padding: "20px",
    borderBottom: "solid 1px black"
  }
};
class Dialog extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { open, onOverlayClick, classes, children } = this.props;
      if (!open) return null;
      return /* @__PURE__ */ jsxs("div", { className: classes.container, "data-cy": "atomic-dialog", children: [
        /* @__PURE__ */ jsx$1("div", { className: classes.overlay, onClick: onOverlayClick }),
        /* @__PURE__ */ jsx$1("div", { className: classes.prompt, children })
      ] });
    });
  }
}
__publicField(Dialog, "propTypes", {
  open: PropTypes$1.bool.isRequired,
  children: PropTypes$1.node.isRequired,
  onOverlayClick: PropTypes$1.func.isRequired,
  classes: PropTypes$1.object.isRequired
});
const index$m = injectSheet(styles$3b)(Dialog);
const escapeKeyCode = 27;
const enterKeyCode = 13;
const styles$3a = {};
class EditableText extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      value: this.props.value
    });
    __publicField(this, "handleClickOutside", (event) => {
      const { editMode } = this.props;
      if (editMode && !this.element.contains(event.target)) {
        this.exit();
      }
    });
    __publicField(this, "exit", () => {
      const { toggleEditMode, value } = this.props;
      this.setState({ value });
      toggleEditMode();
    });
    __publicField(this, "onChange", (event) => {
      this.setState({ value: event.target.value });
    });
    __publicField(this, "handleKeyUp", (event) => {
      if (event.keyCode === escapeKeyCode) {
        this.exit();
      } else if (event.keyCode === enterKeyCode && event.target.value !== "") {
        this.props.onSubmit(event.target.value);
      }
    });
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value && this.props.value !== nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }
  selectAll(e5) {
    e5.target.select();
  }
  render() {
    const { editMode, placeholder } = this.props;
    const { value } = this.state;
    if (!editMode) return /* @__PURE__ */ jsx$1("div", { children: value });
    return /* @__PURE__ */ jsx$1(
      "input",
      {
        type: "text",
        placeholder,
        value,
        onChange: this.onChange,
        onKeyUp: this.handleKeyUp,
        ref: (e5) => {
          this.element = e5;
        },
        autoFocus: true,
        onFocus: this.selectAll
      }
    );
  }
}
__publicField(EditableText, "propTypes", {
  onSubmit: PropTypes$1.func.isRequired,
  value: PropTypes$1.string,
  placeholder: PropTypes$1.string,
  editMode: PropTypes$1.bool.isRequired,
  toggleEditMode: PropTypes$1.func.isRequired
});
__publicField(EditableText, "defaultProps", {
  value: "",
  placeholder: "title"
});
const EditableText$1 = injectSheet(styles$3a)(EditableText);
const styles$39 = {
  container: {
    display: "flex",
    borderBottom: `1px solid ${theme.grey6}`,
    paddingBottom: 10,
    marginTop: 10,
    color: theme.grey1
  },
  label: {
    width: 175,
    color: theme.grey4,
    fontSize: 14,
    fontWeight: 400
  },
  value: {
    fontSize: 14,
    color: "inherit"
  },
  action: {
    textAlign: "right",
    width: 150,
    fontSize: 14
  },
  edit: {
    color: theme.indigo3,
    cursor: "pointer"
  }
};
class EditableLabelField extends React__default.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      editMode: false
    });
    __publicField(this, "toggleEditMode", () => {
      this.setState({ editMode: !this.state.editMode });
    });
    __publicField(this, "onSubmit", (value) => {
      this.props.onSubmit(value);
      this.toggleEditMode();
    });
  }
  static getDerivedStateFromProps(props2, state) {
    if (state.value === void 0) return { value: props2.value };
    return null;
  }
  renderToggle() {
    const { editMode } = this.state;
    const { classes, editable } = this.props;
    if (editable)
      return /* @__PURE__ */ jsx$1("button", { onClick: this.toggleEditMode, className: classes.edit, children: editMode ? "Save" : "Edit" });
    return null;
  }
  renderValue() {
    const {
      onSubmit,
      toggleEditMode,
      props: { editable, label },
      state: { value, editMode }
    } = this;
    if (!editable) return value;
    const placeholder = `Add ${label.toLowerCase()}`;
    return /* @__PURE__ */ jsx$1(
      EditableText$1,
      {
        ...{ placeholder, editMode, value, onSubmit, toggleEditMode }
      }
    );
  }
  render() {
    const { classes, label, valueClassName } = this.props;
    return /* @__PURE__ */ jsxs("div", { className: classes.container, children: [
      /* @__PURE__ */ jsx$1("div", { className: classes.label, children: label }),
      /* @__PURE__ */ jsx$1("div", { className: classNames(classes.value, valueClassName), children: this.renderValue() }),
      /* @__PURE__ */ jsx$1("div", { className: classes.action, children: this.renderToggle() })
    ] });
  }
}
__publicField(EditableLabelField, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  label: PropTypes$1.string.isRequired,
  onSubmit: PropTypes$1.func,
  value: PropTypes$1.string,
  editable: PropTypes$1.bool,
  valueClassName: PropTypes$1.string
});
__publicField(EditableLabelField, "defaultProps", {
  onSubmit: () => null,
  value: void 0,
  editable: false,
  valueClassName: null
});
const EditableLabelField$1 = injectSheet(styles$39)(EditableLabelField);
const styles$38 = (theme2) => ({
  root: {
    display: "flex",
    flexDirection: "column"
  },
  title: {
    fontSize: 11,
    textTransform: "uppercase",
    fontWeight: 600,
    letterSpacing: 1,
    color: theme2.grey1,
    marginBottom: 7
  },
  option: {
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    marginBottom: 3
  },
  input: {
    marginRight: 10,
    width: 15,
    height: 15,
    cursor: "pointer"
  },
  inputChecked: {
    color: theme2.indigo3
  }
});
class InputCollection extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "onClick", (value) => () => this.props.onClick(value));
    __publicField(this, "isChecked", (value) => {
      const { values } = this.props;
      if (Array.isArray(values)) {
        return values.indexOf(value) > -1;
      }
      return value === values;
    });
  }
  render() {
    const { title: title2, options, classes, className, Input: Input2 } = this.props;
    return /* @__PURE__ */ jsxs("div", { className: classNames(classes.root, className), children: [
      /* @__PURE__ */ jsx$1("div", { className: classes.title, children: title2 }),
      options.map((opt) => {
        const isChecked = this.isChecked(opt.value);
        return /* @__PURE__ */ jsxs("div", { className: classes.option, children: [
          /* @__PURE__ */ jsx$1(
            Input2,
            {
              className: classNames(classes.input, {
                [classes.inputChecked]: isChecked
              }),
              checked: isChecked,
              onClick: this.onClick(opt.value)
            }
          ),
          /* @__PURE__ */ jsx$1("span", { children: opt.label })
        ] }, opt.value);
      })
    ] });
  }
}
__publicField(InputCollection, "propTypes", {
  title: PropTypes$1.string.isRequired,
  options: PropTypes$1.arrayOf(
    PropTypes$1.shape({
      value: PropTypes$1.any.isRequired,
      label: PropTypes$1.string.isRequired
    })
  ).isRequired,
  classes: PropTypes$1.object.isRequired,
  onClick: PropTypes$1.func.isRequired,
  Input: PropTypes$1.func.isRequired,
  values: PropTypes$1.oneOfType([
    PropTypes$1.arrayOf(PropTypes$1.string),
    PropTypes$1.string
  ]),
  className: PropTypes$1.string
});
__publicField(InputCollection, "defaultProps", {
  className: null,
  values: null
});
const index$l = injectSheet(styles$38)(InputCollection);
const styles$37 = {
  pictureWrapper: {
    position: "relative",
    "&:hover div": {
      visibility: "visible"
    },
    "&:hover img": {
      opacity: 0.8
    }
  },
  picture: {
    width: 100,
    height: 100
  },
  caption: {
    position: "absolute",
    fontSize: 10,
    color: "white",
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: "center",
    visibility: "hidden",
    backgroundColor: "rgba(0, 0, 0, 0.3)"
  }
};
class ClickablePicture extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, onClick, img, editMode } = this.props;
      const imgObj = /* @__PURE__ */ jsx$1("img", { src: img, alt: "", className: classes.picture });
      if (editMode) {
        return imgObj;
      }
      return /* @__PURE__ */ jsxs(
        Button$2,
        {
          classes,
          className: classes.pictureWrapper,
          onClick,
          children: [
            imgObj,
            /* @__PURE__ */ jsx$1("div", { className: classes.caption, children: this.props.changeLabel })
          ]
        }
      );
    });
  }
}
__publicField(ClickablePicture, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  onClick: PropTypes$1.func.isRequired,
  img: PropTypes$1.string.isRequired,
  editMode: PropTypes$1.bool.isRequired,
  changeLabel: PropTypes$1.node
});
__publicField(ClickablePicture, "defaultProps", {
  changeLabel: "change"
});
const index$k = injectSheet(styles$37)(ClickablePicture);
const styles$36 = {
  infoRow: {
    fontSize: 12,
    borderBottom: `1px solid ${theme.grey4}`,
    color: theme.grey2,
    paddingBottom: 2,
    marginBottom: 2,
    minWidth: 140
  }
};
class ProfileInfo extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children } = this.props;
      return /* @__PURE__ */ jsx$1("div", { className: classes.infoRow, children });
    });
  }
}
__publicField(ProfileInfo, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.any
});
__publicField(ProfileInfo, "defaultProps", {
  children: null
});
const index$j = injectSheet(styles$36)(ProfileInfo);
const styles$35 = {
  titleContainer: {
    display: "inline-flex",
    fontSize: "1.3125rem",
    lineHeight: "1.16667rem"
  },
  titleLeft: {
    fontWeight: 100
  },
  titleRight: {
    fontWeight: 700
  }
};
const Title = ({ classes, left, right, type: type2 }) => /* @__PURE__ */ jsxs("div", { className: classes.titleContainer, "data-cy": "atomic-title", children: [
  /* @__PURE__ */ jsx$1("div", { type: type2, className: classes.titleLeft, children: left }),
  /* @__PURE__ */ jsx$1("div", { type: type2, className: classes.titleRight, children: right })
] });
Title.propTypes = {
  classes: PropTypes$1.object.isRequired,
  left: PropTypes$1.string,
  right: PropTypes$1.string,
  type: PropTypes$1.string
};
Title.defaultProps = {
  left: "Indigo",
  right: "Trace",
  type: "title"
};
const index$i = injectSheet(styles$35)(Title);
var INFINITY$5 = 1 / 0;
var symbolTag$4 = "[object Symbol]";
var freeGlobal$2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
var root$a = freeGlobal$2 || freeSelf$1 || Function("return this")();
var objectProto$j = Object.prototype;
var idCounter = 0;
var objectToString$2 = objectProto$j.toString;
var Symbol$9 = root$a.Symbol;
var symbolProto$3 = Symbol$9 ? Symbol$9.prototype : void 0, symbolToString$1 = symbolProto$3 ? symbolProto$3.toString : void 0;
function baseToString$2(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isSymbol$8(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : "";
  }
  var result2 = value + "";
  return result2 == "0" && 1 / value == -INFINITY$5 ? "-0" : result2;
}
function isObjectLike$d(value) {
  return !!value && typeof value == "object";
}
function isSymbol$8(value) {
  return typeof value == "symbol" || isObjectLike$d(value) && objectToString$2.call(value) == symbolTag$4;
}
function toString$9(value) {
  return value == null ? "" : baseToString$2(value);
}
function uniqueId(prefix2) {
  var id2 = ++idCounter;
  return toString$9(prefix2) + id2;
}
var lodash_uniqueid = uniqueId;
const uniqueId$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(lodash_uniqueid);
const styles$34 = {
  root: {
    display: "block",
    width: 28,
    height: "auto",
    fill: theme.indigo1
  },
  bands: {
    "& > circle:nth-child(1)": {
      fill: theme.teal2
    },
    "& > circle:nth-child(2)": {
      fill: theme.teal1
    },
    "& > circle:nth-child(3)": {
      fill: theme.indigo4
    },
    "& > circle:nth-child(4)": {
      fill: theme.indigo3
    },
    "& > circle:nth-child(5)": {
      fill: theme.indigo2
    },
    "& > circle:nth-child(6)": {
      fill: theme.indigo1
    }
  }
};
class TraceLogomark extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "id", uniqueId$1("lm_"));
    __publicField(this, "render", () => {
      const { classes } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 100 84",
          "aria-hidden": "true",
          className: classes.root,
          children: [
            /* @__PURE__ */ jsxs("clipPath", { id: this.id, children: [
              /* @__PURE__ */ jsx$1("rect", { x: "0", y: "0", width: "25.7", height: "46.3", rx: "3.9", ry: "3.9" }),
              /* @__PURE__ */ jsx$1("rect", { x: "37.2", y: "0", width: "25.7", height: "84", rx: "3.9", ry: "3.9" }),
              /* @__PURE__ */ jsx$1("rect", { x: "74.3", y: "0", width: "25.7", height: "65.3", rx: "3.9", ry: "3.9" })
            ] }),
            /* @__PURE__ */ jsxs("g", { clipPath: `url(#${this.id})`, className: classes.bands, children: [
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "245.65" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "228.5" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "211.3" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "194.1" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "176.95" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "159.75" })
            ] })
          ]
        }
      );
    });
  }
}
__publicField(TraceLogomark, "propTypes", {
  classes: PropTypes$1.object.isRequired
});
const index$h = injectSheet(styles$34)(TraceLogomark);
const styles$33 = {
  root: {
    display: "block",
    width: "auto",
    height: 21,
    fill: theme.indigo1
  },
  bands: {
    "& > circle:nth-child(1)": {
      fill: theme.teal2
    },
    "& > circle:nth-child(2)": {
      fill: theme.teal1
    },
    "& > circle:nth-child(3)": {
      fill: theme.indigo4
    },
    "& > circle:nth-child(4)": {
      fill: theme.indigo3
    },
    "& > circle:nth-child(5)": {
      fill: theme.indigo2
    },
    "& > circle:nth-child(6)": {
      fill: theme.indigo1
    }
  }
};
class TraceLogo extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "id", uniqueId$1("lm_"));
    __publicField(this, "render", () => {
      const { classes } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 426 84",
          "aria-hidden": "true",
          className: classes.root,
          children: [
            /* @__PURE__ */ jsxs("clipPath", { id: this.id, children: [
              /* @__PURE__ */ jsx$1("rect", { x: "0", y: "0", width: "25.7", height: "46.3", rx: "3.9", ry: "3.9" }),
              /* @__PURE__ */ jsx$1("rect", { x: "37.2", y: "0", width: "25.7", height: "84", rx: "3.9", ry: "3.9" }),
              /* @__PURE__ */ jsx$1("rect", { x: "74.3", y: "0", width: "25.7", height: "65.3", rx: "3.9", ry: "3.9" })
            ] }),
            /* @__PURE__ */ jsxs("g", { clipPath: `url(#${this.id})`, className: classes.bands, children: [
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "245.65" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "228.5" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "211.3" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "194.1" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "176.95" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "159.75" })
            ] }),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.type,
                d: "M158.633 13.068H134.6V0h61.83v13.068h-24.148v69.764h-13.649V13.068zM196.205 24.5h12.83v10.384c2.216-6.649 8.749-10.966 15.401-10.966 1.635 0 3.264.118 5.016.466v13.183c-2.218-.701-4.082-1.049-6.417-1.049-7.348 0-14 6.183-14 17.848v28.467h-12.83V24.5zM263.638 35c-10.382 0-17.38 8.166-17.38 18.667 0 10.5 6.998 18.665 17.38 18.665 10.384 0 17.386-8.165 17.386-18.665 0-10.501-7.002-18.667-17.386-18.667m-2.33-11.666c8.397 0 15.4 4.316 18.663 8.982v-7.817h12.832v58.333h-12.832v-7.816c-3.263 4.666-10.266 8.983-18.663 8.983-15.985 0-28.118-13.649-28.118-30.332 0-16.684 12.133-30.333 28.118-30.333M332.65 84c-17.501 0-30.8-13.067-30.8-30.332 0-17.268 13.299-30.335 30.8-30.335 12.014 0 22.164 6.417 27.182 16.099l-11.202 6.069c-2.797-5.953-8.515-10.268-15.98-10.268-10.382 0-17.734 8.05-17.734 18.435 0 10.382 7.352 18.43 17.734 18.43 7.465 0 13.183-4.315 15.98-10.266l11.202 6.067C354.814 77.583 344.664 84 332.65 84M379.555 47.133h32.435c-1.401-8.399-8.17-12.949-15.634-12.949-7.468 0-15.048 4.318-16.801 12.949m17.269-23.799c15.283 0 28.115 10.15 28.115 28.933 0 1.285 0 2.332-.118 4.201h-45.849c.583 9.566 8.285 15.865 17.968 15.865 8.165 0 13.649-3.733 16.68-8.867l9.8 6.999C418.17 78.75 409.072 84 396.824 84c-17.736 0-30.45-12.6-30.45-30.332 0-17.15 12.714-30.334 30.45-30.334"
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(TraceLogo, "propTypes", {
  classes: PropTypes$1.object.isRequired
});
const index$g = injectSheet(styles$33)(TraceLogo);
const styles$32 = {
  root: {
    display: "block"
  },
  default: {
    width: 28,
    height: "auto",
    fill: theme.indigo1
  }
};
class IdentityLogomark extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, className } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          strokeLinejoin: "round",
          strokeMiterlimit: "1.41421",
          clipRule: "evenodd",
          viewBox: "0 0 353 306",
          "aria-hidden": "true",
          className: classNames(classes.root, className || classes.default),
          children: /* @__PURE__ */ jsx$1("path", { d: "M291.128 305.998h-46.51l-.176-.418v.42H104.174v-.002H61.872l98.959-232.7h31.338l98.959 232.7zm-63.232-39.583l-5.047-11.947-17.152-39.892-29.358-68.809-29.366 68.809-16.822 39.892-5.047 11.947h102.792zm16.546-226.83H104.174V0h140.268v39.585z" })
        }
      );
    });
  }
}
__publicField(IdentityLogomark, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  className: PropTypes$1.string
});
__publicField(IdentityLogomark, "defaultProps", {
  className: ""
});
const index$f = injectSheet(styles$32)(IdentityLogomark);
const StratumnLogomark = ({ className, height, width }) => /* @__PURE__ */ jsx$1(
  "svg",
  {
    height,
    width,
    className,
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 18",
    xmlSpace: "preserve",
    children: /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx$1(
        "path",
        {
          className: "st0",
          d: "M8.2,4.6H5.8L0,17.9h14L8.2,4.6z M3.9,15.5L7,8.1l3.1,7.3H3.9z"
        }
      ),
      /* @__PURE__ */ jsx$1("rect", { x: "2.8", y: "0.1", className: "st0", width: "8.3", height: "2.5" })
    ] })
  }
);
StratumnLogomark.propTypes = {
  height: PropTypes$1.number,
  width: PropTypes$1.number,
  className: PropTypes$1.string
};
StratumnLogomark.defaultProps = {
  height: 18,
  width: 14,
  className: ""
};
const styles$31 = {
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center"
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "18px",
    color: theme.grey1
  }
};
class ViewTitle extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, className, children, title: title2 } = this.props;
      return /* @__PURE__ */ jsxs("div", { className: classNames(classes.root, className), children: [
        /* @__PURE__ */ jsx$1("div", { className: classes.title, children: title2 }),
        children
      ] });
    });
  }
}
__publicField(ViewTitle, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  title: PropTypes$1.string.isRequired,
  children: PropTypes$1.node,
  className: PropTypes$1.string
});
__publicField(ViewTitle, "defaultProps", {
  className: null,
  children: null
});
const index$e = injectSheet(styles$31)(ViewTitle);
const styles$30 = {
  container: {
    marginTop: 10,
    display: "flex"
  },
  url: {
    display: "block",
    width: "100%",
    fontSize: 12,
    borderBottom: `1px solid ${theme.grey4}`,
    paddingBottom: 7,
    "&:focus": {
      outline: "none",
      borderBottomColor: theme.indigo3
    }
  },
  saveBtn: {
    marginLeft: 10
  }
};
class UrlSelector extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "onKeyUp", (event) => {
      const { onExit, onValidate } = this.props;
      if (event.keyCode === escapeKeyCode) {
        onExit();
      } else if (event.keyCode === enterKeyCode && event.target.value !== "") {
        onValidate(event);
      }
    });
    __publicField(this, "selectAll", (event) => {
      event.target.select();
    });
    __publicField(this, "render", () => {
      const { classes, onChange, onValidate, url: url2, urlPlaceholder, saveLabel } = this.props;
      return /* @__PURE__ */ jsxs("div", { className: classes.container, children: [
        /* @__PURE__ */ jsx$1(
          "input",
          {
            className: classes.url,
            type: "text",
            placeholder: urlPlaceholder,
            value: url2,
            onChange,
            onKeyUp: this.onKeyUp,
            onFocus: this.selectAll,
            autoFocus: true
          }
        ),
        /* @__PURE__ */ jsx$1(
          Button$3,
          {
            classes,
            className: classes.saveBtn,
            onClick: onValidate,
            disabled: !url2,
            children: saveLabel
          }
        )
      ] });
    });
  }
}
__publicField(UrlSelector, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  onValidate: PropTypes$1.func.isRequired,
  onChange: PropTypes$1.func,
  onExit: PropTypes$1.func,
  url: PropTypes$1.string.isRequired,
  urlPlaceholder: PropTypes$1.string,
  saveLabel: PropTypes$1.node
});
__publicField(UrlSelector, "defaultProps", {
  onChange: () => {
  },
  onExit: () => {
  },
  urlPlaceholder: "url",
  saveLabel: "save"
});
const index$d = injectSheet(styles$30)(UrlSelector);
const styles$2$ = {
  root: {
    display: "block",
    width: 67,
    height: "auto",
    stroke: "currentColor"
  }
};
class OrganisationAvatar extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, src: src2, className } = this.props;
      const { id: id2 } = this.state;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          strokeLinejoin: "round",
          strokeMiterlimit: "1.41421",
          clipRule: "evenodd",
          viewBox: "0 0 200 200",
          "aria-hidden": "true",
          className: classNames(classes.root, className),
          children: [
            /* @__PURE__ */ jsx$1("clipPath", { id: id2, children: /* @__PURE__ */ jsx$1("path", { d: "M200 100l-50 86.603H50L0 100l50-86.603h100L200 100z" }) }),
            /* @__PURE__ */ jsx$1(
              "image",
              {
                clipPath: `url(#${id2})`,
                width: "200",
                height: "200",
                xlinkHref: src2
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M199.5,100l-49.75,86.17l-99.5,0l-49.75,-86.17l49.75,-86.17l99.5,0l49.75,86.17Z",
                strokeWidth: "1",
                fill: "none"
              }
            )
          ]
        }
      );
    });
  }
  UNSAFE_componentWillMount() {
    this.setState({
      id: uniqueId$1("clipPath-")
    });
  }
}
__publicField(OrganisationAvatar, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  src: PropTypes$1.string,
  className: PropTypes$1.string
});
__publicField(OrganisationAvatar, "defaultProps", {
  className: null,
  src: null
});
const index$c = injectSheet(styles$2$)(OrganisationAvatar);
const styles$2_ = {
  profileMask: {
    borderRadius: "50%"
  }
};
class ProfileAvatar extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, src: src2, className } = this.props;
      return /* @__PURE__ */ jsx$1(
        "img",
        {
          className: classNames(classes.profileMask, className),
          src: src2,
          alt: ""
        }
      );
    });
  }
}
__publicField(ProfileAvatar, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  src: PropTypes$1.string,
  className: PropTypes$1.string
});
__publicField(ProfileAvatar, "defaultProps", {
  className: null,
  src: null
});
const ProfileAvatar$1 = injectSheet(styles$2_)(ProfileAvatar);
var index_min = { exports: {} };
(function(module2, exports) {
  !function(e5, t3) {
    module2.exports = t3(React__default);
  }(commonjsGlobal, function(e5) {
    return (() => {
      var t3 = { 798: (t4) => {
        t4.exports = e5;
      } }, r2 = {};
      function o2(e6) {
        var n3 = r2[e6];
        if (void 0 !== n3) return n3.exports;
        var i3 = r2[e6] = { exports: {} };
        return t3[e6](i3, i3.exports, o2), i3.exports;
      }
      o2.n = (e6) => {
        var t4 = e6 && e6.__esModule ? () => e6.default : () => e6;
        return o2.d(t4, { a: t4 }), t4;
      }, o2.d = (e6, t4) => {
        for (var r3 in t4) o2.o(t4, r3) && !o2.o(e6, r3) && Object.defineProperty(e6, r3, { enumerable: true, get: t4[r3] });
      }, o2.o = (e6, t4) => Object.prototype.hasOwnProperty.call(e6, t4), o2.r = (e6) => {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e6, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e6, "__esModule", { value: true });
      };
      var n2 = {};
      return (() => {
        o2.r(n2), o2.d(n2, { default: () => l2 });
        var e6 = o2(798), t4 = o2.n(e6);
        function r3(e7, t5) {
          var r4 = Object.keys(e7);
          if (Object.getOwnPropertySymbols) {
            var o3 = Object.getOwnPropertySymbols(e7);
            t5 && (o3 = o3.filter(function(t6) {
              return Object.getOwnPropertyDescriptor(e7, t6).enumerable;
            })), r4.push.apply(r4, o3);
          }
          return r4;
        }
        function i3(e7) {
          for (var t5 = 1; t5 < arguments.length; t5++) {
            var o3 = null != arguments[t5] ? arguments[t5] : {};
            t5 % 2 ? r3(Object(o3), true).forEach(function(t6) {
              a4(e7, t6, o3[t6]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e7, Object.getOwnPropertyDescriptors(o3)) : r3(Object(o3)).forEach(function(t6) {
              Object.defineProperty(e7, t6, Object.getOwnPropertyDescriptor(o3, t6));
            });
          }
          return e7;
        }
        function a4(e7, t5, r4) {
          return t5 in e7 ? Object.defineProperty(e7, t5, { value: r4, enumerable: true, configurable: true, writable: true }) : e7[t5] = r4, e7;
        }
        const l2 = function(r4) {
          var o3 = function(e7) {
            var t5 = e7.parentNode, r5 = t5.querySelector(".constrainedChild") || e7.childNodes[0], o4 = t5.querySelector(".ellipseMe") || t5.querySelector(".constrainedEllipse") || r5;
            null !== r5 && null !== o4 && (o4.hasAttribute("data-original") && (o4.textContent = o4.getAttribute("data-original")), function(e8, t6, r6) {
              var o5 = t6.offsetWidth, n4 = e8.offsetWidth, i4 = r6.offsetWidth, a5 = o5 > i4 ? o5 : i4;
              if (a5 > n4) {
                var l3 = r6.textContent, c3 = l3.length, u3 = (c3 - (n4 - (a5 - i4)) / (i4 / c3) + 5) / 2, f2 = Math.floor(c3 / 2 - u3), s4 = Math.ceil(c3 / 2 + u3);
                r6.setAttribute("data-original", r6.textContent), r6.textContent = l3.substr(0, f2) + "..." + l3.substr(s4);
              }
            }(e7.offsetWidth > t5.offsetWidth ? t5 : e7, r5, o4));
          }, n3 = (0, e6.useCallback)(function(e7) {
            null !== e7 && (window.addEventListener("resize", function() {
              o3(e7);
            }), o3(e7));
          });
          return t4().createElement("div", { ref: n3, style: i3({ wordBreak: "keep-all", overflowWrap: "normal" }, r4.width && { width: r4.width }) }, r4.children);
        };
      })(), n2;
    })();
  });
})(index_min);
var index_minExports = index_min.exports;
const MiddleEllipsis = /* @__PURE__ */ getDefaultExportFromCjs$1(index_minExports);
function o$3(f2) {
  return (r2) => {
    f2.forEach((n2) => {
      typeof n2 == "function" ? n2(r2) : n2 != null && (n2.current = r2);
    });
  };
}
var resizeObservers = [];
var hasActiveObservations = function() {
  return resizeObservers.some(function(ro) {
    return ro.activeTargets.length > 0;
  });
};
var hasSkippedObservations = function() {
  return resizeObservers.some(function(ro) {
    return ro.skippedTargets.length > 0;
  });
};
var msg = "ResizeObserver loop completed with undelivered notifications.";
var deliverResizeLoopError = function() {
  var event;
  if (typeof ErrorEvent === "function") {
    event = new ErrorEvent("error", {
      message: msg
    });
  } else {
    event = document.createEvent("Event");
    event.initEvent("error", false, false);
    event.message = msg;
  }
  window.dispatchEvent(event);
};
var ResizeObserverBoxOptions;
(function(ResizeObserverBoxOptions2) {
  ResizeObserverBoxOptions2["BORDER_BOX"] = "border-box";
  ResizeObserverBoxOptions2["CONTENT_BOX"] = "content-box";
  ResizeObserverBoxOptions2["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));
var freeze$1 = function(obj) {
  return Object.freeze(obj);
};
var ResizeObserverSize = /* @__PURE__ */ function() {
  function ResizeObserverSize2(inlineSize, blockSize) {
    this.inlineSize = inlineSize;
    this.blockSize = blockSize;
    freeze$1(this);
  }
  return ResizeObserverSize2;
}();
var DOMRectReadOnly = function() {
  function DOMRectReadOnly2(x3, y4, width, height) {
    this.x = x3;
    this.y = y4;
    this.width = width;
    this.height = height;
    this.top = this.y;
    this.left = this.x;
    this.bottom = this.top + this.height;
    this.right = this.left + this.width;
    return freeze$1(this);
  }
  DOMRectReadOnly2.prototype.toJSON = function() {
    var _a2 = this, x3 = _a2.x, y4 = _a2.y, top = _a2.top, right = _a2.right, bottom = _a2.bottom, left = _a2.left, width = _a2.width, height = _a2.height;
    return { x: x3, y: y4, top, right, bottom, left, width, height };
  };
  DOMRectReadOnly2.fromRect = function(rectangle) {
    return new DOMRectReadOnly2(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
  };
  return DOMRectReadOnly2;
}();
var isSVG = function(target) {
  return target instanceof SVGElement && "getBBox" in target;
};
var isHidden = function(target) {
  if (isSVG(target)) {
    var _a2 = target.getBBox(), width = _a2.width, height = _a2.height;
    return !width && !height;
  }
  var _b2 = target, offsetWidth = _b2.offsetWidth, offsetHeight = _b2.offsetHeight;
  return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var isElement$1 = function(obj) {
  var _a2;
  if (obj instanceof Element) {
    return true;
  }
  var scope2 = (_a2 = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a2 === void 0 ? void 0 : _a2.defaultView;
  return !!(scope2 && obj instanceof scope2.Element);
};
var isReplacedElement = function(target) {
  switch (target.tagName) {
    case "INPUT":
      if (target.type !== "image") {
        break;
      }
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return true;
  }
  return false;
};
var global$6 = typeof window !== "undefined" ? window : {};
var cache = /* @__PURE__ */ new WeakMap();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE = /msie|trident/i.test(global$6.navigator && global$6.navigator.userAgent);
var parseDimension = function(pixel) {
  return parseFloat(pixel || "0");
};
var size = function(inlineSize, blockSize, switchSizes) {
  if (inlineSize === void 0) {
    inlineSize = 0;
  }
  if (blockSize === void 0) {
    blockSize = 0;
  }
  if (switchSizes === void 0) {
    switchSizes = false;
  }
  return new ResizeObserverSize((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var zeroBoxes = freeze$1({
  devicePixelContentBoxSize: size(),
  borderBoxSize: size(),
  contentBoxSize: size(),
  contentRect: new DOMRectReadOnly(0, 0, 0, 0)
});
var calculateBoxSizes = function(target, forceRecalculation) {
  if (forceRecalculation === void 0) {
    forceRecalculation = false;
  }
  if (cache.has(target) && !forceRecalculation) {
    return cache.get(target);
  }
  if (isHidden(target)) {
    cache.set(target, zeroBoxes);
    return zeroBoxes;
  }
  var cs = getComputedStyle(target);
  var svg = isSVG(target) && target.ownerSVGElement && target.getBBox();
  var removePadding = !IE && cs.boxSizing === "border-box";
  var switchSizes = verticalRegexp.test(cs.writingMode || "");
  var canScrollVertically = !svg && scrollRegexp.test(cs.overflowY || "");
  var canScrollHorizontally = !svg && scrollRegexp.test(cs.overflowX || "");
  var paddingTop = svg ? 0 : parseDimension(cs.paddingTop);
  var paddingRight = svg ? 0 : parseDimension(cs.paddingRight);
  var paddingBottom = svg ? 0 : parseDimension(cs.paddingBottom);
  var paddingLeft = svg ? 0 : parseDimension(cs.paddingLeft);
  var borderTop = svg ? 0 : parseDimension(cs.borderTopWidth);
  var borderRight = svg ? 0 : parseDimension(cs.borderRightWidth);
  var borderBottom = svg ? 0 : parseDimension(cs.borderBottomWidth);
  var borderLeft = svg ? 0 : parseDimension(cs.borderLeftWidth);
  var horizontalPadding = paddingLeft + paddingRight;
  var verticalPadding = paddingTop + paddingBottom;
  var horizontalBorderArea = borderLeft + borderRight;
  var verticalBorderArea = borderTop + borderBottom;
  var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
  var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
  var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
  var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
  var contentWidth = svg ? svg.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
  var contentHeight = svg ? svg.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
  var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
  var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
  var boxes = freeze$1({
    devicePixelContentBoxSize: size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
    borderBoxSize: size(borderBoxWidth, borderBoxHeight, switchSizes),
    contentBoxSize: size(contentWidth, contentHeight, switchSizes),
    contentRect: new DOMRectReadOnly(paddingLeft, paddingTop, contentWidth, contentHeight)
  });
  cache.set(target, boxes);
  return boxes;
};
var calculateBoxSize = function(target, observedBox, forceRecalculation) {
  var _a2 = calculateBoxSizes(target, forceRecalculation), borderBoxSize = _a2.borderBoxSize, contentBoxSize = _a2.contentBoxSize, devicePixelContentBoxSize = _a2.devicePixelContentBoxSize;
  switch (observedBox) {
    case ResizeObserverBoxOptions.DEVICE_PIXEL_CONTENT_BOX:
      return devicePixelContentBoxSize;
    case ResizeObserverBoxOptions.BORDER_BOX:
      return borderBoxSize;
    default:
      return contentBoxSize;
  }
};
var ResizeObserverEntry = /* @__PURE__ */ function() {
  function ResizeObserverEntry2(target) {
    var boxes = calculateBoxSizes(target);
    this.target = target;
    this.contentRect = boxes.contentRect;
    this.borderBoxSize = freeze$1([boxes.borderBoxSize]);
    this.contentBoxSize = freeze$1([boxes.contentBoxSize]);
    this.devicePixelContentBoxSize = freeze$1([boxes.devicePixelContentBoxSize]);
  }
  return ResizeObserverEntry2;
}();
var calculateDepthForNode = function(node3) {
  if (isHidden(node3)) {
    return Infinity;
  }
  var depth = 0;
  var parent3 = node3.parentNode;
  while (parent3) {
    depth += 1;
    parent3 = parent3.parentNode;
  }
  return depth;
};
var broadcastActiveObservations = function() {
  var shallowestDepth = Infinity;
  var callbacks2 = [];
  resizeObservers.forEach(function processObserver(ro) {
    if (ro.activeTargets.length === 0) {
      return;
    }
    var entries = [];
    ro.activeTargets.forEach(function processTarget(ot2) {
      var entry = new ResizeObserverEntry(ot2.target);
      var targetDepth = calculateDepthForNode(ot2.target);
      entries.push(entry);
      ot2.lastReportedSize = calculateBoxSize(ot2.target, ot2.observedBox);
      if (targetDepth < shallowestDepth) {
        shallowestDepth = targetDepth;
      }
    });
    callbacks2.push(function resizeObserverCallback() {
      ro.callback.call(ro.observer, entries, ro.observer);
    });
    ro.activeTargets.splice(0, ro.activeTargets.length);
  });
  for (var _i2 = 0, callbacks_1 = callbacks2; _i2 < callbacks_1.length; _i2++) {
    var callback = callbacks_1[_i2];
    callback();
  }
  return shallowestDepth;
};
var gatherActiveObservationsAtDepth = function(depth) {
  resizeObservers.forEach(function processObserver(ro) {
    ro.activeTargets.splice(0, ro.activeTargets.length);
    ro.skippedTargets.splice(0, ro.skippedTargets.length);
    ro.observationTargets.forEach(function processTarget(ot2) {
      if (ot2.isActive()) {
        if (calculateDepthForNode(ot2.target) > depth) {
          ro.activeTargets.push(ot2);
        } else {
          ro.skippedTargets.push(ot2);
        }
      }
    });
  });
};
var process = function() {
  var depth = 0;
  gatherActiveObservationsAtDepth(depth);
  while (hasActiveObservations()) {
    depth = broadcastActiveObservations();
    gatherActiveObservationsAtDepth(depth);
  }
  if (hasSkippedObservations()) {
    deliverResizeLoopError();
  }
  return depth > 0;
};
var trigger;
var callbacks = [];
var notify = function() {
  return callbacks.splice(0).forEach(function(cb) {
    return cb();
  });
};
var queueMicroTask = function(callback) {
  if (!trigger) {
    var toggle_1 = 0;
    var el_1 = document.createTextNode("");
    var config = { characterData: true };
    new MutationObserver(function() {
      return notify();
    }).observe(el_1, config);
    trigger = function() {
      el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
    };
  }
  callbacks.push(callback);
  trigger();
};
var queueResizeObserver = function(cb) {
  queueMicroTask(function ResizeObserver2() {
    requestAnimationFrame(cb);
  });
};
var watching = 0;
var isWatching = function() {
  return !!watching;
};
var CATCH_PERIOD = 250;
var observerConfig = { attributes: true, characterData: true, childList: true, subtree: true };
var events = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
];
var time = function(timeout) {
  if (timeout === void 0) {
    timeout = 0;
  }
  return Date.now() + timeout;
};
var scheduled = false;
var Scheduler = function() {
  function Scheduler2() {
    var _this = this;
    this.stopped = true;
    this.listener = function() {
      return _this.schedule();
    };
  }
  Scheduler2.prototype.run = function(timeout) {
    var _this = this;
    if (timeout === void 0) {
      timeout = CATCH_PERIOD;
    }
    if (scheduled) {
      return;
    }
    scheduled = true;
    var until = time(timeout);
    queueResizeObserver(function() {
      var elementsHaveResized = false;
      try {
        elementsHaveResized = process();
      } finally {
        scheduled = false;
        timeout = until - time();
        if (!isWatching()) {
          return;
        }
        if (elementsHaveResized) {
          _this.run(1e3);
        } else if (timeout > 0) {
          _this.run(timeout);
        } else {
          _this.start();
        }
      }
    });
  };
  Scheduler2.prototype.schedule = function() {
    this.stop();
    this.run();
  };
  Scheduler2.prototype.observe = function() {
    var _this = this;
    var cb = function() {
      return _this.observer && _this.observer.observe(document.body, observerConfig);
    };
    document.body ? cb() : global$6.addEventListener("DOMContentLoaded", cb);
  };
  Scheduler2.prototype.start = function() {
    var _this = this;
    if (this.stopped) {
      this.stopped = false;
      this.observer = new MutationObserver(this.listener);
      this.observe();
      events.forEach(function(name2) {
        return global$6.addEventListener(name2, _this.listener, true);
      });
    }
  };
  Scheduler2.prototype.stop = function() {
    var _this = this;
    if (!this.stopped) {
      this.observer && this.observer.disconnect();
      events.forEach(function(name2) {
        return global$6.removeEventListener(name2, _this.listener, true);
      });
      this.stopped = true;
    }
  };
  return Scheduler2;
}();
var scheduler = new Scheduler();
var updateCount = function(n2) {
  !watching && n2 > 0 && scheduler.start();
  watching += n2;
  !watching && scheduler.stop();
};
var skipNotifyOnElement = function(target) {
  return !isSVG(target) && !isReplacedElement(target) && getComputedStyle(target).display === "inline";
};
var ResizeObservation = function() {
  function ResizeObservation2(target, observedBox) {
    this.target = target;
    this.observedBox = observedBox || ResizeObserverBoxOptions.CONTENT_BOX;
    this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  ResizeObservation2.prototype.isActive = function() {
    var size2 = calculateBoxSize(this.target, this.observedBox, true);
    if (skipNotifyOnElement(this.target)) {
      this.lastReportedSize = size2;
    }
    if (this.lastReportedSize.inlineSize !== size2.inlineSize || this.lastReportedSize.blockSize !== size2.blockSize) {
      return true;
    }
    return false;
  };
  return ResizeObservation2;
}();
var ResizeObserverDetail = /* @__PURE__ */ function() {
  function ResizeObserverDetail2(resizeObserver, callback) {
    this.activeTargets = [];
    this.skippedTargets = [];
    this.observationTargets = [];
    this.observer = resizeObserver;
    this.callback = callback;
  }
  return ResizeObserverDetail2;
}();
var observerMap = /* @__PURE__ */ new WeakMap();
var getObservationIndex = function(observationTargets, target) {
  for (var i3 = 0; i3 < observationTargets.length; i3 += 1) {
    if (observationTargets[i3].target === target) {
      return i3;
    }
  }
  return -1;
};
var ResizeObserverController = function() {
  function ResizeObserverController2() {
  }
  ResizeObserverController2.connect = function(resizeObserver, callback) {
    var detail = new ResizeObserverDetail(resizeObserver, callback);
    observerMap.set(resizeObserver, detail);
  };
  ResizeObserverController2.observe = function(resizeObserver, target, options) {
    var detail = observerMap.get(resizeObserver);
    var firstObservation = detail.observationTargets.length === 0;
    if (getObservationIndex(detail.observationTargets, target) < 0) {
      firstObservation && resizeObservers.push(detail);
      detail.observationTargets.push(new ResizeObservation(target, options && options.box));
      updateCount(1);
      scheduler.schedule();
    }
  };
  ResizeObserverController2.unobserve = function(resizeObserver, target) {
    var detail = observerMap.get(resizeObserver);
    var index2 = getObservationIndex(detail.observationTargets, target);
    var lastObservation = detail.observationTargets.length === 1;
    if (index2 >= 0) {
      lastObservation && resizeObservers.splice(resizeObservers.indexOf(detail), 1);
      detail.observationTargets.splice(index2, 1);
      updateCount(-1);
    }
  };
  ResizeObserverController2.disconnect = function(resizeObserver) {
    var _this = this;
    var detail = observerMap.get(resizeObserver);
    detail.observationTargets.slice().forEach(function(ot2) {
      return _this.unobserve(resizeObserver, ot2.target);
    });
    detail.activeTargets.splice(0, detail.activeTargets.length);
  };
  return ResizeObserverController2;
}();
var ResizeObserver = function() {
  function ResizeObserver2(callback) {
    if (arguments.length === 0) {
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    }
    if (typeof callback !== "function") {
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    }
    ResizeObserverController.connect(this, callback);
  }
  ResizeObserver2.prototype.observe = function(target, options) {
    if (arguments.length === 0) {
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    }
    if (!isElement$1(target)) {
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    }
    ResizeObserverController.observe(this, target, options);
  };
  ResizeObserver2.prototype.unobserve = function(target) {
    if (arguments.length === 0) {
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    }
    if (!isElement$1(target)) {
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    }
    ResizeObserverController.unobserve(this, target);
  };
  ResizeObserver2.prototype.disconnect = function() {
    ResizeObserverController.disconnect(this);
  };
  ResizeObserver2.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  };
  return ResizeObserver2;
}();
function debounce$4(func, wait, immediate) {
  var timeout, args, context, timestamp, result2;
  if (null == wait) wait = 100;
  function later() {
    var last2 = Date.now() - timestamp;
    if (last2 < wait && last2 >= 0) {
      timeout = setTimeout(later, wait - last2);
    } else {
      timeout = null;
      if (!immediate) {
        result2 = func.apply(context, args);
        context = args = null;
      }
    }
  }
  var debounced = function() {
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result2 = func.apply(context, args);
      context = args = null;
    }
    return result2;
  };
  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  debounced.flush = function() {
    if (timeout) {
      result2 = func.apply(context, args);
      context = args = null;
      clearTimeout(timeout);
      timeout = null;
    }
  };
  return debounced;
}
debounce$4.debounce = debounce$4;
var debounce_1$1 = debounce$4;
const createDebounce = /* @__PURE__ */ getDefaultExportFromCjs$1(debounce_1$1);
function useMeasure$1(_temp) {
  let {
    debounce: debounce2,
    scroll,
    polyfill: polyfill2,
    offsetSize
  } = _temp === void 0 ? {
    debounce: 0,
    scroll: false,
    offsetSize: false
  } : _temp;
  const ResizeObserver2 = polyfill2 || (typeof window === "undefined" ? class ResizeObserver {
  } : window.ResizeObserver);
  if (!ResizeObserver2) {
    throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
  }
  const [bounds, set2] = useState({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    bottom: 0,
    right: 0,
    x: 0,
    y: 0
  });
  const state = useRef({
    element: null,
    scrollContainers: null,
    resizeObserver: null,
    lastBounds: bounds
  });
  const scrollDebounce = debounce2 ? typeof debounce2 === "number" ? debounce2 : debounce2.scroll : null;
  const resizeDebounce = debounce2 ? typeof debounce2 === "number" ? debounce2 : debounce2.resize : null;
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => void (mounted.current = false);
  });
  const [forceRefresh, resizeChange, scrollChange] = useMemo(() => {
    const callback = () => {
      if (!state.current.element) return;
      const {
        left,
        top,
        width,
        height,
        bottom,
        right,
        x: x3,
        y: y4
      } = state.current.element.getBoundingClientRect();
      const size2 = {
        left,
        top,
        width,
        height,
        bottom,
        right,
        x: x3,
        y: y4
      };
      if (state.current.element instanceof HTMLElement && offsetSize) {
        size2.height = state.current.element.offsetHeight;
        size2.width = state.current.element.offsetWidth;
      }
      Object.freeze(size2);
      if (mounted.current && !areBoundsEqual(state.current.lastBounds, size2)) set2(state.current.lastBounds = size2);
    };
    return [callback, resizeDebounce ? createDebounce(callback, resizeDebounce) : callback, scrollDebounce ? createDebounce(callback, scrollDebounce) : callback];
  }, [set2, offsetSize, scrollDebounce, resizeDebounce]);
  function removeListeners() {
    if (state.current.scrollContainers) {
      state.current.scrollContainers.forEach((element) => element.removeEventListener("scroll", scrollChange, true));
      state.current.scrollContainers = null;
    }
    if (state.current.resizeObserver) {
      state.current.resizeObserver.disconnect();
      state.current.resizeObserver = null;
    }
  }
  function addListeners() {
    if (!state.current.element) return;
    state.current.resizeObserver = new ResizeObserver2(scrollChange);
    state.current.resizeObserver.observe(state.current.element);
    if (scroll && state.current.scrollContainers) {
      state.current.scrollContainers.forEach((scrollContainer) => scrollContainer.addEventListener("scroll", scrollChange, {
        capture: true,
        passive: true
      }));
    }
  }
  const ref2 = (node3) => {
    if (!node3 || node3 === state.current.element) return;
    removeListeners();
    state.current.element = node3;
    state.current.scrollContainers = findScrollContainers(node3);
    addListeners();
  };
  useOnWindowScroll(scrollChange, Boolean(scroll));
  useOnWindowResize(resizeChange);
  useEffect(() => {
    removeListeners();
    addListeners();
  }, [scroll, scrollChange, resizeChange]);
  useEffect(() => removeListeners, []);
  return [ref2, bounds, forceRefresh];
}
function useOnWindowResize(onWindowResize) {
  useEffect(() => {
    const cb = onWindowResize;
    window.addEventListener("resize", cb);
    return () => void window.removeEventListener("resize", cb);
  }, [onWindowResize]);
}
function useOnWindowScroll(onScroll, enabled) {
  useEffect(() => {
    if (enabled) {
      const cb = onScroll;
      window.addEventListener("scroll", cb, {
        capture: true,
        passive: true
      });
      return () => void window.removeEventListener("scroll", cb, true);
    }
  }, [onScroll, enabled]);
}
function findScrollContainers(element) {
  const result2 = [];
  if (!element || element === document.body) return result2;
  const {
    overflow,
    overflowX,
    overflowY
  } = window.getComputedStyle(element);
  if ([overflow, overflowX, overflowY].some((prop) => prop === "auto" || prop === "scroll")) result2.push(element);
  return [...result2, ...findScrollContainers(element.parentElement)];
}
const keys$e = ["x", "y", "top", "bottom", "left", "right", "width", "height"];
const areBoundsEqual = (a4, b3) => keys$e.every((key2) => a4[key2] === b3[key2]);
const useMeasure = (extRef, delay2) => {
  const options = useMemo(
    () => ({
      debounce: delay2,
      scroll: false,
      polyfill: ResizeObserver
    }),
    [delay2]
  );
  const result2 = useMeasure$1(options);
  if (extRef) {
    result2[0] = o$3([extRef, result2[0]]);
  }
  return result2;
};
const styles$2Z = () => ({
  root: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: (props2) => props2.maxWidth
  }
});
const TextEllipsis = ({
  classes,
  className = "",
  text = "",
  middleEllipsis = false
}) => {
  const containerRef = useRef();
  const [measureRef, bounds] = useMeasure(containerRef, 0);
  if (!text || !middleEllipsis)
    return /* @__PURE__ */ jsx$1("div", { className: classNames(classes.root, className), children: text });
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      className: classNames(classes.root, className),
      ref: measureRef,
      title: text,
      children: /* @__PURE__ */ jsx$1(MiddleEllipsis, { width: bounds.width, children: /* @__PURE__ */ jsx$1("span", { children: text }) })
    }
  );
};
const TextEllipsis$1 = injectSheet(styles$2Z)(memo(TextEllipsis));
const styles$2Y = {
  root: {
    maxWidth: 100,
    maxHeight: 100,
    fill: "currentColor",
    display: "block",
    "& path": {
      transition: "opacity 100ms linear"
    }
  }
};
const ToggleIconFilter = ({ classes, className, active }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: "1.41421",
    clipRule: "evenodd",
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    className: classNames(classes.root, className),
    children: [
      /* @__PURE__ */ jsx$1("path", { d: "M13.674 27.61a.66.66 0 0 1-.67-.61v-9.4L6.584 6.67a1.622 1.622 0 0 1 0-1.5 1.42 1.42 0 0 1 1.25-.78h16.35a1.4 1.4 0 0 1 1.24.78 1.6 1.6 0 0 1 0 1.46l-6.42 10.93v7.52a.652.652 0 0 1-.41.61l-4.66 1.87a.703.703 0 0 1-.26.05zM7.824 5.69s-.07 0-.1.09a.319.319 0 0 0 0 .27l6.5 11c.06.1.091.214.09.33V26l3.37-1.35v-7.27a.63.63 0 0 1 .09-.33L24.304 6a.28.28 0 0 0 0-.23c0-.06-.07-.09-.09-.09l-16.39.01z" }),
      /* @__PURE__ */ jsx$1(
        "path",
        {
          style: { opacity: active ? 1 : 0 },
          d: "M13.716 27.4a.649.649 0 0 1-.658-.599v-9.23L6.754 6.839a1.59 1.59 0 0 1 0-1.473c.235-.464.708-.76 1.228-.766h16.054c.518.006.988.302 1.217.766.231.45.231.983 0 1.433L18.95 17.532v7.384a.64.64 0 0 1-.403.599l-4.576 1.836a.696.696 0 0 1-.255.049z"
        }
      )
    ]
  }
);
ToggleIconFilter.propTypes = {
  classes: PropTypes$1.object.isRequired,
  className: PropTypes$1.string,
  active: PropTypes$1.bool
};
ToggleIconFilter.defaultProps = {
  className: null,
  active: false
};
const index$b = injectSheet(styles$2Y)(ToggleIconFilter);
const styles$2X = (theme2) => ({
  container: {
    display: "flex",
    marginRight: 20,
    marginLeft: 20
  },
  imageContainer: {
    flexShrink: 0,
    width: 75,
    marginRight: 20,
    paddingTop: 30
  },
  image: {
    height: 75,
    width: 75
  },
  userDetails: {
    width: "100%",
    marginTop: 20
  },
  publicKey: {
    fontFamily: '"Space Mono", monospace',
    whiteSpace: "pre-wrap",
    fontSize: 10,
    padding: 14,
    backgroundColor: theme2.grey8,
    borderRadius: 4
  }
});
let Profile$1 = (_a = class extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "renderAvatar", () => {
      const {
        classes,
        readOnly,
        userDetails: { img },
        onAvatarClick
      } = this.props;
      if (readOnly) {
        return /* @__PURE__ */ jsx$1("div", { className: classes.imageContainer, children: /* @__PURE__ */ jsx$1(ProfileAvatar$1, { src: img, className: classes.image }) });
      }
      return /* @__PURE__ */ jsx$1(Button$3, { className: classes.imageContainer, onClick: onAvatarClick, children: /* @__PURE__ */ jsx$1(ProfileAvatar$1, { src: img, className: classes.image }) });
    });
    __publicField(this, "renderDetails", () => {
      const { classes, readOnly, userDetails, children, onFieldSubmit } = this.props;
      return /* @__PURE__ */ jsxs("div", { className: classes.userDetails, children: [
        /* @__PURE__ */ jsx$1(EditableLabelField$1, { label: "Name", value: userDetails.name }),
        /* @__PURE__ */ jsx$1(EditableLabelField$1, { label: "Email", value: userDetails.email }),
        /* @__PURE__ */ jsx$1(
          EditableLabelField$1,
          {
            label: "Phone",
            value: userDetails.phone,
            editable: !readOnly,
            onSubmit: onFieldSubmit("phone")
          }
        ),
        /* @__PURE__ */ jsx$1(
          EditableLabelField$1,
          {
            label: "Signing Public Key",
            value: userDetails.signingPublicKey,
            valueClassName: classes.publicKey
          }
        ),
        /* @__PURE__ */ jsx$1(
          EditableLabelField$1,
          {
            label: "Encryption Public Key",
            value: userDetails.encryptionPublicKey,
            valueClassName: classes.publicKey
          }
        ),
        children
      ] });
    });
    __publicField(this, "render", () => {
      const { classes } = this.props;
      return /* @__PURE__ */ jsxs("div", { className: classes.container, children: [
        this.renderAvatar(),
        this.renderDetails()
      ] });
    });
  }
}, __publicField(_a, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  readOnly: PropTypes$1.bool.isRequired,
  userDetails: PropTypes$1.object.isRequired,
  children: PropTypes$1.node,
  onAvatarClick: PropTypes$1.func,
  onFieldSubmit: PropTypes$1.func
}), __publicField(_a, "defaultProps", {
  children: null,
  onAvatarClick: () => {
  },
  onFieldSubmit: () => () => {
  }
}), _a);
const index$a = injectSheet(styles$2X)(Profile$1);
const ATC_X_PADDING = 14;
const ATC_GROUP_WIDTH = 280;
const ATC_GROUP_MIN_WIDTH = 196;
const styles$2W = {
  root: {
    height: "100%",
    display: "flex",
    paddingLeft: ATC_X_PADDING,
    paddingRight: ATC_X_PADDING
  }
};
class ATC extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children } = this.props;
      return /* @__PURE__ */ jsx$1("div", { className: classes.root, "data-cy": "atomic-atc", children });
    });
  }
}
__publicField(ATC, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node
});
__publicField(ATC, "defaultProps", {
  children: null
});
const ATC$1 = injectSheet(styles$2W)(ATC);
const styles$2V = (theme2) => ({
  root: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    padding: 7,
    backgroundColor: theme2.grey9,
    borderRadius: "3px 3px 0 0",
    borderBottom: `1px solid ${theme2.grey4}`
  },
  button: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    overflow: "hidden",
    outline: "none",
    minHeight: 24,
    "&[disabled]": {
      cursor: "default"
    },
    "[aria-busy=true] &[disabled]": {
      cursor: "wait"
    }
  },
  avatar: {
    width: 24,
    flexShrink: 0,
    marginRight: 7
  },
  name: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "18px",
    minWidth: 0,
    color: theme2.grey1
  },
  truncate: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  }
});
const styles$2U = {
  root: {
    flexShrink: 0,
    position: "relative",
    width: "100%",
    height: "auto"
  },
  avatar: {
    position: "relative",
    "&[data-has-border=true]": {
      padding: 1
    }
  }
};
const styles$2T = (theme2) => ({
  root: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme2.white1,
    fontSize: "0.42em",
    fontWeight: 700,
    lineHeight: 1,
    textTransform: "uppercase"
  }
});
class AvatarGroupInitials extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, initials } = this.props;
      return /* @__PURE__ */ jsx$1("div", { className: classes.root, children: initials.slice(0, 2) });
    });
  }
}
__publicField(AvatarGroupInitials, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  initials: PropTypes$1.string.isRequired
});
const AvatarGroupInitials$1 = injectSheet(styles$2T)(AvatarGroupInitials);
class AvatarGroupSvg extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { viewBox, children, ...otherProps } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          viewBox: `0 0 ${viewBox} ${viewBox}`,
          xmlns: "http://www.w3.org/2000/svg",
          "aria-hidden": "true",
          ...otherProps,
          children
        }
      );
    });
  }
}
__publicField(AvatarGroupSvg, "propTypes", {
  children: PropTypes$1.node.isRequired,
  viewBox: PropTypes$1.number.isRequired
});
const styles$2S = {
  root: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    width: 1,
    margin: -1,
    padding: 0,
    overflow: "hidden",
    position: "absolute"
  }
};
class Invisible extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      if (this.props.visible) return this.props.children;
      return /* @__PURE__ */ jsx$1("div", { className: this.props.classes.root, children: this.props.children });
    });
  }
}
__publicField(Invisible, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  visible: PropTypes$1.bool
});
__publicField(Invisible, "defaultProps", {
  visible: false
});
const Invisible$1 = injectSheet(styles$2S)(Invisible);
const AVATAR_GROUP_VIEWBOX_SIZE = 100;
const AVATAR_GROUP_COLOR_1 = "#8EB8A4";
const AVATAR_GROUP_COLOR_2 = "#A7C461";
const AVATAR_GROUP_COLOR_3 = "#F2BC3E";
const AVATAR_GROUP_COLOR_4 = "#EE7534";
const AVATAR_GROUP_COLOR_5 = "#C54444";
const AVATAR_GROUP_COLOR_6 = "#CC92E9";
const AVATAR_GROUP_COLOR_7 = "#6A2A88";
const AVATAR_GROUP_COLOR_8 = "#7BD0CE";
class AvatarGroupClippath extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const points = [
        `${AVATAR_GROUP_VIEWBOX_SIZE * 0.25},${AVATAR_GROUP_VIEWBOX_SIZE * 0.06699}`,
        `${AVATAR_GROUP_VIEWBOX_SIZE * 0.75},${AVATAR_GROUP_VIEWBOX_SIZE * 0.06699}`,
        `${AVATAR_GROUP_VIEWBOX_SIZE},${AVATAR_GROUP_VIEWBOX_SIZE * 0.5}`,
        `${AVATAR_GROUP_VIEWBOX_SIZE * 0.75},${AVATAR_GROUP_VIEWBOX_SIZE * 0.93301}`,
        `${AVATAR_GROUP_VIEWBOX_SIZE * 0.25},${AVATAR_GROUP_VIEWBOX_SIZE * 0.93301}`,
        `0,${AVATAR_GROUP_VIEWBOX_SIZE * 0.5}`
      ];
      return /* @__PURE__ */ jsx$1(Invisible$1, { children: /* @__PURE__ */ jsx$1(AvatarGroupSvg, { viewBox: AVATAR_GROUP_VIEWBOX_SIZE, children: /* @__PURE__ */ jsx$1("clipPath", { id: this.props.clipPathId, children: /* @__PURE__ */ jsx$1("polygon", { points: points.join(" ") }) }) }) });
    });
  }
}
__publicField(AvatarGroupClippath, "propTypes", {
  clipPathId: PropTypes$1.string.isRequired
});
const styles$2R = (theme2) => ({
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "auto",
    fill: theme2.grey7,
    "&[data-is-white=true]": {
      fill: theme2.white1,
      padding: 1
    }
  }
});
class AvatarGroupBorder extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, clipPathId } = this.props;
      return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
        /* @__PURE__ */ jsx$1(AvatarGroupSvg, { viewBox: AVATAR_GROUP_VIEWBOX_SIZE, className: classes.root, children: /* @__PURE__ */ jsx$1("rect", { width: "100", height: "100", clipPath: `url(#${clipPathId})` }) }),
        /* @__PURE__ */ jsx$1(
          AvatarGroupSvg,
          {
            viewBox: AVATAR_GROUP_VIEWBOX_SIZE,
            className: classes.root,
            "data-is-white": true,
            children: /* @__PURE__ */ jsx$1("rect", { width: "100", height: "100", clipPath: `url(#${clipPathId})` })
          }
        )
      ] });
    });
  }
}
__publicField(AvatarGroupBorder, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  clipPathId: PropTypes$1.string.isRequired
});
const AvatarGroupBorder$1 = injectSheet(styles$2R)(AvatarGroupBorder);
const styles$2Q = {
  root: {
    display: "block",
    width: "100%",
    height: "auto",
    '&[data-nth="1"]': {
      fill: AVATAR_GROUP_COLOR_1
    },
    '&[data-nth="2"]': {
      fill: AVATAR_GROUP_COLOR_2
    },
    '&[data-nth="3"]': {
      fill: AVATAR_GROUP_COLOR_3
    },
    '&[data-nth="4"]': {
      fill: AVATAR_GROUP_COLOR_4
    },
    '&[data-nth="5"]': {
      fill: AVATAR_GROUP_COLOR_5
    },
    '&[data-nth="6"]': {
      fill: AVATAR_GROUP_COLOR_6
    },
    '&[data-nth="7"]': {
      fill: AVATAR_GROUP_COLOR_7
    },
    '&[data-nth="8"]': {
      fill: AVATAR_GROUP_COLOR_8
    }
  }
};
class AvatarGroupColour extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, clipPathId, nth } = this.props;
      return /* @__PURE__ */ jsx$1(
        AvatarGroupSvg,
        {
          viewBox: AVATAR_GROUP_VIEWBOX_SIZE,
          className: classes.root,
          "data-nth": nth % 8 || 8,
          children: /* @__PURE__ */ jsx$1("rect", { width: "100", height: "100", clipPath: `url(#${clipPathId})` })
        }
      );
    });
  }
}
__publicField(AvatarGroupColour, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  clipPathId: PropTypes$1.string.isRequired,
  nth: PropTypes$1.number
});
__publicField(AvatarGroupColour, "defaultProps", {
  nth: 1
});
const AvatarGroupColour$1 = injectSheet(styles$2Q)(AvatarGroupColour);
const styles$2P = {
  root: {
    display: "block",
    width: "100%",
    height: "auto"
  }
};
class AvatarGroupImage extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, clipPathId, src: src2 } = this.props;
      return /* @__PURE__ */ jsx$1(AvatarGroupSvg, { viewBox: AVATAR_GROUP_VIEWBOX_SIZE, className: classes.root, children: /* @__PURE__ */ jsx$1(
        "image",
        {
          height: "100%",
          width: "100%",
          preserveAspectRatio: "xMinYMin slice",
          xlinkHref: src2,
          clipPath: `url(#${clipPathId})`
        }
      ) });
    });
  }
}
__publicField(AvatarGroupImage, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  clipPathId: PropTypes$1.string.isRequired,
  src: PropTypes$1.string.isRequired
});
const AvatarGroupImage$1 = injectSheet(styles$2P)(AvatarGroupImage);
class AvatarGroup extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "id", uniqueId$1("ag_"));
    __publicField(this, "renderAvatar", () => {
      const { classes, nth, initials, src: src2 } = this.props;
      return /* @__PURE__ */ jsx$1("div", { className: classes.avatar, "data-has-border": true, children: src2 ? /* @__PURE__ */ jsx$1(AvatarGroupImage$1, { clipPathId: this.id, src: src2 }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx$1(AvatarGroupColour$1, { nth, clipPathId: this.id }),
        !!initials && /* @__PURE__ */ jsx$1(AvatarGroupInitials$1, { initials })
      ] }) });
    });
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      const rootProps = {
        className: classes.root,
        style: {
          width: size2,
          height: size2,
          fontSize: size2
        }
      };
      return /* @__PURE__ */ jsxs("div", { ...rootProps, children: [
        /* @__PURE__ */ jsx$1(AvatarGroupClippath, { clipPathId: this.id }),
        /* @__PURE__ */ jsx$1(AvatarGroupBorder$1, { clipPathId: this.id }),
        this.renderAvatar()
      ] });
    });
  }
}
__publicField(AvatarGroup, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number.isRequired,
  initials: PropTypes$1.string,
  nth: PropTypes$1.number,
  src: PropTypes$1.string
});
__publicField(AvatarGroup, "defaultProps", {
  initials: null,
  nth: null,
  src: null
});
const AvatarGroup$1 = injectSheet(styles$2U)(AvatarGroup);
class ATCGroupHeader extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, avatarSrc, text, onClick, loading, disabled } = this.props;
      return /* @__PURE__ */ jsx$1(
        "div",
        {
          className: classes.root,
          "aria-busy": loading,
          "data-cy": "atomic-atc-group-header",
          children: /* @__PURE__ */ jsxs(
            "button",
            {
              className: classes.button,
              type: "button",
              disabled: disabled || loading,
              onClick,
              children: [
                avatarSrc && /* @__PURE__ */ jsx$1("div", { className: classes.avatar, children: /* @__PURE__ */ jsx$1(AvatarGroup$1, { src: avatarSrc, size: 24 }) }),
                /* @__PURE__ */ jsx$1("div", { className: classes.name, children: /* @__PURE__ */ jsx$1("div", { className: classes.truncate, children: text }) })
              ]
            }
          )
        }
      );
    });
  }
}
__publicField(ATCGroupHeader, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  avatarSrc: PropTypes$1.string,
  text: PropTypes$1.string.isRequired,
  onClick: PropTypes$1.func.isRequired,
  disabled: PropTypes$1.bool,
  loading: PropTypes$1.bool
});
__publicField(ATCGroupHeader, "defaultProps", {
  avatarSrc: null,
  loading: false,
  disabled: false
});
const ATCGroupHeader$1 = injectSheet(styles$2V)(ATCGroupHeader);
const styles$2O = (theme2) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflowY: "hidden",
    borderRadius: "0 0 3px 3px",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: 14,
      backgroundColor: theme2.grey8,
      borderRadius: "0 0 3px 3px",
      zIndex: -1,
      boxShadow: `0 2px 2px 0 rgba(29,3,89, 0.5)`
    }
  },
  body: {
    flexGrow: 1,
    overflowY: "auto",
    borderRadius: "inherit",
    overflowScrolling: "touch"
  },
  content: {
    backgroundColor: theme2.grey8,
    borderRadius: "inherit",
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3
  }
});
class ATCGroupBody extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children, loading } = this.props;
      return /* @__PURE__ */ jsx$1(
        "div",
        {
          className: classes.root,
          "aria-busy": loading,
          "data-cy": "atomic-atc-group-body",
          children: /* @__PURE__ */ jsx$1("div", { className: classes.body, children: /* @__PURE__ */ jsx$1("div", { className: classes.content, children }) })
        }
      );
    });
  }
}
__publicField(ATCGroupBody, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  loading: PropTypes$1.bool
});
__publicField(ATCGroupBody, "defaultProps", {
  loading: false
});
const ATCGroupBody$1 = injectSheet(styles$2O)(ATCGroupBody);
const styles$2N = {
  root: {
    width: `calc(100vw - ${ATC_X_PADDING * 2}px)`,
    maxWidth: ATC_GROUP_WIDTH,
    minWidth: ATC_GROUP_MIN_WIDTH,
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    padding: "14px 7px",
    boxSizing: "border-box"
  }
};
class ATCGroup extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const {
        classes,
        children,
        avatarSrc,
        header: header2,
        headerOnClick,
        loading,
        disabled
      } = this.props;
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: classes.root,
          "aria-busy": loading,
          "data-cy": "atomic-atc-group",
          children: [
            /* @__PURE__ */ jsx$1(
              ATCGroupHeader$1,
              {
                onClick: headerOnClick,
                avatarSrc,
                text: header2,
                loading,
                disabled
              }
            ),
            /* @__PURE__ */ jsx$1(ATCGroupBody$1, { loading, children })
          ]
        }
      );
    });
  }
}
__publicField(ATCGroup, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node,
  avatarSrc: PropTypes$1.string,
  header: PropTypes$1.string.isRequired,
  headerOnClick: PropTypes$1.func.isRequired,
  disabled: PropTypes$1.bool,
  loading: PropTypes$1.bool
});
__publicField(ATCGroup, "defaultProps", {
  children: null,
  avatarSrc: null,
  disabled: false,
  loading: false
});
const ATCGroup$1 = injectSheet(styles$2N)(ATCGroup);
const styles$2M = (theme2) => ({
  root: {
    color: "inherit",
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    borderWidth: 0,
    borderStyle: "solid",
    borderColor: theme2.grey7,
    borderRadius: "50%",
    overflow: "hidden",
    boxSizing: "border-box",
    display: "block",
    boxShadow: `0 0 0 0 ${theme2.indigoPastel2}`,
    transition: `box-shadow 150ms linear 0ms, border-color 100ms linear 0ms`,
    "&[data-has-border=true]": {
      borderWidth: 1
    }
  },
  ratioImage: {
    display: "block",
    width: "100%",
    height: "auto"
  }
});
const defaultSrc = "data:image/svg+xml,%3csvg%20enable-background='new%200%200%20100%20100'%20viewBox='0%200%20100%20100'%20xmlns='http://www.w3.org/2000/svg'%20%3e%3cpath%20d='m-.1-.5h99.8v100.2h-99.8z'%20fill='%238f8b9b'%20/%3e%3cg%20fill='%23e5e3eb'%3e%3ccircle%20cx='49.5'%20cy='29.6'%20r='13.6'%20/%3e%3cpath%20d='m50.2%2082c-16.2%200-25.5-8.6-25.5-8.6v-4.4c0-10.9%208.9-19.9%2019.9-19.9h9.9c10.9%200%2019.9%208.9%2019.9%2019.9v4.3c-.1%200-8%208.7-24.2%208.7z'%20/%3e%3c/g%3e%3c/svg%3e";
class Avatar extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "renderRatioImage", () => /* @__PURE__ */ jsx$1(
      "img",
      {
        className: this.props.classes.ratioImage,
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
        alt: ""
      }
    ));
    __publicField(this, "render", () => {
      const { classes, size: size2, src: src2 } = this.props;
      const rootProps = {
        className: classes.root,
        "data-has-border": true,
        style: {
          backgroundImage: `url(${src2 || defaultSrc})`,
          width: size2,
          height: size2
        }
      };
      return /* @__PURE__ */ jsx$1("div", { ...rootProps, children: this.renderRatioImage() });
    });
  }
}
__publicField(Avatar, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  src: PropTypes$1.string,
  size: PropTypes$1.number
});
__publicField(Avatar, "defaultProps", {
  src: null,
  size: null
});
const Avatar$1 = injectSheet(styles$2M)(Avatar);
const HEADER_HEIGHT = 70;
const NAVBAR_HEIGHT = 70;
const SUB_NAVBAR_HEIGHT = NAVBAR_HEIGHT / 2;
const ASIDE_MAX_WIDTH = 220;
const VIEWPORT_MARGIN = 7;
const MIN_TARGET_SIZE = 34;
const FOCUS_OUTLINE_WIDTH = 3;
const MODAL_MAX_WIDTH_SMALL = 500;
const MODAL_MAX_WIDTH_LARGE = 800;
const TEXTAREA_LINE_HEIGHT = 20;
const TAB_MARGIN_RIGHT = 20;
const WRAPPER_PADDING_LEFT = 14;
const HTMLROOT_FIXED_ZINDEX = 0;
const BG_FIXED_ZINDEX = 1;
const MAIN_FIXED_ZINDEX = 2;
const ASIDE_FIXED_ZINDEX = 3;
const HEADER_FIXED_ZINDEX = 4;
const VENEER_FIXED_ZINDEX = 5;
const TRAY_HANDLE_ZINDEX = 5;
const styles$2L = (theme2) => ({
  root: {
    position: "relative",
    appearance: "none",
    color: theme2.grey5,
    backgroundColor: "transparent",
    boxSizing: "border-box",
    cursor: "pointer",
    outline: "none",
    display: "block",
    boxShadow: `0 0 0 0 ${theme2.indigoPastel2}`,
    transition: `color 100ms linear 0ms, box-shadow 150ms linear 0ms`,
    width: "100%",
    height: "auto",
    borderRadius: "50%",
    "&::after": {
      content: '""',
      position: "absolute",
      width: MIN_TARGET_SIZE,
      height: MIN_TARGET_SIZE,
      top: "50%",
      left: "50%",
      transform: "translateY(-50%) translateX(-50%)"
    },
    "&[disabled]": {
      opacity: 0.3,
      color: theme2.grey3
    },
    "&:not([disabled]):hover": {
      cursor: "pointer",
      color: theme2.indigo3
    },
    "&:focus": {
      boxShadow: `0 0 0 ${FOCUS_OUTLINE_WIDTH}px ${theme2.indigoPastel2}`
    }
  }
});
const styles$2K = (theme2) => ({
  root: {
    color: theme2.indigo3,
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "currentColor",
      opacity: 0.6
    }
  },
  icon: {
    flexShrink: 0,
    width: "70%",
    height: "auto",
    maxWidth: 32,
    position: "relative",
    color: theme2.white1
  }
});
class AvatarOverlay extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, icon: icon2 } = this.props;
      return /* @__PURE__ */ jsx$1("div", { className: classes.root, children: /* @__PURE__ */ jsx$1("div", { className: classes.icon, children: icon2 }) });
    });
  }
}
__publicField(AvatarOverlay, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  icon: PropTypes$1.node.isRequired
});
const AvatarOverlay$1 = injectSheet(styles$2K)(AvatarOverlay);
const __vite_glob_0_0 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M5.0969 28C5.00763 27.9997 4.91943 27.9806 4.8381 27.9439C4.75677 27.9073 4.68416 27.854 4.62499 27.7875C4.56583 27.721 4.52147 27.6428 4.49482 27.558C4.46818 27.4733 4.45985 27.3839 4.47038 27.2957L5.22784 21.178C4.41764 19.5487 3.99741 17.755 4.00001 15.9373C4.00001 13.5763 4.70378 11.2684 6.02236 9.30529C7.34093 7.34221 9.21507 5.81218 11.4078 4.90868C13.6005 4.00517 16.0133 3.76877 18.3411 4.22938C20.6688 4.68998 22.807 5.82689 24.4853 7.49635C26.1635 9.16581 27.3064 11.2928 27.7694 13.6084C28.2324 15.924 27.9948 18.3242 27.0865 20.5055C26.1783 22.6867 24.6402 24.5511 22.6669 25.8628C20.6935 27.1745 18.3734 27.8746 16 27.8746C14.1943 27.8768 12.4119 27.4686 10.789 26.6811L5.24142 27.9826C5.19412 27.9941 5.14559 27.9999 5.0969 28ZM10.8656 25.3951C10.9646 25.3952 11.0623 25.4183 11.1507 25.4626C12.6517 26.2263 14.3141 26.6232 16 26.6203C18.1241 26.6205 20.2005 25.9942 21.9666 24.8204C23.7328 23.6466 25.1094 21.9783 25.9224 20.0262C26.7354 18.0741 26.9482 15.9261 26.5339 13.8537C26.1197 11.7813 25.0969 9.87771 23.5951 8.38356C22.0932 6.88941 20.1796 5.87185 18.0964 5.45957C16.0132 5.04728 13.8539 5.25879 11.8915 6.06734C9.92908 6.87588 8.25182 8.24515 7.07174 10.002C5.89166 11.7588 5.26179 13.8243 5.26179 15.9373C5.25975 17.6226 5.66311 19.2839 6.4382 20.7824C6.49495 20.8938 6.51723 21.0193 6.50222 21.1433L5.83302 26.5557L10.7211 25.4086C10.7685 25.3978 10.817 25.3923 10.8656 25.3922V25.3951Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M13.5 15.75C13.5 16.7165 12.7165 17.5 11.75 17.5C10.7835 17.5 10 16.7165 10 15.75C10 14.7835 10.7835 14 11.75 14C12.7165 14 13.5 14.7835 13.5 15.75ZM18.5 15.75C18.5 16.7165 17.7165 17.5 16.75 17.5C15.7835 17.5 15 16.7165 15 15.75C15 14.7835 15.7835 14 16.75 14C17.7165 14 18.5 14.7835 18.5 15.75ZM21.75 17.5C22.7165 17.5 23.5 16.7165 23.5 15.75C23.5 14.7835 22.7165 14 21.75 14C20.7835 14 20 14.7835 20 15.75C20 16.7165 20.7835 17.5 21.75 17.5Z"\n  />\n</svg>\n';
const __vite_glob_0_1 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M4.8381 27.9439C4.91943 27.9806 5.00763 27.9997 5.0969 28C5.14559 27.9999 5.19412 27.9941 5.24142 27.9826L10.789 26.6811C12.4119 27.4686 14.1943 27.8768 16 27.8746C18.3734 27.8746 20.6935 27.1745 22.6669 25.8628C24.6402 24.5511 26.1783 22.6867 27.0865 20.5055C27.9948 18.3242 28.2324 15.924 27.7694 13.6084C27.3064 11.2928 26.1635 9.16581 24.4853 7.49635C22.807 5.82689 20.6688 4.68998 18.3411 4.22938C16.0133 3.76877 13.6005 4.00517 11.4078 4.90868C9.21507 5.81218 7.34093 7.34221 6.02236 9.30529C4.70378 11.2684 4.00001 13.5763 4.00001 15.9373C3.99741 17.755 4.41764 19.5487 5.22784 21.178L4.47038 27.2957C4.45985 27.3839 4.46818 27.4733 4.49482 27.558C4.52147 27.6428 4.56583 27.721 4.62499 27.7875C4.68416 27.854 4.75677 27.9073 4.8381 27.9439ZM11.75 17.5C12.7165 17.5 13.5 16.7165 13.5 15.75C13.5 14.7835 12.7165 14 11.75 14C10.7835 14 10 14.7835 10 15.75C10 16.7165 10.7835 17.5 11.75 17.5ZM16.75 17.5C17.7165 17.5 18.5 16.7165 18.5 15.75C18.5 14.7835 17.7165 14 16.75 14C15.7835 14 15 14.7835 15 15.75C15 16.7165 15.7835 17.5 16.75 17.5ZM23.5 15.75C23.5 16.7165 22.7165 17.5 21.75 17.5C20.7835 17.5 20 16.7165 20 15.75C20 14.7835 20.7835 14 21.75 14C22.7165 14 23.5 14.7835 23.5 15.75Z"\n  />\n</svg>\n';
const __vite_glob_0_2 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M3.409 28.591V2.108H2.10901V29.241C2.10888 29.3264 2.12559 29.4111 2.1582 29.4901C2.1908 29.569 2.23866 29.6408 2.29903 29.7013C2.35941 29.7617 2.43111 29.8097 2.51003 29.8424C2.58896 29.8752 2.67357 29.892 2.75901 29.892H29.891V28.592L3.409 28.591Z"\n  />\n  <path\n    d="M8.43302 26.1C9.10634 26.0992 9.75183 25.8313 10.2278 25.3551C10.7039 24.8789 10.9715 24.2333 10.972 23.56C10.9697 22.9548 10.7492 22.3708 10.351 21.915L13.62 17.153C14.0219 17.3036 14.4562 17.3459 14.8795 17.2757C15.3029 17.2055 15.7003 17.0252 16.032 16.753L18.148 18.339C17.9718 18.7696 17.9172 19.2403 17.9902 19.6999C18.0631 20.1594 18.2608 20.59 18.5618 20.9449C18.8627 21.2997 19.2553 21.5652 19.6967 21.7122C20.1382 21.8592 20.6115 21.8822 21.0651 21.7787C21.5187 21.6752 21.9352 21.4491 22.2691 21.1251C22.6031 20.8011 22.8416 20.3917 22.9588 19.9414C23.076 19.4911 23.0673 19.0173 22.9337 18.5716C22.8 18.126 22.5466 17.7255 22.201 17.414L25.549 10.995C25.7298 11.0366 25.9146 11.0581 26.1 11.059C26.6992 11.065 27.2815 10.861 27.7459 10.4822C28.2102 10.1035 28.5271 9.57398 28.6416 8.98581C28.7561 8.39764 28.6609 7.78795 28.3725 7.2627C28.0842 6.73744 27.6209 6.32983 27.0632 6.11069C26.5055 5.89155 25.8886 5.87473 25.3198 6.06317C24.751 6.25161 24.2662 6.63338 23.9497 7.14215C23.6331 7.65092 23.5048 8.25452 23.5871 8.84805C23.6694 9.44158 23.957 9.98751 24.4 10.391L21.051 16.81C20.8709 16.7691 20.6868 16.748 20.502 16.747C19.9321 16.7494 19.3799 16.9455 18.936 17.303L16.82 15.718C16.9918 15.2997 17.0488 14.8432 16.9852 14.3955C16.9216 13.9478 16.7397 13.5252 16.4582 13.1713C16.1768 12.8174 15.806 12.545 15.3841 12.3822C14.9622 12.2195 14.5046 12.1722 14.0584 12.2454C13.6121 12.3185 13.1935 12.5094 12.8457 12.7984C12.4979 13.0873 12.2335 13.4638 12.0798 13.8891C11.9261 14.3143 11.8886 14.7729 11.9713 15.2174C12.0539 15.662 12.2537 16.0764 12.55 16.418L9.28202 21.18C9.01084 21.0793 8.72429 21.0262 8.43502 21.023C7.76137 21.023 7.11531 21.2906 6.63897 21.7669C6.16263 22.2433 5.89502 22.8893 5.89502 23.563C5.89502 24.2366 6.16263 24.8827 6.63897 25.359C7.11531 25.8354 7.76137 26.103 8.43502 26.103L8.43302 26.1ZM26.1 7.27899C26.3454 7.27879 26.5852 7.35137 26.7893 7.48755C26.9934 7.62373 27.1525 7.81739 27.2464 8.04401C27.3404 8.27063 27.3651 8.52005 27.3172 8.76068C27.2694 9.00131 27.1513 9.22234 26.9778 9.39581C26.8044 9.56929 26.5833 9.68742 26.3427 9.73523C26.1021 9.78304 25.8527 9.75841 25.626 9.66443C25.3994 9.57045 25.2058 9.41135 25.0696 9.20728C24.9334 9.00321 24.8608 8.76334 24.861 8.51801C24.8615 8.18957 24.9923 7.87473 25.2245 7.64249C25.4567 7.41024 25.7716 7.27952 26.1 7.27899ZM21.74 19.286C21.74 19.531 21.6674 19.7705 21.5313 19.9742C21.3952 20.178 21.2017 20.3368 20.9754 20.4306C20.7491 20.5244 20.5 20.549 20.2597 20.5013C20.0194 20.4535 19.7986 20.3356 19.6253 20.1624C19.452 19.9893 19.3339 19.7686 19.2859 19.5283C19.238 19.288 19.2624 19.039 19.356 18.8126C19.4497 18.5861 19.6083 18.3925 19.8119 18.2563C20.0156 18.12 20.255 18.0472 20.5 18.047C20.8287 18.047 21.144 18.1775 21.3765 18.4098C21.609 18.6421 21.7398 18.9573 21.74 19.286ZM14.467 13.528C14.712 13.5282 14.9515 13.601 15.1551 13.7373C15.3587 13.8736 15.5174 14.0671 15.611 14.2935C15.7046 14.52 15.729 14.7691 15.6811 15.0093C15.6332 15.2496 15.5151 15.4703 15.3418 15.6435C15.1685 15.8166 14.9477 15.9345 14.7074 15.9823C14.4671 16.03 14.218 16.0054 13.9916 15.9116C13.7653 15.8178 13.5719 15.659 13.4358 15.4553C13.2997 15.2515 13.227 15.012 13.227 14.767C13.2275 14.4384 13.3584 14.1234 13.5909 13.8911C13.8233 13.6588 14.1384 13.5283 14.467 13.528ZM8.43302 22.319C8.67831 22.319 8.91809 22.3917 9.12203 22.528C9.32597 22.6643 9.4849 22.8581 9.57873 23.0847C9.67255 23.3114 9.69705 23.5607 9.64912 23.8013C9.6012 24.0418 9.483 24.2628 9.30948 24.4362C9.13596 24.6095 8.91493 24.7276 8.67432 24.7753C8.43372 24.823 8.18436 24.7983 7.9578 24.7043C7.73124 24.6103 7.53764 24.4512 7.40151 24.2472C7.26538 24.0431 7.19283 23.8033 7.19302 23.558C7.19355 23.2294 7.3244 22.9144 7.55685 22.6821C7.78931 22.4499 8.10441 22.3193 8.43302 22.319Z"\n  />\n</svg>\n';
const __vite_glob_0_3 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M3.409 28.591V2.108H2.10901V29.241C2.10888 29.3264 2.12559 29.4111 2.1582 29.4901C2.1908 29.569 2.23866 29.6408 2.29903 29.7013C2.35941 29.7617 2.43111 29.8097 2.51003 29.8424C2.58896 29.8752 2.67357 29.892 2.75901 29.892H29.891V28.592L3.409 28.591Z"\n  />\n  <path\n    d="M8.43302 26.1C9.10634 26.0992 9.75183 25.8313 10.2278 25.3551C10.7039 24.8789 10.9715 24.2333 10.972 23.56C10.9697 22.9548 10.7492 22.3708 10.351 21.915L13.62 17.153C14.0219 17.3036 14.4562 17.3459 14.8795 17.2757C15.3029 17.2055 15.7003 17.0252 16.032 16.753L18.148 18.339C17.9718 18.7696 17.9172 19.2403 17.9902 19.6999C18.0631 20.1594 18.2608 20.59 18.5618 20.9449C18.8627 21.2997 19.2553 21.5652 19.6967 21.7122C20.1382 21.8592 20.6115 21.8822 21.0651 21.7787C21.5187 21.6752 21.9352 21.4491 22.2691 21.1251C22.6031 20.8011 22.8416 20.3917 22.9588 19.9414C23.076 19.4911 23.0673 19.0173 22.9337 18.5716C22.8 18.126 22.5466 17.7255 22.201 17.414L25.549 10.995C25.7298 11.0366 25.9146 11.0581 26.1 11.059C26.6992 11.065 27.2815 10.861 27.7459 10.4822C28.2102 10.1035 28.5271 9.57398 28.6416 8.98581C28.7561 8.39764 28.6609 7.78795 28.3725 7.2627C28.0842 6.73744 27.6209 6.32983 27.0632 6.11069C26.5055 5.89155 25.8886 5.87473 25.3198 6.06317C24.751 6.25161 24.2662 6.63338 23.9497 7.14215C23.6331 7.65092 23.5048 8.25452 23.5871 8.84805C23.6694 9.44158 23.957 9.98751 24.4 10.391L21.051 16.81C20.8709 16.7691 20.6868 16.748 20.502 16.747C19.9321 16.7494 19.3799 16.9455 18.936 17.303L16.82 15.718C16.9918 15.2997 17.0488 14.8432 16.9852 14.3955C16.9216 13.9478 16.7397 13.5252 16.4582 13.1713C16.1768 12.8174 15.806 12.545 15.3841 12.3822C14.9622 12.2195 14.5046 12.1722 14.0584 12.2454C13.6121 12.3185 13.1935 12.5094 12.8457 12.7984C12.4979 13.0873 12.2335 13.4638 12.0798 13.8891C11.9261 14.3143 11.8886 14.7729 11.9713 15.2174C12.0539 15.662 12.2537 16.0764 12.55 16.418L9.28202 21.18C9.01084 21.0793 8.72429 21.0262 8.43502 21.023C7.76137 21.023 7.11531 21.2906 6.63897 21.7669C6.16263 22.2433 5.89502 22.8893 5.89502 23.563C5.89502 24.2366 6.16263 24.8827 6.63897 25.359C7.11531 25.8354 7.76137 26.103 8.43502 26.103L8.43302 26.1Z"\n  />\n</svg>\n';
const __vite_glob_0_4 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M15.99 23.69a1.49 1.49 0 0 1-1.3-.75L7.56 10.56a1.44 1.44 0 0 1 0-1.5 1.48 1.48 0 0 1 1.3-.75h14.29a1.5 1.5 0 0 1 1.3 2.25L17.3 22.94a1.49 1.49 0 0 1-1.31.75zM8.86 9.81l7.13 12.38.65.37-.65-.37 7.16-12.38H8.86z"\n  />\n</svg>\n';
const __vite_glob_0_5 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M15.99 23.69a1.49 1.49 0 0 1-1.3-.75L7.56 10.56a1.44 1.44 0 0 1 0-1.5 1.48 1.48 0 0 1 1.3-.75h14.29a1.5 1.5 0 0 1 1.3 2.25L17.3 22.94a1.49 1.49 0 0 1-1.31.75zM8.86 9.81l7.13 12.38.65.37-.65-.37 7.16-12.38H8.86z"\n  />\n  <path\n    d="M15.99 23.69a1.49 1.49 0 0 1-1.3-.75L7.56 10.56a1.44 1.44 0 0 1 0-1.5 1.48 1.48 0 0 1 1.3-.75h14.29a1.5 1.5 0 0 1 1.3 2.25L17.3 22.94a1.49 1.49 0 0 1-1.31.75z"\n  />\n</svg>\n';
const __vite_glob_0_6 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M4.42869 3.05288C4.68819 2.94539 4.98688 3.00481 5.18549 3.20342L10.5376 8.55558H28.3056V9.94446H10.5376L5.18549 15.2966C4.98688 15.4952 4.68819 15.5546 4.42869 15.4472C4.1692 15.3397 4 15.0865 4 14.8056V3.69446C4 3.41359 4.1692 3.16037 4.42869 3.05288ZM9.26791 9.25002L5.38889 5.371V13.129L9.26791 9.25002Z"\n  />\n  <path\n    fill-rule="evenodd"\n    d="M21.0603 15.5685C21.3009 15.4529 21.5865 15.4854 21.7949 15.6522L28.7394 21.2077C28.9041 21.3395 29 21.539 29 21.75C29 21.961 28.9041 22.1605 28.7394 22.2923L21.7949 27.8478C21.5865 28.0146 21.3009 28.0471 21.0603 27.9315C20.8197 27.8158 20.6667 27.5725 20.6667 27.3056V22.4445H4.69446V21.0556H20.6667V16.1945C20.6667 15.9275 20.8197 15.6842 21.0603 15.5685ZM22.0556 17.6393V25.8607L27.1939 21.75L22.0556 17.6393Z"\n  />\n</svg>\n';
const __vite_glob_0_7 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M4.42869 3.05288C4.68819 2.94539 4.98688 3.00481 5.18549 3.20342L10.5376 8.55558H28.3056V9.94446H10.5376L5.18549 15.2966C4.98688 15.4952 4.68819 15.5546 4.42869 15.4472C4.1692 15.3397 4 15.0865 4 14.8056V3.69446C4 3.41359 4.1692 3.16037 4.42869 3.05288Z"\n  />\n  <path\n    fill-rule="evenodd"\n    d="M21.0603 15.5685C21.3009 15.4529 21.5865 15.4854 21.7949 15.6522L28.7394 21.2077C28.9041 21.3395 29 21.539 29 21.75C29 21.961 28.9041 22.1605 28.7394 22.2923L21.7949 27.8478C21.5865 28.0146 21.3009 28.0471 21.0603 27.9315C20.8197 27.8158 20.6667 27.5725 20.6667 27.3056V22.4445H4.69446V21.0556H20.6667V16.1945C20.6667 15.9275 20.8197 15.6842 21.0603 15.5685Z"\n  />\n</svg>\n';
const __vite_glob_0_8 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M11.5862 15.9288L23.6863 3.82872C24.1046 3.41034 24.1046 2.73206 23.6863 2.31369C23.2678 1.89544 22.5896 1.89544 22.1712 2.31369L9.31369 15.1712C8.89544 15.5896 8.89544 16.2679 9.31369 16.6863L22.1712 29.5438C22.5969 29.9549 23.2752 29.9431 23.6863 29.5175C24.0872 29.1022 24.0872 28.444 23.6863 28.0288L11.5862 15.9288Z"\n  />\n</svg>\n';
const __vite_glob_0_9 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M21.4138 15.9157L9.31373 28.0158C8.89542 28.4341 8.89542 29.1124 9.31373 29.5308C9.73217 29.949 10.4104 29.949 10.8288 29.5308L23.6863 16.6732C24.1046 16.2549 24.1046 15.5766 23.6863 15.1582L10.8288 2.30065C10.4031 1.88956 9.72482 1.90136 9.31373 2.32702C8.91275 2.74225 8.91275 3.40051 9.31373 3.81568L21.4138 15.9157Z"\n    fill="currentColor"\n  />\n</svg>\n';
const __vite_glob_0_10 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M15.5002 20H15.4942C15.3572 20.0002 15.2226 19.9643 15.1039 19.8958C14.9852 19.8273 14.8867 19.7287 14.8182 19.61L11.1102 13.17C11.0382 13.0527 11 12.9177 11 12.78C11 12.6423 11.0382 12.5073 11.1102 12.39C11.1775 12.2719 11.2748 12.1736 11.3923 12.1051C11.5098 12.0366 11.6433 12.0003 11.7792 12H19.2192C19.3566 11.999 19.4918 12.0344 19.6112 12.1024C19.7305 12.1705 19.8298 12.2689 19.8989 12.3876C19.968 12.5064 20.0045 12.6413 20.0047 12.7786C20.005 12.916 19.9689 13.051 19.9002 13.17L16.1762 19.61C16.1077 19.7287 16.0092 19.8272 15.8905 19.8956C15.7718 19.9641 15.6372 20.0001 15.5002 20Z"\n  />\n</svg>\n';
const __vite_glob_0_11 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M12 15.5002L12 15.4942C11.9998 15.3572 12.0357 15.2226 12.1042 15.1039C12.1727 14.9852 12.2713 14.8867 12.39 14.8182L18.83 11.1102C18.9473 11.0382 19.0823 11 19.22 11C19.3577 11 19.4927 11.0382 19.61 11.1102C19.7281 11.1775 19.8264 11.2748 19.8949 11.3923C19.9634 11.5098 19.9997 11.6433 20 11.7792L20 19.2192C20.001 19.3566 19.9656 19.4918 19.8976 19.6112C19.8295 19.7305 19.7311 19.8298 19.6124 19.8989C19.4936 19.968 19.3587 20.0045 19.2214 20.0047C19.084 20.005 18.949 19.9689 18.83 19.9002L12.39 16.1762C12.2713 16.1077 12.1728 16.0092 12.1044 15.8905C12.0359 15.7718 11.9999 15.6372 12 15.5002Z"\n  />\n</svg>\n';
const __vite_glob_0_12 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M20 15.4998V15.5058C20.0002 15.6428 19.9643 15.7774 19.8958 15.8961C19.8273 16.0148 19.7287 16.1133 19.61 16.1818L13.17 19.8898C13.0527 19.9618 12.9177 20 12.78 20C12.6423 20 12.5073 19.9618 12.39 19.8898C12.2719 19.8225 12.1736 19.7252 12.1051 19.6077C12.0366 19.4902 12.0003 19.3567 12 19.2208L12 11.7808C11.999 11.6434 12.0344 11.5082 12.1024 11.3888C12.1705 11.2695 12.2689 11.1702 12.3876 11.1011C12.5064 11.032 12.6413 10.9955 12.7786 10.9952C12.916 10.995 13.051 11.0311 13.17 11.0998L19.61 14.8238C19.7287 14.8923 19.8272 14.9908 19.8956 15.1095C19.9641 15.2281 20.0001 15.3627 20 15.4998Z"\n  />\n</svg>\n';
const __vite_glob_0_13 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M15.5045 12H15.5105C15.6475 11.9998 15.7822 12.0357 15.9009 12.1042C16.0196 12.1727 16.1181 12.2713 16.1865 12.39L19.8945 18.83C19.9666 18.9473 20.0048 19.0823 20.0048 19.22C20.0048 19.3577 19.9666 19.4927 19.8945 19.61C19.8272 19.7281 19.7299 19.8264 19.6125 19.8949C19.495 19.9634 19.3615 19.9997 19.2255 20H11.7855C11.6481 20.001 11.5129 19.9656 11.3936 19.8976C11.2743 19.8295 11.175 19.7311 11.1059 19.6124C11.0368 19.4936 11.0003 19.3587 11 19.2214C10.9998 19.084 11.0358 18.949 11.1045 18.83L14.8285 12.39C14.897 12.2713 14.9956 12.1728 15.1142 12.1044C15.2329 12.0359 15.3675 11.9999 15.5045 12Z"\n  />\n</svg>\n';
const __vite_glob_0_14 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M20.0603 10.0685C20.3009 9.95291 20.5865 9.98542 20.7949 10.1522L27.7394 15.7077C27.9041 15.8395 28 16.039 28 16.25C28 16.461 27.9041 16.6605 27.7394 16.7923L20.7949 22.3478C20.5865 22.5146 20.3009 22.5471 20.0603 22.4315C19.8197 22.3158 19.6667 22.0725 19.6667 21.8056V16.9445H3.69446V15.5556H19.6667V10.6945C19.6667 10.4275 19.8197 10.1842 20.0603 10.0685ZM21.0556 12.1393V20.3607L26.1939 16.25L21.0556 12.1393Z"\n  />\n  <path d="M4.39 11L4.39 21L3 21L3 11L4.39 11Z" />\n</svg>\n';
const __vite_glob_0_15 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M20.0603 10.0685C20.3009 9.95291 20.5865 9.98542 20.7949 10.1522L27.7394 15.7077C27.9041 15.8395 28 16.039 28 16.25C28 16.461 27.9041 16.6605 27.7394 16.7923L20.7949 22.3478C20.5865 22.5146 20.3009 22.5471 20.0603 22.4315C19.8197 22.3158 19.6667 22.0725 19.6667 21.8056V16.9445H3.69446V15.5556H19.6667V10.6945C19.6667 10.4275 19.8197 10.1842 20.0603 10.0685Z"\n  />\n  <path d="M4.39 11L4.39 21L3 21L3 11L4.39 11Z" />\n</svg>\n';
const __vite_glob_0_16 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M17.4736 24.5225L23.9889 18.0071L22.7674 16.7869L16.8575 22.6968L16.8575 7L15.1314 7L15.1314 22.6968L9.22152 16.7869L8 18.0071L14.5153 24.5225C14.908 24.9139 15.4399 25.1337 15.9945 25.1337C16.549 25.1337 17.0809 24.9139 17.4736 24.5225Z"\n  />\n</svg>\n';
const __vite_glob_0_17 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M7.61127 17.4737L14.1266 23.989L15.3468 22.7675L9.43694 16.8576H25.1337V15.1315L9.43694 15.1315L15.3468 9.22163L14.1266 8.00011L7.61127 14.5154C7.21981 14.9081 7 15.4401 7 15.9946C7 16.5491 7.21981 17.081 7.61127 17.4737Z"\n  />\n</svg>\n';
const __vite_glob_0_18 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.3887 14.5153L17.8734 8L16.6532 9.22152L22.5631 15.1314H6.86626V16.8575H22.5631L16.6532 22.7674L17.8734 23.9889L24.3887 17.4736C24.7802 17.0809 25 16.549 25 15.9945C25 15.4399 24.7802 14.908 24.3887 14.5153Z"\n  />\n</svg>\n';
const __vite_glob_0_19 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M14.5153 7.61127L8 14.1266L9.22152 15.3468L15.1314 9.43694V25.1337H16.8575V9.43694L22.7674 15.3468L23.9889 14.1266L17.4736 7.61127C17.0809 7.21981 16.549 7 15.9945 7C15.4399 7 14.908 7.21981 14.5153 7.61127Z"\n  />\n</svg>\n';
const __vite_glob_0_20 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path d="M4.6511 8H3.3501V24H4.6511V8Z" />\n  <path d="M16.6511 8H15.3501V24H16.6511V8Z" />\n  <path d="M28.6511 8H27.3501V24H28.6511V8Z" />\n  <path d="M8.6511 8H7.3501V19H8.6511V8Z" />\n  <path d="M12.6511 8H11.3501V19H12.6511V8Z" />\n  <path d="M20.6511 8H19.3501V19H20.6511V8Z" />\n  <path d="M24.6511 8H23.3501V19H24.6511V8Z" />\n  <path d="M8.6511 22H7.3501V24H8.6511V22Z" />\n  <path d="M12.6511 22H11.3501V24H12.6511V22Z" />\n  <path d="M20.6511 22H19.3501V24H20.6511V22Z" />\n  <path d="M24.6511 22H23.3501V24H24.6511V22Z" />\n</svg>\n';
const __vite_glob_0_21 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M3.5 6.5H22.1842V12.0526H21.1842V7.5H4.5V24.1842H21.1842V19.6316H22.1842V25.1842H3.5V6.5Z"\n  />\n  <path\n    d="M28 15.5803H26.2128C26.141 14.9592 25.8197 14.3844 25.3107 13.9663C24.8017 13.5482 24.1411 13.3165 23.4559 13.3158H20.0354C19.3501 13.3164 18.6894 13.5481 18.1803 13.9662C17.6712 14.3842 17.3498 14.9592 17.278 15.5803H15.3684V16.104H17.278C17.3498 16.7251 17.6712 17.3 18.1803 17.7181C18.6894 18.1361 19.3501 18.3678 20.0354 18.3684H23.4559C24.1411 18.3677 24.8017 18.136 25.3107 17.7179C25.8197 17.2999 26.141 16.725 26.2128 16.104H28V15.5803ZM23.4559 17.8451H20.0354C19.5042 17.8431 18.9919 17.6655 18.5936 17.3453C18.1953 17.0251 17.9379 16.584 17.8694 16.104H19.7348V15.5803H17.8694C17.9379 15.1002 18.1953 14.6591 18.5936 14.3389C18.9919 14.0187 19.5042 13.8411 20.0354 13.8391H23.4559C23.987 13.8411 24.4993 14.0187 24.8977 14.3389C25.296 14.6591 25.5533 15.1002 25.6218 15.5803H23.8793V16.104H25.6218C25.5533 16.584 25.296 17.0251 24.8977 17.3453C24.4993 17.6655 23.987 17.8431 23.4559 17.8451Z"\n  />\n</svg>\n';
const __vite_glob_0_22 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M26 4.39197H5.99997C5.29739 4.39276 4.62381 4.67221 4.12701 5.16901C3.63021 5.66581 3.35077 6.33939 3.34998 7.04197V25.042C3.35077 25.7445 3.63025 26.4179 4.12708 26.9146C4.6239 27.4112 5.29748 27.6904 5.99997 27.691H26C26.7025 27.6904 27.376 27.4112 27.8729 26.9146C28.3697 26.4179 28.6492 25.7445 28.65 25.042V7.04197C28.6492 6.33939 28.3697 5.66581 27.8729 5.16901C27.3761 4.67221 26.7025 4.39276 26 4.39197ZM19.352 5.69197V26.392H12.652V5.69197H19.352ZM4.65198 25.043V7.04297C4.65224 6.68492 4.79452 6.34159 5.04761 6.08831C5.3007 5.83503 5.64393 5.6925 6.00198 5.69197H11.351V26.392H5.99997C5.64209 26.3914 5.29902 26.249 5.04596 25.996C4.7929 25.7429 4.65049 25.3999 4.64996 25.042L4.65198 25.043ZM27.352 25.043C27.3514 25.4008 27.2091 25.7439 26.956 25.997C26.7029 26.25 26.3599 26.3924 26.002 26.393H20.654V5.69297H26C26.358 5.6935 26.7013 5.83604 26.9543 6.08932C27.2074 6.34259 27.3497 6.68591 27.35 7.04397L27.352 25.043Z"\n  />\n  <path d="M10.28 8.55896H5.70801V9.85896H10.28V8.55896Z" />\n  <path d="M10.28 12.017H5.70801V13.317H10.28V12.017Z" />\n  <path d="M10.28 15.475H5.70801V16.775H10.28V15.475Z" />\n  <path d="M26.28 8.55896H21.708V9.85896H26.28V8.55896Z" />\n  <path d="M26.28 12.017H21.708V13.317H26.28V12.017Z" />\n  <path d="M26.28 15.475H21.708V16.775H26.28V15.475Z" />\n  <path d="M26.28 18.934H21.708V20.234H26.28V18.934Z" />\n  <path d="M18.28 8.55896H13.708V9.85896H18.28V8.55896Z" />\n  <path d="M18.28 12.017H13.708V13.317H18.28V12.017Z" />\n</svg>\n';
const __vite_glob_0_23 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M26 4.39197H5.99997C5.29739 4.39276 4.62381 4.67221 4.12701 5.16901C3.63021 5.66581 3.35077 6.33939 3.34998 7.04197V25.042C3.35077 25.7445 3.63025 26.4179 4.12708 26.9146C4.6239 27.4112 5.29748 27.6904 5.99997 27.691H26C26.7025 27.6904 27.376 27.4112 27.8729 26.9146C28.3697 26.4179 28.6492 25.7445 28.65 25.042V7.04197C28.6492 6.33939 28.3697 5.66581 27.8729 5.16901C27.3761 4.67221 26.7025 4.39276 26 4.39197ZM5.70798 8.55897H10.28V9.85897H5.70798V8.55897ZM5.70798 12.017H10.28V13.317H5.70798V12.017ZM10.28 15.475H5.70798V16.775H10.28V15.475ZM21.708 8.55897H26.28V9.85897H21.708V8.55897ZM21.708 12.017H26.28V13.317H21.708V12.017ZM26.28 15.475H21.708V16.775H26.28V15.475ZM21.708 18.934H26.28V20.234H21.708V18.934ZM18.28 8.55897H13.708V9.85897H18.28V8.55897ZM18.28 12.017H13.708V13.317H18.28V12.017Z"\n  />\n</svg>\n';
const __vite_glob_0_24 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M7.68991 21C7.4604 20.9999 7.24023 20.9131 7.0773 20.7586L3 16.9204L4.22655 15.7317L7.66439 18.9704L15.4751 11L16.75 12.1412L8.32669 20.7355C8.24698 20.8166 8.15115 20.8816 8.0448 20.9268C7.93845 20.972 7.82374 20.9964 7.70737 20.9987L7.68991 21Z"\n  />\n  <path\n    d="M20.8457 11L19.75 12.0956L28.6543 20.9992L29.75 19.9036L20.8457 11Z"\n  />\n  <path\n    d="M28.6543 11.0008L19.75 19.9044L20.8457 21L29.75 12.0964L28.6543 11.0008Z"\n  />\n</svg>\n';
const __vite_glob_0_25 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M25.9508 15.6733V11.4484C25.9534 11.3403 25.9129 11.2359 25.8382 11.1577C25.7634 11.0798 25.6608 11.0347 25.5527 11.0328H16.3572V9.17874C17.4284 8.99495 18.1851 8.02798 18.1062 6.94399C18.0272 5.86001 17.1382 5.01283 16.0516 4.98612C14.9652 4.95941 14.0357 5.76193 13.9036 6.84074C13.7716 7.91954 14.4799 8.92239 15.5407 9.1588V11.0328H6.44724C6.3392 11.0347 6.23654 11.0798 6.16179 11.1577C6.08724 11.2359 6.04657 11.3403 6.04917 11.4484V15.6733C4.86173 15.8927 4 16.9283 4 18.1359C4 19.3432 4.86173 20.379 6.04917 20.5982V26.5713C6.04917 26.7968 6.22179 27.0051 6.44724 27.0051H25.5527C25.7782 27.0051 25.9508 26.7968 25.9508 26.5713V20.5982C27.1382 20.379 28 19.3432 28 18.1359C28 16.9283 27.1382 15.8927 25.9508 15.6733ZM14.7045 7.09768C14.7045 6.38207 15.2846 5.802 16 5.802C16.7156 5.802 17.2955 6.38207 17.2955 7.09768C17.2955 7.81309 16.7156 8.39316 16 8.39316C15.2848 8.39236 14.7053 7.81289 14.7045 7.09768ZM4.81648 18.1361C4.81588 17.3788 5.32 16.714 6.04917 16.5105V19.761C5.3202 19.5575 4.81608 18.8929 4.81648 18.1361ZM25.1343 26.1886H6.86564V11.8492H25.1343V26.1886ZM25.9508 19.761V16.5105C26.6796 16.7148 27.1833 17.379 27.1833 18.1359C27.1833 18.8925 26.6796 19.5569 25.9508 19.761Z"\n  />\n  <path\n    d="M21.154 19.963C21.154 19.7375 20.9712 19.5547 20.7457 19.5547H11.2542C11.0287 19.5547 10.8459 19.7375 10.8459 19.963V24.1474C10.8459 24.3729 11.0287 24.5557 11.2542 24.5557H20.7457C20.9712 24.5557 21.154 24.3729 21.154 24.1474V19.963ZM20.3375 20.3712V21.647H11.6624V20.3712H20.3375ZM11.6624 23.7392V22.4634H20.3375V23.7392H11.6624Z"\n  />\n  <path\n    d="M13.9078 14.86C13.9078 14.6346 13.725 14.4518 13.4995 14.4518H10.795C10.5695 14.4518 10.3867 14.6346 10.3867 14.86V17.5646C10.3867 17.79 10.5695 17.9728 10.795 17.9728H13.4995C13.725 17.9728 13.9078 17.79 13.9078 17.5646V14.86ZM11.2032 15.2682H13.0913V17.1563H11.2032V15.2682Z"\n  />\n  <path\n    d="M21.6132 14.86C21.6132 14.6346 21.4304 14.4518 21.205 14.4518H18.5004C18.275 14.4518 18.0922 14.6346 18.0922 14.86V17.5646C18.0922 17.79 18.275 17.9728 18.5004 17.9728H21.205C21.4304 17.9728 21.6132 17.79 21.6132 17.5646V14.86ZM18.9086 15.2682H20.7967V17.1563H18.9086V15.2682Z"\n  />\n</svg>\n';
const __vite_glob_0_26 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M12.709 14.949h13.41v1.98h-13.41v-1.98zM12.709 21.821h13.41v1.98h-13.41v-1.98zM12.709 8.198h13.41v1.981h-13.41v-1.98zM5.882 8.198h3.017v1.981H5.882v-1.98zM5.882 14.949h3.017v1.98H5.882v-1.98zM5.882 21.821h3.017v1.98H5.882v-1.98z"\n  />\n</svg>\n';
const __vite_glob_0_27 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M28.952 0H3.048A3.048 3.048 0 000 3.048v25.904A3.048 3.048 0 003.048 32h25.904A3.048 3.048 0 0032 28.952V3.048A3.048 3.048 0 0028.952 0zM8.9 23.802H5.851V21.82H8.9v1.98zm0-6.872H5.851v-1.981H8.9v1.98zm0-6.751H5.851v-1.98H8.9v1.98zm17.22 13.623h-13.41V21.82h13.41v1.98zm0-6.872h-13.41v-1.981h13.41v1.98zm0-6.751h-13.41v-1.98h13.41v1.98z"\n  />\n</svg>\n';
const __vite_glob_0_28 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.774 2.43201H7.28903C6.58645 2.4328 5.91288 2.71225 5.41608 3.20905C4.91928 3.70584 4.63983 4.37942 4.63904 5.082V26.9C4.63983 27.6026 4.91928 28.2761 5.41608 28.7729C5.91288 29.2697 6.58645 29.5492 7.28903 29.55H24.774C25.4766 29.5492 26.1502 29.2697 26.647 28.7729C27.1438 28.2761 27.4232 27.6026 27.424 26.9V5.082C27.4232 4.37942 27.1438 3.70584 26.647 3.20905C26.1502 2.71225 25.4766 2.4328 24.774 2.43201ZM7.28903 3.73199H24.774C25.1321 3.73226 25.4754 3.87455 25.7287 4.12764C25.982 4.38073 26.1245 4.72395 26.125 5.082V14.482H5.93903V5.082C5.93929 4.72404 6.08162 4.38082 6.33473 4.1277C6.58785 3.87458 6.93107 3.73226 7.28903 3.73199ZM20.753 15.781V19.066H16.684V15.781H20.753ZM15.384 19.066H11.314V15.781H15.384V19.066ZM10.015 19.066H5.93903V15.781H10.015V19.066ZM10.015 20.366V23.651H5.93903V20.366H10.015ZM11.315 20.366H15.385V23.651H11.315V20.366ZM15.385 24.951V28.251H11.315V24.951H15.385ZM16.685 24.951H20.754V28.251H16.685V24.951ZM16.685 23.651V20.366H20.754V23.651H16.685ZM22.054 20.366H26.126V23.651H22.054V20.366ZM22.054 19.066V15.781H26.126V19.066H22.054ZM5.93903 26.9V24.946H10.015V28.246H7.28903C6.93176 28.2457 6.58914 28.104 6.33614 27.8517C6.08313 27.5995 5.94035 27.2573 5.93903 26.9ZM24.774 28.25H22.053V24.95H26.125V26.9C26.1254 27.0777 26.0908 27.2538 26.0231 27.4181C25.9554 27.5824 25.8559 27.7317 25.7305 27.8576C25.605 27.9834 25.4559 28.0833 25.2918 28.1515C25.1277 28.2197 24.9517 28.2549 24.774 28.255V28.25Z"\n  />\n  <path\n    d="M23.4931 11.943C23.9638 11.9431 24.4287 11.8385 24.8541 11.637L24.4281 10.737C23.972 10.9539 23.4547 11.0056 22.9648 10.8832C22.4748 10.7608 22.0426 10.4719 21.7421 10.066H23.0071V9.066H21.3241C21.3058 8.96056 21.2951 8.85396 21.2921 8.74699C21.2921 8.684 21.3051 8.624 21.3111 8.562H23.6001V7.562H21.6401C21.8385 7.25129 22.1118 6.99543 22.4349 6.8179C22.7579 6.64037 23.1204 6.54688 23.4891 6.54601C23.8126 6.54597 24.132 6.61805 24.4241 6.757L24.8501 5.857C24.425 5.65447 23.96 5.54959 23.4891 5.55C22.8497 5.55118 22.2254 5.74385 21.6965 6.10318C21.1677 6.46251 20.7587 6.97201 20.5221 7.566H19.6001V8.566H20.3061C20.3061 8.628 20.2871 8.68801 20.2871 8.75101C20.2922 8.85783 20.3028 8.96431 20.3191 9.07001H19.6001V10.07H20.5791C20.8338 10.629 21.244 11.1028 21.7607 11.4349C22.2775 11.767 22.8788 11.9434 23.4931 11.943Z"\n  />\n  <path\n    d="M17.152 11.943C17.6227 11.943 18.0876 11.8385 18.513 11.637L18.087 10.737C17.6309 10.9537 17.1136 11.0053 16.6237 10.8829C16.1338 10.7605 15.7016 10.4718 15.401 10.066H16.667V9.066H14.983C14.9647 8.96056 14.954 8.85396 14.951 8.74699C14.951 8.684 14.965 8.624 14.97 8.562H17.263V7.562H15.3C15.4984 7.25129 15.7717 6.99543 16.0947 6.8179C16.4178 6.64037 16.7803 6.54688 17.149 6.54601C17.4724 6.54597 17.7919 6.61805 18.084 6.757L18.511 5.857C18.0855 5.65459 17.6202 5.54971 17.149 5.55C16.5096 5.55118 15.8853 5.74385 15.3564 6.10318C14.8276 6.46251 14.4185 6.97201 14.182 7.566H13.262V8.566H13.967C13.967 8.628 13.948 8.68801 13.948 8.75101C13.948 8.86001 13.97 8.96401 13.98 9.07001H13.262V10.07H14.24C14.4946 10.6286 14.9044 11.1023 15.4208 11.4344C15.9371 11.7665 16.5381 11.943 17.152 11.943Z"\n  />\n  <path\n    d="M10.8111 11.943C11.2818 11.9431 11.7467 11.8385 12.1721 11.637L11.7461 10.737C11.29 10.9537 10.7728 11.0053 10.2828 10.8829C9.79291 10.7605 9.3607 10.4718 9.06009 10.066H10.3251V9.066H8.64209C8.62381 8.96056 8.61312 8.85396 8.61009 8.74699C8.61009 8.684 8.62309 8.624 8.62909 8.562H10.9221V7.562H8.9621C9.24795 7.11117 9.68881 6.78047 10.2016 6.63219C10.7144 6.48391 11.2638 6.5283 11.7461 6.757L12.1721 5.857C11.747 5.65447 11.282 5.54959 10.8111 5.55C10.1716 5.55098 9.547 5.74357 9.01797 6.10291C8.48895 6.46225 8.07972 6.97185 7.84309 7.566H6.9231V8.566H7.62909C7.62909 8.628 7.61009 8.68801 7.61009 8.75101C7.61516 8.85783 7.62584 8.96431 7.64209 9.07001H6.9231V10.07H7.90208C8.15645 10.6282 8.56589 11.1015 9.08163 11.4335C9.59738 11.7656 10.1977 11.9424 10.8111 11.943Z"\n  />\n</svg>\n';
const __vite_glob_0_29 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M26.23 5.78h-2.29V3.15h-1.3v2.63H9.36V3.15h-1.3v2.63H5.77a2.65 2.65 0 0 0-2.65 2.65V26.2a2.65 2.65 0 0 0 2.65 2.65h20.46a2.65 2.65 0 0 0 2.65-2.65V8.43a2.65 2.65 0 0 0-2.65-2.65ZM5.77 7.08h20.46a1.35 1.35 0 0 1 1.35 1.35v2.93H4.42V8.43a1.35 1.35 0 0 1 1.35-1.35Zm20.46 20.47H5.77a1.34 1.34 0 0 1-1.35-1.35V12.66h23.16V26.2a1.34 1.34 0 0 1-1.35 1.35Z"\n  />\n  <path\n    d="M14.32 15.45h3.35v1.3h-3.35zM21.11 15.45h3.35v1.3h-3.35zM14.32 19.44h3.35v1.3h-3.35zM7.54 19.44h3.35v1.3H7.54zM21.11 19.44h3.35v1.3h-3.35zM14.32 23.44h3.35v1.3h-3.35zM7.54 23.44h3.35v1.3H7.54zM21.11 23.44h3.35v1.3h-3.35z"\n  />\n</svg>\n';
const __vite_glob_0_30 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M26.23,5.78H23.94V3.15h-1.3V5.78H9.36V3.15H8.06V5.78H5.77A2.65,2.65,0,0,0,3.12,8.43V26.2a2.65,2.65,0,0,0,2.65,2.65H26.23a2.65,2.65,0,0,0,2.65-2.65V8.43a2.65,2.65,0,0,0-2.65-2.65Zm-15.34,19H7.54v-1.3h3.35Zm0-4H7.54v-1.3h3.35Zm6.79,4H14.32v-1.3h3.36Zm0-4H14.32v-1.3h3.36Zm0-4H14.32v-1.3h3.36Zm6.78,8H21.11v-1.3h3.35Zm0-4H21.11v-1.3h3.35Zm0-4H21.11v-1.3h3.35Zm3.12-5.39H4.42V8.43A1.35,1.35,0,0,1,5.77,7.08H26.23a1.35,1.35,0,0,1,1.35,1.35Z"\n  />\n  <path\n    d="M26.23,5.78H23.94V3.15h-1.3V5.78H9.36V3.15H8.06V5.78H5.77A2.65,2.65,0,0,0,3.12,8.43V26.2a2.65,2.65,0,0,0,2.65,2.65H26.23a2.65,2.65,0,0,0,2.65-2.65V8.43a2.65,2.65,0,0,0-2.65-2.65ZM5.77,7.08H26.23a1.35,1.35,0,0,1,1.35,1.35v2.93H4.42V8.43A1.35,1.35,0,0,1,5.77,7.08ZM26.23,27.55H5.77A1.34,1.34,0,0,1,4.42,26.2V12.66H27.58V26.2a1.34,1.34,0,0,1-1.35,1.35Z"\n  />\n</svg>\n';
const __vite_glob_0_31 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M26.137 27.292H5.86297C5.20253 27.2899 4.56975 27.0265 4.10284 26.5594C3.63593 26.0923 3.37282 25.4594 3.37097 24.799V10.509C3.37308 9.84873 3.63631 9.21611 4.1032 8.74922C4.57008 8.28234 5.2027 8.01911 5.86297 8.017H9.38597V7.2C9.38782 6.53955 9.65093 5.90668 10.1178 5.43958C10.5848 4.97248 11.2175 4.70911 11.878 4.707H20.122C20.7824 4.70911 21.4152 4.97248 21.8821 5.43958C22.349 5.90668 22.6121 6.53955 22.614 7.2V8.01601H26.137C26.7972 8.01812 27.4299 8.28133 27.8968 8.74821C28.3636 9.2151 28.6269 9.84772 28.629 10.508V24.8C28.6269 25.4603 28.3636 26.0929 27.8968 26.5598C27.4299 27.0267 26.7972 27.2899 26.137 27.292ZM5.86297 9.31599C5.54714 9.31783 5.24476 9.44412 5.02142 9.66745C4.79809 9.89078 4.67181 10.1932 4.66997 10.509V24.8C4.67181 25.1158 4.79809 25.4182 5.02142 25.6416C5.24476 25.8649 5.54714 25.9912 5.86297 25.993H26.137C26.4528 25.9912 26.7552 25.8649 26.9785 25.6416C27.2019 25.4182 27.3281 25.1158 27.33 24.8V10.51C27.3281 10.1942 27.2019 9.89179 26.9785 9.66846C26.7552 9.44512 26.4528 9.31884 26.137 9.317H21.964C21.7918 9.317 21.6266 9.24865 21.5047 9.12697C21.3828 9.00529 21.3142 8.84022 21.314 8.668V7.2C21.3137 6.88385 21.1881 6.58072 20.9646 6.35707C20.7412 6.13343 20.4381 6.00753 20.122 6.007H11.878C11.5618 6.00753 11.2588 6.13343 11.0353 6.35707C10.8119 6.58072 10.6862 6.88385 10.686 7.2V8.666C10.6857 8.83822 10.6171 9.00329 10.4952 9.12497C10.3734 9.24665 10.2082 9.315 10.036 9.315L5.86297 9.31599Z"\n  />\n  <path\n    d="M7.77693 13.765C8.47778 13.765 9.04593 13.1968 9.04593 12.496C9.04593 11.7951 8.47778 11.227 7.77693 11.227C7.07609 11.227 6.50793 11.7951 6.50793 12.496C6.50793 13.1968 7.07609 13.765 7.77693 13.765Z"\n  />\n  <path\n    d="M16.3 24.436C15.1486 24.436 14.0229 24.0945 13.0655 23.4548C12.1081 22.8151 11.3619 21.9058 10.9212 20.842C10.4806 19.7781 10.3653 18.6075 10.5899 17.4782C10.8145 16.3488 11.369 15.3114 12.1833 14.4972C12.9975 13.683 14.0349 13.1285 15.1642 12.9039C16.2936 12.6792 17.4642 12.7945 18.528 13.2352C19.5918 13.6758 20.5011 14.422 21.1408 15.3795C21.7806 16.3369 22.122 17.4625 22.122 18.614C22.1204 20.1576 21.5065 21.6375 20.4151 22.729C19.3236 23.8205 17.8436 24.4344 16.3 24.436ZM16.3 14.092C15.4057 14.092 14.5314 14.3572 13.7877 14.8541C13.0441 15.351 12.4645 16.0572 12.1222 16.8835C11.78 17.7098 11.6904 18.619 11.8649 19.4962C12.0394 20.3734 12.4701 21.1791 13.1025 21.8115C13.7349 22.4439 14.5406 22.8746 15.4178 23.0491C16.295 23.2236 17.2042 23.134 18.0305 22.7918C18.8568 22.4495 19.5631 21.8699 20.0599 21.1263C20.5568 20.3826 20.822 19.5084 20.822 18.614C20.8204 17.4152 20.3435 16.2659 19.4958 15.4182C18.6481 14.5705 17.4989 14.0936 16.3 14.092Z"\n  />\n  <path\n    d="M16.2999 22.057C15.619 22.057 14.9533 21.8551 14.3871 21.4767C13.8209 21.0984 13.3796 20.5607 13.119 19.9316C12.8584 19.3024 12.7902 18.6102 12.9231 17.9423C13.0559 17.2744 13.3839 16.6609 13.8654 16.1794C14.3469 15.6979 14.9604 15.37 15.6282 15.2371C16.2961 15.1043 16.9884 15.1725 17.6175 15.4331C18.2466 15.6937 18.7844 16.135 19.1627 16.7012C19.541 17.2674 19.7429 17.933 19.7429 18.614C19.7421 19.5269 19.3791 20.4022 18.7336 21.0477C18.0881 21.6932 17.2128 22.0562 16.2999 22.057ZM16.2999 16.471C15.8761 16.471 15.4618 16.5967 15.1093 16.8321C14.7569 17.0676 14.4823 17.4023 14.3201 17.7939C14.1579 18.1855 14.1154 18.6164 14.1981 19.0321C14.2808 19.4478 14.4849 19.8296 14.7846 20.1293C15.0843 20.429 15.4662 20.6331 15.8819 20.7158C16.2976 20.7985 16.7284 20.7561 17.12 20.5939C17.5116 20.4317 17.8463 20.157 18.0818 19.8046C18.3173 19.4522 18.4429 19.0378 18.4429 18.614C18.4424 18.0458 18.2165 17.501 17.8147 17.0993C17.4129 16.6975 16.8681 16.4715 16.2999 16.471Z"\n  />\n  <path d="M25.528 10.857H21.611V12.157H25.528V10.857Z" />\n</svg>\n';
const __vite_glob_0_32 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M26.137 27.292H5.86297C5.20253 27.2899 4.56975 27.0265 4.10284 26.5594C3.63593 26.0923 3.37282 25.4594 3.37097 24.799V10.509C3.37308 9.84873 3.63631 9.21611 4.1032 8.74922C4.57008 8.28234 5.2027 8.01911 5.86297 8.017H9.38597V7.2C9.38782 6.53955 9.65093 5.90668 10.1178 5.43958C10.5848 4.97248 11.2175 4.70911 11.878 4.707H20.122C20.7824 4.70911 21.4152 4.97248 21.8821 5.43958C22.349 5.90668 22.6121 6.53955 22.614 7.2V8.01601H26.137C26.7972 8.01812 27.4299 8.28133 27.8968 8.74821C28.3636 9.2151 28.6269 9.84772 28.629 10.508V24.8C28.6269 25.4603 28.3636 26.0929 27.8968 26.5598C27.4299 27.0267 26.7972 27.2899 26.137 27.292ZM25.528 10.857H21.611V12.157H25.528V10.857ZM7.777 13.765C8.47785 13.765 9.046 13.1969 9.046 12.496C9.046 11.7952 8.47785 11.227 7.777 11.227C7.07615 11.227 6.508 11.7952 6.508 12.496C6.508 13.1969 7.07615 13.765 7.777 13.765ZM16.3 24.436C15.1485 24.436 14.0229 24.0945 13.0654 23.4548C12.108 22.8151 11.3618 21.9058 10.9211 20.842C10.4805 19.7781 10.3652 18.6075 10.5898 17.4782C10.8145 16.3488 11.369 15.3114 12.1832 14.4972C12.9974 13.683 14.0348 13.1285 15.1642 12.9039C16.2935 12.6792 17.4641 12.7945 18.528 13.2352C19.5918 13.6758 20.5011 14.422 21.1408 15.3795C21.7805 16.3369 22.122 17.4625 22.122 18.614C22.1204 20.1576 21.5065 21.6375 20.415 22.729C19.3235 23.8205 17.8436 24.4344 16.3 24.436ZM16.3 14.092C15.4056 14.092 14.5313 14.3572 13.7877 14.8541C13.044 15.351 12.4644 16.0572 12.1222 16.8835C11.7799 17.7098 11.6904 18.619 11.8649 19.4962C12.0393 20.3734 12.47 21.1791 13.1024 21.8115C13.7348 22.4439 14.5406 22.8746 15.4178 23.0491C16.295 23.2236 17.2042 23.134 18.0305 22.7918C18.8568 22.4495 19.563 21.8699 20.0599 21.1263C20.5568 20.3826 20.822 19.5084 20.822 18.614C20.8204 17.4152 20.3434 16.2659 19.4958 15.4182C18.6481 14.5705 17.4988 14.0936 16.3 14.092ZM14.3872 21.4767C14.9534 21.8551 15.619 22.057 16.3 22.057C17.2129 22.0562 18.0882 21.6932 18.7337 21.0477C19.3792 20.4022 19.7422 19.5269 19.743 18.614C19.743 17.933 19.5411 17.2674 19.1627 16.7012C18.7844 16.135 18.2467 15.6937 17.6176 15.4331C16.9884 15.1725 16.2962 15.1043 15.6283 15.2371C14.9604 15.37 14.3469 15.6979 13.8654 16.1794C13.3839 16.6609 13.056 17.2744 12.9232 17.9423C12.7903 18.6102 12.8585 19.3024 13.1191 19.9316C13.3797 20.5607 13.821 21.0984 14.3872 21.4767ZM15.1094 16.8321C15.4618 16.5967 15.8762 16.471 16.3 16.471C16.8682 16.4715 17.413 16.6975 17.8147 17.0993C18.2165 17.501 18.4425 18.0458 18.443 18.614C18.443 19.0378 18.3173 19.4522 18.0818 19.8046C17.8464 20.157 17.5117 20.4317 17.1201 20.5939C16.7285 20.7561 16.2976 20.7985 15.8819 20.7158C15.4662 20.6331 15.0844 20.429 14.7847 20.1293C14.485 19.8296 14.2809 19.4478 14.1982 19.0321C14.1155 18.6164 14.1579 18.1855 14.3201 17.7939C14.4823 17.4023 14.757 17.0676 15.1094 16.8321Z"\n  />\n</svg>\n';
const __vite_glob_0_33 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="nonzero"\n    d="M13.651 21.47c-.208-.001-.407-.083-.555-.229l-4.469-4.482 1.108-1.096 3.916 3.951 8.602-8.795 1.12 1.097-9.156 9.361c-.15.144-.347.23-.554.241l-.012-.048zM16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16c-.013 8.831-7.169 15.987-16 16zm0-30.458C8.015 1.542 1.542 8.015 1.542 16S8.015 30.458 16 30.458 30.458 23.985 30.458 16 23.985 1.542 16 1.542z"\n  />\n</svg>\n';
const __vite_glob_0_34 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16,0c8.831,0 16,7.169 16,16c0,8.831 -7.169,16 -16,16c-8.831,0 -16,-7.169 -16,-16c0,-8.831 7.169,-16 16,-16Zm-2.349,21.47l0.012,0.048c0.207,-0.011 0.404,-0.097 0.554,-0.241l9.156,-9.361l-1.12,-1.097l-8.602,8.795l-3.916,-3.951l-1.108,1.096l4.469,4.482c0.148,0.146 0.347,0.228 0.555,0.229Z"\n  />\n</svg>\n';
const __vite_glob_0_35 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="nonzero"\n    d="M15.993 31.998c-.255.002-.507-.055-.736-.167C6.28 27.363 1.381 18.039 2.117 6.286v-.319c0-.442.175-.866.486-1.18.304-.317.725-.498 1.165-.499 3.927 0 4.163-2.22 4.163-2.665C7.953.731 8.689.007 9.582 0h12.877c.903.007 1.644.748 1.651 1.651 0 .43.25 2.637 4.163 2.637.45.004.881.189 1.193.513.308.308.474.731.458 1.166v.319c.708 11.808-4.093 21.147-13.168 25.601-.239.097-.498.135-.763.111zm6.369-30.194H9.693c-.102 1.715-1.435 4.228-5.828 4.288V6.3C3.227 17.387 7.667 26.087 16.09 30.208c8.325-4.163 12.696-12.821 12.044-23.881V6.05c-4.335 0-5.656-2.585-5.772-4.246zM13.651 21.47c-.208-.001-.407-.083-.555-.229l-4.469-4.482 1.108-1.096 3.916 3.951 8.602-8.795 1.12 1.097-9.156 9.361c-.15.144-.347.23-.554.241l-.012-.048z"\n  />\n</svg>\n';
const __vite_glob_0_36 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M23 8H9C8.44772 8 8 8.44772 8 9V23C8 23.5523 8.44772 24 9 24H23C23.5523 24 24 23.5523 24 23V9C24 8.44772 23.5523 8 23 8ZM9 7C7.89543 7 7 7.89543 7 9V23C7 24.1046 7.89543 25 9 25H23C24.1046 25 25 24.1046 25 23V9C25 7.89543 24.1046 7 23 7H9Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M10.866 17.563L13.897 19.976H13.896C14.0624 20.1082 14.2732 20.1715 14.4849 20.1529C14.6967 20.1343 14.8932 20.0352 15.034 19.876L21.134 12.936L19.89 11.843L14.311 18.19L11.897 16.263L10.866 17.563Z"\n  />\n</svg>\n';
const __vite_glob_0_37 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M25.7556 4.42222H5.84444C5.05897 4.42222 4.42222 5.05897 4.42222 5.84444V25.7556C4.42222 26.541 5.05897 27.1778 5.84444 27.1778H25.7556C26.541 27.1778 27.1778 26.541 27.1778 25.7556V5.84444C27.1778 5.05897 26.541 4.42222 25.7556 4.42222ZM5.84444 3C4.2735 3 3 4.2735 3 5.84444V25.7556C3 27.3265 4.2735 28.6 5.84444 28.6H25.7556C27.3265 28.6 28.6 27.3265 28.6 25.7556V5.84444C28.6 4.2735 27.3265 3 25.7556 3H5.84444Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.49831 18.0229L12.8091 21.4548H12.8076C13.0443 21.6428 13.3441 21.7329 13.6452 21.7064C13.9464 21.6799 14.2259 21.539 14.4261 21.3125L23.1017 11.4423L21.3324 9.88783L13.3979 18.9147L9.96462 16.174L8.49831 18.0229Z"\n  />\n</svg>\n';
const __vite_glob_0_38 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M23 8H9C8.44772 8 8 8.44772 8 9V23C8 23.5523 8.44772 24 9 24H23C23.5523 24 24 23.5523 24 23V9C24 8.44772 23.5523 8 23 8ZM9 7C7.89543 7 7 7.89543 7 9V23C7 24.1046 7.89543 25 9 25H23C24.1046 25 25 24.1046 25 23V9C25 7.89543 24.1046 7 23 7H9Z"\n  />\n  <path d="M11 15H21V17H11V15Z" />\n</svg>\n';
const __vite_glob_0_39 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M23 8H9C8.44772 8 8 8.44772 8 9V23C8 23.5523 8.44772 24 9 24H23C23.5523 24 24 23.5523 24 23V9C24 8.44772 23.5523 8 23 8ZM9 7C7.89543 7 7 7.89543 7 9V23C7 24.1046 7.89543 25 9 25H23C24.1046 25 25 24.1046 25 23V9C25 7.89543 24.1046 7 23 7H9Z"\n  />\n</svg>\n';
const __vite_glob_0_40 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M23 8H9C8.44772 8 8 8.44772 8 9V23C8 23.5523 8.44772 24 9 24H23C23.5523 24 24 23.5523 24 23V9C24 8.44772 23.5523 8 23 8ZM9 7C7.89543 7 7 7.89543 7 9V23C7 24.1046 7.89543 25 9 25H23C24.1046 25 25 24.1046 25 23V9C25 7.89543 24.1046 7 23 7H9Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M10 9C9.44772 9 9 9.44772 9 10V22C9 22.5523 9.44772 23 10 23H22C22.5523 23 23 22.5523 23 22V10C23 9.44772 22.5523 9 22 9H10ZM10.866 17.563L13.897 19.976H13.896C14.0624 20.1082 14.2732 20.1715 14.4849 20.1529C14.6967 20.1343 14.8932 20.0352 15.034 19.876L21.134 12.936L19.89 11.843L14.311 18.19L11.897 16.263L10.866 17.563Z"\n  />\n</svg>\n';
const __vite_glob_0_41 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 29.277C13.3741 29.277 10.8071 28.4983 8.62369 27.0394C6.4403 25.5805 4.73855 23.5069 3.73365 21.0809C2.72874 18.6548 2.46582 15.9853 2.97811 13.4098C3.49041 10.8343 4.75492 8.46856 6.61174 6.61174C8.46856 4.75492 10.8343 3.49041 13.4098 2.97811C15.9853 2.46582 18.6548 2.72875 21.0809 3.73365C23.5069 4.73855 25.5805 6.4403 27.0394 8.6237C28.4983 10.8071 29.277 13.3741 29.277 16C29.273 19.5201 27.8729 22.8948 25.3839 25.3839C22.8948 27.8729 19.5201 29.273 16 29.277ZM16 4.023C13.6312 4.023 11.3155 4.72544 9.34593 6.04149C7.37633 7.35754 5.8412 9.22809 4.93469 11.4166C4.02818 13.6051 3.791 16.0133 4.25313 18.3366C4.71527 20.6599 5.85597 22.794 7.53098 24.469C9.20599 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7102 9.78039 24.4649 7.53507C22.2196 5.28975 19.1754 4.02671 16 4.023Z"\n  />\n  <path\n    d="M9.641 17.779C10.6235 17.779 11.42 16.9825 11.42 16C11.42 15.0175 10.6235 14.221 9.641 14.221C8.65849 14.221 7.862 15.0175 7.862 16C7.862 16.9825 8.65849 17.779 9.641 17.779Z"\n  />\n  <path\n    d="M16 17.779C16.9825 17.779 17.779 16.9825 17.779 16C17.779 15.0175 16.9825 14.221 16 14.221C15.0175 14.221 14.221 15.0175 14.221 16C14.221 16.9825 15.0175 17.779 16 17.779Z"\n  />\n  <path\n    d="M22.359 17.779C23.3415 17.779 24.138 16.9825 24.138 16C24.138 15.0175 23.3415 14.221 22.359 14.221C21.3765 14.221 20.58 15.0175 20.58 16C20.58 16.9825 21.3765 17.779 22.359 17.779Z"\n  />\n</svg>\n';
const __vite_glob_0_42 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62372 27.0394C10.8071 28.4983 13.3741 29.277 16 29.277C19.5201 29.273 22.8948 27.8729 25.3839 25.3839C27.873 22.8948 29.2731 19.5201 29.277 16C29.277 13.3741 28.4983 10.8071 27.0395 8.6237C25.5806 6.4403 23.507 4.73855 21.0809 3.73365C18.6549 2.72875 15.9853 2.46582 13.4098 2.97811C10.8343 3.49041 8.46859 4.75492 6.61177 6.61174C4.75495 8.46856 3.49044 10.8343 2.97814 13.4098C2.46585 15.9853 2.72878 18.6548 3.73368 21.0809C4.73858 23.5069 6.44033 25.5805 8.62372 27.0394ZM11.42 16C11.42 16.9825 10.6235 17.779 9.641 17.779C8.65848 17.779 7.862 16.9825 7.862 16C7.862 15.0175 8.65848 14.221 9.641 14.221C10.6235 14.221 11.42 15.0175 11.42 16ZM24.138 16C24.138 16.9825 23.3415 17.779 22.359 17.779C21.3765 17.779 20.58 16.9825 20.58 16C20.58 15.0175 21.3765 14.221 22.359 14.221C23.3415 14.221 24.138 15.0175 24.138 16ZM16 17.779C16.9825 17.779 17.779 16.9825 17.779 16C17.779 15.0175 16.9825 14.221 16 14.221C15.0175 14.221 14.221 15.0175 14.221 16C14.221 16.9825 15.0175 17.779 16 17.779Z"\n  />\n</svg>\n';
const __vite_glob_0_43 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 3C13.3741 3 10.8071 3.77868 8.62371 5.23758C6.44032 6.69648 4.73857 8.77006 3.73367 11.1961C2.72876 13.6222 2.46585 16.2917 2.97815 18.8672C3.49044 21.4427 4.75496 23.8084 6.61178 25.6653C8.4686 27.5221 10.8343 28.7866 13.4098 29.2989C15.9853 29.8112 18.6549 29.5483 21.0809 28.5434C23.507 27.5384 25.5806 25.8367 27.0395 23.6533C28.4984 21.4699 29.277 18.9029 29.277 16.277C29.2731 12.7569 27.873 9.38219 25.3839 6.89313C22.8948 4.40407 19.5201 3.00397 16 3ZM16 28.254C13.6312 28.254 11.3156 27.5516 9.34597 26.2355C7.37637 24.9195 5.84123 23.0489 4.93472 20.8604C4.02821 18.6719 3.79104 16.2637 4.25317 13.9404C4.71531 11.6171 5.85599 9.483 7.531 7.80798C9.20602 6.13297 11.3401 4.99227 13.6634 4.53014C15.9867 4.068 18.3949 4.30519 20.5834 5.2117C22.7719 6.11821 24.6425 7.65333 25.9586 9.62294C27.2746 11.5925 27.977 13.9082 27.977 16.277C27.9736 19.4525 26.7106 22.497 24.4653 24.7426C22.2199 26.9881 19.1756 28.2503 16 28.254Z"\n  />\n  <path\n    d="M17.114 22.5716L22.0209 17.6646L21.101 16.7456L16.6499 21.1966L16.6499 9.37462H15.35L15.35 21.1966L10.8989 16.7456L9.97895 17.6646L14.8859 22.5716C15.1817 22.8664 15.5823 23.032 16 23.032C16.4176 23.032 16.8182 22.8664 17.114 22.5716Z"\n  />\n</svg>\n';
const __vite_glob_0_44 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62371 5.23758C10.8071 3.77868 13.3741 3 16 3C19.5201 3.00397 22.8948 4.40407 25.3839 6.89313C27.873 9.38219 29.2731 12.7569 29.277 16.277C29.277 18.9029 28.4984 21.4699 27.0395 23.6533C25.5806 25.8367 23.507 27.5384 21.0809 28.5434C18.6549 29.5483 15.9853 29.8112 13.4098 29.2989C10.8343 28.7866 8.4686 27.5221 6.61178 25.6653C4.75496 23.8084 3.49044 21.4427 2.97815 18.8672C2.46585 16.2917 2.72876 13.6222 3.73367 11.1961C4.73857 8.77006 6.44032 6.69648 8.62371 5.23758ZM22.021 17.6646L17.114 22.5716C16.8182 22.8664 16.4176 23.032 16 23.032C15.5824 23.032 15.1818 22.8664 14.886 22.5716L9.979 17.6646L10.899 16.7456L15.35 21.1966L15.35 9.37463L16.65 9.37463L16.65 21.1966L21.101 16.7456L22.021 17.6646Z"\n  />\n</svg>\n';
const __vite_glob_0_45 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 3C13.3741 3 10.8071 3.77868 8.62371 5.23758C6.44032 6.69648 4.73857 8.77006 3.73367 11.1961C2.72876 13.6222 2.46585 16.2917 2.97815 18.8672C3.49044 21.4427 4.75496 23.8084 6.61178 25.6653C8.4686 27.5221 10.8343 28.7866 13.4098 29.2989C15.9853 29.8112 18.6549 29.5483 21.0809 28.5434C23.507 27.5384 25.5806 25.8367 27.0395 23.6533C28.4984 21.4699 29.277 18.9029 29.277 16.277C29.2731 12.7569 27.873 9.38219 25.3839 6.89313C22.8948 4.40407 19.5201 3.00397 16 3ZM16 28.254C13.6312 28.254 11.3156 27.5516 9.34597 26.2355C7.37637 24.9195 5.84123 23.0489 4.93472 20.8604C4.02821 18.6719 3.79104 16.2637 4.25317 13.9404C4.71531 11.6171 5.85599 9.483 7.531 7.80798C9.20602 6.13297 11.3401 4.99227 13.6634 4.53014C15.9867 4.068 18.3949 4.30519 20.5834 5.2117C22.7719 6.11821 24.6425 7.65333 25.9586 9.62294C27.2746 11.5925 27.977 13.9082 27.977 16.277C27.9736 19.4525 26.7106 22.497 24.4653 24.7426C22.2199 26.9881 19.1756 28.2503 16 28.254Z"\n  />\n  <path\n    d="M9.63169 17.3173L14.5387 22.2243L15.4577 21.3043L11.0067 16.8533L22.8287 16.8533V15.5533L11.0067 15.5533L15.4577 11.1023L14.5387 10.1823L9.63169 15.0893C9.33686 15.3851 9.17131 15.7857 9.17131 16.2033C9.17131 16.6209 9.33686 17.0215 9.63169 17.3173Z"\n  />\n</svg>\n';
const __vite_glob_0_46 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62371 5.23758C10.8071 3.77868 13.3741 3 16 3C19.5201 3.00397 22.8948 4.40407 25.3839 6.89313C27.873 9.38219 29.2731 12.7569 29.277 16.277C29.277 18.9029 28.4984 21.4699 27.0395 23.6533C25.5806 25.8367 23.507 27.5384 21.0809 28.5434C18.6549 29.5483 15.9853 29.8112 13.4098 29.2989C10.8343 28.7866 8.4686 27.5221 6.61178 25.6653C4.75496 23.8084 3.49044 21.4427 2.97815 18.8672C2.46585 16.2917 2.72876 13.6222 3.73367 11.1961C4.73857 8.77006 6.44032 6.69648 8.62371 5.23758ZM14.5386 22.2243L9.63164 17.3173C9.33681 17.0215 9.17126 16.6209 9.17126 16.2033C9.17126 15.7857 9.33681 15.3851 9.63164 15.0893L14.5386 10.1823L15.4576 11.1023L11.0066 15.5533L22.8286 15.5533V16.8533L11.0066 16.8533L15.4576 21.3043L14.5386 22.2243Z"\n  />\n</svg>\n';
const __vite_glob_0_47 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 3C13.3741 3 10.8071 3.77868 8.62371 5.23758C6.44032 6.69647 4.73857 8.77006 3.73367 11.1961C2.72876 13.6222 2.46585 16.2917 2.97815 18.8672C3.49044 21.4427 4.75496 23.8084 6.61178 25.6653C8.4686 27.5221 10.8343 28.7866 13.4098 29.2989C15.9853 29.8112 18.6549 29.5483 21.0809 28.5434C23.507 27.5384 25.5806 25.8367 27.0395 23.6533C28.4984 21.4699 29.277 18.9029 29.277 16.277C29.2731 12.7569 27.873 9.38219 25.3839 6.89313C22.8948 4.40407 19.5201 3.00397 16 3ZM16 28.254C13.6312 28.254 11.3156 27.5516 9.34597 26.2355C7.37637 24.9195 5.84123 23.0489 4.93472 20.8604C4.02821 18.6719 3.79104 16.2637 4.25317 13.9404C4.71531 11.6171 5.85599 9.483 7.531 7.80798C9.20602 6.13297 11.3401 4.99227 13.6634 4.53014C15.9867 4.068 18.3949 4.30519 20.5834 5.2117C22.7719 6.11821 24.6425 7.65333 25.9586 9.62294C27.2746 11.5925 27.977 13.9082 27.977 16.277C27.9736 19.4525 26.7106 22.497 24.4653 24.7426C22.2199 26.9881 19.1756 28.2503 16 28.254Z"\n  />\n  <path\n    d="M22.3683 15.0893L17.4613 10.1823L16.5423 11.1023L20.9933 15.5533L9.1713 15.5533L9.1713 16.8533L20.9933 16.8533L16.5423 21.3043L17.4613 22.2243L22.3683 17.3173C22.6631 17.0215 22.8287 16.6209 22.8287 16.2033C22.8287 15.7857 22.6631 15.3851 22.3683 15.0893V15.0893Z"\n  />\n</svg>\n';
const __vite_glob_0_48 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62371 5.23758C10.8071 3.77868 13.3741 3 16 3C19.5201 3.00397 22.8948 4.40407 25.3839 6.89313C27.873 9.38219 29.2731 12.7569 29.277 16.277C29.277 18.9029 28.4984 21.4699 27.0395 23.6533C25.5806 25.8367 23.507 27.5384 21.0809 28.5434C18.6549 29.5483 15.9853 29.8112 13.4098 29.2989C10.8343 28.7866 8.4686 27.5221 6.61178 25.6653C4.75496 23.8084 3.49044 21.4427 2.97815 18.8672C2.46585 16.2917 2.72876 13.6222 3.73367 11.1961C4.73857 8.77006 6.44032 6.69648 8.62371 5.23758ZM17.4614 10.1823L22.3684 15.0893C22.6632 15.3851 22.8287 15.7857 22.8287 16.2033C22.8287 16.6209 22.6632 17.0215 22.3684 17.3173L17.4614 22.2243L16.5424 21.3043L20.9934 16.8533L9.17136 16.8533L9.17136 15.5533L20.9934 15.5533L16.5424 11.1023L17.4614 10.1823Z"\n  />\n</svg>\n';
const __vite_glob_0_49 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 3C13.3741 3 10.8071 3.77868 8.62371 5.23758C6.44032 6.69648 4.73857 8.77006 3.73367 11.1961C2.72876 13.6222 2.46585 16.2917 2.97815 18.8672C3.49044 21.4427 4.75496 23.8084 6.61178 25.6653C8.4686 27.5221 10.8343 28.7866 13.4098 29.2989C15.9853 29.8112 18.6549 29.5483 21.0809 28.5434C23.507 27.5384 25.5806 25.8367 27.0395 23.6533C28.4984 21.4699 29.277 18.9029 29.277 16.277C29.2731 12.7569 27.873 9.38219 25.3839 6.89313C22.8948 4.40407 19.5201 3.00397 16 3ZM16 28.254C13.6312 28.254 11.3156 27.5516 9.34597 26.2355C7.37637 24.9195 5.84123 23.0489 4.93472 20.8604C4.02821 18.6719 3.79104 16.2637 4.25317 13.9404C4.71531 11.6171 5.85599 9.483 7.531 7.80798C9.20602 6.13297 11.3401 4.99227 13.6634 4.53014C15.9867 4.068 18.3949 4.30519 20.5834 5.2117C22.7719 6.11821 24.6425 7.65333 25.9586 9.62294C27.2746 11.5925 27.977 13.9082 27.977 16.277C27.9736 19.4525 26.7106 22.497 24.4653 24.7426C22.2199 26.9881 19.1756 28.2503 16 28.254Z"\n  />\n  <path\n    d="M14.886 9.83501L9.979 14.742L10.899 15.661L15.35 11.21V23.032H16.65V11.21L21.101 15.661L22.021 14.742L17.114 9.83501C16.8182 9.54018 16.4176 9.37463 16 9.37463C15.5824 9.37463 15.1818 9.54018 14.886 9.83501Z"\n  />\n</svg>\n';
const __vite_glob_0_50 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62371 5.23758C10.8071 3.77868 13.3741 3 16 3C19.5201 3.00397 22.8948 4.40407 25.3839 6.89313C27.873 9.38219 29.2731 12.7569 29.277 16.277C29.277 18.9029 28.4984 21.4699 27.0395 23.6533C25.5806 25.8367 23.507 27.5384 21.0809 28.5434C18.6549 29.5483 15.9853 29.8112 13.4098 29.2989C10.8343 28.7866 8.4686 27.5221 6.61178 25.6653C4.75496 23.8084 3.49044 21.4427 2.97815 18.8672C2.46585 16.2917 2.72876 13.6222 3.73367 11.1961C4.73857 8.77006 6.44032 6.69648 8.62371 5.23758ZM9.979 14.742L14.886 9.83501C15.1818 9.54018 15.5824 9.37463 16 9.37463C16.4176 9.37463 16.8182 9.54018 17.114 9.83501L22.021 14.742L21.101 15.661L16.65 11.21V23.032H15.35V11.21L10.899 15.661L9.979 14.742Z"\n  />\n</svg>\n';
const __vite_glob_0_51 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.276 29.552C13.6503 29.552 11.0835 28.7734 8.90026 27.3146C6.71703 25.8558 5.01541 23.7824 4.01058 21.3565C3.00575 18.9306 2.74284 16.2613 3.2551 13.686C3.76736 11.1107 5.03178 8.74514 6.88846 6.88846C8.74515 5.03177 11.1107 3.76736 13.686 3.2551C16.2613 2.74284 18.9306 3.00575 21.3565 4.01058C23.7824 5.01541 25.8558 6.71703 27.3146 8.90026C28.7734 11.0835 29.552 13.6503 29.552 16.276C29.5483 19.7959 28.1484 23.1705 25.6595 25.6595C23.1705 28.1484 19.7959 29.5483 16.276 29.552ZM16.276 4.29901C13.9072 4.29901 11.5915 5.00144 9.62194 6.31749C7.65233 7.63354 6.11721 9.5041 5.2107 11.6926C4.30419 13.8811 4.067 16.2893 4.52913 18.6126C4.99127 20.9359 6.13197 23.07 7.80698 24.745C9.48199 26.42 11.6161 27.5607 13.9394 28.0229C16.2627 28.485 18.6709 28.2478 20.8594 27.3413C23.0479 26.4348 24.9185 24.8997 26.2345 22.9301C27.5506 20.9605 28.253 18.6448 28.253 16.276C28.2493 13.1006 26.9862 10.0564 24.7409 7.81108C22.4956 5.56576 19.4514 4.30271 16.276 4.29901Z"\n  />\n  <path\n    d="M12.5352 11.6157L11.616 12.5349L20.0171 20.936L20.9363 20.0168L12.5352 11.6157Z"\n  />\n  <path\n    d="M20.0171 11.6157L11.616 20.0168L12.5352 20.9361L20.9363 12.5349L20.0171 11.6157Z"\n  />\n</svg>\n';
const __vite_glob_0_52 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M16.276 29.552C13.6503 29.552 11.0835 28.7734 8.90026 27.3146C6.71703 25.8558 5.01541 23.7824 4.01058 21.3565C3.00575 18.9306 2.74284 16.2613 3.2551 13.686C3.76736 11.1107 5.03178 8.74514 6.88846 6.88846C8.74515 5.03177 11.1107 3.76736 13.686 3.2551C16.2613 2.74284 18.9306 3.00575 21.3565 4.01058C23.7824 5.01541 25.8558 6.71703 27.3146 8.90026C28.7734 11.0835 29.552 13.6503 29.552 16.276C29.5483 19.7959 28.1484 23.1705 25.6595 25.6595C23.1705 28.1484 19.7959 29.5483 16.276 29.552ZM12.5352 11.6157L11.616 12.535L15.3569 16.2759L11.616 20.0169L12.5352 20.9361L16.2762 17.1952L20.0171 20.9361L20.9363 20.0169L17.1954 16.2759L20.9363 12.535L20.0171 11.6158L16.2762 15.3567L12.5352 11.6157Z"\n  />\n</svg>\n';
const __vite_glob_0_53 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 29.276C13.3743 29.276 10.8075 28.4974 8.62425 27.0386C6.44103 25.5798 4.73941 23.5064 3.73458 21.0805C2.72975 18.6546 2.46684 15.9853 2.9791 13.41C3.49136 10.8347 4.75577 8.46914 6.61246 6.61246C8.46914 4.75577 10.8347 3.49136 13.41 2.9791C15.9853 2.46684 18.6546 2.72975 21.0805 3.73458C23.5064 4.73941 25.5798 6.44103 27.0386 8.62425C28.4974 10.8075 29.276 13.3743 29.276 16C29.2723 19.5199 27.8724 22.8945 25.3835 25.3835C22.8945 27.8724 19.5199 29.2723 16 29.276V29.276ZM16 4.023C13.6312 4.023 11.3155 4.72544 9.34594 6.04149C7.37633 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.791 16.0133 4.25314 18.3366C4.71528 20.6599 5.85597 22.794 7.53099 24.469C9.206 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7103 9.7804 24.4649 7.53508C22.2196 5.28976 19.1754 4.02671 16 4.023V4.023Z"\n  />\n  <path d="M15.127 19.858H9.68701V21.158H15.127V19.858Z" />\n  <path d="M22.314 15.325H9.68701V16.625H22.314V15.325Z" />\n  <path d="M22.314 10.842H9.68701V12.142H22.314V10.842Z" />\n</svg>\n';
const __vite_glob_0_54 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62425 27.0386C10.8075 28.4974 13.3743 29.276 16 29.276C19.5199 29.2723 22.8945 27.8724 25.3835 25.3835C27.8724 22.8945 29.2723 19.5199 29.276 16C29.276 13.3743 28.4974 10.8075 27.0386 8.62425C25.5798 6.44103 23.5064 4.73941 21.0805 3.73458C18.6546 2.72975 15.9853 2.46684 13.41 2.9791C10.8347 3.49136 8.46914 4.75577 6.61246 6.61246C4.75577 8.46914 3.49136 10.8347 2.9791 13.41C2.46684 15.9853 2.72975 18.6546 3.73458 21.0805C4.73941 23.5064 6.44103 25.5798 8.62425 27.0386ZM22.314 10.842H9.68701V12.142H22.314V10.842ZM9.68701 15.325H22.314V16.625H9.68701V15.325ZM9.68701 19.858H15.127V21.158H9.68701V19.858Z"\n  />\n</svg>\n';
const __vite_glob_0_55 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 19.927C15.7941 19.9271 15.5901 19.8867 15.3998 19.8079C15.2095 19.7291 15.0366 19.6136 14.891 19.468L11.584 16.161L12.504 15.242L15.811 18.549C15.8612 18.599 15.9292 18.627 16 18.627C16.0708 18.627 16.1388 18.599 16.189 18.549L19.496 15.242L20.416 16.161L17.109 19.468C16.9634 19.6136 16.7905 19.7291 16.6002 19.8079C16.4099 19.8867 16.2059 19.9271 16 19.927Z"\n  />\n  <path d="M16.651 9.54001H15.35V19.009H16.651V9.54001Z" />\n  <path\n    d="M21.109 23.11H10.891C10.3906 23.1675 9.88767 23.0247 9.49216 22.7128C9.09664 22.4008 8.84063 21.9451 8.78 21.445V19.094H10.08V21.445C10.08 21.557 10.386 21.811 10.89 21.811H21.108C21.608 21.811 21.918 21.557 21.918 21.445V19.094H23.218V21.445C23.1573 21.9447 22.9016 22.4001 22.5066 22.712C22.1115 23.0239 21.6091 23.167 21.109 23.11Z"\n  />\n  <path\n    d="M16 29.276C13.3743 29.2758 10.8076 28.497 8.62452 27.0381C6.44142 25.5792 4.73997 23.5057 3.7353 21.0798C2.73062 18.6539 2.46786 15.9846 2.98023 13.4094C3.4926 10.8341 4.75708 8.46868 6.61381 6.6121C8.47053 4.75552 10.8361 3.4912 13.4114 2.97903C15.9866 2.46685 18.6559 2.72982 21.0817 3.73468C23.5075 4.73953 25.5809 6.44115 27.0397 8.62436C28.4984 10.8076 29.277 13.3743 29.277 16C29.273 19.52 27.8729 22.8946 25.3838 25.3835C22.8947 27.8724 19.52 29.2723 16 29.276ZM16 4.023C13.6312 4.023 11.3156 4.72544 9.34595 6.04149C7.37635 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.79101 16.0133 4.25315 18.3366C4.71528 20.6599 5.85597 22.794 7.53098 24.469C9.20599 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7103 9.7804 24.4649 7.53508C22.2196 5.28976 19.1754 4.02671 16 4.023Z"\n  />\n</svg>\n';
const __vite_glob_0_56 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62449 27.0381C10.8076 28.497 13.3743 29.2758 16 29.276C19.5199 29.2723 22.8947 27.8724 25.3838 25.3835C27.8729 22.8946 29.273 19.52 29.277 16C29.277 13.3743 28.4984 10.8076 27.0396 8.62436C25.5809 6.44115 23.5075 4.73953 21.0817 3.73468C18.6559 2.72982 15.9866 2.46685 13.4113 2.97903C10.8361 3.4912 8.4705 4.75552 6.61378 6.6121C4.75705 8.46868 3.49257 10.8341 2.9802 13.4094C2.46783 15.9846 2.73059 18.6539 3.73527 21.0798C4.73994 23.5057 6.44139 25.5792 8.62449 27.0381ZM15.35 9.54H16.651V18.087L19.496 15.242L20.416 16.161L17.109 19.468C16.9634 19.6136 16.7905 19.7291 16.6002 19.8079C16.4099 19.8866 16.2059 19.9271 16 19.927C15.794 19.9271 15.5901 19.8866 15.3998 19.8079C15.2095 19.7291 15.0366 19.6136 14.891 19.468L11.584 16.161L12.504 15.242L15.35 18.088V9.54ZM10.891 23.11C10.3905 23.1676 9.88764 23.0248 9.49213 22.7128C9.09661 22.4008 8.84059 21.9451 8.77997 21.445V19.094H10.08V21.445C10.08 21.557 10.386 21.811 10.89 21.811H21.108C21.608 21.811 21.918 21.557 21.918 21.445V19.094H23.218V21.445C23.1573 21.9447 22.9016 22.4001 22.5065 22.712C22.1115 23.0239 21.6091 23.167 21.109 23.11H10.891Z"\n  />\n</svg>\n';
const __vite_glob_0_57 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M17.6 21.784C16.066 21.784 14.5948 21.1746 13.5101 20.0899C12.4254 19.0052 11.816 17.534 11.816 16C11.816 14.466 12.4254 12.9948 13.5101 11.9101C14.5948 10.8254 16.066 10.216 17.6 10.216C18.4503 10.2156 19.29 10.4049 20.058 10.77L19.504 11.946C18.9103 11.6638 18.2613 11.5169 17.604 11.516C17.0151 11.516 16.4321 11.632 15.888 11.8573C15.344 12.0827 14.8497 12.413 14.4333 12.8293C14.0169 13.2457 13.6866 13.74 13.4613 14.2841C13.236 14.8281 13.12 15.4112 13.12 16C13.12 16.5889 13.236 17.1719 13.4613 17.716C13.6866 18.26 14.0169 18.7543 14.4333 19.1707C14.8497 19.5871 15.344 19.9173 15.888 20.1427C16.4321 20.368 17.0151 20.484 17.604 20.484C18.2613 20.4831 18.9103 20.3363 19.504 20.054L20.058 21.23C19.29 21.5951 18.4503 21.7844 17.6 21.784Z"\n  />\n  <path d="M17.814 13.928H10.215V15.228H17.814V13.928Z" />\n  <path d="M17.181 16.461H10.215V17.761H17.181V16.461Z" />\n  <path\n    d="M16 29.276C13.3743 29.276 10.8075 28.4974 8.62426 27.0386C6.44103 25.5798 4.73941 23.5064 3.73458 21.0805C2.72975 18.6546 2.46684 15.9853 2.9791 13.41C3.49136 10.8347 4.75578 8.46914 6.61246 6.61245C8.46914 4.75577 10.8347 3.49136 13.41 2.9791C15.9853 2.46684 18.6546 2.72975 21.0805 3.73458C23.5064 4.73941 25.5798 6.44103 27.0386 8.62425C28.4974 10.8075 29.276 13.3743 29.276 16C29.2723 19.5199 27.8724 22.8945 25.3835 25.3835C22.8945 27.8724 19.5199 29.2723 16 29.276ZM16 4.023C13.6312 4.023 11.3155 4.72544 9.34594 6.04149C7.37633 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.791 16.0133 4.25313 18.3366C4.71527 20.6599 5.85597 22.794 7.53098 24.469C9.20599 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7102 9.7804 24.4649 7.53508C22.2196 5.28976 19.1754 4.02671 16 4.023Z"\n  />\n</svg>\n';
const __vite_glob_0_58 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62426 27.0386C10.8075 28.4974 13.3743 29.276 16 29.276C19.5199 29.2723 22.8945 27.8724 25.3835 25.3835C27.8724 22.8945 29.2723 19.5199 29.276 16C29.276 13.3743 28.4974 10.8075 27.0386 8.62425C25.5798 6.44103 23.5064 4.73941 21.0805 3.73458C18.6546 2.72975 15.9853 2.46684 13.41 2.9791C10.8347 3.49136 8.46914 4.75577 6.61246 6.61245C4.75578 8.46914 3.49136 10.8347 2.9791 13.41C2.46684 15.9853 2.72975 18.6546 3.73458 21.0805C4.73941 23.5064 6.44103 25.5798 8.62426 27.0386ZM13.5101 20.0899C14.5948 21.1746 16.066 21.784 17.6 21.784C18.4503 21.7844 19.29 21.5951 20.058 21.23L19.504 20.054C18.9103 20.3363 18.2613 20.4831 17.604 20.484C17.0151 20.484 16.4321 20.368 15.888 20.1427C15.344 19.9173 14.8497 19.5871 14.4333 19.1707C14.0285 18.7658 13.705 18.2873 13.4802 17.761H17.181V16.461H13.1437C13.1279 16.3081 13.12 16.1543 13.12 16C13.12 15.7406 13.1425 15.4823 13.1869 15.228H17.814V13.928H13.6274C13.8382 13.5235 14.1097 13.1529 14.4333 12.8293C14.8497 12.413 15.344 12.0827 15.888 11.8573C16.4321 11.632 17.0151 11.516 17.604 11.516C18.2613 11.5169 18.9103 11.6638 19.504 11.946L20.058 10.77C19.29 10.4049 18.4503 10.2156 17.6 10.216C16.066 10.216 14.5948 10.8254 13.5101 11.9101C12.9311 12.489 12.4876 13.1781 12.1998 13.928H10.215V15.228H11.8677C11.8334 15.4825 11.816 15.7403 11.816 16C11.816 16.1544 11.8222 16.3082 11.8344 16.461H10.215V17.761H12.0906C12.3688 18.6314 12.852 19.4318 13.5101 20.0899Z"\n  />\n</svg>\n';
const __vite_glob_0_59 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M22.5 21.54H20.459C20.1541 21.5398 19.8617 21.4185 19.6461 21.2029C19.4305 20.9873 19.3093 20.695 19.309 20.39V13.2C19.3093 12.8951 19.4305 12.6028 19.6461 12.3872C19.8617 12.1716 20.1541 12.0503 20.459 12.05H22.5C22.8049 12.0503 23.0973 12.1716 23.3129 12.3872C23.5285 12.6028 23.6497 12.8951 23.65 13.2V20.39C23.6497 20.695 23.5285 20.9873 23.3129 21.2029C23.0973 21.4185 22.8049 21.5398 22.5 21.54V21.54ZM20.609 20.24H22.35V13.353H20.609V20.24Z"\n  />\n  <path\n    d="M17.021 21.54H14.979C14.6742 21.5395 14.382 21.4182 14.1664 21.2026C13.9509 20.9871 13.8295 20.6949 13.829 20.39V11.61C13.8295 11.3052 13.9509 11.013 14.1664 10.7974C14.382 10.5819 14.6742 10.4606 14.979 10.46H17.021C17.3258 10.4606 17.618 10.5819 17.8336 10.7974C18.0491 11.013 18.1705 11.3052 18.171 11.61V20.39C18.1705 20.6949 18.0491 20.9871 17.8336 21.2026C17.618 21.4182 17.3258 21.5395 17.021 21.54V21.54ZM15.13 20.24H16.87V11.76H15.13V20.24Z"\n  />\n  <path\n    d="M11.541 21.54H9.5C9.19508 21.5397 8.90274 21.4185 8.68713 21.2029C8.47152 20.9873 8.35027 20.6949 8.35001 20.39V16.926C8.35027 16.6211 8.47152 16.3287 8.68713 16.1131C8.90274 15.8975 9.19508 15.7763 9.5 15.776H11.541C11.8459 15.7763 12.1383 15.8975 12.3539 16.1131C12.5695 16.3287 12.6907 16.6211 12.691 16.926V20.39C12.6907 20.6949 12.5695 20.9873 12.3539 21.2029C12.1383 21.4185 11.8459 21.5397 11.541 21.54V21.54ZM9.64999 20.24H11.391V17.076H9.64999V20.24Z"\n  />\n  <path\n    d="M16 29.276C13.3743 29.2758 10.8076 28.497 8.62452 27.0381C6.44142 25.5792 4.73997 23.5057 3.7353 21.0798C2.73062 18.6539 2.46786 15.9846 2.98023 13.4094C3.4926 10.8341 4.75708 8.46868 6.61381 6.6121C8.47053 4.75552 10.8361 3.4912 13.4114 2.97903C15.9866 2.46685 18.6559 2.72982 21.0817 3.73468C23.5075 4.73953 25.5809 6.44115 27.0397 8.62436C28.4984 10.8076 29.277 13.3743 29.277 16C29.273 19.52 27.8729 22.8946 25.3838 25.3835C22.8947 27.8724 19.52 29.2723 16 29.276ZM16 4.023C13.6312 4.023 11.3156 4.72544 9.34595 6.04149C7.37635 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.79101 16.0133 4.25315 18.3366C4.71528 20.6599 5.85597 22.794 7.53098 24.469C9.20599 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7103 9.7804 24.4649 7.53508C22.2196 5.28976 19.1754 4.02671 16 4.023V4.023Z"\n  />\n</svg>\n';
const __vite_glob_0_60 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path d="M16.87 20.24H15.13V11.76H16.87V20.24Z" fill="#34323A" />\n  <path d="M22.35 20.24H20.609V13.353H22.35V20.24Z" fill="#34323A" />\n  <path d="M9.64996 20.24H11.391V17.076H9.64996V20.24Z" fill="#34323A" />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62449 27.0381C10.8076 28.497 13.3743 29.2758 16 29.276C19.5199 29.2723 22.8947 27.8724 25.3838 25.3835C27.8729 22.8946 29.273 19.52 29.277 16C29.277 13.3743 28.4984 10.8076 27.0396 8.62436C25.5809 6.44115 23.5075 4.73953 21.0817 3.73468C18.6559 2.72982 15.9866 2.46685 13.4113 2.97903C10.8361 3.4912 8.4705 4.75552 6.61378 6.6121C4.75705 8.46868 3.49257 10.8341 2.9802 13.4094C2.46783 15.9846 2.73059 18.6539 3.73527 21.0798C4.73994 23.5057 6.44139 25.5792 8.62449 27.0381ZM14.979 21.54H17.021C17.3258 21.5395 17.618 21.4181 17.8336 21.2026C18.0491 20.987 18.1704 20.6948 18.171 20.39V11.61C18.1704 11.3052 18.0491 11.013 17.8336 10.7974C17.618 10.5819 17.3258 10.4605 17.021 10.46H14.979C14.6741 10.4605 14.3819 10.5819 14.1664 10.7974C13.9508 11.013 13.8295 11.3052 13.829 11.61V20.39C13.8295 20.6948 13.9508 20.987 14.1664 21.2026C14.3819 21.4181 14.6741 21.5395 14.979 21.54ZM20.459 21.54H22.5C22.8049 21.5397 23.0972 21.4185 23.3128 21.2029C23.5284 20.9873 23.6497 20.6949 23.65 20.39V13.2C23.6497 12.8951 23.5284 12.6027 23.3128 12.3871C23.0972 12.1715 22.8049 12.0503 22.5 12.05H20.459C20.1541 12.0503 19.8617 12.1715 19.6461 12.3871C19.4305 12.6027 19.3092 12.8951 19.309 13.2V20.39C19.3092 20.6949 19.4305 20.9873 19.6461 21.2029C19.8617 21.4185 20.1541 21.5397 20.459 21.54ZM11.541 21.54H9.49997C9.19505 21.5397 8.90271 21.4185 8.6871 21.2029C8.47149 20.9873 8.35024 20.6949 8.34998 20.39V16.926C8.35024 16.6211 8.47149 16.3287 8.6871 16.1131C8.90271 15.8975 9.19505 15.7763 9.49997 15.776H11.541C11.8459 15.7763 12.1382 15.8975 12.3539 16.1131C12.5695 16.3287 12.6907 16.6211 12.691 16.926V20.39C12.6907 20.6949 12.5695 20.9873 12.3539 21.2029C12.1382 21.4185 11.8459 21.5397 11.541 21.54Z"\n  />\n</svg>\n';
const __vite_glob_0_61 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.276 29.552C13.6503 29.552 11.0835 28.7734 8.90026 27.3146C6.71703 25.8558 5.01541 23.7824 4.01058 21.3565C3.00575 18.9306 2.74284 16.2613 3.2551 13.686C3.76736 11.1107 5.03178 8.74514 6.88846 6.88845C8.74515 5.03177 11.1107 3.76736 13.686 3.2551C16.2613 2.74284 18.9306 3.00575 21.3565 4.01058C23.7824 5.01541 25.8558 6.71703 27.3146 8.90025C28.7734 11.0835 29.552 13.6503 29.552 16.276C29.5483 19.7959 28.1484 23.1705 25.6595 25.6595C23.1705 28.1484 19.7959 29.5483 16.276 29.552ZM16.276 4.299C13.9072 4.299 11.5915 5.00144 9.62194 6.31749C7.65233 7.63354 6.11721 9.50409 5.2107 11.6926C4.30419 13.8811 4.067 16.2893 4.52913 18.6126C4.99127 20.9359 6.13197 23.07 7.80698 24.745C9.48199 26.42 11.6161 27.5607 13.9394 28.0229C16.2627 28.485 18.6709 28.2478 20.8594 27.3413C23.0479 26.4348 24.9185 24.8997 26.2345 22.9301C27.5506 20.9605 28.253 18.6448 28.253 16.276C28.2493 13.1006 26.9862 10.0564 24.7409 7.81108C22.4956 5.56576 19.4514 4.30271 16.276 4.299Z"\n  />\n  <path d="M18.036 14.29L16.389 22.064H13.701L15.335 14.29H18.036Z" />\n  <path d="M18.852 10.488L18.39 12.688H15.69L16.152 10.488H18.852Z" />\n</svg>\n';
const __vite_glob_0_62 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M8.90026 27.3146C11.0835 28.7734 13.6503 29.552 16.276 29.552C19.7959 29.5483 23.1705 28.1484 25.6595 25.6595C28.1484 23.1705 29.5483 19.7959 29.552 16.276C29.552 13.6503 28.7734 11.0835 27.3146 8.90025C25.8558 6.71703 23.7824 5.01541 21.3565 4.01058C18.9306 3.00575 16.2613 2.74284 13.686 3.2551C11.1107 3.76736 8.74515 5.03177 6.88846 6.88845C5.03178 8.74514 3.76736 11.1107 3.2551 13.686C2.74284 16.2613 3.00575 18.9306 4.01058 21.3565C5.01541 23.7824 6.71703 25.8558 8.90026 27.3146ZM18.036 14.29L16.389 22.064H13.701L15.335 14.29H18.036ZM18.39 12.688L18.852 10.488H16.152L15.69 12.688H18.39Z"\n  />\n</svg>\n';
const __vite_glob_0_63 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M18.249 19.917H13.749C12.7101 19.917 11.7138 19.5043 10.9793 18.7697C10.2447 18.0352 9.832 17.0389 9.832 16C9.832 14.9612 10.2447 13.9649 10.9793 13.2303C11.7138 12.4957 12.7101 12.083 13.749 12.083H18.249C19.2879 12.083 20.2842 12.4957 21.0187 13.2303C21.7533 13.9649 22.166 14.9612 22.166 16C22.166 17.0389 21.7533 18.0352 21.0187 18.7697C20.2842 19.5043 19.2879 19.917 18.249 19.917ZM13.749 13.382C13.0547 13.382 12.3888 13.6578 11.8978 14.1488C11.4068 14.6398 11.131 15.3057 11.131 16C11.131 16.6943 11.4068 17.3602 11.8978 17.8512C12.3888 18.3422 13.0547 18.618 13.749 18.618H18.249C18.9433 18.618 19.6092 18.3422 20.1002 17.8512C20.5912 17.3602 20.867 16.6943 20.867 16C20.867 15.3057 20.5912 14.6398 20.1002 14.1488C19.6092 13.6578 18.9433 13.382 18.249 13.382H13.749Z"\n  />\n  <path d="M25.246 15.35H18.143V16.65H25.246V15.35Z" />\n  <path d="M13.857 15.35H6.754V16.65H13.857V15.35Z" />\n  <path\n    d="M16 29.276C13.3743 29.276 10.8075 28.4974 8.62425 27.0386C6.44103 25.5798 4.73941 23.5064 3.73458 21.0805C2.72975 18.6546 2.46684 15.9853 2.9791 13.41C3.49136 10.8347 4.75577 8.46914 6.61246 6.61245C8.46914 4.75577 10.8347 3.49136 13.41 2.9791C15.9853 2.46684 18.6546 2.72975 21.0805 3.73458C23.5064 4.73941 25.5798 6.44103 27.0386 8.62425C28.4974 10.8075 29.276 13.3743 29.276 16C29.2723 19.5199 27.8724 22.8945 25.3835 25.3835C22.8945 27.8724 19.5199 29.2723 16 29.276ZM16 4.023C13.6312 4.023 11.3155 4.72544 9.34594 6.04149C7.37633 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.791 16.0133 4.25314 18.3366C4.71528 20.6599 5.85597 22.794 7.53099 24.469C9.206 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7103 9.7804 24.4649 7.53508C22.2196 5.28976 19.1754 4.02671 16 4.023Z"\n  />\n</svg>\n';
const __vite_glob_0_64 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M11.8978 14.1488C11.5632 14.4834 11.3285 14.8993 11.213 15.35H13.857V16.65H11.213C11.3285 17.1007 11.5632 17.5166 11.8978 17.8512C12.3888 18.3422 13.0547 18.618 13.749 18.618H18.249C18.9434 18.618 19.6093 18.3422 20.1002 17.8512C20.4348 17.5166 20.6695 17.1007 20.7851 16.65H18.143V15.35H20.7851C20.6695 14.8993 20.4348 14.4834 20.1002 14.1488C19.6093 13.6578 18.9434 13.382 18.249 13.382H13.749C13.0547 13.382 12.3888 13.6578 11.8978 14.1488Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62425 27.0386C10.8075 28.4974 13.3743 29.276 16 29.276C19.5199 29.2723 22.8945 27.8724 25.3835 25.3835C27.8724 22.8945 29.2723 19.5199 29.276 16C29.276 13.3743 28.4974 10.8075 27.0386 8.62425C25.5798 6.44103 23.5064 4.73941 21.0805 3.73458C18.6546 2.72975 15.9853 2.46684 13.41 2.9791C10.8347 3.49136 8.46914 4.75577 6.61246 6.61245C4.75577 8.46914 3.49136 10.8347 2.9791 13.41C2.46684 15.9853 2.72975 18.6546 3.73458 21.0805C4.73941 23.5064 6.44103 25.5798 8.62425 27.0386ZM13.749 19.917H18.249C19.2879 19.917 20.2842 19.5043 21.0188 18.7697C21.5983 18.1902 21.9775 17.4477 22.1117 16.65H25.246V15.35H22.1117C21.9775 14.5523 21.5983 13.8098 21.0188 13.2303C20.2842 12.4957 19.2879 12.083 18.249 12.083H13.749C12.7102 12.083 11.7139 12.4957 10.9793 13.2303C10.3997 13.8098 10.0206 14.5523 9.88632 15.35H6.75403V16.65H9.88632C10.0206 17.4477 10.3997 18.1902 10.9793 18.7697C11.7139 19.5043 12.7102 19.917 13.749 19.917Z"\n  />\n</svg>\n';
const __vite_glob_0_65 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 23.141C15.8947 23.1411 15.791 23.1155 15.6978 23.0666C15.6046 23.0176 15.5247 22.9467 15.465 22.86C15.011 22.201 11.027 16.348 11.027 13.831C11.027 12.5121 11.5509 11.2472 12.4836 10.3146C13.4162 9.38194 14.6811 8.858 16 8.858C17.3189 8.858 18.5838 9.38194 19.5164 10.3146C20.4491 11.2472 20.973 12.5121 20.973 13.831C20.973 16.348 16.989 22.201 16.535 22.86C16.4753 22.9467 16.3954 23.0176 16.3022 23.0666C16.209 23.1155 16.1053 23.1411 16 23.141ZM16 10.159C15.0264 10.1601 14.0929 10.5472 13.4043 11.2356C12.7158 11.924 12.3283 12.8574 12.327 13.831C12.327 15.392 14.632 19.231 16 21.324C17.368 19.236 19.673 15.392 19.673 13.831C19.6717 12.8574 19.2843 11.924 18.5957 11.2356C17.9071 10.5472 16.9736 10.1601 16 10.159Z"\n  />\n  <path\n    d="M16 16.269C15.5332 16.2692 15.0768 16.131 14.6886 15.8718C14.3004 15.6126 13.9977 15.2441 13.8189 14.8128C13.6402 14.3816 13.5933 13.9071 13.6842 13.4492C13.7752 12.9914 13.9999 12.5707 14.3299 12.2406C14.6599 11.9104 15.0804 11.6856 15.5382 11.5944C15.996 11.5033 16.4706 11.55 16.9019 11.7286C17.3332 11.9072 17.7018 12.2096 17.9612 12.5978C18.2206 12.9859 18.359 13.4422 18.359 13.909C18.3585 14.5346 18.1098 15.1344 17.6675 15.5768C17.2253 16.0193 16.6256 16.2682 16 16.269ZM16 12.849C15.7904 12.849 15.5854 12.9112 15.4111 13.0277C15.2368 13.1441 15.1009 13.3097 15.0207 13.5034C14.9405 13.6971 14.9195 13.9102 14.9604 14.1158C15.0013 14.3214 15.1022 14.5103 15.2505 14.6585C15.3987 14.8068 15.5876 14.9077 15.7932 14.9486C15.9988 14.9895 16.212 14.9686 16.4057 14.8883C16.5993 14.8081 16.7649 14.6722 16.8814 14.4979C16.9978 14.3236 17.06 14.1187 17.06 13.909C17.0595 13.628 16.9476 13.3587 16.749 13.1601C16.5503 12.9614 16.281 12.8495 16 12.849Z"\n  />\n  <path\n    d="M16 29.276C13.3743 29.276 10.8075 28.4974 8.62426 27.0386C6.44103 25.5798 4.73941 23.5064 3.73458 21.0805C2.72975 18.6546 2.46684 15.9853 2.9791 13.41C3.49136 10.8347 4.75577 8.46914 6.61245 6.61245C8.46914 4.75577 10.8347 3.49136 13.41 2.9791C15.9853 2.46684 18.6546 2.72975 21.0805 3.73458C23.5064 4.73941 25.5798 6.44103 27.0386 8.62425C28.4974 10.8075 29.276 13.3743 29.276 16C29.2723 19.5199 27.8724 22.8945 25.3835 25.3835C22.8945 27.8724 19.5199 29.2723 16 29.276ZM16 4.023C13.6312 4.023 11.3155 4.72544 9.34594 6.04149C7.37633 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.79101 16.0133 4.25314 18.3366C4.71528 20.6599 5.85597 22.794 7.53099 24.469C9.206 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7102 9.7804 24.4649 7.53508C22.2196 5.28976 19.1754 4.02671 16 4.023Z"\n  />\n</svg>\n';
const __vite_glob_0_66 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 12.849C15.7903 12.849 15.5854 12.9112 15.4111 13.0276C15.2368 13.1441 15.1009 13.3097 15.0207 13.5034C14.9404 13.697 14.9194 13.9102 14.9603 14.1158C15.0012 14.3214 15.1022 14.5103 15.2504 14.6585C15.3987 14.8068 15.5876 14.9077 15.7932 14.9486C15.9988 14.9895 16.2119 14.9685 16.4056 14.8883C16.5993 14.8081 16.7649 14.6722 16.8813 14.4979C16.9978 14.3236 17.06 14.1186 17.06 13.909C17.0594 13.628 16.9476 13.3587 16.7489 13.16C16.5502 12.9614 16.2809 12.8495 16 12.849Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M16 10.159C15.0263 10.1601 14.0929 10.5472 13.4043 11.2356C12.7157 11.924 12.3283 12.8574 12.327 13.831C12.327 15.392 14.632 19.231 16 21.324C17.368 19.236 19.673 15.392 19.673 13.831C19.6716 12.8574 19.2842 11.924 18.5957 11.2356C17.9071 10.5472 16.9736 10.1601 16 10.159ZM16 16.269C15.5332 16.2692 15.0768 16.131 14.6886 15.8718C14.3003 15.6126 13.9977 15.244 13.8189 14.8128C13.6401 14.3816 13.5933 13.9071 13.6842 13.4492C13.7752 12.9913 13.9998 12.5707 14.3298 12.2406C14.6599 11.9104 15.0804 11.6856 15.5382 11.5944C15.996 11.5033 16.4706 11.55 16.9019 11.7285C17.3332 11.9071 17.7018 12.2096 17.9612 12.5977C18.2205 12.9859 18.359 13.4422 18.359 13.909C18.3584 14.5346 18.1098 15.1344 17.6675 15.5768C17.2253 16.0193 16.6256 16.2682 16 16.269Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62426 27.0386C10.8075 28.4974 13.3743 29.276 16 29.276C19.5199 29.2723 22.8945 27.8724 25.3835 25.3835C27.8724 22.8945 29.2723 19.5199 29.276 16C29.276 13.3743 28.4974 10.8075 27.0386 8.62425C25.5798 6.44103 23.5064 4.73941 21.0805 3.73458C18.6546 2.72975 15.9853 2.46684 13.41 2.9791C10.8347 3.49136 8.46914 4.75577 6.61245 6.61245C4.75577 8.46914 3.49136 10.8347 2.9791 13.41C2.46684 15.9853 2.72975 18.6546 3.73458 21.0805C4.73941 23.5064 6.44103 25.5798 8.62426 27.0386ZM16 23.141C15.8947 23.1411 15.791 23.1155 15.6978 23.0666C15.6046 23.0176 15.5247 22.9467 15.465 22.86C15.011 22.201 11.027 16.348 11.027 13.831C11.027 12.5121 11.5509 11.2472 12.4835 10.3146C13.4162 9.38194 14.6811 8.858 16 8.858C17.3189 8.858 18.5838 9.38194 19.5164 10.3146C20.449 11.2472 20.973 12.5121 20.973 13.831C20.973 16.348 16.989 22.201 16.535 22.86C16.4753 22.9467 16.3954 23.0176 16.3022 23.0666C16.209 23.1155 16.1053 23.1411 16 23.141Z"\n  />\n</svg>\n';
const __vite_glob_0_67 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path d="M21.282 15.35H10.717V16.65H21.282V15.35Z" />\n  <path\n    d="M16 29.276C13.3743 29.276 10.8075 28.4974 8.62426 27.0386C6.44103 25.5798 4.73941 23.5064 3.73458 21.0805C2.72975 18.6546 2.46684 15.9853 2.9791 13.41C3.49136 10.8347 4.75577 8.46913 6.61245 6.61245C8.46914 4.75577 10.8347 3.49135 13.41 2.97909C15.9853 2.46683 18.6546 2.72974 21.0805 3.73457C23.5064 4.7394 25.5798 6.44102 27.0386 8.62425C28.4974 10.8075 29.276 13.3743 29.276 16C29.2723 19.5199 27.8724 22.8945 25.3835 25.3835C22.8945 27.8724 19.5199 29.2723 16 29.276ZM16 4.023C13.6312 4.023 11.3155 4.72544 9.34594 6.04149C7.37633 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.79101 16.0133 4.25314 18.3366C4.71528 20.6599 5.85597 22.794 7.53099 24.469C9.206 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7102 9.78039 24.4649 7.53507C22.2196 5.28975 19.1754 4.0267 16 4.023Z"\n  />\n</svg>\n';
const __vite_glob_0_68 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M8.62426 27.0386C10.8075 28.4974 13.3743 29.276 16 29.276C19.5199 29.2723 22.8945 27.8724 25.3835 25.3835C27.8724 22.8945 29.2723 19.5199 29.276 16C29.276 13.3743 28.4974 10.8075 27.0386 8.62425C25.5798 6.44102 23.5064 4.73941 21.0805 3.73458C18.6546 2.72975 15.9853 2.46684 13.41 2.9791C10.8347 3.49135 8.46914 4.75577 6.61245 6.61245C4.75577 8.46913 3.49136 10.8347 2.9791 13.41C2.46684 15.9853 2.72975 18.6546 3.73458 21.0805C4.73941 23.5064 6.44103 25.5798 8.62426 27.0386ZM10.717 15.35H21.282V16.65H10.717V15.35Z"\n  />\n</svg>\n';
const __vite_glob_0_69 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M18.2888 13.42V14.303H13.7139L13.7148 13.42C13.7148 12.8135 13.9558 12.2318 14.3847 11.8029C14.8136 11.374 15.3953 11.133 16.0019 11.133C16.6084 11.133 17.1901 11.374 17.619 11.8029C18.0479 12.2318 18.2888 12.8135 18.2888 13.42Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M19.1319 20.867H12.8679V15.6H19.1319V20.867ZM15.3499 16.994H16.6509V19.223H15.3499V16.994Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62449 27.0381C10.8076 28.497 13.3743 29.2758 16 29.276C19.5199 29.2723 22.8947 27.8724 25.3838 25.3835C27.8729 22.8946 29.273 19.52 29.277 16C29.277 13.3743 28.4984 10.8076 27.0396 8.62436C25.5809 6.44115 23.5075 4.73953 21.0817 3.73468C18.6559 2.72982 15.9866 2.46685 13.4113 2.97903C10.8361 3.4912 8.4705 4.75552 6.61378 6.6121C4.75705 8.46868 3.49257 10.8341 2.9802 13.4094C2.46783 15.9846 2.73059 18.6539 3.73527 21.0798C4.73994 23.5057 6.44139 25.5792 8.62449 27.0381ZM12.4128 13.42V14.303H12.2179C12.1325 14.3029 12.0478 14.3196 11.9689 14.3522C11.8899 14.3848 11.8181 14.4327 11.7576 14.493C11.6972 14.5534 11.6492 14.6251 11.6165 14.704C11.5838 14.783 11.5669 14.8676 11.5669 14.953V21.518C11.567 21.6034 11.584 21.6879 11.6168 21.7667C11.6495 21.8455 11.6975 21.9171 11.758 21.9773C11.8184 22.0376 11.8902 22.0854 11.9691 22.1179C12.048 22.1505 12.1325 22.1671 12.2179 22.167H19.7819C19.8673 22.1671 19.9518 22.1505 20.0307 22.1179C20.1096 22.0854 20.1814 22.0376 20.2418 21.9773C20.3023 21.9171 20.3503 21.8455 20.3831 21.7667C20.4158 21.6879 20.4328 21.6034 20.4329 21.518V14.953C20.4329 14.8676 20.4161 14.783 20.3833 14.704C20.3506 14.6251 20.3027 14.5534 20.2422 14.493C20.1817 14.4327 20.1099 14.3848 20.0309 14.3522C19.952 14.3196 19.8674 14.3029 19.7819 14.303H19.5888V13.42C19.5888 12.4684 19.2108 11.5558 18.5379 10.8829C17.8651 10.21 16.9525 9.83201 16.0009 9.83201C15.0493 9.83201 14.1366 10.21 13.4637 10.8829C12.7909 11.5558 12.4128 12.4684 12.4128 13.42Z"\n  />\n</svg>\n';
const __vite_glob_0_70 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M19.782 22.167H12.218C12.1326 22.1671 12.0481 22.1505 11.9691 22.1179C11.8902 22.0854 11.8185 22.0376 11.7581 21.9773C11.6976 21.9171 11.6496 21.8455 11.6168 21.7667C11.584 21.6879 11.5671 21.6034 11.567 21.518V14.953C11.567 14.8676 11.5838 14.783 11.6165 14.704C11.6493 14.6251 11.6972 14.5534 11.7577 14.493C11.8182 14.4327 11.89 14.3848 11.9689 14.3522C12.0479 14.3196 12.1325 14.3029 12.218 14.303H19.782C19.8674 14.3029 19.952 14.3196 20.031 14.3522C20.11 14.3848 20.1818 14.4327 20.2422 14.493C20.3027 14.5534 20.3507 14.6251 20.3834 14.704C20.4161 14.783 20.433 14.8676 20.433 14.953V21.518C20.4329 21.6034 20.4159 21.6879 20.3831 21.7667C20.3503 21.8455 20.3023 21.9171 20.2419 21.9773C20.1814 22.0376 20.1097 22.0854 20.0308 22.1179C19.9519 22.1505 19.8673 22.1671 19.782 22.167ZM12.868 20.867H19.132V15.6H12.868V20.867Z"\n  />\n  <path\n    d="M13.713 15.247H12.413V13.42C12.413 12.4684 12.791 11.5558 13.4639 10.8829C14.1367 10.21 15.0494 9.832 16.001 9.832C16.9526 9.832 17.8652 10.21 18.5381 10.8829C19.2109 11.5558 19.589 12.4684 19.589 13.42V14.953H18.289V13.42C18.289 12.8134 18.048 12.2317 17.6191 11.8028C17.1902 11.374 16.6085 11.133 16.002 11.133C15.3954 11.133 14.8137 11.374 14.3848 11.8028C13.9559 12.2317 13.715 12.8134 13.715 13.42L13.713 15.247Z"\n  />\n  <path d="M16.651 16.994H15.35V19.223H16.651V16.994Z" />\n  <path\n    d="M16 29.276C13.3743 29.2758 10.8076 28.497 8.62449 27.0381C6.44139 25.5792 4.73994 23.5057 3.73527 21.0798C2.73059 18.6539 2.46783 15.9846 2.9802 13.4094C3.49257 10.8341 4.75705 8.46868 6.61378 6.6121C8.4705 4.75552 10.8361 3.4912 13.4113 2.97903C15.9866 2.46685 18.6559 2.72982 21.0817 3.73468C23.5075 4.73953 25.5809 6.44115 27.0396 8.62436C28.4984 10.8076 29.277 13.3743 29.277 16C29.273 19.52 27.8729 22.8946 25.3838 25.3835C22.8947 27.8724 19.5199 29.2723 16 29.276ZM16 4.023C13.6311 4.023 11.3155 4.72544 9.34592 6.04149C7.37632 7.35754 5.84118 9.22809 4.93467 11.4166C4.02816 13.6051 3.79098 16.0133 4.25312 18.3366C4.71525 20.6599 5.85594 22.794 7.53095 24.469C9.20596 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7102 9.7804 24.4649 7.53508C22.2196 5.28976 19.1753 4.02671 16 4.023Z"\n  />\n</svg>\n';
const __vite_glob_0_71 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M13.556 22.582H13.535C13.4292 22.5788 13.3258 22.5497 13.2338 22.4975C13.1418 22.4452 13.0639 22.3712 13.007 22.282L12.119 20.882L10.499 20.482C10.3955 20.4567 10.2999 20.4064 10.2204 20.3354C10.141 20.2644 10.0803 20.1749 10.0437 20.0749C10.007 19.9749 9.9955 19.8674 10.0102 19.7619C10.0249 19.6564 10.0654 19.5562 10.128 19.47L16.467 10.726C16.5693 10.5898 16.7211 10.4992 16.8895 10.4738C17.058 10.4483 17.2297 10.49 17.3677 10.5899C17.5057 10.6898 17.599 10.8398 17.6275 11.0078C17.656 11.1758 17.6174 11.3482 17.52 11.488L11.747 19.451L12.684 19.681C12.8465 19.7213 12.9873 19.8226 13.077 19.964L13.592 20.774L19.368 12.805C19.4692 12.6654 19.6217 12.5716 19.792 12.5445C19.9622 12.5173 20.1364 12.5588 20.276 12.66C20.4156 12.7612 20.5094 12.9137 20.5366 13.084C20.5637 13.2543 20.5222 13.4284 20.421 13.568L14.082 22.312C14.0219 22.3954 13.9429 22.4633 13.8515 22.5103C13.76 22.5572 13.6588 22.5818 13.556 22.582Z"\n  />\n  <path\n    d="M19.894 13.837C19.7584 13.8372 19.6262 13.7949 19.516 13.716L16.616 11.636C16.476 11.5355 16.3816 11.3835 16.3537 11.2134C16.3257 11.0433 16.3665 10.869 16.467 10.729L18.567 7.80301C18.6677 7.66298 18.8198 7.56857 18.99 7.54046C19.1602 7.51235 19.3346 7.55281 19.475 7.65301L22.375 9.73301C22.515 9.83355 22.6093 9.98548 22.6374 10.1555C22.6656 10.3255 22.6251 10.4998 22.525 10.64L20.425 13.566C20.3646 13.6503 20.2848 13.7189 20.1924 13.7661C20.1 13.8132 19.9977 13.8376 19.894 13.837ZM17.9 10.958L19.745 12.281L21.085 10.411L19.241 9.08801L17.9 10.958Z"\n  />\n  <path\n    d="M10.008 24.468C9.91376 24.4682 9.8206 24.4479 9.73499 24.4085C9.64939 24.3691 9.5734 24.3115 9.51231 24.2398C9.45121 24.168 9.40647 24.0838 9.3812 23.993C9.35594 23.9022 9.35076 23.807 9.36601 23.714L10.013 19.748C10.0258 19.663 10.0554 19.5813 10.1 19.5078C10.1447 19.4343 10.2034 19.3704 10.2729 19.3197C10.3424 19.2691 10.4213 19.2327 10.5049 19.2128C10.5886 19.1928 10.6754 19.1897 10.7602 19.2035C10.8451 19.2173 10.9264 19.2478 10.9994 19.2933C11.0724 19.3388 11.1356 19.3983 11.1855 19.4684C11.2353 19.5385 11.2707 19.6177 11.2897 19.7016C11.3087 19.7855 11.3108 19.8723 11.296 19.957L10.86 22.629L13.251 21.358C13.3266 21.3153 13.41 21.2881 13.4962 21.2781C13.5825 21.2682 13.6698 21.2756 13.7532 21.2999C13.8365 21.3243 13.9141 21.3651 13.9815 21.4199C14.0488 21.4748 14.1044 21.5425 14.1451 21.6192C14.1858 21.6959 14.2107 21.78 14.2184 21.8665C14.226 21.953 14.2163 22.0401 14.1897 22.1228C14.1631 22.2054 14.1203 22.2819 14.0636 22.3478C14.007 22.4136 13.9378 22.4674 13.86 22.506L10.312 24.392C10.2185 24.442 10.1141 24.4681 10.008 24.468Z"\n  />\n  <path\n    d="M16 29.276C13.3743 29.2758 10.8076 28.497 8.62452 27.0381C6.44142 25.5792 4.73997 23.5057 3.7353 21.0798C2.73062 18.6539 2.46786 15.9846 2.98023 13.4094C3.4926 10.8341 4.75708 8.46868 6.61381 6.6121C8.47053 4.75552 10.8361 3.4912 13.4114 2.97903C15.9866 2.46685 18.6559 2.72982 21.0817 3.73468C23.5075 4.73953 25.5809 6.44115 27.0397 8.62436C28.4984 10.8076 29.277 13.3743 29.277 16C29.273 19.52 27.8729 22.8946 25.3838 25.3835C22.8947 27.8724 19.52 29.2723 16 29.276ZM16 4.023C13.6312 4.023 11.3156 4.72544 9.34595 6.04149C7.37635 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.79101 16.0133 4.25315 18.3366C4.71528 20.6599 5.85597 22.794 7.53098 24.469C9.20599 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7103 9.7804 24.4649 7.53508C22.2196 5.28976 19.1754 4.02671 16 4.023Z"\n  />\n</svg>\n';
const __vite_glob_0_72 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M18.9841 13.3346L17.14 12.012L11.7469 19.451L12.6839 19.681C12.8464 19.7213 12.9872 19.8227 13.0769 19.964L13.5919 20.774L18.9841 13.3346Z"\n  />\n  <path\n    d="M12.1189 20.882L12.6301 21.688L10.86 22.629L11.1827 20.6509L12.1189 20.882Z"\n  />\n  <path\n    d="M19.7449 12.281L17.8999 10.958L19.2409 9.08801L21.0849 10.411L19.7449 12.281Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62449 27.0381C10.8076 28.497 13.3743 29.2758 16 29.276C19.5199 29.2723 22.8947 27.8724 25.3838 25.3835C27.8729 22.8946 29.273 19.52 29.277 16C29.277 13.3743 28.4984 10.8076 27.0396 8.62436C25.5809 6.44115 23.5075 4.73953 21.0817 3.73468C18.6559 2.72982 15.9866 2.46685 13.4113 2.97903C10.8361 3.4912 8.4705 4.75552 6.61378 6.6121C4.75705 8.46868 3.49257 10.8341 2.9802 13.4094C2.46783 15.9846 2.73059 18.6539 3.73527 21.0798C4.73994 23.5057 6.44139 25.5792 8.62449 27.0381ZM16.489 10.6982L18.5669 7.80301C18.6676 7.66299 18.8197 7.56858 18.9899 7.54047C19.1601 7.51235 19.3345 7.55282 19.4749 7.65301L22.3749 9.73301C22.5149 9.83356 22.6092 9.98549 22.6374 10.1555C22.6655 10.3255 22.625 10.4998 22.5249 10.64L20.4249 13.566C20.4141 13.5811 20.4027 13.5957 20.3907 13.6097L14.1515 22.216C14.1278 22.2632 14.0983 22.3075 14.0636 22.3478C14.007 22.4136 13.9377 22.4674 13.86 22.506L10.312 24.392C10.2185 24.442 10.114 24.4681 10.008 24.468C9.91373 24.4682 9.82057 24.4479 9.73496 24.4085C9.64936 24.3691 9.57337 24.3115 9.51228 24.2398C9.45118 24.168 9.40644 24.0838 9.38117 23.993C9.35591 23.9022 9.35073 23.807 9.36598 23.714L10.0081 19.778L10.0101 19.7619C10.014 19.7339 10.0198 19.7062 10.0273 19.679C10.0431 19.6189 10.0676 19.5612 10.1 19.5078C10.1192 19.4761 10.1411 19.4463 10.1653 19.4184L16.4669 10.726C16.4741 10.7165 16.4814 10.7072 16.489 10.6982Z"\n  />\n</svg>\n';
const __vite_glob_0_73 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 29.276C13.3743 29.276 10.8075 28.4974 8.62426 27.0386C6.44103 25.5798 4.73941 23.5064 3.73458 21.0805C2.72975 18.6546 2.46684 15.9853 2.9791 13.41C3.49136 10.8347 4.75578 8.46913 6.61246 6.61245C8.46914 4.75577 10.8347 3.49135 13.41 2.97909C15.9853 2.46683 18.6546 2.72974 21.0805 3.73457C23.5064 4.7394 25.5798 6.44102 27.0386 8.62425C28.4974 10.8075 29.276 13.3743 29.276 16C29.2723 19.5199 27.8724 22.8945 25.3835 25.3835C22.8945 27.8724 19.5199 29.2723 16 29.276ZM16 4.023C13.6312 4.023 11.3155 4.72544 9.34594 6.04149C7.37633 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.791 16.0133 4.25313 18.3366C4.71527 20.6599 5.85597 22.794 7.53098 24.469C9.20599 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7102 9.78039 24.4649 7.53507C22.2196 5.28975 19.1754 4.0267 16 4.023Z"\n  />\n  <path\n    d="M22.4073 10H9.71231C9.30683 10.0005 8.91808 10.1617 8.63131 10.4484C8.34454 10.735 8.18317 11.1237 8.18256 11.5292V20.4768C8.18317 20.8823 8.34454 21.271 8.63131 21.5577C8.91808 21.8443 9.30683 22.0056 9.71231 22.006H22.4073C22.8127 22.0056 23.2014 21.8443 23.4881 21.5576C23.7748 21.2709 23.936 20.8823 23.9365 20.4768V11.5274C23.9356 11.1223 23.7741 10.7341 23.4875 10.4478C23.2009 10.1615 22.8124 10.0005 22.4073 10ZM9.71231 10.7502H22.4073C22.6138 10.7505 22.8117 10.8327 22.9576 10.9787C23.1035 11.1247 23.1856 11.3227 23.1857 11.5292V20.4768C23.1809 20.5286 23.1707 20.5796 23.1552 20.6292L18.7448 16.2927C18.6745 16.2229 18.5795 16.1838 18.4805 16.1838C18.3815 16.1838 18.2865 16.2229 18.2162 16.2927L16.1896 18.3193L13.1509 15.0243C13.1164 14.9873 13.0749 14.9575 13.0287 14.9368C12.9825 14.9161 12.9326 14.9048 12.882 14.9037C12.8312 14.902 12.7805 14.911 12.7334 14.9302C12.6862 14.9494 12.6437 14.9783 12.6085 15.0151L8.93329 18.7244V11.5274C8.9339 11.3212 9.01623 11.1236 9.16224 10.9779C9.30825 10.8322 9.50604 10.7503 9.71231 10.7502ZM9.71231 21.2559C9.50574 21.2557 9.3077 21.1736 9.16164 21.0275C9.01558 20.8815 8.93344 20.6834 8.93329 20.4768V19.7925L12.8653 15.8235L15.9034 19.1167C15.9377 19.154 15.9791 19.1839 16.0252 19.2046C16.0713 19.2253 16.1212 19.2365 16.1718 19.2374C16.2732 19.236 16.3705 19.1969 16.4447 19.1277L18.484 17.0884L22.6681 21.2028C22.585 21.2357 22.4967 21.2537 22.4073 21.2559H9.71231Z"\n  />\n  <path\n    d="M20.656 15.6972C20.9327 15.6973 21.2032 15.6153 21.4333 15.4617C21.6634 15.3081 21.8427 15.0897 21.9487 14.8341C22.0547 14.5785 22.0824 14.2973 22.0285 14.0259C21.9746 13.7545 21.8415 13.5052 21.6459 13.3095C21.4503 13.1139 21.201 12.9806 20.9297 12.9266C20.6583 12.8726 20.377 12.9002 20.1214 13.0061C19.8658 13.1119 19.6473 13.2912 19.4936 13.5212C19.3399 13.7513 19.2578 14.0217 19.2578 14.2984C19.2583 14.6691 19.4057 15.0246 19.6678 15.2868C19.9299 15.549 20.2853 15.6966 20.656 15.6972ZM20.656 13.6504C20.7842 13.6504 20.9094 13.6884 21.016 13.7596C21.1226 13.8308 21.2057 13.932 21.2547 14.0504C21.3038 14.1688 21.3166 14.2991 21.2916 14.4248C21.2666 14.5505 21.2049 14.666 21.1142 14.7566C21.0236 14.8473 20.9081 14.909 20.7824 14.934C20.6567 14.959 20.5264 14.9462 20.408 14.8971C20.2896 14.8481 20.1884 14.765 20.1172 14.6584C20.046 14.5519 20.008 14.4266 20.008 14.2984C20.0081 14.1266 20.0764 13.9619 20.1979 13.8404C20.3194 13.7189 20.4842 13.6505 20.656 13.6504Z"\n  />\n</svg>\n';
const __vite_glob_0_74 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M20.6559 13.6504C20.7841 13.6504 20.9094 13.6884 21.016 13.7596C21.1225 13.8308 21.2056 13.932 21.2546 14.0504C21.3037 14.1688 21.3165 14.2991 21.2915 14.4248C21.2665 14.5505 21.2048 14.666 21.1142 14.7566C21.0235 14.8473 20.9081 14.909 20.7824 14.934C20.6567 14.959 20.5264 14.9462 20.408 14.8971C20.2895 14.8481 20.1883 14.765 20.1171 14.6584C20.0459 14.5519 20.0079 14.4266 20.0079 14.2984C20.0081 14.1266 20.0764 13.9619 20.1979 13.8404C20.3194 13.7189 20.4841 13.6505 20.6559 13.6504Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M9.71231 10.7502H22.4073C22.6138 10.7505 22.8117 10.8327 22.9576 10.9787C23.1035 11.1247 23.1856 11.3227 23.1857 11.5292V20.4768C23.1809 20.5286 23.1707 20.5796 23.1552 20.6292L18.7448 16.2927C18.6745 16.2229 18.5795 16.1838 18.4805 16.1838C18.3815 16.1838 18.2865 16.2229 18.2162 16.2927L16.1896 18.3193L13.1509 15.0243C13.1164 14.9873 13.0749 14.9575 13.0287 14.9368C12.9825 14.9161 12.9326 14.9048 12.882 14.9037C12.8312 14.902 12.7805 14.911 12.7334 14.9302C12.6862 14.9494 12.6437 14.9783 12.6085 15.0151L8.93329 18.7244V11.5274C8.9339 11.3212 9.01623 11.1236 9.16224 10.9779C9.30825 10.8322 9.50604 10.7503 9.71231 10.7502ZM20.6559 15.6972C20.9326 15.6973 21.2031 15.6153 21.4332 15.4617C21.6633 15.3081 21.8427 15.0897 21.9486 14.8341C22.0546 14.5785 22.0824 14.2973 22.0285 14.0259C21.9746 13.7545 21.8414 13.5052 21.6458 13.3095C21.4502 13.1139 21.201 12.9806 20.9296 12.9266C20.6583 12.8726 20.377 12.9002 20.1214 13.0061C19.8657 13.1119 19.6473 13.2912 19.4935 13.5212C19.3398 13.7513 19.2578 14.0217 19.2578 14.2984C19.2582 14.6691 19.4057 15.0246 19.6677 15.2868C19.9298 15.549 20.2852 15.6966 20.6559 15.6972Z"\n  />\n  <path\n    d="M9.71231 21.2559C9.50575 21.2557 9.3077 21.1736 9.16164 21.0275C9.01558 20.8815 8.93344 20.6834 8.93329 20.4768V19.7925L12.8653 15.8235L15.9034 19.1167C15.9377 19.154 15.9791 19.1839 16.0252 19.2046C16.0713 19.2253 16.1212 19.2365 16.1718 19.2374C16.2732 19.236 16.3705 19.1969 16.4447 19.1277L18.484 17.0884L22.6681 21.2028C22.585 21.2357 22.4967 21.2537 22.4073 21.2559H9.71231Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62426 27.0386C10.8075 28.4974 13.3743 29.276 16 29.276C19.5199 29.2723 22.8945 27.8724 25.3835 25.3835C27.8724 22.8945 29.2723 19.5199 29.276 16C29.276 13.3743 28.4974 10.8075 27.0386 8.62425C25.5798 6.44102 23.5064 4.7394 21.0805 3.73457C18.6546 2.72974 15.9853 2.46683 13.41 2.97909C10.8347 3.49135 8.46914 4.75577 6.61246 6.61245C4.75578 8.46913 3.49136 10.8347 2.9791 13.41C2.46684 15.9853 2.72975 18.6546 3.73458 21.0805C4.73941 23.5064 6.44103 25.5798 8.62426 27.0386ZM22.4073 10H9.71231C9.30683 10.0005 8.91808 10.1617 8.63131 10.4484C8.34454 10.735 8.18317 11.1237 8.18256 11.5292V20.4768C8.18317 20.8823 8.34454 21.271 8.63131 21.5577C8.91808 21.8443 9.30683 22.0056 9.71231 22.006H22.4073C22.8127 22.0056 23.2014 21.8443 23.4881 21.5576C23.7748 21.2709 23.936 20.8823 23.9365 20.4768V11.5274C23.9356 11.1223 23.7741 10.7341 23.4875 10.4478C23.2009 10.1615 22.8124 10.0005 22.4073 10Z"\n  />\n</svg>\n';
const __vite_glob_0_75 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M12.7 21.218C12.3296 21.2151 11.9751 21.0667 11.7132 20.8048C11.4513 20.5428 11.3029 20.1884 11.3 19.818V12.188C11.2987 11.9411 11.3628 11.6982 11.4858 11.484C11.6087 11.2699 11.7861 11.092 11.9999 10.9685C12.2138 10.8451 12.4565 10.7803 12.7034 10.7809C12.9504 10.7816 13.1928 10.8475 13.406 10.972L20.006 14.785C20.22 14.9075 20.3979 15.0844 20.5216 15.2978C20.6453 15.5111 20.7104 15.7534 20.7104 16C20.7104 16.2466 20.6453 16.4889 20.5216 16.7022C20.3979 16.9156 20.22 17.0925 20.006 17.215L13.406 21.028C13.1916 21.1528 12.948 21.2183 12.7 21.218ZM12.7 12.083C12.6817 12.0835 12.6638 12.0886 12.648 12.098C12.6321 12.1069 12.6189 12.12 12.6099 12.1359C12.601 12.1518 12.5965 12.1698 12.597 12.188V19.813C12.5966 19.8311 12.6012 19.8489 12.6102 19.8645C12.6192 19.8802 12.6323 19.8932 12.648 19.902C12.6632 19.9108 12.6804 19.9154 12.698 19.9154C12.7155 19.9154 12.7328 19.9108 12.748 19.902L19.348 16.089C19.3644 16.0806 19.3781 16.0679 19.3877 16.0522C19.3973 16.0365 19.4024 16.0184 19.4024 16C19.4024 15.9816 19.3973 15.9636 19.3877 15.9479C19.3781 15.9321 19.3644 15.9194 19.348 15.911L12.748 12.098C12.7335 12.089 12.717 12.0838 12.7 12.083Z"\n  />\n  <path\n    d="M16 29.276C13.3743 29.2758 10.8076 28.497 8.62452 27.0381C6.44142 25.5792 4.73997 23.5057 3.7353 21.0798C2.73062 18.6539 2.46786 15.9846 2.98023 13.4094C3.4926 10.8341 4.75708 8.46868 6.61381 6.6121C8.47053 4.75552 10.8361 3.4912 13.4114 2.97903C15.9866 2.46685 18.6559 2.72982 21.0817 3.73468C23.5075 4.73953 25.5809 6.44115 27.0397 8.62436C28.4984 10.8076 29.277 13.3743 29.277 16C29.273 19.52 27.8729 22.8946 25.3838 25.3835C22.8947 27.8724 19.52 29.2723 16 29.276ZM16 4.023C13.6312 4.023 11.3156 4.72544 9.34595 6.04149C7.37635 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.79101 16.0133 4.25315 18.3366C4.71528 20.6599 5.85597 22.794 7.53098 24.469C9.20599 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7103 9.7804 24.4649 7.53508C22.2196 5.28976 19.1754 4.02671 16 4.023Z"\n  />\n</svg>\n';
const __vite_glob_0_76 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M12.648 12.098C12.6637 12.0886 12.6816 12.0835 12.7 12.083C12.717 12.0838 12.7335 12.089 12.7479 12.098L19.3479 15.911C19.3643 15.9194 19.3781 15.9321 19.3877 15.9478C19.3973 15.9636 19.4024 15.9816 19.4024 16C19.4024 16.0184 19.3973 16.0365 19.3877 16.0522C19.3781 16.0679 19.3643 16.0806 19.3479 16.089L12.7479 19.902C12.7327 19.9108 12.7155 19.9154 12.698 19.9154C12.6804 19.9154 12.6632 19.9108 12.648 19.902C12.6322 19.8932 12.6192 19.8802 12.6102 19.8645C12.6012 19.8489 12.5966 19.8311 12.5969 19.813V12.188C12.5964 12.1698 12.6009 12.1518 12.6099 12.1359C12.6189 12.12 12.6321 12.1069 12.648 12.098Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62449 27.0381C10.8076 28.497 13.3743 29.2758 16 29.276C19.5199 29.2723 22.8947 27.8724 25.3838 25.3835C27.8729 22.8946 29.273 19.52 29.277 16C29.277 13.3743 28.4984 10.8076 27.0396 8.62436C25.5809 6.44115 23.5075 4.73953 21.0817 3.73468C18.6559 2.72982 15.9866 2.46685 13.4113 2.97903C10.8361 3.4912 8.4705 4.75552 6.61378 6.6121C4.75705 8.46868 3.49257 10.8341 2.9802 13.4094C2.46783 15.9846 2.73059 18.6539 3.73527 21.0798C4.73994 23.5057 6.44139 25.5792 8.62449 27.0381ZM11.7132 20.8048C11.9751 21.0667 12.3296 21.2151 12.7 21.218C12.948 21.2183 13.1916 21.1528 13.406 21.028L20.006 17.215C20.22 17.0925 20.3979 16.9156 20.5216 16.7022C20.6453 16.4889 20.7104 16.2466 20.7104 16C20.7104 15.7534 20.6453 15.5111 20.5216 15.2978C20.3979 15.0844 20.22 14.9075 20.006 14.785L13.406 10.972C13.1927 10.8475 12.9503 10.7816 12.7034 10.7809C12.4564 10.7803 12.2137 10.8451 11.9999 10.9685C11.786 11.092 11.6087 11.2699 11.4857 11.484C11.3628 11.6982 11.2987 11.9411 11.2999 12.188V19.818C11.3028 20.1884 11.4513 20.5428 11.7132 20.8048Z"\n  />\n</svg>\n';
const __vite_glob_0_77 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.276 29.552C13.6503 29.552 11.0835 28.7734 8.90025 27.3146C6.71703 25.8558 5.01541 23.7824 4.01058 21.3565C3.00575 18.9306 2.74284 16.2613 3.2551 13.686C3.76736 11.1107 5.03177 8.74514 6.88845 6.88846C8.74514 5.03177 11.1107 3.76736 13.686 3.2551C16.2613 2.74284 18.9306 3.00575 21.3565 4.01058C23.7824 5.01541 25.8558 6.71703 27.3146 8.90026C28.7734 11.0835 29.552 13.6503 29.552 16.276C29.5483 19.7959 28.1484 23.1705 25.6595 25.6595C23.1705 28.1484 19.7959 29.5483 16.276 29.552ZM16.276 4.29901C13.9072 4.29901 11.5915 5.00144 9.62194 6.31749C7.65233 7.63354 6.11721 9.5041 5.2107 11.6926C4.30419 13.8811 4.06701 16.2893 4.52914 18.6126C4.99128 20.9359 6.13197 23.07 7.80699 24.745C9.482 26.42 11.6161 27.5607 13.9394 28.0229C16.2627 28.485 18.6709 28.2478 20.8594 27.3413C23.0479 26.4348 24.9185 24.8997 26.2345 22.9301C27.5506 20.9605 28.253 18.6448 28.253 16.276C28.2493 13.1006 26.9863 10.0564 24.7409 7.81108C22.4956 5.56576 19.4514 4.30271 16.276 4.29901Z"\n  />\n  <path d="M16.926 10.9929H15.626V21.5579H16.926V10.9929Z" />\n  <path d="M21.558 15.626H10.993V16.926H21.558V15.626Z" />\n</svg>\n';
const __vite_glob_0_78 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M16.276 29.552C13.6503 29.552 11.0835 28.7734 8.90025 27.3146C6.71703 25.8558 5.01541 23.7824 4.01058 21.3565C3.00575 18.9306 2.74284 16.2613 3.2551 13.686C3.76736 11.1107 5.03177 8.74514 6.88845 6.88846C8.74514 5.03177 11.1107 3.76736 13.686 3.2551C16.2613 2.74284 18.9306 3.00575 21.3565 4.01058C23.7824 5.01541 25.8558 6.71703 27.3146 8.90026C28.7734 11.0835 29.552 13.6503 29.552 16.276C29.5483 19.7959 28.1484 23.1705 25.6595 25.6595C23.1705 28.1484 19.7959 29.5483 16.276 29.552ZM16.926 10.9929H15.626V15.626H10.993V16.926H15.626V21.5579H16.926V16.926H21.558V15.626H16.926V10.9929Z"\n  />\n</svg>\n';
const __vite_glob_0_79 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.275 29.552C13.6493 29.5518 11.0826 28.773 8.89951 27.3141C6.71642 25.8552 5.01497 23.7817 4.01029 21.3558C3.00561 18.9299 2.74285 16.2606 3.25522 13.6854C3.76759 11.1101 5.03208 8.74469 6.8888 6.8881C8.74552 5.03152 11.1111 3.7672 13.6863 3.25503C16.2616 2.74285 18.9309 3.00582 21.3567 4.01068C23.7825 5.01554 25.8559 6.71715 27.3147 8.90036C28.7734 11.0836 29.552 13.6503 29.552 16.276C29.548 19.796 28.1479 23.1706 25.6588 25.6595C23.1697 28.1484 19.795 29.5483 16.275 29.552ZM16.275 4.299C13.9062 4.299 11.5906 5.00144 9.62095 6.31749C7.65134 7.63354 6.1162 9.50409 5.20969 11.6926C4.30318 13.8811 4.06601 16.2893 4.52814 18.6126C4.99028 20.9359 6.13096 23.07 7.80597 24.745C9.48099 26.42 11.6151 27.5607 13.9384 28.0229C16.2617 28.485 18.6699 28.2478 20.8584 27.3413C23.0469 26.4348 24.9175 24.8997 26.2335 22.9301C27.5496 20.9605 28.252 18.6448 28.252 16.276C28.2483 13.1006 26.9853 10.0564 24.7399 7.81108C22.4946 5.56576 19.4504 4.30271 16.275 4.299Z"\n  />\n  <path\n    d="M23.813 26.8451H22.513V23.5451C22.5114 22.2646 22.002 21.037 21.0966 20.1315C20.1911 19.2261 18.9635 18.7167 17.683 18.7151H14.869C13.5885 18.7167 12.3609 19.2261 11.4554 20.1315C10.55 21.037 10.0406 22.2646 10.039 23.5451L10.044 26.7031H8.74402L8.73901 23.5441C8.74087 21.9186 9.38742 20.3602 10.5368 19.2109C11.6862 18.0615 13.2446 17.4149 14.87 17.4131H17.684C19.3093 17.4149 20.8676 18.0613 22.0169 19.2105C23.1663 20.3597 23.8129 21.9178 23.815 23.5431L23.813 26.8451Z"\n  />\n  <path\n    d="M16.275 16.0291C15.3983 16.0287 14.5414 15.7684 13.8127 15.281C13.084 14.7937 12.5161 14.1012 12.1809 13.2911C11.8456 12.4811 11.7581 11.5898 11.9294 10.73C12.1007 9.87024 12.5231 9.08054 13.1431 8.46078C13.7632 7.84101 14.553 7.41901 15.4129 7.24812C16.2728 7.07724 17.164 7.16514 17.9739 7.50072C18.7838 7.8363 19.476 8.40449 19.9631 9.13345C20.4501 9.86241 20.71 10.7194 20.71 11.5961C20.7084 12.7716 20.2406 13.8986 19.4092 14.7296C18.5777 15.5607 17.4506 16.028 16.275 16.0291ZM16.275 8.46209C15.6552 8.46209 15.0492 8.64589 14.5339 8.99026C14.0185 9.33463 13.6168 9.82409 13.3796 10.3968C13.1424 10.9694 13.0803 11.5996 13.2012 12.2075C13.3221 12.8154 13.6206 13.3739 14.0589 13.8122C14.4972 14.2505 15.0556 14.5489 15.6636 14.6699C16.2715 14.7908 16.9017 14.7287 17.4743 14.4915C18.047 14.2543 18.5365 13.8526 18.8808 13.3372C19.2252 12.8219 19.409 12.2159 19.409 11.5961C19.4082 10.7651 19.0778 9.96846 18.4902 9.38089C17.9026 8.79332 17.1059 8.46288 16.275 8.46209Z"\n  />\n</svg>\n';
const __vite_glob_0_80 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M16.275 29.552C13.6493 29.5518 11.0826 28.773 8.89951 27.3141C6.71642 25.8552 5.01497 23.7817 4.01029 21.3558C3.00561 18.9299 2.74285 16.2606 3.25522 13.6854C3.76759 11.1101 5.03208 8.74469 6.8888 6.8881C8.74552 5.03152 11.1111 3.7672 13.6863 3.25503C16.2616 2.74285 18.9309 3.00582 21.3567 4.01068C23.7825 5.01554 25.8559 6.71715 27.3147 8.90036C28.7734 11.0836 29.552 13.6503 29.552 16.276C29.548 19.796 28.1479 23.1706 25.6588 25.6595C23.1697 28.1484 19.795 29.5483 16.275 29.552ZM16.275 16.0291C15.3983 16.0287 14.5414 15.7684 13.8127 15.281C13.084 14.7937 12.5161 14.1012 12.1809 13.2911C11.8456 12.4811 11.7581 11.5898 11.9294 10.73C12.1007 9.87024 12.5231 9.08054 13.1431 8.46078C13.7632 7.84101 14.553 7.41901 15.4129 7.24812C16.2728 7.07724 17.164 7.16514 17.9739 7.50072C18.7838 7.8363 19.476 8.40449 19.9631 9.13345C20.4501 9.86241 20.71 10.7194 20.71 11.5961C20.7084 12.7717 20.2406 13.8986 19.4092 14.7296C18.5777 15.5607 17.4506 16.028 16.275 16.0291ZM16.275 8.46209C15.6552 8.46209 15.0492 8.64589 14.5339 8.99026C14.0185 9.33463 13.6168 9.82409 13.3796 10.3968C13.1424 10.9694 13.0803 11.5996 13.2012 12.2075C13.3221 12.8154 13.6206 13.3739 14.0589 13.8122C14.4972 14.2505 15.0556 14.5489 15.6636 14.6699C16.2715 14.7908 16.9017 14.7287 17.4743 14.4915C18.047 14.2543 18.5365 13.8526 18.8808 13.3372C19.2252 12.8219 19.409 12.2159 19.409 11.5961C19.4082 10.7651 19.0778 9.96846 18.4902 9.38089C17.9026 8.79332 17.1059 8.46288 16.275 8.46209ZM22.513 26.8451H23.813L23.815 23.5431C23.8129 21.9178 23.1663 20.3597 22.0169 19.2105C20.8676 18.0613 19.3093 17.4149 17.684 17.4131H14.87C13.2446 17.4149 11.6862 18.0615 10.5368 19.2109C9.38742 20.3602 8.74087 21.9186 8.73901 23.5441L8.74402 26.7031H10.044L10.039 23.5451C10.0406 22.2646 10.55 21.037 11.4554 20.1315C12.3609 19.2261 13.5885 18.7167 14.869 18.7151H17.683C18.9635 18.7167 20.1911 19.2261 21.0966 20.1315C22.002 21.037 22.5114 22.2646 22.513 23.5451V26.8451Z"\n  />\n  <path\n    d="M16 29.2759C13.3743 29.2757 10.8076 28.4969 8.62449 27.038C6.44139 25.5791 4.73994 23.5056 3.73527 21.0797C2.73059 18.6538 2.46783 15.9845 2.9802 13.4093C3.49257 10.834 4.75705 8.46856 6.61378 6.61198C8.4705 4.7554 10.8361 3.49108 13.4113 2.9789C15.9866 2.46673 18.6559 2.7297 21.0817 3.73455C23.5075 4.73941 25.5809 6.44103 27.0396 8.62424C28.4984 10.8074 29.277 13.3742 29.277 15.9999C29.273 19.5198 27.8729 22.8945 25.3838 25.3834C22.8947 27.8723 19.5199 29.2722 16 29.2759ZM16 4.02288C13.6311 4.02288 11.3155 4.72532 9.34592 6.04137C7.37632 7.35742 5.84118 9.22797 4.93467 11.4165C4.02816 13.605 3.79098 16.0132 4.25312 18.3365C4.71525 20.6598 5.85594 22.7939 7.53095 24.4689C9.20596 26.1439 11.3401 27.2846 13.6634 27.7467C15.9867 28.2089 18.3949 27.9717 20.5834 27.0652C22.7719 26.1587 24.6425 24.6236 25.9585 22.6539C27.2746 20.6843 27.977 18.3687 27.977 15.9999C27.9733 12.8245 26.7102 9.78028 24.4649 7.53496C22.2196 5.28964 19.1753 4.02659 16 4.02288Z"\n  />\n</svg>\n';
const __vite_glob_0_81 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M14.828 20.4C13.6919 20.4 12.5814 20.0631 11.6368 19.432C10.6922 18.8008 9.95598 17.9037 9.52123 16.8541C9.08648 15.8046 8.97272 14.6496 9.19435 13.5354C9.41599 12.4212 9.96306 11.3977 10.7664 10.5944C11.5697 9.79107 12.5932 9.24401 13.7074 9.02237C14.8216 8.80074 15.9765 8.91449 17.0261 9.34924C18.0757 9.78399 18.9728 10.5202 19.604 11.4648C20.2351 12.4094 20.572 13.5199 20.572 14.656C20.5704 16.1789 19.9647 17.639 18.8879 18.7159C17.811 19.7927 16.3509 20.3984 14.828 20.4ZM14.828 10.212C13.9487 10.2116 13.0891 10.472 12.3578 10.9602C11.6266 11.4484 11.0565 12.1426 10.7198 12.9548C10.3831 13.7671 10.2949 14.6609 10.4662 15.5233C10.6376 16.3857 11.0609 17.1779 11.6825 17.7997C12.3042 18.4215 13.0963 18.845 13.9587 19.0166C14.8211 19.1881 15.7149 19.1001 16.5272 18.7636C17.3396 18.427 18.0338 17.8571 18.5222 17.126C19.0106 16.3948 19.2712 15.5353 19.271 14.656C19.2707 13.4773 18.8027 12.3468 17.9697 11.5129C17.1367 10.6789 16.0067 10.2096 14.828 10.208V10.212Z"\n  />\n  <path\n    d="M18.9363 18.065L18.002 18.969L21.8 22.8944L22.7343 21.9904L18.9363 18.065Z"\n  />\n  <path\n    d="M16 29.276C13.3743 29.2758 10.8076 28.497 8.62449 27.0381C6.44139 25.5792 4.73994 23.5057 3.73527 21.0798C2.73059 18.6539 2.46783 15.9846 2.9802 13.4094C3.49257 10.8341 4.75705 8.46868 6.61378 6.6121C8.4705 4.75552 10.8361 3.4912 13.4113 2.97903C15.9866 2.46685 18.6559 2.72982 21.0817 3.73468C23.5075 4.73953 25.5809 6.44115 27.0396 8.62436C28.4984 10.8076 29.277 13.3743 29.277 16C29.273 19.52 27.8729 22.8946 25.3838 25.3835C22.8947 27.8724 19.5199 29.2723 16 29.276ZM16 4.023C13.6311 4.023 11.3155 4.72544 9.34592 6.04149C7.37632 7.35754 5.84118 9.22809 4.93467 11.4166C4.02816 13.6051 3.79098 16.0133 4.25312 18.3366C4.71525 20.6599 5.85594 22.794 7.53095 24.469C9.20596 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7102 9.7804 24.4649 7.53508C22.2196 5.28976 19.1753 4.02671 16 4.023Z"\n  />\n</svg>\n';
const __vite_glob_0_82 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M14.828 10.212C13.9487 10.2116 13.0891 10.472 12.3578 10.9602C11.6266 11.4484 11.0565 12.1426 10.7198 12.9548C10.3831 13.7671 10.2949 14.6609 10.4662 15.5233C10.6376 16.3857 11.0609 17.1779 11.6825 17.7997C12.3042 18.4215 13.0963 18.845 13.9587 19.0166C14.8211 19.1881 15.7149 19.1001 16.5272 18.7635C17.3396 18.427 18.0338 17.8571 18.5222 17.126C19.0106 16.3948 19.2712 15.5353 19.271 14.656C19.2707 13.4773 18.8027 12.3468 17.9697 11.5128C17.1367 10.6789 16.0067 10.2096 14.828 10.208V10.212Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62449 27.0381C10.8076 28.497 13.3743 29.2758 16 29.276C19.5199 29.2723 22.8947 27.8724 25.3838 25.3835C27.8729 22.8946 29.273 19.52 29.277 16C29.277 13.3743 28.4984 10.8076 27.0396 8.62436C25.5809 6.44115 23.5075 4.73953 21.0817 3.73468C18.6559 2.72982 15.9866 2.46685 13.4113 2.97903C10.8361 3.4912 8.4705 4.75552 6.61378 6.6121C4.75705 8.46868 3.49257 10.8341 2.9802 13.4094C2.46783 15.9846 2.73059 18.6539 3.73527 21.0798C4.73994 23.5057 6.44139 25.5792 8.62449 27.0381ZM14.828 20.4C13.6919 20.4 12.5814 20.0631 11.6368 19.432C10.6922 18.8008 9.95598 17.9037 9.52123 16.8541C9.08648 15.8046 8.97272 14.6496 9.19435 13.5354C9.41599 12.4212 9.96306 11.3977 10.7664 10.5944C11.5697 9.79106 12.5932 9.244 13.7074 9.02237C14.8216 8.80073 15.9765 8.91448 17.0261 9.34923C18.0757 9.78398 18.9728 10.5202 19.604 11.4648C20.2351 12.4094 20.572 13.5199 20.572 14.656C20.5706 16.0155 20.0878 17.3249 19.2181 18.3564L22.7342 21.9904L21.7999 22.8944L18.2731 19.2492C17.2851 19.9906 16.0777 20.3987 14.828 20.4Z"\n  />\n</svg>\n';
const __vite_glob_0_83 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M17.069 24.015H14.937C14.7016 24.0149 14.4739 23.9311 14.2947 23.7784C14.1155 23.6258 13.9965 23.4144 13.959 23.182L13.748 21.794C13.681 21.769 13.614 21.741 13.548 21.712L12.485 22.517C12.3109 22.6548 12.096 22.7308 11.874 22.733C11.7407 22.7309 11.6091 22.7025 11.4867 22.6495C11.3644 22.5965 11.2537 22.5199 11.161 22.424C10.5708 21.9277 10.0296 21.3758 9.54499 20.776C9.40092 20.584 9.32618 20.3489 9.33299 20.109C9.33514 19.8907 9.41049 19.6794 9.54699 19.509C9.68999 19.309 9.86299 19.089 10.037 18.869C10.127 18.755 10.217 18.642 10.306 18.526C10.263 18.426 10.222 18.326 10.184 18.226L8.81899 18.026C8.58972 17.986 8.3814 17.8678 8.22951 17.6915C8.07762 17.5152 7.99156 17.2917 7.98599 17.059V14.916C7.98845 14.7 8.0591 14.4902 8.18787 14.3167C8.31664 14.1433 8.49692 14.0149 8.70299 13.95L10.188 13.712C10.218 13.634 10.251 13.556 10.288 13.479C10.036 13.145 9.78099 12.823 9.51599 12.5C9.37703 12.3344 9.29593 12.1279 9.28499 11.912C9.28102 11.6648 9.36343 11.424 9.51799 11.231C9.51799 11.231 11.047 9.279 11.86 9.279C12.0968 9.27824 12.3271 9.35596 12.515 9.5L13.528 10.292L13.71 10.216C13.7663 9.72568 13.8501 9.23892 13.961 8.758C14.0064 8.53326 14.1304 8.33204 14.3107 8.19039C14.491 8.04875 14.7159 7.97594 14.945 7.985H17.064C17.3005 7.98661 17.529 8.07085 17.71 8.22315C17.891 8.37545 18.013 8.58623 18.055 8.819L18.255 10.207C18.322 10.233 18.39 10.26 18.455 10.289L19.524 9.495C19.6925 9.34445 19.9121 9.26396 20.138 9.27C20.3859 9.27648 20.6236 9.37034 20.809 9.535C21.4114 10.0538 21.9638 10.628 22.459 11.25C22.5954 11.429 22.6693 11.6479 22.6693 11.873C22.6693 12.0981 22.5954 12.317 22.459 12.496C22.314 12.696 22.141 12.919 21.965 13.139C21.876 13.252 21.787 13.365 21.698 13.48C21.74 13.574 21.78 13.67 21.818 13.766L23.188 13.977C23.417 14.0165 23.6252 14.1345 23.7767 14.3108C23.9281 14.4871 24.0135 14.7106 24.018 14.943V17.084C24.0137 17.3073 23.937 17.5231 23.7993 17.6989C23.6617 17.8748 23.4707 18.0012 23.255 18.059L21.795 18.283C21.7643 18.3583 21.731 18.4323 21.695 18.505C21.947 18.842 22.202 19.16 22.466 19.481C22.6129 19.65 22.6988 19.8634 22.71 20.087C22.7159 20.2178 22.6955 20.3485 22.65 20.4714C22.6044 20.5942 22.5347 20.7066 22.445 20.802C22.445 20.802 20.932 22.721 20.133 22.721C19.9109 22.7145 19.6952 22.6451 19.511 22.521L18.477 21.712L18.295 21.788C18.238 22.2783 18.1539 22.765 18.043 23.246C17.991 23.4651 17.8665 23.6603 17.6897 23.7999C17.5129 23.9394 17.2942 24.0152 17.069 24.015ZM13.4 20.193L13.763 20.378C14.0084 20.5039 14.264 20.6089 14.527 20.692L14.912 20.814L15.202 22.714H16.828C16.9289 22.2332 17.0001 21.7466 17.041 21.257L17.077 20.826L17.488 20.692C17.7543 20.6059 18.0132 20.4982 18.262 20.37L18.632 20.178L20.119 21.341C20.5466 20.9656 20.9475 20.561 21.319 20.13C20.999 19.738 20.704 19.36 20.409 18.948L20.174 18.618L20.366 18.262C20.4978 18.0156 20.6082 17.7583 20.696 17.493L20.822 17.115L22.714 16.828V15.218L20.83 14.93L20.709 14.542C20.6206 14.2565 20.5047 13.9802 20.363 13.717L20.173 13.362L20.406 13.033C20.579 12.79 20.762 12.559 20.943 12.333C21.062 12.182 21.182 12.033 21.295 11.88C20.9347 11.4461 20.543 11.0394 20.123 10.663L18.6 11.805L18.24 11.622C17.9946 11.4961 17.739 11.3911 17.476 11.308L17.088 11.185L16.811 9.285H15.173C15.0724 9.76583 15.0016 10.2524 14.961 10.742L14.925 11.173L14.513 11.307C14.247 11.3931 13.9884 11.5008 13.74 11.629L13.369 11.821L11.875 10.652C11.4462 11.0268 11.0452 11.4322 10.675 11.865C10.986 12.25 11.275 12.627 11.575 13.027L11.817 13.358L11.623 13.719C11.4905 13.9644 11.3816 14.2219 11.298 14.488L11.176 14.872L9.29299 15.167V16.78L11.181 17.059L11.3 17.459C11.3864 17.7465 11.5017 18.0246 11.644 18.289L11.834 18.644L11.601 18.972C11.428 19.217 11.244 19.448 11.063 19.672C10.941 19.826 10.821 19.978 10.705 20.133C11.0711 20.5641 11.4688 20.9672 11.895 21.339L13.4 20.193ZM20.374 10.474L20.305 10.526C20.3304 10.5121 20.3536 10.4946 20.374 10.474Z"\n  />\n  <path\n    d="M16 19.4C15.3275 19.4 14.6702 19.2006 14.1111 18.827C13.5519 18.4534 13.1161 17.9224 12.8588 17.3011C12.6015 16.6799 12.5341 15.9962 12.6653 15.3367C12.7965 14.6772 13.1203 14.0713 13.5958 13.5958C14.0713 13.1203 14.6771 12.7965 15.3367 12.6653C15.9962 12.5341 16.6798 12.6015 17.3011 12.8588C17.9224 13.1161 18.4534 13.5519 18.827 14.1111C19.2006 14.6702 19.4 15.3275 19.4 16C19.4 16.9017 19.0418 17.7665 18.4042 18.4042C17.7665 19.0418 16.9017 19.4 16 19.4ZM16 13.9C15.5847 13.9 15.1786 14.0232 14.8333 14.2539C14.488 14.4847 14.2188 14.8126 14.0598 15.1964C13.9009 15.5801 13.8593 16.0023 13.9403 16.4097C14.0214 16.8171 14.2214 17.1912 14.5151 17.4849C14.8088 17.7786 15.1829 17.9786 15.5903 18.0596C15.9977 18.1407 16.4199 18.0991 16.8036 17.9401C17.1874 17.7812 17.5153 17.512 17.7461 17.1667C17.9768 16.8214 18.1 16.4153 18.1 16C18.1 15.443 17.8787 14.9089 17.4849 14.5151C17.0911 14.1213 16.5569 13.9 16 13.9Z"\n  />\n  <path\n    d="M16 29.276C13.3743 29.276 10.8075 28.4974 8.62425 27.0386C6.44103 25.5798 4.73941 23.5064 3.73458 21.0805C2.72975 18.6546 2.46684 15.9853 2.9791 13.41C3.49136 10.8347 4.75577 8.46914 6.61245 6.61245C8.46914 4.75577 10.8347 3.49136 13.41 2.9791C15.9853 2.46684 18.6546 2.72975 21.0805 3.73458C23.5064 4.73941 25.5798 6.44103 27.0386 8.62425C28.4974 10.8075 29.276 13.3743 29.276 16C29.2723 19.5199 27.8724 22.8945 25.3835 25.3835C22.8945 27.8724 19.5199 29.2723 16 29.276ZM16 4.023C13.6312 4.023 11.3155 4.72544 9.34594 6.04149C7.37633 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.791 16.0133 4.25314 18.3366C4.71527 20.6599 5.85597 22.794 7.53099 24.469C9.206 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7103 9.7804 24.4649 7.53508C22.2196 5.28976 19.1754 4.02671 16 4.023Z"\n  />\n</svg>\n';
const __vite_glob_0_84 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 13.9C15.5846 13.9 15.1786 14.0232 14.8333 14.2539C14.4879 14.4847 14.2188 14.8126 14.0598 15.1964C13.9009 15.5801 13.8593 16.0023 13.9403 16.4097C14.0214 16.8171 14.2214 17.1912 14.5151 17.4849C14.8087 17.7786 15.1829 17.9786 15.5903 18.0597C15.9976 18.1407 16.4199 18.0991 16.8036 17.9402C17.1873 17.7812 17.5153 17.512 17.7461 17.1667C17.9768 16.8214 18.1 16.4153 18.1 16C18.1 15.4431 17.8787 14.9089 17.4849 14.5151C17.0911 14.1213 16.5569 13.9 16 13.9Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M13.4 20.193L13.763 20.378C14.0084 20.5039 14.264 20.6089 14.527 20.692L14.912 20.814L15.202 22.714H16.828C16.9289 22.2332 17 21.7466 17.041 21.257L17.077 20.826L17.488 20.692C17.7543 20.6059 18.0132 20.4983 18.262 20.37L18.632 20.178L20.119 21.341C20.5465 20.9656 20.9475 20.561 21.319 20.13C20.999 19.738 20.704 19.36 20.409 18.948L20.174 18.618L20.366 18.262C20.4977 18.0156 20.6081 17.7583 20.696 17.493L20.822 17.115L22.714 16.828V15.218L20.83 14.93L20.709 14.542C20.6205 14.2565 20.5047 13.9802 20.363 13.717L20.173 13.362L20.406 13.033C20.579 12.79 20.762 12.559 20.943 12.333L21.0153 12.2415C21.1103 12.1215 21.2048 12.002 21.295 11.88C20.9347 11.4462 20.5429 11.0394 20.123 10.663L18.6 11.805L18.24 11.622C17.9945 11.4961 17.739 11.3911 17.476 11.308L17.088 11.185L16.811 9.28501H15.173C15.0875 9.69348 15.0235 10.1061 14.9813 10.5212C14.9739 10.5947 14.9671 10.6683 14.961 10.742L14.925 11.173L14.513 11.307C14.2469 11.3931 13.9884 11.5008 13.74 11.629L13.369 11.821L11.875 10.652C11.4462 11.0268 11.0451 11.4322 10.675 11.865C10.986 12.25 11.275 12.627 11.575 13.027L11.817 13.358L11.623 13.719C11.4904 13.9644 11.3816 14.2219 11.298 14.488L11.176 14.872L9.29296 15.167V16.78L11.181 17.059L11.3 17.459C11.3864 17.7466 11.5016 18.0246 11.644 18.289L11.834 18.644L11.601 18.972C11.428 19.217 11.244 19.448 11.063 19.672C10.941 19.826 10.821 19.978 10.705 20.133C11.071 20.5641 11.4688 20.9672 11.895 21.339L13.4 20.193ZM16 19.4C15.3275 19.4 14.6702 19.2006 14.111 18.827C13.5519 18.4534 13.1161 17.9224 12.8588 17.3011C12.6014 16.6799 12.5341 15.9962 12.6653 15.3367C12.7965 14.6772 13.1203 14.0713 13.5958 13.5958C14.0713 13.1203 14.6771 12.7965 15.3367 12.6653C15.9962 12.5341 16.6798 12.6015 17.3011 12.8588C17.9224 13.1162 18.4534 13.5519 18.827 14.1111C19.2006 14.6702 19.4 15.3276 19.4 16C19.4 16.9017 19.0418 17.7665 18.4041 18.4042C17.7665 19.0418 16.9017 19.4 16 19.4Z"\n  />\n  <path\n    d="M20.374 10.474L20.305 10.526C20.3304 10.5121 20.3536 10.4946 20.374 10.474Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62425 27.0386C10.8075 28.4974 13.3743 29.276 16 29.276C19.5199 29.2723 22.8945 27.8724 25.3835 25.3835C27.8724 22.8945 29.2723 19.5199 29.276 16C29.276 13.3743 28.4974 10.8075 27.0386 8.62425C25.5798 6.44103 23.5064 4.73941 21.0805 3.73458C18.6546 2.72975 15.9853 2.46684 13.41 2.9791C10.8347 3.49136 8.46914 4.75577 6.61245 6.61245C4.75577 8.46914 3.49136 10.8347 2.9791 13.41C2.46684 15.9853 2.72975 18.6546 3.73458 21.0805C4.73941 23.5064 6.44103 25.5798 8.62425 27.0386ZM17.069 24.015H14.937C14.7016 24.0149 14.4739 23.9311 14.2947 23.7784C14.1155 23.6258 13.9965 23.4144 13.959 23.182L13.748 21.794C13.681 21.769 13.614 21.741 13.548 21.712L12.485 22.517C12.3109 22.6548 12.096 22.7308 11.874 22.733C11.7406 22.7309 11.609 22.7025 11.4867 22.6495C11.3643 22.5965 11.2537 22.5199 11.161 22.424C10.5708 21.9277 10.0296 21.3758 9.54496 20.776C9.40089 20.5841 9.32615 20.3489 9.33296 20.109C9.3351 19.8907 9.41046 19.6794 9.54696 19.509C9.68996 19.309 9.86296 19.089 10.037 18.869L10.0882 18.8042C10.1611 18.712 10.2339 18.62 10.306 18.526C10.263 18.426 10.222 18.326 10.184 18.226L8.81896 18.026C8.58969 17.9861 8.38137 17.8678 8.22948 17.6915C8.07759 17.5152 7.99153 17.2917 7.98596 17.059V14.916C7.98842 14.7 8.05907 14.4902 8.18784 14.3168C8.3166 14.1433 8.49689 14.0149 8.70296 13.95L10.188 13.712C10.218 13.634 10.251 13.556 10.288 13.479C10.036 13.145 9.78096 12.823 9.51596 12.5C9.377 12.3344 9.2959 12.1279 9.28496 11.912C9.28099 11.6648 9.3634 11.424 9.51796 11.231C9.51796 11.231 11.047 9.27901 11.86 9.27901C12.0967 9.27825 12.3271 9.35597 12.515 9.50001L13.528 10.292L13.71 10.216C13.7663 9.72569 13.8501 9.23892 13.961 8.75801C14.0064 8.53326 14.1304 8.33205 14.3107 8.1904C14.491 8.04876 14.7159 7.97594 14.945 7.98501H17.064C17.3005 7.98662 17.529 8.07086 17.71 8.22316C17.8909 8.37546 18.013 8.58623 18.055 8.81901L18.255 10.207C18.322 10.233 18.39 10.26 18.455 10.289L19.524 9.49501C19.6925 9.34446 19.9121 9.26397 20.138 9.27001C20.3859 9.27649 20.6235 9.37035 20.809 9.53501C21.4114 10.0538 21.9638 10.628 22.459 11.25C22.5954 11.4291 22.6693 11.6479 22.6693 11.873C22.6693 12.0981 22.5954 12.317 22.459 12.496C22.314 12.696 22.141 12.919 21.965 13.139C21.876 13.252 21.787 13.365 21.698 13.48C21.74 13.574 21.78 13.67 21.818 13.766L23.188 13.977C23.417 14.0165 23.6252 14.1345 23.7766 14.3108C23.9281 14.4871 24.0134 14.7106 24.018 14.943V17.084C24.0137 17.3073 23.9369 17.5231 23.7993 17.6989C23.6617 17.8748 23.4706 18.0012 23.255 18.059L21.795 18.283C21.7643 18.3583 21.731 18.4323 21.695 18.505C21.947 18.842 22.202 19.16 22.466 19.481C22.6128 19.65 22.6988 19.8634 22.71 20.087C22.7159 20.2178 22.6955 20.3486 22.6499 20.4714C22.6044 20.5942 22.5347 20.7066 22.445 20.802C22.445 20.802 20.932 22.721 20.133 22.721C19.9109 22.7145 19.6952 22.6451 19.511 22.521L18.477 21.712L18.295 21.788C18.238 22.2783 18.1539 22.765 18.043 23.246C17.9909 23.4651 17.8665 23.6603 17.6897 23.7999C17.5129 23.9394 17.2942 24.0152 17.069 24.015Z"\n  />\n</svg>\n';
const __vite_glob_0_85 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M20.2 23.111C20.0954 23.1105 19.9925 23.0848 19.9 23.036L16 20.988L12.1 23.036C11.9927 23.0924 11.8717 23.1176 11.7508 23.1089C11.6298 23.1001 11.5138 23.0577 11.4157 22.9865C11.3176 22.9152 11.2414 22.8179 11.1957 22.7057C11.15 22.5934 11.1366 22.4705 11.157 22.351L11.901 18.013L8.74901 14.94C8.66236 14.8553 8.60112 14.7481 8.57216 14.6305C8.5432 14.5129 8.54769 14.3895 8.58513 14.2743C8.62256 14.1591 8.69144 14.0566 8.78401 13.9784C8.87658 13.9003 8.98916 13.8496 9.10902 13.832L13.465 13.198L15.413 9.251C15.4729 9.14962 15.5581 9.06559 15.6604 9.00722C15.7626 8.94885 15.8783 8.91815 15.996 8.91815C16.1137 8.91815 16.2294 8.94885 16.3317 9.00722C16.4339 9.06559 16.5192 9.14962 16.579 9.251L18.527 13.198L22.883 13.832C23.0029 13.8496 23.1155 13.9003 23.208 13.9784C23.3006 14.0566 23.3695 14.1591 23.4069 14.2743C23.4443 14.3895 23.4488 14.5129 23.4199 14.6305C23.3909 14.7481 23.3297 14.8553 23.243 14.94L20.1 18.013L20.844 22.351C20.86 22.4443 20.8555 22.54 20.8306 22.6314C20.8058 22.7228 20.7613 22.8077 20.7003 22.8801C20.6392 22.9525 20.5631 23.0106 20.4772 23.0505C20.3913 23.0904 20.2977 23.1111 20.203 23.111H20.2ZM16 19.6C16.1045 19.6002 16.2074 19.6255 16.3 19.674L19.332 21.268L18.753 17.892C18.7354 17.7881 18.7431 17.6815 18.7755 17.5812C18.8079 17.4809 18.864 17.39 18.939 17.316L21.393 14.924L18.003 14.432C17.8987 14.4167 17.7998 14.3764 17.7146 14.3143C17.6294 14.2523 17.5606 14.1705 17.514 14.076L16 11.007L14.483 14.08C14.4365 14.1745 14.3676 14.2563 14.2825 14.3183C14.1973 14.3804 14.0983 14.4207 13.994 14.436L10.604 14.928L13.058 17.32C13.1331 17.394 13.1892 17.485 13.2215 17.5852C13.2539 17.6855 13.2616 17.7921 13.244 17.896L12.665 21.272L15.697 19.678C15.7901 19.6277 15.8942 19.6009 16 19.6Z"\n  />\n  <path\n    d="M16 29.276C13.3743 29.2758 10.8076 28.497 8.62452 27.0381C6.44142 25.5792 4.73997 23.5057 3.7353 21.0798C2.73062 18.6539 2.46786 15.9846 2.98023 13.4094C3.4926 10.8341 4.75708 8.46868 6.61381 6.6121C8.47053 4.75552 10.8361 3.4912 13.4114 2.97903C15.9866 2.46685 18.6559 2.72982 21.0817 3.73468C23.5075 4.73953 25.5809 6.44115 27.0397 8.62436C28.4984 10.8076 29.277 13.3743 29.277 16C29.273 19.52 27.8729 22.8946 25.3838 25.3835C22.8947 27.8724 19.52 29.2723 16 29.276ZM16 4.023C13.6312 4.023 11.3156 4.72544 9.34595 6.04149C7.37635 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.79101 16.0133 4.25315 18.3366C4.71528 20.6599 5.85597 22.794 7.53098 24.469C9.20599 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7103 9.7804 24.4649 7.53508C22.2196 5.28976 19.1754 4.02671 16 4.023Z"\n  />\n</svg>\n';
const __vite_glob_0_86 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.3 19.674C16.2074 19.6255 16.1045 19.6002 16 19.6C15.8942 19.6009 15.7902 19.6277 15.697 19.678L12.6651 21.272L13.244 17.896C13.2616 17.7921 13.254 17.6855 13.2216 17.5852C13.1892 17.485 13.1331 17.394 13.0581 17.32L10.604 14.928L13.994 14.436C14.0983 14.4207 14.1973 14.3804 14.2825 14.3183C14.3677 14.2563 14.4365 14.1745 14.483 14.08L16 11.007L17.5141 14.076C17.5606 14.1705 17.6294 14.2523 17.7146 14.3143C17.7998 14.3764 17.8988 14.4167 18.003 14.432L21.393 14.924L18.939 17.316C18.864 17.39 18.8079 17.4809 18.7755 17.5812C18.7431 17.6815 18.7354 17.7881 18.753 17.892L19.332 21.268L16.3 19.674Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62449 27.0381C10.8076 28.497 13.3743 29.2758 16 29.276C19.5199 29.2723 22.8947 27.8724 25.3838 25.3835C27.8729 22.8946 29.273 19.52 29.277 16C29.277 13.3743 28.4984 10.8076 27.0396 8.62436C25.5809 6.44115 23.5075 4.73953 21.0817 3.73468C18.6559 2.72982 15.9866 2.46685 13.4113 2.97903C10.8361 3.4912 8.4705 4.75552 6.61378 6.6121C4.75705 8.46868 3.49257 10.8341 2.9802 13.4094C2.46783 15.9846 2.73059 18.6539 3.73527 21.0798C4.73994 23.5057 6.44139 25.5792 8.62449 27.0381ZM19.9 23.036C19.9925 23.0848 20.0955 23.1105 20.2001 23.111H20.203C20.2977 23.1111 20.3913 23.0904 20.4772 23.0505C20.5631 23.0106 20.6392 22.9525 20.7003 22.8801C20.7614 22.8077 20.8058 22.7228 20.8307 22.6314C20.8555 22.54 20.8601 22.4443 20.844 22.351L20.1 18.013L23.2431 14.94C23.3297 14.8553 23.3909 14.7481 23.4199 14.6305C23.4489 14.5129 23.4444 14.3895 23.4069 14.2743C23.3695 14.1591 23.3006 14.0566 23.2081 13.9784C23.1155 13.9003 23.0029 13.8496 22.883 13.832L18.5271 13.198L16.5791 9.251C16.5192 9.14962 16.4339 9.06559 16.3317 9.00722C16.2295 8.94885 16.1138 8.91815 15.996 8.91815C15.8783 8.91815 15.7626 8.94885 15.6604 9.00722C15.5581 9.06559 15.4729 9.14962 15.413 9.251L13.465 13.198L9.10905 13.832C8.98919 13.8496 8.87661 13.9003 8.78404 13.9784C8.69147 14.0566 8.62259 14.1591 8.58516 14.2743C8.54772 14.3895 8.54323 14.5129 8.57219 14.6305C8.60115 14.7481 8.6624 14.8553 8.74904 14.94L11.901 18.013L11.1571 22.351C11.1366 22.4705 11.15 22.5934 11.1957 22.7057C11.2414 22.8179 11.3176 22.9152 11.4157 22.9865C11.5138 23.0577 11.6299 23.1001 11.7508 23.1089C11.8717 23.1176 11.9927 23.0924 12.1 23.036L16 20.988L19.9 23.036Z"\n  />\n</svg>\n';
const __vite_glob_0_87 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 29.276C13.3743 29.2758 10.8076 28.497 8.62452 27.0381C6.44142 25.5792 4.73997 23.5057 3.7353 21.0798C2.73062 18.6539 2.46786 15.9846 2.98023 13.4094C3.4926 10.8341 4.75708 8.46868 6.61381 6.6121C8.47053 4.75552 10.8361 3.4912 13.4114 2.97903C15.9866 2.46685 18.6559 2.72982 21.0817 3.73468C23.5075 4.73953 25.5809 6.44115 27.0397 8.62436C28.4984 10.8076 29.277 13.3743 29.277 16C29.273 19.52 27.8729 22.8946 25.3838 25.3835C22.8947 27.8724 19.52 29.2723 16 29.276ZM16 4.023C13.6312 4.023 11.3156 4.72544 9.34595 6.04149C7.37635 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.79101 16.0133 4.25315 18.3366C4.71528 20.6599 5.85597 22.794 7.53098 24.469C9.20599 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7103 9.7804 24.4649 7.53508C22.2196 5.28976 19.1754 4.02671 16 4.023Z"\n  />\n  <path\n    d="M16 23.609C14.6523 23.6077 13.3602 23.0717 12.4072 22.1188C11.4543 21.1658 10.9183 19.8737 10.917 18.526V11.687H12.217V18.526C12.217 19.529 12.6154 20.491 13.3247 21.2003C14.034 21.9095 14.9959 22.308 15.999 22.308C17.002 22.308 17.964 21.9095 18.6733 21.2003C19.3825 20.491 19.781 19.529 19.781 18.526V13.526H21.081V18.526C21.0797 19.8733 20.544 21.1651 19.5915 22.1181C18.6389 23.071 17.3473 23.6071 16 23.609Z"\n  />\n  <path d="M18.771 10.927H17.47V17.075H18.771V10.927Z" />\n  <path d="M14.608 9.535H13.307V17.076H14.608V9.535Z" />\n  <path d="M16.689 9.041H15.388V17.076H16.689V9.041Z" />\n</svg>\n';
const __vite_glob_0_88 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.62449 27.0381C10.8076 28.497 13.3743 29.2758 16 29.276C19.5199 29.2723 22.8947 27.8724 25.3838 25.3835C27.8729 22.8946 29.273 19.52 29.277 16C29.277 13.3743 28.4984 10.8076 27.0396 8.62436C25.5809 6.44115 23.5075 4.73953 21.0817 3.73468C18.6559 2.72982 15.9866 2.46685 13.4113 2.97903C10.8361 3.4912 8.4705 4.75552 6.61378 6.6121C4.75705 8.46868 3.49257 10.8341 2.9802 13.4094C2.46783 15.9846 2.73059 18.6539 3.73527 21.0798C4.73994 23.5057 6.44139 25.5792 8.62449 27.0381ZM16.689 9.041H15.388V17.076H16.689V9.041ZM13.307 9.535H14.608V17.076H13.307V9.535ZM18.771 10.927H17.47V17.075H18.771V10.927ZM16 23.609C14.6523 23.6077 13.3602 23.0717 12.4072 22.1188C11.4543 21.1658 10.9183 19.8737 10.917 18.526V11.687H12.217V18.526C12.217 19.529 12.6154 20.491 13.3247 21.2003C14.034 21.9095 14.9959 22.308 15.999 22.308C17.002 22.308 17.964 21.9095 18.6733 21.2003C19.3825 20.491 19.781 19.529 19.781 18.526V13.526H21.081V18.526C21.0797 19.8733 20.544 21.1651 19.5915 22.1181C18.6389 23.071 17.3473 23.6071 16 23.609Z"\n  />\n</svg>\n';
const __vite_glob_0_89 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.276 29.552C13.6503 29.552 11.0835 28.7734 8.90026 27.3146C6.71703 25.8558 5.01541 23.7824 4.01058 21.3565C3.00575 18.9306 2.74284 16.2613 3.2551 13.686C3.76736 11.1107 5.03178 8.74514 6.88846 6.88846C8.74515 5.03177 11.1107 3.76736 13.686 3.2551C16.2613 2.74284 18.9306 3.00575 21.3565 4.01058C23.7824 5.01541 25.8558 6.71703 27.3146 8.90026C28.7734 11.0835 29.552 13.6503 29.552 16.276C29.5483 19.7959 28.1484 23.1705 25.6595 25.6595C23.1705 28.1484 19.7959 29.5483 16.276 29.552ZM16.276 4.29901C13.9072 4.29901 11.5915 5.00144 9.62194 6.31749C7.65233 7.63354 6.11721 9.5041 5.2107 11.6926C4.30419 13.8811 4.067 16.2893 4.52913 18.6126C4.99127 20.9359 6.13197 23.07 7.80698 24.745C9.48199 26.42 11.6161 27.5607 13.9394 28.0229C16.2627 28.485 18.6709 28.2478 20.8594 27.3413C23.0479 26.4348 24.9185 24.8997 26.2345 22.9301C27.5506 20.9605 28.253 18.6448 28.253 16.276C28.2493 13.1006 26.9862 10.0564 24.7409 7.81108C22.4956 5.56576 19.4514 4.30271 16.276 4.29901Z"\n  />\n  <path\n    d="M14.328 20.812C14.2426 20.812 14.1579 20.7951 14.079 20.7623C14.0001 20.7295 13.9284 20.6815 13.868 20.621L10.158 16.911L11.077 15.992L14.323 19.237L21.47 11.937L22.399 12.846L14.792 20.617C14.7323 20.6793 14.6608 20.729 14.5816 20.7634C14.5025 20.7977 14.4173 20.8159 14.331 20.817L14.328 20.812Z"\n  />\n</svg>\n';
const __vite_glob_0_90 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M8.90026 27.3146C11.0835 28.7734 13.6503 29.552 16.276 29.552C19.7959 29.5483 23.1705 28.1484 25.6595 25.6595C28.1484 23.1705 29.5483 19.7959 29.552 16.276C29.552 13.6503 28.7734 11.0835 27.3146 8.90026C25.8558 6.71703 23.7824 5.01541 21.3565 4.01058C18.9306 3.00575 16.2613 2.74284 13.686 3.2551C11.1107 3.76736 8.74515 5.03177 6.88846 6.88846C5.03178 8.74514 3.76736 11.1107 3.2551 13.686C2.74284 16.2613 3.00575 18.9306 4.01058 21.3565C5.01541 23.7824 6.71703 25.8558 8.90026 27.3146ZM14.079 20.7623C14.1579 20.7951 14.2426 20.812 14.328 20.812L14.331 20.817C14.4173 20.8159 14.5025 20.7977 14.5816 20.7634C14.6608 20.729 14.7323 20.6793 14.792 20.617L22.399 12.846L21.47 11.937L14.323 19.237L11.077 15.992L10.158 16.911L13.868 20.621C13.9284 20.6815 14.0001 20.7295 14.079 20.7623Z"\n  />\n</svg>\n';
const __vite_glob_0_91 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="nonzero"\n    d="M20.8,3.3 C22.5,3.3 23.9,4.7 23.9,6.3 L23.9,27 C23.9,28.7 22.5,30.1 20.8,30.1 L3.2,30.1 C1.5,30.1 0.1,28.7 0.1,27 L0.1,6.3 C0.1,5.5 0.5,4.7 1.1,4.1 C1.7,3.5 2.5,3.2 3.3,3.3 L8,3.3 C8.4,1.4 10.1,0 12.1,0 C14.1,0 15.8,1.4 16.2,3.3 L20.8,3.3 Z M6.3,4.7 L6.3,8.2 L17.8,8.2 L17.8,4.7 C17.7,4.7 6.3,4.7 6.3,4.7 Z M12,1.2 L12,1.2 C10.8,1.2 9.8,2.1 9.4,3.2 L14.5,3.2 C14.3,2.1 13.2,1.2 12,1.2 Z M22.4,27 L22.4,6.3 C22.4,5.4 21.7,4.7 20.8,4.7 L19.2,4.7 L19.2,8.9 C19.2,9.3 18.9,9.7 18.4,9.7 L5.4,9.7 C5,9.7 4.6,9.4 4.6,8.9 L4.6,4.7 L3.2,4.7 C2.3,4.7 1.6,5.4 1.6,6.3 L1.6,27 C1.6,27.9 2.3,28.5 3.2,28.5 L20.8,28.5 C21.7,28.5 22.4,27.8 22.4,27 Z"\n  />\n  <path\n    d="M10,13.5 L18.5,13.5 L18.5,15 L10,15 L10,13.5 Z M5.5,13.5 L8,13.5 L8,15 L5.5,15 L5.5,13.5 Z M10,18.6 L18.5,18.6 L18.5,20.1 L10,20.1 L10,18.6 Z M5.5,18.6 L8,18.6 L8,20.1 L5.5,20.1 L5.5,18.6 Z M10,23.6 L18.5,23.6 L18.5,25.1 L10,25.1 L10,23.6 Z M5.5,23.6 L8,23.6 L8,25.1 L5.5,25.1 L5.5,23.6 Z"\n  />\n</svg>\n';
const __vite_glob_0_92 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="nonzero"\n    d="M20.8,3.3 C22.5,3.3 23.9,4.7 23.9,6.3 L23.9,27 C23.9,28.7 22.5,30.1 20.8,30.1 L3.2,30.1 C1.5,30.1 0.1,28.7 0.1,27 L0.1,6.3 C0.1,5.5 0.5,4.7 1.1,4.1 C1.7,3.5 2.5,3.2 3.3,3.3 L8,3.3 C8.4,1.4 10.1,0 12.1,0 C14.1,0 15.8,1.4 16.2,3.3 L20.8,3.3 Z M6.3,4.7 L6.3,8.2 L17.8,8.2 L17.8,4.7 C17.7,4.7 6.3,4.7 6.3,4.7 Z M12,1.2 L12,1.2 C10.8,1.2 9.8,2.1 9.4,3.2 L14.5,3.2 C14.3,2.1 13.2,1.2 12,1.2 Z M22.4,27 L22.4,6.3 C22.4,5.4 21.7,4.7 20.8,4.7 L19.2,4.7 L19.2,8.9 C19.2,9.3 18.9,9.7 18.4,9.7 L5.4,9.7 C5,9.7 4.6,9.4 4.6,8.9 L4.6,4.7 L3.2,4.7 C2.3,4.7 1.6,5.4 1.6,6.3 L1.6,27 C1.6,27.9 2.3,28.5 3.2,28.5 L20.8,28.5 C21.7,28.5 22.4,27.8 22.4,27 Z"\n  />\n  <path\n    d="M10.3,23.1 L18.5,13.9 L19.7,14.8 L10.9,24.6 C10.7,24.8 10.5,24.9 10.3,24.9 C10.1,24.9 9.9,24.8 9.8,24.7 L5,20.9 L6,19.7 L10.3,23.1 Z M10.3,21.2 C10.1,21.2 9.9,21.1 9.8,21 L6.3,18.2 L7.3,17 L10.2,19.4 L16.7,12 L17.9,13 L10.9,20.9 C10.7,21.1 10.5,21.2 10.3,21.2 Z"\n  />\n</svg>\n';
const __vite_glob_0_93 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.3 5.222H19.7591C19.6199 4.32597 19.165 3.50923 18.4763 2.91928C17.7877 2.32934 16.9108 2.00508 16.0041 2.00508C15.0973 2.00508 14.2204 2.32934 13.5318 2.91928C12.8431 3.50923 12.3882 4.32597 12.2491 5.222H7.70007C6.99749 5.22279 6.32392 5.50224 5.82712 5.99904C5.33032 6.49584 5.05084 7.16941 5.05005 7.87199V27.324C5.05084 28.0266 5.33032 28.7002 5.82712 29.197C6.32392 29.6938 6.99749 29.9732 7.70007 29.974H24.3C25.0026 29.9732 25.6762 29.6938 26.173 29.197C26.6698 28.7002 26.9493 28.0266 26.9501 27.324V7.87199C26.9493 7.16941 26.6698 6.49584 26.173 5.99904C25.6762 5.50224 25.0026 5.22279 24.3 5.222ZM10.6501 6.522H21.3581V9.80901H10.6461L10.6501 6.522ZM16.0041 3.32201C16.5626 3.32376 17.1047 3.51146 17.5447 3.85551C17.9847 4.19956 18.2976 4.68035 18.4341 5.222H13.5741C13.7111 4.68176 14.0237 4.20236 14.4629 3.85916C14.902 3.51596 15.4427 3.32841 16.0001 3.326L16.0041 3.32201ZM25.6501 27.322C25.6498 27.68 25.5075 28.0232 25.2544 28.2763C25.0012 28.5294 24.658 28.6717 24.3 28.672H7.70007C7.34211 28.6717 6.99887 28.5294 6.74576 28.2763C6.49264 28.0232 6.35033 27.68 6.35007 27.322V7.87199C6.35033 7.51403 6.49264 7.17081 6.74576 6.91769C6.99887 6.66458 7.34211 6.52227 7.70007 6.522H9.34207V10.458C9.34207 10.6304 9.41054 10.7957 9.53244 10.9176C9.65434 11.0395 9.81967 11.108 9.99207 11.108H22.0001C22.1725 11.108 22.3378 11.0395 22.4597 10.9176C22.5816 10.7957 22.6501 10.6304 22.6501 10.458V6.522H24.3C24.658 6.52227 25.0012 6.66458 25.2544 6.91769C25.5075 7.17081 25.6498 7.51403 25.6501 7.87199V27.322Z"\n  />\n  <path\n    d="M14.0471 22.4L10.8011 19.154L9.8811 20.073L13.5921 23.784C13.7142 23.9058 13.8796 23.9741 14.0521 23.974C14.138 23.9735 14.2229 23.956 14.3021 23.9225C14.3812 23.889 14.4529 23.8403 14.5131 23.779L22.1241 16L21.1941 15.091L14.0471 22.4Z"\n  />\n</svg>\n';
const __vite_glob_0_94 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path d="M20.61 21.86l-5.17-5.52a.67.67 0 0 1-.18-.44V7.68h1.3v8l5 5.33z" />\n  <path\n    d="M16 28.76A12.76 12.76 0 1 1 28.76 16 12.77 12.77 0 0 1 16 28.76zm0-24.22A11.46 11.46 0 1 0 27.46 16 11.47 11.47 0 0 0 16 4.54z"\n  />\n</svg>\n';
const __vite_glob_0_95 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M4.90002 12.329L3.66602 11.92C3.4421 12.5983 3.27486 13.294 3.16602 14L4.45102 14.2C4.54861 13.565 4.6988 12.9392 4.90002 12.329Z"\n  />\n  <path\n    d="M4.31 16.12L3.01001 16.133C3.01939 16.8469 3.08625 17.5589 3.20999 18.262L4.491 18.038C4.37811 17.4047 4.31757 16.7632 4.31 16.12Z"\n  />\n  <path\n    d="M12.964 4.70601L12.628 3.45C11.9379 3.63544 11.2643 3.8776 10.614 4.174L11.153 5.357C11.7377 5.09056 12.3434 4.87282 12.964 4.70601Z"\n  />\n  <path\n    d="M3.74805 20.332C3.98633 21.0052 4.28002 21.6574 4.62607 22.282L5.76306 21.652C5.45186 21.0904 5.18828 20.5037 4.97507 19.898L3.74805 20.332Z"\n  />\n  <path\n    d="M6.686 8.934L5.64999 8.146C5.21827 8.71544 4.83367 9.3191 4.5 9.951L5.64999 10.557C5.9497 9.9882 6.29624 9.44532 6.686 8.934Z"\n  />\n  <path\n    d="M9.47501 6.3L8.74799 5.222C8.15575 5.62132 7.59723 6.06848 7.078 6.559L7.97101 7.503C8.43843 7.06135 8.94146 6.65899 9.47501 6.3Z"\n  />\n  <path\n    d="M12.885 28.615C13.5784 28.7862 14.2849 28.8995 14.997 28.954L15.097 27.654C14.4565 27.6062 13.821 27.5058 13.197 27.354L12.885 28.615Z"\n  />\n  <path\n    d="M6.83002 23.254L5.81104 24.062C6.25483 24.6215 6.74344 25.1439 7.27203 25.624L8.14603 24.661C7.67009 24.2283 7.22997 23.7578 6.83002 23.254Z"\n  />\n  <path\n    d="M28.992 16.007V15.733H28.982C28.9691 15.0204 28.8979 14.31 28.769 13.609H28.774C28.774 13.591 28.764 13.573 28.761 13.554C28.736 13.426 28.702 13.301 28.674 13.174C28.617 12.919 28.558 12.665 28.486 12.413C28.445 12.273 28.398 12.136 28.354 11.998C28.31 11.86 28.263 11.698 28.209 11.545L28.196 11.55C27.95 10.8799 27.649 10.2314 27.296 9.611L27.311 9.603C27.226 9.453 27.129 9.31101 27.038 9.16501C26.979 9.07101 26.923 8.976 26.862 8.884C26.705 8.644 26.538 8.414 26.362 8.184C26.301 8.103 26.243 8.02 26.181 7.94C26.153 7.906 26.129 7.868 26.101 7.834L26.094 7.84C25.6468 7.28404 25.1548 6.76565 24.623 6.29001L24.589 6.263C24.536 6.215 24.478 6.173 24.423 6.127C24.192 5.927 23.957 5.738 23.712 5.557C23.592 5.467 23.465 5.386 23.342 5.301C23.199 5.201 23.059 5.101 22.913 5.001L22.907 5.01C22.3019 4.63014 21.6664 4.30102 21.007 4.02601L21.012 4.014C20.907 3.969 20.796 3.93501 20.689 3.89401C20.535 3.83401 20.381 3.775 20.223 3.721C20.003 3.645 19.78 3.578 19.556 3.514C19.408 3.472 19.262 3.427 19.112 3.39C19.066 3.379 19.021 3.36301 18.975 3.35201V3.362C18.2804 3.19657 17.5733 3.0892 16.861 3.041V3.036C16.839 3.036 16.816 3.036 16.794 3.036L16.745 3.031C16.0717 2.99209 15.3965 3.00379 14.725 3.06601L14.85 4.36C15.4686 4.30215 16.0908 4.29178 16.711 4.329C17.4173 4.37239 18.1182 4.48017 18.805 4.65101C18.935 4.68301 19.063 4.722 19.192 4.759C19.399 4.817 19.605 4.87901 19.807 4.94901C19.944 4.99601 20.08 5.049 20.214 5.1C21.0572 5.42716 21.8593 5.85171 22.604 6.36501C22.716 6.44201 22.83 6.516 22.94 6.597C23.15 6.752 23.351 6.917 23.55 7.086C23.61 7.137 23.673 7.18601 23.732 7.235C24.253 7.6965 24.7319 8.20351 25.163 8.75C25.214 8.814 25.263 8.88201 25.31 8.95001C25.469 9.16001 25.624 9.37401 25.769 9.59501C25.823 9.67801 25.869 9.763 25.925 9.846C26.4293 10.6563 26.8323 11.5255 27.125 12.434C27.159 12.54 27.196 12.646 27.225 12.753C27.299 13.01 27.361 13.272 27.418 13.536C27.436 13.617 27.458 13.697 27.474 13.777C27.6168 14.5094 27.6895 15.2538 27.691 16C27.691 16.358 27.671 16.714 27.639 17.066C27.628 17.197 27.608 17.326 27.591 17.456C27.478 18.3715 27.256 19.2702 26.93 20.133C26.871 20.29 26.814 20.448 26.747 20.603C26.67 20.783 26.582 20.959 26.496 21.135C26.428 21.273 26.367 21.414 26.296 21.549C25.9646 22.1588 25.5794 22.7377 25.145 23.279C25.055 23.392 24.959 23.501 24.864 23.611C24.721 23.777 24.574 23.941 24.42 24.101C24.266 24.261 24.107 24.428 23.941 24.581L24.824 25.535C24.947 25.421 25.061 25.297 25.18 25.178L25.189 25.187C25.249 25.126 25.301 25.058 25.361 24.996C25.528 24.823 25.688 24.645 25.845 24.463C25.953 24.338 26.061 24.214 26.163 24.086C26.198 24.043 26.237 24.003 26.271 23.959L26.262 23.953C26.817 23.2383 27.2956 22.4674 27.69 21.653C27.775 21.477 27.862 21.304 27.939 21.125C28.016 20.946 28.088 20.749 28.159 20.56C28.204 20.441 28.259 20.323 28.298 20.203H28.288C28.518 19.5275 28.6916 18.8342 28.807 18.13H28.819C28.847 17.964 28.861 17.794 28.882 17.63C28.9 17.481 28.923 17.33 28.937 17.184C28.97 16.79 28.992 16.4 28.992 16.007Z"\n  />\n  <path\n    d="M20.738 26.692L21.266 27.881C21.9187 27.5912 22.5462 27.2477 23.142 26.854L22.427 25.77C21.8903 26.1231 21.3254 26.4315 20.738 26.692Z"\n  />\n  <path\n    d="M8.96802 26.926C9.56882 27.3129 10.2003 27.65 10.856 27.934L11.372 26.74C10.7815 26.4848 10.2129 26.1814 9.67203 25.833L8.96802 26.926Z"\n  />\n  <path\n    d="M17.0229 27.648L17.1369 28.943C17.8479 28.8809 18.5526 28.7605 19.2439 28.583L18.92 27.325C18.2974 27.4839 17.663 27.5919 17.0229 27.648Z"\n  />\n  <path\n    d="M16.65 15.743V7.778H15.35V16C15.3502 16.1651 15.4127 16.324 15.525 16.445L20.695 21.958L21.645 21.069L16.65 15.743Z"\n  />\n</svg>\n';
const __vite_glob_0_96 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M23.6193 13.9771C23.1159 10.309 19.9441 7.5 16.1312 7.5C12.7498 7.5 9.87794 9.70688 8.9173 12.7637C5.85482 13.2563 3.5 15.8908 3.5 19.0905C3.5 22.6438 6.40412 25.5 9.95643 25.5H22.6583C25.8711 25.5 28.5 22.9165 28.5 19.6994C28.5 16.8099 26.3791 14.4315 23.6193 13.9771ZM22.6583 15.3988H22.1889V15.0003C22.1889 11.6864 19.4768 9 16.1312 9C13.0664 9 10.5349 11.2549 10.1313 14.1809H9.95643C7.21907 14.1809 5 16.379 5 19.0905C5 21.8019 7.21907 24 9.95643 24H22.6583C25.0561 24 27 22.0746 27 19.6994C27 17.3242 25.0561 15.3988 22.6583 15.3988Z"\n  />\n</svg>\n';
const __vite_glob_0_97 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M23.6193 13.9771C23.1159 10.309 19.9441 7.5 16.1312 7.5C12.7498 7.5 9.87794 9.70688 8.9173 12.7637C5.85482 13.2563 3.5 15.8908 3.5 19.0905C3.5 22.6438 6.40412 25.5 9.95643 25.5H22.6583C25.8711 25.5 28.5 22.9165 28.5 19.6994C28.5 16.8099 26.3791 14.4315 23.6193 13.9771Z"\n  />\n</svg>\n';
const __vite_glob_0_98 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M19.2113 6.26977L18.3302 6.02213C18.2168 5.98335 18.1051 5.99555 17.9964 6.05861C17.8874 6.12172 17.8138 6.21646 17.776 6.34267L12.4765 25.1473C12.4386 25.2736 12.4505 25.3926 12.512 25.5042C12.5736 25.6159 12.6658 25.6911 12.7891 25.7299L13.67 25.9777C13.7837 26.0167 13.895 26.0045 14.0039 25.9413C14.1129 25.8779 14.1863 25.7835 14.2241 25.6575L19.5238 6.85255C19.5616 6.72633 19.5499 6.60725 19.4882 6.49547C19.4266 6.38374 19.3345 6.30849 19.2113 6.26977Z"\n  />\n  <path\n    d="M11.2691 9.94063C11.2691 9.81441 11.2217 9.70263 11.127 9.60559L10.4165 8.87726C10.3218 8.78017 10.2128 8.7315 10.0897 8.7315C9.9666 8.7315 9.85757 8.78022 9.76292 8.87726L3.14213 15.6649C3.04728 15.762 3 15.8737 3 15.9999C3 16.1262 3.04743 16.2379 3.14213 16.3349L9.76287 23.1226C9.85752 23.2198 9.96635 23.2682 10.0897 23.2682C10.213 23.2682 10.3218 23.2196 10.4165 23.1226L11.1269 22.3946C11.2216 22.2976 11.2691 22.1858 11.2691 22.0594C11.2691 21.9334 11.2216 21.8216 11.1269 21.7246L5.54329 15.9999L11.127 10.2757C11.2218 10.1786 11.2691 10.0668 11.2691 9.94063Z"\n  />\n  <path\n    d="M28.858 15.6647L22.237 8.87709C22.1424 8.78005 22.0333 8.73133 21.9104 8.73133C21.7871 8.73133 21.6785 8.78005 21.5835 8.87709L20.8733 9.60537C20.7787 9.70246 20.7314 9.81403 20.7314 9.9404C20.7314 10.0668 20.7786 10.1784 20.8733 10.2754L26.4571 15.9999L20.8733 21.7246C20.7787 21.8216 20.7314 21.9334 20.7314 22.0594C20.7314 22.1858 20.7786 22.2976 20.8733 22.3946L21.5835 23.1225C21.6785 23.2198 21.7872 23.2681 21.9104 23.2681C22.0334 23.2681 22.1424 23.2196 22.237 23.1225L28.858 16.3349C28.9527 16.2379 29 16.126 29 15.9998C29 15.8735 28.9527 15.7618 28.858 15.6647Z"\n  />\n</svg>\n';
const __vite_glob_0_99 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M17.686 28.262H14.323C14.0409 28.2613 13.7683 28.1604 13.5537 27.9772C13.3392 27.794 13.1968 27.5405 13.152 27.262L12.786 24.862C12.548 24.775 12.312 24.679 12.086 24.574L10.232 25.974C10.0046 26.1623 9.71388 26.2568 9.41919 26.2382C9.1245 26.2197 8.84797 26.0894 8.646 25.874C7.72201 25.0956 6.87389 24.2314 6.11301 23.293C5.94232 23.0619 5.85427 22.7802 5.86301 22.493C5.8639 22.2264 5.9544 21.9679 6.12 21.759C6.354 21.431 6.62001 21.092 6.89401 20.751C7.08201 20.512 7.27301 20.272 7.45901 20.025C7.3259 19.7473 7.20803 19.4626 7.10599 19.172L4.733 18.821C4.45806 18.7729 4.20849 18.6304 4.02725 18.4182C3.84601 18.2059 3.74442 17.9371 3.73999 17.658V14.291C3.74317 14.0303 3.82864 13.7773 3.98416 13.5681C4.13968 13.3589 4.3573 13.2042 4.60599 13.126L7.10599 12.726C7.19999 12.472 7.306 12.226 7.422 11.98C7.003 11.416 6.563 10.856 6.061 10.242C5.89233 10.0405 5.79402 9.78946 5.78101 9.527C5.77863 9.23392 5.87794 8.94908 6.06201 8.721C6.06201 8.721 8.43199 5.777 9.46799 5.777C9.75729 5.77734 10.0385 5.87293 10.268 6.049L12.04 7.435C12.266 7.331 12.4947 7.23534 12.726 7.148C12.8136 6.31299 12.9522 5.48411 13.141 4.666C13.2023 4.40135 13.3517 4.16535 13.5646 3.9966C13.7775 3.82785 14.0413 3.73632 14.313 3.737H17.685C17.9673 3.7387 18.24 3.8399 18.4551 4.02281C18.6702 4.20571 18.8139 4.4586 18.861 4.737L19.212 7.137C19.45 7.225 19.685 7.321 19.912 7.426L21.773 6.043C21.977 5.85874 22.2431 5.75837 22.518 5.762C22.8134 5.77323 23.0959 5.88588 23.318 6.081C24.2539 6.88629 25.1124 7.77752 25.882 8.743C26.0432 8.96041 26.1292 9.22439 26.127 9.49501C26.1248 9.76564 26.0346 10.0282 25.87 10.243C25.637 10.57 25.37 10.908 25.097 11.25C24.909 11.489 24.718 11.728 24.533 11.975C24.663 12.248 24.78 12.528 24.884 12.812L27.26 13.176C27.5346 13.2245 27.7837 13.3672 27.9645 13.5794C28.1454 13.7916 28.2467 14.0602 28.251 14.339V17.705C28.2448 17.9742 28.1515 18.2341 27.9851 18.4458C27.8187 18.6574 27.5881 18.8094 27.328 18.879L24.85 19.258C24.756 19.5073 24.6513 19.751 24.536 19.989C24.927 20.52 25.357 21.069 25.896 21.723C26.0759 21.9284 26.1816 22.1883 26.196 22.461C26.2036 22.616 26.1798 22.7709 26.126 22.9165C26.0722 23.062 25.9896 23.1952 25.883 23.308C25.883 23.308 23.527 26.219 22.508 26.219C22.2341 26.2078 21.9689 26.1194 21.743 25.964L19.949 24.564C19.724 24.664 19.494 24.764 19.261 24.851C19.1747 25.6864 19.0368 26.5157 18.848 27.334C18.7868 27.5968 18.6389 27.8313 18.4281 27.9997C18.2172 28.1681 17.9558 28.2605 17.686 28.262ZM11.942 23.052L12.305 23.238C12.7099 23.445 13.1314 23.618 13.565 23.755L13.951 23.877L14.422 26.962H17.609C17.8059 26.0925 17.9419 25.2104 18.016 24.322L18.051 23.89L18.463 23.757C18.9026 23.6139 19.33 23.4357 19.741 23.224L20.111 23.033L22.488 24.894C23.3689 24.1792 24.1732 23.3749 24.888 22.494C24.23 21.725 23.729 21.079 23.263 20.428L23.026 20.098L23.219 19.741C23.4378 19.334 23.6209 18.9087 23.766 18.47L23.892 18.091L26.965 17.625V14.447L23.908 13.979L23.787 13.591C23.6406 13.1187 23.449 12.6616 23.215 12.226L23.024 11.871L23.257 11.542C23.527 11.162 23.812 10.802 24.094 10.442C24.352 10.118 24.607 9.797 24.844 9.464C24.1338 8.61611 23.3577 7.82565 22.523 7.1L20.055 8.943L19.695 8.759C19.2902 8.5515 18.8687 8.37823 18.435 8.241L18.047 8.118L17.597 5.034H14.397C14.1999 5.90381 14.0636 6.78627 13.989 7.675L13.953 8.106L13.542 8.239C13.1027 8.38195 12.6756 8.5602 12.265 8.772L11.895 8.963L9.50699 7.1C8.61472 7.8131 7.80474 8.62344 7.09201 9.516C7.66586 10.1603 8.2056 10.8343 8.70901 11.535L8.95001 11.866L8.75601 12.227C8.53573 12.6345 8.3549 13.0621 8.216 13.504L8.09399 13.887L5.039 14.367V17.553L8.10001 18L8.21799 18.4C8.36186 18.8772 8.55316 19.3389 8.789 19.778L8.98001 20.133L8.74701 20.462C8.47701 20.842 8.192 21.202 7.909 21.562C7.652 21.886 7.397 22.207 7.16 22.539C7.87758 23.4053 8.67106 24.2058 9.53101 24.931L11.942 23.052ZM22.631 7.023L22.604 7.042C22.6139 7.03708 22.623 7.03067 22.631 7.023Z"\n  />\n  <path\n    d="M16 20.981C15.0149 20.981 14.0519 20.6889 13.2327 20.1415C12.4136 19.5942 11.7752 18.8163 11.3982 17.9061C11.0212 16.996 10.9226 15.9945 11.1148 15.0282C11.3069 14.062 11.7813 13.1745 12.4779 12.4779C13.1745 11.7813 14.0621 11.3069 15.0283 11.1147C15.9945 10.9225 16.996 11.0211 17.9062 11.3981C18.8164 11.7751 19.5943 12.4136 20.1416 13.2327C20.6889 14.0518 20.981 15.0148 20.981 16C20.9794 17.3205 20.4542 18.5866 19.5204 19.5203C18.5866 20.4541 17.3206 20.9794 16 20.981ZM16 12.319C15.272 12.319 14.5603 12.5349 13.955 12.9393C13.3497 13.3438 12.8779 13.9187 12.5993 14.5913C12.3206 15.2639 12.2477 16.0041 12.3898 16.7181C12.5318 17.4322 12.8824 18.088 13.3972 18.6028C13.912 19.1176 14.5679 19.4682 15.2819 19.6103C15.9959 19.7523 16.7361 19.6794 17.4087 19.4008C18.0813 19.1222 18.6562 18.6504 19.0607 18.045C19.4651 17.4397 19.681 16.728 19.681 16C19.68 15.024 19.2918 14.0884 18.6017 13.3983C17.9116 12.7082 16.976 12.32 16 12.319Z"\n  />\n</svg>\n';
const __vite_glob_0_100 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M13.955 12.9393C14.5603 12.5349 15.272 12.319 16 12.319C16.976 12.32 17.9116 12.7082 18.6017 13.3983C19.2918 14.0884 19.68 15.024 19.681 16C19.681 16.728 19.4651 17.4397 19.0607 18.045C18.6562 18.6504 18.0813 19.1222 17.4087 19.4008C16.7361 19.6794 15.9959 19.7523 15.2819 19.6103C14.5679 19.4682 13.912 19.1176 13.3972 18.6028C12.8824 18.088 12.5318 17.4322 12.3898 16.7181C12.2477 16.0041 12.3206 15.2639 12.5993 14.5913C12.8779 13.9187 13.3497 13.3438 13.955 12.9393Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M14.323 28.262H17.686C17.9558 28.2605 18.2172 28.1681 18.4281 27.9997C18.6389 27.8313 18.7868 27.5968 18.848 27.334C19.0368 26.5157 19.1747 25.6864 19.261 24.851C19.494 24.764 19.724 24.664 19.949 24.564L21.743 25.964C21.9689 26.1194 22.2341 26.2078 22.508 26.219C23.527 26.219 25.883 23.308 25.883 23.308C25.9896 23.1952 26.0722 23.062 26.126 22.9165C26.1798 22.7709 26.2036 22.616 26.196 22.461C26.1816 22.1883 26.0759 21.9284 25.896 21.723C25.357 21.069 24.927 20.52 24.536 19.989C24.6513 19.751 24.756 19.5073 24.85 19.258L27.328 18.879C27.5881 18.8094 27.8187 18.6574 27.9851 18.4458C28.1515 18.2341 28.2448 17.9742 28.251 17.705V14.339C28.2467 14.0602 28.1454 13.7916 27.9645 13.5794C27.7837 13.3672 27.5346 13.2245 27.26 13.176L24.884 12.812C24.78 12.528 24.663 12.248 24.533 11.975C24.6818 11.7764 24.8344 11.5829 24.9863 11.3904L25.097 11.25C25.37 10.908 25.637 10.57 25.87 10.243C26.0346 10.0282 26.1248 9.76564 26.127 9.49501C26.1292 9.22439 26.0432 8.96041 25.882 8.743C25.1124 7.77752 24.2539 6.88629 23.318 6.081C23.0959 5.88588 22.8134 5.77323 22.518 5.762C22.2431 5.75837 21.977 5.85874 21.773 6.043L19.912 7.426C19.685 7.321 19.45 7.225 19.212 7.137L18.861 4.737C18.8139 4.4586 18.6702 4.20571 18.4551 4.02281C18.24 3.8399 17.9673 3.7387 17.685 3.737H14.313C14.0413 3.73632 13.7775 3.82785 13.5646 3.9966C13.3517 4.16535 13.2023 4.40135 13.141 4.666C12.9522 5.48411 12.8136 6.31299 12.726 7.148C12.4947 7.23534 12.266 7.331 12.04 7.435L10.268 6.049C10.0385 5.87293 9.75729 5.77734 9.46799 5.777C8.43199 5.777 6.06201 8.721 6.06201 8.721C5.87794 8.94908 5.77863 9.23392 5.78101 9.527C5.79402 9.78946 5.89233 10.0405 6.061 10.242C6.563 10.856 7.003 11.416 7.422 11.98C7.306 12.226 7.19999 12.472 7.10599 12.726L4.60599 13.126C4.3573 13.2042 4.13968 13.3589 3.98416 13.5681C3.82864 13.7773 3.74317 14.0303 3.73999 14.291V17.658C3.74442 17.9371 3.84601 18.2059 4.02725 18.4182C4.20849 18.6304 4.45806 18.7729 4.733 18.821L7.10599 19.172C7.20803 19.4626 7.3259 19.7473 7.45901 20.025C7.3055 20.2289 7.14857 20.428 6.99274 20.6257L6.89401 20.751C6.62001 21.092 6.354 21.431 6.12 21.759C5.9544 21.9679 5.8639 22.2264 5.86301 22.493C5.85427 22.7802 5.94232 23.0619 6.11301 23.293C6.87389 24.2314 7.72201 25.0956 8.646 25.874C8.84797 26.0894 9.1245 26.2197 9.41919 26.2382C9.71388 26.2568 10.0046 26.1623 10.232 25.974L12.086 24.574C12.312 24.679 12.548 24.775 12.786 24.862L13.152 27.262C13.1968 27.5405 13.3392 27.794 13.5537 27.9772C13.7683 28.1604 14.0409 28.2613 14.323 28.262ZM13.2327 20.1415C14.0519 20.6889 15.0149 20.981 16 20.981C17.3206 20.9794 18.5866 20.4541 19.5204 19.5203C20.4542 18.5866 20.9794 17.3205 20.981 16C20.981 15.0148 20.6889 14.0518 20.1416 13.2327C19.5943 12.4136 18.8164 11.7751 17.9062 11.3981C16.996 11.0211 15.9945 10.9225 15.0283 11.1147C14.0621 11.3069 13.1745 11.7813 12.4779 12.4779C11.7813 13.1745 11.3069 14.062 11.1148 15.0282C10.9226 15.9945 11.0212 16.996 11.3982 17.9061C11.7752 18.8163 12.4136 19.5942 13.2327 20.1415Z"\n  />\n</svg>\n';
const __vite_glob_0_101 = '<?xml version="1.0" encoding="utf-8" ?>\n<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\n<svg\n  fill="#000000"\n  viewBox="0 0 32 32"\n  id="icon"\n  xmlns="http://www.w3.org/2000/svg"\n>\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <polygon\n    points="30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41"\n  />\n  <path\n    d="M24,14V28H18V6H16V28a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V14Z"\n  />\n  <path\n    d="M10,30H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6h6a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,10,30ZM4,8V28h6V8Z"\n  />\n  <rect\n    id="_Transparent_Rectangle_"\n    data-name="&lt;Transparent Rectangle&gt;"\n    class="cls-1"\n    width="32"\n    height="32"\n  />\n</svg>\n';
const __vite_glob_0_102 = '<?xml version="1.0" encoding="utf-8" ?>\n<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\n<svg\n  fill="#000000"\n  viewBox="0 0 32 32"\n  id="icon"\n  xmlns="http://www.w3.org/2000/svg"\n>\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path\n    d="M28,30H22a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM22,10V28h6V10Z"\n  />\n  <polygon\n    points="16 9 21.586 3.414 20.172 2 16 6.172 11.828 2 10.414 3.414 16 9"\n  />\n  <path\n    d="M10,30H4a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,4,8h6a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,10,30ZM4,10V28h6V10Z"\n  />\n  <rect\n    id="_Transparent_Rectangle_"\n    data-name="&lt;Transparent Rectangle&gt;"\n    class="cls-1"\n    width="32"\n    height="32"\n  />\n</svg>\n';
const __vite_glob_0_103 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.1241 26.309C24.0186 26.3089 23.9147 26.2831 23.8213 26.234C23.728 26.1849 23.6479 26.1139 23.5881 26.027C23.3341 25.659 17.3781 16.974 17.3781 13.445C17.3781 11.656 18.0887 9.94023 19.3538 8.6752C20.6188 7.41017 22.3345 6.69949 24.1236 6.69949C25.9126 6.69949 27.6283 7.41017 28.8933 8.6752C30.1584 9.94023 30.8691 11.656 30.8691 13.445C30.8691 16.974 24.9131 25.659 24.6591 26.027C24.5993 26.1138 24.5195 26.1848 24.4263 26.2339C24.3331 26.283 24.2294 26.3088 24.1241 26.309ZM24.1241 8C22.6803 8.00132 21.296 8.57537 20.275 9.59619C19.254 10.617 18.6796 12.0012 18.6781 13.445C18.6781 15.796 22.2201 21.624 24.1241 24.496C26.0241 21.624 29.5691 15.796 29.5691 13.445C29.5675 12.0014 28.9933 10.6173 27.9725 9.59656C26.9517 8.57577 25.5677 8.00159 24.1241 8Z"\n  />\n  <path\n    d="M24.1241 16.826C23.4553 16.8264 22.8014 16.6284 22.2452 16.2572C21.6889 15.8859 21.2552 15.358 20.999 14.7402C20.7428 14.1225 20.6756 13.4426 20.8058 12.7866C20.936 12.1306 21.2579 11.528 21.7307 11.055C22.2034 10.5819 22.8058 10.2597 23.4618 10.1291C24.1177 9.99849 24.7976 10.0653 25.4155 10.3212C26.0334 10.577 26.5616 11.0104 26.9332 11.5664C27.3047 12.1224 27.5031 12.7762 27.5031 13.445C27.5023 14.3411 27.1461 15.2003 26.5126 15.8341C25.8792 16.468 25.0202 16.8247 24.1241 16.826ZM24.1241 11.365C23.7127 11.365 23.3106 11.487 22.9685 11.7155C22.6264 11.9441 22.3598 12.2689 22.2024 12.649C22.045 13.0291 22.0038 13.4473 22.0841 13.8508C22.1643 14.2543 22.3624 14.6249 22.6533 14.9158C22.9442 15.2067 23.3148 15.4048 23.7183 15.485C24.1218 15.5653 24.54 15.5241 24.9201 15.3667C25.3001 15.2092 25.625 14.9426 25.8535 14.6006C26.0821 14.2585 26.2041 13.8564 26.2041 13.445C26.2033 12.8936 25.9839 12.365 25.594 11.9751C25.2041 11.5852 24.6755 11.3658 24.1241 11.365Z"\n  />\n  <path\n    d="M25.046 28.956H23.011V27.656H25.046V28.956ZM20.976 28.956H18.941V27.656H20.976V28.956ZM16.907 28.956H14.872V27.656H16.907V28.956ZM12.837 28.956H10.8V27.656H12.835L12.837 28.956ZM8.76703 28.956H7.23703C7.02938 28.9562 6.82216 28.9371 6.61803 28.899L6.85303 27.62C6.97965 27.6437 7.10822 27.6554 7.23703 27.655H8.76703V28.956ZM4.52503 27.75C3.99212 27.2058 3.56607 26.5664 3.26903 25.865L4.46003 25.344C4.69365 25.8955 5.02688 26.3992 5.44303 26.83L4.52503 27.75ZM2.67703 23.742C2.61687 23.3163 2.58679 22.8869 2.58703 22.457C2.58703 22.1523 2.6017 21.8523 2.63103 21.557L3.92503 21.684C3.90003 21.938 3.88703 22.195 3.88703 22.458C3.88702 22.826 3.91275 23.1936 3.96403 23.558L2.67703 23.742ZM4.33903 19.872L3.12203 19.413C3.38149 18.7041 3.76215 18.0456 4.24703 17.467L5.23503 18.311C4.8479 18.7753 4.54469 19.3035 4.33903 19.872ZM6.58403 17.361L6.19403 16.121C6.53148 16.0145 6.88317 15.9599 7.23703 15.959H8.40903V17.259H7.23703C7.01547 17.2599 6.79532 17.2943 6.58403 17.361ZM10.597 17.151L10.273 15.892C10.8074 15.738 11.2855 15.4319 11.649 15.011L12.609 15.888C12.076 16.4949 11.378 16.9337 10.6 17.151H10.597ZM13.791 13.965L12.584 13.479C12.8137 12.9017 12.9654 12.2964 13.035 11.679L14.326 11.829C14.2432 12.5616 14.0633 13.2799 13.791 13.965ZM13.03 9.79999C12.9574 9.1821 12.8024 8.57673 12.569 8L13.769 7.508C14.0457 8.19147 14.23 8.90879 14.317 9.64099L13.03 9.79999ZM11.624 6.48001C11.2568 6.06386 10.7756 5.76448 10.24 5.61899L10.54 4.35501C11.3243 4.55957 12.031 4.99046 12.572 5.59399L11.624 6.48001ZM8.36403 5.55899H6.32903V4.259H8.36403V5.55899ZM4.29403 5.55899H2.25903V4.259H4.29403V5.55899Z"\n  />\n</svg>\n';
const __vite_glob_0_104 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M25.046 28.956H23.011V27.656H25.046V28.956ZM20.976 28.956H18.941V27.656H20.976V28.956ZM16.907 28.956H14.872V27.656H16.907V28.956ZM12.837 28.956H10.8V27.656H12.835L12.837 28.956ZM8.76703 28.956H7.23703C7.02938 28.9562 6.82216 28.9371 6.61803 28.899L6.85303 27.62C6.97965 27.6437 7.10822 27.6554 7.23703 27.655H8.76703V28.956ZM4.52503 27.75C3.99212 27.2058 3.56607 26.5664 3.26903 25.865L4.46003 25.344C4.69365 25.8955 5.02688 26.3992 5.44303 26.83L4.52503 27.75ZM2.67703 23.742C2.61687 23.3163 2.58679 22.8869 2.58703 22.457C2.58703 22.1523 2.6017 21.8523 2.63103 21.557L3.92503 21.684C3.90003 21.938 3.88703 22.195 3.88703 22.458C3.88702 22.826 3.91275 23.1936 3.96403 23.558L2.67703 23.742ZM4.33903 19.872L3.12203 19.413C3.38149 18.7041 3.76215 18.0456 4.24703 17.467L5.23503 18.311C4.8479 18.7753 4.54469 19.3035 4.33903 19.872ZM6.58403 17.361L6.19403 16.121C6.53148 16.0145 6.88317 15.9599 7.23703 15.959H8.40903V17.259H7.23703C7.01547 17.2599 6.79532 17.2943 6.58403 17.361ZM10.597 17.151L10.273 15.892C10.8074 15.738 11.2855 15.4319 11.649 15.011L12.609 15.888C12.076 16.4949 11.378 16.9337 10.6 17.151H10.597ZM13.791 13.965L12.584 13.479C12.8137 12.9017 12.9654 12.2964 13.035 11.679L14.326 11.829C14.2432 12.5616 14.0633 13.2799 13.791 13.965ZM13.03 9.79999C12.9574 9.1821 12.8024 8.57673 12.569 8L13.769 7.508C14.0457 8.19147 14.23 8.90879 14.317 9.64099L13.03 9.79999ZM11.624 6.48001C11.2568 6.06386 10.7756 5.76448 10.24 5.61899L10.54 4.35501C11.3243 4.55957 12.031 4.99046 12.572 5.59399L11.624 6.48001ZM8.36403 5.55899H6.32903V4.259H8.36403V5.55899ZM4.29403 5.55899H2.25903V4.259H4.29403V5.55899Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M23.8213 26.234C23.9147 26.2831 24.0186 26.3089 24.1241 26.309C24.2294 26.3088 24.3331 26.283 24.4263 26.2339C24.5195 26.1848 24.5993 26.1138 24.6591 26.027C24.9131 25.659 30.8691 16.974 30.8691 13.445C30.8691 11.656 30.1584 9.94023 28.8933 8.6752C27.6283 7.41017 25.9126 6.69949 24.1236 6.69949C22.3345 6.69949 20.6188 7.41017 19.3538 8.6752C18.0887 9.94023 17.3781 11.656 17.3781 13.445C17.3781 16.974 23.3341 25.659 23.5881 26.027C23.6479 26.1139 23.728 26.1849 23.8213 26.234ZM22.2451 16.2572C22.8014 16.6284 23.4552 16.8264 24.124 16.826C25.0201 16.8247 25.8791 16.468 26.5126 15.8341C27.146 15.2003 27.5022 14.3411 27.503 13.445C27.503 12.7762 27.3047 12.1224 26.9331 11.5664C26.5615 11.0104 26.0333 10.577 25.4154 10.3212C24.7975 10.0653 24.1176 9.99849 23.4617 10.1291C22.8058 10.2597 22.2034 10.5819 21.7306 11.055C21.2578 11.528 20.936 12.1306 20.8057 12.7866C20.6755 13.4426 20.7428 14.1225 20.999 14.7402C21.2552 15.358 21.6888 15.8859 22.2451 16.2572ZM22.9684 11.7155C23.3105 11.487 23.7126 11.365 24.124 11.365C24.6754 11.3658 25.204 11.5852 25.5939 11.9751C25.9838 12.365 26.2032 12.8936 26.204 13.445C26.204 13.8564 26.082 14.2585 25.8535 14.6006C25.6249 14.9426 25.3001 15.2092 24.92 15.3667C24.5399 15.5241 24.1217 15.5653 23.7182 15.485C23.3148 15.4048 22.9441 15.2067 22.6532 14.9158C22.3624 14.6249 22.1643 14.2543 22.084 13.8508C22.0037 13.4473 22.0449 13.0291 22.2024 12.649C22.3598 12.2689 22.6264 11.9441 22.9684 11.7155Z"\n  />\n</svg>\n';
const __vite_glob_0_105 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M29.7838 19.2061H27.4093V15.9695C27.4093 15.6031 27.1776 15.3588 26.8301 15.3588H16.5792V12.7328H18.9537C19.6486 12.7328 20.1699 12.1832 20.1699 11.4504V5.28244C20.1699 4.54962 19.6486 4 18.9537 4H13.0463C12.3514 4 11.8301 4.54962 11.8301 5.28244V11.5115C11.8301 12.2443 12.3514 12.7939 13.0463 12.7939H15.4208V15.3588H5.16988C4.82239 15.3588 4.59073 15.6031 4.59073 15.9695V19.2061H2.21622C1.52124 19.2061 1 19.7557 1 20.4886V26.7176C1 27.4504 1.52124 28 2.21622 28H8.12355C8.81853 28 9.33977 27.4504 9.33977 26.7176V20.4886C9.33977 19.7557 8.81853 19.2061 8.12355 19.2061H5.74903V16.5802H15.4208V19.2061H13.0463C12.3514 19.2061 11.8301 19.7557 11.8301 20.4886V26.7176C11.8301 27.4504 12.3514 28 13.0463 28H18.9537C19.6486 28 20.1699 27.4504 20.1699 26.7176V20.4886C20.1699 19.7557 19.6486 19.2061 18.9537 19.2061H16.5792V16.5802H26.251V19.2061H23.8764C23.1815 19.2061 22.6602 19.7557 22.6602 20.4886V26.7176C22.6602 27.4504 23.1815 28 23.8764 28H29.7838C30.4788 28 31 27.4504 31 26.7176V20.4886C31 19.7557 30.4209 19.2061 29.7838 19.2061ZM8.18147 20.4886C8.18147 20.4275 8.12355 20.4275 8.18147 20.4886V26.7176C8.18147 26.7786 8.18147 26.7786 8.12355 26.7786H2.21622C2.1583 26.7786 2.1583 26.7786 2.1583 26.7176V20.4886C2.1583 20.4275 2.1583 20.4275 2.21622 20.4275L8.18147 20.4886ZM19.0116 20.4886C19.0116 20.4275 18.9537 20.4275 19.0116 20.4886V26.7176C19.0116 26.7786 19.0116 26.7786 18.9537 26.7786H13.0463C12.9884 26.7786 12.9884 26.7786 12.9884 26.7176V20.4886C12.9884 20.4275 12.9884 20.4275 13.0463 20.4275L19.0116 20.4886ZM12.9884 11.4504C12.9884 11.5115 13.0463 11.5115 12.9884 11.4504V5.28244C12.9884 5.22137 12.9884 5.22137 13.0463 5.22137H18.9537C19.0116 5.22137 19.0116 5.22137 19.0116 5.28244V11.5115C19.0116 11.5725 19.0116 11.5725 18.9537 11.5725L12.9884 11.4504ZM29.8417 26.6565C29.7838 26.7176 29.8417 26.7176 29.8417 26.6565L23.8764 26.7176C23.8185 26.7176 23.8185 26.7176 23.8185 26.6565V20.4886C23.8185 20.4275 23.8185 20.4275 23.8764 20.4275H29.7838C29.8417 20.4275 29.8417 20.4275 29.8417 20.4886V26.6565Z"\n  />\n</svg>\n';
const __vite_glob_0_106 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M29.7838 19.2061H27.4093V15.9695C27.4093 15.6031 27.1776 15.3588 26.8301 15.3588H16.5792V12.7328H18.9537C19.6486 12.7328 20.1699 12.1832 20.1699 11.4504V5.28244C20.1699 4.54962 19.6486 4 18.9537 4H13.0463C12.3514 4 11.8301 4.54962 11.8301 5.28244V11.5115C11.8301 12.2443 12.3514 12.7939 13.0463 12.7939H15.4208V15.3588H5.16988C4.82239 15.3588 4.59073 15.6031 4.59073 15.9695V19.2061H2.21622C1.52124 19.2061 1 19.7557 1 20.4885V26.7176C1 27.4504 1.52124 28 2.21622 28H8.12355C8.81853 28 9.33977 27.4504 9.33977 26.7176V20.4885C9.33977 19.7557 8.81853 19.2061 8.12355 19.2061H5.74903V16.5802H15.4208V19.2061H13.0463C12.3514 19.2061 11.8301 19.7557 11.8301 20.4885V26.7176C11.8301 27.4504 12.3514 28 13.0463 28H18.9537C19.6486 28 20.1699 27.4504 20.1699 26.7176V20.4885C20.1699 19.7557 19.6486 19.2061 18.9537 19.2061H16.5792V16.5802H26.251V19.2061H23.8764C23.1815 19.2061 22.6602 19.7557 22.6602 20.4885V26.7176C22.6602 27.4504 23.1815 28 23.8764 28H29.7838C30.4788 28 31 27.4504 31 26.7176V20.4885C31 19.7557 30.4209 19.2061 29.7838 19.2061Z"\n  />\n</svg>\n';
const __vite_glob_0_107 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.632 7.12498H21.732V5.54199H20.432V7.12498H11.563V5.54199H10.263V7.12498H4.36301C3.66043 7.12578 2.98685 7.40522 2.49006 7.90202C1.99326 8.39882 1.71381 9.0724 1.71301 9.77498V24.458C1.71381 25.1605 1.99329 25.8339 2.49012 26.3306C2.98694 26.8272 3.66052 27.1064 4.36301 27.107H27.632C28.3345 27.1064 29.0081 26.8272 29.5049 26.3306C30.0017 25.8339 30.2812 25.1605 30.282 24.458V9.77498C30.2812 9.0724 30.0018 8.39882 29.505 7.90202C29.0082 7.40522 28.3346 7.12578 27.632 7.12498ZM28.982 24.458C28.9815 24.8159 28.8391 25.1589 28.586 25.412C28.333 25.665 27.9899 25.8075 27.632 25.808H4.36801C4.01013 25.8075 3.66706 25.665 3.414 25.412C3.16094 25.1589 3.01854 24.8159 3.01801 24.458V9.77498C3.01828 9.41702 3.16059 9.0738 3.41371 8.82068C3.66683 8.56756 4.01005 8.42525 4.36801 8.42499H10.268V9.57298H11.568V8.42499H20.442V9.57298H21.742V8.42499H27.642C28 8.42525 28.3432 8.56756 28.5963 8.82068C28.8494 9.0738 28.9917 9.41702 28.992 9.77498L28.982 24.458Z"\n  />\n  <path\n    d="M25.554 12.359H18.3V13.659H24.9V21.892H16.628V13.009C16.628 12.9236 16.6112 12.8391 16.5785 12.7602C16.5459 12.6814 16.498 12.6097 16.4376 12.5493C16.3773 12.489 16.3056 12.4411 16.2268 12.4084C16.1479 12.3758 16.0634 12.359 15.978 12.359H6.44602C6.27363 12.359 6.1083 12.4274 5.9864 12.5493C5.8645 12.6712 5.79602 12.8366 5.79602 13.009V22.542C5.79629 22.7142 5.86488 22.8793 5.98675 23.0009C6.10862 23.1226 6.2738 23.191 6.44602 23.191H13.424V21.891H7.10002V13.658H15.332V22.541C15.3323 22.7132 15.4009 22.8783 15.5228 22.9999C15.6446 23.1216 15.8098 23.19 15.982 23.19H25.558C25.7302 23.19 25.8954 23.1216 26.0173 22.9999C26.1392 22.8783 26.2078 22.7132 26.208 22.541V13.008C26.2079 12.9223 26.1908 12.8376 26.1579 12.7586C26.1249 12.6796 26.0766 12.6079 26.0159 12.5476C25.9551 12.4873 25.883 12.4396 25.8038 12.4072C25.7245 12.3748 25.6396 12.3584 25.554 12.359Z"\n  />\n  <path\n    d="M9.28902 17.161V18.383C9.27336 18.6396 9.31038 18.8967 9.3978 19.1385C9.48522 19.3802 9.62119 19.6015 9.79735 19.7888C9.97351 19.976 10.1861 20.1252 10.4221 20.2272C10.6581 20.3292 10.9124 20.3818 11.1695 20.3818C11.4266 20.3818 11.681 20.3292 11.9169 20.2272C12.1529 20.1252 12.3655 19.976 12.5417 19.7888C12.7178 19.6015 12.8538 19.3802 12.9412 19.1385C13.0287 18.8967 13.0657 18.6396 13.05 18.383V17.161C13.0657 16.9044 13.0287 16.6473 12.9412 16.4056C12.8538 16.1638 12.7178 15.9425 12.5417 15.7553C12.3655 15.568 12.1529 15.4188 11.9169 15.3168C11.681 15.2148 11.4266 15.1622 11.1695 15.1622C10.9124 15.1622 10.6581 15.2148 10.4221 15.3168C10.1861 15.4188 9.97351 15.568 9.79735 15.7553C9.62119 15.9425 9.48522 16.1638 9.3978 16.4056C9.31038 16.6473 9.27336 16.9044 9.28902 17.161ZM12.076 17.161V18.383C12.0938 18.5125 12.0836 18.6442 12.0462 18.7694C12.0088 18.8946 11.945 19.0104 11.8591 19.1088C11.7732 19.2073 11.6672 19.2863 11.5483 19.3404C11.4293 19.3945 11.3002 19.4224 11.1695 19.4224C11.0388 19.4224 10.9097 19.3945 10.7907 19.3404C10.6718 19.2863 10.5658 19.2073 10.4799 19.1088C10.394 19.0104 10.3302 18.8946 10.2928 18.7694C10.2554 18.6442 10.2453 18.5125 10.263 18.383V17.161C10.2464 17.0322 10.2575 16.9013 10.2954 16.7771C10.3334 16.6528 10.3974 16.5381 10.4832 16.4406C10.5689 16.3431 10.6745 16.2649 10.7929 16.2114C10.9112 16.1579 11.0396 16.1302 11.1695 16.1302C11.2994 16.1302 11.4278 16.1579 11.5462 16.2114C11.6645 16.2649 11.7701 16.3431 11.8559 16.4406C11.9417 16.5381 12.0057 16.6528 12.0436 16.7771C12.0816 16.9013 12.0926 17.0322 12.076 17.161Z"\n  />\n  <path\n    d="M21.752 15.252L19.135 18.358V19.147H21.644V20.3H22.619V19.148H23.28V18.248H22.619V15.248L21.752 15.252ZM21.644 18.252H20.337L21.644 16.695V18.252Z"\n  />\n</svg>\n';
const __vite_glob_0_108 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M21.732 7.12498H27.632C28.3346 7.12578 29.0082 7.40522 29.505 7.90202C30.0018 8.39882 30.2812 9.0724 30.282 9.77498V24.458C30.2812 25.1605 30.0017 25.8339 29.5049 26.3306C29.0081 26.8272 28.3345 27.1064 27.632 27.107H4.36301C3.66052 27.1064 2.98694 26.8272 2.49012 26.3306C1.99329 25.8339 1.71381 25.1605 1.71301 24.458V9.77498C1.71381 9.0724 1.99326 8.39882 2.49006 7.90202C2.98685 7.40522 3.66043 7.12578 4.36301 7.12498H10.263V5.54199H11.563V7.12498H20.432V5.54199H21.732V7.12498ZM18.3 12.359H25.554C25.6396 12.3584 25.7245 12.3748 25.8038 12.4072C25.883 12.4396 25.9551 12.4873 26.0159 12.5476C26.0766 12.6079 26.1249 12.6796 26.1579 12.7586C26.1908 12.8376 26.2079 12.9223 26.208 13.008V22.541C26.2078 22.7132 26.1392 22.8783 26.0173 22.9999C25.8954 23.1216 25.7302 23.19 25.558 23.19H15.982C15.8098 23.19 15.6446 23.1216 15.5228 22.9999C15.4009 22.8783 15.3323 22.7132 15.332 22.541V13.658H7.10002V21.891H13.424V23.191H6.44602C6.2738 23.191 6.10862 23.1226 5.98675 23.0009C5.86488 22.8793 5.79629 22.7142 5.79602 22.542V13.009C5.79602 12.8366 5.8645 12.6712 5.9864 12.5493C6.1083 12.4274 6.27363 12.359 6.44602 12.359H15.978C16.0634 12.359 16.1479 12.3758 16.2268 12.4084C16.3056 12.4411 16.3773 12.489 16.4376 12.5493C16.498 12.6097 16.5459 12.6814 16.5785 12.7602C16.6112 12.8391 16.628 12.9236 16.628 13.009V21.892H24.9V13.659H18.3V12.359ZM9.28902 18.383V17.161C9.27336 16.9044 9.31038 16.6473 9.3978 16.4055C9.48522 16.1638 9.62119 15.9425 9.79735 15.7552C9.97351 15.568 10.1861 15.4188 10.4221 15.3168C10.6581 15.2148 10.9124 15.1622 11.1695 15.1622C11.4266 15.1622 11.681 15.2148 11.9169 15.3168C12.1529 15.4188 12.3655 15.568 12.5417 15.7552C12.7178 15.9425 12.8538 16.1638 12.9412 16.4055C13.0287 16.6473 13.0657 16.9044 13.05 17.161V18.383C13.0657 18.6396 13.0287 18.8967 12.9412 19.1384C12.8538 19.3802 12.7178 19.6015 12.5417 19.7887C12.3655 19.976 12.1529 20.1252 11.9169 20.2272C11.681 20.3292 11.4266 20.3818 11.1695 20.3818C10.9124 20.3818 10.6581 20.3292 10.4221 20.2272C10.1861 20.1252 9.97351 19.976 9.79735 19.7887C9.62119 19.6015 9.48522 19.3802 9.3978 19.1384C9.31038 18.8967 9.27336 18.6396 9.28902 18.383ZM12.076 18.383V17.161C12.0926 17.0322 12.0816 16.9013 12.0436 16.777C12.0057 16.6528 11.9417 16.5381 11.8559 16.4406C11.7701 16.343 11.6645 16.2649 11.5462 16.2113C11.4278 16.1578 11.2994 16.1301 11.1695 16.1301C11.0396 16.1301 10.9112 16.1578 10.7929 16.2113C10.6745 16.2649 10.5689 16.343 10.4832 16.4406C10.3974 16.5381 10.3334 16.6528 10.2954 16.777C10.2575 16.9013 10.2464 17.0322 10.263 17.161V18.383C10.2453 18.5124 10.2554 18.6442 10.2928 18.7694C10.3302 18.8946 10.394 19.0103 10.4799 19.1088C10.5658 19.2073 10.6718 19.2862 10.7907 19.3403C10.9097 19.3944 11.0388 19.4224 11.1695 19.4224C11.3002 19.4224 11.4293 19.3944 11.5483 19.3403C11.6672 19.2862 11.7732 19.2073 11.8591 19.1088C11.945 19.0103 12.0088 18.8946 12.0462 18.7694C12.0836 18.6442 12.0938 18.5124 12.076 18.383ZM21.752 15.252L19.135 18.358V19.147H21.644V20.3H22.619V19.148H23.28V18.248H22.619V15.248L21.752 15.252ZM21.644 18.252H20.337L21.644 16.695V18.252Z"\n  />\n</svg>\n';
const __vite_glob_0_109 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M10.6434 9.00019L9 10.6436L22.3555 23.999L23.9988 22.3557L10.6434 9.00019Z"\n  />\n  <path\n    d="M22.3555 9.00098L9 22.3564L10.6434 23.9998L23.9988 10.6443L22.3555 9.00098Z"\n  />\n</svg>\n';
const __vite_glob_0_110 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.094 3.30022C6.62908 3.29055 6.17926 3.46548 5.84303 3.78672C5.5068 4.10796 5.31154 4.54934 5.3 5.01422V26.2862C5.31154 26.7511 5.5068 27.1925 5.84303 27.5137C6.17926 27.8349 6.62908 28.0099 7.094 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.30022H7.094Z"\n  />\n  <path\n    d="M26.65 10.3001H22.642C21.7045 10.326 20.7949 9.97941 20.1123 9.33619C19.4297 8.69298 19.0298 7.80555 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z"\n  />\n  <path d="M21.964 19.5083H9.33701V20.8083H21.964V19.5083Z" />\n  <path d="M21.964 15.0251H9.33701V16.3251H21.964V15.0251Z" />\n  <path d="M14.777 10.4922H9.33701V11.7922H14.777V10.4922Z" />\n</svg>\n';
const __vite_glob_0_111 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.206 29.3002H7.09399C6.28431 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28431 1.9906 7.09399 2.00022H20.368C20.5396 2.00028 20.7043 2.06822 20.826 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.09399 3.30022C6.62907 3.29055 6.17925 3.46548 5.84302 3.78672C5.50678 4.10796 5.31153 4.54934 5.29999 5.01422V26.2862C5.31153 26.7511 5.50678 27.1925 5.84302 27.5137C6.17925 27.8349 6.62907 28.0099 7.09399 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.29922L7.09399 3.30022Z"\n  />\n  <path\n    d="M26.65 10.3001H22.642C21.7044 10.3263 20.7947 9.97976 20.112 9.33649C19.4294 8.69323 19.0295 7.80564 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z"\n  />\n  <path\n    d="M19.98 23.7752H11.32C10.8695 23.8246 10.4178 23.6935 10.0639 23.4104C9.70999 23.1273 9.48277 22.7155 9.43201 22.2652V20.2732H10.732V22.2652C10.8083 22.3414 10.9004 22.3999 11.0019 22.4363C11.1034 22.4728 11.2117 22.4864 11.319 22.4762H19.979C20.0877 22.4877 20.1976 22.4737 20.2999 22.4351C20.4021 22.3966 20.494 22.3346 20.568 22.2542V20.2732H21.868V22.2652C21.8172 22.7155 21.59 23.1273 21.2361 23.4104C20.8822 23.6935 20.4305 23.8246 19.98 23.7752Z"\n  />\n  <path\n    d="M15.65 21.0774C15.4623 21.0781 15.2764 21.0415 15.103 20.9697C14.9296 20.898 14.7722 20.7925 14.64 20.6594L11.84 17.8594L12.759 16.9404L15.559 19.7404C15.559 19.7404 15.671 19.7404 15.718 19.7404H15.739L18.539 16.9404L19.458 17.8594L16.658 20.6594C16.5259 20.7923 16.3688 20.8976 16.1958 20.9694C16.0228 21.0411 15.8373 21.0778 15.65 21.0774Z"\n  />\n  <path d="M16.301 12.1743H15V20.1993H16.301V12.1743Z" />\n</svg>\n';
const __vite_glob_0_112 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M27.3 8.88022V9.00015H22.642C22.0492 9.02598 21.4703 8.81631 21.0315 8.4169C20.5928 8.01748 20.3298 7.46073 20.3 6.86815V2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55139 27.2501 8.63051C27.2831 8.70964 27.3 8.7945 27.3 8.88022ZM7.094 2.00022H19V6.86815C19.0298 7.80556 19.4297 8.69298 20.1123 9.33619C20.7949 9.97941 21.7045 10.326 22.642 10.3001H27.3V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022ZM11.32 23.7752H19.98C20.4305 23.8246 20.8822 23.6935 21.2361 23.4104C21.59 23.1273 21.8172 22.7155 21.868 22.2652V20.2732H20.568V22.2542C20.494 22.3346 20.4021 22.3966 20.2999 22.4351C20.1976 22.4737 20.0877 22.4877 19.979 22.4762H11.319C11.2117 22.4864 11.1034 22.4728 11.0019 22.4363C10.9004 22.3999 10.8083 22.3414 10.732 22.2652V20.2732H9.43201V22.2652C9.48277 22.7155 9.70999 23.1273 10.0639 23.4104C10.4178 23.6935 10.8695 23.8246 11.32 23.7752ZM15.65 21.0774C15.4623 21.0781 15.2764 21.0415 15.103 20.9697C14.9296 20.898 14.7722 20.7925 14.64 20.6594L11.84 17.8594L12.759 16.9404L15 19.1815V12.1743H16.301V19.1784L18.539 16.9404L19.458 17.8594L16.658 20.6594C16.5259 20.7923 16.3688 20.8976 16.1958 20.9694C16.0228 21.0411 15.8373 21.0778 15.65 21.0774Z"\n  />\n</svg>\n';
const __vite_glob_0_113 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M25.1601 25.386H10.954C10.2526 25.394 9.57655 25.1235 9.07418 24.6339C8.5718 24.1443 8.28406 23.4754 8.27405 22.774V5.11199C8.28406 4.41055 8.5718 3.74169 9.07418 3.25206C9.57655 2.76243 10.2526 2.49198 10.954 2.49999H21.974C22.1452 2.50016 22.3093 2.5677 22.431 2.68799L27.6471 7.86099C27.7079 7.92135 27.7562 7.99316 27.7892 8.07228C27.8221 8.15141 27.8391 8.23628 27.839 8.32199V22.774C27.8293 23.4753 27.5418 24.1442 27.0396 24.6339C26.5373 25.1235 25.8614 25.394 25.1601 25.386ZM10.954 3.79999C10.5973 3.79166 10.2517 3.92505 9.99306 4.17095C9.73441 4.41686 9.58374 4.75523 9.57405 5.11199V22.774C9.58348 23.1308 9.73406 23.4694 9.99277 23.7153C10.2515 23.9613 10.5972 24.0946 10.954 24.086H25.1601C25.5169 24.0946 25.8626 23.9613 26.1213 23.7153C26.38 23.4694 26.5306 23.1308 26.5401 22.774V8.59299L21.7061 3.79999H10.954Z"\n  />\n  <path\n    d="M21.046 29.5H6.84001C6.13864 29.508 5.46272 29.2375 4.9605 28.7479C4.45828 28.2582 4.17076 27.5894 4.16101 26.888V9.22601C4.17076 8.52465 4.45828 7.8558 4.9605 7.36614C5.46272 6.87648 6.13864 6.60599 6.84001 6.614H8.80901V7.91401H6.84001C6.48315 7.90541 6.13744 8.03871 5.87873 8.28467C5.62003 8.53063 5.46944 8.86916 5.46001 9.22601V26.888C5.4697 27.2448 5.62037 27.5831 5.87902 27.829C6.13767 28.075 6.48322 28.2083 6.84001 28.2H21.046C21.4028 28.2083 21.7484 28.075 22.007 27.829C22.2657 27.5831 22.4163 27.2448 22.426 26.888V24.788H23.726V26.888C23.716 27.5894 23.4283 28.2583 22.9259 28.7479C22.4235 29.2376 21.7475 29.508 21.046 29.5Z"\n  />\n  <path\n    d="M27.189 9.61198H23.862C23.0543 9.63352 22.271 9.33411 21.6836 8.77932C21.0962 8.22453 20.7526 7.45958 20.728 6.65198V3.15198H22.028V6.65198C22.0529 7.11467 22.2596 7.54879 22.6031 7.85973C22.9467 8.17067 23.3992 8.33323 23.862 8.31198H27.189V9.61198Z"\n  />\n  <path d="M17.226 10.803H12.245V12.103H17.226V10.803Z" />\n  <path d="M23.869 14.954H12.245V16.254H23.869V14.954Z" />\n  <path d="M23.869 19.105H12.245V20.405H23.869V19.105Z" />\n</svg>\n';
const __vite_glob_0_114 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M21.046 29.5H6.84001C6.13864 29.508 5.46272 29.2375 4.9605 28.7479C4.45828 28.2582 4.17076 27.5893 4.16101 26.888V9.22599C4.17076 8.52464 4.45828 7.85578 4.9605 7.36612C5.46272 6.87647 6.13864 6.60598 6.84001 6.61399H8.80901V7.91399H6.84001C6.48315 7.90539 6.13744 8.03869 5.87873 8.28465C5.62003 8.53061 5.46944 8.86915 5.46001 9.22599V26.888C5.4697 27.2447 5.62037 27.5831 5.87902 27.829C6.13767 28.0749 6.48322 28.2083 6.84001 28.2H21.046C21.4028 28.2083 21.7484 28.0749 22.007 27.829C22.2657 27.5831 22.4163 27.2447 22.426 26.888V24.788H23.726V26.888C23.716 27.5894 23.4283 28.2583 22.9259 28.7479C22.4235 29.2375 21.7475 29.508 21.046 29.5Z"\n  />\n  <path\n    d="M27.7891 8.07228C27.8208 8.14833 27.8377 8.22968 27.8389 8.31199H23.862C23.3991 8.33324 22.9466 8.17068 22.6031 7.85974C22.2596 7.5488 22.0528 7.11468 22.028 6.65199V2.50228C22.1794 2.51502 22.3222 2.58041 22.431 2.68799L27.647 7.86099C27.7079 7.92135 27.7562 7.99316 27.7891 8.07228Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M10.954 2.49999H20.728V6.65199C20.7526 7.4596 21.0962 8.22455 21.6836 8.77934C22.271 9.33412 23.0543 9.63353 23.862 9.61199H27.839V22.774C27.8293 23.4753 27.5417 24.1442 27.0395 24.6339C26.5373 25.1235 25.8614 25.394 25.16 25.386H10.954C10.2525 25.394 9.57652 25.1235 9.07415 24.6339C8.57177 24.1443 8.28403 23.4754 8.27402 22.774V5.11199C8.28403 4.41055 8.57177 3.74169 9.07415 3.25206C9.57652 2.76243 10.2525 2.49198 10.954 2.49999ZM12.245 10.803H17.226V12.103H12.245V10.803ZM12.245 14.954H23.869V16.254H12.245V14.954ZM23.869 19.105H12.245V20.405H23.869V19.105Z"\n  />\n</svg>\n';
const __vite_glob_0_115 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.6523 6.63429 2.34039 7.44397 2.35001H20.718C20.8896 2.35007 21.0542 2.41801 21.176 2.53901L27.458 8.76901C27.5188 8.82936 27.5671 8.90118 27.6001 8.9803C27.6331 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44397 3.65001C6.97905 3.64034 6.52923 3.81528 6.19299 4.13652C5.85676 4.45776 5.6615 4.89913 5.64996 5.36401V26.636C5.6615 27.1009 5.85676 27.5423 6.19299 27.8635C6.52923 28.1847 6.97905 28.3597 7.44397 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.8069 27.8635C26.1432 27.5423 26.3384 27.1009 26.35 26.636V9.50001L20.45 3.64901L7.44397 3.65001Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0544 10.6761 21.1446 10.3296 20.462 9.68635C19.7794 9.04308 19.3795 8.1555 19.35 7.218V3H20.65V7.218C20.6798 7.81059 20.9427 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n</svg>\n';
const __vite_glob_0_116 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.35001V9.23001C27.65 9.1443 27.6331 9.05943 27.6001 8.9803C27.5671 8.90118 27.5188 8.82936 27.458 8.76901L21.176 2.53901C21.0542 2.41801 20.8896 2.35007 20.718 2.35001H20.65V7.21801C20.6798 7.81059 20.9427 8.36734 21.3815 8.76676C21.8203 9.16617 22.3992 9.37584 22.992 9.35001H27.65Z"\n  />\n  <path\n    d="M19.35 2.35001H7.44397C6.63429 2.34039 5.85385 2.6523 5.27383 3.21733C4.69381 3.78235 4.36157 4.55435 4.34998 5.36401V26.636C4.36157 27.4457 4.69381 28.2177 5.27383 28.7827C5.85385 29.3477 6.63429 29.6596 7.44397 29.65H24.556C25.3657 29.6596 26.1461 29.3477 26.7261 28.7827C27.3061 28.2177 27.6384 27.4457 27.65 26.636V10.65H22.992C22.0544 10.6761 21.1446 10.3296 20.462 9.68635C19.7794 9.04309 19.3795 8.1555 19.35 7.21801V2.35001Z"\n  />\n</svg>\n';
const __vite_glob_0_117 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.556 29.6502H7.44397C6.63429 29.6598 5.85385 29.3479 5.27383 28.7829C4.69381 28.2179 4.36157 27.4458 4.34998 26.6362V5.36419C4.36157 4.55454 4.69381 3.78254 5.27383 3.21751C5.85385 2.65249 6.63429 2.34058 7.44397 2.35019H20.718C20.8896 2.35025 21.0542 2.4182 21.176 2.53919L27.458 8.76919C27.5188 8.82955 27.5671 8.90136 27.6001 8.98049C27.6331 9.05961 27.65 9.14448 27.65 9.23019V26.6362C27.6384 27.4458 27.3061 28.2179 26.7261 28.7829C26.1461 29.3479 25.3657 29.6598 24.556 29.6502ZM7.44397 3.65019C6.97905 3.64053 6.52923 3.81546 6.19299 4.1367C5.85676 4.45794 5.6615 4.89931 5.64996 5.36419V26.6362C5.6615 27.1011 5.85676 27.5424 6.19299 27.8637C6.52923 28.1849 6.97905 28.3599 7.44397 28.3502H24.556C25.0209 28.3599 25.4707 28.1849 25.8069 27.8637C26.1432 27.5424 26.3384 27.1011 26.35 26.6362V9.50019L20.45 3.64919L7.44397 3.65019Z"\n  />\n  <path\n    d="M27 10.6502H22.992C22.0544 10.6763 21.1446 10.3298 20.462 9.68653C19.7794 9.04326 19.3795 8.15568 19.35 7.21818V3.00018H20.65V7.21818C20.6798 7.81077 20.9427 8.36752 21.3815 8.76693C21.8203 9.16635 22.3992 9.37602 22.992 9.35018H27V10.6502Z"\n  />\n  <path\n    d="M18.18 24.1082C17.3124 24.1099 16.4556 23.9164 15.673 23.542C14.8903 23.1677 14.2019 22.622 13.6588 21.9455C13.1156 21.2691 12.7315 20.4791 12.5351 19.634C12.3386 18.789 12.3348 17.9106 12.5238 17.0639C12.7129 16.2172 13.0899 15.4238 13.6271 14.7426C14.1644 14.0614 14.848 13.5098 15.6273 13.1285C16.4066 12.7473 17.2617 12.5463 18.1292 12.5404C18.9968 12.5344 19.8545 12.7237 20.639 13.0942L20.084 14.2702C19.4903 13.9879 18.8413 13.841 18.184 13.8402C16.9947 13.8402 15.8542 14.3126 15.0133 15.1535C14.1724 15.9945 13.7 17.135 13.7 18.3242C13.7 19.5134 14.1724 20.654 15.0133 21.4949C15.8542 22.3358 16.9947 22.8082 18.184 22.8082C18.8414 22.8079 19.4905 22.661 20.084 22.3782L20.639 23.5542C19.8706 23.9192 19.0306 24.1085 18.18 24.1082Z"\n  />\n  <path d="M18.391 16.2522H10.791V17.5522H18.391V16.2522Z" />\n  <path d="M17.757 18.7852H10.791V20.0852H17.757V18.7852Z" />\n</svg>\n';
const __vite_glob_0_118 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.23019V9.3502H22.992C22.3992 9.37603 21.8203 9.16637 21.3815 8.76695C20.9427 8.36753 20.6798 7.81078 20.65 7.2182V2.35019H20.718C20.8896 2.35025 21.0542 2.4182 21.176 2.53919L27.458 8.76919C27.5188 8.82955 27.5671 8.90136 27.6001 8.98049C27.6331 9.05961 27.65 9.14448 27.65 9.23019Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44397 2.35019H19.35V7.2182C19.3795 8.15569 19.7794 9.04328 20.462 9.68655C21.1446 10.3298 22.0544 10.6763 22.992 10.6502H27.65V26.6362C27.6384 27.4458 27.3061 28.2179 26.7261 28.7829C26.1461 29.3479 25.3657 29.6598 24.556 29.6502H7.44397C6.63429 29.6598 5.85385 29.3479 5.27383 28.7829C4.69381 28.2179 4.36157 27.4458 4.34998 26.6362V5.36419C4.36157 4.55454 4.69381 3.78254 5.27383 3.21751C5.85385 2.65249 6.63429 2.34058 7.44397 2.35019ZM15.673 23.542C16.4556 23.9164 17.3124 24.1099 18.18 24.1082C19.0306 24.1084 19.8706 23.9192 20.639 23.5542L20.084 22.3782C19.4905 22.661 18.8414 22.8079 18.184 22.8082C16.9947 22.8082 15.8542 22.3358 15.0133 21.4949C14.6046 21.0862 14.2829 20.6067 14.0603 20.0852H17.757V18.7852H13.7237C13.708 18.6327 13.7 18.4789 13.7 18.3242C13.7 18.0636 13.7227 17.8054 13.7669 17.5522H18.391V16.2522H14.2074C14.4166 15.8507 14.6873 15.4796 15.0133 15.1535C15.8542 14.3126 16.9947 13.8402 18.184 13.8402C18.8413 13.841 19.4903 13.9879 20.084 14.2702L20.639 13.0942C19.8545 12.7237 18.9968 12.5344 18.1292 12.5403C17.2617 12.5463 16.4066 12.7473 15.6273 13.1285C14.848 13.5097 14.1644 14.0614 13.6271 14.7426C13.2657 15.201 12.9767 15.7102 12.7687 16.2522H10.791V17.5522H12.4366C12.3815 17.9612 12.3704 18.3745 12.4032 18.7852H10.791V20.0852H12.6594C12.8751 20.7601 13.2135 21.391 13.6588 21.9455C14.2019 22.622 14.8903 23.1676 15.673 23.542Z"\n  />\n</svg>\n';
const __vite_glob_0_119 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.206 29.3002H7.09399C6.28431 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28431 1.9906 7.09399 2.00022H20.368C20.5396 2.00028 20.7043 2.06822 20.826 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.09399 3.30022C6.62907 3.29055 6.17925 3.46548 5.84302 3.78672C5.50678 4.10796 5.31153 4.54934 5.29999 5.01422V26.2862C5.31153 26.7511 5.50678 27.1925 5.84302 27.5137C6.17925 27.8349 6.62907 28.0099 7.09399 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.29922L7.09399 3.30022Z"\n  />\n  <path\n    d="M26.65 10.3001H22.642C21.7044 10.3263 20.7947 9.97976 20.112 9.33649C19.4294 8.69323 19.0295 7.80564 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z"\n  />\n  <path\n    d="M23.8083 16.9341C23.663 16.7373 20.2016 12.1162 15.7807 12.1162C11.3599 12.1162 7.89833 16.7373 7.75322 16.9339C7.61563 17.1206 7.61563 17.3738 7.75322 17.5604C7.89833 17.7572 11.3599 22.3783 15.7807 22.3783C20.2016 22.3783 23.663 17.7572 23.8083 17.5606C23.946 17.374 23.946 17.1206 23.8083 16.9341ZM15.7807 21.3168C12.5243 21.3168 9.70391 18.2496 8.86901 17.2469C9.70283 16.2433 12.5173 13.1778 15.7807 13.1778C19.037 13.1778 21.8572 16.2444 22.6925 17.2476C21.8586 18.2512 19.0441 21.3168 15.7807 21.3168Z"\n  />\n  <path\n    fill-rule="evenodd"\n    d="M15.0478 16.4L14.3771 17.5502L15.0436 18.6934L16.385 18.6934L17.0558 17.5432L16.3892 16.4L15.0478 16.4ZM16.9382 15.4513L14.4946 15.4513L13.2727 17.5467L14.4946 19.6421L16.9382 19.6421L18.1601 17.5467L16.9382 15.4513Z"\n  />\n</svg>\n';
const __vite_glob_0_120 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M27.3 9.00015V8.88022C27.3 8.7945 27.2831 8.70963 27.2501 8.63051C27.2172 8.55138 27.1689 8.47957 27.108 8.41922L20.825 2.18922C20.7033 2.06822 20.5386 2.00028 20.367 2.00022H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H27.3ZM19 2.00022H7.094C6.28432 1.9906 5.50388 2.30251 4.92386 2.86753C4.34384 3.43256 4.01159 4.20456 4 5.01422V26.2862C4.01159 27.0959 4.34384 27.8679 4.92386 28.4329C5.50388 28.9979 6.28432 29.3098 7.094 29.3002H24.206C25.0157 29.3098 25.7961 28.9979 26.3761 28.4329C26.9562 27.8679 27.2884 27.0959 27.3 26.2862V10.3001H22.642C21.7045 10.326 20.7949 9.97941 20.1123 9.33619C19.4297 8.69298 19.0298 7.80555 19 6.86815V2.00022ZM15.0477 16.4L14.377 17.5502L15.0436 18.6934H16.385L17.0557 17.5431L16.3891 16.4H15.0477ZM16.9382 15.4513H14.4945L13.2727 17.5467L14.4945 19.6421H16.9382L18.1601 17.5467L16.9382 15.4513ZM15.7807 12.1162C20.2016 12.1162 23.663 16.7373 23.8083 16.9341C23.946 17.1206 23.946 17.374 23.8083 17.5606C23.663 17.7572 20.2016 22.3783 15.7807 22.3783C11.3599 22.3783 7.89833 17.7572 7.75322 17.5604C7.61563 17.3738 7.61563 17.1206 7.75322 16.9339C7.89833 16.7373 11.3599 12.1162 15.7807 12.1162ZM8.86901 17.2469C9.70391 18.2496 12.5243 21.3168 15.7807 21.3168C19.0441 21.3168 21.8586 18.2512 22.6925 17.2476C21.8572 16.2444 19.037 13.1778 15.7807 13.1778C12.5173 13.1778 9.70283 16.2433 8.86901 17.2469Z"\n  />\n</svg>\n';
const __vite_glob_0_121 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M27.3 8.88022V9.00015H22.642C22.0492 9.02598 21.4703 8.81631 21.0315 8.41689C20.5928 8.01748 20.3298 7.46073 20.3 6.86815V2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022ZM7.094 2.00022H19V6.86815C19.0298 7.80555 19.4297 8.69298 20.1123 9.33619C20.7949 9.97941 21.7045 10.326 22.642 10.3001H27.3V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022ZM9.33701 10.4922H14.777V11.7922H9.33701V10.4922ZM21.964 15.0251H9.33701V16.3251H21.964V15.0251ZM9.33701 19.5083H21.964V20.8083H9.33701V19.5083Z"\n  />\n</svg>\n';
const __vite_glob_0_122 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M22.5 24.431H20.459C20.1541 24.4307 19.8617 24.3095 19.6461 24.0939C19.4305 23.8783 19.3092 23.5859 19.309 23.281V16.094C19.3092 15.7891 19.4305 15.4967 19.6461 15.2811C19.8617 15.0655 20.1541 14.9443 20.459 14.944H22.5C22.8049 14.9443 23.0972 15.0655 23.3128 15.2811C23.5284 15.4967 23.6497 15.7891 23.65 16.094V23.281C23.6497 23.5859 23.5284 23.8783 23.3128 24.0939C23.0972 24.3095 22.8049 24.4307 22.5 24.431ZM20.609 23.131H22.35V16.244H20.609V23.131Z"\n  />\n  <path\n    d="M17.021 24.431H14.979C14.6741 24.4307 14.3817 24.3095 14.1661 24.0939C13.9505 23.8783 13.8292 23.5859 13.829 23.281V14.5C13.8295 14.1953 13.9509 13.9032 14.1664 13.6878C14.382 13.4724 14.6742 13.3513 14.979 13.351H17.021C17.3257 13.3513 17.6179 13.4724 17.8335 13.6878C18.0491 13.9032 18.1704 14.1953 18.171 14.5V23.28C18.171 23.5851 18.0498 23.8777 17.8342 24.0935C17.6186 24.3094 17.3261 24.4307 17.021 24.431ZM15.13 23.131H16.87V14.651H15.13V23.131Z"\n  />\n  <path\n    d="M11.541 24.431H9.49997C9.19505 24.4308 8.90271 24.3095 8.6871 24.0939C8.47149 23.8783 8.35024 23.5859 8.34998 23.281V19.817C8.35024 19.5121 8.47149 19.2198 8.6871 19.0041C8.90271 18.7885 9.19505 18.6673 9.49997 18.667H11.541C11.8459 18.6673 12.1382 18.7885 12.3539 19.0041C12.5695 19.2198 12.6907 19.5121 12.691 19.817V23.281C12.6907 23.5859 12.5695 23.8783 12.3539 24.0939C12.1382 24.3095 11.8459 24.4308 11.541 24.431ZM9.64996 23.131H11.391V19.967H9.64996V23.131Z"\n  />\n  <path\n    d="M24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.6523 6.63429 2.34039 7.44397 2.35001H20.718C20.8896 2.35007 21.0542 2.41801 21.176 2.53901L27.458 8.76901C27.5188 8.82936 27.5671 8.90118 27.6001 8.9803C27.6331 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44397 3.65001C6.97905 3.64034 6.52923 3.81528 6.19299 4.13652C5.85676 4.45776 5.6615 4.89913 5.64996 5.36401V26.636C5.6615 27.1009 5.85676 27.5423 6.19299 27.8635C6.52923 28.1847 6.97905 28.3597 7.44397 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.8069 27.8635C26.1432 27.5423 26.3384 27.1009 26.35 26.636V9.50001L20.45 3.64901L7.44397 3.65001Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0544 10.6761 21.1446 10.3296 20.462 9.68635C19.7794 9.04308 19.3795 8.1555 19.35 7.218V3H20.65V7.218C20.6798 7.81059 20.9427 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n</svg>\n';
const __vite_glob_0_123 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.23001V9.35002H22.992C22.3992 9.37585 21.8203 9.16618 21.3815 8.76676C20.9427 8.36735 20.6798 7.8106 20.65 7.21802V2.35001H20.718C20.8896 2.35007 21.0542 2.41801 21.176 2.53901L27.458 8.76901C27.5188 8.82936 27.5671 8.90118 27.6001 8.9803C27.6331 9.05943 27.65 9.1443 27.65 9.23001Z"\n  />\n  <path d="M16.87 23.131H15.13V14.651H16.87V23.131Z" />\n  <path d="M22.35 23.131H20.609V16.244H22.35V23.131Z" />\n  <path d="M9.64996 23.131H11.391V19.967H9.64996V23.131Z" />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44397 2.35001H19.35V7.21802C19.3795 8.15551 19.7794 9.0431 20.462 9.68636C21.1446 10.3296 22.0544 10.6761 22.992 10.65H27.65V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.6523 6.63429 2.34039 7.44397 2.35001ZM14.979 24.431H17.021C17.3261 24.4307 17.6186 24.3094 17.8342 24.0935C18.0498 23.8777 18.171 23.5851 18.171 23.28V14.5C18.1704 14.1953 18.0491 13.9032 17.8335 13.6878C17.6179 13.4724 17.3257 13.3513 17.021 13.351H14.979C14.6742 13.3513 14.382 13.4724 14.1664 13.6878C13.9509 13.9032 13.8295 14.1953 13.829 14.5V23.281C13.8292 23.5859 13.9505 23.8783 14.1661 24.0939C14.3817 24.3095 14.6741 24.4307 14.979 24.431ZM20.459 24.431H22.5C22.8049 24.4307 23.0972 24.3095 23.3128 24.0939C23.5284 23.8783 23.6497 23.5859 23.65 23.281V16.094C23.6497 15.7891 23.5284 15.4967 23.3128 15.2811C23.0972 15.0655 22.8049 14.9443 22.5 14.944H20.459C20.1541 14.9443 19.8617 15.0655 19.6461 15.2811C19.4305 15.4967 19.3092 15.7891 19.309 16.094V23.281C19.3092 23.5859 19.4305 23.8783 19.6461 24.0939C19.8617 24.3095 20.1541 24.4307 20.459 24.431ZM11.541 24.431H9.49997C9.19505 24.4307 8.90271 24.3095 8.6871 24.0939C8.47149 23.8783 8.35024 23.5859 8.34998 23.281V19.817C8.35024 19.5121 8.47149 19.2197 8.6871 19.0041C8.90271 18.7885 9.19505 18.6673 9.49997 18.667H11.541C11.8459 18.6673 12.1382 18.7885 12.3539 19.0041C12.5695 19.2197 12.6907 19.5121 12.691 19.817V23.281C12.6907 23.5859 12.5695 23.8783 12.3539 24.0939C12.1382 24.3095 11.8459 24.4307 11.541 24.431Z"\n  />\n</svg>\n';
const __vite_glob_0_124 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.65231 6.63429 2.34039 7.44397 2.35001H20.717C20.8886 2.35007 21.0532 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82937 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44397 3.65001C6.97905 3.64035 6.52923 3.81528 6.19299 4.13652C5.85676 4.45776 5.6615 4.89913 5.64996 5.36401V26.636C5.6615 27.1009 5.85676 27.5423 6.19299 27.8635C6.52923 28.1847 6.97905 28.3597 7.44397 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.8069 27.8635C26.1432 27.5423 26.3384 27.1009 26.35 26.636V9.50001L20.45 3.64901L7.44397 3.65001Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0544 10.6759 21.1448 10.3293 20.4623 9.68605C19.7797 9.04283 19.3798 8.15541 19.35 7.218V3H20.65V7.218C20.6798 7.81058 20.9427 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n  <path d="M17.7599 15.882L16.1129 23.656H13.4249L15.0589 15.882H17.7599Z" />\n  <path d="M18.5759 12.08L18.1139 14.28H15.4139L15.8759 12.08H18.5759Z" />\n</svg>\n';
const __vite_glob_0_125 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.23001V9.35001H22.992C22.3992 9.37585 21.8203 9.16618 21.3815 8.76677C20.9427 8.36735 20.6798 7.8106 20.65 7.21801V2.35001H20.717C20.8886 2.35007 21.0532 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82937 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44397 2.35001H19.35V7.21801C19.3798 8.15542 19.7797 9.04285 20.4623 9.68606C21.1448 10.3293 22.0544 10.6759 22.992 10.65H27.65V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.65231 6.63429 2.34039 7.44397 2.35001ZM18.576 12.08L18.114 14.28H15.414L15.876 12.08H18.576ZM17.7599 15.882L16.113 23.656H13.425L15.059 15.882H17.7599Z"\n  />\n</svg>\n';
const __vite_glob_0_126 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.65231 6.63429 2.34039 7.44397 2.35001H20.718C20.8896 2.35007 21.0542 2.41801 21.176 2.53901L27.458 8.76901C27.5188 8.82937 27.5671 8.90118 27.6001 8.9803C27.6331 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44397 3.65001C6.97905 3.64035 6.52923 3.81528 6.19299 4.13652C5.85676 4.45776 5.6615 4.89913 5.64996 5.36401V26.636C5.6615 27.1009 5.85676 27.5423 6.19299 27.8635C6.52923 28.1847 6.97905 28.3597 7.44397 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.8069 27.8635C26.1432 27.5423 26.3384 27.1009 26.35 26.636V9.50001L20.45 3.64901L7.44397 3.65001Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0544 10.6761 21.1446 10.3296 20.462 9.68635C19.7794 9.04308 19.3795 8.1555 19.35 7.218V3H20.65V7.218C20.6798 7.81058 20.9427 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n  <path\n    d="M12.0459 20.924C11.3411 20.9242 10.6521 20.7154 10.0661 20.3239C9.47998 19.9325 9.02315 19.3761 8.75335 18.725C8.48355 18.0739 8.4129 17.3574 8.55035 16.6661C8.68779 15.9749 9.02715 15.3399 9.52551 14.8416C10.0239 14.3432 10.6588 14.0039 11.3501 13.8664C12.0413 13.729 12.7578 13.7996 13.4089 14.0694C14.06 14.3392 14.6164 14.796 15.0079 15.3821C15.3993 15.9682 15.6081 16.6572 15.6079 17.362C15.6066 18.3063 15.2309 19.2115 14.5632 19.8793C13.8955 20.547 12.9902 20.9227 12.0459 20.924ZM12.0459 15.099C11.5983 15.0988 11.1607 15.2314 10.7884 15.4799C10.4161 15.7284 10.1259 16.0818 9.95449 16.4953C9.78306 16.9088 9.73807 17.3638 9.82528 17.8029C9.91248 18.2419 10.1279 18.6452 10.4444 18.9618C10.7608 19.2784 11.1641 19.494 11.6031 19.5814C12.0421 19.6688 12.4971 19.6241 12.9107 19.4528C13.3243 19.2816 13.6778 18.9915 13.9265 18.6194C14.1752 18.2472 14.3079 17.8096 14.3079 17.362C14.3072 16.7623 14.0686 16.1874 13.6445 15.7634C13.2205 15.3394 12.6456 15.0998 12.0459 15.099Z"\n  />\n  <path\n    d="M19.8479 19.65C19.7729 16.956 19.7709 16.904 20.2609 16.717L20.9929 16.905L20.4929 17.325L21.1219 17.444C21.1019 17.624 21.1169 18.71 21.1409 19.614L19.8479 19.65Z"\n  />\n  <path d="M18.829 17.428H17.528V20.708H18.829V17.428Z" />\n  <path d="M23.5179 21.123H22.2179V17.976H14.95V16.676H23.5179V21.123Z" />\n</svg>\n';
const __vite_glob_0_127 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.23001V9.35001H22.992C22.3992 9.37585 21.8203 9.16618 21.3815 8.76677C20.9427 8.36735 20.6798 7.8106 20.65 7.21801V2.35001H20.718C20.8896 2.35007 21.0542 2.41801 21.176 2.53901L27.458 8.76901C27.5188 8.82937 27.5671 8.90118 27.6001 8.9803C27.6331 9.05943 27.65 9.1443 27.65 9.23001Z"\n  />\n  <path\n    d="M12.046 15.099C11.5983 15.0988 11.1607 15.2314 10.7884 15.4799C10.4162 15.7285 10.126 16.0818 9.95452 16.4953C9.78309 16.9088 9.7381 17.3639 9.82531 17.8029C9.91252 18.2419 10.128 18.6453 10.4444 18.9618C10.7609 19.2784 11.1641 19.4941 11.6031 19.5815C12.0421 19.6689 12.4972 19.6241 12.9107 19.4529C13.3243 19.2816 13.6778 18.9915 13.9265 18.6194C14.1752 18.2472 14.308 17.8096 14.308 17.362C14.3072 16.7623 14.0686 16.1875 13.6446 15.7634C13.2205 15.3394 12.6456 15.0998 12.046 15.099Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44397 2.35001H19.35V7.21801C19.3795 8.15551 19.7794 9.0431 20.462 9.68636C21.1446 10.3296 22.0544 10.6761 22.992 10.65H27.65V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.65231 6.63429 2.34039 7.44397 2.35001ZM12.046 20.924C11.3412 20.9242 10.6522 20.7154 10.0661 20.324C9.48001 19.9325 9.02318 19.3761 8.75338 18.725C8.48358 18.0739 8.41293 17.3574 8.55038 16.6662C8.68782 15.9749 9.02718 15.3399 9.52554 14.8416C10.0239 14.3432 10.6588 14.0039 11.3501 13.8664C12.0413 13.729 12.7578 13.7996 13.4089 14.0694C14.06 14.3392 14.6165 14.7961 15.0079 15.3821C15.2708 15.7758 15.4513 16.2159 15.5415 16.676H23.518V21.123H22.218V17.976H21.1129C21.1146 18.4174 21.126 19.051 21.1409 19.614L19.8479 19.65L19.8477 19.6409C19.8273 18.9091 19.8124 18.3727 19.8114 17.976H18.829V20.708H17.528V17.976H15.5539C15.4277 18.6922 15.0844 19.3581 14.5632 19.8793C13.8955 20.547 12.9902 20.9227 12.046 20.924Z"\n  />\n</svg>\n';
const __vite_glob_0_128 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M17.646 20.6H14.354C13.5472 20.6 12.7734 20.2795 12.2029 19.709C11.6324 19.1386 11.312 18.3648 11.312 17.558C11.312 16.7512 11.6324 15.9775 12.2029 15.407C12.7734 14.8365 13.5472 14.516 14.354 14.516H17.646C18.4527 14.516 19.2265 14.8365 19.797 15.407C20.3675 15.9775 20.688 16.7512 20.688 17.558C20.688 18.3648 20.3675 19.1386 19.797 19.709C19.2265 20.2795 18.4527 20.6 17.646 20.6ZM14.354 15.815C14.1216 15.8095 13.8905 15.8504 13.6742 15.9355C13.4579 16.0205 13.2609 16.148 13.0946 16.3104C12.9283 16.4727 12.7961 16.6667 12.7059 16.8809C12.6157 17.0951 12.5692 17.3251 12.5692 17.5575C12.5692 17.7899 12.6157 18.02 12.7059 18.2342C12.7961 18.4483 12.9283 18.6423 13.0946 18.8047C13.2609 18.967 13.4579 19.0945 13.6742 19.1796C13.8905 19.2646 14.1216 19.3056 14.354 19.3H17.646C17.8783 19.3056 18.1094 19.2646 18.3257 19.1796C18.542 19.0945 18.739 18.967 18.9053 18.8047C19.0716 18.6423 19.2038 18.4483 19.294 18.2342C19.3842 18.02 19.4307 17.7899 19.4307 17.5575C19.4307 17.3251 19.3842 17.0951 19.294 16.8809C19.2038 16.6667 19.0716 16.4727 18.9053 16.3104C18.739 16.148 18.542 16.0205 18.3257 15.9355C18.1094 15.8504 17.8783 15.8095 17.646 15.815H14.354Z"\n  />\n  <path d="M22.7679 16.909H17.5679V18.209H22.7679V16.909Z" />\n  <path d="M14.431 16.909H9.23096V18.209H14.431V16.909Z" />\n  <path\n    d="M24.556 29.65H7.44398C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.65231 6.63429 2.34039 7.44398 2.35001H20.717C20.8886 2.35007 21.0532 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82937 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44398 3.65001C6.97905 3.64035 6.52924 3.81528 6.19301 4.13652C5.85677 4.45776 5.66151 4.89913 5.64998 5.36401V26.636C5.66151 27.1009 5.85677 27.5423 6.19301 27.8635C6.52924 28.1847 6.97905 28.3597 7.44398 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.8069 27.8635C26.1432 27.5423 26.3384 27.1009 26.35 26.636V9.50001L20.45 3.64901L7.44398 3.65001Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0545 10.6759 21.1449 10.3293 20.4623 9.68605C19.7797 9.04283 19.3798 8.15541 19.35 7.218V3H20.65V7.218C20.6798 7.81058 20.9428 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n</svg>\n';
const __vite_glob_0_129 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.23001V9.35001H22.992C22.3992 9.37585 21.8203 9.16618 21.3815 8.76677C20.9428 8.36735 20.6798 7.8106 20.65 7.21801V2.35001H20.717C20.8886 2.35007 21.0532 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82937 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001Z"\n  />\n  <path\n    d="M12.7059 16.8809L12.6944 16.909H14.431V18.209H12.6956L12.7059 18.2342C12.7962 18.4483 12.9283 18.6423 13.0946 18.8047C13.2609 18.967 13.458 19.0945 13.6743 19.1796C13.8905 19.2646 14.1216 19.3056 14.354 19.3H17.646C17.8783 19.3056 18.1094 19.2646 18.3257 19.1796C18.542 19.0945 18.7391 18.967 18.9054 18.8047C19.0717 18.6423 19.2038 18.4483 19.294 18.2342L19.3044 18.209H17.568V16.909H19.3056L19.294 16.8809C19.2038 16.6667 19.0717 16.4727 18.9054 16.3103C18.7391 16.148 18.542 16.0205 18.3257 15.9355C18.1094 15.8504 17.8783 15.8094 17.646 15.815H14.354C14.1216 15.8094 13.8905 15.8504 13.6743 15.9355C13.458 16.0205 13.2609 16.148 13.0946 16.3103C12.9283 16.4727 12.7962 16.6667 12.7059 16.8809Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44398 2.35001H19.35V7.21801C19.3798 8.15542 19.7797 9.04285 20.4623 9.68606C21.1449 10.3293 22.0545 10.6759 22.992 10.65H27.65V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65H7.44398C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.65231 6.63429 2.34039 7.44398 2.35001ZM14.354 20.6H17.646C18.4528 20.6 19.2265 20.2795 19.797 19.709C20.2115 19.2946 20.494 18.7728 20.6175 18.209H22.768V16.909H20.618C20.4947 16.3445 20.212 15.822 19.797 15.407C19.2265 14.8365 18.4528 14.516 17.646 14.516H14.354C13.5472 14.516 12.7734 14.8365 12.203 15.407C11.788 15.822 11.5053 16.3445 11.382 16.909H9.23099V18.209H11.3824C11.506 18.7728 11.7885 19.2946 12.203 19.709C12.7734 20.2795 13.5472 20.6 14.354 20.6Z"\n  />\n</svg>\n';
const __vite_glob_0_130 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.65231 6.63429 2.34039 7.44397 2.35001H20.717C20.8886 2.35007 21.0532 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82937 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44397 3.65001C6.97905 3.64035 6.52923 3.81528 6.19299 4.13652C5.85676 4.45776 5.6615 4.89913 5.64996 5.36401V26.636C5.6615 27.1009 5.85676 27.5423 6.19299 27.8635C6.52923 28.1847 6.97905 28.3597 7.44397 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.8069 27.8635C26.1432 27.5423 26.3384 27.1009 26.35 26.636V9.50001L20.45 3.64901L7.44397 3.65001Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0544 10.6759 21.1448 10.3293 20.4623 9.68605C19.7797 9.04283 19.3798 8.15541 19.35 7.218V3H20.65V7.218C20.6798 7.81058 20.9427 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n  <path\n    d="M16 25.83C15.8947 25.8301 15.791 25.8045 15.6978 25.7556C15.6046 25.7066 15.5247 25.6357 15.465 25.549C15.011 24.89 11.027 19.037 11.027 16.52C11.027 15.2011 11.5509 13.9362 12.4835 13.0036C13.4162 12.0709 14.6811 11.547 16 11.547C17.3189 11.547 18.5838 12.0709 19.5164 13.0036C20.4491 13.9362 20.973 15.2011 20.973 16.52C20.973 19.037 16.989 24.89 16.535 25.549C16.4753 25.6357 16.3954 25.7066 16.3022 25.7556C16.209 25.8045 16.1053 25.8301 16 25.83ZM16 12.847C15.0263 12.8483 14.0928 13.2357 13.4042 13.9243C12.7157 14.6128 12.3283 15.5463 12.327 16.52C12.327 18.082 14.632 21.925 16 24.013C17.368 21.925 19.673 18.08 19.673 16.52C19.6717 15.5463 19.2843 14.6128 18.5957 13.9243C17.9072 13.2357 16.9737 12.8483 16 12.847Z"\n  />\n  <path\n    d="M15.9999 18.957C15.5331 18.9572 15.0766 18.8189 14.6884 18.5597C14.3001 18.3004 13.9975 17.9319 13.8188 17.5006C13.64 17.0693 13.5932 16.5947 13.6842 16.1368C13.7752 15.6789 14 15.2583 14.3302 14.9282C14.6603 14.5981 15.0809 14.3733 15.5388 14.2823C15.9966 14.1913 16.4712 14.2381 16.9025 14.4168C17.3338 14.5956 17.7024 14.8982 17.9616 15.2865C18.2208 15.6747 18.3591 16.1312 18.3589 16.598C18.3581 17.2234 18.1093 17.823 17.6671 18.2652C17.2249 18.7074 16.6253 18.9562 15.9999 18.957ZM15.9999 15.538C15.7906 15.5382 15.586 15.6004 15.412 15.7169C15.238 15.8333 15.1024 15.9987 15.0223 16.1922C14.9423 16.3857 14.9214 16.5985 14.9623 16.8039C15.0032 17.0092 15.1041 17.1978 15.2521 17.3458C15.4001 17.4939 15.5887 17.5947 15.7941 17.6356C15.9994 17.6765 16.2123 17.6556 16.4057 17.5756C16.5992 17.4955 16.7646 17.36 16.881 17.186C16.9975 17.012 17.0597 16.8074 17.0599 16.598C17.0594 16.317 16.9475 16.0477 16.7489 15.8491C16.5502 15.6504 16.2809 15.5385 15.9999 15.538Z"\n  />\n</svg>\n';
const __vite_glob_0_131 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.23001V9.35001H22.992C22.3992 9.37585 21.8203 9.16618 21.3815 8.76677C20.9427 8.36735 20.6798 7.8106 20.65 7.21801V2.35001H20.717C20.8886 2.35007 21.0532 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82937 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001Z"\n  />\n  <path\n    d="M16 15.538C15.7906 15.5382 15.586 15.6005 15.412 15.7169C15.238 15.8333 15.1024 15.9988 15.0224 16.1922C14.9424 16.3857 14.9215 16.5985 14.9624 16.8039C15.0033 17.0092 15.1041 17.1978 15.2521 17.3458C15.4002 17.4939 15.5888 17.5947 15.7941 17.6356C15.9995 17.6765 16.2123 17.6556 16.4058 17.5756C16.5992 17.4956 16.7646 17.36 16.8811 17.186C16.9975 17.012 17.0598 16.8074 17.06 16.598C17.0594 16.317 16.9476 16.0477 16.7489 15.8491C16.5502 15.6504 16.2809 15.5385 16 15.538Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M16 12.847C15.0262 12.8483 14.0928 13.2357 13.4042 13.9243C12.7157 14.6128 12.3283 15.5463 12.327 16.52C12.327 18.082 14.632 21.925 16 24.013C17.368 21.925 19.673 18.08 19.673 16.52C19.6717 15.5463 19.2843 14.6128 18.5957 13.9243C17.9072 13.2357 16.9737 12.8483 16 12.847ZM16 18.957C15.5331 18.9572 15.0767 18.8189 14.6884 18.5597C14.3002 18.3005 13.9975 17.9319 13.8188 17.5006C13.6401 17.0693 13.5932 16.5947 13.6843 16.1369C13.7753 15.679 14.0001 15.2584 14.3302 14.9282C14.6603 14.5981 15.0809 14.3733 15.5388 14.2823C15.9967 14.1913 16.4713 14.2381 16.9026 14.4169C17.3338 14.5956 17.7024 14.8982 17.9617 15.2865C18.2209 15.6747 18.3592 16.1312 18.359 16.598C18.3582 17.2234 18.1094 17.823 17.6672 18.2652C17.2249 18.7074 16.6254 18.9562 16 18.957Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44397 2.35001H19.35V7.21801C19.3798 8.15542 19.7797 9.04285 20.4623 9.68606C21.1448 10.3293 22.0544 10.6759 22.992 10.65H27.65V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.65231 6.63429 2.34039 7.44397 2.35001ZM16 25.83C15.8947 25.8301 15.791 25.8045 15.6978 25.7556C15.6046 25.7066 15.5247 25.6357 15.465 25.549C15.011 24.89 11.027 19.037 11.027 16.52C11.027 15.2011 11.5509 13.9362 12.4835 13.0036C13.4161 12.0709 14.681 11.547 16 11.547C17.3189 11.547 18.5838 12.0709 19.5164 13.0036C20.449 13.9362 20.973 15.2011 20.973 16.52C20.973 19.037 16.989 24.89 16.535 25.549C16.4753 25.6357 16.3954 25.7066 16.3022 25.7556C16.209 25.8045 16.1052 25.8301 16 25.83Z"\n  />\n</svg>\n';
const __vite_glob_0_132 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.556 29.65H7.44398C6.6343 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.6523 6.6343 2.34039 7.44398 2.35001H20.717C20.8886 2.35007 21.0533 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82936 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44398 3.65001C6.97905 3.64034 6.52924 3.81528 6.19301 4.13652C5.85678 4.45776 5.66152 4.89913 5.64998 5.36401V26.636C5.66152 27.1009 5.85678 27.5423 6.19301 27.8635C6.52924 28.1847 6.97905 28.3597 7.44398 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.807 27.8635C26.1432 27.5423 26.3384 27.1009 26.35 26.636V9.50001L20.45 3.64901L7.44398 3.65001Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0544 10.6759 21.1449 10.3293 20.4623 9.68605C19.7797 9.04284 19.3798 8.15541 19.35 7.218V3H20.65V7.218C20.6798 7.81059 20.9428 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n  <path d="M21.282 17.233H10.717V18.533H21.282V17.233Z" />\n</svg>\n';
const __vite_glob_0_133 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.23001V9.35002H22.992C22.3992 9.37585 21.8203 9.16618 21.3815 8.76676C20.9428 8.36735 20.6798 7.8106 20.65 7.21802V2.35001H20.717C20.8886 2.35007 21.0533 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82936 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44398 2.35001H19.35V7.21802C19.3798 8.15542 19.7797 9.04285 20.4623 9.68606C21.1449 10.3293 22.0544 10.6759 22.992 10.65H27.65V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65H7.44398C6.6343 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.6523 6.6343 2.34039 7.44398 2.35001ZM10.717 17.233H21.282V18.533H10.717V17.233Z"\n  />\n</svg>\n';
const __vite_glob_0_134 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M12.7242 13.6878L11.8049 14.607L19.2755 22.0776L20.1948 21.1584L12.7242 13.6878Z"\n  />\n  <path\n    d="M19.2755 13.6884L11.8049 21.159L12.7242 22.0782L20.1948 14.6077L19.2755 13.6884Z"\n  />\n  <path\n    d="M24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.6523 6.63429 2.34039 7.44397 2.35001H20.717C20.8886 2.35007 21.0532 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82936 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44397 3.65001C6.97905 3.64034 6.52923 3.81528 6.19299 4.13652C5.85676 4.45776 5.6615 4.89913 5.64996 5.36401V26.636C5.6615 27.1009 5.85676 27.5423 6.19299 27.8635C6.52923 28.1847 6.97905 28.3597 7.44397 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.8069 27.8635C26.1432 27.5423 26.3384 27.1009 26.35 26.636V9.50001L20.45 3.64901L7.44397 3.65001Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0544 10.6759 21.1448 10.3293 20.4623 9.68605C19.7797 9.04284 19.3798 8.15541 19.35 7.218V3H20.65V7.218C20.6798 7.81059 20.9427 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n</svg>\n';
const __vite_glob_0_135 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.23001V9.35002H22.992C22.3992 9.37585 21.8203 9.16618 21.3815 8.76676C20.9427 8.36735 20.6798 7.8106 20.65 7.21802V2.35001H20.717C20.8886 2.35007 21.0532 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82936 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44397 2.35001H19.35V7.21802C19.3798 8.15542 19.7797 9.04285 20.4623 9.68606C21.1448 10.3293 22.0544 10.6759 22.992 10.65H27.65V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.6523 6.63429 2.34039 7.44397 2.35001ZM12.7242 13.6878L11.805 14.607L15.081 17.883L11.805 21.159L12.7242 22.0783L16.0002 18.8023L19.2755 22.0776L20.1948 21.1584L16.9194 17.883L20.1948 14.6077L19.2755 13.6884L16.0002 16.9638L12.7242 13.6878Z"\n  />\n</svg>\n';
const __vite_glob_0_136 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M19.782 23.634H12.218C12.1325 23.6342 12.0479 23.6174 11.9689 23.5848C11.89 23.5522 11.8182 23.5044 11.7577 23.444C11.6972 23.3836 11.6493 23.3119 11.6165 23.233C11.5838 23.1541 11.567 23.0695 11.567 22.984V16.419C11.5671 16.3337 11.584 16.2492 11.6168 16.1704C11.6496 16.0915 11.6976 16.02 11.7581 15.9597C11.8185 15.8994 11.8902 15.8517 11.9691 15.8191C12.0481 15.7866 12.1326 15.7699 12.218 15.77H19.782C19.8673 15.7699 19.9519 15.7866 20.0308 15.8191C20.1097 15.8517 20.1814 15.8994 20.2419 15.9597C20.3023 16.02 20.3503 16.0915 20.3831 16.1704C20.4159 16.2492 20.4329 16.3337 20.433 16.419V22.984C20.433 23.0695 20.4161 23.1541 20.3834 23.233C20.3507 23.3119 20.3027 23.3836 20.2422 23.444C20.1818 23.5044 20.11 23.5522 20.031 23.5848C19.952 23.6174 19.8674 23.6342 19.782 23.634ZM12.868 22.334H19.132V17.069H12.868V22.334Z"\n  />\n  <path\n    d="M13.713 16.713H12.413V14.887C12.413 13.9354 12.791 13.0228 13.4639 12.3499C14.1367 11.677 15.0494 11.299 16.001 11.299C16.9526 11.299 17.8652 11.677 18.5381 12.3499C19.2109 13.0228 19.589 13.9354 19.589 14.887V16.419H18.289V14.887C18.289 14.2805 18.048 13.6988 17.6191 13.2699C17.1902 12.841 16.6085 12.6 16.002 12.6C15.3954 12.6 14.8137 12.841 14.3848 13.2699C13.9559 13.6988 13.715 14.2805 13.715 14.887L13.713 16.713Z"\n  />\n  <path d="M16.651 18.46H15.35V20.689H16.651V18.46Z" />\n  <path\n    d="M24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.6523 6.63429 2.34039 7.44397 2.35001H20.718C20.8896 2.35007 21.0542 2.41801 21.176 2.53901L27.458 8.76901C27.5188 8.82936 27.5671 8.90118 27.6001 8.9803C27.6331 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44397 3.65001C6.97905 3.64034 6.52923 3.81528 6.19299 4.13652C5.85676 4.45776 5.6615 4.89913 5.64996 5.36401V26.636C5.6615 27.1009 5.85676 27.5423 6.19299 27.8635C6.52923 28.1847 6.97905 28.3597 7.44397 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.8069 27.8635C26.1432 27.5423 26.3384 27.1009 26.35 26.636V9.50001L20.45 3.64901L7.44397 3.65001Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0544 10.6761 21.1446 10.3296 20.462 9.68635C19.7794 9.04308 19.3795 8.1555 19.35 7.218V3H20.65V7.218C20.6798 7.81059 20.9427 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n</svg>\n';
const __vite_glob_0_137 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.23001V9.35002H22.992C22.3992 9.37585 21.8203 9.16618 21.3815 8.76676C20.9427 8.36735 20.6798 7.8106 20.65 7.21802V2.35001H20.718C20.8896 2.35007 21.0542 2.41801 21.176 2.53901L27.458 8.76901C27.5188 8.82936 27.5671 8.90118 27.6001 8.9803C27.6331 9.05943 27.65 9.1443 27.65 9.23001Z"\n  />\n  <path\n    d="M18.289 15.77V14.887C18.289 14.2805 18.048 13.6988 17.6191 13.2699C17.1902 12.841 16.6085 12.6 16.002 12.6C15.3954 12.6 14.8137 12.841 14.3848 13.2699C13.9559 13.6988 13.715 14.2805 13.715 14.887L13.714 15.77H18.289Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M19.132 22.334H12.868V17.069H19.132V22.334ZM16.651 18.46H15.35V20.689H16.651V18.46Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44397 2.35001H19.35V7.21802C19.3795 8.15551 19.7794 9.0431 20.462 9.68636C21.1446 10.3296 22.0544 10.6761 22.992 10.65H27.65V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.6523 6.63429 2.34039 7.44397 2.35001ZM12.413 15.77V14.887C12.413 13.9354 12.791 13.0228 13.4639 12.3499C14.1367 11.677 15.0494 11.299 16.001 11.299C16.9526 11.299 17.8652 11.677 18.5381 12.3499C19.2109 13.0228 19.589 13.9354 19.589 14.887V15.77H19.782C19.8673 15.7699 19.9519 15.7866 20.0308 15.8191C20.1097 15.8516 20.1814 15.8994 20.2419 15.9597C20.3023 16.0199 20.3503 16.0915 20.3831 16.1703C20.4159 16.2491 20.4329 16.3336 20.433 16.419V22.984C20.433 23.0694 20.4161 23.1541 20.3834 23.233C20.3507 23.3119 20.3027 23.3836 20.2422 23.444C20.1818 23.5043 20.11 23.5522 20.031 23.5848C19.952 23.6174 19.8674 23.6341 19.782 23.634H12.218C12.1325 23.6341 12.0479 23.6174 11.9689 23.5848C11.89 23.5522 11.8182 23.5043 11.7577 23.444C11.6972 23.3836 11.6493 23.3119 11.6165 23.233C11.5838 23.1541 11.567 23.0694 11.567 22.984V16.419C11.5671 16.3336 11.584 16.2491 11.6168 16.1703C11.6496 16.0915 11.6976 16.0199 11.7581 15.9597C11.8185 15.8994 11.8902 15.8516 11.9691 15.8191C12.0481 15.7866 12.1326 15.7699 12.218 15.77H12.413Z"\n  />\n</svg>\n';
const __vite_glob_0_138 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M19.783 23.634H12.217C12.0446 23.634 11.8792 23.5655 11.7573 23.4436C11.6354 23.3217 11.567 23.1564 11.567 22.984V16.419C11.5672 16.2468 11.6358 16.0817 11.7577 15.9601C11.8796 15.8384 12.0447 15.77 12.217 15.77H19.783C19.9552 15.77 20.1204 15.8384 20.2422 15.9601C20.3641 16.0817 20.4327 16.2468 20.433 16.419V22.984C20.433 23.1564 20.3645 23.3217 20.2426 23.4436C20.1207 23.5655 19.9553 23.634 19.783 23.634ZM12.867 22.334H19.133V17.069H12.867V22.334Z"\n  />\n  <path\n    d="M13.7119 16.25H12.4119V14.424C12.4124 13.5317 12.7453 12.6716 13.3458 12.0115C13.9462 11.3514 14.7711 10.9388 15.6594 10.8541C16.5477 10.7694 17.4356 11.0187 18.15 11.5534C18.8644 12.0881 19.3538 12.8699 19.5229 13.746L18.2469 13.99C18.1396 13.4306 17.8275 12.9314 17.3716 12.59C16.9158 12.2485 16.3489 12.0893 15.782 12.1436C15.215 12.1979 14.6886 12.4616 14.3058 12.8834C13.923 13.3051 13.7112 13.8544 13.7119 14.424V16.25Z"\n  />\n  <path d="M16.65 18.46H15.35V20.689H16.65V18.46Z" />\n  <path\n    d="M24.556 29.65H7.44398C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.6523 6.63429 2.34039 7.44398 2.35001H20.717C20.8886 2.35007 21.0532 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82936 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44398 3.65001C6.97905 3.64035 6.52924 3.81528 6.19301 4.13652C5.85677 4.45775 5.66151 4.89913 5.64998 5.36401V26.636C5.66151 27.1009 5.85677 27.5423 6.19301 27.8635C6.52924 28.1847 6.97905 28.3597 7.44398 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.8069 27.8635C26.1432 27.5423 26.3384 27.1009 26.35 26.636V9.50001L20.45 3.64901L7.44398 3.65001Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0545 10.6759 21.1449 10.3293 20.4623 9.68605C19.7797 9.04284 19.3798 8.15541 19.35 7.218V3H20.65V7.218C20.6798 7.81059 20.9428 8.36733 21.3815 8.76675C21.8203 9.16616 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n</svg>\n';
const __vite_glob_0_139 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.23001V9.35H22.992C22.3992 9.37583 21.8203 9.16617 21.3815 8.76675C20.9428 8.36733 20.6798 7.81059 20.65 7.218V2.35001H20.717C20.8886 2.35007 21.0532 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82936 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M19.133 22.334H12.867V17.069H19.133V22.334ZM16.65 18.46H15.35V20.689H16.65V18.46Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44398 2.35001H19.35V7.218C19.3798 8.15541 19.7797 9.04284 20.4623 9.68605C21.1449 10.3293 22.0545 10.6759 22.992 10.65H27.65V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65H7.44398C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.6523 6.63429 2.34039 7.44398 2.35001ZM12.412 15.77V14.424C12.4124 13.5317 12.7454 12.6716 13.3458 12.0115C13.9463 11.3514 14.7711 10.9388 15.6594 10.8541C16.5477 10.7694 17.4357 11.0187 18.15 11.5534C18.8644 12.0881 19.3539 12.8699 19.523 13.746L18.247 13.99C18.1396 13.4306 17.8275 12.9314 17.3717 12.59C16.9158 12.2485 16.349 12.0893 15.782 12.1436C15.215 12.1979 14.6887 12.4616 14.3059 12.8834C13.923 13.3051 13.7113 13.8544 13.712 14.424V15.77H19.783C19.9552 15.77 20.1204 15.8384 20.2422 15.96C20.3641 16.0817 20.4327 16.2468 20.433 16.419V22.984C20.433 23.1564 20.3645 23.3217 20.2426 23.4436C20.1207 23.5655 19.9554 23.634 19.783 23.634H12.217C12.0446 23.634 11.8793 23.5655 11.7574 23.4436C11.6355 23.3217 11.567 23.1564 11.567 22.984V16.419C11.5672 16.2468 11.6358 16.0817 11.7577 15.96C11.8796 15.8384 12.0448 15.77 12.217 15.77H12.412Z"\n  />\n</svg>\n';
const __vite_glob_0_140 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.206 29.3002H7.09399C6.28431 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28431 1.9906 7.09399 2.00022H20.368C20.5396 2.00028 20.7043 2.06822 20.826 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.09399 3.30022C6.62907 3.29055 6.17925 3.46548 5.84302 3.78672C5.50678 4.10796 5.31153 4.54934 5.29999 5.01422V26.2862C5.31153 26.7511 5.50678 27.1925 5.84302 27.5137C6.17925 27.8349 6.62907 28.0099 7.09399 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.29922L7.09399 3.30022Z"\n  />\n  <path\n    d="M26.65 10.3001H22.642C21.7044 10.3263 20.7947 9.97976 20.112 9.33649C19.4294 8.69323 19.0295 7.80564 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z"\n  />\n  <path\n    d="M20.674 24.3434C20.5693 24.3426 20.4664 24.3165 20.374 24.2674L16.826 22.3804C16.7484 22.3415 16.6794 22.2876 16.6231 22.2216C16.5667 22.1557 16.5241 22.0792 16.4977 21.9966C16.4714 21.9139 16.4619 21.8268 16.4697 21.7405C16.4775 21.6541 16.5026 21.5701 16.5433 21.4936C16.5841 21.417 16.6398 21.3494 16.7071 21.2947C16.7744 21.24 16.852 21.1993 16.9353 21.1751C17.0186 21.1508 17.1059 21.1435 17.192 21.1535C17.2782 21.1635 17.3615 21.1907 17.437 21.2334L19.827 22.5044L19.391 19.8314C19.3633 19.6611 19.4043 19.4868 19.5051 19.3468C19.6059 19.2068 19.7582 19.1126 19.9285 19.0849C20.0987 19.0572 20.273 19.0982 20.413 19.199C20.553 19.2998 20.6472 19.4521 20.675 19.6224L21.321 23.5884C21.336 23.6814 21.3307 23.7766 21.3054 23.8673C21.28 23.9581 21.2353 24.0423 21.1743 24.1141C21.1132 24.1859 21.0373 24.2436 20.9518 24.2831C20.8663 24.3227 20.7732 24.3433 20.679 24.3434H20.674Z"\n  />\n  <path\n    d="M17.1279 22.4563C17.025 22.4567 16.9234 22.4326 16.8316 22.386C16.7398 22.3394 16.6604 22.2716 16.5999 22.1883L10.2609 13.4433C10.1635 13.3035 10.125 13.131 10.1534 12.9631C10.1819 12.7951 10.2752 12.645 10.4132 12.5451C10.5513 12.4453 10.723 12.4036 10.8914 12.429C11.0599 12.4545 11.2116 12.5451 11.3139 12.6813L17.2729 20.9013L19.1179 19.5793L13.1619 11.3633C13.1119 11.2942 13.076 11.2159 13.0562 11.133C13.0364 11.05 13.0331 10.9639 13.0466 10.8797C13.0738 10.7096 13.1674 10.5573 13.3069 10.4563C13.4464 10.3552 13.6204 10.3137 13.7905 10.3409C13.9606 10.3681 14.1129 10.4618 14.2139 10.6013L20.5539 19.3453C20.6044 19.4145 20.6406 19.4931 20.6606 19.5765C20.6805 19.6598 20.6837 19.7463 20.67 19.8309C20.6564 19.9155 20.6261 19.9966 20.5809 20.0694C20.5358 20.1422 20.4766 20.2054 20.4069 20.2553L17.5069 22.3353C17.3964 22.4143 17.2638 22.4567 17.1279 22.4563Z"\n  />\n  <path\n    d="M10.788 13.7123C10.7525 13.7121 10.7171 13.7095 10.682 13.7043C10.5119 13.6756 10.36 13.5811 10.259 13.4413L8.15896 10.5153C8.10894 10.4461 8.07311 10.3676 8.05352 10.2845C8.03393 10.2013 8.03098 10.1151 8.04483 10.0308C8.05867 9.94652 8.08905 9.8658 8.13421 9.79328C8.17937 9.72077 8.2384 9.65791 8.30795 9.6083L11.208 7.5273C11.2771 7.47737 11.3555 7.44174 11.4387 7.42251C11.5218 7.40328 11.6079 7.40083 11.692 7.4153C11.7762 7.42895 11.857 7.45912 11.9296 7.50409C12.0022 7.54905 12.0652 7.60792 12.115 7.6773L14.215 10.6033C14.3155 10.7433 14.3562 10.9176 14.3283 11.0877C14.3003 11.2577 14.206 11.4098 14.0659 11.5103L11.1659 13.5903C11.0557 13.6692 10.9236 13.7119 10.788 13.7123ZM9.59597 10.2853L10.9369 12.1553L12.781 10.8333L11.4409 8.9633L9.59597 10.2853Z"\n  />\n</svg>\n';
const __vite_glob_0_141 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M27.3 8.88022V9.00015H22.642C22.0492 9.02598 21.4703 8.81631 21.0315 8.41689C20.5928 8.01748 20.3298 7.46073 20.3 6.86815V2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022ZM7.094 2.00022H19V6.86815C19.0298 7.80555 19.4297 8.69298 20.1123 9.33619C20.7949 9.97941 21.7045 10.326 22.642 10.3001H27.3V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022ZM20.374 24.2674C20.4664 24.3165 20.5693 24.3426 20.674 24.3434H20.679C20.7732 24.3433 20.8663 24.3227 20.9518 24.2831C21.0373 24.2436 21.1132 24.1859 21.1743 24.1141C21.2353 24.0423 21.28 23.9581 21.3054 23.8673C21.3307 23.7766 21.336 23.6814 21.321 23.5884L20.675 19.6224C20.6542 19.4951 20.5964 19.3779 20.51 19.2847L14.2139 10.6013C14.2103 10.5962 14.2065 10.5912 14.2027 10.5862L12.115 7.6773C12.0652 7.60792 12.0022 7.54905 11.9296 7.50409C11.857 7.45912 11.7762 7.42895 11.692 7.4153C11.6079 7.40083 11.5218 7.40328 11.4387 7.42251C11.3555 7.44174 11.2771 7.47737 11.208 7.5273L8.30795 9.6083C8.2384 9.65791 8.17937 9.72077 8.13421 9.79328C8.08905 9.8658 8.05867 9.94652 8.04483 10.0308C8.03098 10.1151 8.03393 10.2013 8.05352 10.2845C8.07311 10.3676 8.10894 10.4461 8.15896 10.5153L10.259 13.4413C10.2638 13.4481 10.2688 13.4547 10.274 13.4612L16.5567 22.1286C16.576 22.1614 16.5982 22.1926 16.6231 22.2216C16.6493 22.2524 16.6783 22.2805 16.7097 22.3057C16.747 22.3368 16.7879 22.3638 16.8316 22.386C16.8446 22.3926 16.8579 22.3988 16.8714 22.4045L20.374 24.2674ZM11.6969 13.2095L17.2729 20.9013L19.1179 19.5793L13.5413 11.8866L11.6969 13.2095ZM18.3593 21.7239L19.5593 20.8632L19.827 22.5044L18.3593 21.7239ZM10.9369 12.1553L9.59597 10.2853L11.4409 8.9633L12.781 10.8333L10.9369 12.1553Z"\n  />\n</svg>\n';
const __vite_glob_0_142 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.65231 6.63429 2.34039 7.44397 2.35001H20.718C20.8896 2.35007 21.0542 2.41801 21.176 2.53901L27.458 8.76901C27.5188 8.82937 27.5671 8.90118 27.6001 8.9803C27.6331 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44397 3.65001C6.97905 3.64035 6.52923 3.81528 6.19299 4.13652C5.85676 4.45776 5.6615 4.89913 5.64996 5.36401V26.636C5.6615 27.1009 5.85676 27.5423 6.19299 27.8635C6.52923 28.1847 6.97905 28.3597 7.44397 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.8069 27.8635C26.1432 27.5423 26.3384 27.1009 26.35 26.636V9.50001L20.45 3.64901L7.44397 3.65001Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0544 10.6761 21.1446 10.3296 20.462 9.68635C19.7794 9.04308 19.3795 8.1555 19.35 7.218V3H20.65V7.218C20.6798 7.81058 20.9427 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n  <path\n    d="M15.9999 17.268C15.4173 17.2678 14.8479 17.0949 14.3636 16.7711C13.8793 16.4473 13.5018 15.9872 13.279 15.4489C13.0561 14.9107 12.9979 14.3184 13.1116 13.747C13.2253 13.1757 13.5059 12.6508 13.9178 12.2389C14.3298 11.8269 14.8546 11.5464 15.426 11.4327C15.9973 11.319 16.5896 11.3772 17.1279 11.6001C17.6661 11.8229 18.1262 12.2004 18.45 12.6847C18.7738 13.169 18.9467 13.7384 18.9469 14.321C18.9461 15.1024 18.6354 15.8515 18.0829 16.404C17.5304 16.9565 16.7813 17.2672 15.9999 17.268ZM15.9999 12.674C15.6741 12.6738 15.3556 12.7702 15.0846 12.9511C14.8137 13.1319 14.6024 13.3891 14.4776 13.69C14.3528 13.991 14.32 14.3222 14.3834 14.6417C14.4469 14.9613 14.6037 15.2548 14.834 15.4853C15.0643 15.7157 15.3577 15.8727 15.6772 15.9363C15.9967 15.9999 16.328 15.9674 16.629 15.8427C16.93 15.7181 17.1873 15.507 17.3683 15.2361C17.5493 14.9653 17.6459 14.6468 17.6459 14.321C17.6457 13.8845 17.4722 13.4658 17.1636 13.1571C16.855 12.8483 16.4365 12.6745 15.9999 12.674Z"\n  />\n  <path\n    d="M16.105 24.883C14.3809 24.9245 12.7 24.3413 11.372 23.241L11.172 23.049V22.043C11.1733 20.9887 11.5928 19.9781 12.3383 19.2327C13.0839 18.4873 14.0947 18.0681 15.149 18.067H16.857C17.9113 18.0681 18.9221 18.4873 19.6676 19.2327C20.4132 19.9781 20.8327 20.9887 20.834 22.043V23.021L20.665 23.207C20.0544 23.7753 19.3366 24.2161 18.5536 24.5039C17.7707 24.7917 16.9383 24.9206 16.105 24.883ZM12.47 22.459C13.533 23.2073 14.8052 23.6006 16.105 23.583C17.3402 23.628 18.552 23.2388 19.53 22.483V22.039C19.5292 21.3295 19.247 20.6493 18.7453 20.1477C18.2437 19.646 17.5635 19.3638 16.854 19.363H15.146C14.4365 19.3638 13.7563 19.646 13.2547 20.1477C12.753 20.6493 12.4708 21.3295 12.47 22.039V22.459Z"\n  />\n</svg>\n';
const __vite_glob_0_143 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.23001V9.35001H22.992C22.3992 9.37585 21.8203 9.16618 21.3815 8.76677C20.9427 8.36735 20.6798 7.8106 20.65 7.21801V2.35001H20.718C20.8896 2.35007 21.0542 2.41801 21.176 2.53901L27.458 8.76901C27.5188 8.82937 27.5671 8.90118 27.6001 8.9803C27.6331 9.05943 27.65 9.1443 27.65 9.23001Z"\n  />\n  <path\n    d="M16 12.674C15.6742 12.6738 15.3557 12.7702 15.0847 12.9511C14.8137 13.1319 14.6024 13.3891 14.4776 13.69C14.3528 13.991 14.32 14.3222 14.3835 14.6417C14.4469 14.9613 14.6037 15.2548 14.834 15.4853C15.0643 15.7157 15.3578 15.8727 15.6773 15.9363C15.9968 15.9999 16.328 15.9674 16.629 15.8427C16.93 15.7181 17.1873 15.507 17.3683 15.2361C17.5493 14.9653 17.646 14.6468 17.646 14.321C17.6457 13.8844 17.4722 13.4658 17.1636 13.1571C16.855 12.8483 16.4365 12.6745 16 12.674Z"\n  />\n  <path\n    d="M12.47 22.459C13.533 23.2072 14.8052 23.6006 16.105 23.583C17.3401 23.6279 18.552 23.2387 19.53 22.483V22.039C19.5292 21.3295 19.247 20.6493 18.7453 20.1477C18.2436 19.646 17.5634 19.3638 16.854 19.363H15.146C14.4365 19.3638 13.7563 19.646 13.2546 20.1477C12.753 20.6493 12.4708 21.3295 12.47 22.039V22.459Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44397 2.35001H19.35V7.21801C19.3795 8.15551 19.7794 9.0431 20.462 9.68636C21.1446 10.3296 22.0544 10.6761 22.992 10.65H27.65V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.65231 6.63429 2.34039 7.44397 2.35001ZM16 17.268C15.4174 17.2678 14.848 17.0949 14.3636 16.7711C13.8793 16.4473 13.5019 15.9872 13.279 15.4489C13.0562 14.9107 12.9979 14.3184 13.1116 13.747C13.2253 13.1757 13.5059 12.6508 13.9178 12.2389C14.3298 11.8269 14.8546 11.5464 15.426 11.4327C15.9974 11.319 16.5896 11.3772 17.1279 11.6001C17.6662 11.8229 18.1263 12.2004 18.4501 12.6847C18.7738 13.169 18.9468 13.7384 18.9469 14.321C18.9462 15.1024 18.6354 15.8515 18.0829 16.404C17.5304 16.9565 16.7813 17.2672 16 17.268ZM16.105 24.883C14.3809 24.9245 12.7 24.3413 11.372 23.241L11.172 23.049V22.043C11.1733 20.9887 11.5927 19.978 12.3383 19.2327C13.0839 18.4873 14.0947 18.0681 15.149 18.067H16.857C17.9112 18.0681 18.922 18.4873 19.6676 19.2327C20.4132 19.978 20.8327 20.9887 20.834 22.043V23.021L20.665 23.207C20.0543 23.7752 19.3366 24.2161 18.5536 24.5039C17.7707 24.7917 16.9383 24.9205 16.105 24.883Z"\n  />\n</svg>\n';
const __vite_glob_0_144 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.65231 6.63429 2.34039 7.44397 2.35001H20.718C20.8896 2.35007 21.0542 2.41801 21.176 2.53901L27.458 8.76901C27.5188 8.82937 27.5671 8.90118 27.6001 8.9803C27.6331 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44397 3.65001C6.97905 3.64035 6.52923 3.81528 6.19299 4.13652C5.85676 4.45776 5.6615 4.89913 5.64996 5.36401V26.636C5.6615 27.1009 5.85676 27.5423 6.19299 27.8635C6.52923 28.1847 6.97905 28.3597 7.44397 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.8069 27.8635C26.1432 27.5423 26.3384 27.1009 26.35 26.636V9.50001L20.45 3.64901L7.44397 3.65001Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0544 10.6761 21.1446 10.3296 20.462 9.68635C19.7794 9.04308 19.3795 8.1555 19.35 7.218V3H20.65V7.218C20.6798 7.81058 20.9427 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n  <path\n    d="M12.7 22.574C12.3285 22.5711 11.9732 22.4219 11.7111 22.1586C11.449 21.8954 11.3012 21.5395 11.2999 21.168V13.543C11.2987 13.2961 11.3628 13.0532 11.4857 12.839C11.6087 12.6249 11.786 12.447 11.9999 12.3235C12.2137 12.2001 12.4564 12.1354 12.7034 12.136C12.9503 12.1366 13.1927 12.2025 13.406 12.327L20 16.14C20.2142 16.2625 20.3923 16.4394 20.5162 16.6529C20.6401 16.8663 20.7053 17.1087 20.7053 17.3555C20.7053 17.6023 20.6401 17.8447 20.5162 18.0582C20.3923 18.2716 20.2142 18.4486 20 18.571L13.4 22.383C13.1875 22.5071 12.946 22.573 12.7 22.574ZM12.7 13.438C12.6813 13.4384 12.6631 13.4436 12.647 13.453C12.6311 13.4619 12.6179 13.475 12.6089 13.4909C12.5999 13.5068 12.5955 13.5248 12.596 13.543V21.168C12.5949 21.1865 12.5991 21.205 12.6079 21.2213C12.6167 21.2376 12.6299 21.2511 12.646 21.2603C12.6621 21.2696 12.6804 21.2741 12.699 21.2735C12.7175 21.273 12.7355 21.2672 12.751 21.257L19.351 17.445C19.3669 17.4361 19.38 17.423 19.389 17.4071C19.398 17.3913 19.4025 17.3732 19.402 17.355C19.4023 17.337 19.3977 17.3191 19.3888 17.3035C19.3798 17.2878 19.3667 17.2749 19.351 17.266L12.751 13.453C12.7355 13.4438 12.718 13.4386 12.7 13.438Z"\n  />\n</svg>\n';
const __vite_glob_0_145 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.23001V9.35001H22.992C22.3992 9.37585 21.8203 9.16618 21.3815 8.76677C20.9427 8.36735 20.6798 7.8106 20.65 7.21801V2.35001H20.718C20.8896 2.35007 21.0542 2.41801 21.176 2.53901L27.458 8.76901C27.5188 8.82937 27.5671 8.90118 27.6001 8.9803C27.6331 9.05943 27.65 9.1443 27.65 9.23001Z"\n  />\n  <path\n    d="M12.647 13.453C12.6631 13.4436 12.6813 13.4384 12.7 13.438C12.718 13.4386 12.7355 13.4438 12.751 13.453L19.351 17.266C19.3667 17.2749 19.3798 17.2878 19.3888 17.3035C19.3977 17.3191 19.4023 17.337 19.402 17.355C19.4025 17.3732 19.398 17.3913 19.389 17.4071C19.38 17.423 19.3669 17.4361 19.351 17.445L12.751 21.257C12.7355 21.2672 12.7175 21.273 12.699 21.2735C12.6804 21.2741 12.6621 21.2696 12.646 21.2603C12.6299 21.2511 12.6167 21.2376 12.6079 21.2213C12.5991 21.205 12.5949 21.1865 12.596 21.168V13.543C12.5955 13.5248 12.5999 13.5068 12.6089 13.4909C12.6179 13.475 12.6311 13.4619 12.647 13.453Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44397 2.35001H19.35V7.21801C19.3795 8.15551 19.7794 9.0431 20.462 9.68636C21.1446 10.3296 22.0544 10.6761 22.992 10.65H27.65V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.65231 6.63429 2.34039 7.44397 2.35001ZM11.7111 22.1586C11.9732 22.4219 12.3285 22.5711 12.7 22.574C12.946 22.573 13.1875 22.5071 13.4 22.383L20 18.571C20.2142 18.4486 20.3923 18.2716 20.5162 18.0582C20.6401 17.8447 20.7053 17.6023 20.7053 17.3555C20.7053 17.1087 20.6401 16.8663 20.5162 16.6529C20.3923 16.4394 20.2142 16.2625 20 16.14L13.406 12.327C13.1927 12.2025 12.9503 12.1366 12.7034 12.136C12.4564 12.1354 12.2137 12.2001 11.9999 12.3235C11.786 12.447 11.6087 12.6249 11.4857 12.839C11.3628 13.0532 11.2987 13.2961 11.2999 13.543V21.168C11.3012 21.5395 11.449 21.8954 11.7111 22.1586Z"\n  />\n</svg>\n';
const __vite_glob_0_146 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.094 3.30022C6.62908 3.29055 6.17927 3.46548 5.84303 3.78672C5.5068 4.10796 5.31154 4.54934 5.3 5.01422V26.2862C5.31154 26.7511 5.5068 27.1925 5.84303 27.5137C6.17927 27.8349 6.62908 28.0099 7.094 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.30022H7.094Z"\n  />\n  <path\n    d="M26.65 10.3001H22.642C21.7045 10.326 20.7949 9.97941 20.1123 9.33619C19.4298 8.69298 19.0298 7.80555 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z"\n  />\n  <path d="M16.3 12.2502H15V22.8152H16.3V12.2502Z" />\n  <path d="M20.932 16.8833H10.367V18.1833H20.932V16.8833Z" />\n</svg>\n';
const __vite_glob_0_147 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M27.3 9.00015V8.88022C27.3 8.7945 27.2831 8.70963 27.2501 8.63051C27.2172 8.55138 27.1689 8.47957 27.108 8.41922L20.825 2.18922C20.7033 2.06822 20.5386 2.00028 20.367 2.00022H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H27.3ZM19 2.00022H7.094C6.28432 1.9906 5.50388 2.30251 4.92386 2.86753C4.34384 3.43256 4.01159 4.20456 4 5.01422V26.2862C4.01159 27.0959 4.34384 27.8679 4.92386 28.4329C5.50388 28.9979 6.28432 29.3098 7.094 29.3002H24.206C25.0157 29.3098 25.7961 28.9979 26.3761 28.4329C26.9562 27.8679 27.2884 27.0959 27.3 26.2862V10.3001H22.642C21.7045 10.326 20.7949 9.97941 20.1123 9.33619C19.4297 8.69298 19.0298 7.80555 19 6.86815V2.00022ZM16.3 12.2502H15V16.8833H10.367V18.1833H15V22.8152H16.3V18.1833H20.932V16.8833H16.3V12.2502Z"\n  />\n</svg>\n';
const __vite_glob_0_148 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.206 29.3002H7.09399C6.28431 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28431 1.9906 7.09399 2.00022H20.368C20.5396 2.00028 20.7043 2.06822 20.826 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.09399 3.30022C6.62907 3.29055 6.17925 3.46548 5.84302 3.78672C5.50678 4.10796 5.31153 4.54934 5.29999 5.01422V26.2862C5.31153 26.7511 5.50678 27.1925 5.84302 27.5137C6.17925 27.8349 6.62907 28.0099 7.09399 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.29922L7.09399 3.30022Z"\n  />\n  <path\n    d="M26.65 10.3001H22.642C21.7044 10.3263 20.7947 9.97976 20.112 9.33649C19.4294 8.69323 19.0295 7.80564 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z"\n  />\n  <path\n    d="M18.5863 19.3753L17.652 20.2793L21.45 24.2047L22.3843 23.3007L18.5863 19.3753Z"\n  />\n  <path\n    d="M14.478 21.7063C13.342 21.7063 12.2314 21.3694 11.2868 20.7382C10.3422 20.1071 9.606 19.21 9.17125 18.1604C8.7365 17.1108 8.62275 15.9559 8.84438 14.8417C9.06601 13.7274 9.61309 12.704 10.4164 11.9006C11.2197 11.0973 12.2432 10.5503 13.3574 10.3286C14.4716 10.107 15.6266 10.2208 16.6761 10.6555C17.7257 11.0902 18.6228 11.8265 19.254 12.7711C19.8851 13.7157 20.222 14.8262 20.222 15.9623C20.2202 17.4851 19.6144 18.945 18.5376 20.0218C17.4608 21.0986 16.0009 21.7044 14.478 21.7063ZM14.478 11.5183C13.599 11.5181 12.7397 11.7785 12.0088 12.2667C11.2778 12.7549 10.7081 13.4489 10.3716 14.2609C10.0351 15.0729 9.94691 15.9665 10.1183 16.8286C10.2896 17.6907 10.7128 18.4827 11.3343 19.1043C11.9557 19.7259 12.7476 20.1492 13.6097 20.3208C14.4717 20.4924 15.3653 20.4044 16.1774 20.0681C16.9895 19.7318 17.6836 19.1622 18.172 18.4313C18.6603 17.7005 18.921 16.8412 18.921 15.9623C18.9199 14.7841 18.4515 13.6546 17.6186 12.8214C16.7856 11.9883 15.6561 11.5196 14.478 11.5183Z"\n  />\n</svg>\n';
const __vite_glob_0_149 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M27.3 9.00015V8.88022C27.3 8.7945 27.2831 8.70963 27.2501 8.63051C27.2172 8.55138 27.1689 8.47957 27.108 8.41922L20.825 2.18922C20.7033 2.06822 20.5386 2.00028 20.367 2.00022H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H27.3ZM19 2.00022H7.094C6.28432 1.9906 5.50388 2.30251 4.92386 2.86753C4.34384 3.43256 4.01159 4.20456 4 5.01422V26.2862C4.01159 27.0959 4.34384 27.8679 4.92386 28.4329C5.50388 28.9979 6.28432 29.3098 7.094 29.3002H24.206C25.0157 29.3098 25.7961 28.9979 26.3761 28.4329C26.9562 27.8679 27.2884 27.0959 27.3 26.2862V10.3001H22.642C21.7045 10.326 20.7949 9.97941 20.1123 9.33619C19.4297 8.69298 19.0298 7.80555 19 6.86815V2.00022ZM17.9206 20.5569C16.9331 21.2972 15.7267 21.7047 14.478 21.7063C13.342 21.7063 12.2314 21.3694 11.2868 20.7382C10.3422 20.1071 9.606 19.21 9.17125 18.1604C8.7365 17.1108 8.62275 15.9559 8.84438 14.8417C9.06601 13.7274 9.61309 12.704 10.4164 11.9006C11.2197 11.0973 12.2432 10.5503 13.3574 10.3286C14.4716 10.107 15.6266 10.2207 16.6761 10.6555C17.7257 11.0903 18.6228 11.8265 19.254 12.7711C19.8851 13.7157 20.222 14.8262 20.222 15.9623C20.2203 17.3226 19.7368 18.6328 18.866 19.6644L22.3843 23.3007L21.45 24.2047L17.9206 20.5569ZM12.0088 12.2667C12.7397 11.7785 13.599 11.5181 14.478 11.5183C15.6561 11.5196 16.7856 11.9883 17.6186 12.8214C18.4515 13.6546 18.9199 14.7841 18.921 15.9623C18.921 16.8412 18.6603 17.7005 18.172 18.4313C17.6836 19.1622 16.9895 19.7318 16.1774 20.0681C15.3653 20.4044 14.4717 20.4924 13.6097 20.3208C12.7476 20.1492 11.9557 19.7259 11.3343 19.1043C10.7128 18.4827 10.2896 17.6907 10.1183 16.8286C9.94691 15.9665 10.0351 15.0729 10.3716 14.2609C10.7081 13.4489 11.2778 12.7549 12.0088 12.2667Z"\n  />\n</svg>\n';
const __vite_glob_0_150 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.852 24.453H15.152C14.9332 24.4528 14.7215 24.3748 14.5549 24.2331C14.3882 24.0913 14.2773 23.8949 14.242 23.679L14.085 22.646L14.063 22.638L13.277 23.232C13.1153 23.3596 12.9159 23.43 12.71 23.432C12.46 23.4275 12.2218 23.3248 12.047 23.146C11.5726 22.7473 11.1373 22.3043 10.747 21.823C10.6105 21.645 10.5399 21.4252 10.547 21.201C10.5492 20.9984 10.6196 20.8025 10.747 20.645C10.859 20.487 10.998 20.312 11.139 20.135L11.304 19.925C11.29 19.893 11.276 19.86 11.263 19.825L10.252 19.676C10.0382 19.6394 9.84375 19.5296 9.702 19.3654C9.56024 19.2012 9.47999 18.9929 9.47498 18.776V17.07C9.47674 16.8696 9.54209 16.675 9.66161 16.5141C9.78112 16.3533 9.94863 16.2345 10.14 16.175L11.267 15.992L11.287 15.943C11.103 15.7 10.917 15.465 10.723 15.229C10.5947 15.0748 10.5196 14.8833 10.509 14.683C10.5045 14.4532 10.581 14.2291 10.725 14.05C10.725 14.05 11.962 12.45 12.693 12.45C12.9093 12.45 13.1199 12.5202 13.293 12.65L14.039 13.234C14.0843 12.8642 14.1487 12.4971 14.232 12.134C14.2793 11.9305 14.3938 11.7489 14.5572 11.6186C14.7205 11.4883 14.923 11.4169 15.132 11.416H16.827C17.0467 11.4171 17.2591 11.495 17.4275 11.6361C17.5958 11.7773 17.7096 11.9729 17.749 12.189L17.9 13.223L17.922 13.232L18.713 12.644C18.8695 12.5067 19.0718 12.4332 19.28 12.438C19.5088 12.445 19.7282 12.5308 19.901 12.681C20.3878 13.1001 20.8341 13.5642 21.234 14.067C21.3679 14.2376 21.4367 14.4503 21.428 14.667C21.4262 14.8702 21.3557 15.0669 21.228 15.225C21.116 15.383 20.977 15.558 20.836 15.735C20.782 15.805 20.727 15.874 20.671 15.944C20.685 15.975 20.697 16.005 20.71 16.035L21.727 16.191C21.9401 16.2283 22.1337 16.3384 22.2747 16.5025C22.4157 16.6667 22.4953 16.8747 22.5 17.091V18.8C22.4961 19.0071 22.425 19.2073 22.2975 19.3705C22.17 19.5337 21.993 19.6511 21.793 19.705L20.693 19.874L20.675 19.915C20.859 20.159 21.046 20.391 21.239 20.626C21.3878 20.7972 21.468 21.0174 21.4639 21.2442C21.4599 21.471 21.3719 21.6883 21.217 21.854C21.217 21.854 20.005 23.425 19.278 23.425C19.0737 23.4187 18.8754 23.3538 18.707 23.238L17.939 22.638C17.8939 23.0078 17.8295 23.3749 17.746 23.738C17.6982 23.9399 17.5842 24.12 17.4222 24.2496C17.2602 24.3791 17.0594 24.4508 16.852 24.453ZM13.915 21.121L14.278 21.306C14.4671 21.4022 14.6637 21.4828 14.866 21.547L15.252 21.669L15.478 23.153H16.553C16.6209 22.8094 16.6694 22.4621 16.698 22.113L16.734 21.682L17.146 21.548C17.3524 21.4817 17.553 21.3988 17.746 21.3L18.116 21.109L19.282 22.021C19.558 21.7681 19.8207 21.5011 20.069 21.221C19.838 20.936 19.624 20.659 19.409 20.359L19.174 20.03L19.365 19.673C19.4671 19.4838 19.5524 19.2861 19.62 19.082L19.744 18.703L21.221 18.479V17.425L19.749 17.2L19.628 16.812C19.5612 16.5928 19.4728 16.3807 19.364 16.179L19.172 15.823L19.406 15.495C19.545 15.295 19.693 15.112 19.839 14.927C19.912 14.836 19.983 14.746 20.054 14.654C19.8124 14.3716 19.5535 14.1044 19.279 13.854L18.084 14.754L17.724 14.571C17.5348 14.4739 17.3378 14.393 17.135 14.329L16.747 14.206L16.531 12.723H15.451C15.3831 13.0667 15.3347 13.4139 15.306 13.763L15.27 14.194L14.858 14.327C14.6516 14.3938 14.451 14.4771 14.258 14.576L13.888 14.767L12.716 13.85C12.4378 14.1016 12.1741 14.3687 11.926 14.65C12.15 14.928 12.362 15.205 12.574 15.495L12.815 15.826L12.622 16.186C12.5205 16.3747 12.4371 16.5726 12.373 16.777L12.251 17.161L10.781 17.392V18.45L12.257 18.667L12.375 19.067C12.441 19.2878 12.5294 19.5013 12.639 19.704L12.829 20.059L12.596 20.387C12.457 20.587 12.309 20.77 12.163 20.955C12.089 21.048 12.015 21.141 11.943 21.234C12.188 21.5169 12.4505 21.7841 12.729 22.034L13.915 21.121ZM12.92 22.185L12.937 22.2C12.9328 22.1936 12.9269 22.1884 12.92 22.185ZM20.241 21.015C20.2342 21.0208 20.2288 21.028 20.225 21.036L20.241 21.015ZM19.577 13.625L19.495 13.687C19.5251 13.6703 19.5527 13.6495 19.577 13.625Z"\n  />\n  <path\n    d="M16 20.773C15.4385 20.773 14.8896 20.6065 14.4227 20.2945C13.9559 19.9826 13.592 19.5392 13.3771 19.0204C13.1622 18.5017 13.106 17.9309 13.2156 17.3801C13.3251 16.8294 13.5955 16.3236 13.9925 15.9265C14.3896 15.5295 14.8954 15.2591 15.4461 15.1496C15.9969 15.04 16.5677 15.0962 17.0865 15.3111C17.6052 15.526 18.0486 15.8899 18.3606 16.3567C18.6725 16.8236 18.839 17.3725 18.839 17.934C18.8382 18.6867 18.5389 19.4084 18.0066 19.9406C17.4744 20.4728 16.7527 20.7722 16 20.773ZM16 16.395C15.6956 16.395 15.3981 16.4853 15.145 16.6544C14.8919 16.8235 14.6946 17.0638 14.5782 17.345C14.4617 17.6263 14.4312 17.9357 14.4906 18.2342C14.55 18.5328 14.6965 18.807 14.9118 19.0222C15.127 19.2375 15.4012 19.384 15.6998 19.4434C15.9983 19.5028 16.3077 19.4723 16.589 19.3559C16.8702 19.2394 17.1105 19.0421 17.2796 18.789C17.4487 18.5359 17.539 18.2384 17.539 17.934C17.5387 17.5259 17.3765 17.1346 17.088 16.8461C16.7994 16.5575 16.4081 16.3953 16 16.395Z"\n  />\n  <path\n    d="M24.556 29.65H7.44398C6.6343 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36399C4.36157 4.55434 4.69381 3.78234 5.27383 3.21731C5.85385 2.65229 6.6343 2.34038 7.44398 2.34999H20.717C20.8886 2.35006 21.0533 2.418 21.175 2.539L27.458 8.769C27.5188 8.82935 27.5671 8.90116 27.6001 8.98029C27.633 9.05941 27.65 9.14428 27.65 9.22999V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44398 3.65C6.97905 3.64033 6.52924 3.81526 6.19301 4.1365C5.85678 4.45774 5.66152 4.89911 5.64998 5.36399V26.636C5.66152 27.1009 5.85678 27.5422 6.19301 27.8635C6.52924 28.1847 6.97905 28.3597 7.44398 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.807 27.8635C26.1432 27.5422 26.3384 27.1009 26.35 26.636V9.49999L20.45 3.64899L7.44398 3.65Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0544 10.6759 21.1449 10.3293 20.4623 9.68605C19.7797 9.04283 19.3798 8.15541 19.35 7.218V3H20.65V7.218C20.6798 7.81058 20.9428 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n</svg>\n';
const __vite_glob_0_151 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.22999V9.35H22.992C22.3992 9.37583 21.8203 9.16617 21.3815 8.76675C20.9428 8.36733 20.6798 7.81058 20.65 7.218V2.34999H20.717C20.8886 2.35005 21.0533 2.418 21.175 2.539L27.458 8.769C27.5188 8.82935 27.5671 8.90116 27.6001 8.98029C27.633 9.05941 27.65 9.14428 27.65 9.22999Z"\n  />\n  <path\n    d="M16 16.395C15.6956 16.395 15.398 16.4853 15.145 16.6544C14.8919 16.8235 14.6946 17.0638 14.5781 17.345C14.4616 17.6263 14.4312 17.9357 14.4906 18.2342C14.5499 18.5328 14.6965 18.807 14.9117 19.0222C15.127 19.2375 15.4012 19.384 15.6997 19.4434C15.9983 19.5028 16.3077 19.4723 16.5889 19.3559C16.8701 19.2394 17.1105 19.0421 17.2796 18.789C17.4487 18.5359 17.539 18.2384 17.539 17.934C17.5387 17.5259 17.3765 17.1346 17.0879 16.8461C16.7994 16.5575 16.4081 16.3953 16 16.395Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M13.915 21.121L14.278 21.306C14.4671 21.4022 14.6637 21.4828 14.866 21.547L15.252 21.669L15.478 23.153H16.553C16.6209 22.8094 16.6694 22.4621 16.698 22.113L16.734 21.682L17.146 21.548C17.3524 21.4817 17.553 21.3988 17.746 21.3L18.116 21.109L19.282 22.021C19.558 21.7681 19.8207 21.5011 20.069 21.221C19.838 20.936 19.624 20.659 19.409 20.359L19.174 20.03L19.365 19.673C19.4671 19.4838 19.5524 19.2861 19.62 19.082L19.744 18.703L21.221 18.479V17.425L19.749 17.2L19.628 16.812C19.5612 16.5928 19.4728 16.3807 19.364 16.179L19.172 15.823L19.406 15.495C19.5258 15.3225 19.6524 15.1627 19.7786 15.0033L19.839 14.927C19.912 14.836 19.983 14.746 20.054 14.654C19.8124 14.3716 19.5535 14.1044 19.279 13.854L18.084 14.754L17.724 14.571C17.5348 14.4739 17.3378 14.393 17.135 14.329L16.747 14.206L16.531 12.723H15.451C15.3831 13.0667 15.3347 13.4139 15.306 13.763L15.27 14.194L14.858 14.327C14.6516 14.3938 14.451 14.4771 14.258 14.576L13.888 14.767L12.716 13.85C12.4378 14.1016 12.1741 14.3687 11.926 14.65C12.15 14.928 12.362 15.205 12.574 15.495L12.815 15.826L12.622 16.186C12.5205 16.3747 12.4371 16.5726 12.373 16.777L12.251 17.161L10.781 17.392V18.45L12.257 18.667L12.375 19.067C12.441 19.2878 12.5294 19.5013 12.639 19.704L12.829 20.059L12.596 20.387C12.4761 20.5595 12.3495 20.7193 12.2233 20.8787L12.163 20.955C12.0891 21.0479 12.0149 21.1411 11.943 21.234C12.188 21.5169 12.4505 21.7841 12.729 22.034L13.915 21.121ZM16 20.773C15.4385 20.773 14.8896 20.6065 14.4227 20.2945C13.9558 19.9826 13.592 19.5392 13.3771 19.0204C13.1622 18.5017 13.106 17.9309 13.2155 17.3801C13.3251 16.8294 13.5955 16.3236 13.9925 15.9265C14.3895 15.5295 14.8954 15.2591 15.4461 15.1496C15.9968 15.04 16.5677 15.0962 17.0864 15.3111C17.6052 15.526 18.0486 15.8899 18.3605 16.3567C18.6725 16.8236 18.839 17.3725 18.839 17.934C18.8382 18.6867 18.5388 19.4084 18.0066 19.9406C17.4743 20.4728 16.7527 20.7722 16 20.773Z"\n  />\n  <path\n    d="M12.92 22.185L12.937 22.2C12.9328 22.1936 12.9269 22.1884 12.92 22.185Z"\n  />\n  <path\n    d="M20.241 21.015C20.2342 21.0208 20.2288 21.028 20.225 21.036L20.241 21.015Z"\n  />\n  <path\n    d="M19.577 13.625L19.495 13.687C19.5251 13.6703 19.5527 13.6495 19.577 13.625Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44398 2.34999H19.35V7.218C19.3798 8.15541 19.7797 9.04284 20.4623 9.68605C21.1449 10.3293 22.0544 10.6759 22.992 10.65H27.65V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65H7.44398C6.6343 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36399C4.36157 4.55434 4.69381 3.78234 5.27383 3.21731C5.85385 2.65229 6.6343 2.34038 7.44398 2.34999ZM16.852 24.453H15.152C14.9332 24.4528 14.7215 24.3748 14.5549 24.2331C14.3882 24.0913 14.2773 23.8949 14.242 23.679L14.085 22.646L14.063 22.638L13.277 23.232C13.1153 23.3596 12.9159 23.43 12.71 23.432C12.46 23.4275 12.2218 23.3248 12.047 23.146C11.5726 22.7473 11.1373 22.3043 10.747 21.823C10.6105 21.645 10.5399 21.4252 10.547 21.201C10.5492 20.9984 10.6196 20.8025 10.747 20.645C10.859 20.487 10.998 20.312 11.139 20.135L11.304 19.925C11.29 19.893 11.276 19.86 11.263 19.825L10.252 19.676C10.0382 19.6394 9.84375 19.5296 9.702 19.3654C9.56024 19.2012 9.47999 18.9929 9.47498 18.776V17.07C9.47674 16.8696 9.54209 16.675 9.66161 16.5141C9.78112 16.3533 9.94863 16.2345 10.14 16.175L11.267 15.992L11.287 15.943C11.103 15.7 10.917 15.465 10.723 15.229C10.5947 15.0748 10.5196 14.8833 10.509 14.683C10.5045 14.4532 10.581 14.2291 10.725 14.05C10.725 14.05 11.962 12.45 12.693 12.45C12.9093 12.45 13.1199 12.5202 13.293 12.65L14.039 13.234C14.0843 12.8642 14.1487 12.4971 14.232 12.134C14.2793 11.9305 14.3938 11.7489 14.5572 11.6186C14.7205 11.4883 14.923 11.4169 15.132 11.416H16.827C17.0467 11.4171 17.2591 11.495 17.4275 11.6361C17.5958 11.7773 17.7096 11.9729 17.749 12.189L17.9 13.223L17.922 13.232L18.713 12.644C18.8695 12.5067 19.0718 12.4332 19.28 12.438C19.5088 12.445 19.7282 12.5308 19.901 12.681C20.3878 13.1001 20.8341 13.5642 21.234 14.067C21.3679 14.2376 21.4367 14.4503 21.428 14.667C21.4262 14.8702 21.3557 15.0669 21.228 15.225C21.116 15.383 20.977 15.558 20.836 15.735C20.782 15.805 20.727 15.874 20.671 15.944C20.6795 15.963 20.6873 15.9815 20.6951 16L20.71 16.035L21.727 16.191C21.9401 16.2283 22.1337 16.3384 22.2747 16.5025C22.4157 16.6667 22.4953 16.8747 22.5 17.091V18.8C22.4961 19.0071 22.425 19.2073 22.2975 19.3705C22.17 19.5337 21.9929 19.6511 21.793 19.705L20.693 19.874L20.675 19.915C20.859 20.159 21.046 20.391 21.239 20.626C21.3878 20.7972 21.468 21.0174 21.4639 21.2442C21.4599 21.471 21.3719 21.6883 21.217 21.854C21.217 21.854 20.005 23.425 19.278 23.425C19.0737 23.4187 18.8754 23.3538 18.707 23.238L17.939 22.638C17.8939 23.0078 17.8295 23.3749 17.746 23.738C17.6982 23.9399 17.5842 24.12 17.4222 24.2496C17.2602 24.3791 17.0594 24.4508 16.852 24.453Z"\n  />\n</svg>\n';
const __vite_glob_0_152 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36399C4.36157 4.55434 4.69381 3.78234 5.27383 3.21731C5.85385 2.65229 6.63429 2.34038 7.44397 2.34999H20.718C20.8896 2.35006 21.0542 2.418 21.176 2.539L27.458 8.769C27.5188 8.82935 27.5671 8.90116 27.6001 8.98029C27.6331 9.05941 27.65 9.14428 27.65 9.22999V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44397 3.65C6.97905 3.64033 6.52923 3.81526 6.19299 4.1365C5.85676 4.45774 5.6615 4.89911 5.64996 5.36399V26.636C5.6615 27.1009 5.85676 27.5422 6.19299 27.8635C6.52923 28.1847 6.97905 28.3597 7.44397 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.8069 27.8635C26.1432 27.5422 26.3384 27.1009 26.35 26.636V9.49999L20.45 3.64899L7.44397 3.65Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0544 10.6761 21.1446 10.3296 20.462 9.68635C19.7794 9.04308 19.3795 8.1555 19.35 7.218V3H20.65V7.218C20.6798 7.81058 20.9427 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n  <path\n    d="M19.1719 22.891C19.0673 22.8908 18.9643 22.8651 18.872 22.816L16 21.309L13.131 22.816C13.0237 22.8731 12.9026 22.8987 12.7814 22.8901C12.6603 22.8814 12.544 22.8387 12.446 22.767C12.3479 22.6956 12.2717 22.5982 12.2259 22.4859C12.1802 22.3735 12.1667 22.2506 12.187 22.131L12.7359 18.937L10.414 16.674C10.3273 16.5893 10.2661 16.4821 10.2371 16.3645C10.2081 16.2469 10.2126 16.1235 10.2501 16.0083C10.2875 15.893 10.3564 15.7906 10.449 15.7124C10.5415 15.6343 10.6541 15.5836 10.7739 15.566L13.9819 15.099L15.4169 12.193C15.4768 12.0916 15.562 12.0076 15.6643 11.9492C15.7665 11.8908 15.8822 11.8601 16 11.8601C16.1177 11.8601 16.2334 11.8908 16.3356 11.9492C16.4379 12.0076 16.5231 12.0916 16.583 12.193L18.018 15.099L21.226 15.566C21.3458 15.5836 21.4584 15.6343 21.5509 15.7124C21.6435 15.7906 21.7124 15.893 21.7498 16.0083C21.7873 16.1235 21.7918 16.2469 21.7628 16.3645C21.7338 16.4821 21.6726 16.5893 21.586 16.674L19.264 18.937L19.812 22.131C19.8282 22.2243 19.8237 22.32 19.799 22.4113C19.7743 22.5027 19.7299 22.5876 19.6689 22.66C19.6079 22.7324 19.5319 22.7906 19.446 22.8305C19.3602 22.8704 19.2666 22.8911 19.1719 22.891ZM16 19.924C16.1045 19.9245 16.2074 19.9502 16.2999 19.999L18.306 21.053L17.9219 18.82C17.9042 18.7162 17.9119 18.6098 17.9443 18.5096C17.9767 18.4095 18.0328 18.3187 18.108 18.245L19.7319 16.663L17.489 16.336C17.3847 16.3211 17.2857 16.2809 17.2005 16.2191C17.1152 16.1572 17.0464 16.0755 17 15.981L16 13.949L15 15.981C14.9535 16.0755 14.8847 16.1572 14.7995 16.2191C14.7142 16.2809 14.6152 16.3211 14.5109 16.336L12.268 16.663L13.892 18.245C13.9671 18.3187 14.0232 18.4095 14.0556 18.5096C14.088 18.6098 14.0957 18.7162 14.078 18.82L13.694 21.053L15.7 20C15.7924 19.9509 15.8953 19.9248 16 19.924Z"\n  />\n</svg>\n';
const __vite_glob_0_153 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.65 9.22999V9.35H22.992C22.3992 9.37583 21.8203 9.16617 21.3815 8.76675C20.9427 8.36733 20.6798 7.81058 20.65 7.218V2.34999H20.718C20.8896 2.35005 21.0542 2.418 21.176 2.539L27.458 8.769C27.5188 8.82935 27.5671 8.90116 27.6001 8.98029C27.6331 9.05941 27.65 9.14428 27.65 9.22999Z"\n  />\n  <path\n    d="M16.3 19.999C16.2075 19.9502 16.1046 19.9245 16 19.924C15.8953 19.9248 15.7924 19.9509 15.7 20L13.694 21.053L14.078 18.82C14.0957 18.7162 14.088 18.6098 14.0556 18.5096C14.0232 18.4095 13.9671 18.3187 13.892 18.245L12.268 16.663L14.511 16.336C14.6152 16.3211 14.7143 16.2809 14.7995 16.2191C14.8847 16.1572 14.9535 16.0755 15 15.981L16 13.949L17 15.981C17.0464 16.0755 17.1153 16.1572 17.2005 16.2191C17.2857 16.2809 17.3848 16.3211 17.489 16.336L19.732 16.663L18.108 18.245C18.0329 18.3187 17.9767 18.4095 17.9443 18.5096C17.912 18.6098 17.9043 18.7162 17.922 18.82L18.306 21.053L16.3 19.999Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.44397 2.34999H19.35V7.218C19.3795 8.1555 19.7794 9.04308 20.462 9.68635C21.1446 10.3296 22.0544 10.6761 22.992 10.65H27.65V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65H7.44397C6.63429 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36399C4.36157 4.55434 4.69381 3.78234 5.27383 3.21731C5.85385 2.65229 6.63429 2.34038 7.44397 2.34999ZM18.872 22.816C18.9644 22.8651 19.0674 22.8908 19.172 22.891C19.2667 22.8911 19.3602 22.8704 19.4461 22.8305C19.5319 22.7906 19.608 22.7324 19.669 22.66C19.7299 22.5876 19.7744 22.5027 19.7991 22.4113C19.8238 22.32 19.8282 22.2243 19.812 22.131L19.264 18.937L21.586 16.674C21.6726 16.5893 21.7339 16.4821 21.7628 16.3645C21.7918 16.2469 21.7873 16.1235 21.7499 16.0083C21.7124 15.893 21.6435 15.7906 21.551 15.7124C21.4584 15.6343 21.3459 15.5836 21.226 15.566L18.018 15.099L16.583 12.193C16.5231 12.0916 16.4379 12.0076 16.3356 11.9492C16.2334 11.8908 16.1177 11.8601 16 11.8601C15.8823 11.8601 15.7666 11.8908 15.6643 11.9492C15.5621 12.0076 15.4768 12.0916 15.417 12.193L13.982 15.099L10.774 15.566C10.6541 15.5836 10.5416 15.6343 10.449 15.7124C10.3564 15.7906 10.2875 15.893 10.2501 16.0083C10.2127 16.1235 10.2082 16.2469 10.2371 16.3645C10.2661 16.4821 10.3273 16.5893 10.414 16.674L12.736 18.937L12.187 22.131C12.1667 22.2506 12.1802 22.3735 12.226 22.4859C12.2717 22.5982 12.3479 22.6956 12.446 22.767C12.544 22.8387 12.6603 22.8814 12.7814 22.8901C12.9026 22.8987 13.0238 22.8731 13.131 22.816L16 21.309L18.872 22.816Z"\n  />\n</svg>\n';
const __vite_glob_0_154 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.556 29.65H7.44398C6.6343 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.6523 6.6343 2.34039 7.44398 2.35001H20.717C20.8886 2.35007 21.0533 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82936 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM7.44398 3.65001C6.97905 3.64035 6.52924 3.81528 6.19301 4.13652C5.85678 4.45775 5.66152 4.89913 5.64998 5.36401V26.636C5.66152 27.1009 5.85678 27.5423 6.19301 27.8635C6.52924 28.1847 6.97905 28.3597 7.44398 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.8069 27.8635C26.1432 27.5423 26.3384 27.1009 26.35 26.636V9.50001L20.45 3.64901L7.44398 3.65001Z"\n  />\n  <path\n    d="M27 10.65H22.992C22.0544 10.6759 21.1449 10.3293 20.4623 9.68605C19.7797 9.04284 19.3798 8.15541 19.35 7.218V3H20.65V7.218C20.6798 7.81059 20.9428 8.36733 21.3815 8.76675C21.8203 9.16616 22.3992 9.37583 22.992 9.35H27V10.65Z"\n  />\n  <path\n    d="M16 25.271C14.6524 25.2694 13.3604 24.7334 12.4075 23.7805C11.4546 22.8276 10.9186 21.5356 10.917 20.188V13.348H12.217V20.188C12.217 21.1913 12.6156 22.1535 13.325 22.863C14.0345 23.5724 14.9967 23.971 16 23.971C17.0033 23.971 17.9655 23.5724 18.675 22.863C19.3844 22.1535 19.783 21.1913 19.783 20.188V15.188H21.083V20.188C21.0814 21.5356 20.5454 22.8276 19.5925 23.7805C18.6396 24.7334 17.3476 25.2694 16 25.271Z"\n  />\n  <path d="M18.77 12.588H17.47V18.737H18.77V12.588Z" />\n  <path d="M14.607 11.196H13.307V18.737H14.607V11.196Z" />\n  <path d="M16.689 10.702H15.389V18.737H16.689V10.702Z" />\n</svg>\n';
const __vite_glob_0_155 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M24.556 29.65H7.44398C6.6343 29.6596 5.85385 29.3477 5.27383 28.7827C4.69381 28.2177 4.36157 27.4457 4.34998 26.636V5.36401C4.36157 4.55435 4.69381 3.78235 5.27383 3.21733C5.85385 2.6523 6.6343 2.34039 7.44398 2.35001H20.717C20.8886 2.35007 21.0533 2.41801 21.175 2.53901L27.458 8.76901C27.5188 8.82936 27.5671 8.90118 27.6001 8.9803C27.633 9.05943 27.65 9.1443 27.65 9.23001V26.636C27.6384 27.4457 27.3061 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65ZM16.6889 10.702H15.3889V18.737H16.6889V10.702ZM13.307 11.196H14.607V18.737H13.307V11.196ZM18.7699 12.588H17.4699V18.737H18.7699V12.588ZM16 25.271C14.6524 25.2694 13.3604 24.7334 12.4075 23.7805C11.4546 22.8276 10.9185 21.5356 10.917 20.188V13.348H12.217V20.188C12.217 21.1913 12.6155 22.1535 13.325 22.863C14.0344 23.5724 14.9966 23.971 16 23.971C17.0033 23.971 17.9655 23.5724 18.6749 22.863C19.3844 22.1535 19.783 21.1913 19.783 20.188V15.188H21.083V20.188C21.0814 21.5356 20.5453 22.8276 19.5924 23.7805C18.6395 24.7334 17.3476 25.2694 16 25.271Z"\n  />\n</svg>\n';
const __vite_glob_0_156 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.206 29.3002H7.09399C6.28431 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28431 1.9906 7.09399 2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1688 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.09399 3.30022C6.62907 3.29055 6.17925 3.46548 5.84302 3.78672C5.50678 4.10796 5.31153 4.54934 5.29999 5.01422V26.2862C5.31153 26.7511 5.50678 27.1925 5.84302 27.5137C6.17925 27.8349 6.62907 28.0099 7.09399 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.29922L7.09399 3.30022Z"\n  />\n  <path\n    d="M26.65 10.3001H22.642C21.7045 10.326 20.7949 9.97941 20.1123 9.33619C19.4297 8.69298 19.0298 7.80555 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z"\n  />\n  <path\n    d="M13.702 22.7373C13.6165 22.7375 13.5318 22.7207 13.4528 22.6879C13.3739 22.6551 13.3022 22.607 13.242 22.5463L9.53198 18.8363L10.451 17.9173L13.697 21.1633L20.844 13.8633L21.773 14.7733L14.166 22.5453C14.1059 22.6067 14.0342 22.6555 13.955 22.689C13.8759 22.7225 13.7909 22.7399 13.705 22.7403L13.702 22.7373Z"\n  />\n</svg>\n';
const __vite_glob_0_157 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M27.3 8.88022V9.00015H22.642C22.0492 9.02598 21.4703 8.81631 21.0315 8.41689C20.5928 8.01748 20.3298 7.46073 20.3 6.86815V2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022ZM7.094 2.00022H19V6.86815C19.0298 7.80555 19.4297 8.69298 20.1123 9.33619C20.7949 9.97941 21.7045 10.326 22.642 10.3001H27.3V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022ZM13.4528 22.6879C13.5318 22.7207 13.6165 22.7375 13.702 22.7373L13.705 22.7403C13.7909 22.7399 13.8759 22.7225 13.955 22.689C14.0342 22.6555 14.1059 22.6067 14.166 22.5453L21.773 14.7733L20.844 13.8633L13.697 21.1633L10.451 17.9173L9.53198 18.8363L13.242 22.5463C13.3022 22.607 13.3739 22.6551 13.4528 22.6879Z"\n  />\n</svg>\n';
const __vite_glob_0_158 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.206 29.3002H7.09399C6.28431 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28431 1.9906 7.09399 2.00022H20.368C20.5396 2.00028 20.7043 2.06822 20.826 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.09399 3.30022C6.62907 3.29055 6.17925 3.46548 5.84302 3.78672C5.50678 4.10796 5.31153 4.54934 5.29999 5.01422V26.2862C5.31153 26.7511 5.50678 27.1925 5.84302 27.5137C6.17925 27.8349 6.62907 28.0099 7.09399 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.29922L7.09399 3.30022Z"\n  />\n  <path\n    d="M26.65 10.3001H22.642C21.7044 10.3263 20.7947 9.97976 20.112 9.33649C19.4294 8.69323 19.0295 7.80564 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z"\n  />\n  <path\n    d="M19.98 23.7752H11.32C10.8695 23.8246 10.4178 23.6935 10.0639 23.4104C9.70999 23.1273 9.48277 22.7155 9.43201 22.2652V20.2732H10.732V22.2652C10.8083 22.3414 10.9004 22.3999 11.0019 22.4363C11.1034 22.4728 11.2117 22.4864 11.319 22.4762H19.979C20.0877 22.4877 20.1976 22.4737 20.2999 22.4351C20.4021 22.3966 20.494 22.3346 20.568 22.2542V20.2732H21.868V22.2652C21.8172 22.7155 21.59 23.1273 21.2361 23.4104C20.8822 23.6935 20.4305 23.8246 19.98 23.7752Z"\n  />\n  <path\n    d="M14.997 21.0774L16.298 21.0774L16.298 13.0524L14.997 13.0524L14.997 21.0774Z"\n  />\n  <path\n    d="M15.648 12.1743C15.8357 12.1736 16.0216 12.2102 16.1949 12.282C16.3683 12.3537 16.5257 12.4592 16.658 12.5923L19.458 15.3923L18.539 16.3113L15.739 13.5113C15.739 13.5113 15.627 13.5113 15.58 13.5113L15.559 13.5113L12.759 16.3113L11.84 15.3923L14.64 12.5923C14.7721 12.4594 14.9292 12.3541 15.1022 12.2824C15.2752 12.2106 15.4607 12.1739 15.648 12.1743Z"\n  />\n</svg>\n';
const __vite_glob_0_159 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    d="M27.3 8.88022V9.00015H22.642C22.0492 9.02598 21.4703 8.81631 21.0315 8.41689C20.5928 8.01748 20.3298 7.46073 20.3 6.86815V2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022ZM7.094 2.00022H19V6.86815C19.0298 7.80555 19.4297 8.69298 20.1123 9.33619C20.7949 9.97941 21.7045 10.326 22.642 10.3001H27.3V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022ZM11.32 23.7752H19.98C20.4305 23.8246 20.8822 23.6935 21.2361 23.4104C21.59 23.1273 21.8172 22.7155 21.868 22.2652V20.2732H20.568V22.2542C20.494 22.3346 20.4021 22.3966 20.2999 22.4351C20.1976 22.4737 20.0877 22.4877 19.979 22.4762H11.319C11.2117 22.4864 11.1034 22.4728 11.0019 22.4363C10.9004 22.3999 10.8083 22.3414 10.732 22.2652V20.2732H9.43201V22.2652C9.48277 22.7155 9.70999 23.1273 10.0639 23.4104C10.4178 23.6935 10.8695 23.8246 11.32 23.7752ZM14.997 21.0774H16.298L16.298 14.0703L18.539 16.3113L19.458 15.3923L16.658 12.5923C16.5257 12.4592 16.3683 12.3537 16.1949 12.282C16.0216 12.2102 15.8357 12.1736 15.648 12.1743C15.4607 12.1739 15.2752 12.2106 15.1022 12.2824C14.9292 12.3541 14.7721 12.4594 14.64 12.5923L11.84 15.3923L12.759 16.3113L14.997 14.0733V21.0774Z"\n  />\n</svg>\n';
const __vite_glob_0_160 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M25.6001 17.7L18.642 24.647L18.653 4.74696H17.353L17.341 25.947L17.1821 26.106C17.0261 26.2627 16.8407 26.387 16.6364 26.4716C16.4321 26.5562 16.2131 26.5995 15.9921 26.599C15.7706 26.5995 15.5513 26.556 15.3469 26.471C15.1424 26.386 14.9569 26.2613 14.801 26.104L14.6431 25.946L14.655 4.74597H13.355L13.344 24.646L6.39604 17.687L5.47705 18.606L13.877 27.024C14.4375 27.5827 15.1966 27.8965 15.9881 27.8965C16.7795 27.8965 17.5386 27.5827 18.099 27.024L26.517 18.624L25.6001 17.7Z"\n  />\n</svg>\n';
const __vite_glob_0_161 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M6.05096 14.644L27.251 14.656V13.356L7.35098 13.345L14.311 6.39703L13.393 5.47803L4.97498 13.878C4.69759 14.1552 4.47753 14.4842 4.32739 14.8465C4.17726 15.2087 4.09998 15.5969 4.09998 15.989C4.09998 16.3811 4.17726 16.7694 4.32739 17.1316C4.47753 17.4938 4.69759 17.8229 4.97498 18.1L13.375 26.518L14.295 25.599L7.34796 18.641L27.248 18.652V17.352L6.04797 17.34L5.88898 17.181C5.73238 17.0246 5.60813 16.8389 5.52338 16.6344C5.43862 16.43 5.39502 16.2109 5.39502 15.9895C5.39502 15.7682 5.43862 15.5491 5.52338 15.3446C5.60813 15.1402 5.73238 14.9544 5.88898 14.798L6.05096 14.644Z"\n  />\n</svg>\n';
const __vite_glob_0_162 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.028 13.9L18.628 5.48199L17.708 6.401L24.655 13.359L4.755 13.348V14.648L25.955 14.66L26.114 14.819C26.2706 14.9754 26.3948 15.1611 26.4796 15.3656C26.5643 15.57 26.608 15.7892 26.608 16.0105C26.608 16.2318 26.5643 16.451 26.4796 16.6554C26.3948 16.8599 26.2706 17.0456 26.114 17.202L25.956 17.36L4.75601 17.348V18.648L24.656 18.659L17.697 25.607L18.615 26.526L27.033 18.126C27.3104 17.8489 27.5304 17.5198 27.6806 17.1576C27.8307 16.7954 27.908 16.4071 27.908 16.015C27.908 15.6229 27.8307 15.2346 27.6806 14.8724C27.5304 14.5102 27.3104 14.1811 27.033 13.904L27.028 13.9Z"\n  />\n</svg>\n';
const __vite_glob_0_163 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M26.522 13.393L18.122 4.97499C17.5616 4.41624 16.8024 4.10248 16.011 4.10248C15.2196 4.10248 14.4605 4.41624 13.9 4.97499L5.48303 13.375L6.40002 14.295L13.359 7.34799L13.348 27.248H14.648L14.659 6.04799L14.817 5.88998C15.1333 5.57415 15.562 5.39676 16.009 5.39676C16.456 5.39676 16.8847 5.57415 17.201 5.88998L17.358 6.04698L17.347 27.247H18.647L18.657 7.34698L25.605 14.305L26.522 13.393Z"\n  />\n</svg>\n';
const __vite_glob_0_164 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.462 20.428V23.728C24.462 24.095 23.862 24.506 23.062 24.506H8.7C7.9 24.506 7.3 24.095 7.3 23.728V20.428H6V23.728C6 24.893 7.186 25.806 8.7 25.806H23.06C24.575 25.806 25.76 24.893 25.76 23.728V20.428H24.462Z"\n  />\n  <path\n    d="M15.88 21.334C16.1348 21.3343 16.3872 21.2843 16.6226 21.1868C16.8581 21.0894 17.072 20.9464 17.252 20.766L21.9 16.118L20.981 15.199L16.53 19.65V7H15.23V19.65L10.78 15.199L9.86099 16.118L14.509 20.766C14.6889 20.9462 14.9026 21.0892 15.1379 21.1867C15.3731 21.2841 15.6253 21.3342 15.88 21.334Z"\n  />\n</svg>\n';
const __vite_glob_0_165 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M22.1538 8.6923C22.1538 9.90308 21.1722 10.8846 19.9615 10.8846C18.7507 10.8846 17.7692 9.90308 17.7692 8.6923C17.7692 7.48153 18.7507 6.5 19.9615 6.5C21.1722 6.5 22.1538 7.48153 22.1538 8.6923Z"\n    fill="#34323A"\n  />\n  <path\n    d="M13.3846 8.6923C13.3846 9.90308 12.4031 10.8846 11.1923 10.8846C9.98153 10.8846 9 9.90308 9 8.6923C9 7.48153 9.98153 6.5 11.1923 6.5C12.4031 6.5 13.3846 7.48153 13.3846 8.6923Z"\n    fill="#34323A"\n  />\n  <path\n    d="M22.1538 16C22.1538 17.2108 21.1722 18.1923 19.9615 18.1923C18.7507 18.1923 17.7692 17.2108 17.7692 16C17.7692 14.7892 18.7507 13.8077 19.9615 13.8077C21.1722 13.8077 22.1538 14.7892 22.1538 16Z"\n    fill="#34323A"\n  />\n  <path\n    d="M13.3846 16C13.3846 17.2108 12.4031 18.1923 11.1923 18.1923C9.98153 18.1923 9 17.2108 9 16C9 14.7892 9.98153 13.8077 11.1923 13.8077C12.4031 13.8077 13.3846 14.7892 13.3846 16Z"\n    fill="#34323A"\n  />\n  <path\n    d="M22.1538 23.3077C22.1538 24.5184 21.1722 25.5 19.9615 25.5C18.7507 25.5 17.7692 24.5184 17.7692 23.3077C17.7692 22.0969 18.7507 21.1154 19.9615 21.1154C21.1722 21.1154 22.1538 22.0969 22.1538 23.3077Z"\n    fill="#34323A"\n  />\n  <path\n    d="M13.3846 23.3077C13.3846 24.5184 12.4031 25.5 11.1923 25.5C9.98153 25.5 9 24.5184 9 23.3077C9 22.0969 9.98153 21.1154 11.1923 21.1154C12.4031 21.1154 13.3846 22.0969 13.3846 23.3077Z"\n    fill="#34323A"\n  />\n</svg>\n';
const __vite_glob_0_166 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M7.5 14.267C6.81903 14.267 6.267 14.819 6.267 15.5V25.5C6.267 26.181 6.81903 26.733 7.5 26.733H17.5C18.181 26.733 18.733 26.181 18.733 25.5V21H20V25.5C20 26.8807 18.8807 28 17.5 28H7.5C6.11929 28 5 26.8807 5 25.5V15.5C5 14.1193 6.11929 13 7.5 13H11V14.267H7.5Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M24.5 6.267H14.5C13.819 6.267 13.267 6.81903 13.267 7.5V17.5C13.267 18.181 13.819 18.733 14.5 18.733H24.5C25.181 18.733 25.733 18.181 25.733 17.5V7.5C25.733 6.81903 25.181 6.267 24.5 6.267ZM14.5 5C13.1193 5 12 6.11929 12 7.5V17.5C12 18.8807 13.1193 20 14.5 20H24.5C25.8807 20 27 18.8807 27 17.5V7.5C27 6.11929 25.8807 5 24.5 5H14.5Z"\n  />\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M19 17L19 8H20.27V17H19Z" />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M15 12L24 12V13.27L15 13.27V12Z"\n  />\n</svg>\n';
const __vite_glob_0_167 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M7.5 14.267C6.81903 14.267 6.267 14.819 6.267 15.5V25.5C6.267 26.181 6.81903 26.733 7.5 26.733H17.5C18.181 26.733 18.733 26.181 18.733 25.5V21H20V25.5C20 26.8807 18.8807 28 17.5 28H7.5C6.11929 28 5 26.8807 5 25.5V15.5C5 14.1193 6.11929 13 7.5 13H11V14.267H7.5Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M12 7.5C12 6.11929 13.1193 5 14.5 5H24.5C25.8807 5 27 6.11929 27 7.5V17.5C27 18.8807 25.8807 20 24.5 20H14.5C13.1193 20 12 18.8807 12 17.5V7.5ZM19 17V13.27L15 13.27V12L19 12V8H20.27V12L24 12V13.27H20.27V17H19Z"\n  />\n</svg>\n';
const __vite_glob_0_168 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M25.4 7.9H6.59995C5.89729 7.90053 5.22356 8.17989 4.7267 8.67675C4.22985 9.17361 3.95048 9.84734 3.94995 10.55V21.458C3.95048 22.1607 4.22985 22.8344 4.7267 23.3312C5.22356 23.8281 5.89729 24.1075 6.59995 24.108H25.4C26.1026 24.1075 26.7763 23.8281 27.2732 23.3312C27.7701 22.8344 28.0494 22.1607 28.05 21.458V10.546C28.0484 9.84403 27.7685 9.17133 27.2718 8.67534C26.775 8.17935 26.1019 7.90053 25.4 7.9ZM26.75 21.458C26.7441 21.6989 26.6718 21.9336 26.541 22.136L19.108 16.054L26.5849 9.937C26.6885 10.1236 26.7451 10.3326 26.75 10.546V21.458ZM5.24995 21.458V10.546C5.25414 10.3313 5.31079 10.1208 5.41495 9.933L12.8919 16.051L5.45895 22.133C5.32831 21.9301 5.256 21.6952 5.24995 21.454V21.458ZM13.9179 16.894L15.5879 18.261C15.7042 18.356 15.8498 18.408 16 18.408C16.1501 18.408 16.2957 18.356 16.412 18.261L18.082 16.894L25.3089 22.808H6.69095L13.9179 16.894ZM25.4 9.2C25.41 9.2 25.417 9.2 25.426 9.2L16 16.914L6.57395 9.2C6.58295 9.2 6.58995 9.2 6.59995 9.2H25.4Z"\n  />\n</svg>\n';
const __vite_glob_0_169 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M18.4492 22.0625C18.2892 22.0625 18.1284 22.0017 18.0067 21.8792L10.1209 13.9792C9.87754 13.735 9.87754 13.3392 10.1217 13.0958C10.3659 12.8525 10.7625 12.8525 11.0067 13.0967L18.8925 20.9958C19.1359 21.24 19.1359 21.6358 18.8917 21.88C18.7692 22.0017 18.6092 22.0625 18.4492 22.0625Z"\n  />\n  <path\n    d="M13.895 25.9998C13.3517 25.9998 12.8067 25.7923 12.3925 25.3781L6.62083 19.6065C6.22083 19.2065 6 18.6723 6 18.104C6 17.5356 6.22083 17.0015 6.62083 16.6015L16.6025 6.61981C17.43 5.79148 18.7783 5.79065 19.6075 6.61981L25.3792 12.3915C25.7792 12.7915 26 13.3256 26 13.894C26 14.4623 25.7792 14.9965 25.3792 15.3965L15.3975 25.3781C14.9833 25.7923 14.4392 25.9998 13.895 25.9998ZM13.2758 24.494C13.6167 24.8356 14.1708 24.8365 14.5133 24.494L24.495 14.5123C24.8358 14.1706 24.8358 13.6156 24.495 13.2748L18.7233 7.50315C18.3817 7.16148 17.8275 7.16315 17.4858 7.50315L7.505 17.4848C7.16417 17.8265 7.16417 18.3815 7.505 18.7223L13.2758 24.494Z"\n  />\n</svg>\n';
const __vite_glob_0_170 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M19.579 24.379C17.8129 24.3761 16.0928 23.816 14.6637 22.7783C13.2346 21.7406 12.1695 20.2784 11.62 18.6H18.836V17.3H11.312C11.1337 16.2519 11.1677 15.1787 11.412 14.144H19.948V12.844H11.82C12.4477 11.3007 13.5209 9.97937 14.9026 9.04843C16.2843 8.1175 17.9119 7.61917 19.578 7.617C20.8093 7.61607 22.0254 7.88935 23.138 8.417L23.692 7.241C22.4064 6.63055 21.0011 6.31389 19.578 6.314C17.565 6.31758 15.6031 6.948 13.9648 8.11769C12.3264 9.28737 11.0931 10.9383 10.436 12.841H6.58301V14.141H10.083C9.87132 15.1811 9.84322 16.2502 10 17.3H6.586V18.6H10.267C10.8368 20.633 12.0549 22.4242 13.7361 23.7013C15.4174 24.9784 17.4697 25.6714 19.581 25.675C21.0041 25.6751 22.4095 25.3585 23.695 24.748L23.141 23.572C22.0284 24.1024 20.8116 24.378 19.579 24.379Z"\n  />\n</svg>\n';
const __vite_glob_0_171 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M15.2812 14.9535L14.349 16.5521L15.2754 18.1408H17.1397L18.0718 16.5423L17.1454 14.9535H15.2812ZM17.9085 13.6351L14.5123 13.6351L12.8143 16.5472L14.5123 19.4593H17.9085L19.6066 16.5472L17.9085 13.6351Z"\n  />\n  <path\n    d="M27.4564 15.6958C27.2545 15.4224 22.4439 9 16.2999 9C10.1559 9 5.34509 15.4224 5.14341 15.6956C4.9522 15.955 4.9522 16.3069 5.14341 16.5663C5.34509 16.8398 10.1559 23.2621 16.2999 23.2621C22.4439 23.2621 27.2545 16.8397 27.4564 16.5665C27.6479 16.3071 27.6479 15.955 27.4564 15.6958ZM16.2999 21.7867C11.7742 21.7867 7.85445 17.5241 6.69412 16.1306C7.85295 14.7358 11.7645 10.4754 16.2999 10.4754C20.8254 10.4754 24.7449 14.7373 25.9057 16.1316C24.7469 17.5263 20.8353 21.7867 16.2999 21.7867Z"\n  />\n</svg>\n';
const __vite_glob_0_172 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M15.2812 14.9536L14.349 16.5521L15.2754 18.1409H17.1397L18.0718 16.5423L17.1454 14.9536H15.2812ZM17.9085 13.6351L14.5123 13.6351L12.8143 16.5472L14.5123 19.4593H17.9085L19.6066 16.5472L17.9085 13.6351Z"\n  />\n  <path\n    d="M27.4564 15.6959C27.2545 15.4224 22.4439 9.00002 16.2999 9.00002C10.1559 9.00002 5.34509 15.4224 5.14341 15.6956C4.9522 15.955 4.9522 16.3069 5.14341 16.5663C5.34509 16.8398 10.1559 23.2622 16.2999 23.2622C22.4439 23.2622 27.2545 16.8397 27.4564 16.5665C27.6479 16.3072 27.6479 15.955 27.4564 15.6959ZM16.2999 21.7868C11.7742 21.7868 7.85445 17.5241 6.69412 16.1306C7.85295 14.7358 11.7645 10.4754 16.2999 10.4754C20.8254 10.4754 24.7449 14.7373 25.9057 16.1316C24.7469 17.5263 20.8353 21.7868 16.2999 21.7868Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M24.8969 7.53035C25.1898 7.82325 25.1737 8.31423 24.861 8.62699L8.62696 24.861C8.3142 25.1737 7.82322 25.1899 7.53033 24.897C7.23744 24.6041 7.25354 24.1131 7.5663 23.8003L23.8003 7.56633C24.1131 7.25357 24.604 7.23746 24.8969 7.53035Z"\n  />\n</svg>\n';
const __vite_glob_0_173 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  strokeLinejoin="round"\n  strokeMiterlimit="1.41421"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M13.674 27.61a.66.66 0 0 1-.67-.61v-9.4L6.584 6.67a1.622 1.622 0 0 1 0-1.5 1.42 1.42 0 0 1 1.25-.78h16.35a1.4 1.4 0 0 1 1.24.78 1.6 1.6 0 0 1 0 1.46l-6.42 10.93v7.52a.652.652 0 0 1-.41.61l-4.66 1.87a.703.703 0 0 1-.26.05zM7.824 5.69s-.07 0-.1.09a.319.319 0 0 0 0 .27l6.5 11c.06.1.091.214.09.33V26l3.37-1.35v-7.27a.63.63 0 0 1 .09-.33L24.304 6a.28.28 0 0 0 0-.23c0-.06-.07-.09-.09-.09l-16.39.01z"\n  />\n</svg>\n';
const __vite_glob_0_174 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  strokeLinejoin="round"\n  strokeMiterlimit="1.41421"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M13.674 27.61a.66.66 0 0 1-.67-.61v-9.4L6.584 6.67a1.622 1.622 0 0 1 0-1.5 1.42 1.42 0 0 1 1.25-.78h16.35a1.4 1.4 0 0 1 1.24.78 1.6 1.6 0 0 1 0 1.46l-6.42 10.93v7.52a.652.652 0 0 1-.41.61l-4.66 1.87a.703.703 0 0 1-.26.05zM7.824 5.69s-.07 0-.1.09a.319.319 0 0 0 0 .27l6.5 11c.06.1.091.214.09.33V26l3.37-1.35v-7.27a.63.63 0 0 1 .09-.33L24.304 6a.28.28 0 0 0 0-.23c0-.06-.07-.09-.09-.09l-16.39.01z"\n  />\n  <path\n    d="M13.716 27.4a.649.649 0 0 1-.658-.599v-9.23L6.754 6.839a1.59 1.59 0 0 1 0-1.473c.235-.464.708-.76 1.228-.766h16.054c.518.006.988.302 1.217.766.231.45.231.983 0 1.433L18.95 17.532v7.384a.64.64 0 0 1-.403.599l-4.576 1.836a.696.696 0 0 1-.255.049z"\n  />\n</svg>\n';
const __vite_glob_0_175 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M9.97897 27.945H8.67896V4.24501C8.67913 4.08928 8.73515 3.93878 8.83679 3.82081C8.93844 3.70284 9.07899 3.6252 9.23297 3.602C11.1604 3.14774 13.1883 3.44113 14.908 4.423C15.7002 4.90285 16.4193 5.49425 17.043 6.179C17.6151 6.81398 18.2739 7.36508 19 7.816C19.951 8.3311 21.0044 8.62869 22.0844 8.68731C23.1643 8.74593 24.2438 8.56412 25.245 8.155C25.3428 8.12197 25.447 8.11271 25.5491 8.12798C25.6512 8.14325 25.7482 8.18261 25.8321 8.24282C25.9159 8.30302 25.9842 8.38233 26.0313 8.47418C26.0785 8.56603 26.103 8.66778 26.103 8.77101V20.848C26.1029 20.9808 26.0623 21.1104 25.9865 21.2194C25.9107 21.3284 25.8034 21.4117 25.679 21.458C23.079 22.422 20.802 22.351 18.915 21.247C18.2201 20.8184 17.5886 20.2947 17.039 19.691C16.3924 18.9755 15.6453 18.3577 14.821 17.857C13.3578 17.0127 11.6523 16.6871 9.98096 16.933L9.97897 27.945ZM11.091 15.559C12.6287 15.5551 14.1398 15.9596 15.47 16.731C16.3742 17.2755 17.1956 17.947 17.909 18.725C18.3945 19.2662 18.9529 19.7373 19.568 20.125C20.3685 20.5468 21.2514 20.7887 22.155 20.834C23.0587 20.8792 23.9613 20.7267 24.8 20.387V9.643C23.7314 9.9703 22.6073 10.0765 21.4963 9.95512C20.3853 9.83374 19.3107 9.48732 18.338 8.937C17.5165 8.43049 16.7705 7.81073 16.122 7.096C15.5778 6.49256 14.9493 5.97085 14.256 5.547C12.9612 4.80634 11.4494 4.53841 9.97897 4.789V15.624C10.3481 15.5814 10.7194 15.5597 11.091 15.559Z"\n  />\n  <path d="M7.19993 4.245H5.89893V27.945H7.19993V4.245Z" />\n</svg>\n';
const __vite_glob_0_176 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="nonzero"\n    d="M1.698 12.2L1.367 2.033c.001-.386.391-.715.924-.78 3.241-.54 6.648-.189 9.543.984 1.302.584 2.484 1.295 3.511 2.112.987.764 2.118 1.427 3.36 1.968 3.233 1.251 7.083 1.397 10.483.396.336-.075.702-.035.991.108.284.149.452.385.454.636v14.496c-.004.325-.283.615-.706.732-4.368 1.2-8.198 1.068-11.373-.252-1.188-.512-2.269-1.142-3.209-1.872-1.089-.856-2.345-1.596-3.73-2.196-2.169-.89-4.653-1.299-7.137-1.18v13.809h-2.78V12.2z"\n  />\n</svg>\n';
const __vite_glob_0_177 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M9.97897 27.945H8.67896V4.24501C8.67913 4.08928 8.73515 3.93878 8.83679 3.82081C8.93844 3.70284 9.07899 3.6252 9.23297 3.602C11.1604 3.14774 13.1883 3.44113 14.908 4.423C15.7002 4.90285 16.4193 5.49425 17.043 6.179C17.6151 6.81398 18.2739 7.36508 19 7.816C19.951 8.3311 21.0044 8.62869 22.0844 8.68731C23.1643 8.74593 24.2438 8.56412 25.245 8.155C25.3428 8.12197 25.447 8.11271 25.5491 8.12798C25.6512 8.14325 25.7482 8.18261 25.8321 8.24282C25.9159 8.30302 25.9842 8.38233 26.0313 8.47418C26.0785 8.56603 26.103 8.66778 26.103 8.77101V20.848C26.1029 20.9808 26.0623 21.1104 25.9865 21.2194C25.9107 21.3284 25.8034 21.4117 25.679 21.458C23.079 22.422 20.802 22.351 18.915 21.247C18.2201 20.8184 17.5886 20.2947 17.039 19.691C16.3924 18.9755 15.6453 18.3577 14.821 17.857C13.3578 17.0127 11.6523 16.6871 9.98096 16.933L9.97897 27.945Z"\n  />\n  <path d="M7.19993 4.245H5.89893V27.945H7.19993V4.245Z" />\n</svg>\n';
const __vite_glob_0_178 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M14 0C6.26802 0 0 6.26802 0 14C0 21.732 6.26802 28 14 28C21.732 28 28 21.732 28 14C27.9918 6.27147 21.7286 0.00826173 14 0ZM6.22407 4.84794C8.3955 3.0051 11.152 1.99553 14 2.00004C16.8363 1.99916 19.5803 3.00768 21.741 4.84507L4.84102 21.745C0.556935 16.6971 1.17615 9.13202 6.22407 4.84794ZM21.776 23.1521C19.6046 24.995 16.848 26.0045 14.0001 26C11.1638 26.0009 8.41976 24.9924 6.25905 23.155L23.1591 6.25495C27.4431 11.3029 26.8239 18.868 21.776 23.1521Z"\n  />\n</svg>\n';
const __vite_glob_0_179 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M13.7533 5.35804C14.0045 5.54343 14.05 5.82323 14.05 6C14.05 6.16704 14.0933 6.38568 14.1807 6.66251C14.2671 6.93617 14.3839 7.22894 14.5106 7.54574L14.5147 7.55602C14.6369 7.86132 14.7682 8.18973 14.8682 8.50626C14.9683 8.82318 15.05 9.16704 15.05 9.5C15.05 9.58447 15.1385 9.77527 15.5364 10.018C15.8926 10.2353 16.337 10.3923 16.6333 10.4664C16.8304 10.5157 16.9843 10.6696 17.0335 10.8666C17.1249 11.2319 17.2149 11.8029 17.1592 12.3101C17.1315 12.5612 17.0622 12.8568 16.8855 13.1024C16.6877 13.3774 16.3819 13.55 16 13.55C15.8049 13.55 15.6604 13.5501 15.5489 13.5531C15.5417 13.7407 15.4977 13.9647 15.428 14.1739C15.3529 14.3992 15.2248 14.678 15.0139 14.8889C14.7796 15.1231 14.4138 15.2906 13.9823 15.1468C13.6181 15.0254 13.3131 14.7113 13.0423 14.3051C12.9162 14.1159 12.8058 13.9426 12.7098 13.7919L12.704 13.7828C12.6049 13.6271 12.5247 13.5015 12.4534 13.3982C12.4529 13.3974 12.4524 13.3966 12.4518 13.3959C12.3381 13.5747 12.1915 13.8468 11.9919 14.246C11.5726 15.0846 11.6944 15.6426 11.9182 16.0454C12.113 16.396 12.3753 16.6353 12.6294 16.8671C12.718 16.9479 12.8055 17.0277 12.8889 17.1111C13.1567 17.3789 13.3279 17.5388 13.5167 17.6143C13.656 17.6701 13.8658 17.7021 14.254 17.5081C14.9771 17.1465 15.6738 17.3511 16.1541 17.557C16.3143 17.6256 16.4832 17.71 16.62 17.7782C16.6792 17.8078 16.7325 17.8344 16.7763 17.8554C16.9123 17.9204 16.9763 17.9408 16.9963 17.9471C17.005 17.9499 17.0054 17.95 17 17.95C17.061 17.95 17.1616 17.9362 17.3355 17.9123C17.3792 17.9063 17.4276 17.8997 17.4811 17.8924C17.7163 17.8607 18.0128 17.825 18.3125 17.825C18.6068 17.825 18.9503 17.8587 19.2624 17.9974C19.595 18.1452 19.8831 18.4103 20.0217 18.8261C20.2088 19.3873 20.3911 19.6985 20.5177 19.8574C20.5478 19.8952 20.573 19.9222 20.5925 19.9411C20.9943 19.9218 21.3736 20.0092 21.6516 20.2726C21.9709 20.5751 22.0285 20.9866 21.9824 21.3243C21.8947 21.9677 21.4061 22.6565 20.7575 22.9861C18.6043 24.1844 17.5632 25.4783 16.9919 26.621C16.7026 27.1996 16.5265 27.7539 16.391 28.2657C16.3465 28.4337 16.304 28.6084 16.262 28.7813C16.1838 29.1027 16.107 29.4182 16.0217 29.6739C15.9257 29.9621 15.6142 30.1178 15.326 30.0218C14.8686 29.8693 14.5363 29.536 14.2983 29.1703C14.0602 28.8042 13.8913 28.3683 13.7703 27.9357C13.5282 27.0705 13.45 26.1181 13.45 25.5C13.45 25.43 13.4633 25.3607 13.4893 25.2957C13.6441 24.9087 13.8259 24.3113 13.8776 23.7839C13.9035 23.5186 13.8925 23.3086 13.8534 23.1639C13.8164 23.027 13.7708 23.0003 13.754 22.9919C13.2285 22.7292 12.8298 22.2619 12.5526 21.8392C12.2703 21.4089 12.0753 20.9654 11.9782 20.6739C11.9595 20.6178 11.95 20.5591 11.95 20.5C11.95 20.1525 11.945 19.8719 11.8563 19.6206C11.7865 19.4228 11.6559 19.2215 11.3557 19.0468C11.1234 19.0357 10.9161 18.9949 10.7227 18.8982C10.5159 18.7948 10.3652 18.6435 10.2554 18.5333C10.2488 18.5267 10.2424 18.5202 10.236 18.5139L10.2258 18.5037C10.007 18.2847 9.67475 17.9523 8.75398 17.4919C7.93043 17.0802 7.3891 16.7242 7.04442 16.4321C6.87253 16.2865 6.73859 16.1476 6.64265 16.0157C6.56317 15.9064 6.44995 15.7223 6.44995 15.5C6.44995 15.4638 6.45353 15.4277 6.46063 15.3921C6.53605 15.015 6.59644 14.4134 6.55147 13.877C6.52896 13.6085 6.4822 13.3844 6.41546 13.2213C6.34786 13.0561 6.28248 13.0062 6.25398 12.9919C6.087 12.9084 5.94121 12.8426 5.79396 12.7762C5.72942 12.7471 5.6646 12.7178 5.5976 12.6869C5.38564 12.5891 5.16784 12.4813 4.94487 12.3326C4.48855 12.0284 4.06583 11.5903 3.54232 10.8051C3.42981 10.6363 3.41932 10.4193 3.51503 10.2405C3.59067 10.0991 3.72294 9.99978 3.87521 9.96432C3.90018 9.91548 3.9339 9.8339 3.97818 9.70108C4.00184 9.63009 4.02738 9.54724 4.05569 9.45542C4.1572 9.12616 4.29431 8.68146 4.50802 8.25404C4.57325 8.12357 4.68764 8.02436 4.82603 7.97823C5.47728 7.76114 6.64818 7.54701 7.80367 7.36892C8.88137 7.20282 9.98973 7.06177 10.749 6.97484C11.1686 6.56501 11.7433 6.04559 12.2435 5.68947C12.504 5.50398 12.818 5.30775 13.106 5.24306C13.2485 5.21104 13.5146 5.18194 13.7533 5.35804ZM12.8815 6.58554C12.3973 6.93024 11.7974 7.48038 11.3889 7.88891C11.3006 7.97722 11.1848 8.03285 11.0607 8.04664C10.3168 8.12929 9.12463 8.27832 7.97123 8.45609C6.94282 8.61459 5.98432 8.79032 5.39488 8.95479C5.28161 9.2175 5.2029 9.47187 5.12501 9.72354C5.09133 9.83235 5.05782 9.94066 5.02173 10.0489C4.96147 10.2297 4.88227 10.4453 4.76113 10.6238C5.08133 11.0456 5.3282 11.2662 5.55504 11.4174C5.70707 11.5187 5.86427 11.5985 6.05856 11.6881C6.11044 11.7121 6.16657 11.7374 6.22617 11.7643C6.38065 11.8341 6.55843 11.9143 6.74592 12.0081C7.10021 12.1852 7.30956 12.5018 7.43353 12.8048C7.55836 13.1098 7.62 13.4556 7.64762 13.7851C7.69578 14.3595 7.64709 14.9698 7.57345 15.4192C7.61109 15.4616 7.66922 15.5198 7.75548 15.5929C8.0108 15.8092 8.46948 16.1198 9.24592 16.5081C10.3107 17.0404 10.7326 17.4548 11.0139 17.7361C11.1526 17.8749 11.1839 17.8989 11.2147 17.9143C11.2321 17.9231 11.2919 17.95 11.5 17.95C11.5853 17.95 11.6695 17.9699 11.7459 18.0081C12.3724 18.3213 12.7208 18.7649 12.8936 19.2545C13.0397 19.6684 13.0494 20.0925 13.0499 20.406C13.1289 20.6187 13.273 20.9319 13.4723 21.2358C13.7034 21.5881 13.9714 21.8708 14.2459 22.0081C14.6292 22.1997 14.8252 22.5439 14.9152 22.8767C15.0032 23.2019 15.0047 23.5606 14.9723 23.8911C14.9121 24.5063 14.7205 25.1544 14.5507 25.6013C14.559 26.1493 14.6341 26.9405 14.8296 27.6393C14.9271 27.9878 15.0486 28.2913 15.1917 28.525C15.2311 28.3623 15.2748 28.1838 15.3276 27.9843C15.4734 27.4337 15.6723 26.8004 16.008 26.129C16.6859 24.7734 17.8926 23.3194 20.2328 22.0192C20.2398 22.0153 20.2469 22.0116 20.254 22.0081C20.5996 21.8352 20.8558 21.4451 20.8925 21.1757C20.9009 21.1143 20.8956 21.0828 20.8914 21.0695C20.8689 21.0574 20.7816 21.0221 20.5607 21.0466C20.5405 21.0489 20.5202 21.05 20.5 21.05C20.3086 21.05 20.1436 20.9713 20.0246 20.892C19.8961 20.8064 19.7733 20.6884 19.6572 20.5426C19.4254 20.2516 19.1911 19.8127 18.9782 19.1739C18.9501 19.0897 18.9049 19.0423 18.8156 19.0026C18.7059 18.9538 18.539 18.925 18.3125 18.925C18.0913 18.925 17.8565 18.9518 17.6281 18.9826C17.5952 18.987 17.5606 18.9919 17.5249 18.9968C17.3473 19.0217 17.1446 19.05 17 19.05C16.7318 19.05 16.4667 18.9266 16.3017 18.8477C16.2239 18.8105 16.1535 18.7752 16.0853 18.7411C15.9657 18.6812 15.8533 18.6248 15.7208 18.568C15.3261 18.3989 15.0228 18.3535 14.7459 18.4919C14.1341 18.7979 13.5939 18.8299 13.1082 18.6357C12.6891 18.468 12.3692 18.1475 12.1388 17.9167C12.1294 17.9073 12.1201 17.898 12.111 17.8889C12.0778 17.8557 12.0292 17.8118 11.9698 17.7582C11.7121 17.5257 11.2511 17.1096 10.9567 16.5796C10.5555 15.8574 10.4273 14.9154 11.008 13.754C11.2556 13.259 11.4627 12.8731 11.6517 12.6179C11.7459 12.4909 11.8641 12.3559 12.0146 12.2607C12.1841 12.1536 12.3996 12.0955 12.6333 12.1539C12.8382 12.2051 12.9867 12.3296 13.0831 12.4274C13.1837 12.5295 13.2756 12.6528 13.359 12.7737C13.444 12.8969 13.5357 13.0409 13.6318 13.1918L13.636 13.1985C13.7328 13.3505 13.838 13.5155 13.9576 13.6949C14.0663 13.858 14.1566 13.9624 14.2258 14.0267C14.2434 14.043 14.2588 14.056 14.272 14.0663C14.3069 14.0154 14.3482 13.9348 14.3844 13.8261C14.433 13.6805 14.45 13.5526 14.45 13.5C14.45 13.4922 14.4499 13.484 14.4499 13.4755C14.4497 13.3752 14.4493 13.2238 14.4787 13.0916C14.4975 13.0068 14.5332 12.9023 14.6063 12.8007C14.6821 12.6954 14.7782 12.621 14.879 12.5706C15.0524 12.4838 15.2486 12.4666 15.3913 12.4587C15.5473 12.45 15.7476 12.45 15.9838 12.45H15.999C16.0184 12.4167 16.0495 12.3376 16.0658 12.1899C16.0908 11.9624 16.0692 11.685 16.0283 11.4357C15.6996 11.3287 15.3108 11.1688 14.9635 10.957C14.5281 10.6914 13.95 10.2155 13.95 9.5C13.95 9.33296 13.9066 9.11432 13.8192 8.8375C13.7328 8.56383 13.616 8.27106 13.4893 7.95427L13.4852 7.94399C13.3631 7.63869 13.2317 7.31028 13.1317 6.99375C13.0816 6.83496 13.0361 6.6694 13.0031 6.50184C12.9655 6.52675 12.925 6.55457 12.8815 6.58554ZM13.347 6.31632C13.3524 6.31549 13.3522 6.31517 13.347 6.31632V6.31632ZM7.51581 15.343C7.51612 15.3431 7.51828 15.3464 7.52137 15.3529C7.51705 15.3462 7.51551 15.343 7.51581 15.343Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M20.611 3.61109C20.7583 3.46378 20.9762 3.41234 21.1738 3.47822L22.6738 3.97822C22.7299 3.99692 22.7826 4.02453 22.8299 4.06L24.8299 5.56C24.8507 5.57561 24.8704 5.59269 24.8888 5.61109L25.8888 6.61109C26.1036 6.82588 26.1036 7.17412 25.8888 7.38891C25.3015 7.97618 24.8194 8.15017 24.3403 8.23001C24.2322 8.24803 24.1361 8.26088 24.0468 8.27282C23.8407 8.30038 23.6712 8.32304 23.4752 8.39311C23.3779 8.77946 23.2487 9.09557 23.0649 9.31453C22.9417 9.46132 22.7714 9.59085 22.5496 9.63707C22.3265 9.68354 22.1261 9.63024 21.9732 9.55152C21.6962 9.40893 21.4915 9.14191 21.3554 8.92929C21.2069 8.69731 21.0816 8.43529 20.9892 8.20426C20.9852 8.19426 20.9815 8.18414 20.9781 8.17392C20.8715 7.85417 20.7708 7.7732 20.7515 7.76089C20.7468 7.75788 20.7461 7.75788 20.7449 7.75788C20.7452 7.7579 20.7447 7.75788 20.7449 7.75788C20.7391 7.75751 20.7165 7.75753 20.6738 7.77177C20.5799 7.80308 20.4535 7.87928 20.3013 8.0038C20.1538 8.12449 20.016 8.26173 19.8888 8.3889C19.8284 8.44928 19.7548 8.49477 19.6738 8.52177C19.4415 8.59922 19.1543 8.65072 18.8802 8.54859C18.5578 8.42851 18.4017 8.15733 18.3512 7.90474C18.3056 7.6765 18.3355 7.4357 18.3839 7.22593C18.4345 7.00672 18.5174 6.7714 18.6194 6.53334C19.022 5.59385 19.8117 4.41042 20.611 3.61109ZM21.1579 4.63241C20.5364 5.32097 19.9396 6.24524 19.6304 6.96665C19.593 7.05398 19.5609 7.13583 19.534 7.21171C19.5572 7.19182 19.5808 7.17202 19.6047 7.15245C19.7963 6.99572 20.0449 6.82191 20.326 6.72822C20.6226 6.62936 20.9927 6.61055 21.3421 6.83286C21.6623 7.03665 21.8728 7.38672 22.0161 7.80958C22.0896 7.99109 22.1829 8.18162 22.2819 8.33633C22.2965 8.35921 22.3109 8.38062 22.3248 8.40054C22.3694 8.28015 22.4161 8.11448 22.4606 7.89213C22.4939 7.7257 22.6021 7.58396 22.7539 7.50806C23.2402 7.26495 23.6669 7.21025 23.9711 7.17128C24.0405 7.16238 24.1036 7.1543 24.1595 7.14498C24.3239 7.11758 24.4872 7.07881 24.6824 6.96032L24.1386 6.41654L22.2413 4.99355L21.1579 4.63241Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M26.9986 12.5284C27.5894 12.5946 28.2665 12.8143 28.7042 12.9893L28.809 13.0313L29.5499 13.7722V17.5C29.5499 17.765 29.5254 18.1833 29.4244 18.5031C29.3977 18.5875 29.3601 18.684 29.3045 18.7758C29.2512 18.864 29.1599 18.9836 29.0109 19.0652C28.843 19.1572 28.6518 19.173 28.4736 19.1178C28.3154 19.0688 28.1955 18.9734 28.111 18.8889C27.9656 18.7435 27.8187 18.657 27.7 18.6073C27.6878 18.6022 27.676 18.5975 27.6647 18.5933C27.4823 18.7459 27.2534 18.9077 27.0091 19.0226C26.6882 19.1736 26.0777 19.3556 25.611 18.8889C25.6046 18.8825 25.598 18.876 25.5913 18.8693C25.3497 18.6279 24.9116 18.1902 24.6819 17.6542C24.5585 17.3663 24.4831 17.025 24.5428 16.6546C24.6033 16.28 24.7934 15.9287 25.111 15.6111C25.5312 15.1909 25.5749 14.9491 25.5749 14.75C25.5749 14.6198 25.5542 14.4857 25.523 14.2828C25.5216 14.2738 25.5202 14.2647 25.5188 14.2555C25.4871 14.0493 25.4499 13.7951 25.4499 13.5C25.4499 13.2999 25.504 13.0994 25.6326 12.9274C25.758 12.7596 25.9239 12.6593 26.08 12.6007C26.3735 12.4906 26.7137 12.4965 26.9986 12.5284ZM26.5524 13.6134C26.5596 13.7744 26.581 13.9257 26.606 14.0882C26.6085 14.1042 26.611 14.1205 26.6136 14.1372C26.6414 14.3161 26.6749 14.5313 26.6749 14.75C26.6749 15.3009 26.4686 15.8091 25.8888 16.3889C25.7064 16.5713 25.6465 16.72 25.6288 16.8298C25.6104 16.9437 25.6288 17.0712 25.6929 17.2208C25.8275 17.5348 26.1074 17.8289 26.364 18.0863C26.3964 18.0823 26.4549 18.0677 26.5407 18.0273C26.7476 17.93 26.9715 17.7505 27.111 17.6111L27.2721 17.45H27.4999C27.7234 17.45 28.076 17.5304 28.4407 17.7554C28.4468 17.6695 28.4499 17.5819 28.4499 17.5V14.2278L28.1926 13.9705C27.8048 13.8231 27.2892 13.6678 26.8762 13.6216C26.7277 13.605 26.6218 13.6061 26.5524 13.6134Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M16 28.5C22.9036 28.5 28.5 22.9036 28.5 16C28.5 9.09644 22.9036 3.5 16 3.5C9.09644 3.5 3.5 9.09644 3.5 16C3.5 22.9036 9.09644 28.5 16 28.5ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"\n  />\n</svg>\n';
const __vite_glob_0_180 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M28.6101 25.831H23.4331C23.1282 25.8307 22.8358 25.7095 22.6202 25.4939C22.4046 25.2783 22.2833 24.9859 22.2831 24.681V9.051C22.2833 8.74608 22.4046 8.45373 22.6202 8.23812C22.8358 8.02251 23.1282 7.90127 23.4331 7.901H28.6101C28.915 7.90127 29.2074 8.02251 29.423 8.23812C29.6386 8.45373 29.7598 8.74608 29.7601 9.051V24.681C29.7598 24.9859 29.6386 25.2783 29.423 25.4939C29.2074 25.7095 28.915 25.8307 28.6101 25.831ZM23.5831 24.531H28.4601V9.2H23.5831V24.531Z"\n  />\n  <path\n    d="M18.583 25.831H13.4C13.0951 25.8307 12.8027 25.7095 12.5871 25.4939C12.3715 25.2783 12.2503 24.9859 12.25 24.681V3.881C12.2503 3.57609 12.3715 3.28373 12.5871 3.06812C12.8027 2.85251 13.0951 2.73127 13.4 2.731H18.578C18.8827 2.73153 19.1748 2.8529 19.3902 3.06848C19.6056 3.28406 19.7267 3.57626 19.727 3.881V24.681C19.7267 24.9849 19.6063 25.2763 19.392 25.4918C19.1777 25.7072 18.8869 25.8292 18.583 25.831ZM13.555 24.531H18.433V4.031H13.555V24.531Z"\n  />\n  <path\n    d="M8.55503 25.831H3.37703C3.07229 25.8305 2.78019 25.7091 2.5648 25.4935C2.3494 25.278 2.22829 24.9858 2.22803 24.681V14.464C2.22829 14.1593 2.3494 13.8671 2.5648 13.6515C2.78019 13.4359 3.07229 13.3145 3.37703 13.314H8.55503C8.85995 13.3143 9.1523 13.4355 9.36791 13.6511C9.58352 13.8667 9.70477 14.1591 9.70503 14.464V24.681C9.70477 24.9859 9.58352 25.2783 9.36791 25.4939C9.1523 25.7095 8.85995 25.8307 8.55503 25.831ZM3.52703 24.531H8.40003V14.614H3.52203L3.52703 24.531Z"\n  />\n  <path d="M29.845 27.972H2.15503V29.272H29.845V27.972Z" />\n</svg>\n';
const __vite_glob_0_181 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M28.6101 25.831H23.4331C23.1282 25.8307 22.8358 25.7095 22.6202 25.4939C22.4046 25.2783 22.2833 24.9859 22.2831 24.681V9.051C22.2833 8.74608 22.4046 8.45373 22.6202 8.23812C22.8358 8.02251 23.1282 7.90127 23.4331 7.901H28.6101C28.915 7.90127 29.2074 8.02251 29.423 8.23812C29.6386 8.45373 29.7598 8.74608 29.7601 9.051V24.681C29.7598 24.9859 29.6386 25.2783 29.423 25.4939C29.2074 25.7095 28.915 25.8307 28.6101 25.831Z"\n  />\n  <path\n    d="M18.583 25.831H13.4C13.0951 25.8307 12.8027 25.7095 12.5871 25.4939C12.3715 25.2783 12.2503 24.9859 12.25 24.681V3.881C12.2503 3.57609 12.3715 3.28373 12.5871 3.06812C12.8027 2.85251 13.0951 2.73127 13.4 2.731H18.578C18.8827 2.73153 19.1748 2.8529 19.3902 3.06848C19.6056 3.28406 19.7267 3.57626 19.727 3.881V24.681C19.7267 24.9849 19.6063 25.2763 19.392 25.4918C19.1777 25.7072 18.8869 25.8292 18.583 25.831Z"\n  />\n  <path\n    d="M8.55503 25.831H3.37703C3.07229 25.8305 2.78019 25.7091 2.5648 25.4935C2.3494 25.278 2.22829 24.9858 2.22803 24.681V14.464C2.22829 14.1593 2.3494 13.8671 2.5648 13.6515C2.78019 13.4359 3.07229 13.3145 3.37703 13.314H8.55503C8.85995 13.3143 9.1523 13.4355 9.36791 13.6511C9.58352 13.8667 9.70477 14.1591 9.70503 14.464V24.681C9.70477 24.9859 9.58352 25.2783 9.36791 25.4939C9.1523 25.7095 8.85995 25.8307 8.55503 25.831Z"\n  />\n  <path d="M29.845 27.972H2.15503V29.272H29.845V27.972Z" />\n</svg>\n';
const __vite_glob_0_182 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.7171 28.367H4.28307C4.19771 28.367 4.11318 28.3502 4.03432 28.3175C3.95546 28.2849 3.8838 28.237 3.82344 28.1766C3.76308 28.1163 3.71521 28.0446 3.68254 27.9657C3.64988 27.8869 3.63306 27.8024 3.63306 27.717V4.283H4.93306V27.067H27.7171V28.367Z"\n  />\n  <path\n    d="M8.09203 23.608L6.82703 23.308L9.42703 12.208C9.45775 12.0774 9.52811 11.9595 9.62846 11.8705C9.72882 11.7815 9.85427 11.7258 9.98758 11.7109C10.1209 11.696 10.2555 11.7227 10.3731 11.7873C10.4906 11.852 10.5852 11.9514 10.644 12.072L13.017 16.955L15.894 14.096C15.9657 14.0238 16.0534 13.9696 16.1501 13.938C16.2468 13.9063 16.3496 13.8981 16.45 13.914C16.5506 13.9292 16.6463 13.968 16.7291 14.027C16.812 14.0861 16.8798 14.1638 16.927 14.254L19.379 18.913L21.808 11.455C21.8442 11.3441 21.9095 11.245 21.997 11.168L26.311 7.368L27.17 8.344L22.989 12.026L20.139 20.778C20.0993 20.8994 20.0247 21.0064 19.9246 21.0857C19.8245 21.165 19.7033 21.2131 19.576 21.224C19.4485 21.2364 19.3202 21.2101 19.2079 21.1486C19.0955 21.087 19.0043 20.9931 18.946 20.879L16.186 15.638L13.286 18.518C13.2126 18.5907 13.123 18.6449 13.0245 18.6761C12.926 18.7073 12.8214 18.7145 12.7196 18.6972C12.6177 18.6799 12.5214 18.6386 12.4387 18.5766C12.356 18.5147 12.2893 18.4339 12.244 18.341L10.273 14.287L8.09203 23.608Z"\n  />\n</svg>\n';
const __vite_glob_0_183 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.212 15.209C15.3523 15.2088 14.5119 14.9537 13.7972 14.4759C13.0825 13.9981 12.5254 13.3192 12.1966 12.5248C11.8677 11.7305 11.7818 10.8565 11.9496 10.0133C12.1175 9.17016 12.5316 8.39569 13.1395 7.78785C13.7475 7.18002 14.5221 6.7661 15.3653 6.59845C16.2085 6.43081 17.0825 6.51695 17.8767 6.84599C18.671 7.17504 19.3498 7.7322 19.8274 8.44704C20.305 9.16188 20.56 10.0023 20.56 10.862C20.5586 12.0147 20.1001 13.1197 19.2849 13.9347C18.4698 14.7496 17.3646 15.2079 16.212 15.209ZM16.212 7.815C15.6093 7.815 15.0202 7.9937 14.5191 8.32851C14.0181 8.66332 13.6275 9.1392 13.3969 9.69596C13.1663 10.2527 13.1059 10.8654 13.2235 11.4564C13.3411 12.0475 13.6313 12.5904 14.0574 13.0166C14.4835 13.4427 15.0265 13.7329 15.6175 13.8505C16.2086 13.968 16.8212 13.9077 17.378 13.6771C17.9348 13.4464 18.4106 13.0559 18.7455 12.5548C19.0803 12.0537 19.259 11.4646 19.259 10.862C19.2582 10.0541 18.9369 9.27957 18.3657 8.70832C17.7944 8.13707 17.0199 7.8158 16.212 7.815Z"\n  />\n  <path\n    d="M16.381 26.514C13.7066 26.5834 11.0974 25.683 9.03497 23.979L8.83496 23.787V22.338C8.83814 20.7468 9.47198 19.2218 10.5976 18.0971C11.7232 16.9724 13.2488 16.3398 14.84 16.338H17.59C19.1812 16.3398 20.7067 16.9724 21.8323 18.0971C22.9579 19.2218 23.5918 20.7468 23.595 22.338V23.759L23.426 23.945C22.4813 24.8199 21.3717 25.4977 20.1621 25.9388C18.9525 26.3799 17.6671 26.5754 16.381 26.514ZM10.133 23.2C11.9386 24.5374 14.1343 25.2433 16.381 25.209C18.5266 25.2909 20.6282 24.5865 22.291 23.228V22.328C22.2883 21.0823 21.7923 19.8884 20.9114 19.0075C20.0306 18.1267 18.8367 17.6306 17.591 17.628H14.841C13.5953 17.6306 12.4013 18.1267 11.5205 19.0075C10.6396 19.8884 10.1436 21.0823 10.141 22.328L10.133 23.2Z"\n  />\n  <path\n    d="M24.593 10.713C24.076 10.713 23.5705 10.5597 23.1406 10.2724C22.7107 9.98512 22.3757 9.57681 22.1779 9.0991C21.9801 8.6214 21.9284 8.09576 22.0293 7.58867C22.1302 7.08157 22.3793 6.61581 22.745 6.25027C23.1106 5.88474 23.5765 5.63586 24.0837 5.53511C24.5908 5.43436 25.1164 5.48627 25.594 5.68427C26.0717 5.88227 26.4798 6.21747 26.7669 6.64747C27.0541 7.07747 27.2072 7.58296 27.207 8.1C27.2059 8.79286 26.9302 9.45702 26.4402 9.94686C25.9501 10.4367 25.2859 10.7122 24.593 10.713ZM24.593 6.786C24.3331 6.7858 24.0789 6.8627 23.8627 7.00696C23.6465 7.15123 23.4779 7.35638 23.3783 7.59646C23.2787 7.83655 23.2526 8.10078 23.3031 8.35574C23.3537 8.61069 23.4788 8.84492 23.6625 9.02879C23.8462 9.21265 24.0804 9.3379 24.3353 9.38868C24.5902 9.43946 24.8545 9.4135 25.0946 9.31407C25.3348 9.21465 25.5401 9.04623 25.6845 8.83012C25.8289 8.61402 25.906 8.35993 25.906 8.1C25.9057 7.75176 25.7674 7.41785 25.5212 7.17151C25.2751 6.92517 24.9412 6.78653 24.593 6.786Z"\n  />\n  <path\n    d="M24.684 17.077C23.1852 17.1119 21.7244 16.6037 20.571 15.646L20.371 15.455V14.555C20.3728 13.629 20.7416 12.7415 21.3965 12.0868C22.0513 11.4321 22.939 11.0636 23.865 11.062H25.326C26.2521 11.0633 27.14 11.4317 27.7951 12.0864C28.4502 12.7411 28.8191 13.6288 28.821 14.555V15.428L28.652 15.613C28.1211 16.1085 27.4967 16.4932 26.8154 16.7446C26.1341 16.996 25.4095 17.109 24.684 17.077ZM21.669 14.865C22.5535 15.4776 23.6082 15.7966 24.684 15.777C25.7023 15.8129 26.7022 15.4996 27.518 14.889V14.554C27.5164 13.9716 27.2839 13.4135 26.8715 13.0022C26.4591 12.591 25.9004 12.36 25.318 12.36H23.857C23.2757 12.3619 22.7189 12.5936 22.308 13.0047C21.8971 13.4158 21.6656 13.9728 21.664 14.554L21.669 14.865Z"\n  />\n  <path\n    d="M7.40699 10.713C6.88995 10.713 6.38449 10.5597 5.9546 10.2724C5.5247 9.98512 5.18968 9.57681 4.99186 9.0991C4.79404 8.6214 4.74233 8.09576 4.84327 7.58867C4.94421 7.08157 5.19329 6.61581 5.55897 6.25027C5.92464 5.88474 6.39049 5.63586 6.89762 5.53511C7.40475 5.43436 7.93037 5.48627 8.408 5.68427C8.88562 5.88227 9.2938 6.21747 9.58091 6.64747C9.86802 7.07747 10.0212 7.58296 10.021 8.1C10.0199 8.79286 9.74415 9.45702 9.25413 9.94686C8.76411 10.4367 8.09985 10.7122 7.40699 10.713ZM7.40699 6.786C7.14706 6.7858 6.89289 6.8627 6.67667 7.00696C6.46046 7.15123 6.2919 7.35638 6.1923 7.59646C6.09269 7.83655 6.06651 8.10078 6.1171 8.35574C6.16769 8.61069 6.29275 8.84492 6.47648 9.02879C6.6602 9.21265 6.89435 9.3379 7.14927 9.38868C7.40419 9.43946 7.66842 9.4135 7.90858 9.31407C8.14874 9.21465 8.35402 9.04623 8.49845 8.83012C8.64288 8.61402 8.71998 8.35993 8.71998 8.1C8.71971 7.75176 8.58133 7.41785 8.33518 7.17151C8.08903 6.92517 7.75523 6.78653 7.40699 6.786Z"\n  />\n  <path\n    d="M7.5 17.077C6.00153 17.1121 4.54097 16.6038 3.388 15.646L3.18799 15.455V14.555C3.18984 13.6288 3.55874 12.7411 4.21384 12.0864C4.86893 11.4317 5.75683 11.0633 6.68301 11.062H8.14401C9.07002 11.0636 9.95764 11.4321 10.6125 12.0868C11.2674 12.7415 11.6361 13.629 11.638 14.555V15.428L11.469 15.613C10.9379 16.1085 10.3133 16.4931 9.63184 16.7445C8.95037 16.9958 8.22565 17.1089 7.5 17.077ZM4.48499 14.865C5.36969 15.4772 6.42429 15.7962 7.5 15.777C8.51833 15.8131 9.51838 15.4998 10.334 14.889V14.554C10.3324 13.9728 10.1009 13.4158 9.69 13.0047C9.27911 12.5936 8.72222 12.3619 8.14099 12.36H6.67999C6.09755 12.36 5.5389 12.591 5.1265 13.0022C4.71409 13.4135 4.4816 13.9716 4.48001 14.554L4.48499 14.865Z"\n  />\n</svg>\n';
const __vite_glob_0_184 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.212 15.209C15.3523 15.2088 14.5119 14.9537 13.7972 14.4759C13.0825 13.9981 12.5254 13.3192 12.1966 12.5248C11.8677 11.7305 11.7818 10.8565 11.9496 10.0133C12.1175 9.17016 12.5316 8.39569 13.1395 7.78785C13.7475 7.18002 14.5221 6.7661 15.3653 6.59845C16.2085 6.43081 17.0825 6.51695 17.8767 6.84599C18.671 7.17504 19.3498 7.7322 19.8274 8.44704C20.305 9.16188 20.56 10.0023 20.56 10.862C20.5586 12.0147 20.1001 13.1197 19.2849 13.9347C18.4698 14.7496 17.3646 15.2079 16.212 15.209Z"\n  />\n  <path\n    d="M16.381 26.514C13.7066 26.5834 11.0974 25.683 9.03497 23.979L8.83496 23.787V22.338C8.83814 20.7468 9.47198 19.2218 10.5976 18.0971C11.7232 16.9724 13.2488 16.3398 14.84 16.338H17.59C19.1812 16.3398 20.7067 16.9724 21.8323 18.0971C22.9579 19.2218 23.5918 20.7468 23.595 22.338V23.759L23.426 23.945C22.4813 24.8199 21.3717 25.4977 20.1621 25.9388C18.9525 26.3799 17.6671 26.5754 16.381 26.514Z"\n  />\n  <path\n    d="M24.593 10.713C24.076 10.713 23.5705 10.5597 23.1406 10.2724C22.7107 9.98512 22.3757 9.57681 22.1779 9.0991C21.9801 8.6214 21.9284 8.09576 22.0293 7.58867C22.1302 7.08157 22.3793 6.61581 22.745 6.25027C23.1106 5.88474 23.5765 5.63586 24.0837 5.53511C24.5908 5.43436 25.1164 5.48627 25.594 5.68427C26.0717 5.88227 26.4798 6.21747 26.7669 6.64747C27.0541 7.07747 27.2072 7.58296 27.207 8.1C27.2059 8.79286 26.9302 9.45702 26.4402 9.94686C25.9501 10.4367 25.2859 10.7122 24.593 10.713Z"\n  />\n  <path\n    d="M24.684 17.077C23.1852 17.1119 21.7244 16.6037 20.571 15.646L20.371 15.455V14.555C20.3728 13.629 20.7416 12.7415 21.3965 12.0868C22.0513 11.4321 22.939 11.0636 23.865 11.062H25.326C26.2521 11.0633 27.14 11.4317 27.7951 12.0864C28.4502 12.7411 28.8191 13.6288 28.821 14.555V15.428L28.652 15.613C28.1211 16.1085 27.4967 16.4932 26.8154 16.7446C26.1341 16.996 25.4095 17.109 24.684 17.077Z"\n  />\n  <path\n    d="M5.9546 10.2724C6.38449 10.5597 6.88995 10.713 7.40699 10.713C8.09985 10.7122 8.76411 10.4367 9.25413 9.94686C9.74415 9.45702 10.0199 8.79286 10.021 8.1C10.0212 7.58296 9.86802 7.07747 9.58091 6.64747C9.2938 6.21747 8.88562 5.88227 8.408 5.68427C7.93037 5.48627 7.40475 5.43436 6.89762 5.53511C6.39049 5.63586 5.92464 5.88474 5.55897 6.25027C5.19329 6.61581 4.94421 7.08157 4.84327 7.58867C4.74233 8.09576 4.79404 8.6214 4.99186 9.0991C5.18968 9.57681 5.5247 9.98512 5.9546 10.2724Z"\n  />\n  <path\n    d="M7.5 17.077C6.00153 17.1121 4.54097 16.6038 3.388 15.646L3.18799 15.455V14.555C3.18984 13.6288 3.55874 12.7411 4.21384 12.0864C4.86893 11.4317 5.75683 11.0633 6.68301 11.062H8.14401C9.07002 11.0636 9.95764 11.4321 10.6125 12.0868C11.2674 12.7415 11.6361 13.629 11.638 14.555V15.428L11.469 15.613C10.9379 16.1085 10.3133 16.4931 9.63184 16.7445C8.95037 16.9958 8.22565 17.1089 7.5 17.077Z"\n  />\n</svg>\n';
const __vite_glob_0_185 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M30.6 10.406C29.8409 9.23787 29.0197 8.11126 28.14 7.031C27.8752 6.5994 27.4547 6.28607 26.9654 6.15578C26.4761 6.0255 25.9554 6.08823 25.511 6.331C25.349 6.42 25.135 6.569 24.879 6.75C24.3547 7.14151 23.7941 7.48205 23.205 7.767C22.8841 7.95597 22.5241 8.06867 22.1527 8.09641C21.7813 8.12415 21.4085 8.06619 21.063 7.92701C20.851 7.83801 20.619 7.71 20.369 7.574C19.363 7.027 17.845 6.2 16.28 7.032C16.129 7.111 15.961 7.213 15.786 7.321C15.624 7.211 15.412 7.08201 15.129 6.92601C14.5877 6.62118 13.9722 6.47326 13.3514 6.49887C12.7307 6.52449 12.1294 6.72261 11.615 7.071C11.2393 7.33743 10.8087 7.51632 10.3548 7.59454C9.90092 7.67276 9.43526 7.64832 8.99204 7.52301C8.76504 7.44301 8.50604 7.333 8.22904 7.215C7.77334 7.01271 7.30776 6.83349 6.83404 6.678C6.37753 6.56253 5.89735 6.58163 5.45144 6.73298C5.00553 6.88434 4.61294 7.16149 4.32104 7.531C4.21304 7.649 3.94904 7.954 3.62604 8.331C3.02604 9.019 2.13205 10.058 1.83205 10.358C1.62499 10.52 1.45379 10.7231 1.32928 10.9547C1.20478 11.1862 1.12967 11.441 1.10871 11.7031C1.08775 11.9651 1.1214 12.2286 1.20752 12.477C1.29364 12.7254 1.43036 12.9532 1.60905 13.146C2.06805 13.604 3.59504 14.956 4.40904 15.674L3.34105 16.742C3.08648 16.9929 2.90018 17.3047 2.79978 17.6477C2.69938 17.9908 2.6882 18.3538 2.76731 18.7024C2.84642 19.0509 3.01319 19.3735 3.25184 19.6397C3.49048 19.9058 3.7931 20.1065 4.13104 20.223C3.9128 20.5935 3.81357 21.0221 3.84675 21.4508C3.87994 21.8796 4.04393 22.2878 4.31658 22.6203C4.58923 22.9528 4.95739 23.1936 5.37131 23.3102C5.78522 23.4267 6.22494 23.4134 6.63104 23.272C6.71799 23.5955 6.88088 23.8935 7.10618 24.1414C7.33147 24.3893 7.61266 24.5798 7.92638 24.6971C8.24011 24.8145 8.57731 24.8553 8.90997 24.8161C9.24263 24.777 9.56114 24.659 9.83904 24.472C9.96541 24.8002 10.1718 25.0917 10.4395 25.3198C10.7072 25.548 11.0277 25.7056 11.3718 25.7783C11.7159 25.851 12.0727 25.8366 12.4099 25.7363C12.747 25.636 13.0537 25.453 13.302 25.204L14.364 24.142C14.728 24.489 15.318 25.042 15.679 25.313C16.1294 25.6805 16.6872 25.8911 17.268 25.913C17.5386 25.9123 17.8056 25.8524 18.0505 25.7373C18.2953 25.6222 18.5119 25.4549 18.685 25.247C18.8722 25.0318 19.0134 24.7807 19.1 24.509C19.211 24.602 19.323 24.691 19.437 24.78C19.8614 25.111 20.3873 25.2845 20.9253 25.271C21.4632 25.2575 21.9799 25.0578 22.387 24.706C22.7292 24.3585 22.9463 23.9072 23.004 23.423C23.3655 23.5323 23.7504 23.5375 24.1146 23.4379C24.4788 23.3383 24.8076 23.138 25.063 22.86C25.3064 22.6199 25.4763 22.3156 25.553 21.9824C25.6297 21.6493 25.6099 21.3013 25.496 20.979C26.0663 20.9331 26.5967 20.6683 26.976 20.24C27.1361 20.049 27.2554 19.8272 27.3264 19.5883C27.3974 19.3494 27.4188 19.0985 27.3891 18.851C27.3102 18.1923 26.9895 17.5865 26.489 17.151C27.577 15.951 30.189 13.08 30.489 12.71C30.7417 12.3837 30.8879 11.9877 30.9077 11.5755C30.9276 11.1633 30.8202 10.755 30.6 10.406ZM4.26105 17.661L6.69804 15.225C6.7727 15.1453 6.86261 15.0814 6.96245 15.0371C7.06228 14.9929 7.16999 14.9691 7.27919 14.9673C7.38838 14.9654 7.49684 14.9856 7.5981 15.0265C7.69936 15.0674 7.79137 15.1282 7.86866 15.2054C7.94595 15.2825 8.00694 15.3744 8.04802 15.4756C8.0891 15.5768 8.10941 15.6852 8.10777 15.7944C8.10613 15.9036 8.08256 16.0114 8.03846 16.1113C7.99436 16.2112 7.93062 16.3012 7.85104 16.376L5.41405 18.813C5.25872 18.9612 5.05226 19.044 4.83755 19.044C4.62283 19.044 4.41637 18.9612 4.26105 18.813C4.10874 18.6601 4.02314 18.4531 4.02296 18.2372C4.02277 18.0214 4.109 17.8142 4.26105 17.661ZM5.37904 21.855C5.22687 21.7019 5.14146 21.4949 5.14146 21.279C5.14146 21.0632 5.22687 20.8561 5.37904 20.703L6.50805 19.573L6.50004 19.565L8.77004 17.295C8.82308 17.2366 8.87315 17.1755 8.92004 17.112L8.94504 17.137C9.01977 17.0574 9.10975 16.9936 9.20962 16.9494C9.30949 16.9052 9.41722 16.8815 9.52642 16.8798C9.63562 16.878 9.74405 16.8983 9.84527 16.9392C9.9465 16.9802 10.0385 17.0411 10.1157 17.1184C10.1929 17.1956 10.2538 17.2875 10.2948 17.3888C10.3358 17.49 10.356 17.5984 10.3543 17.7076C10.3525 17.8168 10.3289 17.9246 10.2847 18.0244C10.2405 18.1243 10.1767 18.2143 10.097 18.289L6.53104 21.855C6.3756 22.003 6.16918 22.0856 5.95454 22.0856C5.7399 22.0856 5.53448 22.003 5.37904 21.855ZM8.08904 23.289C7.93662 23.1361 7.85104 22.9289 7.85104 22.713C7.85104 22.4971 7.93662 22.29 8.08904 22.137L10.661 19.564C10.8154 19.4192 11.02 19.3401 11.2317 19.3434C11.4433 19.3468 11.6453 19.4324 11.795 19.5821C11.9447 19.7317 12.0302 19.9337 12.0336 20.1454C12.037 20.357 11.9579 20.5617 11.813 20.716L10.313 22.216L10.299 22.233L9.23704 23.295C9.08116 23.4413 8.87511 23.5222 8.66135 23.5211C8.44759 23.5199 8.24339 23.4369 8.08904 23.289ZM12.389 24.281C12.2339 24.4292 12.0276 24.5119 11.813 24.5119C11.5985 24.5119 11.3922 24.4292 11.237 24.281C11.0857 24.1299 11.0001 23.9251 10.999 23.7112C10.9978 23.4974 11.0813 23.2917 11.231 23.139L12.731 21.639C12.769 21.602 12.795 21.559 12.831 21.52L12.84 21.529C12.9934 21.3791 13.1997 21.2958 13.4142 21.297C13.6286 21.2982 13.8339 21.3838 13.9856 21.5354C14.1373 21.687 14.2232 21.8923 14.2246 22.1067C14.226 22.3211 14.1428 22.5275 13.993 22.681L12.389 24.281ZM26.004 19.381C25.8308 19.5467 25.6083 19.6516 25.3703 19.6799C25.1322 19.7083 24.8914 19.6584 24.684 19.538L20.293 15.669L19.433 16.645L23.779 20.473C24.556 21.521 24.243 21.842 24.14 21.948C23.74 22.355 23.19 22.258 22.508 21.662C22.494 21.65 22.477 21.646 22.463 21.635L18.602 18.191L17.736 19.161L21.569 22.579C21.685 22.7627 21.738 22.9792 21.7199 23.1957C21.7019 23.4123 21.6138 23.617 21.469 23.779C21.2863 23.904 21.0687 23.9682 20.8474 23.9624C20.626 23.9567 20.4121 23.8813 20.236 23.747C19.7777 23.3891 19.3465 22.9976 18.946 22.576L18.959 22.562L16.729 20.433L15.829 21.374L17.88 23.333C17.9305 23.5099 17.9414 23.6958 17.912 23.8774C17.8826 24.059 17.8137 24.232 17.71 24.384C17.42 24.713 17.001 24.673 16.464 24.266C16.164 24.039 15.604 23.518 15.23 23.166C15.4234 22.8403 15.5251 22.4683 15.5243 22.0895C15.5236 21.7107 15.4203 21.3392 15.2256 21.0143C15.0308 20.6894 14.7518 20.4232 14.4181 20.2439C14.0844 20.0647 13.7085 19.979 13.33 19.996C13.3033 19.5246 13.117 19.0763 12.8017 18.7248C12.4863 18.3733 12.0608 18.1396 11.595 18.062C11.616 17.9465 11.6273 17.8294 11.629 17.712C11.63 17.4217 11.5707 17.1343 11.4549 16.8681C11.3391 16.6018 11.1694 16.3625 10.9565 16.1652C10.7436 15.9678 10.492 15.8168 10.2177 15.7216C9.94348 15.6264 9.65245 15.5891 9.36304 15.612C9.32356 15.1186 9.11107 14.655 8.76305 14.303C8.36602 13.9071 7.82822 13.6848 7.26755 13.6848C6.70687 13.6848 6.16907 13.9071 5.77205 14.303L5.32504 14.751C4.53704 14.058 2.96105 12.664 2.52505 12.225C2.19705 11.896 2.57205 11.451 2.74805 11.275C3.08105 10.942 3.92705 9.96501 4.60605 9.17501C4.91905 8.81401 5.17504 8.517 5.27904 8.404C5.40903 8.22207 5.58726 8.08008 5.79363 7.99403C6.00001 7.90798 6.22632 7.8813 6.44704 7.917C6.86904 8.048 7.30005 8.231 7.71805 8.409C8.01805 8.538 8.30804 8.65901 8.55804 8.74601C9.17794 8.93582 9.83243 8.98467 10.4736 8.88899C11.1148 8.79331 11.7266 8.55552 12.264 8.193C12.5834 7.95749 12.9642 7.81959 13.3604 7.79599C13.7565 7.77238 14.151 7.86409 14.496 8.06L14.596 8.12001C14.136 8.45301 13.72 8.77201 13.479 8.96601C13.034 9.28382 12.7251 9.75768 12.6139 10.2931C12.5027 10.8286 12.5974 11.3863 12.879 11.855C13.1659 12.3448 13.6303 12.7053 14.1759 12.8617C14.7214 13.0181 15.3063 12.9584 15.809 12.695L16.015 12.573C17.234 11.847 17.707 11.63 18.233 12.035L25.523 18.015C25.6766 18.1277 25.8063 18.2698 25.9045 18.4331C26.0027 18.5964 26.0675 18.7775 26.095 18.966C26.1079 19.0385 26.1061 19.1128 26.0898 19.1846C26.0735 19.2564 26.043 19.3242 26 19.384L26.004 19.381ZM29.481 11.891C29.228 12.203 26.805 14.874 25.497 16.313L19.048 11.023L18.636 11.523L19.036 11.009C17.764 10.028 16.542 10.754 15.359 11.457L15.159 11.578C14.9476 11.6678 14.7102 11.675 14.4937 11.5982C14.2773 11.5213 14.0975 11.366 13.99 11.163C13.879 10.9629 13.8502 10.7274 13.9098 10.5064C13.9693 10.2854 14.1125 10.0963 14.309 9.979C15.1275 9.31823 15.992 8.7167 16.896 8.179C17.776 7.712 18.636 8.106 19.754 8.715C20.046 8.874 20.319 9.02 20.565 9.124C21.0754 9.33297 21.6259 9.42577 22.1766 9.39567C22.7273 9.36558 23.2645 9.21334 23.749 8.95C24.4131 8.63122 25.0449 8.24947 25.636 7.81C25.842 7.665 26.012 7.542 26.143 7.471C26.305 7.382 26.607 7.217 27.153 7.864C27.62 8.417 29.191 10.51 29.462 11.015C29.5563 11.1414 29.6086 11.2941 29.6117 11.4518C29.6147 11.6094 29.5684 11.7641 29.479 11.894L29.481 11.891Z"\n  />\n</svg>\n';
const __vite_glob_0_186 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M30.6 10.406C29.8409 9.23787 29.0197 8.11126 28.14 7.031C27.8752 6.5994 27.4547 6.28607 26.9654 6.15578C26.4761 6.0255 25.9554 6.08823 25.511 6.331C25.349 6.42 25.135 6.569 24.879 6.75C24.3547 7.14151 23.7941 7.48205 23.205 7.767C22.8841 7.95597 22.5241 8.06867 22.1527 8.09641C21.7813 8.12415 21.4085 8.06619 21.063 7.92701C20.851 7.83801 20.619 7.71 20.369 7.574C19.363 7.027 17.845 6.2 16.28 7.032C16.129 7.111 15.961 7.213 15.786 7.321C15.624 7.211 15.412 7.08201 15.129 6.92601C14.5877 6.62118 13.9722 6.47326 13.3514 6.49887C12.7307 6.52449 12.1294 6.72261 11.615 7.071C11.2393 7.33743 10.8087 7.51632 10.3548 7.59454C9.90092 7.67276 9.43526 7.64832 8.99204 7.52301C8.76504 7.44301 8.50604 7.333 8.22904 7.215C7.77334 7.01271 7.30776 6.83349 6.83404 6.678C6.37753 6.56253 5.89735 6.58163 5.45144 6.73298C5.00553 6.88434 4.61294 7.16149 4.32104 7.531C4.21304 7.649 3.94904 7.954 3.62604 8.331C3.02604 9.019 2.13205 10.058 1.83205 10.358C1.62499 10.52 1.45379 10.7231 1.32928 10.9547C1.20478 11.1862 1.12967 11.441 1.10871 11.7031C1.08775 11.9651 1.1214 12.2286 1.20752 12.477C1.29364 12.7254 1.43036 12.9532 1.60905 13.146C2.06805 13.604 3.59504 14.956 4.40904 15.674L3.34105 16.742C3.08648 16.9929 2.90018 17.3047 2.79978 17.6477C2.69938 17.9908 2.6882 18.3538 2.76731 18.7024C2.84642 19.0509 3.01319 19.3735 3.25184 19.6397C3.49048 19.9058 3.7931 20.1065 4.13104 20.223C3.9128 20.5935 3.81357 21.0221 3.84675 21.4508C3.87994 21.8796 4.04393 22.2878 4.31658 22.6203C4.58923 22.9528 4.95739 23.1936 5.37131 23.3102C5.78522 23.4267 6.22494 23.4134 6.63104 23.272C6.71799 23.5955 6.88088 23.8935 7.10618 24.1414C7.33147 24.3893 7.61266 24.5798 7.92638 24.6971C8.24011 24.8145 8.57731 24.8553 8.90997 24.8161C9.24263 24.777 9.56114 24.659 9.83904 24.472C9.96541 24.8002 10.1718 25.0917 10.4395 25.3198C10.7072 25.548 11.0277 25.7056 11.3718 25.7783C11.7159 25.851 12.0727 25.8366 12.4099 25.7363C12.747 25.636 13.0537 25.453 13.302 25.204L14.364 24.142C14.728 24.489 15.318 25.042 15.679 25.313C16.1294 25.6805 16.6872 25.8911 17.268 25.913C17.5386 25.9123 17.8056 25.8524 18.0505 25.7373C18.2953 25.6222 18.5119 25.4549 18.685 25.247C18.8722 25.0318 19.0134 24.7807 19.1 24.509C19.211 24.602 19.323 24.691 19.437 24.78C19.8614 25.111 20.3873 25.2845 20.9253 25.271C21.4632 25.2575 21.9799 25.0578 22.387 24.706C22.7292 24.3585 22.9463 23.9072 23.004 23.423C23.3655 23.5323 23.7504 23.5375 24.1146 23.4379C24.4788 23.3383 24.8076 23.138 25.063 22.86C25.3064 22.6199 25.4763 22.3156 25.553 21.9824C25.6297 21.6493 25.6099 21.3013 25.496 20.979C26.0663 20.9331 26.5967 20.6683 26.976 20.24C27.1361 20.049 27.2554 19.8272 27.3264 19.5883C27.3974 19.3494 27.4188 19.0985 27.3891 18.851C27.3102 18.1923 26.9895 17.5865 26.489 17.151C27.577 15.951 30.189 13.08 30.489 12.71C30.7417 12.3837 30.8879 11.9877 30.9077 11.5755C30.9276 11.1633 30.8202 10.755 30.6 10.406ZM26.004 19.381C25.8308 19.5467 25.6083 19.6516 25.3703 19.6799C25.1322 19.7083 24.8914 19.6584 24.684 19.538L20.293 15.669L19.433 16.645L23.779 20.473C24.556 21.521 24.243 21.842 24.14 21.948C23.74 22.355 23.19 22.258 22.508 21.662C22.494 21.65 22.477 21.646 22.463 21.635L18.602 18.191L17.736 19.161L21.569 22.579C21.685 22.7627 21.738 22.9792 21.7199 23.1957C21.7019 23.4123 21.6138 23.617 21.469 23.779C21.2863 23.904 21.0687 23.9682 20.8474 23.9624C20.626 23.9567 20.4121 23.8813 20.236 23.747C19.7777 23.3891 19.3465 22.9976 18.946 22.576L18.959 22.562L16.729 20.433L15.829 21.374L17.88 23.333C17.9305 23.5099 17.9414 23.6958 17.912 23.8774C17.8826 24.059 17.8137 24.232 17.71 24.384C17.42 24.713 17.001 24.673 16.464 24.266C16.164 24.039 15.604 23.518 15.23 23.166C15.4234 22.8403 15.5251 22.4683 15.5243 22.0895C15.5236 21.7107 15.4203 21.3392 15.2256 21.0143C15.0308 20.6894 14.7518 20.4232 14.4181 20.2439C14.0844 20.0647 13.7085 19.979 13.33 19.996C13.3033 19.5246 13.117 19.0763 12.8017 18.7248C12.4863 18.3733 12.0608 18.1396 11.595 18.062C11.616 17.9465 11.6273 17.8294 11.629 17.712C11.63 17.4217 11.5707 17.1343 11.4549 16.8681C11.3391 16.6018 11.1694 16.3625 10.9565 16.1652C10.7436 15.9678 10.492 15.8168 10.2177 15.7216C9.94348 15.6264 9.65245 15.5891 9.36304 15.612C9.32356 15.1186 9.11107 14.655 8.76305 14.303C8.36602 13.9071 7.82822 13.6848 7.26755 13.6848C6.70687 13.6848 6.16907 13.9071 5.77205 14.303L5.32504 14.751C4.53704 14.058 2.96105 12.664 2.52505 12.225C2.19705 11.896 2.57205 11.451 2.74805 11.275C3.08105 10.942 3.92705 9.96501 4.60605 9.17501C4.91905 8.81401 5.17504 8.517 5.27904 8.404C5.40903 8.22207 5.58726 8.08008 5.79363 7.99403C6.00001 7.90798 6.22632 7.8813 6.44704 7.917C6.86904 8.048 7.30005 8.231 7.71805 8.409C8.01805 8.538 8.30804 8.65901 8.55804 8.74601C9.17794 8.93582 9.83243 8.98467 10.4736 8.88899C11.1148 8.79331 11.7266 8.55552 12.264 8.193C12.5834 7.95749 12.9642 7.81959 13.3604 7.79599C13.7565 7.77238 14.151 7.86409 14.496 8.06L14.596 8.12001C14.136 8.45301 13.72 8.77201 13.479 8.96601C13.034 9.28382 12.7251 9.75768 12.6139 10.2931C12.5027 10.8286 12.5974 11.3863 12.879 11.855C13.1659 12.3448 13.6303 12.7053 14.1759 12.8617C14.7214 13.0181 15.3063 12.9584 15.809 12.695L16.015 12.573C17.234 11.847 17.707 11.63 18.233 12.035L25.523 18.015C25.6766 18.1277 25.8063 18.2698 25.9045 18.4331C26.0027 18.5964 26.0675 18.7775 26.095 18.966C26.1079 19.0385 26.1061 19.1128 26.0898 19.1846C26.0735 19.2564 26.043 19.3242 26 19.384L26.004 19.381Z"\n  />\n</svg>\n';
const __vite_glob_0_187 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.4 28H7.6C6.93726 28 6.4 27.446 6.4 26.7625V16.8628H4L15.1504 5.36293C15.3755 5.13057 15.6809 5 15.9994 5C16.3179 5 16.6233 5.13057 16.8484 5.36293L28 16.8628H25.6V26.7625C25.6 27.446 25.0627 28 24.4 28ZM13.6 20.3377H18.4V26.5251H24.2V15.4124L16 6.98761L7.8 15.4124V26.5251H13.6V20.3377Z"\n  />\n</svg>\n';
const __vite_glob_0_188 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M4 16.8625L15.1516 5.36232C15.6202 4.87923 16.3798 4.87923 16.8484 5.36232L28 16.8625H25.6V26.7625C25.6 27.4459 25.0627 28 24.4 28H18.4V20.3375H13.6V28H7.6C6.93726 28 6.4 27.4459 6.4 26.7625V16.8625H4Z"\n  />\n</svg>\n';
const __vite_glob_0_189 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M6.92696 9.776C6.88723 9.77257 6.84771 9.78457 6.8166 9.80953C6.7855 9.83448 6.7652 9.87048 6.75995 9.91001V14.567C6.7652 14.6065 6.7855 14.6425 6.8166 14.6675C6.84771 14.6924 6.88723 14.7044 6.92696 14.701H13.416C13.4556 14.7044 13.495 14.6924 13.5259 14.6674C13.5569 14.6424 13.5769 14.6064 13.582 14.567V9.91001C13.5769 9.87056 13.5569 9.83458 13.5259 9.8096C13.495 9.78463 13.4556 9.77259 13.416 9.776H6.92696Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M5.15097 27.422H26.851C27.7445 27.4236 28.6022 27.0706 29.2357 26.4405C29.8692 25.8103 30.2268 24.9545 30.23 24.061V7.939C30.2268 7.04547 29.8692 6.1897 29.2357 5.55956C28.6022 4.92942 27.7445 4.57641 26.851 4.57801H5.15097C4.25743 4.57641 3.39976 4.92942 2.76625 5.55956C2.13274 6.1897 1.77515 7.04547 1.77197 7.939V24.061C1.77515 24.9545 2.13274 25.8103 2.76625 26.4405C3.39976 27.0706 4.25743 27.4236 5.15097 27.422ZM13.416 16H6.92696C6.54254 16.004 6.17222 15.8554 5.89722 15.5868C5.62221 15.3181 5.46497 14.9514 5.45996 14.567V9.91001C5.46497 9.5256 5.62221 9.15888 5.89722 8.89025C6.17222 8.62161 6.54254 8.473 6.92696 8.47701H13.416C13.8002 8.47327 14.1702 8.62199 14.445 8.8906C14.7198 9.1592 14.8769 9.52578 14.882 9.91001V14.567C14.8769 14.9512 14.7198 15.3178 14.445 15.5864C14.1702 15.855 13.8002 16.0037 13.416 16ZM18.172 9.979H25.889V11.279H18.172V9.979ZM18.172 13.202H25.889V14.502H18.172V13.202ZM25.89 18.774H6.15796V20.074H25.89V18.774ZM6.15796 21.996H25.89V23.296H6.15796V21.996Z"\n  />\n</svg>\n';
const __vite_glob_0_190 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M26.851 27.422H5.15097C4.25743 27.4236 3.39976 27.0706 2.76625 26.4405C2.13274 25.8103 1.77515 24.9545 1.77197 24.061V7.939C1.77515 7.04547 2.13274 6.1897 2.76625 5.55956C3.39976 4.92942 4.25743 4.57641 5.15097 4.57801H26.851C27.7445 4.57641 28.6022 4.92942 29.2357 5.55956C29.8692 6.1897 30.2268 7.04547 30.23 7.939V24.061C30.2268 24.9545 29.8692 25.8103 29.2357 26.4405C28.6022 27.0706 27.7445 27.4236 26.851 27.422ZM5.15097 5.877C4.60187 5.87514 4.07446 6.09122 3.68449 6.4778C3.29453 6.86439 3.07388 7.3899 3.07097 7.939V24.061C3.07388 24.6101 3.29453 25.1356 3.68449 25.5222C4.07446 25.9088 4.60187 26.1249 5.15097 26.123H26.851C27.4001 26.1249 27.9275 25.9088 28.3174 25.5222C28.7074 25.1356 28.9281 24.6101 28.931 24.061V7.939C28.9281 7.3899 28.7074 6.86439 28.3174 6.4778C27.9275 6.09122 27.4001 5.87514 26.851 5.877H5.15097Z"\n  />\n  <path\n    d="M13.416 16H6.92696C6.54254 16.004 6.17222 15.8554 5.89722 15.5868C5.62221 15.3181 5.46497 14.9514 5.45996 14.567V9.91001C5.46497 9.5256 5.62221 9.15888 5.89722 8.89025C6.17222 8.62161 6.54254 8.473 6.92696 8.47701H13.416C13.8002 8.47327 14.1702 8.62199 14.445 8.8906C14.7198 9.1592 14.8769 9.52578 14.882 9.91001V14.567C14.8769 14.9512 14.7198 15.3178 14.445 15.5864C14.1702 15.855 13.8002 16.0037 13.416 16ZM6.92696 9.776C6.88723 9.77257 6.84771 9.78457 6.8166 9.80953C6.7855 9.83448 6.7652 9.87048 6.75995 9.91001V14.567C6.7652 14.6065 6.7855 14.6425 6.8166 14.6675C6.84771 14.6924 6.88723 14.7044 6.92696 14.701H13.416C13.4556 14.7044 13.495 14.6924 13.5259 14.6674C13.5569 14.6424 13.5769 14.6065 13.582 14.567V9.91001C13.5769 9.87056 13.5569 9.83458 13.5259 9.8096C13.495 9.78463 13.4556 9.77259 13.416 9.776H6.92696Z"\n  />\n  <path d="M25.889 9.979H18.172V11.279H25.889V9.979Z" />\n  <path d="M25.889 13.202H18.172V14.502H25.889V13.202Z" />\n  <path d="M25.89 18.774H6.15796V20.074H25.89V18.774Z" />\n  <path d="M25.89 21.996H6.15796V23.296H25.89V21.996Z" />\n</svg>\n';
const __vite_glob_0_191 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M10.421 12.409C10.1844 11.663 10.0713 10.8835 10.086 10.101C10.1084 8.18937 10.8835 6.36365 12.2433 5.01978C13.603 3.6759 15.4377 2.92224 17.3495 2.92224C19.2612 2.92224 21.0959 3.6759 22.4557 5.01978C23.8154 6.36365 24.5906 8.18937 24.613 10.101C24.6138 10.8443 24.4988 11.5832 24.272 12.291L23.034 11.891C23.2199 11.3123 23.3138 10.7079 23.312 10.1C23.2939 9.24712 23.0929 8.40802 22.7228 7.63939C22.3527 6.87076 21.822 6.19049 21.1665 5.64447C20.511 5.09846 19.7461 4.69942 18.9232 4.47429C18.1003 4.24916 17.2388 4.20319 16.3966 4.33946C15.5545 4.47574 14.7514 4.7911 14.0415 5.26425C13.3317 5.73741 12.7316 6.35734 12.2818 7.08221C11.8319 7.80709 11.5429 8.62003 11.434 9.46616C11.3252 10.3123 11.3992 11.1719 11.651 11.987L10.421 12.409Z"\n  />\n  <path\n    d="M19.584 29.162H10.533L10.339 28.886C8.4772 26.165 7.45115 22.9593 7.38696 19.663C7.38696 16.796 11.179 14.371 15.687 14.335V9.592C15.6853 9.22783 15.762 8.86757 15.9117 8.53561C16.0615 8.20366 16.2809 7.90777 16.555 7.668C16.8356 7.42841 17.1643 7.25177 17.519 7.14999C17.8736 7.04822 18.246 7.02367 18.611 7.078C19.2149 7.20347 19.7579 7.53135 20.1502 8.00742C20.5424 8.48349 20.7604 9.07921 20.768 9.696V17.879C21.6481 18.2552 22.3997 18.8796 22.9308 19.6758C23.462 20.4721 23.7498 21.4059 23.759 22.363C23.759 24.822 22.297 27.257 19.749 29.044L19.584 29.162ZM11.215 27.862H19.171C20.1129 27.2681 20.9016 26.4607 21.4732 25.5051C22.0448 24.5496 22.3832 23.4728 22.461 22.362C22.4402 21.5849 22.179 20.8333 21.7134 20.2108C21.2478 19.5883 20.6006 19.1254 19.861 18.886L19.472 18.715V9.7C19.4659 9.39551 19.3612 9.1012 19.1737 8.86122C18.9862 8.62124 18.726 8.44854 18.432 8.369C18.2513 8.33969 18.0664 8.34999 17.8901 8.3992C17.7138 8.44841 17.5503 8.53536 17.411 8.65401C17.2771 8.77127 17.1704 8.91628 17.0982 9.07895C17.026 9.24162 16.9901 9.41805 16.993 9.59599V14.387C16.9993 14.7082 16.8794 15.019 16.6592 15.2529C16.439 15.4867 16.1359 15.625 15.815 15.638C12.075 15.638 8.68896 17.559 8.68896 19.667C8.76031 22.5792 9.63444 25.415 11.215 27.862Z"\n  />\n</svg>\n';
const __vite_glob_0_192 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M10.421 12.409C10.1844 11.663 10.0713 10.8835 10.086 10.101C10.1084 8.18937 10.8835 6.36365 12.2433 5.01978C13.603 3.6759 15.4377 2.92224 17.3495 2.92224C19.2612 2.92224 21.0959 3.6759 22.4557 5.01978C23.8154 6.36365 24.5906 8.18937 24.613 10.101C24.6138 10.8443 24.4988 11.5832 24.272 12.291L23.034 11.891C23.2199 11.3123 23.3138 10.7079 23.312 10.1C23.2939 9.24712 23.0929 8.40802 22.7228 7.63939C22.3527 6.87076 21.822 6.19049 21.1665 5.64447C20.511 5.09846 19.7461 4.69942 18.9232 4.47429C18.1003 4.24916 17.2388 4.20319 16.3966 4.33946C15.5545 4.47574 14.7514 4.7911 14.0415 5.26425C13.3317 5.73741 12.7316 6.35734 12.2818 7.08221C11.8319 7.80709 11.5429 8.62003 11.434 9.46616C11.3252 10.3123 11.3992 11.1719 11.651 11.987L10.421 12.409Z"\n  />\n  <path\n    d="M19.584 29.162H10.533L10.339 28.886C8.4772 26.165 7.45115 22.9593 7.38696 19.663C7.38696 16.796 11.179 14.371 15.687 14.335V9.592C15.6853 9.22783 15.762 8.86757 15.9117 8.53561C16.0615 8.20366 16.2809 7.90777 16.555 7.668C16.8356 7.42841 17.1643 7.25177 17.519 7.14999C17.8736 7.04822 18.246 7.02367 18.611 7.078C19.2149 7.20347 19.7579 7.53135 20.1502 8.00742C20.5424 8.48349 20.7604 9.07921 20.768 9.696V17.879C21.6481 18.2552 22.3997 18.8796 22.9308 19.6758C23.462 20.4721 23.7498 21.4059 23.759 22.363C23.759 24.822 22.297 27.257 19.749 29.044L19.584 29.162Z"\n  />\n</svg>\n';
const __vite_glob_0_193 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.937 10.6C17.5944 10.6 18.2434 10.4534 18.837 10.171L18.282 8.99599C17.5974 9.32007 16.819 9.38726 16.089 9.18533C15.3589 8.98341 14.7258 8.52581 14.305 7.89598H16.621V6.59598H13.812C13.7847 6.4407 13.769 6.28361 13.765 6.12599C13.7688 5.96633 13.7848 5.80718 13.813 5.64998H17.093V4.34999H14.31C14.7322 3.72322 15.365 3.26845 16.0937 3.06812C16.8224 2.86778 17.5987 2.93514 18.282 3.25798L18.837 2.08298C18.2959 1.82713 17.7087 1.68287 17.1107 1.65881C16.5126 1.63476 15.9157 1.7314 15.3558 1.94296C14.7959 2.15453 14.2843 2.47669 13.8515 2.89023C13.4188 3.30377 13.0738 3.80023 12.837 4.34999H11.437V5.64998H12.513C12.4884 5.80766 12.4724 5.96657 12.465 6.12599C12.4725 6.28337 12.4882 6.44023 12.512 6.59598H11.437V7.89598H12.837C13.1825 8.69728 13.7546 9.38014 14.483 9.86055C15.2114 10.341 16.0644 10.598 16.937 10.6Z"\n  />\n  <path\n    d="M13.661 21.946C13.6608 22.4086 13.7978 22.861 14.0547 23.2457C14.3116 23.6305 14.6768 23.9304 15.1042 24.1076C15.5316 24.2848 16.0019 24.3313 16.4557 24.2411C16.9095 24.151 17.3263 23.9283 17.6536 23.6012C17.9808 23.2742 18.2036 22.8574 18.294 22.4037C18.3843 21.9499 18.338 21.4796 18.161 21.0521C17.984 20.6247 17.6843 20.2593 17.2996 20.0022C16.9149 19.7452 16.4627 19.608 16 19.608C15.3801 19.6088 14.7858 19.8553 14.3473 20.2936C13.9089 20.7318 13.6621 21.326 13.661 21.946ZM17.038 21.946C17.038 22.1513 16.9771 22.3519 16.8631 22.5226C16.749 22.6933 16.5869 22.8264 16.3972 22.905C16.2075 22.9835 15.9988 23.0041 15.7975 22.964C15.5961 22.924 15.4112 22.8251 15.266 22.6799C15.1209 22.5348 15.022 22.3498 14.9819 22.1485C14.9419 21.9471 14.9625 21.7384 15.041 21.5487C15.1196 21.3591 15.2526 21.197 15.4233 21.0829C15.594 20.9688 15.7947 20.908 16 20.908C16.2752 20.9082 16.5391 21.0177 16.7337 21.2123C16.9283 21.4069 17.0377 21.6708 17.038 21.946Z"\n  />\n  <path\n    d="M16.628 24.991H15.372C14.5498 24.991 13.7613 25.3176 13.1799 25.8989C12.5986 26.4803 12.272 27.2688 12.272 28.091V28.904L12.472 29.096C13.4816 29.9341 14.7601 30.3794 16.072 30.35C16.708 30.3766 17.3429 30.2764 17.9398 30.0553C18.5368 29.8341 19.0838 29.4965 19.549 29.062L19.719 28.876V28.091C19.719 27.2704 19.3936 26.4832 18.8142 25.9021C18.2348 25.321 17.4486 24.9933 16.628 24.991ZM18.428 28.329C17.7473 28.8217 16.9218 29.0736 16.082 29.045C15.1927 29.0598 14.3202 28.8019 13.582 28.306V28.086C13.5833 27.6094 13.7735 27.1529 14.1109 26.8164C14.4484 26.4799 14.9054 26.291 15.382 26.291H16.638C17.1145 26.291 17.5716 26.4799 17.909 26.8164C18.2464 27.1529 18.4366 27.6094 18.438 28.086L18.428 28.329Z"\n  />\n  <path\n    d="M6.073 24.284C6.53537 24.2838 6.98729 24.1465 7.37164 23.8895C7.75599 23.6324 8.05553 23.2672 8.23233 22.84C8.40913 22.4128 8.45529 21.9427 8.36496 21.4892C8.27463 21.0358 8.05187 20.6193 7.72485 20.2924C7.39784 19.9655 6.98124 19.743 6.52774 19.6528C6.07424 19.5627 5.60422 19.6091 5.17706 19.786C4.74991 19.963 4.38482 20.2627 4.12796 20.6472C3.8711 21.0316 3.73401 21.4836 3.73401 21.946C3.7348 22.566 3.98151 23.1604 4.42001 23.5987C4.85852 24.037 5.45299 24.2834 6.073 24.284ZM6.073 20.908C6.2783 20.908 6.47899 20.9688 6.64969 21.0829C6.82039 21.197 6.95342 21.3591 7.03198 21.5487C7.11055 21.7384 7.13112 21.9471 7.09106 22.1485C7.05101 22.3498 6.95214 22.5348 6.80698 22.68C6.66181 22.8251 6.47686 22.924 6.27551 22.964C6.07416 23.0041 5.86545 22.9835 5.67578 22.905C5.48611 22.8264 5.32399 22.6933 5.20993 22.5226C5.09587 22.3519 5.035 22.1513 5.035 21.946C5.035 21.6707 5.14436 21.4067 5.33902 21.212C5.53368 21.0173 5.7977 20.908 6.073 20.908Z"\n  />\n  <path\n    d="M6.69998 24.991H5.44498C4.62281 24.991 3.83429 25.3176 3.25293 25.8989C2.67157 26.4803 2.34497 27.2688 2.34497 28.091V28.904L2.54498 29.096C3.55436 29.9347 4.83296 30.3801 6.14496 30.35C6.78097 30.3766 7.41592 30.2764 8.01285 30.0553C8.60978 29.8341 9.15678 29.4965 9.62198 29.062L9.79095 28.876V28.091C9.79096 27.2704 9.46562 26.4832 8.8862 25.9021C8.30678 25.321 7.52059 24.9933 6.69998 24.991ZM8.49496 28.328C7.81367 28.8189 6.98928 29.0709 6.14996 29.045C5.26073 29.0596 4.38832 28.8017 3.64996 28.306V28.086C3.65129 27.6094 3.84153 27.1529 4.17896 26.8164C4.51638 26.4799 4.97346 26.291 5.44998 26.291H6.69998C7.17564 26.2923 7.63143 26.4818 7.96777 26.8182C8.30412 27.1545 8.49365 27.6103 8.49496 28.086V28.328Z"\n  />\n  <path\n    d="M23.589 21.946C23.5888 22.4087 23.7259 22.861 23.9828 23.2458C24.2397 23.6306 24.605 23.9306 25.0324 24.1077C25.4599 24.2849 25.9302 24.3313 26.3841 24.2411C26.8379 24.1509 27.2547 23.9281 27.5819 23.6009C27.9091 23.2737 28.1319 22.8569 28.2221 22.403C28.3123 21.9492 28.2659 21.4788 28.0888 21.0514C27.9116 20.624 27.6117 20.2587 27.2269 20.0017C26.8421 19.7448 26.3897 19.6078 25.927 19.608C25.3072 19.6088 24.7129 19.8553 24.2747 20.2936C23.8364 20.7319 23.5898 21.3261 23.589 21.946ZM26.965 21.946C26.9648 22.151 26.9038 22.3513 26.7898 22.5217C26.6758 22.6921 26.5138 22.8249 26.3244 22.9032C26.1349 22.9816 25.9265 23.002 25.7254 22.962C25.5244 22.9219 25.3397 22.8232 25.1947 22.6782C25.0498 22.5333 24.951 22.3486 24.911 22.1475C24.8709 21.9465 24.8914 21.738 24.9698 21.5486C25.0481 21.3591 25.1809 21.1972 25.3513 21.0831C25.5216 20.9691 25.722 20.9082 25.927 20.908C26.2022 20.9082 26.4661 21.0177 26.6607 21.2123C26.8553 21.4069 26.9647 21.6708 26.965 21.946Z"\n  />\n  <path\n    d="M26.5549 24.991H25.2999C24.4778 24.991 23.6893 25.3176 23.1079 25.8989C22.5265 26.4803 22.2 27.2688 22.2 28.091V28.904L22.3999 29.096C23.4096 29.9341 24.688 30.3794 25.9999 30.35C26.6358 30.3764 27.2705 30.2762 27.8673 30.0551C28.464 29.834 29.0109 29.4964 29.476 29.062L29.6449 28.876V28.091C29.6449 27.2705 29.3197 26.4835 28.7405 25.9025C28.1613 25.3214 27.3754 24.9936 26.5549 24.991ZM28.3549 28.328C27.6736 28.8187 26.8493 29.0708 26.0099 29.045C25.1207 29.0598 24.2482 28.8019 23.5099 28.306V28.086C23.5113 27.6103 23.7008 27.1545 24.0371 26.8182C24.3735 26.4818 24.8293 26.2923 25.3049 26.291H26.5599C27.0365 26.291 27.4935 26.4799 27.831 26.8164C28.1684 27.1529 28.3586 27.6094 28.3599 28.086L28.3549 28.328Z"\n  />\n  <path\n    d="M6.31293 15.638H14.9999V17.969H16.2999V15.638H25.683V17.969H26.9829V14.339H16.2999V11.888H14.9999V14.339H5.00793V17.969H6.30795L6.31293 15.638Z"\n  />\n</svg>\n';
const __vite_glob_0_194 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.937 10.6C17.5944 10.6 18.2434 10.4534 18.837 10.171L18.282 8.99599C17.5974 9.32007 16.819 9.38726 16.089 9.18533C15.3589 8.98341 14.7258 8.52581 14.305 7.89598H16.621V6.59598H13.812C13.7847 6.4407 13.769 6.28361 13.765 6.12599C13.7688 5.96633 13.7848 5.80718 13.813 5.64998H17.093V4.34999H14.31C14.7322 3.72322 15.365 3.26845 16.0937 3.06812C16.8224 2.86778 17.5987 2.93514 18.282 3.25798L18.837 2.08298C18.2959 1.82713 17.7087 1.68287 17.1107 1.65881C16.5126 1.63476 15.9157 1.7314 15.3558 1.94296C14.7959 2.15453 14.2843 2.47669 13.8515 2.89023C13.4188 3.30377 13.0738 3.80023 12.837 4.34999H11.437V5.64998H12.513C12.4884 5.80766 12.4724 5.96657 12.465 6.12599C12.4725 6.28337 12.4882 6.44023 12.512 6.59598H11.437V7.89598H12.837C13.1825 8.69728 13.7546 9.38014 14.483 9.86055C15.2114 10.341 16.0644 10.598 16.937 10.6Z"\n  />\n  <path\n    d="M13.661 21.946C13.6608 22.4086 13.7978 22.861 14.0547 23.2457C14.3116 23.6305 14.6768 23.9304 15.1042 24.1076C15.5316 24.2848 16.0019 24.3313 16.4557 24.2411C16.9095 24.151 17.3263 23.9283 17.6536 23.6012C17.9808 23.2742 18.2036 22.8574 18.294 22.4037C18.3843 21.9499 18.338 21.4796 18.161 21.0521C17.984 20.6247 17.6843 20.2593 17.2996 20.0022C16.9149 19.7452 16.4627 19.608 16 19.608C15.3801 19.6088 14.7858 19.8553 14.3473 20.2936C13.9089 20.7318 13.6621 21.326 13.661 21.946Z"\n  />\n  <path\n    d="M16.628 24.991H15.372C14.5498 24.991 13.7613 25.3176 13.1799 25.8989C12.5986 26.4803 12.272 27.2688 12.272 28.091V28.904L12.472 29.096C13.4816 29.9341 14.7601 30.3794 16.072 30.35C16.708 30.3766 17.3429 30.2764 17.9398 30.0553C18.5368 29.8341 19.0838 29.4965 19.549 29.062L19.719 28.876V28.091C19.719 27.2704 19.3936 26.4832 18.8142 25.9021C18.2348 25.321 17.4486 24.9933 16.628 24.991Z"\n  />\n  <path\n    d="M6.073 24.284C6.53537 24.2838 6.98729 24.1465 7.37164 23.8895C7.75599 23.6324 8.05553 23.2672 8.23233 22.84C8.40913 22.4128 8.45529 21.9427 8.36496 21.4892C8.27463 21.0358 8.05187 20.6193 7.72485 20.2924C7.39784 19.9655 6.98124 19.743 6.52774 19.6528C6.07424 19.5627 5.60422 19.6091 5.17706 19.786C4.74991 19.963 4.38482 20.2627 4.12796 20.6472C3.8711 21.0316 3.73401 21.4836 3.73401 21.946C3.7348 22.566 3.98151 23.1604 4.42001 23.5987C4.85852 24.037 5.45299 24.2834 6.073 24.284Z"\n  />\n  <path\n    d="M6.69998 24.991H5.44498C4.62281 24.991 3.83429 25.3176 3.25293 25.8989C2.67157 26.4803 2.34497 27.2688 2.34497 28.091V28.904L2.54498 29.096C3.55436 29.9347 4.83296 30.3801 6.14496 30.35C6.78097 30.3766 7.41592 30.2764 8.01285 30.0553C8.60978 29.8341 9.15678 29.4965 9.62198 29.062L9.79095 28.876V28.091C9.79096 27.2704 9.46562 26.4832 8.8862 25.9021C8.30678 25.321 7.52059 24.9933 6.69998 24.991Z"\n  />\n  <path\n    d="M23.589 21.946C23.5888 22.4087 23.7259 22.861 23.9828 23.2458C24.2397 23.6306 24.605 23.9306 25.0324 24.1077C25.4599 24.2849 25.9302 24.3313 26.3841 24.2411C26.8379 24.1509 27.2547 23.9281 27.5819 23.6009C27.9091 23.2737 28.1319 22.8569 28.2221 22.403C28.3123 21.9492 28.2659 21.4788 28.0888 21.0514C27.9116 20.624 27.6117 20.2587 27.2269 20.0017C26.8421 19.7448 26.3897 19.6078 25.927 19.608C25.3072 19.6088 24.7129 19.8553 24.2747 20.2936C23.8364 20.7319 23.5898 21.3261 23.589 21.946Z"\n  />\n  <path\n    d="M26.5549 24.991H25.2999C24.4778 24.991 23.6893 25.3176 23.1079 25.8989C22.5265 26.4803 22.2 27.2688 22.2 28.091V28.904L22.3999 29.096C23.4096 29.9341 24.688 30.3794 25.9999 30.35C26.6358 30.3764 27.2705 30.2762 27.8673 30.0551C28.464 29.834 29.0109 29.4964 29.476 29.062L29.6449 28.876V28.091C29.6449 27.2705 29.3197 26.4835 28.7405 25.9025C28.1613 25.3214 27.3754 24.9936 26.5549 24.991Z"\n  />\n  <path\n    d="M6.31293 15.638H14.9999V17.969H16.2999V15.638H25.683V17.969H26.9829V14.339H16.2999V11.888H14.9999V14.339H5.00793V17.969H6.30795L6.31293 15.638Z"\n  />\n</svg>\n';
const __vite_glob_0_195 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.01101 9.5H14.5305L17.7554 15.7495L14.5182 21.5H7.02333L3.78613 15.7495L7.01101 9.5ZM7.62028 10.5L4.92208 15.7288L7.60796 20.5H13.9336L16.6195 15.7288L13.9213 10.5H7.62028Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M21.7292 16H17.1875V15H29.1458V21H28.1458V16H25.9375V18.7083H24.9375V16H22.7292V20.0833H21.7292V16Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M10.7707 17.25C11.7372 17.25 12.5207 16.4665 12.5207 15.5C12.5207 14.5335 11.7372 13.75 10.7707 13.75C9.80423 13.75 9.02073 14.5335 9.02073 15.5C9.02073 16.4665 9.80423 17.25 10.7707 17.25ZM10.7707 18.25C12.2895 18.25 13.5207 17.0188 13.5207 15.5C13.5207 13.9812 12.2895 12.75 10.7707 12.75C9.25195 12.75 8.02073 13.9812 8.02073 15.5C8.02073 17.0188 9.25195 18.25 10.7707 18.25Z"\n  />\n</svg>\n';
const __vite_glob_0_196 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M12.5208 15.5C12.5208 16.4665 11.7373 17.25 10.7708 17.25C9.80426 17.25 9.02075 16.4665 9.02075 15.5C9.02075 14.5335 9.80426 13.75 10.7708 13.75C11.7373 13.75 12.5208 14.5335 12.5208 15.5Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M14.5305 9.5H7.01101L3.78613 15.7495L7.02333 21.5H14.5182L17.7554 15.7495L14.5305 9.5ZM13.5208 15.5C13.5208 17.0188 12.2895 18.25 10.7708 18.25C9.25197 18.25 8.02075 17.0188 8.02075 15.5C8.02075 13.9812 9.25197 12.75 10.7708 12.75C12.2895 12.75 13.5208 13.9812 13.5208 15.5Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M21.7292 16H17.1875V15H29.1458V21H28.1458V16H25.9375V18.7083H24.9375V16H22.7292V20.0833H21.7292V16Z"\n  />\n</svg>\n';
const __vite_glob_0_197 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M32 32v-9.407h-1.475v-5.799h-2.553c0 .749.068 2.134.068 3.405h-1.475c-.069-1.702-.069-2.78-.069-3.473H24v5.402h-1.487v-5.436h-4.539l-4.187 7.251h-9.18L0 16l4.607-7.943h9.18l4.199 7.194H32V0v32zM12.959 9.532l-7.501-.034L1.702 16l3.756 6.502h7.501L16.715 16l-3.756-6.468zM9.248 19.96c-1.056.009-2.072-.404-2.822-1.148-.75-.743-1.172-1.756-1.172-2.812 0-2.183 1.766-3.954 3.949-3.96 2.183-.006 3.959 1.755 3.971 3.938.013 2.182-1.743 3.964-3.926 3.982zm0-6.434c-.664-.012-1.305.243-1.778.709-.474.465-.741 1.101-.741 1.765 0 1.36 1.099 2.465 2.459 2.473 1.36.008 2.472-1.083 2.488-2.443.017-1.36-1.068-2.479-2.428-2.504z"\n  />\n</svg>\n';
const __vite_glob_0_198 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M26.193 4.48H5.80701C5.10425 4.48053 4.43043 4.75987 3.93341 5.2567C3.4364 5.75353 3.1568 6.42725 3.15601 7.13V24.87C3.1568 25.5727 3.4364 26.2465 3.93341 26.7433C4.43043 27.2401 5.10425 27.5195 5.80701 27.52H26.193C26.8957 27.5195 27.5696 27.2401 28.0666 26.7433C28.5636 26.2465 28.8432 25.5727 28.844 24.87V7.13C28.8432 6.42725 28.5636 5.75353 28.0666 5.2567C27.5696 4.75987 26.8957 4.48053 26.193 4.48ZM5.80701 5.78H26.193C26.551 5.78026 26.8942 5.92259 27.1473 6.1757C27.4004 6.42882 27.5427 6.77204 27.543 7.13V11.668H4.457V7.13C4.45727 6.77204 4.59957 6.42882 4.85269 6.1757C5.10581 5.92259 5.44905 5.78026 5.80701 5.78ZM4.457 24.87V12.97H10.757V26.22H5.802C5.44491 26.2184 5.10296 26.0755 4.85092 25.8225C4.59888 25.5696 4.45726 25.2271 4.457 24.87ZM26.193 26.22H12.062V12.968H27.543V24.868C27.5431 25.0454 27.5083 25.2211 27.4406 25.3851C27.3728 25.549 27.2734 25.698 27.148 25.8236C27.0227 25.9491 26.8738 26.0488 26.7099 26.1168C26.5461 26.1848 26.3704 26.2199 26.193 26.22Z"\n  />\n</svg>\n';
const __vite_glob_0_199 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M 26 6 L 6 15.21875 L 6 16.78125 L 26 26 L 26 23.84375 L 9.46875 16 L 26 8.15625 Z"\n  />\n</svg>\n';
const __vite_glob_0_200 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M15.9288 20.4138L3.82872 8.31373C3.41034 7.89542 2.73206 7.89542 2.31369 8.31373C1.89544 8.73217 1.89544 9.41039 2.31369 9.82876L15.1712 22.6863C15.5896 23.1046 16.2679 23.1046 16.6863 22.6863L29.5438 9.82876C29.9549 9.40311 29.9431 8.72482 29.5175 8.31373C29.1022 7.91275 28.444 7.91275 28.0288 8.31373L15.9288 20.4138Z"\n  />\n</svg>\n';
const __vite_glob_0_201 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.0046 19.6034L7.31352 10.7301C7.01301 10.4233 6.52582 10.4233 6.22531 10.7301C5.9249 11.0369 5.9249 11.5343 6.22531 11.8411L15.4605 21.27C15.761 21.5767 16.2482 21.5767 16.5487 21.27L25.784 11.8411C26.0792 11.5289 26.0708 11.0315 25.765 10.7301C25.4668 10.436 24.994 10.436 24.6958 10.7301L16.0046 19.6034Z"\n    fill="#34323A"\n  />\n</svg>\n';
const __vite_glob_0_202 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M11.5862 15.9288L23.6863 3.82872C24.1046 3.41034 24.1046 2.73206 23.6863 2.31369C23.2678 1.89544 22.5896 1.89544 22.1712 2.31369L9.31369 15.1712C8.89544 15.5896 8.89544 16.2679 9.31369 16.6863L22.1712 29.5438C22.5969 29.9549 23.2752 29.9431 23.6863 29.5175C24.0872 29.1022 24.0872 28.444 23.6863 28.0288L11.5862 15.9288Z"\n  />\n</svg>\n';
const __vite_glob_0_203 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M21.4138 15.9158L9.31373 28.0159C8.89542 28.4343 8.89542 29.1125 9.31373 29.5309C9.73217 29.9492 10.4104 29.9492 10.8288 29.5309L23.6863 16.6734C24.1046 16.255 24.1046 15.5767 23.6863 15.1583L10.8288 2.30077C10.4031 1.88968 9.72482 1.90148 9.31373 2.32714C8.91275 2.74237 8.91275 3.40063 9.31373 3.8158L21.4138 15.9158Z"\n  />\n</svg>\n';
const __vite_glob_0_204 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M15.9158 10.5862L28.0159 22.6863C28.4342 23.1046 29.1125 23.1046 29.5309 22.6863C29.9492 22.2678 29.9492 21.5896 29.5309 21.1712L16.6734 8.31369C16.255 7.89544 15.5767 7.89544 15.1583 8.31369L2.30076 21.1712C1.88967 21.5969 1.90147 22.2752 2.32713 22.6863C2.74236 23.0872 3.40062 23.0872 3.81579 22.6863L15.9158 10.5862Z"\n  />\n</svg>\n';
const __vite_glob_0_205 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M26.606 6.796l-1.402-1.402-2.469 2.469a6.415 6.415 0 00-3.718-1.22 6.309 6.309 0 00-4.48 1.86l-6.095 6.095a6.324 6.324 0 00-.64 8.198l-2.408 2.408 1.402 1.402 2.469-2.469a6.415 6.415 0 003.718 1.22 6.309 6.309 0 004.48-1.86l6.095-6.095a6.323 6.323 0 00.64-8.198l2.408-2.408zm-3.23 6.187a4.31 4.31 0 01-1.28 3.047L16 22.127a4.312 4.312 0 01-3.048 1.28 4.358 4.358 0 01-2.285-.701l2.346-2.332-1.402-1.402-2.316 2.362a4.358 4.358 0 01-.67-2.3 4.312 4.312 0 011.28-3.048L16 9.89a4.311 4.311 0 013.048-1.28 4.266 4.266 0 012.285.685l-2.362 2.332 1.402 1.402 2.332-2.362c.441.691.674 1.495.67 2.316z"\n  />\n</svg>\n';
const __vite_glob_0_206 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M20.373 13.029l-1.402-1.402 2.362-2.332a4.267 4.267 0 00-2.285-.67A4.312 4.312 0 0016 9.905L9.905 16a4.311 4.311 0 00-1.28 3.048c.007.809.239 1.6.67 2.285l2.332-2.346 1.402 1.402-2.362 2.316c.689.434 1.486.666 2.3.67a4.31 4.31 0 003.048-1.28L22.11 16a4.312 4.312 0 001.28-3.048 4.267 4.267 0 00-.685-2.285l-2.332 2.362z"\n    fill="currentColor"\n  />\n  <path\n    d="M28.952 0H3.048A3.048 3.048 0 000 3.048v25.904A3.048 3.048 0 003.048 32h25.904A3.048 3.048 0 0032 28.952V3.048A3.048 3.048 0 0028.952 0zm-5.455 17.463l-6.095 6.095a6.31 6.31 0 01-4.48 1.86 6.415 6.415 0 01-3.718-1.22l-2.408 2.408-1.402-1.402 2.469-2.469a6.324 6.324 0 01.64-8.198l6.095-6.095a6.308 6.308 0 014.48-1.86 6.415 6.415 0 013.718 1.22l2.469-2.469 1.402 1.402-2.53 2.53a6.324 6.324 0 01-.64 8.198z"\n    fill="currentColor"\n  />\n</svg>\n';
const __vite_glob_0_207 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M26.606 6.796l-1.402-1.402-2.469 2.469a6.415 6.415 0 00-3.718-1.22 6.309 6.309 0 00-4.48 1.86l-6.095 6.095a6.324 6.324 0 00-.64 8.198l-2.408 2.408 1.402 1.402 2.469-2.469a6.415 6.415 0 003.718 1.22 6.309 6.309 0 004.48-1.86l6.095-6.095a6.323 6.323 0 00.64-8.198l2.408-2.408zm-3.23 6.187a4.31 4.31 0 01-1.28 3.047L16 22.127a4.312 4.312 0 01-3.048 1.28 4.358 4.358 0 01-2.285-.701l2.346-2.332-1.402-1.402-2.316 2.362a4.358 4.358 0 01-.67-2.3 4.312 4.312 0 011.28-3.048L16 9.89a4.311 4.311 0 013.048-1.28 4.266 4.266 0 012.285.685l-2.362 2.332 1.402 1.402 2.332-2.362c.441.691.674 1.495.67 2.316z"\n  />\n</svg>\n';
const __vite_glob_0_208 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M30.288 15.35H26.245C26.0826 13.8084 25.3557 12.3815 24.2042 11.3437C23.0528 10.306 21.5581 9.73084 20.008 9.729H12.27C10.7198 9.73059 9.22489 10.3056 8.07321 11.3434C6.92154 12.3811 6.1945 13.8083 6.03204 15.35H1.71204V16.65H6.03204C6.1945 18.1917 6.92154 19.6189 8.07321 20.6566C9.22489 21.6944 10.7198 22.2694 12.27 22.271H20.008C21.5581 22.2692 23.0528 21.694 24.2042 20.6563C25.3557 19.6185 26.0826 18.1916 26.245 16.65H30.288V15.35ZM20.008 20.972H12.27C11.0684 20.967 9.90943 20.5262 9.00827 19.7313C8.10711 18.9365 7.525 17.8416 7.37003 16.65H11.59V15.35H7.37003C7.525 14.1584 8.10711 13.0635 9.00827 12.2687C9.90943 11.4738 11.0684 11.033 12.27 11.028H20.008C21.2096 11.033 22.3686 11.4738 23.2698 12.2687C24.1709 13.0635 24.753 14.1584 24.908 15.35H20.966V16.65H24.908C24.753 17.8416 24.1709 18.9365 23.2698 19.7313C22.3686 20.5262 21.2096 20.967 20.008 20.972Z"\n  />\n</svg>\n';
const __vite_glob_0_209 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path d="M24.925 8L13.1479 8.02355L13.152 10.0428L24.929 10.0193L24.925 8Z" />\n  <path\n    d="M10.4747 8.02904L7 8.03599L7.00404 10.0553L10.4787 10.0483L10.4747 8.02904Z"\n  />\n  <path\n    d="M24.9389 14.9557L13.1635 14.9807L13.1678 17L24.9432 16.9749L24.9389 14.9557Z"\n  />\n  <path\n    d="M10.4902 14.9871L7.0155 14.9947L7.01991 17.014L10.4946 17.0064L10.4902 14.9871Z"\n  />\n  <path\n    d="M24.9529 21.9144L13.1775 21.9395L13.1818 23.9587L24.9572 23.9336L24.9529 21.9144Z"\n  />\n  <path\n    d="M10.5042 21.945L7.02954 21.9519L7.03352 23.9712L10.5082 23.9643L10.5042 21.945Z"\n  />\n</svg>\n';
const __vite_glob_0_210 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 25.419C15.8947 25.4191 15.791 25.3935 15.6978 25.3446C15.6046 25.2956 15.5247 25.2247 15.465 25.138C15.187 24.738 8.64001 15.189 8.64001 11.326C8.64001 9.374 9.41542 7.50196 10.7957 6.1217C12.176 4.74143 14.048 3.966 16 3.966C17.952 3.966 19.824 4.74143 21.2043 6.1217C22.5846 7.50196 23.36 9.374 23.36 11.326C23.36 15.189 16.813 24.733 16.535 25.138C16.4753 25.2247 16.3954 25.2956 16.3022 25.3446C16.209 25.3935 16.1053 25.4191 16 25.419ZM16 5.266C14.3933 5.26759 12.8528 5.90656 11.7167 7.04269C10.5805 8.17881 9.94159 9.71927 9.94 11.326C9.94 13.951 13.915 20.472 16 23.608C18.085 20.472 22.06 13.951 22.06 11.326C22.0584 9.71927 21.4195 8.17881 20.2833 7.04269C19.1472 5.90656 17.6067 5.26759 16 5.266Z"\n  />\n  <path\n    d="M16 14.981C15.2771 14.981 14.5704 14.7666 13.9694 14.365C13.3683 13.9634 12.8998 13.3926 12.6232 12.7247C12.3466 12.0568 12.2742 11.3219 12.4152 10.6129C12.5562 9.90394 12.9043 9.25268 13.4155 8.74152C13.9267 8.23036 14.5779 7.88225 15.2869 7.74122C15.9959 7.60019 16.7308 7.67258 17.3987 7.94921C18.0666 8.22585 18.6374 8.69432 19.039 9.29538C19.4406 9.89644 19.655 10.6031 19.655 11.326C19.6539 12.295 19.2685 13.2241 18.5833 13.9093C17.8981 14.5945 16.969 14.9799 16 14.981ZM16 8.971C15.5342 8.9708 15.0787 9.10875 14.6913 9.3674C14.3039 9.62605 14.0019 9.99378 13.8235 10.4241C13.6451 10.8544 13.5983 11.3279 13.6891 11.7848C13.7798 12.2417 14.0041 12.6614 14.3334 12.9909C14.6627 13.3203 15.0823 13.5447 15.5392 13.6357C15.996 13.7266 16.4696 13.68 16.9 13.5018C17.3303 13.3236 17.6982 13.0218 17.957 12.6345C18.2158 12.2472 18.354 11.7918 18.354 11.326C18.3537 10.7017 18.1057 10.103 17.6643 9.6614C17.2229 9.21984 16.6243 8.97153 16 8.971Z"\n  />\n  <path\n    d="M16 28.034C12.577 28.034 6.78296 27.442 6.78296 25.221C6.78296 23.688 9.52696 22.99 11.83 22.674L12.006 23.962C8.97898 24.377 8.13996 25.078 8.08096 25.243C8.27196 25.735 11.161 26.734 16 26.734C20.839 26.734 23.728 25.734 23.919 25.199C23.86 25.078 23.019 24.377 19.994 23.962L20.17 22.674C22.47 22.99 25.217 23.688 25.217 25.221C25.217 27.442 19.423 28.034 16 28.034Z"\n  />\n</svg>\n';
const __vite_glob_0_211 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 28.034C12.577 28.034 6.78296 27.442 6.78296 25.221C6.78296 23.688 9.52696 22.99 11.83 22.674L12.006 23.962C8.97898 24.377 8.13996 25.078 8.08096 25.243C8.27196 25.735 11.161 26.734 16 26.734C20.839 26.734 23.728 25.734 23.919 25.199C23.86 25.078 23.019 24.377 19.994 23.962L20.17 22.674C22.47 22.99 25.217 23.688 25.217 25.221C25.217 27.442 19.423 28.034 16 28.034Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M15.6978 25.3446C15.791 25.3935 15.8947 25.4191 16 25.419C16.1053 25.4191 16.209 25.3935 16.3022 25.3446C16.3954 25.2956 16.4753 25.2247 16.535 25.138C16.813 24.733 23.36 15.189 23.36 11.326C23.36 9.374 22.5846 7.50196 21.2043 6.1217C19.824 4.74143 17.952 3.966 16 3.966C14.048 3.966 12.176 4.74143 10.7957 6.1217C9.41542 7.50196 8.64001 9.374 8.64001 11.326C8.64001 15.189 15.187 24.738 15.465 25.138C15.5247 25.2247 15.6046 25.2956 15.6978 25.3446ZM13.9694 14.365C14.5704 14.7666 15.2771 14.981 16 14.981C16.969 14.9799 17.8981 14.5945 18.5833 13.9093C19.2685 13.2241 19.6539 12.295 19.655 11.326C19.655 10.6031 19.4406 9.89644 19.039 9.29538C18.6374 8.69432 18.0666 8.22585 17.3987 7.94921C16.7308 7.67257 15.9959 7.60019 15.2869 7.74122C14.5779 7.88225 13.9267 8.23036 13.4155 8.74152C12.9043 9.25268 12.5562 9.90394 12.4152 10.6129C12.2742 11.3219 12.3466 12.0568 12.6232 12.7247C12.8998 13.3926 13.3683 13.9634 13.9694 14.365ZM14.6913 9.3674C15.0787 9.10875 15.5342 8.9708 16 8.97099C16.6243 8.97153 17.2229 9.21984 17.6643 9.6614C18.1057 10.103 18.3537 10.7017 18.354 11.326C18.354 11.7918 18.2158 12.2472 17.957 12.6345C17.6982 13.0218 17.3303 13.3236 16.9 13.5018C16.4696 13.68 15.996 13.7266 15.5392 13.6357C15.0823 13.5447 14.6627 13.3203 14.3334 12.9909C14.0041 12.6614 13.7798 12.2417 13.6891 11.7848C13.5983 11.3279 13.6451 10.8544 13.8235 10.4241C14.0019 9.99378 14.3039 9.62605 14.6913 9.3674Z"\n  />\n</svg>\n';
const __vite_glob_0_212 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 17 17"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n  stroke="currentColor"\n>\n  <ellipse\n    cx="6.5"\n    cy="7.2"\n    rx="5.5"\n    ry="5.5"\n    stroke-width="0.8"\n    fill="transparent"\n  />\n  <line x1="12.457" y1="13.117" x2="16.051" y2="16.767" stroke-width="0.8" />\n  <path\n    d="M10.5,7.2H9.7c0-1.7-1.4-3.1-3.2-3.1V3.3C8.7,3.3,10.5,5,10.5,7.2z"\n    stroke-width="0.025"\n  />\n</svg>\n';
const __vite_glob_0_213 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.8109 12.92C27.7999 12.911 27.7849 12.907 27.7729 12.899V12.894L24.3729 10.034V5.26301C24.3729 5.09062 24.3045 4.92529 24.1826 4.80339C24.0607 4.68149 23.8953 4.61301 23.7229 4.61301H8.26995C8.09756 4.61301 7.93223 4.68149 7.81033 4.80339C7.68843 4.92529 7.61995 5.09062 7.61995 5.26301V10.034L4.21995 12.894C3.94188 13.1083 3.71631 13.3831 3.56036 13.6976C3.40441 14.0121 3.32219 14.358 3.31995 14.709V25.017C3.33853 25.6622 3.61208 26.2737 4.08068 26.7175C4.54928 27.1614 5.17471 27.4014 5.81995 27.385H26.1699C26.8152 27.4014 27.4406 27.1614 27.9092 26.7175C28.3778 26.2737 28.6514 25.6622 28.6699 25.017V14.711C28.6684 14.3675 28.5906 14.0286 28.442 13.7188C28.2934 13.4091 28.0779 13.1362 27.8109 12.92ZM26.3549 13.396L24.3799 14.884V11.733L26.3549 13.396ZM23.0809 5.91301V15.863L15.9999 21.2L8.91795 15.824V5.91501L23.0809 5.91301ZM7.61995 14.836L5.68095 13.365L7.61995 11.733V14.836ZM27.3749 25.019C27.3561 25.3193 27.2195 25.6 26.9947 25.8C26.77 26 26.4754 26.1032 26.1749 26.087H5.82495C5.52452 26.1032 5.22988 26 5.00514 25.8C4.78041 25.6 4.64376 25.3193 4.62495 25.019V14.711C4.62514 14.5591 4.66111 14.4094 4.72995 14.274L15.6069 22.53C15.7198 22.6153 15.8574 22.6615 15.9989 22.6615C16.1404 22.6615 16.2781 22.6153 16.3909 22.53L27.2909 14.315C27.346 14.4391 27.3742 14.5733 27.3739 14.709L27.3749 25.019Z"\n  />\n  <path d="M20.295 8.04901H11.705V9.34901H20.295V8.04901Z" />\n  <path d="M20.295 11.485H11.705V12.785H20.295V11.485Z" />\n  <path d="M20.295 14.92H11.705V16.22H20.295V14.92Z" />\n</svg>\n';
const __vite_glob_0_214 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M27.7901 12.908C27.7975 12.9115 27.8049 12.915 27.8111 12.92C28.078 13.1362 28.2936 13.4091 28.4421 13.7188C28.5907 14.0286 28.6685 14.3675 28.6701 14.711V25.017C28.6515 25.6622 28.3779 26.2737 27.9093 26.7175C27.4407 27.1614 26.8153 27.4014 26.1701 27.385H5.82007C5.17484 27.4014 4.54941 27.1614 4.08081 26.7175C3.61221 26.2737 3.33865 25.6622 3.32007 25.017V14.709C3.32232 14.358 3.40454 14.0121 3.56048 13.6976C3.71643 13.3831 3.94201 13.1083 4.22007 12.894L7.62007 10.034V5.26301C7.62007 5.09062 7.68855 4.92529 7.81045 4.80339C7.93235 4.68149 8.09768 4.61301 8.27007 4.61301H23.7231C23.8955 4.61301 24.0608 4.68149 24.1827 4.80339C24.3046 4.92529 24.3731 5.09062 24.3731 5.26301V10.034L27.7731 12.894V12.899C27.7784 12.9025 27.7842 12.9053 27.7901 12.908ZM24.3801 14.884L26.3551 13.396L24.3801 11.733V14.884ZM5.68107 13.365L7.62007 14.836V11.733L5.68107 13.365ZM26.9949 25.8C27.2196 25.6 27.3563 25.3193 27.3751 25.019L27.3741 14.709C27.3744 14.5733 27.3461 14.4391 27.2911 14.315L16.3911 22.53C16.2782 22.6153 16.1406 22.6615 15.9991 22.6615C15.8576 22.6615 15.7199 22.6153 15.6071 22.53L4.73007 14.274C4.66123 14.4094 4.62526 14.5591 4.62507 14.711V25.019C4.64388 25.3193 4.78053 25.6 5.00527 25.8C5.23001 26 5.52465 26.1032 5.82507 26.087H26.1751C26.4755 26.1032 26.7701 26 26.9949 25.8ZM11.7051 8.04901H20.2951V9.34901H11.7051V8.04901ZM11.7051 11.485H20.2951V12.785H11.7051V11.485ZM20.2951 14.92H11.7051V16.22H20.2951V14.92Z"\n  />\n</svg>\n';
const __vite_glob_0_215 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M15.988 19.129C15.5023 19.1292 15.0275 19.2734 14.6237 19.5434C14.22 19.8134 13.9054 20.197 13.7196 20.6458C13.5339 21.0946 13.4854 21.5884 13.5803 22.0648C13.6752 22.5411 13.9091 22.9786 14.2526 23.322C14.5962 23.6654 15.0338 23.8992 15.5102 23.9939C15.9866 24.0886 16.4803 24.0399 16.9291 23.854C17.3778 23.668 17.7613 23.3532 18.0311 22.9494C18.3009 22.5455 18.445 22.0707 18.445 21.585C18.4442 20.9337 18.185 20.3093 17.7244 19.8489C17.2637 19.3884 16.6393 19.1295 15.988 19.129ZM15.988 22.741C15.7594 22.7408 15.536 22.6728 15.346 22.5457C15.156 22.4186 15.008 22.2379 14.9207 22.0267C14.8333 21.8154 14.8106 21.583 14.8553 21.3589C14.9 21.1347 15.0102 20.9288 15.1719 20.7672C15.3336 20.6057 15.5396 20.4957 15.7638 20.4511C15.988 20.4066 16.2204 20.4296 16.4316 20.5171C16.6427 20.6046 16.8232 20.7528 16.9502 20.9429C17.0772 21.133 17.1449 21.3564 17.1449 21.585C17.1449 21.7369 17.115 21.8873 17.0569 22.0276C16.9987 22.1679 16.9135 22.2954 16.806 22.4028C16.6986 22.5101 16.571 22.5953 16.4306 22.6533C16.2903 22.7113 16.1399 22.7411 15.988 22.741Z"\n  />\n  <path\n    d="M15.988 6.686C16.474 6.6862 16.9491 6.54226 17.3533 6.2724C17.7575 6.00254 18.0725 5.61889 18.2587 5.16995C18.4448 4.72101 18.4936 4.22695 18.3989 3.75027C18.3042 3.2736 18.0703 2.8357 17.7267 2.49199C17.3831 2.14827 16.9453 1.91417 16.4687 1.81929C15.9921 1.7244 15.498 1.773 15.049 1.95894C14.5999 2.14487 14.2161 2.45979 13.9461 2.86386C13.6761 3.26793 13.532 3.74301 13.532 4.229C13.5328 4.88022 13.7917 5.50456 14.2521 5.96513C14.7125 6.42571 15.3368 6.68494 15.988 6.686ZM15.988 3.073C16.2169 3.0726 16.4409 3.14015 16.6314 3.26709C16.822 3.39402 16.9706 3.57463 17.0584 3.78607C17.1463 3.99751 17.1694 4.23027 17.1249 4.45486C17.0804 4.67946 16.9703 4.88579 16.8084 5.04776C16.6466 5.20973 16.4404 5.32005 16.2158 5.36474C15.9913 5.40944 15.7585 5.38649 15.547 5.29883C15.3355 5.21116 15.1547 5.06271 15.0276 4.87227C14.9005 4.68182 14.8328 4.45796 14.833 4.229C14.8335 3.92275 14.9553 3.62917 15.1718 3.41252C15.3882 3.19587 15.6817 3.07379 15.988 3.073Z"\n  />\n  <path\n    d="M27.0639 14.365C27.5497 14.365 28.0245 14.221 28.4284 13.9511C28.8323 13.6812 29.1471 13.2977 29.3329 12.8489C29.5188 12.4001 29.5675 11.9063 29.4727 11.4299C29.378 10.9534 29.144 10.5158 28.8006 10.1723C28.4571 9.82887 28.0195 9.59496 27.5431 9.5002C27.0666 9.40543 26.5728 9.45406 26.124 9.63995C25.6752 9.82584 25.2917 10.1406 25.0218 10.5445C24.752 10.9484 24.6079 11.4232 24.6079 11.909C24.6087 12.5601 24.8677 13.1844 25.3281 13.6448C25.7885 14.1052 26.4128 14.3642 27.0639 14.365ZM27.0639 10.753C27.2926 10.7528 27.5162 10.8204 27.7064 10.9473C27.8967 11.0742 28.045 11.2547 28.1326 11.4659C28.2203 11.6771 28.2433 11.9096 28.1988 12.1339C28.1543 12.3582 28.0443 12.5643 27.8827 12.7261C27.7211 12.8878 27.5151 12.998 27.2908 13.0427C27.0665 13.0874 26.8341 13.0646 26.6228 12.9771C26.4115 12.8896 26.2309 12.7415 26.1038 12.5513C25.9767 12.3612 25.9089 12.1377 25.9089 11.909C25.9092 11.6027 26.0309 11.3089 26.2474 11.0922C26.464 10.8755 26.7576 10.7535 27.0639 10.753Z"\n  />\n  <path\n    d="M4.9859 14.365C5.47165 14.365 5.94652 14.221 6.3504 13.9511C6.75429 13.6812 7.06906 13.2977 7.25494 12.8489C7.44083 12.4001 7.48948 11.9063 7.39471 11.4299C7.29995 10.9534 7.06604 10.5158 6.72256 10.1723C6.37909 9.82887 5.94147 9.59496 5.46506 9.5002C4.98864 9.40543 4.49483 9.45406 4.04605 9.63995C3.59728 9.82584 3.21369 10.1406 2.94382 10.5445C2.67395 10.9484 2.52991 11.4232 2.52991 11.909C2.53044 12.5602 2.78937 13.1846 3.24985 13.6451C3.71032 14.1055 4.33469 14.3645 4.9859 14.365ZM4.9859 10.753C5.21458 10.7528 5.43818 10.8204 5.62842 10.9473C5.81865 11.0742 5.96698 11.2547 6.05463 11.4659C6.14227 11.6771 6.16531 11.9096 6.12082 12.1339C6.07633 12.3582 5.96632 12.5643 5.80469 12.7261C5.64306 12.8878 5.43707 12.998 5.2128 13.0427C4.98853 13.0874 4.75606 13.0646 4.54477 12.9771C4.33348 12.8896 4.15285 12.7415 4.02579 12.5513C3.89872 12.3612 3.8309 12.1377 3.8309 11.909C3.83117 11.6027 3.95291 11.3089 4.16943 11.0922C4.38595 10.8755 4.67957 10.7535 4.9859 10.753Z"\n  />\n  <path\n    d="M30.1199 18.245C30.1189 17.3933 29.78 16.5768 29.1776 15.9746C28.5753 15.3724 27.7587 15.0338 26.907 15.033H26.6069C25.8578 15.0476 25.1261 15.2624 24.4879 15.655L23.5249 11.355H20.7459C20.7417 10.318 20.3271 9.32491 19.5927 8.59277C18.8583 7.86064 17.8639 7.44905 16.8269 7.448H15.1469C14.1101 7.44931 13.116 7.86102 12.3818 8.59312C11.6477 9.32523 11.2332 10.3182 11.2289 11.355H8.44894L7.48993 15.641C6.85578 15.2567 6.13132 15.047 5.38995 15.033H5.08994C4.23821 15.0338 3.4216 15.3724 2.81924 15.9746C2.21689 16.5768 1.87801 17.3933 1.87695 18.245V25.268H5.33395L4.67892 28.194H11.2679C11.2464 28.3318 11.2324 28.4707 11.226 28.61V29.237H12.5259V28.61C12.5267 27.9156 12.8029 27.2498 13.2939 26.7586C13.7848 26.2675 14.4505 25.9911 15.1449 25.99H16.825C17.5194 25.9911 18.1851 26.2675 18.676 26.7586C19.167 27.2498 19.4431 27.9156 19.4439 28.61V29.577H20.7439V28.61C20.7375 28.4707 20.7235 28.3318 20.7019 28.194H27.2919L26.6369 25.268H30.1159L30.1199 18.245ZM15.1479 8.745H16.8279C17.5201 8.74578 18.1839 9.02035 18.6744 9.50877C19.1649 9.9972 19.4423 10.6598 19.446 11.352H12.5309C12.5352 10.6604 12.8126 9.99858 13.3029 9.51077C13.7931 9.02297 14.4564 8.74878 15.1479 8.748V8.745ZM3.18094 23.965V18.242C3.1812 17.735 3.38273 17.2488 3.74124 16.8903C4.09975 16.5318 4.58591 16.3303 5.09293 16.33H5.39294C6.05246 16.3495 6.6843 16.5993 7.17892 17.036L5.62793 23.965H3.18094ZM20.3359 26.892C20.0161 26.233 19.5178 25.677 18.8976 25.2872C18.2775 24.8974 17.5604 24.6895 16.8279 24.687H15.1479C14.4156 24.6895 13.6987 24.8975 13.0787 25.2873C12.4587 25.6771 11.9606 26.2331 11.6409 26.892H6.29993L9.48593 12.652H22.4799L25.6679 26.892H20.3359ZM28.8189 23.965H26.3499L24.8029 17.054C25.2982 16.607 25.9361 16.3504 26.6029 16.33H26.903C27.41 16.3303 27.8961 16.5318 28.2546 16.8903C28.6132 17.2488 28.8147 17.735 28.8149 18.242L28.8189 23.965Z"\n  />\n</svg>\n';
const __vite_glob_0_216 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M15.9879 6.686C16.4739 6.6862 16.949 6.54226 17.3532 6.2724C17.7574 6.00254 18.0725 5.61889 18.2586 5.16995C18.4447 4.72101 18.4935 4.22695 18.3988 3.75027C18.3041 3.2736 18.0702 2.8357 17.7266 2.49199C17.383 2.14827 16.9453 1.91417 16.4686 1.81929C15.992 1.7244 15.4979 1.773 15.0489 1.95894C14.5999 2.14487 14.2161 2.45979 13.946 2.86386C13.676 3.26793 13.5319 3.74301 13.5319 4.229C13.5327 4.88022 13.7917 5.50456 14.2521 5.96513C14.7125 6.42571 15.3367 6.68494 15.9879 6.686ZM15.9879 3.073C16.2169 3.0726 16.4408 3.14015 16.6313 3.26709C16.8219 3.39402 16.9705 3.57463 17.0583 3.78607C17.1462 3.99751 17.1693 4.23027 17.1248 4.45486C17.0803 4.67946 16.9702 4.88579 16.8084 5.04776C16.6466 5.20973 16.4403 5.32005 16.2158 5.36474C15.9912 5.40944 15.7584 5.38649 15.5469 5.29883C15.3354 5.21116 15.1547 5.06271 15.0276 4.87227C14.9005 4.68182 14.8327 4.45796 14.8329 4.229C14.8334 3.92275 14.9553 3.62917 15.1717 3.41252C15.3882 3.19587 15.6817 3.07379 15.9879 3.073Z"\n  />\n  <path\n    d="M27.064 14.365C27.5497 14.365 28.0245 14.221 28.4284 13.9511C28.8323 13.6812 29.1471 13.2977 29.333 12.8489C29.5189 12.4001 29.5675 11.9063 29.4728 11.4299C29.378 10.9534 29.1441 10.5158 28.8006 10.1723C28.4572 9.82887 28.0195 9.59496 27.5431 9.5002C27.0667 9.40543 26.5729 9.45406 26.1241 9.63995C25.6753 9.82584 25.2917 10.1406 25.0219 10.5445C24.752 10.9484 24.608 11.4232 24.608 11.909C24.6088 12.5601 24.8678 13.1844 25.3282 13.6448C25.7886 14.1052 26.4128 14.3642 27.064 14.365ZM27.064 10.753C27.2926 10.7528 27.5162 10.8204 27.7065 10.9473C27.8967 11.0742 28.045 11.2547 28.1327 11.4659C28.2203 11.6771 28.2434 11.9096 28.1989 12.1339C28.1544 12.3582 28.0444 12.5643 27.8828 12.7261C27.7211 12.8878 27.5151 12.998 27.2909 13.0427C27.0666 13.0874 26.8341 13.0646 26.6228 12.9771C26.4115 12.8896 26.2309 12.7415 26.1039 12.5513C25.9768 12.3612 25.909 12.1377 25.909 11.909C25.9092 11.6027 26.031 11.3089 26.2475 11.0922C26.464 10.8755 26.7576 10.7535 27.064 10.753Z"\n  />\n  <path\n    d="M4.98596 14.365C5.47171 14.365 5.94658 14.221 6.35046 13.9511C6.75435 13.6812 7.06912 13.2977 7.255 12.8489C7.44089 12.4001 7.48954 11.9063 7.39478 11.4299C7.30001 10.9534 7.0661 10.5158 6.72263 10.1723C6.37915 9.82887 5.94154 9.59496 5.46512 9.5002C4.9887 9.40543 4.49489 9.45406 4.04611 9.63995C3.59734 9.82584 3.21375 10.1406 2.94388 10.5445C2.67401 10.9484 2.52997 11.4232 2.52997 11.909C2.5305 12.5602 2.78943 13.1846 3.24991 13.6451C3.71038 14.1055 4.33475 14.3645 4.98596 14.365ZM4.98596 10.753C5.21464 10.7528 5.43824 10.8204 5.62848 10.9473C5.81871 11.0742 5.96704 11.2547 6.05469 11.4659C6.14234 11.6771 6.16537 11.9096 6.12088 12.1339C6.07639 12.3582 5.96638 12.5643 5.80475 12.7261C5.64312 12.8878 5.43713 12.998 5.21286 13.0427C4.98859 13.0874 4.75612 13.0646 4.54483 12.9771C4.33354 12.8896 4.15292 12.7415 4.02585 12.5513C3.89878 12.3612 3.83096 12.1377 3.83096 11.909C3.83123 11.6027 3.95298 11.3089 4.16949 11.0922C4.38601 10.8755 4.67963 10.7535 4.98596 10.753Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M29.1776 15.9746C29.78 16.5768 30.1189 17.3933 30.1199 18.245L30.1159 25.268H26.6369L27.2919 28.194H20.7019C20.7235 28.3318 20.7375 28.4707 20.7439 28.61V29.577H19.4439V28.61C19.4431 27.9156 19.167 27.2498 18.676 26.7586C18.1851 26.2675 17.5194 25.9911 16.825 25.99H15.1449C14.4505 25.9911 13.7848 26.2675 13.2939 26.7586C12.8029 27.2498 12.5267 27.9156 12.5259 28.61V29.237H11.226V28.61C11.2324 28.4707 11.2464 28.3318 11.2679 28.194H4.67892L5.33395 25.268H1.87695V18.245C1.87801 17.3933 2.21689 16.5768 2.81924 15.9746C3.4216 15.3724 4.23821 15.0338 5.08994 15.033H5.38995C6.13132 15.047 6.85578 15.2567 7.48993 15.641L8.44894 11.355H11.2289C11.2332 10.3182 11.6477 9.32523 12.3818 8.59312C13.116 7.86102 14.1101 7.44931 15.1469 7.448H16.8269C17.8639 7.44905 18.8583 7.86064 19.5927 8.59277C20.3271 9.32491 20.7417 10.318 20.7459 11.355H23.5249L24.4879 15.655C25.1261 15.2624 25.8578 15.0476 26.6069 15.033H26.907C27.7587 15.0338 28.5753 15.3724 29.1776 15.9746ZM16.8279 8.745H15.1479V8.748C14.4564 8.74878 13.7931 9.02297 13.3029 9.51077C12.8126 9.99858 12.5352 10.6604 12.5309 11.352H19.446C19.4423 10.6598 19.1649 9.9972 18.6744 9.50877C18.1839 9.02035 17.5201 8.74578 16.8279 8.745ZM3.18094 18.242V23.965H5.62793L7.17892 17.036C6.6843 16.5993 6.05246 16.3495 5.39294 16.33H5.09293C4.58591 16.3303 4.09975 16.5318 3.74124 16.8903C3.38273 17.2488 3.1812 17.735 3.18094 18.242ZM26.3499 23.965H28.8189L28.8149 18.242C28.8147 17.735 28.6132 17.2488 28.2546 16.8903C27.8961 16.5318 27.41 16.3303 26.903 16.33H26.6029C25.9361 16.3504 25.2982 16.607 24.8029 17.054L26.3499 23.965ZM14.6237 19.5434C15.0275 19.2734 15.5023 19.1292 15.988 19.129C16.6393 19.1295 17.2637 19.3884 17.7244 19.8489C18.185 20.3093 18.4442 20.9337 18.445 21.585C18.445 22.0707 18.3009 22.5455 18.0311 22.9494C17.7613 23.3532 17.3778 23.668 16.9291 23.854C16.4803 24.0399 15.9866 24.0886 15.5102 23.9939C15.0338 23.8992 14.5962 23.6654 14.2526 23.322C13.9091 22.9786 13.6752 22.5411 13.5803 22.0648C13.4854 21.5884 13.5339 21.0946 13.7196 20.6458C13.9054 20.197 14.22 19.8134 14.6237 19.5434ZM15.346 22.5457C15.536 22.6728 15.7594 22.7408 15.988 22.741C16.1399 22.7411 16.2903 22.7113 16.4306 22.6533C16.571 22.5953 16.6986 22.5101 16.806 22.4028C16.9135 22.2954 16.9987 22.1679 17.0569 22.0276C17.115 21.8873 17.1449 21.7369 17.1449 21.585C17.1449 21.3564 17.0772 21.133 16.9502 20.9429C16.8232 20.7528 16.6427 20.6046 16.4316 20.5171C16.2204 20.4296 15.988 20.4066 15.7638 20.4511C15.5396 20.4957 15.3336 20.6057 15.1719 20.7672C15.0102 20.9288 14.9 21.1347 14.8553 21.3589C14.8106 21.583 14.8333 21.8154 14.9207 22.0267C15.008 22.2379 15.156 22.4186 15.346 22.5457Z"\n  />\n</svg>\n';
const __vite_glob_0_217 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <rect x="14" y="8" width="3.65714" height="3.65714" rx="1.82857" />\n  <rect x="14" y="14.3999" width="3.65714" height="3.65714" rx="1.82857" />\n  <rect x="14" y="20.8" width="3.65714" height="3.65714" rx="1.82857" />\n</svg>\n';
const __vite_glob_0_218 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.4327 17.6584C27.1873 17.5969 26.942 17.6584 26.7273 17.8123C25.9298 18.4895 25.0097 19.0435 23.9975 19.4128C23.0467 19.7822 22.0039 19.9668 20.8998 19.9668C18.4154 19.9668 16.1457 18.9511 14.5202 17.3199C12.8946 15.6886 11.8825 13.411 11.8825 10.918C11.8825 9.87149 12.0665 8.85581 12.3732 7.93245C12.7106 6.94754 13.2013 6.05497 13.8454 5.28551C14.1215 4.94694 14.0601 4.45449 13.7227 4.17748C13.508 4.02359 13.2627 3.96203 13.0173 4.02359C10.4103 4.73149 8.14059 6.30119 6.51503 8.39413C4.9508 10.4563 4 13.0109 4 15.8117C4 19.1666 5.34953 22.2137 7.55784 24.4297C9.76616 26.6458 12.8026 28 16.1457 28C18.9675 28 21.5745 27.0151 23.6602 25.3838C25.7765 23.7218 27.31 21.3519 27.9541 18.6434C28.1075 18.1817 27.8621 17.7508 27.4327 17.6584ZM22.74 24.0911C20.9611 25.5069 18.6914 26.3687 16.2071 26.3687C13.2933 26.3687 10.6556 25.1684 8.75402 23.2601C6.85241 21.3519 5.65624 18.7049 5.65624 15.781C5.65624 13.3495 6.45369 11.1334 7.83388 9.34826C8.78469 8.11712 9.98086 7.10143 11.3611 6.39353C11.2077 6.73209 11.0543 7.07066 10.9317 7.44C10.5329 8.54802 10.3489 9.7176 10.3489 10.9487C10.3489 13.8727 11.5451 16.5504 13.4467 18.4587C15.3483 20.3669 18.0167 21.5673 20.9304 21.5673C22.2186 21.5673 23.4455 21.3519 24.5803 20.921C24.979 20.7671 25.3777 20.6132 25.7458 20.4285C25.0097 21.8443 23.9975 23.1062 22.74 24.0911Z"\n  />\n</svg>\n';
const __vite_glob_0_219 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.4327 17.6584C27.1873 17.5969 26.942 17.6584 26.7273 17.8123C25.9298 18.4895 25.0097 19.0435 23.9975 19.4128C23.0467 19.7822 22.0039 19.9668 20.8998 19.9668C18.4154 19.9668 16.1457 18.9511 14.5202 17.3199C12.8946 15.6886 11.8825 13.411 11.8825 10.918C11.8825 9.87149 12.0665 8.85581 12.3732 7.93245C12.7106 6.94754 13.2013 6.05497 13.8454 5.28551C14.1215 4.94694 14.0601 4.45449 13.7227 4.17748C13.508 4.02359 13.2627 3.96203 13.0173 4.02359C10.4103 4.73149 8.14059 6.30119 6.51503 8.39413C4.9508 10.4563 4 13.0109 4 15.8117C4 19.1666 5.34953 22.2137 7.55784 24.4297C9.76616 26.6457 12.8026 28 16.1457 28C18.9675 28 21.5745 27.0151 23.6602 25.3838C25.7765 23.7218 27.31 21.3519 27.9541 18.6434C28.1075 18.1817 27.8621 17.7508 27.4327 17.6584Z"\n  />\n</svg>\n';
const __vite_glob_0_220 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M25.7397 7.55L13.9626 7.57355L13.9667 9.59283L25.7437 9.56927L25.7397 7.55Z"\n  />\n  <path d="M8.00984 11H9V6H7.7082L7 7.0493H8.00984V11Z" />\n  <path\n    d="M10 16.9681H8.30408C8.42041 16.7188 8.86735 16.4488 9.07551 16.2756C9.58367 15.8532 9.96939 15.4169 9.96939 14.5374C9.96939 13.5194 9.29592 13 8.56122 13C7.67959 13 7.01837 13.6787 7.01837 14.6482H7.94286C7.93673 14.3227 8.16939 14.0319 8.53061 14.0319C8.87959 14.0319 9.0449 14.295 9.0449 14.6136C9.0449 14.9668 8.73265 15.2784 8.3898 15.5554C7.75306 16.0679 7 16.5319 7 17.6468V18H10V16.9681Z"\n  />\n  <path\n    d="M8.54932 25C9.41973 25 10 24.3929 10 23.5402C10 22.9945 9.73308 22.6262 9.45455 22.4693C9.66925 22.2715 9.88395 21.8963 9.88395 21.4256C9.88395 20.6685 9.41393 20 8.53191 20C7.81238 20 7.08124 20.5935 7.08124 21.6235H7.95745C7.95164 21.296 8.18375 21.0164 8.53191 21.0164C8.79884 21.0164 9.00774 21.221 9.00193 21.5143C8.99613 21.8213 8.82785 22.0396 8.46228 22.0396H8.14894V22.8649H8.5087C8.88008 22.8649 9.12379 23.1037 9.11799 23.4516C9.11219 23.7653 8.88588 23.9836 8.54932 23.9836C8.17215 23.9836 7.91103 23.7722 7.87041 23.3288H7C7.03482 24.4407 7.78337 25 8.54932 25Z"\n  />\n  <path\n    d="M25.7536 14.5249L13.9781 14.55L13.9824 16.5693L25.7579 16.5442L25.7536 14.5249Z"\n  />\n  <path\n    d="M25.7676 21.5249L13.9922 21.55L13.9965 23.5693L25.7719 23.5442L25.7676 21.5249Z"\n  />\n</svg>\n';
const __vite_glob_0_221 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M25.0001 4.35H7.00009C6.29751 4.35079 5.62394 4.63025 5.12714 5.12704C4.63034 5.62384 4.35089 6.29742 4.3501 7V25C4.35089 25.7026 4.63034 26.3762 5.12714 26.873C5.62394 27.3698 6.29751 27.6492 7.00009 27.65H25.0001C25.7027 27.6492 26.3762 27.3698 26.873 26.873C27.3698 26.3762 27.6493 25.7026 27.6501 25V7C27.6493 6.29742 27.3698 5.62384 26.873 5.12704C26.3762 4.63025 25.7027 4.35079 25.0001 4.35ZM19.3501 5.65V12.95L16.0001 11.273L12.6501 12.948V5.648L19.3501 5.65ZM26.3501 25C26.3498 25.358 26.2075 25.7012 25.9544 25.9543C25.7013 26.2074 25.3581 26.3497 25.0001 26.35H7.00009C6.64213 26.3497 6.29889 26.2074 6.04578 25.9543C5.79266 25.7012 5.65035 25.358 5.65009 25V7C5.65035 6.64204 5.79266 6.29882 6.04578 6.0457C6.29889 5.79258 6.64213 5.65027 7.00009 5.65H11.3501V15.05L16.0001 12.727L20.6501 15.052V5.652H25.0001C25.3577 5.65226 25.7006 5.7943 25.9537 6.04699C26.2067 6.29967 26.3493 6.64239 26.3501 7V25Z"\n  />\n  <path d="M12 19.35H8V20.65H12V19.35Z" />\n  <path d="M15 22.35H8V23.65H15V22.35Z" />\n</svg>\n';
const __vite_glob_0_222 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M23.019 13.5H22.176V11.441C22.176 9.8916 21.5605 8.40567 20.4649 7.31008C19.3693 6.21449 17.8834 5.599 16.334 5.599C14.7846 5.599 13.2987 6.21449 12.2031 7.31008C11.1075 8.40567 10.492 9.8916 10.492 11.441V13.5H9.649C9.47695 13.5003 9.31203 13.5687 9.19038 13.6904C9.06873 13.812 9.00026 13.977 9 14.149V25.749C9 25.9212 9.06834 26.0864 9.19003 26.2083C9.31171 26.3301 9.47678 26.3987 9.649 26.399H23.019C23.1912 26.3987 23.3563 26.3301 23.478 26.2083C23.5997 26.0864 23.668 25.9212 23.668 25.749V14.149C23.6677 13.977 23.5993 13.812 23.4776 13.6904C23.356 13.5687 23.191 13.5003 23.019 13.5ZM11.792 11.441C11.792 10.2364 12.2705 9.08111 13.1223 8.22932C13.9741 7.37753 15.1294 6.899 16.334 6.899C17.5386 6.899 18.6939 7.37753 19.5457 8.22932C20.3975 9.08111 20.876 10.2364 20.876 11.441V13.5H11.792V11.441ZM22.369 25.1H10.299V14.8H22.369V25.1Z"\n  />\n  <path d="M16.984 17.756H15.684V21.695H16.984V17.756Z" />\n</svg>\n';
const __vite_glob_0_223 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M22.176 13.5H23.019C23.191 13.5003 23.356 13.5687 23.4776 13.6904C23.5993 13.812 23.6677 13.977 23.668 14.149V25.749C23.668 25.9212 23.5997 26.0864 23.478 26.2083C23.3563 26.3301 23.1912 26.3987 23.019 26.399H9.649C9.47678 26.3987 9.31171 26.3301 9.19003 26.2083C9.06834 26.0864 9 25.9212 9 25.749V14.149C9.00026 13.977 9.06873 13.812 9.19038 13.6904C9.31203 13.5687 9.47695 13.5003 9.649 13.5H10.492V11.441C10.492 9.8916 11.1075 8.40567 12.2031 7.31008C13.2987 6.21449 14.7846 5.599 16.334 5.599C17.8834 5.599 19.3693 6.21449 20.4649 7.31008C21.5605 8.40567 22.176 9.8916 22.176 11.441V13.5ZM13.1223 8.22932C12.2705 9.08111 11.792 10.2364 11.792 11.441V13.5H20.876V11.441C20.876 10.2364 20.3975 9.08111 19.5457 8.22932C18.6939 7.37753 17.5386 6.899 16.334 6.899C15.1294 6.899 13.9741 7.37753 13.1223 8.22932ZM15.684 17.756H16.984V21.695H15.684V17.756Z"\n  />\n</svg>\n';
const __vite_glob_0_224 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M23.019 13.5H11.792V10.922C11.7898 9.75621 12.2359 8.63421 13.0381 7.78825C13.8402 6.94229 14.9369 6.43715 16.1012 6.3774C17.2655 6.31766 18.4081 6.70787 19.2927 7.46727C20.1772 8.22667 20.7358 9.29711 20.853 10.457L22.146 10.325C21.9943 8.83379 21.2752 7.45793 20.1375 6.48203C18.9998 5.50614 17.5306 5.00488 16.0336 5.08195C14.5367 5.15902 13.1267 5.80852 12.0952 6.89609C11.0637 7.98366 10.4897 9.42609 10.492 10.925V13.5H9.65C9.47778 13.5 9.3126 13.5683 9.19073 13.69C9.06886 13.8117 9.00026 13.9768 9 14.149V25.749C9 25.9214 9.06848 26.0867 9.19038 26.2086C9.31228 26.3305 9.47761 26.399 9.65 26.399H23.019C23.1044 26.399 23.1889 26.3822 23.2677 26.3495C23.3466 26.3169 23.4183 26.269 23.4786 26.2086C23.539 26.1483 23.5869 26.0766 23.6195 25.9977C23.6522 25.9189 23.669 25.8344 23.669 25.749V14.149C23.6687 13.9768 23.6001 13.8117 23.4783 13.69C23.3564 13.5683 23.1912 13.5 23.019 13.5ZM22.369 25.1H10.299V14.8H22.369V25.1Z"\n  />\n  <path d="M16.984 17.756H15.684V21.695H16.984V17.756Z" />\n</svg>\n';
const __vite_glob_0_225 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M11.792 13.5H23.019C23.1912 13.5 23.3564 13.5683 23.4783 13.69C23.6001 13.8117 23.6687 13.9768 23.669 14.149V25.749C23.669 25.8344 23.6522 25.9189 23.6195 25.9977C23.5869 26.0766 23.539 26.1483 23.4786 26.2086C23.4183 26.269 23.3466 26.3169 23.2677 26.3495C23.1889 26.3822 23.1044 26.399 23.019 26.399H9.65C9.47761 26.399 9.31228 26.3305 9.19038 26.2086C9.06848 26.0867 9 25.9214 9 25.749V14.149C9.00026 13.9768 9.06886 13.8117 9.19073 13.69C9.3126 13.5683 9.47778 13.5 9.65 13.5H10.492V10.925C10.4897 9.42609 11.0637 7.98366 12.0952 6.89609C13.1267 5.80852 14.5367 5.15902 16.0336 5.08195C17.5306 5.00488 18.9998 5.50614 20.1375 6.48203C21.2752 7.45793 21.9943 8.83379 22.146 10.325L20.853 10.457C20.7358 9.29711 20.1772 8.22667 19.2927 7.46727C18.4081 6.70787 17.2655 6.31766 16.1012 6.3774C14.9369 6.43715 13.8402 6.94229 13.0381 7.78825C12.2359 8.63421 11.7898 9.75621 11.792 10.922V13.5ZM15.684 17.756H16.984V21.695H15.684V17.756Z"\n  />\n</svg>\n';
const __vite_glob_0_226 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M13.766 28.456C13.4192 28.4563 13.0732 28.4228 12.733 28.356C11.5649 28.0933 10.5232 27.4355 9.78393 26.4938C9.04462 25.5521 8.65291 24.3841 8.67495 23.187V10.865C8.67552 9.82615 8.89702 8.79929 9.3247 7.85256C9.75239 6.90583 10.3765 6.06087 11.1557 5.37373C11.9348 4.6866 12.8512 4.17301 13.8439 3.86704C14.8367 3.56106 15.8832 3.4697 16.914 3.599C18.7161 3.85486 20.3625 4.76066 21.5432 6.14587C22.724 7.53107 23.3577 9.30013 23.325 11.12V21.564H22.025V11.12C22.0581 9.61797 21.5411 8.15563 20.5712 7.00822C19.6014 5.86081 18.2455 5.10747 16.759 4.89C15.908 4.77738 15.0428 4.85009 14.2226 5.10312C13.4024 5.35616 12.6465 5.78355 12.007 6.356C11.369 6.92129 10.8582 7.61548 10.5082 8.39273C10.1583 9.16998 9.97723 10.0126 9.97696 10.865V23.185C9.95371 24.0814 10.2406 24.9584 10.7892 25.6677C11.3378 26.377 12.1145 26.8751 12.988 27.078C13.5459 27.1941 14.1228 27.1841 14.6764 27.0488C15.23 26.9135 15.7464 26.6563 16.188 26.296C16.6228 25.9401 16.9731 25.492 17.2133 24.984C17.4536 24.476 17.5778 23.9209 17.577 23.359L17.565 10.959C17.5656 10.7318 17.5175 10.507 17.4238 10.3C17.3301 10.093 17.1931 9.90849 17.022 9.759C16.8511 9.61208 16.6505 9.50398 16.4338 9.44217C16.2171 9.38036 15.9896 9.36632 15.767 9.40101C15.3761 9.4882 15.0282 9.70964 14.7837 10.0268C14.5393 10.344 14.4137 10.7368 14.429 11.137L14.44 21.566H13.14L13.129 11.137C13.1103 10.4237 13.3469 9.7272 13.7963 9.17295C14.2457 8.6187 14.8782 8.24317 15.58 8.114C15.9885 8.05248 16.4055 8.08017 16.8024 8.19517C17.1992 8.31017 17.5664 8.50975 17.8788 8.78019C18.1911 9.05062 18.4412 9.38551 18.6118 9.7618C18.7823 10.1381 18.8694 10.5469 18.867 10.96L18.879 23.36C18.879 24.0305 18.7468 24.6944 18.4899 25.3138C18.233 25.9331 17.8565 26.4957 17.382 26.9694C16.9075 27.4431 16.3442 27.8186 15.7244 28.0744C15.1046 28.3301 14.4405 28.4612 13.77 28.46L13.766 28.456Z"\n  />\n</svg>\n';
const __vite_glob_0_227 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M25.4071 6.826L21.0361 3.693C20.896 3.59276 20.7218 3.55216 20.5518 3.58009C20.3818 3.60801 20.2298 3.7022 20.1291 3.842L16.9691 8.251L7.42012 21.422C7.42012 21.428 7.42012 21.436 7.41112 21.443C7.39158 21.4768 7.37518 21.5122 7.36212 21.549C7.3414 21.5902 7.32498 21.6334 7.31312 21.678C7.31312 21.685 7.30612 21.691 7.30512 21.699L6.33012 27.674C6.31049 27.7936 6.32468 27.9163 6.37109 28.0282C6.4175 28.1402 6.49429 28.2369 6.59278 28.3076C6.69127 28.3782 6.80754 28.4199 6.92847 28.4279C7.04939 28.4359 7.17016 28.41 7.27712 28.353L12.6231 25.511C12.7051 25.4661 12.7764 25.404 12.8321 25.329C12.8321 25.324 12.8411 25.323 12.8441 25.318L22.3941 12.145L25.5551 7.736C25.655 7.59566 25.6953 7.4215 25.6672 7.25156C25.6391 7.08162 25.5449 6.92971 25.4051 6.829L25.4071 6.826ZM17.6441 9.535L20.9581 11.911L12.1711 24.032L8.85612 21.656L17.6441 9.535ZM8.42012 22.943L11.0881 24.855L7.82412 26.589L8.42012 22.943ZM21.7201 10.856L18.4001 8.48L20.8001 5.128L24.1211 7.5L21.7201 10.856Z"\n  />\n</svg>\n';
const __vite_glob_0_228 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 14.354C15.0227 14.354 14.0674 14.0642 13.2549 13.5213C12.4423 12.9784 11.809 12.2067 11.4351 11.3038C11.0611 10.401 10.9633 9.40752 11.1539 8.44906C11.3446 7.4906 11.8151 6.6102 12.5061 5.91919C13.1972 5.22818 14.0776 4.75759 15.036 4.56694C15.9945 4.37629 16.9879 4.47414 17.8908 4.84811C18.7936 5.22209 19.5653 5.85539 20.1083 6.66793C20.6512 7.48047 20.941 8.43577 20.941 9.413C20.9394 10.7229 20.4183 11.9788 19.492 12.9051C18.5658 13.8313 17.3099 14.3524 16 14.354ZM16 5.771C15.2796 5.7708 14.5753 5.98424 13.9763 6.3843C13.3772 6.78437 12.9103 7.35311 12.6345 8.01858C12.3587 8.68405 12.2864 9.41636 12.4268 10.1229C12.5672 10.8295 12.914 11.4785 13.4233 11.9879C13.9326 12.4974 14.5816 12.8443 15.2881 12.9849C15.9946 13.1256 16.7269 13.0535 17.3925 12.7779C18.058 12.5022 18.6269 12.0354 19.0271 11.4365C19.4273 10.8375 19.641 10.1334 19.641 9.413C19.6399 8.44758 19.256 7.52199 18.5734 6.83924C17.8909 6.15649 16.9654 5.77233 16 5.771Z"\n  />\n  <path\n    d="M16.1999 27.529C13.122 27.6099 10.1186 26.5749 7.74394 24.615L7.54395 24.422V22.787C7.54606 20.9669 8.27001 19.222 9.55699 17.9351C10.844 16.6481 12.5889 15.9241 14.4089 15.922H17.5999C19.42 15.9241 21.1649 16.6481 22.4519 17.9351C23.7389 19.222 24.4628 20.9669 24.4649 22.787V24.4L24.2959 24.586C24.1829 24.7 21.5519 27.529 16.1999 27.529ZM8.84193 23.843C10.9629 25.4308 13.5508 26.27 16.1999 26.229C18.7323 26.3265 21.2117 25.487 23.1639 23.871V22.787C23.1624 21.3116 22.5755 19.897 21.5322 18.8537C20.4889 17.8104 19.0744 17.2236 17.5989 17.222H14.3999C12.9245 17.2236 11.5099 17.8104 10.4666 18.8537C9.42335 19.897 8.83653 21.3116 8.83495 22.787L8.84193 23.843Z"\n  />\n</svg>\n';
const __vite_glob_0_229 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 14.354C15.0227 14.354 14.0674 14.0642 13.2549 13.5213C12.4423 12.9784 11.809 12.2067 11.4351 11.3038C11.0611 10.401 10.9633 9.40752 11.1539 8.44906C11.3446 7.4906 11.8151 6.6102 12.5061 5.91919C13.1972 5.22818 14.0776 4.75759 15.036 4.56694C15.9945 4.37629 16.9879 4.47414 17.8908 4.84811C18.7936 5.22209 19.5653 5.85539 20.1083 6.66793C20.6512 7.48047 20.941 8.43577 20.941 9.413C20.9394 10.7229 20.4183 11.9788 19.492 12.9051C18.5658 13.8313 17.3099 14.3524 16 14.354Z"\n  />\n  <path\n    d="M16.1999 27.529C13.122 27.6099 10.1186 26.5749 7.74394 24.615L7.54395 24.422V22.787C7.54606 20.9669 8.27001 19.222 9.55699 17.9351C10.844 16.6481 12.5889 15.9241 14.4089 15.922H17.5999C19.42 15.9241 21.1649 16.6481 22.4519 17.9351C23.7389 19.222 24.4628 20.9669 24.4649 22.787V24.4L24.2959 24.586C24.1829 24.7 21.5519 27.529 16.1999 27.529Z"\n  />\n</svg>\n';
const __vite_glob_0_230 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M21.9701 3.35H9.97009C9.26742 3.35079 8.59373 3.63021 8.09677 4.12698C7.59981 4.62375 7.32015 5.29733 7.31909 6V26C7.32015 26.7027 7.59981 27.3762 8.09677 27.873C8.59373 28.3698 9.26742 28.6492 9.97009 28.65H21.9701C22.6727 28.6492 23.3462 28.3698 23.843 27.873C24.3398 27.3762 24.6193 26.7026 24.6201 26V6C24.6193 5.29742 24.3398 4.62384 23.843 4.12704C23.3462 3.63025 22.6727 3.35079 21.9701 3.35ZM9.97009 4.65H21.9701C22.3279 4.65053 22.6708 4.79296 22.9237 5.04605C23.1766 5.29914 23.3188 5.64221 23.3191 6V7.35H8.61908V6C8.61934 5.64187 8.7618 5.29849 9.01514 5.04535C9.26847 4.7922 9.61196 4.65 9.97009 4.65ZM23.3191 8.65V20.35H8.61908V8.65H23.3191ZM21.9701 27.35H9.97009C9.61213 27.3497 9.26889 27.2074 9.01578 26.9543C8.76266 26.7012 8.62035 26.358 8.62009 26V21.65H23.3201V26C23.3198 26.358 23.1775 26.7012 22.9244 26.9543C22.6713 27.2074 22.3281 27.3497 21.9701 27.35Z"\n  />\n  <path\n    d="M15.97 22.646C15.6338 22.646 15.3051 22.7457 15.0256 22.9325C14.746 23.1193 14.5281 23.3848 14.3994 23.6954C14.2708 24.0061 14.2371 24.3479 14.3027 24.6777C14.3683 25.0074 14.5302 25.3103 14.7679 25.5481C15.0057 25.7858 15.3086 25.9477 15.6383 26.0133C15.9681 26.0789 16.31 26.0453 16.6206 25.9166C16.9312 25.7879 17.1967 25.57 17.3835 25.2905C17.5703 25.0109 17.67 24.6822 17.67 24.346C17.67 23.8951 17.4909 23.4627 17.1721 23.1439C16.8533 22.8251 16.4209 22.646 15.97 22.646ZM15.97 24.746C15.8909 24.746 15.8136 24.7225 15.7478 24.6786C15.682 24.6346 15.6307 24.5722 15.6004 24.4991C15.5702 24.426 15.5623 24.3456 15.5777 24.268C15.5931 24.1904 15.6312 24.1191 15.6872 24.0632C15.7431 24.0072 15.8144 23.9691 15.892 23.9537C15.9696 23.9383 16.05 23.9462 16.1231 23.9764C16.1962 24.0067 16.2586 24.058 16.3026 24.1238C16.3465 24.1896 16.37 24.2669 16.37 24.346C16.3703 24.3987 16.3601 24.4509 16.3401 24.4997C16.3201 24.5484 16.2907 24.5928 16.2536 24.6301C16.2164 24.6675 16.1722 24.6971 16.1235 24.7174C16.0749 24.7376 16.0227 24.748 15.97 24.748V24.746Z"\n  />\n</svg>\n';
const __vite_glob_0_231 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.0599 5.60001H5.05994C4.35726 5.6008 3.68357 5.88022 3.18661 6.37699C2.68966 6.87376 2.40999 7.54734 2.40894 8.25001V23.756C2.40999 24.4587 2.68966 25.1322 3.18661 25.629C3.68357 26.1258 4.35726 26.4052 5.05994 26.406H27.0599C27.7625 26.4052 28.4361 26.1258 28.9329 25.629C29.4297 25.1322 29.7091 24.4586 29.7099 23.756V8.24701C29.7083 7.54495 29.4285 6.87214 28.9318 6.37599C28.4351 5.87984 27.762 5.6008 27.0599 5.60001ZM5.05994 6.90001H27.0599C27.4177 6.90054 27.7607 7.04297 28.0136 7.29606C28.2665 7.54915 28.4087 7.89222 28.4089 8.25001V23.756C28.4005 23.8456 28.3828 23.9341 28.3559 24.02L20.713 16.505C20.5912 16.3841 20.4265 16.3162 20.2549 16.3162C20.0833 16.3162 19.9187 16.3841 19.7969 16.505L16.2849 20.017L11.019 14.307C10.9592 14.2428 10.8871 14.1912 10.8071 14.1553C10.7271 14.1194 10.6407 14.0999 10.5529 14.098C10.4648 14.095 10.377 14.1106 10.2953 14.1439C10.2136 14.1771 10.1399 14.2273 10.0789 14.291L3.70993 20.719V8.24701C3.71099 7.88957 3.85366 7.54712 4.10669 7.29465C4.35972 7.04218 4.70249 6.90027 5.05994 6.90001ZM5.05994 25.106C4.70198 25.1057 4.35877 24.9634 4.10565 24.7103C3.85254 24.4572 3.7102 24.114 3.70993 23.756V22.57L10.5239 15.692L15.7889 21.399C15.8483 21.4635 15.9201 21.5153 16 21.5512C16.0799 21.5872 16.1663 21.6065 16.2539 21.608C16.4297 21.6056 16.5983 21.5379 16.7269 21.418L20.2609 17.884L27.5119 25.014C27.3679 25.0711 27.2148 25.1022 27.0599 25.106H5.05994Z"\n  />\n  <path\n    d="M24.0251 15.473C24.5045 15.4732 24.9733 15.3312 25.372 15.065C25.7708 14.7987 26.0816 14.4202 26.2653 13.9773C26.4489 13.5344 26.497 13.047 26.4036 12.5767C26.3102 12.1064 26.0794 11.6744 25.7404 11.3353C25.4015 10.9962 24.9696 10.7653 24.4993 10.6717C24.0291 10.578 23.5416 10.626 23.0987 10.8094C22.6557 10.9929 22.277 11.3036 22.0107 11.7022C21.7443 12.1008 21.6021 12.5695 21.6021 13.049C21.6028 13.6915 21.8584 14.3074 22.3126 14.7618C22.7668 15.2162 23.3826 15.4719 24.0251 15.473ZM24.0251 11.926C24.2472 11.926 24.4643 11.9919 24.649 12.1153C24.8336 12.2387 24.9776 12.4141 25.0626 12.6193C25.1476 12.8245 25.1698 13.0503 25.1265 13.2681C25.0832 13.4859 24.9762 13.686 24.8192 13.8431C24.6621 14.0001 24.462 14.1071 24.2441 14.1504C24.0263 14.1938 23.8005 14.1715 23.5953 14.0865C23.3901 14.0015 23.2147 13.8576 23.0913 13.6729C22.9679 13.4882 22.9021 13.2711 22.9021 13.049C22.9023 12.7513 23.0207 12.4658 23.2313 12.2552C23.4418 12.0447 23.7273 11.9263 24.0251 11.926Z"\n  />\n</svg>\n';
const __vite_glob_0_232 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path d="M17.662 7.05585H15.3379V25.9433H17.662V7.05585Z" />\n  <path d="M25.9428 15.3384H7.0553V17.6624H25.9428V15.3384Z" />\n</svg>\n';
const __vite_glob_0_233 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M3.60611 9.38663H4.56377V21.8098C4.56513 22.4576 4.8244 23.0779 5.28388 23.5344C5.74371 23.9908 6.36575 24.2453 7.01358 24.2423H14.6644L10.4465 28.0088C11.2555 28.9244 10.4465 28.0088 11.2555 28.9244L15.9166 24.7724L20.5777 28.9251C21.3867 28.0085 20.5777 28.9251 21.3867 28.0085L17.1688 24.2423H24.8196C25.464 24.2443 26.0824 23.9881 26.5368 23.5313C26.9912 23.0742 27.2436 22.4542 27.2382 21.8098V9.38663H28.258C28.6014 9.38086 28.8793 9.10564 28.8888 8.76221V4.58711C28.8759 4.25115 28.5939 3.98883 28.258 4.00037H3.60611C3.44729 3.99562 3.29322 4.05534 3.1792 4.16563C3.06517 4.27626 3.00035 4.42829 3.00002 4.58711V8.76221C2.99764 9.10089 3.26743 9.37882 3.60611 9.38663ZM26.022 21.8098C26.0281 22.1318 25.9035 22.4427 25.6772 22.6714C25.4508 22.9005 25.1417 23.0284 24.8196 23.026H7.01358C6.68848 23.0298 6.37525 22.9032 6.14347 22.6748C5.91203 22.4464 5.78104 22.1352 5.78002 21.8098V9.38663H26.022V21.8098ZM4.21627 5.21662H27.6726V8.17037H4.21627V5.21662Z"\n  />\n  <path d="M19.5807 14.1629H7.85437V12.9467H19.5807V14.1629Z" />\n  <path d="M23.9567 16.5827H7.85437V15.5439H23.9567V16.5827Z" />\n  <path d="M23.9567 19.1799H7.85437V18.141H23.9567V19.1799Z" />\n</svg>\n';
const __vite_glob_0_234 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M4.56377 9.38663H3.60611C3.26743 9.37882 2.99764 9.10089 3.00002 8.76221V4.58711C3.00035 4.42829 3.06517 4.27626 3.1792 4.16563C3.29322 4.05534 3.44729 3.99562 3.60611 4.00037H28.258C28.5939 3.98883 28.8759 4.25115 28.8888 4.58711V8.76221C28.8793 9.10564 28.6014 9.38086 28.258 9.38663H27.2382V21.8098C27.2436 22.4542 26.9912 23.0742 26.5368 23.5313C26.0824 23.9881 25.464 24.2443 24.8196 24.2423H17.1688L21.3867 28.0085L20.5777 28.9251L15.9166 24.7724L11.2555 28.9244L10.4465 28.0088L14.6644 24.2423H7.01358C6.36575 24.2453 5.74371 23.9908 5.28388 23.5344C4.8244 23.0779 4.56513 22.4576 4.56377 21.8098V9.38663ZM7.85431 14.1629H19.5806V12.9467H7.85431V14.1629ZM7.85431 16.5827H23.9567V15.5439H7.85431V16.5827ZM23.9567 19.1799H7.85431V18.141H23.9567V19.1799Z"\n  />\n</svg>\n';
const __vite_glob_0_235 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M10.879 10.4H4.771V4.28998H10.879V10.4ZM6.071 9.09998H9.58V5.58998H6.071V9.09998Z"\n  />\n  <path d="M18.573 9.74898H17.273V5.58998H14.073V4.28998H18.573V9.74898Z" />\n  <path d="M26.579 19.054H21.121V13.6H22.421V17.759H26.58L26.579 19.054Z" />\n  <path\n    d="M27.229 10.4H21.121V4.28998H27.229V10.4ZM22.42 9.09998H25.929V5.58998H22.42V9.09998Z"\n  />\n  <path\n    d="M10.879 27.71H4.771V21.6H10.879V27.71ZM6.071 26.41H9.58V22.9H6.071V26.41Z"\n  />\n  <path\n    d="M27.229 27.71H21.121V21.6H27.229V27.71ZM22.42 26.41H25.929V22.9H22.42V26.41Z"\n  />\n  <path d="M6.071 18.4H4.771V13.9H13.427V8.78699H14.727V15.207H6.071V18.4Z" />\n  <path d="M10.229 17.754H8.30603V19.054H10.229V17.754Z" />\n  <path d="M27.229 13.5959H25.929V15.5189H27.229V13.5959Z" />\n  <path\n    d="M18.573 27.71H14.073V26.41H17.273V22.9H13.426V17.754H17.273V13.6H18.573V19.058H14.726V21.6H18.573V27.71Z"\n  />\n</svg>\n';
const __vite_glob_0_236 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path d="M10.879 10.4H4.771V4.29004H10.879V10.4Z" />\n  <path d="M18.573 9.74904H17.273V5.59004H14.073V4.29004H18.573V9.74904Z" />\n  <path d="M26.579 19.054H21.121V13.6H22.421V17.759H26.58L26.579 19.054Z" />\n  <path d="M27.229 10.4H21.121V4.29004H27.229V10.4Z" />\n  <path d="M10.879 27.71H4.771V21.6H10.879V27.71Z" />\n  <path d="M27.229 27.71H21.121V21.6H27.229V27.71Z" />\n  <path d="M6.071 18.4H4.771V13.9H13.427V8.78703H14.727V15.207H6.071V18.4Z" />\n  <path d="M10.229 17.754H8.30603V19.054H10.229V17.754Z" />\n  <path d="M27.229 13.596H25.929V15.519H27.229V13.596Z" />\n  <path\n    d="M18.573 27.71H14.073V26.41H17.273V22.9H13.426V17.754H17.273V13.6H18.573V19.058H14.726V21.6H18.573V27.71Z"\n  />\n</svg>\n';
const __vite_glob_0_237 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M15.691 23.717C15.3736 23.7214 15.0621 23.6313 14.7961 23.4581C14.5301 23.285 14.3217 23.0366 14.1972 22.7447C14.0727 22.4527 14.0378 22.1304 14.0971 21.8186C14.1563 21.5068 14.3069 21.2196 14.5298 20.9936C14.7526 20.7677 15.0377 20.6131 15.3486 20.5495C15.6596 20.486 15.9824 20.5164 16.2761 20.6368C16.5697 20.7572 16.8209 20.9623 16.9977 21.2258C17.1745 21.4894 17.2689 21.7996 17.269 22.117C17.2708 22.5381 17.1059 22.9428 16.8102 23.2427C16.5145 23.5425 16.1121 23.713 15.691 23.717ZM18.314 16.341C17.524 16.959 16.63 17.535 16.63 18.341V18.513H14.8V18.086C14.8 16.956 15.91 15.933 16.741 15.313C17.913 14.44 18.724 13.822 18.724 12.543C18.7377 12.2014 18.6813 11.8605 18.5581 11.5416C18.4349 11.2226 18.2476 10.9323 18.0077 10.6886C17.7679 10.4449 17.4806 10.253 17.1637 10.1248C16.8467 9.99651 16.5068 9.93465 16.165 9.943C15.7856 9.92409 15.4065 9.98414 15.0516 10.1193C14.6966 10.2545 14.3736 10.4619 14.103 10.7284C13.8324 10.9949 13.6201 11.3147 13.4794 11.6675C13.3388 12.0203 13.2729 12.3984 13.286 12.778H11.453C11.4492 12.1621 11.5691 11.5517 11.8056 10.9831C12.0422 10.4144 12.3905 9.899 12.8299 9.46748C13.2694 9.03595 13.791 8.69706 14.3639 8.47092C14.9368 8.24478 15.5493 8.13599 16.165 8.151C16.7422 8.1361 17.3164 8.23807 17.8532 8.45081C18.3899 8.66354 18.8781 8.98263 19.2884 9.38889C19.6987 9.79515 20.0226 10.2802 20.2406 10.8148C20.4586 11.3495 20.5662 11.9227 20.557 12.5C20.5227 13.2741 20.3006 14.0283 19.9098 14.6975C19.519 15.3666 18.9713 15.9307 18.314 16.341Z"\n  />\n  <path\n    d="M4.75795 28.438C4.6659 28.4377 4.57496 28.4179 4.4911 28.3799C4.40725 28.3419 4.33237 28.2867 4.27137 28.2178C4.21037 28.1488 4.16463 28.0678 4.13716 27.9799C4.10968 27.8921 4.1011 27.7994 4.11195 27.708L4.89296 21.367C4.05758 19.6782 3.62429 17.8191 3.62697 15.935C3.62697 13.4879 4.35261 11.0957 5.71217 9.06093C7.07173 7.0262 9.00413 5.44032 11.265 4.50384C13.5259 3.56736 16.0137 3.32233 18.4138 3.79975C20.8139 4.27716 23.0186 5.45557 24.749 7.18597C26.4794 8.91636 27.6578 11.121 28.1352 13.5212C28.6126 15.9213 28.3676 18.4091 27.4311 20.6699C26.4946 22.9308 24.9088 24.8632 22.874 26.2228C20.8393 27.5823 18.4471 28.308 16 28.308C14.1381 28.3103 12.3004 27.8872 10.627 27.071L4.90696 28.42C4.85819 28.4319 4.80815 28.4379 4.75795 28.438ZM10.7059 25.738C10.8081 25.7381 10.9087 25.7621 11 25.808C12.5476 26.5996 14.2616 27.011 16 27.008C18.19 27.0082 20.331 26.3589 22.1521 25.1424C23.9731 23.9258 25.3925 22.1965 26.2308 20.1732C27.069 18.1498 27.2885 15.9234 26.8613 13.7754C26.4342 11.6274 25.3796 9.65425 23.8311 8.10556C22.2825 6.55688 20.3095 5.50217 18.1615 5.07484C16.0136 4.6475 13.7871 4.86673 11.7637 5.70479C9.74033 6.54285 8.01093 7.9621 6.79417 9.78307C5.57741 11.604 4.92796 13.7449 4.92796 15.935C4.92586 17.6818 5.34176 19.4037 6.14094 20.957C6.19945 21.0724 6.22243 21.2026 6.20695 21.331L5.51695 26.941L10.557 25.752C10.6058 25.7409 10.6558 25.7352 10.7059 25.735V25.738Z"\n  />\n</svg>\n';
const __vite_glob_0_238 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M4.4911 28.3799C4.57496 28.4179 4.6659 28.4377 4.75795 28.438C4.80815 28.4379 4.85819 28.4319 4.90696 28.42L10.627 27.071C12.3004 27.8872 14.1381 28.3103 16 28.308C18.4471 28.308 20.8393 27.5823 22.874 26.2228C24.9088 24.8632 26.4946 22.9308 27.4311 20.6699C28.3676 18.4091 28.6126 15.9213 28.1352 13.5212C27.6578 11.121 26.4794 8.91636 24.749 7.18597C23.0186 5.45557 20.8139 4.27716 18.4138 3.79975C16.0137 3.32233 13.5259 3.56736 11.265 4.50384C9.00413 5.44032 7.07173 7.0262 5.71217 9.06093C4.35261 11.0957 3.62697 13.4879 3.62697 15.935C3.62429 17.8191 4.05758 19.6782 4.89296 21.367L4.11195 27.708C4.1011 27.7994 4.10968 27.8921 4.13716 27.9799C4.16463 28.0678 4.21037 28.1488 4.27137 28.2178C4.33237 28.2867 4.40725 28.3419 4.4911 28.3799ZM14.7961 23.4581C15.0621 23.6313 15.3736 23.7214 15.6909 23.717C16.112 23.713 16.5144 23.5425 16.8101 23.2427C17.1058 22.9428 17.2708 22.5381 17.2689 22.117C17.2689 21.7996 17.1744 21.4894 16.9976 21.2258C16.8208 20.9623 16.5696 20.7572 16.276 20.6368C15.9824 20.5164 15.6595 20.486 15.3486 20.5495C15.0376 20.6131 14.7526 20.7677 14.5297 20.9936C14.3069 21.2196 14.1562 21.5068 14.097 21.8186C14.0378 22.1304 14.0726 22.4527 14.1971 22.7447C14.3216 23.0366 14.5301 23.285 14.7961 23.4581ZM18.033 16.5574C18.127 16.4855 18.2212 16.4136 18.3139 16.341C18.9713 15.9307 19.519 15.3666 19.9097 14.6975C20.3005 14.0283 20.5226 13.2741 20.5569 12.5C20.5661 11.9227 20.4585 11.3495 20.2405 10.8148C20.0225 10.2802 19.6986 9.79515 19.2884 9.38889C18.8781 8.98263 18.3899 8.66354 17.8531 8.45081C17.3163 8.23808 16.7421 8.1361 16.1649 8.151C15.5492 8.13599 14.9367 8.24478 14.3638 8.47092C13.7909 8.69707 13.2693 9.03595 12.8299 9.46748C12.3904 9.899 12.0421 10.4144 11.8056 10.9831C11.569 11.5517 11.4491 12.1621 11.4529 12.778H13.2859C13.2728 12.3984 13.3387 12.0203 13.4794 11.6675C13.62 11.3147 13.8323 10.9949 14.103 10.7284C14.3736 10.4619 14.6966 10.2545 15.0515 10.1193C15.4064 9.98414 15.7856 9.92409 16.1649 9.943C16.5067 9.93465 16.8466 9.99651 17.1636 10.1248C17.4806 10.253 17.7678 10.4449 18.0077 10.6886C18.2475 10.9323 18.4349 11.2226 18.558 11.5416C18.6812 11.8605 18.7377 12.2014 18.7239 12.543C18.7239 13.822 17.9129 14.44 16.7409 15.313C15.9099 15.933 14.7999 16.956 14.7999 18.086V18.513H16.6299V18.341C16.6299 17.6296 17.3263 17.0974 18.033 16.5574Z"\n  />\n</svg>\n';
const __vite_glob_0_239 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M16 24C20.4183 24 24 20.4183 24 16C24 11.5817 20.4183 8 16 8C11.5817 8 8 11.5817 8 16C8 20.4183 11.5817 24 16 24ZM16 25C20.9706 25 25 20.9706 25 16C25 11.0294 20.9706 7 16 7C11.0294 7 7 11.0294 7 16C7 20.9706 11.0294 25 16 25Z"\n  />\n</svg>\n';
const __vite_glob_0_240 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M16 24C20.4183 24 24 20.4183 24 16C24 11.5817 20.4183 8 16 8C11.5817 8 8 11.5817 8 16C8 20.4183 11.5817 24 16 24ZM16 25C20.9706 25 25 20.9706 25 16C25 11.0294 20.9706 7 16 7C11.0294 7 7 11.0294 7 16C7 20.9706 11.0294 25 16 25Z"\n  />\n  <path\n    d="M21 16C21 18.7614 18.7614 21 16 21C13.2386 21 11 18.7614 11 16C11 13.2386 13.2386 11 16 11C18.7614 11 21 13.2386 21 16Z"\n  />\n</svg>\n';
const __vite_glob_0_241 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M15.8 27.1778C22.0838 27.1778 27.1778 22.0838 27.1778 15.8C27.1778 9.51623 22.0838 4.42222 15.8 4.42222C9.51623 4.42222 4.42222 9.51623 4.42222 15.8C4.42222 22.0838 9.51623 27.1778 15.8 27.1778ZM15.8 28.6C22.8692 28.6 28.6 22.8692 28.6 15.8C28.6 8.73075 22.8692 3 15.8 3C8.73075 3 3 8.73075 3 15.8C3 22.8692 8.73075 28.6 15.8 28.6Z"\n  />\n  <path\n    d="M22.9111 15.8C22.9111 19.7274 19.7274 22.9111 15.8 22.9111C11.8726 22.9111 8.68889 19.7274 8.68889 15.8C8.68889 11.8726 11.8726 8.68889 15.8 8.68889C19.7274 8.68889 22.9111 11.8726 22.9111 15.8Z"\n  />\n</svg>\n';
const __vite_glob_0_242 = '<?xml version="1.0" encoding="utf-8" ?>\n<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\n<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M16.4697 3.46967C16.7626 3.17678 17.2374 3.17678 17.5303 3.46967L20.5303 6.46967C20.8232 6.76256 20.8232 7.23744 20.5303 7.53033L17.5303 10.5303C17.2374 10.8232 16.7626 10.8232 16.4697 10.5303C16.1768 10.2374 16.1768 9.76256 16.4697 9.46967L18.1893 7.75H9.00001C6.6528 7.75 4.75 9.65279 4.75 12C4.75 14.3472 6.65279 16.25 9 16.25H16C16.4142 16.25 16.75 16.5858 16.75 17C16.75 17.4142 16.4142 17.75 16 17.75H9C5.82436 17.75 3.25 15.1756 3.25 12C3.25 8.82436 5.82437 6.25 9.00001 6.25H18.1893L16.4697 4.53033C16.1768 4.23744 16.1768 3.76256 16.4697 3.46967Z"\n    fill="#1C274C"\n  />\n</svg>\n';
const __vite_glob_0_243 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M9.81091 11.293V20.707C9.81287 20.9324 9.85921 21.1551 9.94728 21.3624C10.0353 21.5698 10.1634 21.7579 10.3242 21.9157C10.4849 22.0736 10.6752 22.1982 10.8842 22.2825C11.0931 22.3669 11.3166 22.4092 11.5419 22.4071H19.1139C19.3393 22.4092 19.5628 22.3669 19.7718 22.2826C19.9808 22.1983 20.1712 22.0736 20.332 21.9158C20.4928 21.7579 20.621 21.5699 20.7092 21.3625C20.7974 21.1551 20.8438 20.9324 20.8459 20.707V13C20.846 12.9142 20.8291 12.8291 20.7962 12.7498C20.7632 12.6705 20.7149 12.5985 20.6539 12.538L17.8729 9.78105C17.7512 9.66076 17.587 9.5932 17.4159 9.59303H11.5419C11.3166 9.59092 11.0931 9.63324 10.8842 9.71754C10.6752 9.80185 10.4849 9.92649 10.3242 10.0844C10.1634 10.2422 10.0353 10.4303 9.94728 10.6376C9.85921 10.845 9.81287 11.0677 9.81091 11.293ZM19.1109 21.103H11.5389C11.4843 21.1053 11.4298 21.0967 11.3785 21.0778C11.3272 21.0589 11.2801 21.03 11.2401 20.9928C11.2 20.9557 11.1677 20.9109 11.145 20.8612C11.1223 20.8114 11.1097 20.7577 11.1079 20.703V11.289C11.1097 11.2344 11.1223 11.1807 11.145 11.1309C11.1677 11.0812 11.2 11.0364 11.2401 10.9992C11.2801 10.962 11.3272 10.9332 11.3785 10.9143C11.4298 10.8953 11.4843 10.8868 11.5389 10.8891H15.3719V12.77C15.3895 13.3935 15.6534 13.9845 16.1058 14.4137C16.5583 14.843 17.1624 15.0754 17.7859 15.06H19.5429V20.6991C19.5411 20.7536 19.5286 20.8072 19.506 20.8568C19.4835 20.9065 19.4514 20.9512 19.4115 20.9885C19.3717 21.0257 19.3249 21.0547 19.2738 21.0739C19.2228 21.093 19.1684 21.1019 19.1139 21.1001L19.1109 21.103ZM19.5429 13.274V13.7681H17.7859C17.5072 13.7831 17.2339 13.6876 17.0253 13.5022C16.8167 13.3168 16.6897 13.0566 16.6719 12.7781V10.9H17.1449L19.5429 13.274Z"\n  />\n  <path\n    d="M30.9799 17.682L28.489 15.19C28.233 14.9458 27.8928 14.8095 27.539 14.8095C27.1851 14.8095 26.8449 14.9458 26.589 15.19L24.098 17.682L25.017 18.602L26.847 16.815C26.6873 19.0549 25.877 21.1993 24.5156 22.9851C23.1543 24.7709 21.3011 26.1203 19.1836 26.8677C17.0661 27.6151 14.7765 27.7279 12.5958 27.1922C10.4151 26.6566 8.43826 25.4958 6.908 23.8524C5.37774 22.2091 4.36065 20.1546 3.9816 17.9413C3.60256 15.728 3.87805 13.4522 4.77426 11.3933C5.67047 9.33437 7.14839 7.58197 9.02656 6.35121C10.9047 5.12044 13.1014 4.46488 15.347 4.46504V3.16505C12.8371 3.16169 10.3813 3.8942 8.28347 5.27198C6.1856 6.64976 4.53767 8.61236 3.54357 10.9169C2.54947 13.2215 2.2528 15.767 2.69028 18.2384C3.12775 20.7098 4.28018 22.9988 6.00497 24.8221C7.72977 26.6454 9.95126 27.923 12.3946 28.4969C14.838 29.0709 17.396 28.9159 19.7521 28.0512C22.1083 27.1864 24.1593 25.65 25.6514 23.6318C27.1434 21.6136 28.0111 19.2022 28.147 16.6961L30.054 18.603L30.9799 17.682Z"\n  />\n</svg>\n';
const __vite_glob_0_244 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M9.81091 11.293V20.707C9.81287 20.9324 9.85921 21.1551 9.94728 21.3624C10.0353 21.5698 10.1634 21.7579 10.3242 21.9157C10.4849 22.0736 10.6752 22.1982 10.8842 22.2825C11.0931 22.3669 11.3166 22.4092 11.5419 22.4071H19.1139C19.3393 22.4092 19.5628 22.3669 19.7718 22.2826C19.9808 22.1983 20.1712 22.0736 20.332 21.9158C20.4928 21.7579 20.621 21.5699 20.7092 21.3625C20.7974 21.1551 20.8438 20.9324 20.8459 20.707V13C20.846 12.9142 20.8291 12.8291 20.7962 12.7498C20.7632 12.6705 20.7148 12.5985 20.6539 12.538L17.8729 9.78105C17.7512 9.66076 17.587 9.5932 17.4159 9.59303H11.5419C11.3166 9.59092 11.0931 9.63324 10.8842 9.71754C10.6752 9.80185 10.4849 9.92649 10.3242 10.0844C10.1634 10.2422 10.0353 10.4303 9.94728 10.6376C9.85921 10.845 9.81287 11.0677 9.81091 11.293ZM19.5429 13.274V13.7681H17.7859C17.5072 13.7831 17.2339 13.6876 17.0253 13.5022C16.8167 13.3168 16.6897 13.0566 16.6719 12.7781V10.9H17.1449L19.5429 13.274Z"\n  />\n  <path\n    d="M30.9799 17.682L28.489 15.19C28.233 14.9458 27.8928 14.8095 27.539 14.8095C27.1851 14.8095 26.8449 14.9458 26.589 15.19L24.098 17.682L25.017 18.602L26.847 16.815C26.6873 19.0549 25.877 21.1993 24.5156 22.9851C23.1543 24.7709 21.3011 26.1203 19.1836 26.8677C17.0661 27.6151 14.7765 27.7279 12.5958 27.1922C10.4151 26.6566 8.43826 25.4958 6.908 23.8524C5.37774 22.2091 4.36065 20.1546 3.9816 17.9413C3.60256 15.728 3.87805 13.4522 4.77426 11.3933C5.67047 9.33437 7.14839 7.58197 9.02656 6.35121C10.9047 5.12044 13.1014 4.46488 15.347 4.46504V3.16505C12.8371 3.16169 10.3813 3.8942 8.28347 5.27198C6.1856 6.64976 4.53767 8.61236 3.54357 10.9169C2.54947 13.2215 2.2528 15.767 2.69028 18.2384C3.12775 20.7098 4.28018 22.9988 6.00497 24.8221C7.72977 26.6454 9.95126 27.923 12.3946 28.4969C14.838 29.0709 17.396 28.9159 19.7521 28.0512C22.1083 27.1864 24.1593 25.65 25.6514 23.6318C27.1434 21.6136 28.0111 19.2022 28.147 16.6961L30.054 18.603L30.9799 17.682Z"\n  />\n</svg>\n';
const __vite_glob_0_245 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M15.1239 5.62195C20.7403 5.62195 25.3171 10.2551 25.3171 16C25.3171 21.7449 20.7403 26.378 15.1239 26.378V28.061C21.6961 28.061 27 22.6479 27 16C27 9.35214 21.6961 3.93903 15.1239 3.93903C10.0787 3.93903 5.77939 7.13157 4.056 11.6185L5.62702 12.2219C7.11399 8.35055 10.8118 5.62195 15.1239 5.62195Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M5.68293 10.6707V5.34146H4V11.5122C4 11.9769 4.37674 12.3537 4.84146 12.3537H10.4512V10.6707H5.68293Z"\n  />\n</svg>\n';
const __vite_glob_0_246 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M9.3 17.7511C9.3 21.5342 12.3668 24.6011 16.15 24.6011C19.9332 24.6011 23 21.5342 23 17.7511C23 13.9679 19.9332 10.9011 16.15 10.9011V8.60105C21.2034 8.60105 25.3 12.6976 25.3 17.7511C25.3 22.8045 21.2034 26.9011 16.15 26.9011C11.0966 26.9011 7 22.8045 7 17.7511H9.3Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M13.9981 9.70461C13.7382 9.20501 13.9326 8.58935 14.4322 8.32952L19.6779 5.60132L20.6188 7.41055L16.2778 9.66827L18.5355 14.0093L16.7263 14.9503L13.9981 9.70461Z"\n  />\n</svg>\n';
const __vite_glob_0_247 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.73059 16.1238C11.3746 19.5401 13.7576 21.0762 16.0774 21.0762C18.4052 21.0762 20.9277 19.5328 23.8559 16.1238C20.9277 12.7148 18.4052 11.1714 16.0774 11.1714C13.7576 11.1714 11.3746 12.7075 8.73059 16.1238ZM16.0774 9.93333C19.0779 9.93333 22.0234 11.9849 25.1423 15.7275C25.3336 15.9571 25.3336 16.2905 25.1423 16.5201C22.0234 20.2628 19.0779 22.3143 16.0774 22.3143C13.063 22.3143 10.2712 20.2472 7.45718 16.4952C7.2921 16.2751 7.2921 15.9725 7.45718 15.7524C10.2712 12.0004 13.063 9.93333 16.0774 9.93333Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M15.3524 14.9575L14.644 16.1845L15.3524 17.4115H16.7692L17.4776 16.1845L16.7692 14.9575H15.3524ZM14.995 13.7194C14.7738 13.7194 14.5695 13.8374 14.4589 14.029L13.3931 15.875C13.2825 16.0665 13.2825 16.3025 13.3931 16.494L14.4589 18.3401C14.5695 18.5316 14.7738 18.6496 14.995 18.6496H17.1266C17.3478 18.6496 17.5521 18.5316 17.6627 18.3401L18.7285 16.494C18.8391 16.3025 18.8391 16.0665 18.7285 15.875L17.6627 14.029C17.5521 13.8374 17.3478 13.7194 17.1266 13.7194H14.995Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M16 4.2381C9.50408 4.2381 4.2381 9.50408 4.2381 16C4.2381 22.4959 9.50408 27.7619 16 27.7619C22.4959 27.7619 27.7619 22.4959 27.7619 16H29C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C19.0385 3 21.8343 4.04306 24.0476 5.78977V3.61905H25.2857V7.15823C25.2857 7.50012 25.0086 7.77727 24.6667 7.77727H20.9524V6.53918H22.9896C21.0353 5.09282 18.6179 4.2381 16 4.2381Z"\n  />\n</svg>\n';
const __vite_glob_0_248 = '<?xml version="1.0" encoding="utf-8" ?>\n<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\n<svg\n  fill="#000000"\n  viewBox="0 0 32 32"\n  id="icon"\n  xmlns="http://www.w3.org/2000/svg"\n>\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path\n    d="M24,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H24a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,24,30ZM4,22H3.9985L4,28H24V22Z"\n  />\n  <polygon\n    points="30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41"\n  />\n  <path\n    d="M4,14V8H18V6H4A2.0023,2.0023,0,0,0,2,8v6a2.0023,2.0023,0,0,0,2,2H26V14Z"\n  />\n  <rect\n    id="_Transparent_Rectangle_"\n    data-name="&lt;Transparent Rectangle&gt;"\n    class="cls-1"\n    width="32"\n    height="32"\n  />\n</svg>\n';
const __vite_glob_0_249 = '<?xml version="1.0" encoding="utf-8" ?>\n<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\n<svg\n  fill="#000000"\n  viewBox="0 0 32 32"\n  id="icon"\n  xmlns="http://www.w3.org/2000/svg"\n>\n  <defs>\n    <style>\n      .cls-1 {\n        fill: none;\n      }\n    </style>\n  </defs>\n  <path\n    d="M28,12H10a2.0021,2.0021,0,0,1-2-2V4a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12ZM10,4v6H28V4Z"\n  />\n  <path\n    d="M28,30H10a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM10,22v6H28V22Z"\n  />\n  <polygon\n    points="9 16 3.414 10.414 2 11.828 6.172 16 2 20.172 3.414 21.586 9 16"\n  />\n  <rect\n    id="_Transparent_Rectangle_"\n    data-name="&lt;Transparent Rectangle&gt;"\n    class="cls-1"\n    width="32"\n    height="32"\n  />\n</svg>\n';
const __vite_glob_0_250 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M22.288 2.15601H9.712C9.35589 2.15654 9.01455 2.29836 8.76294 2.55035C8.51132 2.80235 8.36999 3.1439 8.37 3.5V28.5C8.37026 28.8559 8.5117 29.1972 8.76329 29.449C9.01488 29.7008 9.35607 29.8425 9.712 29.843H22.288C22.6438 29.8422 22.9849 29.7004 23.2364 29.4487C23.4879 29.197 23.6295 28.8559 23.63 28.5V3.5C23.63 3.1439 23.4887 2.80235 23.2371 2.55035C22.9854 2.29836 22.6441 2.15654 22.288 2.15601ZM9.66999 28.5L9.712 3.457H12.345V28.509L9.66999 28.5ZM13.645 28.514V3.457H22.288C22.2935 3.457 22.299 3.45809 22.3041 3.46021C22.3092 3.46232 22.3138 3.4654 22.3177 3.4693C22.3216 3.4732 22.3247 3.47784 22.3268 3.48294C22.3289 3.48804 22.33 3.49348 22.33 3.49899V5.45401H16.894V6.754H22.325V8.754H19.462V10.054H22.319V12.054H19.462V13.354H22.313V15.354H16.894V16.654H22.308V18.654H19.462V19.954H22.3V21.954H19.462V23.254H22.3V25.254H16.9V26.554H22.3V28.554L13.645 28.514Z"\n  />\n</svg>\n';
const __vite_glob_0_251 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M12.495 2.15601H9.71201C9.35607 2.15654 9.01488 2.29821 8.76329 2.54999C8.5117 2.80176 8.37026 3.14306 8.37 3.49899V28.499C8.37026 28.8549 8.5117 29.1962 8.76329 29.448C9.01488 29.6998 9.35607 29.8415 9.71201 29.842H12.495V2.15601Z"\n  />\n  <path\n    d="M22.288 2.15601H13.495V29.843H22.288C22.644 29.8422 22.9852 29.7003 23.2368 29.4484C23.4883 29.1964 23.6297 28.855 23.63 28.499V3.49899C23.6297 3.14306 23.4883 2.80176 23.2367 2.54999C22.9851 2.29821 22.6439 2.15654 22.288 2.15601ZM22.282 26.395H16.782V25.395H22.282V26.395ZM22.282 23.095H19.352V22.095H22.282V23.095ZM22.282 19.795H19.352V18.795H22.282V19.795ZM22.282 16.495H16.782V15.495H22.282V16.495ZM22.282 13.195H19.352V12.195H22.282V13.195ZM22.282 9.89499H19.352V8.89499H22.282V9.89499ZM22.282 6.595H16.782V5.595H22.282V6.595Z"\n  />\n</svg>\n';
const __vite_glob_0_252 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.9961 9.93213C27.983 9.79957 27.9314 9.66654 27.8407 9.55587C27.8056 9.51308 28.1638 9.87396 22.4967 4.2069C22.3616 4.0718 22.1782 4.00088 21.9993 4.00093C21.5729 4.00093 6.53388 4.00093 6.1091 4.00093C4.94601 4.00093 3.99976 4.94718 3.99976 6.11028V25.8913C3.99976 27.0544 4.94601 28.0006 6.1091 28.0006H25.8901C27.0532 28.0006 27.9994 27.0544 27.9994 25.8913C27.9995 8.82027 28.0013 9.98604 27.9961 9.93213ZM20.1715 5.40716V10.0009C20.1715 10.3885 19.856 10.704 19.4683 10.704H18.5777V5.40716H20.1715ZM17.1715 5.40716V10.704H10.656C10.2683 10.704 9.95285 10.3885 9.95285 10.0009V5.40716H17.1715ZM20.1715 19.0476H9.95285V18.157C9.95285 17.7693 10.2683 17.4539 10.656 17.4539H19.4683C19.856 17.4539 20.1715 17.7693 20.1715 18.157V19.0476ZM9.95285 26.5944V20.4538H20.1715V26.5944H9.95285ZM26.5932 25.8913C26.5932 26.279 26.2778 26.5944 25.8901 26.5944H21.5777C21.5777 25.6777 21.5777 19.2019 21.5777 18.157C21.5777 16.9939 20.6314 16.0476 19.4683 16.0476H10.656C9.49287 16.0476 8.54662 16.9939 8.54662 18.157V26.5944H6.10915C5.72145 26.5944 5.40603 26.279 5.40603 25.8913V6.11028C5.40603 5.72258 5.72145 5.40716 6.10915 5.40716H8.54662V10.0009C8.54662 11.1639 9.49287 12.1102 10.656 12.1102H19.4683C20.6314 12.1102 21.5777 11.1639 21.5777 10.0009V5.40716H21.7083L26.5932 10.2921V25.8913Z"\n  />\n</svg>\n';
const __vite_glob_0_253 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M17.828 20.416C16.9515 20.4176 16.0859 20.2219 15.2954 19.8436C14.5048 19.4653 13.8094 18.9141 13.2607 18.2306C12.712 17.5472 12.324 16.7491 12.1256 15.8954C11.9271 15.0418 11.9232 14.1544 12.1141 13.299C12.305 12.4436 12.6859 11.6421 13.2285 10.9538C13.7712 10.2656 14.4617 9.70818 15.2489 9.32292C16.0361 8.93766 16.8999 8.73439 17.7763 8.72817C18.6528 8.72196 19.5193 8.91297 20.312 9.28703L19.759 10.463C19.0662 10.1353 18.3019 9.98811 17.537 10.0351C16.7721 10.082 16.0315 10.3216 15.384 10.7316C14.7365 11.1415 14.2033 11.7086 13.8337 12.3799C13.4642 13.0513 13.2704 13.8052 13.2704 14.5715C13.2704 15.3379 13.4642 16.0918 13.8337 16.7631C14.2033 17.4345 14.7365 18.0015 15.384 18.4115C16.0315 18.8214 16.7721 19.061 17.537 19.108C18.3019 19.1549 19.0662 19.0077 19.759 18.68L20.313 19.856C19.5365 20.225 18.6876 20.4163 17.828 20.416Z"\n  />\n  <path d="M18.0409 12.4821H10.3529V13.7821H18.0409V12.4821Z" />\n  <path d="M17.4009 15.045H10.3529V16.345H17.4009V15.045Z" />\n  <path\n    d="M16.025 27.527C15.8431 27.5267 15.6636 27.4853 15.5 27.406C8.95095 24.194 5.46995 17.469 5.94995 8.95401L5.95995 8.77101C5.95846 8.45201 6.0832 8.14538 6.30695 7.91801C6.41748 7.8061 6.54902 7.71713 6.69403 7.6562C6.83905 7.59528 6.99467 7.56362 7.15195 7.56302C9.97895 7.56302 10.158 5.96301 10.166 5.64201C10.174 5.33071 10.3027 5.03473 10.525 4.81659C10.7472 4.59845 11.0456 4.47525 11.357 4.47302H20.637C20.9507 4.47508 21.2512 4.59995 21.474 4.82089C21.6968 5.04184 21.8243 5.34126 21.829 5.65501C21.835 5.96701 22.012 7.56302 24.842 7.56302C24.9997 7.56274 25.156 7.59381 25.3016 7.65442C25.4473 7.71503 25.5794 7.80397 25.6904 7.91608C25.8014 8.02819 25.889 8.16123 25.9482 8.30748C26.0073 8.45373 26.0368 8.61027 26.035 8.76802L26.045 8.96101C26.554 17.473 23.093 24.197 16.545 27.406C16.3829 27.4849 16.2052 27.5262 16.025 27.527ZM7.25695 8.86201C7.25695 8.90301 7.25195 8.95301 7.24895 9.01001C6.79895 16.995 10.015 23.269 16.073 26.239C22.027 23.272 25.224 17.001 24.747 9.03401L24.738 8.83401C21.538 8.84402 20.606 6.96601 20.538 5.77501H11.461C11.386 6.95301 10.429 8.82201 7.25695 8.86201Z"\n  />\n</svg>\n';
const __vite_glob_0_254 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M16.0251 27.527C15.8432 27.5267 15.6637 27.4853 15.5001 27.406C8.95108 24.194 5.47008 17.469 5.95008 8.95401L5.96008 8.77101C5.95858 8.45201 6.08332 8.14538 6.30708 7.91801C6.4176 7.8061 6.54914 7.71713 6.69416 7.6562C6.83917 7.59528 6.99479 7.56362 7.15208 7.56302C9.97908 7.56302 10.1581 5.96301 10.1661 5.64201C10.1741 5.33071 10.3029 5.03473 10.5251 4.81659C10.7473 4.59845 11.0457 4.47525 11.3571 4.47302H20.6371C20.9509 4.47508 21.2513 4.59995 21.4742 4.82089C21.697 5.04184 21.8244 5.34126 21.8291 5.65501C21.8351 5.96701 22.0121 7.56302 24.8421 7.56302C24.9998 7.56274 25.1561 7.59381 25.3017 7.65442C25.4474 7.71503 25.5795 7.80397 25.6905 7.91608C25.8015 8.02819 25.8891 8.16123 25.9483 8.30748C26.0074 8.45373 26.0369 8.61027 26.0351 8.76802L26.0451 8.96101C26.5541 17.473 23.0931 24.197 16.5451 27.406C16.383 27.4849 16.2053 27.5262 16.0251 27.527ZM15.2955 19.8436C16.0861 20.2219 16.9516 20.4176 17.8281 20.416C18.6877 20.4163 19.5366 20.225 20.3131 19.856L19.7591 18.68C19.0663 19.0077 18.302 19.1549 17.5371 19.108C16.7722 19.061 16.0316 18.8214 15.3841 18.4115C14.7367 18.0015 14.2034 17.4345 13.8339 16.7631C13.7589 16.627 13.6912 16.4874 13.6309 16.345H17.4011V15.045H13.2953C13.2789 14.8881 13.2706 14.7301 13.2706 14.5715C13.2706 14.3059 13.2938 14.0418 13.3397 13.782H18.0411V12.482H13.7793C13.7971 12.4478 13.8152 12.4138 13.8339 12.3799C14.2034 11.7086 14.7367 11.1415 15.3841 10.7316C16.0316 10.3216 16.7722 10.082 17.5371 10.0351C18.302 9.98811 19.0663 10.1353 19.7591 10.463L20.3121 9.28703C19.5195 8.91297 18.6529 8.72196 17.7765 8.72817C16.9 8.73439 16.0362 8.93766 15.249 9.32292C14.4618 9.70818 13.7713 10.2656 13.2287 10.9538C12.8628 11.4178 12.5705 11.9333 12.3604 12.482H10.3531V13.782H12.0275C11.9704 14.2009 11.9589 14.6244 11.993 15.045H10.3531V16.345H12.2493C12.4672 17.0292 12.8096 17.6687 13.2608 18.2306C13.8095 18.9141 14.5049 19.4653 15.2955 19.8436Z"\n  />\n</svg>\n';
const __vite_glob_0_255 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  svg">\n  <path\n    d="M27.7591 8.908V4.392H4.24106V8.908C3.67006 10.021 0.841064 15.635 0.841064 17.523C0.874133 18.5751 1.31532 19.573 2.07123 20.3056C2.82714 21.0381 3.83844 21.4477 4.89106 21.4477C5.94368 21.4477 6.95498 21.0381 7.71089 20.3056C8.4668 19.573 8.90799 18.5751 8.94106 17.523C8.94106 15.635 6.11006 10.023 5.54106 8.908V5.692H13.8001V26.308H9.16206V27.608H22.8381V26.308H18.2001V5.692H26.4591V8.908C25.8891 10.021 23.0591 15.635 23.0591 17.523C23.0826 18.5815 23.5196 19.5888 24.2766 20.3291C25.0335 21.0695 26.0502 21.484 27.1091 21.484C28.1679 21.484 29.1846 21.0695 29.9415 20.3291C30.6985 19.5888 31.1355 18.5815 31.1591 17.523C31.1611 15.635 28.3301 10.021 27.7591 8.908ZM4.89106 10.508C5.94985 12.5513 6.83465 14.6802 7.53606 16.872H2.24506C2.94694 14.6805 3.83206 12.552 4.89106 10.509V10.508ZM4.89106 20.273C4.27586 20.2715 3.67893 20.0638 3.19565 19.6831C2.71237 19.3024 2.37064 18.7707 2.22506 18.173H7.55606C7.41087 18.7708 7.06942 19.3027 6.58629 19.6836C6.10316 20.0645 5.50627 20.2724 4.89106 20.274V20.273ZM16.9001 5.757V26.243H15.1001V5.757H16.9001ZM29.7551 16.873H24.4641C25.1655 14.6812 26.0503 12.5523 27.1091 10.509C28.1681 12.5523 29.0532 14.6812 29.7551 16.873ZM27.1091 20.273C26.494 20.2714 25.8972 20.0637 25.4141 19.683C24.931 19.3023 24.5894 18.7707 24.4441 18.173H29.7751C29.6297 18.7709 29.288 19.3028 28.8047 19.6837C28.3214 20.0646 27.7244 20.2724 27.1091 20.274V20.273Z"\n  />\n</svg>\n';
const __vite_glob_0_256 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.7591 8.908V4.392H4.24106V8.908C3.67006 10.021 0.841064 15.635 0.841064 17.523C0.874133 18.5751 1.31532 19.573 2.07123 20.3056C2.82714 21.0381 3.83844 21.4477 4.89106 21.4477C5.94368 21.4477 6.95498 21.0381 7.71089 20.3056C8.4668 19.573 8.90799 18.5751 8.94106 17.523C8.94106 15.635 6.11006 10.023 5.54106 8.908V5.692H13.8001V26.308H9.16206V27.608H22.8381V26.308H18.2001V5.692H26.4591V8.908C25.8891 10.021 23.0591 15.635 23.0591 17.523C23.0826 18.5815 23.5196 19.5888 24.2766 20.3291C25.0335 21.0695 26.0502 21.484 27.1091 21.484C28.1679 21.484 29.1846 21.0695 29.9415 20.3291C30.6985 19.5888 31.1355 18.5815 31.1591 17.523C31.1611 15.635 28.3301 10.021 27.7591 8.908ZM4.89106 10.508C5.94985 12.5513 6.83465 14.6802 7.53606 16.872H2.24506C2.94694 14.6805 3.83206 12.552 4.89106 10.509V10.508ZM29.7551 16.873H24.4641C25.1655 14.6812 26.0503 12.5523 27.1091 10.509C28.1681 12.5523 29.0532 14.6812 29.7551 16.873Z"\n  />\n</svg>\n';
const __vite_glob_0_257 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M26.0821 25.433L20.4561 19.618C21.9021 18.0021 22.6663 15.8889 22.5882 13.7218C22.5102 11.5547 21.596 9.50207 20.0374 7.99433C18.4789 6.4866 16.397 5.64097 14.2285 5.6348C12.0601 5.62863 9.97343 6.4624 8.40631 7.96124C6.83919 9.46008 5.91334 11.5075 5.82297 13.6741C5.73259 15.8408 6.48472 17.9582 7.92157 19.5823C9.35842 21.2065 11.3683 22.2111 13.5298 22.3856C15.6913 22.56 17.8364 21.8907 19.5151 20.518L25.1481 26.341L26.0821 25.433ZM14.2001 21.1C12.7825 21.1002 11.3968 20.68 10.218 19.8926C9.03928 19.1052 8.12052 17.986 7.57791 16.6764C7.03531 15.3668 6.89322 13.9257 7.16965 12.5354C7.44608 11.1451 8.12858 9.86794 9.13086 8.86552C10.1331 7.8631 11.4102 7.18041 12.8005 6.90378C14.1908 6.62716 15.6319 6.76903 16.9415 7.31146C18.2512 7.85388 19.3706 8.77249 20.1581 9.95112C20.9457 11.1298 21.3661 12.5155 21.3661 13.933C21.3639 15.833 20.6083 17.6546 19.2649 18.9981C17.9215 20.3417 16.1001 21.0976 14.2001 21.1Z"\n  />\n</svg>\n';
const __vite_glob_0_258 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M28.192 12C28.1901 11.502 28.0272 11.0181 27.7277 10.6203C27.4281 10.2226 27.008 9.93233 26.53 9.79297V4.92297H25.23V9.79297C24.7526 9.9326 24.3334 10.2232 24.0352 10.6212C23.7369 11.0192 23.5757 11.5031 23.5757 12.0005C23.5757 12.4978 23.7369 12.9818 24.0352 13.3798C24.3334 13.7778 24.7526 14.0683 25.23 14.208V27.075H26.53V14.209C27.0082 14.0692 27.4284 13.7786 27.7279 13.3805C28.0274 12.9824 28.1902 12.4982 28.192 12ZM25.88 13.012C25.6798 13.012 25.4841 12.9526 25.3177 12.8414C25.1513 12.7302 25.0216 12.5722 24.945 12.3872C24.8684 12.2023 24.8484 11.9989 24.8874 11.8026C24.9265 11.6062 25.0228 11.4259 25.1644 11.2844C25.3059 11.1428 25.4862 11.0465 25.6825 11.0074C25.8788 10.9684 26.0823 10.9884 26.2672 11.065C26.4522 11.1416 26.6102 11.2713 26.7214 11.4377C26.8326 11.6042 26.892 11.7998 26.892 12C26.8921 12.133 26.866 12.2646 26.8152 12.3875C26.7644 12.5104 26.6899 12.6221 26.5959 12.7162C26.5019 12.8103 26.3903 12.8849 26.2675 12.9359C26.1446 12.9868 26.013 13.013 25.88 13.013V13.012Z"\n  />\n  <path\n    d="M19.92 18.0459V4.92395H18.62V18.0459C18.1431 18.1858 17.7243 18.4765 17.4264 18.8744C17.1284 19.2722 16.9674 19.7559 16.9674 20.2529C16.9674 20.75 17.1284 21.2336 17.4264 21.6315C17.7243 22.0294 18.1431 22.32 18.62 22.4599V27.0759H19.92V22.4599C20.397 22.32 20.8157 22.0294 21.1136 21.6315C21.4116 21.2336 21.5726 20.75 21.5726 20.2529C21.5726 19.7559 21.4116 19.2722 21.1136 18.8744C20.8157 18.4765 20.397 18.1858 19.92 18.0459ZM19.27 21.2639C19.07 21.2639 18.8746 21.2047 18.7083 21.0936C18.5421 20.9825 18.4125 20.8246 18.336 20.6398C18.2594 20.4551 18.2394 20.2518 18.2784 20.0557C18.3174 19.8596 18.4137 19.6794 18.5551 19.5381C18.6965 19.3967 18.8766 19.3004 19.0728 19.2614C19.2689 19.2223 19.4722 19.2424 19.6569 19.3189C19.8416 19.3954 19.9995 19.525 20.1106 19.6913C20.2217 19.8575 20.281 20.053 20.281 20.2529C20.281 20.3857 20.2548 20.5172 20.204 20.6398C20.1532 20.7625 20.0788 20.874 19.9849 20.9678C19.891 21.0617 19.7796 21.1362 19.6569 21.187C19.5342 21.2378 19.4028 21.2639 19.27 21.2639Z"\n  />\n  <path\n    d="M13.3 13.9479V4.92395H12V13.9479C11.5231 14.0878 11.1043 14.3785 10.8063 14.7764C10.5084 15.1742 10.3474 15.6579 10.3474 16.1549C10.3474 16.652 10.5084 17.1356 10.8063 17.5335C11.1043 17.9314 11.5231 18.222 12 18.3619V27.0759H13.3V18.3619C13.7769 18.222 14.1957 17.9314 14.4937 17.5335C14.7916 17.1356 14.9526 16.652 14.9526 16.1549C14.9526 15.6579 14.7916 15.1742 14.4937 14.7764C14.1957 14.3785 13.7769 14.0878 13.3 13.9479ZM12.649 17.1659C12.449 17.1659 12.2536 17.1066 12.0873 16.9955C11.9211 16.8845 11.7915 16.7266 11.715 16.5418C11.6384 16.3571 11.6184 16.1538 11.6574 15.9577C11.6964 15.7616 11.7927 15.5815 11.9341 15.4401C12.0755 15.2987 12.2556 15.2024 12.4518 15.1634C12.6479 15.1244 12.8512 15.1444 13.0359 15.2209C13.2206 15.2974 13.3785 15.427 13.4896 15.5933C13.6007 15.7595 13.66 15.955 13.66 16.1549C13.6597 16.4226 13.5534 16.6794 13.3643 16.8688C13.1752 17.0583 12.9187 17.1651 12.651 17.1659H12.649Z"\n  />\n  <path\n    d="M6.73297 21.368V4.92395H5.43298V21.368C4.95564 21.5076 4.53641 21.7982 4.23816 22.1962C3.93991 22.5942 3.77869 23.0781 3.77869 23.5754C3.77869 24.0728 3.93991 24.5567 4.23816 24.9547C4.53641 25.3527 4.95564 25.6433 5.43298 25.7829V27.0759H6.73297V25.7829C7.21032 25.6433 7.62954 25.3527 7.9278 24.9547C8.22605 24.5567 8.38727 24.0728 8.38727 23.5754C8.38727 23.0781 8.22605 22.5942 7.9278 22.1962C7.62954 21.7982 7.21032 21.5076 6.73297 21.368ZM6.08298 24.5869C5.88278 24.5869 5.68707 24.5276 5.52063 24.4163C5.35419 24.3051 5.22449 24.147 5.14792 23.962C5.07135 23.777 5.05136 23.5735 5.09048 23.3771C5.12961 23.1808 5.22611 23.0005 5.36774 22.859C5.50937 22.7175 5.68976 22.6212 5.88614 22.5823C6.08251 22.5433 6.28605 22.5635 6.47095 22.6403C6.65585 22.717 6.81382 22.8469 6.9249 23.0134C7.03598 23.18 7.09517 23.3757 7.09497 23.5759C7.09497 23.7088 7.06878 23.8403 7.01791 23.9631C6.96704 24.0858 6.89248 24.1973 6.79849 24.2912C6.70451 24.3851 6.59296 24.4595 6.47018 24.5103C6.34741 24.561 6.21583 24.5871 6.08298 24.5869Z"\n  />\n</svg>\n';
const __vite_glob_0_259 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M28.192 12C28.1901 11.502 28.0272 11.0181 27.7277 10.6203C27.4281 10.2226 27.008 9.93233 26.53 9.79297V4.92297H25.23V9.79297C24.7526 9.9326 24.3334 10.2232 24.0352 10.6212C23.7369 11.0192 23.5757 11.5031 23.5757 12.0005C23.5757 12.4978 23.7369 12.9818 24.0352 13.3798C24.3334 13.7778 24.7526 14.0683 25.23 14.208V27.075H26.53V14.209C27.0082 14.0692 27.4284 13.7786 27.7279 13.3805C28.0274 12.9824 28.1902 12.4982 28.192 12Z"\n  />\n  <path\n    d="M19.92 18.0459V4.92395H18.62V18.0459C18.1431 18.1858 17.7243 18.4765 17.4264 18.8744C17.1284 19.2722 16.9674 19.7559 16.9674 20.2529C16.9674 20.75 17.1284 21.2336 17.4264 21.6315C17.7243 22.0294 18.1431 22.32 18.62 22.4599V27.0759H19.92V22.4599C20.397 22.32 20.8157 22.0294 21.1136 21.6315C21.4116 21.2336 21.5726 20.75 21.5726 20.2529C21.5726 19.7559 21.4116 19.2722 21.1136 18.8744C20.8157 18.4765 20.397 18.1858 19.92 18.0459Z"\n  />\n  <path\n    d="M13.3 13.9479V4.92395H12V13.9479C11.5231 14.0878 11.1043 14.3785 10.8063 14.7764C10.5084 15.1742 10.3474 15.6579 10.3474 16.1549C10.3474 16.652 10.5084 17.1356 10.8063 17.5335C11.1043 17.9314 11.5231 18.222 12 18.3619V27.0759H13.3V18.3619C13.7769 18.222 14.1957 17.9314 14.4937 17.5335C14.7916 17.1356 14.9526 16.652 14.9526 16.1549C14.9526 15.6579 14.7916 15.1742 14.4937 14.7764C14.1957 14.3785 13.7769 14.0878 13.3 13.9479Z"\n  />\n  <path\n    d="M6.73297 21.368V4.92395H5.43298V21.368C4.95564 21.5076 4.53641 21.7982 4.23816 22.1962C3.93991 22.5942 3.77869 23.0781 3.77869 23.5754C3.77869 24.0728 3.93991 24.5567 4.23816 24.9547C4.53641 25.3527 4.95564 25.6433 5.43298 25.7829V27.0759H6.73297V25.7829C7.21032 25.6433 7.62954 25.3527 7.9278 24.9547C8.22605 24.5567 8.38727 24.0728 8.38727 23.5754C8.38727 23.0781 8.22605 22.5942 7.9278 22.1962C7.62954 21.7982 7.21032 21.5076 6.73297 21.368Z"\n  />\n</svg>\n';
const __vite_glob_0_260 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.025 27.528C15.843 27.5272 15.6636 27.4855 15.5 27.406C8.95095 24.194 5.46995 17.469 5.94995 8.95401L5.95995 8.771C5.9589 8.61341 5.98889 8.45715 6.04823 8.31116C6.10756 8.16516 6.19507 8.03231 6.30576 7.92014C6.41645 7.80796 6.54815 7.71868 6.69334 7.65741C6.83853 7.59613 6.99437 7.56404 7.15195 7.56299C9.97895 7.56299 10.158 5.963 10.166 5.642C10.1737 5.33052 10.3024 5.03427 10.5246 4.81592C10.7469 4.59757 11.0454 4.47422 11.357 4.47198H20.637C20.9509 4.47405 21.2515 4.59909 21.4744 4.82025C21.6972 5.04141 21.8245 5.34107 21.829 5.655C21.835 5.967 22.012 7.56299 24.842 7.56299C24.9996 7.56298 25.1558 7.59423 25.3013 7.65494C25.4468 7.71564 25.5789 7.8046 25.6898 7.91666C25.8007 8.02871 25.8884 8.16164 25.9476 8.30777C26.0069 8.4539 26.0365 8.61033 26.035 8.76801L26.045 8.961C26.554 17.473 23.093 24.197 16.55 27.406C16.3865 27.486 16.2069 27.5277 16.025 27.528ZM7.25695 8.862C7.25695 8.903 7.25195 8.954 7.24895 9.013C6.79895 16.995 10.015 23.269 16.073 26.238C22.027 23.271 25.224 17.001 24.747 9.03799L24.738 8.83801H24.689C21.563 8.83801 20.6049 6.96299 20.533 5.77899H11.461C11.386 6.95199 10.429 8.821 7.25695 8.862Z"\n  />\n  <path\n    d="M14.474 19.519C14.3032 19.5189 14.1393 19.4513 14.018 19.331L10.983 16.341L11.896 15.415L14.455 17.938L20.269 11.729L21.218 12.618L14.948 19.313C14.8887 19.3761 14.8174 19.4268 14.7382 19.462C14.659 19.4972 14.5736 19.5162 14.487 19.518L14.474 19.519Z"\n  />\n</svg>\n';
const __vite_glob_0_261 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M15.5001 27.406C15.6637 27.4855 15.8431 27.5272 16.0251 27.528C16.2071 27.5277 16.3866 27.486 16.5501 27.406C23.0931 24.197 26.5541 17.473 26.0451 8.961L26.0351 8.76801C26.0367 8.61033 26.007 8.4539 25.9477 8.30777C25.8885 8.16164 25.8009 8.02871 25.6899 7.91666C25.579 7.8046 25.4469 7.71564 25.3014 7.65494C25.1559 7.59423 24.9998 7.56298 24.8421 7.56299C22.0121 7.56299 21.8351 5.967 21.8291 5.655C21.8246 5.34107 21.6973 5.04141 21.4745 4.82025C21.2517 4.59909 20.951 4.47405 20.6371 4.47198H11.3571C11.0455 4.47422 10.747 4.59757 10.5248 4.81592C10.3025 5.03427 10.1739 5.33052 10.1661 5.642C10.1581 5.963 9.97908 7.56299 7.15208 7.56299C6.99449 7.56404 6.83865 7.59613 6.69346 7.65741C6.54827 7.71868 6.41657 7.80796 6.30588 7.92014C6.1952 8.03231 6.10768 8.16516 6.04835 8.31116C5.98902 8.45715 5.95902 8.61341 5.96007 8.771L5.95008 8.95401C5.47008 17.469 8.95108 24.194 15.5001 27.406ZM14.0181 19.331C14.1394 19.4513 14.3033 19.5189 14.4741 19.519L14.4871 19.518C14.5737 19.5162 14.6591 19.4972 14.7383 19.462C14.8174 19.4268 14.8888 19.3761 14.9481 19.313L21.2181 12.618L20.2691 11.729L14.4551 17.938L11.8961 15.415L10.9831 16.341L14.0181 19.331Z"\n  />\n</svg>\n';
const __vite_glob_0_262 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M8.62461 27.0381C10.8077 28.497 13.3744 29.2758 16.0001 29.276C19.5201 29.2723 22.8948 27.8724 25.3839 25.3835L24.5001 24.4379C23.3869 25.5593 22.0573 26.4548 20.5835 27.0653C18.395 27.9718 15.9868 28.209 13.6635 27.7469C11.3402 27.2847 9.20609 26.144 7.53107 24.469C5.85606 22.794 4.71538 20.6599 4.25324 18.3366C3.79111 16.0133 4.02828 13.6051 4.93479 11.4166C5.8413 9.22809 7.37644 7.35754 9.34604 6.04149C11.3157 4.72544 13.6313 4.023 16.0001 4.023C19.1755 4.02671 22.2197 5.28976 24.465 7.53508L25.3766 6.60037C24.1522 5.37921 22.6949 4.40289 21.0818 3.73468C18.656 2.72982 15.9867 2.46685 13.4114 2.97903C10.8362 3.4912 8.47062 4.75552 6.6139 6.6121C4.75718 8.46868 3.49269 10.8341 2.98032 13.4094C2.46795 15.9846 2.73071 18.6539 3.73539 21.0798C4.74006 23.5057 6.44151 25.5792 8.62461 27.0381Z"\n  />\n  <path\n    d="M28.6966 15.2599L25.463 12L24.8574 12.6112L27.7905 15.5682H13V16.4318H27.7905L24.8574 19.3888L25.463 20L28.6966 16.7401C28.8909 16.5436 29 16.2774 29 16C29 15.7226 28.8909 15.4564 28.6966 15.2599Z"\n  />\n</svg>\n';
const __vite_glob_0_263 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16.0046 6H16.0106C16.1476 5.99981 16.2823 6.03577 16.401 6.10424C16.5197 6.17271 16.6182 6.27128 16.6866 6.39L20.3946 12.83C20.4667 12.9473 20.5049 13.0823 20.5049 13.22C20.5049 13.3577 20.4667 13.4927 20.3946 13.61C20.3273 13.7282 20.23 13.8265 20.1126 13.8949C19.9951 13.9634 19.8616 13.9997 19.7256 14H12.2856C12.1482 14.001 12.013 13.9656 11.8937 13.8976C11.7743 13.8295 11.6751 13.7311 11.606 13.6124C11.5369 13.4937 11.5003 13.3588 11.5001 13.2214C11.4999 13.084 11.5359 12.949 11.6046 12.83L15.3286 6.39C15.3971 6.27135 15.4957 6.17284 15.6143 6.10438C15.733 6.03591 15.8676 5.99991 16.0046 6Z"\n  />\n  <path\n    d="M16.0002 26H15.9942C15.8572 26.0002 15.7226 25.9643 15.6039 25.8958C15.4852 25.8273 15.3867 25.7287 15.3182 25.61L11.6102 19.17C11.5382 19.0527 11.5 18.9177 11.5 18.78C11.5 18.6423 11.5382 18.5073 11.6102 18.39C11.6775 18.2719 11.7748 18.1736 11.8923 18.1051C12.0098 18.0366 12.1433 18.0004 12.2792 18L19.7192 18C19.8566 17.9991 19.9918 18.0344 20.1112 18.1025C20.2305 18.1705 20.3298 18.2689 20.3989 18.3876C20.468 18.5064 20.5045 18.6413 20.5047 18.7787C20.505 18.916 20.4689 19.0511 20.4002 19.17L16.6762 25.61C16.6077 25.7287 16.5092 25.8272 16.3905 25.8957C16.2718 25.9641 16.1372 26.0001 16.0002 26Z"\n  />\n</svg>\n';
const __vite_glob_0_264 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M22.5199 28.507L16.5719 23.778H6.79994C6.01417 23.7769 5.26087 23.4643 4.70525 22.9087C4.14962 22.3531 3.837 21.5998 3.83594 20.814V7.054C3.83673 6.26805 4.14923 5.51451 4.70489 4.95866C5.26054 4.40282 6.01399 4.09006 6.79994 4.089H25.1999C25.9859 4.09006 26.7393 4.40282 27.295 4.95866C27.8506 5.51451 28.1631 6.26805 28.1639 7.054V20.814C28.1629 21.5998 27.8503 22.3531 27.2946 22.9087C26.739 23.4643 25.9857 23.7769 25.1999 23.778H23.0169L22.5199 28.507ZM6.79994 5.38901C6.35869 5.3898 5.93576 5.5655 5.62384 5.87761C5.31192 6.18971 5.13647 6.61275 5.13594 7.054V20.814C5.13673 21.2551 5.3123 21.6779 5.62419 21.9897C5.93608 22.3016 6.35887 22.4772 6.79994 22.478H17.0229L21.4699 26.014L21.8399 22.478H25.1999C25.641 22.4772 26.0638 22.3016 26.3757 21.9897C26.6876 21.6779 26.8631 21.2551 26.8639 20.814V7.054C26.8634 6.61275 26.688 6.18971 26.376 5.87761C26.0641 5.5655 25.6412 5.3898 25.1999 5.38901H6.79994Z"\n  />\n  <path d="M22.692 8.683H9.30896V9.983H22.692V8.683Z" />\n  <path d="M22.692 12.89H9.30896V14.19H22.692V12.89Z" />\n  <path d="M22.692 17.098H9.30896V18.398H22.692V17.098Z" />\n</svg>\n';
const __vite_glob_0_265 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M16.5719 23.778L22.5199 28.507L23.0169 23.778H25.1999C25.9857 23.7769 26.739 23.4643 27.2946 22.9087C27.8503 22.353 28.1629 21.5998 28.1639 20.814V7.05399C28.1631 6.26804 27.8506 5.51449 27.295 4.95865C26.7393 4.4028 25.9859 4.09005 25.1999 4.08899H6.79994C6.01399 4.09005 5.26054 4.4028 4.70489 4.95865C4.14923 5.51449 3.83673 6.26804 3.83594 7.05399V20.814C3.837 21.5998 4.14962 22.353 4.70525 22.9087C5.26087 23.4643 6.01417 23.7769 6.79994 23.778H16.5719ZM9.30896 8.68298H22.692V9.98298H9.30896V8.68298ZM9.30896 12.89H22.692V14.19H9.30896V12.89ZM22.692 17.098H9.30896V18.398H22.692V17.098Z"\n  />\n</svg>\n';
const __vite_glob_0_266 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M22.4351 26.552C22.3305 26.5515 22.2276 26.5258 22.1351 26.477L16.0001 23.253L9.86808 26.477C9.76075 26.5334 9.63978 26.5586 9.51886 26.5499C9.39793 26.5411 9.28186 26.4987 9.18377 26.4275C9.08567 26.3562 9.00946 26.2589 8.96375 26.1466C8.91804 26.0344 8.90464 25.9115 8.92508 25.792L10.1001 18.964L5.13508 14.128C5.04806 14.0435 4.98647 13.9363 4.95729 13.8185C4.92811 13.7008 4.93251 13.5772 4.96999 13.4619C5.00748 13.3465 5.07654 13.244 5.16935 13.1659C5.26217 13.0878 5.37501 13.0372 5.49508 13.02L12.3511 12.02L15.4171 5.808C15.4767 5.70637 15.5619 5.6221 15.6642 5.56355C15.7664 5.50499 15.8822 5.47418 16.0001 5.47418C16.1179 5.47418 16.2337 5.50499 16.336 5.56355C16.4382 5.6221 16.5234 5.70637 16.5831 5.808L19.6491 12.02L26.5051 13.02C26.6252 13.0372 26.738 13.0878 26.8308 13.1659C26.9236 13.244 26.9927 13.3465 27.0302 13.4619C27.0677 13.5772 27.0721 13.7008 27.0429 13.8185C27.0137 13.9363 26.9521 14.0435 26.8651 14.128L21.9001 18.964L23.0711 25.792C23.0871 25.8853 23.0826 25.9809 23.0578 26.0722C23.033 26.1635 22.9886 26.2483 22.9277 26.3207C22.8667 26.3931 22.7907 26.4513 22.7049 26.4912C22.6192 26.5312 22.5257 26.5519 22.4311 26.552H22.4351ZM16.0001 21.869C16.1047 21.8692 16.2077 21.895 16.3001 21.944L21.5691 24.714L20.5631 18.847C20.5454 18.743 20.5532 18.6363 20.5858 18.536C20.6183 18.4357 20.6747 18.3448 20.7501 18.271L25.0131 14.116L19.1221 13.26C19.0178 13.2449 18.9187 13.2047 18.8333 13.1429C18.748 13.0811 18.6789 12.9994 18.6321 12.905L16.0001 7.56701L13.3661 12.9C13.3192 12.9944 13.2502 13.0761 13.1648 13.1379C13.0795 13.1997 12.9804 13.2399 12.8761 13.255L6.98508 14.111L11.2481 18.266C11.3234 18.3398 11.3798 18.4307 11.4124 18.531C11.445 18.6313 11.4527 18.738 11.4351 18.842L10.4291 24.709L15.6981 21.939C15.7915 21.8914 15.8952 21.8674 16.0001 21.869Z"\n  />\n</svg>\n';
const __vite_glob_0_267 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M22.4351 26.552C22.3305 26.5515 22.2276 26.5258 22.1351 26.477L16.0001 23.253L9.86808 26.477C9.76075 26.5334 9.63978 26.5586 9.51886 26.5499C9.39793 26.5411 9.28186 26.4987 9.18377 26.4275C9.08567 26.3562 9.00946 26.2589 8.96375 26.1466C8.91804 26.0344 8.90464 25.9115 8.92508 25.792L10.1001 18.964L5.13508 14.128C5.04806 14.0435 4.98647 13.9363 4.95729 13.8185C4.92811 13.7008 4.93251 13.5772 4.96999 13.4619C5.00748 13.3465 5.07654 13.244 5.16935 13.1659C5.26217 13.0878 5.37501 13.0372 5.49508 13.02L12.3511 12.02L15.4171 5.808C15.4767 5.70637 15.5619 5.6221 15.6642 5.56355C15.7664 5.50499 15.8822 5.47418 16.0001 5.47418C16.1179 5.47418 16.2337 5.50499 16.336 5.56355C16.4382 5.6221 16.5234 5.70637 16.5831 5.808L19.6491 12.02L26.5051 13.02C26.6252 13.0372 26.738 13.0878 26.8308 13.1659C26.9236 13.244 26.9927 13.3465 27.0302 13.4619C27.0677 13.5772 27.0721 13.7008 27.0429 13.8185C27.0137 13.9363 26.9521 14.0435 26.8651 14.128L21.9001 18.964L23.0711 25.792C23.0871 25.8853 23.0826 25.9809 23.0578 26.0722C23.033 26.1635 22.9886 26.2483 22.9277 26.3207C22.8667 26.3931 22.7907 26.4513 22.7049 26.4912C22.6192 26.5312 22.5257 26.5519 22.4311 26.552H22.4351Z"\n  />\n</svg>\n';
const __vite_glob_0_268 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M16 28.713C13.7905 28.7104 11.6723 27.8315 10.1099 26.2691C8.54757 24.7067 7.66866 22.5885 7.66602 20.379V8.52299H8.96603V20.379C8.96603 21.3026 9.14793 22.2171 9.50137 23.0704C9.85481 23.9237 10.3729 24.699 11.0259 25.3521C11.679 26.0052 12.4543 26.5232 13.3076 26.8766C14.1609 27.2301 15.0754 27.412 15.999 27.412C16.9226 27.412 17.8371 27.2301 18.6904 26.8766C19.5437 26.5232 20.319 26.0052 20.9721 25.3521C21.6252 24.699 22.1432 23.9237 22.4967 23.0704C22.8501 22.2171 23.032 21.3026 23.032 20.379V11.707H24.332V20.379C24.3294 22.5882 23.4508 24.7061 21.8889 26.2684C20.3269 27.8307 18.2092 28.7098 16 28.713Z"\n  />\n  <path d="M20.325 7.20599H19.024V17.864H20.325V7.20599Z" />\n  <path d="M13.1101 4.793H11.8091V17.864H13.1101V4.793Z" />\n  <path d="M16.717 3.937H15.416V17.864H16.717V3.937Z" />\n</svg>\n';
const __vite_glob_0_269 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.766 5H4.23398C3.5314 5.00079 2.85782 5.28024 2.36102 5.77704C1.86422 6.27384 1.58478 6.94741 1.58398 7.64999V24.65C1.58478 25.3526 1.86422 26.0261 2.36102 26.5229C2.85782 27.0197 3.5314 27.2992 4.23398 27.3H27.766C28.4686 27.2992 29.1421 27.0197 29.6389 26.5229C30.1357 26.0261 30.4152 25.3526 30.416 24.65V7.64999C30.4152 6.94741 30.1357 6.27384 29.6389 5.77704C29.1421 5.28024 28.4686 5.00079 27.766 5ZM19.941 6.29999V26H12.06V6.29999H19.941ZM2.88399 24.65V7.64999C2.88425 7.29203 3.02656 6.94883 3.27968 6.69571C3.5328 6.44259 3.87602 6.30025 4.23398 6.29999H10.76V26H4.23398C3.87602 25.9997 3.5328 25.8574 3.27968 25.6043C3.02656 25.3512 2.88425 25.008 2.88399 24.65ZM29.116 24.65C29.1157 25.008 28.9734 25.3512 28.7203 25.6043C28.4672 25.8574 28.124 25.9997 27.766 26H21.241V6.29999H27.766C28.124 6.30025 28.4672 6.44259 28.7203 6.69571C28.9734 6.94883 29.1157 7.29203 29.116 7.64999V24.65Z"\n  />\n  <path d="M27.606 9.37201H22.728V10.673H27.606V9.37201Z" />\n  <path d="M27.606 13.507H22.728V14.808H27.606V13.507Z" />\n  <path d="M27.606 17.643H22.728V18.944H27.606V17.643Z" />\n  <path d="M27.606 21.779H22.728V23.08H27.606V21.779Z" />\n  <path d="M18.44 9.37201H13.561V10.673H18.44V9.37201Z" />\n  <path d="M18.44 13.507H13.561V14.808H18.44V13.507Z" />\n  <path d="M18.44 17.643H13.561V18.944H18.44V17.643Z" />\n  <path d="M18.44 21.779H13.561V23.08H18.44V21.779Z" />\n  <path d="M9.27204 9.37201H4.39404V10.673H9.27204V9.37201Z" />\n  <path d="M9.27204 13.507H4.39404V14.808H9.27204V13.507Z" />\n  <path d="M9.27204 17.643H4.39404V18.944H9.27204V17.643Z" />\n  <path d="M9.27204 21.779H4.39404V23.08H9.27204V21.779Z" />\n</svg>\n';
const __vite_glob_0_270 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.767 4.892H4.233C3.53042 4.89279 2.85685 5.17224 2.36005 5.66904C1.86325 6.16584 1.5838 6.83941 1.58301 7.54199V24.542C1.5838 25.2446 1.86325 25.9181 2.36005 26.4149C2.85685 26.9117 3.53042 27.1912 4.233 27.192H27.767C28.4696 27.1912 29.1432 26.9117 29.64 26.4149C30.1368 25.9181 30.4162 25.2446 30.417 24.542V7.54199C30.4162 6.83941 30.1368 6.16584 29.64 5.66904C29.1432 5.17224 28.4696 4.89279 27.767 4.892ZM19.94 6.19199V25.892H12.061V6.19199H19.94ZM2.884 24.542V7.54199C2.88427 7.1842 3.02646 6.84113 3.27936 6.58804C3.53226 6.33496 3.87521 6.19252 4.233 6.19199H10.76V25.892H4.233C3.87521 25.8915 3.53226 25.749 3.27936 25.4959C3.02646 25.2429 2.88427 24.8998 2.884 24.542ZM29.116 24.542C29.1157 24.8998 28.9735 25.2429 28.7206 25.4959C28.4677 25.749 28.1248 25.8915 27.767 25.892H21.241V6.19199H27.767C28.1248 6.19252 28.4677 6.33496 28.7206 6.58804C28.9735 6.84113 29.1157 7.1842 29.116 7.54199V24.542Z"\n  />\n</svg>\n';
const __vite_glob_0_271 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M10.76 4.85001H4.233C3.53042 4.8508 2.85685 5.13025 2.36005 5.62704C1.86325 6.12384 1.5838 6.79742 1.58301 7.5V24.5C1.5838 25.2026 1.86325 25.8762 2.36005 26.373C2.85685 26.8698 3.53042 27.1492 4.233 27.15H10.76V4.85001Z"\n  />\n  <path d="M19.941 4.85001H12.061V27.151H19.941V4.85001Z" />\n  <path\n    d="M27.767 4.85001H21.241V27.15H27.767C28.4695 27.1492 29.1431 26.8698 29.6399 26.373C30.1367 25.8762 30.4162 25.2026 30.417 24.5V7.5C30.4162 6.79742 30.1367 6.12384 29.6399 5.62704C29.1431 5.13025 28.4695 4.8508 27.767 4.85001Z"\n  />\n</svg>\n';
const __vite_glob_0_272 = '<?xml version="1.0" encoding="utf-8" ?>\n<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\n<svg fill="#000000" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">\n  <path\n    d="M1800 1740c0 33-26.88 60-60 60H180c-33.12 0-60-27-60-60V180c0-33.12 26.88-60 60-60h1560c33.12 0 60 26.88 60 60v1560ZM1740 0H180C80.76 0 0 80.76 0 180v1560c0 99.24 80.76 180 180 180h1560c99.24 0 180-80.76 180-180V180c0-99.24-80.76-180-180-180Zm-235.08 245.388L960 790.308l-544.92-544.92-169.68 169.68 544.92 544.92-544.92 544.92 169.68 169.68L960 1129.668l544.92 544.92 169.68-169.68-544.92-544.92 544.92-544.92-169.68-169.68Z"\n    fill-rule="evenodd"\n  />\n</svg>\n';
const __vite_glob_0_273 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M28.2159 5H4.68393C3.98135 5.00079 3.30777 5.28024 2.81097 5.77704C2.31417 6.27384 2.03473 6.94741 2.03394 7.64999V24.65C2.03473 25.3526 2.31417 26.0261 2.81097 26.5229C3.30777 27.0197 3.98135 27.2992 4.68393 27.3H28.2159C28.9185 27.2992 29.5921 27.0197 30.0889 26.5229C30.5857 26.0261 30.8651 25.3526 30.8659 24.65V7.64999C30.8651 6.94741 30.5857 6.27384 30.0889 5.77704C29.5921 5.28024 28.9185 5.00079 28.2159 5ZM9.72192 23.08H4.84393V21.78H9.72192V23.08ZM9.72192 18.944H4.84393V17.644H9.72192V18.944ZM9.72192 14.808H4.84393V13.508H9.72192V14.808ZM9.72192 10.672H4.84393V9.37198H9.72192V10.672ZM18.8889 22.865H14.0099V21.565H18.8889V22.865ZM18.8889 18.729H14.0099V17.429H18.8889V18.729ZM18.8889 14.593H14.0099V13.293H18.8889V14.593ZM18.8889 10.458H14.0099V9.15799H18.8889V10.458ZM28.0559 22.865H23.1769V21.565H28.0559V22.865ZM28.0559 18.729H23.1769V17.429H28.0559V18.729ZM28.0559 14.593H23.1769V13.293H28.0559V14.593ZM28.0559 10.458H23.1769V9.15799H28.0559V10.458Z"\n  />\n</svg>\n';
const __vite_glob_0_274 = '<?xml version="1.0" encoding="utf-8" ?>\n<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\n<svg fill="#000000" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">\n  <path\n    d="M1740 0c99.24 0 180 80.76 180 180v1560c0 99.24-80.76 180-180 180H180c-99.24 0-180-80.76-180-180V180C0 80.76 80.76 0 180 0h1560ZM894 1800v-774H120v677.25c0 53.213 43.537 96.75 96.75 96.75H894Zm0-906V120H216.75c-53.213 0-96.75 43.537-96.75 96.75V894h774Zm906 809.25V1026h-774v774h677.25c53.213 0 96.75-43.537 96.75-96.75Zm0-809.25V216.75c0-53.213-43.537-96.75-96.75-96.75H1026v774h774Z"\n    fill-rule="evenodd"\n  />\n</svg>\n';
const __vite_glob_0_275 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M26.2143 5H17.5714C17.363 5.00005 17.1632 5.08287 17.0159 5.23024L5.23006 17.016C4.92331 17.3229 4.92331 17.8202 5.23006 18.127L13.873 26.7699C14.1798 27.0766 14.6772 27.0766 14.984 26.7699L26.7698 14.9841C26.9171 14.8368 27 14.637 27 14.4286V5.78574C27 5.35178 26.6482 5 26.2143 5ZM25.4286 14.1033L14.4285 25.1034L6.89656 17.5715L17.8967 6.57142H25.4286V14.1033Z"\n  />\n  <path\n    d="M21.5 8.14291C20.1982 8.14291 19.1428 9.19825 19.1428 10.5001C19.1428 11.8019 20.1982 12.8572 21.5 12.8572C22.8018 12.8572 23.8571 11.8019 23.8571 10.5001C23.8571 9.19825 22.8018 8.14291 21.5 8.14291ZM21.5 11.2858C21.066 11.2858 20.7142 10.934 20.7142 10.5C20.7142 10.0661 21.066 9.71429 21.5 9.71429C21.9339 9.71429 22.2857 10.0661 22.2857 10.5C22.2857 10.934 21.9339 11.2858 21.5 11.2858Z"\n  />\n</svg>\n';
const __vite_glob_0_276 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M20.7142 10.5C20.7142 10.934 21.066 11.2858 21.5 11.2858C21.9339 11.2858 22.2857 10.934 22.2857 10.5C22.2857 10.0661 21.9339 9.71429 21.5 9.71429C21.066 9.71429 20.7142 10.0661 20.7142 10.5Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M17.5714 5H26.2143C26.6482 5 27 5.35178 27 5.78574V14.4286C27 14.637 26.9171 14.8368 26.7698 14.9841L14.984 26.7699C14.6772 27.0766 14.1798 27.0766 13.873 26.7699L5.23006 18.127C4.92331 17.8202 4.92331 17.3229 5.23006 17.016L17.0159 5.23024C17.1632 5.08287 17.363 5.00005 17.5714 5ZM19.1428 10.5001C19.1428 9.19825 20.1982 8.14291 21.5 8.14291C22.8018 8.14291 23.8571 9.19825 23.8571 10.5001C23.8571 11.8019 22.8018 12.8572 21.5 12.8572C20.1982 12.8572 19.1428 11.8019 19.1428 10.5001Z"\n  />\n</svg>\n';
const __vite_glob_0_277 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M20.4167 6.60415C20.4167 5.16831 19.2484 4 17.8125 4C16.3767 4 15.2084 5.16831 15.2084 6.60415V22.8187C14.5436 23.5002 14.1667 24.4117 14.1667 25.3542C14.1667 27.3643 15.8025 29 17.8126 29C19.8227 29 21.4584 27.3643 21.4584 25.3542C21.4584 24.4117 21.0815 23.5002 20.4167 22.8187V6.60415ZM17.8125 27.9583C16.3767 27.9583 15.2084 26.79 15.2084 25.3542C15.2084 24.6167 15.5171 23.9321 16.0782 23.427C16.1875 23.3278 16.2501 23.1875 16.2501 23.0399V6.60415C16.2501 5.74253 16.951 5.04165 17.8126 5.04165C18.6742 5.04165 19.3751 5.74253 19.3751 6.60415V23.0399C19.3751 23.1874 19.4376 23.3278 19.547 23.427C20.1081 23.932 20.4168 24.6167 20.4168 25.3542C20.4167 26.79 19.2484 27.9583 17.8125 27.9583Z"\n  />\n  <path\n    d="M18.3334 23.8876V14.9375C18.3334 14.6496 18.1004 14.4167 17.8125 14.4167C17.5246 14.4167 17.2917 14.6496 17.2917 14.9375V23.8876C16.6867 24.1033 16.25 24.676 16.25 25.3541C16.25 26.2158 16.9509 26.9166 17.8125 26.9166C18.6741 26.9166 19.375 26.2158 19.375 25.3541C19.375 24.676 18.9383 24.1033 18.3334 23.8876ZM17.8125 25.875C17.5251 25.875 17.2917 25.6415 17.2917 25.3541C17.2917 25.0668 17.5251 24.8333 17.8125 24.8333C18.0999 24.8333 18.3334 25.0667 18.3334 25.3541C18.3334 25.6415 18.0999 25.875 17.8125 25.875Z"\n  />\n  <path\n    d="M13.6458 20.6667H10.5208C10.233 20.6667 10 20.8996 10 21.1875C10 21.4754 10.233 21.7084 10.5208 21.7084H13.6458C13.9337 21.7084 14.1667 21.4754 14.1667 21.1875C14.1667 20.8996 13.9337 20.6667 13.6458 20.6667Z"\n  />\n  <path\n    d="M13.6459 18.5833H12.6042C12.3163 18.5833 12.0834 18.8163 12.0834 19.1042C12.0834 19.392 12.3163 19.625 12.6042 19.625H13.6459C13.9338 19.625 14.1667 19.392 14.1667 19.1041C14.1667 18.8163 13.9338 18.5833 13.6459 18.5833Z"\n  />\n  <path\n    d="M13.6459 16.5H12.6042C12.3163 16.5 12.0834 16.733 12.0834 17.0208C12.0834 17.3087 12.3163 17.5417 12.6042 17.5417H13.6459C13.9338 17.5417 14.1667 17.3087 14.1667 17.0208C14.1667 16.733 13.9338 16.5 13.6459 16.5Z"\n  />\n  <path\n    d="M10.5208 15.4584H13.6458C13.9337 15.4584 14.1667 15.2254 14.1667 14.9375C14.1667 14.6496 13.9337 14.4167 13.6458 14.4167H10.5208C10.233 14.4167 10 14.6496 10 14.9375C10 15.2254 10.233 15.4584 10.5208 15.4584Z"\n  />\n  <path\n    d="M10.5208 9.20836H13.6458C13.9337 9.20836 14.1667 8.9754 14.1667 8.68751C14.1667 8.39962 13.9337 8.16666 13.6458 8.16666H10.5208C10.233 8.16666 10 8.39962 10 8.68751C10 8.9754 10.233 9.20836 10.5208 9.20836Z"\n  />\n  <path\n    d="M13.6459 12.3333H12.6042C12.3163 12.3333 12.0834 12.5663 12.0834 12.8542C12.0834 13.142 12.3163 13.375 12.6042 13.375H13.6459C13.9338 13.375 14.1667 13.142 14.1667 12.8541C14.1667 12.5663 13.9338 12.3333 13.6459 12.3333Z"\n  />\n  <path\n    d="M13.6459 10.25H12.6042C12.3163 10.25 12.0834 10.483 12.0834 10.7709C12.0834 11.0587 12.3163 11.2917 12.6042 11.2917H13.6459C13.9338 11.2917 14.1667 11.0587 14.1667 10.7709C14.1667 10.483 13.9338 10.25 13.6459 10.25Z"\n  />\n</svg>\n';
const __vite_glob_0_278 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M20.4167 6.60415C20.4167 5.16831 19.2484 4 17.8125 4C16.3766 4 15.2084 5.16831 15.2084 6.60415V22.8187C14.5436 23.5002 14.1667 24.4117 14.1667 25.3542C14.1667 27.3643 15.8025 29 17.8126 29C19.8226 29 21.4584 27.3643 21.4584 25.3542C21.4584 24.4117 21.0815 23.5002 20.4167 22.8187V6.60415ZM18.3334 14.9375V23.8876C18.9383 24.1033 19.375 24.676 19.375 25.3541C19.375 26.2158 18.6741 26.9166 17.8125 26.9166C16.9509 26.9166 16.25 26.2158 16.25 25.3541C16.25 24.676 16.6867 24.1033 17.2917 23.8876V14.9375C17.2917 14.6496 17.5246 14.4167 17.8125 14.4167C18.1004 14.4167 18.3334 14.6496 18.3334 14.9375ZM17.2917 25.3541C17.2917 25.6415 17.5251 25.875 17.8125 25.875C18.0999 25.875 18.3334 25.6415 18.3334 25.3541C18.3334 25.0667 18.0999 24.8333 17.8125 24.8333C17.5251 24.8333 17.2917 25.0668 17.2917 25.3541Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M13.6458 9.20836H10.5208C10.233 9.20836 10 8.9754 10 8.68751C10 8.39962 10.233 8.16666 10.5208 8.16666H13.6458C13.9337 8.16666 14.1667 8.39962 14.1667 8.68751C14.1667 8.9754 13.9337 9.20836 13.6458 9.20836ZM10.5208 15.4584H13.6458C13.9337 15.4584 14.1667 15.2254 14.1667 14.9375C14.1667 14.6496 13.9337 14.4167 13.6458 14.4167H10.5208C10.233 14.4167 10 14.6496 10 14.9375C10 15.2254 10.233 15.4584 10.5208 15.4584ZM12.6042 16.5H13.6459C13.9337 16.5 14.1667 16.733 14.1667 17.0208C14.1667 17.3087 13.9337 17.5417 13.6459 17.5417H12.6042C12.3163 17.5417 12.0834 17.3087 12.0834 17.0208C12.0834 16.733 12.3163 16.5 12.6042 16.5ZM13.6459 18.5833H12.6042C12.3163 18.5833 12.0834 18.8163 12.0834 19.1042C12.0834 19.392 12.3163 19.625 12.6042 19.625H13.6459C13.9337 19.625 14.1667 19.392 14.1667 19.1041C14.1667 18.8163 13.9337 18.5833 13.6459 18.5833ZM13.6458 20.6667H10.5208C10.233 20.6667 10 20.8996 10 21.1875C10 21.4754 10.233 21.7084 10.5208 21.7084H13.6458C13.9337 21.7084 14.1667 21.4754 14.1667 21.1875C14.1667 20.8996 13.9337 20.6667 13.6458 20.6667ZM13.6459 12.3333H12.6042C12.3163 12.3333 12.0834 12.5663 12.0834 12.8542C12.0834 13.142 12.3163 13.375 12.6042 13.375H13.6459C13.9337 13.375 14.1667 13.142 14.1667 12.8541C14.1667 12.5663 13.9337 12.3333 13.6459 12.3333ZM12.6042 10.25H13.6459C13.9337 10.25 14.1667 10.483 14.1667 10.7709C14.1667 11.0587 13.9337 11.2917 13.6459 11.2917H12.6042C12.3163 11.2917 12.0834 11.0587 12.0834 10.7709C12.0834 10.483 12.3163 10.25 12.6042 10.25Z"\n  />\n</svg>\n';
const __vite_glob_0_279 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path d="M27.469 8.79199H4.53003V10.093H27.469V8.79199Z" />\n  <path d="M27.469 15.35H4.53003V16.651H27.469V15.35Z" />\n  <path d="M16.11 21.907H4.53003V23.208H16.11V21.907Z" />\n</svg>\n';
const __vite_glob_0_280 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path d="M27.469 12H4.53003V13.301H27.469V12Z" />\n  <path d="M16.11 18.558H4.53003V19.859H16.11V18.558Z" />\n</svg>\n';
const __vite_glob_0_281 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M13.1395 22C12.8391 21.9998 12.5508 21.887 12.3376 21.6862L7 16.6965L8.60566 15.1512L13.1061 19.3616L23.331 9L25 10.4836L13.9731 21.6562C13.8688 21.7615 13.7433 21.8461 13.6041 21.9048C13.4649 21.9636 13.3147 21.9954 13.1624 21.9983L13.1395 22Z"\n  />\n</svg>\n';
const __vite_glob_0_282 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M21.7811 11.7038L14.1991 11.719L14.2017 13.019L21.7837 13.0038L21.7811 11.7038Z"\n  />\n  <path\n    d="M12.4781 11.7225L10.2411 11.727L10.2437 13.027L12.4807 13.0225L12.4781 11.7225Z"\n  />\n  <path\n    d="M21.79 16.1819L14.209 16.198L14.2118 17.498L21.7927 17.4819L21.79 16.1819Z"\n  />\n  <path\n    d="M12.4881 16.2022L10.2511 16.207L10.2539 17.507L12.4909 17.5021L12.4881 16.2022Z"\n  />\n  <path\n    d="M21.799 20.6618L14.218 20.678L14.2208 21.978L21.8018 21.9618L21.799 20.6618Z"\n  />\n  <path\n    d="M12.497 20.6816L10.26 20.686L10.2626 21.986L12.4996 21.9816L12.497 20.6816Z"\n  />\n  <path\n    d="M27.718 4.968C27.7179 4.88278 27.701 4.7984 27.6683 4.71971C27.6355 4.64102 27.5876 4.56956 27.5273 4.50938C27.4669 4.44921 27.3953 4.40151 27.3165 4.36902C27.2377 4.33653 27.1533 4.31988 27.068 4.32001H4.92404C4.8386 4.32001 4.75399 4.33684 4.67506 4.36957C4.59614 4.4023 4.52444 4.45026 4.46407 4.51073C4.4037 4.57119 4.35585 4.64298 4.32324 4.72196C4.29064 4.80093 4.27392 4.88555 4.27405 4.97099L4.28204 8.33901C4.28204 8.42432 4.29887 8.50878 4.33154 8.58759C4.36422 8.66639 4.41212 8.73799 4.47249 8.79826C4.53286 8.85854 4.60453 8.90633 4.68338 8.93889C4.76224 8.97145 4.84674 8.98814 4.93205 8.98801H6.11005L6.14804 27.032C6.14817 27.1172 6.16509 27.2016 6.19783 27.2803C6.23057 27.359 6.27848 27.4304 6.33884 27.4906C6.3992 27.5508 6.47082 27.5985 6.54961 27.631C6.6284 27.6635 6.71282 27.6801 6.79805 27.68C6.89006 27.6799 6.98102 27.6605 7.06505 27.623L11.4171 25.661L15.7791 27.604C15.8626 27.6418 15.9533 27.6614 16.045 27.6614C16.1368 27.6614 16.2275 27.6418 16.3111 27.604L20.663 25.641L25.024 27.585C25.1235 27.6292 25.2324 27.6477 25.3409 27.6389C25.4493 27.63 25.5538 27.5941 25.6448 27.5344C25.7357 27.4747 25.8103 27.3931 25.8615 27.2971C25.9127 27.2011 25.9391 27.0938 25.938 26.985L25.9 8.985H27.076C27.1616 8.985 27.2463 8.96812 27.3253 8.93533C27.4042 8.90254 27.476 8.85449 27.5364 8.79392C27.5968 8.73335 27.6446 8.66145 27.6771 8.58235C27.7097 8.50326 27.7263 8.41852 27.726 8.33299L27.718 4.968ZM24.636 25.989L20.926 24.335C20.8424 24.2979 20.752 24.2788 20.6606 24.2788C20.5691 24.2788 20.4787 24.2979 20.3951 24.335L16.0421 26.297L11.681 24.353C11.5972 24.3161 11.5066 24.2971 11.415 24.2971C11.3235 24.2971 11.2329 24.3161 11.149 24.353L7.44905 26.023L7.41205 8.98599H24.6001L24.636 25.989ZM5.58005 7.689V5.621H26.42V7.689H5.58005Z"\n  />\n</svg>\n';
const __vite_glob_0_283 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M27.6681 4.71971C27.7009 4.7984 27.7178 4.88278 27.7179 4.968L27.7259 8.33299C27.7262 8.41852 27.7096 8.50326 27.677 8.58235C27.6445 8.66145 27.5966 8.73335 27.5363 8.79392C27.4759 8.85449 27.4041 8.90254 27.3251 8.93534C27.2461 8.96813 27.1615 8.985 27.0759 8.985H25.8999L25.9379 26.985C25.9389 27.0938 25.9126 27.2011 25.8614 27.2971C25.8101 27.3931 25.7356 27.4747 25.6447 27.5344C25.5537 27.5941 25.4492 27.63 25.3407 27.6389C25.2323 27.6477 25.1234 27.6292 25.0239 27.585L20.6629 25.641L16.3109 27.604C16.2274 27.6418 16.1367 27.6614 16.0449 27.6614C15.9532 27.6614 15.8625 27.6418 15.7789 27.604L11.4169 25.661L7.06493 27.623C6.9809 27.6605 6.88994 27.6799 6.79793 27.68C6.7127 27.6801 6.62828 27.6635 6.54949 27.631C6.47069 27.5985 6.39907 27.5508 6.33872 27.4906C6.27836 27.4304 6.23045 27.359 6.19771 27.2803C6.16497 27.2016 6.14805 27.1172 6.14792 27.032L6.10993 8.98801H4.93193C4.84662 8.98814 4.76212 8.97145 4.68326 8.93889C4.6044 8.90633 4.53274 8.85854 4.47237 8.79827C4.412 8.73799 4.3641 8.66639 4.33142 8.58759C4.29874 8.50878 4.28192 8.42432 4.28192 8.33901L4.27393 4.97099C4.2738 4.88555 4.29051 4.80093 4.32312 4.72196C4.35573 4.64298 4.40357 4.57119 4.46394 4.51073C4.52432 4.45026 4.59602 4.4023 4.67494 4.36957C4.75387 4.33684 4.83848 4.32001 4.92392 4.32001H27.0679C27.1531 4.31988 27.2376 4.33653 27.3164 4.36902C27.3952 4.40151 27.4668 4.44921 27.5271 4.50939C27.5875 4.56956 27.6354 4.64102 27.6681 4.71971ZM21.7809 11.7038L14.1989 11.719L14.2015 13.019L21.7835 13.0038L21.7809 11.7038ZM12.4779 11.7225L10.2409 11.727L10.2435 13.027L12.4805 13.0225L12.4779 11.7225ZM14.2089 16.198L21.7899 16.1819L21.7927 17.4819L14.2117 17.498L14.2089 16.198ZM12.4879 16.2021L10.2509 16.207L10.2538 17.507L12.4907 17.5021L12.4879 16.2021ZM14.218 20.678L21.7989 20.6618L21.8017 21.9618L14.2207 21.978L14.218 20.678ZM12.4969 20.6816L10.2599 20.686L10.2625 21.986L12.4995 21.9816L12.4969 20.6816Z"\n  />\n</svg>\n';
const __vite_glob_0_284 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M11.1553 8H20.8447L25 15.8123L20.8293 23H11.1707L7 15.8123L11.1553 8ZM11.9133 9.2069L8.41313 15.7874L11.8979 21.7931H20.1021L23.5869 15.7874L20.0867 9.2069H11.9133Z"\n  />\n  <path d="M24.245 15.35H30.288V16.65H24.245V15.35Z" />\n  <path d="M1.71204 15.35H8.03204V16.65H1.71204V15.35Z" />\n</svg>\n';
const __vite_glob_0_285 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M11.1553 8H20.8447L25 15.8123L20.8293 23H11.1707L7 15.8123L11.1553 8Z"\n  />\n  <path d="M24.245 15.35H30.288V16.65H24.245V15.35Z" />\n  <path d="M1.71204 15.35H8.03204V16.65H1.71204V15.35Z" />\n</svg>\n';
const __vite_glob_0_286 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M4 8C2.89543 8 2 8.89543 2 10V22C2 23.1046 2.89543 24 4 24H28C29.1046 24 30 23.1046 30 22V10C30 8.89543 29.1046 8 28 8H4ZM5 10C4.44772 10 4 10.4477 4 11V21C4 21.5523 4.44772 22 5 22H15C15.5523 22 16 21.5523 16 21V11C16 10.4477 15.5523 10 15 10H5Z"\n  />\n</svg>\n';
const __vite_glob_0_287 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M4 8C2.89543 8 2 8.89543 2 10V22C2 23.1046 2.89543 24 4 24H28C29.1046 24 30 23.1046 30 22V10C30 8.89543 29.1046 8 28 8H4ZM17 10C16.4477 10 16 10.4477 16 11V21C16 21.5523 16.4477 22 17 22H27C27.5523 22 28 21.5523 28 21V11C28 10.4477 27.5523 10 27 10H17Z"\n  />\n</svg>\n';
const __vite_glob_0_288 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.452 21.87H22.823C22.518 21.8697 22.2257 21.7485 22.0101 21.5329C21.7945 21.3173 21.6732 21.0249 21.673 20.72V6.56601C21.6735 6.26117 21.7948 5.96897 22.0104 5.75342C22.2259 5.53787 22.5181 5.41651 22.823 5.41599H27.452C27.7569 5.41651 28.0492 5.53783 28.2649 5.75336C28.4806 5.96888 28.6022 6.26108 28.603 6.56601V20.72C28.6024 21.025 28.481 21.3173 28.2652 21.5329C28.0494 21.7485 27.757 21.8697 27.452 21.87ZM22.974 20.57H27.3V6.71701H22.972L22.974 20.57Z"\n  />\n  <path\n    d="M18.3139 26.584H13.6859C13.381 26.5835 13.0887 26.4622 12.873 26.2466C12.6572 26.0311 12.5357 25.7389 12.5349 25.434V6.56601C12.5357 6.26108 12.6572 5.96888 12.873 5.75336C13.0887 5.53783 13.381 5.41651 13.6859 5.41599H18.3139C18.6188 5.41651 18.9111 5.53783 19.1269 5.75336C19.3426 5.96888 19.4641 6.26108 19.4649 6.56601V25.434C19.4641 25.7389 19.3426 26.0311 19.1269 26.2466C18.9111 26.4622 18.6188 26.5835 18.3139 26.584ZM13.8359 25.284H18.1639V6.71701H13.8359V25.284Z"\n  />\n  <path\n    d="M9.17697 16.938H4.54797C4.24287 16.9375 3.95042 16.816 3.73468 16.6003C3.51894 16.3845 3.3975 16.0921 3.39697 15.787V6.56601C3.39777 6.26108 3.5193 5.96888 3.73502 5.75336C3.95073 5.53783 4.24304 5.41651 4.54797 5.41599H9.17697C9.48181 5.41651 9.77401 5.53787 9.98956 5.75342C10.2051 5.96897 10.3264 6.26117 10.327 6.56601V15.787C10.3267 16.092 10.2055 16.3845 9.9899 16.6002C9.77432 16.816 9.48198 16.9375 9.17697 16.938ZM4.69797 15.638H9.02597V6.71799H4.69998L4.69797 15.638Z"\n  />\n</svg>\n';
const __vite_glob_0_289 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M27.452 21.87H22.823C22.518 21.8697 22.2257 21.7485 22.0101 21.5329C21.7945 21.3173 21.6732 21.0249 21.673 20.72V6.56601C21.6735 6.26117 21.7948 5.96897 22.0104 5.75342C22.2259 5.53787 22.5181 5.41651 22.823 5.41599H27.452C27.7569 5.41651 28.0492 5.53783 28.2649 5.75336C28.4806 5.96888 28.6022 6.26108 28.603 6.56601V20.72C28.6024 21.025 28.481 21.3173 28.2652 21.5329C28.0494 21.7485 27.757 21.8697 27.452 21.87Z"\n  />\n  <path\n    d="M18.3139 26.584H13.6859C13.381 26.5835 13.0887 26.4622 12.873 26.2466C12.6572 26.0311 12.5357 25.7389 12.5349 25.434V6.56601C12.5357 6.26108 12.6572 5.96888 12.873 5.75336C13.0887 5.53783 13.381 5.41651 13.6859 5.41599H18.3139C18.6188 5.41651 18.9111 5.53783 19.1269 5.75336C19.3426 5.96888 19.4641 6.26108 19.4649 6.56601V25.434C19.4641 25.7389 19.3426 26.0311 19.1269 26.2466C18.9111 26.4622 18.6188 26.5835 18.3139 26.584Z"\n  />\n  <path\n    d="M9.17697 16.938H4.54797C4.24287 16.9375 3.95042 16.816 3.73468 16.6003C3.51894 16.3845 3.3975 16.0921 3.39697 15.787V6.56601C3.39777 6.26108 3.5193 5.96888 3.73502 5.75336C3.95073 5.53783 4.24304 5.41651 4.54797 5.41599H9.17697C9.48181 5.41651 9.77401 5.53787 9.98956 5.75342C10.2051 5.96897 10.3264 6.26117 10.327 6.56601V15.787C10.3267 16.092 10.2055 16.3845 9.9899 16.6002C9.77432 16.816 9.48198 16.9375 9.17697 16.938Z"\n  />\n</svg>\n';
const __vite_glob_0_290 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M5.79398 28.8C5.6887 28.8001 5.58498 28.7745 5.49178 28.7256C5.39857 28.6766 5.31867 28.6057 5.25897 28.519C4.78897 27.837 0.667969 21.783 0.667969 19.183C0.667969 17.8235 1.20803 16.5197 2.16934 15.5584C3.13065 14.5971 4.43448 14.057 5.79398 14.057C7.15348 14.057 8.45728 14.5971 9.41859 15.5584C10.3799 16.5197 10.92 17.8235 10.92 19.183C10.92 21.783 6.79896 27.837 6.32896 28.519C6.26927 28.6057 6.18938 28.6766 6.09618 28.7256C6.00297 28.7745 5.89926 28.8001 5.79398 28.8ZM5.79398 15.357C4.77958 15.3581 3.80704 15.7615 3.08975 16.4788C2.37247 17.1961 1.96903 18.1686 1.96797 19.183C1.96797 20.813 4.37898 24.827 5.79398 26.983C7.20898 24.825 9.61996 20.811 9.61996 19.183C9.61997 18.1679 9.217 17.1944 8.4996 16.4762C7.7822 15.7581 6.80906 15.3541 5.79398 15.353V15.357Z"\n  />\n  <path\n    d="M5.79402 21.833C5.26911 21.833 4.75598 21.6774 4.31954 21.3857C3.88309 21.0941 3.54292 20.6796 3.34204 20.1947C3.14117 19.7097 3.08861 19.1761 3.19101 18.6613C3.29342 18.1464 3.54619 17.6735 3.91736 17.3024C4.28853 16.9312 4.76142 16.6784 5.27625 16.576C5.79107 16.4736 6.32471 16.5262 6.80966 16.727C7.29462 16.9279 7.70911 17.2681 8.00073 17.7045C8.29236 18.141 8.44801 18.6541 8.44801 19.179C8.44722 19.8827 8.16735 20.5573 7.6698 21.0548C7.17225 21.5524 6.49766 21.8322 5.79402 21.833ZM5.79402 17.824C5.52599 17.8238 5.2639 17.9031 5.04094 18.0519C4.81798 18.2007 4.64415 18.4122 4.54144 18.6598C4.43873 18.9074 4.41176 19.1798 4.46393 19.4428C4.5161 19.7057 4.64507 19.9472 4.83453 20.1368C5.02399 20.3264 5.26543 20.4556 5.52831 20.5079C5.79118 20.5603 6.06367 20.5335 6.31133 20.431C6.55898 20.3285 6.77065 20.1548 6.91959 19.9319C7.06852 19.7091 7.14801 19.4471 7.14801 19.179C7.14748 18.82 7.0047 18.4758 6.75092 18.2218C6.49714 17.9679 6.15306 17.8248 5.79402 17.824Z"\n  />\n  <path\n    d="M26.2059 15.127C26.1007 15.1271 25.997 15.1015 25.9037 15.0526C25.8105 15.0036 25.7307 14.9327 25.671 14.846C25.201 14.165 21.08 8.11 21.08 5.51C21.08 4.1505 21.62 2.84668 22.5813 1.88537C23.5426 0.924057 24.8464 0.384003 26.2059 0.384003C27.5654 0.384003 28.8693 0.924057 29.8306 1.88537C30.7919 2.84668 31.332 4.1505 31.332 5.51C31.332 8.11 27.211 14.165 26.741 14.846C26.6813 14.9327 26.6014 15.0036 26.5081 15.0526C26.4149 15.1015 26.3112 15.1271 26.2059 15.127ZM26.2059 1.684C25.1916 1.68506 24.219 2.08849 23.5017 2.80578C22.7845 3.52306 22.381 4.49561 22.38 5.51C22.38 7.14 24.7909 11.154 26.2059 13.31C27.6209 11.152 30.032 7.138 30.032 5.51C30.0309 4.49561 29.6275 3.52306 28.9102 2.80578C28.1929 2.08849 27.2203 1.68506 26.2059 1.684Z"\n  />\n  <path\n    d="M26.206 8.165C25.6811 8.1648 25.1682 8.009 24.7319 7.7173C24.2956 7.4256 23.9556 7.01109 23.7548 6.52617C23.5541 6.04126 23.5016 5.50772 23.604 4.99299C23.7065 4.47825 23.9592 4.00544 24.3303 3.63434C24.7014 3.26323 25.1742 3.01048 25.689 2.90804C26.2037 2.8056 26.7372 2.85808 27.2222 3.05883C27.7071 3.25958 28.1216 3.5996 28.4133 4.03589C28.705 4.47219 28.8608 4.98517 28.861 5.51C28.8604 6.21399 28.5805 6.88898 28.0828 7.38678C27.585 7.88457 26.91 8.16447 26.206 8.165ZM26.206 4.156C25.9382 4.15619 25.6765 4.23577 25.454 4.38467C25.2315 4.53357 25.0581 4.74511 24.9558 4.99254C24.8534 5.23996 24.8268 5.51218 24.8791 5.77476C24.9315 6.03735 25.0605 6.27851 25.2499 6.46777C25.4393 6.65703 25.6806 6.78589 25.9432 6.83806C26.2058 6.89022 26.478 6.86334 26.7254 6.76083C26.9727 6.65832 27.1841 6.48478 27.3329 6.26214C27.4816 6.03949 27.561 5.77775 27.561 5.51C27.5604 5.15089 27.4175 4.80665 27.1635 4.55281C26.9094 4.29897 26.5651 4.15626 26.206 4.156Z"\n  />\n  <path\n    d="M21.1819 31.616H20.6519V30.316H21.1819C21.6136 30.3173 22.0426 30.2481 22.4519 30.111L22.8679 31.342C22.3247 31.525 21.7551 31.6175 21.1819 31.616ZM18.6169 31.616H16.5819V30.316H18.6169V31.616ZM14.5469 31.616H12.5119V30.316H14.5469V31.616ZM10.4779 31.616H8.44292V30.316H10.4779V31.616ZM6.40793 31.616H4.37292V30.316H6.40793V31.616ZM24.8359 30.076L23.8729 29.203C24.2431 28.8079 24.4717 28.301 24.5229 27.762L25.8229 27.871C25.7469 28.695 25.3998 29.4704 24.8359 30.076ZM24.1189 26.251C23.7966 25.7872 23.3551 25.4189 22.8409 25.185L23.3949 24.009C24.1206 24.3433 24.7426 24.8674 25.1949 25.526L24.1189 26.251ZM21.1449 24.824H19.1099V23.524H21.1449V24.824ZM16.8849 24.511C16.1363 24.2452 15.4691 23.7906 14.9479 23.191L15.9369 22.348C16.3127 22.7764 16.7924 23.1008 17.3299 23.29L16.8849 24.511ZM14.0369 20.956L14.0319 20.778C14.0351 20.0066 14.2818 19.2559 14.7369 18.633L15.7929 19.392C15.4969 19.7938 15.3356 20.2789 15.3319 20.778V20.888L14.0369 20.956ZM17.1029 18.356L16.5779 17.166C17.2406 16.878 17.9554 16.7296 18.6779 16.73H18.8179V18.03H18.6779C18.1349 18.0294 17.5977 18.1411 17.0999 18.358L17.1029 18.356ZM26.9619 18.03H24.9269V16.73H26.9619V18.03ZM22.8919 18.03H20.8569V16.73H22.8919V18.03Z"\n  />\n</svg>\n';
const __vite_glob_0_291 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M21.182 31.616H20.652V30.316H21.182C21.6137 30.3173 22.0426 30.2481 22.452 30.111L22.868 31.342C22.3248 31.525 21.7552 31.6175 21.182 31.616ZM18.617 31.616H16.582V30.316H18.617V31.616ZM14.547 31.616H12.512V30.316H14.547V31.616ZM10.478 31.616H8.44298V30.316H10.478V31.616ZM6.40799 31.616H4.37299V30.316H6.40799V31.616ZM24.836 30.076L23.873 29.203C24.2432 28.8079 24.4718 28.301 24.523 27.762L25.823 27.871C25.747 28.695 25.3998 29.4704 24.836 30.076ZM24.119 26.251C23.7966 25.7872 23.3551 25.4189 22.841 25.185L23.395 24.009C24.1207 24.3433 24.7426 24.8674 25.195 25.526L24.119 26.251ZM21.145 24.824H19.11V23.524H21.145V24.824ZM16.885 24.511C16.1364 24.2452 15.4691 23.7906 14.948 23.191L15.937 22.348C16.3128 22.7764 16.7925 23.1008 17.33 23.29L16.885 24.511ZM14.037 20.956L14.032 20.778C14.0351 20.0066 14.2819 19.2559 14.737 18.633L15.793 19.392C15.497 19.7938 15.3356 20.2789 15.332 20.778V20.888L14.037 20.956ZM17.103 18.356L16.578 17.166C17.2406 16.878 17.9555 16.7296 18.678 16.73H18.818V18.03H18.678C18.135 18.0294 17.5978 18.1411 17.1 18.358L17.103 18.356ZM26.962 18.03H24.927V16.73H26.962V18.03ZM22.892 18.03H20.857V16.73H22.892V18.03Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M5.49178 28.7256C5.58498 28.7745 5.6887 28.8001 5.79398 28.8C5.89926 28.8001 6.00297 28.7745 6.09618 28.7256C6.18938 28.6766 6.26927 28.6057 6.32896 28.519C6.79896 27.837 10.92 21.783 10.92 19.183C10.92 17.8235 10.3799 16.5197 9.41859 15.5584C8.45728 14.5971 7.15348 14.057 5.79398 14.057C4.43448 14.057 3.13065 14.5971 2.16934 15.5584C1.20803 16.5197 0.667969 17.8235 0.667969 19.183C0.667969 21.783 4.78897 27.837 5.25897 28.519C5.31867 28.6057 5.39857 28.6766 5.49178 28.7256ZM4.31947 21.3857C4.75592 21.6774 5.26905 21.833 5.79396 21.833C6.4976 21.8322 7.17219 21.5524 7.66974 21.0548C8.16729 20.5573 8.44716 19.8827 8.44795 19.179C8.44795 18.6541 8.2923 18.141 8.00067 17.7045C7.70905 17.2681 7.29456 16.9279 6.8096 16.727C6.32465 16.5262 5.79101 16.4736 5.27619 16.576C4.76136 16.6784 4.28847 16.9312 3.9173 17.3024C3.54613 17.6735 3.29335 18.1464 3.19095 18.6613C3.08854 19.1761 3.14111 19.7097 3.34198 20.1947C3.54286 20.6796 3.88303 21.0941 4.31947 21.3857ZM5.04088 18.0519C5.26384 17.9031 5.52593 17.8238 5.79396 17.824C6.15299 17.8248 6.49707 17.9679 6.75086 18.2218C7.00464 18.4758 7.14742 18.82 7.14795 19.179C7.14795 19.4471 7.06846 19.7091 6.91953 19.9319C6.77059 20.1548 6.55892 20.3285 6.31126 20.431C6.06361 20.5335 5.79112 20.5603 5.52824 20.5079C5.26537 20.4556 5.02393 20.3264 4.83447 20.1368C4.64501 19.9472 4.51604 19.7057 4.46387 19.4428C4.4117 19.1799 4.43867 18.9074 4.54138 18.6598C4.64409 18.4122 4.81792 18.2007 5.04088 18.0519Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M25.9037 15.0526C25.997 15.1015 26.1007 15.1271 26.2059 15.127C26.3112 15.1271 26.4149 15.1015 26.5081 15.0526C26.6014 15.0036 26.6813 14.9327 26.741 14.846C27.211 14.165 31.332 8.11 31.332 5.51C31.332 4.1505 30.7919 2.84668 29.8306 1.88537C28.8693 0.924057 27.5654 0.384003 26.2059 0.384003C24.8464 0.384003 23.5426 0.924057 22.5813 1.88537C21.62 2.84668 21.08 4.1505 21.08 5.51C21.08 8.11 25.201 14.165 25.671 14.846C25.7307 14.9327 25.8105 15.0036 25.9037 15.0526ZM24.7319 7.7173C25.1682 8.009 25.6811 8.1648 26.206 8.165C26.91 8.16447 27.585 7.88457 28.0828 7.38678C28.5805 6.88898 28.8604 6.21399 28.861 5.51C28.8608 4.98517 28.705 4.47219 28.4133 4.03589C28.1216 3.5996 27.7071 3.25958 27.2222 3.05883C26.7372 2.85808 26.2037 2.8056 25.689 2.90804C25.1742 3.01048 24.7014 3.26323 24.3303 3.63434C23.9592 4.00544 23.7065 4.47825 23.604 4.99299C23.5016 5.50772 23.5541 6.04126 23.7548 6.52617C23.9556 7.01109 24.2956 7.4256 24.7319 7.7173ZM25.454 4.38467C25.6765 4.23577 25.9382 4.15619 26.206 4.156C26.5651 4.15626 26.9094 4.29897 27.1635 4.55281C27.4175 4.80665 27.5604 5.15089 27.561 5.51C27.561 5.77775 27.4816 6.03949 27.3329 6.26214C27.1841 6.48478 26.9727 6.65832 26.7254 6.76083C26.478 6.86334 26.2058 6.89022 25.9432 6.83806C25.6806 6.78589 25.4393 6.65703 25.2499 6.46777C25.0605 6.27851 24.9315 6.03735 24.8791 5.77476C24.8268 5.51218 24.8534 5.23996 24.9558 4.99254C25.0581 4.74511 25.2315 4.53357 25.454 4.38467Z"\n  />\n</svg>\n';
const __vite_glob_0_292 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M19.0623 12.6953C18.7519 12.6953 18.5002 12.9469 18.5002 13.2574V23.8803C18.5002 24.1906 18.7519 24.4424 19.0623 24.4424C19.3728 24.4424 19.6244 24.1906 19.6244 23.8803V13.2574C19.6244 12.9469 19.3728 12.6953 19.0623 12.6953Z"\n  />\n  <path\n    d="M12.4301 12.6953C12.1197 12.6953 11.868 12.9469 11.868 13.2574V23.8803C11.868 24.1906 12.1197 24.4424 12.4301 24.4424C12.7406 24.4424 12.9922 24.1906 12.9922 23.8803V13.2574C12.9922 12.9469 12.7406 12.6953 12.4301 12.6953Z"\n  />\n  <path\n    d="M7.59634 11.145V24.993C7.59634 25.8115 7.89647 26.5801 8.42077 27.1317C8.94265 27.6847 9.66893 27.9987 10.429 28H21.0634C21.8237 27.9987 22.55 27.6847 23.0716 27.1317C23.5959 26.5801 23.8961 25.8115 23.8961 24.993V11.145C24.9383 10.8684 25.6136 9.86152 25.4742 8.79207C25.3346 7.72284 24.4236 6.923 23.3452 6.92278H20.4675V6.22021C20.4708 5.62939 20.2372 5.06206 19.8189 4.64469C19.4007 4.22753 18.8325 3.99524 18.2417 4.00007H13.2507C12.6599 3.99524 12.0917 4.22753 11.6735 4.64469C11.2552 5.06206 11.0216 5.62939 11.0249 6.22021V6.92278H8.1472C7.06875 6.923 6.15782 7.72284 6.01818 8.79207C5.87877 9.86152 6.55412 10.8684 7.59634 11.145ZM21.0634 26.8759H10.429C9.46804 26.8759 8.72046 26.0504 8.72046 24.993V11.1944H22.7719V24.993C22.7719 26.0504 22.0244 26.8759 21.0634 26.8759ZM12.149 6.22021C12.1453 5.92754 12.2603 5.64585 12.468 5.43925C12.6755 5.23265 12.9579 5.11914 13.2507 5.12419H18.2417C18.5345 5.11914 18.8169 5.23265 19.0244 5.43925C19.2321 5.64563 19.3471 5.92754 19.3434 6.22021V6.92278H12.149V6.22021ZM8.1472 8.0469H23.3452C23.904 8.0469 24.3569 8.49984 24.3569 9.05861C24.3569 9.61737 23.904 10.0703 23.3452 10.0703H8.1472C7.58844 10.0703 7.13549 9.61737 7.13549 9.05861C7.13549 8.49984 7.58844 8.0469 8.1472 8.0469Z"\n  />\n  <path\n    d="M15.7461 12.6953C15.4357 12.6953 15.1841 12.9469 15.1841 13.2574V23.8803C15.1841 24.1906 15.4357 24.4424 15.7461 24.4424C16.0566 24.4424 16.3082 24.1906 16.3082 23.8803V13.2574C16.3082 12.9469 16.0566 12.6953 15.7461 12.6953Z"\n  />\n</svg>\n';
const __vite_glob_0_293 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.59634 24.993V11.145C6.55412 10.8684 5.87877 9.86152 6.01818 8.79207C6.15782 7.72284 7.06875 6.923 8.1472 6.92278H11.0249V6.22021C11.0216 5.62939 11.2552 5.06206 11.6735 4.64469C12.0917 4.22753 12.6599 3.99524 13.2507 4.00007H18.2417C18.8325 3.99524 19.4007 4.22753 19.8189 4.64469C20.2372 5.06206 20.4708 5.62939 20.4675 6.22021V6.92278H23.3452C24.4236 6.923 25.3346 7.72284 25.4742 8.79207C25.6136 9.86152 24.9383 10.8684 23.8961 11.145V24.993C23.8961 25.8115 23.5959 26.5801 23.0716 27.1317C22.55 27.6847 21.8237 27.9987 21.0634 28H10.429C9.66893 27.9987 8.94265 27.6847 8.42077 27.1317C7.89647 26.5801 7.59634 25.8115 7.59634 24.993ZM12.468 5.43925C12.2603 5.64585 12.1453 5.92754 12.149 6.22021V6.92278H19.3434V6.22021C19.3471 5.92754 19.2321 5.64563 19.0244 5.43925C18.8169 5.23265 18.5345 5.11914 18.2417 5.12419H13.2507C12.9579 5.11914 12.6755 5.23265 12.468 5.43925ZM11.868 13.2574C11.868 12.9469 12.1196 12.6953 12.43 12.6953C12.7405 12.6953 12.9921 12.9469 12.9921 13.2574V23.8803C12.9921 24.1906 12.7405 24.4424 12.43 24.4424C12.1196 24.4424 11.868 24.1906 11.868 23.8803V13.2574ZM18.5002 13.2574C18.5002 12.9469 18.7519 12.6953 19.0623 12.6953C19.3728 12.6953 19.6244 12.9469 19.6244 13.2574V23.8803C19.6244 24.1906 19.3728 24.4424 19.0623 24.4424C18.7519 24.4424 18.5002 24.1906 18.5002 23.8803V13.2574ZM15.7462 12.6953C15.4358 12.6953 15.1841 12.9469 15.1841 13.2574V23.8803C15.1841 24.1906 15.4358 24.4424 15.7462 24.4424C16.0567 24.4424 16.3083 24.1906 16.3083 23.8803V13.2574C16.3083 12.9469 16.0567 12.6953 15.7462 12.6953Z"\n  />\n</svg>\n';
const __vite_glob_0_294 = '<?xml version="1.0" encoding="utf-8" ?>\n<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->\n<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M7.53033 3.46967C7.82322 3.76256 7.82322 4.23744 7.53033 4.53033L5.81066 6.25H15C18.1756 6.25 20.75 8.82436 20.75 12C20.75 15.1756 18.1756 17.75 15 17.75H8.00001C7.58579 17.75 7.25001 17.4142 7.25001 17C7.25001 16.5858 7.58579 16.25 8.00001 16.25H15C17.3472 16.25 19.25 14.3472 19.25 12C19.25 9.65279 17.3472 7.75 15 7.75H5.81066L7.53033 9.46967C7.82322 9.76256 7.82322 10.2374 7.53033 10.5303C7.23744 10.8232 6.76256 10.8232 6.46967 10.5303L3.46967 7.53033C3.17678 7.23744 3.17678 6.76256 3.46967 6.46967L6.46967 3.46967C6.76256 3.17678 7.23744 3.17678 7.53033 3.46967Z"\n    fill="#1C274C"\n  />\n</svg>\n';
const __vite_glob_0_295 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M8.13113 8.38568C12.4035 3.97282 19.4442 3.85881 23.8571 8.13115L24 8.64288V9.77857H23.0977C21.3121 7.82785 18.7893 6.71666 16.1447 6.71616C10.9375 6.71511 6.71534 10.9356 6.71429 16.1429H5.00002C4.99445 13.2482 6.11769 10.4654 8.13113 8.38568Z"\n  />\n  <path\n    d="M16.1408 25.5696C21.3481 25.5706 25.5702 21.3501 25.5713 16.1429H27.2855C27.2911 19.0375 26.1678 21.8204 24.1544 23.9C19.8821 28.313 12.8413 28.4269 8.4284 24.1546L8.32166 22.5072H9.18782C10.9735 24.4579 13.4962 25.5691 16.1408 25.5696Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M23.8605 9.49653H19V11.0331H24.6279C25.0518 11.0331 25.3953 10.6891 25.3953 10.2648V5.14288L23.8605 5.14288V9.49653Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.53492 22.6795L13.3954 22.6795V21.1429H7.76748C7.34363 21.1429 7.00004 21.4869 7.00004 21.9112L7.00004 27.0331H8.53492L8.53492 22.6795Z"\n  />\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M8.53492 22.6795L13.3954 22.6795V21.1429H7.76748C7.34363 21.1429 7.00004 21.4869 7.00004 21.9112L7.00004 27.0331H8.53492L8.53492 22.6795Z"\n  />\n</svg>\n';
const __vite_glob_0_296 = '<svg\n  xmlns="http://www.w3.org/2000/svg"\n  fill-rule="evenodd"\n  viewBox="0 0 32 32"\n  display="block"\n  aria-hidden="true"\n  fill="currentColor"\n>\n  <path\n    d="M24.462 20.0596V23.3596C24.462 23.7266 23.862 24.1376 23.062 24.1376H8.70001C7.90001 24.1376 7.3 23.7266 7.3 23.3596V20.0596H6V23.3596C6 24.5246 7.18601 25.4376 8.70001 25.4376H23.06C24.575 25.4376 25.76 24.5246 25.76 23.3596V20.0596H24.462Z"\n  />\n  <path\n    d="M15.23 7.66648V20.3105H16.53V7.66648L20.981 12.1165L21.9 11.1975L17.252 6.55048C16.8826 6.19718 16.3911 6 15.88 6C15.3688 6 14.8774 6.19718 14.508 6.55048L9.85999 11.1975L10.779 12.1165L15.23 7.66648Z"\n  />\n</svg>\n';
const svgs = {};
const svgIcons = /* @__PURE__ */ Object.assign({
  "./Actions.svg": __vite_glob_0_0,
  "./ActionsFill.svg": __vite_glob_0_1,
  "./Analytics.svg": __vite_glob_0_2,
  "./AnalyticsFill.svg": __vite_glob_0_3,
  "./ArrowDown.svg": __vite_glob_0_4,
  "./ArrowDownFill.svg": __vite_glob_0_5,
  "./ArrowIncoming.svg": __vite_glob_0_6,
  "./ArrowIncomingFill.svg": __vite_glob_0_7,
  "./ArrowLightLeft.svg": __vite_glob_0_8,
  "./ArrowLightRight.svg": __vite_glob_0_9,
  "./ArrowMinDown.svg": __vite_glob_0_10,
  "./ArrowMinLeft.svg": __vite_glob_0_11,
  "./ArrowMinRight.svg": __vite_glob_0_12,
  "./ArrowMinTop.svg": __vite_glob_0_13,
  "./ArrowOutgoing.svg": __vite_glob_0_14,
  "./ArrowOutgoingFill.svg": __vite_glob_0_15,
  "./ArrowSimpleDown.svg": __vite_glob_0_16,
  "./ArrowSimpleLeft.svg": __vite_glob_0_17,
  "./ArrowSimpleRight.svg": __vite_glob_0_18,
  "./ArrowSimpleUp.svg": __vite_glob_0_19,
  "./Barcode.svg": __vite_glob_0_20,
  "./Blockchain.svg": __vite_glob_0_21,
  "./Board.svg": __vite_glob_0_22,
  "./BoardFill.svg": __vite_glob_0_23,
  "./Boolean.svg": __vite_glob_0_24,
  "./Bot.svg": __vite_glob_0_25,
  "./Bullets.svg": __vite_glob_0_26,
  "./BulletsFill.svg": __vite_glob_0_27,
  "./Calculator.svg": __vite_glob_0_28,
  "./Calendar.svg": __vite_glob_0_29,
  "./CalendarFill.svg": __vite_glob_0_30,
  "./Camera.svg": __vite_glob_0_31,
  "./CameraFill.svg": __vite_glob_0_32,
  "./CheckCircle.svg": __vite_glob_0_33,
  "./CheckCircleFill.svg": __vite_glob_0_34,
  "./CheckShield.svg": __vite_glob_0_35,
  "./CheckboxChecked.svg": __vite_glob_0_36,
  "./CheckboxDropdown.svg": __vite_glob_0_37,
  "./CheckboxMinus.svg": __vite_glob_0_38,
  "./CheckboxOff.svg": __vite_glob_0_39,
  "./CheckboxOn.svg": __vite_glob_0_40,
  "./CircleActions.svg": __vite_glob_0_41,
  "./CircleActionsFill.svg": __vite_glob_0_42,
  "./CircleArrowDown.svg": __vite_glob_0_43,
  "./CircleArrowDownFill.svg": __vite_glob_0_44,
  "./CircleArrowLeft.svg": __vite_glob_0_45,
  "./CircleArrowLeftFill.svg": __vite_glob_0_46,
  "./CircleArrowRight.svg": __vite_glob_0_47,
  "./CircleArrowRightFill.svg": __vite_glob_0_48,
  "./CircleArrowUp.svg": __vite_glob_0_49,
  "./CircleArrowUpFill.svg": __vite_glob_0_50,
  "./CircleCross.svg": __vite_glob_0_51,
  "./CircleCrossFill.svg": __vite_glob_0_52,
  "./CircleDoc.svg": __vite_glob_0_53,
  "./CircleDocFill.svg": __vite_glob_0_54,
  "./CircleDownload.svg": __vite_glob_0_55,
  "./CircleDownloadFill.svg": __vite_glob_0_56,
  "./CircleEuro.svg": __vite_glob_0_57,
  "./CircleEuroFill.svg": __vite_glob_0_58,
  "./CircleGraph.svg": __vite_glob_0_59,
  "./CircleGraphFill.svg": __vite_glob_0_60,
  "./CircleInfo.svg": __vite_glob_0_61,
  "./CircleInfoFill.svg": __vite_glob_0_62,
  "./CircleLink.svg": __vite_glob_0_63,
  "./CircleLinkFill.svg": __vite_glob_0_64,
  "./CircleLocation.svg": __vite_glob_0_65,
  "./CircleLocationFill.svg": __vite_glob_0_66,
  "./CircleMinus.svg": __vite_glob_0_67,
  "./CircleMinusFill.svg": __vite_glob_0_68,
  "./CirclePacklockFill.svg": __vite_glob_0_69,
  "./CirclePadlock.svg": __vite_glob_0_70,
  "./CirclePen.svg": __vite_glob_0_71,
  "./CirclePenFill.svg": __vite_glob_0_72,
  "./CirclePicture.svg": __vite_glob_0_73,
  "./CirclePictureFill.svg": __vite_glob_0_74,
  "./CirclePlay.svg": __vite_glob_0_75,
  "./CirclePlayFill.svg": __vite_glob_0_76,
  "./CirclePlus.svg": __vite_glob_0_77,
  "./CirclePlusFill.svg": __vite_glob_0_78,
  "./CircleProfile.svg": __vite_glob_0_79,
  "./CircleProfileFill.svg": __vite_glob_0_80,
  "./CircleSearch.svg": __vite_glob_0_81,
  "./CircleSearchFill.svg": __vite_glob_0_82,
  "./CircleSetting.svg": __vite_glob_0_83,
  "./CircleSettingFill.svg": __vite_glob_0_84,
  "./CircleStar.svg": __vite_glob_0_85,
  "./CircleStarFill.svg": __vite_glob_0_86,
  "./CircleStop.svg": __vite_glob_0_87,
  "./CircleStopFill.svg": __vite_glob_0_88,
  "./CircleTick.svg": __vite_glob_0_89,
  "./CircleTickFill.svg": __vite_glob_0_90,
  "./Clipboard.svg": __vite_glob_0_91,
  "./ClipboardCheck.svg": __vite_glob_0_92,
  "./ClipboardTick.svg": __vite_glob_0_93,
  "./Clock.svg": __vite_glob_0_94,
  "./ClockDashed.svg": __vite_glob_0_95,
  "./Cloud.svg": __vite_glob_0_96,
  "./CloudFill.svg": __vite_glob_0_97,
  "./Code.svg": __vite_glob_0_98,
  "./Cog.svg": __vite_glob_0_99,
  "./CogFill.svg": __vite_glob_0_100,
  "./ColumnDelete.svg": __vite_glob_0_101,
  "./ColumnInsert.svg": __vite_glob_0_102,
  "./Conclusion.svg": __vite_glob_0_103,
  "./ConclusionFill.svg": __vite_glob_0_104,
  "./Condition.svg": __vite_glob_0_105,
  "./ConditionFill.svg": __vite_glob_0_106,
  "./Counter.svg": __vite_glob_0_107,
  "./CounterFill.svg": __vite_glob_0_108,
  "./Cross.svg": __vite_glob_0_109,
  "./Doc.svg": __vite_glob_0_110,
  "./DocDownload.svg": __vite_glob_0_111,
  "./DocDownloadFill.svg": __vite_glob_0_112,
  "./DocDuplicate.svg": __vite_glob_0_113,
  "./DocDuplicateFill.svg": __vite_glob_0_114,
  "./DocEmpty.svg": __vite_glob_0_115,
  "./DocEmptyFill.svg": __vite_glob_0_116,
  "./DocEuro.svg": __vite_glob_0_117,
  "./DocEuroFill.svg": __vite_glob_0_118,
  "./DocEye.svg": __vite_glob_0_119,
  "./DocEyeFill.svg": __vite_glob_0_120,
  "./DocFill.svg": __vite_glob_0_121,
  "./DocGraph.svg": __vite_glob_0_122,
  "./DocGraphFill.svg": __vite_glob_0_123,
  "./DocInfo.svg": __vite_glob_0_124,
  "./DocInfoFill.svg": __vite_glob_0_125,
  "./DocKey.svg": __vite_glob_0_126,
  "./DocKeyFill.svg": __vite_glob_0_127,
  "./DocLink.svg": __vite_glob_0_128,
  "./DocLinkFill.svg": __vite_glob_0_129,
  "./DocLocation.svg": __vite_glob_0_130,
  "./DocLocationFill.svg": __vite_glob_0_131,
  "./DocMinus.svg": __vite_glob_0_132,
  "./DocMinusFill.svg": __vite_glob_0_133,
  "./DocMultiply.svg": __vite_glob_0_134,
  "./DocMultiplyFill.svg": __vite_glob_0_135,
  "./DocPadlock.svg": __vite_glob_0_136,
  "./DocPadlockFill.svg": __vite_glob_0_137,
  "./DocPadlockOpen.svg": __vite_glob_0_138,
  "./DocPadlockOpenFill.svg": __vite_glob_0_139,
  "./DocPen.svg": __vite_glob_0_140,
  "./DocPenFill.svg": __vite_glob_0_141,
  "./DocPerson.svg": __vite_glob_0_142,
  "./DocPersonFill.svg": __vite_glob_0_143,
  "./DocPlay.svg": __vite_glob_0_144,
  "./DocPlayFill.svg": __vite_glob_0_145,
  "./DocPlus.svg": __vite_glob_0_146,
  "./DocPlusFill.svg": __vite_glob_0_147,
  "./DocSearch.svg": __vite_glob_0_148,
  "./DocSearchFill.svg": __vite_glob_0_149,
  "./DocSetting.svg": __vite_glob_0_150,
  "./DocSettingFill.svg": __vite_glob_0_151,
  "./DocStar.svg": __vite_glob_0_152,
  "./DocStarFill.svg": __vite_glob_0_153,
  "./DocStop.svg": __vite_glob_0_154,
  "./DocStopFill.svg": __vite_glob_0_155,
  "./DocTick.svg": __vite_glob_0_156,
  "./DocTickFill.svg": __vite_glob_0_157,
  "./DocUpload.svg": __vite_glob_0_158,
  "./DocUploadFill.svg": __vite_glob_0_159,
  "./DoubleArrowDown.svg": __vite_glob_0_160,
  "./DoubleArrowLeft.svg": __vite_glob_0_161,
  "./DoubleArrowRight.svg": __vite_glob_0_162,
  "./DoubleArrowUp.svg": __vite_glob_0_163,
  "./Download.svg": __vite_glob_0_164,
  "./Drag.svg": __vite_glob_0_165,
  "./Duplicate.svg": __vite_glob_0_166,
  "./DuplicateFill.svg": __vite_glob_0_167,
  "./Envelope.svg": __vite_glob_0_168,
  "./Erase.svg": __vite_glob_0_169,
  "./Euro.svg": __vite_glob_0_170,
  "./Eye.svg": __vite_glob_0_171,
  "./EyeCrossed.svg": __vite_glob_0_172,
  "./Filter.svg": __vite_glob_0_173,
  "./FilterFill.svg": __vite_glob_0_174,
  "./Flag.svg": __vite_glob_0_175,
  "./FlagFill.svg": __vite_glob_0_176,
  "./FlagFull.svg": __vite_glob_0_177,
  "./Forbidden.svg": __vite_glob_0_178,
  "./Globe.svg": __vite_glob_0_179,
  "./Graph.svg": __vite_glob_0_180,
  "./GraphFill.svg": __vite_glob_0_181,
  "./GraphLine.svg": __vite_glob_0_182,
  "./Group.svg": __vite_glob_0_183,
  "./GroupFill.svg": __vite_glob_0_184,
  "./Handshake.svg": __vite_glob_0_185,
  "./HandshakeFill.svg": __vite_glob_0_186,
  "./House.svg": __vite_glob_0_187,
  "./HouseFill.svg": __vite_glob_0_188,
  "./IdFill.svg": __vite_glob_0_189,
  "./IdLight.svg": __vite_glob_0_190,
  "./Input.svg": __vite_glob_0_191,
  "./InputFill.svg": __vite_glob_0_192,
  "./Investors.svg": __vite_glob_0_193,
  "./InvestorsFill.svg": __vite_glob_0_194,
  "./Key.svg": __vite_glob_0_195,
  "./KeyFill.svg": __vite_glob_0_196,
  "./KeyHorizontal.svg": __vite_glob_0_197,
  "./Layout.svg": __vite_glob_0_198,
  "./LessThan.svg": __vite_glob_0_199,
  "./LightArrowDown.svg": __vite_glob_0_200,
  "./LightArrowDropdown.svg": __vite_glob_0_201,
  "./LightArrowLeft.svg": __vite_glob_0_202,
  "./LightArrowRight.svg": __vite_glob_0_203,
  "./LightArrowUp.svg": __vite_glob_0_204,
  "./Link.svg": __vite_glob_0_205,
  "./LinkFill.svg": __vite_glob_0_206,
  "./LinkHorizontal.svg": __vite_glob_0_207,
  "./LinkLight.svg": __vite_glob_0_208,
  "./List.svg": __vite_glob_0_209,
  "./Location.svg": __vite_glob_0_210,
  "./LocationFill.svg": __vite_glob_0_211,
  "./Loupe.svg": __vite_glob_0_212,
  "./Mail.svg": __vite_glob_0_213,
  "./MailFill.svg": __vite_glob_0_214,
  "./Meeting.svg": __vite_glob_0_215,
  "./MeetingFill.svg": __vite_glob_0_216,
  "./Menu.svg": __vite_glob_0_217,
  "./Moon.svg": __vite_glob_0_218,
  "./MoonFill.svg": __vite_glob_0_219,
  "./OrderedList.svg": __vite_glob_0_220,
  "./Package.svg": __vite_glob_0_221,
  "./PadlockClose.svg": __vite_glob_0_222,
  "./PadlockCloseFill.svg": __vite_glob_0_223,
  "./PadlockOpen.svg": __vite_glob_0_224,
  "./PadlockOpenFill.svg": __vite_glob_0_225,
  "./Paperclip.svg": __vite_glob_0_226,
  "./Pen.svg": __vite_glob_0_227,
  "./Person.svg": __vite_glob_0_228,
  "./PersonFill.svg": __vite_glob_0_229,
  "./Phone.svg": __vite_glob_0_230,
  "./Picture.svg": __vite_glob_0_231,
  "./Plus.svg": __vite_glob_0_232,
  "./Presentation.svg": __vite_glob_0_233,
  "./PresentationFill.svg": __vite_glob_0_234,
  "./QRcode.svg": __vite_glob_0_235,
  "./QRcodeFill.svg": __vite_glob_0_236,
  "./Question.svg": __vite_glob_0_237,
  "./QuestionFill.svg": __vite_glob_0_238,
  "./RadioButtonOff.svg": __vite_glob_0_239,
  "./RadioButtonOn.svg": __vite_glob_0_240,
  "./RadioDropdown.svg": __vite_glob_0_241,
  "./Redo.svg": __vite_glob_0_242,
  "./ReplaceFile.svg": __vite_glob_0_243,
  "./ReplaceFileFill.svg": __vite_glob_0_244,
  "./Reset.svg": __vite_glob_0_245,
  "./Reset2.svg": __vite_glob_0_246,
  "./Review.svg": __vite_glob_0_247,
  "./RowDelete.svg": __vite_glob_0_248,
  "./RowInsert.svg": __vite_glob_0_249,
  "./Ruler.svg": __vite_glob_0_250,
  "./RulerFill.svg": __vite_glob_0_251,
  "./Save.svg": __vite_glob_0_252,
  "./Savings.svg": __vite_glob_0_253,
  "./SavingsFill.svg": __vite_glob_0_254,
  "./Scales.svg": __vite_glob_0_255,
  "./ScalesFill.svg": __vite_glob_0_256,
  "./Search.svg": __vite_glob_0_257,
  "./Settings.svg": __vite_glob_0_258,
  "./SettingsFill.svg": __vite_glob_0_259,
  "./Shield.svg": __vite_glob_0_260,
  "./ShieldFill.svg": __vite_glob_0_261,
  "./Signout.svg": __vite_glob_0_262,
  "./SortArrows.svg": __vite_glob_0_263,
  "./Speech.svg": __vite_glob_0_264,
  "./SpeechFill.svg": __vite_glob_0_265,
  "./Star.svg": __vite_glob_0_266,
  "./StarFill.svg": __vite_glob_0_267,
  "./Stop.svg": __vite_glob_0_268,
  "./Table.svg": __vite_glob_0_269,
  "./TableColumns.svg": __vite_glob_0_270,
  "./TableColumnsFill.svg": __vite_glob_0_271,
  "./TableDelete.svg": __vite_glob_0_272,
  "./TableFill.svg": __vite_glob_0_273,
  "./TableInsert.svg": __vite_glob_0_274,
  "./Tag.svg": __vite_glob_0_275,
  "./TagFill.svg": __vite_glob_0_276,
  "./Temperature.svg": __vite_glob_0_277,
  "./TemperatureFill.svg": __vite_glob_0_278,
  "./TextParaBig.svg": __vite_glob_0_279,
  "./TextParaSmall.svg": __vite_glob_0_280,
  "./Tick.svg": __vite_glob_0_281,
  "./Ticket.svg": __vite_glob_0_282,
  "./TicketFill.svg": __vite_glob_0_283,
  "./Timeline.svg": __vite_glob_0_284,
  "./TimelineFill.svg": __vite_glob_0_285,
  "./ToggleButtonOff.svg": __vite_glob_0_286,
  "./ToggleButtonOn.svg": __vite_glob_0_287,
  "./Trace.svg": __vite_glob_0_288,
  "./TraceFill.svg": __vite_glob_0_289,
  "./Trail.svg": __vite_glob_0_290,
  "./TrailFill.svg": __vite_glob_0_291,
  "./Trash.svg": __vite_glob_0_292,
  "./TrashFill.svg": __vite_glob_0_293,
  "./Undo.svg": __vite_glob_0_294,
  "./Update.svg": __vite_glob_0_295,
  "./Upload.svg": __vite_glob_0_296
});
Object.entries(svgIcons).forEach(([key2, module2]) => {
  const name2 = key2.match(/^\.\/(.*)\.svg$/)[1];
  svgs[name2] = module2.default || module2;
});
const styles$2J = {
  icon: (props2) => {
    const svg = svgs[props2.name];
    const url2 = `data:image/svg+xml;charset=utf8,${encodeURIComponent(svg)}`;
    return {
      width: Number(props2.size) || "inherit",
      height: Number(props2.size) || "inherit",
      backgroundColor: props2.color || "currentColor",
      mask: `url(${url2}) no-repeat center`,
      "-webkit-mask": `url(${url2}) no-repeat center`
    };
  }
};
const IconComp = ({ classes, name: name2, className }) => {
  if (!svgs[name2]) {
    console.warn(`Icon ${name2} does not exist`);
    return null;
  }
  return /* @__PURE__ */ jsx$1("div", { className: classNames(className, classes.icon) });
};
IconComp.propTypes = {
  // prop size is used in styles
  size: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  // prop color is used in styles
  color: PropTypes$1.string,
  classes: PropTypes$1.object.isRequired,
  name: PropTypes$1.string.isRequired,
  className: PropTypes$1.string
};
IconComp.defaultProps = {
  size: null,
  color: null,
  className: void 0
};
const Icon$2 = injectSheet(styles$2J)(IconComp);
const icons = {};
Object.keys(svgs).forEach((key2) => {
  icons[key2] = (props2) => /* @__PURE__ */ jsx$1(Icon$2, { name: key2, ...props2 });
});
class AvatarButton extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleClick", (event) => {
      if (!this.props.disabled) this.props.onClick(event);
    });
    __publicField(this, "render", () => {
      const {
        classes,
        label,
        src: src2,
        disabled,
        buttonRef: ref2,
        size: size2,
        overlay
      } = this.props;
      const rootProps = {
        className: classes.root,
        onClick: this.handleClick,
        type: "button",
        style: {
          height: size2,
          width: size2
        },
        disabled,
        ref: ref2,
        "aria-label": label
      };
      return /* @__PURE__ */ jsxs("button", { ...rootProps, children: [
        /* @__PURE__ */ jsx$1(Avatar$1, { src: src2, border: true }),
        overlay && /* @__PURE__ */ jsx$1(AvatarOverlay$1, { icon: /* @__PURE__ */ jsx$1(icons.Upload, {}) })
      ] });
    });
  }
}
__publicField(AvatarButton, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  onClick: PropTypes$1.func.isRequired,
  label: PropTypes$1.string,
  src: PropTypes$1.string,
  disabled: PropTypes$1.bool,
  buttonRef: PropTypes$1.func,
  size: PropTypes$1.number,
  overlay: PropTypes$1.bool
});
__publicField(AvatarButton, "defaultProps", {
  label: null,
  src: null,
  disabled: false,
  buttonRef: () => {
  },
  size: null,
  overlay: false
});
const AvatarButton$1 = injectSheet(styles$2L)(AvatarButton);
const styles$2I = (theme2) => ({
  root: {
    flexShrink: 0,
    position: "relative",
    width: "100%",
    height: "auto",
    appearance: "none",
    color: theme2.grey5,
    backgroundColor: "transparent",
    boxSizing: "border-box",
    cursor: "pointer",
    outline: "none",
    display: "block",
    boxShadow: `0 0 0 0 ${theme2.indigoPastel2}`,
    transition: `color 100ms linear 0ms`,
    "&::before": {
      content: '""',
      position: "absolute",
      width: MIN_TARGET_SIZE,
      height: MIN_TARGET_SIZE,
      top: "50%",
      left: "50%",
      transform: "translateY(-50%) translateX(-50%)"
    },
    "&[disabled]": {
      opacity: 0.3,
      color: theme2.grey3
    },
    "&:not([disabled]):hover": {
      cursor: "pointer",
      color: theme2.indigo3
    }
  },
  avatar: {
    position: "relative",
    padding: 1
  }
});
const styles$2H = (theme2) => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden"
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "block",
    width: "100%",
    height: "auto",
    fill: theme2.indigo3,
    opacity: 0.6
  },
  icon: {
    flexShrink: 0,
    width: "70%",
    height: "auto",
    maxWidth: 32,
    position: "relative",
    color: theme2.white1
  }
});
class AvatarGroupOverlay extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, clipPathId, icon: icon2 } = this.props;
      return /* @__PURE__ */ jsxs("div", { className: classes.root, children: [
        /* @__PURE__ */ jsx$1(AvatarGroupSvg, { viewBox: AVATAR_GROUP_VIEWBOX_SIZE, className: classes.overlay, children: /* @__PURE__ */ jsx$1("rect", { width: "100", height: "100", clipPath: `url(#${clipPathId})` }) }),
        /* @__PURE__ */ jsx$1("div", { className: classes.icon, children: icon2 })
      ] });
    });
  }
}
__publicField(AvatarGroupOverlay, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  clipPathId: PropTypes$1.string.isRequired,
  icon: PropTypes$1.node.isRequired
});
const AvatarGroupOverlay$1 = injectSheet(styles$2H)(AvatarGroupOverlay);
const styles$2G = (theme2) => ({
  root: {
    position: "absolute",
    top: -FOCUS_OUTLINE_WIDTH,
    left: -FOCUS_OUTLINE_WIDTH,
    width: `calc(100% + ${FOCUS_OUTLINE_WIDTH * 2}px)`,
    height: "auto",
    display: "block",
    fill: theme2.indigoPastel2,
    transform: "scale(0.7)",
    transition: "transform 200ms ease-in-out 0ms",
    ":focus &": {
      transform: "scale(1)"
    }
  }
});
class AvatarGroupOutline extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, clipPathId } = this.props;
      return /* @__PURE__ */ jsx$1(AvatarGroupSvg, { viewBox: AVATAR_GROUP_VIEWBOX_SIZE, className: classes.root, children: /* @__PURE__ */ jsx$1("rect", { width: "100", height: "100", clipPath: `url(#${clipPathId})` }) });
    });
  }
}
__publicField(AvatarGroupOutline, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  clipPathId: PropTypes$1.string.isRequired
});
const AvatarGroupOutline$1 = injectSheet(styles$2G)(AvatarGroupOutline);
class AvatarGroupButton extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "id", uniqueId$1("agb_"));
    __publicField(this, "handleClick", (event) => {
      if (!this.props.disabled) this.props.onClick(event);
    });
    __publicField(this, "renderOverlay", () => {
      if (!this.props.overlay) return null;
      return /* @__PURE__ */ jsx$1(AvatarGroupOverlay$1, { clipPathId: this.id, icon: /* @__PURE__ */ jsx$1(icons.Upload, {}) });
    });
    __publicField(this, "renderAvatar", () => {
      const { classes, nth, initials, src: src2 } = this.props;
      return /* @__PURE__ */ jsx$1("div", { className: classes.avatar, children: src2 ? /* @__PURE__ */ jsx$1(AvatarGroupImage$1, { clipPathId: this.id, src: src2 }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx$1(AvatarGroupColour$1, { nth, clipPathId: this.id }),
        !!initials && /* @__PURE__ */ jsx$1(AvatarGroupInitials$1, { initials })
      ] }) });
    });
    __publicField(this, "render", () => {
      const { classes, size: size2, label, disabled, buttonRef: ref2 } = this.props;
      const rootProps = {
        className: classes.root,
        onClick: this.handleClick,
        type: "button",
        style: {
          height: size2,
          width: size2,
          fontSize: size2
        },
        disabled,
        ref: ref2,
        "aria-label": label
      };
      return /* @__PURE__ */ jsxs("button", { ...rootProps, children: [
        /* @__PURE__ */ jsx$1(AvatarGroupClippath, { clipPathId: this.id }),
        /* @__PURE__ */ jsx$1(AvatarGroupOutline$1, { clipPathId: this.id }),
        /* @__PURE__ */ jsx$1(AvatarGroupBorder$1, { clipPathId: this.id }),
        this.renderAvatar(),
        this.renderOverlay()
      ] });
    });
  }
}
__publicField(AvatarGroupButton, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  onClick: PropTypes$1.func.isRequired,
  size: PropTypes$1.number.isRequired,
  initials: PropTypes$1.string,
  nth: PropTypes$1.number,
  label: PropTypes$1.string,
  src: PropTypes$1.string,
  disabled: PropTypes$1.bool,
  buttonRef: PropTypes$1.func,
  overlay: PropTypes$1.bool
});
__publicField(AvatarGroupButton, "defaultProps", {
  initials: null,
  nth: null,
  label: null,
  src: null,
  disabled: false,
  buttonRef: () => {
  },
  overlay: false
});
const AvatarGroupButton$1 = injectSheet(styles$2I)(AvatarGroupButton);
var DynamicIcon$1 = { exports: {} };
var lib$a = {};
var misc = {};
var CheckboxTick = { exports: {} };
var createSvgIcon = { exports: {} };
var pure$1 = {};
var shouldUpdate$1 = {};
var classCallCheck$1 = {};
classCallCheck$1.__esModule = true;
classCallCheck$1.default = function(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var possibleConstructorReturn = {};
var _typeof$5 = {};
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function(it2) {
  return isNaN(it2 = +it2) ? 0 : (it2 > 0 ? floor : ceil)(it2);
};
var _defined = function(it2) {
  if (it2 == void 0) throw TypeError("Can't call method on  " + it2);
  return it2;
};
var toInteger$5 = _toInteger;
var defined$2 = _defined;
var _stringAt = function(TO_STRING) {
  return function(that, pos) {
    var s4 = String(defined$2(that));
    var i3 = toInteger$5(pos);
    var l2 = s4.length;
    var a4, b3;
    if (i3 < 0 || i3 >= l2) return TO_STRING ? "" : void 0;
    a4 = s4.charCodeAt(i3);
    return a4 < 55296 || a4 > 56319 || i3 + 1 === l2 || (b3 = s4.charCodeAt(i3 + 1)) < 56320 || b3 > 57343 ? TO_STRING ? s4.charAt(i3) : a4 : TO_STRING ? s4.slice(i3, i3 + 2) : (a4 - 55296 << 10) + (b3 - 56320) + 65536;
  };
};
var _library = true;
var _global = { exports: {} };
var global$5 = _global.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
if (typeof __g == "number") __g = global$5;
var _globalExports = _global.exports;
var _core = { exports: {} };
var core$7 = _core.exports = { version: "2.6.12" };
if (typeof __e == "number") __e = core$7;
var _coreExports = _core.exports;
var _aFunction = function(it2) {
  if (typeof it2 != "function") throw TypeError(it2 + " is not a function!");
  return it2;
};
var aFunction = _aFunction;
var _ctx = function(fn2, that, length) {
  aFunction(fn2);
  if (that === void 0) return fn2;
  switch (length) {
    case 1:
      return function(a4) {
        return fn2.call(that, a4);
      };
    case 2:
      return function(a4, b3) {
        return fn2.call(that, a4, b3);
      };
    case 3:
      return function(a4, b3, c3) {
        return fn2.call(that, a4, b3, c3);
      };
  }
  return function() {
    return fn2.apply(that, arguments);
  };
};
var _objectDp = {};
var _isObject = function(it2) {
  return typeof it2 === "object" ? it2 !== null : typeof it2 === "function";
};
var isObject$n = _isObject;
var _anObject = function(it2) {
  if (!isObject$n(it2)) throw TypeError(it2 + " is not an object!");
  return it2;
};
var _fails = function(exec) {
  try {
    return !!exec();
  } catch (e5) {
    return true;
  }
};
var _descriptors = !_fails(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
});
var _domCreate;
var hasRequired_domCreate;
function require_domCreate() {
  if (hasRequired_domCreate) return _domCreate;
  hasRequired_domCreate = 1;
  var isObject3 = _isObject;
  var document2 = _globalExports.document;
  var is3 = isObject3(document2) && isObject3(document2.createElement);
  _domCreate = function(it2) {
    return is3 ? document2.createElement(it2) : {};
  };
  return _domCreate;
}
var _ie8DomDefine = !_descriptors && !_fails(function() {
  return Object.defineProperty(require_domCreate()("div"), "a", { get: function() {
    return 7;
  } }).a != 7;
});
var isObject$m = _isObject;
var _toPrimitive$3 = function(it2, S4) {
  if (!isObject$m(it2)) return it2;
  var fn2, val;
  if (S4 && typeof (fn2 = it2.toString) == "function" && !isObject$m(val = fn2.call(it2))) return val;
  if (typeof (fn2 = it2.valueOf) == "function" && !isObject$m(val = fn2.call(it2))) return val;
  if (!S4 && typeof (fn2 = it2.toString) == "function" && !isObject$m(val = fn2.call(it2))) return val;
  throw TypeError("Can't convert object to primitive value");
};
var anObject$3 = _anObject;
var IE8_DOM_DEFINE$1 = _ie8DomDefine;
var toPrimitive$3 = _toPrimitive$3;
var dP$3 = Object.defineProperty;
_objectDp.f = _descriptors ? Object.defineProperty : function defineProperty(O3, P2, Attributes) {
  anObject$3(O3);
  P2 = toPrimitive$3(P2, true);
  anObject$3(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return dP$3(O3, P2, Attributes);
  } catch (e5) {
  }
  if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
  if ("value" in Attributes) O3[P2] = Attributes.value;
  return O3;
};
var _propertyDesc = function(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value
  };
};
var dP$2 = _objectDp;
var createDesc$2 = _propertyDesc;
var _hide = _descriptors ? function(object, key2, value) {
  return dP$2.f(object, key2, createDesc$2(1, value));
} : function(object, key2, value) {
  object[key2] = value;
  return object;
};
var hasOwnProperty$i = {}.hasOwnProperty;
var _has = function(it2, key2) {
  return hasOwnProperty$i.call(it2, key2);
};
var global$4 = _globalExports;
var core$6 = _coreExports;
var ctx = _ctx;
var hide$3 = _hide;
var has$d = _has;
var PROTOTYPE$2 = "prototype";
var $export$4 = function(type2, name2, source) {
  var IS_FORCED = type2 & $export$4.F;
  var IS_GLOBAL = type2 & $export$4.G;
  var IS_STATIC = type2 & $export$4.S;
  var IS_PROTO = type2 & $export$4.P;
  var IS_BIND = type2 & $export$4.B;
  var IS_WRAP = type2 & $export$4.W;
  var exports = IS_GLOBAL ? core$6 : core$6[name2] || (core$6[name2] = {});
  var expProto = exports[PROTOTYPE$2];
  var target = IS_GLOBAL ? global$4 : IS_STATIC ? global$4[name2] : (global$4[name2] || {})[PROTOTYPE$2];
  var key2, own2, out;
  if (IS_GLOBAL) source = name2;
  for (key2 in source) {
    own2 = !IS_FORCED && target && target[key2] !== void 0;
    if (own2 && has$d(exports, key2)) continue;
    out = own2 ? target[key2] : source[key2];
    exports[key2] = IS_GLOBAL && typeof target[key2] != "function" ? source[key2] : IS_BIND && own2 ? ctx(out, global$4) : IS_WRAP && target[key2] == out ? function(C2) {
      var F2 = function(a4, b3, c3) {
        if (this instanceof C2) {
          switch (arguments.length) {
            case 0:
              return new C2();
            case 1:
              return new C2(a4);
            case 2:
              return new C2(a4, b3);
          }
          return new C2(a4, b3, c3);
        }
        return C2.apply(this, arguments);
      };
      F2[PROTOTYPE$2] = C2[PROTOTYPE$2];
      return F2;
    }(out) : IS_PROTO && typeof out == "function" ? ctx(Function.call, out) : out;
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key2] = out;
      if (type2 & $export$4.R && expProto && !expProto[key2]) hide$3(expProto, key2, out);
    }
  }
};
$export$4.F = 1;
$export$4.G = 2;
$export$4.S = 4;
$export$4.P = 8;
$export$4.B = 16;
$export$4.W = 32;
$export$4.U = 64;
$export$4.R = 128;
var _export = $export$4;
var _redefine = _hide;
var _iterators = {};
var toString$8 = {}.toString;
var _cof = function(it2) {
  return toString$8.call(it2).slice(8, -1);
};
var cof$1 = _cof;
var _iobject = Object("z").propertyIsEnumerable(0) ? Object : function(it2) {
  return cof$1(it2) == "String" ? it2.split("") : Object(it2);
};
var IObject = _iobject;
var defined$1 = _defined;
var _toIobject = function(it2) {
  return IObject(defined$1(it2));
};
var toInteger$4 = _toInteger;
var min$3 = Math.min;
var _toLength = function(it2) {
  return it2 > 0 ? min$3(toInteger$4(it2), 9007199254740991) : 0;
};
var toInteger$3 = _toInteger;
var max$3 = Math.max;
var min$2 = Math.min;
var _toAbsoluteIndex = function(index2, length) {
  index2 = toInteger$3(index2);
  return index2 < 0 ? max$3(index2 + length, 0) : min$2(index2, length);
};
var toIObject$5 = _toIobject;
var toLength = _toLength;
var toAbsoluteIndex = _toAbsoluteIndex;
var _arrayIncludes$1 = function(IS_INCLUDES) {
  return function($this, el2, fromIndex) {
    var O3 = toIObject$5($this);
    var length = toLength(O3.length);
    var index2 = toAbsoluteIndex(fromIndex, length);
    var value;
    if (IS_INCLUDES && el2 != el2) while (length > index2) {
      value = O3[index2++];
      if (value != value) return true;
    }
    else for (; length > index2; index2++) if (IS_INCLUDES || index2 in O3) {
      if (O3[index2] === el2) return IS_INCLUDES || index2 || 0;
    }
    return !IS_INCLUDES && -1;
  };
};
var _shared = { exports: {} };
var core$5 = _coreExports;
var global$3 = _globalExports;
var SHARED = "__core-js_shared__";
var store$1 = global$3[SHARED] || (global$3[SHARED] = {});
(_shared.exports = function(key2, value) {
  return store$1[key2] || (store$1[key2] = value !== void 0 ? value : {});
})("versions", []).push({
  version: core$5.version,
  mode: "pure",
  copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
});
var _sharedExports = _shared.exports;
var id$2 = 0;
var px = Math.random();
var _uid = function(key2) {
  return "Symbol(".concat(key2 === void 0 ? "" : key2, ")_", (++id$2 + px).toString(36));
};
var shared$1 = _sharedExports("keys");
var uid$3 = _uid;
var _sharedKey = function(key2) {
  return shared$1[key2] || (shared$1[key2] = uid$3(key2));
};
var has$c = _has;
var toIObject$4 = _toIobject;
var arrayIndexOf = _arrayIncludes$1(false);
var IE_PROTO$2 = _sharedKey("IE_PROTO");
var _objectKeysInternal = function(object, names2) {
  var O3 = toIObject$4(object);
  var i3 = 0;
  var result2 = [];
  var key2;
  for (key2 in O3) if (key2 != IE_PROTO$2) has$c(O3, key2) && result2.push(key2);
  while (names2.length > i3) if (has$c(O3, key2 = names2[i3++])) {
    ~arrayIndexOf(result2, key2) || result2.push(key2);
  }
  return result2;
};
var _enumBugKeys = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
var $keys$2 = _objectKeysInternal;
var enumBugKeys$1 = _enumBugKeys;
var _objectKeys = Object.keys || function keys(O3) {
  return $keys$2(O3, enumBugKeys$1);
};
var dP$1 = _objectDp;
var anObject$2 = _anObject;
var getKeys$1 = _objectKeys;
var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O3, Properties) {
  anObject$2(O3);
  var keys4 = getKeys$1(Properties);
  var length = keys4.length;
  var i3 = 0;
  var P2;
  while (length > i3) dP$1.f(O3, P2 = keys4[i3++], Properties[P2]);
  return O3;
};
var _html;
var hasRequired_html;
function require_html() {
  if (hasRequired_html) return _html;
  hasRequired_html = 1;
  var document2 = _globalExports.document;
  _html = document2 && document2.documentElement;
  return _html;
}
var anObject$1 = _anObject;
var dPs = _objectDps;
var enumBugKeys = _enumBugKeys;
var IE_PROTO$1 = _sharedKey("IE_PROTO");
var Empty = function() {
};
var PROTOTYPE$1 = "prototype";
var createDict = function() {
  var iframe = require_domCreate()("iframe");
  var i3 = enumBugKeys.length;
  var lt2 = "<";
  var gt2 = ">";
  var iframeDocument;
  iframe.style.display = "none";
  require_html().appendChild(iframe);
  iframe.src = "javascript:";
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt2 + "script" + gt2 + "document.F=Object" + lt2 + "/script" + gt2);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i3--) delete createDict[PROTOTYPE$1][enumBugKeys[i3]];
  return createDict();
};
var _objectCreate = Object.create || function create(O3, Properties) {
  var result2;
  if (O3 !== null) {
    Empty[PROTOTYPE$1] = anObject$1(O3);
    result2 = new Empty();
    Empty[PROTOTYPE$1] = null;
    result2[IE_PROTO$1] = O3;
  } else result2 = createDict();
  return Properties === void 0 ? result2 : dPs(result2, Properties);
};
var _wks = { exports: {} };
var store = _sharedExports("wks");
var uid$2 = _uid;
var Symbol$8 = _globalExports.Symbol;
var USE_SYMBOL = typeof Symbol$8 == "function";
var $exports = _wks.exports = function(name2) {
  return store[name2] || (store[name2] = USE_SYMBOL && Symbol$8[name2] || (USE_SYMBOL ? Symbol$8 : uid$2)("Symbol." + name2));
};
$exports.store = store;
var _wksExports = _wks.exports;
var def$t = _objectDp.f;
var has$b = _has;
var TAG = _wksExports("toStringTag");
var _setToStringTag = function(it2, tag2, stat) {
  if (it2 && !has$b(it2 = stat ? it2 : it2.prototype, TAG)) def$t(it2, TAG, { configurable: true, value: tag2 });
};
var create$3 = _objectCreate;
var descriptor = _propertyDesc;
var setToStringTag$2 = _setToStringTag;
var IteratorPrototype = {};
_hide(IteratorPrototype, _wksExports("iterator"), function() {
  return this;
});
var _iterCreate = function(Constructor, NAME, next3) {
  Constructor.prototype = create$3(IteratorPrototype, { next: descriptor(1, next3) });
  setToStringTag$2(Constructor, NAME + " Iterator");
};
var defined = _defined;
var _toObject = function(it2) {
  return Object(defined(it2));
};
var has$a = _has;
var toObject$2 = _toObject;
var IE_PROTO = _sharedKey("IE_PROTO");
var ObjectProto$1 = Object.prototype;
var _objectGpo = Object.getPrototypeOf || function(O3) {
  O3 = toObject$2(O3);
  if (has$a(O3, IE_PROTO)) return O3[IE_PROTO];
  if (typeof O3.constructor == "function" && O3 instanceof O3.constructor) {
    return O3.constructor.prototype;
  }
  return O3 instanceof Object ? ObjectProto$1 : null;
};
var $export$3 = _export;
var redefine$1 = _redefine;
var hide$2 = _hide;
var Iterators$2 = _iterators;
var $iterCreate = _iterCreate;
var setToStringTag$1 = _setToStringTag;
var getPrototypeOf$2 = _objectGpo;
var ITERATOR = _wksExports("iterator");
var BUGGY = !([].keys && "next" in [].keys());
var FF_ITERATOR = "@@iterator";
var KEYS = "keys";
var VALUES = "values";
var returnThis = function() {
  return this;
};
var _iterDefine = function(Base, NAME, Constructor, next3, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next3);
  var getMethod = function(kind) {
    if (!BUGGY && kind in proto2) return proto2[kind];
    switch (kind) {
      case KEYS:
        return function keys4() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }
    return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG2 = NAME + " Iterator";
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto2 = Base.prototype;
  var $native = proto2[ITERATOR] || proto2[FF_ITERATOR] || DEFAULT && proto2[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod("entries") : void 0;
  var $anyNative = NAME == "Array" ? proto2.entries || $native : $native;
  var methods, key2, IteratorPrototype2;
  if ($anyNative) {
    IteratorPrototype2 = getPrototypeOf$2($anyNative.call(new Base()));
    if (IteratorPrototype2 !== Object.prototype && IteratorPrototype2.next) {
      setToStringTag$1(IteratorPrototype2, TAG2, true);
    }
  }
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  if (FORCED && (BUGGY || VALUES_BUG || !proto2[ITERATOR])) {
    hide$2(proto2, ITERATOR, $default);
  }
  Iterators$2[NAME] = $default;
  Iterators$2[TAG2] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key2 in methods) {
      if (!(key2 in proto2)) redefine$1(proto2, key2, methods[key2]);
    }
    else $export$3($export$3.P + $export$3.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};
var $at = _stringAt(true);
_iterDefine(String, "String", function(iterated) {
  this._t = String(iterated);
  this._i = 0;
}, function() {
  var O3 = this._t;
  var index2 = this._i;
  var point3;
  if (index2 >= O3.length) return { value: void 0, done: true };
  point3 = $at(O3, index2);
  this._i += point3.length;
  return { value: point3, done: false };
});
var _iterStep = function(done, value) {
  return { value, done: !!done };
};
var step = _iterStep;
var Iterators$1 = _iterators;
var toIObject$3 = _toIobject;
_iterDefine(Array, "Array", function(iterated, kind) {
  this._t = toIObject$3(iterated);
  this._i = 0;
  this._k = kind;
}, function() {
  var O3 = this._t;
  var kind = this._k;
  var index2 = this._i++;
  if (!O3 || index2 >= O3.length) {
    this._t = void 0;
    return step(1);
  }
  if (kind == "keys") return step(0, index2);
  if (kind == "values") return step(0, O3[index2]);
  return step(0, [index2, O3[index2]]);
}, "values");
Iterators$1.Arguments = Iterators$1.Array;
var global$2 = _globalExports;
var hide$1 = _hide;
var Iterators = _iterators;
var TO_STRING_TAG = _wksExports("toStringTag");
var DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(",");
for (var i$1 = 0; i$1 < DOMIterables.length; i$1++) {
  var NAME = DOMIterables[i$1];
  var Collection$2 = global$2[NAME];
  var proto$7 = Collection$2 && Collection$2.prototype;
  if (proto$7 && !proto$7[TO_STRING_TAG]) hide$1(proto$7, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}
var _wksExt = {};
_wksExt.f = _wksExports;
var iterator$1 = _wksExt.f("iterator");
var iterator = { "default": iterator$1, __esModule: true };
var _meta = { exports: {} };
var META$1 = _uid("meta");
var isObject$l = _isObject;
var has$9 = _has;
var setDesc = _objectDp.f;
var id$1 = 0;
var isExtensible = Object.isExtensible || function() {
  return true;
};
var FREEZE = !_fails(function() {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it2) {
  setDesc(it2, META$1, { value: {
    i: "O" + ++id$1,
    // object ID
    w: {}
    // weak collections IDs
  } });
};
var fastKey = function(it2, create5) {
  if (!isObject$l(it2)) return typeof it2 == "symbol" ? it2 : (typeof it2 == "string" ? "S" : "P") + it2;
  if (!has$9(it2, META$1)) {
    if (!isExtensible(it2)) return "F";
    if (!create5) return "E";
    setMeta(it2);
  }
  return it2[META$1].i;
};
var getWeak = function(it2, create5) {
  if (!has$9(it2, META$1)) {
    if (!isExtensible(it2)) return true;
    if (!create5) return false;
    setMeta(it2);
  }
  return it2[META$1].w;
};
var onFreeze = function(it2) {
  if (FREEZE && meta.NEED && isExtensible(it2) && !has$9(it2, META$1)) setMeta(it2);
  return it2;
};
var meta = _meta.exports = {
  KEY: META$1,
  NEED: false,
  fastKey,
  getWeak,
  onFreeze
};
var _metaExports = _meta.exports;
var core$4 = _coreExports;
var wksExt$1 = _wksExt;
var defineProperty$8 = _objectDp.f;
var _wksDefine = function(name2) {
  var $Symbol2 = core$4.Symbol || (core$4.Symbol = {});
  if (name2.charAt(0) != "_" && !(name2 in $Symbol2)) defineProperty$8($Symbol2, name2, { value: wksExt$1.f(name2) });
};
var _objectGops = {};
_objectGops.f = Object.getOwnPropertySymbols;
var _objectPie = {};
_objectPie.f = {}.propertyIsEnumerable;
var getKeys = _objectKeys;
var gOPS = _objectGops;
var pIE$1 = _objectPie;
var _enumKeys = function(it2) {
  var result2 = getKeys(it2);
  var getSymbols2 = gOPS.f;
  if (getSymbols2) {
    var symbols2 = getSymbols2(it2);
    var isEnum2 = pIE$1.f;
    var i3 = 0;
    var key2;
    while (symbols2.length > i3) if (isEnum2.call(it2, key2 = symbols2[i3++])) result2.push(key2);
  }
  return result2;
};
var cof = _cof;
var _isArray = Array.isArray || function isArray(arg) {
  return cof(arg) == "Array";
};
var _objectGopnExt = {};
var _objectGopn = {};
var $keys$1 = _objectKeysInternal;
var hiddenKeys = _enumBugKeys.concat("length", "prototype");
_objectGopn.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O3) {
  return $keys$1(O3, hiddenKeys);
};
var toIObject$2 = _toIobject;
var gOPN$1 = _objectGopn.f;
var toString$7 = {}.toString;
var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function(it2) {
  try {
    return gOPN$1(it2);
  } catch (e5) {
    return windowNames.slice();
  }
};
_objectGopnExt.f = function getOwnPropertyNames2(it2) {
  return windowNames && toString$7.call(it2) == "[object Window]" ? getWindowNames(it2) : gOPN$1(toIObject$2(it2));
};
var _objectGopd = {};
var pIE = _objectPie;
var createDesc$1 = _propertyDesc;
var toIObject$1 = _toIobject;
var toPrimitive$2 = _toPrimitive$3;
var has$8 = _has;
var IE8_DOM_DEFINE = _ie8DomDefine;
var gOPD$6 = Object.getOwnPropertyDescriptor;
_objectGopd.f = _descriptors ? gOPD$6 : function getOwnPropertyDescriptor(O3, P2) {
  O3 = toIObject$1(O3);
  P2 = toPrimitive$2(P2, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD$6(O3, P2);
  } catch (e5) {
  }
  if (has$8(O3, P2)) return createDesc$1(!pIE.f.call(O3, P2), O3[P2]);
};
var global$1 = _globalExports;
var has$7 = _has;
var DESCRIPTORS = _descriptors;
var $export$2 = _export;
var redefine = _redefine;
var META = _metaExports.KEY;
var $fails = _fails;
var shared = _sharedExports;
var setToStringTag = _setToStringTag;
var uid$1 = _uid;
var wks = _wksExports;
var wksExt = _wksExt;
var wksDefine = _wksDefine;
var enumKeys = _enumKeys;
var isArray$p = _isArray;
var anObject = _anObject;
var isObject$k = _isObject;
var toObject$1 = _toObject;
var toIObject = _toIobject;
var toPrimitive$1 = _toPrimitive$3;
var createDesc = _propertyDesc;
var _create$1 = _objectCreate;
var gOPNExt = _objectGopnExt;
var $GOPD = _objectGopd;
var $GOPS = _objectGops;
var $DP = _objectDp;
var $keys = _objectKeys;
var gOPD$5 = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global$1.Symbol;
var $JSON = global$1.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = "prototype";
var HIDDEN = wks("_hidden");
var TO_PRIMITIVE = wks("toPrimitive");
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared("symbol-registry");
var AllSymbols = shared("symbols");
var OPSymbols = shared("op-symbols");
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == "function" && !!$GOPS.f;
var QObject = global$1.QObject;
var setter$1 = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
var setSymbolDesc = DESCRIPTORS && $fails(function() {
  return _create$1(dP({}, "a", {
    get: function() {
      return dP(this, "a", { value: 7 }).a;
    }
  })).a != 7;
}) ? function(it2, key2, D3) {
  var protoDesc = gOPD$5(ObjectProto, key2);
  if (protoDesc) delete ObjectProto[key2];
  dP(it2, key2, D3);
  if (protoDesc && it2 !== ObjectProto) dP(ObjectProto, key2, protoDesc);
} : dP;
var wrap$3 = function(tag2) {
  var sym = AllSymbols[tag2] = _create$1($Symbol[PROTOTYPE]);
  sym._k = tag2;
  return sym;
};
var isSymbol$7 = USE_NATIVE && typeof $Symbol.iterator == "symbol" ? function(it2) {
  return typeof it2 == "symbol";
} : function(it2) {
  return it2 instanceof $Symbol;
};
var $defineProperty$3 = function defineProperty2(it2, key2, D3) {
  if (it2 === ObjectProto) $defineProperty$3(OPSymbols, key2, D3);
  anObject(it2);
  key2 = toPrimitive$1(key2, true);
  anObject(D3);
  if (has$7(AllSymbols, key2)) {
    if (!D3.enumerable) {
      if (!has$7(it2, HIDDEN)) dP(it2, HIDDEN, createDesc(1, {}));
      it2[HIDDEN][key2] = true;
    } else {
      if (has$7(it2, HIDDEN) && it2[HIDDEN][key2]) it2[HIDDEN][key2] = false;
      D3 = _create$1(D3, { enumerable: createDesc(0, false) });
    }
    return setSymbolDesc(it2, key2, D3);
  }
  return dP(it2, key2, D3);
};
var $defineProperties = function defineProperties2(it2, P2) {
  anObject(it2);
  var keys4 = enumKeys(P2 = toIObject(P2));
  var i3 = 0;
  var l2 = keys4.length;
  var key2;
  while (l2 > i3) $defineProperty$3(it2, key2 = keys4[i3++], P2[key2]);
  return it2;
};
var $create = function create2(it2, P2) {
  return P2 === void 0 ? _create$1(it2) : $defineProperties(_create$1(it2), P2);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key2) {
  var E3 = isEnum.call(this, key2 = toPrimitive$1(key2, true));
  if (this === ObjectProto && has$7(AllSymbols, key2) && !has$7(OPSymbols, key2)) return false;
  return E3 || !has$7(this, key2) || !has$7(AllSymbols, key2) || has$7(this, HIDDEN) && this[HIDDEN][key2] ? E3 : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor2(it2, key2) {
  it2 = toIObject(it2);
  key2 = toPrimitive$1(key2, true);
  if (it2 === ObjectProto && has$7(AllSymbols, key2) && !has$7(OPSymbols, key2)) return;
  var D3 = gOPD$5(it2, key2);
  if (D3 && has$7(AllSymbols, key2) && !(has$7(it2, HIDDEN) && it2[HIDDEN][key2])) D3.enumerable = true;
  return D3;
};
var $getOwnPropertyNames = function getOwnPropertyNames3(it2) {
  var names2 = gOPN(toIObject(it2));
  var result2 = [];
  var i3 = 0;
  var key2;
  while (names2.length > i3) {
    if (!has$7(AllSymbols, key2 = names2[i3++]) && key2 != HIDDEN && key2 != META) result2.push(key2);
  }
  return result2;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it2) {
  var IS_OP = it2 === ObjectProto;
  var names2 = gOPN(IS_OP ? OPSymbols : toIObject(it2));
  var result2 = [];
  var i3 = 0;
  var key2;
  while (names2.length > i3) {
    if (has$7(AllSymbols, key2 = names2[i3++]) && (IS_OP ? has$7(ObjectProto, key2) : true)) result2.push(AllSymbols[key2]);
  }
  return result2;
};
if (!USE_NATIVE) {
  $Symbol = function Symbol2() {
    if (this instanceof $Symbol) throw TypeError("Symbol is not a constructor!");
    var tag2 = uid$1(arguments.length > 0 ? arguments[0] : void 0);
    var $set = function(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has$7(this, HIDDEN) && has$7(this[HIDDEN], tag2)) this[HIDDEN][tag2] = false;
      setSymbolDesc(this, tag2, createDesc(1, value));
    };
    if (DESCRIPTORS && setter$1) setSymbolDesc(ObjectProto, tag2, { configurable: true, set: $set });
    return wrap$3(tag2);
  };
  redefine($Symbol[PROTOTYPE], "toString", function toString2() {
    return this._k;
  });
  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty$3;
  _objectGopn.f = gOPNExt.f = $getOwnPropertyNames;
  _objectPie.f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;
  if (DESCRIPTORS && !_library) {
    redefine(ObjectProto, "propertyIsEnumerable", $propertyIsEnumerable);
  }
  wksExt.f = function(name2) {
    return wrap$3(wks(name2));
  };
}
$export$2($export$2.G + $export$2.W + $export$2.F * !USE_NATIVE, { Symbol: $Symbol });
for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(",")
), j$3 = 0; es6Symbols.length > j$3; ) wks(es6Symbols[j$3++]);
for (var wellKnownSymbols = $keys(wks.store), k$3 = 0; wellKnownSymbols.length > k$3; ) wksDefine(wellKnownSymbols[k$3++]);
$export$2($export$2.S + $export$2.F * !USE_NATIVE, "Symbol", {
  // 19.4.2.1 Symbol.for(key)
  "for": function(key2) {
    return has$7(SymbolRegistry, key2 += "") ? SymbolRegistry[key2] : SymbolRegistry[key2] = $Symbol(key2);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol$7(sym)) throw TypeError(sym + " is not a symbol!");
    for (var key2 in SymbolRegistry) if (SymbolRegistry[key2] === sym) return key2;
  },
  useSetter: function() {
    setter$1 = true;
  },
  useSimple: function() {
    setter$1 = false;
  }
});
$export$2($export$2.S + $export$2.F * !USE_NATIVE, "Object", {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty$3,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});
var FAILS_ON_PRIMITIVES = $fails(function() {
  $GOPS.f(1);
});
$export$2($export$2.S + $export$2.F * FAILS_ON_PRIMITIVES, "Object", {
  getOwnPropertySymbols: function getOwnPropertySymbols2(it2) {
    return $GOPS.f(toObject$1(it2));
  }
});
$JSON && $export$2($export$2.S + $export$2.F * (!USE_NATIVE || $fails(function() {
  var S4 = $Symbol();
  return _stringify([S4]) != "[null]" || _stringify({ a: S4 }) != "{}" || _stringify(Object(S4)) != "{}";
})), "JSON", {
  stringify: function stringify(it2) {
    var args = [it2];
    var i3 = 1;
    var replacer, $replacer;
    while (arguments.length > i3) args.push(arguments[i3++]);
    $replacer = replacer = args[1];
    if (!isObject$k(replacer) && it2 === void 0 || isSymbol$7(it2)) return;
    if (!isArray$p(replacer)) replacer = function(key2, value) {
      if (typeof $replacer == "function") value = $replacer.call(this, key2, value);
      if (!isSymbol$7(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});
$Symbol[PROTOTYPE][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
setToStringTag($Symbol, "Symbol");
setToStringTag(Math, "Math", true);
setToStringTag(global$1.JSON, "JSON", true);
_wksDefine("asyncIterator");
_wksDefine("observable");
var symbol$1 = _coreExports.Symbol;
var symbol = { "default": symbol$1, __esModule: true };
_typeof$5.__esModule = true;
var _iterator = iterator;
var _iterator2 = _interopRequireDefault$b(_iterator);
var _symbol = symbol;
var _symbol2 = _interopRequireDefault$b(_symbol);
var _typeof$4 = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
};
function _interopRequireDefault$b(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
_typeof$5.default = typeof _symbol2.default === "function" && _typeof$4(_iterator2.default) === "symbol" ? function(obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof$4(obj);
} : function(obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof$4(obj);
};
possibleConstructorReturn.__esModule = true;
var _typeof2$1 = _typeof$5;
var _typeof3$1 = _interopRequireDefault$a(_typeof2$1);
function _interopRequireDefault$a(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
possibleConstructorReturn.default = function(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && ((typeof call2 === "undefined" ? "undefined" : (0, _typeof3$1.default)(call2)) === "object" || typeof call2 === "function") ? call2 : self2;
};
var inherits$1 = {};
var _setProto;
var hasRequired_setProto;
function require_setProto() {
  if (hasRequired_setProto) return _setProto;
  hasRequired_setProto = 1;
  var isObject3 = _isObject;
  var anObject2 = _anObject;
  var check = function(O3, proto2) {
    anObject2(O3);
    if (!isObject3(proto2) && proto2 !== null) throw TypeError(proto2 + ": can't set as prototype!");
  };
  _setProto = {
    set: Object.setPrototypeOf || ("__proto__" in {} ? (
      // eslint-disable-line
      function(test2, buggy, set2) {
        try {
          set2 = _ctx(Function.call, _objectGopd.f(Object.prototype, "__proto__").set, 2);
          set2(test2, []);
          buggy = !(test2 instanceof Array);
        } catch (e5) {
          buggy = true;
        }
        return function setPrototypeOf2(O3, proto2) {
          check(O3, proto2);
          if (buggy) O3.__proto__ = proto2;
          else set2(O3, proto2);
          return O3;
        };
      }({}, false)
    ) : void 0),
    check
  };
  return _setProto;
}
var $export$1 = _export;
$export$1($export$1.S, "Object", { setPrototypeOf: require_setProto().set });
var setPrototypeOf$1 = _coreExports.Object.setPrototypeOf;
var setPrototypeOf = { "default": setPrototypeOf$1, __esModule: true };
var $export = _export;
$export($export.S, "Object", { create: _objectCreate });
var $Object$2 = _coreExports.Object;
var create$2 = function create3(P2, D3) {
  return $Object$2.create(P2, D3);
};
var create$1 = { "default": create$2, __esModule: true };
inherits$1.__esModule = true;
var _setPrototypeOf$2 = setPrototypeOf;
var _setPrototypeOf2 = _interopRequireDefault$9(_setPrototypeOf$2);
var _create = create$1;
var _create2 = _interopRequireDefault$9(_create);
var _typeof2 = _typeof$5;
var _typeof3 = _interopRequireDefault$9(_typeof2);
function _interopRequireDefault$9(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
inherits$1.default = function(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }
  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
var setDisplayName$1 = {};
var setStatic$1 = {};
Object.defineProperty(setStatic$1, "__esModule", {
  value: true
});
var setStatic = function setStatic2(key2, value) {
  return function(BaseComponent) {
    BaseComponent[key2] = value;
    return BaseComponent;
  };
};
setStatic$1.default = setStatic;
Object.defineProperty(setDisplayName$1, "__esModule", {
  value: true
});
var _setStatic = setStatic$1;
var _setStatic2 = _interopRequireDefault$8(_setStatic);
function _interopRequireDefault$8(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var setDisplayName = function setDisplayName2(displayName) {
  return (0, _setStatic2.default)("displayName", displayName);
};
setDisplayName$1.default = setDisplayName;
var wrapDisplayName$1 = {};
var getDisplayName$1 = {};
Object.defineProperty(getDisplayName$1, "__esModule", {
  value: true
});
var getDisplayName2 = function getDisplayName3(Component2) {
  if (typeof Component2 === "string") {
    return Component2;
  }
  if (!Component2) {
    return void 0;
  }
  return Component2.displayName || Component2.name || "Component";
};
getDisplayName$1.default = getDisplayName2;
Object.defineProperty(wrapDisplayName$1, "__esModule", {
  value: true
});
var _getDisplayName = getDisplayName$1;
var _getDisplayName2 = _interopRequireDefault$7(_getDisplayName);
function _interopRequireDefault$7(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var wrapDisplayName = function wrapDisplayName2(BaseComponent, hocName) {
  return hocName + "(" + (0, _getDisplayName2.default)(BaseComponent) + ")";
};
wrapDisplayName$1.default = wrapDisplayName;
Object.defineProperty(shouldUpdate$1, "__esModule", {
  value: true
});
var _classCallCheck2 = classCallCheck$1;
var _classCallCheck3 = _interopRequireDefault$6(_classCallCheck2);
var _possibleConstructorReturn2 = possibleConstructorReturn;
var _possibleConstructorReturn3 = _interopRequireDefault$6(_possibleConstructorReturn2);
var _inherits2 = inherits$1;
var _inherits3 = _interopRequireDefault$6(_inherits2);
var _react = React__default;
var _setDisplayName$1 = setDisplayName$1;
var _setDisplayName2$1 = _interopRequireDefault$6(_setDisplayName$1);
var _wrapDisplayName$1 = wrapDisplayName$1;
var _wrapDisplayName2$1 = _interopRequireDefault$6(_wrapDisplayName$1);
function _interopRequireDefault$6(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var shouldUpdate = function shouldUpdate2(test2) {
  return function(BaseComponent) {
    var factory2 = (0, _react.createFactory)(BaseComponent);
    var ShouldUpdate = function(_Component) {
      (0, _inherits3.default)(ShouldUpdate2, _Component);
      function ShouldUpdate2() {
        (0, _classCallCheck3.default)(this, ShouldUpdate2);
        return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
      }
      ShouldUpdate2.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test2(this.props, nextProps);
      };
      ShouldUpdate2.prototype.render = function render() {
        return factory2(this.props);
      };
      return ShouldUpdate2;
    }(_react.Component);
    if (process$1$1.env.NODE_ENV !== "production") {
      return (0, _setDisplayName2$1.default)((0, _wrapDisplayName2$1.default)(BaseComponent, "shouldUpdate"))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};
shouldUpdate$1.default = shouldUpdate;
var shallowEqual$2 = {};
var hasOwnProperty$h = Object.prototype.hasOwnProperty;
function is$2(x3, y4) {
  if (x3 === y4) {
    return x3 !== 0 || y4 !== 0 || 1 / x3 === 1 / y4;
  } else {
    return x3 !== x3 && y4 !== y4;
  }
}
function shallowEqual$1(objA, objB) {
  if (is$2(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }
  for (var i3 = 0; i3 < keysA.length; i3++) {
    if (!hasOwnProperty$h.call(objB, keysA[i3]) || !is$2(objA[keysA[i3]], objB[keysA[i3]])) {
      return false;
    }
  }
  return true;
}
var shallowEqual_1 = shallowEqual$1;
Object.defineProperty(shallowEqual$2, "__esModule", {
  value: true
});
var _shallowEqual$1 = shallowEqual_1;
var _shallowEqual2$1 = _interopRequireDefault$5(_shallowEqual$1);
function _interopRequireDefault$5(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
shallowEqual$2.default = _shallowEqual2$1.default;
Object.defineProperty(pure$1, "__esModule", {
  value: true
});
var _shouldUpdate = shouldUpdate$1;
var _shouldUpdate2 = _interopRequireDefault$4(_shouldUpdate);
var _shallowEqual = shallowEqual$2;
var _shallowEqual2 = _interopRequireDefault$4(_shallowEqual);
var _setDisplayName = setDisplayName$1;
var _setDisplayName2 = _interopRequireDefault$4(_setDisplayName);
var _wrapDisplayName = wrapDisplayName$1;
var _wrapDisplayName2 = _interopRequireDefault$4(_wrapDisplayName);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var pure = function pure2(BaseComponent) {
  var hoc = (0, _shouldUpdate2.default)(function(props2, nextProps) {
    return !(0, _shallowEqual2.default)(props2, nextProps);
  });
  if (process$1$1.env.NODE_ENV !== "production") {
    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, "pure"))(hoc(BaseComponent));
  }
  return hoc(BaseComponent);
};
pure$1.default = pure;
var svgIcon = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _propTypes = _interopRequireDefault2(propTypesExports);
  var _classnames = _interopRequireDefault2(classnamesExports);
  var _reactJss = _interopRequireDefault2(lib$o);
  var _excluded3 = ["children", "className", "classes"];
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _extends2() {
    _extends2 = Object.assign ? Object.assign.bind() : function(target) {
      for (var i3 = 1; i3 < arguments.length; i3++) {
        var source = arguments[i3];
        for (var key2 in source) {
          if (Object.prototype.hasOwnProperty.call(source, key2)) {
            target[key2] = source[key2];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  function _objectWithoutPropertiesLoose2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key2, i3;
    for (i3 = 0; i3 < sourceKeys.length; i3++) {
      key2 = sourceKeys[i3];
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
    return target;
  }
  var styles2 = {
    svgIcon: {
      fill: "currentColor"
    }
  };
  var SvgIcon = function SvgIcon2(props2) {
    var children = props2.children, className = props2.className, classes = props2.classes, other = _objectWithoutPropertiesLoose2(props2, _excluded3);
    return /* @__PURE__ */ _react2["default"].createElement("svg", _extends2({
      className: (0, _classnames["default"])(className, classes.svgIcon)
    }, other), children);
  };
  SvgIcon.propTypes = process$1$1.env.NODE_ENV !== "production" ? {
    classes: _propTypes["default"].object.isRequired,
    children: _propTypes["default"].node.isRequired,
    className: _propTypes["default"].string,
    viewBox: _propTypes["default"].string,
    width: _propTypes["default"].number,
    height: _propTypes["default"].number
  } : {};
  SvgIcon.defaultProps = {
    className: null,
    viewBox: "0 0 32 32",
    width: 32,
    height: 32
  };
  exports["default"] = (0, _reactJss["default"])(styles2)(SvgIcon);
  module2.exports = exports.default;
})(svgIcon, svgIcon.exports);
var svgIconExports = svgIcon.exports;
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _pure = _interopRequireDefault2(pure$1);
  var _svgIcon = _interopRequireDefault2(svgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _extends2() {
    _extends2 = Object.assign ? Object.assign.bind() : function(target) {
      for (var i3 = 1; i3 < arguments.length; i3++) {
        var source = arguments[i3];
        for (var key2 in source) {
          if (Object.prototype.hasOwnProperty.call(source, key2)) {
            target[key2] = source[key2];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  exports["default"] = function _default2(path3, customProps) {
    if (customProps === void 0) {
      customProps = {};
    }
    return (0, _pure["default"])(function(props2) {
      return /* @__PURE__ */ _react2["default"].createElement(_svgIcon["default"], _extends2({}, props2, customProps), path3);
    });
  };
  module2.exports = exports.default;
})(createSvgIcon, createSvgIcon.exports);
var createSvgIconExports = createSvgIcon.exports;
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M3.6212257 7.610797c-.157343 0-.3155852-.051249-.4477533-.156444L.54 5.358545l.8955065-1.125677 2.0976071 1.669634L8.3792783.389203 9.46 1.338655 4.1624856 7.36714c-.1420582.16094-.34076.243657-.5412599.243657"
  }), {
    viewBox: "0 0 10 8",
    width: 10,
    height: 8
  });
  module2.exports = exports.default;
})(CheckboxTick, CheckboxTick.exports);
var CheckboxTickExports = CheckboxTick.exports;
var CollapseLane = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M5.8.3l-.9.9 2.1 2H0v1.3h7L4.9 6.6l.9.9 2.7-2.7c.3-.3.4-.6.4-1s-.1-.7-.4-1L5.8.3z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M19 3.2h-7l2.1-2.1-.9-.9-2.7 2.7c-.3.3-.4.6-.4 1s.1.7.4 1l2.7 2.7.9-.9L12 4.5h7V3.2z"
  })), {
    viewBox: "0 0 19 8",
    width: 19,
    height: 8
  });
  module2.exports = exports.default;
})(CollapseLane, CollapseLane.exports);
var CollapseLaneExports = CollapseLane.exports;
var ExpandLane = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M17.039453 3.2l-2.1-2.1 1-.8 2.7 2.7c.3.3.4.6.4 1s-.1.7-.4 1l-2.7 2.5-.9-.9 2.1-2.1h-15.2l2.1 2.1-1 .9-2.6-2.6c-.3-.3-.4-.6-.4-1s.1-.7.4-1l2.7-2.7.9.9-2.1 2.1h15.1z"
  }), {
    viewBox: "0 0 19 8",
    width: 19,
    height: 8
  });
  module2.exports = exports.default;
})(ExpandLane, ExpandLane.exports);
var ExpandLaneExports = ExpandLane.exports;
var OutgoingPullPushArrow = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M9.5 6.2L5.6 1.9l4.1.2-.2 4.1zm.9-5.4L4.1.5c-.3 0-.5.1-.6.4-.1.2-.1.5.1.7l2.5 2.8c-4 4-6.1 9.5-6.1 16.2h1.3c0-6.4 1.9-11.5 5.6-15.2l2.6 2.9c.1.1.3.2.5.2h.2c.2-.1.4-.3.4-.6l.3-6.3c.1-.5-.2-.8-.5-.8z"
  }), {
    viewBox: "0 0 11 21",
    width: 11,
    height: 21
  });
  module2.exports = exports.default;
})(OutgoingPullPushArrow, OutgoingPullPushArrow.exports);
var OutgoingPullPushArrowExports = OutgoingPullPushArrow.exports;
var MenuDots = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "16",
    cy: "23.36",
    r: "2.24"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2.24"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "16",
    cy: "8.64",
    r: "2.24"
  })), {
    viewBox: "0 0 32 32"
  });
  module2.exports = exports.default;
})(MenuDots, MenuDots.exports);
var MenuDotsExports = MenuDots.exports;
var Outgoing = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M15.2961975,10.2734375 L15.296875,18.0859375 C15.296875,18.7265625 14.921875,19.2734375 14.4765625,19.2734375 L2.5234375,19.2734375 C2.078125,19.2734375 1.7421875,18.7265625 1.7421875,18.0859375 L1.7421875,2.8828125 C1.7421875,2.2421875 2.1171875,1.6953125 2.5234375,1.6953125 L7.8515625,1.6953125 L7.8515625,0.6796875 L2.5234375,0.6796875 C1.411171,0.786950604 0.592432044,1.76943735 0.6875,2.8828125 L0.6875,18.1171875 C0.592432044,19.2305627 1.411171,20.2130494 2.5234375,20.3203125 L14.4765625,20.3203125 C15.588829,20.2130494 16.407568,19.2305627 16.3125,18.1171875 L16.3125,10.3046875 L15.296875,10.2734375 Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M5.6640625,17.2109375 L6.6796875,17.2109375 C6.54495081,12.6434917 8.60395217,8.28735336 12.21875,5.4921875 L13.6953125,8.09375 C13.7894509,8.25063691 13.9576957,8.3480418 14.140625,8.3515625 L14.203125,8.3515625 C14.4075286,8.32754856 14.5772249,8.18253533 14.6328125,7.984375 L15.9375,3.2109375 C15.9765132,3.08242875 15.9594922,2.9434239 15.890625,2.828125 C15.8239679,2.71123338 15.7148545,2.62450222 15.5859375,2.5859375 L10.84375,1.2734375 C10.6464951,1.22521275 10.4393038,1.29725319 10.3145177,1.45745159 C10.1897315,1.61764999 10.1705904,1.83617161 10.265625,2.015625 L11.7421875,4.6015625 C7.79286916,7.57168188 5.52750463,12.2712941 5.6640625,17.2109375 Z M14.828125,3.46875 L13.9765625,6.59375 L11.7265625,2.6875 L14.828125,3.46875 Z"
  })), {
    viewBox: "0 0 17 21",
    width: 17,
    height: 21
  });
  module2.exports = exports.default;
})(Outgoing, Outgoing.exports);
var OutgoingExports = Outgoing.exports;
var PendingTransferPullArrow = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M4.5.9L.2 5.8c-.2.2-.2.4-.1.7.1.2.3.4.6.4h3.7v13.5h1.3V6.8h3.7c.3 0 .5-.1.6-.4 0-.1.1-.2.1-.3l-.3-.3L5.5.9C5.4.7 5.2.6 5 .6s-.4.1-.5.3zm3.4 4.6H2.1L5 2.3l2.9 3.2z"
  }), {
    viewBox: "0 0 10 21",
    width: 10,
    height: 21
  });
  module2.exports = exports.default;
})(PendingTransferPullArrow, PendingTransferPullArrow.exports);
var PendingTransferPullArrowExports = PendingTransferPullArrow.exports;
var PendingTransferPushArrow = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M5.7 20.4v-14l4.1-4.7c.2-.2.2-.4.1-.7-.1-.2-.3-.4-.6-.4H.7C.4.6.2.8.1 1c0 .1-.1.2-.1.3 0 .2.1.3.2.4l4.1 4.7v13.9h1.4zM2.1 1.9h5.7L5 5.2 2.1 1.9z"
  }), {
    viewBox: "0 0 10 21",
    width: 10,
    height: 21
  });
  module2.exports = exports.default;
})(PendingTransferPushArrow, PendingTransferPushArrow.exports);
var PendingTransferPushArrowExports = PendingTransferPushArrow.exports;
misc.__esModule = true;
misc.PendingTransferPushArrow = misc.PendingTransferPullArrow = misc.OutgoingPullPushArrow = misc.Outgoing = misc.MenuDots = misc.ExpandLane = misc.CollapseLane = misc.CheckboxTick = void 0;
var _CheckboxTick = _interopRequireDefault$3(CheckboxTickExports);
misc.CheckboxTick = _CheckboxTick["default"];
var _CollapseLane = _interopRequireDefault$3(CollapseLaneExports);
misc.CollapseLane = _CollapseLane["default"];
var _ExpandLane = _interopRequireDefault$3(ExpandLaneExports);
misc.ExpandLane = _ExpandLane["default"];
var _OutgoingPullPushArrow = _interopRequireDefault$3(OutgoingPullPushArrowExports);
misc.OutgoingPullPushArrow = _OutgoingPullPushArrow["default"];
var _MenuDots = _interopRequireDefault$3(MenuDotsExports);
misc.MenuDots = _MenuDots["default"];
var _Outgoing$1 = _interopRequireDefault$3(OutgoingExports);
misc.Outgoing = _Outgoing$1["default"];
var _PendingTransferPullArrow = _interopRequireDefault$3(PendingTransferPullArrowExports);
misc.PendingTransferPullArrow = _PendingTransferPullArrow["default"];
var _PendingTransferPushArrow = _interopRequireDefault$3(PendingTransferPushArrowExports);
misc.PendingTransferPushArrow = _PendingTransferPushArrow["default"];
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}
var mui = {};
var MUIImage = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
  }), {
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  });
  module2.exports = exports.default;
})(MUIImage, MUIImage.exports);
var MUIImageExports = MUIImage.exports;
var MUILabel = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"
  }), {
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  });
  module2.exports = exports.default;
})(MUILabel, MUILabel.exports);
var MUILabelExports = MUILabel.exports;
mui.__esModule = true;
mui.MUILabel = mui.MUIImage = void 0;
var _MUIImage = _interopRequireDefault$2(MUIImageExports);
mui.MUIImage = _MUIImage["default"];
var _MUILabel = _interopRequireDefault$2(MUILabelExports);
mui.MUILabel = _MUILabel["default"];
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}
var generatedIcons = {};
var Add = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.65 9.84h-1.3v5.51H9.84v1.3h5.51v5.51h1.3v-5.51h5.51v-1.3h-5.51V9.84z"
  })));
  module2.exports = exports.default;
})(Add, Add.exports);
var AddExports = Add.exports;
var AddCircle = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16 3.72A12.28 12.28 0 1 0 28.28 16 12.3 12.3 0 0 0 16 3.72zM16 27a11 11 0 1 1 11-11 11 11 0 0 1-11 11z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.65 9.84h-1.3v5.51H9.84v1.3h5.51v5.51h1.3v-5.51h5.51v-1.3h-5.51V9.84z"
  })));
  module2.exports = exports.default;
})(AddCircle, AddCircle.exports);
var AddCircleExports = AddCircle.exports;
var AddForms = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("polygon", {
    points: "16.65 12.84 15.35 12.84 15.35 17.35 10.84 17.35 10.84 18.65 15.35 18.65 15.35 23.16 16.65 23.16 16.65 18.65 21.16 18.65 21.16 17.35 16.65 17.35 16.65 12.84"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M20.51,3.65H8.3A2.82,2.82,0,0,0,5.45,6.43V25.57A2.82,2.82,0,0,0,8.3,28.35H23.7a2.82,2.82,0,0,0,2.85-2.78V9.64Zm-.26,1.57L25,10H22.29a2,2,0,0,1-2-1.85ZM23.7,27.05H8.3a1.52,1.52,0,0,1-1.55-1.48V6.43A1.52,1.52,0,0,1,8.3,5H19V8.1a3.26,3.26,0,0,0,3.34,3.15h3V25.57A1.52,1.52,0,0,1,23.7,27.05Z"
  })));
  module2.exports = exports.default;
})(AddForms, AddForms.exports);
var AddFormsExports = AddForms.exports;
var AddMembers = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("polygon", {
    points: "26.25 6.94 26.25 2.73 24.95 2.73 24.95 6.94 20.75 6.94 20.75 8.24 24.95 8.24 24.95 12.44 26.25 12.44 26.25 8.24 30.46 8.24 30.46 6.94 26.25 6.94"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M15,7.75a4.73,4.73,0,1,0,4.73,4.73A4.73,4.73,0,0,0,15,7.75Zm0,8.16a3.43,3.43,0,1,1,3.43-3.43A3.44,3.44,0,0,1,15,15.91Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.53,14.58A13.52,13.52,0,0,1,27.61,16a12.39,12.39,0,0,1-4.49,9.54v-.4a6.57,6.57,0,0,0-6.56-6.55h-3A6.56,6.56,0,0,0,7,25.14v.06A12.38,12.38,0,0,1,19.73,4.46l.48-1.21a13.7,13.7,0,1,0,8.61,11.19ZM8.27,26.23V25.14a5.26,5.26,0,0,1,5.25-5.25h3a5.26,5.26,0,0,1,5.25,5.25v1.33a12.32,12.32,0,0,1-13.54-.24Z"
  })));
  module2.exports = exports.default;
})(AddMembers, AddMembers.exports);
var AddMembersExports = AddMembers.exports;
var Analytics = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M2.35,29.65V1.35h-1v29.3h29.3v-1Z",
    transform: "translate(0 0)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M6.63,26.67a2.71,2.71,0,0,0,2-4.51l3.61-5.26a2.72,2.72,0,0,0,1,.18,2.67,2.67,0,0,0,1.71-.63l2.38,1.79a2.63,2.63,0,0,0-.22,1.05,2.71,2.71,0,1,0,4.5-2l3.69-7.1a2.59,2.59,0,0,0,.63.09,2.72,2.72,0,1,0-2.71-2.71,2.68,2.68,0,0,0,.93,2l-3.69,7.09a2.74,2.74,0,0,0-.64-.08,2.66,2.66,0,0,0-1.7.62l-2.38-1.78a2.82,2.82,0,0,0,.21-1.06,2.71,2.71,0,1,0-4.73,1.8L7.57,21.42a2.66,2.66,0,0,0-.94-.18,2.72,2.72,0,0,0,0,5.43ZM25.9,6.13a1.42,1.42,0,1,1-.64,2.67h0a1.41,1.41,0,0,1,.66-2.66ZM19.79,17.88a1.38,1.38,0,0,1,.64.16h0a1.4,1.4,0,1,1-.66-.17ZM13.21,13a1.41,1.41,0,0,1,1.41,1.41,1.44,1.44,0,0,1-.28.84h0A1.41,1.41,0,1,1,13.21,13ZM6.63,22.54a1.42,1.42,0,1,1-1.019.43,1.42,1.42,0,0,1,1.019-.43Z",
    transform: "translate(0 0)"
  })));
  module2.exports = exports.default;
})(Analytics, Analytics.exports);
var AnalyticsExports = Analytics.exports;
var Archive = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.06,4.75H4.94a2.5,2.5,0,1,0,0,5h.27v15a2.45,2.45,0,0,0,2.41,2.49H24.38a2.45,2.45,0,0,0,2.41-2.49v-15h.27a2.5,2.5,0,1,0,0-5Zm-1.57,20A1.15,1.15,0,0,1,24.38,26H7.62a1.15,1.15,0,0,1-1.11-1.19v-15h19ZM27.06,8.44H4.94a1.2,1.2,0,1,1,0-2.39H27.06a1.2,1.2,0,1,1,0,2.39Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "11.39",
    y: "15.2",
    width: "9.22",
    height: "1.3"
  })));
  module2.exports = exports.default;
})(Archive, Archive.exports);
var ArchiveExports = Archive.exports;
var ArchiveFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M28 4H4a2.65 2.65 0 0 0 0 5.3h.35v16.37a2.61 2.61 0 0 0 2.56 2.65h18.18a2.61 2.61 0 0 0 2.56-2.65V9.32H28A2.65 2.65 0 0 0 28 4zm-7 12.65H11v-1.3h10zM28 8H4a1.35 1.35 0 0 1 0-2.7h24A1.35 1.35 0 1 1 28 8z"
  })));
  module2.exports = exports.default;
})(ArchiveFill, ArchiveFill.exports);
var ArchiveFillExports = ArchiveFill.exports;
var ArrowArchive = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16,22.36a3.52,3.52,0,0,1-2.53-1.05L2.91,10.75l.92-.92L14.39,20.39a2.33,2.33,0,0,0,3.22,0L28.17,9.83l.92.92L18.53,21.31A3.52,3.52,0,0,1,16,22.36Z"
  })));
  module2.exports = exports.default;
})(ArrowArchive, ArrowArchive.exports);
var ArrowArchiveExports = ArrowArchive.exports;
var ArrowLeft = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", {
    transform: "translate(-271 -277)"
  }, /* @__PURE__ */ _react2["default"].createElement("rect", {
    width: "32",
    height: "32",
    transform: "translate(271 277)",
    fill: "#fff"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M6.672,17.1,0,10.743,1.251,9.552,7.3,15.32V0H9.07V15.32l6.052-5.768,1.251,1.191L9.7,17.1A2.22,2.22,0,0,1,6.672,17.1Z",
    transform: "translate(295.678 285.131) rotate(90)",
    fill: "#34323a"
  })));
  module2.exports = exports.default;
})(ArrowLeft, ArrowLeft.exports);
var ArrowLeftExports = ArrowLeft.exports;
var ArrowLeftLight = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11.5862 15.9288L23.6863 3.82872C24.1046 3.41034 24.1046 2.73206 23.6863 2.31369C23.2678 1.89544 22.5896 1.89544 22.1712 2.31369L9.31369 15.1712C8.89544 15.5896 8.89544 16.2679 9.31369 16.6863L22.1712 29.5438C22.5969 29.9549 23.2752 29.9431 23.6863 29.5175C24.0872 29.1022 24.0872 28.444 23.6863 28.0288L11.5862 15.9288Z"
  })));
  module2.exports = exports.default;
})(ArrowLeftLight, ArrowLeftLight.exports);
var ArrowLeftLightExports = ArrowLeftLight.exports;
var ArrowRightLight = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21.4138 15.9158L9.31373 28.0159C8.89542 28.4342 8.89542 29.1125 9.31373 29.5309C9.73217 29.9492 10.4104 29.9492 10.8288 29.5309L23.6863 16.6733C24.1046 16.255 24.1046 15.5767 23.6863 15.1583L10.8288 2.30076C10.4031 1.88967 9.72482 1.90147 9.31373 2.32712C8.91275 2.74236 8.91275 3.40062 9.31373 3.81579L21.4138 15.9158Z"
  })));
  module2.exports = exports.default;
})(ArrowRightLight, ArrowRightLight.exports);
var ArrowRightLightExports = ArrowRightLight.exports;
var ArrowRight = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("rect", {
    width: "32",
    height: "32",
    fill: "#fff"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M6.672.6,0,6.956,1.251,8.147,7.3,2.379V17.7H9.07V2.379l6.052,5.768,1.251-1.191L9.7.6A2.22,2.22,0,0,0,6.672.6Z",
    transform: "translate(25.021 8.131) rotate(90)"
  })));
  module2.exports = exports.default;
})(ArrowRight, ArrowRight.exports);
var ArrowRightExports = ArrowRight.exports;
var AwaitingAction = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("g", {
    fillRule: "evenodd"
  }, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M9.617488-.010571C6.26214552-.01992045 3.16505996 1.78919841 1.52510822 4.71647852-.11484352 7.6437586-.04025986 11.2297435 1.719988 14.086304l-1.2025 4.428125c-.00918838.0700549.01592708.1402472.06747248.188571.0515454.0483238.12321042.0688632.19252752.055179l5.005-1.0725c1.2046924.5444981 2.5130024.8216824 3.835.8125 3.4371463.2037777 6.7040929-1.5141765 8.4842045-4.4614978 1.7801115-2.9473213 1.7801115-6.6384331 0-9.58575441C16.3215809 1.50360551 13.0546343-.21434873 9.617488-.010571zM5.335613 10.950054c-.7269448 0-1.31625-.5893052-1.31625-1.31625s.5893052-1.31625 1.31625-1.31625 1.31625.5893052 1.31625 1.31625c-.004435.7250998-.59115017 1.311815-1.31625 1.31625zm4.411875.0000253c-.5331005.0032655-1.015541-.3153336-1.221834-.8069129-.206293-.4915792-.0956946-1.0590493.2801027-1.4371807.3757972-.3781314.9425716-.4922413 1.4354187-.2889961.4928472.2032452.8144376.6837038.8144376 1.2168144 0 .7237836-.5843552 1.3117822-1.308125 1.3162753zm4.40375-.0000253c-.7269448 0-1.31625-.5893052-1.31625-1.31625s.5893052-1.31625 1.31625-1.31625 1.31625.5893052 1.31625 1.31625c0 .3490912-.1386759.6838845-.3855207.9307293-.2468448.2468448-.5816381.3855207-.9307293.3855207z",
    fillRule: "nonzero"
  }))));
  module2.exports = exports.default;
})(AwaitingAction, AwaitingAction.exports);
var AwaitingActionExports = AwaitingAction.exports;
var Barcode = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M3.35 8h1.3v16h-1.3zM15.35 8h1.3v16h-1.3zM27.35 8h1.3v16h-1.3zM7.35 8h1.3v11h-1.3zM11.35 8h1.3v11h-1.3zM19.35 8h1.3v11h-1.3zM23.35 8h1.3v11h-1.3zM7.35 22h1.3v2h-1.3zM11.35 22h1.3v2h-1.3zM19.35 22h1.3v2h-1.3zM23.35 22h1.3v2h-1.3z"
  })));
  module2.exports = exports.default;
})(Barcode, Barcode.exports);
var BarcodeExports = Barcode.exports;
var Bell = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.2 25.65H2.8a.65.65 0 0 1-.46-1.11c1.08-1.06 2-2 2-3.87v-6.25c0-5.25 3.7-6.58 7.73-7.83A4.17 4.17 0 0 1 16 2.68a4.17 4.17 0 0 1 3.92 3.91c4 1.25 7.73 2.58 7.73 7.83v6.25c0 1.89.93 2.81 2 3.87a.65.65 0 0 1-.46 1.11zm-24.89-1.3h23.38a5.45 5.45 0 0 1-1.34-3.68v-6.25c0-4.27-2.62-5.29-7.25-6.72a.63.63 0 0 1-.45-.61A2.94 2.94 0 0 0 16 4a2.94 2.94 0 0 0-2.65 3.11.63.63 0 0 1-.45.61c-4.63 1.43-7.25 2.45-7.25 6.72v6.25a5.45 5.45 0 0 1-1.34 3.66z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16 30.65a4.72 4.72 0 0 1-4.65-5V25a.65.65 0 0 1 1.3 0v.67a3.36 3.36 0 1 0 6.7 0V25a.65.65 0 0 1 1.3 0v.67A4.72 4.72 0 0 1 16 30.65z"
  })));
  module2.exports = exports.default;
})(Bell, Bell.exports);
var BellExports = Bell.exports;
var BellFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.66 24.54c-1.08-1.06-2-2-2-3.87v-6.25c0-5.25-3.7-6.58-7.73-7.83A4.17 4.17 0 0 0 16 2.68a4.17 4.17 0 0 0-3.92 3.91c-4 1.25-7.73 2.58-7.73 7.83v6.25c0 1.89-.93 2.81-2 3.87a.65.65 0 0 0 .46 1.11h8.55a4.66 4.66 0 1 0 9.3 0h8.54a.65.65 0 0 0 .46-1.11zm-10.31 1.13a3.36 3.36 0 1 1-6.7 0h6.7z"
  })));
  module2.exports = exports.default;
})(BellFill, BellFill.exports);
var BellFillExports = BellFill.exports;
var Blockchain = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.91,15.72H27.7a3.49,3.49,0,0,0-3.41-2.84h-5.9A3.5,3.5,0,0,0,15,15.72H12.76V17H15a3.49,3.49,0,0,0,3.42,2.83h5.9A3.48,3.48,0,0,0,27.7,17h2.21Zm-5.62,2.83h-5.9A2.19,2.19,0,0,1,16.31,17h2v-1.3h-2a2.18,2.18,0,0,1,2.08-1.53h5.9a2.17,2.17,0,0,1,2.07,1.53h-2V17h2A2.19,2.19,0,0,1,24.29,18.55Z"
  }), /* @__PURE__ */ _react2["default"].createElement("polygon", {
    points: "20.69 24.97 2.74 24.97 2.74 7.03 20.69 7.03 20.69 11.21 21.99 11.21 21.99 5.73 1.44 5.73 1.44 26.27 21.99 26.27 21.99 21.38 20.69 21.38 20.69 24.97"
  }), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  })));
  module2.exports = exports.default;
})(Blockchain, Blockchain.exports);
var BlockchainExports = Blockchain.exports;
var Building = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M8.87.38H23.13V4.85h3V31.62H5.85V4.85h3Zm1.77,4.47H21.36V2.14H10.64Zm-3,1.76V29.86H17.84V22.79h3.55v7.07h3V6.61Zm3,6.79V9.85h3.55V13.4Zm7.23,0V9.85h3.55V13.4Zm-7.23,6.47V16.32h3.55v3.55Zm7.23,0V16.32h3.55v3.55Zm-7.23,6.47V22.79h3.55v3.55Z"
  })));
  module2.exports = exports.default;
})(Building, Building.exports);
var BuildingExports = Building.exports;
var Calendar = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27,6.59H24.4V4.11H23.1V6.59H8.9V4.11H7.6V6.59H5A2.65,2.65,0,0,0,2.35,9.24v16A2.65,2.65,0,0,0,5,27.89H27a2.65,2.65,0,0,0,2.65-2.65v-16A2.65,2.65,0,0,0,27,6.59ZM5,7.89H27a1.35,1.35,0,0,1,1.35,1.35v2.47H3.65V9.24A1.35,1.35,0,0,1,5,7.89Zm22,18.7H5a1.36,1.36,0,0,1-1.35-1.35V13h24.7V25.24A1.36,1.36,0,0,1,27,26.59Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M14,15.57a2.84,2.84,0,0,0-2.86,3v2.07a2.87,2.87,0,1,0,5.74,0V18.61A2.85,2.85,0,0,0,14,15.57Zm1.65,5.11a1.65,1.65,0,1,1-3.28,0V18.61a1.65,1.65,0,1,1,3.28,0Z"
  }), /* @__PURE__ */ _react2["default"].createElement("polygon", {
    points: "17.51 16.92 19.1 16.92 19.1 23.61 20.32 23.61 20.32 15.7 18.44 15.7 17.51 16.92"
  }), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  })));
  module2.exports = exports.default;
})(Calendar, Calendar.exports);
var CalendarExports = Calendar.exports;
var CalendarRow = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("rect", {
    width: "32",
    height: "32",
    fill: "none"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.23,5.78H23.94V3.15h-1.3V5.78H9.36V3.15H8.06V5.78H5.77A2.65,2.65,0,0,0,3.12,8.43V26.2a2.65,2.65,0,0,0,2.65,2.65H26.23a2.65,2.65,0,0,0,2.65-2.65V8.43a2.65,2.65,0,0,0-2.65-2.65Zm-15.34,19H7.54v-1.3h3.35Zm0-4H7.54v-1.3h3.35Zm6.79,4H14.32v-1.3h3.36Zm0-4H14.32v-1.3h3.36Zm0-4H14.32v-1.3h3.36Zm6.78,8H21.11v-1.3h3.35Zm0-4H21.11v-1.3h3.35Zm0-4H21.11v-1.3h3.35Zm3.12-5.39H4.42V8.43A1.35,1.35,0,0,1,5.77,7.08H26.23a1.35,1.35,0,0,1,1.35,1.35Z"
  })));
  module2.exports = exports.default;
})(CalendarRow, CalendarRow.exports);
var CalendarRowExports = CalendarRow.exports;
var Camera = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27,28.2H5a2.65,2.65,0,0,1-2.65-2.65V10A2.65,2.65,0,0,1,5,7.39H8.88V6.45A2.65,2.65,0,0,1,11.53,3.8h8.94a2.65,2.65,0,0,1,2.65,2.65v.94H27A2.65,2.65,0,0,1,29.65,10V25.55A2.65,2.65,0,0,1,27,28.2ZM5,8.69A1.36,1.36,0,0,0,3.65,10V25.55A1.36,1.36,0,0,0,5,26.9H27a1.36,1.36,0,0,0,1.35-1.35V10A1.36,1.36,0,0,0,27,8.69H22.47A.65.65,0,0,1,21.82,8V6.45A1.35,1.35,0,0,0,20.47,5.1H11.53a1.35,1.35,0,0,0-1.35,1.35V8a.65.65,0,0,1-.65.65Z"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "6.86",
    cy: "11.48",
    r: "1.38"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.33,25.1a6.27,6.27,0,1,1,6.26-6.26A6.27,6.27,0,0,1,16.33,25.1Zm0-11.23a5,5,0,1,0,5,5A5,5,0,0,0,16.33,13.87Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.33,22.52A3.68,3.68,0,1,1,20,18.84,3.68,3.68,0,0,1,16.33,22.52Zm0-6.06a2.38,2.38,0,1,0,2.38,2.38A2.37,2.37,0,0,0,16.33,16.46Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "21.84",
    y: "10.83",
    width: "4.25",
    height: "1.3"
  })));
  module2.exports = exports.default;
})(Camera, Camera.exports);
var CameraExports = Camera.exports;
var CircleInfo = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M17.76 14.014L16.113 21.788H13.425L15.059 14.014H17.76Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M18.576 10.212L18.114 12.412H15.414L15.876 10.212H18.576Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16 29.276C13.3743 29.276 10.8075 28.4974 8.62426 27.0386C6.44103 25.5798 4.73941 23.5064 3.73458 21.0805C2.72975 18.6546 2.46684 15.9853 2.9791 13.41C3.49136 10.8347 4.75578 8.46914 6.61246 6.61245C8.46914 4.75577 10.8347 3.49136 13.41 2.9791C15.9853 2.46684 18.6546 2.72975 21.0805 3.73458C23.5064 4.73941 25.5798 6.44103 27.0386 8.62425C28.4974 10.8075 29.276 13.3743 29.276 16C29.2723 19.5199 27.8724 22.8945 25.3835 25.3835C22.8945 27.8724 19.5199 29.2723 16 29.276ZM16 4.023C13.6312 4.023 11.3155 4.72544 9.34594 6.04149C7.37633 7.35754 5.84121 9.22809 4.9347 11.4166C4.02819 13.6051 3.791 16.0133 4.25313 18.3366C4.71527 20.6599 5.85597 22.794 7.53098 24.469C9.20599 26.144 11.3401 27.2847 13.6634 27.7469C15.9867 28.209 18.3949 27.9718 20.5834 27.0653C22.7719 26.1588 24.6425 24.6237 25.9585 22.6541C27.2746 20.6845 27.977 18.3688 27.977 16C27.9733 12.8246 26.7102 9.7804 24.4649 7.53508C22.2196 5.28976 19.1754 4.02671 16 4.023Z"
  })));
  module2.exports = exports.default;
})(CircleInfo, CircleInfo.exports);
var CircleInfoExports = CircleInfo.exports;
var CircleUpload = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16 3a13.28 13.28 0 1 0 13.28 13.28A13.3 13.3 0 0 0 16 3zm0 25.25a12 12 0 1 1 12-12 12 12 0 0 1-12 12z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M14.89 9.84L10 14.74l.92.92 4.45-4.45V23h1.3V11.21l4.45 4.45.92-.92-4.91-4.9a1.56 1.56 0 0 0-2.24 0z"
  })));
  module2.exports = exports.default;
})(CircleUpload, CircleUpload.exports);
var CircleUploadExports = CircleUpload.exports;
var Clipboard = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.55 6h-4a3.57 3.57 0 0 0-7 0h-4A2.65 2.65 0 0 0 5.8 8.61v17.75A2.65 2.65 0 0 0 8.45 29h15.1a2.65 2.65 0 0 0 2.65-2.65V8.61A2.65 2.65 0 0 0 23.55 6zM11.08 7.26h9.84v3h-9.84zm4.92-3A2.29 2.29 0 0 1 18.19 6h-4.38A2.29 2.29 0 0 1 16 4.29zm8.9 22.07a1.36 1.36 0 0 1-1.35 1.35H8.45a1.36 1.36 0 0 1-1.35-1.32V8.61a1.35 1.35 0 0 1 1.35-1.35h1.33v3.6a.65.65 0 0 0 .65.65h11.14a.65.65 0 0 0 .65-.65v-3.6h1.33a1.35 1.35 0 0 1 1.35 1.35z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M14.25 14.81h7.32v1.3h-7.32zM10.43 14.81h2.16v1.3h-2.16zM14.25 19.14h7.32v1.3h-7.32zM10.43 19.14h2.16v1.3h-2.16zM14.25 23.46h7.32v1.3h-7.32zM10.43 23.46h2.16v1.3h-2.16z"
  })));
  module2.exports = exports.default;
})(Clipboard, Clipboard.exports);
var ClipboardExports = Clipboard.exports;
var ClipboardCopied = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.55 6h-4a3.57 3.57 0 0 0-7 0h-4A2.65 2.65 0 0 0 5.8 8.61v17.75A2.65 2.65 0 0 0 8.45 29h15.1a2.65 2.65 0 0 0 2.65-2.65V8.61A2.65 2.65 0 0 0 23.55 6zM11.08 7.26h9.84v3h-9.84zm4.92-3A2.29 2.29 0 0 1 18.19 6h-4.38A2.29 2.29 0 0 1 16 4.29zm8.9 22.07a1.36 1.36 0 0 1-1.35 1.35H8.45a1.36 1.36 0 0 1-1.35-1.32V8.61a1.35 1.35 0 0 1 1.35-1.35h1.33v3.6a.65.65 0 0 0 .65.65h11.14a.65.65 0 0 0 .65-.65v-3.6h1.33a1.35 1.35 0 0 1 1.35 1.35z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M14.26 23.19l-3.61-2.87-.81 1 4.09 3.25a.67.67 0 0 0 .4.14.64.64 0 0 0 .49-.22l7.41-8.25-1-.87z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M14.23 21.52a.65.65 0 0 0 .49-.23l5.89-6.7-1-.86L14.15 20l-2.44-2-.81 1 2.93 2.33a.62.62 0 0 0 .4.19z"
  })));
  module2.exports = exports.default;
})(ClipboardCopied, ClipboardCopied.exports);
var ClipboardCopiedExports = ClipboardCopied.exports;
var Clock = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M20.61 21.86l-5.17-5.52a.67.67 0 0 1-.18-.44V7.68h1.3v8l5 5.33z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16 28.76A12.76 12.76 0 1 1 28.76 16 12.77 12.77 0 0 1 16 28.76zm0-24.22A11.46 11.46 0 1 0 27.46 16 11.47 11.47 0 0 0 16 4.54z"
  })));
  module2.exports = exports.default;
})(Clock, Clock.exports);
var ClockExports = Clock.exports;
var ClockGeneral = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", {
    transform: "translate(180.843 -10.001)"
  }, /* @__PURE__ */ _react2["default"].createElement("g", {
    transform: "translate(-180.843 10.001)"
  }, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M4.9,12.33l-1.24-.41A13.69,13.69,0,0,0,3.16,14l1.29.2a10.84,10.84,0,0,1,.45-1.87Z",
    transform: "translate(0 0)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M4.31,16.12H3a13.71,13.71,0,0,0,.19,2.13L4.49,18a12.35,12.35,0,0,1-.18-1.88Z",
    transform: "translate(0 0)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M13,4.71l-.33-1.26a13.12,13.12,0,0,0-2,.72l.54,1.19A11.2,11.2,0,0,1,13,4.71Z",
    transform: "translate(0 0)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M3.75,20.33a12.65,12.65,0,0,0,.88,2l1.13-.63A12.5,12.5,0,0,1,5,19.9Z",
    transform: "translate(0 0)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M6.69,8.93l-1-.78A12.49,12.49,0,0,0,4.5,10l1.15.61A11.54,11.54,0,0,1,6.69,8.93Z",
    transform: "translate(0 0)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M9.47,6.3,8.75,5.22A13.43,13.43,0,0,0,7.08,6.56L8,7.5A12.32,12.32,0,0,1,9.47,6.3Z",
    transform: "translate(0 0)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M12.88,28.62A12.64,12.64,0,0,0,15,29l.1-1.29a11.069,11.069,0,0,1-1.9-.31Z",
    transform: "translate(0 0)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M6.83,23.25l-1,.81a12.661,12.661,0,0,0,1.46,1.56l.88-1a11,11,0,0,1-1.34-1.37Z",
    transform: "translate(0 0)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29,16h0v-.27h0a13.481,13.481,0,0,0-.21-2.12h0v-.06l-.09-.38c-.06-.25-.11-.51-.19-.76s-.08-.28-.13-.41-.09-.31-.14-.46h0a12.17,12.17,0,0,0-.89-1.94h0c-.08-.15-.18-.29-.27-.44l-.18-.28c-.16-.24-.32-.47-.49-.7l-.19-.24-.07-.11h0a12.7,12.7,0,0,0-1.47-1.55h0l-.17-.14c-.23-.19-.47-.39-.71-.57l-.37-.25c-.15-.1-.28-.21-.43-.3h0A13,13,0,0,0,21,4h0l-.32-.12-.47-.17-.67-.2-.44-.13h-.14A13.25,13.25,0,0,0,16.87,3h-.12a13.6,13.6,0,0,0-2,0l.13,1.29a13.092,13.092,0,0,1,3.95.32l.39.11.61.19.41.15a11.63,11.63,0,0,1,2.39,1.27L23,6.6l.61.49.18.15a12,12,0,0,1,1.43,1.51l.15.2c.16.21.31.42.46.65l.15.25a11.89,11.89,0,0,1,1.2,2.58,1.191,1.191,0,0,0,.1.32c.07.26.14.52.19.79l.06.24A11.61,11.61,0,0,1,27.69,16a7.667,7.667,0,0,1-.05,1.07,1.048,1.048,0,0,1-.05.39,11.59,11.59,0,0,1-.66,2.67l-.18.47-.25.54c-.07.13-.13.27-.21.41h0a10.831,10.831,0,0,1-1.15,1.73l-.28.33c-.14.17-.29.33-.44.49s-.31.33-.48.48l.88,1c.13-.12.24-.24.36-.36h0l.17-.19q.26-.27.48-.54l.32-.37.11-.13h0a12.78,12.78,0,0,0,1.43-2.3c.08-.17.17-.34.25-.52s.15-.38.22-.57.09-.23.14-.35h0a13.061,13.061,0,0,0,.52-2.07h0l.06-.5a1.384,1.384,0,0,1,.05-.45A11.46,11.46,0,0,0,29,16Z",
    transform: "translate(0 0)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M20.74,26.69l.53,1.19a12.15,12.15,0,0,0,1.87-1l-.71-1.08a12.59,12.59,0,0,1-1.69.89Z",
    transform: "translate(0 0)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M9,26.93a13.111,13.111,0,0,0,1.89,1l.51-1.19a11.11,11.11,0,0,1-1.7-.91Z",
    transform: "translate(0 0)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M17,27.65l.12,1.29a12.29,12.29,0,0,0,2.1-.36l-.32-1.26a12.179,12.179,0,0,1-1.9.33Z",
    transform: "translate(0 0)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.65,15.74v-8h-1.3V16a.6.6,0,0,0,.18.44L20.7,22l.94-.89Z",
    transform: "translate(0 0)"
  }))));
  module2.exports = exports.default;
})(ClockGeneral, ClockGeneral.exports);
var ClockGeneralExports = ClockGeneral.exports;
var Copy = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M7.5 14.267C6.81903 14.267 6.267 14.819 6.267 15.5V25.5C6.267 26.181 6.81903 26.733 7.5 26.733H17.5C18.181 26.733 18.733 26.181 18.733 25.5V21H20V25.5C20 26.8807 18.8807 28 17.5 28H7.5C6.11929 28 5 26.8807 5 25.5V15.5C5 14.1193 6.11929 13 7.5 13H11V14.267H7.5Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 6.267H14.5C13.819 6.267 13.267 6.81903 13.267 7.5V17.5C13.267 18.181 13.819 18.733 14.5 18.733H24.5C25.181 18.733 25.733 18.181 25.733 17.5V7.5C25.733 6.81903 25.181 6.267 24.5 6.267ZM14.5 5C13.1193 5 12 6.11929 12 7.5V17.5C12 18.8807 13.1193 20 14.5 20H24.5C25.8807 20 27 18.8807 27 17.5V7.5C27 6.11929 25.8807 5 24.5 5H14.5Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 17L19 8L20.27 8L20.27 17L19 17Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12L24 12L24 13.27L15 13.27L15 12Z"
  })));
  module2.exports = exports.default;
})(Copy, Copy.exports);
var CopyExports = Copy.exports;
var CopyFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M7.5 14.267C6.81903 14.267 6.267 14.819 6.267 15.5V25.5C6.267 26.181 6.81903 26.733 7.5 26.733H17.5C18.181 26.733 18.733 26.181 18.733 25.5V21H20V25.5C20 26.8807 18.8807 28 17.5 28H7.5C6.11929 28 5 26.8807 5 25.5V15.5C5 14.1193 6.11929 13 7.5 13H11V14.267H7.5Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "13",
    y: "6",
    width: "13",
    height: "13"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 6.267H14.5C13.819 6.267 13.267 6.81903 13.267 7.5V17.5C13.267 18.181 13.819 18.733 14.5 18.733H24.5C25.181 18.733 25.733 18.181 25.733 17.5V7.5C25.733 6.81903 25.181 6.267 24.5 6.267ZM14.5 5C13.1193 5 12 6.11929 12 7.5V17.5C12 18.8807 13.1193 20 14.5 20H24.5C25.8807 20 27 18.8807 27 17.5V7.5C27 6.11929 25.8807 5 24.5 5H14.5Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 17L19 8L20.27 8L20.27 17L19 17Z",
    fill: "white"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12L24 12L24 13.27L15 13.27L15 12Z",
    fill: "white"
  })));
  module2.exports = exports.default;
})(CopyFill, CopyFill.exports);
var CopyFillExports = CopyFill.exports;
var Cross = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11.8733 11L11 11.8732L18.9811 19.8543L19.8544 18.981L11.8733 11Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M18.9811 11L11 18.9811L11.8733 19.8543L19.8544 11.8733L18.9811 11Z"
  })));
  module2.exports = exports.default;
})(Cross, Cross.exports);
var CrossExports = Cross.exports;
var CustomizeRuler = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("clipPath", {
    id: "clip-path"
  }), /* @__PURE__ */ _react2["default"].createElement("clipPath", {
    id: "clip-path-3"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M22.29 2.16H9.71A1.34 1.34 0 0 0 8.37 3.5v25a1.34 1.34 0 0 0 1.34 1.34h12.58a1.34 1.34 0 0 0 1.34-1.34v-25a1.34 1.34 0 0 0-1.34-1.34zM9.67 28.5v-25h2.63v25.01zm4 0v-25h8.65v2h-5.43v1.3h5.43v2h-2.86v1.3h2.86v2h-2.86v1.3h2.85v2h-5.42v1.3h5.42v2h-2.85V20h2.84v2h-2.84v1.3h2.84v2h-5.4v1.3h5.4v2z"
  })));
  module2.exports = exports.default;
})(CustomizeRuler, CustomizeRuler.exports);
var CustomizeRulerExports = CustomizeRuler.exports;
var CustomizeRulerFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("clipPath", {
    id: "clip-path"
  }), /* @__PURE__ */ _react2["default"].createElement("clipPath", {
    id: "clip-path-3"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M12.5 2.16H9.71A1.34 1.34 0 0 0 8.37 3.5v25a1.34 1.34 0 0 0 1.34 1.34h2.79zM22.29 2.16H13.5v27.68h8.79a1.34 1.34 0 0 0 1.34-1.34v-25a1.34 1.34 0 0 0-1.34-1.34zm0 24.23h-5.5v-1h5.5zm0-3.29h-2.94v-1h2.93zm0-3.3h-2.94v-1h2.93zm0-3.3h-5.5v-1h5.5zm0-3.3h-2.94v-1h2.93zm0-3.3h-2.94v-1h2.93zm0-3.3h-5.5v-1h5.5z"
  })));
  module2.exports = exports.default;
})(CustomizeRulerFill, CustomizeRulerFill.exports);
var CustomizeRulerFillExports = CustomizeRulerFill.exports;
var DamagedPackage = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.57,22.69,25.9,19.61l1.68-3.32a.66.66,0,0,0,0-.5.7.7,0,0,0-.33-.37l-3.22-1.6,2.24-2.24a.65.65,0,0,0,0-.88L24.29,8.31l.57-3.2a.61.61,0,0,0-.14-.53.66.66,0,0,0-.5-.23H7A2.65,2.65,0,0,0,4.35,7V25A2.65,2.65,0,0,0,7,27.65h9.41a.64.64,0,0,0,.49-.22l.9-1,.95,1a.64.64,0,0,0,.47.21h1.5a.59.59,0,0,0,.29-.07l1.57-.75,2.2.78a.57.57,0,0,0,.22,0A2.65,2.65,0,0,0,27.65,25V23A.65.65,0,0,0,27.57,22.69Zm-14.92-17h4.16l1.48,6.73-2-1a.67.67,0,0,0-.57,0L12.65,13ZM26.35,25a1.36,1.36,0,0,1-1.25,1.35l-2.35-.84a.67.67,0,0,0-.5,0l-1.67.81H19.51L18.27,25a.58.58,0,0,0-.49-.21.64.64,0,0,0-.48.22l-1.18,1.34H7A1.36,1.36,0,0,1,5.65,25V7A1.36,1.36,0,0,1,7,5.65h4.35V14a.65.65,0,0,0,.31.55.63.63,0,0,0,.63,0L16,12.72l2.92,1.41a.65.65,0,0,0,.91-.73l-1.7-7.75h5.31L23,8.39a.63.63,0,0,0,.15.53L25,11.09l-2.45,2.45a.68.68,0,0,0-.18.56.66.66,0,0,0,.36.48l3.43,1.71-1.54,3a.69.69,0,0,0,0,.61l1.76,3.23Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "8",
    y: "19.35",
    width: "4",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "8",
    y: "22.35",
    width: "7",
    height: "1.3"
  })));
  module2.exports = exports.default;
})(DamagedPackage, DamagedPackage.exports);
var DamagedPackageExports = DamagedPackage.exports;
var Document$1 = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.36,9.45,20.7,3.84a.64.64,0,0,0-.45-.19H8.3A2.82,2.82,0,0,0,5.45,6.43V25.57A2.82,2.82,0,0,0,8.3,28.35H23.7a2.82,2.82,0,0,0,2.85-2.78V9.91A.64.64,0,0,0,26.36,9.45ZM20.25,5.22,25,10H22.29a2,2,0,0,1-2-1.85ZM23.7,27.05H8.3a1.52,1.52,0,0,1-1.55-1.48V6.43A1.52,1.52,0,0,1,8.3,5H19V8.1a3.25,3.25,0,0,0,3.34,3.15h3V25.57A1.52,1.52,0,0,1,23.7,27.05Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "9.7",
    y: "12.65",
    width: "5.4",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "9.7",
    y: "17.15",
    width: "12.6",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "9.7",
    y: "21.65",
    width: "12.6",
    height: "1.3"
  })));
  module2.exports = exports.default;
})(Document$1, Document$1.exports);
var DocumentExports = Document$1.exports;
var DocumentClosed = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21.7 15.2l-3.2 3.3-3.3-3.3-.9.9 3.3 3.3-3.3 3.2.9.9 3.3-3.2 3.2 3.2 1-.9-3.3-3.2 3.3-3.3z",
    transform: "translate(-2.653 -1.745)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.9 10.3l-6.2-6.2c-.2-.1-.4-.1-.5-.1H10C8.4 4 7 5.3 7 6.9V28c0 1.7 1.4 3 3.1 3h17c1.7 0 3-1.3 3.1-3V10.8c-.2-.2-.2-.3-.3-.5zm-1.3.6h-3.2c-1.2.1-2.3-.9-2.3-2.1V5.5l5.5 5.4zM27 29.7H10c-1 0-1.7-.7-1.8-1.7V7c0-1 .8-1.7 1.8-1.7h11.8v3.5c0 .9.4 1.8 1.1 2.4.7.6 1.6 1 2.5 1h3.3v15.9c0 .9-.8 1.7-1.7 1.6z",
    transform: "translate(-2.653 -1.745)"
  })));
  module2.exports = exports.default;
})(DocumentClosed, DocumentClosed.exports);
var DocumentClosedExports = DocumentClosed.exports;
var DocumentComplete = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M30 9.8l-6.3-6.2c-.1-.1-.3-.2-.5-.2H10c-1.7 0-3.1 1.3-3.1 3v21.3c0 1.7 1.4 3 3.1 3h17.1c1.7 0 3.1-1.3 3.1-3V10.2c-.1-.1-.1-.3-.2-.4zm-1.3.6h-3.2c-1.2.1-2.3-.9-2.3-2.1V4.9l5.5 5.5zm-1.6 18.9H10c-1 0-1.8-.7-1.8-1.7V6.4c0-1 .8-1.7 1.8-1.7h11.9v3.6c0 .9.4 1.8 1.1 2.5.7.6 1.6 1 2.5 1h3.4v16c-.1.8-.9 1.6-1.8 1.5z",
    transform: "translate(-2.653 -.86)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.6 22.5l-3.2-3.2-.9.9 3.7 3.7c.1.1.3.2.5.2s.3-.1.5-.2l7.6-7.8-.9-.9-7.3 7.3z",
    transform: "translate(-2.653 -.86)"
  })));
  module2.exports = exports.default;
})(DocumentComplete, DocumentComplete.exports);
var DocumentCompleteExports = DocumentComplete.exports;
var DocumentDownload = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.36,9.45,20.7,3.84a.64.64,0,0,0-.45-.19H8.3A2.82,2.82,0,0,0,5.45,6.43V25.57A2.82,2.82,0,0,0,8.3,28.35H23.7a2.82,2.82,0,0,0,2.85-2.78V9.91A.64.64,0,0,0,26.36,9.45ZM20.25,5.22,25,10H22.29a2,2,0,0,1-2-1.85ZM23.7,27.05H8.3a1.52,1.52,0,0,1-1.55-1.48V6.43A1.52,1.52,0,0,1,8.3,5H19V8.1a3.25,3.25,0,0,0,3.34,3.15h3V25.57A1.52,1.52,0,0,1,23.7,27.05Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16,20.84a1.42,1.42,0,0,0,1-.42l2.8-2.8-.92-.92L16.65,19v-7h-1.3v7L13.11,16.7l-.92.92,2.8,2.8A1.42,1.42,0,0,0,16,20.84Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M20.92,22a.7.7,0,0,1-.59.22H11.67a.74.74,0,0,1-.59-.21V20H9.78v2a1.71,1.71,0,0,0,1.89,1.51h8.66A1.71,1.71,0,0,0,22.22,22V20h-1.3Z"
  })));
  module2.exports = exports.default;
})(DocumentDownload, DocumentDownload.exports);
var DocumentDownloadExports = DocumentDownload.exports;
var DocumentEmpty = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M24.556 29.65H7.444C6.63432 29.6596 5.85389 29.3477 5.27386 28.7827C4.69384 28.2177 4.3616 27.4457 4.35001 26.636V5.364C4.3616 4.55435 4.69384 3.78234 5.27386 3.21732C5.85389 2.6523 6.63432 2.34039 7.444 2.35H20.718C20.8896 2.35006 21.0543 2.418 21.176 2.539L27.458 8.769C27.5189 8.82936 27.5672 8.90117 27.6001 8.98029C27.6331 9.05942 27.65 9.14429 27.65 9.23V26.636C27.6384 27.4457 27.3062 28.2177 26.7261 28.7827C26.1461 29.3477 25.3657 29.6596 24.556 29.65V29.65ZM7.444 3.65C6.97908 3.64034 6.52926 3.81527 6.19302 4.13651C5.85679 4.45775 5.66153 4.89912 5.64999 5.364V26.636C5.66153 27.1009 5.85679 27.5423 6.19302 27.8635C6.52926 28.1847 6.97908 28.3597 7.444 28.35H24.556C25.0209 28.3597 25.4707 28.1847 25.807 27.8635C26.1432 27.5423 26.3385 27.1009 26.35 26.636V9.5L20.45 3.649L7.444 3.65Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27 10.65H22.992C22.0544 10.6761 21.1447 10.3296 20.462 9.68635C19.7794 9.04308 19.3795 8.1555 19.35 7.218V3H20.65V7.218C20.6798 7.81059 20.9428 8.36733 21.3815 8.76675C21.8203 9.16617 22.3992 9.37583 22.992 9.35H27V10.65Z"
  })));
  module2.exports = exports.default;
})(DocumentEmpty, DocumentEmpty.exports);
var DocumentEmptyExports = DocumentEmpty.exports;
var DocumentFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.46 9.56l-6.33-6.35a.66.66 0 0 0-.46-.21H7.44a3 3 0 0 0-3.09 2.94v20.45a3 3 0 0 0 3.09 2.93H24.5a3 3 0 0 0 3.08-2.93L27.65 10a.66.66 0 0 0-.19-.44zM9 12.35h6v1.3H9zm14 11.3H9v-1.3h14zm0-5H9v-1.3h14zm0-8A2.85 2.85 0 0 1 20 8V4.67l6 6z"
  })));
  module2.exports = exports.default;
})(DocumentFill, DocumentFill.exports);
var DocumentFillExports = DocumentFill.exports;
var DocumentGraph = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.36,9.45,20.7,3.84a.64.64,0,0,0-.45-.19H8.3A2.82,2.82,0,0,0,5.45,6.43V25.57A2.82,2.82,0,0,0,8.3,28.35H23.7a2.82,2.82,0,0,0,2.85-2.78V9.91A.64.64,0,0,0,26.36,9.45ZM20.25,5.22,25,10H22.29a2,2,0,0,1-2-1.85ZM23.7,27.05H8.3a1.52,1.52,0,0,1-1.55-1.48V6.43A1.52,1.52,0,0,1,8.3,5H19V8.1a3.25,3.25,0,0,0,3.34,3.15h3V25.57A1.52,1.52,0,0,1,23.7,27.05Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M22.5,13.17h-2a1.16,1.16,0,0,0-1.15,1.15v6.19a1.16,1.16,0,0,0,1.15,1.15h2a1.16,1.16,0,0,0,1.15-1.15V14.32A1.16,1.16,0,0,0,22.5,13.17Zm-.15,7.19H20.61V14.47h1.74Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M15,21.66h2a1.16,1.16,0,0,0,1.15-1.15V12.73A1.15,1.15,0,0,0,17,11.58H15a1.15,1.15,0,0,0-1.15,1.15v7.78A1.16,1.16,0,0,0,15,21.66Zm.15-8.78h1.74v7.48H15.13Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M9.5,21.66h2a1.16,1.16,0,0,0,1.15-1.15V18.05a1.15,1.15,0,0,0-1.15-1.15h-2a1.15,1.15,0,0,0-1.15,1.15v2.46A1.16,1.16,0,0,0,9.5,21.66Zm.15-3.47h1.74v2.17H9.65Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "8.52",
    y: "22.73",
    width: "14.96",
    height: "1.3"
  })));
  module2.exports = exports.default;
})(DocumentGraph, DocumentGraph.exports);
var DocumentGraphExports = DocumentGraph.exports;
var DocumentIncomplete = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.9 9.8l-6.2-6.2c-.1-.1-.3-.2-.5-.2H10c-1.7 0-3 1.3-3.1 3v21.1c0 1.7 1.4 3 3.1 3h17c1.7 0 3-1.3 3.1-3V10.3c0-.2-.1-.4-.2-.5zm-1.3.6h-3.2c-1.2.1-2.3-.9-2.3-2.1V4.9l5.5 5.5zM27 29.3H10c-1 0-1.7-.7-1.8-1.7V6.4c0-1 .8-1.7 1.8-1.7h11.8v3.5c0 .9.4 1.8 1.1 2.5.7.6 1.6 1 2.5 1h3.3v15.9c0 .9-.7 1.7-1.7 1.7z",
    transform: "translate(-2.653 -.977)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M12.7 19.2c-.6 0-1.1.3-1.3.9-.2.5-.1 1.1.3 1.5.4.4 1 .5 1.5.3s.9-.7.9-1.3c0-.8-.6-1.4-1.4-1.4zm5.2 0c-.6 0-1.1.3-1.3.9-.2.5-.1 1.1.3 1.5.4.4 1 .5 1.5.3s.9-.7.9-1.3c0-.8-.6-1.4-1.4-1.4zm5.2 0c-.6 0-1.1.3-1.3.9-.2.5-.1 1.1.3 1.5.4.4 1 .5 1.5.3s.9-.7.9-1.3c0-.8-.6-1.4-1.4-1.4z",
    transform: "translate(-2.653 -.977)"
  })));
  module2.exports = exports.default;
})(DocumentIncomplete, DocumentIncomplete.exports);
var DocumentIncompleteExports = DocumentIncomplete.exports;
var DocumentInvalid = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.8 9.9l-6.2-6.1c-.1-.1-.3-.2-.4-.2H10.1c-1.7 0-3 1.3-3 3v21c0 1.7 1.4 3 3 3H27c1.7 0 3-1.3 3-3V10.3c0-.1-.1-.3-.2-.4zm-1.2.5h-3.2c-1.2.1-2.2-.9-2.3-2.1V5l5.5 5.4zm-1.7 18.8H10.1c-1 0-1.7-.7-1.8-1.7v-21c0-1 .8-1.7 1.8-1.7h11.7v3.5c0 .9.4 1.8 1.1 2.4.7.6 1.6 1 2.5.9h3.3v15.8c0 1-.8 1.8-1.8 1.8z",
    transform: "translate(-2.653 -1.092)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M18.5 13c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-3 6.5-6.5-2.9-6.5-6.5-6.5zm-5.2 6.5c0-1.1.4-2.3 1.1-3.2l7.2 7.2c-1.6 1.2-3.7 1.5-5.5.6-1.7-.8-2.8-2.7-2.8-4.6zm9.3 3.1l-7.2-7.2c.9-.7 2-1.1 3.2-1.1 2.9 0 5.2 2.3 5.2 5.2-.1 1.1-.5 2.2-1.2 3.1z",
    transform: "translate(-2.653 -1.092)"
  })));
  module2.exports = exports.default;
})(DocumentInvalid, DocumentInvalid.exports);
var DocumentInvalidExports = DocumentInvalid.exports;
var DocumentLinked = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.36,9.45,20.7,3.84a.64.64,0,0,0-.45-.19H8.3A2.82,2.82,0,0,0,5.45,6.43V25.57A2.82,2.82,0,0,0,8.3,28.35H23.7a2.82,2.82,0,0,0,2.85-2.78V9.91A.64.64,0,0,0,26.36,9.45ZM20.25,5.22,25,10H22.29a2,2,0,0,1-2-1.85ZM23.7,27.05H8.3a1.52,1.52,0,0,1-1.55-1.48V6.43A1.52,1.52,0,0,1,8.3,5H19V8.1a3.25,3.25,0,0,0,3.34,3.15h3V25.57A1.52,1.52,0,0,1,23.7,27.05Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M17.65,15.35h-3.3a3.05,3.05,0,0,0-3,2.39H9.23V19h2.15a3,3,0,0,0,3,2.39h3.3a3,3,0,0,0,3-2.39h2.15v-1.3H20.62A3.05,3.05,0,0,0,17.65,15.35Zm0,4.78h-3.3A1.74,1.74,0,0,1,12.74,19h1.69v-1.3H12.74a1.74,1.74,0,0,1,1.61-1.09h3.3a1.74,1.74,0,0,1,1.61,1.09H17.57V19h1.69A1.74,1.74,0,0,1,17.65,20.13Z"
  })));
  module2.exports = exports.default;
})(DocumentLinked, DocumentLinked.exports);
var DocumentLinkedExports = DocumentLinked.exports;
var DocumentLocked = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.36,9.45,20.7,3.84a.64.64,0,0,0-.45-.19H8.3A2.82,2.82,0,0,0,5.45,6.43V25.57A2.82,2.82,0,0,0,8.3,28.35H23.7a2.82,2.82,0,0,0,2.85-2.78V9.91A.64.64,0,0,0,26.36,9.45ZM20.25,5.22,25,10H22.29a2,2,0,0,1-2-1.85ZM23.7,27.05H8.3a1.52,1.52,0,0,1-1.55-1.48V6.43A1.52,1.52,0,0,1,8.3,5H19V8.1a3.25,3.25,0,0,0,3.34,3.15h3V25.57A1.52,1.52,0,0,1,23.7,27.05Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M19.78,16h-.19v-.88a3.59,3.59,0,0,0-7.18,0V16h-.19a.65.65,0,0,0-.65.65v6.56a.65.65,0,0,0,.65.65h7.56a.65.65,0,0,0,.65-.65V16.69A.65.65,0,0,0,19.78,16Zm-6.07-.88a2.29,2.29,0,1,1,4.58,0V16H13.71Zm5.42,7.44H12.87V17.34h6.26Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "15.35",
    y: "18.73",
    width: "1.3",
    height: "2.23"
  })));
  module2.exports = exports.default;
})(DocumentLocked, DocumentLocked.exports);
var DocumentLockedExports = DocumentLocked.exports;
var DocumentRequest = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.8 9.4l-5.1-5.2c-.1-.1-.2-.2-.4-.2H13.6c-.7 0-1.4.2-1.9.7S11 5.9 11 6.6v1.5H9.6C8.2 8.1 7 9.3 7 10.7v17.7C7 29.8 8.2 31 9.6 31h13.8c1.4 0 2.6-1.2 2.6-2.6v-1.5h1.4c1.4 0 2.6-1.2 2.6-2.6V9.8c0-.2-.1-.3-.2-.4zm-5.5-3.8l4.1 4.2h-2.3c-.5 0-.9-.1-1.2-.4-.3-.3-.5-.8-.6-1.2V5.6zm.4 22.8c0 .7-.6 1.3-1.3 1.3H9.6c-.7 0-1.3-.6-1.3-1.3V10.7c0-.4.2-.7.4-.9.3-.2.6-.4.9-.4H11v14.9c0 .7.3 1.4.8 1.9s1.2.8 1.9.7h11.1l-.1 1.5zm2.7-2.8H13.6c-.3 0-.7-.1-.9-.4-.3-.2-.4-.6-.4-.9V6.6c0-.7.6-1.3 1.3-1.3h9.5v2.8c0 .8.3 1.6.9 2.2.6.6 1.3.9 2.1.8h2.6v13.1c0 .4-.2.7-.4 1-.2.3-.5.4-.9.4z",
    transform: "translate(-2.653 -1.44)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M25.3 15.3l-3.4-2c-.4-.3-.9-.3-1.3 0-.4.2-.7.7-.7 1.2V16h-5.2v1.3h5.2v1.2c0 .5.3 1 .7 1.2.4.3.9.3 1.4 0l3.4-2c.4-.3.7-.7.7-1.2-.1-.4-.4-.9-.8-1.2zm-.6 1.3l-3.4 2h-.1s-.1-.1 0-.1v-4-.1l3.4 2v.1s0 .1.1.1z",
    transform: "translate(-2.653 -1.44)"
  })));
  module2.exports = exports.default;
})(DocumentRequest, DocumentRequest.exports);
var DocumentRequestExports = DocumentRequest.exports;
var DocumentSearch = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.51,9.45,20.86,3.84a.66.66,0,0,0-.46-.19H8.46A2.82,2.82,0,0,0,5.61,6.43V25.57a2.82,2.82,0,0,0,2.85,2.78h15.4a2.82,2.82,0,0,0,2.85-2.78V9.91A.61.61,0,0,0,26.51,9.45Zm-6.1-4.23L25.18,10H22.45a2,2,0,0,1-2-1.85Zm3.45,21.83H8.46a1.51,1.51,0,0,1-1.55-1.48V6.43A1.51,1.51,0,0,1,8.46,5H19.11V8.1a3.25,3.25,0,0,0,3.34,3.15h3V25.57A1.52,1.52,0,0,1,23.86,27.05Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M20.05,16.24a5.28,5.28,0,1,0-5.27,5.27,5.17,5.17,0,0,0,3.11-1l3.92,3.92.92-.92-3.9-3.9A5.22,5.22,0,0,0,20.05,16.24Zm-5.27,4a4,4,0,1,1,4-4A4,4,0,0,1,14.78,20.21Z"
  })));
  module2.exports = exports.default;
})(DocumentSearch, DocumentSearch.exports);
var DocumentSearchExports = DocumentSearch.exports;
var DocumentSigned = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M22.06,25.57a1.51,1.51,0,0,1-1.55,1.48H5.12a1.51,1.51,0,0,1-1.55-1.48V6.43A1.51,1.51,0,0,1,5.12,5H15.76V8.1a3.25,3.25,0,0,0,3.35,3.15h2.95v2.33h1.31V9.91a.65.65,0,0,0-.2-.47l-5.65-5.6a.66.66,0,0,0-.46-.19H5.12A2.82,2.82,0,0,0,2.26,6.43V25.57a2.82,2.82,0,0,0,2.86,2.78H20.51a2.82,2.82,0,0,0,2.86-2.78V24.14H22.06ZM21.83,10H19.11a2,2,0,0,1-2-1.85V5.22Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "6.51",
    y: "13.78",
    width: "12.6",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "6.51",
    y: "17.82",
    width: "9.9",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.48,12.65,27.34,11a.65.65,0,0,0-.91.11l-1.68,2.16-5.84,7.49s0,0,0,0a1.34,1.34,0,0,0-.06.12s0,.07-.05.11v0l-.61,3a.65.65,0,0,0,.23.64.66.66,0,0,0,.68.08l2.76-1.33a.65.65,0,0,0,.22-.18h0l5.83-7.49,1.69-2.16a.69.69,0,0,0,.13-.48A.62.62,0,0,0,29.48,12.65ZM20,21.42l5.34-6.86,1.12.87-5.34,6.86-1.44.7Zm7.26-7-1.12-.87.88-1.14,1.12.87Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M8,23.36c0-.53.08-.67.17-.75a.6.6,0,0,1,.62,0,2,2,0,0,1,.47.46,2.16,2.16,0,0,0,1.38.91,2.29,2.29,0,0,0,1.7-.72,2.39,2.39,0,0,1,.71-.45c.29-.05.35,0,.73.47a3.51,3.51,0,0,0,2.53,1.54l.17-1.28a2.26,2.26,0,0,1-1.67-1.06,1.91,1.91,0,0,0-2-1,3,3,0,0,0-1.27.71,2.18,2.18,0,0,1-.75.45c-.15,0-.34-.23-.54-.46a3.19,3.19,0,0,0-.8-.74,1.92,1.92,0,0,0-2.07.13,2.13,2.13,0,0,0-.68,1.82Z"
  })));
  module2.exports = exports.default;
})(DocumentSigned, DocumentSigned.exports);
var DocumentSignedExports = DocumentSigned.exports;
var DocumentTick = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16,11.4a7.38,7.38,0,1,0,7.37,7.38A7.38,7.38,0,0,0,16,11.4Zm0,13.45a6.08,6.08,0,1,1,6.07-6.07A6.07,6.07,0,0,1,16,24.85Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M14.38,20.77l-1.9-1.9-.92.92,2,2a1.16,1.16,0,0,0,.85.35,1.2,1.2,0,0,0,.85-.35l5.21-5.21-.92-.92Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.46,8.77,21.18,2.54a.68.68,0,0,0-.46-.19H7.44a3.06,3.06,0,0,0-3.09,3V26.64a3.06,3.06,0,0,0,3.09,3H24.56a3.06,3.06,0,0,0,3.09-3V9.23A.66.66,0,0,0,27.46,8.77Zm-1.26.58H23a2.25,2.25,0,0,1-2.34-2.13V3.85Zm-1.64,19H7.44a1.76,1.76,0,0,1-1.79-1.71V5.36A1.76,1.76,0,0,1,7.44,3.65H19.35V7.22A3.54,3.54,0,0,0,23,10.65h3.36v16A1.75,1.75,0,0,1,24.56,28.35Z"
  })));
  module2.exports = exports.default;
})(DocumentTick, DocumentTick.exports);
var DocumentTickExports = DocumentTick.exports;
var DocumentUpload = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M15.4 13.7v6.8h1.3v-6.8l2.2 2.2.9-.9-2.8-2.8c-.5-.5-1.4-.5-1.9 0L12.3 15l.9.9 2.2-2.2z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M20.8 22.2c0 .1-.2.2-.6.2h-8.4c-.2 0-.4-.1-.6-.2v-1.9H10v1.9c.1.9.9 1.6 1.8 1.5h8.4c.9.1 1.7-.6 1.8-1.5v-1.9h-1.3c.1 0 .1 1.9.1 1.9z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.1 8.8l-6.1-6c-.1-.1-.3-.2-.4-.2H7.7c-1.6 0-3 1.3-3 2.9v20.6c0 1.6 1.4 2.9 3 2.9h16.6c1.6 0 3-1.3 3-2.9V9.3c0-.2-.1-.4-.2-.5zm-1.2.6h-3.1c-1.2 0-2.2-.9-2.3-2.1V4l5.4 5.4zm-1.6 18.4H7.7c-.9 0-1.7-.7-1.7-1.7V5.5c0-.9.8-1.7 1.7-1.7h11.5v3.5c.1 1.9 1.6 3.4 3.5 3.3H26v15.5c0 1-.8 1.7-1.7 1.7z"
  })));
  module2.exports = exports.default;
})(DocumentUpload, DocumentUpload.exports);
var DocumentUploadExports = DocumentUpload.exports;
var DocumentValid = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M30.1 9.7l-6.4-6.3c-.1-.1-.3-.2-.5-.2H9.9c-1.7 0-3.1 1.3-3.1 3v21.5c0 1.7 1.4 3 3.1 3h17.3c1.7 0 3.1-1.3 3.1-3V10.2c0-.2-.1-.4-.2-.5zm-1.3.6h-3.2c-1.2.1-2.3-.9-2.4-2.2V4.7l5.6 5.6zm-1.7 19.2H9.9c-1 0-1.8-.8-1.8-1.7V6.3c0-1 .8-1.7 1.8-1.7h12v3.6c0 .9.4 1.8 1.1 2.5.7.6 1.6 1 2.6 1H29v16.2c-.1.8-.9 1.6-1.9 1.6z",
    transform: "translate(-2.653 -1.208)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.8 16.6l-3.3-.5-1.5-2.9c-.1-.2-.3-.4-.6-.4-.2 0-.5.1-.6.4l-1.4 2.9-3.2.5c-.2 0-.4.2-.5.5-.1.2 0 .5.2.7l2.4 2.3-.6 3.2c0 .2.1.5.3.6.2.1.5.2.7.1l2.9-1.5 2.9 1.5c.2.1.5.1.7-.1.2-.1.3-.4.3-.6l-.7-3.3 2.3-2.3c.2-.2.2-.4.2-.7-.1-.2-.3-.4-.5-.4zm-3.2 2.7c-.2.2-.2.4-.2.6l.4 2.3-2-1.1c-.2-.1-.4-.1-.6 0l-2 1.1.4-2.3c0-.2 0-.4-.2-.6l-1.6-1.6 2.3-.3c.2 0 .4-.2.5-.3l1-2 1 2c.1.2.3.3.5.4l2.3.3-1.8 1.5z",
    transform: "translate(-2.653 -1.208)"
  })));
  module2.exports = exports.default;
})(DocumentValid, DocumentValid.exports);
var DocumentValidExports = DocumentValid.exports;
var DownArrow = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16 23.45a1.37 1.37 0 0 1-1.21-.7L7.65 10.38a1.42 1.42 0 0 1 0-1.38 1.4 1.4 0 0 1 1.22-.7h14.29a1.38 1.38 0 0 1 1.21.7 1.42 1.42 0 0 1 0 1.41l-7.14 12.34a1.4 1.4 0 0 1-1.23.7zm.65-1zM8.87 9.57a.09.09 0 0 0-.09 0 .08.08 0 0 0 0 .1l7.14 12.43a.28.28 0 0 0 .18 0l7.15-12.38a.16.16 0 0 0 0-.1.11.11 0 0 0-.09 0z"
  })));
  module2.exports = exports.default;
})(DownArrow, DownArrow.exports);
var DownArrowExports = DownArrow.exports;
var DownArrowFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M24.36 9.11a1.4 1.4 0 0 0-1.22-.7H8.86a1.39 1.39 0 0 0-1.22.7 1.42 1.42 0 0 0 0 1.41l7.14 12.37a1.41 1.41 0 0 0 2.44 0l7.14-12.37a1.42 1.42 0 0 0 0-1.41z"
  })));
  module2.exports = exports.default;
})(DownArrowFill, DownArrowFill.exports);
var DownArrowFillExports = DownArrowFill.exports;
var Download = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16,21.68a2,2,0,0,0,1.46-.6L22.53,16l-.92-.92-5,5v-14h-1.3V20l-5-5L9.47,16l5.07,5.08A2,2,0,0,0,16,21.68Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M25.43,20.75v3.61c0,.43-.68.91-1.59.91H8.16c-.94,0-1.59-.48-1.59-.91V20.75H5.27v3.61c0,1.24,1.27,2.21,2.89,2.21H23.84c1.62,0,2.89-1,2.89-2.21V20.75Z"
  })));
  module2.exports = exports.default;
})(Download, Download.exports);
var DownloadExports = Download.exports;
var DragDrop = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("g", {
    fillRule: "evenodd"
  }, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M8 11.4375081V4.43750806M11.343401 8.04717259h-7",
    stroke: "#5246F7",
    strokeLinecap: "square"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M7.9971126.04717394c-.15323128-.00066629-.29499043.08111784-.37109108.21411783l-2.0352919 3.53392898c-.08020588.13145938-.08020588.29672264 0 .42818203.07565647.13344172.21769973.21538976.37109109.21410622h4.07914739c.1530238.00008293.2944682-.08148933.3710225-.21398727.0765544-.13249795.0765805-.29577852.0000686-.42830098L8.37105824.26129177C8.29445608.12739651 8.1513619.04547235 7.9971126.04717394zM7.9971126 16.047173c-.15323128.0006663-.29499043-.0811178-.37109108-.2141178l-2.0352919-3.533929c-.08020588-.1314594-.08020588-.2967227 0-.428182.07565647-.1334418.21769973-.2153898.37109109-.2141063h4.07914739c.1530238-.0000829.2944682.0814894.3710225.2139873.0765544.132498.0765805.2957785.0000686.428301l-2.04100096 3.533929c-.07660216.1338952-.21969634.2158194-.37394564.2141178zM-.0231005 8.05005997c-.0006663.15323128.0811178.29499043.2141178.37109109l3.53392898 2.03529189c.13145938.08020589.29672265.08020589.42818203 0 .13344173-.07565647.21538976-.21769973.21410622-.37109109V6.00620443c.00008294-.15302375-.08148933-.29446812-.21398727-.37102249-.13249795-.07655436-.29577851-.07658052-.42830098-.00006859L.1910173 7.67611433c-.1338953.07660216-.2158194.21969635-.2141178.37394564zM15.9768995 8.05006c.0006663.1532313-.0811178.2949905-.2141178.3710911l-3.53392898 2.0352919c-.13145938.0802059-.29672265.0802059-.42818203 0-.13344173-.0756565-.21538976-.2176997-.21410622-.3710911V6.0062045c-.00008294-.1530238.08148933-.2944681.21398727-.3710225.13249795-.0765544.29577851-.0765805.42830098-.0000686l3.53392898 2.041001c.1338953.0766022.2158194.2196963.2141178.3739456z",
    fillRule: "nonzero"
  }))));
  module2.exports = exports.default;
})(DragDrop, DragDrop.exports);
var DragDropExports = DragDrop.exports;
var Duplicate = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.65,7.86,22.43,2.69A.64.64,0,0,0,22,2.5H11A2.65,2.65,0,0,0,8.27,5.11v1.5H6.84A2.66,2.66,0,0,0,4.16,9.23V26.89A2.65,2.65,0,0,0,6.84,29.5H21.05a2.65,2.65,0,0,0,2.68-2.61v-1.5h1.43a2.66,2.66,0,0,0,2.68-2.62V8.32A.66.66,0,0,0,27.65,7.86Zm-1.39.45h-2.4A1.75,1.75,0,0,1,22,6.65V4.12ZM22.43,26.89a1.35,1.35,0,0,1-1.38,1.31H6.84a1.35,1.35,0,0,1-1.38-1.31V9.23A1.35,1.35,0,0,1,6.84,7.91H8.27V22.77A2.66,2.66,0,0,0,11,25.39H22.43Zm2.73-2.8H11a1.35,1.35,0,0,1-1.38-1.32V5.11A1.35,1.35,0,0,1,11,3.8h9.78V6.65a3.05,3.05,0,0,0,3.13,3h2.68V22.77A1.35,1.35,0,0,1,25.16,24.09Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M12.25,12.1h5a.65.65,0,0,0,0-1.3h-5a.65.65,0,1,0,0,1.3Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.87,15H12.25a.66.66,0,0,0-.66.65.66.66,0,0,0,.66.65H23.87a.65.65,0,0,0,0-1.3Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.87,19.1H12.25a.66.66,0,0,0-.66.65.66.66,0,0,0,.66.65H23.87a.65.65,0,1,0,0-1.3Z"
  })));
  module2.exports = exports.default;
})(Duplicate, Duplicate.exports);
var DuplicateExports = Duplicate.exports;
var Email = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.65 9.56A2.65 2.65 0 0 0 27 6.91H5a2.65 2.65 0 0 0-2.65 2.65v13a2.67 2.67 0 0 0 .77 1.86.64.64 0 0 0 .58.42 2.64 2.64 0 0 0 1.3.36h22a2.64 2.64 0 0 0 1.3-.36.64.64 0 0 0 .58-.42 2.67 2.67 0 0 0 .77-1.86zm-26 13v-13a1.35 1.35 0 0 1 .17-.63l8.78 7.19-8.73 7.14a1.32 1.32 0 0 1-.22-.7zM18.37 17l8.07 6.6H5.56l8.07-6.6 2 1.61a.64.64 0 0 0 .82 0zm1-.84l8.78-7.19a1.35 1.35 0 0 1 .17.63v13a1.32 1.32 0 0 1-.22.7zM27 8.21l-11 9-11-9h22z"
  })));
  module2.exports = exports.default;
})(Email, Email.exports);
var EmailExports = Email.exports;
var EmailDoc = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.68 12.5l-4-3.37V3.5a.65.65 0 0 0-.68-.65H7a.65.65 0 0 0-.65.65v5.6l-4 3.37a2.59 2.59 0 0 0-1 2v12a2.73 2.73 0 0 0 2.8 2.65h23.7a2.73 2.73 0 0 0 2.8-2.65v-12a2.56 2.56 0 0 0-.97-1.97zm-1.45.5l-2.58 1.94V10.8zM7.65 4.15h16.7V15.5a.6.6 0 0 0 .1.32L16 22.18l-8.43-6.39a.57.57 0 0 0 .08-.29zm-1.3 10.71l-2.53-1.92 2.53-2.14zm23 11.64a1.43 1.43 0 0 1-1.5 1.35H4.15a1.43 1.43 0 0 1-1.5-1.35v-12a1.22 1.22 0 0 1 .2-.67l12.76 9.69a.66.66 0 0 0 .78 0l12.79-9.64a1.23 1.23 0 0 1 .17.62z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11 6.85h10v1.3H11zM11 10.85h10v1.3H11zM11 14.85h10v1.3H11z"
  })));
  module2.exports = exports.default;
})(EmailDoc, EmailDoc.exports);
var EmailDocExports = EmailDoc.exports;
var Erase = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("g", {
    clipPath: "url(#clip0)"
  }, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M18.4492 22.0625C18.2892 22.0625 18.1283 22.0017 18.0067 21.8792L10.1208 13.9792C9.87751 13.735 9.87751 13.3392 10.1217 13.0958C10.3658 12.8525 10.7625 12.8525 11.0067 13.0967L18.8925 20.9958C19.1358 21.24 19.1358 21.6358 18.8917 21.88C18.7692 22.0017 18.6092 22.0625 18.4492 22.0625Z",
    fill: "#34323A"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M13.895 25.9998C13.3517 25.9998 12.8067 25.7923 12.3925 25.3781L6.62083 19.6065C6.22083 19.2065 6 18.6723 6 18.104C6 17.5356 6.22083 17.0015 6.62083 16.6015L16.6025 6.61981C17.43 5.79147 18.7783 5.79064 19.6075 6.61981L25.3792 12.3915C25.7792 12.7915 26 13.3256 26 13.894C26 14.4623 25.7792 14.9965 25.3792 15.3965L15.3975 25.3781C14.9833 25.7923 14.4392 25.9998 13.895 25.9998V25.9998ZM13.2758 24.494C13.6167 24.8356 14.1708 24.8365 14.5133 24.494L24.495 14.5123C24.8358 14.1706 24.8358 13.6156 24.495 13.2748L18.7233 7.50314C18.3817 7.16147 17.8275 7.16314 17.4858 7.50314L7.505 17.4848C7.16417 17.8265 7.16417 18.3815 7.505 18.7223L13.2758 24.494Z",
    fill: "#34323A"
  })), /* @__PURE__ */ _react2["default"].createElement("defs", null, /* @__PURE__ */ _react2["default"].createElement("clipPath", {
    id: "clip0"
  }, /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "6",
    y: "6",
    width: "20",
    height: "20",
    fill: "white"
  })))));
  module2.exports = exports.default;
})(Erase, Erase.exports);
var EraseExports = Erase.exports;
var EuroPayment = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29 24.46l-2.33 2.32V11.5a.65.65 0 0 0-.65-.65H20v1.3h5.35v14.63L23 24.46l-.91.92L25 28.25a1.45 1.45 0 0 0 2 0l2.87-2.87zM13.67 4.29a7.4 7.4 0 0 1 3.16.71l.56-1.17A8.61 8.61 0 0 0 13.67 3a8.77 8.77 0 0 0-8.26 5.85H2v1.3h3.06a9.33 9.33 0 0 0-.15 1.6 8 8 0 0 0 .09 1.1H2v1.3h3.25a8.77 8.77 0 0 0 8.42 6.35 8.61 8.61 0 0 0 3.72-.84l-.56-1.17a7.43 7.43 0 0 1-10.21-4.34H13v-1.3H6.3a8 8 0 0 1-.09-1.1 7.07 7.07 0 0 1 .18-1.6H14v-1.3H6.8a7.45 7.45 0 0 1 6.87-4.56z"
  })));
  module2.exports = exports.default;
})(EuroPayment, EuroPayment.exports);
var EuroPaymentExports = EuroPayment.exports;
var Filter = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M12.62,29.78v-12L5.08,5a1.78,1.78,0,0,1,0-1.65,1.56,1.56,0,0,1,1.36-.85H25.57a1.56,1.56,0,0,1,1.36.85,1.76,1.76,0,0,1,0,1.61l-7.56,12.8v9.28ZM6.43,3.83A.25.25,0,0,0,6.22,4a.48.48,0,0,0,0,.42l7.7,13V27.86l4.16-1.67V17.44L25.8,4.37a.46.46,0,0,0,0-.38.25.25,0,0,0-.21-.16Z"
  })));
  module2.exports = exports.default;
})(Filter, Filter.exports);
var FilterExports = Filter.exports;
var FilterFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.93,3.38a1.56,1.56,0,0,0-1.36-.85H6.43a1.56,1.56,0,0,0-1.36.85A1.78,1.78,0,0,0,5.08,5l7.54,12.76v12l6.76-2.71V17.79L26.94,5A1.76,1.76,0,0,0,26.93,3.38Z"
  })));
  module2.exports = exports.default;
})(FilterFill, FilterFill.exports);
var FilterFillExports = FilterFill.exports;
var Flag = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M8.69,28H7.51V4.78A.6.6,0,0,1,8,4.19a7.68,7.68,0,0,1,5.53.8,9.53,9.53,0,0,1,2.08,1.72,9.32,9.32,0,0,0,1.92,1.62,7.26,7.26,0,0,0,6.16.33.61.61,0,0,1,.54.08.6.6,0,0,1,.24.48V21a.57.57,0,0,1-.38.55c-2.53.91-4.75.91-6.59-.2a8.55,8.55,0,0,1-1.82-1.52A9.47,9.47,0,0,0,13.52,18a7.42,7.42,0,0,0-4.81-.91Z"
  })));
  module2.exports = exports.default;
})(Flag, Flag.exports);
var FlagExports = Flag.exports;
var Help = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M15.68 24.17A1.67 1.67 0 0 1 14 22.49a1.66 1.66 0 1 1 3.31 0 1.67 1.67 0 0 1-1.63 1.68zm2.75-7.74c-.83.64-1.77 1.25-1.77 2.1v.18h-1.92v-.45c0-1.19 1.16-2.26 2-2.91 1.23-.92 2.08-1.57 2.08-2.91a2.62 2.62 0 0 0-2.68-2.73 2.88 2.88 0 0 0-3 3h-1.92a4.84 4.84 0 0 1 5-4.86 4.5 4.5 0 0 1 4.61 4.57 5 5 0 0 1-2.4 4.01z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M4.2 29a.62.62 0 0 1-.43-.16.67.67 0 0 1-.22-.57l.82-6.66A12.82 12.82 0 0 1 3 15.93a13 13 0 1 1 7.32 11.66L4.35 29zm6.24-2.77a.63.63 0 0 1 .3.07A11.5 11.5 0 0 0 16 27.59 11.66 11.66 0 1 0 4.34 15.93a11.5 11.5 0 0 0 1.28 5.29.67.67 0 0 1 .07.37L5 27.53l5.33-1.26z"
  })));
  module2.exports = exports.default;
})(Help, Help.exports);
var HelpExports = Help.exports;
var HexagonTeamAdd = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("polygon", {
    points: "16.65 9.84 15.35 9.84 15.35 15.35 9.84 15.35 9.84 16.65 15.35 16.65 15.35 22.16 16.65 22.16 16.65 16.65 22.16 16.65 22.16 15.35 16.65 15.35 16.65 9.84"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.14,3.64H8.86L1.72,16,8.86,28.36H23.14L30.28,16Zm-.75,23.42H9.61L3.23,16,9.61,4.94H22.39L28.78,16Z"
  })));
  module2.exports = exports.default;
})(HexagonTeamAdd, HexagonTeamAdd.exports);
var HexagonTeamAddExports = HexagonTeamAdd.exports;
var IdentityKey = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M5.91,9,1.85,16l4.06,7H14l3.69-6.39h4V21.4H23V16.64H25.2c0,.61,0,1.56.06,3.06l1.3,0c0-1.12-.06-2.34-.06-3h2.25v5.17h1.3V15.34H17.7L14,9Zm7.36,1.3L16.58,16l-3.31,5.73H6.66L3.35,16l3.31-5.73Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M10,19.49A3.49,3.49,0,1,0,6.48,16,3.49,3.49,0,0,0,10,19.49Zm0-5.67A2.18,2.18,0,1,1,7.78,16,2.18,2.18,0,0,1,10,13.82Z"
  }), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  })));
  module2.exports = exports.default;
})(IdentityKey, IdentityKey.exports);
var IdentityKeyExports = IdentityKey.exports;
var Image$1 = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27,5.6H5A2.65,2.65,0,0,0,2.35,8.25v15.5A2.65,2.65,0,0,0,5,26.4H27a2.65,2.65,0,0,0,2.65-2.65V8.25A2.65,2.65,0,0,0,27,5.6ZM5,6.9H27a1.35,1.35,0,0,1,1.35,1.35v15.5a2.16,2.16,0,0,1-.05.27L20.65,16.5a.64.64,0,0,0-.91,0L16.23,20,11,14.31a.64.64,0,0,0-.47-.21h0a.66.66,0,0,0-.46.19L3.65,20.72V8.25A1.35,1.35,0,0,1,5,6.9ZM5,25.1a1.35,1.35,0,0,1-1.35-1.35V22.57l6.81-6.88,5.27,5.71a.63.63,0,0,0,.47.2c.16.06.34-.06.47-.18l3.53-3.54L27.45,25a1.34,1.34,0,0,1-.45.09Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M22.38,14.67A2.42,2.42,0,1,0,20,12.25,2.42,2.42,0,0,0,22.38,14.67Zm0-3.54a1.12,1.12,0,1,1-1.13,1.12A1.12,1.12,0,0,1,22.38,11.13Z"
  }), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  })));
  module2.exports = exports.default;
})(Image$1, Image$1.exports);
var ImageExports = Image$1.exports;
var Input = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M10.13 12.19a7.74 7.74 0 0 1-.35-2.43 7.65 7.65 0 1 1 15.3 0 7.47 7.47 0 0 1-.36 2.3l-1.24-.4a6.09 6.09 0 0 0 .3-1.9 6.35 6.35 0 1 0-12.7 0 6.59 6.59 0 0 0 .28 2z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M19.58 29.9h-9a.66.66 0 0 1-.53-.28 17.89 17.89 0 0 1-3.12-9.74c0-3 4.06-5.6 8.86-5.6l-.07-5.06a2.65 2.65 0 0 1 3.05-2.63A2.83 2.83 0 0 1 21 9.33V18a5.19 5.19 0 0 1 3.17 4.73c0 2.59-1.54 5.15-4.23 7a.71.71 0 0 1-.36.17zm-8.67-1.31h8.46c2.23-1.62 3.51-3.75 3.51-5.85A4 4 0 0 0 20.1 19a.64.64 0 0 1-.39-.59V9.33a1.53 1.53 0 0 0-1.13-1.45 1.36 1.36 0 0 0-1.11.31 1.33 1.33 0 0 0-.46 1v5.07a1.26 1.26 0 0 1-1.21 1.28c-4 0-7.58 2.06-7.58 4.31a16.78 16.78 0 0 0 2.69 8.74z"
  })));
  module2.exports = exports.default;
})(Input, Input.exports);
var InputExports = Input.exports;
var InputFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M10.77 11.93a7.46 7.46 0 0 1-.35-2.43 7.65 7.65 0 0 1 15.3 0 7.42 7.42 0 0 1-.36 2.3l-1.24-.4a6.09 6.09 0 0 0 .3-1.9 6.35 6.35 0 0 0-12.7 0 6.25 6.25 0 0 0 .28 2z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21 18.17a4.65 4.65 0 0 1 3.17 4.31c0 2.63-1.75 5-4 6.51h-9a17.23 17.23 0 0 1-3-9.37c0-2.65 3.79-5 8.21-5A.63.63 0 0 0 17 14V9a2 2 0 0 1 2.31-2A2.17 2.17 0 0 1 21 9.07z"
  })));
  module2.exports = exports.default;
})(InputFill, InputFill.exports);
var InputFillExports = InputFill.exports;
var InputLongText = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26 25.25H6a2.65 2.65 0 0 1-2.65-2.65V9.4A2.65 2.65 0 0 1 6 6.75h20a2.65 2.65 0 0 1 2.65 2.65v13.2A2.65 2.65 0 0 1 26 25.25zM6 8.05A1.36 1.36 0 0 0 4.65 9.4v13.2A1.36 1.36 0 0 0 6 24h20a1.36 1.36 0 0 0 1.35-1.35V9.4A1.36 1.36 0 0 0 26 8.05z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M6.58 11.41h18.84v1.3H6.58zM6.58 15.35h18.84v1.3H6.58zM6.58 19.29h10.29v1.3H6.58z"
  })));
  module2.exports = exports.default;
})(InputLongText, InputLongText.exports);
var InputLongTextExports = InputLongText.exports;
var InputShortText = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26 21.27H6a2.65 2.65 0 0 1-2.65-2.65v-5.23A2.66 2.66 0 0 1 6 10.73h20a2.66 2.66 0 0 1 2.65 2.66v5.23A2.65 2.65 0 0 1 26 21.27zM6 12a1.35 1.35 0 0 0-1.35 1.35v5.23A1.36 1.36 0 0 0 6 20h20a1.36 1.36 0 0 0 1.35-1.35v-5.26A1.35 1.35 0 0 0 26 12z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M6.58 15.35h18.84v1.3H6.58z"
  })));
  module2.exports = exports.default;
})(InputShortText, InputShortText.exports);
var InputShortTextExports = InputShortText.exports;
var Kanban$1 = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32-2",
    "data-name": "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26,4.39H6A2.65,2.65,0,0,0,3.35,7V25A2.65,2.65,0,0,0,6,27.69H26A2.65,2.65,0,0,0,28.65,25V7A2.65,2.65,0,0,0,26,4.39Zm-6.65,1.3v20.7h-6.7V5.69ZM4.65,25V7A1.36,1.36,0,0,1,6,5.69h5.35v20.7H6A1.35,1.35,0,0,1,4.65,25Zm22.7,0A1.35,1.35,0,0,1,26,26.39H20.65V5.69H26A1.36,1.36,0,0,1,27.35,7Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "5.71",
    y: "8.56",
    width: "4.57",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "5.71",
    y: "12.02",
    width: "4.57",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "5.71",
    y: "15.47",
    width: "4.57",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "21.71",
    y: "8.56",
    width: "4.57",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "21.71",
    y: "12.02",
    width: "4.57",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "21.71",
    y: "15.47",
    width: "4.57",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "21.71",
    y: "18.93",
    width: "4.57",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "13.71",
    y: "8.56",
    width: "4.57",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "13.71",
    y: "12.02",
    width: "4.57",
    height: "1.3"
  })));
  module2.exports = exports.default;
})(Kanban$1, Kanban$1.exports);
var KanbanExports = Kanban$1.exports;
var Key$1 = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.35 28.68a.66.66 0 0 1-.45-.18l-2.77-2.6a.65.65 0 0 1 0-.9l1.23-1.42-1.7-1.36a.65.65 0 0 1-.25-.48.7.7 0 0 1 .2-.5l1.52-1.48-1.62-1.2a.66.66 0 0 1-.25-.68l.42-1.88a6.76 6.76 0 1 1 6.93-.16v9.59a.64.64 0 0 1-.19.46l-2.62 2.6a.65.65 0 0 1-.45.19zm-1.87-3.3l1.85 1.74 2-2V15.5a.65.65 0 0 1 .33-.61 5.47 5.47 0 1 0-4.94.17.64.64 0 0 1 .36.74l-.47 2 1.88 1.4a.64.64 0 0 1 .07 1L14 21.66 15.66 23a.65.65 0 0 1 .08.94z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M18.12 12.67l-.83-1a2 2 0 1 0-2.58 0l-.83 1a3.34 3.34 0 1 1 4.24 0z"
  })));
  module2.exports = exports.default;
})(Key$1, Key$1.exports);
var KeyExports = Key$1.exports;
var Layers = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.86,15.25l-3.4-1.5L16.22,18a.49.49,0,0,1-.44,0L7.54,13.75l-3.4,1.5a.48.48,0,0,0,0,.88l11.66,6a.43.43,0,0,0,.44,0l11.66-6A.48.48,0,0,0,27.86,15.25Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.86,22.22l-3.4-1.51-8.24,4.22a.43.43,0,0,1-.44,0L7.54,20.71l-3.4,1.51a.48.48,0,0,0,0,.88l11.66,6a.49.49,0,0,0,.44,0l11.66-6A.48.48,0,0,0,27.86,22.22Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.88,9l-11.66,6a.49.49,0,0,1-.44,0L4.12,9a.48.48,0,0,1,0-.88L15.8,2.92a.47.47,0,0,1,.4,0L27.86,8.07A.48.48,0,0,1,27.88,9Z"
  })));
  module2.exports = exports.default;
})(Layers, Layers.exports);
var LayersExports = Layers.exports;
var Legal = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.76,8.91V4.39H4.24V8.91C3.67,10,.84,15.64.84,17.52a4,4,0,1,0,8.1,0c0-1.88-2.83-7.49-3.4-8.61V5.69H13.8V26.31H9.16v1.3H22.84v-1.3H18.2V5.69h8.26V8.91c-.57,1.12-3.4,6.73-3.4,8.61a4.05,4.05,0,1,0,8.1,0C31.16,15.64,28.33,10,27.76,8.91ZM4.89,10.51a41.05,41.05,0,0,1,2.64,6.36H2.25A41.05,41.05,0,0,1,4.89,10.51Zm0,9.76a2.73,2.73,0,0,1-2.66-2.1H7.56A2.75,2.75,0,0,1,4.89,20.27Zm12-14.51V26.24H15.1V5.76ZM29.75,16.87H24.47a41.05,41.05,0,0,1,2.64-6.36A41.05,41.05,0,0,1,29.75,16.87Zm-2.64,3.4a2.75,2.75,0,0,1-2.67-2.1h5.33A2.73,2.73,0,0,1,27.11,20.27Z"
  })));
  module2.exports = exports.default;
})(Legal, Legal.exports);
var LegalExports = Legal.exports;
var linkReferencedBy = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.29,15.67,22.9,4.61a.64.64,0,0,0-.56-.32H11.57v1.3H22L28,16,22,26.41H10L3.75,15.67l-1.13.66L9,27.39a.64.64,0,0,0,.56.32H22.34a.64.64,0,0,0,.56-.32l6.39-11.06A.65.65,0,0,0,29.29,15.67Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11.36,16l.32,1.26,3.65-.89a1.39,1.39,0,0,0,.85-.63,1.36,1.36,0,0,0,.16-1.06L15.44,11l-1.26.31.7,2.83-9.54-6-.69,1.1,9.58,6Z"
  })));
  module2.exports = exports.default;
})(linkReferencedBy, linkReferencedBy.exports);
var linkReferencedByExports = linkReferencedBy.exports;
var linkReferences = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M28.21,15.68,22,26.41H10L4,16,10,5.59h10.4V4.29H9.61a.65.65,0,0,0-.56.32L2.67,15.68a.63.63,0,0,0,0,.65L9.05,27.39a.65.65,0,0,0,.56.32H22.39a.65.65,0,0,0,.56-.32l6.38-11.06Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M15.54,15.58l.69,1.11,9.54-6-.69,2.82,1.26.32.9-3.66a1.39,1.39,0,0,0-1-1.68l-3.65-.9-.31,1.26,2.87.71Z"
  })));
  module2.exports = exports.default;
})(linkReferences, linkReferences.exports);
var linkReferencesExports = linkReferences.exports;
var MagnifyingGlass = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M13.13 23.28a10.15 10.15 0 1 1 10.15-10.16 10.17 10.17 0 0 1-10.15 10.16zm0-19A8.85 8.85 0 1 0 22 13.12a8.87 8.87 0 0 0-8.87-8.85z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M19.48 13.12h-1.31a5.05 5.05 0 0 0-5-5V6.77a6.36 6.36 0 0 1 6.31 6.35z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    transform: "rotate(-45 25.50122292 25.4970476)",
    d: "M24.85 21.43h1.3v8.13h-1.3z"
  })));
  module2.exports = exports.default;
})(MagnifyingGlass, MagnifyingGlass.exports);
var MagnifyingGlassExports = MagnifyingGlass.exports;
var Members = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16,14.9a5.16,5.16,0,1,1,5.15-5.16A5.16,5.16,0,0,1,16,14.9Zm0-9a3.85,3.85,0,1,0,3.85,3.85A3.85,3.85,0,0,0,16,5.89Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.21,28.67a13.4,13.4,0,0,1-8.86-3.05l-.2-.19V23.72a7.18,7.18,0,0,1,7.17-7.17h3.36a7.18,7.18,0,0,1,7.17,7.17V25.4l-.17.18C24.56,25.71,21.81,28.67,16.21,28.67ZM8.45,24.85a12.63,12.63,0,0,0,7.76,2.52,10.92,10.92,0,0,0,7.34-2.5V23.72a5.88,5.88,0,0,0-5.87-5.87H14.32a5.88,5.88,0,0,0-5.87,5.87Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27,9.42a3,3,0,1,1,3-3A3.06,3.06,0,0,1,27,9.42Zm0-4.79a1.75,1.75,0,1,0,1.74,1.74A1.74,1.74,0,0,0,27,4.63Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.1,17.17a7.45,7.45,0,0,1-4.91-1.7l-.2-.2v-1a4.13,4.13,0,0,1,4.12-4.12h1.77A4.13,4.13,0,0,1,32,14.24v1l-.17.18A6.49,6.49,0,0,1,27.1,17.17Zm-3.81-2.48a6.52,6.52,0,0,0,3.81,1.18,5.51,5.51,0,0,0,3.6-1.16v-.47a2.82,2.82,0,0,0-2.82-2.82H26.11a2.82,2.82,0,0,0-2.82,2.82Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M5,9.42a3,3,0,1,1,3.05-3A3.05,3.05,0,0,1,5,9.42ZM5,4.63A1.75,1.75,0,1,0,6.75,6.37,1.74,1.74,0,0,0,5,4.63Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M5.11,17.17A7.45,7.45,0,0,1,.2,15.47l-.2-.2v-1a4.13,4.13,0,0,1,4.12-4.12H5.89A4.13,4.13,0,0,1,10,14.24v1l-.17.18A6.49,6.49,0,0,1,5.11,17.17ZM1.3,14.69a6.52,6.52,0,0,0,3.81,1.18,5.51,5.51,0,0,0,3.6-1.16v-.47a2.82,2.82,0,0,0-2.82-2.82H4.12A2.82,2.82,0,0,0,1.3,14.24Z"
  })));
  module2.exports = exports.default;
})(Members, Members.exports);
var MembersExports = Members.exports;
var Metrics = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.75 24.87h-2a2.65 2.65 0 0 1-2.65-2.65V9.85a2.65 2.65 0 0 1 2.65-2.65h2a2.65 2.65 0 0 1 2.65 2.65v12.37a2.65 2.65 0 0 1-2.65 2.65zm-2-16.37a1.35 1.35 0 0 0-1.35 1.35v12.37a1.36 1.36 0 0 0 1.35 1.35h2a1.36 1.36 0 0 0 1.35-1.35V9.85a1.35 1.35 0 0 0-1.35-1.35zM17 24.87h-2a2.65 2.65 0 0 1-2.65-2.65v-16A2.65 2.65 0 0 1 15 3.57h2a2.65 2.65 0 0 1 2.65 2.65v16A2.65 2.65 0 0 1 17 24.87zm-2-20a1.35 1.35 0 0 0-1.35 1.35v16A1.36 1.36 0 0 0 15 23.57h2a1.36 1.36 0 0 0 1.35-1.35v-16A1.35 1.35 0 0 0 17 4.87zM7.25 24.87h-2a2.65 2.65 0 0 1-2.65-2.65v-3.89a2.65 2.65 0 0 1 2.65-2.65h2a2.65 2.65 0 0 1 2.65 2.65v3.89a2.65 2.65 0 0 1-2.65 2.65zm-2-7.87a1.35 1.35 0 0 0-1.35 1.33v3.89a1.36 1.36 0 0 0 1.35 1.35h2a1.36 1.36 0 0 0 1.35-1.35v-3.89A1.35 1.35 0 0 0 7.25 17zM2.6 27.13h26.8v1.3H2.6z"
  })));
  module2.exports = exports.default;
})(Metrics, Metrics.exports);
var MetricsExports = Metrics.exports;
var MetricsFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.75 24.87h-2a2.65 2.65 0 0 1-2.65-2.65V9.85a2.65 2.65 0 0 1 2.65-2.65h2a2.65 2.65 0 0 1 2.65 2.65v12.37a2.65 2.65 0 0 1-2.65 2.65zM17 24.87h-2a2.65 2.65 0 0 1-2.65-2.65v-16A2.65 2.65 0 0 1 15 3.57h2a2.65 2.65 0 0 1 2.65 2.65v16A2.65 2.65 0 0 1 17 24.87zM7.25 24.87h-2a2.65 2.65 0 0 1-2.65-2.65v-3.89a2.65 2.65 0 0 1 2.65-2.65h2a2.65 2.65 0 0 1 2.65 2.65v3.89a2.65 2.65 0 0 1-2.65 2.65zM2.6 27.13h26.8v1.3H2.6z"
  })));
  module2.exports = exports.default;
})(MetricsFill, MetricsFill.exports);
var MetricsFillExports = MetricsFill.exports;
var Minus = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "9.84",
    y: "15.35",
    width: "12.32",
    height: "1.3"
  })));
  module2.exports = exports.default;
})(Minus, Minus.exports);
var MinusExports = Minus.exports;
var Mobile = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21.94 3.35h-12A2.65 2.65 0 0 0 7.29 6v20a2.65 2.65 0 0 0 2.65 2.65h12A2.65 2.65 0 0 0 24.59 26V6a2.65 2.65 0 0 0-2.65-2.65zm-12 1.3h12A1.36 1.36 0 0 1 23.29 6v1.35H8.59V6a1.36 1.36 0 0 1 1.35-1.35zm13.35 4v11.7H8.59V8.65zm-1.35 18.7h-12A1.36 1.36 0 0 1 8.59 26v-4.35h14.7V26a1.36 1.36 0 0 1-1.35 1.35z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M15.94 23.3a1.05 1.05 0 1 0 1 1.05 1 1 0 0 0-1-1.05z"
  })));
  module2.exports = exports.default;
})(Mobile, Mobile.exports);
var MobileExports = Mobile.exports;
var Moon = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M25.7182 16.5548C25.4881 16.4971 25.2581 16.5548 25.0568 16.6991C24.3092 17.3339 23.4466 17.8533 22.4977 18.1995C21.6063 18.5458 20.6287 18.7189 19.5935 18.7189C17.2644 18.7189 15.1366 17.7667 13.6127 16.2374C12.0887 14.7081 11.1398 12.5728 11.1398 10.2356C11.1398 9.25453 11.3123 8.30232 11.5999 7.43667C11.9162 6.51332 12.3762 5.67653 12.9801 4.95516C13.2389 4.63776 13.1814 4.17608 12.8651 3.91639C12.6638 3.77211 12.4337 3.7144 12.2037 3.77211C9.75961 4.43577 7.63181 5.90737 6.10784 7.8695C4.64138 9.80277 3.75 12.1977 3.75 14.8235C3.75 17.9687 5.01518 20.8253 7.08548 22.9028C9.15578 24.9804 12.0024 26.25 15.1366 26.25C17.782 26.25 20.2261 25.3266 22.1814 23.7973C24.1654 22.2392 25.6031 20.0174 26.207 17.4781C26.3507 17.0453 26.1207 16.6414 25.7182 16.5548ZM21.3188 22.5854C19.651 23.9128 17.5232 24.7207 15.1941 24.7207C12.4625 24.7207 9.98965 23.5954 8.20689 21.8064C6.42413 20.0174 5.30272 17.5359 5.30272 14.7946C5.30272 12.5151 6.05033 10.4376 7.34427 8.76399C8.23564 7.6098 9.35705 6.65759 10.651 5.99393C10.5072 6.31134 10.3634 6.62874 10.2484 6.975C9.87463 8.01377 9.7021 9.11025 9.7021 10.2644C9.7021 13.0056 10.8235 15.516 12.6063 17.305C14.389 19.094 16.8906 20.2193 19.6223 20.2193C20.83 20.2193 21.9801 20.0174 23.044 19.6134C23.4178 19.4691 23.7916 19.3249 24.1367 19.1517C23.4466 20.479 22.4977 21.6621 21.3188 22.5854Z"
  })));
  module2.exports = exports.default;
})(Moon, Moon.exports);
var MoonExports = Moon.exports;
var Outgoing32 = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M24.7,15.71v10c0,.82-.48,1.52-1.05,1.52H8.35c-.57,0-1-.7-1-1.52V6.25c0-.82.48-1.52,1-1.52h6.82V3.43H8.35A2.61,2.61,0,0,0,6,6.25v19.5a2.61,2.61,0,0,0,2.35,2.82h15.3A2.61,2.61,0,0,0,26,25.75v-10Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M12.37,24.59h1.3a18.28,18.28,0,0,1,7.09-15l1.89,3.33a.68.68,0,0,0,.57.33h.08a.65.65,0,0,0,.55-.47l1.67-6.11a.61.61,0,0,0-.06-.49.67.67,0,0,0-.39-.31L19,4.19a.66.66,0,0,0-.74.95l1.89,3.31A19.52,19.52,0,0,0,12.37,24.59ZM24.1,7l-1.09,4-2.88-5Z"
  })));
  module2.exports = exports.default;
})(Outgoing32, Outgoing32.exports);
var Outgoing32Exports = Outgoing32.exports;
var OutisdeLink = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.48 22.65a.83.83 0 0 1-.83.82H9.35a.83.83 0 0 1-.83-.82V9.35a.83.83 0 0 1 .83-.82h5.85V7.22H9.35a2.13 2.13 0 0 0-2.12 2.13v13.3a2.13 2.13 0 0 0 2.12 2.13h13.3a2.13 2.13 0 0 0 2.12-2.13v-5.84h-1.29z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.39 7.22h-3.77v1.31h2.94l-6.9 6.89.91.92 6.91-6.9v2.94h1.29V8.61a1.39 1.39 0 0 0-1.38-1.39z"
  })));
  module2.exports = exports.default;
})(OutisdeLink, OutisdeLink.exports);
var OutisdeLinkExports = OutisdeLink.exports;
var OutsideLink = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.48 22.65a.83.83 0 0 1-.83.82H9.35a.83.83 0 0 1-.83-.82V9.35a.83.83 0 0 1 .83-.82h5.85V7.22H9.35a2.13 2.13 0 0 0-2.12 2.13v13.3a2.13 2.13 0 0 0 2.12 2.13h13.3a2.13 2.13 0 0 0 2.12-2.13v-5.84h-1.29z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.39 7.22h-3.77v1.31h2.94l-6.9 6.89.91.92 6.91-6.9v2.94h1.29V8.61a1.39 1.39 0 0 0-1.38-1.39z"
  })));
  module2.exports = exports.default;
})(OutsideLink, OutsideLink.exports);
var OutsideLinkExports = OutsideLink.exports;
var Package = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M25 4.35H7A2.65 2.65 0 0 0 4.35 7v18A2.65 2.65 0 0 0 7 27.65h18A2.65 2.65 0 0 0 27.65 25V7A2.65 2.65 0 0 0 25 4.35zm-12.35 1.3h6.7V13l-3.06-1.53a.64.64 0 0 0-.58 0L12.65 13zM26.35 25A1.36 1.36 0 0 1 25 26.35H7A1.36 1.36 0 0 1 5.65 25V7A1.36 1.36 0 0 1 7 5.65h4.35V14a.65.65 0 0 0 .94.58L16 12.73l3.71 1.85a.63.63 0 0 0 .63 0 .65.65 0 0 0 .31-.55V5.65H25A1.36 1.36 0 0 1 26.35 7z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M8 19.35h4v1.3H8zM8 22.35h7v1.3H8z"
  })));
  module2.exports = exports.default;
})(Package, Package.exports);
var PackageExports = Package.exports;
var PackageDelivery = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M31.71,20.42a2.58,2.58,0,0,0-3.47-.82l-.69.34V5.72A2.65,2.65,0,0,0,24.9,3.07H6.9A2.65,2.65,0,0,0,4.25,5.72V15.1H.6a.66.66,0,0,0-.65.65v11a.65.65,0,0,0,.65.65H4.9a.65.65,0,0,0,.65-.65V26c1.12.58,3.59,1.92,5.22,2.82a.72.72,0,0,0,.32.08h10.3a.62.62,0,0,0,.32-.09l9.17-5.11A2.43,2.43,0,0,0,31.71,20.42Zm-12.46-16v7.29l-3.06-1.53a.73.73,0,0,0-.58,0l-3.06,1.53V4.37ZM5.55,5.72A1.35,1.35,0,0,1,6.9,4.37h4.35v8.35a.66.66,0,0,0,.31.55.64.64,0,0,0,.63,0l3.71-1.86,3.71,1.86a.73.73,0,0,0,.29.07.67.67,0,0,0,.34-.1.64.64,0,0,0,.31-.55V4.37H24.9a1.34,1.34,0,0,1,1.35,1.35V20.59l-.86.43a2.33,2.33,0,0,0-2-1.44H15l-3.69-2.65a.63.63,0,0,0-.37-.12H5.55V15.75a1.13,1.13,0,0,0,0-.18,1.08,1.08,0,0,0,0-.19ZM4.25,26.09h-3V16.4h3Zm26-3.46-9,5h-10c-1.61-.88-4.93-2.68-5.7-3V18.11h5.2l3.68,2.65a.64.64,0,0,0,.38.12h8.61c.33,0,.79.48.85.94a.65.65,0,0,0,0,.28c-.07.51-.38,1-.51,1H16a.65.65,0,0,0,0,1.3h7.7c1,0,1.61-1,1.79-2l3.27-1.62a1.34,1.34,0,0,1,1.78.29A1.13,1.13,0,0,1,30.2,22.63Z"
  })));
  module2.exports = exports.default;
})(PackageDelivery, PackageDelivery.exports);
var PackageDeliveryExports = PackageDelivery.exports;
var PadlockClose = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.019 13.5H22.176V11.441C22.176 9.89161 21.5605 8.40567 20.4649 7.31008C19.3693 6.21449 17.8834 5.599 16.334 5.599C14.7846 5.599 13.2987 6.21449 12.2031 7.31008C11.1075 8.40567 10.492 9.89161 10.492 11.441V13.5H9.649C9.47695 13.5003 9.31203 13.5687 9.19038 13.6904C9.06873 13.812 9.00026 13.977 9 14.149V25.749C9 25.9212 9.06834 26.0864 9.19003 26.2083C9.31171 26.3301 9.47678 26.3987 9.649 26.399H23.019C23.1912 26.3987 23.3563 26.3301 23.478 26.2083C23.5997 26.0864 23.668 25.9212 23.668 25.749V14.149C23.6677 13.977 23.5993 13.812 23.4776 13.6904C23.356 13.5687 23.191 13.5003 23.019 13.5ZM11.792 11.441C11.792 10.2364 12.2705 9.08111 13.1223 8.22932C13.9741 7.37753 15.1294 6.899 16.334 6.899C17.5386 6.899 18.6939 7.37753 19.5457 8.22932C20.3975 9.08111 20.876 10.2364 20.876 11.441V13.5H11.792V11.441ZM22.369 25.1H10.299V14.8H22.369V25.1Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.984 17.756H15.684V21.695H16.984V17.756Z"
  })));
  module2.exports = exports.default;
})(PadlockClose, PadlockClose.exports);
var PadlockCloseExports = PadlockClose.exports;
var PadlockCloseFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "10",
    y: "14",
    width: "13",
    height: "12"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.019 13.5H22.176V11.441C22.176 9.8916 21.5605 8.40567 20.4649 7.31008C19.3693 6.21449 17.8834 5.599 16.334 5.599C14.7846 5.599 13.2987 6.21449 12.2031 7.31008C11.1075 8.40567 10.492 9.8916 10.492 11.441V13.5H9.649C9.47695 13.5003 9.31203 13.5687 9.19038 13.6904C9.06873 13.812 9.00026 13.977 9 14.149V25.749C9 25.9212 9.06834 26.0864 9.19003 26.2083C9.31171 26.3301 9.47678 26.3987 9.649 26.399H23.019C23.1912 26.3987 23.3563 26.3301 23.478 26.2083C23.5997 26.0864 23.668 25.9212 23.668 25.749V14.149C23.6677 13.977 23.5993 13.812 23.4776 13.6904C23.356 13.5687 23.191 13.5003 23.019 13.5ZM11.792 11.441C11.792 10.2364 12.2705 9.08111 13.1223 8.22932C13.9741 7.37753 15.1294 6.899 16.334 6.899C17.5386 6.899 18.6939 7.37753 19.5457 8.22932C20.3975 9.08111 20.876 10.2364 20.876 11.441V13.5H11.792V11.441ZM22.369 25.1H10.299V14.8H22.369V25.1Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.984 17.756H15.684V21.695H16.984V17.756Z",
    fill: "white"
  })));
  module2.exports = exports.default;
})(PadlockCloseFill, PadlockCloseFill.exports);
var PadlockCloseFillExports = PadlockCloseFill.exports;
var PadlockOpen = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.019 13.5H11.792V10.922C11.7898 9.75621 12.2359 8.6342 13.0381 7.78824C13.8402 6.94228 14.9369 6.43715 16.1012 6.3774C17.2655 6.31765 18.4081 6.70787 19.2927 7.46727C20.1772 8.22667 20.7358 9.29711 20.853 10.457L22.146 10.325C21.9943 8.83378 21.2752 7.45792 20.1375 6.48203C18.9998 5.50614 17.5306 5.00488 16.0336 5.08195C14.5367 5.15902 13.1267 5.80851 12.0952 6.89609C11.0637 7.98366 10.4897 9.42609 10.492 10.925V13.5H9.65C9.47778 13.5 9.3126 13.5683 9.19073 13.69C9.06886 13.8117 9.00026 13.9768 9 14.149V25.749C9 25.9214 9.06848 26.0867 9.19038 26.2086C9.31228 26.3305 9.47761 26.399 9.65 26.399H23.019C23.1044 26.399 23.1889 26.3822 23.2677 26.3495C23.3466 26.3169 23.4183 26.269 23.4786 26.2086C23.539 26.1483 23.5869 26.0766 23.6195 25.9977C23.6522 25.9189 23.669 25.8344 23.669 25.749V14.149C23.6687 13.9768 23.6001 13.8117 23.4783 13.69C23.3564 13.5683 23.1912 13.5 23.019 13.5ZM22.369 25.1H10.299V14.8H22.369V25.1Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.984 17.756H15.684V21.695H16.984V17.756Z"
  })));
  module2.exports = exports.default;
})(PadlockOpen, PadlockOpen.exports);
var PadlockOpenExports = PadlockOpen.exports;
var Paperclip = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M13.77 28.53a5.35 5.35 0 0 1-1-.11 5.26 5.26 0 0 1-4.17-5.24V10.86a7.4 7.4 0 0 1 8.32-7.33 7.53 7.53 0 0 1 6.48 7.59v10.44H22V11.12A6.09 6.09 0 0 0 16.75 5a5.95 5.95 0 0 0-6.7 5.9v12.28a3.73 3.73 0 0 0 6.09 3.06 3.73 3.73 0 0 0 1.36-2.88V11a1.49 1.49 0 0 0-1.72-1.49 1.64 1.64 0 0 0-1.27 1.66v10.39h-1.45V11.13A3.07 3.07 0 0 1 15.57 8a2.94 2.94 0 0 1 3.37 3v12.4a5.17 5.17 0 0 1-1.89 4 5.23 5.23 0 0 1-3.28 1.13z"
  })));
  module2.exports = exports.default;
})(Paperclip, Paperclip.exports);
var PaperclipExports = Paperclip.exports;
var Paragraph = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M4 9.36h24v1.3H4zM4 13.63h24v1.3H4zM4 17.9h24v1.3H4zM4 22.17h14.02v1.3H4z"
  })));
  module2.exports = exports.default;
})(Paragraph, Paragraph.exports);
var ParagraphExports = Paragraph.exports;
var PasswordHide = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "3.95",
    y: "15.35",
    width: "24.42",
    height: "1.3",
    transform: "translate(-5.73 22.17) rotate(-60.47)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M10.47,22.09A13.91,13.91,0,0,1,5,16.44C7.36,12,11.53,9.27,16,9.26h0a10,10,0,0,1,1.65.13l.68-1.2A12.87,12.87,0,0,0,16,8h0c-5,0-9.73,3.15-12.24,8.19a.66.66,0,0,0,0,.58,15.24,15.24,0,0,0,6.1,6.49Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M28.27,16.07a15.17,15.17,0,0,0-6.21-6.53l-.64,1.13A13.85,13.85,0,0,1,27,16.37c-2.32,4.42-6.49,7.16-10.94,7.17h0a11.76,11.76,0,0,1-1.78-.14l-.67,1.19a12.5,12.5,0,0,0,2.45.26h0c5.05,0,9.74-3.16,12.25-8.19A.68.68,0,0,0,28.27,16.07Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M19.79,13.55l-.74,1.31.89,1.53-2,3.42H16.24l-.74,1.3h2.86a.65.65,0,0,0,.56-.32l2.33-4.07a.63.63,0,0,0,0-.65Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M12.14,19.14l.74-1.31-.82-1.42L14,13h1.6l.74-1.31H13.64a.66.66,0,0,0-.56.33l-2.33,4.06a.63.63,0,0,0,0,.65Z"
  }), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  })));
  module2.exports = exports.default;
})(PasswordHide, PasswordHide.exports);
var PasswordHideExports = PasswordHide.exports;
var PasswordShow = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Password-Show"), /* @__PURE__ */ _react2["default"].createElement("polygon", {
    points: "18.33 11.93 13.64 11.95 11.31 16.01 13.67 20.07 18.36 20.05 20.69 15.99 18.33 11.93"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16,24.44c-5,0-9.73-3.1-12.26-8.11a.68.68,0,0,1,0-.59c2.51-5,7.2-8.17,12.24-8.18h0c5,0,9.73,3.1,12.26,8.11a.68.68,0,0,1,0,.59c-2.51,5-7.2,8.17-12.24,8.18ZM5,16c2.35,4.41,6.51,7.14,11,7.11S24.64,20.39,27,16C24.62,11.57,20.45,8.86,16,8.86h0C11.53,8.87,7.36,11.61,5,16Z"
  }), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  })));
  module2.exports = exports.default;
})(PasswordShow, PasswordShow.exports);
var PasswordShowExports = PasswordShow.exports;
var Pen = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M24.81 10.51L22.5 9.27 24.82 5a.64.64 0 0 0 .05-.49.66.66 0 0 0-.32-.39l-4.82-2.6a.65.65 0 0 0-.88.26l-2.62 4.84-9.09 16.84v.09a.8.8 0 0 0 0 .15l-.21 6.17a.64.64 0 0 0 .34.59.68.68 0 0 0 .31.08.63.63 0 0 0 .37-.12l5-3.56a.47.47 0 0 0 .1-.1l.07-.09 8.77-16.27 1.74.94-4.74 8.79 1.14.62 5.05-9.37a.65.65 0 0 0-.27-.87zm-5.12-7.57l3.67 2-2 3.72-3.68-2zM8.32 24.84l3 1.61-3.11 2.2zm3.95.65l-3.68-2 8.47-15.7 3.68 2z"
  })));
  module2.exports = exports.default;
})(Pen, Pen.exports);
var PenExports = Pen.exports;
var PinToPin = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M5.65,28.8h0a.66.66,0,0,1-.53-.28C4.65,27.83.53,21.78.53,19.18a5.13,5.13,0,1,1,10.25,0c0,2.6-4.12,8.65-4.59,9.34A.66.66,0,0,1,5.65,28.8Zm0-13.45a3.83,3.83,0,0,0-3.82,3.83c0,1.63,2.41,5.64,3.82,7.8,1.42-2.16,3.83-6.17,3.83-7.8A3.84,3.84,0,0,0,5.65,15.35Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M5.65,21.83a2.66,2.66,0,1,1,2.66-2.65A2.65,2.65,0,0,1,5.65,21.83Zm0-4A1.35,1.35,0,1,0,7,19.18,1.35,1.35,0,0,0,5.65,17.83Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.35,15.13a.66.66,0,0,1-.54-.28c-.47-.68-4.59-6.74-4.59-9.34a5.13,5.13,0,1,1,10.25,0c0,2.6-4.12,8.65-4.59,9.34A.66.66,0,0,1,26.35,15.13Zm0-13.45a3.84,3.84,0,0,0-3.83,3.83c0,1.63,2.41,5.64,3.83,7.8,1.41-2.16,3.82-6.17,3.82-7.8A3.83,3.83,0,0,0,26.35,1.68Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.35,8.17A2.66,2.66,0,1,1,29,5.51,2.67,2.67,0,0,1,26.35,8.17Zm0-4A1.36,1.36,0,1,0,27.7,5.51,1.35,1.35,0,0,0,26.35,4.16Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21.48,31.62H21v-1.3h.53a3.85,3.85,0,0,0,1.27-.21l.42,1.23A5.35,5.35,0,0,1,21.48,31.62Zm-2.57,0h-2v-1.3h2Zm-4.07,0h-2v-1.3h2Zm-4.07,0h-2v-1.3h2Zm-4.06,0h-2v-1.3h2Zm18.42-1.54-1-.88a2.43,2.43,0,0,0,.65-1.44l1.3.11A3.75,3.75,0,0,1,25.13,30.08Zm-.71-3.83a3.3,3.3,0,0,0-1.28-1.07L23.69,24a4.38,4.38,0,0,1,1.8,1.51Zm-3-1.43h-2v-1.3h2Zm-4.26-.31a4.66,4.66,0,0,1-1.94-1.32l1-.84a3.37,3.37,0,0,0,1.4.94ZM14.33,21v-.17a3.68,3.68,0,0,1,.7-2.15l1.06.76a2.39,2.39,0,0,0-.46,1.39v.12Zm3.07-2.59-.52-1.19a5.13,5.13,0,0,1,2.1-.44h.14V18H19A4,4,0,0,0,17.4,18.36ZM27.26,18h-2v-1.3h2Zm-4.07,0h-2v-1.3h2Z"
  })));
  module2.exports = exports.default;
})(PinToPin, PinToPin.exports);
var PinToPinExports = PinToPin.exports;
var Presentation = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M3.60611 9.38663H4.56377V21.8098C4.56513 22.4576 4.8244 23.0779 5.28388 23.5344C5.74371 23.9908 6.36575 24.2453 7.01358 24.2423H14.6644L10.4465 28.0088C11.2555 28.9244 10.4465 28.0088 11.2555 28.9244L15.9166 24.7724L20.5777 28.9251C21.3867 28.0085 20.5777 28.9251 21.3867 28.0085L17.1688 24.2423H24.8196C25.464 24.2443 26.0824 23.9881 26.5368 23.5313C26.9912 23.0742 27.2436 22.4542 27.2382 21.8098V9.38663H28.258C28.6014 9.38086 28.8793 9.10564 28.8888 8.76221V4.58711C28.8759 4.25115 28.5939 3.98883 28.258 4.00037H3.60611C3.44729 3.99562 3.29322 4.05534 3.1792 4.16563C3.06517 4.27626 3.00035 4.42829 3.00002 4.58711V8.76221C2.99764 9.10089 3.26743 9.37882 3.60611 9.38663ZM26.022 21.8098C26.0281 22.1318 25.9035 22.4427 25.6772 22.6714C25.4508 22.9005 25.1417 23.0284 24.8196 23.026H7.01358C6.68848 23.0298 6.37525 22.9032 6.14347 22.6748C5.91203 22.4464 5.78104 22.1352 5.78002 21.8098V9.38663H26.022V21.8098ZM4.21627 5.21662H27.6726V8.17037H4.21627V5.21662Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M19.5807 14.163H7.85432V12.9467H19.5807V14.163Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.9567 16.5827H7.85432V15.5439H23.9567V16.5827Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.9567 19.1799H7.85432V18.141H23.9567V19.1799Z"
  })));
  module2.exports = exports.default;
})(Presentation, Presentation.exports);
var PresentationExports = Presentation.exports;
var PrivateProcess = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", {
    transform: "translate(6 5)"
  }, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11,15a4,4,0,1,1,4-4A4,4,0,0,1,11,15ZM11,8a3,3,0,1,0,3,3A3,3,0,0,0,11,8Z"
  })));
  module2.exports = exports.default;
})(PrivateProcess, PrivateProcess.exports);
var PrivateProcessExports = PrivateProcess.exports;
var PrivateProcessFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", {
    transform: "translate(6 5)"
  }, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11,15a4,4,0,1,1,4-4A4,4,0,0,1,11,15ZM11,8a3,3,0,1,0,3,3A3,3,0,0,0,11,8Z"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "10.98",
    cy: "11.03",
    r: "1.53"
  })));
  module2.exports = exports.default;
})(PrivateProcessFill, PrivateProcessFill.exports);
var PrivateProcessFillExports = PrivateProcessFill.exports;
var Profile = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M15.83,8.57a4.29,4.29,0,1,0,4.29,4.29A4.3,4.3,0,0,0,15.83,8.57Zm0,7.28a3,3,0,1,1,3-3A3,3,0,0,1,15.83,15.85Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16,3.73A12.27,12.27,0,1,0,28.28,16,12.29,12.29,0,0,0,16,3.73ZM9.86,25.09v-.93a4.62,4.62,0,0,1,4.62-4.62h2.71a4.63,4.63,0,0,1,4.62,4.62V25.3a10.9,10.9,0,0,1-11.95-.21Zm13.25-.74v-.19a5.93,5.93,0,0,0-5.92-5.92H14.48a5.91,5.91,0,0,0-5.91,5.81,11,11,0,1,1,14.54.3Z"
  })));
  module2.exports = exports.default;
})(Profile, Profile.exports);
var ProfileExports = Profile.exports;
var Pull = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M4.54,21.51a.64.64,0,0,0-.22.49.66.66,0,0,0,.22.49l5.71,5a.67.67,0,0,0,.42.16.65.65,0,0,0,.65-.65V22.6H27V25h1.34V18.88H27v2.41H11.32V16.92a.66.66,0,0,0-.17-.44.63.63,0,0,0-.9,0Zm1.39.43L10,18.36v7.15Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M4.31,9.41v1.3H17.92v4.35a.66.66,0,0,0,.38.59.63.63,0,0,0,.7-.11l5.7-5a.64.64,0,0,0,.22-.49.66.66,0,0,0-.22-.49l-5.7-5a.65.65,0,0,0-1.12.49V9.41ZM19.18,6.49l4.07,3.57-4.07,3.58Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "27.04",
    y: "7.01",
    width: "1.3",
    height: "6.11"
  })));
  module2.exports = exports.default;
})(Pull, Pull.exports);
var PullExports = Pull.exports;
var Push = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M4.54,21.51a.64.64,0,0,0-.22.49.66.66,0,0,0,.22.49l5.71,5a.67.67,0,0,0,.42.16.65.65,0,0,0,.65-.65V22.6H27V25h1.34V18.88H27v2.41H11.32V16.92a.66.66,0,0,0-.17-.44.63.63,0,0,0-.9,0Zm1.39.43L10,18.36v7.15Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M4.31,9.41v1.3H17.92v4.35a.66.66,0,0,0,.38.59.63.63,0,0,0,.7-.11l5.7-5a.64.64,0,0,0,.22-.49.66.66,0,0,0-.22-.49l-5.7-5a.65.65,0,0,0-1.12.49V9.41ZM19.18,6.49l4.07,3.57-4.07,3.58Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "27.04",
    y: "7.01",
    width: "1.3",
    height: "6.11"
  })));
  module2.exports = exports.default;
})(Push, Push.exports);
var PushExports = Push.exports;
var QRCode = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M10.75 10.4h-5a.65.65 0 0 1-.65-.65v-5a.65.65 0 0 1 .65-.65h5a.65.65 0 0 1 .65.65v5a.65.65 0 0 1-.65.65zM6.4 9.1h3.7V5.4H6.4zM19.4 9.75h-1.3V5.4h-3.35V4.1h4a.65.65 0 0 1 .65.65zM27.75 19.4h-5a.65.65 0 0 1-.65-.65v-5h1.3v4.35h4.35zM27.75 10.4h-5a.65.65 0 0 1-.65-.65v-5a.65.65 0 0 1 .65-.65h5a.65.65 0 0 1 .65.65v5a.65.65 0 0 1-.65.65zM23.4 9.1h3.7V5.4h-3.7zM10.75 28.4h-5a.65.65 0 0 1-.65-.65v-5a.65.65 0 0 1 .65-.65h5a.65.65 0 0 1 .65.65v5a.65.65 0 0 1-.65.65zM6.4 27.1h3.7v-3.7H6.4zM27.75 28.4h-5a.65.65 0 0 1-.65-.65v-5a.65.65 0 0 1 .65-.65h5a.65.65 0 0 1 .65.65v5a.65.65 0 0 1-.65.65zm-4.35-1.3h3.7v-3.7h-3.7zM6.4 18.75H5.1v-4a.65.65 0 0 1 .65-.65h8.35V8.75h1.3v6a.65.65 0 0 1-.65.65H6.4zM8.75 18.1h2v1.3h-2zM27.1 13.75h1.3v2h-1.3zM18.75 28.4h-4v-1.3h3.35v-3.7h-3.35a.65.65 0 0 1-.65-.65v-4a.65.65 0 0 1 .65-.65h3.35v-4.35h1.3v5a.65.65 0 0 1-.65.65H15.4v2.7h3.35a.65.65 0 0 1 .65.65v5a.65.65 0 0 1-.65.65z"
  })));
  module2.exports = exports.default;
})(QRCode, QRCode.exports);
var QRCodeExports = QRCode.exports;
var Remove = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16,3.72A12.28,12.28,0,1,0,28.28,16,12.3,12.3,0,0,0,16,3.72ZM16,27A11,11,0,1,1,27,16,11,11,0,0,1,16,27Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "9.84",
    y: "15.35",
    width: "12.32",
    height: "1.3"
  })));
  module2.exports = exports.default;
})(Remove, Remove.exports);
var RemoveExports = Remove.exports;
var Rename = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27 10.35h-7.35v-3.7H22v-1.3h-6v1.3h2.35v18.7H16v1.3h6v-1.3h-2.35v-3.7H27A2.65 2.65 0 0 0 29.65 19v-6A2.65 2.65 0 0 0 27 10.35zM28.35 19A1.36 1.36 0 0 1 27 20.35h-7.35v-8.7H27A1.36 1.36 0 0 1 28.35 13zM2.35 13v6A2.65 2.65 0 0 0 5 21.65h8v-1.3H5A1.36 1.36 0 0 1 3.65 19v-6A1.36 1.36 0 0 1 5 11.65h8v-1.3H5A2.65 2.65 0 0 0 2.35 13z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M6 15.35h7v1.3H6z"
  })));
  module2.exports = exports.default;
})(Rename, Rename.exports);
var RenameExports = Rename.exports;
var RenameFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27 10.35h-7.35v-3.7H22v-1.3h-6v1.3h2.35v18.7H16v1.3h6v-1.3h-2.35v-3.7H27A2.65 2.65 0 0 0 29.65 19v-6A2.65 2.65 0 0 0 27 10.35zM13 10.35H5A2.65 2.65 0 0 0 2.35 13v6A2.65 2.65 0 0 0 5 21.65h8a.65.65 0 0 0 .65-.65v-4.35H6v-1.3h7.65V11a.65.65 0 0 0-.65-.65z"
  })));
  module2.exports = exports.default;
})(RenameFill, RenameFill.exports);
var RenameFillExports = RenameFill.exports;
var Reset = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1239 5.62195C20.7403 5.62195 25.3171 10.2551 25.3171 16C25.3171 21.7449 20.7403 26.3781 15.1239 26.3781V28.061C21.696 28.061 27 22.6479 27 16C27 9.35214 21.696 3.93903 15.1239 3.93903C10.0787 3.93903 5.77935 7.13157 4.05595 11.6185L5.62698 12.2219C7.11394 8.35055 10.8118 5.62195 15.1239 5.62195Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68292 10.6707V5.34146H4V11.5122C4 11.9769 4.37673 12.3537 4.84146 12.3537H10.4512V10.6707H5.68292Z"
  })));
  module2.exports = exports.default;
})(Reset, Reset.exports);
var ResetExports = Reset.exports;
var Return = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "_Symbols",
    "data-name": "Symbols"
  }, /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Header-ATC-view-Searching"
  }, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Fill-1",
    d: "M18.06 10.64v1.3h5.59v5.19H8.91L11 15l-.92-.92-2.63 2.66a1.42 1.42 0 0 0-.4 1 1.39 1.39 0 0 0 .4 1l2.66 2.65.92-.92-2-2H24.3a.65.65 0 0 0 .65-.65v-6.53a.65.65 0 0 0-.65-.65z"
  })))));
  module2.exports = exports.default;
})(Return, Return.exports);
var ReturnExports = Return.exports;
var Review = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M17.86 13.29a.65.65 0 0 0-.57-.32h-2.58a.65.65 0 0 0-.57.32l-1.29 2.24a.63.63 0 0 0 0 .65l1.29 2.24a.64.64 0 0 0 .57.33h2.58a.64.64 0 0 0 .57-.33l1.29-2.24a.63.63 0 0 0 0-.65zm-.94 4.16h-1.84l-.92-1.59.92-1.59h1.84l.92 1.59z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16 9.24a10.87 10.87 0 0 0-9.54 6.33.66.66 0 0 0 0 .58A10.87 10.87 0 0 0 16 22.48a10.87 10.87 0 0 0 9.54-6.33.66.66 0 0 0 0-.58A10.87 10.87 0 0 0 16 9.24zm0 11.94a9.53 9.53 0 0 1-8.23-5.32A9.53 9.53 0 0 1 16 10.54a9.53 9.53 0 0 1 8.23 5.32A9.53 9.53 0 0 1 16 21.18z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.35 15.86a13.39 13.39 0 1 1-4.45-9.93h-3v1.3h4.48a.65.65 0 0 0 .62-.65V2.1h-1.3v2.79A14.5 14.5 0 0 0 16 1.21a14.65 14.65 0 1 0 14.65 14.65z"
  })));
  module2.exports = exports.default;
})(Review, Review.exports);
var ReviewExports = Review.exports;
var Save = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.9961 9.93213C27.983 9.79957 27.9314 9.66654 27.8407 9.55587C27.8056 9.51308 28.1638 9.87396 22.4967 4.2069C22.3616 4.0718 22.1782 4.00088 21.9993 4.00093C21.5729 4.00093 6.53388 4.00093 6.1091 4.00093C4.94601 4.00093 3.99976 4.94718 3.99976 6.11028V25.8913C3.99976 27.0544 4.94601 28.0006 6.1091 28.0006H25.8901C27.0532 28.0006 27.9994 27.0544 27.9994 25.8913C27.9995 8.82027 28.0013 9.98604 27.9961 9.93213ZM20.1715 5.40716V10.0009C20.1715 10.3885 19.856 10.704 19.4683 10.704H18.5777V5.40716H20.1715ZM17.1715 5.40716V10.704H10.656C10.2683 10.704 9.95285 10.3885 9.95285 10.0009V5.40716H17.1715ZM20.1715 19.0476H9.95285V18.157C9.95285 17.7693 10.2683 17.4539 10.656 17.4539H19.4683C19.856 17.4539 20.1715 17.7693 20.1715 18.157V19.0476ZM9.95285 26.5944V20.4538H20.1715V26.5944H9.95285ZM26.5932 25.8913C26.5932 26.279 26.2778 26.5944 25.8901 26.5944H21.5777C21.5777 25.6777 21.5777 19.2019 21.5777 18.157C21.5777 16.9939 20.6314 16.0476 19.4683 16.0476H10.656C9.49287 16.0476 8.54662 16.9939 8.54662 18.157V26.5944H6.10915C5.72145 26.5944 5.40603 26.279 5.40603 25.8913V6.11028C5.40603 5.72258 5.72145 5.40716 6.10915 5.40716H8.54662V10.0009C8.54662 11.1639 9.49287 12.1102 10.656 12.1102H19.4683C20.6314 12.1102 21.5777 11.1639 21.5777 10.0009V5.40716H21.7083L26.5932 10.2921V25.8913Z"
  })));
  module2.exports = exports.default;
})(Save, Save.exports);
var SaveExports = Save.exports;
var Scoring = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32-2",
    "data-name": "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.63,7.12H21.74V5.54a.65.65,0,1,0-1.3,0V7.12H11.56V5.54a.65.65,0,1,0-1.3,0V7.12H4.37A2.65,2.65,0,0,0,1.72,9.77V24.46a2.65,2.65,0,0,0,2.65,2.65H27.63a2.65,2.65,0,0,0,2.65-2.65V9.77A2.65,2.65,0,0,0,27.63,7.12ZM29,24.46a1.35,1.35,0,0,1-1.35,1.35H4.37A1.35,1.35,0,0,1,3,24.46V9.77A1.34,1.34,0,0,1,4.37,8.43h5.89V9.57a.65.65,0,0,0,1.3,0V8.43h8.88V9.57a.65.65,0,1,0,1.3,0V8.43h5.89A1.34,1.34,0,0,1,29,9.77Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M25.55,11.7H18.3V13h6.6v8.23H16.63V12.35A.65.65,0,0,0,16,11.7H6.45a.65.65,0,0,0-.65.65v9.53a.65.65,0,0,0,.65.65h7v-1.3H7.1V13h8.23v8.88a.65.65,0,0,0,.65.65h9.57a.65.65,0,0,0,.65-.65V12.35A.65.65,0,0,0,25.55,11.7Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M9.29,16.5v1.22a1.88,1.88,0,1,0,3.76,0V16.5a1.88,1.88,0,1,0-3.76,0Zm2.79,0v1.22a.92.92,0,1,1-1.82,0V16.5a.92.92,0,1,1,1.82,0Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21.35,14.59,18.74,17.7v.79h2.51v1.15h1V18.49h.66v-.9h-.66v-3Zm-.1,3H19.94L21.25,16Z"
  })));
  module2.exports = exports.default;
})(Scoring, Scoring.exports);
var ScoringExports = Scoring.exports;
var SegmentReference = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M28.21,15.68,22,26.41H10L4,16,10,5.59h10.4V4.29H9.61a.65.65,0,0,0-.56.32L2.67,15.68a.63.63,0,0,0,0,.65L9.05,27.39a.65.65,0,0,0,.56.32H22.39a.65.65,0,0,0,.56-.32l6.38-11.06Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M15.54,15.58l.69,1.11,9.54-6-.69,2.82,1.26.32.9-3.66a1.39,1.39,0,0,0-1-1.68l-3.65-.9-.31,1.26,2.87.71Z"
  })));
  module2.exports = exports.default;
})(SegmentReference, SegmentReference.exports);
var SegmentReferenceExports = SegmentReference.exports;
var SegmentReferenceBY = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.29,15.67,22.9,4.61a.64.64,0,0,0-.56-.32H11.57v1.3H22L28,16,22,26.41H10L3.75,15.67l-1.13.66L9,27.39a.64.64,0,0,0,.56.32H22.34a.64.64,0,0,0,.56-.32l6.39-11.06A.65.65,0,0,0,29.29,15.67Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11.36,16l.32,1.26,3.65-.89a1.39,1.39,0,0,0,.85-.63,1.36,1.36,0,0,0,.16-1.06L15.44,11l-1.26.31.7,2.83-9.54-6-.69,1.1,9.58,6Z"
  })));
  module2.exports = exports.default;
})(SegmentReferenceBY, SegmentReferenceBY.exports);
var SegmentReferenceBYExports = SegmentReferenceBY.exports;
var Settings = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M18 30.63h-4a1.29 1.29 0 0 1-1.28-1.09l-.45-3c-.33-.12-.66-.25-1-.4L9 27.9a1.32 1.32 0 0 1-.81.3 1.34 1.34 0 0 1-.92-.41 22.81 22.81 0 0 1-3-3.09 1.36 1.36 0 0 1-.27-.88 1.26 1.26 0 0 1 .28-.8c.28-.4.6-.81.93-1.22s.49-.62.73-.94a10.51 10.51 0 0 1-.48-1.16l-2.93-.44A1.31 1.31 0 0 1 1.37 18v-4.06a1.35 1.35 0 0 1 .95-1.27l3.07-.49a9.38 9.38 0 0 1 .44-1C5.31 10.44 4.75 9.73 4.14 9a1.35 1.35 0 0 1-.31-.78 1.45 1.45 0 0 1 .31-.89s2.86-3.5 4-3.5a1.45 1.45 0 0 1 .89.3l2.19 1.71c.32-.14.64-.28 1-.4a24.23 24.23 0 0 1 .5-3.05 1.31 1.31 0 0 1 1.28-1h4a1.33 1.33 0 0 1 1.3 1.09l.43 3a9.55 9.55 0 0 1 1 .4L23 4.15a1.22 1.22 0 0 1 .85-.34 1.39 1.39 0 0 1 .88.35 23.76 23.76 0 0 1 3.07 3.19 1.3 1.3 0 0 1 .26.83 1.27 1.27 0 0 1-.28.81c-.28.4-.6.8-.93 1.22s-.49.61-.73.94a11.44 11.44 0 0 1 .48 1.14l2.94.45A1.31 1.31 0 0 1 30.63 14v4.06a1.37 1.37 0 0 1-1 1.28l-3.05.47c-.13.34-.27.68-.43 1 .48.66 1 1.33 1.68 2.16a1.26 1.26 0 0 1 .33.81 1.23 1.23 0 0 1-.34.92s-2.81 3.46-4 3.46a1.6 1.6 0 0 1-.85-.28l-2.22-1.73c-.31.14-.64.28-1 .4a24.23 24.23 0 0 1-.5 3.05A1.3 1.3 0 0 1 18 30.63zm-6.9-6l.36.19a10.36 10.36 0 0 0 1.54.63l.39.12.61 3.76h4a20.83 20.83 0 0 0 .54-3.3v-.43l.42-.14a9.58 9.58 0 0 0 1.55-.65l.37-.19 2.84 2.23a18.75 18.75 0 0 0 3-3c-.54-.73-1.26-1.62-2-2.62l-.24-.33.19-.36a9.67 9.67 0 0 0 .8-1.54l.12-.38 3.77-.57V14l-3.71-.57-.12-.39a9.82 9.82 0 0 0-.7-1.67l-.22-.37.23-.33c.32-.46.66-.89 1-1.31s.62-.78.91-1.19a18.17 18.17 0 0 0-2.87-3.07l-3 2.21-.36-.18A10.36 10.36 0 0 0 19 6.54l-.39-.13L18 2.66h-4A20.8 20.8 0 0 0 13.45 6v.43l-.45.11a9.69 9.69 0 0 0-1.56.65l-.37.19-2.84-2.23a15.1 15.1 0 0 0-3.06 3c.69.92 1.34 1.75 2 2.58l.24.33-.2.36A9.23 9.23 0 0 0 6.5 13l-.12.39-3.76.59v4.05l3.72.55.12.4a8.48 8.48 0 0 0 .69 1.68l.19.36-.23.33c-.32.45-.66.88-1 1.31s-.62.78-.91 1.18a16.78 16.78 0 0 0 2.88 3.06z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16 22.44A6.44 6.44 0 1 1 22.44 16 6.45 6.45 0 0 1 16 22.44zm0-11.58A5.14 5.14 0 1 0 21.14 16 5.14 5.14 0 0 0 16 10.86z"
  })));
  module2.exports = exports.default;
})(Settings, Settings.exports);
var SettingsExports = Settings.exports;
var SettingsDocument = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.36,9.45,20.7,3.84a.64.64,0,0,0-.45-.19H8.3A2.82,2.82,0,0,0,5.45,6.43V25.57A2.82,2.82,0,0,0,8.3,28.35H23.7a2.82,2.82,0,0,0,2.85-2.78V9.91A.64.64,0,0,0,26.36,9.45ZM20.25,5.22,25,10H22.29a2,2,0,0,1-2-1.85ZM23.7,27.05H8.3a1.52,1.52,0,0,1-1.55-1.48V6.43A1.52,1.52,0,0,1,8.3,5H19V8.1a3.25,3.25,0,0,0,3.34,3.15h3V25.57A1.52,1.52,0,0,1,23.7,27.05Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21.75,16.64l-1-.15,0-.1.16-.2c.15-.18.28-.36.4-.52a1,1,0,0,0,.2-.55.91.91,0,0,0-.2-.6,9.74,9.74,0,0,0-1.33-1.39,1,1,0,0,0-.62-.24.94.94,0,0,0-.6.22l-.76.57h0l-.15-1a1,1,0,0,0-.92-.78h-1.7a.93.93,0,0,0-.9.72,10.13,10.13,0,0,0-.2,1.1h0l-.75-.58a1,1,0,0,0-.6-.2c-.73,0-2,1.6-2,1.6a1,1,0,0,0-.22.63.88.88,0,0,0,.22.55c.19.23.38.47.56.71a.08.08,0,0,1,0,.05l-1.13.19a1,1,0,0,0-.66.89v1.71a.94.94,0,0,0,.78.9l1,.15a1,1,0,0,1,0,.1l-.17.2-.39.51a1,1,0,0,0-.2.56,1.06,1.06,0,0,0,.2.62,10.28,10.28,0,0,0,1.3,1.33,1,1,0,0,0,.66.28.94.94,0,0,0,.57-.2l.78-.59h0l.15,1a.93.93,0,0,0,.91.77h1.7a.93.93,0,0,0,.91-.71,11,11,0,0,0,.19-1.1h0l.77.61a1.13,1.13,0,0,0,.57.18c.73,0,1.95-1.57,1.94-1.57a.9.9,0,0,0,.25-.67,1,1,0,0,0-.22-.56c-.2-.23-.38-.46-.57-.71l0,0,1.1-.17a1,1,0,0,0,.71-.9V17.54A.94.94,0,0,0,21.75,16.64Zm-2,2.51-.12.38a2.85,2.85,0,0,1-.26.59l-.19.36.24.33c.21.3.43.58.66.86a10,10,0,0,1-.79.8l-1.17-.91-.37.19a4.35,4.35,0,0,1-.59.25l-.42.13,0,.43a9,9,0,0,1-.15,1H15.48l-.23-1.48L14.87,22a5.19,5.19,0,0,1-.59-.24l-.36-.19-1.19.9a9.92,9.92,0,0,1-.79-.8c.07-.09.15-.18.22-.28s.3-.37.44-.56l.23-.33-.19-.36a3.61,3.61,0,0,1-.27-.64l-.12-.39-1.47-.22V17.83l1.47-.23.12-.38a4.35,4.35,0,0,1,.25-.59l.2-.36-.25-.33c-.21-.29-.42-.57-.64-.85a10,10,0,0,1,.79-.8l1.17.92.37-.19a4,4,0,0,1,.6-.25l.41-.13,0-.43a9.48,9.48,0,0,1,.15-1.05h1.08l.22,1.49.38.12a3.83,3.83,0,0,1,.59.24l.36.19,1.2-.9a9.57,9.57,0,0,1,.77.8l-.21.28c-.15.18-.3.37-.44.56l-.23.33.19.36a3.52,3.52,0,0,1,.27.63l.12.39,1.47.22v1.06Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16,15.55a2.84,2.84,0,1,0,2.84,2.83A2.84,2.84,0,0,0,16,15.55Zm0,4.37a1.54,1.54,0,1,1,1.54-1.54A1.54,1.54,0,0,1,16,19.92Z"
  })));
  module2.exports = exports.default;
})(SettingsDocument, SettingsDocument.exports);
var SettingsDocumentExports = SettingsDocument.exports;
var SettingsFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M30.63 14a1.31 1.31 0 0 0-1.08-1.26l-2.94-.45a11.44 11.44 0 0 0-.48-1.14c.24-.33.49-.64.73-.94s.65-.82.93-1.22a1.27 1.27 0 0 0 .28-.81 1.3 1.3 0 0 0-.26-.83 23.78 23.78 0 0 0-3.07-3.19 1.39 1.39 0 0 0-.88-.35 1.22 1.22 0 0 0-.85.34l-2.27 1.68c-.33-.15-.65-.28-1-.4l-.43-3A1.29 1.29 0 0 0 18 1.37h-4a1.32 1.32 0 0 0-1.29 1 23.94 23.94 0 0 0-.5 3.05c-.33.12-.65.26-1 .4L9 4.13a1.44 1.44 0 0 0-.88-.3c-1.15 0-4 3.49-4 3.49a1.45 1.45 0 0 0-.31.89 1.38 1.38 0 0 0 .33.79c.61.74 1.17 1.45 1.69 2.16a9.38 9.38 0 0 0-.44 1l-3.07.49a1.35 1.35 0 0 0-.95 1.27V18a1.31 1.31 0 0 0 1.08 1.26l2.94.44a10.51 10.51 0 0 0 .48 1.16c-.24.32-.49.63-.73.94s-.65.82-.93 1.21a1.31 1.31 0 0 0-.28.81 1.35 1.35 0 0 0 .27.88 22.24 22.24 0 0 0 3 3.09 1.3 1.3 0 0 0 .92.41 1.32 1.32 0 0 0 .88-.3l2.3-1.73c.32.15.65.28 1 .4l.45 3A1.29 1.29 0 0 0 14 30.63h4a1.31 1.31 0 0 0 1.28-1 25.87 25.87 0 0 0 .51-3.05c.32-.12.65-.26 1-.4L23 27.89a1.6 1.6 0 0 0 .85.28c1.14 0 4-3.46 4-3.46a1.23 1.23 0 0 0 .34-.92 1.29 1.29 0 0 0-.33-.81c-.68-.83-1.2-1.5-1.68-2.16.16-.33.3-.67.43-1l3.05-.47a1.37 1.37 0 0 0 1-1.28zM16 21.14A5.14 5.14 0 1 1 21.14 16 5.14 5.14 0 0 1 16 21.14z"
  })));
  module2.exports = exports.default;
})(SettingsFill, SettingsFill.exports);
var SettingsFillExports = SettingsFill.exports;
var SFAddCircle = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16 3.72A12.28 12.28 0 1 0 28.28 16 12.3 12.3 0 0 0 16 3.72zM16 27a11 11 0 1 1 11-11 11 11 0 0 1-11 11z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.65 9.84h-1.3v5.51H9.84v1.3h5.51v5.51h1.3v-5.51h5.51v-1.3h-5.51V9.84z"
  })));
  module2.exports = exports.default;
})(SFAddCircle, SFAddCircle.exports);
var SFAddCircleExports = SFAddCircle.exports;
var SFInputLongText = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26 25.25H6a2.65 2.65 0 0 1-2.65-2.65V9.4A2.65 2.65 0 0 1 6 6.75h20a2.65 2.65 0 0 1 2.65 2.65v13.2A2.65 2.65 0 0 1 26 25.25zM6 8.05A1.36 1.36 0 0 0 4.65 9.4v13.2A1.36 1.36 0 0 0 6 24h20a1.36 1.36 0 0 0 1.35-1.35V9.4A1.36 1.36 0 0 0 26 8.05z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M6.58 11.41h18.84v1.3H6.58zM6.58 15.35h18.84v1.3H6.58zM6.58 19.29h10.29v1.3H6.58z"
  })));
  module2.exports = exports.default;
})(SFInputLongText, SFInputLongText.exports);
var SFInputLongTextExports = SFInputLongText.exports;
var SFInputShortText = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26 21.27H6a2.65 2.65 0 0 1-2.65-2.65v-5.23A2.66 2.66 0 0 1 6 10.73h20a2.66 2.66 0 0 1 2.65 2.66v5.23A2.65 2.65 0 0 1 26 21.27zM6 12a1.35 1.35 0 0 0-1.35 1.35v5.23A1.36 1.36 0 0 0 6 20h20a1.36 1.36 0 0 0 1.35-1.35v-5.26A1.35 1.35 0 0 0 26 12z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M6.58 15.35h18.84v1.3H6.58z"
  })));
  module2.exports = exports.default;
})(SFInputShortText, SFInputShortText.exports);
var SFInputShortTextExports = SFInputShortText.exports;
var SFKanban = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32-2",
    "data-name": "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26 4.39H6A2.65 2.65 0 0 0 3.35 7v18A2.65 2.65 0 0 0 6 27.69h20A2.65 2.65 0 0 0 28.65 25V7A2.65 2.65 0 0 0 26 4.39zm-6.65 1.3v20.7h-6.7V5.69zM4.65 25V7A1.36 1.36 0 0 1 6 5.69h5.35v20.7H6A1.35 1.35 0 0 1 4.65 25zm22.7 0A1.35 1.35 0 0 1 26 26.39h-5.35V5.69H26A1.36 1.36 0 0 1 27.35 7z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M5.71 8.56h4.57v1.3H5.71zM5.71 12.02h4.57v1.3H5.71zM5.71 15.47h4.57v1.3H5.71zM21.71 8.56h4.57v1.3h-4.57zM21.71 12.02h4.57v1.3h-4.57zM21.71 15.47h4.57v1.3h-4.57zM21.71 18.93h4.57v1.3h-4.57zM13.71 8.56h4.57v1.3h-4.57zM13.71 12.02h4.57v1.3h-4.57z"
  })));
  module2.exports = exports.default;
})(SFKanban, SFKanban.exports);
var SFKanbanExports = SFKanban.exports;
var SFParagraph = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M4 9.36h24v1.3H4zM4 13.63h24v1.3H4zM4 17.9h24v1.3H4zM4 22.17h14.02v1.3H4z"
  })));
  module2.exports = exports.default;
})(SFParagraph, SFParagraph.exports);
var SFParagraphExports = SFParagraph.exports;
var SFTextInsert = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32-2",
    "data-name": "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11.84 9.71H28v1.3H11.84zM11.84 13.98H28v1.3H11.84zM4 18.25h24v1.3H4zM4 22.52h14.01v1.3H4z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M6.44 9.53h1l2.45 5.66H8.71l-.55-1.29H5.75l-.55 1.29H4zm1.29 3.36L7 11l-.78 1.85z"
  })));
  module2.exports = exports.default;
})(SFTextInsert, SFTextInsert.exports);
var SFTextInsertExports = SFTextInsert.exports;
var SFTickCircle = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16 28.28A12.28 12.28 0 1 1 28.28 16 12.3 12.3 0 0 1 16 28.28zM16 5a11 11 0 1 0 11 11A11 11 0 0 0 16 5z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M13.2 21.3a1.6 1.6 0 0 1-1.13-.47l-3.42-3.41.92-.92L13 19.91a.29.29 0 0 0 .42 0l9-9 .92.92-9 9a1.62 1.62 0 0 1-1.14.47z"
  })));
  module2.exports = exports.default;
})(SFTickCircle, SFTickCircle.exports);
var SFTickCircleExports = SFTickCircle.exports;
var SFTimesCircle = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16 3.72A12.28 12.28 0 1 0 28.28 16 12.3 12.3 0 0 0 16 3.72zM16 27a11 11 0 1 1 11-11 11 11 0 0 1-11 11z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M19.89 11.19L16 15.08l-3.89-3.89-.92.92L15.08 16l-3.89 3.89.92.92L16 16.92l3.89 3.89.92-.92L16.92 16l3.89-3.89-.92-.92z"
  })));
  module2.exports = exports.default;
})(SFTimesCircle, SFTimesCircle.exports);
var SFTimesCircleExports = SFTimesCircle.exports;
var SharedProcess = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", {
    transform: "translate(6 5)"
  }, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.94,15a4,4,0,1,1,4-4A4,4,0,0,1,16.94,15Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,16.94,8Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M5.06,8.67a4,4,0,1,1,4-4A4,4,0,0,1,5.06,8.67Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,5.06,1.67Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M5.06,21.33a4,4,0,1,1,4-4A4,4,0,0,1,5.06,21.33Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,5.06,14.33Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "7.77",
    y: "13.67",
    width: "6.45",
    height: "1",
    transform: "translate(-5.38 6.85) rotate(-28.12)"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "10.51",
    y: "4.58",
    width: "1",
    height: "6.47",
    transform: "translate(-1.07 13.85) rotate(-61.88)"
  })));
  module2.exports = exports.default;
})(SharedProcess, SharedProcess.exports);
var SharedProcessExports = SharedProcess.exports;
var SharedProcessFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", {
    transform: "translate(6 5)"
  }, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.94,15a4,4,0,1,1,4-4A4,4,0,0,1,16.94,15Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,16.94,8Z"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "16.94",
    cy: "11.02",
    r: "1.53"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M5.06,8.67a4,4,0,1,1,4-4A4,4,0,0,1,5.06,8.67Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,5.06,1.67Z"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "5.06",
    cy: "4.67",
    r: "1.53"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M5.06,21.33a4,4,0,1,1,4-4A4,4,0,0,1,5.06,21.33Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,5.06,14.33Z"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "5.06",
    cy: "17.33",
    r: "1.53"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "7.77",
    y: "13.67",
    width: "6.45",
    height: "1",
    transform: "translate(-5.38 6.85) rotate(-28.12)"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "10.51",
    y: "4.58",
    width: "1",
    height: "6.47",
    transform: "translate(-1.07 13.85) rotate(-61.88)"
  })));
  module2.exports = exports.default;
})(SharedProcessFill, SharedProcessFill.exports);
var SharedProcessFillExports = SharedProcessFill.exports;
var ShieldStar = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16,30.05a1.29,1.29,0,0,1-.58-.13C7.38,26,3.1,17.67,3.69,7.18c0-.15,0-.21,0-.25A1.39,1.39,0,0,1,4.08,6,1.33,1.33,0,0,1,5,5.6c3.66,0,3.89-2.11,3.9-2.54a1.33,1.33,0,0,1,1.32-1.3H21.75a1.33,1.33,0,0,1,1.33,1.32c0,.24.16,2.52,3.89,2.52a1.31,1.31,0,0,1,1.32,1.34l0,.25c.62,10.49-3.64,18.78-11.7,22.73A1.29,1.29,0,0,1,16,30.05Zm-5.79-27C10.19,4.5,9.06,6.9,5,6.9a2,2,0,0,0,0,.3C4.42,17.2,8.45,25,16,28.75,23.61,25,27.6,17.21,27,7.26V7.12C27,7,27,7,27,6.94v0c-4.06,0-5.19-2.39-5.21-3.81Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11.72,21.56a1.37,1.37,0,0,1-.78-.25A1.32,1.32,0,0,1,10.42,20l.75-4.09-3-2.86a1.32,1.32,0,0,1,.73-2.27L13,10.23l1.8-3.75a1.32,1.32,0,0,1,2.38,0L19,10.23l4.12.55a1.32,1.32,0,0,1,.73,2.27l-3,2.86L21.58,20a1.3,1.3,0,0,1-.52,1.31,1.35,1.35,0,0,1-1.41.09l-3.65-2-3.65,2A1.4,1.4,0,0,1,11.72,21.56ZM16,17.94l4.27,2.32-.84-4.81L23,12.11l.07-.69-.09.65-4.81-.64L16,7l-2.14,4.39-4.81.64,3.5,3.38-.88,4.78Z"
  })));
  module2.exports = exports.default;
})(ShieldStar, ShieldStar.exports);
var ShieldStarExports = ShieldStar.exports;
var Signature = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M30.42 10.24L28.11 9l2.32-4.3a.66.66 0 0 0-.26-.88l-4.82-2.6a.66.66 0 0 0-.89.27l-2.62 4.86-9.09 16.85v.09a.42.42 0 0 0 0 .16l-.22 6.17a.68.68 0 0 0 .34.59.71.71 0 0 0 .31.08.64.64 0 0 0 .38-.12l5-3.56.09-.1.08-.09 8.77-16.28 1.73.94-4.74 8.79 1.14.62 5.06-9.37a.65.65 0 0 0-.27-.88zM25.3 2.67l3.68 2L27 8.38l-3.68-2zm-11.36 21.9l3 1.61-3.11 2.2zm3.94.66l-3.67-2 8.47-15.7 3.67 2zM10.61 31.57a4.52 4.52 0 0 1-2.35-1.23c-.51-.43-.79-.66-1.17-.61a1.7 1.7 0 0 0-.69.42 2.06 2.06 0 0 1-1.76.62 2.33 2.33 0 0 1-1.37-1.14 2.43 2.43 0 0 0-.48-.58A.71.71 0 0 0 2 29c-.13.08-.27.24-.32.85l-1.27-.07a2.21 2.21 0 0 1 .93-1.87 2.05 2.05 0 0 1 2.22.09 3.41 3.41 0 0 1 .78.9c.24.35.4.56.59.61s.41-.18.66-.38A2.67 2.67 0 0 1 7 28.44a2.76 2.76 0 0 1 2.15.91 3.26 3.26 0 0 0 1.71.93z"
  })));
  module2.exports = exports.default;
})(Signature, Signature.exports);
var SignatureExports = Signature.exports;
var SignOut = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.44 14.88l-3.36-3.36-.92.92 2.91 2.91H13.32v1.3h12.75l-2.91 2.92.92.92 3.36-3.37a1.58 1.58 0 0 0 0-2.24z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16.37 27a11 11 0 1 1 7.3-19.14l.87-1a12.28 12.28 0 1 0 0 18.28l-.87-1a10.92 10.92 0 0 1-7.3 2.86z"
  })));
  module2.exports = exports.default;
})(SignOut, SignOut.exports);
var SignOutExports = SignOut.exports;
var SortingIconAscending = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("g", {
    fillRule: "evenodd"
  }, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M2.99948819 5.967157v7",
    stroke: "#736F7F",
    strokeLinecap: "square"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M2.99598101.7852099c-.18612246-.0008419-.35831029.0984972-.45074599.2600458L.07306659 5.33774445c-.09742212.15967721-.09742212.36041432 0 .52009153.09189617.16208507.2644291.2616233.450746.26008229h4.95473868c.18587038.00008269.35767586-.0989991.45066267-.25993781.09298681-.1609387.09301857-.35926753.00008333-.52023601L3.45019429 1.0452557C3.35714944.8826197 3.18334.7831105 2.99598101.7852099z",
    fillRule: "nonzero"
  }))));
  module2.exports = exports.default;
})(SortingIconAscending, SortingIconAscending.exports);
var SortingIconAscendingExports = SortingIconAscending.exports;
var SortingIconDescending = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("g", {
    fillRule: "evenodd"
  }, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M2.99948819 7.967157v-7",
    stroke: "#736F7F",
    strokeLinecap: "square"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M2.99598101 13.1491041c-.18612246.0008419-.35831029-.0984972-.45074599-.2600458L.07306659 8.59656955c-.09742212-.15967721-.09742212-.36041432 0-.52009153.09189617-.16208507.2644291-.2616233.450746-.26008229h4.95473868c.18587038-.00008269.35767586.0989991.45066267.25993781.09298681.1609387.09301857.35926753.00008333.52023601L3.45019429 12.8890583c-.09304485.162636-.26685429.2621452-.45421328.2600458z",
    fillRule: "nonzero"
  }))));
  module2.exports = exports.default;
})(SortingIconDescending, SortingIconDescending.exports);
var SortingIconDescendingExports = SortingIconDescending.exports;
var SortingIconGeneral = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("g", {
    fillRule: "nonzero"
  }, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M2.99598101-.03953896c-.18612246-.00080931-.35831029.09852983-.45074599.26007834L.07306659 4.51302818c-.09742212.1596772-.09742212.36041432 0 .52009153.09189617.16208507.2644291.2616233.450746.26006424h4.95473868c.18587038.00010074.35767586-.09898106.45066267-.25991976.09298681-.1609387.09301857-.35926753.00008333-.52023602L3.45019429.22053938C3.35714944.05790342 3.18334-.04160579 2.99598101-.03953896zM2.99598101 13.0051246c-.18612246.0008093-.35831029-.0985298-.45074599-.2600783L.07306659 8.45255747c-.09742212-.15967721-.09742212-.36041432 0-.52009153.09189617-.16208508.2644291-.2616233.450746-.26006425h4.95473868c.18587038-.00010074.35767586.09898106.45066267.25991976.09298681.16093871.09301857.35926754.00008333.52023602L3.45019429 12.7450463c-.09304485.1626359-.26685429.2621451-.45421328.2600783z"
  }))));
  module2.exports = exports.default;
})(SortingIconGeneral, SortingIconGeneral.exports);
var SortingIconGeneralExports = SortingIconGeneral.exports;
var SpeechBubble = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M22.52,28.51l-5.95-4.73H6.8a3,3,0,0,1-3-3V7.05a3,3,0,0,1,3-3H25.2a3,3,0,0,1,3,3V20.81a3,3,0,0,1-3,3H23ZM6.8,5.39A1.67,1.67,0,0,0,5.14,7.05V20.81A1.67,1.67,0,0,0,6.8,22.48H17L21.47,26l.37-3.53H25.2a1.67,1.67,0,0,0,1.66-1.67V7.05A1.67,1.67,0,0,0,25.2,5.39Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "9.31",
    y: "8.68",
    width: "13.38",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "9.31",
    y: "12.89",
    width: "13.38",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "9.31",
    y: "17.1",
    width: "13.38",
    height: "1.3"
  })));
  module2.exports = exports.default;
})(SpeechBubble, SpeechBubble.exports);
var SpeechBubbleExports = SpeechBubble.exports;
var Steps = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.38,28.77H8.62L1.25,16,8.62,3.23H23.38L30.75,16Zm-14-1.3H22.62L29.25,16,22.62,4.53H9.38L2.75,16Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M13.06,21.81A4,4,0,0,1,9,17.48v-3a4.09,4.09,0,1,1,8.17,0v3A4,4,0,0,1,13.06,21.81Zm0-1.72a2.32,2.32,0,0,0,2.35-2.61v-3a2.36,2.36,0,1,0-4.69,0v3A2.32,2.32,0,0,0,13.06,20.09Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M20.35,12.11H18.08l1.33-1.73h2.68V21.65H20.35Z"
  })));
  module2.exports = exports.default;
})(Steps, Steps.exports);
var StepsExports = Steps.exports;
var SubmittedProgram = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M30.2 9.3L25 4.1c-.1-.1-.3-.2-.4-.2H13.5c-.7 0-1.4.2-1.9.7-.5.5-.8 1.2-.8 1.9V8H9.3c-1.5 0-2.7 1.2-2.7 2.6v17.8c0 1.5 1.2 2.6 2.7 2.6h14.3c1.5 0 2.7-1.2 2.7-2.6V27h1.4c1.5 0 2.7-1.2 2.7-2.6V9.8c0-.2 0-.4-.2-.5zm-5.7-3.8l4.2 4.2h-2.4c-.5 0-.9-.1-1.3-.4-.4-.3-.6-.8-.6-1.2V5.5zm.4 23c0 .7-.6 1.3-1.4 1.3H9.3c-.7 0-1.4-.6-1.4-1.3V10.7c0-.4.2-.7.4-1 .3-.2.6-.4 1-.4h1.4v15c0 .7.3 1.4.8 1.9s1.2.8 1.9.7H25l-.1 1.6zm2.8-2.9H13.5c-.4 0-.7-.1-1-.4-.3-.2-.4-.6-.4-1V6.5c0-.7.6-1.3 1.4-1.3h9.8v2.9c0 .8.4 1.6.9 2.2.6.6 1.4.9 2.2.9h2.7v13.2c0 .4-.2.7-.4 1-.2.1-.6.3-1 .2z",
    transform: "translate(-2.5 -1.546)"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M25.5 15.3l-3.5-2c-.4-.3-1-.3-1.4 0-.4.2-.7.7-.7 1.2V16h-5.4v1.3h5.4v1.2c0 .5.3 1 .7 1.2.4.3 1 .3 1.4 0l3.5-2c.4-.3.7-.7.7-1.2s-.2-.9-.7-1.2zm-.6 1.3l-3.5 2h-.1l-.1-.1v-4.1s0-.1.1-.1h.1l3.5 2V16.6z",
    transform: "translate(-2.5 -1.546)"
  })));
  module2.exports = exports.default;
})(SubmittedProgram, SubmittedProgram.exports);
var SubmittedProgramExports = SubmittedProgram.exports;
var TableColumns = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.77 4.89H4.23a2.65 2.65 0 0 0-2.65 2.65v17a2.65 2.65 0 0 0 2.65 2.65h23.54a2.65 2.65 0 0 0 2.65-2.65v-17a2.65 2.65 0 0 0-2.65-2.65zm-7.83 1.3v19.7h-7.88V6.19zM2.88 24.54v-17a1.36 1.36 0 0 1 1.35-1.35h6.53v19.7H4.23a1.35 1.35 0 0 1-1.35-1.35zm26.24 0a1.35 1.35 0 0 1-1.35 1.35h-6.53V6.19h6.53a1.36 1.36 0 0 1 1.35 1.35z"
  })));
  module2.exports = exports.default;
})(TableColumns, TableColumns.exports);
var TableColumnsExports = TableColumns.exports;
var TableColumnsFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M10.76 4.85H4.23A2.65 2.65 0 0 0 1.58 7.5v17a2.65 2.65 0 0 0 2.65 2.65h6.53zM12.06 4.85h7.88v22.3h-7.88zM27.77 4.85h-6.53v22.3h6.53a2.65 2.65 0 0 0 2.65-2.65v-17a2.65 2.65 0 0 0-2.65-2.65z"
  })));
  module2.exports = exports.default;
})(TableColumnsFill, TableColumnsFill.exports);
var TableColumnsFillExports = TableColumnsFill.exports;
var TextInsert = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32-2",
    "data-name": "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11.84 9.71H28v1.3H11.84zM11.84 13.98H28v1.3H11.84zM4 18.25h24v1.3H4zM4 22.52h14.01v1.3H4z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M6.44 9.53h1l2.45 5.66H8.71l-.55-1.29H5.75l-.55 1.29H4zm1.29 3.36L7 11l-.78 1.85z"
  })));
  module2.exports = exports.default;
})(TextInsert, TextInsert.exports);
var TextInsertExports = TextInsert.exports;
var TimesCircle = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16 3.72A12.28 12.28 0 1 0 28.28 16 12.3 12.3 0 0 0 16 3.72zM16 27a11 11 0 1 1 11-11 11 11 0 0 1-11 11z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M19.89 11.19L16 15.08l-3.89-3.89-.92.92L15.08 16l-3.89 3.89.92.92L16 16.92l3.89 3.89.92-.92L16.92 16l3.89-3.89-.92-.92z"
  })));
  module2.exports = exports.default;
})(TimesCircle, TimesCircle.exports);
var TimesCircleExports = TimesCircle.exports;
var TimeLine = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4581 7.5H19.5419L23.4375 14.824L19.5275 21.5625H10.4725L6.5625 14.824L10.4581 7.5ZM11.1687 8.63147L7.88731 14.8007L11.1543 20.431H18.8457L22.1127 14.8007L18.8313 8.63147H11.1687Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M22.7297 14.3906H28.395V15.6094H22.7297V14.3906Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M1.60504 14.3906H7.53005V15.6094H1.60504V14.3906Z"
  })));
  module2.exports = exports.default;
})(TimeLine, TimeLine.exports);
var TimeLineExports = TimeLine.exports;
var Trace = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.847 22.756h-4.5c-.6 0-1.1-.5-1.1-1.2v-14.8c0-.3.1-.6.3-.8.2-.2.5-.4.8-.4h4.5c.3 0 .6.1.8.3.2.2.3.5.3.9v14.8c.1.6-.4 1.2-1.1 1.2zm-4.2-1.4h4.1v-14.5h-4.1v14.5zm-4.6 6.3h-4.5c-.3 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.9v-19.7c0-.3.1-.6.3-.9.2-.2.5-.4.8-.3h4.5c.3 0 .6.1.8.3.2.2.3.5.3.9v19.7c0 .3-.1.6-.3.9s-.5.3-.8.3zm-4.3-1.4h4.2v-19.4h-4.2v19.4zm-4.5-8.7h-4.4c-.6 0-1.1-.5-1.1-1.2v-9.6c0-.3.1-.6.3-.9.2-.2.5-.4.8-.3h4.5c.3 0 .6.1.8.4.2.2.3.5.3.8v9.6c-.1.7-.6 1.2-1.2 1.2zm-4.3-1.4h4.1v-9.3h-4.1v9.3z"
  })));
  module2.exports = exports.default;
})(Trace, Trace.exports);
var TraceExports = Trace.exports;
var TraceIcons13Receipt = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "14.19",
    y: "11.72",
    width: "7.58",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "10.23",
    y: "11.72",
    width: "2.24",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "14.19",
    y: "16.2",
    width: "7.58",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "10.23",
    y: "16.2",
    width: "2.24",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "14.19",
    y: "20.68",
    width: "7.58",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "10.23",
    y: "20.68",
    width: "2.24",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.07,4.33H4.93A.65.65,0,0,0,4.28,5V8.37A.65.65,0,0,0,4.93,9H6.1V27a.67.67,0,0,0,.3.55.65.65,0,0,0,.62,0l4.36-1.95,4.35,1.95a.64.64,0,0,0,.54,0l4.35-1.95L25,27.61a.6.6,0,0,0,.27.06.64.64,0,0,0,.35-.1.67.67,0,0,0,.3-.55V9h1.17a.65.65,0,0,0,.65-.65V5A.65.65,0,0,0,27.07,4.33ZM24.59,26l-3.7-1.66a.62.62,0,0,0-.53,0L16,26.31l-4.36-1.95a.62.62,0,0,0-.53,0L7.41,26V9H24.59Zm1.83-18.3H5.58V5.63H26.42Z"
  })));
  module2.exports = exports.default;
})(TraceIcons13Receipt, TraceIcons13Receipt.exports);
var TraceIcons13ReceiptExports = TraceIcons13Receipt.exports;
var Transfer = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M25.86 10.3H11.94L7.22 6.15a.64.64 0 0 0-.7-.1.65.65 0 0 0-.38.59v8.62a.65.65 0 0 0 .65.65.69.69 0 0 0 .43-.16l4.72-4.15h13.92zM7.44 13.82V8.08L10.71 11zM25.64 20.56l-4.91-4.31a.65.65 0 0 0-1.07.49v3.66H6.14v1.3h13.52v3.66A.65.65 0 0 0 20 26a.63.63 0 0 0 .27.06.67.67 0 0 0 .42-.16l4.91-4.31a.64.64 0 0 0 .22-.49.66.66 0 0 0-.18-.54zM21 23.92v-5.74l3.27 2.87z"
  })));
  module2.exports = exports.default;
})(Transfer, Transfer.exports);
var TransferExports = Transfer.exports;
var TransferLinkII = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21.75,16.44a.64.64,0,0,0-1.07.48v4.37H5V18.88H3.66V25H5v-2.4H20.68V27a.65.65,0,0,0,.65.65.67.67,0,0,0,.42-.16l5.71-5a.68.68,0,0,0,.22-.49.64.64,0,0,0-.22-.49ZM22,25.51V18.36l4.07,3.58Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M14.12,9.41V5.05A.65.65,0,0,0,13,4.56l-5.7,5a.68.68,0,0,0-.22.49.64.64,0,0,0,.22.49l5.7,5a.67.67,0,0,0,.43.17.63.63,0,0,0,.27-.06.66.66,0,0,0,.38-.59V10.71H27.69V9.41Zm-1.3,4.23L8.75,10.06l4.07-3.57Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "3.66",
    y: "7.01",
    width: "1.3",
    height: "6.11"
  })));
  module2.exports = exports.default;
})(TransferLinkII, TransferLinkII.exports);
var TransferLinkIIExports = TransferLinkII.exports;
var TransferPull = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M25.86 10.3H11.94L7.22 6.15a.64.64 0 0 0-.7-.1.65.65 0 0 0-.38.59v8.62a.65.65 0 0 0 .65.65.69.69 0 0 0 .43-.16l4.72-4.15h13.92zM7.44 13.82V8.08L10.71 11z",
    opacity: ".5"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M25.64 20.56l-4.91-4.31a.65.65 0 0 0-1.07.49v3.66H6.14v1.3h13.52v3.66A.65.65 0 0 0 20 26a.63.63 0 0 0 .27.06.67.67 0 0 0 .42-.16l4.91-4.31a.64.64 0 0 0 .22-.49.66.66 0 0 0-.18-.54zM21 23.92v-5.74l3.27 2.87z"
  })));
  module2.exports = exports.default;
})(TransferPull, TransferPull.exports);
var TransferPullExports = TransferPull.exports;
var TransferPush = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M25.86 10.3H11.94L7.22 6.15a.64.64 0 0 0-.7-.1.65.65 0 0 0-.38.59v8.62a.65.65 0 0 0 .65.65.69.69 0 0 0 .43-.16l4.72-4.15h13.92zM7.44 13.82V8.08L10.71 11z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M25.64 20.56l-4.91-4.31a.65.65 0 0 0-1.07.49v3.66H6.14v1.3h13.52v3.66A.65.65 0 0 0 20 26a.63.63 0 0 0 .27.06.67.67 0 0 0 .42-.16l4.91-4.31a.64.64 0 0 0 .22-.49.66.66 0 0 0-.18-.54zM21 23.92v-5.74l3.27 2.87z",
    opacity: ".5"
  })));
  module2.exports = exports.default;
})(TransferPush, TransferPush.exports);
var TransferPushExports = TransferPush.exports;
var Trash = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27,7.26H21.65V5.91A2.65,2.65,0,0,0,19,3.26H13a2.65,2.65,0,0,0-2.65,2.65V7.26H5a.65.65,0,0,0,0,1.3H6.35V26.09a2.61,2.61,0,0,0,2.56,2.65H23.09a2.61,2.61,0,0,0,2.56-2.65V8.56H27a.65.65,0,0,0,0-1.3ZM11.65,5.91A1.35,1.35,0,0,1,13,4.56h6a1.35,1.35,0,0,1,1.35,1.35V7.26h-8.7Zm12.7,20.18a1.31,1.31,0,0,1-1.26,1.35H8.91a1.31,1.31,0,0,1-1.26-1.35V8.56h16.7Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "11.35",
    y: "12.59",
    width: "1.3",
    height: "11"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "15.35",
    y: "12.59",
    width: "1.3",
    height: "11"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "19.35",
    y: "12.59",
    width: "1.3",
    height: "11"
  })));
  module2.exports = exports.default;
})(Trash, Trash.exports);
var TrashExports = Trash.exports;
var TrashFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26 7h-4.35V5.67A2.65 2.65 0 0 0 19 3h-6a2.65 2.65 0 0 0-2.65 2.65V7H6a2.65 2.65 0 0 0 0 5.3h.35v13.37a2.61 2.61 0 0 0 2.56 2.65h14.18a2.61 2.61 0 0 0 2.56-2.65V12.32H26A2.65 2.65 0 0 0 26 7zM11.65 5.67A1.35 1.35 0 0 1 13 4.32h6a1.35 1.35 0 0 1 1.35 1.35V7h-8.7zm1 18h-1.3v-8h1.3zm4 0h-1.3v-8h1.3zm4 0h-1.3v-8h1.3zM26 11H6a1.35 1.35 0 1 1 0-2.7h20a1.35 1.35 0 1 1 0 2.7z"
  })));
  module2.exports = exports.default;
})(TrashFill, TrashFill.exports);
var TrashFillExports = TrashFill.exports;
var Truck = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M30.4,17.18a.68.68,0,0,0-.46-.19H26.62l-2.5-6.17a.65.65,0,0,0-.6-.41h-5V6.69A.65.65,0,0,0,17.89,6H2.56a.65.65,0,0,0-.65.65V23.12a.65.65,0,0,0,.65.65H6.37a2.83,2.83,0,0,0,5.52,0h8.72a2.83,2.83,0,0,0,5.52,0h3.81a.65.65,0,0,0,.65-.65V17.64A.66.66,0,0,0,30.4,17.18ZM3.21,7.34h14V22.47H11.89a2.83,2.83,0,0,0-5.52,0H3.21ZM9.13,24.66a1.54,1.54,0,1,1,1.54-1.54A1.54,1.54,0,0,1,9.13,24.66Zm14.24,0a1.54,1.54,0,1,1,1.54-1.54A1.54,1.54,0,0,1,23.37,24.66Zm5.92-2.19H26.13a2.83,2.83,0,0,0-5.52,0H18.54V11.72h4.54l2.49,6.17a.65.65,0,0,0,.61.41h3.11Z"
  })));
  module2.exports = exports.default;
})(Truck, Truck.exports);
var TruckExports = Truck.exports;
var TruckLoading = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M31.78,17.18a.66.66,0,0,0-.46-.19H28l-2.49-6.17a.65.65,0,0,0-.61-.41h-5V6.69A.65.65,0,0,0,19.28,6H4a.65.65,0,0,0-.65.65v15.9L0,24.26l.59,1.16,3.26-1.67.07,0H7.76a2.83,2.83,0,0,0,5.52,0H22a2.83,2.83,0,0,0,5.51,0h3.81a.65.65,0,0,0,.65-.65V17.64A.66.66,0,0,0,31.78,17.18ZM10.52,24.66a1.54,1.54,0,1,1,1.54-1.54A1.54,1.54,0,0,1,10.52,24.66Zm0-4.38a2.84,2.84,0,0,0-2.76,2.19H4.6V7.34h14V22.47H13.28A2.84,2.84,0,0,0,10.52,20.28Zm14.23,4.38a1.54,1.54,0,1,1,1.54-1.54A1.54,1.54,0,0,1,24.75,24.66Zm5.92-2.19H27.51a2.83,2.83,0,0,0-5.51,0H19.93V11.72h4.54L27,17.89a.65.65,0,0,0,.6.41h3.11Z"
  })));
  module2.exports = exports.default;
})(TruckLoading, TruckLoading.exports);
var TruckLoadingExports = TruckLoading.exports;
var TruckMoving = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M31.76,17.18A.66.66,0,0,0,31.3,17H28l-2.5-6.17a.64.64,0,0,0-.6-.41h-5V6.69A.65.65,0,0,0,19.26,6H3.93a.65.65,0,0,0-.65.65v6.85h1.3V7.34h14V22.47H13.25a2.83,2.83,0,0,0-5.51,0H4.58v-1H3.28v1.65a.65.65,0,0,0,.65.65H7.74a2.83,2.83,0,0,0,5.51,0H22a2.83,2.83,0,0,0,5.52,0H31.3a.65.65,0,0,0,.65-.65V17.64A.66.66,0,0,0,31.76,17.18ZM10.5,24.66A1.54,1.54,0,1,1,12,23.12,1.54,1.54,0,0,1,10.5,24.66Zm14.23,0a1.54,1.54,0,1,1,1.54-1.54A1.54,1.54,0,0,1,24.73,24.66Zm5.92-2.19H27.49a2.83,2.83,0,0,0-5.52,0H19.91V11.72h4.53l2.5,6.17a.65.65,0,0,0,.6.41h3.11Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "0.05",
    y: "18.19",
    width: "6.68",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "1.05",
    y: "15.21",
    width: "5.68",
    height: "1.3"
  })));
  module2.exports = exports.default;
})(TruckMoving, TruckMoving.exports);
var TruckMovingExports = TruckMoving.exports;
var Upload = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M15.35,7.13v14h1.3v-14l5,5,.92-.92L17.46,6.1a2.11,2.11,0,0,0-2.92,0L9.47,11.17l.92.92Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M25.43,20.81v3.61c0,.43-.65.91-1.59.91H8.16c-.91,0-1.59-.48-1.59-.91V20.81H5.27v3.61c0,1.24,1.27,2.21,2.89,2.21H23.84c1.62,0,2.89-1,2.89-2.21V20.81Z"
  })));
  module2.exports = exports.default;
})(Upload, Upload.exports);
var UploadExports = Upload.exports;
var Video = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Artboard-32"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27,26.4H5a2.65,2.65,0,0,1-2.65-2.65V8.25A2.65,2.65,0,0,1,5,5.6H27a2.65,2.65,0,0,1,2.65,2.65v15.5A2.65,2.65,0,0,1,27,26.4ZM5,6.9A1.35,1.35,0,0,0,3.65,8.25v15.5A1.35,1.35,0,0,0,5,25.1H27a1.35,1.35,0,0,0,1.35-1.35V8.25A1.35,1.35,0,0,0,27,6.9Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M12.14,21.86a1.37,1.37,0,0,1-.7-.19,1.38,1.38,0,0,1-.7-1.21V11.54a1.38,1.38,0,0,1,.7-1.21,1.35,1.35,0,0,1,1.4,0l7.72,4.46h0a1.37,1.37,0,0,1,.7,1.21,1.4,1.4,0,0,1-.7,1.22l-7.72,4.45A1.37,1.37,0,0,1,12.14,21.86Zm0-10.42h-.05a.09.09,0,0,0-.05.09v8.92a.1.1,0,0,0,.05.09.11.11,0,0,0,.1,0l7.72-4.46a.11.11,0,0,0,0-.18l-7.72-4.46Z"
  })));
  module2.exports = exports.default;
})(Video, Video.exports);
var VideoExports = Video.exports;
var ViewAttestations = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "View Attestations"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M4.8,20.49V4.33A1.19,1.19,0,0,1,6,3.18H14.9V5.74A2.85,2.85,0,0,0,17.82,8.5h2.4v3.68h1.3V7.27a.68.68,0,0,0-.19-.47L16.55,2.07a.64.64,0,0,0-.46-.19H6A2.49,2.49,0,0,0,3.5,4.33V20.49A2.48,2.48,0,0,0,6,22.93h5v-1.3H6A1.18,1.18,0,0,1,4.8,20.49ZM19.88,7.2H17.82A1.55,1.55,0,0,1,16.2,5.74V3.55Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M18.57,13.43a6.5,6.5,0,1,0,6.5,6.5A6.51,6.51,0,0,0,18.57,13.43Zm0,11.7a5.2,5.2,0,1,1,5.2-5.2A5.2,5.2,0,0,1,18.57,25.13Z"
  }), /* @__PURE__ */ _react2["default"].createElement("polygon", {
    points: "27.84 28.54 24.94 25.64 24.28 24.98 23.36 25.9 24.02 26.56 26.92 29.46 27.58 30.12 28.5 29.2 27.84 28.54"
  })));
  module2.exports = exports.default;
})(ViewAttestations, ViewAttestations.exports);
var ViewAttestationsExports = ViewAttestations.exports;
var WalletKeys = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M17.76,13.85a2.66,2.66,0,1,0,2.65,2.66A2.66,2.66,0,0,0,17.76,13.85Zm0,4a1.36,1.36,0,1,1,1.35-1.35A1.35,1.35,0,0,1,17.76,17.86Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.37,15.91l-2.63-4.56h-6l-3,5.16,3,5.15h6l2.57-4.44h2.18v3h1.3v-3h1.27v1.92h1.3V17.22h1.31v3.27H32V15.91ZM20,20.36H15.53l-2.22-3.85,2.22-3.86H20l2.22,3.86Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M25.56,25.17a1.36,1.36,0,0,1-1.35,1.35H2.79a1.35,1.35,0,0,1-1.35-1.35V6.43a2.77,2.77,0,0,0,1.29.32H24.21A1.36,1.36,0,0,1,25.56,8.1v5.78h1.3V8.1a2.65,2.65,0,0,0-2.65-2.65H2.73A1.25,1.25,0,0,1,1.38,4.33V4.09A1.25,1.25,0,0,1,2.73,3H22.24V1.67H2.73A2.54,2.54,0,0,0,.08,4.09v.24a2,2,0,0,0,.06.49V25.17a2.65,2.65,0,0,0,2.65,2.65H24.21a2.65,2.65,0,0,0,2.65-2.65V22.36h-1.3Z"
  })));
  module2.exports = exports.default;
})(WalletKeys, WalletKeys.exports);
var WalletKeysExports = WalletKeys.exports;
var Warehouse = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M20 28.65h-8a.65.65 0 0 1-.65-.65v-7a.65.65 0 0 1 .65-.65h8a.65.65 0 0 1 .65.65v7a.65.65 0 0 1-.65.65zm-7.35-1.3h6.7v-5.7h-6.7zM2 13.77a.65.65 0 0 1-.62-.45.63.63 0 0 1 .24-.73l14-10a.65.65 0 0 1 .75 0l14.05 9.89a.65.65 0 0 1-.42 1.17l-2 .06a.65.65 0 0 1 0-1.3l-12-8.5-11.91 8.52a.64.64 0 0 1 .53.62.63.63 0 0 1-.63.66h-2z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M28 28.65h-4a.65.65 0 0 1-.65-.65V13.65H8.65V28a.65.65 0 0 1-.65.65H4a.65.65 0 0 1-.65-.65V13h1.3v14.35h2.69V13a.65.65 0 0 1 .66-.65h16a.68.68 0 0 1 .46.19.66.66 0 0 1 .19.46v14.35h2.7V13h1.3v15a.65.65 0 0 1-.65.65zM14 8.35h4v1.3h-4z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M15.35 21h1.3v3h-1.3z"
  })));
  module2.exports = exports.default;
})(Warehouse, Warehouse.exports);
var WarehouseExports = Warehouse.exports;
var Watching = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M19,9.41a.64.64,0,0,0-.56-.32H13.21a.65.65,0,0,0-.57.32L10,13.91a.7.7,0,0,0,0,.66l2.6,4.5a.65.65,0,0,0,.57.32H18.4a.64.64,0,0,0,.56-.32l2.6-4.5a.65.65,0,0,0,0-.66ZM18,18.09H13.58l-2.22-3.85,2.22-3.85H18l2.22,3.85Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.88,14C27,8.18,21.59,4.59,15.8,4.59S4.62,8.18,1.72,14a.66.66,0,0,0,0,.58c2.9,5.77,8.3,9.36,14.08,9.36S27,20.3,29.88,14.53A.6.6,0,0,0,29.88,14ZM15.8,22.59C10.61,22.59,5.74,19.4,3,14.24,5.74,9.08,10.61,5.89,15.8,5.89s10.06,3.19,12.77,8.35C25.86,19.4,21,22.59,15.8,22.59Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21,26.19l.44,1.22a19.55,19.55,0,0,0,8-5.54l-1-.86A18.23,18.23,0,0,1,21,26.19Z"
  })));
  module2.exports = exports.default;
})(Watching, Watching.exports);
var WatchingExports = Watching.exports;
var WatchingFill = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("polygon", {
    points: "13.4 11 10.8 15.5 13.4 20 18.6 20 21.2 15.5 18.6 11 13.4 11"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M30.08,15.21C27.18,9.44,21.79,5.85,16,5.85S4.82,9.44,1.92,15.21a.66.66,0,0,0,0,.58c2.9,5.77,8.29,9.36,14.08,9.36s11.18-3.59,14.08-9.36A.66.66,0,0,0,30.08,15.21ZM16,23.85c-5.19,0-10.06-3.19-12.77-8.35C5.94,10.34,10.81,7.15,16,7.15s10.06,3.19,12.77,8.35C26.06,20.66,21.19,23.85,16,23.85Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21.18,27.45l.44,1.22a19.45,19.45,0,0,0,8-5.54l-1-.86A18.23,18.23,0,0,1,21.18,27.45Z"
  })));
  module2.exports = exports.default;
})(WatchingFill, WatchingFill.exports);
var WatchingFillExports = WatchingFill.exports;
var World = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("title", null, "Trace Icons_1-3"), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M29.73,13.86v0s0,0,0,0A13.83,13.83,0,1,0,29.91,16,13.73,13.73,0,0,0,29.73,13.86Zm-1.42,3.95,0,0a1.41,1.41,0,0,0-.88-.38,1.29,1.29,0,0,0-1,.48.63.63,0,0,0-.12.11,1.5,1.5,0,0,1-.23-.31,3.37,3.37,0,0,1-.39-.82.7.7,0,0,1,0-.54A2.76,2.76,0,0,1,26,16a1.78,1.78,0,0,0,.74-1.16,2,2,0,0,0-.12-.77l0-.1c.15,0,.34,0,.55,0,.84-.07,1.27,0,1.31.1A12.51,12.51,0,0,1,28.61,16a11.52,11.52,0,0,1-.09,1.45A1.38,1.38,0,0,1,28.31,17.81ZM24.2,6.49a1.29,1.29,0,0,1,.15.49c-.54.09-1.67.31-2,1.12l-.06.18a.36.36,0,0,1,0,.1l0,0a1.72,1.72,0,0,1-.2-.43c-.07-.17-.14-.33-.22-.49a1.45,1.45,0,0,0-1.63-.81,1,1,0,0,0-.34.16c.31-.71.87-1.83,1.36-2a.62.62,0,0,0,.19-.12,12.82,12.82,0,0,1,2.71,1.75A.24.24,0,0,0,24.2,6.49ZM11.16,17A5.74,5.74,0,0,0,13,18.54l.59.4a.77.77,0,0,0,.83-.09,2.07,2.07,0,0,1,1.25,0l1.21.27a4.24,4.24,0,0,0,.7.11,4.86,4.86,0,0,0,.66,0c.28,0,.59-.06.68,0a1.35,1.35,0,0,1,.15.54,1.94,1.94,0,0,0,.63,1.35,2.09,2.09,0,0,0,.87.33,1.71,1.71,0,0,1,.29.08.16.16,0,0,1,0,.08,1.43,1.43,0,0,1-.41.4l-1.18.79a15.44,15.44,0,0,0-2.06,1.5A5.09,5.09,0,0,0,15.31,28c-.05-.08-.09-.16-.14-.23a4,4,0,0,1-.49-2.63c0-.16.06-.32.1-.48a3.26,3.26,0,0,0,0-2.2,3.16,3.16,0,0,0-.51-.72,2.72,2.72,0,0,1-.29-.38c-.07-.13-.18-.29-.3-.47A4.51,4.51,0,0,1,13,19.64c.11-.83-1.61-1.67-1.63-1.68a5.24,5.24,0,0,1-.88-.62,14.71,14.71,0,0,0-2.72-1.77,2.3,2.3,0,0,1,0-.84c0-.22,0-.43,0-.62a3,3,0,0,0-.94-2.4,3.14,3.14,0,0,0-1.1-.49,1.89,1.89,0,0,1-.71-.31.86.86,0,0,1-.28-.49l.76-1.29a2.59,2.59,0,0,1,.92-.32L7,8.7a22.76,22.76,0,0,1,3.53-.51,3.77,3.77,0,0,0,1.58-.8c.24-.16.6-.41.87-.55.08.23.16.52.23.77.55,1.88.88,2.8,1.48,3.09a2,2,0,0,1,1.23,1.82,1.51,1.51,0,0,1-.37,0,1,1,0,0,0-1,.31,2,2,0,0,0-.32,1v.1c0,.12,0,.19,0,.22a.24.24,0,0,1-.08-.06,1.79,1.79,0,0,1-.25-.63,2.63,2.63,0,0,0-.56-1.16A.85.85,0,0,0,12.5,12c-.62.11-.95.87-1.33,1.75a6.47,6.47,0,0,1-.28.61A2.68,2.68,0,0,0,11.16,17ZM3.39,16a12.63,12.63,0,0,1,.73-4.19l0,0a2.67,2.67,0,0,0,1.24.61,2.21,2.21,0,0,1,.67.28c.28.21.42.66.42,1.38a2.8,2.8,0,0,1,0,.49c-.06.67-.15,1.68.72,2.12a13.83,13.83,0,0,1,2.51,1.63,6.23,6.23,0,0,0,1.13.78,5.13,5.13,0,0,1,.88.61,4.54,4.54,0,0,0,.87,1.85c.1.15.19.28.25.39a3.48,3.48,0,0,0,.44.59,1.84,1.84,0,0,1,.31.43,2.19,2.19,0,0,1-.06,1.35c0,.19-.08.37-.11.55a5.25,5.25,0,0,0,.67,3.54A12.61,12.61,0,0,1,3.39,16ZM16.65,28.58a2.83,2.83,0,0,0,0-.3v-.14a3.72,3.72,0,0,1,1.43-2.84A14.23,14.23,0,0,1,20,23.92c.42-.27.83-.54,1.23-.83a2.59,2.59,0,0,0,.79-.82,1.4,1.4,0,0,0-.09-1.54,1.69,1.69,0,0,0-1.05-.52,1.41,1.41,0,0,1-.34-.1c-.07-.05-.11-.32-.14-.51a2,2,0,0,0-.55-1.29,2,2,0,0,0-1.69-.37,2.53,2.53,0,0,1-.47,0,2.18,2.18,0,0,1-.49-.08L16,17.62a3.33,3.33,0,0,0-2,0l-.25-.17a8.27,8.27,0,0,1-1.41-1.07c-.23-.43-.51-1-.32-1.34a6.31,6.31,0,0,0,.37-.77c.06-.13.13-.31.21-.48a2.72,2.72,0,0,0,.53,1.12,1.38,1.38,0,0,0,1.71.34,1.61,1.61,0,0,0,.66-1.17l0-.12a.77.77,0,0,1,0-.15,1.36,1.36,0,0,0,1.59-.94,3.1,3.1,0,0,0-1.82-3.32,10,10,0,0,1-.85-2.32,7,7,0,0,0-.51-1.46.82.82,0,0,0-.52-.36c-.52-.11-1.08.25-2,.89-.33.21-.82.54-.92.58a23.77,23.77,0,0,0-3.65.52A12.53,12.53,0,0,1,20,4.06a8.32,8.32,0,0,0-1.51,2.6l0,.09a1.8,1.8,0,0,0-.21.77,1.12,1.12,0,0,0,.63,1.07,1.23,1.23,0,0,0,1.43-.43l.1-.12c.06-.07.14-.17.11-.18a.42.42,0,0,1,.18.18,3.68,3.68,0,0,1,.15.35,2.64,2.64,0,0,0,.36.71,1.53,1.53,0,0,0,1,.62h.18a1.12,1.12,0,0,0,.69-.23,1.56,1.56,0,0,0,.5-.85l0-.08s.21-.18,1-.32l.13,0a1.1,1.1,0,0,0,.71-.54,12.65,12.65,0,0,1,2.68,4.94,6.66,6.66,0,0,0-1.12,0l-.48,0a1.31,1.31,0,0,0-1,.34,1.24,1.24,0,0,0-.26,1.28l.05.18a.69.69,0,0,1,.06.24c0,.06-.19.22-.3.32a2.66,2.66,0,0,0-.54.6,2,2,0,0,0-.19,1.55,4.81,4.81,0,0,0,.53,1.14c.46.78.95,1,1.34,1l.22,0a1.68,1.68,0,0,0,.8-.48l.1-.09.1.08a1.58,1.58,0,0,0,.7.34A12.62,12.62,0,0,1,16.65,28.58Z"
  })));
  module2.exports = exports.default;
})(World, World.exports);
var WorldExports = World.exports;
generatedIcons.__esModule = true;
generatedIcons.Pull = generatedIcons.Profile = generatedIcons.PrivateProcessFill = generatedIcons.PrivateProcess = generatedIcons.Presentation = generatedIcons.PinToPin = generatedIcons.Pen = generatedIcons.PasswordShow = generatedIcons.PasswordHide = generatedIcons.Paragraph = generatedIcons.Paperclip = generatedIcons.PadlockOpen = generatedIcons.PadlockCloseFill = generatedIcons.PadlockClose = generatedIcons.PackageDelivery = generatedIcons.Package = generatedIcons.OutsideLink = generatedIcons.OutisdeLink = generatedIcons.Outgoing32 = generatedIcons.Moon = generatedIcons.Mobile = generatedIcons.Minus = generatedIcons.MetricsFill = generatedIcons.Metrics = generatedIcons.Members = generatedIcons.MagnifyingGlass = generatedIcons.Legal = generatedIcons.Layers = generatedIcons.Key = generatedIcons.Kanban = generatedIcons.InputShortText = generatedIcons.InputLongText = generatedIcons.InputFill = generatedIcons.Input = generatedIcons.Image = generatedIcons.IdentityKey = generatedIcons.HexagonTeamAdd = generatedIcons.Help = generatedIcons.Flag = generatedIcons.FilterFill = generatedIcons.Filter = generatedIcons.EuroPayment = generatedIcons.Erase = generatedIcons.EmailDoc = generatedIcons.Email = generatedIcons.Duplicate = generatedIcons.DragDrop = generatedIcons.Download = generatedIcons.DownArrowFill = generatedIcons.DownArrow = generatedIcons.DocumentValid = generatedIcons.DocumentUpload = generatedIcons.DocumentTick = generatedIcons.DocumentSigned = generatedIcons.DocumentSearch = generatedIcons.DocumentRequest = generatedIcons.DocumentLocked = generatedIcons.DocumentLinked = generatedIcons.DocumentInvalid = generatedIcons.DocumentIncomplete = generatedIcons.DocumentGraph = generatedIcons.DocumentFill = generatedIcons.DocumentEmpty = generatedIcons.DocumentDownload = generatedIcons.DocumentComplete = generatedIcons.DocumentClosed = generatedIcons.Document = generatedIcons.DamagedPackage = generatedIcons.CustomizeRulerFill = generatedIcons.CustomizeRuler = generatedIcons.Cross = generatedIcons.CopyFill = generatedIcons.Copy = generatedIcons.ClockGeneral = generatedIcons.Clock = generatedIcons.ClipboardCopied = generatedIcons.Clipboard = generatedIcons.CircleUpload = generatedIcons.CircleInfo = generatedIcons.Camera = generatedIcons.CalendarRow = generatedIcons.Calendar = generatedIcons.Building = generatedIcons.Blockchain = generatedIcons.BellFill = generatedIcons.Bell = generatedIcons.Barcode = generatedIcons.AwaitingAction = generatedIcons.ArrowRightLight = generatedIcons.ArrowRight = generatedIcons.ArrowLeftLight = generatedIcons.ArrowLeft = generatedIcons.ArrowArchive = generatedIcons.ArchiveFill = generatedIcons.Archive = generatedIcons.Analytics = generatedIcons.AddMembers = generatedIcons.AddForms = generatedIcons.AddCircle = generatedIcons.Add = void 0;
generatedIcons.linkReferences = generatedIcons.linkReferencedBy = generatedIcons.World = generatedIcons.WatchingFill = generatedIcons.Watching = generatedIcons.Warehouse = generatedIcons.WalletKeys = generatedIcons.ViewAttestations = generatedIcons.Video = generatedIcons.Upload = generatedIcons.TruckMoving = generatedIcons.TruckLoading = generatedIcons.Truck = generatedIcons.TrashFill = generatedIcons.Trash = generatedIcons.TransferPush = generatedIcons.TransferPull = generatedIcons.TransferLinkII = generatedIcons.Transfer = generatedIcons.TraceIcons13Receipt = generatedIcons.Trace = generatedIcons.TimesCircle = generatedIcons.TimeLine = generatedIcons.TextInsert = generatedIcons.TableColumnsFill = generatedIcons.TableColumns = generatedIcons.SubmittedProgram = generatedIcons.Steps = generatedIcons.SpeechBubble = generatedIcons.SortingIconGeneral = generatedIcons.SortingIconDescending = generatedIcons.SortingIconAscending = generatedIcons.Signature = generatedIcons.SignOut = generatedIcons.ShieldStar = generatedIcons.SharedProcessFill = generatedIcons.SharedProcess = generatedIcons.SettingsFill = generatedIcons.SettingsDocument = generatedIcons.Settings = generatedIcons.SegmentReferenceBY = generatedIcons.SegmentReference = generatedIcons.Scoring = generatedIcons.Save = generatedIcons.SFTimesCircle = generatedIcons.SFTickCircle = generatedIcons.SFTextInsert = generatedIcons.SFParagraph = generatedIcons.SFKanban = generatedIcons.SFInputShortText = generatedIcons.SFInputLongText = generatedIcons.SFAddCircle = generatedIcons.Review = generatedIcons.Return = generatedIcons.Reset = generatedIcons.RenameFill = generatedIcons.Rename = generatedIcons.Remove = generatedIcons.QRCode = generatedIcons.Push = void 0;
var _Add = _interopRequireDefault$1(AddExports);
generatedIcons.Add = _Add["default"];
var _AddCircle = _interopRequireDefault$1(AddCircleExports);
generatedIcons.AddCircle = _AddCircle["default"];
var _AddForms = _interopRequireDefault$1(AddFormsExports);
generatedIcons.AddForms = _AddForms["default"];
var _AddMembers = _interopRequireDefault$1(AddMembersExports);
generatedIcons.AddMembers = _AddMembers["default"];
var _Analytics = _interopRequireDefault$1(AnalyticsExports);
generatedIcons.Analytics = _Analytics["default"];
var _Archive = _interopRequireDefault$1(ArchiveExports);
generatedIcons.Archive = _Archive["default"];
var _ArchiveFill = _interopRequireDefault$1(ArchiveFillExports);
generatedIcons.ArchiveFill = _ArchiveFill["default"];
var _ArrowArchive = _interopRequireDefault$1(ArrowArchiveExports);
generatedIcons.ArrowArchive = _ArrowArchive["default"];
var _ArrowLeft = _interopRequireDefault$1(ArrowLeftExports);
generatedIcons.ArrowLeft = _ArrowLeft["default"];
var _ArrowLeftLight = _interopRequireDefault$1(ArrowLeftLightExports);
generatedIcons.ArrowLeftLight = _ArrowLeftLight["default"];
var _ArrowRightLight = _interopRequireDefault$1(ArrowRightLightExports);
generatedIcons.ArrowRightLight = _ArrowRightLight["default"];
var _ArrowRight = _interopRequireDefault$1(ArrowRightExports);
generatedIcons.ArrowRight = _ArrowRight["default"];
var _AwaitingAction = _interopRequireDefault$1(AwaitingActionExports);
generatedIcons.AwaitingAction = _AwaitingAction["default"];
var _Barcode = _interopRequireDefault$1(BarcodeExports);
generatedIcons.Barcode = _Barcode["default"];
var _Bell = _interopRequireDefault$1(BellExports);
generatedIcons.Bell = _Bell["default"];
var _BellFill = _interopRequireDefault$1(BellFillExports);
generatedIcons.BellFill = _BellFill["default"];
var _Blockchain = _interopRequireDefault$1(BlockchainExports);
generatedIcons.Blockchain = _Blockchain["default"];
var _Building = _interopRequireDefault$1(BuildingExports);
generatedIcons.Building = _Building["default"];
var _Calendar = _interopRequireDefault$1(CalendarExports);
generatedIcons.Calendar = _Calendar["default"];
var _CalendarRow = _interopRequireDefault$1(CalendarRowExports);
generatedIcons.CalendarRow = _CalendarRow["default"];
var _Camera = _interopRequireDefault$1(CameraExports);
generatedIcons.Camera = _Camera["default"];
var _CircleInfo = _interopRequireDefault$1(CircleInfoExports);
generatedIcons.CircleInfo = _CircleInfo["default"];
var _CircleUpload = _interopRequireDefault$1(CircleUploadExports);
generatedIcons.CircleUpload = _CircleUpload["default"];
var _Clipboard = _interopRequireDefault$1(ClipboardExports);
generatedIcons.Clipboard = _Clipboard["default"];
var _ClipboardCopied = _interopRequireDefault$1(ClipboardCopiedExports);
generatedIcons.ClipboardCopied = _ClipboardCopied["default"];
var _Clock = _interopRequireDefault$1(ClockExports);
generatedIcons.Clock = _Clock["default"];
var _ClockGeneral = _interopRequireDefault$1(ClockGeneralExports);
generatedIcons.ClockGeneral = _ClockGeneral["default"];
var _Copy = _interopRequireDefault$1(CopyExports);
generatedIcons.Copy = _Copy["default"];
var _CopyFill = _interopRequireDefault$1(CopyFillExports);
generatedIcons.CopyFill = _CopyFill["default"];
var _Cross = _interopRequireDefault$1(CrossExports);
generatedIcons.Cross = _Cross["default"];
var _CustomizeRuler = _interopRequireDefault$1(CustomizeRulerExports);
generatedIcons.CustomizeRuler = _CustomizeRuler["default"];
var _CustomizeRulerFill = _interopRequireDefault$1(CustomizeRulerFillExports);
generatedIcons.CustomizeRulerFill = _CustomizeRulerFill["default"];
var _DamagedPackage = _interopRequireDefault$1(DamagedPackageExports);
generatedIcons.DamagedPackage = _DamagedPackage["default"];
var _Document = _interopRequireDefault$1(DocumentExports);
generatedIcons.Document = _Document["default"];
var _DocumentClosed = _interopRequireDefault$1(DocumentClosedExports);
generatedIcons.DocumentClosed = _DocumentClosed["default"];
var _DocumentComplete = _interopRequireDefault$1(DocumentCompleteExports);
generatedIcons.DocumentComplete = _DocumentComplete["default"];
var _DocumentDownload = _interopRequireDefault$1(DocumentDownloadExports);
generatedIcons.DocumentDownload = _DocumentDownload["default"];
var _DocumentEmpty = _interopRequireDefault$1(DocumentEmptyExports);
generatedIcons.DocumentEmpty = _DocumentEmpty["default"];
var _DocumentFill = _interopRequireDefault$1(DocumentFillExports);
generatedIcons.DocumentFill = _DocumentFill["default"];
var _DocumentGraph = _interopRequireDefault$1(DocumentGraphExports);
generatedIcons.DocumentGraph = _DocumentGraph["default"];
var _DocumentIncomplete = _interopRequireDefault$1(DocumentIncompleteExports);
generatedIcons.DocumentIncomplete = _DocumentIncomplete["default"];
var _DocumentInvalid = _interopRequireDefault$1(DocumentInvalidExports);
generatedIcons.DocumentInvalid = _DocumentInvalid["default"];
var _DocumentLinked = _interopRequireDefault$1(DocumentLinkedExports);
generatedIcons.DocumentLinked = _DocumentLinked["default"];
var _DocumentLocked = _interopRequireDefault$1(DocumentLockedExports);
generatedIcons.DocumentLocked = _DocumentLocked["default"];
var _DocumentRequest = _interopRequireDefault$1(DocumentRequestExports);
generatedIcons.DocumentRequest = _DocumentRequest["default"];
var _DocumentSearch = _interopRequireDefault$1(DocumentSearchExports);
generatedIcons.DocumentSearch = _DocumentSearch["default"];
var _DocumentSigned = _interopRequireDefault$1(DocumentSignedExports);
generatedIcons.DocumentSigned = _DocumentSigned["default"];
var _DocumentTick = _interopRequireDefault$1(DocumentTickExports);
generatedIcons.DocumentTick = _DocumentTick["default"];
var _DocumentUpload = _interopRequireDefault$1(DocumentUploadExports);
generatedIcons.DocumentUpload = _DocumentUpload["default"];
var _DocumentValid = _interopRequireDefault$1(DocumentValidExports);
generatedIcons.DocumentValid = _DocumentValid["default"];
var _DownArrow = _interopRequireDefault$1(DownArrowExports);
generatedIcons.DownArrow = _DownArrow["default"];
var _DownArrowFill = _interopRequireDefault$1(DownArrowFillExports);
generatedIcons.DownArrowFill = _DownArrowFill["default"];
var _Download = _interopRequireDefault$1(DownloadExports);
generatedIcons.Download = _Download["default"];
var _DragDrop = _interopRequireDefault$1(DragDropExports);
generatedIcons.DragDrop = _DragDrop["default"];
var _Duplicate = _interopRequireDefault$1(DuplicateExports);
generatedIcons.Duplicate = _Duplicate["default"];
var _Email = _interopRequireDefault$1(EmailExports);
generatedIcons.Email = _Email["default"];
var _EmailDoc = _interopRequireDefault$1(EmailDocExports);
generatedIcons.EmailDoc = _EmailDoc["default"];
var _Erase = _interopRequireDefault$1(EraseExports);
generatedIcons.Erase = _Erase["default"];
var _EuroPayment = _interopRequireDefault$1(EuroPaymentExports);
generatedIcons.EuroPayment = _EuroPayment["default"];
var _Filter = _interopRequireDefault$1(FilterExports);
generatedIcons.Filter = _Filter["default"];
var _FilterFill = _interopRequireDefault$1(FilterFillExports);
generatedIcons.FilterFill = _FilterFill["default"];
var _Flag = _interopRequireDefault$1(FlagExports);
generatedIcons.Flag = _Flag["default"];
var _Help = _interopRequireDefault$1(HelpExports);
generatedIcons.Help = _Help["default"];
var _HexagonTeamAdd = _interopRequireDefault$1(HexagonTeamAddExports);
generatedIcons.HexagonTeamAdd = _HexagonTeamAdd["default"];
var _IdentityKey = _interopRequireDefault$1(IdentityKeyExports);
generatedIcons.IdentityKey = _IdentityKey["default"];
var _Image = _interopRequireDefault$1(ImageExports);
generatedIcons.Image = _Image["default"];
var _Input = _interopRequireDefault$1(InputExports);
generatedIcons.Input = _Input["default"];
var _InputFill = _interopRequireDefault$1(InputFillExports);
generatedIcons.InputFill = _InputFill["default"];
var _InputLongText = _interopRequireDefault$1(InputLongTextExports);
generatedIcons.InputLongText = _InputLongText["default"];
var _InputShortText = _interopRequireDefault$1(InputShortTextExports);
generatedIcons.InputShortText = _InputShortText["default"];
var _Kanban = _interopRequireDefault$1(KanbanExports);
generatedIcons.Kanban = _Kanban["default"];
var _Key = _interopRequireDefault$1(KeyExports);
generatedIcons.Key = _Key["default"];
var _Layers = _interopRequireDefault$1(LayersExports);
generatedIcons.Layers = _Layers["default"];
var _Legal = _interopRequireDefault$1(LegalExports);
generatedIcons.Legal = _Legal["default"];
var _linkReferencedBy = _interopRequireDefault$1(linkReferencedByExports);
generatedIcons.linkReferencedBy = _linkReferencedBy["default"];
var _linkReferences = _interopRequireDefault$1(linkReferencesExports);
generatedIcons.linkReferences = _linkReferences["default"];
var _MagnifyingGlass = _interopRequireDefault$1(MagnifyingGlassExports);
generatedIcons.MagnifyingGlass = _MagnifyingGlass["default"];
var _Members = _interopRequireDefault$1(MembersExports);
generatedIcons.Members = _Members["default"];
var _Metrics = _interopRequireDefault$1(MetricsExports);
generatedIcons.Metrics = _Metrics["default"];
var _MetricsFill = _interopRequireDefault$1(MetricsFillExports);
generatedIcons.MetricsFill = _MetricsFill["default"];
var _Minus = _interopRequireDefault$1(MinusExports);
generatedIcons.Minus = _Minus["default"];
var _Mobile = _interopRequireDefault$1(MobileExports);
generatedIcons.Mobile = _Mobile["default"];
var _Moon = _interopRequireDefault$1(MoonExports);
generatedIcons.Moon = _Moon["default"];
var _Outgoing = _interopRequireDefault$1(Outgoing32Exports);
generatedIcons.Outgoing32 = _Outgoing["default"];
var _OutisdeLink = _interopRequireDefault$1(OutisdeLinkExports);
generatedIcons.OutisdeLink = _OutisdeLink["default"];
var _OutsideLink = _interopRequireDefault$1(OutsideLinkExports);
generatedIcons.OutsideLink = _OutsideLink["default"];
var _Package = _interopRequireDefault$1(PackageExports);
generatedIcons.Package = _Package["default"];
var _PackageDelivery = _interopRequireDefault$1(PackageDeliveryExports);
generatedIcons.PackageDelivery = _PackageDelivery["default"];
var _PadlockClose = _interopRequireDefault$1(PadlockCloseExports);
generatedIcons.PadlockClose = _PadlockClose["default"];
var _PadlockCloseFill = _interopRequireDefault$1(PadlockCloseFillExports);
generatedIcons.PadlockCloseFill = _PadlockCloseFill["default"];
var _PadlockOpen = _interopRequireDefault$1(PadlockOpenExports);
generatedIcons.PadlockOpen = _PadlockOpen["default"];
var _Paperclip = _interopRequireDefault$1(PaperclipExports);
generatedIcons.Paperclip = _Paperclip["default"];
var _Paragraph = _interopRequireDefault$1(ParagraphExports);
generatedIcons.Paragraph = _Paragraph["default"];
var _PasswordHide = _interopRequireDefault$1(PasswordHideExports);
generatedIcons.PasswordHide = _PasswordHide["default"];
var _PasswordShow = _interopRequireDefault$1(PasswordShowExports);
generatedIcons.PasswordShow = _PasswordShow["default"];
var _Pen = _interopRequireDefault$1(PenExports);
generatedIcons.Pen = _Pen["default"];
var _PinToPin = _interopRequireDefault$1(PinToPinExports);
generatedIcons.PinToPin = _PinToPin["default"];
var _Presentation = _interopRequireDefault$1(PresentationExports);
generatedIcons.Presentation = _Presentation["default"];
var _PrivateProcess = _interopRequireDefault$1(PrivateProcessExports);
generatedIcons.PrivateProcess = _PrivateProcess["default"];
var _PrivateProcessFill = _interopRequireDefault$1(PrivateProcessFillExports);
generatedIcons.PrivateProcessFill = _PrivateProcessFill["default"];
var _Profile = _interopRequireDefault$1(ProfileExports);
generatedIcons.Profile = _Profile["default"];
var _Pull = _interopRequireDefault$1(PullExports);
generatedIcons.Pull = _Pull["default"];
var _Push = _interopRequireDefault$1(PushExports);
generatedIcons.Push = _Push["default"];
var _QRCode = _interopRequireDefault$1(QRCodeExports);
generatedIcons.QRCode = _QRCode["default"];
var _Remove = _interopRequireDefault$1(RemoveExports);
generatedIcons.Remove = _Remove["default"];
var _Rename = _interopRequireDefault$1(RenameExports);
generatedIcons.Rename = _Rename["default"];
var _RenameFill = _interopRequireDefault$1(RenameFillExports);
generatedIcons.RenameFill = _RenameFill["default"];
var _Reset = _interopRequireDefault$1(ResetExports);
generatedIcons.Reset = _Reset["default"];
var _Return = _interopRequireDefault$1(ReturnExports);
generatedIcons.Return = _Return["default"];
var _Review = _interopRequireDefault$1(ReviewExports);
generatedIcons.Review = _Review["default"];
var _Save = _interopRequireDefault$1(SaveExports);
generatedIcons.Save = _Save["default"];
var _Scoring = _interopRequireDefault$1(ScoringExports);
generatedIcons.Scoring = _Scoring["default"];
var _SegmentReference = _interopRequireDefault$1(SegmentReferenceExports);
generatedIcons.SegmentReference = _SegmentReference["default"];
var _SegmentReferenceBY = _interopRequireDefault$1(SegmentReferenceBYExports);
generatedIcons.SegmentReferenceBY = _SegmentReferenceBY["default"];
var _Settings = _interopRequireDefault$1(SettingsExports);
generatedIcons.Settings = _Settings["default"];
var _SettingsDocument = _interopRequireDefault$1(SettingsDocumentExports);
generatedIcons.SettingsDocument = _SettingsDocument["default"];
var _SettingsFill = _interopRequireDefault$1(SettingsFillExports);
generatedIcons.SettingsFill = _SettingsFill["default"];
var _SFAddCircle = _interopRequireDefault$1(SFAddCircleExports);
generatedIcons.SFAddCircle = _SFAddCircle["default"];
var _SFInputLongText = _interopRequireDefault$1(SFInputLongTextExports);
generatedIcons.SFInputLongText = _SFInputLongText["default"];
var _SFInputShortText = _interopRequireDefault$1(SFInputShortTextExports);
generatedIcons.SFInputShortText = _SFInputShortText["default"];
var _SFKanban = _interopRequireDefault$1(SFKanbanExports);
generatedIcons.SFKanban = _SFKanban["default"];
var _SFParagraph = _interopRequireDefault$1(SFParagraphExports);
generatedIcons.SFParagraph = _SFParagraph["default"];
var _SFTextInsert = _interopRequireDefault$1(SFTextInsertExports);
generatedIcons.SFTextInsert = _SFTextInsert["default"];
var _SFTickCircle = _interopRequireDefault$1(SFTickCircleExports);
generatedIcons.SFTickCircle = _SFTickCircle["default"];
var _SFTimesCircle = _interopRequireDefault$1(SFTimesCircleExports);
generatedIcons.SFTimesCircle = _SFTimesCircle["default"];
var _SharedProcess = _interopRequireDefault$1(SharedProcessExports);
generatedIcons.SharedProcess = _SharedProcess["default"];
var _SharedProcessFill = _interopRequireDefault$1(SharedProcessFillExports);
generatedIcons.SharedProcessFill = _SharedProcessFill["default"];
var _ShieldStar = _interopRequireDefault$1(ShieldStarExports);
generatedIcons.ShieldStar = _ShieldStar["default"];
var _Signature = _interopRequireDefault$1(SignatureExports);
generatedIcons.Signature = _Signature["default"];
var _SignOut = _interopRequireDefault$1(SignOutExports);
generatedIcons.SignOut = _SignOut["default"];
var _SortingIconAscending = _interopRequireDefault$1(SortingIconAscendingExports);
generatedIcons.SortingIconAscending = _SortingIconAscending["default"];
var _SortingIconDescending = _interopRequireDefault$1(SortingIconDescendingExports);
generatedIcons.SortingIconDescending = _SortingIconDescending["default"];
var _SortingIconGeneral = _interopRequireDefault$1(SortingIconGeneralExports);
generatedIcons.SortingIconGeneral = _SortingIconGeneral["default"];
var _SpeechBubble = _interopRequireDefault$1(SpeechBubbleExports);
generatedIcons.SpeechBubble = _SpeechBubble["default"];
var _Steps = _interopRequireDefault$1(StepsExports);
generatedIcons.Steps = _Steps["default"];
var _SubmittedProgram = _interopRequireDefault$1(SubmittedProgramExports);
generatedIcons.SubmittedProgram = _SubmittedProgram["default"];
var _TableColumns = _interopRequireDefault$1(TableColumnsExports);
generatedIcons.TableColumns = _TableColumns["default"];
var _TableColumnsFill = _interopRequireDefault$1(TableColumnsFillExports);
generatedIcons.TableColumnsFill = _TableColumnsFill["default"];
var _TextInsert = _interopRequireDefault$1(TextInsertExports);
generatedIcons.TextInsert = _TextInsert["default"];
var _TimesCircle = _interopRequireDefault$1(TimesCircleExports);
generatedIcons.TimesCircle = _TimesCircle["default"];
var _TimeLine = _interopRequireDefault$1(TimeLineExports);
generatedIcons.TimeLine = _TimeLine["default"];
var _Trace = _interopRequireDefault$1(TraceExports);
generatedIcons.Trace = _Trace["default"];
var _TraceIcons13Receipt = _interopRequireDefault$1(TraceIcons13ReceiptExports);
generatedIcons.TraceIcons13Receipt = _TraceIcons13Receipt["default"];
var _Transfer = _interopRequireDefault$1(TransferExports);
generatedIcons.Transfer = _Transfer["default"];
var _TransferLinkII = _interopRequireDefault$1(TransferLinkIIExports);
generatedIcons.TransferLinkII = _TransferLinkII["default"];
var _TransferPull = _interopRequireDefault$1(TransferPullExports);
generatedIcons.TransferPull = _TransferPull["default"];
var _TransferPush = _interopRequireDefault$1(TransferPushExports);
generatedIcons.TransferPush = _TransferPush["default"];
var _Trash = _interopRequireDefault$1(TrashExports);
generatedIcons.Trash = _Trash["default"];
var _TrashFill = _interopRequireDefault$1(TrashFillExports);
generatedIcons.TrashFill = _TrashFill["default"];
var _Truck = _interopRequireDefault$1(TruckExports);
generatedIcons.Truck = _Truck["default"];
var _TruckLoading = _interopRequireDefault$1(TruckLoadingExports);
generatedIcons.TruckLoading = _TruckLoading["default"];
var _TruckMoving = _interopRequireDefault$1(TruckMovingExports);
generatedIcons.TruckMoving = _TruckMoving["default"];
var _Upload = _interopRequireDefault$1(UploadExports);
generatedIcons.Upload = _Upload["default"];
var _Video = _interopRequireDefault$1(VideoExports);
generatedIcons.Video = _Video["default"];
var _ViewAttestations = _interopRequireDefault$1(ViewAttestationsExports);
generatedIcons.ViewAttestations = _ViewAttestations["default"];
var _WalletKeys = _interopRequireDefault$1(WalletKeysExports);
generatedIcons.WalletKeys = _WalletKeys["default"];
var _Warehouse = _interopRequireDefault$1(WarehouseExports);
generatedIcons.Warehouse = _Warehouse["default"];
var _Watching = _interopRequireDefault$1(WatchingExports);
generatedIcons.Watching = _Watching["default"];
var _WatchingFill = _interopRequireDefault$1(WatchingFillExports);
generatedIcons.WatchingFill = _WatchingFill["default"];
var _World = _interopRequireDefault$1(WorldExports);
generatedIcons.World = _World["default"];
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}
var supplychain = {};
var Additives = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21.79,10.26a6.86,6.86,0,1,0,6.85,6.86A6.87,6.87,0,0,0,21.79,10.26Zm0,12.42a5.56,5.56,0,1,1,5.55-5.56A5.57,5.57,0,0,1,21.79,22.68Z"
  }), /* @__PURE__ */ _react2["default"].createElement("polygon", {
    points: "22.44 13.83 21.14 13.83 21.14 16.47 18.5 16.47 18.5 17.77 21.14 17.77 21.14 20.41 22.44 20.41 22.44 17.77 25.07 17.77 25.07 16.47 22.44 16.47 22.44 13.83"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11.41,2.67h-6a2.05,2.05,0,1,0,0,4.1h.25V26.58a2.75,2.75,0,1,0,5.49,0V6.77h.26a2.05,2.05,0,1,0,0-4.1ZM8.41,28A1.45,1.45,0,0,1,7,26.58v-13H9.85v13A1.45,1.45,0,0,1,8.41,28ZM9.85,12.31H7V6.77H9.85Zm1.56-6.84h-6a.75.75,0,1,1,0-1.5h6a.75.75,0,1,1,0,1.5Z"
  })));
  module2.exports = exports.default;
})(Additives, Additives.exports);
var AdditivesExports = Additives.exports;
var Cooling = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M12.9,17.71,11,19.54V6.07H9.73V19.58L7.86,17.71l-.92.92,2.5,2.49a1.32,1.32,0,0,0,.94.39,1.34,1.34,0,0,0,.95-.39l2.49-2.49Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21,21.19V5.67a2.75,2.75,0,0,0-5.49,0V21.19a4.43,4.43,0,1,0,5.49,0Zm-2.74,6.58a3.12,3.12,0,0,1-1.74-5.71.65.65,0,0,0,.29-.54V5.67a1.45,1.45,0,0,1,2.89,0V21.52a.65.65,0,0,0,.29.54,3.12,3.12,0,0,1-1.73,5.71Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M18.87,22.52V18.19a.65.65,0,0,0-1.3,0v4.33a2.32,2.32,0,1,0,1.3,0Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "22.85",
    y: "4.84",
    width: "2.21",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "22.75",
    y: "8.33",
    width: "2.21",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "22.75",
    y: "11.82",
    width: "2.21",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "22.75",
    y: "15.3",
    width: "2.21",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "22.75",
    y: "18.79",
    width: "2.21",
    height: "1.3"
  })));
  module2.exports = exports.default;
})(Cooling, Cooling.exports);
var CoolingExports = Cooling.exports;
var Display = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M1.92,4.8a2,2,0,0,0-.11.64v4a1.91,1.91,0,0,0,1.9,1.9h4a1.91,1.91,0,0,0,1.9-1.9v-4A2,2,0,0,0,9.5,4.8a.64.64,0,0,0,.58-.63.66.66,0,0,0-.65-.65H2a.65.65,0,0,0-.65.65A.64.64,0,0,0,1.92,4.8ZM8.32,7H3.11V5.44a.6.6,0,0,1,.6-.6h4a.6.6,0,0,1,.6.6Zm-.6,3h-4a.6.6,0,0,1-.6-.6V8.34H8.32V9.46A.6.6,0,0,1,7.72,10.06Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M12.13,4.8a2,2,0,0,0-.12.64v4a1.91,1.91,0,0,0,1.9,1.9h4a1.91,1.91,0,0,0,1.9-1.9v-4a2,2,0,0,0-.12-.64.64.64,0,0,0,.57-.63.65.65,0,0,0-.65-.65H12.21a.65.65,0,0,0-.65.65A.63.63,0,0,0,12.13,4.8ZM18.53,7H13.31V5.44a.6.6,0,0,1,.6-.6h4a.6.6,0,0,1,.6.6Zm-.6,3h-4a.6.6,0,0,1-.6-.6V8.34h5.22V9.46A.6.6,0,0,1,17.93,10.06Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M22.34,4.8a2,2,0,0,0-.12.64v4a1.91,1.91,0,0,0,1.9,1.9h4A1.91,1.91,0,0,0,30,9.46v-4a2,2,0,0,0-.11-.64.63.63,0,0,0,.57-.63.65.65,0,0,0-.65-.65H22.42a.65.65,0,0,0-.65.65A.64.64,0,0,0,22.34,4.8ZM28.73,7H23.52V5.44a.6.6,0,0,1,.6-.6h4a.6.6,0,0,1,.6.6Zm-.6,3h-4a.6.6,0,0,1-.6-.6V8.34h5.21V9.46A.6.6,0,0,1,28.13,10.06Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "0.05",
    y: "12.74",
    width: "31.91",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M10.08,18.61A.66.66,0,0,0,9.43,18H2a.65.65,0,0,0-.07,1.29,1.69,1.69,0,0,0-.12.64v4a1.9,1.9,0,0,0,1.9,1.9h4a1.9,1.9,0,0,0,1.9-1.9v-4a1.91,1.91,0,0,0-.12-.64A.66.66,0,0,0,10.08,18.61ZM8.32,21.48H3.11V19.89a.6.6,0,0,1,.6-.6h4a.6.6,0,0,1,.6.6Zm-.6,3h-4a.6.6,0,0,1-.6-.6V22.78H8.32V23.9A.6.6,0,0,1,7.72,24.5Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M20.28,18.61a.65.65,0,0,0-.65-.65H12.21a.65.65,0,0,0-.08,1.29,1.91,1.91,0,0,0-.12.64v4a1.91,1.91,0,0,0,1.9,1.9h4a1.91,1.91,0,0,0,1.9-1.9v-4a1.91,1.91,0,0,0-.12-.64A.65.65,0,0,0,20.28,18.61Zm-1.75,2.87H13.31V19.89a.6.6,0,0,1,.6-.6h4a.6.6,0,0,1,.6.6Zm-.6,3h-4a.6.6,0,0,1-.6-.6V22.78h5.22V23.9A.6.6,0,0,1,17.93,24.5Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M30.49,18.61a.65.65,0,0,0-.65-.65H22.42a.65.65,0,0,0-.08,1.29,1.91,1.91,0,0,0-.12.64v4a1.9,1.9,0,0,0,1.9,1.9h4A1.9,1.9,0,0,0,30,23.9v-4a1.91,1.91,0,0,0-.11-.64A.65.65,0,0,0,30.49,18.61Zm-1.76,2.87H23.52V19.89a.6.6,0,0,1,.6-.6h4a.6.6,0,0,1,.6.6Zm-.6,3h-4a.6.6,0,0,1-.6-.6V22.78h5.21V23.9A.6.6,0,0,1,28.13,24.5Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "0.05",
    y: "27.18",
    width: "31.91",
    height: "1.3"
  })));
  module2.exports = exports.default;
})(Display, Display.exports);
var DisplayExports = Display.exports;
var Fermentation = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M24.22,8.13A2.54,2.54,0,0,0,22.09,4.2H9.91A2.54,2.54,0,0,0,7.78,8.13a2.71,2.71,0,0,0-2.15,2.54V25.15A2.8,2.8,0,0,0,8.55,27.8h14.9a2.8,2.8,0,0,0,2.92-2.65V10.67A2.71,2.71,0,0,0,24.22,8.13ZM9.91,5.5H22.09a1.25,1.25,0,0,1,0,2.49l-.18,0H10.08a.86.86,0,0,0-.17,0,1.25,1.25,0,0,1,0-2.49ZM8.55,9.32h14.9a1.51,1.51,0,0,1,1.62,1.35v9.15a2.32,2.32,0,0,1-1-.74,3,3,0,0,0-4.76,0,1.69,1.69,0,0,1-2.87,0,3,3,0,0,0-4.75,0,1.81,1.81,0,0,1-1.43.8,1.81,1.81,0,0,1-1.43-.8,3.23,3.23,0,0,0-1.92-1.16V10.67A1.51,1.51,0,0,1,8.55,9.32ZM23.45,26.5H8.55a1.51,1.51,0,0,1-1.62-1.35v-5.9a2.29,2.29,0,0,1,1,.73,3.06,3.06,0,0,0,2.37,1.2A3.08,3.08,0,0,0,12.66,20a1.84,1.84,0,0,1,1.43-.8,1.81,1.81,0,0,1,1.43.8,3,3,0,0,0,4.75,0,1.87,1.87,0,0,1,1.44-.8,1.84,1.84,0,0,1,1.44.8,3.24,3.24,0,0,0,1.92,1.17v4A1.51,1.51,0,0,1,23.45,26.5Z"
  })));
  module2.exports = exports.default;
})(Fermentation, Fermentation.exports);
var FermentationExports = Fermentation.exports;
var Heating = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M13.82,8.3,11.33,5.81a1.33,1.33,0,0,0-.94-.39h0a1.36,1.36,0,0,0-1,.39L6.94,8.3l.92.92L9.73,7.4V20.86H11V7.35L12.9,9.22Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M21,21.19V5.67a2.75,2.75,0,0,0-5.49,0V21.19a4.43,4.43,0,1,0,5.49,0Zm-2.74,6.58a3.12,3.12,0,0,1-1.74-5.71.65.65,0,0,0,.29-.54V5.67a1.45,1.45,0,0,1,2.89,0V21.52a.65.65,0,0,0,.29.54,3.12,3.12,0,0,1-1.73,5.71Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M18.87,22.52V6.19a.65.65,0,1,0-1.3,0V22.52a2.32,2.32,0,1,0,1.3,0Z"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "22.85",
    y: "4.84",
    width: "2.21",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "22.75",
    y: "8.33",
    width: "2.21",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "22.75",
    y: "11.82",
    width: "2.21",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "22.75",
    y: "15.3",
    width: "2.21",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "22.75",
    y: "18.79",
    width: "2.21",
    height: "1.3"
  })));
  module2.exports = exports.default;
})(Heating, Heating.exports);
var HeatingExports = Heating.exports;
var Homogenization = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.55,3.8a1.6,1.6,0,0,0-1.41-.88H5.86a1.6,1.6,0,0,0-1.41.88,1.82,1.82,0,0,0,0,1.64L10.28,19v9.42a.65.65,0,0,0,.65.65H21.07a.66.66,0,0,0,.66-.65V19L27.57,5.47A1.85,1.85,0,0,0,27.55,3.8ZM26.39,4.92,20.48,18.61a.58.58,0,0,0-.06.26v8.91H17a1.73,1.73,0,0,0,.14-.66c0-.72-.41-1.31-.91-1.31s-.92.59-.92,1.31a1.73,1.73,0,0,0,.14.66H11.58V18.87a.58.58,0,0,0-.06-.26L5.6,4.89a.51.51,0,0,1,0-.48.31.31,0,0,1,.26-.19H26.14a.31.31,0,0,1,.26.19A.54.54,0,0,1,26.39,4.92Z"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "10.4",
    cy: "7.23",
    r: "1.09"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "14.77",
    cy: "10.72",
    r: "1.09"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "17.09",
    cy: "6.58",
    r: "1.09"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "19.56",
    cy: "13.12",
    r: "1.09"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "21.75",
    cy: "9.63",
    r: "1.09"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "11.49",
    cy: "14.86",
    r: "1.09"
  }), /* @__PURE__ */ _react2["default"].createElement("circle", {
    cx: "15.86",
    cy: "16",
    r: "1.09"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M14.06,21.15c0-.73-.41-1.31-.92-1.31s-.91.58-.91,1.31.41,1.3.91,1.3S14.06,21.87,14.06,21.15Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16,18.29c-.51,0-.92.59-.92,1.31s.41,1.31.92,1.31.92-.59.92-1.31S16.51,18.29,16,18.29Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M16,21.93c-.51,0-.92.58-.92,1.3s.41,1.31.92,1.31.92-.58.92-1.31S16.51,21.93,16,21.93Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M18.47,19.6c-.51,0-.92.59-.92,1.31s.41,1.3.92,1.3.91-.58.91-1.3S19,19.6,18.47,19.6Z"
  }), /* @__PURE__ */ _react2["default"].createElement("ellipse", {
    cx: "18.47",
    cy: "24.54",
    rx: "0.92",
    ry: "1.31"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M13.68,23.79c-.51,0-.92.59-.92,1.31s.41,1.31.92,1.31.91-.59.91-1.31S14.18,23.79,13.68,23.79Z"
  })));
  module2.exports = exports.default;
})(Homogenization, Homogenization.exports);
var HomogenizationExports = Homogenization.exports;
var Incubation = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "20.76",
    y: "11.58",
    width: "2.83",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "20.64",
    y: "14.9",
    width: "2.83",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "20.65",
    y: "18.23",
    width: "2.83",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "20.65",
    y: "21.55",
    width: "2.83",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "20.65",
    y: "24.88",
    width: "2.83",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M23.36,9H8.64a2.78,2.78,0,0,0-2.89,2.65V26.12a2.78,2.78,0,0,0,2.89,2.65H23.36a2.78,2.78,0,0,0,2.89-2.65V11.64A2.78,2.78,0,0,0,23.36,9ZM25,26.12a1.49,1.49,0,0,1-1.59,1.35H8.64a1.49,1.49,0,0,1-1.59-1.35V11.64a1.49,1.49,0,0,1,1.59-1.35H23.36A1.49,1.49,0,0,1,25,11.64Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M7.35,7.7h17.3a.65.65,0,0,0,0-1.3h-8V4.53h2.12a.65.65,0,1,0,0-1.3H13.23a.65.65,0,0,0,0,1.3h2.12V6.4h-8a.65.65,0,0,0,0,1.3Z"
  })));
  module2.exports = exports.default;
})(Incubation, Incubation.exports);
var IncubationExports = Incubation.exports;
var LoadTruck = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M31.63,17.18a.68.68,0,0,0-.46-.19H27.85l-2.5-6.17a.65.65,0,0,0-.6-.41h-5V6.69A.65.65,0,0,0,19.12,6H3.79a.65.65,0,0,0-.65.65v5.19h1.3V7.34h14V22.47H13.12a2.83,2.83,0,0,0-5.51,0H3.79a.62.62,0,0,0-.35.1L1,24.17l.71,1.09L4,23.77H7.61a2.83,2.83,0,0,0,5.51,0h8.72a2.83,2.83,0,0,0,5.51,0h3.82a.65.65,0,0,0,.65-.65V17.64A.66.66,0,0,0,31.63,17.18ZM10.36,24.66a1.54,1.54,0,1,1,1.54-1.54A1.54,1.54,0,0,1,10.36,24.66Zm14.24,0a1.54,1.54,0,1,1,1.54-1.54A1.54,1.54,0,0,1,24.6,24.66Zm5.92-2.19H27.35a2.83,2.83,0,0,0-5.51,0H19.77V11.72h4.54l2.49,6.17a.65.65,0,0,0,.61.41h3.11Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M3.87,19.66l.92.92,2.49-2.49a1.31,1.31,0,0,0,.4-.95,1.32,1.32,0,0,0-.4-.95L4.79,13.7l-.92.92L5.7,16.49H.18v1.3H5.74Z"
  })));
  module2.exports = exports.default;
})(LoadTruck, LoadTruck.exports);
var LoadTruckExports = LoadTruck.exports;
var MilkCollection = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M22.58,10.06H9.42a2.65,2.65,0,0,0-2.65,2.65V27.18a2.66,2.66,0,0,0,2.65,2.66H22.58a2.66,2.66,0,0,0,2.65-2.66V12.71A2.65,2.65,0,0,0,22.58,10.06ZM9.42,11.36H22.58a1.35,1.35,0,0,1,1.35,1.35V24.4H8.07V12.71A1.35,1.35,0,0,1,9.42,11.36ZM22.58,28.53H9.42a1.35,1.35,0,0,1-1.35-1.35V25.7H23.93v1.48A1.35,1.35,0,0,1,22.58,28.53Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11.46,7.25h9.08a2.55,2.55,0,0,0,0-5.09H11.46a2.55,2.55,0,0,0,0,5.09Zm0-3.79h9.08a1.25,1.25,0,0,1,0,2.49H11.46a1.25,1.25,0,0,1,0-2.49Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M24.8,8H7.2a.65.65,0,1,0,0,1.3H24.8a.65.65,0,0,0,0-1.3Z"
  })));
  module2.exports = exports.default;
})(MilkCollection, MilkCollection.exports);
var MilkCollectionExports = MilkCollection.exports;
var Packaging = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "9.38",
    y: "16.74",
    width: "3.86",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("rect", {
    x: "14.8",
    y: "16.74",
    width: "7.81",
    height: "1.3"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.63,7.15a2.54,2.54,0,0,0-2.54-2.54H6.91a2.54,2.54,0,0,0-.86,4.93A2.73,2.73,0,0,0,6,10v14.7a2.65,2.65,0,0,0,2.65,2.65h14.7A2.65,2.65,0,0,0,26,24.74V10a2.73,2.73,0,0,0-.05-.5A2.55,2.55,0,0,0,27.63,7.15ZM24.7,10v2.88H7.3V10A1.36,1.36,0,0,1,8.65,8.69h14.7A1.36,1.36,0,0,1,24.7,10ZM7.3,14.22H24.7v6.35H7.3ZM23.35,26.09H8.65A1.35,1.35,0,0,1,7.3,24.74V21.87H24.7v2.87A1.35,1.35,0,0,1,23.35,26.09Zm2-17.75a2.63,2.63,0,0,0-2-1H8.65a2.67,2.67,0,0,0-2,1,1.23,1.23,0,0,1,.28-2.43H25.09a1.23,1.23,0,0,1,.27,2.43Z"
  })));
  module2.exports = exports.default;
})(Packaging, Packaging.exports);
var PackagingExports = Packaging.exports;
var Recall = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M31.07,16.13l-6.93-12a.65.65,0,0,0-.56-.33H9.73a.66.66,0,0,0-.57.33L2.85,15.07l-.73-2.82a.65.65,0,0,0-1.26.33L2,16.92a.65.65,0,0,0,.63.48.5.5,0,0,0,.17,0l4.33-1.12A.65.65,0,0,0,6.79,15L4,15.73,10.1,5.11H23.21l6.55,11.34L23.21,27.8H10.1L6.4,21.4a.65.65,0,1,0-1.12.65l3.88,6.73a.66.66,0,0,0,.57.33H23.58a.65.65,0,0,0,.56-.33l6.93-12A.63.63,0,0,0,31.07,16.13Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11.46,21.65a.62.62,0,0,0,.46.19.65.65,0,0,0,.46-.19l4.27-4.28,4.28,4.28a.65.65,0,0,0,.92,0,.66.66,0,0,0,0-.92l-4.28-4.28,4.28-4.27a.66.66,0,0,0,0-.92.64.64,0,0,0-.92,0l-4.28,4.27-4.27-4.27a.65.65,0,0,0-.92.92l4.27,4.27-4.27,4.28A.64.64,0,0,0,11.46,21.65Z"
  })));
  module2.exports = exports.default;
})(Recall, Recall.exports);
var RecallExports = Recall.exports;
var Sold = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M17.83,16.45A1.48,1.48,0,0,0,18.88,16l3-3-.92-.92-2.46,2.46V3.88h-1.3v10.7l-2.46-2.46L13.8,13l3,3A1.48,1.48,0,0,0,17.83,16.45Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M27.54,8.17H22.47v1.3h4.42V21.94H9.69L6.26,9.47h7V8.17H5.9L4.7,3.8l-1.26.35L8.57,22.77a.63.63,0,0,0,.62.47H27.54a.65.65,0,0,0,.65-.65V8.82A.65.65,0,0,0,27.54,8.17Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M11.53,24.82a1.65,1.65,0,1,0,1.65,1.65A1.65,1.65,0,0,0,11.53,24.82Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M26.28,24.82a1.65,1.65,0,1,0,1.65,1.65A1.65,1.65,0,0,0,26.28,24.82Z"
  }))));
  module2.exports = exports.default;
})(Sold, Sold.exports);
var SoldExports = Sold.exports;
var UnloadTruck = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _createSvgIcon = _interopRequireDefault2(createSvgIconExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  exports["default"] = (0, _createSvgIcon["default"])(/* @__PURE__ */ _react2["default"].createElement("g", null, /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M31.45,17.18A.66.66,0,0,0,31,17H27.67l-2.5-6.17a.63.63,0,0,0-.6-.41h-5V6.69A.65.65,0,0,0,19,6H3.62A.65.65,0,0,0,3,6.69v5.19h1.3V7.34h14V22.47H13a2.83,2.83,0,0,0-5.52,0H3.62a.65.65,0,0,0-.36.1L.82,24.17l.71,1.09,2.28-1.49H7.43a2.83,2.83,0,0,0,5.52,0h8.71a2.83,2.83,0,0,0,5.52,0H31a.65.65,0,0,0,.65-.65V17.64A.66.66,0,0,0,31.45,17.18ZM10.19,24.66a1.54,1.54,0,1,1,1.54-1.54A1.54,1.54,0,0,1,10.19,24.66Zm14.23,0A1.54,1.54,0,1,1,26,23.12,1.54,1.54,0,0,1,24.42,24.66Zm5.92-2.19H27.18a2.83,2.83,0,0,0-5.52,0H19.6V11.72h4.53l2.5,6.17a.65.65,0,0,0,.6.41h3.11Z"
  }), /* @__PURE__ */ _react2["default"].createElement("path", {
    d: "M4.16,19.66,2.33,17.79H7.85v-1.3H2.29l1.87-1.87-.92-.92L.75,16.19a1.35,1.35,0,0,0,0,1.9l2.49,2.49Z"
  })));
  module2.exports = exports.default;
})(UnloadTruck, UnloadTruck.exports);
var UnloadTruckExports = UnloadTruck.exports;
supplychain.__esModule = true;
supplychain.UnloadTruck = supplychain.Sold = supplychain.Recall = supplychain.Packaging = supplychain.MilkCollection = supplychain.LoadTruck = supplychain.Incubation = supplychain.Homogenization = supplychain.Heating = supplychain.Fermentation = supplychain.Display = supplychain.Cooling = supplychain.Additives = void 0;
var _Additives = _interopRequireDefault(AdditivesExports);
supplychain.Additives = _Additives["default"];
var _Cooling = _interopRequireDefault(CoolingExports);
supplychain.Cooling = _Cooling["default"];
var _Display = _interopRequireDefault(DisplayExports);
supplychain.Display = _Display["default"];
var _Fermentation = _interopRequireDefault(FermentationExports);
supplychain.Fermentation = _Fermentation["default"];
var _Heating = _interopRequireDefault(HeatingExports);
supplychain.Heating = _Heating["default"];
var _Homogenization = _interopRequireDefault(HomogenizationExports);
supplychain.Homogenization = _Homogenization["default"];
var _Incubation = _interopRequireDefault(IncubationExports);
supplychain.Incubation = _Incubation["default"];
var _LoadTruck = _interopRequireDefault(LoadTruckExports);
supplychain.LoadTruck = _LoadTruck["default"];
var _MilkCollection = _interopRequireDefault(MilkCollectionExports);
supplychain.MilkCollection = _MilkCollection["default"];
var _Packaging = _interopRequireDefault(PackagingExports);
supplychain.Packaging = _Packaging["default"];
var _Recall = _interopRequireDefault(RecallExports);
supplychain.Recall = _Recall["default"];
var _Sold = _interopRequireDefault(SoldExports);
supplychain.Sold = _Sold["default"];
var _UnloadTruck = _interopRequireDefault(UnloadTruckExports);
supplychain.UnloadTruck = _UnloadTruck["default"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}
(function(exports) {
  exports.__esModule = true;
  var _misc = misc;
  Object.keys(_misc).forEach(function(key2) {
    if (key2 === "default" || key2 === "__esModule") return;
    if (key2 in exports && exports[key2] === _misc[key2]) return;
    exports[key2] = _misc[key2];
  });
  var _mui = mui;
  Object.keys(_mui).forEach(function(key2) {
    if (key2 === "default" || key2 === "__esModule") return;
    if (key2 in exports && exports[key2] === _mui[key2]) return;
    exports[key2] = _mui[key2];
  });
  var _generatedIcons = generatedIcons;
  Object.keys(_generatedIcons).forEach(function(key2) {
    if (key2 === "default" || key2 === "__esModule") return;
    if (key2 in exports && exports[key2] === _generatedIcons[key2]) return;
    exports[key2] = _generatedIcons[key2];
  });
  var _supplychain = supplychain;
  Object.keys(_supplychain).forEach(function(key2) {
    if (key2 === "default" || key2 === "__esModule") return;
    if (key2 in exports && exports[key2] === _supplychain[key2]) return;
    exports[key2] = _supplychain[key2];
  });
})(lib$a);
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = void 0;
  var _react2 = _interopRequireDefault2(React__default);
  var _propTypes = _interopRequireDefault2(propTypesExports);
  var icons2 = _interopRequireWildcard(lib$a);
  var _excluded3 = ["icon"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
    var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache2(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return { "default": obj };
    }
    var cache2 = _getRequireWildcardCache(nodeInterop);
    if (cache2 && cache2.has(obj)) {
      return cache2.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key2 in obj) {
      if (key2 !== "default" && Object.prototype.hasOwnProperty.call(obj, key2)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key2) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key2, desc);
        } else {
          newObj[key2] = obj[key2];
        }
      }
    }
    newObj["default"] = obj;
    if (cache2) {
      cache2.set(obj, newObj);
    }
    return newObj;
  }
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _objectWithoutPropertiesLoose2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key2, i3;
    for (i3 = 0; i3 < sourceKeys.length; i3++) {
      key2 = sourceKeys[i3];
      if (excluded.indexOf(key2) >= 0) continue;
      target[key2] = source[key2];
    }
    return target;
  }
  var DynamicIcon2 = function DynamicIcon3(props2) {
    var icon2 = props2.icon, rest = _objectWithoutPropertiesLoose2(props2, _excluded3);
    var Icon2 = icons2[icon2] || icons2.Document;
    return /* @__PURE__ */ _react2["default"].createElement(Icon2, rest);
  };
  DynamicIcon2.propTypes = process$1$1.env.NODE_ENV !== "production" ? {
    icon: _propTypes["default"].string.isRequired
  } : {};
  exports["default"] = DynamicIcon2;
  module2.exports = exports.default;
})(DynamicIcon$1, DynamicIcon$1.exports);
var DynamicIconExports = DynamicIcon$1.exports;
const DynamicIcon = /* @__PURE__ */ getDefaultExportFromCjs$1(DynamicIconExports);
const styles$2F = (theme2) => ({
  root: {
    display: "flex",
    flexFlow: "row nowrap",
    alignItems: "center",
    gap: "5px",
    fontSize: 14,
    lineHeight: "17.75px",
    color: theme2.grey3
  },
  item: {
    textDecoration: "none",
    outline: "none",
    display: "flex",
    flexFlow: "row nowrap",
    gap: "7px",
    height: "18px",
    alignItems: "center",
    color: theme2.grey3,
    "&:hover": {
      color: theme2.grey2
    }
  },
  dynamicIcon: {
    height: ICON_SIZE,
    width: ICON_SIZE
  },
  label: {
    height: "16px"
  },
  isLastLink: {
    color: theme2.grey2
  },
  isNotClickable: {
    cursor: "default",
    pointerEvent: "none"
  }
});
const ICON_SIZE = 18;
const BreadCrumbs = ({
  classes,
  items: items2 = [],
  separatorIcon = "ArrowSimpleRight",
  linkComponent: Link2
}) => {
  const renderIcon = (iconName) => {
    if (icons && icons[iconName]) {
      return /* @__PURE__ */ jsx$1(Icon$2, { name: iconName, size: ICON_SIZE });
    }
    return /* @__PURE__ */ jsx$1(DynamicIcon, { icon: iconName, className: classes.dynamicIcon });
  };
  const renderLinkContent = (item) => {
    const { label, icon: icon2 } = item;
    return /* @__PURE__ */ jsxs(Fragment$1, { children: [
      icon2 && renderIcon(icon2),
      /* @__PURE__ */ jsx$1("p", { className: classes.label, children: label })
    ] });
  };
  return !items2.length ? null : /* @__PURE__ */ jsx$1("div", { className: classes.root, children: items2.map((item, index2) => {
    const isClickable = !!item.path;
    const computedClasses = classNames(classes.item, {
      [classes.isLastLink]: index2 === items2.length - 1
    });
    if (!item.icon && !item.label) return null;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      index2 > 0 && /* @__PURE__ */ jsx$1(Icon$2, { name: separatorIcon, size: ICON_SIZE }),
      isClickable ? /* @__PURE__ */ jsx$1(
        Link2,
        {
          to: item.path,
          className: computedClasses,
          draggable: "false",
          children: renderLinkContent(item)
        }
      ) : /* @__PURE__ */ jsx$1("span", { className: computedClasses, children: renderLinkContent(item) })
    ] }, index2);
  }) });
};
const index$9 = injectSheet(styles$2F)(memo(BreadCrumbs));
const styles$2E = (theme2) => ({
  root: {},
  title: {
    marginBottom: 7
  },
  description: {
    marginBottom: 7
  },
  items: {
    listStyle: "none",
    paddingLeft: 0,
    margin: 0,
    "&:not(:first-child)": {
      borderWidth: `1px 0 0 0`,
      borderStyle: `solid`,
      borderColor: theme2.grey6
    },
    "&:not(:last-child)": {
      marginBottom: 7
    }
  }
});
class Collection extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children, title: title2, description: description2, action } = this.props;
      return /* @__PURE__ */ jsxs("section", { className: classes.root, children: [
        title2 && /* @__PURE__ */ jsx$1("div", { className: classes.title, children: title2 }),
        description2 && /* @__PURE__ */ jsx$1("div", { className: classes.description, children: description2 }),
        /* @__PURE__ */ jsx$1("ul", { className: classes.items, children: Children$1.map(children, (child) => /* @__PURE__ */ jsx$1("li", { children: child })) }),
        action && /* @__PURE__ */ jsx$1("div", { className: classes.action, children: action })
      ] });
    });
  }
}
__publicField(Collection, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  title: PropTypes$1.node,
  description: PropTypes$1.node,
  action: PropTypes$1.node
});
__publicField(Collection, "defaultProps", {
  title: null,
  description: null,
  action: null
});
const Collection$1 = injectSheet(styles$2E)(Collection);
const styles$2D = (theme2) => ({
  root: {
    fontSize: 16,
    lineHeight: `20px`,
    fontWeight: 600,
    color: theme2.grey1,
    display: "flex",
    alignItems: "center"
  },
  suffix: {
    marginLeft: 7,
    flexShrink: 0
  }
});
class CollectionTitle extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children, suffix } = this.props;
      return /* @__PURE__ */ jsxs("div", { className: classes.root, children: [
        children,
        suffix && /* @__PURE__ */ jsx$1("span", { className: classes.suffix, children: suffix })
      ] });
    });
  }
}
__publicField(CollectionTitle, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.string.isRequired,
  suffix: PropTypes$1.node
});
__publicField(CollectionTitle, "defaultProps", {
  suffix: null
});
const CollectionTitle$1 = injectSheet(styles$2D)(CollectionTitle);
const styles$2C = (theme2) => ({
  root: {
    fontSize: 14,
    lineHeight: `21px`,
    fontWeight: 400,
    color: theme2.grey1
  }
});
class CollectionDescription extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children } = this.props;
      return /* @__PURE__ */ jsx$1("div", { className: classes.root, children });
    });
  }
}
__publicField(CollectionDescription, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.string.isRequired
});
const CollectionDescription$1 = injectSheet(styles$2C)(CollectionDescription);
const styles$2B = (theme2) => ({
  root: {
    borderWidth: `0 0 1px 0`,
    borderStyle: `solid`,
    borderColor: theme2.grey6,
    paddingTop: 7,
    '&[data-is-borderless="true"]': {
      border: "none"
    }
  },
  label: {
    fontSize: 10,
    fontWeight: 600,
    lineHeight: `24px`,
    color: theme2.grey4,
    textTransform: `uppercase`,
    letterSpacing: 1,
    overflow: `hidden`,
    whiteSpace: `nowrap`,
    textOverflow: `ellipsis`
  },
  content: {
    display: `flex`,
    alignItems: `center`,
    marginBottom: 10
  },
  value: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: `24px`,
    color: theme2.grey1,
    flexGrow: 1,
    flexShrink: 1,
    overflow: `hidden`,
    whiteSpace: `nowrap`,
    textOverflow: `ellipsis`,
    display: "flex",
    alignItems: "center",
    '&[data-is-idle="true"]': {
      color: theme2.grey4
    }
  },
  prefix: {
    marginRight: 7,
    flexShrink: 0
  },
  action: {
    flexShrink: 0,
    minHeight: 24,
    display: "flex",
    alignItems: "center"
  }
});
class CollectionItem extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const {
        classes,
        label,
        hideLabel,
        value,
        prefix: prefix2,
        idle,
        borderless,
        action
      } = this.props;
      return /* @__PURE__ */ jsxs("dl", { className: classes.root, "data-is-borderless": borderless, children: [
        /* @__PURE__ */ jsx$1("dt", { className: classes.label, children: /* @__PURE__ */ jsx$1(Invisible$1, { visible: !hideLabel, children: label }) }),
        /* @__PURE__ */ jsxs("dd", { className: classes.content, children: [
          /* @__PURE__ */ jsxs("div", { className: classes.value, "data-is-idle": idle, children: [
            prefix2 && /* @__PURE__ */ jsx$1("span", { className: classes.prefix, children: prefix2 }),
            value
          ] }),
          action && /* @__PURE__ */ jsx$1("div", { className: classes.action, children: action })
        ] })
      ] });
    });
  }
}
__publicField(CollectionItem, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  label: PropTypes$1.string.isRequired,
  hideLabel: PropTypes$1.bool,
  value: PropTypes$1.string.isRequired,
  prefix: PropTypes$1.node,
  idle: PropTypes$1.bool,
  borderless: PropTypes$1.bool,
  action: PropTypes$1.node
});
__publicField(CollectionItem, "defaultProps", {
  hideLabel: false,
  prefix: null,
  idle: false,
  borderless: false,
  action: null
});
const CollectionItem$1 = injectSheet(styles$2B)(CollectionItem);
const LINE_BREAK = "<br>";
const parseModalContent = (content) => {
  if (content.search(LINE_BREAK) === -1) return /* @__PURE__ */ jsx$1(Prose$1, { text: content });
  const contentListWithBreak = content.split(LINE_BREAK);
  return contentListWithBreak.map((text, index2) => /* @__PURE__ */ jsx$1(Prose$1, { text, breakAfter: true }, index2));
};
const styles$2A = (theme2) => ({
  modalContent: {
    "& strong": {
      color: theme2.indigo3
    }
  }
});
const DEFAULT_CONFIRM_BTN_LABEL = "confirm";
const ConfirmationModal = ({
  classes,
  title: title2,
  content,
  confirmBtnText = "",
  confirm,
  cancel,
  warning: warning2 = false
}) => {
  const proseContent = useMemo(() => parseModalContent(content), [content]);
  return /* @__PURE__ */ jsxs(Modal$1, { title: title2, closeButtonLabel: "Cancel", handleCollapse: cancel, children: [
    /* @__PURE__ */ jsx$1(ModalContent$1, { children: /* @__PURE__ */ jsx$1("div", { className: classes.modalContent, children: proseContent }) }),
    /* @__PURE__ */ jsx$1(
      ModalActions$1,
      {
        adverseAction: /* @__PURE__ */ jsx$1(Pushbutton$1, { onClick: cancel, dataCy: "cancel-button", children: "cancel" }),
        children: /* @__PURE__ */ jsx$1(
          Pushbutton$1,
          {
            warning: warning2,
            primary: !warning2,
            onClick: confirm,
            dataCy: "confirm-button",
            children: confirmBtnText || DEFAULT_CONFIRM_BTN_LABEL
          }
        )
      }
    )
  ] });
};
const index$8 = injectSheet(styles$2A)(memo(ConfirmationModal));
var reactIsExports$1 = requireReactIs();
function stylis_min(W2) {
  function M4(d4, c3, e5, h4, a4) {
    for (var m4 = 0, b3 = 0, v2 = 0, n2 = 0, q3, g2, x3 = 0, K3 = 0, k3, u3 = k3 = q3 = 0, l2 = 0, r2 = 0, I3 = 0, t3 = 0, B4 = e5.length, J2 = B4 - 1, y4, f2 = "", p2 = "", F3 = "", G4 = "", C2; l2 < B4; ) {
      g2 = e5.charCodeAt(l2);
      l2 === J2 && 0 !== b3 + n2 + v2 + m4 && (0 !== b3 && (g2 = 47 === b3 ? 10 : 47), n2 = v2 = m4 = 0, B4++, J2++);
      if (0 === b3 + n2 + v2 + m4) {
        if (l2 === J2 && (0 < r2 && (f2 = f2.replace(N2, "")), 0 < f2.trim().length)) {
          switch (g2) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              f2 += e5.charAt(l2);
          }
          g2 = 59;
        }
        switch (g2) {
          case 123:
            f2 = f2.trim();
            q3 = f2.charCodeAt(0);
            k3 = 1;
            for (t3 = ++l2; l2 < B4; ) {
              switch (g2 = e5.charCodeAt(l2)) {
                case 123:
                  k3++;
                  break;
                case 125:
                  k3--;
                  break;
                case 47:
                  switch (g2 = e5.charCodeAt(l2 + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u3 = l2 + 1; u3 < J2; ++u3) {
                          switch (e5.charCodeAt(u3)) {
                            case 47:
                              if (42 === g2 && 42 === e5.charCodeAt(u3 - 1) && l2 + 2 !== u3) {
                                l2 = u3 + 1;
                                break a;
                              }
                              break;
                            case 10:
                              if (47 === g2) {
                                l2 = u3 + 1;
                                break a;
                              }
                          }
                        }
                        l2 = u3;
                      }
                  }
                  break;
                case 91:
                  g2++;
                case 40:
                  g2++;
                case 34:
                case 39:
                  for (; l2++ < J2 && e5.charCodeAt(l2) !== g2; ) {
                  }
              }
              if (0 === k3) break;
              l2++;
            }
            k3 = e5.substring(t3, l2);
            0 === q3 && (q3 = (f2 = f2.replace(ca2, "").trim()).charCodeAt(0));
            switch (q3) {
              case 64:
                0 < r2 && (f2 = f2.replace(N2, ""));
                g2 = f2.charCodeAt(1);
                switch (g2) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r2 = c3;
                    break;
                  default:
                    r2 = O3;
                }
                k3 = M4(c3, r2, k3, g2, a4 + 1);
                t3 = k3.length;
                0 < A2 && (r2 = X3(O3, f2, I3), C2 = H4(3, k3, r2, c3, D3, z3, t3, g2, a4, h4), f2 = r2.join(""), void 0 !== C2 && 0 === (t3 = (k3 = C2.trim()).length) && (g2 = 0, k3 = ""));
                if (0 < t3) switch (g2) {
                  case 115:
                    f2 = f2.replace(da2, ea2);
                  case 100:
                  case 109:
                  case 45:
                    k3 = f2 + "{" + k3 + "}";
                    break;
                  case 107:
                    f2 = f2.replace(fa2, "$1 $2");
                    k3 = f2 + "{" + k3 + "}";
                    k3 = 1 === w3 || 2 === w3 && L3("@" + k3, 3) ? "@-webkit-" + k3 + "@" + k3 : "@" + k3;
                    break;
                  default:
                    k3 = f2 + k3, 112 === h4 && (k3 = (p2 += k3, ""));
                }
                else k3 = "";
                break;
              default:
                k3 = M4(c3, X3(c3, f2, I3), k3, h4, a4 + 1);
            }
            F3 += k3;
            k3 = I3 = r2 = u3 = q3 = 0;
            f2 = "";
            g2 = e5.charCodeAt(++l2);
            break;
          case 125:
          case 59:
            f2 = (0 < r2 ? f2.replace(N2, "") : f2).trim();
            if (1 < (t3 = f2.length)) switch (0 === u3 && (q3 = f2.charCodeAt(0), 45 === q3 || 96 < q3 && 123 > q3) && (t3 = (f2 = f2.replace(" ", ":")).length), 0 < A2 && void 0 !== (C2 = H4(1, f2, c3, d4, D3, z3, p2.length, h4, a4, h4)) && 0 === (t3 = (f2 = C2.trim()).length) && (f2 = "\0\0"), q3 = f2.charCodeAt(0), g2 = f2.charCodeAt(1), q3) {
              case 0:
                break;
              case 64:
                if (105 === g2 || 99 === g2) {
                  G4 += f2 + e5.charAt(l2);
                  break;
                }
              default:
                58 !== f2.charCodeAt(t3 - 1) && (p2 += P2(f2, q3, g2, f2.charCodeAt(2)));
            }
            I3 = r2 = u3 = q3 = 0;
            f2 = "";
            g2 = e5.charCodeAt(++l2);
        }
      }
      switch (g2) {
        case 13:
        case 10:
          47 === b3 ? b3 = 0 : 0 === 1 + q3 && 107 !== h4 && 0 < f2.length && (r2 = 1, f2 += "\0");
          0 < A2 * Y3 && H4(0, f2, c3, d4, D3, z3, p2.length, h4, a4, h4);
          z3 = 1;
          D3++;
          break;
        case 59:
        case 125:
          if (0 === b3 + n2 + v2 + m4) {
            z3++;
            break;
          }
        default:
          z3++;
          y4 = e5.charAt(l2);
          switch (g2) {
            case 9:
            case 32:
              if (0 === n2 + m4 + b3) switch (x3) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y4 = "";
                  break;
                default:
                  32 !== g2 && (y4 = " ");
              }
              break;
            case 0:
              y4 = "\\0";
              break;
            case 12:
              y4 = "\\f";
              break;
            case 11:
              y4 = "\\v";
              break;
            case 38:
              0 === n2 + b3 + m4 && (r2 = I3 = 1, y4 = "\f" + y4);
              break;
            case 108:
              if (0 === n2 + b3 + m4 + E3 && 0 < u3) switch (l2 - u3) {
                case 2:
                  112 === x3 && 58 === e5.charCodeAt(l2 - 3) && (E3 = x3);
                case 8:
                  111 === K3 && (E3 = K3);
              }
              break;
            case 58:
              0 === n2 + b3 + m4 && (u3 = l2);
              break;
            case 44:
              0 === b3 + v2 + n2 + m4 && (r2 = 1, y4 += "\r");
              break;
            case 34:
            case 39:
              0 === b3 && (n2 = n2 === g2 ? 0 : 0 === n2 ? g2 : n2);
              break;
            case 91:
              0 === n2 + b3 + v2 && m4++;
              break;
            case 93:
              0 === n2 + b3 + v2 && m4--;
              break;
            case 41:
              0 === n2 + b3 + m4 && v2--;
              break;
            case 40:
              if (0 === n2 + b3 + m4) {
                if (0 === q3) switch (2 * x3 + 3 * K3) {
                  case 533:
                    break;
                  default:
                    q3 = 1;
                }
                v2++;
              }
              break;
            case 64:
              0 === b3 + v2 + n2 + m4 + u3 + k3 && (k3 = 1);
              break;
            case 42:
            case 47:
              if (!(0 < n2 + m4 + v2)) switch (b3) {
                case 0:
                  switch (2 * g2 + 3 * e5.charCodeAt(l2 + 1)) {
                    case 235:
                      b3 = 47;
                      break;
                    case 220:
                      t3 = l2, b3 = 42;
                  }
                  break;
                case 42:
                  47 === g2 && 42 === x3 && t3 + 2 !== l2 && (33 === e5.charCodeAt(t3 + 2) && (p2 += e5.substring(t3, l2 + 1)), y4 = "", b3 = 0);
              }
          }
          0 === b3 && (f2 += y4);
      }
      K3 = x3;
      x3 = g2;
      l2++;
    }
    t3 = p2.length;
    if (0 < t3) {
      r2 = c3;
      if (0 < A2 && (C2 = H4(2, p2, r2, d4, D3, z3, t3, h4, a4, h4), void 0 !== C2 && 0 === (p2 = C2).length)) return G4 + p2 + F3;
      p2 = r2.join(",") + "{" + p2 + "}";
      if (0 !== w3 * E3) {
        2 !== w3 || L3(p2, 2) || (E3 = 0);
        switch (E3) {
          case 111:
            p2 = p2.replace(ha2, ":-moz-$1") + p2;
            break;
          case 112:
            p2 = p2.replace(Q3, "::-webkit-input-$1") + p2.replace(Q3, "::-moz-$1") + p2.replace(Q3, ":-ms-input-$1") + p2;
        }
        E3 = 0;
      }
    }
    return G4 + p2 + F3;
  }
  function X3(d4, c3, e5) {
    var h4 = c3.trim().split(ia2);
    c3 = h4;
    var a4 = h4.length, m4 = d4.length;
    switch (m4) {
      case 0:
      case 1:
        var b3 = 0;
        for (d4 = 0 === m4 ? "" : d4[0] + " "; b3 < a4; ++b3) {
          c3[b3] = Z2(d4, c3[b3], e5).trim();
        }
        break;
      default:
        var v2 = b3 = 0;
        for (c3 = []; b3 < a4; ++b3) {
          for (var n2 = 0; n2 < m4; ++n2) {
            c3[v2++] = Z2(d4[n2] + " ", h4[b3], e5).trim();
          }
        }
    }
    return c3;
  }
  function Z2(d4, c3, e5) {
    var h4 = c3.charCodeAt(0);
    33 > h4 && (h4 = (c3 = c3.trim()).charCodeAt(0));
    switch (h4) {
      case 38:
        return c3.replace(F2, "$1" + d4.trim());
      case 58:
        return d4.trim() + c3.replace(F2, "$1" + d4.trim());
      default:
        if (0 < 1 * e5 && 0 < c3.indexOf("\f")) return c3.replace(F2, (58 === d4.charCodeAt(0) ? "" : "$1") + d4.trim());
    }
    return d4 + c3;
  }
  function P2(d4, c3, e5, h4) {
    var a4 = d4 + ";", m4 = 2 * c3 + 3 * e5 + 4 * h4;
    if (944 === m4) {
      d4 = a4.indexOf(":", 9) + 1;
      var b3 = a4.substring(d4, a4.length - 1).trim();
      b3 = a4.substring(0, d4).trim() + b3 + ";";
      return 1 === w3 || 2 === w3 && L3(b3, 1) ? "-webkit-" + b3 + b3 : b3;
    }
    if (0 === w3 || 2 === w3 && !L3(a4, 1)) return a4;
    switch (m4) {
      case 1015:
        return 97 === a4.charCodeAt(10) ? "-webkit-" + a4 + a4 : a4;
      case 951:
        return 116 === a4.charCodeAt(3) ? "-webkit-" + a4 + a4 : a4;
      case 963:
        return 110 === a4.charCodeAt(5) ? "-webkit-" + a4 + a4 : a4;
      case 1009:
        if (100 !== a4.charCodeAt(4)) break;
      case 969:
      case 942:
        return "-webkit-" + a4 + a4;
      case 978:
        return "-webkit-" + a4 + "-moz-" + a4 + a4;
      case 1019:
      case 983:
        return "-webkit-" + a4 + "-moz-" + a4 + "-ms-" + a4 + a4;
      case 883:
        if (45 === a4.charCodeAt(8)) return "-webkit-" + a4 + a4;
        if (0 < a4.indexOf("image-set(", 11)) return a4.replace(ja2, "$1-webkit-$2") + a4;
        break;
      case 932:
        if (45 === a4.charCodeAt(4)) switch (a4.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + a4.replace("-grow", "") + "-webkit-" + a4 + "-ms-" + a4.replace("grow", "positive") + a4;
          case 115:
            return "-webkit-" + a4 + "-ms-" + a4.replace("shrink", "negative") + a4;
          case 98:
            return "-webkit-" + a4 + "-ms-" + a4.replace("basis", "preferred-size") + a4;
        }
        return "-webkit-" + a4 + "-ms-" + a4 + a4;
      case 964:
        return "-webkit-" + a4 + "-ms-flex-" + a4 + a4;
      case 1023:
        if (99 !== a4.charCodeAt(8)) break;
        b3 = a4.substring(a4.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
        return "-webkit-box-pack" + b3 + "-webkit-" + a4 + "-ms-flex-pack" + b3 + a4;
      case 1005:
        return ka2.test(a4) ? a4.replace(aa2, ":-webkit-") + a4.replace(aa2, ":-moz-") + a4 : a4;
      case 1e3:
        b3 = a4.substring(13).trim();
        c3 = b3.indexOf("-") + 1;
        switch (b3.charCodeAt(0) + b3.charCodeAt(c3)) {
          case 226:
            b3 = a4.replace(G3, "tb");
            break;
          case 232:
            b3 = a4.replace(G3, "tb-rl");
            break;
          case 220:
            b3 = a4.replace(G3, "lr");
            break;
          default:
            return a4;
        }
        return "-webkit-" + a4 + "-ms-" + b3 + a4;
      case 1017:
        if (-1 === a4.indexOf("sticky", 9)) break;
      case 975:
        c3 = (a4 = d4).length - 10;
        b3 = (33 === a4.charCodeAt(c3) ? a4.substring(0, c3) : a4).substring(d4.indexOf(":", 7) + 1).trim();
        switch (m4 = b3.charCodeAt(0) + (b3.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b3.charCodeAt(8)) break;
          case 115:
            a4 = a4.replace(b3, "-webkit-" + b3) + ";" + a4;
            break;
          case 207:
          case 102:
            a4 = a4.replace(b3, "-webkit-" + (102 < m4 ? "inline-" : "") + "box") + ";" + a4.replace(b3, "-webkit-" + b3) + ";" + a4.replace(b3, "-ms-" + b3 + "box") + ";" + a4;
        }
        return a4 + ";";
      case 938:
        if (45 === a4.charCodeAt(5)) switch (a4.charCodeAt(6)) {
          case 105:
            return b3 = a4.replace("-items", ""), "-webkit-" + a4 + "-webkit-box-" + b3 + "-ms-flex-" + b3 + a4;
          case 115:
            return "-webkit-" + a4 + "-ms-flex-item-" + a4.replace(ba2, "") + a4;
          default:
            return "-webkit-" + a4 + "-ms-flex-line-pack" + a4.replace("align-content", "").replace(ba2, "") + a4;
        }
        break;
      case 973:
      case 989:
        if (45 !== a4.charCodeAt(3) || 122 === a4.charCodeAt(4)) break;
      case 931:
      case 953:
        if (true === la2.test(d4)) return 115 === (b3 = d4.substring(d4.indexOf(":") + 1)).charCodeAt(0) ? P2(d4.replace("stretch", "fill-available"), c3, e5, h4).replace(":fill-available", ":stretch") : a4.replace(b3, "-webkit-" + b3) + a4.replace(b3, "-moz-" + b3.replace("fill-", "")) + a4;
        break;
      case 962:
        if (a4 = "-webkit-" + a4 + (102 === a4.charCodeAt(5) ? "-ms-" + a4 : "") + a4, 211 === e5 + h4 && 105 === a4.charCodeAt(13) && 0 < a4.indexOf("transform", 10)) return a4.substring(0, a4.indexOf(";", 27) + 1).replace(ma2, "$1-webkit-$2") + a4;
    }
    return a4;
  }
  function L3(d4, c3) {
    var e5 = d4.indexOf(1 === c3 ? ":" : "{"), h4 = d4.substring(0, 3 !== c3 ? e5 : 10);
    e5 = d4.substring(e5 + 1, d4.length - 1);
    return R3(2 !== c3 ? h4 : h4.replace(na2, "$1"), e5, c3);
  }
  function ea2(d4, c3) {
    var e5 = P2(c3, c3.charCodeAt(0), c3.charCodeAt(1), c3.charCodeAt(2));
    return e5 !== c3 + ";" ? e5.replace(oa2, " or ($1)").substring(4) : "(" + c3 + ")";
  }
  function H4(d4, c3, e5, h4, a4, m4, b3, v2, n2, q3) {
    for (var g2 = 0, x3 = c3, w4; g2 < A2; ++g2) {
      switch (w4 = S4[g2].call(B3, d4, x3, e5, h4, a4, m4, b3, v2, n2, q3)) {
        case void 0:
        case false:
        case true:
        case null:
          break;
        default:
          x3 = w4;
      }
    }
    if (x3 !== c3) return x3;
  }
  function T3(d4) {
    switch (d4) {
      case void 0:
      case null:
        A2 = S4.length = 0;
        break;
      default:
        if ("function" === typeof d4) S4[A2++] = d4;
        else if ("object" === typeof d4) for (var c3 = 0, e5 = d4.length; c3 < e5; ++c3) {
          T3(d4[c3]);
        }
        else Y3 = !!d4 | 0;
    }
    return T3;
  }
  function U2(d4) {
    d4 = d4.prefix;
    void 0 !== d4 && (R3 = null, d4 ? "function" !== typeof d4 ? w3 = 1 : (w3 = 2, R3 = d4) : w3 = 0);
    return U2;
  }
  function B3(d4, c3) {
    var e5 = d4;
    33 > e5.charCodeAt(0) && (e5 = e5.trim());
    V2 = e5;
    e5 = [V2];
    if (0 < A2) {
      var h4 = H4(-1, c3, e5, e5, D3, z3, 0, 0, 0, 0);
      void 0 !== h4 && "string" === typeof h4 && (c3 = h4);
    }
    var a4 = M4(O3, e5, c3, 0, 0);
    0 < A2 && (h4 = H4(-2, a4, e5, e5, D3, z3, a4.length, 0, 0, 0), void 0 !== h4 && (a4 = h4));
    V2 = "";
    E3 = 0;
    z3 = D3 = 1;
    return a4;
  }
  var ca2 = /^\0+/g, N2 = /[\0\r\f]/g, aa2 = /: */g, ka2 = /zoo|gra/, ma2 = /([,: ])(transform)/g, ia2 = /,\r+?/g, F2 = /([\t\r\n ])*\f?&/g, fa2 = /@(k\w+)\s*(\S*)\s*/, Q3 = /::(place)/g, ha2 = /:(read-only)/g, G3 = /[svh]\w+-[tblr]{2}/, da2 = /\(\s*(.*)\s*\)/g, oa2 = /([\s\S]*?);/g, ba2 = /-self|flex-/g, na2 = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la2 = /stretch|:\s*\w+\-(?:conte|avail)/, ja2 = /([^-])(image-set\()/, z3 = 1, D3 = 1, E3 = 0, w3 = 1, O3 = [], S4 = [], A2 = 0, R3 = null, Y3 = 0, V2 = "";
  B3.use = T3;
  B3.set = U2;
  void 0 !== W2 && U2(W2);
  return B3;
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function memoize$2(fn2) {
  var cache2 = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache2[arg] === void 0) cache2[arg] = fn2(arg);
    return cache2[arg];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid = /* @__PURE__ */ memoize$2(
  function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
var reactIs$1 = requireReactIs();
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$1.Memo] = MEMO_STATICS;
function getStatics(component) {
  if (reactIs$1.isMemo(component)) {
    return MEMO_STATICS;
  }
  return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty$7 = Object.defineProperty;
var getOwnPropertyNames4 = Object.getOwnPropertyNames;
var getOwnPropertySymbols3 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor3 = Object.getOwnPropertyDescriptor;
var getPrototypeOf$1 = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== "string") {
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf$1(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys4 = getOwnPropertyNames4(sourceComponent);
    if (getOwnPropertySymbols3) {
      keys4 = keys4.concat(getOwnPropertySymbols3(sourceComponent));
    }
    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);
    for (var i3 = 0; i3 < keys4.length; ++i3) {
      var key2 = keys4[i3];
      if (!KNOWN_STATICS[key2] && !(blacklist && blacklist[key2]) && !(sourceStatics && sourceStatics[key2]) && !(targetStatics && targetStatics[key2])) {
        var descriptor2 = getOwnPropertyDescriptor3(sourceComponent, key2);
        try {
          defineProperty$7(targetComponent, key2, descriptor2);
        } catch (e5) {
        }
      }
    }
  }
  return targetComponent;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;
const m$2 = /* @__PURE__ */ getDefaultExportFromCjs$1(hoistNonReactStatics_cjs);
function y$2() {
  return (y$2 = Object.assign || function(e5) {
    for (var t3 = 1; t3 < arguments.length; t3++) {
      var n2 = arguments[t3];
      for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e5[r2] = n2[r2]);
    }
    return e5;
  }).apply(this, arguments);
}
var v$2 = function(e5, t3) {
  for (var n2 = [e5[0]], r2 = 0, o2 = t3.length; r2 < o2; r2 += 1) n2.push(t3[r2], e5[r2 + 1]);
  return n2;
}, g$2 = function(t3) {
  return null !== t3 && "object" == typeof t3 && "[object Object]" === (t3.toString ? t3.toString() : Object.prototype.toString.call(t3)) && !reactIsExports$1.typeOf(t3);
}, S$2 = Object.freeze([]), w$2 = Object.freeze({});
function E$2(e5) {
  return "function" == typeof e5;
}
function b$2(e5) {
  return "production" !== process$1$1.env.NODE_ENV && "string" == typeof e5 && e5 || e5.displayName || e5.name || "Component";
}
function _$2(e5) {
  return e5 && "string" == typeof e5.styledComponentId;
}
var N$2 = "undefined" != typeof process$1$1 && void 0 !== process$1$1.env && (process$1$1.env.REACT_APP_SC_ATTR || process$1$1.env.SC_ATTR) || "data-styled", C$2 = "undefined" != typeof window && "HTMLElement" in window, I$2 = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process$1$1 && void 0 !== process$1$1.env && (void 0 !== process$1$1.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== process$1$1.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== process$1$1.env.REACT_APP_SC_DISABLE_SPEEDY && process$1$1.env.REACT_APP_SC_DISABLE_SPEEDY : void 0 !== process$1$1.env.SC_DISABLE_SPEEDY && "" !== process$1$1.env.SC_DISABLE_SPEEDY ? "false" !== process$1$1.env.SC_DISABLE_SPEEDY && process$1$1.env.SC_DISABLE_SPEEDY : "production" !== process$1$1.env.NODE_ENV)), O$2 = "production" !== process$1$1.env.NODE_ENV ? { 1: "Cannot create styled-component for component: %s.\n\n", 2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n", 3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n", 4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n", 5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n", 6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n", 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: 'ThemeProvider: Please make your "theme" prop an object.\n\n', 9: "Missing document `<head>`\n\n", 10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n", 11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n", 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n", 14: 'ThemeProvider: "theme" prop is required.\n\n', 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n", 17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n" } : {};
function R$2() {
  for (var e5 = arguments.length <= 0 ? void 0 : arguments[0], t3 = [], n2 = 1, r2 = arguments.length; n2 < r2; n2 += 1) t3.push(n2 < 0 || arguments.length <= n2 ? void 0 : arguments[n2]);
  return t3.forEach(function(t4) {
    e5 = e5.replace(/%[a-z]/, t4);
  }), e5;
}
function D$2(e5) {
  for (var t3 = arguments.length, n2 = new Array(t3 > 1 ? t3 - 1 : 0), r2 = 1; r2 < t3; r2++) n2[r2 - 1] = arguments[r2];
  throw "production" === process$1$1.env.NODE_ENV ? new Error("An error occurred. See https://git.io/JUIaE#" + e5 + " for more information." + (n2.length > 0 ? " Args: " + n2.join(", ") : "")) : new Error(R$2.apply(void 0, [O$2[e5]].concat(n2)).trim());
}
var j$2 = function() {
  function e5(e6) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e6;
  }
  var t3 = e5.prototype;
  return t3.indexOfGroup = function(e6) {
    for (var t4 = 0, n2 = 0; n2 < e6; n2++) t4 += this.groupSizes[n2];
    return t4;
  }, t3.insertRules = function(e6, t4) {
    if (e6 >= this.groupSizes.length) {
      for (var n2 = this.groupSizes, r2 = n2.length, o2 = r2; e6 >= o2; ) (o2 <<= 1) < 0 && D$2(16, "" + e6);
      this.groupSizes = new Uint32Array(o2), this.groupSizes.set(n2), this.length = o2;
      for (var s4 = r2; s4 < o2; s4++) this.groupSizes[s4] = 0;
    }
    for (var i3 = this.indexOfGroup(e6 + 1), a4 = 0, c3 = t4.length; a4 < c3; a4++) this.tag.insertRule(i3, t4[a4]) && (this.groupSizes[e6]++, i3++);
  }, t3.clearGroup = function(e6) {
    if (e6 < this.length) {
      var t4 = this.groupSizes[e6], n2 = this.indexOfGroup(e6), r2 = n2 + t4;
      this.groupSizes[e6] = 0;
      for (var o2 = n2; o2 < r2; o2++) this.tag.deleteRule(n2);
    }
  }, t3.getGroup = function(e6) {
    var t4 = "";
    if (e6 >= this.length || 0 === this.groupSizes[e6]) return t4;
    for (var n2 = this.groupSizes[e6], r2 = this.indexOfGroup(e6), o2 = r2 + n2, s4 = r2; s4 < o2; s4++) t4 += this.tag.getRule(s4) + "/*!sc*/\n";
    return t4;
  }, e5;
}(), T$2 = /* @__PURE__ */ new Map(), x$2 = /* @__PURE__ */ new Map(), k$2 = 1, V$2 = function(e5) {
  if (T$2.has(e5)) return T$2.get(e5);
  for (; x$2.has(k$2); ) k$2++;
  var t3 = k$2++;
  return "production" !== process$1$1.env.NODE_ENV && ((0 | t3) < 0 || t3 > 1 << 30) && D$2(16, "" + t3), T$2.set(e5, t3), x$2.set(t3, e5), t3;
}, B$2 = function(e5) {
  return x$2.get(e5);
}, z$2 = function(e5, t3) {
  t3 >= k$2 && (k$2 = t3 + 1), T$2.set(e5, t3), x$2.set(t3, e5);
}, M$2 = "style[" + N$2 + '][data-styled-version="5.3.11"]', G$2 = new RegExp("^" + N$2 + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), L$2 = function(e5, t3, n2) {
  for (var r2, o2 = n2.split(","), s4 = 0, i3 = o2.length; s4 < i3; s4++) (r2 = o2[s4]) && e5.registerName(t3, r2);
}, F$2 = function(e5, t3) {
  for (var n2 = (t3.textContent || "").split("/*!sc*/\n"), r2 = [], o2 = 0, s4 = n2.length; o2 < s4; o2++) {
    var i3 = n2[o2].trim();
    if (i3) {
      var a4 = i3.match(G$2);
      if (a4) {
        var c3 = 0 | parseInt(a4[1], 10), u3 = a4[2];
        0 !== c3 && (z$2(u3, c3), L$2(e5, u3, a4[3]), e5.getTag().insertRules(c3, r2)), r2.length = 0;
      } else r2.push(i3);
    }
  }
}, Y$2 = function() {
  return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, q$2 = function(e5) {
  var t3 = document.head, n2 = e5 || t3, r2 = document.createElement("style"), o2 = function(e6) {
    for (var t4 = e6.childNodes, n3 = t4.length; n3 >= 0; n3--) {
      var r3 = t4[n3];
      if (r3 && 1 === r3.nodeType && r3.hasAttribute(N$2)) return r3;
    }
  }(n2), s4 = void 0 !== o2 ? o2.nextSibling : null;
  r2.setAttribute(N$2, "active"), r2.setAttribute("data-styled-version", "5.3.11");
  var i3 = Y$2();
  return i3 && r2.setAttribute("nonce", i3), n2.insertBefore(r2, s4), r2;
}, H$2 = function() {
  function e5(e6) {
    var t4 = this.element = q$2(e6);
    t4.appendChild(document.createTextNode("")), this.sheet = function(e7) {
      if (e7.sheet) return e7.sheet;
      for (var t5 = document.styleSheets, n2 = 0, r2 = t5.length; n2 < r2; n2++) {
        var o2 = t5[n2];
        if (o2.ownerNode === e7) return o2;
      }
      D$2(17);
    }(t4), this.length = 0;
  }
  var t3 = e5.prototype;
  return t3.insertRule = function(e6, t4) {
    try {
      return this.sheet.insertRule(t4, e6), this.length++, true;
    } catch (e7) {
      return false;
    }
  }, t3.deleteRule = function(e6) {
    this.sheet.deleteRule(e6), this.length--;
  }, t3.getRule = function(e6) {
    var t4 = this.sheet.cssRules[e6];
    return void 0 !== t4 && "string" == typeof t4.cssText ? t4.cssText : "";
  }, e5;
}(), $$2 = function() {
  function e5(e6) {
    var t4 = this.element = q$2(e6);
    this.nodes = t4.childNodes, this.length = 0;
  }
  var t3 = e5.prototype;
  return t3.insertRule = function(e6, t4) {
    if (e6 <= this.length && e6 >= 0) {
      var n2 = document.createTextNode(t4), r2 = this.nodes[e6];
      return this.element.insertBefore(n2, r2 || null), this.length++, true;
    }
    return false;
  }, t3.deleteRule = function(e6) {
    this.element.removeChild(this.nodes[e6]), this.length--;
  }, t3.getRule = function(e6) {
    return e6 < this.length ? this.nodes[e6].textContent : "";
  }, e5;
}(), W$2 = function() {
  function e5(e6) {
    this.rules = [], this.length = 0;
  }
  var t3 = e5.prototype;
  return t3.insertRule = function(e6, t4) {
    return e6 <= this.length && (this.rules.splice(e6, 0, t4), this.length++, true);
  }, t3.deleteRule = function(e6) {
    this.rules.splice(e6, 1), this.length--;
  }, t3.getRule = function(e6) {
    return e6 < this.length ? this.rules[e6] : "";
  }, e5;
}(), U$2 = C$2, J$2 = { isServer: !C$2, useCSSOMInjection: !I$2 }, X$2 = function() {
  function e5(e6, t4, n2) {
    void 0 === e6 && (e6 = w$2), void 0 === t4 && (t4 = {}), this.options = y$2({}, J$2, {}, e6), this.gs = t4, this.names = new Map(n2), this.server = !!e6.isServer, !this.server && C$2 && U$2 && (U$2 = false, function(e7) {
      for (var t5 = document.querySelectorAll(M$2), n3 = 0, r2 = t5.length; n3 < r2; n3++) {
        var o2 = t5[n3];
        o2 && "active" !== o2.getAttribute(N$2) && (F$2(e7, o2), o2.parentNode && o2.parentNode.removeChild(o2));
      }
    }(this));
  }
  e5.registerId = function(e6) {
    return V$2(e6);
  };
  var t3 = e5.prototype;
  return t3.reconstructWithOptions = function(t4, n2) {
    return void 0 === n2 && (n2 = true), new e5(y$2({}, this.options, {}, t4), this.gs, n2 && this.names || void 0);
  }, t3.allocateGSInstance = function(e6) {
    return this.gs[e6] = (this.gs[e6] || 0) + 1;
  }, t3.getTag = function() {
    return this.tag || (this.tag = (n2 = (t4 = this.options).isServer, r2 = t4.useCSSOMInjection, o2 = t4.target, e6 = n2 ? new W$2(o2) : r2 ? new H$2(o2) : new $$2(o2), new j$2(e6)));
    var e6, t4, n2, r2, o2;
  }, t3.hasNameForId = function(e6, t4) {
    return this.names.has(e6) && this.names.get(e6).has(t4);
  }, t3.registerName = function(e6, t4) {
    if (V$2(e6), this.names.has(e6)) this.names.get(e6).add(t4);
    else {
      var n2 = /* @__PURE__ */ new Set();
      n2.add(t4), this.names.set(e6, n2);
    }
  }, t3.insertRules = function(e6, t4, n2) {
    this.registerName(e6, t4), this.getTag().insertRules(V$2(e6), n2);
  }, t3.clearNames = function(e6) {
    this.names.has(e6) && this.names.get(e6).clear();
  }, t3.clearRules = function(e6) {
    this.getTag().clearGroup(V$2(e6)), this.clearNames(e6);
  }, t3.clearTag = function() {
    this.tag = void 0;
  }, t3.toString = function() {
    return function(e6) {
      for (var t4 = e6.getTag(), n2 = t4.length, r2 = "", o2 = 0; o2 < n2; o2++) {
        var s4 = B$2(o2);
        if (void 0 !== s4) {
          var i3 = e6.names.get(s4), a4 = t4.getGroup(o2);
          if (i3 && a4 && i3.size) {
            var c3 = N$2 + ".g" + o2 + '[id="' + s4 + '"]', u3 = "";
            void 0 !== i3 && i3.forEach(function(e7) {
              e7.length > 0 && (u3 += e7 + ",");
            }), r2 += "" + a4 + c3 + '{content:"' + u3 + '"}/*!sc*/\n';
          }
        }
      }
      return r2;
    }(this);
  }, e5;
}(), Z$2 = /(a)(d)/gi, K$2 = function(e5) {
  return String.fromCharCode(e5 + (e5 > 25 ? 39 : 97));
};
function Q$2(e5) {
  var t3, n2 = "";
  for (t3 = Math.abs(e5); t3 > 52; t3 = t3 / 52 | 0) n2 = K$2(t3 % 52) + n2;
  return (K$2(t3 % 52) + n2).replace(Z$2, "$1-$2");
}
var ee$2 = function(e5, t3) {
  for (var n2 = t3.length; n2; ) e5 = 33 * e5 ^ t3.charCodeAt(--n2);
  return e5;
}, te$2 = function(e5) {
  return ee$2(5381, e5);
};
function ne$3(e5) {
  for (var t3 = 0; t3 < e5.length; t3 += 1) {
    var n2 = e5[t3];
    if (E$2(n2) && !_$2(n2)) return false;
  }
  return true;
}
var re$2 = te$2("5.3.11"), oe$3 = function() {
  function e5(e6, t3, n2) {
    this.rules = e6, this.staticRulesId = "", this.isStatic = "production" === process$1$1.env.NODE_ENV && (void 0 === n2 || n2.isStatic) && ne$3(e6), this.componentId = t3, this.baseHash = ee$2(re$2, t3), this.baseStyle = n2, X$2.registerId(t3);
  }
  return e5.prototype.generateAndInjectStyles = function(e6, t3, n2) {
    var r2 = this.componentId, o2 = [];
    if (this.baseStyle && o2.push(this.baseStyle.generateAndInjectStyles(e6, t3, n2)), this.isStatic && !n2.hash) if (this.staticRulesId && t3.hasNameForId(r2, this.staticRulesId)) o2.push(this.staticRulesId);
    else {
      var s4 = _e$3(this.rules, e6, t3, n2).join(""), i3 = Q$2(ee$2(this.baseHash, s4) >>> 0);
      if (!t3.hasNameForId(r2, i3)) {
        var a4 = n2(s4, "." + i3, void 0, r2);
        t3.insertRules(r2, i3, a4);
      }
      o2.push(i3), this.staticRulesId = i3;
    }
    else {
      for (var c3 = this.rules.length, u3 = ee$2(this.baseHash, n2.hash), l2 = "", d4 = 0; d4 < c3; d4++) {
        var h4 = this.rules[d4];
        if ("string" == typeof h4) l2 += h4, "production" !== process$1$1.env.NODE_ENV && (u3 = ee$2(u3, h4 + d4));
        else if (h4) {
          var p2 = _e$3(h4, e6, t3, n2), f2 = Array.isArray(p2) ? p2.join("") : p2;
          u3 = ee$2(u3, f2 + d4), l2 += f2;
        }
      }
      if (l2) {
        var m4 = Q$2(u3 >>> 0);
        if (!t3.hasNameForId(r2, m4)) {
          var y4 = n2(l2, "." + m4, void 0, r2);
          t3.insertRules(r2, m4, y4);
        }
        o2.push(m4);
      }
    }
    return o2.join(" ");
  }, e5;
}(), se$3 = /^\s*\/\/.*$/gm, ie$3 = [":", "[", ".", "#"];
function ae$3(e5) {
  var t3, n2, r2, o2, s4 = w$2, i3 = s4.options, a4 = void 0 === i3 ? w$2 : i3, c3 = s4.plugins, u3 = void 0 === c3 ? S$2 : c3, l2 = new stylis_min(a4), d4 = [], p2 = /* @__PURE__ */ function(e6) {
    function t4(t5) {
      if (t5) try {
        e6(t5 + "}");
      } catch (e7) {
      }
    }
    return function(n3, r3, o3, s5, i4, a5, c4, u4, l3, d5) {
      switch (n3) {
        case 1:
          if (0 === l3 && 64 === r3.charCodeAt(0)) return e6(r3 + ";"), "";
          break;
        case 2:
          if (0 === u4) return r3 + "/*|*/";
          break;
        case 3:
          switch (u4) {
            case 102:
            case 112:
              return e6(o3[0] + r3), "";
            default:
              return r3 + (0 === d5 ? "/*|*/" : "");
          }
        case -2:
          r3.split("/*|*/}").forEach(t4);
      }
    };
  }(function(e6) {
    d4.push(e6);
  }), f2 = function(e6, r3, s5) {
    return 0 === r3 && -1 !== ie$3.indexOf(s5[n2.length]) || s5.match(o2) ? e6 : "." + t3;
  };
  function m4(e6, s5, i4, a5) {
    void 0 === a5 && (a5 = "&");
    var c4 = e6.replace(se$3, ""), u4 = s5 && i4 ? i4 + " " + s5 + " { " + c4 + " }" : c4;
    return t3 = a5, n2 = s5, r2 = new RegExp("\\" + n2 + "\\b", "g"), o2 = new RegExp("(\\" + n2 + "\\b){2,}"), l2(i4 || !s5 ? "" : s5, u4);
  }
  return l2.use([].concat(u3, [function(e6, t4, o3) {
    2 === e6 && o3.length && o3[0].lastIndexOf(n2) > 0 && (o3[0] = o3[0].replace(r2, f2));
  }, p2, function(e6) {
    if (-2 === e6) {
      var t4 = d4;
      return d4 = [], t4;
    }
  }])), m4.hash = u3.length ? u3.reduce(function(e6, t4) {
    return t4.name || D$2(15), ee$2(e6, t4.name);
  }, 5381).toString() : "", m4;
}
var ce$3 = React__default.createContext();
ce$3.Consumer;
var le$3 = React__default.createContext(), de$3 = (le$3.Consumer, new X$2()), he$3 = ae$3();
function pe$3() {
  return useContext(ce$3) || de$3;
}
function fe$3() {
  return useContext(le$3) || he$3;
}
var ye$3 = function() {
  function e5(e6, t3) {
    var n2 = this;
    this.inject = function(e7, t4) {
      void 0 === t4 && (t4 = he$3);
      var r2 = n2.name + t4.hash;
      e7.hasNameForId(n2.id, r2) || e7.insertRules(n2.id, r2, t4(n2.rules, r2, "@keyframes"));
    }, this.toString = function() {
      return D$2(12, String(n2.name));
    }, this.name = e6, this.id = "sc-keyframes-" + e6, this.rules = t3;
  }
  return e5.prototype.getName = function(e6) {
    return void 0 === e6 && (e6 = he$3), this.name + e6.hash;
  }, e5;
}(), ve$3 = /([A-Z])/, ge$3 = /([A-Z])/g, Se$3 = /^ms-/, we$3 = function(e5) {
  return "-" + e5.toLowerCase();
};
function Ee$3(e5) {
  return ve$3.test(e5) ? e5.replace(ge$3, we$3).replace(Se$3, "-ms-") : e5;
}
var be$3 = function(e5) {
  return null == e5 || false === e5 || "" === e5;
};
function _e$3(e5, n2, r2, o2) {
  if (Array.isArray(e5)) {
    for (var s4, i3 = [], a4 = 0, c3 = e5.length; a4 < c3; a4 += 1) "" !== (s4 = _e$3(e5[a4], n2, r2, o2)) && (Array.isArray(s4) ? i3.push.apply(i3, s4) : i3.push(s4));
    return i3;
  }
  if (be$3(e5)) return "";
  if (_$2(e5)) return "." + e5.styledComponentId;
  if (E$2(e5)) {
    if ("function" != typeof (l2 = e5) || l2.prototype && l2.prototype.isReactComponent || !n2) return e5;
    var u3 = e5(n2);
    return "production" !== process$1$1.env.NODE_ENV && reactIsExports$1.isElement(u3) && console.warn(b$2(e5) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), _e$3(u3, n2, r2, o2);
  }
  var l2;
  return e5 instanceof ye$3 ? r2 ? (e5.inject(r2, o2), e5.getName(o2)) : e5 : g$2(e5) ? function e6(t3, n3) {
    var r3, o3, s5 = [];
    for (var i4 in t3) t3.hasOwnProperty(i4) && !be$3(t3[i4]) && (Array.isArray(t3[i4]) && t3[i4].isCss || E$2(t3[i4]) ? s5.push(Ee$3(i4) + ":", t3[i4], ";") : g$2(t3[i4]) ? s5.push.apply(s5, e6(t3[i4], i4)) : s5.push(Ee$3(i4) + ": " + (r3 = i4, null == (o3 = t3[i4]) || "boolean" == typeof o3 || "" === o3 ? "" : "number" != typeof o3 || 0 === o3 || r3 in unitlessKeys || r3.startsWith("--") ? String(o3).trim() : o3 + "px") + ";"));
    return n3 ? [n3 + " {"].concat(s5, ["}"]) : s5;
  }(e5) : e5.toString();
}
var Ne$3 = function(e5) {
  return Array.isArray(e5) && (e5.isCss = true), e5;
};
function Ae$2(e5) {
  for (var t3 = arguments.length, n2 = new Array(t3 > 1 ? t3 - 1 : 0), r2 = 1; r2 < t3; r2++) n2[r2 - 1] = arguments[r2];
  return E$2(e5) || g$2(e5) ? Ne$3(_e$3(v$2(S$2, [e5].concat(n2)))) : 0 === n2.length && 1 === e5.length && "string" == typeof e5[0] ? e5 : Ne$3(_e$3(v$2(e5, n2)));
}
var Ce$3 = /invalid hook call/i, Ie$3 = /* @__PURE__ */ new Set(), Pe$3 = function(e5, t3) {
  if ("production" !== process$1$1.env.NODE_ENV) {
    var n2 = "The component " + e5 + (t3 ? ' with the id of "' + t3 + '"' : "") + " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.", r2 = console.error;
    try {
      var o2 = true;
      console.error = function(e6) {
        if (Ce$3.test(e6)) o2 = false, Ie$3.delete(n2);
        else {
          for (var t4 = arguments.length, s4 = new Array(t4 > 1 ? t4 - 1 : 0), i3 = 1; i3 < t4; i3++) s4[i3 - 1] = arguments[i3];
          r2.apply(void 0, [e6].concat(s4));
        }
      }, useRef(), o2 && !Ie$3.has(n2) && (console.warn(n2), Ie$3.add(n2));
    } catch (e6) {
      Ce$3.test(e6.message) && Ie$3.delete(n2);
    } finally {
      console.error = r2;
    }
  }
}, Oe$3 = function(e5, t3, n2) {
  return void 0 === n2 && (n2 = w$2), e5.theme !== n2.theme && e5.theme || t3 || n2.theme;
}, Re$3 = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, De$3 = /(^-|-$)/g;
function je$3(e5) {
  return e5.replace(Re$3, "-").replace(De$3, "");
}
var Te$3 = function(e5) {
  return Q$2(te$2(e5) >>> 0);
};
function xe$3(e5) {
  return "string" == typeof e5 && ("production" === process$1$1.env.NODE_ENV || e5.charAt(0) === e5.charAt(0).toLowerCase());
}
var ke$3 = function(e5) {
  return "function" == typeof e5 || "object" == typeof e5 && null !== e5 && !Array.isArray(e5);
}, Ve$2 = function(e5) {
  return "__proto__" !== e5 && "constructor" !== e5 && "prototype" !== e5;
};
function Be$3(e5, t3, n2) {
  var r2 = e5[n2];
  ke$3(t3) && ke$3(r2) ? ze$3(r2, t3) : e5[n2] = t3;
}
function ze$3(e5) {
  for (var t3 = arguments.length, n2 = new Array(t3 > 1 ? t3 - 1 : 0), r2 = 1; r2 < t3; r2++) n2[r2 - 1] = arguments[r2];
  for (var o2 = 0, s4 = n2; o2 < s4.length; o2++) {
    var i3 = s4[o2];
    if (ke$3(i3)) for (var a4 in i3) Ve$2(a4) && Be$3(e5, i3[a4], a4);
  }
  return e5;
}
var Me$3 = React__default.createContext();
Me$3.Consumer;
function Le$3(e5) {
  var t3 = useContext(Me$3), n2 = useMemo(function() {
    return function(e6, t4) {
      if (!e6) return D$2(14);
      if (E$2(e6)) {
        var n3 = e6(t4);
        return "production" === process$1$1.env.NODE_ENV || null !== n3 && !Array.isArray(n3) && "object" == typeof n3 ? n3 : D$2(7);
      }
      return Array.isArray(e6) || "object" != typeof e6 ? D$2(8) : t4 ? y$2({}, t4, {}, e6) : e6;
    }(e5.theme, t3);
  }, [e5.theme, t3]);
  return e5.children ? React__default.createElement(Me$3.Provider, { value: n2 }, e5.children) : null;
}
var Fe$3 = {};
function Ye$2(e5, t3, n2) {
  var o2 = _$2(e5), i3 = !xe$3(e5), a4 = t3.attrs, c3 = void 0 === a4 ? S$2 : a4, l2 = t3.componentId, d4 = void 0 === l2 ? function(e6, t4) {
    var n3 = "string" != typeof e6 ? "sc" : je$3(e6);
    Fe$3[n3] = (Fe$3[n3] || 0) + 1;
    var r2 = n3 + "-" + Te$3("5.3.11" + n3 + Fe$3[n3]);
    return t4 ? t4 + "-" + r2 : r2;
  }(t3.displayName, t3.parentComponentId) : l2, h4 = t3.displayName, p2 = void 0 === h4 ? function(e6) {
    return xe$3(e6) ? "styled." + e6 : "Styled(" + b$2(e6) + ")";
  }(e5) : h4, v2 = t3.displayName && t3.componentId ? je$3(t3.displayName) + "-" + t3.componentId : t3.componentId || d4, g2 = o2 && e5.attrs ? Array.prototype.concat(e5.attrs, c3).filter(Boolean) : c3, N2 = t3.shouldForwardProp;
  o2 && e5.shouldForwardProp && (N2 = t3.shouldForwardProp ? function(n3, r2, o3) {
    return e5.shouldForwardProp(n3, r2, o3) && t3.shouldForwardProp(n3, r2, o3);
  } : e5.shouldForwardProp);
  var A2, C2 = new oe$3(n2, v2, o2 ? e5.componentStyle : void 0), I3 = C2.isStatic && 0 === c3.length, P2 = function(e6, t4) {
    return function(e7, t5, n3, r2) {
      var o3 = e7.attrs, i4 = e7.componentStyle, a5 = e7.defaultProps, c4 = e7.foldedComponentIds, l3 = e7.shouldForwardProp, d5 = e7.styledComponentId, h5 = e7.target, p3 = function(e8, t6, n4) {
        void 0 === e8 && (e8 = w$2);
        var r3 = y$2({}, t6, { theme: e8 }), o4 = {};
        return n4.forEach(function(e9) {
          var t7, n5, s4, i5 = e9;
          for (t7 in E$2(i5) && (i5 = i5(r3)), i5) r3[t7] = o4[t7] = "className" === t7 ? (n5 = o4[t7], s4 = i5[t7], n5 && s4 ? n5 + " " + s4 : n5 || s4) : i5[t7];
        }), [r3, o4];
      }(Oe$3(t5, useContext(Me$3), a5) || w$2, t5, o3), m4 = p3[0], v3 = p3[1], g3 = function(e8, t6, n4, r3) {
        var o4 = pe$3(), s4 = fe$3(), i5 = t6 ? e8.generateAndInjectStyles(w$2, o4, s4) : e8.generateAndInjectStyles(n4, o4, s4);
        return "production" !== process$1$1.env.NODE_ENV && !t6 && r3 && r3(i5), i5;
      }(i4, r2, m4, "production" !== process$1$1.env.NODE_ENV ? e7.warnTooManyClasses : void 0), S4 = n3, b3 = v3.$as || t5.$as || v3.as || t5.as || h5, _2 = xe$3(b3), N3 = v3 !== t5 ? y$2({}, t5, {}, v3) : t5, A3 = {};
      for (var C3 in N3) "$" !== C3[0] && "as" !== C3 && ("forwardedAs" === C3 ? A3.as = N3[C3] : (l3 ? l3(C3, isPropValid, b3) : !_2 || isPropValid(C3)) && (A3[C3] = N3[C3]));
      return t5.style && v3.style !== t5.style && (A3.style = y$2({}, t5.style, {}, v3.style)), A3.className = Array.prototype.concat(c4, d5, g3 !== d5 ? g3 : null, t5.className, v3.className).filter(Boolean).join(" "), A3.ref = S4, createElement$2(b3, A3);
    }(A2, e6, t4, I3);
  };
  return P2.displayName = p2, (A2 = React__default.forwardRef(P2)).attrs = g2, A2.componentStyle = C2, A2.displayName = p2, A2.shouldForwardProp = N2, A2.foldedComponentIds = o2 ? Array.prototype.concat(e5.foldedComponentIds, e5.styledComponentId) : S$2, A2.styledComponentId = v2, A2.target = o2 ? e5.target : e5, A2.withComponent = function(e6) {
    var r2 = t3.componentId, o3 = function(e7, t4) {
      if (null == e7) return {};
      var n3, r3, o4 = {}, s5 = Object.keys(e7);
      for (r3 = 0; r3 < s5.length; r3++) n3 = s5[r3], t4.indexOf(n3) >= 0 || (o4[n3] = e7[n3]);
      return o4;
    }(t3, ["componentId"]), s4 = r2 && r2 + "-" + (xe$3(e6) ? e6 : je$3(b$2(e6)));
    return Ye$2(e6, y$2({}, o3, { attrs: g2, componentId: s4 }), n2);
  }, Object.defineProperty(A2, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(t4) {
    this._foldedDefaultProps = o2 ? ze$3({}, e5.defaultProps, t4) : t4;
  } }), "production" !== process$1$1.env.NODE_ENV && (Pe$3(p2, v2), A2.warnTooManyClasses = /* @__PURE__ */ function(e6, t4) {
    var n3 = {}, r2 = false;
    return function(o3) {
      if (!r2 && (n3[o3] = true, Object.keys(n3).length >= 200)) {
        var s4 = t4 ? ' with the id of "' + t4 + '"' : "";
        console.warn("Over 200 classes were generated for component " + e6 + s4 + ".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), r2 = true, n3 = {};
      }
    };
  }(p2, v2)), Object.defineProperty(A2, "toString", { value: function() {
    return "." + A2.styledComponentId;
  } }), i3 && m$2(A2, e5, { attrs: true, componentStyle: true, displayName: true, foldedComponentIds: true, shouldForwardProp: true, styledComponentId: true, target: true, withComponent: true }), A2;
}
var qe$2 = function(e5) {
  return function e6(t3, r2, o2) {
    if (void 0 === o2 && (o2 = w$2), !reactIsExports$1.isValidElementType(r2)) return D$2(1, String(r2));
    var s4 = function() {
      return t3(r2, o2, Ae$2.apply(void 0, arguments));
    };
    return s4.withConfig = function(n2) {
      return e6(t3, r2, y$2({}, o2, {}, n2));
    }, s4.attrs = function(n2) {
      return e6(t3, r2, y$2({}, o2, { attrs: Array.prototype.concat(o2.attrs, n2).filter(Boolean) }));
    }, s4;
  }(Ye$2, e5);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e5) {
  qe$2[e5] = qe$2(e5);
});
function We$3(e5) {
  "production" !== process$1$1.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  for (var t3 = arguments.length, n2 = new Array(t3 > 1 ? t3 - 1 : 0), r2 = 1; r2 < t3; r2++) n2[r2 - 1] = arguments[r2];
  var o2 = Ae$2.apply(void 0, [e5].concat(n2)).join(""), s4 = Te$3(o2);
  return new ye$3(s4, o2);
}
"production" !== process$1$1.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"), "production" !== process$1$1.env.NODE_ENV && "test" !== process$1$1.env.NODE_ENV && "undefined" != typeof window && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, 1 === window["__styled-components-init__"] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window["__styled-components-init__"] += 1);
var f$2 = {
  lessThanXSeconds: { one: "less than a second", other: "less than {{count}} seconds" },
  xSeconds: { one: "1 second", other: "{{count}} seconds" },
  halfAMinute: "half a minute",
  lessThanXMinutes: { one: "less than a minute", other: "less than {{count}} minutes" },
  xMinutes: { one: "1 minute", other: "{{count}} minutes" },
  aboutXHours: { one: "about 1 hour", other: "about {{count}} hours" },
  xHours: { one: "1 hour", other: "{{count}} hours" },
  xDays: { one: "1 day", other: "{{count}} days" },
  aboutXWeeks: { one: "about 1 week", other: "about {{count}} weeks" },
  xWeeks: { one: "1 week", other: "{{count}} weeks" },
  aboutXMonths: { one: "about 1 month", other: "about {{count}} months" },
  xMonths: { one: "1 month", other: "{{count}} months" },
  aboutXYears: { one: "about 1 year", other: "about {{count}} years" },
  xYears: { one: "1 year", other: "{{count}} years" },
  overXYears: { one: "over 1 year", other: "over {{count}} years" },
  almostXYears: { one: "almost 1 year", other: "almost {{count}} years" }
};
function g$1(e5) {
  return function(t3) {
    var n2 = t3 || {}, r2 = n2.width ? String(n2.width) : e5.defaultWidth;
    return e5.formats[r2] || e5.formats[e5.defaultWidth];
  };
}
var h$1 = {
  date: g$1({
    formats: {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    },
    defaultWidth: "full"
  }),
  time: g$1({
    formats: { full: "h:mm:ss a zzzz", long: "h:mm:ss a z", medium: "h:mm:ss a", short: "h:mm a" },
    defaultWidth: "full"
  }),
  dateTime: g$1({
    formats: {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    },
    defaultWidth: "full"
  })
}, m$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
function y$1(e5) {
  return function(t3, n2) {
    var r2, a4 = n2 || {};
    if ("formatting" === (a4.context ? String(a4.context) : "standalone") && e5.formattingValues) {
      var o2 = e5.defaultFormattingWidth || e5.defaultWidth, i3 = a4.width ? String(a4.width) : o2;
      r2 = e5.formattingValues[i3] || e5.formattingValues[o2];
    } else {
      var d4 = e5.defaultWidth, s4 = a4.width ? String(a4.width) : e5.defaultWidth;
      r2 = e5.values[s4] || e5.values[d4];
    }
    return r2[e5.argumentCallback ? e5.argumentCallback(t3) : t3];
  };
}
function v$1(e5) {
  return function(t3, n2) {
    var r2 = String(t3), a4 = n2 || {}, o2 = a4.width, i3 = o2 && e5.matchPatterns[o2] || e5.matchPatterns[e5.defaultMatchWidth], d4 = r2.match(i3);
    if (!d4) return null;
    var s4, c3 = d4[0], u3 = o2 && e5.parsePatterns[o2] || e5.parsePatterns[e5.defaultParseWidth];
    return s4 = "[object Array]" === Object.prototype.toString.call(u3) ? function(e6, t4) {
      for (var n3 = 0; n3 < e6.length; n3++) if (t4(e6[n3])) return n3;
    }(u3, function(e6) {
      return e6.test(c3);
    }) : function(e6, t4) {
      for (var n3 in e6) if (e6.hasOwnProperty(n3) && t4(e6[n3])) return n3;
    }(u3, function(e6) {
      return e6.test(c3);
    }), s4 = e5.valueCallback ? e5.valueCallback(s4) : s4, { value: s4 = a4.valueCallback ? a4.valueCallback(s4) : s4, rest: r2.slice(c3.length) };
  };
}
var b$1, w$1 = {
  code: "en-US",
  formatDistance: function(e5, t3, n2) {
    var r2;
    return n2 = n2 || {}, r2 = "string" == typeof f$2[e5] ? f$2[e5] : 1 === t3 ? f$2[e5].one : f$2[e5].other.replace("{{count}}", t3), n2.addSuffix ? n2.comparison > 0 ? "in " + r2 : r2 + " ago" : r2;
  },
  formatLong: h$1,
  formatRelative: function(e5, t3, n2, r2) {
    return m$1[e5];
  },
  localize: {
    ordinalNumber: function(e5, t3) {
      var n2 = Number(e5), r2 = n2 % 100;
      if (r2 > 20 || r2 < 10)
        switch (r2 % 10) {
          case 1:
            return n2 + "st";
          case 2:
            return n2 + "nd";
          case 3:
            return n2 + "rd";
        }
      return n2 + "th";
    },
    era: y$1({
      values: {
        narrow: ["B", "A"],
        abbreviated: ["BC", "AD"],
        wide: ["Before Christ", "Anno Domini"]
      },
      defaultWidth: "wide"
    }),
    quarter: y$1({
      values: {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
      },
      defaultWidth: "wide",
      argumentCallback: function(e5) {
        return Number(e5) - 1;
      }
    }),
    month: y$1({
      values: {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        wide: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ]
      },
      defaultWidth: "wide"
    }),
    day: y$1({
      values: {
        narrow: ["S", "M", "T", "W", "T", "F", "S"],
        short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      },
      defaultWidth: "wide"
    }),
    dayPeriod: y$1({
      values: {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        }
      },
      defaultWidth: "wide",
      formattingValues: {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        }
      },
      defaultFormattingWidth: "wide"
    })
  },
  match: {
    ordinalNumber: (b$1 = {
      matchPattern: /^(\d+)(th|st|nd|rd)?/i,
      parsePattern: /\d+/i,
      valueCallback: function(e5) {
        return parseInt(e5, 10);
      }
    }, function(e5, t3) {
      var n2 = String(e5), r2 = t3 || {}, a4 = n2.match(b$1.matchPattern);
      if (!a4) return null;
      var o2 = a4[0], i3 = n2.match(b$1.parsePattern);
      if (!i3) return null;
      var d4 = b$1.valueCallback ? b$1.valueCallback(i3[0]) : i3[0];
      return { value: d4 = r2.valueCallback ? r2.valueCallback(d4) : d4, rest: n2.slice(o2.length) };
    }),
    era: v$1({
      matchPatterns: {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: { any: [/^b/i, /^(a|c)/i] },
      defaultParseWidth: "any"
    }),
    quarter: v$1({
      matchPatterns: {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: { any: [/1/i, /2/i, /3/i, /4/i] },
      defaultParseWidth: "any",
      valueCallback: function(e5) {
        return e5 + 1;
      }
    }),
    month: v$1({
      matchPatterns: {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        narrow: [
          /^j/i,
          /^f/i,
          /^m/i,
          /^a/i,
          /^m/i,
          /^j/i,
          /^j/i,
          /^a/i,
          /^s/i,
          /^o/i,
          /^n/i,
          /^d/i
        ],
        any: [
          /^ja/i,
          /^f/i,
          /^mar/i,
          /^ap/i,
          /^may/i,
          /^jun/i,
          /^jul/i,
          /^au/i,
          /^s/i,
          /^o/i,
          /^n/i,
          /^d/i
        ]
      },
      defaultParseWidth: "any"
    }),
    day: v$1({
      matchPatterns: {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      },
      defaultParseWidth: "any"
    }),
    dayPeriod: v$1({
      matchPatterns: {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      },
      defaultMatchWidth: "any",
      parsePatterns: {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      },
      defaultParseWidth: "any"
    })
  },
  options: { weekStartsOn: 0, firstWeekContainsDate: 1 }
};
function D$1(e5) {
  if (null === e5 || true === e5 || false === e5) return NaN;
  var t3 = Number(e5);
  return isNaN(t3) ? t3 : t3 < 0 ? Math.ceil(t3) : Math.floor(t3);
}
function k$1(e5, t3) {
  if (t3.length < e5)
    throw new TypeError(
      e5 + " argument" + (e5 > 1 ? "s" : "") + " required, but only " + t3.length + " present"
    );
}
function x$1(e5) {
  k$1(1, arguments);
  var t3 = Object.prototype.toString.call(e5);
  return e5 instanceof Date || "object" == typeof e5 && "[object Date]" === t3 ? new Date(e5.getTime()) : "number" == typeof e5 || "[object Number]" === t3 ? new Date(e5) : ("string" != typeof e5 && "[object String]" !== t3 || "undefined" == typeof console || (console.warn(
    "Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"
  ), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function C$1(e5, t3) {
  k$1(2, arguments);
  var n2 = x$1(e5).getTime(), r2 = D$1(t3);
  return new Date(n2 + r2);
}
function T$1(e5, t3) {
  k$1(2, arguments);
  var n2 = D$1(t3);
  return C$1(e5, -n2);
}
function S$1(e5, t3) {
  if (null == e5)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n2 in t3 = t3 || {}) t3.hasOwnProperty(n2) && (e5[n2] = t3[n2]);
  return e5;
}
function B$1(e5, t3) {
  switch (e5) {
    case "P":
      return t3.date({ width: "short" });
    case "PP":
      return t3.date({ width: "medium" });
    case "PPP":
      return t3.date({ width: "long" });
    case "PPPP":
    default:
      return t3.date({ width: "full" });
  }
}
function M$1(e5, t3) {
  switch (e5) {
    case "p":
      return t3.time({ width: "short" });
    case "pp":
      return t3.time({ width: "medium" });
    case "ppp":
      return t3.time({ width: "long" });
    case "pppp":
    default:
      return t3.time({ width: "full" });
  }
}
var L$1 = {
  p: M$1,
  P: function(e5, t3) {
    var n2, r2 = e5.match(/(P+)(p+)?/), a4 = r2[1], o2 = r2[2];
    if (!o2) return B$1(e5, t3);
    switch (a4) {
      case "P":
        n2 = t3.dateTime({ width: "short" });
        break;
      case "PP":
        n2 = t3.dateTime({ width: "medium" });
        break;
      case "PPP":
        n2 = t3.dateTime({ width: "long" });
        break;
      case "PPPP":
      default:
        n2 = t3.dateTime({ width: "full" });
    }
    return n2.replace("{{date}}", B$1(a4, t3)).replace("{{time}}", M$1(o2, t3));
  }
};
function W$1(e5) {
  return e5.getTime() % 6e4;
}
function R$1(e5) {
  var t3 = new Date(e5.getTime()), n2 = Math.ceil(t3.getTimezoneOffset());
  return t3.setSeconds(0, 0), 6e4 * n2 + (n2 > 0 ? (6e4 + W$1(t3)) % 6e4 : W$1(t3));
}
var E$1 = ["D", "DD"], F$1 = ["YY", "YYYY"];
function H$1(e5) {
  return -1 !== E$1.indexOf(e5);
}
function P$1(e5) {
  return -1 !== F$1.indexOf(e5);
}
function O$1(e5) {
  if ("YYYY" === e5)
    throw new RangeError(
      "Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr"
    );
  if ("YY" === e5)
    throw new RangeError("Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr");
  if ("D" === e5)
    throw new RangeError(
      "Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr"
    );
  if ("DD" === e5)
    throw new RangeError(
      "Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr"
    );
}
function I$1(e5, t3) {
  k$1(1, arguments);
  var n2 = t3 || {}, r2 = n2.locale, a4 = r2 && r2.options && r2.options.weekStartsOn, o2 = null == a4 ? 0 : D$1(a4), i3 = null == n2.weekStartsOn ? o2 : D$1(n2.weekStartsOn);
  if (!(i3 >= 0 && i3 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d4 = x$1(e5), s4 = d4.getUTCDay(), c3 = (s4 < i3 ? 7 : 0) + s4 - i3;
  return d4.setUTCDate(d4.getUTCDate() - c3), d4.setUTCHours(0, 0, 0, 0), d4;
}
function z$1(e5, t3) {
  k$1(1, arguments);
  var n2 = x$1(e5, t3), r2 = n2.getUTCFullYear(), a4 = t3 || {}, o2 = a4.locale, i3 = o2 && o2.options && o2.options.firstWeekContainsDate, d4 = null == i3 ? 1 : D$1(i3), s4 = null == a4.firstWeekContainsDate ? d4 : D$1(a4.firstWeekContainsDate);
  if (!(s4 >= 1 && s4 <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var c3 = /* @__PURE__ */ new Date(0);
  c3.setUTCFullYear(r2 + 1, 0, s4), c3.setUTCHours(0, 0, 0, 0);
  var u3 = I$1(c3, t3), l2 = /* @__PURE__ */ new Date(0);
  l2.setUTCFullYear(r2, 0, s4), l2.setUTCHours(0, 0, 0, 0);
  var p2 = I$1(l2, t3);
  return n2.getTime() >= u3.getTime() ? r2 + 1 : n2.getTime() >= p2.getTime() ? r2 : r2 - 1;
}
function U$1(e5, t3, n2) {
  k$1(2, arguments);
  var r2 = n2 || {}, a4 = r2.locale, o2 = a4 && a4.options && a4.options.weekStartsOn, i3 = null == o2 ? 0 : D$1(o2), d4 = null == r2.weekStartsOn ? i3 : D$1(r2.weekStartsOn);
  if (!(d4 >= 0 && d4 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var s4 = x$1(e5), c3 = D$1(t3), u3 = s4.getUTCDay(), l2 = c3 % 7, p2 = (l2 + 7) % 7, f2 = (p2 < d4 ? 7 : 0) + c3 - u3;
  return s4.setUTCDate(s4.getUTCDate() + f2), s4;
}
function N$1(e5) {
  k$1(1, arguments);
  var t3 = 1, n2 = x$1(e5), r2 = n2.getUTCDay(), a4 = (r2 < t3 ? 7 : 0) + r2 - t3;
  return n2.setUTCDate(n2.getUTCDate() - a4), n2.setUTCHours(0, 0, 0, 0), n2;
}
function Y$1(e5) {
  k$1(1, arguments);
  var t3 = x$1(e5), n2 = t3.getUTCFullYear(), r2 = /* @__PURE__ */ new Date(0);
  r2.setUTCFullYear(n2 + 1, 0, 4), r2.setUTCHours(0, 0, 0, 0);
  var a4 = N$1(r2), o2 = /* @__PURE__ */ new Date(0);
  o2.setUTCFullYear(n2, 0, 4), o2.setUTCHours(0, 0, 0, 0);
  var i3 = N$1(o2);
  return t3.getTime() >= a4.getTime() ? n2 + 1 : t3.getTime() >= i3.getTime() ? n2 : n2 - 1;
}
function A$1(e5) {
  k$1(1, arguments);
  var t3 = Y$1(e5), n2 = /* @__PURE__ */ new Date(0);
  n2.setUTCFullYear(t3, 0, 4), n2.setUTCHours(0, 0, 0, 0);
  var r2 = N$1(n2);
  return r2;
}
function q$1(e5) {
  k$1(1, arguments);
  var t3 = x$1(e5), n2 = N$1(t3).getTime() - A$1(t3).getTime();
  return Math.round(n2 / 6048e5) + 1;
}
function G$1(e5, t3) {
  k$1(1, arguments);
  var n2 = t3 || {}, r2 = n2.locale, a4 = r2 && r2.options && r2.options.firstWeekContainsDate, o2 = null == a4 ? 1 : D$1(a4), i3 = null == n2.firstWeekContainsDate ? o2 : D$1(n2.firstWeekContainsDate), d4 = z$1(e5, t3), s4 = /* @__PURE__ */ new Date(0);
  s4.setUTCFullYear(d4, 0, i3), s4.setUTCHours(0, 0, 0, 0);
  var c3 = I$1(s4, t3);
  return c3;
}
function j$1(e5, t3) {
  k$1(1, arguments);
  var n2 = x$1(e5), r2 = I$1(n2, t3).getTime() - G$1(n2, t3).getTime();
  return Math.round(r2 / 6048e5) + 1;
}
var X$1 = /^(1[0-2]|0?\d)/, Q$1 = /^(3[0-1]|[0-2]?\d)/, V$1 = /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, Z$1 = /^(5[0-3]|[0-4]?\d)/, K$1 = /^(2[0-3]|[0-1]?\d)/, J$1 = /^(2[0-4]|[0-1]?\d)/, _$1 = /^(1[0-1]|0?\d)/, $$1 = /^(1[0-2]|0?\d)/, ee$1 = /^[0-5]?\d/, te$1 = /^[0-5]?\d/, ne$2 = /^\d/, re$1 = /^\d{1,2}/, ae$2 = /^\d{1,3}/, oe$2 = /^\d{1,4}/, ie$2 = /^-?\d+/, de$2 = /^-?\d/, se$2 = /^-?\d{1,2}/, ce$2 = /^-?\d{1,3}/, ue$2 = /^-?\d{1,4}/, le$2 = /^([+-])(\d{2})(\d{2})?|Z/, pe$2 = /^([+-])(\d{2})(\d{2})|Z/, fe$2 = /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/, ge$2 = /^([+-])(\d{2}):(\d{2})|Z/, he$2 = /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/;
function me$2(e5, t3, n2) {
  var r2 = t3.match(e5);
  if (!r2) return null;
  var a4 = parseInt(r2[0], 10);
  return { value: n2 ? n2(a4) : a4, rest: t3.slice(r2[0].length) };
}
function ye$2(e5, t3) {
  var n2 = t3.match(e5);
  return n2 ? "Z" === n2[0] ? { value: 0, rest: t3.slice(1) } : {
    value: ("+" === n2[1] ? 1 : -1) * (36e5 * (n2[2] ? parseInt(n2[2], 10) : 0) + 6e4 * (n2[3] ? parseInt(n2[3], 10) : 0) + 1e3 * (n2[5] ? parseInt(n2[5], 10) : 0)),
    rest: t3.slice(n2[0].length)
  } : null;
}
function ve$2(e5, t3) {
  return me$2(ie$2, e5, t3);
}
function be$2(e5, t3, n2) {
  switch (e5) {
    case 1:
      return me$2(ne$2, t3, n2);
    case 2:
      return me$2(re$1, t3, n2);
    case 3:
      return me$2(ae$2, t3, n2);
    case 4:
      return me$2(oe$2, t3, n2);
    default:
      return me$2(new RegExp("^\\d{1," + e5 + "}"), t3, n2);
  }
}
function we$2(e5, t3, n2) {
  switch (e5) {
    case 1:
      return me$2(de$2, t3, n2);
    case 2:
      return me$2(se$2, t3, n2);
    case 3:
      return me$2(ce$2, t3, n2);
    case 4:
      return me$2(ue$2, t3, n2);
    default:
      return me$2(new RegExp("^-?\\d{1," + e5 + "}"), t3, n2);
  }
}
function De$2(e5) {
  switch (e5) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function ke$2(e5, t3) {
  var n2, r2 = t3 > 0, a4 = r2 ? t3 : 1 - t3;
  if (a4 <= 50) n2 = e5 || 100;
  else {
    var o2 = a4 + 50;
    n2 = e5 + 100 * Math.floor(o2 / 100) - (e5 >= o2 % 100 ? 100 : 0);
  }
  return r2 ? n2 : 1 - n2;
}
var xe$2 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ce$2 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Te$2(e5) {
  return e5 % 400 == 0 || e5 % 4 == 0 && e5 % 100 != 0;
}
var Se$2 = {
  G: {
    priority: 140,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "G":
        case "GG":
        case "GGG":
          return n2.era(e5, { width: "abbreviated" }) || n2.era(e5, { width: "narrow" });
        case "GGGGG":
          return n2.era(e5, { width: "narrow" });
        case "GGGG":
        default:
          return n2.era(e5, { width: "wide" }) || n2.era(e5, { width: "abbreviated" }) || n2.era(e5, { width: "narrow" });
      }
    },
    set: function(e5, t3, n2, r2) {
      return t3.era = n2, e5.setUTCFullYear(n2, 0, 1), e5.setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: ["R", "u", "t", "T"]
  },
  y: {
    priority: 130,
    parse: function(e5, t3, n2, r2) {
      var a4 = function(e6) {
        return { year: e6, isTwoDigitYear: "yy" === t3 };
      };
      switch (t3) {
        case "y":
          return be$2(4, e5, a4);
        case "yo":
          return n2.ordinalNumber(e5, { unit: "year", valueCallback: a4 });
        default:
          return be$2(t3.length, e5, a4);
      }
    },
    validate: function(e5, t3, n2) {
      return t3.isTwoDigitYear || t3.year > 0;
    },
    set: function(e5, t3, n2, r2) {
      var a4 = e5.getUTCFullYear();
      if (n2.isTwoDigitYear) {
        var o2 = ke$2(n2.year, a4);
        return e5.setUTCFullYear(o2, 0, 1), e5.setUTCHours(0, 0, 0, 0), e5;
      }
      var i3 = "era" in t3 && 1 !== t3.era ? 1 - n2.year : n2.year;
      return e5.setUTCFullYear(i3, 0, 1), e5.setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]
  },
  Y: {
    priority: 130,
    parse: function(e5, t3, n2, r2) {
      var a4 = function(e6) {
        return { year: e6, isTwoDigitYear: "YY" === t3 };
      };
      switch (t3) {
        case "Y":
          return be$2(4, e5, a4);
        case "Yo":
          return n2.ordinalNumber(e5, { unit: "year", valueCallback: a4 });
        default:
          return be$2(t3.length, e5, a4);
      }
    },
    validate: function(e5, t3, n2) {
      return t3.isTwoDigitYear || t3.year > 0;
    },
    set: function(e5, t3, n2, r2) {
      var a4 = z$1(e5, r2);
      if (n2.isTwoDigitYear) {
        var o2 = ke$2(n2.year, a4);
        return e5.setUTCFullYear(o2, 0, r2.firstWeekContainsDate), e5.setUTCHours(0, 0, 0, 0), I$1(e5, r2);
      }
      var i3 = "era" in t3 && 1 !== t3.era ? 1 - n2.year : n2.year;
      return e5.setUTCFullYear(i3, 0, r2.firstWeekContainsDate), e5.setUTCHours(0, 0, 0, 0), I$1(e5, r2);
    },
    incompatibleTokens: ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]
  },
  R: {
    priority: 130,
    parse: function(e5, t3, n2, r2) {
      return we$2("R" === t3 ? 4 : t3.length, e5);
    },
    set: function(e5, t3, n2, r2) {
      var a4 = /* @__PURE__ */ new Date(0);
      return a4.setUTCFullYear(n2, 0, 4), a4.setUTCHours(0, 0, 0, 0), N$1(a4);
    },
    incompatibleTokens: [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]
  },
  u: {
    priority: 130,
    parse: function(e5, t3, n2, r2) {
      return we$2("u" === t3 ? 4 : t3.length, e5);
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCFullYear(n2, 0, 1), e5.setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]
  },
  Q: {
    priority: 120,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "Q":
        case "QQ":
          return be$2(t3.length, e5);
        case "Qo":
          return n2.ordinalNumber(e5, { unit: "quarter" });
        case "QQQ":
          return n2.quarter(e5, { width: "abbreviated", context: "formatting" }) || n2.quarter(e5, { width: "narrow", context: "formatting" });
        case "QQQQQ":
          return n2.quarter(e5, { width: "narrow", context: "formatting" });
        case "QQQQ":
        default:
          return n2.quarter(e5, { width: "wide", context: "formatting" }) || n2.quarter(e5, { width: "abbreviated", context: "formatting" }) || n2.quarter(e5, { width: "narrow", context: "formatting" });
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 1 && t3 <= 4;
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCMonth(3 * (n2 - 1), 1), e5.setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
  },
  q: {
    priority: 120,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "q":
        case "qq":
          return be$2(t3.length, e5);
        case "qo":
          return n2.ordinalNumber(e5, { unit: "quarter" });
        case "qqq":
          return n2.quarter(e5, { width: "abbreviated", context: "standalone" }) || n2.quarter(e5, { width: "narrow", context: "standalone" });
        case "qqqqq":
          return n2.quarter(e5, { width: "narrow", context: "standalone" });
        case "qqqq":
        default:
          return n2.quarter(e5, { width: "wide", context: "standalone" }) || n2.quarter(e5, { width: "abbreviated", context: "standalone" }) || n2.quarter(e5, { width: "narrow", context: "standalone" });
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 1 && t3 <= 4;
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCMonth(3 * (n2 - 1), 1), e5.setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
  },
  M: {
    priority: 110,
    parse: function(e5, t3, n2, r2) {
      var a4 = function(e6) {
        return e6 - 1;
      };
      switch (t3) {
        case "M":
          return me$2(X$1, e5, a4);
        case "MM":
          return be$2(2, e5, a4);
        case "Mo":
          return n2.ordinalNumber(e5, { unit: "month", valueCallback: a4 });
        case "MMM":
          return n2.month(e5, { width: "abbreviated", context: "formatting" }) || n2.month(e5, { width: "narrow", context: "formatting" });
        case "MMMMM":
          return n2.month(e5, { width: "narrow", context: "formatting" });
        case "MMMM":
        default:
          return n2.month(e5, { width: "wide", context: "formatting" }) || n2.month(e5, { width: "abbreviated", context: "formatting" }) || n2.month(e5, { width: "narrow", context: "formatting" });
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 0 && t3 <= 11;
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCMonth(n2, 1), e5.setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  L: {
    priority: 110,
    parse: function(e5, t3, n2, r2) {
      var a4 = function(e6) {
        return e6 - 1;
      };
      switch (t3) {
        case "L":
          return me$2(X$1, e5, a4);
        case "LL":
          return be$2(2, e5, a4);
        case "Lo":
          return n2.ordinalNumber(e5, { unit: "month", valueCallback: a4 });
        case "LLL":
          return n2.month(e5, { width: "abbreviated", context: "standalone" }) || n2.month(e5, { width: "narrow", context: "standalone" });
        case "LLLLL":
          return n2.month(e5, { width: "narrow", context: "standalone" });
        case "LLLL":
        default:
          return n2.month(e5, { width: "wide", context: "standalone" }) || n2.month(e5, { width: "abbreviated", context: "standalone" }) || n2.month(e5, { width: "narrow", context: "standalone" });
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 0 && t3 <= 11;
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCMonth(n2, 1), e5.setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  w: {
    priority: 100,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "w":
          return me$2(Z$1, e5);
        case "wo":
          return n2.ordinalNumber(e5, { unit: "week" });
        default:
          return be$2(t3.length, e5);
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 1 && t3 <= 53;
    },
    set: function(e5, t3, n2, r2) {
      return I$1(
        function(e6, t4, n3) {
          k$1(2, arguments);
          var r3 = x$1(e6), a4 = D$1(t4), o2 = j$1(r3, n3) - a4;
          return r3.setUTCDate(r3.getUTCDate() - 7 * o2), r3;
        }(e5, n2, r2),
        r2
      );
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]
  },
  I: {
    priority: 100,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "I":
          return me$2(Z$1, e5);
        case "Io":
          return n2.ordinalNumber(e5, { unit: "week" });
        default:
          return be$2(t3.length, e5);
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 1 && t3 <= 53;
    },
    set: function(e5, t3, n2, r2) {
      return N$1(
        function(e6, t4) {
          k$1(2, arguments);
          var n3 = x$1(e6), r3 = D$1(t4), a4 = q$1(n3) - r3;
          return n3.setUTCDate(n3.getUTCDate() - 7 * a4), n3;
        }(e5, n2, r2),
        r2
      );
    },
    incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
  },
  d: {
    priority: 90,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "d":
          return me$2(Q$1, e5);
        case "do":
          return n2.ordinalNumber(e5, { unit: "date" });
        default:
          return be$2(t3.length, e5);
      }
    },
    validate: function(e5, t3, n2) {
      var r2 = Te$2(e5.getUTCFullYear()), a4 = e5.getUTCMonth();
      return r2 ? t3 >= 1 && t3 <= Ce$2[a4] : t3 >= 1 && t3 <= xe$2[a4];
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCDate(n2), e5.setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  D: {
    priority: 90,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "D":
        case "DD":
          return me$2(V$1, e5);
        case "Do":
          return n2.ordinalNumber(e5, { unit: "date" });
        default:
          return be$2(t3.length, e5);
      }
    },
    validate: function(e5, t3, n2) {
      return Te$2(e5.getUTCFullYear()) ? t3 >= 1 && t3 <= 366 : t3 >= 1 && t3 <= 365;
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCMonth(0, n2), e5.setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]
  },
  E: {
    priority: 90,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "E":
        case "EE":
        case "EEE":
          return n2.day(e5, { width: "abbreviated", context: "formatting" }) || n2.day(e5, { width: "short", context: "formatting" }) || n2.day(e5, { width: "narrow", context: "formatting" });
        case "EEEEE":
          return n2.day(e5, { width: "narrow", context: "formatting" });
        case "EEEEEE":
          return n2.day(e5, { width: "short", context: "formatting" }) || n2.day(e5, { width: "narrow", context: "formatting" });
        case "EEEE":
        default:
          return n2.day(e5, { width: "wide", context: "formatting" }) || n2.day(e5, { width: "abbreviated", context: "formatting" }) || n2.day(e5, { width: "short", context: "formatting" }) || n2.day(e5, { width: "narrow", context: "formatting" });
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 0 && t3 <= 6;
    },
    set: function(e5, t3, n2, r2) {
      return (e5 = U$1(e5, n2, r2)).setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: ["D", "i", "e", "c", "t", "T"]
  },
  e: {
    priority: 90,
    parse: function(e5, t3, n2, r2) {
      var a4 = function(e6) {
        var t4 = 7 * Math.floor((e6 - 1) / 7);
        return (e6 + r2.weekStartsOn + 6) % 7 + t4;
      };
      switch (t3) {
        case "e":
        case "ee":
          return be$2(t3.length, e5, a4);
        case "eo":
          return n2.ordinalNumber(e5, { unit: "day", valueCallback: a4 });
        case "eee":
          return n2.day(e5, { width: "abbreviated", context: "formatting" }) || n2.day(e5, { width: "short", context: "formatting" }) || n2.day(e5, { width: "narrow", context: "formatting" });
        case "eeeee":
          return n2.day(e5, { width: "narrow", context: "formatting" });
        case "eeeeee":
          return n2.day(e5, { width: "short", context: "formatting" }) || n2.day(e5, { width: "narrow", context: "formatting" });
        case "eeee":
        default:
          return n2.day(e5, { width: "wide", context: "formatting" }) || n2.day(e5, { width: "abbreviated", context: "formatting" }) || n2.day(e5, { width: "short", context: "formatting" }) || n2.day(e5, { width: "narrow", context: "formatting" });
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 0 && t3 <= 6;
    },
    set: function(e5, t3, n2, r2) {
      return (e5 = U$1(e5, n2, r2)).setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]
  },
  c: {
    priority: 90,
    parse: function(e5, t3, n2, r2) {
      var a4 = function(e6) {
        var t4 = 7 * Math.floor((e6 - 1) / 7);
        return (e6 + r2.weekStartsOn + 6) % 7 + t4;
      };
      switch (t3) {
        case "c":
        case "cc":
          return be$2(t3.length, e5, a4);
        case "co":
          return n2.ordinalNumber(e5, { unit: "day", valueCallback: a4 });
        case "ccc":
          return n2.day(e5, { width: "abbreviated", context: "standalone" }) || n2.day(e5, { width: "short", context: "standalone" }) || n2.day(e5, { width: "narrow", context: "standalone" });
        case "ccccc":
          return n2.day(e5, { width: "narrow", context: "standalone" });
        case "cccccc":
          return n2.day(e5, { width: "short", context: "standalone" }) || n2.day(e5, { width: "narrow", context: "standalone" });
        case "cccc":
        default:
          return n2.day(e5, { width: "wide", context: "standalone" }) || n2.day(e5, { width: "abbreviated", context: "standalone" }) || n2.day(e5, { width: "short", context: "standalone" }) || n2.day(e5, { width: "narrow", context: "standalone" });
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 0 && t3 <= 6;
    },
    set: function(e5, t3, n2, r2) {
      return (e5 = U$1(e5, n2, r2)).setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]
  },
  i: {
    priority: 90,
    parse: function(e5, t3, n2, r2) {
      var a4 = function(e6) {
        return 0 === e6 ? 7 : e6;
      };
      switch (t3) {
        case "i":
        case "ii":
          return be$2(t3.length, e5);
        case "io":
          return n2.ordinalNumber(e5, { unit: "day" });
        case "iii":
          return n2.day(e5, { width: "abbreviated", context: "formatting", valueCallback: a4 }) || n2.day(e5, { width: "short", context: "formatting", valueCallback: a4 }) || n2.day(e5, { width: "narrow", context: "formatting", valueCallback: a4 });
        case "iiiii":
          return n2.day(e5, { width: "narrow", context: "formatting", valueCallback: a4 });
        case "iiiiii":
          return n2.day(e5, { width: "short", context: "formatting", valueCallback: a4 }) || n2.day(e5, { width: "narrow", context: "formatting", valueCallback: a4 });
        case "iiii":
        default:
          return n2.day(e5, { width: "wide", context: "formatting", valueCallback: a4 }) || n2.day(e5, { width: "abbreviated", context: "formatting", valueCallback: a4 }) || n2.day(e5, { width: "short", context: "formatting", valueCallback: a4 }) || n2.day(e5, { width: "narrow", context: "formatting", valueCallback: a4 });
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 1 && t3 <= 7;
    },
    set: function(e5, t3, n2, r2) {
      return (e5 = function(e6, t4) {
        k$1(2, arguments);
        var n3 = D$1(t4);
        n3 % 7 == 0 && (n3 -= 7);
        var r3 = 1, a4 = x$1(e6), o2 = a4.getUTCDay(), i3 = n3 % 7, d4 = (i3 + 7) % 7, s4 = (d4 < r3 ? 7 : 0) + n3 - o2;
        return a4.setUTCDate(a4.getUTCDate() + s4), a4;
      }(e5, n2, r2)).setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]
  },
  a: {
    priority: 80,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "a":
        case "aa":
        case "aaa":
          return n2.dayPeriod(e5, { width: "abbreviated", context: "formatting" }) || n2.dayPeriod(e5, { width: "narrow", context: "formatting" });
        case "aaaaa":
          return n2.dayPeriod(e5, { width: "narrow", context: "formatting" });
        case "aaaa":
        default:
          return n2.dayPeriod(e5, { width: "wide", context: "formatting" }) || n2.dayPeriod(e5, { width: "abbreviated", context: "formatting" }) || n2.dayPeriod(e5, { width: "narrow", context: "formatting" });
      }
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCHours(De$2(n2), 0, 0, 0), e5;
    },
    incompatibleTokens: ["b", "B", "H", "K", "k", "t", "T"]
  },
  b: {
    priority: 80,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "b":
        case "bb":
        case "bbb":
          return n2.dayPeriod(e5, { width: "abbreviated", context: "formatting" }) || n2.dayPeriod(e5, { width: "narrow", context: "formatting" });
        case "bbbbb":
          return n2.dayPeriod(e5, { width: "narrow", context: "formatting" });
        case "bbbb":
        default:
          return n2.dayPeriod(e5, { width: "wide", context: "formatting" }) || n2.dayPeriod(e5, { width: "abbreviated", context: "formatting" }) || n2.dayPeriod(e5, { width: "narrow", context: "formatting" });
      }
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCHours(De$2(n2), 0, 0, 0), e5;
    },
    incompatibleTokens: ["a", "B", "H", "K", "k", "t", "T"]
  },
  B: {
    priority: 80,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "B":
        case "BB":
        case "BBB":
          return n2.dayPeriod(e5, { width: "abbreviated", context: "formatting" }) || n2.dayPeriod(e5, { width: "narrow", context: "formatting" });
        case "BBBBB":
          return n2.dayPeriod(e5, { width: "narrow", context: "formatting" });
        case "BBBB":
        default:
          return n2.dayPeriod(e5, { width: "wide", context: "formatting" }) || n2.dayPeriod(e5, { width: "abbreviated", context: "formatting" }) || n2.dayPeriod(e5, { width: "narrow", context: "formatting" });
      }
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCHours(De$2(n2), 0, 0, 0), e5;
    },
    incompatibleTokens: ["a", "b", "t", "T"]
  },
  h: {
    priority: 70,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "h":
          return me$2($$1, e5);
        case "ho":
          return n2.ordinalNumber(e5, { unit: "hour" });
        default:
          return be$2(t3.length, e5);
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 1 && t3 <= 12;
    },
    set: function(e5, t3, n2, r2) {
      var a4 = e5.getUTCHours() >= 12;
      return a4 && n2 < 12 ? e5.setUTCHours(n2 + 12, 0, 0, 0) : a4 || 12 !== n2 ? e5.setUTCHours(n2, 0, 0, 0) : e5.setUTCHours(0, 0, 0, 0), e5;
    },
    incompatibleTokens: ["H", "K", "k", "t", "T"]
  },
  H: {
    priority: 70,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "H":
          return me$2(K$1, e5);
        case "Ho":
          return n2.ordinalNumber(e5, { unit: "hour" });
        default:
          return be$2(t3.length, e5);
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 0 && t3 <= 23;
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCHours(n2, 0, 0, 0), e5;
    },
    incompatibleTokens: ["a", "b", "h", "K", "k", "t", "T"]
  },
  K: {
    priority: 70,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "K":
          return me$2(_$1, e5);
        case "Ko":
          return n2.ordinalNumber(e5, { unit: "hour" });
        default:
          return be$2(t3.length, e5);
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 0 && t3 <= 11;
    },
    set: function(e5, t3, n2, r2) {
      return e5.getUTCHours() >= 12 && n2 < 12 ? e5.setUTCHours(n2 + 12, 0, 0, 0) : e5.setUTCHours(n2, 0, 0, 0), e5;
    },
    incompatibleTokens: ["a", "b", "h", "H", "k", "t", "T"]
  },
  k: {
    priority: 70,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "k":
          return me$2(J$1, e5);
        case "ko":
          return n2.ordinalNumber(e5, { unit: "hour" });
        default:
          return be$2(t3.length, e5);
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 1 && t3 <= 24;
    },
    set: function(e5, t3, n2, r2) {
      var a4 = n2 <= 24 ? n2 % 24 : n2;
      return e5.setUTCHours(a4, 0, 0, 0), e5;
    },
    incompatibleTokens: ["a", "b", "h", "H", "K", "t", "T"]
  },
  m: {
    priority: 60,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "m":
          return me$2(ee$1, e5);
        case "mo":
          return n2.ordinalNumber(e5, { unit: "minute" });
        default:
          return be$2(t3.length, e5);
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 0 && t3 <= 59;
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCMinutes(n2, 0, 0), e5;
    },
    incompatibleTokens: ["t", "T"]
  },
  s: {
    priority: 50,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "s":
          return me$2(te$1, e5);
        case "so":
          return n2.ordinalNumber(e5, { unit: "second" });
        default:
          return be$2(t3.length, e5);
      }
    },
    validate: function(e5, t3, n2) {
      return t3 >= 0 && t3 <= 59;
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCSeconds(n2, 0), e5;
    },
    incompatibleTokens: ["t", "T"]
  },
  S: {
    priority: 30,
    parse: function(e5, t3, n2, r2) {
      return be$2(t3.length, e5, function(e6) {
        return Math.floor(e6 * Math.pow(10, 3 - t3.length));
      });
    },
    set: function(e5, t3, n2, r2) {
      return e5.setUTCMilliseconds(n2), e5;
    },
    incompatibleTokens: ["t", "T"]
  },
  X: {
    priority: 10,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "X":
          return ye$2(le$2, e5);
        case "XX":
          return ye$2(pe$2, e5);
        case "XXXX":
          return ye$2(fe$2, e5);
        case "XXXXX":
          return ye$2(he$2, e5);
        case "XXX":
        default:
          return ye$2(ge$2, e5);
      }
    },
    set: function(e5, t3, n2, r2) {
      return t3.timestampIsSet ? e5 : new Date(e5.getTime() - n2);
    },
    incompatibleTokens: ["t", "T", "x"]
  },
  x: {
    priority: 10,
    parse: function(e5, t3, n2, r2) {
      switch (t3) {
        case "x":
          return ye$2(le$2, e5);
        case "xx":
          return ye$2(pe$2, e5);
        case "xxxx":
          return ye$2(fe$2, e5);
        case "xxxxx":
          return ye$2(he$2, e5);
        case "xxx":
        default:
          return ye$2(ge$2, e5);
      }
    },
    set: function(e5, t3, n2, r2) {
      return t3.timestampIsSet ? e5 : new Date(e5.getTime() - n2);
    },
    incompatibleTokens: ["t", "T", "X"]
  },
  t: {
    priority: 40,
    parse: function(e5, t3, n2, r2) {
      return ve$2(e5);
    },
    set: function(e5, t3, n2, r2) {
      return [new Date(1e3 * n2), { timestampIsSet: true }];
    },
    incompatibleTokens: "*"
  },
  T: {
    priority: 20,
    parse: function(e5, t3, n2, r2) {
      return ve$2(e5);
    },
    set: function(e5, t3, n2, r2) {
      return [new Date(n2), { timestampIsSet: true }];
    },
    incompatibleTokens: "*"
  }
}, Be$2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Me$2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Le$2 = /^'([^]*?)'?$/, We$2 = /''/g, Re$2 = /\S/, Ee$2 = /[a-zA-Z]/;
function Fe$2(e5, t3) {
  if (t3.timestampIsSet) return e5;
  var n2 = /* @__PURE__ */ new Date(0);
  return n2.setFullYear(e5.getUTCFullYear(), e5.getUTCMonth(), e5.getUTCDate()), n2.setHours(e5.getUTCHours(), e5.getUTCMinutes(), e5.getUTCSeconds(), e5.getUTCMilliseconds()), n2;
}
function He$2(e5) {
  return e5.match(Le$2)[1].replace(We$2, "'");
}
function Pe$2(e5) {
  k$1(1, arguments);
  var t3 = x$1(e5);
  return !isNaN(t3);
}
function Oe$2(e5, t3) {
  for (var n2 = e5 < 0 ? "-" : "", r2 = Math.abs(e5).toString(); r2.length < t3; ) r2 = "0" + r2;
  return n2 + r2;
}
var Ie$2 = {
  G: function(e5, t3, n2) {
    var r2 = e5.getUTCFullYear() > 0 ? 1 : 0;
    switch (t3) {
      case "G":
      case "GG":
      case "GGG":
        return n2.era(r2, { width: "abbreviated" });
      case "GGGGG":
        return n2.era(r2, { width: "narrow" });
      case "GGGG":
      default:
        return n2.era(r2, { width: "wide" });
    }
  },
  y: function(e5, t3, n2) {
    if ("yo" === t3) {
      var r2 = e5.getUTCFullYear(), a4 = r2 > 0 ? r2 : 1 - r2;
      return n2.ordinalNumber(a4, { unit: "year" });
    }
    return function(e6, t4) {
      var n3 = e6.getUTCFullYear(), r3 = n3 > 0 ? n3 : 1 - n3;
      return Oe$2("yy" === t4 ? r3 % 100 : r3, t4.length);
    }(e5, t3);
  },
  Y: function(e5, t3, n2, r2) {
    var a4 = z$1(e5, r2), o2 = a4 > 0 ? a4 : 1 - a4;
    return "YY" === t3 ? Oe$2(o2 % 100, 2) : "Yo" === t3 ? n2.ordinalNumber(o2, { unit: "year" }) : Oe$2(o2, t3.length);
  },
  R: function(e5, t3) {
    return Oe$2(Y$1(e5), t3.length);
  },
  u: function(e5, t3) {
    return Oe$2(e5.getUTCFullYear(), t3.length);
  },
  Q: function(e5, t3, n2) {
    var r2 = Math.ceil((e5.getUTCMonth() + 1) / 3);
    switch (t3) {
      case "Q":
        return String(r2);
      case "QQ":
        return Oe$2(r2, 2);
      case "Qo":
        return n2.ordinalNumber(r2, { unit: "quarter" });
      case "QQQ":
        return n2.quarter(r2, { width: "abbreviated", context: "formatting" });
      case "QQQQQ":
        return n2.quarter(r2, { width: "narrow", context: "formatting" });
      case "QQQQ":
      default:
        return n2.quarter(r2, { width: "wide", context: "formatting" });
    }
  },
  q: function(e5, t3, n2) {
    var r2 = Math.ceil((e5.getUTCMonth() + 1) / 3);
    switch (t3) {
      case "q":
        return String(r2);
      case "qq":
        return Oe$2(r2, 2);
      case "qo":
        return n2.ordinalNumber(r2, { unit: "quarter" });
      case "qqq":
        return n2.quarter(r2, { width: "abbreviated", context: "standalone" });
      case "qqqqq":
        return n2.quarter(r2, { width: "narrow", context: "standalone" });
      case "qqqq":
      default:
        return n2.quarter(r2, { width: "wide", context: "standalone" });
    }
  },
  M: function(e5, t3, n2) {
    var r2 = e5.getUTCMonth();
    switch (t3) {
      case "M":
      case "MM":
        return function(e6, t4) {
          var n3 = e6.getUTCMonth();
          return "M" === t4 ? String(n3 + 1) : Oe$2(n3 + 1, 2);
        }(e5, t3);
      case "Mo":
        return n2.ordinalNumber(r2 + 1, { unit: "month" });
      case "MMM":
        return n2.month(r2, { width: "abbreviated", context: "formatting" });
      case "MMMMM":
        return n2.month(r2, { width: "narrow", context: "formatting" });
      case "MMMM":
      default:
        return n2.month(r2, { width: "wide", context: "formatting" });
    }
  },
  L: function(e5, t3, n2) {
    var r2 = e5.getUTCMonth();
    switch (t3) {
      case "L":
        return String(r2 + 1);
      case "LL":
        return Oe$2(r2 + 1, 2);
      case "Lo":
        return n2.ordinalNumber(r2 + 1, { unit: "month" });
      case "LLL":
        return n2.month(r2, { width: "abbreviated", context: "standalone" });
      case "LLLLL":
        return n2.month(r2, { width: "narrow", context: "standalone" });
      case "LLLL":
      default:
        return n2.month(r2, { width: "wide", context: "standalone" });
    }
  },
  w: function(e5, t3, n2, r2) {
    var a4 = j$1(e5, r2);
    return "wo" === t3 ? n2.ordinalNumber(a4, { unit: "week" }) : Oe$2(a4, t3.length);
  },
  I: function(e5, t3, n2) {
    var r2 = q$1(e5);
    return "Io" === t3 ? n2.ordinalNumber(r2, { unit: "week" }) : Oe$2(r2, t3.length);
  },
  d: function(e5, t3, n2) {
    return "do" === t3 ? n2.ordinalNumber(e5.getUTCDate(), { unit: "date" }) : function(e6, t4) {
      return Oe$2(e6.getUTCDate(), t4.length);
    }(e5, t3);
  },
  D: function(e5, t3, n2) {
    var r2 = function(e6) {
      k$1(1, arguments);
      var t4 = x$1(e6), n3 = t4.getTime();
      t4.setUTCMonth(0, 1), t4.setUTCHours(0, 0, 0, 0);
      var r3 = t4.getTime(), a4 = n3 - r3;
      return Math.floor(a4 / 864e5) + 1;
    }(e5);
    return "Do" === t3 ? n2.ordinalNumber(r2, { unit: "dayOfYear" }) : Oe$2(r2, t3.length);
  },
  E: function(e5, t3, n2) {
    var r2 = e5.getUTCDay();
    switch (t3) {
      case "E":
      case "EE":
      case "EEE":
        return n2.day(r2, { width: "abbreviated", context: "formatting" });
      case "EEEEE":
        return n2.day(r2, { width: "narrow", context: "formatting" });
      case "EEEEEE":
        return n2.day(r2, { width: "short", context: "formatting" });
      case "EEEE":
      default:
        return n2.day(r2, { width: "wide", context: "formatting" });
    }
  },
  e: function(e5, t3, n2, r2) {
    var a4 = e5.getUTCDay(), o2 = (a4 - r2.weekStartsOn + 8) % 7 || 7;
    switch (t3) {
      case "e":
        return String(o2);
      case "ee":
        return Oe$2(o2, 2);
      case "eo":
        return n2.ordinalNumber(o2, { unit: "day" });
      case "eee":
        return n2.day(a4, { width: "abbreviated", context: "formatting" });
      case "eeeee":
        return n2.day(a4, { width: "narrow", context: "formatting" });
      case "eeeeee":
        return n2.day(a4, { width: "short", context: "formatting" });
      case "eeee":
      default:
        return n2.day(a4, { width: "wide", context: "formatting" });
    }
  },
  c: function(e5, t3, n2, r2) {
    var a4 = e5.getUTCDay(), o2 = (a4 - r2.weekStartsOn + 8) % 7 || 7;
    switch (t3) {
      case "c":
        return String(o2);
      case "cc":
        return Oe$2(o2, t3.length);
      case "co":
        return n2.ordinalNumber(o2, { unit: "day" });
      case "ccc":
        return n2.day(a4, { width: "abbreviated", context: "standalone" });
      case "ccccc":
        return n2.day(a4, { width: "narrow", context: "standalone" });
      case "cccccc":
        return n2.day(a4, { width: "short", context: "standalone" });
      case "cccc":
      default:
        return n2.day(a4, { width: "wide", context: "standalone" });
    }
  },
  i: function(e5, t3, n2) {
    var r2 = e5.getUTCDay(), a4 = 0 === r2 ? 7 : r2;
    switch (t3) {
      case "i":
        return String(a4);
      case "ii":
        return Oe$2(a4, t3.length);
      case "io":
        return n2.ordinalNumber(a4, { unit: "day" });
      case "iii":
        return n2.day(r2, { width: "abbreviated", context: "formatting" });
      case "iiiii":
        return n2.day(r2, { width: "narrow", context: "formatting" });
      case "iiiiii":
        return n2.day(r2, { width: "short", context: "formatting" });
      case "iiii":
      default:
        return n2.day(r2, { width: "wide", context: "formatting" });
    }
  },
  a: function(e5, t3, n2) {
    var r2 = e5.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t3) {
      case "a":
      case "aa":
      case "aaa":
        return n2.dayPeriod(r2, { width: "abbreviated", context: "formatting" });
      case "aaaaa":
        return n2.dayPeriod(r2, { width: "narrow", context: "formatting" });
      case "aaaa":
      default:
        return n2.dayPeriod(r2, { width: "wide", context: "formatting" });
    }
  },
  b: function(e5, t3, n2) {
    var r2, a4 = e5.getUTCHours();
    switch (r2 = 12 === a4 ? "noon" : 0 === a4 ? "midnight" : a4 / 12 >= 1 ? "pm" : "am", t3) {
      case "b":
      case "bb":
      case "bbb":
        return n2.dayPeriod(r2, { width: "abbreviated", context: "formatting" });
      case "bbbbb":
        return n2.dayPeriod(r2, { width: "narrow", context: "formatting" });
      case "bbbb":
      default:
        return n2.dayPeriod(r2, { width: "wide", context: "formatting" });
    }
  },
  B: function(e5, t3, n2) {
    var r2, a4 = e5.getUTCHours();
    switch (r2 = a4 >= 17 ? "evening" : a4 >= 12 ? "afternoon" : a4 >= 4 ? "morning" : "night", t3) {
      case "B":
      case "BB":
      case "BBB":
        return n2.dayPeriod(r2, { width: "abbreviated", context: "formatting" });
      case "BBBBB":
        return n2.dayPeriod(r2, { width: "narrow", context: "formatting" });
      case "BBBB":
      default:
        return n2.dayPeriod(r2, { width: "wide", context: "formatting" });
    }
  },
  h: function(e5, t3, n2) {
    if ("ho" === t3) {
      var r2 = e5.getUTCHours() % 12;
      return 0 === r2 && (r2 = 12), n2.ordinalNumber(r2, { unit: "hour" });
    }
    return function(e6, t4) {
      return Oe$2(e6.getUTCHours() % 12 || 12, t4.length);
    }(e5, t3);
  },
  H: function(e5, t3, n2) {
    return "Ho" === t3 ? n2.ordinalNumber(e5.getUTCHours(), { unit: "hour" }) : function(e6, t4) {
      return Oe$2(e6.getUTCHours(), t4.length);
    }(e5, t3);
  },
  K: function(e5, t3, n2) {
    var r2 = e5.getUTCHours() % 12;
    return "Ko" === t3 ? n2.ordinalNumber(r2, { unit: "hour" }) : Oe$2(r2, t3.length);
  },
  k: function(e5, t3, n2) {
    var r2 = e5.getUTCHours();
    return 0 === r2 && (r2 = 24), "ko" === t3 ? n2.ordinalNumber(r2, { unit: "hour" }) : Oe$2(r2, t3.length);
  },
  m: function(e5, t3, n2) {
    return "mo" === t3 ? n2.ordinalNumber(e5.getUTCMinutes(), { unit: "minute" }) : function(e6, t4) {
      return Oe$2(e6.getUTCMinutes(), t4.length);
    }(e5, t3);
  },
  s: function(e5, t3, n2) {
    return "so" === t3 ? n2.ordinalNumber(e5.getUTCSeconds(), { unit: "second" }) : function(e6, t4) {
      return Oe$2(e6.getUTCSeconds(), t4.length);
    }(e5, t3);
  },
  S: function(e5, t3) {
    return function(e6, t4) {
      var n2 = t4.length, r2 = e6.getUTCMilliseconds();
      return Oe$2(Math.floor(r2 * Math.pow(10, n2 - 3)), t4.length);
    }(e5, t3);
  },
  X: function(e5, t3, n2, r2) {
    var a4 = (r2._originalDate || e5).getTimezoneOffset();
    if (0 === a4) return "Z";
    switch (t3) {
      case "X":
        return Ue$2(a4);
      case "XXXX":
      case "XX":
        return Ne$2(a4);
      case "XXXXX":
      case "XXX":
      default:
        return Ne$2(a4, ":");
    }
  },
  x: function(e5, t3, n2, r2) {
    var a4 = (r2._originalDate || e5).getTimezoneOffset();
    switch (t3) {
      case "x":
        return Ue$2(a4);
      case "xxxx":
      case "xx":
        return Ne$2(a4);
      case "xxxxx":
      case "xxx":
      default:
        return Ne$2(a4, ":");
    }
  },
  O: function(e5, t3, n2, r2) {
    var a4 = (r2._originalDate || e5).getTimezoneOffset();
    switch (t3) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ze$2(a4, ":");
      case "OOOO":
      default:
        return "GMT" + Ne$2(a4, ":");
    }
  },
  z: function(e5, t3, n2, r2) {
    var a4 = (r2._originalDate || e5).getTimezoneOffset();
    switch (t3) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ze$2(a4, ":");
      case "zzzz":
      default:
        return "GMT" + Ne$2(a4, ":");
    }
  },
  t: function(e5, t3, n2, r2) {
    var a4 = r2._originalDate || e5;
    return Oe$2(Math.floor(a4.getTime() / 1e3), t3.length);
  },
  T: function(e5, t3, n2, r2) {
    return Oe$2((r2._originalDate || e5).getTime(), t3.length);
  }
};
function ze$2(e5, t3) {
  var n2 = e5 > 0 ? "-" : "+", r2 = Math.abs(e5), a4 = Math.floor(r2 / 60), o2 = r2 % 60;
  if (0 === o2) return n2 + String(a4);
  var i3 = t3;
  return n2 + String(a4) + i3 + Oe$2(o2, 2);
}
function Ue$2(e5, t3) {
  return e5 % 60 == 0 ? (e5 > 0 ? "-" : "+") + Oe$2(Math.abs(e5) / 60, 2) : Ne$2(e5, t3);
}
function Ne$2(e5, t3) {
  var n2 = t3 || "", r2 = e5 > 0 ? "-" : "+", a4 = Math.abs(e5);
  return r2 + Oe$2(Math.floor(a4 / 60), 2) + n2 + Oe$2(a4 % 60, 2);
}
var Ye$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ae$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, qe$1 = /^'([^]*?)'?$/, Ge$2 = /''/g, je$2 = /[a-zA-Z]/;
function Xe$1(e5, t3, n2) {
  k$1(2, arguments);
  var r2 = String(t3), a4 = {}, o2 = a4.locale || w$1, i3 = o2.options && o2.options.firstWeekContainsDate, d4 = null == i3 ? 1 : D$1(i3), s4 = null == a4.firstWeekContainsDate ? d4 : D$1(a4.firstWeekContainsDate);
  if (!(s4 >= 1 && s4 <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var c3 = o2.options && o2.options.weekStartsOn, u3 = null == c3 ? 0 : D$1(c3), l2 = null == a4.weekStartsOn ? u3 : D$1(a4.weekStartsOn);
  if (!(l2 >= 0 && l2 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!o2.localize) throw new RangeError("locale must contain localize property");
  if (!o2.formatLong) throw new RangeError("locale must contain formatLong property");
  var p2 = x$1(e5);
  if (!Pe$2(p2)) throw new RangeError("Invalid time value");
  var f2 = R$1(p2), g2 = T$1(p2, f2), h4 = { firstWeekContainsDate: s4, weekStartsOn: l2, locale: o2, _originalDate: p2 }, m4 = r2.match(Ae$1).map(function(e6) {
    var t4 = e6[0];
    return "p" === t4 || "P" === t4 ? (0, L$1[t4])(e6, o2.formatLong, h4) : e6;
  }).join("").match(Ye$1).map(function(e6) {
    if ("''" === e6) return "'";
    var t4 = e6[0];
    if ("'" === t4) return Qe$1(e6);
    var n3 = Ie$2[t4];
    if (n3)
      return !a4.useAdditionalWeekYearTokens && P$1(e6) && O$1(e6), !a4.useAdditionalDayOfYearTokens && H$1(e6) && O$1(e6), n3(g2, e6, o2.localize, h4);
    if (t4.match(je$2))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + t4 + "`"
      );
    return e6;
  }).join("");
  return m4;
}
function Qe$1(e5) {
  return e5.match(qe$1)[1].replace(Ge$2, "'");
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function Ve$1(e5, t3) {
  k$1(2, arguments);
  var n2 = x$1(e5), r2 = D$1(t3);
  return isNaN(r2) ? /* @__PURE__ */ new Date(NaN) : r2 ? (n2.setDate(n2.getDate() + r2), n2) : n2;
}
function Ze$2(e5, t3) {
  k$1(1, arguments);
  var n2 = e5 || {}, r2 = x$1(n2.start), a4 = x$1(n2.end), o2 = a4.getTime();
  if (!(r2.getTime() <= o2)) throw new RangeError("Invalid interval");
  var i3 = [], d4 = r2;
  d4.setHours(0, 0, 0, 0);
  var s4 = 1;
  if (isNaN(s4)) throw new RangeError("`options.step` must be a number greater than 1");
  for (; d4.getTime() <= o2; ) i3.push(x$1(d4)), d4.setDate(d4.getDate() + s4), d4.setHours(0, 0, 0, 0);
  return i3;
}
function Ke$1(e5, t3) {
  k$1(1, arguments);
  var n2 = {}, r2 = n2.locale, a4 = r2 && r2.options && r2.options.weekStartsOn, o2 = null == a4 ? 0 : D$1(a4), i3 = null == n2.weekStartsOn ? o2 : D$1(n2.weekStartsOn);
  if (!(i3 >= 0 && i3 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d4 = x$1(e5), s4 = d4.getDay(), c3 = 6 + (s4 < i3 ? -7 : 0) - (s4 - i3);
  return d4.setDate(d4.getDate() + c3), d4.setHours(23, 59, 59, 999), d4;
}
function Je$1(e5) {
  k$1(1, arguments);
  var t3 = x$1(e5);
  return t3.setDate(1), t3.setHours(0, 0, 0, 0), t3;
}
function _e$2(e5, t3) {
  k$1(1, arguments);
  var n2 = {}, r2 = n2.locale, a4 = r2 && r2.options && r2.options.weekStartsOn, o2 = null == a4 ? 0 : D$1(a4), i3 = null == n2.weekStartsOn ? o2 : D$1(n2.weekStartsOn);
  if (!(i3 >= 0 && i3 <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d4 = x$1(e5), s4 = d4.getDay(), c3 = (s4 < i3 ? 7 : 0) + s4 - i3;
  return d4.setDate(d4.getDate() - c3), d4.setHours(0, 0, 0, 0), d4;
}
var $e$2 = function(e5) {
  return Xe$1(e5, "dd");
}, et$1 = function(e5) {
  return Xe$1(e5, "eeeeee");
}, tt$1 = function(e5) {
  return Xe$1(e5, "MMMM yyyy");
};
function nt$1(e5) {
  var t3 = e5.year, n2 = e5.month, r2 = e5.firstDayOfWeek, o2 = void 0 === r2 ? 1 : r2, i3 = e5.dayLabelFormat, d4 = void 0 === i3 ? $e$2 : i3, s4 = e5.weekdayLabelFormat, c3 = void 0 === s4 ? et$1 : s4, u3 = e5.monthLabelFormat, l2 = void 0 === u3 ? tt$1 : u3;
  return {
    days: useMemo(
      function() {
        return function(e6) {
          var t4 = e6.year, n3 = e6.month, r3 = e6.firstDayOfWeek, a4 = void 0 === r3 ? 1 : r3, o3 = e6.dayLabelFormat, i4 = void 0 === o3 ? function(e7) {
            return Xe$1(e7, "dd");
          } : o3, d5 = new Date(t4, n3), s5 = Je$1(d5), c4 = function(e7) {
            k$1(1, arguments);
            var t5 = x$1(e7), n4 = t5.getDay();
            return n4;
          }(s5), u4 = function(e7) {
            k$1(1, arguments);
            var t5 = x$1(e7), n4 = t5.getMonth();
            return t5.setFullYear(t5.getFullYear(), n4 + 1, 0), t5.setHours(23, 59, 59, 999), t5;
          }(d5);
          return function() {
            for (var e7 = 0, t5 = 0, n4 = arguments.length; t5 < n4; t5++) e7 += arguments[t5].length;
            var r4 = Array(e7), a5 = 0;
            for (t5 = 0; t5 < n4; t5++)
              for (var o4 = arguments[t5], i5 = 0, d6 = o4.length; i5 < d6; i5++, a5++) r4[a5] = o4[i5];
            return r4;
          }(
            Array.from(Array(c4 >= a4 ? c4 - a4 : 6 - a4 + c4 + 1).keys()).fill(0),
            Ze$2({ start: s5, end: u4 }).map(function(e7) {
              return { date: e7, dayLabel: i4(e7) };
            })
          );
        }({ year: t3, month: n2, firstDayOfWeek: o2, dayLabelFormat: d4 });
      },
      [t3, n2, o2, d4]
    ),
    weekdayLabels: useMemo(
      function() {
        return function(e6) {
          var t4 = void 0 === e6 ? {} : e6, n3 = t4.firstDayOfWeek, r3 = void 0 === n3 ? 1 : n3, a4 = t4.weekdayLabelFormat, o3 = void 0 === a4 ? function(e7) {
            return Xe$1(e7, "iiiiii");
          } : a4, i4 = /* @__PURE__ */ new Date();
          return Ze$2({ start: Ve$1(_e$2(i4), r3), end: Ve$1(Ke$1(i4), r3) }).reduce(function(e7, t5) {
            return e7.push(o3(t5)), e7;
          }, []);
        }({ firstDayOfWeek: o2, weekdayLabelFormat: c3 });
      },
      [o2, c3]
    ),
    monthLabel: l2(new Date(t3, n2))
  };
}
function rt$1(e5, t3) {
  k$1(2, arguments);
  var n2 = x$1(e5), r2 = x$1(t3);
  return n2.getTime() < r2.getTime();
}
function at$1(e5, t3) {
  k$1(2, arguments);
  var n2 = x$1(e5), r2 = x$1(t3);
  return n2.getTime() > r2.getTime();
}
function ot$1(e5, t3) {
  k$1(2, arguments);
  var n2 = t3 || {}, r2 = x$1(e5).getTime(), a4 = x$1(n2.start).getTime(), o2 = x$1(n2.end).getTime();
  if (!(a4 <= o2)) throw new RangeError("Invalid interval");
  return r2 >= a4 && r2 <= o2;
}
function it$1(e5) {
  k$1(1, arguments);
  var t3 = x$1(e5);
  return t3.setHours(0, 0, 0, 0), t3;
}
function dt$1(e5, t3) {
  k$1(2, arguments);
  var n2 = it$1(e5), r2 = it$1(t3);
  return n2.getTime() === r2.getTime();
}
function st$1(e5, t3) {
  k$1(2, arguments);
  var n2 = x$1(e5), r2 = D$1(t3);
  if (isNaN(r2)) return /* @__PURE__ */ new Date(NaN);
  if (!r2) return n2;
  var a4 = n2.getDate(), o2 = new Date(n2.getTime());
  o2.setMonth(n2.getMonth() + r2 + 1, 0);
  var i3 = o2.getDate();
  return a4 >= i3 ? o2 : (n2.setFullYear(o2.getFullYear(), o2.getMonth(), a4), n2);
}
var ct$1 = function(e5, t3) {
  return void 0 === e5 && (e5 = []), e5.some(function(e6) {
    return dt$1(t3, e6);
  });
};
function ut$1(e5) {
  var t3 = Je$1(e5);
  return {
    year: function(e6) {
      k$1(1, arguments);
      var t4 = x$1(e6), n2 = t4.getFullYear();
      return n2;
    }(t3),
    month: function(e6) {
      k$1(1, arguments);
      var t4 = x$1(e6), n2 = t4.getMonth();
      return n2;
    }(t3),
    date: t3
  };
}
function lt$2(e5, t3) {
  var n2 = ut$1(t3 || it$1(Date.now())), r2 = n2.date, a4 = [n2];
  return e5 > 1 && (a4 = Array.from(Array(e5 - 1).keys()).reduce(function(e6) {
    return r2 = st$1(e6[e6.length - 1].date, 1), e6.concat([ut$1(r2)]);
  }, a4)), a4;
}
function pt$1(e5, t3, n2, r2) {
  var a4 = e5[r2 ? n2 > 0 ? 0 : e5.length - r2 : n2 > 0 ? e5.length - 1 : 0].date;
  return Array.from(Array(t3).keys()).reduce(function(e6) {
    return a4 = 0 === e6.length ? st$1(a4, n2) : st$1(a4, n2 >= 0 ? 1 : -1), n2 > 0 ? e6.concat([ut$1(a4)]) : [ut$1(a4)].concat(e6);
  }, []);
}
function ft$1(e5, t3, n2) {
  return e5 && "string" == typeof t3 ? Xe$1(e5, t3) : e5 && "function" == typeof t3 ? t3(e5) : n2;
}
function gt$2(e5) {
  var t3 = e5.startDate, n2 = e5.endDate, r2 = e5.isDateBlocked, a4 = e5.minBookingDays, o2 = e5.exactMinBookingDays, i3 = e5.minBookingDate, d4 = e5.maxBookingDate, s4 = !i3 || !rt$1(t3, Ve$1(i3, -1)), c3 = !d4 || !at$1(Ve$1(t3, a4 - 1), d4);
  return !((!t3 || 1 !== a4 || n2 || r2(t3)) && (t3 && a4 > 1 && !n2 && !o2 || t3 && a4 > 0 && o2 && s4 && c3 || t3 && a4 > 0 && o2 && !i3 && !d4 ? Ze$2({ start: t3, end: Ve$1(t3, a4 - 1) }).some(function(e6) {
    return r2(e6);
  }) : !t3 || !n2 || o2 || rt$1(n2, Ve$1(t3, a4 - 1)) || Ze$2({ start: t3, end: n2 }).some(function(e6) {
    return r2(e6);
  })));
}
var ht$1 = "startDate", mt$1 = "endDate";
function yt$1(e5) {
  var a4 = e5.startDate, o2 = e5.endDate, i3 = e5.focusedInput, d4 = e5.minBookingDate, s4 = e5.maxBookingDate, c3 = e5.onDatesChange, u3 = e5.initialVisibleMonth, l2 = e5.exactMinBookingDays, p2 = void 0 !== l2 && l2, f2 = e5.minBookingDays, g2 = void 0 === f2 ? 1 : f2, h4 = e5.numberOfMonths, m4 = void 0 === h4 ? 2 : h4, y4 = e5.firstDayOfWeek, v2 = void 0 === y4 ? 1 : y4, b3 = e5.isDateBlocked, w3 = void 0 === b3 ? function() {
    return false;
  } : b3, D3 = e5.unavailableDates, k3 = void 0 === D3 ? [] : D3, x3 = e5.changeActiveMonthOnSelect, C2 = void 0 === x3 || x3, T3 = useState(function() {
    return lt$2(m4, a4 || u3 || null);
  }), S4 = T3[0], B3 = T3[1], M4 = useState(null), L3 = M4[0], W2 = M4[1], R3 = useState(a4), E3 = R3[0], F2 = R3[1];
  useEffect(function() {
    return "undefined" != typeof window && window.addEventListener && window.addEventListener("keydown", I3), function() {
      window.removeEventListener && window.removeEventListener("keydown", I3);
    };
  });
  var H4 = function(e6) {
    return ct$1(k3, e6) || w3(e6);
  }, P2 = function(e6) {
    F2(e6), (!E3 || E3 && !dt$1(e6, E3)) && B3(lt$2(m4, e6));
  }, O3 = function(e6) {
    return function(e7) {
      var t3 = e7.date, n2 = e7.minBookingDate, r2 = e7.maxBookingDate, a5 = e7.isDateBlockedFn, o3 = e7.startDate, i4 = e7.endDate, d5 = e7.minBookingDays, s5 = void 0 === d5 ? 1 : d5, c4 = e7.unavailableDates, u4 = void 0 === c4 ? [] : c4, l3 = n2 ? new Date(n2.getFullYear(), n2.getMonth(), n2.getDate(), 0, 0, 0) : n2, p3 = r2 ? new Date(r2.getFullYear(), r2.getMonth(), r2.getDate(), 0, 0, 0) : r2;
      return !!(ct$1(u4, t3) || l3 && rt$1(t3, l3) || p3 && at$1(t3, p3) || o3 && !i4 && s5 > 1 && ot$1(t3, { start: o3, end: Ve$1(o3, s5 - 2) }) || a5 && a5(t3));
    }({
      date: e6,
      minBookingDate: d4,
      maxBookingDate: s4,
      startDate: a4,
      endDate: o2,
      minBookingDays: g2,
      isDateBlockedFn: H4
    });
  };
  function I3(e6) {
    if (("ArrowRight" === e6.key || "ArrowLeft" === e6.key || "ArrowDown" === e6.key || "ArrowUp" === e6.key) && !E3) {
      var t3 = S4[0];
      P2(t3.date), B3(lt$2(m4, t3.date));
    }
  }
  var z3 = useCallback(
    function() {
      B3(pt$1(S4, m4, -1)), F2(null);
    },
    [S4, m4]
  ), U2 = useCallback(
    function() {
      B3(pt$1(S4, m4, -1, 1)), F2(null);
    },
    [S4, m4]
  ), N2 = useCallback(
    function() {
      B3(pt$1(S4, m4, 1)), F2(null);
    },
    [S4, m4]
  ), Y3 = useCallback(
    function() {
      B3(pt$1(S4, m4, 1, 1)), F2(null);
    },
    [S4, m4]
  ), A2 = useCallback(
    function(e6) {
      B3(lt$2(m4, e6)), F2(null);
    },
    [m4]
  ), q3 = useCallback(
    function(e6) {
      void 0 === e6 && (e6 = 1), B3(pt$1(S4, m4, -(12 * e6 - m4 + 1))), F2(null);
    },
    [S4, m4]
  ), G3 = useCallback(
    function(e6) {
      void 0 === e6 && (e6 = 1), B3(pt$1(S4, m4, 12 * e6 - m4 + 1)), F2(null);
    },
    [S4, m4]
  );
  return {
    firstDayOfWeek: v2,
    activeMonths: S4,
    isDateSelected: function(e6) {
      return function(e7, t3, n2) {
        return !(!t3 || !n2) && ot$1(e7, { start: t3, end: n2 });
      }(e6, a4, o2);
    },
    isDateHovered: function(e6) {
      return function(e7) {
        var t3 = e7.date, n2 = e7.startDate, r2 = e7.endDate, a5 = e7.isDateBlocked, o3 = e7.hoveredDate, i4 = e7.minBookingDays;
        return o3 && i4 > 1 && e7.exactMinBookingDays && ot$1(t3, { start: o3, end: Ve$1(o3, i4 - 1) }) ? !Ze$2({ start: o3, end: Ve$1(o3, i4 - 1) }).some(function(e8) {
          return a5(e8);
        }) : n2 && !r2 && o3 && ot$1(t3, { start: n2, end: Ve$1(n2, i4 - 1) }) && dt$1(n2, o3) && i4 > 1 ? !Ze$2({ start: n2, end: Ve$1(n2, i4 - 1) }).some(function(e8) {
          return a5(e8);
        }) : !(!n2 || r2 || !o3 || rt$1(o3, n2) || !ot$1(t3, { start: n2, end: o3 }) || Ze$2({ start: n2, end: o3 }).some(function(e8) {
          return a5(e8);
        }));
      }({
        date: e6,
        hoveredDate: L3,
        startDate: a4,
        endDate: o2,
        minBookingDays: g2,
        exactMinBookingDays: p2,
        isDateBlocked: H4
      });
    },
    isFirstOrLastSelectedDate: function(e6) {
      return function(e7, t3, n2) {
        return !!(t3 && dt$1(e7, t3) || n2 && dt$1(e7, n2));
      }(e6, a4, o2);
    },
    isStartDate: function(e6) {
      return function(e7, t3) {
        return !(!t3 || !dt$1(e7, t3));
      }(e6, a4);
    },
    isEndDate: function(e6) {
      return function(e7, t3) {
        return !(!t3 || !dt$1(e7, t3));
      }(e6, o2);
    },
    isDateBlocked: O3,
    numberOfMonths: m4,
    isDateFocused: function(e6) {
      return !!E3 && dt$1(e6, E3);
    },
    focusedDate: E3,
    hoveredDate: L3,
    onResetDates: function() {
      c3({ startDate: null, endDate: null, focusedInput: "startDate" });
    },
    onDateHover: function(e6) {
      if (e6) {
        if (e6) {
          var t3 = !O3(e6) || a4 && dt$1(e6, a4), n2 = !d4 || !rt$1(e6, Ve$1(d4, -1)), r2 = !s4 || !at$1(e6, s4), i4 = Ve$1(e6, g2 - 1), c4 = !d4 || !rt$1(i4, d4), u4 = !s4 || !at$1(i4, s4), l3 = p2 && g2 > 1 && n2 && r2 && c4 && u4, f3 = a4 && !o2 && !p2 && n2 && r2, h5 = !(g2 > 1 && a4) || ot$1(e6, { start: a4, end: Ve$1(a4, g2 - 2) }), m5 = a4 && dt$1(e6, a4) && h5;
          t3 && (l3 || f3 || m5) ? W2(e6) : null !== L3 && W2(null);
        }
      } else W2(null);
    },
    onDateSelect: function(e6) {
      ("endDate" === i3 || "startDate" === i3) && g2 > 0 && p2 && gt$2({
        minBookingDays: g2,
        exactMinBookingDays: p2,
        minBookingDate: d4,
        maxBookingDate: s4,
        isDateBlocked: H4,
        startDate: e6,
        endDate: null
      }) ? c3({ startDate: e6, endDate: Ve$1(e6, g2 - 1), focusedInput: null }) : ("endDate" === i3 && a4 && rt$1(e6, a4) || "startDate" === i3 && o2 && at$1(e6, o2)) && !p2 && gt$2({ minBookingDays: g2, isDateBlocked: H4, startDate: e6, endDate: null }) ? c3({ endDate: null, startDate: e6, focusedInput: "endDate" }) : "startDate" === i3 && !p2 && gt$2({ minBookingDays: g2, isDateBlocked: H4, endDate: o2, startDate: e6 }) ? c3({ endDate: o2, startDate: e6, focusedInput: "endDate" }) : "startDate" === i3 && !p2 && gt$2({ minBookingDays: g2, isDateBlocked: H4, endDate: null, startDate: e6 }) ? c3({ endDate: null, startDate: e6, focusedInput: "endDate" }) : "endDate" === i3 && a4 && !rt$1(e6, a4) && !p2 && gt$2({ minBookingDays: g2, isDateBlocked: H4, startDate: a4, endDate: e6 }) && c3({ startDate: a4, endDate: e6, focusedInput: null }), "endDate" !== i3 && (!E3 || E3 && !dt$1(e6, E3)) && C2 && B3(lt$2(m4, e6));
    },
    onDateFocus: P2,
    goToPreviousMonths: z3,
    goToPreviousMonthsByOneMonth: U2,
    goToNextMonths: N2,
    goToNextMonthsByOneMonth: Y3,
    goToDate: A2,
    goToPreviousYear: q3,
    goToNextYear: G3
  };
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var vt$1 = function() {
  return (vt$1 = Object.assign || function(e5) {
    for (var t3, n2 = 1, r2 = arguments.length; n2 < r2; n2++)
      for (var a4 in t3 = arguments[n2])
        Object.prototype.hasOwnProperty.call(t3, a4) && (e5[a4] = t3[a4]);
    return e5;
  }).apply(this, arguments);
};
function bt$1(e5, t3) {
  return Object.defineProperty ? Object.defineProperty(e5, "raw", { value: t3 }) : e5.raw = t3, e5;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var wt$1 = Object.getOwnPropertySymbols, Dt$1 = Object.prototype.hasOwnProperty, kt$1 = Object.prototype.propertyIsEnumerable;
function xt$1(e5) {
  if (null == e5) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e5);
}
var Ct$1 = function() {
  try {
    if (!Object.assign) return false;
    var e5 = new String("abc");
    if (e5[5] = "de", "5" === Object.getOwnPropertyNames(e5)[0]) return false;
    for (var t3 = {}, n2 = 0; n2 < 10; n2++) t3["_" + String.fromCharCode(n2)] = n2;
    if ("0123456789" !== Object.getOwnPropertyNames(t3).map(function(e6) {
      return t3[e6];
    }).join(""))
      return false;
    var r2 = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(e6) {
      r2[e6] = e6;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r2)).join("");
  } catch (e6) {
    return false;
  }
}() ? Object.assign : function(e5, t3) {
  for (var n2, r2, a4 = xt$1(e5), o2 = 1; o2 < arguments.length; o2++) {
    for (var i3 in n2 = Object(arguments[o2])) Dt$1.call(n2, i3) && (a4[i3] = n2[i3]);
    if (wt$1) {
      r2 = wt$1(n2);
      for (var d4 = 0; d4 < r2.length; d4++) kt$1.call(n2, r2[d4]) && (a4[r2[d4]] = n2[r2[d4]]);
    }
  }
  return a4;
}, Tt$1 = function(e5, t3) {
  var n2 = Ct$1({}, e5, t3);
  for (var r2 in e5) {
    var a4;
    e5[r2] && "object" == typeof t3[r2] && Ct$1(n2, ((a4 = {})[r2] = Ct$1(e5[r2], t3[r2]), a4));
  }
  return n2;
}, St$1 = {
  breakpoints: [40, 52, 64].map(function(e5) {
    return e5 + "em";
  })
}, Bt = function(e5) {
  return "@media screen and (min-width: " + e5 + ")";
}, Mt$1 = function(e5, t3) {
  return Lt(t3, e5, e5);
}, Lt = function(e5, t3, n2, r2, a4) {
  for (t3 = t3 && t3.split ? t3.split(".") : [t3], r2 = 0; r2 < t3.length; r2++) e5 = e5 ? e5[t3[r2]] : a4;
  return e5 === a4 ? n2 : e5;
}, Wt = function e(t3) {
  var n2 = {}, r2 = function(e5) {
    var r3, a5, o2 = {}, i3 = false, d4 = e5.theme && e5.theme.disableStyledSystemCache;
    for (var s4 in e5)
      if (t3[s4]) {
        var c3 = t3[s4], u3 = e5[s4], l2 = Lt(e5.theme, c3.scale, c3.defaults);
        if ("object" != typeof u3) Ct$1(o2, c3(u3, l2, e5));
        else {
          if (n2.breakpoints = !d4 && n2.breakpoints || Lt(e5.theme, "breakpoints", St$1.breakpoints), Array.isArray(u3)) {
            n2.media = !d4 && n2.media || [null].concat(n2.breakpoints.map(Bt)), o2 = Tt$1(o2, Rt(n2.media, c3, l2, u3, e5));
            continue;
          }
          null !== u3 && (o2 = Tt$1(o2, Et$1(n2.breakpoints, c3, l2, u3, e5)), i3 = true);
        }
      }
    return i3 && (r3 = o2, a5 = {}, Object.keys(r3).sort(function(e6, t4) {
      return e6.localeCompare(t4, void 0, { numeric: true, sensitivity: "base" });
    }).forEach(function(e6) {
      a5[e6] = r3[e6];
    }), o2 = a5), o2;
  };
  r2.config = t3, r2.propNames = Object.keys(t3), r2.cache = n2;
  var a4 = Object.keys(t3).filter(function(e5) {
    return "config" !== e5;
  });
  return a4.length > 1 && a4.forEach(function(n3) {
    var a5;
    r2[n3] = e(((a5 = {})[n3] = t3[n3], a5));
  }), r2;
}, Rt = function(e5, t3, n2, r2, a4) {
  var o2 = {};
  return r2.slice(0, e5.length).forEach(function(r3, i3) {
    var d4, s4 = e5[i3], c3 = t3(r3, n2, a4);
    s4 ? Ct$1(o2, ((d4 = {})[s4] = Ct$1({}, o2[s4], c3), d4)) : Ct$1(o2, c3);
  }), o2;
}, Et$1 = function(e5, t3, n2, r2, a4) {
  var o2 = {};
  for (var i3 in r2) {
    var d4 = e5[i3], s4 = t3(r2[i3], n2, a4);
    if (d4) {
      var c3, u3 = Bt(d4);
      Ct$1(o2, ((c3 = {})[u3] = Ct$1({}, o2[u3], s4), c3));
    } else Ct$1(o2, s4);
  }
  return o2;
}, Ft = function(e5) {
  var t3 = e5.properties, n2 = e5.property, r2 = e5.scale, a4 = e5.transform, o2 = void 0 === a4 ? Mt$1 : a4, i3 = e5.defaultScale;
  t3 = t3 || [n2];
  var d4 = function(e6, n3, r3) {
    var a5 = {}, i4 = o2(e6, n3, r3);
    if (null !== i4)
      return t3.forEach(function(e7) {
        a5[e7] = i4;
      }), a5;
  };
  return d4.scale = r2, d4.defaults = i3, d4;
}, Ht = function(e5) {
  void 0 === e5 && (e5 = {});
  var t3 = {};
  return Object.keys(e5).forEach(function(n2) {
    var r2 = e5[n2];
    t3[n2] = true !== r2 ? "function" != typeof r2 ? Ft(r2) : r2 : Ft({ property: n2, scale: n2 });
  }), Wt(t3);
}, Pt$1 = function() {
  for (var e5 = {}, t3 = arguments.length, n2 = new Array(t3), r2 = 0; r2 < t3; r2++) n2[r2] = arguments[r2];
  n2.forEach(function(t4) {
    t4 && t4.config && Ct$1(e5, t4.config);
  });
  var a4 = Wt(e5);
  return a4;
}, Ot$1 = Ht({
  width: {
    property: "width",
    scale: "sizes",
    transform: function(e5, t3) {
      return Lt(
        t3,
        e5,
        !function(e6) {
          return "number" == typeof e6 && !isNaN(e6);
        }(e5) || e5 > 1 ? e5 : 100 * e5 + "%"
      );
    }
  },
  height: { property: "height", scale: "sizes" },
  minWidth: { property: "minWidth", scale: "sizes" },
  minHeight: { property: "minHeight", scale: "sizes" },
  maxWidth: { property: "maxWidth", scale: "sizes" },
  maxHeight: { property: "maxHeight", scale: "sizes" },
  size: { properties: ["width", "height"], scale: "sizes" },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
}), It = {
  color: { property: "color", scale: "colors" },
  backgroundColor: { property: "backgroundColor", scale: "colors" },
  opacity: true
};
It.bg = It.backgroundColor;
var zt = Ht(It), Ut = Ht({
  fontFamily: { property: "fontFamily", scale: "fonts" },
  fontSize: {
    property: "fontSize",
    scale: "fontSizes",
    defaultScale: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  },
  fontWeight: { property: "fontWeight", scale: "fontWeights" },
  lineHeight: { property: "lineHeight", scale: "lineHeights" },
  letterSpacing: { property: "letterSpacing", scale: "letterSpacings" },
  textAlign: true,
  fontStyle: true
}), Nt$1 = Ht({
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
}), Yt$1 = { space: [0, 4, 8, 16, 32, 64, 128, 256, 512] }, At = Ht({
  gridGap: { property: "gridGap", scale: "space", defaultScale: Yt$1.space },
  gridColumnGap: { property: "gridColumnGap", scale: "space", defaultScale: Yt$1.space },
  gridRowGap: { property: "gridRowGap", scale: "space", defaultScale: Yt$1.space },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
}), qt = {
  border: { property: "border", scale: "borders" },
  borderWidth: { property: "borderWidth", scale: "borderWidths" },
  borderStyle: { property: "borderStyle", scale: "borderStyles" },
  borderColor: { property: "borderColor", scale: "colors" },
  borderRadius: { property: "borderRadius", scale: "radii" },
  borderTop: { property: "borderTop", scale: "borders" },
  borderTopLeftRadius: { property: "borderTopLeftRadius", scale: "radii" },
  borderTopRightRadius: { property: "borderTopRightRadius", scale: "radii" },
  borderRight: { property: "borderRight", scale: "borders" },
  borderBottom: { property: "borderBottom", scale: "borders" },
  borderBottomLeftRadius: { property: "borderBottomLeftRadius", scale: "radii" },
  borderBottomRightRadius: { property: "borderBottomRightRadius", scale: "radii" },
  borderLeft: { property: "borderLeft", scale: "borders" },
  borderX: { properties: ["borderLeft", "borderRight"], scale: "borders" },
  borderY: { properties: ["borderTop", "borderBottom"], scale: "borders" },
  borderTopWidth: { property: "borderTopWidth", scale: "borderWidths" },
  borderTopColor: { property: "borderTopColor", scale: "colors" },
  borderTopStyle: { property: "borderTopStyle", scale: "borderStyles" }
};
qt.borderTopLeftRadius = { property: "borderTopLeftRadius", scale: "radii" }, qt.borderTopRightRadius = { property: "borderTopRightRadius", scale: "radii" }, qt.borderBottomWidth = { property: "borderBottomWidth", scale: "borderWidths" }, qt.borderBottomColor = { property: "borderBottomColor", scale: "colors" }, qt.borderBottomStyle = { property: "borderBottomStyle", scale: "borderStyles" }, qt.borderBottomLeftRadius = { property: "borderBottomLeftRadius", scale: "radii" }, qt.borderBottomRightRadius = { property: "borderBottomRightRadius", scale: "radii" }, qt.borderLeftWidth = { property: "borderLeftWidth", scale: "borderWidths" }, qt.borderLeftColor = { property: "borderLeftColor", scale: "colors" }, qt.borderLeftStyle = { property: "borderLeftStyle", scale: "borderStyles" }, qt.borderRightWidth = { property: "borderRightWidth", scale: "borderWidths" }, qt.borderRightColor = { property: "borderRightColor", scale: "colors" }, qt.borderRightStyle = { property: "borderRightStyle", scale: "borderStyles" };
var Gt = Ht(qt), jt = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
jt.bgImage = jt.backgroundImage, jt.bgSize = jt.backgroundSize, jt.bgPosition = jt.backgroundPosition, jt.bgRepeat = jt.backgroundRepeat;
var Xt = Ht(jt), Qt = { space: [0, 4, 8, 16, 32, 64, 128, 256, 512] }, Vt = Ht({
  position: true,
  zIndex: { property: "zIndex", scale: "zIndices" },
  top: { property: "top", scale: "space", defaultScale: Qt.space },
  right: { property: "right", scale: "space", defaultScale: Qt.space },
  bottom: { property: "bottom", scale: "space", defaultScale: Qt.space },
  left: { property: "left", scale: "space", defaultScale: Qt.space }
}), Zt = { space: [0, 4, 8, 16, 32, 64, 128, 256, 512] }, Kt = function(e5) {
  return "number" == typeof e5 && !isNaN(e5);
}, Jt = function(e5, t3) {
  if (!Kt(e5)) return Lt(t3, e5, e5);
  var n2 = e5 < 0, r2 = Math.abs(e5), a4 = Lt(t3, r2, r2);
  return Kt(a4) ? a4 * (n2 ? -1 : 1) : n2 ? "-" + a4 : a4;
}, _t$1 = {};
_t$1.margin = {
  margin: { property: "margin", scale: "space", transform: Jt, defaultScale: Zt.space },
  marginTop: { property: "marginTop", scale: "space", transform: Jt, defaultScale: Zt.space },
  marginRight: { property: "marginRight", scale: "space", transform: Jt, defaultScale: Zt.space },
  marginBottom: { property: "marginBottom", scale: "space", transform: Jt, defaultScale: Zt.space },
  marginLeft: { property: "marginLeft", scale: "space", transform: Jt, defaultScale: Zt.space },
  marginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "space",
    transform: Jt,
    defaultScale: Zt.space
  },
  marginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "space",
    transform: Jt,
    defaultScale: Zt.space
  }
}, _t$1.margin.m = _t$1.margin.margin, _t$1.margin.mt = _t$1.margin.marginTop, _t$1.margin.mr = _t$1.margin.marginRight, _t$1.margin.mb = _t$1.margin.marginBottom, _t$1.margin.ml = _t$1.margin.marginLeft, _t$1.margin.mx = _t$1.margin.marginX, _t$1.margin.my = _t$1.margin.marginY, _t$1.padding = {
  padding: { property: "padding", scale: "space", defaultScale: Zt.space },
  paddingTop: { property: "paddingTop", scale: "space", defaultScale: Zt.space },
  paddingRight: { property: "paddingRight", scale: "space", defaultScale: Zt.space },
  paddingBottom: { property: "paddingBottom", scale: "space", defaultScale: Zt.space },
  paddingLeft: { property: "paddingLeft", scale: "space", defaultScale: Zt.space },
  paddingX: { properties: ["paddingLeft", "paddingRight"], scale: "space", defaultScale: Zt.space },
  paddingY: { properties: ["paddingTop", "paddingBottom"], scale: "space", defaultScale: Zt.space }
}, _t$1.padding.p = _t$1.padding.padding, _t$1.padding.pt = _t$1.padding.paddingTop, _t$1.padding.pr = _t$1.padding.paddingRight, _t$1.padding.pb = _t$1.padding.paddingBottom, _t$1.padding.pl = _t$1.padding.paddingLeft, _t$1.padding.px = _t$1.padding.paddingX, _t$1.padding.py = _t$1.padding.paddingY;
var $t = Pt$1(Ht(_t$1.margin), Ht(_t$1.padding)), en = Ht({
  boxShadow: { property: "boxShadow", scale: "shadows" },
  textShadow: { property: "textShadow", scale: "shadows" }
});
function tn() {
  return (tn = Object.assign || function(e5) {
    for (var t3 = 1; t3 < arguments.length; t3++) {
      var n2 = arguments[t3];
      for (var r2 in n2) Object.prototype.hasOwnProperty.call(n2, r2) && (e5[r2] = n2[r2]);
    }
    return e5;
  }).apply(this, arguments);
}
var nn, rn, an, on = function(e5, t3, n2, r2, a4) {
  for (t3 = t3 && t3.split ? t3.split(".") : [t3], r2 = 0; r2 < t3.length; r2++) e5 = e5 ? e5[t3[r2]] : a4;
  return e5 === a4 ? n2 : e5;
}, dn = [40, 52, 64].map(function(e5) {
  return e5 + "em";
}), sn = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
}, cn = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
}, un = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  size: ["width", "height"]
}, ln = {
  color: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  outlineColor: "colors",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  fill: "colors",
  stroke: "colors"
}, pn = function(e5, t3) {
  if ("number" != typeof t3 || t3 >= 0) return on(e5, t3, t3);
  var n2 = Math.abs(t3), r2 = on(e5, n2, n2);
  return "string" == typeof r2 ? "-" + r2 : -1 * r2;
}, fn = [
  "margin",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "marginX",
  "marginY",
  "top",
  "bottom",
  "left",
  "right"
].reduce(function(e5, t3) {
  var n2;
  return tn({}, e5, ((n2 = {})[t3] = pn, n2));
}, {}), gn = function e2(t3) {
  return function(n2) {
    void 0 === n2 && (n2 = {});
    var r2 = tn({}, sn, {}, n2.theme || n2), a4 = {}, o2 = (/* @__PURE__ */ function(e5) {
      return function(t4) {
        var n3 = {}, r3 = on(t4, "breakpoints", dn), a5 = [null].concat(
          r3.map(function(e6) {
            return "@media screen and (min-width: " + e6 + ")";
          })
        );
        for (var o3 in e5) {
          var i4 = "function" == typeof e5[o3] ? e5[o3](t4) : e5[o3];
          if (null != i4)
            if (Array.isArray(i4))
              for (var d5 = 0; d5 < i4.slice(0, a5.length).length; d5++) {
                var s5 = a5[d5];
                s5 ? (n3[s5] = n3[s5] || {}, null != i4[d5] && (n3[s5][o3] = i4[d5])) : n3[o3] = i4[d5];
              }
            else n3[o3] = i4;
        }
        return n3;
      };
    }("function" == typeof t3 ? t3(r2) : t3))(r2);
    for (var i3 in o2) {
      var d4 = o2[i3], s4 = "function" == typeof d4 ? d4(r2) : d4;
      if ("variant" !== i3)
        if (s4 && "object" == typeof s4) a4[i3] = e2(s4)(r2);
        else {
          var c3 = on(cn, i3, i3), u3 = on(ln, c3), l2 = on(r2, u3, on(r2, c3, {})), p2 = on(fn, c3, on)(l2, s4, s4);
          if (un[c3]) for (var f2 = un[c3], g2 = 0; g2 < f2.length; g2++) a4[f2[g2]] = p2;
          else a4[c3] = p2;
        }
      else a4 = tn({}, a4, {}, e2(on(r2, s4))(r2));
    }
    return a4;
  };
}, hn = function(e5) {
  var t3, n2, r2 = e5.scale, a4 = e5.prop, o2 = void 0 === a4 ? "variant" : a4, i3 = e5.variants, d4 = void 0 === i3 ? {} : i3, s4 = e5.key;
  (n2 = Object.keys(d4).length ? function(e6, t4, n3) {
    return gn(Lt(t4, e6, null))(n3.theme);
  } : function(e6, t4) {
    return Lt(t4, e6, null);
  }).scale = r2 || s4, n2.defaults = d4;
  var c3 = ((t3 = {})[o2] = n2, t3);
  return Wt(c3);
}, mn = (hn({ key: "buttons" }), hn({ key: "textStyles", prop: "textStyle" }), hn({ key: "colorStyles", prop: "colors" }), Ot$1.width), yn = Ot$1.height, vn = Ot$1.minHeight, bn = Ot$1.display, wn = Ot$1.overflow, Dn = zt.opacity, kn = Ut.fontSize, xn = Ut.fontFamily, Cn = Ut.fontWeight, Tn = Ut.lineHeight, Sn = Nt$1.alignItems, Bn = Nt$1.justifyContent, Mn = Nt$1.flexWrap, Ln = Nt$1.flexDirection, Wn = Nt$1.flex, Rn = At.gridGap, En = At.gridColumnGap, Fn = At.gridRowGap, Hn = At.gridAutoFlow, Pn = At.gridAutoColumns, On = At.gridAutoRows, In = At.gridTemplateColumns, zn = At.gridTemplateRows, Un = At.gridTemplateAreas, Nn = At.gridArea, Yn = Gt.borderRadius, An = Vt.zIndex, qn = Vt.top, Gn = Vt.right, jn = Vt.bottom, Xn = Vt.left, Qn = function(e5) {
  var t3 = e5.prop, n2 = e5.cssProperty, r2 = e5.alias, a4 = e5.key, o2 = e5.transformValue, i3 = e5.scale, d4 = e5.properties, s4 = {};
  return s4[t3] = Ft({ properties: d4, property: n2 || t3, scale: a4, defaultScale: i3, transform: o2 }), r2 && (s4[r2] = s4[t3]), Wt(s4);
}, Vn = {
  datepickerStartDatePlaceholder: "Select",
  datepickerStartDateLabel: "Start date:",
  datepickerEndDatePlaceholder: "Select",
  datepickerEndDateLabel: "End date:",
  resetDates: "Reset dates",
  close: "Close"
}, Zn = vt$1(vt$1({}, Vn), {
  startDateAriaLabel: "Start date",
  endDateAriaLabel: "End date",
  startDatePlaceholder: "Start date",
  endDatePlaceholder: "End date"
});
vt$1(vt$1({}, Vn), { dateAriaLabel: "Select date", datePlaceholder: "Select date" });
var Jn = Qn({
  prop: "daySizeGridTemplateColumns",
  cssProperty: "gridTemplateColumns",
  key: "gridTemplateColumns",
  transformValue: function(e5) {
    return "repeat(7, " + e5 + "px)";
  },
  scale: [0, 4, 8, 16, 32]
}), _n = Pt$1(Pn, Hn, On, En, Rn, Fn, Un, In, zn, Sn, Bn, $t), $n = qe$2("div")(
  nn || (nn = bt$1(["\n  display: grid;\n  ", "\n  ", "\n"], ["\n  display: grid;\n  ", "\n  ", "\n"])),
  _n,
  Jn
), er = Pt$1($t, Wn, Mn, Ln, Sn, Bn, Nn, yn, mn), tr = qe$2("div")(
  rn || (rn = bt$1(["\n  display: flex;\n  ", "\n"], ["\n  display: flex;\n  ", "\n"])),
  er
), nr = Pt$1(Nn, yn, $t, mn, Vt, qn, Xn, Gn, jn, An), rr = qe$2("div")(
  an || (an = bt$1(
    ["\n  box-sizing: border-box;\n  ", "\n"],
    ["\n  box-sizing: border-box;\n  ", "\n"]
  )),
  nr
);
function ar(t3) {
  var n2 = t3.height, r2 = t3.width, a4 = t3.color, o2 = t3.className, i3 = void 0 === o2 ? "" : o2;
  return React__default.createElement(
    "svg",
    {
      width: r2,
      height: n2,
      color: a4,
      className: i3,
      viewBox: "0 0 12 12",
      xmlns: "http://www.w3.org/2000/svg"
    },
    React__default.createElement("path", {
      d: "M8 1H7v1h1V1zM6.5 6.5h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM6 3a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v2A.5.5 0 0 0 6 3zm3.5 5.5h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0-2h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM9 3a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v2A.5.5 0 0 0 9 3zm-.5 2.5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1zm-3 0h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1zm-2 3h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM11 1h-1v1h1v9H1V2h1V1H1a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM3.5 6.5h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM5 1H4v1h1V1zm1.5 7.5h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm-4-3h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1zM3 3a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v2A.5.5 0 0 0 3 3z",
      fill: "currentColor",
      fillRule: "nonzero"
    })
  );
}
function or(e5) {
  void 0 === e5 && (e5 = {});
  var t3 = useContext(Me$3);
  return useMemo(
    function() {
      return t3 && "object" == typeof t3 && t3.reactDatepicker && "object" == typeof t3.reactDatepicker ? Object.keys(e5).reduce(function(n2, r2) {
        var a4;
        return vt$1(vt$1({}, n2), ((a4 = {})[r2] = t3.reactDatepicker[r2] || e5[r2], a4));
      }, {}) : e5;
    },
    [t3, e5]
  );
}
var ir = "Montserrat, sans-serif", dr = {
  primaryColor: "#00aeef",
  silverCloud: "#929598",
  charcoal: "#001217",
  darcula: "#343132",
  mud: "#58595B",
  greey: "#808285",
  graci: "#BCBEC0",
  white: "#ffffff",
  accessibility: "#009fef",
  selectedDay: "#71c9ed",
  selectedDayHover: "#39beef",
  normalDayHover: "#e6e7e8"
}, sr = 36;
function cr(e5, t3, n2) {
  return n2 && "object" == typeof n2 && n2.reactDatepicker && "object" == typeof n2.reactDatepicker && n2.reactDatepicker.colors && "object" == typeof n2.reactDatepicker.colors && n2.reactDatepicker.colors[e5] ? n2.reactDatepicker.colors[e5] : t3;
}
var ur, lr, pr, fr = Qn({ prop: "placeholderColor", cssProperty: "color" }), gr = Qn({ prop: "placeholderFontWeight", cssProperty: "fontWeight" }), hr = Pt$1(Vt, Gt, Xt, bn, Yn, $t), mr = qe$2("label")(ur || (ur = bt$1(["\n  ", "\n"], ["\n  ", "\n"])), hr), yr = Pt$1(Vt, Xn, Gn, qn, yn, mn), vr = qe$2("div")(
  lr || (lr = bt$1(
    ["\n  ", "\n  cursor: pointer;\n\n  svg {\n    display: block;\n  }\n"],
    ["\n  ", "\n  cursor: pointer;\n\n  svg {\n    display: block;\n  }\n"]
  )),
  yr
), br = Pt$1(Xt, $t, xn, kn, zt, Cn, $t, Gt, mn, vn, en), wr = qe$2("input")(
  pr || (pr = bt$1(
    [
      "\n  ",
      "\n  cursor: pointer;\n  box-sizing: border-box;\n  outline: 0;\n\n  ::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    ",
      "\n    ",
      "\n  }\n  ::-moz-placeholder {\n    /* Firefox 19+ */\n    ",
      "\n    ",
      "\n  }\n  :-moz-placeholder {\n    /* Firefox 18- */\n    ",
      "\n    ",
      "\n  }\n"
    ],
    [
      "\n  ",
      "\n  cursor: pointer;\n  box-sizing: border-box;\n  outline: 0;\n\n  ::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    ",
      "\n    ",
      "\n  }\n  ::-moz-placeholder {\n    /* Firefox 19+ */\n    ",
      "\n    ",
      "\n  }\n  :-moz-placeholder {\n    /* Firefox 18- */\n    ",
      "\n    ",
      "\n  }\n"
    ]
  )),
  br,
  gr,
  fr,
  gr,
  fr,
  gr,
  fr
);
function Dr(r2) {
  var a4 = r2.placeholder, d4 = r2.id, s4 = r2.vertical, u3 = r2.isActive, l2 = r2.ariaLabel, p2 = r2.onClick, f2 = r2.value, g2 = r2.showCalendarIcon, h4 = r2.padding, m4 = r2.rtl, y4 = r2.disableAccessibility, v2 = r2.dateFormat, b3 = r2.onChange, C2 = void 0 === b3 ? function() {
  } : b3, B3 = useState(f2), M4 = B3[0], W2 = B3[1], E3 = useRef(null);
  useEffect(
    function() {
      W2(f2);
    },
    [f2]
  );
  var F2 = useContext(Me$3), I3 = or({
    fontFamily: ir,
    inputFontWeight: 600,
    inputFontSize: "14px",
    inputColor: cr("charcoal", dr.charcoal, F2),
    inputBackground: cr("white", dr.white, F2),
    inputMinHeight: "46px",
    inputWidth: "100%",
    inputPadding: h4,
    inputBorder: "0",
    inputPlaceholderFontWeight: 500,
    inputPlaceholderColor: cr("silverCloud", dr.silverCloud, F2),
    inputCalendarWrapperPosition: "absolute",
    inputCalendarWrapperHeight: "12px",
    inputCalendarWrapperWidth: "12px",
    inputCalendarWrapperTop: "16px",
    inputCalendarWrapperLeft: m4 ? "unset" : s4 ? "8px" : "16px",
    inputCalendarWrapperRight: m4 ? s4 ? "8px" : "16px" : "unset",
    inputCalendarIconWidth: "12px",
    inputCalendarIconHeight: "12px",
    inputCalendarIconColor: cr("graci", dr.graci, F2),
    inputLabelDisplay: "block",
    inputLabelPosition: "relative",
    inputLabelBorder: "1px solid " + cr("graci", dr.graci, F2),
    inputLabelBorderRadius: "2px",
    inputLabelBackground: cr("white", dr.white, F2),
    inputLabelMargin: "0",
    inputActiveBoxShadow: "inset 0px -3px 0 " + cr("primaryColor", dr.primaryColor, F2)
  });
  return React__default.createElement(
    mr,
    {
      htmlFor: d4,
      display: I3.inputLabelDisplay,
      position: I3.inputLabelPosition,
      border: I3.inputLabelBorder,
      background: I3.inputLabelBackground,
      borderRadius: I3.inputLabelBorderRadius,
      m: I3.inputLabelMargin
    },
    g2 && React__default.createElement(
      vr,
      {
        position: I3.inputCalendarWrapperPosition,
        height: I3.inputCalendarWrapperHeight,
        width: I3.inputCalendarWrapperWidth,
        top: I3.inputCalendarWrapperTop,
        left: I3.inputCalendarWrapperLeft,
        right: I3.inputCalendarWrapperRight
      },
      React__default.createElement(ar, {
        width: I3.inputCalendarIconWidth,
        height: I3.inputCalendarIconHeight,
        color: I3.inputCalendarIconColor
      })
    ),
    React__default.createElement(wr, {
      tabIndex: y4 ? -1 : 0,
      border: I3.inputBorder,
      p: I3.inputPadding,
      width: I3.inputWidth,
      minHeight: I3.inputMinHeight,
      background: I3.inputBackground,
      fontFamily: I3.fontFamily,
      color: I3.inputColor,
      fontSize: I3.inputFontSize,
      fontWeight: I3.inputFontWeight,
      placeholderColor: I3.inputPlaceholderColor,
      placeholderFontWeight: I3.inputPlaceholderFontWeight,
      boxShadow: u3 ? I3.inputActiveBoxShadow : "none",
      id: d4,
      placeholder: a4,
      "aria-label": l2,
      value: M4,
      autoComplete: "off",
      onChange: function(e5) {
        var t3 = e5.target.value;
        W2(t3), "number" == typeof E3.current && clearTimeout(E3.current), E3.current = setTimeout(function() {
          p2();
          var e6 = function(e7, t4, n2, r3) {
            k$1(3, arguments);
            var a5 = String(e7), o2 = String(t4), i3 = {}, d5 = i3.locale || w$1;
            if (!d5.match) throw new RangeError("locale must contain match property");
            var s5 = d5.options && d5.options.firstWeekContainsDate, c3 = null == s5 ? 1 : D$1(s5), u4 = null == i3.firstWeekContainsDate ? c3 : D$1(i3.firstWeekContainsDate);
            if (!(u4 >= 1 && u4 <= 7))
              throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
            var l3 = d5.options && d5.options.weekStartsOn, p3 = null == l3 ? 0 : D$1(l3), f3 = null == i3.weekStartsOn ? p3 : D$1(i3.weekStartsOn);
            if (!(f3 >= 0 && f3 <= 6))
              throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
            if ("" === o2) return "" === a5 ? x$1(n2) : /* @__PURE__ */ new Date(NaN);
            var g3, h5 = { firstWeekContainsDate: u4, weekStartsOn: f3, locale: d5 }, m5 = [{ priority: 10, set: Fe$2, index: 0 }], y5 = o2.match(Me$2).map(function(e8) {
              var t5 = e8[0];
              return "p" === t5 || "P" === t5 ? (0, L$1[t5])(e8, d5.formatLong, h5) : e8;
            }).join("").match(Be$2), v3 = [];
            for (g3 = 0; g3 < y5.length; g3++) {
              var b4 = y5[g3];
              !i3.useAdditionalWeekYearTokens && P$1(b4) && O$1(b4), !i3.useAdditionalDayOfYearTokens && H$1(b4) && O$1(b4);
              var C3 = b4[0], B4 = Se$2[C3];
              if (B4) {
                var M5 = B4.incompatibleTokens;
                if (Array.isArray(M5)) {
                  for (var W3 = void 0, E4 = 0; E4 < v3.length; E4++) {
                    var F3 = v3[E4].token;
                    if (-1 !== M5.indexOf(F3) || F3 === C3) {
                      W3 = v3[E4];
                      break;
                    }
                  }
                  if (W3)
                    throw new RangeError(
                      "The format string mustn't contain `".concat(W3.fullToken, "` and `").concat(b4, "` at the same time")
                    );
                } else if ("*" === B4.incompatibleTokens && v3.length)
                  throw new RangeError(
                    "The format string mustn't contain `".concat(
                      b4,
                      "` and any other token at the same time"
                    )
                  );
                v3.push({ token: C3, fullToken: b4 });
                var I4 = B4.parse(a5, b4, d5.match, h5);
                if (!I4) return /* @__PURE__ */ new Date(NaN);
                m5.push({
                  priority: B4.priority,
                  set: B4.set,
                  validate: B4.validate,
                  value: I4.value,
                  index: m5.length
                }), a5 = I4.rest;
              } else {
                if (C3.match(Ee$2))
                  throw new RangeError(
                    "Format string contains an unescaped latin alphabet character `" + C3 + "`"
                  );
                if ("''" === b4 ? b4 = "'" : "'" === C3 && (b4 = He$2(b4)), 0 !== a5.indexOf(b4))
                  return /* @__PURE__ */ new Date(NaN);
                a5 = a5.slice(b4.length);
              }
            }
            if (a5.length > 0 && Re$2.test(a5)) return /* @__PURE__ */ new Date(NaN);
            var z3 = m5.map(function(e8) {
              return e8.priority;
            }).sort(function(e8, t5) {
              return t5 - e8;
            }).filter(function(e8, t5, n3) {
              return n3.indexOf(e8) === t5;
            }).map(function(e8) {
              return m5.filter(function(t5) {
                return t5.priority === e8;
              }).reverse();
            }).map(function(e8) {
              return e8[0];
            }), U2 = x$1(n2);
            if (isNaN(U2)) return /* @__PURE__ */ new Date(NaN);
            var N2 = T$1(U2, R$1(U2)), Y3 = {};
            for (g3 = 0; g3 < z3.length; g3++) {
              var A2 = z3[g3];
              if (A2.validate && !A2.validate(N2, A2.value, h5)) return /* @__PURE__ */ new Date(NaN);
              var q3 = A2.set(N2, Y3, A2.value, h5);
              q3[0] ? (N2 = q3[0], S$1(Y3, q3[1])) : N2 = q3;
            }
            return N2;
          }(t3, v2, /* @__PURE__ */ new Date());
          isNaN(e6) || C2(e6);
        }, 1e3);
      },
      onFocus: p2,
      "data-testid": "DatepickerInput"
    })
  );
}
function kr(t3) {
  var n2 = t3.height, r2 = t3.width, a4 = t3.iconColor, o2 = t3.direction, i3 = void 0 === o2 ? "right" : o2, d4 = t3.className, s4 = void 0 === d4 ? "" : d4, c3 = function(e5) {
    switch (e5) {
      case "up":
        return 0;
      case "down":
        return 180;
      case "left":
        return -90;
      case "right":
      default:
        return 90;
    }
  }(i3);
  return React__default.createElement(
    "svg",
    {
      width: r2,
      height: n2,
      color: a4,
      className: s4,
      transform: "rotate(" + c3 + " 0 0)",
      viewBox: "0 0 9 12",
      xmlns: "http://www.w3.org/2000/svg"
    },
    React__default.createElement("path", {
      fill: "currentColor",
      d: "M4.46.001a.538.538 0 0 0-.358.174L.156 4.48a.538.538 0 1 0 .796.724l3.01-3.285v13.689a.563.563 0 0 0 .538.55.563.563 0 0 0 .538-.55V1.918l3.01 3.286a.538.538 0 1 0 .796-.724L4.898.175a.538.538 0 0 0-.437-.174z"
    })
  );
}
var xr, Cr, Tr, Sr = Pt$1(xn, kn, Cn, zt, Tn, $t), Br = qe$2("div")(xr || (xr = bt$1(["\n  ", "\n"], ["\n  ", "\n"])), Sr), Mr = qe$2(Br)(
  Tr || (Tr = bt$1(
    [
      "\n  position: relative;\n  display: inline-block;\n\n  &:after {\n    content: '';\n    position: absolute;\n    height: 2px;\n    width: 100%;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n  }\n\n  ",
      "\n"
    ],
    [
      "\n  position: relative;\n  display: inline-block;\n\n  &:after {\n    content: '';\n    position: absolute;\n    height: 2px;\n    width: 100%;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n  }\n\n  ",
      "\n"
    ]
  )),
  function(e5) {
    var t3 = e5.isActive, n2 = e5.selectDateBorderColor;
    return t3 && Ae$2(
      Cr || (Cr = bt$1(
        ["\n      &:after {\n        background: ", ";\n      }\n    "],
        ["\n      &:after {\n        background: ", ";\n      }\n    "]
      )),
      n2
    );
  }
);
function Lr(t3) {
  var n2 = t3.title, r2 = t3.isActive, a4 = t3.date, i3 = t3.vertical, d4 = useContext(Me$3), s4 = or({
    fontFamily: ir,
    selectDateLabelFontSize: "11px",
    selectDateLabelColor: cr("silverCloud", dr.silverCloud, d4),
    selectDateLabelMargin: "0 0 8px",
    selectDateDateColor: cr("charcoal", dr.charcoal, d4),
    selectDateDateFontSize: i3 ? "16px" : "24px",
    selectDateDateFontWeight: 500,
    selectDateDatePadding: "0 0 15px",
    selectDateBorderColor: cr("primaryColor", dr.primaryColor, d4),
    selectDatePadding: "0"
  });
  return React__default.createElement(
    rr,
    { p: s4.selectDatePadding },
    React__default.createElement(
      Br,
      {
        fontFamily: s4.fontFamily,
        fontSize: s4.selectDateLabelFontSize,
        color: s4.selectDateLabelColor,
        m: s4.selectDateLabelMargin
      },
      n2
    ),
    React__default.createElement(
      Mr,
      {
        as: "span",
        color: s4.selectDateDateColor,
        fontSize: s4.selectDateDateFontSize,
        fontWeight: s4.selectDateDateFontWeight,
        fontFamily: s4.fontFamily,
        p: s4.selectDateDatePadding,
        isActive: r2,
        selectDateBorderColor: s4.selectDateBorderColor
      },
      a4
    )
  );
}
var Wr, Rr, Er, Fr, Hr, Pr = function(t3) {
  var n2 = t3.label, r2 = useContext(Me$3), a4 = or({
    fontFamily: ir,
    monthLabelColor: cr("darcula", dr.darcula, r2),
    monthLabelLineHeight: 1.57,
    monthLabelFontWeight: 600,
    monthLabelFontSize: "14px"
  });
  return React__default.createElement(
    Br,
    {
      fontFamily: a4.fontFamily,
      fontSize: a4.monthLabelFontSize,
      fontWeight: a4.monthLabelFontWeight,
      lineHeight: a4.monthLabelLineHeight,
      color: a4.monthLabelColor,
      "data-testid": "MonthLabel"
    },
    n2
  );
}, Or = function(t3) {
  var n2 = t3.label, r2 = useContext(Me$3), a4 = or({
    fontFamily: ir,
    dayLabelColor: cr("silverCloud", dr.silverCloud, r2),
    dayLabelFontWeight: 500,
    dayLabelFontSize: "11px"
  });
  return React__default.createElement(
    Br,
    {
      fontFamily: a4.fontFamily,
      fontSize: a4.dayLabelFontSize,
      fontWeight: a4.dayLabelFontWeight,
      color: a4.dayLabelColor,
      "data-testid": "DayLabel"
    },
    n2
  );
}, Ir = {
  rtl: false,
  focusedDate: null,
  isDateFocused: function() {
    return false;
  },
  isDateSelected: function() {
    return false;
  },
  isDateHovered: function() {
    return false;
  },
  isDateBlocked: function() {
    return false;
  },
  isFirstOrLastSelectedDate: function() {
    return false;
  },
  onDateFocus: function() {
  },
  onDateHover: function() {
  },
  onDateSelect: function() {
  },
  onDayRender: void 0
}, zr = React__default.createContext(Ir), Ur = Qn({
  prop: "dayHeight",
  cssProperty: "height",
  key: "dayHeight",
  transformValue: function(e5) {
    return e5 + "px";
  },
  scale: [0, 4, 8, 16, 32]
}), Nr = Qn({
  prop: "dayWidth",
  cssProperty: "width",
  key: "dayWidth",
  transformValue: function(e5) {
    return e5 + "px";
  },
  scale: [0, 4, 8, 16, 32]
}), Yr = Qn({
  prop: "dayHoverColor",
  cssProperty: "color",
  key: "dayHoverColor",
  transformValue: function(e5) {
    return e5;
  },
  scale: [0, 4, 8, 16, 32]
}), Ar = Qn({
  prop: "daySelectedHoverColor",
  cssProperty: "color",
  key: "daySelectedHoverColor",
  transformValue: function(e5) {
    return e5;
  },
  scale: [0, 4, 8, 16, 32]
}), qr = Qn({
  prop: "dayHoverBackground",
  cssProperty: "background",
  key: "dayHoverBackground",
  transformValue: function(e5) {
    return e5;
  },
  scale: [0, 4, 8, 16, 32]
}), Gr = Qn({
  prop: "daySelectedHoverBackground",
  cssProperty: "background",
  key: "daySelectedHoverBackground",
  transformValue: function(e5) {
    return e5;
  },
  scale: [0, 4, 8, 16, 32]
}), jr = Pt$1(en, Xt, zt, xn, Cn, kn), Xr = qe$2("button")(
  Hr || (Hr = bt$1(
    [
      "\n  ",
      "\n  ",
      "\n  ",
      "\n  cursor: pointer;\n  border: 0;\n  padding: 0;\n  outline: 0;\n\n  ",
      "\n\n  // @ts-ignore\n  ",
      "\n\n  &:focus {\n    // @ts-ignore\n    ",
      "\n  }\n"
    ],
    [
      "\n  ",
      "\n  ",
      "\n  ",
      "\n  cursor: pointer;\n  border: 0;\n  padding: 0;\n  outline: 0;\n\n  ",
      "\n\n  // @ts-ignore\n  ",
      "\n\n  &:focus {\n    // @ts-ignore\n    ",
      "\n  }\n"
    ]
  )),
  Ur,
  Nr,
  jr,
  function(e5) {
    var t3 = e5.disabledDate, n2 = e5.isSelectedStartOrEnd;
    return t3 && !n2 && Ae$2(
      Wr || (Wr = bt$1(
        ["\n      cursor: initial;\n      opacity: 0.4;\n    "],
        ["\n      cursor: initial;\n      opacity: 0.4;\n    "]
      ))
    );
  },
  function(e5) {
    var t3 = e5.disabledDate, n2 = e5.isSelected, r2 = e5.isSelectedStartOrEnd, a4 = e5.isWithinHoverRange;
    return t3 || n2 || r2 || a4 ? n2 && !r2 ? Ae$2(
      Er || (Er = bt$1(
        ["\n        &:hover {\n          ", "\n          ", "\n        }\n      "],
        ["\n        &:hover {\n          ", "\n          ", "\n        }\n      "]
      )),
      Gr,
      Ar
    ) : "" : Ae$2(
      Rr || (Rr = bt$1(
        ["\n        &:hover {\n          ", "\n          ", "\n        }\n      "],
        ["\n        &:hover {\n          ", "\n          ", "\n        }\n      "]
      )),
      qr,
      Yr
    );
  },
  function(e5) {
    var t3 = e5.borderAccessibilityColor;
    return Ae$2(
      Fr || (Fr = bt$1(
        ["\n      box-shadow: none;\n      border: 2px solid ", ";\n    "],
        ["\n      box-shadow: none;\n      border: 2px solid ", ";\n    "]
      )),
      t3
    );
  }
);
function Qr(e5, t3, n2, r2) {
  var a4 = r2.selectedFirstOrLast, o2 = r2.normal, i3 = r2.selected, d4 = r2.rangeHover;
  return t3 ? a4 : e5 ? i3 : n2 ? d4 : o2;
}
function Vr(t3) {
  var n2 = t3.day, d4 = t3.date, s4 = useRef(null), u3 = useContext(zr), l2 = u3.focusedDate, p2 = u3.isDateFocused, f2 = u3.isDateSelected, g2 = u3.isDateHovered, h4 = u3.isDateBlocked, m4 = u3.isFirstOrLastSelectedDate, y4 = u3.onDateSelect, v2 = u3.onDateFocus, b3 = u3.onDateHover, w3 = u3.onDayRender, D3 = function(e5) {
    var t4 = e5.date, n3 = e5.focusedDate, a4 = e5.isDateSelected, o2 = e5.isDateFocused, i3 = e5.isFirstOrLastSelectedDate, d5 = e5.isDateHovered, s5 = e5.isDateBlocked, c3 = e5.onDateSelect, u4 = e5.onDateFocus, l3 = e5.onDateHover, p3 = useCallback(
      function() {
        return c3(t4);
      },
      [t4, c3]
    ), f3 = useCallback(
      function() {
        return l3(t4);
      },
      [t4, l3]
    ), g3 = s5(t4) && !d5(t4);
    return {
      tabIndex: null === n3 || o2(t4) ? 0 : -1,
      isSelected: a4(t4),
      isSelectedStartOrEnd: i3(t4),
      isWithinHoverRange: d5(t4),
      disabledDate: g3,
      onKeyDown: function(e6) {
        "ArrowRight" === e6.key ? u4(Ve$1(t4, 1)) : "ArrowLeft" === e6.key ? u4(Ve$1(t4, -1)) : "ArrowUp" === e6.key ? u4(Ve$1(t4, -7)) : "ArrowDown" === e6.key && u4(Ve$1(t4, 7));
      },
      onClick: g3 ? function() {
      } : p3,
      onMouseEnter: f3
    };
  }({
    date: d4,
    focusedDate: l2,
    isDateFocused: p2,
    isDateSelected: f2,
    isDateHovered: g2,
    isDateBlocked: h4,
    isFirstOrLastSelectedDate: m4,
    onDateFocus: v2,
    onDateSelect: y4,
    onDateHover: b3,
    dayRef: s4
  }), k3 = useContext(Me$3), x3 = cr("white", dr.white, k3), C2 = cr("mud", dr.mud, k3), T3 = cr("primaryColor", dr.primaryColor, k3), S4 = cr("accessibility", dr.accessibility, k3), B3 = cr("selectedDay", dr.selectedDay, k3), M4 = cr("selectedDayHover", dr.selectedDayHover, k3), L3 = cr("normalDayHover", dr.normalDayHover, k3), W2 = or({
    fontFamily: ir,
    daySize: sr,
    dayFontWeight: 500,
    dayFontSize: "14px",
    dayColor: C2,
    dayHoverColor: C2,
    daySelectedColor: x3,
    daySelectedHoverColor: x3,
    dayHoverRangeColor: x3,
    daySelectedFirstOrLastColor: x3,
    dayBackground: x3,
    dayHoverBackground: L3,
    daySelectedBackground: B3,
    daySelectedHoverBackground: M4,
    dayHoverRangeBackground: B3,
    daySelectedFirstOrLastBackground: T3,
    dayBorderColor: L3,
    daySelectedBorderColor: B3,
    dayHoverRangeBorderColor: B3,
    daySelectedFirstOrLastBorderColor: T3,
    dayAccessibilityBorderColor: S4
  }), R3 = useMemo(
    function() {
      return Qr(D3.isSelected, D3.isSelectedStartOrEnd, D3.isWithinHoverRange, {
        selectedFirstOrLast: W2.daySelectedFirstOrLastBorderColor,
        selected: W2.daySelectedBorderColor,
        normal: W2.dayBorderColor,
        rangeHover: W2.dayHoverRangeColor
      });
    },
    [D3.isSelected, D3.isSelectedStartOrEnd, W2, D3.isWithinHoverRange]
  ), E3 = useMemo(
    function() {
      return Qr(D3.isSelected, D3.isSelectedStartOrEnd, D3.isWithinHoverRange, {
        selectedFirstOrLast: W2.daySelectedFirstOrLastBackground,
        selected: W2.daySelectedBackground,
        normal: W2.dayBackground,
        rangeHover: W2.dayHoverRangeBackground
      });
    },
    [D3.isSelected, D3.isSelectedStartOrEnd, W2, D3.isWithinHoverRange]
  ), F2 = useMemo(
    function() {
      return Qr(D3.isSelected, D3.isSelectedStartOrEnd, D3.isWithinHoverRange, {
        selectedFirstOrLast: W2.daySelectedFirstOrLastColor,
        selected: W2.daySelectedColor,
        normal: W2.dayColor,
        rangeHover: W2.dayHoverRangeColor
      });
    },
    [D3.isSelected, D3.isSelectedStartOrEnd, W2, D3.isWithinHoverRange]
  );
  return React__default.createElement(
    Xr,
    vt$1({}, D3, {
      ref: s4,
      dayHeight: W2.daySize,
      dayWidth: W2.daySize,
      background: E3,
      color: F2,
      fontFamily: W2.fontFamily,
      fontWeight: W2.dayFontWeight,
      fontSize: W2.dayFontSize,
      daySelectedHoverBackground: W2.daySelectedHoverBackground,
      dayHoverBackground: W2.dayHoverBackground,
      dayHoverColor: W2.dayHoverColor,
      daySelectedHoverColor: W2.daySelectedHoverColor,
      borderAccessibilityColor: W2.dayAccessibilityBorderColor,
      boxShadow: "1px 0 0 0 " + R3 + ",\n        0 1px 0 0 " + R3 + ",\n        1px 1px 0 0 " + R3 + ",\n        1px 0 0 0 " + R3 + " inset,\n        0 1px 0 0 " + R3 + " inset",
      "data-testid": "Day",
      "aria-label": "Day-" + d4.toDateString(),
      type: "button"
    }),
    "function" == typeof w3 ? w3(d4) : React__default.createElement(
      tr,
      { justifyContent: "center", alignItems: "center", height: "100%", width: "100%" },
      n2
    )
  );
}
var Zr, Kr, Jr = We$3(
  Zr || (Zr = bt$1(
    ["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"],
    ["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"]
  ))
), _r = qe$2("div")(
  Kr || (Kr = bt$1(
    [
      "\n  animation-name: ",
      ";\n  animation-duration: 0.25s;\n  animation-timing-function: ease-in;\n\n  &:last-child {\n    padding: 0 1px 1px 0;\n  }\n"
    ],
    [
      "\n  animation-name: ",
      ";\n  animation-duration: 0.25s;\n  animation-timing-function: ease-in;\n\n  &:last-child {\n    padding: 0 1px 1px 0;\n  }\n"
    ]
  )),
  Jr
), $r = function(t3) {
  var n2 = t3.year, r2 = t3.month, a4 = t3.firstDayOfWeek, o2 = nt$1({
    dayLabelFormat: t3.dayLabelFormat,
    monthLabelFormat: t3.monthLabelFormat,
    weekdayLabelFormat: t3.weekdayLabelFormat,
    year: n2,
    month: r2,
    firstDayOfWeek: a4
  }), i3 = o2.days, d4 = o2.weekdayLabels, s4 = o2.monthLabel, c3 = or({ daySize: sr, monthLabelMargin: "0 0 28px", monthDayLabelMargin: "0 0 16px" });
  return React__default.createElement(
    _r,
    null,
    React__default.createElement(
      tr,
      { justifyContent: "center", m: c3.monthLabelMargin },
      React__default.createElement(Pr, { label: s4 })
    ),
    React__default.createElement(
      $n,
      { daySizeGridTemplateColumns: c3.daySize },
      d4.map(function(t4) {
        return React__default.createElement(
          tr,
          { key: t4, justifyContent: "center", m: c3.monthDayLabelMargin },
          React__default.createElement(Or, { label: t4 })
        );
      })
    ),
    React__default.createElement(
      $n,
      { daySizeGridTemplateColumns: c3.daySize },
      i3.map(function(t4, n3) {
        return "object" == typeof t4 ? React__default.createElement(Vr, { date: t4.date, key: t4.dayLabel, day: t4.dayLabel }) : React__default.createElement("div", { key: n3 });
      })
    )
  );
};
var ea, ta, na, ra = qe$2("button")(
  ea || (ea = bt$1(
    [
      "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  border: 0;\n  background: transparent;\n  padding: 0;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ],
    [
      "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  border: 0;\n  background: transparent;\n  padding: 0;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]
  ))
), aa = qe$2(function(t3) {
  var n2 = t3.height, r2 = t3.width, a4 = t3.color, o2 = t3.className, i3 = void 0 === o2 ? "" : o2;
  return React__default.createElement(
    "svg",
    {
      width: r2,
      height: n2,
      color: a4,
      className: i3,
      viewBox: "0 0 14 14",
      xmlns: "http://www.w3.org/2000/svg"
    },
    React__default.createElement("path", {
      fill: "currentColor",
      fillRule: "nonzero",
      d: "M9.015 11.15c-.027-.18-.04-.39-.067-.585a3.958 3.958 0 0 1-4.48-.056C2.663 9.241 2.142 6.663 3.292 4.74c1.217-2.02 3.797-2.592 5.696-1.282.589.404 1.03.934 1.35 1.533l-1.216.808L13 7.917l-.174-4.556-1.056.696a5.812 5.812 0 0 0-1.846-2.062C7.25.155 3.64.935 1.901 3.765c-1.672 2.717-.95 6.382 1.605 8.194a5.535 5.535 0 0 0 5.616.501c0-.083 0-.167-.013-.264a9.193 9.193 0 0 0-.094-1.046z"
    })
  );
})(na || (na = bt$1(["\n  ", "\n"], ["\n  ", "\n"])), function(e5) {
  return e5.rtl && Ae$2(
    ta || (ta = bt$1(
      ["\n      transform: rotate(-180deg);\n    "],
      ["\n      transform: rotate(-180deg);\n    "]
    ))
  );
});
function oa(t3) {
  var n2 = t3.onResetDates, r2 = t3.text, a4 = t3.rtl, i3 = useContext(Me$3), d4 = or({
    fontFamily: ir,
    resetDatesIconColor: cr("mud", dr.mud, i3),
    resetDatesIconHeight: "14px",
    resetDatesIconWidth: "14px",
    resetDatesTextColor: cr("darcula", dr.darcula, i3),
    resetDatesTextMargin: a4 ? "1px 8px 0 0" : "1px 0 0 8px",
    resetDatesTextLineHeight: 1.18,
    resetDatesTextFontSize: "11px"
  });
  return React__default.createElement(
    ra,
    {
      "aria-label": "Reset dates",
      tabIndex: -1,
      onClick: n2,
      onMouseUp: function(e5) {
        e5.currentTarget.blur();
      }
    },
    React__default.createElement(aa, {
      height: d4.resetDatesIconHeight,
      width: d4.resetDatesIconWidth,
      color: d4.resetDatesIconColor,
      rtl: a4
    }),
    React__default.createElement(
      Br,
      {
        m: d4.resetDatesTextMargin,
        lineHeight: d4.resetDatesTextLineHeight,
        fontFamily: d4.fontFamily,
        fontSize: d4.resetDatesTextFontSize,
        color: d4.resetDatesTextColor
      },
      r2
    )
  );
}
var ia, da, sa = qe$2("svg")(da || (da = bt$1(["\n  ", "\n"], ["\n  ", "\n"])), function(e5) {
  var t3 = e5.angle;
  return Ae$2(
    ia || (ia = bt$1(
      ["\n      transform: rotate(", "deg);\n    "],
      ["\n      transform: rotate(", "deg);\n    "]
    )),
    t3
  );
});
function ca(t3) {
  var n2 = t3.height, r2 = t3.width, a4 = t3.color, o2 = t3.direction, i3 = void 0 === o2 ? "right" : o2, d4 = t3.className, s4 = void 0 === d4 ? "" : d4, c3 = function(e5) {
    switch (e5) {
      case "up":
        return 180;
      case "down":
        return 0;
      case "left":
        return 90;
      case "right":
      default:
        return -90;
    }
  }(i3);
  return React__default.createElement(
    sa,
    {
      width: r2,
      height: n2,
      color: a4,
      className: s4,
      angle: c3,
      viewBox: "0 0 9 6",
      xmlns: "http://www.w3.org/2000/svg"
    },
    React__default.createElement("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4.058 4.594L1.185 1.72a.312.312 0 1 1 .442-.442L4.5 4.152l2.873-2.873a.312.312 0 1 1 .442.442L4.723 4.812a.316.316 0 0 1-.446 0l-.219-.218z"
    })
  );
}
var ua, la = Pt$1(mn, yn, Xt, $t, Gt), pa = qe$2("button")(
  ua || (ua = bt$1(
    ["\n  ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"],
    ["\n  ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]
  )),
  la
);
function fa(t3) {
  var n2 = t3.type, r2 = t3.onClick, a4 = t3.vertical, i3 = t3.rtl, d4 = t3.ariaLabel, s4 = useContext(Me$3), u3 = or({
    navButtonWidth: a4 ? "48px" : "30px",
    navButtonHeight: a4 ? "48px" : "30px",
    navButtonBackground: cr("white", dr.white, s4),
    navButtonBorder: "1px solid " + cr("silverCloud", dr.silverCloud, s4),
    navButtonPadding: "0",
    navButtonIconHeight: a4 ? "18px" : "11px",
    navButtonIconWidth: a4 ? "28px" : "18px",
    navButtonIconColor: cr("greey", dr.greey, s4)
  });
  function l2() {
    return "next" !== n2 || a4 ? "next" === n2 && a4 ? "down" : "prev" !== n2 || a4 ? "up" : "left" : "right";
  }
  return React__default.createElement(
    pa,
    {
      width: u3.navButtonWidth,
      height: u3.navButtonHeight,
      background: u3.navButtonBackground,
      border: u3.navButtonBorder,
      borderRight: "up" !== l2() || i3 ? u3.navButtonBorder : "unset",
      borderLeft: "up" === l2() && i3 ? "unset" : u3.navButtonBorder,
      p: u3.navButtonPadding,
      type: "button",
      "aria-label": d4,
      onClick: r2,
      onMouseUp: function(e5) {
        e5.currentTarget.blur();
      },
      "data-testid": "DatepickerNavButton"
    },
    React__default.createElement(ca, {
      width: u3.navButtonIconWidth,
      height: u3.navButtonIconHeight,
      color: u3.navButtonIconColor,
      direction: l2()
    })
  );
}
function ga(t3) {
  var n2 = t3.height, r2 = t3.width, a4 = t3.color, o2 = t3.className, i3 = void 0 === o2 ? "" : o2;
  return React__default.createElement(
    "svg",
    {
      width: r2,
      height: n2,
      color: a4,
      className: i3,
      viewBox: "0 0 15 16",
      xmlns: "http://www.w3.org/2000/svg"
    },
    React__default.createElement("path", {
      fill: "currentColor",
      fillRule: "nonzero",
      d: "M14.69.263a.802.802 0 0 0-1.187 0L7.47 6.694 1.433.262a.802.802 0 0 0-1.187 0 .938.938 0 0 0 0 1.267L6.28 7.96.246 14.392a.937.937 0 0 0 0 1.266.81.81 0 0 0 .594.262.81.81 0 0 0 .593-.262l6.035-6.432 6.035 6.432a.812.812 0 0 0 .593.262.81.81 0 0 0 .594-.262.937.937 0 0 0 0-1.266L8.656 7.96l6.034-6.43a.937.937 0 0 0 0-1.267z"
    })
  );
}
var ha, ma, ya = Pt$1($t, zt, kn, xn, Cn), va = qe$2("div")(
  ha || (ha = bt$1(
    ["\n  ", "\n  float: left;\n  transition: color 0.15s;\n"],
    ["\n  ", "\n  float: left;\n  transition: color 0.15s;\n"]
  )),
  ya
), ba = qe$2("button")(
  ma || (ma = bt$1(
    [
      "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  background: transparent;\n  padding: 0;\n  border: 0;\n\n  svg {\n    transition: color 0.15s;\n  }\n\n  &:hover {\n    ",
      " {\n      ",
      "\n    }\n\n    svg {\n      ",
      "\n    }\n  }\n"
    ],
    [
      "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  background: transparent;\n  padding: 0;\n  border: 0;\n\n  svg {\n    transition: color 0.15s;\n  }\n\n  &:hover {\n    ",
      " {\n      ",
      "\n    }\n\n    svg {\n      ",
      "\n    }\n  }\n"
    ]
  )),
  va,
  zt,
  zt
);
function wa(t3) {
  var n2 = t3.onClick, r2 = t3.rtl, a4 = t3.closeText, i3 = useContext(Me$3), d4 = or({
    fontFamily: ir,
    closeMargin: r2 ? "1px 16px 0 0" : "1px 0 0 16px",
    closeColor: cr("silverCloud", dr.silverCloud, i3),
    closeHoverColor: cr("darcula", dr.darcula, i3),
    closeFontSize: "12px",
    closeFontWeight: 600
  });
  return React__default.createElement(
    ba,
    {
      onClick: n2,
      color: d4.closeHoverColor,
      "data-testid": "DatepickerClose",
      tabIndex: -1,
      "aria-label": "Close"
    },
    React__default.createElement(ga, { width: "15px", height: "16px", color: "#ADADAD" }),
    React__default.createElement(
      va,
      {
        m: d4.closeMargin,
        color: d4.closeColor,
        fontSize: d4.closeFontSize,
        fontFamily: d4.fontFamily,
        fontWeight: d4.closeFontWeight
      },
      a4
    )
  );
}
var Da = We$3(
  La || (La = bt$1(
    ["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"],
    ["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"]
  ))
), ka = Pt$1(Xt, $t, Yn, Vt, en, mn, An), xa = qe$2("div")(
  Ra || (Ra = bt$1(
    [
      "\n  ",
      "\n  ",
      "\n\n  animation-name: ",
      ";\n  animation-duration: 0.15s;\n  animation-timing-function: ease-in;\n"
    ],
    [
      "\n  ",
      "\n  ",
      "\n\n  animation-name: ",
      ";\n  animation-duration: 0.15s;\n  animation-timing-function: ease-in;\n"
    ]
  )),
  ka,
  function(e5) {
    return e5.rtl && Ae$2(Wa || (Wa = bt$1(["\n      direction: rtl;\n    "], ["\n      direction: rtl;\n    "])));
  },
  Da
), Ca = qe$2("div")(
  Ea || (Ea = bt$1(
    [
      "\n  position: relative;\n  width: 100%;\n\n  &:after {\n    content: '';\n    position: absolute;\n    height: 1px;\n    width: 100%;\n    background: #e6e7e8;\n    bottom: 0;\n    left: 0;\n  }\n"
    ],
    [
      "\n  position: relative;\n  width: 100%;\n\n  &:after {\n    content: '';\n    position: absolute;\n    height: 1px;\n    width: 100%;\n    background: #e6e7e8;\n    bottom: 0;\n    left: 0;\n  }\n"
    ]
  ))
), Ta = Pt$1(bn, Bn), Sa = qe$2(rr)(Fa || (Fa = bt$1(["\n  ", "\n"], ["\n  ", "\n"])), Ta), Ba = Pt$1(wn, yn), Ma = qe$2($n)(Ha || (Ha = bt$1(["\n  ", "\n"], ["\n  ", "\n"])), Ba);
var La, Wa, Ra, Ea, Fa, Ha, Pa, Oa, Ia, za, Ua, Na = React__default.forwardRef(function(t3, n2) {
  var r2 = t3.startDate, a4 = t3.endDate, s4 = t3.minBookingDate, u3 = t3.maxBookingDate, l2 = t3.focusedInput, f2 = t3.onDatesChange, g2 = t3.dayLabelFormat, h4 = t3.weekdayLabelFormat, m4 = t3.monthLabelFormat, y4 = t3.onDayRender, v2 = t3.initialVisibleMonth, b3 = t3.vertical, w3 = void 0 !== b3 && b3, D3 = t3.rtl, k3 = void 0 !== D3 && D3, x3 = t3.showResetDates, C2 = void 0 === x3 || x3, T3 = t3.showClose, S4 = void 0 === T3 || T3, B3 = t3.showSelectedDates, M4 = void 0 === B3 || B3, L3 = t3.exactMinBookingDays, W2 = void 0 !== L3 && L3, R3 = t3.isDateBlocked, E3 = void 0 === R3 ? function() {
    return false;
  } : R3, F2 = t3.minBookingDays, H4 = void 0 === F2 ? 1 : F2, P2 = t3.onClose, O3 = void 0 === P2 ? function() {
  } : P2, I3 = t3.numberOfMonths, z3 = t3.firstDayOfWeek, U2 = t3.displayFormat, N2 = void 0 === U2 ? "MM/dd/yyyy" : U2, Y3 = t3.phrases, A2 = void 0 === Y3 ? Vn : Y3, q3 = t3.unavailableDates, G3 = yt$1({
    startDate: r2,
    endDate: a4,
    focusedInput: l2,
    onDatesChange: f2,
    minBookingDate: s4,
    maxBookingDate: u3,
    minBookingDays: H4,
    isDateBlocked: E3,
    exactMinBookingDays: W2,
    unavailableDates: void 0 === q3 ? [] : q3,
    initialVisibleMonth: v2,
    numberOfMonths: I3,
    firstDayOfWeek: z3
  }), j2 = G3.activeMonths, X3 = G3.isDateSelected, Q3 = G3.isFirstOrLastSelectedDate, V2 = G3.isDateHovered, Z2 = G3.firstDayOfWeek, K3 = G3.onDateSelect, J2 = G3.onResetDates, _2 = G3.goToPreviousMonths, $2 = G3.goToNextMonths, ee2 = G3.numberOfMonths, te2 = G3.hoveredDate, ne2 = G3.onDateHover, re2 = G3.isDateFocused, ae2 = G3.focusedDate, oe2 = G3.onDateFocus, ie2 = G3.isDateBlocked;
  useImperativeHandle(n2, function() {
    return {
      onDateSelect: function(e5) {
        K3(e5);
      }
    };
  });
  var de2 = useRef(null), se2 = useContext(Me$3), ce2 = or({
    datepickerZIndex: null,
    datepickerBackground: "#ffffff",
    datepickerPadding: w3 ? "16px 16px 0" : "32px",
    datepickerBorderRadius: "2px",
    datepickerPosition: "relative",
    datepickerWidth: "fit-content",
    datepickerCloseWrapperPosition: w3 ? "relative" : "absolute",
    datepickerCloseWrapperDisplay: w3 ? "flex" : "block",
    datepickerCloseWrapperJustifyContent: w3 ? "flex-end" : "initial",
    datepickerCloseWrapperMargin: w3 ? "0 0 16px" : "0",
    datepickerCloseWrapperRight: k3 ? "unset" : w3 ? "0" : "32px",
    datepickerCloseWrapperTop: "unset",
    datepickerCloseWrapperLeft: k3 ? "32px" : "unset",
    datepickerCloseWrapperBottom: "unset",
    datepickerCloseWrapperZIndex: 1,
    datepickerSelectDateGridTemplateColumns: w3 ? "87px 50px 87px" : "126px 75px 126px",
    datepickerSelectDateGridTemplateRows: "unset",
    datepickerSelectDateArrowIconWidth: "15px",
    datepickerSelectDateArrowIconHeight: "12px",
    datepickerSelectDateArrowIconColor: cr("silverCloud", dr.silverCloud, se2),
    datepickerMonthsWrapperMargin: S4 || M4 ? M4 ? "28px 0 0" : "48px 0 0" : "unset",
    datepickerPreviousMonthButtonPosition: w3 ? "relative" : "absolute",
    datepickerPreviousMonthButtonTop: w3 ? "unset" : "-5px",
    datepickerPreviousMonthButtonLeft: w3 ? "unset" : "0",
    datepickerPreviousMonthButtonRight: "unset",
    datepickerPreviousMonthButtonBottom: "unset",
    datepickerNextMonthButtonPosition: w3 ? "relative" : "absolute",
    datepickerNextMonthButtonTop: w3 ? "unset" : "-5px",
    datepickerNextMonthButtonLeft: "unset",
    datepickerNextMonthButtonRight: w3 ? "unset" : "0",
    datepickerNextMonthButtonBottom: "unset",
    datepickerMonthsGridGap: w3 ? "32px" : "0 32px",
    datepickerMonthsGridOverflow: "auto",
    datepickerMonthsGridHeight: w3 ? "50vh" : "100%",
    datepickerResetDatesWrapperMargin: w3 ? "unset" : "32px 0 0",
    datepickerBoxShadow: "rgba(0, 0, 0, 0.05) 0px 2px 6px, rgba(0, 0, 0, 0.07) 0px 0px 0px 1px"
  });
  function ue2() {
    de2 && de2.current && w3 && (de2.current.scrollTop = 0);
  }
  function le2() {
    $2(), ue2();
  }
  function pe2() {
    _2(), ue2();
  }
  return React__default.createElement(
    Le$3,
    {
      theme: function(e5) {
        return e5 || {};
      }
    },
    React__default.createElement(
      zr.Provider,
      {
        value: {
          rtl: k3,
          isDateFocused: re2,
          isDateSelected: X3,
          isDateHovered: V2,
          isFirstOrLastSelectedDate: Q3,
          onDateFocus: oe2,
          focusedDate: ae2,
          onDateSelect: K3,
          onDateHover: ne2,
          onDayRender: y4,
          isDateBlocked: ie2
        }
      },
      React__default.createElement(
        xa,
        {
          background: ce2.datepickerBackground,
          p: ce2.datepickerPadding,
          borderRadius: ce2.datepickerBorderRadius,
          position: ce2.datepickerPosition,
          boxShadow: ce2.datepickerBoxShadow,
          width: ce2.datepickerWidth,
          zIndex: ce2.datepickerZIndex,
          rtl: k3
        },
        S4 && React__default.createElement(
          Sa,
          {
            m: ce2.datepickerCloseWrapperMargin,
            display: ce2.datepickerCloseWrapperDisplay,
            justifyContent: ce2.datepickerCloseWrapperJustifyContent,
            position: ce2.datepickerCloseWrapperPosition,
            right: ce2.datepickerCloseWrapperRight,
            top: ce2.datepickerCloseWrapperTop,
            left: ce2.datepickerCloseWrapperLeft,
            bottom: ce2.datepickerCloseWrapperBottom,
            zIndex: ce2.datepickerCloseWrapperZIndex
          },
          React__default.createElement(wa, { onClick: O3, rtl: k3, closeText: A2.close })
        ),
        M4 && React__default.createElement(
          Ca,
          null,
          React__default.createElement(
            $n,
            {
              "data-testid": "SelectedDatesGrid",
              gridTemplateColumns: ce2.datepickerSelectDateGridTemplateColumns,
              gridTemplateRows: ce2.datepickerSelectDateGridTemplateRows
            },
            React__default.createElement(Lr, {
              title: A2.datepickerStartDateLabel,
              date: ft$1(r2, N2, A2.datepickerStartDatePlaceholder),
              isActive: l2 === ht$1,
              vertical: w3
            }),
            React__default.createElement(
              tr,
              { justifyContent: "center", alignItems: "center" },
              React__default.createElement(kr, {
                height: ce2.datepickerSelectDateArrowIconHeight,
                width: ce2.datepickerSelectDateArrowIconWidth,
                iconColor: ce2.datepickerSelectDateArrowIconColor
              })
            ),
            React__default.createElement(Lr, {
              title: A2.datepickerEndDateLabel,
              date: ft$1(a4, N2, A2.datepickerEndDatePlaceholder),
              isActive: l2 === mt$1,
              vertical: w3
            })
          )
        ),
        React__default.createElement(
          rr,
          { position: "relative" },
          React__default.createElement(
            rr,
            { m: ce2.datepickerMonthsWrapperMargin },
            React__default.createElement(
              Ma,
              {
                "data-testid": "MonthGrid",
                overflow: ce2.datepickerMonthsGridOverflow,
                height: ce2.datepickerMonthsGridHeight,
                gridTemplateColumns: w3 ? "1fr" : "repeat(" + ee2 + ", 1fr)",
                gridGap: ce2.datepickerMonthsGridGap,
                pr: k3 ? "1px" : "0",
                ref: de2,
                onMouseLeave: function() {
                  te2 && ne2(null);
                }
              },
              j2.map(function(t4) {
                return React__default.createElement($r, {
                  key: "month-" + t4.year + "-" + t4.month,
                  year: t4.year,
                  month: t4.month,
                  firstDayOfWeek: Z2,
                  dayLabelFormat: g2 || $e$2,
                  weekdayLabelFormat: h4 || et$1,
                  monthLabelFormat: m4 || tt$1
                });
              })
            )
          ),
          React__default.createElement(
            tr,
            { alignItems: "center" },
            React__default.createElement(
              React__default.Fragment,
              null,
              C2 && React__default.createElement(
                tr,
                { flex: "1", m: ce2.datepickerResetDatesWrapperMargin },
                React__default.createElement(oa, { rtl: k3, onResetDates: J2, text: A2.resetDates })
              ),
              React__default.createElement(
                rr,
                {
                  position: ce2.datepickerPreviousMonthButtonPosition,
                  top: ce2.datepickerPreviousMonthButtonTop,
                  left: ce2.datepickerPreviousMonthButtonLeft,
                  right: ce2.datepickerPreviousMonthButtonRight,
                  bottom: ce2.datepickerPreviousMonthButtonBottom
                },
                React__default.createElement(fa, {
                  type: "prev",
                  onClick: k3 && !w3 ? le2 : pe2,
                  vertical: w3,
                  rtl: k3,
                  ariaLabel: "Previous month"
                })
              ),
              React__default.createElement(
                rr,
                {
                  position: ce2.datepickerNextMonthButtonPosition,
                  top: ce2.datepickerNextMonthButtonTop,
                  left: ce2.datepickerNextMonthButtonLeft,
                  right: ce2.datepickerNextMonthButtonRight,
                  bottom: ce2.datepickerNextMonthButtonBottom
                },
                React__default.createElement(fa, {
                  type: "next",
                  onClick: k3 && !w3 ? pe2 : le2,
                  vertical: w3,
                  rtl: k3,
                  ariaLabel: "Next month"
                })
              )
            )
          )
        )
      )
    )
  );
}), Ya = qe$2(rr)(Oa || (Oa = bt$1(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), An, function(e5) {
  return e5.rtl && Ae$2(Pa || (Pa = bt$1(["\n      direction: rtl;\n    "], ["\n      direction: rtl;\n    "])));
}), Aa = Pt$1(zt, Dn), qa = qe$2(kr)(za || (za = bt$1(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), Aa, function(e5) {
  return e5.rtl && Ae$2(
    Ia || (Ia = bt$1(
      ["\n      transform: rotate(-90deg);\n    "],
      ["\n      transform: rotate(-90deg);\n    "]
    ))
  );
}), Ga = Pt$1(Xt, Gt, Yn), ja = qe$2($n)(Ua || (Ua = bt$1(["\n  ", "\n"], ["\n  ", "\n"])), Ga);
function Xa(t3) {
  var r2 = t3.startDate, a4 = t3.endDate, d4 = t3.minBookingDate, s4 = t3.maxBookingDate, u3 = t3.firstDayOfWeek, l2 = t3.onFocusChange, f2 = t3.numberOfMonths, g2 = t3.focusedInput, h4 = t3.onDatesChange, m4 = t3.exactMinBookingDays, y4 = t3.dayLabelFormat, v2 = t3.weekdayLabelFormat, b3 = t3.monthLabelFormat, w3 = t3.onDayRender, D3 = t3.initialVisibleMonth, k3 = t3.showClose, x3 = void 0 === k3 || k3, C2 = t3.showSelectedDates, T3 = void 0 === C2 || C2, S4 = t3.showResetDates, B3 = void 0 === S4 || S4, M4 = t3.vertical, L3 = void 0 !== M4 && M4, W2 = t3.rtl, R3 = void 0 !== W2 && W2, E3 = t3.isDateBlocked, F2 = void 0 === E3 ? function() {
    return false;
  } : E3, H4 = t3.minBookingDays, P2 = void 0 === H4 ? 1 : H4, O3 = t3.onClose, I3 = void 0 === O3 ? function() {
  } : O3, z3 = t3.showStartDateCalendarIcon, U2 = void 0 === z3 || z3, N2 = t3.showEndDateCalendarIcon, Y3 = void 0 === N2 || N2, A2 = t3.displayFormat, q3 = void 0 === A2 ? "MM/dd/yyyy" : A2, G3 = t3.phrases, j2 = void 0 === G3 ? Zn : G3, X3 = t3.placement, Q3 = void 0 === X3 ? "bottom" : X3, V2 = t3.startDateInputId, Z2 = void 0 === V2 ? "startDate" : V2, K3 = t3.endDateInputId, J2 = void 0 === K3 ? "endDate" : K3, _2 = t3.unavailableDates, $2 = void 0 === _2 ? [] : _2, ee2 = useRef(null), te2 = useRef(null), ne2 = useContext(Me$3), re2 = or(
    vt$1(
      {
        dateRangeZIndex: null,
        dateRangeBackground: "transparent",
        dateRangeGridTemplateColumns: L3 ? "1fr 24px 1fr" : "194px 39px 194px",
        dateRangeGridTemplateRows: "unset",
        dateRangeBorder: "0",
        dateRangeBorderRadius: "0",
        dateRangeArrowIconWidth: "15px",
        dateRangeArrowIconHeight: "12px",
        dateRangeArrowIconColor: cr("graci", dr.graci, ne2),
        dateRangeArrowIconOpacity: 1,
        dateRangeStartDateInputPadding: L3 ? R3 ? "0 32px 0 8px" : "0 8px 0 32px" : "0 44px",
        dateRangeEndDateInputPadding: L3 ? R3 ? "0 32px 0 8px" : "0 8px 0 32px" : "0 44px",
        dateRangeDatepickerWrapperPosition: "absolute"
      },
      /* @__PURE__ */ function(e5, t4) {
        return "top" !== e5 || t4 ? "top" === e5 && t4 ? {
          dateRangeDatepickerWrapperTop: "unset",
          dateRangeDatepickerWrapperRight: "0",
          dateRangeDatepickerWrapperBottom: "65px",
          dateRangeDatepickerWrapperLeft: "unset"
        } : "bottom" === e5 && t4 ? {
          dateRangeDatepickerWrapperTop: "unset",
          dateRangeDatepickerWrapperRight: "0",
          dateRangeDatepickerWrapperBottom: "unset",
          dateRangeDatepickerWrapperLeft: "unset"
        } : {
          dateRangeDatepickerWrapperTop: "unset",
          dateRangeDatepickerWrapperRight: "unset",
          dateRangeDatepickerWrapperBottom: "unset",
          dateRangeDatepickerWrapperLeft: "0"
        } : {
          dateRangeDatepickerWrapperTop: "unset",
          dateRangeDatepickerWrapperRight: "unset",
          dateRangeDatepickerWrapperBottom: "65px",
          dateRangeDatepickerWrapperLeft: "0"
        };
      }(Q3, R3)
    )
  );
  function ae2(e5) {
    null !== g2 && te2 && te2.current && !te2.current.contains(e5.target) && l2(null);
  }
  function oe2(e5) {
    ee2 && ee2.current && ee2.current.onDateSelect && ee2.current.onDateSelect(e5);
  }
  return useEffect(function() {
    return "undefined" != typeof window && window.addEventListener("click", ae2), function() {
      window.removeEventListener("click", ae2);
    };
  }), React__default.createElement(
    Le$3,
    {
      theme: function(e5) {
        return e5 || {};
      }
    },
    React__default.createElement(
      Ya,
      { zIndex: re2.dateRangeZIndex, rtl: R3, position: "relative", ref: te2 },
      React__default.createElement(
        ja,
        {
          "data-testid": "DateRangeInputGrid",
          background: re2.dateRangeBackground,
          gridTemplateColumns: re2.dateRangeGridTemplateColumns,
          gridTemplateRows: re2.dateRangeGridTemplateRows,
          border: re2.dateRangeBorder,
          borderRadius: re2.dateRangeBorderRadius
        },
        React__default.createElement(Dr, {
          id: Z2,
          ariaLabel: j2.startDateAriaLabel,
          placeholder: j2.startDatePlaceholder,
          value: ft$1(r2, q3, ""),
          onClick: function() {
            return l2(ht$1);
          },
          showCalendarIcon: U2,
          vertical: L3,
          isActive: g2 === ht$1,
          padding: re2.dateRangeStartDateInputPadding,
          rtl: R3,
          onChange: oe2,
          dateFormat: q3
        }),
        React__default.createElement(
          tr,
          { alignItems: "center", justifyContent: "center" },
          React__default.createElement(qa, {
            width: re2.dateRangeArrowIconWidth,
            height: re2.dateRangeArrowIconHeight,
            color: re2.dateRangeArrowIconColor,
            opacity: re2.dateRangeArrowIconOpacity,
            rtl: R3
          })
        ),
        React__default.createElement(Dr, {
          id: J2,
          ariaLabel: j2.endDateAriaLabel,
          placeholder: j2.endDatePlaceholder,
          value: ft$1(a4, q3, ""),
          onClick: function() {
            return l2(r2 ? mt$1 : ht$1);
          },
          showCalendarIcon: Y3,
          vertical: L3,
          isActive: g2 === mt$1,
          padding: re2.dateRangeEndDateInputPadding,
          rtl: R3,
          disableAccessibility: g2 === ht$1,
          onChange: oe2,
          dateFormat: q3
        })
      ),
      React__default.createElement(
        rr,
        {
          position: re2.dateRangeDatepickerWrapperPosition,
          bottom: re2.dateRangeDatepickerWrapperBottom,
          left: re2.dateRangeDatepickerWrapperLeft,
          top: re2.dateRangeDatepickerWrapperTop,
          right: re2.dateRangeDatepickerWrapperRight
        },
        null !== g2 && React__default.createElement(Na, {
          onClose: function() {
            I3(), l2(null);
          },
          startDate: r2,
          endDate: a4,
          minBookingDate: d4,
          maxBookingDate: s4,
          firstDayOfWeek: u3,
          numberOfMonths: f2,
          focusedInput: g2,
          displayFormat: q3,
          onDatesChange: h4,
          minBookingDays: P2,
          isDateBlocked: F2,
          exactMinBookingDays: m4,
          showResetDates: B3,
          vertical: L3,
          showSelectedDates: T3,
          showClose: x3,
          rtl: R3,
          dayLabelFormat: y4,
          weekdayLabelFormat: v2,
          monthLabelFormat: b3,
          onDayRender: w3,
          phrases: j2,
          unavailableDates: $2,
          ref: ee2,
          initialVisibleMonth: D3
        })
      )
    )
  );
}
var Qa, Va;
qe$2(rr)(Va || (Va = bt$1(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), An, function(e5) {
  return e5.rtl && Ae$2(Qa || (Qa = bt$1(["\n      direction: rtl;\n    "], ["\n      direction: rtl;\n    "])));
});
const styles$2z = (theme2) => ({
  root: {
    "& .prefix": {
      display: "grid",
      gridTemplateColumns: "194px 39px 194px",
      fontSize: 10,
      fontWeight: 600,
      textTransform: "uppercase",
      color: theme2.grey5,
      padding: "0 44px"
    }
  }
});
const initialState$1 = {
  startDate: null,
  endDate: null,
  focusedInput: null
};
function reducer$1(state, action) {
  switch (action.type) {
    case "focusChange":
      return { ...state, focusedInput: action.payload };
    case "dateChange":
      return action.payload;
    default:
      throw new Error();
  }
}
const DateRange = ({
  classes,
  showResetDates,
  showClose,
  showSelectedDates,
  numberOfMonths,
  onValueChange,
  placement
}) => {
  const [state, dispatch] = useReducer(reducer$1, initialState$1);
  const { startDate, endDate, focusedInput } = state;
  const handleOnDatesChange = (data) => {
    dispatch({ type: "dateChange", payload: data });
    onValueChange(data);
  };
  const handleOnFocusChange = (input) => {
    dispatch({ type: "focusChange", payload: input });
  };
  return /* @__PURE__ */ jsxs("div", { className: classes.root, children: [
    /* @__PURE__ */ jsxs("ul", { className: "prefix", children: [
      /* @__PURE__ */ jsx$1("li", { children: "From" }),
      /* @__PURE__ */ jsx$1("li", {}),
      /* @__PURE__ */ jsx$1("li", { children: "To" })
    ] }),
    /* @__PURE__ */ jsx$1(
      Le$3,
      {
        theme: {
          breakpoints: ["32em", "48em", "64em"],
          reactDatepicker: {
            daySize: [36, 36],
            fontFamily: "EuclidCircularB, system-ui, -apple-system",
            colors: {
              primaryColor: "#4B35D2",
              accessibility: "#4B35D2",
              selectedDay: "#EEEDFD",
              selectedDayHover: "#faf9fd",
              normalDayHover: "#faf9fd"
            },
            dayLabelFontSize: 10,
            dayLabelColor: "#8F8B9B",
            selectDateLabelFontSize: 10,
            selectDateLabelColor: "#D0CED5",
            selectDateDateFontSize: 14,
            selectDateDateColor: "#34323A",
            selectDateBorderColor: "#4B35D2",
            navButtonBorder: "none",
            monthLabelFontSize: 16,
            monthLabelFontWeight: 600,
            dayBackground: "#ffffff",
            dayBorderColor: "transparent",
            dayColor: "#34323A",
            dayFontSize: 15,
            daySelectedBorderColor: "transparent",
            daySelectedColor: "#34323A",
            daySelectedHoverColor: "#000000",
            dayHoverColor: "#000000",
            dayHoverBackground: "#EEEDFD",
            // dayHoverRangeColor: "#000000", // be carefull here
            dayHoverRangeBackground: "#EEEDFD",
            dayAccessibilityBorderColor: "none",
            inputLabelDisplay: "flex",
            inputLabelBorder: "none",
            inputLabelMargin: 0,
            inputPadding: 0,
            inputBorder: "none",
            inputFontSize: 14,
            inputColor: "#34323A",
            inputActiveBoxShadow: "none",
            inputLabelBackground: "transparent",
            inputBackground: "none",
            datepickerZIndex: 1,
            datepickerBoxShadow: "0px 5px 15px #28128733",
            datepickerBorderRadius: 5,
            datepickerPadding: 25,
            datepickerPosition: "absolute",
            datepickerMonthsGridGap: 10,
            dateRangeBorder: "none",
            dateRangeArrowIconColor: "#34323A",
            dateRangeStartDateInputPadding: 0,
            dateRangeEndDateInputPadding: 0,
            dateRangeDatepickerWrapperLeft: placement === "right" ? -170 : 30,
            dateRangeDatepickerWrapperTop: 77
          }
        },
        children: /* @__PURE__ */ jsx$1(
          Xa,
          {
            onDatesChange: handleOnDatesChange,
            onFocusChange: handleOnFocusChange,
            displayFormat: "MMM d, y",
            startDate,
            endDate,
            focusedInput,
            showClose,
            showResetDates,
            showStartDateCalendarIcon: false,
            showEndDateCalendarIcon: false,
            showSelectedDates,
            onClose: () => {
            },
            numberOfMonths
          }
        )
      }
    )
  ] });
};
DateRange.propTypes = {
  classes: PropTypes$1.object.isRequired,
  onValueChange: PropTypes$1.func.isRequired,
  showResetDates: PropTypes$1.bool,
  showClose: PropTypes$1.bool,
  showSelectedDates: PropTypes$1.bool,
  numberOfMonths: PropTypes$1.number,
  placement: PropTypes$1.oneOf(["left", "right"])
};
DateRange.defaultProps = {
  showResetDates: true,
  showClose: true,
  showSelectedDates: true,
  numberOfMonths: 2,
  placement: "left"
};
const DateRange$1 = injectSheet(styles$2z)(DateRange);
function useKeyPress(searchKey, handler, element = null) {
  useEffect(() => {
    const listener = ({ keyCode, key: key2 }) => {
      if (typeof searchKey === "string") return key2 === searchKey && handler();
      return keyCode === searchKey && handler();
    };
    const elementToListen = element || window;
    elementToListen.addEventListener("keydown", listener);
    return () => {
      elementToListen.removeEventListener("keydown", listener);
    };
  }, [handler, searchKey, element]);
}
const useOnClickOutside = (ref2, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref2.current || ref2.current.contains(event.target)) return;
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref2, handler]);
};
var isRegExp = function(re2) {
  return re2 instanceof RegExp;
};
var escapeRegExp = function escapeRegExp2(string3) {
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar2.source);
  return string3 && reHasRegExpChar.test(string3) ? string3.replace(reRegExpChar2, "\\$&") : string3;
};
var isString$4 = function(value) {
  return typeof value === "string";
};
var flatten$4 = function(array) {
  var newArray = [];
  array.forEach(function(item) {
    if (Array.isArray(item)) {
      newArray = newArray.concat(item);
    } else {
      newArray.push(item);
    }
  });
  return newArray;
};
function replaceString(str, match5, fn2) {
  var curCharStart = 0;
  var curCharLen = 0;
  if (str === "") {
    return str;
  } else if (!str || !isString$4(str)) {
    throw new TypeError("First argument to react-string-replace#replaceString must be a string");
  }
  var re2 = match5;
  if (!isRegExp(re2)) {
    re2 = new RegExp("(" + escapeRegExp(re2) + ")", "gi");
  }
  var result2 = str.split(re2);
  for (var i3 = 1, length = result2.length; i3 < length; i3 += 2) {
    if (result2[i3] === void 0 || result2[i3 - 1] === void 0) {
      console.warn("reactStringReplace: Encountered undefined value during string replacement. Your RegExp may not be working the way you expect.");
      continue;
    }
    curCharLen = result2[i3].length;
    curCharStart += result2[i3 - 1].length;
    result2[i3] = fn2(result2[i3], i3, curCharStart);
    curCharStart += curCharLen;
  }
  return result2;
}
var reactStringReplace = function reactStringReplace2(source, match5, fn2) {
  if (!Array.isArray(source)) source = [source];
  return flatten$4(source.map(function(x3) {
    return isString$4(x3) ? replaceString(x3, match5, fn2) : x3;
  }));
};
const reactStringReplace$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(reactStringReplace);
const parseBoldMarkdown = (text = "", markdown = /\*{2}(.*?)\*{2}/g) => reactStringReplace$1(text, markdown, (match5, i3) => /* @__PURE__ */ jsx$1("strong", { children: match5 }, `bold_${i3}`));
const escapeSpecialCharacters = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const parseSearchOccurencesInStr = (str, match5) => {
  if (!match5) return str;
  const escMatch = escapeSpecialCharacters(match5);
  const regex2 = new RegExp(`(${escMatch})`, "gi");
  const transformedStr = reactStringReplace$1(str, regex2, (matchOcc, i3) => /* @__PURE__ */ jsx$1("strong", { children: matchOcc }, `bold_${i3}`));
  if (transformedStr.length === 1) return null;
  return transformedStr;
};
const styles$2y = {
  tooltipBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    visibility: "hidden"
  },
  tooltipArrowWrapper: {
    visibility: "hidden",
    position: "absolute",
    zIndex: 7,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  tooltipContainer: {
    visibility: "hidden",
    position: "absolute",
    overflowY: "auto",
    zIndex: 7
  }
};
const getDomElementAbsoluteRect = (el2) => {
  const rect = el2.getBoundingClientRect();
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return {
    top: rect.top + scrollTop,
    height: rect.height,
    bottom: rect.bottom + scrollTop,
    left: rect.left + scrollLeft,
    width: rect.width,
    right: rect.right + scrollLeft
  };
};
const getWindowSizes$1 = () => {
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return {
    windowWidth: viewportWidth + scrollLeft,
    windowHeight: viewportHeight + scrollTop
  };
};
const TOOLTIP_WINDOW_BUFFER = 15;
const positionTooltipElementAndShow = (tooltipEl, clientRefEl, position2, arrowEl, delay2) => {
  const { windowWidth, windowHeight } = getWindowSizes$1();
  const {
    top: clientTop,
    height: clientHeight,
    bottom: clientBottom,
    left: clientLeft,
    width: clientWidth,
    right: clientRight
  } = getDomElementAbsoluteRect(clientRefEl);
  const { height: tooltipHeight, width: tooltipWidth } = getDomElementAbsoluteRect(tooltipEl);
  const { height: arrowSize } = getDomElementAbsoluteRect(arrowEl);
  const { style: tooltipStyle } = tooltipEl;
  tooltipStyle.width = `${tooltipWidth}px`;
  tooltipStyle.height = `${tooltipHeight}px`;
  const { style: arrowStyle } = arrowEl;
  let arrowRotation = 0;
  let {
    place = "below"
    /* below */
  } = position2;
  const {
    placeShift = 0,
    adjustPlace = false,
    anchor = "center",
    anchorShift = 0,
    adjustAnchor = true
  } = position2;
  const totalPlaceShift = placeShift + arrowSize;
  const roomBelow = windowHeight - clientBottom - totalPlaceShift - tooltipHeight;
  const roomAbove = clientTop - totalPlaceShift - tooltipHeight;
  const roomLeft = clientLeft - totalPlaceShift - tooltipWidth;
  const roomRight = windowWidth - clientRight - totalPlaceShift - tooltipWidth;
  switch (place) {
    case "above":
      if (adjustPlace && roomAbove < TOOLTIP_WINDOW_BUFFER && roomBelow > roomAbove) {
        place = "below";
      }
      break;
    case "left":
      if (adjustPlace && roomLeft < TOOLTIP_WINDOW_BUFFER && roomRight > roomLeft) {
        place = "right";
      }
      break;
    case "right":
      if (adjustPlace && roomRight < TOOLTIP_WINDOW_BUFFER && roomLeft > roomRight) {
        place = "left";
      }
      break;
    case "below":
    default:
      if (adjustPlace && roomBelow < TOOLTIP_WINDOW_BUFFER && roomAbove > roomBelow) {
        place = "above";
      }
  }
  switch (place) {
    case "above":
      tooltipStyle.top = `${Math.max(
        clientTop - totalPlaceShift - tooltipHeight,
        TOOLTIP_WINDOW_BUFFER
      )}px`;
      arrowStyle.top = `${clientTop - totalPlaceShift}px`;
      arrowRotation = 180;
      break;
    case "left":
      tooltipStyle.left = `${Math.max(
        clientLeft - totalPlaceShift - tooltipWidth,
        TOOLTIP_WINDOW_BUFFER
      )}px`;
      arrowStyle.left = `${clientLeft - totalPlaceShift}px`;
      arrowRotation = 90;
      break;
    case "right":
      tooltipStyle.left = `${clientRight + totalPlaceShift}px`;
      arrowStyle.left = `${clientRight + placeShift}px`;
      arrowRotation = 270;
      break;
    case "below":
    default:
      tooltipStyle.top = `${clientBottom + totalPlaceShift}px`;
      arrowStyle.top = `${clientBottom + placeShift}px`;
  }
  if (place === "left" || place === "right") {
    let tooltipTop = null;
    switch (anchor) {
      case "top":
        tooltipTop = clientTop + anchorShift;
        break;
      case "bottom":
        tooltipTop = clientBottom - tooltipHeight - anchorShift;
        break;
      case "center":
      default:
        tooltipTop = Math.floor(
          clientTop + 0.5 * clientHeight - 0.5 * tooltipHeight + anchorShift
        );
    }
    tooltipTop = Math.max(tooltipTop, TOOLTIP_WINDOW_BUFFER);
    tooltipStyle.top = `${tooltipTop}px`;
    if (adjustAnchor && tooltipTop + tooltipHeight > windowHeight - TOOLTIP_WINDOW_BUFFER) {
      tooltipTop = Math.max(
        tooltipTop - (tooltipTop + tooltipHeight - windowHeight + TOOLTIP_WINDOW_BUFFER),
        TOOLTIP_WINDOW_BUFFER
      );
      tooltipStyle.top = `${tooltipTop}px`;
    }
    const arrowTop = Math.max(clientTop, tooltipTop);
    arrowStyle.top = `${arrowTop}px`;
    arrowStyle.height = `${Math.min(clientBottom, tooltipTop + tooltipHeight) - arrowTop}px`;
    arrowStyle.width = `${arrowSize}px`;
  } else {
    let tooltipLeft = null;
    switch (anchor) {
      case "right":
        tooltipLeft = clientRight - tooltipWidth - anchorShift;
        break;
      case "left":
        tooltipLeft = clientLeft + anchorShift;
        break;
      case "center":
      default:
        tooltipLeft = Math.floor(
          clientLeft + 0.5 * clientWidth - 0.5 * tooltipWidth + anchorShift
        );
    }
    tooltipLeft = Math.max(tooltipLeft, TOOLTIP_WINDOW_BUFFER);
    tooltipStyle.left = `${tooltipLeft}px`;
    if (adjustAnchor && tooltipLeft + tooltipWidth > windowWidth - TOOLTIP_WINDOW_BUFFER) {
      tooltipLeft = Math.max(
        tooltipLeft - (tooltipLeft + tooltipWidth - windowWidth + TOOLTIP_WINDOW_BUFFER),
        TOOLTIP_WINDOW_BUFFER
      );
      tooltipStyle.left = `${tooltipLeft}px`;
    }
    const arrowLeft = Math.max(clientLeft, tooltipLeft);
    arrowStyle.left = `${arrowLeft}px`;
    arrowStyle.width = `${Math.min(clientRight, tooltipLeft + tooltipWidth) - arrowLeft}px`;
    arrowStyle.height = `${arrowSize}px`;
  }
  arrowEl.children[0].style.transform = `rotate(${arrowRotation}deg)`;
  setTimeout(() => {
    tooltipStyle.visibility = "visible";
    arrowStyle.visibility = "visible";
  }, delay2);
};
const Tooltip = ({
  classes,
  clientEl,
  portalEl,
  children,
  position: position2 = {
    place: "right",
    placeShift: 3,
    adjustPlace: true
  },
  arrowUp = null,
  delay: delay2 = 0
}) => {
  const arrowRef = useRef(null);
  const tooltipRef = useRef(null);
  useEffect(() => {
    positionTooltipElementAndShow(
      tooltipRef.current,
      clientEl,
      position2,
      arrowRef.current,
      delay2
    );
  }, [clientEl, delay2, position2]);
  return ReactDOM.createPortal(
    /* @__PURE__ */ jsxs("div", { className: classes.tooltipBackground, children: [
      /* @__PURE__ */ jsx$1("div", { className: classes.tooltipArrowWrapper, ref: arrowRef, children: arrowUp || /* @__PURE__ */ jsx$1("div", {}) }),
      /* @__PURE__ */ jsx$1("div", { className: classes.tooltipContainer, ref: tooltipRef, children })
    ] }),
    portalEl
  );
};
const Tooltip$1 = injectSheet(styles$2y)(Tooltip);
const styles$2x = {
  tooltipWrapper: {
    display: "inline-block"
  },
  infoTooltipBody: {
    borderRadius: 5,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 0.1,
    wordBreak: "break-word",
    whiteSpace: "pre-line",
    lineHeight: "20px",
    "& strong": {
      fontWeight: 800
    }
  },
  infoTooltipArrowUp: {
    borderLeft: "6px solid transparent",
    borderRight: "6px solid transparent",
    borderBottomWidth: 6,
    borderBottomStyle: "solid"
  }
};
const convertToRGB = (hex) => {
  const newHex = hex.replace("#", "");
  if (newHex.length !== 6) {
    console.warn("only six-digit hex colors are allowed.");
  }
  const aRgbHex = newHex.match(/.{1,2}/g);
  const aRgb = [
    parseInt(aRgbHex[0], 16),
    parseInt(aRgbHex[1], 16),
    parseInt(aRgbHex[2], 16)
  ];
  return aRgb;
};
const computeBoxShadow = (color, opacity) => {
  if (opacity > 10 || opacity < 0) {
    console.error("only range 0-10 is allowed");
  }
  const position2 = "0px 3px 20px";
  const rgba = convertToRGB(color);
  return `${position2} rgba(${rgba.join(", ")}, ${opacity / 10})`;
};
const InfoTooltip = ({
  classes,
  dataCy = "info-tooltip",
  text,
  textAlign = "left",
  textColor = theme.white1,
  backgroundColor = theme.grey2,
  padding = "10px 20px",
  children,
  position: position2 = {
    place: "right",
    placeShift: 3,
    adjustPlace: true
  },
  delay: delay2 = 100,
  minWidth = 100,
  maxWidth = 200,
  boxShadowColor = "",
  boxShadowOpacity = 0,
  onClick = false,
  includeTooltipInWrapper = false
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipWrapperRef = useRef(null);
  const usedBackgroundColor = theme[backgroundColor] || backgroundColor;
  const usedTextColor = theme[textColor] || textColor;
  const usedBoxShadow = useMemo(() => {
    if (boxShadowOpacity === 0) return "unset";
    return computeBoxShadow(
      boxShadowColor || usedBackgroundColor,
      boxShadowOpacity
    );
  }, [boxShadowColor, boxShadowOpacity, usedBackgroundColor]);
  useOnClickOutside(tooltipWrapperRef, () => onClick && setShowTooltip(false));
  const handleMouseEnter = useCallback(
    () => !onClick && setShowTooltip(true),
    [onClick]
  );
  const handleMouseLeave = useCallback(
    () => !onClick && setShowTooltip(false),
    [onClick]
  );
  const handleClick = useCallback(
    () => onClick && setShowTooltip(!showTooltip),
    [onClick, showTooltip]
  );
  const rootProps = {
    "data-cy": dataCy,
    className: classes.tooltipWrapper,
    ref: tooltipWrapperRef,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick
  };
  const tooltip = showTooltip && /* @__PURE__ */ jsx$1(
    Tooltip$1,
    {
      clientEl: tooltipWrapperRef.current,
      portalEl: document.body,
      position: position2,
      arrowUp: /* @__PURE__ */ jsx$1(
        "div",
        {
          className: classes.infoTooltipArrowUp,
          style: {
            borderBottomColor: usedBackgroundColor,
            boxShadow: usedBoxShadow
          }
        }
      ),
      delay: delay2,
      children: /* @__PURE__ */ jsx$1(
        "p",
        {
          className: classes.infoTooltipBody,
          style: {
            color: usedTextColor,
            backgroundColor: usedBackgroundColor,
            boxShadow: usedBoxShadow,
            minWidth,
            maxWidth,
            textAlign,
            padding
          },
          children: parseBoldMarkdown(text)
        }
      )
    }
  );
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsxs("div", { ...rootProps, children: [
      children,
      includeTooltipInWrapper && tooltip
    ] }),
    !includeTooltipInWrapper && tooltip
  ] });
};
const InfoTooltip$1 = injectSheet(styles$2x)(InfoTooltip);
const styles$2w = (theme2) => ({
  titleRow: {
    display: "grid",
    gridTemplateColumns: "repeat(8, 1fr)",
    gridGap: 10,
    gridAutoRows: "minmax(25px, auto)",
    textAlign: "right",
    padding: "0px 0",
    background: "linear-gradient(180deg, rgba(255,255,255,1) 70%,  rgba(255,255,255,0) 100%)",
    fontSize: 10,
    textTransform: "uppercase",
    color: `${theme2.grey4}`,
    position: "sticky",
    top: 0,
    zIndex: 2
  },
  table: {
    position: "relative",
    overflow: "auto",
    paddingRight: "1rem",
    boxSizing: "border-box"
  },
  columnTitleCommon: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    letterSpacing: 1,
    fontWeight: 600,
    "& div": {
      marginRight: 5,
      "& svg": {
        width: 22
      }
    }
  },
  columnTitle: {
    extend: "columnTitleCommon",
    justifyContent: "flex-start",
    gridColumn: "1/5"
  },
  columnTitle1: {
    extend: "columnTitleCommon",
    gridColumn: "8/8"
  },
  columnTitle2: {
    extend: "columnTitleCommon",
    textAlign: "right",
    gridColumn: "7/8"
  },
  columnTitle3: {
    extend: "columnTitleCommon",
    textAlign: "right",
    gridColumn: "5/7"
  }
});
const Directory = forwardRef((props2, ref2) => {
  const {
    classes,
    children,
    columnTitle,
    columnTitle1,
    columnTitle2,
    columnTitle3,
    columnInfo1,
    columnInfo2,
    columnInfo3,
    showColumnTitles
  } = props2;
  const renderTooltip = (info2) => /* @__PURE__ */ jsx$1(
    InfoTooltip$1,
    {
      text: info2,
      textColor: "#fff",
      backgroundColor: "grey",
      position: {
        place: "above",
        placeShift: 3,
        adjustPlace: true,
        anchor: "center"
      },
      delay: 200,
      children: /* @__PURE__ */ jsx$1(lib$a.CircleInfo, {})
    }
  );
  const renderTitleRow = () => {
    if (!showColumnTitles) return null;
    return /* @__PURE__ */ jsxs("div", { className: classes.titleRow, children: [
      /* @__PURE__ */ jsx$1("div", { className: classes.columnTitle, children: columnTitle }),
      /* @__PURE__ */ jsxs("div", { className: classes.columnTitle3, children: [
        columnInfo3 && renderTooltip(columnInfo3),
        columnTitle3
      ] }),
      /* @__PURE__ */ jsxs("div", { className: classes.columnTitle2, children: [
        columnInfo2 && renderTooltip(columnInfo2),
        columnTitle2
      ] }),
      /* @__PURE__ */ jsxs("div", { className: classes.columnTitle1, children: [
        columnInfo1 && renderTooltip(columnInfo1),
        columnTitle1
      ] })
    ] });
  };
  return /* @__PURE__ */ jsxs("section", { className: classes.table, ref: ref2, children: [
    renderTitleRow(),
    /* @__PURE__ */ jsx$1("div", { className: classes.tableContent, children })
  ] });
});
Directory.propTypes = {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  columnTitle: PropTypes$1.node,
  columnTitle1: PropTypes$1.node,
  columnTitle2: PropTypes$1.node,
  columnTitle3: PropTypes$1.node,
  columnInfo1: PropTypes$1.node,
  columnInfo2: PropTypes$1.node,
  columnInfo3: PropTypes$1.node,
  showColumnTitles: PropTypes$1.bool
};
Directory.defaultProps = {
  columnTitle: null,
  columnTitle1: null,
  columnTitle2: null,
  columnTitle3: null,
  columnInfo1: null,
  columnInfo2: null,
  columnInfo3: null,
  showColumnTitles: false
};
const StyledDirectory = injectSheet(styles$2w)(Directory);
const Directory$1 = forwardRef((props2, ref2) => /* @__PURE__ */ jsx$1(
  StyledDirectory,
  {
    ...props2,
    innerRef: (el2) => {
      if (ref2) ref2.current = el2;
    }
  }
));
const styles$2v = (theme2) => ({
  root: {
    display: "grid",
    gridTemplateColumns: "repeat(8, 1fr)",
    gridGap: 10,
    gridAutoRows: "minmax(25px, auto)",
    fontSize: 14,
    padding: "8px 0",
    borderTop: `1px solid ${theme2.grey6}`,
    color: theme2.grey2
  },
  borderBottom: {
    display: "grid",
    gridTemplateColumns: "repeat(8, 1fr)",
    gridGap: 10,
    gridAutoRows: "minmax(25px, auto)",
    fontSize: 14,
    padding: "8px 0",
    borderTop: `1px solid ${theme2.grey6}`,
    color: theme2.grey2
  },
  main: {
    textAlign: "left",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gridColumn: "1/5"
  },
  cell1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    gridColumn: "8/8"
  },
  cell2: {
    textAlign: "right",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    gridColumn: "7/8"
  },
  cell3: {
    textAlign: "right",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    gridColumn: "5/7"
  }
});
class DirectoryRow extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes } = this.props;
      const { main, cell1, cell2, cell3, isLast } = this.props;
      return /* @__PURE__ */ jsxs("div", { className: isLast ? classes.borderBottom : classes.root, children: [
        main && /* @__PURE__ */ jsx$1("div", { className: classes.main, children: main }),
        cell3 && /* @__PURE__ */ jsx$1("div", { className: classes.cell3, children: cell3 }),
        cell2 && /* @__PURE__ */ jsx$1("div", { className: classes.cell2, children: cell2 }),
        cell1 && /* @__PURE__ */ jsx$1("div", { className: classes.cell1, children: cell1 })
      ] });
    });
  }
}
__publicField(DirectoryRow, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  isLast: PropTypes$1.bool,
  main: PropTypes$1.node.isRequired,
  cell1: PropTypes$1.node,
  cell2: PropTypes$1.node,
  cell3: PropTypes$1.node
});
__publicField(DirectoryRow, "defaultProps", {
  cell1: null,
  cell2: null,
  cell3: null,
  isLast: null
});
const DirectoryRow$1 = injectSheet(styles$2v)(DirectoryRow);
const styles$2u = {
  root: {
    display: "flex",
    flexGrow: 1,
    zIndex: 1
  }
};
const STATUS_INVALID = "invalid";
const STATUS_CAUTION = "caution";
const STATUS_VALID = "valid";
const STATUS_MODIFIED = "modified";
const styles$2t = (theme2) => ({
  root: {
    overflow: "hidden",
    transform: "translateZ(0)",
    borderRadius: 2,
    maxHeight: "inherit",
    boxShadow: `2px 3px 10px 0 rgba(0,0,0,0.1)`,
    '&[data-is-open="true"]': {
      border: `1px solid ${theme2.indigo3}`
    },
    '&[data-is-invalid="true"]': {
      borderColor: theme2.warningRed
    }
  },
  options: {
    overflow: "auto",
    "-webkit-overflow-scrolling": "touch",
    backgroundColor: "inherit",
    maxHeight: "inherit",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    position: "relative",
    zIndex: 0,
    paddingTop: 35,
    "&::-webkit-scrollbar": {
      width: 6
    },
    "&::-webkit-scrollbar-track": {
      background: theme2.grey5,
      borderRadius: 10
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme2.grey3,
      borderRadius: 10,
      "&:hover": {
        background: theme2.grey2
      }
    }
  }
});
var candidateSelectors = [
  "input",
  "select",
  "textarea",
  "a[href]",
  "button",
  "[tabindex]",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable="false"])'
];
var candidateSelector = candidateSelectors.join(",");
var matches = typeof Element === "undefined" ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
function tabbable$1(el2, options) {
  options = options || {};
  var elementDocument = el2.ownerDocument || el2;
  var regularTabbables = [];
  var orderedTabbables = [];
  var untouchabilityChecker = new UntouchabilityChecker(elementDocument);
  var candidates = el2.querySelectorAll(candidateSelector);
  if (options.includeContainer) {
    if (matches.call(el2, candidateSelector)) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el2);
    }
  }
  var i3, candidate, candidateTabindex;
  for (i3 = 0; i3 < candidates.length; i3++) {
    candidate = candidates[i3];
    if (!isNodeMatchingSelectorTabbable(candidate, untouchabilityChecker)) continue;
    candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i3,
        tabIndex: candidateTabindex,
        node: candidate
      });
    }
  }
  var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function(a4) {
    return a4.node;
  }).concat(regularTabbables);
  return tabbableNodes;
}
tabbable$1.isTabbable = isTabbable;
tabbable$1.isFocusable = isFocusable;
function isNodeMatchingSelectorTabbable(node3, untouchabilityChecker) {
  if (!isNodeMatchingSelectorFocusable(node3, untouchabilityChecker) || isNonTabbableRadio(node3) || getTabindex(node3) < 0) {
    return false;
  }
  return true;
}
function isTabbable(node3, untouchabilityChecker) {
  if (!node3) throw new Error("No node provided");
  if (matches.call(node3, candidateSelector) === false) return false;
  return isNodeMatchingSelectorTabbable(node3, untouchabilityChecker);
}
function isNodeMatchingSelectorFocusable(node3, untouchabilityChecker) {
  untouchabilityChecker = untouchabilityChecker || new UntouchabilityChecker(node3.ownerDocument || node3);
  if (node3.disabled || isHiddenInput(node3) || untouchabilityChecker.isUntouchable(node3)) {
    return false;
  }
  return true;
}
var focusableCandidateSelector = candidateSelectors.concat("iframe").join(",");
function isFocusable(node3, untouchabilityChecker) {
  if (!node3) throw new Error("No node provided");
  if (matches.call(node3, focusableCandidateSelector) === false) return false;
  return isNodeMatchingSelectorFocusable(node3, untouchabilityChecker);
}
function getTabindex(node3) {
  var tabindexAttr = parseInt(node3.getAttribute("tabindex"), 10);
  if (!isNaN(tabindexAttr)) return tabindexAttr;
  if (isContentEditable(node3)) return 0;
  return node3.tabIndex;
}
function sortOrderedTabbables(a4, b3) {
  return a4.tabIndex === b3.tabIndex ? a4.documentOrder - b3.documentOrder : a4.tabIndex - b3.tabIndex;
}
function find$1(list, predicate) {
  for (var i3 = 0, length = list.length; i3 < length; i3++) {
    if (predicate(list[i3])) return list[i3];
  }
}
function isContentEditable(node3) {
  return node3.contentEditable === "true";
}
function isInput(node3) {
  return node3.tagName === "INPUT";
}
function isHiddenInput(node3) {
  return isInput(node3) && node3.type === "hidden";
}
function isRadio(node3) {
  return isInput(node3) && node3.type === "radio";
}
function isNonTabbableRadio(node3) {
  return isRadio(node3) && !isTabbableRadio(node3);
}
function getCheckedRadio(nodes2) {
  for (var i3 = 0; i3 < nodes2.length; i3++) {
    if (nodes2[i3].checked) {
      return nodes2[i3];
    }
  }
}
function isTabbableRadio(node3) {
  if (!node3.name) return true;
  var radioSet = node3.ownerDocument.querySelectorAll('input[type="radio"][name="' + node3.name + '"]');
  var checked = getCheckedRadio(radioSet);
  return !checked || checked === node3;
}
function UntouchabilityChecker(elementDocument) {
  this.doc = elementDocument;
  this.cache = [];
}
UntouchabilityChecker.prototype.hasDisplayNone = function hasDisplayNone(node3, nodeComputedStyle) {
  if (node3.nodeType !== Node.ELEMENT_NODE) return false;
  var cached = find$1(this.cache, function(item) {
    return item === node3;
  });
  if (cached) return cached[1];
  nodeComputedStyle = nodeComputedStyle || this.doc.defaultView.getComputedStyle(node3);
  var result2 = false;
  if (nodeComputedStyle.display === "none") {
    result2 = true;
  } else if (node3.parentNode) {
    result2 = this.hasDisplayNone(node3.parentNode);
  }
  this.cache.push([node3, result2]);
  return result2;
};
UntouchabilityChecker.prototype.isUntouchable = function isUntouchable(node3) {
  if (node3 === this.doc.documentElement) return false;
  var computedStyle = this.doc.defaultView.getComputedStyle(node3);
  if (this.hasDisplayNone(node3, computedStyle)) return true;
  return computedStyle.visibility === "hidden";
};
var tabbable_1 = tabbable$1;
var immutable = extend$3;
var hasOwnProperty$g = Object.prototype.hasOwnProperty;
function extend$3() {
  var target = {};
  for (var i3 = 0; i3 < arguments.length; i3++) {
    var source = arguments[i3];
    for (var key2 in source) {
      if (hasOwnProperty$g.call(source, key2)) {
        target[key2] = source[key2];
      }
    }
  }
  return target;
}
var tabbable = tabbable_1;
var xtend$7 = immutable;
var listeningFocusTrap = null;
function focusTrap(element, userOptions) {
  var doc = document;
  var container = typeof element === "string" ? doc.querySelector(element) : element;
  var config = xtend$7(
    {
      returnFocusOnDeactivate: true,
      escapeDeactivates: true
    },
    userOptions
  );
  var state = {
    firstTabbableNode: null,
    lastTabbableNode: null,
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false
  };
  var trap = {
    activate,
    deactivate,
    pause,
    unpause
  };
  return trap;
  function activate(activateOptions) {
    if (state.active) return;
    updateTabbableNodes();
    state.active = true;
    state.paused = false;
    state.nodeFocusedBeforeActivation = doc.activeElement;
    var onActivate = activateOptions && activateOptions.onActivate ? activateOptions.onActivate : config.onActivate;
    if (onActivate) {
      onActivate();
    }
    addListeners();
    return trap;
  }
  function deactivate(deactivateOptions) {
    if (!state.active) return;
    removeListeners();
    state.active = false;
    state.paused = false;
    var onDeactivate = deactivateOptions && deactivateOptions.onDeactivate !== void 0 ? deactivateOptions.onDeactivate : config.onDeactivate;
    if (onDeactivate) {
      onDeactivate();
    }
    var returnFocus = deactivateOptions && deactivateOptions.returnFocus !== void 0 ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate;
    if (returnFocus) {
      delay$1(function() {
        tryFocus(state.nodeFocusedBeforeActivation);
      });
    }
    return trap;
  }
  function pause() {
    if (state.paused || !state.active) return;
    state.paused = true;
    removeListeners();
  }
  function unpause() {
    if (!state.paused || !state.active) return;
    state.paused = false;
    addListeners();
  }
  function addListeners() {
    if (!state.active) return;
    if (listeningFocusTrap) {
      listeningFocusTrap.pause();
    }
    listeningFocusTrap = trap;
    updateTabbableNodes();
    delay$1(function() {
      tryFocus(getInitialFocusNode());
    });
    doc.addEventListener("focusin", checkFocusIn, true);
    doc.addEventListener("mousedown", checkPointerDown, true);
    doc.addEventListener("touchstart", checkPointerDown, true);
    doc.addEventListener("click", checkClick, true);
    doc.addEventListener("keydown", checkKey, true);
    return trap;
  }
  function removeListeners() {
    if (!state.active || listeningFocusTrap !== trap) return;
    doc.removeEventListener("focusin", checkFocusIn, true);
    doc.removeEventListener("mousedown", checkPointerDown, true);
    doc.removeEventListener("touchstart", checkPointerDown, true);
    doc.removeEventListener("click", checkClick, true);
    doc.removeEventListener("keydown", checkKey, true);
    listeningFocusTrap = null;
    return trap;
  }
  function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    var node3 = optionValue;
    if (!optionValue) {
      return null;
    }
    if (typeof optionValue === "string") {
      node3 = doc.querySelector(optionValue);
      if (!node3) {
        throw new Error("`" + optionName + "` refers to no known node");
      }
    }
    if (typeof optionValue === "function") {
      node3 = optionValue();
      if (!node3) {
        throw new Error("`" + optionName + "` did not return a node");
      }
    }
    return node3;
  }
  function getInitialFocusNode() {
    var node3;
    if (getNodeForOption("initialFocus") !== null) {
      node3 = getNodeForOption("initialFocus");
    } else if (container.contains(doc.activeElement)) {
      node3 = doc.activeElement;
    } else {
      node3 = state.firstTabbableNode || getNodeForOption("fallbackFocus");
    }
    if (!node3) {
      throw new Error(
        "You can't have a focus-trap without at least one focusable element"
      );
    }
    return node3;
  }
  function checkPointerDown(e5) {
    if (container.contains(e5.target)) return;
    if (config.clickOutsideDeactivates) {
      deactivate({
        returnFocus: !tabbable.isFocusable(e5.target)
      });
    } else {
      e5.preventDefault();
    }
  }
  function checkFocusIn(e5) {
    if (container.contains(e5.target) || e5.target instanceof Document) {
      return;
    }
    e5.stopImmediatePropagation();
    tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
  }
  function checkKey(e5) {
    if (config.escapeDeactivates !== false && isEscapeEvent(e5)) {
      e5.preventDefault();
      deactivate();
      return;
    }
    if (isTabEvent(e5)) {
      checkTab(e5);
      return;
    }
  }
  function checkTab(e5) {
    updateTabbableNodes();
    if (e5.shiftKey && e5.target === state.firstTabbableNode) {
      e5.preventDefault();
      tryFocus(state.lastTabbableNode);
      return;
    }
    if (!e5.shiftKey && e5.target === state.lastTabbableNode) {
      e5.preventDefault();
      tryFocus(state.firstTabbableNode);
      return;
    }
  }
  function checkClick(e5) {
    if (config.clickOutsideDeactivates) return;
    if (container.contains(e5.target)) return;
    e5.preventDefault();
    e5.stopImmediatePropagation();
  }
  function updateTabbableNodes() {
    var tabbableNodes = tabbable(container);
    state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
    state.lastTabbableNode = tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
  }
  function tryFocus(node3) {
    if (node3 === doc.activeElement) return;
    if (!node3 || !node3.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }
    node3.focus();
    state.mostRecentlyFocusedNode = node3;
    if (isSelectableInput(node3)) {
      node3.select();
    }
  }
}
function isSelectableInput(node3) {
  return node3.tagName && node3.tagName.toLowerCase() === "input" && typeof node3.select === "function";
}
function isEscapeEvent(e5) {
  return e5.key === "Escape" || e5.key === "Esc" || e5.keyCode === 27;
}
function isTabEvent(e5) {
  return e5.key === "Tab" || e5.keyCode === 9;
}
function delay$1(fn2) {
  return setTimeout(fn2, 0);
}
var focusTrap_1 = focusTrap;
const createFocusTrap = /* @__PURE__ */ getDefaultExportFromCjs$1(focusTrap_1);
var bodyScrollLock_min = {};
(function(exports) {
  !function(e5, t3) {
    t3(exports);
  }(commonjsGlobal, function(exports2) {
    function i3(e6) {
      if (Array.isArray(e6)) {
        for (var t3 = 0, o3 = Array(e6.length); t3 < e6.length; t3++) o3[t3] = e6[t3];
        return o3;
      }
      return Array.from(e6);
    }
    Object.defineProperty(exports2, "__esModule", { value: true });
    var l2 = false;
    if ("undefined" != typeof window) {
      var e5 = { get passive() {
        l2 = true;
      } };
      window.addEventListener("testPassive", null, e5), window.removeEventListener("testPassive", null, e5);
    }
    function d4(t3) {
      return u3.some(function(e6) {
        return !(!e6.options.allowTouchMove || !e6.options.allowTouchMove(t3));
      });
    }
    function c3(e6) {
      var t3 = e6 || window.event;
      return !!d4(t3.target) || (1 < t3.touches.length || (t3.preventDefault && t3.preventDefault(), false));
    }
    function o2() {
      setTimeout(function() {
        void 0 !== m4 && (document.body.style.paddingRight = m4, m4 = void 0), void 0 !== f2 && (document.body.style.overflow = f2, f2 = void 0);
      });
    }
    var a4 = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && 1 < window.navigator.maxTouchPoints), u3 = [], s4 = false, v2 = -1, f2 = void 0, m4 = void 0;
    exports2.disableBodyScroll = function(r2, e6) {
      if (a4) {
        if (!r2) return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        if (r2 && !u3.some(function(e7) {
          return e7.targetElement === r2;
        })) {
          var t3 = { targetElement: r2, options: e6 || {} };
          u3 = [].concat(i3(u3), [t3]), r2.ontouchstart = function(e7) {
            1 === e7.targetTouches.length && (v2 = e7.targetTouches[0].clientY);
          }, r2.ontouchmove = function(e7) {
            var t4, o4, n3, i4;
            1 === e7.targetTouches.length && (o4 = r2, i4 = (t4 = e7).targetTouches[0].clientY - v2, d4(t4.target) || (o4 && 0 === o4.scrollTop && 0 < i4 || (n3 = o4) && n3.scrollHeight - n3.scrollTop <= n3.clientHeight && i4 < 0 ? c3(t4) : t4.stopPropagation()));
          }, s4 || (document.addEventListener("touchmove", c3, l2 ? { passive: false } : void 0), s4 = true);
        }
      } else {
        n2 = e6, setTimeout(function() {
          if (void 0 === m4) {
            var e7 = !!n2 && true === n2.reserveScrollBarGap, t4 = window.innerWidth - document.documentElement.clientWidth;
            e7 && 0 < t4 && (m4 = document.body.style.paddingRight, document.body.style.paddingRight = t4 + "px");
          }
          void 0 === f2 && (f2 = document.body.style.overflow, document.body.style.overflow = "hidden");
        });
        var o3 = { targetElement: r2, options: e6 || {} };
        u3 = [].concat(i3(u3), [o3]);
      }
      var n2;
    }, exports2.clearAllBodyScrollLocks = function() {
      a4 ? (u3.forEach(function(e6) {
        e6.targetElement.ontouchstart = null, e6.targetElement.ontouchmove = null;
      }), s4 && (document.removeEventListener("touchmove", c3, l2 ? { passive: false } : void 0), s4 = false), u3 = [], v2 = -1) : (o2(), u3 = []);
    }, exports2.enableBodyScroll = function(t3) {
      if (a4) {
        if (!t3) return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        t3.ontouchstart = null, t3.ontouchmove = null, u3 = u3.filter(function(e6) {
          return e6.targetElement !== t3;
        }), s4 && 0 === u3.length && (document.removeEventListener("touchmove", c3, l2 ? { passive: false } : void 0), s4 = false);
      } else (u3 = u3.filter(function(e6) {
        return e6.targetElement !== t3;
      })).length || o2();
    };
  });
})(bodyScrollLock_min);
const styles$2s = () => ({
  root: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    zIndex: VENEER_FIXED_ZINDEX,
    overflow: "hidden"
  },
  content: {
    position: "absolute",
    "&:focus": {
      outline: "none"
    }
  },
  contentCentred: {
    top: "50%",
    left: "50%",
    transform: "translateY(-50%) translateX(-50%)",
    maxWidth: `calc(100vw - ${VIEWPORT_MARGIN * 2}px)`,
    maxHeight: `calc(100vh - ${VIEWPORT_MARGIN * 2}px)`
  }
});
class Veneer extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "onClickPrimed", false);
    __publicField(this, "deBounce", false);
    __publicField(this, "componentWillUnmount", () => {
      this.deactivateFocusTrap(this.props.returnFocus);
      bodyScrollLock_min.clearAllBodyScrollLocks();
    });
    __publicField(this, "getScrollElement", () => {
      if (!this.props.scrollElementSelector) return this.content;
      return document.querySelector(this.props.scrollElementSelector);
    });
    __publicField(this, "componentDidMount", () => {
      bodyScrollLock_min.disableBodyScroll(this.getScrollElement());
      this.trap = createFocusTrap(this.content, {
        initialFocus: this.props.focusElement || void 0,
        fallbackFocus: this.content,
        escapeDeactivates: true,
        clickOutsideDeactivates: true,
        returnFocusOnDeactivate: false
      });
      this.trap.activate();
    });
    __publicField(this, "handleCollapse", () => {
      if (this.deBounce) return;
      this.deBounce = true;
      window.setTimeout(() => {
        this.deBounce = false;
      }, 100);
      const veneerStack = document.querySelectorAll(
        `[class="${this.props.classes.root}"]`
      );
      if (veneerStack[veneerStack.length - 1] === this.veneer) {
        this.deactivateFocusTrap(true);
        this.props.handleCollapse();
      }
    });
    __publicField(this, "handleMouseDown", (event) => {
      if (this.content.contains(event.target)) {
        this.onClickPrimed = false;
        return;
      }
      this.onClickPrimed = true;
    });
    __publicField(this, "handleMouseUp", (event) => {
      if (!this.onClickPrimed) return;
      this.onClickPrimed = false;
      if (!this.content.contains(event.target)) {
        this.handleCollapse();
      }
    });
    __publicField(this, "handleKeyPress", (event) => {
      const hotKeys = {
        27: () => {
          this.handleCollapse();
        }
      };
      if (hotKeys[event.keyCode]) {
        event.preventDefault();
        hotKeys[event.keyCode]();
      }
    });
    __publicField(this, "deactivateFocusTrap", (returnFocus) => {
      this.trap.deactivate({
        returnFocus
      });
    });
    __publicField(this, "getContentProps", () => {
      const {
        classes,
        contentPosition: { top, left, right, bottom }
      } = this.props;
      const isCentred = !top && !bottom && !left && !right;
      const style2 = !isCentred && {
        style: {
          top,
          left,
          right,
          bottom,
          maxWidth: window.innerWidth - ((left || VIEWPORT_MARGIN) + (right || VIEWPORT_MARGIN)),
          maxHeight: window.innerHeight - ((top || VIEWPORT_MARGIN) + (bottom || VIEWPORT_MARGIN))
        }
      };
      return {
        ref: (el2) => {
          this.content = el2;
        },
        tabIndex: "-1",
        className: classNames({
          [classes.content]: true,
          [classes.contentCentred]: isCentred
        }),
        ...style2
      };
    });
    __publicField(this, "render", () => {
      const { classes, children, invisible } = this.props;
      const rootProps = {
        className: classes.root,
        style: {
          backgroundColor: `rgba(0, 0, 0, ${invisible ? "0" : "0.3"})`,
          backdropFilter: `${invisible ? void 0 : "blur(2px)"}`
        },
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onTouchStart: this.handleMouseDown,
        onTouchEnd: this.handleMouseUp,
        onKeyDown: this.handleKeyPress,
        ref: (el2) => {
          this.veneer = el2;
        }
      };
      return createPortal(
        /* @__PURE__ */ jsx$1("div", { ...rootProps, children: /* @__PURE__ */ jsx$1("div", { ...this.getContentProps(), children }) }),
        document.body
      );
    });
  }
}
__publicField(Veneer, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  handleCollapse: PropTypes$1.func.isRequired,
  invisible: PropTypes$1.bool,
  focusElement: PropTypes$1.oneOfType([
    PropTypes$1.string,
    PropTypes$1.object,
    PropTypes$1.func
  ]),
  contentPosition: PropTypes$1.shape({
    top: PropTypes$1.number,
    left: PropTypes$1.number,
    right: PropTypes$1.number,
    bottom: PropTypes$1.number
  }),
  scrollElementSelector: PropTypes$1.string,
  returnFocus: PropTypes$1.bool
});
__publicField(Veneer, "defaultProps", {
  contentPosition: {},
  invisible: false,
  focusElement: null,
  scrollElementSelector: null,
  returnFocus: false
});
const Veneer$1 = injectSheet(styles$2s)(Veneer);
let SelectMenu$4 = (_b = class extends React__default.PureComponent {
  constructor(props2) {
    super(props2);
    __publicField(this, "buttonData", this.props.buttonElement.getBoundingClientRect());
    __publicField(this, "state", {
      top: this.buttonData.top < VIEWPORT_MARGIN ? VIEWPORT_MARGIN : this.buttonData.top,
      left: this.buttonData.left < VIEWPORT_MARGIN ? VIEWPORT_MARGIN : this.buttonData.left,
      right: window.innerWidth - this.buttonData.left - this.buttonData.width
    });
    __publicField(this, "componentDidUpdate", () => {
      if (this.props.hasValue)
        this.options.querySelector('[data-is-selected="true"]').focus();
    });
    __publicField(this, "componentDidMount", () => {
      window.addEventListener("resize", this.updateDimensions.bind(this));
    });
    __publicField(this, "componentWillUnmount", () => {
      window.removeEventListener("resize", this.updateDimensions.bind(this));
    });
    __publicField(this, "render", () => {
      const { classes, children, onCollapse, open, status } = this.props;
      const veneerProps = {
        handleCollapse: onCollapse,
        contentPosition: {
          top: this.state.top,
          left: this.state.left,
          right: this.state.right
        },
        invisible: true,
        scrollElement: `[class="${classes.options}"]`,
        returnFocus: true
      };
      const rootProps = {
        className: classes.root,
        "data-is-open": open,
        "data-is-invalid": status === STATUS_INVALID
      };
      const optionsProps = {
        className: classes.options,
        ref: this.setOptionsRef
      };
      return /* @__PURE__ */ jsx$1(Veneer$1, { ...veneerProps, children: /* @__PURE__ */ jsx$1("div", { ...rootProps, children: /* @__PURE__ */ jsx$1("div", { ...optionsProps, children }) }) });
    });
    this.setOptionsRef = this.setOptionsRef.bind(this);
  }
  setOptionsRef(el2) {
    this.options = el2;
  }
  updateDimensions() {
    this.buttonData = this.props.buttonElement.getBoundingClientRect();
    this.setState({
      top: this.buttonData.top < VIEWPORT_MARGIN ? VIEWPORT_MARGIN : this.buttonData.top,
      left: this.buttonData.left < VIEWPORT_MARGIN ? VIEWPORT_MARGIN : this.buttonData.left,
      right: window.innerWidth - this.buttonData.left - this.buttonData.width
    });
  }
}, __publicField(_b, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  onCollapse: PropTypes$1.func.isRequired,
  buttonElement: PropTypes$1.object.isRequired,
  hasValue: PropTypes$1.bool.isRequired,
  open: PropTypes$1.bool.isRequired,
  status: PropTypes$1.oneOf([STATUS_INVALID])
}), __publicField(_b, "defaultProps", {
  status: null
}), _b);
const SelectMenu$5 = injectSheet(styles$2t)(SelectMenu$4);
const styles$2r = (theme2) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexGrow: 1,
    minWidth: 200,
    maxWidth: "100%",
    appearance: "none",
    boxSizing: "border-box",
    outline: "none",
    border: `1px solid ${theme2.grey5}`,
    backgroundColor: theme2.white1,
    borderRadius: 5,
    flexShrink: 0,
    cursor: "default",
    height: MIN_TARGET_SIZE + 2,
    paddingLeft: 7,
    paddingRight: 7,
    fontSize: 14,
    fontWeight: 400,
    color: theme2.grey1,
    zIndex: 10,
    transition: "border-color 150ms linear 0ms",
    "&[disabled]": {
      opacity: 0.3
    },
    '&[data-is-invalid="true"]': {
      borderColor: theme2.warningRed
    },
    '&[data-has-value="false"]': {
      color: theme2.grey4
    },
    '&[data-is-open="true"]': {
      borderTop: `1px solid ${theme2.indigo3}`,
      borderLeft: `1px solid ${theme2.indigo3}`,
      borderRight: `1px solid ${theme2.indigo3}`,
      '&[data-is-invalid="true"]': {
        borderColor: theme2.warningRed,
        borderBottom: `1px solid ${theme2.grey5}`
      }
    }
  },
  value: {
    flexGrow: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  icon: {
    color: theme2.grey3,
    transform: "rotate(0deg)",
    transition: "transform 0.3s ease-in-out",
    '&[data-is-open="true"]': {
      transform: "rotate(180deg)"
    }
  }
});
let SelectButton$2 = (_c = class extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleClick", () => {
      if (!this.props.disabled) this.props.onClick();
    });
    __publicField(this, "render", () => {
      const {
        classes,
        id: id2,
        children,
        hasValue,
        buttonRef,
        disabled,
        status,
        onFocus,
        onBlur,
        open
      } = this.props;
      const rootProps = {
        className: classes.root,
        id: id2,
        onFocus,
        onBlur,
        onClick: this.handleClick,
        type: "button",
        ref: buttonRef,
        disabled,
        "data-has-value": hasValue,
        "data-is-invalid": status === STATUS_INVALID,
        "data-is-open": open,
        "data-cy": "atomic-dropdown-select"
      };
      const iconProps = {
        className: classes.icon,
        "data-is-open": open
      };
      return /* @__PURE__ */ jsxs("button", { ...rootProps, children: [
        /* @__PURE__ */ jsx$1("span", { className: classes.value, children }),
        /* @__PURE__ */ jsx$1("span", { ...iconProps, children: /* @__PURE__ */ jsx$1(icons.ArrowDownFill, { size: 17 }) })
      ] });
    });
  }
}, __publicField(_c, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  id: PropTypes$1.string,
  children: PropTypes$1.node.isRequired,
  onFocus: PropTypes$1.func.isRequired,
  onBlur: PropTypes$1.func.isRequired,
  onClick: PropTypes$1.func.isRequired,
  hasValue: PropTypes$1.bool.isRequired,
  buttonRef: PropTypes$1.func.isRequired,
  open: PropTypes$1.bool.isRequired,
  status: PropTypes$1.oneOf([STATUS_INVALID]),
  disabled: PropTypes$1.bool
}), __publicField(_c, "defaultProps", {
  id: null,
  status: null,
  disabled: false
}), _c);
const SelectButton$3 = injectSheet(styles$2r)(SelectButton$2);
let Select$2 = (_d = class extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      expanded: false
    });
    __publicField(this, "handleToggle", () => {
      this.setState({
        expanded: !this.state.expanded
      });
    });
    __publicField(this, "handleCollapse", () => {
      this.setState({
        expanded: false
      });
    });
    __publicField(this, "handleOptionClick", (e5) => {
      this.props.onChange(e5);
      this.handleCollapse();
    });
    __publicField(this, "getLabel", () => {
      const selectedOption = Children$1.toArray(this.props.children).find(
        (option2) => option2.props.selected === true
      );
      if (!selectedOption) return this.props.placeholder;
      return selectedOption.props.label;
    });
    __publicField(this, "getOptions", () => Children$1.map(
      this.props.children,
      (option2) => cloneElement(option2, {
        onClick: this.handleOptionClick
      })
    ));
    __publicField(this, "render", () => {
      const {
        classes,
        id: id2,
        placeholder,
        status,
        disabled,
        onBlur,
        onFocus,
        selectRef
      } = this.props;
      const label = this.getLabel();
      const rootProps = {
        className: classes.root,
        ref: selectRef
      };
      const buttonProps = {
        id: id2,
        onFocus,
        onBlur,
        onClick: this.handleToggle,
        hasValue: label !== placeholder,
        status,
        disabled,
        open: this.state.expanded,
        buttonRef: (el2) => {
          this.button = el2;
        }
      };
      const selectMenuProps = {
        onCollapse: this.handleCollapse,
        hasValue: label !== placeholder,
        buttonElement: this.button,
        children: this.getOptions(),
        open: this.state.expanded,
        status
      };
      return /* @__PURE__ */ jsxs("div", { ...rootProps, children: [
        /* @__PURE__ */ jsx$1(SelectButton$3, { ...buttonProps, children: label }),
        !disabled && this.state.expanded && /* @__PURE__ */ jsx$1(SelectMenu$5, { ...selectMenuProps })
      ] });
    });
  }
}, __publicField(_d, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  id: PropTypes$1.string,
  onFocus: PropTypes$1.func,
  onBlur: PropTypes$1.func,
  onChange: PropTypes$1.func,
  selectRef: PropTypes$1.func,
  placeholder: PropTypes$1.string,
  status: PropTypes$1.oneOf([STATUS_INVALID]),
  disabled: PropTypes$1.bool
}), __publicField(_d, "defaultProps", {
  id: null,
  onFocus: () => {
  },
  onBlur: () => {
  },
  onChange: () => {
  },
  selectRef: () => {
  },
  placeholder: "",
  status: null,
  disabled: false
}), _d);
const Select$3 = injectSheet(styles$2u)(Select$2);
const styles$2q = (theme2) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    backgroundColor: "inherit"
  },
  label: {
    paddingBottom: 8,
    color: theme2.grey1,
    fontSize: 16,
    fontWeight: 600,
    letterSpacing: 0,
    '[data-input-is-required="true"] > &::before': {
      content: '"* "',
      color: theme2.warningRed
    }
  }
});
class Dumblabel extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const {
        classes,
        hideLabel,
        text,
        forId,
        children,
        inputHasFocus,
        inputHasValue,
        status,
        maxWidth,
        required: required2
      } = this.props;
      const rootProps = {
        className: classes.root,
        "data-input-has-focus": inputHasFocus,
        "data-input-has-value": inputHasValue,
        "data-input-is-required": required2,
        "data-input-is-invalid": status === STATUS_INVALID,
        "data-input-is-caution": status === STATUS_CAUTION,
        "data-input-is-valid": status === STATUS_VALID,
        "data-is-max-width": maxWidth
      };
      return /* @__PURE__ */ jsxs("label", { ...rootProps, htmlFor: forId, children: [
        /* @__PURE__ */ jsx$1(Invisible$1, { visible: !hideLabel, children: /* @__PURE__ */ jsx$1("div", { className: classes.label, children: /* @__PURE__ */ jsx$1("span", { children: text }) }) }),
        children
      ] });
    });
  }
}
__publicField(Dumblabel, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  text: PropTypes$1.string.isRequired,
  forId: PropTypes$1.string.isRequired,
  children: PropTypes$1.node.isRequired,
  inputHasFocus: PropTypes$1.bool.isRequired,
  inputHasValue: PropTypes$1.bool.isRequired,
  status: PropTypes$1.oneOf([STATUS_INVALID, STATUS_CAUTION, STATUS_VALID]),
  maxWidth: PropTypes$1.bool,
  required: PropTypes$1.bool,
  hideLabel: PropTypes$1.bool
});
__publicField(Dumblabel, "defaultProps", {
  status: null,
  maxWidth: false,
  required: false,
  hideLabel: false
});
const Dumblabel$1 = injectSheet(styles$2q)(Dumblabel);
const styles$2p = (theme2) => ({
  content: {
    width: "100%",
    position: "relative",
    color: theme2.warningRed,
    fontSize: 12,
    letterSpacing: "0.24px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    padding: "4px 0"
  }
});
const ErrorMessage = ({ classes, text, dataCy }) => /* @__PURE__ */ jsx$1("div", { className: classes.content, "data-cy": dataCy || "atomic-error-message", children: text });
ErrorMessage.propTypes = {
  classes: PropTypes$1.object.isRequired,
  text: PropTypes$1.string.isRequired,
  dataCy: PropTypes$1.string
};
ErrorMessage.defaultProps = {
  dataCy: ""
};
const ErrorMessage$1 = injectSheet(styles$2p)(ErrorMessage);
const Dropdown = (props2) => {
  const [blurCounter, setBlurCount] = React__default.useState(0);
  const generatedId = uniqueId$1("fslctc_");
  const {
    onValueChange,
    children,
    label,
    id: id2,
    invalid: invalid2,
    selectRef,
    disabled,
    required: required2,
    errorMessage,
    value,
    hideLabel
  } = props2;
  const error2 = value === "" && blurCounter > 1 && required2;
  const handleFocus = () => {
    setBlurCount(required2 ? blurCounter + 1 : blurCounter);
  };
  const labelProps = {
    forId: id2 || generatedId,
    text: label,
    required: required2,
    inputHasFocus: false,
    inputHasValue: false,
    hideLabel
  };
  const selectProps = {
    id: id2 || generatedId,
    placeholder: label,
    onChange: (e5) => onValueChange(e5),
    status: error2 || invalid2 ? STATUS_INVALID : null,
    selectRef,
    disabled,
    onFocus: handleFocus
  };
  return /* @__PURE__ */ jsxs(Dumblabel$1, { ...labelProps, children: [
    /* @__PURE__ */ jsx$1(Select$3, { ...selectProps, children }),
    invalid2 && !!errorMessage && /* @__PURE__ */ jsx$1(ErrorMessage$1, { text: errorMessage })
  ] });
};
Dropdown.propTypes = {
  children: PropTypes$1.node.isRequired,
  label: PropTypes$1.string.isRequired,
  onValueChange: PropTypes$1.func.isRequired,
  errorMessage: PropTypes$1.string,
  selectRef: PropTypes$1.func,
  invalid: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  required: PropTypes$1.bool,
  value: PropTypes$1.string,
  hideLabel: PropTypes$1.bool,
  id: PropTypes$1.string
};
Dropdown.defaultProps = {
  selectRef: () => {
  },
  errorMessage: "",
  invalid: false,
  disabled: false,
  required: false,
  value: "",
  hideLabel: false,
  id: ""
};
const styles$2o = (theme2) => ({
  root: {
    minHeight: MIN_TARGET_SIZE + 2,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    boxSizing: "border-box",
    appearance: "none",
    flexShrink: 0,
    flexGrow: 1,
    cursor: "default",
    outline: "none",
    paddingLeft: 7,
    paddingRight: 14,
    fontSize: 14,
    fontWeight: 400,
    color: theme2.grey1,
    position: "relative",
    marginLeft: 0,
    marginRight: 0,
    backgroundColor: theme2.white1,
    "&:hover": {
      backgroundColor: theme2.grey8
    },
    '&[data-is-selected="true"]': {
      backgroundColor: theme2.grey8
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }
  },
  prefix: {
    marginRight: 7,
    width: 14,
    flexShrink: 0
  }
});
let Option$1 = (_e = class extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, label, value, selected, onClick } = this.props;
      const rootProps = {
        className: classes.root,
        value,
        "data-is-selected": selected,
        onClick,
        "data-cy": "atomic-dropdown-option"
      };
      return /* @__PURE__ */ jsx$1("button", { ...rootProps, children: label });
    });
  }
}, __publicField(_e, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  label: PropTypes$1.node.isRequired,
  value: PropTypes$1.string.isRequired,
  onClick: PropTypes$1.func.isRequired,
  selected: PropTypes$1.bool
}), __publicField(_e, "defaultProps", {
  selected: false
}), _e);
const OptionDrop = injectSheet(styles$2o)(Option$1);
const styles$2n = (theme2) => ({
  root: {
    display: "flex",
    boxSizing: "border-box",
    position: "relative",
    width: "100%",
    backgroundColor: theme2.white1,
    borderRadius: 2,
    '&[data-is-max-width="true"]': {
      maxWidth: 300
    }
  },
  label: {
    boxSizing: "border-box",
    position: "absolute",
    zIndex: 2,
    top: -6,
    left: 4,
    height: 13,
    lineHeight: `13px`,
    paddingLeft: 3,
    paddingRight: 3,
    fontSize: 10,
    fontWeight: 400,
    color: theme2.grey3,
    whiteSpace: "nowrap",
    overflow: "hidden",
    transition: "color 150ms linear 0ms",
    "& > span": {
      opacity: 0,
      transition: "opacity 150ms linear 0ms"
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: 6,
      height: 1,
      left: 0,
      right: 0,
      backgroundColor: theme2.white1,
      zIndex: -1,
      opacity: 0,
      transform: `scaleX(0)`,
      transition: "opacity 0ms linear 200ms, transform 50ms linear 150ms"
    },
    '[data-input-has-value="true"] > &': {
      "&::after": {
        opacity: 1,
        transform: `scaleX(1)`,
        transitionDelay: "0ms, 0ms"
      },
      "& > span": {
        opacity: 1,
        transitionDelay: "100ms"
      }
    },
    '[data-input-has-focus="true"]:not([data-input-is-invalid="true"]):not([data-input-is-caution="true"]):not([data-input-is-valid="true"]):not([data-input-is-modified="true"]) > &': {
      color: theme2.indigo3
    },
    '[data-input-is-required="true"] > &::before': {
      content: '"* "'
    },
    '[data-input-is-invalid="true"] > &': {
      color: theme2.warningRed
    },
    '[data-input-is-caution="true"] > &': {
      color: theme2.cautionOrange
    },
    '[data-input-is-valid="true"] > &': {
      color: theme2.validGreen
    },
    '[data-input-is-modified="true"] > &': {
      color: theme2.teal1
    }
  }
});
class Smartlabel extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const {
        classes,
        hideLabel,
        text,
        forId,
        children,
        inputHasFocus,
        inputHasValue,
        status,
        maxWidth,
        required: required2
      } = this.props;
      const rootProps = {
        className: classes.root,
        "data-input-has-focus": inputHasFocus,
        "data-input-has-value": inputHasValue,
        "data-input-is-required": required2,
        "data-input-is-invalid": status === STATUS_INVALID,
        "data-input-is-caution": status === STATUS_CAUTION,
        "data-input-is-valid": status === STATUS_VALID,
        "data-input-is-modified": status === STATUS_MODIFIED,
        "data-is-max-width": maxWidth
      };
      return /* @__PURE__ */ jsxs("label", { ...rootProps, htmlFor: forId, children: [
        /* @__PURE__ */ jsx$1(Invisible$1, { visible: !hideLabel, children: /* @__PURE__ */ jsx$1("div", { className: classes.label, children: /* @__PURE__ */ jsx$1("span", { children: text }) }) }),
        children
      ] });
    });
  }
}
__publicField(Smartlabel, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  text: PropTypes$1.string.isRequired,
  forId: PropTypes$1.string.isRequired,
  children: PropTypes$1.node.isRequired,
  inputHasFocus: PropTypes$1.bool.isRequired,
  inputHasValue: PropTypes$1.bool.isRequired,
  status: PropTypes$1.oneOf([
    STATUS_INVALID,
    STATUS_CAUTION,
    STATUS_VALID,
    STATUS_MODIFIED
  ]),
  maxWidth: PropTypes$1.bool,
  required: PropTypes$1.bool,
  hideLabel: PropTypes$1.bool
});
__publicField(Smartlabel, "defaultProps", {
  status: null,
  maxWidth: false,
  required: false,
  hideLabel: false
});
const Smartlabel$1 = injectSheet(styles$2n)(Smartlabel);
const styles$2m = (theme2) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    flexGrow: 1,
    backgroundColor: theme2.white1,
    border: `1px solid ${theme2.grey5}`,
    borderRadius: 5,
    transition: "border-color 150ms linear 0ms",
    '&[data-is-disabled="true"]': {
      opacity: 0.3
    },
    '&[data-has-focus="true"]': {
      borderColor: theme2.indigo3
    },
    '&[data-has-value="true"]:not([data-has-focus="true"]):not([data-is-invalid="true"]):not([data-is-caution="true"]):not([data-is-valid="true"]):not([data-is-modified="true"])': {
      borderColor: theme2.grey5
    },
    '&[data-is-invalid="true"]': {
      borderColor: theme2.warningRed
    },
    '&[data-is-caution="true"]': {
      borderColor: theme2.cautionOrange
    },
    '&[data-is-valid="true"]': {
      borderColor: theme2.validGreen
    },
    '&[data-is-modified="true"]': {
      borderColor: theme2.teal1
    }
  },
  prefix: {
    display: "flex",
    flexShrink: 0,
    alignItems: "center",
    paddingLeft: 13,
    color: theme2.grey3
  },
  input: {
    display: "block",
    flexGrow: 1,
    appearance: "none",
    boxSizing: "border-box",
    outline: "none",
    backgroundColor: "transparent",
    borderWidth: 0,
    borderRadius: "inherit",
    padding: "8px 11px 9px 11px",
    fontSize: 14,
    fontWeight: 400,
    color: theme2.grey1,
    "&::placeholder": {
      color: theme2.grey4
    },
    minWidth: 0
  },
  chips: {
    listStyle: "none",
    display: "flex",
    padding: "4px 11px 4px 11px",
    overflow: "auto",
    zIndex: 1
  },
  focusTrigger: {
    width: "100%",
    height: "100%",
    cursor: "pointer",
    position: "absolute"
  },
  chip: {
    backgroundColor: theme2.grey6,
    display: "flex",
    alignItems: "center",
    borderRadius: "5px",
    marginRight: "5px",
    padding: "2px 8px",
    "& span": {
      color: theme2.grey2,
      fontSize: "12px",
      whiteSpace: "nowrap"
    },
    "& svg": {
      fontSize: "1rem",
      fill: theme2.grey3,
      cursor: "pointer",
      transition: "fill 0.2s"
    }
  }
});
const styles$2l = (theme2) => ({
  root: {
    display: "flex",
    flexShrink: 0,
    alignItems: "center",
    paddingRight: 7,
    color: theme2.grey3
  }
});
class TextinputSuffix extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => /* @__PURE__ */ jsx$1("div", { className: this.props.classes.root, children: this.props.children }));
  }
}
__publicField(TextinputSuffix, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired
});
const TextinputSuffix$1 = injectSheet(styles$2l)(TextinputSuffix);
class Textinput extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      hasFocus: false,
      focusCounter: 0
    });
    __publicField(this, "timer");
    __publicField(this, "handleFocus", (e5) => {
      window.clearTimeout(this.timer);
      this.setState({
        hasFocus: true
      });
      this.props.handleFocus(e5);
    });
    __publicField(this, "handleBlur", (e5) => {
      const { required: required2 } = this.props;
      const { focusCounter } = this.state;
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        this.setState({
          hasFocus: false,
          focusCounter: required2 ? focusCounter + 1 : 0
        });
        this.props.handleBlur(e5);
      }, 50);
    });
    __publicField(this, "render", () => {
      const {
        classes,
        id: id2,
        value,
        type: type2,
        placeholder,
        handleChange,
        inputRef,
        prefix: prefix2,
        suffix,
        status,
        disabled,
        errorMessage,
        required: required2,
        dataCy,
        chips,
        removeChip
      } = this.props;
      const { focusCounter } = this.state;
      const invalid2 = (value === "" || value.match(/^[ \t\r\n\s]*$/g)) && focusCounter >= 0 && required2;
      const rootProps = {
        className: classes.root,
        "data-has-focus": this.state.hasFocus,
        "data-has-value": !!value.length,
        "data-is-invalid": status === STATUS_INVALID || (invalid2 === null ? false : invalid2),
        "data-is-caution": status === STATUS_CAUTION,
        "data-is-valid": status === STATUS_VALID,
        "data-is-modified": status === STATUS_MODIFIED,
        "data-is-disabled": disabled,
        "data-is-required": required2
      };
      const inputProps = {
        className: classes.input,
        id: id2,
        value,
        type: type2,
        placeholder,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: handleChange,
        ref: inputRef,
        disabled,
        "data-cy": dataCy,
        autoComplete: "off"
      };
      const renderChips = () => {
        const chips2 = value.split(", ");
        return /* @__PURE__ */ jsxs(Fragment$1, { children: [
          /* @__PURE__ */ jsx$1("ul", { className: classes.chips, children: chips2.map((chip, index2) => /* @__PURE__ */ jsxs("li", { className: classes.chip, children: [
            /* @__PURE__ */ jsx$1("span", { children: chip }),
            /* @__PURE__ */ jsx$1(
              "svg",
              {
                stroke: "currentColor",
                fill: "currentColor",
                strokeWidth: "0",
                version: "1.2",
                baseProfile: "tiny",
                viewBox: "0 0 24 24",
                tabIndex: "0",
                height: "1em",
                width: "1em",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: () => removeChip(chip),
                children: /* @__PURE__ */ jsx$1("path", { d: "M12 4c-4.419 0-8 3.582-8 8s3.581 8 8 8 8-3.582 8-8-3.581-8-8-8zm3.707 10.293c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-2.293-2.293-2.293 2.293c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414l2.293-2.293-2.293-2.293c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l2.293 2.293 2.293-2.293c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-2.293 2.293 2.293 2.293z" })
              }
            )
          ] }, index2)) }),
          /* @__PURE__ */ jsx$1("div", { className: classes.focusTrigger, onClick: this.handleFocus })
        ] });
      };
      return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
        /* @__PURE__ */ jsxs("div", { ...rootProps, children: [
          prefix2 && !chips && /* @__PURE__ */ jsx$1("span", { className: classes.prefix, children: prefix2 }),
          chips && value ? renderChips() : /* @__PURE__ */ jsx$1("input", { ...inputProps }),
          suffix && /* @__PURE__ */ jsx$1(TextinputSuffix$1, { children: suffix })
        ] }),
        invalid2 && errorMessage && /* @__PURE__ */ jsx$1(ErrorMessage$1, { text: errorMessage })
      ] });
    });
  }
}
__publicField(Textinput, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  id: PropTypes$1.string,
  value: PropTypes$1.string.isRequired,
  type: PropTypes$1.oneOf(["text", "password", "search"]).isRequired,
  placeholder: PropTypes$1.string,
  handleFocus: PropTypes$1.func,
  handleBlur: PropTypes$1.func,
  handleChange: PropTypes$1.func,
  inputRef: PropTypes$1.oneOfType([
    PropTypes$1.func,
    PropTypes$1.shape({ current: PropTypes$1.instanceOf(Element) })
  ]),
  prefix: PropTypes$1.node,
  suffix: PropTypes$1.node,
  status: PropTypes$1.oneOf([
    STATUS_INVALID,
    STATUS_CAUTION,
    STATUS_VALID,
    STATUS_MODIFIED
  ]),
  disabled: PropTypes$1.bool,
  errorMessage: PropTypes$1.string,
  required: PropTypes$1.bool,
  dataCy: PropTypes$1.string,
  chips: PropTypes$1.bool,
  removeChip: PropTypes$1.func
});
__publicField(Textinput, "defaultProps", {
  id: null,
  placeholder: null,
  handleFocus: () => {
  },
  handleBlur: () => {
  },
  handleChange: () => {
  },
  inputRef: () => {
  },
  prefix: null,
  suffix: null,
  status: null,
  disabled: false,
  errorMessage: "",
  required: false,
  dataCy: "atomic-textinput",
  chips: false,
  removeChip: () => {
  }
});
const Textinput$1 = injectSheet(styles$2m)(Textinput);
class FieldTextCompact extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      inputHasFocus: false
    });
    __publicField(this, "id", uniqueId$1("ftc_"));
    __publicField(this, "handleFocus", (e5) => {
      this.props.onFocus(e5);
      this.setState({
        inputHasFocus: true
      });
    });
    __publicField(this, "handleBlur", (e5) => {
      this.props.onBlur(e5);
      this.setState({
        inputHasFocus: false
      });
    });
    __publicField(this, "handleChange", (e5) => {
      this.props.onValueChange(e5);
    });
    __publicField(this, "render", () => {
      const {
        label,
        value,
        inputRef,
        disabled,
        invalid: invalid2,
        caution,
        valid,
        modified,
        required: required2,
        hideLabel,
        addClear,
        dataCy
      } = this.props;
      const { inputHasFocus } = this.state;
      let status;
      if (invalid2) {
        status = STATUS_INVALID;
      } else if (caution) {
        status = STATUS_CAUTION;
      } else if (valid) {
        status = STATUS_VALID;
      } else if (modified) {
        status = STATUS_MODIFIED;
      } else {
        status = null;
      }
      const labelProps = {
        forId: this.id,
        text: label,
        inputHasValue: !!value,
        inputHasFocus,
        status,
        required: required2,
        hideLabel
      };
      const inputProps = {
        type: addClear ? "search" : "text",
        placeholder: label,
        id: this.id,
        handleFocus: this.handleFocus,
        handleBlur: this.handleBlur,
        handleChange: this.handleChange,
        value,
        inputRef,
        status,
        disabled,
        dataCy
      };
      return /* @__PURE__ */ jsx$1(Smartlabel$1, { ...labelProps, children: /* @__PURE__ */ jsx$1(Textinput$1, { ...inputProps }) });
    });
  }
}
__publicField(FieldTextCompact, "propTypes", {
  label: PropTypes$1.string.isRequired,
  onValueChange: PropTypes$1.func.isRequired,
  inputRef: PropTypes$1.func,
  value: PropTypes$1.string,
  disabled: PropTypes$1.bool,
  invalid: PropTypes$1.bool,
  caution: PropTypes$1.bool,
  valid: PropTypes$1.bool,
  modified: PropTypes$1.bool,
  required: PropTypes$1.bool,
  hideLabel: PropTypes$1.bool,
  addClear: PropTypes$1.bool,
  onFocus: PropTypes$1.func,
  onBlur: PropTypes$1.func,
  dataCy: PropTypes$1.string
});
__publicField(FieldTextCompact, "defaultProps", {
  inputRef: () => {
  },
  value: "",
  disabled: false,
  invalid: false,
  caution: false,
  valid: false,
  modified: false,
  required: false,
  hideLabel: false,
  addClear: false,
  onFocus: () => {
  },
  onBlur: () => {
  },
  dataCy: "atomic-fieldtext-compact"
});
const styles$2k = (theme2) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    borderColor: theme2.grey5,
    backgroundColor: theme2.white1,
    borderStyle: "solid",
    borderWidth: 1,
    borderRadius: 5,
    padding: "8px 11px 9px 11px",
    transition: "border-color 150ms linear 0ms",
    '&[data-is-disabled="true"]': {
      opacity: 0.3
    },
    '&[data-has-focus="true"]': {
      borderColor: theme2.indigo3
    },
    '&[data-has-value="true"]:not([data-has-focus="true"]):not([data-is-invalid="true"]):not([data-is-caution="true"]):not([data-is-valid="true"]):not([data-is-modified="true"])': {
      borderColor: theme2.grey5
    },
    '&[data-is-invalid="true"]': {
      borderColor: theme2.warningRed
    },
    '&[data-is-caution="true"]': {
      borderColor: theme2.cautionOrange
    },
    '&[data-is-valid="true"]': {
      borderColor: theme2.validGreen
    },
    '&[data-is-modified="true"]': {
      borderColor: theme2.teal1
    },
    '&[data-is-required="true"]': {
      marginBottom: 22
    }
  },
  textarea: {
    display: "block",
    flexGrow: 1,
    appearance: "none",
    boxSizing: "border-box",
    outline: "none",
    backgroundColor: "transparent",
    borderWidth: 0,
    borderRadius: "inherit",
    fontSize: 14,
    lineHeight: `${TEXTAREA_LINE_HEIGHT}px`,
    height: (props2) => props2.rows ? `${TEXTAREA_LINE_HEIGHT * props2.rows}px` : "auto",
    fontWeight: 400,
    color: theme2.grey1,
    "&[data-is-not-resizeable=true]": {
      resize: "none"
    },
    "&::placeholder": {
      color: theme2.grey4
    }
  }
});
let TextArea$2 = (_f = class extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      hasFocus: false,
      focusCounter: 0
    });
    __publicField(this, "timer");
    __publicField(this, "handleFocus", (e5) => {
      window.clearTimeout(this.timer);
      this.setState({
        hasFocus: true
      });
      this.props.handleFocus(e5);
    });
    __publicField(this, "handleBlur", (e5) => {
      const { required: required2 } = this.props;
      const { focusCounter } = this.state;
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        this.setState({
          hasFocus: false,
          focusCounter: required2 ? focusCounter + 1 : 0
        });
        this.props.handleBlur(e5);
      }, 50);
    });
    __publicField(this, "render", () => {
      const {
        classes,
        id: id2,
        value,
        placeholder,
        handleChange,
        inputRef,
        status,
        disabled,
        rows,
        errorMessage,
        required: required2,
        noResize
      } = this.props;
      const { focusCounter } = this.state;
      const invalid2 = (value === "" || value.match(/^[ \t\r\n\s]*$/g)) && focusCounter > 0 && required2;
      const rootProps = {
        className: classes.root,
        "data-has-focus": this.state.hasFocus,
        "data-has-value": !!value.length,
        "data-is-invalid": status === STATUS_INVALID || (invalid2 === null ? false : invalid2),
        "data-is-caution": status === STATUS_CAUTION,
        "data-is-valid": status === STATUS_VALID,
        "data-is-modified": status === STATUS_MODIFIED,
        "data-is-disabled": disabled,
        "data-is-required": required2
      };
      const textAreaProps = {
        className: classes.textarea,
        id: id2,
        value,
        placeholder,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: handleChange,
        ref: inputRef,
        disabled,
        rows,
        "data-is-not-resizeable": noResize
      };
      return /* @__PURE__ */ jsxs("div", { ...rootProps, children: [
        /* @__PURE__ */ jsx$1("textarea", { ...textAreaProps }),
        invalid2 && errorMessage && /* @__PURE__ */ jsx$1(ErrorMessage$1, { text: errorMessage })
      ] });
    });
  }
}, __publicField(_f, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  id: PropTypes$1.string,
  value: PropTypes$1.string.isRequired,
  placeholder: PropTypes$1.string,
  handleFocus: PropTypes$1.func,
  handleBlur: PropTypes$1.func,
  handleChange: PropTypes$1.func,
  inputRef: PropTypes$1.func,
  suffix: PropTypes$1.node,
  status: PropTypes$1.oneOf([
    STATUS_INVALID,
    STATUS_CAUTION,
    STATUS_VALID,
    STATUS_MODIFIED
  ]),
  disabled: PropTypes$1.bool,
  rows: PropTypes$1.number,
  errorMessage: PropTypes$1.string,
  required: PropTypes$1.bool,
  noResize: PropTypes$1.bool
}), __publicField(_f, "defaultProps", {
  id: null,
  placeholder: null,
  handleFocus: () => {
  },
  handleBlur: () => {
  },
  handleChange: () => {
  },
  inputRef: () => {
  },
  suffix: null,
  status: null,
  disabled: false,
  rows: null,
  errorMessage: "",
  required: false,
  noResize: false
}), _f);
const Textarea = injectSheet(styles$2k)(TextArea$2);
class FieldTextAreaCompact extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      inputHasFocus: false
    });
    __publicField(this, "id", uniqueId$1("ftc_"));
    __publicField(this, "handleFocus", (e5) => {
      this.setState({
        inputHasFocus: true
      });
      this.props.onFocus(e5);
    });
    __publicField(this, "handleBlur", (e5) => {
      this.setState({
        inputHasFocus: false
      });
      this.props.onBlur(e5);
    });
    __publicField(this, "handleChange", (e5) => {
      this.props.onValueChange(e5);
    });
    __publicField(this, "render", () => {
      const {
        label,
        value,
        inputRef,
        disabled,
        invalid: invalid2,
        caution,
        valid,
        modified,
        rows,
        noResize
      } = this.props;
      const { inputHasFocus } = this.state;
      let status;
      if (invalid2) {
        status = STATUS_INVALID;
      } else if (caution) {
        status = STATUS_CAUTION;
      } else if (valid) {
        status = STATUS_VALID;
      } else if (modified) {
        status = STATUS_MODIFIED;
      } else {
        status = null;
      }
      const labelProps = {
        forId: this.id,
        text: label,
        inputHasValue: !!value,
        inputHasFocus,
        status
      };
      const textAreaProps = {
        type: "text",
        placeholder: label,
        id: this.id,
        handleFocus: this.handleFocus,
        handleBlur: this.handleBlur,
        handleChange: this.handleChange,
        value,
        inputRef,
        status,
        disabled,
        rows,
        noResize
      };
      return /* @__PURE__ */ jsx$1(Smartlabel$1, { ...labelProps, children: /* @__PURE__ */ jsx$1(Textarea, { ...textAreaProps }) });
    });
  }
}
__publicField(FieldTextAreaCompact, "propTypes", {
  label: PropTypes$1.string.isRequired,
  inputRef: PropTypes$1.func,
  value: PropTypes$1.string,
  disabled: PropTypes$1.bool,
  invalid: PropTypes$1.bool,
  caution: PropTypes$1.bool,
  valid: PropTypes$1.bool,
  modified: PropTypes$1.bool,
  rows: PropTypes$1.number,
  noResize: PropTypes$1.bool,
  onValueChange: PropTypes$1.func.isRequired,
  onFocus: PropTypes$1.func,
  onBlur: PropTypes$1.func
});
__publicField(FieldTextAreaCompact, "defaultProps", {
  inputRef: () => {
  },
  value: "",
  disabled: false,
  invalid: false,
  caution: false,
  valid: false,
  modified: false,
  rows: 3,
  noResize: false,
  onFocus: () => {
  },
  onBlur: () => {
  }
});
const styles$2j = (theme2) => ({
  button: {
    position: "relative",
    color: theme2.grey3,
    appearance: "none",
    backgroundColor: "transparent",
    borderRadius: "50%",
    overflow: "hidden",
    width: 24,
    height: 24,
    boxSizing: "border-box",
    cursor: "default",
    outline: "none",
    display: "block",
    "&::before": {
      content: '""',
      position: "absolute",
      width: MIN_TARGET_SIZE,
      height: MIN_TARGET_SIZE,
      top: "50%",
      left: "50%",
      transform: "translateY(-50%) translateX(-50%)"
    },
    "&[disabled]": {
      opacity: 0.3,
      color: theme2.grey3
    },
    "&:not([disabled]):hover": {
      cursor: "pointer",
      color: theme2.grey1
    },
    '&:not([disabled])[aria-checked="true"]': {
      color: theme2.grey3
    }
  }
});
const styles$2i = (theme2) => ({
  root: {
    display: "block",
    width: "100%",
    height: "100%",
    fill: "currentColor",
    "& *": {
      transformOrigin: `50%`,
      transitionTimingFunction: "ease-in-out",
      transitionDuration: "250ms",
      strokeLinejoin: "round"
    },
    '& [data-name="bg"]': {
      fill: theme2.indigoPastel2,
      opacity: 0,
      transitionProperty: "opacity"
    },
    '& [data-name="eye"]': {
      strokeWidth: 4,
      fill: "transparent",
      stroke: "currentColor"
    },
    '& [data-name="retina"]': {
      strokeWidth: 4,
      fill: "transparent",
      stroke: "currentColor",
      transitionProperty: "stroke-width, fill"
    },
    '& [data-name="slash"]': {
      opacity: 1,
      transform: `scaleY(1) rotate(30deg)`,
      transitionProperty: `opacity, transform`
    },
    '& [data-name="mask-left"]': {
      transform: `rotate(30deg) translateX(0)`,
      transitionProperty: `transform`
    },
    '& [data-name="mask-right"]': {
      transform: `rotate(30deg) translateX(0)`,
      transitionProperty: `transform`
    },
    // FOCUSED
    ":focus:not(:active) > &": {
      '& [data-name="bg"]': {
        opacity: 1
      }
    },
    // CHECKED
    '[aria-checked="false"]:hover > &, [aria-checked="true"]:not(:hover) > &': {
      '& [data-name="retina"]': {
        strokeWidth: 0,
        fill: "currentColor"
      },
      '& [data-name="slash"]': {
        opacity: 0,
        transform: `scaleY(0) rotate(0deg)`
      },
      '& [data-name="mask-left"]': {
        transform: `rotate(30deg) translateX(6px)`
      },
      '& [data-name="mask-right"]': {
        transform: `rotate(30deg) translateX(-6px)`
      }
    }
  }
});
class VisibilityIcon extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "id", uniqueId$1("vis_icon_"));
    __publicField(this, "render", () => {
      const { classes } = this.props;
      const slashMaskId = `mask_${this.id}`;
      const eyeMaskId = `eye_${this.id}`;
      const eyePath = "M13.5 50 C 30 18, 70 18, 86.5 50, C 70 82, 30 82, 13.5 50 z";
      return /* @__PURE__ */ jsxs("svg", { className: classes.root, viewBox: "0 0 100 100", "aria-hidden": "true", children: [
        /* @__PURE__ */ jsxs("clipPath", { id: slashMaskId, children: [
          /* @__PURE__ */ jsx$1("rect", { "data-name": "mask-left", x: "-22", y: "-25", width: "66", height: "150" }),
          /* @__PURE__ */ jsx$1("rect", { "data-name": "mask-right", x: "56", y: "-25", width: "66", height: "150" })
        ] }),
        /* @__PURE__ */ jsx$1("clipPath", { id: eyeMaskId, clipRule: "evenodd", children: /* @__PURE__ */ jsx$1("path", { d: `M 0 0, L 100 0, 100 100, 0 100, 0 0, ${eyePath}` }) }),
        /* @__PURE__ */ jsx$1(
          "rect",
          {
            "data-name": "bg",
            x: "0",
            y: "0",
            width: "100",
            height: "100",
            clipPath: `url(#${eyeMaskId})`
          }
        ),
        /* @__PURE__ */ jsx$1("path", { "data-name": "eye", d: eyePath, clipPath: `url(#${slashMaskId})` }),
        /* @__PURE__ */ jsx$1(
          "polygon",
          {
            "data-name": "retina",
            points: "35.3,50 42.6,37.3 57.3,37.3 64.7,50 57.4,62.7 42.7,62.7",
            clipPath: `url(#${slashMaskId})`
          }
        ),
        /* @__PURE__ */ jsx$1("rect", { "data-name": "slash", x: "48", y: "12", width: "4", height: "76" })
      ] });
    });
  }
}
__publicField(VisibilityIcon, "propTypes", {
  classes: PropTypes$1.object.isRequired
});
const VisibilityIcon$1 = injectSheet(styles$2i)(VisibilityIcon);
const styles$2h = (theme2) => {
  const hoverColor = ({ variant, color }) => {
    if (variant === "outline") return theme2.white1;
    return theme2[color] || theme2.indigo3;
  };
  const hoverBackgroundColor = ({ variant, color }) => {
    if (variant !== "outline") return "none";
    return theme2[color] || theme2.indigo3;
  };
  const boxShadow = ({ variant }) => {
    const shadow = variant === "float" ? "10px 1px" : "0 0";
    return `0 0 ${shadow} ${theme2.indigoPastel2}`;
  };
  return {
    root: {
      position: "relative",
      color: ({ color }) => theme2[color] || theme2.indigo3,
      appearance: "none",
      borderWidth: ({ variant }) => Number(variant === "outline"),
      borderStyle: "solid",
      borderColor: "currentColor",
      borderRadius: "50%",
      width: ({ size: size2 }) => size2,
      height: ({ size: size2 }) => size2,
      boxSizing: "border-box",
      cursor: "default",
      outline: "none",
      display: "block",
      boxShadow,
      transition: `box-shadow 150ms linear`,
      "&::before": {
        content: '""',
        position: "absolute",
        width: MIN_TARGET_SIZE,
        height: MIN_TARGET_SIZE,
        top: "50%",
        left: "50%",
        transform: "translateY(-50%) translateX(-50%)"
      },
      "&[disabled]": {
        opacity: 0.3
      },
      "&:focus": {
        boxShadow: `0 0 0 ${FOCUS_OUTLINE_WIDTH}px ${theme2.indigoPastel2}`
      },
      "&:not([disabled]):hover": {
        cursor: "pointer",
        color: hoverColor,
        backgroundColor: hoverBackgroundColor,
        borderColor: hoverBackgroundColor
      },
      "& > svg": {
        display: "block",
        width: "100%",
        height: "100%",
        stroke: "currentColor"
      }
    }
  };
};
const Generic = ({
  classes,
  className,
  type: type2,
  onClick,
  label,
  buttonRef,
  disabled,
  children,
  ...props2
}) => {
  const rootProps = {
    ...props2,
    onClick: () => !disabled && onClick(),
    type: type2,
    className: `${classes.root} ${className}`,
    disabled,
    ref: buttonRef
  };
  return /* @__PURE__ */ jsxs("button", { ...rootProps, children: [
    /* @__PURE__ */ jsx$1(Invisible$1, { children: label }),
    children
  ] });
};
Generic.propTypes = {
  classes: PropTypes$1.object.isRequired,
  className: PropTypes$1.string,
  variant: PropTypes$1.string,
  color: PropTypes$1.string,
  size: PropTypes$1.string,
  type: PropTypes$1.string,
  onClick: PropTypes$1.func.isRequired,
  label: PropTypes$1.string.isRequired,
  buttonRef: PropTypes$1.func,
  disabled: PropTypes$1.bool,
  children: PropTypes$1.node.isRequired
};
Generic.defaultProps = {
  className: "",
  type: "button",
  variant: "none",
  color: "indigo3",
  size: "21px",
  disabled: false,
  buttonRef: null
};
const Iconbutton = injectSheet(styles$2h)(Generic);
const Visibility = ({
  classes,
  onClick,
  checked,
  label,
  text,
  checkedText,
  subjectId,
  buttonRef,
  disabled
}) => {
  const id2 = uniqueId$1("vis_");
  const rootProps = {
    className: classes.root
  };
  const buttonProps = {
    onClick,
    label: checked ? checkedText : text,
    role: "switch",
    "aria-checked": checked,
    "aria-controls": subjectId,
    disabled,
    ref: buttonRef,
    id: id2
  };
  return /* @__PURE__ */ jsxs("label", { htmlFor: id2, ...rootProps, children: [
    /* @__PURE__ */ jsx$1(Invisible$1, { children: label }),
    /* @__PURE__ */ jsx$1(Iconbutton, { ...buttonProps, color: "grey3", children: /* @__PURE__ */ jsx$1(VisibilityIcon$1, {}) })
  ] });
};
Visibility.propTypes = {
  classes: PropTypes$1.object.isRequired,
  onClick: PropTypes$1.func.isRequired,
  checked: PropTypes$1.bool.isRequired,
  label: PropTypes$1.string,
  text: PropTypes$1.string,
  checkedText: PropTypes$1.string,
  buttonRef: PropTypes$1.func,
  subjectId: PropTypes$1.string,
  disabled: PropTypes$1.bool
};
Visibility.defaultProps = {
  label: "Toggle visibility",
  text: "show",
  checkedText: "hide",
  subjectId: null,
  disabled: false,
  buttonRef: () => {
  }
};
const Visibility$1 = injectSheet(styles$2j)(Visibility);
class FieldPasswordCompact extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      inputHasFocus: false
    });
    __publicField(this, "id", uniqueId$1("fpc_"));
    __publicField(this, "togglePasswordVisibility", () => {
      this.input.focus();
      this.props.onVisibilityChange();
    });
    __publicField(this, "handleFocus", () => {
      this.setState({
        inputHasFocus: true
      });
    });
    __publicField(this, "handleBlur", () => {
      this.setState({
        inputHasFocus: false
      });
    });
    __publicField(this, "handleChange", (e5) => {
      this.props.onValueChange(e5);
    });
    __publicField(this, "setInputRefs", (el2) => {
      this.input = el2;
      this.props.inputRef(el2);
    });
    __publicField(this, "render", () => {
      const {
        label,
        value,
        passwordIsVisible,
        disabled,
        invalid: invalid2,
        caution,
        valid,
        modified
      } = this.props;
      const { inputHasFocus } = this.state;
      const type2 = passwordIsVisible ? "text" : "password";
      let status;
      if (invalid2) {
        status = STATUS_INVALID;
      } else if (caution) {
        status = STATUS_CAUTION;
      } else if (valid) {
        status = STATUS_VALID;
      } else if (modified) {
        status = STATUS_MODIFIED;
      } else {
        status = null;
      }
      const labelProps = {
        forId: this.id,
        text: label,
        inputHasValue: !!value,
        inputHasFocus,
        status
      };
      const inputProps = {
        type: type2,
        placeholder: label,
        id: this.id,
        handleFocus: this.handleFocus,
        handleBlur: this.handleBlur,
        handleChange: this.handleChange,
        value,
        inputRef: this.setInputRefs,
        status,
        disabled,
        suffix: /* @__PURE__ */ jsx$1(
          Visibility$1,
          {
            onClick: this.togglePasswordVisibility,
            checked: passwordIsVisible,
            subjectId: this.id,
            disabled
          }
        )
      };
      return /* @__PURE__ */ jsx$1(Smartlabel$1, { ...labelProps, children: /* @__PURE__ */ jsx$1(Textinput$1, { ...inputProps }) });
    });
  }
}
__publicField(FieldPasswordCompact, "propTypes", {
  label: PropTypes$1.string.isRequired,
  onValueChange: PropTypes$1.func.isRequired,
  onVisibilityChange: PropTypes$1.func.isRequired,
  passwordIsVisible: PropTypes$1.bool,
  inputRef: PropTypes$1.func,
  value: PropTypes$1.string,
  disabled: PropTypes$1.bool,
  invalid: PropTypes$1.bool,
  caution: PropTypes$1.bool,
  valid: PropTypes$1.bool,
  modified: PropTypes$1.bool
});
__publicField(FieldPasswordCompact, "defaultProps", {
  inputRef: () => {
  },
  passwordIsVisible: false,
  value: "",
  disabled: false,
  invalid: false,
  caution: false,
  valid: false,
  modified: false
});
class FieldSearchCompact extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      inputHasFocus: false
    });
    __publicField(this, "id", uniqueId$1("fsc_"));
    __publicField(this, "handleFocus", () => {
      this.setState({
        inputHasFocus: true
      });
    });
    __publicField(this, "handleBlur", () => {
      this.setState({
        inputHasFocus: false
      });
    });
    __publicField(this, "handleChange", (e5) => {
      this.props.onValueChange(e5);
    });
    __publicField(this, "render", () => {
      const {
        value,
        label,
        inputRef,
        disabled,
        invalid: invalid2,
        caution,
        valid,
        modified,
        maxWidth
      } = this.props;
      const { inputHasFocus } = this.state;
      let status;
      if (invalid2) {
        status = STATUS_INVALID;
      } else if (caution) {
        status = STATUS_CAUTION;
      } else if (valid) {
        status = STATUS_VALID;
      } else if (modified) {
        status = STATUS_MODIFIED;
      } else {
        status = null;
      }
      const labelProps = {
        text: label,
        forId: this.id,
        inputHasFocus,
        inputHasValue: !!value,
        status,
        maxWidth
      };
      const inputProps = {
        id: this.id,
        value,
        type: "search",
        placeholder: label,
        inputRef,
        suffix: /* @__PURE__ */ jsx$1(icons.Loupe, { size: 17 }),
        handleChange: this.handleChange,
        handleFocus: this.handleFocus,
        handleBlur: this.handleBlur,
        status,
        disabled
      };
      return /* @__PURE__ */ jsx$1(Smartlabel$1, { ...labelProps, children: /* @__PURE__ */ jsx$1(Textinput$1, { ...inputProps }) });
    });
  }
}
__publicField(FieldSearchCompact, "propTypes", {
  label: PropTypes$1.string.isRequired,
  onValueChange: PropTypes$1.func.isRequired,
  inputRef: PropTypes$1.func,
  value: PropTypes$1.string,
  disabled: PropTypes$1.bool,
  invalid: PropTypes$1.bool,
  caution: PropTypes$1.bool,
  valid: PropTypes$1.bool,
  modified: PropTypes$1.bool,
  maxWidth: PropTypes$1.bool
});
__publicField(FieldSearchCompact, "defaultProps", {
  inputRef: () => {
  },
  value: "",
  disabled: false,
  invalid: false,
  caution: false,
  valid: false,
  modified: false,
  maxWidth: false
});
const styles$2g = {
  root: {
    display: "flex",
    flexGrow: 1
  }
};
const styles$2f = (theme2) => ({
  root: {
    overflow: "hidden",
    backgroundColor: theme2.indigo3,
    transform: "translateZ(0)",
    borderRadius: 2,
    maxHeight: "inherit",
    boxShadow: `2px 3px 10px 0 rgba(0,0,0,0.1)`
  },
  options: {
    overflow: "auto",
    "-webkit-overflow-scrolling": "touch",
    backgroundColor: "inherit",
    maxHeight: "inherit",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    position: "relative",
    zIndex: 0
  }
});
let SelectMenu$2 = (_g = class extends React__default.PureComponent {
  constructor(props2) {
    super(props2);
    __publicField(this, "buttonData", this.props.buttonElement.getBoundingClientRect());
    __publicField(this, "state", {
      top: this.buttonData.top < VIEWPORT_MARGIN ? VIEWPORT_MARGIN : this.buttonData.top,
      left: this.buttonData.left < VIEWPORT_MARGIN ? VIEWPORT_MARGIN : this.buttonData.left,
      right: window.innerWidth - this.buttonData.left - this.buttonData.width
    });
    __publicField(this, "componentDidUpdate", () => {
      if (this.props.hasValue)
        this.options.querySelector('[data-is-selected="true"]').focus();
    });
    __publicField(this, "componentDidMount", () => {
      const viewportHeight = window.innerHeight - VIEWPORT_MARGIN - VIEWPORT_MARGIN;
      const menuHeight = this.options.scrollHeight;
      const { top: buttonTopFromViewportTop } = this.buttonData;
      const buttonTopFromViewportBottom = viewportHeight - buttonTopFromViewportTop + VIEWPORT_MARGIN;
      if (menuHeight > viewportHeight) {
        this.setState({
          top: VIEWPORT_MARGIN
        });
      } else if (menuHeight > buttonTopFromViewportBottom) {
        this.setState({
          top: viewportHeight - menuHeight + VIEWPORT_MARGIN
        });
      }
    });
    __publicField(this, "render", () => {
      const { classes, children, onCollapse } = this.props;
      const veneerProps = {
        handleCollapse: onCollapse,
        contentPosition: {
          top: this.state.top,
          left: this.state.left,
          right: this.state.right
        },
        invisible: true,
        scrollElement: `[class="${classes.options}"]`,
        returnFocus: true
      };
      const rootProps = {
        className: classes.root
      };
      const optionsProps = {
        className: classes.options,
        ref: this.setOptionsRef
      };
      return /* @__PURE__ */ jsx$1(Veneer$1, { ...veneerProps, children: /* @__PURE__ */ jsx$1("div", { ...rootProps, children: /* @__PURE__ */ jsx$1("div", { ...optionsProps, children }) }) });
    });
    this.setOptionsRef = this.setOptionsRef.bind(this);
  }
  setOptionsRef(el2) {
    this.options = el2;
  }
}, __publicField(_g, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  onCollapse: PropTypes$1.func.isRequired,
  buttonElement: PropTypes$1.object.isRequired,
  hasValue: PropTypes$1.bool.isRequired
}), _g);
const SelectMenu$3 = injectSheet(styles$2f)(SelectMenu$2);
const styles$2e = (theme2) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexGrow: 1,
    minWidth: 200,
    appearance: "none",
    boxSizing: "border-box",
    outline: "none",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme2.grey5,
    backgroundColor: theme2.grey9,
    borderRadius: 5,
    flexShrink: 0,
    cursor: "default",
    height: MIN_TARGET_SIZE + 2,
    paddingLeft: 7,
    paddingRight: 7,
    fontSize: 14,
    fontWeight: 400,
    color: theme2.grey1,
    transition: "border-color 150ms linear 0ms",
    "&[disabled]": {
      opacity: 0.3
    },
    "&:focus": {
      borderColor: theme2.indigo3
    },
    '&[data-has-value="true"]:not(:focus):not([data-is-invalid="true"]):not([data-is-caution="true"]):not([data-is-valid="true"]):not([data-is-modified="true"])': {
      borderColor: theme2.grey2
    },
    '&[data-is-invalid="true"]': {
      borderColor: theme2.warningRed
    },
    '&[data-is-caution="true"]': {
      borderColor: theme2.cautionOrange
    },
    '&[data-is-valid="true"]': {
      borderColor: theme2.validGreen
    },
    '&[data-is-modified="true"]': {
      borderColor: theme2.teal1
    },
    '&[data-has-value="false"]': {
      color: theme2.grey4
    }
  },
  value: {
    flexGrow: 1
  },
  icon: {
    color: theme2.grey3
  }
});
class SelectButton extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleClick", () => {
      if (!this.props.disabled) this.props.onClick();
    });
    __publicField(this, "render", () => {
      const {
        classes,
        id: id2,
        children,
        hasValue,
        buttonRef,
        disabled,
        status,
        onFocus,
        onBlur
      } = this.props;
      const rootProps = {
        className: classes.root,
        id: id2,
        onFocus,
        onBlur,
        onClick: this.handleClick,
        type: "button",
        ref: buttonRef,
        disabled,
        "data-has-value": hasValue,
        "data-is-invalid": status === STATUS_INVALID,
        "data-is-caution": status === STATUS_CAUTION,
        "data-is-modified": status === STATUS_MODIFIED,
        "data-is-valid": status === STATUS_VALID
      };
      return /* @__PURE__ */ jsxs("button", { ...rootProps, children: [
        /* @__PURE__ */ jsx$1("span", { className: classes.value, children }),
        /* @__PURE__ */ jsx$1("span", { className: classes.icon, children: /* @__PURE__ */ jsx$1(icons.ArrowDown, { size: 17 }) })
      ] });
    });
  }
}
__publicField(SelectButton, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  id: PropTypes$1.string,
  children: PropTypes$1.node.isRequired,
  onFocus: PropTypes$1.func.isRequired,
  onBlur: PropTypes$1.func.isRequired,
  onClick: PropTypes$1.func.isRequired,
  hasValue: PropTypes$1.bool.isRequired,
  buttonRef: PropTypes$1.func.isRequired,
  status: PropTypes$1.oneOf([
    STATUS_INVALID,
    STATUS_CAUTION,
    STATUS_VALID,
    STATUS_MODIFIED
  ]),
  disabled: PropTypes$1.bool
});
__publicField(SelectButton, "defaultProps", {
  id: null,
  status: null,
  disabled: false
});
const SelectButton$1 = injectSheet(styles$2e)(SelectButton);
class Select extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      expanded: false
    });
    __publicField(this, "handleToggle", () => {
      this.setState({
        expanded: !this.state.expanded
      });
    });
    __publicField(this, "handleCollapse", () => {
      this.setState({
        expanded: false
      });
    });
    __publicField(this, "handleOptionClick", (e5) => {
      this.props.onChange(e5);
      this.handleCollapse();
    });
    __publicField(this, "getLabel", () => {
      const selectedOption = Children$1.toArray(this.props.children).find(
        (option2) => option2.props.selected === true
      );
      if (!selectedOption) return this.props.placeholder;
      return selectedOption.props.label;
    });
    __publicField(this, "getOptions", () => Children$1.map(
      this.props.children,
      (option2) => cloneElement(option2, {
        onClick: this.handleOptionClick
      })
    ));
    __publicField(this, "render", () => {
      const {
        classes,
        id: id2,
        placeholder,
        status,
        disabled,
        onBlur,
        onFocus,
        selectRef
      } = this.props;
      const label = this.getLabel();
      const rootProps = {
        className: classes.root,
        ref: selectRef
      };
      const buttonProps = {
        id: id2,
        onFocus,
        onBlur,
        onClick: this.handleToggle,
        hasValue: label !== placeholder,
        status,
        disabled,
        buttonRef: (el2) => {
          this.button = el2;
        }
      };
      const selectMenuProps = {
        onCollapse: this.handleCollapse,
        hasValue: label !== placeholder,
        buttonElement: this.button,
        children: this.getOptions()
      };
      return /* @__PURE__ */ jsxs("div", { ...rootProps, children: [
        /* @__PURE__ */ jsx$1(SelectButton$1, { ...buttonProps, children: label }),
        !disabled && this.state.expanded && /* @__PURE__ */ jsx$1(SelectMenu$3, { ...selectMenuProps })
      ] });
    });
  }
}
__publicField(Select, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  id: PropTypes$1.string,
  onFocus: PropTypes$1.func,
  onBlur: PropTypes$1.func,
  onChange: PropTypes$1.func,
  selectRef: PropTypes$1.func,
  placeholder: PropTypes$1.string,
  status: PropTypes$1.oneOf([
    STATUS_INVALID,
    STATUS_CAUTION,
    STATUS_VALID,
    STATUS_MODIFIED
  ]),
  disabled: PropTypes$1.bool
});
__publicField(Select, "defaultProps", {
  id: null,
  onFocus: () => {
  },
  onBlur: () => {
  },
  onChange: () => {
  },
  selectRef: () => {
  },
  placeholder: "",
  status: null,
  disabled: false
});
const Select$1 = injectSheet(styles$2g)(Select);
class FieldSelectCompact extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      inputHasFocus: false
    });
    __publicField(this, "id", uniqueId$1("fslctc_"));
    __publicField(this, "handleFocus", () => {
      this.setState({
        inputHasFocus: true
      });
    });
    __publicField(this, "handleBlur", () => {
      this.setState({
        inputHasFocus: false
      });
    });
    __publicField(this, "handleChange", (e5) => {
      this.props.onValueChange(e5);
    });
    __publicField(this, "render", () => {
      const {
        children,
        label,
        selectRef,
        valid,
        modified,
        invalid: invalid2,
        caution,
        disabled
      } = this.props;
      const { inputHasFocus } = this.state;
      const inputHasValue = !!Children$1.toArray(this.props.children).find(
        (option2) => option2.props.selected === true
      );
      let status;
      if (invalid2) {
        status = STATUS_INVALID;
      } else if (caution) {
        status = STATUS_CAUTION;
      } else if (valid) {
        status = STATUS_VALID;
      } else if (modified) {
        status = STATUS_MODIFIED;
      } else {
        status = null;
      }
      const labelProps = {
        forId: this.id,
        text: label,
        inputHasValue,
        inputHasFocus,
        status
      };
      const selectProps = {
        placeholder: label,
        id: this.id,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        status,
        selectRef,
        disabled
      };
      return /* @__PURE__ */ jsx$1(Smartlabel$1, { ...labelProps, children: /* @__PURE__ */ jsx$1(Select$1, { ...selectProps, children }) });
    });
  }
}
__publicField(FieldSelectCompact, "propTypes", {
  children: PropTypes$1.node.isRequired,
  label: PropTypes$1.string.isRequired,
  onValueChange: PropTypes$1.func.isRequired,
  selectRef: PropTypes$1.func,
  invalid: PropTypes$1.bool,
  caution: PropTypes$1.bool,
  valid: PropTypes$1.bool,
  modified: PropTypes$1.bool,
  disabled: PropTypes$1.bool
});
__publicField(FieldSelectCompact, "defaultProps", {
  selectRef: () => {
  },
  invalid: false,
  caution: false,
  valid: false,
  modified: false,
  disabled: false
});
class FieldText extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      inputHasFocus: false
    });
    __publicField(this, "id", uniqueId$1("ftc_"));
    __publicField(this, "handleFocus", (e5) => {
      this.props.onFocus(e5);
      this.setState({
        inputHasFocus: true
      });
    });
    __publicField(this, "handleBlur", (e5) => {
      this.props.onBlur(e5);
      this.setState({
        inputHasFocus: false
      });
    });
    __publicField(this, "handleChange", (e5) => {
      this.props.onValueChange(e5);
    });
  }
  render() {
    const {
      label,
      placeholder,
      value,
      inputRef,
      disabled,
      invalid: invalid2,
      caution,
      valid,
      required: required2,
      hideLabel,
      errorMessage,
      hideErrorMessage,
      dataCy
    } = this.props;
    const { inputHasFocus } = this.state;
    let status;
    if (invalid2) {
      status = STATUS_INVALID;
    } else if (caution) {
      status = STATUS_CAUTION;
    } else if (valid) {
      status = STATUS_VALID;
    } else {
      status = null;
    }
    const labelProps = {
      forId: this.id,
      text: label,
      inputHasValue: !!value,
      inputHasFocus,
      status,
      hideLabel,
      required: required2
    };
    const inputProps = {
      type: "text",
      placeholder,
      id: this.id,
      handleFocus: this.handleFocus,
      handleBlur: this.handleBlur,
      handleChange: this.handleChange,
      value,
      inputRef,
      status,
      disabled,
      required: required2,
      errorMessage,
      hideErrorMessage,
      dataCy
    };
    return /* @__PURE__ */ jsx$1(Dumblabel$1, { ...labelProps, children: /* @__PURE__ */ jsx$1(Textinput$1, { ...inputProps }) });
  }
}
__publicField(FieldText, "propTypes", {
  label: PropTypes$1.string.isRequired,
  inputRef: PropTypes$1.func,
  value: PropTypes$1.string,
  placeholder: PropTypes$1.string,
  disabled: PropTypes$1.bool,
  invalid: PropTypes$1.bool,
  caution: PropTypes$1.bool,
  valid: PropTypes$1.bool,
  hideLabel: PropTypes$1.bool,
  required: PropTypes$1.bool,
  errorMessage: PropTypes$1.string,
  onValueChange: PropTypes$1.func.isRequired,
  onFocus: PropTypes$1.func,
  onBlur: PropTypes$1.func,
  hideErrorMessage: PropTypes$1.bool,
  dataCy: PropTypes$1.string
});
__publicField(FieldText, "defaultProps", {
  inputRef: () => {
  },
  value: "",
  placeholder: "",
  disabled: false,
  invalid: false,
  caution: false,
  valid: false,
  required: false,
  hideLabel: false,
  errorMessage: "",
  onFocus: () => {
  },
  onBlur: () => {
  },
  hideErrorMessage: false,
  dataCy: "atomic-fieldtext"
});
class FieldTextarea extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      inputHasFocus: false,
      rows: 3,
      minRows: 3,
      maxRows: 100
    });
    __publicField(this, "id", uniqueId$1("fta_"));
    __publicField(this, "handleFocus", (e5) => {
      this.props.onFocus(e5);
      this.setState({
        inputHasFocus: true
      });
    });
    __publicField(this, "handleBlur", (e5) => {
      this.props.onBlur(e5);
      this.setState({
        inputHasFocus: false
      });
    });
    __publicField(this, "handleChange", (e5) => {
      const { minRows, maxRows } = this.state;
      const textareaLineHeight = TEXTAREA_LINE_HEIGHT;
      const previousRows = e5.target.rows;
      e5.target.rows = minRows;
      const currentRows = e5.target.scrollHeight / textareaLineHeight;
      if (currentRows === previousRows) {
        e5.target.rows = currentRows;
      }
      if (currentRows >= maxRows) {
        e5.target.rows = maxRows;
        e5.target.scrollTop = e5.target.scrollHeight;
      }
      this.setState({
        rows: currentRows < maxRows ? currentRows : maxRows
      });
      this.props.onValueChange(e5);
    });
    __publicField(this, "render", () => {
      const {
        label,
        placeholder,
        value,
        inputRef,
        disabled,
        invalid: invalid2,
        caution,
        valid,
        required: required2,
        hideLabel,
        noResize,
        errorMessage,
        hideErrorMessage
      } = this.props;
      const { inputHasFocus, rows } = this.state;
      let status;
      if (invalid2) {
        status = STATUS_INVALID;
      } else if (caution) {
        status = STATUS_CAUTION;
      } else if (valid) {
        status = STATUS_VALID;
      } else {
        status = null;
      }
      const labelProps = {
        forId: this.id,
        text: label,
        inputHasValue: !!value,
        inputHasFocus,
        status,
        hideLabel,
        required: required2
      };
      const textAreaProps = {
        type: "text",
        placeholder,
        id: this.id,
        handleFocus: this.handleFocus,
        handleBlur: this.handleBlur,
        handleChange: this.handleChange,
        value,
        inputRef,
        status,
        disabled,
        rows,
        required: required2,
        noResize,
        errorMessage,
        hideErrorMessage
      };
      return /* @__PURE__ */ jsx$1(Dumblabel$1, { ...labelProps, children: /* @__PURE__ */ jsx$1(Textarea, { ...textAreaProps }) });
    });
  }
}
__publicField(FieldTextarea, "propTypes", {
  label: PropTypes$1.string.isRequired,
  inputRef: PropTypes$1.func,
  value: PropTypes$1.string,
  placeholder: PropTypes$1.string,
  disabled: PropTypes$1.bool,
  invalid: PropTypes$1.bool,
  caution: PropTypes$1.bool,
  valid: PropTypes$1.bool,
  hideLabel: PropTypes$1.bool,
  required: PropTypes$1.bool,
  errorMessage: PropTypes$1.string,
  noResize: PropTypes$1.bool,
  onValueChange: PropTypes$1.func.isRequired,
  onFocus: PropTypes$1.func,
  onBlur: PropTypes$1.func,
  hideErrorMessage: PropTypes$1.bool
});
__publicField(FieldTextarea, "defaultProps", {
  inputRef: () => {
  },
  value: "",
  placeholder: "",
  disabled: false,
  invalid: false,
  caution: false,
  valid: false,
  required: false,
  hideLabel: false,
  errorMessage: "",
  noResize: false,
  onFocus: () => {
  },
  onBlur: () => {
  },
  hideErrorMessage: false
});
const addAttrs = {
  strokeWidth: "1",
  strokeLinecap: "butt",
  vectorEffect: "non-scaling-stroke"
};
const IconbuttonAdd = (props2) => /* @__PURE__ */ jsx$1(Iconbutton, { ...props2, variant: "outline", children: /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 100 100", "aria-hidden": "true", children: [
  /* @__PURE__ */ jsx$1("line", { ...addAttrs, x1: "30", x2: "70", y1: "50", y2: "50" }),
  /* @__PURE__ */ jsx$1("line", { ...addAttrs, x1: "50", x2: "50", y1: "30", y2: "70" })
] }) });
IconbuttonAdd.propTypes = {
  onClick: PropTypes$1.func.isRequired,
  label: PropTypes$1.string,
  buttonRef: PropTypes$1.func,
  disabled: PropTypes$1.bool
};
IconbuttonAdd.defaultProps = {
  label: "Add",
  disabled: false,
  buttonRef: null
};
const closeAttrs = {
  x1: "30",
  x2: "70",
  strokeWidth: "1",
  strokeLinecap: "butt",
  vectorEffect: "non-scaling-stroke"
};
const IconbuttonClose = (props2) => /* @__PURE__ */ jsx$1(Iconbutton, { ...props2, color: "grey3", variant: "outline", children: /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 100 100", "aria-hidden": "true", children: [
  /* @__PURE__ */ jsx$1("line", { ...closeAttrs, y1: "30", y2: "70" }),
  /* @__PURE__ */ jsx$1("line", { ...closeAttrs, y1: "70", y2: "30" })
] }) });
IconbuttonClose.propTypes = {
  onClick: PropTypes$1.func.isRequired,
  label: PropTypes$1.string,
  buttonRef: PropTypes$1.func,
  disabled: PropTypes$1.bool
};
IconbuttonClose.defaultProps = {
  label: "Close",
  disabled: false,
  buttonRef: null
};
const ISOLATE_MAX_WIDTH = 440;
const ISOLATE_X_PADDING = 14;
const styles$2d = (theme2) => {
  const backgroundColor = theme2.grey8;
  return {
    "@global": {
      ":root": {
        backgroundColor,
        position: "fixed",
        zIndex: HTMLROOT_FIXED_ZINDEX,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        overflow: "hidden"
      },
      body: {
        backgroundColor: "inherit",
        margin: 0,
        height: "100%",
        width: "100%"
      },
      "#root": {
        backgroundColor: "inherit",
        width: "inherit",
        height: "inherit"
      }
    },
    root: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor,
      overflow: "auto",
      "-webkit-font-smoothing": "antialiased",
      "-moz-osx-font-smoothing": "grayscale",
      "-webkit-text-size-adjust": "100%",
      "-webkit-overflow-scrolling": "touch",
      paddingLeft: ISOLATE_X_PADDING,
      paddingRight: ISOLATE_X_PADDING
    }
  };
};
class Isolate extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => /* @__PURE__ */ jsx$1("div", { className: this.props.classes.root, children: /* @__PURE__ */ jsx$1("main", { className: this.props.classes.main, children: this.props.children }) }));
  }
}
__publicField(Isolate, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired
});
const isolate = injectSheet(styles$2d)(Isolate);
const styles$2c = {
  root: {
    marginBottom: 42
  },
  [`@media (min-width: ${ISOLATE_MAX_WIDTH + ISOLATE_X_PADDING * 2}px)`]: {
    root: {
      marginLeft: `calc(50% - ${ISOLATE_MAX_WIDTH / 2}px)`
    }
  }
};
class IsolateHeader extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => /* @__PURE__ */ jsx$1("header", { className: this.props.classes.root, children: this.props.children }));
  }
}
__publicField(IsolateHeader, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired
});
const isolate_header = injectSheet(styles$2c)(IsolateHeader);
const styles$2b = {
  root: {
    maxWidth: ISOLATE_MAX_WIDTH,
    marginLeft: "auto",
    marginRight: "auto"
  }
};
class IsolateMain extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => /* @__PURE__ */ jsx$1("main", { className: this.props.classes.root, children: this.props.children }));
  }
}
__publicField(IsolateMain, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired
});
const isolate_main = injectSheet(styles$2b)(IsolateMain);
const animationName = "loaderTraceLogo";
const animationDuration = 1500;
const styles$2a = (theme2) => ({
  root: {
    width: 29,
    height: 29,
    position: "relative",
    color: theme2.indigo3,
    flexShrink: 0,
    "& > em": {
      position: "absolute",
      top: 0,
      width: 7,
      backgroundColor: "currentColor",
      animationName,
      animationDirection: "alternate",
      animationIterationCount: "infinite",
      animationTimingFunction: "ease-in-out",
      transformOrigin: "50% 0",
      transform: "scaleY(1)",
      borderRadius: 1
    },
    "& > em:first-child": {
      left: 0,
      height: 14,
      animationDuration: `${animationDuration}ms`
    },
    "& > em:nth-child(2)": {
      left: 11,
      height: 25,
      animationDelay: `${animationDuration * 0.1}ms`,
      animationDuration: `${animationDuration * 0.9}ms`
    },
    "& > em:last-child": {
      right: 0,
      height: 18,
      animationDelay: `${animationDuration * 0.3}ms`,
      animationDuration: `${animationDuration * 0.7}ms`
    }
  },
  rootLight: {
    color: theme2.grey7
  },
  [`@keyframes ${animationName}`]: {
    from: { transform: "scaleY(1)" },
    to: { transform: "scaleY(0.05)" }
  }
});
class LoaderTraceLogo extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, light } = this.props;
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: classNames(classes.root, { [classes.rootLight]: light }),
          role: "none",
          "data-cy": "atomic-loader-trace-logo",
          children: [
            /* @__PURE__ */ jsx$1("em", {}),
            /* @__PURE__ */ jsx$1("em", {}),
            /* @__PURE__ */ jsx$1("em", {})
          ]
        }
      );
    });
  }
}
__publicField(LoaderTraceLogo, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  light: PropTypes$1.bool
});
__publicField(LoaderTraceLogo, "defaultProps", {
  light: false
});
const LoaderTraceLogo$1 = injectSheet(styles$2a)(LoaderTraceLogo);
const styles$29 = (theme2) => {
  const ANIMATION_NAME = "slide";
  const HEIGHT = 10;
  const BACKGROUND_WIDTH = 72;
  const BACKGROUND_FROM_POSITION = "0 50%";
  const BACKGROUND_TO_POSITION = `${BACKGROUND_WIDTH}px 50%`;
  return {
    [`@keyframes ${ANIMATION_NAME}`]: {
      from: {
        backgroundPosition: BACKGROUND_FROM_POSITION
      },
      to: {
        backgroundPosition: BACKGROUND_TO_POSITION
      }
    },
    root: {
      animationName: ANIMATION_NAME,
      animationDuration: `450ms`,
      animationIterationCount: `infinite`,
      animationTimingFunction: `linear`,
      boxSizing: "border-box",
      height: HEIGHT,
      minWidth: 140,
      border: `1px solid ${theme2.grey5}`,
      borderRadius: 5,
      backgroundRepeat: "repeat",
      backgroundPosition: BACKGROUND_FROM_POSITION,
      backgroundSize: `${BACKGROUND_WIDTH}px ${HEIGHT}px`
    }
  };
};
const bg = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'%20?%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20fill-rule='evenodd'%20stroke-linejoin='round'%20stroke-miterlimit='1.41421'%20clip-rule='evenodd'%20viewBox='0%200%20720%20100'%20%3e%3cpath%20fill='%23e5e3eb'%20d='M360%200%20H%20720%20L%20620%20100%20H%20260z'%20/%3e%3c/svg%3e";
class LoaderUnsure extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => /* @__PURE__ */ jsx$1(
      "div",
      {
        role: "none",
        className: this.props.classes.root,
        style: { backgroundImage: `url(${bg})` }
      }
    ));
  }
}
__publicField(LoaderUnsure, "propTypes", {
  classes: PropTypes$1.object.isRequired
});
const loader_unsure = injectSheet(styles$29)(LoaderUnsure);
const styles$28 = {
  root: {
    display: "flex",
    color: "currentColor"
  },
  logoMark: {
    flexBasis: "23.4741784%",
    height: "100%"
  },
  logoText: {
    flexBasis: "76.5258216%",
    height: "100%"
  }
};
const styles$27 = (theme2) => ({
  root: {
    display: "block",
    fill: theme2.indigo1
  },
  fill: {
    "& > rect": {
      fill: "currentColor"
    }
  },
  bands: {
    "& > circle:nth-child(1)": {
      fill: theme2.teal2
    },
    "& > circle:nth-child(2)": {
      fill: theme2.teal1
    },
    "& > circle:nth-child(3)": {
      fill: theme2.indigo4
    },
    "& > circle:nth-child(4)": {
      fill: theme2.indigo3
    },
    "& > circle:nth-child(5)": {
      fill: theme2.indigo2
    },
    "& > circle:nth-child(6)": {
      fill: theme2.indigo1
    }
  }
});
class LogoMark extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "id", uniqueId$1("lm_"));
    __publicField(this, "render", () => {
      const { classes, axis, size: size2, fill } = this.props;
      const style2 = {
        width: axis === "x" ? size2 || "100%" : "auto",
        height: axis === "y" ? size2 || "100%" : "auto"
      };
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 100 84",
          "aria-hidden": "true",
          className: classes.root,
          style: style2,
          children: [
            /* @__PURE__ */ jsxs("clipPath", { id: this.id, children: [
              /* @__PURE__ */ jsx$1("rect", { x: "0", y: "0", width: "25.7", height: "46.3", rx: "3.9", ry: "3.9" }),
              /* @__PURE__ */ jsx$1("rect", { x: "37.2", y: "0", width: "25.7", height: "84", rx: "3.9", ry: "3.9" }),
              /* @__PURE__ */ jsx$1("rect", { x: "74.3", y: "0", width: "25.7", height: "65.3", rx: "3.9", ry: "3.9" })
            ] }),
            fill && /* @__PURE__ */ jsx$1("g", { clipPath: `url(#${this.id})`, className: classes.fill, children: /* @__PURE__ */ jsx$1("rect", { x: "0", y: "0", width: "100", height: "84" }) }),
            !fill && /* @__PURE__ */ jsxs("g", { clipPath: `url(#${this.id})`, className: classes.bands, children: [
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "245.65" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "228.5" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "211.3" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "194.1" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "176.95" }),
              /* @__PURE__ */ jsx$1("circle", { cx: "-46.1", cy: "198.8", r: "159.75" })
            ] })
          ]
        }
      );
    });
  }
}
__publicField(LogoMark, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  axis: PropTypes$1.oneOf(["x", "y"]),
  size: PropTypes$1.number,
  fill: PropTypes$1.bool
});
__publicField(LogoMark, "defaultProps", {
  axis: "x",
  size: null,
  fill: false
});
const LogoMark$1 = injectSheet(styles$27)(LogoMark);
const styles$26 = (theme2) => ({
  root: {
    display: "block",
    fill: theme2.indigo1
  },
  type: {
    "&[data-fill=true]": {
      fill: "currentColor"
    }
  }
});
class LogoText extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, axis, size: size2, fill } = this.props;
      const style2 = {
        width: axis === "x" ? size2 || "100%" : "auto",
        height: axis === "y" ? size2 || "100%" : "auto"
      };
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 326 84",
          "aria-hidden": "true",
          className: classes.root,
          style: style2,
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              "data-fill": fill,
              className: classes.type,
              d: "M58.633 13.068H34.6V0h61.83v13.068H72.282v69.764H58.633V13.068zM96.205 24.5h12.83v10.384c2.216-6.649 8.749-10.966 15.401-10.966 1.635 0 3.264.118 5.016.466v13.183c-2.218-.701-4.082-1.049-6.417-1.049-7.348 0-14 6.183-14 17.848v28.467h-12.83V24.5zM163.638 35c-10.382 0-17.38 8.166-17.38 18.667 0 10.5 6.998 18.665 17.38 18.665 10.384 0 17.386-8.165 17.386-18.665 0-10.501-7.002-18.667-17.386-18.667m-2.33-11.666c8.397 0 15.4 4.316 18.663 8.982v-7.817h12.832v58.333h-12.832v-7.816c-3.263 4.666-10.266 8.983-18.663 8.983-15.985 0-28.118-13.649-28.118-30.332 0-16.684 12.133-30.333 28.118-30.333M232.65 84c-17.501 0-30.8-13.067-30.8-30.332 0-17.268 13.299-30.335 30.8-30.335 12.014 0 22.164 6.417 27.182 16.099l-11.202 6.069c-2.797-5.953-8.515-10.268-15.98-10.268-10.382 0-17.734 8.05-17.734 18.435 0 10.382 7.352 18.43 17.734 18.43 7.465 0 13.183-4.315 15.98-10.266l11.202 6.067C254.814 77.583 244.664 84 232.65 84m46.905-36.867h32.435c-1.401-8.399-8.17-12.949-15.634-12.949-7.468 0-15.048 4.318-16.801 12.949m17.269-23.799c15.283 0 28.115 10.15 28.115 28.933 0 1.285 0 2.332-.118 4.201h-45.849c.583 9.566 8.285 15.865 17.968 15.865 8.165 0 13.649-3.733 16.68-8.867l9.8 6.999C318.17 78.75 309.072 84 296.824 84c-17.736 0-30.45-12.6-30.45-30.332 0-17.15 12.714-30.334 30.45-30.334"
            }
          )
        }
      );
    });
  }
}
__publicField(LogoText, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  axis: PropTypes$1.oneOf(["x", "y"]),
  size: PropTypes$1.number,
  fill: PropTypes$1.bool
});
__publicField(LogoText, "defaultProps", {
  axis: "x",
  size: null,
  fill: false
});
const LogoText$1 = injectSheet(styles$26)(LogoText);
class Logo extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2, fill, axis } = this.props;
      const style2 = {
        width: axis === "x" ? size2 : size2 * 5.071428571,
        height: axis === "x" ? size2 / 5.071428571 : size2
      };
      return /* @__PURE__ */ jsxs("div", { className: classes.root, style: style2, children: [
        /* @__PURE__ */ jsx$1("div", { className: classes.logoMark, children: /* @__PURE__ */ jsx$1(LogoMark$1, { fill, axis: "y" }) }),
        /* @__PURE__ */ jsx$1("div", { className: classes.logoText, children: /* @__PURE__ */ jsx$1(LogoText$1, { fill, axis: "y" }) })
      ] });
    });
  }
}
__publicField(Logo, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number,
  axis: PropTypes$1.oneOf(["x", "y"]),
  fill: PropTypes$1.bool
});
__publicField(Logo, "defaultProps", {
  size: 106,
  axis: "x",
  fill: false
});
const logo = injectSheet(styles$28)(Logo);
const styles$25 = {
  root: {
    display: "block",
    fill: theme.indigo1
  },
  type: {
    "&[data-fill-white=true]": {
      fill: theme.white1
    }
  }
};
class LogoTriangle extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, axis, size: size2, fillWhite } = this.props;
      const style2 = {
        width: axis === "x" ? size2 || "100%" : "auto",
        height: axis === "y" ? size2 || "100%" : "auto"
      };
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          strokeLinejoin: "round",
          strokeMiterlimit: "1.41421",
          clipRule: "evenodd",
          viewBox: "0 0 353 306",
          "aria-hidden": "true",
          className: classes.root,
          style: style2,
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              "data-fill-white": fillWhite,
              className: classes.type,
              d: "M291.128 305.998h-46.51l-.176-.418v.42H104.174v-.002H61.872l98.959-232.7h31.338l98.959 232.7zm-63.232-39.583l-5.047-11.947-17.152-39.892-29.358-68.809-29.366 68.809-16.822 39.892-5.047 11.947h102.792zm16.546-226.83H104.174V0h140.268v39.585z"
            }
          )
        }
      );
    });
  }
}
__publicField(LogoTriangle, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  axis: PropTypes$1.oneOf(["x", "y"]),
  size: PropTypes$1.number,
  fillWhite: PropTypes$1.bool
});
__publicField(LogoTriangle, "defaultProps", {
  axis: "x",
  size: null,
  fillWhite: false
});
const logo_triangle = injectSheet(styles$25)(LogoTriangle);
const styles$24 = (theme2) => ({
  "@global": {
    ":root": {
      fontFamily: 'EuclidCircularB, "Helvetica Neue", Helvetica, Arial, sans-serif',
      backgroundColor: theme2.grey9,
      position: "fixed",
      zIndex: HTMLROOT_FIXED_ZINDEX,
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      overflow: "hidden",
      "-webkit-font-smoothing": "antialiased",
      "-moz-osx-font-smoothing": "grayscale",
      "-webkit-text-size-adjust": "100%"
    },
    body: {
      backgroundColor: "inherit",
      margin: 0,
      height: "100%",
      width: "100%"
    },
    "#root": {
      backgroundColor: "inherit",
      width: "inherit",
      height: "inherit"
    }
  }
});
class Kanban extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => /* @__PURE__ */ jsx$1(React__default.Fragment, { children: this.props.children }));
  }
}
__publicField(Kanban, "propTypes", {
  children: PropTypes$1.node.isRequired
});
const kanban = injectSheet(styles$24)(Kanban);
const styles$23 = (theme2) => ({
  root: {
    boxSizing: "border-box",
    width: "100%",
    backgroundColor: theme2.grey9,
    position: "fixed",
    zIndex: HEADER_FIXED_ZINDEX,
    top: 0,
    left: 0,
    right: 0,
    paddingTop: "env(safe-area-inset-top)",
    paddingLeft: "env(safe-area-inset-left)",
    paddingRight: "env(safe-area-inset-right)"
  }
});
class KanbanHeader extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => /* @__PURE__ */ jsx$1("div", { className: this.props.classes.root, children: this.props.children }));
  }
}
__publicField(KanbanHeader, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired
});
const kanban_header = injectSheet(styles$23)(KanbanHeader);
const kanbanMainBgSvg = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'%20?%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20fill-rule='evenodd'%20stroke-miterlimit='10'%20clip-rule='evenodd'%20viewBox='0%200%201082%20700'%20%3e%3cpath%20fill='%236bedd8'%20d='M231.34%20538.011h7.676l3.839-6.648-3.839-6.649h-7.676l-3.838%206.649%203.838%206.648zm8.096.726h-8.516l-4.257-7.374%204.257-7.375h8.516l4.258%207.375-4.258%207.374z'%20/%3e%3cpath%20fill='%236bedd8'%20d='M234.248%20532.975h1.861l.932-1.613-.932-1.612h-1.861l-.932%201.612.932%201.613zm2.281.727h-2.701l-1.35-2.34%201.35-2.338h2.7l1.351%202.338-1.35%202.34zM247.644%20547.192h7.676l3.839-6.648-3.839-6.649h-7.676l-3.839%206.649%203.839%206.648zm8.096.726h-8.516l-4.257-7.374%204.257-7.375h8.516l4.258%207.375-4.258%207.374z'%20/%3e%3cpath%20fill='%236bedd8'%20d='M250.551%20542.156h1.862l.931-1.613-.931-1.612h-1.862l-.931%201.612.931%201.613zm2.282.726h-2.702l-1.35-2.339%201.35-2.338h2.702l1.35%202.338-1.35%202.339zM871.023%20257.692h6.068l3.035-5.256-3.035-5.256h-6.068l-3.035%205.256%203.035%205.256zm6.4.574h-6.732l-3.365-5.83%203.365-5.83h6.732l3.366%205.83-3.366%205.83z'%20/%3e%3cpath%20fill='%236bedd8'%20d='M873.321%20253.711h1.472l.736-1.275-.736-1.275h-1.472l-.736%201.275.736%201.275zm1.804.574h-2.136l-1.067-1.849%201.067-1.849h2.136l1.067%201.849-1.067%201.849zM227.276%20281.977h14.354v-14.354h-14.354v14.354zm-.726.727h15.807v-15.807H226.55v15.807z'%20/%3e%3cpath%20fill='%236bedd8'%20d='M232.548%20276.706h3.811v-3.811h-3.811v3.811zm-.727.726h5.264v-5.264h-5.264v5.264zM928.329%20148.058h16.208l-8.104-14.037-8.104%2014.037zm17.467.726h-18.725l9.362-16.216%209.363%2016.216z'%20/%3e%3cpath%20fill='%236bedd8'%20d='M934.694%20144.583h3.477l-1.738-3.011-1.739%203.011zm4.736.726h-5.994l2.997-5.19%202.997%205.19zM244.56%20126.18h11.914l-5.957-10.318-5.957%2010.318zm13.173.726h-14.431l7.215-12.497%207.216%2012.497z'%20/%3e%3cpath%20fill='%236bedd8'%20d='M249.361%20123.56h2.313l-1.156-2.004-1.157%202.004zm3.571.726h-4.829l2.415-4.183%202.414%204.183zM226.711%20126.18h11.913l-5.957-10.318-5.956%2010.318zm13.172.726h-14.43l7.214-12.497%207.216%2012.497z'%20/%3e%3cpath%20fill='%236bedd8'%20d='M231.511%20123.56h2.313l-1.157-2.004-1.156%202.004zm3.571.726h-4.829l2.414-4.183%202.415%204.183zM720.274%20491.472c-6.365%200-11.543%205.178-11.543%2011.542%200%206.363%205.178%2011.541%2011.543%2011.541%206.364%200%2011.542-5.178%2011.542-11.541%200-6.364-5.178-11.542-11.542-11.542m0%2023.81c-6.765%200-12.269-5.504-12.269-12.268%200-6.765%205.504-12.268%2012.269-12.268%206.764%200%2012.268%205.503%2012.268%2012.268%200%206.764-5.504%2012.268-12.268%2012.268'%20/%3e%3cpath%20fill='%236bedd8'%20d='M720.274%20500.922c-1.154%200-2.093.938-2.093%202.092%200%201.153.939%202.092%202.093%202.092%201.153%200%202.092-.939%202.092-2.092%200-1.154-.939-2.092-2.092-2.092m0%204.91c-1.554%200-2.819-1.264-2.819-2.818%200-1.555%201.265-2.818%202.819-2.818s2.818%201.263%202.818%202.818c0%201.554-1.264%202.818-2.818%202.818M748.28%20514.676c-3.801%200-6.893%203.093-6.893%206.894s3.092%206.893%206.893%206.893c3.801%200%206.894-3.092%206.894-6.893%200-3.801-3.093-6.894-6.894-6.894m0%2014.513c-4.202%200-7.62-3.418-7.62-7.619%200-4.202%203.418-7.62%207.62-7.62s7.62%203.418%207.62%207.62c0%204.201-3.418%207.619-7.62%207.619'%20/%3e%3cpath%20fill='%236bedd8'%20d='M748.28%20520.436c-.625%200-1.134.509-1.134%201.134%200%20.625.509%201.133%201.134%201.133.625%200%201.134-.508%201.134-1.133s-.509-1.134-1.134-1.134m0%202.994c-1.025%200-1.86-.834-1.86-1.86%200-1.026.835-1.86%201.86-1.86%201.026%200%201.86.834%201.86%201.86%200%201.026-.834%201.86-1.86%201.86'%20/%3e%3cpath%20fill='%235246f7'%20d='M581.219%20530.966c3.64%200%207.274.07%2010.914.215%2031.058%201.245%2061.983%208.08%2091.89%2014.69%207.874%201.739%2016.015%203.539%2024.028%205.207%2035.52%207.393%2077.147%2013.889%20116.594%205.992%2019.784-3.961%2038.479-11.858%2054.066-22.838%2016.819-11.848%2029.526-27.078%2036.745-44.043%2010.073-23.672%209.827-50.118%209.588-75.692-.182-19.582-.371-39.83%203.989-58.988%206.062-26.634%2020.702-50.45%2034.86-73.48%205.538-9.009%2011.264-18.324%2016.394-27.674%2030.883-56.284%2020.895-91.826%2012.192-108.002-7.086-13.171-22.004-30.464-52.834-38.054-21.713-5.345-47.056-4.364-69.528%202.691-30.252%209.498-58.101%2026.662-85.032%2043.261-35.884%2022.116-72.989%2044.984-116.035%2049.767-24.579%202.733-44.621-.179-67.022-9.729-14.285-6.09-29.379-9.115-43.975-12.039-9.158-1.835-18.627-3.733-27.861-6.372-3.753-1.072-7.203-2.188-10.544-3.408-7.707-2.815-15.546-5.989-23.127-9.059-16.906-6.846-34.387-13.924-51.868-17.647-52.929-11.274-108.415%202.03-157.368%2013.766-46.471%2011.142-94.524%2022.664-137.586%2045.421-23.554%2012.447-39.842%2025.449-51.259%2040.916-14.167%2019.19-19.584%2042.43-14.49%2062.165%206.867%2026.607%2029.009%2042.811%2052.451%2059.967%2013.337%209.76%2027.129%2019.853%2037.814%2032.032%2013.549%2015.445%2022.218%2034.561%2030.603%2053.049%207.381%2016.274%2015.013%2033.102%2025.954%2047.409%2017.823%2023.305%2043.816%2039.732%2077.259%2048.825%2028.199%207.665%2061.304%209.828%2095.734%206.257%2023.784-2.468%2047.789-6.979%2071.003-11.341%2034.756-6.53%2070.593-13.264%20106.451-13.264m204.755%2030.433c-27.121.001-53.997-4.598-78.07-9.61-8.017-1.669-16.162-3.468-24.038-5.209-29.876-6.603-60.769-13.431-91.762-14.673-39.408-1.581-78.958%205.851-117.202%2013.036-23.228%204.365-47.249%208.879-71.063%2011.35-34.517%203.583-67.713%201.411-95.999-6.278-33.6-9.136-59.723-25.65-77.645-49.086-10.991-14.372-18.641-31.238-26.039-47.549-8.362-18.439-17.01-37.506-30.487-52.869-10.632-12.12-24.39-22.189-37.697-31.926-23.55-17.234-45.794-33.513-52.725-60.371-5.148-19.946.313-43.414%2014.608-62.778%2011.485-15.558%2027.851-28.627%2051.505-41.128%2043.142-22.799%2091.241-34.332%20137.756-45.484%2049.028-11.754%20104.597-25.077%20157.689-13.77%2017.543%203.736%2035.053%2010.827%2051.988%2017.683%207.576%203.068%2015.41%206.24%2023.104%209.05%203.325%201.215%206.758%202.326%2010.495%203.393%209.206%202.631%2018.66%204.526%2027.804%206.357%2014.632%202.932%2029.762%205.964%2044.118%2012.084%2022.277%209.498%2042.214%2012.391%2066.654%209.675%2042.886-4.765%2079.921-27.59%20115.735-49.663%2026.969-16.623%2054.857-33.81%2085.197-43.336%2022.594-7.094%2048.079-8.08%2069.919-2.703%2024.608%206.058%2043.039%2019.342%2053.3%2038.414%208.315%2015.457%2010.847%2033.78%207.524%2054.461-2.721%2016.929-9.539%2035.684-19.719%2054.235-5.139%209.366-10.869%2018.689-16.412%2027.705-14.127%2022.981-28.735%2046.744-34.77%2073.261-4.342%2019.074-4.153%2039.28-3.971%2058.82.239%2025.649.486%2052.171-9.646%2075.983-7.273%2017.09-20.065%2032.427-36.996%2044.353-15.669%2011.038-34.46%2018.976-54.34%2022.956-12.806%202.564-25.84%203.617-38.815%203.617'%20/%3e%3cpath%20fill='%235246f7'%20d='M958.443%2061.007l-.008-.726c.467-.005.932-.007%201.398-.007l.039.507-.025.219c-.477%200-.94.002-1.404.007zm4.342.027c-.483-.011-.965-.019-1.447-.024l.007-.727c.487.005.972.013%201.456.025l-.016.726zm-7.234.035l-.025-.726c.486-.016.971-.029%201.455-.039l.015.727c-.481.01-.963.022-1.445.038zm10.124.065c-.481-.023-.963-.042-1.444-.058l.024-.727c.486.016.97.037%201.454.06l-.034.725zm-13.016.056l-.037-.725c.484-.024.968-.047%201.451-.069l.031.726c-.481.021-.963.044-1.445.068zm15.903.114c-.48-.034-.962-.066-1.443-.094l.042-.725c.485.028.969.06%201.452.094l-.051.725zm-18.792.066l-.053-.725c.485-.035.968-.068%201.451-.097l.046.724c-.481.03-.962.063-1.444.098zm21.672.175c-.479-.046-.959-.09-1.439-.129l.061-.725c.483.041.966.085%201.448.13l-.07.724zm-24.556.059l-.067-.723c.484-.044.967-.086%201.45-.125l.058.723c-.48.04-.96.081-1.441.125zm27.43.257c-.477-.059-.956-.114-1.436-.168l.08-.722c.482.053.963.11%201.445.169l-.089.721zm-30.313.03l-.077-.722c.482-.052.964-.102%201.446-.15l.072.722c-.481.048-.96.099-1.441.15zm-2.875.341l-.092-.721c.482-.061.963-.12%201.444-.177l.086.721c-.48.057-.959.116-1.438.177zm36.051.022c-.475-.071-.953-.14-1.431-.206l.1-.72c.48.066.96.135%201.44.209l-.109.717zm-38.922.366l-.105-.72c.481-.069.962-.136%201.442-.2l.097.719c-.479.064-.957.131-1.434.201zm41.775.108c-.474-.086-.949-.168-1.424-.248l.119-.716c.478.079.957.164%201.433.249l-.128.715zm-44.639.328l-.116-.717c.48-.077.96-.151%201.438-.225l.109.719c-.477.072-.953.147-1.431.223zm47.475.229c-.471-.1-.943-.196-1.416-.29l.14-.712c.476.094.953.192%201.427.291l-.151.711zm-50.333.252l-.127-.715c.477-.084.956-.167%201.434-.247l.121.717c-.477.08-.953.161-1.428.245zm53.151.39c-.468-.115-.937-.225-1.407-.332l.161-.708c.474.107.947.219%201.418.335l-.172.705zm-56.002.137l-.138-.714c.477-.091.953-.18%201.431-.269l.131.714c-.475.088-.949.177-1.424.269zm-2.845.568l-.147-.71c.475-.099.951-.196%201.426-.291l.142.712c-.473.095-.946.191-1.421.289zm61.642.025c-.464-.128-.929-.254-1.395-.375l.183-.703c.471.122.939.249%201.407.379l-.195.699zm-64.478.586l-.157-.71c.474-.105.947-.209%201.422-.31l.153.709c-.473.102-.946.206-1.418.311zm67.251.235c-.459-.145-.92-.285-1.382-.422l.206-.697c.466.139.931.281%201.394.427l-.218.692zm-70.078.415l-.167-.707c.471-.112.944-.223%201.417-.331l.163.707c-.472.109-.943.218-1.413.331zm72.82.499c-.453-.16-.908-.316-1.366-.467l.229-.69c.462.153.921.31%201.379.472l-.242.685zm-75.64.188l-.178-.704c.471-.119.942-.235%201.415-.35l.171.704c-.469.116-.939.232-1.408.35zm-2.812.725l-.185-.703%201.409-.368.181.704-1.405.367zm81.163.097c-.449-.176-.899-.349-1.352-.517l.254-.681c.456.17.91.344%201.363.521l-.265.677zm-83.965.664l-.195-.699c.467-.131.936-.26%201.405-.386l.19.7c-.468.127-.933.255-1.4.385zm86.638.441c-.443-.192-.886-.38-1.332-.565l.278-.672c.449.187.898.377%201.344.57l-.29.667zm-89.433.354l-.204-.696c.467-.137.934-.271%201.401-.404l.199.699c-.466.132-.931.266-1.396.401zm-2.785.831l-.212-.695c.465-.141.93-.281%201.396-.42l.208.695c-.465.139-.929.279-1.392.42zm94.849.016c-.434-.208-.872-.413-1.31-.612l.302-.661c.442.202.883.408%201.322.618l-.314.655zm-97.624.848l-.22-.693c.462-.147.926-.293%201.39-.437l.216.694c-.463.144-.925.288-1.386.436zm100.211.451c-.427-.224-.857-.445-1.288-.662l.327-.648c.435.219.868.44%201.299.668l-.338.642zm-102.978.444l-.227-.689c.461-.153.923-.304%201.385-.453l.224.69c-.462.15-.923.301-1.382.452zm-2.757.926l-.235-.686c.459-.158.919-.315%201.381-.469l.231.688c-.461.155-.919.31-1.377.467zm108.27.027c-.418-.242-.839-.479-1.261-.71l.35-.637c.427.234.852.474%201.274.717l-.363.63zm-111.018.931l-.242-.685%201.375-.483.24.685-1.373.483zm113.5.562c-.409-.257-.821-.509-1.233-.759l.375-.621c.416.25.832.506%201.245.766l-.387.614zm-116.234.424l-.245-.684%201.364-.496.247.683-1.366.497zm-2.722%201.007l-.254-.681%201.363-.506.253.681-1.362.506zm121.379.16c-.399-.274-.801-.543-1.204-.808l.399-.607c.406.267.812.539%201.215.814l-.41.601zm-124.095.864l-.259-.679%201.36-.515.257.68-1.358.514zm126.456.82c-.39-.289-.78-.573-1.173-.853l.422-.591c.396.282.791.57%201.184.861l-.433.583zm-129.168.222l-.261-.678%201.356-.523.261.678-1.356.523zm-2.704%201.057l-.267-.676%201.354-.531.264.677-1.351.53zm134.157.491c-.377-.302-.755-.601-1.135-.895l.445-.575c.384.297.766.599%201.146.905l-.456.565zm-136.857.58l-.269-.674%201.35-.539.268.676-1.349.537zm-2.694%201.084l-.273-.671%201.348-.546.271.673-1.346.544zm141.766.194c-.216-.189-.434-.378-.654-.564l-.444-.376.468-.557.447.38c.222.189.442.379.662.57l-.479.547zm-144.453.907l-.277-.671%201.345-.552.275.672-1.343.551zm146.588%201.036c-.349-.331-.701-.658-1.056-.982l.488-.538c.36.328.716.658%201.067.992l-.499.528zm-149.271.076l-.28-.67%201.343-.558.278.672-1.341.556zm-2.678%201.124l-.283-.669%201.341-.564.28.67-1.338.563zm154.001.823c-.335-.344-.674-.684-1.016-1.023l.511-.516c.345.341.688.685%201.025%201.033l-.52.506zm-156.673.313l-.286-.668%201.338-.57.284.668-1.336.57zm-2.669%201.146l-.288-.666%201.335-.575.286.668-1.333.573zm161.312.647c-.321-.356-.646-.711-.975-1.064l.531-.494c.332.355.66.712.984%201.073l-.54.485zm-163.977.509l-.29-.665%201.333-.581.289.667-1.332.579zm-2.659%201.166l-.293-.664%201.331-.586.292.666-1.33.584zm168.524.51c-.307-.371-.618-.737-.934-1.102l.551-.475c.318.369.631.74.941%201.112l-.558.465zm-171.181.663l-.294-.663%201.328-.588.293.664-1.327.587zm-2.654%201.181l-.297-.663%201.328-.591.295.664-1.326.59zm175.635.414c-.293-.383-.589-.761-.89-1.138l.568-.453c.303.38.602.763.898%201.148l-.576.443zm-178.286.775l-.298-.663%201.326-.595.296.663-1.324.595zm-2.647%201.196l-.299-.661%201.324-.599.299.662-1.324.598zm182.647.355c-.278-.394-.56-.784-.846-1.172l.584-.431c.29.392.574.787.855%201.183l-.593.42zm-185.292.847l-.301-.661%201.323-.602.3.662-1.322.601zm-2.643%201.207l-.302-.661%201.322-.604.302.661-1.322.604zm189.561.336c-.264-.404-.531-.805-.802-1.204l.6-.408c.274.403.544.808.811%201.215l-.609.397zm-192.2.874l-.304-.659%201.321-.607.303.66-1.32.606zm-2.64%201.215l-.304-.66%201.32-.608.303.66-1.319.608zm196.378.362c-.25-.413-.502-.824-.759-1.233l.616-.385c.258.412.514.826.764%201.243l-.621.375zm-199.016.856l-.305-.66%201.32-.609.304.66-1.319.609zm-2.637%201.219l-.305-.659%201.319-.61.305.659-1.319.61zm203.101.431c-.234-.423-.472-.843-.713-1.26l.629-.363c.243.422.483.844.719%201.27l-.635.353zm-205.736.792l-.307-.658%201.319-.611.306.658-1.318.611zm-2.637%201.223l-.306-.658%201.319-.612.305.659-1.318.611zm209.735.54c-.22-.431-.443-.858-.669-1.285l.641-.34c.227.429.453.861.675%201.294l-.647.331zm-212.371.685l-.305-.659%201.317-.612.307.658-1.319.613zm-2.635%201.222l-.305-.659%201.318-.612.305.659-1.318.612zm216.278.694c-.205-.437-.413-.874-.625-1.307l.652-.319c.214.438.424.877.631%201.318l-.658.308zm-218.914.529l-.307-.658%201.319-.612.305.659-1.317.611zm-341.707.051c-.424-.003-.851-.003-1.273-.003h-.178v-.727h.177c.426%200%20.853.002%201.278.004l-.004.726zm-4.351.02l-.009-.726c.485-.008.97-.013%201.454-.017l.006.726c-.484.004-.967.01-1.451.017zm7.251.019c-.483-.01-.967-.018-1.45-.024l.009-.726c.485.006.97.013%201.455.024l-.014.726zm-10.15.041l-.02-.726c.485-.014.97-.025%201.455-.036l.015.727c-.483.01-.966.021-1.45.035zm13.05.038c-.483-.017-.966-.031-1.449-.044l.019-.727c.486.014.97.028%201.455.045l-.025.726zm-15.947.06l-.03-.726c.485-.02.969-.037%201.455-.054l.024.727c-.483.016-.966.034-1.449.053zm18.843.061c-.482-.023-.965-.045-1.447-.065l.03-.726c.485.021.969.043%201.454.066l-.037.725zm-21.74.073l-.037-.725%201.451-.072.034.726-1.448.071zm24.638.094c-.483-.031-.966-.061-1.448-.088l.041-.725c.484.028.969.057%201.453.089l-.046.724zm-27.532.075l-.047-.725c.484-.031.968-.061%201.451-.089l.043.725c-.483.028-.965.059-1.447.089zm30.424.135c-.482-.039-.965-.074-1.446-.11l.053-.725c.483.035.967.073%201.451.112l-.058.723zm-33.316.07l-.055-.724c.484-.038.967-.073%201.45-.108l.05.725c-.481.034-.963.07-1.445.107zm36.204.187c-.481-.047-.962-.092-1.443-.135l.063-.723c.483.042.967.087%201.451.134l-.071.724zm-39.095.049l-.064-.723c.484-.043.967-.083%201.45-.123l.06.723c-.482.04-.964.08-1.446.123zm360.791.248l-.305-.659%201.318-.611.305.66-1.318.61zm-318.811.006c-.48-.056-.961-.108-1.441-.158l.075-.722c.482.05.965.102%201.448.157l-.082.723zm-44.868.013l-.069-.724%201.447-.137.066.723-1.444.138zm-2.883.297l-.078-.722%201.445-.153.075.722-1.442.153zm50.631.039c-.48-.063-.959-.123-1.439-.181l.088-.72c.481.058.963.118%201.444.18l-.093.721zm-53.513.288l-.085-.722%201.443-.167.083.722-1.441.167zm56.384.11c-.477-.071-.956-.14-1.434-.206l.099-.719c.48.066.961.135%201.442.207l-.107.718zm535.796.14c-.19-.444-.384-.886-.581-1.325l.662-.298c.2.444.395.89.587%201.338l-.668.285zm-595.059.105l-.092-.721c.481-.061.962-.122%201.443-.181l.088.721c-.48.059-.959.119-1.439.181zm62.13.202c-.478-.079-.954-.155-1.432-.229l.112-.718c.479.074.959.151%201.438.231l-.118.716zm307.553.019l-.305-.66%201.319-.609.304.66-1.318.609zm-372.557.16l-.099-.719%201.44-.195.097.72-1.438.194zm67.86.317c-.45-.082-.901-.163-1.352-.241l-.074-.013.123-.716.075.012c.453.08.906.161%201.359.243l-.131.715zm-70.733.091l-.103-.72%201.437-.206.103.719-1.437.207zm-2.868.432l-.11-.717%201.437-.22.108.719-1.435.218zm76.448.023c-.473-.095-.948-.187-1.423-.279l.138-.714c.476.092.952.185%201.428.28l-.143.713zm299.209.191l-.303-.66%201.32-.607.304.66-1.321.607zm-378.52.241l-.118-.716%201.435-.231.113.718-1.43.229zm82.147.159c-.471-.102-.943-.202-1.416-.301l.148-.711c.476.098.949.199%201.423.303l-.155.709zm-85.011.32l-.122-.717%201.434-.242.119.717-1.431.242zm87.838.318c-.471-.11-.942-.219-1.413-.325l.16-.708c.473.107.946.215%201.417.325l-.164.708zm522.662.104c-.177-.451-.356-.899-.539-1.345l.671-.276c.186.45.367.902.544%201.356l-.676.265zm-231.757.07l-.303-.661%201.321-.604.303.659-1.321.606zm-381.6.007l-.128-.714%201.432-.253.125.715-1.429.252zm93.512.499c-.469-.118-.937-.233-1.407-.345l.17-.707c.471.115.943.23%201.413.346l-.176.706zm-96.367.02l-.133-.714%201.429-.263.131.716-1.427.261zm-2.853.538l-.136-.713%201.428-.272.134.714-1.426.271zm384.664.144l-.3-.661%201.32-.603.302.661-1.322.603zm-282.635.017c-.467-.124-.935-.245-1.403-.365l.18-.704c.47.12.939.243%201.408.366l-.185.703zm-104.877.396l-.142-.712%201.427-.281.139.712-1.424.281zm107.677.362c-.466-.129-.932-.258-1.398-.384l.188-.7c.47.125.938.254%201.405.385l-.195.699zm-110.522.212l-.146-.712%201.425-.289.143.711-1.422.29zm387.711.217l-.301-.661%201.323-.601.301.661-1.323.601zm238.06.233c-.163-.456-.328-.91-.497-1.361l.681-.255c.171.455.338.913.5%201.373l-.684.243zm-512.458.133c-.464-.136-.929-.271-1.394-.401l.198-.7c.467.132.933.267%201.4.403l-.204.698zm-116.157.006l-.149-.71%201.423-.297.148.71-1.422.297zm-2.84.605l-.153-.709%201.422-.305.151.71-1.42.304zm121.78.216c-.463-.14-.927-.28-1.39-.417l.207-.696c.464.137.928.278%201.393.418l-.21.695zm268.966.004l-.299-.662%201.324-.598.3.663-1.325.597zm-393.583.398l-.156-.71%201.42-.31.155.709-1.419.311zm127.391.455l-1.387-.433.214-.694%201.39.435-.217.692zm-130.227.178l-.159-.709%201.419-.318.159.709-1.419.318zm393.766.16l-.297-.663%201.326-.595.298.663-1.327.595zm-396.598.483l-.163-.708%201.419-.323.16.708-1.416.323zm135.822.067l-1.381-.448.223-.691%201.384.448-.226.691zm505.066.042c-.148-.461-.299-.92-.454-1.377l.689-.233c.155.462.308.924.457%201.387l-.692.223zm-643.718.546l-.164-.708%201.415-.329.164.708-1.415.329zm396.773.046l-.295-.664%201.328-.591.295.663-1.328.592zm-255.363.278l-1.378-.46.23-.69%201.38.462-.232.688zm-144.239.341l-.167-.707%201.415-.334.166.707-1.414.334zm396.943.557l-.294-.664%201.33-.588.294.664-1.33.588zm-249.955.041l-1.374-.471.235-.688%201.377.473-.238.686zm-149.815.075l-.169-.707%201.415-.338.167.707-1.413.338zm-2.825.683l-.171-.706%201.413-.343.17.707-1.412.342zm155.382.202l-1.371-.482.24-.686%201.374.483-.243.685zm497.662.004c-.134-.464-.272-.928-.412-1.391l.695-.21c.141.466.28.933.415%201.4l-.698.201zm-253.112.161l-.29-.665%201.33-.583.292.666-1.332.582zm-402.757.322l-.172-.705%201.412-.346.172.705-1.412.346zm160.942.492l-1.367-.491.245-.685%201.369.493-.247.683zm-163.764.204l-.175-.705%201.412-.349.174.705-1.411.349zm402.911.141l-.287-.667%201.333-.578.289.667-1.335.578zm-405.734.56l-.175-.705%201.41-.352.176.706-1.411.351zm169.318.09l-1.365-.499.25-.683%201.366.502-.251.68zm233.746.498l-.284-.668%201.334-.572.287.667-1.337.573zm-405.887.118l-.176-.706%201.411-.353.176.706-1.411.353zm665.1.212c-.12-.469-.244-.936-.371-1.402l.7-.191c.128.468.253.94.375%201.411l-.704.182zm-490.236.185l-1.361-.508.253-.681%201.364.509-.256.68zm-177.684.311l-.177-.706%201.41-.353.177.703-1.41.356zm406.032.313l-.282-.67%201.337-.566.284.668-1.339.568zm-408.851.396l-.178-.704%201.41-.355.177.705-1.409.354zm183.223.006l-1.359-.514.256-.68%201.361.514-.258.68zm-186.039.708l-.18-.704%201.41-.358.177.704-1.407.358zm408.987.016l-.279-.669%201.338-.562.283.67-1.342.561zm-220.232.313l-1.357-.52.258-.678%201.359.519-.26.679zm-191.563.392l-.182-.704%201.402-.361.18.704-1.4.361zm677.048.179c-.108-.473-.218-.943-.332-1.412l.706-.172c.114.474.226.947.334%201.422l-.708.162zm-267.939.23l-.277-.671%201.343-.555.278.672-1.344.554zm-214.834.242l-1.356-.523.261-.678%201.357.525-.262.676zm-197.074.079l-.185-.703%201.401-.366.184.702-1.4.367zm-2.797.741l-.187-.702%201.4-.371.186.701-1.399.372zm412.016.042l-.274-.672%201.344-.55.275.673-1.345.549zm-209.436.191l-1.354-.528.263-.676%201.355.527-.264.677zm-205.375.515l-.189-.7%201.399-.377.187.703-1.397.374zm412.114.383l-.269-.675%201.347-.542.272.674-1.35.543zm-204.031.159l-1.354-.529.264-.677%201.355.529-.265.677zm-210.877.217l-.191-.7%201.398-.381.19.701-1.397.38zm688.836.036c-.094-.474-.192-.948-.293-1.42l.712-.151c.1.475.199.952.293%201.43l-.712.141zm-276.629.662l-.267-.675%201.35-.535.268.675-1.351.535zm-414.999.069l-.194-.7%201.397-.385.193.701-1.396.384zm216.376.075l-1.354-.53.265-.677%201.354.53-.265.677zm-219.168.696l-.194-.699%201.396-.388.193.701-1.395.386zm415.084.219l-.263-.676%201.352-.528.265.677-1.354.527zm-193.21.144l-1.353-.53.265-.677%201.353.53-.265.677zm-224.663.416l-.197-.699%201.396-.39.196.699-1.395.39zm415.16.483l-.257-.68%201.354-.518.262.678-1.359.52zm282.574.088c-.08-.477-.165-.953-.252-1.428l.714-.132c.088.479.172.958.255%201.438l-.717.122zm-470.364.072l-1.355-.531.266-.676%201.352.53-.263.677zm-230.16.142l-.198-.7%201.396-.392.196.699-1.394.393zm415.231.723l-.252-.681c.453-.169.906-.338%201.358-.51l.256.68c-.453.171-.907.342-1.362.511zm-418.019.065l-.198-.699%201.394-.396.198.7-1.394.395zm235.656.125l-1.354-.527.262-.677%201.354.527-.262.677zm-238.444.668l-.199-.698%201.395-.397.198.698-1.394.397zm418.081.149l-.249-.683%201.363-.499.25.68-1.364.502zm-176.927.231l-1.355-.524.262-.677%201.355.523-.262.678zm-243.943.415l-.199-.698%201.394-.398.199.698-1.394.398zm709.338.274c-.067-.478-.139-.956-.214-1.434l.718-.112c.074.481.146.962.216%201.443l-.72.103zm-291.201.068l-.245-.684%201.366-.491.247.683-1.368.492zm-171.48.285l-1.358-.52.26-.678%201.356.519-.258.679zm-249.444.172l-.2-.698%201.395-.401.199.698-1.394.401zm418.184.513l-.24-.685c.457-.16.914-.321%201.369-.481l.243.684c-.457.162-.914.322-1.372.482zm-420.973.286l-.2-.698%201.394-.4.2.698-1.394.4zm254.95.06l-1.359-.514.259-.68%201.357.514-.257.68zm163.276.604l-.235-.687%201.372-.472.238.686-1.375.473zm-421.013.137l-.201-.698%201.395-.4.2.698-1.394.4zm260.458.279l-1.361-.508.255-.681%201.359.507-.253.682zm457.616.471c-.055-.48-.114-.959-.176-1.439l.721-.092c.061.482.121.965.177%201.448l-.722.083zm-299.817.044l-.23-.69%201.376-.461.232.688-1.378.463zm-421.046.008l-.202-.698%201.396-.401.2.698-1.394.401zm265.973.482l-1.364-.502.252-.681%201.362.5-.25.683zm-268.762.319l-.201-.698%201.395-.4.201.698-1.395.4zm421.073.101l-.224-.691%201.378-.451.229.689-1.383.453zm-149.577.57l-1.367-.493.248-.682%201.365.491-.246.684zm-274.288.13l-.2-.698%201.396-.4.2.698-1.396.4zm421.095.187l-.221-.692%201.383-.44.223.691-1.385.441zm-423.886.612l-.198-.698%201.394-.399.2.697-1.396.4zm279.818.041l-1.37-.483.242-.685%201.368.483-.24.685zm141.292.214l-.215-.694%201.388-.43.215.694-1.388.43zm308.424.176c-.044-.481-.091-.962-.139-1.441l.722-.075c.05.483.097.966.14%201.451l-.723.065zm-732.326.365l-.199-.698%201.396-.398.198.698-1.395.398zm285.357.196l-1.374-.473.237-.686%201.373.472-.236.687zm135.759.107l-.208-.697%201.391-.417.21.695-1.393.419zm-423.91.491l-.199-.7%201.397-.396.199.7-1.397.396zm421.119.329l-.201-.698%201.393-.406.205.696-1.397.408zm-130.213.001c-.46-.154-.919-.307-1.379-.462l.232-.688c.459.155.917.308%201.375.46l-.228.69zm-293.702.461l-.197-.7%201.398-.394.197.699-1.398.395zm421.115.333l-.196-.699%201.398-.394.198.698-1.4.395zm-124.65.109l-1.382-.447.225-.691%201.38.447-.223.691zm-299.263.344l-.196-.7%201.398-.392.197.699-1.399.393zm740.939.154c-.031-.483-.066-.964-.103-1.446l.723-.056c.039.485.074.97.105%201.455l-.725.047zm-319.832.164l-.19-.7%201.402-.382.193.7-1.405.382zm-119.071.214l-1.388-.434.219-.693%201.384.433-.215.694zm-304.836.248l-.194-.7%201.399-.389.194.699-1.399.39zm421.094.284l-.183-.702%201.405-.369.186.702-1.408.369zm-113.475.315c-.465-.139-.929-.279-1.393-.42l.211-.695c.463.141.925.281%201.389.418l-.207.697zm-310.421.176l-.194-.7%201.401-.386.194.699-1.401.387zm421.075.228l-.176-.705c.47-.117.939-.234%201.408-.354l.18.703c-.471.12-.941.24-1.412.356zm-107.862.409c-.467-.133-.933-.267-1.398-.403l.204-.697c.465.135.929.269%201.393.402l-.199.698zm-316.016.133l-.191-.701%201.401-.384.192.701-1.402.384zm421.05.151l-.17-.707%201.412-.341.172.705-1.414.343zm-102.232.497c-.469-.126-.936-.255-1.403-.385l.195-.7c.465.129.931.258%201.398.385l-.19.7zm430.678.076c-.019-.483-.041-.965-.067-1.447l.725-.039c.025.486.049.971.068%201.457l-.726.029zm-752.304.038l-.188-.701%201.401-.381.191.701-1.404.381zm421.023.053l-.162-.709%201.415-.328.166.708-1.419.329zm-96.583.578c-.471-.121-.94-.244-1.409-.368l.186-.702c.467.124.935.245%201.404.366l-.181.704zm93.742.058l-.156-.71%201.419-.314.159.709-1.422.315zm-420.99.067l-.189-.702%201.405-.377.188.702-1.404.377zm418.142.539l-.147-.712%201.421-.299.151.711-1.425.3zm-88.07.04c-.472-.115-.943-.23-1.414-.347l.176-.705c.469.117.938.233%201.409.346l-.171.706zm-332.885.165l-.186-.702%201.407-.371.186.701-1.407.372zm418.102.371l-.142-.712%201.426-.284.143.712-1.427.284zm-82.384.13c-.474-.108-.946-.216-1.418-.328l.165-.706c.472.11.941.218%201.414.325l-.161.709zm-338.533.237l-.183-.704%201.407-.367.184.703-1.408.368zm418.055.179l-.132-.716c.476-.087.952-.176%201.427-.267l.136.714c-.476.091-.954.18-1.431.269zm-76.675.203c-.476-.099-.951-.201-1.425-.305l.156-.709c.471.103.944.204%201.417.304l-.148.71zm419.441.238c-.008-.483-.018-.966-.032-1.449l.727-.019c.013.486.024.972.032%201.457l-.727.011zm-345.632.071l-.124-.716c.477-.082.953-.167%201.43-.252l.128.715c-.479.085-.956.17-1.434.253zm-418.006.037l-.18-.704%201.408-.362.182.703-1.41.363zm347.052.229c-.476-.091-.953-.186-1.428-.281l.143-.712c.474.096.948.189%201.423.28l-.138.713zm68.082.215l-.115-.718c.478-.076.955-.155%201.432-.235l.12.717c-.479.079-.958.159-1.437.236zm-417.955.272l-.177-.704%201.409-.356.179.703-1.411.357zm352.739.041l-.074-.014c-.451-.079-.905-.161-1.359-.243l.13-.715c.453.083.905.164%201.358.244l.009.37-.064.358zm62.338.133l-.107-.717c.478-.072.957-.145%201.435-.22l.112.718c-.48.075-.96.148-1.44.219zm-59.464.342c-.479-.075-.958-.153-1.437-.231l.118-.717c.478.079.955.155%201.431.231l-.112.717zm56.581.071l-.098-.72c.479-.065.958-.132%201.437-.201l.104.719c-.483.069-.963.136-1.443.202zm-415.018.119l-.175-.705%201.411-.351.176.704-1.412.352zm361.318.237c-.48-.067-.961-.136-1.441-.207l.107-.719c.477.071.956.14%201.434.207l-.1.719zm50.813.02l-.091-.72%201.441-.184.093.72-1.443.184zm-2.893.341l-.08-.722c.48-.053.96-.109%201.441-.166l.085.721c-.482.058-.964.114-1.446.167zm-45.033.014c-.482-.058-.964-.118-1.446-.181l.095-.721c.48.063.958.124%201.438.182l-.087.72zm-367.035.083l-.171-.706%201.412-.346.173.706-1.414.346zm409.171.206l-.071-.722c.481-.048.962-.096%201.444-.146l.075.722c-.483.05-.966.098-1.448.146zm-39.243.04c-.483-.051-.965-.103-1.448-.157l.082-.722c.48.054.961.106%201.441.157l-.075.722zm36.343.226l-.062-.723c.482-.042.964-.084%201.445-.128l.067.723c-.484.045-.967.087-1.45.128zm-33.444.052c-.483-.042-.966-.087-1.449-.132l.068-.723c.482.045.963.09%201.445.132l-.064.723zm400.023.155l-.727-.006c.003-.348.005-.697.005-1.046l-.001-.402.726-.004.001.406c0%20.351-.001.702-.004%201.052zm-775.68.001l-.17-.706%201.415-.339.17.706-1.415.339zm406.198.02l-.053-.725c.483-.035.966-.071%201.448-.109l.056.725c-.483.037-.967.074-1.451.109zm-27.639.056c-.484-.035-.968-.072-1.452-.11l.058-.724c.481.038.964.074%201.446.109l-.052.725zm24.732.131l-.042-.725c.482-.028.965-.057%201.448-.089l.047.725c-.484.032-.969.061-1.453.089zm-21.827.053c-.484-.027-.969-.056-1.453-.087l.045-.724c.483.03.966.058%201.449.086l-.041.725zm18.919.094l-.032-.726c.484-.022.966-.044%201.449-.068l.037.725c-.485.024-.969.048-1.454.069zm-16.009.043c-.485-.019-.97-.04-1.455-.062l.034-.726c.484.022.967.044%201.449.062l-.028.726zm13.099.062l-.021-.726c.483-.014.966-.03%201.45-.048l.026.727c-.485.017-.971.033-1.455.047zm-10.189.029c-.485-.012-.971-.025-1.456-.04l.023-.726c.483.015.966.028%201.45.04l-.017.726zm7.277.033l-.009-.727c.483-.006.966-.015%201.449-.025l.016.726c-.486.01-.971.019-1.456.026zm-4.367.014c-.485-.004-.97-.01-1.454-.018l.01-.726c.483.008.967.014%201.45.018l-.006.726zm1.587.006h-.131v-.726h.131c.44%200%20.88-.002%201.32-.005l.005.727c-.442.003-.884.004-1.325.004zm-394.617.127l-.164-.707%201.416-.332.166.706-1.418.333zm-2.839.654l-.161-.708%201.418-.325.163.707-1.42.326zm-2.842.638l-.158-.709%201.42-.316.159.709-1.421.316zm-2.847.623l-.155-.71%201.423-.309.155.709-1.423.31zm786.982.33l-.726-.023c.015-.483.028-.966.039-1.449l.726.015c-.011.486-.024.972-.039%201.457zm-789.833.276l-.15-.711%201.425-.301.15.711-1.425.301zm-2.853.589l-.146-.712%201.426-.291.146.711-1.426.292zm-2.859.57l-.14-.712%201.428-.283.141.712-1.429.283zm-2.863.552l-.135-.714%201.429-.273.137.714-1.431.273zm-2.868.532l-.128-.715%201.43-.263.133.714-1.435.264zm801.145.393l-.725-.041c.028-.483.053-.965.075-1.447l.725.032c-.022.486-.047.971-.075%201.456zm-804.016.118l-.124-.716%201.433-.251.128.715-1.437.252zm-2.873.489l-.12-.717%201.436-.242.122.717-1.438.242zm-2.88.467l-.113-.718%201.438-.23.116.717-1.441.231zm-2.881.443l-.107-.719%201.438-.218.111.718-1.442.219zm-2.886.419l-.101-.719%201.441-.207.103.72-1.443.206zm-2.89.393l-.096-.721%201.443-.192.098.719-1.445.194zm-2.894.367l-.088-.721%201.444-.18.091.721-1.447.18zm821.12.212l-.724-.058c.039-.481.075-.963.108-1.445l.725.05c-.034.485-.07.969-.109%201.453zm-824.017.127l-.08-.722c.481-.054.963-.109%201.444-.165l.085.72c-.483.058-.966.113-1.449.167zm-2.901.311l-.074-.722%201.447-.152.078.722-1.451.152zm-2.901.283l-.068-.723%201.449-.138.07.723-1.451.138zm-2.906.251l-.06-.723%201.45-.122.062.724-1.452.121zm-2.908.221l-.05-.725c.484-.033.966-.069%201.449-.105l.056.725c-.484.036-.97.071-1.455.105zm-2.906.189l-.044-.725%201.45-.09.048.725-1.454.09zm-2.907.155l-.036-.725%201.451-.073.038.725-1.453.073zm-2.892.164l-.053-.725c.488-.034.974-.066%201.457-.093l.041.725c-.48.027-.962.058-1.445.093zm-2.885.26l-.075-.722c.486-.052.97-.099%201.452-.143l.065.724c-.479.043-.959.09-1.442.141zm-2.872.346l-.098-.719c.485-.066.966-.128%201.446-.186l.088.721c-.477.058-.955.12-1.436.184zm-2.865.43l-.118-.716c.483-.08.963-.155%201.441-.227l.109.719c-.475.071-.953.146-1.432.224zm852.69.164l-.722-.075c.05-.48.097-.962.142-1.442l.723.068c-.045.483-.093.966-.143%201.449zm-855.544.341l-.135-.714c.48-.091.958-.179%201.435-.262l.125.714c-.473.084-.948.171-1.425.262zm-2.84.575l-.153-.711c.477-.102.954-.2%201.427-.297l.145.712c-.471.095-.944.194-1.419.296zm-2.826.638l-.169-.706c.475-.114.948-.223%201.42-.329l.161.707c-.47.107-.94.216-1.412.328zm-2.814.7l-.183-.702c.473-.123.944-.242%201.413-.36l.174.705c-.466.117-.934.235-1.404.357zm863.685.641l-.72-.093c.062-.479.122-.958.177-1.437l.721.083c-.056.483-.115.966-.178%201.447zm-866.485.115l-.196-.699c.47-.131.938-.26%201.404-.387l.191.701c-.466.126-.931.254-1.399.385zm-2.785.81l-.208-.695c.466-.141.931-.278%201.396-.414l.203.698c-.463.134-.926.271-1.391.411zm-2.768.86l-.222-.692c.465-.148.927-.294%201.389-.438l.216.694c-.461.143-.921.288-1.383.436zm-2.755.908l-.235-.688c.461-.157.922-.311%201.383-.462l.226.689c-.457.151-.915.304-1.374.461zm874.384.194l-.717-.111c.074-.477.144-.955.211-1.432l.719.1c-.067.482-.139.963-.213%201.443zm-877.125.758l-.244-.684c.458-.164.916-.325%201.374-.485l.238.687c-.456.158-.911.319-1.368.482zm-2.724.996l-.255-.68c.456-.171.911-.339%201.366-.506l.249.682c-.453.166-.907.334-1.36.504zm-2.709%201.04l-.265-.676c.452-.178.906-.354%201.358-.527l.259.678c-.451.173-.901.348-1.352.525zm882.08.081l-.714-.128c.085-.475.166-.952.246-1.428l.716.119c-.079.479-.163.959-.248%201.437zm-884.774.995l-.275-.673c.451-.184.9-.366%201.35-.545l.269.674c-.448.179-.896.36-1.344.544zm-2.677%201.116l-.285-.668c.448-.191.895-.379%201.342-.565l.279.671c-.445.184-.891.372-1.336.562zm886.907.75l-.712-.144c.095-.472.187-.947.278-1.422l.713.136c-.091.477-.184.954-.279%201.43zm-889.572.405l-.293-.664c.444-.198.889-.392%201.334-.585l.288.667c-.442.192-.885.386-1.329.582zm-2.645%201.189l-.302-.662c.442-.201.884-.402%201.326-.601l.298.663c-.441.198-.881.398-1.322.6zm-2.626%201.223l-.311-.657c.437-.207.875-.413%201.313-.616l.306.658c-.436.204-.872.408-1.308.615zm894.243.03l-.71-.156c.105-.472.206-.944.306-1.416l.711.15c-.1.474-.203.949-.307%201.422zm-896.848%201.224l-.321-.651c.435-.214.871-.426%201.306-.635l.316.654c-.435.21-.868.419-1.301.632zm-2.593%201.289l-.328-.649c.433-.218.866-.435%201.299-.651l.324.651c-.432.214-.864.43-1.295.649zm898.786.321l-.707-.17c.113-.469.225-.939.333-1.409l.708.164c-.11.472-.221.944-.334%201.415zm-901.365%201.002l-.336-.643c.429-.225.86-.448%201.292-.669l.331.647c-.43.22-.859.441-1.287.665zm-2.564%201.358l-.345-.64c.428-.23.857-.458%201.285-.685l.339.643c-.427.226-.853.452-1.279.682zm903.217.462l-.702-.183c.121-.467.241-.935.36-1.403l.703.177c-.118.47-.238.941-.361%201.409zm-905.767.929l-.352-.636c.425-.236.85-.47%201.277-.702l.347.638c-.424.231-.848.464-1.272.7zm-2.535%201.423l-.361-.632c.422-.24.846-.48%201.27-.717l.356.632c-.423.238-.845.476-1.265.717zm907.542.457l-.699-.195c.13-.466.258-.931.385-1.398l.701.19c-.127.468-.256.937-.387%201.403zm-910.062.997l-.366-.627%201.261-.733.363.629-1.258.731zm-2.504%201.49l-.374-.621c.417-.252.834-.503%201.253-.751l.372.624c-.418.249-.834.497-1.251.748zm911.755.309l-.695-.209c.138-.463.276-.927.411-1.39l.697.203c-.136.466-.273.931-.413%201.396zm-914.23%201.205l-.383-.616c.412-.257.825-.511%201.24-.764l.378.619c-.412.253-.825.507-1.235.761zm-2.456%201.545l-.391-.612c.409-.262.818-.521%201.23-.779l.387.614c-.41.258-.818.516-1.226.777zm915.827.031l-.693-.22c.148-.46.292-.921.435-1.383l.693.214c-.143.465-.288.927-.435%201.389zm-918.264%201.545l-.398-.607c.405-.266.812-.53%201.22-.794l.394.61c-.406.263-.812.527-1.216.791zm917.358%201.222l-.688-.232c.154-.458.306-.916.456-1.376l.691.225c-.151.462-.304.923-.459%201.383zm-919.774.386l-.406-.602%201.209-.81.403.605-1.206.807zm-2.395%201.64l-.414-.598c.398-.275.798-.551%201.199-.826l.409.6c-.399.273-.796.548-1.194.824zm921.22.728l-.686-.243c.162-.456.322-.913.48-1.368l.686.236c-.159.459-.319.917-.48%201.375zm-923.593.942l-.422-.592%201.188-.841.418.592-1.184.841zm-2.349%201.701l-.43-.584c.391-.288.783-.574%201.176-.86l.426.589c-.392.284-.783.569-1.172.855zm924.949.093l-.681-.253c.169-.453.335-.907.5-1.361l.682.247c-.165.457-.332.912-.501%201.367zm-927.274%201.644l-.44-.579c.387-.293.775-.585%201.165-.875l.434.582c-.388.289-.774.58-1.159.872zm926.24%201.078l-.677-.262c.174-.451.349-.903.519-1.355l.68.258c-.173.453-.346.906-.522%201.359zm-928.541.689l-.447-.573c.382-.298.766-.595%201.151-.891l.443.576c-.385.295-.767.591-1.147.888zm-2.272%201.802l-.457-.564c.376-.305.757-.607%201.137-.91l.451.569c-.379.301-.757.602-1.131.905zm929.74.218l-.674-.272c.182-.449.362-.898.54-1.348l.675.268c-.178.451-.359.901-.541%201.352zm-931.987%201.62l-.464-.559c.373-.309.748-.618%201.124-.927l.46.563c-.376.307-.749.615-1.12.923zm930.877%201.073l-.669-.282c.188-.446.373-.893.558-1.34l.671.278c-.185.448-.372.897-.56%201.344zm-933.091.799l-.474-.55c.367-.316.736-.631%201.108-.945l.469.555c-.37.312-.738.626-1.103.94zm931.947%201.879l-.665-.29c.193-.443.385-.888.575-1.332l.668.285c-.191.446-.384.891-.578%201.337zm-934.131.031l-.483-.542c.361-.322.725-.644%201.092-.965l.478.547c-.365.319-.727.639-1.087.96zm-2.15%201.947l-.492-.535c.356-.328.714-.655%201.075-.982l.488.539c-.359.326-.716.652-1.071.978zm935.103.686l-.662-.298c.198-.441.394-.883.591-1.326l.664.294c-.196.444-.394.887-.593%201.33zm-937.215%201.301l-.502-.525c.349-.335.701-.669%201.056-1.003l.497.529c-.353.332-.703.665-1.051.999zm936.007%201.347l-.661-.305.608-1.319.661.302-.608%201.322zm-938.08.678l-.513-.514c.342-.342.688-.683%201.036-1.024l.508.519c-.346.339-.691.679-1.031%201.019zM1030%20218.264l-.656-.312.623-1.314.656.31-.623%201.316zm-938.869.113l-.524-.502c.335-.35.674-.698%201.015-1.046l.519.507c-.34.348-.676.694-1.01%201.041zm-1.983%202.113l-.536-.491c.327-.356.657-.712.992-1.068l.529.497c-.332.354-.661.708-.985%201.062zm939.585.397l-.653-.319c.214-.436.425-.871.636-1.306l.654.316c-.211.437-.424.873-.637%201.309zM87.216%20222.65l-.548-.478c.319-.364.64-.728.965-1.092l.542.484c-.324.362-.643.724-.959%201.086zm940.224.845l-.649-.326c.217-.433.433-.866.647-1.299l.652.322c-.216.435-.432.869-.65%201.303zm-942.098%201.363l-.561-.463c.307-.373.62-.746.937-1.118l.553.47c-.313.369-.624.74-.929%201.111zm940.78%201.233l-.647-.332.661-1.294.647.329-.661%201.297zm-942.593%201.026l-.573-.447c.297-.38.598-.762.904-1.143l.566.454c-.304.379-.603.758-.897%201.136zm941.25%201.557l-.643-.337.672-1.288.645.335-.674%201.29zm-943.247.832l-.536-.49c.327-.358.655-.714.987-1.067l.087-.121.579.438-.109.146c-.356.384-.682.738-1.008%201.094zm941.885%201.74l-.642-.342.684-1.283.641.34-.683%201.285zm-943.815.416l-.546-.48c.32-.364.641-.727.965-1.088l.54.486c-.32.358-.641.719-.959%201.082zm942.433%202.145l-.639-.348.694-1.277.638.345-.693%201.28zm-944.317.05l-.556-.467c.312-.371.626-.741.942-1.109l.551.474c-.314.365-.626.733-.937%201.102zm-1.838%202.236l-.567-.455c.306-.379.612-.755.92-1.129l.56.461c-.306.372-.61.747-.913%201.123zm944.753.264l-.635-.352.702-1.272.637.35-.704%201.274zm-946.544%202.009l-.575-.445c.297-.383.594-.766.894-1.147l.571.45c-.299.379-.595.759-.89%201.142zm945.127.531l-.633-.355.709-1.266.634.353-.71%201.268zm-946.873%201.778l-.584-.432c.288-.39.579-.778.871-1.165l.58.438c-.291.384-.58.771-.867%201.159zm945.439.754l-.631-.36.717-1.262.632.359-.718%201.263zm-947.137%201.592l-.593-.42c.281-.397.564-.791.848-1.183l.589.425c-.284.391-.565.784-.844%201.178zm945.69.931l-.629-.363.724-1.258.63.361-.725%201.26zm-947.344%201.447l-.599-.408c.273-.401.547-.802.823-1.2l.597.415c-.276.396-.549.795-.821%201.193zm945.884%201.068l-.627-.366.73-1.255.629.365-.732%201.256zm-947.486%201.345l-.608-.396c.265-.406.531-.812.8-1.216l.604.402c-.267.402-.533.805-.796%201.21zm946.015%201.162l-.626-.369.735-1.25.628.367-.737%201.252zm-947.568%201.284l-.617-.384c.256-.411.514-.823.774-1.233l.613.39c-.258.408-.515.816-.77%201.227zm946.087%201.218l-.624-.371.741-1.249.624.371-.741%201.249zm-947.592%201.259l-.626-.371c.248-.418.499-.834.751-1.249l.621.378c-.252.412-.5.825-.746%201.242zm946.103%201.237l-.622-.374.745-1.246.623.372-.746%201.248zm-947.558%201.27l-.633-.357c.239-.423.481-.844.725-1.265l.628.365c-.242.418-.483.837-.72%201.257zm946.063%201.22l-.623-.375.749-1.243.623.374-.749%201.244zm-947.468%201.316l-.64-.345c.23-.427.464-.852.7-1.278l.635.351c-.234.423-.466.847-.695%201.272zm945.966%201.17l-.621-.375.751-1.243.621.376-.751%201.242zm-947.319%201.396l-.646-.332c.222-.432.447-.863.674-1.293l.642.339c-.225.427-.449.856-.67%201.286zm945.814%201.088l-.622-.377.753-1.24.622.375-.753%201.242zm-947.113%201.505l-.652-.32c.214-.436.429-.872.646-1.306l.65.325c-.217.433-.432.866-.644%201.301zm945.637.92l-.344-.132-.284-.234.728-1.196.621.377-.721%201.185zm-946.883%201.698l-.66-.305c.205-.441.411-.881.62-1.32l.655.312c-.208.437-.412.875-.615%201.313zm945.338.839l-.621-.377.756-1.242.62.378-.755%201.241zM56.38%20268.2l-.666-.292c.195-.445.392-.889.592-1.333l.663.3c-.199.44-.396.881-.589%201.325zm945.017.679l-.621-.377.757-1.242.621.378-.757%201.241zM55.243%20270.87l-.671-.278c.186-.45.373-.898.564-1.345l.668.285c-.189.445-.377.891-.561%201.338zm944.645.494l-.622-.377.755-1.242.622.376-.755%201.243zm-945.725%202.199l-.676-.264c.176-.452.354-.904.536-1.356l.674.271c-.18.449-.359.899-.534%201.349zm944.218.288l-.621-.376.753-1.244.621.377-.753%201.243zm-945.239%202.428l-.683-.248c.167-.458.335-.914.507-1.369l.679.256c-.17.453-.339.906-.503%201.361zm943.737.06l-.622-.374.751-1.246.621.376-.75%201.244zm-1.496%202.492l-.623-.373.747-1.247.623.373-.747%201.247zm-943.204.186l-.688-.234c.157-.461.315-.92.477-1.379l.685.241c-.161.457-.318.913-.474%201.372zm941.716%202.31l-.624-.372.743-1.248.624.371-.743%201.249zm-942.619.448l-.693-.217c.146-.464.295-.927.447-1.39l.69.227c-.151.459-.298.918-.444%201.38zm941.139%202.052l-.625-.368.739-1.252.625.37-.739%201.25zm-941.98.728l-.697-.204c.137-.466.275-.933.416-1.398l.695.21c-.141.464-.278.928-.414%201.392zm940.511%201.779l-.626-.366.732-1.255.628.367-.734%201.254zm-941.287%201.017l-.702-.188c.125-.469.252-.939.383-1.407l.699.193c-.129.467-.256.934-.38%201.402zm939.829%201.494l-.629-.363.728-1.259.629.365-.728%201.257zm-940.542%201.321l-.707-.17c.114-.474.23-.946.35-1.419l.704.179c-.119.47-.235.939-.347%201.41zm939.099%201.197l-.631-.359.722-1.262.63.362-.721%201.259zm-939.747%201.633l-.709-.154c.103-.476.208-.951.317-1.425l.708.161c-.108.472-.212.944-.316%201.418zm938.317.895l-.635-.356.715-1.267.632.359-.712%201.264zM47.72%20295.84l-.714-.136c.093-.478.186-.956.282-1.433l.713.145c-.097.475-.19.949-.281%201.424zm937.481.585l-.635-.351.706-1.271.634.353-.705%201.269zM47.21%20298.697l-.716-.117c.079-.481.162-.96.247-1.441l.715.128c-.084.477-.167.953-.246%201.43zm936.594.273l-.638-.348.697-1.274.637.35-.696%201.272zm-1.378%202.553l-.641-.342.688-1.28.64.345-.687%201.277zm-935.654.044l-.719-.101c.068-.482.139-.963.212-1.445l.717.11c-.072.479-.142.957-.21%201.436zm934.296%202.521l-.642-.338.676-1.285.643.339-.677%201.284zm-934.659.357l-.722-.082c.054-.483.114-.966.174-1.449l.721.091c-.061.48-.118.96-.173%201.44zm933.324%202.218l-.646-.331.666-1.293.646.335-.666%201.289zm-933.615.67l-.723-.062c.042-.485.087-.97.135-1.454l.724.072c-.049.481-.094.963-.136%201.444zm932.304%201.918l-.65-.326.655-1.298.648.329-.653%201.295zm-932.517.976l-.725-.044c.029-.485.062-.971.098-1.457l.725.053c-.036.483-.069.966-.098%201.448zm931.229%201.622l-.652-.318.642-1.305.65.322-.64%201.301zM45.77%20313.123l-.726-.024c.016-.487.035-.973.059-1.459l.725.034c-.023.483-.042.966-.058%201.449zm930.104%201.338l-.655-.312c.207-.437.417-.874.628-1.311l.653.316c-.21.436-.419.872-.626%201.307zm-930.16%201.561l-.726-.005c.003-.486.009-.972.018-1.458l.726.013c-.009.483-.015.966-.018%201.45zm928.929%201.065l-.659-.305c.203-.439.407-.88.614-1.318l.657.308c-.206.438-.41.877-.612%201.315zm-929.628%201.848c-.011-.487-.019-.973-.023-1.459l.726-.007c.004.483.012.965.024%201.448l-.727.018zm928.425.79l-.662-.296c.198-.443.398-.885.599-1.326l.661.301c-.201.439-.399.88-.598%201.321zM45.127%20321.85c-.025-.486-.048-.972-.066-1.458l.726-.027c.018.482.04.964.065%201.447l-.725.038zm927.143.528l-.666-.289c.193-.445.386-.89.583-1.333l.664.293c-.196.443-.389.885-.581%201.329zM45.323%20324.76c-.039-.485-.076-.969-.108-1.455l.724-.049c.033.483.069.964.108%201.444l-.724.06zm925.811.286l-.67-.279c.187-.448.375-.894.565-1.34l.668.283c-.189.446-.377.891-.563%201.336zm-925.527%202.618c-.054-.484-.106-.967-.153-1.451l.724-.07c.046.48.097.959.151%201.44l-.722.081zm924.426.064l-.674-.271c.181-.45.363-.899.549-1.348l.671.276c-.184.448-.366.896-.546%201.343zm-1.065%202.697l-.678-.261c.175-.453.351-.905.53-1.356l.675.266c-.177.45-.354.9-.527%201.351zm-922.987.134c-.071-.482-.136-.964-.199-1.446l.721-.092c.062.477.126.955.197%201.433l-.719.105zm921.961%202.579l-.68-.253c.167-.454.337-.908.509-1.362l.679.257c-.171.452-.339.905-.508%201.358zm-921.499.3c-.085-.479-.165-.958-.243-1.438l.718-.116c.076.477.157.953.241%201.428l-.716.126zm920.514%202.427l-.685-.241c.162-.459.324-.916.49-1.372l.683.248c-.165.454-.328.909-.488%201.365zm-919.96.436c-.1-.476-.196-.952-.288-1.428l.713-.14c.091.474.187.947.285%201.419l-.71.149zm919.018%202.306l-.688-.231c.154-.459.309-.919.467-1.378l.687.237c-.156.456-.312.914-.466%201.372zm-918.372.539c-.115-.473-.227-.945-.334-1.42l.708-.16c.107.47.218.94.332%201.409l-.706.171zm917.474%202.219l-.692-.22c.146-.462.295-.924.445-1.385l.691.224c-.15.46-.297.92-.444%201.381zm-916.735.602c-.13-.467-.257-.937-.38-1.407l.702-.184c.123.466.248.932.377%201.397l-.699.194zm915.884%202.171l-.697-.208c.139-.465.279-.931.421-1.394l.695.213c-.142.462-.282.924-.419%201.389zm-915.051.626c-.147-.464-.29-.929-.428-1.395l.696-.207c.137.461.279.922.424%201.382l-.692.22zm914.247%202.161l-.7-.195c.131-.468.264-.935.398-1.402l.698.202c-.134.465-.266.93-.396%201.395zm-913.322.604c-.163-.459-.321-.918-.475-1.38l.69-.229c.152.457.309.911.47%201.366l-.685.243zm912.567%202.198l-.703-.183c.122-.471.246-.94.372-1.409l.702.188c-.126.467-.25.934-.371%201.404zm-911.55.533c-.177-.453-.351-.907-.52-1.361l.681-.254c.168.452.34.901.516%201.35l-.677.265zm910.847%202.281l-.706-.169c.112-.473.229-.944.346-1.416l.705.175c-.117.47-.232.939-.345%201.41zm-909.735.414c-.193-.447-.382-.893-.567-1.342l.671-.277c.184.445.371.888.563%201.332l-.667.287zm909.085%202.414l-.71-.156c.073-.331.146-.661.222-.993l.098-.428.708.162-.097.428c-.076.329-.149.658-.221.987zm-907.883.24c-.207-.439-.411-.879-.612-1.322l.661-.299c.199.438.402.875.608%201.311l-.657.31zm907.288%202.597l-.713-.144c.095-.475.194-.951.292-1.425l.711.149c-.099.473-.196.945-.29%201.42zm-905.994.016c-.223-.432-.443-.865-.658-1.3l.651-.322c.213.43.43.859.653%201.288l-.646.334zm1.384%202.568c-.147-.263-.293-.527-.438-.791l-.265-.488.64-.344.262.483c.143.263.288.524.435.785l-.634.355zm904.065.262l-.715-.131c.087-.476.176-.953.267-1.43l.714.136c-.091.475-.179.949-.266%201.425zM57.617%20363.31c-.251-.415-.499-.833-.744-1.255l.627-.365c.244.418.489.832.739%201.243l-.622.377zm902.103.599l-.717-.118c.079-.478.159-.956.242-1.435l.716.124c-.082.477-.162.953-.241%201.429zM59.171%20365.79c-.266-.407-.528-.82-.787-1.233l.615-.386c.257.41.517.819.78%201.223l-.608.396zm900.105.982l-.72-.105c.071-.48.144-.96.218-1.44l.717.112c-.074.477-.146.955-.215%201.433zM60.798%20368.22c-.278-.401-.552-.804-.823-1.208l.603-.405c.269.403.541.801.817%201.198l-.597.415zm898.078%201.426l-.72-.095c.063-.481.128-.962.194-1.443l.719.101c-.066.478-.13.957-.193%201.437zm-896.379.948c-.289-.392-.575-.785-.858-1.181l.59-.423c.281.393.566.784.852%201.173l-.584.431zm896.024%201.929l-.722-.083c.055-.482.114-.964.174-1.446l.72.089c-.059.48-.116.96-.172%201.44zm-894.259.395c-.301-.382-.597-.767-.892-1.154l.579-.44c.292.384.586.767.884%201.147l-.571.447zm1.826%202.272c-.311-.374-.616-.751-.921-1.129l.565-.456c.303.376.608.75.916%201.122l-.56.463zm892.122.217l-.723-.072c.049-.483.099-.966.152-1.448l.722.078c-.053.481-.103.961-.151%201.442zM67.973%20377.41c-.319-.367-.635-.735-.949-1.104l.553-.47c.313.367.627.733.944%201.097l-.548.477zm889.967.885l-.723-.062c.041-.484.085-.967.13-1.45l.723.068c-.045.482-.089.963-.13%201.444zm-888.028%201.286c-.328-.358-.653-.718-.976-1.08l.541-.483c.321.359.645.717.971%201.072l-.536.491zm887.796%201.606l-.725-.052c.036-.484.072-.968.112-1.451l.724.058c-.04.482-.076.964-.111%201.445zm-885.809.516c-.335-.349-.668-.702-1-1.055l.531-.496c.329.35.661.701.994%201.049l-.525.502zm2.034%202.079c-.343-.343-.684-.688-1.022-1.034l.519-.508c.336.345.675.687%201.016%201.028l-.513.514zm883.58.301l-.725-.044.093-1.452.725.048-.093%201.448zm-881.504%201.731c-.35-.335-.698-.672-1.043-1.01l.508-.52c.344.337.69.673%201.039%201.007l-.504.523zm881.342%201.167l-.725-.037c.024-.483.049-.969.077-1.452l.725.04c-.028.483-.053.966-.077%201.449zm-879.229.828c-.355-.329-.709-.661-1.06-.993l.497-.528c.351.332.703.66%201.057.987l-.494.534zm2.149%201.954c-.361-.322-.722-.647-1.079-.972l.49-.537c.355.323.713.646%201.073.967l-.484.542zm876.953.118l-.726-.029.061-1.454.725.033-.06%201.45zM82.45%20391.682c-.366-.317-.731-.635-1.094-.956l.48-.545c.362.319.725.636%201.089.952l-.475.549zm874.676%201.1l-.726-.021.045-1.454.727.024-.046%201.451zm-872.468.785c-.372-.312-.74-.625-1.108-.939l.471-.552c.366.313.735.624%201.104.935l-.467.556zm2.232%201.855c-.374-.308-.747-.616-1.119-.925l.463-.558c.372.308.744.615%201.118.921l-.462.562zm870.167.262l-.727-.014c.01-.485.02-.97.032-1.455l.727.019c-.013.483-.023.966-.032%201.45zm-867.911%201.565c-.377-.303-.754-.605-1.13-.91l.456-.565c.375.303.751.606%201.128.907l-.454.568zm867.866%201.338l-.726-.007.019-1.456.726.011-.019%201.452zm-865.592.465c-.379-.298-.76-.598-1.139-.898l.451-.57c.378.3.757.599%201.137.896l-.449.572zm2.293%201.781c-.383-.295-.765-.59-1.148-.888l.446-.573c.381.296.763.592%201.145.885l-.443.576zm863.28.658l-.726-.002.007-1.455.726.005-.007%201.452zm-860.972%201.103l-1.156-.878.442-.578%201.153.877-.439.579zm2.32%201.746l-1.162-.87.437-.581%201.159.87-.434.581zm857.928.058l-.004-1.454.726-.002.005%201.453-.727.003zm-855.599%201.675l-1.166-.864.434-.583%201.164.863-.432.584zm855.621%201.234l-.013-1.454.726-.006.014%201.452-.727.008zm-853.282.489l-1.169-.861.43-.584%201.169.858-.43.587zm2.344%201.714l-1.173-.857.428-.586%201.173.856-.428.587zm850.978.705l-.022-1.454.727-.01.021%201.452-.726.012zm-848.629%201.006l-1.175-.855.427-.587%201.175.854-.427.588zm2.349%201.707l-1.175-.854.427-.587%201.175.854-.427.587zm846.335.195l-.029-1.454.726-.014.03%201.453-.727.015zm-843.984%201.515l-1.175-.855.427-.587%201.175.853-.427.589zm844.054%201.393l-.036-1.454.726-.017.036%201.452-.726.019zm-841.708.32l-1.173-.856.429-.587%201.174.858-.43.585zm2.344%201.719l-1.17-.861.429-.586%201.173.862-.432.585zm839.445.868l-.042-1.453.726-.02.042%201.452-.726.021zm-837.108.86l-1.167-.865.431-.585%201.17.868-.434.582zm2.329%201.74l-1.163-.871.434-.582%201.165.873-.436.58zm834.869.306l-.047-1.452.727-.024.046%201.453-.726.023zm-832.553%201.45l-1.157-.88.438-.579%201.16.881-.441.578zm832.651%201.456l-.048-1.406.724-.071.05%201.452-.726.025zm-830.347.316l-1.149-.887.442-.576%201.153.89-.446.573zm2.29%201.793l-1.143-.899.448-.571%201.144.9-.449.57zm828.16.796l-.052-1.454.727-.024.051%201.451-.726.027zm-825.892%201.02c-.376-.305-.754-.609-1.132-.911l.454-.568c.379.304.757.608%201.135.914l-.457.565zm2.251%201.839c-.374-.308-.747-.616-1.122-.923l.46-.562c.375.307.751.617%201.125.927l-.463.558zm823.749.045l-.054-1.452.727-.028.054%201.453-.727.027zm-821.525%201.825c-.368-.315-.738-.628-1.109-.939l.467-.556c.372.313.743.626%201.113.941l-.471.554zm821.633%201.078l-.054-1.451.726-.027.054%201.452-.726.026zm-819.434.819c-.364-.319-.729-.636-1.096-.953l.475-.55c.367.318.734.637%201.099.957l-.478.546zm2.168%201.933c-.358-.325-.719-.649-1.08-.971l.483-.541c.363.323.725.648%201.085.973l-.488.539zm817.375.152l-.054-1.452.726-.026.054%201.451-.726.027zm-815.238%201.812c-.353-.33-.708-.659-1.064-.987l.492-.535c.358.33.714.66%201.068.992l-.496.53zm815.342%201.092l-.05-1.4.361-.065.363-.013.053%201.453-.727.025zm-813.243.911c-.347-.337-.696-.673-1.046-1.007l.502-.524c.352.335.701.672%201.049%201.009l-.505.522zm813.344%201.992l-.049-1.451.726-.025.05%201.452-.727.024zm-811.275.058c-.372-.377-.702-.706-1.034-1.036l.51-.517c.334.332.667.664.997.999l-.473.554zm2.011%202.075c-.334-.352-.668-.7-1.005-1.048l.521-.505c.339.349.675.699%201.011%201.052l-.527.501zm809.359.77l-.048-1.451.727-.024.047%201.453-.726.022zm-807.382%201.353c-.326-.357-.654-.712-.983-1.066l.531-.495c.332.355.661.713.988%201.072l-.536.489zm807.467%201.55l-.04-1.41.361-.052.364-.01.042%201.452-.727.02zm-805.53.61c-.319-.363-.64-.725-.962-1.085l.54-.485c.324.363.648.726.968%201.091l-.546.479zm1.895%202.197c-.312-.37-.627-.737-.942-1.103l.55-.474c.317.367.633.736.947%201.107l-.555.47zm803.71.095l-.035-1.45.726-.019.035%201.452-.726.017zm-801.853%202.135c-.307-.375-.614-.748-.923-1.119l.558-.465c.31.373.619.748.927%201.124l-.562.46zm801.916.769l-.029-1.451.726-.015.03%201.452-.727.014zm-800.101%201.491c-.299-.379-.6-.757-.903-1.133l.566-.455c.304.377.606.758.907%201.139l-.57.449zm800.149%201.412l-.022-1.451.726-.012.023%201.453-.727.01zm-798.373.88c-.292-.384-.586-.767-.883-1.149l.573-.446c.298.383.594.768.888%201.155l-.578.44zm798.404%202.023l-.013-1.45.726-.009.014%201.453-.727.006zm-796.663.295c-.286-.389-.575-.777-.865-1.163l.58-.435c.292.387.582.776.87%201.167l-.585.431zm1.706%202.345c-.283-.394-.565-.785-.849-1.176l.587-.427c.286.392.569.785.852%201.18l-.59.423zm795.333.263h-.363l-.004-1.452.727-.002.003%201.404-.363.05zm-793.665%202.105c-.274-.396-.551-.792-.83-1.187l.594-.419c.279.397.557.794.833%201.192l-.597.414zm794.017.805l-.727-.006c.005-.485.007-.968.008-1.452l.727.002c-.002.486-.004.971-.008%201.456zm-792.378%201.588c-.271-.401-.542-.801-.815-1.199l.6-.41c.273.4.545.801.816%201.202l-.601.407zm792.339%201.325l-.726-.012.022-1.456.727.01-.023%201.458zm-790.733%201.088c-.265-.403-.531-.807-.799-1.209l.605-.402c.268.403.536.807.801%201.213l-.607.398zm790.666%201.831l-.727-.021.038-1.454.726.016-.037%201.459zm-789.092.603c-.259-.408-.52-.814-.783-1.22l.61-.394c.263.407.526.815.786%201.224l-.613.39zm788.993%202.312l-.726-.028c.02-.485.037-.969.053-1.453l.726.023c-.016.487-.033.973-.053%201.458zm-787.445.14c-.256-.411-.512-.82-.77-1.229l.615-.387c.259.409.515.82.772%201.231l-.617.385zm1.522%202.468l-.758-1.236.618-.381.759%201.239-.619.378zm785.793.305l-.724-.036.067-1.453.726.032-.069%201.457zm-784.299%202.179c-.247-.415-.495-.83-.745-1.244l.623-.374c.25.415.499.83.746%201.247l-.624.371zm784.137.731l-.725-.043c.03-.485.058-.969.085-1.452l.725.041c-.027.484-.055.97-.085%201.454zm-782.666%201.769l-.732-1.251.625-.369.734%201.254-.627.366zm782.47%201.139l-.725-.052.102-1.45.725.05-.102%201.452zm-781.022%201.374c-.238-.421-.479-.84-.721-1.258l.629-.363c.242.419.484.84.723%201.261l-.631.36zm780.789%201.529l-.723-.062c.042-.482.082-.964.12-1.446l.723.057c-.037.483-.078.968-.12%201.451zm-779.36.996l-.713-1.264.633-.358.714%201.266-.634.356zm779.091%201.905l-.722-.072c.047-.483.093-.963.138-1.445l.724.067c-.045.484-.091.967-.14%201.45zm-777.681.629l-.703-1.268.636-.353.703%201.271-.636.35zm777.374%202.267l-.722-.083c.054-.48.107-.96.158-1.441l.722.076c-.051.482-.103.965-.158%201.448zM181%20491.861l-.694-1.275.637-.347.695%201.276-.638.346zm1.377%202.555l-.687-1.279.639-.345.688%201.281-.64.343zm774.256.053l-.72-.092c.061-.479.12-.958.178-1.439l.721.088c-.058.482-.118.963-.179%201.443zm-772.892%202.509l-.68-1.281.641-.342.681%201.284-.642.339zm772.504.376l-.72-.103c.068-.478.135-.956.2-1.435l.719.096c-.065.481-.132.962-.199%201.442zm-771.154%202.193l-.674-1.284.643-.338.675%201.286-.644.336zm770.722.683l-.718-.113c.075-.477.149-.954.22-1.432l.718.107c-.072.48-.146.959-.22%201.438zm-769.381%201.893l-.669-1.288.644-.336.67%201.29-.645.334zm768.903.977l-.715-.125c.083-.475.163-.951.243-1.428l.716.12c-.079.477-.16.956-.244%201.433zm-767.57%201.605l-.665-1.291.645-.333.665%201.292-.645.332zm767.047%201.255l-.713-.136c.091-.474.18-.949.267-1.424l.714.132c-.088.477-.177.953-.268%201.428zm-765.722%201.33l-.662-1.294.647-.33.661%201.293-.646.331zm765.151%201.521l-.711-.148c.099-.472.196-.945.29-1.418l.712.141c-.094.477-.192.951-.291%201.425zm-763.832%201.067l-.659-1.293.647-.331.659%201.295-.647.329zm763.211%201.773l-.708-.162c.108-.47.213-.94.316-1.412l.709.155c-.103.474-.209.947-.317%201.419zm-761.895.818l-.658-1.296.649-.329.657%201.296-.648.329zm761.221%202.01l-.705-.174c.116-.469.229-.937.342-1.407l.706.169c-.112.471-.227.942-.343%201.412zm-759.907.583l-.657-1.296.649-.329.657%201.297-.649.328zm759.18%202.232l-.701-.189c.125-.465.248-.932.369-1.399l.703.182c-.122.47-.245.938-.371%201.406zm-757.866.363l-.657-1.298.648-.327.657%201.297-.648.328zm757.083%202.436l-.698-.202c.134-.463.266-.926.396-1.39l.699.196c-.129.465-.263.932-.397%201.396zm-755.769.156l-.657-1.296.648-.329.658%201.297-.649.328zm1.317%202.594l-.658-1.297.647-.329.66%201.296-.649.33zm753.611.032l-.694-.216c.145-.461.287-.921.426-1.382l.695.21c-.139.464-.282.927-.427%201.388zm-752.287%202.558l-.662-1.295.647-.33.662%201.294-.647.331zm751.385.207l-.688-.233c.154-.456.307-.914.456-1.373l.691.226c-.151.46-.303.921-.459%201.38zm-750.055%202.382l-.666-1.294.647-.332.665%201.293-.646.333zm749.093.361l-.683-.248c.165-.452.327-.906.486-1.361l.686.24c-.16.457-.323.914-.489%201.369zm-747.757%202.223l-.669-1.291.646-.334.669%201.292-.646.333zm746.731.5l-.677-.266c.175-.447.348-.897.518-1.349l.68.255c-.171.455-.344.907-.521%201.36zm-745.382%202.08l-.676-1.289.645-.336.673%201.287-.642.338zm744.291.615l-.67-.281c.186-.444.369-.89.551-1.337l.673.274c-.182.45-.367.897-.554%201.344zm-742.937%201.953l-.679-1.283.643-.338.678%201.28-.642.341zm741.778.716l-.662-.298c.197-.439.391-.88.584-1.322l.667.289c-.194.446-.39.889-.589%201.331zm-740.406%201.841l-.688-1.277.64-.343.686%201.276-.638.344zm739.179.798l-.655-.316c.209-.433.416-.869.619-1.306l.659.306c-.205.44-.413.879-.623%201.316zm-737.79%201.752l-.697-1.273.638-.347.695%201.27-.636.35zm736.492.854l-.645-.332c.221-.43.438-.86.653-1.291l.651.325c-.218.434-.437.867-.659%201.298zM207.845%20543.4l-.706-1.268.635-.352.705%201.266-.634.354zm733.715.885l-.636-.35c.232-.422.462-.846.689-1.272l.641.342c-.229.428-.459.855-.694%201.28zm-732.286%201.646l-.717-1.265.633-.356.715%201.261-.631.36zm730.843.886l-.626-.368c.244-.416.486-.833.724-1.252l.632.359c-.241.423-.484.843-.73%201.261zm-729.392%201.632c-.244-.418-.487-.838-.728-1.258l.629-.362c.241.419.483.837.727%201.255l-.628.365zm727.874.857l-.615-.387c.257-.409.512-.818.763-1.23l.619.377c-.252.415-.508.829-.767%201.24zm-726.402%201.65l-.738-1.251.625-.369.738%201.25-.625.37zm724.81.795l-.603-.405c.271-.401.537-.804.801-1.207l.609.396c-.266.408-.535.813-.807%201.216zm-723.312%201.699l-.751-1.246.622-.372.75%201.242-.621.376zm721.644.696l-.59-.424c.283-.392.561-.786.837-1.182l.596.415c-.277.398-.559.796-.843%201.191zm-720.12%201.784c-.256-.412-.511-.825-.764-1.238l.618-.38c.253.412.507.823.763%201.234l-.617.384zm718.376.561l-.576-.443c.294-.383.586-.767.874-1.155l.583.432c-.29.391-.584.78-.881%201.166zm-716.827%201.903l-.778-1.23.615-.388.776%201.228-.613.39zm715.008.385l-.56-.461c.307-.374.61-.75.911-1.128l.568.453c-.303.381-.609.76-.919%201.136zm-713.431%202.062l-.792-1.222.61-.393.791%201.219-.609.396zm711.537.168l-.546-.48c.319-.364.636-.73.948-1.097l.554.471c-.315.371-.634.74-.956%201.106zm-1.965%202.163l-.529-.499c.33-.351.657-.705.982-1.061l.537.487c-.327.36-.656.718-.99%201.073zm-707.966.1c-.27-.404-.539-.808-.806-1.213l.605-.4c.267.404.536.806.805%201.208l-.604.405zm705.934%201.994l-.512-.515c.341-.34.68-.683%201.015-1.029l.522.505c-.339.349-.681.696-1.025%201.039zm-704.298.417c-.274-.401-.549-.801-.822-1.203l.601-.408c.272.401.545.801.82%201.2l-.599.411zm702.2%201.602l-.495-.532c.352-.328.701-.659%201.048-.993l.504.524c-.35.337-.703.67-1.057%201.001zm-700.532.789c-.281-.397-.56-.795-.838-1.194l.596-.415c.277.397.556.794.835%201.189l-.593.42zm698.369%201.159l-.477-.548c.362-.316.723-.635%201.08-.957l.487.54c-.36.324-.724.646-1.09.965zm-696.669%201.208c-.287-.392-.571-.786-.855-1.181l.59-.423c.283.394.567.786.851%201.177l-.586.427zm694.443.669l-.459-.563c.373-.304.744-.612%201.112-.921l.467.554c-.37.313-.743.623-1.12.93zm-298.164.444v-.727l1.452-.001v.727l-1.452.001zm4.357.008l-1.452-.006.001-.727%201.453.006-.002.727zm-7.262.001l-.003-.726%201.453-.007.002.726-1.452.007zm10.166.02l-1.452-.012.005-.726%201.453.012-.006.726zm-13.07.003l-.007-.727%201.454-.013.005.726-1.452.014zm15.974.031l-1.452-.018.008-.727%201.453.018-.009.727zm-18.878.002l-.011-.726%201.454-.02.008.726-1.451.02zm21.782.043l-1.452-.024.011-.727%201.452.024-.011.727zm-24.687.004l-.013-.726%201.454-.025.01.726-1.451.025zm27.591.054l-1.452-.031.014-.726%201.453.031-.015.726zm-30.495.005l-.016-.726%201.454-.032.014.727-1.452.031zm33.398.066l-1.452-.037.019-.726%201.452.037-.019.726zm-36.301.007l-.019-.727%201.453-.038.018.727-1.452.038zm39.204.076l-1.451-.043.021-.726%201.453.043-.023.726zm-42.107.006l-.022-.726%201.412-.041.061.725-1.451.042zm45.01.089l-1.451-.049.024-.726%201.452.049-.025.726zm-47.913.007l-.025-.726%201.452-.049.024.726-1.451.049zm50.816.101l-1.451-.055.027-.726%201.452.055-.028.726zm-53.718.007l-.029-.726%201.453-.056.027.727-1.451.055zm56.62.114l-1.451-.061.03-.727%201.453.063-.032.725zm-59.521.008l-.033-.726%201.453-.062.03.726-1.45.062zm62.422.123l-1.451-.067.033-.726%201.452.068-.034.725zm-65.324.01l-.036-.725%201.453-.069.033.726-1.45.068zm68.225.136l-1.451-.075.036-.724%201.452.074-.037.725zm-71.125.009l-.039-.725%201.452-.074.037.725-1.45.074zm74.025.147l-1.451-.08.04-.725%201.451.08-.04.725zm-76.926.011l-.041-.725%201.451-.081.04.725-1.45.081zm-356.81.144l-.87-1.169.584-.432.868%201.166-.582.435zm436.636.016l-1.45-.086.042-.725%201.452.086-.044.725zm-82.726.01l-.043-.725%201.451-.087.042.725-1.45.087zm336.516.102l-.441-.577c.383-.292.764-.588%201.142-.887l.45.571c-.382.301-.765.598-1.151.893zm-250.891.069l-1.45-.092.045-.725%201.45.092-.045.725zm-88.524.01l-.047-.725%201.451-.093.045.725-1.449.093zm91.422.185l-1.45-.098.049-.725%201.451.098-.05.725zm-94.319.011l-.051-.725%201.451-.1.049.725-1.449.1zm97.215.196l-1.449-.105.053-.725%201.45.105-.054.725zm-100.112.011l-.054-.725%201.45-.105.053.725-1.449.105zm103.008.208l-1.448-.111.055-.724%201.45.11-.057.725zm-105.904.012l-.056-.725%201.449-.111.055.724-1.448.112zm108.799.219l-1.447-.118.057-.723%201.45.118-.06.723zm-111.694.01l-.06-.723%201.449-.118.059.723-1.448.118zm114.589.234l-1.448-.123.061-.724%201.448.123-.061.724zm-117.483.011l-.063-.724%201.448-.123.061.723-1.446.124zm120.375.245l-1.445-.13.063-.723%201.449.13-.067.723zm-123.269.011l-.065-.724%201.447-.13.064.724-1.446.13zm126.161.259l-1.445-.136.067-.723%201.448.135-.07.724zm-129.052.009l-.07-.723%201.448-.137.067.724-1.445.136zm357.335.032l-.423-.59c.392-.281.782-.564%201.169-.851l.432.585c-.39.288-.783.574-1.178.856zm-225.391.24l-1.445-.142.069-.724%201.447.143-.071.723zm-134.836.009l-.071-.724%201.447-.141.069.723-1.445.142zm-326.086.211c-.298-.386-.593-.771-.889-1.156l.578-.442c.294.386.589.77.886%201.153l-.575.445zm463.811.073l-1.445-.149.074-.722%201.445.149-.074.722zm-140.614.008l-.074-.722%201.445-.148.074.722-1.445.148zm143.503.298l-1.444-.155.076-.722%201.445.155-.077.722zm-146.391.007l-.078-.722%201.445-.154.077.722-1.444.154zm149.277.312l-1.443-.161.08-.722%201.444.16-.081.723zm-152.164.006l-.081-.722%201.445-.161.08.723-1.444.16zm155.05.325l-1.444-.167.083-.722%201.443.167-.082.722zm-157.937.005l-.083-.722%201.444-.167.082.722-1.443.167zm369.381.165l-.404-.603c.4-.268.799-.54%201.195-.814l.414.597c-.4.277-.801.55-1.205.82zm-208.56.172l-1.443-.173.087-.72%201.442.173-.086.72zm-163.705.004l-.086-.721%201.443-.172.085.721-1.442.172zm166.587.353l-1.442-.18.09-.721%201.443.18-.091.721zm-169.469.001l-.091-.721%201.444-.179.088.721-1.441.179zm-2.881.366l-.093-.72%201.442-.185.091.72-1.44.185zm175.23.001l-1.44-.186.092-.72%201.442.186-.094.72zm-479.314.196c-.304-.38-.606-.76-.907-1.143l.571-.45c.299.382.6.761.903%201.138l-.567.455zm301.204.183l-.096-.72%201.44-.191.095.72-1.439.191zm180.99%200l-1.44-.191.095-.72%201.441.192-.096.719zm197.47.311l-.386-.616c.409-.257.817-.515%201.222-.778l.394.61c-.408.264-.817.525-1.23.784zm-381.338.08l-.1-.719%201.441-.198.097.72-1.438.197zm186.746.003l-1.439-.198.098-.719%201.441.198-.1.719zm-189.622.4l-.103-.72%201.44-.203.1.719-1.437.204zm192.496.005l-1.436-.204.1-.719%201.44.204-.104.719zm-195.37.411l-.106-.719%201.438-.209.104.719-1.436.209zm198.245.008l-1.436-.21.103-.719%201.44.21-.107.719zm-201.118.419l-.108-.718%201.437-.215.107.718-1.436.215zm203.991.011l-1.436-.217.108-.718%201.438.217-.11.718zm183.477.176l-.368-.627c.416-.244.831-.491%201.244-.742l.376.621c-.416.252-.833.501-1.252.748zm-390.339.254l-.113-.718%201.437-.222.11.718-1.434.222zm-284.991.002c-.31-.375-.618-.751-.925-1.128l.563-.458c.305.376.612.751.922%201.123l-.56.463zm494.723.011l-1.434-.223.11-.717%201.437.222-.113.718zm-212.601.438l-.115-.716%201.437-.229.112.718-1.434.227zm215.471.018l-1.435-.23.114-.717%201.436.228-.115.719zm-218.338.447l-.118-.716%201.435-.235.116.718-1.433.233zm221.204.02l-1.434-.235.116-.717%201.436.236-.118.716zm172.334.249l-.35-.637c.424-.232.846-.468%201.265-.705l.357.631c-.422.24-.846.477-1.272.711zm-396.403.208l-.121-.716%201.433-.241.12.716-1.432.241zm226.933.023l-1.433-.242.121-.716%201.432.242-.12.716zm-229.796.465l-.122-.716%201.431-.246.122.716-1.431.246zm232.659.027l-1.432-.247.123-.716%201.432.247-.123.716zm-504.307.325c-.316-.368-.631-.739-.944-1.111l.555-.468c.313.37.626.739.941%201.107l-.552.472zm268.787.149l-.127-.715%201.431-.253.126.716-1.43.252zm238.378.031l-1.43-.253.126-.716%201.432.254-.128.715zm161.171.14l-.332-.647c.429-.221.858-.444%201.285-.669l.34.641c-.43.229-.861.452-1.293.675zm-402.408.342l-.13-.714%201.431-.258.128.715-1.429.257zm244.096.036l-1.429-.26.129-.715%201.43.26-.13.715zm-246.951.49l-.134-.714%201.429-.265.133.714-1.428.265zm249.804.038l-1.426-.265.132-.715%201.428.266-.134.714zm152.843.39l-.314-.655c.436-.208.871-.42%201.302-.634l.324.649c-.436.217-.873.43-1.312.64zm-405.502.111l-.136-.714%201.428-.271.135.714-1.427.271zm255.513.037l-1.426-.27.134-.713%201.429.27-.137.713zm-513.813.436c-.322-.363-.644-.728-.964-1.095l.548-.477c.318.365.638.728.959%201.09l-.543.482zm255.448.076l-.139-.713%201.427-.277.138.714-1.426.276zm261.218.034l-1.425-.273.135-.714%201.428.274-.138.713zm-264.067.529l-.142-.712%201.426-.284.14.713-1.424.283zm408.554.002l-.297-.663c.442-.197.881-.397%201.321-.6l.305.659c-.442.205-.885.406-1.329.604zm-141.633.021l-1.427-.277.139-.713%201.425.276-.137.714zm-269.768.552l-.145-.713%201.424-.288.144.712-1.423.289zm272.617.003l-1.425-.277.139-.713%201.426.279-.14.711zm2.853.56l-1.426-.279.139-.713%201.426.28-.139.712zm133.251.02l-.28-.671c.447-.185.893-.374%201.336-.565l.288.667c-.447.192-.895.382-1.344.569zm-411.566.002l-.148-.71%201.422-.296.148.711-1.422.295zm-244.949.364c-.329-.357-.657-.716-.983-1.076l.539-.488c.324.358.652.716.98%201.072l-.536.492zm526.115.174l-1.427-.28.14-.712%201.425.279-.138.713zm-284.007.061l-.152-.71%201.422-.301.15.71-1.42.301zm411.697.486l-.263-.677c.451-.175.903-.353%201.351-.533l.27.674c-.452.181-.904.36-1.358.536zm-124.839.015l-1.426-.281.14-.712%201.425.28-.139.713zm-289.698.11l-.155-.709%201.421-.307.153.709-1.419.307zm292.549.448l-1.425-.279.139-.713%201.426.281-.14.711zm-295.386.177l-.157-.71%201.419-.313.156.709-1.418.314zm414.64.27l-.246-.684c.456-.163.91-.33%201.364-.498l.252.681c-.455.17-.912.336-1.37.501zm-116.4.11l-1.428-.278.14-.712%201.426.277-.138.713zm-301.074.255l-.16-.708%201.418-.32.159.707-1.417.321zm-231.595.019c-.337-.35-.672-.703-1.006-1.057l.53-.498c.331.353.664.703%201%201.052l-.524.503zm535.523.276l-1.427-.275.138-.713%201.426.274-.137.714zm110.786.292l-.229-.689c.46-.153.917-.308%201.374-.466l.238.688c-.46.158-.921.313-1.383.467zm-417.544.061l-.164-.708%201.417-.326.161.708-1.414.326zm309.615.191l-1.428-.271.136-.714%201.427.271-.135.714zm-312.444.467l-.167-.706%201.416-.332.165.707-1.414.331zm315.301.068l-1.429-.267.134-.713%201.429.267-.134.713zm102.293.102l-.213-.694c.463-.143.925-.287%201.384-.434l.222.692c-.464.147-.928.293-1.393.436zm-99.433.425l-1.43-.263.132-.714%201.428.261-.13.716zm-320.987.078l-.169-.706%201.414-.338.167.706-1.412.338zm-221.068.126c-.344-.344-.687-.69-1.027-1.038l.52-.507c.338.346.679.689%201.02%201.032l-.513.513zm638.689.196l-.198-.7c.466-.131.93-.266%201.394-.402l.205.696c-.466.138-.934.273-1.401.406zm-93.771.114l-1.432-.256.129-.715%201.431.256-.128.715zm-326.673.249l-.173-.705%201.414-.345.17.706-1.411.344zm329.538.253l-1.432-.249.125-.715%201.431.248-.124.716zm88.089.146l-.182-.703c.468-.121.936-.245%201.401-.372l.191.701c-.469.128-.939.252-1.41.374zm-420.446.297l-.176-.705%201.412-.35.174.705-1.41.35zm335.225.043l-1.433-.242.12-.716%201.434.241-.121.717zm82.388.36l-.165-.706c.47-.112.941-.225%201.409-.342l.175.706c-.472.116-.945.231-1.419.342zm-79.517.11l-1.435-.233.117-.716%201.434.232-.116.717zm-340.912.196l-.18-.704%201.41-.356.177.704-1.407.356zm-210.527.078c-.35-.337-.7-.675-1.047-1.016l.508-.519c.346.339.694.676%201.042%201.011l-.503.524zm554.313.179l-1.436-.224.113-.718%201.435.224-.112.718zm73.799.079l-.152-.71c.474-.101.946-.206%201.416-.311l.161.707c-.474.108-.949.211-1.425.314zm-70.921.353l-1.439-.214.108-.718%201.436.213-.105.719zm-349.479.031l-.182-.703%201.408-.362.18.703-1.406.362zm417.543.197l-.138-.714c.475-.092.949-.185%201.423-.282l.145.712c-.478.097-.953.191-1.43.284zm-65.184.184l-1.441-.203.104-.72%201.437.204-.1.719zm62.315.342l-.124-.717c.477-.081.952-.166%201.428-.254l.131.715c-.478.087-.956.172-1.435.256zm-417.483.01l-.185-.702%201.406-.368.183.702-1.404.368zm358.052.036l-1.441-.192.096-.719%201.439.19-.094.721zm2.886.361l-1.443-.178.091-.72%201.439.178-.087.72zm53.668.06l-.109-.718c.478-.073.955-.148%201.433-.226l.117.717c-.48.079-.96.153-1.441.227zm-617.381.165c-.359-.329-.715-.66-1.069-.992l.497-.53c.353.331.707.66%201.062.986l-.49.536zm566.604.113l-1.445-.165.084-.722%201.442.165-.081.722zm-366.637.011l-.188-.702%201.406-.375.186.702-1.404.375zm414.529.122l-.096-.72c.48-.063.958-.128%201.437-.198l.104.719c-.482.07-.963.136-1.445.199zm-44.998.175l-1.447-.15.077-.722%201.443.15-.073.722zm42.108.184l-.083-.722c.48-.055.96-.112%201.44-.171l.089.721c-.483.058-.964.117-1.446.172zm-39.212.094l-1.448-.135.07-.723%201.444.135-.066.723zm-375.231.182l-.19-.7%201.402-.381.19.701-1.402.38zm411.547.029l-.07-.724c.481-.046.962-.093%201.442-.145l.076.722c-.483.052-.966.1-1.448.147zm-33.416.035c-.484-.037-.967-.077-1.449-.119l.061-.723c.481.041.963.081%201.445.119l-.057.723zm2.9.214c-.482-.033-.966-.066-1.45-.102l.053-.725c.483.035.965.069%201.447.102l-.05.725zm27.615.003l-.057-.724c.482-.038.962-.077%201.445-.119l.062.723c-.483.042-.967.081-1.45.12zm-24.709.176c-.485-.027-.969-.056-1.453-.085l.045-.725c.482.03.965.058%201.449.085l-.041.725zm21.806.024l-.045-.725c.483-.029.964-.061%201.446-.094l.051.725c-.484.033-.969.064-1.452.094zm-18.901.117c-.484-.021-.969-.042-1.453-.066l.035-.725c.483.023.966.045%201.449.066l-.031.725zm15.995.033l-.032-.726c.483-.021.964-.043%201.448-.068l.037.725c-.485.025-.97.047-1.453.069zm-13.088.07c-.484-.013-.969-.029-1.453-.046l.025-.726c.483.016.967.032%201.45.046l-.022.726zm10.18.029l-.018-.727c.482-.011.965-.026%201.447-.042l.025.726c-.485.017-.969.031-1.454.043zm-7.27.035c-.487-.007-.971-.016-1.456-.027l.016-.726c.483.011.966.02%201.45.027l-.01.726zm-395.46.003l-.192-.699%201.4-.387.193.7-1.401.386zm399.823.012l-.005-.727c.481-.004.963-.01%201.446-.019l.013.726c-.484.009-.969.015-1.454.02zm-1.453.006l-1.456-.005.006-.726%201.406.005.044.726zm-590.56.281c-.366-.319-.73-.643-1.092-.968l.485-.54c.36.323.721.644%201.085.962l-.478.546zm189.393.483l-.198-.699%201.4-.393.196.699-1.398.393zm-2.794.794l-.2-.698%201.399-.398.198.698-1.397.398zm-184.386.621c-.371-.312-.743-.626-1.112-.942l.473-.552c.367.315.736.627%201.106.937l-.467.557zm181.596.186l-.203-.698%201.397-.405.201.698-1.395.405zm-2.787.817l-.206-.697%201.395-.41.204.696-1.393.411zm-2.784.83l-.208-.695%201.4-.419.192.701-1.384.413zm-173.765.011c-.379-.302-.758-.607-1.134-.915l.459-.563c.374.305.751.609%201.128.909l-.453.569zm170.979.828l-.21-.695%201.394-.42.21.695-1.394.42zm-2.788.847l-.212-.695%201.395-.425.211.695-1.394.425zm-165.886.111c-.387-.293-.774-.588-1.158-.886l.445-.573c.382.295.766.589%201.151.881l-.438.578zm163.097.74l-.212-.695%201.394-.426.212.695-1.394.426zm-2.786.853l-.213-.694%201.394-.427.212.695-1.393.426zm-157.965.133c-.395-.282-.787-.568-1.178-.855l.43-.586c.388.286.779.57%201.171.851l-.423.59zm155.179.721l-.213-.695%201.393-.427.213.694-1.393.428zm-2.785.854l-.213-.695%201.392-.427.213.696-1.392.426zm-150.001.089c-.402-.271-.802-.547-1.201-.824l.415-.596c.396.275.793.548%201.193.818l-.407.602zm147.215.762l-.212-.695%201.392-.426.213.696-1.393.425zm-144.782.838c-.409-.263-.816-.526-1.222-.791l.399-.608c.403.265.806.527%201.214.786l-.391.613zm141.997.011l-.212-.696%201.392-.424.213.695-1.393.425zm-2.786.843l-.21-.695%201.393-.422.21.696-1.393.421zm-136.736.674c-.416-.249-.83-.501-1.243-.756l.382-.617c.409.252.82.503%201.234.75l-.373.623zm133.947.164l-.208-.696%201.392-.418.21.696-1.394.418zm-2.789.829l-.205-.697%201.393-.413.207.696-1.395.414zm-128.642.466c-.423-.238-.844-.477-1.263-.72l.365-.628c.416.241.834.479%201.254.715l-.356.633zm125.852.354l-.205-.697%201.395-.409.206.697-1.396.409zm-2.795.811l-.201-.697%201.395-.404.202.698-1.396.403zm-120.501.219c-.428-.224-.856-.452-1.282-.682l.346-.639c.423.229.848.456%201.273.679l-.337.642zm117.704.579l-.197-.7%201.397-.397.198.698-1.398.399zm-115.108.732c-.437-.212-.871-.427-1.303-.646l.327-.648c.429.217.86.43%201.293.641l-.317.653zm112.309.053l-.195-.7%201.399-.391.197.7-1.401.391zm-2.804.77l-.189-.701%201.399-.383.194.7-1.404.384zm-106.866.411c-.444-.199-.885-.402-1.325-.608l.308-.658c.437.205.874.406%201.315.604l-.298.662zm104.059.342l-.186-.703%201.403-.374.187.703-1.404.374zm-2.811.736l-.181-.704%201.404-.364.184.702-1.407.366zm-98.568.083c-.448-.187-.896-.377-1.344-.57l.288-.667c.445.192.89.381%201.336.566l-.28.671zm95.753.633l-.177-.706%201.406-.354.179.704-1.408.356zm-93.039.446c-.454-.173-.907-.349-1.36-.529l.268-.676c.45.179.901.355%201.352.528l-.26.677zm90.217.249l-.17-.707%201.408-.343.174.705-1.412.345zm-2.825.672l-.165-.708c.471-.109.941-.22%201.411-.332l.168.706c-.471.113-.943.223-1.414.334zm-84.648.08c-.459-.16-.918-.323-1.376-.491l.25-.682c.454.166.909.329%201.364.487l-.238.686zm81.817.568l-.159-.709%201.414-.321.161.708-1.416.322zm-79.047.354c-.464-.147-.926-.297-1.389-.451l.23-.689c.458.152.918.302%201.378.447l-.219.693zm76.211.267l-.153-.711%201.415-.306.157.709-1.419.308zm-73.415.573c-.468-.133-.934-.27-1.401-.411l.209-.695c.463.14.927.275%201.39.408l-.198.698zm70.572.021l-.144-.711%201.418-.293.148.711-1.422.293zm-2.848.565l-.138-.714%201.422-.278.14.713-1.424.279zm-64.908.176c-.471-.12-.941-.244-1.411-.371l.189-.701c.467.126.934.249%201.402.368l-.18.704zm62.054.355l-.129-.714c.475-.087.949-.174%201.424-.262l.133.714c-.476.09-.952.177-1.428.262zm-59.217.328c-.474-.107-.948-.218-1.421-.331l.17-.707c.471.114.94.223%201.411.33l-.16.708zm56.358.171l-.121-.716c.476-.08.951-.162%201.427-.244l.124.716c-.477.083-.953.165-1.43.244zm-53.505.434c-.478-.094-.954-.192-1.429-.292l.151-.711c.471.101.944.198%201.418.291l-.14.712zm50.638.03l-.111-.718c.475-.074.952-.149%201.428-.226l.116.716c-.477.078-.955.154-1.433.228zm-2.872.425l-.1-.719c.477-.067.954-.137%201.431-.207l.107.719c-.479.071-.958.14-1.438.207zm-44.9.074c-.478-.083-.957-.167-1.436-.256l.133-.713c.475.087.95.171%201.425.252l-.122.717zm42.023.311l-.092-.72c.479-.061.957-.124%201.435-.188l.097.72c-.48.065-.96.127-1.44.188zm-39.142.143c-.481-.071-.961-.143-1.442-.218l.113-.718c.478.075.954.148%201.433.216l-.104.72zm36.261.202l-.081-.722c.479-.053.957-.109%201.436-.166l.087.721c-.481.058-.962.114-1.442.167zm-33.372.178c-.483-.057-.965-.117-1.447-.181l.096-.72c.478.063.956.123%201.436.179l-.085.722zm30.483.122l-.07-.723c.48-.047.959-.094%201.44-.143l.074.722c-.483.05-.963.098-1.444.144zm-27.585.188c-.483-.047-.966-.095-1.45-.146l.077-.722c.48.051.96.098%201.442.144l-.069.724zm24.694.065l-.058-.723c.48-.039.961-.079%201.442-.121l.062.724c-.482.041-.964.082-1.446.12zm-21.79.174c-.484-.034-.969-.072-1.452-.111l.059-.724c.481.039.963.076%201.444.11l-.051.725zm18.892.031l-.045-.725c.481-.03.961-.062%201.442-.096l.052.725c-.483.034-.967.066-1.449.096zm-15.984.142c-.485-.024-.971-.05-1.455-.078l.042-.725c.482.028.964.054%201.446.077l-.033.726zm13.084.01l-.032-.725c.481-.021.963-.045%201.445-.07l.036.725c-.483.025-.966.049-1.449.07zm-10.175.099c-.486-.014-.971-.029-1.456-.047l.028-.726c.482.018.964.033%201.447.046l-.019.727zm7.272.002l-.019-.727c.482-.012.964-.026%201.446-.042l.024.726c-.484.016-.968.03-1.451.043zm-4.361.042c-.485-.002-.971-.007-1.456-.015l.012-.726c.482.007.965.012%201.447.015l-.003.726zm1.455%200l-.003-.726c.481-.003.963-.008%201.444-.014l.011.726c-.484.007-.968.012-1.452.014z'%20/%3e%3cpath%20fill='%235246f7'%20d='M474.476%20102.01c-36.617%200-73.284%209.258-106.531%2017.653-14.934%203.77-30.426%208.223-45.409%2012.529-40.753%2011.714-82.893%2023.826-124.139%2025.692-19.259.871-44.284%209.065-68.657%2022.48-24.031%2013.228-44.636%2029.911-56.529%2045.768l-.026.03c-16.931%2018.128-29.202%2040.961-34.556%2064.294-5.839%2025.445-3.119%2049.499%207.865%2069.558%2012.388%2022.625%2033.865%2038.233%2054.634%2053.326%2012.87%209.354%2026.179%2019.026%2037.388%2030.351%2021.165%2021.384%2035.089%2048.879%2048.555%2075.469%203.189%206.298%206.487%2012.811%209.824%2019.124%2015.453%2029.246%2037.778%2064.844%2073.54%2080.662%2014.902%206.591%2030.403%209.199%2046.222%209.2%2030.621.001%2062.458-9.765%2093.603-19.317%204.933-1.513%2010.034-3.077%2014.992-4.557%20103.553-30.899%20214.502-37.097%20320.853-17.927%207.315%201.319%2014.745%202.781%2021.931%204.195%2024.78%204.876%2050.403%209.918%2075.994%2010.012.231.001.466.002.697.002%2050.71%200%2077.954-20.514%2089.706-32.78%2021.316-22.252%2031.657-55.911%2031.613-102.901-.011-10.074-.395-20.362-.767-30.311-.99-26.497-2.014-53.896%203.927-80.088%207.445-32.824%2025.418-62.331%2042.798-90.866l1.034-1.698c15.763-25.887%2035.381-58.103%2041.894-93.06%203.242-17.404%202.716-35.126-1.52-51.249-4.597-17.493-13.477-32.233-25.677-42.627-15.595-13.285-36.31-20.159-61.57-20.43-26.43-.266-51.369%206.75-67.636%2012.7-23.775%208.695-47.139%2019.542-69.735%2030.032-19.114%208.874-38.879%2018.05-58.818%2025.89-31.865%2012.53-68.45%2024.557-106.403%2024.557-9.497.001-19.072-.751-28.688-2.437-22.125-3.879-43.459-12.234-64.091-20.313-20.648-8.087-41.999-16.449-64.11-20.302-10.669-1.859-21.44-2.661-32.208-2.661M316.658%20628.876c-15.911%200-31.503-2.626-46.516-9.266-35.968-15.908-58.381-51.637-73.89-80.986-3.338-6.319-6.638-12.835-9.829-19.137-13.441-26.539-27.339-53.982-48.424-75.286-11.167-11.282-24.451-20.937-37.298-30.273-20.834-15.14-42.377-30.797-54.844-53.565-11.07-20.219-13.816-44.447-7.936-70.069%205.38-23.451%2017.71-46.396%2034.72-64.613%2011.955-15.934%2032.637-32.681%2056.749-45.954%2024.467-13.467%2049.607-21.693%2068.975-22.569%2041.159-1.862%2083.257-13.962%20123.971-25.664%2014.987-4.308%2030.485-8.763%2045.431-12.535%2043.094-10.881%2091.939-23.216%20139.041-15.003%2022.184%203.865%2043.569%2012.241%2064.251%2020.341%2020.598%208.066%2041.897%2016.407%2063.95%2020.274%2047.876%208.393%2094.957-6.453%20134.702-22.081%2019.918-7.832%2039.674-17.004%2058.777-25.873%2022.609-10.496%2045.988-21.349%2069.791-30.056%2016.325-5.97%2041.336-13.038%2067.894-12.743%2025.434.273%2046.306%207.205%2062.033%2020.603%2012.314%2010.491%2021.273%2025.358%2025.908%2042.995%204.264%2016.226%204.794%2034.058%201.531%2051.568-6.537%2035.087-26.193%2067.367-41.987%2093.304l-1.033%201.698c-17.351%2028.486-35.292%2057.94-42.712%2090.649-5.919%2026.099-4.897%2053.45-3.908%2079.9.373%209.955.757%2020.25.767%2030.336.045%2047.188-10.363%2081.011-31.815%20103.405-11.831%2012.35-39.257%2033.003-90.23%2033.004-.236%200-.464-.001-.7-.001-25.66-.096-51.317-5.144-76.132-10.026-7.182-1.413-14.61-2.875-21.919-4.193-106.238-19.151-217.071-12.958-320.516%2017.909-4.956%201.478-10.055%203.042-14.988%204.555-31.199%209.568-63.099%2019.352-93.814%2019.352'%20/%3e%3cpath%20fill='%235246f7'%20d='M404.435%20188.787c-25.601%200-65.272%205.209-130.827%2028.965-29.12%2010.552-57.262%2023.845-83.646%2039.509-25.61%2015.206-38.035%2031.518-36.928%2048.486%201.377%2021.089%2023.319%2033.968%2032.688%2038.525%204.858%202.363%209.976%204.487%2014.925%206.54%2011.345%204.708%2023.076%209.575%2032.513%2017.674%2017.183%2014.748%2024.154%2037.377%2030.896%2059.261.52%201.689%201.038%203.374%201.561%205.048%207.127%2022.875%2017.37%2047.721%2039.301%2058.558%207.806%203.858%2016.013%205.43%2024.404%205.431%2020.1.002%2041.268-9.02%2060.62-17.266%201.903-.811%203.792-1.615%205.664-2.406%2034.817-14.69%2071.758-24.373%20109.796-28.778%2038.035-4.407%2076.211-3.424%20113.466%202.918%2010.987%201.871%2022.084%204.238%2032.814%206.528%2019.813%204.228%2040.3%208.599%2060.818%209.99%2046.888%203.186%2074.442-11.374%2089.293-24.143%2018.368-15.792%2029.273-38.934%2038.896-59.351l73.998-157.02c8.856-18.792%2017.607-40.4%209.292-59.02-8.477-18.983-37.612-31.037-67.47-18.73-17.675%207.287-32.337%2020.348-46.516%2032.977-5.076%204.522-10.325%209.197-15.637%2013.541-29.503%2024.126-65.622%2040.934-104.452%2048.608-38.83%207.672-78.629%205.868-115.09-5.223-18.723-5.695-36.976-13.199-54.627-20.456-31.059-12.769-63.176-25.975-98.252-29.327-5.002-.478-10.766-.839-17.5-.839m-75.11%20308.728c-8.493%200-16.803-1.595-24.729-5.51-22.176-10.959-32.499-35.972-39.673-58.994-.522-1.675-1.041-3.36-1.562-5.051-6.711-21.785-13.65-44.312-30.673-58.922-9.35-8.025-21.027-12.87-32.319-17.555-4.959-2.057-10.087-4.185-14.965-6.558-9.484-4.613-31.693-17.662-33.095-39.131-1.126-17.263%2011.418-33.801%2037.282-49.157l.186.312-.186-.312c26.423-15.688%2054.607-29.001%2083.769-39.568%2028.187-10.214%2051.386-17.178%2073.01-21.915%2028.831-6.315%2053.572-8.36%2075.634-6.252%2035.184%203.364%2067.351%2016.589%2098.459%2029.379%2017.635%207.251%2035.872%2014.748%2054.562%2020.433%2036.348%2011.056%2076.025%2012.855%20114.738%205.205%2038.714-7.65%2074.723-24.406%20104.133-48.457%205.301-4.334%2010.543-9.005%2015.614-13.521%2014.224-12.671%2028.933-25.773%2046.722-33.106%2024.421-10.07%2057.738-4.793%2068.41%2019.105%208.441%2018.9-.374%2040.688-9.299%2059.626l-73.998%20157.019c-9.653%2020.483-20.593%2043.699-39.079%2059.593-13.541%2011.642-37.557%2024.759-76.974%2024.76-4.114.001-8.387-.141-12.842-.444-20.569-1.394-41.081-5.771-60.919-10.003-10.723-2.288-21.813-4.655-32.785-6.522-37.185-6.332-75.294-7.311-113.261-2.914-37.968%204.399-74.842%2014.062-109.597%2028.727-1.872.789-3.759%201.593-5.661%202.404-19.421%208.275-40.671%2017.328-60.902%2017.329'%20/%3e%3cpath%20fill='%235246f7'%20d='M816.895%20211.167c-.402-.018-.805-.027-1.208-.028l-.225.001-.007-.727h.233c.413%200%20.826.01%201.238.027l-.031.727zm-4.293.148l-.082-.722c.487-.055.976-.098%201.464-.129l.046.725c-.477.029-.953.072-1.428.126zm7.145.126c-.473-.07-.948-.128-1.423-.174l.07-.724c.488.048.975.107%201.46.18l-.107.718zm-9.971.351l-.159-.709c.48-.108.962-.202%201.444-.283l.121.716c-.47.079-.939.171-1.406.276zm12.783.217c-.464-.118-.93-.224-1.398-.32l.144-.712c.48.098.959.207%201.434.328l-.18.704zm-15.543.556l-.233-.687c.468-.159.936-.303%201.406-.435l.196.7c-.458.128-.915.268-1.369.422zm18.284.294c-.45-.164-.904-.317-1.361-.459l.215-.694c.469.145.934.302%201.396.471l-.25.682zm-20.949.762l-.302-.661c.449-.205.9-.397%201.353-.577l.268.675c-.441.176-.881.362-1.319.563zm23.599.353c-.434-.208-.871-.404-1.311-.589l.282-.67c.451.19.899.392%201.342.604l-.313.655zm-26.146.966l-.366-.627c.427-.249.856-.485%201.288-.71l.335.646c-.422.219-.841.449-1.257.691zm28.675.397c-.412-.248-.828-.485-1.249-.711l.345-.64c.43.232.857.475%201.279.729l-.375.622zm-31.084%201.165l-.423-.59c.402-.288.807-.564%201.214-.828l.396.608c-.399.259-.794.529-1.187.81zm33.474.427c-.387-.285-.779-.558-1.177-.823l.403-.605c.406.271.808.552%201.204.842l-.43.586zm-35.73%201.351l-.474-.55c.374-.323.752-.634%201.133-.934l.449.57c-.372.293-.741.598-1.108.914zm37.966.45c-.36-.317-.727-.626-1.098-.925l.456-.566c.38.306.754.622%201.123.947l-.481.544zm-40.06%201.517l-.519-.508c.345-.353.695-.695%201.049-1.027l.497.529c-.346.325-.689.66-1.027%201.006zm42.13.475c-.332-.349-.669-.688-1.014-1.019l.504-.524c.351.339.697.686%201.036%201.043l-.526.5zm-44.075%201.651l-.551-.474c.316-.367.64-.731.971-1.093l.537.488c-.327.359-.645.718-.957%201.079zm45.967.514c-.302-.376-.609-.743-.923-1.102l.547-.478c.321.367.635.741.942%201.126l-.566.454zm-47.791%201.719l-.574-.443c.296-.385.598-.765.908-1.146l.563.46c-.306.375-.605.751-.897%201.129zm49.495.595c-.27-.399-.546-.791-.829-1.174l.585-.432c.289.393.57.793.845%201.201l-.601.405zm-51.2%201.734l-.596-.414c.275-.398.558-.795.848-1.19l.585.429c-.285.391-.564.783-.837%201.175zm52.711.713c-.236-.42-.48-.832-.731-1.238l.619-.381c.255.414.504.835.745%201.263l-.633.356zm-54.302%201.696l-.614-.385c.258-.412.521-.821.791-1.229l.606.4c-.267.404-.527.809-.783%201.214zm55.616.864c-.204-.438-.415-.868-.632-1.292l.646-.333c.222.433.437.872.644%201.318l-.658.307zm-57.102%201.615l-.63-.363c.242-.42.488-.84.739-1.257l.622.373c-.247.415-.491.83-.731%201.247zm58.214%201.035l-.016-.047c-.164-.429-.335-.861-.515-1.288l.669-.281c.183.434.359.875.528%201.321l-.325.169-.341.126zm-59.615%201.496l-.641-.342c.228-.427.46-.855.695-1.282l.636.353c-.234.423-.464.847-.69%201.271zm60.536%201.235c-.137-.46-.282-.917-.436-1.373l.688-.232c.157.464.305.93.445%201.397l-.697.208zm-61.872%201.344l-.648-.328c.219-.433.44-.867.663-1.3l.646.334c-.223.431-.443.862-.661%201.294zm62.6%201.442c-.105-.469-.219-.934-.34-1.399l.702-.185c.124.474.239.948.346%201.425l-.708.159zm-63.89%201.16l-.653-.319c.213-.436.427-.873.643-1.308l.651.323c-.215.433-.428.868-.641%201.304zm64.429%201.67c-.075-.474-.157-.948-.246-1.421l.713-.134c.091.479.174.96.251%201.443l-.718.112zm-65.698.943l-.654-.317.634-1.307.654.316-.634%201.308zm66.055%201.918c-.045-.478-.097-.956-.156-1.433l.721-.089c.06.484.112.969.158%201.455l-.723.067zm-67.33.696l-.652-.322.639-1.302.653.318-.64%201.306zm67.511%202.183c-.017-.481-.039-.961-.069-1.443l.725-.043c.03.486.054.974.07%201.462l-.726.024zm-68.818.414l-.645-.332c.22-.43.439-.86.655-1.29l.649.326c-.217.433-.436.865-.659%201.296zm69.558%202.488l-.727-.017c.01-.401.015-.803.015-1.204l-.001-.238.726-.007.001.245c0%20.407-.005.814-.014%201.221zm-70.922.08l-.637-.35c.232-.423.461-.846.686-1.27l.641.341c-.226.426-.457.853-.69%201.279zm-1.452%202.533l-.623-.374c.249-.415.491-.831.73-1.248l.631.361c-.242.421-.486.841-.738%201.261zm72.226.308l-.724-.055c.037-.479.068-.96.092-1.44l.725.036c-.024.487-.055.973-.093%201.459zm-73.779%202.164l-.605-.4c.266-.404.526-.808.78-1.215l.616.386c-.257.411-.521.821-.791%201.229zm73.481.746l-.721-.092c.062-.478.117-.956.167-1.434l.722.073c-.05.485-.107.969-.168%201.453zm-75.152%201.652l-.584-.43c.286-.39.566-.781.84-1.174l.595.415c-.276.398-.56.794-.851%201.189zm74.709%201.237l-.715-.128c.085-.474.163-.95.237-1.424l.717.109c-.074.482-.153.963-.239%201.443zm-76.504%201.068l-.561-.462c.308-.373.609-.748.902-1.125l.574.447c-.299.382-.604.762-.915%201.14zm75.927%201.796l-.71-.16c.107-.469.207-.94.302-1.412l.713.143c-.097.478-.199.955-.305%201.429zm-77.854.405l-.532-.494c.329-.355.651-.712.965-1.071l.547.479c-.319.364-.645.726-.98%201.086zm-2.053%202.083l-.502-.525c.351-.336.693-.673%201.028-1.011l.516.51c-.339.343-.686.686-1.042%201.026zm79.199.348l-.701-.191c.128-.465.249-.931.366-1.399l.705.176c-.118.473-.241.944-.37%201.414zm-81.371%201.608l-.469-.553c.368-.314.729-.631%201.083-.949l.487.54c-.359.323-.726.644-1.101.962zm80.544%201.193l-.693-.22c.147-.459.289-.919.425-1.381l.697.205c-.138.468-.281.933-.429%201.396zm-82.823.638l-.442-.576.469-.363c.227-.176.45-.352.67-.528l.454.567c-.223.179-.448.357-.677.535l-.474.365zm-2.317%201.759l-.435-.582c.387-.289.772-.58%201.157-.872l.44.579c-.387.293-.774.584-1.162.875zm84.196.368l-.683-.25c.166-.452.326-.907.482-1.363l.687.235c-.158.461-.32.92-.486%201.378zm-86.538%201.358l-.427-.588c.391-.284.781-.569%201.17-.856l.431.585c-.39.287-.782.574-1.174.859zm85.484%201.365l-.673-.276c.183-.446.362-.893.536-1.343l.677.262c-.175.454-.356.906-.54%201.357zm-87.851.327l-.419-.593c.395-.278.789-.558%201.182-.839l.423.59c-.395.282-.79.563-1.186.842zm-2.39%201.66l-.411-.598c.4-.274.798-.548%201.195-.824l.414.597c-.399.276-.798.552-1.198.825zm89.082.69l-.66-.299c.198-.439.393-.88.585-1.323l.667.289c-.194.447-.392.892-.592%201.333zm-91.497.937l-.401-.605c.403-.267.804-.536%201.205-.806l.405.603c-.401.27-.804.54-1.209.808zm-2.434%201.593l-.393-.611c.406-.261.812-.524%201.216-.788l.398.607c-.406.266-.813.53-1.221.792zm92.682.103l-.651-.321c.214-.432.425-.866.631-1.302l.656.312c-.209.439-.421.876-.636%201.311zm-95.139%201.456l-.384-.616c.409-.256.819-.513%201.226-.772l.39.613c-.41.26-.821.519-1.232.775zm93.801%201.136l-.64-.344c.228-.424.454-.851.674-1.279l.646.333c-.224.433-.45.863-.68%201.29zm-96.279.389l-.376-.621c.414-.25.826-.502%201.237-.756l.382.619c-.414.254-.828.507-1.243.758zm-2.499%201.491l-.368-.626c.418-.244.833-.491%201.247-.739l.373.625c-.416.248-.833.495-1.252.74zm97.353.666l-.627-.366c.242-.416.481-.834.717-1.255l.634.354c-.239.424-.48.847-.724%201.267zm-388.81.016l-.003-.726.964-.002.493.001-.003.726-.49-.001-.961.002zm4.352.027c-.484-.008-.968-.015-1.451-.019l.008-.727c.485.005.971.011%201.456.02l-.013.726zm-7.253.01l-.015-.726c.485-.01.971-.018%201.456-.025l.01.727c-.484.006-.967.014-1.451.024zm10.155.061c-.484-.015-.968-.029-1.452-.04l.019-.727c.485.012.971.026%201.456.041l-.023.726zm-13.055.022l-.027-.727c.486-.018.971-.033%201.456-.047l.02.726c-.483.014-.966.029-1.449.048zm15.955.087c-.483-.021-.967-.041-1.45-.059l.028-.726c.485.018.97.038%201.455.061l-.033.724zm-18.853.04l-.038-.725c.485-.026.969-.049%201.455-.071l.032.726c-.483.021-.966.044-1.449.07zm21.752.11c-.483-.028-.965-.054-1.449-.079l.037-.725c.485.025.97.051%201.454.079l-.042.725zm-24.648.068l-.05-.725c.484-.033.968-.065%201.454-.095l.043.725c-.482.03-.965.062-1.447.095zm27.545.118c-.483-.034-.966-.067-1.448-.098l.046-.725c.484.031.968.064%201.453.098l-.051.725zm-30.436.109l-.064-.723c.484-.043.968-.083%201.452-.12l.057.723c-.483.038-.964.078-1.445.12zm33.33.113l-1.447-.116.056-.723%201.451.115-.06.724zm270.094.01l-.36-.631c.421-.239.84-.48%201.259-.722l.363.629c-.42.243-.84.485-1.262.724zm-306.312.155l-.075-.722c.483-.05.966-.1%201.449-.147l.069.724c-.481.046-.962.095-1.443.145zm39.11.092l-1.446-.133.064-.724%201.45.133-.068.724zm-41.99.239l-.089-.72c.481-.06.963-.117%201.446-.173l.083.722c-.48.054-.96.112-1.44.171zm44.878.049c-.481-.051-.962-.1-1.444-.148l.073-.723c.483.049.965.098%201.448.149l-.077.722zm2.886.322l-1.442-.165.082-.722%201.444.165-.084.722zm-50.638.015l-.103-.719c.481-.069.961-.135%201.442-.2l.097.719c-.479.065-.958.132-1.436.2zm53.519.336l-1.441-.181.089-.72%201.443.18-.091.721zm-56.384.106l-.117-.717c.479-.079.958-.155%201.438-.229l.111.718c-.478.074-.955.148-1.432.228zm312.392.109l-.35-.637c.424-.232.846-.467%201.267-.704l.356.633c-.424.238-.848.474-1.273.708zm-253.131.166l-1.439-.194.095-.721%201.442.195-.098.72zm354.033.115l-.615-.385c.255-.409.508-.82.759-1.232l.621.376c-.252.416-.507.83-.765%201.241zm-416.15.107l-.132-.714c.478-.088.955-.173%201.433-.257l.125.715c-.476.083-.951.169-1.426.256zm64.991.187l-1.437-.208.102-.719%201.44.208-.105.719zm-67.835.37l-.146-.712c.475-.097.951-.193%201.428-.286l.138.712c-.473.093-.947.189-1.42.286zm70.704.066l-1.435-.222.11-.718%201.437.221-.112.719zm244.831.377l-.342-.641c.427-.227.852-.456%201.277-.687l.347.638c-.427.231-.854.462-1.282.69zm-241.965.083l-1.433-.235.117-.716%201.434.234-.118.717zm-76.402.091l-.162-.708c.475-.109.947-.215%201.422-.318l.154.71c-.472.103-.943.208-1.414.316zm79.263.394l-1.43-.245.122-.717%201.433.246-.125.716zm-82.079.281l-.178-.704c.471-.119.943-.235%201.415-.348l.169.707c-.469.111-.939.227-1.406.345zm84.937.226l-1.427-.257.126-.715%201.432.257-.131.715zm338.121.255l-.603-.405c.269-.399.533-.799.795-1.203l.609.396c-.264.407-.531.811-.801%201.212zm-104.452.023l-.333-.645c.43-.223.859-.446%201.286-.67l.337.643c-.428.225-.858.449-1.29.672zm-321.409.235l-.191-.701c.467-.128.937-.255%201.406-.378l.185.702c-.467.124-.933.249-1.4.377zm90.594.017l-1.426-.267.133-.714%201.428.267-.135.714zm2.849.551l-1.424-.278.138-.713%201.426.279-.14.712zm-96.225.232l-.209-.695c.466-.14.932-.276%201.398-.411l.201.698c-.463.133-.927.27-1.39.408zm321.598.284l-.326-.65%201.296-.653.329.649-1.299.654zm-222.527.056l-1.423-.288.143-.713%201.424.289-.144.712zm-101.833.524l-.226-.691c.462-.15.924-.298%201.388-.443l.216.694c-.46.144-.919.29-1.378.44zm104.673.065l-1.42-.297.146-.711%201.424.297-.15.711zm325.069.401l-.59-.425c.282-.39.56-.783.834-1.178l.597.415c-.277.398-.558.794-.841%201.188zm-322.232.207l-1.419-.307.155-.71%201.419.307-.155.71zm214.238.031l-.316-.655c.434-.209.869-.422%201.303-.635l.321.653c-.436.213-.872.425-1.308.637zm-324.492.223l-.241-.685c.458-.162.917-.32%201.377-.475l.232.688c-.457.154-.913.311-1.368.472zm113.091.368l-1.417-.314.156-.709%201.419.313-.158.71zm-115.811.623l-.257-.68c.455-.171.91-.34%201.366-.507l.249.682c-.454.166-.907.335-1.358.505zm118.648.013l-1.417-.319.158-.71%201.418.32-.159.709zm205.935.021l-.308-.658c.438-.204.876-.411%201.313-.619l.311.656c-.438.209-.877.415-1.316.621zm-203.104.626l-1.416-.326.162-.707%201.417.325-.163.708zm311.99.224l-.576-.442c.293-.383.584-.767.871-1.154l.583.435c-.29.389-.582.776-.878%201.161zm-436.164.171l-.272-.674c.45-.182.901-.361%201.351-.538l.265.677c-.449.175-.896.353-1.344.535zm324.632.193l-.297-.662c.441-.198.881-.399%201.32-.6l.304.659c-.443.203-.884.404-1.327.603zm-197.627.068l-1.415-.329.164-.708%201.417.33-.166.707zm2.828.668l-1.414-.335.167-.707%201.415.335-.168.707zm-132.505.181l-.286-.668c.446-.19.893-.379%201.34-.565l.279.671c-.446.185-.889.372-1.333.562zm324.643.26l-.289-.665c.444-.193.887-.388%201.328-.582l.294.663c-.443.197-.887.391-1.333.584zm-189.311.233l-1.413-.339.168-.706%201.414.338-.169.707zm301.695.511l-.564-.46c.306-.374.608-.749.907-1.127l.57.451c-.301.381-.606.759-.913%201.136zm-439.682.157l-.296-.664c.443-.197.887-.394%201.33-.587l.291.665c-.442.193-.883.389-1.325.586zm140.813.011l-1.413-.341.17-.706%201.413.34-.17.707zm183.809.231l-.282-.67c.446-.187.892-.375%201.337-.566l.285.669c-.446.19-.893.38-1.34.567zm-180.985.455l-1.412-.343.171-.707%201.412.343-.171.707zm-146.274.505l-.304-.659c.44-.204.879-.406%201.32-.608l.302.661c-.439.2-.879.403-1.318.606zm324.567.148l-.271-.674c.449-.181.895-.364%201.342-.547l.277.671c-.448.185-.898.368-1.348.55zm-175.47.034l-1.411-.345.172-.705%201.412.345-.173.705zm291.345.69l-.549-.475c.316-.364.629-.731.94-1.101l.556.468c-.314.372-.629.741-.947%201.108zm-288.522%200l-1.412-.345.173-.705%201.412.345-.173.705zm169.941.347l-.264-.677c.451-.176.902-.352%201.352-.53l.266.675c-.451.178-.902.355-1.354.532zm-324.486.013l-.312-.655c.438-.209.876-.416%201.314-.623l.31.658c-.438.205-.875.412-1.312.62zm157.368.331l-1.412-.345.173-.705%201.412.345-.173.705zm164.397.69l-.254-.68c.453-.169.906-.34%201.358-.511l.258.678c-.454.173-.908.344-1.362.513zm-161.575.002l-1.41-.345.171-.705%201.412.345-.173.705zm-162.804.236l-.318-.652%201.309-.634.315.654-1.306.632zm165.629.453l-1.412-.345.172-.705%201.411.343-.171.707zm278.112.107l-.535-.491c.326-.355.65-.714.971-1.074l.542.483c-.323.363-.649.724-.978%201.082zm-122.095.201l-.245-.684c.455-.164.91-.327%201.364-.493l.25.682c-.456.166-.912.332-1.369.495zm-153.195.378l-1.412-.343.172-.706%201.412.342-.172.707zm-171.057.138l-.322-.65%201.305-.643.32.653-1.303.64zm321.505.446l-.236-.687c.458-.157.915-.315%201.37-.475l.241.685c-.458.161-.916.32-1.375.477zm-147.622.095l-1.412-.339.17-.706%201.411.339-.169.706zm2.827.677l-1.414-.337.169-.706%201.412.336-.167.707zm-179.315.072l-.324-.652%201.303-.645.323.651-1.302.646zm321.35.082l-.227-.689c.46-.152.918-.304%201.376-.457l.232.687c-.46.155-.92.308-1.381.459zm125.601.037l-.522-.505c.335-.347.669-.697%201-1.05l.529.499c-.332.353-.669.706-1.007%201.056zm-264.807.476l-1.415-.333.167-.707%201.414.333-.166.707zm136.435.377l-.219-.693c.462-.145.923-.291%201.383-.438l.223.69c-.462.149-.924.295-1.387.441zm-133.605.283l-1.416-.329.165-.708%201.414.329-.163.708zm-187.58.036l-.322-.651%201.302-.646.324.651-1.304.646zm318.401.533l-.207-.696c.462-.138.925-.278%201.388-.42l.212.695c-.464.142-.928.282-1.393.421zm-127.988.08l-1.417-.324.162-.707%201.416.323-.161.708zm257.087.288l-.509-.518c.345-.339.687-.682%201.029-1.024l.515.512c-.343.345-.688.689-1.035%201.03zm-254.252.35l-1.418-.318.159-.709%201.417.317-.158.71zm-195.856.036l-.32-.652%201.303-.642.322.651-1.305.643zm318.214.061l-.199-.697c.465-.133.93-.268%201.395-.403l.203.698c-.467.135-.932.27-1.399.402zm-119.519.528l-1.421-.312.158-.708%201.417.31-.154.71zm116.713.251l-.189-.701c.466-.127.933-.254%201.399-.383l.195.699c-.468.13-.936.258-1.405.385zm-113.87.361l-1.422-.303.152-.711%201.42.303-.15.711zm-204.154.077l-.318-.652%201.308-.637.318.652-1.308.637zm315.209.302l-.178-.703c.468-.12.936-.242%201.403-.364l.185.701c-.469.125-.94.247-1.41.366zm135.406.055l-.497-.53c.353-.331.705-.663%201.054-.998l.503.525c-.352.335-.705.67-1.06%201.003zm-243.617.162l-1.423-.296.149-.711%201.421.297-.147.71zm105.387.487l-.17-.706c.47-.113.94-.228%201.408-.345l.177.704c-.472.118-.943.233-1.415.347zm-102.538.092l-1.426-.288.145-.712%201.424.288-.143.712zm-212.475.163l-.31-.658%201.311-.625.314.655-1.315.628zm215.327.398l-1.427-.279.14-.712%201.425.277-.138.714zm96.851.011l-.161-.708c.472-.107.942-.216%201.414-.326l.165.707c-.472.111-.945.22-1.418.327zm-93.995.53l-1.429-.268.135-.714%201.427.268-.133.714zm91.152.099l-.152-.71c.473-.101.946-.204%201.418-.308l.156.709c-.473.104-.948.207-1.422.309zm141.749.028l-.484-.542c.363-.323.722-.647%201.08-.973l.489.536c-.36.329-.721.655-1.085.979zm-453.725.166l-.304-.659c.44-.203.88-.406%201.319-.612l.307.658c-.44.206-.881.411-1.322.613zm223.684.227l-1.43-.257.13-.715%201.428.257-.128.715zm85.441.168l-.142-.712c.474-.095.948-.191%201.422-.289l.146.711c-.475.098-.951.195-1.426.29zm-82.576.33l-1.433-.246.125-.715%201.43.245-.122.716zm79.718.222l-.134-.714c.476-.089.951-.179%201.426-.271l.138.714c-.477.092-.953.182-1.43.271zm-76.849.252l-1.435-.234.118-.716%201.432.233-.115.717zm-232.078%200l-.293-.664c.443-.195.884-.393%201.326-.592l.299.662c-.444.2-.887.399-1.332.594zm306.06.26l-.124-.717c.477-.081.954-.164%201.43-.249l.127.714c-.477.085-.955.169-1.433.252zm-71.108.187l-1.438-.22.113-.718%201.434.22-.109.718zm219.229.107l-.471-.553c.37-.314.736-.63%201.101-.948l.478.547c-.368.32-.737.639-1.108.954zm-150.995.179l-.112-.717c.478-.076.955-.152%201.433-.231l.117.716c-.478.079-.958.157-1.438.232zm-65.356.137l-1.439-.208.105-.719%201.436.207-.102.72zm-240.509.289l-.282-.67c.446-.187.891-.378%201.336-.57l.289.667c-.448.194-.895.384-1.343.573zm302.987.009l-.103-.72c.478-.068.957-.138%201.434-.211l.109.718c-.479.072-.959.144-1.44.213zm-59.596.095l-1.442-.194.098-.719%201.439.192-.095.721zm56.711.3l-.094-.721c.48-.062.959-.125%201.438-.191l.099.719c-.481.066-.962.131-1.443.193zm-53.824.064l-1.443-.178.089-.721%201.441.177-.087.722zm50.933.293l-.083-.722c.48-.055.96-.113%201.44-.173l.089.721c-.481.06-.964.117-1.446.174zm-48.04.039c-.483-.053-.966-.107-1.448-.163l.084-.721c.48.055.961.109%201.442.161l-.078.723zm45.146.277l-.074-.722c.482-.049.963-.1%201.444-.153l.078.722c-.482.053-.965.104-1.448.153zm-42.252.022c-.484-.048-.966-.095-1.448-.146l.074-.722c.481.051.963.098%201.444.145l-.07.723zm-254.765.006l-.268-.675c.449-.177.898-.358%201.346-.543l.275.672c-.451.185-.901.367-1.353.546zm457.313.161l-.458-.562c.376-.307.75-.616%201.123-.925l.464.559c-.374.311-.751.621-1.129.928zm-163.195.088l-.064-.724c.482-.042.964-.087%201.445-.133l.069.724c-.483.045-.966.091-1.45.133zm-36.454.011c-.484-.041-.967-.083-1.45-.128l.067-.724c.481.045.963.087%201.444.129l-.061.723zm33.554.225l-.055-.725c.482-.035.964-.073%201.446-.112l.059.723c-.484.04-.967.078-1.45.114zm-30.652.005l-1.451-.11.057-.723%201.448.109-.054.724zm27.746.192l-.045-.725c.483-.029.966-.061%201.449-.093l.048.725c-.484.032-.969.063-1.452.093zm-24.841.002c-.484-.029-.969-.06-1.453-.093l.049-.724c.483.032.966.063%201.449.092l-.045.725zm21.933.151l-.034-.724c.483-.023.966-.048%201.449-.073l.039.725c-.485.025-.969.05-1.454.072zm-18.914.01l-.115-.006c-.48-.023-.965-.047-1.45-.073l.04-.725c.483.026.966.05%201.449.073l.104.005-.028.726zm16.005.107l-.024-.727c.483-.015.966-.033%201.45-.052l.028.726c-.485.019-.97.037-1.454.053zm-13.099.006c-.486-.016-.97-.032-1.455-.051l.027-.727c.484.019.967.036%201.451.052l-.023.726zm10.189.068l-.015-.727c.483-.009.967-.02%201.451-.031l.019.726c-.485.011-.971.022-1.455.032zm-7.279.003c-.486-.008-.971-.018-1.456-.031l.019-.726c.483.012.966.022%201.45.03l-.013.727zm-275.033.018l-.253-.681c.454-.168.907-.339%201.359-.512l.26.678c-.454.174-.91.345-1.366.515zm279.399.011l-.003-.727c.484-.001.967-.005%201.451-.01l.009.726c-.486.006-.971.009-1.457.011zm-1.456%200c-.485%200-.97-.003-1.456-.008l.008-.727c.483.006.967.008%201.451.009l-.003.726zm179.812.926l-.447-.572c.382-.298.762-.598%201.141-.9l.453.567c-.381.303-.763.605-1.147.905zm-460.508.039l-.233-.689c.457-.155.914-.313%201.37-.475l.243.685c-.459.162-.919.322-1.38.479zm-2.778.896l-.213-.695c.462-.141.922-.286%201.382-.434l.223.691c-.463.15-.928.296-1.392.438zm-2.808.807l-.189-.702c.467-.125.931-.254%201.395-.388l.2.698c-.467.135-.936.266-1.406.392zm463.773.035l-.435-.582c.388-.29.774-.583%201.159-.878l.441.578c-.386.296-.775.59-1.165.882zm-466.605.67l-.162-.708c.469-.108.938-.22%201.405-.337l.177.705c-.473.118-.945.231-1.42.34zm-36.231.558c-.484-.012-.966-.02-1.448-.024l.006-.726c.485.004.971.012%201.459.023l-.017.727zm-4.339.016l-.025-.727c.484-.016.971-.028%201.46-.035l.01.727c-.484.006-.966.018-1.445.035zm37.715.022l-.135-.713c.474-.089.946-.183%201.416-.281l.149.711c-.476.099-.953.194-1.43.283zm-30.482.069c-.483-.024-.966-.044-1.448-.063l.029-.726c.483.018.968.04%201.455.064l-.036.725zm-10.114.087l-.066-.723c.483-.044.971-.081%201.46-.111l.045.725c-.483.03-.962.066-1.439.109zm13.009.083c-.483-.032-.965-.062-1.448-.091l.043-.725c.484.029.969.059%201.454.091l-.049.725zm2.898.204l-1.448-.104.051-.725%201.45.104-.053.725zm491.793.022l-.425-.589c.393-.283.785-.569%201.175-.856l.432.584c-.393.289-.787.576-1.182.861zm-469.979.012l-.105-.719c.477-.069.952-.143%201.425-.221l.119.717c-.478.079-.958.153-1.439.223zm-40.579.033l-.115-.717c.481-.076.964-.145%201.451-.205l.089.72c-.478.059-.953.126-1.425.202zm21.663.147l-1.45-.107.054-.725%201.448.107-.052.725zm16.019.167l-.07-.724c.479-.045.958-.098%201.435-.155l.087.72c-.483.059-.967.112-1.452.159zm-13.116.03l-1.451-.096.048-.724%201.448.095-.045.725zm2.908.157c-.483-.022-.967-.046-1.454-.072l.039-.725c.483.026.966.051%201.448.072l-.033.725zm7.296.026l-.036-.725c.481-.024.96-.053%201.438-.089l.055.725c-.484.036-.969.065-1.457.089zm-37.586.048l-.176-.706c.473-.118.951-.226%201.433-.324l.144.713c-.471.095-.938.2-1.401.317zm33.206.014c-.485-.007-.971-.018-1.459-.033l.023-.727c.484.016.966.026%201.447.034l-.011.726zm1.459.011l-.003-.726c.483-.003.965-.008%201.445-.021l.019.727c-.486.012-.972.018-1.461.02zm-37.409.805l-.246-.684c.461-.165.926-.319%201.397-.461l.21.695c-.459.139-.913.288-1.361.45zm513.733.239l-.414-.597c.399-.276.795-.555%201.191-.835l.42.593c-.398.282-.797.561-1.197.839zm-516.369.881l-.322-.65c.441-.219.888-.424%201.34-.616l.283.668c-.438.187-.871.386-1.301.598zm513.956.765l-.404-.603c.403-.271.805-.542%201.205-.815l.409.6c-.402.274-.805.547-1.21.818zm-516.43.662l-.402-.606c.413-.273.831-.531%201.256-.776l.362.63c-.411.236-.817.488-1.216.752zm513.989.946l-.394-.61c.408-.263.814-.529%201.218-.796l.4.607c-.407.267-.814.534-1.224.799zm-516.265.78l-.475-.549c.376-.325.758-.634%201.146-.929l.439.579c-.376.285-.747.585-1.11.899zm513.802.789l-.386-.616c.411-.257.821-.517%201.231-.777l.39.613c-.411.262-.823.521-1.235.78zm-515.827%201.219l-.547-.479c.321-.368.661-.73%201.011-1.077l.513.516c-.338.335-.667.684-.977%201.04zm513.342.314l-.378-.621c.416-.252.829-.505%201.241-.759l.382.618c-.414.255-.829.509-1.245.762zm-2.506%201.497l-.369-.626c.418-.247.835-.493%201.252-.742l.372.624c-.417.249-.836.497-1.255.744zm-512.548.468l-.611-.391c.266-.416.55-.825.843-1.215l.582.435c-.283.377-.557.771-.814%201.171zm510.024.997l-.36-.629c.421-.241.84-.483%201.26-.727l.364.628c-.42.244-.842.487-1.264.728zm-2.54%201.435l-.353-.634c.424-.236.847-.474%201.268-.712l.357.633c-.423.239-.847.477-1.272.713zm-508.845.074l-.661-.301c.204-.449.427-.895.658-1.322l.639.346c-.225.413-.438.843-.636%201.277zm506.29%201.331l-.346-.638c.427-.232.852-.463%201.277-.697l.349.637c-.426.234-.852.467-1.28.698zm-507.287%201.343l-.697-.207c.139-.468.298-.939.469-1.401l.681.254c-.167.446-.319.903-.453%201.354zm504.717.033l-.338-.643c.428-.226.856-.454%201.282-.682l.344.64c-.428.23-.858.457-1.288.685zm-2.58%201.351l-.334-.645%201.29-.67.336.644-1.292.671zm-2.593%201.326l-.328-.648%201.295-.659.33.646-1.297.661zm-500.184.074l-.716-.117c.079-.487.175-.969.284-1.447l.708.161c-.107.464-.199.933-.276%201.403zm497.581%201.229l-.321-.651%201.299-.647.325.65-1.303.648zm-2.611%201.282l-.318-.653%201.305-.637.319.652-1.306.638zm-495.27.334l-.725-.034c.023-.492.061-.982.111-1.468l.722.074c-.049.475-.085.95-.108%201.428zm492.65.928l-.313-.655%201.309-.627.315.654-1.311.628zm-2.624%201.245l-.309-.657%201.312-.619.31.657-1.313.619zm-490.735.733c-.03-.491-.045-.981-.048-1.469l.727-.004c.003.475.018.953.045%201.431l-.724.042zm488.102.496l-.305-.66%201.314-.611.308.658-1.317.613zm-2.636%201.212l-.302-.662%201.317-.603.304.66-1.319.605zm-2.642%201.201l-.299-.663%201.32-.597.301.661-1.322.599zm-482.509.012c-.077-.485-.141-.971-.193-1.456l.722-.079c.051.474.114.947.189%201.421l-.718.114zm479.865%201.175l-.298-.662%201.322-.593.298.662-1.322.593zm-2.648%201.177l-.293-.663%201.322-.588.295.664-1.324.587zm-476.625.523c-.121-.475-.231-.952-.329-1.43l.711-.146c.096.466.204.932.322%201.397l-.704.179zm473.972.65l-.294-.666%201.33-.586.294.665-1.33.587zm-2.663%201.167l-.291-.665%201.33-.583.29.665-1.329.583zm-470.459.994c-.162-.462-.314-.929-.456-1.396l.695-.21c.139.458.288.913.447%201.365l-.686.241zm467.798.173l-.293-.665%201.331-.583.292.665-1.33.583zm-2.661%201.166l-.293-.665%201.331-.583.292.665-1.33.583zm-2.662%201.167l-.292-.665%201.331-.583.291.665-1.33.583zm-461.383.219c-.201-.448-.393-.898-.575-1.351l.674-.271c.178.444.366.885.563%201.322l-.662.3zm120.704.919c-.446-.007-.892-.01-1.337-.01h-.112v-.726h.112c.45%200%20.899.003%201.348.01l-.011.726zm338.018.029l-.293-.666%201.332-.582.291.665-1.33.583zm-342.358.016l-.027-.726c.486-.018.973-.031%201.459-.041l.014.727c-.482.009-.964.022-1.446.04zm7.233.053c-.482-.025-.964-.045-1.446-.061l.024-.727c.487.016.973.037%201.459.063l-.037.725zm-10.122.106l-.053-.724c.486-.035.971-.067%201.457-.093l.04.725c-.482.026-.962.058-1.444.092zm13.009.088c-.481-.04-.961-.077-1.444-.109l.05-.725c.485.032.97.07%201.455.11l-.061.724zm-15.889.178l-.08-.722c.485-.053.969-.103%201.452-.148l.067.724c-.479.045-.959.092-1.439.146zm18.767.11c-.48-.056-.959-.108-1.438-.156l.073-.722c.483.048.966.1%201.449.156l-.084.722zm-21.635.261l-.107-.717c.465-.07.929-.134%201.396-.196l.097.354.046.36c-.51.067-.972.132-1.432.199zm24.502.117c-.476-.07-.955-.138-1.432-.2l.095-.721c.482.064.963.132%201.443.203l-.106.718zm323.83.237l-.292-.665%201.332-.583.291.665-1.331.583zm-351.183.124l-.132-.714c.478-.089.957-.173%201.436-.253l.12.716c-.475.079-.95.163-1.424.251zm30.208.105c-.475-.084-.95-.165-1.426-.243l.118-.717c.479.078.956.16%201.434.245l-.126.715zm-133.762.278c-.239-.427-.469-.86-.689-1.296l.648-.327c.216.427.44.85.675%201.269l-.634.354zm100.717.188l-.154-.709c.474-.104.95-.203%201.425-.3l.145.712c-.472.095-.944.195-1.416.297zm35.882.08c-.472-.097-.944-.192-1.417-.283l.137-.713c.476.092.952.187%201.427.286l-.147.71zm315.477.392l-.292-.666%201.331-.583.291.665-1.33.584zm-354.177.186l-.175-.706c.472-.117.944-.23%201.417-.34l.166.706c-.47.111-.94.223-1.408.34zm41.523.048c-.47-.11-.939-.218-1.41-.322l.158-.709c.473.105.946.213%201.419.325l-.167.706zm-44.325.686l-.193-.701c.469-.129.939-.255%201.408-.378l.184.703c-.467.122-.933.247-1.399.376zm47.13.013c-.466-.122-.932-.242-1.4-.358l.176-.705c.47.118.94.238%201.409.361l-.185.702zm307.188.233l-.292-.665%201.331-.583.291.665-1.33.583zm-304.402.537c-.464-.135-.927-.265-1.39-.393l.192-.701c.467.129.934.261%201.4.396l-.202.698zm-52.704.016l-.207-.697c.466-.138.931-.275%201.398-.409l.201.698c-.464.134-.928.27-1.392.408zm-90.765.119c-.275-.404-.543-.815-.8-1.232l.618-.381c.252.406.512.809.783%201.205l-.601.408zm445.209.495l-.292-.666%201.331-.583.291.665-1.33.584zm-298.971.205c-.46-.144-.921-.286-1.382-.426l.21-.695c.464.14.926.283%201.389.427l-.217.694zm-58.244.036l-.22-.692c.463-.146.926-.292%201.389-.436l.216.693c-.462.144-.924.289-1.385.435zm60.993.861c-.456-.155-.914-.307-1.372-.456l.226-.691c.46.151.921.304%201.38.459l-.234.688zm-63.751.041l-.231-.688c.461-.155.921-.307%201.383-.458l.225.69c-.459.15-.918.303-1.377.456zm357.311.024l-.292-.666%201.331-.583.291.666-1.33.583zm-440.789.693c-.31-.379-.613-.764-.906-1.158l.582-.434c.287.384.582.761.886%201.13l-.562.462zm149.96.197c-.454-.163-.908-.324-1.363-.484l.24-.685c.457.159.914.322%201.37.487l-.247.682zm-69.229.025l-.239-.686%201.375-.474.236.686-1.372.474zm357.397.25l-.292-.665%201.331-.583.291.665-1.33.583zm-360.136.714l-.244-.683%201.371-.487.243.685-1.37.485zm74.679.022c-.452-.173-.903-.344-1.355-.512l.255-.681c.453.17.906.341%201.359.514l-.259.679zm282.795.431l-.292-.665%201.332-.583.29.665-1.33.583zm-360.206.532l-.248-.683%201.368-.494.245.683-1.365.494zm-73.292.013c-.344-.347-.681-.703-1.009-1.068l.539-.487c.321.356.649.705.986%201.043l-.516.512zm153.396.085c-.448-.181-.896-.36-1.345-.538l.267-.675c.45.178.9.358%201.35.539l-.272.674zm277.44.536l-.292-.665%201.332-.583.29.665-1.33.583zm-360.276.357l-.249-.682%201.366-.497.248.682-1.365.497zm85.51.216c-.445-.189-.89-.376-1.335-.56l.278-.671c.447.186.895.372%201.341.563l-.284.668zm272.105.594l-.292-.665%201.332-.583.29.665-1.33.583zm-360.348.184l-.247-.684%201.364-.495.25.683-1.367.496zm-65.656.014c-.378-.312-.749-.634-1.111-.967l.491-.535c.352.323.712.637%201.082.941l-.462.561zm156.555.36c-.442-.196-.883-.39-1.326-.581l.29-.667c.443.193.886.387%201.331.585l-.295.663zm-93.635.608l-.244-.684%201.366-.489.246.684-1.368.489zm360.423.001l-.292-.665%201.331-.583.291.665-1.33.583zm-264.149.586c-.438-.202-.878-.403-1.317-.603l.299-.661c.441.2.882.402%201.322.605l-.304.659zm-156.831.201c-.408-.271-.811-.554-1.205-.847l.433-.583c.384.286.775.56%201.173.824l-.401.606zm57.813.178l-.238-.687%201.37-.479.242.686-1.374.48zm360.506.201l-.292-.665%201.331-.583.291.665-1.33.583zm-258.865.654c-.436-.209-.872-.417-1.309-.622l.309-.657c.438.206.876.414%201.313.623l-.313.656zm-104.395.083l-.23-.689c.459-.153.916-.307%201.373-.464l.236.687c-.459.157-.919.312-1.379.466zm-52.537.392c-.43-.234-.855-.476-1.275-.727l.372-.624c.413.246.83.484%201.25.712l-.347.639zm413.135.038l-.292-.665%201.331-.583.291.665-1.33.583zm-363.365.471l-.219-.692c.46-.146.92-.294%201.379-.444l.226.691c-.462.15-.924.299-1.386.445zm109.77.285l-1.302-.639.318-.653%201.305.641-.321.651zm250.933.411l-.292-.666%201.332-.583.29.665-1.33.584zm-407.849.101c-.444-.201-.886-.411-1.324-.629l.323-.65c.43.214.863.42%201.3.617l-.299.662zm44.362.059l-.206-.696.351-.106c.346-.103.691-.208%201.036-.314l.214.694c-.347.107-.694.212-1.04.315l-.355.107zm115.145.731c-.431-.22-.863-.438-1.294-.655l.326-.649c.434.218.866.436%201.299.657l-.331.647zm-117.953.062l-.186-.702c.466-.125.931-.253%201.394-.384l.199.698c-.468.133-.935.262-1.407.388zm363.634.213l-.293-.665%201.332-.584.291.666-1.33.583zm-402.474.045c-.458-.168-.914-.345-1.367-.53l.275-.673c.445.183.892.356%201.342.521l-.25.682zm36.015.459l-.169-.707c.47-.111.938-.228%201.407-.346l.178.704c-.47.12-.943.236-1.416.349zm-33.23.455c-.47-.137-.936-.281-1.401-.434l.227-.69c.455.151.914.292%201.375.426l-.201.698zm156.586.099c-.429-.224-.858-.448-1.288-.669l.334-.646c.431.224.862.447%201.292.672l-.338.643zm-126.203.083l-.147-.711c.472-.098.944-.2%201.415-.305l.159.707c-.474.108-.95.21-1.427.309zm366.645.026l-.293-.666%201.332-.583.291.665-1.33.584zm-394.193.517c-.476-.106-.952-.22-1.424-.34l.18-.704c.466.12.932.23%201.402.334l-.158.71zm24.683.008l-.124-.716c.475-.083.949-.17%201.423-.262l.137.713c-.477.092-.956.181-1.436.265zm-2.881.458l-.101-.72c.476-.067.953-.138%201.43-.215l.115.719c-.481.076-.963.148-1.444.216zm-18.925.08c-.482-.077-.963-.161-1.441-.251l.134-.714c.472.09.946.172%201.421.247l-.114.718zm388.654.103l-.293-.665%201.332-.584.291.666-1.33.583zm-235.217.086c-.426-.23-.853-.457-1.28-.684l.34-.642c.429.228.857.456%201.285.687l-.345.639zm-137.409.087l-.075-.722c.48-.051.958-.105%201.438-.164l.088.721c-.484.06-.967.114-1.451.165zm-13.128.1c-.485-.049-.97-.105-1.453-.168l.094-.72c.476.062.953.117%201.433.165l-.074.723zm10.218.147l-.047-.725c.481-.031.961-.067%201.442-.108l.061.723c-.485.042-.971.079-1.456.11zm-7.301.07c-.487-.023-.974-.053-1.459-.089l.054-.725c.479.036.959.066%201.441.089l-.036.725zm4.383.056l-.016-.726c.482-.01.962-.027%201.445-.048l.031.726c-.487.021-.973.038-1.46.048zm-1.461.016c-.488-.001-.975-.006-1.461-.018l.018-.726c.481.011.963.017%201.445.018l-.002.726zm377.254.604l-.293-.665%201.331-.583.292.665-1.33.583zm-230.004.308c-.423-.233-.848-.466-1.273-.697l.345-.638c.427.231.854.465%201.279.698l-.351.637zm227.342.859l-.292-.665%201.331-.583.291.665-1.33.583zm-224.8.55l-1.27-.708.353-.635%201.271.709-.354.634zm222.138.616l-.292-.665%201.331-.583.291.665-1.33.583zm-219.607.815l-1.264-.718.358-.633%201.266.719-.36.632zm216.946.352l-.293-.665%201.332-.583.291.665-1.33.583zm-214.425%201.097l-1.259-.727.361-.629%201.263.728-.365.628zm211.763.069l-.292-.665%201.332-.583.29.665-1.33.583zm-2.662%201.167l-.292-.665%201.332-.583.29.665-1.33.583zm-206.586.232l-1.256-.735.366-.627%201.258.736-.368.626zm203.925.935l-.292-.665%201.331-.583.291.665-1.33.583zm-201.417.546l-1.254-.742.371-.625%201.253.743-.37.624zm198.756.62l-.292-.665%201.331-.584.291.666-1.33.583zm-196.261.872l-1.246-.747.373-.623%201.248.748-.375.622zm193.599.295l-.292-.665%201.332-.584.29.666-1.33.583zm-2.662%201.167l-.292-.666%201.332-.583.29.665-1.33.584zm-188.45.034l-1.242-.748.375-.623%201.241.748-.374.623zm185.789%201.132l-.292-.665%201.332-.584.29.666-1.33.583zm-183.308.365l-1.241-.749.376-.621%201.242.749-.377.621zm180.647.801l-.292-.665%201.331-.583.291.665-1.33.583zm-178.159.696l-1.243-.748.375-.623%201.243.748-.375.623zm175.497.47l-.292-.665%201.331-.583.291.666-1.33.582zm-173.008%201.023l-1.245-.747.374-.622%201.244.746-.373.623zm170.347.144l-.292-.665%201.331-.583.291.665-1.33.583zm-2.662%201.167l-.292-.665%201.332-.583.29.665-1.33.583zm-165.191.176l-1.247-.743.371-.624%201.248.742-.372.625zm162.53.99l-.292-.665%201.331-.583.291.665-1.33.583zm-160.029.489l-1.251-.738.37-.626%201.249.738-.368.626zm157.367.678l-.292-.665%201.331-.583.291.665-1.33.583zm-154.858.792l-1.256-.734.368-.627%201.254.732-.366.629zm152.197.375l-.293-.665%201.332-.583.291.665-1.33.583zm-149.681%201.08l-1.26-.727.364-.628%201.259.725-.363.63zm147.02.086l-.293-.666%201.331-.583.292.666-1.33.583zm-2.662%201.167l-.293-.665%201.331-.584.292.666-1.33.583zm-141.83.187l-1.265-.717.36-.631%201.263.717-.358.631zm139.168.979l-.292-.666%201.331-.583.291.666-1.33.583zm-136.629.444l-1.271-.709.354-.634%201.269.707-.352.636zm133.968.723l-.292-.665%201.331-.584.291.666-1.33.583zm-131.417.681l-1.277-.698.351-.637%201.274.697-.348.638zm128.755.485l-.292-.665%201.331-.583.291.665-1.33.583zm-126.189.894c-.43-.228-.858-.456-1.285-.687l.344-.639c.426.23.854.457%201.281.685l-.34.641zm123.525.271l-.29-.665%201.332-.582.29.666-1.332.581zm-120.945%201.083l-1.292-.674.337-.642%201.289.672-.334.644zm118.279.081l-.29-.667%201.334-.579.29.665-1.334.581zm-2.672%201.154l-.287-.667%201.335-.576.288.667-1.336.576zm-113.011.09c-.435-.218-.868-.438-1.301-.659l.331-.647c.431.221.863.44%201.296.656l-.326.65zm110.336%201.053l-.284-.669%201.337-.569.285.668-1.338.57zm-107.724.241c-.437-.212-.873-.427-1.309-.643l.322-.651c.434.216.869.43%201.305.642l-.318.652zm105.041.886l-.279-.671%201.34-.56.281.669-1.342.562zm-102.41.372c-.44-.207-.879-.416-1.318-.625l.314-.655c.437.209.875.416%201.313.622l-.309.658zm99.72.736l-.274-.672c.449-.183.896-.366%201.343-.55l.277.671c-.448.185-.897.368-1.346.551zm-97.071.486c-.443-.2-.884-.401-1.327-.606l.304-.659c.441.203.881.405%201.322.603l-.299.662zm94.372.598l-.268-.675c.449-.178.899-.357%201.347-.538l.271.673c-.449.181-.899.361-1.35.54zm-91.704.582c-.446-.193-.891-.388-1.336-.585l.294-.664c.443.196.887.39%201.331.582l-.289.667zm88.994.476l-.261-.677c.451-.174.902-.349%201.352-.525l.264.677c-.451.176-.903.352-1.355.525zm-86.305.659c-.449-.185-.898-.373-1.346-.561l.282-.67c.447.189.894.375%201.341.56l-.277.671zm83.582.369l-.253-.681c.453-.168.906-.337%201.358-.508l.257.679c-.454.172-.908.341-1.362.51zm-80.874.718c-.453-.178-.905-.356-1.357-.538l.271-.674c.449.18.899.359%201.35.535l-.264.677zm78.139.276l-.242-.686c.455-.161.91-.325%201.364-.489l.248.682c-.457.166-.913.33-1.37.493zm-75.41.759c-.456-.168-.912-.338-1.367-.511l.258-.679c.452.172.906.341%201.359.508l-.25.682zm72.662.193l-.233-.688c.457-.155.914-.312%201.37-.47l.239.686c-.459.16-.917.316-1.376.472zm-69.913.786c-.458-.159-.918-.318-1.377-.483l.244-.683c.456.162.913.322%201.37.479l-.237.687zm67.149.125l-.222-.693c.459-.146.919-.296%201.377-.447l.228.689c-.46.153-.921.302-1.383.451zm-64.38.795c-.463-.148-.926-.299-1.388-.453l.231-.689c.458.153.918.303%201.379.45l-.222.692zm61.601.068l-.208-.696c.461-.139.922-.279%201.384-.423l.216.694c-.463.143-.928.285-1.392.425zm-58.81.787c-.466-.137-.933-.277-1.398-.42l.212-.694c.463.142.927.281%201.39.417l-.204.697zm56.015.024l-.195-.7c.464-.13.929-.262%201.392-.397l.203.698c-.466.135-.932.268-1.4.399zm-2.812.754l-.181-.703c.467-.12.934-.243%201.4-.368l.189.701c-.469.126-.939.249-1.408.37zm-50.394.011c-.47-.125-.94-.254-1.408-.386l.197-.699c.465.13.931.259%201.398.383l-.187.702zm47.567.682l-.165-.708c.469-.109.939-.221%201.407-.336l.174.705c-.472.116-.944.229-1.416.339zm-44.739.035c-.474-.114-.946-.231-1.416-.351l.178-.703c.468.119.936.235%201.406.347l-.168.707zm41.895.592l-.148-.71c.473-.099.944-.2%201.416-.304l.156.709c-.475.105-.949.207-1.424.305zm-39.051.047c-.475-.099-.951-.204-1.424-.31l.16-.709c.47.106.942.209%201.413.308l-.149.711zm36.191.51l-.13-.715c.475-.086.95-.175%201.423-.267l.138.714c-.477.092-.954.182-1.431.268zm-33.331.053c-.479-.087-.955-.177-1.433-.271l.141-.712c.472.093.947.183%201.421.269l-.129.714zm30.455.426l-.109-.718c.477-.073.953-.149%201.429-.228l.119.716c-.479.08-.958.157-1.439.23zm-27.583.052c-.48-.072-.959-.149-1.437-.229l.119-.716c.475.079.951.154%201.428.227l-.11.718zm24.694.347l-.089-.72c.48-.06.958-.123%201.435-.188l.1.719c-.481.067-.963.13-1.446.189zm-21.808.045c-.482-.058-.963-.119-1.444-.185l.098-.72c.477.065.954.127%201.432.184l-.086.721zm18.908.268l-.066-.724c.48-.044.961-.092%201.441-.144l.077.722c-.483.053-.967.101-1.452.146zm-16.014.034c-.483-.042-.966-.089-1.449-.14l.076-.722c.478.05.956.097%201.435.138l-.062.724zm13.103.189l-.044-.725c.482-.029.963-.063%201.444-.1l.057.724c-.486.038-.972.072-1.457.101zm-10.205.023c-.484-.028-.967-.059-1.45-.094l.052-.725c.479.035.959.066%201.439.094l-.041.725zm7.288.106l-.02-.726c.483-.014.966-.032%201.448-.052l.032.726c-.487.021-.973.038-1.46.052zm-4.377.009c-.487-.011-.972-.027-1.456-.046l.028-.726c.48.019.961.035%201.443.045l-.015.727zm2.015.024l-.56-.002.005-.726.553.001.894-.005.01.727-.902.005z'%20/%3e%3cpath%20fill='%235246f7'%20d='M434.064%2070.833c-12.949%200-25.889.227-38.781.77-5.827.244-11.517.535-16.911.86-53.691%203.242-96.045%2011.127-133.291%2024.817-13.271%204.877-25.59%2011.687-37.502%2018.274-8.347%204.615-16.978%209.387-25.846%2013.44-15.38%207.031-31.796%2012.871-47.671%2018.519-10.581%203.765-21.522%207.657-32.014%2011.854C66.837%20172.786%2030.433%20186.659.28%20210.501c-15.527%2012.276-28.532%2027.163-37.609%2043.051-10.077%2017.639-15.066%2035.752-14.831%2053.838.374%2028.813%2014.024%2055.966%2026.069%2079.923l95.041%20189.05c14.841%2029.519%2030.187%2060.043%2053.28%2084.579%2035.761%2037.997%2090.17%2059.422%20147.553%2059.424%2011.752.001%2023.617-.897%2035.485-2.735%2049.188-7.617%2096.235-29.791%20141.733-51.235%2031-14.611%2063.057-29.72%2095.082-39.788%2035.885-11.281%2068.155-14.971%2098.651-11.278%2028.857%203.493%2056.957%2013.949%2084.133%2024.061%2035.61%2013.249%2072.427%2026.954%20110.582%2024.557%2032.813-2.059%2064.11-15.654%2093.018-40.408%2025.356-21.71%2047.333-50.906%2063.559-84.43%2018.331-37.876%2030.079-79.105%2041.44-118.977%207.574-26.577%2015.404-54.058%2025.124-80.36%206.36-17.21%2013.706-34.398%2020.811-51.021%2012.879-30.127%2026.194-61.28%2034.057-93.59%2014.167-58.219%206.086-111.994-22.173-147.534-15.203-19.124-36.125-33.369-62.182-42.34-23.472-8.08-49.99-11.318-76.699-9.364C902.889-.452%20855.52%2018.387%20809.71%2036.605l-5.095%202.026c-51.783%2020.57-98.734%2037.664-148.945%2038.472-39.533.64-79.779-1.247-118.7-3.071-33.755-1.58-68.351-3.199-102.906-3.199M269.788%20721.092c-57.587%200-112.186-21.506-148.088-59.651-23.164-24.614-38.534-55.186-53.398-84.752l-95.043-189.05C-38.819%20363.613-52.51%20336.38-52.886%20307.4c-.237-18.218%204.785-36.456%2014.926-54.208%209.124-15.968%2022.19-30.927%2037.789-43.261%2030.241-23.911%2066.699-37.805%20101.955-51.241%2010.499-4.2%2021.447-8.095%2032.034-11.861%2015.861-5.643%2032.261-11.477%2047.613-18.496%208.843-4.042%2017.462-8.806%2025.796-13.415%2011.937-6.6%2024.28-13.423%2037.603-18.32%2037.315-13.715%2079.734-21.613%20133.498-24.86l.022.362-.022-.362c5.398-.326%2011.093-.617%2016.924-.861%2047.333-1.988%2095.331.257%20141.752%202.43%2038.908%201.822%2079.141%203.709%20118.655%203.069%2050.088-.806%2096.972-17.877%20148.688-38.421l5.094-2.025c45.861-18.239%2093.283-37.098%20142.911-40.731%2026.8-1.96%2053.422%201.29%2076.987%209.402%2026.19%209.017%2047.224%2023.341%2062.516%2042.574%2028.398%2035.719%2036.529%2089.72%2022.308%20148.158-7.875%2032.37-21.204%2063.551-34.094%2093.706-7.101%2016.613-14.445%2033.793-20.799%2050.987-9.709%2026.275-17.535%2053.742-25.105%2080.306-11.37%2039.901-23.127%2081.162-41.485%20119.094-16.269%2033.614-38.31%2062.891-63.74%2084.666-29.032%2024.859-60.471%2038.512-93.446%2040.581-38.3%202.405-75.199-11.325-110.88-24.601-27.136-10.097-55.197-20.538-83.967-24.022-30.394-3.678-62.562.003-98.346%2011.251-31.979%2010.052-64.011%2025.151-94.991%2039.752-45.544%2021.466-92.639%2043.662-141.932%2051.296-11.898%201.843-23.807%202.743-35.59%202.743'%20/%3e%3c/svg%3e";
const kanbanMainBgSvgLight = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'%20?%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20fill-rule='evenodd'%20stroke-miterlimit='10'%20clip-rule='evenodd'%20viewBox='0%200%201082%20700'%20%3e%3cpath%20fill='%23e1deff'%20d='M581.382%20534.79c3.633%200%207.26.07%2010.892.214%2030.997%201.244%2061.861%208.065%2091.709%2014.661%207.858%201.737%2015.984%203.533%2023.981%205.197%2035.45%207.379%2076.994%2013.862%20116.363%205.98%2019.745-3.953%2038.403-11.834%2053.959-22.792%2016.786-11.825%2029.468-27.025%2036.673-43.957%2010.053-23.625%209.807-50.018%209.569-75.542-.182-19.543-.37-39.752%203.981-58.871%206.05-26.582%2020.661-50.351%2034.792-73.336%205.526-8.99%2011.241-18.287%2016.361-27.619%2030.822-56.172%2020.853-91.644%2012.168-107.788-7.072-13.145-21.96-30.404-52.73-37.979-21.671-5.335-46.963-4.356-69.391%202.686-30.192%209.479-57.986%2026.609-84.864%2043.175-35.813%2022.072-72.844%2044.895-115.806%2049.669-24.53%202.727-44.533-.179-66.889-9.71-14.257-6.079-29.321-9.097-43.889-12.015-9.139-1.832-18.589-3.726-27.805-6.36-3.746-1.07-7.189-2.183-10.524-3.401-7.691-2.81-15.515-5.977-23.081-9.042-16.873-6.832-34.319-13.896-51.765-17.611-52.825-11.252-108.201%202.026-157.058%2013.739-46.379%2011.12-94.337%2022.619-137.314%2045.331-23.507%2012.423-39.763%2025.399-51.158%2040.835-14.139%2019.152-19.545%2042.346-14.461%2062.042%206.853%2026.555%2028.952%2042.727%2052.348%2059.849%2013.31%209.741%2027.075%2019.814%2037.738%2031.968%2013.522%2015.415%2022.175%2034.493%2030.543%2052.945%207.367%2016.242%2014.983%2033.037%2025.903%2047.315%2017.787%2023.259%2043.729%2039.654%2077.106%2048.729%2028.144%207.65%2061.184%209.809%2095.545%206.244%2023.737-2.463%2047.695-6.964%2070.863-11.318%2034.687-6.518%2070.454-13.238%20106.241-13.238m204.35%2030.373c-27.067.001-53.89-4.589-77.916-9.591-8.001-1.666-16.129-3.462-23.99-5.199-29.817-6.59-60.649-13.404-91.581-14.644-39.33-1.578-78.801%205.839-116.97%2013.011-23.183%204.356-47.156%208.861-70.922%2011.327-34.45%203.576-67.581%201.408-95.81-6.265-33.534-9.118-59.606-25.6-77.492-48.989-10.969-14.344-18.604-31.177-25.988-47.456-8.345-18.403-16.976-37.432-30.427-52.765-10.61-12.095-24.342-22.144-37.622-31.862-23.504-17.2-45.703-33.447-52.621-60.252-5.137-19.907.312-43.328%2014.58-62.654%2011.462-15.527%2027.796-28.57%2051.402-41.046%2043.058-22.755%2091.061-34.265%20137.485-45.395%2048.931-11.731%20104.39-25.027%20157.377-13.743%2017.508%203.728%2034.984%2010.805%2051.886%2017.648%207.56%203.062%2015.379%206.228%2023.058%209.033%203.318%201.212%206.745%202.321%2010.474%203.386%209.188%202.625%2018.623%204.516%2027.749%206.345%2014.603%202.925%2029.704%205.952%2044.031%2012.06%2022.233%209.479%2042.131%2012.366%2066.523%209.655%2042.8-4.755%2079.763-27.535%20115.506-49.565%2026.916-16.59%2054.749-33.743%2085.028-43.251%2022.55-7.079%2047.985-8.063%2069.781-2.697%2024.56%206.046%2042.954%2019.304%2053.196%2038.339%208.298%2015.426%2010.825%2033.713%207.508%2054.353-2.715%2016.896-9.52%2035.613-19.679%2054.128-5.13%209.348-10.848%2018.652-16.38%2027.65-14.099%2022.935-28.679%2046.651-34.702%2073.116-4.332%2019.037-4.145%2039.203-3.963%2058.704.239%2025.598.485%2052.068-9.627%2075.833-7.258%2017.056-20.025%2032.363-36.922%2044.265-15.638%2011.016-34.392%2018.938-54.233%2022.912-12.781%202.558-25.789%203.609-38.739%203.609'%20/%3e%3cpath%20fill='%23e1deff'%20d='M957.861%2065.759l-.008-.724c.466-.006.93-.008%201.395-.008l.039.506-.025.219c-.476%200-.938.002-1.401.007zm4.333.027c-.481-.011-.963-.019-1.444-.024l.007-.725c.486.005.97.013%201.454.024l-.017.725zm-7.219.035l-.025-.725c.484-.016.969-.028%201.451-.038l.016.725c-.48.01-.962.022-1.442.038zm10.103.065c-.48-.023-.96-.042-1.441-.058l.024-.725c.485.016.969.036%201.451.059l-.034.724zm-12.99.056l-.037-.723c.483-.025.966-.048%201.449-.069l.031.724c-.481.021-.961.043-1.443.068zm15.872.113c-.479-.034-.96-.065-1.441-.093l.043-.724c.484.029.966.06%201.448.094l-.05.723zm-18.755.066l-.053-.723c.484-.035.967-.068%201.449-.097l.045.723c-.48.03-.96.062-1.441.097zm21.63.175c-.479-.046-.958-.089-1.437-.129l.061-.723c.482.041.964.084%201.445.13l-.069.722zm-24.508.059l-.067-.722c.483-.044.965-.085%201.447-.124l.058.722c-.479.039-.958.08-1.438.124zm27.376.256c-.477-.059-.955-.114-1.433-.167l.079-.721c.481.053.962.11%201.442.169l-.088.719zm-30.253.031l-.078-.721c.481-.052.963-.102%201.443-.15l.073.721c-.48.047-.958.098-1.438.15zm-2.87.34l-.092-.72c.481-.061.962-.12%201.442-.176l.085.719c-.478.057-.957.116-1.435.177zm35.98.022c-.474-.072-.951-.141-1.428-.206l.099-.718c.48.066.959.135%201.438.208l-.109.716zm-38.846.365l-.104-.719c.48-.069.96-.135%201.44-.2l.096.718c-.478.064-.955.131-1.432.201zm41.693.108c-.473-.086-.947-.168-1.421-.247l.119-.715c.477.079.955.163%201.43.248l-.128.714zm-44.551.327l-.115-.716c.479-.076.957-.151%201.435-.224l.109.717c-.476.073-.952.147-1.429.223zm47.382.229c-.471-.1-.941-.196-1.414-.29l.14-.71c.476.094.951.191%201.424.29l-.15.71zm-50.234.251l-.126-.713c.476-.084.953-.167%201.43-.247l.121.715c-.476.08-.951.161-1.425.245zm53.046.389c-.467-.114-.935-.224-1.404-.331l.161-.707c.472.107.945.219%201.415.335l-.172.703zm-55.892.137l-.137-.712c.476-.091.951-.181%201.428-.269l.131.713c-.474.087-.947.176-1.422.268zm-2.838.567l-.147-.709c.474-.098.949-.195%201.423-.29l.142.711c-.472.095-.945.19-1.418.288zm61.52.025c-.463-.128-.927-.254-1.393-.375l.183-.701c.47.121.937.248%201.404.378l-.194.698zm-64.351.584l-.157-.708c.473-.104.946-.208%201.419-.309l.153.707c-.472.102-.944.206-1.415.31zm67.118.235c-.458-.144-.918-.284-1.379-.421l.205-.695c.465.138.929.28%201.392.425l-.218.691zm-69.939.414l-.168-.705c.471-.112.943-.223%201.415-.331l.163.706c-.471.109-.941.218-1.41.33zm72.676.499c-.452-.16-.907-.316-1.364-.467l.229-.689c.461.153.919.311%201.376.472l-.241.684zm-75.491.187l-.178-.703c.471-.119.941-.234%201.413-.349l.171.703c-.469.115-.938.231-1.406.349zm-2.807.723l-.184-.701%201.406-.367.181.702-1.403.366zm81.003.097c-.448-.175-.897-.348-1.349-.515l.253-.68c.455.17.909.343%201.361.52l-.265.675zm-83.799.664l-.195-.698c.466-.131.935-.26%201.402-.386l.19.699c-.467.127-.931.255-1.397.385zm86.467.439c-.442-.191-.885-.379-1.33-.564l.278-.67c.449.186.896.376%201.341.568l-.289.666zm-89.256.354l-.204-.695c.466-.137.932-.271%201.399-.404l.198.699c-.465.131-.929.265-1.393.4zm-2.78.829l-.212-.694c.464-.14.929-.28%201.394-.419l.207.694c-.464.138-.927.278-1.389.419zm94.662.016c-.433-.208-.871-.412-1.308-.611l.302-.66c.441.202.881.408%201.319.617l-.313.654zm-97.432.846l-.219-.692c.461-.146.925-.292%201.388-.435l.215.692c-.462.143-.923.288-1.384.435zm100.014.451c-.427-.224-.855-.445-1.286-.661l.326-.647c.435.218.867.439%201.297.666l-.337.642zm-102.775.443l-.227-.688c.461-.153.922-.303%201.383-.453l.224.69c-.461.149-.922.3-1.38.451zm-2.752.924l-.234-.685c.458-.158.917-.314%201.378-.468l.231.687c-.46.154-.917.309-1.375.466zm108.057.027c-.418-.242-.837-.478-1.258-.709l.349-.636c.425.234.85.473%201.271.716l-.362.629zm-110.799.929l-.242-.684%201.373-.482.239.684-1.37.482zm113.276.561c-.408-.257-.819-.509-1.231-.758l.374-.62c.416.25.831.505%201.243.765l-.386.613zm-116.004.423l-.245-.682%201.361-.496.246.682-1.362.496zm-2.717%201.005l-.254-.68%201.361-.505.252.68-1.359.505zm121.139.16c-.399-.274-.799-.543-1.202-.806l.398-.607c.406.267.811.538%201.214.813l-.41.6zm-123.85.862l-.258-.678%201.357-.514.256.679-1.355.513zm126.206.819c-.388-.289-.778-.572-1.171-.852l.422-.59c.395.282.79.569%201.181.86l-.432.582zm-128.912.221l-.261-.677%201.353-.522.26.677-1.352.522zm-2.699%201.054l-.267-.674%201.352-.53.263.675-1.348.529zm133.892.491c-.376-.302-.754-.6-1.133-.894l.445-.573c.382.296.764.597%201.143.902l-.455.565zm-136.587.579l-.268-.673%201.347-.538.268.674-1.347.537zm-2.688%201.082l-.273-.671%201.345-.544.27.672-1.342.543zm141.486.193c-.216-.189-.434-.377-.653-.563l-.444-.375.467-.556.447.379c.222.189.441.378.66.569l-.477.546zm-144.168.905l-.276-.67%201.341-.551.275.672-1.34.549zm146.299%201.034c-.349-.33-.7-.657-1.055-.98l.487-.537c.36.327.715.657%201.066.99l-.498.527zm-148.977.076l-.279-.668%201.34-.557.277.67-1.338.555zm-2.673%201.122l-.282-.668%201.338-.563.28.669-1.336.562zm153.697.821c-.334-.343-.672-.683-1.014-1.02l.51-.516c.344.341.686.684%201.024%201.031l-.52.505zm-156.364.313l-.284-.667%201.334-.569.284.667-1.334.569zm-2.663%201.144l-.288-.666%201.333-.573.285.666-1.33.573zm160.993.646c-.32-.356-.644-.71-.972-1.062l.529-.494c.332.354.659.711.983%201.071l-.54.485zm-163.652.507l-.29-.664%201.33-.579.288.665-1.328.578zm-2.654%201.163l-.293-.662%201.328-.584.291.664-1.326.582zm168.19.509c-.306-.369-.616-.735-.931-1.099l.549-.474c.318.368.63.738.94%201.11l-.558.463zm-170.842.663l-.294-.663%201.326-.586.293.662-1.325.587zm-2.649%201.178l-.296-.661%201.325-.59.294.662-1.323.589zm175.288.413c-.292-.382-.588-.76-.888-1.136l.567-.452c.302.38.6.762.896%201.146l-.575.442zm-177.934.773l-.297-.661%201.323-.593.296.661-1.322.593zm-2.642%201.194l-.298-.659%201.321-.598.299.661-1.322.596zm182.286.355c-.276-.393-.558-.782-.844-1.17l.583-.43c.29.391.573.785.854%201.181l-.593.419zm-184.926.845l-.3-.66%201.321-.601.299.661-1.32.6zm-2.637%201.205l-.301-.66%201.319-.603.301.66-1.319.603zm189.186.335c-.263-.403-.529-.804-.8-1.201l.599-.408c.273.402.543.806.809%201.213l-.608.396zm-191.82.872l-.303-.658%201.318-.605.303.658-1.318.605zm-2.635%201.212l-.303-.658%201.317-.606.303.658-1.317.606zm195.991.362c-.25-.412-.502-.822-.758-1.23l.615-.385c.257.411.512.825.763%201.241l-.62.374zm-198.623.854l-.305-.658%201.317-.608.304.659-1.316.607zm-2.632%201.217l-.305-.658%201.317-.609.304.658-1.316.609zm202.699.43c-.233-.422-.471-.841-.711-1.258l.628-.362c.242.421.481.843.718%201.268l-.635.352zm-205.329.791l-.306-.658%201.316-.609.305.657-1.315.61zm-2.632%201.22l-.305-.657%201.316-.61.304.657-1.315.61zm209.321.539c-.22-.43-.443-.857-.668-1.282l.64-.34c.227.428.452.86.674%201.292l-.646.33zm-211.952.684l-.304-.658%201.315-.611.306.657-1.317.612zm-2.629%201.219l-.305-.657%201.315-.611.305.658-1.315.61zm215.85.693c-.204-.436-.412-.872-.623-1.304l.65-.319c.214.437.424.875.63%201.316l-.657.307zm-218.481.528l-.306-.657%201.315-.61.305.657-1.314.61zm-341.033.051c-.423-.003-.848-.003-1.27-.003h-.178v-.725h.177c.425-.001.851.001%201.276.003l-.005.725zm-4.342.02l-.009-.725c.484-.007.968-.013%201.451-.017l.006.725c-.483.004-.965.01-1.448.017zm7.236.019c-.482-.01-.965-.018-1.447-.024l.01-.725c.483.006.967.014%201.452.024l-.015.725zm-10.129.041l-.02-.725c.484-.014.968-.025%201.452-.035l.014.724c-.482.011-.964.022-1.446.036zm13.024.038c-.482-.017-.964-.032-1.446-.045l.019-.724c.484.013.968.027%201.452.044l-.025.725zm-15.915.06l-.03-.725c.484-.02.967-.037%201.451-.054l.024.725c-.481.017-.963.034-1.445.054zm18.806.061c-.482-.023-.964-.046-1.445-.066l.03-.724c.484.021.967.042%201.451.066l-.036.724zm-21.698.072l-.037-.723%201.449-.072.034.724-1.446.071zm24.589.094c-.481-.031-.963-.06-1.445-.088l.042-.723c.483.027.967.057%201.45.088l-.047.723zm-27.478.075l-.046-.723c.483-.032.966-.061%201.448-.089l.043.723c-.482.028-.963.059-1.445.089zm30.365.135c-.482-.039-.963-.075-1.444-.11l.054-.724c.482.035.965.073%201.448.112l-.058.722zm-33.25.07l-.055-.723c.482-.038.964-.073%201.446-.107l.051.723c-.48.034-.961.07-1.442.107zm36.133.186c-.481-.047-.961-.092-1.442-.134l.064-.722c.482.042.965.087%201.448.133l-.07.723zm-39.018.049l-.064-.722c.483-.043.965-.083%201.447-.122l.059.722c-.48.039-.962.079-1.442.122zm360.077.247l-.304-.657%201.316-.61.304.658-1.316.609zm-318.181.006c-.479-.055-.959-.107-1.437-.157l.074-.721c.482.05.964.102%201.446.157l-.083.721zm-44.779.013l-.069-.722%201.444-.137.067.722-1.442.137zm-2.877.297l-.078-.721%201.442-.152.075.72-1.439.153zm50.53.039c-.478-.063-.957-.123-1.435-.181l.088-.719c.48.058.96.118%201.441.181l-.094.719zm-53.407.287l-.085-.72%201.441-.167.082.721-1.438.166zm56.274.11c-.477-.071-.955-.14-1.432-.205l.098-.718c.48.065.96.134%201.44.206l-.106.717zm534.737.14c-.19-.443-.383-.884-.58-1.323l.661-.297c.199.443.394.888.586%201.336l-.667.284zm-593.884.104l-.092-.719c.48-.061.96-.122%201.44-.18l.088.719c-.479.059-.957.119-1.436.18zm62.007.202c-.476-.078-.952-.155-1.429-.229l.112-.716c.478.074.957.151%201.435.23l-.118.715zm306.946.019l-.304-.659%201.316-.608.304.659-1.316.608zm-371.822.16l-.098-.718%201.437-.195.097.719-1.436.194zm67.727.317c-.449-.083-.9-.163-1.35-.242l-.074-.012.123-.715.075.013c.452.079.905.16%201.356.242l-.13.714zm-70.594.09l-.102-.718%201.434-.206.102.718-1.434.206zm-2.861.432l-.111-.717%201.434-.219.108.717-1.431.219zm76.297.022c-.473-.095-.947-.187-1.421-.278l.138-.713c.475.092.95.185%201.425.28l-.142.711zm298.618.191l-.303-.659%201.317-.606.303.659-1.317.606zm-377.774.24l-.117-.714%201.432-.231.113.716-1.428.229zm81.985.159c-.469-.102-.94-.202-1.412-.301l.147-.709c.475.098.947.199%201.42.303l-.155.707zm-84.842.319l-.122-.715%201.431-.242.119.716-1.428.241zm87.664.318c-.47-.11-.94-.219-1.41-.324l.159-.707c.473.106.944.214%201.415.324l-.164.707zm521.63.103c-.176-.449-.355-.896-.538-1.342l.67-.276c.185.45.366.901.543%201.354l-.675.264zm-231.3.071l-.301-.66%201.317-.603.303.658-1.319.605zm-380.846.007l-.127-.714%201.428-.252.125.714-1.426.252zm93.328.497c-.469-.117-.936-.232-1.405-.344l.17-.706c.47.115.941.229%201.41.346l-.175.704zm-96.177.02l-.133-.712%201.426-.263.131.714-1.424.261zm-2.848.537l-.135-.711%201.425-.271.134.711-1.424.271zm383.905.144l-.3-.66%201.318-.601.302.659-1.32.602zm-282.077.017c-.466-.124-.933-.245-1.401-.364l.18-.703c.469.12.937.242%201.406.366l-.185.701zm-104.67.395l-.141-.711%201.423-.279.139.71-1.421.28zm107.464.361c-.464-.129-.93-.257-1.395-.383l.188-.699c.469.126.935.254%201.401.384l-.194.698zm-110.304.212l-.145-.711%201.422-.288.143.71-1.42.289zm386.946.217l-.3-.66%201.32-.6.3.66-1.32.6zm237.59.232c-.162-.455-.327-.908-.496-1.359l.679-.253c.171.453.337.911.5%201.37l-.683.242zm-511.446.133c-.463-.136-.927-.27-1.391-.401l.197-.698c.466.132.932.266%201.397.402l-.203.697zm-115.927.006l-.149-.709%201.42-.296.147.709-1.418.296zm-2.835.603l-.153-.707%201.419-.305.151.709-1.417.303zm121.539.216c-.462-.14-.925-.279-1.387-.416l.206-.695c.463.137.927.278%201.391.417l-.21.694zm268.435.005l-.298-.662%201.322-.596.298.661-1.322.597zm-392.805.396l-.156-.708%201.417-.31.155.708-1.416.31zm127.138.455l-1.383-.432.213-.693%201.387.434-.217.691zm-129.969.177l-.159-.707%201.416-.318.159.708-1.416.317zm392.988.16l-.296-.661%201.323-.594.298.661-1.325.594zm-395.814.482l-.163-.706%201.416-.323.16.706-1.413.323zm135.554.067l-1.379-.447.222-.69%201.382.447-.225.69zm504.068.041c-.148-.459-.298-.917-.453-1.373l.687-.233c.156.461.308.922.456%201.385l-.69.221zm-642.446.546l-.165-.707%201.413-.329.163.707-1.411.329zm395.989.045l-.295-.662%201.325-.59.295.662-1.325.59zm-254.859.278l-1.375-.459.229-.689%201.377.461-.231.687zm-143.954.34l-.167-.706%201.412-.333.166.706-1.411.333zm396.159.556l-.293-.663%201.327-.586.293.662-1.327.587zm-249.461.041l-1.372-.47.234-.687%201.375.472-.237.685zm-149.519.075l-.169-.706%201.412-.337.167.706-1.41.337zm-2.82.681l-.171-.704%201.411-.342.169.705-1.409.341zm155.075.202l-1.368-.481.24-.684%201.37.481-.242.684zm496.679.004c-.133-.463-.271-.926-.411-1.388l.694-.21c.141.465.279.931.414%201.397l-.697.201zm-252.612.161l-.29-.664%201.328-.581.292.664-1.33.581zm-401.961.321l-.173-.704%201.41-.345.172.704-1.409.345zm160.624.492l-1.364-.491.244-.683%201.367.491-.247.683zm-163.441.203l-.175-.704%201.409-.348.174.704-1.408.348zm402.116.14l-.287-.665%201.331-.577.288.666-1.332.576zm-404.933.559l-.175-.703%201.407-.351.176.704-1.408.35zm168.983.091l-1.362-.499.249-.681%201.364.5-.251.68zm233.285.496l-.284-.667%201.332-.57.287.665-1.335.572zM379%20126.921l-.175-.704%201.408-.353.176.704-1.409.353zm663.787.211c-.12-.467-.244-.933-.37-1.399l.699-.19c.127.467.252.938.374%201.408l-.703.181zm-489.268.185l-1.358-.507.252-.679%201.361.508-.255.678zm-177.333.31l-.177-.703%201.408-.353.176.701-1.407.355zm405.23.313l-.282-.669%201.335-.565.283.667-1.336.567zm-408.044.396l-.177-.704%201.407-.354.177.704-1.407.354zm182.862.005l-1.357-.513.256-.678%201.358.513-.257.678zm-185.672.706l-.18-.702%201.407-.357.177.702-1.404.357zm408.179.017l-.278-.668%201.335-.561.282.669-1.339.56zm-219.797.312l-1.354-.518.258-.678%201.355.519-.259.677zm-191.184.391l-.182-.702%201.399-.36.18.702-1.397.36zm675.711.179c-.108-.472-.218-.941-.331-1.409l.704-.172c.114.473.226.946.333%201.419l-.706.162zm-267.41.23l-.276-.67%201.339-.553.278.669-1.341.554zm-214.411.242l-1.352-.522.26-.677%201.354.524-.262.675zm-196.684.078l-.184-.701%201.398-.366.183.701-1.397.366zm-2.791.74l-.187-.701%201.397-.37.185.7-1.395.371zm411.202.042l-.274-.671%201.342-.549.275.671-1.343.549zm-209.023.19l-1.351-.526.262-.676%201.353.526-.264.676zm-204.969.515l-.189-.699%201.397-.376.187.701-1.395.374zm411.301.381l-.269-.673%201.344-.541.272.672-1.347.542zm-203.629.159l-1.351-.528.263-.676%201.352.529-.264.675zm-210.46.216l-.191-.698%201.395-.38.19.699-1.394.379zm687.475.037c-.094-.474-.191-.946-.292-1.418l.71-.15c.101.474.199.95.293%201.427l-.711.141zm-276.083.66l-.266-.673%201.348-.535.267.674-1.349.534zm-414.179.069l-.193-.699%201.394-.383.193.699-1.394.383zm215.948.075l-1.351-.529.265-.676%201.351.53-.265.675zm-218.734.695l-.194-.698%201.394-.388.192.7-1.392.386zm414.264.219l-.262-.676%201.349-.526.264.675-1.351.527zm-192.829.143l-1.35-.529.264-.676%201.351.53-.265.675zm-224.219.415l-.196-.698%201.392-.389.196.698-1.392.389zm414.341.482l-.258-.679%201.352-.517.261.677-1.355.519zm282.016.088c-.081-.476-.165-.951-.253-1.426l.714-.131c.087.478.171.956.254%201.435l-.715.122zm-469.436.071l-1.352-.529.265-.675%201.35.529-.263.675zm-229.706.142l-.197-.698%201.393-.392.196.698-1.392.392zm414.412.722l-.252-.68c.453-.169.904-.337%201.355-.508l.256.678c-.452.17-.905.341-1.359.51zm-417.194.065l-.198-.698%201.392-.395.197.699-1.391.394zm235.19.125l-1.351-.526.262-.676%201.352.526-.263.676zm-237.972.666l-.199-.696%201.392-.397.198.697-1.391.396zm417.255.149l-.248-.681%201.359-.499.251.679-1.362.501zm-176.577.231l-1.353-.523.262-.676%201.352.522-.261.677zm-243.461.413l-.2-.696%201.392-.397.199.696-1.391.397zm707.937.274c-.068-.477-.14-.954-.214-1.43l.716-.113c.075.48.146.96.216%201.441l-.718.102zm-290.627.068l-.244-.682%201.364-.491.245.682-1.365.491zm-171.141.285l-1.356-.519.261-.677%201.352.518-.257.678zm-248.952.171l-.199-.697%201.392-.399.199.696-1.392.4zm417.358.512l-.239-.683c.456-.16.912-.321%201.367-.481l.242.683c-.456.162-.912.322-1.37.481zm-420.14.286l-.201-.697%201.392-.399.2.697-1.391.399zm254.446.059l-1.357-.513.258-.678%201.355.513-.256.678zm162.954.603l-.235-.685%201.369-.471.237.685-1.371.471zm-420.182.138l-.201-.697%201.392-.4.2.696-1.391.401zm259.943.277l-1.358-.507.254-.68%201.357.507-.253.68zm456.713.471c-.055-.48-.114-.958-.176-1.436l.719-.092c.062.481.121.962.177%201.444l-.72.084zm-299.225.043l-.229-.688%201.373-.46.231.686-1.375.462zm-420.214.008l-.202-.697%201.393-.4.2.697-1.391.4zm265.447.481l-1.362-.501.253-.679%201.359.499-.25.681zm-268.231.319l-.201-.696%201.393-.4.2.696-1.392.4zm420.241.1l-.223-.689%201.375-.45.228.688-1.38.451zm-149.281.569l-1.365-.492.248-.68%201.362.49-.245.682zm-273.747.13l-.2-.696%201.394-.4.199.697-1.393.399zm420.263.187l-.219-.691%201.38-.439.222.69-1.383.44zm-423.048.611l-.198-.697%201.392-.398.199.696-1.393.399zm279.265.041l-1.368-.482.243-.684%201.365.482-.24.684zm141.013.213l-.214-.692%201.384-.429.216.692-1.386.429zm307.815.176c-.043-.48-.091-.96-.139-1.439l.72-.074c.05.482.098.964.141%201.448l-.722.065zm-730.88.364l-.198-.697%201.393-.397.198.697-1.393.397zm284.794.196l-1.372-.472.237-.685%201.37.471-.235.686zm135.491.106l-.208-.695%201.389-.417.209.694-1.39.418zm-423.073.49l-.199-.698%201.394-.395.199.698-1.394.395zm420.287.329l-.201-.697%201.39-.405.205.695-1.394.407zm-129.956%200c-.458-.153-.917-.305-1.376-.461l.232-.686c.457.155.915.307%201.372.46l-.228.687zm-293.121.461l-.197-.698%201.395-.394.197.698-1.395.394zm420.282.332l-.195-.698%201.395-.392.198.696-1.398.394zm-124.403.109l-1.38-.446.225-.69%201.377.447-.222.689zm-298.672.343l-.196-.698%201.395-.391.197.698-1.396.391zm739.476.154c-.031-.482-.066-.962-.103-1.443l.722-.056c.038.484.073.968.104%201.452l-.723.047zm-319.201.164l-.189-.699%201.398-.382.193.7-1.402.381zm-118.835.213l-1.386-.433.218-.691%201.382.432-.214.692zm-304.235.248l-.193-.698%201.396-.389.194.698-1.397.389zm420.263.284l-.183-.701%201.402-.368.186.701-1.405.368zm-113.251.314c-.464-.139-.928-.279-1.391-.419l.211-.694c.462.141.924.28%201.386.417l-.206.696zm-309.809.176l-.192-.7%201.397-.385.194.698-1.399.387zm420.244.227l-.175-.703c.469-.117.936-.235%201.405-.354l.179.701c-.469.121-.938.24-1.409.356zm-107.649.408c-.465-.132-.931-.266-1.395-.403l.204-.695c.463.135.926.269%201.39.401l-.199.697zm-315.392.132l-.191-.699%201.399-.383.192.7-1.4.382zm420.219.151l-.169-.705%201.409-.341.171.704-1.411.342zm-102.03.497c-.468-.126-.934-.255-1.4-.385l.194-.698c.464.129.93.257%201.396.384l-.19.699zm429.827.075c-.019-.482-.041-.962-.066-1.444l.723-.038c.025.484.049.969.068%201.454l-.725.028zm-750.818.038l-.188-.7%201.399-.38.19.7-1.401.38zm420.192.053l-.162-.707%201.412-.328.166.706-1.416.329zm-96.393.577c-.47-.121-.938-.243-1.406-.367l.186-.701c.466.124.933.245%201.4.365l-.18.703zm93.557.058l-.156-.708%201.417-.314.158.708-1.419.314zm-420.159.066l-.188-.7%201.402-.376.188.7-1.402.376zm417.317.538l-.147-.709%201.418-.299.151.71-1.422.298zm-87.897.041c-.471-.115-.941-.23-1.41-.347l.175-.703c.468.116.937.232%201.406.345l-.171.705zm-332.227.164l-.185-.7%201.403-.371.186.7-1.404.371zm417.277.371l-.143-.711%201.423-.284.143.711-1.423.284zm-82.222.129c-.473-.107-.944-.215-1.416-.327l.166-.705c.47.11.939.218%201.41.325l-.16.707zm-337.864.237l-.183-.702%201.404-.367.184.701-1.405.368zm417.229.178l-.131-.714c.474-.087.949-.176%201.423-.266l.137.712c-.476.091-.953.18-1.429.268zm-76.524.203c-.474-.099-.949-.201-1.422-.304l.156-.708c.47.103.942.204%201.415.303l-.149.709zm418.613.238c-.007-.482-.018-.964-.031-1.446l.724-.02c.014.485.024.97.032%201.455l-.725.011zm-344.95.07l-.123-.714c.476-.082.951-.166%201.427-.251l.128.713c-.478.085-.955.17-1.432.252zm-417.18.037l-.18-.702%201.406-.362.181.703-1.407.361zm346.367.229c-.475-.091-.951-.185-1.426-.281l.143-.71c.474.095.947.189%201.421.28l-.138.711zm67.947.214l-.114-.716c.477-.076.953-.154%201.428-.235l.121.716c-.479.079-.956.158-1.435.235zm-417.13.272l-.176-.702%201.407-.356.178.702-1.409.356zm352.044.041l-.075-.014c-.45-.078-.903-.16-1.356-.243l.13-.713c.452.082.903.164%201.355.243l.009.369-.063.358zm62.214.133l-.107-.716c.478-.072.955-.144%201.432-.219l.112.716c-.479.075-.958.148-1.437.219zm-59.347.341c-.477-.075-.956-.153-1.434-.231l.118-.715c.477.079.953.155%201.429.23l-.113.716zm56.469.071l-.098-.719c.479-.064.957-.132%201.435-.2l.104.717c-.482.069-.962.137-1.441.202zm-414.198.119l-.175-.704%201.409-.35.175.703-1.409.351zm360.605.236c-.479-.067-.959-.136-1.438-.207l.106-.717c.477.071.954.14%201.432.206l-.1.718zm50.713.02l-.091-.719%201.437-.183.094.719-1.44.183zm-2.888.341l-.08-.721c.479-.053.959-.109%201.439-.166l.085.72c-.482.057-.963.113-1.444.167zm-44.944.014c-.481-.058-.962-.118-1.443-.181l.095-.72c.479.063.956.124%201.435.182l-.087.719zm-366.31.082l-.171-.704%201.41-.345.172.704-1.411.345zm408.363.206l-.071-.721c.48-.047.96-.096%201.442-.146l.074.721c-.482.05-.964.098-1.445.146zm-39.165.04c-.482-.051-.964-.103-1.446-.157l.082-.721c.479.055.959.107%201.438.157l-.074.721zm36.27.226l-.061-.722c.481-.042.962-.084%201.442-.128l.067.722c-.483.044-.966.086-1.448.128zm-33.377.052c-.482-.042-.964-.087-1.446-.132l.067-.722c.481.045.962.09%201.442.132l-.063.722zm399.233.154l-.725-.006c.003-.348.004-.696.004-1.044l-.001-.401.725-.004.001.405c0%20.35-.002.701-.004%201.05zm-774.149.001l-.169-.705%201.412-.338.17.704-1.413.339zm405.396.019l-.053-.723c.482-.035.964-.07%201.445-.109l.057.724c-.483.037-.966.074-1.449.108zm-27.584.057c-.483-.035-.966-.072-1.449-.11l.058-.722c.48.037.961.074%201.443.109l-.052.723zm24.683.13l-.041-.723c.48-.028.962-.057%201.444-.088l.047.723c-.483.031-.967.061-1.45.088zm-21.784.053c-.483-.026-.967-.055-1.45-.086l.045-.723c.482.03.964.058%201.446.086l-.041.723zm18.881.095l-.031-.725c.483-.022.964-.044%201.446-.068l.037.724c-.484.024-.967.047-1.452.069zm-15.977.042c-.483-.018-.968-.039-1.452-.062l.034-.724c.483.022.965.043%201.446.061l-.028.725zm13.073.062l-.021-.725c.483-.014.965-.03%201.447-.047l.027.725c-.485.017-.969.033-1.453.047zm-10.168.029c-.485-.012-.969-.025-1.453-.04l.023-.725c.482.015.964.029%201.446.04l-.016.725zm7.262.033l-.009-.725c.482-.007.964-.016%201.447-.026l.015.725c-.484.01-.969.019-1.453.026zm-4.358.014c-.484-.004-.968-.01-1.452-.018l.011-.725c.482.008.965.014%201.447.018l-.006.725zm1.584.006h-.131v-.725h.131c.439%200%20.878-.001%201.317-.004l.005.725c-.441.002-.882.004-1.322.004zm-393.838.127l-.164-.706%201.414-.332.166.706-1.416.332zm-2.834.652l-.16-.707%201.415-.324.163.706-1.418.325zm-2.836.637l-.157-.707%201.417-.316.159.707-1.419.316zm-2.841.622l-.154-.709%201.42-.308.154.708-1.42.309zm785.428.329l-.725-.023c.015-.482.028-.964.039-1.446l.725.015c-.011.485-.024.97-.039%201.454zm-788.273.276l-.15-.71%201.422-.3.15.71-1.422.3zm-2.848.588l-.145-.711%201.423-.29.145.709-1.423.292zm-2.853.569l-.14-.711%201.425-.283.141.711-1.426.283zm-2.858.55l-.135-.712%201.427-.272.137.711-1.429.273zm-2.862.531l-.128-.714%201.428-.261.132.711-1.432.264zm799.563.392l-.723-.041c.028-.481.052-.962.075-1.444l.723.033c-.022.484-.047.968-.075%201.452zm-802.428.119l-.124-.715%201.431-.251.127.713-1.434.253zm-2.868.487l-.119-.715%201.433-.241.121.715-1.435.241zm-2.873.466l-.113-.716%201.434-.229.116.714-1.437.231zm-2.876.442l-.107-.717%201.436-.217.11.716-1.439.218zm-2.881.418l-.101-.717%201.439-.206.103.718-1.441.205zm-2.884.392l-.095-.719%201.44-.192.097.718-1.442.193zm-2.888.367l-.088-.72%201.441-.179.091.72-1.444.179zm819.498.212l-.722-.058c.039-.481.074-.961.108-1.443l.723.05c-.033.485-.069.968-.109%201.451zm-822.389.126l-.08-.72c.48-.054.961-.109%201.441-.165l.085.719c-.482.057-.964.112-1.446.166zm-2.895.311l-.074-.72%201.444-.152.077.721-1.447.151zm-2.895.283l-.069-.722%201.447-.138.069.722-1.447.138zm-2.901.25l-.06-.722%201.447-.122.062.723-1.449.121zm-2.902.22l-.05-.723c.483-.034.964-.069%201.446-.105l.056.723c-.484.036-.968.072-1.452.105zm-2.9.189l-.045-.724%201.448-.09.047.724-1.45.09zm-2.902.155l-.036-.724%201.448-.073.038.724-1.45.073zm-2.887.164l-.052-.724c.487-.035.972-.066%201.454-.093l.041.723c-.479.028-.96.059-1.443.094zm-2.878.258l-.076-.72c.485-.052.969-.099%201.449-.142l.066.722c-.478.043-.957.09-1.439.14zm-2.867.346l-.098-.717c.484-.066.965-.128%201.444-.186l.088.719c-.477.059-.954.12-1.434.184zm-2.859.429l-.118-.714c.482-.08.962-.155%201.439-.227l.108.717c-.474.071-.951.147-1.429.224zm851.006.164l-.721-.075c.05-.479.097-.96.142-1.439l.722.068c-.045.482-.093.964-.143%201.446zm-853.854.34l-.136-.712c.479-.091.956-.179%201.433-.262l.125.713c-.473.084-.947.171-1.422.261zm-2.835.574l-.152-.709c.476-.103.951-.2%201.424-.297l.144.71c-.47.095-.942.194-1.416.296zm-2.82.637l-.169-.705c.474-.113.946-.222%201.417-.328l.16.706c-.468.106-.938.215-1.408.327zm-2.808.699l-.183-.701c.471-.123.942-.242%201.41-.359l.174.704c-.465.116-.933.234-1.401.356zm861.979.64l-.719-.094c.062-.478.122-.956.177-1.434l.72.084c-.056.482-.116.963-.178%201.444zm-864.774.114l-.195-.698c.468-.13.935-.259%201.401-.386l.19.7c-.465.126-.929.254-1.396.384zm-2.78.808l-.208-.693c.466-.141.93-.278%201.394-.414l.202.697c-.461.134-.924.271-1.388.41zm-2.762.859l-.221-.691c.463-.148.925-.294%201.386-.437l.215.693c-.46.143-.919.287-1.38.435zm-2.75.906l-.234-.687c.46-.156.92-.31%201.38-.461l.226.688c-.457.151-.914.303-1.372.46zm872.658.193l-.716-.111c.074-.475.143-.952.211-1.428l.717.1c-.067.48-.138.961-.212%201.439zm-875.394.757l-.243-.683c.457-.163.915-.324%201.371-.483l.238.685c-.455.158-.91.319-1.366.481zm-2.718.994l-.254-.679c.454-.17.909-.338%201.362-.504l.249.681c-.452.165-.905.332-1.357.502zm-2.704%201.038l-.264-.675c.451-.177.904-.353%201.355-.525l.259.677c-.45.172-.9.346-1.35.523zm880.339.08l-.713-.127c.084-.474.166-.95.245-1.425l.715.119c-.079.478-.162.956-.247%201.433zm-883.027.994l-.275-.672c.45-.183.899-.365%201.348-.544l.268.673c-.447.179-.894.359-1.341.543zm-2.672%201.114l-.284-.667c.446-.19.893-.378%201.338-.564l.28.67c-.445.184-.89.371-1.334.561zm885.155.748l-.71-.143c.095-.472.187-.945.277-1.419l.712.135c-.09.476-.184.952-.279%201.427zm-887.815.404l-.293-.662c.444-.197.888-.391%201.333-.584l.287.666c-.442.191-.884.385-1.327.58zm-2.639%201.187l-.302-.66c.441-.201.882-.401%201.323-.6l.297.661c-.439.198-.879.397-1.318.599zm-2.621%201.221l-.311-.656c.437-.206.874-.412%201.31-.615l.306.657c-.435.203-.87.407-1.305.614zm892.476.029l-.708-.156c.105-.47.206-.941.305-1.412l.71.15c-.1.472-.202.946-.307%201.418zm-895.077%201.222l-.32-.65c.434-.214.869-.425%201.304-.633l.315.653c-.434.209-.867.418-1.299.63zm-2.587%201.286l-.327-.647c.432-.218.864-.434%201.296-.649l.323.649c-.431.214-.862.429-1.292.647zm897.011.321l-.706-.17c.113-.468.225-.937.333-1.406l.707.164c-.11.471-.221.942-.334%201.412zm-899.585%201l-.335-.642c.428-.224.858-.447%201.289-.667l.331.645c-.429.22-.858.441-1.285.664zm-2.559%201.355l-.344-.638c.427-.23.855-.457%201.282-.684l.339.641c-.426.226-.852.452-1.277.681zm901.434.462l-.701-.183c.121-.466.241-.934.359-1.4l.702.176c-.118.469-.238.939-.36%201.407zm-903.979.926l-.351-.634c.424-.236.848-.469%201.274-.701l.346.637c-.423.231-.846.463-1.269.698zm-2.53%201.421l-.36-.631c.421-.24.844-.479%201.267-.716l.355.632c-.422.237-.843.474-1.262.715zm905.75.456l-.698-.195c.13-.465.258-.929.385-1.395l.699.19c-.127.467-.256.935-.386%201.4zm-908.265.995l-.365-.625%201.258-.733.362.628-1.255.73zm-2.499%201.487l-.373-.62c.416-.251.832-.501%201.25-.749l.372.622c-.417.249-.833.497-1.249.747zm909.955.308l-.694-.208c.138-.462.275-.925.41-1.387l.696.202c-.136.465-.273.929-.412%201.393zm-912.425%201.203l-.382-.615c.411-.256.823-.51%201.237-.763l.378.619c-.412.252-.824.506-1.233.759zm-2.451%201.541l-.391-.61c.408-.261.817-.52%201.228-.778l.387.614c-.41.257-.817.515-1.224.774zm914.018.032l-.691-.22c.147-.459.291-.919.433-1.38l.693.214c-.143.464-.288.925-.435%201.386zm-916.45%201.542l-.398-.606c.405-.265.81-.529%201.218-.793l.393.609c-.405.262-.81.526-1.213.79zm915.546%201.219l-.687-.231c.154-.457.306-.914.455-1.373l.69.224c-.151.461-.303.922-.458%201.38zm-917.958.386l-.405-.602%201.206-.807.403.603-1.204.806zm-2.39%201.636l-.414-.596c.398-.275.797-.551%201.197-.825l.409.599c-.399.273-.795.547-1.192.822zm919.401.727l-.684-.243c.161-.455.321-.911.478-1.365l.685.236c-.159.457-.318.915-.479%201.372zm-921.77.94l-.42-.591%201.185-.839.418.591-1.183.839zm-2.343%201.697l-.43-.582c.39-.287.781-.573%201.174-.858l.425.588c-.391.283-.781.568-1.169.852zm923.122.093l-.68-.252c.169-.452.334-.905.5-1.359l.68.248c-.165.455-.332.909-.5%201.363zm-925.443%201.641l-.439-.577c.386-.293.774-.584%201.163-.874l.433.581c-.387.289-.773.579-1.157.87zm924.411%201.076l-.676-.262c.174-.45.348-.901.519-1.352l.678.258c-.172.452-.346.904-.521%201.356zm-926.707.688l-.447-.572c.382-.297.764-.594%201.149-.889l.443.574c-.385.295-.766.591-1.145.887zm-2.268%201.798l-.456-.563c.375-.304.755-.606%201.135-.907l.45.567c-.378.3-.756.601-1.129.903zm927.904.218l-.673-.272c.182-.448.361-.896.539-1.345l.673.267c-.177.45-.358.9-.539%201.35zM105%20211.03l-.464-.557c.372-.309.746-.617%201.122-.925l.459.561c-.375.307-.747.614-1.117.921zm929.039%201.072l-.669-.282c.188-.445.373-.891.558-1.338l.669.278c-.184.447-.371.895-.558%201.342zm-931.25.796l-.472-.548c.366-.316.734-.63%201.105-.943l.469.553c-.369.312-.737.625-1.102.938zm930.108%201.876l-.664-.289c.192-.443.384-.886.573-1.33l.667.285c-.191.445-.383.889-.576%201.334zm-932.287.031l-.482-.541c.361-.321.724-.642%201.09-.962l.477.545c-.365.319-.726.638-1.085.958zm-2.146%201.943l-.491-.533c.356-.328.713-.655%201.073-.981l.487.538c-.359.325-.714.651-1.069.976zm933.257.685l-.661-.298c.198-.44.394-.881.59-1.323l.663.293c-.196.444-.394.886-.592%201.328zm-935.365%201.298l-.501-.523c.349-.335.7-.668%201.054-1.001l.497.527c-.353.332-.702.664-1.05.997zm934.159%201.345l-.659-.305.606-1.316.66.301-.607%201.32zm-936.227.676l-.513-.513c.342-.341.688-.682%201.035-1.022l.507.519c-.346.338-.69.677-1.029%201.016zm934.989%201.954l-.655-.312.621-1.311.656.309-.622%201.314zm-937.015.113l-.523-.502c.334-.349.672-.696%201.012-1.044l.519.507c-.34.346-.675.692-1.008%201.039zm-1.98%202.108l-.535-.49c.326-.356.656-.711.99-1.066l.529.497c-.331.353-.66.706-.984%201.059zm937.73.396l-.651-.318c.213-.435.424-.869.634-1.303l.653.315c-.211.436-.423.871-.636%201.306zm-939.658%201.76l-.547-.477c.319-.363.639-.727.964-1.09l.541.483c-.324.361-.643.722-.958%201.084zm938.367.843l-.648-.325c.217-.432.433-.864.647-1.296l.65.321c-.215.434-.431.867-.649%201.3zm-940.237%201.36l-.56-.462c.307-.372.619-.744.935-1.115l.552.469c-.312.368-.623.738-.927%201.108zm938.922%201.231l-.645-.331.659-1.291.646.328-.66%201.294zm-940.732%201.024l-.571-.446c.296-.379.596-.761.902-1.141l.565.453c-.303.378-.602.757-.896%201.134zm939.392%201.554l-.642-.337.671-1.285.643.334-.672%201.288zm-941.384.83l-.535-.488c.326-.358.654-.713.984-1.066l.088-.12.578.437-.11.146c-.354.383-.68.736-1.005%201.091zm940.024%201.737l-.64-.341.682-1.281.64.34-.682%201.282zm-941.95.415l-.545-.479c.319-.363.639-.725.962-1.085l.54.484c-.32.357-.64.717-.957%201.08zm940.571%202.14l-.637-.346.692-1.275.637.344-.692%201.277zm-942.452.051l-.555-.467c.312-.37.625-.739.94-1.106l.55.473c-.313.364-.624.732-.935%201.1zm-1.834%202.231l-.566-.454c.305-.378.611-.753.918-1.127l.559.461c-.305.371-.609.745-.911%201.12zm942.888.264l-.635-.351.701-1.27.635.35-.701%201.271zm-944.676%202.005l-.573-.444c.295-.383.593-.765.892-1.145l.569.449c-.298.378-.594.758-.888%201.14zm943.261.53l-.632-.355.708-1.263.632.352-.708%201.266zM73.51%20245.072l-.582-.431c.287-.39.578-.777.869-1.163l.579.438c-.291.383-.579.769-.866%201.156zm943.573.752l-.63-.358.716-1.26.631.358-.717%201.26zm-945.267%201.589l-.592-.419c.281-.395.563-.789.846-1.18l.588.424c-.283.39-.563.783-.842%201.175zm943.823.93l-.628-.363.723-1.255.628.361-.723%201.257zm-945.473%201.444l-.599-.407c.273-.4.547-.8.822-1.197l.595.413c-.275.396-.547.793-.818%201.191zm944.016%201.066l-.626-.365.729-1.253.627.364-.73%201.254zm-945.615%201.343l-.608-.396c.265-.405.531-.811.799-1.214l.603.402c-.267.401-.532.803-.794%201.208zm944.146%201.159l-.624-.368.733-1.248.627.366-.736%201.25zm-945.697%201.281l-.615-.382c.255-.412.513-.823.772-1.231l.612.389c-.258.407-.514.815-.769%201.224zm944.22%201.216l-.624-.371.74-1.246.623.37-.739%201.247zm-945.722%201.256l-.624-.37c.247-.417.497-.832.75-1.246l.619.377c-.251.411-.499.824-.745%201.239zm944.236%201.235l-.622-.373.744-1.244.622.372-.744%201.245zM64.062%20259.61l-.631-.356c.238-.422.48-.842.723-1.262l.627.364c-.242.417-.482.835-.719%201.254zm944.195%201.218l-.621-.374.746-1.241.622.374-.747%201.241zM62.66%20262.142l-.638-.345c.229-.426.463-.851.698-1.275l.634.35c-.234.422-.465.846-.694%201.27zm944.098%201.168l-.62-.375.75-1.24.62.374-.75%201.241zM61.31%20264.702l-.645-.331c.221-.432.446-.861.672-1.291l.642.339c-.225.426-.448.855-.669%201.283zm943.946%201.087l-.62-.377.751-1.238.621.375-.752%201.24zM60.014%20267.29l-.651-.319c.213-.435.427-.87.645-1.303l.648.324c-.216.432-.431.864-.642%201.298zm943.769.918l-.343-.132-.284-.232.726-1.194.621.376-.72%201.182zM58.77%20269.903l-.659-.304c.204-.44.41-.88.619-1.317l.654.311c-.208.436-.412.873-.614%201.31zm943.471.837l-.62-.376.755-1.239.619.377-.754%201.238zm-944.662%201.802l-.664-.29c.194-.445.391-.888.591-1.331l.661.299c-.199.44-.395.88-.588%201.322zm943.152.679l-.62-.376.755-1.241.619.378-.754%201.239zm-944.287%201.986l-.669-.277c.186-.448.372-.896.563-1.342l.667.285c-.19.443-.377.888-.561%201.334zm942.78.494l-.62-.376.753-1.24.62.375-.753%201.241zm-943.858%202.195l-.674-.264c.176-.452.353-.903.535-1.353l.672.27c-.18.448-.358.897-.533%201.347zm942.354.287l-.62-.376.752-1.241.62.376-.752%201.241zm-943.373%202.423l-.681-.248c.167-.456.334-.912.506-1.365l.678.255c-.17.452-.338.904-.503%201.358zm941.874.06l-.621-.374.749-1.243.62.376-.748%201.241zm-1.493%202.487l-.622-.372.746-1.245.622.373-.746%201.244zm-941.341.185l-.687-.233c.156-.46.314-.919.476-1.376l.683.241c-.16.455-.317.91-.472%201.368zm939.856%202.306l-.623-.371.742-1.246.623.37-.742%201.247zm-940.757.447l-.692-.216c.146-.464.294-.926.446-1.388l.689.226c-.151.459-.298.917-.443%201.378zm939.28%202.048l-.624-.367.738-1.25.624.37-.738%201.247zm-940.12.727l-.696-.204c.137-.465.274-.931.415-1.396l.694.21c-.14.463-.277.926-.413%201.39zm938.654%201.775l-.625-.366.731-1.252.626.367-.732%201.251zm-939.429%201.015l-.701-.187c.126-.469.253-.938.383-1.405l.697.193c-.128.466-.255.932-.379%201.399zm937.973%201.492l-.627-.363.727-1.256.627.364-.727%201.255zM50.16%20294.465l-.706-.169c.114-.473.23-.944.35-1.416l.702.178c-.118.469-.234.938-.346%201.407zm937.245%201.196l-.63-.359.72-1.259.629.361-.719%201.257zM49.514%20297.29l-.709-.154c.103-.475.208-.949.316-1.422l.707.161c-.107.471-.211.942-.314%201.415zm936.463.893l-.633-.355.713-1.265.631.359-.711%201.261zm-937.041%201.945l-.712-.135c.092-.477.186-.954.281-1.431l.711.145c-.096.474-.189.947-.28%201.421zm935.63.584l-.634-.35.705-1.268.633.352-.704%201.266zM48.428%20302.98l-.715-.117c.078-.48.161-.958.246-1.438l.714.128c-.084.475-.167.951-.245%201.427zm934.744.272l-.637-.347.696-1.272.636.349-.695%201.27zm-1.376%202.548l-.639-.342.687-1.277.638.344-.686%201.275zm-933.805.044l-.718-.101c.067-.48.138-.961.211-1.442l.716.11c-.072.478-.142.955-.209%201.433zm932.451%202.516l-.641-.337.675-1.283.641.338-.675%201.282zm-932.815.357l-.72-.082c.054-.482.114-.964.174-1.446l.72.09c-.061.479-.118.959-.174%201.438zm931.482%202.213l-.645-.331.665-1.289.644.333-.664%201.287zm-931.771.669l-.722-.062c.042-.484.087-.968.135-1.452l.722.072c-.048.481-.093.961-.135%201.442zm930.463%201.914l-.649-.326.654-1.295.646.328-.651%201.293zm-930.676.974l-.723-.044c.029-.484.061-.969.097-1.454l.723.052c-.035.482-.068.965-.097%201.446zm929.39%201.619l-.651-.318.641-1.302.649.321-.639%201.299zM46.99%20317.377l-.725-.024c.016-.486.036-.971.059-1.456l.724.035c-.023.482-.042.963-.058%201.445zm928.267%201.336l-.654-.312c.208-.436.417-.873.627-1.308l.653.315c-.21.435-.419.87-.626%201.305zM46.934%20320.27l-.724-.004c.002-.485.008-.97.018-1.456l.725.014c-.01.481-.016.964-.019%201.446zm927.095%201.063l-.658-.304c.203-.439.407-.878.613-1.315l.656.307c-.206.438-.409.875-.611%201.312zm-927.792%201.845c-.011-.486-.019-.972-.024-1.457l.725-.006c.004.482.012.963.024%201.444l-.725.019zm926.592.788l-.661-.296c.198-.441.397-.882.598-1.322l.659.3c-.2.438-.398.878-.596%201.318zm-926.48%202.121c-.026-.485-.048-.97-.067-1.455l.725-.027c.018.481.04.963.065%201.444l-.723.038zm925.312.527l-.665-.288c.192-.445.385-.888.582-1.331l.662.293c-.195.442-.388.883-.579%201.326zm-925.117%202.377c-.039-.483-.076-.967-.108-1.452l.723-.048c.033.481.068.962.107%201.441l-.722.059zm923.983.286l-.669-.279c.186-.447.374-.892.564-1.337l.667.283c-.188.444-.376.888-.562%201.333zm-923.7%202.612c-.053-.482-.105-.965-.152-1.448l.722-.07c.046.48.097.958.151%201.438l-.721.08zm922.601.065l-.673-.271c.181-.449.363-.898.548-1.346l.67.276c-.184.447-.365.894-.545%201.341zm-1.063%202.691l-.676-.261c.174-.452.35-.903.528-1.353l.674.266c-.177.449-.353.898-.526%201.348zm-921.164.134c-.071-.481-.136-.962-.198-1.444l.719-.092c.061.477.126.954.196%201.431l-.717.105zm920.14%202.574l-.679-.252c.168-.454.337-.907.508-1.36l.678.256c-.17.452-.338.903-.507%201.356zm-919.679.299c-.085-.478-.165-.956-.243-1.435l.717-.115c.076.475.156.95.24%201.424l-.714.126zm918.696%202.422l-.684-.241c.162-.457.324-.913.489-1.369l.682.248c-.165.453-.327.908-.487%201.362zm-918.143.436c-.1-.476-.196-.951-.288-1.426l.712-.139c.091.473.187.945.285%201.416l-.709.149zm917.203%202.301l-.686-.23c.153-.459.308-.918.466-1.376l.685.237c-.156.455-.311.912-.465%201.369zm-916.559.538c-.114-.472-.226-.943-.333-1.417l.706-.16c.108.469.218.938.332%201.406l-.705.171zm915.663%202.215l-.691-.22c.146-.461.295-.922.444-1.382l.689.224c-.149.458-.296.917-.442%201.378zm-914.925.6c-.13-.466-.257-.935-.379-1.404l.701-.184c.122.466.247.93.376%201.394l-.698.194zm914.075%202.167l-.695-.208c.138-.464.278-.928.42-1.391l.694.213c-.142.461-.282.922-.419%201.386zm-913.244.624c-.146-.463-.289-.926-.427-1.391l.695-.207c.137.46.278.92.423%201.379l-.691.219zm912.441%202.158l-.698-.195c.131-.467.264-.933.398-1.399l.696.201c-.134.464-.265.928-.396%201.393zm-911.518.602c-.162-.457-.319-.916-.473-1.377l.688-.229c.152.456.309.91.469%201.364l-.684.242zm910.765%202.194l-.701-.183c.121-.47.245-.938.372-1.406l.7.188c-.126.465-.25.932-.371%201.401zm-909.749.532c-.177-.452-.35-.905-.519-1.359l.679-.253c.168.451.34.9.515%201.347l-.675.265zm909.048%202.277l-.705-.169c.112-.472.228-.943.345-1.414l.704.176c-.117.468-.231.937-.344%201.407zm-907.938.413c-.193-.446-.382-.892-.567-1.34l.67-.276c.184.444.371.886.562%201.329l-.665.287zm907.289%202.409l-.708-.156c.072-.33.145-.66.221-.991l.098-.427.706.161-.097.428c-.075.328-.148.656-.22.985zm-906.09.239c-.207-.438-.411-.877-.611-1.319l.66-.298c.199.437.401.873.607%201.308l-.656.309zm905.496%202.592l-.711-.144c.095-.474.193-.948.291-1.422l.71.149c-.099.472-.196.944-.29%201.417zm-904.205.016c-.222-.431-.442-.863-.656-1.298l.65-.321c.211.429.429.858.651%201.286l-.645.333zm1.382%202.563c-.147-.262-.293-.525-.437-.789l-.265-.487.639-.343.262.482c.142.261.287.522.434.783l-.633.354zm902.28.262l-.714-.131c.086-.475.176-.951.266-1.428l.713.137c-.091.474-.179.947-.265%201.422zm-900.815%202.253c-.251-.414-.498-.832-.742-1.252l.625-.365c.243.417.488.83.738%201.241l-.621.376zm900.322.598l-.716-.118c.079-.477.159-.954.242-1.432l.714.124c-.082.475-.162.951-.24%201.426zM60.365%20369.94c-.266-.406-.527-.818-.786-1.231l.614-.385c.256.41.516.817.779%201.221l-.607.395zm898.327.98l-.718-.105c.071-.479.143-.957.217-1.437l.716.112c-.074.476-.146.953-.215%201.43zm-896.704%201.445c-.277-.4-.551-.802-.821-1.205l.602-.404c.269.401.54.799.815%201.195l-.596.414zm896.305%201.424l-.719-.095c.063-.48.128-.96.194-1.441l.718.101c-.066.477-.13.956-.193%201.435zm-894.609.946c-.289-.391-.574-.784-.856-1.179l.589-.422c.281.392.565.782.85%201.171l-.583.43zm894.255%201.925l-.721-.083c.055-.481.114-.962.173-1.443l.72.089c-.06.479-.116.958-.172%201.437zm-892.494.394c-.3-.381-.596-.765-.889-1.152l.578-.439c.29.384.585.766.882%201.145l-.571.446zm1.823%202.268c-.31-.374-.615-.75-.919-1.127l.564-.455c.302.375.606.748.914%201.119l-.559.463zm890.361.216l-.722-.072c.049-.481.099-.963.151-1.445l.721.078c-.053.48-.103.959-.15%201.439zm-888.48%201.999c-.318-.366-.634-.733-.947-1.102l.552-.469c.312.367.626.732.942%201.096l-.547.475zm888.21.884l-.722-.063c.041-.482.085-.964.13-1.447l.722.069c-.045.48-.089.96-.13%201.441zm-886.274%201.283c-.328-.358-.652-.716-.975-1.077l.541-.483c.32.358.643.715.968%201.07l-.534.49zm886.042%201.603l-.724-.052c.037-.483.073-.966.113-1.448l.722.058c-.039.48-.076.962-.111%201.442zm-884.059.515c-.335-.349-.667-.7-.999-1.053l.53-.495c.329.35.66.699.993%201.047l-.524.501zm2.029%202.075c-.342-.343-.682-.687-1.02-1.032l.519-.507c.335.344.673.685%201.014%201.026l-.513.513zm881.836.3l-.724-.044.093-1.449.723.048-.092%201.445zM77.17%20389.925c-.35-.335-.697-.671-1.041-1.009l.506-.518c.344.337.689.671%201.037%201.005l-.502.522zm879.601%201.164l-.723-.036c.023-.483.049-.967.076-1.45l.724.04c-.028.483-.053.964-.077%201.446zm-877.493.826c-.354-.328-.707-.659-1.058-.99l.497-.527c.35.331.701.658%201.054.985l-.493.532zm2.145%201.951c-.361-.322-.72-.646-1.077-.971l.489-.535c.354.322.712.644%201.071.965l-.483.541zm875.221.117l-.725-.028.061-1.451.724.033-.06%201.446zm-873.047%201.798c-.364-.317-.729-.634-1.091-.954l.479-.543c.361.318.723.634%201.087.949l-.475.548zm872.95%201.098l-.725-.021.045-1.451.725.024-.045%201.448zm-870.746.783c-.37-.311-.738-.623-1.106-.936l.471-.552c.365.312.733.623%201.102.934l-.467.554zm2.228%201.852c-.374-.308-.746-.615-1.117-.923l.463-.558c.37.308.742.614%201.115.92l-.461.561zm868.448.261l-.724-.013c.009-.485.019-.969.031-1.452l.725.018c-.012.482-.022.965-.032%201.447zm-866.196%201.562c-.377-.302-.753-.604-1.128-.908l.455-.564c.374.302.75.605%201.126.906l-.453.566zm866.152%201.335l-.725-.007.019-1.452.725.011-.019%201.448zm-863.883.465c-.379-.298-.759-.597-1.137-.897l.45-.568c.377.299.756.598%201.135.894l-.448.571zm2.289%201.777c-.383-.294-.764-.589-1.146-.886l.445-.572c.38.295.761.59%201.143.883l-.442.575zm861.575.657l-.725-.002.007-1.452.725.005-.007%201.449zm-859.272%201.101l-1.153-.877.44-.576%201.151.875-.438.578zm2.315%201.743l-1.159-.87.436-.579%201.157.868-.434.581zm856.235.057l-.005-1.451.725-.002.005%201.45-.725.003zm-853.91%201.672l-1.164-.862.433-.583%201.161.862-.43.583zm853.931%201.231l-.013-1.45.725-.007.013%201.45-.725.007zm-851.597.488l-1.167-.859.429-.583%201.167.857-.429.585zm2.339%201.711l-1.17-.855.427-.585%201.171.854-.428.586zm849.298.703l-.022-1.451.725-.01.022%201.45-.725.011zM108.8%20415.281l-1.173-.853.427-.585%201.172.852-.426.586zm2.344%201.704l-1.172-.852.426-.586%201.172.852-.426.586zm844.664.195l-.029-1.451.724-.014.03%201.45-.725.015zm-842.318%201.512l-1.173-.854.427-.586%201.173.852-.427.588zm842.388%201.39l-.036-1.452.725-.016.036%201.45-.725.018zm-840.046.319l-1.17-.854.427-.586%201.172.856-.429.584zm2.34%201.716l-1.169-.859.429-.585%201.17.861-.43.583zm837.786.866l-.042-1.45.725-.02.042%201.449-.725.021zm-835.454.859l-1.165-.864.43-.583%201.167.865-.432.582zm2.324%201.737l-1.161-.87.434-.581%201.162.871-.435.58zm833.22.305l-.046-1.45.725-.023.046%201.45-.725.023zm-830.909%201.447l-1.154-.879.437-.578%201.158.88-.441.577zm831.007%201.453l-.048-1.403.723-.071.05%201.449-.725.025zm-828.707.315l-1.147-.885.441-.575%201.151.888-.445.572zm2.285%201.789l-1.141-.896.448-.571%201.142.898-.449.569zm826.525.795l-.051-1.451.724-.024.052%201.448-.725.027zm-824.261%201.018c-.375-.304-.752-.608-1.13-.909l.453-.567c.378.303.756.607%201.133.912l-.456.564zm2.247%201.836c-.374-.308-.746-.615-1.12-.922l.458-.561c.375.307.75.616%201.123.925l-.461.558zm822.122.044l-.054-1.448.725-.029.054%201.45-.725.027zm-819.903%201.822c-.367-.314-.736-.627-1.107-.937l.466-.555c.371.312.742.625%201.112.939l-.471.553zm820.01%201.076l-.053-1.449.725-.027.053%201.449-.725.027zm-817.815.817c-.363-.318-.728-.635-1.094-.951l.474-.549c.366.317.732.636%201.097.955l-.477.545zm2.163%201.929c-.357-.324-.717-.647-1.078-.969l.482-.54c.363.322.724.647%201.083.971l-.487.538zm815.761.152l-.054-1.449.725-.027.054%201.449-.725.027zm-813.627%201.809c-.353-.33-.707-.658-1.062-.985l.49-.535c.358.33.713.659%201.067.991l-.495.529zm813.731%201.089l-.05-1.397.361-.065.362-.013.052%201.45-.725.025zm-811.637.909c-.346-.336-.695-.671-1.043-1.004l.501-.524c.35.334.699.671%201.046%201.007l-.504.521zm811.738%201.989l-.049-1.449.725-.025.049%201.45-.725.024zm-809.673.057c-.371-.376-.7-.705-1.032-1.034l.509-.515c.334.33.666.662.996.997l-.473.552zm2.007%202.071c-.333-.351-.667-.699-1.003-1.046l.52-.504c.338.348.674.698%201.009%201.05l-.526.5zm807.76.769l-.047-1.448.725-.024.047%201.45-.725.022zm-805.787%201.35c-.325-.356-.652-.711-.981-1.064l.53-.494c.331.354.659.712.986%201.07l-.535.488zm805.873%201.547l-.041-1.407.361-.052.363-.011.042%201.45-.725.02zm-803.939.609c-.319-.363-.639-.724-.961-1.083l.539-.484c.324.362.647.724.967%201.088l-.545.479zm1.891%202.192c-.312-.369-.626-.735-.94-1.1l.548-.473c.317.366.633.734.946%201.104l-.554.469zm802.123.095l-.036-1.447.725-.019.036%201.45-.725.016zm-800.27%202.131c-.306-.374-.613-.746-.921-1.117l.557-.464c.309.372.617.747.925%201.122l-.561.459zm800.333.768l-.03-1.449.725-.015.03%201.45-.725.014zm-798.522%201.488c-.298-.379-.599-.756-.901-1.131l.565-.455c.304.377.605.757.905%201.137l-.569.449zm798.57%201.409l-.023-1.448.725-.013.022%201.451-.724.01zm-796.797.878c-.292-.384-.585-.766-.881-1.147l.572-.444c.297.382.592.766.886%201.151l-.577.44zm796.828%202.019l-.014-1.447.725-.009.014%201.45-.725.006zm-795.09.295c-.286-.389-.574-.776-.864-1.162l.579-.434c.291.387.581.775.868%201.165l-.583.431zm1.702%202.34c-.282-.393-.564-.784-.847-1.174l.586-.426c.285.391.568.783.849%201.178l-.588.422zm793.763.262h-.363l-.004-1.448.725-.003.004%201.402-.362.049zm-792.098%202.101c-.274-.395-.55-.79-.829-1.185l.593-.417c.279.395.556.792.832%201.189l-.596.413zm792.448.804l-.725-.006c.005-.484.007-.966.008-1.449l.725.002c-.001.484-.003.968-.008%201.453zm-790.813%201.584c-.27-.4-.54-.799-.813-1.196l.599-.409c.272.399.544.799.815%201.199l-.601.406zm790.775%201.323l-.725-.012.023-1.453.724.01-.022%201.455zM168.69%20473.35c-.265-.402-.53-.804-.797-1.206l.603-.402c.269.403.535.807.8%201.212l-.606.396zm789.105%201.828l-.725-.021.037-1.452.725.017-.037%201.456zm-787.533.601c-.259-.406-.52-.811-.783-1.217l.609-.393c.263.406.525.813.785%201.221l-.611.389zm787.435%202.308l-.725-.028c.019-.483.037-.967.053-1.45l.725.024c-.016.485-.034.97-.053%201.454zm-785.891.14c-.255-.41-.511-.819-.768-1.227l.613-.386c.259.409.515.818.771%201.229l-.616.384zm1.519%202.464l-.756-1.234.617-.381.757%201.237-.618.378zm784.242.303l-.724-.035.068-1.451.725.033-.069%201.453zm-782.751%202.176c-.246-.415-.494-.829-.743-1.242l.621-.373c.25.414.498.828.745%201.244l-.623.371zm782.589.729l-.724-.044c.03-.483.058-.967.085-1.448l.723.041c-.026.482-.055.967-.084%201.451zm-781.12%201.766l-.732-1.249.624-.369.733%201.252-.625.366zm780.924%201.136l-.724-.052.103-1.447.723.05-.102%201.449zm-779.48%201.371c-.237-.42-.478-.838-.719-1.255l.628-.363c.241.419.483.839.721%201.259l-.63.359zm779.248%201.527l-.722-.063c.042-.481.082-.962.119-1.443l.722.057c-.037.482-.077.966-.119%201.449zm-777.821.993l-.712-1.261.632-.357.712%201.263-.632.355zm777.553%201.901l-.722-.072c.047-.481.094-.961.138-1.441l.723.066c-.045.483-.091.965-.139%201.447zm-776.146.629l-.702-1.267.635-.352.701%201.269-.634.35zm775.838%202.261l-.72-.082c.054-.479.107-.959.158-1.438l.72.076c-.05.481-.103.962-.158%201.444zm-774.448.279l-.693-1.272.636-.346.694%201.273-.637.345zm1.374%202.55l-.686-1.276.639-.344.686%201.278-.639.342zm772.728.053l-.719-.092c.061-.478.12-.956.178-1.436l.719.088c-.058.481-.117.961-.178%201.44zm-771.366%202.504l-.679-1.278.64-.342.68%201.282-.641.338zm770.978.375l-.718-.102c.068-.477.134-.955.199-1.433l.718.096c-.065.481-.132.961-.199%201.439zm-769.631%202.189l-.673-1.281.642-.338.674%201.284-.643.335zm769.2.682l-.717-.113c.075-.476.149-.952.22-1.429l.717.107c-.072.479-.146.957-.22%201.435zm-767.861%201.889l-.668-1.286.642-.334.67%201.287-.644.333zm767.384.975l-.714-.124c.083-.475.163-.95.243-1.425l.715.118c-.08.477-.16.955-.244%201.431zm-766.054%201.602l-.664-1.288.644-.333.664%201.289-.644.332zm765.532%201.252l-.711-.135c.09-.473.179-.947.266-1.422l.713.132c-.088.476-.177.951-.268%201.425zm-764.21%201.328l-.66-1.291.645-.33.66%201.291-.645.33zm763.64%201.518l-.71-.148c.1-.471.196-.943.29-1.415l.711.141c-.095.476-.192.949-.291%201.422zm-762.323%201.065l-.658-1.291.646-.33.657%201.293-.645.328zm761.703%201.769l-.706-.161c.107-.469.213-.939.315-1.409l.708.154c-.103.473-.209.945-.317%201.416zm-760.39.817l-.657-1.293.648-.329.656%201.293-.647.329zm759.718%202.006l-.704-.174c.116-.468.229-.935.341-1.404l.705.168c-.112.471-.226.941-.342%201.41zm-758.407.582l-.655-1.294.647-.329.656%201.295-.648.328zm757.681%202.227l-.7-.188c.125-.465.248-.93.369-1.396l.701.181c-.121.469-.244.936-.37%201.403zm-756.369.362l-.656-1.295.647-.327.655%201.295-.646.327zm755.587%202.432l-.696-.202c.134-.462.266-.924.396-1.388l.697.196c-.129.465-.262.93-.397%201.394zm-754.276.155l-.656-1.293.647-.328.656%201.294-.647.327zm1.315%202.589l-.657-1.294.645-.329.659%201.294-.647.329zm752.122.032l-.692-.216c.144-.459.286-.919.425-1.379l.694.209c-.139.464-.282.926-.427%201.386zm-750.801%202.553l-.661-1.292.646-.33.661%201.292-.646.33zm749.901.206l-.686-.232c.154-.455.306-.912.454-1.37l.69.225c-.15.46-.302.919-.458%201.377zm-748.573%202.378l-.665-1.291.645-.331.664%201.289-.644.333zm747.613.36l-.681-.247c.164-.452.326-.905.485-1.358l.684.239c-.16.456-.323.912-.488%201.366zm-746.28%202.219l-.668-1.289.645-.333.667%201.289-.644.333zm745.256.499l-.675-.266c.175-.446.347-.895.517-1.346l.678.255c-.171.454-.343.905-.52%201.357zm-743.91%202.076l-.674-1.287.643-.335.672%201.285-.641.337zm742.821.613l-.668-.28c.185-.443.368-.888.55-1.334l.671.273c-.182.449-.366.895-.553%201.341zm-741.47%201.949l-.677-1.28.642-.338.676%201.278-.641.34zm740.314.715l-.661-.297c.197-.438.39-.878.582-1.319l.666.288c-.194.445-.389.887-.587%201.328zm-738.944%201.838l-.687-1.275.639-.343.685%201.274-.637.344zm737.719.796l-.653-.315c.208-.433.415-.868.617-1.303l.658.304c-.205.44-.412.878-.622%201.314zm-736.333%201.749l-.696-1.271.637-.346.693%201.267-.634.35zm735.038.852l-.644-.332c.22-.428.437-.857.652-1.288l.649.324c-.217.434-.436.866-.657%201.296zM208.745%20547.2l-.705-1.266.634-.351.704%201.263-.633.354zm732.266.883l-.634-.349c.231-.422.461-.845.687-1.27l.64.341c-.228.428-.459.854-.693%201.278zm-730.84%201.643l-.715-1.263.631-.355.714%201.258-.63.36zm729.4.884l-.625-.368c.244-.415.485-.831.723-1.249l.63.358c-.24.422-.482.841-.728%201.259zm-727.951%201.629c-.244-.418-.486-.837-.728-1.256l.629-.361c.24.418.482.835.725%201.252l-.626.365zm726.436.855l-.614-.386c.257-.408.511-.817.762-1.228l.618.377c-.252.414-.507.827-.766%201.237zm-724.967%201.647l-.737-1.249.624-.368.736%201.247-.623.37zm723.379.793l-.602-.404c.27-.401.536-.802.799-1.205l.607.396c-.265.406-.533.811-.804%201.213zm-721.884%201.696l-.75-1.244.621-.371.748%201.24-.619.375zm720.218.695l-.588-.424c.282-.391.559-.785.835-1.18l.595.414c-.277.398-.558.795-.842%201.19zm-718.698%201.78c-.255-.411-.51-.823-.762-1.236l.617-.379c.253.411.506.821.762%201.232l-.617.383zm716.958.56l-.575-.442c.294-.383.585-.766.872-1.153l.582.431c-.289.39-.583.778-.879%201.164zm-715.411%201.899l-.777-1.228.614-.386.774%201.225-.611.389zm713.595.384l-.559-.46c.307-.373.61-.748.91-1.125l.567.451c-.302.38-.608.759-.918%201.134zm-712.022%202.058l-.79-1.219.609-.392.789%201.216-.608.395zm710.132.168l-.545-.479c.318-.363.635-.728.947-1.095l.552.47c-.314.37-.633.738-.954%201.104zm-1.96%202.158l-.529-.497c.33-.351.656-.705.98-1.06l.537.487c-.327.359-.656.716-.988%201.07zm-706.569.1c-.269-.403-.538-.807-.805-1.21l.605-.4c.266.403.534.805.803%201.207l-.603.403zm704.54%201.99l-.511-.514c.34-.339.679-.681%201.013-1.026l.521.503c-.338.349-.68.695-1.023%201.037zm-702.907.416c-.274-.399-.548-.799-.82-1.2l.6-.408c.271.401.544.8.818%201.198l-.598.41zm700.813%201.599l-.494-.53c.351-.328.7-.658%201.046-.991l.503.522c-.349.337-.701.669-1.055.999zm-699.148.788c-.281-.396-.559-.794-.836-1.191l.594-.415c.276.396.555.792.833%201.187l-.591.419zm696.99%201.156l-.476-.546c.361-.315.721-.634%201.078-.956l.485.539c-.359.324-.722.645-1.087.963zm-695.294%201.206c-.286-.392-.569-.784-.853-1.179l.589-.422c.282.393.566.785.85%201.175l-.586.426zm693.072.668l-.459-.562c.373-.304.743-.611%201.11-.919l.467.553c-.37.312-.742.622-1.118.928zm-297.575.442v-.724l1.449-.001v.725h-1.449zm4.348.008l-1.449-.005.001-.725%201.45.006-.002.724zm-7.247.002l-.004-.725%201.451-.007.002.725-1.449.007zm10.145.02l-1.449-.012.005-.725%201.451.012-.007.725zm-13.044.002l-.007-.725%201.451-.013.005.725-1.449.013zm15.942.032l-1.449-.019.008-.724%201.451.018-.01.725zm-18.84.002l-.011-.725%201.451-.02.008.725-1.448.02zm21.739.042l-1.449-.023.01-.725%201.45.024-.011.724zm-24.639.005l-.012-.725%201.45-.025.011.725-1.449.025zm27.537.053l-1.449-.03.014-.725%201.451.031-.016.724zm-30.435.006l-.015-.725%201.45-.032.015.725-1.45.032zm33.333.066l-1.449-.037.018-.725%201.45.037-.019.725zm-36.23.006l-.018-.725%201.449-.038.019.725-1.45.038zm39.127.076l-1.449-.043.021-.725%201.451.043-.023.725zm-42.024.007l-.022-.725%201.409-.042.061.724-1.448.043zm44.921.088l-1.448-.048.023-.725%201.45.048-.025.725zm-47.818.007l-.026-.725%201.45-.049.024.725-1.448.049zm50.715.101l-1.448-.055.027-.725%201.45.055-.029.725zm-53.612.007l-.028-.725%201.45-.055.026.725-1.448.055zm56.509.113l-1.448-.06.029-.725%201.45.062-.031.723zm-59.404.008l-.033-.724%201.451-.062.029.725-1.447.061zm62.298.123l-1.447-.066.032-.725%201.449.067-.034.724zm-65.194.01l-.036-.723%201.45-.069.033.725-1.447.067zm68.09.136l-1.448-.074.036-.724%201.449.074-.037.724zm-70.985.009l-.038-.723%201.449-.074.036.723-1.447.074zm73.879.146l-1.447-.079.039-.724%201.449.08-.041.723zm-76.774.011l-.04-.723%201.448-.081.04.724-1.448.08zm-356.105.145l-.869-1.167.584-.432.865%201.164-.58.435zm435.774.016l-1.447-.087.042-.723%201.448.086-.043.724zm-82.563.009l-.043-.723%201.448-.087.042.724-1.447.086zm335.852.102l-.441-.576c.383-.292.763-.587%201.14-.884l.449.569c-.381.3-.763.597-1.148.891zm-250.396.069l-1.447-.092.045-.723%201.447.092-.045.723zm-88.349.01l-.047-.723%201.448-.093.045.723-1.446.093zm91.241.184l-1.447-.098.049-.723%201.448.098-.05.723zm-94.133.011l-.05-.723%201.448-.1.049.724-1.447.099zm97.024.196l-1.446-.104.053-.724%201.446.104-.053.724zm-99.915.011l-.053-.724%201.446-.104.053.723-1.446.105zm102.805.208l-1.445-.111.055-.723%201.447.11-.057.724zm-105.695.011l-.056-.722%201.446-.112.055.724-1.445.11zm108.584.219l-1.444-.117.057-.722%201.447.117-.06.722zm-111.473.011l-.06-.722%201.446-.118.058.722-1.444.118zm114.362.233l-1.445-.123.061-.722%201.446.122-.062.723zm-117.251.011l-.062-.722%201.445-.123.061.722-1.444.123zm120.138.245l-1.443-.13.064-.722%201.445.13-.066.722zm-123.026.01l-.065-.722%201.444-.13.064.722-1.443.13zm125.912.259l-1.442-.136.066-.722%201.446.136-.07.722zm-128.797.009l-.07-.722%201.445-.136.067.722-1.442.136zm356.629.032l-.422-.589c.391-.28.781-.563%201.167-.849l.431.583c-.39.288-.782.573-1.176.855zm-224.945.239l-1.443-.141.069-.723%201.444.142-.07.722zm-134.571.009l-.07-.722%201.443-.141.07.722-1.443.141zm-325.441.211c-.298-.385-.593-.769-.888-1.154l.577-.441c.293.386.588.769.884%201.151l-.573.444zm462.895.072l-1.443-.147.074-.721%201.442.148-.073.72zm-140.336.009l-.075-.72%201.442-.148.074.72-1.441.148zm143.218.297l-1.441-.154.076-.721%201.443.155-.078.72zm-146.101.008l-.078-.721%201.442-.154.077.72-1.441.155zm148.982.311l-1.44-.161.079-.721%201.442.16-.081.722zm-151.864.005l-.08-.72%201.442-.16.079.721-1.441.159zm154.744.325l-1.441-.167.083-.72%201.441.166-.083.721zm-157.624.004l-.084-.72%201.441-.166.082.72-1.439.166zm368.651.166l-.403-.602c.399-.268.797-.539%201.193-.813l.412.596c-.398.276-.799.549-1.202.819zm-208.148.172l-1.441-.173.087-.719%201.44.172-.086.72zm-163.382.003l-.086-.719%201.44-.172.086.719-1.44.172zm166.258.352l-1.439-.179.089-.719%201.441.179-.091.719zm-169.134.001l-.091-.719%201.441-.178.088.719-1.438.178zm-2.875.366l-.094-.719%201.44-.185.09.719-1.436.185zm174.883.001l-1.437-.186.092-.719%201.439.186-.094.719zm-478.367.196c-.304-.379-.605-.759-.905-1.141l.57-.449c.298.381.598.759.901%201.135l-.566.455zm300.609.182l-.096-.719%201.438-.19.094.719-1.436.19zm180.632%200l-1.436-.19.095-.719%201.438.192-.097.717zm197.081.311l-.385-.615c.408-.257.815-.515%201.219-.776l.394.608c-.408.264-.816.524-1.228.783zm-380.585.079l-.1-.717%201.438-.197.097.717-1.435.197zm186.377.003l-1.436-.198.097-.717%201.438.198-.099.717zm-189.248.4l-.102-.719%201.437-.203.1.718-1.435.204zm192.117.005l-1.434-.204.1-.718%201.437.204-.103.718zm-194.985.41l-.105-.718%201.435-.208.104.717-1.434.209zm197.854.008l-1.433-.21.102-.718%201.437.21-.106.718zm-200.721.418l-.108-.717%201.434-.214.107.716-1.433.215zm203.588.01l-1.433-.216.107-.717%201.436.217-.11.716zm183.114.177l-.367-.627c.416-.243.83-.49%201.242-.74l.375.62c-.415.251-.831.5-1.25.747zm-389.568.253l-.112-.717%201.434-.221.11.716-1.432.222zm-284.428.002c-.309-.374-.617-.749-.923-1.126l.562-.457c.305.375.611.749.92%201.121l-.559.462zm493.746.011l-1.431-.222.11-.716%201.434.221-.113.717zm-212.181.437l-.115-.715%201.434-.228.112.717-1.431.226zm215.045.018l-1.431-.229.113-.716%201.433.228-.115.717zm-217.906.446l-.118-.714%201.432-.235.116.717-1.43.232zm220.767.02l-1.431-.235.116-.715%201.432.235-.117.715zm171.993.249l-.348-.636c.422-.232.843-.467%201.262-.704l.356.63c-.421.24-.844.476-1.27.71zm-395.62.207l-.12-.715%201.43-.24.12.715-1.43.24zm226.485.023l-1.429-.241.12-.715%201.429.241-.12.715zm-229.342.464l-.122-.714%201.429-.246.121.715-1.428.245zm232.2.028l-1.43-.248.123-.714%201.43.247-.123.715zm-503.312.324c-.315-.368-.63-.738-.942-1.11l.555-.466c.311.369.624.738.938%201.104l-.551.472zm268.256.148l-.126-.713%201.428-.252.126.714-1.428.251zm237.908.031l-1.427-.253.126-.714%201.429.254-.128.713zm160.853.14l-.332-.646c.429-.22.856-.443%201.283-.668l.34.64c-.43.228-.86.452-1.291.674zm-401.614.342l-.129-.714%201.427-.257.129.713-1.427.258zm243.614.035l-1.426-.259.129-.714%201.427.26-.13.713zm-246.463.489l-.134-.712%201.427-.265.132.713-1.425.264zm249.311.038l-1.423-.264.131-.714%201.426.266-.134.712zm152.541.389l-.314-.653c.436-.208.869-.419%201.3-.633l.323.648c-.435.217-.871.429-1.309.638zm-404.701.111l-.136-.712%201.425-.271.134.712-1.423.271zm255.008.037l-1.423-.269.134-.712%201.426.269-.137.712zm-512.798.435c-.322-.362-.643-.726-.962-1.093l.546-.476c.318.364.638.727.958%201.088l-.542.481zm254.943.076l-.138-.711%201.424-.277.137.712-1.423.276zm260.703.034l-1.423-.273.135-.712%201.425.274-.137.711zm-263.546.528l-.142-.711%201.423-.283.14.711-1.421.283zm407.748.002l-.297-.661c.441-.198.879-.397%201.318-.6l.304.658c-.441.205-.883.405-1.325.603zm-141.354.021l-1.425-.277.139-.711%201.423.275-.137.713zm-269.235.551l-.145-.712%201.421-.287.144.71-1.42.289zm272.079.003l-1.423-.277.139-.712%201.423.279-.139.71zm2.846.559l-1.423-.279.139-.711%201.423.279-.139.711zm132.988.02l-.279-.67c.446-.185.891-.373%201.333-.564l.288.665c-.446.192-.893.382-1.342.569zm-410.753.002l-.148-.709%201.42-.295.147.71-1.419.294zm-244.465.363c-.328-.357-.656-.715-.981-1.074l.537-.487c.324.358.651.714.978%201.07l-.534.491zm525.075.173l-1.423-.279.14-.711%201.422.279-.139.711zm-283.446.062l-.151-.709%201.419-.301.15.709-1.418.301zm410.885.484l-.262-.676c.45-.174.9-.352%201.348-.531l.269.673c-.451.18-.902.359-1.355.534zm-124.593.015l-1.423-.28.14-.711%201.422.279-.139.712zm-289.126.11l-.154-.707%201.418-.307.152.708-1.416.306zm291.972.448l-1.423-.279.139-.711%201.423.279-.139.711zm-294.803.176l-.157-.708%201.416-.313.156.708-1.415.313zm413.821.27l-.245-.683c.454-.163.908-.329%201.361-.497l.252.679c-.455.17-.911.336-1.368.501zm-116.17.109l-1.425-.277.139-.711%201.423.276-.137.712zm-300.479.254l-.16-.706%201.415-.319.159.706-1.414.319zm-231.138.02c-.336-.349-.671-.702-1.004-1.055l.528-.498c.332.353.664.702.999%201.051l-.523.502zm534.465.275l-1.424-.274.138-.712%201.423.273-.137.713zm110.568.292l-.229-.688c.459-.152.916-.307%201.371-.465l.238.686c-.459.158-.92.313-1.38.467zm-416.72.06l-.164-.706%201.414-.325.161.706-1.411.325zm309.004.191l-1.426-.27.136-.713%201.424.271-.134.712zm-311.827.467l-.167-.705%201.413-.332.165.706-1.411.331zm314.678.067l-1.426-.266.134-.712%201.426.266-.134.712zm102.091.101l-.212-.692c.461-.143.922-.286%201.381-.433l.221.69c-.462.148-.925.293-1.39.435zm-99.236.424l-1.427-.261.131-.713%201.426.26-.13.714zm-320.354.079l-.168-.705%201.411-.337.167.705-1.41.337zm-220.631.126c-.343-.344-.685-.689-1.025-1.036l.519-.507c.337.346.677.688%201.018%201.03l-.512.513zm637.427.195l-.197-.698c.465-.131.928-.265%201.391-.402l.205.695c-.465.138-.932.272-1.399.405zm-93.585.114l-1.429-.255.129-.714%201.427.255-.127.714zm-326.028.248l-.173-.704%201.411-.344.17.705-1.408.343zm328.887.253l-1.429-.249.125-.713%201.428.248-.124.714zm87.915.145l-.181-.701c.467-.121.933-.245%201.398-.371l.19.7c-.467.127-.937.251-1.407.372zm-419.615.298l-.176-.704%201.409-.35.174.704-1.407.35zm334.563.042l-1.431-.241.12-.715%201.431.241-.12.715zm82.225.359l-.165-.704c.469-.112.939-.225%201.407-.341l.174.704c-.471.116-.943.23-1.416.341zm-79.36.11l-1.432-.232.117-.715%201.431.232-.116.715zm-340.239.195l-.179-.702%201.407-.355.176.702-1.404.355zm-210.111.079c-.35-.337-.699-.675-1.045-1.015l.507-.518c.345.339.692.675%201.04%201.01l-.502.523zm553.218.179l-1.433-.224.112-.717%201.433.224-.112.717zm73.653.078l-.151-.709c.472-.101.944-.205%201.413-.31l.161.706c-.473.107-.948.211-1.423.313zm-70.78.352l-1.437-.214.108-.716%201.433.213-.104.717zm-348.789.031l-.182-.701%201.405-.362.18.702-1.403.361zm416.718.197l-.138-.713c.474-.091.947-.185%201.421-.281l.144.71c-.476.097-.951.191-1.427.284zm-65.055.183l-1.438-.202.103-.718%201.434.203-.099.717zm62.191.342l-.123-.716c.476-.081.95-.166%201.425-.253l.131.713c-.477.087-.954.172-1.433.256zm-416.658.01l-.184-.701%201.403-.367.183.7-1.402.368zm357.346.035l-1.439-.191.096-.718%201.436.19-.093.719zm2.88.361l-1.441-.177.091-.719%201.437.177-.087.719zm53.562.06l-.109-.716c.476-.074.953-.148%201.429-.226l.117.716c-.478.078-.957.153-1.437.226zm-616.163.164c-.358-.328-.713-.658-1.067-.99l.496-.528c.353.329.706.658%201.061.984l-.49.534zm565.486.113l-1.442-.164.083-.721%201.44.165-.081.72zm-365.913.011l-.188-.701%201.403-.374.186.701-1.401.374zm413.71.122l-.095-.718c.478-.063.955-.129%201.434-.198l.103.717c-.48.07-.961.136-1.442.199zm-44.909.175l-1.444-.15.076-.721%201.441.15-.073.721zm42.024.184l-.082-.721c.479-.056.958-.112%201.437-.171l.089.719c-.482.059-.962.117-1.444.173zm-39.134.093l-1.445-.134.07-.722%201.441.134-.066.722zm-374.49.182l-.19-.699%201.4-.38.189.699-1.399.38zm410.734.029l-.069-.723c.48-.046.959-.093%201.439-.144l.076.72c-.482.052-.964.1-1.446.147zm-33.35.035c-.483-.038-.965-.077-1.446-.119l.061-.722c.481.042.961.081%201.442.119l-.057.722zm2.895.213c-.482-.032-.964-.066-1.447-.101l.053-.724c.482.035.963.069%201.444.102l-.05.723zm27.56.003l-.057-.723c.481-.037.961-.076%201.442-.118l.063.722c-.483.042-.966.081-1.448.119zm-24.66.176c-.484-.027-.967-.056-1.45-.085l.044-.724c.482.03.964.058%201.447.085l-.041.724zm21.763.023l-.045-.723c.482-.029.962-.06%201.444-.093l.05.723c-.483.033-.967.064-1.449.093zm-18.863.118c-.484-.021-.967-.042-1.451-.066l.036-.724c.482.023.964.045%201.446.066l-.031.724zm15.962.033l-.031-.725c.481-.021.962-.043%201.445-.068l.037.724c-.484.024-.968.047-1.451.069zm-13.061.07c-.484-.014-.967-.03-1.451-.047l.025-.724c.482.016.965.032%201.447.046l-.021.725zm10.16.028l-.019-.725c.481-.011.963-.026%201.444-.043l.026.725c-.484.017-.968.032-1.451.043zm-7.257.036c-.485-.008-.969-.016-1.452-.027l.016-.725c.482.011.964.019%201.447.027l-.011.725zm-394.678.003l-.192-.699%201.398-.386.192.7-1.398.385zm399.034.011l-.006-.725c.48-.004.962-.011%201.444-.019l.013.725c-.484.008-.968.015-1.451.019zm-1.451.007l-1.453-.005.006-.725%201.403.005.044.725zm-589.394.28c-.365-.319-.728-.642-1.09-.966l.485-.539c.358.322.719.643%201.082.96l-.477.545zm189.019.482l-.197-.698%201.397-.392.196.698-1.396.392zm-2.788.793l-.199-.697%201.395-.398.198.697-1.394.398zm-184.022.619c-.371-.311-.742-.625-1.11-.94l.472-.551c.367.314.735.626%201.104.935l-.466.556zm181.237.185l-.202-.696%201.394-.404.2.696-1.392.404zm-2.782.816l-.205-.696%201.392-.409.204.695-1.391.41zm-2.777.828l-.208-.694%201.397-.418.192.7-1.381.412zm-173.422.012c-.379-.302-.757-.607-1.133-.914l.458-.561c.374.304.75.607%201.126.907l-.451.568zm170.641.826l-.21-.694%201.392-.419.209.693-1.391.42zm-2.783.845l-.211-.694%201.392-.423.211.693-1.392.424zm-165.558.111c-.387-.293-.772-.587-1.156-.884l.444-.573c.382.295.764.588%201.149.88l-.437.577zm162.775.738l-.211-.693%201.391-.425.211.693-1.391.425zm-2.781.852l-.213-.693%201.392-.426.211.693-1.39.426zm-157.652.133c-.395-.282-.786-.567-1.177-.854l.429-.585c.388.286.778.569%201.17.849l-.422.59zm154.872.719l-.213-.693%201.391-.426.212.692-1.39.427zm-2.78.852l-.212-.693%201.389-.426.213.694-1.39.425zm-149.705.089c-.401-.271-.8-.545-1.198-.822l.414-.595c.395.274.791.547%201.19.816l-.406.601zm146.925.761l-.212-.694%201.39-.425.212.694-1.39.425zm-144.496.836c-.409-.262-.815-.524-1.22-.79l.398-.606c.402.264.805.526%201.212.784l-.39.612zm141.716.01l-.211-.693%201.389-.424.212.694-1.39.423zm-2.781.842l-.209-.694%201.39-.42.21.694-1.391.42zm-136.465.673c-.416-.249-.829-.5-1.241-.755l.382-.615c.408.251.818.501%201.231.749l-.372.621zm133.682.164l-.208-.695%201.39-.417.21.694-1.392.418zm-2.783.827l-.205-.695%201.39-.413.207.695-1.392.413zm-128.388.465c-.422-.237-.842-.476-1.26-.718l.364-.627c.415.24.832.478%201.251.714l-.355.631zm125.604.353l-.205-.695%201.392-.408.205.695-1.392.408zm-2.79.81l-.201-.696%201.393-.403.201.696-1.393.403zm-120.263.219c-.427-.224-.854-.452-1.279-.682l.345-.637c.422.228.846.455%201.271.677l-.337.642zm117.472.577l-.197-.698%201.394-.396.198.696-1.395.398zm-114.882.731c-.435-.212-.869-.427-1.3-.645l.327-.647c.428.217.858.43%201.29.64l-.317.652zm112.088.052l-.194-.698%201.395-.39.197.698-1.398.39zm-2.798.769l-.189-.7%201.397-.382.192.699-1.4.383zm-106.655.411c-.443-.199-.884-.402-1.323-.607l.308-.657c.435.204.872.405%201.312.603l-.297.661zm103.853.34l-.185-.701%201.399-.373.187.701-1.401.373zm-2.805.735l-.181-.702%201.401-.364.184.701-1.404.365zm-98.374.083c-.447-.186-.894-.376-1.341-.569l.287-.665c.444.191.888.379%201.333.564l-.279.67zm95.564.631l-.177-.703%201.404-.354.179.702-1.406.355zm-92.855.446c-.454-.173-.906-.348-1.357-.528l.267-.674c.449.178.899.353%201.349.526l-.259.676zm90.039.248l-.17-.705%201.405-.342.173.703-1.408.344zm-2.82.671l-.164-.706c.469-.109.938-.22%201.407-.332l.168.705c-.469.112-.94.223-1.411.333zm-84.481.08c-.458-.159-.915-.322-1.373-.49l.25-.681c.453.166.907.328%201.361.486l-.238.685zm81.656.566l-.159-.707%201.411-.32.161.707-1.413.32zm-78.891.354c-.463-.147-.924-.296-1.386-.45l.229-.688c.457.152.916.302%201.375.447l-.218.691zm76.061.267l-.153-.71%201.412-.306.156.708-1.415.308zm-73.271.571c-.467-.133-.932-.269-1.398-.41l.208-.693c.463.139.926.274%201.388.406l-.198.697zm70.433.022l-.144-.711%201.416-.292.147.71-1.419.293zm-2.843.563l-.137-.713%201.419-.276.14.711-1.422.278zm-64.78.176c-.469-.119-.938-.243-1.407-.37l.188-.7c.466.126.932.249%201.399.368l-.18.702zm61.932.355l-.128-.714c.473-.086.947-.173%201.421-.261l.132.713c-.474.089-.949.176-1.425.262zm-59.1.327c-.473-.107-.946-.218-1.418-.331l.17-.705c.469.114.938.222%201.408.329l-.16.707zm56.247.171l-.12-.715c.474-.08.948-.162%201.423-.244l.124.714c-.476.084-.951.165-1.427.245zm-53.4.432c-.476-.093-.952-.191-1.426-.291l.151-.71c.471.101.942.198%201.415.291l-.14.71zm50.539.03l-.111-.716c.474-.074.95-.149%201.425-.226l.116.715c-.476.078-.953.154-1.43.227zm-2.866.425l-.1-.718c.475-.067.951-.137%201.428-.206l.106.717c-.477.071-.955.14-1.434.207zm-44.812.073c-.477-.082-.955-.167-1.433-.255l.132-.712c.474.087.948.171%201.423.252l-.122.715zm41.94.311l-.092-.719c.478-.061.955-.123%201.433-.188l.096.719c-.479.065-.957.127-1.437.188zm-39.065.142c-.48-.07-.959-.143-1.439-.217l.113-.716c.477.074.952.147%201.43.215l-.104.718zm36.19.202l-.081-.72c.478-.054.955-.109%201.433-.166l.087.719c-.48.058-.96.114-1.439.167zm-33.307.177c-.481-.056-.962-.116-1.443-.179l.095-.72c.477.064.955.124%201.434.179l-.086.72zm30.423.123l-.069-.722c.479-.047.957-.094%201.437-.143l.074.721c-.482.05-.962.097-1.442.144zm-27.531.187c-.482-.047-.964-.095-1.446-.146l.076-.72c.48.05.959.097%201.439.144l-.069.722zm24.646.065l-.058-.722c.479-.038.959-.079%201.439-.12l.062.722c-.481.041-.962.082-1.443.12zm-21.747.173c-.483-.034-.967-.071-1.449-.111l.059-.722c.48.04.96.076%201.441.11l-.051.723zm18.855.032l-.045-.724c.48-.03.959-.062%201.439-.096l.052.724c-.482.034-.965.066-1.446.096zm-15.953.141c-.484-.023-.968-.049-1.452-.078l.042-.723c.481.028.962.054%201.443.077l-.033.724zm13.059.01l-.033-.723c.481-.021.962-.045%201.443-.07l.036.723c-.482.025-.964.049-1.446.07zm-10.156.099c-.484-.013-.968-.029-1.452-.047l.027-.725c.481.018.963.034%201.445.047l-.02.725zm7.258.002l-.018-.725c.48-.012.961-.027%201.442-.043l.024.725c-.483.016-.966.03-1.448.043zm-4.352.042c-.484-.002-.969-.007-1.453-.015l.012-.725c.481.008.963.013%201.444.015l-.003.725zm1.452%200l-.003-.725c.48-.002.961-.007%201.441-.014l.011.725c-.482.007-.966.012-1.449.014z'%20/%3e%3cpath%20fill='%23e1deff'%20d='M474.85%20106.681c-36.545%200-73.14%209.24-106.321%2017.618-14.905%203.763-30.366%208.207-45.319%2012.505-40.673%2011.69-82.73%2023.779-123.894%2025.641-19.221.869-44.197%209.046-68.521%2022.435-23.985%2013.203-44.548%2029.852-56.418%2045.678l-.026.03c-16.897%2018.092-29.145%2040.88-34.488%2064.167-5.827%2025.395-3.113%2049.401%207.85%2069.421%2012.364%2022.58%2033.798%2038.157%2054.526%2053.221%2012.844%209.335%2026.127%2018.988%2037.314%2030.29%2021.123%2021.342%2035.02%2048.783%2048.459%2075.32%203.183%206.286%206.475%2012.786%209.805%2019.087%2015.423%2029.188%2037.703%2064.715%2073.395%2080.503%2014.873%206.577%2030.342%209.18%2046.131%209.181%2030.56.002%2062.334-9.745%2093.417-19.278%204.923-1.51%2010.015-3.072%2014.963-4.548%20103.349-30.839%20214.078-37.025%20320.219-17.892%207.301%201.316%2014.716%202.775%2021.888%204.186%2024.731%204.866%2050.303%209.899%2075.844%209.993.231.001.465.001.695.001%2050.61%200%2077.801-20.473%2089.529-32.715%2021.274-22.207%2031.595-55.8%2031.551-102.698-.011-10.053-.394-20.321-.765-30.251-.988-26.444-2.01-53.789%203.919-79.929%207.43-32.76%2025.367-62.208%2042.713-90.687l1.032-1.694c15.732-25.836%2035.311-57.989%2041.811-92.877%203.236-17.37%202.711-35.057-1.517-51.148-4.588-17.458-13.45-32.169-25.626-42.542-15.564-13.259-36.238-20.12-61.449-20.39-26.377-.266-51.267%206.736-67.501%2012.674-23.729%208.678-47.047%2019.504-69.598%2029.973-19.076%208.857-38.803%2018.015-58.702%2025.839-31.802%2012.506-68.315%2024.509-106.193%2024.509-9.478.001-19.034-.75-28.631-2.432-22.082-3.871-43.373-12.21-63.965-20.273-20.607-8.071-41.916-16.416-63.983-20.263-10.648-1.855-21.398-2.655-32.144-2.655M317.343%20632.507c-15.879%200-31.44-2.621-46.424-9.248-35.897-15.877-58.265-51.535-73.744-80.826-3.331-6.307-6.625-12.81-9.81-19.099-13.414-26.487-27.285-53.876-48.327-75.137-11.146-11.261-24.404-20.896-37.225-30.214-20.793-15.11-42.294-30.736-54.736-53.459-11.049-20.179-13.789-44.36-7.921-69.93%205.37-23.405%2017.676-46.305%2034.652-64.486%2011.932-15.902%2032.572-32.617%2056.637-45.863%2024.418-13.441%2049.509-21.65%2068.839-22.525%2041.078-1.858%2083.093-13.934%20123.726-25.613%2014.958-4.3%2030.425-8.745%2045.342-12.511%2043.008-10.859%2091.757-23.169%20138.766-14.973%2022.14%203.858%2043.483%2012.217%2064.124%2020.301%2020.557%208.05%2041.815%2016.375%2063.824%2020.234%2047.781%208.376%2094.769-6.44%20134.435-22.037%2019.879-7.817%2039.596-16.971%2058.662-25.822%2022.564-10.476%2045.896-21.307%2069.653-29.997%2016.293-5.958%2041.254-13.012%2067.759-12.718%2025.385.272%2046.215%207.191%2061.911%2020.563%2012.29%2010.469%2021.231%2025.308%2025.857%2042.91%204.256%2016.194%204.785%2033.991%201.528%2051.466-6.524%2035.018-26.141%2067.234-41.904%2093.12l-1.031%201.695c-17.317%2028.429-35.223%2057.825-42.627%2090.469-5.908%2026.047-4.888%2053.345-3.901%2079.742.372%209.936.755%2020.211.765%2030.277.045%2047.094-10.342%2080.851-31.751%20103.2-11.809%2012.326-39.181%2032.938-90.053%2032.939-.235%200-.463-.001-.698-.001-25.609-.095-51.216-5.133-75.981-10.006-7.169-1.411-14.582-2.869-21.876-4.185-106.028-19.113-216.643-12.932-319.884%2017.874-4.945%201.475-10.035%203.036-14.958%204.546-31.137%209.549-62.975%2019.314-93.629%2019.314'%20/%3e%3cpath%20fill='%23e1deff'%20d='M404.947%20193.286c-25.551%200-65.143%205.199-130.569%2028.908-29.063%2010.532-57.149%2023.799-83.481%2039.431-25.559%2015.176-37.959%2031.456-36.855%2048.391%201.375%2021.047%2023.273%2033.901%2032.624%2038.449%204.848%202.358%209.956%204.478%2014.896%206.527%2011.322%204.698%2023.03%209.556%2032.448%2017.639%2017.15%2014.719%2024.106%2037.303%2030.835%2059.144.519%201.686%201.036%203.368%201.558%205.038%207.113%2022.829%2017.336%2047.627%2039.223%2058.443%207.791%203.85%2015.982%205.419%2024.356%205.42%2020.061.001%2041.187-9.003%2060.5-17.232%201.899-.809%203.785-1.613%205.654-2.401%2034.748-14.662%2071.616-24.325%20109.578-28.722%2037.961-4.398%2076.061-3.417%20113.243%202.913%2010.965%201.867%2022.039%204.229%2032.749%206.515%2019.773%204.219%2040.22%208.581%2060.698%209.969%2046.795%203.181%2074.295-11.351%2089.116-24.094%2018.332-15.762%2029.216-38.857%2038.819-59.235l73.852-156.709c8.839-18.755%2017.573-40.32%209.274-58.904-8.461-18.945-37.537-30.976-67.337-18.692-17.64%207.272-32.273%2020.307-46.424%2032.911-5.066%204.513-10.304%209.179-15.606%2013.515-29.445%2024.078-65.493%2040.853-104.246%2048.512-38.754%207.657-78.473%205.855-114.863-5.213-18.686-5.684-36.902-13.173-54.519-20.416-30.998-12.744-63.051-25.923-98.058-29.269-4.992-.477-10.744-.838-17.465-.838m-74.962%20308.12c-8.476%200-16.77-1.592-24.68-5.5-22.132-10.937-32.435-35.901-39.595-58.878-.52-1.672-1.038-3.353-1.558-5.04-6.698-21.742-13.624-44.225-30.613-58.806-9.332-8.009-20.985-12.845-32.255-17.52-4.949-2.054-10.067-4.177-14.935-6.545-9.465-4.605-31.631-17.627-33.03-39.054-1.124-17.229%2011.395-33.735%2037.209-49.06l.184.312-.184-.312c26.37-15.657%2054.498-28.944%2083.603-39.49%2028.131-10.194%2051.284-17.144%2072.866-21.871%2028.773-6.303%2053.465-8.345%2075.484-6.24%2035.114%203.357%2067.218%2016.556%2098.265%2029.321%2017.6%207.236%2035.801%2014.719%2054.454%2020.392%2036.277%2011.035%2075.875%2012.83%20114.511%205.195%2038.638-7.635%2074.576-24.358%20103.928-48.361%205.29-4.326%2010.522-8.987%2015.583-13.495%2014.196-12.645%2028.876-25.722%2046.63-33.04%2024.373-10.051%2057.624-4.784%2068.274%2019.067%208.425%2018.863-.372%2040.607-9.28%2059.508l-73.852%20156.709c-9.633%2020.443-20.552%2043.613-39.002%2059.475-13.514%2011.62-37.483%2024.71-76.822%2024.712-4.105%200-8.37-.142-12.816-.443-20.529-1.392-41.001-5.76-60.799-9.984-10.702-2.283-21.77-4.645-32.72-6.509-37.112-6.319-75.146-7.297-113.037-2.908-37.894%204.39-74.695%2014.034-109.381%2028.67-1.868.788-3.752%201.59-5.65%202.399-19.383%208.259-40.59%2017.294-60.782%2017.296'%20/%3e%3cpath%20fill='%23e1deff'%20d='M816.592%20215.622c-.401-.017-.803-.027-1.205-.027h-.225l-.006-.725h.232c.412%200%20.825.01%201.236.027l-.032.725zm-4.284.148l-.082-.721c.486-.055.974-.097%201.461-.128l.046.724c-.476.029-.951.071-1.425.125zm7.13.126c-.472-.07-.945-.128-1.42-.174l.071-.722c.486.047.972.107%201.457.18l-.108.716zm-9.951.35l-.159-.707c.48-.108.961-.202%201.442-.283l.12.715c-.469.079-.936.171-1.403.275zm12.758.217c-.463-.118-.928-.224-1.395-.319l.144-.711c.478.098.957.207%201.431.328l-.18.702zm-15.512.555l-.232-.686c.466-.158.933-.302%201.403-.434l.195.698c-.457.129-.913.269-1.366.422zm18.248.293c-.45-.164-.903-.316-1.359-.458l.215-.692c.468.144.932.301%201.393.469l-.249.681zm-20.908.761l-.302-.66c.449-.205.899-.397%201.352-.576l.267.674c-.441.175-.88.361-1.317.562zm23.552.352c-.432-.208-.869-.403-1.307-.588l.28-.668c.45.189.898.39%201.34.602l-.313.654zm-26.094.964l-.365-.626c.426-.248.854-.484%201.285-.708l.334.645c-.421.218-.839.448-1.254.689zm28.618.396c-.411-.247-.826-.484-1.246-.709l.344-.639c.43.231.855.474%201.276.727l-.374.621zm-31.022%201.163l-.422-.589c.401-.287.805-.563%201.211-.827l.395.607c-.398.259-.792.529-1.184.809zm33.408.426c-.386-.284-.778-.557-1.175-.822l.402-.603c.405.271.807.551%201.202.84l-.429.585zm-35.66%201.349l-.473-.55c.373-.322.751-.632%201.131-.932l.449.569c-.372.293-.74.597-1.107.913zm37.891.449c-.359-.317-.725-.625-1.095-.923l.454-.566c.38.306.754.621%201.121.945l-.48.544zm-39.98%201.514l-.519-.507c.345-.352.694-.694%201.047-1.025l.497.528c-.346.324-.688.659-1.025%201.004zm42.046.474c-.331-.348-.667-.687-1.012-1.017l.503-.523c.351.338.696.684%201.035%201.04l-.526.5zm-43.988%201.647l-.549-.473c.315-.366.638-.729.969-1.091l.536.488c-.327.358-.645.716-.956%201.076zm45.876.513c-.3-.375-.607-.741-.92-1.1l.545-.477c.32.366.634.74.941%201.124l-.566.453zm-47.696%201.716l-.573-.442c.295-.384.597-.764.906-1.144l.562.459c-.305.374-.603.75-.895%201.127zm49.397.594c-.269-.399-.544-.789-.827-1.172l.584-.431c.288.392.569.791.843%201.199l-.6.404zm-51.099%201.73l-.594-.413c.274-.397.556-.793.846-1.187l.584.428c-.284.39-.563.781-.836%201.172zm52.608.712c-.237-.419-.48-.83-.73-1.236l.617-.38c.255.413.503.833.744%201.261l-.631.355zm-54.195%201.693l-.614-.385c.258-.41.521-.819.79-1.226l.605.399c-.267.403-.526.807-.781%201.212zm55.506.862c-.204-.437-.415-.866-.631-1.29l.645-.332c.221.432.435.871.643%201.316l-.657.306zm-56.99%201.612l-.629-.362c.242-.419.487-.838.738-1.255l.621.372c-.247.414-.49.829-.73%201.245zm58.1%201.032l-.017-.046c-.163-.429-.334-.86-.513-1.286l.667-.28c.182.433.359.873.527%201.318l-.324.169-.34.125zm-59.498%201.494l-.64-.341c.228-.427.46-.853.695-1.28l.634.352c-.234.423-.463.845-.689%201.269zm60.417%201.233c-.137-.459-.281-.916-.435-1.37l.686-.232c.157.463.304.927.444%201.394l-.695.208zm-61.75%201.341l-.647-.328c.219-.432.439-.865.662-1.297l.645.333c-.223.43-.442.86-.66%201.292zm62.476%201.439c-.105-.468-.218-.933-.339-1.397l.701-.184c.123.473.238.946.345%201.422l-.707.159zm-63.763%201.157l-.652-.317c.212-.436.426-.872.642-1.307l.649.323c-.215.433-.427.866-.639%201.301zm64.301%201.667c-.075-.473-.156-.946-.246-1.417l.712-.135c.091.479.174.959.25%201.441l-.716.111zm-65.568.941l-.653-.316.633-1.305.653.316-.633%201.305zm65.924%201.915c-.044-.477-.096-.955-.155-1.43l.719-.09c.06.483.112.967.158%201.453l-.722.067zm-67.197.694l-.65-.321.637-1.3.652.318-.639%201.303zm67.378%202.179c-.016-.48-.039-.96-.069-1.44l.724-.044c.03.486.053.972.07%201.46l-.725.024zm-68.682.413l-.644-.332c.22-.428.438-.857.654-1.287l.648.325c-.217.433-.436.864-.658%201.294zm69.42%202.483l-.725-.017c.01-.4.015-.801.015-1.201l-.001-.238.725-.007.001.245c0%20.406-.005.812-.015%201.218zm-70.782.08l-.636-.349c.232-.422.461-.845.686-1.268l.64.34c-.227.426-.456.852-.69%201.277zm-1.448%202.528l-.622-.373c.248-.414.49-.829.728-1.245l.63.359c-.241.421-.485.84-.736%201.259zm72.083.308l-.723-.055c.037-.479.068-.959.092-1.438l.724.036c-.024.486-.055.972-.093%201.457zm-73.633%202.159l-.604-.399c.266-.403.525-.806.779-1.212l.614.385c-.256.41-.52.819-.789%201.226zm73.335.745l-.719-.092c.062-.477.117-.954.167-1.431l.72.073c-.05.484-.106.967-.168%201.45zm-75.003%201.649l-.583-.43c.286-.389.565-.779.838-1.172l.595.415c-.277.397-.559.792-.85%201.187zm74.562%201.234l-.714-.127c.084-.474.163-.949.236-1.422l.716.109c-.074.481-.153.961-.238%201.44zm-76.354%201.066l-.559-.461c.307-.373.607-.747.9-1.123l.573.446c-.298.381-.603.76-.914%201.138zm75.777%201.792l-.708-.159c.107-.468.207-.939.302-1.409l.711.143c-.097.477-.199.952-.305%201.425zm-77.7.404l-.531-.493c.329-.354.65-.71.964-1.068l.545.478c-.318.363-.644.724-.978%201.083zm-2.049%202.079l-.5-.524c.35-.335.691-.671%201.025-1.009l.516.51c-.339.342-.685.684-1.041%201.023zm79.043.347l-.699-.19c.127-.464.248-.93.364-1.396l.704.175c-.118.473-.24.942-.369%201.411zm-81.211%201.605l-.468-.551c.368-.314.729-.63%201.082-.948l.485.54c-.358.321-.724.642-1.099.959zm80.386%201.191l-.692-.219c.147-.458.288-.918.424-1.379l.695.205c-.137.467-.28.931-.427%201.393zm-82.66.637l-.441-.575.468-.362c.227-.176.45-.351.669-.527l.453.566c-.222.178-.448.356-.676.533l-.473.365zm-2.312%201.755l-.434-.58c.385-.289.77-.579%201.154-.871l.439.578c-.386.293-.772.584-1.159.873zm84.029.367l-.681-.249c.165-.451.325-.905.48-1.36l.686.235c-.157.459-.319.918-.485%201.374zm-86.367%201.356l-.426-.587c.39-.283.78-.568%201.168-.854l.43.583c-.39.287-.78.574-1.172.858zm85.315%201.362l-.671-.275c.183-.445.361-.891.535-1.341l.676.262c-.176.454-.355.904-.54%201.354zm-87.677.327l-.418-.592c.394-.278.787-.557%201.18-.838l.422.59c-.394.281-.789.561-1.184.84zm-2.385%201.657l-.41-.597c.398-.274.796-.547%201.192-.822l.413.595c-.398.276-.796.551-1.195.824zm88.906.688l-.659-.299c.198-.438.393-.878.584-1.32l.665.289c-.193.446-.39.89-.59%201.33zm-91.316.936l-.401-.605c.402-.266.803-.534%201.203-.804l.405.602c-.401.27-.804.539-1.207.807zm-2.429%201.589l-.393-.609c.406-.261.811-.524%201.214-.788l.397.606c-.405.266-.812.53-1.218.791zm92.498.103l-.649-.321c.213-.43.423-.864.629-1.299l.655.311c-.208.439-.42.874-.635%201.309zm-94.951%201.453l-.383-.615c.409-.255.817-.512%201.223-.77l.39.612c-.409.259-.82.517-1.23.773zm93.615%201.134l-.637-.344c.227-.423.452-.849.672-1.276l.645.332c-.224.432-.45.861-.68%201.288zm-96.088.388l-.376-.62c.414-.25.825-.501%201.235-.754l.381.617c-.413.254-.826.506-1.24.757zm-2.494%201.488l-.367-.625c.417-.244.831-.489%201.244-.737l.373.623c-.416.248-.832.494-1.25.739zm97.16.664l-.625-.365c.241-.415.48-.832.715-1.253l.633.354c-.238.424-.478.845-.723%201.264zm-388.042.017l-.003-.725.962-.002.492.001-.002.725-.49-.001-.959.002zm4.344.027c-.483-.009-.966-.015-1.448-.02l.007-.725c.485.005.97.011%201.454.02l-.013.725zm-7.239.01l-.015-.725c.485-.01.969-.018%201.453-.024l.01.724c-.482.007-.965.015-1.448.025zm10.135.061c-.483-.015-.966-.029-1.449-.041l.019-.725c.484.012.969.026%201.453.041l-.023.725zm-13.029.021l-.027-.725c.485-.018.969-.033%201.453-.047l.02.725c-.482.014-.964.029-1.446.047zm15.924.088c-.483-.021-.966-.042-1.448-.06l.028-.725c.484.018.968.039%201.453.061l-.033.724zm-18.817.04l-.037-.724c.484-.026.967-.049%201.452-.071l.031.724c-.482.021-.964.044-1.446.071zm21.71.109c-.482-.028-.963-.054-1.446-.079l.036-.723c.484.024.969.05%201.452.079l-.042.723zm-24.6.068l-.049-.723c.483-.034.966-.066%201.45-.095l.044.723c-.482.03-.964.062-1.445.095zm27.491.118c-.482-.034-.964-.067-1.446-.098l.047-.724c.483.031.966.064%201.45.098l-.051.724zm-30.376.108l-.064-.722c.483-.042.967-.082%201.449-.119l.057.722c-.481.037-.962.077-1.442.119zm33.265.113l-1.445-.116.056-.722%201.448.116-.059.722zm269.56.01l-.359-.63c.42-.239.838-.479%201.256-.72l.362.627c-.419.243-.838.484-1.259.723zm-305.707.155l-.075-.721c.482-.05.964-.1%201.446-.146l.069.722c-.48.046-.96.095-1.44.145zm39.032.091l-1.443-.132.065-.722%201.446.132-.068.722zm-41.906.24l-.089-.72c.479-.059.961-.116%201.443-.172l.082.72c-.479.055-.958.112-1.436.172zm44.788.048c-.479-.051-.959-.1-1.44-.148l.073-.721c.482.049.963.098%201.444.149l-.077.72zm2.881.322l-1.439-.165.081-.721%201.442.165-.084.721zm-50.538.014l-.103-.717c.48-.069.959-.135%201.44-.2l.096.718c-.477.065-.956.131-1.433.199zm53.414.335l-1.439-.179.089-.72%201.44.18-.09.719zm-56.273.106l-.117-.715c.478-.079.956-.155%201.435-.229l.111.717c-.477.073-.953.148-1.429.227zm311.775.11l-.349-.636c.422-.232.844-.466%201.264-.703l.355.632c-.422.238-.846.473-1.27.707zm-252.632.165l-1.436-.194.095-.719%201.44.195-.099.718zm353.335.115l-.614-.385c.255-.408.507-.817.757-1.229l.62.375c-.252.416-.506.828-.763%201.239zm-415.329.107l-.131-.713c.476-.088.953-.173%201.43-.256l.125.714c-.476.082-.95.168-1.424.255zm64.864.186l-1.435-.207.102-.718%201.437.207-.104.718zm-67.702.37l-.146-.711c.475-.097.95-.193%201.425-.286l.139.711c-.473.093-.946.189-1.418.286zm70.565.065l-1.433-.221.11-.716%201.434.22-.111.717zm244.347.377l-.341-.64c.426-.226.85-.455%201.274-.686l.346.637c-.425.231-.852.461-1.279.689zm-241.487.083l-1.43-.235.116-.714%201.432.233-.118.716zm-76.251.09l-.162-.707c.474-.108.946-.213%201.419-.316l.154.708c-.471.103-.941.208-1.411.315zm79.107.393l-1.428-.244.122-.716%201.43.246-.124.714zm-81.918.281l-.177-.703c.47-.119.941-.234%201.412-.347l.168.705c-.468.112-.936.227-1.403.345zm84.769.226l-1.424-.257.126-.713%201.429.256-.131.714zm337.454.254l-.602-.404c.268-.398.532-.798.794-1.201l.607.395c-.263.406-.53.81-.799%201.21zm-104.245.023l-.333-.644c.429-.222.857-.444%201.284-.668l.336.641c-.428.225-.857.448-1.287.671zm-320.775.235l-.19-.7c.466-.128.934-.254%201.402-.378l.185.701c-.466.124-.931.249-1.397.377zm90.415.016l-1.423-.266.132-.712%201.426.266-.135.712zm2.843.55l-1.421-.277.138-.712%201.423.279-.14.71zm-96.035.232l-.208-.694c.465-.139.93-.276%201.395-.41l.201.697c-.463.133-.926.269-1.388.407zm320.964.284l-.326-.649%201.293-.652.329.648-1.296.653zm-222.089.055l-1.42-.287.143-.711%201.422.287-.145.711zm-101.632.523l-.225-.689c.461-.15.923-.298%201.385-.442l.216.692c-.459.143-.917.289-1.376.439zm104.467.065l-1.417-.297.146-.709%201.421.297-.15.709zm324.427.4l-.589-.423c.281-.39.559-.782.832-1.176l.596.414c-.276.397-.557.792-.839%201.185zm-321.595.206l-1.417-.305.155-.709%201.416.306-.154.708zm213.814.032l-.315-.653c.433-.21.868-.422%201.3-.635l.321.652c-.435.213-.87.425-1.306.636zm-323.851.222l-.241-.683c.458-.162.916-.319%201.375-.474l.232.687c-.456.153-.912.31-1.366.47zm112.868.368l-1.415-.313.156-.708%201.417.312-.158.709zm-115.583.621l-.256-.678c.454-.171.908-.34%201.363-.506l.249.681c-.453.165-.905.333-1.356.503zm118.414.013l-1.414-.318.158-.708%201.415.319-.159.707zm205.529.021l-.307-.657c.437-.203.873-.409%201.309-.617l.311.655c-.437.208-.875.414-1.313.619zm-202.703.625l-1.413-.325.161-.706%201.415.324-.163.707zm311.373.224l-.574-.442c.292-.382.582-.765.869-1.151l.582.434c-.289.388-.582.775-.877%201.159zm-435.302.17l-.272-.672c.449-.182.9-.361%201.349-.537l.264.675c-.447.175-.894.353-1.341.534zm323.991.193l-.297-.661c.441-.197.879-.398%201.318-.599l.303.658c-.442.203-.882.403-1.324.602zm-197.237.068l-1.412-.328.164-.707%201.413.329-.165.706zm2.823.666l-1.411-.334.166-.705%201.412.334-.167.705zm-132.244.182l-.285-.667c.444-.19.891-.379%201.337-.564l.279.669c-.445.185-.888.372-1.331.562zm324.002.259l-.288-.664c.443-.193.885-.387%201.325-.581l.293.662c-.442.196-.885.39-1.33.583zm-188.937.232l-1.41-.338.168-.705%201.41.338-.168.705zm301.099.51l-.563-.458c.305-.374.607-.749.906-1.126l.568.451c-.3.379-.605.757-.911%201.133zm-438.814.157l-.295-.663c.442-.197.885-.393%201.327-.586l.291.664c-.442.193-.882.388-1.323.585zm140.535.011l-1.41-.34.17-.705%201.41.339-.17.706zm183.446.23l-.281-.668c.445-.187.891-.375%201.334-.565l.284.667c-.445.19-.891.379-1.337.566zm-180.628.454l-1.409-.342.171-.705%201.409.342-.171.705zm-145.984.505l-.304-.659c.439-.203.877-.405%201.317-.606l.302.66c-.439.199-.877.402-1.315.605zm323.925.147l-.27-.673c.448-.18.894-.362%201.34-.546l.276.67c-.447.185-.896.368-1.346.549zm-175.123.035l-1.408-.345.171-.704%201.41.345-.173.704zm290.77.688l-.548-.474c.315-.364.627-.73.938-1.1l.555.468c-.313.371-.628.739-.945%201.106zm-287.952%200l-1.41-.345.173-.703%201.409.344-.172.704zm169.605.346l-.264-.676c.451-.175.901-.35%201.349-.529l.266.674c-.45.178-.9.355-1.351.531zm-323.845.013l-.311-.654c.437-.209.874-.415%201.311-.621l.309.656c-.437.205-.873.412-1.309.619zm157.057.331l-1.409-.345.173-.704%201.409.345-.173.704zm164.073.688l-.254-.679c.452-.168.904-.338%201.355-.51l.257.677c-.452.173-.905.343-1.358.512zm-161.256.002l-1.408-.344.171-.704%201.409.345-.172.703zm-162.483.235l-.317-.651%201.306-.632.314.653-1.303.63zm165.302.453l-1.41-.345.172-.704%201.409.343-.171.706zm277.562.107l-.533-.49c.325-.355.648-.713.969-1.072l.541.481c-.323.363-.648.723-.977%201.081zm-121.853.2l-.245-.682c.455-.164.908-.327%201.361-.493l.25.681c-.455.166-.91.331-1.366.494zm-152.892.377l-1.41-.342.171-.705%201.41.342-.171.705zm-170.719.138l-.322-.649%201.302-.641.319.651-1.299.639zm320.869.445l-.235-.685c.457-.157.913-.315%201.367-.474l.241.683c-.458.161-.915.32-1.373.476zm-147.33.095l-1.41-.338.17-.705%201.408.339-.168.704zm2.821.675l-1.411-.335.168-.705%201.41.335-.167.705zm-178.961.072l-.323-.65%201.3-.644.322.65-1.299.644zm320.715.083l-.226-.688c.459-.152.916-.304%201.374-.457l.231.687c-.459.154-.919.306-1.379.458zm125.353.037l-.521-.505c.335-.346.669-.696.998-1.047l.529.497c-.332.353-.668.705-1.006%201.055zm-264.284.474l-1.412-.332.167-.706%201.411.333-.166.705zm136.166.377l-.218-.692c.461-.145.921-.291%201.38-.438l.222.69c-.461.148-.922.294-1.384.44zm-133.341.282l-1.414-.328.165-.707%201.412.329-.163.706zm-187.21.036l-.321-.65%201.299-.645.324.65-1.302.645zm317.772.532l-.206-.695c.461-.137.923-.277%201.385-.419l.212.694c-.463.142-.926.282-1.391.42zm-127.734.08l-1.415-.324.162-.706%201.413.323-.16.707zm256.578.287l-.508-.517c.345-.339.687-.68%201.028-1.021l.513.511c-.342.343-.686.687-1.033%201.027zm-253.749.349l-1.416-.317.159-.707%201.414.316-.157.708zm-195.47.036l-.319-.651%201.301-.64.321.65-1.303.641zm317.586.061l-.198-.696c.464-.132.928-.266%201.392-.401l.202.696c-.465.135-.93.269-1.396.401zm-119.282.527l-1.419-.311.157-.707%201.415.31-.153.708zm116.482.25l-.189-.699c.466-.126.931-.254%201.396-.382l.195.697c-.467.131-.934.258-1.402.384zm-113.646.361l-1.418-.303.151-.709%201.417.303-.15.709zm-203.751.077l-.317-.651%201.305-.635.319.65-1.307.636zm314.588.301l-.179-.702c.468-.119.935-.241%201.401-.363l.185.7c-.469.124-.938.246-1.407.365zm135.137.055l-.495-.529c.353-.33.703-.662%201.052-.996l.502.524c-.351.335-.704.669-1.059%201.001zm-243.135.162l-1.42-.295.148-.71%201.419.296-.147.709zm105.179.486l-.17-.705c.469-.112.938-.228%201.405-.344l.177.703c-.472.117-.941.232-1.412.346zm-102.336.092l-1.422-.288.144-.71%201.421.287-.143.711zm-212.055.162l-.31-.656%201.309-.624.313.654-1.312.626zm214.901.397l-1.424-.277.141-.712%201.421.277-.138.712zm96.66.012l-.16-.707c.471-.107.94-.215%201.411-.325l.165.705c-.471.111-.944.22-1.416.327zm-93.809.529l-1.426-.268.135-.712%201.423.267-.132.713zm90.972.099l-.151-.709c.471-.101.943-.204%201.415-.308l.155.708c-.472.104-.946.207-1.419.309zm141.469.027l-.483-.541c.362-.322.721-.646%201.077-.971l.489.536c-.36.327-.72.653-1.083.976zm-452.829.166l-.303-.658c.438-.202.878-.405%201.316-.611l.307.657c-.44.205-.88.411-1.32.612zm223.242.226l-1.427-.256.13-.714%201.425.257-.128.713zm85.272.168l-.141-.711c.473-.095.947-.19%201.419-.288l.146.709c-.474.099-.949.195-1.424.29zm-82.412.329l-1.43-.245.125-.714%201.426.245-.121.714zm79.56.222l-.133-.713c.474-.088.949-.178%201.423-.27l.137.713c-.476.091-.951.181-1.427.27zm-76.697.252l-1.432-.234.117-.714%201.43.232-.115.716zm-231.62%200l-.292-.663c.442-.195.882-.392%201.323-.591l.299.661c-.443.199-.886.398-1.33.593zm305.456.259l-.124-.715c.477-.081.952-.165%201.427-.249l.127.713c-.476.085-.953.168-1.43.251zm-70.967.187l-1.436-.22.113-.717%201.431.22-.108.717zm218.796.107l-.471-.552c.369-.314.735-.629%201.099-.946l.477.545c-.367.32-.735.638-1.105.953zm-150.697.178l-.112-.716c.477-.075.953-.151%201.43-.23l.117.715c-.478.078-.956.157-1.435.231zm-65.227.137l-1.437-.208.105-.717%201.433.206-.101.719zm-240.035.288l-.281-.668c.446-.187.889-.377%201.334-.569l.288.665c-.447.194-.893.384-1.341.572zm302.389.009l-.103-.718c.478-.068.956-.138%201.432-.211l.109.717c-.479.072-.958.144-1.438.212zm-59.478.095l-1.439-.193.098-.718%201.435.192-.094.719zm56.599.3l-.094-.72c.479-.062.957-.125%201.435-.191l.099.718c-.48.066-.96.13-1.44.193zm-53.717.063l-1.441-.178.089-.719%201.438.177-.086.72zm50.832.293l-.084-.721c.48-.055.959-.113%201.438-.172l.089.719c-.481.06-.962.117-1.443.174zm-47.946.039c-.482-.053-.963-.107-1.445-.163l.084-.72c.48.056.96.109%201.439.162l-.078.721zm45.058.276l-.074-.72c.481-.05.96-.101%201.441-.153l.078.72c-.482.053-.963.104-1.445.153zm-42.169.023c-.483-.048-.964-.096-1.446-.147l.075-.72c.48.05.96.097%201.44.145l-.069.722zm-254.262.005l-.268-.673c.448-.178.896-.358%201.344-.542l.274.67c-.45.184-.899.366-1.35.545zm456.41.161l-.458-.562c.376-.305.749-.614%201.121-.922l.463.558c-.373.31-.748.619-1.126.926zm-162.873.087l-.064-.722c.482-.042.962-.087%201.442-.132l.07.722c-.483.045-.965.09-1.448.132zm-36.381.012c-.484-.041-.966-.084-1.448-.128l.067-.722c.48.044.961.087%201.441.128l-.06.722zm33.487.224l-.055-.724c.481-.034.962-.072%201.443-.111l.059.722c-.483.039-.965.077-1.447.113zm-30.592.006l-1.448-.111.057-.722%201.445.109-.054.724zm27.691.19l-.044-.723c.481-.029.963-.06%201.446-.093l.048.723c-.483.033-.967.064-1.45.093zm-24.791.002c-.483-.029-.967-.059-1.45-.092l.049-.723c.481.033.963.063%201.445.092l-.044.723zm21.89.152l-.034-.723c.482-.023.964-.048%201.446-.073l.038.723c-.483.026-.967.05-1.45.073zm-18.877.009l-.115-.005c-.479-.024-.963-.048-1.447-.074l.04-.723c.481.026.964.05%201.446.073l.104.004-.028.725zm15.973.107l-.024-.725c.482-.015.965-.033%201.447-.052l.029.725c-.485.019-.969.037-1.452.052zm-13.073.006c-.485-.015-.968-.032-1.452-.051l.027-.725c.483.019.965.036%201.447.052l-.022.724zm10.169.068l-.015-.725c.482-.009.965-.02%201.448-.032l.019.725c-.485.012-.969.022-1.452.032zm-7.265.003c-.484-.008-.969-.018-1.453-.031l.019-.725c.482.013.964.023%201.447.031l-.013.725zm-274.49.018l-.252-.68c.453-.168.905-.338%201.357-.511l.258.677c-.453.174-.907.344-1.363.514zm278.848.011l-.003-.725c.483-.002.965-.005%201.448-.011l.008.725c-.484.006-.968.009-1.453.011zm-1.453%200c-.485%200-.969-.003-1.453-.008l.007-.725c.483.005.966.008%201.448.009l-.002.724zm179.456.924l-.446-.57c.381-.298.761-.598%201.139-.899l.452.566c-.38.303-.761.604-1.145.903zm-459.598.039l-.233-.687c.457-.155.912-.312%201.368-.474l.242.683c-.458.162-.917.322-1.377.478zm-2.773.895l-.213-.694c.461-.141.921-.286%201.38-.434l.222.69c-.462.15-.925.296-1.389.438zm-2.802.804l-.188-.7c.465-.125.928-.254%201.391-.387l.201.697c-.467.134-.935.265-1.404.39zm462.857.036l-.435-.581c.388-.29.773-.582%201.157-.876l.441.576c-.386.296-.774.589-1.163.881zm-465.683.668l-.163-.707c.469-.107.937-.219%201.403-.335l.176.703c-.471.117-.943.23-1.416.339zm-36.16.557c-.483-.012-.964-.02-1.445-.023l.005-.725c.485.003.97.011%201.457.023l-.017.725zm-4.33.016l-.026-.725c.484-.017.97-.028%201.458-.035l.009.725c-.482.007-.964.018-1.441.035zm37.64.022l-.135-.712c.473-.089.944-.182%201.414-.28l.148.71c-.475.098-.951.193-1.427.282zm-30.421.069c-.483-.024-.964-.044-1.446-.063l.029-.725c.482.019.967.041%201.452.065l-.035.723zm-10.094.087l-.067-.722c.483-.043.969-.08%201.458-.11l.044.723c-.481.03-.96.066-1.435.109zm12.982.083c-.482-.032-.963-.063-1.444-.091l.042-.723c.483.028.967.058%201.451.09l-.049.724zm2.893.203l-1.446-.104.052-.723%201.447.104-.053.723zm490.822.022l-.425-.588c.393-.282.784-.567%201.174-.854l.43.583c-.392.289-.785.574-1.179.859zm-469.051.013l-.105-.719c.476-.068.95-.142%201.422-.219l.119.714c-.478.079-.956.153-1.436.224zm-40.499.032l-.115-.715c.48-.076.963-.145%201.448-.205l.089.719c-.477.058-.951.126-1.422.201zm21.62.147l-1.447-.107.054-.723%201.445.106-.052.724zm15.988.166l-.071-.722c.479-.045.956-.098%201.433-.155l.087.719c-.482.058-.966.111-1.449.158zm-13.091.03l-1.448-.095.048-.723%201.445.095-.045.723zm2.903.157c-.482-.021-.966-.046-1.451-.071l.038-.724c.483.026.965.05%201.446.071l-.033.724zm7.281.026l-.036-.724c.48-.024.958-.053%201.435-.088l.055.723c-.483.036-.967.065-1.454.089zm-37.511.048l-.176-.704c.472-.118.949-.226%201.43-.324l.144.712c-.47.094-.936.2-1.398.316zm33.14.014c-.484-.007-.97-.018-1.456-.033l.022-.725c.483.015.965.026%201.444.033l-.01.725zm1.456.011l-.003-.725c.482-.002.963-.008%201.443-.02l.018.725c-.485.012-.97.018-1.458.02zm-37.336.803l-.245-.682c.46-.165.925-.319%201.394-.46l.21.693c-.458.139-.911.288-1.359.449zm512.719.239l-.413-.596c.398-.276.794-.553%201.189-.833l.419.592c-.397.281-.795.56-1.195.837zm-515.348.88l-.322-.65c.44-.218.886-.423%201.337-.615l.283.667c-.437.187-.87.385-1.298.598zm512.94.763l-.404-.602c.403-.27.804-.541%201.204-.813l.408.599c-.401.273-.804.546-1.208.816zm-515.41.66l-.401-.604c.412-.273.829-.531%201.253-.774l.361.628c-.409.236-.815.486-1.213.75zm512.974.945l-.394-.609c.408-.263.814-.529%201.216-.795l.399.606c-.406.266-.812.533-1.221.798zm-515.246.778l-.474-.548c.375-.324.757-.632%201.145-.927l.437.578c-.375.284-.746.583-1.108.897zm512.788.788l-.385-.615c.41-.257.819-.516%201.228-.776l.389.612c-.41.261-.821.52-1.232.779zm-514.808%201.216l-.547-.478c.321-.367.661-.729%201.01-1.075l.511.515c-.337.334-.665.683-.974%201.038zm512.328.313l-.377-.62c.415-.251.827-.503%201.238-.757l.381.617c-.413.254-.827.508-1.242.76zm-2.501%201.495l-.368-.625c.417-.246.833-.492%201.249-.741l.371.623c-.416.248-.834.496-1.252.743zm-511.536.467l-.61-.391c.265-.415.549-.823.841-1.213l.581.435c-.283.376-.556.769-.812%201.169zm509.017.995l-.36-.629c.42-.24.839-.482%201.257-.725l.364.627c-.419.243-.84.486-1.261.727zm-2.535%201.432l-.352-.633c.422-.236.844-.473%201.265-.711l.356.632c-.422.238-.845.476-1.269.712zm-507.84.074l-.66-.301c.204-.448.426-.893.657-1.32l.637.346c-.224.413-.437.842-.634%201.275zm505.29%201.328l-.345-.637c.425-.231.85-.462%201.274-.695l.348.635c-.425.233-.85.466-1.277.697zm-506.286%201.34l-.695-.207c.139-.467.297-.936.468-1.397l.68.253c-.167.445-.319.901-.453%201.351zm503.721.033l-.338-.641c.427-.226.854-.453%201.28-.681l.343.639c-.427.229-.856.456-1.285.683zm-2.575%201.349l-.333-.644%201.287-.669.335.643-1.289.67zm-2.588%201.323l-.327-.647%201.292-.658.329.646-1.294.659zm-499.196.074l-.715-.117c.079-.486.175-.967.284-1.444l.706.161c-.106.463-.198.93-.275%201.4zm496.599%201.227l-.322-.65%201.297-.646.324.648-1.299.648zm-2.606%201.278l-.318-.651%201.303-.636.318.651-1.303.636zm-494.293.334l-.723-.034c.022-.491.06-.98.111-1.465l.72.074c-.049.474-.085.949-.108%201.425zm491.678.926l-.313-.654%201.307-.625.314.652-1.308.627zm-2.619%201.243l-.309-.656%201.31-.618.309.656-1.31.618zm-489.767.732c-.029-.49-.044-.98-.047-1.467l.725-.004c.003.475.018.951.046%201.428l-.724.043zm487.139.494l-.304-.659%201.311-.609.307.657-1.314.611zm-2.631%201.21l-.302-.66%201.315-.603.303.659-1.316.604zm-2.637%201.198l-.298-.661%201.318-.596.3.66-1.32.597zm-481.555.013c-.077-.485-.142-.97-.194-1.454l.721-.078c.051.473.114.945.189%201.418l-.716.114zm478.916%201.172l-.296-.661%201.319-.591.297.661-1.32.591zm-2.642%201.175l-.293-.662%201.32-.586.294.662-1.321.586zm-475.684.522c-.121-.474-.23-.951-.329-1.428l.711-.145c.095.465.203.93.321%201.394l-.703.179zm473.036.648l-.293-.664%201.327-.585.293.664-1.327.585zm-2.658%201.165l-.29-.664%201.328-.581.289.664-1.327.581zm-469.53.993c-.162-.462-.313-.927-.455-1.394l.694-.209c.138.457.287.91.446%201.362l-.685.241zm466.874.172l-.292-.664%201.329-.582.291.664-1.328.582zm-2.656%201.164l-.292-.664%201.329-.582.291.664-1.328.582zm-2.656%201.165l-.292-.664%201.329-.582.291.664-1.328.582zm-460.472.218c-.201-.447-.392-.896-.574-1.348l.673-.271c.177.444.366.884.562%201.319l-.661.3zm120.466.918c-.445-.008-.89-.011-1.335-.011h-.111v-.725h.111c.449%200%20.897.003%201.346.011l-.011.725zm337.35.028l-.292-.664%201.329-.582.291.664-1.328.582zm-341.682.016l-.027-.724c.486-.019.972-.032%201.456-.041l.014.725c-.48.009-.962.022-1.443.04zm7.219.053c-.481-.025-.962-.045-1.443-.061l.024-.725c.486.016.97.037%201.456.062l-.037.724zm-10.102.106l-.053-.723c.485-.035.969-.066%201.454-.093l.04.724c-.48.026-.96.057-1.441.092zm12.983.088c-.479-.041-.959-.077-1.44-.11l.049-.723c.484.033.968.07%201.452.11l-.061.723zm-15.857.178l-.08-.721c.484-.054.966-.103%201.449-.148l.067.723c-.479.044-.957.092-1.436.146zm18.73.109c-.48-.056-.957-.107-1.436-.156l.073-.72c.483.047.965.1%201.446.155l-.083.721zm-21.593.261l-.106-.716c.464-.07.927-.134%201.393-.195l.096.353.047.359c-.51.067-.971.132-1.43.199zm24.454.117c-.475-.071-.953-.138-1.429-.2l.095-.72c.481.064.96.132%201.44.203l-.106.717zm323.191.236l-.292-.664%201.329-.582.291.664-1.328.582zm-350.49.124l-.132-.713c.477-.089.955-.172%201.433-.253l.121.715c-.475.079-.949.163-1.422.251zm30.148.104c-.474-.083-.948-.164-1.423-.243l.118-.714c.477.077.954.159%201.431.244l-.126.713zm-133.498.278c-.238-.426-.468-.858-.688-1.294l.648-.325c.215.425.439.848.673%201.265l-.633.354zm100.519.188l-.154-.709c.473-.102.948-.202%201.422-.299l.145.711c-.472.095-.942.194-1.413.297zm35.811.079c-.471-.097-.943-.192-1.415-.282l.137-.712c.475.092.95.187%201.425.285l-.147.709zm314.854.391l-.292-.664%201.329-.582.29.664-1.327.582zm-353.478.186l-.175-.704c.472-.117.943-.23%201.415-.34l.165.704c-.468.111-.937.224-1.405.34zm41.441.048c-.469-.11-.937-.217-1.407-.321l.158-.708c.472.105.943.212%201.415.325l-.166.704zm-44.238.685l-.192-.7c.468-.128.937-.254%201.405-.377l.184.701c-.466.123-.931.247-1.397.376zm47.038.013c-.465-.122-.931-.242-1.398-.358l.176-.704c.469.119.938.238%201.406.361l-.184.701zm306.581.232l-.292-.664%201.329-.582.29.664-1.327.582zm-303.801.536c-.463-.135-.925-.265-1.388-.392l.193-.7c.466.129.932.261%201.397.395l-.202.697zm-52.6.016l-.206-.695c.464-.138.929-.275%201.394-.408l.201.696c-.463.134-.925.269-1.389.407zm-90.586.119c-.274-.403-.541-.813-.798-1.23l.617-.38c.252.406.511.807.781%201.202l-.6.408zm444.33.493l-.291-.664%201.328-.582.29.664-1.327.582zm-298.38.206c-.459-.145-.919-.286-1.38-.426l.21-.694c.463.14.924.283%201.387.427l-.217.693zm-58.129.036l-.22-.691c.462-.146.924-.292%201.386-.436l.216.693c-.461.143-.922.287-1.382.434zm60.873.859c-.456-.155-.913-.307-1.37-.455l.225-.69c.46.15.919.303%201.377.458l-.232.687zm-63.626.04l-.23-.686c.46-.154.919-.307%201.379-.457l.225.689c-.458.149-.916.302-1.374.454zm356.605.024l-.291-.664%201.329-.582.29.664-1.328.582zm-439.918.692c-.31-.378-.611-.763-.904-1.156l.58-.433c.287.383.582.76.885%201.129l-.561.46zm149.663.197c-.453-.163-.906-.324-1.359-.483l.239-.684c.456.159.912.321%201.367.486l-.247.681zm-69.092.025l-.238-.685%201.373-.473.235.685-1.37.473zm356.691.25l-.291-.664%201.329-.582.29.664-1.328.582zm-359.424.712l-.243-.682%201.368-.486.242.683-1.367.485zm74.531.021c-.45-.172-.901-.342-1.351-.51l.253-.68c.453.17.905.34%201.357.513l-.259.677zm282.237.431l-.291-.664%201.329-.581.29.664-1.328.581zm-359.495.531l-.248-.682%201.366-.493.244.682-1.362.493zm-73.147.013c-.343-.346-.679-.702-1.007-1.066l.538-.486c.32.356.648.704.984%201.041l-.515.511zm153.093.084c-.447-.18-.894-.358-1.342-.536l.266-.673c.449.177.899.356%201.347.537l-.271.672zm276.893.536l-.292-.664%201.329-.582.29.664-1.327.582zm-359.566.356l-.248-.681%201.363-.496.248.681-1.363.496zm85.342.215c-.444-.188-.888-.375-1.333-.558l.278-.67c.447.185.893.372%201.338.561l-.283.667zm271.568.593l-.292-.664%201.329-.581.29.664-1.327.581zm-359.637.184l-.246-.682%201.361-.495.25.682-1.365.495zm-65.526.014c-.378-.311-.748-.633-1.109-.965l.49-.534c.351.323.711.636%201.08.94l-.461.559zm156.246.36c-.441-.196-.882-.389-1.324-.581l.289-.665c.443.193.885.386%201.329.583l-.294.663zm-93.45.607l-.244-.683%201.364-.488.245.682-1.365.489zm359.711%200l-.292-.664%201.329-.582.29.664-1.327.582zm-263.627.585c-.438-.202-.877-.402-1.315-.601l.299-.66c.44.199.88.401%201.319.603l-.303.658zm-156.522.2c-.408-.27-.809-.553-1.203-.845l.432-.582c.384.286.774.56%201.172.823l-.401.604zm57.699.178l-.238-.685%201.368-.479.241.685-1.371.479zm359.794.201l-.292-.664%201.329-.582.29.664-1.327.582zm-258.354.653c-.435-.209-.87-.416-1.307-.621l.309-.656c.437.205.875.413%201.311.622l-.313.655zm-104.189.082l-.229-.687c.458-.153.914-.307%201.37-.463l.236.685c-.458.157-.918.312-1.377.465zm-52.433.391c-.429-.233-.853-.475-1.273-.725l.372-.623c.412.246.828.483%201.248.711l-.347.637zm412.319.039l-.291-.664%201.328-.582.29.664-1.327.582zm-362.648.469l-.218-.69c.46-.146.919-.293%201.377-.443l.225.689c-.461.15-.922.299-1.384.444zm109.554.285l-1.299-.638.317-.651%201.303.639-.321.65zm250.438.41l-.292-.664%201.329-.582.29.664-1.327.582zm-407.044.101c-.443-.201-.884-.41-1.322-.627l.323-.649c.429.214.862.419%201.297.615l-.298.661zm44.275.059l-.206-.695.351-.105c.345-.103.689-.208%201.033-.313l.213.692c-.346.106-.692.211-1.038.314l-.353.107zm114.917.73c-.43-.22-.861-.438-1.292-.654l.326-.648c.433.218.864.435%201.296.656l-.33.646zm-117.72.062l-.186-.701c.465-.125.93-.253%201.392-.384l.198.697c-.467.132-.933.261-1.404.388zm362.916.212l-.292-.664%201.329-.582.29.664-1.327.582zm-401.679.045c-.457-.168-.912-.344-1.365-.529l.275-.672c.444.182.89.356%201.339.52l-.249.681zm35.943.458l-.169-.705c.47-.112.937-.228%201.405-.346l.178.702c-.47.12-.942.236-1.414.349zm-33.164.454c-.469-.136-.935-.281-1.398-.433l.226-.689c.455.15.912.292%201.373.425l-.201.697zm156.277.099c-.428-.224-.856-.447-1.285-.668l.332-.645c.431.224.861.446%201.29.671l-.337.642zm-125.954.083l-.147-.71c.471-.098.943-.199%201.412-.304l.159.706c-.473.107-.948.209-1.424.308zm365.921.025l-.292-.664%201.329-.582.29.664-1.327.582zm-393.414.516c-.476-.106-.951-.219-1.422-.339l.18-.702c.465.119.93.229%201.399.333l-.157.708zm24.634.008l-.124-.714c.474-.083.947-.17%201.42-.261l.137.711c-.476.092-.954.181-1.433.264zm-2.876.458l-.101-.719c.476-.066.951-.137%201.428-.214l.114.717c-.48.076-.96.148-1.441.216zm-18.887.079c-.481-.076-.961-.16-1.439-.25l.134-.712c.471.089.944.171%201.418.246l-.113.716zm387.886.103l-.292-.664%201.329-.582.291.664-1.328.582zm-234.752.087c-.426-.23-.852-.457-1.278-.684l.34-.64c.428.227.855.455%201.282.685l-.344.639zm-137.138.086l-.074-.721c.478-.05.956-.105%201.434-.163l.088.719c-.483.06-.965.114-1.448.165zm-13.102.1c-.484-.049-.968-.105-1.45-.168l.094-.719c.474.063.951.117%201.43.166l-.074.721zm10.198.146l-.047-.723c.48-.031.959-.067%201.439-.108l.061.722c-.484.041-.969.078-1.453.109zm-7.286.071c-.487-.024-.972-.053-1.457-.09l.054-.723c.479.036.958.066%201.438.089l-.035.724zm4.374.055l-.016-.724c.48-.011.96-.027%201.442-.048l.031.724c-.486.022-.972.038-1.457.048zm-1.458.016c-.487%200-.974-.006-1.458-.018l.018-.725c.48.012.96.018%201.441.018l-.001.725zm376.508.603l-.292-.664%201.329-.582.291.664-1.328.582zm-229.549.307c-.422-.233-.846-.465-1.271-.695l.345-.637c.426.23.852.464%201.276.696l-.35.636zm226.893.858l-.292-.664%201.329-.582.291.664-1.328.582zm-224.356.548l-1.267-.706.351-.634%201.269.708-.353.632zm221.7.616l-.293-.664%201.329-.582.291.664-1.327.582zm-219.174.812l-1.261-.716.356-.631%201.264.717-.359.63zm216.518.352l-.293-.664%201.329-.581.291.664-1.327.581zm-214.002%201.095l-1.257-.725.361-.629%201.26.727-.364.627zm211.345.069l-.292-.664%201.329-.582.29.664-1.327.582zm-2.657%201.164l-.291-.664%201.328-.581.29.664-1.327.581zm-206.178.232l-1.254-.734.366-.626%201.255.735-.367.625zm203.522.933l-.291-.664%201.328-.582.29.664-1.327.582zm-201.019.545l-1.252-.74.37-.625%201.251.742-.369.623zm198.363.619l-.291-.664%201.328-.582.29.664-1.327.582zm-195.873.87l-1.244-.746.372-.621%201.246.746-.374.621zm193.217.295l-.291-.664%201.328-.582.29.664-1.327.582zm-2.657%201.164l-.291-.664%201.329-.582.29.664-1.328.582zm-188.078.034l-1.239-.746.374-.622%201.239.747-.374.621zm185.422%201.13l-.291-.664%201.329-.582.29.664-1.328.582zm-182.945.364l-1.239-.748.375-.619%201.239.747-.375.62zm180.289.8l-.291-.664%201.329-.582.29.664-1.328.582zm-177.807.694l-1.24-.746.374-.622%201.24.747-.374.621zm175.151.47l-.292-.664%201.329-.582.29.664-1.327.582zm-172.666%201.02l-1.244-.745.374-.621%201.241.744-.371.622zm170.01.144l-.292-.664%201.329-.582.29.664-1.327.582zm-2.656%201.165l-.292-.664%201.329-.582.29.664-1.327.582zm-164.866.175l-1.245-.741.371-.623%201.245.741-.371.623zm162.21.989l-.292-.664%201.328-.582.291.664-1.327.582zm-159.713.488l-1.249-.738.369-.624%201.247.737-.367.625zm157.056.676l-.292-.664%201.329-.581.29.664-1.327.581zm-154.553.79l-1.253-.732.367-.626%201.252.731-.366.627zm151.897.375l-.292-.664%201.329-.582.29.664-1.327.582zm-149.386%201.078l-1.257-.726.363-.627%201.257.724-.363.629zm146.73.085l-.292-.664%201.329-.582.29.664-1.327.582zm-2.657%201.165l-.292-.664%201.329-.582.29.664-1.327.582zm-141.549.187l-1.263-.716.36-.63%201.259.716-.356.63zm138.893.977l-.292-.664%201.329-.582.29.664-1.327.582zm-136.36.443l-1.268-.707.353-.633%201.267.705-.352.635zm133.703.722l-.291-.664%201.329-.582.29.664-1.328.582zm-131.156.68l-1.275-.698.35-.636%201.271.696-.346.638zm128.5.484l-.292-.664%201.329-.582.291.664-1.328.582zm-125.94.891c-.428-.227-.856-.455-1.282-.685l.343-.638c.426.23.852.456%201.279.684l-.34.639zm123.282.271l-.29-.664%201.329-.58.29.664-1.329.58zm-120.707%201.081l-1.289-.672.336-.642%201.287.671-.334.643zm118.045.081l-.289-.666%201.332-.578.289.664-1.332.58zm-2.666%201.152l-.287-.666%201.333-.575.287.666-1.333.575zm-112.788.09c-.434-.219-.866-.438-1.298-.658l.33-.646c.431.221.862.439%201.293.655l-.325.649zm110.118%201.05l-.283-.667%201.334-.568.285.667-1.336.568zm-107.511.241c-.436-.212-.871-.427-1.306-.642l.321-.649c.433.215.868.428%201.302.64l-.317.651zm104.834.884l-.279-.67%201.337-.559.281.668-1.339.561zm-102.208.371c-.44-.207-.877-.415-1.315-.623l.313-.654c.436.209.873.415%201.31.621l-.308.656zm99.523.734l-.273-.67c.448-.182.894-.366%201.34-.549l.276.67c-.447.184-.895.367-1.343.549zm-96.88.486c-.441-.199-.882-.401-1.323-.605l.303-.658c.44.203.879.404%201.319.602l-.299.661zm94.186.597l-.267-.674c.448-.178.897-.356%201.344-.537l.271.672c-.449.181-.898.36-1.348.539zm-91.523.58c-.444-.193-.889-.387-1.333-.583l.293-.663c.443.195.885.389%201.329.581l-.289.665zm88.819.476l-.261-.677c.45-.173.901-.347%201.349-.523l.264.676c-.45.175-.901.351-1.352.524zm-86.135.657c-.449-.185-.896-.372-1.343-.56l.281-.668c.447.188.893.374%201.338.558l-.276.67zm83.417.369l-.252-.68c.452-.168.904-.337%201.355-.507l.256.678c-.453.171-.906.34-1.359.509zm-80.714.716c-.453-.177-.904-.355-1.355-.537l.271-.672c.448.179.897.358%201.347.533l-.263.676zm77.985.275l-.242-.684c.454-.16.908-.324%201.361-.488l.248.681c-.456.165-.911.329-1.367.491zm-75.262.758c-.455-.168-.91-.337-1.364-.51l.257-.678c.452.172.905.341%201.357.508l-.25.68zm72.519.192l-.233-.686c.456-.155.912-.311%201.368-.469l.238.685c-.458.159-.915.315-1.373.47zm-69.775.785c-.458-.158-.917-.318-1.375-.482l.244-.682c.455.162.911.322%201.367.479l-.236.685zm67.016.125l-.221-.691c.458-.147.917-.296%201.374-.447l.228.688c-.46.152-.92.302-1.381.45zm-64.252.793c-.463-.148-.925-.298-1.386-.451l.23-.688c.458.153.916.302%201.377.448l-.221.691zm61.479.068l-.208-.694c.46-.139.921-.279%201.382-.423l.215.693c-.462.143-.926.284-1.389.424zm-58.694.785c-.466-.136-.931-.276-1.396-.419l.213-.693c.461.143.924.281%201.386.417l-.203.695zm55.905.024l-.195-.698c.463-.13.927-.261%201.389-.396l.203.696c-.466.135-.93.268-1.397.398zm-2.807.754l-.181-.703c.467-.119.932-.242%201.397-.367l.189.7c-.468.126-.937.248-1.405.37zm-50.295.01c-.469-.125-.937-.253-1.405-.385l.196-.698c.464.13.93.258%201.396.382l-.187.701zm47.473.681l-.165-.707c.469-.108.938-.221%201.405-.335l.173.704c-.471.115-.942.228-1.413.338zm-44.65.034c-.473-.113-.944-.23-1.414-.349l.178-.702c.467.118.935.234%201.404.346l-.168.705zm41.812.592l-.148-.709c.472-.099.942-.2%201.414-.303l.155.707c-.474.105-.947.207-1.421.305zm-38.974.047c-.474-.1-.949-.204-1.421-.31l.159-.707c.469.106.94.208%201.411.307l-.149.71zm36.119.508l-.129-.713c.474-.086.948-.175%201.42-.267l.138.712c-.476.093-.952.182-1.429.268zm-33.265.054c-.478-.087-.953-.177-1.429-.272l.14-.71c.471.093.945.183%201.418.268l-.129.714zm30.396.424l-.109-.716c.476-.073.951-.148%201.426-.228l.119.715c-.478.079-.957.156-1.436.229zm-27.529.052c-.479-.072-.957-.149-1.434-.228l.118-.715c.474.079.949.154%201.426.227l-.11.716zm24.645.347l-.089-.719c.479-.059.956-.123%201.433-.188l.099.718c-.48.067-.961.13-1.443.189zm-21.765.044c-.481-.057-.961-.119-1.441-.184l.098-.718c.475.064.952.126%201.429.183l-.086.719zm18.871.268l-.067-.722c.48-.044.959-.092%201.439-.144l.077.72c-.482.053-.965.102-1.449.146zm-15.983.034c-.482-.041-.964-.089-1.445-.139l.075-.721c.477.049.955.097%201.432.138l-.062.722zm13.078.188l-.044-.723c.48-.029.961-.062%201.441-.099l.056.722c-.484.038-.969.071-1.453.1zm-10.185.023c-.483-.027-.965-.058-1.448-.093l.053-.723c.477.034.957.066%201.436.093l-.041.723zm7.273.106l-.02-.725c.482-.013.964-.031%201.446-.051l.031.725c-.486.02-.971.038-1.457.051zm-4.368.009c-.486-.011-.97-.027-1.454-.046l.029-.725c.479.019.959.035%201.44.046l-.015.725zm2.011.024l-.559-.002.005-.724.552.001.892-.005.01.725-.9.005z'%20/%3e%3cpath%20fill='%23e1deff'%20d='M441.2%2063.532c-12.923%200-25.838.227-38.704.769-5.816.243-11.494.533-16.878.858-53.585%203.236-95.855%2011.105-133.028%2024.768-13.245%204.868-25.539%2011.664-37.428%2018.238-8.33%204.606-16.944%209.368-25.795%2013.414-15.35%207.017-31.733%2012.845-47.577%2018.482-10.559%203.757-21.479%207.641-31.95%2011.83-35.142%2013.393-71.474%2027.239-101.568%2051.033-15.496%2012.252-28.475%2027.11-37.534%2042.967-10.057%2017.603-15.036%2035.681-14.802%2053.731.373%2028.756%2013.997%2055.856%2026.018%2079.766l94.853%20188.676c14.812%2029.461%2030.127%2059.925%2053.175%2084.412%2035.69%2037.922%2089.992%2059.304%20147.262%2059.307%2011.729%200%2023.57-.896%2035.414-2.73%2049.091-7.602%2096.045-29.732%20141.453-51.134%2030.939-14.582%2062.932-29.661%2094.895-39.71%2035.814-11.258%2068.02-14.941%2098.455-11.255%2028.8%203.487%2056.846%2013.921%2083.968%2024.013%2035.539%2013.224%2072.284%2026.901%20110.363%2024.509%2032.749-2.054%2063.984-15.623%2092.835-40.328%2025.306-21.667%2047.24-50.805%2063.433-84.263%2018.295-37.802%2030.02-78.949%2041.359-118.743%207.558-26.524%2015.373-53.951%2025.074-80.201%206.347-17.175%2013.679-34.33%2020.77-50.92%2012.853-30.067%2026.142-61.159%2033.989-93.405%2014.139-58.104%206.074-111.773-22.128-147.243-15.174-19.086-36.054-33.303-62.061-42.256-23.424-8.065-49.89-11.295-76.547-9.346-49.417%203.617-96.692%2022.418-142.412%2040.601l-5.085%202.022c-51.681%2020.529-98.538%2037.59-148.651%2038.396-39.454.638-79.621-1.245-118.465-3.065-33.689-1.577-68.216-3.193-102.703-3.193M277.248%20712.507c-57.473%200-111.964-21.464-147.795-59.533-23.119-24.565-38.458-55.077-53.292-84.584l-94.856-188.677c-12.054-23.979-25.718-51.158-26.094-80.081-.236-18.182%204.776-36.384%2014.897-54.101%209.106-15.936%2022.146-30.866%2037.714-43.176%2030.182-23.863%2066.568-37.729%20101.755-51.139%2010.478-4.191%2021.404-8.079%2031.97-11.838%2015.83-5.631%2032.198-11.454%2047.519-18.459%208.825-4.034%2017.427-8.789%2025.745-13.389%2011.913-6.587%2024.232-13.396%2037.528-18.284%2037.242-13.687%2079.578-21.57%20133.235-24.81l.022.361-.022-.361c5.388-.326%2011.071-.616%2016.89-.86%2047.24-1.984%2095.144.257%20141.473%202.425%2038.831%201.819%2078.984%203.702%20118.42%203.064%2049.989-.805%2096.781-17.842%20148.395-38.346l5.084-2.021c45.771-18.202%2093.099-37.025%20142.628-40.651%2026.748-1.955%2053.317%201.288%2076.835%209.384%2026.139%209%2047.131%2023.295%2062.393%2042.49%2028.342%2035.648%2036.457%2089.543%2022.264%20147.866-7.86%2032.305-21.162%2063.425-34.026%2093.52-7.087%2016.581-14.417%2033.727-20.758%2050.887-9.691%2026.222-17.501%2053.636-25.056%2080.147-11.347%2039.823-23.081%2081.002-41.403%20118.859-16.237%2033.548-38.234%2062.767-63.614%2084.499-28.975%2024.809-60.352%2038.436-93.262%2040.5-38.224%202.401-75.051-11.302-110.661-24.552-27.082-10.077-55.088-20.497-83.801-23.974-30.334-3.671-62.438.002-98.151%2011.229-31.917%2010.032-63.886%2025.101-94.804%2039.673-45.454%2021.423-92.456%2043.576-141.651%2051.195-11.876%201.839-23.761%202.737-35.521%202.737'%20/%3e%3cpath%20fill='%23bab5fc'%20d='M232.194%20541.821h7.661l3.831-6.635-3.831-6.636h-7.661l-3.831%206.636%203.831%206.635zm8.08.725h-8.499l-4.249-7.36%204.249-7.361h8.499l4.249%207.361-4.249%207.36z'%20/%3e%3cpath%20fill='%23bab5fc'%20d='M235.096%20536.795h1.858l.93-1.61-.93-1.608h-1.858l-.93%201.608.93%201.61zm2.276.725h-2.695l-1.348-2.335%201.348-2.333h2.695l1.348%202.333-1.348%202.335zM248.466%20550.984h7.66l3.832-6.635-3.832-6.636h-7.66l-3.832%206.636%203.832%206.635zm8.079.725h-8.498l-4.25-7.36%204.25-7.361h8.498l4.25%207.361-4.25%207.36z'%20/%3e%3cpath%20fill='%23bab5fc'%20d='M251.367%20545.958h1.858l.93-1.609-.93-1.61h-1.858l-.93%201.61.93%201.609zm2.277.725h-2.696l-1.348-2.334%201.348-2.335h2.696l1.347%202.335-1.347%202.334zM867.903%20265.119h7.661l3.832-6.635-3.832-6.635h-7.661l-3.831%206.635%203.831%206.635zm8.08.725h-8.499l-4.248-7.36%204.248-7.36h8.499l4.249%207.36-4.249%207.36z'%20/%3e%3cpath%20fill='%23bab5fc'%20d='M870.805%20260.093h1.858l.929-1.609-.929-1.609h-1.858l-.929%201.609.929%201.609zm2.277.725h-2.696l-1.348-2.334%201.348-2.334h2.696l1.347%202.334-1.347%202.334zM228.138%20286.293h14.326v-14.326h-14.326v14.326zm-.725.725h15.776v-15.776h-15.776v15.776z'%20/%3e%3cpath%20fill='%23bab5fc'%20d='M233.399%20281.032h3.804v-3.804h-3.804v3.804zm-.725.725h5.253v-5.254h-5.253v5.254zM927.807%20152.638h16.176l-8.089-14.009-8.087%2014.009zm17.432.725h-18.688l9.343-16.184%209.345%2016.184z'%20/%3e%3cpath%20fill='%23bab5fc'%20d='M934.159%20149.17h3.47l-1.734-3.005-1.736%203.005zm4.727.725h-5.982l2.991-5.18%202.991%205.18zM245.388%20130.804h11.89l-5.945-10.298-5.945%2010.298zm13.146.724h-14.402l7.201-12.472%207.201%2012.472z'%20/%3e%3cpath%20fill='%23bab5fc'%20d='M250.179%20128.189h2.309l-1.154-2-1.155%202zm3.564.724h-4.82l2.411-4.174%202.409%204.174zM227.573%20130.804h11.891l-5.946-10.298-5.945%2010.298zm13.147.724h-14.402l7.2-12.472%207.202%2012.472z'%20/%3e%3cpath%20fill='%23bab5fc'%20d='M232.365%20128.189h2.308l-1.154-2-1.154%202zm3.564.724h-4.82l2.41-4.174%202.41%204.174zM868.187%20383.381c-6.353%200-11.52%205.168-11.52%2011.519s5.167%2011.519%2011.52%2011.519c6.351%200%2011.519-5.168%2011.519-11.519s-5.168-11.519-11.519-11.519m0%2023.763c-6.752%200-12.245-5.493-12.245-12.244%200-6.751%205.493-12.244%2012.245-12.244%206.751%200%2012.244%205.493%2012.244%2012.244%200%206.751-5.493%2012.244-12.244%2012.244'%20/%3e%3cpath%20fill='%23bab5fc'%20d='M868.187%20392.812c-1.152%200-2.089.937-2.089%202.088s.937%202.088%202.089%202.088c1.151%200%202.087-.937%202.087-2.088s-.936-2.088-2.087-2.088m0%204.901c-1.552%200-2.814-1.262-2.814-2.813%200-1.551%201.262-2.813%202.814-2.813%201.551%200%202.812%201.262%202.812%202.813%200%201.551-1.261%202.813-2.812%202.813M896.137%20406.539c-3.793%200-6.88%203.087-6.88%206.88%200%203.794%203.087%206.88%206.88%206.88%203.794%200%206.88-3.086%206.88-6.88%200-3.793-3.086-6.88-6.88-6.88m0%2014.485c-4.193%200-7.604-3.411-7.604-7.605%200-4.193%203.411-7.605%207.604-7.605%204.194%200%207.605%203.412%207.605%207.605%200%204.194-3.411%207.605-7.605%207.605'%20/%3e%3cpath%20fill='%23bab5fc'%20d='M896.137%20412.288c-.623%200-1.131.508-1.131%201.132%200%20.623.508%201.131%201.131%201.131.624%200%201.132-.508%201.132-1.131%200-.624-.508-1.132-1.132-1.132m0%202.987c-1.023%200-1.856-.832-1.856-1.855%200-1.025.833-1.857%201.856-1.857%201.024%200%201.857.832%201.857%201.857%200%201.023-.833%201.855-1.857%201.855'%20/%3e%3c/svg%3e";
const TOTAL_HEADER_HEIGHT$1 = NAVBAR_HEIGHT + SUB_NAVBAR_HEIGHT;
const styles$22 = (theme2) => ({
  root: {
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    height: `calc(100% - ${TOTAL_HEADER_HEIGHT$1}px)`,
    position: "fixed",
    zIndex: MAIN_FIXED_ZINDEX,
    top: TOTAL_HEADER_HEIGHT$1,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "auto",
    paddingBottom: "env(safe-area-inset-bottom)",
    paddingLeft: "env(safe-area-inset-left)",
    paddingRight: "env(safe-area-inset-right)",
    "-webkit-overflow-scrolling": "touch",
    opacity: 1,
    transition: "opacity 250ms linear 250ms",
    '&[aria-busy="true"]': {
      opacity: 0
    }
  },
  bg: {
    position: "fixed",
    zIndex: BG_FIXED_ZINDEX,
    left: 0,
    right: 0,
    bottom: 0,
    top: TOTAL_HEADER_HEIGHT$1,
    overflow: "hidden",
    backgroundColor: theme2.indigo1
  },
  bgLightTheme: {
    backgroundColor: theme2.white1
  },
  bgGreyTheme: {
    backgroundColor: theme2.grey8
  },
  bgImage: {
    height: `100%`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: `50%`,
    backgroundImage: (props2) => `url(${props2.lightTheme ? kanbanMainBgSvgLight : kanbanMainBgSvg})`
  },
  bgLoader: {
    height: "100%",
    opacity: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "opacity 250ms linear 250ms",
    '&[data-loading="true"]': {
      opacity: 1
    }
  }
});
class KanbanMain extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children, lightTheme, greyTheme, loading } = this.props;
      return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
        /* @__PURE__ */ jsx$1("div", { className: classes.root, "aria-busy": loading, children }),
        /* @__PURE__ */ jsx$1(
          "div",
          {
            className: classNames(classes.bg, {
              [classes.bgLightTheme]: lightTheme,
              [classes.bgGreyTheme]: greyTheme
            }),
            role: "none",
            children: greyTheme ? /* @__PURE__ */ jsx$1("div", { className: classes.bgLoader, "data-loading": loading, children: /* @__PURE__ */ jsx$1(LoaderTraceLogo$1, { light: lightTheme }) }) : /* @__PURE__ */ jsx$1("div", { className: classes.bgImage, role: "none", children: /* @__PURE__ */ jsx$1("div", { className: classes.bgLoader, "data-loading": loading, children: /* @__PURE__ */ jsx$1(LoaderTraceLogo$1, { light: lightTheme }) }) })
          }
        )
      ] });
    });
  }
}
__publicField(KanbanMain, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node,
  lightTheme: PropTypes$1.bool,
  greyTheme: PropTypes$1.bool,
  loading: PropTypes$1.bool
});
__publicField(KanbanMain, "defaultProps", {
  lightTheme: false,
  greyTheme: false,
  children: null,
  loading: false
});
const kanban_main = injectSheet(styles$22)(KanbanMain);
const TOTAL_HEADER_HEIGHT = NAVBAR_HEIGHT + SUB_NAVBAR_HEIGHT;
const styles$21 = (theme2) => ({
  root: {
    backgroundColor: theme2.grey8,
    position: "fixed",
    zIndex: ASIDE_FIXED_ZINDEX,
    width: `calc(100% - 14px)`,
    maxWidth: ASIDE_MAX_WIDTH,
    height: `calc(100% - ${TOTAL_HEADER_HEIGHT}px)`,
    top: TOTAL_HEADER_HEIGHT,
    right: 0,
    paddingBottom: "env(safe-area-inset-bottom)",
    paddingRight: "env(safe-area-inset-right)",
    overflow: "auto",
    boxShadow: `-2px 0 4px 0 rgba(52, 50, 58, 0.2)`,
    "-webkit-overflow-scrolling": "touch",
    transform: "translateX(100%)",
    transition: "transform 100ms ease-in-out 0ms",
    '&[aria-expanded="true"]': {
      transform: "translateX(0)"
    }
  },
  content: {
    padding: 14
  },
  placeholder: {
    display: "none"
  },
  "@media (min-width: 420px)": {
    root: {
      width: ASIDE_MAX_WIDTH
    },
    placeholder: {
      display: "block",
      width: ASIDE_MAX_WIDTH,
      flexShrink: 0
    }
  }
});
class KanbanAside extends React__default.PureComponent {
  render() {
    const { classes, children, expanded } = this.props;
    return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
      expanded && /* @__PURE__ */ jsx$1("div", { className: classes.placeholder, role: "none" }),
      createPortal(
        /* @__PURE__ */ jsx$1("div", { className: classes.root, "aria-expanded": expanded, children: /* @__PURE__ */ jsx$1("div", { className: classes.content, children }) }),
        document.body
      )
    ] });
  }
}
__publicField(KanbanAside, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  expanded: PropTypes$1.bool.isRequired
});
const kanban_aside = injectSheet(styles$21)(KanbanAside);
const styles$20 = {
  root: {
    listStyle: "none",
    paddingLeft: 0
  }
};
const MENU_FONT_SIZE = 14;
const MENU_LINE_HEIGHT = 1.5;
const MENU_TITLE_FONT_SIZE = 11;
const MENU_TITLE_LINE_HEIGHT = 1.36;
const styles$1$ = (theme2) => ({
  root: {
    marginBottom: 14,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start"
  },
  title: {
    color: theme2.grey2,
    fontSize: MENU_TITLE_FONT_SIZE,
    lineHeight: MENU_TITLE_LINE_HEIGHT,
    fontWeight: 400,
    letterSpacing: "1px",
    textTransform: "uppercase",
    marginRight: 14
  },
  action: {
    flexShrink: 0,
    minHeight: MENU_TITLE_FONT_SIZE * MENU_TITLE_LINE_HEIGHT,
    display: "flex",
    alignItems: "center"
  }
});
class MenuHeader extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, title: title2, action } = this.props;
      if (!title2 && !action) return null;
      return /* @__PURE__ */ jsxs("div", { className: classes.root, children: [
        title2 && /* @__PURE__ */ jsx$1("div", { className: classes.title, children: title2 }),
        action && /* @__PURE__ */ jsx$1("div", { className: classes.action, children: action })
      ] });
    });
  }
}
__publicField(MenuHeader, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  title: PropTypes$1.string,
  action: PropTypes$1.node
});
__publicField(MenuHeader, "defaultProps", {
  title: null,
  action: null
});
const MenuHeader$1 = injectSheet(styles$1$)(MenuHeader);
class Menu extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children, title: title2, action } = this.props;
      const rootProps = {
        role: "menu",
        className: classes.root
      };
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx$1(MenuHeader$1, { title: title2, action }),
        /* @__PURE__ */ jsx$1("ul", { ...rootProps, children })
      ] });
    });
  }
}
__publicField(Menu, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  title: PropTypes$1.string,
  action: PropTypes$1.node
});
__publicField(Menu, "defaultProps", {
  title: null,
  action: null
});
const menu = injectSheet(styles$20)(Menu);
const styles$1_ = (theme2) => ({
  root: {
    listStyle: "none",
    flexShrink: 0,
    "li + &": {
      paddingTop: 7
    },
    "&:not(:last-child)": {
      paddingBottom: 7
    }
  },
  button: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    boxSizing: "border-box",
    borderWidth: 0,
    appearance: "none",
    flexShrink: 0,
    cursor: "pointer",
    outline: "none",
    backgroundColor: "transparent",
    position: "relative",
    lineHeight: MENU_LINE_HEIGHT,
    fontWeight: 400,
    color: theme2.grey3,
    "&::before": {
      content: '""',
      position: "absolute",
      height: MIN_TARGET_SIZE,
      top: "50%",
      left: 0,
      right: 0,
      transform: "translateY(-50%)"
    },
    "&:not([data-is-selected=true]):hover": {
      color: theme2.indigo3
    },
    "&[data-is-selected=true]": {
      color: theme2.grey1
    }
  },
  label: {
    fontSize: MENU_FONT_SIZE,
    fontWeight: "inherit",
    lineHeight: "inherit",
    color: "inherit",
    ":not(:hover):focus > &": {
      textDecoration: "underline"
    },
    "&[data-is-bold=true]": {
      fontWeight: 700
    }
  },
  icon: {
    marginRight: 14,
    flexShrink: 0,
    width: 20,
    minHeight: MENU_FONT_SIZE * MENU_LINE_HEIGHT,
    display: "flex",
    alignItems: "center",
    color: "inherit"
  },
  suffix: {
    marginLeft: 14,
    flexShrink: 0,
    minHeight: MENU_FONT_SIZE * MENU_LINE_HEIGHT,
    display: "flex",
    alignItems: "center",
    color: "inherit"
  }
});
class MenuItem extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, label, onClick, icon: icon2, suffix, selected, bold } = this.props;
      const rootProps = {
        role: "menuitem",
        className: classes.root
      };
      const buttonProps = {
        type: "button",
        onClick,
        "data-is-selected": selected,
        className: classes.button
      };
      const spanProps = {
        className: classes.label,
        "data-is-bold": bold
      };
      return /* @__PURE__ */ jsx$1("li", { ...rootProps, children: /* @__PURE__ */ jsxs("button", { ...buttonProps, children: [
        icon2 && /* @__PURE__ */ jsx$1("span", { className: classes.icon, children: icon2 }),
        /* @__PURE__ */ jsx$1("span", { ...spanProps, children: label }),
        suffix && /* @__PURE__ */ jsx$1("span", { className: classes.suffix, children: suffix })
      ] }) });
    });
  }
}
__publicField(MenuItem, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  label: PropTypes$1.string.isRequired,
  onClick: PropTypes$1.func.isRequired,
  icon: PropTypes$1.node,
  suffix: PropTypes$1.node,
  selected: PropTypes$1.bool,
  bold: PropTypes$1.bool
});
__publicField(MenuItem, "defaultProps", {
  icon: null,
  suffix: null,
  selected: false,
  bold: false
});
const menu_item = injectSheet(styles$1_)(MenuItem);
const styles$1Z = (theme2) => ({
  root: {
    listStyle: "none",
    flexShrink: 0,
    "li + &": {
      paddingTop: 7
    },
    "&:not(:last-child)": {
      paddingBottom: 7
    }
  },
  link: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    boxSizing: "border-box",
    flexShrink: 0,
    outline: "none",
    position: "relative",
    lineHeight: MENU_LINE_HEIGHT,
    fontWeight: 400,
    color: theme2.grey3,
    textDecoration: "none",
    "&::before": {
      content: '""',
      position: "absolute",
      height: MIN_TARGET_SIZE,
      top: "50%",
      left: 0,
      right: 0,
      transform: "translateY(-50%)"
    },
    "&:not([data-is-selected=true]):hover": {
      color: theme2.indigo3
    },
    "&[data-is-selected=true]": {
      color: theme2.grey1
    }
  },
  label: {
    fontSize: MENU_FONT_SIZE,
    fontWeight: "inherit",
    lineHeight: "inherit",
    color: "inherit",
    ":not(:hover):focus > &": {
      textDecoration: "underline"
    }
  },
  icon: {
    marginRight: 14,
    flexShrink: 0,
    width: 20,
    minHeight: MENU_FONT_SIZE * MENU_LINE_HEIGHT,
    display: "flex",
    alignItems: "center",
    color: "inherit"
  },
  suffix: {
    marginLeft: 14,
    flexShrink: 0,
    minHeight: MENU_FONT_SIZE * MENU_LINE_HEIGHT,
    display: "flex",
    alignItems: "center",
    color: "inherit"
  }
});
class MenuItemHref extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, label, href, icon: icon2, suffix, selected, external } = this.props;
      const rootProps = {
        role: "menuitem",
        className: classes.root
      };
      const linkProps = {
        href,
        "data-is-selected": selected,
        className: classes.link
      };
      if (external) {
        linkProps.rel = "external";
        linkProps.target = "_blank";
      }
      return /* @__PURE__ */ jsx$1("li", { ...rootProps, children: /* @__PURE__ */ jsxs("a", { ...linkProps, children: [
        icon2 && /* @__PURE__ */ jsx$1("span", { className: classes.icon, children: icon2 }),
        /* @__PURE__ */ jsx$1("span", { className: classes.label, children: label }),
        suffix && /* @__PURE__ */ jsx$1("span", { className: classes.suffix, children: suffix })
      ] }) });
    });
  }
}
__publicField(MenuItemHref, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  label: PropTypes$1.string.isRequired,
  href: PropTypes$1.string.isRequired,
  icon: PropTypes$1.node,
  suffix: PropTypes$1.node,
  selected: PropTypes$1.bool,
  external: PropTypes$1.bool
});
__publicField(MenuItemHref, "defaultProps", {
  icon: null,
  suffix: null,
  selected: false,
  external: false
});
const menu_item_href = injectSheet(styles$1Z)(MenuItemHref);
const styles$1Y = (theme2) => ({
  root: {
    width: `calc(100vw - ${VIEWPORT_MARGIN}px - ${VIEWPORT_MARGIN}px)`,
    maxWidth: MODAL_MAX_WIDTH_SMALL,
    maxHeight: "inherit",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme2.white1,
    borderRadius: 5,
    boxShadow: `0 0 2px 0 rgba(0,0,0,0.2)`,
    "&[data-is-large=true]": {
      maxWidth: MODAL_MAX_WIDTH_LARGE
    },
    "&[data-is-fullscreen=true]": {
      maxWidth: "unset"
    }
  }
});
const styles$1X = (theme2) => ({
  root: {
    display: "flex",
    flexShrink: 0,
    padding: 14,
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit",
    backgroundColor: theme2.grey8,
    "& > * + *": {
      marginLeft: 14
    },
    "&[data-has-borderbottom=true]": {
      borderBottom: `1px solid ${theme2.grey6}`
    }
  },
  title: {
    flexGrow: 1,
    fontSize: 16,
    fontWeight: 600,
    color: theme2.grey1,
    lineHeight: "20px",
    "& strong": {
      color: theme2.indigo3
    }
  },
  closeButton: {
    flexShrink: 0
  }
});
class ModalHeader extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const {
        classes,
        titleId: titleId2,
        title: title2,
        closeButtonLabel,
        handleClose,
        hideCloseButton,
        hideHeaderBorderBottom
      } = this.props;
      const parsedTitle = typeof title2 === "string" ? parseBoldMarkdown(title2) : title2;
      return /* @__PURE__ */ jsxs(
        "header",
        {
          className: classes.root,
          "data-has-borderbottom": !hideHeaderBorderBottom,
          children: [
            /* @__PURE__ */ jsx$1("h1", { className: classes.title, id: titleId2, children: parsedTitle }),
            !hideCloseButton && /* @__PURE__ */ jsx$1("div", { className: classes.closeButton, children: /* @__PURE__ */ jsx$1(IconbuttonClose, { label: closeButtonLabel, onClick: handleClose }) })
          ]
        }
      );
    });
  }
}
__publicField(ModalHeader, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  titleId: PropTypes$1.string.isRequired,
  title: PropTypes$1.node.isRequired,
  closeButtonLabel: PropTypes$1.string.isRequired,
  handleClose: PropTypes$1.func.isRequired,
  hideCloseButton: PropTypes$1.bool,
  hideHeaderBorderBottom: PropTypes$1.bool
});
__publicField(ModalHeader, "defaultProps", {
  hideCloseButton: false,
  hideHeaderBorderBottom: false
});
const ModalHeader$1 = injectSheet(styles$1X)(ModalHeader);
const voidFn = () => {
};
class Modal extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "id", uniqueId$1("modal_"));
    __publicField(this, "render", () => {
      const {
        classes,
        title: title2,
        children,
        handleCollapse,
        focusElement,
        closeButtonLabel,
        large,
        fullscreen,
        hideCloseButton,
        hideHeaderBorderBottom,
        disableClickOutside
      } = this.props;
      const titleId2 = `${this.id}_title`;
      const veneerProps = {
        handleCollapse: disableClickOutside ? voidFn : handleCollapse,
        focusElement
      };
      const rootProps = {
        className: classes.root,
        role: "dialog",
        "aria-labelledby": titleId2,
        "data-is-large": large,
        "data-is-fullscreen": fullscreen
      };
      const headerProps = {
        titleId: titleId2,
        title: title2,
        closeButtonLabel,
        handleClose: handleCollapse,
        hideCloseButton,
        hideHeaderBorderBottom
      };
      return /* @__PURE__ */ jsx$1(Veneer$1, { ...veneerProps, children: /* @__PURE__ */ jsxs("div", { ...rootProps, children: [
        /* @__PURE__ */ jsx$1(ModalHeader$1, { ...headerProps }),
        children
      ] }) });
    });
  }
}
__publicField(Modal, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  title: PropTypes$1.node.isRequired,
  children: PropTypes$1.node.isRequired,
  handleCollapse: PropTypes$1.func.isRequired,
  focusElement: PropTypes$1.oneOfType([
    PropTypes$1.string,
    PropTypes$1.object,
    PropTypes$1.func
  ]),
  closeButtonLabel: PropTypes$1.string,
  large: PropTypes$1.bool,
  fullscreen: PropTypes$1.bool,
  hideCloseButton: PropTypes$1.bool,
  hideHeaderBorderBottom: PropTypes$1.bool,
  disableClickOutside: PropTypes$1.bool
});
__publicField(Modal, "defaultProps", {
  focusElement: null,
  closeButtonLabel: "Close",
  large: false,
  fullscreen: false,
  hideCloseButton: false,
  hideHeaderBorderBottom: false,
  disableClickOutside: false
});
const Modal$1 = injectSheet(styles$1Y)(Modal);
const MODAL_PADDING = 14;
const styles$1W = {
  root: {
    display: "flex",
    overflowX: "auto",
    flexShrink: 0
  },
  actions: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "flex-end",
    padding: MODAL_PADDING
  },
  action: {
    marginLeft: 14
  },
  adverseAction: {
    flexGrow: 1
  }
};
class ModalActions extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children, adverseAction } = this.props;
      return /* @__PURE__ */ jsx$1("div", { className: classes.root, children: /* @__PURE__ */ jsxs("div", { className: classes.actions, children: [
        adverseAction && /* @__PURE__ */ jsx$1("div", { className: classes.adverseAction, children: adverseAction }),
        Children$1.map(children, (action) => /* @__PURE__ */ jsx$1("div", { className: classes.action, children: action }))
      ] }) });
    });
  }
}
__publicField(ModalActions, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  adverseAction: PropTypes$1.node
});
__publicField(ModalActions, "defaultProps", {
  adverseAction: null
});
const ModalActions$1 = injectSheet(styles$1W)(ModalActions);
const styles$1V = {
  root: {
    overflow: "auto",
    padding: MODAL_PADDING,
    "&[data-is-centered=true]": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start"
    }
  },
  content: {
    flexGrow: 1
  }
};
class ModalContent extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children, centered } = this.props;
      const rootProps = {
        className: classes.root,
        "data-is-centered": centered
      };
      return /* @__PURE__ */ jsx$1("div", { ...rootProps, children: /* @__PURE__ */ jsx$1("div", { className: classes.content, children }) });
    });
  }
}
__publicField(ModalContent, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  centered: PropTypes$1.bool
});
__publicField(ModalContent, "defaultProps", {
  centered: false
});
const ModalContent$1 = injectSheet(styles$1V)(ModalContent);
const style = () => ({
  cls1: {
    fill: "none"
  },
  cls2: {
    isolation: "isolate"
  },
  cls3: {
    fill: "#352594"
  },
  cls4: {
    fill: "#261b6b"
  },
  cls5: {
    fill: "#2e2182"
  },
  cls6: {
    fill: "#fff"
  },
  cls7: {
    clipPath: "url(#clip-path)"
  },
  cls8: {
    fill: "#2f2182"
  },
  cls9: {
    fill: "#302286"
  },
  cls10: {
    fill: "#32238b"
  },
  cls11: {
    fill: "#2d207e"
  },
  cls12: {
    fill: "#2c1f7a"
  },
  cls13: {
    fill: "#2a1e76"
  },
  cls14: {
    fill: "#291d71"
  },
  cls15: {
    fill: "#271c6d"
  },
  cls16: {
    clipPath: "url(#clip-path-2)"
  },
  cls17: {
    clipPath: "url(#clip-path-3)"
  },
  cls18: {
    clipPath: "url(#clip-path-4)"
  },
  cls19: {
    clipPath: "url(#clip-path-5)"
  }
});
class Icon extends React__default.Component {
  render() {
    const { classes, className } = this.props;
    return /* @__PURE__ */ jsxs(
      "svg",
      {
        id: "Layer_1",
        "data-name": "Layer 1",
        viewBox: "0 0 288 150.67",
        className,
        children: [
          /* @__PURE__ */ jsxs("defs", { children: [
            /* @__PURE__ */ jsx$1("clipPath", { id: "clip-path", children: /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls1,
                d: "M156.63,118.47l-41-22.28A13.3,13.3,0,0,0,124,97.46c9-1.27,15.31-9.21,15.34-21.21l41,22.28c0,12-6.32,19.94-15.34,21.21A13.3,13.3,0,0,1,156.63,118.47Z"
              }
            ) }),
            /* @__PURE__ */ jsx$1("clipPath", { id: "clip-path-2", children: /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls1,
                d: "M132.27,37.29l41,22.28c4.42,2.4,7.12,7.78,7.1,15.66L139.37,53C139.38,45.06,136.69,39.69,132.27,37.29Z"
              }
            ) }),
            /* @__PURE__ */ jsx$1("clipPath", { id: "clip-path-3", children: /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls1,
                d: "M145.85,137.75l-41-22.29c-10-5.44-16.08-17-16-32.12l41,22.29C129.76,120.71,135.85,132.31,145.85,137.75Z"
              }
            ) }),
            /* @__PURE__ */ jsx$1("clipPath", { id: "clip-path-4", children: /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls1,
                d: "M143.06,18,184,40.3a30.24,30.24,0,0,0-18.92-3L124.14,15A30.24,30.24,0,0,1,143.06,18Z"
              }
            ) }),
            /* @__PURE__ */ jsx$1("clipPath", { id: "clip-path-5", children: /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls1,
                d: "M129.83,82.33,88.87,60c0-23.15,14.47-42.12,35.27-45l41,22.29C144.3,40.2,129.88,59.17,129.83,82.33Z"
              }
            ) })
          ] }),
          /* @__PURE__ */ jsx$1("title", { children: "Trace 404" }),
          /* @__PURE__ */ jsxs("g", { className: classes.cls2, children: [
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls3,
                points: "273.84 82.7 232.88 60.41 244.78 58.74 285.75 81.02 273.84 82.7"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "254.01 126.71 213.04 104.43 213.09 82.68 254.05 104.96 254.01 126.71"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "254.08 85.47 213.12 63.19 213.17 35.52 254.13 57.8 254.08 85.47"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls3,
                points: "232.76 88.47 191.8 66.19 213.12 63.19 254.08 85.47 232.76 88.47"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls3,
                points: "256.16 26.18 215.19 3.89 232.99 1.39 273.95 23.68 256.16 26.18"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls5,
                points: "208.68 94.12 167.72 71.83 215.19 3.89 256.16 26.18 208.68 94.12"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "208.65 111.34 167.69 89.06 167.72 71.83 208.68 94.12 208.65 111.34"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls6,
                d: "M273.84,82.7,285.75,81l0,19.49-11.91,1.68,0,21.74L254,126.71l0-21.75-45.4,6.38,0-17.22,47.48-67.94L274,23.68Zm-19.76,2.77,0-27.67L232.76,88.47l21.32-3"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("g", { className: classes.cls2, children: [
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "180.29 98.53 139.33 76.25 139.37 52.95 180.33 75.23 180.29 98.53"
              }
            ),
            /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls7, children: /* @__PURE__ */ jsxs("g", { className: classes.cls2, children: [
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls8,
                  d: "M156.63,118.47l-41-22.28.42.21,41,22.29-.42-.22"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls9,
                  d: "M157.05,118.69l-41-22.29a11.12,11.12,0,0,0,2.22.82l41,22.28a11.74,11.74,0,0,1-2.22-.81"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls10,
                  d: "M159.27,119.5l-41-22.28a14.61,14.61,0,0,0,5.68.24A16.71,16.71,0,0,0,128.78,96l41,22.29a16.92,16.92,0,0,1-4.79,1.41,14.61,14.61,0,0,1-5.68-.24"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls9,
                  d: "M169.74,118.33,128.78,96a15,15,0,0,0,2.3-1.32L172,117a16,16,0,0,1-2.3,1.33"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls8,
                  d: "M172,117l-41-22.28a15.49,15.49,0,0,0,1.64-1.29l41,22.28A15.49,15.49,0,0,1,172,117"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls11,
                  d: "M173.68,115.71l-41-22.28a17.74,17.74,0,0,0,1.36-1.38l41,22.28a17.85,17.85,0,0,1-1.37,1.38"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls12,
                  d: "M175.05,114.33l-41-22.28a17.62,17.62,0,0,0,1.24-1.58l41,22.28a17.53,17.53,0,0,1-1.23,1.58"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls13,
                  d: "M176.28,112.75l-41-22.28a19.37,19.37,0,0,0,1.19-1.92l41,22.28a18.28,18.28,0,0,1-1.19,1.92"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls14,
                  d: "M177.47,110.83l-41-22.28a22.23,22.23,0,0,0,1.23-2.75l41,22.28a22.23,22.23,0,0,1-1.23,2.75"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls15,
                  d: "M178.7,108.08l-41-22.28a27.94,27.94,0,0,0,1.59-9.55l41,22.28a27.94,27.94,0,0,1-1.59,9.55"
                }
              )
            ] }) }) }),
            /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls16, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls15,
                d: "M180.33,75.23,139.37,53c0-7.89-2.68-13.26-7.1-15.66l41,22.28c4.42,2.4,7.12,7.78,7.1,15.66"
              }
            ) }) }) }),
            /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls17, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls15,
                d: "M145.85,137.75l-41-22.29c-10-5.44-16.08-17-16-32.12l41,22.29c0,15.08,6.06,26.68,16.06,32.12"
              }
            ) }) }) }),
            /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls18, children: /* @__PURE__ */ jsxs("g", { className: classes.cls2, children: [
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls10,
                  d: "M165.1,37.28,124.14,15a32.56,32.56,0,0,1,12.67.58l41,22.28a32.57,32.57,0,0,0-12.67-.57"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls9,
                  d: "M177.77,37.85l-41-22.28a27.18,27.18,0,0,1,5.25,1.93l41,22.29a27.21,27.21,0,0,0-5.25-1.94"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls8,
                  d: "M183,39.79l-41-22.29,1,.52L184,40.3c-.33-.18-.66-.35-1-.51"
                }
              )
            ] }) }) }),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "129.79 105.63 88.83 83.34 88.87 60.04 129.83 82.33 129.79 105.63"
              }
            ),
            /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls20, children: /* @__PURE__ */ jsxs("g", { className: classes.cls2, children: [
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls15,
                  d: "M129.83,82.33,88.87,60A52.11,52.11,0,0,1,92,42.22l41,22.28a52.36,52.36,0,0,0-3.1,17.83"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls14,
                  d: "M132.93,64.5,92,42.22a47.81,47.81,0,0,1,2.73-6.09l41,22.28a47.81,47.81,0,0,0-2.73,6.09"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls13,
                  d: "M135.66,58.41l-41-22.28a42.92,42.92,0,0,1,2.78-4.51l41,22.28a45.81,45.81,0,0,0-2.78,4.51"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls12,
                  d: "M138.44,53.9l-41-22.28a41.22,41.22,0,0,1,3-3.75l41,22.28a43.06,43.06,0,0,0-2.95,3.75"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls11,
                  d: "M141.39,50.15l-41-22.28a41.61,41.61,0,0,1,3.3-3.34l41,22.28a40.13,40.13,0,0,0-3.31,3.34"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls8,
                  d: "M144.7,46.81l-41-22.28a40.68,40.68,0,0,1,4-3.12l41,22.28a39.51,39.51,0,0,0-4,3.12"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls9,
                  d: "M148.65,43.69l-41-22.28a39.44,39.44,0,0,1,5.5-3.17l41,22.29a37.77,37.77,0,0,0-5.49,3.16"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls10,
                  d: "M154.14,40.53l-41-22.29a38.54,38.54,0,0,1,11-3.25l41,22.29a37.91,37.91,0,0,0-11,3.25"
                }
              )
            ] }) }) }),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls6,
                d: "M165.1,37.28c20.67-2.91,35,12,35,35.17L200,95.75c0,23.16-14.46,42.13-35.13,45s-35.16-12-35.12-35.15l0-23.3C129.88,59.17,144.3,40.2,165.1,37.28Zm15.19,61.25,0-23.3c0-12-6.25-18.19-15.27-16.92s-15.45,9.24-15.47,21.24l0,23.3c0,12,6.24,18.18,15.4,16.89s15.32-9.21,15.34-21.21"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("g", { className: classes.cls2, children: [
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls3,
                points: "106.9 106.16 65.93 83.88 77.84 82.2 118.8 104.48 106.9 106.16"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "87.06 150.17 46.1 127.89 46.14 106.14 87.1 128.43 87.06 150.17"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "87.14 108.94 46.18 86.65 46.23 58.98 87.19 81.26 87.14 108.94"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls3,
                points: "65.82 111.93 24.86 89.65 46.18 86.65 87.14 108.94 65.82 111.93"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls3,
                points: "89.21 49.64 48.25 27.36 66.04 24.86 107 47.14 89.21 49.64"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls5,
                points: "41.74 117.58 0.78 95.3 48.25 27.36 89.21 49.64 41.74 117.58"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "41.71 134.81 0.75 112.52 0.78 95.3 41.74 117.58 41.71 134.81"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls6,
                d: "M106.9,106.16l11.9-1.67,0,19.49-11.91,1.67,0,21.74-19.76,2.78,0-21.74-45.39,6.38,0-17.23L89.21,49.64l17.8-2.5Zm-19.76,2.78,0-27.68L65.82,111.93l21.32-3"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("g", { className: classes.cls2, children: [
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls3,
                points: "273.84 82.7 232.88 60.41 244.78 58.74 285.75 81.02 273.84 82.7"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "254.01 126.71 213.04 104.43 213.09 82.68 254.05 104.96 254.01 126.71"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "254.08 85.47 213.12 63.19 213.17 35.52 254.13 57.8 254.08 85.47"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls3,
                points: "232.76 88.47 191.8 66.19 213.12 63.19 254.08 85.47 232.76 88.47"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls3,
                points: "256.16 26.18 215.19 3.89 232.99 1.39 273.95 23.68 256.16 26.18"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls5,
                points: "208.68 94.12 167.72 71.83 215.19 3.89 256.16 26.18 208.68 94.12"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "208.65 111.34 167.69 89.06 167.72 71.83 208.68 94.12 208.65 111.34"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls6,
                d: "M273.84,82.7,285.75,81l0,19.49-11.91,1.68,0,21.74L254,126.71l0-21.75-45.4,6.38,0-17.22,47.48-67.94L274,23.68Zm-19.76,2.77,0-27.67L232.76,88.47l21.32-3"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("g", { className: classes.cls2, children: [
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "180.29 98.53 139.33 76.25 139.37 52.95 180.33 75.23 180.29 98.53"
              }
            ),
            /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls7, children: /* @__PURE__ */ jsxs("g", { className: classes.cls2, children: [
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls8,
                  d: "M156.63,118.47l-41-22.28.42.21,41,22.29-.42-.22"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls9,
                  d: "M157.05,118.69l-41-22.29a11.12,11.12,0,0,0,2.22.82l41,22.28a11.74,11.74,0,0,1-2.22-.81"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls10,
                  d: "M159.27,119.5l-41-22.28a14.61,14.61,0,0,0,5.68.24A16.71,16.71,0,0,0,128.78,96l41,22.29a16.92,16.92,0,0,1-4.79,1.41,14.61,14.61,0,0,1-5.68-.24"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls9,
                  d: "M169.74,118.33,128.78,96a15,15,0,0,0,2.3-1.32L172,117a16,16,0,0,1-2.3,1.33"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls8,
                  d: "M172,117l-41-22.28a15.49,15.49,0,0,0,1.64-1.29l41,22.28A15.49,15.49,0,0,1,172,117"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls11,
                  d: "M173.68,115.71l-41-22.28a17.74,17.74,0,0,0,1.36-1.38l41,22.28a17.85,17.85,0,0,1-1.37,1.38"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls12,
                  d: "M175.05,114.33l-41-22.28a17.62,17.62,0,0,0,1.24-1.58l41,22.28a17.53,17.53,0,0,1-1.23,1.58"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls13,
                  d: "M176.28,112.75l-41-22.28a19.37,19.37,0,0,0,1.19-1.92l41,22.28a18.28,18.28,0,0,1-1.19,1.92"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls14,
                  d: "M177.47,110.83l-41-22.28a22.23,22.23,0,0,0,1.23-2.75l41,22.28a22.23,22.23,0,0,1-1.23,2.75"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls15,
                  d: "M178.7,108.08l-41-22.28a27.94,27.94,0,0,0,1.59-9.55l41,22.28a27.94,27.94,0,0,1-1.59,9.55"
                }
              )
            ] }) }) }),
            /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls16, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls15,
                d: "M180.33,75.23,139.37,53c0-7.89-2.68-13.26-7.1-15.66l41,22.28c4.42,2.4,7.12,7.78,7.1,15.66"
              }
            ) }) }) }),
            /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls17, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls15,
                d: "M145.85,137.75l-41-22.29c-10-5.44-16.08-17-16-32.12l41,22.29c0,15.08,6.06,26.68,16.06,32.12"
              }
            ) }) }) }),
            /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls18, children: /* @__PURE__ */ jsxs("g", { className: classes.cls2, children: [
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls10,
                  d: "M165.1,37.28,124.14,15a32.56,32.56,0,0,1,12.67.58l41,22.28a32.57,32.57,0,0,0-12.67-.57"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls9,
                  d: "M177.77,37.85l-41-22.28a27.18,27.18,0,0,1,5.25,1.93l41,22.29a27.21,27.21,0,0,0-5.25-1.94"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls8,
                  d: "M183,39.79l-41-22.29,1,.52L184,40.3c-.33-.18-.66-.35-1-.51"
                }
              )
            ] }) }) }),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "129.79 105.63 88.83 83.34 88.87 60.04 129.83 82.33 129.79 105.63"
              }
            ),
            /* @__PURE__ */ jsx$1("g", { className: classes.cls2, children: /* @__PURE__ */ jsx$1("g", { className: classes.cls20, children: /* @__PURE__ */ jsxs("g", { className: classes.cls2, children: [
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls15,
                  d: "M129.83,82.33,88.87,60A52.11,52.11,0,0,1,92,42.22l41,22.28a52.36,52.36,0,0,0-3.1,17.83"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls14,
                  d: "M132.93,64.5,92,42.22a47.81,47.81,0,0,1,2.73-6.09l41,22.28a47.81,47.81,0,0,0-2.73,6.09"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls13,
                  d: "M135.66,58.41l-41-22.28a42.92,42.92,0,0,1,2.78-4.51l41,22.28a45.81,45.81,0,0,0-2.78,4.51"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls12,
                  d: "M138.44,53.9l-41-22.28a41.22,41.22,0,0,1,3-3.75l41,22.28a43.06,43.06,0,0,0-2.95,3.75"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls11,
                  d: "M141.39,50.15l-41-22.28a41.61,41.61,0,0,1,3.3-3.34l41,22.28a40.13,40.13,0,0,0-3.31,3.34"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls8,
                  d: "M144.7,46.81l-41-22.28a40.68,40.68,0,0,1,4-3.12l41,22.28a39.51,39.51,0,0,0-4,3.12"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls9,
                  d: "M148.65,43.69l-41-22.28a39.44,39.44,0,0,1,5.5-3.17l41,22.29a37.77,37.77,0,0,0-5.49,3.16"
                }
              ),
              /* @__PURE__ */ jsx$1(
                "path",
                {
                  className: classes.cls10,
                  d: "M154.14,40.53l-41-22.29a38.54,38.54,0,0,1,11-3.25l41,22.29a37.91,37.91,0,0,0-11,3.25"
                }
              )
            ] }) }) }),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls6,
                d: "M165.1,37.28c20.67-2.91,35,12,35,35.17L200,95.75c0,23.16-14.46,42.13-35.13,45s-35.16-12-35.12-35.15l0-23.3C129.88,59.17,144.3,40.2,165.1,37.28Zm15.19,61.25,0-23.3c0-12-6.25-18.19-15.27-16.92s-15.45,9.24-15.47,21.24l0,23.3c0,12,6.24,18.18,15.4,16.89s15.32-9.21,15.34-21.21"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("g", { className: classes.cls2, children: [
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls3,
                points: "106.9 106.16 65.93 83.88 77.84 82.2 118.8 104.48 106.9 106.16"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "87.06 150.17 46.1 127.89 46.14 106.14 87.1 128.43 87.06 150.17"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "87.14 108.94 46.18 86.65 46.23 58.98 87.19 81.26 87.14 108.94"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls3,
                points: "65.82 111.93 24.86 89.65 46.18 86.65 87.14 108.94 65.82 111.93"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls3,
                points: "89.21 49.64 48.25 27.36 66.04 24.86 107 47.14 89.21 49.64"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls5,
                points: "41.74 117.58 0.78 95.3 48.25 27.36 89.21 49.64 41.74 117.58"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "polygon",
              {
                className: classes.cls4,
                points: "41.71 134.81 0.75 112.52 0.78 95.3 41.74 117.58 41.71 134.81"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                className: classes.cls6,
                d: "M106.9,106.16l11.9-1.67,0,19.49-11.91,1.67,0,21.74-19.76,2.78,0-21.74-45.39,6.38,0-17.23L89.21,49.64l17.8-2.5Zm-19.76,2.78,0-27.68L65.82,111.93l21.32-3"
              }
            )
          ] })
        ]
      }
    );
  }
}
__publicField(Icon, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  className: PropTypes$1.string
});
__publicField(Icon, "defaultProps", {
  className: null
});
const Icon$1 = injectSheet(style)(Icon);
const PREFIX_MARGIN = 5;
const pushbuttonStyles = (theme2) => ({
  root: {
    height: 32,
    borderRadius: 3,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    overflow: "hidden",
    boxSizing: "border-box",
    borderWidth: 1,
    borderStyle: "solid",
    appearance: "none",
    flexShrink: 0,
    cursor: "default",
    outline: "none",
    paddingLeft: 15,
    paddingRight: 15,
    transition: `box-shadow 150ms linear, background-color 150ms linear, border-color 150ms linear`,
    color: theme2.grey3,
    borderColor: "currentColor",
    backgroundColor: "transparent",
    "&:not([disabled]):hover, &:not([disabled]):focus": {
      color: theme2.grey1,
      cursor: "pointer"
    },
    '&[data-is-primary="true"]': {
      color: theme2.white1,
      borderColor: theme2.indigo3,
      backgroundColor: theme2.indigo3,
      "&:not([disabled]):hover, &:not([disabled]):focus": {
        color: theme2.white1,
        backgroundColor: theme2.indigo2,
        borderColor: theme2.indigo2,
        boxShadow: theme2.indigoShadow2
      }
    },
    '&[data-is-secondary="true"]': {
      color: theme2.indigo3,
      "&:not([disabled]):hover, &:not([disabled]):focus": {
        color: theme2.indigo2
      }
    },
    '&[data-is-warning="true"]': {
      color: theme2.warningRed,
      borderColor: theme2.warningRed,
      "&:not([disabled]):hover, &:not([disabled]):focus": {
        backgroundColor: theme2.warningRed,
        color: theme2.white1,
        boxShadow: theme2.redShadow1
      }
    },
    "&[data-is-complete=true]": {
      backgroundColor: theme2.indigo3,
      color: theme2.white1
    }
  },
  prefix: {
    marginRight: PREFIX_MARGIN,
    flexShrink: 0
  },
  suffix: {
    marginLeft: PREFIX_MARGIN,
    flexShrink: 0
  },
  text: {
    color: "currentColor",
    lineHeight: `${MIN_TARGET_SIZE - 2}px`,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 1,
    textTransform: "uppercase",
    whiteSpace: "nowrap"
  }
});
const styles$1U = (theme2) => {
  const sharedStyles = pushbuttonStyles(theme2);
  return {
    root: {
      ...sharedStyles.root,
      "&[disabled]": {
        color: theme2.disabled.grey3,
        '&[data-is-primary="true"]': {
          color: theme2.white1,
          borderColor: theme2.disabled.indigo3,
          backgroundColor: theme2.disabled.indigo3
        },
        '&[data-is-secondary="true"]': {
          color: theme2.disabled.indigo3
        },
        '&[data-is-warning="true"]': {
          color: theme2.disabled.warningRed,
          borderColor: theme2.disabled.warningRed
        },
        "&[data-is-complete=true]": {
          backgroundColor: theme2.disabled.indigo3,
          color: theme2.white1
        }
      },
      '&[data-is-sexy-shadow="true"]': {
        background: theme2.white1,
        height: 40,
        boxShadow: theme2.indigoShadow2,
        border: "none",
        padding: "0 20px",
        "&:not([disabled]):hover": {
          backgroundColor: theme2.indigo2
        },
        "&:not([disabled]):hover span": {
          color: theme2.white1
        },
        "& span": {
          textTransform: "inherit",
          color: theme2.grey1,
          fontWeight: 600,
          fontSize: 14
        }
      },
      "&[data-is-complete=true]": {
        backgroundColor: theme2.indigo3,
        color: theme2.white1
      }
    },
    prefix: {
      ...sharedStyles.prefix
    },
    suffix: {
      ...sharedStyles.suffix
    },
    text: {
      ...sharedStyles.text,
      '[aria-haspopup="true"] > &::after': {
        content: '"…"'
      }
    }
  };
};
const Pushbutton = ({
  classes,
  children,
  onClick = null,
  buttonRef: ref2 = null,
  primary = false,
  secondary = false,
  warning: warning2 = false,
  hasPopup = false,
  disabled = false,
  type: type2 = "button",
  prefix: prefix2 = null,
  suffix = null,
  dataCy = "atomic-pushbutton",
  sexyShadow = false,
  complete = false,
  formId = null
}) => {
  const handleClick = () => {
    if (!disabled && onClick) onClick();
  };
  const rootProps = {
    onClick: handleClick,
    type: type2,
    className: classes.root,
    disabled,
    ref: ref2,
    form: formId || null,
    "data-is-primary": primary,
    "data-is-secondary": secondary,
    "data-is-warning": warning2,
    "aria-haspopup": hasPopup,
    "data-cy": dataCy || "atomic-pushbutton",
    "data-is-sexy-shadow": sexyShadow,
    "data-is-complete": complete
  };
  return /* @__PURE__ */ jsxs("button", { ...rootProps, children: [
    prefix2 && /* @__PURE__ */ jsx$1("span", { className: classes.prefix, children: prefix2 }),
    /* @__PURE__ */ jsx$1("span", { className: classes.text, children }),
    suffix && /* @__PURE__ */ jsx$1("span", { className: classes.suffix, children: suffix })
  ] });
};
const Pushbutton$1 = injectSheet(styles$1U)(Pushbutton);
const styles$1T = () => ({
  root: {
    textAlign: "center",
    margin: 24
  },
  icon: {
    width: 350,
    marginBottom: 12
  },
  btn: {
    display: "flex",
    justifyContent: "center",
    marginTop: 18
  }
});
const NotFound = ({ classes, onHomeClick }) => /* @__PURE__ */ jsxs("div", { className: classes.root, children: [
  /* @__PURE__ */ jsx$1(Icon$1, { className: classes.icon }),
  /* @__PURE__ */ jsx$1("p", { children: "Sorry, we can't find the page you're looking for." }),
  /* @__PURE__ */ jsx$1("div", { className: classes.btn, children: /* @__PURE__ */ jsx$1(Pushbutton$1, { primary: true, onClick: onHomeClick, children: "Take me home" }) })
] });
NotFound.propTypes = {
  classes: PropTypes$1.object.isRequired,
  onHomeClick: PropTypes$1.func.isRequired
};
const notFound = injectSheet(styles$1T)(NotFound);
const icon = "data:image/png;base64,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";
const styles$1S = () => ({
  root: {
    textAlign: "center",
    margin: 24
  },
  icon: {
    margin: "auto",
    width: 200,
    marginBottom: 12
  },
  btn: {
    display: "flex",
    justifyContent: "center",
    marginTop: 18
  }
});
const Oops = ({ classes, onHomeClick, label, description: description2 }) => /* @__PURE__ */ jsxs("div", { className: classes.root, children: [
  /* @__PURE__ */ jsx$1("img", { alt: "", src: icon, className: classes.icon }),
  /* @__PURE__ */ jsx$1("p", { children: description2 }),
  /* @__PURE__ */ jsx$1("div", { className: classes.btn, children: /* @__PURE__ */ jsx$1(Pushbutton$1, { primary: true, onClick: onHomeClick, children: label }) })
] });
Oops.propTypes = {
  classes: PropTypes$1.object.isRequired,
  onHomeClick: PropTypes$1.func.isRequired,
  label: PropTypes$1.string,
  description: PropTypes$1.string
};
Oops.defaultProps = {
  label: "take me home",
  description: "Sorry, we can't find the page you're looking for."
};
const oops = injectSheet(styles$1S)(Oops);
const styles$1R = (theme2) => ({
  root: {
    height: MIN_TARGET_SIZE + 2,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    boxSizing: "border-box",
    appearance: "none",
    flexShrink: 0,
    flexGrow: 1,
    cursor: "default",
    outline: "none",
    paddingLeft: 7,
    paddingRight: 14,
    backgroundColor: theme2.indigo3,
    fontSize: 14,
    fontWeight: 400,
    color: theme2.white1,
    position: "relative",
    marginLeft: 0,
    marginRight: 0,
    "&:hover:not(:focus)": {
      backgroundColor: theme2.indigo2
    },
    "&:focus": {
      backgroundColor: theme2.indigo1
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }
  },
  label: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  prefix: {
    marginRight: 7,
    width: 14,
    flexShrink: 0
  }
});
class Option extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, label, value, selected, onClick } = this.props;
      const rootProps = {
        className: classes.root,
        value,
        "data-is-selected": selected,
        onClick
      };
      return /* @__PURE__ */ jsxs("button", { ...rootProps, children: [
        /* @__PURE__ */ jsx$1("div", { className: classes.prefix, children: selected && /* @__PURE__ */ jsx$1(icons.CheckCircleFill, {}) }),
        /* @__PURE__ */ jsx$1("div", { className: classes.label, children: label })
      ] });
    });
  }
}
__publicField(Option, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  label: PropTypes$1.string.isRequired,
  value: PropTypes$1.string.isRequired,
  onClick: PropTypes$1.func.isRequired,
  selected: PropTypes$1.bool
});
__publicField(Option, "defaultProps", {
  selected: false
});
const option = injectSheet(styles$1R)(Option);
const styles$1Q = (theme2) => ({
  root: {
    appearance: "none",
    backgroundColor: "transparent",
    flexShrink: 0,
    boxSizing: "border-box",
    cursor: "pointer",
    outline: "none",
    borderWidth: 1,
    borderStyle: "solid",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme2.grey2,
    borderColor: "transparent",
    opacity: 1,
    transition: "opacity 250ms linear 250ms",
    '&[aria-busy="true"]': {
      opacity: 0
    },
    "&:focus": {
      backgroundColor: theme2.grey7
    },
    '&[aria-expanded="true"]': {
      backgroundColor: "transparent",
      color: theme2.grey2,
      borderColor: theme2.grey5
    }
  },
  rootTricolon: {
    width: 18,
    height: 28,
    borderRadius: 2,
    "& > span": {
      flexShrink: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      width: 4,
      height: 18,
      "&::before, &::after": {
        content: '""'
      },
      "&::before, &::after, & > i": {
        display: "block",
        padding: "50%",
        backgroundColor: "currentColor",
        borderRadius: "50%"
      }
    }
  },
  rootTricolonSmall: {
    width: 13,
    height: 21,
    "& > span": {
      width: 3,
      height: 13
    }
  },
  rootAvatar: {
    width: (props2) => props2.avatarSize || 32,
    height: (props2) => props2.avatarSize || 32,
    borderRadius: "50%",
    position: "relative",
    overflow: "hidden",
    borderWidth: 0,
    '&:focus, &[aria-expanded="true"]': {
      boxShadow: `0 0 0 ${FOCUS_OUTLINE_WIDTH}px ${theme2.grey7}`
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      boxShadow: `inset 0px 0px 3px 0px rgba(52, 50, 58, 0.3)`,
      borderRadius: "inherit"
    },
    "& > span": {
      display: "block",
      "& > img": {
        display: "block",
        width: "100%",
        height: "auto"
      }
    }
  }
});
class PopoverButton extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const {
        classes,
        buttonRef: ref2,
        small,
        expanded,
        onClick,
        avatarButton,
        // eslint-disable-next-line
        avatarSize,
        avatarSrc,
        loading
      } = this.props;
      const rootProps = {
        type: "button",
        onClick,
        ref: ref2,
        "aria-busy": loading,
        "aria-expanded": !loading && expanded,
        "aria-haspopup": true,
        disabled: loading,
        className: classNames({
          [classes.root]: true,
          [classes.rootTricolon]: !avatarButton,
          [classes.rootTricolonSmall]: !avatarButton && small,
          [classes.rootAvatar]: avatarButton
        })
      };
      return /* @__PURE__ */ jsx$1("button", { ...rootProps, children: /* @__PURE__ */ jsx$1("span", { children: !loading && avatarButton ? /* @__PURE__ */ jsx$1("img", { src: avatarSrc || defaultSrc, alt: "User avatar" }) : /* @__PURE__ */ jsx$1("i", {}) }) });
    });
  }
}
__publicField(PopoverButton, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  buttonRef: PropTypes$1.func.isRequired,
  small: PropTypes$1.bool.isRequired,
  onClick: PropTypes$1.func.isRequired,
  expanded: PropTypes$1.bool.isRequired,
  avatarButton: PropTypes$1.bool.isRequired,
  avatarSize: PropTypes$1.number,
  avatarSrc: PropTypes$1.string,
  loading: PropTypes$1.bool.isRequired
});
__publicField(PopoverButton, "defaultProps", {
  avatarSrc: null,
  avatarSize: null
});
const PopoverButton$1 = injectSheet(styles$1Q)(PopoverButton);
const styles$1P = (theme2) => ({
  root: {
    paddingTop: 2,
    paddingBottom: 2,
    maxHeight: "inherit"
  },
  menu: {
    listStyle: "none",
    paddingLeft: 0,
    borderRadius: 8,
    overflow: "auto",
    outline: "none",
    maxHeight: "inherit",
    border: `1px solid ${theme2.grey7}`,
    backgroundColor: "rgba(255,255,255, 0.9)",
    backdropFilter: "blur(10px) saturate(1.2)"
  }
});
class PopoverMenu extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "getPosition", () => {
      const { width, height, left, top } = this.props.button.getBoundingClientRect();
      const right = window.innerWidth - left - width;
      const bottom = window.innerHeight - top - height;
      const position2 = {};
      if (left < right) {
        position2.left = left;
      } else {
        position2.right = right;
      }
      if (bottom < top) {
        position2.bottom = window.innerHeight - top;
      } else {
        position2.top = top + height;
      }
      return position2;
    });
    __publicField(this, "render", () => {
      const { classes, children, handleCollapse } = this.props;
      const veneerProps = {
        handleCollapse,
        invisible: true,
        contentPosition: this.getPosition()
      };
      const menuProps = {
        role: "menu",
        tabIndex: 0,
        className: classes.menu,
        onClick: handleCollapse
      };
      return /* @__PURE__ */ jsx$1(Veneer$1, { ...veneerProps, children: /* @__PURE__ */ jsx$1("div", { className: classes.root, children: /* @__PURE__ */ jsx$1("ul", { ...menuProps, children }) }) });
    });
  }
}
__publicField(PopoverMenu, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  handleCollapse: PropTypes$1.func.isRequired,
  button: PropTypes$1.object.isRequired
});
const PopoverMenu$1 = injectSheet(styles$1P)(PopoverMenu);
class Popover extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      expanded: false
    });
    __publicField(this, "toggle", () => {
      this.setState({
        expanded: !this.state.expanded
      });
    });
    __publicField(this, "collapse", () => {
      this.setState({
        expanded: false
      });
    });
    __publicField(this, "render", () => {
      const {
        children,
        smallButton,
        avatarButton,
        avatarSize,
        avatarSrc,
        loading
      } = this.props;
      const { expanded } = this.state;
      const buttonProps = {
        onClick: this.toggle,
        expanded,
        small: smallButton,
        avatarButton,
        avatarSize,
        avatarSrc,
        loading,
        buttonRef: (el2) => {
          this.button = el2;
        }
      };
      return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
        /* @__PURE__ */ jsx$1(PopoverButton$1, { ...buttonProps }),
        !loading && expanded && /* @__PURE__ */ jsx$1(PopoverMenu$1, { handleCollapse: this.collapse, button: this.button, children })
      ] });
    });
  }
}
__publicField(Popover, "propTypes", {
  children: PropTypes$1.node.isRequired,
  smallButton: PropTypes$1.bool,
  avatarButton: PropTypes$1.bool,
  avatarSize: PropTypes$1.number,
  avatarSrc: PropTypes$1.string,
  loading: PropTypes$1.bool
});
__publicField(Popover, "defaultProps", {
  smallButton: false,
  avatarButton: false,
  avatarSize: null,
  avatarSrc: "",
  loading: false
});
const styles$1O = (theme2) => ({
  root: {
    display: "flex",
    color: theme2.grey1,
    borderTopWidth: 0.5,
    borderTopStyle: "solid",
    borderTopColor: theme2.grey5,
    backgroundColor: "transparent",
    "&:first-child": {
      borderTopWidth: 0
    },
    "&:hover": {
      backgroundColor: theme2.indigo3,
      color: theme2.white1,
      borderTopColor: theme2.indigo3,
      "& + *": {
        borderTopColor: theme2.indigo3
      }
    },
    "&[data-is-selected=true]:not(:hover)": {
      color: theme2.indigo3
    }
  },
  button: {
    appearance: "none",
    backgroundColor: "transparent",
    flexGrow: 1,
    boxSizing: "border-box",
    height: 38,
    display: "flex",
    alignItems: "center",
    paddingLeft: 14,
    paddingRight: 14,
    borderWidth: 0,
    cursor: "pointer",
    outline: "none",
    color: "inherit",
    "&:focus:not(:hover)": {
      color: theme2.indigo3
    }
  },
  buttonIcon: {
    display: "block",
    flexShrink: 0,
    width: 20,
    height: 20,
    marginRight: 14,
    "& > svg": {
      display: "block",
      width: "100%",
      height: "auto"
    }
  },
  buttonLabel: {
    display: "block",
    flexGrow: 1,
    fontSize: 14,
    fontWeight: 400
  }
});
class PopoverMenuItem extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children, onClick, icon: icon2, selected } = this.props;
      const rootProps = {
        role: "none",
        className: classes.root,
        "data-is-selected": selected
      };
      const buttonProps = {
        type: "button",
        role: "menuitem",
        onClick,
        className: classes.button
      };
      return /* @__PURE__ */ jsx$1("li", { ...rootProps, children: /* @__PURE__ */ jsxs("button", { ...buttonProps, children: [
        /* @__PURE__ */ jsx$1("span", { className: classes.buttonIcon, children: icon2 }),
        /* @__PURE__ */ jsx$1("span", { className: classes.buttonLabel, children })
      ] }) });
    });
  }
}
__publicField(PopoverMenuItem, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.string.isRequired,
  onClick: PropTypes$1.func.isRequired,
  icon: PropTypes$1.object.isRequired,
  selected: PropTypes$1.bool
});
__publicField(PopoverMenuItem, "defaultProps", {
  selected: false
});
const PopoverMenuItem$1 = injectSheet(styles$1O)(PopoverMenuItem);
const PROSE_REGEX_MARKDOWN_BOLD = /\*{2}(.*?)\*{2}/g;
const PROSE_FONT_WEIGHT_BOLD = 700;
const PROSE_FONT_WEIGHT = 400;
const PROSE_FONT_SIZE = 14;
const PROSE_LINE_HEIGHT = 1.5;
const PROSE_FONT_SIZE_SMALL = 11;
const PROSE_LINE_HEIGHT_SMALL = 1.36;
const PROSE_COLOR = theme.grey1;
const PROSE_COLOR_LIGHT = theme.grey2;
const styles$1N = {
  root: {
    fontSize: PROSE_FONT_SIZE,
    fontWeight: PROSE_FONT_WEIGHT,
    lineHeight: PROSE_LINE_HEIGHT,
    color: PROSE_COLOR,
    "&[data-is-small=true]": {
      fontSize: PROSE_FONT_SIZE_SMALL,
      lineHeight: PROSE_LINE_HEIGHT_SMALL
    },
    "&[data-is-light=true]": {
      color: PROSE_COLOR_LIGHT
    },
    "&[data-break-after=true]::after": {
      content: '" "',
      whiteSpace: "pre",
      display: "block"
    },
    "& strong": {
      fontWeight: PROSE_FONT_WEIGHT_BOLD
    }
  }
};
class Prose extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "parseBoldMarkdown", () => reactStringReplace$1(
      this.props.text,
      PROSE_REGEX_MARKDOWN_BOLD,
      (match5, i3) => /* @__PURE__ */ jsx$1("strong", { children: match5 }, `bold_${i3}`)
    ));
    __publicField(this, "render", () => {
      const { classes, breakAfter, small, light } = this.props;
      const rootProps = {
        className: classes.root,
        "data-break-after": breakAfter,
        "data-is-small": small,
        "data-is-light": light
      };
      return /* @__PURE__ */ jsx$1("p", { ...rootProps, children: this.parseBoldMarkdown() });
    });
  }
}
__publicField(Prose, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  text: PropTypes$1.string.isRequired,
  breakAfter: PropTypes$1.bool,
  small: PropTypes$1.bool,
  light: PropTypes$1.bool
});
__publicField(Prose, "defaultProps", {
  breakAfter: false,
  small: false,
  light: false
});
const Prose$1 = injectSheet(styles$1N)(Prose);
const styles$1M = {
  root: {
    listStyle: "none",
    paddingLeft: 0,
    marginLeft: 0,
    color: PROSE_COLOR,
    fontSize: PROSE_FONT_SIZE,
    fontWeight: PROSE_FONT_WEIGHT,
    lineHeight: PROSE_LINE_HEIGHT,
    "&[data-is-light=true]": {
      color: PROSE_COLOR_LIGHT
    },
    "&[data-is-small=true]": {
      fontSize: PROSE_FONT_SIZE_SMALL,
      lineHeight: PROSE_LINE_HEIGHT_SMALL
    },
    "&[data-break-after=true]::after": {
      content: '" "',
      whiteSpace: "pre",
      display: "block"
    },
    "& > li": {
      fontSize: "inherit",
      fontWeight: "inherit",
      lineHeight: "inherit",
      display: "flex",
      whiteSpace: "pre",
      marginBottom: 3,
      "&::before": {
        content: '"·"',
        display: "block",
        marginRight: 7
      },
      "& strong": {
        fontWeight: PROSE_FONT_WEIGHT_BOLD
      }
    },
    "&[data-is-ordered=true]": {
      counterReset: "proseList",
      "& > li": {
        "&::before": {
          counterIncrement: "proseList",
          content: 'counter(proseList)"."',
          display: "flex",
          justifyContent: "flex-end",
          width: 14
        }
      }
    }
  }
};
class ProseList extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "parseBoldMarkdown", (item) => reactStringReplace$1(item, PROSE_REGEX_MARKDOWN_BOLD, (match5, i3) => /* @__PURE__ */ jsx$1("strong", { children: match5 }, `bold_${i3}`)));
    __publicField(this, "renderItems", () => {
      const { classes, items: items2 } = this.props;
      return items2.map((item, i3) => /* @__PURE__ */ jsx$1("li", { className: classes.item, children: this.parseBoldMarkdown(item) }, `item_${i3}`));
    });
    __publicField(this, "render", () => {
      const { classes, breakAfter, small, light, ordered } = this.props;
      const rootProps = {
        className: classes.root,
        "data-break-after": breakAfter,
        "data-is-small": small,
        "data-is-light": light,
        "data-is-ordered": ordered
      };
      if (ordered) return /* @__PURE__ */ jsx$1("ol", { ...rootProps, children: this.renderItems() });
      return /* @__PURE__ */ jsx$1("ul", { ...rootProps, children: this.renderItems() });
    });
  }
}
__publicField(ProseList, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  items: PropTypes$1.array.isRequired,
  breakAfter: PropTypes$1.bool,
  small: PropTypes$1.bool,
  light: PropTypes$1.bool,
  ordered: PropTypes$1.bool
});
__publicField(ProseList, "defaultProps", {
  breakAfter: false,
  small: false,
  light: false,
  ordered: false
});
const ProseList$1 = injectSheet(styles$1M)(ProseList);
const styles$1L = (theme2) => ({
  root: {
    height: MIN_TARGET_SIZE,
    borderRadius: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    overflow: "hidden",
    boxSizing: "border-box",
    borderWidth: 1,
    borderStyle: "solid",
    appearance: "none",
    flexShrink: 0,
    cursor: "default",
    outline: "none",
    paddingLeft: 14,
    paddingRight: 14,
    boxShadow: `0 0 0 0 ${theme2.indigoPastel2}`,
    transition: `box-shadow 150ms linear, background-color 150ms linear, border-color 150ms linear`,
    color: theme2.grey2,
    borderColor: "currentColor",
    backgroundColor: "transparent",
    "&:not([disabled]):hover": {
      color: theme2.grey1,
      cursor: "pointer"
    },
    "&[disabled]": {
      opacity: 0.3
    },
    "&:focus, &[aria-expanded=true]": {
      boxShadow: `0 0 0 ${FOCUS_OUTLINE_WIDTH}px ${theme2.indigoPastel2}`
    },
    '&[data-is-primary="true"]': {
      color: theme2.white1,
      borderColor: theme2.indigo3,
      backgroundColor: theme2.indigo3,
      "&:not([disabled]):hover": {
        color: theme2.white1,
        backgroundColor: theme2.indigo2,
        borderColor: theme2.indigo2
      }
    },
    '&[data-is-secondary="true"]': {
      color: theme2.indigo3,
      "&:not([disabled]):hover": {
        color: theme2.indigo2
      }
    },
    '&[data-is-warning="true"]': {
      color: theme2.warningRed,
      borderColor: theme2.warningRed,
      "&:not([disabled]):hover": {
        backgroundColor: theme2.warningRed,
        color: theme2.white1
      }
    }
  },
  text: {
    flexGrow: 1,
    color: "currentColor",
    lineHeight: `${MIN_TARGET_SIZE - 2}px`,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 1,
    textTransform: "uppercase",
    whiteSpace: "nowrap"
  },
  icon: {
    flexShrink: 0,
    marginLeft: 14,
    color: "currentColor"
  }
});
class PulldownButton extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const {
        classes,
        children,
        buttonRef,
        onClick,
        expanded,
        primary,
        secondary,
        warning: warning2,
        disabled
      } = this.props;
      const rootProps = {
        onClick,
        type: "button",
        className: classes.root,
        disabled,
        ref: buttonRef,
        "data-is-primary": primary,
        "data-is-secondary": secondary,
        "data-is-warning": warning2,
        "aria-expanded": expanded,
        "aria-haspopup": true
      };
      return /* @__PURE__ */ jsxs("button", { ...rootProps, children: [
        /* @__PURE__ */ jsx$1("span", { className: classes.text, children }),
        /* @__PURE__ */ jsx$1("span", { className: classes.icon, children: /* @__PURE__ */ jsx$1(icons.ArrowDown, { size: 17 }) })
      ] });
    });
  }
}
__publicField(PulldownButton, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  buttonRef: PropTypes$1.func.isRequired,
  onClick: PropTypes$1.func.isRequired,
  expanded: PropTypes$1.bool.isRequired,
  disabled: PropTypes$1.bool.isRequired,
  primary: PropTypes$1.bool.isRequired,
  secondary: PropTypes$1.bool.isRequired,
  warning: PropTypes$1.bool.isRequired
});
const PulldownButton$1 = injectSheet(styles$1L)(PulldownButton);
const styles$1K = (theme2) => ({
  root: {
    paddingTop: 1,
    paddingBottom: 1,
    maxHeight: "inherit",
    "&[data-is-invisible=true]": {
      visibility: "hidden"
    }
  },
  menu: {
    listStyle: "none",
    paddingLeft: 0,
    borderRadius: 8,
    border: `1px solid ${theme2.grey7}`,
    backgroundColor: "rgba(255,255,255, 0.9)",
    backdropFilter: "blur(10px) saturate(1.2)",
    overflow: "auto",
    outline: "none",
    maxHeight: "inherit",
    "&::-webkit-scrollbar": {
      cursor: "pointer",
      width: 5
    },
    "&::-webkit-scrollbar-track": {
      background: theme2.grey8,
      borderRadius: 10
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme2.grey4,
      borderRadius: 10,
      "&:hover": {
        background: theme2.grey3
      }
    }
  }
});
class PulldownMenu extends React__default.PureComponent {
  constructor(props2) {
    super(props2);
    __publicField(this, "buttonData", this.props.buttonElement.getBoundingClientRect());
    __publicField(this, "state", {
      invisible: true,
      top: null,
      left: null,
      right: null
    });
    __publicField(this, "getMinWidth", () => {
      const { width } = this.props.buttonElement.getBoundingClientRect();
      const maxWidth = window.innerWidth - VIEWPORT_MARGIN - VIEWPORT_MARGIN;
      return width > maxWidth ? maxWidth : width;
    });
    __publicField(this, "componentDidMount", () => {
      if (this.state.invisible) {
        this.setState({
          invisible: false,
          ...this.getMenuY(),
          ...this.getMenuX()
        });
      }
    });
    __publicField(this, "render", () => {
      const { classes, children, handleCollapse } = this.props;
      const veneerProps = {
        handleCollapse,
        invisible: true,
        contentPosition: {
          top: this.state.top,
          left: this.state.left,
          right: this.state.right,
          bottom: this.state.bottom
        }
      };
      const rootProps = {
        className: classes.root,
        "data-is-invisible": this.state.invisible
      };
      const menuProps = {
        role: "menu",
        tabIndex: 0,
        className: classes.menu,
        onClick: handleCollapse,
        ref: this.setMenuRef,
        style: {
          minWidth: this.getMinWidth()
        }
      };
      return /* @__PURE__ */ jsx$1(Veneer$1, { ...veneerProps, children: /* @__PURE__ */ jsx$1("div", { ...rootProps, children: /* @__PURE__ */ jsx$1("ul", { ...menuProps, children }) }) });
    });
    this.setMenuRef = this.setMenuRef.bind(this);
    this.getMenuY = this.getMenuY.bind(this);
    this.getMenuX = this.getMenuX.bind(this);
  }
  getMenuY() {
    const menuHeight = this.menu.scrollHeight;
    if (menuHeight > window.innerHeight - VIEWPORT_MARGIN - VIEWPORT_MARGIN)
      return {
        top: VIEWPORT_MARGIN
      };
    if (menuHeight > window.innerHeight - this.buttonData.top - this.buttonData.height - VIEWPORT_MARGIN)
      return {
        top: window.innerHeight - menuHeight - VIEWPORT_MARGIN
      };
    return {
      top: this.buttonData.top + this.buttonData.height
    };
  }
  getMenuX() {
    const menuData = this.menu.getBoundingClientRect();
    if (menuData.width > window.innerWidth - this.buttonData.left - VIEWPORT_MARGIN)
      return {
        left: this.buttonData.left < VIEWPORT_MARGIN ? VIEWPORT_MARGIN : null,
        right: VIEWPORT_MARGIN
      };
    return {
      left: this.buttonData.left < VIEWPORT_MARGIN ? VIEWPORT_MARGIN : this.buttonData.left,
      right: null
    };
  }
  setMenuRef(el2) {
    this.menu = el2;
  }
}
__publicField(PulldownMenu, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  handleCollapse: PropTypes$1.func.isRequired,
  buttonElement: PropTypes$1.object.isRequired
});
const PulldownMenu$1 = injectSheet(styles$1K)(PulldownMenu);
class Pulldown extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      expanded: false
    });
    __publicField(this, "toggle", () => {
      this.setState({
        expanded: !this.state.expanded
      });
    });
    __publicField(this, "collapse", () => {
      this.setState({
        expanded: false
      });
    });
    __publicField(this, "handleClick", () => {
      if (!this.props.disabled) {
        this.toggle();
      }
    });
    __publicField(this, "componentDidUpdate", () => {
      if (this.props.disabled && this.state.expanded) this.collapse();
    });
    __publicField(this, "render", () => {
      const { children, buttonLabel, primary, secondary, warning: warning2, disabled } = this.props;
      const { expanded } = this.state;
      const buttonProps = {
        buttonRef: (el2) => {
          this.button = el2;
        },
        onClick: this.handleClick,
        expanded,
        primary,
        secondary,
        warning: warning2,
        disabled
      };
      const menuProps = {
        buttonElement: this.button,
        handleCollapse: this.collapse
      };
      return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
        /* @__PURE__ */ jsx$1(PulldownButton$1, { ...buttonProps, children: buttonLabel }),
        expanded && /* @__PURE__ */ jsx$1(PulldownMenu$1, { ...menuProps, children })
      ] });
    });
  }
}
__publicField(Pulldown, "propTypes", {
  children: PropTypes$1.node.isRequired,
  buttonLabel: PropTypes$1.node.isRequired,
  primary: PropTypes$1.bool,
  secondary: PropTypes$1.bool,
  warning: PropTypes$1.bool,
  disabled: PropTypes$1.bool
});
__publicField(Pulldown, "defaultProps", {
  primary: false,
  secondary: false,
  warning: false,
  disabled: false
});
const styles$1J = (theme2) => ({
  root: {
    display: "flex",
    color: theme2.grey1,
    borderTop: `solid 0.5px ${theme2.grey5}`,
    backgroundColor: "transparent",
    "&:first-child": {
      borderTopWidth: 0
    },
    "&:hover": {
      backgroundColor: theme2.indigo3,
      color: theme2.white1,
      borderTopColor: theme2.indigo3,
      "& + *": {
        borderTopColor: theme2.indigo3
      }
    }
  },
  button: {
    appearance: "none",
    backgroundColor: "transparent",
    flexGrow: 1,
    boxSizing: "border-box",
    height: 38,
    display: "flex",
    alignItems: "center",
    paddingLeft: 14,
    paddingRight: 14,
    borderWidth: 0,
    cursor: "pointer",
    outline: "none",
    color: "inherit",
    "&:focus:not(:hover)": {
      color: theme2.indigo3
    }
  },
  buttonIcon: {
    display: "block",
    flexShrink: 0,
    width: 20,
    height: 20,
    marginRight: 14,
    "& > svg": {
      display: "block",
      width: "100%",
      height: "auto"
    }
  },
  buttonLabel: {
    display: "block",
    flexGrow: 1,
    fontSize: 14,
    fontWeight: 400
  }
});
class PulldownMenuItem extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children, onClick, icon: icon2 } = this.props;
      const rootProps = {
        role: "none",
        className: classes.root
      };
      const buttonProps = {
        type: "button",
        role: "menuitem",
        onClick,
        className: classes.button
      };
      return /* @__PURE__ */ jsx$1("li", { ...rootProps, children: /* @__PURE__ */ jsxs("button", { ...buttonProps, children: [
        icon2 && /* @__PURE__ */ jsx$1("span", { className: classes.buttonIcon, children: icon2 }),
        /* @__PURE__ */ jsx$1("span", { className: classes.buttonLabel, children })
      ] }) });
    });
  }
}
__publicField(PulldownMenuItem, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.string.isRequired,
  onClick: PropTypes$1.func.isRequired,
  icon: PropTypes$1.object
});
__publicField(PulldownMenuItem, "defaultProps", {
  icon: null
});
const pulldown_menu_item = injectSheet(styles$1J)(PulldownMenuItem);
const styles$1I = (theme2) => ({
  root: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    overflow: "hidden",
    boxSizing: "border-box",
    borderWidth: 0,
    appearance: "none",
    flexShrink: 0,
    cursor: "default",
    outline: "none",
    color: theme2.indigo3,
    backgroundColor: "transparent",
    position: "relative",
    lineHeight: "inherit",
    "&::before": {
      content: '""',
      position: "absolute",
      height: MIN_TARGET_SIZE,
      top: "50%",
      left: 0,
      right: 0,
      transform: "translateY(-50%)"
    },
    "&[data-is-warning=true]": {
      color: theme2.warningRed
    },
    "&[data-is-muted=true]": {
      color: theme2.grey4,
      "&[data-is-warning=true]:hover": {
        color: theme2.warningRed
      }
    },
    "&[disabled]": {
      color: theme2.grey4,
      "& img": {
        opacity: 0.3
      }
    },
    "&:not([disabled]):hover": {
      cursor: "pointer"
    }
  },
  prefix: {
    marginRight: 7,
    flexShrink: 0
  },
  suffix: {
    marginLeft: 7,
    flexShrink: 0
  },
  text: {
    color: "currentColor",
    fontSize: 14,
    fontWeight: 400,
    whiteSpace: "nowrap",
    ":not([disabled]):hover > &, :focus > &": {
      textDecoration: "underline"
    },
    '[aria-haspopup="true"] > &::after': {
      content: '"…"'
    }
  }
});
class Pushtext extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleClick", () => {
      if (!this.props.disabled) this.props.onClick();
    });
    __publicField(this, "render", () => {
      const {
        classes,
        children,
        disabled,
        hasPopup,
        mute,
        warning: warning2,
        textRef: ref2,
        prefix: prefix2,
        suffix,
        dataCy
      } = this.props;
      const rootProps = {
        onClick: this.handleClick,
        type: "button",
        className: classes.root,
        disabled,
        ref: ref2,
        "data-is-muted": mute,
        "data-is-warning": warning2,
        "aria-haspopup": hasPopup,
        "data-cy": dataCy || "atomic-button"
      };
      return /* @__PURE__ */ jsxs("button", { ...rootProps, children: [
        prefix2 && /* @__PURE__ */ jsx$1("span", { className: classes.prefix, children: prefix2 }),
        /* @__PURE__ */ jsx$1("span", { className: classes.text, children }),
        suffix && /* @__PURE__ */ jsx$1("span", { className: classes.suffix, children: suffix })
      ] });
    });
  }
}
__publicField(Pushtext, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  onClick: PropTypes$1.func.isRequired,
  textRef: PropTypes$1.func,
  hasPopup: PropTypes$1.bool,
  mute: PropTypes$1.bool,
  warning: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  prefix: PropTypes$1.node,
  suffix: PropTypes$1.node,
  dataCy: PropTypes$1.string
});
__publicField(Pushtext, "defaultProps", {
  disabled: false,
  hasPopup: false,
  mute: false,
  warning: false,
  textRef: null,
  prefix: null,
  suffix: null,
  dataCy: ""
});
const pushtext = injectSheet(styles$1I)(Pushtext);
const styles$1H = (theme2) => ({
  root: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    overflow: "hidden",
    boxSizing: "border-box",
    flexShrink: 0,
    color: theme2.indigo3,
    lineHeight: "inherit",
    "&[data-is-warning=true]": {
      color: theme2.warningRed
    },
    "&[data-is-muted=true]": {
      color: theme2.grey4,
      "&[data-is-warning=true]:hover": {
        color: theme2.warningRed
      }
    },
    '&[data-is-disabled="true"]': {
      color: theme2.grey4,
      "& img": {
        opacity: 0.3
      }
    }
  },
  prefix: {
    marginRight: 7,
    flexShrink: 0
  },
  suffix: {
    marginLeft: 7,
    flexShrink: 0
  },
  text: {
    color: `currentColor`,
    fontSize: 14,
    fontWeight: 400,
    whiteSpace: `nowrap`,
    outline: `none`,
    textDecoration: `none`,
    position: "relative",
    "&:focus": {
      textDecoration: `underline`
    },
    "&::before": {
      content: '""',
      position: "absolute",
      height: MIN_TARGET_SIZE,
      top: "50%",
      left: 0,
      right: 0,
      transform: "translateY(-50%)"
    },
    ':not([data-is-disabled="true"]) > &:hover': {
      cursor: "pointer",
      textDecoration: `underline`
    }
  }
});
class PushtextHref extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const {
        classes,
        children,
        href,
        mute,
        warning: warning2,
        disabled,
        external,
        textRef: ref2,
        prefix: prefix2,
        suffix
      } = this.props;
      if (disabled) {
        return /* @__PURE__ */ jsxs("div", { className: classes.root, "data-is-disabled": "true", children: [
          prefix2 && /* @__PURE__ */ jsx$1("span", { className: classes.prefix, children: prefix2 }),
          /* @__PURE__ */ jsx$1("span", { className: classes.text, children }),
          suffix && /* @__PURE__ */ jsx$1("span", { className: classes.suffix, children: suffix })
        ] });
      }
      const textProps = {
        href,
        role: "button",
        className: classes.text,
        ref: ref2
      };
      if (external) {
        textProps.rel = "external";
        textProps.target = "_blank";
      }
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: classes.root,
          "data-is-muted": mute,
          "data-is-warning": warning2,
          children: [
            prefix2 && /* @__PURE__ */ jsx$1("span", { className: classes.prefix, children: prefix2 }),
            /* @__PURE__ */ jsx$1("a", { ...textProps, children }),
            suffix && /* @__PURE__ */ jsx$1("span", { className: classes.suffix, children: suffix })
          ]
        }
      );
    });
  }
}
__publicField(PushtextHref, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  href: PropTypes$1.string.isRequired,
  textRef: PropTypes$1.func,
  mute: PropTypes$1.bool,
  warning: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  external: PropTypes$1.bool,
  prefix: PropTypes$1.node,
  suffix: PropTypes$1.node
});
__publicField(PushtextHref, "defaultProps", {
  textRef: null,
  mute: false,
  warning: false,
  disabled: false,
  external: false,
  prefix: null,
  suffix: null
});
const pushtext_href = injectSheet(styles$1H)(PushtextHref);
const styles$1G = (theme2) => ({
  root: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      height: MIN_TARGET_SIZE,
      top: "50%",
      left: 0,
      right: 0,
      transform: "translateY(-50%)"
    },
    "&:not([data-is-disabled=true])": {
      cursor: "pointer"
    },
    "&[data-is-disabled=true]": {
      opacity: 0.3,
      color: theme2.grey3
    }
  },
  checkbox: {
    order: 2,
    boxSizing: "border-box",
    width: 18,
    height: 18,
    color: theme2.grey4,
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: 10,
    borderColor: "currentColor",
    overflow: "hidden",
    boxShadow: `0 0 0 0 ${theme2.indigoPastel2}`,
    transition: `box-shadow 150ms linear 0ms, border-color 100ms linear 0ms`,
    position: "relative",
    "&[data-is-dark=true]": {
      color: theme2.grey2
    },
    "&::before": {
      content: '""',
      position: "absolute",
      borderRadius: 9,
      top: 1,
      left: 1,
      right: 1,
      bottom: 1,
      backgroundColor: theme2.indigo3,
      opacity: 0,
      transformOrigin: "center",
      transform: "scaleX(0) scaleY(0)",
      transition: "opacity 100ms linear 0ms, transform 0ms linear 100ms"
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: 4,
      left: 6,
      right: 5,
      bottom: 3,
      opacity: 0,
      transformOrigin: "center",
      transform: "rotate(45deg) translateY(-1px) translateX(-1px)",
      borderWidth: "0 2px 2px 0",
      borderStyle: "solid",
      borderColor: theme2.white1,
      boxSizing: "border-box",
      transition: "opacity 100ms linear 0ms"
    },
    "&[data-is-checked=true]": {
      color: theme2.indigo3,
      "&::before": {
        opacity: 1,
        transform: "scaleX(0.75) scaleY(0.75)",
        transition: "opacity 100ms linear 0ms, transform 50ms linear 0ms"
      }
    }
  },
  label: {
    fontSize: 11,
    fontWeight: 400,
    lineHeight: "14px",
    color: theme2.grey2,
    "&:not([data-is-inverted=true])": {
      order: 3,
      marginLeft: 7
    },
    "&[data-is-inverted=true]": {
      order: 1,
      marginRight: 7
    }
  },
  input: {
    position: "absolute",
    zIndex: 0,
    transform: "translateX(-200%)"
  }
});
class RadioButton extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      hasFocus: false
    });
    __publicField(this, "id", uniqueId$1("cb_"));
    __publicField(this, "timer");
    __publicField(this, "handleFocus", (e5) => {
      window.clearTimeout(this.timer);
      this.setState({
        hasFocus: true
      });
      this.props.handleFocus(e5);
    });
    __publicField(this, "handleBlur", (e5) => {
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        this.setState({
          hasFocus: false
        });
        this.props.handleBlur(e5);
      }, 50);
    });
    __publicField(this, "handleChange", (e5) => {
      if (this.props.disabled) return;
      this.props.handleChange(e5);
    });
    __publicField(this, "render", () => {
      const {
        classes,
        checked,
        label,
        invert,
        disabled,
        showLabel,
        isDark,
        value,
        dataCy
      } = this.props;
      const { hasFocus } = this.state;
      const rootProps = {
        className: classes.root,
        "data-is-disabled": disabled
      };
      const labelProps = {
        className: classes.label,
        "data-is-inverted": invert
      };
      const checkboxProps = {
        className: classes.checkbox,
        "data-is-checked": checked,
        "data-has-focus": hasFocus,
        "data-is-dark": isDark,
        "data-cy": dataCy || "atomic-radiobutton"
      };
      const inputProps = {
        className: classes.input,
        id: this.id,
        checked,
        type: "radio",
        disabled,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        value
      };
      return /* @__PURE__ */ jsxs("label", { ...rootProps, htmlFor: this.id, children: [
        /* @__PURE__ */ jsx$1(Invisible$1, { visible: showLabel, children: /* @__PURE__ */ jsx$1("div", { ...labelProps, children: label }) }),
        /* @__PURE__ */ jsx$1("div", { ...checkboxProps, children: /* @__PURE__ */ jsx$1("input", { ...inputProps }) })
      ] });
    });
  }
}
__publicField(RadioButton, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  label: PropTypes$1.string.isRequired,
  value: PropTypes$1.boolean || PropTypes$1.string,
  checked: PropTypes$1.bool,
  handleFocus: PropTypes$1.func,
  handleBlur: PropTypes$1.func,
  handleChange: PropTypes$1.func,
  invert: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  showLabel: PropTypes$1.bool,
  isDark: PropTypes$1.bool,
  dataCy: PropTypes$1.string
});
__publicField(RadioButton, "defaultProps", {
  checked: false,
  handleFocus: () => {
  },
  handleBlur: () => {
  },
  handleChange: () => {
  },
  invert: false,
  disabled: false,
  showLabel: false,
  isDark: false,
  value: null,
  dataCy: ""
});
const RadioButton$1 = injectSheet(styles$1G)(RadioButton);
const styles$1F = (theme2) => ({
  root: {
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme2.grey6}`
    }
  },
  header: {
    display: "flex",
    width: "100%",
    padding: "10px 7px",
    alignItems: "center",
    outline: "none",
    color: theme2.grey1,
    "&[disabled]": {
      cursor: "default",
      color: theme2.grey3
    }
  },
  icon: {
    width: 24,
    height: 24,
    flexShrink: 0,
    marginRight: 7,
    color: "currentColor",
    "& > svg": {
      display: "block",
      width: "100%",
      height: "100%"
    }
  },
  name: {
    flexGrow: 1,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "18px",
    marginRight: 7,
    color: "currentColor",
    textTransform: "capitalize"
  },
  traceCount: {
    textAlign: "right",
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "18px",
    marginRight: 3,
    flexShrink: 0,
    color: "currentColor"
  },
  toggleIcon: {
    width: 19,
    height: 19,
    color: "currentColor",
    flexShrink: 0
  },
  items: {
    paddingLeft: 7,
    paddingRight: 7,
    transition: "opacity 100ms linear 50ms",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
});
class Stage extends React__default.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "id", uniqueId$1("stage_"));
    __publicField(this, "headerId", `${this.id}_header`);
    __publicField(this, "render", () => {
      const { classes, header: header2, traceCount, expanded, onClick, children, icon: icon2 } = this.props;
      return /* @__PURE__ */ jsxs("div", { className: classes.root, "data-cy": "atomic-stage", children: [
        /* @__PURE__ */ jsxs(
          "button",
          {
            className: classes.header,
            disabled: !traceCount,
            type: "button",
            onClick,
            "aria-expanded": expanded,
            "aria-controls": this.id,
            children: [
              /* @__PURE__ */ jsx$1("div", { className: classes.icon, children: icon2 }),
              /* @__PURE__ */ jsx$1("div", { className: classes.name, role: "heading", id: this.headerId, children: /* @__PURE__ */ jsx$1("div", { className: classes.truncate, children: header2 }) }),
              /* @__PURE__ */ jsx$1("div", { className: classes.traceCount, children: traceCount }),
              /* @__PURE__ */ jsx$1("div", { className: classes.toggleIcon, children: expanded ? /* @__PURE__ */ jsx$1(icons.ArrowDownFill, {}) : /* @__PURE__ */ jsx$1(icons.ArrowDown, {}) })
            ]
          }
        ),
        /* @__PURE__ */ jsx$1(
          "div",
          {
            className: classes.items,
            hidden: !expanded,
            id: this.id,
            "aria-labelledby": this.headerId,
            children: expanded && children
          }
        )
      ] });
    });
  }
}
__publicField(Stage, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  header: PropTypes$1.string.isRequired,
  traceCount: PropTypes$1.number.isRequired,
  onClick: PropTypes$1.func.isRequired,
  icon: PropTypes$1.object,
  expanded: PropTypes$1.bool,
  children: PropTypes$1.node
});
__publicField(Stage, "defaultProps", {
  expanded: false,
  children: null,
  icon: null
});
const stage = injectSheet(styles$1F)(Stage);
const styles$1E = {
  root: {
    paddingBottom: 7
  }
};
class StageItem extends React__default.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children } = this.props;
      return /* @__PURE__ */ jsx$1("div", { className: classes.root, "data-cy": "atomic-stage-item", children });
    });
  }
}
__publicField(StageItem, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node
});
__publicField(StageItem, "defaultProps", {
  children: null
});
const stage_item = injectSheet(styles$1E)(StageItem);
const styles$1D = (theme2) => ({
  root: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      height: MIN_TARGET_SIZE,
      top: "50%",
      left: 0,
      right: 0,
      transform: "translateY(-50%)"
    },
    "&:not([data-is-disabled=true])": {
      cursor: "pointer"
    },
    "&[data-is-disabled=true]": {
      opacity: 0.3,
      color: theme2.grey3
    }
  },
  switch: {
    boxSizing: "border-box",
    width: 28,
    height: 16,
    color: theme2.grey4,
    borderRadius: 8,
    backgroundColor: "currentColor",
    overflow: "hidden",
    boxShadow: `0 0 0 0 ${theme2.indigoPastel2}`,
    transition: `box-shadow 150ms linear 0ms, background-color 100ms linear 0ms`,
    position: "relative",
    order: 2,
    userSelect: "none",
    "&::before": {
      content: '""',
      position: "absolute",
      borderRadius: 8,
      top: 2,
      left: 2,
      width: 12,
      bottom: 2,
      backgroundColor: theme2.white1,
      transformOrigin: "center",
      transform: "translateX(0)",
      transition: "transform 50ms ease"
    },
    "&[data-is-on=true]": {
      color: theme2.indigo3,
      "&::before": {
        transform: "translateX(12px)"
      }
    }
  },
  label: {
    fontSize: 12,
    fontColor: theme2.grey3,
    fontWeight: 400,
    lineHeight: "14px",
    color: theme2.grey3,
    "&[data-is-on=true]": {
      color: theme2.grey1
    },
    "&:not([data-is-inverted=true])": {
      order: 3,
      marginLeft: 5
    },
    "&[data-is-inverted=true]": {
      order: 1,
      marginRight: 7
    }
  },
  label2: {
    fontSize: 12,
    fontColor: theme2.grey3,
    fontWeight: 400,
    lineHeight: "14px",
    color: theme2.grey3,
    "&[data-is-on=true]": {
      color: theme2.grey1
    },
    "&:not([data-is-inverted=true])": {
      order: 1,
      marginRight: 5
    },
    "&[data-is-inverted=true]": {
      order: 3,
      marginLeft: 7
    }
  },
  input: {
    position: "absolute",
    zIndex: 0,
    transform: "translateX(-200%)"
  }
});
class Switch extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      hasFocus: false
    });
    __publicField(this, "id", uniqueId$1("cb_"));
    __publicField(this, "timer");
    __publicField(this, "handleFocus", (e5) => {
      window.clearTimeout(this.timer);
      this.setState({
        hasFocus: true
      });
      this.props.handleFocus(e5);
    });
    __publicField(this, "handleBlur", (e5) => {
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        this.setState({
          hasFocus: false
        });
        this.props.handleBlur(e5);
      }, 50);
    });
    __publicField(this, "handleChange", (e5) => {
      if (this.props.disabled) return;
      this.props.handleChange(e5);
    });
    __publicField(this, "render", () => {
      const {
        classes,
        on: on2,
        inputRef,
        label,
        label2,
        invert,
        disabled,
        showLabel
      } = this.props;
      const { hasFocus } = this.state;
      const rootProps = {
        className: classes.root,
        "data-is-disabled": disabled
      };
      const labelProps = {
        className: classes.label,
        "data-is-on": on2,
        "data-is-inverted": invert
      };
      const labelProps2 = {
        className: classes.label2,
        "data-is-on": !on2,
        "data-is-inverted": invert
      };
      const switchProps = {
        className: classes.switch,
        "data-is-on": on2,
        "data-has-focus": hasFocus
      };
      const inputProps = {
        className: classes.input,
        id: this.id,
        checked: on2,
        type: "checkbox",
        disabled,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        ref: inputRef
      };
      return /* @__PURE__ */ jsxs("label", { ...rootProps, htmlFor: this.id, children: [
        /* @__PURE__ */ jsx$1(Invisible$1, { visible: showLabel, children: /* @__PURE__ */ jsx$1("div", { ...labelProps, children: label }) }),
        /* @__PURE__ */ jsx$1("div", { ...switchProps, children: /* @__PURE__ */ jsx$1("input", { ...inputProps }) }),
        label2 && /* @__PURE__ */ jsx$1(Invisible$1, { visible: showLabel, children: /* @__PURE__ */ jsx$1("div", { ...labelProps2, children: label2 }) })
      ] });
    });
  }
}
__publicField(Switch, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  label: PropTypes$1.node.isRequired,
  label2: PropTypes$1.string,
  on: PropTypes$1.bool,
  handleFocus: PropTypes$1.func,
  handleBlur: PropTypes$1.func,
  handleChange: PropTypes$1.func,
  inputRef: PropTypes$1.func,
  invert: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  showLabel: PropTypes$1.bool
});
__publicField(Switch, "defaultProps", {
  label2: "",
  on: false,
  handleFocus: () => {
  },
  handleBlur: () => {
  },
  handleChange: () => {
  },
  inputRef: () => {
  },
  invert: false,
  disabled: false,
  showLabel: false
});
const Switch$1 = injectSheet(styles$1D)(Switch);
const styles$1C = (theme2) => ({
  root: {
    display: "flex"
  },
  constraint: {
    backgroundColor: ({ backgroundColor }) => theme2[backgroundColor] || theme2.grey7,
    borderRadius: 7.5,
    fontSize: 10,
    fontWeight: 400,
    color: ({ color }) => theme2[color] || theme2.grey3,
    lineHeight: "15px",
    paddingLeft: 7,
    paddingRight: 7
  }
});
class Tally extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => /* @__PURE__ */ jsx$1("div", { className: this.props.classes.root, children: /* @__PURE__ */ jsx$1("div", { className: this.props.classes.constraint, children: this.props.value }) }));
  }
}
__publicField(Tally, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  value: PropTypes$1.number.isRequired,
  // The following props are used in ./tally.style.js
  color: PropTypes$1.string,
  backgroundColor: PropTypes$1.string
});
__publicField(Tally, "defaultProps", {
  color: "grey3",
  backgroundColor: "grey7"
});
const tally = injectSheet(styles$1C)(Tally);
const styles$1B = (theme2) => ({
  root: {
    padding: 14,
    backgroundColor: theme2.white1,
    border: `1px solid ${theme2.grey6}`,
    borderRadius: 4
  }
});
class Tile extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children } = this.props;
      return /* @__PURE__ */ jsx$1("div", { className: classes.root, children });
    });
  }
}
__publicField(Tile, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired
});
const tile = injectSheet(styles$1B)(Tile);
const styles$1A = (theme2) => ({
  root: {
    listStyle: "none",
    paddingLeft: 0,
    margin: 0,
    display: "flex"
  },
  item: {
    flexShrink: 1,
    minWidth: 0,
    position: "relative",
    "&:not(:last-child)": {
      paddingRight: 21,
      marginRight: 21,
      "&::after": {
        content: '""',
        position: "absolute",
        top: 14,
        right: 0,
        bottom: 0,
        width: 1,
        backgroundColor: theme2.grey5
      }
    }
  }
});
class Todo extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, children } = this.props;
      return /* @__PURE__ */ jsx$1("ul", { className: classes.root, children: Children$1.map(children, (item) => /* @__PURE__ */ jsx$1("li", { className: classes.item, children: item })) });
    });
  }
}
__publicField(Todo, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired
});
const todo = injectSheet(styles$1A)(Todo);
const styles$1z = (theme2) => ({
  root: {
    color: theme2.grey4,
    fontWeight: 400,
    position: "relative",
    paddingTop: 14,
    marginTop: 0,
    marginBottom: 0,
    transition: "color 100ms linear 0ms",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: 4,
      backgroundColor: "currentColor",
      opacity: 0,
      transition: "opacity 100ms linear 0ms"
    },
    "&[data-is-doing=true]": {
      color: theme2.grey2,
      fontWeight: 700,
      "&::before": {
        opacity: 1
      }
    }
  },
  icon: {
    opacity: 0,
    color: theme2.validGreen,
    width: 16,
    marginLeft: 7,
    transition: "opacity 100ms linear 0ms",
    "[data-is-done=true] &": {
      opacity: 1
    }
  },
  label: {
    fontSize: 10,
    lineHeight: 1,
    fontWeight: 600,
    height: 16,
    display: "flex",
    alignItems: "center",
    marginBottom: 4,
    color: "inherit",
    textTransform: "uppercase",
    letterSpacing: 1,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  title: {
    fontSize: 12,
    lineHeight: 1,
    fontWeight: "inherit",
    color: "inherit",
    marginLeft: 0,
    position: "relative",
    "&::before": {
      content: "attr(data-text)",
      position: "absolute",
      left: 0,
      right: 0,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      transition: "font-weight 100ms linear 0ms"
    }
  },
  titleText: {
    visibility: "hidden",
    fontWeight: 700,
    overflow: `hidden`,
    whiteSpace: `nowrap`,
    textOverflow: `ellipsis`
  }
});
class TodoItem extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, label, title: title2, done, doing } = this.props;
      return /* @__PURE__ */ jsxs("dl", { className: classes.root, "data-is-doing": doing, "data-is-done": done, children: [
        /* @__PURE__ */ jsxs("dt", { className: classes.label, children: [
          label,
          /* @__PURE__ */ jsx$1("span", { className: classes.icon, children: /* @__PURE__ */ jsx$1(icons.CheckCircle, {}) })
        ] }),
        /* @__PURE__ */ jsx$1("dd", { className: classes.title, "data-text": title2, children: /* @__PURE__ */ jsx$1("span", { className: classes.titleText, children: title2 }) })
      ] });
    });
  }
}
__publicField(TodoItem, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  label: PropTypes$1.string.isRequired,
  title: PropTypes$1.string.isRequired,
  done: PropTypes$1.bool,
  doing: PropTypes$1.bool
});
__publicField(TodoItem, "defaultProps", {
  done: false,
  doing: false
});
const todo_item = injectSheet(styles$1z)(TodoItem);
const styles$1y = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconArrowDown extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, active, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1("path", { d: "M15.99 23.69a1.49 1.49 0 0 1-1.3-.75L7.56 10.56a1.44 1.44 0 0 1 0-1.5 1.48 1.48 0 0 1 1.3-.75h14.29a1.5 1.5 0 0 1 1.3 2.25L17.3 22.94a1.49 1.49 0 0 1-1.31.75zM8.86 9.81l7.13 12.38.65.37-.65-.37 7.16-12.38H8.86z" }),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M15.99 23.69a1.49 1.49 0 0 1-1.3-.75L7.56 10.56a1.44 1.44 0 0 1 0-1.5 1.48 1.48 0 0 1 1.3-.75h14.29a1.5 1.5 0 0 1 1.3 2.25L17.3 22.94a1.49 1.49 0 0 1-1.31.75z",
                className: classes.fill,
                hidden: !active
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconArrowDown, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  active: PropTypes$1.bool,
  size: PropTypes$1.number
});
__publicField(UiconArrowDown, "defaultProps", {
  active: false,
  size: null
});
const uicon_arrow_down = injectSheet(styles$1y)(UiconArrowDown);
class UiconBullets extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M12.709 14.949h13.41v1.98h-13.41v-1.98zM12.709 21.821h13.41v1.98h-13.41v-1.98zM12.709 8.198h13.41v1.981h-13.41v-1.98zM5.882 8.198h3.017v1.981H5.882v-1.98zM5.882 14.949h3.017v1.98H5.882v-1.98zM5.882 21.821h3.017v1.98H5.882v-1.98z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconBullets, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconBullets, "defaultProps", {
  size: null
});
const uicon_bullets = injectSheet(styles$1y)(UiconBullets);
const styles$1x = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear 0ms"
  }
};
class UiconBulletsFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M28.952 0H3.048A3.048 3.048 0 000 3.048v25.904A3.048 3.048 0 003.048 32h25.904A3.048 3.048 0 0032 28.952V3.048A3.048 3.048 0 0028.952 0zM8.9 23.802H5.851V21.82H8.9v1.98zm0-6.872H5.851v-1.981H8.9v1.98zm0-6.751H5.851v-1.98H8.9v1.98zm17.22 13.623h-13.41V21.82h13.41v1.98zm0-6.872h-13.41v-1.981h13.41v1.98zm0-6.751h-13.41v-1.98h13.41v1.98z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconBulletsFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconBulletsFill, "defaultProps", {
  size: null
});
const uicon_bullets_fill = injectSheet(styles$1x)(UiconBulletsFill);
const styles$1w = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  opacity: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  },
  fill: {
    fill: "currentColor",
    transition: "color 100ms linear",
    "&[hidden]": {
      fill: "white"
    }
  }
};
class UiconCalendar extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, active, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M26.23,5.78H23.94V3.15h-1.3V5.78H9.36V3.15H8.06V5.78H5.77A2.65,2.65,0,0,0,3.12,8.43V26.2a2.65,2.65,0,0,0,2.65,2.65H26.23a2.65,2.65,0,0,0,2.65-2.65V8.43a2.65,2.65,0,0,0-2.65-2.65Zm-15.34,19H7.54v-1.3h3.35Zm0-4H7.54v-1.3h3.35Zm6.79,4H14.32v-1.3h3.36Zm0-4H14.32v-1.3h3.36Zm0-4H14.32v-1.3h3.36Zm6.78,8H21.11v-1.3h3.35Zm0-4H21.11v-1.3h3.35Zm0-4H21.11v-1.3h3.35Zm3.12-5.39H4.42V8.43A1.35,1.35,0,0,1,5.77,7.08H26.23a1.35,1.35,0,0,1,1.35,1.35Z",
                className: classes.opacity,
                hidden: !active
              }
            ),
            /* @__PURE__ */ jsx$1("path", { d: "M26.23,5.78H23.94V3.15h-1.3V5.78H9.36V3.15H8.06V5.78H5.77A2.65,2.65,0,0,0,3.12,8.43V26.2a2.65,2.65,0,0,0,2.65,2.65H26.23a2.65,2.65,0,0,0,2.65-2.65V8.43a2.65,2.65,0,0,0-2.65-2.65ZM5.77,7.08H26.23a1.35,1.35,0,0,1,1.35,1.35v2.93H4.42V8.43A1.35,1.35,0,0,1,5.77,7.08ZM26.23,27.55H5.77A1.34,1.34,0,0,1,4.42,26.2V12.66H27.58V26.2a1.34,1.34,0,0,1-1.35,1.35Z" }),
            /* @__PURE__ */ jsx$1(
              "rect",
              {
                width: "3.35",
                height: "1.3",
                transform: "translate(14.32 15.45)",
                hidden: active,
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "rect",
              {
                width: "3.35",
                height: "1.3",
                transform: "translate(21.11 15.45)",
                hidden: active,
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "rect",
              {
                width: "3.35",
                height: "1.3",
                transform: "translate(14.32 19.44)",
                hidden: active,
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "rect",
              {
                width: "3.35",
                height: "1.3",
                transform: "translate(7.54 19.44)",
                hidden: active,
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "rect",
              {
                width: "3.35",
                height: "1.3",
                transform: "translate(21.11 19.44)",
                hidden: active,
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "rect",
              {
                width: "3.35",
                height: "1.3",
                transform: "translate(14.32 23.44)",
                hidden: active,
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "rect",
              {
                width: "3.35",
                height: "1.3",
                transform: "translate(7.54 23.44)",
                hidden: active,
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "rect",
              {
                width: "3.35",
                height: "1.3",
                transform: "translate(21.11 23.44)",
                hidden: active,
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconCalendar, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  active: PropTypes$1.bool,
  size: PropTypes$1.number
});
__publicField(UiconCalendar, "defaultProps", {
  active: false,
  size: null
});
const uicon_calendar = injectSheet(styles$1w)(UiconCalendar);
const styles$1v = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear 0ms"
  }
};
class UiconCheckCircle extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "nonzero",
              d: "M13.651 21.47c-.208-.001-.407-.083-.555-.229l-4.469-4.482 1.108-1.096 3.916 3.951 8.602-8.795 1.12 1.097-9.156 9.361c-.15.144-.347.23-.554.241l-.012-.048zM16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16c-.013 8.831-7.169 15.987-16 16zm0-30.458C8.015 1.542 1.542 8.015 1.542 16S8.015 30.458 16 30.458 30.458 23.985 30.458 16 23.985 1.542 16 1.542z"
            }
          )
        }
      );
    });
  }
}
__publicField(UiconCheckCircle, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconCheckCircle, "defaultProps", {
  size: null
});
const uicon_check_circle = injectSheet(styles$1v)(UiconCheckCircle);
const styles$1u = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear 0ms"
  }
};
class UiconCheckCircleFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1("path", { d: "M16,0c8.831,0 16,7.169 16,16c0,8.831 -7.169,16 -16,16c-8.831,0 -16,-7.169 -16,-16c0,-8.831 7.169,-16 16,-16Zm-2.349,21.47l0.012,0.048c0.207,-0.011 0.404,-0.097 0.554,-0.241l9.156,-9.361l-1.12,-1.097l-8.602,8.795l-3.916,-3.951l-1.108,1.096l4.469,4.482c0.148,0.146 0.347,0.228 0.555,0.229Z" })
        }
      );
    });
  }
}
__publicField(UiconCheckCircleFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconCheckCircleFill, "defaultProps", {
  size: null
});
const uicon_check_circle_fill = injectSheet(styles$1u)(UiconCheckCircleFill);
const styles$1t = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear 0ms"
  }
};
class UiconCheckShield extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "nonzero",
              d: "M15.993 31.998c-.255.002-.507-.055-.736-.167C6.28 27.363 1.381 18.039 2.117 6.286v-.319c0-.442.175-.866.486-1.18.304-.317.725-.498 1.165-.499 3.927 0 4.163-2.22 4.163-2.665C7.953.731 8.689.007 9.582 0h12.877c.903.007 1.644.748 1.651 1.651 0 .43.25 2.637 4.163 2.637.45.004.881.189 1.193.513.308.308.474.731.458 1.166v.319c.708 11.808-4.093 21.147-13.168 25.601-.239.097-.498.135-.763.111zm6.369-30.194H9.693c-.102 1.715-1.435 4.228-5.828 4.288V6.3C3.227 17.387 7.667 26.087 16.09 30.208c8.325-4.163 12.696-12.821 12.044-23.881V6.05c-4.335 0-5.656-2.585-5.772-4.246zM13.651 21.47c-.208-.001-.407-.083-.555-.229l-4.469-4.482 1.108-1.096 3.916 3.951 8.602-8.795 1.12 1.097-9.156 9.361c-.15.144-.347.23-.554.241l-.012-.048z"
            }
          )
        }
      );
    });
  }
}
__publicField(UiconCheckShield, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconCheckShield, "defaultProps", {
  size: null
});
const uicon_check_shield = injectSheet(styles$1t)(UiconCheckShield);
const styles$1s = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear 0ms"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconClipboard extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, checked, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                fillRule: "nonzero",
                d: "M20.8,3.3 C22.5,3.3 23.9,4.7 23.9,6.3 L23.9,27 C23.9,28.7 22.5,30.1 20.8,30.1 L3.2,30.1 C1.5,30.1 0.1,28.7 0.1,27 L0.1,6.3 C0.1,5.5 0.5,4.7 1.1,4.1 C1.7,3.5 2.5,3.2 3.3,3.3 L8,3.3 C8.4,1.4 10.1,0 12.1,0 C14.1,0 15.8,1.4 16.2,3.3 L20.8,3.3 Z M6.3,4.7 L6.3,8.2 L17.8,8.2 L17.8,4.7 C17.7,4.7 6.3,4.7 6.3,4.7 Z M12,1.2 L12,1.2 C10.8,1.2 9.8,2.1 9.4,3.2 L14.5,3.2 C14.3,2.1 13.2,1.2 12,1.2 Z M22.4,27 L22.4,6.3 C22.4,5.4 21.7,4.7 20.8,4.7 L19.2,4.7 L19.2,8.9 C19.2,9.3 18.9,9.7 18.4,9.7 L5.4,9.7 C5,9.7 4.6,9.4 4.6,8.9 L4.6,4.7 L3.2,4.7 C2.3,4.7 1.6,5.4 1.6,6.3 L1.6,27 C1.6,27.9 2.3,28.5 3.2,28.5 L20.8,28.5 C21.7,28.5 22.4,27.8 22.4,27 Z"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                hidden: !checked,
                className: classes.fill,
                d: "M10.3,23.1 L18.5,13.9 L19.7,14.8 L10.9,24.6 C10.7,24.8 10.5,24.9 10.3,24.9 C10.1,24.9 9.9,24.8 9.8,24.7 L5,20.9 L6,19.7 L10.3,23.1 Z M10.3,21.2 C10.1,21.2 9.9,21.1 9.8,21 L6.3,18.2 L7.3,17 L10.2,19.4 L16.7,12 L17.9,13 L10.9,20.9 C10.7,21.1 10.5,21.2 10.3,21.2 Z"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                hidden: checked,
                className: classes.fill,
                d: "M10,13.5 L18.5,13.5 L18.5,15 L10,15 L10,13.5 Z M5.5,13.5 L8,13.5 L8,15 L5.5,15 L5.5,13.5 Z M10,18.6 L18.5,18.6 L18.5,20.1 L10,20.1 L10,18.6 Z M5.5,18.6 L8,18.6 L8,20.1 L5.5,20.1 L5.5,18.6 Z M10,23.6 L18.5,23.6 L18.5,25.1 L10,25.1 L10,23.6 Z M5.5,23.6 L8,23.6 L8,25.1 L5.5,25.1 L5.5,23.6 Z"
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconClipboard, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  checked: PropTypes$1.bool,
  size: PropTypes$1.number
});
__publicField(UiconClipboard, "defaultProps", {
  checked: false,
  size: null
});
const uicon_clipboard = injectSheet(styles$1s)(UiconClipboard);
const styles$1r = {
  root: {
    maxWidth: 100,
    maxHeight: 100,
    fill: "currentColor",
    display: "block",
    "& path": {
      transition: "opacity 100ms linear"
    }
  }
};
const UiconFilter = ({ classes, active, size: size2 }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: "1.41421",
    clipRule: "evenodd",
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    className: classes.root,
    style: { width: size2, height: size2 },
    children: [
      /* @__PURE__ */ jsx$1("path", { d: "M13.674 27.61a.66.66 0 0 1-.67-.61v-9.4L6.584 6.67a1.622 1.622 0 0 1 0-1.5 1.42 1.42 0 0 1 1.25-.78h16.35a1.4 1.4 0 0 1 1.24.78 1.6 1.6 0 0 1 0 1.46l-6.42 10.93v7.52a.652.652 0 0 1-.41.61l-4.66 1.87a.703.703 0 0 1-.26.05zM7.824 5.69s-.07 0-.1.09a.319.319 0 0 0 0 .27l6.5 11c.06.1.091.214.09.33V26l3.37-1.35v-7.27a.63.63 0 0 1 .09-.33L24.304 6a.28.28 0 0 0 0-.23c0-.06-.07-.09-.09-.09l-16.39.01z" }),
      /* @__PURE__ */ jsx$1(
        "path",
        {
          style: { opacity: active ? 1 : 0 },
          d: "M13.716 27.4a.649.649 0 0 1-.658-.599v-9.23L6.754 6.839a1.59 1.59 0 0 1 0-1.473c.235-.464.708-.76 1.228-.766h16.054c.518.006.988.302 1.217.766.231.45.231.983 0 1.433L18.95 17.532v7.384a.64.64 0 0 1-.403.599l-4.576 1.836a.696.696 0 0 1-.255.049z"
        }
      )
    ]
  }
);
UiconFilter.propTypes = {
  classes: PropTypes$1.object.isRequired,
  active: PropTypes$1.bool,
  size: PropTypes$1.number
};
UiconFilter.defaultProps = {
  active: false,
  size: null
};
const uicon_filter = injectSheet(styles$1r)(UiconFilter);
const styles$1q = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear 0ms"
  }
};
class UiconFlagFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "nonzero",
              d: "M1.698 12.2L1.367 2.033c.001-.386.391-.715.924-.78 3.241-.54 6.648-.189 9.543.984 1.302.584 2.484 1.295 3.511 2.112.987.764 2.118 1.427 3.36 1.968 3.233 1.251 7.083 1.397 10.483.396.336-.075.702-.035.991.108.284.149.452.385.454.636v14.496c-.004.325-.283.615-.706.732-4.368 1.2-8.198 1.068-11.373-.252-1.188-.512-2.269-1.142-3.209-1.872-1.089-.856-2.345-1.596-3.73-2.196-2.169-.89-4.653-1.299-7.137-1.18v13.809h-2.78V12.2z"
            }
          )
        }
      );
    });
  }
}
__publicField(UiconFlagFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconFlagFill, "defaultProps", {
  size: null
});
const uicon_flag_fill = injectSheet(styles$1q)(UiconFlagFill);
const styles$1p = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear 0ms"
  }
};
class UiconKeyHorizontal extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1("path", { d: "M32 32v-9.407h-1.475v-5.799h-2.553c0 .749.068 2.134.068 3.405h-1.475c-.069-1.702-.069-2.78-.069-3.473H24v5.402h-1.487v-5.436h-4.539l-4.187 7.251h-9.18L0 16l4.607-7.943h9.18l4.199 7.194H32V0v32zM12.959 9.532l-7.501-.034L1.702 16l3.756 6.502h7.501L16.715 16l-3.756-6.468zM9.248 19.96c-1.056.009-2.072-.404-2.822-1.148-.75-.743-1.172-1.756-1.172-2.812 0-2.183 1.766-3.954 3.949-3.96 2.183-.006 3.959 1.755 3.971 3.938.013 2.182-1.743 3.964-3.926 3.982zm0-6.434c-.664-.012-1.305.243-1.778.709-.474.465-.741 1.101-.741 1.765 0 1.36 1.099 2.465 2.459 2.473 1.36.008 2.472-1.083 2.488-2.443.017-1.36-1.068-2.479-2.428-2.504z" })
        }
      );
    });
  }
}
__publicField(UiconKeyHorizontal, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconKeyHorizontal, "defaultProps", {
  size: null
});
const uicon_key_horizontal = injectSheet(styles$1p)(UiconKeyHorizontal);
const styles$1o = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear 0ms"
  }
};
class UiconLink extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M26.606 6.796l-1.402-1.402-2.469 2.469a6.415 6.415 0 00-3.718-1.22 6.309 6.309 0 00-4.48 1.86l-6.095 6.095a6.324 6.324 0 00-.64 8.198l-2.408 2.408 1.402 1.402 2.469-2.469a6.415 6.415 0 003.718 1.22 6.309 6.309 0 004.48-1.86l6.095-6.095a6.323 6.323 0 00.64-8.198l2.408-2.408zm-3.23 6.187a4.31 4.31 0 01-1.28 3.047L16 22.127a4.312 4.312 0 01-3.048 1.28 4.358 4.358 0 01-2.285-.701l2.346-2.332-1.402-1.402-2.316 2.362a4.358 4.358 0 01-.67-2.3 4.312 4.312 0 011.28-3.048L16 9.89a4.311 4.311 0 013.048-1.28 4.266 4.266 0 012.285.685l-2.362 2.332 1.402 1.402 2.332-2.362c.441.691.674 1.495.67 2.316z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconLink, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconLink, "defaultProps", {
  size: null
});
const uicon_link = injectSheet(styles$1o)(UiconLink);
const styles$1n = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear 0ms"
  }
};
class UiconLinkFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M20.373 13.029l-1.402-1.402 2.362-2.332a4.267 4.267 0 00-2.285-.67A4.312 4.312 0 0016 9.905L9.905 16a4.311 4.311 0 00-1.28 3.048c.007.809.239 1.6.67 2.285l2.332-2.346 1.402 1.402-2.362 2.316c.689.434 1.486.666 2.3.67a4.31 4.31 0 003.048-1.28L22.11 16a4.312 4.312 0 001.28-3.048 4.267 4.267 0 00-.685-2.285l-2.332 2.362z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M28.952 0H3.048A3.048 3.048 0 000 3.048v25.904A3.048 3.048 0 003.048 32h25.904A3.048 3.048 0 0032 28.952V3.048A3.048 3.048 0 0028.952 0zm-5.455 17.463l-6.095 6.095a6.31 6.31 0 01-4.48 1.86 6.415 6.415 0 01-3.718-1.22l-2.408 2.408-1.402-1.402 2.469-2.469a6.324 6.324 0 01.64-8.198l6.095-6.095a6.308 6.308 0 014.48-1.86 6.415 6.415 0 013.718 1.22l2.469-2.469 1.402 1.402-2.53 2.53a6.324 6.324 0 01-.64 8.198z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconLinkFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconLinkFill, "defaultProps", {
  size: null
});
const uicon_link_fill = injectSheet(styles$1n)(UiconLinkFill);
const styles$1m = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear 0ms",
    transform: "rotate(45deg)"
  }
};
class UiconLinkHorizontal extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M26.606 6.796l-1.402-1.402-2.469 2.469a6.415 6.415 0 00-3.718-1.22 6.309 6.309 0 00-4.48 1.86l-6.095 6.095a6.324 6.324 0 00-.64 8.198l-2.408 2.408 1.402 1.402 2.469-2.469a6.415 6.415 0 003.718 1.22 6.309 6.309 0 004.48-1.86l6.095-6.095a6.323 6.323 0 00.64-8.198l2.408-2.408zm-3.23 6.187a4.31 4.31 0 01-1.28 3.047L16 22.127a4.312 4.312 0 01-3.048 1.28 4.358 4.358 0 01-2.285-.701l2.346-2.332-1.402-1.402-2.316 2.362a4.358 4.358 0 01-.67-2.3 4.312 4.312 0 011.28-3.048L16 9.89a4.311 4.311 0 013.048-1.28 4.266 4.266 0 012.285.685l-2.362 2.332 1.402 1.402 2.332-2.362c.441.691.674 1.495.67 2.316z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconLinkHorizontal, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconLinkHorizontal, "defaultProps", {
  size: null
});
const uicon_link_horizontal = injectSheet(styles$1m)(UiconLinkHorizontal);
const styles$1l = {
  root: {
    display: "block",
    stroke: "currentColor",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear 0ms"
  }
};
class UiconLoupe extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 17 17",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "ellipse",
              {
                cx: "6.5",
                cy: "7.2",
                rx: "5.5",
                ry: "5.5",
                strokeWidth: "0.8",
                fill: "transparent"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "line",
              {
                x1: "12.457",
                y1: "13.117",
                x2: "16.051",
                y2: "16.767",
                strokeWidth: "0.8"
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M10.5,7.2H9.7c0-1.7-1.4-3.1-3.2-3.1V3.3C8.7,3.3,10.5,5,10.5,7.2z",
                strokeWidth: "0.025"
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconLoupe, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconLoupe, "defaultProps", {
  size: null
});
const uicon_loupe = injectSheet(styles$1l)(UiconLoupe);
const styles$1k = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear 0ms"
  }
};
class UiconUpload extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M24.462 20.0596V23.3596C24.462 23.7266 23.862 24.1376 23.062 24.1376H8.70001C7.90001 24.1376 7.3 23.7266 7.3 23.3596V20.0596H6V23.3596C6 24.5246 7.18601 25.4376 8.70001 25.4376H23.06C24.575 25.4376 25.76 24.5246 25.76 23.3596V20.0596H24.462Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M15.23 7.66648V20.3105H16.53V7.66648L20.981 12.1165L21.9 11.1975L17.252 6.55048C16.8826 6.19718 16.3911 6 15.88 6C15.3688 6 14.8774 6.19718 14.508 6.55048L9.85999 11.1975L10.779 12.1165L15.23 7.66648Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconUpload, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconUpload, "defaultProps", {
  size: null
});
const uicon_upload = injectSheet(styles$1k)(UiconUpload);
const styles$1j = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconCircleCross extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M16.276 29.552C13.6503 29.552 11.0835 28.7734 8.90026 27.3146C6.71703 25.8558 5.01541 23.7824 4.01058 21.3565C3.00575 18.9306 2.74284 16.2613 3.2551 13.686C3.76736 11.1107 5.03178 8.74514 6.88846 6.88846C8.74515 5.03177 11.1107 3.76736 13.686 3.2551C16.2613 2.74284 18.9306 3.00575 21.3565 4.01058C23.7824 5.01541 25.8558 6.71703 27.3146 8.90026C28.7734 11.0835 29.552 13.6503 29.552 16.276C29.5483 19.7959 28.1484 23.1705 25.6595 25.6595C23.1705 28.1484 19.7959 29.5483 16.276 29.552ZM16.276 4.29901C13.9072 4.29901 11.5915 5.00144 9.62194 6.31749C7.65233 7.63354 6.11721 9.5041 5.2107 11.6926C4.30419 13.8811 4.067 16.2893 4.52913 18.6126C4.99127 20.9359 6.13197 23.07 7.80698 24.745C9.48199 26.42 11.6161 27.5607 13.9394 28.0229C16.2627 28.485 18.6709 28.2478 20.8594 27.3413C23.0479 26.4348 24.9185 24.8997 26.2345 22.9301C27.5506 20.9605 28.253 18.6448 28.253 16.276C28.2493 13.1006 26.9862 10.0564 24.7409 7.81108C22.4956 5.56576 19.4514 4.30271 16.276 4.29901Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M12.5352 11.6157L11.616 12.5349L20.0171 20.936L20.9363 20.0168L12.5352 11.6157Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M20.0171 11.6157L11.616 20.0168L12.5352 20.9361L20.9363 12.5349L20.0171 11.6157Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconCircleCross, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconCircleCross, "defaultProps", {
  size: null
});
const uicon_circle_cross = injectSheet(styles$1j)(UiconCircleCross);
const styles$1i = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconCircleCrossFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M16.276 29.552C13.6503 29.552 11.0835 28.7734 8.90026 27.3146C6.71703 25.8558 5.01541 23.7824 4.01058 21.3565C3.00575 18.9306 2.74284 16.2613 3.2551 13.686C3.76736 11.1107 5.03178 8.74514 6.88846 6.88846C8.74515 5.03177 11.1107 3.76736 13.686 3.2551C16.2613 2.74284 18.9306 3.00575 21.3565 4.01058C23.7824 5.01541 25.8558 6.71703 27.3146 8.90026C28.7734 11.0835 29.552 13.6503 29.552 16.276C29.5483 19.7959 28.1484 23.1705 25.6595 25.6595C23.1705 28.1484 19.7959 29.5483 16.276 29.552ZM12.5352 11.6157L11.616 12.535L15.3569 16.2759L11.616 20.0169L12.5352 20.9361L16.2762 17.1952L20.0171 20.9361L20.9363 20.0169L17.1954 16.2759L20.9363 12.535L20.0171 11.6158L16.2762 15.3567L12.5352 11.6157Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconCircleCrossFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconCircleCrossFill, "defaultProps", {
  size: null
});
const uicon_circle_cross_fill = injectSheet(styles$1i)(UiconCircleCrossFill);
const styles$1h = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconCircleInfo extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M16.276 29.552C13.6503 29.552 11.0835 28.7734 8.90026 27.3146C6.71703 25.8558 5.01541 23.7824 4.01058 21.3565C3.00575 18.9306 2.74284 16.2613 3.2551 13.686C3.76736 11.1107 5.03178 8.74514 6.88846 6.88845C8.74515 5.03177 11.1107 3.76736 13.686 3.2551C16.2613 2.74284 18.9306 3.00575 21.3565 4.01058C23.7824 5.01541 25.8558 6.71703 27.3146 8.90025C28.7734 11.0835 29.552 13.6503 29.552 16.276C29.5483 19.7959 28.1484 23.1705 25.6595 25.6595C23.1705 28.1484 19.7959 29.5483 16.276 29.552ZM16.276 4.299C13.9072 4.299 11.5915 5.00144 9.62194 6.31749C7.65233 7.63354 6.11721 9.50409 5.2107 11.6926C4.30419 13.8811 4.067 16.2893 4.52913 18.6126C4.99127 20.9359 6.13197 23.07 7.80698 24.745C9.48199 26.42 11.6161 27.5607 13.9394 28.0229C16.2627 28.485 18.6709 28.2478 20.8594 27.3413C23.0479 26.4348 24.9185 24.8997 26.2345 22.9301C27.5506 20.9605 28.253 18.6448 28.253 16.276C28.2493 13.1006 26.9862 10.0564 24.7409 7.81108C22.4956 5.56576 19.4514 4.30271 16.276 4.299Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M18.036 14.29L16.389 22.064H13.701L15.335 14.29H18.036Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M18.852 10.488L18.39 12.688H15.69L16.152 10.488H18.852Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconCircleInfo, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconCircleInfo, "defaultProps", {
  size: null
});
const uicon_circle_info = injectSheet(styles$1h)(UiconCircleInfo);
const styles$1g = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconCircleInfoFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.90026 27.3146C11.0835 28.7734 13.6503 29.552 16.276 29.552C19.7959 29.5483 23.1705 28.1484 25.6595 25.6595C28.1484 23.1705 29.5483 19.7959 29.552 16.276C29.552 13.6503 28.7734 11.0835 27.3146 8.90025C25.8558 6.71703 23.7824 5.01541 21.3565 4.01058C18.9306 3.00575 16.2613 2.74284 13.686 3.2551C11.1107 3.76736 8.74515 5.03177 6.88846 6.88845C5.03178 8.74514 3.76736 11.1107 3.2551 13.686C2.74284 16.2613 3.00575 18.9306 4.01058 21.3565C5.01541 23.7824 6.71703 25.8558 8.90026 27.3146ZM18.036 14.29L16.389 22.064H13.701L15.335 14.29H18.036ZM18.39 12.688L18.852 10.488H16.152L15.69 12.688H18.39Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconCircleInfoFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconCircleInfoFill, "defaultProps", {
  size: null
});
const uicon_circle_info_fill = injectSheet(styles$1g)(UiconCircleInfoFill);
const styles$1f = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconCirclePlus extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M16.276 29.552C13.6503 29.552 11.0835 28.7734 8.90025 27.3146C6.71703 25.8558 5.01541 23.7824 4.01058 21.3565C3.00575 18.9306 2.74284 16.2613 3.2551 13.686C3.76736 11.1107 5.03177 8.74514 6.88845 6.88846C8.74514 5.03177 11.1107 3.76736 13.686 3.2551C16.2613 2.74284 18.9306 3.00575 21.3565 4.01058C23.7824 5.01541 25.8558 6.71703 27.3146 8.90026C28.7734 11.0835 29.552 13.6503 29.552 16.276C29.5483 19.7959 28.1484 23.1705 25.6595 25.6595C23.1705 28.1484 19.7959 29.5483 16.276 29.552ZM16.276 4.29901C13.9072 4.29901 11.5915 5.00144 9.62194 6.31749C7.65233 7.63354 6.11721 9.5041 5.2107 11.6926C4.30419 13.8811 4.06701 16.2893 4.52914 18.6126C4.99128 20.9359 6.13197 23.07 7.80699 24.745C9.482 26.42 11.6161 27.5607 13.9394 28.0229C16.2627 28.485 18.6709 28.2478 20.8594 27.3413C23.0479 26.4348 24.9185 24.8997 26.2345 22.9301C27.5506 20.9605 28.253 18.6448 28.253 16.276C28.2493 13.1006 26.9863 10.0564 24.7409 7.81108C22.4956 5.56576 19.4514 4.30271 16.276 4.29901Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M16.926 10.9929H15.626V21.5579H16.926V10.9929Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M21.558 15.626H10.993V16.926H21.558V15.626Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconCirclePlus, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconCirclePlus, "defaultProps", {
  size: null
});
const uicon_circle_plus = injectSheet(styles$1f)(UiconCirclePlus);
const styles$1e = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconCirclePlusFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M16.276 29.552C13.6503 29.552 11.0835 28.7734 8.90025 27.3146C6.71703 25.8558 5.01541 23.7824 4.01058 21.3565C3.00575 18.9306 2.74284 16.2613 3.2551 13.686C3.76736 11.1107 5.03177 8.74514 6.88845 6.88846C8.74514 5.03177 11.1107 3.76736 13.686 3.2551C16.2613 2.74284 18.9306 3.00575 21.3565 4.01058C23.7824 5.01541 25.8558 6.71703 27.3146 8.90026C28.7734 11.0835 29.552 13.6503 29.552 16.276C29.5483 19.7959 28.1484 23.1705 25.6595 25.6595C23.1705 28.1484 19.7959 29.5483 16.276 29.552ZM16.926 10.9929H15.626V15.626H10.993V16.926H15.626V21.5579H16.926V16.926H21.558V15.626H16.926V10.9929Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconCirclePlusFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconCirclePlusFill, "defaultProps", {
  size: null
});
const uicon_circle_plus_fill = injectSheet(styles$1e)(UiconCirclePlusFill);
const styles$1d = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconCircleProfile extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M16.275 29.552C13.6493 29.5518 11.0826 28.773 8.89951 27.3141C6.71642 25.8552 5.01497 23.7817 4.01029 21.3558C3.00561 18.9299 2.74285 16.2606 3.25522 13.6854C3.76759 11.1101 5.03208 8.74469 6.8888 6.8881C8.74552 5.03152 11.1111 3.7672 13.6863 3.25503C16.2616 2.74285 18.9309 3.00582 21.3567 4.01068C23.7825 5.01554 25.8559 6.71715 27.3147 8.90036C28.7734 11.0836 29.552 13.6503 29.552 16.276C29.548 19.796 28.1479 23.1706 25.6588 25.6595C23.1697 28.1484 19.795 29.5483 16.275 29.552ZM16.275 4.299C13.9062 4.299 11.5906 5.00144 9.62095 6.31749C7.65134 7.63354 6.1162 9.50409 5.20969 11.6926C4.30318 13.8811 4.06601 16.2893 4.52814 18.6126C4.99028 20.9359 6.13096 23.07 7.80597 24.745C9.48099 26.42 11.6151 27.5607 13.9384 28.0229C16.2617 28.485 18.6699 28.2478 20.8584 27.3413C23.0469 26.4348 24.9175 24.8997 26.2335 22.9301C27.5496 20.9605 28.252 18.6448 28.252 16.276C28.2483 13.1006 26.9853 10.0564 24.7399 7.81108C22.4946 5.56576 19.4504 4.30271 16.275 4.299Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M23.813 26.8451H22.513V23.5451C22.5114 22.2646 22.002 21.037 21.0966 20.1315C20.1911 19.2261 18.9635 18.7167 17.683 18.7151H14.869C13.5885 18.7167 12.3609 19.2261 11.4554 20.1315C10.55 21.037 10.0406 22.2646 10.039 23.5451L10.044 26.7031H8.74402L8.73901 23.5441C8.74087 21.9186 9.38742 20.3602 10.5368 19.2109C11.6862 18.0615 13.2446 17.4149 14.87 17.4131H17.684C19.3093 17.4149 20.8676 18.0613 22.0169 19.2105C23.1663 20.3597 23.8129 21.9178 23.815 23.5431L23.813 26.8451Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M16.275 16.0291C15.3983 16.0287 14.5414 15.7684 13.8127 15.281C13.084 14.7937 12.5161 14.1012 12.1809 13.2911C11.8456 12.4811 11.7581 11.5898 11.9294 10.73C12.1007 9.87024 12.5231 9.08054 13.1431 8.46078C13.7632 7.84101 14.553 7.41901 15.4129 7.24812C16.2728 7.07724 17.164 7.16514 17.9739 7.50072C18.7838 7.8363 19.476 8.40449 19.9631 9.13345C20.4501 9.86241 20.71 10.7194 20.71 11.5961C20.7084 12.7716 20.2406 13.8986 19.4092 14.7296C18.5777 15.5607 17.4506 16.028 16.275 16.0291ZM16.275 8.46209C15.6552 8.46209 15.0492 8.64589 14.5339 8.99026C14.0185 9.33463 13.6168 9.82409 13.3796 10.3968C13.1424 10.9694 13.0803 11.5996 13.2012 12.2075C13.3221 12.8154 13.6206 13.3739 14.0589 13.8122C14.4972 14.2505 15.0556 14.5489 15.6636 14.6699C16.2715 14.7908 16.9017 14.7287 17.4743 14.4915C18.047 14.2543 18.5365 13.8526 18.8808 13.3372C19.2252 12.8219 19.409 12.2159 19.409 11.5961C19.4082 10.7651 19.0778 9.96846 18.4902 9.38089C17.9026 8.79332 17.1059 8.46288 16.275 8.46209Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconCircleProfile, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconCircleProfile, "defaultProps", {
  size: null
});
const uicon_circle_profile = injectSheet(styles$1d)(UiconCircleProfile);
const styles$1c = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconCircleProfileFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.275 29.552C13.6493 29.5518 11.0826 28.773 8.89951 27.3141C6.71642 25.8552 5.01497 23.7817 4.01029 21.3558C3.00561 18.9299 2.74285 16.2606 3.25522 13.6854C3.76759 11.1101 5.03208 8.74469 6.8888 6.8881C8.74552 5.03152 11.1111 3.7672 13.6863 3.25503C16.2616 2.74285 18.9309 3.00582 21.3567 4.01068C23.7825 5.01554 25.8559 6.71715 27.3147 8.90036C28.7734 11.0836 29.552 13.6503 29.552 16.276C29.548 19.796 28.1479 23.1706 25.6588 25.6595C23.1697 28.1484 19.795 29.5483 16.275 29.552ZM16.275 16.0291C15.3983 16.0287 14.5414 15.7684 13.8127 15.281C13.084 14.7937 12.5161 14.1012 12.1809 13.2911C11.8456 12.4811 11.7581 11.5898 11.9294 10.73C12.1007 9.87024 12.5231 9.08054 13.1431 8.46078C13.7632 7.84101 14.553 7.41901 15.4129 7.24812C16.2728 7.07724 17.164 7.16514 17.9739 7.50072C18.7838 7.8363 19.476 8.40449 19.9631 9.13345C20.4501 9.86241 20.71 10.7194 20.71 11.5961C20.7084 12.7717 20.2406 13.8986 19.4092 14.7296C18.5777 15.5607 17.4506 16.028 16.275 16.0291ZM16.275 8.46209C15.6552 8.46209 15.0492 8.64589 14.5339 8.99026C14.0185 9.33463 13.6168 9.82409 13.3796 10.3968C13.1424 10.9694 13.0803 11.5996 13.2012 12.2075C13.3221 12.8154 13.6206 13.3739 14.0589 13.8122C14.4972 14.2505 15.0556 14.5489 15.6636 14.6699C16.2715 14.7908 16.9017 14.7287 17.4743 14.4915C18.047 14.2543 18.5365 13.8526 18.8808 13.3372C19.2252 12.8219 19.409 12.2159 19.409 11.5961C19.4082 10.7651 19.0778 9.96846 18.4902 9.38089C17.9026 8.79332 17.1059 8.46288 16.275 8.46209ZM22.513 26.8451H23.813L23.815 23.5431C23.8129 21.9178 23.1663 20.3597 22.0169 19.2105C20.8676 18.0613 19.3093 17.4149 17.684 17.4131H14.87C13.2446 17.4149 11.6862 18.0615 10.5368 19.2109C9.38742 20.3602 8.74087 21.9186 8.73901 23.5441L8.74402 26.7031H10.044L10.039 23.5451C10.0406 22.2646 10.55 21.037 11.4554 20.1315C12.3609 19.2261 13.5885 18.7167 14.869 18.7151H17.683C18.9635 18.7167 20.1911 19.2261 21.0966 20.1315C22.002 21.037 22.5114 22.2646 22.513 23.5451V26.8451Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M16 29.2759C13.3743 29.2757 10.8076 28.4969 8.62449 27.038C6.44139 25.5791 4.73994 23.5056 3.73527 21.0797C2.73059 18.6538 2.46783 15.9845 2.9802 13.4093C3.49257 10.834 4.75705 8.46856 6.61378 6.61198C8.4705 4.7554 10.8361 3.49108 13.4113 2.9789C15.9866 2.46673 18.6559 2.7297 21.0817 3.73455C23.5075 4.73941 25.5809 6.44103 27.0396 8.62424C28.4984 10.8074 29.277 13.3742 29.277 15.9999C29.273 19.5198 27.8729 22.8945 25.3838 25.3834C22.8947 27.8723 19.5199 29.2722 16 29.2759ZM16 4.02288C13.6311 4.02288 11.3155 4.72532 9.34592 6.04137C7.37632 7.35742 5.84118 9.22797 4.93467 11.4165C4.02816 13.605 3.79098 16.0132 4.25312 18.3365C4.71525 20.6598 5.85594 22.7939 7.53095 24.4689C9.20596 26.1439 11.3401 27.2846 13.6634 27.7467C15.9867 28.2089 18.3949 27.9717 20.5834 27.0652C22.7719 26.1587 24.6425 24.6236 25.9585 22.6539C27.2746 20.6843 27.977 18.3687 27.977 15.9999C27.9733 12.8245 26.7102 9.78028 24.4649 7.53496C22.2196 5.28964 19.1753 4.02659 16 4.02288Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconCircleProfileFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconCircleProfileFill, "defaultProps", {
  size: null
});
const uicon_circle_profile_fill = injectSheet(styles$1c)(UiconCircleProfileFill);
const styles$1b = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconCircleTick extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M16.276 29.552C13.6503 29.552 11.0835 28.7734 8.90026 27.3146C6.71703 25.8558 5.01541 23.7824 4.01058 21.3565C3.00575 18.9306 2.74284 16.2613 3.2551 13.686C3.76736 11.1107 5.03178 8.74514 6.88846 6.88846C8.74515 5.03177 11.1107 3.76736 13.686 3.2551C16.2613 2.74284 18.9306 3.00575 21.3565 4.01058C23.7824 5.01541 25.8558 6.71703 27.3146 8.90026C28.7734 11.0835 29.552 13.6503 29.552 16.276C29.5483 19.7959 28.1484 23.1705 25.6595 25.6595C23.1705 28.1484 19.7959 29.5483 16.276 29.552ZM16.276 4.29901C13.9072 4.29901 11.5915 5.00144 9.62194 6.31749C7.65233 7.63354 6.11721 9.5041 5.2107 11.6926C4.30419 13.8811 4.067 16.2893 4.52913 18.6126C4.99127 20.9359 6.13197 23.07 7.80698 24.745C9.48199 26.42 11.6161 27.5607 13.9394 28.0229C16.2627 28.485 18.6709 28.2478 20.8594 27.3413C23.0479 26.4348 24.9185 24.8997 26.2345 22.9301C27.5506 20.9605 28.253 18.6448 28.253 16.276C28.2493 13.1006 26.9862 10.0564 24.7409 7.81108C22.4956 5.56576 19.4514 4.30271 16.276 4.29901Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M14.328 20.812C14.2426 20.812 14.1579 20.7951 14.079 20.7623C14.0001 20.7295 13.9284 20.6815 13.868 20.621L10.158 16.911L11.077 15.992L14.323 19.237L21.47 11.937L22.399 12.846L14.792 20.617C14.7323 20.6793 14.6608 20.729 14.5816 20.7634C14.5025 20.7977 14.4173 20.8159 14.331 20.817L14.328 20.812Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconCircleTick, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconCircleTick, "defaultProps", {
  size: null
});
const uicon_circle_tick = injectSheet(styles$1b)(UiconCircleTick);
const styles$1a = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconCircleTickFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.90026 27.3146C11.0835 28.7734 13.6503 29.552 16.276 29.552C19.7959 29.5483 23.1705 28.1484 25.6595 25.6595C28.1484 23.1705 29.5483 19.7959 29.552 16.276C29.552 13.6503 28.7734 11.0835 27.3146 8.90026C25.8558 6.71703 23.7824 5.01541 21.3565 4.01058C18.9306 3.00575 16.2613 2.74284 13.686 3.2551C11.1107 3.76736 8.74515 5.03177 6.88846 6.88846C5.03178 8.74514 3.76736 11.1107 3.2551 13.686C2.74284 16.2613 3.00575 18.9306 4.01058 21.3565C5.01541 23.7824 6.71703 25.8558 8.90026 27.3146ZM14.079 20.7623C14.1579 20.7951 14.2426 20.812 14.328 20.812L14.331 20.817C14.4173 20.8159 14.5025 20.7977 14.5816 20.7634C14.6608 20.729 14.7323 20.6793 14.792 20.617L22.399 12.846L21.47 11.937L14.323 19.237L11.077 15.992L10.158 16.911L13.868 20.621C13.9284 20.6815 14.0001 20.7295 14.079 20.7623Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconCircleTickFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconCircleTickFill, "defaultProps", {
  size: null
});
const uicon_circle_tick_fill = injectSheet(styles$1a)(UiconCircleTickFill);
const styles$19 = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconArrowLightLeft extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M11.5862 15.9288L23.6863 3.82872C24.1046 3.41034 24.1046 2.73206 23.6863 2.31369C23.2678 1.89544 22.5896 1.89544 22.1712 2.31369L9.31369 15.1712C8.89544 15.5896 8.89544 16.2679 9.31369 16.6863L22.1712 29.5438C22.5969 29.9549 23.2752 29.9431 23.6863 29.5175C24.0872 29.1022 24.0872 28.444 23.6863 28.0288L11.5862 15.9288Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconArrowLightLeft, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconArrowLightLeft, "defaultProps", {
  size: null
});
const uicon_arrow_light_left = injectSheet(styles$19)(UiconArrowLightLeft);
const styles$18 = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconArrowLightRight extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M21.4138 15.9157L9.31373 28.0158C8.89542 28.4341 8.89542 29.1124 9.31373 29.5308C9.73217 29.949 10.4104 29.949 10.8288 29.5308L23.6863 16.6732C24.1046 16.2549 24.1046 15.5766 23.6863 15.1582L10.8288 2.30065C10.4031 1.88956 9.72482 1.90136 9.31373 2.32702C8.91275 2.74225 8.91275 3.40051 9.31373 3.81568L21.4138 15.9157Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconArrowLightRight, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconArrowLightRight, "defaultProps", {
  size: null
});
const uicon_arrow_light_right = injectSheet(styles$18)(UiconArrowLightRight);
const styles$17 = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconArrowMinDown extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M15.5002 20H15.4942C15.3572 20.0002 15.2226 19.9643 15.1039 19.8958C14.9852 19.8273 14.8867 19.7287 14.8182 19.61L11.1102 13.17C11.0382 13.0527 11 12.9177 11 12.78C11 12.6423 11.0382 12.5073 11.1102 12.39C11.1775 12.2719 11.2748 12.1736 11.3923 12.1051C11.5098 12.0366 11.6433 12.0003 11.7792 12H19.2192C19.3566 11.999 19.4918 12.0344 19.6112 12.1024C19.7305 12.1705 19.8298 12.2689 19.8989 12.3876C19.968 12.5064 20.0045 12.6413 20.0047 12.7786C20.005 12.916 19.9689 13.051 19.9002 13.17L16.1762 19.61C16.1077 19.7287 16.0092 19.8272 15.8905 19.8956C15.7718 19.9641 15.6372 20.0001 15.5002 20Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconArrowMinDown, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconArrowMinDown, "defaultProps", {
  size: null
});
const uicon_arrow_min_down = injectSheet(styles$17)(UiconArrowMinDown);
const styles$16 = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconArrowMinTop extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M15.5045 12H15.5105C15.6475 11.9998 15.7822 12.0357 15.9009 12.1042C16.0196 12.1727 16.1181 12.2713 16.1865 12.39L19.8945 18.83C19.9666 18.9473 20.0048 19.0823 20.0048 19.22C20.0048 19.3577 19.9666 19.4927 19.8945 19.61C19.8272 19.7281 19.7299 19.8264 19.6125 19.8949C19.495 19.9634 19.3615 19.9997 19.2255 20H11.7855C11.6481 20.001 11.5129 19.9656 11.3936 19.8976C11.2743 19.8295 11.175 19.7311 11.1059 19.6124C11.0368 19.4936 11.0003 19.3587 11 19.2214C10.9998 19.084 11.0358 18.949 11.1045 18.83L14.8285 12.39C14.897 12.2713 14.9956 12.1728 15.1142 12.1044C15.2329 12.0359 15.3675 11.9999 15.5045 12Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconArrowMinTop, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconArrowMinTop, "defaultProps", {
  size: null
});
const uicon_arrow_min_top = injectSheet(styles$16)(UiconArrowMinTop);
const styles$15 = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconArrowSimpleLeft extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M7.61127 17.4737L14.1266 23.989L15.3468 22.7675L9.43694 16.8576H25.1337V15.1315L9.43694 15.1315L15.3468 9.22163L14.1266 8.00011L7.61127 14.5154C7.21981 14.9081 7 15.4401 7 15.9946C7 16.5491 7.21981 17.081 7.61127 17.4737Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconArrowSimpleLeft, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconArrowSimpleLeft, "defaultProps", {
  size: null
});
const uicon_arrow_simple_left = injectSheet(styles$15)(UiconArrowSimpleLeft);
const styles$14 = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconArrowSimpleRight extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              d: "M24.3887 14.5153L17.8734 8L16.6532 9.22152L22.5631 15.1314H6.86626V16.8575H22.5631L16.6532 22.7674L17.8734 23.9889L24.3887 17.4736C24.7802 17.0809 25 16.549 25 15.9945C25 15.4399 24.7802 14.908 24.3887 14.5153Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconArrowSimpleRight, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconArrowSimpleRight, "defaultProps", {
  size: null
});
const uicon_arrow_simple_right = injectSheet(styles$14)(UiconArrowSimpleRight);
const styles$13 = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconArrowIncoming extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.42869 3.05288C4.68819 2.94539 4.98688 3.00481 5.18549 3.20342L10.5376 8.55558H28.3056V9.94446H10.5376L5.18549 15.2966C4.98688 15.4952 4.68819 15.5546 4.42869 15.4472C4.1692 15.3397 4 15.0865 4 14.8056V3.69446C4 3.41359 4.1692 3.16037 4.42869 3.05288ZM9.26791 9.25002L5.38889 5.371V13.129L9.26791 9.25002Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.0603 15.5685C21.3009 15.4529 21.5865 15.4854 21.7949 15.6522L28.7394 21.2077C28.9041 21.3395 29 21.539 29 21.75C29 21.961 28.9041 22.1605 28.7394 22.2923L21.7949 27.8478C21.5865 28.0146 21.3009 28.0471 21.0603 27.9315C20.8197 27.8158 20.6667 27.5725 20.6667 27.3056V22.4445H4.69446V21.0556H20.6667V16.1945C20.6667 15.9275 20.8197 15.6842 21.0603 15.5685ZM22.0556 17.6393V25.8607L27.1939 21.75L22.0556 17.6393Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconArrowIncoming, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconArrowIncoming, "defaultProps", {
  size: null
});
const uicon_arrow_incoming = injectSheet(styles$13)(UiconArrowIncoming);
const styles$12 = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconArrowIncomingFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.42869 3.05288C4.68819 2.94539 4.98688 3.00481 5.18549 3.20342L10.5376 8.55558H28.3056V9.94446H10.5376L5.18549 15.2966C4.98688 15.4952 4.68819 15.5546 4.42869 15.4472C4.1692 15.3397 4 15.0865 4 14.8056V3.69446C4 3.41359 4.1692 3.16037 4.42869 3.05288Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.0603 15.5685C21.3009 15.4529 21.5865 15.4854 21.7949 15.6522L28.7394 21.2077C28.9041 21.3395 29 21.539 29 21.75C29 21.961 28.9041 22.1605 28.7394 22.2923L21.7949 27.8478C21.5865 28.0146 21.3009 28.0471 21.0603 27.9315C20.8197 27.8158 20.6667 27.5725 20.6667 27.3056V22.4445H4.69446V21.0556H20.6667V16.1945C20.6667 15.9275 20.8197 15.6842 21.0603 15.5685Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconArrowIncomingFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconArrowIncomingFill, "defaultProps", {
  size: null
});
const uicon_arrow_incoming_fill = injectSheet(styles$12)(UiconArrowIncomingFill);
const styles$11 = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconArrowOutgoing extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.0603 10.0685C20.3009 9.95291 20.5865 9.98542 20.7949 10.1522L27.7394 15.7077C27.9041 15.8395 28 16.039 28 16.25C28 16.461 27.9041 16.6605 27.7394 16.7923L20.7949 22.3478C20.5865 22.5146 20.3009 22.5471 20.0603 22.4315C19.8197 22.3158 19.6667 22.0725 19.6667 21.8056V16.9445H3.69446V15.5556H19.6667V10.6945C19.6667 10.4275 19.8197 10.1842 20.0603 10.0685ZM21.0556 12.1393V20.3607L26.1939 16.25L21.0556 12.1393Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M4.39 11L4.39 21L3 21L3 11L4.39 11Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconArrowOutgoing, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconArrowOutgoing, "defaultProps", {
  size: null
});
const uicon_arrow_outgoing = injectSheet(styles$11)(UiconArrowOutgoing);
const styles$10 = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconArrowOutgoingFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.0603 10.0685C20.3009 9.95291 20.5865 9.98542 20.7949 10.1522L27.7394 15.7077C27.9041 15.8395 28 16.039 28 16.25C28 16.461 27.9041 16.6605 27.7394 16.7923L20.7949 22.3478C20.5865 22.5146 20.3009 22.5471 20.0603 22.4315C19.8197 22.3158 19.6667 22.0725 19.6667 21.8056V16.9445H3.69446V15.5556H19.6667V10.6945C19.6667 10.4275 19.8197 10.1842 20.0603 10.0685Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M4.39 11L4.39 21L3 21L3 11L4.39 11Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconArrowOutgoingFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconArrowOutgoingFill, "defaultProps", {
  size: null
});
const uicon_arrow_outgoing_fill = injectSheet(styles$10)(UiconArrowOutgoingFill);
const styles$$ = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDoc extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.094 3.30022C6.62908 3.29055 6.17926 3.46548 5.84303 3.78672C5.5068 4.10796 5.31154 4.54934 5.3 5.01422V26.2862C5.31154 26.7511 5.5068 27.1925 5.84303 27.5137C6.17926 27.8349 6.62908 28.0099 7.094 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.30022H7.094Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M26.65 10.3001H22.642C21.7045 10.326 20.7949 9.97941 20.1123 9.33619C19.4297 8.69298 19.0298 7.80555 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M21.964 19.5083H9.33701V20.8083H21.964V19.5083Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M21.964 15.0251H9.33701V16.3251H21.964V15.0251Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M14.777 10.4922H9.33701V11.7922H14.777V10.4922Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconDoc, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDoc, "defaultProps", {
  size: null
});
const uicon_doc = injectSheet(styles$$)(UiconDoc);
const styles$_ = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M27.3 8.88022V9.00015H22.642C22.0492 9.02598 21.4703 8.81631 21.0315 8.41689C20.5928 8.01748 20.3298 7.46073 20.3 6.86815V2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022ZM7.094 2.00022H19V6.86815C19.0298 7.80555 19.4297 8.69298 20.1123 9.33619C20.7949 9.97941 21.7045 10.326 22.642 10.3001H27.3V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022ZM9.33701 10.4922H14.777V11.7922H9.33701V10.4922ZM21.964 15.0251H9.33701V16.3251H21.964V15.0251ZM9.33701 19.5083H21.964V20.8083H9.33701V19.5083Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconDocFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocFill, "defaultProps", {
  size: null
});
const uicon_doc_fill = injectSheet(styles$_)(UiconDocFill);
const styles$Z = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocDownload extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M24.206 29.3002H7.09399C6.28431 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28431 1.9906 7.09399 2.00022H20.368C20.5396 2.00028 20.7043 2.06822 20.826 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.09399 3.30022C6.62907 3.29055 6.17925 3.46548 5.84302 3.78672C5.50678 4.10796 5.31153 4.54934 5.29999 5.01422V26.2862C5.31153 26.7511 5.50678 27.1925 5.84302 27.5137C6.17925 27.8349 6.62907 28.0099 7.09399 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.29922L7.09399 3.30022Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M26.65 10.3001H22.642C21.7044 10.3263 20.7947 9.97976 20.112 9.33649C19.4294 8.69323 19.0295 7.80564 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M19.98 23.7752H11.32C10.8695 23.8246 10.4178 23.6935 10.0639 23.4104C9.70999 23.1273 9.48277 22.7155 9.43201 22.2652V20.2732H10.732V22.2652C10.8083 22.3414 10.9004 22.3999 11.0019 22.4363C11.1034 22.4728 11.2117 22.4864 11.319 22.4762H19.979C20.0877 22.4877 20.1976 22.4737 20.2999 22.4351C20.4021 22.3966 20.494 22.3346 20.568 22.2542V20.2732H21.868V22.2652C21.8172 22.7155 21.59 23.1273 21.2361 23.4104C20.8822 23.6935 20.4305 23.8246 19.98 23.7752Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M15.65 21.0774C15.4623 21.0781 15.2764 21.0415 15.103 20.9697C14.9296 20.898 14.7722 20.7925 14.64 20.6594L11.84 17.8594L12.759 16.9404L15.559 19.7404C15.559 19.7404 15.671 19.7404 15.718 19.7404H15.739L18.539 16.9404L19.458 17.8594L16.658 20.6594C16.5259 20.7923 16.3688 20.8976 16.1958 20.9694C16.0228 21.0411 15.8373 21.0778 15.65 21.0774Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M16.301 12.1743H15V20.1993H16.301V12.1743Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconDocDownload, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocDownload, "defaultProps", {
  size: null
});
const uicon_doc_download = injectSheet(styles$Z)(UiconDocDownload);
const styles$Y = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocDownloadFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M27.3 8.88022V9.00015H22.642C22.0492 9.02598 21.4703 8.81631 21.0315 8.4169C20.5928 8.01748 20.3298 7.46073 20.3 6.86815V2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55139 27.2501 8.63051C27.2831 8.70964 27.3 8.7945 27.3 8.88022ZM7.094 2.00022H19V6.86815C19.0298 7.80556 19.4297 8.69298 20.1123 9.33619C20.7949 9.97941 21.7045 10.326 22.642 10.3001H27.3V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022ZM11.32 23.7752H19.98C20.4305 23.8246 20.8822 23.6935 21.2361 23.4104C21.59 23.1273 21.8172 22.7155 21.868 22.2652V20.2732H20.568V22.2542C20.494 22.3346 20.4021 22.3966 20.2999 22.4351C20.1976 22.4737 20.0877 22.4877 19.979 22.4762H11.319C11.2117 22.4864 11.1034 22.4728 11.0019 22.4363C10.9004 22.3999 10.8083 22.3414 10.732 22.2652V20.2732H9.43201V22.2652C9.48277 22.7155 9.70999 23.1273 10.0639 23.4104C10.4178 23.6935 10.8695 23.8246 11.32 23.7752ZM15.65 21.0774C15.4623 21.0781 15.2764 21.0415 15.103 20.9697C14.9296 20.898 14.7722 20.7925 14.64 20.6594L11.84 17.8594L12.759 16.9404L15 19.1815V12.1743H16.301V19.1784L18.539 16.9404L19.458 17.8594L16.658 20.6594C16.5259 20.7923 16.3688 20.8976 16.1958 20.9694C16.0228 21.0411 15.8373 21.0778 15.65 21.0774Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconDocDownloadFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocDownloadFill, "defaultProps", {
  size: null
});
const uicon_doc_download_fill = injectSheet(styles$Y)(UiconDocDownloadFill);
const styles$X = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocEye extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M24.206 29.3002H7.09399C6.28431 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28431 1.9906 7.09399 2.00022H20.368C20.5396 2.00028 20.7043 2.06822 20.826 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.09399 3.30022C6.62907 3.29055 6.17925 3.46548 5.84302 3.78672C5.50678 4.10796 5.31153 4.54934 5.29999 5.01422V26.2862C5.31153 26.7511 5.50678 27.1925 5.84302 27.5137C6.17925 27.8349 6.62907 28.0099 7.09399 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.29922L7.09399 3.30022Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M26.65 10.3001H22.642C21.7044 10.3263 20.7947 9.97976 20.112 9.33649C19.4294 8.69323 19.0295 7.80564 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M23.8083 16.9341C23.663 16.7373 20.2016 12.1162 15.7807 12.1162C11.3599 12.1162 7.89833 16.7373 7.75322 16.9339C7.61563 17.1206 7.61563 17.3738 7.75322 17.5604C7.89833 17.7572 11.3599 22.3783 15.7807 22.3783C20.2016 22.3783 23.663 17.7572 23.8083 17.5606C23.946 17.374 23.946 17.1206 23.8083 16.9341ZM15.7807 21.3168C12.5243 21.3168 9.70391 18.2496 8.86901 17.2469C9.70283 16.2433 12.5173 13.1778 15.7807 13.1778C19.037 13.1778 21.8572 16.2444 22.6925 17.2476C21.8586 18.2512 19.0441 21.3168 15.7807 21.3168Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.0478 16.4L14.3771 17.5502L15.0436 18.6934L16.385 18.6934L17.0558 17.5432L16.3892 16.4L15.0478 16.4ZM16.9382 15.4513L14.4946 15.4513L13.2727 17.5467L14.4946 19.6421L16.9382 19.6421L18.1601 17.5467L16.9382 15.4513Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconDocEye, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocEye, "defaultProps", {
  size: null
});
const uicon_doc_eye = injectSheet(styles$X)(UiconDocEye);
const styles$W = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocEyeFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M27.3 9.00015V8.88022C27.3 8.7945 27.2831 8.70963 27.2501 8.63051C27.2172 8.55138 27.1689 8.47957 27.108 8.41922L20.825 2.18922C20.7033 2.06822 20.5386 2.00028 20.367 2.00022H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H27.3ZM19 2.00022H7.094C6.28432 1.9906 5.50388 2.30251 4.92386 2.86753C4.34384 3.43256 4.01159 4.20456 4 5.01422V26.2862C4.01159 27.0959 4.34384 27.8679 4.92386 28.4329C5.50388 28.9979 6.28432 29.3098 7.094 29.3002H24.206C25.0157 29.3098 25.7961 28.9979 26.3761 28.4329C26.9562 27.8679 27.2884 27.0959 27.3 26.2862V10.3001H22.642C21.7045 10.326 20.7949 9.97941 20.1123 9.33619C19.4297 8.69298 19.0298 7.80555 19 6.86815V2.00022ZM15.0477 16.4L14.377 17.5502L15.0436 18.6934H16.385L17.0557 17.5431L16.3891 16.4H15.0477ZM16.9382 15.4513H14.4945L13.2727 17.5467L14.4945 19.6421H16.9382L18.1601 17.5467L16.9382 15.4513ZM15.7807 12.1162C20.2016 12.1162 23.663 16.7373 23.8083 16.9341C23.946 17.1206 23.946 17.374 23.8083 17.5606C23.663 17.7572 20.2016 22.3783 15.7807 22.3783C11.3599 22.3783 7.89833 17.7572 7.75322 17.5604C7.61563 17.3738 7.61563 17.1206 7.75322 16.9339C7.89833 16.7373 11.3599 12.1162 15.7807 12.1162ZM8.86901 17.2469C9.70391 18.2496 12.5243 21.3168 15.7807 21.3168C19.0441 21.3168 21.8586 18.2512 22.6925 17.2476C21.8572 16.2444 19.037 13.1778 15.7807 13.1778C12.5173 13.1778 9.70283 16.2433 8.86901 17.2469Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconDocEyeFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocEyeFill, "defaultProps", {
  size: null
});
const uicon_doc_eye_fill = injectSheet(styles$W)(UiconDocEyeFill);
const styles$V = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocPen extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M24.206 29.3002H7.09399C6.28431 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28431 1.9906 7.09399 2.00022H20.368C20.5396 2.00028 20.7043 2.06822 20.826 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.09399 3.30022C6.62907 3.29055 6.17925 3.46548 5.84302 3.78672C5.50678 4.10796 5.31153 4.54934 5.29999 5.01422V26.2862C5.31153 26.7511 5.50678 27.1925 5.84302 27.5137C6.17925 27.8349 6.62907 28.0099 7.09399 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.29922L7.09399 3.30022Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M26.65 10.3001H22.642C21.7044 10.3263 20.7947 9.97976 20.112 9.33649C19.4294 8.69323 19.0295 7.80564 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M20.674 24.3434C20.5693 24.3426 20.4664 24.3165 20.374 24.2674L16.826 22.3804C16.7484 22.3415 16.6794 22.2876 16.6231 22.2216C16.5667 22.1557 16.5241 22.0792 16.4977 21.9966C16.4714 21.9139 16.4619 21.8268 16.4697 21.7405C16.4775 21.6541 16.5026 21.5701 16.5433 21.4936C16.5841 21.417 16.6398 21.3494 16.7071 21.2947C16.7744 21.24 16.852 21.1993 16.9353 21.1751C17.0186 21.1508 17.1059 21.1435 17.192 21.1535C17.2782 21.1635 17.3615 21.1907 17.437 21.2334L19.827 22.5044L19.391 19.8314C19.3633 19.6611 19.4043 19.4868 19.5051 19.3468C19.6059 19.2068 19.7582 19.1126 19.9285 19.0849C20.0987 19.0572 20.273 19.0982 20.413 19.199C20.553 19.2998 20.6472 19.4521 20.675 19.6224L21.321 23.5884C21.336 23.6814 21.3307 23.7766 21.3054 23.8673C21.28 23.9581 21.2353 24.0423 21.1743 24.1141C21.1132 24.1859 21.0373 24.2436 20.9518 24.2831C20.8663 24.3227 20.7732 24.3433 20.679 24.3434H20.674Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M17.1279 22.4563C17.025 22.4567 16.9234 22.4326 16.8316 22.386C16.7398 22.3394 16.6604 22.2716 16.5999 22.1883L10.2609 13.4433C10.1635 13.3035 10.125 13.131 10.1534 12.9631C10.1819 12.7951 10.2752 12.645 10.4132 12.5451C10.5513 12.4453 10.723 12.4036 10.8914 12.429C11.0599 12.4545 11.2116 12.5451 11.3139 12.6813L17.2729 20.9013L19.1179 19.5793L13.1619 11.3633C13.1119 11.2942 13.076 11.2159 13.0562 11.133C13.0364 11.05 13.0331 10.9639 13.0466 10.8797C13.0738 10.7096 13.1674 10.5573 13.3069 10.4563C13.4464 10.3552 13.6204 10.3137 13.7905 10.3409C13.9606 10.3681 14.1129 10.4618 14.2139 10.6013L20.5539 19.3453C20.6044 19.4145 20.6406 19.4931 20.6606 19.5765C20.6805 19.6598 20.6837 19.7463 20.67 19.8309C20.6564 19.9155 20.6261 19.9966 20.5809 20.0694C20.5358 20.1422 20.4766 20.2054 20.4069 20.2553L17.5069 22.3353C17.3964 22.4143 17.2638 22.4567 17.1279 22.4563Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M10.788 13.7123C10.7525 13.7121 10.7171 13.7095 10.682 13.7043C10.5119 13.6756 10.36 13.5811 10.259 13.4413L8.15896 10.5153C8.10894 10.4461 8.07311 10.3676 8.05352 10.2845C8.03393 10.2013 8.03098 10.1151 8.04483 10.0308C8.05867 9.94652 8.08905 9.8658 8.13421 9.79328C8.17937 9.72077 8.2384 9.65791 8.30795 9.6083L11.208 7.5273C11.2771 7.47737 11.3555 7.44174 11.4387 7.42251C11.5218 7.40328 11.6079 7.40083 11.692 7.4153C11.7762 7.42895 11.857 7.45912 11.9296 7.50409C12.0022 7.54905 12.0652 7.60792 12.115 7.6773L14.215 10.6033C14.3155 10.7433 14.3562 10.9176 14.3283 11.0877C14.3003 11.2577 14.206 11.4098 14.0659 11.5103L11.1659 13.5903C11.0557 13.6692 10.9236 13.7119 10.788 13.7123ZM9.59597 10.2853L10.9369 12.1553L12.781 10.8333L11.4409 8.9633L9.59597 10.2853Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconDocPen, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocPen, "defaultProps", {
  size: null
});
const uicon_doc_pen = injectSheet(styles$V)(UiconDocPen);
const styles$U = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocPenFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M27.3 8.88022V9.00015H22.642C22.0492 9.02598 21.4703 8.81631 21.0315 8.41689C20.5928 8.01748 20.3298 7.46073 20.3 6.86815V2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022ZM7.094 2.00022H19V6.86815C19.0298 7.80555 19.4297 8.69298 20.1123 9.33619C20.7949 9.97941 21.7045 10.326 22.642 10.3001H27.3V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022ZM20.374 24.2674C20.4664 24.3165 20.5693 24.3426 20.674 24.3434H20.679C20.7732 24.3433 20.8663 24.3227 20.9518 24.2831C21.0373 24.2436 21.1132 24.1859 21.1743 24.1141C21.2353 24.0423 21.28 23.9581 21.3054 23.8673C21.3307 23.7766 21.336 23.6814 21.321 23.5884L20.675 19.6224C20.6542 19.4951 20.5964 19.3779 20.51 19.2847L14.2139 10.6013C14.2103 10.5962 14.2065 10.5912 14.2027 10.5862L12.115 7.6773C12.0652 7.60792 12.0022 7.54905 11.9296 7.50409C11.857 7.45912 11.7762 7.42895 11.692 7.4153C11.6079 7.40083 11.5218 7.40328 11.4387 7.42251C11.3555 7.44174 11.2771 7.47737 11.208 7.5273L8.30795 9.6083C8.2384 9.65791 8.17937 9.72077 8.13421 9.79328C8.08905 9.8658 8.05867 9.94652 8.04483 10.0308C8.03098 10.1151 8.03393 10.2013 8.05352 10.2845C8.07311 10.3676 8.10894 10.4461 8.15896 10.5153L10.259 13.4413C10.2638 13.4481 10.2688 13.4547 10.274 13.4612L16.5567 22.1286C16.576 22.1614 16.5982 22.1926 16.6231 22.2216C16.6493 22.2524 16.6783 22.2805 16.7097 22.3057C16.747 22.3368 16.7879 22.3638 16.8316 22.386C16.8446 22.3926 16.8579 22.3988 16.8714 22.4045L20.374 24.2674ZM11.6969 13.2095L17.2729 20.9013L19.1179 19.5793L13.5413 11.8866L11.6969 13.2095ZM18.3593 21.7239L19.5593 20.8632L19.827 22.5044L18.3593 21.7239ZM10.9369 12.1553L9.59597 10.2853L11.4409 8.9633L12.781 10.8333L10.9369 12.1553Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconDocPenFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocPenFill, "defaultProps", {
  size: null
});
const uicon_doc_pen_fill = injectSheet(styles$U)(UiconDocPenFill);
const styles$T = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocPlus extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.094 3.30022C6.62908 3.29055 6.17927 3.46548 5.84303 3.78672C5.5068 4.10796 5.31154 4.54934 5.3 5.01422V26.2862C5.31154 26.7511 5.5068 27.1925 5.84303 27.5137C6.17927 27.8349 6.62908 28.0099 7.094 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.30022H7.094Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M26.65 10.3001H22.642C21.7045 10.326 20.7949 9.97941 20.1123 9.33619C19.4298 8.69298 19.0298 7.80555 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M16.3 12.2502H15V22.8152H16.3V12.2502Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M20.932 16.8833H10.367V18.1833H20.932V16.8833Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconDocPlus, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocPlus, "defaultProps", {
  size: null
});
const uicon_doc_plus = injectSheet(styles$T)(UiconDocPlus);
const styles$S = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocPlusFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M27.3 9.00015V8.88022C27.3 8.7945 27.2831 8.70963 27.2501 8.63051C27.2172 8.55138 27.1689 8.47957 27.108 8.41922L20.825 2.18922C20.7033 2.06822 20.5386 2.00028 20.367 2.00022H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H27.3ZM19 2.00022H7.094C6.28432 1.9906 5.50388 2.30251 4.92386 2.86753C4.34384 3.43256 4.01159 4.20456 4 5.01422V26.2862C4.01159 27.0959 4.34384 27.8679 4.92386 28.4329C5.50388 28.9979 6.28432 29.3098 7.094 29.3002H24.206C25.0157 29.3098 25.7961 28.9979 26.3761 28.4329C26.9562 27.8679 27.2884 27.0959 27.3 26.2862V10.3001H22.642C21.7045 10.326 20.7949 9.97941 20.1123 9.33619C19.4297 8.69298 19.0298 7.80555 19 6.86815V2.00022ZM16.3 12.2502H15V16.8833H10.367V18.1833H15V22.8152H16.3V18.1833H20.932V16.8833H16.3V12.2502Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconDocPlusFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocPlusFill, "defaultProps", {
  size: null
});
const uicon_doc_plus_fill = injectSheet(styles$S)(UiconDocPlusFill);
const styles$R = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocSearch extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M24.206 29.3002H7.09399C6.28431 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28431 1.9906 7.09399 2.00022H20.368C20.5396 2.00028 20.7043 2.06822 20.826 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.09399 3.30022C6.62907 3.29055 6.17925 3.46548 5.84302 3.78672C5.50678 4.10796 5.31153 4.54934 5.29999 5.01422V26.2862C5.31153 26.7511 5.50678 27.1925 5.84302 27.5137C6.17925 27.8349 6.62907 28.0099 7.09399 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.29922L7.09399 3.30022Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M26.65 10.3001H22.642C21.7044 10.3263 20.7947 9.97976 20.112 9.33649C19.4294 8.69323 19.0295 7.80564 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M18.5863 19.3753L17.652 20.2793L21.45 24.2047L22.3843 23.3007L18.5863 19.3753Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M14.478 21.7063C13.342 21.7063 12.2314 21.3694 11.2868 20.7382C10.3422 20.1071 9.606 19.21 9.17125 18.1604C8.7365 17.1108 8.62275 15.9559 8.84438 14.8417C9.06601 13.7274 9.61309 12.704 10.4164 11.9006C11.2197 11.0973 12.2432 10.5503 13.3574 10.3286C14.4716 10.107 15.6266 10.2208 16.6761 10.6555C17.7257 11.0902 18.6228 11.8265 19.254 12.7711C19.8851 13.7157 20.222 14.8262 20.222 15.9623C20.2202 17.4851 19.6144 18.945 18.5376 20.0218C17.4608 21.0986 16.0009 21.7044 14.478 21.7063ZM14.478 11.5183C13.599 11.5181 12.7397 11.7785 12.0088 12.2667C11.2778 12.7549 10.7081 13.4489 10.3716 14.2609C10.0351 15.0729 9.94691 15.9665 10.1183 16.8286C10.2896 17.6907 10.7128 18.4827 11.3343 19.1043C11.9557 19.7259 12.7476 20.1492 13.6097 20.3208C14.4717 20.4924 15.3653 20.4044 16.1774 20.0681C16.9895 19.7318 17.6836 19.1622 18.172 18.4313C18.6603 17.7005 18.921 16.8412 18.921 15.9623C18.9199 14.7841 18.4515 13.6546 17.6186 12.8214C16.7856 11.9883 15.6561 11.5196 14.478 11.5183Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconDocSearch, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocSearch, "defaultProps", {
  size: null
});
const uicon_doc_search = injectSheet(styles$R)(UiconDocSearch);
const styles$Q = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocSearchFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M27.3 9.00015V8.88022C27.3 8.7945 27.2831 8.70963 27.2501 8.63051C27.2172 8.55138 27.1689 8.47957 27.108 8.41922L20.825 2.18922C20.7033 2.06822 20.5386 2.00028 20.367 2.00022H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H27.3ZM19 2.00022H7.094C6.28432 1.9906 5.50388 2.30251 4.92386 2.86753C4.34384 3.43256 4.01159 4.20456 4 5.01422V26.2862C4.01159 27.0959 4.34384 27.8679 4.92386 28.4329C5.50388 28.9979 6.28432 29.3098 7.094 29.3002H24.206C25.0157 29.3098 25.7961 28.9979 26.3761 28.4329C26.9562 27.8679 27.2884 27.0959 27.3 26.2862V10.3001H22.642C21.7045 10.326 20.7949 9.97941 20.1123 9.33619C19.4297 8.69298 19.0298 7.80555 19 6.86815V2.00022ZM17.9206 20.5569C16.9331 21.2972 15.7267 21.7047 14.478 21.7063C13.342 21.7063 12.2314 21.3694 11.2868 20.7382C10.3422 20.1071 9.606 19.21 9.17125 18.1604C8.7365 17.1108 8.62275 15.9559 8.84438 14.8417C9.06601 13.7274 9.61309 12.704 10.4164 11.9006C11.2197 11.0973 12.2432 10.5503 13.3574 10.3286C14.4716 10.107 15.6266 10.2207 16.6761 10.6555C17.7257 11.0903 18.6228 11.8265 19.254 12.7711C19.8851 13.7157 20.222 14.8262 20.222 15.9623C20.2203 17.3226 19.7368 18.6328 18.866 19.6644L22.3843 23.3007L21.45 24.2047L17.9206 20.5569ZM12.0088 12.2667C12.7397 11.7785 13.599 11.5181 14.478 11.5183C15.6561 11.5196 16.7856 11.9883 17.6186 12.8214C18.4515 13.6546 18.9199 14.7841 18.921 15.9623C18.921 16.8412 18.6603 17.7005 18.172 18.4313C17.6836 19.1622 16.9895 19.7318 16.1774 20.0681C15.3653 20.4044 14.4717 20.4924 13.6097 20.3208C12.7476 20.1492 11.9557 19.7259 11.3343 19.1043C10.7128 18.4827 10.2896 17.6907 10.1183 16.8286C9.94691 15.9665 10.0351 15.0729 10.3716 14.2609C10.7081 13.4489 11.2778 12.7549 12.0088 12.2667Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconDocSearchFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocSearchFill, "defaultProps", {
  size: null
});
const uicon_doc_search_fill = injectSheet(styles$Q)(UiconDocSearchFill);
const styles$P = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocTick extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M24.206 29.3002H7.09399C6.28431 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28431 1.9906 7.09399 2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1688 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.09399 3.30022C6.62907 3.29055 6.17925 3.46548 5.84302 3.78672C5.50678 4.10796 5.31153 4.54934 5.29999 5.01422V26.2862C5.31153 26.7511 5.50678 27.1925 5.84302 27.5137C6.17925 27.8349 6.62907 28.0099 7.09399 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.29922L7.09399 3.30022Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M26.65 10.3001H22.642C21.7045 10.326 20.7949 9.97941 20.1123 9.33619C19.4297 8.69298 19.0298 7.80555 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M13.702 22.7373C13.6165 22.7375 13.5318 22.7207 13.4528 22.6879C13.3739 22.6551 13.3022 22.607 13.242 22.5463L9.53198 18.8363L10.451 17.9173L13.697 21.1633L20.844 13.8633L21.773 14.7733L14.166 22.5453C14.1059 22.6067 14.0342 22.6555 13.955 22.689C13.8759 22.7225 13.7909 22.7399 13.705 22.7403L13.702 22.7373Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconDocTick, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocTick, "defaultProps", {
  size: null
});
const uicon_doc_tick = injectSheet(styles$P)(UiconDocTick);
const styles$O = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocTickFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M27.3 8.88022V9.00015H22.642C22.0492 9.02598 21.4703 8.81631 21.0315 8.41689C20.5928 8.01748 20.3298 7.46073 20.3 6.86815V2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022ZM7.094 2.00022H19V6.86815C19.0298 7.80555 19.4297 8.69298 20.1123 9.33619C20.7949 9.97941 21.7045 10.326 22.642 10.3001H27.3V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022ZM13.4528 22.6879C13.5318 22.7207 13.6165 22.7375 13.702 22.7373L13.705 22.7403C13.7909 22.7399 13.8759 22.7225 13.955 22.689C14.0342 22.6555 14.1059 22.6067 14.166 22.5453L21.773 14.7733L20.844 13.8633L13.697 21.1633L10.451 17.9173L9.53198 18.8363L13.242 22.5463C13.3022 22.607 13.3739 22.6551 13.4528 22.6879Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconDocTickFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocTickFill, "defaultProps", {
  size: null
});
const uicon_doc_tick_fill = injectSheet(styles$O)(UiconDocTickFill);
const styles$N = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocUpload extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M24.206 29.3002H7.09399C6.28431 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28431 1.9906 7.09399 2.00022H20.368C20.5396 2.00028 20.7043 2.06822 20.826 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002ZM7.09399 3.30022C6.62907 3.29055 6.17925 3.46548 5.84302 3.78672C5.50678 4.10796 5.31153 4.54934 5.29999 5.01422V26.2862C5.31153 26.7511 5.50678 27.1925 5.84302 27.5137C6.17925 27.8349 6.62907 28.0099 7.09399 28.0002H24.206C24.6709 28.0099 25.1207 27.8349 25.457 27.5137C25.7932 27.1925 25.9885 26.7511 26 26.2862V9.15022L20.1 3.29922L7.09399 3.30022Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M26.65 10.3001H22.642C21.7044 10.3263 20.7947 9.97976 20.112 9.33649C19.4294 8.69323 19.0295 7.80564 19 6.86815V2.65015H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H26.65V10.3001Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M19.98 23.7752H11.32C10.8695 23.8246 10.4178 23.6935 10.0639 23.4104C9.70999 23.1273 9.48277 22.7155 9.43201 22.2652V20.2732H10.732V22.2652C10.8083 22.3414 10.9004 22.3999 11.0019 22.4363C11.1034 22.4728 11.2117 22.4864 11.319 22.4762H19.979C20.0877 22.4877 20.1976 22.4737 20.2999 22.4351C20.4021 22.3966 20.494 22.3346 20.568 22.2542V20.2732H21.868V22.2652C21.8172 22.7155 21.59 23.1273 21.2361 23.4104C20.8822 23.6935 20.4305 23.8246 19.98 23.7752Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M14.997 21.0774L16.298 21.0774L16.298 13.0524L14.997 13.0524L14.997 21.0774Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M15.648 12.1743C15.8357 12.1736 16.0216 12.2102 16.1949 12.282C16.3683 12.3537 16.5257 12.4592 16.658 12.5923L19.458 15.3923L18.539 16.3113L15.739 13.5113C15.739 13.5113 15.627 13.5113 15.58 13.5113L15.559 13.5113L12.759 16.3113L11.84 15.3923L14.64 12.5923C14.7721 12.4594 14.9292 12.3541 15.1022 12.2824C15.2752 12.2106 15.4607 12.1739 15.648 12.1743Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconDocUpload, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocUpload, "defaultProps", {
  size: null
});
const uicon_doc_upload = injectSheet(styles$N)(UiconDocUpload);
const styles$M = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear"
  },
  fill: {
    transition: "opacity 100ms linear",
    opacity: 1,
    "&[hidden]": {
      opacity: 0
    }
  }
};
class UiconDocUploadFill extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsx$1(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: /* @__PURE__ */ jsx$1(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M27.3 8.88022V9.00015H22.642C22.0492 9.02598 21.4703 8.81631 21.0315 8.41689C20.5928 8.01748 20.3298 7.46073 20.3 6.86815V2.00022H20.367C20.5386 2.00028 20.7033 2.06822 20.825 2.18922L27.108 8.41922C27.1689 8.47957 27.2172 8.55138 27.2501 8.63051C27.2831 8.70963 27.3 8.7945 27.3 8.88022ZM7.094 2.00022H19V6.86815C19.0298 7.80555 19.4297 8.69298 20.1123 9.33619C20.7949 9.97941 21.7045 10.326 22.642 10.3001H27.3V26.2862C27.2884 27.0959 26.9562 27.8679 26.3761 28.4329C25.7961 28.9979 25.0157 29.3098 24.206 29.3002H7.094C6.28432 29.3098 5.50388 28.9979 4.92386 28.4329C4.34384 27.8679 4.01159 27.0959 4 26.2862V5.01422C4.01159 4.20456 4.34384 3.43256 4.92386 2.86753C5.50388 2.30251 6.28432 1.9906 7.094 2.00022ZM11.32 23.7752H19.98C20.4305 23.8246 20.8822 23.6935 21.2361 23.4104C21.59 23.1273 21.8172 22.7155 21.868 22.2652V20.2732H20.568V22.2542C20.494 22.3346 20.4021 22.3966 20.2999 22.4351C20.1976 22.4737 20.0877 22.4877 19.979 22.4762H11.319C11.2117 22.4864 11.1034 22.4728 11.0019 22.4363C10.9004 22.3999 10.8083 22.3414 10.732 22.2652V20.2732H9.43201V22.2652C9.48277 22.7155 9.70999 23.1273 10.0639 23.4104C10.4178 23.6935 10.8695 23.8246 11.32 23.7752ZM14.997 21.0774H16.298L16.298 14.0703L18.539 16.3113L19.458 15.3923L16.658 12.5923C16.5257 12.4592 16.3683 12.3537 16.1949 12.282C16.0216 12.2102 15.8357 12.1736 15.648 12.1743C15.4607 12.1739 15.2752 12.2106 15.1022 12.2824C14.9292 12.3541 14.7721 12.4594 14.64 12.5923L11.84 15.3923L12.759 16.3113L14.997 14.0733V21.0774Z",
              className: classes.fill
            }
          )
        }
      );
    });
  }
}
__publicField(UiconDocUploadFill, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDocUploadFill, "defaultProps", {
  size: null
});
const uicon_doc_upload_fill = injectSheet(styles$M)(UiconDocUploadFill);
const styles$L = {
  root: {
    display: "block",
    fill: "currentColor",
    width: "100%",
    height: "auto",
    transition: "color 100ms linear 0ms"
  }
};
class UiconDownload extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "render", () => {
      const { classes, size: size2 } = this.props;
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fillRule: "evenodd",
          viewBox: "0 0 32 32",
          "aria-hidden": "true",
          className: classes.root,
          style: { width: size2, height: size2 },
          children: [
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M24.462 20.428V23.728C24.462 24.095 23.862 24.506 23.062 24.506H8.7C7.9 24.506 7.3 24.095 7.3 23.728V20.428H6V23.728C6 24.893 7.186 25.806 8.7 25.806H23.06C24.575 25.806 25.76 24.893 25.76 23.728V20.428H24.462Z",
                className: classes.fill
              }
            ),
            /* @__PURE__ */ jsx$1(
              "path",
              {
                d: "M15.88 21.334C16.1348 21.3343 16.3872 21.2843 16.6226 21.1868C16.8581 21.0894 17.072 20.9464 17.252 20.766L21.9 16.118L20.981 15.199L16.53 19.65V7H15.23V19.65L10.78 15.199L9.86099 16.118L14.509 20.766C14.6889 20.9462 14.9026 21.0892 15.1379 21.1867C15.3731 21.2841 15.6253 21.3342 15.88 21.334Z",
                className: classes.fill
              }
            )
          ]
        }
      );
    });
  }
}
__publicField(UiconDownload, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  size: PropTypes$1.number
});
__publicField(UiconDownload, "defaultProps", {
  size: null
});
const uicon_download = injectSheet(styles$L)(UiconDownload);
const styles$K = () => ({
  root: {
    flexGrow: 0,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    opacity: 1,
    transition: "opacity 250ms linear 250ms",
    '&[aria-busy="true"]': {
      opacity: 0
    }
  },
  primary: {
    order: 1,
    marginRight: 21,
    overflow: "hidden",
    maxWidth: "70%"
  },
  secondary: {
    order: 3,
    justifyContent: "flex-end",
    "&:only-child": {
      width: "100%"
    }
  },
  tertiary: {
    flexGrow: 1,
    order: 2,
    marginRight: 21,
    justifyContent: "center",
    flexShrink: 1
  }
});
var NavbarSectionLevels = /* @__PURE__ */ ((NavbarSectionLevels2) => {
  NavbarSectionLevels2["primary"] = "primary";
  NavbarSectionLevels2["secondary"] = "secondary";
  NavbarSectionLevels2["tertiary"] = "tertiary";
  return NavbarSectionLevels2;
})(NavbarSectionLevels || {});
const NavbarSection = ({
  children,
  classes,
  level,
  loading
}) => {
  const typeClass = {
    [classes.primary]: level === "primary",
    [classes.secondary]: level === "secondary",
    [classes.tertiary]: level === "tertiary"
    /* tertiary */
  };
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      className: classNames(classes.root, typeClass),
      "data-cy": "atomic-navbar-section",
      "aria-busy": loading,
      children
    }
  );
};
const NavbarSection$1 = injectSheet(styles$K)(NavbarSection);
const styles$J = (theme2) => ({
  root: {
    textDecoration: "none",
    flexShrink: 0,
    color: "#413f48",
    paddingInline: "16px",
    cursor: "pointer",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: 16,
    lineHeight: "20px",
    letterSpacing: "0.05em",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    userSelect: "none",
    "&:hover": {
      color: theme2.indigo2,
      textDecoration: "underline",
      textDecorationThickness: "2px",
      textUnderlineOffset: "4px"
    }
  },
  highlighted: {
    color: theme2.indigo2,
    textDecoration: "underline",
    textDecorationThickness: "2px",
    textUnderlineOffset: "4px",
    fontWeight: 600
  }
});
const NavbarLink = ({
  classes,
  link: link2,
  currentPageName
}) => {
  const isCurrentPage = currentPageName === link2.name;
  const isHighlighted = {
    [classes.highlighted]: currentPageName === link2.name
  };
  return /* @__PURE__ */ jsx$1(
    "a",
    {
      className: classNames(classes.root, isHighlighted),
      "data-cy": "atomic-navbar-link",
      href: link2.url,
      target: isCurrentPage ? "_self" : "_blank",
      rel: "noopener noreferrer",
      draggable: "false",
      children: link2.name
    }
  );
};
const NavbarLink$1 = injectSheet(styles$J)(NavbarLink);
const styles$I = (theme2) => {
  const withSubNavbarColor = theme2.greyTable;
  const navbarPadding = "0 21px";
  return {
    root: {
      height: NAVBAR_HEIGHT,
      width: "100%"
    },
    fixed: {
      backgroundColor: withSubNavbarColor,
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 4,
      width: "100vw"
    },
    navbar: {
      position: "relative",
      height: NAVBAR_HEIGHT,
      width: "100%",
      backgroundColor: theme2.white1,
      display: "flex",
      alignItems: "center",
      padding: navbarPadding,
      paddingLeft: 11,
      borderBottom: `1px solid ${theme2.grey7}`
    },
    subnavbar: {
      width: "100%",
      backgroundColor: withSubNavbarColor,
      display: "flex",
      alignItems: "center",
      padding: navbarPadding,
      height: SUB_NAVBAR_HEIGHT,
      borderBottom: `1px solid ${theme2.grey7}`
    },
    home: {
      flexShrink: 0,
      marginRight: 18,
      height: 18,
      display: "flex",
      alignItems: "center",
      appearance: "none",
      textAlign: "left",
      backgroundColor: "inherit",
      border: "none",
      cursor: "pointer",
      outline: "none",
      "&[disabled]": {
        cursor: "default",
        opacity: "0.5"
      }
    },
    logo: {
      padding: "6px",
      paddingLeft: "14px",
      paddingRight: "17px",
      paddingBottom: "12px",
      "& > svg": {
        fill: theme2.indigo2
      }
    },
    sections: {
      flexGrow: 1,
      display: "flex",
      justifyContent: "space-between",
      opacity: 1,
      transition: "opacity 250ms linear 250ms",
      '&[aria-busy="true"]': {
        opacity: 0
      }
    },
    environmentName: {
      background: `linear-gradient(to right, ${theme2.indigo2} 0%, ${theme2.indigo3} 100%)`,
      borderRadius: "1rem",
      color: "white",
      fontSize: "14px",
      fontWeight: 600,
      letterSpacing: "0.05em",
      lineHeight: "20px",
      paddingInline: "12px !important",
      marginLeft: "12px",
      userSelect: "none"
    }
  };
};
const LogoStratumn = ({
  classes,
  axis = "x",
  size: size2 = null,
  fillWhite = false
}) => {
  const style2 = {
    width: axis === "x" ? size2 || "100%" : "auto",
    height: axis === "y" ? size2 || "100%" : "auto"
  };
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      viewBox: "0 0 134 24",
      fill: "none",
      style: style2,
      className: classes.root,
      xmlns: "http://www.w3.org/2000/svg",
      "data-v-7a283b0c": "",
      children: [
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M2.79244 18.5026C3.67312 19.8269 5.20721 20.6019 6.66647 20.6019C8.10009 20.6019 9.05629 19.9019 9.05629 18.8777C9.05629 17.8783 8.32667 17.1783 6.566 16.5788L5.05685 16.0544C2.18892 15.055 0.654834 13.4058 0.654834 10.9817C0.654834 7.63314 3.22066 5.65912 6.69211 5.65912C8.88099 5.65912 10.7927 6.40867 12.3268 8.10806L9.91203 10.5818C9.05699 9.55691 7.94973 9.05721 6.71705 9.05721C5.48437 9.05721 4.32722 9.58169 4.32722 10.6313C4.32722 11.7058 5.20791 12.1807 7.09468 12.8552L8.5283 13.3797C11.1447 14.3295 12.78 15.9787 12.78 18.652C12.755 21.8257 10.2141 23.9993 6.51611 23.9993C3.67312 23.9993 1.28399 22.7748 0.000732422 20.8256L2.79244 18.5026Z",
            "data-fill-white": fillWhite,
            className: classes.type,
            "data-v-7a283b0c": ""
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M18.8663 9.40686H14.1116V5.95853H27.344V9.40686H22.5394V23.7006H18.8663V9.40686Z",
            "data-fill-white": fillWhite,
            className: classes.type,
            "data-v-7a283b0c": ""
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M30.1108 5.95853H36.9533C40.2993 5.95853 42.4376 8.25742 42.4376 11.2061C42.4376 13.58 41.1294 15.0791 38.7645 15.8286L44.2308 23.6999H40.0997L34.9355 16.2285H33.759V23.6999H30.1115V5.95853H30.1108ZM36.5257 13.1305C37.8838 13.1305 38.8151 12.4057 38.8151 11.2061C38.8151 9.98158 37.8845 9.28228 36.5257 9.28228H33.7583V13.1305H36.5257Z",
            "data-fill-white": fillWhite,
            className: classes.type,
            "data-v-7a283b0c": ""
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M67.0968 9.40686H62.342V5.95853H75.5738V9.40686H70.7692V23.7006H67.0968V9.40686Z",
            "data-fill-white": fillWhite,
            className: classes.type,
            "data-v-7a283b0c": ""
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M85.4101 24C81.1335 24 78.1401 21.1264 78.1401 16.7034V5.95853H81.7876V16.7537C81.7876 19.1028 83.2468 20.5021 85.4101 20.5021C87.5733 20.5021 89.0326 19.1028 89.0326 16.7537V5.95853H92.6801V16.7034C92.6808 21.1264 89.6368 24 85.4101 24Z",
            "data-fill-white": fillWhite,
            className: classes.type,
            "data-v-7a283b0c": ""
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M99.8523 12.1559V23.7006H96.2048V5.95853H99.5252L105.336 13.8546L111.147 5.95853H114.468V23.7006H110.82V12.1559L105.336 19.6273L99.8523 12.1559Z",
            "data-fill-white": fillWhite,
            className: classes.type,
            "data-v-7a283b0c": ""
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M130.856 23.7006L121.699 12.1311V23.7006H118.052V5.95853H121.196L130.353 17.528V5.95853H134V23.7006H130.856Z",
            "data-fill-white": fillWhite,
            className: classes.type,
            "data-v-7a283b0c": ""
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M55.5168 5.95853H52.2719L44.5737 23.7006H63.2399L55.5168 5.95853ZM49.7379 20.4346L53.8815 10.7064L58.0251 20.4346H49.7379Z",
            "data-fill-white": fillWhite,
            className: classes.type,
            "data-v-7a283b0c": ""
          }
        ),
        /* @__PURE__ */ jsx$1(
          "path",
          {
            d: "M59.5529 0H48.4644V3.26525H59.5529V0Z",
            "data-fill-white": fillWhite,
            className: classes.type,
            "data-v-7a283b0c": ""
          }
        )
      ]
    }
  );
};
const LogoStratumn$1 = injectSheet(styles$25)(LogoStratumn);
var EnvironmentName = /* @__PURE__ */ ((EnvironmentName2) => {
  EnvironmentName2["Local"] = "local";
  EnvironmentName2["Demo"] = "demo";
  EnvironmentName2["Sandbox"] = "sandbox";
  EnvironmentName2["Staging"] = "staging";
  EnvironmentName2["Preprod"] = "preprod";
  EnvironmentName2["Release"] = "release";
  return EnvironmentName2;
})(EnvironmentName || {});
const Navbar = ({
  classes,
  signOut,
  currentPage,
  links,
  menuLinks,
  userAvatarPath,
  loading = false,
  subNavbarPrimary,
  subNavbarSecondary,
  environmentName
}) => {
  const linkClicked = (clickedLink) => {
    window.open(
      clickedLink.url,
      clickedLink.name === currentPage.name ? "_self" : "_blank"
    );
  };
  const hasSubNavbar = !!subNavbarPrimary || !!subNavbarSecondary;
  const isEnvironmentDisplayed = environmentName !== "release" && !!environmentName && Object.values(EnvironmentName).includes(environmentName);
  return /* @__PURE__ */ jsx$1("div", { className: classes.root, "data-cy": "atomic-navbar", children: /* @__PURE__ */ jsxs("div", { className: classes.fixed, children: [
    /* @__PURE__ */ jsxs("div", { className: classes.navbar, "data-has-subheader": hasSubNavbar, children: [
      /* @__PURE__ */ jsx$1(
        "button",
        {
          type: "button",
          "data-cy": "go-home",
          className: classes.logo,
          onClick: () => linkClicked(currentPage),
          children: /* @__PURE__ */ jsx$1(LogoStratumn$1, { axis: "y", size: 24 })
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: classes.sections, children: [
        /* @__PURE__ */ jsxs(NavbarSection$1, { level: "primary", children: [
          links.map((link2) => /* @__PURE__ */ jsx$1(
            NavbarLink$1,
            {
              currentPageName: currentPage.name,
              link: link2
            },
            link2.name
          )),
          isEnvironmentDisplayed && /* @__PURE__ */ jsxs("span", { className: classes.environmentName, children: [
            environmentName,
            " environment"
          ] })
        ] }),
        /* @__PURE__ */ jsx$1(NavbarSection$1, { level: "secondary", loading, children: /* @__PURE__ */ jsxs(Popover, { avatarButton: true, avatarSrc: userAvatarPath, avatarSize: 40, children: [
          menuLinks.map((menuLink) => /* @__PURE__ */ jsx$1(
            PopoverMenuItem$1,
            {
              onClick: () => linkClicked(menuLink.link),
              icon: /* @__PURE__ */ jsx$1(DynamicIcon, { icon: menuLink.iconName ?? "ArrowRight" }),
              children: menuLink.link.name
            },
            menuLink.link.name
          )),
          /* @__PURE__ */ jsx$1(PopoverMenuItem$1, { onClick: () => signOut(), icon: /* @__PURE__ */ jsx$1(lib$a.SignOut, {}), children: "Sign out" })
        ] }) })
      ] })
    ] }),
    hasSubNavbar && /* @__PURE__ */ jsx$1("div", { className: classes.subnavbar, "data-cy": "atomic-subnavbar", children: /* @__PURE__ */ jsxs("div", { className: classes.sections, "aria-busy": loading, children: [
      subNavbarPrimary && /* @__PURE__ */ jsx$1(
        NavbarSection$1,
        {
          level: NavbarSectionLevels.primary,
          className: classes.subnavbarprimary,
          children: subNavbarPrimary
        }
      ),
      subNavbarSecondary && /* @__PURE__ */ jsx$1(NavbarSection$1, { level: NavbarSectionLevels.secondary, children: subNavbarSecondary })
    ] }) })
  ] }) });
};
const navbar = injectSheet(styles$I)(Navbar);
const styles$H = () => ({
  root: {
    flexGrow: 0,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    opacity: 1,
    transition: "opacity 250ms linear 250ms",
    '&[aria-busy="true"]': {
      opacity: 0
    }
  },
  primary: {
    order: 1,
    marginRight: 21
  },
  secondary: {
    order: 3,
    justifyContent: "flex-end",
    "&:only-child": {
      width: "100%"
    }
  },
  tertiary: {
    flexGrow: 1,
    order: 2,
    marginRight: 21,
    justifyContent: "center",
    flexShrink: 1
  }
});
const headerSectionLevels = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary"
};
class HeaderSection extends Component {
  render() {
    const { children, classes, level, loading } = this.props;
    const typeClass = {
      [classes.primary]: level === headerSectionLevels.primary,
      [classes.secondary]: level === headerSectionLevels.secondary,
      [classes.tertiary]: level === headerSectionLevels.tertiary
    };
    return /* @__PURE__ */ jsx$1(
      "div",
      {
        className: classNames(classes.root, typeClass),
        "data-cy": "atomic-header-section",
        "aria-busy": loading,
        children
      }
    );
  }
}
__publicField(HeaderSection, "propTypes", {
  children: PropTypes$1.node.isRequired,
  classes: PropTypes$1.object.isRequired,
  level: PropTypes$1.oneOf([
    headerSectionLevels.primary,
    headerSectionLevels.secondary,
    headerSectionLevels.tertiary
  ]).isRequired,
  loading: PropTypes$1.bool
});
__publicField(HeaderSection, "defaultProps", {
  loading: false
});
const HeaderSection$1 = injectSheet(styles$H)(HeaderSection);
const styles$G = (theme2) => {
  const withSubheaderColor = theme2.greyTable;
  const headerPadding = "0 21px";
  return {
    root: {
      height: HEADER_HEIGHT,
      width: "100%"
    },
    fixed: {
      backgroundColor: withSubheaderColor,
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 4,
      width: "100vw"
    },
    header: {
      height: HEADER_HEIGHT,
      width: "100%",
      backgroundColor: theme2.white1,
      display: "flex",
      alignItems: "center",
      padding: headerPadding,
      boxShadow: theme2.indigoShadow1,
      '&[data-has-subheader="true"]': {
        height: HEADER_HEIGHT / 2,
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10
      }
    },
    subheader: {
      width: "100%",
      backgroundColor: withSubheaderColor,
      display: "flex",
      alignItems: "center",
      padding: headerPadding,
      height: HEADER_HEIGHT / 2
    },
    home: {
      flexShrink: 0,
      marginRight: 18,
      height: 18,
      display: "flex",
      alignItems: "center",
      appearance: "none",
      textAlign: "left",
      backgroundColor: "inherit",
      border: "none",
      cursor: "pointer",
      outline: "none",
      "&[disabled]": {
        cursor: "default",
        opacity: "0.5"
      }
    },
    logoText: {
      paddingLeft: 7,
      "& > svg": {
        fill: theme2.colorBrandPrimary
      }
    },
    sections: {
      flexGrow: 1,
      display: "flex",
      justifyContent: "space-between",
      opacity: 1,
      transition: "opacity 250ms linear 250ms",
      '&[aria-busy="true"]': {
        opacity: 0
      }
    },
    animatedLogo: {
      width: 28,
      height: 28,
      flexShrink: 0
    }
  };
};
class Header extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "renderLogo", () => {
      const { classes, onHomeClick, fullLogo } = this.props;
      return onHomeClick ? /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          "data-cy": "go-home",
          className: classes.home,
          onClick: onHomeClick,
          children: [
            /* @__PURE__ */ jsx$1(LogoMark$1, { axis: "y" }),
            fullLogo && /* @__PURE__ */ jsx$1("div", { className: classes.logoText, children: /* @__PURE__ */ jsx$1(LogoText$1, { axis: "y", size: 16 }) })
          ]
        }
      ) : null;
    });
    __publicField(this, "render", () => {
      const {
        classes,
        children,
        fixed,
        loading,
        subheaderPrimary,
        subheaderSecondary
      } = this.props;
      const hasSubheader = !!subheaderPrimary || !!subheaderSecondary;
      return /* @__PURE__ */ jsx$1("div", { className: classes.root, "data-cy": "atomic-header", children: /* @__PURE__ */ jsxs("div", { className: fixed ? classes.fixed : null, children: [
        /* @__PURE__ */ jsxs("div", { className: classes.header, "data-has-subheader": hasSubheader, children: [
          this.renderLogo(),
          /* @__PURE__ */ jsx$1("div", { className: classes.sections, "aria-busy": loading, children })
        ] }),
        hasSubheader && /* @__PURE__ */ jsx$1("div", { className: classes.subheader, "data-cy": "atomic-subheader", children: /* @__PURE__ */ jsxs("div", { className: classes.sections, "aria-busy": loading, children: [
          subheaderPrimary && /* @__PURE__ */ jsx$1(HeaderSection$1, { level: "primary", children: subheaderPrimary }),
          subheaderSecondary && /* @__PURE__ */ jsx$1(HeaderSection$1, { level: "secondary", children: subheaderSecondary })
        ] }) })
      ] }) });
    });
  }
}
__publicField(Header, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node,
  onHomeClick: PropTypes$1.func,
  fixed: PropTypes$1.bool,
  fullLogo: PropTypes$1.bool,
  loading: PropTypes$1.bool,
  subheaderPrimary: PropTypes$1.node,
  subheaderSecondary: PropTypes$1.node
});
__publicField(Header, "defaultProps", {
  fixed: true,
  onHomeClick: null,
  fullLogo: false,
  children: null,
  loading: false,
  subheaderPrimary: null,
  subheaderSecondary: null
});
const header = injectSheet(styles$G)(Header);
const styles$F = () => ({
  root: {
    flexShrink: 0,
    marginRight: 20,
    "&:last-child": {
      marginRight: 0
    }
  }
});
class HeaderSectionItem extends Component {
  render() {
    const { children, classes } = this.props;
    return /* @__PURE__ */ jsx$1("div", { className: classes.root, "data-cy": "atomic-header-section-item", children });
  }
}
__publicField(HeaderSectionItem, "propTypes", {
  children: PropTypes$1.node.isRequired,
  classes: PropTypes$1.object.isRequired
});
const header_section_item = injectSheet(styles$F)(HeaderSectionItem);
const styles$E = (theme2) => ({
  labelContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: 5
  },
  label: {
    fontSize: 16,
    fontWeight: 600,
    color: theme2.grey3
  },
  title: {
    color: theme2.blue900,
    fontSize: 10,
    lineHeight: "12px",
    letterSpacing: "0.5px",
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textTransform: "uppercase"
  },
  valueContainer: {
    padding: "0 16px",
    marginLeft: 9,
    borderLeft: `2px solid ${theme2.grey7}`,
    lineHeight: "18px",
    color: theme2.grey1,
    fontSize: 14,
    textWrap: "wrap",
    overflowWrap: "break-word"
  }
});
const KeyValue = ({
  classes,
  label = "",
  labelSuffix,
  children
}) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
  /* @__PURE__ */ jsxs("div", { className: classes.labelContainer, children: [
    label && /* @__PURE__ */ jsx$1("div", { className: classes.title, title: label, children: label }),
    labelSuffix
  ] }),
  /* @__PURE__ */ jsx$1("div", { className: classes.valueContainer, children })
] });
KeyValue.defaultProps = {
  label: null,
  labelSuffix: null
};
const KeyValue$1 = injectSheet(styles$E)(KeyValue);
const styles$D = (theme2) => ({
  root: {
    display: "flex",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      height: MIN_TARGET_SIZE,
      top: "50%",
      left: 0,
      right: 0,
      transform: "translateY(-50%)"
    },
    "&:not([data-is-disabled=true])": {
      cursor: "pointer"
    },
    "&[data-is-disabled=true]": {
      opacity: 0.3,
      color: theme2.grey3
    }
  },
  checkbox: {
    order: 2,
    boxSizing: "border-box",
    width: 18,
    height: 18,
    flexShrink: 0,
    marginTop: 1,
    color: theme2.grey4,
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: 4,
    borderColor: "currentColor",
    overflow: "hidden",
    boxShadow: `0 0 0 0 ${theme2.indigoPastel2}`,
    transition: `box-shadow 150ms linear 0ms, border-color 100ms linear 0ms`,
    position: "relative",
    "&[data-is-dark=true]": {
      color: theme2.grey2
    },
    "&::before": {
      content: '""',
      position: "absolute",
      borderRadius: 1,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: theme2.indigo3,
      opacity: 0,
      transformOrigin: "center",
      transform: "scaleX(0) scaleY(0)",
      transition: "opacity 100ms linear 0ms, transform 0ms linear 100ms"
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: 4,
      left: 6,
      right: 5,
      bottom: 3,
      opacity: 0,
      transformOrigin: "center",
      transform: "rotate(45deg) translateY(-1px) translateX(-1px)",
      borderWidth: "0 2px 2px 0",
      borderStyle: "solid",
      borderColor: theme2.white1,
      boxSizing: "border-box",
      transition: "opacity 100ms linear 0ms"
    },
    "&[data-is-indeterminate=true]": {
      "&::before": {
        backgroundColor: theme2.white1
      },
      "&::after": {
        top: 7,
        left: 3,
        right: 3,
        bottom: 7,
        transform: "unset",
        borderWidth: "0 0 2px 0",
        borderColor: theme2.indigo3
      }
    },
    "&[data-is-checked=true]": {
      color: theme2.indigo3,
      "&::before": {
        opacity: 1,
        transform: "scaleX(1) scaleY(1)",
        transition: "opacity 100ms linear 0ms, transform 50ms linear 0ms"
      },
      "&::after": {
        opacity: 1,
        transition: "opacity 100ms linear 100ms"
      }
    }
  },
  label: {
    fontSize: 11,
    fontWeight: 400,
    lineHeight: "20px",
    color: theme2.grey2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    "&:not([data-is-inverted=true])": {
      order: 3,
      marginLeft: 7
    },
    "&[data-is-inverted=true]": {
      order: 1,
      marginRight: 7
    },
    "&[data-is-largelabel=true]": {
      fontSize: 14,
      lineHeight: "20px"
    },
    "&[data-is-bold=true]": {
      fontWeight: 700
    },
    "&[data-is-darklabel=true]": {
      color: theme2.grey1
    }
  },
  input: {
    position: "absolute",
    zIndex: 0,
    transform: "translateX(-200%)"
  }
});
const escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
let classCounter = 0;
const generateClassName = (rule, styleSheet) => {
  classCounter += 1;
  if (styleSheet && styleSheet.options.classNamePrefix) {
    let prefix2 = styleSheet.options.classNamePrefix;
    prefix2 = prefix2.replace(escapeRegex, "-");
    return `${prefix2}-${rule.key}-${classCounter}`;
  }
  return `${rule.key}-${classCounter}`;
};
class CheckInput extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      hasFocus: false
    });
    __publicField(this, "id", uniqueId$1("cb_"));
    __publicField(this, "timer");
    __publicField(this, "handleFocus", (e5) => {
      window.clearTimeout(this.timer);
      this.setState({
        hasFocus: true
      });
      this.props.handleFocus(e5);
    });
    __publicField(this, "handleBlur", (e5) => {
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        this.setState({
          hasFocus: false
        });
        this.props.handleBlur(e5);
      }, 50);
    });
    __publicField(this, "handleChange", (e5) => {
      if (this.props.disabled) return;
      this.props.handleChange(e5);
    });
    __publicField(this, "render", () => {
      const {
        classes,
        checked,
        inputRef,
        label,
        invert,
        disabled,
        showLabel,
        isDark,
        largeLabel,
        bold,
        darkLabel,
        indeterminate
      } = this.props;
      const { hasFocus } = this.state;
      const rootProps = {
        className: classes.root,
        "data-is-disabled": disabled,
        title: label
      };
      const labelProps = {
        className: classes.label,
        "data-is-inverted": invert,
        "data-is-largelabel": largeLabel,
        "data-is-bold": bold,
        "data-is-darklabel": darkLabel
      };
      const checkboxProps = {
        className: classes.checkbox,
        "data-is-checked": checked,
        "data-has-focus": hasFocus,
        "data-is-dark": isDark,
        "data-is-indeterminate": indeterminate
      };
      const inputProps = {
        className: classes.input,
        id: this.id,
        checked,
        type: "checkbox",
        disabled,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        ref: inputRef
      };
      return /* @__PURE__ */ jsx$1(JssProvider, { generateClassName, children: /* @__PURE__ */ jsxs("label", { ...rootProps, htmlFor: this.id, children: [
        /* @__PURE__ */ jsx$1(Invisible$1, { visible: showLabel, children: /* @__PURE__ */ jsx$1("div", { ...labelProps, children: label }) }),
        /* @__PURE__ */ jsx$1("div", { ...checkboxProps, children: /* @__PURE__ */ jsx$1("input", { ...inputProps }) })
      ] }) });
    });
  }
}
__publicField(CheckInput, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  label: PropTypes$1.node.isRequired,
  checked: PropTypes$1.bool,
  handleFocus: PropTypes$1.func,
  handleBlur: PropTypes$1.func,
  handleChange: PropTypes$1.func,
  inputRef: PropTypes$1.func,
  invert: PropTypes$1.bool,
  disabled: PropTypes$1.bool,
  showLabel: PropTypes$1.bool,
  isDark: PropTypes$1.bool,
  largeLabel: PropTypes$1.bool,
  bold: PropTypes$1.bool,
  darkLabel: PropTypes$1.bool,
  indeterminate: PropTypes$1.bool
});
__publicField(CheckInput, "defaultProps", {
  checked: false,
  handleFocus: () => {
  },
  handleBlur: () => {
  },
  handleChange: () => {
  },
  inputRef: () => {
  },
  invert: false,
  disabled: false,
  showLabel: false,
  isDark: false,
  largeLabel: true,
  bold: false,
  darkLabel: false,
  indeterminate: false
});
const CheckComponent = injectSheet(styles$D)(CheckInput);
const Check = (props2) => /* @__PURE__ */ jsx$1(JssProvider, { generateClassName, children: /* @__PURE__ */ jsx$1(CheckComponent, { ...props2 }) });
const styles$C = (theme2) => ({
  root: {
    marginRight: 10,
    outline: "none",
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    flexFlow: "row wrap",
    lineHeight: "15px",
    "& button": {
      height: "100%",
      backgroundColor: "transparent",
      cursor: "pointer",
      textTransform: "capitalize"
    },
    "&[data-is-set=true]": {
      "& button": {
        color: theme2.grey1,
        textTransform: "unset"
      }
    }
  },
  multiselectInputDropDown: {
    width: "100%",
    border: `1px solid ${theme2.grey5}`,
    borderRadius: 5
  },
  tooltipHeader: {
    cursor: "pointer",
    padding: 7,
    display: "flex",
    flexFlow: "row nowrap",
    alignItems: "center",
    height: "100%"
  },
  option: {
    cursor: "pointer",
    padding: "11px 10px",
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch",
    "&[data-is-selected=true]": {
      backgroundColor: theme2.indigoPastel3
    },
    "&:hover": {
      backgroundColor: theme2.indigoPastel3
    }
  },
  textDisplay: {
    flexGrow: 1,
    fontSize: 14,
    whiteSpace: "nowrap",
    color: theme2.grey1,
    outline: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "&[data-is-unset=true]": {
      color: theme2.grey3
    }
  },
  multiselectDropdownIcon: {
    marginLeft: 5,
    flexShrink: 0,
    height: 17,
    width: 17,
    color: theme2.grey4,
    transition: "transform 0.3s ease-in-out",
    "&[data-input-focused=true]": {
      transform: "rotate(180deg)",
      color: theme2.indigo3
    },
    "& svg": {
      fill: theme2.grey1
    }
  },
  optionsList: {
    maxHeight: 330,
    overflow: "auto",
    position: "absolute",
    top: 40,
    // height of the fieldSelectCompact
    left: 0,
    // so the groups check list is aligned with the fieldSelectCompact
    zIndex: 3,
    // so the fieldSelectCompact smart label goes under
    background: theme2.white1,
    border: ({ shadows }) => !shadows ? `1px solid ${theme2.grey5}` : "none",
    boxShadow: ({ shadows }) => shadows ? theme2.indigoShadow1 : "unset",
    borderRadius: 5,
    width: "100%",
    "&::placeholder": {
      color: theme2.grey4
    },
    "&::-webkit-scrollbar": {
      cursor: "pointer",
      width: 5
    },
    "&::-webkit-scrollbar-track": {
      background: theme2.grey8,
      borderRadius: 10
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme2.grey4,
      borderRadius: 10,
      "&:hover": {
        background: theme2.grey3
      }
    }
  }
});
const pluralize = (count, word, firstLetterUppercase = false) => {
  const firstLetter = firstLetterUppercase ? word[0].toUpperCase() : word[0];
  return `${count} ${firstLetter + word.slice(1)}${count !== 1 ? "s" : ""}`;
};
const MultiSelect = ({
  classes,
  dataCy = "multiselect",
  options,
  selectedValues,
  onSelect,
  displayValue = "",
  compact = false,
  hideLabel = true,
  disabled = false,
  invalid: invalid2 = false,
  displayLabelIfOneSelected = false,
  // @ts-ignore only used within the stylesheet
  shadows = false
}) => {
  const selectBtn = useRef(null);
  const [isFocused, setFocus] = useState(false);
  useOnClickOutside(selectBtn, () => blur());
  useKeyPress("Escape", () => blur());
  const focus2 = useCallback(() => {
    if (!disabled && !isFocused) setFocus(true);
  }, [disabled, isFocused]);
  const blur = useCallback(() => {
    setFocus(false);
    if (selectBtn && selectBtn.current) selectBtn.current.focus();
  }, []);
  const selectMultipleItems = useCallback(
    (value) => {
      const newValues = [...selectedValues];
      const valueIndex = newValues.findIndex((item) => item === value);
      if (valueIndex > -1) {
        newValues.splice(valueIndex, 1);
      } else {
        newValues.push(value);
      }
      return onSelect(newValues);
    },
    [selectedValues, onSelect]
  );
  const handleOnSelect = useCallback(
    (value) => selectMultipleItems(value),
    [selectMultipleItems]
  );
  const textDisplay = useMemo(() => {
    var _a2;
    let disp = `No ${displayValue}s selected`;
    const nbValuesSelected = selectedValues == null ? void 0 : selectedValues.length;
    if (nbValuesSelected) {
      if (displayLabelIfOneSelected && nbValuesSelected === 1) {
        const [firstValue] = selectedValues;
        disp = ((_a2 = options == null ? void 0 : options.find(({ value }) => value === firstValue)) == null ? void 0 : _a2.label) || "";
      } else {
        disp = `${pluralize(selectedValues.length, displayValue)} selected`;
      }
    }
    return disp;
  }, [displayValue, selectedValues, options, displayLabelIfOneSelected]);
  const optionsList2 = options == null ? void 0 : options.map((item) => {
    const isSelected = (selectedValues == null ? void 0 : selectedValues.length) > 0 && selectedValues.filter((el2) => el2 === item.value).length > 0;
    const handleChange = () => handleOnSelect(item.value);
    return /* @__PURE__ */ jsx$1(
      "div",
      {
        className: classes.option,
        "data-is-selected": isSelected,
        children: /* @__PURE__ */ jsx$1(
          Check,
          {
            label: item.label,
            checked: isSelected,
            showLabel: true,
            largeLabel: true,
            handleChange
          }
        )
      },
      item.value
    );
  });
  const renderClosedDropdown = useMemo(
    () => compact ? /* @__PURE__ */ jsx$1(
      FieldSelectCompact,
      {
        onValueChange: () => {
        },
        value: "",
        label: `Select ${displayValue}`,
        disabled,
        invalid: invalid2,
        children: /* @__PURE__ */ jsx$1(
          OptionDrop,
          {
            label: textDisplay,
            value: textDisplay,
            selected: (options == null ? void 0 : options.length) > 0
          }
        )
      }
    ) : /* @__PURE__ */ jsx$1(
      Dropdown,
      {
        onValueChange: () => {
        },
        value: "",
        label: selectedValues.length > 0 ? textDisplay : `Select ${displayValue}s`,
        hideLabel,
        disabled,
        invalid: invalid2,
        children: /* @__PURE__ */ jsx$1(OptionDrop, { label: displayValue, value: "" })
      }
    ),
    [
      compact,
      hideLabel,
      options == null ? void 0 : options.length,
      selectedValues.length,
      displayValue,
      textDisplay,
      disabled,
      invalid2
    ]
  );
  const renderOpenedDropdown = useMemo(
    () => /* @__PURE__ */ jsxs("div", { className: classes.multiselectInputDropDown, children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: classes.tooltipHeader,
          onClick: blur,
          "data-cy": "multiselect-blur",
          children: [
            /* @__PURE__ */ jsx$1(
              "div",
              {
                "data-cy": "multiselect-placeholder",
                className: classes.textDisplay,
                children: (options == null ? void 0 : options.length) && textDisplay
              }
            ),
            /* @__PURE__ */ jsx$1(
              "div",
              {
                className: classes.multiselectDropdownIcon,
                "data-input-focused": isFocused,
                children: /* @__PURE__ */ jsx$1(icons.ArrowDownFill, { size: 17 })
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx$1("div", { className: classes.optionsList, children: optionsList2 })
    ] }),
    [blur, classes, isFocused, options == null ? void 0 : options.length, optionsList2, textDisplay]
  );
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      className: classes.root,
      "data-input-focused": isFocused,
      "data-is-set": (selectedValues == null ? void 0 : selectedValues.length) > 0,
      onClick: focus2,
      ref: selectBtn,
      "data-cy": dataCy,
      children: !isFocused ? renderClosedDropdown : renderOpenedDropdown
    }
  );
};
const MultiSelect$1 = injectSheet(styles$C)(MultiSelect);
var lib$9 = {};
Object.defineProperty(lib$9, "__esModule", {
  value: true
});
var IS_MAC = typeof window != "undefined" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
var MODIFIERS = {
  alt: "altKey",
  control: "ctrlKey",
  meta: "metaKey",
  shift: "shiftKey"
};
var ALIASES = {
  add: "+",
  break: "pause",
  cmd: "meta",
  command: "meta",
  ctl: "control",
  ctrl: "control",
  del: "delete",
  down: "arrowdown",
  esc: "escape",
  ins: "insert",
  left: "arrowleft",
  mod: IS_MAC ? "meta" : "control",
  opt: "alt",
  option: "alt",
  return: "enter",
  right: "arrowright",
  space: " ",
  spacebar: " ",
  up: "arrowup",
  win: "meta",
  windows: "meta"
};
var CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  " ": 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ";": 186,
  "=": 187,
  ",": 188,
  "-": 189,
  ".": 190,
  "/": 191,
  "`": 192,
  "[": 219,
  "\\": 220,
  "]": 221,
  "'": 222
};
for (var f$1 = 1; f$1 < 20; f$1++) {
  CODES["f" + f$1] = 111 + f$1;
}
function isHotkey(hotkey, options, event) {
  if (options && !("byKey" in options)) {
    event = options;
    options = null;
  }
  if (!Array.isArray(hotkey)) {
    hotkey = [hotkey];
  }
  var array = hotkey.map(function(string3) {
    return parseHotkey(string3, options);
  });
  var check = function check2(e5) {
    return array.some(function(object) {
      return compareHotkey(object, e5);
    });
  };
  var ret = event == null ? check : check(event);
  return ret;
}
function isCodeHotkey(hotkey, event) {
  return isHotkey(hotkey, event);
}
function isKeyHotkey(hotkey, event) {
  return isHotkey(hotkey, { byKey: true }, event);
}
function parseHotkey(hotkey, options) {
  var byKey = options && options.byKey;
  var ret = {};
  hotkey = hotkey.replace("++", "+add");
  var values = hotkey.split("+");
  var length = values.length;
  for (var k3 in MODIFIERS) {
    ret[MODIFIERS[k3]] = false;
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = void 0;
  try {
    for (var _iterator3 = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator3.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;
      var optional = value.endsWith("?") && value.length > 1;
      if (optional) {
        value = value.slice(0, -1);
      }
      var name2 = toKeyName(value);
      var modifier = MODIFIERS[name2];
      if (value.length > 1 && !modifier && !ALIASES[value] && !CODES[name2]) {
        throw new TypeError('Unknown modifier: "' + value + '"');
      }
      if (length === 1 || !modifier) {
        if (byKey) {
          ret.key = name2;
        } else {
          ret.which = toKeyCode(value);
        }
      }
      if (modifier) {
        ret[modifier] = optional ? null : true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return ret;
}
function compareHotkey(object, event) {
  for (var key2 in object) {
    var expected = object[key2];
    var actual = void 0;
    if (expected == null) {
      continue;
    }
    if (key2 === "key" && event.key != null) {
      actual = event.key.toLowerCase();
    } else if (key2 === "which") {
      actual = expected === 91 && event.which === 93 ? 91 : event.which;
    } else {
      actual = event[key2];
    }
    if (actual == null && expected === false) {
      continue;
    }
    if (actual !== expected) {
      return false;
    }
  }
  return true;
}
function toKeyCode(name2) {
  name2 = toKeyName(name2);
  var code2 = CODES[name2] || name2.toUpperCase().charCodeAt(0);
  return code2;
}
function toKeyName(name2) {
  name2 = name2.toLowerCase();
  name2 = ALIASES[name2] || name2;
  return name2;
}
var _default = lib$9.default = isHotkey;
var isHotkey_1 = lib$9.isHotkey = isHotkey;
lib$9.isCodeHotkey = isCodeHotkey;
lib$9.isKeyHotkey = isKeyHotkey;
lib$9.parseHotkey = parseHotkey;
lib$9.compareHotkey = compareHotkey;
lib$9.toKeyCode = toKeyCode;
lib$9.toKeyName = toKeyName;
var direction_1 = direction;
var RTL = "֑-߿יִ-﷽ﹰ-ﻼ";
var LTR = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿";
var rtl = new RegExp("^[^" + LTR + "]*[" + RTL + "]");
var ltr = new RegExp("^[^" + RTL + "]*[" + LTR + "]");
function direction(value) {
  value = String(value || "");
  if (rtl.test(value)) {
    return "rtl";
  }
  if (ltr.test(value)) {
    return "ltr";
  }
  return "neutral";
}
const getDirection = /* @__PURE__ */ getDefaultExportFromCjs$1(direction_1);
function isObject$i(value) {
  var type2 = typeof value;
  return value != null && (type2 == "object" || type2 == "function");
}
var isObject_1 = isObject$i;
const isObject$j = /* @__PURE__ */ getDefaultExportFromCjs$1(isObject_1);
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$9 = freeGlobal || freeSelf || Function("return this")();
var _root = root$9;
var root$8 = _root;
var now$2 = function() {
  return root$8.Date.now();
};
var now_1 = now$2;
var reWhitespace = /\s/;
function trimmedEndIndex$1(string3) {
  var index2 = string3.length;
  while (index2-- && reWhitespace.test(string3.charAt(index2))) {
  }
  return index2;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string3) {
  return string3 ? string3.slice(0, trimmedEndIndex(string3) + 1).replace(reTrimStart, "") : string3;
}
var _baseTrim = baseTrim$1;
var root$7 = _root;
var Symbol$7 = root$7.Symbol;
var _Symbol = Symbol$7;
var Symbol$6 = _Symbol;
var objectProto$i = Object.prototype;
var hasOwnProperty$f = objectProto$i.hasOwnProperty;
var nativeObjectToString$1 = objectProto$i.toString;
var symToStringTag$1 = Symbol$6 ? Symbol$6.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$f.call(value, symToStringTag$1), tag2 = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e5) {
  }
  var result2 = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag2;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result2;
}
var _getRawTag = getRawTag$1;
var objectProto$h = Object.prototype;
var nativeObjectToString = objectProto$h.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$5 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$5 ? Symbol$5.toStringTag : void 0;
function baseGetTag$9(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$9;
function isObjectLike$c(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$c;
var baseGetTag$8 = _baseGetTag, isObjectLike$b = isObjectLike_1;
var symbolTag$3 = "[object Symbol]";
function isSymbol$6(value) {
  return typeof value == "symbol" || isObjectLike$b(value) && baseGetTag$8(value) == symbolTag$3;
}
var isSymbol_1 = isSymbol$6;
var baseTrim = _baseTrim, isObject$h = isObject_1, isSymbol$5 = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$2(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol$5(value)) {
    return NAN;
  }
  if (isObject$h(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$h(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$2;
var isObject$g = isObject_1, now$1 = now_1, toNumber$1 = toNumber_1;
var FUNC_ERROR_TEXT$2 = "Expected a function";
var nativeMax$1 = Math.max, nativeMin$2 = Math.min;
function debounce$2(func, wait, options) {
  var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$g(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time2;
    result2 = func.apply(thisArg, args);
    return result2;
  }
  function leadingEdge(time2) {
    lastInvokeTime = time2;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time2) : result2;
  }
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin$2(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time2 = now$1();
    if (shouldInvoke(time2)) {
      return trailingEdge(time2);
    }
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  function trailingEdge(time2) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time2);
    }
    lastArgs = lastThis = void 0;
    return result2;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result2 : trailingEdge(now$1());
  }
  function debounced() {
    var time2 = now$1(), isInvoking = shouldInvoke(time2);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time2;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result2;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce$2;
const debounce$3 = /* @__PURE__ */ getDefaultExportFromCjs$1(debounce_1);
var debounce$1 = debounce_1, isObject$f = isObject_1;
var FUNC_ERROR_TEXT$1 = "Expected a function";
function throttle(func, wait, options) {
  var leading = true, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  if (isObject$f(options)) {
    leading = "leading" in options ? !!options.leading : leading;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  return debounce$1(func, wait, {
    "leading": leading,
    "maxWait": wait,
    "trailing": trailing
  });
}
var throttle_1 = throttle;
const throttle$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(throttle_1);
const t$1 = (t3) => "object" == typeof t3 && null != t3 && 1 === t3.nodeType, e$1 = (t3, e5) => (!e5 || "hidden" !== t3) && ("visible" !== t3 && "clip" !== t3), n$2 = (t3, n2) => {
  if (t3.clientHeight < t3.scrollHeight || t3.clientWidth < t3.scrollWidth) {
    const o2 = getComputedStyle(t3, null);
    return e$1(o2.overflowY, n2) || e$1(o2.overflowX, n2) || ((t4) => {
      const e5 = ((t5) => {
        if (!t5.ownerDocument || !t5.ownerDocument.defaultView) return null;
        try {
          return t5.ownerDocument.defaultView.frameElement;
        } catch (t6) {
          return null;
        }
      })(t4);
      return !!e5 && (e5.clientHeight < t4.scrollHeight || e5.clientWidth < t4.scrollWidth);
    })(t3);
  }
  return false;
}, o$2 = (t3, e5, n2, o2, l2, r2, i3, s4) => r2 < t3 && i3 > e5 || r2 > t3 && i3 < e5 ? 0 : r2 <= t3 && s4 <= n2 || i3 >= e5 && s4 >= n2 ? r2 - t3 - o2 : i3 > e5 && s4 < n2 || r2 < t3 && s4 > n2 ? i3 - e5 + l2 : 0, l$1 = (t3) => {
  const e5 = t3.parentElement;
  return null == e5 ? t3.getRootNode().host || null : e5;
}, r$1 = (e5, r2) => {
  var i3, s4, d4, h4;
  if ("undefined" == typeof document) return [];
  const { scrollMode: c3, block: f2, inline: u3, boundary: a4, skipOverflowHiddenElements: g2 } = r2, p2 = "function" == typeof a4 ? a4 : (t3) => t3 !== a4;
  if (!t$1(e5)) throw new TypeError("Invalid target");
  const m4 = document.scrollingElement || document.documentElement, w3 = [];
  let W2 = e5;
  for (; t$1(W2) && p2(W2); ) {
    if (W2 = l$1(W2), W2 === m4) {
      w3.push(W2);
      break;
    }
    null != W2 && W2 === document.body && n$2(W2) && !n$2(document.documentElement) || null != W2 && n$2(W2, g2) && w3.push(W2);
  }
  const b3 = null != (s4 = null == (i3 = window.visualViewport) ? void 0 : i3.width) ? s4 : innerWidth, H4 = null != (h4 = null == (d4 = window.visualViewport) ? void 0 : d4.height) ? h4 : innerHeight, { scrollX: y4, scrollY: M4 } = window, { height: v2, width: E3, top: x3, right: C2, bottom: I3, left: R3 } = e5.getBoundingClientRect(), { top: T3, right: B3, bottom: F2, left: V2 } = ((t3) => {
    const e6 = window.getComputedStyle(t3);
    return { top: parseFloat(e6.scrollMarginTop) || 0, right: parseFloat(e6.scrollMarginRight) || 0, bottom: parseFloat(e6.scrollMarginBottom) || 0, left: parseFloat(e6.scrollMarginLeft) || 0 };
  })(e5);
  let k3 = "start" === f2 || "nearest" === f2 ? x3 - T3 : "end" === f2 ? I3 + F2 : x3 + v2 / 2 - T3 + F2, D3 = "center" === u3 ? R3 + E3 / 2 - V2 + B3 : "end" === u3 ? C2 + B3 : R3 - V2;
  const L3 = [];
  for (let t3 = 0; t3 < w3.length; t3++) {
    const e6 = w3[t3], { height: n2, width: l2, top: r3, right: i4, bottom: s5, left: d5 } = e6.getBoundingClientRect();
    if ("if-needed" === c3 && x3 >= 0 && R3 >= 0 && I3 <= H4 && C2 <= b3 && x3 >= r3 && I3 <= s5 && R3 >= d5 && C2 <= i4) return L3;
    const h5 = getComputedStyle(e6), a5 = parseInt(h5.borderLeftWidth, 10), g3 = parseInt(h5.borderTopWidth, 10), p3 = parseInt(h5.borderRightWidth, 10), W3 = parseInt(h5.borderBottomWidth, 10);
    let T4 = 0, B4 = 0;
    const F3 = "offsetWidth" in e6 ? e6.offsetWidth - e6.clientWidth - a5 - p3 : 0, V3 = "offsetHeight" in e6 ? e6.offsetHeight - e6.clientHeight - g3 - W3 : 0, S4 = "offsetWidth" in e6 ? 0 === e6.offsetWidth ? 0 : l2 / e6.offsetWidth : 0, X3 = "offsetHeight" in e6 ? 0 === e6.offsetHeight ? 0 : n2 / e6.offsetHeight : 0;
    if (m4 === e6) T4 = "start" === f2 ? k3 : "end" === f2 ? k3 - H4 : "nearest" === f2 ? o$2(M4, M4 + H4, H4, g3, W3, M4 + k3, M4 + k3 + v2, v2) : k3 - H4 / 2, B4 = "start" === u3 ? D3 : "center" === u3 ? D3 - b3 / 2 : "end" === u3 ? D3 - b3 : o$2(y4, y4 + b3, b3, a5, p3, y4 + D3, y4 + D3 + E3, E3), T4 = Math.max(0, T4 + M4), B4 = Math.max(0, B4 + y4);
    else {
      T4 = "start" === f2 ? k3 - r3 - g3 : "end" === f2 ? k3 - s5 + W3 + V3 : "nearest" === f2 ? o$2(r3, s5, n2, g3, W3 + V3, k3, k3 + v2, v2) : k3 - (r3 + n2 / 2) + V3 / 2, B4 = "start" === u3 ? D3 - d5 - a5 : "center" === u3 ? D3 - (d5 + l2 / 2) + F3 / 2 : "end" === u3 ? D3 - i4 + p3 + F3 : o$2(d5, i4, l2, a5, p3 + F3, D3, D3 + E3, E3);
      const { scrollLeft: t4, scrollTop: h6 } = e6;
      T4 = 0 === X3 ? 0 : Math.max(0, Math.min(h6 + T4 / X3, e6.scrollHeight - n2 / X3 + V3)), B4 = 0 === S4 ? 0 : Math.max(0, Math.min(t4 + B4 / S4, e6.scrollWidth - l2 / S4 + F3)), k3 += h6 - T4, D3 += t4 - B4;
    }
    L3.push({ el: e6, top: T4, left: B4 });
  }
  return L3;
};
const o$1 = (t3) => false === t3 ? { block: "end", inline: "nearest" } : ((t4) => t4 === Object(t4) && 0 !== Object.keys(t4).length)(t3) ? t3 : { block: "start", inline: "nearest" };
function e3(e5, r2) {
  if (!e5.isConnected || !((t3) => {
    let o2 = t3;
    for (; o2 && o2.parentNode; ) {
      if (o2.parentNode === document) return true;
      o2 = o2.parentNode instanceof ShadowRoot ? o2.parentNode.host : o2.parentNode;
    }
    return false;
  })(e5)) return;
  const n2 = ((t3) => {
    const o2 = window.getComputedStyle(t3);
    return { top: parseFloat(o2.scrollMarginTop) || 0, right: parseFloat(o2.scrollMarginRight) || 0, bottom: parseFloat(o2.scrollMarginBottom) || 0, left: parseFloat(o2.scrollMarginLeft) || 0 };
  })(e5);
  if (((t3) => "object" == typeof t3 && "function" == typeof t3.behavior)(r2)) return r2.behavior(r$1(e5, r2));
  const l2 = "boolean" == typeof r2 || null == r2 ? void 0 : r2.behavior;
  for (const { el: a4, top: i3, left: s4 } of r$1(e5, o$1(r2))) {
    const t3 = i3 - n2.top + n2.bottom, o2 = s4 - n2.left + n2.right;
    a4.scroll({ top: t3, left: o2, behavior: l2 });
  }
}
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function isObject$e(o2) {
  return Object.prototype.toString.call(o2) === "[object Object]";
}
function isPlainObject$9(o2) {
  var ctor, prot;
  if (isObject$e(o2) === false) return false;
  ctor = o2.constructor;
  if (ctor === void 0) return true;
  prot = ctor.prototype;
  if (isObject$e(prot) === false) return false;
  if (prot.hasOwnProperty("isPrototypeOf") === false) {
    return false;
  }
  return true;
}
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
var errors$1 = process$1$1.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(plugin) {
    return `The plugin for '${plugin}' has not been loaded into Immer. To enable the plugin, import and call \`enable${plugin}()\` when initializing your application.`;
  },
  function(thing) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${thing}'`;
  },
  "This object has been frozen and should not be mutated",
  function(data) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + data;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(thing) {
    return `'current' expects a draft, got: ${thing}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(thing) {
    return `'original' expects a draft, got: ${thing}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die(error2, ...args) {
  if (process$1$1.env.NODE_ENV !== "production") {
    const e5 = errors$1[error2];
    const msg2 = typeof e5 === "function" ? e5.apply(null, args) : e5;
    throw new Error(`[Immer] ${msg2}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${error2}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  var _a2;
  if (!value)
    return false;
  return isPlainObject$8(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a2 = value.constructor) == null ? void 0 : _a2[DRAFTABLE]) || isMap$2(value) || isSet$2(value);
}
var objectCtorString$1 = Object.prototype.constructor.toString();
function isPlainObject$8(value) {
  if (!value || typeof value !== "object")
    return false;
  const proto2 = getPrototypeOf(value);
  if (proto2 === null) {
    return true;
  }
  const Ctor = Object.hasOwnProperty.call(proto2, "constructor") && proto2.constructor;
  if (Ctor === Object)
    return true;
  return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString$1;
}
function each(obj, iter) {
  if (getArchtype(obj) === 0) {
    Reflect.ownKeys(obj).forEach((key2) => {
      iter(key2, obj[key2], obj);
    });
  } else {
    obj.forEach((entry, index2) => iter(index2, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : Array.isArray(thing) ? 1 : isMap$2(thing) ? 2 : isSet$2(thing) ? 3 : 0;
}
function has$6(thing, prop) {
  return getArchtype(thing) === 2 ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function set$5(thing, propOrOldValue, value) {
  const t3 = getArchtype(thing);
  if (t3 === 2)
    thing.set(propOrOldValue, value);
  else if (t3 === 3) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
}
function is$1(x3, y4) {
  if (x3 === y4) {
    return x3 !== 0 || 1 / x3 === 1 / y4;
  } else {
    return x3 !== x3 && y4 !== y4;
  }
}
function isMap$2(target) {
  return target instanceof Map;
}
function isSet$2(target) {
  return target instanceof Set;
}
function latest(state) {
  return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
  if (isMap$2(base)) {
    return new Map(base);
  }
  if (isSet$2(base)) {
    return new Set(base);
  }
  if (Array.isArray(base))
    return Array.prototype.slice.call(base);
  const isPlain = isPlainObject$8(base);
  if (strict === true || strict === "class_only" && !isPlain) {
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    let keys4 = Reflect.ownKeys(descriptors);
    for (let i3 = 0; i3 < keys4.length; i3++) {
      const key2 = keys4[i3];
      const desc = descriptors[key2];
      if (desc.writable === false) {
        desc.writable = true;
        desc.configurable = true;
      }
      if (desc.get || desc.set)
        descriptors[key2] = {
          configurable: true,
          writable: true,
          // could live with !!desc.set as well here...
          enumerable: desc.enumerable,
          value: base[key2]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
  } else {
    const proto2 = getPrototypeOf(base);
    if (proto2 !== null && isPlain) {
      return { ...base };
    }
    const obj = Object.create(proto2);
    return Object.assign(obj, base);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
  }
  Object.freeze(obj);
  if (deep)
    Object.entries(obj).forEach(([key2, value]) => freeze(value, true));
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
function isFrozen(obj) {
  return Object.isFrozen(obj);
}
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(parent_, immer_) {
  return {
    drafts_: [],
    parent_,
    immer_,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: true,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(scope2, patchListener) {
  if (patchListener) {
    getPlugin("Patches");
    scope2.patches_ = [];
    scope2.inversePatches_ = [];
    scope2.patchListener_ = patchListener;
  }
}
function revokeScope(scope2) {
  leaveScope(scope2);
  scope2.drafts_.forEach(revokeDraft);
  scope2.drafts_ = null;
}
function leaveScope(scope2) {
  if (scope2 === currentScope) {
    currentScope = scope2.parent_;
  }
}
function enterScope(immer2) {
  return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 || state.type_ === 1)
    state.revoke_();
  else
    state.revoked_ = true;
}
function processResult(result2, scope2) {
  scope2.unfinalizedDrafts_ = scope2.drafts_.length;
  const baseDraft = scope2.drafts_[0];
  const isReplaced = result2 !== void 0 && result2 !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope2);
      die(4);
    }
    if (isDraftable(result2)) {
      result2 = finalize(scope2, result2);
      if (!scope2.parent_)
        maybeFreeze(scope2, result2);
    }
    if (scope2.patches_) {
      getPlugin("Patches").generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result2,
        scope2.patches_,
        scope2.inversePatches_
      );
    }
  } else {
    result2 = finalize(scope2, baseDraft, []);
  }
  revokeScope(scope2);
  if (scope2.patches_) {
    scope2.patchListener_(scope2.patches_, scope2.inversePatches_);
  }
  return result2 !== NOTHING ? result2 : void 0;
}
function finalize(rootScope, value, path3) {
  if (isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    each(
      value,
      (key2, childValue) => finalizeProperty(rootScope, state, value, key2, childValue, path3)
    );
    return value;
  }
  if (state.scope_ !== rootScope)
    return value;
  if (!state.modified_) {
    maybeFreeze(rootScope, state.base_, true);
    return state.base_;
  }
  if (!state.finalized_) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
    const result2 = state.copy_;
    let resultEach = result2;
    let isSet2 = false;
    if (state.type_ === 3) {
      resultEach = new Set(result2);
      result2.clear();
      isSet2 = true;
    }
    each(
      resultEach,
      (key2, childValue) => finalizeProperty(rootScope, state, result2, key2, childValue, path3, isSet2)
    );
    maybeFreeze(rootScope, result2, false);
    if (path3 && rootScope.patches_) {
      getPlugin("Patches").generatePatches_(
        state,
        path3,
        rootScope.patches_,
        rootScope.inversePatches_
      );
    }
  }
  return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
  if (process$1$1.env.NODE_ENV !== "production" && childValue === targetObject)
    die(5);
  if (isDraft(childValue)) {
    const path3 = rootPath && parentState && parentState.type_ !== 3 && // Set objects are atomic since they have no keys.
    !has$6(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
    const res = finalize(rootScope, childValue, path3);
    set$5(targetObject, prop, res);
    if (isDraft(res)) {
      rootScope.canAutoFreeze_ = false;
    } else
      return;
  } else if (targetIsSet) {
    targetObject.add(childValue);
  }
  if (isDraftable(childValue) && !isFrozen(childValue)) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
      return;
    }
    finalize(rootScope, childValue);
    if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop))
      maybeFreeze(rootScope, childValue);
  }
}
function maybeFreeze(scope2, value, deep = false) {
  if (!scope2.parent_ && scope2.immer_.autoFreeze_ && scope2.canAutoFreeze_) {
    freeze(value, deep);
  }
}
function createProxyProxy(base, parent3) {
  const isArray4 = Array.isArray(base);
  const state = {
    type_: isArray4 ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: parent3 ? parent3.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: parent3,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false
  };
  let target = state;
  let traps = objectTraps;
  if (isArray4) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return proxy;
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has$6(source, prop)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      return state.copy_[prop] = createProxy(value, state);
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc == null ? void 0 : desc.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_[prop] = false;
        return true;
      }
      if (is$1(value, current2) && (value !== void 0 || has$6(state.base_, prop)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_[prop] = true;
    return true;
  },
  deleteProperty(state, prop) {
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_[prop] = false;
      prepareCopy(state);
      markChanged(state);
    } else {
      delete state.assigned_[prop];
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      writable: true,
      configurable: state.type_ !== 1 || prop !== "length",
      enumerable: desc.enumerable,
      value: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each(objectTraps, (key2, fn2) => {
  arrayTraps[key2] = function() {
    arguments[0] = arguments[0][0];
    return fn2.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  if (process$1$1.env.NODE_ENV !== "production" && isNaN(parseInt(prop)))
    die(13);
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  if (process$1$1.env.NODE_ENV !== "production" && prop !== "length" && isNaN(parseInt(prop)))
    die(14);
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  var _a2;
  const desc = getDescriptorFromProto(source, prop);
  return desc ? `value` in desc ? desc.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a2 = desc.get) == null ? void 0 : _a2.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto2 = getPrototypeOf(source);
  while (proto2) {
    const desc = Object.getOwnPropertyDescriptor(proto2, prop);
    if (desc)
      return desc;
    proto2 = getPrototypeOf(proto2);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}
var Immer2 = class {
  constructor(config) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    this.produce = (base, recipe, patchListener) => {
      if (typeof base === "function" && typeof recipe !== "function") {
        const defaultBase = recipe;
        recipe = base;
        const self2 = this;
        return function curriedProduce(base2 = defaultBase, ...args) {
          return self2.produce(base2, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (typeof recipe !== "function")
        die(6);
      if (patchListener !== void 0 && typeof patchListener !== "function")
        die(7);
      let result2;
      if (isDraftable(base)) {
        const scope2 = enterScope(this);
        const proxy = createProxy(base, void 0);
        let hasError = true;
        try {
          result2 = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope2);
          else
            leaveScope(scope2);
        }
        usePatchesInScope(scope2, patchListener);
        return processResult(result2, scope2);
      } else if (!base || typeof base !== "object") {
        result2 = recipe(base);
        if (result2 === void 0)
          result2 = base;
        if (result2 === NOTHING)
          result2 = void 0;
        if (this.autoFreeze_)
          freeze(result2, true);
        if (patchListener) {
          const p2 = [];
          const ip = [];
          getPlugin("Patches").generateReplacementPatches_(base, result2, p2, ip);
          patchListener(p2, ip);
        }
        return result2;
      } else
        die(1, base);
    };
    this.produceWithPatches = (base, recipe) => {
      if (typeof base === "function") {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
      }
      let patches, inversePatches;
      const result2 = this.produce(base, recipe, (p2, ip) => {
        patches = p2;
        inversePatches = ip;
      });
      return [result2, patches, inversePatches];
    };
    if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean")
      this.setAutoFreeze(config.autoFreeze);
    if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean")
      this.setUseStrictShallowCopy(config.useStrictShallowCopy);
  }
  createDraft(base) {
    if (!isDraftable(base))
      die(8);
    if (isDraft(base))
      base = current(base);
    const scope2 = enterScope(this);
    const proxy = createProxy(base, void 0);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope2);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope2 } = state;
    usePatchesInScope(scope2, patchListener);
    return processResult(void 0, scope2);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  applyPatches(base, patches) {
    let i3;
    for (i3 = patches.length - 1; i3 >= 0; i3--) {
      const patch = patches[i3];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i3 > -1) {
      patches = patches.slice(i3 + 1);
    }
    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
    if (isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(
      base,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(value, parent3) {
  const draft = isMap$2(value) ? getPlugin("MapSet").proxyMap_(value, parent3) : isSet$2(value) ? getPlugin("MapSet").proxySet_(value, parent3) : createProxyProxy(value, parent3);
  const scope2 = parent3 ? parent3.scope_ : getCurrentScope();
  scope2.drafts_.push(draft);
  return draft;
}
function current(value) {
  if (!isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy2;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy2 = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
  } else {
    copy2 = shallowCopy(value, true);
  }
  each(copy2, (key2, childValue) => {
    set$5(copy2, key2, currentImpl(childValue));
  });
  if (state) {
    state.finalized_ = false;
  }
  return copy2;
}
var immer = new Immer2();
var produce = immer.produce;
immer.produceWithPatches.bind(
  immer
);
immer.setAutoFreeze.bind(immer);
immer.setUseStrictShallowCopy.bind(immer);
immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
var PathRef = {
  transform(ref2, op) {
    var {
      current: current2,
      affinity
    } = ref2;
    if (current2 == null) {
      return;
    }
    var path3 = Path.transform(current2, op, {
      affinity
    });
    ref2.current = path3;
    if (path3 == null) {
      ref2.unref();
    }
  }
};
var PointRef = {
  transform(ref2, op) {
    var {
      current: current2,
      affinity
    } = ref2;
    if (current2 == null) {
      return;
    }
    var point3 = Point.transform(current2, op, {
      affinity
    });
    ref2.current = point3;
    if (point3 == null) {
      ref2.unref();
    }
  }
};
var RangeRef = {
  transform(ref2, op) {
    var {
      current: current2,
      affinity
    } = ref2;
    if (current2 == null) {
      return;
    }
    var path3 = Range.transform(current2, op, {
      affinity
    });
    ref2.current = path3;
    if (path3 == null) {
      ref2.unref();
    }
  }
};
var DIRTY_PATHS = /* @__PURE__ */ new WeakMap();
var DIRTY_PATH_KEYS = /* @__PURE__ */ new WeakMap();
var FLUSHING = /* @__PURE__ */ new WeakMap();
var NORMALIZING = /* @__PURE__ */ new WeakMap();
var PATH_REFS = /* @__PURE__ */ new WeakMap();
var POINT_REFS = /* @__PURE__ */ new WeakMap();
var RANGE_REFS = /* @__PURE__ */ new WeakMap();
var Path = {
  ancestors(path3) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var {
      reverse = false
    } = options;
    var paths = Path.levels(path3, options);
    if (reverse) {
      paths = paths.slice(1);
    } else {
      paths = paths.slice(0, -1);
    }
    return paths;
  },
  common(path3, another) {
    var common2 = [];
    for (var i3 = 0; i3 < path3.length && i3 < another.length; i3++) {
      var av = path3[i3];
      var bv = another[i3];
      if (av !== bv) {
        break;
      }
      common2.push(av);
    }
    return common2;
  },
  compare(path3, another) {
    var min2 = Math.min(path3.length, another.length);
    for (var i3 = 0; i3 < min2; i3++) {
      if (path3[i3] < another[i3]) return -1;
      if (path3[i3] > another[i3]) return 1;
    }
    return 0;
  },
  endsAfter(path3, another) {
    var i3 = path3.length - 1;
    var as2 = path3.slice(0, i3);
    var bs = another.slice(0, i3);
    var av = path3[i3];
    var bv = another[i3];
    return Path.equals(as2, bs) && av > bv;
  },
  endsAt(path3, another) {
    var i3 = path3.length;
    var as2 = path3.slice(0, i3);
    var bs = another.slice(0, i3);
    return Path.equals(as2, bs);
  },
  endsBefore(path3, another) {
    var i3 = path3.length - 1;
    var as2 = path3.slice(0, i3);
    var bs = another.slice(0, i3);
    var av = path3[i3];
    var bv = another[i3];
    return Path.equals(as2, bs) && av < bv;
  },
  equals(path3, another) {
    return path3.length === another.length && path3.every((n2, i3) => n2 === another[i3]);
  },
  hasPrevious(path3) {
    return path3[path3.length - 1] > 0;
  },
  isAfter(path3, another) {
    return Path.compare(path3, another) === 1;
  },
  isAncestor(path3, another) {
    return path3.length < another.length && Path.compare(path3, another) === 0;
  },
  isBefore(path3, another) {
    return Path.compare(path3, another) === -1;
  },
  isChild(path3, another) {
    return path3.length === another.length + 1 && Path.compare(path3, another) === 0;
  },
  isCommon(path3, another) {
    return path3.length <= another.length && Path.compare(path3, another) === 0;
  },
  isDescendant(path3, another) {
    return path3.length > another.length && Path.compare(path3, another) === 0;
  },
  isParent(path3, another) {
    return path3.length + 1 === another.length && Path.compare(path3, another) === 0;
  },
  isPath(value) {
    return Array.isArray(value) && (value.length === 0 || typeof value[0] === "number");
  },
  isSibling(path3, another) {
    if (path3.length !== another.length) {
      return false;
    }
    var as2 = path3.slice(0, -1);
    var bs = another.slice(0, -1);
    var al = path3[path3.length - 1];
    var bl = another[another.length - 1];
    return al !== bl && Path.equals(as2, bs);
  },
  levels(path3) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var {
      reverse = false
    } = options;
    var list = [];
    for (var i3 = 0; i3 <= path3.length; i3++) {
      list.push(path3.slice(0, i3));
    }
    if (reverse) {
      list.reverse();
    }
    return list;
  },
  next(path3) {
    if (path3.length === 0) {
      throw new Error("Cannot get the next path of a root path [".concat(path3, "], because it has no next index."));
    }
    var last2 = path3[path3.length - 1];
    return path3.slice(0, -1).concat(last2 + 1);
  },
  operationCanTransformPath(operation) {
    switch (operation.type) {
      case "insert_node":
      case "remove_node":
      case "merge_node":
      case "split_node":
      case "move_node":
        return true;
      default:
        return false;
    }
  },
  parent(path3) {
    if (path3.length === 0) {
      throw new Error("Cannot get the parent path of the root path [".concat(path3, "]."));
    }
    return path3.slice(0, -1);
  },
  previous(path3) {
    if (path3.length === 0) {
      throw new Error("Cannot get the previous path of a root path [".concat(path3, "], because it has no previous index."));
    }
    var last2 = path3[path3.length - 1];
    if (last2 <= 0) {
      throw new Error("Cannot get the previous path of a first child path [".concat(path3, "] because it would result in a negative index."));
    }
    return path3.slice(0, -1).concat(last2 - 1);
  },
  relative(path3, ancestor) {
    if (!Path.isAncestor(ancestor, path3) && !Path.equals(path3, ancestor)) {
      throw new Error("Cannot get the relative path of [".concat(path3, "] inside ancestor [").concat(ancestor, "], because it is not above or equal to the path."));
    }
    return path3.slice(ancestor.length);
  },
  transform(path3, operation) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!path3) return null;
    var p2 = [...path3];
    var {
      affinity = "forward"
    } = options;
    if (path3.length === 0) {
      return p2;
    }
    switch (operation.type) {
      case "insert_node": {
        var {
          path: op
        } = operation;
        if (Path.equals(op, p2) || Path.endsBefore(op, p2) || Path.isAncestor(op, p2)) {
          p2[op.length - 1] += 1;
        }
        break;
      }
      case "remove_node": {
        var {
          path: _op
        } = operation;
        if (Path.equals(_op, p2) || Path.isAncestor(_op, p2)) {
          return null;
        } else if (Path.endsBefore(_op, p2)) {
          p2[_op.length - 1] -= 1;
        }
        break;
      }
      case "merge_node": {
        var {
          path: _op2,
          position: position2
        } = operation;
        if (Path.equals(_op2, p2) || Path.endsBefore(_op2, p2)) {
          p2[_op2.length - 1] -= 1;
        } else if (Path.isAncestor(_op2, p2)) {
          p2[_op2.length - 1] -= 1;
          p2[_op2.length] += position2;
        }
        break;
      }
      case "split_node": {
        var {
          path: _op3,
          position: _position
        } = operation;
        if (Path.equals(_op3, p2)) {
          if (affinity === "forward") {
            p2[p2.length - 1] += 1;
          } else if (affinity === "backward") ;
          else {
            return null;
          }
        } else if (Path.endsBefore(_op3, p2)) {
          p2[_op3.length - 1] += 1;
        } else if (Path.isAncestor(_op3, p2) && path3[_op3.length] >= _position) {
          p2[_op3.length - 1] += 1;
          p2[_op3.length] -= _position;
        }
        break;
      }
      case "move_node": {
        var {
          path: _op4,
          newPath: onp
        } = operation;
        if (Path.equals(_op4, onp)) {
          return p2;
        }
        if (Path.isAncestor(_op4, p2) || Path.equals(_op4, p2)) {
          var copy2 = onp.slice();
          if (Path.endsBefore(_op4, onp) && _op4.length < onp.length) {
            copy2[_op4.length - 1] -= 1;
          }
          return copy2.concat(p2.slice(_op4.length));
        } else if (Path.isSibling(_op4, onp) && (Path.isAncestor(onp, p2) || Path.equals(onp, p2))) {
          if (Path.endsBefore(_op4, p2)) {
            p2[_op4.length - 1] -= 1;
          } else {
            p2[_op4.length - 1] += 1;
          }
        } else if (Path.endsBefore(onp, p2) || Path.equals(onp, p2) || Path.isAncestor(onp, p2)) {
          if (Path.endsBefore(_op4, p2)) {
            p2[_op4.length - 1] -= 1;
          }
          p2[onp.length - 1] += 1;
        } else if (Path.endsBefore(_op4, p2)) {
          if (Path.equals(onp, p2)) {
            p2[onp.length - 1] += 1;
          }
          p2[_op4.length - 1] -= 1;
        }
        break;
      }
    }
    return p2;
  }
};
function _typeof$3(o2) {
  "@babel/helpers - typeof";
  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$3(o2);
}
function _toPrimitive$2(input, hint) {
  if (_typeof$3(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$3(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey$2(arg) {
  var key2 = _toPrimitive$2(arg, "string");
  return _typeof$3(key2) === "symbol" ? key2 : String(key2);
}
function _defineProperty$4(obj, key2, value) {
  key2 = _toPropertyKey$2(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function ownKeys$e(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$e(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$e(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$e(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var applyToDraft = (editor, selection, op) => {
  switch (op.type) {
    case "insert_node": {
      var {
        path: path3,
        node: node3
      } = op;
      var parent3 = Node$1.parent(editor, path3);
      var index2 = path3[path3.length - 1];
      if (index2 > parent3.children.length) {
        throw new Error('Cannot apply an "insert_node" operation at path ['.concat(path3, "] because the destination is past the end of the node."));
      }
      parent3.children.splice(index2, 0, node3);
      if (selection) {
        for (var [point3, key2] of Range.points(selection)) {
          selection[key2] = Point.transform(point3, op);
        }
      }
      break;
    }
    case "insert_text": {
      var {
        path: _path,
        offset: offset2,
        text
      } = op;
      if (text.length === 0) break;
      var _node = Node$1.leaf(editor, _path);
      var before3 = _node.text.slice(0, offset2);
      var after3 = _node.text.slice(offset2);
      _node.text = before3 + text + after3;
      if (selection) {
        for (var [_point, _key] of Range.points(selection)) {
          selection[_key] = Point.transform(_point, op);
        }
      }
      break;
    }
    case "merge_node": {
      var {
        path: _path2
      } = op;
      var _node2 = Node$1.get(editor, _path2);
      var prevPath = Path.previous(_path2);
      var prev = Node$1.get(editor, prevPath);
      var _parent2 = Node$1.parent(editor, _path2);
      var _index = _path2[_path2.length - 1];
      if (Text$1.isText(_node2) && Text$1.isText(prev)) {
        prev.text += _node2.text;
      } else if (!Text$1.isText(_node2) && !Text$1.isText(prev)) {
        prev.children.push(..._node2.children);
      } else {
        throw new Error('Cannot apply a "merge_node" operation at path ['.concat(_path2, "] to nodes of different interfaces: ").concat(Scrubber.stringify(_node2), " ").concat(Scrubber.stringify(prev)));
      }
      _parent2.children.splice(_index, 1);
      if (selection) {
        for (var [_point2, _key2] of Range.points(selection)) {
          selection[_key2] = Point.transform(_point2, op);
        }
      }
      break;
    }
    case "move_node": {
      var {
        path: _path3,
        newPath
      } = op;
      if (Path.isAncestor(_path3, newPath)) {
        throw new Error("Cannot move a path [".concat(_path3, "] to new path [").concat(newPath, "] because the destination is inside itself."));
      }
      var _node3 = Node$1.get(editor, _path3);
      var _parent22 = Node$1.parent(editor, _path3);
      var _index2 = _path3[_path3.length - 1];
      _parent22.children.splice(_index2, 1);
      var truePath = Path.transform(_path3, op);
      var newParent = Node$1.get(editor, Path.parent(truePath));
      var newIndex = truePath[truePath.length - 1];
      newParent.children.splice(newIndex, 0, _node3);
      if (selection) {
        for (var [_point3, _key3] of Range.points(selection)) {
          selection[_key3] = Point.transform(_point3, op);
        }
      }
      break;
    }
    case "remove_node": {
      var {
        path: _path4
      } = op;
      var _index3 = _path4[_path4.length - 1];
      var _parent3 = Node$1.parent(editor, _path4);
      _parent3.children.splice(_index3, 1);
      if (selection) {
        for (var [_point4, _key4] of Range.points(selection)) {
          var result2 = Point.transform(_point4, op);
          if (selection != null && result2 != null) {
            selection[_key4] = result2;
          } else {
            var _prev = void 0;
            var next3 = void 0;
            for (var [n2, p2] of Node$1.texts(editor)) {
              if (Path.compare(p2, _path4) === -1) {
                _prev = [n2, p2];
              } else {
                next3 = [n2, p2];
                break;
              }
            }
            var preferNext = false;
            if (_prev && next3) {
              if (Path.equals(next3[1], _path4)) {
                preferNext = !Path.hasPrevious(next3[1]);
              } else {
                preferNext = Path.common(_prev[1], _path4).length < Path.common(next3[1], _path4).length;
              }
            }
            if (_prev && !preferNext) {
              _point4.path = _prev[1];
              _point4.offset = _prev[0].text.length;
            } else if (next3) {
              _point4.path = next3[1];
              _point4.offset = 0;
            } else {
              selection = null;
            }
          }
        }
      }
      break;
    }
    case "remove_text": {
      var {
        path: _path5,
        offset: _offset,
        text: _text
      } = op;
      if (_text.length === 0) break;
      var _node4 = Node$1.leaf(editor, _path5);
      var _before = _node4.text.slice(0, _offset);
      var _after = _node4.text.slice(_offset + _text.length);
      _node4.text = _before + _after;
      if (selection) {
        for (var [_point5, _key5] of Range.points(selection)) {
          selection[_key5] = Point.transform(_point5, op);
        }
      }
      break;
    }
    case "set_node": {
      var {
        path: _path6,
        properties: properties2,
        newProperties
      } = op;
      if (_path6.length === 0) {
        throw new Error("Cannot set properties on the root node!");
      }
      var _node5 = Node$1.get(editor, _path6);
      for (var _key6 in newProperties) {
        if (_key6 === "children" || _key6 === "text") {
          throw new Error('Cannot set the "'.concat(_key6, '" property of nodes!'));
        }
        var value = newProperties[_key6];
        if (value == null) {
          delete _node5[_key6];
        } else {
          _node5[_key6] = value;
        }
      }
      for (var _key7 in properties2) {
        if (!newProperties.hasOwnProperty(_key7)) {
          delete _node5[_key7];
        }
      }
      break;
    }
    case "set_selection": {
      var {
        newProperties: _newProperties
      } = op;
      if (_newProperties == null) {
        selection = _newProperties;
      } else {
        if (selection == null) {
          if (!Range.isRange(_newProperties)) {
            throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat(Scrubber.stringify(_newProperties), " when there is no current selection."));
          }
          selection = _objectSpread$e({}, _newProperties);
        }
        for (var _key8 in _newProperties) {
          var _value = _newProperties[_key8];
          if (_value == null) {
            if (_key8 === "anchor" || _key8 === "focus") {
              throw new Error('Cannot remove the "'.concat(_key8, '" selection property'));
            }
            delete selection[_key8];
          } else {
            selection[_key8] = _value;
          }
        }
      }
      break;
    }
    case "split_node": {
      var {
        path: _path7,
        position: position2,
        properties: _properties
      } = op;
      if (_path7.length === 0) {
        throw new Error('Cannot apply a "split_node" operation at path ['.concat(_path7, "] because the root node cannot be split."));
      }
      var _node6 = Node$1.get(editor, _path7);
      var _parent4 = Node$1.parent(editor, _path7);
      var _index4 = _path7[_path7.length - 1];
      var newNode;
      if (Text$1.isText(_node6)) {
        var _before2 = _node6.text.slice(0, position2);
        var _after2 = _node6.text.slice(position2);
        _node6.text = _before2;
        newNode = _objectSpread$e(_objectSpread$e({}, _properties), {}, {
          text: _after2
        });
      } else {
        var _before3 = _node6.children.slice(0, position2);
        var _after3 = _node6.children.slice(position2);
        _node6.children = _before3;
        newNode = _objectSpread$e(_objectSpread$e({}, _properties), {}, {
          children: _after3
        });
      }
      _parent4.children.splice(_index4 + 1, 0, newNode);
      if (selection) {
        for (var [_point6, _key9] of Range.points(selection)) {
          selection[_key9] = Point.transform(_point6, op);
        }
      }
      break;
    }
  }
  return selection;
};
var GeneralTransforms = {
  transform(editor, op) {
    editor.children = createDraft(editor.children);
    var selection = editor.selection && createDraft(editor.selection);
    try {
      selection = applyToDraft(editor, selection, op);
    } finally {
      editor.children = finishDraft(editor.children);
      if (selection) {
        editor.selection = isDraft(selection) ? finishDraft(selection) : selection;
      } else {
        editor.selection = null;
      }
    }
  }
};
var NodeTransforms = {
  insertNodes(editor, nodes2, options) {
    editor.insertNodes(nodes2, options);
  },
  liftNodes(editor, options) {
    editor.liftNodes(options);
  },
  mergeNodes(editor, options) {
    editor.mergeNodes(options);
  },
  moveNodes(editor, options) {
    editor.moveNodes(options);
  },
  removeNodes(editor, options) {
    editor.removeNodes(options);
  },
  setNodes(editor, props2, options) {
    editor.setNodes(props2, options);
  },
  splitNodes(editor, options) {
    editor.splitNodes(options);
  },
  unsetNodes(editor, props2, options) {
    editor.unsetNodes(props2, options);
  },
  unwrapNodes(editor, options) {
    editor.unwrapNodes(options);
  },
  wrapNodes(editor, element, options) {
    editor.wrapNodes(element, options);
  }
};
var SelectionTransforms = {
  collapse(editor, options) {
    editor.collapse(options);
  },
  deselect(editor) {
    editor.deselect();
  },
  move(editor, options) {
    editor.move(options);
  },
  select(editor, target) {
    editor.select(target);
  },
  setPoint(editor, props2, options) {
    editor.setPoint(props2, options);
  },
  setSelection(editor, props2) {
    editor.setSelection(props2);
  }
};
var isDeepEqual = (node3, another) => {
  for (var key2 in node3) {
    var a4 = node3[key2];
    var b3 = another[key2];
    if (isPlainObject$9(a4) && isPlainObject$9(b3)) {
      if (!isDeepEqual(a4, b3)) return false;
    } else if (Array.isArray(a4) && Array.isArray(b3)) {
      if (a4.length !== b3.length) return false;
      for (var i3 = 0; i3 < a4.length; i3++) {
        if (a4[i3] !== b3[i3]) return false;
      }
    } else if (a4 !== b3) {
      return false;
    }
  }
  for (var _key in another) {
    if (node3[_key] === void 0 && another[_key] !== void 0) {
      return false;
    }
  }
  return true;
};
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i3;
  for (i3 = 0; i3 < sourceKeys.length; i3++) {
    key2 = sourceKeys[i3];
    if (excluded.indexOf(key2) >= 0) continue;
    target[key2] = source[key2];
  }
  return target;
}
function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$3(source, excluded);
  var key2, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key2 = sourceSymbolKeys[i3];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
var _excluded$4 = ["anchor", "focus"];
function ownKeys$d(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$d(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$d(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$d(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var Range = {
  edges(range2) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var {
      reverse = false
    } = options;
    var {
      anchor,
      focus: focus2
    } = range2;
    return Range.isBackward(range2) === reverse ? [anchor, focus2] : [focus2, anchor];
  },
  end(range2) {
    var [, end2] = Range.edges(range2);
    return end2;
  },
  equals(range2, another) {
    return Point.equals(range2.anchor, another.anchor) && Point.equals(range2.focus, another.focus);
  },
  includes(range2, target) {
    if (Range.isRange(target)) {
      if (Range.includes(range2, target.anchor) || Range.includes(range2, target.focus)) {
        return true;
      }
      var [rs, re2] = Range.edges(range2);
      var [ts, te2] = Range.edges(target);
      return Point.isBefore(rs, ts) && Point.isAfter(re2, te2);
    }
    var [start2, end2] = Range.edges(range2);
    var isAfterStart = false;
    var isBeforeEnd = false;
    if (Point.isPoint(target)) {
      isAfterStart = Point.compare(target, start2) >= 0;
      isBeforeEnd = Point.compare(target, end2) <= 0;
    } else {
      isAfterStart = Path.compare(target, start2.path) >= 0;
      isBeforeEnd = Path.compare(target, end2.path) <= 0;
    }
    return isAfterStart && isBeforeEnd;
  },
  intersection(range2, another) {
    var rest = _objectWithoutProperties$2(range2, _excluded$4);
    var [s1, e1] = Range.edges(range2);
    var [s22, e22] = Range.edges(another);
    var start2 = Point.isBefore(s1, s22) ? s22 : s1;
    var end2 = Point.isBefore(e1, e22) ? e1 : e22;
    if (Point.isBefore(end2, start2)) {
      return null;
    } else {
      return _objectSpread$d({
        anchor: start2,
        focus: end2
      }, rest);
    }
  },
  isBackward(range2) {
    var {
      anchor,
      focus: focus2
    } = range2;
    return Point.isAfter(anchor, focus2);
  },
  isCollapsed(range2) {
    var {
      anchor,
      focus: focus2
    } = range2;
    return Point.equals(anchor, focus2);
  },
  isExpanded(range2) {
    return !Range.isCollapsed(range2);
  },
  isForward(range2) {
    return !Range.isBackward(range2);
  },
  isRange(value) {
    return isPlainObject$9(value) && Point.isPoint(value.anchor) && Point.isPoint(value.focus);
  },
  *points(range2) {
    yield [range2.anchor, "anchor"];
    yield [range2.focus, "focus"];
  },
  start(range2) {
    var [start2] = Range.edges(range2);
    return start2;
  },
  transform(range2, op) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return produce(range2, (r2) => {
      if (r2 === null) {
        return null;
      }
      var {
        affinity = "inward"
      } = options;
      var affinityAnchor;
      var affinityFocus;
      if (affinity === "inward") {
        var isCollapsed = Range.isCollapsed(r2);
        if (Range.isForward(r2)) {
          affinityAnchor = "forward";
          affinityFocus = isCollapsed ? affinityAnchor : "backward";
        } else {
          affinityAnchor = "backward";
          affinityFocus = isCollapsed ? affinityAnchor : "forward";
        }
      } else if (affinity === "outward") {
        if (Range.isForward(r2)) {
          affinityAnchor = "backward";
          affinityFocus = "forward";
        } else {
          affinityAnchor = "forward";
          affinityFocus = "backward";
        }
      } else {
        affinityAnchor = affinity;
        affinityFocus = affinity;
      }
      var anchor = Point.transform(r2.anchor, op, {
        affinity: affinityAnchor
      });
      var focus2 = Point.transform(r2.focus, op, {
        affinity: affinityFocus
      });
      if (!anchor || !focus2) {
        return null;
      }
      r2.anchor = anchor;
      r2.focus = focus2;
    });
  }
};
var isElement = (value) => {
  return isPlainObject$9(value) && Node$1.isNodeList(value.children) && !Editor.isEditor(value);
};
var Element$3 = {
  isAncestor(value) {
    return isPlainObject$9(value) && Node$1.isNodeList(value.children);
  },
  isElement,
  isElementList(value) {
    return Array.isArray(value) && value.every((val) => Element$3.isElement(val));
  },
  isElementProps(props2) {
    return props2.children !== void 0;
  },
  isElementType: function isElementType(value, elementVal) {
    var elementKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "type";
    return isElement(value) && value[elementKey] === elementVal;
  },
  matches(element, props2) {
    for (var key2 in props2) {
      if (key2 === "children") {
        continue;
      }
      if (element[key2] !== props2[key2]) {
        return false;
      }
    }
    return true;
  }
};
var _excluded$3$1 = ["children"], _excluded2$3 = ["text"];
var IS_NODE_LIST_CACHE = /* @__PURE__ */ new WeakMap();
var Node$1 = {
  ancestor(root2, path3) {
    var node3 = Node$1.get(root2, path3);
    if (Text$1.isText(node3)) {
      throw new Error("Cannot get the ancestor node at path [".concat(path3, "] because it refers to a text node instead: ").concat(Scrubber.stringify(node3)));
    }
    return node3;
  },
  ancestors(root2, path3) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function* () {
      for (var p2 of Path.ancestors(path3, options)) {
        var n2 = Node$1.ancestor(root2, p2);
        var entry = [n2, p2];
        yield entry;
      }
    }();
  },
  child(root2, index2) {
    if (Text$1.isText(root2)) {
      throw new Error("Cannot get the child of a text node: ".concat(Scrubber.stringify(root2)));
    }
    var c3 = root2.children[index2];
    if (c3 == null) {
      throw new Error("Cannot get child at index `".concat(index2, "` in node: ").concat(Scrubber.stringify(root2)));
    }
    return c3;
  },
  children(root2, path3) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function* () {
      var {
        reverse = false
      } = options;
      var ancestor = Node$1.ancestor(root2, path3);
      var {
        children
      } = ancestor;
      var index2 = reverse ? children.length - 1 : 0;
      while (reverse ? index2 >= 0 : index2 < children.length) {
        var child = Node$1.child(ancestor, index2);
        var childPath = path3.concat(index2);
        yield [child, childPath];
        index2 = reverse ? index2 - 1 : index2 + 1;
      }
    }();
  },
  common(root2, path3, another) {
    var p2 = Path.common(path3, another);
    var n2 = Node$1.get(root2, p2);
    return [n2, p2];
  },
  descendant(root2, path3) {
    var node3 = Node$1.get(root2, path3);
    if (Editor.isEditor(node3)) {
      throw new Error("Cannot get the descendant node at path [".concat(path3, "] because it refers to the root editor node instead: ").concat(Scrubber.stringify(node3)));
    }
    return node3;
  },
  descendants(root2) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var [node3, path3] of Node$1.nodes(root2, options)) {
        if (path3.length !== 0) {
          yield [node3, path3];
        }
      }
    }();
  },
  elements(root2) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var [node3, path3] of Node$1.nodes(root2, options)) {
        if (Element$3.isElement(node3)) {
          yield [node3, path3];
        }
      }
    }();
  },
  extractProps(node3) {
    if (Element$3.isAncestor(node3)) {
      var properties2 = _objectWithoutProperties$2(node3, _excluded$3$1);
      return properties2;
    } else {
      var properties2 = _objectWithoutProperties$2(node3, _excluded2$3);
      return properties2;
    }
  },
  first(root2, path3) {
    var p2 = path3.slice();
    var n2 = Node$1.get(root2, p2);
    while (n2) {
      if (Text$1.isText(n2) || n2.children.length === 0) {
        break;
      } else {
        n2 = n2.children[0];
        p2.push(0);
      }
    }
    return [n2, p2];
  },
  fragment(root2, range2) {
    if (Text$1.isText(root2)) {
      throw new Error("Cannot get a fragment starting from a root text node: ".concat(Scrubber.stringify(root2)));
    }
    var newRoot = produce({
      children: root2.children
    }, (r2) => {
      var [start2, end2] = Range.edges(range2);
      var nodeEntries = Node$1.nodes(r2, {
        reverse: true,
        pass: (_ref) => {
          var [, path4] = _ref;
          return !Range.includes(range2, path4);
        }
      });
      for (var [, path3] of nodeEntries) {
        if (!Range.includes(range2, path3)) {
          var parent3 = Node$1.parent(r2, path3);
          var index2 = path3[path3.length - 1];
          parent3.children.splice(index2, 1);
        }
        if (Path.equals(path3, end2.path)) {
          var leaf3 = Node$1.leaf(r2, path3);
          leaf3.text = leaf3.text.slice(0, end2.offset);
        }
        if (Path.equals(path3, start2.path)) {
          var _leaf = Node$1.leaf(r2, path3);
          _leaf.text = _leaf.text.slice(start2.offset);
        }
      }
      if (Editor.isEditor(r2)) {
        r2.selection = null;
      }
    });
    return newRoot.children;
  },
  get(root2, path3) {
    var node3 = root2;
    for (var i3 = 0; i3 < path3.length; i3++) {
      var p2 = path3[i3];
      if (Text$1.isText(node3) || !node3.children[p2]) {
        throw new Error("Cannot find a descendant at path [".concat(path3, "] in node: ").concat(Scrubber.stringify(root2)));
      }
      node3 = node3.children[p2];
    }
    return node3;
  },
  has(root2, path3) {
    var node3 = root2;
    for (var i3 = 0; i3 < path3.length; i3++) {
      var p2 = path3[i3];
      if (Text$1.isText(node3) || !node3.children[p2]) {
        return false;
      }
      node3 = node3.children[p2];
    }
    return true;
  },
  isNode(value) {
    return Text$1.isText(value) || Element$3.isElement(value) || Editor.isEditor(value);
  },
  isNodeList(value) {
    if (!Array.isArray(value)) {
      return false;
    }
    var cachedResult = IS_NODE_LIST_CACHE.get(value);
    if (cachedResult !== void 0) {
      return cachedResult;
    }
    var isNodeList = value.every((val) => Node$1.isNode(val));
    IS_NODE_LIST_CACHE.set(value, isNodeList);
    return isNodeList;
  },
  last(root2, path3) {
    var p2 = path3.slice();
    var n2 = Node$1.get(root2, p2);
    while (n2) {
      if (Text$1.isText(n2) || n2.children.length === 0) {
        break;
      } else {
        var i3 = n2.children.length - 1;
        n2 = n2.children[i3];
        p2.push(i3);
      }
    }
    return [n2, p2];
  },
  leaf(root2, path3) {
    var node3 = Node$1.get(root2, path3);
    if (!Text$1.isText(node3)) {
      throw new Error("Cannot get the leaf node at path [".concat(path3, "] because it refers to a non-leaf node: ").concat(Scrubber.stringify(node3)));
    }
    return node3;
  },
  levels(root2, path3) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function* () {
      for (var p2 of Path.levels(path3, options)) {
        var n2 = Node$1.get(root2, p2);
        yield [n2, p2];
      }
    }();
  },
  matches(node3, props2) {
    return Element$3.isElement(node3) && Element$3.isElementProps(props2) && Element$3.matches(node3, props2) || Text$1.isText(node3) && Text$1.isTextProps(props2) && Text$1.matches(node3, props2);
  },
  nodes(root2) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      var {
        pass,
        reverse = false
      } = options;
      var {
        from: from2 = [],
        to: to2
      } = options;
      var visited = /* @__PURE__ */ new Set();
      var p2 = [];
      var n2 = root2;
      while (true) {
        if (to2 && (reverse ? Path.isBefore(p2, to2) : Path.isAfter(p2, to2))) {
          break;
        }
        if (!visited.has(n2)) {
          yield [n2, p2];
        }
        if (!visited.has(n2) && !Text$1.isText(n2) && n2.children.length !== 0 && (pass == null || pass([n2, p2]) === false)) {
          visited.add(n2);
          var nextIndex = reverse ? n2.children.length - 1 : 0;
          if (Path.isAncestor(p2, from2)) {
            nextIndex = from2[p2.length];
          }
          p2 = p2.concat(nextIndex);
          n2 = Node$1.get(root2, p2);
          continue;
        }
        if (p2.length === 0) {
          break;
        }
        if (!reverse) {
          var newPath = Path.next(p2);
          if (Node$1.has(root2, newPath)) {
            p2 = newPath;
            n2 = Node$1.get(root2, p2);
            continue;
          }
        }
        if (reverse && p2[p2.length - 1] !== 0) {
          var _newPath = Path.previous(p2);
          p2 = _newPath;
          n2 = Node$1.get(root2, p2);
          continue;
        }
        p2 = Path.parent(p2);
        n2 = Node$1.get(root2, p2);
        visited.add(n2);
      }
    }();
  },
  parent(root2, path3) {
    var parentPath = Path.parent(path3);
    var p2 = Node$1.get(root2, parentPath);
    if (Text$1.isText(p2)) {
      throw new Error("Cannot get the parent of path [".concat(path3, "] because it does not exist in the root."));
    }
    return p2;
  },
  string(node3) {
    if (Text$1.isText(node3)) {
      return node3.text;
    } else {
      return node3.children.map(Node$1.string).join("");
    }
  },
  texts(root2) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var [node3, path3] of Node$1.nodes(root2, options)) {
        if (Text$1.isText(node3)) {
          yield [node3, path3];
        }
      }
    }();
  }
};
function ownKeys$c(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$c(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$c(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$c(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var Operation = {
  isNodeOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith("_node");
  },
  isOperation(value) {
    if (!isPlainObject$9(value)) {
      return false;
    }
    switch (value.type) {
      case "insert_node":
        return Path.isPath(value.path) && Node$1.isNode(value.node);
      case "insert_text":
        return typeof value.offset === "number" && typeof value.text === "string" && Path.isPath(value.path);
      case "merge_node":
        return typeof value.position === "number" && Path.isPath(value.path) && isPlainObject$9(value.properties);
      case "move_node":
        return Path.isPath(value.path) && Path.isPath(value.newPath);
      case "remove_node":
        return Path.isPath(value.path) && Node$1.isNode(value.node);
      case "remove_text":
        return typeof value.offset === "number" && typeof value.text === "string" && Path.isPath(value.path);
      case "set_node":
        return Path.isPath(value.path) && isPlainObject$9(value.properties) && isPlainObject$9(value.newProperties);
      case "set_selection":
        return value.properties === null && Range.isRange(value.newProperties) || value.newProperties === null && Range.isRange(value.properties) || isPlainObject$9(value.properties) && isPlainObject$9(value.newProperties);
      case "split_node":
        return Path.isPath(value.path) && typeof value.position === "number" && isPlainObject$9(value.properties);
      default:
        return false;
    }
  },
  isOperationList(value) {
    return Array.isArray(value) && value.every((val) => Operation.isOperation(val));
  },
  isSelectionOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith("_selection");
  },
  isTextOperation(value) {
    return Operation.isOperation(value) && value.type.endsWith("_text");
  },
  inverse(op) {
    switch (op.type) {
      case "insert_node": {
        return _objectSpread$c(_objectSpread$c({}, op), {}, {
          type: "remove_node"
        });
      }
      case "insert_text": {
        return _objectSpread$c(_objectSpread$c({}, op), {}, {
          type: "remove_text"
        });
      }
      case "merge_node": {
        return _objectSpread$c(_objectSpread$c({}, op), {}, {
          type: "split_node",
          path: Path.previous(op.path)
        });
      }
      case "move_node": {
        var {
          newPath,
          path: path3
        } = op;
        if (Path.equals(newPath, path3)) {
          return op;
        }
        if (Path.isSibling(path3, newPath)) {
          return _objectSpread$c(_objectSpread$c({}, op), {}, {
            path: newPath,
            newPath: path3
          });
        }
        var inversePath = Path.transform(path3, op);
        var inverseNewPath = Path.transform(Path.next(path3), op);
        return _objectSpread$c(_objectSpread$c({}, op), {}, {
          path: inversePath,
          newPath: inverseNewPath
        });
      }
      case "remove_node": {
        return _objectSpread$c(_objectSpread$c({}, op), {}, {
          type: "insert_node"
        });
      }
      case "remove_text": {
        return _objectSpread$c(_objectSpread$c({}, op), {}, {
          type: "insert_text"
        });
      }
      case "set_node": {
        var {
          properties: properties2,
          newProperties
        } = op;
        return _objectSpread$c(_objectSpread$c({}, op), {}, {
          properties: newProperties,
          newProperties: properties2
        });
      }
      case "set_selection": {
        var {
          properties: _properties,
          newProperties: _newProperties
        } = op;
        if (_properties == null) {
          return _objectSpread$c(_objectSpread$c({}, op), {}, {
            properties: _newProperties,
            newProperties: null
          });
        } else if (_newProperties == null) {
          return _objectSpread$c(_objectSpread$c({}, op), {}, {
            properties: null,
            newProperties: _properties
          });
        } else {
          return _objectSpread$c(_objectSpread$c({}, op), {}, {
            properties: _newProperties,
            newProperties: _properties
          });
        }
      }
      case "split_node": {
        return _objectSpread$c(_objectSpread$c({}, op), {}, {
          type: "merge_node",
          path: Path.next(op.path)
        });
      }
    }
  }
};
var IS_EDITOR_CACHE = /* @__PURE__ */ new WeakMap();
var isEditor = (value) => {
  var cachedIsEditor = IS_EDITOR_CACHE.get(value);
  if (cachedIsEditor !== void 0) {
    return cachedIsEditor;
  }
  if (!isPlainObject$9(value)) {
    return false;
  }
  var isEditor2 = typeof value.addMark === "function" && typeof value.apply === "function" && typeof value.deleteFragment === "function" && typeof value.insertBreak === "function" && typeof value.insertSoftBreak === "function" && typeof value.insertFragment === "function" && typeof value.insertNode === "function" && typeof value.insertText === "function" && typeof value.isElementReadOnly === "function" && typeof value.isInline === "function" && typeof value.isSelectable === "function" && typeof value.isVoid === "function" && typeof value.normalizeNode === "function" && typeof value.onChange === "function" && typeof value.removeMark === "function" && typeof value.getDirtyPaths === "function" && (value.marks === null || isPlainObject$9(value.marks)) && (value.selection === null || Range.isRange(value.selection)) && Node$1.isNodeList(value.children) && Operation.isOperationList(value.operations);
  IS_EDITOR_CACHE.set(value, isEditor2);
  return isEditor2;
};
var Editor = {
  above(editor, options) {
    return editor.above(options);
  },
  addMark(editor, key2, value) {
    editor.addMark(key2, value);
  },
  after(editor, at2, options) {
    return editor.after(at2, options);
  },
  before(editor, at2, options) {
    return editor.before(at2, options);
  },
  deleteBackward(editor) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var {
      unit = "character"
    } = options;
    editor.deleteBackward(unit);
  },
  deleteForward(editor) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var {
      unit = "character"
    } = options;
    editor.deleteForward(unit);
  },
  deleteFragment(editor, options) {
    editor.deleteFragment(options);
  },
  edges(editor, at2) {
    return editor.edges(at2);
  },
  elementReadOnly(editor) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return editor.elementReadOnly(options);
  },
  end(editor, at2) {
    return editor.end(at2);
  },
  first(editor, at2) {
    return editor.first(at2);
  },
  fragment(editor, at2) {
    return editor.fragment(at2);
  },
  hasBlocks(editor, element) {
    return editor.hasBlocks(element);
  },
  hasInlines(editor, element) {
    return editor.hasInlines(element);
  },
  hasPath(editor, path3) {
    return editor.hasPath(path3);
  },
  hasTexts(editor, element) {
    return editor.hasTexts(element);
  },
  insertBreak(editor) {
    editor.insertBreak();
  },
  insertFragment(editor, fragment2, options) {
    editor.insertFragment(fragment2, options);
  },
  insertNode(editor, node3) {
    editor.insertNode(node3);
  },
  insertSoftBreak(editor) {
    editor.insertSoftBreak();
  },
  insertText(editor, text) {
    editor.insertText(text);
  },
  isBlock(editor, value) {
    return editor.isBlock(value);
  },
  isEdge(editor, point3, at2) {
    return editor.isEdge(point3, at2);
  },
  isEditor(value) {
    return isEditor(value);
  },
  isElementReadOnly(editor, element) {
    return editor.isElementReadOnly(element);
  },
  isEmpty(editor, element) {
    return editor.isEmpty(element);
  },
  isEnd(editor, point3, at2) {
    return editor.isEnd(point3, at2);
  },
  isInline(editor, value) {
    return editor.isInline(value);
  },
  isNormalizing(editor) {
    return editor.isNormalizing();
  },
  isSelectable(editor, value) {
    return editor.isSelectable(value);
  },
  isStart(editor, point3, at2) {
    return editor.isStart(point3, at2);
  },
  isVoid(editor, value) {
    return editor.isVoid(value);
  },
  last(editor, at2) {
    return editor.last(at2);
  },
  leaf(editor, at2, options) {
    return editor.leaf(at2, options);
  },
  levels(editor, options) {
    return editor.levels(options);
  },
  marks(editor) {
    return editor.getMarks();
  },
  next(editor, options) {
    return editor.next(options);
  },
  node(editor, at2, options) {
    return editor.node(at2, options);
  },
  nodes(editor, options) {
    return editor.nodes(options);
  },
  normalize(editor, options) {
    editor.normalize(options);
  },
  parent(editor, at2, options) {
    return editor.parent(at2, options);
  },
  path(editor, at2, options) {
    return editor.path(at2, options);
  },
  pathRef(editor, path3, options) {
    return editor.pathRef(path3, options);
  },
  pathRefs(editor) {
    return editor.pathRefs();
  },
  point(editor, at2, options) {
    return editor.point(at2, options);
  },
  pointRef(editor, point3, options) {
    return editor.pointRef(point3, options);
  },
  pointRefs(editor) {
    return editor.pointRefs();
  },
  positions(editor, options) {
    return editor.positions(options);
  },
  previous(editor, options) {
    return editor.previous(options);
  },
  range(editor, at2, to2) {
    return editor.range(at2, to2);
  },
  rangeRef(editor, range2, options) {
    return editor.rangeRef(range2, options);
  },
  rangeRefs(editor) {
    return editor.rangeRefs();
  },
  removeMark(editor, key2) {
    editor.removeMark(key2);
  },
  setNormalizing(editor, isNormalizing2) {
    editor.setNormalizing(isNormalizing2);
  },
  start(editor, at2) {
    return editor.start(at2);
  },
  string(editor, at2, options) {
    return editor.string(at2, options);
  },
  unhangRange(editor, range2, options) {
    return editor.unhangRange(range2, options);
  },
  void(editor, options) {
    return editor.void(options);
  },
  withoutNormalizing(editor, fn2) {
    editor.withoutNormalizing(fn2);
  },
  shouldMergeNodesRemovePrevNode: (editor, prevNode, curNode) => {
    return editor.shouldMergeNodesRemovePrevNode(prevNode, curNode);
  }
};
var Span = {
  isSpan(value) {
    return Array.isArray(value) && value.length === 2 && value.every(Path.isPath);
  }
};
function ownKeys$b(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$b(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$b(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$b(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var Point = {
  compare(point3, another) {
    var result2 = Path.compare(point3.path, another.path);
    if (result2 === 0) {
      if (point3.offset < another.offset) return -1;
      if (point3.offset > another.offset) return 1;
      return 0;
    }
    return result2;
  },
  isAfter(point3, another) {
    return Point.compare(point3, another) === 1;
  },
  isBefore(point3, another) {
    return Point.compare(point3, another) === -1;
  },
  equals(point3, another) {
    return point3.offset === another.offset && Path.equals(point3.path, another.path);
  },
  isPoint(value) {
    return isPlainObject$9(value) && typeof value.offset === "number" && Path.isPath(value.path);
  },
  transform(point3, op) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return produce(point3, (p2) => {
      if (p2 === null) {
        return null;
      }
      var {
        affinity = "forward"
      } = options;
      var {
        path: path3,
        offset: offset2
      } = p2;
      switch (op.type) {
        case "insert_node":
        case "move_node": {
          p2.path = Path.transform(path3, op, options);
          break;
        }
        case "insert_text": {
          if (Path.equals(op.path, path3) && (op.offset < offset2 || op.offset === offset2 && affinity === "forward")) {
            p2.offset += op.text.length;
          }
          break;
        }
        case "merge_node": {
          if (Path.equals(op.path, path3)) {
            p2.offset += op.position;
          }
          p2.path = Path.transform(path3, op, options);
          break;
        }
        case "remove_text": {
          if (Path.equals(op.path, path3) && op.offset <= offset2) {
            p2.offset -= Math.min(offset2 - op.offset, op.text.length);
          }
          break;
        }
        case "remove_node": {
          if (Path.equals(op.path, path3) || Path.isAncestor(op.path, path3)) {
            return null;
          }
          p2.path = Path.transform(path3, op, options);
          break;
        }
        case "split_node": {
          if (Path.equals(op.path, path3)) {
            if (op.position === offset2 && affinity == null) {
              return null;
            } else if (op.position < offset2 || op.position === offset2 && affinity === "forward") {
              p2.offset -= op.position;
              p2.path = Path.transform(path3, op, _objectSpread$b(_objectSpread$b({}, options), {}, {
                affinity: "forward"
              }));
            }
          } else {
            p2.path = Path.transform(path3, op, options);
          }
          break;
        }
      }
    });
  }
};
var _scrubber = void 0;
var Scrubber = {
  setScrubber(scrubber) {
    _scrubber = scrubber;
  },
  stringify(value) {
    return JSON.stringify(value, _scrubber);
  }
};
var _excluded$2$1 = ["text"], _excluded2$2 = ["anchor", "focus"];
function ownKeys$a(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$a(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$a(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$a(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var Text$1 = {
  equals(text, another) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var {
      loose = false
    } = options;
    function omitText(obj) {
      var rest = _objectWithoutProperties$2(obj, _excluded$2$1);
      return rest;
    }
    return isDeepEqual(loose ? omitText(text) : text, loose ? omitText(another) : another);
  },
  isText(value) {
    return isPlainObject$9(value) && typeof value.text === "string";
  },
  isTextList(value) {
    return Array.isArray(value) && value.every((val) => Text$1.isText(val));
  },
  isTextProps(props2) {
    return props2.text !== void 0;
  },
  matches(text, props2) {
    for (var key2 in props2) {
      if (key2 === "text") {
        continue;
      }
      if (!text.hasOwnProperty(key2) || text[key2] !== props2[key2]) {
        return false;
      }
    }
    return true;
  },
  decorations(node3, decorations) {
    var leaves = [_objectSpread$a({}, node3)];
    for (var dec of decorations) {
      var rest = _objectWithoutProperties$2(dec, _excluded2$2);
      var [start2, end2] = Range.edges(dec);
      var next3 = [];
      var leafEnd = 0;
      var decorationStart = start2.offset;
      var decorationEnd = end2.offset;
      for (var leaf3 of leaves) {
        var {
          length
        } = leaf3.text;
        var leafStart = leafEnd;
        leafEnd += length;
        if (decorationStart <= leafStart && leafEnd <= decorationEnd) {
          Object.assign(leaf3, rest);
          next3.push(leaf3);
          continue;
        }
        if (decorationStart !== decorationEnd && (decorationStart === leafEnd || decorationEnd === leafStart) || decorationStart > leafEnd || decorationEnd < leafStart || decorationEnd === leafStart && leafStart !== 0) {
          next3.push(leaf3);
          continue;
        }
        var middle = leaf3;
        var before3 = void 0;
        var after3 = void 0;
        if (decorationEnd < leafEnd) {
          var off = decorationEnd - leafStart;
          after3 = _objectSpread$a(_objectSpread$a({}, middle), {}, {
            text: middle.text.slice(off)
          });
          middle = _objectSpread$a(_objectSpread$a({}, middle), {}, {
            text: middle.text.slice(0, off)
          });
        }
        if (decorationStart > leafStart) {
          var _off = decorationStart - leafStart;
          before3 = _objectSpread$a(_objectSpread$a({}, middle), {}, {
            text: middle.text.slice(0, _off)
          });
          middle = _objectSpread$a(_objectSpread$a({}, middle), {}, {
            text: middle.text.slice(_off)
          });
        }
        Object.assign(middle, rest);
        if (before3) {
          next3.push(before3);
        }
        next3.push(middle);
        if (after3) {
          next3.push(after3);
        }
      }
      leaves = next3;
    }
    return leaves;
  }
};
var getDefaultInsertLocation = (editor) => {
  if (editor.selection) {
    return editor.selection;
  } else if (editor.children.length > 0) {
    return Editor.end(editor, []);
  } else {
    return [0];
  }
};
var matchPath = (editor, path3) => {
  var [node3] = Editor.node(editor, path3);
  return (n2) => n2 === node3;
};
var getCharacterDistance = function getCharacterDistance2(str) {
  var isRTL = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var isLTR = !isRTL;
  var codepoints = isRTL ? codepointsIteratorRTL(str) : str;
  var left = CodepointType.None;
  var right = CodepointType.None;
  var distance = 0;
  var gb11 = null;
  var gb12Or13 = null;
  for (var char of codepoints) {
    var code2 = char.codePointAt(0);
    if (!code2) break;
    var type2 = getCodepointType(char, code2);
    [left, right] = isLTR ? [right, type2] : [type2, left];
    if (intersects(left, CodepointType.ZWJ) && intersects(right, CodepointType.ExtPict)) {
      if (isLTR) {
        gb11 = endsWithEmojiZWJ(str.substring(0, distance));
      } else {
        gb11 = endsWithEmojiZWJ(str.substring(0, str.length - distance));
      }
      if (!gb11) break;
    }
    if (intersects(left, CodepointType.RI) && intersects(right, CodepointType.RI)) {
      if (gb12Or13 !== null) {
        gb12Or13 = !gb12Or13;
      } else {
        if (isLTR) {
          gb12Or13 = true;
        } else {
          gb12Or13 = endsWithOddNumberOfRIs(str.substring(0, str.length - distance));
        }
      }
      if (!gb12Or13) break;
    }
    if (left !== CodepointType.None && right !== CodepointType.None && isBoundaryPair(left, right)) {
      break;
    }
    distance += char.length;
  }
  return distance || 1;
};
var SPACE = /\s/;
var PUNCTUATION = /[\u002B\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
var CHAMELEON = /['\u2018\u2019]/;
var getWordDistance = function getWordDistance2(text) {
  var isRTL = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var dist2 = 0;
  var started = false;
  while (text.length > 0) {
    var charDist = getCharacterDistance(text, isRTL);
    var [char, remaining] = splitByCharacterDistance(text, charDist, isRTL);
    if (isWordCharacter$1(char, remaining, isRTL)) {
      started = true;
      dist2 += charDist;
    } else if (!started) {
      dist2 += charDist;
    } else {
      break;
    }
    text = remaining;
  }
  return dist2;
};
var splitByCharacterDistance = (str, dist2, isRTL) => {
  if (isRTL) {
    var at2 = str.length - dist2;
    return [str.slice(at2, str.length), str.slice(0, at2)];
  }
  return [str.slice(0, dist2), str.slice(dist2)];
};
var isWordCharacter$1 = function isWordCharacter(char, remaining) {
  var isRTL = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  if (SPACE.test(char)) {
    return false;
  }
  if (CHAMELEON.test(char)) {
    var charDist = getCharacterDistance(remaining, isRTL);
    var [nextChar, nextRemaining] = splitByCharacterDistance(remaining, charDist, isRTL);
    if (isWordCharacter(nextChar, nextRemaining, isRTL)) {
      return true;
    }
  }
  if (PUNCTUATION.test(char)) {
    return false;
  }
  return true;
};
var codepointsIteratorRTL = function* codepointsIteratorRTL2(str) {
  var end2 = str.length - 1;
  for (var i3 = 0; i3 < str.length; i3++) {
    var char1 = str.charAt(end2 - i3);
    if (isLowSurrogate(char1.charCodeAt(0))) {
      var char2 = str.charAt(end2 - i3 - 1);
      if (isHighSurrogate(char2.charCodeAt(0))) {
        yield char2 + char1;
        i3++;
        continue;
      }
    }
    yield char1;
  }
};
var isHighSurrogate = (charCode) => {
  return charCode >= 55296 && charCode <= 56319;
};
var isLowSurrogate = (charCode) => {
  return charCode >= 56320 && charCode <= 57343;
};
var CodepointType;
(function(CodepointType2) {
  CodepointType2[CodepointType2["None"] = 0] = "None";
  CodepointType2[CodepointType2["Extend"] = 1] = "Extend";
  CodepointType2[CodepointType2["ZWJ"] = 2] = "ZWJ";
  CodepointType2[CodepointType2["RI"] = 4] = "RI";
  CodepointType2[CodepointType2["Prepend"] = 8] = "Prepend";
  CodepointType2[CodepointType2["SpacingMark"] = 16] = "SpacingMark";
  CodepointType2[CodepointType2["L"] = 32] = "L";
  CodepointType2[CodepointType2["V"] = 64] = "V";
  CodepointType2[CodepointType2["T"] = 128] = "T";
  CodepointType2[CodepointType2["LV"] = 256] = "LV";
  CodepointType2[CodepointType2["LVT"] = 512] = "LVT";
  CodepointType2[CodepointType2["ExtPict"] = 1024] = "ExtPict";
  CodepointType2[CodepointType2["Any"] = 2048] = "Any";
})(CodepointType || (CodepointType = {}));
var reExtend = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/;
var rePrepend = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/;
var reSpacingMark = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/;
var reL = /^[\u1100-\u115F\uA960-\uA97C]$/;
var reV = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/;
var reT = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/;
var reLV = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/;
var reLVT = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/;
var reExtPict = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/;
var getCodepointType = (char, code2) => {
  var type2 = CodepointType.Any;
  if (char.search(reExtend) !== -1) {
    type2 |= CodepointType.Extend;
  }
  if (code2 === 8205) {
    type2 |= CodepointType.ZWJ;
  }
  if (code2 >= 127462 && code2 <= 127487) {
    type2 |= CodepointType.RI;
  }
  if (char.search(rePrepend) !== -1) {
    type2 |= CodepointType.Prepend;
  }
  if (char.search(reSpacingMark) !== -1) {
    type2 |= CodepointType.SpacingMark;
  }
  if (char.search(reL) !== -1) {
    type2 |= CodepointType.L;
  }
  if (char.search(reV) !== -1) {
    type2 |= CodepointType.V;
  }
  if (char.search(reT) !== -1) {
    type2 |= CodepointType.T;
  }
  if (char.search(reLV) !== -1) {
    type2 |= CodepointType.LV;
  }
  if (char.search(reLVT) !== -1) {
    type2 |= CodepointType.LVT;
  }
  if (char.search(reExtPict) !== -1) {
    type2 |= CodepointType.ExtPict;
  }
  return type2;
};
function intersects(x3, y4) {
  return (x3 & y4) !== 0;
}
var NonBoundaryPairs = [
  // GB6
  [CodepointType.L, CodepointType.L | CodepointType.V | CodepointType.LV | CodepointType.LVT],
  // GB7
  [CodepointType.LV | CodepointType.V, CodepointType.V | CodepointType.T],
  // GB8
  [CodepointType.LVT | CodepointType.T, CodepointType.T],
  // GB9
  [CodepointType.Any, CodepointType.Extend | CodepointType.ZWJ],
  // GB9a
  [CodepointType.Any, CodepointType.SpacingMark],
  // GB9b
  [CodepointType.Prepend, CodepointType.Any],
  // GB11
  [CodepointType.ZWJ, CodepointType.ExtPict],
  // GB12 and GB13
  [CodepointType.RI, CodepointType.RI]
];
function isBoundaryPair(left, right) {
  return NonBoundaryPairs.findIndex((r2) => intersects(left, r2[0]) && intersects(right, r2[1])) === -1;
}
var endingEmojiZWJ = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/;
var endsWithEmojiZWJ = (str) => {
  return str.search(endingEmojiZWJ) !== -1;
};
var endingRIs = /(?:\uD83C[\uDDE6-\uDDFF])+$/g;
var endsWithOddNumberOfRIs = (str) => {
  var match5 = str.match(endingRIs);
  if (match5 === null) {
    return false;
  } else {
    var numRIs = match5[0].length / 2;
    return numRIs % 2 === 1;
  }
};
var TextTransforms = {
  delete(editor, options) {
    editor.delete(options);
  },
  insertFragment(editor, fragment2, options) {
    editor.insertFragment(fragment2, options);
  },
  insertText(editor, text) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    Editor.withoutNormalizing(editor, () => {
      var {
        voids = false
      } = options;
      var {
        at: at2 = getDefaultInsertLocation(editor)
      } = options;
      if (Path.isPath(at2)) {
        at2 = Editor.range(editor, at2);
      }
      if (Range.isRange(at2)) {
        if (Range.isCollapsed(at2)) {
          at2 = at2.anchor;
        } else {
          var end2 = Range.end(at2);
          if (!voids && Editor.void(editor, {
            at: end2
          })) {
            return;
          }
          var start2 = Range.start(at2);
          var startRef = Editor.pointRef(editor, start2);
          var endRef = Editor.pointRef(editor, end2);
          Transforms.delete(editor, {
            at: at2,
            voids
          });
          var startPoint = startRef.unref();
          var endPoint = endRef.unref();
          at2 = startPoint || endPoint;
          Transforms.setSelection(editor, {
            anchor: at2,
            focus: at2
          });
        }
      }
      if (!voids && Editor.void(editor, {
        at: at2
      }) || Editor.elementReadOnly(editor, {
        at: at2
      })) {
        return;
      }
      var {
        path: path3,
        offset: offset2
      } = at2;
      if (text.length > 0) editor.apply({
        type: "insert_text",
        path: path3,
        offset: offset2,
        text
      });
    });
  }
};
function ownKeys$9(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$9(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$9(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$9(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var Transforms = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, GeneralTransforms), NodeTransforms), SelectionTransforms), TextTransforms);
var BATCHING_DIRTY_PATHS = /* @__PURE__ */ new WeakMap();
var isBatchingDirtyPaths = (editor) => {
  return BATCHING_DIRTY_PATHS.get(editor) || false;
};
var batchDirtyPaths = (editor, fn2, update2) => {
  var value = BATCHING_DIRTY_PATHS.get(editor) || false;
  BATCHING_DIRTY_PATHS.set(editor, true);
  try {
    fn2();
    update2();
  } finally {
    BATCHING_DIRTY_PATHS.set(editor, value);
  }
};
function updateDirtyPaths(editor, newDirtyPaths, transform2) {
  var oldDirtyPaths = DIRTY_PATHS.get(editor) || [];
  var oldDirtyPathKeys = DIRTY_PATH_KEYS.get(editor) || /* @__PURE__ */ new Set();
  var dirtyPaths;
  var dirtyPathKeys;
  var add2 = (path4) => {
    if (path4) {
      var key2 = path4.join(",");
      if (!dirtyPathKeys.has(key2)) {
        dirtyPathKeys.add(key2);
        dirtyPaths.push(path4);
      }
    }
  };
  if (transform2) {
    dirtyPaths = [];
    dirtyPathKeys = /* @__PURE__ */ new Set();
    for (var path3 of oldDirtyPaths) {
      var newPath = transform2(path3);
      add2(newPath);
    }
  } else {
    dirtyPaths = oldDirtyPaths;
    dirtyPathKeys = oldDirtyPathKeys;
  }
  for (var _path of newDirtyPaths) {
    add2(_path);
  }
  DIRTY_PATHS.set(editor, dirtyPaths);
  DIRTY_PATH_KEYS.set(editor, dirtyPathKeys);
}
var apply$3 = (editor, op) => {
  for (var ref2 of Editor.pathRefs(editor)) {
    PathRef.transform(ref2, op);
  }
  for (var _ref of Editor.pointRefs(editor)) {
    PointRef.transform(_ref, op);
  }
  for (var _ref2 of Editor.rangeRefs(editor)) {
    RangeRef.transform(_ref2, op);
  }
  if (!isBatchingDirtyPaths(editor)) {
    var transform2 = Path.operationCanTransformPath(op) ? (p2) => Path.transform(p2, op) : void 0;
    updateDirtyPaths(editor, editor.getDirtyPaths(op), transform2);
  }
  Transforms.transform(editor, op);
  editor.operations.push(op);
  Editor.normalize(editor, {
    operation: op
  });
  if (op.type === "set_selection") {
    editor.marks = null;
  }
  if (!FLUSHING.get(editor)) {
    FLUSHING.set(editor, true);
    Promise.resolve().then(() => {
      FLUSHING.set(editor, false);
      editor.onChange({
        operation: op
      });
      editor.operations = [];
    });
  }
};
var getDirtyPaths = (editor, op) => {
  switch (op.type) {
    case "insert_text":
    case "remove_text":
    case "set_node": {
      var {
        path: path3
      } = op;
      return Path.levels(path3);
    }
    case "insert_node": {
      var {
        node: node3,
        path: _path
      } = op;
      var levels2 = Path.levels(_path);
      var descendants = Text$1.isText(node3) ? [] : Array.from(Node$1.nodes(node3), (_ref) => {
        var [, p3] = _ref;
        return _path.concat(p3);
      });
      return [...levels2, ...descendants];
    }
    case "merge_node": {
      var {
        path: _path2
      } = op;
      var ancestors = Path.ancestors(_path2);
      var previousPath = Path.previous(_path2);
      return [...ancestors, previousPath];
    }
    case "move_node": {
      var {
        path: _path3,
        newPath
      } = op;
      if (Path.equals(_path3, newPath)) {
        return [];
      }
      var oldAncestors = [];
      var newAncestors = [];
      for (var ancestor of Path.ancestors(_path3)) {
        var p2 = Path.transform(ancestor, op);
        oldAncestors.push(p2);
      }
      for (var _ancestor of Path.ancestors(newPath)) {
        var _p = Path.transform(_ancestor, op);
        newAncestors.push(_p);
      }
      var newParent = newAncestors[newAncestors.length - 1];
      var newIndex = newPath[newPath.length - 1];
      var resultPath = newParent.concat(newIndex);
      return [...oldAncestors, ...newAncestors, resultPath];
    }
    case "remove_node": {
      var {
        path: _path4
      } = op;
      var _ancestors = Path.ancestors(_path4);
      return [..._ancestors];
    }
    case "split_node": {
      var {
        path: _path5
      } = op;
      var _levels = Path.levels(_path5);
      var nextPath = Path.next(_path5);
      return [..._levels, nextPath];
    }
    default: {
      return [];
    }
  }
};
var getFragment = (editor) => {
  var {
    selection
  } = editor;
  if (selection) {
    return Node$1.fragment(editor, selection);
  }
  return [];
};
var normalizeNode = (editor, entry) => {
  var [node3, path3] = entry;
  if (Text$1.isText(node3)) {
    return;
  }
  if (Element$3.isElement(node3) && node3.children.length === 0) {
    var child = {
      text: ""
    };
    Transforms.insertNodes(editor, child, {
      at: path3.concat(0),
      voids: true
    });
    return;
  }
  var shouldHaveInlines = Editor.isEditor(node3) ? false : Element$3.isElement(node3) && (editor.isInline(node3) || node3.children.length === 0 || Text$1.isText(node3.children[0]) || editor.isInline(node3.children[0]));
  var n2 = 0;
  for (var i3 = 0; i3 < node3.children.length; i3++, n2++) {
    var currentNode = Node$1.get(editor, path3);
    if (Text$1.isText(currentNode)) continue;
    var _child = currentNode.children[n2];
    var prev = currentNode.children[n2 - 1];
    var isLast = i3 === node3.children.length - 1;
    var isInlineOrText = Text$1.isText(_child) || Element$3.isElement(_child) && editor.isInline(_child);
    if (isInlineOrText !== shouldHaveInlines) {
      Transforms.removeNodes(editor, {
        at: path3.concat(n2),
        voids: true
      });
      n2--;
    } else if (Element$3.isElement(_child)) {
      if (editor.isInline(_child)) {
        if (prev == null || !Text$1.isText(prev)) {
          var newChild = {
            text: ""
          };
          Transforms.insertNodes(editor, newChild, {
            at: path3.concat(n2),
            voids: true
          });
          n2++;
        } else if (isLast) {
          var _newChild = {
            text: ""
          };
          Transforms.insertNodes(editor, _newChild, {
            at: path3.concat(n2 + 1),
            voids: true
          });
          n2++;
        }
      }
    } else {
      if (!Text$1.isText(_child) && !("children" in _child)) {
        var elementChild = _child;
        elementChild.children = [];
      }
      if (prev != null && Text$1.isText(prev)) {
        if (Text$1.equals(_child, prev, {
          loose: true
        })) {
          Transforms.mergeNodes(editor, {
            at: path3.concat(n2),
            voids: true
          });
          n2--;
        } else if (prev.text === "") {
          Transforms.removeNodes(editor, {
            at: path3.concat(n2 - 1),
            voids: true
          });
          n2--;
        } else if (_child.text === "") {
          Transforms.removeNodes(editor, {
            at: path3.concat(n2),
            voids: true
          });
          n2--;
        }
      }
    }
  }
};
var shouldNormalize = (editor, _ref) => {
  var {
    iteration,
    initialDirtyPathsLength
  } = _ref;
  var maxIterations = initialDirtyPathsLength * 42;
  if (iteration > maxIterations) {
    throw new Error("Could not completely normalize the editor after ".concat(maxIterations, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state."));
  }
  return true;
};
var above = function above2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var {
    voids = false,
    mode = "lowest",
    at: at2 = editor.selection,
    match: match5
  } = options;
  if (!at2) {
    return;
  }
  var path3 = Editor.path(editor, at2);
  var reverse = mode === "lowest";
  for (var [n2, p2] of Editor.levels(editor, {
    at: path3,
    voids,
    match: match5,
    reverse
  })) {
    if (Text$1.isText(n2)) continue;
    if (Range.isRange(at2)) {
      if (Path.isAncestor(p2, at2.anchor.path) && Path.isAncestor(p2, at2.focus.path)) {
        return [n2, p2];
      }
    } else {
      if (!Path.equals(path3, p2)) {
        return [n2, p2];
      }
    }
  }
};
function ownKeys$8(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$8(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$8(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$8(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var addMark = (editor, key2, value) => {
  var {
    selection
  } = editor;
  if (selection) {
    var match5 = (node3, path3) => {
      if (!Text$1.isText(node3)) {
        return false;
      }
      var [parentNode2, parentPath] = Editor.parent(editor, path3);
      return !editor.isVoid(parentNode2) || editor.markableVoid(parentNode2);
    };
    var expandedSelection = Range.isExpanded(selection);
    var markAcceptingVoidSelected = false;
    if (!expandedSelection) {
      var [selectedNode, selectedPath] = Editor.node(editor, selection);
      if (selectedNode && match5(selectedNode, selectedPath)) {
        var [parentNode] = Editor.parent(editor, selectedPath);
        markAcceptingVoidSelected = parentNode && editor.markableVoid(parentNode);
      }
    }
    if (expandedSelection || markAcceptingVoidSelected) {
      Transforms.setNodes(editor, {
        [key2]: value
      }, {
        match: match5,
        split: true,
        voids: true
      });
    } else {
      var marks3 = _objectSpread$8(_objectSpread$8({}, Editor.marks(editor) || {}), {}, {
        [key2]: value
      });
      editor.marks = marks3;
      if (!FLUSHING.get(editor)) {
        editor.onChange();
      }
    }
  }
};
function ownKeys$7$1(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$7$1(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$7$1(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$7$1(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var after = function after2(editor, at2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var anchor = Editor.point(editor, at2, {
    edge: "end"
  });
  var focus2 = Editor.end(editor, []);
  var range2 = {
    anchor,
    focus: focus2
  };
  var {
    distance = 1
  } = options;
  var d4 = 0;
  var target;
  for (var p2 of Editor.positions(editor, _objectSpread$7$1(_objectSpread$7$1({}, options), {}, {
    at: range2
  }))) {
    if (d4 > distance) {
      break;
    }
    if (d4 !== 0) {
      target = p2;
    }
    d4++;
  }
  return target;
};
function ownKeys$6$1(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$6$1(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$6$1(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$6$1(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var before = function before2(editor, at2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var anchor = Editor.start(editor, []);
  var focus2 = Editor.point(editor, at2, {
    edge: "start"
  });
  var range2 = {
    anchor,
    focus: focus2
  };
  var {
    distance = 1
  } = options;
  var d4 = 0;
  var target;
  for (var p2 of Editor.positions(editor, _objectSpread$6$1(_objectSpread$6$1({}, options), {}, {
    at: range2,
    reverse: true
  }))) {
    if (d4 > distance) {
      break;
    }
    if (d4 !== 0) {
      target = p2;
    }
    d4++;
  }
  return target;
};
var deleteBackward = (editor, unit) => {
  var {
    selection
  } = editor;
  if (selection && Range.isCollapsed(selection)) {
    Transforms.delete(editor, {
      unit,
      reverse: true
    });
  }
};
var deleteForward = (editor, unit) => {
  var {
    selection
  } = editor;
  if (selection && Range.isCollapsed(selection)) {
    Transforms.delete(editor, {
      unit
    });
  }
};
var deleteFragment = function deleteFragment2(editor) {
  var {
    direction: direction2 = "forward"
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var {
    selection
  } = editor;
  if (selection && Range.isExpanded(selection)) {
    Transforms.delete(editor, {
      reverse: direction2 === "backward"
    });
  }
};
var edges = (editor, at2) => {
  return [Editor.start(editor, at2), Editor.end(editor, at2)];
};
function ownKeys$5$1(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$5$1(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$5$1(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$5$1(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var elementReadOnly = function elementReadOnly2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Editor.above(editor, _objectSpread$5$1(_objectSpread$5$1({}, options), {}, {
    match: (n2) => Element$3.isElement(n2) && Editor.isElementReadOnly(editor, n2)
  }));
};
var end = (editor, at2) => {
  return Editor.point(editor, at2, {
    edge: "end"
  });
};
var first$1 = (editor, at2) => {
  var path3 = Editor.path(editor, at2, {
    edge: "start"
  });
  return Editor.node(editor, path3);
};
var fragment = (editor, at2) => {
  var range2 = Editor.range(editor, at2);
  return Node$1.fragment(editor, range2);
};
function ownKeys$4$1(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$4$1(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$4$1(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$4$1(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var getVoid = function getVoid2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Editor.above(editor, _objectSpread$4$1(_objectSpread$4$1({}, options), {}, {
    match: (n2) => Element$3.isElement(n2) && Editor.isVoid(editor, n2)
  }));
};
var hasBlocks = (editor, element) => {
  return element.children.some((n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2));
};
var hasInlines = (editor, element) => {
  return element.children.some((n2) => Text$1.isText(n2) || Editor.isInline(editor, n2));
};
var hasPath$3 = (editor, path3) => {
  return Node$1.has(editor, path3);
};
var hasTexts = (editor, element) => {
  return element.children.every((n2) => Text$1.isText(n2));
};
var insertBreak = (editor) => {
  Transforms.splitNodes(editor, {
    always: true
  });
};
var insertNode = (editor, node3, options) => {
  Transforms.insertNodes(editor, node3, options);
};
var insertSoftBreak = (editor) => {
  Transforms.splitNodes(editor, {
    always: true
  });
};
function ownKeys$3$1(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$3$1(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$3$1(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$3$1(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var insertText = function insertText2(editor, text) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var {
    selection,
    marks: marks3
  } = editor;
  if (selection) {
    if (marks3) {
      var node3 = _objectSpread$3$1({
        text
      }, marks3);
      Transforms.insertNodes(editor, node3, {
        at: options.at,
        voids: options.voids
      });
    } else {
      Transforms.insertText(editor, text, options);
    }
    editor.marks = null;
  }
};
var isBlock = (editor, value) => {
  return !editor.isInline(value);
};
var isEdge$1 = (editor, point3, at2) => {
  return Editor.isStart(editor, point3, at2) || Editor.isEnd(editor, point3, at2);
};
var isEmpty$1 = (editor, element) => {
  var {
    children
  } = element;
  var [first2] = children;
  return children.length === 0 || children.length === 1 && Text$1.isText(first2) && first2.text === "" && !editor.isVoid(element);
};
var isEnd = (editor, point3, at2) => {
  var end2 = Editor.end(editor, at2);
  return Point.equals(point3, end2);
};
var isNormalizing = (editor) => {
  var isNormalizing2 = NORMALIZING.get(editor);
  return isNormalizing2 === void 0 ? true : isNormalizing2;
};
var isStart = (editor, point3, at2) => {
  if (point3.offset !== 0) {
    return false;
  }
  var start2 = Editor.start(editor, at2);
  return Point.equals(point3, start2);
};
var last$3 = (editor, at2) => {
  var path3 = Editor.path(editor, at2, {
    edge: "end"
  });
  return Editor.node(editor, path3);
};
var leaf = function leaf2(editor, at2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var path3 = Editor.path(editor, at2, options);
  var node3 = Node$1.leaf(editor, path3);
  return [node3, path3];
};
function levels(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function* () {
    var {
      at: at2 = editor.selection,
      reverse = false,
      voids = false
    } = options;
    var {
      match: match5
    } = options;
    if (match5 == null) {
      match5 = () => true;
    }
    if (!at2) {
      return;
    }
    var levels2 = [];
    var path3 = Editor.path(editor, at2);
    for (var [n2, p2] of Node$1.levels(editor, path3)) {
      if (!match5(n2, p2)) {
        continue;
      }
      levels2.push([n2, p2]);
      if (!voids && Element$3.isElement(n2) && Editor.isVoid(editor, n2)) {
        break;
      }
    }
    if (reverse) {
      levels2.reverse();
    }
    yield* levels2;
  }();
}
var _excluded$1$1 = ["text"], _excluded2$1$1 = ["text"];
var marks = function marks2(editor) {
  var {
    marks: marks3,
    selection
  } = editor;
  if (!selection) {
    return null;
  }
  var {
    anchor,
    focus: focus2
  } = selection;
  if (marks3) {
    return marks3;
  }
  if (Range.isExpanded(selection)) {
    var isEnd2 = Editor.isEnd(editor, anchor, anchor.path);
    if (isEnd2) {
      var after3 = Editor.after(editor, anchor);
      if (after3) {
        anchor = after3;
      }
    }
    var [match5] = Editor.nodes(editor, {
      match: Text$1.isText,
      at: {
        anchor,
        focus: focus2
      }
    });
    if (match5) {
      var [_node] = match5;
      var _rest = _objectWithoutProperties$2(_node, _excluded$1$1);
      return _rest;
    } else {
      return {};
    }
  }
  var {
    path: path3
  } = anchor;
  var [node3] = Editor.leaf(editor, path3);
  if (anchor.offset === 0) {
    var prev = Editor.previous(editor, {
      at: path3,
      match: Text$1.isText
    });
    var markedVoid = Editor.above(editor, {
      match: (n2) => Element$3.isElement(n2) && Editor.isVoid(editor, n2) && editor.markableVoid(n2)
    });
    if (!markedVoid) {
      var block = Editor.above(editor, {
        match: (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2)
      });
      if (prev && block) {
        var [prevNode, prevPath] = prev;
        var [, blockPath] = block;
        if (Path.isAncestor(blockPath, prevPath)) {
          node3 = prevNode;
        }
      }
    }
  }
  var rest = _objectWithoutProperties$2(node3, _excluded2$1$1);
  return rest;
};
var next = function next2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var {
    mode = "lowest",
    voids = false
  } = options;
  var {
    match: match5,
    at: at2 = editor.selection
  } = options;
  if (!at2) {
    return;
  }
  var pointAfterLocation = Editor.after(editor, at2, {
    voids
  });
  if (!pointAfterLocation) return;
  var [, to2] = Editor.last(editor, []);
  var span = [pointAfterLocation.path, to2];
  if (Path.isPath(at2) && at2.length === 0) {
    throw new Error("Cannot get the next node from the root node!");
  }
  if (match5 == null) {
    if (Path.isPath(at2)) {
      var [parent3] = Editor.parent(editor, at2);
      match5 = (n2) => parent3.children.includes(n2);
    } else {
      match5 = () => true;
    }
  }
  var [next3] = Editor.nodes(editor, {
    at: span,
    match: match5,
    mode,
    voids
  });
  return next3;
};
var node = function node2(editor, at2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var path3 = Editor.path(editor, at2, options);
  var node3 = Node$1.get(editor, path3);
  return [node3, path3];
};
function nodes(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function* () {
    var {
      at: at2 = editor.selection,
      mode = "all",
      universal = false,
      reverse = false,
      voids = false,
      ignoreNonSelectable = false
    } = options;
    var {
      match: match5
    } = options;
    if (!match5) {
      match5 = () => true;
    }
    if (!at2) {
      return;
    }
    var from2;
    var to2;
    if (Span.isSpan(at2)) {
      from2 = at2[0];
      to2 = at2[1];
    } else {
      var first2 = Editor.path(editor, at2, {
        edge: "start"
      });
      var last2 = Editor.path(editor, at2, {
        edge: "end"
      });
      from2 = reverse ? last2 : first2;
      to2 = reverse ? first2 : last2;
    }
    var nodeEntries = Node$1.nodes(editor, {
      reverse,
      from: from2,
      to: to2,
      pass: (_ref) => {
        var [node4] = _ref;
        if (!Element$3.isElement(node4)) return false;
        if (!voids && (Editor.isVoid(editor, node4) || Editor.isElementReadOnly(editor, node4))) return true;
        if (ignoreNonSelectable && !Editor.isSelectable(editor, node4)) return true;
        return false;
      }
    });
    var matches2 = [];
    var hit;
    for (var [node3, path3] of nodeEntries) {
      if (ignoreNonSelectable && Element$3.isElement(node3) && !Editor.isSelectable(editor, node3)) {
        continue;
      }
      var isLower = hit && Path.compare(path3, hit[1]) === 0;
      if (mode === "highest" && isLower) {
        continue;
      }
      if (!match5(node3, path3)) {
        if (universal && !isLower && Text$1.isText(node3)) {
          return;
        } else {
          continue;
        }
      }
      if (mode === "lowest" && isLower) {
        hit = [node3, path3];
        continue;
      }
      var emit = mode === "lowest" ? hit : [node3, path3];
      if (emit) {
        if (universal) {
          matches2.push(emit);
        } else {
          yield emit;
        }
      }
      hit = [node3, path3];
    }
    if (mode === "lowest" && hit) {
      if (universal) {
        matches2.push(hit);
      } else {
        yield hit;
      }
    }
    if (universal) {
      yield* matches2;
    }
  }();
}
var normalize = function normalize2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var {
    force = false,
    operation
  } = options;
  var getDirtyPaths2 = (editor2) => {
    return DIRTY_PATHS.get(editor2) || [];
  };
  var getDirtyPathKeys = (editor2) => {
    return DIRTY_PATH_KEYS.get(editor2) || /* @__PURE__ */ new Set();
  };
  var popDirtyPath = (editor2) => {
    var path3 = getDirtyPaths2(editor2).pop();
    var key2 = path3.join(",");
    getDirtyPathKeys(editor2).delete(key2);
    return path3;
  };
  if (!Editor.isNormalizing(editor)) {
    return;
  }
  if (force) {
    var allPaths = Array.from(Node$1.nodes(editor), (_ref) => {
      var [, p2] = _ref;
      return p2;
    });
    var allPathKeys = new Set(allPaths.map((p2) => p2.join(",")));
    DIRTY_PATHS.set(editor, allPaths);
    DIRTY_PATH_KEYS.set(editor, allPathKeys);
  }
  if (getDirtyPaths2(editor).length === 0) {
    return;
  }
  Editor.withoutNormalizing(editor, () => {
    for (var dirtyPath of getDirtyPaths2(editor)) {
      if (Node$1.has(editor, dirtyPath)) {
        var entry = Editor.node(editor, dirtyPath);
        var [node3, _2] = entry;
        if (Element$3.isElement(node3) && node3.children.length === 0) {
          editor.normalizeNode(entry, {
            operation
          });
        }
      }
    }
    var dirtyPaths = getDirtyPaths2(editor);
    var initialDirtyPathsLength = dirtyPaths.length;
    var iteration = 0;
    while (dirtyPaths.length !== 0) {
      if (!editor.shouldNormalize({
        dirtyPaths,
        iteration,
        initialDirtyPathsLength,
        operation
      })) {
        return;
      }
      var _dirtyPath = popDirtyPath(editor);
      if (Node$1.has(editor, _dirtyPath)) {
        var _entry = Editor.node(editor, _dirtyPath);
        editor.normalizeNode(_entry, {
          operation
        });
      }
      iteration++;
      dirtyPaths = getDirtyPaths2(editor);
    }
  });
};
var parent$2 = function parent(editor, at2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var path3 = Editor.path(editor, at2, options);
  var parentPath = Path.parent(path3);
  var entry = Editor.node(editor, parentPath);
  return entry;
};
var pathRef = function pathRef2(editor, path3) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var {
    affinity = "forward"
  } = options;
  var ref2 = {
    current: path3,
    affinity,
    unref() {
      var {
        current: current2
      } = ref2;
      var pathRefs2 = Editor.pathRefs(editor);
      pathRefs2.delete(ref2);
      ref2.current = null;
      return current2;
    }
  };
  var refs = Editor.pathRefs(editor);
  refs.add(ref2);
  return ref2;
};
var pathRefs = (editor) => {
  var refs = PATH_REFS.get(editor);
  if (!refs) {
    refs = /* @__PURE__ */ new Set();
    PATH_REFS.set(editor, refs);
  }
  return refs;
};
var path$2 = function path(editor, at2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var {
    depth,
    edge
  } = options;
  if (Path.isPath(at2)) {
    if (edge === "start") {
      var [, firstPath] = Node$1.first(editor, at2);
      at2 = firstPath;
    } else if (edge === "end") {
      var [, lastPath] = Node$1.last(editor, at2);
      at2 = lastPath;
    }
  }
  if (Range.isRange(at2)) {
    if (edge === "start") {
      at2 = Range.start(at2);
    } else if (edge === "end") {
      at2 = Range.end(at2);
    } else {
      at2 = Path.common(at2.anchor.path, at2.focus.path);
    }
  }
  if (Point.isPoint(at2)) {
    at2 = at2.path;
  }
  if (depth != null) {
    at2 = at2.slice(0, depth);
  }
  return at2;
};
var pointRef = function pointRef2(editor, point3) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var {
    affinity = "forward"
  } = options;
  var ref2 = {
    current: point3,
    affinity,
    unref() {
      var {
        current: current2
      } = ref2;
      var pointRefs2 = Editor.pointRefs(editor);
      pointRefs2.delete(ref2);
      ref2.current = null;
      return current2;
    }
  };
  var refs = Editor.pointRefs(editor);
  refs.add(ref2);
  return ref2;
};
var pointRefs = (editor) => {
  var refs = POINT_REFS.get(editor);
  if (!refs) {
    refs = /* @__PURE__ */ new Set();
    POINT_REFS.set(editor, refs);
  }
  return refs;
};
var point$1 = function point(editor, at2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var {
    edge = "start"
  } = options;
  if (Path.isPath(at2)) {
    var path3;
    if (edge === "end") {
      var [, lastPath] = Node$1.last(editor, at2);
      path3 = lastPath;
    } else {
      var [, firstPath] = Node$1.first(editor, at2);
      path3 = firstPath;
    }
    var node3 = Node$1.get(editor, path3);
    if (!Text$1.isText(node3)) {
      throw new Error("Cannot get the ".concat(edge, " point in the node at path [").concat(at2, "] because it has no ").concat(edge, " text node."));
    }
    return {
      path: path3,
      offset: edge === "end" ? node3.text.length : 0
    };
  }
  if (Range.isRange(at2)) {
    var [start2, end2] = Range.edges(at2);
    return edge === "start" ? start2 : end2;
  }
  return at2;
};
function positions(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function* () {
    var {
      at: at2 = editor.selection,
      unit = "offset",
      reverse = false,
      voids = false,
      ignoreNonSelectable = false
    } = options;
    if (!at2) {
      return;
    }
    var range2 = Editor.range(editor, at2);
    var [start2, end2] = Range.edges(range2);
    var first2 = reverse ? end2 : start2;
    var isNewBlock = false;
    var blockText = "";
    var distance = 0;
    var leafTextRemaining = 0;
    var leafTextOffset = 0;
    for (var [node3, path3] of Editor.nodes(editor, {
      at: at2,
      reverse,
      voids,
      ignoreNonSelectable
    })) {
      if (Element$3.isElement(node3)) {
        if (!voids && (editor.isVoid(node3) || editor.isElementReadOnly(node3))) {
          yield Editor.start(editor, path3);
          continue;
        }
        if (editor.isInline(node3)) continue;
        if (Editor.hasInlines(editor, node3)) {
          var e5 = Path.isAncestor(path3, end2.path) ? end2 : Editor.end(editor, path3);
          var s4 = Path.isAncestor(path3, start2.path) ? start2 : Editor.start(editor, path3);
          blockText = Editor.string(editor, {
            anchor: s4,
            focus: e5
          }, {
            voids
          });
          isNewBlock = true;
        }
      }
      if (Text$1.isText(node3)) {
        var isFirst = Path.equals(path3, first2.path);
        if (isFirst) {
          leafTextRemaining = reverse ? first2.offset : node3.text.length - first2.offset;
          leafTextOffset = first2.offset;
        } else {
          leafTextRemaining = node3.text.length;
          leafTextOffset = reverse ? leafTextRemaining : 0;
        }
        if (isFirst || isNewBlock || unit === "offset") {
          yield {
            path: path3,
            offset: leafTextOffset
          };
          isNewBlock = false;
        }
        while (true) {
          if (distance === 0) {
            if (blockText === "") break;
            distance = calcDistance(blockText, unit, reverse);
            blockText = splitByCharacterDistance(blockText, distance, reverse)[1];
          }
          leafTextOffset = reverse ? leafTextOffset - distance : leafTextOffset + distance;
          leafTextRemaining = leafTextRemaining - distance;
          if (leafTextRemaining < 0) {
            distance = -leafTextRemaining;
            break;
          }
          distance = 0;
          yield {
            path: path3,
            offset: leafTextOffset
          };
        }
      }
    }
    function calcDistance(text, unit2, reverse2) {
      if (unit2 === "character") {
        return getCharacterDistance(text, reverse2);
      } else if (unit2 === "word") {
        return getWordDistance(text, reverse2);
      } else if (unit2 === "line" || unit2 === "block") {
        return text.length;
      }
      return 1;
    }
  }();
}
var previous = function previous2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var {
    mode = "lowest",
    voids = false
  } = options;
  var {
    match: match5,
    at: at2 = editor.selection
  } = options;
  if (!at2) {
    return;
  }
  var pointBeforeLocation = Editor.before(editor, at2, {
    voids
  });
  if (!pointBeforeLocation) {
    return;
  }
  var [, to2] = Editor.first(editor, []);
  var span = [pointBeforeLocation.path, to2];
  if (Path.isPath(at2) && at2.length === 0) {
    throw new Error("Cannot get the previous node from the root node!");
  }
  if (match5 == null) {
    if (Path.isPath(at2)) {
      var [parent3] = Editor.parent(editor, at2);
      match5 = (n2) => parent3.children.includes(n2);
    } else {
      match5 = () => true;
    }
  }
  var [previous3] = Editor.nodes(editor, {
    reverse: true,
    at: span,
    match: match5,
    mode,
    voids
  });
  return previous3;
};
var rangeRef = function rangeRef2(editor, range2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var {
    affinity = "forward"
  } = options;
  var ref2 = {
    current: range2,
    affinity,
    unref() {
      var {
        current: current2
      } = ref2;
      var rangeRefs2 = Editor.rangeRefs(editor);
      rangeRefs2.delete(ref2);
      ref2.current = null;
      return current2;
    }
  };
  var refs = Editor.rangeRefs(editor);
  refs.add(ref2);
  return ref2;
};
var rangeRefs = (editor) => {
  var refs = RANGE_REFS.get(editor);
  if (!refs) {
    refs = /* @__PURE__ */ new Set();
    RANGE_REFS.set(editor, refs);
  }
  return refs;
};
var range$1 = (editor, at2, to2) => {
  if (Range.isRange(at2) && !to2) {
    return at2;
  }
  var start2 = Editor.start(editor, at2);
  var end2 = Editor.end(editor, to2 || at2);
  return {
    anchor: start2,
    focus: end2
  };
};
function ownKeys$2$1(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$2$1(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$2$1(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$2$1(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var removeMark = (editor, key2) => {
  var {
    selection
  } = editor;
  if (selection) {
    var match5 = (node3, path3) => {
      if (!Text$1.isText(node3)) {
        return false;
      }
      var [parentNode2, parentPath] = Editor.parent(editor, path3);
      return !editor.isVoid(parentNode2) || editor.markableVoid(parentNode2);
    };
    var expandedSelection = Range.isExpanded(selection);
    var markAcceptingVoidSelected = false;
    if (!expandedSelection) {
      var [selectedNode, selectedPath] = Editor.node(editor, selection);
      if (selectedNode && match5(selectedNode, selectedPath)) {
        var [parentNode] = Editor.parent(editor, selectedPath);
        markAcceptingVoidSelected = parentNode && editor.markableVoid(parentNode);
      }
    }
    if (expandedSelection || markAcceptingVoidSelected) {
      Transforms.unsetNodes(editor, key2, {
        match: match5,
        split: true,
        voids: true
      });
    } else {
      var marks3 = _objectSpread$2$1({}, Editor.marks(editor) || {});
      delete marks3[key2];
      editor.marks = marks3;
      if (!FLUSHING.get(editor)) {
        editor.onChange();
      }
    }
  }
};
var setNormalizing = (editor, isNormalizing2) => {
  NORMALIZING.set(editor, isNormalizing2);
};
var start = (editor, at2) => {
  return Editor.point(editor, at2, {
    edge: "start"
  });
};
var string$1 = function string(editor, at2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var {
    voids = false
  } = options;
  var range2 = Editor.range(editor, at2);
  var [start2, end2] = Range.edges(range2);
  var text = "";
  for (var [node3, path3] of Editor.nodes(editor, {
    at: range2,
    match: Text$1.isText,
    voids
  })) {
    var t3 = node3.text;
    if (Path.equals(path3, end2.path)) {
      t3 = t3.slice(0, end2.offset);
    }
    if (Path.equals(path3, start2.path)) {
      t3 = t3.slice(start2.offset);
    }
    text += t3;
  }
  return text;
};
var unhangRange = function unhangRange2(editor, range2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var {
    voids = false
  } = options;
  var [start2, end2] = Range.edges(range2);
  if (start2.offset !== 0 || end2.offset !== 0 || Range.isCollapsed(range2) || Path.hasPrevious(end2.path)) {
    return range2;
  }
  var endBlock = Editor.above(editor, {
    at: end2,
    match: (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2),
    voids
  });
  var blockPath = endBlock ? endBlock[1] : [];
  var first2 = Editor.start(editor, start2);
  var before3 = {
    anchor: first2,
    focus: end2
  };
  var skip = true;
  for (var [node3, path3] of Editor.nodes(editor, {
    at: before3,
    match: Text$1.isText,
    reverse: true,
    voids
  })) {
    if (skip) {
      skip = false;
      continue;
    }
    if (node3.text !== "" || Path.isBefore(path3, blockPath)) {
      end2 = {
        path: path3,
        offset: node3.text.length
      };
      break;
    }
  }
  return {
    anchor: start2,
    focus: end2
  };
};
var withoutNormalizing = (editor, fn2) => {
  var value = Editor.isNormalizing(editor);
  Editor.setNormalizing(editor, false);
  try {
    fn2();
  } finally {
    Editor.setNormalizing(editor, value);
  }
  Editor.normalize(editor);
};
var shouldMergeNodesRemovePrevNode = (editor, _ref, _ref2) => {
  var [prevNode, prevPath] = _ref;
  return Element$3.isElement(prevNode) && Editor.isEmpty(editor, prevNode) || Text$1.isText(prevNode) && prevNode.text === "" && prevPath[prevPath.length - 1] !== 0;
};
var deleteText = function deleteText2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  Editor.withoutNormalizing(editor, () => {
    var _Editor$void, _Editor$void2;
    var {
      reverse = false,
      unit = "character",
      distance = 1,
      voids = false
    } = options;
    var {
      at: at2 = editor.selection,
      hanging = false
    } = options;
    if (!at2) {
      return;
    }
    var isCollapsed = false;
    if (Range.isRange(at2) && Range.isCollapsed(at2)) {
      isCollapsed = true;
      at2 = at2.anchor;
    }
    if (Point.isPoint(at2)) {
      var furthestVoid = Editor.void(editor, {
        at: at2,
        mode: "highest"
      });
      if (!voids && furthestVoid) {
        var [, voidPath] = furthestVoid;
        at2 = voidPath;
      } else {
        var opts = {
          unit,
          distance
        };
        var target = reverse ? Editor.before(editor, at2, opts) || Editor.start(editor, []) : Editor.after(editor, at2, opts) || Editor.end(editor, []);
        at2 = {
          anchor: at2,
          focus: target
        };
        hanging = true;
      }
    }
    if (Path.isPath(at2)) {
      Transforms.removeNodes(editor, {
        at: at2,
        voids
      });
      return;
    }
    if (Range.isCollapsed(at2)) {
      return;
    }
    if (!hanging) {
      var [, _end] = Range.edges(at2);
      var endOfDoc = Editor.end(editor, []);
      if (!Point.equals(_end, endOfDoc)) {
        at2 = Editor.unhangRange(editor, at2, {
          voids
        });
      }
    }
    var [start2, end2] = Range.edges(at2);
    var startBlock = Editor.above(editor, {
      match: (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2),
      at: start2,
      voids
    });
    var endBlock = Editor.above(editor, {
      match: (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2),
      at: end2,
      voids
    });
    var isAcrossBlocks = startBlock && endBlock && !Path.equals(startBlock[1], endBlock[1]);
    var isSingleText = Path.equals(start2.path, end2.path);
    var startNonEditable = voids ? null : (_Editor$void = Editor.void(editor, {
      at: start2,
      mode: "highest"
    })) !== null && _Editor$void !== void 0 ? _Editor$void : Editor.elementReadOnly(editor, {
      at: start2,
      mode: "highest"
    });
    var endNonEditable = voids ? null : (_Editor$void2 = Editor.void(editor, {
      at: end2,
      mode: "highest"
    })) !== null && _Editor$void2 !== void 0 ? _Editor$void2 : Editor.elementReadOnly(editor, {
      at: end2,
      mode: "highest"
    });
    if (startNonEditable) {
      var before3 = Editor.before(editor, start2);
      if (before3 && startBlock && Path.isAncestor(startBlock[1], before3.path)) {
        start2 = before3;
      }
    }
    if (endNonEditable) {
      var after3 = Editor.after(editor, end2);
      if (after3 && endBlock && Path.isAncestor(endBlock[1], after3.path)) {
        end2 = after3;
      }
    }
    var matches2 = [];
    var lastPath;
    for (var entry of Editor.nodes(editor, {
      at: at2,
      voids
    })) {
      var [node3, path3] = entry;
      if (lastPath && Path.compare(path3, lastPath) === 0) {
        continue;
      }
      if (!voids && Element$3.isElement(node3) && (Editor.isVoid(editor, node3) || Editor.isElementReadOnly(editor, node3)) || !Path.isCommon(path3, start2.path) && !Path.isCommon(path3, end2.path)) {
        matches2.push(entry);
        lastPath = path3;
      }
    }
    var pathRefs2 = Array.from(matches2, (_ref) => {
      var [, p2] = _ref;
      return Editor.pathRef(editor, p2);
    });
    var startRef = Editor.pointRef(editor, start2);
    var endRef = Editor.pointRef(editor, end2);
    var removedText = "";
    if (!isSingleText && !startNonEditable) {
      var _point = startRef.current;
      var [_node] = Editor.leaf(editor, _point);
      var {
        path: _path
      } = _point;
      var {
        offset: offset2
      } = start2;
      var text = _node.text.slice(offset2);
      if (text.length > 0) {
        editor.apply({
          type: "remove_text",
          path: _path,
          offset: offset2,
          text
        });
        removedText = text;
      }
    }
    pathRefs2.reverse().map((r2) => r2.unref()).filter((r2) => r2 !== null).forEach((p2) => Transforms.removeNodes(editor, {
      at: p2,
      voids
    }));
    if (!endNonEditable) {
      var _point2 = endRef.current;
      var [_node2] = Editor.leaf(editor, _point2);
      var {
        path: _path2
      } = _point2;
      var _offset = isSingleText ? start2.offset : 0;
      var _text = _node2.text.slice(_offset, end2.offset);
      if (_text.length > 0) {
        editor.apply({
          type: "remove_text",
          path: _path2,
          offset: _offset,
          text: _text
        });
        removedText = _text;
      }
    }
    if (!isSingleText && isAcrossBlocks && endRef.current && startRef.current) {
      Transforms.mergeNodes(editor, {
        at: endRef.current,
        hanging: true,
        voids
      });
    }
    if (isCollapsed && reverse && unit === "character" && removedText.length > 1 && removedText.match(/[\u0E00-\u0E7F]+/)) {
      Transforms.insertText(editor, removedText.slice(0, removedText.length - distance));
    }
    var startUnref = startRef.unref();
    var endUnref = endRef.unref();
    var point3 = reverse ? startUnref || endUnref : endUnref || startUnref;
    if (options.at == null && point3) {
      Transforms.select(editor, point3);
    }
  });
};
var insertFragment = function insertFragment2(editor, fragment2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Editor.withoutNormalizing(editor, () => {
    var {
      hanging = false,
      voids = false
    } = options;
    var {
      at: at2 = getDefaultInsertLocation(editor),
      batchDirty = true
    } = options;
    if (!fragment2.length) {
      return;
    }
    if (Range.isRange(at2)) {
      if (!hanging) {
        at2 = Editor.unhangRange(editor, at2, {
          voids
        });
      }
      if (Range.isCollapsed(at2)) {
        at2 = at2.anchor;
      } else {
        var [, end2] = Range.edges(at2);
        if (!voids && Editor.void(editor, {
          at: end2
        })) {
          return;
        }
        var pointRef3 = Editor.pointRef(editor, end2);
        Transforms.delete(editor, {
          at: at2
        });
        at2 = pointRef3.unref();
      }
    } else if (Path.isPath(at2)) {
      at2 = Editor.start(editor, at2);
    }
    if (!voids && Editor.void(editor, {
      at: at2
    })) {
      return;
    }
    var inlineElementMatch = Editor.above(editor, {
      at: at2,
      match: (n2) => Element$3.isElement(n2) && Editor.isInline(editor, n2),
      mode: "highest",
      voids
    });
    if (inlineElementMatch) {
      var [, _inlinePath] = inlineElementMatch;
      if (Editor.isEnd(editor, at2, _inlinePath)) {
        var after3 = Editor.after(editor, _inlinePath);
        at2 = after3;
      } else if (Editor.isStart(editor, at2, _inlinePath)) {
        var before3 = Editor.before(editor, _inlinePath);
        at2 = before3;
      }
    }
    var blockMatch = Editor.above(editor, {
      match: (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2),
      at: at2,
      voids
    });
    var [, blockPath] = blockMatch;
    var isBlockStart = Editor.isStart(editor, at2, blockPath);
    var isBlockEnd = Editor.isEnd(editor, at2, blockPath);
    var isBlockEmpty = isBlockStart && isBlockEnd;
    var mergeStart = !isBlockStart || isBlockStart && isBlockEnd;
    var mergeEnd = !isBlockEnd;
    var [, firstPath] = Node$1.first({
      children: fragment2
    }, []);
    var [, lastPath] = Node$1.last({
      children: fragment2
    }, []);
    var matches2 = [];
    var matcher = (_ref) => {
      var [n2, p2] = _ref;
      var isRoot = p2.length === 0;
      if (isRoot) {
        return false;
      }
      if (isBlockEmpty) {
        return true;
      }
      if (mergeStart && Path.isAncestor(p2, firstPath) && Element$3.isElement(n2) && !editor.isVoid(n2) && !editor.isInline(n2)) {
        return false;
      }
      if (mergeEnd && Path.isAncestor(p2, lastPath) && Element$3.isElement(n2) && !editor.isVoid(n2) && !editor.isInline(n2)) {
        return false;
      }
      return true;
    };
    for (var entry of Node$1.nodes({
      children: fragment2
    }, {
      pass: matcher
    })) {
      if (matcher(entry)) {
        matches2.push(entry);
      }
    }
    var starts = [];
    var middles = [];
    var ends = [];
    var starting = true;
    var hasBlocks2 = false;
    for (var [node3] of matches2) {
      if (Element$3.isElement(node3) && !editor.isInline(node3)) {
        starting = false;
        hasBlocks2 = true;
        middles.push(node3);
      } else if (starting) {
        starts.push(node3);
      } else {
        ends.push(node3);
      }
    }
    var [inlineMatch] = Editor.nodes(editor, {
      at: at2,
      match: (n2) => Text$1.isText(n2) || Editor.isInline(editor, n2),
      mode: "highest",
      voids
    });
    var [, inlinePath] = inlineMatch;
    var isInlineStart = Editor.isStart(editor, at2, inlinePath);
    var isInlineEnd = Editor.isEnd(editor, at2, inlinePath);
    var middleRef = Editor.pathRef(editor, isBlockEnd && !ends.length ? Path.next(blockPath) : blockPath);
    var endRef = Editor.pathRef(editor, isInlineEnd ? Path.next(inlinePath) : inlinePath);
    Transforms.splitNodes(editor, {
      at: at2,
      match: (n2) => hasBlocks2 ? Element$3.isElement(n2) && Editor.isBlock(editor, n2) : Text$1.isText(n2) || Editor.isInline(editor, n2),
      mode: hasBlocks2 ? "lowest" : "highest",
      always: hasBlocks2 && (!isBlockStart || starts.length > 0) && (!isBlockEnd || ends.length > 0),
      voids
    });
    var startRef = Editor.pathRef(editor, !isInlineStart || isInlineStart && isInlineEnd ? Path.next(inlinePath) : inlinePath);
    Transforms.insertNodes(editor, starts, {
      at: startRef.current,
      match: (n2) => Text$1.isText(n2) || Editor.isInline(editor, n2),
      mode: "highest",
      voids,
      batchDirty
    });
    if (isBlockEmpty && !starts.length && middles.length && !ends.length) {
      Transforms.delete(editor, {
        at: blockPath,
        voids
      });
    }
    Transforms.insertNodes(editor, middles, {
      at: middleRef.current,
      match: (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2),
      mode: "lowest",
      voids,
      batchDirty
    });
    Transforms.insertNodes(editor, ends, {
      at: endRef.current,
      match: (n2) => Text$1.isText(n2) || Editor.isInline(editor, n2),
      mode: "highest",
      voids,
      batchDirty
    });
    if (!options.at) {
      var path3;
      if (ends.length > 0 && endRef.current) {
        path3 = Path.previous(endRef.current);
      } else if (middles.length > 0 && middleRef.current) {
        path3 = Path.previous(middleRef.current);
      } else if (startRef.current) {
        path3 = Path.previous(startRef.current);
      }
      if (path3) {
        var _end = Editor.end(editor, path3);
        Transforms.select(editor, _end);
      }
    }
    startRef.unref();
    middleRef.unref();
    endRef.unref();
  });
};
var collapse = function collapse2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var {
    edge = "anchor"
  } = options;
  var {
    selection
  } = editor;
  if (!selection) {
    return;
  } else if (edge === "anchor") {
    Transforms.select(editor, selection.anchor);
  } else if (edge === "focus") {
    Transforms.select(editor, selection.focus);
  } else if (edge === "start") {
    var [start2] = Range.edges(selection);
    Transforms.select(editor, start2);
  } else if (edge === "end") {
    var [, end2] = Range.edges(selection);
    Transforms.select(editor, end2);
  }
};
var deselect = (editor) => {
  var {
    selection
  } = editor;
  if (selection) {
    editor.apply({
      type: "set_selection",
      properties: selection,
      newProperties: null
    });
  }
};
var move = function move2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var {
    selection
  } = editor;
  var {
    distance = 1,
    unit = "character",
    reverse = false
  } = options;
  var {
    edge = null
  } = options;
  if (!selection) {
    return;
  }
  if (edge === "start") {
    edge = Range.isBackward(selection) ? "focus" : "anchor";
  }
  if (edge === "end") {
    edge = Range.isBackward(selection) ? "anchor" : "focus";
  }
  var {
    anchor,
    focus: focus2
  } = selection;
  var opts = {
    distance,
    unit,
    ignoreNonSelectable: true
  };
  var props2 = {};
  if (edge == null || edge === "anchor") {
    var point3 = reverse ? Editor.before(editor, anchor, opts) : Editor.after(editor, anchor, opts);
    if (point3) {
      props2.anchor = point3;
    }
  }
  if (edge == null || edge === "focus") {
    var _point = reverse ? Editor.before(editor, focus2, opts) : Editor.after(editor, focus2, opts);
    if (_point) {
      props2.focus = _point;
    }
  }
  Transforms.setSelection(editor, props2);
};
var select = (editor, target) => {
  var {
    selection
  } = editor;
  target = Editor.range(editor, target);
  if (selection) {
    Transforms.setSelection(editor, target);
    return;
  }
  if (!Range.isRange(target)) {
    throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(Scrubber.stringify(target)));
  }
  editor.apply({
    type: "set_selection",
    properties: selection,
    newProperties: target
  });
};
function ownKeys$1$2(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$1$2(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$1$2(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$1$2(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var setPoint = function setPoint2(editor, props2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var {
    selection
  } = editor;
  var {
    edge = "both"
  } = options;
  if (!selection) {
    return;
  }
  if (edge === "start") {
    edge = Range.isBackward(selection) ? "focus" : "anchor";
  }
  if (edge === "end") {
    edge = Range.isBackward(selection) ? "anchor" : "focus";
  }
  var {
    anchor,
    focus: focus2
  } = selection;
  var point3 = edge === "anchor" ? anchor : focus2;
  Transforms.setSelection(editor, {
    [edge === "anchor" ? "anchor" : "focus"]: _objectSpread$1$2(_objectSpread$1$2({}, point3), props2)
  });
};
var setSelection = (editor, props2) => {
  var {
    selection
  } = editor;
  var oldProps = {};
  var newProps = {};
  if (!selection) {
    return;
  }
  for (var k3 in props2) {
    if (k3 === "anchor" && props2.anchor != null && !Point.equals(props2.anchor, selection.anchor) || k3 === "focus" && props2.focus != null && !Point.equals(props2.focus, selection.focus) || k3 !== "anchor" && k3 !== "focus" && props2[k3] !== selection[k3]) {
      oldProps[k3] = selection[k3];
      newProps[k3] = props2[k3];
    }
  }
  if (Object.keys(oldProps).length > 0) {
    editor.apply({
      type: "set_selection",
      properties: oldProps,
      newProperties: newProps
    });
  }
};
var insertNodes = function insertNodes2(editor, nodes2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Editor.withoutNormalizing(editor, () => {
    var {
      hanging = false,
      voids = false,
      mode = "lowest",
      batchDirty = true
    } = options;
    var {
      at: at2,
      match: match5,
      select: select2
    } = options;
    if (Node$1.isNode(nodes2)) {
      nodes2 = [nodes2];
    }
    if (nodes2.length === 0) {
      return;
    }
    var [node3] = nodes2;
    if (!at2) {
      at2 = getDefaultInsertLocation(editor);
      if (select2 !== false) {
        select2 = true;
      }
    }
    if (select2 == null) {
      select2 = false;
    }
    if (Range.isRange(at2)) {
      if (!hanging) {
        at2 = Editor.unhangRange(editor, at2, {
          voids
        });
      }
      if (Range.isCollapsed(at2)) {
        at2 = at2.anchor;
      } else {
        var [, end2] = Range.edges(at2);
        var pointRef3 = Editor.pointRef(editor, end2);
        Transforms.delete(editor, {
          at: at2
        });
        at2 = pointRef3.unref();
      }
    }
    if (Point.isPoint(at2)) {
      if (match5 == null) {
        if (Text$1.isText(node3)) {
          match5 = (n2) => Text$1.isText(n2);
        } else if (editor.isInline(node3)) {
          match5 = (n2) => Text$1.isText(n2) || Editor.isInline(editor, n2);
        } else {
          match5 = (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2);
        }
      }
      var [entry] = Editor.nodes(editor, {
        at: at2.path,
        match: match5,
        mode,
        voids
      });
      if (entry) {
        var [, matchPath2] = entry;
        var pathRef3 = Editor.pathRef(editor, matchPath2);
        var isAtEnd = Editor.isEnd(editor, at2, matchPath2);
        Transforms.splitNodes(editor, {
          at: at2,
          match: match5,
          mode,
          voids
        });
        var path3 = pathRef3.unref();
        at2 = isAtEnd ? Path.next(path3) : path3;
      } else {
        return;
      }
    }
    var parentPath = Path.parent(at2);
    var index2 = at2[at2.length - 1];
    if (!voids && Editor.void(editor, {
      at: parentPath
    })) {
      return;
    }
    if (batchDirty) {
      var batchedOps = [];
      var newDirtyPaths = Path.levels(parentPath);
      batchDirtyPaths(editor, () => {
        var _loop = function _loop2() {
          var path4 = parentPath.concat(index2);
          index2++;
          var op = {
            type: "insert_node",
            path: path4,
            node: _node
          };
          editor.apply(op);
          at2 = Path.next(at2);
          batchedOps.push(op);
          if (!Text$1.isText) {
            newDirtyPaths.push(path4);
          } else {
            newDirtyPaths.push(...Array.from(Node$1.nodes(_node), (_ref) => {
              var [, p2] = _ref;
              return path4.concat(p2);
            }));
          }
        };
        for (var _node of nodes2) {
          _loop();
        }
      }, () => {
        updateDirtyPaths(editor, newDirtyPaths, (p2) => {
          var newPath = p2;
          for (var op of batchedOps) {
            if (Path.operationCanTransformPath(op)) {
              newPath = Path.transform(newPath, op);
              if (!newPath) {
                return null;
              }
            }
          }
          return newPath;
        });
      });
    } else {
      for (var _node2 of nodes2) {
        var _path = parentPath.concat(index2);
        index2++;
        editor.apply({
          type: "insert_node",
          path: _path,
          node: _node2
        });
        at2 = Path.next(at2);
      }
    }
    at2 = Path.previous(at2);
    if (select2) {
      var point3 = Editor.end(editor, at2);
      if (point3) {
        Transforms.select(editor, point3);
      }
    }
  });
};
var liftNodes = function liftNodes2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  Editor.withoutNormalizing(editor, () => {
    var {
      at: at2 = editor.selection,
      mode = "lowest",
      voids = false
    } = options;
    var {
      match: match5
    } = options;
    if (match5 == null) {
      match5 = Path.isPath(at2) ? matchPath(editor, at2) : (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2);
    }
    if (!at2) {
      return;
    }
    var matches2 = Editor.nodes(editor, {
      at: at2,
      match: match5,
      mode,
      voids
    });
    var pathRefs2 = Array.from(matches2, (_ref) => {
      var [, p2] = _ref;
      return Editor.pathRef(editor, p2);
    });
    for (var pathRef3 of pathRefs2) {
      var path3 = pathRef3.unref();
      if (path3.length < 2) {
        throw new Error("Cannot lift node at a path [".concat(path3, "] because it has a depth of less than `2`."));
      }
      var parentNodeEntry = Editor.node(editor, Path.parent(path3));
      var [parent3, parentPath] = parentNodeEntry;
      var index2 = path3[path3.length - 1];
      var {
        length
      } = parent3.children;
      if (length === 1) {
        var toPath2 = Path.next(parentPath);
        Transforms.moveNodes(editor, {
          at: path3,
          to: toPath2,
          voids
        });
        Transforms.removeNodes(editor, {
          at: parentPath,
          voids
        });
      } else if (index2 === 0) {
        Transforms.moveNodes(editor, {
          at: path3,
          to: parentPath,
          voids
        });
      } else if (index2 === length - 1) {
        var _toPath2 = Path.next(parentPath);
        Transforms.moveNodes(editor, {
          at: path3,
          to: _toPath2,
          voids
        });
      } else {
        var splitPath = Path.next(path3);
        var _toPath22 = Path.next(parentPath);
        Transforms.splitNodes(editor, {
          at: splitPath,
          voids
        });
        Transforms.moveNodes(editor, {
          at: path3,
          to: _toPath22,
          voids
        });
      }
    }
  });
};
var _excluded$5 = ["text"], _excluded2$4 = ["children"];
var hasSingleChildNest = (editor, node3) => {
  if (Element$3.isElement(node3)) {
    var element = node3;
    if (Editor.isVoid(editor, node3)) {
      return true;
    } else if (element.children.length === 1) {
      return hasSingleChildNest(editor, element.children[0]);
    } else {
      return false;
    }
  } else if (Editor.isEditor(node3)) {
    return false;
  } else {
    return true;
  }
};
var mergeNodes = function mergeNodes2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  Editor.withoutNormalizing(editor, () => {
    var {
      match: match5,
      at: at2 = editor.selection
    } = options;
    var {
      hanging = false,
      voids = false,
      mode = "lowest"
    } = options;
    if (!at2) {
      return;
    }
    if (match5 == null) {
      if (Path.isPath(at2)) {
        var [parent3] = Editor.parent(editor, at2);
        match5 = (n2) => parent3.children.includes(n2);
      } else {
        match5 = (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2);
      }
    }
    if (!hanging && Range.isRange(at2)) {
      at2 = Editor.unhangRange(editor, at2, {
        voids
      });
    }
    if (Range.isRange(at2)) {
      if (Range.isCollapsed(at2)) {
        at2 = at2.anchor;
      } else {
        var [, end2] = Range.edges(at2);
        var pointRef3 = Editor.pointRef(editor, end2);
        Transforms.delete(editor, {
          at: at2
        });
        at2 = pointRef3.unref();
        if (options.at == null) {
          Transforms.select(editor, at2);
        }
      }
    }
    var [current2] = Editor.nodes(editor, {
      at: at2,
      match: match5,
      voids,
      mode
    });
    var prev = Editor.previous(editor, {
      at: at2,
      match: match5,
      voids,
      mode
    });
    if (!current2 || !prev) {
      return;
    }
    var [node3, path3] = current2;
    var [prevNode, prevPath] = prev;
    if (path3.length === 0 || prevPath.length === 0) {
      return;
    }
    var newPath = Path.next(prevPath);
    var commonPath = Path.common(path3, prevPath);
    var isPreviousSibling = Path.isSibling(path3, prevPath);
    var levels2 = Array.from(Editor.levels(editor, {
      at: path3
    }), (_ref) => {
      var [n2] = _ref;
      return n2;
    }).slice(commonPath.length).slice(0, -1);
    var emptyAncestor = Editor.above(editor, {
      at: path3,
      mode: "highest",
      match: (n2) => levels2.includes(n2) && hasSingleChildNest(editor, n2)
    });
    var emptyRef = emptyAncestor && Editor.pathRef(editor, emptyAncestor[1]);
    var properties2;
    var position2;
    if (Text$1.isText(node3) && Text$1.isText(prevNode)) {
      var rest = _objectWithoutProperties$2(node3, _excluded$5);
      position2 = prevNode.text.length;
      properties2 = rest;
    } else if (Element$3.isElement(node3) && Element$3.isElement(prevNode)) {
      var rest = _objectWithoutProperties$2(node3, _excluded2$4);
      position2 = prevNode.children.length;
      properties2 = rest;
    } else {
      throw new Error("Cannot merge the node at path [".concat(path3, "] with the previous sibling because it is not the same kind: ").concat(Scrubber.stringify(node3), " ").concat(Scrubber.stringify(prevNode)));
    }
    if (!isPreviousSibling) {
      Transforms.moveNodes(editor, {
        at: path3,
        to: newPath,
        voids
      });
    }
    if (emptyRef) {
      Transforms.removeNodes(editor, {
        at: emptyRef.current,
        voids
      });
    }
    if (Editor.shouldMergeNodesRemovePrevNode(editor, prev, current2)) {
      Transforms.removeNodes(editor, {
        at: prevPath,
        voids
      });
    } else {
      editor.apply({
        type: "merge_node",
        path: newPath,
        position: position2,
        properties: properties2
      });
    }
    if (emptyRef) {
      emptyRef.unref();
    }
  });
};
var moveNodes = (editor, options) => {
  Editor.withoutNormalizing(editor, () => {
    var {
      to: to2,
      at: at2 = editor.selection,
      mode = "lowest",
      voids = false
    } = options;
    var {
      match: match5
    } = options;
    if (!at2) {
      return;
    }
    if (match5 == null) {
      match5 = Path.isPath(at2) ? matchPath(editor, at2) : (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2);
    }
    var toRef = Editor.pathRef(editor, to2);
    var targets = Editor.nodes(editor, {
      at: at2,
      match: match5,
      mode,
      voids
    });
    var pathRefs2 = Array.from(targets, (_ref) => {
      var [, p2] = _ref;
      return Editor.pathRef(editor, p2);
    });
    for (var pathRef3 of pathRefs2) {
      var path3 = pathRef3.unref();
      var newPath = toRef.current;
      if (path3.length !== 0) {
        editor.apply({
          type: "move_node",
          path: path3,
          newPath
        });
      }
      if (toRef.current && Path.isSibling(newPath, path3) && Path.isAfter(newPath, path3)) {
        toRef.current = Path.next(toRef.current);
      }
    }
    toRef.unref();
  });
};
var removeNodes = function removeNodes2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  Editor.withoutNormalizing(editor, () => {
    var {
      hanging = false,
      voids = false,
      mode = "lowest"
    } = options;
    var {
      at: at2 = editor.selection,
      match: match5
    } = options;
    if (!at2) {
      return;
    }
    if (match5 == null) {
      match5 = Path.isPath(at2) ? matchPath(editor, at2) : (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2);
    }
    if (!hanging && Range.isRange(at2)) {
      at2 = Editor.unhangRange(editor, at2, {
        voids
      });
    }
    var depths = Editor.nodes(editor, {
      at: at2,
      match: match5,
      mode,
      voids
    });
    var pathRefs2 = Array.from(depths, (_ref) => {
      var [, p2] = _ref;
      return Editor.pathRef(editor, p2);
    });
    for (var pathRef3 of pathRefs2) {
      var path3 = pathRef3.unref();
      if (path3) {
        var [node3] = Editor.node(editor, path3);
        editor.apply({
          type: "remove_node",
          path: path3,
          node: node3
        });
      }
    }
  });
};
var setNodes = function setNodes2(editor, props2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Editor.withoutNormalizing(editor, () => {
    var {
      match: match5,
      at: at2 = editor.selection,
      compare: compare2,
      merge: merge2
    } = options;
    var {
      hanging = false,
      mode = "lowest",
      split = false,
      voids = false
    } = options;
    if (!at2) {
      return;
    }
    if (match5 == null) {
      match5 = Path.isPath(at2) ? matchPath(editor, at2) : (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2);
    }
    if (!hanging && Range.isRange(at2)) {
      at2 = Editor.unhangRange(editor, at2, {
        voids
      });
    }
    if (split && Range.isRange(at2)) {
      if (Range.isCollapsed(at2) && Editor.leaf(editor, at2.anchor)[0].text.length > 0) {
        return;
      }
      var rangeRef3 = Editor.rangeRef(editor, at2, {
        affinity: "inward"
      });
      var [start2, end2] = Range.edges(at2);
      var splitMode = mode === "lowest" ? "lowest" : "highest";
      var endAtEndOfNode = Editor.isEnd(editor, end2, end2.path);
      Transforms.splitNodes(editor, {
        at: end2,
        match: match5,
        mode: splitMode,
        voids,
        always: !endAtEndOfNode
      });
      var startAtStartOfNode = Editor.isStart(editor, start2, start2.path);
      Transforms.splitNodes(editor, {
        at: start2,
        match: match5,
        mode: splitMode,
        voids,
        always: !startAtStartOfNode
      });
      at2 = rangeRef3.unref();
      if (options.at == null) {
        Transforms.select(editor, at2);
      }
    }
    if (!compare2) {
      compare2 = (prop, nodeProp) => prop !== nodeProp;
    }
    for (var [node3, path3] of Editor.nodes(editor, {
      at: at2,
      match: match5,
      mode,
      voids
    })) {
      var properties2 = {};
      var newProperties = {};
      if (path3.length === 0) {
        continue;
      }
      var hasChanges = false;
      for (var k3 in props2) {
        if (k3 === "children" || k3 === "text") {
          continue;
        }
        if (compare2(props2[k3], node3[k3])) {
          hasChanges = true;
          if (node3.hasOwnProperty(k3)) properties2[k3] = node3[k3];
          if (merge2) {
            if (props2[k3] != null) newProperties[k3] = merge2(node3[k3], props2[k3]);
          } else {
            if (props2[k3] != null) newProperties[k3] = props2[k3];
          }
        }
      }
      if (hasChanges) {
        editor.apply({
          type: "set_node",
          path: path3,
          properties: properties2,
          newProperties
        });
      }
    }
  });
};
var deleteRange = (editor, range2) => {
  if (Range.isCollapsed(range2)) {
    return range2.anchor;
  } else {
    var [, end2] = Range.edges(range2);
    var pointRef3 = Editor.pointRef(editor, end2);
    Transforms.delete(editor, {
      at: range2
    });
    return pointRef3.unref();
  }
};
var splitNodes = function splitNodes2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  Editor.withoutNormalizing(editor, () => {
    var {
      mode = "lowest",
      voids = false
    } = options;
    var {
      match: match5,
      at: at2 = editor.selection,
      height = 0,
      always = false
    } = options;
    if (match5 == null) {
      match5 = (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2);
    }
    if (Range.isRange(at2)) {
      at2 = deleteRange(editor, at2);
    }
    if (Path.isPath(at2)) {
      var path3 = at2;
      var point3 = Editor.point(editor, path3);
      var [parent3] = Editor.parent(editor, path3);
      match5 = (n2) => n2 === parent3;
      height = point3.path.length - path3.length + 1;
      at2 = point3;
      always = true;
    }
    if (!at2) {
      return;
    }
    var beforeRef = Editor.pointRef(editor, at2, {
      affinity: "backward"
    });
    var afterRef;
    try {
      var [highest] = Editor.nodes(editor, {
        at: at2,
        match: match5,
        mode,
        voids
      });
      if (!highest) {
        return;
      }
      var voidMatch = Editor.void(editor, {
        at: at2,
        mode: "highest"
      });
      var nudge = 0;
      if (!voids && voidMatch) {
        var [voidNode, voidPath] = voidMatch;
        if (Element$3.isElement(voidNode) && editor.isInline(voidNode)) {
          var after3 = Editor.after(editor, voidPath);
          if (!after3) {
            var text = {
              text: ""
            };
            var afterPath = Path.next(voidPath);
            Transforms.insertNodes(editor, text, {
              at: afterPath,
              voids
            });
            after3 = Editor.point(editor, afterPath);
          }
          at2 = after3;
          always = true;
        }
        var siblingHeight = at2.path.length - voidPath.length;
        height = siblingHeight + 1;
        always = true;
      }
      afterRef = Editor.pointRef(editor, at2);
      var depth = at2.path.length - height;
      var [, highestPath] = highest;
      var lowestPath = at2.path.slice(0, depth);
      var position2 = height === 0 ? at2.offset : at2.path[depth] + nudge;
      for (var [node3, _path] of Editor.levels(editor, {
        at: lowestPath,
        reverse: true,
        voids
      })) {
        var split = false;
        if (_path.length < highestPath.length || _path.length === 0 || !voids && Element$3.isElement(node3) && Editor.isVoid(editor, node3)) {
          break;
        }
        var _point = beforeRef.current;
        var isEnd2 = Editor.isEnd(editor, _point, _path);
        if (always || !beforeRef || !Editor.isEdge(editor, _point, _path)) {
          split = true;
          var properties2 = Node$1.extractProps(node3);
          editor.apply({
            type: "split_node",
            path: _path,
            position: position2,
            properties: properties2
          });
        }
        position2 = _path[_path.length - 1] + (split || isEnd2 ? 1 : 0);
      }
      if (options.at == null) {
        var _point2 = afterRef.current || Editor.end(editor, []);
        Transforms.select(editor, _point2);
      }
    } finally {
      var _afterRef;
      beforeRef.unref();
      (_afterRef = afterRef) === null || _afterRef === void 0 || _afterRef.unref();
    }
  });
};
var unsetNodes = function unsetNodes2(editor, props2) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!Array.isArray(props2)) {
    props2 = [props2];
  }
  var obj = {};
  for (var key2 of props2) {
    obj[key2] = null;
  }
  Transforms.setNodes(editor, obj, options);
};
var unwrapNodes = function unwrapNodes2(editor) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  Editor.withoutNormalizing(editor, () => {
    var {
      mode = "lowest",
      split = false,
      voids = false
    } = options;
    var {
      at: at2 = editor.selection,
      match: match5
    } = options;
    if (!at2) {
      return;
    }
    if (match5 == null) {
      match5 = Path.isPath(at2) ? matchPath(editor, at2) : (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2);
    }
    if (Path.isPath(at2)) {
      at2 = Editor.range(editor, at2);
    }
    var rangeRef3 = Range.isRange(at2) ? Editor.rangeRef(editor, at2) : null;
    var matches2 = Editor.nodes(editor, {
      at: at2,
      match: match5,
      mode,
      voids
    });
    var pathRefs2 = Array.from(
      matches2,
      (_ref) => {
        var [, p2] = _ref;
        return Editor.pathRef(editor, p2);
      }
      // unwrapNode will call liftNode which does not support splitting the node when nested.
      // If we do not reverse the order and call it from top to the bottom, it will remove all blocks
      // that wrap target node. So we reverse the order.
    ).reverse();
    var _loop = function _loop2() {
      var path3 = pathRef3.unref();
      var [node3] = Editor.node(editor, path3);
      var range2 = Editor.range(editor, path3);
      if (split && rangeRef3) {
        range2 = Range.intersection(rangeRef3.current, range2);
      }
      Transforms.liftNodes(editor, {
        at: range2,
        match: (n2) => Element$3.isAncestor(node3) && node3.children.includes(n2),
        voids
      });
    };
    for (var pathRef3 of pathRefs2) {
      _loop();
    }
    if (rangeRef3) {
      rangeRef3.unref();
    }
  });
};
function ownKeys$f(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$f(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$f(Object(t3), true).forEach(function(r3) {
      _defineProperty$4(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$f(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var wrapNodes = function wrapNodes2(editor, element) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Editor.withoutNormalizing(editor, () => {
    var {
      mode = "lowest",
      split = false,
      voids = false
    } = options;
    var {
      match: match5,
      at: at2 = editor.selection
    } = options;
    if (!at2) {
      return;
    }
    if (match5 == null) {
      if (Path.isPath(at2)) {
        match5 = matchPath(editor, at2);
      } else if (editor.isInline(element)) {
        match5 = (n2) => Element$3.isElement(n2) && Editor.isInline(editor, n2) || Text$1.isText(n2);
      } else {
        match5 = (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2);
      }
    }
    if (split && Range.isRange(at2)) {
      var [start2, end2] = Range.edges(at2);
      var rangeRef3 = Editor.rangeRef(editor, at2, {
        affinity: "inward"
      });
      Transforms.splitNodes(editor, {
        at: end2,
        match: match5,
        voids
      });
      Transforms.splitNodes(editor, {
        at: start2,
        match: match5,
        voids
      });
      at2 = rangeRef3.unref();
      if (options.at == null) {
        Transforms.select(editor, at2);
      }
    }
    var roots = Array.from(Editor.nodes(editor, {
      at: at2,
      match: editor.isInline(element) ? (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2) : (n2) => Editor.isEditor(n2),
      mode: "lowest",
      voids
    }));
    var _loop = function _loop2() {
      var a4 = Range.isRange(at2) ? Range.intersection(at2, Editor.range(editor, rootPath)) : at2;
      if (!a4) {
        return 0;
      }
      var matches2 = Array.from(Editor.nodes(editor, {
        at: a4,
        match: match5,
        mode,
        voids
      }));
      if (matches2.length > 0) {
        var [first2] = matches2;
        var last2 = matches2[matches2.length - 1];
        var [, firstPath] = first2;
        var [, lastPath] = last2;
        if (firstPath.length === 0 && lastPath.length === 0) {
          return 0;
        }
        var commonPath = Path.equals(firstPath, lastPath) ? Path.parent(firstPath) : Path.common(firstPath, lastPath);
        var range2 = Editor.range(editor, firstPath, lastPath);
        var commonNodeEntry = Editor.node(editor, commonPath);
        var [commonNode] = commonNodeEntry;
        var depth = commonPath.length + 1;
        var wrapperPath = Path.next(lastPath.slice(0, depth));
        var wrapper = _objectSpread$f(_objectSpread$f({}, element), {}, {
          children: []
        });
        Transforms.insertNodes(editor, wrapper, {
          at: wrapperPath,
          voids
        });
        Transforms.moveNodes(editor, {
          at: range2,
          match: (n2) => Element$3.isAncestor(commonNode) && commonNode.children.includes(n2),
          to: wrapperPath.concat(0),
          voids
        });
      }
    }, _ret;
    for (var [, rootPath] of roots) {
      _ret = _loop();
      if (_ret === 0) continue;
    }
  });
};
var createEditor$1 = () => {
  var editor = {
    children: [],
    operations: [],
    selection: null,
    marks: null,
    isElementReadOnly: () => false,
    isInline: () => false,
    isSelectable: () => true,
    isVoid: () => false,
    markableVoid: () => false,
    onChange: () => {
    },
    // Core
    apply: function apply$12() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return apply$3(editor, ...args);
    },
    // Editor
    addMark: function addMark$1() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return addMark(editor, ...args);
    },
    deleteBackward: function deleteBackward$1() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return deleteBackward(editor, ...args);
    },
    deleteForward: function deleteForward$1() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return deleteForward(editor, ...args);
    },
    deleteFragment: function deleteFragment$1() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      return deleteFragment(editor, ...args);
    },
    getFragment: function getFragment$1() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }
      return getFragment(editor, ...args);
    },
    insertBreak: function insertBreak$1() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      return insertBreak(editor, ...args);
    },
    insertSoftBreak: function insertSoftBreak$1() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }
      return insertSoftBreak(editor, ...args);
    },
    insertFragment: function insertFragment$1() {
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }
      return insertFragment(editor, ...args);
    },
    insertNode: function insertNode$1() {
      for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        args[_key10] = arguments[_key10];
      }
      return insertNode(editor, ...args);
    },
    insertText: function insertText$1() {
      for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        args[_key11] = arguments[_key11];
      }
      return insertText(editor, ...args);
    },
    normalizeNode: function normalizeNode$1() {
      for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        args[_key12] = arguments[_key12];
      }
      return normalizeNode(editor, ...args);
    },
    removeMark: function removeMark$1() {
      for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        args[_key13] = arguments[_key13];
      }
      return removeMark(editor, ...args);
    },
    getDirtyPaths: function getDirtyPaths$1() {
      for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
        args[_key14] = arguments[_key14];
      }
      return getDirtyPaths(editor, ...args);
    },
    shouldNormalize: function shouldNormalize$1() {
      for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
        args[_key15] = arguments[_key15];
      }
      return shouldNormalize(editor, ...args);
    },
    // Editor interface
    above: function above$1() {
      for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
        args[_key16] = arguments[_key16];
      }
      return above(editor, ...args);
    },
    after: function after$1() {
      for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
        args[_key17] = arguments[_key17];
      }
      return after(editor, ...args);
    },
    before: function before$1() {
      for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
        args[_key18] = arguments[_key18];
      }
      return before(editor, ...args);
    },
    collapse: function collapse$1() {
      for (var _len19 = arguments.length, args = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
        args[_key19] = arguments[_key19];
      }
      return collapse(editor, ...args);
    },
    delete: function _delete2() {
      for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
        args[_key20] = arguments[_key20];
      }
      return deleteText(editor, ...args);
    },
    deselect: function deselect$1() {
      for (var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
        args[_key21] = arguments[_key21];
      }
      return deselect(editor, ...args);
    },
    edges: function edges$1() {
      for (var _len22 = arguments.length, args = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
        args[_key22] = arguments[_key22];
      }
      return edges(editor, ...args);
    },
    elementReadOnly: function elementReadOnly$1() {
      for (var _len23 = arguments.length, args = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
        args[_key23] = arguments[_key23];
      }
      return elementReadOnly(editor, ...args);
    },
    end: function end$1() {
      for (var _len24 = arguments.length, args = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
        args[_key24] = arguments[_key24];
      }
      return end(editor, ...args);
    },
    first: function first$1$1() {
      for (var _len25 = arguments.length, args = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
        args[_key25] = arguments[_key25];
      }
      return first$1(editor, ...args);
    },
    fragment: function fragment$1() {
      for (var _len26 = arguments.length, args = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
        args[_key26] = arguments[_key26];
      }
      return fragment(editor, ...args);
    },
    getMarks: function getMarks() {
      for (var _len27 = arguments.length, args = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
        args[_key27] = arguments[_key27];
      }
      return marks(editor, ...args);
    },
    hasBlocks: function hasBlocks$1() {
      for (var _len28 = arguments.length, args = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
        args[_key28] = arguments[_key28];
      }
      return hasBlocks(editor, ...args);
    },
    hasInlines: function hasInlines$1() {
      for (var _len29 = arguments.length, args = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
        args[_key29] = arguments[_key29];
      }
      return hasInlines(editor, ...args);
    },
    hasPath: function hasPath$12() {
      for (var _len30 = arguments.length, args = new Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
        args[_key30] = arguments[_key30];
      }
      return hasPath$3(editor, ...args);
    },
    hasTexts: function hasTexts$1() {
      for (var _len31 = arguments.length, args = new Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
        args[_key31] = arguments[_key31];
      }
      return hasTexts(editor, ...args);
    },
    insertNodes: function insertNodes$1() {
      for (var _len32 = arguments.length, args = new Array(_len32), _key32 = 0; _key32 < _len32; _key32++) {
        args[_key32] = arguments[_key32];
      }
      return insertNodes(editor, ...args);
    },
    isBlock: function isBlock$1() {
      for (var _len33 = arguments.length, args = new Array(_len33), _key33 = 0; _key33 < _len33; _key33++) {
        args[_key33] = arguments[_key33];
      }
      return isBlock(editor, ...args);
    },
    isEdge: function isEdge$1$1() {
      for (var _len34 = arguments.length, args = new Array(_len34), _key34 = 0; _key34 < _len34; _key34++) {
        args[_key34] = arguments[_key34];
      }
      return isEdge$1(editor, ...args);
    },
    isEmpty: function isEmpty$1$1() {
      for (var _len35 = arguments.length, args = new Array(_len35), _key35 = 0; _key35 < _len35; _key35++) {
        args[_key35] = arguments[_key35];
      }
      return isEmpty$1(editor, ...args);
    },
    isEnd: function isEnd$1() {
      for (var _len36 = arguments.length, args = new Array(_len36), _key36 = 0; _key36 < _len36; _key36++) {
        args[_key36] = arguments[_key36];
      }
      return isEnd(editor, ...args);
    },
    isNormalizing: function isNormalizing$1() {
      for (var _len37 = arguments.length, args = new Array(_len37), _key37 = 0; _key37 < _len37; _key37++) {
        args[_key37] = arguments[_key37];
      }
      return isNormalizing(editor, ...args);
    },
    isStart: function isStart$1() {
      for (var _len38 = arguments.length, args = new Array(_len38), _key38 = 0; _key38 < _len38; _key38++) {
        args[_key38] = arguments[_key38];
      }
      return isStart(editor, ...args);
    },
    last: function last$12() {
      for (var _len39 = arguments.length, args = new Array(_len39), _key39 = 0; _key39 < _len39; _key39++) {
        args[_key39] = arguments[_key39];
      }
      return last$3(editor, ...args);
    },
    leaf: function leaf$1() {
      for (var _len40 = arguments.length, args = new Array(_len40), _key40 = 0; _key40 < _len40; _key40++) {
        args[_key40] = arguments[_key40];
      }
      return leaf(editor, ...args);
    },
    levels: function levels$1() {
      for (var _len41 = arguments.length, args = new Array(_len41), _key41 = 0; _key41 < _len41; _key41++) {
        args[_key41] = arguments[_key41];
      }
      return levels(editor, ...args);
    },
    liftNodes: function liftNodes$1() {
      for (var _len42 = arguments.length, args = new Array(_len42), _key42 = 0; _key42 < _len42; _key42++) {
        args[_key42] = arguments[_key42];
      }
      return liftNodes(editor, ...args);
    },
    mergeNodes: function mergeNodes$1() {
      for (var _len43 = arguments.length, args = new Array(_len43), _key43 = 0; _key43 < _len43; _key43++) {
        args[_key43] = arguments[_key43];
      }
      return mergeNodes(editor, ...args);
    },
    move: function move$1() {
      for (var _len44 = arguments.length, args = new Array(_len44), _key44 = 0; _key44 < _len44; _key44++) {
        args[_key44] = arguments[_key44];
      }
      return move(editor, ...args);
    },
    moveNodes: function moveNodes$1() {
      for (var _len45 = arguments.length, args = new Array(_len45), _key45 = 0; _key45 < _len45; _key45++) {
        args[_key45] = arguments[_key45];
      }
      return moveNodes(editor, ...args);
    },
    next: function next$1() {
      for (var _len46 = arguments.length, args = new Array(_len46), _key46 = 0; _key46 < _len46; _key46++) {
        args[_key46] = arguments[_key46];
      }
      return next(editor, ...args);
    },
    node: function node$1() {
      for (var _len47 = arguments.length, args = new Array(_len47), _key47 = 0; _key47 < _len47; _key47++) {
        args[_key47] = arguments[_key47];
      }
      return node(editor, ...args);
    },
    nodes: function nodes$1() {
      for (var _len48 = arguments.length, args = new Array(_len48), _key48 = 0; _key48 < _len48; _key48++) {
        args[_key48] = arguments[_key48];
      }
      return nodes(editor, ...args);
    },
    normalize: function normalize$1() {
      for (var _len49 = arguments.length, args = new Array(_len49), _key49 = 0; _key49 < _len49; _key49++) {
        args[_key49] = arguments[_key49];
      }
      return normalize(editor, ...args);
    },
    parent: function parent$12() {
      for (var _len50 = arguments.length, args = new Array(_len50), _key50 = 0; _key50 < _len50; _key50++) {
        args[_key50] = arguments[_key50];
      }
      return parent$2(editor, ...args);
    },
    path: function path$12() {
      for (var _len51 = arguments.length, args = new Array(_len51), _key51 = 0; _key51 < _len51; _key51++) {
        args[_key51] = arguments[_key51];
      }
      return path$2(editor, ...args);
    },
    pathRef: function pathRef$1() {
      for (var _len52 = arguments.length, args = new Array(_len52), _key52 = 0; _key52 < _len52; _key52++) {
        args[_key52] = arguments[_key52];
      }
      return pathRef(editor, ...args);
    },
    pathRefs: function pathRefs$1() {
      for (var _len53 = arguments.length, args = new Array(_len53), _key53 = 0; _key53 < _len53; _key53++) {
        args[_key53] = arguments[_key53];
      }
      return pathRefs(editor, ...args);
    },
    point: function point$1$1() {
      for (var _len54 = arguments.length, args = new Array(_len54), _key54 = 0; _key54 < _len54; _key54++) {
        args[_key54] = arguments[_key54];
      }
      return point$1(editor, ...args);
    },
    pointRef: function pointRef$1() {
      for (var _len55 = arguments.length, args = new Array(_len55), _key55 = 0; _key55 < _len55; _key55++) {
        args[_key55] = arguments[_key55];
      }
      return pointRef(editor, ...args);
    },
    pointRefs: function pointRefs$1() {
      for (var _len56 = arguments.length, args = new Array(_len56), _key56 = 0; _key56 < _len56; _key56++) {
        args[_key56] = arguments[_key56];
      }
      return pointRefs(editor, ...args);
    },
    positions: function positions$1() {
      for (var _len57 = arguments.length, args = new Array(_len57), _key57 = 0; _key57 < _len57; _key57++) {
        args[_key57] = arguments[_key57];
      }
      return positions(editor, ...args);
    },
    previous: function previous$1() {
      for (var _len58 = arguments.length, args = new Array(_len58), _key58 = 0; _key58 < _len58; _key58++) {
        args[_key58] = arguments[_key58];
      }
      return previous(editor, ...args);
    },
    range: function range$1$1() {
      for (var _len59 = arguments.length, args = new Array(_len59), _key59 = 0; _key59 < _len59; _key59++) {
        args[_key59] = arguments[_key59];
      }
      return range$1(editor, ...args);
    },
    rangeRef: function rangeRef$1() {
      for (var _len60 = arguments.length, args = new Array(_len60), _key60 = 0; _key60 < _len60; _key60++) {
        args[_key60] = arguments[_key60];
      }
      return rangeRef(editor, ...args);
    },
    rangeRefs: function rangeRefs$1() {
      for (var _len61 = arguments.length, args = new Array(_len61), _key61 = 0; _key61 < _len61; _key61++) {
        args[_key61] = arguments[_key61];
      }
      return rangeRefs(editor, ...args);
    },
    removeNodes: function removeNodes$1() {
      for (var _len62 = arguments.length, args = new Array(_len62), _key62 = 0; _key62 < _len62; _key62++) {
        args[_key62] = arguments[_key62];
      }
      return removeNodes(editor, ...args);
    },
    select: function select$1() {
      for (var _len63 = arguments.length, args = new Array(_len63), _key63 = 0; _key63 < _len63; _key63++) {
        args[_key63] = arguments[_key63];
      }
      return select(editor, ...args);
    },
    setNodes: function setNodes$1() {
      for (var _len64 = arguments.length, args = new Array(_len64), _key64 = 0; _key64 < _len64; _key64++) {
        args[_key64] = arguments[_key64];
      }
      return setNodes(editor, ...args);
    },
    setNormalizing: function setNormalizing$1() {
      for (var _len65 = arguments.length, args = new Array(_len65), _key65 = 0; _key65 < _len65; _key65++) {
        args[_key65] = arguments[_key65];
      }
      return setNormalizing(editor, ...args);
    },
    setPoint: function setPoint$1() {
      for (var _len66 = arguments.length, args = new Array(_len66), _key66 = 0; _key66 < _len66; _key66++) {
        args[_key66] = arguments[_key66];
      }
      return setPoint(editor, ...args);
    },
    setSelection: function setSelection$1() {
      for (var _len67 = arguments.length, args = new Array(_len67), _key67 = 0; _key67 < _len67; _key67++) {
        args[_key67] = arguments[_key67];
      }
      return setSelection(editor, ...args);
    },
    splitNodes: function splitNodes$1() {
      for (var _len68 = arguments.length, args = new Array(_len68), _key68 = 0; _key68 < _len68; _key68++) {
        args[_key68] = arguments[_key68];
      }
      return splitNodes(editor, ...args);
    },
    start: function start$1() {
      for (var _len69 = arguments.length, args = new Array(_len69), _key69 = 0; _key69 < _len69; _key69++) {
        args[_key69] = arguments[_key69];
      }
      return start(editor, ...args);
    },
    string: function string$1$1() {
      for (var _len70 = arguments.length, args = new Array(_len70), _key70 = 0; _key70 < _len70; _key70++) {
        args[_key70] = arguments[_key70];
      }
      return string$1(editor, ...args);
    },
    unhangRange: function unhangRange$1() {
      for (var _len71 = arguments.length, args = new Array(_len71), _key71 = 0; _key71 < _len71; _key71++) {
        args[_key71] = arguments[_key71];
      }
      return unhangRange(editor, ...args);
    },
    unsetNodes: function unsetNodes$1() {
      for (var _len72 = arguments.length, args = new Array(_len72), _key72 = 0; _key72 < _len72; _key72++) {
        args[_key72] = arguments[_key72];
      }
      return unsetNodes(editor, ...args);
    },
    unwrapNodes: function unwrapNodes$1() {
      for (var _len73 = arguments.length, args = new Array(_len73), _key73 = 0; _key73 < _len73; _key73++) {
        args[_key73] = arguments[_key73];
      }
      return unwrapNodes(editor, ...args);
    },
    void: function _void() {
      for (var _len74 = arguments.length, args = new Array(_len74), _key74 = 0; _key74 < _len74; _key74++) {
        args[_key74] = arguments[_key74];
      }
      return getVoid(editor, ...args);
    },
    withoutNormalizing: function withoutNormalizing$1() {
      for (var _len75 = arguments.length, args = new Array(_len75), _key75 = 0; _key75 < _len75; _key75++) {
        args[_key75] = arguments[_key75];
      }
      return withoutNormalizing(editor, ...args);
    },
    wrapNodes: function wrapNodes$1() {
      for (var _len76 = arguments.length, args = new Array(_len76), _key76 = 0; _key76 < _len76; _key76++) {
        args[_key76] = arguments[_key76];
      }
      return wrapNodes(editor, ...args);
    },
    shouldMergeNodesRemovePrevNode: function shouldMergeNodesRemovePrevNode$1() {
      for (var _len77 = arguments.length, args = new Array(_len77), _key77 = 0; _key77 < _len77; _key77++) {
        args[_key77] = arguments[_key77];
      }
      return shouldMergeNodesRemovePrevNode(editor, ...args);
    }
  };
  return editor;
};
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i3;
  for (i3 = 0; i3 < sourceKeys.length; i3++) {
    key2 = sourceKeys[i3];
    if (excluded.indexOf(key2) >= 0) continue;
    target[key2] = source[key2];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key2, i3;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i3 = 0; i3 < sourceSymbolKeys.length; i3++) {
      key2 = sourceSymbolKeys[i3];
      if (excluded.indexOf(key2) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2)) continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _typeof$2(o2) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$2(o2);
}
function _toPrimitive$1(input, hint) {
  if (_typeof$2(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$2(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey$1(arg) {
  var key2 = _toPrimitive$1(arg, "string");
  return _typeof$2(key2) === "symbol" ? key2 : String(key2);
}
function _defineProperty$3(obj, key2, value) {
  key2 = _toPropertyKey$1(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var EditorContext = /* @__PURE__ */ createContext$1(null);
var useSlateStatic = () => {
  var editor = useContext(EditorContext);
  if (!editor) {
    throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
  }
  return editor;
};
var _navigator$userAgent$, _navigator$userAgent$2;
var REACT_MAJOR_VERSION = parseInt(React__default.version.split(".")[0], 10);
var IS_IOS = typeof navigator !== "undefined" && typeof window !== "undefined" && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var IS_APPLE = typeof navigator !== "undefined" && /Mac OS X/.test(navigator.userAgent);
var IS_ANDROID = typeof navigator !== "undefined" && /Android/.test(navigator.userAgent);
var IS_FIREFOX = typeof navigator !== "undefined" && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
var IS_WEBKIT = typeof navigator !== "undefined" && /AppleWebKit(?!.*Chrome)/i.test(navigator.userAgent);
var IS_EDGE_LEGACY = typeof navigator !== "undefined" && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent);
var IS_CHROME = typeof navigator !== "undefined" && /Chrome/i.test(navigator.userAgent);
var IS_CHROME_LEGACY = typeof navigator !== "undefined" && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent);
var IS_ANDROID_CHROME_LEGACY = IS_ANDROID && typeof navigator !== "undefined" && /Chrome?\/(?:[0-5]?\d)(?:\.)/i.test(navigator.userAgent);
var IS_FIREFOX_LEGACY = typeof navigator !== "undefined" && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent);
var IS_UC_MOBILE = typeof navigator !== "undefined" && /.*UCBrowser/.test(navigator.userAgent);
var IS_WECHATBROWSER = typeof navigator !== "undefined" && /.*Wechat/.test(navigator.userAgent) && !/.*MacWechat/.test(navigator.userAgent);
var CAN_USE_DOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var IS_SAFARI_LEGACY = typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && /Version\/(\d+)/.test(navigator.userAgent) && ((_navigator$userAgent$ = navigator.userAgent.match(/Version\/(\d+)/)) !== null && _navigator$userAgent$ !== void 0 && _navigator$userAgent$[1] ? parseInt((_navigator$userAgent$2 = navigator.userAgent.match(/Version\/(\d+)/)) === null || _navigator$userAgent$2 === void 0 ? void 0 : _navigator$userAgent$2[1], 10) < 17 : false);
var HAS_BEFORE_INPUT_SUPPORT = (!IS_CHROME_LEGACY || !IS_ANDROID_CHROME_LEGACY) && !IS_EDGE_LEGACY && // globalThis is undefined in older browsers
typeof globalThis !== "undefined" && globalThis.InputEvent && // @ts-ignore The `getTargetRanges` property isn't recognized.
typeof globalThis.InputEvent.prototype.getTargetRanges === "function";
var NODE_TO_INDEX = /* @__PURE__ */ new WeakMap();
var NODE_TO_PARENT = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_WINDOW = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_ELEMENT = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_PLACEHOLDER_ELEMENT = /* @__PURE__ */ new WeakMap();
var ELEMENT_TO_NODE = /* @__PURE__ */ new WeakMap();
var NODE_TO_ELEMENT = /* @__PURE__ */ new WeakMap();
var NODE_TO_KEY = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_KEY_TO_ELEMENT = /* @__PURE__ */ new WeakMap();
var IS_READ_ONLY = /* @__PURE__ */ new WeakMap();
var IS_FOCUSED = /* @__PURE__ */ new WeakMap();
var IS_COMPOSING = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_USER_SELECTION = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_ON_CHANGE = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_SCHEDULE_FLUSH = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_PENDING_INSERTION_MARKS = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_USER_MARKS = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_PENDING_DIFFS = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_PENDING_ACTION = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_PENDING_SELECTION = /* @__PURE__ */ new WeakMap();
var EDITOR_TO_FORCE_RENDER = /* @__PURE__ */ new WeakMap();
var PLACEHOLDER_SYMBOL = Symbol("placeholder");
var MARK_PLACEHOLDER_SYMBOL = Symbol("mark-placeholder");
var DOMText = globalThis.Text;
var getDefaultView = (value) => {
  return value && value.ownerDocument && value.ownerDocument.defaultView || null;
};
var isDOMComment = (value) => {
  return isDOMNode(value) && value.nodeType === 8;
};
var isDOMElement = (value) => {
  return isDOMNode(value) && value.nodeType === 1;
};
var isDOMNode = (value) => {
  var window2 = getDefaultView(value);
  return !!window2 && value instanceof window2.Node;
};
var isDOMSelection = (value) => {
  var window2 = value && value.anchorNode && getDefaultView(value.anchorNode);
  return !!window2 && value instanceof window2.Selection;
};
var isDOMText = (value) => {
  return isDOMNode(value) && value.nodeType === 3;
};
var isPlainTextOnlyPaste = (event) => {
  return event.clipboardData && event.clipboardData.getData("text/plain") !== "" && event.clipboardData.types.length === 1;
};
var normalizeDOMPoint = (domPoint) => {
  var [node3, offset2] = domPoint;
  if (isDOMElement(node3) && node3.childNodes.length) {
    var isLast = offset2 === node3.childNodes.length;
    var index2 = isLast ? offset2 - 1 : offset2;
    [node3, index2] = getEditableChildAndIndex(node3, index2, isLast ? "backward" : "forward");
    isLast = index2 < offset2;
    while (isDOMElement(node3) && node3.childNodes.length) {
      var i3 = isLast ? node3.childNodes.length - 1 : 0;
      node3 = getEditableChild(node3, i3, isLast ? "backward" : "forward");
    }
    offset2 = isLast && node3.textContent != null ? node3.textContent.length : 0;
  }
  return [node3, offset2];
};
var hasShadowRoot = (node3) => {
  var parent3 = node3 && node3.parentNode;
  while (parent3) {
    if (parent3.toString() === "[object ShadowRoot]") {
      return true;
    }
    parent3 = parent3.parentNode;
  }
  return false;
};
var getEditableChildAndIndex = (parent3, index2, direction2) => {
  var {
    childNodes
  } = parent3;
  var child = childNodes[index2];
  var i3 = index2;
  var triedForward = false;
  var triedBackward = false;
  while (isDOMComment(child) || isDOMElement(child) && child.childNodes.length === 0 || isDOMElement(child) && child.getAttribute("contenteditable") === "false") {
    if (triedForward && triedBackward) {
      break;
    }
    if (i3 >= childNodes.length) {
      triedForward = true;
      i3 = index2 - 1;
      direction2 = "backward";
      continue;
    }
    if (i3 < 0) {
      triedBackward = true;
      i3 = index2 + 1;
      direction2 = "forward";
      continue;
    }
    child = childNodes[i3];
    index2 = i3;
    i3 += direction2 === "forward" ? 1 : -1;
  }
  return [child, index2];
};
var getEditableChild = (parent3, index2, direction2) => {
  var [child] = getEditableChildAndIndex(parent3, index2, direction2);
  return child;
};
var getPlainText = (domNode) => {
  var text = "";
  if (isDOMText(domNode) && domNode.nodeValue) {
    return domNode.nodeValue;
  }
  if (isDOMElement(domNode)) {
    for (var childNode of Array.from(domNode.childNodes)) {
      text += getPlainText(childNode);
    }
    var display = getComputedStyle(domNode).getPropertyValue("display");
    if (display === "block" || display === "list" || domNode.tagName === "BR") {
      text += "\n";
    }
  }
  return text;
};
var catchSlateFragment = /data-slate-fragment="(.+?)"/m;
var getSlateFragmentAttribute = (dataTransfer) => {
  var htmlData = dataTransfer.getData("text/html");
  var [, fragment2] = htmlData.match(catchSlateFragment) || [];
  return fragment2;
};
var isTrackedMutation = (editor, mutation, batch) => {
  var {
    target
  } = mutation;
  if (isDOMElement(target) && target.matches('[contentEditable="false"]')) {
    return false;
  }
  var {
    document: document2
  } = ReactEditor.getWindow(editor);
  if (document2.contains(target)) {
    return ReactEditor.hasDOMNode(editor, target, {
      editable: true
    });
  }
  var parentMutation = batch.find((_ref) => {
    var {
      addedNodes,
      removedNodes
    } = _ref;
    for (var node3 of addedNodes) {
      if (node3 === target || node3.contains(target)) {
        return true;
      }
    }
    for (var _node of removedNodes) {
      if (_node === target || _node.contains(target)) {
        return true;
      }
    }
  });
  if (!parentMutation || parentMutation === mutation) {
    return false;
  }
  return isTrackedMutation(editor, parentMutation, batch);
};
var getActiveElement = () => {
  var activeElement = document.activeElement;
  while ((_activeElement = activeElement) !== null && _activeElement !== void 0 && _activeElement.shadowRoot && (_activeElement$shadow = activeElement.shadowRoot) !== null && _activeElement$shadow !== void 0 && _activeElement$shadow.activeElement) {
    var _activeElement, _activeElement$shadow, _activeElement2;
    activeElement = (_activeElement2 = activeElement) === null || _activeElement2 === void 0 || (_activeElement2 = _activeElement2.shadowRoot) === null || _activeElement2 === void 0 ? void 0 : _activeElement2.activeElement;
  }
  return activeElement;
};
var n$1 = 0;
class Key {
  constructor() {
    _defineProperty$3(this, "id", void 0);
    this.id = "".concat(n$1++);
  }
}
var ReactEditor = {
  androidPendingDiffs: (editor) => EDITOR_TO_PENDING_DIFFS.get(editor),
  androidScheduleFlush: (editor) => {
    var _EDITOR_TO_SCHEDULE_F;
    (_EDITOR_TO_SCHEDULE_F = EDITOR_TO_SCHEDULE_FLUSH.get(editor)) === null || _EDITOR_TO_SCHEDULE_F === void 0 || _EDITOR_TO_SCHEDULE_F();
  },
  blur: (editor) => {
    var el2 = ReactEditor.toDOMNode(editor, editor);
    var root2 = ReactEditor.findDocumentOrShadowRoot(editor);
    IS_FOCUSED.set(editor, false);
    if (root2.activeElement === el2) {
      el2.blur();
    }
  },
  deselect: (editor) => {
    var {
      selection
    } = editor;
    var root2 = ReactEditor.findDocumentOrShadowRoot(editor);
    var domSelection = root2.getSelection();
    if (domSelection && domSelection.rangeCount > 0) {
      domSelection.removeAllRanges();
    }
    if (selection) {
      Transforms.deselect(editor);
    }
  },
  findDocumentOrShadowRoot: (editor) => {
    var el2 = ReactEditor.toDOMNode(editor, editor);
    var root2 = el2.getRootNode();
    if ((root2 instanceof Document || root2 instanceof ShadowRoot) && root2.getSelection != null) {
      return root2;
    }
    return el2.ownerDocument;
  },
  findEventRange: (editor, event) => {
    if ("nativeEvent" in event) {
      event = event.nativeEvent;
    }
    var {
      clientX: x3,
      clientY: y4,
      target
    } = event;
    if (x3 == null || y4 == null) {
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
    }
    var node3 = ReactEditor.toSlateNode(editor, event.target);
    var path3 = ReactEditor.findPath(editor, node3);
    if (Element$3.isElement(node3) && Editor.isVoid(editor, node3)) {
      var rect = target.getBoundingClientRect();
      var isPrev = editor.isInline(node3) ? x3 - rect.left < rect.left + rect.width - x3 : y4 - rect.top < rect.top + rect.height - y4;
      var edge = Editor.point(editor, path3, {
        edge: isPrev ? "start" : "end"
      });
      var point3 = isPrev ? Editor.before(editor, edge) : Editor.after(editor, edge);
      if (point3) {
        var _range = Editor.range(editor, point3);
        return _range;
      }
    }
    var domRange;
    var {
      document: document2
    } = ReactEditor.getWindow(editor);
    if (document2.caretRangeFromPoint) {
      domRange = document2.caretRangeFromPoint(x3, y4);
    } else {
      var position2 = document2.caretPositionFromPoint(x3, y4);
      if (position2) {
        domRange = document2.createRange();
        domRange.setStart(position2.offsetNode, position2.offset);
        domRange.setEnd(position2.offsetNode, position2.offset);
      }
    }
    if (!domRange) {
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
    }
    var range2 = ReactEditor.toSlateRange(editor, domRange, {
      exactMatch: false,
      suppressThrow: false
    });
    return range2;
  },
  findKey: (editor, node3) => {
    var key2 = NODE_TO_KEY.get(node3);
    if (!key2) {
      key2 = new Key();
      NODE_TO_KEY.set(node3, key2);
    }
    return key2;
  },
  findPath: (editor, node3) => {
    var path3 = [];
    var child = node3;
    while (true) {
      var parent3 = NODE_TO_PARENT.get(child);
      if (parent3 == null) {
        if (Editor.isEditor(child)) {
          return path3;
        } else {
          break;
        }
      }
      var i3 = NODE_TO_INDEX.get(child);
      if (i3 == null) {
        break;
      }
      path3.unshift(i3);
      child = parent3;
    }
    throw new Error("Unable to find the path for Slate node: ".concat(Scrubber.stringify(node3)));
  },
  focus: function focus(editor) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      retries: 5
    };
    if (IS_FOCUSED.get(editor)) {
      return;
    }
    if (options.retries <= 0) {
      throw new Error("Could not set focus, editor seems stuck with pending operations");
    }
    if (editor.operations.length > 0) {
      setTimeout(() => {
        ReactEditor.focus(editor, {
          retries: options.retries - 1
        });
      }, 10);
      return;
    }
    var el2 = ReactEditor.toDOMNode(editor, editor);
    var root2 = ReactEditor.findDocumentOrShadowRoot(editor);
    if (root2.activeElement !== el2) {
      if (editor.selection && root2 instanceof Document) {
        var domSelection = root2.getSelection();
        var domRange = ReactEditor.toDOMRange(editor, editor.selection);
        domSelection === null || domSelection === void 0 || domSelection.removeAllRanges();
        domSelection === null || domSelection === void 0 || domSelection.addRange(domRange);
      }
      if (!editor.selection) {
        Transforms.select(editor, Editor.start(editor, []));
        editor.onChange();
      }
      IS_FOCUSED.set(editor, true);
      el2.focus({
        preventScroll: true
      });
    }
  },
  getWindow: (editor) => {
    var window2 = EDITOR_TO_WINDOW.get(editor);
    if (!window2) {
      throw new Error("Unable to find a host window element for this editor");
    }
    return window2;
  },
  hasDOMNode: function hasDOMNode(editor, target) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var {
      editable = false
    } = options;
    var editorEl = ReactEditor.toDOMNode(editor, editor);
    var targetEl;
    try {
      targetEl = isDOMElement(target) ? target : target.parentElement;
    } catch (err) {
      if (err instanceof Error && !err.message.includes('Permission denied to access property "nodeType"')) {
        throw err;
      }
    }
    if (!targetEl) {
      return false;
    }
    return targetEl.closest("[data-slate-editor]") === editorEl && (!editable || targetEl.isContentEditable ? true : typeof targetEl.isContentEditable === "boolean" && // isContentEditable exists only on HTMLElement, and on other nodes it will be undefined
    // this is the core logic that lets you know you got the right editor.selection instead of null when editor is contenteditable="false"(readOnly)
    targetEl.closest('[contenteditable="false"]') === editorEl || !!targetEl.getAttribute("data-slate-zero-width"));
  },
  hasEditableTarget: (editor, target) => isDOMNode(target) && ReactEditor.hasDOMNode(editor, target, {
    editable: true
  }),
  hasRange: (editor, range2) => {
    var {
      anchor,
      focus: focus2
    } = range2;
    return Editor.hasPath(editor, anchor.path) && Editor.hasPath(editor, focus2.path);
  },
  hasSelectableTarget: (editor, target) => ReactEditor.hasEditableTarget(editor, target) || ReactEditor.isTargetInsideNonReadonlyVoid(editor, target),
  hasTarget: (editor, target) => isDOMNode(target) && ReactEditor.hasDOMNode(editor, target),
  insertData: (editor, data) => {
    editor.insertData(data);
  },
  insertFragmentData: (editor, data) => editor.insertFragmentData(data),
  insertTextData: (editor, data) => editor.insertTextData(data),
  isComposing: (editor) => {
    return !!IS_COMPOSING.get(editor);
  },
  isFocused: (editor) => !!IS_FOCUSED.get(editor),
  isReadOnly: (editor) => !!IS_READ_ONLY.get(editor),
  isTargetInsideNonReadonlyVoid: (editor, target) => {
    if (IS_READ_ONLY.get(editor)) return false;
    var slateNode = ReactEditor.hasTarget(editor, target) && ReactEditor.toSlateNode(editor, target);
    return Element$3.isElement(slateNode) && Editor.isVoid(editor, slateNode);
  },
  setFragmentData: (editor, data, originEvent) => editor.setFragmentData(data, originEvent),
  toDOMNode: (editor, node3) => {
    var KEY_TO_ELEMENT = EDITOR_TO_KEY_TO_ELEMENT.get(editor);
    var domNode = Editor.isEditor(node3) ? EDITOR_TO_ELEMENT.get(editor) : KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 ? void 0 : KEY_TO_ELEMENT.get(ReactEditor.findKey(editor, node3));
    if (!domNode) {
      throw new Error("Cannot resolve a DOM node from Slate node: ".concat(Scrubber.stringify(node3)));
    }
    return domNode;
  },
  toDOMPoint: (editor, point3) => {
    var [node3] = Editor.node(editor, point3.path);
    var el2 = ReactEditor.toDOMNode(editor, node3);
    var domPoint;
    if (Editor.void(editor, {
      at: point3
    })) {
      point3 = {
        path: point3.path,
        offset: 0
      };
    }
    var selector = "[data-slate-string], [data-slate-zero-width]";
    var texts = Array.from(el2.querySelectorAll(selector));
    var start2 = 0;
    for (var i3 = 0; i3 < texts.length; i3++) {
      var text = texts[i3];
      var domNode = text.childNodes[0];
      if (domNode == null || domNode.textContent == null) {
        continue;
      }
      var {
        length
      } = domNode.textContent;
      var attr = text.getAttribute("data-slate-length");
      var trueLength = attr == null ? length : parseInt(attr, 10);
      var end2 = start2 + trueLength;
      var nextText = texts[i3 + 1];
      if (point3.offset === end2 && nextText !== null && nextText !== void 0 && nextText.hasAttribute("data-slate-mark-placeholder")) {
        var _nextText$textContent;
        var domText = nextText.childNodes[0];
        domPoint = [
          // COMPAT: If we don't explicity set the dom point to be on the actual
          // dom text element, chrome will put the selection behind the actual dom
          // text element, causing domRange.getBoundingClientRect() calls on a collapsed
          // selection to return incorrect zero values (https://bugs.chromium.org/p/chromium/issues/detail?id=435438)
          // which will cause issues when scrolling to it.
          domText instanceof DOMText ? domText : nextText,
          (_nextText$textContent = nextText.textContent) !== null && _nextText$textContent !== void 0 && _nextText$textContent.startsWith("\uFEFF") ? 1 : 0
        ];
        break;
      }
      if (point3.offset <= end2) {
        var offset2 = Math.min(length, Math.max(0, point3.offset - start2));
        domPoint = [domNode, offset2];
        break;
      }
      start2 = end2;
    }
    if (!domPoint) {
      throw new Error("Cannot resolve a DOM point from Slate point: ".concat(Scrubber.stringify(point3)));
    }
    return domPoint;
  },
  toDOMRange: (editor, range2) => {
    var {
      anchor,
      focus: focus2
    } = range2;
    var isBackward = Range.isBackward(range2);
    var domAnchor = ReactEditor.toDOMPoint(editor, anchor);
    var domFocus = Range.isCollapsed(range2) ? domAnchor : ReactEditor.toDOMPoint(editor, focus2);
    var window2 = ReactEditor.getWindow(editor);
    var domRange = window2.document.createRange();
    var [startNode, startOffset] = isBackward ? domFocus : domAnchor;
    var [endNode, endOffset] = isBackward ? domAnchor : domFocus;
    var startEl = isDOMElement(startNode) ? startNode : startNode.parentElement;
    var isStartAtZeroWidth = !!startEl.getAttribute("data-slate-zero-width");
    var endEl = isDOMElement(endNode) ? endNode : endNode.parentElement;
    var isEndAtZeroWidth = !!endEl.getAttribute("data-slate-zero-width");
    domRange.setStart(startNode, isStartAtZeroWidth ? 1 : startOffset);
    domRange.setEnd(endNode, isEndAtZeroWidth ? 1 : endOffset);
    return domRange;
  },
  toSlateNode: (editor, domNode) => {
    var domEl = isDOMElement(domNode) ? domNode : domNode.parentElement;
    if (domEl && !domEl.hasAttribute("data-slate-node")) {
      domEl = domEl.closest("[data-slate-node]");
    }
    var node3 = domEl ? ELEMENT_TO_NODE.get(domEl) : null;
    if (!node3) {
      throw new Error("Cannot resolve a Slate node from DOM node: ".concat(domEl));
    }
    return node3;
  },
  toSlatePoint: (editor, domPoint, options) => {
    var {
      exactMatch,
      suppressThrow
    } = options;
    var [nearestNode, nearestOffset] = exactMatch ? domPoint : normalizeDOMPoint(domPoint);
    var parentNode = nearestNode.parentNode;
    var textNode = null;
    var offset2 = 0;
    if (parentNode) {
      var _domNode$textContent, _domNode$textContent2;
      var editorEl = ReactEditor.toDOMNode(editor, editor);
      var potentialVoidNode = parentNode.closest('[data-slate-void="true"]');
      var voidNode = potentialVoidNode && editorEl.contains(potentialVoidNode) ? potentialVoidNode : null;
      var leafNode = parentNode.closest("[data-slate-leaf]");
      var domNode = null;
      if (leafNode) {
        textNode = leafNode.closest('[data-slate-node="text"]');
        if (textNode) {
          var window2 = ReactEditor.getWindow(editor);
          var range2 = window2.document.createRange();
          range2.setStart(textNode, 0);
          range2.setEnd(nearestNode, nearestOffset);
          var contents = range2.cloneContents();
          var removals = [...Array.prototype.slice.call(contents.querySelectorAll("[data-slate-zero-width]")), ...Array.prototype.slice.call(contents.querySelectorAll("[contenteditable=false]"))];
          removals.forEach((el2) => {
            if (IS_ANDROID && !exactMatch && el2.hasAttribute("data-slate-zero-width") && el2.textContent.length > 0 && el2.textContext !== "\uFEFF") {
              if (el2.textContent.startsWith("\uFEFF")) {
                el2.textContent = el2.textContent.slice(1);
              }
              return;
            }
            el2.parentNode.removeChild(el2);
          });
          offset2 = contents.textContent.length;
          domNode = textNode;
        }
      } else if (voidNode) {
        var leafNodes = voidNode.querySelectorAll("[data-slate-leaf]");
        for (var index2 = 0; index2 < leafNodes.length; index2++) {
          var current2 = leafNodes[index2];
          if (ReactEditor.hasDOMNode(editor, current2)) {
            leafNode = current2;
            break;
          }
        }
        if (!leafNode) {
          offset2 = 1;
        } else {
          textNode = leafNode.closest('[data-slate-node="text"]');
          domNode = leafNode;
          offset2 = domNode.textContent.length;
          domNode.querySelectorAll("[data-slate-zero-width]").forEach((el2) => {
            offset2 -= el2.textContent.length;
          });
        }
      }
      if (domNode && offset2 === domNode.textContent.length && // COMPAT: Android IMEs might remove the zero width space while composing,
      // and we don't add it for line-breaks.
      IS_ANDROID && domNode.getAttribute("data-slate-zero-width") === "z" && (_domNode$textContent = domNode.textContent) !== null && _domNode$textContent !== void 0 && _domNode$textContent.startsWith("\uFEFF") && // COMPAT: If the parent node is a Slate zero-width space, editor is
      // because the text node should have no characters. However, during IME
      // composition the ASCII characters will be prepended to the zero-width
      // space, so subtract 1 from the offset to account for the zero-width
      // space character.
      (parentNode.hasAttribute("data-slate-zero-width") || // COMPAT: In Firefox, `range.cloneContents()` returns an extra trailing '\n'
      // when the document ends with a new-line character. This results in the offset
      // length being off by one, so we need to subtract one to account for this.
      IS_FIREFOX && (_domNode$textContent2 = domNode.textContent) !== null && _domNode$textContent2 !== void 0 && _domNode$textContent2.endsWith("\n\n"))) {
        offset2--;
      }
    }
    if (IS_ANDROID && !textNode && !exactMatch) {
      var node3 = parentNode.hasAttribute("data-slate-node") ? parentNode : parentNode.closest("[data-slate-node]");
      if (node3 && ReactEditor.hasDOMNode(editor, node3, {
        editable: true
      })) {
        var _slateNode = ReactEditor.toSlateNode(editor, node3);
        var {
          path: _path,
          offset: _offset
        } = Editor.start(editor, ReactEditor.findPath(editor, _slateNode));
        if (!node3.querySelector("[data-slate-leaf]")) {
          _offset = nearestOffset;
        }
        return {
          path: _path,
          offset: _offset
        };
      }
    }
    if (!textNode) {
      if (suppressThrow) {
        return null;
      }
      throw new Error("Cannot resolve a Slate point from DOM point: ".concat(domPoint));
    }
    var slateNode = ReactEditor.toSlateNode(editor, textNode);
    var path3 = ReactEditor.findPath(editor, slateNode);
    return {
      path: path3,
      offset: offset2
    };
  },
  toSlateRange: (editor, domRange, options) => {
    var _focusNode$textConten;
    var {
      exactMatch,
      suppressThrow
    } = options;
    var el2 = isDOMSelection(domRange) ? domRange.anchorNode : domRange.startContainer;
    var anchorNode;
    var anchorOffset;
    var focusNode;
    var focusOffset;
    var isCollapsed;
    if (el2) {
      if (isDOMSelection(domRange)) {
        if (IS_FIREFOX && domRange.rangeCount > 1) {
          focusNode = domRange.focusNode;
          var firstRange = domRange.getRangeAt(0);
          var lastRange = domRange.getRangeAt(domRange.rangeCount - 1);
          if (focusNode instanceof HTMLTableRowElement && firstRange.startContainer instanceof HTMLTableRowElement && lastRange.startContainer instanceof HTMLTableRowElement) {
            let getLastChildren = function(element) {
              if (element.childElementCount > 0) {
                return getLastChildren(element.children[0]);
              } else {
                return element;
              }
            };
            var firstNodeRow = firstRange.startContainer;
            var lastNodeRow = lastRange.startContainer;
            var firstNode = getLastChildren(firstNodeRow.children[firstRange.startOffset]);
            var lastNode = getLastChildren(lastNodeRow.children[lastRange.startOffset]);
            focusOffset = 0;
            if (lastNode.childNodes.length > 0) {
              anchorNode = lastNode.childNodes[0];
            } else {
              anchorNode = lastNode;
            }
            if (firstNode.childNodes.length > 0) {
              focusNode = firstNode.childNodes[0];
            } else {
              focusNode = firstNode;
            }
            if (lastNode instanceof HTMLElement) {
              anchorOffset = lastNode.innerHTML.length;
            } else {
              anchorOffset = 0;
            }
          } else {
            if (firstRange.startContainer === focusNode) {
              anchorNode = lastRange.endContainer;
              anchorOffset = lastRange.endOffset;
              focusOffset = firstRange.startOffset;
            } else {
              anchorNode = firstRange.startContainer;
              anchorOffset = firstRange.endOffset;
              focusOffset = lastRange.startOffset;
            }
          }
        } else {
          anchorNode = domRange.anchorNode;
          anchorOffset = domRange.anchorOffset;
          focusNode = domRange.focusNode;
          focusOffset = domRange.focusOffset;
        }
        if (IS_CHROME && hasShadowRoot(anchorNode) || IS_FIREFOX) {
          isCollapsed = domRange.anchorNode === domRange.focusNode && domRange.anchorOffset === domRange.focusOffset;
        } else {
          isCollapsed = domRange.isCollapsed;
        }
      } else {
        anchorNode = domRange.startContainer;
        anchorOffset = domRange.startOffset;
        focusNode = domRange.endContainer;
        focusOffset = domRange.endOffset;
        isCollapsed = domRange.collapsed;
      }
    }
    if (anchorNode == null || focusNode == null || anchorOffset == null || focusOffset == null) {
      throw new Error("Cannot resolve a Slate range from DOM range: ".concat(domRange));
    }
    if (IS_FIREFOX && (_focusNode$textConten = focusNode.textContent) !== null && _focusNode$textConten !== void 0 && _focusNode$textConten.endsWith("\n\n") && focusOffset === focusNode.textContent.length) {
      focusOffset--;
    }
    if ("getAttribute" in focusNode && focusNode.getAttribute("contenteditable") === "false" && focusNode.getAttribute("data-slate-void") !== "true") {
      var _anchorNode$textConte;
      focusNode = anchorNode;
      focusOffset = ((_anchorNode$textConte = anchorNode.textContent) === null || _anchorNode$textConte === void 0 ? void 0 : _anchorNode$textConte.length) || 0;
    }
    var anchor = ReactEditor.toSlatePoint(editor, [anchorNode, anchorOffset], {
      exactMatch,
      suppressThrow
    });
    if (!anchor) {
      return null;
    }
    var focus2 = isCollapsed ? anchor : ReactEditor.toSlatePoint(editor, [focusNode, focusOffset], {
      exactMatch,
      suppressThrow
    });
    if (!focus2) {
      return null;
    }
    var range2 = {
      anchor,
      focus: focus2
    };
    if (Range.isExpanded(range2) && Range.isForward(range2) && isDOMElement(focusNode) && Editor.void(editor, {
      at: range2.focus,
      mode: "highest"
    })) {
      range2 = Editor.unhangRange(editor, range2, {
        voids: true
      });
    }
    return range2;
  }
};
function verifyDiffState(editor, textDiff) {
  var {
    path: path3,
    diff: diff2
  } = textDiff;
  if (!Editor.hasPath(editor, path3)) {
    return false;
  }
  var node3 = Node$1.get(editor, path3);
  if (!Text$1.isText(node3)) {
    return false;
  }
  if (diff2.start !== node3.text.length || diff2.text.length === 0) {
    return node3.text.slice(diff2.start, diff2.start + diff2.text.length) === diff2.text;
  }
  var nextPath = Path.next(path3);
  if (!Editor.hasPath(editor, nextPath)) {
    return false;
  }
  var nextNode = Node$1.get(editor, nextPath);
  return Text$1.isText(nextNode) && nextNode.text.startsWith(diff2.text);
}
function applyStringDiff(text) {
  for (var _len = arguments.length, diffs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    diffs[_key - 1] = arguments[_key];
  }
  return diffs.reduce((text2, diff2) => text2.slice(0, diff2.start) + diff2.text + text2.slice(diff2.end), text);
}
function longestCommonPrefixLength(str, another) {
  var length = Math.min(str.length, another.length);
  for (var i3 = 0; i3 < length; i3++) {
    if (str.charAt(i3) !== another.charAt(i3)) {
      return i3;
    }
  }
  return length;
}
function longestCommonSuffixLength(str, another, max2) {
  var length = Math.min(str.length, another.length, max2);
  for (var i3 = 0; i3 < length; i3++) {
    if (str.charAt(str.length - i3 - 1) !== another.charAt(another.length - i3 - 1)) {
      return i3;
    }
  }
  return length;
}
function normalizeStringDiff(targetText, diff2) {
  var {
    start: start2,
    end: end2,
    text
  } = diff2;
  var removedText = targetText.slice(start2, end2);
  var prefixLength = longestCommonPrefixLength(removedText, text);
  var max2 = Math.min(removedText.length - prefixLength, text.length - prefixLength);
  var suffixLength = longestCommonSuffixLength(removedText, text, max2);
  var normalized = {
    start: start2 + prefixLength,
    end: end2 - suffixLength,
    text: text.slice(prefixLength, text.length - suffixLength)
  };
  if (normalized.start === normalized.end && normalized.text.length === 0) {
    return null;
  }
  return normalized;
}
function mergeStringDiffs(targetText, a4, b3) {
  var start2 = Math.min(a4.start, b3.start);
  var overlap = Math.max(0, Math.min(a4.start + a4.text.length, b3.end) - b3.start);
  var applied = applyStringDiff(targetText, a4, b3);
  var sliceEnd = Math.max(b3.start + b3.text.length, a4.start + a4.text.length + (a4.start + a4.text.length > b3.start ? b3.text.length : 0) - overlap);
  var text = applied.slice(start2, sliceEnd);
  var end2 = Math.max(a4.end, b3.end - a4.text.length + (a4.end - a4.start));
  return normalizeStringDiff(targetText, {
    start: start2,
    end: end2,
    text
  });
}
function targetRange(textDiff) {
  var {
    path: path3,
    diff: diff2
  } = textDiff;
  return {
    anchor: {
      path: path3,
      offset: diff2.start
    },
    focus: {
      path: path3,
      offset: diff2.end
    }
  };
}
function normalizePoint(editor, point3) {
  var {
    path: path3,
    offset: offset2
  } = point3;
  if (!Editor.hasPath(editor, path3)) {
    return null;
  }
  var leaf3 = Node$1.get(editor, path3);
  if (!Text$1.isText(leaf3)) {
    return null;
  }
  var parentBlock = Editor.above(editor, {
    match: (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2),
    at: path3
  });
  if (!parentBlock) {
    return null;
  }
  while (offset2 > leaf3.text.length) {
    var entry = Editor.next(editor, {
      at: path3,
      match: Text$1.isText
    });
    if (!entry || !Path.isDescendant(entry[1], parentBlock[1])) {
      return null;
    }
    offset2 -= leaf3.text.length;
    leaf3 = entry[0];
    path3 = entry[1];
  }
  return {
    path: path3,
    offset: offset2
  };
}
function normalizeRange(editor, range2) {
  var anchor = normalizePoint(editor, range2.anchor);
  if (!anchor) {
    return null;
  }
  if (Range.isCollapsed(range2)) {
    return {
      anchor,
      focus: anchor
    };
  }
  var focus2 = normalizePoint(editor, range2.focus);
  if (!focus2) {
    return null;
  }
  return {
    anchor,
    focus: focus2
  };
}
function transformPendingPoint(editor, point3, op) {
  var pendingDiffs = EDITOR_TO_PENDING_DIFFS.get(editor);
  var textDiff = pendingDiffs === null || pendingDiffs === void 0 ? void 0 : pendingDiffs.find((_ref) => {
    var {
      path: path3
    } = _ref;
    return Path.equals(path3, point3.path);
  });
  if (!textDiff || point3.offset <= textDiff.diff.start) {
    return Point.transform(point3, op, {
      affinity: "backward"
    });
  }
  var {
    diff: diff2
  } = textDiff;
  if (point3.offset <= diff2.start + diff2.text.length) {
    var _anchor = {
      path: point3.path,
      offset: diff2.start
    };
    var _transformed = Point.transform(_anchor, op, {
      affinity: "backward"
    });
    if (!_transformed) {
      return null;
    }
    return {
      path: _transformed.path,
      offset: _transformed.offset + point3.offset - diff2.start
    };
  }
  var anchor = {
    path: point3.path,
    offset: point3.offset - diff2.text.length + diff2.end - diff2.start
  };
  var transformed = Point.transform(anchor, op, {
    affinity: "backward"
  });
  if (!transformed) {
    return null;
  }
  if (op.type === "split_node" && Path.equals(op.path, point3.path) && anchor.offset < op.position && diff2.start < op.position) {
    return transformed;
  }
  return {
    path: transformed.path,
    offset: transformed.offset + diff2.text.length - diff2.end + diff2.start
  };
}
function transformPendingRange(editor, range2, op) {
  var anchor = transformPendingPoint(editor, range2.anchor, op);
  if (!anchor) {
    return null;
  }
  if (Range.isCollapsed(range2)) {
    return {
      anchor,
      focus: anchor
    };
  }
  var focus2 = transformPendingPoint(editor, range2.focus, op);
  if (!focus2) {
    return null;
  }
  return {
    anchor,
    focus: focus2
  };
}
function transformTextDiff(textDiff, op) {
  var {
    path: path3,
    diff: diff2,
    id: id2
  } = textDiff;
  switch (op.type) {
    case "insert_text": {
      if (!Path.equals(op.path, path3) || op.offset >= diff2.end) {
        return textDiff;
      }
      if (op.offset <= diff2.start) {
        return {
          diff: {
            start: op.text.length + diff2.start,
            end: op.text.length + diff2.end,
            text: diff2.text
          },
          id: id2,
          path: path3
        };
      }
      return {
        diff: {
          start: diff2.start,
          end: diff2.end + op.text.length,
          text: diff2.text
        },
        id: id2,
        path: path3
      };
    }
    case "remove_text": {
      if (!Path.equals(op.path, path3) || op.offset >= diff2.end) {
        return textDiff;
      }
      if (op.offset + op.text.length <= diff2.start) {
        return {
          diff: {
            start: diff2.start - op.text.length,
            end: diff2.end - op.text.length,
            text: diff2.text
          },
          id: id2,
          path: path3
        };
      }
      return {
        diff: {
          start: diff2.start,
          end: diff2.end - op.text.length,
          text: diff2.text
        },
        id: id2,
        path: path3
      };
    }
    case "split_node": {
      if (!Path.equals(op.path, path3) || op.position >= diff2.end) {
        return {
          diff: diff2,
          id: id2,
          path: Path.transform(path3, op, {
            affinity: "backward"
          })
        };
      }
      if (op.position > diff2.start) {
        return {
          diff: {
            start: diff2.start,
            end: Math.min(op.position, diff2.end),
            text: diff2.text
          },
          id: id2,
          path: path3
        };
      }
      return {
        diff: {
          start: diff2.start - op.position,
          end: diff2.end - op.position,
          text: diff2.text
        },
        id: id2,
        path: Path.transform(path3, op, {
          affinity: "forward"
        })
      };
    }
    case "merge_node": {
      if (!Path.equals(op.path, path3)) {
        return {
          diff: diff2,
          id: id2,
          path: Path.transform(path3, op)
        };
      }
      return {
        diff: {
          start: diff2.start + op.position,
          end: diff2.end + op.position,
          text: diff2.text
        },
        id: id2,
        path: Path.transform(path3, op)
      };
    }
  }
  var newPath = Path.transform(path3, op);
  if (!newPath) {
    return null;
  }
  return {
    diff: diff2,
    path: newPath,
    id: id2
  };
}
function ownKeys$6(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$6(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$6(Object(t3), true).forEach(function(r3) {
      _defineProperty$3(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$6(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var RESOLVE_DELAY = 25;
var FLUSH_DELAY = 200;
var debug = function debug2() {
};
var isDataTransfer = (value) => (value === null || value === void 0 ? void 0 : value.constructor.name) === "DataTransfer";
function createAndroidInputManager(_ref) {
  var {
    editor,
    scheduleOnDOMSelectionChange,
    onDOMSelectionChange
  } = _ref;
  var flushing = false;
  var compositionEndTimeoutId = null;
  var flushTimeoutId = null;
  var actionTimeoutId = null;
  var idCounter2 = 0;
  var insertPositionHint = false;
  var applyPendingSelection = () => {
    var pendingSelection = EDITOR_TO_PENDING_SELECTION.get(editor);
    EDITOR_TO_PENDING_SELECTION.delete(editor);
    if (pendingSelection) {
      var {
        selection
      } = editor;
      var normalized = normalizeRange(editor, pendingSelection);
      if (normalized && (!selection || !Range.equals(normalized, selection))) {
        Transforms.select(editor, normalized);
      }
    }
  };
  var performAction = () => {
    var action = EDITOR_TO_PENDING_ACTION.get(editor);
    EDITOR_TO_PENDING_ACTION.delete(editor);
    if (!action) {
      return;
    }
    if (action.at) {
      var target = Point.isPoint(action.at) ? normalizePoint(editor, action.at) : normalizeRange(editor, action.at);
      if (!target) {
        return;
      }
      var _targetRange = Editor.range(editor, target);
      if (!editor.selection || !Range.equals(editor.selection, _targetRange)) {
        Transforms.select(editor, target);
      }
    }
    action.run();
  };
  var flush = () => {
    if (flushTimeoutId) {
      clearTimeout(flushTimeoutId);
      flushTimeoutId = null;
    }
    if (actionTimeoutId) {
      clearTimeout(actionTimeoutId);
      actionTimeoutId = null;
    }
    if (!hasPendingDiffs() && !hasPendingAction()) {
      applyPendingSelection();
      return;
    }
    if (!flushing) {
      flushing = true;
      setTimeout(() => flushing = false);
    }
    if (hasPendingAction()) {
      flushing = "action";
    }
    var selectionRef = editor.selection && Editor.rangeRef(editor, editor.selection, {
      affinity: "forward"
    });
    EDITOR_TO_USER_MARKS.set(editor, editor.marks);
    debug("flush", EDITOR_TO_PENDING_ACTION.get(editor), EDITOR_TO_PENDING_DIFFS.get(editor));
    var scheduleSelectionChange = hasPendingDiffs();
    var diff2;
    while (diff2 = (_EDITOR_TO_PENDING_DI = EDITOR_TO_PENDING_DIFFS.get(editor)) === null || _EDITOR_TO_PENDING_DI === void 0 ? void 0 : _EDITOR_TO_PENDING_DI[0]) {
      var _EDITOR_TO_PENDING_DI, _EDITOR_TO_PENDING_DI2;
      var pendingMarks = EDITOR_TO_PENDING_INSERTION_MARKS.get(editor);
      if (pendingMarks !== void 0) {
        EDITOR_TO_PENDING_INSERTION_MARKS.delete(editor);
        editor.marks = pendingMarks;
      }
      if (pendingMarks && insertPositionHint === false) {
        insertPositionHint = null;
      }
      var range2 = targetRange(diff2);
      if (!editor.selection || !Range.equals(editor.selection, range2)) {
        Transforms.select(editor, range2);
      }
      if (diff2.diff.text) {
        Editor.insertText(editor, diff2.diff.text);
      } else {
        Editor.deleteFragment(editor);
      }
      EDITOR_TO_PENDING_DIFFS.set(editor, (_EDITOR_TO_PENDING_DI2 = EDITOR_TO_PENDING_DIFFS.get(editor)) === null || _EDITOR_TO_PENDING_DI2 === void 0 ? void 0 : _EDITOR_TO_PENDING_DI2.filter((_ref2) => {
        var {
          id: id2
        } = _ref2;
        return id2 !== diff2.id;
      }));
      if (!verifyDiffState(editor, diff2)) {
        scheduleSelectionChange = false;
        EDITOR_TO_PENDING_ACTION.delete(editor);
        EDITOR_TO_USER_MARKS.delete(editor);
        flushing = "action";
        EDITOR_TO_PENDING_SELECTION.delete(editor);
        scheduleOnDOMSelectionChange.cancel();
        onDOMSelectionChange.cancel();
        selectionRef === null || selectionRef === void 0 || selectionRef.unref();
      }
    }
    var selection = selectionRef === null || selectionRef === void 0 ? void 0 : selectionRef.unref();
    if (selection && !EDITOR_TO_PENDING_SELECTION.get(editor) && (!editor.selection || !Range.equals(selection, editor.selection))) {
      Transforms.select(editor, selection);
    }
    if (hasPendingAction()) {
      performAction();
      return;
    }
    if (scheduleSelectionChange) {
      scheduleOnDOMSelectionChange();
    }
    scheduleOnDOMSelectionChange.flush();
    onDOMSelectionChange.flush();
    applyPendingSelection();
    var userMarks = EDITOR_TO_USER_MARKS.get(editor);
    EDITOR_TO_USER_MARKS.delete(editor);
    if (userMarks !== void 0) {
      editor.marks = userMarks;
      editor.onChange();
    }
  };
  var handleCompositionEnd = (_event) => {
    if (compositionEndTimeoutId) {
      clearTimeout(compositionEndTimeoutId);
    }
    compositionEndTimeoutId = setTimeout(() => {
      IS_COMPOSING.set(editor, false);
      flush();
    }, RESOLVE_DELAY);
  };
  var handleCompositionStart = (_event) => {
    IS_COMPOSING.set(editor, true);
    if (compositionEndTimeoutId) {
      clearTimeout(compositionEndTimeoutId);
      compositionEndTimeoutId = null;
    }
  };
  var updatePlaceholderVisibility = function updatePlaceholderVisibility2() {
    var forceHide = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var placeholderElement = EDITOR_TO_PLACEHOLDER_ELEMENT.get(editor);
    if (!placeholderElement) {
      return;
    }
    if (hasPendingDiffs() || forceHide) {
      placeholderElement.style.display = "none";
      return;
    }
    placeholderElement.style.removeProperty("display");
  };
  var storeDiff = (path3, diff2) => {
    var _EDITOR_TO_PENDING_DI3;
    var pendingDiffs = (_EDITOR_TO_PENDING_DI3 = EDITOR_TO_PENDING_DIFFS.get(editor)) !== null && _EDITOR_TO_PENDING_DI3 !== void 0 ? _EDITOR_TO_PENDING_DI3 : [];
    EDITOR_TO_PENDING_DIFFS.set(editor, pendingDiffs);
    var target = Node$1.leaf(editor, path3);
    var idx = pendingDiffs.findIndex((change) => Path.equals(change.path, path3));
    if (idx < 0) {
      var normalized = normalizeStringDiff(target.text, diff2);
      if (normalized) {
        pendingDiffs.push({
          path: path3,
          diff: diff2,
          id: idCounter2++
        });
      }
      updatePlaceholderVisibility();
      return;
    }
    var merged = mergeStringDiffs(target.text, pendingDiffs[idx].diff, diff2);
    if (!merged) {
      pendingDiffs.splice(idx, 1);
      updatePlaceholderVisibility();
      return;
    }
    pendingDiffs[idx] = _objectSpread$6(_objectSpread$6({}, pendingDiffs[idx]), {}, {
      diff: merged
    });
  };
  var scheduleAction = function scheduleAction2(run) {
    var {
      at: at2
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    insertPositionHint = false;
    EDITOR_TO_PENDING_SELECTION.delete(editor);
    scheduleOnDOMSelectionChange.cancel();
    onDOMSelectionChange.cancel();
    if (hasPendingAction()) {
      flush();
    }
    EDITOR_TO_PENDING_ACTION.set(editor, {
      at: at2,
      run
    });
    actionTimeoutId = setTimeout(flush);
  };
  var handleDOMBeforeInput = (event) => {
    var _targetRange2;
    if (flushTimeoutId) {
      clearTimeout(flushTimeoutId);
      flushTimeoutId = null;
    }
    var {
      inputType: type2
    } = event;
    var targetRange2 = null;
    var data = event.dataTransfer || event.data || void 0;
    if (insertPositionHint !== false && type2 !== "insertText" && type2 !== "insertCompositionText") {
      insertPositionHint = false;
    }
    var [nativeTargetRange] = event.getTargetRanges();
    if (nativeTargetRange) {
      targetRange2 = ReactEditor.toSlateRange(editor, nativeTargetRange, {
        exactMatch: false,
        suppressThrow: true
      });
    }
    var window2 = ReactEditor.getWindow(editor);
    var domSelection = window2.getSelection();
    if (!targetRange2 && domSelection) {
      nativeTargetRange = domSelection;
      targetRange2 = ReactEditor.toSlateRange(editor, domSelection, {
        exactMatch: false,
        suppressThrow: true
      });
    }
    targetRange2 = (_targetRange2 = targetRange2) !== null && _targetRange2 !== void 0 ? _targetRange2 : editor.selection;
    if (!targetRange2) {
      return;
    }
    var canStoreDiff = true;
    if (type2.startsWith("delete")) {
      if (Range.isExpanded(targetRange2)) {
        var [_start, _end] = Range.edges(targetRange2);
        var _leaf = Node$1.leaf(editor, _start.path);
        if (_leaf.text.length === _start.offset && _end.offset === 0) {
          var next3 = Editor.next(editor, {
            at: _start.path,
            match: Text$1.isText
          });
          if (next3 && Path.equals(next3[1], _end.path)) {
            targetRange2 = {
              anchor: _end,
              focus: _end
            };
          }
        }
      }
      var direction2 = type2.endsWith("Backward") ? "backward" : "forward";
      var [start2, end2] = Range.edges(targetRange2);
      var [leaf3, path3] = Editor.leaf(editor, start2.path);
      var diff2 = {
        text: "",
        start: start2.offset,
        end: end2.offset
      };
      var pendingDiffs = EDITOR_TO_PENDING_DIFFS.get(editor);
      var relevantPendingDiffs = pendingDiffs === null || pendingDiffs === void 0 ? void 0 : pendingDiffs.find((change) => Path.equals(change.path, path3));
      var diffs = relevantPendingDiffs ? [relevantPendingDiffs.diff, diff2] : [diff2];
      var text = applyStringDiff(leaf3.text, ...diffs);
      if (text.length === 0) {
        canStoreDiff = false;
      }
      if (Range.isExpanded(targetRange2)) {
        if (canStoreDiff && Path.equals(targetRange2.anchor.path, targetRange2.focus.path)) {
          var point3 = {
            path: targetRange2.anchor.path,
            offset: start2.offset
          };
          var range2 = Editor.range(editor, point3, point3);
          handleUserSelect(range2);
          return storeDiff(targetRange2.anchor.path, {
            text: "",
            end: end2.offset,
            start: start2.offset
          });
        }
        return scheduleAction(() => Editor.deleteFragment(editor, {
          direction: direction2
        }), {
          at: targetRange2
        });
      }
    }
    switch (type2) {
      case "deleteByComposition":
      case "deleteByCut":
      case "deleteByDrag": {
        return scheduleAction(() => Editor.deleteFragment(editor), {
          at: targetRange2
        });
      }
      case "deleteContent":
      case "deleteContentForward": {
        var {
          anchor
        } = targetRange2;
        if (canStoreDiff && Range.isCollapsed(targetRange2)) {
          var targetNode = Node$1.leaf(editor, anchor.path);
          if (anchor.offset < targetNode.text.length) {
            return storeDiff(anchor.path, {
              text: "",
              start: anchor.offset,
              end: anchor.offset + 1
            });
          }
        }
        return scheduleAction(() => Editor.deleteForward(editor), {
          at: targetRange2
        });
      }
      case "deleteContentBackward": {
        var _nativeTargetRange;
        var {
          anchor: _anchor
        } = targetRange2;
        var nativeCollapsed = isDOMSelection(nativeTargetRange) ? nativeTargetRange.isCollapsed : !!((_nativeTargetRange = nativeTargetRange) !== null && _nativeTargetRange !== void 0 && _nativeTargetRange.collapsed);
        if (canStoreDiff && nativeCollapsed && Range.isCollapsed(targetRange2) && _anchor.offset > 0) {
          return storeDiff(_anchor.path, {
            text: "",
            start: _anchor.offset - 1,
            end: _anchor.offset
          });
        }
        return scheduleAction(() => Editor.deleteBackward(editor), {
          at: targetRange2
        });
      }
      case "deleteEntireSoftLine": {
        return scheduleAction(() => {
          Editor.deleteBackward(editor, {
            unit: "line"
          });
          Editor.deleteForward(editor, {
            unit: "line"
          });
        }, {
          at: targetRange2
        });
      }
      case "deleteHardLineBackward": {
        return scheduleAction(() => Editor.deleteBackward(editor, {
          unit: "block"
        }), {
          at: targetRange2
        });
      }
      case "deleteSoftLineBackward": {
        return scheduleAction(() => Editor.deleteBackward(editor, {
          unit: "line"
        }), {
          at: targetRange2
        });
      }
      case "deleteHardLineForward": {
        return scheduleAction(() => Editor.deleteForward(editor, {
          unit: "block"
        }), {
          at: targetRange2
        });
      }
      case "deleteSoftLineForward": {
        return scheduleAction(() => Editor.deleteForward(editor, {
          unit: "line"
        }), {
          at: targetRange2
        });
      }
      case "deleteWordBackward": {
        return scheduleAction(() => Editor.deleteBackward(editor, {
          unit: "word"
        }), {
          at: targetRange2
        });
      }
      case "deleteWordForward": {
        return scheduleAction(() => Editor.deleteForward(editor, {
          unit: "word"
        }), {
          at: targetRange2
        });
      }
      case "insertLineBreak": {
        return scheduleAction(() => Editor.insertSoftBreak(editor), {
          at: targetRange2
        });
      }
      case "insertParagraph": {
        return scheduleAction(() => Editor.insertBreak(editor), {
          at: targetRange2
        });
      }
      case "insertCompositionText":
      case "deleteCompositionText":
      case "insertFromComposition":
      case "insertFromDrop":
      case "insertFromPaste":
      case "insertFromYank":
      case "insertReplacementText":
      case "insertText": {
        if (isDataTransfer(data)) {
          return scheduleAction(() => ReactEditor.insertData(editor, data), {
            at: targetRange2
          });
        }
        var _text = data !== null && data !== void 0 ? data : "";
        if (EDITOR_TO_PENDING_INSERTION_MARKS.get(editor)) {
          _text = _text.replace("\uFEFF", "");
        }
        if (type2 === "insertText" && /.*\n.*\n$/.test(_text)) {
          _text = _text.slice(0, -1);
        }
        if (_text.includes("\n")) {
          return scheduleAction(() => {
            var parts = _text.split("\n");
            parts.forEach((line, i3) => {
              if (line) {
                Editor.insertText(editor, line);
              }
              if (i3 !== parts.length - 1) {
                Editor.insertSoftBreak(editor);
              }
            });
          }, {
            at: targetRange2
          });
        }
        if (Path.equals(targetRange2.anchor.path, targetRange2.focus.path)) {
          var [_start2, _end2] = Range.edges(targetRange2);
          var _diff = {
            start: _start2.offset,
            end: _end2.offset,
            text: _text
          };
          if (_text && insertPositionHint && type2 === "insertCompositionText") {
            var hintPosition = insertPositionHint.start + insertPositionHint.text.search(/\S|$/);
            var diffPosition = _diff.start + _diff.text.search(/\S|$/);
            if (diffPosition === hintPosition + 1 && _diff.end === insertPositionHint.start + insertPositionHint.text.length) {
              _diff.start -= 1;
              insertPositionHint = null;
              scheduleFlush();
            } else {
              insertPositionHint = false;
            }
          } else if (type2 === "insertText") {
            if (insertPositionHint === null) {
              insertPositionHint = _diff;
            } else if (insertPositionHint && Range.isCollapsed(targetRange2) && insertPositionHint.end + insertPositionHint.text.length === _start2.offset) {
              insertPositionHint = _objectSpread$6(_objectSpread$6({}, insertPositionHint), {}, {
                text: insertPositionHint.text + _text
              });
            } else {
              insertPositionHint = false;
            }
          } else {
            insertPositionHint = false;
          }
          if (canStoreDiff) {
            storeDiff(_start2.path, _diff);
            return;
          }
        }
        return scheduleAction(() => Editor.insertText(editor, _text), {
          at: targetRange2
        });
      }
    }
  };
  var hasPendingAction = () => {
    return !!EDITOR_TO_PENDING_ACTION.get(editor);
  };
  var hasPendingDiffs = () => {
    var _EDITOR_TO_PENDING_DI4;
    return !!((_EDITOR_TO_PENDING_DI4 = EDITOR_TO_PENDING_DIFFS.get(editor)) !== null && _EDITOR_TO_PENDING_DI4 !== void 0 && _EDITOR_TO_PENDING_DI4.length);
  };
  var hasPendingChanges = () => {
    return hasPendingAction() || hasPendingDiffs();
  };
  var isFlushing = () => {
    return flushing;
  };
  var handleUserSelect = (range2) => {
    EDITOR_TO_PENDING_SELECTION.set(editor, range2);
    if (flushTimeoutId) {
      clearTimeout(flushTimeoutId);
      flushTimeoutId = null;
    }
    var {
      selection
    } = editor;
    if (!range2) {
      return;
    }
    var pathChanged = !selection || !Path.equals(selection.anchor.path, range2.anchor.path);
    var parentPathChanged = !selection || !Path.equals(selection.anchor.path.slice(0, -1), range2.anchor.path.slice(0, -1));
    if (pathChanged && insertPositionHint || parentPathChanged) {
      insertPositionHint = false;
    }
    if (pathChanged || hasPendingDiffs()) {
      flushTimeoutId = setTimeout(flush, FLUSH_DELAY);
    }
  };
  var handleInput = () => {
    if (hasPendingAction() || !hasPendingDiffs()) {
      flush();
    }
  };
  var handleKeyDown = (_2) => {
    if (!hasPendingDiffs()) {
      updatePlaceholderVisibility(true);
      setTimeout(updatePlaceholderVisibility);
    }
  };
  var scheduleFlush = () => {
    if (!hasPendingAction()) {
      actionTimeoutId = setTimeout(flush);
    }
  };
  var handleDomMutations = (mutations) => {
    if (hasPendingDiffs() || hasPendingAction()) {
      return;
    }
    if (mutations.some((mutation) => isTrackedMutation(editor, mutation, mutations))) {
      var _EDITOR_TO_FORCE_REND;
      (_EDITOR_TO_FORCE_REND = EDITOR_TO_FORCE_RENDER.get(editor)) === null || _EDITOR_TO_FORCE_REND === void 0 || _EDITOR_TO_FORCE_REND();
    }
  };
  return {
    flush,
    scheduleFlush,
    hasPendingDiffs,
    hasPendingAction,
    hasPendingChanges,
    isFlushing,
    handleUserSelect,
    handleCompositionEnd,
    handleCompositionStart,
    handleDOMBeforeInput,
    handleKeyDown,
    handleDomMutations,
    handleInput
  };
}
function useIsMounted() {
  var isMountedRef = useRef(false);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  return isMountedRef.current;
}
var useIsomorphicLayoutEffect = CAN_USE_DOM ? useLayoutEffect : useEffect;
function useMutationObserver(node3, callback, options) {
  var [mutationObserver] = useState(() => new MutationObserver(callback));
  useIsomorphicLayoutEffect(() => {
    mutationObserver.takeRecords();
  });
  useEffect(() => {
    if (!node3.current) {
      throw new Error("Failed to attach MutationObserver, `node` is undefined");
    }
    mutationObserver.observe(node3.current, options);
    return () => mutationObserver.disconnect();
  }, [mutationObserver, node3, options]);
}
var _excluded$3 = ["node"];
function ownKeys$5(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$5(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$5(Object(t3), true).forEach(function(r3) {
      _defineProperty$3(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$5(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var MUTATION_OBSERVER_CONFIG$1 = {
  subtree: true,
  childList: true,
  characterData: true
};
var useAndroidInputManager = !IS_ANDROID ? () => null : (_ref) => {
  var {
    node: node3
  } = _ref, options = _objectWithoutProperties$1(_ref, _excluded$3);
  if (!IS_ANDROID) {
    return null;
  }
  var editor = useSlateStatic();
  var isMounted = useIsMounted();
  var [inputManager] = useState(() => createAndroidInputManager(_objectSpread$5({
    editor
  }, options)));
  useMutationObserver(node3, inputManager.handleDomMutations, MUTATION_OBSERVER_CONFIG$1);
  EDITOR_TO_SCHEDULE_FLUSH.set(editor, inputManager.scheduleFlush);
  if (isMounted) {
    inputManager.flush();
  }
  return inputManager;
};
var _excluded$2 = ["anchor", "focus"], _excluded2$1 = ["anchor", "focus"];
var shallowCompare = (obj1, obj2) => Object.keys(obj1).length === Object.keys(obj2).length && Object.keys(obj1).every((key2) => obj2.hasOwnProperty(key2) && obj1[key2] === obj2[key2]);
var isDecorationFlagsEqual = (range2, other) => {
  var rangeOwnProps = _objectWithoutProperties$1(range2, _excluded$2);
  var otherOwnProps = _objectWithoutProperties$1(other, _excluded2$1);
  return range2[PLACEHOLDER_SYMBOL] === other[PLACEHOLDER_SYMBOL] && shallowCompare(rangeOwnProps, otherOwnProps);
};
var isElementDecorationsEqual = (list, another) => {
  if (list.length !== another.length) {
    return false;
  }
  for (var i3 = 0; i3 < list.length; i3++) {
    var range2 = list[i3];
    var other = another[i3];
    if (!Range.equals(range2, other) || !isDecorationFlagsEqual(range2, other)) {
      return false;
    }
  }
  return true;
};
var isTextDecorationsEqual = (list, another) => {
  if (list.length !== another.length) {
    return false;
  }
  for (var i3 = 0; i3 < list.length; i3++) {
    var range2 = list[i3];
    var other = another[i3];
    if (range2.anchor.offset !== other.anchor.offset || range2.focus.offset !== other.focus.offset || !isDecorationFlagsEqual(range2, other)) {
      return false;
    }
  }
  return true;
};
function ownKeys$4(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$4(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$4(Object(t3), true).forEach(function(r3) {
      _defineProperty$3(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$4(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var String$1 = (props2) => {
  var {
    isLast,
    leaf: leaf3,
    parent: parent3,
    text
  } = props2;
  var editor = useSlateStatic();
  var path3 = ReactEditor.findPath(editor, text);
  var parentPath = Path.parent(path3);
  var isMarkPlaceholder = Boolean(leaf3[MARK_PLACEHOLDER_SYMBOL]);
  if (editor.isVoid(parent3)) {
    return /* @__PURE__ */ React__default.createElement(ZeroWidthString, {
      length: Node$1.string(parent3).length
    });
  }
  if (leaf3.text === "" && parent3.children[parent3.children.length - 1] === text && !editor.isInline(parent3) && Editor.string(editor, parentPath) === "") {
    return /* @__PURE__ */ React__default.createElement(ZeroWidthString, {
      isLineBreak: true,
      isMarkPlaceholder
    });
  }
  if (leaf3.text === "") {
    return /* @__PURE__ */ React__default.createElement(ZeroWidthString, {
      isMarkPlaceholder
    });
  }
  if (isLast && leaf3.text.slice(-1) === "\n") {
    return /* @__PURE__ */ React__default.createElement(TextString, {
      isTrailing: true,
      text: leaf3.text
    });
  }
  return /* @__PURE__ */ React__default.createElement(TextString, {
    text: leaf3.text
  });
};
var TextString = (props2) => {
  var {
    text,
    isTrailing = false
  } = props2;
  var ref2 = useRef(null);
  var getTextContent = () => {
    return "".concat(text !== null && text !== void 0 ? text : "").concat(isTrailing ? "\n" : "");
  };
  var [initialText] = useState(getTextContent);
  useIsomorphicLayoutEffect(() => {
    var textWithTrailing = getTextContent();
    if (ref2.current && ref2.current.textContent !== textWithTrailing) {
      ref2.current.textContent = textWithTrailing;
    }
  });
  return /* @__PURE__ */ React__default.createElement(MemoizedText$1, {
    ref: ref2
  }, initialText);
};
var MemoizedText$1 = /* @__PURE__ */ memo(/* @__PURE__ */ forwardRef((props2, ref2) => {
  return /* @__PURE__ */ React__default.createElement("span", {
    "data-slate-string": true,
    ref: ref2
  }, props2.children);
}));
var ZeroWidthString = (props2) => {
  var {
    length = 0,
    isLineBreak = false,
    isMarkPlaceholder = false
  } = props2;
  var attributes = {
    "data-slate-zero-width": isLineBreak ? "n" : "z",
    "data-slate-length": length
  };
  if (isMarkPlaceholder) {
    attributes["data-slate-mark-placeholder"] = true;
  }
  return /* @__PURE__ */ React__default.createElement("span", _objectSpread$4({}, attributes), !IS_ANDROID || !isLineBreak ? "\uFEFF" : null, isLineBreak ? /* @__PURE__ */ React__default.createElement("br", null) : null);
};
function ownKeys$3(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$3(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$3(Object(t3), true).forEach(function(r3) {
      _defineProperty$3(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$3(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var PLACEHOLDER_DELAY = IS_ANDROID ? 300 : 0;
function disconnectPlaceholderResizeObserver(placeholderResizeObserver, releaseObserver) {
  if (placeholderResizeObserver.current) {
    placeholderResizeObserver.current.disconnect();
    if (releaseObserver) {
      placeholderResizeObserver.current = null;
    }
  }
}
function clearTimeoutRef(timeoutRef) {
  if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = null;
  }
}
var Leaf$1 = (props2) => {
  var {
    leaf: leaf3,
    isLast,
    text,
    parent: parent3,
    renderPlaceholder,
    renderLeaf = (props3) => /* @__PURE__ */ React__default.createElement(DefaultLeaf, _objectSpread$3({}, props3))
  } = props2;
  var editor = useSlateStatic();
  var placeholderResizeObserver = useRef(null);
  var placeholderRef = useRef(null);
  var [showPlaceholder, setShowPlaceholder] = useState(false);
  var showPlaceholderTimeoutRef = useRef(null);
  var callbackPlaceholderRef = useCallback((placeholderEl) => {
    disconnectPlaceholderResizeObserver(placeholderResizeObserver, placeholderEl == null);
    if (placeholderEl == null) {
      var _leaf$onPlaceholderRe;
      EDITOR_TO_PLACEHOLDER_ELEMENT.delete(editor);
      (_leaf$onPlaceholderRe = leaf3.onPlaceholderResize) === null || _leaf$onPlaceholderRe === void 0 || _leaf$onPlaceholderRe.call(leaf3, null);
    } else {
      EDITOR_TO_PLACEHOLDER_ELEMENT.set(editor, placeholderEl);
      if (!placeholderResizeObserver.current) {
        var ResizeObserver$1 = window.ResizeObserver || ResizeObserver;
        placeholderResizeObserver.current = new ResizeObserver$1(() => {
          var _leaf$onPlaceholderRe2;
          (_leaf$onPlaceholderRe2 = leaf3.onPlaceholderResize) === null || _leaf$onPlaceholderRe2 === void 0 || _leaf$onPlaceholderRe2.call(leaf3, placeholderEl);
        });
      }
      placeholderResizeObserver.current.observe(placeholderEl);
      placeholderRef.current = placeholderEl;
    }
  }, [placeholderRef, leaf3, editor]);
  var children = /* @__PURE__ */ React__default.createElement(String$1, {
    isLast,
    leaf: leaf3,
    parent: parent3,
    text
  });
  var leafIsPlaceholder = Boolean(leaf3[PLACEHOLDER_SYMBOL]);
  useEffect(() => {
    if (leafIsPlaceholder) {
      if (!showPlaceholderTimeoutRef.current) {
        showPlaceholderTimeoutRef.current = setTimeout(() => {
          setShowPlaceholder(true);
          showPlaceholderTimeoutRef.current = null;
        }, PLACEHOLDER_DELAY);
      }
    } else {
      clearTimeoutRef(showPlaceholderTimeoutRef);
      setShowPlaceholder(false);
    }
    return () => clearTimeoutRef(showPlaceholderTimeoutRef);
  }, [leafIsPlaceholder, setShowPlaceholder]);
  if (leafIsPlaceholder && showPlaceholder) {
    var placeholderProps = {
      children: leaf3.placeholder,
      attributes: {
        "data-slate-placeholder": true,
        style: {
          position: "absolute",
          top: 0,
          pointerEvents: "none",
          width: "100%",
          maxWidth: "100%",
          display: "block",
          opacity: "0.333",
          userSelect: "none",
          textDecoration: "none",
          // Fixes https://github.com/udecode/plate/issues/2315
          WebkitUserModify: IS_WEBKIT ? "inherit" : void 0
        },
        contentEditable: false,
        ref: callbackPlaceholderRef
      }
    };
    children = /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, renderPlaceholder(placeholderProps), children);
  }
  var attributes = {
    "data-slate-leaf": true
  };
  return renderLeaf({
    attributes,
    children,
    leaf: leaf3,
    text
  });
};
var MemoizedLeaf = /* @__PURE__ */ React__default.memo(Leaf$1, (prev, next3) => {
  return next3.parent === prev.parent && next3.isLast === prev.isLast && next3.renderLeaf === prev.renderLeaf && next3.renderPlaceholder === prev.renderPlaceholder && next3.text === prev.text && Text$1.equals(next3.leaf, prev.leaf) && next3.leaf[PLACEHOLDER_SYMBOL] === prev.leaf[PLACEHOLDER_SYMBOL];
});
var DefaultLeaf = (props2) => {
  var {
    attributes,
    children
  } = props2;
  return /* @__PURE__ */ React__default.createElement("span", _objectSpread$3({}, attributes), children);
};
var Text = (props2) => {
  var {
    decorations,
    isLast,
    parent: parent3,
    renderPlaceholder,
    renderLeaf,
    text
  } = props2;
  var editor = useSlateStatic();
  var ref2 = useRef(null);
  var leaves = Text$1.decorations(text, decorations);
  var key2 = ReactEditor.findKey(editor, text);
  var children = [];
  for (var i3 = 0; i3 < leaves.length; i3++) {
    var leaf3 = leaves[i3];
    children.push(/* @__PURE__ */ React__default.createElement(MemoizedLeaf, {
      isLast: isLast && i3 === leaves.length - 1,
      key: "".concat(key2.id, "-").concat(i3),
      renderPlaceholder,
      leaf: leaf3,
      text,
      parent: parent3,
      renderLeaf
    }));
  }
  var callbackRef = useCallback((span) => {
    var KEY_TO_ELEMENT = EDITOR_TO_KEY_TO_ELEMENT.get(editor);
    if (span) {
      KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 || KEY_TO_ELEMENT.set(key2, span);
      NODE_TO_ELEMENT.set(text, span);
      ELEMENT_TO_NODE.set(span, text);
    } else {
      KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 || KEY_TO_ELEMENT.delete(key2);
      NODE_TO_ELEMENT.delete(text);
      if (ref2.current) {
        ELEMENT_TO_NODE.delete(ref2.current);
      }
    }
    ref2.current = span;
  }, [ref2, editor, key2, text]);
  return /* @__PURE__ */ React__default.createElement("span", {
    "data-slate-node": "text",
    ref: callbackRef
  }, children);
};
var MemoizedText = /* @__PURE__ */ React__default.memo(Text, (prev, next3) => {
  return next3.parent === prev.parent && next3.isLast === prev.isLast && next3.renderLeaf === prev.renderLeaf && next3.renderPlaceholder === prev.renderPlaceholder && next3.text === prev.text && isTextDecorationsEqual(next3.decorations, prev.decorations);
});
function ownKeys$2(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$2(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$2(Object(t3), true).forEach(function(r3) {
      _defineProperty$3(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$2(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var Element$2 = (props2) => {
  var {
    decorations,
    element,
    renderElement = (p2) => /* @__PURE__ */ React__default.createElement(DefaultElement, _objectSpread$2({}, p2)),
    renderPlaceholder,
    renderLeaf,
    selection
  } = props2;
  var editor = useSlateStatic();
  var readOnly = useReadOnly();
  var isInline = editor.isInline(element);
  var key2 = ReactEditor.findKey(editor, element);
  var ref2 = useCallback((ref3) => {
    var KEY_TO_ELEMENT = EDITOR_TO_KEY_TO_ELEMENT.get(editor);
    if (ref3) {
      KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 || KEY_TO_ELEMENT.set(key2, ref3);
      NODE_TO_ELEMENT.set(element, ref3);
      ELEMENT_TO_NODE.set(ref3, element);
    } else {
      KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 || KEY_TO_ELEMENT.delete(key2);
      NODE_TO_ELEMENT.delete(element);
    }
  }, [editor, key2, element]);
  var children = useChildren({
    decorations,
    node: element,
    renderElement,
    renderPlaceholder,
    renderLeaf,
    selection
  });
  var attributes = {
    "data-slate-node": "element",
    ref: ref2
  };
  if (isInline) {
    attributes["data-slate-inline"] = true;
  }
  if (!isInline && Editor.hasInlines(editor, element)) {
    var text = Node$1.string(element);
    var dir = getDirection(text);
    if (dir === "rtl") {
      attributes.dir = dir;
    }
  }
  if (Editor.isVoid(editor, element)) {
    attributes["data-slate-void"] = true;
    if (!readOnly && isInline) {
      attributes.contentEditable = false;
    }
    var Tag = isInline ? "span" : "div";
    var [[_text]] = Node$1.texts(element);
    children = /* @__PURE__ */ React__default.createElement(Tag, {
      "data-slate-spacer": true,
      style: {
        height: "0",
        color: "transparent",
        outline: "none",
        position: "absolute"
      }
    }, /* @__PURE__ */ React__default.createElement(MemoizedText, {
      renderPlaceholder,
      decorations: [],
      isLast: false,
      parent: element,
      text: _text
    }));
    NODE_TO_INDEX.set(_text, 0);
    NODE_TO_PARENT.set(_text, element);
  }
  return renderElement({
    attributes,
    children,
    element
  });
};
var MemoizedElement = /* @__PURE__ */ React__default.memo(Element$2, (prev, next3) => {
  return prev.element === next3.element && prev.renderElement === next3.renderElement && prev.renderLeaf === next3.renderLeaf && prev.renderPlaceholder === next3.renderPlaceholder && isElementDecorationsEqual(prev.decorations, next3.decorations) && (prev.selection === next3.selection || !!prev.selection && !!next3.selection && Range.equals(prev.selection, next3.selection));
});
var DefaultElement = (props2) => {
  var {
    attributes,
    children,
    element
  } = props2;
  var editor = useSlateStatic();
  var Tag = editor.isInline(element) ? "span" : "div";
  return /* @__PURE__ */ React__default.createElement(Tag, _objectSpread$2(_objectSpread$2({}, attributes), {}, {
    style: {
      position: "relative"
    }
  }), children);
};
var DecorateContext = /* @__PURE__ */ createContext$1(() => []);
var useDecorate = () => {
  return useContext(DecorateContext);
};
var SelectedContext = /* @__PURE__ */ createContext$1(false);
var useSelected = () => {
  return useContext(SelectedContext);
};
var useChildren = (props2) => {
  var {
    decorations,
    node: node3,
    renderElement,
    renderPlaceholder,
    renderLeaf,
    selection
  } = props2;
  var decorate = useDecorate();
  var editor = useSlateStatic();
  var path3 = ReactEditor.findPath(editor, node3);
  var children = [];
  var isLeafBlock = Element$3.isElement(node3) && !editor.isInline(node3) && Editor.hasInlines(editor, node3);
  for (var i3 = 0; i3 < node3.children.length; i3++) {
    var p2 = path3.concat(i3);
    var n2 = node3.children[i3];
    var key2 = ReactEditor.findKey(editor, n2);
    var range2 = Editor.range(editor, p2);
    var sel = selection && Range.intersection(range2, selection);
    var ds = decorate([n2, p2]);
    for (var dec of decorations) {
      var d4 = Range.intersection(dec, range2);
      if (d4) {
        ds.push(d4);
      }
    }
    if (Element$3.isElement(n2)) {
      children.push(/* @__PURE__ */ React__default.createElement(SelectedContext.Provider, {
        key: "provider-".concat(key2.id),
        value: !!sel
      }, /* @__PURE__ */ React__default.createElement(MemoizedElement, {
        decorations: ds,
        element: n2,
        key: key2.id,
        renderElement,
        renderPlaceholder,
        renderLeaf,
        selection: sel
      })));
    } else {
      children.push(/* @__PURE__ */ React__default.createElement(MemoizedText, {
        decorations: ds,
        key: key2.id,
        isLast: isLeafBlock && i3 === node3.children.length - 1,
        parent: node3,
        renderPlaceholder,
        renderLeaf,
        text: n2
      }));
    }
    NODE_TO_INDEX.set(n2, i3);
    NODE_TO_PARENT.set(n2, node3);
  }
  return children;
};
var ReadOnlyContext = /* @__PURE__ */ createContext$1(false);
var useReadOnly = () => {
  return useContext(ReadOnlyContext);
};
var SlateContext = /* @__PURE__ */ createContext$1(null);
var useSlate = () => {
  var context = useContext(SlateContext);
  if (!context) {
    throw new Error("The `useSlate` hook must be used inside the <Slate> component's context.");
  }
  var {
    editor
  } = context;
  return editor;
};
function useTrackUserInput() {
  var editor = useSlateStatic();
  var receivedUserInput = useRef(false);
  var animationFrameIdRef = useRef(0);
  var onUserInput = useCallback(() => {
    if (receivedUserInput.current) {
      return;
    }
    receivedUserInput.current = true;
    var window2 = ReactEditor.getWindow(editor);
    window2.cancelAnimationFrame(animationFrameIdRef.current);
    animationFrameIdRef.current = window2.requestAnimationFrame(() => {
      receivedUserInput.current = false;
    });
  }, [editor]);
  useEffect(() => () => cancelAnimationFrame(animationFrameIdRef.current), []);
  return {
    receivedUserInput,
    onUserInput
  };
}
var TRIPLE_CLICK = 3;
var HOTKEYS$1 = {
  bold: "mod+b",
  compose: ["down", "left", "right", "up", "backspace", "enter"],
  moveBackward: "left",
  moveForward: "right",
  moveWordBackward: "ctrl+left",
  moveWordForward: "ctrl+right",
  deleteBackward: "shift?+backspace",
  deleteForward: "shift?+delete",
  extendBackward: "shift+left",
  extendForward: "shift+right",
  italic: "mod+i",
  insertSoftBreak: "shift+enter",
  splitBlock: "enter",
  undo: "mod+z"
};
var APPLE_HOTKEYS = {
  moveLineBackward: "opt+up",
  moveLineForward: "opt+down",
  moveWordBackward: "opt+left",
  moveWordForward: "opt+right",
  deleteBackward: ["ctrl+backspace", "ctrl+h"],
  deleteForward: ["ctrl+delete", "ctrl+d"],
  deleteLineBackward: "cmd+shift?+backspace",
  deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
  deleteWordBackward: "opt+shift?+backspace",
  deleteWordForward: "opt+shift?+delete",
  extendLineBackward: "opt+shift+up",
  extendLineForward: "opt+shift+down",
  redo: "cmd+shift+z",
  transposeCharacter: "ctrl+t"
};
var WINDOWS_HOTKEYS = {
  deleteWordBackward: "ctrl+shift?+backspace",
  deleteWordForward: "ctrl+shift?+delete",
  redo: ["ctrl+y", "ctrl+shift+z"]
};
var create4 = (key2) => {
  var generic = HOTKEYS$1[key2];
  var apple = APPLE_HOTKEYS[key2];
  var windows = WINDOWS_HOTKEYS[key2];
  var isGeneric = generic && isHotkey_1(generic);
  var isApple = apple && isHotkey_1(apple);
  var isWindows = windows && isHotkey_1(windows);
  return (event) => {
    if (isGeneric && isGeneric(event)) return true;
    if (IS_APPLE && isApple && isApple(event)) return true;
    if (!IS_APPLE && isWindows && isWindows(event)) return true;
    return false;
  };
};
var Hotkeys = {
  isBold: create4("bold"),
  isCompose: create4("compose"),
  isMoveBackward: create4("moveBackward"),
  isMoveForward: create4("moveForward"),
  isDeleteBackward: create4("deleteBackward"),
  isDeleteForward: create4("deleteForward"),
  isDeleteLineBackward: create4("deleteLineBackward"),
  isDeleteLineForward: create4("deleteLineForward"),
  isDeleteWordBackward: create4("deleteWordBackward"),
  isDeleteWordForward: create4("deleteWordForward"),
  isExtendBackward: create4("extendBackward"),
  isExtendForward: create4("extendForward"),
  isExtendLineBackward: create4("extendLineBackward"),
  isExtendLineForward: create4("extendLineForward"),
  isItalic: create4("italic"),
  isMoveLineBackward: create4("moveLineBackward"),
  isMoveLineForward: create4("moveLineForward"),
  isMoveWordBackward: create4("moveWordBackward"),
  isMoveWordForward: create4("moveWordForward"),
  isRedo: create4("redo"),
  isSoftBreak: create4("insertSoftBreak"),
  isSplitBlock: create4("splitBlock"),
  isTransposeCharacter: create4("transposeCharacter"),
  isUndo: create4("undo")
};
var createRestoreDomManager = (editor, receivedUserInput) => {
  var bufferedMutations = [];
  var clear = () => {
    bufferedMutations = [];
  };
  var registerMutations = (mutations) => {
    if (!receivedUserInput.current) {
      return;
    }
    var trackedMutations = mutations.filter((mutation) => isTrackedMutation(editor, mutation, mutations));
    bufferedMutations.push(...trackedMutations);
  };
  function restoreDOM() {
    if (bufferedMutations.length > 0) {
      bufferedMutations.reverse().forEach((mutation) => {
        if (mutation.type === "characterData") {
          return;
        }
        mutation.removedNodes.forEach((node3) => {
          mutation.target.insertBefore(node3, mutation.nextSibling);
        });
        mutation.addedNodes.forEach((node3) => {
          mutation.target.removeChild(node3);
        });
      });
      clear();
    }
  }
  return {
    registerMutations,
    restoreDOM,
    clear
  };
};
var MUTATION_OBSERVER_CONFIG = {
  subtree: true,
  childList: true,
  characterData: true,
  characterDataOldValue: true
};
class RestoreDOMComponent extends Component {
  constructor() {
    super(...arguments);
    _defineProperty$3(this, "context", null);
    _defineProperty$3(this, "manager", null);
    _defineProperty$3(this, "mutationObserver", null);
  }
  observe() {
    var _this$mutationObserve;
    var {
      node: node3
    } = this.props;
    if (!node3.current) {
      throw new Error("Failed to attach MutationObserver, `node` is undefined");
    }
    (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(node3.current, MUTATION_OBSERVER_CONFIG);
  }
  componentDidMount() {
    var {
      receivedUserInput
    } = this.props;
    var editor = this.context;
    this.manager = createRestoreDomManager(editor, receivedUserInput);
    this.mutationObserver = new MutationObserver(this.manager.registerMutations);
    this.observe();
  }
  getSnapshotBeforeUpdate() {
    var _this$mutationObserve2, _this$mutationObserve3, _this$manager2;
    var pendingMutations = (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 ? void 0 : _this$mutationObserve2.takeRecords();
    if (pendingMutations !== null && pendingMutations !== void 0 && pendingMutations.length) {
      var _this$manager;
      (_this$manager = this.manager) === null || _this$manager === void 0 || _this$manager.registerMutations(pendingMutations);
    }
    (_this$mutationObserve3 = this.mutationObserver) === null || _this$mutationObserve3 === void 0 || _this$mutationObserve3.disconnect();
    (_this$manager2 = this.manager) === null || _this$manager2 === void 0 || _this$manager2.restoreDOM();
    return null;
  }
  componentDidUpdate() {
    var _this$manager3;
    (_this$manager3 = this.manager) === null || _this$manager3 === void 0 || _this$manager3.clear();
    this.observe();
  }
  componentWillUnmount() {
    var _this$mutationObserve4;
    (_this$mutationObserve4 = this.mutationObserver) === null || _this$mutationObserve4 === void 0 || _this$mutationObserve4.disconnect();
  }
  render() {
    return this.props.children;
  }
}
_defineProperty$3(RestoreDOMComponent, "contextType", EditorContext);
var RestoreDOM = IS_ANDROID ? RestoreDOMComponent : (_ref) => {
  var {
    children
  } = _ref;
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children);
};
var _excluded$1 = ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "renderPlaceholder", "scrollSelectionIntoView", "style", "as", "disableDefaultStyles"], _excluded2 = ["text"];
function ownKeys$1$1(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$1$1(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$1$1(Object(t3), true).forEach(function(r3) {
      _defineProperty$3(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$1$1(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var Children = (props2) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, useChildren(props2));
var Editable = (props2) => {
  var defaultRenderPlaceholder = useCallback((props3) => /* @__PURE__ */ React__default.createElement(DefaultPlaceholder, _objectSpread$1$1({}, props3)), []);
  var {
    autoFocus,
    decorate = defaultDecorate,
    onDOMBeforeInput: propsOnDOMBeforeInput,
    placeholder,
    readOnly = false,
    renderElement,
    renderLeaf,
    renderPlaceholder = defaultRenderPlaceholder,
    scrollSelectionIntoView = defaultScrollSelectionIntoView,
    style: userStyle = {},
    as: Component2 = "div",
    disableDefaultStyles = false
  } = props2, attributes = _objectWithoutProperties$1(props2, _excluded$1);
  var editor = useSlate();
  var [isComposing, setIsComposing] = useState(false);
  var ref2 = useRef(null);
  var deferredOperations = useRef([]);
  var [placeholderHeight, setPlaceholderHeight] = useState();
  var processing = useRef(false);
  var {
    onUserInput,
    receivedUserInput
  } = useTrackUserInput();
  var [, forceRender] = useReducer((s4) => s4 + 1, 0);
  EDITOR_TO_FORCE_RENDER.set(editor, forceRender);
  IS_READ_ONLY.set(editor, readOnly);
  var state = useMemo(() => ({
    isDraggingInternally: false,
    isUpdatingSelection: false,
    latestElement: null,
    hasMarkPlaceholder: false
  }), []);
  useEffect(() => {
    if (ref2.current && autoFocus) {
      ref2.current.focus();
    }
  }, [autoFocus]);
  var androidInputManagerRef = useRef();
  var onDOMSelectionChange = useMemo(() => throttle$1(() => {
    var el2 = ReactEditor.toDOMNode(editor, editor);
    var root2 = el2.getRootNode();
    if (IS_SAFARI_LEGACY && !processing.current && IS_WEBKIT && root2 instanceof ShadowRoot) {
      processing.current = true;
      var active = getActiveElement();
      if (active) {
        document.execCommand("indent");
      } else {
        Transforms.deselect(editor);
      }
      processing.current = false;
      return;
    }
    var androidInputManager = androidInputManagerRef.current;
    if ((IS_ANDROID || !ReactEditor.isComposing(editor)) && (!state.isUpdatingSelection || androidInputManager !== null && androidInputManager !== void 0 && androidInputManager.isFlushing()) && !state.isDraggingInternally) {
      var _root2 = ReactEditor.findDocumentOrShadowRoot(editor);
      var {
        activeElement
      } = _root2;
      var _el = ReactEditor.toDOMNode(editor, editor);
      var domSelection = _root2.getSelection();
      if (activeElement === _el) {
        state.latestElement = activeElement;
        IS_FOCUSED.set(editor, true);
      } else {
        IS_FOCUSED.delete(editor);
      }
      if (!domSelection) {
        return Transforms.deselect(editor);
      }
      var {
        anchorNode,
        focusNode
      } = domSelection;
      var anchorNodeSelectable = ReactEditor.hasEditableTarget(editor, anchorNode) || ReactEditor.isTargetInsideNonReadonlyVoid(editor, anchorNode);
      var focusNodeSelectable = ReactEditor.hasEditableTarget(editor, focusNode) || ReactEditor.isTargetInsideNonReadonlyVoid(editor, focusNode);
      if (anchorNodeSelectable && focusNodeSelectable) {
        var range2 = ReactEditor.toSlateRange(editor, domSelection, {
          exactMatch: false,
          suppressThrow: true
        });
        if (range2) {
          if (!ReactEditor.isComposing(editor) && !(androidInputManager !== null && androidInputManager !== void 0 && androidInputManager.hasPendingChanges()) && !(androidInputManager !== null && androidInputManager !== void 0 && androidInputManager.isFlushing())) {
            Transforms.select(editor, range2);
          } else {
            androidInputManager === null || androidInputManager === void 0 || androidInputManager.handleUserSelect(range2);
          }
        }
      }
      if (readOnly && (!anchorNodeSelectable || !focusNodeSelectable)) {
        Transforms.deselect(editor);
      }
    }
  }, 100), [editor, readOnly, state]);
  var scheduleOnDOMSelectionChange = useMemo(() => debounce$3(onDOMSelectionChange, 0), [onDOMSelectionChange]);
  androidInputManagerRef.current = useAndroidInputManager({
    node: ref2,
    onDOMSelectionChange,
    scheduleOnDOMSelectionChange
  });
  useIsomorphicLayoutEffect(() => {
    var _androidInputManagerR, _androidInputManagerR2;
    var window2;
    if (ref2.current && (window2 = getDefaultView(ref2.current))) {
      EDITOR_TO_WINDOW.set(editor, window2);
      EDITOR_TO_ELEMENT.set(editor, ref2.current);
      NODE_TO_ELEMENT.set(editor, ref2.current);
      ELEMENT_TO_NODE.set(ref2.current, editor);
    } else {
      NODE_TO_ELEMENT.delete(editor);
    }
    var {
      selection
    } = editor;
    var root2 = ReactEditor.findDocumentOrShadowRoot(editor);
    var domSelection = root2.getSelection();
    if (!domSelection || !ReactEditor.isFocused(editor) || (_androidInputManagerR = androidInputManagerRef.current) !== null && _androidInputManagerR !== void 0 && _androidInputManagerR.hasPendingAction()) {
      return;
    }
    var setDomSelection = (forceChange) => {
      var hasDomSelection = domSelection.type !== "None";
      if (!selection && !hasDomSelection) {
        return;
      }
      var focusNode = domSelection.focusNode;
      var anchorNode;
      if (IS_FIREFOX && domSelection.rangeCount > 1) {
        var firstRange = domSelection.getRangeAt(0);
        var lastRange = domSelection.getRangeAt(domSelection.rangeCount - 1);
        if (firstRange.startContainer === focusNode) {
          anchorNode = lastRange.endContainer;
        } else {
          anchorNode = firstRange.startContainer;
        }
      } else {
        anchorNode = domSelection.anchorNode;
      }
      var editorElement = EDITOR_TO_ELEMENT.get(editor);
      var hasDomSelectionInEditor = false;
      if (editorElement.contains(anchorNode) && editorElement.contains(focusNode)) {
        hasDomSelectionInEditor = true;
      }
      if (hasDomSelection && hasDomSelectionInEditor && selection && !forceChange) {
        var slateRange = ReactEditor.toSlateRange(editor, domSelection, {
          exactMatch: true,
          // domSelection is not necessarily a valid Slate range
          // (e.g. when clicking on contentEditable:false element)
          suppressThrow: true
        });
        if (slateRange && Range.equals(slateRange, selection)) {
          var _anchorNode;
          if (!state.hasMarkPlaceholder) {
            return;
          }
          if ((_anchorNode = anchorNode) !== null && _anchorNode !== void 0 && (_anchorNode = _anchorNode.parentElement) !== null && _anchorNode !== void 0 && _anchorNode.hasAttribute("data-slate-mark-placeholder")) {
            return;
          }
        }
      }
      if (selection && !ReactEditor.hasRange(editor, selection)) {
        editor.selection = ReactEditor.toSlateRange(editor, domSelection, {
          exactMatch: false,
          suppressThrow: true
        });
        return;
      }
      state.isUpdatingSelection = true;
      var newDomRange = selection && ReactEditor.toDOMRange(editor, selection);
      if (newDomRange) {
        if (ReactEditor.isComposing(editor) && !IS_ANDROID) {
          domSelection.collapseToEnd();
        } else if (Range.isBackward(selection)) {
          domSelection.setBaseAndExtent(newDomRange.endContainer, newDomRange.endOffset, newDomRange.startContainer, newDomRange.startOffset);
        } else {
          domSelection.setBaseAndExtent(newDomRange.startContainer, newDomRange.startOffset, newDomRange.endContainer, newDomRange.endOffset);
        }
        scrollSelectionIntoView(editor, newDomRange);
      } else {
        domSelection.removeAllRanges();
      }
      return newDomRange;
    };
    if (domSelection.rangeCount <= 1) {
      setDomSelection();
    }
    var ensureSelection = ((_androidInputManagerR2 = androidInputManagerRef.current) === null || _androidInputManagerR2 === void 0 ? void 0 : _androidInputManagerR2.isFlushing()) === "action";
    if (!IS_ANDROID || !ensureSelection) {
      setTimeout(() => {
        state.isUpdatingSelection = false;
      });
      return;
    }
    var timeoutId = null;
    var animationFrameId = requestAnimationFrame(() => {
      if (ensureSelection) {
        var ensureDomSelection = (forceChange) => {
          try {
            var el2 = ReactEditor.toDOMNode(editor, editor);
            el2.focus();
            setDomSelection(forceChange);
          } catch (e5) {
          }
        };
        ensureDomSelection();
        timeoutId = setTimeout(() => {
          ensureDomSelection(true);
          state.isUpdatingSelection = false;
        });
      }
    });
    return () => {
      cancelAnimationFrame(animationFrameId);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  });
  var onDOMBeforeInput = useCallback((event) => {
    var el2 = ReactEditor.toDOMNode(editor, editor);
    var root2 = el2.getRootNode();
    if (IS_SAFARI_LEGACY && processing !== null && processing !== void 0 && processing.current && IS_WEBKIT && root2 instanceof ShadowRoot) {
      var ranges = event.getTargetRanges();
      var range2 = ranges[0];
      var newRange = new window.Range();
      newRange.setStart(range2.startContainer, range2.startOffset);
      newRange.setEnd(range2.endContainer, range2.endOffset);
      var slateRange = ReactEditor.toSlateRange(editor, newRange, {
        exactMatch: false,
        suppressThrow: false
      });
      Transforms.select(editor, slateRange);
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    onUserInput();
    if (!readOnly && ReactEditor.hasEditableTarget(editor, event.target) && !isDOMEventHandled(event, propsOnDOMBeforeInput)) {
      var _EDITOR_TO_USER_SELEC;
      if (androidInputManagerRef.current) {
        return androidInputManagerRef.current.handleDOMBeforeInput(event);
      }
      scheduleOnDOMSelectionChange.flush();
      onDOMSelectionChange.flush();
      var {
        selection
      } = editor;
      var {
        inputType: type2
      } = event;
      var data = event.dataTransfer || event.data || void 0;
      var isCompositionChange = type2 === "insertCompositionText" || type2 === "deleteCompositionText";
      if (isCompositionChange && ReactEditor.isComposing(editor)) {
        return;
      }
      var native = false;
      if (type2 === "insertText" && selection && Range.isCollapsed(selection) && // Only use native character insertion for single characters a-z or space for now.
      // Long-press events (hold a + press 4 = ä) to choose a special character otherwise
      // causes duplicate inserts.
      event.data && event.data.length === 1 && /[a-z ]/i.test(event.data) && // Chrome has issues correctly editing the start of nodes: https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
      // When there is an inline element, e.g. a link, and you select
      // right after it (the start of the next node).
      selection.anchor.offset !== 0) {
        var _node$parentElement, _window$getComputedSt;
        native = true;
        if (editor.marks) {
          native = false;
        }
        var {
          anchor: anchor2
        } = selection;
        var [node3, offset2] = ReactEditor.toDOMPoint(editor, anchor2);
        var anchorNode = (_node$parentElement = node3.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.closest("a");
        var _window = ReactEditor.getWindow(editor);
        if (native && anchorNode && ReactEditor.hasDOMNode(editor, anchorNode)) {
          var _lastText$textContent;
          var lastText = _window === null || _window === void 0 ? void 0 : _window.document.createTreeWalker(anchorNode, NodeFilter.SHOW_TEXT).lastChild();
          if (lastText === node3 && ((_lastText$textContent = lastText.textContent) === null || _lastText$textContent === void 0 ? void 0 : _lastText$textContent.length) === offset2) {
            native = false;
          }
        }
        if (native && node3.parentElement && (_window === null || _window === void 0 || (_window$getComputedSt = _window.getComputedStyle(node3.parentElement)) === null || _window$getComputedSt === void 0 ? void 0 : _window$getComputedSt.whiteSpace) === "pre") {
          var block = Editor.above(editor, {
            at: anchor2.path,
            match: (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2)
          });
          if (block && Node$1.string(block[0]).includes("	")) {
            native = false;
          }
        }
      }
      if (!type2.startsWith("delete") || type2.startsWith("deleteBy")) {
        var [targetRange2] = event.getTargetRanges();
        if (targetRange2) {
          var _range = ReactEditor.toSlateRange(editor, targetRange2, {
            exactMatch: false,
            suppressThrow: false
          });
          if (!selection || !Range.equals(selection, _range)) {
            native = false;
            var selectionRef = !isCompositionChange && editor.selection && Editor.rangeRef(editor, editor.selection);
            Transforms.select(editor, _range);
            if (selectionRef) {
              EDITOR_TO_USER_SELECTION.set(editor, selectionRef);
            }
          }
        }
      }
      if (isCompositionChange) {
        return;
      }
      if (!native) {
        event.preventDefault();
      }
      if (selection && Range.isExpanded(selection) && type2.startsWith("delete")) {
        var direction2 = type2.endsWith("Backward") ? "backward" : "forward";
        Editor.deleteFragment(editor, {
          direction: direction2
        });
        return;
      }
      switch (type2) {
        case "deleteByComposition":
        case "deleteByCut":
        case "deleteByDrag": {
          Editor.deleteFragment(editor);
          break;
        }
        case "deleteContent":
        case "deleteContentForward": {
          Editor.deleteForward(editor);
          break;
        }
        case "deleteContentBackward": {
          Editor.deleteBackward(editor);
          break;
        }
        case "deleteEntireSoftLine": {
          Editor.deleteBackward(editor, {
            unit: "line"
          });
          Editor.deleteForward(editor, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineBackward": {
          Editor.deleteBackward(editor, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineBackward": {
          Editor.deleteBackward(editor, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineForward": {
          Editor.deleteForward(editor, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineForward": {
          Editor.deleteForward(editor, {
            unit: "line"
          });
          break;
        }
        case "deleteWordBackward": {
          Editor.deleteBackward(editor, {
            unit: "word"
          });
          break;
        }
        case "deleteWordForward": {
          Editor.deleteForward(editor, {
            unit: "word"
          });
          break;
        }
        case "insertLineBreak":
          Editor.insertSoftBreak(editor);
          break;
        case "insertParagraph": {
          Editor.insertBreak(editor);
          break;
        }
        case "insertFromComposition":
        case "insertFromDrop":
        case "insertFromPaste":
        case "insertFromYank":
        case "insertReplacementText":
        case "insertText": {
          if (type2 === "insertFromComposition") {
            if (ReactEditor.isComposing(editor)) {
              setIsComposing(false);
              IS_COMPOSING.set(editor, false);
            }
          }
          if ((data === null || data === void 0 ? void 0 : data.constructor.name) === "DataTransfer") {
            ReactEditor.insertData(editor, data);
          } else if (typeof data === "string") {
            if (native) {
              deferredOperations.current.push(() => Editor.insertText(editor, data));
            } else {
              Editor.insertText(editor, data);
            }
          }
          break;
        }
      }
      var toRestore = (_EDITOR_TO_USER_SELEC = EDITOR_TO_USER_SELECTION.get(editor)) === null || _EDITOR_TO_USER_SELEC === void 0 ? void 0 : _EDITOR_TO_USER_SELEC.unref();
      EDITOR_TO_USER_SELECTION.delete(editor);
      if (toRestore && (!editor.selection || !Range.equals(editor.selection, toRestore))) {
        Transforms.select(editor, toRestore);
      }
    }
  }, [editor, onDOMSelectionChange, onUserInput, propsOnDOMBeforeInput, readOnly, scheduleOnDOMSelectionChange]);
  var callbackRef = useCallback((node3) => {
    if (node3 == null) {
      onDOMSelectionChange.cancel();
      scheduleOnDOMSelectionChange.cancel();
      EDITOR_TO_ELEMENT.delete(editor);
      NODE_TO_ELEMENT.delete(editor);
      if (ref2.current && HAS_BEFORE_INPUT_SUPPORT) {
        ref2.current.removeEventListener("beforeinput", onDOMBeforeInput);
      }
    } else {
      if (HAS_BEFORE_INPUT_SUPPORT) {
        node3.addEventListener("beforeinput", onDOMBeforeInput);
      }
    }
    ref2.current = node3;
  }, [onDOMSelectionChange, scheduleOnDOMSelectionChange, editor, onDOMBeforeInput]);
  useIsomorphicLayoutEffect(() => {
    var window2 = ReactEditor.getWindow(editor);
    window2.document.addEventListener("selectionchange", scheduleOnDOMSelectionChange);
    return () => {
      window2.document.removeEventListener("selectionchange", scheduleOnDOMSelectionChange);
    };
  }, [scheduleOnDOMSelectionChange]);
  var decorations = decorate([editor, []]);
  var showPlaceholder = placeholder && editor.children.length === 1 && Array.from(Node$1.texts(editor)).length === 1 && Node$1.string(editor) === "" && !isComposing;
  var placeHolderResizeHandler = useCallback((placeholderEl) => {
    if (placeholderEl && showPlaceholder) {
      var _placeholderEl$getBou;
      setPlaceholderHeight((_placeholderEl$getBou = placeholderEl.getBoundingClientRect()) === null || _placeholderEl$getBou === void 0 ? void 0 : _placeholderEl$getBou.height);
    } else {
      setPlaceholderHeight(void 0);
    }
  }, [showPlaceholder]);
  if (showPlaceholder) {
    var start2 = Editor.start(editor, []);
    decorations.push({
      [PLACEHOLDER_SYMBOL]: true,
      placeholder,
      onPlaceholderResize: placeHolderResizeHandler,
      anchor: start2,
      focus: start2
    });
  }
  var {
    marks: marks3
  } = editor;
  state.hasMarkPlaceholder = false;
  if (editor.selection && Range.isCollapsed(editor.selection) && marks3) {
    var {
      anchor
    } = editor.selection;
    var leaf3 = Node$1.leaf(editor, anchor.path);
    var rest = _objectWithoutProperties$1(leaf3, _excluded2);
    if (!Text$1.equals(leaf3, marks3, {
      loose: true
    })) {
      state.hasMarkPlaceholder = true;
      var unset2 = Object.fromEntries(Object.keys(rest).map((mark) => [mark, null]));
      decorations.push(_objectSpread$1$1(_objectSpread$1$1(_objectSpread$1$1({
        [MARK_PLACEHOLDER_SYMBOL]: true
      }, unset2), marks3), {}, {
        anchor,
        focus: anchor
      }));
    }
  }
  useEffect(() => {
    setTimeout(() => {
      var {
        selection
      } = editor;
      if (selection) {
        var {
          anchor: _anchor
        } = selection;
        var _text = Node$1.leaf(editor, _anchor.path);
        if (marks3 && !Text$1.equals(_text, marks3, {
          loose: true
        })) {
          EDITOR_TO_PENDING_INSERTION_MARKS.set(editor, marks3);
          return;
        }
      }
      EDITOR_TO_PENDING_INSERTION_MARKS.delete(editor);
    });
  });
  return /* @__PURE__ */ React__default.createElement(ReadOnlyContext.Provider, {
    value: readOnly
  }, /* @__PURE__ */ React__default.createElement(DecorateContext.Provider, {
    value: decorate
  }, /* @__PURE__ */ React__default.createElement(RestoreDOM, {
    node: ref2,
    receivedUserInput
  }, /* @__PURE__ */ React__default.createElement(Component2, _objectSpread$1$1(_objectSpread$1$1({
    role: readOnly ? void 0 : "textbox",
    "aria-multiline": readOnly ? void 0 : true
  }, attributes), {}, {
    // COMPAT: Certain browsers don't support the `beforeinput` event, so we'd
    // have to use hacks to make these replacement-based features work.
    // For SSR situations HAS_BEFORE_INPUT_SUPPORT is false and results in prop
    // mismatch warning app moves to browser. Pass-through consumer props when
    // not CAN_USE_DOM (SSR) and default to falsy value
    spellCheck: HAS_BEFORE_INPUT_SUPPORT || !CAN_USE_DOM ? attributes.spellCheck : false,
    autoCorrect: HAS_BEFORE_INPUT_SUPPORT || !CAN_USE_DOM ? attributes.autoCorrect : "false",
    autoCapitalize: HAS_BEFORE_INPUT_SUPPORT || !CAN_USE_DOM ? attributes.autoCapitalize : "false",
    "data-slate-editor": true,
    "data-slate-node": "value",
    // explicitly set this
    contentEditable: !readOnly,
    // in some cases, a decoration needs access to the range / selection to decorate a text node,
    // then you will select the whole text node when you select part the of text
    // this magic zIndex="-1" will fix it
    zindex: -1,
    suppressContentEditableWarning: true,
    ref: callbackRef,
    style: _objectSpread$1$1(_objectSpread$1$1({}, disableDefaultStyles ? {} : _objectSpread$1$1({
      // Allow positioning relative to the editable element.
      position: "relative",
      // Preserve adjacent whitespace and new lines.
      whiteSpace: "pre-wrap",
      // Allow words to break if they are too long.
      wordWrap: "break-word"
    }, placeholderHeight ? {
      minHeight: placeholderHeight
    } : {})), userStyle),
    onBeforeInput: useCallback((event) => {
      if (!HAS_BEFORE_INPUT_SUPPORT && !readOnly && !isEventHandled(event, attributes.onBeforeInput) && ReactEditor.hasSelectableTarget(editor, event.target)) {
        event.preventDefault();
        if (!ReactEditor.isComposing(editor)) {
          var _text2 = event.data;
          Editor.insertText(editor, _text2);
        }
      }
    }, [attributes.onBeforeInput, editor, readOnly]),
    onInput: useCallback((event) => {
      if (isEventHandled(event, attributes.onInput)) {
        return;
      }
      if (androidInputManagerRef.current) {
        androidInputManagerRef.current.handleInput();
        return;
      }
      for (var op of deferredOperations.current) {
        op();
      }
      deferredOperations.current = [];
    }, [attributes.onInput]),
    onBlur: useCallback((event) => {
      if (readOnly || state.isUpdatingSelection || !ReactEditor.hasSelectableTarget(editor, event.target) || isEventHandled(event, attributes.onBlur)) {
        return;
      }
      var root2 = ReactEditor.findDocumentOrShadowRoot(editor);
      if (state.latestElement === root2.activeElement) {
        return;
      }
      var {
        relatedTarget
      } = event;
      var el2 = ReactEditor.toDOMNode(editor, editor);
      if (relatedTarget === el2) {
        return;
      }
      if (isDOMElement(relatedTarget) && relatedTarget.hasAttribute("data-slate-spacer")) {
        return;
      }
      if (relatedTarget != null && isDOMNode(relatedTarget) && ReactEditor.hasDOMNode(editor, relatedTarget)) {
        var node3 = ReactEditor.toSlateNode(editor, relatedTarget);
        if (Element$3.isElement(node3) && !editor.isVoid(node3)) {
          return;
        }
      }
      if (IS_WEBKIT) {
        var domSelection = root2.getSelection();
        domSelection === null || domSelection === void 0 || domSelection.removeAllRanges();
      }
      IS_FOCUSED.delete(editor);
    }, [readOnly, state.isUpdatingSelection, state.latestElement, editor, attributes.onBlur]),
    onClick: useCallback((event) => {
      if (ReactEditor.hasTarget(editor, event.target) && !isEventHandled(event, attributes.onClick) && isDOMNode(event.target)) {
        var node3 = ReactEditor.toSlateNode(editor, event.target);
        var path3 = ReactEditor.findPath(editor, node3);
        if (!Editor.hasPath(editor, path3) || Node$1.get(editor, path3) !== node3) {
          return;
        }
        if (event.detail === TRIPLE_CLICK && path3.length >= 1) {
          var blockPath = path3;
          if (!(Element$3.isElement(node3) && Editor.isBlock(editor, node3))) {
            var _block$;
            var block = Editor.above(editor, {
              match: (n2) => Element$3.isElement(n2) && Editor.isBlock(editor, n2),
              at: path3
            });
            blockPath = (_block$ = block === null || block === void 0 ? void 0 : block[1]) !== null && _block$ !== void 0 ? _block$ : path3.slice(0, 1);
          }
          var range2 = Editor.range(editor, blockPath);
          Transforms.select(editor, range2);
          return;
        }
        if (readOnly) {
          return;
        }
        var _start = Editor.start(editor, path3);
        var end2 = Editor.end(editor, path3);
        var startVoid = Editor.void(editor, {
          at: _start
        });
        var endVoid = Editor.void(editor, {
          at: end2
        });
        if (startVoid && endVoid && Path.equals(startVoid[1], endVoid[1])) {
          var _range2 = Editor.range(editor, _start);
          Transforms.select(editor, _range2);
        }
      }
    }, [editor, attributes.onClick, readOnly]),
    onCompositionEnd: useCallback((event) => {
      if (ReactEditor.hasSelectableTarget(editor, event.target)) {
        var _androidInputManagerR3;
        if (ReactEditor.isComposing(editor)) {
          Promise.resolve().then(() => {
            setIsComposing(false);
            IS_COMPOSING.set(editor, false);
          });
        }
        (_androidInputManagerR3 = androidInputManagerRef.current) === null || _androidInputManagerR3 === void 0 || _androidInputManagerR3.handleCompositionEnd(event);
        if (isEventHandled(event, attributes.onCompositionEnd) || IS_ANDROID) {
          return;
        }
        if (!IS_WEBKIT && !IS_FIREFOX_LEGACY && !IS_IOS && !IS_WECHATBROWSER && !IS_UC_MOBILE && event.data) {
          var placeholderMarks = EDITOR_TO_PENDING_INSERTION_MARKS.get(editor);
          EDITOR_TO_PENDING_INSERTION_MARKS.delete(editor);
          if (placeholderMarks !== void 0) {
            EDITOR_TO_USER_MARKS.set(editor, editor.marks);
            editor.marks = placeholderMarks;
          }
          Editor.insertText(editor, event.data);
          var userMarks = EDITOR_TO_USER_MARKS.get(editor);
          EDITOR_TO_USER_MARKS.delete(editor);
          if (userMarks !== void 0) {
            editor.marks = userMarks;
          }
        }
      }
    }, [attributes.onCompositionEnd, editor]),
    onCompositionUpdate: useCallback((event) => {
      if (ReactEditor.hasSelectableTarget(editor, event.target) && !isEventHandled(event, attributes.onCompositionUpdate)) {
        if (!ReactEditor.isComposing(editor)) {
          setIsComposing(true);
          IS_COMPOSING.set(editor, true);
        }
      }
    }, [attributes.onCompositionUpdate, editor]),
    onCompositionStart: useCallback((event) => {
      if (ReactEditor.hasSelectableTarget(editor, event.target)) {
        var _androidInputManagerR4;
        (_androidInputManagerR4 = androidInputManagerRef.current) === null || _androidInputManagerR4 === void 0 || _androidInputManagerR4.handleCompositionStart(event);
        if (isEventHandled(event, attributes.onCompositionStart) || IS_ANDROID) {
          return;
        }
        setIsComposing(true);
        var {
          selection
        } = editor;
        if (selection && Range.isExpanded(selection)) {
          Editor.deleteFragment(editor);
          return;
        }
      }
    }, [attributes.onCompositionStart, editor]),
    onCopy: useCallback((event) => {
      if (ReactEditor.hasSelectableTarget(editor, event.target) && !isEventHandled(event, attributes.onCopy) && !isDOMEventTargetInput(event)) {
        event.preventDefault();
        ReactEditor.setFragmentData(editor, event.clipboardData, "copy");
      }
    }, [attributes.onCopy, editor]),
    onCut: useCallback((event) => {
      if (!readOnly && ReactEditor.hasSelectableTarget(editor, event.target) && !isEventHandled(event, attributes.onCut) && !isDOMEventTargetInput(event)) {
        event.preventDefault();
        ReactEditor.setFragmentData(editor, event.clipboardData, "cut");
        var {
          selection
        } = editor;
        if (selection) {
          if (Range.isExpanded(selection)) {
            Editor.deleteFragment(editor);
          } else {
            var node3 = Node$1.parent(editor, selection.anchor.path);
            if (Editor.isVoid(editor, node3)) {
              Transforms.delete(editor);
            }
          }
        }
      }
    }, [readOnly, editor, attributes.onCut]),
    onDragOver: useCallback((event) => {
      if (ReactEditor.hasTarget(editor, event.target) && !isEventHandled(event, attributes.onDragOver)) {
        var node3 = ReactEditor.toSlateNode(editor, event.target);
        if (Element$3.isElement(node3) && Editor.isVoid(editor, node3)) {
          event.preventDefault();
        }
      }
    }, [attributes.onDragOver, editor]),
    onDragStart: useCallback((event) => {
      if (!readOnly && ReactEditor.hasTarget(editor, event.target) && !isEventHandled(event, attributes.onDragStart)) {
        var node3 = ReactEditor.toSlateNode(editor, event.target);
        var path3 = ReactEditor.findPath(editor, node3);
        var voidMatch = Element$3.isElement(node3) && Editor.isVoid(editor, node3) || Editor.void(editor, {
          at: path3,
          voids: true
        });
        if (voidMatch) {
          var range2 = Editor.range(editor, path3);
          Transforms.select(editor, range2);
        }
        state.isDraggingInternally = true;
        ReactEditor.setFragmentData(editor, event.dataTransfer, "drag");
      }
    }, [readOnly, editor, attributes.onDragStart, state]),
    onDrop: useCallback((event) => {
      if (!readOnly && ReactEditor.hasTarget(editor, event.target) && !isEventHandled(event, attributes.onDrop)) {
        event.preventDefault();
        var draggedRange = editor.selection;
        var range2 = ReactEditor.findEventRange(editor, event);
        var data = event.dataTransfer;
        Transforms.select(editor, range2);
        if (state.isDraggingInternally) {
          if (draggedRange && !Range.equals(draggedRange, range2) && !Editor.void(editor, {
            at: range2,
            voids: true
          })) {
            Transforms.delete(editor, {
              at: draggedRange
            });
          }
        }
        ReactEditor.insertData(editor, data);
        if (!ReactEditor.isFocused(editor)) {
          ReactEditor.focus(editor);
        }
      }
      state.isDraggingInternally = false;
    }, [readOnly, editor, attributes.onDrop, state]),
    onDragEnd: useCallback((event) => {
      if (!readOnly && state.isDraggingInternally && attributes.onDragEnd && ReactEditor.hasTarget(editor, event.target)) {
        attributes.onDragEnd(event);
      }
      state.isDraggingInternally = false;
    }, [readOnly, state, attributes, editor]),
    onFocus: useCallback((event) => {
      if (!readOnly && !state.isUpdatingSelection && ReactEditor.hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onFocus)) {
        var el2 = ReactEditor.toDOMNode(editor, editor);
        var root2 = ReactEditor.findDocumentOrShadowRoot(editor);
        state.latestElement = root2.activeElement;
        if (IS_FIREFOX && event.target !== el2) {
          el2.focus();
          return;
        }
        IS_FOCUSED.set(editor, true);
      }
    }, [readOnly, state, editor, attributes.onFocus]),
    onKeyDown: useCallback((event) => {
      if (!readOnly && ReactEditor.hasEditableTarget(editor, event.target)) {
        var _androidInputManagerR5;
        (_androidInputManagerR5 = androidInputManagerRef.current) === null || _androidInputManagerR5 === void 0 || _androidInputManagerR5.handleKeyDown(event);
        var {
          nativeEvent
        } = event;
        if (ReactEditor.isComposing(editor) && nativeEvent.isComposing === false) {
          IS_COMPOSING.set(editor, false);
          setIsComposing(false);
        }
        if (isEventHandled(event, attributes.onKeyDown) || ReactEditor.isComposing(editor)) {
          return;
        }
        var {
          selection
        } = editor;
        var element = editor.children[selection !== null ? selection.focus.path[0] : 0];
        var isRTL = getDirection(Node$1.string(element)) === "rtl";
        if (Hotkeys.isRedo(nativeEvent)) {
          event.preventDefault();
          var maybeHistoryEditor = editor;
          if (typeof maybeHistoryEditor.redo === "function") {
            maybeHistoryEditor.redo();
          }
          return;
        }
        if (Hotkeys.isUndo(nativeEvent)) {
          event.preventDefault();
          var _maybeHistoryEditor = editor;
          if (typeof _maybeHistoryEditor.undo === "function") {
            _maybeHistoryEditor.undo();
          }
          return;
        }
        if (Hotkeys.isMoveLineBackward(nativeEvent)) {
          event.preventDefault();
          Transforms.move(editor, {
            unit: "line",
            reverse: true
          });
          return;
        }
        if (Hotkeys.isMoveLineForward(nativeEvent)) {
          event.preventDefault();
          Transforms.move(editor, {
            unit: "line"
          });
          return;
        }
        if (Hotkeys.isExtendLineBackward(nativeEvent)) {
          event.preventDefault();
          Transforms.move(editor, {
            unit: "line",
            edge: "focus",
            reverse: true
          });
          return;
        }
        if (Hotkeys.isExtendLineForward(nativeEvent)) {
          event.preventDefault();
          Transforms.move(editor, {
            unit: "line",
            edge: "focus"
          });
          return;
        }
        if (Hotkeys.isMoveBackward(nativeEvent)) {
          event.preventDefault();
          if (selection && Range.isCollapsed(selection)) {
            Transforms.move(editor, {
              reverse: !isRTL
            });
          } else {
            Transforms.collapse(editor, {
              edge: isRTL ? "end" : "start"
            });
          }
          return;
        }
        if (Hotkeys.isMoveForward(nativeEvent)) {
          event.preventDefault();
          if (selection && Range.isCollapsed(selection)) {
            Transforms.move(editor, {
              reverse: isRTL
            });
          } else {
            Transforms.collapse(editor, {
              edge: isRTL ? "start" : "end"
            });
          }
          return;
        }
        if (Hotkeys.isMoveWordBackward(nativeEvent)) {
          event.preventDefault();
          if (selection && Range.isExpanded(selection)) {
            Transforms.collapse(editor, {
              edge: "focus"
            });
          }
          Transforms.move(editor, {
            unit: "word",
            reverse: !isRTL
          });
          return;
        }
        if (Hotkeys.isMoveWordForward(nativeEvent)) {
          event.preventDefault();
          if (selection && Range.isExpanded(selection)) {
            Transforms.collapse(editor, {
              edge: "focus"
            });
          }
          Transforms.move(editor, {
            unit: "word",
            reverse: isRTL
          });
          return;
        }
        if (!HAS_BEFORE_INPUT_SUPPORT) {
          if (Hotkeys.isBold(nativeEvent) || Hotkeys.isItalic(nativeEvent) || Hotkeys.isTransposeCharacter(nativeEvent)) {
            event.preventDefault();
            return;
          }
          if (Hotkeys.isSoftBreak(nativeEvent)) {
            event.preventDefault();
            Editor.insertSoftBreak(editor);
            return;
          }
          if (Hotkeys.isSplitBlock(nativeEvent)) {
            event.preventDefault();
            Editor.insertBreak(editor);
            return;
          }
          if (Hotkeys.isDeleteBackward(nativeEvent)) {
            event.preventDefault();
            if (selection && Range.isExpanded(selection)) {
              Editor.deleteFragment(editor, {
                direction: "backward"
              });
            } else {
              Editor.deleteBackward(editor);
            }
            return;
          }
          if (Hotkeys.isDeleteForward(nativeEvent)) {
            event.preventDefault();
            if (selection && Range.isExpanded(selection)) {
              Editor.deleteFragment(editor, {
                direction: "forward"
              });
            } else {
              Editor.deleteForward(editor);
            }
            return;
          }
          if (Hotkeys.isDeleteLineBackward(nativeEvent)) {
            event.preventDefault();
            if (selection && Range.isExpanded(selection)) {
              Editor.deleteFragment(editor, {
                direction: "backward"
              });
            } else {
              Editor.deleteBackward(editor, {
                unit: "line"
              });
            }
            return;
          }
          if (Hotkeys.isDeleteLineForward(nativeEvent)) {
            event.preventDefault();
            if (selection && Range.isExpanded(selection)) {
              Editor.deleteFragment(editor, {
                direction: "forward"
              });
            } else {
              Editor.deleteForward(editor, {
                unit: "line"
              });
            }
            return;
          }
          if (Hotkeys.isDeleteWordBackward(nativeEvent)) {
            event.preventDefault();
            if (selection && Range.isExpanded(selection)) {
              Editor.deleteFragment(editor, {
                direction: "backward"
              });
            } else {
              Editor.deleteBackward(editor, {
                unit: "word"
              });
            }
            return;
          }
          if (Hotkeys.isDeleteWordForward(nativeEvent)) {
            event.preventDefault();
            if (selection && Range.isExpanded(selection)) {
              Editor.deleteFragment(editor, {
                direction: "forward"
              });
            } else {
              Editor.deleteForward(editor, {
                unit: "word"
              });
            }
            return;
          }
        } else {
          if (IS_CHROME || IS_WEBKIT) {
            if (selection && (Hotkeys.isDeleteBackward(nativeEvent) || Hotkeys.isDeleteForward(nativeEvent)) && Range.isCollapsed(selection)) {
              var currentNode = Node$1.parent(editor, selection.anchor.path);
              if (Element$3.isElement(currentNode) && Editor.isVoid(editor, currentNode) && (Editor.isInline(editor, currentNode) || Editor.isBlock(editor, currentNode))) {
                event.preventDefault();
                Editor.deleteBackward(editor, {
                  unit: "block"
                });
                return;
              }
            }
          }
        }
      }
    }, [readOnly, editor, attributes.onKeyDown]),
    onPaste: useCallback((event) => {
      if (!readOnly && ReactEditor.hasEditableTarget(editor, event.target) && !isEventHandled(event, attributes.onPaste)) {
        if (!HAS_BEFORE_INPUT_SUPPORT || isPlainTextOnlyPaste(event.nativeEvent) || IS_WEBKIT) {
          event.preventDefault();
          ReactEditor.insertData(editor, event.clipboardData);
        }
      }
    }, [readOnly, editor, attributes.onPaste])
  }), /* @__PURE__ */ React__default.createElement(Children, {
    decorations,
    node: editor,
    renderElement,
    renderPlaceholder,
    renderLeaf,
    selection: editor.selection
  })))));
};
var DefaultPlaceholder = (_ref) => {
  var {
    attributes,
    children
  } = _ref;
  return (
    // COMPAT: Artificially add a line-break to the end on the placeholder element
    // to prevent Android IMEs to pick up its content in autocorrect and to auto-capitalize the first letter
    /* @__PURE__ */ React__default.createElement("span", _objectSpread$1$1({}, attributes), children, IS_ANDROID && /* @__PURE__ */ React__default.createElement("br", null))
  );
};
var defaultDecorate = () => [];
var defaultScrollSelectionIntoView = (editor, domRange) => {
  if (domRange.getBoundingClientRect && (!editor.selection || editor.selection && Range.isCollapsed(editor.selection))) {
    var leafEl = domRange.startContainer.parentElement;
    leafEl.getBoundingClientRect = domRange.getBoundingClientRect.bind(domRange);
    e3(leafEl, {
      scrollMode: "if-needed"
    });
    delete leafEl.getBoundingClientRect;
  }
};
var isEventHandled = (event, handler) => {
  if (!handler) {
    return false;
  }
  var shouldTreatEventAsHandled = handler(event);
  if (shouldTreatEventAsHandled != null) {
    return shouldTreatEventAsHandled;
  }
  return event.isDefaultPrevented() || event.isPropagationStopped();
};
var isDOMEventTargetInput = (event) => {
  return isDOMNode(event.target) && (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement);
};
var isDOMEventHandled = (event, handler) => {
  if (!handler) {
    return false;
  }
  var shouldTreatEventAsHandled = handler(event);
  if (shouldTreatEventAsHandled != null) {
    return shouldTreatEventAsHandled;
  }
  return event.defaultPrevented;
};
var FocusedContext = /* @__PURE__ */ createContext$1(false);
var useFocused = () => {
  return useContext(FocusedContext);
};
var SlateSelectorContext = /* @__PURE__ */ createContext$1({});
function useSelectorContext(editor) {
  var eventListeners = useRef([]).current;
  var slateRef = useRef({
    editor
  }).current;
  var onChange = useCallback((editor2) => {
    slateRef.editor = editor2;
    eventListeners.forEach((listener) => listener(editor2));
  }, [eventListeners, slateRef]);
  var selectorContext = useMemo(() => {
    return {
      getSlate: () => slateRef.editor,
      addEventListener: (callback) => {
        eventListeners.push(callback);
        return () => {
          eventListeners.splice(eventListeners.indexOf(callback), 1);
        };
      }
    };
  }, [eventListeners, slateRef]);
  return {
    selectorContext,
    onChange
  };
}
var _excluded = ["editor", "children", "onChange", "onSelectionChange", "onValueChange", "initialValue"];
var Slate = (props2) => {
  var {
    editor,
    children,
    onChange,
    onSelectionChange,
    onValueChange,
    initialValue
  } = props2, rest = _objectWithoutProperties$1(props2, _excluded);
  var [context, setContext] = React__default.useState(() => {
    if (!Node$1.isNodeList(initialValue)) {
      throw new Error("[Slate] initialValue is invalid! Expected a list of elements but got: ".concat(Scrubber.stringify(initialValue)));
    }
    if (!Editor.isEditor(editor)) {
      throw new Error("[Slate] editor is invalid! You passed: ".concat(Scrubber.stringify(editor)));
    }
    editor.children = initialValue;
    Object.assign(editor, rest);
    return {
      v: 0,
      editor
    };
  });
  var {
    selectorContext,
    onChange: handleSelectorChange
  } = useSelectorContext(editor);
  var onContextChange = useCallback((options) => {
    var _options$operation;
    if (onChange) {
      onChange(editor.children);
    }
    switch (options === null || options === void 0 || (_options$operation = options.operation) === null || _options$operation === void 0 ? void 0 : _options$operation.type) {
      case "set_selection":
        onSelectionChange === null || onSelectionChange === void 0 || onSelectionChange(editor.selection);
        break;
      default:
        onValueChange === null || onValueChange === void 0 || onValueChange(editor.children);
    }
    setContext((prevContext) => ({
      v: prevContext.v + 1,
      editor
    }));
    handleSelectorChange(editor);
  }, [editor, handleSelectorChange, onChange, onSelectionChange, onValueChange]);
  useEffect(() => {
    EDITOR_TO_ON_CHANGE.set(editor, onContextChange);
    return () => {
      EDITOR_TO_ON_CHANGE.set(editor, () => {
      });
    };
  }, [editor, onContextChange]);
  var [isFocused, setIsFocused] = useState(ReactEditor.isFocused(editor));
  useEffect(() => {
    setIsFocused(ReactEditor.isFocused(editor));
  }, [editor]);
  useIsomorphicLayoutEffect(() => {
    var fn2 = () => setIsFocused(ReactEditor.isFocused(editor));
    if (REACT_MAJOR_VERSION >= 17) {
      document.addEventListener("focusin", fn2);
      document.addEventListener("focusout", fn2);
      return () => {
        document.removeEventListener("focusin", fn2);
        document.removeEventListener("focusout", fn2);
      };
    } else {
      document.addEventListener("focus", fn2, true);
      document.addEventListener("blur", fn2, true);
      return () => {
        document.removeEventListener("focus", fn2, true);
        document.removeEventListener("blur", fn2, true);
      };
    }
  }, []);
  return /* @__PURE__ */ React__default.createElement(SlateSelectorContext.Provider, {
    value: selectorContext
  }, /* @__PURE__ */ React__default.createElement(SlateContext.Provider, {
    value: context
  }, /* @__PURE__ */ React__default.createElement(EditorContext.Provider, {
    value: context.editor
  }, /* @__PURE__ */ React__default.createElement(FocusedContext.Provider, {
    value: isFocused
  }, children))));
};
var doRectsIntersect = (rect, compareRect) => {
  var middle = (compareRect.top + compareRect.bottom) / 2;
  return rect.top <= middle && rect.bottom >= middle;
};
var areRangesSameLine = (editor, range1, range2) => {
  var rect1 = ReactEditor.toDOMRange(editor, range1).getBoundingClientRect();
  var rect2 = ReactEditor.toDOMRange(editor, range2).getBoundingClientRect();
  return doRectsIntersect(rect1, rect2) && doRectsIntersect(rect2, rect1);
};
var findCurrentLineRange = (editor, parentRange) => {
  var parentRangeBoundary = Editor.range(editor, Range.end(parentRange));
  var positions2 = Array.from(Editor.positions(editor, {
    at: parentRange
  }));
  var left = 0;
  var right = positions2.length;
  var middle = Math.floor(right / 2);
  if (areRangesSameLine(editor, Editor.range(editor, positions2[left]), parentRangeBoundary)) {
    return Editor.range(editor, positions2[left], parentRangeBoundary);
  }
  if (positions2.length < 2) {
    return Editor.range(editor, positions2[positions2.length - 1], parentRangeBoundary);
  }
  while (middle !== positions2.length && middle !== left) {
    if (areRangesSameLine(editor, Editor.range(editor, positions2[middle]), parentRangeBoundary)) {
      right = middle;
    } else {
      left = middle;
    }
    middle = Math.floor((left + right) / 2);
  }
  return Editor.range(editor, positions2[right], parentRangeBoundary);
};
function ownKeys$7(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$7(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$7(Object(t3), true).forEach(function(r3) {
      _defineProperty$3(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$7(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var withReact = function withReact2(editor) {
  var clipboardFormatKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x-slate-fragment";
  var e5 = editor;
  var {
    apply: apply2,
    onChange,
    deleteBackward: deleteBackward2,
    addMark: addMark2,
    removeMark: removeMark2
  } = e5;
  EDITOR_TO_KEY_TO_ELEMENT.set(e5, /* @__PURE__ */ new WeakMap());
  e5.addMark = (key2, value) => {
    var _EDITOR_TO_SCHEDULE_F, _EDITOR_TO_PENDING_DI;
    (_EDITOR_TO_SCHEDULE_F = EDITOR_TO_SCHEDULE_FLUSH.get(e5)) === null || _EDITOR_TO_SCHEDULE_F === void 0 || _EDITOR_TO_SCHEDULE_F();
    if (!EDITOR_TO_PENDING_INSERTION_MARKS.get(e5) && (_EDITOR_TO_PENDING_DI = EDITOR_TO_PENDING_DIFFS.get(e5)) !== null && _EDITOR_TO_PENDING_DI !== void 0 && _EDITOR_TO_PENDING_DI.length) {
      EDITOR_TO_PENDING_INSERTION_MARKS.set(e5, null);
    }
    EDITOR_TO_USER_MARKS.delete(e5);
    addMark2(key2, value);
  };
  e5.removeMark = (key2) => {
    var _EDITOR_TO_PENDING_DI2;
    if (!EDITOR_TO_PENDING_INSERTION_MARKS.get(e5) && (_EDITOR_TO_PENDING_DI2 = EDITOR_TO_PENDING_DIFFS.get(e5)) !== null && _EDITOR_TO_PENDING_DI2 !== void 0 && _EDITOR_TO_PENDING_DI2.length) {
      EDITOR_TO_PENDING_INSERTION_MARKS.set(e5, null);
    }
    EDITOR_TO_USER_MARKS.delete(e5);
    removeMark2(key2);
  };
  e5.deleteBackward = (unit) => {
    if (unit !== "line") {
      return deleteBackward2(unit);
    }
    if (e5.selection && Range.isCollapsed(e5.selection)) {
      var parentBlockEntry = Editor.above(e5, {
        match: (n2) => Element$3.isElement(n2) && Editor.isBlock(e5, n2),
        at: e5.selection
      });
      if (parentBlockEntry) {
        var [, parentBlockPath] = parentBlockEntry;
        var parentElementRange = Editor.range(e5, parentBlockPath, e5.selection.anchor);
        var currentLineRange = findCurrentLineRange(e5, parentElementRange);
        if (!Range.isCollapsed(currentLineRange)) {
          Transforms.delete(e5, {
            at: currentLineRange
          });
        }
      }
    }
  };
  e5.apply = (op) => {
    var matches2 = [];
    var pathRefMatches = [];
    var pendingDiffs = EDITOR_TO_PENDING_DIFFS.get(e5);
    if (pendingDiffs !== null && pendingDiffs !== void 0 && pendingDiffs.length) {
      var transformed = pendingDiffs.map((textDiff) => transformTextDiff(textDiff, op)).filter(Boolean);
      EDITOR_TO_PENDING_DIFFS.set(e5, transformed);
    }
    var pendingSelection = EDITOR_TO_PENDING_SELECTION.get(e5);
    if (pendingSelection) {
      EDITOR_TO_PENDING_SELECTION.set(e5, transformPendingRange(e5, pendingSelection, op));
    }
    var pendingAction = EDITOR_TO_PENDING_ACTION.get(e5);
    if (pendingAction !== null && pendingAction !== void 0 && pendingAction.at) {
      var at2 = Point.isPoint(pendingAction === null || pendingAction === void 0 ? void 0 : pendingAction.at) ? transformPendingPoint(e5, pendingAction.at, op) : transformPendingRange(e5, pendingAction.at, op);
      EDITOR_TO_PENDING_ACTION.set(e5, at2 ? _objectSpread$7(_objectSpread$7({}, pendingAction), {}, {
        at: at2
      }) : null);
    }
    switch (op.type) {
      case "insert_text":
      case "remove_text":
      case "set_node":
      case "split_node": {
        matches2.push(...getMatches(e5, op.path));
        break;
      }
      case "set_selection": {
        var _EDITOR_TO_USER_SELEC;
        (_EDITOR_TO_USER_SELEC = EDITOR_TO_USER_SELECTION.get(e5)) === null || _EDITOR_TO_USER_SELEC === void 0 || _EDITOR_TO_USER_SELEC.unref();
        EDITOR_TO_USER_SELECTION.delete(e5);
        break;
      }
      case "insert_node":
      case "remove_node": {
        matches2.push(...getMatches(e5, Path.parent(op.path)));
        break;
      }
      case "merge_node": {
        var prevPath = Path.previous(op.path);
        matches2.push(...getMatches(e5, prevPath));
        break;
      }
      case "move_node": {
        var commonPath = Path.common(Path.parent(op.path), Path.parent(op.newPath));
        matches2.push(...getMatches(e5, commonPath));
        var changedPath;
        if (Path.isBefore(op.path, op.newPath)) {
          matches2.push(...getMatches(e5, Path.parent(op.path)));
          changedPath = op.newPath;
        } else {
          matches2.push(...getMatches(e5, Path.parent(op.newPath)));
          changedPath = op.path;
        }
        var changedNode = Node$1.get(editor, Path.parent(changedPath));
        var changedNodeKey = ReactEditor.findKey(e5, changedNode);
        var changedPathRef = Editor.pathRef(e5, Path.parent(changedPath));
        pathRefMatches.push([changedPathRef, changedNodeKey]);
        break;
      }
    }
    apply2(op);
    for (var [path3, key2] of matches2) {
      var [node3] = Editor.node(e5, path3);
      NODE_TO_KEY.set(node3, key2);
    }
    for (var [pathRef3, _key] of pathRefMatches) {
      if (pathRef3.current) {
        var [_node] = Editor.node(e5, pathRef3.current);
        NODE_TO_KEY.set(_node, _key);
      }
    }
  };
  e5.setFragmentData = (data) => {
    var {
      selection
    } = e5;
    if (!selection) {
      return;
    }
    var [start2, end2] = Range.edges(selection);
    var startVoid = Editor.void(e5, {
      at: start2.path
    });
    var endVoid = Editor.void(e5, {
      at: end2.path
    });
    if (Range.isCollapsed(selection) && !startVoid) {
      return;
    }
    var domRange = ReactEditor.toDOMRange(e5, selection);
    var contents = domRange.cloneContents();
    var attach = contents.childNodes[0];
    contents.childNodes.forEach((node3) => {
      if (node3.textContent && node3.textContent.trim() !== "") {
        attach = node3;
      }
    });
    if (endVoid) {
      var [voidNode] = endVoid;
      var r2 = domRange.cloneRange();
      var domNode = ReactEditor.toDOMNode(e5, voidNode);
      r2.setEndAfter(domNode);
      contents = r2.cloneContents();
    }
    if (startVoid) {
      attach = contents.querySelector("[data-slate-spacer]");
    }
    Array.from(contents.querySelectorAll("[data-slate-zero-width]")).forEach((zw) => {
      var isNewline = zw.getAttribute("data-slate-zero-width") === "n";
      zw.textContent = isNewline ? "\n" : "";
    });
    if (isDOMText(attach)) {
      var span = attach.ownerDocument.createElement("span");
      span.style.whiteSpace = "pre";
      span.appendChild(attach);
      contents.appendChild(span);
      attach = span;
    }
    var fragment2 = e5.getFragment();
    var string3 = JSON.stringify(fragment2);
    var encoded = window.btoa(encodeURIComponent(string3));
    attach.setAttribute("data-slate-fragment", encoded);
    data.setData("application/".concat(clipboardFormatKey), encoded);
    var div = contents.ownerDocument.createElement("div");
    div.appendChild(contents);
    div.setAttribute("hidden", "true");
    contents.ownerDocument.body.appendChild(div);
    data.setData("text/html", div.innerHTML);
    data.setData("text/plain", getPlainText(div));
    contents.ownerDocument.body.removeChild(div);
    return data;
  };
  e5.insertData = (data) => {
    if (!e5.insertFragmentData(data)) {
      e5.insertTextData(data);
    }
  };
  e5.insertFragmentData = (data) => {
    var fragment2 = data.getData("application/".concat(clipboardFormatKey)) || getSlateFragmentAttribute(data);
    if (fragment2) {
      var decoded = decodeURIComponent(window.atob(fragment2));
      var parsed = JSON.parse(decoded);
      e5.insertFragment(parsed);
      return true;
    }
    return false;
  };
  e5.insertTextData = (data) => {
    var text = data.getData("text/plain");
    if (text) {
      var lines = text.split(/\r\n|\r|\n/);
      var split = false;
      for (var line of lines) {
        if (split) {
          Transforms.splitNodes(e5, {
            always: true
          });
        }
        e5.insertText(line);
        split = true;
      }
      return true;
    }
    return false;
  };
  e5.onChange = (options) => {
    var maybeBatchUpdates = REACT_MAJOR_VERSION < 18 ? ReactDOM.unstable_batchedUpdates : (callback) => callback();
    maybeBatchUpdates(() => {
      var onContextChange = EDITOR_TO_ON_CHANGE.get(e5);
      if (onContextChange) {
        onContextChange(options);
      }
      onChange(options);
    });
  };
  return e5;
};
var getMatches = (e5, path3) => {
  var matches2 = [];
  for (var [n2, p2] of Editor.levels(e5, {
    at: path3
  })) {
    var key2 = ReactEditor.findKey(e5, n2);
    matches2.push([p2, key2]);
  }
  return matches2;
};
var History = {
  /**
   * Check if a value is a `History` object.
   */
  isHistory(value) {
    return isPlainObject$9(value) && Array.isArray(value.redos) && Array.isArray(value.undos) && (value.redos.length === 0 || Operation.isOperationList(value.redos[0].operations)) && (value.undos.length === 0 || Operation.isOperationList(value.undos[0].operations));
  }
};
var SAVING = /* @__PURE__ */ new WeakMap();
var MERGING = /* @__PURE__ */ new WeakMap();
var HistoryEditor = {
  /**
   * Check if a value is a `HistoryEditor` object.
   */
  isHistoryEditor(value) {
    return History.isHistory(value.history) && Editor.isEditor(value);
  },
  /**
   * Get the merge flag's current value.
   */
  isMerging(editor) {
    return MERGING.get(editor);
  },
  /**
   * Get the saving flag's current value.
   */
  isSaving(editor) {
    return SAVING.get(editor);
  },
  /**
   * Redo to the previous saved state.
   */
  redo(editor) {
    editor.redo();
  },
  /**
   * Undo to the previous saved state.
   */
  undo(editor) {
    editor.undo();
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without merging any of
   * the new operations into previous save point in the history.
   */
  withoutMerging(editor, fn2) {
    var prev = HistoryEditor.isMerging(editor);
    MERGING.set(editor, false);
    fn2();
    MERGING.set(editor, prev);
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without saving any of
   * their operations into the history.
   */
  withoutSaving(editor, fn2) {
    var prev = HistoryEditor.isSaving(editor);
    SAVING.set(editor, false);
    fn2();
    SAVING.set(editor, prev);
  }
};
var withHistory = (editor) => {
  var e5 = editor;
  var {
    apply: apply2
  } = e5;
  e5.history = {
    undos: [],
    redos: []
  };
  e5.redo = () => {
    var {
      history
    } = e5;
    var {
      redos
    } = history;
    if (redos.length > 0) {
      var batch = redos[redos.length - 1];
      if (batch.selectionBefore) {
        Transforms.setSelection(e5, batch.selectionBefore);
      }
      HistoryEditor.withoutSaving(e5, () => {
        Editor.withoutNormalizing(e5, () => {
          for (var op of batch.operations) {
            e5.apply(op);
          }
        });
      });
      history.redos.pop();
      e5.writeHistory("undos", batch);
    }
  };
  e5.undo = () => {
    var {
      history
    } = e5;
    var {
      undos
    } = history;
    if (undos.length > 0) {
      var batch = undos[undos.length - 1];
      HistoryEditor.withoutSaving(e5, () => {
        Editor.withoutNormalizing(e5, () => {
          var inverseOps = batch.operations.map(Operation.inverse).reverse();
          for (var op of inverseOps) {
            e5.apply(op);
          }
          if (batch.selectionBefore) {
            Transforms.setSelection(e5, batch.selectionBefore);
          }
        });
      });
      e5.writeHistory("redos", batch);
      history.undos.pop();
    }
  };
  e5.apply = (op) => {
    var {
      operations,
      history
    } = e5;
    var {
      undos
    } = history;
    var lastBatch = undos[undos.length - 1];
    var lastOp = lastBatch && lastBatch.operations[lastBatch.operations.length - 1];
    var save = HistoryEditor.isSaving(e5);
    var merge2 = HistoryEditor.isMerging(e5);
    if (save == null) {
      save = shouldSave(op);
    }
    if (save) {
      if (merge2 == null) {
        if (lastBatch == null) {
          merge2 = false;
        } else if (operations.length !== 0) {
          merge2 = true;
        } else {
          merge2 = shouldMerge(op, lastOp);
        }
      }
      if (lastBatch && merge2) {
        lastBatch.operations.push(op);
      } else {
        var batch = {
          operations: [op],
          selectionBefore: e5.selection
        };
        e5.writeHistory("undos", batch);
      }
      while (undos.length > 100) {
        undos.shift();
      }
      history.redos = [];
    }
    apply2(op);
  };
  e5.writeHistory = (stack, batch) => {
    e5.history[stack].push(batch);
  };
  return e5;
};
var shouldMerge = (op, prev) => {
  if (prev && op.type === "insert_text" && prev.type === "insert_text" && op.offset === prev.offset + prev.text.length && Path.equals(op.path, prev.path)) {
    return true;
  }
  if (prev && op.type === "remove_text" && prev.type === "remove_text" && op.offset + op.text.length === prev.offset && Path.equals(op.path, prev.path)) {
    return true;
  }
  return false;
};
var shouldSave = (op, prev) => {
  if (op.type === "set_selection") {
    return false;
  }
  return true;
};
const ErrorBoundaryContext = createContext$1(null);
const initialState = {
  didCatch: false,
  error: null
};
class ErrorBoundary extends Component {
  constructor(props2) {
    super(props2);
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    this.state = initialState;
  }
  static getDerivedStateFromError(error2) {
    return {
      didCatch: true,
      error: error2
    };
  }
  resetErrorBoundary() {
    const {
      error: error2
    } = this.state;
    if (error2 !== null) {
      var _this$props$onReset, _this$props;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call(_this$props, {
        args,
        reason: "imperative-api"
      });
      this.setState(initialState);
    }
  }
  componentDidCatch(error2, info2) {
    var _this$props$onError, _this$props2;
    (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props2, error2, info2);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      didCatch
    } = this.state;
    const {
      resetKeys
    } = this.props;
    if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
      var _this$props$onReset2, _this$props3;
      (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 ? void 0 : _this$props$onReset2.call(_this$props3, {
        next: resetKeys,
        prev: prevProps.resetKeys,
        reason: "keys"
      });
      this.setState(initialState);
    }
  }
  render() {
    const {
      children,
      fallbackRender,
      FallbackComponent,
      fallback
    } = this.props;
    const {
      didCatch,
      error: error2
    } = this.state;
    let childToRender = children;
    if (didCatch) {
      const props2 = {
        error: error2,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof fallbackRender === "function") {
        childToRender = fallbackRender(props2);
      } else if (FallbackComponent) {
        childToRender = createElement$2(FallbackComponent, props2);
      } else if (fallback !== void 0) {
        childToRender = fallback;
      } else {
        throw error2;
      }
    }
    return createElement$2(ErrorBoundaryContext.Provider, {
      value: {
        didCatch,
        error: error2,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, childToRender);
  }
}
function hasArrayChanged() {
  let a4 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  let b3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return a4.length !== b3.length || a4.some((item, index2) => !Object.is(item, b3[index2]));
}
var isUrl_1 = isUrl;
var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;
function isUrl(string3) {
  if (typeof string3 !== "string") {
    return false;
  }
  var match5 = string3.match(protocolAndDomainRE);
  if (!match5) {
    return false;
  }
  var everythingAfterProtocol = match5[1];
  if (!everythingAfterProtocol) {
    return false;
  }
  if (localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol)) {
    return true;
  }
  return false;
}
const isUrl$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(isUrl_1);
function _typeof$1(o2) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$1(o2);
}
function _toPrimitive(input, hint) {
  if (_typeof$1(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$1(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key2 = _toPrimitive(arg, "string");
  return _typeof$1(key2) === "symbol" ? key2 : String(key2);
}
function _defineProperty$2(obj, key2, value) {
  key2 = _toPropertyKey(key2);
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var ANCHOR$1 = /* @__PURE__ */ new WeakMap();
var FOCUS = /* @__PURE__ */ new WeakMap();
let Token$1 = class Token {
};
class AnchorToken extends Token$1 {
  constructor() {
    var props2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    super();
    _defineProperty$2(this, "offset", void 0);
    _defineProperty$2(this, "path", void 0);
    var {
      offset: offset2,
      path: path3
    } = props2;
    this.offset = offset2;
    this.path = path3;
  }
}
class FocusToken extends Token$1 {
  constructor() {
    var props2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    super();
    _defineProperty$2(this, "offset", void 0);
    _defineProperty$2(this, "path", void 0);
    var {
      offset: offset2,
      path: path3
    } = props2;
    this.offset = offset2;
    this.path = path3;
  }
}
var addAnchorToken = (text, token2) => {
  var offset2 = text.text.length;
  ANCHOR$1.set(text, [offset2, token2]);
};
var getAnchorOffset = (text) => {
  return ANCHOR$1.get(text);
};
var addFocusToken = (text, token2) => {
  var offset2 = text.text.length;
  FOCUS.set(text, [offset2, token2]);
};
var getFocusOffset = (text) => {
  return FOCUS.get(text);
};
function ownKeys$1(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread$1(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$1(Object(t3), true).forEach(function(r3) {
      _defineProperty$2(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys$1(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var STRINGS = /* @__PURE__ */ new WeakSet();
var resolveDescendants = (children) => {
  var nodes2 = [];
  var addChild = (child2) => {
    if (child2 == null) {
      return;
    }
    var prev = nodes2[nodes2.length - 1];
    if (typeof child2 === "string") {
      var text = {
        text: child2
      };
      STRINGS.add(text);
      child2 = text;
    }
    if (Text$1.isText(child2)) {
      var c3 = child2;
      if (Text$1.isText(prev) && STRINGS.has(prev) && STRINGS.has(c3) && Text$1.equals(prev, c3, {
        loose: true
      })) {
        prev.text += c3.text;
      } else {
        nodes2.push(c3);
      }
    } else if (Element$3.isElement(child2)) {
      nodes2.push(child2);
    } else if (child2 instanceof Token$1) {
      var n2 = nodes2[nodes2.length - 1];
      if (!Text$1.isText(n2)) {
        addChild("");
        n2 = nodes2[nodes2.length - 1];
      }
      if (child2 instanceof AnchorToken) {
        addAnchorToken(n2, child2);
      } else if (child2 instanceof FocusToken) {
        addFocusToken(n2, child2);
      }
    } else {
      throw new Error("Unexpected hyperscript child object: ".concat(child2));
    }
  };
  for (var child of children.flat(Infinity)) {
    addChild(child);
  }
  return nodes2;
};
function createAnchor(tagName, attributes, children) {
  return new AnchorToken(attributes);
}
function createCursor(tagName, attributes, children) {
  return [new AnchorToken(attributes), new FocusToken(attributes)];
}
function createElement$1(tagName, attributes, children) {
  return _objectSpread$1(_objectSpread$1({}, attributes), {}, {
    children: resolveDescendants(children)
  });
}
function createFocus(tagName, attributes, children) {
  return new FocusToken(attributes);
}
function createFragment(tagName, attributes, children) {
  return resolveDescendants(children);
}
function createSelection(tagName, attributes, children) {
  var anchor = children.find((c3) => c3 instanceof AnchorToken);
  var focus2 = children.find((c3) => c3 instanceof FocusToken);
  if (!anchor || anchor.offset == null || anchor.path == null) {
    throw new Error("The <selection> hyperscript tag must have an <anchor> tag as a child with `path` and `offset` attributes defined.");
  }
  if (!focus2 || focus2.offset == null || focus2.path == null) {
    throw new Error("The <selection> hyperscript tag must have a <focus> tag as a child with `path` and `offset` attributes defined.");
  }
  return _objectSpread$1({
    anchor: {
      offset: anchor.offset,
      path: anchor.path
    },
    focus: {
      offset: focus2.offset,
      path: focus2.path
    }
  }, attributes);
}
function createText(tagName, attributes, children) {
  var nodes2 = resolveDescendants(children);
  if (nodes2.length > 1) {
    throw new Error("The <text> hyperscript tag must only contain a single node's worth of children.");
  }
  var [node3] = nodes2;
  if (node3 == null) {
    node3 = {
      text: ""
    };
  }
  if (!Text$1.isText(node3)) {
    throw new Error("\n    The <text> hyperscript tag can only contain text content as children.");
  }
  STRINGS.delete(node3);
  Object.assign(node3, attributes);
  return node3;
}
var createEditor = (makeEditor) => (tagName, attributes, children) => {
  var otherChildren = [];
  var selectionChild;
  for (var child of children) {
    if (Range.isRange(child)) {
      selectionChild = child;
    } else {
      otherChildren.push(child);
    }
  }
  var descendants = resolveDescendants(otherChildren);
  var selection = {};
  var editor = makeEditor();
  Object.assign(editor, attributes);
  editor.children = descendants;
  for (var [node3, path3] of Node$1.texts(editor)) {
    var anchor = getAnchorOffset(node3);
    var focus2 = getFocusOffset(node3);
    if (anchor != null) {
      var [offset2] = anchor;
      selection.anchor = {
        path: path3,
        offset: offset2
      };
    }
    if (focus2 != null) {
      var [_offset] = focus2;
      selection.focus = {
        path: path3,
        offset: _offset
      };
    }
  }
  if (selection.anchor && !selection.focus) {
    throw new Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<anchor />`. For collapsed selections, use `<cursor />` instead.");
  }
  if (!selection.anchor && selection.focus) {
    throw new Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<focus />`. For collapsed selections, use `<cursor />` instead.");
  }
  if (selectionChild != null) {
    editor.selection = selectionChild;
  } else if (Range.isRange(selection)) {
    editor.selection = selection;
  }
  return editor;
};
function ownKeys(e5, r2) {
  var t3 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e5);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e5, r3).enumerable;
    })), t3.push.apply(t3, o2);
  }
  return t3;
}
function _objectSpread(e5) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t3 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys(Object(t3), true).forEach(function(r3) {
      _defineProperty$2(e5, r3, t3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(t3)) : ownKeys(Object(t3)).forEach(function(r3) {
      Object.defineProperty(e5, r3, Object.getOwnPropertyDescriptor(t3, r3));
    });
  }
  return e5;
}
var DEFAULT_CREATORS = {
  anchor: createAnchor,
  cursor: createCursor,
  editor: createEditor(createEditor$1),
  element: createElement$1,
  focus: createFocus,
  fragment: createFragment,
  selection: createSelection,
  text: createText
};
var createHyperscript = function createHyperscript2() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var {
    elements = {}
  } = options;
  var elementCreators = normalizeElements(elements);
  var creators = _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_CREATORS), elementCreators), options.creators);
  var jsx2 = createFactory(creators);
  return jsx2;
};
var createFactory = (creators) => {
  var jsx2 = function jsx3(tagName, attributes) {
    for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      children[_key - 2] = arguments[_key];
    }
    var creator = creators[tagName];
    if (!creator) {
      throw new Error("No hyperscript creator found for tag: <".concat(tagName, ">"));
    }
    if (attributes == null) {
      attributes = {};
    }
    if (!isPlainObject$9(attributes)) {
      children = [attributes].concat(children);
      attributes = {};
    }
    children = children.filter((child) => Boolean(child)).flat();
    var ret = creator(tagName, attributes, children);
    return ret;
  };
  return jsx2;
};
var normalizeElements = (elements) => {
  var creators = {};
  var _loop = function _loop2() {
    var props2 = elements[tagName];
    if (typeof props2 !== "object") {
      throw new Error("Properties specified for a hyperscript shorthand should be an object, but for the custom element <".concat(tagName, ">  tag you passed: ").concat(props2));
    }
    creators[tagName] = (tagName2, attributes, children) => {
      return createElement$1("element", _objectSpread(_objectSpread({}, props2), attributes), children);
    };
  };
  for (var tagName in elements) {
    _loop();
  }
  return creators;
};
var jsx = createHyperscript();
const BLOCK_TYPES = {
  SUBJECT: "subject",
  PARAGRAPH: "paragraph",
  HEADING1: "heading-one",
  HEADING2: "heading-two",
  BLOCKQUOTE: "block-quote",
  UNORDERED_LIST: "unordered-list",
  ORDERED_LIST: "ordered-list",
  LIST_ITEM: "list-item",
  MENTION: "mention",
  LINK: "link",
  TABLE: "table",
  TABLE_ROW: "table-row",
  TABLE_CELL: "table-cell",
  IMAGE: "image"
};
const FORMAT_TYPES = {
  BOLD: "bold",
  ITALIC: "italic",
  UNDERLINE: "underline",
  STRIKETHROUGH: "strikethrough",
  HIGHLIGHT: "highlight"
};
const LIST_TYPES = [
  BLOCK_TYPES.ORDERED_LIST,
  BLOCK_TYPES.UNORDERED_LIST
];
const TEXT_ALIGN_TYPES = ["left", "center", "right"];
const HOTKEYS = {
  "mod+b": "bold",
  "mod+i": "italic",
  "mod+u": "underline"
};
const defaultEmptyValue = JSON.stringify([
  {
    type: BLOCK_TYPES.PARAGRAPH,
    children: [{ text: "" }]
  }
]);
const getStringFromValueFromRichTextEditor = (nodes2) => nodes2.map((n2) => Node$1.string(n2)).join("");
const isJson$1 = (str) => {
  try {
    const result2 = JSON.parse(str);
    return !!str && typeof result2 === "object";
  } catch (e5) {
    return false;
  }
};
const isHtml = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
const parseInitialValue = (string3) => {
  if (typeof string3 === "string") {
    let parsedValue = [];
    if (isJson$1(string3)) {
      parsedValue = JSON.parse(string3);
    } else if (isHtml(string3)) {
      parsedValue = convertHtmlToSlate(string3);
    } else {
      parsedValue = convertHtmlToSlate(`<p>${string3}</p>`);
    }
    const normalizedValue = normalizeSlateValue(parsedValue);
    return normalizedValue;
  }
  return JSON.parse(defaultEmptyValue);
};
const normalizeSlateValue = (value) => {
  if (!Array.isArray(value)) {
    return [{ type: "paragraph", children: [{ text: "" }] }];
  }
  return value.map((node3) => {
    if (!node3.type || !Array.isArray(node3.children)) {
      return { type: "paragraph", children: [{ text: "" }] };
    }
    return {
      ...node3,
      children: node3.children.map(
        (child) => typeof child.text === "string" ? child : { text: "" }
      )
    };
  });
};
const focusEditor = (editor) => {
  const subject = editor.children.find(
    (node3) => Element$3.isElementType(node3, BLOCK_TYPES.SUBJECT)
  );
  const subjectIsEmpty = Element$3.isElement(subject) && Node$1.string(subject) === "";
  Transforms.select(
    editor,
    subjectIsEmpty ? Editor.start(editor, []) : Editor.end(editor, [])
  );
  ReactEditor.focus(editor);
};
const isRichEditorEmpty = (editorValue) => editorValue.every((item) => item.isEmpty === true);
const isMarkActive = (editor, format3) => {
  try {
    const marks3 = Editor.marks(editor);
    return marks3 ? marks3[format3] === true : false;
  } catch (err) {
    return false;
  }
};
const toggleMark = (editor, format3) => {
  const isActive = isMarkActive(editor, format3);
  if (isActive) {
    Editor.removeMark(editor, format3);
  } else {
    Editor.addMark(editor, format3, true);
  }
};
const isBlockActive = (editor, format3, blockType = "type") => {
  const { selection } = editor;
  if (!selection) return false;
  try {
    const [match5] = Array.from(
      Editor.nodes(editor, {
        at: Editor.unhangRange(editor, selection),
        match: (n2) => !Editor.isEditor(n2) && Element$3.isElement(n2) && n2[blockType] === format3
      })
    );
    return !!match5;
  } catch (err) {
    return false;
  }
};
const toggleBlock = (editor, format3) => {
  const isActive = isBlockActive(
    editor,
    format3,
    TEXT_ALIGN_TYPES.includes(format3) ? "align" : "type"
  );
  const isList = LIST_TYPES.includes(format3);
  Transforms.unwrapNodes(editor, {
    match: (n2) => !Editor.isEditor(n2) && Element$3.isElement(n2) && LIST_TYPES.includes(n2.type) && !TEXT_ALIGN_TYPES.includes(format3),
    split: true
  });
  let newProperties;
  if (TEXT_ALIGN_TYPES.includes(format3)) {
    newProperties = {
      align: isActive ? void 0 : format3
    };
  } else if (isActive) {
    newProperties = {
      type: BLOCK_TYPES.PARAGRAPH
    };
  } else if (isList) {
    newProperties = {
      type: "list-item"
    };
  } else {
    newProperties = {
      type: format3
    };
  }
  Transforms.setNodes(editor, newProperties);
  if (!isActive && isList) {
    const block = { type: format3, children: [] };
    Transforms.wrapNodes(editor, block);
  }
};
const withMentionsPlugin = (editor) => {
  const { isInline, isVoid } = editor;
  editor.isInline = (element) => element.type === "mention" ? true : isInline(element);
  editor.isVoid = (element) => element.type === "mention" ? true : isVoid(element);
  return editor;
};
const withIsEmptyAttribute = (editor) => {
  const { normalizeNode: normalizeNode2 } = editor;
  editor.normalizeNode = ([node3, path3]) => {
    if (Element$3.isElement(node3)) {
      Editor.withoutNormalizing(editor, () => {
        Transforms.setNodes(
          editor,
          { isEmpty: Node$1.string(node3).trim() === "" },
          { at: path3 }
        );
      });
    }
    normalizeNode2([node3, path3]);
  };
  return editor;
};
const insertSubject = (editor, selectedSubject) => {
  const subject = `${selectedSubject} `;
  Transforms.insertText(editor, subject, { at: [0, 0] });
};
const insertMention = (editor, user) => {
  const mention = {
    type: "mention",
    user,
    children: [{ text: `@${user.name}` }]
  };
  Transforms.insertNodes(editor, [
    mention,
    {
      text: " "
    }
  ]);
  Transforms.move(editor);
};
const withLinks = (editor) => {
  const { insertData, insertText: insertText3, isInline } = editor;
  editor.isInline = (element) => element.type === "link" || isInline(element);
  editor.insertText = (text) => {
    if (text && isUrl$1(text)) {
      wrapLink(editor, text);
    } else {
      insertText3(text);
    }
  };
  editor.insertData = (data) => {
    const text = data.getData("text/plain");
    if (text && isUrl$1(text)) {
      wrapLink(editor, text);
    } else {
      insertData(data);
    }
  };
  return editor;
};
const wrapLink = (editor, url2) => {
  if (isLinkActive(editor)) {
    unwrapLink(editor);
  }
  const { selection } = editor;
  const isCollapsed = selection && Range.isCollapsed(selection);
  const link2 = {
    type: "link",
    url: url2,
    children: isCollapsed ? [{ text: url2 }] : []
  };
  if (isCollapsed) {
    Transforms.insertNodes(editor, [
      link2,
      {
        text: " "
      }
    ]);
  } else {
    Transforms.wrapNodes(editor, link2, { split: true });
    Transforms.collapse(editor, { edge: "end" });
  }
  Transforms.move(editor, { distance: 1 });
};
const getActiveNodeOfType = (editor, type2) => {
  try {
    const [node3] = Editor.nodes(editor, {
      match: (n2) => !Editor.isEditor(n2) && Element$3.isElement(n2) && Element$3.isElementType(n2, type2)
    });
    return node3;
  } catch (err) {
    return void 0;
  }
};
const isLinkActive = (editor) => !!getActiveNodeOfType(editor, "link");
const isSubjectActive = (editor) => !!getActiveNodeOfType(editor, BLOCK_TYPES.SUBJECT);
const unwrapLink = (editor) => {
  Transforms.unwrapNodes(editor, {
    match: (n2) => !Editor.isEditor(n2) && Element$3.isElement(n2) && n2.type === "link"
  });
};
const insertLink = (editor, url2) => {
  if (editor.selection) {
    wrapLink(editor, url2);
  }
};
const promptUrl = (defaultValue) => {
  const url2 = window.prompt("Enter the URL of the link:", defaultValue);
  if (!!url2 && !isUrl$1(url2)) {
    window.alert("The URL is not valid");
    return promptUrl(url2);
  }
  return url2;
};
const toggleLink = (editor) => {
  const activeLink = getActiveNodeOfType(editor, "link");
  if (activeLink) {
    const [link2, at2] = activeLink;
    const url2 = promptUrl(link2.url);
    if (!url2) {
      unwrapLink(editor);
    } else {
      Transforms.setNodes(editor, { url: url2 }, { at: at2 });
    }
  } else {
    const url2 = promptUrl();
    if (!url2) return;
    insertLink(editor, url2);
  }
};
const removeSubject = (editor, [child, childPath]) => {
  if (Element$3.isElement(child)) {
    Transforms.setNodes(
      editor,
      { type: BLOCK_TYPES.PARAGRAPH },
      {
        at: childPath
      }
    );
  }
};
const getWithSubjectLine = (withSubject, readOnly) => (editor) => {
  const { normalizeNode: normalizeNode2, insertBreak: insertBreak2 } = editor;
  editor.insertBreak = () => {
    if (withSubject && isSubjectActive(editor)) {
      Transforms.select(editor, Editor.end(editor, []));
    } else {
      insertBreak2();
    }
  };
  editor.normalizeNode = ([node3, path3]) => {
    var _a2;
    if (path3.length === 0) {
      if (withSubject && editor.children.length <= 1 && Editor.string(editor, [0, 0]) === "") {
        const title2 = {
          type: BLOCK_TYPES.SUBJECT,
          children: [{ text: "" }]
        };
        Transforms.insertNodes(editor, title2, {
          at: path3.concat(0),
          select: true
        });
      }
      for (const [child, childPath] of Node$1.children(editor, path3)) {
        const isFirstChild = childPath[0] === 0;
        const editorHasSubject = ((_a2 = editor.children) == null ? void 0 : _a2.filter((n2) => n2.type === BLOCK_TYPES.SUBJECT).length) > 1;
        if (withSubject && editorHasSubject && Element$3.isElementType(child, BLOCK_TYPES.SUBJECT)) {
          removeSubject(editor, [child, childPath]);
        }
        if (readOnly) {
          if (withSubject && isFirstChild && Node$1.string(child) !== "") {
            enforceSubject(editor, [child, childPath]);
          } else if (Element$3.isElementType(child, BLOCK_TYPES.SUBJECT)) {
            removeSubject(editor, [child, childPath]);
          }
        } else if (withSubject && isFirstChild) {
          enforceSubject(editor, [child, childPath]);
        }
      }
      const firstParagraphExists = node3.children.find(
        (p2) => p2.type === "paragraph"
      );
      if (!firstParagraphExists) {
        const paragraph = {
          type: "paragraph",
          children: [{ text: "" }]
        };
        Transforms.insertNodes(editor, paragraph, {
          at: path3.concat(1),
          select: true
        });
      }
    }
    normalizeNode2([node3, path3]);
  };
  return editor;
};
const enforceSubject = (editor, [child, childPath]) => {
  if (Element$3.isElement(child)) {
    Editor.withoutNormalizing(editor, () => {
      if (child.type !== BLOCK_TYPES.SUBJECT) {
        Transforms.setNodes(
          editor,
          { type: BLOCK_TYPES.SUBJECT },
          {
            at: childPath
          }
        );
      }
      if (child.children.length > 1) {
        Transforms.insertText(editor, Node$1.string(child), {
          at: childPath
        });
      }
      const firstChildProperties = Object.keys(child.children[0]).filter(
        (prop) => prop !== "text"
      );
      if (firstChildProperties.length) {
        const newProperties = firstChildProperties.reduce(
          (acc, prop) => ({ ...acc, [prop]: void 0 }),
          {}
        );
        Transforms.setNodes(editor, newProperties, {
          at: childPath.concat(0)
        });
      }
    });
  }
};
const withImages = (editor) => {
  const { insertData, isVoid } = editor;
  editor.isVoid = (element) => element.type === "image" ? true : isVoid(element);
  editor.insertData = (data) => {
    const text = data.getData("text/plain");
    const { files } = data;
    if (files && files.length > 0) {
      for (const file of files) {
        const reader = new FileReader();
        const [mime] = file.type.split("/");
        if (mime === "image") {
          reader.addEventListener("load", () => {
            const url2 = reader.result;
            insertImage(editor, url2);
          });
          reader.readAsDataURL(file);
        }
      }
    } else if (isImageUrl(text)) {
      insertImage(editor, text);
    } else {
      insertData(data);
    }
  };
  return editor;
};
const insertImage = (editor, url2) => {
  const text = { text: "" };
  const image = { type: "image", url: url2, children: [text] };
  Transforms.insertNodes(editor, image);
  const [match5] = Editor.nodes(editor, {
    match: (n2) => n2.type === "image"
  });
  const path3 = match5 ? match5[1] : [];
  const nextNode = Editor.next(editor, { at: path3 });
  if (!nextNode || nextNode[0].type === "image") {
    const paragraph = { type: "paragraph", children: [{ text: "" }] };
    Transforms.insertNodes(editor, paragraph, { at: Path.next(path3) });
  }
};
const isImageUrl = (url2) => {
  if (!url2) return false;
  if (!isUrl$1(url2)) return false;
  const ext = new URL(url2).pathname.split(".").pop() || "";
  return ["jpeg", "jpg", "png", "gif"].includes(ext);
};
const deserializeHtml = (el2, markAttributes = {}) => {
  if (["STYLE", "META"].includes(el2.nodeName)) {
    return null;
  }
  if (el2.nodeType === window.Node.TEXT_NODE) {
    return jsx("text", markAttributes, el2.textContent);
  } else if (el2.nodeType !== window.Node.ELEMENT_NODE) {
    return null;
  }
  const nodeAttributes = { ...markAttributes };
  switch (el2.nodeName) {
    case "STRONG":
      nodeAttributes[FORMAT_TYPES.BOLD] = true;
      break;
    case "EM":
      nodeAttributes[FORMAT_TYPES.ITALIC] = true;
      break;
    case "U":
      nodeAttributes[FORMAT_TYPES.UNDERLINE] = true;
      break;
    case "S":
      nodeAttributes[FORMAT_TYPES.STRIKETHROUGH] = true;
      break;
    case "MARK":
      nodeAttributes[FORMAT_TYPES.HIGHLIGHT] = true;
      break;
  }
  let currentElement = el2;
  if (el2.nodeName === "TABLE") {
    const cleanTable = document.createElement("table");
    el2.querySelectorAll("tr").forEach((row) => {
      const cleanRow = document.createElement("tr");
      row.querySelectorAll("td, th").forEach((cell) => {
        const cleanCell = document.createElement("td");
        cleanCell.innerHTML = cell.textContent;
        cleanRow.appendChild(cleanCell);
      });
      cleanTable.appendChild(cleanRow);
    });
    currentElement = cleanTable;
  }
  const children = Array.from(currentElement.childNodes).map((node3) => deserializeHtml(node3, nodeAttributes)).flat();
  if (children.length === 0) {
    children.push({
      type: BLOCK_TYPES.PARAGRAPH,
      children: [
        {
          text: ""
        }
      ]
    });
  }
  switch (currentElement.nodeName) {
    case "BODY":
      return jsx("fragment", {}, children);
    case "BR":
      return "\n";
    case "H1":
      return jsx("element", { type: BLOCK_TYPES.HEADING1 }, children);
    case "H2":
      return jsx("element", { type: BLOCK_TYPES.HEADING2 }, children);
    case "P":
      return jsx("element", { type: BLOCK_TYPES.PARAGRAPH }, children);
    case "A":
      return jsx(
        "element",
        { type: BLOCK_TYPES.LINK, url: currentElement.getAttribute("href") },
        children
      );
    case "BLOCKQUOTE":
      return jsx("element", { type: BLOCK_TYPES.BLOCKQUOTE }, children);
    case "OL":
      return jsx("element", { type: BLOCK_TYPES.ORDERED_LIST }, children);
    case "UL":
      return jsx("element", { type: BLOCK_TYPES.UNORDERED_LIST }, children);
    case "LI":
      return jsx("element", { type: BLOCK_TYPES.LIST_ITEM }, children);
    case "TABLE":
      return jsx("element", { type: BLOCK_TYPES.TABLE }, children);
    case "TR":
      return jsx("element", { type: BLOCK_TYPES.TABLE_ROW }, children);
    case "TD":
      return jsx("element", { type: BLOCK_TYPES.TABLE_CELL }, children);
    default:
      return children;
  }
};
const convertHtmlToSlate = (html2) => {
  const normalizedString = html2.replace(/>(\s+)</gm, "><");
  const document2 = new DOMParser().parseFromString(
    normalizedString,
    "text/html"
  );
  return deserializeHtml(document2.body);
};
function createTable(columns, rows) {
  const rowNodes = [...new Array(rows)].map(() => createRow(columns));
  return {
    type: BLOCK_TYPES.TABLE,
    children: rowNodes
  };
}
function createRow(columns) {
  const cellNodes = [...new Array(columns)].map(
    () => createCell()
  );
  return {
    type: BLOCK_TYPES.TABLE_ROW,
    children: cellNodes
  };
}
function createCell() {
  return {
    type: BLOCK_TYPES.TABLE_CELL,
    children: [{ text: "" }]
  };
}
const insertParagraph = (editor, at2, text = "") => {
  const paragraphNode = {
    type: BLOCK_TYPES.PARAGRAPH,
    children: [{ text }]
  };
  Transforms.insertNodes(editor, paragraphNode, {
    at: at2
  });
};
const isTableActive = (editor) => !!getActiveNodeOfType(editor, BLOCK_TYPES.TABLE);
const handleTableMouseDown = (_event, editor) => {
  editor.isTableKeyboardSelecting = false;
};
const handleTableKeydown = (event, editor) => {
  const tabKeys = ["Tab", "Shift+Tab"];
  if (tabKeys.some((key2) => _default(key2, event))) {
    const moveForward = _default("Tab")(event);
    const { selection } = editor;
    const activeCell = getActiveCell(editor, selection.focus.path);
    const activeRow = getActiveRow(editor, selection.focus.path);
    const activeTable = getActiveTable(editor, selection.focus.path);
    if (activeCell) {
      const nextCell = moveForward ? Editor.next(editor, { at: activeCell[1] }) : Editor.previous(editor, { at: activeCell[1] });
      if (nextCell) {
        Transforms.select(editor, Editor.end(editor, nextCell[1]));
        event.preventDefault();
      } else if (activeRow) {
        const nextRow = moveForward ? Editor.next(editor, { at: activeRow[1] }) : Editor.previous(editor, { at: activeRow[1] });
        if (nextRow) {
          const targetCell = moveForward ? Editor.first(editor, nextRow[1]) : Editor.last(editor, nextRow[1]);
          Transforms.select(editor, Editor.end(editor, targetCell[1]));
          event.preventDefault();
        } else {
          const targetNode = moveForward ? Editor.next(editor, { at: activeTable[1] }) : Editor.previous(editor, { at: activeTable[1] });
          if (targetNode) {
            Transforms.select(
              editor,
              moveForward ? Editor.start(editor, targetNode[1]) : Editor.end(editor, targetNode[1])
            );
            event.preventDefault();
          }
        }
      }
    }
  }
  const movingSelectionKeys = ["Up", "Shift+Up", "Down", "Shift+Down"];
  if (movingSelectionKeys.some((key2) => _default(key2, event))) {
    editor.isTableKeyboardSelecting = true;
  } else {
    editor.isTableKeyboardSelecting = false;
  }
};
const overrideSelectionChange = (editor, currentSelection, nextSelection) => {
  const isCollapsed = Range.isCollapsed(nextSelection);
  const { path: currentPath } = currentSelection.focus;
  const { path: nextPath } = nextSelection.focus;
  const currentCell = getActiveCell(editor, currentPath);
  const nextCell = getActiveCell(editor, nextPath);
  if (currentCell && nextCell && !Path.equals(currentCell[1], nextCell[1])) {
    const currentCellPath = currentCell[1];
    const nextCellPath = nextCell[1];
    const currentCellIndex = currentCellPath.slice(-1)[0];
    const moveForward = Path.compare(nextCellPath, currentCellPath) === 1;
    const [, currentRowPath] = getActiveRow(editor, currentCellPath);
    const nextRow = moveForward ? Editor.next(editor, { at: currentRowPath }) : Editor.previous(editor, { at: currentRowPath });
    if (nextRow) {
      const nextRowPath = nextRow[1];
      const nextRowCells = Array.from(Node$1.children(editor, nextRowPath));
      const targetCellPath = nextRowCells[currentCellIndex][1];
      const nextPoint = Editor.end(editor, targetCellPath);
      Transforms.setSelection(editor, {
        anchor: isCollapsed ? nextPoint : void 0,
        focus: nextPoint
      });
    } else {
      const [, activeTablePath] = getActiveTable(editor, currentPath);
      const nextPoint = moveForward ? Editor.start(editor, Path.next(activeTablePath)) : Editor.end(editor, Path.previous(activeTablePath));
      Transforms.setSelection(editor, {
        anchor: isCollapsed ? nextPoint : void 0,
        focus: nextPoint
      });
    }
  }
};
const PreserveSpaceAfter = /* @__PURE__ */ new Set([BLOCK_TYPES.TABLE]);
const PreserveSpaceBefore = /* @__PURE__ */ new Set([BLOCK_TYPES.TABLE]);
const preserveSpace = (editor, entry) => {
  let preserved = false;
  const [node3, path3] = entry;
  if (Element$3.isElement(node3)) {
    const { type: type2 } = node3;
    if (PreserveSpaceAfter.has(type2)) {
      const next3 = Editor.next(editor, {
        at: path3
      });
      if (!next3 || Element$3.isElement(next3[0]) && PreserveSpaceAfter.has(next3[0].type)) {
        insertParagraph(editor, Path.next(path3));
        preserved = true;
      }
    }
    if (PreserveSpaceBefore.has(type2)) {
      if (path3[path3.length - 1] === 0) {
        insertParagraph(editor, path3);
        preserved = true;
      } else {
        const prev = Editor.previous(editor, {
          at: path3
        });
        if (!prev || Element$3.isElement(prev[0]) && PreserveSpaceAfter.has(prev[0].type)) {
          insertParagraph(editor, path3);
          preserved = true;
        }
      }
    }
  }
  return preserved;
};
const getActiveTable = (editor, at2) => {
  const [table] = Array.from(
    Editor.nodes(editor, {
      match: (n2) => Element$3.isElementType(n2, BLOCK_TYPES.TABLE),
      at: at2
    })
  );
  return table;
};
const getActiveRow = (editor, at2) => {
  const [row] = Array.from(
    Editor.nodes(editor, {
      match: (n2) => Element$3.isElementType(n2, BLOCK_TYPES.TABLE_ROW),
      at: at2
    })
  );
  return row;
};
const getActiveCell = (editor, at2) => {
  const [cell] = Array.from(
    Editor.nodes(editor, {
      match: (n2) => Element$3.isElementType(n2, BLOCK_TYPES.TABLE_CELL),
      at: at2
    })
  );
  return cell;
};
const getSelectionCommonNode = (editor) => {
  if (editor.selection) {
    const range2 = Editor.unhangRange(editor, editor.selection, { voids: true });
    const commonNode = Node$1.common(editor, range2.anchor.path, range2.focus.path);
    if (Editor.isBlock(editor, commonNode[0]) || Editor.isEditor(commonNode[0])) {
      return commonNode;
    }
    return Editor.above(editor, {
      at: commonNode[1],
      match: (n2) => Editor.isBlock(editor, n2) || Editor.isEditor(n2)
    });
  }
  return void 0;
};
const insertRow = (editor, before3 = false) => {
  const [row, path3] = getActiveRow(editor);
  const newRow = createRow(row.children.length);
  const at2 = before3 ? path3 : Path.next(path3);
  Transforms.insertNodes(editor, newRow, { at: at2 });
};
const deleteRow = (editor) => {
  Transforms.removeNodes(editor, {
    match: (n2) => Element$3.isElementType(n2, BLOCK_TYPES.TABLE_ROW)
  });
};
const insertColumn = (editor, before3 = false) => {
  const [, activeCellPath] = getActiveCell(editor);
  const activeCellIndex = activeCellPath.slice(-1)[0];
  const [, activeTablePath] = getActiveTable(editor);
  const activeTableRows = Array.from(Node$1.children(editor, activeTablePath));
  activeTableRows.forEach(([_row, rowPath]) => {
    const rowCells = Array.from(Node$1.children(editor, rowPath));
    const [, targetCellPath] = rowCells[activeCellIndex] || rowCells.slice(-1)[0];
    const newCell = createCell();
    const at2 = before3 ? targetCellPath : Path.next(targetCellPath);
    Transforms.insertNodes(editor, newCell, { at: at2 });
  });
};
const deleteColumn = (editor) => {
  const [, activeCellPath] = getActiveCell(editor);
  const activeCellIndex = activeCellPath.slice(-1)[0];
  const [, activeTablePath] = getActiveTable(editor);
  const activeTableRows = Array.from(Node$1.children(editor, activeTablePath));
  activeTableRows.forEach(([_row, rowPath]) => {
    const rowCells = Array.from(Node$1.children(editor, rowPath));
    const [, targetCellPath] = rowCells[activeCellIndex] || rowCells.slice(-1)[0];
    Transforms.removeNodes(editor, {
      at: targetCellPath
    });
  });
};
const insertTable = (editor) => {
  const newTable = createTable(3, 3);
  Transforms.insertNodes(editor, newTable);
};
const deleteTable = (editor) => {
  Transforms.removeNodes(editor, {
    match: (n2) => Element$3.isElementType(n2, BLOCK_TYPES.TABLE)
  });
};
const decorateSelectedNodes = (editor) => {
  const selectionCommonNode = getSelectionCommonNode(editor);
  if (selectionCommonNode) {
    const [commonParent] = selectionCommonNode;
    Transforms.unsetNodes(editor, "isSelected", {
      match: (n2) => n2.isSelected,
      at: []
    });
    if (Element$3.isElementType(commonParent, BLOCK_TYPES.TABLE) || Element$3.isElementType(commonParent, BLOCK_TYPES.TABLE_ROW)) {
      Transforms.setNodes(
        editor,
        { isSelected: true },
        {
          match: (n2) => Element$3.isElementType(n2, BLOCK_TYPES.TABLE_ROW)
        }
      );
    } else if (!Element$3.isElementType(commonParent, BLOCK_TYPES.TABLE_CELL) && (Element$3.isElement(commonParent) || Editor.isEditor(commonParent))) {
      Transforms.setNodes(
        editor,
        { isSelected: true },
        {
          match: (n2) => Element$3.isElementType(n2, BLOCK_TYPES.TABLE)
        }
      );
    }
  }
};
const getWithTables = (readOnly) => (editor) => {
  const {
    deleteBackward: deleteBackward2,
    deleteForward: deleteForward2,
    deleteFragment: deleteFragment3,
    insertBreak: insertBreak2,
    insertText: insertText3,
    insertData,
    normalizeNode: normalizeNode2,
    onChange
  } = editor;
  editor.onChange = () => {
    if (!readOnly) {
      const selectionOperation = editor.operations.find(
        (op) => op.type === "set_selection"
      );
      if (selectionOperation) {
        const selectionHasChanged = JSON.stringify(selectionOperation.newProperties) !== JSON.stringify(selectionOperation.properties);
        if (selectionHasChanged) {
          if (isTableActive(editor) && editor.isTableKeyboardSelecting) {
            const { selection } = editor;
            const newSelection = {
              ...selection,
              ...selectionOperation.newProperties
            };
            const currentSelection = {
              ...selection,
              ...selectionOperation.properties
            };
            overrideSelectionChange(editor, currentSelection, newSelection);
          }
          decorateSelectedNodes(editor);
        }
      }
    }
    return onChange(editor);
  };
  editor.deleteFragment = () => {
    const selectionCommonNode = getSelectionCommonNode(editor);
    if (selectionCommonNode) {
      const [commonParent, commonParentPath] = selectionCommonNode;
      if (Element$3.isElementType(commonParent, BLOCK_TYPES.TABLE_ROW)) {
        const isOnlyRow = Node$1.parent(editor, commonParentPath).children.length === 1;
        const typeToRemove = isOnlyRow ? BLOCK_TYPES.TABLE : BLOCK_TYPES.TABLE_ROW;
        Transforms.removeNodes(editor, {
          match: (n2) => Element$3.isElementType(n2, typeToRemove)
        });
      } else if (Element$3.isElementType(commonParent, BLOCK_TYPES.TABLE)) {
        const selectedRows = Array.from(
          Editor.nodes(editor, {
            match: (n2) => Element$3.isElementType(n2, BLOCK_TYPES.TABLE_ROW)
          })
        );
        const tableRows = Array.from(
          Editor.nodes(editor, {
            match: (n2) => Element$3.isElementType(n2, BLOCK_TYPES.TABLE_ROW),
            at: commonParentPath
          })
        );
        if (tableRows.length === selectedRows.length) {
          Transforms.removeNodes(editor, {
            match: (n2) => Element$3.isElementType(n2, BLOCK_TYPES.TABLE)
          });
        } else {
          Transforms.removeNodes(editor, {
            match: (n2) => Element$3.isElementType(n2, BLOCK_TYPES.TABLE_ROW)
          });
        }
      } else if (!Element$3.isElementType(commonParent, BLOCK_TYPES.TABLE_CELL) && (Element$3.isElement(commonParent) || Editor.isEditor(commonParent))) {
        Transforms.removeNodes(editor, {
          match: (n2) => Element$3.isElementType(n2, BLOCK_TYPES.TABLE)
        });
      }
    }
    deleteFragment3(editor);
  };
  editor.deleteBackward = (unit) => {
    const { selection } = editor;
    if (selection && Range.isCollapsed(selection)) {
      const [cell] = Editor.nodes(editor, {
        match: (n2) => !Editor.isEditor(n2) && Element$3.isElement(n2) && n2.type === BLOCK_TYPES.TABLE_CELL
      });
      if (cell) {
        const [, cellPath] = cell;
        const start2 = Editor.start(editor, cellPath);
        if (Point.equals(selection.anchor, start2)) {
          return;
        }
      }
    }
    deleteBackward2(unit);
  };
  editor.deleteForward = (unit) => {
    const { selection } = editor;
    if (selection && Range.isCollapsed(selection)) {
      const [cell] = Editor.nodes(editor, {
        match: (n2) => !Editor.isEditor(n2) && Element$3.isElement(n2) && n2.type === BLOCK_TYPES.TABLE_CELL
      });
      if (cell) {
        const [, cellPath] = cell;
        const end2 = Editor.end(editor, cellPath);
        if (Point.equals(selection.anchor, end2)) {
          return;
        }
      }
      const selectionNotInTable = !getActiveTable(editor);
      if (selectionNotInTable) {
        const nextPoint = Editor.after(editor, selection.anchor);
        if (nextPoint) {
          const [nextPointTable] = Editor.nodes(editor, {
            match: (n2) => !Editor.isEditor(n2) && Element$3.isElement(n2) && n2.type === BLOCK_TYPES.TABLE,
            at: nextPoint.path
          });
          const nextPointInTable = !!nextPointTable;
          if (nextPointInTable) return;
        }
      }
    }
    deleteForward2(unit);
  };
  editor.insertText = (text) => {
    const selectionCommonNode = getSelectionCommonNode(editor);
    if (selectionCommonNode) {
      const [commonParent] = selectionCommonNode;
      if (Element$3.isElementType(commonParent, BLOCK_TYPES.TABLE) || Element$3.isElementType(commonParent, BLOCK_TYPES.TABLE_ROW) || getActiveTable(editor) && !Element$3.isElementType(commonParent, BLOCK_TYPES.TABLE_CELL) && (Element$3.isElement(commonParent) || Editor.isEditor(commonParent))) {
        const { selection } = editor;
        Transforms.setSelection(editor, {
          anchor: selection.focus,
          focus: selection.focus
        });
      }
    }
    insertText3(text);
  };
  editor.insertBreak = () => {
    const { selection } = editor;
    if (selection) {
      const table = getActiveTable(editor);
      const selectionCommonNode = getSelectionCommonNode(editor);
      if (table && selectionCommonNode) {
        const [commonParent] = selectionCommonNode;
        if (Range.isCollapsed(selection) || Text$1.isText(commonParent) || Element$3.isElementType(commonParent, BLOCK_TYPES.TABLE_CELL)) {
          editor.insertText("\n");
        }
        return;
      }
    }
    insertBreak2();
  };
  editor.normalizeNode = (entry) => {
    if (preserveSpace(editor, entry)) return;
    normalizeNode2(entry);
  };
  editor.insertData = (data) => {
    const html2 = data.getData("text/html");
    if (html2) {
      const fragment2 = convertHtmlToSlate(html2);
      Transforms.insertFragment(editor, fragment2);
      return;
    }
    insertData(data);
  };
  return editor;
};
const spacing = 10;
const styles$B = (theme2) => ({
  root: {},
  editorWrapper: {
    minHeight: "fit-content",
    maxHeight: 300,
    fontWeight: 400,
    borderRadius: 5,
    overflow: "auto",
    padding: spacing,
    fontSize: 14,
    border: `1px solid ${theme2.grey5}`,
    transition: "border-color 150ms linear 0ms",
    '&[data-has-focus="true"]': {
      borderColor: theme2.indigo3
    },
    "& [data-slate-editor]": {
      outline: "none",
      "& > *": {
        margin: "8px 0"
      },
      "& > h1.subject": {
        fontSize: 14,
        position: "sticky",
        zIndex: 1,
        top: `${-spacing}px`,
        fontWeight: 700,
        background: theme2.white1,
        padding: "1em 0 0.5em",
        borderBottom: `1px solid ${theme2.grey6}`,
        margin: `${-spacing}px 0 ${spacing}px`,
        // When subject is not in a disabled parent and is empty
        '[data-is-disabled="false"] & > span[data-slate-node]:only-child > span[data-slate-leaf]:only-child > span[data-slate-length="0"]:before': {
          content: (props2) => `"${props2.subjectPlaceholder}"`,
          color: `${theme2.grey6}`,
          position: "absolute",
          fontWeight: "normal",
          borderBottom: `0px solid ${theme2.grey6}`
        },
        // When subject is not in a disabled parent target the following block that is emtpy
        '[data-is-disabled="false"] & + *:last-child > span[data-slate-node]:only-child > span[data-slate-leaf]:only-child > span[data-slate-length="0"]:before': {
          content: (props2) => `"${props2.placeholder}"`,
          color: `${theme2.grey6}`,
          position: "absolute",
          fontWeight: "normal"
        }
      },
      '& > h1, [data-with-subject="true"] & > h2': {
        fontSize: 20,
        fontWeight: "bold"
      },
      '& > h2, [data-with-subject="true"] & > h3': {
        fontSize: 16,
        fontWeight: "bold"
      },
      "& > blockquote": {
        borderLeft: `2px solid ${theme2.grey6}`,
        padding: "5px 0 5px 10px",
        fontStyle: "italic",
        color: theme2.grey2
      },
      "& ul": {
        listStyleType: "disc",
        marginLeft: "1.5em"
      },
      "& ol": {
        listStyleType: "decimal",
        marginLeft: "1.5em"
      },
      "& strong": {
        fontWeight: "bold"
      },
      "& em": {
        fontStyle: "italic"
      },
      "& u": {
        textDecoration: "underline"
      },
      "& mark": {
        backgroundColor: theme2.indigoPastel2,
        padding: "4px 2px"
      },
      "& code": {
        backgroundColor: theme2.grey6,
        padding: "4px 6px",
        borderRadius: 2
      },
      "& table": {
        borderCollapse: "collapse",
        width: "100%",
        '[data-is-disabled="false"] &': {
          width: "calc(100% - 10px)"
        }
      },
      "& td": {
        padding: 10,
        border: `1px solid ${theme2.grey6}`,
        position: "relative"
      },
      '& [data-is-selected="true"] td': {
        backgroundColor: theme2.indigoPastel3,
        border: `1px solid ${theme2.indigo3}`,
        // '& *::selection': {
        //   backgroundColor: "transparent"
        // },
        "&:before": {
          content: '""',
          display: "block",
          position: "absolute",
          top: -1,
          left: -1,
          height: 1,
          width: "calc(100% + 2px)",
          backgroundColor: theme2.indigo3
        }
      }
    }
  },
  editorWrapperReadOnly: {
    border: 0,
    padding: 0,
    minHeight: "none",
    maxHeight: "none",
    "& [data-slate-editor]": {
      '& [data-is-empty="true"]:not(td)': {
        display: "none"
      },
      "& > h1.subject": {
        borderBottom: `0px`,
        "&::before": {
          content: '"Subject: "'
        }
      }
    }
  },
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: 5,
    justifyContent: "flex-start",
    gap: "8px 16px"
  },
  toolbarButtonGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: "4px"
  },
  toolbarButtonGroupHistory: {
    marginLeft: "auto"
  },
  toolbarSeparator: {
    borderRight: `1px solid ${theme2.grey5}`,
    marginRight: 12,
    paddingRight: 8
  },
  button: {
    "&[disabled]": {
      cursor: "not-allowed",
      color: `${theme2.grey5}`,
      borderColor: `${theme2.grey5}`
    },
    minWidth: 20,
    height: 20,
    fontSize: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    border: `1px solid ${theme2.indigo2}`,
    color: theme2.indigo3,
    borderRadius: 2,
    outline: "none",
    boxShadow: `0 0 0 0 ${theme2.indigoPastel2}`,
    transition: "box-shadow 650ms ease, background-color 650ms ease, border-color 650ms ease",
    "&:not([disabled])": {
      "&:hover, &:focus": {
        borderColor: theme2.indigo2,
        backgroundColor: theme2.indigo2,
        color: theme2.white1
      },
      "&:focus": {
        boxShadow: `0 0 0 2px ${theme2.indigoPastel2}`
      }
    },
    "& strong": {
      fontWeight: "bold"
    },
    "& em": {
      fontStyle: "italic"
    },
    "& u": {
      textDecoration: "underline"
    }
  },
  buttonActive: {
    borderColor: theme2.indigo3,
    backgroundColor: theme2.indigo3,
    color: theme2.white1
  },
  autoCompleteList: {
    top: "-9999px",
    left: "-9999px",
    position: "absolute",
    zIndex: 2,
    padding: 3,
    background: theme2.white1,
    borderRadius: 2,
    boxShadow: theme2.indigoShadow2,
    fontSize: 14
  },
  autoCompleteListItem: {
    padding: "1px 3px",
    borderRadius: "3px",
    background: "transparent",
    color: theme2.grey2
  },
  autoCompleteListItemActive: {
    background: theme2.indigoPastel2,
    color: "unset"
  },
  mention: {
    backgroundColor: theme2.blue50,
    padding: "0 6px",
    marginInline: "1px",
    color: theme2.blue800,
    borderRadius: 14,
    fontSize: "0.9em",
    verticalAlign: "baseline",
    display: "inline-block"
  },
  mentionSelected: {
    outline: `1px solid ${theme2.blue800}`
  },
  link: {
    color: theme2.indigo3
  },
  linkSelected: {
    outline: `2px solid ${theme2.indigoPastel1}`
  },
  tableContainer: {
    with: "100%",
    overflow: "auto"
  },
  image: {
    position: "relative",
    width: "fit-content",
    "& .image-actions": {
      display: "none",
      position: "absolute",
      top: "0.5em",
      left: "0.5em"
    },
    "& .image-placeholder": {
      position: "absolute",
      top: 0,
      pointerEvents: "none",
      animation: "skeleton-loading 1s linear infinite alternate"
    },
    "& img": {
      display: "block",
      maxWidth: "100%",
      maxHeight: "20em",
      cursor: "zoom-in"
    },
    "& a": {
      textDecoration: "none"
    },
    "& button": {
      border: `1px solid ${theme2.indigo2}`,
      color: theme2.indigo3,
      borderRadius: 2,
      backgroundColor: theme2.white1,
      height: "fit-content",
      "&:hover": {
        borderColor: theme2.indigo2,
        backgroundColor: theme2.indigo2,
        color: theme2.white1
      }
    },
    "&:hover": {
      "& .image-actions": {
        display: "flex",
        gap: "10px"
      }
    }
  },
  imageLoader: {
    position: "absolute",
    top: 0,
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgb(255 255 255 / 50%)"
  },
  "@keyframes skeleton-loading": {
    "0%": {
      backgroundColor: "hsl(200, 20%, 80%)"
    },
    "100%": {
      backgroundColor: "hsl(200, 20%, 95%)"
    }
  }
});
const ElementComponent = (props2) => {
  const {
    classes,
    attributes,
    children,
    element,
    withSubject,
    withMentions,
    readOnly
  } = props2;
  const style2 = { textAlign: element.align };
  const Heading1 = withSubject ? "h2" : "h1";
  const Heading2 = withSubject ? "h3" : "h2";
  const newAttributes = {
    ...attributes,
    "data-is-empty": element.isEmpty,
    "data-is-selected": element.isSelected
  };
  if (withSubject && element.type === BLOCK_TYPES.SUBJECT) {
    return /* @__PURE__ */ jsx$1("h1", { className: "subject", style: style2, ...newAttributes, children });
  }
  if ((withMentions || readOnly) && element.type === BLOCK_TYPES.MENTION) {
    return /* @__PURE__ */ jsx$1(Mention, { attributes: newAttributes, element, children });
  }
  switch (element.type) {
    case BLOCK_TYPES.BLOCKQUOTE:
      return /* @__PURE__ */ jsx$1("blockquote", { style: style2, ...newAttributes, children });
    case BLOCK_TYPES.UNORDERED_LIST:
      return /* @__PURE__ */ jsx$1("ul", { style: style2, ...newAttributes, children });
    case BLOCK_TYPES.HEADING1:
      return /* @__PURE__ */ jsx$1(Heading1, { style: style2, ...newAttributes, children });
    case BLOCK_TYPES.HEADING2:
      return /* @__PURE__ */ jsx$1(Heading2, { style: style2, ...newAttributes, children });
    case BLOCK_TYPES.LIST_ITEM:
      return /* @__PURE__ */ jsx$1("li", { style: style2, ...newAttributes, children });
    case BLOCK_TYPES.ORDERED_LIST:
      return /* @__PURE__ */ jsx$1("ol", { style: style2, ...newAttributes, children });
    case BLOCK_TYPES.LINK:
      return /* @__PURE__ */ jsx$1(Link, { ...props2 });
    case BLOCK_TYPES.TABLE:
      return /* @__PURE__ */ jsx$1("div", { className: classes.tableContainer, children: /* @__PURE__ */ jsx$1("table", { children: /* @__PURE__ */ jsx$1("tbody", { ...newAttributes, children }) }) });
    case BLOCK_TYPES.TABLE_ROW:
      return /* @__PURE__ */ jsx$1("tr", { ...newAttributes, children });
    case BLOCK_TYPES.TABLE_CELL:
      return /* @__PURE__ */ jsx$1("td", { style: style2, ...newAttributes, children });
    case BLOCK_TYPES.IMAGE:
      return /* @__PURE__ */ jsx$1(Image, { ...props2 });
    default:
      return /* @__PURE__ */ jsx$1("p", { style: style2, ...newAttributes, children });
  }
};
ElementComponent.propTypes = {
  classes: PropTypes$1.object.isRequired,
  attributes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  element: PropTypes$1.object.isRequired,
  withSubject: PropTypes$1.bool,
  withMentions: PropTypes$1.bool,
  readOnly: PropTypes$1.bool
};
ElementComponent.defaultProps = {
  withSubject: false,
  withMentions: false,
  readOnly: false
};
const Element$1 = injectSheet(styles$B)(ElementComponent);
const Leaf = ({ attributes, children, leaf: leaf3 }) => {
  let wrappedChildren = children;
  if (leaf3.bold) {
    wrappedChildren = /* @__PURE__ */ jsx$1("strong", { children: wrappedChildren });
  }
  if (leaf3.code) {
    wrappedChildren = /* @__PURE__ */ jsx$1("code", { children: wrappedChildren });
  }
  if (leaf3.italic) {
    wrappedChildren = /* @__PURE__ */ jsx$1("em", { children: wrappedChildren });
  }
  if (leaf3.underline) {
    wrappedChildren = /* @__PURE__ */ jsx$1("u", { children: wrappedChildren });
  }
  if (leaf3.mark) {
    wrappedChildren = /* @__PURE__ */ jsx$1("mark", { children: wrappedChildren });
  }
  if (leaf3.highlight) {
    wrappedChildren = /* @__PURE__ */ jsx$1(
      "span",
      {
        "data-cy": "search-highlighted",
        style: {
          fontWeight: leaf3.bold ? "bold" : "normal",
          backgroundColor: "#ffeeba"
        },
        children: wrappedChildren
      }
    );
  }
  return /* @__PURE__ */ jsx$1("span", { ...attributes, children: wrappedChildren });
};
Leaf.propTypes = {
  attributes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  leaf: PropTypes$1.object.isRequired
};
const ButtonTooltip = ({ disabled, format: format3, children }) => disabled ? children : /* @__PURE__ */ jsx$1(
  InfoTooltip$1,
  {
    text: format3,
    padding: "5px 10px",
    textAlign: "center",
    minWidth: "50",
    position: {
      place: "above",
      placeShift: 3,
      adjustPlace: true,
      anchor: "center"
    },
    children
  }
);
const BlockButtonComponent = ({
  disabled,
  format: format3,
  classes,
  children
}) => {
  const editor = useSlate();
  const isActive = isBlockActive(
    editor,
    format3,
    TEXT_ALIGN_TYPES.includes(format3) ? "align" : "type"
  );
  return /* @__PURE__ */ jsx$1(ButtonTooltip, { disabled, format: format3, children: /* @__PURE__ */ jsx$1(
    "button",
    {
      disabled,
      type: "button",
      className: classNames(classes.button, {
        [classes.buttonActive]: isActive
      }),
      onMouseDown: (event) => {
        event.preventDefault();
        toggleBlock(editor, format3);
      },
      children
    }
  ) });
};
BlockButtonComponent.propTypes = {
  classes: PropTypes$1.object.isRequired,
  format: PropTypes$1.string.isRequired,
  children: PropTypes$1.node.isRequired,
  disabled: PropTypes$1.bool
};
BlockButtonComponent.defaultProps = {
  disabled: false
};
const BlockButton = injectSheet(styles$B)(BlockButtonComponent);
const MarkButtonComponent = ({ disabled, format: format3, classes, children }) => {
  const editor = useSlate();
  const isActive = isMarkActive(editor, format3);
  return /* @__PURE__ */ jsx$1(ButtonTooltip, { disabled, format: format3, children: /* @__PURE__ */ jsx$1(
    "button",
    {
      disabled,
      type: "button",
      className: classNames(classes.button, {
        [classes.buttonActive]: isActive
      }),
      onMouseDown: (event) => {
        event.preventDefault();
        toggleMark(editor, format3);
      },
      children
    }
  ) });
};
MarkButtonComponent.propTypes = {
  classes: PropTypes$1.object.isRequired,
  format: PropTypes$1.string.isRequired,
  children: PropTypes$1.node.isRequired,
  disabled: PropTypes$1.bool
};
MarkButtonComponent.defaultProps = {
  disabled: false
};
const MarkButton = injectSheet(styles$B)(MarkButtonComponent);
const LinkButtonComponent = ({ disabled, classes, children }) => {
  const editor = useSlate();
  const isActive = isLinkActive(editor);
  return /* @__PURE__ */ jsx$1(ButtonTooltip, { disabled, format: "link", children: /* @__PURE__ */ jsx$1(
    "button",
    {
      disabled,
      type: "button",
      className: classNames(classes.button, {
        [classes.buttonActive]: isActive
      }),
      onMouseDown: (event) => {
        event.preventDefault();
        toggleLink(editor);
      },
      children
    }
  ) });
};
LinkButtonComponent.propTypes = {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  disabled: PropTypes$1.bool
};
LinkButtonComponent.defaultProps = {
  disabled: false
};
const LinkButton = injectSheet(styles$B)(LinkButtonComponent);
const GenericButtonComponent = ({
  disabled,
  children,
  classes,
  onMouseDown,
  tooltip
}) => /* @__PURE__ */ jsx$1(ButtonTooltip, { disabled, format: tooltip, children: /* @__PURE__ */ jsx$1(
  "button",
  {
    disabled,
    type: "button",
    className: classNames(classes.button),
    onMouseDown: (e5) => {
      e5.preventDefault();
      onMouseDown();
    },
    children
  }
) });
GenericButtonComponent.propTypes = {
  classes: PropTypes$1.object.isRequired,
  tooltip: PropTypes$1.string.isRequired,
  children: PropTypes$1.node.isRequired,
  onMouseDown: PropTypes$1.func.isRequired,
  disabled: PropTypes$1.bool
};
GenericButtonComponent.defaultProps = {
  disabled: false
};
const GenericButton = injectSheet(styles$B)(GenericButtonComponent);
const ToolbarComponent = ({ disabled, classes }) => {
  const editor = useSlate();
  const isDisabled = disabled || isSubjectActive(editor);
  const isInTable = isTableActive(editor);
  return /* @__PURE__ */ jsxs("div", { className: classes.toolbar, children: [
    /* @__PURE__ */ jsxs("div", { className: classes.toolbarButtonGroup, children: [
      /* @__PURE__ */ jsx$1(MarkButton, { disabled: isDisabled, format: "bold", children: /* @__PURE__ */ jsx$1("strong", { children: "B" }) }),
      /* @__PURE__ */ jsx$1(MarkButton, { disabled: isDisabled, format: "italic", children: /* @__PURE__ */ jsx$1("em", { children: "I" }) }),
      /* @__PURE__ */ jsx$1(MarkButton, { disabled: isDisabled, format: "underline", children: /* @__PURE__ */ jsx$1("u", { children: "U" }) }),
      /* @__PURE__ */ jsx$1(
        BlockButton,
        {
          disabled: isDisabled || isInTable,
          format: BLOCK_TYPES.HEADING1,
          children: /* @__PURE__ */ jsx$1("strong", { children: "H1" })
        }
      ),
      /* @__PURE__ */ jsx$1(
        BlockButton,
        {
          disabled: isDisabled || isInTable,
          format: BLOCK_TYPES.UNORDERED_LIST,
          children: /* @__PURE__ */ jsx$1(Icon$2, { size: 16, name: "Bullets" })
        }
      ),
      /* @__PURE__ */ jsx$1(LinkButton, { disabled: isDisabled, children: /* @__PURE__ */ jsx$1(Icon$2, { size: 16, name: "Link" }) }),
      /* @__PURE__ */ jsx$1(
        GenericButton,
        {
          disabled: isDisabled || isInTable,
          tooltip: "Insert table",
          onMouseDown: () => insertTable(editor),
          children: /* @__PURE__ */ jsx$1(Icon$2, { size: 16, name: "TableInsert" })
        }
      )
    ] }),
    isInTable && /* @__PURE__ */ jsxs("div", { className: classes.toolbarButtonGroup, children: [
      /* @__PURE__ */ jsx$1(
        GenericButton,
        {
          disabled: isDisabled,
          tooltip: "Insert row",
          onMouseDown: () => insertRow(editor),
          children: /* @__PURE__ */ jsx$1(Icon$2, { size: 16, name: "RowInsert" })
        }
      ),
      /* @__PURE__ */ jsx$1(
        GenericButton,
        {
          disabled: isDisabled,
          tooltip: "Delete row",
          onMouseDown: () => deleteRow(editor),
          children: /* @__PURE__ */ jsx$1(Icon$2, { size: 16, name: "RowDelete" })
        }
      ),
      /* @__PURE__ */ jsx$1(
        GenericButton,
        {
          disabled: isDisabled,
          tooltip: "Insert column",
          onMouseDown: () => insertColumn(editor),
          children: /* @__PURE__ */ jsx$1(Icon$2, { size: 16, name: "ColumnInsert" })
        }
      ),
      /* @__PURE__ */ jsx$1(
        GenericButton,
        {
          disabled: isDisabled,
          tooltip: "Delete column",
          onMouseDown: () => deleteColumn(editor),
          children: /* @__PURE__ */ jsx$1(Icon$2, { size: 16, name: "ColumnDelete" })
        }
      ),
      /* @__PURE__ */ jsx$1(
        GenericButton,
        {
          disabled: isDisabled,
          tooltip: "Delete table",
          onMouseDown: () => deleteTable(editor),
          children: /* @__PURE__ */ jsx$1(Icon$2, { size: 16, name: "TableDelete" })
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames(
          classes.toolbarButtonGroup,
          classes.toolbarButtonGroupHistory
        ),
        children: [
          /* @__PURE__ */ jsx$1(
            GenericButton,
            {
              disabled: isDisabled || editor.history.undos.length <= 1,
              tooltip: "Undo",
              onMouseDown: editor.undo,
              children: /* @__PURE__ */ jsx$1(Icon$2, { size: 16, name: "Undo" })
            }
          ),
          /* @__PURE__ */ jsx$1(
            GenericButton,
            {
              disabled: isDisabled || editor.history.redos.length === 0,
              tooltip: "Redo",
              onMouseDown: editor.redo,
              children: /* @__PURE__ */ jsx$1(Icon$2, { size: 16, name: "Redo" })
            }
          )
        ]
      }
    )
  ] });
};
ToolbarComponent.propTypes = {
  classes: PropTypes$1.object.isRequired,
  disabled: PropTypes$1.bool
};
ToolbarComponent.defaultProps = {
  disabled: false
};
const Toolbar = injectSheet(styles$B)(ToolbarComponent);
const Portal = ({ children }) => typeof document === "object" ? createPortal(children, document.body) : null;
const UserListComponent = ({ classes, users, index: index2, search, target }) => {
  const ref2 = useRef(null);
  const editor = useSlate();
  useEffect(() => {
    if (target && (users == null ? void 0 : users.length) > 0 && ref2.current) {
      const el2 = ref2.current;
      const domRange = ReactEditor.toDOMRange(editor, target);
      const rect = domRange.getBoundingClientRect();
      el2.style.top = `${rect.top + window.pageYOffset + 24}px`;
      el2.style.left = `${rect.left + window.pageXOffset}px`;
    }
  }, [users == null ? void 0 : users.length, editor, index2, search, target]);
  if (target && (users == null ? void 0 : users.length) > 0) {
    return /* @__PURE__ */ jsx$1(Portal, { children: /* @__PURE__ */ jsx$1("div", { ref: ref2, className: classes.autoCompleteList, children: users == null ? void 0 : users.map((user, i3) => /* @__PURE__ */ jsx$1(
      "div",
      {
        className: classNames(classes.autoCompleteListItem, {
          [classes.autoCompleteListItemActive]: i3 === index2
        }),
        children: user.name
      },
      user.id
    )) }) });
  }
  return null;
};
UserListComponent.propTypes = {
  classes: PropTypes$1.object.isRequired,
  users: PropTypes$1.array.isRequired,
  index: PropTypes$1.number.isRequired,
  search: PropTypes$1.string.isRequired,
  target: PropTypes$1.object
};
UserListComponent.defaultProps = {
  target: null
};
const UserList = injectSheet(styles$B)(UserListComponent);
const MentionComponent = ({ attributes, children, element, classes }) => {
  const selected = useSelected();
  const focused = useFocused();
  return /* @__PURE__ */ jsxs(
    "span",
    {
      ...attributes,
      contentEditable: false,
      className: classNames(classes.mention, {
        [classes.mentionSelected]: selected && focused
      }),
      children: [
        children,
        "@",
        element.user.name
      ]
    }
  );
};
MentionComponent.propTypes = {
  classes: PropTypes$1.object.isRequired,
  attributes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  element: PropTypes$1.object.isRequired
};
const Mention = injectSheet(styles$B)(MentionComponent);
const LinkComponent = ({ classes, attributes, children, element }) => {
  const selected = useSelected();
  return /* @__PURE__ */ jsxs(
    "a",
    {
      ...attributes,
      href: element.url,
      className: classNames(classes.link, {
        [classes.linkSelected]: selected
      }),
      children: [
        /* @__PURE__ */ jsx$1(InlineChromiumBugfix, {}),
        children,
        /* @__PURE__ */ jsx$1(InlineChromiumBugfix, {})
      ]
    }
  );
};
LinkComponent.propTypes = {
  classes: PropTypes$1.object.isRequired,
  attributes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  element: PropTypes$1.object.isRequired
};
const Link = injectSheet(styles$B)(LinkComponent);
const InlineChromiumBugfix = () => /* @__PURE__ */ jsxs("span", { contentEditable: false, style: { fontSize: 0 }, children: [
  "$",
  String.fromCodePoint(160)
] });
const SubjectListComponent = ({ classes, subjects, index: index2 }) => {
  const ref2 = useRef(null);
  const editor = useSlate();
  useEffect(() => {
    const el2 = ref2.current;
    if (el2 && (subjects == null ? void 0 : subjects.length) > 0 && ref2.current) {
      const domRange = ReactEditor.toDOMRange(editor, {
        anchor: { path: [0, 0], offset: 0 },
        focus: { path: [0, 0], offset: 0 }
      });
      const rect = domRange.getBoundingClientRect();
      el2.style.top = `${rect.top + window.pageYOffset + 24}px`;
      el2.style.left = `${rect.left + window.pageXOffset}px`;
    }
  }, [subjects == null ? void 0 : subjects.length, editor, index2]);
  if ((subjects == null ? void 0 : subjects.length) > 0) {
    return /* @__PURE__ */ jsx$1(Portal, { children: /* @__PURE__ */ jsx$1("div", { ref: ref2, className: classes.autoCompleteList, children: subjects == null ? void 0 : subjects.map((subject, i3) => /* @__PURE__ */ jsx$1(
      "div",
      {
        className: classNames(classes.autoCompleteListItem, {
          [classes.autoCompleteListItemActive]: i3 === index2
        }),
        children: subject
      },
      subject
    )) }) });
  }
  return null;
};
const SubjectAutoComplete = injectSheet(styles$B)(SubjectListComponent);
const ImageComponent = ({
  classes,
  attributes,
  children,
  element,
  readOnly,
  uploadImage,
  downloadImage
}) => {
  var _a2, _b2;
  const editor = useSlateStatic();
  const path3 = ReactEditor.findPath(editor, element);
  const [fullScreen, setFullScreen] = useState(false);
  const [loading, setLoading] = useState(false);
  const imgRef = useRef(null);
  const selected = useSelected();
  const focused = useFocused();
  const onFileSuccess = useCallback(
    (file) => {
      const dimension = { width: 0, height: 0 };
      if (imgRef.current) {
        dimension.width = imgRef.current.width;
        dimension.height = imgRef.current.height;
      }
      const media = {
        digest: file.digest,
        key: file.key
      };
      downloadImage(
        file,
        setLoading,
        false,
        (file2) => {
          Transforms.setNodes(
            editor,
            { url: URL.createObjectURL(file2), media, dimension },
            { at: path3 }
          );
          setLoading(false);
        },
        false
      );
    },
    [editor, path3]
  );
  const onFileError = useCallback(() => {
    setLoading(false);
  }, []);
  useEffect(() => {
    if (readOnly && (element == null ? void 0 : element.media)) {
      downloadImage(
        element.media,
        setLoading,
        loading,
        (file) => {
          if (!file) return;
          Transforms.setNodes(
            editor,
            { url: URL.createObjectURL(file) },
            { at: path3 }
          );
        },
        false
      );
    }
    if (!(element == null ? void 0 : element.media) && !readOnly) {
      setLoading(true);
      uploadImage(element.url, onFileSuccess, onFileError, () => {
      });
    }
  }, []);
  const downloadFile = (evt) => {
    evt.preventDefault();
    if (!imgRef || !imgRef.current) return;
    const link2 = document.createElement("a");
    const canvas = document.createElement("canvas");
    canvas.width = imgRef.current.naturalWidth;
    canvas.height = imgRef.current.naturalHeight;
    const ctx2 = canvas.getContext("2d");
    ctx2 == null ? void 0 : ctx2.drawImage(imgRef.current, 0, 0);
    link2.href = canvas.toDataURL("image/png");
    link2.download = element.media.name || "image";
    link2.click();
    link2.remove();
  };
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsxs("div", { ...attributes, children: [
      children,
      /* @__PURE__ */ jsxs("div", { contentEditable: false, className: classes.image, children: [
        /* @__PURE__ */ jsx$1(
          "img",
          {
            ref: imgRef,
            src: element.url,
            alt: "",
            onClick: () => setFullScreen(true),
            style: {
              boxShadow: `${selected && focused ? "0 0 0 3px #B4D5FF" : "none"}`
            }
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "image-actions", children: [
          !readOnly && /* @__PURE__ */ jsx$1(
            Button$3,
            {
              onClick: () => Transforms.removeNodes(editor, { at: path3 }),
              children: /* @__PURE__ */ jsx$1(Icon$2, { name: "Trash", size: 25 })
            }
          ),
          /* @__PURE__ */ jsx$1(Button$3, { onClick: (evt) => downloadFile(evt), children: /* @__PURE__ */ jsx$1(Icon$2, { name: "Download", size: 25 }) })
        ] }),
        element && readOnly && loading && /* @__PURE__ */ jsx$1(
          "div",
          {
            className: "image-placeholder",
            style: {
              width: `${(_a2 = element == null ? void 0 : element.dimension) == null ? void 0 : _a2.width}px`,
              height: `${(_b2 = element == null ? void 0 : element.dimension) == null ? void 0 : _b2.height}px`
            }
          }
        ),
        loading && !readOnly && /* @__PURE__ */ jsx$1("div", { className: classes.imageLoader, children: /* @__PURE__ */ jsx$1(LoaderTraceLogo$1, {}) })
      ] })
    ] }),
    fullScreen && /* @__PURE__ */ jsx$1(Portal, { children: /* @__PURE__ */ jsx$1(
      "div",
      {
        style: {
          position: "fixed",
          top: 0,
          left: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "rgb(0 0 0 / 86%)",
          width: "100%",
          height: "100%",
          cursor: "zoom-out",
          zIndex: 4
        },
        onClick: () => setFullScreen(false),
        children: /* @__PURE__ */ jsx$1(
          "img",
          {
            src: element.url,
            style: {
              maxWidth: "100%",
              maxHeight: "100%"
            },
            alt: ""
          }
        )
      }
    ) })
  ] });
};
ImageComponent.propTypes = {
  classes: PropTypes$1.object.isRequired,
  attributes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired,
  element: PropTypes$1.object.isRequired,
  uploadImage: PropTypes$1.func.isRequired,
  downloadImage: PropTypes$1.func.isRequired,
  readonly: PropTypes$1.bool
};
ImageComponent.defaultProps = {
  readonly: false
};
const Image = injectSheet(styles$B)(memo(ImageComponent));
const defaultProps = {
  className: "",
  classes: {},
  placeholder: "",
  subjectPlaceholder: "",
  disabled: false,
  readOnly: false,
  autoFocus: false,
  workflowContext: {},
  searchValue: "",
  onChange: () => {
  },
  onBlur: () => {
  },
  uploadImage: () => {
  },
  downloadImage: () => {
  }
};
const RichEditorInner = forwardRef(
  ({
    className = "",
    placeholder = "",
    subjectPlaceholder = "",
    disabled = false,
    onChange = () => {
    },
    onBlur = () => {
    },
    initialValue = defaultEmptyValue,
    autoFocus = false,
    withSubject = false,
    withMentions = false,
    readOnly = false,
    classes = {},
    workflowContext,
    searchValue,
    uploadImage,
    downloadImage,
    ...props2
  }, ref2) => {
    var _a2;
    const renderElement = useCallback(
      (elementProps) => /* @__PURE__ */ jsx$1(
        Element$1,
        {
          withSubject,
          withMentions,
          readOnly,
          uploadImage,
          downloadImage,
          ...elementProps
        }
      ),
      [withSubject, withMentions, readOnly, uploadImage, downloadImage]
    );
    const renderLeaf = useCallback((leafProps) => /* @__PURE__ */ jsx$1(Leaf, { ...leafProps }), []);
    const withTables = getWithTables(readOnly);
    const withSubjectLine = getWithSubjectLine(withSubject, readOnly);
    const editor = useMemo(
      () => compose(
        withImages,
        withTables,
        withSubjectLine,
        withLinks,
        withMentionsPlugin,
        withReact,
        withHistory,
        withIsEmptyAttribute
      )(createEditor$1()),
      []
    );
    const [isFocused, setIsFocused] = useState(false);
    const [editorValue, setEditorValue] = useState(
      () => parseInitialValue(initialValue)
    );
    const [target, setTarget] = useState();
    const [index2, setIndex] = useState(0);
    const [search, setSearch] = useState("");
    const [isDirty, setIsDirty] = useState(false);
    const [subjectIndex, setSubjectIndex] = useState(0);
    const [subjectSearch, setSubjectSearch] = useState("");
    const users = withMentions && ((_a2 = workflowContext == null ? void 0 : workflowContext.members) == null ? void 0 : _a2.filter((c3) => c3.name.toLowerCase().startsWith(search.toLowerCase())).slice(0, 10));
    const subjectsList = workflowContext == null ? void 0 : workflowContext.subjects;
    const [subjects, setSubjects] = useState(
      (subjectSearch == null ? void 0 : subjectSearch.length) ? subjectsList == null ? void 0 : subjectsList.filter(
        (sub) => sub.toLowerCase().startsWith(subjectSearch.toLowerCase())
      ).slice(0, 10) : ""
    );
    useImperativeHandle(ref2, () => ({
      clearEditor() {
        const point3 = { path: [0, 0], offset: 0 };
        editor.selection = { anchor: point3, focus: point3 };
        editor.history = { redos: [], undos: [] };
        editor.children = JSON.parse(defaultEmptyValue);
      }
    }));
    const handleFocus = () => {
      setIsFocused(true);
    };
    const handleBlur = () => {
      setIsFocused(false);
    };
    const handleEditorMouseDown = (e5) => {
      if (e5.currentTarget === e5.target) {
        e5.preventDefault();
        focusEditor(editor);
      }
      handleTableMouseDown(e5, editor);
    };
    const handleKeyDown = useCallback(
      (event) => {
        if (isTableActive(editor)) {
          handleTableKeydown(event, editor);
        }
        const { selection } = editor;
        const subjectIsActive = isSubjectActive(editor);
        setIsDirty(true);
        const subjectsAreActive = subjectIsActive && ((subjects == null ? void 0 : subjects.length) || (subjectSearch == null ? void 0 : subjectSearch.length)) && withSubject;
        if (event.key === " " && event.ctrlKey && withSubject)
          setSubjects(subjectsList.splice(0, 10));
        const keyEventActions = (data) => {
          const dataIndex = target ? index2 : subjectIndex;
          const setDataIndex = (dataIndex2) => target ? setIndex(dataIndex2) : setSubjectIndex(dataIndex2);
          switch (event.key) {
            case "ArrowDown": {
              event.preventDefault();
              const prevIndex = dataIndex >= (data == null ? void 0 : data.length) - 1 ? 0 : dataIndex + 1;
              setDataIndex(prevIndex);
              break;
            }
            case "ArrowUp": {
              event.preventDefault();
              const nextIndex = dataIndex <= 0 ? (data == null ? void 0 : data.length) - 1 : dataIndex - 1;
              setDataIndex(nextIndex);
              break;
            }
            case "Tab":
            case "Enter": {
              if (!target && !data) return;
              if (data[index2]) {
                event.preventDefault();
                if (target) {
                  Transforms.select(editor, target);
                  insertMention(editor, data[index2]);
                  setTarget(null);
                } else {
                  insertSubject(editor, data[subjectIndex]);
                }
              }
              break;
            }
            case "Escape":
              event.preventDefault();
              if (target) {
                setTarget(null);
              } else {
                setSubjectSearch("");
              }
              break;
          }
        };
        if (withMentions && target) {
          keyEventActions(users);
        } else if (subjectsAreActive) {
          keyEventActions(subjects);
        }
        if (selection && Range.isCollapsed(selection)) {
          const { nativeEvent } = event;
          if (_default("left", nativeEvent)) {
            event.preventDefault();
            Transforms.move(editor, { unit: "offset", reverse: true });
            return;
          }
          if (_default("right", nativeEvent)) {
            event.preventDefault();
            Transforms.move(editor, { unit: "offset" });
            return;
          }
        }
        if (!subjectIsActive) {
          Object.keys(HOTKEYS).forEach((hotkey) => {
            if (_default(hotkey, event)) {
              event.preventDefault();
              const mark = HOTKEYS[hotkey];
              toggleMark(editor, mark);
            }
          });
        }
        if (_default("shift+Enter", event)) {
          event.preventDefault();
          if (!subjectIsActive) {
            editor.insertText("\n");
          }
        }
      },
      [
        editor,
        index2,
        subjectIndex,
        subjectSearch == null ? void 0 : subjectSearch.length,
        subjects,
        subjectsList,
        target,
        users,
        withMentions,
        withSubject
      ]
    );
    const handleChange = (value) => {
      var _a3, _b2, _c2;
      const { selection } = editor;
      if (withSubject && ((_a3 = value.find((val) => val.type === "subject")) == null ? void 0 : _a3.children[0])) {
        setSubjectSearch(
          (_c2 = (_b2 = value.find((val) => val.type === "subject")) == null ? void 0 : _b2.children[0]) == null ? void 0 : _c2.text
        );
        setSubjectIndex(0);
      }
      if ((users == null ? void 0 : users.length) > 0 && selection && Range.isCollapsed(selection)) {
        const [start2] = Range.edges(selection);
        const wordBefore = Editor.before(editor, start2, { unit: "word" });
        const before3 = wordBefore && Editor.before(editor, wordBefore);
        const beforeRange = before3 && Editor.range(editor, before3, start2);
        const beforeText = beforeRange && Editor.string(editor, beforeRange);
        const beforeMatch = beforeText && beforeText.match(/^@(\w+)$/);
        const after3 = Editor.after(editor, start2);
        const afterRange = Editor.range(editor, start2, after3);
        const afterText = Editor.string(editor, afterRange);
        const afterMatch = afterText.match(/^(\s|$)/);
        if (beforeMatch && afterMatch) {
          setTarget(beforeRange);
          setSearch(beforeMatch[1]);
          setIndex(0);
          return;
        }
      }
      setTarget(null);
      setEditorValue(value);
    };
    const decorate = useCallback(
      ([node3, path3]) => {
        const ranges = [];
        if (searchValue && Text$1.isText(node3)) {
          const { text } = node3;
          const parts = text.toLowerCase().split(searchValue.toLowerCase());
          let offset2 = 0;
          parts.forEach((part, i3) => {
            if (i3 !== 0) {
              ranges.push({
                anchor: { path: path3, offset: offset2 - searchValue.length },
                focus: { path: path3, offset: offset2 },
                highlight: true
              });
            }
            offset2 = offset2 + part.length + searchValue.length;
          });
        }
        return ranges;
      },
      [searchValue]
    );
    useEffect(() => {
      const parsValue = isJson$1(initialValue) ? JSON.parse(initialValue) : [];
      if (isRichEditorEmpty(parsValue)) {
        const point3 = { path: [0, 0], offset: 0 };
        editor.selection = { anchor: point3, focus: point3 };
        editor.history = { redos: [], undos: [] };
      }
      editor.children = parseInitialValue(initialValue);
      Editor.normalize(editor, { force: true });
      setEditorValue(editor.children);
    }, [initialValue, editor]);
    useEffect(() => {
      setSubjects(
        (subjectSearch == null ? void 0 : subjectSearch.length) ? subjectsList == null ? void 0 : subjectsList.filter(
          (sub) => sub.toLowerCase().startsWith(subjectSearch.toLowerCase())
        ).slice(0, 10) : ""
      );
    }, [subjectSearch, subjectsList]);
    useEffect(() => {
      if (isDirty) {
        if (isRichEditorEmpty(editorValue)) {
          onChange(void 0);
        } else {
          onChange(JSON.stringify(editorValue));
        }
      }
    }, [editorValue, isDirty]);
    useEffect(() => {
      if (autoFocus) {
        focusEditor(editor);
      }
    }, [autoFocus, editor]);
    return /* @__PURE__ */ jsx$1(
      "div",
      {
        className: classes.root,
        "data-is-disabled": disabled,
        "data-with-subject": withSubject,
        "data-cy": "atomic-rich-editor",
        children: /* @__PURE__ */ jsxs(
          Slate,
          {
            editor,
            initialValue: editorValue,
            onChange: handleChange,
            children: [
              !readOnly && /* @__PURE__ */ jsx$1(Toolbar, { disabled: disabled || !isFocused }),
              /* @__PURE__ */ jsx$1(
                "div",
                {
                  className: classNames({
                    [classes.editorWrapper]: true,
                    [classes.editorWrapperReadOnly]: readOnly,
                    [className]: !!className
                  }),
                  "data-has-focus": isFocused,
                  onMouseDown: handleEditorMouseDown,
                  children: /* @__PURE__ */ jsx$1(
                    Editable,
                    {
                      renderElement,
                      renderLeaf,
                      placeholder,
                      spellCheck: true,
                      autoFocus,
                      onKeyDown: handleKeyDown,
                      onFocus: handleFocus,
                      onBlur: handleBlur,
                      ...props2,
                      readOnly: readOnly || disabled,
                      decorate
                    }
                  )
                }
              ),
              (users == null ? void 0 : users.length) > 0 && /* @__PURE__ */ jsx$1(
                UserList,
                {
                  users,
                  target,
                  index: index2,
                  search
                }
              ),
              /* @__PURE__ */ jsx$1(SubjectAutoComplete, { index: subjectIndex, subjects })
            ]
          }
        )
      }
    );
  }
);
const RichEditorWithStyles = injectSheet(styles$B)(RichEditorInner);
RichEditorInner.defaultProps = defaultProps;
const RichEditor = forwardRef((props2, ref2) => /* @__PURE__ */ jsx$1(
  ErrorBoundary,
  {
    fallback: /* @__PURE__ */ jsx$1(Textinput$1, { value: props2.initialValue || "", ...props2 }),
    children: /* @__PURE__ */ jsx$1(RichEditorWithStyles, { ...props2, innerRef: ref2 })
  }
));
RichEditor.defaultProps = defaultProps;
const getStringFromValue = getStringFromValueFromRichTextEditor;
const RichEditor$1 = injectSheet(styles$B)(RichEditor);
const TYPE_ERROR = "error";
const SNACKBAR_TIMEOUT = 8e3;
const styles$A = (theme2) => ({
  root: {
    position: "fixed",
    bottom: 0,
    left: "50%",
    width: "55%",
    transform: "translateX(-50%) translateY(0)",
    backgroundColor: theme2.teal1,
    borderRadius: "5px 5px 0 0",
    color: theme2.white1,
    boxShadow: `0px 3px 20px rgba(48, 206, 202, 0.2)`,
    height: 60,
    fontSize: 14,
    lineHeight: "20px",
    textAlign: "center",
    transition: "transform 150ms linear",
    opacity: 1,
    zIndex: 6,
    padding: 10,
    display: "flex",
    flexFlow: "row nowrap",
    alignItems: "center",
    "& strong": {
      fontWeight: 800
    }
  },
  ready: {
    opacity: 0,
    transform: "translateX(-50%) translateY(100%)"
  },
  error: {
    backgroundColor: theme2.warningRed
  },
  btn: {
    flexShrink: 0,
    margin: "0 4px",
    color: theme2.white1,
    "&:focus": {
      outline: "none"
    }
  },
  message: {
    flexGrow: 1,
    overflow: "hidden",
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical"
  },
  clickBtn: {
    extend: "btn",
    border: `1px solid ${theme2.white1}`,
    borderRadius: 2,
    padding: "9px 15px",
    fontWeight: 600,
    fontSize: 11,
    lineHeight: "14px",
    textTransform: "uppercase"
  }
});
const SnackbarsContext = React__default.createContext(() => {
});
const withSnackbarsContext = (Component2) => (props2) => /* @__PURE__ */ jsx$1(SnackbarsContext.Consumer, { children: ({ successSnackbar, errorSnackbar, closeSnackbars }) => /* @__PURE__ */ jsx$1(
  Component2,
  {
    successSnackbar,
    errorSnackbar,
    closeSnackbars,
    ...props2
  }
) });
const defaultState = {
  messages: [],
  // We keep last message for display purposes, so that the message is still
  // written in the component during the transition.
  lastMessage: { message: "", type: "" },
  // is the component ready to display a new message, i.e. the last message has been already hidden.
  isReady: true
};
class Snackbars extends React__default.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", defaultState);
    __publicField(this, "componentDidUpdate", () => {
      const { isReady, messages: messages2 } = this.state;
      if (!isReady || !messages2.length) return;
      const msgs = [...messages2];
      const msg2 = msgs.shift();
      this.setState({ messages: msgs, lastMessage: msg2, isReady: false });
      this.timer = setTimeout(this.onReady, msg2.timeout || SNACKBAR_TIMEOUT);
    });
    __publicField(this, "componentWillUnmount", () => {
      if (this.timer) clearTimeout(this.timer);
    });
    __publicField(this, "onAddAlert", (msg2, clearStack) => {
      const { messages: messages2, isReady } = this.state;
      if (clearStack || isReady && !messages2.length) {
        this.setState({
          lastMessage: msg2,
          isReady: false,
          messages: clearStack ? [] : messages2
        });
        if (clearStack) clearTimeout(this.timer);
        this.timer = setTimeout(this.onReady, msg2.timeout || SNACKBAR_TIMEOUT);
      } else {
        this.setState({ messages: [...messages2, msg2] });
      }
    });
    __publicField(this, "onAddSuccessAlert", (message2, label, onClick, timeout, clearStack) => this.onAddAlert({ message: message2, label, onClick, timeout }, clearStack));
    __publicField(this, "onAddErrorAlert", (message2, timeout, clearStack) => this.onAddAlert({ message: message2, type: TYPE_ERROR, timeout }, clearStack));
    __publicField(this, "closeAll", () => {
      this.setState(defaultState);
      clearTimeout(this.timer);
    });
    __publicField(this, "onReady", () => {
      this.setState({ isReady: true });
    });
    __publicField(this, "handleClose", () => {
      this.onReady();
      clearTimeout(this.timer);
    });
    __publicField(this, "handleClick", () => {
      const {
        lastMessage: { onClick }
      } = this.state;
      onClick();
      this.setState({ isReady: true });
      clearTimeout(this.timer);
    });
    __publicField(this, "renderMessage", () => {
      const { classes } = this.props;
      const { lastMessage, isReady } = this.state;
      const rootClasses = classNames({
        [classes.root]: true,
        [classes.ready]: isReady,
        [classes.error]: lastMessage.type === TYPE_ERROR
      });
      const snackbarClasses = classNames({
        [classes.message]: true
      });
      const dataCy = `atomic-snackbar-${lastMessage.type === TYPE_ERROR ? "error" : "success"}`;
      return /* @__PURE__ */ jsxs("div", { className: rootClasses, children: [
        /* @__PURE__ */ jsx$1(
          "button",
          {
            className: classes.btn,
            onClick: this.handleClose,
            "data-cy": "close-btn",
            children: /* @__PURE__ */ jsx$1(Icon$2, { name: "Cross", size: 32 })
          }
        ),
        /* @__PURE__ */ jsx$1("div", { "data-cy": dataCy, className: snackbarClasses, children: parseBoldMarkdown(lastMessage.message) }),
        lastMessage.onClick && lastMessage.label && /* @__PURE__ */ jsx$1("button", { className: classes.clickBtn, onClick: this.handleClick, children: lastMessage.label })
      ] });
    });
  }
  render() {
    return /* @__PURE__ */ jsxs(
      SnackbarsContext.Provider,
      {
        value: {
          successSnackbar: this.onAddSuccessAlert,
          errorSnackbar: this.onAddErrorAlert,
          closeSnackbars: this.closeAll
        },
        children: [
          this.props.children,
          this.renderMessage()
        ]
      }
    );
  }
}
__publicField(Snackbars, "propTypes", {
  classes: PropTypes$1.object.isRequired,
  children: PropTypes$1.node.isRequired
});
const index$7 = injectSheet(styles$A)(Snackbars);
const styles$z = (theme2) => ({
  root: {
    display: "flex",
    alignItems: "center",
    marginRight: TAB_MARGIN_RIGHT,
    padding: "10px 0",
    fontSize: 12,
    color: theme2.grey1,
    "&[data-has-folder=true]": {
      padding: "15px 20px",
      borderRadius: "5px 5px 0px 0px",
      fontSize: 18,
      fontWeight: 700,
      color: theme2.grey4,
      marginRight: 0
    },
    "& span": {
      marginRight: 10,
      "&:empty": {
        display: "none"
      }
    },
    "&:hover": {
      cursor: "pointer"
    },
    "&:first-letter": {
      textTransform: "uppercase"
    },
    "&[data-is-active=true]&[data-has-folder=true]": {
      color: theme2.grey1,
      backgroundColor: "white"
    }
  }
});
const Tab = ({
  classes,
  uniqueKey,
  activeTab,
  label,
  onClick,
  folder,
  prefix: prefix2
}) => {
  const handleClick = (event) => onClick(event, uniqueKey);
  const rootProps = {
    className: classes.root,
    "data-is-active": activeTab === uniqueKey,
    "data-has-folder": folder,
    onClick: handleClick
  };
  return /* @__PURE__ */ jsxs("div", { ...rootProps, children: [
    /* @__PURE__ */ jsx$1("span", { children: prefix2 }),
    label
  ] });
};
Tab.propTypes = {
  classes: PropTypes$1.object.isRequired,
  uniqueKey: PropTypes$1.string.isRequired,
  activeTab: PropTypes$1.string.isRequired,
  label: PropTypes$1.string.isRequired,
  onClick: PropTypes$1.func.isRequired,
  folder: PropTypes$1.bool,
  prefix: PropTypes$1.node
};
Tab.defaultProps = {
  folder: false,
  prefix: ""
};
const Tab$1 = injectSheet(styles$z)(Tab);
const styles$y = (theme2) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme2.grey8,
    // Same Color as ModalHeader background
    paddingLeft: WRAPPER_PADDING_LEFT,
    "&[data-has-modal=true]": {
      paddingTop: 0
    },
    "&[data-has-folder=true]": {
      borderRadius: "5px 5px 0px 0px",
      backgroundColor: theme2.white,
      paddingLeft: 0
    }
  },
  tabsWrapper: {
    display: "flex"
  },
  tabsElement: {
    "&[data-has-folder=true]": {
      backgroundColor: "#ECEBF2",
      borderRadius: "5px 5px 0px 0px"
    }
  },
  slider: {
    position: "relative",
    borderBottom: `4px solid ${theme2.grey1}`,
    transition: "left 0.3s cubic-bezier(0.2, 0.86, 0.35, 1), width 0.3s cubic-bezier(0.3, 0.94, 0.21, 1.04);"
  },
  contentWrapper: {
    padding: 14,
    minHeight: 240,
    "&[data-is-centered=true]": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    "&[data-has-folder=true]": {
      backgroundColor: "white",
      padding: 20,
      overflow: "scroll",
      height: "93%"
    }
  }
});
const Tabs = ({ classes, tabs: rawTabs, slider, folder, centered }) => {
  const tabs = useMemo(
    () => rawTabs.reduce((acc, curr) => {
      acc.push({
        key: curr.key || curr.label,
        ...curr
      });
      return acc;
    }, []),
    [rawTabs]
  );
  const [activeTab, setActiveTab] = React__default.useState(tabs && tabs[0].key || "");
  const [sliderDimensions, setSliderDimensions] = React__default.useState({
    left: 0,
    width: 0
  });
  const tabRef = React__default.useRef(null);
  const wrapperRef = React__default.useRef(null);
  React__default.useEffect(() => {
    if (slider) {
      setSliderDimensions({
        left: 0,
        width: tabRef.current.offsetWidth - TAB_MARGIN_RIGHT
      });
    }
  }, [slider]);
  const handleClickItem = (event, key2) => {
    setActiveTab(key2);
    const tabLeftPosition = event.currentTarget.getBoundingClientRect().left;
    const wrapperLeftPosition = wrapperRef.current.getBoundingClientRect().left;
    setSliderDimensions({
      left: tabLeftPosition - wrapperLeftPosition - WRAPPER_PADDING_LEFT,
      width: event.currentTarget.getBoundingClientRect().width
    });
  };
  const contentWrapperProps = {
    className: classes.contentWrapper,
    "data-is-centered": centered,
    "data-has-folder": folder
  };
  return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { ref: wrapperRef, className: classes.root, "data-has-folder": folder, children: [
      /* @__PURE__ */ jsx$1("div", { className: classes.tabsWrapper, children: tabs.map((tab2, index2) => {
        const { key: key2, label, prefix: prefix2 } = tab2;
        const firstTabRef = index2 === 0 ? {
          ref: tabRef
        } : null;
        return /* @__PURE__ */ jsx$1(
          "div",
          {
            ...firstTabRef,
            className: classes.tabsElement,
            "data-has-folder": folder,
            children: /* @__PURE__ */ jsx$1(
              Tab$1,
              {
                uniqueKey: key2,
                activeTab,
                label,
                onClick: handleClickItem,
                prefix: prefix2,
                folder
              }
            )
          },
          key2
        );
      }) }),
      slider && /* @__PURE__ */ jsx$1(
        "div",
        {
          style: {
            left: sliderDimensions.left,
            width: sliderDimensions.width
          },
          className: classes.slider
        }
      )
    ] }),
    /* @__PURE__ */ jsx$1("div", { ...contentWrapperProps, children: Array.isArray(tabs) && tabs.map((tab2) => {
      if (tab2.key !== activeTab) return void 0;
      return /* @__PURE__ */ jsx$1(React__default.Fragment, { children: tab2.component }, tab2.key);
    }) })
  ] });
};
Tabs.propTypes = {
  classes: PropTypes$1.object.isRequired,
  tabs: PropTypes$1.arrayOf(
    PropTypes$1.shape({
      prefix: PropTypes$1.nodes,
      key: PropTypes$1.string,
      label: PropTypes$1.string,
      component: PropTypes$1.nodes
    })
  ).isRequired,
  slider: PropTypes$1.bool,
  folder: PropTypes$1.bool,
  centered: PropTypes$1.bool
};
Tabs.defaultProps = {
  slider: true,
  folder: false,
  centered: false
};
const index$6 = injectSheet(styles$y)(Tabs);
const ESCAPE = "Escape";
const ENTER = "Enter";
const ARROW_DOWN = "ArrowDown";
const ARROW_UP = "ArrowUp";
const scrollToRef = (ref2, smooth, delay2) => {
  const scrollFn = () => {
    const currentRef = ref2.current;
    if (currentRef) {
      currentRef.scrollIntoView({
        behavior: void 0,
        block: "nearest",
        inline: "center"
      });
    }
  };
  {
    scrollFn();
  }
};
const styles$x = (theme2) => ({
  item: {
    overflow: "hidden",
    cursor: "pointer",
    padding: "9px 10px",
    display: "flex",
    flexFlow: "row nowrap",
    alignItems: "center",
    "&[data-is-active=true]": {
      backgroundColor: theme2.indigoPastel3
    },
    "&[data-is-selected=true]": {
      color: theme2.grey1,
      backgroundColor: theme2.indigoPastel3
    },
    "&[data-is-selected=true][data-is-active=true]": {
      backgroundColor: theme2.indigoPastel2
    },
    "& strong": {
      fontWeight: "bold",
      color: theme2.grey1
    },
    "& label": {
      width: "100%"
    }
  },
  prefix: {
    marginRight: 10
  }
});
const FilteredItem = ({
  classes,
  index: index2,
  value,
  label,
  prefix: prefix2,
  transformedLabel,
  onSelect,
  isActive,
  activate,
  isSelected,
  multiselect
}) => {
  const itemRef = useRef(null);
  const onClick = useCallback(() => onSelect(value), [onSelect, value]);
  const onEnter = useCallback(() => activate(index2), [activate, index2]);
  useEffect(() => {
    if (isActive) {
      scrollToRef(itemRef);
    }
  }, [isActive]);
  if (multiselect) {
    return /* @__PURE__ */ jsx$1(
      "li",
      {
        ref: itemRef,
        className: classes.item,
        "data-is-active": isActive,
        "data-is-selected": isSelected,
        onMouseEnter: onEnter,
        title: label,
        children: /* @__PURE__ */ jsx$1(
          Check,
          {
            label: transformedLabel,
            checked: isSelected,
            showLabel: true,
            largeLabel: true,
            handleChange: onClick
          }
        )
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "li",
    {
      ref: itemRef,
      className: classes.item,
      "data-is-active": isActive,
      "data-is-selected": isSelected,
      onMouseEnter: onEnter,
      onClick,
      title: label,
      children: [
        prefix2 && /* @__PURE__ */ jsx$1("span", { className: classes.prefix, children: prefix2 }),
        transformedLabel
      ]
    }
  );
};
const FilteredItem$1 = injectSheet(styles$x)(memo(FilteredItem));
const styles$w = (theme2) => ({
  root: {
    width: "100%",
    height: 36,
    lineHeight: "17px",
    "& input": {
      paddingRight: 0,
      textOverflow: "ellipsis"
    },
    "&[data-embed-list=true]": {
      height: "unset"
    }
  },
  arrowIcon: {
    cursor: "pointer",
    color: theme2.indigo2,
    transition: "transform 0.3s ease-in-out, color 150ms linear 0ms",
    "&[data-is-down=true]": {
      transform: "rotate(180deg)",
      color: theme2.grey1
    }
  },
  clearIcon: {
    cursor: "pointer",
    color: theme2.grey1
  },
  searchIcon: {
    color: theme2.grey5
  },
  optionsList: {
    maxHeight: 200,
    position: "relative",
    top: 5,
    left: 0,
    zIndex: 3,
    border: `1px solid ${theme2.grey7}`,
    backgroundColor: "rgba(255,255,255, 0.9)",
    backdropFilter: "blur(10px) saturate(1.2)",
    borderRadius: 5,
    width: "fit-content",
    minWidth: "100%",
    fontSize: 14,
    lineHeight: "18px",
    color: theme2.grey3,
    whiteSpace: "pre",
    overflowX: "hidden",
    overflowY: "auto",
    "&::placeholder": {
      color: theme2.grey4
    },
    "&::-webkit-scrollbar": {
      cursor: "pointer",
      width: 5
    },
    "&::-webkit-scrollbar-track": {
      background: theme2.grey8,
      borderRadius: 10
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme2.grey4,
      borderRadius: 10,
      "&:hover": {
        background: theme2.grey3
      }
    },
    "&[data-has-shadows=true]": {
      border: "none",
      boxShadow: theme2.indigoShadow1
    }
  },
  noMatch: {
    overflow: "hidden",
    cursor: "not-allowed",
    padding: "11px 10px"
  },
  item: {
    overflow: "hidden",
    cursor: "pointer",
    padding: "9px 10px",
    display: "flex",
    flexFlow: "row nowrap",
    alignItems: "center",
    "&[data-is-active=true]": {
      backgroundColor: theme2.indigoPastel3
    },
    "& label": {
      width: "100%",
      "& > div": {
        fontWeight: "bold"
      }
    }
  }
});
function OnTop({
  refElement,
  children
}) {
  const [{ top, left, right }, setPosition] = useState({
    top: "auto",
    left: "auto",
    right: "auto"
  });
  useEffect(() => {
    const bodyOverflow = document.body.style.overflow;
    if (refElement) {
      const pos = refElement.getBoundingClientRect();
      setPosition({
        top: pos.top < VIEWPORT_MARGIN ? VIEWPORT_MARGIN : pos.top + pos.height,
        left: pos.left < VIEWPORT_MARGIN ? VIEWPORT_MARGIN : pos.left,
        right: window.innerWidth - pos.left - pos.width
      });
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = bodyOverflow;
    };
  }, [setPosition, refElement]);
  return /* @__PURE__ */ jsx$1("div", { style: { position: "fixed", left, top, right, zIndex: 10 }, children });
}
const OnTop$1 = memo(OnTop);
const SmartDropdown = ({
  classes,
  id: id2,
  dataCy = "smartDropdown",
  options,
  value,
  onSelect,
  label,
  placeholder,
  noMatchMessage,
  compact = false,
  disabled = false,
  invalid: invalid2 = false,
  // @ts-ignore only used within the stylesheet
  shadows = false,
  searchMode = false,
  embedList = false,
  multiselect = false
}) => {
  const usedId = useMemo(() => id2 || uniqueId$1("sdp_"), [id2]);
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const checkBoxRef = useRef(null);
  const itemRef = useRef(null);
  const [isFocused, setFocus] = useState(false);
  const [searchStr, setSearchStr] = useState("");
  const [activeOptionIdx, setActiveOptionIdx] = useState(0);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  useEffect(() => {
    if (multiselect) {
      const splitValue = value ? value == null ? void 0 : value.split(",") : [];
      setSelectedValues(splitValue);
    }
  }, [value, multiselect]);
  useEffect(() => {
    const filteredItems = options.filter(
      (item) => item.label.toLowerCase().includes(searchStr.toLowerCase())
    ).map((item) => item.value);
    const includesAll = filteredItems.every((v2) => selectedValues.includes(v2));
    if (includesAll && selectedValues.length > 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [searchStr, selectedValues]);
  useEffect(() => {
    if (activeOptionIdx === -1) {
      scrollToRef(itemRef);
    }
  }, [activeOptionIdx]);
  const updateSearchStr = useCallback((e5) => {
    const newValue = e5.target.value;
    setSearchStr(newValue);
    setActiveOptionIdx(0);
  }, []);
  const activateCurrentValue = useCallback(() => {
    if (value !== void 0) {
      const valueOptionIndex = options.findIndex(
        (option2) => option2.value === value
      );
      setActiveOptionIdx(Math.max(valueOptionIndex, 0));
    } else {
      setActiveOptionIdx(0);
    }
  }, [value, options, multiselect]);
  const focus2 = useCallback(() => {
    if (!disabled && !isFocused) {
      setFocus(true);
      activateCurrentValue();
      if (inputRef && inputRef.current) inputRef.current.focus();
    }
  }, [disabled, isFocused, activateCurrentValue]);
  const blur = useCallback(() => {
    setFocus(false);
    setActiveOptionIdx(0);
    setSearchStr("");
    if (inputRef && inputRef.current) inputRef.current.blur();
  }, []);
  const toggleFocus = useCallback(
    () => isFocused ? blur() : focus2(),
    [isFocused, focus2, blur]
  );
  useOnClickOutside(wrapperRef, blur);
  useKeyPress(ESCAPE, blur);
  const handleSelect = useCallback(
    (selectedValue) => {
      if (multiselect) {
        const updatedValues = selectedValues.includes(selectedValue) ? selectedValues.filter((val) => val !== selectedValue) : [...selectedValues, selectedValue];
        setSelectedValues(updatedValues);
        onSelect(updatedValues.join(","));
      } else {
        onSelect(selectedValue);
        blur();
      }
    },
    [onSelect, multiselect, selectedValues, blur]
  );
  const handleSelectAllChange = (checked) => {
    setSelectAll(checked);
    const filteredItems = options.filter(
      (item) => item.label.toLowerCase().includes(searchStr.toLowerCase())
    ).map((item) => item.value);
    if (checked) {
      const currentSelectedValues = filteredItems.filter(
        (item) => !selectedValues.includes(item)
      );
      const newSelectedValues = [...selectedValues, ...currentSelectedValues];
      setSelectedValues(newSelectedValues);
      onSelect(newSelectedValues.join(","));
    } else {
      const newSelectedValues = selectedValues.filter(
        (item) => !filteredItems.includes(item)
      );
      setSelectedValues(newSelectedValues);
      onSelect(newSelectedValues.join(","));
    }
  };
  const filteredOptions = useMemo(() => {
    if (!isFocused) return [];
    return options.reduce(
      (items2, { value: optionValue, label: optionLabel, prefix: optionPrefix }) => {
        const transformedLabel = parseSearchOccurencesInStr(
          optionLabel,
          searchStr
        );
        if (transformedLabel) {
          items2.push({
            optionValue,
            optionLabel,
            optionPrefix,
            transformedLabel
          });
        }
        return items2;
      },
      []
    );
  }, [isFocused, options, searchStr]);
  const navigateDown = useCallback(() => {
    if (filteredOptions.length && activeOptionIdx < filteredOptions.length - 1) {
      setActiveOptionIdx(activeOptionIdx + 1);
    }
  }, [activeOptionIdx, filteredOptions]);
  useKeyPress(ARROW_DOWN, navigateDown);
  const navigateUp = useCallback(() => {
    const hasSelectAllOption = searchStr && (filteredOptions == null ? void 0 : filteredOptions.length) > 0 && multiselect;
    const limitIdx = hasSelectAllOption ? -1 : 0;
    if (filteredOptions.length && activeOptionIdx > limitIdx) {
      setActiveOptionIdx(activeOptionIdx - 1);
    }
  }, [activeOptionIdx, filteredOptions, searchStr]);
  useKeyPress(ARROW_UP, navigateUp);
  const selectActiveOptionOnEnter = useCallback(() => {
    if (filteredOptions.length && activeOptionIdx >= 0) {
      handleSelect(filteredOptions[activeOptionIdx].optionValue);
    }
    if (activeOptionIdx < 0) {
      handleSelectAllChange(!checkBoxRef.current.checked);
    }
  }, [handleSelect, activeOptionIdx, filteredOptions]);
  useKeyPress(ENTER, selectActiveOptionOnEnter, inputRef.current);
  const { inputValue, inputPrefix } = useMemo(() => {
    if (isFocused) return { inputValue: searchStr };
    const currentOption = options.find((item) => item.value === value);
    return {
      inputValue: currentOption == null ? void 0 : currentOption.label,
      inputPrefix: currentOption == null ? void 0 : currentOption.prefix
    };
  }, [isFocused, searchStr, options, value]);
  const inputPlaceholder = useMemo(() => {
    if (isFocused && value !== void 0) {
      if (multiselect) {
        return selectedValues.map((val) => {
          var _a2;
          return (_a2 = options.find((option2) => option2.value === val)) == null ? void 0 : _a2.value;
        }).join(", ");
      }
      const valueOption = options.find((option2) => option2.value === value);
      if (valueOption) return valueOption.label;
    }
    return isFocused ? placeholder || label : label || placeholder;
  }, [isFocused, value, options, placeholder, label, selectedValues]);
  const isSearchSet = !!searchStr;
  const isValueSet = !!value;
  const clearSearch = useCallback(() => {
    if (!disabled) {
      if (inputRef && inputRef.current) {
        inputRef.current.focus();
      }
      if (isSearchSet) {
        setSearchStr("");
        activateCurrentValue();
      } else {
        onSelect("");
        setSelectedValues([]);
        setActiveOptionIdx(0);
      }
    }
  }, [disabled, onSelect, isSearchSet, activateCurrentValue]);
  const icon2 = useMemo(() => {
    if (searchMode) {
      return isSearchSet || isValueSet ? /* @__PURE__ */ jsx$1("span", { className: classes.clearIcon, onClick: clearSearch, children: /* @__PURE__ */ jsx$1(icons.Cross, { size: 25 }) }) : /* @__PURE__ */ jsx$1("span", { className: classes.searchIcon, children: /* @__PURE__ */ jsx$1(icons.Search, { size: 25 }) });
    }
    return (isSearchSet || isValueSet) && isFocused ? /* @__PURE__ */ jsx$1("span", { className: classes.clearIcon, onClick: clearSearch, children: /* @__PURE__ */ jsx$1(icons.Cross, { size: 25 }) }) : /* @__PURE__ */ jsx$1(
      "span",
      {
        className: classes.arrowIcon,
        "data-is-down": !isFocused,
        onClick: toggleFocus,
        children: /* @__PURE__ */ jsx$1(icons.ArrowMinTop, { size: 25 })
      }
    );
  }, [
    searchMode,
    isSearchSet,
    isValueSet,
    isFocused,
    clearSearch,
    toggleFocus,
    classes
  ]);
  let status = null;
  if (invalid2) {
    status = STATUS_INVALID;
  }
  const inputProps = {
    id: usedId,
    dataCy,
    value: inputValue || "",
    type: "text",
    placeholder: inputPlaceholder,
    inputRef,
    prefix: inputPrefix,
    suffix: icon2,
    handleChange: updateSearchStr,
    handleFocus: focus2,
    status,
    disabled,
    chips: !isFocused && multiselect,
    removeChip: (_chip) => {
    }
  };
  if (!isFocused && multiselect) {
    inputProps.value = selectedValues.join(", ");
    inputProps.removeChip = (chip) => {
      const updatedValues = selectedValues.filter((val) => val !== chip);
      setSelectedValues(updatedValues);
      onSelect(updatedValues.join(","));
    };
  }
  let input = /* @__PURE__ */ jsx$1(Textinput$1, { ...inputProps });
  if (compact && !!label) {
    const labelProps = {
      text: label,
      forId: usedId,
      inputHasFocus: isFocused,
      inputHasValue: isValueSet || !!inputValue,
      status
    };
    input = /* @__PURE__ */ jsx$1(Smartlabel$1, { ...labelProps, children: input });
  }
  return /* @__PURE__ */ jsxs("div", { className: classes.root, ref: wrapperRef, "data-embed-list": embedList, children: [
    input,
    isFocused && /* @__PURE__ */ jsx$1(OnTop$1, { refElement: wrapperRef.current, children: /* @__PURE__ */ jsxs("ul", { className: classes.optionsList, "data-has-shadows": shadows, children: [
      searchStr && (filteredOptions == null ? void 0 : filteredOptions.length) > 0 && multiselect && /* @__PURE__ */ jsx$1(
        "li",
        {
          className: classes.item,
          "data-is-active": activeOptionIdx === -1,
          onMouseEnter: () => setActiveOptionIdx(-1),
          ref: itemRef,
          children: /* @__PURE__ */ jsx$1(
            Check,
            {
              inputRef: checkBoxRef,
              label: "Select all search results",
              checked: selectAll,
              showLabel: true,
              largeLabel: true,
              handleChange: (evt) => handleSelectAllChange(evt.target.checked)
            }
          )
        }
      ),
      !(filteredOptions == null ? void 0 : filteredOptions.length) ? /* @__PURE__ */ jsx$1("li", { className: classes.noMatch, children: noMatchMessage || "No match..." }) : filteredOptions.map(
        ({ optionValue, optionLabel, optionPrefix, transformedLabel }, idx) => /* @__PURE__ */ jsx$1(
          FilteredItem$1,
          {
            index: idx,
            value: optionValue,
            label: optionLabel,
            prefix: optionPrefix,
            transformedLabel,
            onSelect: handleSelect,
            isActive: idx === activeOptionIdx,
            activate: setActiveOptionIdx,
            isSelected: selectedValues.includes(optionValue),
            multiselect
          },
          idx
        )
      )
    ] }) })
  ] });
};
const SmartDropdown$1 = injectSheet(styles$w)(memo(SmartDropdown));
const styles$v = (theme2) => {
  const sharedStyles = pushbuttonStyles(theme2);
  return {
    root: {
      ...sharedStyles.root,
      textDecoration: "none",
      '&[data-is-disabled="true"]': {
        opacity: 0.6
      }
    },
    prefix: {
      ...sharedStyles.prefix
    },
    suffix: {
      ...sharedStyles.suffix
    },
    text: {
      ...sharedStyles.text
    }
  };
};
const PushbuttonHref = ({
  classes,
  children,
  href,
  buttonRef: ref2 = null,
  primary = false,
  secondary = false,
  warning: warning2 = false,
  disabled = false,
  external = false,
  prefix: prefix2 = null,
  suffix = null
}) => {
  const buttonChildren = useMemo(
    () => /* @__PURE__ */ jsxs(Fragment$1, { children: [
      prefix2 && /* @__PURE__ */ jsx$1("span", { className: classes.prefix, children: prefix2 }),
      /* @__PURE__ */ jsx$1("span", { className: classes.text, children }),
      suffix && /* @__PURE__ */ jsx$1("span", { className: classes.suffix, children: suffix })
    ] }),
    [children, classes.prefix, classes.suffix, classes.text, prefix2, suffix]
  );
  const rootPropsShared = {
    className: classes.root,
    "data-is-primary": primary,
    "data-is-secondary": secondary,
    "data-is-warning": warning2
  };
  if (disabled) {
    return /* @__PURE__ */ jsx$1("div", { ...rootPropsShared, "data-is-disabled": "true", children: buttonChildren });
  }
  const rootProps = {
    ...rootPropsShared,
    href,
    role: "button",
    ref: ref2
  };
  if (external) {
    rootProps.rel = "external";
    rootProps.target = "_blank";
  }
  return /* @__PURE__ */ jsx$1("a", { ...rootProps, children: buttonChildren });
};
const index$5 = injectSheet(styles$v)(PushbuttonHref);
var __extends$1 = /* @__PURE__ */ function() {
  var extendStatics = function(d4, b3) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d5, b4) {
      d5.__proto__ = b4;
    } || function(d5, b4) {
      for (var p2 in b4) if (Object.prototype.hasOwnProperty.call(b4, p2)) d5[p2] = b4[p2];
    };
    return extendStatics(d4, b3);
  };
  return function(d4, b3) {
    extendStatics(d4, b3);
    function __() {
      this.constructor = d4;
    }
    d4.prototype = b3 === null ? Object.create(b3) : (__.prototype = b3.prototype, new __());
  };
}();
var __assign$1 = function() {
  __assign$1 = Object.assign || function(t3) {
    for (var s4, i3 = 1, n2 = arguments.length; i3 < n2; i3++) {
      s4 = arguments[i3];
      for (var p2 in s4) if (Object.prototype.hasOwnProperty.call(s4, p2))
        t3[p2] = s4[p2];
    }
    return t3;
  };
  return __assign$1.apply(this, arguments);
};
var rowSizeBase = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
};
var colSizeBase = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
};
var edgeBase = {
  width: "20px",
  height: "20px",
  position: "absolute"
};
var styles$u = {
  top: __assign$1(__assign$1({}, rowSizeBase), { top: "-5px" }),
  right: __assign$1(__assign$1({}, colSizeBase), { left: void 0, right: "-5px" }),
  bottom: __assign$1(__assign$1({}, rowSizeBase), { top: void 0, bottom: "-5px" }),
  left: __assign$1(__assign$1({}, colSizeBase), { left: "-5px" }),
  topRight: __assign$1(__assign$1({}, edgeBase), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: __assign$1(__assign$1({}, edgeBase), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: __assign$1(__assign$1({}, edgeBase), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: __assign$1(__assign$1({}, edgeBase), { left: "-10px", top: "-10px", cursor: "nw-resize" })
};
var Resizer = (
  /** @class */
  function(_super) {
    __extends$1(Resizer2, _super);
    function Resizer2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.onMouseDown = function(e5) {
        _this.props.onResizeStart(e5, _this.props.direction);
      };
      _this.onTouchStart = function(e5) {
        _this.props.onResizeStart(e5, _this.props.direction);
      };
      return _this;
    }
    Resizer2.prototype.render = function() {
      return React$2.createElement("div", { className: this.props.className || "", style: __assign$1(__assign$1({ position: "absolute", userSelect: "none" }, styles$u[this.props.direction]), this.props.replaceStyles || {}), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children);
    };
    return Resizer2;
  }(React$2.PureComponent)
);
var __extends = /* @__PURE__ */ function() {
  var extendStatics = function(d4, b3) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d5, b4) {
      d5.__proto__ = b4;
    } || function(d5, b4) {
      for (var p2 in b4) if (Object.prototype.hasOwnProperty.call(b4, p2)) d5[p2] = b4[p2];
    };
    return extendStatics(d4, b3);
  };
  return function(d4, b3) {
    extendStatics(d4, b3);
    function __() {
      this.constructor = d4;
    }
    d4.prototype = b3 === null ? Object.create(b3) : (__.prototype = b3.prototype, new __());
  };
}();
var __assign = function() {
  __assign = Object.assign || function(t3) {
    for (var s4, i3 = 1, n2 = arguments.length; i3 < n2; i3++) {
      s4 = arguments[i3];
      for (var p2 in s4) if (Object.prototype.hasOwnProperty.call(s4, p2))
        t3[p2] = s4[p2];
    }
    return t3;
  };
  return __assign.apply(this, arguments);
};
var DEFAULT_SIZE = {
  width: "auto",
  height: "auto"
};
var clamp = function(n2, min2, max2) {
  return Math.max(Math.min(n2, max2), min2);
};
var snap = function(n2, size2) {
  return Math.round(n2 / size2) * size2;
};
var hasDirection = function(dir, target) {
  return new RegExp(dir, "i").test(target);
};
var isTouchEvent = function(event) {
  return Boolean(event.touches && event.touches.length);
};
var isMouseEvent = function(event) {
  return Boolean((event.clientX || event.clientX === 0) && (event.clientY || event.clientY === 0));
};
var findClosestSnap = function(n2, snapArray, snapGap) {
  if (snapGap === void 0) {
    snapGap = 0;
  }
  var closestGapIndex = snapArray.reduce(function(prev, curr, index2) {
    return Math.abs(curr - n2) < Math.abs(snapArray[prev] - n2) ? index2 : prev;
  }, 0);
  var gap = Math.abs(snapArray[closestGapIndex] - n2);
  return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n2;
};
var getStringSize = function(n2) {
  n2 = n2.toString();
  if (n2 === "auto") {
    return n2;
  }
  if (n2.endsWith("px")) {
    return n2;
  }
  if (n2.endsWith("%")) {
    return n2;
  }
  if (n2.endsWith("vh")) {
    return n2;
  }
  if (n2.endsWith("vw")) {
    return n2;
  }
  if (n2.endsWith("vmax")) {
    return n2;
  }
  if (n2.endsWith("vmin")) {
    return n2;
  }
  return n2 + "px";
};
var getPixelSize = function(size2, parentSize, innerWidth2, innerHeight2) {
  if (size2 && typeof size2 === "string") {
    if (size2.endsWith("px")) {
      return Number(size2.replace("px", ""));
    }
    if (size2.endsWith("%")) {
      var ratio = Number(size2.replace("%", "")) / 100;
      return parentSize * ratio;
    }
    if (size2.endsWith("vw")) {
      var ratio = Number(size2.replace("vw", "")) / 100;
      return innerWidth2 * ratio;
    }
    if (size2.endsWith("vh")) {
      var ratio = Number(size2.replace("vh", "")) / 100;
      return innerHeight2 * ratio;
    }
  }
  return size2;
};
var calculateNewMax = function(parentSize, innerWidth2, innerHeight2, maxWidth, maxHeight, minWidth, minHeight) {
  maxWidth = getPixelSize(maxWidth, parentSize.width, innerWidth2, innerHeight2);
  maxHeight = getPixelSize(maxHeight, parentSize.height, innerWidth2, innerHeight2);
  minWidth = getPixelSize(minWidth, parentSize.width, innerWidth2, innerHeight2);
  minHeight = getPixelSize(minHeight, parentSize.height, innerWidth2, innerHeight2);
  return {
    maxWidth: typeof maxWidth === "undefined" ? void 0 : Number(maxWidth),
    maxHeight: typeof maxHeight === "undefined" ? void 0 : Number(maxHeight),
    minWidth: typeof minWidth === "undefined" ? void 0 : Number(minWidth),
    minHeight: typeof minHeight === "undefined" ? void 0 : Number(minHeight)
  };
};
var normalizeToPair = function(val) {
  return Array.isArray(val) ? val : [val, val];
};
var definedProps = [
  "as",
  "ref",
  "style",
  "className",
  "grid",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
];
var baseClassName = "__resizable_base__";
var Resizable = (
  /** @class */
  function(_super) {
    __extends(Resizable2, _super);
    function Resizable2(props2) {
      var _a2, _b2, _c2, _d2;
      var _this = _super.call(this, props2) || this;
      _this.ratio = 1;
      _this.resizable = null;
      _this.parentLeft = 0;
      _this.parentTop = 0;
      _this.resizableLeft = 0;
      _this.resizableRight = 0;
      _this.resizableTop = 0;
      _this.resizableBottom = 0;
      _this.targetLeft = 0;
      _this.targetTop = 0;
      _this.appendBase = function() {
        if (!_this.resizable || !_this.window) {
          return null;
        }
        var parent3 = _this.parentNode;
        if (!parent3) {
          return null;
        }
        var element = _this.window.document.createElement("div");
        element.style.width = "100%";
        element.style.height = "100%";
        element.style.position = "absolute";
        element.style.transform = "scale(0, 0)";
        element.style.left = "0";
        element.style.flex = "0 0 100%";
        if (element.classList) {
          element.classList.add(baseClassName);
        } else {
          element.className += baseClassName;
        }
        parent3.appendChild(element);
        return element;
      };
      _this.removeBase = function(base) {
        var parent3 = _this.parentNode;
        if (!parent3) {
          return;
        }
        parent3.removeChild(base);
      };
      _this.state = {
        isResizing: false,
        width: (_b2 = (_a2 = _this.propsSize) === null || _a2 === void 0 ? void 0 : _a2.width) !== null && _b2 !== void 0 ? _b2 : "auto",
        height: (_d2 = (_c2 = _this.propsSize) === null || _c2 === void 0 ? void 0 : _c2.height) !== null && _d2 !== void 0 ? _d2 : "auto",
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      };
      _this.onResizeStart = _this.onResizeStart.bind(_this);
      _this.onMouseMove = _this.onMouseMove.bind(_this);
      _this.onMouseUp = _this.onMouseUp.bind(_this);
      return _this;
    }
    Object.defineProperty(Resizable2.prototype, "parentNode", {
      get: function() {
        if (!this.resizable) {
          return null;
        }
        return this.resizable.parentNode;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Resizable2.prototype, "window", {
      get: function() {
        if (!this.resizable) {
          return null;
        }
        if (!this.resizable.ownerDocument) {
          return null;
        }
        return this.resizable.ownerDocument.defaultView;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Resizable2.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || DEFAULT_SIZE;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Resizable2.prototype, "size", {
      get: function() {
        var width = 0;
        var height = 0;
        if (this.resizable && this.window) {
          var orgWidth = this.resizable.offsetWidth;
          var orgHeight = this.resizable.offsetHeight;
          var orgPosition = this.resizable.style.position;
          if (orgPosition !== "relative") {
            this.resizable.style.position = "relative";
          }
          width = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : orgWidth;
          height = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : orgHeight;
          this.resizable.style.position = orgPosition;
        }
        return { width, height };
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Resizable2.prototype, "sizeStyle", {
      get: function() {
        var _this = this;
        var size2 = this.props.size;
        var getSize2 = function(key2) {
          var _a2;
          if (typeof _this.state[key2] === "undefined" || _this.state[key2] === "auto") {
            return "auto";
          }
          if (_this.propsSize && _this.propsSize[key2] && ((_a2 = _this.propsSize[key2]) === null || _a2 === void 0 ? void 0 : _a2.toString().endsWith("%"))) {
            if (_this.state[key2].toString().endsWith("%")) {
              return _this.state[key2].toString();
            }
            var parentSize = _this.getParentSize();
            var value = Number(_this.state[key2].toString().replace("px", ""));
            var percent = value / parentSize[key2] * 100;
            return percent + "%";
          }
          return getStringSize(_this.state[key2]);
        };
        var width = size2 && typeof size2.width !== "undefined" && !this.state.isResizing ? getStringSize(size2.width) : getSize2("width");
        var height = size2 && typeof size2.height !== "undefined" && !this.state.isResizing ? getStringSize(size2.height) : getSize2("height");
        return { width, height };
      },
      enumerable: false,
      configurable: true
    });
    Resizable2.prototype.getParentSize = function() {
      if (!this.parentNode) {
        if (!this.window) {
          return { width: 0, height: 0 };
        }
        return { width: this.window.innerWidth, height: this.window.innerHeight };
      }
      var base = this.appendBase();
      if (!base) {
        return { width: 0, height: 0 };
      }
      var wrapChanged = false;
      var wrap2 = this.parentNode.style.flexWrap;
      if (wrap2 !== "wrap") {
        wrapChanged = true;
        this.parentNode.style.flexWrap = "wrap";
      }
      base.style.position = "relative";
      base.style.minWidth = "100%";
      base.style.minHeight = "100%";
      var size2 = {
        width: base.offsetWidth,
        height: base.offsetHeight
      };
      if (wrapChanged) {
        this.parentNode.style.flexWrap = wrap2;
      }
      this.removeBase(base);
      return size2;
    };
    Resizable2.prototype.bindEvents = function() {
      if (this.window) {
        this.window.addEventListener("mouseup", this.onMouseUp);
        this.window.addEventListener("mousemove", this.onMouseMove);
        this.window.addEventListener("mouseleave", this.onMouseUp);
        this.window.addEventListener("touchmove", this.onMouseMove, {
          capture: true,
          passive: false
        });
        this.window.addEventListener("touchend", this.onMouseUp);
      }
    };
    Resizable2.prototype.unbindEvents = function() {
      if (this.window) {
        this.window.removeEventListener("mouseup", this.onMouseUp);
        this.window.removeEventListener("mousemove", this.onMouseMove);
        this.window.removeEventListener("mouseleave", this.onMouseUp);
        this.window.removeEventListener("touchmove", this.onMouseMove, true);
        this.window.removeEventListener("touchend", this.onMouseUp);
      }
    };
    Resizable2.prototype.componentDidMount = function() {
      if (!this.resizable || !this.window) {
        return;
      }
      var computedStyle = this.window.getComputedStyle(this.resizable);
      this.setState({
        width: this.state.width || this.size.width,
        height: this.state.height || this.size.height,
        flexBasis: computedStyle.flexBasis !== "auto" ? computedStyle.flexBasis : void 0
      });
    };
    Resizable2.prototype.componentWillUnmount = function() {
      if (this.window) {
        this.unbindEvents();
      }
    };
    Resizable2.prototype.createSizeForCssProperty = function(newSize, kind) {
      var propsSize = this.propsSize && this.propsSize[kind];
      return this.state[kind] === "auto" && this.state.original[kind] === newSize && (typeof propsSize === "undefined" || propsSize === "auto") ? "auto" : newSize;
    };
    Resizable2.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
      var boundsByDirection = this.props.boundsByDirection;
      var direction2 = this.state.direction;
      var widthByDirection = boundsByDirection && hasDirection("left", direction2);
      var heightByDirection = boundsByDirection && hasDirection("top", direction2);
      var boundWidth;
      var boundHeight;
      if (this.props.bounds === "parent") {
        var parent_1 = this.parentNode;
        if (parent_1) {
          boundWidth = widthByDirection ? this.resizableRight - this.parentLeft : parent_1.offsetWidth + (this.parentLeft - this.resizableLeft);
          boundHeight = heightByDirection ? this.resizableBottom - this.parentTop : parent_1.offsetHeight + (this.parentTop - this.resizableTop);
        }
      } else if (this.props.bounds === "window") {
        if (this.window) {
          boundWidth = widthByDirection ? this.resizableRight : this.window.innerWidth - this.resizableLeft;
          boundHeight = heightByDirection ? this.resizableBottom : this.window.innerHeight - this.resizableTop;
        }
      } else if (this.props.bounds) {
        boundWidth = widthByDirection ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
        boundHeight = heightByDirection ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
      }
      if (boundWidth && Number.isFinite(boundWidth)) {
        maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
      }
      if (boundHeight && Number.isFinite(boundHeight)) {
        maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
      }
      return { maxWidth, maxHeight };
    };
    Resizable2.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
      var scale = this.props.scale || 1;
      var _a2 = normalizeToPair(this.props.resizeRatio || 1), resizeRatioX = _a2[0], resizeRatioY = _a2[1];
      var _b2 = this.state, direction2 = _b2.direction, original = _b2.original;
      var _c2 = this.props, lockAspectRatio = _c2.lockAspectRatio, lockAspectRatioExtraHeight = _c2.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _c2.lockAspectRatioExtraWidth;
      var newWidth = original.width;
      var newHeight = original.height;
      var extraHeight = lockAspectRatioExtraHeight || 0;
      var extraWidth = lockAspectRatioExtraWidth || 0;
      if (hasDirection("right", direction2)) {
        newWidth = original.width + (clientX - original.x) * resizeRatioX / scale;
        if (lockAspectRatio) {
          newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
      }
      if (hasDirection("left", direction2)) {
        newWidth = original.width - (clientX - original.x) * resizeRatioX / scale;
        if (lockAspectRatio) {
          newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
      }
      if (hasDirection("bottom", direction2)) {
        newHeight = original.height + (clientY - original.y) * resizeRatioY / scale;
        if (lockAspectRatio) {
          newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
      }
      if (hasDirection("top", direction2)) {
        newHeight = original.height - (clientY - original.y) * resizeRatioY / scale;
        if (lockAspectRatio) {
          newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
      }
      return { newWidth, newHeight };
    };
    Resizable2.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max2, min2) {
      var _a2 = this.props, lockAspectRatio = _a2.lockAspectRatio, lockAspectRatioExtraHeight = _a2.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a2.lockAspectRatioExtraWidth;
      var computedMinWidth = typeof min2.width === "undefined" ? 10 : min2.width;
      var computedMaxWidth = typeof max2.width === "undefined" || max2.width < 0 ? newWidth : max2.width;
      var computedMinHeight = typeof min2.height === "undefined" ? 10 : min2.height;
      var computedMaxHeight = typeof max2.height === "undefined" || max2.height < 0 ? newHeight : max2.height;
      var extraHeight = lockAspectRatioExtraHeight || 0;
      var extraWidth = lockAspectRatioExtraWidth || 0;
      if (lockAspectRatio) {
        var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
        var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
        var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
        var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
        var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
        var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
        var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
        var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
        newWidth = clamp(newWidth, lockedMinWidth, lockedMaxWidth);
        newHeight = clamp(newHeight, lockedMinHeight, lockedMaxHeight);
      } else {
        newWidth = clamp(newWidth, computedMinWidth, computedMaxWidth);
        newHeight = clamp(newHeight, computedMinHeight, computedMaxHeight);
      }
      return { newWidth, newHeight };
    };
    Resizable2.prototype.setBoundingClientRect = function() {
      if (this.props.bounds === "parent") {
        var parent_2 = this.parentNode;
        if (parent_2) {
          var parentRect = parent_2.getBoundingClientRect();
          this.parentLeft = parentRect.left;
          this.parentTop = parentRect.top;
        }
      }
      if (this.props.bounds && typeof this.props.bounds !== "string") {
        var targetRect = this.props.bounds.getBoundingClientRect();
        this.targetLeft = targetRect.left;
        this.targetTop = targetRect.top;
      }
      if (this.resizable) {
        var _a2 = this.resizable.getBoundingClientRect(), left = _a2.left, top_1 = _a2.top, right = _a2.right, bottom = _a2.bottom;
        this.resizableLeft = left;
        this.resizableRight = right;
        this.resizableTop = top_1;
        this.resizableBottom = bottom;
      }
    };
    Resizable2.prototype.onResizeStart = function(event, direction2) {
      if (!this.resizable || !this.window) {
        return;
      }
      var clientX = 0;
      var clientY = 0;
      if (event.nativeEvent && isMouseEvent(event.nativeEvent)) {
        clientX = event.nativeEvent.clientX;
        clientY = event.nativeEvent.clientY;
      } else if (event.nativeEvent && isTouchEvent(event.nativeEvent)) {
        clientX = event.nativeEvent.touches[0].clientX;
        clientY = event.nativeEvent.touches[0].clientY;
      }
      if (this.props.onResizeStart) {
        if (this.resizable) {
          var startResize = this.props.onResizeStart(event, direction2, this.resizable);
          if (startResize === false) {
            return;
          }
        }
      }
      if (this.props.size) {
        if (typeof this.props.size.height !== "undefined" && this.props.size.height !== this.state.height) {
          this.setState({ height: this.props.size.height });
        }
        if (typeof this.props.size.width !== "undefined" && this.props.size.width !== this.state.width) {
          this.setState({ width: this.props.size.width });
        }
      }
      this.ratio = typeof this.props.lockAspectRatio === "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
      var flexBasis;
      var computedStyle = this.window.getComputedStyle(this.resizable);
      if (computedStyle.flexBasis !== "auto") {
        var parent_3 = this.parentNode;
        if (parent_3) {
          var dir = this.window.getComputedStyle(parent_3).flexDirection;
          this.flexDir = dir.startsWith("row") ? "row" : "column";
          flexBasis = computedStyle.flexBasis;
        }
      }
      this.setBoundingClientRect();
      this.bindEvents();
      var state = {
        original: {
          x: clientX,
          y: clientY,
          width: this.size.width,
          height: this.size.height
        },
        isResizing: true,
        backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(event.target).cursor || "auto" }),
        direction: direction2,
        flexBasis
      };
      this.setState(state);
    };
    Resizable2.prototype.onMouseMove = function(event) {
      var _this = this;
      if (!this.state.isResizing || !this.resizable || !this.window) {
        return;
      }
      if (this.window.TouchEvent && isTouchEvent(event)) {
        try {
          event.preventDefault();
          event.stopPropagation();
        } catch (e5) {
        }
      }
      var _a2 = this.props, maxWidth = _a2.maxWidth, maxHeight = _a2.maxHeight, minWidth = _a2.minWidth, minHeight = _a2.minHeight;
      var clientX = isTouchEvent(event) ? event.touches[0].clientX : event.clientX;
      var clientY = isTouchEvent(event) ? event.touches[0].clientY : event.clientY;
      var _b2 = this.state, direction2 = _b2.direction, original = _b2.original, width = _b2.width, height = _b2.height;
      var parentSize = this.getParentSize();
      var max2 = calculateNewMax(parentSize, this.window.innerWidth, this.window.innerHeight, maxWidth, maxHeight, minWidth, minHeight);
      maxWidth = max2.maxWidth;
      maxHeight = max2.maxHeight;
      minWidth = max2.minWidth;
      minHeight = max2.minHeight;
      var _c2 = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c2.newHeight, newWidth = _c2.newWidth;
      var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
      if (this.props.snap && this.props.snap.x) {
        newWidth = findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
      }
      if (this.props.snap && this.props.snap.y) {
        newHeight = findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
      }
      var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, { width: boundaryMax.maxWidth, height: boundaryMax.maxHeight }, { width: minWidth, height: minHeight });
      newWidth = newSize.newWidth;
      newHeight = newSize.newHeight;
      if (this.props.grid) {
        var newGridWidth = snap(newWidth, this.props.grid[0]);
        var newGridHeight = snap(newHeight, this.props.grid[1]);
        var gap = this.props.snapGap || 0;
        var w3 = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
        var h4 = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        newWidth = w3;
        newHeight = h4;
      }
      var delta = {
        width: newWidth - original.width,
        height: newHeight - original.height
      };
      if (width && typeof width === "string") {
        if (width.endsWith("%")) {
          var percent = newWidth / parentSize.width * 100;
          newWidth = percent + "%";
        } else if (width.endsWith("vw")) {
          var vw = newWidth / this.window.innerWidth * 100;
          newWidth = vw + "vw";
        } else if (width.endsWith("vh")) {
          var vh = newWidth / this.window.innerHeight * 100;
          newWidth = vh + "vh";
        }
      }
      if (height && typeof height === "string") {
        if (height.endsWith("%")) {
          var percent = newHeight / parentSize.height * 100;
          newHeight = percent + "%";
        } else if (height.endsWith("vw")) {
          var vw = newHeight / this.window.innerWidth * 100;
          newHeight = vw + "vw";
        } else if (height.endsWith("vh")) {
          var vh = newHeight / this.window.innerHeight * 100;
          newHeight = vh + "vh";
        }
      }
      var newState = {
        width: this.createSizeForCssProperty(newWidth, "width"),
        height: this.createSizeForCssProperty(newHeight, "height")
      };
      if (this.flexDir === "row") {
        newState.flexBasis = newState.width;
      } else if (this.flexDir === "column") {
        newState.flexBasis = newState.height;
      }
      var widthChanged = this.state.width !== newState.width;
      var heightChanged = this.state.height !== newState.height;
      var flexBaseChanged = this.state.flexBasis !== newState.flexBasis;
      var changed = widthChanged || heightChanged || flexBaseChanged;
      if (changed) {
        flushSync(function() {
          _this.setState(newState);
        });
      }
      if (this.props.onResize) {
        if (changed) {
          this.props.onResize(event, direction2, this.resizable, delta);
        }
      }
    };
    Resizable2.prototype.onMouseUp = function(event) {
      var _a2, _b2;
      var _c2 = this.state, isResizing = _c2.isResizing, direction2 = _c2.direction, original = _c2.original;
      if (!isResizing || !this.resizable) {
        return;
      }
      var delta = {
        width: this.size.width - original.width,
        height: this.size.height - original.height
      };
      if (this.props.onResizeStop) {
        this.props.onResizeStop(event, direction2, this.resizable, delta);
      }
      if (this.props.size) {
        this.setState({ width: (_a2 = this.props.size.width) !== null && _a2 !== void 0 ? _a2 : "auto", height: (_b2 = this.props.size.height) !== null && _b2 !== void 0 ? _b2 : "auto" });
      }
      this.unbindEvents();
      this.setState({
        isResizing: false,
        backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: "auto" })
      });
    };
    Resizable2.prototype.updateSize = function(size2) {
      var _a2, _b2;
      this.setState({ width: (_a2 = size2.width) !== null && _a2 !== void 0 ? _a2 : "auto", height: (_b2 = size2.height) !== null && _b2 !== void 0 ? _b2 : "auto" });
    };
    Resizable2.prototype.renderResizer = function() {
      var _this = this;
      var _a2 = this.props, enable = _a2.enable, handleStyles = _a2.handleStyles, handleClasses = _a2.handleClasses, handleWrapperStyle = _a2.handleWrapperStyle, handleWrapperClass = _a2.handleWrapperClass, handleComponent = _a2.handleComponent;
      if (!enable) {
        return null;
      }
      var resizers = Object.keys(enable).map(function(dir) {
        if (enable[dir] !== false) {
          return React$2.createElement(Resizer, { key: dir, direction: dir, onResizeStart: _this.onResizeStart, replaceStyles: handleStyles && handleStyles[dir], className: handleClasses && handleClasses[dir] }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
        }
        return null;
      });
      return React$2.createElement("div", { className: handleWrapperClass, style: handleWrapperStyle }, resizers);
    };
    Resizable2.prototype.render = function() {
      var _this = this;
      var extendsProps = Object.keys(this.props).reduce(function(acc, key2) {
        if (definedProps.indexOf(key2) !== -1) {
          return acc;
        }
        acc[key2] = _this.props[key2];
        return acc;
      }, {});
      var style2 = __assign(__assign(__assign({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      if (this.state.flexBasis) {
        style2.flexBasis = this.state.flexBasis;
      }
      var Wrapper = this.props.as || "div";
      return React$2.createElement(
        Wrapper,
        __assign({ style: style2, className: this.props.className }, extendsProps, {
          // `ref` is after `extendsProps` to ensure this one wins over a version
          // passed in
          ref: function(c3) {
            if (c3) {
              _this.resizable = c3;
            }
          }
        }),
        this.state.isResizing && React$2.createElement("div", { style: this.state.backgroundStyle }),
        this.props.children,
        this.renderResizer()
      );
    };
    Resizable2.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: true,
        right: true,
        bottom: true,
        left: true,
        topRight: true,
        bottomRight: true,
        bottomLeft: true,
        topLeft: true
      },
      style: {},
      grid: [1, 1],
      lockAspectRatio: false,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    };
    return Resizable2;
  }(React$2.PureComponent)
);
const styles$t = (theme2) => ({
  tray: {
    backgroundColor: theme2.white1,
    boxShadow: theme2.indigoShadow1,
    display: "flex",
    flexFlow: "column nowrap"
  },
  handleWrapper: {
    zIndex: TRAY_HANDLE_ZINDEX
  },
  trayTitleContainer: {
    flexShrink: 0,
    height: 70,
    width: "100%",
    padding: 10,
    display: "flex",
    flexFlow: "row-reverse nowrap",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: `1px solid ${theme2.grey6}`,
    "&[data-is-collapsed=true]": {
      borderBottom: "none"
    },
    "&[data-is-inverted=true]": {
      flexFlow: "row nowrap"
    }
  },
  trayCollapseIcon: {
    flexShrink: 0,
    cursor: "pointer",
    color: theme2.grey3,
    transition: "transform .25s, color .25s",
    "&:hover": {
      color: theme2.grey1
    },
    "&[data-is-collapsed=true]": {
      transform: "rotate(-180deg)"
    },
    "&[data-is-inverted=true]": {
      transform: "rotate(-180deg)",
      "&[data-is-collapsed=true]": {
        transform: "rotate(0deg)"
      }
    }
  },
  trayTitle: {
    fontSize: 18,
    lineHeight: "25px",
    marginRight: 10,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    fontWeight: 600,
    "& strong": {
      color: theme2.indigo3
    }
  },
  trayBody: {
    flexGrow: 1,
    overflow: "hidden",
    display: "flex",
    flexFlow: "column nowrap",
    "&[data-is-hidden=true]": {
      visibility: "hidden",
      height: 0,
      flexGrow: 0
    }
  },
  trayCollapsedTitleWrapper: {
    marginTop: -8,
    flexGrow: 1,
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "center",
    overflow: "hidden"
  },
  trayCollapsedTitle: {
    fontSize: 18,
    lineHeight: "25px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    fontWeight: 600,
    writingMode: "vertical-lr",
    "& strong": {
      color: theme2.indigo3
    }
  },
  trayCloseIcon: {
    flexShrink: 0,
    padding: 10,
    cursor: "pointer",
    color: theme2.grey3,
    transition: "color .25s",
    "&:hover": {
      color: theme2.grey1
    }
  }
});
const Tray = ({
  classes,
  portalEl,
  title: title2,
  children,
  isLeftSide = false,
  width = 450,
  collapsedWidth = 54,
  resizable = true,
  minWidth = 200,
  onResize,
  onClose
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const [currentWidth, setCurrentWidth] = useState(width);
  const [isResizing, setIsResizing] = useState(false);
  const [resizingWidth, setResizingWidth] = useState(width);
  const isResizable = resizable && !collapsed;
  let usedWidth = collapsed ? collapsedWidth : currentWidth;
  if (isResizing) {
    usedWidth = resizingWidth;
  }
  const trayEnable = useMemo(
    () => ({
      top: false,
      right: isResizable && isLeftSide,
      bottom: false,
      left: isResizable && !isLeftSide,
      topRight: false,
      bottomRight: false,
      bottomLeft: false,
      topLeft: false
    }),
    [isResizable, isLeftSide]
  );
  const onResizeStart = useCallback(() => setIsResizing(true), []);
  const onResizeInternal = useCallback(
    (...args) => {
      const d4 = args[3];
      setResizingWidth(currentWidth + d4.width);
    },
    [currentWidth]
  );
  const onResizeStop = useCallback(() => {
    setCurrentWidth(resizingWidth);
    setIsResizing(false);
    if (onResize) onResize(resizingWidth);
  }, [resizingWidth, onResize]);
  const trayContent = useMemo(() => {
    const parsedTitle = typeof title2 === "string" ? parseBoldMarkdown(title2) : title2;
    return /* @__PURE__ */ jsxs(Fragment$1, { children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: classes.trayTitleContainer,
          "data-is-collapsed": collapsed,
          "data-is-inverted": isLeftSide,
          children: [
            /* @__PURE__ */ jsx$1(
              "div",
              {
                className: classes.trayCollapseIcon,
                "data-is-collapsed": collapsed,
                "data-is-inverted": isLeftSide,
                onClick: () => setCollapsed(!collapsed),
                "data-cy": "collapse-toggle",
                children: /* @__PURE__ */ jsx$1(Icon$2, { name: "CircleArrowRight", size: 32 })
              }
            ),
            !collapsed && /* @__PURE__ */ jsx$1("div", { className: classes.trayTitle, children: parsedTitle })
          ]
        }
      ),
      collapsed && /* @__PURE__ */ jsx$1("div", { className: classes.trayCollapsedTitleWrapper, children: /* @__PURE__ */ jsx$1("div", { className: classes.trayCollapsedTitle, children: parsedTitle }) }),
      collapsed && onClose && /* @__PURE__ */ jsx$1(
        "div",
        {
          className: classes.trayCloseIcon,
          onClick: onClose,
          "data-cy": "close-tray",
          children: /* @__PURE__ */ jsx$1(Icon$2, { name: "CircleCross", size: 32 })
        }
      ),
      /* @__PURE__ */ jsx$1("div", { className: classes.trayBody, "data-is-hidden": collapsed, children })
    ] });
  }, [classes, collapsed, isLeftSide, title2, onClose, children]);
  const resizableStyle = useMemo(
    () => ({ transition: isResizing ? "none" : "width .25s" }),
    [isResizing]
  );
  const resizableSize = useMemo(
    () => ({
      width: usedWidth,
      height: "100%"
    }),
    [usedWidth]
  );
  return createPortal(
    /* @__PURE__ */ jsx$1(
      Resizable,
      {
        className: classes.tray,
        handleWrapperClass: classes.handleWrapper,
        style: resizableStyle,
        minWidth: isResizing ? minWidth : 0,
        size: resizableSize,
        enable: trayEnable,
        onResizeStart,
        onResize: onResizeInternal,
        onResizeStop,
        children: trayContent
      }
    ),
    portalEl
  );
};
const index$4 = injectSheet(styles$t)(memo(Tray));
const styles$s = (theme2) => ({
  modalContent: {
    "& strong": {
      color: theme2.indigo3
    }
  }
});
const DEFAULT_OK_BTN_LABEL = "ok";
const MessageModal = ({
  classes,
  title: title2,
  content,
  close,
  okBtn = false,
  okBtnText = ""
}) => {
  const proseContent = useMemo(() => parseModalContent(content), [content]);
  return /* @__PURE__ */ jsxs(Modal$1, { title: title2, closeButtonLabel: "Cancel", handleCollapse: close, children: [
    /* @__PURE__ */ jsx$1(ModalContent$1, { children: /* @__PURE__ */ jsx$1("div", { className: classes.modalContent, children: proseContent }) }),
    okBtn && /* @__PURE__ */ jsx$1(ModalActions$1, { children: /* @__PURE__ */ jsx$1(Pushbutton$1, { onClick: close, dataCy: "ok-button", children: okBtnText || DEFAULT_OK_BTN_LABEL }) })
  ] });
};
const index$3 = injectSheet(styles$s)(memo(MessageModal));
const ProfileButton = ({
  loading,
  avatar,
  avatarSize,
  goToProfile,
  signOut
}) => {
  const avatarSrc = loading ? "" : avatar;
  const menuItems = loading ? [] : [
    {
      label: "Profile",
      icon: /* @__PURE__ */ jsx$1(Icon$2, { name: "CircleProfile", size: 20 }),
      onClick: goToProfile
    },
    {
      label: "Sign out",
      icon: /* @__PURE__ */ jsx$1(Icon$2, { name: "Signout", size: 20 }),
      onClick: signOut
    }
  ];
  return /* @__PURE__ */ jsx$1(
    Popover,
    {
      avatarButton: true,
      avatarSize,
      avatarSrc,
      loading,
      children: menuItems.map((item) => /* @__PURE__ */ jsx$1(
        PopoverMenuItem$1,
        {
          onClick: item.onClick,
          icon: item.icon,
          dataCy: item.label,
          children: item.label
        },
        item.label
      ))
    }
  );
};
const index$2 = memo(ProfileButton);
const AutoNumericEnum = {};
AutoNumericEnum.allowedTagList = [
  "b",
  "caption",
  "cite",
  "code",
  "const",
  "dd",
  "del",
  "div",
  "dfn",
  "dt",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "input",
  "ins",
  "kdb",
  "label",
  "li",
  "option",
  "output",
  "p",
  "q",
  "s",
  "sample",
  "span",
  "strong",
  "td",
  "th",
  "u"
];
Object.freeze(AutoNumericEnum.allowedTagList);
Object.defineProperty(AutoNumericEnum, "allowedTagList", { configurable: false, writable: false });
AutoNumericEnum.fromCharCodeKeyCode = {
  0: "LaunchCalculator",
  8: "Backspace",
  9: "Tab",
  13: "Enter",
  16: "Shift",
  17: "Ctrl",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  48: "0",
  49: "1",
  50: "2",
  51: "3",
  52: "4",
  53: "5",
  54: "6",
  55: "7",
  56: "8",
  57: "9",
  // 65: 'a',
  // 66: 'b',
  // 67: 'c',
  // 68: 'd',
  // 69: 'e',
  // 70: 'f',
  // 71: 'g',
  // 72: 'h',
  // 73: 'i',
  // 74: 'j',
  // 75: 'k',
  // 76: 'l',
  // 77: 'm',
  // 78: 'n',
  // 79: 'o',
  // 80: 'p',
  // 81: 'q',
  // 82: 'r',
  // 83: 's',
  // 84: 't',
  // 85: 'u',
  // 86: 'v',
  // 87: 'w',
  // 88: 'x',
  // 89: 'y',
  // 90: 'z',
  91: "OS",
  // Note: Firefox and Chrome reports 'OS' instead of 'OSLeft'
  92: "OSRight",
  93: "ContextMenu",
  96: "0",
  97: "1",
  98: "2",
  99: "3",
  100: "4",
  101: "5",
  102: "6",
  103: "7",
  104: "8",
  105: "9",
  106: "*",
  107: "+",
  109: "-",
  // The 'NumpadSubtract' code
  110: ".",
  111: "/",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  173: "-",
  // The 'Minus' sign on Firefox. This is only needed when using the Selenium bot though.
  182: "MyComputer",
  183: "MyCalculator",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  // The 'Minus' sign on all other browsers
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'",
  224: "Meta",
  225: "AltGraph"
};
Object.freeze(AutoNumericEnum.fromCharCodeKeyCode);
Object.defineProperty(AutoNumericEnum, "fromCharCodeKeyCode", { configurable: false, writable: false });
AutoNumericEnum.keyName = {
  // Special values
  Unidentified: "Unidentified",
  AndroidDefault: "AndroidDefault",
  // Modifier keys
  Alt: "Alt",
  AltGr: "AltGraph",
  CapsLock: "CapsLock",
  // Under Chrome, e.key is empty for CapsLock
  Ctrl: "Control",
  Fn: "Fn",
  FnLock: "FnLock",
  Hyper: "Hyper",
  // 'OS' under Firefox
  Meta: "Meta",
  OSLeft: "OS",
  OSRight: "OS",
  Command: "OS",
  NumLock: "NumLock",
  ScrollLock: "ScrollLock",
  Shift: "Shift",
  Super: "Super",
  // 'OS' under Firefox
  Symbol: "Symbol",
  SymbolLock: "SymbolLock",
  // Whitespace keys
  Enter: "Enter",
  Tab: "Tab",
  Space: " ",
  // 'Spacebar' for Firefox <37, and IE9
  // Navigation keys
  LeftArrow: "ArrowLeft",
  // 'Left' for Firefox <=36, and IE9
  UpArrow: "ArrowUp",
  // 'Up' for Firefox <=36, and IE9
  RightArrow: "ArrowRight",
  // 'Right' for Firefox <=36, and IE9
  DownArrow: "ArrowDown",
  // 'Down' for Firefox <=36, and IE9
  End: "End",
  Home: "Home",
  PageUp: "PageUp",
  PageDown: "PageDown",
  // Editing keys
  Backspace: "Backspace",
  Clear: "Clear",
  Copy: "Copy",
  CrSel: "CrSel",
  // 'Crsel' for Firefox <=36, and IE9
  Cut: "Cut",
  Delete: "Delete",
  // 'Del' for Firefox <=36, and IE9
  EraseEof: "EraseEof",
  ExSel: "ExSel",
  // 'Exsel' for Firefox <=36, and IE9
  Insert: "Insert",
  Paste: "Paste",
  Redo: "Redo",
  Undo: "Undo",
  // UI keys
  Accept: "Accept",
  Again: "Again",
  Attn: "Attn",
  // 'Unidentified' for Firefox, Chrome, and IE9 ('KanaMode' when using the Japanese keyboard layout)
  Cancel: "Cancel",
  ContextMenu: "ContextMenu",
  // 'Apps' for Firefox <=36, and IE9
  Esc: "Escape",
  // 'Esc' for Firefox <=36, and IE9
  Execute: "Execute",
  Find: "Find",
  Finish: "Finish",
  // 'Unidentified' for Firefox, Chrome, and IE9 ('Katakana' when using the Japanese keyboard layout)
  Help: "Help",
  Pause: "Pause",
  Play: "Play",
  Props: "Props",
  Select: "Select",
  ZoomIn: "ZoomIn",
  ZoomOut: "ZoomOut",
  // Device keys
  BrightnessDown: "BrightnessDown",
  BrightnessUp: "BrightnessUp",
  Eject: "Eject",
  LogOff: "LogOff",
  Power: "Power",
  PowerOff: "PowerOff",
  PrintScreen: "PrintScreen",
  Hibernate: "Hibernate",
  // 'Unidentified' for Firefox <=37
  Standby: "Standby",
  // 'Unidentified' for Firefox <=36, and IE9
  WakeUp: "WakeUp",
  // IME and composition keys
  Compose: "Compose",
  Dead: "Dead",
  // Function keys
  F1: "F1",
  F2: "F2",
  F3: "F3",
  F4: "F4",
  F5: "F5",
  F6: "F6",
  F7: "F7",
  F8: "F8",
  F9: "F9",
  F10: "F10",
  F11: "F11",
  F12: "F12",
  // Document keys
  Print: "Print",
  // 'Normal' keys
  num0: "0",
  num1: "1",
  num2: "2",
  num3: "3",
  num4: "4",
  num5: "5",
  num6: "6",
  num7: "7",
  num8: "8",
  num9: "9",
  a: "a",
  b: "b",
  c: "c",
  d: "d",
  e: "e",
  f: "f",
  g: "g",
  h: "h",
  i: "i",
  j: "j",
  k: "k",
  l: "l",
  m: "m",
  n: "n",
  o: "o",
  p: "p",
  q: "q",
  r: "r",
  s: "s",
  t: "t",
  u: "u",
  v: "v",
  w: "w",
  x: "x",
  y: "y",
  z: "z",
  A: "A",
  B: "B",
  C: "C",
  D: "D",
  E: "E",
  F: "F",
  G: "G",
  H: "H",
  I: "I",
  J: "J",
  K: "K",
  L: "L",
  M: "M",
  N: "N",
  O: "O",
  P: "P",
  Q: "Q",
  R: "R",
  S: "S",
  T: "T",
  U: "U",
  V: "V",
  W: "W",
  X: "X",
  Y: "Y",
  Z: "Z",
  Semicolon: ";",
  Equal: "=",
  Comma: ",",
  Hyphen: "-",
  Minus: "-",
  Plus: "+",
  Dot: ".",
  Slash: "/",
  Backquote: "`",
  LeftParenthesis: "(",
  RightParenthesis: ")",
  LeftBracket: "[",
  RightBracket: "]",
  Backslash: "\\",
  Quote: "'",
  // Numeric keypad keys
  numpad0: "0",
  numpad1: "1",
  numpad2: "2",
  numpad3: "3",
  numpad4: "4",
  numpad5: "5",
  numpad6: "6",
  numpad7: "7",
  numpad8: "8",
  numpad9: "9",
  NumpadDot: ".",
  NumpadDotAlt: ",",
  // Modern browsers automatically adapt the character sent by this key to the decimal character of the current language
  NumpadMultiply: "*",
  NumpadPlus: "+",
  NumpadMinus: "-",
  NumpadSubtract: "-",
  NumpadSlash: "/",
  NumpadDotObsoleteBrowsers: "Decimal",
  NumpadMultiplyObsoleteBrowsers: "Multiply",
  NumpadPlusObsoleteBrowsers: "Add",
  NumpadMinusObsoleteBrowsers: "Subtract",
  NumpadSlashObsoleteBrowsers: "Divide",
  // Special arrays for quicker tests
  _allFnKeys: ["F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12"],
  _someNonPrintableKeys: ["Tab", "Enter", "Shift", "ShiftLeft", "ShiftRight", "Control", "ControlLeft", "ControlRight", "Alt", "AltLeft", "AltRight", "Pause", "CapsLock", "Escape"],
  _directionKeys: ["PageUp", "PageDown", "End", "Home", "ArrowDown", "ArrowLeft", "ArrowRight", "ArrowUp"]
};
Object.freeze(AutoNumericEnum.keyName._allFnKeys);
Object.freeze(AutoNumericEnum.keyName._someNonPrintableKeys);
Object.freeze(AutoNumericEnum.keyName._directionKeys);
Object.freeze(AutoNumericEnum.keyName);
Object.defineProperty(AutoNumericEnum, "keyName", { configurable: false, writable: false });
Object.freeze(AutoNumericEnum);
class AutoNumericHelper {
  /**
   * Return `true` if the `value` is null
   *
   * @static
   * @param {*} value The value to test
   * @returns {boolean} Return `true` if the `value` is null, FALSE otherwise
   */
  static isNull(value) {
    return value === null;
  }
  /**
   * Return `true` if the `value` is undefined
   *
   * @static
   * @param {*} value The value to test
   * @returns {boolean} Return `true` if the `value` is undefined, FALSE otherwise
   */
  static isUndefined(value) {
    return value === void 0;
  }
  /**
   * Return `true` if the `value` is undefined, null or empty
   *
   * @param {*} value
   * @returns {boolean}
   */
  static isUndefinedOrNullOrEmpty(value) {
    return value === null || value === void 0 || "" === value;
  }
  /**
   * Return `true` if the given parameter is a String
   *
   * @param {*} str
   * @returns {boolean}
   */
  static isString(str) {
    return typeof str === "string" || str instanceof String;
  }
  /**
   * Return `true` if the `value` is an empty string ''
   *
   * @static
   * @param {*} value The value to test
   * @returns {boolean} Return `true` if the `value` is an empty string '', FALSE otherwise
   */
  static isEmptyString(value) {
    return value === "";
  }
  /**
   * Return `true` if the parameter is a boolean
   *
   * @static
   * @param {*} value
   * @returns {boolean}
   */
  static isBoolean(value) {
    return typeof value === "boolean";
  }
  /**
   * Return `true` if the parameter is a string 'true' or 'false'
   *
   * This function accepts any cases for those strings.
   * @param {string} value
   * @returns {boolean}
   */
  static isTrueOrFalseString(value) {
    const lowercaseValue = String(value).toLowerCase();
    return lowercaseValue === "true" || lowercaseValue === "false";
  }
  /**
   * Return `true` if the parameter is an object
   *
   * @param {*} reference
   * @returns {boolean}
   */
  static isObject(reference) {
    return typeof reference === "object" && reference !== null && !Array.isArray(reference);
  }
  /**
   * Return `true` if the given object is empty
   * cf. http://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object and http://jsperf.com/empty-object-test
   *
   * @param {object} obj
   * @returns {boolean}
   */
  static isEmptyObj(obj) {
    for (const prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
    return true;
  }
  /**
   * Return `true` if the parameter is a real number (and not a numeric string).
   *
   * @param {*} n
   * @returns {boolean}
   */
  static isNumberStrict(n2) {
    return typeof n2 === "number";
  }
  /**
   * Return `true` if the parameter is a number (or a number written as a string).
   *
   * @param {*} n
   * @returns {boolean}
   */
  static isNumber(n2) {
    return !this.isArray(n2) && !isNaN(parseFloat(n2)) && isFinite(n2);
  }
  /**
   * Return `true` if the given character is a number (0 to 9)
   *
   * @param {char} char
   * @returns {boolean}
   */
  static isDigit(char) {
    return /\d/.test(char);
  }
  /**
   * Return `true` if the parameter is a number (or a number written as a string).
   * This version also accepts Arabic and Persian numbers.
   *
   * @param {*} n
   * @returns {boolean}
   */
  static isNumberOrArabic(n2) {
    const latinConvertedNumber = this.arabicToLatinNumbers(n2, false, true, true);
    return this.isNumber(latinConvertedNumber);
  }
  /**
   * Return `true` if the parameter is an integer (and not a float).
   *
   * @param {*} n
   * @returns {boolean}
   */
  static isInt(n2) {
    return typeof n2 === "number" && parseFloat(n2) === parseInt(n2, 10) && !isNaN(n2);
  }
  /**
   * Return `true` if the parameter is a function.
   *
   * @param {function} func
   * @returns {boolean}
   */
  static isFunction(func) {
    return typeof func === "function";
  }
  /**
   * Return `true` is the string `str` contains the string `needle`
   * Note: this function does not coerce the parameters types
   *
   * @param {string} str
   * @param {string} needle
   * @returns {boolean}
   */
  static contains(str, needle) {
    if (!this.isString(str) || !this.isString(needle) || str === "" || needle === "") {
      return false;
    }
    return str.indexOf(needle) !== -1;
  }
  /**
   * Return `true` if the `needle` is in the array
   *
   * @param {*} needle
   * @param {Array} array
   * @returns {boolean}
   */
  static isInArray(needle, array) {
    if (!this.isArray(array) || array === [] || this.isUndefined(needle)) {
      return false;
    }
    return array.indexOf(needle) !== -1;
  }
  /**
   * Return `true` if the parameter is an Array
   * //TODO Replace this by the default `Array.isArray()` function?
   *
   * @param {*} arr
   * @throws Error
   * @returns {*|boolean}
   */
  static isArray(arr) {
    if (Object.prototype.toString.call([]) === "[object Array]") {
      return Array.isArray(arr) || typeof arr === "object" && Object.prototype.toString.call(arr) === "[object Array]";
    } else {
      throw new Error("toString message changed for Object Array");
    }
  }
  /**
   * Return `true` if the parameter is a DOM element
   * cf. http://stackoverflow.com/a/4754104/2834898
   *
   * @param {*} obj
   * @returns {boolean}
   */
  static isElement(obj) {
    if (typeof Element === "undefined") {
      return false;
    }
    return obj instanceof Element;
  }
  /**
   * Return `true` in the given DOM element is an <input>.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @returns {boolean}
   * @private
   */
  static isInputElement(domElement) {
    return this.isElement(domElement) && domElement.tagName.toLowerCase() === "input";
  }
  /**
   * Return `true` if the parameter is a string that represents a float number, and that number has a decimal part
   *
   * @param {string} str
   * @returns {boolean}
   */
  // static hasDecimals(str) {
  //     const [, decimalPart] = str.split('.');
  //     return !isUndefined(decimalPart);
  // }
  /**
   * Return the number of decimal places if the parameter is a string that represents a float number, and that number has a decimal part.
   *
   * @param {string} str
   * @returns {int}
   */
  static decimalPlaces(str) {
    const [, decimalPart] = str.split(".");
    if (!this.isUndefined(decimalPart)) {
      return decimalPart.length;
    }
    return 0;
  }
  /**
   * Return the index of the first non-zero decimal place in the given value.
   * The index starts after the decimal point, if any, and begins at '1'.
   * If no decimal places are found in the value, this function returns `0`.
   *
   * @example
   * indexFirstNonZeroDecimalPlace('0.00') -> 0
   * indexFirstNonZeroDecimalPlace('1.00') -> 0
   * indexFirstNonZeroDecimalPlace('0.12') -> 1
   * indexFirstNonZeroDecimalPlace('0.1234') -> 1
   * indexFirstNonZeroDecimalPlace('0.01234') -> 2
   * indexFirstNonZeroDecimalPlace('0.001234') -> 3
   * indexFirstNonZeroDecimalPlace('0.0001234') -> 4
   *
   * @param {number} value
   * @returns {Number|number}
   */
  static indexFirstNonZeroDecimalPlace(value) {
    const [, decimalPart] = String(Math.abs(value)).split(".");
    if (this.isUndefined(decimalPart)) {
      return 0;
    }
    let result2 = decimalPart.lastIndexOf("0");
    if (result2 === -1) {
      result2 = 0;
    } else {
      result2 += 2;
    }
    return result2;
  }
  /**
   * Return the code for the key used to generate the given event.
   *
   * @param {Event} event
   * @returns {string|Number}
   */
  static keyCodeNumber(event) {
    return typeof event.which === "undefined" ? event.keyCode : event.which;
  }
  /**
   * Return the character from the event key code.
   * If the KeyboardEvent does not represent a printable character, then the key name is used (ie. 'Meta', 'Shift', 'F1', etc.)
   * @example character(50) => '2'
   *
   * @param {KeyboardEvent} event
   * @returns {string}
   */
  static character(event) {
    let result2;
    if (event.key === "Unidentified" || event.key === void 0 || this.isSeleniumBot()) {
      const keyCode = this.keyCodeNumber(event);
      if (keyCode === 229) {
        return AutoNumericEnum.keyName.AndroidDefault;
      }
      const potentialResult = AutoNumericEnum.fromCharCodeKeyCode[keyCode];
      if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(potentialResult)) {
        result2 = potentialResult;
      } else {
        result2 = String.fromCharCode(keyCode);
      }
    } else {
      switch (event.key) {
        case "Add":
          result2 = AutoNumericEnum.keyName.NumpadPlus;
          break;
        case "Apps":
          result2 = AutoNumericEnum.keyName.ContextMenu;
          break;
        case "Crsel":
          result2 = AutoNumericEnum.keyName.CrSel;
          break;
        case "Decimal":
          if (event.char) {
            result2 = event.char;
          } else {
            result2 = AutoNumericEnum.keyName.NumpadDot;
          }
          break;
        case "Del":
          result2 = AutoNumericEnum.keyName.Delete;
          break;
        case "Divide":
          result2 = AutoNumericEnum.keyName.NumpadSlash;
          break;
        case "Down":
          result2 = AutoNumericEnum.keyName.DownArrow;
          break;
        case "Esc":
          result2 = AutoNumericEnum.keyName.Esc;
          break;
        case "Exsel":
          result2 = AutoNumericEnum.keyName.ExSel;
          break;
        case "Left":
          result2 = AutoNumericEnum.keyName.LeftArrow;
          break;
        case "Meta":
        case "Super":
          result2 = AutoNumericEnum.keyName.OSLeft;
          break;
        case "Multiply":
          result2 = AutoNumericEnum.keyName.NumpadMultiply;
          break;
        case "Right":
          result2 = AutoNumericEnum.keyName.RightArrow;
          break;
        case "Spacebar":
          result2 = AutoNumericEnum.keyName.Space;
          break;
        case "Subtract":
          result2 = AutoNumericEnum.keyName.NumpadMinus;
          break;
        case "Up":
          result2 = AutoNumericEnum.keyName.UpArrow;
          break;
        default:
          result2 = event.key;
      }
    }
    return result2;
  }
  /**
   * Return an object containing the name and version of the current browser.
   * @example `browserVersion()` => { name: 'Firefox', version: '42' }
   * Based on http://stackoverflow.com/a/38080051/2834898
   *
   * @returns {{ name: string, version: string }}
   */
  static browser() {
    const ua2 = navigator.userAgent;
    let tem;
    let M4 = ua2.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M4[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua2) || [];
      return { name: "ie", version: tem[1] || "" };
    }
    if (M4[1] === "Chrome") {
      tem = ua2.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem !== null) {
        return { name: tem[1].replace("OPR", "opera"), version: tem[2] };
      }
    }
    M4 = M4[2] ? [M4[1], M4[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua2.match(/version\/(\d+)/i)) !== null) {
      M4.splice(1, 1, tem[1]);
    }
    return { name: M4[0].toLowerCase(), version: M4[1] };
  }
  /**
   * Check if the browser is controlled by Selenium.
   * Note: This only works within the geckodriver.
   * cf. http://stackoverflow.com/questions/33225947/can-a-website-detect-when-you-are-using-selenium-with-chromedriver
   *
   * @returns {boolean}
   */
  static isSeleniumBot() {
    return window.navigator.webdriver === true;
  }
  /**
   * Return `true` if the given number is negative, or if the given string contains a negative sign :
   * - everywhere in the string (by default), or
   * - on the first character only if the `checkEverywhere` parameter is set to `false`.
   *
   * Note: `-0` is not a negative number since it's equal to `0`.
   *
   * @param {number|string} numberOrNumericString A Number, or a number represented by a string
   * @param {string} negativeSignCharacter The single character that represent the negative sign
   * @param {boolean} checkEverywhere If TRUE, then the negative sign is search everywhere in the numeric string (this is needed for instance if the string is '1234.56-')
   * @returns {boolean}
   */
  static isNegative(numberOrNumericString, negativeSignCharacter = "-", checkEverywhere = true) {
    if (numberOrNumericString === negativeSignCharacter) {
      return true;
    }
    if (numberOrNumericString === "") {
      return false;
    }
    if (AutoNumericHelper.isNumber(numberOrNumericString)) {
      return numberOrNumericString < 0;
    }
    if (checkEverywhere) {
      return this.contains(numberOrNumericString, negativeSignCharacter);
    }
    return this.isNegativeStrict(numberOrNumericString, negativeSignCharacter);
  }
  /**
   * Return `true` if the given string contains a negative sign on the first character (on the far left).
   *
   * @example isNegativeStrict('1234.56')     => false
   * @example isNegativeStrict('1234.56-')    => false
   * @example isNegativeStrict('-1234.56')    => true
   * @example isNegativeStrict('-1,234.56 €') => true
   *
   * @param {string} numericString
   * @param {string} negativeSignCharacter The single character that represent the negative sign
   * @returns {boolean}
   */
  static isNegativeStrict(numericString, negativeSignCharacter = "-") {
    return numericString.charAt(0) === negativeSignCharacter;
  }
  /**
   * Return `true` if the very first character is the opening bracket, and if the rest of the `valueString` also has the closing bracket.
   *
   * @param {string} valueString
   * @param {string} leftBracket
   * @param {string} rightBracket
   * @returns {boolean}
   */
  static isNegativeWithBrackets(valueString, leftBracket, rightBracket) {
    return valueString.charAt(0) === leftBracket && this.contains(valueString, rightBracket);
  }
  /**
   * Return `true` if the formatted or unformatted numeric string represent the value 0 (ie. '0,00 €'), or is empty (' €').
   * This works since we test if there are any numbers from 1 to 9 in the string. If there is none, then the number is zero (or the string is empty).
   *
   * @param {string} numericString
   * @returns {boolean}
   */
  static isZeroOrHasNoValue(numericString) {
    return !/[1-9]/g.test(numericString);
  }
  /**
   * Return the negative version of the value (represented as a string) given as a parameter.
   * The numeric string is a valid Javascript number when typecast to a `Number`.
   *
   * @param {string} value
   * @returns {*}
   */
  static setRawNegativeSign(value) {
    if (!this.isNegativeStrict(value, "-")) {
      return `-${value}`;
    }
    return value;
  }
  /**
   * Replace the character at the position `index` in the string `string` by the character(s) `newCharacter`.
   *
   * @param {string} string
   * @param {int} index
   * @param {string} newCharacter
   * @returns {string}
   */
  static replaceCharAt(string3, index2, newCharacter) {
    return `${string3.substr(0, index2)}${newCharacter}${string3.substr(index2 + newCharacter.length)}`;
  }
  /**
   * Return the value clamped to the nearest minimum/maximum value, as defined in the settings.
   *
   * @param {string|number} value
   * @param {object} settings
   * @returns {number}
   */
  static clampToRangeLimits(value, settings) {
    return Math.max(settings.minimumValue, Math.min(settings.maximumValue, value));
  }
  /**
   * Return the number of number or dot characters on the left side of the caret, in a formatted number.
   *
   * @param {string} formattedNumberString
   * @param {int} caretPosition This must be a positive integer
   * @param {string} decimalCharacter
   * @returns {number}
   */
  static countNumberCharactersOnTheCaretLeftSide(formattedNumberString, caretPosition, decimalCharacter) {
    const numberDotOrNegativeSign = new RegExp(`[0-9${decimalCharacter}-]`);
    let numberDotAndNegativeSignCount = 0;
    for (let i3 = 0; i3 < caretPosition; i3++) {
      if (numberDotOrNegativeSign.test(formattedNumberString[i3])) {
        numberDotAndNegativeSignCount++;
      }
    }
    return numberDotAndNegativeSignCount;
  }
  /**
   * Walk the `formattedNumberString` from left to right, one char by one, counting the `formattedNumberStringIndex`.
   * If the char is in the `rawNumberString` (starting at index 0), then `rawNumberStringIndex++`, and continue until
   * there is no more characters in `rawNumberString`) or that `rawNumberStringIndex === caretPositionInRawValue`.
   * When you stop, the `formattedNumberStringIndex` is the position where the caret should be set.
   *
   * @example
   * 1234567|89.01   : position 7 (rawNumberString)
   * 123.456.7|89,01 : position 9 (formattedNumberString)
   *
   * @param {string} rawNumberString
   * @param {int} caretPositionInRawValue
   * @param {string} formattedNumberString
   * @param {string} decimalCharacter
   * @returns {*}
   */
  static findCaretPositionInFormattedNumber(rawNumberString, caretPositionInRawValue, formattedNumberString, decimalCharacter) {
    const formattedNumberStringSize = formattedNumberString.length;
    const rawNumberStringSize = rawNumberString.length;
    let formattedNumberStringIndex;
    let rawNumberStringIndex = 0;
    for (formattedNumberStringIndex = 0; formattedNumberStringIndex < formattedNumberStringSize && rawNumberStringIndex < rawNumberStringSize && rawNumberStringIndex < caretPositionInRawValue; formattedNumberStringIndex++) {
      if (rawNumberString[rawNumberStringIndex] === formattedNumberString[formattedNumberStringIndex] || rawNumberString[rawNumberStringIndex] === "." && formattedNumberString[formattedNumberStringIndex] === decimalCharacter) {
        rawNumberStringIndex++;
      }
    }
    return formattedNumberStringIndex;
  }
  /**
   * Count the number of occurrence of the given character, in the given text.
   *
   * @param {string} character
   * @param {string} text
   * @returns {number}
   */
  static countCharInText(character, text) {
    let charCounter = 0;
    for (let i3 = 0; i3 < text.length; i3++) {
      if (text[i3] === character) {
        charCounter++;
      }
    }
    return charCounter;
  }
  /**
   * Return the index that can be used to set the caret position.
   * This takes into account that the position is starting at '0', not 1.
   *
   * @param {int} characterCount
   * @returns {number}
   */
  static convertCharacterCountToIndexPosition(characterCount) {
    return Math.max(characterCount, characterCount - 1);
  }
  /**
   * Cross browser routine for getting selected range/cursor position.
   * Note: this also works with edge cases like contenteditable-enabled elements, and hidden inputs.
   *
   * @param {HTMLInputElement|EventTarget} element
   * @returns {{}}
   */
  static getElementSelection(element) {
    const position2 = {};
    let isSelectionStartUndefined;
    try {
      isSelectionStartUndefined = this.isUndefined(element.selectionStart);
    } catch (error2) {
      isSelectionStartUndefined = false;
    }
    try {
      if (isSelectionStartUndefined) {
        const selection = window.getSelection();
        const selectionInfo = selection.getRangeAt(0);
        position2.start = selectionInfo.startOffset;
        position2.end = selectionInfo.endOffset;
        position2.length = position2.end - position2.start;
      } else {
        position2.start = element.selectionStart;
        position2.end = element.selectionEnd;
        position2.length = position2.end - position2.start;
      }
    } catch (error2) {
      position2.start = 0;
      position2.end = 0;
      position2.length = 0;
    }
    return position2;
  }
  /**
   * Cross browser routine for setting selected range/cursor position
   *
   * @param {HTMLInputElement|EventTarget} element
   * @param {int} start
   * @param {int|null} end
   */
  static setElementSelection(element, start2, end2 = null) {
    if (this.isUndefinedOrNullOrEmpty(end2)) {
      end2 = start2;
    }
    if (this.isInputElement(element)) {
      element.setSelectionRange(start2, end2);
    } else if (!AutoNumericHelper.isNull(element.firstChild)) {
      const range2 = document.createRange();
      range2.setStart(element.firstChild, start2);
      range2.setEnd(element.firstChild, end2);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range2);
    }
  }
  /**
   * Function that throw error messages
   *
   * @param {string} message
   * @throws
   */
  static throwError(message2) {
    throw new Error(message2);
  }
  /**
   * Function that display a warning messages, according to the debug level.
   *
   * @param {string} message
   * @param {boolean} showWarning If FALSE, then the warning message is not displayed
   */
  static warning(message2, showWarning = true) {
    if (showWarning) {
      console.warn(`Warning: ${message2}`);
    }
  }
  /**
   * Return `true` if the given event is an instance of WheelEvent
   *
   * @static
   * @param {event} event The event to test
   * @returns {boolean} Return `true` if the event is an instance of WheelEvent, FALSE otherwise
  */
  static isWheelEvent(event) {
    return event instanceof WheelEvent;
  }
  /**
   * Return `true` if the given event is a wheelup event
   *
   * @param {WheelEvent} wheelEvent
   * @returns {boolean}
   */
  static isWheelUpEvent(wheelEvent) {
    if (!this.isWheelEvent(wheelEvent) || this.isUndefinedOrNullOrEmpty(wheelEvent.deltaY)) {
      this.throwError(`The event passed as a parameter is not a valid wheel event, '${wheelEvent.type}' given.`);
    }
    return wheelEvent.deltaY < 0;
  }
  /**
   * Return `true` if the given event is a wheeldown event
   *
   * @param {WheelEvent} wheelEvent
   * @returns {boolean}
   */
  static isWheelDownEvent(wheelEvent) {
    if (!this.isWheelEvent(wheelEvent) || this.isUndefinedOrNullOrEmpty(wheelEvent.deltaY)) {
      this.throwError(`The event passed as a parameter is not a valid wheel event, '${wheelEvent.type}' given.`);
    }
    return wheelEvent.deltaY > 0;
  }
  /**
   * Return `true` if the given event is an instance of WheelEvent and the deltaY value is equal to zero
   *
   * @param {WheelEvent} wheelEvent The event to test
   * @returns {boolean} Return `true` if the event is an instance of WheelEvent and the deltaY value is equal to zero, FALSE otherwise
   */
  static isWheelEventWithZeroDeltaY(wheelEvent) {
    return this.isWheelEvent(wheelEvent) && !this.isUndefinedOrNullOrEmpty(wheelEvent.deltaY) && wheelEvent.deltaY === 0;
  }
  /**
   * Return the given raw value truncated at the given number of decimal places `decimalPlaces`.
   * This function does not round the value.
   *
   * @example
   * forceDecimalPlaces(123.45678, 0) -> '123.45678'
   * forceDecimalPlaces(123.45678, 1) -> '123.4'
   * forceDecimalPlaces(123.45678, 2) -> '123.45'
   * forceDecimalPlaces(123.45678, 3) -> '123.456'
   *
   * @param {number} value
   * @param {int} decimalPlaces
   * @returns {number|string}
   */
  static forceDecimalPlaces(value, decimalPlaces) {
    const [integerPart, decimalPart] = String(value).split(".");
    if (!decimalPart) {
      return value;
    }
    return `${integerPart}.${decimalPart.substr(0, decimalPlaces)}`;
  }
  /**
   * Return the 'nearest rounded' value, according to the given step size.
   * @example roundToNearest(264789, 10000)) => 260000
   *
   * @param {number} value
   * @param {number} stepPlace
   * @returns {*}
   */
  static roundToNearest(value, stepPlace = 1e3) {
    if (0 === value) {
      return 0;
    }
    if (stepPlace === 0) {
      this.throwError("The `stepPlace` used to round is equal to `0`. This value must not be equal to zero.");
    }
    return Math.round(value / stepPlace) * stepPlace;
  }
  /**
   * Return the 'nearest rounded' value by automatically adding or subtracting the calculated offset to the initial value.
   * This is done without having to pass a step to this function, and based on the size of the given `value`.
   *
   * @example                    Calculated offset
   *           1 ->           1 (1)
   *          14 ->          10 (10)
   *         143 ->         140 (10)
   *       1.278 ->       1.300 (100)
   *      28.456 ->      28.500 (100)
   *     276.345 ->     276.000 (1.000)
   *   4.534.061 ->   4.530.000 (10.000)
   *  66.723.844 ->  66.700.000 (100.000)
   * 257.833.411 -> 258.000.000 (1.000.000)
   *
   *                           Initial   Added   Offset
   * 2 decimalPlacesRawValue : 1.12   -> 2.00   (1)
   * 3 decimalPlacesRawValue : 1.123  -> 2.000  (1)
   *
   * Special case when the `value` to round is between -1 and 1, excluded :
   * @example
   *     Number of             Initial   Result  Calculated
   *     decimal places        value     (add)   offset
   * 2 decimalPlacesRawValue : 0.12   -> 0.13    (0.01) : Math.pow(10, -2)
   * 2 decimalPlacesRawValue : 0.01   -> 0.02    (0.01)
   * 2 decimalPlacesRawValue : 0.00   -> 0.01    (0.01)
   *
   * 3 decimalPlacesRawValue : 0.123  -> 0.133   (0.01)  : Math.pow(10, -2)
   * 3 decimalPlacesRawValue : 0.012  -> 0.013   (0.001) : Math.pow(10, -3)
   * 3 decimalPlacesRawValue : 0.001  -> 0.001   (0.001)
   * 3 decimalPlacesRawValue : 0.000  -> 0.001   (0.001)
   *
   * 4 decimalPlacesRawValue : 0.4123 -> 0.4200  (0.01)   : Math.pow(10, -2)
   * 4 decimalPlacesRawValue : 0.0412 -> 0.0420  (0.001)  : Math.pow(10, -3)
   * 4 decimalPlacesRawValue : 0.0041 -> 0.0042  (0.0001) : Math.pow(10, -4)
   * 4 decimalPlacesRawValue : 0.0004 -> 0.0005  (0.0001)
   * 4 decimalPlacesRawValue : 0.0000 -> 0.0001  (0.0001)
   *
   * @param {number} value
   * @param {boolean} isAddition
   * @param {int} decimalPlacesRawValue The precision needed by the `rawValue`
   * @returns {*}
   */
  static modifyAndRoundToNearestAuto(value, isAddition, decimalPlacesRawValue) {
    value = Number(this.forceDecimalPlaces(value, decimalPlacesRawValue));
    const absValue = Math.abs(value);
    if (absValue >= 0 && absValue < 1) {
      const rawValueMinimumOffset = Math.pow(10, -decimalPlacesRawValue);
      if (value === 0) {
        return isAddition ? rawValueMinimumOffset : -rawValueMinimumOffset;
      }
      let offset2;
      const minimumOffsetFirstDecimalPlaceIndex = decimalPlacesRawValue;
      const indexFirstNonZeroDecimalPlace = this.indexFirstNonZeroDecimalPlace(value);
      if (indexFirstNonZeroDecimalPlace >= minimumOffsetFirstDecimalPlaceIndex - 1) {
        offset2 = rawValueMinimumOffset;
      } else {
        offset2 = Math.pow(10, -(indexFirstNonZeroDecimalPlace + 1));
      }
      let result2;
      if (isAddition) {
        result2 = value + offset2;
      } else {
        result2 = value - offset2;
      }
      return this.roundToNearest(result2, offset2);
    } else {
      value = parseInt(value, 10);
      const lengthValue = Math.abs(value).toString().length;
      let pow;
      switch (lengthValue) {
        case 1:
          pow = 0;
          break;
        case 2:
        case 3:
          pow = 1;
          break;
        case 4:
        case 5:
          pow = 2;
          break;
        default:
          pow = lengthValue - 3;
      }
      const offset2 = Math.pow(10, pow);
      let result2;
      if (isAddition) {
        result2 = value + offset2;
      } else {
        result2 = value - offset2;
      }
      if (result2 <= 10 && result2 >= -10) {
        return result2;
      }
      return this.roundToNearest(result2, offset2);
    }
  }
  /**
   * Return the 'nearest rounded' value automatically by adding the calculated offset to the initial value.
   * This will limit the result to the given number of decimal places `decimalPlacesLimit`.
   *
   * @param {number} value
   * @param {int} decimalPlacesLimit
   * @returns {*}
   */
  static addAndRoundToNearestAuto(value, decimalPlacesLimit) {
    return this.modifyAndRoundToNearestAuto(value, true, decimalPlacesLimit);
  }
  /**
   * Return the 'nearest rounded' value automatically by subtracting the calculated offset to the initial value.
   * This will limit the result to the given number of decimal places `decimalPlacesLimit`.
   *
   * @param {number} value
   * @param {int} decimalPlacesLimit
   * @returns {*}
   */
  static subtractAndRoundToNearestAuto(value, decimalPlacesLimit) {
    return this.modifyAndRoundToNearestAuto(value, false, decimalPlacesLimit);
  }
  /**
   * Take an arabic number as a string and return a javascript number.
   * By default, this function does not try to convert the arabic decimal and thousand separator characters.
   * This returns `NaN` is the conversion is not possible.
   * Based on http://stackoverflow.com/a/17025392/2834898
   *
   * @param {string} arabicNumbers
   * @param {boolean} returnANumber If `true`, return a Number, otherwise return a String
   * @param {boolean} parseDecimalCharacter
   * @param {boolean} parseThousandSeparator
   * @returns {string|number|NaN}
   */
  static arabicToLatinNumbers(arabicNumbers, returnANumber = true, parseDecimalCharacter = false, parseThousandSeparator = false) {
    if (this.isNull(arabicNumbers)) {
      return arabicNumbers;
    }
    let result2 = arabicNumbers.toString();
    if (result2 === "") {
      return arabicNumbers;
    }
    if (result2.match(/[٠١٢٣٤٥٦٧٨٩۴۵۶]/g) === null) {
      if (returnANumber) {
        result2 = Number(result2);
      }
      return result2;
    }
    if (parseDecimalCharacter) {
      result2 = result2.replace(/٫/, ".");
    }
    if (parseThousandSeparator) {
      result2 = result2.replace(/٬/g, "");
    }
    result2 = result2.replace(/[٠١٢٣٤٥٦٧٨٩]/g, (d4) => d4.charCodeAt(0) - 1632).replace(/[۰۱۲۳۴۵۶۷۸۹]/g, (d4) => d4.charCodeAt(0) - 1776);
    const resultAsNumber = Number(result2);
    if (isNaN(resultAsNumber)) {
      return resultAsNumber;
    }
    if (returnANumber) {
      result2 = resultAsNumber;
    }
    return result2;
  }
  /**
   * Create a custom event and immediately sent it from the given element.
   * By default, if no element is given, the event is thrown from `document`.
   *
   * @param {string} eventName
   * @param {HTMLElement|HTMLDocument|EventTarget} element
   * @param {object} detail
   * @param {boolean} bubbles Set to `true` if the event must bubble up
   * @param {boolean} cancelable Set to `true` if the event must be cancelable
   */
  static triggerEvent(eventName, element = document, detail = null, bubbles = true, cancelable = true) {
    let event;
    if (window.CustomEvent) {
      event = new CustomEvent(eventName, { detail, bubbles, cancelable });
    } else {
      event = document.createEvent("CustomEvent");
      event.initCustomEvent(eventName, bubbles, cancelable, { detail });
    }
    element.dispatchEvent(event);
  }
  /**
   * Function to parse minimumValue, maximumValue & the input value to prepare for testing to determine if the value falls within the min / max range.
   * Return an object example: minimumValue: "999999999999999.99" returns the following "{s: -1, e: 12, c: Array[15]}".
   *
   * This function is adapted from Big.js https://github.com/MikeMcl/big.js/. Many thanks to Mike.
   *
   * @param {number|string} n A numeric value.
   * @returns {{}}
   */
  static parseStr(n2) {
    const x3 = {};
    let e5;
    let i3;
    let nL;
    let j2;
    if (n2 === 0 && 1 / n2 < 0) {
      n2 = "-0";
    }
    n2 = n2.toString();
    if (this.isNegativeStrict(n2, "-")) {
      n2 = n2.slice(1);
      x3.s = -1;
    } else {
      x3.s = 1;
    }
    e5 = n2.indexOf(".");
    if (e5 > -1) {
      n2 = n2.replace(".", "");
    }
    if (e5 < 0) {
      e5 = n2.length;
    }
    i3 = n2.search(/[1-9]/i) === -1 ? n2.length : n2.search(/[1-9]/i);
    nL = n2.length;
    if (i3 === nL) {
      x3.e = 0;
      x3.c = [0];
    } else {
      for (j2 = nL - 1; n2.charAt(j2) === "0"; j2 -= 1) {
        nL -= 1;
      }
      nL -= 1;
      x3.e = e5 - i3 - 1;
      x3.c = [];
      for (e5 = 0; i3 <= nL; i3 += 1) {
        x3.c[e5] = +n2.charAt(i3);
        e5 += 1;
      }
    }
    return x3;
  }
  /**
   * Function to test if the input value falls with the Min / Max settings.
   * This uses the parsed strings for the above parseStr function.
   *
   * This function is adapted from Big.js https://github.com/MikeMcl/big.js/. Many thanks to Mike.
   *
   * @param {object} y Big number instance
   * @param {object} x Big number instance
   * @returns {*}
   */
  static testMinMax(y4, x3) {
    const xc = x3.c;
    const yc = y4.c;
    let i3 = x3.s;
    let j2 = y4.s;
    let k3 = x3.e;
    let l2 = y4.e;
    if (!xc[0] || !yc[0]) {
      let result3;
      if (!xc[0]) {
        result3 = !yc[0] ? 0 : -j2;
      } else {
        result3 = i3;
      }
      return result3;
    }
    if (i3 !== j2) {
      return i3;
    }
    const xNeg = i3 < 0;
    if (k3 !== l2) {
      return k3 > l2 ^ xNeg ? 1 : -1;
    }
    i3 = -1;
    k3 = xc.length;
    l2 = yc.length;
    j2 = k3 < l2 ? k3 : l2;
    for (i3 += 1; i3 < j2; i3 += 1) {
      if (xc[i3] !== yc[i3]) {
        return xc[i3] > yc[i3] ^ xNeg ? 1 : -1;
      }
    }
    let result2;
    if (k3 === l2) {
      result2 = 0;
    } else {
      result2 = k3 > l2 ^ xNeg ? 1 : -1;
    }
    return result2;
  }
  /**
   * Generate a random string.
   * cf. http://stackoverflow.com/a/8084248/2834898
   *
   * @param {Number} strLength Length of the generated string (in character count)
   * @returns {string}
   */
  static randomString(strLength = 5) {
    return Math.random().toString(36).substr(2, strLength);
  }
  /**
   * Return the DOM element when passed either a DOM element or a selector string.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @returns {HTMLElement}
   */
  static domElement(domElementOrSelector) {
    let domElement;
    if (AutoNumericHelper.isString(domElementOrSelector)) {
      domElement = document.querySelector(domElementOrSelector);
    } else {
      domElement = domElementOrSelector;
    }
    return domElement;
  }
  /**
   * Retrieve the current element value.
   *
   * @param {HTMLElement|HTMLInputElement|EventTarget} element
   * @returns {number|string|null}
   */
  static getElementValue(element) {
    if (element.tagName.toLowerCase() === "input") {
      return element.value;
    }
    return this.text(element);
  }
  /**
   * Modify the element value directly.
   *
   * @param {HTMLElement|HTMLInputElement} element
   * @param {number|string|null} value
   */
  static setElementValue(element, value = null) {
    if (element.tagName.toLowerCase() === "input") {
      element.value = value;
    } else {
      element.textContent = value;
    }
  }
  /**
   * Set the invalid state for the given element.
   * A custom message can be passed as the second argument.
   * Note: This does not work with contenteditable elements
   *
   * @param {HTMLElement|HTMLInputElement} element
   * @param {string|null} message
   * @throws Error
   */
  static setInvalidState(element, message2 = "Invalid") {
    if (message2 === "" || this.isNull(message2)) this.throwError("Cannot set the invalid state with an empty message.");
    element.setCustomValidity(message2);
  }
  /**
   * Set the valid state for the given element.
   * Note: This does not work with contenteditable elements
   *
   * @param {HTMLElement|HTMLInputElement} element
   */
  static setValidState(element) {
    element.setCustomValidity("");
  }
  /**
   * This clone the given object, and return it.
   * WARNING: This does not do a deep cloning.
   * cf. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Examples
   * //TODO Add a `deep` option to clone object with more than one depth
   *
   * @param {object} obj
   * @returns {object}
   */
  static cloneObject(obj) {
    return Object.assign({}, obj);
  }
  /**
   * Return a 'camelized' version of the given string.
   * By default, this assume that :
   * - the separators are hyphens '-',
   * - the 'data-' string should be removed, and
   * - that the very first word should not be capitalized.
   *
   * @example camelize('data-currency-symbol') => 'currencySymbol'
   *
   * @param {string} str Text to camelize
   * @param {string} separator Character that separate each word
   * @param {boolean} removeData If set to `true`, remove the `data-` part that you can find on some html attributes
   * @param {boolean} skipFirstWord If set to `true`, do not capitalize the very first word
   * @returns {string|null}
   */
  static camelize(str, separator = "-", removeData = true, skipFirstWord = true) {
    if (this.isNull(str)) {
      return null;
    }
    if (removeData) {
      str = str.replace(/^data-/, "");
    }
    const words = str.split(separator);
    let result2 = words.map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`);
    result2 = result2.join("");
    if (skipFirstWord) {
      result2 = `${result2.charAt(0).toLowerCase()}${result2.slice(1)}`;
    }
    return result2;
  }
  /**
   * Return the text component of the given DOM element.
   *
   * @param {Element} domElement
   * @returns {string}
   */
  static text(domElement) {
    const nodeType = domElement.nodeType;
    let result2;
    if (nodeType === Node.ELEMENT_NODE || nodeType === Node.DOCUMENT_NODE || nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      result2 = domElement.textContent;
    } else if (nodeType === Node.TEXT_NODE) {
      result2 = domElement.nodeValue;
    } else {
      result2 = "";
    }
    return result2;
  }
  /**
   * Set the text content of the given DOM element.
   * @param {Element} domElement
   * @param {string} text
   */
  static setText(domElement, text) {
    const nodeType = domElement.nodeType;
    if (nodeType === Node.ELEMENT_NODE || nodeType === Node.DOCUMENT_NODE || nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      domElement.textContent = text;
    }
  }
  /**
   * Filter out the given `arr` array with the elements found in `excludedElements`.
   * This returns a new array and does not modify the source.
   * cf. verification here : http://codepen.io/AnotherLinuxUser/pen/XpvrMg?editors=0012
   *
   * @param {Array} arr
   * @param {Array} excludedElements
   * @returns {*|Array.<T>}
   */
  static filterOut(arr, excludedElements) {
    return arr.filter((element) => !this.isInArray(element, excludedElements));
  }
  /**
   * Remove the trailing zeros in the decimal part of a number.
   *
   * @param {string} numericString
   * @returns {*}
   */
  static trimPaddedZerosFromDecimalPlaces(numericString) {
    numericString = String(numericString);
    if (numericString === "") {
      return "";
    }
    const [integerPart, decimalPart] = numericString.split(".");
    if (this.isUndefinedOrNullOrEmpty(decimalPart)) {
      return integerPart;
    }
    const trimmedDecimalPart = decimalPart.replace(/0+$/g, "");
    let result2;
    if (trimmedDecimalPart === "") {
      result2 = integerPart;
    } else {
      result2 = `${integerPart}.${trimmedDecimalPart}`;
    }
    return result2;
  }
  /**
   * Return the top-most hovered item by the mouse cursor.
   *
   * @returns {*}
   */
  static getHoveredElement() {
    const hoveredElements = [...document.querySelectorAll(":hover")];
    return hoveredElements[hoveredElements.length - 1];
  }
  /**
   * Return the given array trimmed to the given length.
   * @example arrayTrim([1, 2, 3, 4], 2) -> [1, 2]
   *
   * @param {Array} array
   * @param {Number} length
   * @returns {*}
   */
  static arrayTrim(array, length) {
    const arrLength = array.length;
    if (arrLength === 0 || length > arrLength) {
      return array;
    }
    if (length < 0) {
      return [];
    }
    array.length = parseInt(length, 10);
    return array;
  }
  /**
   * Merge all the given arrays by keeping only unique elements, and return an array with de-duplicated values.
   * cf. http://stackoverflow.com/a/27664971/2834898
   *
   * @param {...array} arrays
   * @returns {[*]}
   */
  static arrayUnique(...arrays) {
    return [...new Set([].concat(...arrays))];
  }
  /**
   * Merge all the given Maps by keeping only unique elements, and return a new Map with de-duplicated keys.
   *
   * @param {...Map} mapObjects
   * @returns {Map}
   */
  static mergeMaps(...mapObjects) {
    return new Map(mapObjects.reduce((as2, b3) => as2.concat([...b3]), []));
  }
  /**
   * Search the given `value` in the object `obj`, and return the very first key it finds
   *
   * @param {object} obj
   * @param {string|number} value
   * @returns {*|null}
   */
  static objectKeyLookup(obj, value) {
    const result2 = Object.entries(obj).find((array) => array[1] === value);
    let key2 = null;
    if (result2 !== void 0) {
      key2 = result2[0];
    }
    return key2;
  }
  /**
   * Insert the single character `char` in the string `str` at the given position `index`
   *
   * @param {string} str
   * @param {string} char
   * @param {int} index
   * @returns {string}
   */
  static insertAt(str, char, index2) {
    str = String(str);
    if (index2 > str.length) {
      throw new Error(`The given index is out of the string range.`);
    }
    if (char.length !== 1) {
      throw new Error("The given string `char` should be only one character long.");
    }
    if (str === "" && index2 === 0) {
      return char;
    }
    return `${str.slice(0, index2)}${char}${str.slice(index2)}`;
  }
  /**
   * Convert the given scientific notation to the 'expanded' decimal notation
   *
   * @example scientificToDecimal('-123.4567e-6') returns '-0.0001234567'
   *
   * @param {number|string} val
   * @returns {number|string}
   */
  static scientificToDecimal(val) {
    const numericValue = Number(val);
    if (isNaN(numericValue)) {
      return NaN;
    }
    val = String(val);
    const isScientific = this.contains(val, "e") || this.contains(val, "E");
    if (!isScientific) {
      return val;
    }
    let [value, exponent] = val.split(/e/i);
    const isNegative = value < 0;
    if (isNegative) {
      value = value.replace("-", "");
    }
    const isNegativeExponent = +exponent < 0;
    if (isNegativeExponent) {
      exponent = exponent.replace("-", "");
    }
    const [int, float] = value.split(/\./);
    let result2;
    if (isNegativeExponent) {
      if (int.length > exponent) {
        result2 = this.insertAt(int, ".", int.length - exponent);
      } else {
        result2 = `0.${"0".repeat(exponent - int.length)}${int}`;
      }
      result2 = `${result2}${float ? float : ""}`;
    } else {
      if (float) {
        value = `${int}${float}`;
        if (exponent < float.length) {
          result2 = this.insertAt(value, ".", +exponent + int.length);
        } else {
          result2 = `${value}${"0".repeat(exponent - float.length)}`;
        }
      } else {
        value = value.replace(".", "");
        result2 = `${value}${"0".repeat(Number(exponent))}`;
      }
    }
    if (isNegative) {
      result2 = `-${result2}`;
    }
    return result2;
  }
}
class Evaluator {
  constructor(ast) {
    if (ast === null) {
      throw new Error(`Invalid AST`);
    }
  }
  evaluate(subtree) {
    if (subtree === void 0 || subtree === null) {
      throw new Error(`Invalid AST sub-tree`);
    }
    if (subtree.type === "number") {
      return subtree.value;
    } else if (subtree.type === "unaryMinus") {
      return -this.evaluate(subtree.left);
    } else {
      const left = this.evaluate(subtree.left);
      const right = this.evaluate(subtree.right);
      switch (subtree.type) {
        case "op_+":
          return Number(left) + Number(right);
        case "op_-":
          return left - right;
        case "op_*":
          return left * right;
        case "op_/":
          return left / right;
        default:
          throw new Error(`Invalid operator '${subtree.type}'`);
      }
    }
  }
}
class ASTNode {
  /*
  constructor() {
      // this.type = void(0);
      // this.value = 0;
      // this.left = null;
      // this.right = null;
  }
  */
  static createNode(type2, left, right) {
    const node3 = new ASTNode();
    node3.type = type2;
    node3.left = left;
    node3.right = right;
    return node3;
  }
  static createUnaryNode(left) {
    const node3 = new ASTNode();
    node3.type = "unaryMinus";
    node3.left = left;
    node3.right = null;
    return node3;
  }
  static createLeaf(value) {
    const node3 = new ASTNode();
    node3.type = "number";
    node3.value = value;
    return node3;
  }
}
class Token2 {
  constructor(type2, value, symbol2) {
    this.type = type2;
    this.value = value;
    this.symbol = symbol2;
  }
}
class Lexer {
  constructor(text) {
    this.text = text;
    this.textLength = text.length;
    this.index = 0;
    this.token = new Token2("Error", 0, 0);
  }
  /**
   * Ignore white spaces and increment the index count until a non-space character is found
   * @private
   */
  _skipSpaces() {
    while (this.text[this.index] === " " && this.index <= this.textLength) {
      this.index++;
    }
  }
  /**
   * Return the current index
   *
   * @returns {number}
   */
  getIndex() {
    return this.index;
  }
  /**
   * Return the next token object
   *
   * @param {string} decimalCharacter The decimal character to use in the float numbers
   * @returns {Token}
   */
  getNextToken(decimalCharacter = ".") {
    this._skipSpaces();
    if (this.textLength === this.index) {
      this.token.type = "EOT";
      return this.token;
    }
    if (AutoNumericHelper.isDigit(this.text[this.index])) {
      this.token.type = "num";
      this.token.value = this._getNumber(decimalCharacter);
      return this.token;
    }
    this.token.type = "Error";
    switch (this.text[this.index]) {
      case "+":
        this.token.type = "+";
        break;
      case "-":
        this.token.type = "-";
        break;
      case "*":
        this.token.type = "*";
        break;
      case "/":
        this.token.type = "/";
        break;
      case "(":
        this.token.type = "(";
        break;
      case ")":
        this.token.type = ")";
        break;
    }
    if (this.token.type !== "Error") {
      this.token.symbol = this.text[this.index];
      this.index++;
    } else {
      throw new Error(`Unexpected token '${this.token.symbol}' at position '${this.token.index}' in the token function`);
    }
    return this.token;
  }
  /**
   * Return the integer or float number starting from the `this.index` string index
   *
   * @param {string} decimalCharacter The decimal character to use in the float numbers
   *
   * @returns {string}
   * @private
   */
  _getNumber(decimalCharacter) {
    this._skipSpaces();
    const startIndex = this.index;
    while (this.index <= this.textLength && AutoNumericHelper.isDigit(this.text[this.index])) {
      this.index++;
    }
    if (this.text[this.index] === decimalCharacter) {
      this.index++;
    }
    while (this.index <= this.textLength && AutoNumericHelper.isDigit(this.text[this.index])) {
      this.index++;
    }
    if (this.index === startIndex) {
      throw new Error(`No number has been found while it was expected`);
    }
    return this.text.substring(startIndex, this.index).replace(decimalCharacter, ".");
  }
}
let Parser$3 = class Parser {
  /**
   * Parse the given string, and generate an abstract syntax tree (AST) from the math expression
   *
   * @param {string} text
   * @param {string} customDecimalCharacter The custom decimal character to use in floats
   * @returns {ASTNode}
   */
  constructor(text, customDecimalCharacter = ".") {
    this.text = text;
    this.decimalCharacter = customDecimalCharacter;
    this.lexer = new Lexer(text);
    this.token = this.lexer.getNextToken(this.decimalCharacter);
    return this._exp();
  }
  _exp() {
    const termNode = this._term();
    const exprNode = this._moreExp();
    return ASTNode.createNode("op_+", termNode, exprNode);
  }
  _moreExp() {
    let termNode;
    let exprNode;
    switch (this.token.type) {
      case "+":
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        termNode = this._term();
        exprNode = this._moreExp();
        return ASTNode.createNode("op_+", exprNode, termNode);
      case "-":
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        termNode = this._term();
        exprNode = this._moreExp();
        return ASTNode.createNode("op_-", exprNode, termNode);
    }
    return ASTNode.createLeaf(0);
  }
  _term() {
    const factorNode = this._factor();
    const termsNode = this._moreTerms();
    return ASTNode.createNode("op_*", factorNode, termsNode);
  }
  _moreTerms() {
    let factorNode;
    let termsNode;
    switch (this.token.type) {
      case "*":
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        factorNode = this._factor();
        termsNode = this._moreTerms();
        return ASTNode.createNode("op_*", termsNode, factorNode);
      case "/":
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        factorNode = this._factor();
        termsNode = this._moreTerms();
        return ASTNode.createNode("op_/", termsNode, factorNode);
    }
    return ASTNode.createLeaf(1);
  }
  _factor() {
    let expression;
    let factor;
    let value;
    switch (this.token.type) {
      case "num":
        value = this.token.value;
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        return ASTNode.createLeaf(value);
      case "-":
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        factor = this._factor();
        return ASTNode.createUnaryNode(factor);
      case "(":
        this.token = this.lexer.getNextToken(this.decimalCharacter);
        expression = this._exp();
        this._match(")");
        return expression;
      default: {
        throw new Error(`Unexpected token '${this.token.symbol}' with type '${this.token.type}' at position '${this.token.index}' in the factor function`);
      }
    }
  }
  _match(expected) {
    const index2 = this.lexer.getIndex() - 1;
    if (this.text[index2] === expected) {
      this.token = this.lexer.getNextToken(this.decimalCharacter);
    } else {
      throw new Error(`Unexpected token '${this.token.symbol}' at position '${index2}' in the match function`);
    }
  }
};
/**
 *               AutoNumeric.js
 *
 * @version      4.10.5
 * @date         2024-02-06 UTC 20:14
 *
 * @authors      2016-2024 Alexandre Bonneau <alexandre.bonneau@linuxfr.eu>
 *               2009-2016 Bob Knothe <bob.knothe@gmail.com>
 * @contributors Sokolov Yura and others, cf. AUTHORS
 * @copyright    Alexandre Bonneau & Robert J. Knothe
 * @since        2009-08-09
 *
 * @summary      AutoNumeric is a standalone Javascript library
 *               that provides live *as-you-type* formatting for
 *               international numbers and currencies.
 *
 * @link         http://autonumeric.org
 * @docs         https://docs.autonumeric.org
 *
 *               Note : Some functions are borrowed from big.js
 * @see          https://github.com/MikeMcl/big.js/
 *
 * Please report any bugs to https://github.com/autoNumeric/autoNumeric
 *
 * @license      Released under the MIT License
 * @link         http://www.opensource.org/licenses/mit-license.php
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sub license, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */
const _AutoNumeric = class _AutoNumeric {
  /**
   * Return the autoNumeric version number (for debugging purpose)
   *
   * @returns {string}
   */
  static version() {
    return "4.10.5";
  }
  /**
   * Initialize the AutoNumeric object onto the given DOM element, and attach the settings and related event listeners to it.
   * The options passed as a parameter is an object that contains the settings (i.e. {digitGroupSeparator: ".", decimalCharacter: ",", currencySymbol: '€ '})
   *
   * @example
   * anElement = new AutoNumeric(domElement); // With the default options
   * anElement = new AutoNumeric(domElement, { options }); // With one option object
   * anElement = new AutoNumeric(domElement, 'euroPos'); // With a named pre-defined string
   * anElement = new AutoNumeric(domElement, [{ options1 }, 'euroPos', { options2 }]); // With multiple option objects (the latest option overwriting the previous ones)
   * anElement = new AutoNumeric(domElement, null, { options }); // With one option object, and a failed initial value
   * anElement = new AutoNumeric(domElement).french(); // With one pre-defined language object
   * anElement = new AutoNumeric(domElement).french({ options });// With one pre-defined language object and additional options that will override the defaults
   *
   * // ...or init and set the value in one call :
   * anElement = new AutoNumeric(domElement, 12345.789); // With the default options, and an initial value
   * anElement = new AutoNumeric(domElement, 12345.789, { options });
   * anElement = new AutoNumeric(domElement, '12345.789', { options });
   * anElement = new AutoNumeric(domElement, 12345.789, 'euroPos');
   * anElement = new AutoNumeric(domElement, 12345.789, [{ options1 }, 'euroPos', { options2 }]);
   * anElement = new AutoNumeric(domElement, 12345.789).french({ options });
   * anElement = new AutoNumeric(domElement, 12345.789, { options }).french({ options }); // Not really helpful, but possible
   *
   * // The AutoNumeric constructor class can also accept a string as a css selector. Under the hood this use `QuerySelector` and limit itself to only the first element it finds.
   * anElement = new AutoNumeric('.myCssClass > input');
   * anElement = new AutoNumeric('.myCssClass > input', { options });
   * anElement = new AutoNumeric('.myCssClass > input', 'euroPos');
   * anElement = new AutoNumeric('.myCssClass > input', [{ options1 }, 'euroPos', { options2 }]);
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789);
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789, { options });
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789, 'euroPos');
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789, [{ options1 }, 'euroPos', { options2 }]);
   * anElement = new AutoNumeric('.myCssClass > input', null, { options }); // With a failed initial value
   * anElement = new AutoNumeric('.myCssClass > input', 12345.789).french({ options });
   *
   * @param {object|Array|number|string} arg1
   * @param {object|Array|number|string|null} arg2
   * @param {object|Array|number|string|null} arg3
   * @throws
   */
  constructor(arg1 = null, arg2 = null, arg3 = null) {
    const { domElement, initialValue, userOptions } = _AutoNumeric._setArgumentsValues(arg1, arg2, arg3);
    this.domElement = domElement;
    this.defaultRawValue = "";
    this._setSettings(userOptions, false);
    this._checkElement();
    this.savedCancellableValue = null;
    this.historyTable = [];
    this.historyTableIndex = -1;
    this.onGoingRedo = false;
    this.parentForm = this._getParentForm();
    if (!this.runOnce && this.settings.formatOnPageLoad) {
      this._formatDefaultValueOnPageLoad(initialValue);
    } else {
      let valueToSet;
      if (AutoNumericHelper.isNull(initialValue)) {
        switch (this.settings.emptyInputBehavior) {
          case _AutoNumeric.options.emptyInputBehavior.min:
            valueToSet = this.settings.minimumValue;
            break;
          case _AutoNumeric.options.emptyInputBehavior.max:
            valueToSet = this.settings.maximumValue;
            break;
          case _AutoNumeric.options.emptyInputBehavior.zero:
            valueToSet = "0";
            break;
          case _AutoNumeric.options.emptyInputBehavior.focus:
          case _AutoNumeric.options.emptyInputBehavior.press:
          case _AutoNumeric.options.emptyInputBehavior.always:
            valueToSet = "";
            break;
          case _AutoNumeric.options.emptyInputBehavior.null:
            valueToSet = null;
            break;
          default:
            valueToSet = this.settings.emptyInputBehavior;
        }
      } else {
        valueToSet = initialValue;
      }
      this._setElementAndRawValue(valueToSet);
    }
    this.runOnce = true;
    this.hasEventListeners = false;
    if (this.isInputElement || this.isContentEditable) {
      if (!this.settings.noEventListeners) {
        this._createEventListeners();
      }
      this._setWritePermissions(true);
    }
    this._saveInitialValues(initialValue);
    this.storageNamePrefix = "AUTO_";
    this._setPersistentStorageName();
    this.validState = true;
    this.isFocused = false;
    this.isWheelEvent = false;
    this.isDropEvent = false;
    this.isEditing = false;
    this.rawValueOnFocus = void 0;
    this.internalModification = false;
    this.attributeToWatch = this._getAttributeToWatch();
    this.getterSetter = Object.getOwnPropertyDescriptor(this.domElement.__proto__, this.attributeToWatch);
    this._addWatcher();
    if (this.settings.createLocalList) {
      this._createLocalList();
    }
    this.constructor._addToGlobalList(this);
    this.global = {
      /**
       * Set the same given element value for each element in the local AutoNumeric element list, and format those elements immediately
       *
       * @param {number|string} newValue The value must be a number or a numeric string
       * @param {object} options A settings object that will override the current settings. Note: the update is done only if the `newValue` is defined.
       */
      set: (newValue, options = null) => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.set(newValue, options);
        });
      },
      /**
       * Set the value given value directly as the DOM element value, without formatting it beforehand.
       * This sets the same unformatted value for each element in the local AutoNumeric element list.
       *
       * @param {number|string} value
       * @param {object} options
       */
      setUnformatted: (value, options = null) => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.setUnformatted(value, options);
        });
      },
      /**
       * This is an alias of the `getNumericString()` function, and should not be used anymore.
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<string>}
       * @deprecated
       */
      get: (callback = null) => {
        const result2 = [];
        this.autoNumericLocalList.forEach((aNObject) => {
          result2.push(aNObject.get());
        });
        this._executeCallback(result2, callback);
        return result2;
      },
      /**
       * Return an array of the unformatted values (as a string) of each AutoNumeric element of the local AutoNumeric element list
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<string>}
       */
      getNumericString: (callback = null) => {
        const result2 = [];
        this.autoNumericLocalList.forEach((aNObject) => {
          result2.push(aNObject.getNumericString());
        });
        this._executeCallback(result2, callback);
        return result2;
      },
      /**
       * Return an array of the current formatted values (as a string) of each AutoNumeric element of the local AutoNumeric element list
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<string>}
       */
      getFormatted: (callback = null) => {
        const result2 = [];
        this.autoNumericLocalList.forEach((aNObject) => {
          result2.push(aNObject.getFormatted());
        });
        this._executeCallback(result2, callback);
        return result2;
      },
      /**
       * Return an array of the element unformatted values (as a real Javascript number), for each element of the local AutoNumeric element list
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<number>}
       */
      getNumber: (callback = null) => {
        const result2 = [];
        this.autoNumericLocalList.forEach((aNObject) => {
          result2.push(aNObject.getNumber());
        });
        this._executeCallback(result2, callback);
        return result2;
      },
      /**
       * Returns the unformatted values (following the `outputFormat` setting) of each element of the local AutoNumeric element list into an array
       *
       * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
       * @returns {Array<string>}
       */
      getLocalized: (callback = null) => {
        const result2 = [];
        this.autoNumericLocalList.forEach((aNObject) => {
          result2.push(aNObject.getLocalized());
        });
        this._executeCallback(result2, callback);
        return result2;
      },
      /**
       * Force each element of the local AutoNumeric element list to reformat its value
       */
      reformat: () => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.reformat();
        });
      },
      /**
       * Remove the formatting and keep only the raw unformatted value (as a numericString) in each element of the local AutoNumeric element list
       */
      unformat: () => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.unformat();
        });
      },
      /**
       * Remove the formatting and keep only the localized unformatted value in the element, with the option to override the default outputFormat if needed
       *
       * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
       */
      unformatLocalized: (forcedOutputFormat = null) => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.unformatLocalized(forcedOutputFormat);
        });
      },
      /**
       * Updates the AutoNumeric settings, and immediately format the elements accordingly, for each element of the local AutoNumeric element list
       *
       * @param {object} newOptions This can be either one or more option objects
       */
      update: (...newOptions) => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.update(...newOptions);
        });
      },
      /**
       * Return `true` if *all* the autoNumeric-managed elements are pristine, if their raw value hasn't changed.
       * By default, this returns `true` if the raw unformatted value is still the same even if the formatted one has changed (due to a configuration update for instance).
       *
       * @param {boolean} checkOnlyRawValue If set to `true`, the pristine value is done on the raw unformatted value, not the formatted one. If set to `false`, this also checks that the formatted value hasn't changed.
       * @returns {boolean}
       */
      isPristine: (checkOnlyRawValue = true) => {
        let isPristine = true;
        this.autoNumericLocalList.forEach((aNObject) => {
          if (isPristine && !aNObject.isPristine(checkOnlyRawValue)) {
            isPristine = false;
          }
        });
        return isPristine;
      },
      /**
       * Execute the `clear()` method on each AutoNumeric object in the local AutoNumeric element list
       *
       * @param {boolean} forceClearAll
       */
      clear: (forceClearAll = false) => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.clear(forceClearAll);
        });
      },
      /**
       * Execute the `remove()` method on each AutoNumeric object in the local AutoNumeric element list
       */
      remove: () => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.remove();
        });
      },
      /**
       * Execute the `wipe()` method on each AutoNumeric object in the local AutoNumeric element list
       */
      wipe: () => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.wipe();
        });
      },
      /**
       * Execute the `nuke()` method on each AutoNumeric object in the local AutoNumeric element list
       */
      nuke: () => {
        this.autoNumericLocalList.forEach((aNObject) => {
          aNObject.nuke();
        });
      },
      /**
       * Return `true` if the given AutoNumeric object (or DOM element) is in the local AutoNumeric element list
       *
       * @param {HTMLElement|HTMLInputElement|AutoNumeric} domElementOrAutoNumericObject
       * @returns {*}
       */
      has: (domElementOrAutoNumericObject) => {
        let result2;
        if (domElementOrAutoNumericObject instanceof _AutoNumeric) {
          result2 = this.autoNumericLocalList.has(domElementOrAutoNumericObject.node());
        } else {
          result2 = this.autoNumericLocalList.has(domElementOrAutoNumericObject);
        }
        return result2;
      },
      /**
       * Add an existing AutoNumeric object (or DOM element) to the local AutoNumeric element list, using the DOM element as the key.
       * This manages the case where `addObject` is used on an AutoNumeric object that already has multiple elements in its local list.
       *
       * @param {HTMLElement|HTMLInputElement|AutoNumeric} domElementOrAutoNumericObject
       */
      addObject: (domElementOrAutoNumericObject) => {
        let domElement2;
        let otherAutoNumericObject;
        if (domElementOrAutoNumericObject instanceof _AutoNumeric) {
          domElement2 = domElementOrAutoNumericObject.node();
          otherAutoNumericObject = domElementOrAutoNumericObject;
        } else {
          domElement2 = domElementOrAutoNumericObject;
          otherAutoNumericObject = _AutoNumeric.getAutoNumericElement(domElement2);
        }
        if (!this._hasLocalList()) {
          this._createLocalList();
        }
        let otherANLocalList = otherAutoNumericObject._getLocalList();
        if (otherANLocalList.size === 0) {
          otherAutoNumericObject._createLocalList();
          otherANLocalList = otherAutoNumericObject._getLocalList();
        }
        let mergedLocalLists;
        if (otherANLocalList instanceof Map) {
          mergedLocalLists = AutoNumericHelper.mergeMaps(this._getLocalList(), otherANLocalList);
        } else {
          this._addToLocalList(domElement2, otherAutoNumericObject);
          mergedLocalLists = this._getLocalList();
        }
        mergedLocalLists.forEach((aNObject) => {
          aNObject._setLocalList(mergedLocalLists);
        });
      },
      /**
       * Remove the given AutoNumeric object (or DOM element) from the local AutoNumeric element list, using the DOM element as the key.
       * If this function attempts to remove the current AutoNumeric object from the local list, a warning is shown, but the deletion is still done.
       *
       * Special cases :
       * - If the current object removes itself, then it's removed from the shared local list, then a new empty local list is used/created
       * - If another object remove this object, then a local list with only this object is used/created
       *
       * @param {HTMLElement|HTMLInputElement|AutoNumeric} domElementOrAutoNumericObject
       * @param {boolean} keepCurrentANObject If set to `false`, then the function will also remove the current AutoNumeric object if asked, otherwise it will ignore it and print a warning message
       */
      removeObject: (domElementOrAutoNumericObject, keepCurrentANObject = false) => {
        let domElement2;
        let otherAutoNumericObject;
        if (domElementOrAutoNumericObject instanceof _AutoNumeric) {
          domElement2 = domElementOrAutoNumericObject.node();
          otherAutoNumericObject = domElementOrAutoNumericObject;
        } else {
          domElement2 = domElementOrAutoNumericObject;
          otherAutoNumericObject = _AutoNumeric.getAutoNumericElement(domElement2);
        }
        const initialCompleteLocalList = this.autoNumericLocalList;
        this.autoNumericLocalList.delete(domElement2);
        initialCompleteLocalList.forEach((aNObject) => {
          aNObject._setLocalList(this.autoNumericLocalList);
        });
        if (!keepCurrentANObject && domElement2 === this.node()) {
          otherAutoNumericObject._setLocalList(/* @__PURE__ */ new Map());
        } else {
          otherAutoNumericObject._createLocalList();
        }
      },
      /**
       * Remove all elements from the shared list, effectively emptying it.
       * This is the equivalent of calling `detach()` on each of its elements.
       *
       * @param {boolean} keepEachANObjectInItsOwnList If set to `true`, then instead of completely emptying the local list of each AutoNumeric objects, each one of those keeps itself in its own local list
       */
      empty: (keepEachANObjectInItsOwnList = false) => {
        const initialCompleteLocalList = this.autoNumericLocalList;
        initialCompleteLocalList.forEach((aNObject) => {
          if (keepEachANObjectInItsOwnList) {
            aNObject._createLocalList();
          } else {
            aNObject._setLocalList(/* @__PURE__ */ new Map());
          }
        });
      },
      /**
       * Return an array containing all the AutoNumeric DOM elements that have been initialized by each other
       *
       * @returns {Array<HTMLElement>}
       */
      elements: () => {
        const result2 = [];
        this.autoNumericLocalList.forEach((aNObject) => {
          result2.push(aNObject.node());
        });
        return result2;
      },
      /**
       * Return the `Map` object directly
       * @returns {Map}
       */
      getList: () => this.autoNumericLocalList,
      /**
       * Return the number of element in the local AutoNumeric element list
       * @returns {number}
       */
      size: () => this.autoNumericLocalList.size
    };
    this.options = {
      /**
       * Reset any options set previously, by overwriting them with the default settings
       *
       * @returns {AutoNumeric}
       */
      reset: () => {
        this.settings = { rawValue: this.defaultRawValue };
        this.update(_AutoNumeric.defaultSettings);
        return this;
      },
      allowDecimalPadding: (allowDecimalPadding) => {
        this.update({ allowDecimalPadding });
        return this;
      },
      alwaysAllowDecimalCharacter: (alwaysAllowDecimalCharacter) => {
        this.update({ alwaysAllowDecimalCharacter });
        return this;
      },
      caretPositionOnFocus: (caretPositionOnFocus) => {
        this.settings.caretPositionOnFocus = caretPositionOnFocus;
        return this;
      },
      createLocalList: (createLocalList) => {
        this.settings.createLocalList = createLocalList;
        if (this.settings.createLocalList) {
          if (!this._hasLocalList()) {
            this._createLocalList();
          }
        } else {
          this._deleteLocalList();
        }
        return this;
      },
      currencySymbol: (currencySymbol) => {
        this.update({ currencySymbol });
        return this;
      },
      currencySymbolPlacement: (currencySymbolPlacement) => {
        this.update({ currencySymbolPlacement });
        return this;
      },
      decimalCharacter: (decimalCharacter) => {
        this.update({ decimalCharacter });
        return this;
      },
      decimalCharacterAlternative: (decimalCharacterAlternative) => {
        this.settings.decimalCharacterAlternative = decimalCharacterAlternative;
        return this;
      },
      /**
       * Update the decimal places globally, which means this override any previously set number of decimal shown on focus, on blur, or in the raw value.
       *
       * @param {int} decimalPlaces
       * @returns {AutoNumeric}
       */
      decimalPlaces: (decimalPlaces) => {
        AutoNumericHelper.warning("Using `options.decimalPlaces()` instead of calling the specific `options.decimalPlacesRawValue()`, `options.decimalPlacesShownOnFocus()` and `options.decimalPlacesShownOnBlur()` methods will reset those options.\nPlease call the specific methods if you do not want to reset those.", this.settings.showWarnings);
        this.update({ decimalPlaces });
        return this;
      },
      decimalPlacesRawValue: (decimalPlacesRawValue) => {
        this.update({ decimalPlacesRawValue });
        return this;
      },
      decimalPlacesShownOnBlur: (decimalPlacesShownOnBlur) => {
        this.update({ decimalPlacesShownOnBlur });
        return this;
      },
      decimalPlacesShownOnFocus: (decimalPlacesShownOnFocus) => {
        this.update({ decimalPlacesShownOnFocus });
        return this;
      },
      defaultValueOverride: (defaultValueOverride) => {
        this.update({ defaultValueOverride });
        return this;
      },
      digitalGroupSpacing: (digitalGroupSpacing) => {
        this.update({ digitalGroupSpacing });
        return this;
      },
      digitGroupSeparator: (digitGroupSeparator) => {
        this.update({ digitGroupSeparator });
        return this;
      },
      divisorWhenUnfocused: (divisorWhenUnfocused) => {
        this.update({ divisorWhenUnfocused });
        return this;
      },
      emptyInputBehavior: (emptyInputBehavior) => {
        if (this.rawValue === null && emptyInputBehavior !== _AutoNumeric.options.emptyInputBehavior.null) {
          AutoNumericHelper.warning(`You are trying to modify the \`emptyInputBehavior\` option to something different than \`'null'\` (${emptyInputBehavior}), but the element raw value is currently set to \`null\`. This would result in an invalid \`rawValue\`. In order to fix that, the element value has been changed to the empty string \`''\`.`, this.settings.showWarnings);
          this.rawValue = "";
        }
        this.update({ emptyInputBehavior });
        return this;
      },
      eventBubbles: (eventBubbles) => {
        this.settings.eventBubbles = eventBubbles;
        return this;
      },
      eventIsCancelable: (eventIsCancelable) => {
        this.settings.eventIsCancelable = eventIsCancelable;
        return this;
      },
      failOnUnknownOption: (failOnUnknownOption) => {
        this.settings.failOnUnknownOption = failOnUnknownOption;
        return this;
      },
      formatOnPageLoad: (formatOnPageLoad) => {
        this.settings.formatOnPageLoad = formatOnPageLoad;
        return this;
      },
      formulaMode: (formulaMode) => {
        this.settings.formulaMode = formulaMode;
        return this;
      },
      historySize: (historySize) => {
        this.settings.historySize = historySize;
        return this;
      },
      invalidClass: (invalidClass) => {
        this.settings.invalidClass = invalidClass;
        return this;
      },
      isCancellable: (isCancellable) => {
        this.settings.isCancellable = isCancellable;
        return this;
      },
      leadingZero: (leadingZero) => {
        this.update({ leadingZero });
        return this;
      },
      maximumValue: (maximumValue2) => {
        this.update({ maximumValue: maximumValue2 });
        return this;
      },
      minimumValue: (minimumValue2) => {
        this.update({ minimumValue: minimumValue2 });
        return this;
      },
      modifyValueOnUpDownArrow: (modifyValueOnUpDownArrow) => {
        this.settings.modifyValueOnUpDownArrow = modifyValueOnUpDownArrow;
        return this;
      },
      modifyValueOnWheel: (modifyValueOnWheel) => {
        this.settings.modifyValueOnWheel = modifyValueOnWheel;
        return this;
      },
      negativeBracketsTypeOnBlur: (negativeBracketsTypeOnBlur) => {
        this.update({ negativeBracketsTypeOnBlur });
        return this;
      },
      negativePositiveSignPlacement: (negativePositiveSignPlacement) => {
        this.update({ negativePositiveSignPlacement });
        return this;
      },
      negativeSignCharacter: (negativeSignCharacter) => {
        this.update({ negativeSignCharacter });
        return this;
      },
      negativePositiveSignBehavior: (negativePositiveSignBehavior) => {
        this.settings.negativePositiveSignBehavior = negativePositiveSignBehavior;
        return this;
      },
      noEventListeners: (noEventListeners) => {
        if (noEventListeners === _AutoNumeric.options.noEventListeners.noEvents && this.settings.noEventListeners === _AutoNumeric.options.noEventListeners.addEvents) {
          this._removeEventListeners();
        }
        this.update({ noEventListeners });
        return this;
      },
      onInvalidPaste: (onInvalidPaste) => {
        this.settings.onInvalidPaste = onInvalidPaste;
        return this;
      },
      outputFormat: (outputFormat) => {
        this.settings.outputFormat = outputFormat;
        return this;
      },
      overrideMinMaxLimits: (overrideMinMaxLimits) => {
        this.update({ overrideMinMaxLimits });
        return this;
      },
      positiveSignCharacter: (positiveSignCharacter) => {
        this.update({ positiveSignCharacter });
        return this;
      },
      rawValueDivisor: (rawValueDivisor) => {
        this.update({ rawValueDivisor });
        return this;
      },
      readOnly: (readOnly) => {
        this.settings.readOnly = readOnly;
        this._setWritePermissions();
        return this;
      },
      roundingMethod: (roundingMethod) => {
        this.update({ roundingMethod });
        return this;
      },
      saveValueToSessionStorage: (saveValueToSessionStorage) => {
        this.update({ saveValueToSessionStorage });
        return this;
      },
      symbolWhenUnfocused: (symbolWhenUnfocused) => {
        this.update({ symbolWhenUnfocused });
        return this;
      },
      selectNumberOnly: (selectNumberOnly) => {
        this.settings.selectNumberOnly = selectNumberOnly;
        return this;
      },
      selectOnFocus: (selectOnFocus) => {
        this.settings.selectOnFocus = selectOnFocus;
        return this;
      },
      serializeSpaces: (serializeSpaces) => {
        this.settings.serializeSpaces = serializeSpaces;
        return this;
      },
      showOnlyNumbersOnFocus: (showOnlyNumbersOnFocus) => {
        this.update({ showOnlyNumbersOnFocus });
        return this;
      },
      showPositiveSign: (showPositiveSign) => {
        this.update({ showPositiveSign });
        return this;
      },
      showWarnings: (showWarnings) => {
        this.settings.showWarnings = showWarnings;
        return this;
      },
      styleRules: (styleRules) => {
        this.update({ styleRules });
        return this;
      },
      suffixText: (suffixText) => {
        this.update({ suffixText });
        return this;
      },
      unformatOnHover: (unformatOnHover) => {
        this.settings.unformatOnHover = unformatOnHover;
        return this;
      },
      unformatOnSubmit: (unformatOnSubmit) => {
        this.settings.unformatOnSubmit = unformatOnSubmit;
        return this;
      },
      upDownStep: (upDownStep) => {
        this.settings.upDownStep = upDownStep;
        return this;
      },
      valuesToStrings: (valuesToStrings) => {
        this.update({ valuesToStrings });
        return this;
      },
      watchExternalChanges: (watchExternalChanges) => {
        this.update({ watchExternalChanges });
        return this;
      },
      wheelOn: (wheelOn) => {
        this.settings.wheelOn = wheelOn;
        return this;
      },
      wheelStep: (wheelStep) => {
        this.settings.wheelStep = wheelStep;
        return this;
      }
    };
    this._triggerEvent(_AutoNumeric.events.initialized, this.domElement, {
      newValue: AutoNumericHelper.getElementValue(this.domElement),
      newRawValue: this.rawValue,
      error: null,
      aNElement: this
    });
  }
  /**
   * Take the parameters given to the AutoNumeric object, and output the three variables that are needed to finish initializing it :
   * - domElement : The target DOM element
   * - initialValue : The initial value, or `null` if none is given
   * - userOptions : The option object
   *
   * @param {object|Array|number|string} arg1
   * @param {object|Array|number|string|null} arg2
   * @param {object|Array|number|string|null} arg3
   * @returns {{domElement: *, initialValue: *, userOptions: *}}
   * @throws
   * @private
   */
  static _setArgumentsValues(arg1, arg2, arg3) {
    if (AutoNumericHelper.isNull(arg1)) {
      AutoNumericHelper.throwError("At least one valid parameter is needed in order to initialize an AutoNumeric object");
    }
    const isArg1Element = AutoNumericHelper.isElement(arg1);
    const isArg1String = AutoNumericHelper.isString(arg1);
    const isArg2Object = AutoNumericHelper.isObject(arg2);
    const isArg2Array = Array.isArray(arg2) && arg2.length > 0;
    const isArg2Number = AutoNumericHelper.isNumberOrArabic(arg2) || arg2 === "";
    const isArg2PreDefinedOptionName = this._isPreDefinedOptionValid(arg2);
    const isArg2Null = AutoNumericHelper.isNull(arg2);
    const isArg2EmptyString = AutoNumericHelper.isEmptyString(arg2);
    const isArg3Object = AutoNumericHelper.isObject(arg3);
    const isArg3Array = Array.isArray(arg3) && arg3.length > 0;
    const isArg3Null = AutoNumericHelper.isNull(arg3);
    const isArg3PreDefinedOptionName = this._isPreDefinedOptionValid(arg3);
    let domElement;
    let userOptions;
    let initialValue;
    if (isArg1Element && isArg2Null && isArg3Null) {
      domElement = arg1;
      initialValue = null;
      userOptions = null;
    } else if (isArg1Element && isArg2Number && isArg3Null) {
      domElement = arg1;
      initialValue = arg2;
      userOptions = null;
    } else if (isArg1Element && isArg2Object && isArg3Null) {
      domElement = arg1;
      initialValue = null;
      userOptions = arg2;
    } else if (isArg1Element && isArg2PreDefinedOptionName && isArg3Null) {
      domElement = arg1;
      initialValue = null;
      userOptions = this._getOptionObject(arg2);
    } else if (isArg1Element && isArg2Array && isArg3Null) {
      domElement = arg1;
      initialValue = null;
      userOptions = this.mergeOptions(arg2);
    } else if (isArg1Element && (isArg2Null || isArg2EmptyString) && isArg3Object) {
      domElement = arg1;
      initialValue = null;
      userOptions = arg3;
    } else if (isArg1Element && (isArg2Null || isArg2EmptyString) && isArg3Array) {
      domElement = arg1;
      initialValue = null;
      userOptions = this.mergeOptions(arg3);
    } else if (isArg1String && isArg2Null && isArg3Null) {
      domElement = document.querySelector(arg1);
      initialValue = null;
      userOptions = null;
    } else if (isArg1String && isArg2Object && isArg3Null) {
      domElement = document.querySelector(arg1);
      initialValue = null;
      userOptions = arg2;
    } else if (isArg1String && isArg2PreDefinedOptionName && isArg3Null) {
      domElement = document.querySelector(arg1);
      initialValue = null;
      userOptions = this._getOptionObject(arg2);
    } else if (isArg1String && isArg2Array && isArg3Null) {
      domElement = document.querySelector(arg1);
      initialValue = null;
      userOptions = this.mergeOptions(arg2);
    } else if (isArg1String && (isArg2Null || isArg2EmptyString) && isArg3Object) {
      domElement = document.querySelector(arg1);
      initialValue = null;
      userOptions = arg3;
    } else if (isArg1String && (isArg2Null || isArg2EmptyString) && isArg3Array) {
      domElement = document.querySelector(arg1);
      initialValue = null;
      userOptions = this.mergeOptions(arg3);
    } else if (isArg1String && isArg2Number && isArg3Null) {
      domElement = document.querySelector(arg1);
      initialValue = arg2;
      userOptions = null;
    } else if (isArg1String && isArg2Number && isArg3Object) {
      domElement = document.querySelector(arg1);
      initialValue = arg2;
      userOptions = arg3;
    } else if (isArg1String && isArg2Number && isArg3PreDefinedOptionName) {
      domElement = document.querySelector(arg1);
      initialValue = arg2;
      userOptions = this._getOptionObject(arg3);
    } else if (isArg1String && isArg2Number && isArg3Array) {
      domElement = document.querySelector(arg1);
      initialValue = arg2;
      userOptions = this.mergeOptions(arg3);
    } else if (isArg1Element && isArg2Number && isArg3Object) {
      domElement = arg1;
      initialValue = arg2;
      userOptions = arg3;
    } else if (isArg1Element && isArg2Number && isArg3PreDefinedOptionName) {
      domElement = arg1;
      initialValue = arg2;
      userOptions = this._getOptionObject(arg3);
    } else if (isArg1Element && isArg2Number && isArg3Array) {
      domElement = arg1;
      initialValue = arg2;
      userOptions = this.mergeOptions(arg3);
    } else {
      AutoNumericHelper.throwError(`The parameters given to the AutoNumeric object are not valid, '${arg1}', '${arg2}' and '${arg3}' given.`);
    }
    if (AutoNumericHelper.isNull(domElement)) {
      AutoNumericHelper.throwError(`The selector '${arg1}' did not select any valid DOM element. Please check on which element you called AutoNumeric.`);
    }
    return { domElement, initialValue, userOptions };
  }
  /**
   * Merge the option objects found in the given array `optionsArray`.
   * If a `string` is found, then we try to get the related pre-defined option using that string as its name.
   * When merging the options, the latest option overwrite any previously set. This allows to fine tune a pre-defined option for instance.
   *
   * @param {Array<object|string>} optionsArray
   * @returns {{}}
   */
  static mergeOptions(optionsArray) {
    const mergedOptions = {};
    optionsArray.forEach((optionObjectOrPredefinedOptionString) => {
      Object.assign(mergedOptions, this._getOptionObject(optionObjectOrPredefinedOptionString));
    });
    return mergedOptions;
  }
  /**
   * Return `true` if the given pre-defined option name is an attribute of the `AutoNumeric.predefinedOptions` object
   *
   * @param {string} preDefinedOptionName
   * @returns {boolean}
   * @private
   */
  static _isPreDefinedOptionValid(preDefinedOptionName) {
    return Object.prototype.hasOwnProperty.call(_AutoNumeric.predefinedOptions, preDefinedOptionName);
  }
  /**
   * Return an option object based on the given parameter.
   * If `optionObjectOrPredefinedName` is as string, then we retrieve the pre-defined option object, if it's an object, we use it as is.
   *
   * @param {object|string} optionObjectOrPredefinedName
   * @returns {object}
   */
  static _getOptionObject(optionObjectOrPredefinedName) {
    let options;
    if (AutoNumericHelper.isString(optionObjectOrPredefinedName)) {
      options = _AutoNumeric.getPredefinedOptions()[optionObjectOrPredefinedName];
      if (options === void 0 || options === null) {
        AutoNumericHelper.warning(`The given pre-defined option [${optionObjectOrPredefinedName}] is not recognized by autoNumeric. Please check that pre-defined option name.`, true);
      }
    } else {
      options = optionObjectOrPredefinedName;
    }
    return options;
  }
  /**
   * Save the initial element values for later use in the pristine test.
   * Those values are :
   * - the html attribute (i.e. <input value='42'>), and
   * - the script `value` (i.e. `let domElement.value`)
   *
   * @param {null|number|string} initialValue
   * @private
   */
  _saveInitialValues(initialValue) {
    this.initialValueHtmlAttribute = AutoNumericHelper.scientificToDecimal(this.domElement.getAttribute("value"));
    if (AutoNumericHelper.isNull(this.initialValueHtmlAttribute)) {
      this.initialValueHtmlAttribute = "";
    }
    this.initialValue = initialValue;
    if (AutoNumericHelper.isNull(this.initialValue)) {
      this.initialValue = "";
    }
  }
  /**
   * Generate all the event listeners for the given DOM element
   * @private
   */
  _createEventListeners() {
    this.formulaMode = false;
    this._onFocusInFunc = (e5) => {
      this._onFocusIn(e5);
    };
    this._onFocusInAndMouseEnterFunc = (e5) => {
      this._onFocusInAndMouseEnter(e5);
    };
    this._onFocusFunc = () => {
      this._onFocus();
    };
    this._onKeydownFunc = (e5) => {
      this._onKeydown(e5);
    };
    this._onKeypressFunc = (e5) => {
      this._onKeypress(e5);
    };
    this._onKeyupFunc = (e5) => {
      this._onKeyup(e5);
    };
    this._onFocusOutAndMouseLeaveFunc = (e5) => {
      this._onFocusOutAndMouseLeave(e5);
    };
    this._onPasteFunc = (e5) => {
      this._onPaste(e5);
    };
    this._onWheelFunc = (e5) => {
      this._onWheel(e5);
    };
    this._onDropFunc = (e5) => {
      this._onDrop(e5);
    };
    this._onKeydownGlobalFunc = (e5) => {
      this._onKeydownGlobal(e5);
    };
    this._onKeyupGlobalFunc = (e5) => {
      this._onKeyupGlobal(e5);
    };
    this.domElement.addEventListener("focusin", this._onFocusInFunc, false);
    this.domElement.addEventListener("focus", this._onFocusInAndMouseEnterFunc, false);
    this.domElement.addEventListener("focus", this._onFocusFunc, false);
    this.domElement.addEventListener("mouseenter", this._onFocusInAndMouseEnterFunc, false);
    this.domElement.addEventListener("keydown", this._onKeydownFunc, false);
    this.domElement.addEventListener("keypress", this._onKeypressFunc, false);
    this.domElement.addEventListener("keyup", this._onKeyupFunc, false);
    this.domElement.addEventListener("blur", this._onFocusOutAndMouseLeaveFunc, false);
    this.domElement.addEventListener("mouseleave", this._onFocusOutAndMouseLeaveFunc, false);
    this.domElement.addEventListener("paste", this._onPasteFunc, false);
    this.domElement.addEventListener("wheel", this._onWheelFunc, false);
    this.domElement.addEventListener("drop", this._onDropFunc, false);
    this._setupFormListener();
    this.hasEventListeners = true;
    if (!_AutoNumeric._doesGlobalListExists()) {
      document.addEventListener("keydown", this._onKeydownGlobalFunc, false);
      document.addEventListener("keyup", this._onKeyupGlobalFunc, false);
    }
  }
  /**
   * Remove all the autoNumeric-related event listeners for the given DOM element
   * @private
   */
  _removeEventListeners() {
    this.domElement.removeEventListener("focusin", this._onFocusInFunc, false);
    this.domElement.removeEventListener("focus", this._onFocusInAndMouseEnterFunc, false);
    this.domElement.removeEventListener("focus", this._onFocusFunc, false);
    this.domElement.removeEventListener("mouseenter", this._onFocusInAndMouseEnterFunc, false);
    this.domElement.removeEventListener("blur", this._onFocusOutAndMouseLeaveFunc, false);
    this.domElement.removeEventListener("mouseleave", this._onFocusOutAndMouseLeaveFunc, false);
    this.domElement.removeEventListener("keydown", this._onKeydownFunc, false);
    this.domElement.removeEventListener("keypress", this._onKeypressFunc, false);
    this.domElement.removeEventListener("keyup", this._onKeyupFunc, false);
    this.domElement.removeEventListener("paste", this._onPasteFunc, false);
    this.domElement.removeEventListener("wheel", this._onWheelFunc, false);
    this.domElement.removeEventListener("drop", this._onDropFunc, false);
    this._removeFormListener();
    this.hasEventListeners = false;
    document.removeEventListener("keydown", this._onKeydownGlobalFunc, false);
    document.removeEventListener("keyup", this._onKeyupGlobalFunc, false);
  }
  /**
   * Toggle the event listeners according to the `noEventListeners` option, if those were not activated/deactivated before
   * @private
   */
  _updateEventListeners() {
    if (!this.settings.noEventListeners && !this.hasEventListeners) {
      this._createEventListeners();
    }
    if (this.settings.noEventListeners && this.hasEventListeners) {
      this._removeEventListeners();
    }
  }
  /**
   * Mark the parent <form> so that other AutoNumeric object will not add more listeners.
   * Add a counter so that when removing the AutoNumeric object, we only remove the submit listener if that count is equal to 0.
   * Also keep a reference to the 'submit' event handler function to be able to remove that handler later if the `_removeFormListener()` function is called from another AutoNumeric object.
   *
   * @private
   */
  _setupFormListener() {
    if (!AutoNumericHelper.isNull(this.parentForm)) {
      this._onFormSubmitFunc = () => {
        this._onFormSubmit();
      };
      this._onFormResetFunc = () => {
        this._onFormReset();
      };
      if (this._hasParentFormCounter()) {
        this._incrementParentFormCounter();
      } else {
        this._initializeFormCounterToOne();
        this.parentForm.addEventListener("submit", this._onFormSubmitFunc, false);
        this.parentForm.addEventListener("reset", this._onFormResetFunc, false);
        this._storeFormHandlerFunction();
      }
    }
  }
  /**
   * Remove the form 'submit' event listener, as well as the `dataset` info (`anCount` and `anFormHandler`) from the parent form, only when there are only one AutoNumeric child element left in that <form>.
   * Otherwise, decrement the `anCount`.
   *
   * @private
   */
  _removeFormListener() {
    if (!AutoNumericHelper.isNull(this.parentForm)) {
      const anCount = this._getParentFormCounter();
      if (anCount === 1) {
        this.parentForm.removeEventListener("submit", this._getFormHandlerFunction().submitFn, false);
        this.parentForm.removeEventListener("reset", this._getFormHandlerFunction().resetFn, false);
        this._removeFormDataSetInfo();
      } else if (anCount > 1) {
        this._decrementParentFormCounter();
      } else {
        AutoNumericHelper.throwError(`The AutoNumeric object count on the form is incoherent.`);
      }
    }
  }
  /**
   * Return `true` if the parent form has the form counter attribute
   *
   * @returns {boolean}
   * @private
   */
  _hasParentFormCounter() {
    return "anCount" in this.parentForm.dataset;
  }
  /**
   * Return the count of AutoNumeric form children
   *
   * @returns {number}
   * @private
   */
  _getParentFormCounter() {
    return Number(this.parentForm.dataset.anCount);
  }
  /**
   * Set the count of AutoNumeric form children to 1 for the given form element, or if none are passed, the current `this.parentForm` one.
   *
   * @param {HTMLFormElement|null} formElement
   * @private
   */
  _initializeFormCounterToOne(formElement = null) {
    this._getFormElement(formElement).dataset.anCount = 1;
  }
  /**
   * Increment the AutoNumeric form children count for the given form element, or if none are passed, the current `this.parentForm` one.
   *
   * @param {HTMLFormElement|null} formElement
   * @private
   */
  _incrementParentFormCounter(formElement = null) {
    this._getFormElement(formElement).dataset.anCount++;
  }
  /**
   * Decrement the AutoNumeric form children count for the current `this.parentForm` form element.
   *
   * @private
   */
  _decrementParentFormCounter() {
    this.parentForm.dataset.anCount--;
  }
  /**
   * Return `true` if the global form handler list exists on the `window` object.
   *
   * @returns {boolean}
   * @private
   */
  static _doesFormHandlerListExists() {
    const type2 = typeof window.aNFormHandlerMap;
    return type2 !== "undefined" && type2 === "object";
  }
  /**
   * Create the global form handler list on the `window` object.
   *
   * @private
   */
  static _createFormHandlerList() {
    window.aNFormHandlerMap = /* @__PURE__ */ new Map();
  }
  /**
   * Return `true` if the given form element, or if none are passed, the current `this.parentForm` one has a form handler name.
   *
   * @param {HTMLFormElement|null} formElement
   * @returns {boolean}
   * @private
   */
  _hasFormHandlerFunction(formElement = null) {
    return "anFormHandler" in this._getFormElement(formElement).dataset;
  }
  /**
   * Return the given form element, or defaults to `this.parentForm` if no argument is passed.
   *
   * @param {HTMLFormElement|null} formElement
   * @returns {*}
   * @private
   */
  _getFormElement(formElement = null) {
    let formElementToUse;
    if (!AutoNumericHelper.isNull(formElement)) {
      formElementToUse = formElement;
    } else {
      formElementToUse = this.parentForm;
    }
    return formElementToUse;
  }
  /**
   * Generate a form handler unique name and store it in the global form handler list.
   * This also save that name in the dataset of the given form element.
   *
   * @param {HTMLFormElement|null} formElement
   * @private
   */
  _storeFormHandlerFunction(formElement = null) {
    if (!this.constructor._doesFormHandlerListExists()) {
      this.constructor._createFormHandlerList();
    }
    const formHandlerName = AutoNumericHelper.randomString();
    this._getFormElement(formElement).dataset.anFormHandler = formHandlerName;
    window.aNFormHandlerMap.set(formHandlerName, { submitFn: this._onFormSubmitFunc, resetFn: this._onFormResetFunc });
  }
  /**
   * Return the form handler key name from the parent form element, for the global form handler list.
   *
   * @returns {string|*}
   * @private
   */
  _getFormHandlerKey() {
    if (!this._hasFormHandlerFunction()) {
      AutoNumericHelper.throwError(`Unable to retrieve the form handler name`);
    }
    const formHandlerName = this.parentForm.dataset.anFormHandler;
    if (formHandlerName === "") {
      AutoNumericHelper.throwError(`The form handler name is invalid`);
    }
    return formHandlerName;
  }
  /**
   * Return the 'submit' event handler function used for the parent form.
   *
   * @returns {function}
   * @private
   */
  _getFormHandlerFunction() {
    const formHandlerName = this._getFormHandlerKey();
    return window.aNFormHandlerMap.get(formHandlerName);
  }
  /**
   * Remove the dataset attributes `data-an-count` and `data-an-form-handler` from the parent form element.
   *
   * @private
   */
  _removeFormDataSetInfo() {
    this._decrementParentFormCounter();
    window.aNFormHandlerMap.delete(this._getFormHandlerKey());
    this.parentForm.removeAttribute("data-an-count");
    this.parentForm.removeAttribute("data-an-form-handler");
  }
  /**
   * Set the DOM element write permissions according to the current settings, by setting the `readonly` or `contenteditable` attributes depending on its tag type.
   * If the `useHtmlAttribute` parameter is set to `true`, then the `readonly` html attribute is used and has precedence over the `readOnly` option to set the element as read-only.
   *
   * @param {boolean} useHtmlAttribute If set to `true`, then the write permissions are set by taking into account the html 'readonly' attribute, even if the `readOnly` option is set to false
   * @private
   */
  _setWritePermissions(useHtmlAttribute = false) {
    if (useHtmlAttribute && this.domElement.readOnly || this.settings.readOnly) {
      this._setReadOnly();
    } else {
      this._setReadWrite();
    }
  }
  /**
   * Set the element to be read-only.
   * If the DOM element tag is not an `input`, then it `contenteditable` attribute is set to `false`.
   *
   * @private
   */
  _setReadOnly() {
    if (this.isInputElement) {
      this.domElement.readOnly = true;
    } else {
      this.domElement.setAttribute("contenteditable", false);
    }
  }
  /**
   * Set the element to be read-write.
   *
   * @private
   */
  _setReadWrite() {
    if (this.isInputElement) {
      this.domElement.readOnly = false;
    } else {
      this.domElement.setAttribute("contenteditable", true);
    }
  }
  /**
   * Add a watcher so that any external change to the AutoNumeric-managed element would be detected.
   * As soon as such change is detected, AutoNumeric then tries to `set()` the value so that it gets formatted and stored in the history.
   * //XXX For now, this only works when watching the `value` attribute, not the `textContent` one
   * @private
   */
  _addWatcher() {
    if (!AutoNumericHelper.isUndefined(this.getterSetter)) {
      const { set: setter2, get: getter } = this.getterSetter;
      Object.defineProperty(this.domElement, this.attributeToWatch, {
        configurable: true,
        // This is needed in some rare cases
        get: () => getter.call(this.domElement),
        set: (val) => {
          setter2.call(this.domElement, val);
          if (this.settings.watchExternalChanges && !this.internalModification) {
            this.set(val);
          }
        }
      });
    }
  }
  /**
   * Remove the watcher on the AutoNumeric-managed element
   * Note: This needs to be called when the AutoNumeric element is 'removed', otherwise the getter/setter stays on the DOM element and that can lead to problem if the user initialize another AutoNumeric object on it.
   * @private
   */
  _removeWatcher() {
    if (!AutoNumericHelper.isUndefined(this.getterSetter)) {
      const { set: setter2, get: getter } = this.getterSetter;
      Object.defineProperty(this.domElement, this.attributeToWatch, {
        configurable: true,
        // This is needed in some rare cases
        get: () => getter.call(this.domElement),
        set: (val) => {
          setter2.call(this.domElement, val);
        }
      });
    }
  }
  /**
   * Return the name of the object attribute that store the current formatted data in the DOM element.
   *
   * @returns {string}
   * @private
   */
  _getAttributeToWatch() {
    let attributeToWatch;
    if (this.isInputElement) {
      attributeToWatch = "value";
    } else {
      const nodeType = this.domElement.nodeType;
      if (nodeType === Node.ELEMENT_NODE || nodeType === Node.DOCUMENT_NODE || nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        attributeToWatch = "textContent";
      } else if (nodeType === Node.TEXT_NODE) {
        attributeToWatch = "nodeValue";
      }
    }
    return attributeToWatch;
  }
  /**
   * Save the current raw value into the history table, along with the selection information.
   *
   * If the user has done some undos and tries to enter:
   * - a new and different number than the 'next' state, this drops the rest of the history table
   * - the very same number that result in the same rawValue as the 'next' state, we only move the history table pointer to the next state
   *
   * @private
   */
  _historyTableAdd() {
    const isEmptyHistoryTable = this.historyTable.length === 0;
    if (isEmptyHistoryTable || this.rawValue !== this._historyTableCurrentValueUsed()) {
      let addNewHistoryState = true;
      if (!isEmptyHistoryTable) {
        const nextHistoryStateIndex = this.historyTableIndex + 1;
        if (nextHistoryStateIndex < this.historyTable.length && this.rawValue === this.historyTable[nextHistoryStateIndex].value) {
          addNewHistoryState = false;
        } else {
          AutoNumericHelper.arrayTrim(this.historyTable, this.historyTableIndex + 1);
        }
      }
      this.historyTableIndex++;
      if (addNewHistoryState) {
        const selection = AutoNumericHelper.getElementSelection(this.domElement);
        this.selectionStart = selection.start;
        this.selectionEnd = selection.end;
        this.historyTable.push({
          // Save the rawValue and selection start/end
          value: this.rawValue,
          // The selection for this element is temporary, and will be updated when the next history state will be recorded.
          // That way, we are always sure we save the last caret or selection positions just before the value is changed. Otherwise, we would only save those positions when the value is first changed, and would not take into account that the user could move the caret around afterward.
          // For instance, this is needed if the user change the element value, and immediately undo it ; if he then does a redo, he'll see the value and the right selection
          // To sum up; The selection position are not always +1 character, since it could also be '2' if a group separator is added when entering one character. That's why the current history state caret/selection position is updated on each `keyup` event.
          start: this.selectionStart + 1,
          // Here we add one since the user added one character too
          end: this.selectionEnd + 1
        });
        if (this.historyTable.length > 1) {
          this.historyTable[this.historyTableIndex - 1].start = this.selectionStart;
          this.historyTable[this.historyTableIndex - 1].end = this.selectionEnd;
        }
      }
      if (this.historyTable.length > this.settings.historySize) {
        this._historyTableForget();
      }
    }
  }
  /**
   * Debug function for the history table
   * @private
   */
  /*
  _debugHistoryTable() {
      let i = 0;
      let mark;
      this.historyTable.forEach(history => {
          if (this.historyTableIndex === i) {
              mark = '> ';
          } else {
              mark = '';
          }
          console.log(`${mark}${i++}: ${history.value} ${history.start}|${history.end} [onGoingRedo: ${this.onGoingRedo}]`); //DEBUG
      });
  }
  */
  /**
   * 'Undo' or 'Redo' the last/next user entry in the history table.
   * This does not modify the history table, only the pointer to the current state.
   *
   * @param {boolean} undo If set to `true`, then this function does an 'Undo', otherwise it does a 'Redo'
   * @private
   */
  _historyTableUndoOrRedo(undo = true) {
    let check;
    if (undo) {
      check = this.historyTableIndex > 0;
      if (check) {
        this.historyTableIndex--;
      }
    } else {
      check = this.historyTableIndex + 1 < this.historyTable.length;
      if (check) {
        this.historyTableIndex++;
      }
    }
    if (check) {
      const undoInfo = this.historyTable[this.historyTableIndex];
      this.set(undoInfo.value, null, false);
      AutoNumericHelper.setElementSelection(this.domElement, undoInfo.start, undoInfo.end);
    }
  }
  /**
   * 'Undo' the last user entry by going back one entry in the history table.
   * This keeps the following entries in order to allow for a 'redo'.
   * This does not modify the history table, only the pointer to the current state.
   * @private
   */
  _historyTableUndo() {
    this._historyTableUndoOrRedo(true);
  }
  /**
   * 'Redo' the next user entry in the history table.
   * This does not modify the history table, only the pointer to the current state.
   * @private
   */
  _historyTableRedo() {
    this._historyTableUndoOrRedo(false);
  }
  /**
   * Reset the history table to its initial state, and select the value.
   * @private
   */
  /*
  resetHistoryTable() { //FIXME Test this
      this.set(this.rawValue, null, false);
      this.select();
      const selection = AutoNumericHelper.getElementSelection(this.domElement);
      this.historyTableIndex = 0;
      this.historyTable = [{
          // Save the rawValue and selection start/end
          value: this.rawValue,
          start: selection.start,
          end  : selection.end,
      }];
  }
  */
  /**
   * Make the history table forget its first N elements, shifting its indexes in the process.
   * `N` being given as the `numberOfEntriesToForget` parameter.
   *
   * @param {Number} numberOfEntriesToForget
   * @returns {object|Array<object>} The discarded objects, in an Array.
   * @private
   */
  _historyTableForget(numberOfEntriesToForget = 1) {
    const shiftedAway = [];
    for (let i3 = 0; i3 < numberOfEntriesToForget; i3++) {
      shiftedAway.push(this.historyTable.shift());
      this.historyTableIndex--;
      if (this.historyTableIndex < 0) {
        this.historyTableIndex = 0;
      }
    }
    if (shiftedAway.length === 1) {
      return shiftedAway[0];
    }
    return shiftedAway;
  }
  /**
   * Return the currently used value from the history table.
   *
   * @returns {string|number}
   * @private
   */
  _historyTableCurrentValueUsed() {
    let indexToUse = this.historyTableIndex;
    if (indexToUse < 0) {
      indexToUse = 0;
    }
    let result2;
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(this.historyTable[indexToUse])) {
      result2 = "";
    } else {
      result2 = this.historyTable[indexToUse].value;
    }
    return result2;
  }
  /**
   * Parse the `styleRules` option and run the test for each given rules, either pre-defined ones like `positive`, `negative` and `ranges`, or user defined callbacks within the `userDefined` attribute.
   * @private
   */
  _parseStyleRules() {
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(this.settings.styleRules) || this.rawValue === "") {
      return;
    }
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(this.settings.styleRules.positive)) {
      if (this.rawValue >= 0) {
        this._addCSSClass(this.settings.styleRules.positive);
      } else {
        this._removeCSSClass(this.settings.styleRules.positive);
      }
    }
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(this.settings.styleRules.negative)) {
      if (this.rawValue < 0) {
        this._addCSSClass(this.settings.styleRules.negative);
      } else {
        this._removeCSSClass(this.settings.styleRules.negative);
      }
    }
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(this.settings.styleRules.ranges) && this.settings.styleRules.ranges.length !== 0) {
      this.settings.styleRules.ranges.forEach((range2) => {
        if (this.rawValue >= range2.min && this.rawValue < range2.max) {
          this._addCSSClass(range2.class);
        } else {
          this._removeCSSClass(range2.class);
        }
      });
    }
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(this.settings.styleRules.userDefined) && this.settings.styleRules.userDefined.length !== 0) {
      this.settings.styleRules.userDefined.forEach((userObject) => {
        if (AutoNumericHelper.isFunction(userObject.callback)) {
          if (AutoNumericHelper.isString(userObject.classes)) {
            if (userObject.callback(this.rawValue)) {
              this._addCSSClass(userObject.classes);
            } else {
              this._removeCSSClass(userObject.classes);
            }
          } else if (AutoNumericHelper.isArray(userObject.classes)) {
            if (userObject.classes.length === 2) {
              if (userObject.callback(this.rawValue)) {
                this._addCSSClass(userObject.classes[0]);
                this._removeCSSClass(userObject.classes[1]);
              } else {
                this._removeCSSClass(userObject.classes[0]);
                this._addCSSClass(userObject.classes[1]);
              }
            } else if (userObject.classes.length > 2) {
              const callbackResult = userObject.callback(this.rawValue);
              if (AutoNumericHelper.isArray(callbackResult)) {
                userObject.classes.forEach((userClass, index2) => {
                  if (AutoNumericHelper.isInArray(index2, callbackResult)) {
                    this._addCSSClass(userClass);
                  } else {
                    this._removeCSSClass(userClass);
                  }
                });
              } else if (AutoNumericHelper.isInt(callbackResult)) {
                userObject.classes.forEach((userClass, index2) => {
                  if (index2 === callbackResult) {
                    this._addCSSClass(userClass);
                  } else {
                    this._removeCSSClass(userClass);
                  }
                });
              } else if (AutoNumericHelper.isNull(callbackResult)) {
                userObject.classes.forEach((userClass) => {
                  this._removeCSSClass(userClass);
                });
              } else {
                AutoNumericHelper.throwError(`The callback result is not an array nor a valid array index, ${typeof callbackResult} given.`);
              }
            } else {
              AutoNumericHelper.throwError("The classes attribute is not valid for the `styleRules` option.");
            }
          } else if (AutoNumericHelper.isUndefinedOrNullOrEmpty(userObject.classes)) {
            userObject.callback(this);
          } else {
            AutoNumericHelper.throwError("The callback/classes structure is not valid for the `styleRules` option.");
          }
        } else {
          AutoNumericHelper.warning(`The given \`styleRules\` callback is not a function, ${typeof userObject.callback} given.`, this.settings.showWarnings);
        }
      });
    }
  }
  /**
   * Add the given CSS class to the DOM element.
   *
   * @param {string} cssClassName
   * @private
   */
  _addCSSClass(cssClassName) {
    this.domElement.classList.add(cssClassName);
  }
  /**
   * Remove the given CSS class from the DOM element.
   *
   * @param {string} cssClassName
   * @private
   */
  _removeCSSClass(cssClassName) {
    this.domElement.classList.remove(cssClassName);
  }
  // Those are the public function available on each autoNumeric-managed element
  /**
   * Method that updates the AutoNumeric settings, and immediately format the element accordingly.
   * The options passed as parameter(s) is either one or many objects that each contains some settings, i.e. :
   * {
   *     digitGroupSeparator: ".",
   *     decimalCharacter: ",",
   *     currencySymbol: '€ ',
   * }
   * If multiple options are passed, the latter overwrite the previous ones.
   *
   * Note: If the new settings are not validated, or the call to `set()` fails, then the previous valid settings are reverted back to.
   *
   * @example anElement.update({ options }) // Updates the settings
   * @example anElement.update({ options1 }, { options2 }) // Updates the settings with multiple option objects
   * @example anElement.update([{ options1 }, { options2 }]) // Updates the settings with multiple option objects in a single array
   *
   * @param {object|string|array} newOptions
   * @returns {AutoNumeric}
   */
  update(...newOptions) {
    if (Array.isArray(newOptions) && Array.isArray(newOptions[0])) {
      newOptions = newOptions[0];
    }
    const originalSettings = AutoNumericHelper.cloneObject(this.settings);
    const numericString = this.rawValue;
    let optionsToUse = {};
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(newOptions) || newOptions.length === 0) {
      optionsToUse = null;
    } else if (newOptions.length >= 1) {
      newOptions.forEach((optionObject) => {
        if (this.constructor._isPreDefinedOptionValid(optionObject)) {
          optionObject = this.constructor._getOptionObject(optionObject);
        }
        Object.assign(optionsToUse, optionObject);
      });
    }
    try {
      this._setSettings(optionsToUse, true);
      this._setWritePermissions();
      this._updateEventListeners();
      this.set(numericString);
    } catch (error2) {
      this._setSettings(originalSettings, true);
      AutoNumericHelper.throwError(`Unable to update the settings, those are invalid: [${error2}]`);
      return this;
    }
    return this;
  }
  /**
   * Return the options object containing all the current autoNumeric settings in effect.
   * You can then directly access each option by using its name : `anElement.getSettings().optionNameAutoCompleted`.
   *
   * @example
   * anElement.getSettings()
   * anElement.getSettings().decimalCharacter // Return the decimalCharacter setting as a string - any valid option name can be used
   *
   * @returns {object}
   */
  getSettings() {
    return this.settings;
  }
  /**
   * Set the given element value, and format it immediately.
   * Additionally, this `set()` method can accept options that will be merged into the current AutoNumeric element, taking precedence over any previous settings.
   *
   * @example anElement.set('12345.67') // Formats the value
   * @example anElement.set(12345.67) // Formats the value
   * @example anElement.set(12345.67, { decimalCharacter : ',' }) // Update the settings and formats the value in one go
   * @example anElement.northAmerican().set('$12,345.67') // Set an already formatted value (this does not _exactly_ respect the currency symbol/negative placements, but only remove all non-numbers characters, according to the ones given in the settings)
   * @example anElement.set(null) // Set the rawValue and element value to `null`
   *
   * @param {number|string|null} newValue The value must be a Number, a numeric string or `null` (if `emptyInputBehavior` is set to `'null'`)
   * @param {object} options A settings object that will override the current settings. Note: the update is done only if the `newValue` is defined.
   * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history table
   * @returns {AutoNumeric}
   * @throws
   */
  set(newValue, options = null, saveChangeToHistory = true) {
    if (AutoNumericHelper.isUndefined(newValue)) {
      AutoNumericHelper.warning(`You are trying to set an 'undefined' value ; an error could have occurred.`, this.settings.showWarnings);
      return this;
    }
    if (!AutoNumericHelper.isNull(options)) {
      this._setSettings(options, true);
    }
    if (newValue === null && this.settings.emptyInputBehavior !== _AutoNumeric.options.emptyInputBehavior.null) {
      AutoNumericHelper.warning(`You are trying to set the \`null\` value while the \`emptyInputBehavior\` option is set to ${this.settings.emptyInputBehavior}. If you want to be able to set the \`null\` value, you need to change the 'emptyInputBehavior' option to \`'null'\`.`, this.settings.showWarnings);
      return this;
    }
    let value;
    if (newValue === null) {
      this._setElementAndRawValue(null, null, saveChangeToHistory);
      this._saveValueToPersistentStorage();
      return this;
    }
    value = this.constructor._toNumericValue(newValue, this.settings);
    if (isNaN(Number(value))) {
      AutoNumericHelper.warning(`The value you are trying to set results in \`NaN\`. The element value is set to the empty string instead.`, this.settings.showWarnings);
      this.setValue("", saveChangeToHistory);
      return this;
    }
    if (value === "") {
      switch (this.settings.emptyInputBehavior) {
        case _AutoNumeric.options.emptyInputBehavior.zero:
          value = 0;
          break;
        case _AutoNumeric.options.emptyInputBehavior.min:
          value = this.settings.minimumValue;
          break;
        case _AutoNumeric.options.emptyInputBehavior.max:
          value = this.settings.maximumValue;
          break;
        default:
          if (AutoNumericHelper.isNumber(this.settings.emptyInputBehavior)) {
            value = Number(this.settings.emptyInputBehavior);
          }
      }
    }
    if (value !== "") {
      const [minTest, maxTest] = this.constructor._checkIfInRangeWithOverrideOption(value, this.settings);
      if (minTest && maxTest && this.settings.valuesToStrings && this._checkValuesToStrings(value)) {
        this._setElementAndRawValue(this.settings.valuesToStrings[value], value, saveChangeToHistory);
        this._saveValueToPersistentStorage();
        return this;
      }
      const isZero = AutoNumericHelper.isZeroOrHasNoValue(value);
      if (isZero) {
        value = "0";
      }
      if (minTest && maxTest) {
        let forcedRawValue = this.constructor._roundRawValue(value, this.settings);
        forcedRawValue = this._trimLeadingAndTrailingZeros(forcedRawValue.replace(this.settings.decimalCharacter, "."));
        value = this._getRawValueToFormat(value);
        if (this.isFocused) {
          value = this.constructor._roundFormattedValueShownOnFocus(value, this.settings);
        } else {
          if (this.settings.divisorWhenUnfocused) {
            value = value / this.settings.divisorWhenUnfocused;
            value = value.toString();
          }
          value = this.constructor._roundFormattedValueShownOnBlur(value, this.settings);
        }
        value = this.constructor._modifyNegativeSignAndDecimalCharacterForFormattedValue(value, this.settings);
        value = this.constructor._addGroupSeparators(value, this.settings, this.isFocused, this.rawValue, forcedRawValue);
        if (!this.isFocused && this.settings.symbolWhenUnfocused) {
          value = `${value}${this.settings.symbolWhenUnfocused}`;
        }
        if (this.settings.decimalPlacesShownOnFocus || this.settings.divisorWhenUnfocused) {
          this._saveValueToPersistentStorage();
        }
        this._setElementAndRawValue(value, forcedRawValue, saveChangeToHistory);
        this._setValidOrInvalidState(forcedRawValue);
        return this;
      } else {
        this._triggerRangeEvents(minTest, maxTest);
        AutoNumericHelper.throwError(`The value [${value}] being set falls outside of the minimumValue [${this.settings.minimumValue}] and maximumValue [${this.settings.maximumValue}] range set for this element`);
        this._removeValueFromPersistentStorage();
        this.setValue("", saveChangeToHistory);
        return this;
      }
    } else {
      let result2;
      if (this.settings.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.always) {
        result2 = this.settings.currencySymbol;
      } else {
        result2 = "";
      }
      this._setElementAndRawValue(result2, "", saveChangeToHistory);
      return this;
    }
  }
  /**
   * Set the given value directly as the DOM element value, without formatting it beforehand.
   * You can also set the value and update the setting in one go (the value will again not be formatted immediately).
   *
   * @param {number|string} value
   * @param {object} options
   * @returns {AutoNumeric}
   * @throws
   */
  setUnformatted(value, options = null) {
    if (value === null || AutoNumericHelper.isUndefined(value)) {
      return this;
    }
    if (!AutoNumericHelper.isNull(options)) {
      this._setSettings(options, true);
    }
    const strippedValue = this.constructor._removeBrackets(value, this.settings);
    const normalizedValue = this.constructor._stripAllNonNumberCharacters(strippedValue, this.settings, true, this.isFocused);
    if (!AutoNumericHelper.isNumber(normalizedValue)) {
      AutoNumericHelper.throwError(`The value is not a valid one, it's not a numeric string nor a recognized currency.`);
    }
    if (this.constructor._isWithinRangeWithOverrideOption(normalizedValue, this.settings)) {
      this.setValue(value);
    } else {
      AutoNumericHelper.throwError(`The value is out of the range limits [${this.settings.minimumValue}, ${this.settings.maximumValue}].`);
    }
    return this;
  }
  /**
   * Set the given value directly as the DOM element value, without formatting it beforehand, and without checking its validity.
   * This also updates the `rawValue` with the given `newValue`, without checking it too ; if it's not formatted like a number recognized by Javascript, this *will* likely make other AutoNumeric methods fail.
   *
   * @param {string|number|null} newValue The new value to set on the element
   * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history array, otherwise it is not
   * @returns {AutoNumeric}
   */
  setValue(newValue, saveChangeToHistory = true) {
    this._setElementAndRawValue(newValue, saveChangeToHistory);
    return this;
  }
  /**
   * Save the raw value inside the AutoNumeric object.
   *
   * @param {number|string|null} rawValue The numeric value as understood by Javascript like a `Number`
   * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history array, otherwise it is not
   * @private
   */
  _setRawValue(rawValue, saveChangeToHistory = true) {
    if (this.rawValue !== rawValue) {
      const oldRawValue = this.rawValue;
      this.rawValue = rawValue;
      if (!AutoNumericHelper.isNull(this.settings.rawValueDivisor) && this.settings.rawValueDivisor !== 0 && // Only divide if the `rawValueDivisor` option is set
      rawValue !== "" && rawValue !== null && // Do not modify the `rawValue` if it's an empty string or null
      this._isUserManuallyEditingTheValue()) {
        this.rawValue /= this.settings.rawValueDivisor;
      }
      this._triggerEvent(_AutoNumeric.events.rawValueModified, this.domElement, {
        oldRawValue,
        newRawValue: this.rawValue,
        isPristine: this.isPristine(true),
        error: null,
        aNElement: this
      });
      this._parseStyleRules();
      if (saveChangeToHistory) {
        window.requestAnimationFrame(() => this._historyTableAdd());
      }
    }
  }
  /**
   * Set the given value on the DOM element, without affecting the `rawValue`.
   * This sends an 'autoNumeric:formatted' event if the new value is different from the old one.
   *
   * @param {number|string} newElementValue
   * @param {boolean} sendFormattedEvent If set to `true`, then the `AutoNumeric.events.formatted` event is sent if the value has changed
   * @returns {AutoNumeric}
   * @private
   */
  _setElementValue(newElementValue, sendFormattedEvent = true) {
    const oldElementValue = AutoNumericHelper.getElementValue(this.domElement);
    if (newElementValue !== oldElementValue) {
      this.internalModification = true;
      AutoNumericHelper.setElementValue(this.domElement, newElementValue);
      this.internalModification = false;
      if (sendFormattedEvent) {
        this._triggerEvent(_AutoNumeric.events.formatted, this.domElement, {
          oldValue: oldElementValue,
          newValue: newElementValue,
          oldRawValue: this.rawValue,
          newRawValue: this.rawValue,
          isPristine: this.isPristine(false),
          error: null,
          aNElement: this
        });
      }
    }
    return this;
  }
  /**
   * Set the given value on the DOM element, and the raw value on `this.rawValue`, if both are given.
   * If only one value is given, then both the DOM element value and the raw value are set with that value.
   * The third argument `saveChangeToHistory` defines if the change should be recorded in the history array.
   * Note: if the second argument `rawValue` is a boolean, we consider that is really is the `saveChangeToHistory` argument.
   *
   * @param {number|string|null} newElementValue
   * @param {number|string|null|boolean} rawValue
   * @param {boolean} saveChangeToHistory
   * @returns {AutoNumeric}
   * @private
   */
  _setElementAndRawValue(newElementValue, rawValue = null, saveChangeToHistory = true) {
    if (AutoNumericHelper.isNull(rawValue)) {
      rawValue = newElementValue;
    } else if (AutoNumericHelper.isBoolean(rawValue)) {
      saveChangeToHistory = rawValue;
      rawValue = newElementValue;
    }
    this._setElementValue(newElementValue);
    this._setRawValue(rawValue, saveChangeToHistory);
    return this;
  }
  /**
   * Return the multiplied raw value with the `rawValueDivisor`.
   * This is used to display different values between the raw and formatted values.
   *
   * @param {number|string|null} rawValue The numeric value as understood by Javascript like a `Number`
   * @returns {number|string|null}
   * @private
   */
  _getRawValueToFormat(rawValue) {
    let rawValueForTheElementValue;
    if (!AutoNumericHelper.isNull(this.settings.rawValueDivisor) && this.settings.rawValueDivisor !== 0 && // Only multiply if the `rawValueDivisor` option is set
    rawValue !== "" && rawValue !== null) {
      rawValueForTheElementValue = rawValue * this.settings.rawValueDivisor;
    } else {
      rawValueForTheElementValue = rawValue;
    }
    return rawValueForTheElementValue;
  }
  /**
   * Check if the given value has a corresponding key in the `valuesToStrings` option object.
   *
   * @param {number|string} value
   * @returns {boolean} Returns `true` if such a key is found.
   * @private
   */
  _checkValuesToStrings(value) {
    return this.constructor._checkValuesToStringsArray(value, this.valuesToStringsKeys);
  }
  /**
   * Check if the given value has a corresponding key in the `stringsArray` array.
   *
   * @param {number|string} key
   * @param {array} stringsArray Array where the `key` is checked against its keys
   * @returns {boolean} Returns `true` if such a key is found.
   * @private
   */
  static _checkValuesToStringsArray(key2, stringsArray) {
    return AutoNumericHelper.isInArray(String(key2), stringsArray);
  }
  /**
   * Static helper for checking if the given `key` is found in the settings' `valuesToStrings` option object.
   *
   * @param {number|string} key
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _checkValuesToStringsSettings(key2, settings) {
    return this._checkValuesToStringsArray(key2, Object.keys(settings.valuesToStrings));
  }
  /**
   * Static helper for checking if the given `value` is found in the settings' `valuesToStrings` option object.
   *
   * @param {number|string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _checkStringsToValuesSettings(value, settings) {
    return this._checkValuesToStringsArray(value, Object.values(settings.valuesToStrings));
  }
  /**
   * Return `true` if the user is currently modifying the element value manually.
   *
   * @returns {boolean}
   * @private
   */
  _isUserManuallyEditingTheValue() {
    return this.isFocused && this.isEditing || this.isDropEvent;
  }
  /**
   * Execute the given callback function using the given result as its first parameter, and the AutoNumeric object as its second.
   *
   * @param {number|string|Array|null} result
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   * @private
   */
  _executeCallback(result2, callback) {
    if (!AutoNumericHelper.isNull(callback) && AutoNumericHelper.isFunction(callback)) {
      callback(result2, this);
    }
  }
  /**
   * Trigger the given event on the given element with the given detail.
   * This takes into account the `eventBubbles` and `eventIsCancelable` options.
   *
   * @param {string} eventName
   * @param {HTMLElement|HTMLDocument|EventTarget} element
   * @param {object} detail
   * @private
   */
  _triggerEvent(eventName, element = document, detail = null) {
    AutoNumericHelper.triggerEvent(eventName, element, detail, this.settings.eventBubbles, this.settings.eventIsCancelable);
  }
  /**
   * Alias of the `getNumericString()` function.
   * Developers should use one of the more explicit function names to get what they want :
   * - a numeric string : `getNumericString()`
   * - a formatted string : `getFormatted()`
   * - a number : `getNumber()`, or
   * - a localized numeric string : `getLocalized()`
   *
   * @usage anElement.get();
   *
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @deprecated
   * @returns {string|null}
   */
  get(callback = null) {
    return this.getNumericString(callback);
  }
  /**
   * Return the unformatted value as a string.
   * This can also return `null` if `rawValue` is null.
   *
   * @usage anElement.getNumericString();
   *
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @returns {string|null}
   */
  getNumericString(callback = null) {
    let result2;
    if (AutoNumericHelper.isNull(this.rawValue)) {
      result2 = null;
    } else {
      result2 = AutoNumericHelper.trimPaddedZerosFromDecimalPlaces(this.rawValue);
    }
    this._executeCallback(result2, callback);
    return result2;
  }
  /**
   * Return the current formatted value of the AutoNumeric element as a string
   *
   * @usage anElement.getFormatted()
   *
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @returns {string}
   */
  getFormatted(callback = null) {
    if (!("value" in this.domElement || "textContent" in this.domElement)) {
      AutoNumericHelper.throwError("Unable to get the formatted string from the element.");
    }
    const result2 = AutoNumericHelper.getElementValue(this.domElement);
    this._executeCallback(result2, callback);
    return result2;
  }
  /**
   * Return the element unformatted value as a real Javascript number.
   * Warning: This can lead to precision problems with big numbers that should be stored as strings.
   *
   * @usage anElement.getNumber()
   *
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @returns {number|null}
   */
  getNumber(callback = null) {
    let result2;
    if (this.rawValue === null) {
      result2 = null;
    } else {
      result2 = this.constructor._toLocale(this.getNumericString(), "number", this.settings);
    }
    this._executeCallback(result2, callback);
    return result2;
  }
  /**
   * Returns the unformatted value, but following the `outputFormat` setting, which means the output can either be :
   * - a string (that could or could not represent a number (i.e. "12345,67-")), or
   * - a plain number (if the setting 'number' is used).
   *
   * By default, the returned values are an ISO numeric string "1234.56" or "-1234.56" where the decimal character is a period.
   * Check the "outputFormat" option definition for more details.
   *
   * @usage anElement.getLocalized();
   *
   * @param {null|string|function} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @param {function|null} callback If a callback is passed, then the result is passed to it as its first argument, and the AutoNumeric object has its second
   *
   * @returns {*}
   */
  getLocalized(forcedOutputFormat = null, callback = null) {
    if (AutoNumericHelper.isFunction(forcedOutputFormat) && AutoNumericHelper.isNull(callback)) {
      callback = forcedOutputFormat;
      forcedOutputFormat = null;
    }
    let value;
    if (AutoNumericHelper.isEmptyString(this.rawValue)) {
      value = "";
    } else {
      value = "" + Number(this.rawValue);
    }
    if (value !== "" && Number(value) === 0 && this.settings.leadingZero !== _AutoNumeric.options.leadingZero.keep) {
      value = "0";
    }
    let outputFormatToUse;
    if (AutoNumericHelper.isNull(forcedOutputFormat)) {
      outputFormatToUse = this.settings.outputFormat;
    } else {
      outputFormatToUse = forcedOutputFormat;
    }
    const result2 = this.constructor._toLocale(value, outputFormatToUse, this.settings);
    this._executeCallback(result2, callback);
    return result2;
  }
  /**
   * Force the element to reformat its value again (just in case the formatting has been lost).
   * This can be used right after a form submission for instance (after a previous call to `unformat`).
   *
   * @example anElement.reformat()
   *
   * @returns {AutoNumeric}
   */
  reformat() {
    this.set(this.rawValue);
    return this;
  }
  /**
   * Remove the formatting and keep only the raw unformatted value in the element (as a numericString)
   * Note: this is loosely based on the previous 'unSet()' function
   *
   * By default, values are returned as ISO numeric strings (i.e. "1234.56" or "-1234.56"), where the decimal character is a period.
   * @example anElement.unformat()
   *
   * @returns {AutoNumeric}
   */
  unformat() {
    this._setElementValue(this.getNumericString());
    return this;
  }
  /**
   * Remove the formatting and keep only the localized unformatted value in the element, with the option to override the default outputFormat if needed
   *
   * Locale formats are supported "1234.56-" or "1234,56" or "-1234,56 or "1234,56-", or even plain numbers.
   * Take a look at the `outputFormat` option definition in the default settings for more details.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {AutoNumeric}
   */
  unformatLocalized(forcedOutputFormat = null) {
    this._setElementValue(this.getLocalized(forcedOutputFormat));
    return this;
  }
  /**
   * Return `true` if the current value is the same as when the element got initialized.
   * Note: By default, this returns `true` if the raw unformatted value is still the same even if the formatted one has changed (due to a configuration update for instance).
   * In order to test if the formatted value is the same (which means neither the raw value nor the settings have been changed), then you must pass `false` as its argument.
   *
   * @param {boolean} checkOnlyRawValue If set to `true`, the pristine value is done on the raw unformatted value, not the formatted one.  If set to `false`, this also checks that the formatted value hasn't changed.
   * @returns {boolean}
   */
  isPristine(checkOnlyRawValue = true) {
    let result2;
    if (checkOnlyRawValue) {
      result2 = this.initialValue === this.getNumericString();
    } else {
      result2 = this.initialValueHtmlAttribute === this.getFormatted();
    }
    return result2;
  }
  /**
   * Select the formatted element content, based on the `selectNumberOnly` option
   *
   * @returns {AutoNumeric}
   */
  select() {
    if (this.settings.selectNumberOnly) {
      this.selectNumber();
    } else {
      this._defaultSelectAll();
    }
    return this;
  }
  /**
   * Select the whole element content (including the currency symbol).
   * @private
   */
  _defaultSelectAll() {
    AutoNumericHelper.setElementSelection(this.domElement, 0, AutoNumericHelper.getElementValue(this.domElement).length);
  }
  /**
   * Select only the numbers in the formatted element content, leaving out the currency symbol, whatever the value of the `selectNumberOnly` option
   *
   * @returns {AutoNumeric}
   */
  selectNumber() {
    const unformattedValue = AutoNumericHelper.getElementValue(this.domElement);
    const valueLen = unformattedValue.length;
    const currencySymbolSize = this.settings.currencySymbol.length;
    const currencySymbolPlacement = this.settings.currencySymbolPlacement;
    const negLen = !AutoNumericHelper.isNegative(unformattedValue, this.settings.negativeSignCharacter) ? 0 : 1;
    const suffixTextLen = this.settings.suffixText.length;
    let start2;
    if (currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
      start2 = 0;
    } else if (this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.left && negLen === 1 && currencySymbolSize > 0) {
      start2 = currencySymbolSize + 1;
    } else {
      start2 = currencySymbolSize;
    }
    let end2;
    if (currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix) {
      end2 = valueLen - suffixTextLen;
    } else {
      switch (this.settings.negativePositiveSignPlacement) {
        case _AutoNumeric.options.negativePositiveSignPlacement.left:
          end2 = valueLen - (suffixTextLen + currencySymbolSize);
          break;
        case _AutoNumeric.options.negativePositiveSignPlacement.right:
          if (currencySymbolSize > 0) {
            end2 = valueLen - (currencySymbolSize + negLen + suffixTextLen);
          } else {
            end2 = valueLen - (currencySymbolSize + suffixTextLen);
          }
          break;
        default:
          end2 = valueLen - (currencySymbolSize + suffixTextLen);
      }
    }
    AutoNumericHelper.setElementSelection(this.domElement, start2, end2);
    return this;
  }
  /**
   * Select only the integer part in the formatted element content, whatever the value of `selectNumberOnly`
   *
   * @returns {AutoNumeric}
   */
  selectInteger() {
    let start2 = 0;
    const isPositive = this.rawValue >= 0;
    if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix || this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix && (this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.prefix || this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.none)) {
      if (this.settings.showPositiveSign && isPositive || // This only exclude the positive sign from being selected
      !isPositive && this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.left) {
        start2 = start2 + 1;
      }
    }
    if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix) {
      start2 = start2 + this.settings.currencySymbol.length;
    }
    const elementValue = AutoNumericHelper.getElementValue(this.domElement);
    let end2 = elementValue.indexOf(this.settings.decimalCharacter);
    if (end2 === -1) {
      if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
        end2 = elementValue.length - this.settings.currencySymbol.length;
      } else {
        end2 = elementValue.length;
      }
      if (!isPositive && (this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.suffix || this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix)) {
        end2 = end2 - 1;
      }
      end2 = end2 - this.settings.suffixText.length;
    }
    AutoNumericHelper.setElementSelection(this.domElement, start2, end2);
    return this;
  }
  /**
   * Select only the decimal part in the formatted element content, whatever the value of `selectNumberOnly`
   * Multiple cases are possible :
   * +1.234,57suffixText
   *
   * € +1.234,57suffixText
   * +€ 1.234,57suffixText
   * € 1.234,57+suffixText
   *
   * 1.234,57+ €suffixText
   * 1.234,57 €+suffixText
   * +1.234,57 €suffixText
   *
   * @returns {AutoNumeric}
   */
  selectDecimal() {
    let start2 = AutoNumericHelper.getElementValue(this.domElement).indexOf(this.settings.decimalCharacter);
    let end2;
    if (start2 === -1) {
      start2 = 0;
      end2 = 0;
    } else {
      start2 = start2 + 1;
      let decimalCount;
      if (this.isFocused) {
        decimalCount = this.settings.decimalPlacesShownOnFocus;
      } else {
        decimalCount = this.settings.decimalPlacesShownOnBlur;
      }
      end2 = start2 + Number(decimalCount);
    }
    AutoNumericHelper.setElementSelection(this.domElement, start2, end2);
    return this;
  }
  /**
   * Return the DOM element reference of the autoNumeric-managed element
   *
   * @returns {HTMLElement|HTMLInputElement}
   */
  node() {
    return this.domElement;
  }
  /**
   * Return the DOM element reference of the parent node of the autoNumeric-managed element
   *
   * @returns {HTMLElement|HTMLInputElement|Node}
   */
  parent() {
    return this.domElement.parentNode;
  }
  /**
   * Detach the current AutoNumeric element from the shared local 'init' list.
   * This means any changes made on that local shared list will not be transmitted to that element anymore.
   * Note : The user can provide another AutoNumeric element, and detach this one instead of the current one.
   *
   * @param {AutoNumeric} otherAnElement
   * @returns {AutoNumeric}
   */
  detach(otherAnElement = null) {
    let domElementToDetach;
    if (!AutoNumericHelper.isNull(otherAnElement)) {
      domElementToDetach = otherAnElement.node();
    } else {
      domElementToDetach = this.domElement;
    }
    this._removeFromLocalList(domElementToDetach);
    return this;
  }
  /**
   * Attach the given AutoNumeric element to the shared local 'init' list.
   * When doing that, by default the DOM content is left untouched.
   * The user can force a reformat with the new shared list options by passing a second argument to `true`.
   *
   * @param {AutoNumeric} otherAnElement
   * @param {boolean} reFormat
   * @returns {AutoNumeric}
   */
  attach(otherAnElement, reFormat = true) {
    this._addToLocalList(otherAnElement.node());
    if (reFormat) {
      otherAnElement.update(this.settings);
    }
    return this;
  }
  /**
   * Format and return the given value, or set the formatted value into the given DOM element if one is passed as an argument.
   * By default, this use the current element settings.
   * The user can override any option of its choosing by passing an option object.
   *
   * @param {number|HTMLElement|HTMLInputElement} valueOrElement
   * @param {null|object} optionOverride
   * @returns {string|null}
   */
  formatOther(valueOrElement, optionOverride = null) {
    return this._formatOrUnformatOther(true, valueOrElement, optionOverride);
  }
  /**
       * Unformat and return the raw numeric string corresponding to the given value, or directly set the unformatted value into the given DOM element if one is passed as an argument.
       * By default, this use the current element settings.
       * The user can override any option of its choosing by passing an option object.
  
       * @param {string|HTMLElement|HTMLInputElement} stringOrElement
       * @param {null|object} optionOverride
       * @returns {string|null}
       */
  unformatOther(stringOrElement, optionOverride = null) {
    return this._formatOrUnformatOther(false, stringOrElement, optionOverride);
  }
  /**
   * Method that either format or unformat the value of another element.
   *
   * - Format and return the given value, or set the formatted value into the given DOM element if one is passed as an argument.
   * - Unformat and return the raw numeric string corresponding to the given value, or directly set the unformatted value into the given DOM element if one is passed as an argument.
   *
   * By default, this use the current element settings.
   * The user can override any option of its choosing by passing an option object.
   *
   * @param {boolean} isFormatting If set to `true`, then the method formats, otherwise if set to `false`, it unformats
   * @param {number|string|HTMLElement|HTMLInputElement} valueOrStringOrElement
   * @param {null|object} optionOverride
   * @returns {string|null}
   * @private
   */
  _formatOrUnformatOther(isFormatting, valueOrStringOrElement, optionOverride = null) {
    let settingsToUse;
    if (!AutoNumericHelper.isNull(optionOverride)) {
      settingsToUse = this._cloneAndMergeSettings(optionOverride);
    } else {
      settingsToUse = this.settings;
    }
    let result2;
    if (AutoNumericHelper.isElement(valueOrStringOrElement)) {
      const elementValue = AutoNumericHelper.getElementValue(valueOrStringOrElement);
      if (isFormatting) {
        result2 = _AutoNumeric.format(elementValue, settingsToUse);
      } else {
        result2 = _AutoNumeric.unformat(elementValue, settingsToUse);
      }
      AutoNumericHelper.setElementValue(valueOrStringOrElement, result2);
      return null;
    }
    if (isFormatting) {
      result2 = _AutoNumeric.format(valueOrStringOrElement, settingsToUse);
    } else {
      result2 = _AutoNumeric.unformat(valueOrStringOrElement, settingsToUse);
    }
    return result2;
  }
  /**
   * Use the current AutoNumeric element settings to initialize the DOM element(s) given as a parameter.
   * Doing so will *link* the AutoNumeric elements together since they will share the same local AutoNumeric element list.
   * (cf. prototype pattern : https://en.wikipedia.org/wiki/Prototype_pattern)
   *
   * You can `init` either a single DOM element (in that case an AutoNumeric object will be returned), or an array of DOM elements or a string that will be used as a CSS selector. In the latter cases, an array of AutoNumeric objects will then be returned (or an empty array if nothing gets selected by the CSS selector).
   *
   * Use case : Once you have an AutoNumeric element already setup correctly with the right options, you can use it as many times you want to initialize as many other DOM elements as needed.
   * Note : this works only on elements that can be managed by autoNumeric.
   *
   * @param {HTMLElement|HTMLInputElement|Array<HTMLElement|HTMLInputElement>|string} domElementOrArrayOrString
   * @param {boolean} attached If set to `false`, then the newly generated AutoNumeric element will not share the same local element list
   * @returns {AutoNumeric|[AutoNumeric]}
   */
  init(domElementOrArrayOrString, attached = true) {
    let returnASingleAutoNumericObject = false;
    let domElementsArray = [];
    if (AutoNumericHelper.isString(domElementOrArrayOrString)) {
      domElementsArray = [...document.querySelectorAll(domElementOrArrayOrString)];
    } else if (AutoNumericHelper.isElement(domElementOrArrayOrString)) {
      domElementsArray.push(domElementOrArrayOrString);
      returnASingleAutoNumericObject = true;
    } else if (AutoNumericHelper.isArray(domElementOrArrayOrString)) {
      domElementsArray = domElementOrArrayOrString;
    } else {
      AutoNumericHelper.throwError(`The given parameters to the 'init' function are invalid.`);
    }
    if (domElementsArray.length === 0) {
      AutoNumericHelper.warning(`No valid DOM elements were given hence no AutoNumeric object were instantiated.`, true);
      return [];
    }
    const currentLocalList = this._getLocalList();
    const autoNumericObjectsArray = [];
    domElementsArray.forEach((domElement) => {
      const originalCreateLocalListSetting = this.settings.createLocalList;
      if (attached) {
        this.settings.createLocalList = false;
      }
      const newAutoNumericElement = new _AutoNumeric(domElement, AutoNumericHelper.getElementValue(domElement), this.settings);
      if (attached) {
        newAutoNumericElement._setLocalList(currentLocalList);
        this._addToLocalList(domElement, newAutoNumericElement);
        this.settings.createLocalList = originalCreateLocalListSetting;
      }
      autoNumericObjectsArray.push(newAutoNumericElement);
    });
    if (returnASingleAutoNumericObject) {
      return autoNumericObjectsArray[0];
    }
    return autoNumericObjectsArray;
  }
  /**
   * Reset the element value either to the empty string '', or the currency sign, depending on the `emptyInputBehavior` option value.
   * If you set the `forceClearAll` argument to `true`, then the `emptyInputBehavior` option is overridden and the whole input is clear, including any currency sign.
   *
   * @param {boolean} forceClearAll
   * @returns {AutoNumeric}
   */
  clear(forceClearAll = false) {
    if (forceClearAll) {
      const temporaryForcedOptions = {
        emptyInputBehavior: _AutoNumeric.options.emptyInputBehavior.focus
      };
      this.set("", temporaryForcedOptions);
    } else {
      this.set("");
    }
    return this;
  }
  /**
   * Remove the autoNumeric data and event listeners from the element, but keep the element content intact.
   * This also clears the value from sessionStorage (or cookie, depending on browser supports).
   * Note: this does not remove the formatting.
   *
   * @example anElement.remove()
   */
  remove() {
    this._removeValueFromPersistentStorage();
    this._removeEventListeners();
    this._removeWatcher();
    this._removeFromLocalList(this.domElement);
    this.constructor._removeFromGlobalList(this);
  }
  /**
   * Remove the autoNumeric data and event listeners from the element, and reset its value to the empty string ''.
   * This also clears the value from sessionStorage (or cookie, depending on browser supports).
   *
   * @example anElement.wipe()
   */
  wipe() {
    this._setElementValue("", false);
    this.remove();
  }
  /**
   * Remove the autoNumeric data and event listeners from the element, and delete the DOM element altogether
   */
  nuke() {
    this.remove();
    this.domElement.parentNode.removeChild(this.domElement);
  }
  // Special functions that really work on the parent <form> element, instead of the <input> element itself
  /**
   * Return a reference to the parent <form> element if it exists, otherwise return `null`.
   * If the parent form element as already been found, this directly return a reference to it.
   * However, you can force AutoNumeric to search again for its reference by passing `true` as a parameter to this method.
   * This method updates the `this.parentForm` attribute.
   *
   * In either case, whenever a new parent form is set for the current AutoNumeric element, we make sure to update the anCount and anFormHandler attributes on both the old form and the new one (for instance in case the user moved the input elements with `appendChild()` since AutoNumeric cannot not detect that).
   *
   * @param {boolean} forceSearch If set to `true`, the parent form is searched again, even if `this.parentForm` is already set.
   *
   * @returns {HTMLFormElement|null}
   */
  form(forceSearch = false) {
    if (forceSearch || AutoNumericHelper.isUndefinedOrNullOrEmpty(this.parentForm)) {
      const newParentForm = this._getParentForm();
      if (!AutoNumericHelper.isNull(newParentForm) && newParentForm !== this.parentForm) {
        const oldANChildren = this._getFormAutoNumericChildren(this.parentForm);
        this.parentForm.dataset.anCount = oldANChildren.length;
        if (this._hasFormHandlerFunction(newParentForm)) {
          this._incrementParentFormCounter(newParentForm);
        } else {
          this._storeFormHandlerFunction(newParentForm);
          this._initializeFormCounterToOne(newParentForm);
        }
      }
      this.parentForm = newParentForm;
    }
    return this.parentForm;
  }
  /**
   * Returns an array of the AutoNumeric-managed elements for the given form element is passed, otherwise for the current `this.parentForm` element.
   * This search for <input> elements, as well as contenteditable non-input tag ones. This also search for elements outside the `form` elements.
   *
   * @param {HTMLFormElement|null} formElement
   *
   * @returns {Array.<HTMLInputElement>}
   * @private
   */
  _getFormAutoNumericChildren(formElement) {
    const inputElementsList = [...formElement.elements];
    const nonInputContentEditableElementsList = this._getContenteditableElements(formElement);
    const elementsList = AutoNumericHelper.arrayUnique(inputElementsList, nonInputContentEditableElementsList);
    return elementsList.filter((element) => this.constructor.isManagedByAutoNumeric(element));
  }
  /**
   * Returns an array of the non-input contenteditable elements linked to the given form element.
   * Two types of elements are possible, either located inside the form element, or outside.
   * For the outside elements, this only works if the form element has a defined id and that id is referenced on the non-input element as the `form` attribute.
   * If no elements can be found, then an empty array is returned.
   *
   * @param {HTMLFormElement|null} formElement
   *
   * @returns {Array.<HTMLInputElement>}
   * @private
   */
  _getContenteditableElements(formElement) {
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(formElement) || !formElement.hasAttribute("id")) {
      return [];
    }
    const elementsInside = [...formElement.querySelectorAll("[contenteditable=true]")];
    const elementsOutside = [...document.querySelectorAll(`*:not(input)[form=${formElement.id}][contenteditable=true]`)];
    return AutoNumericHelper.arrayUnique(elementsInside, elementsOutside);
  }
  /**
   * Returns a reference to the parent <form> element if it exists, otherwise return `null`.
   *
   * @returns {HTMLFormElement|null}
   * @private
   */
  _getParentForm() {
    if (!AutoNumericHelper.isUndefined(this.domElement.form)) return this.domElement.form;
    if (this.domElement.tagName.toLowerCase() === "body") {
      return null;
    }
    let node3 = this.domElement;
    let tagName;
    do {
      node3 = node3.parentNode;
      if (AutoNumericHelper.isNull(node3)) {
        return null;
      }
      if (node3.tagName) {
        tagName = node3.tagName.toLowerCase();
      } else {
        tagName = "";
      }
      if (tagName === "body") {
        break;
      }
    } while (tagName !== "form");
    if (tagName === "form") {
      return node3;
    } else {
      return null;
    }
  }
  /**
   * Return a string in standard URL-encoded notation with the form input values being unformatted.
   * This string can be used as a query for instance.
   *
   * @returns {string}
   */
  formNumericString() {
    return this.constructor._serializeNumericString(this.form(), this.settings.serializeSpaces);
  }
  /**
   * Return a string in standard URL-encoded notation with the form input values being formatted.
   *
   * @returns {string}
   */
  formFormatted() {
    return this.constructor._serializeFormatted(this.form(), this.settings.serializeSpaces);
  }
  /**
   * Return a string in standard URL-encoded notation with the form input values, with localized values.
   * The default output format can be overridden by passing the option as a parameter.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {string}
   */
  formLocalized(forcedOutputFormat = null) {
    let outputFormatToUse;
    if (AutoNumericHelper.isNull(forcedOutputFormat)) {
      outputFormatToUse = this.settings.outputFormat;
    } else {
      outputFormatToUse = forcedOutputFormat;
    }
    return this.constructor._serializeLocalized(this.form(), this.settings.serializeSpaces, outputFormatToUse);
  }
  /**
   * Return an array containing an object for each form <input> element.
   * Those objects are of the following structure `{ name: foo, value: '42' }`, where the `name` is the DOM element name, and the `value` is an unformatted numeric string.
   *
   * @returns {Array}
   */
  formArrayNumericString() {
    return this.constructor._serializeNumericStringArray(this.form(), this.settings.serializeSpaces);
  }
  /**
   * Return an array containing an object for each form <input> element.
   * Those objects are of the following structure `{ name: foo, value: '42' }`, where the `name` is the DOM element name, and the `value` is the formatted string.
   *
   * @returns {Array}
   */
  formArrayFormatted() {
    return this.constructor._serializeFormattedArray(this.form(), this.settings.serializeSpaces);
  }
  /**
   * Return an array containing an object for each form <input> element.
   * Those objects are of the following structure `{ name: foo, value: '42' }`, where the `name` is the DOM element name, and the `value` is the localized numeric string.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {Array}
   */
  formArrayLocalized(forcedOutputFormat = null) {
    let outputFormatToUse;
    if (AutoNumericHelper.isNull(forcedOutputFormat)) {
      outputFormatToUse = this.settings.outputFormat;
    } else {
      outputFormatToUse = forcedOutputFormat;
    }
    return this.constructor._serializeLocalizedArray(this.form(), this.settings.serializeSpaces, outputFormatToUse);
  }
  /**
   * Return a JSON string containing an object representing the form input values.
   * This is based on the result of the `formArrayNumericString()` function.
   *
   * @returns {string}
   */
  formJsonNumericString() {
    return JSON.stringify(this.formArrayNumericString());
  }
  /**
   * Return a JSON string containing an object representing the form input values.
   * This is based on the result of the `formArrayFormatted()` function.
   *
   * @returns {string}
   */
  formJsonFormatted() {
    return JSON.stringify(this.formArrayFormatted());
  }
  /**
   * Return a JSON string containing an object representing the form input values.
   * This is based on the result of the `formArrayLocalized()` function.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {string}
   */
  formJsonLocalized(forcedOutputFormat = null) {
    return JSON.stringify(this.formArrayLocalized(forcedOutputFormat));
  }
  /**
   * Unformat all the autoNumeric-managed elements that are a child of the parent <form> element of this DOM element, to numeric strings
   *
   * @returns {AutoNumeric}
   */
  formUnformat() {
    const inputs = this.constructor._getChildANInputElement(this.form());
    inputs.forEach((input) => {
      _AutoNumeric.getAutoNumericElement(input).unformat();
    });
    return this;
  }
  /**
   * Unformat all the autoNumeric-managed elements that are a child of the parent <form> element of this DOM element, to localized strings
   *
   * @returns {AutoNumeric}
   */
  formUnformatLocalized() {
    const inputs = this.constructor._getChildANInputElement(this.form());
    inputs.forEach((input) => {
      _AutoNumeric.getAutoNumericElement(input).unformatLocalized();
    });
    return this;
  }
  /**
   * Reformat all the autoNumeric-managed elements that are a child of the parent <form> element of this DOM element
   *
   * @returns {AutoNumeric}
   */
  formReformat() {
    const inputs = this.constructor._getChildANInputElement(this.form());
    inputs.forEach((input) => {
      _AutoNumeric.getAutoNumericElement(input).reformat();
    });
    return this;
  }
  /**
   * Convert the input values to numeric strings, submit the form, then reformat those back.
   * The function can either take a callback, or not. If it doesn't, the default `form.submit()` function will be called.
   * Otherwise, it runs `callback(value)` with `value` being equal to the result of `formNumericString()`.
   *
   * @param {function|null} callback
   * @returns {AutoNumeric}
   */
  formSubmitNumericString(callback = null) {
    if (AutoNumericHelper.isNull(callback)) {
      this.formUnformat();
      this.form().submit();
      this.formReformat();
    } else if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formNumericString());
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Submit the form with the current formatted values.
   * The function can either take a callback, or not. If it doesn't, the default `form.submit()` function will be called.
   * Otherwise, it runs `callback(value)` with `value` being equal to the result of `formFormatted()`.
   *
   * @param {function|null} callback
   * @returns {AutoNumeric}
   */
  formSubmitFormatted(callback = null) {
    if (AutoNumericHelper.isNull(callback)) {
      this.form().submit();
    } else if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formFormatted());
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Convert the input values to localized strings, submit the form, then reformat those back.
   * The function can either take a callback, or not. If it doesn't, the default `form.submit()` function will be called.
   * Otherwise, it runs `callback(value)` with `value` being equal to the result of `formLocalized()`.
   *
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @param {function|null} callback
   * @returns {AutoNumeric}
   */
  formSubmitLocalized(forcedOutputFormat = null, callback = null) {
    if (AutoNumericHelper.isNull(callback)) {
      this.formUnformatLocalized();
      this.form().submit();
      this.formReformat();
    } else if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formLocalized(forcedOutputFormat));
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Generate an array of numeric strings from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formArrayNumericString()`.
   *
   * @param {function} callback
   * @returns {AutoNumeric}
   */
  formSubmitArrayNumericString(callback) {
    if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formArrayNumericString());
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Generate an array of the current formatted values from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formArrayFormatted()`.
   *
   * @param {function} callback
   * @returns {AutoNumeric}
   */
  formSubmitArrayFormatted(callback) {
    if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formArrayFormatted());
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Generate an array of localized strings from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formArrayLocalized()`.
   *
   * @param {function} callback
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {AutoNumeric}
   */
  formSubmitArrayLocalized(callback, forcedOutputFormat = null) {
    if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formArrayLocalized(forcedOutputFormat));
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Generate a JSON string with the numeric strings values from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formJsonNumericString()`.
   *
   * @param {function} callback
   * @returns {AutoNumeric}
   */
  formSubmitJsonNumericString(callback) {
    if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formJsonNumericString());
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Generate a JSON string with the current formatted values from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formJsonFormatted()`.
   *
   * @param {function} callback
   * @returns {AutoNumeric}
   */
  formSubmitJsonFormatted(callback) {
    if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formJsonFormatted());
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Generate a JSON string with the localized strings values from the `<input>` elements, and pass it to the given callback.
   * Under the hood, the array is generated via a call to `formJsonLocalized()`.
   *
   * @param {function} callback
   * @param {null|string} forcedOutputFormat If set to something different from `null`, then this is used as an overriding outputFormat option
   * @returns {AutoNumeric}
   */
  formSubmitJsonLocalized(callback, forcedOutputFormat = null) {
    if (AutoNumericHelper.isFunction(callback)) {
      callback(this.formJsonLocalized(forcedOutputFormat));
    } else {
      AutoNumericHelper.throwError(`The given callback is not a function.`);
    }
    return this;
  }
  /**
   * Unformat the given AutoNumeric element, and update the `hoveredWithAlt` variable.
   *
   * @param {AutoNumeric} anElement
   * @private
   */
  static _unformatAltHovered(anElement) {
    anElement.hoveredWithAlt = true;
    anElement.unformat();
  }
  /**
   * Reformat the given AutoNumeric element, and update the `hoveredWithAlt` variable.
   *
   * @param {AutoNumeric} anElement
   * @private
   */
  static _reformatAltHovered(anElement) {
    anElement.hoveredWithAlt = false;
    anElement.reformat();
  }
  /**
   * Return an array of autoNumeric elements, child of the <form> element passed as a parameter.
   *
   * @param {HTMLElement} formNode
   * @returns {Array}
   * @private
   */
  static _getChildANInputElement(formNode) {
    const inputList = formNode.getElementsByTagName("input");
    const autoNumericInputs = [];
    const inputElements = Array.prototype.slice.call(inputList, 0);
    inputElements.forEach((input) => {
      if (this.test(input)) {
        autoNumericInputs.push(input);
      }
    });
    return autoNumericInputs;
  }
  // Static methods
  /**
   * Test if the given DOM element, or the element selected by the given selector string is already managed by AutoNumeric (if it has been initialized on the current page).
   *
   * @param {HTMLElement|string} domElementOrSelector Accepts either directly a DOM element to test, or a string selector (that will return one and only one element, if any)
   * @returns {boolean}
   */
  static test(domElementOrSelector) {
    return this._isInGlobalList(AutoNumericHelper.domElement(domElementOrSelector));
  }
  /**
   * Create a WeakMap with the given name.
   *
   * @param {string} weakMapName
   * @private
   */
  static _createWeakMap(weakMapName) {
    window[weakMapName] = /* @__PURE__ */ new WeakMap();
  }
  /**
   * Create a list of all the AutoNumeric elements that are initialized on the current page.
   * This is needed in order to determine if a given dom element is already managed by autoNumeric.
   * This uses a WeakMap in order to limit potential garbage collection problems.
   * (cf. my tests on http://codepen.io/AnotherLinuxUser/pen/pRQGaM?editors=1011)
   * @private
   */
  static _createGlobalList() {
    this.autoNumericGlobalListName = "autoNumericGlobalList";
    this._createWeakMap(this.autoNumericGlobalListName);
  }
  /**
   * Return `true` if the global AutoNumeric element list exists.
   *
   * @returns {boolean}
   * @private
   */
  static _doesGlobalListExists() {
    const type2 = typeof window[this.autoNumericGlobalListName];
    return type2 !== "undefined" && type2 === "object";
  }
  /**
   * Add the given object to the global AutoNumeric element list.
   *
   * @param {AutoNumeric} autoNumericObject
   * @private
   */
  static _addToGlobalList(autoNumericObject) {
    if (!this._doesGlobalListExists()) {
      this._createGlobalList();
    }
    const domElement = autoNumericObject.node();
    if (this._isInGlobalList(domElement)) {
      if (this._getFromGlobalList(domElement) === this) {
        return;
      } else {
        AutoNumericHelper.warning(`A reference to the DOM element you just initialized already exists in the global AutoNumeric element list. Please make sure to not initialize the same DOM element multiple times.`, autoNumericObject.getSettings().showWarnings);
      }
    }
    window[this.autoNumericGlobalListName].set(domElement, autoNumericObject);
  }
  /**
   * Remove the given object from the global AutoNumeric element list.
   *
   * @param {AutoNumeric} autoNumericObject
   * @private
   */
  static _removeFromGlobalList(autoNumericObject) {
    if (this._doesGlobalListExists()) {
      window[this.autoNumericGlobalListName].delete(autoNumericObject.node());
    }
  }
  /**
   * Return the value associated to the key `domElement` passed as a parameter.
   * The value is the AutoNumeric object that manages the DOM element `domElement`.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @returns {null|AutoNumeric}
   * @private
   */
  static _getFromGlobalList(domElement) {
    if (this._doesGlobalListExists()) {
      return window[this.autoNumericGlobalListName].get(domElement);
    }
    return null;
  }
  /**
   * Check if the given DOM element is in the global AutoNumeric element list.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @returns {boolean}
   * @private
   */
  static _isInGlobalList(domElement) {
    if (!this._doesGlobalListExists()) {
      return false;
    }
    return window[this.autoNumericGlobalListName].has(domElement);
  }
  /**
   * Create a `Map` that will store all the autoNumeric elements that are initialized from this current element.
   * @private
   */
  _createLocalList() {
    this.autoNumericLocalList = /* @__PURE__ */ new Map();
    this._addToLocalList(this.domElement);
  }
  /**
   * In some rare cases, you could want to delete the local list generated during the element initialization (in order to use another one instead for instance).
   * @private
   */
  _deleteLocalList() {
    delete this.autoNumericLocalList;
  }
  /**
   * Set the local list with the given Map object.
   *
   * @param {Map} localList
   * @private
   */
  _setLocalList(localList) {
    this.autoNumericLocalList = localList;
  }
  /**
   * Return the local list Map object.
   *
   * @returns {*|Map}
   * @private
   */
  _getLocalList() {
    return this.autoNumericLocalList;
  }
  /**
   * Return `true` if the AutoNumeric object has a local list defined already and has at least one element in it (itself usually).
   *
   * @returns {boolean}
   * @private
   */
  _hasLocalList() {
    return this.autoNumericLocalList instanceof Map && this.autoNumericLocalList.size !== 0;
  }
  /**
   * Add the given object to the local autoNumeric element list.
   * Note: in order to keep a coherent list, we only add DOM elements in it, not the autoNumeric object.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @param {AutoNumeric} autoNumericObject A reference to the AutoNumeric object that manage the given DOM element
   * @throws
   * @private
   */
  _addToLocalList(domElement, autoNumericObject = null) {
    if (AutoNumericHelper.isNull(autoNumericObject)) {
      autoNumericObject = this;
    }
    if (!AutoNumericHelper.isUndefined(this.autoNumericLocalList)) {
      this.autoNumericLocalList.set(domElement, autoNumericObject);
    } else {
      AutoNumericHelper.throwError(`The local list provided does not exists when trying to add an element. [${this.autoNumericLocalList}] given.`);
    }
  }
  /**
   * Remove the given object from the local autoNumeric element list.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @private
   */
  _removeFromLocalList(domElement) {
    if (!AutoNumericHelper.isUndefined(this.autoNumericLocalList)) {
      this.autoNumericLocalList.delete(domElement);
    } else if (this.settings.createLocalList) {
      AutoNumericHelper.throwError(`The local list provided does not exists when trying to remove an element. [${this.autoNumericLocalList}] given.`);
    }
  }
  /**
   * Merge the `newSettings` given as parameters into the current element settings.
   *
   * WARNING: Using `Object.assign()` here means the merge is not recursive and only one depth is merged.
   * cf. http://stackoverflow.com/a/39188108/2834898
   * cf. tests on http://codepen.io/AnotherLinuxUser/pen/KaJORq?editors=0011
   *
   * @param {object} newSettings
   * @private
   */
  _mergeSettings(...newSettings) {
    Object.assign(this.settings, ...newSettings);
  }
  /**
   * Return a new object with the current element settings merged with the new settings.
   *
   * @param {object} newSettings
   * @returns {object}
   * @private
   */
  _cloneAndMergeSettings(...newSettings) {
    const result2 = {};
    Object.assign(result2, this.settings, ...newSettings);
    return result2;
  }
  /**
   * Validate the given option object.
   * If the options are valid, this function returns nothing, otherwise if the options are invalid, this function throws an error.
   *
   * This tests if the options are not conflicting and are well formatted.
   * This function is lenient since it only tests the settings properties ; it ignores any other properties the options object could have.
   *
   * @param {*} userOptions
   * @param {Boolean} shouldExtendDefaultOptions If `true`, then this function will extend the `userOptions` passed by the user, with the default options.
   * @param {object|null} originalOptions The user can pass the original options (and not the one that are generated from the default settings and the various usability corrections), in order to add compatibility and conflicts checks.
   * @throws Error This throws if the `userOptions` are not valid
   */
  static validate(userOptions, shouldExtendDefaultOptions = true, originalOptions = null) {
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(userOptions) || !AutoNumericHelper.isObject(userOptions)) {
      AutoNumericHelper.throwError(`The userOptions are invalid ; it should be a valid object, [${userOptions}] given.`);
    }
    const isOriginalOptionAnObject = AutoNumericHelper.isObject(originalOptions);
    if (!isOriginalOptionAnObject && !AutoNumericHelper.isNull(originalOptions)) {
      AutoNumericHelper.throwError(`The 'originalOptions' parameter is invalid ; it should either be a valid option object or \`null\`, [${userOptions}] given.`);
    }
    if (!AutoNumericHelper.isNull(userOptions)) {
      this._convertOldOptionsToNewOnes(userOptions);
    }
    let options;
    if (shouldExtendDefaultOptions) {
      options = Object.assign({}, this.getDefaultConfig(), userOptions);
    } else {
      options = userOptions;
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.showWarnings) && !AutoNumericHelper.isBoolean(options.showWarnings)) {
      AutoNumericHelper.throwError(`The debug option 'showWarnings' is invalid ; it should be either 'true' or 'false', [${options.showWarnings}] given.`);
    }
    const testPositiveInteger = /^[0-9]+$/;
    const testNumericalCharacters = /[0-9]+/;
    const testFloatOrIntegerAndPossibleNegativeSign = /^-?[0-9]+(\.?[0-9]+)?$/;
    const testPositiveFloatOrInteger = /^[0-9]+(\.?[0-9]+)?$/;
    if (!AutoNumericHelper.isTrueOrFalseString(options.allowDecimalPadding) && !AutoNumericHelper.isBoolean(options.allowDecimalPadding) && options.allowDecimalPadding !== _AutoNumeric.options.allowDecimalPadding.floats && !(AutoNumericHelper.isNumber(options.allowDecimalPadding) && options.allowDecimalPadding > 0)) {
      AutoNumericHelper.throwError(`The decimal padding option 'allowDecimalPadding' is invalid ; it should either be \`false\`, \`true\`, \`'floats'\` or a positive integer superior to 0, [${options.allowDecimalPadding}] given.`);
    }
    if (AutoNumericHelper.isNumber(options.allowDecimalPadding) && options.allowDecimalPadding > options.decimalPlaces) {
      AutoNumericHelper.warning(`Setting 'allowDecimalPadding' to a number [${options.allowDecimalPadding}] superior to the current 'decimalPlaces' settings [${options.decimalPlaces}] is useless, since the padding will not be shown.`, options.showWarnings);
    }
    if ((options.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.never || options.allowDecimalPadding === "false") && (options.decimalPlaces !== _AutoNumeric.options.decimalPlaces.none || options.decimalPlacesShownOnBlur !== _AutoNumeric.options.decimalPlacesShownOnBlur.none || options.decimalPlacesShownOnFocus !== _AutoNumeric.options.decimalPlacesShownOnFocus.none)) {
      AutoNumericHelper.warning(`Setting 'allowDecimalPadding' to [${options.allowDecimalPadding}] will override the current 'decimalPlaces*' settings [${options.decimalPlaces}, ${options.decimalPlacesShownOnBlur} and ${options.decimalPlacesShownOnFocus}].`, options.showWarnings);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.alwaysAllowDecimalCharacter) && !AutoNumericHelper.isBoolean(options.alwaysAllowDecimalCharacter)) {
      AutoNumericHelper.throwError(`The option 'alwaysAllowDecimalCharacter' is invalid ; it should either be \`true\` or \`false\`, [${options.alwaysAllowDecimalCharacter}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.caretPositionOnFocus) && !AutoNumericHelper.isInArray(options.caretPositionOnFocus, [
      _AutoNumeric.options.caretPositionOnFocus.start,
      _AutoNumeric.options.caretPositionOnFocus.end,
      _AutoNumeric.options.caretPositionOnFocus.decimalLeft,
      _AutoNumeric.options.caretPositionOnFocus.decimalRight
    ])) {
      AutoNumericHelper.throwError(`The display on empty string option 'caretPositionOnFocus' is invalid ; it should either be \`null\`, 'focus', 'press', 'always' or 'zero', [${options.caretPositionOnFocus}] given.`);
    }
    let optionsToUse;
    if (isOriginalOptionAnObject) {
      optionsToUse = originalOptions;
    } else {
      optionsToUse = this._correctCaretPositionOnFocusAndSelectOnFocusOptions(userOptions);
    }
    if (!AutoNumericHelper.isNull(optionsToUse) && (optionsToUse.caretPositionOnFocus !== _AutoNumeric.options.caretPositionOnFocus.doNoForceCaretPosition && optionsToUse.selectOnFocus === _AutoNumeric.options.selectOnFocus.select)) {
      AutoNumericHelper.warning(`The 'selectOnFocus' option is set to 'select', which is in conflict with the 'caretPositionOnFocus' which is set to '${optionsToUse.caretPositionOnFocus}'. As a result, if this has been called when instantiating an AutoNumeric object, the 'selectOnFocus' option is forced to 'doNotSelect'.`, options.showWarnings);
    }
    if (!AutoNumericHelper.isInArray(options.digitGroupSeparator, [
      _AutoNumeric.options.digitGroupSeparator.comma,
      _AutoNumeric.options.digitGroupSeparator.dot,
      _AutoNumeric.options.digitGroupSeparator.normalSpace,
      _AutoNumeric.options.digitGroupSeparator.thinSpace,
      _AutoNumeric.options.digitGroupSeparator.narrowNoBreakSpace,
      _AutoNumeric.options.digitGroupSeparator.noBreakSpace,
      _AutoNumeric.options.digitGroupSeparator.noSeparator,
      _AutoNumeric.options.digitGroupSeparator.apostrophe,
      _AutoNumeric.options.digitGroupSeparator.arabicThousandsSeparator,
      _AutoNumeric.options.digitGroupSeparator.dotAbove,
      _AutoNumeric.options.digitGroupSeparator.privateUseTwo
    ])) {
      AutoNumericHelper.throwError(`The thousand separator character option 'digitGroupSeparator' is invalid ; it should be ',', '.', '٬', '˙', "'", '', ' ', ' ', ' ', ' ' or empty (''), [${options.digitGroupSeparator}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.showOnlyNumbersOnFocus) && !AutoNumericHelper.isBoolean(options.showOnlyNumbersOnFocus)) {
      AutoNumericHelper.throwError(`The 'showOnlyNumbersOnFocus' option is invalid ; it should be either 'true' or 'false', [${options.showOnlyNumbersOnFocus}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.digitalGroupSpacing, [
      _AutoNumeric.options.digitalGroupSpacing.two,
      _AutoNumeric.options.digitalGroupSpacing.twoThree,
      _AutoNumeric.options.digitalGroupSpacing.twoScaled,
      _AutoNumeric.options.digitalGroupSpacing.three,
      _AutoNumeric.options.digitalGroupSpacing.four
    ]) && !(options.digitalGroupSpacing >= 2 && options.digitalGroupSpacing <= 4)) {
      AutoNumericHelper.throwError(`The grouping separator option for thousands 'digitalGroupSpacing' is invalid ; it should be '2', '2t', '2s', '3', or '4', [${options.digitalGroupSpacing}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.decimalCharacter, [
      _AutoNumeric.options.decimalCharacter.comma,
      _AutoNumeric.options.decimalCharacter.dot,
      _AutoNumeric.options.decimalCharacter.middleDot,
      _AutoNumeric.options.decimalCharacter.arabicDecimalSeparator,
      _AutoNumeric.options.decimalCharacter.decimalSeparatorKeySymbol
    ])) {
      AutoNumericHelper.throwError(`The decimal separator character option 'decimalCharacter' is invalid ; it should be '.', ',', '·', '⎖' or '٫', [${options.decimalCharacter}] given.`);
    }
    if (options.decimalCharacter === options.digitGroupSeparator) {
      AutoNumericHelper.throwError(`autoNumeric will not function properly when the decimal character 'decimalCharacter' [${options.decimalCharacter}] and the thousand separator 'digitGroupSeparator' [${options.digitGroupSeparator}] are the same character.`);
    }
    if (!AutoNumericHelper.isNull(options.decimalCharacterAlternative) && !AutoNumericHelper.isString(options.decimalCharacterAlternative)) {
      AutoNumericHelper.throwError(`The alternate decimal separator character option 'decimalCharacterAlternative' is invalid ; it should be a string, [${options.decimalCharacterAlternative}] given.`);
    }
    if (options.currencySymbol !== "" && !AutoNumericHelper.isString(options.currencySymbol)) {
      AutoNumericHelper.throwError(`The currency symbol option 'currencySymbol' is invalid ; it should be a string, [${options.currencySymbol}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.currencySymbolPlacement, [
      _AutoNumeric.options.currencySymbolPlacement.prefix,
      _AutoNumeric.options.currencySymbolPlacement.suffix
    ])) {
      AutoNumericHelper.throwError(`The placement of the currency sign option 'currencySymbolPlacement' is invalid ; it should either be 'p' (prefix) or 's' (suffix), [${options.currencySymbolPlacement}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.negativePositiveSignPlacement, [
      _AutoNumeric.options.negativePositiveSignPlacement.prefix,
      _AutoNumeric.options.negativePositiveSignPlacement.suffix,
      _AutoNumeric.options.negativePositiveSignPlacement.left,
      _AutoNumeric.options.negativePositiveSignPlacement.right,
      _AutoNumeric.options.negativePositiveSignPlacement.none
    ])) {
      AutoNumericHelper.throwError(`The placement of the negative sign option 'negativePositiveSignPlacement' is invalid ; it should either be 'p' (prefix), 's' (suffix), 'l' (left), 'r' (right) or 'null', [${options.negativePositiveSignPlacement}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.showPositiveSign) && !AutoNumericHelper.isBoolean(options.showPositiveSign)) {
      AutoNumericHelper.throwError(`The show positive sign option 'showPositiveSign' is invalid ; it should be either 'true' or 'false', [${options.showPositiveSign}] given.`);
    }
    if (!AutoNumericHelper.isString(options.suffixText) || options.suffixText !== "" && (AutoNumericHelper.isNegative(options.suffixText, options.negativeSignCharacter) || testNumericalCharacters.test(options.suffixText))) {
      AutoNumericHelper.throwError(`The additional suffix option 'suffixText' is invalid ; it should not contains the negative sign '${options.negativeSignCharacter}' nor any numerical characters, [${options.suffixText}] given.`);
    }
    if (!AutoNumericHelper.isString(options.negativeSignCharacter) || options.negativeSignCharacter.length !== 1 || AutoNumericHelper.isUndefinedOrNullOrEmpty(options.negativeSignCharacter) || testNumericalCharacters.test(options.negativeSignCharacter)) {
      AutoNumericHelper.throwError(`The negative sign character option 'negativeSignCharacter' is invalid ; it should be a single character, and cannot be any numerical characters, [${options.negativeSignCharacter}] given.`);
    }
    if (!AutoNumericHelper.isString(options.positiveSignCharacter) || options.positiveSignCharacter.length !== 1 || AutoNumericHelper.isUndefinedOrNullOrEmpty(options.positiveSignCharacter) || testNumericalCharacters.test(options.positiveSignCharacter)) {
      AutoNumericHelper.throwError(`The positive sign character option 'positiveSignCharacter' is invalid ; it should be a single character, and cannot be any numerical characters, [${options.positiveSignCharacter}] given.
If you want to show the positive sign character, you need to set the \`showPositiveSign\` option to \`true\`.`);
    }
    if (options.negativeSignCharacter === options.positiveSignCharacter) {
      AutoNumericHelper.throwError(`The positive 'positiveSignCharacter' and negative 'negativeSignCharacter' sign characters cannot be identical ; [${options.negativeSignCharacter}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.negativePositiveSignBehavior) && !AutoNumericHelper.isBoolean(options.negativePositiveSignBehavior)) {
      AutoNumericHelper.throwError(`The option 'negativePositiveSignBehavior' is invalid ; it should be either 'true' or 'false', [${options.negativePositiveSignBehavior}] given.`);
    }
    const [leftBracket, rightBracket] = AutoNumericHelper.isNull(options.negativeBracketsTypeOnBlur) ? ["", ""] : options.negativeBracketsTypeOnBlur.split(",");
    if (AutoNumericHelper.contains(options.digitGroupSeparator, options.negativeSignCharacter) || AutoNumericHelper.contains(options.decimalCharacter, options.negativeSignCharacter) || AutoNumericHelper.contains(options.decimalCharacterAlternative, options.negativeSignCharacter) || AutoNumericHelper.contains(leftBracket, options.negativeSignCharacter) || AutoNumericHelper.contains(rightBracket, options.negativeSignCharacter) || AutoNumericHelper.contains(options.suffixText, options.negativeSignCharacter)) {
      AutoNumericHelper.throwError(`The negative sign character option 'negativeSignCharacter' is invalid ; it should not be equal or a part of the digit separator, the decimal character, the decimal character alternative, the negative brackets or the suffix text, [${options.negativeSignCharacter}] given.`);
    }
    if (AutoNumericHelper.contains(options.digitGroupSeparator, options.positiveSignCharacter) || AutoNumericHelper.contains(options.decimalCharacter, options.positiveSignCharacter) || AutoNumericHelper.contains(options.decimalCharacterAlternative, options.positiveSignCharacter) || AutoNumericHelper.contains(leftBracket, options.positiveSignCharacter) || AutoNumericHelper.contains(rightBracket, options.positiveSignCharacter) || AutoNumericHelper.contains(options.suffixText, options.positiveSignCharacter)) {
      AutoNumericHelper.throwError(`The positive sign character option 'positiveSignCharacter' is invalid ; it should not be equal or a part of the digit separator, the decimal character, the decimal character alternative, the negative brackets or the suffix text, [${options.positiveSignCharacter}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.overrideMinMaxLimits) && !AutoNumericHelper.isInArray(options.overrideMinMaxLimits, [
      _AutoNumeric.options.overrideMinMaxLimits.ceiling,
      _AutoNumeric.options.overrideMinMaxLimits.floor,
      _AutoNumeric.options.overrideMinMaxLimits.ignore,
      _AutoNumeric.options.overrideMinMaxLimits.invalid
    ])) {
      AutoNumericHelper.throwError(`The override min & max limits option 'overrideMinMaxLimits' is invalid ; it should either be 'ceiling', 'floor', 'ignore' or 'invalid', [${options.overrideMinMaxLimits}] given.`);
    }
    if (options.overrideMinMaxLimits !== _AutoNumeric.options.overrideMinMaxLimits.invalid && options.overrideMinMaxLimits !== _AutoNumeric.options.overrideMinMaxLimits.ignore && (options.minimumValue > 0 || options.maximumValue < 0)) {
      AutoNumericHelper.warning(`You've set a \`minimumValue\` or a \`maximumValue\` excluding the value \`0\`. AutoNumeric will force the users to always have a valid value in the input, hence preventing them to clear the field. If you want to allow for temporary invalid values (i.e. out-of-range), you should use the 'invalid' option for the 'overrideMinMaxLimits' setting.`);
    }
    if (!AutoNumericHelper.isString(options.maximumValue) || !testFloatOrIntegerAndPossibleNegativeSign.test(options.maximumValue)) {
      AutoNumericHelper.throwError(`The maximum possible value option 'maximumValue' is invalid ; it should be a string that represents a positive or negative number, [${options.maximumValue}] given.`);
    }
    if (!AutoNumericHelper.isString(options.minimumValue) || !testFloatOrIntegerAndPossibleNegativeSign.test(options.minimumValue)) {
      AutoNumericHelper.throwError(`The minimum possible value option 'minimumValue' is invalid ; it should be a string that represents a positive or negative number, [${options.minimumValue}] given.`);
    }
    if (parseFloat(options.minimumValue) > parseFloat(options.maximumValue)) {
      AutoNumericHelper.throwError(`The minimum possible value option is greater than the maximum possible value option ; 'minimumValue' [${options.minimumValue}] should be smaller than 'maximumValue' [${options.maximumValue}].`);
    }
    if (!(AutoNumericHelper.isInt(options.decimalPlaces) && options.decimalPlaces >= 0 || // If integer option
    AutoNumericHelper.isString(options.decimalPlaces) && testPositiveInteger.test(options.decimalPlaces))) {
      AutoNumericHelper.throwError(`The number of decimal places option 'decimalPlaces' is invalid ; it should be a positive integer, [${options.decimalPlaces}] given.`);
    }
    if (!(AutoNumericHelper.isNull(options.decimalPlacesRawValue) || AutoNumericHelper.isInt(options.decimalPlacesRawValue) && options.decimalPlacesRawValue >= 0 || // If integer option
    AutoNumericHelper.isString(options.decimalPlacesRawValue) && testPositiveInteger.test(options.decimalPlacesRawValue))) {
      AutoNumericHelper.throwError(`The number of decimal places for the raw value option 'decimalPlacesRawValue' is invalid ; it should be a positive integer or \`null\`, [${options.decimalPlacesRawValue}] given.`);
    }
    this._validateDecimalPlacesRawValue(options);
    if (!AutoNumericHelper.isNull(options.decimalPlacesShownOnFocus) && !testPositiveInteger.test(String(options.decimalPlacesShownOnFocus))) {
      AutoNumericHelper.throwError(`The number of expanded decimal places option 'decimalPlacesShownOnFocus' is invalid ; it should be a positive integer or \`null\`, [${options.decimalPlacesShownOnFocus}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.decimalPlacesShownOnFocus) && Number(options.decimalPlaces) > Number(options.decimalPlacesShownOnFocus)) {
      AutoNumericHelper.warning(`The extended decimal places 'decimalPlacesShownOnFocus' [${options.decimalPlacesShownOnFocus}] should be greater than the 'decimalPlaces' [${options.decimalPlaces}] value. Currently, this will limit the ability of your user to manually change some of the decimal places. Do you really want to do that?`, options.showWarnings);
    }
    if (!AutoNumericHelper.isNull(options.divisorWhenUnfocused) && !testPositiveFloatOrInteger.test(options.divisorWhenUnfocused) || options.divisorWhenUnfocused === 0 || options.divisorWhenUnfocused === "0" || options.divisorWhenUnfocused === 1 || options.divisorWhenUnfocused === "1") {
      AutoNumericHelper.throwError(`The divisor option 'divisorWhenUnfocused' is invalid ; it should be a positive number higher than one, preferably an integer, [${options.divisorWhenUnfocused}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.decimalPlacesShownOnBlur) && !testPositiveInteger.test(options.decimalPlacesShownOnBlur)) {
      AutoNumericHelper.throwError(`The number of decimals shown when unfocused option 'decimalPlacesShownOnBlur' is invalid ; it should be a positive integer or \`null\`, [${options.decimalPlacesShownOnBlur}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.symbolWhenUnfocused) && !AutoNumericHelper.isString(options.symbolWhenUnfocused)) {
      AutoNumericHelper.throwError(`The symbol to show when unfocused option 'symbolWhenUnfocused' is invalid ; it should be a string, [${options.symbolWhenUnfocused}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.saveValueToSessionStorage) && !AutoNumericHelper.isBoolean(options.saveValueToSessionStorage)) {
      AutoNumericHelper.throwError(`The save to session storage option 'saveValueToSessionStorage' is invalid ; it should be either 'true' or 'false', [${options.saveValueToSessionStorage}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.onInvalidPaste, [
      _AutoNumeric.options.onInvalidPaste.error,
      _AutoNumeric.options.onInvalidPaste.ignore,
      _AutoNumeric.options.onInvalidPaste.clamp,
      _AutoNumeric.options.onInvalidPaste.truncate,
      _AutoNumeric.options.onInvalidPaste.replace
    ])) {
      AutoNumericHelper.throwError(`The paste behavior option 'onInvalidPaste' is invalid ; it should either be 'error', 'ignore', 'clamp', 'truncate' or 'replace' (cf. documentation), [${options.onInvalidPaste}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.roundingMethod, [
      _AutoNumeric.options.roundingMethod.halfUpSymmetric,
      _AutoNumeric.options.roundingMethod.halfUpAsymmetric,
      _AutoNumeric.options.roundingMethod.halfDownSymmetric,
      _AutoNumeric.options.roundingMethod.halfDownAsymmetric,
      _AutoNumeric.options.roundingMethod.halfEvenBankersRounding,
      _AutoNumeric.options.roundingMethod.upRoundAwayFromZero,
      _AutoNumeric.options.roundingMethod.downRoundTowardZero,
      _AutoNumeric.options.roundingMethod.toCeilingTowardPositiveInfinity,
      _AutoNumeric.options.roundingMethod.toFloorTowardNegativeInfinity,
      _AutoNumeric.options.roundingMethod.toNearest05,
      _AutoNumeric.options.roundingMethod.toNearest05Alt,
      _AutoNumeric.options.roundingMethod.upToNext05,
      _AutoNumeric.options.roundingMethod.downToNext05
    ])) {
      AutoNumericHelper.throwError(`The rounding method option 'roundingMethod' is invalid ; it should either be 'S', 'A', 's', 'a', 'B', 'U', 'D', 'C', 'F', 'N05', 'CHF', 'U05' or 'D05' (cf. documentation), [${options.roundingMethod}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.negativeBracketsTypeOnBlur) && !AutoNumericHelper.isInArray(options.negativeBracketsTypeOnBlur, [
      _AutoNumeric.options.negativeBracketsTypeOnBlur.parentheses,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.brackets,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.chevrons,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.curlyBraces,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.angleBrackets,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.japaneseQuotationMarks,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.halfBrackets,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.whiteSquareBrackets,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.quotationMarks,
      _AutoNumeric.options.negativeBracketsTypeOnBlur.guillemets
    ])) {
      AutoNumericHelper.throwError(`The brackets for negative values option 'negativeBracketsTypeOnBlur' is invalid ; it should either be '(,)', '[,]', '<,>', '{,}', '〈,〉', '｢,｣', '⸤,⸥', '⟦,⟧', '‹,›' or '«,»', [${options.negativeBracketsTypeOnBlur}] given.`);
    }
    if (!(AutoNumericHelper.isString(options.emptyInputBehavior) || AutoNumericHelper.isNumber(options.emptyInputBehavior)) || !(AutoNumericHelper.isInArray(options.emptyInputBehavior, [
      _AutoNumeric.options.emptyInputBehavior.focus,
      _AutoNumeric.options.emptyInputBehavior.press,
      _AutoNumeric.options.emptyInputBehavior.always,
      _AutoNumeric.options.emptyInputBehavior.min,
      _AutoNumeric.options.emptyInputBehavior.max,
      _AutoNumeric.options.emptyInputBehavior.zero,
      _AutoNumeric.options.emptyInputBehavior.null
    ]) || testFloatOrIntegerAndPossibleNegativeSign.test(options.emptyInputBehavior))) {
      AutoNumericHelper.throwError(`The display on empty string option 'emptyInputBehavior' is invalid ; it should either be 'focus', 'press', 'always', 'min', 'max', 'zero', 'null', a number, or a string that represents a number, [${options.emptyInputBehavior}] given.`);
    }
    if (options.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.zero && (options.minimumValue > 0 || options.maximumValue < 0)) {
      AutoNumericHelper.throwError(`The 'emptyInputBehavior' option is set to 'zero', but this value is outside of the range defined by 'minimumValue' and 'maximumValue' [${options.minimumValue}, ${options.maximumValue}].`);
    }
    if (testFloatOrIntegerAndPossibleNegativeSign.test(String(options.emptyInputBehavior))) {
      if (!this._isWithinRangeWithOverrideOption(options.emptyInputBehavior, options)) {
        AutoNumericHelper.throwError(`The 'emptyInputBehavior' option is set to a number or a string that represents a number, but its value [${options.emptyInputBehavior}] is outside of the range defined by the 'minimumValue' and 'maximumValue' options [${options.minimumValue}, ${options.maximumValue}].`);
      }
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.eventBubbles) && !AutoNumericHelper.isBoolean(options.eventBubbles)) {
      AutoNumericHelper.throwError(`The event bubbles option 'eventBubbles' is invalid ; it should be either 'true' or 'false', [${options.eventBubbles}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.eventIsCancelable) && !AutoNumericHelper.isBoolean(options.eventIsCancelable)) {
      AutoNumericHelper.throwError(`The event is cancelable option 'eventIsCancelable' is invalid ; it should be either 'true' or 'false', [${options.eventIsCancelable}] given.`);
    }
    if (AutoNumericHelper.isBoolean(options.invalidClass) || !/^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$/.test(options.invalidClass)) {
      AutoNumericHelper.throwError(`The name of the 'invalidClass' option is not a valid CSS class name ; it should not be empty, and should follow the '^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$' regex, [${options.invalidClass}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.leadingZero, [
      _AutoNumeric.options.leadingZero.allow,
      _AutoNumeric.options.leadingZero.deny,
      _AutoNumeric.options.leadingZero.keep
    ])) {
      AutoNumericHelper.throwError(`The leading zero behavior option 'leadingZero' is invalid ; it should either be 'allow', 'deny' or 'keep', [${options.leadingZero}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.formatOnPageLoad) && !AutoNumericHelper.isBoolean(options.formatOnPageLoad)) {
      AutoNumericHelper.throwError(`The format on initialization option 'formatOnPageLoad' is invalid ; it should be either 'true' or 'false', [${options.formatOnPageLoad}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.formulaMode) && !AutoNumericHelper.isBoolean(options.formulaMode)) {
      AutoNumericHelper.throwError(`The formula mode option 'formulaMode' is invalid ; it should be either 'true' or 'false', [${options.formulaMode}] given.`);
    }
    if (!testPositiveInteger.test(options.historySize) || options.historySize === 0) {
      AutoNumericHelper.throwError(`The history size option 'historySize' is invalid ; it should be a positive integer, [${options.historySize}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.selectNumberOnly) && !AutoNumericHelper.isBoolean(options.selectNumberOnly)) {
      AutoNumericHelper.throwError(`The select number only option 'selectNumberOnly' is invalid ; it should be either 'true' or 'false', [${options.selectNumberOnly}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.selectOnFocus) && !AutoNumericHelper.isBoolean(options.selectOnFocus)) {
      AutoNumericHelper.throwError(`The select on focus option 'selectOnFocus' is invalid ; it should be either 'true' or 'false', [${options.selectOnFocus}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.defaultValueOverride) && (options.defaultValueOverride !== "" && !testFloatOrIntegerAndPossibleNegativeSign.test(options.defaultValueOverride))) {
      AutoNumericHelper.throwError(`The unformatted default value option 'defaultValueOverride' is invalid ; it should be a string that represents a positive or negative number, [${options.defaultValueOverride}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.unformatOnSubmit) && !AutoNumericHelper.isBoolean(options.unformatOnSubmit)) {
      AutoNumericHelper.throwError(`The remove formatting on submit option 'unformatOnSubmit' is invalid ; it should be either 'true' or 'false', [${options.unformatOnSubmit}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.valuesToStrings) && !AutoNumericHelper.isObject(options.valuesToStrings)) {
      AutoNumericHelper.throwError(`The option 'valuesToStrings' is invalid ; it should be an object, ideally with 'key -> value' entries, [${options.valuesToStrings}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.outputFormat) && !AutoNumericHelper.isInArray(options.outputFormat, [
      _AutoNumeric.options.outputFormat.string,
      _AutoNumeric.options.outputFormat.number,
      _AutoNumeric.options.outputFormat.dot,
      _AutoNumeric.options.outputFormat.negativeDot,
      _AutoNumeric.options.outputFormat.comma,
      _AutoNumeric.options.outputFormat.negativeComma,
      _AutoNumeric.options.outputFormat.dotNegative,
      _AutoNumeric.options.outputFormat.commaNegative
    ])) {
      AutoNumericHelper.throwError(`The custom locale format option 'outputFormat' is invalid ; it should either be null, 'string', 'number', '.', '-.', ',', '-,', '.-' or ',-', [${options.outputFormat}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.isCancellable) && !AutoNumericHelper.isBoolean(options.isCancellable)) {
      AutoNumericHelper.throwError(`The cancellable behavior option 'isCancellable' is invalid ; it should be either 'true' or 'false', [${options.isCancellable}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.modifyValueOnUpDownArrow) && !AutoNumericHelper.isBoolean(options.modifyValueOnUpDownArrow)) {
      AutoNumericHelper.throwError(`The increment/decrement on up and down arrow keys 'modifyValueOnUpDownArrow' is invalid ; it should be either 'true' or 'false', [${options.modifyValueOnUpDownArrow}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.modifyValueOnWheel) && !AutoNumericHelper.isBoolean(options.modifyValueOnWheel)) {
      AutoNumericHelper.throwError(`The increment/decrement on mouse wheel option 'modifyValueOnWheel' is invalid ; it should be either 'true' or 'false', [${options.modifyValueOnWheel}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.watchExternalChanges) && !AutoNumericHelper.isBoolean(options.watchExternalChanges)) {
      AutoNumericHelper.throwError(`The option 'watchExternalChanges' is invalid ; it should be either 'true' or 'false', [${options.watchExternalChanges}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.wheelOn, [
      _AutoNumeric.options.wheelOn.focus,
      _AutoNumeric.options.wheelOn.hover
    ])) {
      AutoNumericHelper.throwError(`The wheel behavior option 'wheelOn' is invalid ; it should either be 'focus' or 'hover', [${options.wheelOn}] given.`);
    }
    if (!(AutoNumericHelper.isString(options.upDownStep) || AutoNumericHelper.isNumber(options.upDownStep)) || options.upDownStep !== "progressive" && !testPositiveFloatOrInteger.test(options.upDownStep) || Number(options.upDownStep) === 0) {
      AutoNumericHelper.throwError(`The up/down arrow step value option 'upDownStep' is invalid ; it should either be the string 'progressive', or a number or a string that represents a positive number (excluding zero), [${options.upDownStep}] given.`);
    }
    if (!(AutoNumericHelper.isString(options.wheelStep) || AutoNumericHelper.isNumber(options.wheelStep)) || options.wheelStep !== "progressive" && !testPositiveFloatOrInteger.test(options.wheelStep) || Number(options.wheelStep) === 0) {
      AutoNumericHelper.throwError(`The wheel step value option 'wheelStep' is invalid ; it should either be the string 'progressive', or a number or a string that represents a positive number (excluding zero), [${options.wheelStep}] given.`);
    }
    if (!AutoNumericHelper.isInArray(options.serializeSpaces, [
      _AutoNumeric.options.serializeSpaces.plus,
      _AutoNumeric.options.serializeSpaces.percent
    ])) {
      AutoNumericHelper.throwError(`The space replacement character option 'serializeSpaces' is invalid ; it should either be '+' or '%20', [${options.serializeSpaces}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.noEventListeners) && !AutoNumericHelper.isBoolean(options.noEventListeners)) {
      AutoNumericHelper.throwError(`The option 'noEventListeners' that prevent the creation of event listeners is invalid ; it should be either 'true' or 'false', [${options.noEventListeners}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.styleRules) && !(AutoNumericHelper.isObject(options.styleRules) && (Object.prototype.hasOwnProperty.call(options.styleRules, "positive") || Object.prototype.hasOwnProperty.call(options.styleRules, "negative") || Object.prototype.hasOwnProperty.call(options.styleRules, "ranges") || Object.prototype.hasOwnProperty.call(options.styleRules, "userDefined")))) {
      AutoNumericHelper.throwError(`The option 'styleRules' is invalid ; it should be a correctly structured object, with one or more 'positive', 'negative', 'ranges' or 'userDefined' attributes, [${options.styleRules}] given.`);
    }
    if (!AutoNumericHelper.isNull(options.styleRules) && Object.prototype.hasOwnProperty.call(options.styleRules, "userDefined") && !AutoNumericHelper.isNull(options.styleRules.userDefined)) {
      options.styleRules.userDefined.forEach((rule) => {
        if (Object.prototype.hasOwnProperty.call(rule, "callback") && !AutoNumericHelper.isFunction(rule.callback)) {
          AutoNumericHelper.throwError(`The callback defined in the \`userDefined\` attribute is not a function, ${typeof rule.callback} given.`);
        }
      });
    }
    if (!AutoNumericHelper.isNull(options.rawValueDivisor) && !testPositiveFloatOrInteger.test(options.rawValueDivisor) || options.rawValueDivisor === 0 || options.rawValueDivisor === "0" || options.rawValueDivisor === 1 || options.rawValueDivisor === "1") {
      AutoNumericHelper.throwError(`The raw value divisor option 'rawValueDivisor' is invalid ; it should be a positive number higher than one, preferably an integer, [${options.rawValueDivisor}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.readOnly) && !AutoNumericHelper.isBoolean(options.readOnly)) {
      AutoNumericHelper.throwError(`The option 'readOnly' is invalid ; it should be either 'true' or 'false', [${options.readOnly}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.unformatOnHover) && !AutoNumericHelper.isBoolean(options.unformatOnHover)) {
      AutoNumericHelper.throwError(`The option 'unformatOnHover' is invalid ; it should be either 'true' or 'false', [${options.unformatOnHover}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.failOnUnknownOption) && !AutoNumericHelper.isBoolean(options.failOnUnknownOption)) {
      AutoNumericHelper.throwError(`The debug option 'failOnUnknownOption' is invalid ; it should be either 'true' or 'false', [${options.failOnUnknownOption}] given.`);
    }
    if (!AutoNumericHelper.isTrueOrFalseString(options.createLocalList) && !AutoNumericHelper.isBoolean(options.createLocalList)) {
      AutoNumericHelper.throwError(`The debug option 'createLocalList' is invalid ; it should be either 'true' or 'false', [${options.createLocalList}] given.`);
    }
  }
  /**
   * Check the `decimalPlaces*` options and output the relevant warnings if some of those will get overwritten during the initialization or settings update.
   *
   * @param {object} options
   * @private
   */
  static _validateDecimalPlacesRawValue(options) {
    if (!AutoNumericHelper.isNull(options.decimalPlacesRawValue)) {
      if (options.decimalPlacesRawValue < options.decimalPlaces) {
        AutoNumericHelper.warning(`The number of decimal places to store in the raw value [${options.decimalPlacesRawValue}] is lower than the ones to display [${options.decimalPlaces}]. This will likely confuse your users.
To solve that, you'd need to either set \`decimalPlacesRawValue\` to \`null\`, or set a number of decimal places for the raw value equal of bigger than \`decimalPlaces\`.`, options.showWarnings);
      }
      if (options.decimalPlacesRawValue < options.decimalPlacesShownOnFocus) {
        AutoNumericHelper.warning(`The number of decimal places to store in the raw value [${options.decimalPlacesRawValue}] is lower than the ones shown on focus [${options.decimalPlacesShownOnFocus}]. This will likely confuse your users.
To solve that, you'd need to either set \`decimalPlacesRawValue\` to \`null\`, or set a number of decimal places for the raw value equal of bigger than \`decimalPlacesShownOnFocus\`.`, options.showWarnings);
      }
      if (options.decimalPlacesRawValue < options.decimalPlacesShownOnBlur) {
        AutoNumericHelper.warning(`The number of decimal places to store in the raw value [${options.decimalPlacesRawValue}] is lower than the ones shown when unfocused [${options.decimalPlacesShownOnBlur}]. This will likely confuse your users.
To solve that, you'd need to either set \`decimalPlacesRawValue\` to \`null\`, or set a number of decimal places for the raw value equal of bigger than \`decimalPlacesShownOnBlur\`.`, options.showWarnings);
      }
    }
  }
  /**
   * Return `true` if the settings/options are valid, `false` otherwise.
   *
   * @param {object} options
   * @returns {boolean}
   */
  static areSettingsValid(options) {
    let isValid2 = true;
    try {
      this.validate(options, true);
    } catch (error2) {
      isValid2 = false;
    }
    return isValid2;
  }
  /**
   * Return the default autoNumeric settings.
   *
   * @returns {object}
   */
  static getDefaultConfig() {
    return _AutoNumeric.defaultSettings;
  }
  /**
   * Return all the predefined language options in one object.
   * You can also access a specific language object directly by using `AutoNumeric.getPredefinedOptions().French` for instance.
   *
   * @returns {object}
   */
  static getPredefinedOptions() {
    return _AutoNumeric.predefinedOptions;
  }
  /**
   * Analyse the given array `options` and return a single 'merged' option objet.
   * `options` can be `null`, or an array of an option objects, or an array containing another array of option objects / strings (pre-defined option names)
   *
   * @param {null|Array<object|string|Array<string|object>>} options
   * @returns {null|object}
   * @private
   */
  static _generateOptionsObjectFromOptionsArray(options) {
    let optionsResult;
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(options) || options.length === 0) {
      optionsResult = null;
    } else {
      optionsResult = {};
      if (options.length === 1 && Array.isArray(options[0])) {
        options[0].forEach((optionObject) => {
          Object.assign(optionsResult, this._getOptionObject(optionObject));
        });
      } else if (options.length >= 1) {
        options.forEach((optionObject) => {
          Object.assign(optionsResult, this._getOptionObject(optionObject));
        });
      }
    }
    return optionsResult;
  }
  /**
   * Format the given number (or numeric string) with the given options. This returns the formatted value as a string.
   * This can also format the given DOM element value with the given options and returns the formatted value as a string.
   * Note : This function does *not* update that element value with the newly formatted value.
   * This basically allows to get the formatted value without first having to initialize an AutoNumeric object.
   *
   * @param {number|string|HTMLElement|HTMLInputElement} numericStringOrDomElement A number, or a string that represent a javascript number, or a DOM element
   * @param {object|null} options Multiple objects can be passed, the latter overwriting the settings from the former ones
   * @returns {string|null}
   */
  static format(numericStringOrDomElement, ...options) {
    if (AutoNumericHelper.isUndefined(numericStringOrDomElement) || numericStringOrDomElement === null) {
      return null;
    }
    let value;
    if (AutoNumericHelper.isElement(numericStringOrDomElement)) {
      value = AutoNumericHelper.getElementValue(numericStringOrDomElement);
    } else {
      value = numericStringOrDomElement;
    }
    if (!AutoNumericHelper.isString(value) && !AutoNumericHelper.isNumber(value)) {
      AutoNumericHelper.throwError(`The value "${value}" being "set" is not numeric and therefore cannot be used appropriately.`);
    }
    const optionsToUse = this._generateOptionsObjectFromOptionsArray(options);
    const settings = Object.assign({}, this.getDefaultConfig(), optionsToUse);
    settings.isNegativeSignAllowed = value < 0;
    settings.isPositiveSignAllowed = value >= 0;
    this._setBrackets(settings);
    const regex2 = {};
    this._cachesUsualRegularExpressions(settings, regex2);
    let valueString = this._toNumericValue(value, settings);
    if (isNaN(Number(valueString))) {
      AutoNumericHelper.throwError(`The value [${valueString}] that you are trying to format is not a recognized number.`);
    }
    if (!this._isWithinRangeWithOverrideOption(valueString, settings)) {
      AutoNumericHelper.triggerEvent(_AutoNumeric.events.formatted, document, {
        oldValue: null,
        newValue: null,
        oldRawValue: null,
        newRawValue: null,
        isPristine: null,
        error: "Range test failed",
        aNElement: null
      }, true, true);
      AutoNumericHelper.throwError(`The value [${valueString}] being set falls outside of the minimumValue [${settings.minimumValue}] and maximumValue [${settings.maximumValue}] range set for this element`);
    }
    if (settings.valuesToStrings && this._checkValuesToStringsSettings(value, settings)) {
      return settings.valuesToStrings[value];
    }
    this._correctNegativePositiveSignPlacementOption(settings);
    this._calculateDecimalPlacesOnInit(settings);
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(settings.rawValueDivisor) && settings.rawValueDivisor !== 0 && // Only divide if the `rawValueDivisor` option is set
    valueString !== "" && valueString !== null) {
      valueString *= settings.rawValueDivisor;
    }
    valueString = this._roundFormattedValueShownOnFocus(valueString, settings);
    valueString = this._modifyNegativeSignAndDecimalCharacterForFormattedValue(valueString, settings);
    valueString = this._addGroupSeparators(valueString, settings, false, valueString);
    return valueString;
  }
  /**
   * Format the given DOM element value, and set the resulting value back as the element value.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @param {object} options
   * @returns {string|null}
   */
  static formatAndSet(domElement, options = null) {
    const formattedValue = this.format(domElement, options);
    AutoNumericHelper.setElementValue(domElement, formattedValue);
    return formattedValue;
  }
  /**
   * Unformat the given formatted string with the given options. This returns a numeric string.
   * It can also unformat the given DOM element value with the given options and returns the unformatted numeric string.
   * Note: This does *not* update that element value.
   * This basically allows to get the unformatted value without first having to initialize an AutoNumeric object.
   *
   * @param {string|number|HTMLElement|HTMLInputElement} numericStringOrDomElement A number, or a string that represent a javascript number, or a DOM element
   * @param {object|null} options Multiple objects can be passed, the latter overwriting the settings from the former ones
   * @returns {string|number|NaN}
   */
  static unformat(numericStringOrDomElement, ...options) {
    if (AutoNumericHelper.isNumberStrict(numericStringOrDomElement)) {
      return numericStringOrDomElement;
    }
    let value;
    if (AutoNumericHelper.isElement(numericStringOrDomElement)) {
      value = AutoNumericHelper.getElementValue(numericStringOrDomElement);
    } else {
      value = numericStringOrDomElement;
    }
    if (value === "") {
      return "";
    }
    if (AutoNumericHelper.isUndefined(value) || value === null) {
      return null;
    }
    if (AutoNumericHelper.isArray(value) || AutoNumericHelper.isObject(value)) {
      AutoNumericHelper.throwError(`A number or a string representing a number is needed to be able to unformat it, [${value}] given.`);
    }
    const optionsToUse = this._generateOptionsObjectFromOptionsArray(options);
    const settings = Object.assign({}, this.getDefaultConfig(), optionsToUse);
    settings.isNegativeSignAllowed = false;
    settings.isPositiveSignAllowed = true;
    value = value.toString();
    if (settings.valuesToStrings && this._checkStringsToValuesSettings(value, settings)) {
      return AutoNumericHelper.objectKeyLookup(settings.valuesToStrings, value);
    }
    if (AutoNumericHelper.isNegative(value, settings.negativeSignCharacter)) {
      settings.isNegativeSignAllowed = true;
      settings.isPositiveSignAllowed = false;
    } else if (!AutoNumericHelper.isNull(settings.negativeBracketsTypeOnBlur)) {
      [settings.firstBracket, settings.lastBracket] = settings.negativeBracketsTypeOnBlur.split(",");
      if (value.charAt(0) === settings.firstBracket && value.charAt(value.length - 1) === settings.lastBracket) {
        settings.isNegativeSignAllowed = true;
        settings.isPositiveSignAllowed = false;
        value = this._removeBrackets(value, settings, false);
      }
    }
    value = this._convertToNumericString(value, settings);
    if (AutoNumericHelper.isNumber(Number(value))) {
      value = AutoNumericHelper.scientificToDecimal(value);
    }
    const unwantedCharacters = new RegExp(`[^+-0123456789.]`, "gi");
    if (unwantedCharacters.test(value)) {
      return NaN;
    }
    this._correctNegativePositiveSignPlacementOption(settings);
    if (settings.decimalPlacesRawValue) {
      settings.originalDecimalPlacesRawValue = settings.decimalPlacesRawValue;
    } else {
      settings.originalDecimalPlacesRawValue = settings.decimalPlaces;
    }
    this._calculateDecimalPlacesOnInit(settings);
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(settings.rawValueDivisor) && settings.rawValueDivisor !== 0 && // Only divide if the `rawValueDivisor` option is set
    value !== "" && value !== null) {
      value /= settings.rawValueDivisor;
    }
    value = this._roundRawValue(value, settings);
    value = value.replace(settings.decimalCharacter, ".");
    value = this._toLocale(value, settings.outputFormat, settings);
    return value;
  }
  /**
   * Unformat the given DOM element value, and set the resulting value back as the element value.
   *
   * @param {HTMLElement|HTMLInputElement} domElement
   * @param {object} options
   * @returns {*}
   */
  static unformatAndSet(domElement, options = null) {
    const unformattedValue = this.unformat(domElement, options);
    AutoNumericHelper.setElementValue(domElement, unformattedValue);
    return unformattedValue;
  }
  /**
   * Unformat and localize the given formatted string with the given options. This returns a numeric string.
   * It can also unformat and localize the given DOM element value with the given options and returns the unformatted numeric string.
   * Note: This does *not* update that element value.
   * This basically allows to get the localized value without first having to initialize an AutoNumeric object.
   *
   * @param {string|number|HTMLElement|HTMLInputElement} numericStringOrDomElement
   * @param {object} settings
   * @returns {*}
   */
  static localize(numericStringOrDomElement, settings = null) {
    let value;
    if (AutoNumericHelper.isElement(numericStringOrDomElement)) {
      value = AutoNumericHelper.getElementValue(numericStringOrDomElement);
    } else {
      value = numericStringOrDomElement;
    }
    if (value === "") {
      return "";
    }
    if (AutoNumericHelper.isNull(settings)) {
      settings = _AutoNumeric.defaultSettings;
    }
    value = this.unformat(value, settings);
    if (Number(value) === 0 && settings.leadingZero !== _AutoNumeric.options.leadingZero.keep) {
      value = "0";
    }
    let outputFormatToUse;
    if (AutoNumericHelper.isNull(settings)) {
      outputFormatToUse = settings.outputFormat;
    } else {
      outputFormatToUse = _AutoNumeric.defaultSettings.outputFormat;
    }
    return this._toLocale(value, outputFormatToUse, settings);
  }
  static localizeAndSet(domElement, options = null) {
    const localizedValue = this.localize(domElement, options);
    AutoNumericHelper.setElementValue(domElement, localizedValue);
    return localizedValue;
  }
  /**
   * Return `true` if the given DOM element has an AutoNumeric object that manages it.
   * This function also accepts a selector string.
   *
   * @param {HTMLElement|string} domElementOrSelector Accepts either directly a DOM element to test, or a string selector (that will return one and only one element, if any)
   * @returns {boolean}
   */
  static isManagedByAutoNumeric(domElementOrSelector) {
    return this._isInGlobalList(AutoNumericHelper.domElement(domElementOrSelector));
  }
  /**
   * Return the AutoNumeric object that manages the given DOM element.
   * This function also accepts a selector string.
   *
   * @param {HTMLElement|string} domElementOrSelector Accepts either directly a DOM element to test, or a string selector (that will return one and only one element, if any)
   * @returns {null|AutoNumeric}
   */
  static getAutoNumericElement(domElementOrSelector) {
    const domElement = AutoNumericHelper.domElement(domElementOrSelector);
    if (!this.isManagedByAutoNumeric(domElement)) {
      return null;
    }
    return this._getFromGlobalList(domElement);
  }
  /**
   * Set the given element value, and format it immediately.
   * Return `null` if no AutoNumeric object is found, else, return the AutoNumeric object.
   *
   * @param {HTMLElement|string} domElementOrSelector Either a DOM element reference, or a selector string can be used
   * @param {number|string|null} newValue The value must be a Number, a numeric string or `null` (if `emptyInputBehavior` is set to `'null'`)
   * @param {object} options A settings object that will override the current settings. Note: the update is done only if the `newValue` is defined.
   * @param {boolean} saveChangeToHistory If set to `true`, then the change is recorded in the history table
   * @returns {AutoNumeric|null}
   */
  static set(domElementOrSelector, newValue, options = null, saveChangeToHistory = true) {
    const domElement = AutoNumericHelper.domElement(domElementOrSelector);
    if (!this.isManagedByAutoNumeric(domElement)) {
      let showWarnings;
      if (!AutoNumericHelper.isNull(options) && Object.prototype.hasOwnProperty.call(options, "showWarnings")) {
        showWarnings = options.showWarnings;
      } else {
        showWarnings = true;
      }
      AutoNumericHelper.warning(`Impossible to find an AutoNumeric object for the given DOM element or selector.`, showWarnings);
      return null;
    }
    return this.getAutoNumericElement(domElement).set(newValue, options, saveChangeToHistory);
  }
  /**
   * Return the unformatted value as a string from the given DOM element or query selector.
   * This can also return `null` if `rawValue` is null.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {function|null} callback
   * @returns {string|null}
   */
  static getNumericString(domElementOrSelector, callback = null) {
    return this._get(domElementOrSelector, "getNumericString", callback);
  }
  /**
   * Return the current formatted value of the AutoNumeric element as a string, from the given DOM element or query selector.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {function|null} callback
   * @returns {string}
   */
  static getFormatted(domElementOrSelector, callback = null) {
    return this._get(domElementOrSelector, "getFormatted", callback);
  }
  /**
   * Return the element unformatted value as a real Javascript number, from the given DOM element or query selector.
   * Warning: This can lead to precision problems with big numbers that should be stored as strings.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {function|null} callback
   * @returns {number|null}
   */
  static getNumber(domElementOrSelector, callback = null) {
    return this._get(domElementOrSelector, "getNumber", callback);
  }
  /**
   * DRY the code between the static `get*` functions
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {string} getFunction The name of the non-static `get*` function as a string
   * @param {function|null} callback
   * @returns {*}
   * @private
   */
  static _get(domElementOrSelector, getFunction, callback = null) {
    const domElement = AutoNumericHelper.domElement(domElementOrSelector);
    if (!this.isManagedByAutoNumeric(domElement)) {
      AutoNumericHelper.throwError(`Impossible to find an AutoNumeric object for the given DOM element or selector.`);
    }
    return this.getAutoNumericElement(domElement)[getFunction](callback);
  }
  /**
   * Returns the unformatted value following the `outputFormat` setting, from the given DOM element or query selector.
   * See the non-static `getLocalized()` method documentation for more details.
   *
   * @param {HTMLElement|string} domElementOrSelector
   * @param {null|string|function} forcedOutputFormat
   * @param {function|null} callback
   * @returns {*}
   */
  static getLocalized(domElementOrSelector, forcedOutputFormat = null, callback = null) {
    const domElement = AutoNumericHelper.domElement(domElementOrSelector);
    if (!this.isManagedByAutoNumeric(domElement)) {
      AutoNumericHelper.throwError(`Impossible to find an AutoNumeric object for the given DOM element or selector.`);
    }
    return this.getAutoNumericElement(domElement).getLocalized(forcedOutputFormat, callback);
  }
  // Pre-defined options can be called to update the current default options with their specificities
  //XXX A better way would be to not initialize first, but that's not possible since `new` is called first and we do not pass the language options (i.e. `French`) to the constructor
  /**
   * Update the AutoNumeric object with the predefined options, and possibly some option overrides.
   *
   * @param {object} predefinedOption
   * @param {object} optionOverride
   * @private
   * @returns {AutoNumeric}
   */
  _updatePredefinedOptions(predefinedOption, optionOverride = null) {
    if (!AutoNumericHelper.isNull(optionOverride)) {
      this._mergeSettings(predefinedOption, optionOverride);
      this.update(this.settings);
    } else {
      this.update(predefinedOption);
    }
    return this;
  }
  /**
   * Update the settings to use the French pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  french(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().French, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the North American pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  northAmerican(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().NorthAmerican, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the British pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  british(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().British, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the Swiss pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  swiss(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().Swiss, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the Japanese pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  japanese(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().Japanese, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the Spanish pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  spanish(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().Spanish, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the Chinese pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  chinese(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().Chinese, optionOverride);
    return this;
  }
  /**
   * Update the settings to use the Brazilian pre-defined language options.
   * Those pre-defined options can be overridden by passing an option object as a parameter.
   *
   * @param {object} optionOverride
   * @returns {AutoNumeric}
   */
  brazilian(optionOverride = null) {
    this._updatePredefinedOptions(_AutoNumeric.getPredefinedOptions().Brazilian, optionOverride);
    return this;
  }
  // Internal private functions
  /**
   * Run any callbacks found in the settings object in order to set the settings value back.
   * Any parameter can have a callback defined.
   * The callback takes the current AutoNumeric element as the first argument, and the key name as the second.
   * @example callback(this, 'currencySymbol')
   */
  _runCallbacksFoundInTheSettingsObject() {
    for (const key2 in this.settings) {
      if (Object.prototype.hasOwnProperty.call(this.settings, key2)) {
        const value = this.settings[key2];
        if (typeof value === "function") {
          this.settings[key2] = value(this, key2);
        } else {
          let htmlAttribute = "";
          if (key2 in this.domElement.dataset) {
            htmlAttribute = this.domElement.dataset[key2];
          }
          htmlAttribute = AutoNumericHelper.camelize(htmlAttribute);
          if (typeof this.settings[htmlAttribute] === "function") {
            this.settings[key2] = htmlAttribute(this, key2);
          }
        }
      }
    }
  }
  /**
   * Keep track if the settings configuration leads to a trailing negative sign (only when the raw value is negative), so we do not have to test the settings values every time we need to know that.
   * `isTrailingNegative` is set to `true` if the settings result in a trailing negative character, `false` otherwise.
   * Note: This returns `true` even if the raw value is positive.
   * @private
   */
  _setTrailingNegativeSignInfo() {
    this.isTrailingNegative = this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.suffix || this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix && (this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.left || this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.right);
  }
  /**
   * Strip all the unwanted non-number characters.
   * However, it does not reorder the localized negative sign.
   *
   * @param {string} s
   * @param {object} settings
   * @param {boolean} stripZeros If set to `false`, then the leading zero(s) are not stripped, otherwise if set to `true`, the `leadingZero` option is followed
   * @param {boolean} isFocused If the element is focused, then this is `true`
   * @returns {string}
   * @private
   */
  static _stripAllNonNumberCharacters(s4, settings, stripZeros, isFocused) {
    return this._stripAllNonNumberCharactersExceptCustomDecimalChar(s4, settings, stripZeros, isFocused).replace(settings.decimalCharacter, ".");
  }
  /**
   * Strip all unwanted non-number characters except the custom decimal character.
   *
   * It converts the custom negative sign and removes the positive sign (custom or not).
   * This keeps :
   * - the numbers,
   * - the normal negative sign '-' if any,
   * - and the *custom* decimal character.
   *
   * @param {string} s
   * @param {object} settings
   * @param {boolean} stripZeros If set to `false`, then the leading zero(s) are not stripped, otherwise if set to `true`, the `leadingZero` option is followed
   * @param {boolean} isFocused If the element is focused, then this is `true`
   * @returns {string|*}
   */
  static _stripAllNonNumberCharactersExceptCustomDecimalChar(s4, settings, stripZeros, isFocused) {
    s4 = this._normalizeCurrencySuffixAndNegativeSignCharacters(s4, settings);
    s4 = s4.replace(settings.allowedAutoStrip, "");
    const m4 = s4.match(settings.numRegAutoStrip);
    s4 = m4 ? [m4[1], m4[2], m4[3]].join("") : "";
    if (settings.leadingZero === _AutoNumeric.options.leadingZero.allow || settings.leadingZero === _AutoNumeric.options.leadingZero.keep) {
      let negativeSign = "";
      const [integerPart, decimalPart] = s4.split(settings.decimalCharacter);
      let modifiedIntegerPart = integerPart;
      if (AutoNumericHelper.contains(modifiedIntegerPart, settings.negativeSignCharacter)) {
        negativeSign = settings.negativeSignCharacter;
        modifiedIntegerPart = modifiedIntegerPart.replace(settings.negativeSignCharacter, "");
      }
      if (negativeSign === "" && modifiedIntegerPart.length > settings.mIntPos && modifiedIntegerPart.charAt(0) === "0") {
        modifiedIntegerPart = modifiedIntegerPart.slice(1);
      }
      if (negativeSign !== "" && modifiedIntegerPart.length > settings.mIntNeg && modifiedIntegerPart.charAt(0) === "0") {
        modifiedIntegerPart = modifiedIntegerPart.slice(1);
      }
      s4 = `${negativeSign}${modifiedIntegerPart}${AutoNumericHelper.isUndefined(decimalPart) ? "" : settings.decimalCharacter + decimalPart}`;
    }
    if (stripZeros && settings.leadingZero === _AutoNumeric.options.leadingZero.deny || !isFocused && settings.leadingZero === _AutoNumeric.options.leadingZero.allow) {
      s4 = s4.replace(settings.stripReg, "$1$2");
    }
    return s4;
  }
  /**
   * Sets or removes brackets on negative values, depending on the focus state, which is passed as `isFocused`.
   * The focus state is 'stored' in that object property.
   *
   * @param {string} value
   * @param {object} settings
   * @param {boolean} isFocused
   * @returns {*}
   */
  static _toggleNegativeBracket(value, settings, isFocused) {
    let result2;
    if (isFocused) {
      result2 = this._removeBrackets(value, settings);
    } else {
      result2 = this._addBrackets(value, settings);
    }
    return result2;
  }
  /**
   * Add the bracket types specified in the `settings` object, to the given string `value`.
   *
   * @param {string} value
   * @param {object} settings
   * @returns {string}
   * @private
   */
  static _addBrackets(value, settings) {
    if (AutoNumericHelper.isNull(settings.negativeBracketsTypeOnBlur)) {
      return value;
    }
    return `${settings.firstBracket}${value.replace(settings.negativeSignCharacter, "")}${settings.lastBracket}`;
  }
  /**
   * Remove the bracket types specified in the `settings` object, from the given string `value`.
   *
   * @param {string} value
   * @param {object} settings
   * @param {boolean} rearrangeSignsAndValueOrder If set to `true`, then only the brackets are remove and a negative sign is added, without reordering the negative sign, currency symbol and value according to the settings.
   * @returns {string}
   * @private
   */
  static _removeBrackets(value, settings, rearrangeSignsAndValueOrder = true) {
    let result2;
    if (!AutoNumericHelper.isNull(settings.negativeBracketsTypeOnBlur) && value.charAt(0) === settings.firstBracket) {
      result2 = value.replace(settings.firstBracket, "");
      result2 = result2.replace(settings.lastBracket, "");
      if (rearrangeSignsAndValueOrder) {
        result2 = result2.replace(settings.currencySymbol, "");
        result2 = this._mergeCurrencySignNegativePositiveSignAndValue(result2, settings, true, false);
      } else {
        result2 = `${settings.negativeSignCharacter}${result2}`;
      }
    } else {
      result2 = value;
    }
    return result2;
  }
  /**
   * Analyze the `negativeBracketsTypeOnBlur` options and keep track of the first and last bracket characters to use.
   *
   * @param {object} settings
   * @private
   */
  static _setBrackets(settings) {
    if (AutoNumericHelper.isNull(settings.negativeBracketsTypeOnBlur)) {
      settings.firstBracket = "";
      settings.lastBracket = "";
    } else {
      const [firstBracket, lastBracket] = settings.negativeBracketsTypeOnBlur.split(",");
      settings.firstBracket = firstBracket;
      settings.lastBracket = lastBracket;
    }
  }
  /**
   * Return a number as a numeric string that can be typecast to a Number that Javascript will understand.
   *
   * This function returns the given string by stripping:
   * - the currency sign (currencySymbol),
   * - the grouping separators (digitalGroupSpacing),
   * - the suffix text (suffixText),
   * - the positive sign (positiveSignCharacter),
   * - the brackets if any,
   * - by replacing the negative sign character with a hyphen,
   * - and by replacing the decimal character (decimalCharacter) by a dot.
   *
   * Lastly, it also put the negative sign back to its normal position if needed.
   * Bonus; it converts any arabic numbers found to the latin ones.
   *
   * @param {string} s
   * @param {object} settings
   * @returns {string|void|*}
   */
  static _convertToNumericString(s4, settings) {
    s4 = this._removeBrackets(s4, settings, false);
    s4 = this._normalizeCurrencySuffixAndNegativeSignCharacters(s4, settings);
    s4 = s4.replace(new RegExp(`[${settings.digitGroupSeparator}]`, "g"), "");
    if (settings.decimalCharacter !== ".") {
      s4 = s4.replace(settings.decimalCharacter, ".");
    }
    if (AutoNumericHelper.isNegative(s4) && s4.lastIndexOf("-") === s4.length - 1) {
      s4 = s4.replace("-", "");
      s4 = `-${s4}`;
    }
    if (settings.showPositiveSign) {
      s4 = s4.replace(settings.positiveSignCharacter, "");
    }
    const convertToNumber = settings.leadingZero !== _AutoNumeric.options.leadingZero.keep;
    const temp = AutoNumericHelper.arabicToLatinNumbers(s4, convertToNumber, false, false);
    if (!isNaN(temp)) {
      s4 = temp.toString();
    }
    return s4;
  }
  /**
   * Removes the currency symbol and the suffix text from the given string, and replace the custom negative sign with a hyphen.
   *
   * @param {string} s
   * @param {object} settings
   * @returns {string | *}
   * @private
   */
  static _normalizeCurrencySuffixAndNegativeSignCharacters(s4, settings) {
    s4 = String(s4);
    if (settings.currencySymbol !== _AutoNumeric.options.currencySymbol.none) {
      s4 = s4.replace(settings.currencySymbol, "");
    }
    if (settings.suffixText !== _AutoNumeric.options.suffixText.none) {
      s4 = s4.replace(settings.suffixText, "");
    }
    if (settings.negativeSignCharacter !== _AutoNumeric.options.negativeSignCharacter.hyphen) {
      s4 = s4.replace(settings.negativeSignCharacter, "-");
    }
    return s4;
  }
  /**
   * Converts the ISO numeric string to the locale decimal and minus sign placement.
   * See the "outputFormat" option definition for more details.
   * Note: If the `outputFormat` is set to a number, the custom `negativeSignCharacter` is ignored.
   *
   * @param {string|null} value The unformatted value
   * @param {string|null} locale
   * @param {object} settings
   * @returns {*}
   */
  static _toLocale(value, locale2, settings) {
    if (AutoNumericHelper.isNull(locale2) || locale2 === _AutoNumeric.options.outputFormat.string) {
      return value;
    }
    let result2;
    switch (locale2) {
      case _AutoNumeric.options.outputFormat.number:
        result2 = Number(value);
        break;
      case _AutoNumeric.options.outputFormat.dotNegative:
        result2 = AutoNumericHelper.isNegative(value) ? value.replace("-", "") + "-" : value;
        break;
      case _AutoNumeric.options.outputFormat.comma:
      case _AutoNumeric.options.outputFormat.negativeComma:
        result2 = value.replace(".", ",");
        break;
      case _AutoNumeric.options.outputFormat.commaNegative:
        result2 = value.replace(".", ",");
        result2 = AutoNumericHelper.isNegative(result2) ? result2.replace("-", "") + "-" : result2;
        break;
      case _AutoNumeric.options.outputFormat.dot:
      case _AutoNumeric.options.outputFormat.negativeDot:
        result2 = value;
        break;
      default:
        AutoNumericHelper.throwError(`The given outputFormat [${locale2}] option is not recognized.`);
    }
    if (locale2 !== _AutoNumeric.options.outputFormat.number && settings.negativeSignCharacter !== "-") {
      result2 = result2.replace("-", settings.negativeSignCharacter);
    }
    return result2;
  }
  /**
   * Modify the negative sign and the decimal character of the given string value to a hyphen (-) and a dot (.) in order to make that value 'typecastable' to a real number.
   *
   * @param {string} s The formatted value
   * @returns {string} The value with the 'normal' minus sign and decimal character
   */
  _modifyNegativeSignAndDecimalCharacterForRawValue(s4) {
    if (this.settings.decimalCharacter !== ".") {
      s4 = s4.replace(this.settings.decimalCharacter, ".");
    }
    if (this.settings.negativeSignCharacter !== "-" && this.settings.isNegativeSignAllowed) {
      s4 = s4.replace(this.settings.negativeSignCharacter, "-");
    }
    if (!s4.match(/\d/)) {
      s4 += "0";
    }
    return s4;
  }
  /**
   * Modify the negative sign and the decimal character to use those defined in the settings.
   *
   * @param {string} s
   * @param {object} settings
   * @returns {string}
   */
  static _modifyNegativeSignAndDecimalCharacterForFormattedValue(s4, settings) {
    if (settings.negativeSignCharacter !== "-") {
      s4 = s4.replace("-", settings.negativeSignCharacter);
    }
    if (settings.decimalCharacter !== ".") {
      s4 = s4.replace(".", settings.decimalCharacter);
    }
    return s4;
  }
  /**
   * Return `true` if the given value is empty or is equal to the negative sign character defined in the given settings.
   *
   * @param {string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _isElementValueEmptyOrOnlyTheNegativeSign(value, settings) {
    return value === "" || value === settings.negativeSignCharacter;
  }
  /**
   * Return the value with the currency symbol and the suffix text ordered according to the given settings.
   *
   * @param {string} value
   * @param {object} settings
   * @param {boolean} signOnEmpty
   * @returns {*}
   * @private
   */
  static _orderValueCurrencySymbolAndSuffixText(value, settings, signOnEmpty) {
    let result2;
    if (settings.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.always || signOnEmpty) {
      switch (settings.negativePositiveSignPlacement) {
        case _AutoNumeric.options.negativePositiveSignPlacement.left:
        case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
        case _AutoNumeric.options.negativePositiveSignPlacement.none:
          result2 = value + settings.currencySymbol + settings.suffixText;
          break;
        default:
          result2 = settings.currencySymbol + value + settings.suffixText;
      }
    } else {
      result2 = value;
    }
    return result2;
  }
  /**
   * Modify the input value by adding the group separators, as defined in the settings, and the negative brackets if needed.
   *
   * @param {string} inputValue The formatted value (i.e. with the `decimalCharacter` defined in the settings, not the raw value)
   * @param {object} settings
   * @param {boolean} isFocused
   * @param {number|string|null} currentRawValue The object current raw value (`this.rawValue`)
   * @param {number|string|null} forcedRawValue If this is set, then this rawValue is used instead of the one passed through the `settings` object. This is useful is some very specific cases where we need to set the raw value *after* settings the formatted value, using the `_addGroupSeparators()` method.
   * @returns {*}
   */
  static _addGroupSeparators(inputValue, settings, isFocused, currentRawValue, forcedRawValue = null) {
    let isValueNegative;
    if (!AutoNumericHelper.isNull(forcedRawValue)) {
      isValueNegative = forcedRawValue < 0;
    } else {
      isValueNegative = AutoNumericHelper.isNegative(inputValue, settings.negativeSignCharacter) || AutoNumericHelper.isNegativeWithBrackets(inputValue, settings.firstBracket, settings.lastBracket);
    }
    inputValue = this._stripAllNonNumberCharactersExceptCustomDecimalChar(inputValue, settings, false, isFocused);
    if (this._isElementValueEmptyOrOnlyTheNegativeSign(inputValue, settings)) {
      return this._orderValueCurrencySymbolAndSuffixText(inputValue, settings, true);
    }
    const isZeroOrHasNoValue = AutoNumericHelper.isZeroOrHasNoValue(inputValue);
    if (isValueNegative) {
      inputValue = inputValue.replace("-", "");
    }
    let [integerPart, decimalPart] = inputValue.split(settings.decimalCharacter);
    if (settings.decimalCharacterAlternative && AutoNumericHelper.isUndefined(decimalPart)) {
      [integerPart, decimalPart] = inputValue.split(settings.decimalCharacterAlternative);
    }
    if (settings.digitGroupSeparator !== "") {
      settings.digitalGroupSpacing = settings.digitalGroupSpacing.toString();
      let digitalGroup;
      switch (settings.digitalGroupSpacing) {
        case _AutoNumeric.options.digitalGroupSpacing.twoThree:
          digitalGroup = /(\d)((\d)(\d{2}?)+)$/;
          break;
        case _AutoNumeric.options.digitalGroupSpacing.twoScaled:
          digitalGroup = /(\d)((?:\d{2}){0,2}\d{3}(?:(?:\d{2}){2}\d{3})*?)$/;
          break;
        case _AutoNumeric.options.digitalGroupSpacing.two:
        case _AutoNumeric.options.digitalGroupSpacing.three:
        case _AutoNumeric.options.digitalGroupSpacing.four:
        default:
          digitalGroup = new RegExp(`(\\d)((\\d{${settings.digitalGroupSpacing}}?)+)$`);
      }
      while (digitalGroup.test(integerPart)) {
        integerPart = integerPart.replace(digitalGroup, `$1${settings.digitGroupSeparator}$2`);
      }
    }
    let decimalPlacesToRoundTo;
    if (isFocused) {
      decimalPlacesToRoundTo = settings.decimalPlacesShownOnFocus;
    } else {
      decimalPlacesToRoundTo = settings.decimalPlacesShownOnBlur;
    }
    if (decimalPlacesToRoundTo !== 0 && !AutoNumericHelper.isUndefined(decimalPart)) {
      if (decimalPart.length > decimalPlacesToRoundTo) {
        decimalPart = decimalPart.substring(0, decimalPlacesToRoundTo);
      }
      inputValue = `${integerPart}${settings.decimalCharacter}${decimalPart}`;
    } else {
      inputValue = integerPart;
    }
    inputValue = _AutoNumeric._mergeCurrencySignNegativePositiveSignAndValue(inputValue, settings, isValueNegative, isZeroOrHasNoValue);
    if (AutoNumericHelper.isNull(forcedRawValue)) {
      forcedRawValue = currentRawValue;
    }
    if (settings.negativeBracketsTypeOnBlur !== null && (forcedRawValue < 0 || AutoNumericHelper.isNegativeStrict(inputValue, settings.negativeSignCharacter))) {
      inputValue = this._toggleNegativeBracket(inputValue, settings, isFocused);
    }
    let result2;
    if (settings.suffixText) {
      result2 = `${inputValue}${settings.suffixText}`;
    } else {
      result2 = inputValue;
    }
    return result2;
  }
  /**
   * Return a semi-formatted string where the input value, the negative or positive sign, and the currency symbol are stitched together at the right positions, using the options set in the `settings` object.
   * Note : the `inputValue` is usually not a numeric string since the grouping symbols are already added to it at this point.
   *
   * @param {string} inputValue
   * @param {object} settings
   * @param {boolean} isValueNegative
   * @param {boolean} isZeroOrHasNoValue
   * @returns {*}
   * @throws
   * @private
   */
  static _mergeCurrencySignNegativePositiveSignAndValue(inputValue, settings, isValueNegative, isZeroOrHasNoValue) {
    let signToUse = "";
    if (isValueNegative) {
      signToUse = settings.negativeSignCharacter;
    } else if (settings.showPositiveSign && !isZeroOrHasNoValue) {
      signToUse = settings.positiveSignCharacter;
    }
    let result2;
    if (settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix) {
      if (settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && settings.showPositiveSign && !isZeroOrHasNoValue)) {
        switch (settings.negativePositiveSignPlacement) {
          case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
          case _AutoNumeric.options.negativePositiveSignPlacement.left:
            result2 = `${signToUse}${settings.currencySymbol}${inputValue}`;
            break;
          case _AutoNumeric.options.negativePositiveSignPlacement.right:
            result2 = `${settings.currencySymbol}${signToUse}${inputValue}`;
            break;
          case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
            result2 = `${settings.currencySymbol}${inputValue}${signToUse}`;
            break;
        }
      } else {
        result2 = settings.currencySymbol + inputValue;
      }
    } else if (settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
      if (settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && settings.showPositiveSign && !isZeroOrHasNoValue)) {
        switch (settings.negativePositiveSignPlacement) {
          case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
          case _AutoNumeric.options.negativePositiveSignPlacement.right:
            result2 = `${inputValue}${settings.currencySymbol}${signToUse}`;
            break;
          case _AutoNumeric.options.negativePositiveSignPlacement.left:
            result2 = `${inputValue}${signToUse}${settings.currencySymbol}`;
            break;
          case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
            result2 = `${signToUse}${inputValue}${settings.currencySymbol}`;
            break;
        }
      } else {
        result2 = inputValue + settings.currencySymbol;
      }
    }
    return result2;
  }
  /**
   * Calculate where to put the caret position on focus if the element content is not selected.
   * This calculation is affected by the `caretPositionOnFocus` option which can be either `null`, `'start'`, `'end'`, `'decimalLeft'` or 'decimalRight'`, and will decide where to put the caret (on the left or right of the value or the decimal character, respectively) :
   * - `null` : the caret position is not forced
   * - `'start'` : the caret is positioned on the left hand side of the value
   * - `'end'` : the caret is positioned on the right hand side of the value
   * - `'decimalLeft'` : the caret is positioned on the left side of the decimal character
   * - `'decimalRight'` : the caret is positioned on the right side of the decimal character
   *
   * @param {string} value The formatted string stripped of the currency symbol and negative/positive sign
   * @returns {number}
   * @throws
   * @private
   */
  _initialCaretPosition(value) {
    if (AutoNumericHelper.isNull(this.settings.caretPositionOnFocus) && this.settings.selectOnFocus === _AutoNumeric.options.selectOnFocus.doNotSelect) {
      AutoNumericHelper.throwError("`_initialCaretPosition()` should never be called when the `caretPositionOnFocus` option is `null`.");
    }
    const isValueNegative = this.rawValue < 0;
    const isZeroOrHasNoValue = AutoNumericHelper.isZeroOrHasNoValue(value);
    const totalLength = value.length;
    let valueSize = 0;
    let integerSize = 0;
    let hasDecimalChar = false;
    let offsetDecimalChar = 0;
    if (this.settings.caretPositionOnFocus !== _AutoNumeric.options.caretPositionOnFocus.start) {
      value = value.replace(this.settings.negativeSignCharacter, "");
      value = value.replace(this.settings.positiveSignCharacter, "");
      value = value.replace(this.settings.currencySymbol, "");
      valueSize = value.length;
      hasDecimalChar = AutoNumericHelper.contains(value, this.settings.decimalCharacter);
      if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.decimalLeft || this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.decimalRight) {
        if (hasDecimalChar) {
          integerSize = value.indexOf(this.settings.decimalCharacter);
          offsetDecimalChar = this.settings.decimalCharacter.length;
        } else {
          integerSize = valueSize;
          offsetDecimalChar = 0;
        }
      }
    }
    let signToUse = "";
    if (isValueNegative) {
      signToUse = this.settings.negativeSignCharacter;
    } else if (this.settings.showPositiveSign && !isZeroOrHasNoValue) {
      signToUse = this.settings.positiveSignCharacter;
    }
    const positiveNegativeSignSize = signToUse.length;
    const currencySymbolSize = this.settings.currencySymbol.length;
    let caretPosition;
    if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix) {
      if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.start) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
              caretPosition = positiveNegativeSignSize + currencySymbolSize;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
              caretPosition = currencySymbolSize;
              break;
          }
        } else {
          caretPosition = currencySymbolSize;
        }
      } else if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.end) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
              caretPosition = totalLength;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
              caretPosition = currencySymbolSize + valueSize;
              break;
          }
        } else {
          caretPosition = totalLength;
        }
      } else if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.decimalLeft) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
              caretPosition = positiveNegativeSignSize + currencySymbolSize + integerSize;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
              caretPosition = currencySymbolSize + integerSize;
              break;
          }
        } else {
          caretPosition = currencySymbolSize + integerSize;
        }
      } else if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.decimalRight) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
              caretPosition = positiveNegativeSignSize + currencySymbolSize + integerSize + offsetDecimalChar;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
              caretPosition = currencySymbolSize + integerSize + offsetDecimalChar;
              break;
          }
        } else {
          caretPosition = currencySymbolSize + integerSize + offsetDecimalChar;
        }
      }
    } else if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
      if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.start) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
              caretPosition = 0;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
              caretPosition = positiveNegativeSignSize;
              break;
          }
        } else {
          caretPosition = 0;
        }
      } else if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.end) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
              caretPosition = valueSize;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
              caretPosition = positiveNegativeSignSize + valueSize;
              break;
          }
        } else {
          caretPosition = valueSize;
        }
      } else if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.decimalLeft) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
              caretPosition = integerSize;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
              caretPosition = positiveNegativeSignSize + integerSize;
              break;
          }
        } else {
          caretPosition = integerSize;
        }
      } else if (this.settings.caretPositionOnFocus === _AutoNumeric.options.caretPositionOnFocus.decimalRight) {
        if (this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.none && (isValueNegative || !isValueNegative && this.settings.showPositiveSign && !isZeroOrHasNoValue)) {
          switch (this.settings.negativePositiveSignPlacement) {
            case _AutoNumeric.options.negativePositiveSignPlacement.suffix:
            case _AutoNumeric.options.negativePositiveSignPlacement.right:
            case _AutoNumeric.options.negativePositiveSignPlacement.left:
              caretPosition = integerSize + offsetDecimalChar;
              break;
            case _AutoNumeric.options.negativePositiveSignPlacement.prefix:
              caretPosition = positiveNegativeSignSize + integerSize + offsetDecimalChar;
              break;
          }
        } else {
          caretPosition = integerSize + offsetDecimalChar;
        }
      }
    }
    return caretPosition;
  }
  /**
   * Truncate the trailing zeroes to the given number of decimal places
   *
   * @param {string} roundedInputValue
   * @param {int} decimalPlacesNeeded The number of decimal places to keep
   * @returns {string}
   */
  static _truncateZeros(roundedInputValue, decimalPlacesNeeded) {
    let regex2;
    switch (decimalPlacesNeeded) {
      case 0:
        regex2 = /(\.(?:\d*[1-9])?)0*$/;
        break;
      case 1:
        regex2 = /(\.\d(?:\d*[1-9])?)0*$/;
        break;
      default:
        regex2 = new RegExp(`(\\.\\d{${decimalPlacesNeeded}}(?:\\d*[1-9])?)0*`);
    }
    roundedInputValue = roundedInputValue.replace(regex2, "$1");
    if (decimalPlacesNeeded === 0) {
      roundedInputValue = roundedInputValue.replace(/\.$/, "");
    }
    return roundedInputValue;
  }
  /**
   * Round the given `value` with the number of decimal places to keep for the raw value.
   *
   * @param {string|null} value An unformatted numeric value
   * @param {object} settings
   * @returns {*}
   * @private
   */
  static _roundRawValue(value, settings) {
    return this._roundValue(value, settings, settings.decimalPlacesRawValue);
  }
  /**
   * Round the given `value` with the number of decimal places to show for the element if focused.
   *
   * @param {string|null} value An unformatted numeric value
   * @param {object} settings
   * @returns {*}
   * @private
   */
  static _roundFormattedValueShownOnFocus(value, settings) {
    return this._roundValue(value, settings, Number(settings.decimalPlacesShownOnFocus));
  }
  /**
   * Round the given `value` with the number of decimal places to show for the element if unfocused.
   *
   * @param {string|null} value An unformatted numeric value
   * @param {object} settings
   * @returns {*}
   * @private
   */
  static _roundFormattedValueShownOnBlur(value, settings) {
    return this._roundValue(value, settings, Number(settings.decimalPlacesShownOnBlur));
  }
  /**
   * Round the given `value` with the number of decimal places to show for the element based on the value of isFocused.
   *
   * @param {string|null} value An unformatted numeric value
   * @param {object} settings
   * @param {boolean} isFocused
   * @returns {*}
   * @private
   */
  static _roundFormattedValueShownOnFocusOrBlur(value, settings, isFocused) {
    if (isFocused) {
      return this._roundFormattedValueShownOnFocus(value, settings);
    } else {
      return this._roundFormattedValueShownOnBlur(value, settings);
    }
  }
  /**
   * Round the input value using the rounding method defined in the settings.
   * This function accepts multiple rounding methods. See the documentation for more details about those.
   *
   * Note : This is handled as text since JavaScript math functions can return inaccurate values.
   *
   * @param {string|null} inputValue An unformatted numeric value
   * @param {object} settings
   * @param {int} decimalPlacesToRoundTo
   * @returns {*}
   */
  static _roundValue(inputValue, settings, decimalPlacesToRoundTo) {
    if (AutoNumericHelper.isNull(inputValue)) {
      return inputValue;
    }
    inputValue = inputValue === "" ? "0" : inputValue.toString();
    if (settings.roundingMethod === _AutoNumeric.options.roundingMethod.toNearest05 || settings.roundingMethod === _AutoNumeric.options.roundingMethod.toNearest05Alt || settings.roundingMethod === _AutoNumeric.options.roundingMethod.upToNext05 || settings.roundingMethod === _AutoNumeric.options.roundingMethod.downToNext05) {
      return this._roundCloseTo05(inputValue, settings);
    }
    const [negativeSign, preparedValue] = _AutoNumeric._prepareValueForRounding(inputValue, settings);
    inputValue = preparedValue;
    const decimalCharacterPosition = inputValue.lastIndexOf(".");
    const inputValueHasNoDot = decimalCharacterPosition === -1;
    const [integerPart, decimalPart] = inputValue.split(".");
    const hasDecimals = decimalPart > 0;
    if (!hasDecimals && (settings.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.never || settings.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.floats)) {
      return Number(inputValue) === 0 ? integerPart : `${negativeSign}${integerPart}`;
    }
    let temporaryDecimalPlacesOverride;
    if (settings.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.always || settings.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.floats) {
      temporaryDecimalPlacesOverride = decimalPlacesToRoundTo;
    } else if (settings.allowDecimalPadding > 0) {
      temporaryDecimalPlacesOverride = settings.allowDecimalPadding;
    } else {
      temporaryDecimalPlacesOverride = 0;
    }
    const decimalPositionToUse = inputValueHasNoDot ? inputValue.length - 1 : decimalCharacterPosition;
    let checkDecimalPlaces = inputValue.length - 1 - decimalPositionToUse;
    let inputValueRounded = "";
    if (checkDecimalPlaces <= decimalPlacesToRoundTo) {
      inputValueRounded = inputValue;
      if (checkDecimalPlaces < temporaryDecimalPlacesOverride) {
        if (inputValueHasNoDot) {
          inputValueRounded = `${inputValueRounded}${settings.decimalCharacter}`;
        }
        let zeros = "000000";
        while (checkDecimalPlaces < temporaryDecimalPlacesOverride) {
          zeros = zeros.substring(0, temporaryDecimalPlacesOverride - checkDecimalPlaces);
          inputValueRounded += zeros;
          checkDecimalPlaces += zeros.length;
        }
      } else if (checkDecimalPlaces > temporaryDecimalPlacesOverride) {
        inputValueRounded = this._truncateZeros(inputValueRounded, temporaryDecimalPlacesOverride);
      } else if (checkDecimalPlaces === 0 && temporaryDecimalPlacesOverride === 0) {
        inputValueRounded = inputValueRounded.replace(/\.$/, "");
      }
      return Number(inputValueRounded) === 0 ? inputValueRounded : `${negativeSign}${inputValueRounded}`;
    }
    let roundedStrLength;
    if (inputValueHasNoDot) {
      roundedStrLength = decimalPlacesToRoundTo - 1;
    } else {
      roundedStrLength = Number(decimalPlacesToRoundTo) + Number(decimalCharacterPosition);
    }
    const lastDigit = Number(inputValue.charAt(roundedStrLength + 1));
    let inputValueArray = inputValue.substring(0, roundedStrLength + 1).split("");
    let odd;
    if (inputValue.charAt(roundedStrLength) === ".") {
      odd = inputValue.charAt(roundedStrLength - 1) % 2;
    } else {
      odd = inputValue.charAt(roundedStrLength) % 2;
    }
    if (this._shouldRoundUp(lastDigit, settings, negativeSign, odd)) {
      for (let i3 = inputValueArray.length - 1; i3 >= 0; i3 -= 1) {
        if (inputValueArray[i3] !== ".") {
          inputValueArray[i3] = +inputValueArray[i3] + 1;
          if (inputValueArray[i3] < 10) {
            break;
          }
          if (i3 > 0) {
            inputValueArray[i3] = "0";
          }
        }
      }
    }
    inputValueArray = inputValueArray.slice(0, roundedStrLength + 1);
    inputValueRounded = this._truncateZeros(inputValueArray.join(""), temporaryDecimalPlacesOverride);
    return Number(inputValueRounded) === 0 ? inputValueRounded : `${negativeSign}${inputValueRounded}`;
  }
  /**
   * Round the `value` when the rounding method deals with '.05'
   *
   * @param {string} value
   * @param {object} settings
   * @returns {string}
   * @private
   */
  static _roundCloseTo05(value, settings) {
    switch (settings.roundingMethod) {
      case _AutoNumeric.options.roundingMethod.toNearest05:
      case _AutoNumeric.options.roundingMethod.toNearest05Alt:
        value = (Math.round(value * 20) / 20).toString();
        break;
      case _AutoNumeric.options.roundingMethod.upToNext05:
        value = (Math.ceil(value * 20) / 20).toString();
        break;
      default:
        value = (Math.floor(value * 20) / 20).toString();
    }
    let result2;
    if (!AutoNumericHelper.contains(value, ".")) {
      result2 = value + ".00";
    } else if (value.length - value.indexOf(".") < 3) {
      result2 = value + "0";
    } else {
      result2 = value;
    }
    return result2;
  }
  /**
   * Modify the given `value` in order to make it usable for the rest of the rounding function.
   * This convert the `value` to a positive one, trim any leading zeros and make sure it does not start with a leading dot.
   *
   * @param {string} value The unformatted value
   * @param {object} settings
   * @returns {[string, string]}
   * @private
   */
  static _prepareValueForRounding(value, settings) {
    let negativeSign = "";
    if (AutoNumericHelper.isNegativeStrict(value, "-")) {
      negativeSign = "-";
      value = value.replace("-", "");
    }
    if (!value.match(/^\d/)) {
      value = `0${value}`;
    }
    if (Number(value) === 0) {
      negativeSign = "";
    }
    if (Number(value) > 0 && settings.leadingZero !== _AutoNumeric.options.leadingZero.keep || value.length > 0 && settings.leadingZero === _AutoNumeric.options.leadingZero.allow) {
      value = value.replace(/^0*(\d)/, "$1");
    }
    return [negativeSign, value];
  }
  /**
   * Return `true` if a round up should be done given the last digit, the settings and other information about the value.
   *
   * @param {number} lastDigit
   * @param {object} settings
   * @param {string} negativeSign This variable comes from `_prepareValueForRounding()`, which return `'-'` if the initial value was negative
   * @param {number} odd
   * @returns {boolean}
   * @private
   */
  static _shouldRoundUp(lastDigit, settings, negativeSign, odd) {
    return lastDigit > 4 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfUpSymmetric || // Round half up symmetric
    lastDigit > 4 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfUpAsymmetric && negativeSign === "" || // Round half up asymmetric positive values
    lastDigit > 5 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfUpAsymmetric && negativeSign === "-" || // Round half up asymmetric negative values
    lastDigit > 5 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfDownSymmetric || // Round half down symmetric
    lastDigit > 5 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfDownAsymmetric && negativeSign === "" || // Round half down asymmetric positive values
    lastDigit > 4 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfDownAsymmetric && negativeSign === "-" || // Round half down asymmetric negative values
    lastDigit > 5 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfEvenBankersRounding || lastDigit === 5 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.halfEvenBankersRounding && odd === 1 || lastDigit > 0 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.toCeilingTowardPositiveInfinity && negativeSign === "" || lastDigit > 0 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.toFloorTowardNegativeInfinity && negativeSign === "-" || lastDigit > 0 && settings.roundingMethod === _AutoNumeric.options.roundingMethod.upRoundAwayFromZero;
  }
  /**
   * Truncates the decimal part of a number to the given number of decimal places `decimalPlacesToRoundTo`.
   *
   * @param {string} value
   * @param {object} settings
   * @param {boolean} isPaste
   * @param {int} decimalPlacesToRoundTo
   * @returns {*}
   */
  static _truncateDecimalPlaces(value, settings, isPaste, decimalPlacesToRoundTo) {
    if (isPaste) {
      value = this._roundFormattedValueShownOnFocus(value, settings);
    }
    const [integerPart, decimalPart] = value.split(settings.decimalCharacter);
    if (decimalPart && decimalPart.length > decimalPlacesToRoundTo) {
      if (decimalPlacesToRoundTo > 0) {
        const modifiedDecimalPart = decimalPart.substring(0, decimalPlacesToRoundTo);
        value = `${integerPart}${settings.decimalCharacter}${modifiedDecimalPart}`;
      } else {
        value = integerPart;
      }
    }
    return value;
  }
  /**
   * Check if the given value is within the `minimumValue` and `maximumValue` range, while using the override options set with `overrideMinMaxLimits`.
   * The minimum and maximum limit test results are returned in an array like `[isMinimumLimitRespected, isMaximumLimitRespected]`.
   *
   * @param {string} value
   * @param {object} settings
   * @returns {[boolean, boolean]}
   */
  static _checkIfInRangeWithOverrideOption(value, settings) {
    if (AutoNumericHelper.isNull(value) && settings.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.null || // When the `null` value is accepted as the `rawValue`, the limits are ignored
    settings.overrideMinMaxLimits === _AutoNumeric.options.overrideMinMaxLimits.ignore || settings.overrideMinMaxLimits === _AutoNumeric.options.overrideMinMaxLimits.invalid) {
      return [true, true];
    }
    value = value.toString();
    value = value.replace(",", ".");
    const minParse = AutoNumericHelper.parseStr(settings.minimumValue);
    const maxParse = AutoNumericHelper.parseStr(settings.maximumValue);
    const valParse = AutoNumericHelper.parseStr(value);
    let result2;
    switch (settings.overrideMinMaxLimits) {
      case _AutoNumeric.options.overrideMinMaxLimits.floor:
        result2 = [AutoNumericHelper.testMinMax(minParse, valParse) > -1, true];
        break;
      case _AutoNumeric.options.overrideMinMaxLimits.ceiling:
        result2 = [true, AutoNumericHelper.testMinMax(maxParse, valParse) < 1];
        break;
      default:
        result2 = [AutoNumericHelper.testMinMax(minParse, valParse) > -1, AutoNumericHelper.testMinMax(maxParse, valParse) < 1];
    }
    return result2;
  }
  /**
   * Returns `true` if the given value is within the `minimumValue` and `maximumValue` limits, while using the override options set with `overrideMinMaxLimits`, `false` otherwise
   *
   * @param {string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _isWithinRangeWithOverrideOption(value, settings) {
    const [minTest, maxTest] = this._checkIfInRangeWithOverrideOption(value, settings);
    return minTest && maxTest;
  }
  /**
   * Helper function that prepares the value string for the min/max test
   *
   * @param {string} value
   * @returns {{}}
   * @private
   */
  static _cleanValueForRangeParse(value) {
    value = value.toString().replace(",", ".");
    return AutoNumericHelper.parseStr(value);
  }
  /**
   * Returns `true` is the value is superior or equal to the `minimumValue` limit, discarding any override options
   *
   * @param {string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _isMinimumRangeRespected(value, settings) {
    return AutoNumericHelper.testMinMax(AutoNumericHelper.parseStr(settings.minimumValue), this._cleanValueForRangeParse(value)) > -1;
  }
  /**
   * Returns `true` is the value is inferior or equal to the `maximumValue` limit, discarding any override options
   *
   * @param {string} value
   * @param {object} settings
   * @returns {boolean}
   * @private
   */
  static _isMaximumRangeRespected(value, settings) {
    return AutoNumericHelper.testMinMax(AutoNumericHelper.parseStr(settings.maximumValue), this._cleanValueForRangeParse(value)) < 1;
  }
  /**
   * Helper function that triggers the range events if they are needed
   *
   * @param {boolean} minTest
   * @param {boolean} maxTest
   * @private
   */
  _triggerRangeEvents(minTest, maxTest) {
    if (!minTest) {
      this._triggerEvent(_AutoNumeric.events.minRangeExceeded, this.domElement);
    }
    if (!maxTest) {
      this._triggerEvent(_AutoNumeric.events.maxRangeExceeded, this.domElement);
    }
  }
  /**
   * Set the invalid state on the AutoNumeric element.
   * If the element is not an input, and therefore a contenteditable-enabled element, its validity state cannot be changed.
   * In that case, the invalid css class defined with the `settings.invalidClass` option is added to the element.
   * The 'autoNumeric:invalidValue' event is always sent when this function is called.
   *
   * @private
   */
  _setInvalidState() {
    if (this.isInputElement) {
      AutoNumericHelper.setInvalidState(this.domElement);
    } else {
      this._addCSSClass(this.settings.invalidClass);
    }
    this._triggerEvent(_AutoNumeric.events.invalidValue, this.domElement);
    this.validState = false;
  }
  /**
   * Set the valid state on the AutoNumeric element.
   * If the element is not an input, and therefore a contenteditable-enabled element, its validity state cannot be changed.
   * In that case, the invalid css class defined with the `settings.invalidClass` option is removed.
   * The 'autoNumeric:correctedValue' event is sent if the element state is invalid when this is called.
   *
   * @private
   */
  _setValidState() {
    if (this.isInputElement) {
      AutoNumericHelper.setValidState(this.domElement);
    } else {
      this._removeCSSClass(this.settings.invalidClass);
    }
    if (!this.validState) {
      this._triggerEvent(_AutoNumeric.events.correctedValue, this.domElement);
    }
    this.validState = true;
  }
  /**
   * Sets the valid or invalid state on the DOM element, if the value is within the range set by the minimum and maximum value
   *
   * @param {string} value
   * @private
   */
  _setValidOrInvalidState(value) {
    if (this.settings.overrideMinMaxLimits === _AutoNumeric.options.overrideMinMaxLimits.invalid) {
      const minRangeOk = this.constructor._isMinimumRangeRespected(value, this.settings);
      const maxRangeOk = this.constructor._isMaximumRangeRespected(value, this.settings);
      if (minRangeOk && maxRangeOk) {
        this._setValidState();
      } else {
        this._setInvalidState();
      }
      this._triggerRangeEvents(minRangeOk, maxRangeOk);
    }
  }
  /**
   * Original settings saved for use when the `decimalPlacesShownOnFocus` and `showOnlyNumbersOnFocus` options are used.
   * Those original settings are used exclusively in the `focusin` and `focusout` event handlers.
   */
  _keepAnOriginalSettingsCopy() {
    this.originalDigitGroupSeparator = this.settings.digitGroupSeparator;
    this.originalCurrencySymbol = this.settings.currencySymbol;
    this.originalSuffixText = this.settings.suffixText;
  }
  /**
   * Removes any zeros in excess in the front and back of the given `value`, according to the `settings`.
   * This also manages the cases where the decimal point is on the far left or far right of the `value`.
   *
   * @param {string} value
   * @returns {string|null}
   */
  _trimLeadingAndTrailingZeros(value) {
    if (value === "" || value === null) {
      return value;
    }
    if (this.settings.leadingZero !== _AutoNumeric.options.leadingZero.keep) {
      if (Number(value) === 0) {
        return "0";
      }
      value = value.replace(/^(-)?0+(?=\d)/g, "$1");
    }
    if (AutoNumericHelper.contains(value, ".")) {
      value = value.replace(/(\.[0-9]*?)0+$/, "$1");
    }
    value = value.replace(/\.$/, "");
    return value;
  }
  /**
   * Generate the name for the persistent stored data variable
   * @private
   */
  _setPersistentStorageName() {
    if (this.settings.saveValueToSessionStorage) {
      if (this.domElement.name !== "" && !AutoNumericHelper.isUndefined(this.domElement.name)) {
        this.rawValueStorageName = `${this.storageNamePrefix}${decodeURIComponent(this.domElement.name)}`;
      } else {
        this.rawValueStorageName = `${this.storageNamePrefix}${this.domElement.id}`;
      }
    }
  }
  /**
   * Save the raw Value into sessionStorage or a cookie depending on what the browser is supporting.
   * @private
   */
  _saveValueToPersistentStorage() {
    if (this.settings.saveValueToSessionStorage) {
      sessionStorage.setItem(this.rawValueStorageName, this.rawValue);
    }
  }
  /**
   * Retrieve the raw value from sessionStorage or the cookie depending on what the browser is supporting.
   *
   * @returns {*}
   * @private
   */
  _getValueFromPersistentStorage() {
    if (this.settings.saveValueToSessionStorage) {
      return sessionStorage.getItem(this.rawValueStorageName);
    }
    AutoNumericHelper.warning("`_getValueFromPersistentStorage()` is called but `settings.saveValueToSessionStorage` is false. There must be an error that needs fixing.", this.settings.showWarnings);
    return null;
  }
  /**
   * Remove the raw value data from sessionStorage or the cookie depending on what the browser is supporting.
   * @private
   */
  _removeValueFromPersistentStorage() {
    if (this.settings.saveValueToSessionStorage) {
      sessionStorage.removeItem(this.rawValueStorageName);
    }
  }
  /**
   * Get the default value from the html `value` attribute.
   * Return the empty string if such attribute is not found.
   *
   * @param {HTMLElement} domElement
   *
   * @returns {string}
   * @private
   */
  _getDefaultValue(domElement) {
    const value = domElement.getAttribute("value");
    if (AutoNumericHelper.isNull(value)) {
      return "";
    }
    return value;
  }
  /**
   * Handler for 'focusin' and 'mouseenter' events
   * On focusin, multiple things happens :
   * - If `Alt` is pressed, unformat
   * - Remove the separators if `showOnlyNumbersOnFocus` is set
   * - Depending on `emptyInputBehavior`, reformat the empty formatted value
   * - Display the correct number of decimal places (on focus/blur)
   * - Place the caret correctly if the element is empty
   *
   * Note: On focusin, the `rawValue` is never changed. Only the formatted value can be modified.
   *
   * @param {KeyboardEvent|MouseEvent} e
   * @private
   */
  _onFocusInAndMouseEnter(e5) {
    this.isEditing = false;
    if (!this.formulaMode && this.settings.unformatOnHover && e5.type === "mouseenter" && e5.altKey) {
      this.constructor._unformatAltHovered(this);
      return;
    }
    if (e5.type === "focus") {
      this.isFocused = true;
      this.rawValueOnFocus = this.rawValue;
    }
    if (e5.type === "focus" && this.settings.unformatOnHover && this.hoveredWithAlt) {
      this.constructor._reformatAltHovered(this);
    }
    if (e5.type === "focus" || e5.type === "mouseenter" && !this.isFocused) {
      let elementValueToSet = null;
      if (this.settings.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.focus && this.rawValue < 0 && this.settings.negativeBracketsTypeOnBlur !== null && this.settings.isNegativeSignAllowed) {
        elementValueToSet = this.constructor._removeBrackets(AutoNumericHelper.getElementValue(this.domElement), this.settings);
      }
      const rawValueToFormat = this._getRawValueToFormat(this.rawValue);
      if (rawValueToFormat !== "") {
        const roundedValue = this.constructor._roundFormattedValueShownOnFocusOrBlur(rawValueToFormat, this.settings, this.isFocused);
        if (this.settings.showOnlyNumbersOnFocus === _AutoNumeric.options.showOnlyNumbersOnFocus.onlyNumbers) {
          this.settings.digitGroupSeparator = "";
          this.settings.currencySymbol = "";
          this.settings.suffixText = "";
          elementValueToSet = roundedValue.replace(".", this.settings.decimalCharacter);
        } else {
          let formattedValue;
          if (AutoNumericHelper.isNull(roundedValue)) {
            formattedValue = "";
          } else {
            formattedValue = this.constructor._addGroupSeparators(roundedValue.replace(".", this.settings.decimalCharacter), this.settings, this.isFocused, rawValueToFormat);
          }
          elementValueToSet = formattedValue;
        }
      }
      if (AutoNumericHelper.isNull(elementValueToSet)) {
        this.valueOnFocus = "";
      } else {
        this.valueOnFocus = elementValueToSet;
      }
      this.lastVal = this.valueOnFocus;
      const isEmptyValue = this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(this.valueOnFocus, this.settings);
      const orderedValue = this.constructor._orderValueCurrencySymbolAndSuffixText(this.valueOnFocus, this.settings, true);
      const orderedValueTest = isEmptyValue && orderedValue !== "" && this.settings.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.focus;
      if (orderedValueTest) {
        elementValueToSet = orderedValue;
      }
      if (!AutoNumericHelper.isNull(elementValueToSet)) {
        this._setElementValue(elementValueToSet);
      }
      if (orderedValueTest && orderedValue === this.settings.currencySymbol && this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
        AutoNumericHelper.setElementSelection(e5.target, 0);
      }
    }
  }
  /**
   * Handler for the 'focus' event.
   * We update the info of the focused state in the `this.isFocused` variable when the element gets focused.
   * @private
   */
  _onFocus() {
    if (this.settings.isCancellable) {
      this._saveCancellableValue();
    }
  }
  /**
   * Handler for the 'focusin' event.
   * This is called before the 'focus' event, and is necessary to change the selection on focus under Firefox for instance.
   *
   * @param {Event} e
   * @private
   */
  _onFocusIn(e5) {
    if (this.settings.selectOnFocus) {
      this.select();
    } else {
      if (!AutoNumericHelper.isNull(this.settings.caretPositionOnFocus)) {
        AutoNumericHelper.setElementSelection(e5.target, this._initialCaretPosition(AutoNumericHelper.getElementValue(this.domElement)));
      }
    }
  }
  /**
   * Enter the special 'formula mode' where users can enter a math expression that will be evaluated on blur and `enter`
   * @private
   */
  _enterFormulaMode() {
    if (this.settings.formulaMode) {
      this.formulaMode = true;
      AutoNumericHelper.setElementValue(this.domElement, "=");
      AutoNumericHelper.setElementSelection(this.domElement, 1);
    }
  }
  /**
   * Exit the formula mode
   * Tries to parse and evaluate the math expression, then `set()` the result if it's correct, otherwise reformat with the previous `rawValue`
   * @private
   */
  _exitFormulaMode() {
    let formula = AutoNumericHelper.getElementValue(this.domElement);
    formula = formula.replace(/^\s*=/, "");
    let result2;
    try {
      const ast = new Parser$3(formula, this.settings.decimalCharacter);
      result2 = new Evaluator().evaluate(ast);
    } catch (e5) {
      this._triggerEvent(_AutoNumeric.events.invalidFormula, this.domElement, {
        formula,
        aNElement: this
      });
      this.reformat();
      this.formulaMode = false;
      return;
    }
    this._triggerEvent(_AutoNumeric.events.validFormula, this.domElement, {
      formula,
      result: result2,
      aNElement: this
    });
    this.set(result2);
    this.formulaMode = false;
  }
  /**
   * Returns `true` if the non-printable key is accepted in formula mode
   *
   * @returns {boolean}
   * @private
   */
  _acceptNonPrintableKeysInFormulaMode() {
    return this.eventKey === AutoNumericEnum.keyName.Backspace || this.eventKey === AutoNumericEnum.keyName.Delete || this.eventKey === AutoNumericEnum.keyName.LeftArrow || this.eventKey === AutoNumericEnum.keyName.RightArrow || this.eventKey === AutoNumericEnum.keyName.Home || this.eventKey === AutoNumericEnum.keyName.End;
  }
  /**
   * Handler for 'keydown' events.
   * The user just started pushing any key, hence one event is sent.
   *
   * Note :
   * By default a 'normal' input output those events in the right order when inputting a character key (i.e. 'a') :
   * - keydown
   * - keypress
   * - input
   * - keyup
   *
   * ...when inputting a modifier key (i.e. 'ctrl') :
   * - keydown
   * - keyup
   *
   * If 'delete' or 'backspace' are entered 'normally', the following events are sent :
   * - keydown
   * - input
   * - keyup
   *
   * If 'delete' or 'backspace' are entered continuously (with the key still pressed), the following events are sent :
   * - keydown
   * - input
   * [- keydown
   * - input] x times
   * - keyup
   *
   * If 'enter' is entered and the value has not changed, the following events are sent :
   * - keydown
   * - keypress
   * - keyup
   *
   * If 'enter' is entered and the value has been changed, the following events are sent :
   * - keydown
   * - keypress
   * - change
   * - keyup
   *
   * When a paste is done, the following events are sent :
   * - input (if paste is done with the mouse)
   *
   * - keydown (if paste is done with ctrl+v)
   * - keydown
   * - input
   * - keyup
   * - keyup
   *
   * @param {KeyboardEvent} e
   */
  _onKeydown(e5) {
    this.formatted = false;
    this.isEditing = true;
    if (!this.formulaMode && !this.isFocused && this.settings.unformatOnHover && e5.altKey && this.domElement === AutoNumericHelper.getHoveredElement()) {
      this.constructor._unformatAltHovered(this);
      return;
    }
    this._updateEventKeyInfo(e5);
    this.keydownEventCounter += 1;
    if (this.keydownEventCounter === 1) {
      this.initialValueOnFirstKeydown = AutoNumericHelper.getElementValue(e5.target);
      this.initialRawValueOnFirstKeydown = this.rawValue;
    }
    if (this.formulaMode) {
      if (this.eventKey === AutoNumericEnum.keyName.Esc) {
        this.formulaMode = false;
        this.reformat();
        return;
      }
      if (this.eventKey === AutoNumericEnum.keyName.Enter) {
        this._exitFormulaMode();
        return;
      }
      if (this._acceptNonPrintableKeysInFormulaMode()) {
        return;
      }
    } else {
      if (this.eventKey === AutoNumericEnum.keyName.Equal) {
        this._enterFormulaMode();
        return;
      }
      if (this.settings.modifyValueOnUpDownArrow && (this.eventKey === AutoNumericEnum.keyName.UpArrow || this.eventKey === AutoNumericEnum.keyName.DownArrow)) {
        this.upDownArrowAction(e5);
        return;
      }
    }
    if (this.domElement.readOnly || this.settings.readOnly || this.domElement.disabled) {
      this.processed = true;
      return;
    }
    if (this.eventKey === AutoNumericEnum.keyName.Esc) {
      e5.preventDefault();
      if (this.settings.isCancellable) {
        if (this.rawValue !== this.savedCancellableValue) {
          this.set(this.savedCancellableValue);
          this._triggerEvent(_AutoNumeric.events.native.input, e5.target);
        }
      }
      this.select();
    }
    let targetValue = AutoNumericHelper.getElementValue(e5.target);
    if (this.eventKey === AutoNumericEnum.keyName.Enter && this.rawValue !== this.rawValueOnFocus) {
      this._triggerEvent(_AutoNumeric.events.native.change, e5.target);
      this.valueOnFocus = targetValue;
      this.rawValueOnFocus = this.rawValue;
      if (this.settings.isCancellable) {
        this._saveCancellableValue();
      }
    }
    this._updateInternalProperties(e5);
    if (this._processNonPrintableKeysAndShortcuts(e5)) {
      this.processed = true;
      return;
    }
    if (this.eventKey === AutoNumericEnum.keyName.Backspace || this.eventKey === AutoNumericEnum.keyName.Delete) {
      const isDeletionAllowed = this._processCharacterDeletion(e5);
      this.processed = true;
      if (!isDeletionAllowed) {
        e5.preventDefault();
        return;
      }
      this._formatValue(e5);
      targetValue = AutoNumericHelper.getElementValue(e5.target);
      if (targetValue !== this.lastVal && this.throwInput) {
        this._triggerEvent(_AutoNumeric.events.native.input, e5.target);
        e5.preventDefault();
      }
      this.lastVal = targetValue;
      this.throwInput = true;
    }
  }
  /**
   * Handler for 'keypress' events.
   * The user is still pressing the key, which will output a character (i.e. '2') continuously until he releases the key.
   * Note: 'keypress' events are not sent for delete keys like Backspace/Delete.
   *
   * @param {KeyboardEvent} e
   */
  _onKeypress(e5) {
    if (this.formulaMode) {
      if (this._acceptNonPrintableKeysInFormulaMode()) {
        return;
      }
      if (this.settings.formulaChars.test(this.eventKey)) {
        return;
      } else {
        e5.preventDefault();
      }
      return;
    }
    if (this.eventKey === AutoNumericEnum.keyName.Insert) {
      return;
    }
    const processed = this.processed;
    this._updateInternalProperties(e5);
    if (this._processNonPrintableKeysAndShortcuts(e5)) {
      return;
    }
    if (processed) {
      e5.preventDefault();
      return;
    }
    const isCharacterInsertionAllowed = this._processCharacterInsertion();
    if (isCharacterInsertionAllowed) {
      this._formatValue(e5);
      const targetValue = AutoNumericHelper.getElementValue(e5.target);
      if (targetValue !== this.lastVal && this.throwInput) {
        this._triggerEvent(_AutoNumeric.events.native.input, e5.target);
        e5.preventDefault();
      } else {
        if ((this.eventKey === this.settings.decimalCharacter || this.eventKey === this.settings.decimalCharacterAlternative) && AutoNumericHelper.getElementSelection(e5.target).start === AutoNumericHelper.getElementSelection(e5.target).end && AutoNumericHelper.getElementSelection(e5.target).start === targetValue.indexOf(this.settings.decimalCharacter)) {
          const position2 = AutoNumericHelper.getElementSelection(e5.target).start + 1;
          AutoNumericHelper.setElementSelection(e5.target, position2);
        }
        e5.preventDefault();
      }
      this.lastVal = AutoNumericHelper.getElementValue(e5.target);
      this.throwInput = true;
      this._setValidOrInvalidState(this.rawValue);
      return;
    }
    e5.preventDefault();
  }
  /**
   * Handler for 'keyup' events.
   * The user just released any key, hence one event is sent.
   *
   * @param {KeyboardEvent} e
   */
  _onKeyup(e5) {
    this.isEditing = false;
    this.keydownEventCounter = 0;
    if (this.formulaMode) {
      return;
    }
    if (this.settings.isCancellable && this.eventKey === AutoNumericEnum.keyName.Esc) {
      e5.preventDefault();
      return;
    }
    this._updateEventKeyInfo(e5);
    if (this.eventKey === AutoNumericEnum.keyName.Z || this.eventKey === AutoNumericEnum.keyName.z) {
      if (e5.ctrlKey && e5.shiftKey) {
        e5.preventDefault();
        this._historyTableRedo();
        this._triggerEvent(_AutoNumeric.events.native.input, e5.target);
        this.onGoingRedo = true;
        return;
      } else if (e5.ctrlKey && !e5.shiftKey) {
        if (this.onGoingRedo) {
          this.onGoingRedo = false;
        } else {
          e5.preventDefault();
          this._historyTableUndo();
          this._triggerEvent(_AutoNumeric.events.native.input, e5.target);
          return;
        }
      }
    } else if ((this.eventKey === AutoNumericEnum.keyName.Y || this.eventKey === AutoNumericEnum.keyName.y) && e5.ctrlKey) {
      e5.preventDefault();
      this._historyTableRedo();
      this._triggerEvent(_AutoNumeric.events.native.input, e5.target);
      this.onGoingRedo = true;
      return;
    }
    if (this.onGoingRedo && (e5.ctrlKey || e5.shiftKey)) {
      this.onGoingRedo = false;
    }
    if ((e5.ctrlKey || e5.metaKey) && (this.eventKey === AutoNumericEnum.keyName.X || this.eventKey === AutoNumericEnum.keyName.x)) {
      const caretPosition = AutoNumericHelper.getElementSelection(this.domElement).start;
      const cutNumber = this.constructor._toNumericValue(AutoNumericHelper.getElementValue(e5.target), this.settings);
      this.set(cutNumber);
      this._setCaretPosition(caretPosition);
    }
    if (this.eventKey === AutoNumericEnum.keyName.Alt && this.settings.unformatOnHover && this.hoveredWithAlt) {
      this.constructor._reformatAltHovered(this);
      return;
    }
    if ((e5.ctrlKey || e5.metaKey) && (this.eventKey === AutoNumericEnum.keyName.Backspace || this.eventKey === AutoNumericEnum.keyName.Delete)) {
      const targetValue2 = AutoNumericHelper.getElementValue(e5.target);
      this._setRawValue(this._formatOrUnformatOther(false, targetValue2));
      return;
    }
    this._updateInternalProperties(e5);
    const skip = this._processNonPrintableKeysAndShortcuts(e5);
    delete this.valuePartsBeforePaste;
    const targetValue = AutoNumericHelper.getElementValue(e5.target);
    if (skip || targetValue === "" && this.initialValueOnFirstKeydown === "") {
      return;
    }
    if (targetValue === this.settings.currencySymbol) {
      if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
        AutoNumericHelper.setElementSelection(e5.target, 0);
      } else {
        AutoNumericHelper.setElementSelection(e5.target, this.settings.currencySymbol.length);
      }
    } else if (this.eventKey === AutoNumericEnum.keyName.Tab) {
      AutoNumericHelper.setElementSelection(e5.target, 0, targetValue.length);
    }
    if (targetValue === this.settings.suffixText || this.rawValue === "" && this.settings.currencySymbol !== "" && this.settings.suffixText !== "") {
      AutoNumericHelper.setElementSelection(e5.target, 0);
    }
    if (this.settings.decimalPlacesShownOnFocus !== null) {
      this._saveValueToPersistentStorage();
    }
    if (!this.formatted) {
      this._formatValue(e5);
    }
    this._setValidOrInvalidState(this.rawValue);
    this._saveRawValueForAndroid();
    if (targetValue !== this.initialValueOnFirstKeydown) {
      this._triggerEvent(_AutoNumeric.events.formatted, e5.target, {
        oldValue: this.initialValueOnFirstKeydown,
        newValue: targetValue,
        oldRawValue: this.initialRawValueOnFirstKeydown,
        newRawValue: this.rawValue,
        isPristine: this.isPristine(false),
        error: null,
        aNElement: this
      });
    }
    if (this.historyTable.length > 1) {
      const selection = AutoNumericHelper.getElementSelection(this.domElement);
      this.selectionStart = selection.start;
      this.selectionEnd = selection.end;
      this.historyTable[this.historyTableIndex].start = this.selectionStart;
      this.historyTable[this.historyTableIndex].end = this.selectionEnd;
    }
  }
  /**
   * On Android Chrome, the `rawValue` is not updated when the user changes the input value.
   * This function updates the `rawValue` accordingly.
   * @private
   */
  _saveRawValueForAndroid() {
    if (this.eventKey === AutoNumericEnum.keyName.AndroidDefault) {
      let normalizedValue = this.constructor._stripAllNonNumberCharactersExceptCustomDecimalChar(this.getFormatted(), this.settings, true, this.isFocused);
      normalizedValue = this.constructor._convertToNumericString(normalizedValue, this.settings);
      this._setRawValue(normalizedValue);
    }
  }
  /**
   * Handler for 'focusout' events
   * On focusout, multiple things happens :
   * - The element value is formatted back if the `Alt` key was pressed,
   * - The element value is formatted back if `showOnlyNumbersOnFocus` was set to only show numbers,
   * - The element value is multiplied by `rawValueDivisor` on `blur`
   *
   * Note: On focusout, the `rawValue` is never changed. Only the formatted value can be modified.
   *
   * @param {Event} e
   */
  _onFocusOutAndMouseLeave(e5) {
    this.isEditing = false;
    if (e5.type === "mouseleave" && this.formulaMode) {
      return;
    }
    if (this.settings.unformatOnHover && e5.type === "mouseleave" && this.hoveredWithAlt) {
      this.constructor._reformatAltHovered(this);
      return;
    }
    if (e5.type === "mouseleave" && !this.isFocused || e5.type === "blur") {
      if (e5.type === "blur" && this.formulaMode) {
        this._exitFormulaMode();
      }
      this._saveValueToPersistentStorage();
      if (this.settings.showOnlyNumbersOnFocus === _AutoNumeric.options.showOnlyNumbersOnFocus.onlyNumbers) {
        this.settings.digitGroupSeparator = this.originalDigitGroupSeparator;
        this.settings.currencySymbol = this.originalCurrencySymbol;
        this.settings.suffixText = this.originalSuffixText;
      }
      const rawValueToFormat = this._getRawValueToFormat(this.rawValue);
      const isRawValueNull = AutoNumericHelper.isNull(rawValueToFormat);
      const [minTest, maxTest] = this.constructor._checkIfInRangeWithOverrideOption(rawValueToFormat, this.settings);
      let elementValueIsAlreadySet = false;
      if (rawValueToFormat !== "" && !isRawValueNull) {
        this._triggerRangeEvents(minTest, maxTest);
        if (this.settings.valuesToStrings && this._checkValuesToStrings(rawValueToFormat)) {
          this._setElementValue(this.settings.valuesToStrings[rawValueToFormat]);
          elementValueIsAlreadySet = true;
        }
      }
      if (!elementValueIsAlreadySet) {
        let value;
        if (isRawValueNull || rawValueToFormat === "") {
          value = rawValueToFormat;
        } else {
          value = String(rawValueToFormat);
        }
        if (rawValueToFormat !== "" && !isRawValueNull) {
          if (minTest && maxTest && !this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(rawValueToFormat, this.settings)) {
            value = this._modifyNegativeSignAndDecimalCharacterForRawValue(value);
            if (this.settings.divisorWhenUnfocused && !AutoNumericHelper.isNull(value)) {
              value = value / this.settings.divisorWhenUnfocused;
              value = value.toString();
            }
            value = this.constructor._roundFormattedValueShownOnBlur(value, this.settings);
            value = this.constructor._modifyNegativeSignAndDecimalCharacterForFormattedValue(value, this.settings);
          } else {
            this._triggerRangeEvents(minTest, maxTest);
          }
        } else if (rawValueToFormat === "") {
          switch (this.settings.emptyInputBehavior) {
            case _AutoNumeric.options.emptyInputBehavior.zero:
              this._setRawValue("0");
              value = this.constructor._roundValue("0", this.settings, 0);
              break;
            case _AutoNumeric.options.emptyInputBehavior.min:
              this._setRawValue(this.settings.minimumValue);
              value = this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.minimumValue, this.settings, this.isFocused);
              break;
            case _AutoNumeric.options.emptyInputBehavior.max:
              this._setRawValue(this.settings.maximumValue);
              value = this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.maximumValue, this.settings, this.isFocused);
              break;
            default:
              if (AutoNumericHelper.isNumber(this.settings.emptyInputBehavior)) {
                this._setRawValue(this.settings.emptyInputBehavior);
                value = this.constructor._roundFormattedValueShownOnFocusOrBlur(this.settings.emptyInputBehavior, this.settings, this.isFocused);
              }
          }
        }
        let groupedValue = this.constructor._orderValueCurrencySymbolAndSuffixText(value, this.settings, false);
        if (!(this.constructor._isElementValueEmptyOrOnlyTheNegativeSign(value, this.settings) || isRawValueNull && this.settings.emptyInputBehavior === _AutoNumeric.options.emptyInputBehavior.null)) {
          groupedValue = this.constructor._addGroupSeparators(value, this.settings, false, rawValueToFormat);
        }
        if (groupedValue !== rawValueToFormat || rawValueToFormat === "" || // This make sure we get rid on any currency symbol or suffix that might have been added on focus
        this.settings.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.never || this.settings.allowDecimalPadding === _AutoNumeric.options.allowDecimalPadding.floats) {
          if (this.settings.symbolWhenUnfocused && rawValueToFormat !== "" && rawValueToFormat !== null) {
            groupedValue = `${groupedValue}${this.settings.symbolWhenUnfocused}`;
          }
          this._setElementValue(groupedValue);
        }
      }
      this._setValidOrInvalidState(this.rawValue);
      if (e5.type === "blur") {
        this._onBlur(e5);
      }
    }
  }
  /**
   * Handler for 'paste' event
   *
   * @param {Event|ClipboardEvent} e
   */
  _onPaste(e5) {
    e5.preventDefault();
    if (this.settings.readOnly || this.domElement.readOnly || this.domElement.disabled) {
      return;
    }
    let rawPastedText;
    if (e5.clipboardData && e5.clipboardData.getData) {
      rawPastedText = e5.clipboardData.getData("text/plain");
    } else {
      AutoNumericHelper.throwError("Unable to retrieve the pasted value. Please use a modern browser (i.e. Firefox or Chromium).");
    }
    let eventTarget;
    if (!e5.target.tagName) {
      eventTarget = e5.explicitOriginalTarget;
    } else {
      eventTarget = e5.target;
    }
    const initialFormattedValue = AutoNumericHelper.getElementValue(eventTarget);
    const selectionStart = eventTarget.selectionStart || 0;
    const selectionEnd = eventTarget.selectionEnd || 0;
    const selectionSize = selectionEnd - selectionStart;
    if (selectionSize === initialFormattedValue.length) {
      const untranslatedPastedText2 = this._preparePastedText(rawPastedText);
      const pastedRawValue = AutoNumericHelper.arabicToLatinNumbers(untranslatedPastedText2, false, false, false);
      if (pastedRawValue === "." || pastedRawValue === "" || pastedRawValue !== "." && !AutoNumericHelper.isNumber(pastedRawValue)) {
        this.formatted = true;
        if (this.settings.onInvalidPaste === _AutoNumeric.options.onInvalidPaste.error) {
          AutoNumericHelper.throwError(`The pasted value '${rawPastedText}' is not a valid paste content.`);
        }
        return;
      }
      this.set(pastedRawValue);
      this.formatted = true;
      this._triggerEvent(_AutoNumeric.events.native.input, eventTarget);
      return;
    }
    const isPasteNegative = AutoNumericHelper.isNegativeStrict(rawPastedText, this.settings.negativeSignCharacter);
    if (isPasteNegative) {
      rawPastedText = rawPastedText.slice(1, rawPastedText.length);
    }
    const untranslatedPastedText = this._preparePastedText(rawPastedText);
    let pastedText;
    if (untranslatedPastedText === ".") {
      pastedText = ".";
    } else {
      pastedText = AutoNumericHelper.arabicToLatinNumbers(untranslatedPastedText, false, false, false);
    }
    if (pastedText !== "." && (!AutoNumericHelper.isNumber(pastedText) || pastedText === "")) {
      this.formatted = true;
      if (this.settings.onInvalidPaste === _AutoNumeric.options.onInvalidPaste.error) {
        AutoNumericHelper.throwError(`The pasted value '${rawPastedText}' is not a valid paste content.`);
      }
      return;
    }
    let caretPositionOnInitialTextAfterPasting;
    let isInitialValueNegative = AutoNumericHelper.isNegativeStrict(this.getNumericString(), this.settings.negativeSignCharacter);
    let isPasteNegativeAndInitialValueIsPositive;
    let result2;
    if (isPasteNegative && !isInitialValueNegative) {
      isInitialValueNegative = true;
      isPasteNegativeAndInitialValueIsPositive = true;
    } else {
      isPasteNegativeAndInitialValueIsPositive = false;
    }
    const leftFormattedPart = initialFormattedValue.slice(0, selectionStart);
    const rightFormattedPart = initialFormattedValue.slice(selectionEnd, initialFormattedValue.length);
    if (selectionStart !== selectionEnd) {
      result2 = this._preparePastedText(leftFormattedPart + rightFormattedPart);
    } else {
      result2 = this._preparePastedText(initialFormattedValue);
    }
    if (isInitialValueNegative) {
      result2 = AutoNumericHelper.setRawNegativeSign(result2);
    }
    caretPositionOnInitialTextAfterPasting = AutoNumericHelper.convertCharacterCountToIndexPosition(AutoNumericHelper.countNumberCharactersOnTheCaretLeftSide(initialFormattedValue, selectionStart, this.settings.decimalCharacter));
    if (isPasteNegativeAndInitialValueIsPositive) {
      caretPositionOnInitialTextAfterPasting++;
    }
    let leftPart = result2.slice(0, caretPositionOnInitialTextAfterPasting);
    let rightPart = result2.slice(caretPositionOnInitialTextAfterPasting, result2.length);
    let leftPartContainedADot = false;
    if (pastedText === ".") {
      if (AutoNumericHelper.contains(leftPart, ".")) {
        leftPartContainedADot = true;
        leftPart = leftPart.replace(".", "");
      }
      rightPart = rightPart.replace(".", "");
    }
    let negativePasteOnNegativeNumber = false;
    if (leftPart === "" && rightPart === "-") {
      leftPart = "-";
      rightPart = "";
      negativePasteOnNegativeNumber = true;
    }
    switch (this.settings.onInvalidPaste) {
      case _AutoNumeric.options.onInvalidPaste.truncate:
      case _AutoNumeric.options.onInvalidPaste.replace:
        const minParse = AutoNumericHelper.parseStr(this.settings.minimumValue);
        const maxParse = AutoNumericHelper.parseStr(this.settings.maximumValue);
        let lastGoodKnownResult = result2;
        let pastedTextIndex = 0;
        let modifiedLeftPart = leftPart;
        while (pastedTextIndex < pastedText.length) {
          modifiedLeftPart += pastedText[pastedTextIndex];
          result2 = modifiedLeftPart + rightPart;
          if (!this.constructor._checkIfInRange(result2, minParse, maxParse)) {
            break;
          }
          lastGoodKnownResult = result2;
          pastedTextIndex++;
        }
        caretPositionOnInitialTextAfterPasting += pastedTextIndex;
        if (negativePasteOnNegativeNumber) caretPositionOnInitialTextAfterPasting++;
        if (this.settings.onInvalidPaste === _AutoNumeric.options.onInvalidPaste.truncate) {
          result2 = lastGoodKnownResult;
          if (leftPartContainedADot) {
            caretPositionOnInitialTextAfterPasting--;
          }
          break;
        }
        let lastGoodKnownResultIndex = caretPositionOnInitialTextAfterPasting;
        const lastGoodKnownResultSize = lastGoodKnownResult.length;
        while (pastedTextIndex < pastedText.length && lastGoodKnownResultIndex < lastGoodKnownResultSize) {
          if (lastGoodKnownResult[lastGoodKnownResultIndex] === ".") {
            lastGoodKnownResultIndex++;
            continue;
          }
          result2 = AutoNumericHelper.replaceCharAt(lastGoodKnownResult, lastGoodKnownResultIndex, pastedText[pastedTextIndex]);
          if (!this.constructor._checkIfInRange(result2, minParse, maxParse)) {
            break;
          }
          lastGoodKnownResult = result2;
          pastedTextIndex++;
          lastGoodKnownResultIndex++;
        }
        caretPositionOnInitialTextAfterPasting = lastGoodKnownResultIndex;
        if (leftPartContainedADot) {
          caretPositionOnInitialTextAfterPasting--;
        }
        result2 = lastGoodKnownResult;
        break;
      case _AutoNumeric.options.onInvalidPaste.error:
      case _AutoNumeric.options.onInvalidPaste.ignore:
      case _AutoNumeric.options.onInvalidPaste.clamp:
      default:
        result2 = `${leftPart}${pastedText}${rightPart}`;
        if (selectionStart === selectionEnd) {
          const indexWherePastedTextHasBeenInserted = AutoNumericHelper.convertCharacterCountToIndexPosition(AutoNumericHelper.countNumberCharactersOnTheCaretLeftSide(initialFormattedValue, selectionStart, this.settings.decimalCharacter));
          caretPositionOnInitialTextAfterPasting = indexWherePastedTextHasBeenInserted + pastedText.length;
        } else if (rightPart === "") {
          caretPositionOnInitialTextAfterPasting = AutoNumericHelper.convertCharacterCountToIndexPosition(AutoNumericHelper.countNumberCharactersOnTheCaretLeftSide(initialFormattedValue, selectionStart, this.settings.decimalCharacter)) + pastedText.length;
          if (negativePasteOnNegativeNumber) caretPositionOnInitialTextAfterPasting++;
        } else {
          const indexSelectionEndInRawValue = AutoNumericHelper.convertCharacterCountToIndexPosition(AutoNumericHelper.countNumberCharactersOnTheCaretLeftSide(initialFormattedValue, selectionEnd, this.settings.decimalCharacter));
          const selectedText = AutoNumericHelper.getElementValue(eventTarget).slice(selectionStart, selectionEnd);
          caretPositionOnInitialTextAfterPasting = indexSelectionEndInRawValue - selectionSize + AutoNumericHelper.countCharInText(this.settings.digitGroupSeparator, selectedText) + pastedText.length;
        }
        if (isPasteNegativeAndInitialValueIsPositive) {
          caretPositionOnInitialTextAfterPasting++;
        }
        if (leftPartContainedADot) {
          caretPositionOnInitialTextAfterPasting--;
        }
    }
    if (!AutoNumericHelper.isNumber(result2) || result2 === "") {
      if (this.settings.onInvalidPaste === _AutoNumeric.options.onInvalidPaste.error) {
        AutoNumericHelper.throwError(`The pasted value '${rawPastedText}' would result into an invalid content '${result2}'.`);
      }
      return;
    }
    let valueHasBeenSet = false;
    let valueHasBeenClamped = false;
    try {
      this.set(result2);
      valueHasBeenSet = true;
    } catch (error2) {
      let clampedValue;
      switch (this.settings.onInvalidPaste) {
        case _AutoNumeric.options.onInvalidPaste.clamp:
          clampedValue = AutoNumericHelper.clampToRangeLimits(result2, this.settings);
          try {
            this.set(clampedValue);
          } catch (error3) {
            AutoNumericHelper.throwError(`Fatal error: Unable to set the clamped value '${clampedValue}'.`);
          }
          valueHasBeenClamped = true;
          valueHasBeenSet = true;
          result2 = clampedValue;
          break;
        case _AutoNumeric.options.onInvalidPaste.error:
        case _AutoNumeric.options.onInvalidPaste.truncate:
        case _AutoNumeric.options.onInvalidPaste.replace:
          AutoNumericHelper.throwError(`The pasted value '${rawPastedText}' results in a value '${result2}' that is outside of the minimum [${this.settings.minimumValue}] and maximum [${this.settings.maximumValue}] value range.`);
        case _AutoNumeric.options.onInvalidPaste.ignore:
        default:
          return;
      }
    }
    const targetValue = AutoNumericHelper.getElementValue(eventTarget);
    let caretPositionInFormattedNumber;
    if (valueHasBeenSet) {
      switch (this.settings.onInvalidPaste) {
        case _AutoNumeric.options.onInvalidPaste.clamp:
          if (valueHasBeenClamped) {
            if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
              AutoNumericHelper.setElementSelection(eventTarget, targetValue.length - this.settings.currencySymbol.length);
            } else {
              AutoNumericHelper.setElementSelection(eventTarget, targetValue.length);
            }
            break;
          }
        case _AutoNumeric.options.onInvalidPaste.error:
        case _AutoNumeric.options.onInvalidPaste.ignore:
        case _AutoNumeric.options.onInvalidPaste.truncate:
        case _AutoNumeric.options.onInvalidPaste.replace:
        default:
          caretPositionInFormattedNumber = AutoNumericHelper.findCaretPositionInFormattedNumber(result2, caretPositionOnInitialTextAfterPasting, targetValue, this.settings.decimalCharacter);
          AutoNumericHelper.setElementSelection(eventTarget, caretPositionInFormattedNumber);
      }
    }
    if (valueHasBeenSet && initialFormattedValue !== targetValue) {
      this._triggerEvent(_AutoNumeric.events.native.input, eventTarget);
    }
  }
  /**
   * When focusing out of the input, we check if the value has changed, and if it has, then we send a `change` event (since the native one would have been prevented by `e.preventDefault()` called in the other event listeners).
   * We also update the info of the focused state in the `this.isFocused` variable.
   *
   * @param {Event} e
   */
  _onBlur(e5) {
    this.isFocused = false;
    this.isEditing = false;
    if (AutoNumericHelper.trimPaddedZerosFromDecimalPlaces(this.rawValue) !== AutoNumericHelper.trimPaddedZerosFromDecimalPlaces(this.rawValueOnFocus)) {
      this._triggerEvent(_AutoNumeric.events.native.change, e5.target);
    }
    this.rawValueOnFocus = void 0;
  }
  /**
   * Helper function that DRY the similar behaviors of the mousewheel and up/down arrow keys, which increment/decrement the element value, either by a fixed value, or using the 'progressive' heuristic
   *
   * @param {WheelEvent|KeyboardEvent} e The `wheel` or keyboard event
   * @param {boolean} isUp Defines if the event should increment the value
   * @param {boolean} isDown Defines if the event should decrement the value
   * @param {string|number} step The step to be applied to the increment/decrement action
   * @private
   */
  _wheelAndUpDownActions(e5, isUp, isDown, step2) {
    const selectionStart = e5.target.selectionStart || 0;
    const selectionEnd = e5.target.selectionEnd || 0;
    const currentUnformattedValue = this.rawValue;
    let result2;
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(currentUnformattedValue)) {
      if (this.settings.minimumValue > 0 || this.settings.maximumValue < 0) {
        if (isUp) {
          result2 = this.settings.minimumValue;
        } else {
          result2 = this.settings.maximumValue;
        }
      } else {
        result2 = 0;
      }
    } else {
      result2 = currentUnformattedValue;
    }
    result2 = +result2;
    if (AutoNumericHelper.isNumber(step2)) {
      const stepToUse = +step2;
      if (isUp) {
        result2 += stepToUse;
      } else if (isDown) {
        result2 -= stepToUse;
      }
    } else {
      if (isUp) {
        result2 = AutoNumericHelper.addAndRoundToNearestAuto(result2, this.settings.decimalPlacesRawValue);
      } else if (isDown) {
        result2 = AutoNumericHelper.subtractAndRoundToNearestAuto(result2, this.settings.decimalPlacesRawValue);
      }
    }
    result2 = AutoNumericHelper.clampToRangeLimits(result2, this.settings);
    if (result2 !== +currentUnformattedValue) {
      this.set(result2);
      this._triggerEvent(_AutoNumeric.events.native.input, e5.target);
    }
    e5.preventDefault();
    this._setSelection(selectionStart, selectionEnd);
  }
  /**
   * Handler for up and down arrow keys
   * Increment or decrement the element value according to the `upDownStep` option chosen
   *
   * @param {KeyboardEvent} e
   */
  upDownArrowAction(e5) {
    if (this.formulaMode || this.settings.readOnly || this.domElement.readOnly || this.domElement.disabled) {
      return;
    }
    let isUp = false;
    let isDown = false;
    if (this.eventKey === AutoNumericEnum.keyName.UpArrow) {
      isUp = true;
    } else if (this.eventKey === AutoNumericEnum.keyName.DownArrow) {
      isDown = true;
    } else {
      AutoNumericHelper.throwError("Something has gone wrong since neither an Up or Down arrow key is detected, but the function was still called!");
    }
    this._wheelAndUpDownActions(e5, isUp, isDown, this.settings.upDownStep);
  }
  /**
   * Handler for 'wheel' event
   *
   * @param {WheelEvent} e
   */
  _onWheel(e5) {
    if (this.formulaMode) {
      return;
    }
    if (this.settings.readOnly || this.domElement.readOnly || this.domElement.disabled) {
      return;
    }
    if (this.settings.modifyValueOnWheel) {
      if (this.settings.wheelOn === _AutoNumeric.options.wheelOn.focus) {
        if (this.isFocused) {
          if (!e5.shiftKey) {
            this.wheelAction(e5);
          }
        } else if (e5.shiftKey) {
          this.wheelAction(e5);
        }
      } else if (this.settings.wheelOn === _AutoNumeric.options.wheelOn.hover) {
        if (!e5.shiftKey) {
          this.wheelAction(e5);
        } else {
          e5.preventDefault();
          window.scrollBy(0, AutoNumericHelper.isNegativeStrict(String(e5.deltaY)) ? -50 : 50);
        }
      } else {
        AutoNumericHelper.throwError("Unknown `wheelOn` option.");
      }
    }
  }
  /**
   * Increment or decrement the element value according to the `wheelStep` option chosen
   *
   * @param {WheelEvent} e The `wheel` event
   */
  wheelAction(e5) {
    this.isWheelEvent = true;
    let isUp = false;
    let isDown = false;
    let isDeltaYZero = false;
    if (AutoNumericHelper.isWheelUpEvent(e5)) {
      isUp = true;
    } else if (AutoNumericHelper.isWheelDownEvent(e5)) {
      isDown = true;
    } else if (AutoNumericHelper.isWheelEventWithZeroDeltaY(e5)) {
      isDeltaYZero = true;
    } else {
      AutoNumericHelper.throwError(`The event is not a 'wheel' event.`);
    }
    if (!isDeltaYZero) {
      this._wheelAndUpDownActions(e5, isUp, isDown, this.settings.wheelStep);
    }
    this.isWheelEvent = false;
  }
  /**
   * Handler for 'drop' event
   *
   * @param {DragEvent} e
   */
  _onDrop(e5) {
    if (this.formulaMode) {
      return;
    }
    this.isDropEvent = true;
    e5.preventDefault();
    const droppedText = e5.dataTransfer.getData("text/plain");
    const cleanedValue = this.unformatOther(droppedText);
    const previousValue = this.rawValue;
    this.set(cleanedValue);
    this.isDropEvent = false;
    const newValue = this.constructor._toNumericValue(cleanedValue, this.settings);
    if (!isNaN(Number(newValue))) {
      if (AutoNumericHelper.trimPaddedZerosFromDecimalPlaces(previousValue) !== AutoNumericHelper.trimPaddedZerosFromDecimalPlaces(newValue)) {
        this._triggerEvent(_AutoNumeric.events.native.change, this.domElement);
      }
    }
  }
  /**
   * Handler for 'submit' events happening on the parent <form> element.
   * If `unformatOnSubmit` is set to `true`, the element value is first unformatted before the form is submitted.
   *
   * @returns {boolean}
   */
  _onFormSubmit() {
    const inputElements = this._getFormAutoNumericChildren(this.parentForm);
    const aNElements = inputElements.map((aNElement) => this.constructor.getAutoNumericElement(aNElement));
    aNElements.forEach((aNElement) => aNElement._unformatOnSubmit());
    return true;
  }
  /**
   * Handler for 'reset' events caught on the parent <form> element.
   * When such event is detected, then every child AutoNumeric elements must format their default value that the browser is forcing upon them.
   *
   * @private
   */
  _onFormReset() {
    const inputElements = this._getFormAutoNumericChildren(this.parentForm);
    const aNElements = inputElements.map((aNElement) => this.constructor.getAutoNumericElement(aNElement));
    aNElements.forEach((aNElement) => {
      const val = this._getDefaultValue(aNElement.node());
      setTimeout(() => aNElement.set(val), 0);
    });
  }
  /**
   * Unformat the element value according to the `unformatOnSubmit` option
   *
   * @private
   */
  _unformatOnSubmit() {
    if (this.settings.unformatOnSubmit) {
      this._setElementValue(this.rawValue);
    }
  }
  /**
   * Listen for the `alt` key keydown event globally, and if the event is caught, unformat the AutoNumeric element that is hovered by the mouse.
   *
   * @param {KeyboardEvent} e
   * @private
   */
  _onKeydownGlobal(e5) {
    if (AutoNumericHelper.character(e5) === AutoNumericEnum.keyName.Alt) {
      const hoveredElement = AutoNumericHelper.getHoveredElement();
      if (_AutoNumeric.isManagedByAutoNumeric(hoveredElement)) {
        const anElement = _AutoNumeric.getAutoNumericElement(hoveredElement);
        if (!anElement.formulaMode && anElement.settings.unformatOnHover) {
          this.constructor._unformatAltHovered(anElement);
        }
      }
    }
  }
  /**
   * Listen for the `alt` key keyup event globally, and if the event is caught, reformat the AutoNumeric element that is hovered by the mouse.
   *
   * @param {KeyboardEvent} e
   * @private
   */
  _onKeyupGlobal(e5) {
    if (AutoNumericHelper.character(e5) === AutoNumericEnum.keyName.Alt) {
      const hoveredElement = AutoNumericHelper.getHoveredElement();
      if (_AutoNumeric.isManagedByAutoNumeric(hoveredElement)) {
        const anElement = _AutoNumeric.getAutoNumericElement(hoveredElement);
        if (anElement.formulaMode || !anElement.settings.unformatOnHover) {
          return;
        }
        this.constructor._reformatAltHovered(anElement);
      }
    }
  }
  /**
   * Return `true` if the DOM element is supported by autoNumeric.
   * A supported element is an element whitelisted in the `allowedTagList`.
   *
   * @returns {boolean}
   * @private
   */
  _isElementTagSupported() {
    if (!AutoNumericHelper.isElement(this.domElement)) {
      AutoNumericHelper.throwError(`The DOM element is not valid, ${this.domElement} given.`);
    }
    return AutoNumericHelper.isInArray(this.domElement.tagName.toLowerCase(), this.allowedTagList);
  }
  /**
   * Return `true` in the DOM element is an <input>.
   *
   * @returns {boolean}
   * @private
   */
  _isInputElement() {
    return this.domElement.tagName.toLowerCase() === "input";
  }
  /**
   * Return `true` if the input type is supported by AutoNumeric
   *
   * @returns {boolean}
   * @throws
   */
  _isInputTypeSupported() {
    return this.domElement.type === "text" || this.domElement.type === "hidden" || this.domElement.type === "tel" || AutoNumericHelper.isUndefinedOrNullOrEmpty(this.domElement.type);
  }
  /**
   * Check if the DOM element is supported by autoNumeric.
   * A supported element is either an <input> element with the correct 'type' attribute, or a tag whitelisted in the `allowedTagList` array.
   * If the check fails, this method throws.
   * This function also sets the info `this.isInputElement` which keep tracks if the DOM element is an <input> or not, and the `this.isContentEditable` if the element has the `contenteditable` attribute set to `true` initially.
   *
   * @throws
   * @private
   */
  _checkElement() {
    const currentElementTag = this.domElement.tagName.toLowerCase();
    if (!this._isElementTagSupported()) {
      AutoNumericHelper.throwError(`The <${currentElementTag}> tag is not supported by autoNumeric`);
    }
    if (this._isInputElement()) {
      if (!this._isInputTypeSupported()) {
        AutoNumericHelper.throwError(`The input type "${this.domElement.type}" is not supported by autoNumeric`);
      }
      this.isInputElement = true;
    } else {
      this.isInputElement = false;
      this.isContentEditable = this._isContentEditable(this.domElement);
    }
  }
  /**
   * Returns `true` if the given DOM element is a contenteditable one (set to `true`)
   *
   * @param {HTMLElement} domElement
   * @returns {boolean}
   */
  _isContentEditable(domElement) {
    return domElement.hasAttribute("contenteditable") && domElement.getAttribute("contenteditable") === "true";
  }
  /**
   * Formats the default value on page load.
   * This is called only if the `formatOnPageLoad` option is set to `true`.
   *
   * @param {number|string|null} forcedInitialValue The value that should be used for initialization, in place on the eventual html one
   */
  _formatDefaultValueOnPageLoad(forcedInitialValue = null) {
    let setValue = true;
    let currentValue;
    if (!AutoNumericHelper.isNull(forcedInitialValue)) {
      currentValue = forcedInitialValue;
    } else {
      currentValue = AutoNumericHelper.getElementValue(this.domElement).trim();
      this.domElement.setAttribute("value", currentValue);
    }
    if (this.isInputElement || this.isContentEditable) {
      const unLocalizedCurrentValue = this.constructor._toNumericValue(currentValue, this.settings);
      if (!this.domElement.hasAttribute("value") || this.domElement.getAttribute("value") === "") {
        if (!isNaN(Number(unLocalizedCurrentValue)) && Infinity !== unLocalizedCurrentValue) {
          this.set(unLocalizedCurrentValue);
          setValue = false;
        } else {
          AutoNumericHelper.throwError(`The value [${currentValue}] used in the input is not a valid value autoNumeric can work with.`);
        }
      } else {
        if (this.settings.defaultValueOverride !== null && this.settings.defaultValueOverride.toString() !== currentValue || this.settings.defaultValueOverride === null && currentValue !== "" && currentValue !== this.domElement.getAttribute("value") || currentValue !== "" && this.domElement.getAttribute("type") === "hidden" && !AutoNumericHelper.isNumber(unLocalizedCurrentValue)) {
          if (this.settings.saveValueToSessionStorage && (this.settings.decimalPlacesShownOnFocus !== null || this.settings.divisorWhenUnfocused)) {
            this._setRawValue(this._getValueFromPersistentStorage());
          }
          if (!this.settings.saveValueToSessionStorage) {
            const toStrip = this.constructor._removeBrackets(currentValue, this.settings);
            if ((this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.suffix || this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.prefix && this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) && this.settings.negativeSignCharacter !== "" && AutoNumericHelper.isNegative(currentValue, this.settings.negativeSignCharacter)) {
              this._setRawValue(`-${this.constructor._stripAllNonNumberCharacters(toStrip, this.settings, true, this.isFocused)}`);
            } else {
              this._setRawValue(this.constructor._stripAllNonNumberCharacters(toStrip, this.settings, true, this.isFocused));
            }
          }
          setValue = false;
        }
      }
      if (currentValue === "") {
        switch (this.settings.emptyInputBehavior) {
          case _AutoNumeric.options.emptyInputBehavior.focus:
          case _AutoNumeric.options.emptyInputBehavior.press:
            break;
          case _AutoNumeric.options.emptyInputBehavior.always:
            this._setElementValue(this.settings.currencySymbol);
            break;
          case _AutoNumeric.options.emptyInputBehavior.min:
            this.set(this.settings.minimumValue);
            break;
          case _AutoNumeric.options.emptyInputBehavior.max:
            this.set(this.settings.maximumValue);
            break;
          case _AutoNumeric.options.emptyInputBehavior.zero:
            this.set("0");
            break;
          case _AutoNumeric.options.emptyInputBehavior.null:
            this.set(null);
            break;
          default:
            this.set(this.settings.emptyInputBehavior);
        }
      } else if (setValue && currentValue === this.domElement.getAttribute("value")) {
        this.set(currentValue);
      }
    } else if (this.settings.defaultValueOverride === null || this.settings.defaultValueOverride === currentValue) {
      this.set(currentValue);
    }
  }
  /**
   * Enhance the user experience by modifying the default `negativePositiveSignPlacement` option depending on `currencySymbol` and `currencySymbolPlacement`.
   *
   * If the user has not set the placement of the negative sign (`negativePositiveSignPlacement`), but has set a currency symbol (`currencySymbol`),
   * then we modify the default value of `negativePositiveSignPlacement` in order to keep the resulting output logical by default :
   * - "$-1,234.56" instead of "-$1,234.56" ({currencySymbol: "$", negativePositiveSignPlacement: "r"})
   * - "-1,234.56$" instead of "1,234.56-$" ({currencySymbol: "$", currencySymbolPlacement: "s", negativePositiveSignPlacement: "p"})
   *
   * @param {object} settings
   */
  static _correctNegativePositiveSignPlacementOption(settings) {
    if (!AutoNumericHelper.isNull(settings.negativePositiveSignPlacement)) {
      return;
    }
    if (!AutoNumericHelper.isUndefined(settings) && AutoNumericHelper.isUndefinedOrNullOrEmpty(settings.negativePositiveSignPlacement) && !AutoNumericHelper.isUndefinedOrNullOrEmpty(settings.currencySymbol)) {
      switch (settings.currencySymbolPlacement) {
        case _AutoNumeric.options.currencySymbolPlacement.suffix:
          settings.negativePositiveSignPlacement = _AutoNumeric.options.negativePositiveSignPlacement.prefix;
          break;
        case _AutoNumeric.options.currencySymbolPlacement.prefix:
          settings.negativePositiveSignPlacement = _AutoNumeric.options.negativePositiveSignPlacement.left;
          break;
      }
    } else {
      settings.negativePositiveSignPlacement = _AutoNumeric.options.negativePositiveSignPlacement.left;
    }
  }
  /**
   * Correct the `caretPositionOnFocus` and `selectOnFocus` options, since setting both leads to a conflict.
   * This method directly modifies the `options` object passed as a parameter, then returns it.
   * It returns `null` if the given option is `null`.
   *
   * @param {object} options The options passed as an argument by the user
   * @returns {object|null}
   * @private
   */
  static _correctCaretPositionOnFocusAndSelectOnFocusOptions(options) {
    if (AutoNumericHelper.isNull(options)) {
      return null;
    }
    if (!AutoNumericHelper.isUndefinedOrNullOrEmpty(options.caretPositionOnFocus) && AutoNumericHelper.isUndefinedOrNullOrEmpty(options.selectOnFocus)) {
      options.selectOnFocus = _AutoNumeric.options.selectOnFocus.doNotSelect;
    }
    if (AutoNumericHelper.isUndefinedOrNullOrEmpty(options.caretPositionOnFocus) && !AutoNumericHelper.isUndefinedOrNullOrEmpty(options.selectOnFocus) && options.selectOnFocus === _AutoNumeric.options.selectOnFocus.select) {
      options.caretPositionOnFocus = _AutoNumeric.options.caretPositionOnFocus.doNoForceCaretPosition;
    }
    return options;
  }
  /**
   * Calculate the number de decimal places to be used by the AutoNumeric object, for each of its state, and for its formatted and raw value.
   * By default, the `rawValue` precision is the same as the formatted value one.
   *
   * This method is called during the AutoNumeric object initialization. This assumes some internal variable state.
   *
   * This method set the following options accordingly to their own value and the mandatory `decimalPlaces` option:
   * - decimalPlacesRawValue     (nullable)
   * - decimalPlacesShownOnBlur  (nullable)
   * - decimalPlacesShownOnFocus (nullable)
   *
   * Note: the `decimalPlaces` option is only used here and only serve to define those three previous options value.
   * AutoNumeric will then *only* use `decimalPlacesRawValue`, `decimalPlacesShownOnBlur` and `decimalPlacesShownOnFocus` from there.
   *
   * This method directly modifies the `settings` object passed as a parameter.
   *
   * @param {object} settings This is an object with the new settings to use.
   * @private
   */
  static _calculateDecimalPlacesOnInit(settings) {
    this._validateDecimalPlacesRawValue(settings);
    if (settings.decimalPlacesShownOnFocus === _AutoNumeric.options.decimalPlacesShownOnFocus.useDefault) {
      settings.decimalPlacesShownOnFocus = settings.decimalPlaces;
    }
    if (settings.decimalPlacesShownOnBlur === _AutoNumeric.options.decimalPlacesShownOnBlur.useDefault) {
      settings.decimalPlacesShownOnBlur = settings.decimalPlaces;
    }
    if (settings.decimalPlacesRawValue === _AutoNumeric.options.decimalPlacesRawValue.useDefault) {
      settings.decimalPlacesRawValue = settings.decimalPlaces;
    }
    let additionalDecimalPlacesRawValue = 0;
    if (settings.rawValueDivisor && settings.rawValueDivisor !== _AutoNumeric.options.rawValueDivisor.none) {
      additionalDecimalPlacesRawValue = String(settings.rawValueDivisor).length - 1;
      if (additionalDecimalPlacesRawValue < 0) {
        additionalDecimalPlacesRawValue = 0;
      }
    }
    settings.decimalPlacesRawValue = Math.max(
      Math.max(settings.decimalPlacesShownOnBlur, settings.decimalPlacesShownOnFocus) + additionalDecimalPlacesRawValue,
      Number(settings.originalDecimalPlacesRawValue) + additionalDecimalPlacesRawValue
    );
  }
  /**
   * Recalculate the number de decimal places to be used by the AutoNumeric object, for each of its state, and for its formatted and raw value.
   * By default, the `rawValue` precision is the same as the formatted value one.
   *
   * This method is close to the one called during initialization, `_calculateDecimalPlacesOnInit()`, but with slight difference so that the `decimalPlaces*` options are correctly updated as needed.
   *
   * This methods set the following options accordingly to their own value and the mandatory `decimalPlaces` option:
   * - decimalPlacesRawValue     (nullable)
   * - decimalPlacesShownOnBlur  (nullable)
   * - decimalPlacesShownOnFocus (nullable)
   *
   * Note: the `decimalPlaces` option is only used here and only serve to define those three previous options value.
   * AutoNumeric will then *only* use `decimalPlacesRawValue`, `decimalPlacesShownOnBlur` and `decimalPlacesShownOnFocus` from there.
   *
   * This methods directly modifies the `settings` object passed as a parameter.
   *
   * @param {object} settings This is an object with the new settings to use.
   * @param {object} currentSettings This is the current settings (`this.settings`) used by the element.
   * @private
   */
  static _calculateDecimalPlacesOnUpdate(settings, currentSettings = null) {
    this._validateDecimalPlacesRawValue(settings);
    if (AutoNumericHelper.isNull(currentSettings)) {
      AutoNumericHelper.throwError(`When updating the settings, the previous ones should be passed as an argument.`);
    }
    const decimalPlacesInOptions = "decimalPlaces" in settings;
    if (!(decimalPlacesInOptions || "decimalPlacesRawValue" in settings || "decimalPlacesShownOnFocus" in settings || "decimalPlacesShownOnBlur" in settings || "rawValueDivisor" in settings)) {
      return;
    }
    if (decimalPlacesInOptions) {
      if (!("decimalPlacesShownOnFocus" in settings) || settings.decimalPlacesShownOnFocus === _AutoNumeric.options.decimalPlacesShownOnFocus.useDefault) {
        settings.decimalPlacesShownOnFocus = settings.decimalPlaces;
      }
      if (!("decimalPlacesShownOnBlur" in settings) || settings.decimalPlacesShownOnBlur === _AutoNumeric.options.decimalPlacesShownOnBlur.useDefault) {
        settings.decimalPlacesShownOnBlur = settings.decimalPlaces;
      }
      if (!("decimalPlacesRawValue" in settings) || settings.decimalPlacesRawValue === _AutoNumeric.options.decimalPlacesRawValue.useDefault) {
        settings.decimalPlacesRawValue = settings.decimalPlaces;
      }
    } else {
      if (AutoNumericHelper.isUndefined(settings.decimalPlacesShownOnFocus)) {
        settings.decimalPlacesShownOnFocus = currentSettings.decimalPlacesShownOnFocus;
      }
      if (AutoNumericHelper.isUndefined(settings.decimalPlacesShownOnBlur)) {
        settings.decimalPlacesShownOnBlur = currentSettings.decimalPlacesShownOnBlur;
      }
    }
    let additionalDecimalPlacesRawValue = 0;
    if (settings.rawValueDivisor && settings.rawValueDivisor !== _AutoNumeric.options.rawValueDivisor.none) {
      additionalDecimalPlacesRawValue = String(settings.rawValueDivisor).length - 1;
      if (additionalDecimalPlacesRawValue < 0) {
        additionalDecimalPlacesRawValue = 0;
      }
    }
    if (!settings.decimalPlaces && !settings.decimalPlacesRawValue) {
      settings.decimalPlacesRawValue = Math.max(
        Math.max(settings.decimalPlacesShownOnBlur, settings.decimalPlacesShownOnFocus) + additionalDecimalPlacesRawValue,
        Number(currentSettings.originalDecimalPlacesRawValue) + additionalDecimalPlacesRawValue
      );
    } else {
      settings.decimalPlacesRawValue = Math.max(
        Math.max(settings.decimalPlacesShownOnBlur, settings.decimalPlacesShownOnFocus) + additionalDecimalPlacesRawValue,
        Number(settings.decimalPlacesRawValue) + additionalDecimalPlacesRawValue
      );
    }
  }
  /**
   * Analyze and save the minimumValue and maximumValue integer size for later uses
   * @private
   */
  _calculateVMinAndVMaxIntegerSizes() {
    let [maximumValueIntegerPart] = this.settings.maximumValue.toString().split(".");
    let [minimumValueIntegerPart] = !this.settings.minimumValue && this.settings.minimumValue !== 0 ? [] : this.settings.minimumValue.toString().split(".");
    maximumValueIntegerPart = maximumValueIntegerPart.replace(this.settings.negativeSignCharacter, "");
    minimumValueIntegerPart = minimumValueIntegerPart.replace(this.settings.negativeSignCharacter, "");
    this.settings.mIntPos = Math.max(maximumValueIntegerPart.length, 1);
    this.settings.mIntNeg = Math.max(minimumValueIntegerPart.length, 1);
  }
  /**
   * Calculate once what are the `valuesToStrings` option keys.
   * @private
   */
  _calculateValuesToStringsKeys() {
    if (this.settings.valuesToStrings) {
      this.valuesToStringsKeys = Object.keys(this.settings.valuesToStrings);
    } else {
      this.valuesToStringsKeys = [];
    }
  }
  /**
   * Caches regular expressions for _stripAllNonNumberCharactersExceptCustomDecimalChar
   *
   * @param {object} settings
   * @param {object} regex
   */
  static _cachesUsualRegularExpressions(settings, regex2) {
    let negativeSignReg;
    if (settings.negativeSignCharacter !== _AutoNumeric.options.negativeSignCharacter.hyphen) {
      negativeSignReg = `([-\\${settings.negativeSignCharacter}]?)`;
    } else {
      negativeSignReg = "(-?)";
    }
    regex2.aNegRegAutoStrip = negativeSignReg;
    settings.allowedAutoStrip = new RegExp(`[^-0123456789\\${settings.decimalCharacter}]`, "g");
    settings.numRegAutoStrip = new RegExp(`${negativeSignReg}(?:\\${settings.decimalCharacter}?([0-9]+\\${settings.decimalCharacter}[0-9]+)|([0-9]*(?:\\${settings.decimalCharacter}[0-9]*)?))`);
    settings.stripReg = new RegExp(`^${regex2.aNegRegAutoStrip}0*([0-9])`);
    settings.formulaChars = new RegExp(`[0-9${settings.decimalCharacter}+\\-*/() ]`);
  }
  /**
   * Modify the user settings to make them 'exploitable' later.
   */
  _transformOptionsValuesToDefaultTypes() {
    for (const key2 in this.settings) {
      if (Object.prototype.hasOwnProperty.call(this.settings, key2)) {
        const value = this.settings[key2];
        if (value === "true" || value === "false") {
          this.settings[key2] = value === "true";
        }
        if (typeof value === "number") {
          this.settings[key2] = value.toString();
        }
      }
    }
  }
  /**
   * Convert the old settings options name to new ones.
   *
   * @param {object} options
   */
  static _convertOldOptionsToNewOnes(options) {
    const oldOptionsConverter = {
      // Old option names, with their corresponding new names
      aSep: "digitGroupSeparator",
      nSep: "showOnlyNumbersOnFocus",
      dGroup: "digitalGroupSpacing",
      aDec: "decimalCharacter",
      altDec: "decimalCharacterAlternative",
      aSign: "currencySymbol",
      pSign: "currencySymbolPlacement",
      pNeg: "negativePositiveSignPlacement",
      aSuffix: "suffixText",
      oLimits: "overrideMinMaxLimits",
      vMax: "maximumValue",
      vMin: "minimumValue",
      mDec: "decimalPlacesOverride",
      eDec: "decimalPlacesShownOnFocus",
      scaleDecimal: "decimalPlacesShownOnBlur",
      aStor: "saveValueToSessionStorage",
      mRound: "roundingMethod",
      aPad: "allowDecimalPadding",
      nBracket: "negativeBracketsTypeOnBlur",
      wEmpty: "emptyInputBehavior",
      lZero: "leadingZero",
      aForm: "formatOnPageLoad",
      sNumber: "selectNumberOnly",
      anDefault: "defaultValueOverride",
      unSetOnSubmit: "unformatOnSubmit",
      outputType: "outputFormat",
      debug: "showWarnings",
      // Current options :
      allowDecimalPadding: true,
      alwaysAllowDecimalCharacter: true,
      caretPositionOnFocus: true,
      createLocalList: true,
      currencySymbol: true,
      currencySymbolPlacement: true,
      decimalCharacter: true,
      decimalCharacterAlternative: true,
      decimalPlaces: true,
      decimalPlacesRawValue: true,
      decimalPlacesShownOnBlur: true,
      decimalPlacesShownOnFocus: true,
      defaultValueOverride: true,
      digitalGroupSpacing: true,
      digitGroupSeparator: true,
      divisorWhenUnfocused: true,
      emptyInputBehavior: true,
      eventBubbles: true,
      eventIsCancelable: true,
      failOnUnknownOption: true,
      formatOnPageLoad: true,
      formulaMode: true,
      historySize: true,
      isCancellable: true,
      leadingZero: true,
      maximumValue: true,
      minimumValue: true,
      modifyValueOnUpDownArrow: true,
      modifyValueOnWheel: true,
      negativeBracketsTypeOnBlur: true,
      negativePositiveSignPlacement: true,
      negativeSignCharacter: true,
      negativePositiveSignBehavior: true,
      noEventListeners: true,
      onInvalidPaste: true,
      outputFormat: true,
      overrideMinMaxLimits: true,
      positiveSignCharacter: true,
      rawValueDivisor: true,
      readOnly: true,
      roundingMethod: true,
      saveValueToSessionStorage: true,
      selectNumberOnly: true,
      selectOnFocus: true,
      serializeSpaces: true,
      showOnlyNumbersOnFocus: true,
      showPositiveSign: true,
      showWarnings: true,
      styleRules: true,
      suffixText: true,
      symbolWhenUnfocused: true,
      upDownStep: true,
      unformatOnHover: true,
      unformatOnSubmit: true,
      valuesToStrings: true,
      watchExternalChanges: true,
      wheelOn: true,
      wheelStep: true,
      // Additional information that are added to the `settings` object :
      //TODO Find a way to exclude those internal data from the settings object (ideally by using another object, or better yet, class attributes) -->
      allowedAutoStrip: true,
      formulaChars: true,
      isNegativeSignAllowed: true,
      isPositiveSignAllowed: true,
      mIntNeg: true,
      mIntPos: true,
      numRegAutoStrip: true,
      originalDecimalPlaces: true,
      originalDecimalPlacesRawValue: true,
      stripReg: true
    };
    for (const option2 in options) {
      if (Object.prototype.hasOwnProperty.call(options, option2)) {
        if (oldOptionsConverter[option2] === true) {
          continue;
        }
        if (Object.prototype.hasOwnProperty.call(oldOptionsConverter, option2)) {
          AutoNumericHelper.warning(`You are using the deprecated option name '${option2}'. Please use '${oldOptionsConverter[option2]}' instead from now on. The old option name will be dropped very soon™.`, true);
          options[oldOptionsConverter[option2]] = options[option2];
          delete options[option2];
        } else if (options.failOnUnknownOption) {
          AutoNumericHelper.throwError(`Option name '${option2}' is unknown. Please fix the options passed to autoNumeric`);
        }
      }
    }
    if ("mDec" in options) {
      AutoNumericHelper.warning("The old `mDec` option has been deprecated in favor of more accurate options ; `decimalPlaces`, `decimalPlacesRawValue`, `decimalPlacesShownOnFocus` and `decimalPlacesShownOnBlur`.", true);
    }
  }
  /**
   * Analyse the settings/options passed by the user, validate and clean them, then set them into `this.settings`.
   * Note: This sets the settings to `null` if somehow the settings objet is undefined or empty
   *       If only `decimalPlaces` is defined in the option, overwrite the other decimalPlaces* options, otherwise, use those options
   *
   * @param {object} options
   * @param {boolean} update - If set to `true`, then the settings already exists and this function only updates them instead of recreating them from scratch
   * @throws
   */
  _setSettings(options, update2 = false) {
    if (update2 || !AutoNumericHelper.isNull(options)) {
      this.constructor._convertOldOptionsToNewOnes(options);
    }
    if (update2) {
      const decimalPlacesRawValueInOptions = "decimalPlacesRawValue" in options;
      if (decimalPlacesRawValueInOptions) {
        this.settings.originalDecimalPlacesRawValue = options.decimalPlacesRawValue;
      }
      const decimalPlacesInOptions = "decimalPlaces" in options;
      if (decimalPlacesInOptions) {
        this.settings.originalDecimalPlaces = options.decimalPlaces;
      }
      this.constructor._calculateDecimalPlacesOnUpdate(options, this.settings);
      this._mergeSettings(options);
    } else {
      this.settings = {};
      this._mergeSettings(this.constructor.getDefaultConfig(), this.domElement.dataset, options, { rawValue: this.defaultRawValue });
      this.caretFix = false;
      this.throwInput = true;
      this.allowedTagList = AutoNumericEnum.allowedTagList;
      this.runOnce = false;
      this.hoveredWithAlt = false;
    }
    this._transformOptionsValuesToDefaultTypes();
    this._runCallbacksFoundInTheSettingsObject();
    this.constructor._correctNegativePositiveSignPlacementOption(this.settings);
    this.constructor._correctCaretPositionOnFocusAndSelectOnFocusOptions(this.settings);
    this.constructor._setNegativePositiveSignPermissions(this.settings);
    if (!update2) {
      if (AutoNumericHelper.isNull(options) || !options.decimalPlaces) {
        this.settings.originalDecimalPlaces = null;
      } else {
        this.settings.originalDecimalPlaces = options.decimalPlaces;
      }
      this.settings.originalDecimalPlacesRawValue = this.settings.decimalPlacesRawValue;
      this.constructor._calculateDecimalPlacesOnInit(this.settings);
    }
    this._calculateVMinAndVMaxIntegerSizes();
    this._setTrailingNegativeSignInfo();
    this.regex = {};
    this.constructor._cachesUsualRegularExpressions(this.settings, this.regex);
    this.constructor._setBrackets(this.settings);
    this._calculateValuesToStringsKeys();
    if (AutoNumericHelper.isEmptyObj(this.settings)) {
      AutoNumericHelper.throwError("Unable to set the settings, those are invalid ; an empty object was given.");
    }
    this.constructor.validate(this.settings, false, options);
    this._keepAnOriginalSettingsCopy();
  }
  /**
   * Define if the negative or positive signs are allowed, and update the given settings object directly.
   *
   * @param {object} settings
   * @private
   */
  static _setNegativePositiveSignPermissions(settings) {
    settings.isNegativeSignAllowed = settings.minimumValue < 0;
    settings.isPositiveSignAllowed = settings.maximumValue >= 0;
  }
  /**
   * Convert the `value` parameter that can either be :
   * - a real number,
   * - a number represented in the scientific notation (i.e. -123.4567e-6)
   * - a string representing a real number, or
   * - a string representing a localized number (with specific group separators and decimal character),
   * ...to a string representing a real 'javascript' number (i.e. '1234' or '1234.567').
   *
   * This function returns `NaN` if such conversion fails.
   *
   * @param {int|float|string} value
   * @param {object} settings
   * @returns {string|NaN}
   */
  static _toNumericValue(value, settings) {
    let result2;
    if (AutoNumericHelper.isNumber(Number(value))) {
      if (!AutoNumericHelper.isNumberStrict(value)) {
        value = String(value).trim();
      }
      result2 = AutoNumericHelper.scientificToDecimal(value);
    } else {
      result2 = this._convertToNumericString(value.toString(), settings);
      if (!AutoNumericHelper.isNumber(Number(result2))) {
        AutoNumericHelper.warning(`The given value "${value}" cannot be converted to a numeric one and therefore cannot be used appropriately.`, settings.showWarnings);
        result2 = NaN;
      }
    }
    return result2;
  }
  /**
   * Return the pasted text that will be used, by stripping most non-numeric characters
   *
   * @param {string} text
   * @returns {string}
   */
  _preparePastedText(text) {
    return this.constructor._stripAllNonNumberCharacters(text, this.settings, true, this.isFocused);
  }
  /**
   * Return TRUE if the given value (a number as a string) is within the range set in the settings `minimumValue` and `maximumValue`, FALSE otherwise.
   *
   * @param {string} value
   * @param {object} parsedMinValue Parsed via the `parseStr()` function
   * @param {object} parsedMaxValue Parsed via the `parseStr()` function
   * @returns {boolean}
   */
  static _checkIfInRange(value, parsedMinValue, parsedMaxValue) {
    const parsedValue = AutoNumericHelper.parseStr(value);
    return AutoNumericHelper.testMinMax(parsedMinValue, parsedValue) > -1 && AutoNumericHelper.testMinMax(parsedMaxValue, parsedValue) < 1;
  }
  /**
   * Update the selection values as well as resets the internal state of the current AutoNumeric object.
   * This keeps tracks of the current selection and resets the 'processed' state.
   *
   * Note : This state can change between the keydown, keypress and keyup events, that's why
   *        this function is called on each event handler.
   *
   * @private
   */
  _updateInternalProperties() {
    this.selection = AutoNumericHelper.getElementSelection(this.domElement);
    this.processed = false;
  }
  /**
   * Update the `event.key` attribute that triggered the given event.
   *
   * `event.key` describes:
   * - the key name (if a non-printable character),
   * - or directly the character that result from the key press used to trigger the event.
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
   * The key list is described here:
   * @link https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
   *
   * @param {Event|KeyboardEvent} e
   * @private
   */
  _updateEventKeyInfo(e5) {
    this.eventKey = AutoNumericHelper.character(e5);
  }
  /**
   * Save the unformatted element value.
   * This is used in the 'cancellable' feature where the element value is saved on focus and input validation, to be used if the user wants to cancel his modifications by hitting the 'Escape' key.
   *
   * @private
   */
  _saveCancellableValue() {
    this.savedCancellableValue = this.rawValue;
  }
  /**
   * Set the text selection inside the input with the given start and end position.
   *
   * @param {int} start
   * @param {int} end
   * @private
   */
  _setSelection(start2, end2) {
    start2 = Math.max(start2, 0);
    end2 = Math.min(end2, AutoNumericHelper.getElementValue(this.domElement).length);
    this.selection = {
      start: start2,
      end: end2,
      length: end2 - start2
    };
    AutoNumericHelper.setElementSelection(this.domElement, start2, end2);
  }
  /**
   * Set the caret position inside the input at the given position.
   *
   * @param {int} position
   * @private
   */
  _setCaretPosition(position2) {
    this._setSelection(position2, position2);
  }
  /**
   * Return an array containing the string parts located on the left and right side of the caret or selection.
   * Those parts are left 'untouched', i.e. formatted by autoNumeric.
   *
   * @returns {[string, string]} The parts on the left and right of the caret or selection
   * @private
   */
  _getLeftAndRightPartAroundTheSelection() {
    const value = AutoNumericHelper.getElementValue(this.domElement);
    const left = value.substring(0, this.selection.start);
    const right = value.substring(this.selection.end, value.length);
    return [left, right];
  }
  /**
   * Return an array containing the string parts located on the left and right side of the caret or selection.
   * Those parts are unformatted (stripped) of any non-numbers characters, and any trailing negative character is put back on the left hand side of the number.
   *
   * @returns {[string, string]} The parts on the left and right of the caret or selection, unformatted.
   * @private
   */
  _getUnformattedLeftAndRightPartAroundTheSelection() {
    let [left, right] = this._getLeftAndRightPartAroundTheSelection();
    if (left === "" && right === "") {
      return ["", ""];
    }
    let stripZeros = true;
    if ((this.eventKey === AutoNumericEnum.keyName.Hyphen || this.eventKey === AutoNumericEnum.keyName.Minus) && Number(left) === 0) {
      stripZeros = false;
    }
    if (this.isTrailingNegative && (AutoNumericHelper.isNegative(right, this.settings.negativeSignCharacter) && // The caret is placed on the left of the negative sign
    !AutoNumericHelper.isNegative(left, this.settings.negativeSignCharacter) || right === "" && // ...or the caret is placed on the far right of the input (Fix issue #481)
    AutoNumericHelper.isNegative(left, this.settings.negativeSignCharacter, true))) {
      left = left.replace(this.settings.negativeSignCharacter, "");
      right = right.replace(this.settings.negativeSignCharacter, "");
      left = left.replace("-", "");
      right = right.replace("-", "");
      left = `-${left}`;
    }
    left = _AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(left, this.settings, stripZeros, this.isFocused);
    right = _AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(right, this.settings, false, this.isFocused);
    return [left, right];
  }
  /**
   * Strip parts from excess characters and leading zeros.
   *
   * @param {string} left
   * @param {string} right
   * @returns {[*,*,*]}
   * @private
   */
  _normalizeParts(left, right) {
    let stripZeros = true;
    if ((this.eventKey === AutoNumericEnum.keyName.Hyphen || this.eventKey === AutoNumericEnum.keyName.Minus) && Number(left) === 0) {
      stripZeros = false;
    }
    if (this.isTrailingNegative && AutoNumericHelper.isNegative(right, this.settings.negativeSignCharacter) && !AutoNumericHelper.isNegative(left, this.settings.negativeSignCharacter)) {
      left = `-${left}`;
      right = right.replace(this.settings.negativeSignCharacter, "");
    }
    left = _AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(left, this.settings, stripZeros, this.isFocused);
    right = _AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(right, this.settings, false, this.isFocused);
    if (this.settings.leadingZero === _AutoNumeric.options.leadingZero.deny && (this.eventKey === AutoNumericEnum.keyName.num0 || this.eventKey === AutoNumericEnum.keyName.numpad0) && Number(left) === 0 && // If `right` is not empty and the first character is not `decimalCharacter`
    !AutoNumericHelper.contains(left, this.settings.decimalCharacter) && right !== "") {
      left = left.substring(0, left.length - 1);
    }
    let newValue = left + right;
    if (this.settings.decimalCharacter) {
      const m4 = newValue.match(new RegExp(`^${this.regex.aNegRegAutoStrip}\\${this.settings.decimalCharacter}`));
      if (m4) {
        left = left.replace(m4[1], m4[1] + "0");
        newValue = left + right;
      }
    }
    return [left, right, newValue];
  }
  /**
   * Set the formatted element value as well as the `rawValue`.
   * This returns `true` if the element and raw value have been modified, `false` otherwise.
   * This method also adjust the caret position according to the `leadingZero` option and the normalized value. //TODO What about the cursor *selection*?
   *
   * @param {string} left
   * @param {string} right
   * @param {boolean} isPaste
   * @returns {boolean}
   * @private
   */
  _setValueParts(left, right, isPaste = false) {
    const [normalizedLeft, normalizedRight, normalizedNewValue] = this._normalizeParts(left, right);
    const [minTest, maxTest] = _AutoNumeric._checkIfInRangeWithOverrideOption(normalizedNewValue, this.settings);
    if (minTest && maxTest) {
      const roundedRawValue = _AutoNumeric._truncateDecimalPlaces(normalizedNewValue, this.settings, isPaste, this.settings.decimalPlacesRawValue);
      const testValue = roundedRawValue.replace(this.settings.decimalCharacter, ".");
      if (testValue === "" || testValue === this.settings.negativeSignCharacter) {
        let valueToSetOnEmpty;
        switch (this.settings.emptyInputBehavior) {
          case _AutoNumeric.options.emptyInputBehavior.focus:
          case _AutoNumeric.options.emptyInputBehavior.press:
          case _AutoNumeric.options.emptyInputBehavior.always:
            valueToSetOnEmpty = "";
            break;
          case _AutoNumeric.options.emptyInputBehavior.min:
            valueToSetOnEmpty = this.settings.minimumValue;
            break;
          case _AutoNumeric.options.emptyInputBehavior.max:
            valueToSetOnEmpty = this.settings.maximumValue;
            break;
          case _AutoNumeric.options.emptyInputBehavior.zero:
            valueToSetOnEmpty = "0";
            break;
          case _AutoNumeric.options.emptyInputBehavior.null:
            valueToSetOnEmpty = null;
            break;
          default:
            valueToSetOnEmpty = this.settings.emptyInputBehavior;
        }
        this._setRawValue(valueToSetOnEmpty);
      } else {
        this._setRawValue(this._trimLeadingAndTrailingZeros(testValue));
      }
      const roundedValueToShow = _AutoNumeric._truncateDecimalPlaces(normalizedNewValue, this.settings, isPaste, this.settings.decimalPlacesShownOnFocus);
      let position2 = normalizedLeft.length;
      if (position2 > roundedValueToShow.length) {
        position2 = roundedValueToShow.length;
      }
      if (position2 === 1 && normalizedLeft === "0" && this.settings.leadingZero === _AutoNumeric.options.leadingZero.deny) {
        if (normalizedRight === "" || normalizedLeft === "0" && normalizedRight !== "") {
          position2 = 1;
        } else {
          position2 = 0;
        }
      }
      this._setElementValue(roundedValueToShow, false);
      this._setCaretPosition(position2);
      return true;
    }
    this._triggerRangeEvents(minTest, maxTest);
    return false;
  }
  /**
   * Helper function for `_expandSelectionOnSign()`.
   *
   * @returns {Array} Array containing [signPosition, currencySymbolPosition] of a formatted value
   * @private
   */
  _getSignPosition() {
    let result2;
    if (this.settings.currencySymbol) {
      const currencySymbolLen = this.settings.currencySymbol.length;
      const value = AutoNumericHelper.getElementValue(this.domElement);
      if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix) {
        const hasNeg = this.settings.negativeSignCharacter && value && value.charAt(0) === this.settings.negativeSignCharacter;
        if (hasNeg) {
          result2 = [1, currencySymbolLen + 1];
        } else {
          result2 = [0, currencySymbolLen];
        }
      } else {
        const valueLen = value.length;
        result2 = [valueLen - currencySymbolLen, valueLen];
      }
    } else {
      result2 = [1e3, -1];
    }
    return result2;
  }
  /**
   * Expands selection to cover whole sign
   * Prevents partial deletion/copying/overwriting of a sign
   * @private
   */
  _expandSelectionOnSign() {
    const [signPosition, currencySymbolPosition] = this._getSignPosition();
    const selection = this.selection;
    if (selection.start < currencySymbolPosition && selection.end > signPosition) {
      if ((selection.start < signPosition || selection.end > currencySymbolPosition) && AutoNumericHelper.getElementValue(this.domElement).substring(Math.max(selection.start, signPosition), Math.min(selection.end, currencySymbolPosition)).match(/^\s*$/)) {
        if (selection.start < signPosition) {
          this._setSelection(selection.start, signPosition);
        } else {
          this._setSelection(currencySymbolPosition, selection.end);
        }
      } else {
        this._setSelection(Math.min(selection.start, signPosition), Math.max(selection.end, currencySymbolPosition));
      }
    }
  }
  /**
   * Try to strip pasted value to digits
   */
  _checkPaste() {
    if (this.formatted) {
      return;
    }
    if (!AutoNumericHelper.isUndefined(this.valuePartsBeforePaste)) {
      const oldParts = this.valuePartsBeforePaste;
      const [left, right] = this._getLeftAndRightPartAroundTheSelection();
      delete this.valuePartsBeforePaste;
      const modifiedLeftPart = left.substr(0, oldParts[0].length) + _AutoNumeric._stripAllNonNumberCharactersExceptCustomDecimalChar(left.substr(oldParts[0].length), this.settings, true, this.isFocused);
      if (!this._setValueParts(modifiedLeftPart, right, true)) {
        this._setElementValue(oldParts.join(""), false);
        this._setCaretPosition(oldParts[0].length);
      }
    }
  }
  /**
   * Return `true` if the given key should be ignored or not.
   *
   * @param {string} eventKeyName
   * @returns {boolean}
   * @private
   */
  static _shouldSkipEventKey(eventKeyName) {
    const isFnKeys = AutoNumericHelper.isInArray(eventKeyName, AutoNumericEnum.keyName._allFnKeys);
    const isOSKeys = eventKeyName === AutoNumericEnum.keyName.OSLeft || eventKeyName === AutoNumericEnum.keyName.OSRight;
    const isContextMenu = eventKeyName === AutoNumericEnum.keyName.ContextMenu;
    const isSomeNonPrintableKeys = AutoNumericHelper.isInArray(eventKeyName, AutoNumericEnum.keyName._someNonPrintableKeys);
    const isOtherNonPrintableKeys = eventKeyName === AutoNumericEnum.keyName.NumLock || eventKeyName === AutoNumericEnum.keyName.ScrollLock || eventKeyName === AutoNumericEnum.keyName.Insert || eventKeyName === AutoNumericEnum.keyName.Command;
    const isUnrecognizableKeys = eventKeyName === AutoNumericEnum.keyName.Unidentified;
    return isFnKeys || isOSKeys || isContextMenu || isSomeNonPrintableKeys || isUnrecognizableKeys || isOtherNonPrintableKeys;
  }
  /**
   * Process copying, cutting and pasting, as well as undo/redoing and cursor moving.
   * Return `true` if further processing should not be performed.
   *
   * @param {KeyboardEvent} e
   * @returns {boolean}
   * @private
   */
  _processNonPrintableKeysAndShortcuts(e5) {
    if ((e5.ctrlKey || e5.metaKey) && e5.type === "keyup" && !AutoNumericHelper.isUndefined(this.valuePartsBeforePaste) || e5.shiftKey && this.eventKey === AutoNumericEnum.keyName.Insert) {
      this._checkPaste();
      return false;
    }
    if (this.constructor._shouldSkipEventKey(this.eventKey)) {
      return true;
    }
    if ((e5.ctrlKey || e5.metaKey) && this.eventKey === AutoNumericEnum.keyName.a) {
      if (this.settings.selectNumberOnly) {
        e5.preventDefault();
        this.selectNumber();
      }
      return true;
    }
    if ((e5.ctrlKey || e5.metaKey) && (this.eventKey === AutoNumericEnum.keyName.c || this.eventKey === AutoNumericEnum.keyName.v || this.eventKey === AutoNumericEnum.keyName.x)) {
      if (e5.type === "keydown") {
        this._expandSelectionOnSign();
      }
      if (this.eventKey === AutoNumericEnum.keyName.v || this.eventKey === AutoNumericEnum.keyName.Insert) {
        if (e5.type === "keydown" || e5.type === "keypress") {
          if (AutoNumericHelper.isUndefined(this.valuePartsBeforePaste)) {
            this.valuePartsBeforePaste = this._getLeftAndRightPartAroundTheSelection();
          }
        } else {
          this._checkPaste();
        }
      }
      return e5.type === "keydown" || e5.type === "keypress" || this.eventKey === AutoNumericEnum.keyName.c;
    }
    if (e5.ctrlKey || e5.metaKey) {
      return !(this.eventKey === AutoNumericEnum.keyName.Z || this.eventKey === AutoNumericEnum.keyName.z);
    }
    if (this.eventKey === AutoNumericEnum.keyName.LeftArrow || this.eventKey === AutoNumericEnum.keyName.RightArrow) {
      if (e5.type === "keydown" && !e5.shiftKey) {
        const value = AutoNumericHelper.getElementValue(this.domElement);
        if (this.eventKey === AutoNumericEnum.keyName.LeftArrow && (value.charAt(this.selection.start - 2) === this.settings.digitGroupSeparator || value.charAt(this.selection.start - 2) === this.settings.decimalCharacter)) {
          this._setCaretPosition(this.selection.start - 1);
        } else if (this.eventKey === AutoNumericEnum.keyName.RightArrow && (value.charAt(this.selection.start + 1) === this.settings.digitGroupSeparator || value.charAt(this.selection.start + 1) === this.settings.decimalCharacter)) {
          this._setCaretPosition(this.selection.start + 1);
        }
      }
      return true;
    }
    return AutoNumericHelper.isInArray(this.eventKey, AutoNumericEnum.keyName._directionKeys);
  }
  /**
   * Process deletion of characters when the minus sign is to the right of the numeric characters.
   *
   * @param {string[]} leftAndRight The parts on the left and on the right of the caret or selection as an array with [left, right]
   * @returns {string[]} Processed left and right as an array with [left, right]
   * @private
   */
  _processCharacterDeletionIfTrailingNegativeSign([left, right]) {
    const value = AutoNumericHelper.getElementValue(this.domElement);
    const isValNegative = AutoNumericHelper.isNegative(value, this.settings.negativeSignCharacter);
    if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.suffix) {
      if (this.eventKey === AutoNumericEnum.keyName.Backspace) {
        this.caretFix = this.selection.start >= value.indexOf(this.settings.suffixText) && this.settings.suffixText !== "";
        if (value.charAt(this.selection.start - 1) === "-") {
          left = left.substring(1);
        } else if (this.selection.start <= value.length - this.settings.suffixText.length) {
          left = left.substring(0, left.length - 1);
        }
      } else {
        this.caretFix = this.selection.start >= value.indexOf(this.settings.suffixText) && this.settings.suffixText !== "";
        if (this.selection.start >= value.indexOf(this.settings.currencySymbol) + this.settings.currencySymbol.length) {
          right = right.substring(1, right.length);
        }
        if (AutoNumericHelper.isNegative(left, this.settings.negativeSignCharacter) && value.charAt(this.selection.start) === "-") {
          left = left.substring(1);
        }
      }
    }
    if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
      switch (this.settings.negativePositiveSignPlacement) {
        case _AutoNumeric.options.negativePositiveSignPlacement.left:
          this.caretFix = this.selection.start >= value.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length;
          if (this.eventKey === AutoNumericEnum.keyName.Backspace) {
            if (this.selection.start === value.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length && isValNegative) {
              left = left.substring(1);
            } else if (left !== "-" && (this.selection.start <= value.indexOf(this.settings.negativeSignCharacter) || !isValNegative)) {
              left = left.substring(0, left.length - 1);
            }
          } else {
            if (left[0] === "-") {
              right = right.substring(1);
            }
            if (this.selection.start === value.indexOf(this.settings.negativeSignCharacter) && isValNegative) {
              left = left.substring(1);
            }
          }
          break;
        case _AutoNumeric.options.negativePositiveSignPlacement.right:
          this.caretFix = this.selection.start >= value.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length;
          if (this.eventKey === AutoNumericEnum.keyName.Backspace) {
            if (this.selection.start === value.indexOf(this.settings.negativeSignCharacter) + this.settings.negativeSignCharacter.length) {
              left = left.substring(1);
            } else if (left !== "-" && this.selection.start <= value.indexOf(this.settings.negativeSignCharacter) - this.settings.currencySymbol.length) {
              left = left.substring(0, left.length - 1);
            } else if (left !== "" && !isValNegative) {
              left = left.substring(0, left.length - 1);
            }
          } else {
            this.caretFix = this.selection.start >= value.indexOf(this.settings.currencySymbol) && this.settings.currencySymbol !== "";
            if (this.selection.start === value.indexOf(this.settings.negativeSignCharacter)) {
              left = left.substring(1);
            }
            right = right.substring(1);
          }
          break;
      }
    }
    return [left, right];
  }
  /**
   * Process the deletion of characters.
   * Returns `true` if the deletion is allowed (within the min and max range, according to the `overrideMinMaxLimits` option), `false` otherwise.
   *
   * @param {Event} e
   * @returns {boolean}
   */
  _processCharacterDeletion(e5) {
    let left;
    let right;
    if (!this.selection.length) {
      [left, right] = this._getUnformattedLeftAndRightPartAroundTheSelection();
      if (left === "" && right === "") {
        this.throwInput = false;
      }
      if (this.isTrailingNegative && AutoNumericHelper.isNegative(AutoNumericHelper.getElementValue(this.domElement), this.settings.negativeSignCharacter)) {
        [left, right] = this._processCharacterDeletionIfTrailingNegativeSign([left, right]);
      } else {
        if (this.eventKey === AutoNumericEnum.keyName.Backspace) {
          left = left.substring(0, left.length - 1);
        } else {
          right = right.substring(1, right.length);
        }
      }
    } else {
      this._expandSelectionOnSign();
      [left, right] = this._getUnformattedLeftAndRightPartAroundTheSelection();
    }
    if (!this.constructor._isWithinRangeWithOverrideOption(`${left}${right}`, this.settings)) {
      return false;
    }
    if (AutoNumericHelper.getElementValue(e5.target) === this.settings.currencySymbol) {
      return false;
    }
    this._setValueParts(left, right);
    return true;
  }
  /**
   * Return `true` if a decimal character is allowed to be typed.
   * If the number of decimal places shown on focus is zero, then the decimal character is not allowed.
   *
   * @returns {boolean}
   * @private
   */
  _isDecimalCharacterInsertionAllowed() {
    return String(this.settings.decimalPlacesShownOnFocus) !== String(_AutoNumeric.options.decimalPlacesShownOnFocus.none) && String(this.settings.decimalPlaces) !== String(_AutoNumeric.options.decimalPlaces.none);
  }
  /**
   * Return `true` if the key is allowed.
   * This function decides if the key pressed should be dropped or accepted, and modify the value 'on-the-fly' accordingly.
   * //TODO This should use another function in order to separate the test and the modification
   *
   * @returns {boolean}
   */
  _processCharacterInsertion() {
    let [left, right] = this._getUnformattedLeftAndRightPartAroundTheSelection();
    if (this.eventKey !== AutoNumericEnum.keyName.AndroidDefault) {
      this.throwInput = true;
    }
    if (this.eventKey === this.settings.decimalCharacter || this.settings.decimalCharacterAlternative && this.eventKey === this.settings.decimalCharacterAlternative) {
      if (!this._isDecimalCharacterInsertionAllowed() || !this.settings.decimalCharacter) {
        return false;
      }
      if (this.settings.alwaysAllowDecimalCharacter) {
        left = left.replace(this.settings.decimalCharacter, "");
        right = right.replace(this.settings.decimalCharacter, "");
      } else {
        if (AutoNumericHelper.contains(left, this.settings.decimalCharacter)) {
          return true;
        }
        if (right.indexOf(this.settings.decimalCharacter) > 0) {
          return true;
        }
        if (right.indexOf(this.settings.decimalCharacter) === 0) {
          right = right.substr(1);
        }
      }
      if (this.settings.negativeSignCharacter && AutoNumericHelper.contains(right, this.settings.negativeSignCharacter)) {
        left = `${this.settings.negativeSignCharacter}${left}`;
        right = right.replace(this.settings.negativeSignCharacter, "");
      }
      this._setValueParts(left + this.settings.decimalCharacter, right);
      return true;
    }
    if ((this.eventKey === "-" || this.eventKey === "+") && this.settings.isNegativeSignAllowed) {
      if (left === "" && AutoNumericHelper.contains(right, "-")) {
        if (this.settings.negativePositiveSignBehavior || !this.settings.negativePositiveSignBehavior && this.eventKey === "+") {
          right = right.replace("-", "");
        }
      } else if (AutoNumericHelper.isNegativeStrict(left, "-")) {
        if (this.settings.negativePositiveSignBehavior || !this.settings.negativePositiveSignBehavior && this.eventKey === "+") {
          left = left.replace("-", "");
        }
      } else if (this.settings.negativePositiveSignBehavior || !this.settings.negativePositiveSignBehavior && this.eventKey === "-") {
        left = `${this.settings.negativeSignCharacter}${left}`;
      }
      this._setValueParts(left, right);
      return true;
    }
    const eventNumber = Number(this.eventKey);
    if (eventNumber >= 0 && eventNumber <= 9) {
      if (this.settings.isNegativeSignAllowed && left === "" && AutoNumericHelper.contains(right, "-")) {
        left = "-";
        right = right.substring(1, right.length);
      }
      if (this.settings.maximumValue <= 0 && this.settings.minimumValue < this.settings.maximumValue && !AutoNumericHelper.contains(AutoNumericHelper.getElementValue(this.domElement), this.settings.negativeSignCharacter) && this.eventKey !== "0") {
        left = `-${left}`;
      }
      this._setValueParts(`${left}${this.eventKey}`, right);
      return true;
    }
    this.throwInput = false;
    return false;
  }
  /**
   * Formatting of just processed value while keeping the cursor position
   *
   * @param {Event} e
   * @private
   */
  _formatValue(e5) {
    const elementValue = AutoNumericHelper.getElementValue(this.domElement);
    let [left] = this._getUnformattedLeftAndRightPartAroundTheSelection();
    if ((this.settings.digitGroupSeparator === "" || this.settings.digitGroupSeparator !== "" && !AutoNumericHelper.contains(elementValue, this.settings.digitGroupSeparator)) && (this.settings.currencySymbol === "" || this.settings.currencySymbol !== "" && !AutoNumericHelper.contains(elementValue, this.settings.currencySymbol))) {
      let [subParts] = elementValue.split(this.settings.decimalCharacter);
      let negativeSign = "";
      if (AutoNumericHelper.isNegative(subParts, this.settings.negativeSignCharacter)) {
        negativeSign = this.settings.negativeSignCharacter;
        subParts = subParts.replace(this.settings.negativeSignCharacter, "");
        left = left.replace("-", "");
      }
      if (negativeSign === "" && subParts.length > this.settings.mIntPos && left.charAt(0) === "0") {
        left = left.slice(1);
      }
      if (negativeSign === this.settings.negativeSignCharacter && subParts.length > this.settings.mIntNeg && left.charAt(0) === "0") {
        left = left.slice(1);
      }
      if (!this.isTrailingNegative) {
        left = `${negativeSign}${left}`;
      }
    }
    const value = this.constructor._addGroupSeparators(elementValue, this.settings, this.isFocused, this.rawValue);
    let position2 = value.length;
    if (value) {
      const leftAr = left.split("");
      if ((this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.suffix || this.settings.negativePositiveSignPlacement !== _AutoNumeric.options.negativePositiveSignPlacement.prefix && this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) && leftAr[0] === this.settings.negativeSignCharacter && !this.settings.isNegativeSignAllowed) {
        leftAr.shift();
        if ((this.eventKey === AutoNumericEnum.keyName.Backspace || this.eventKey === AutoNumericEnum.keyName.Delete) && this.caretFix) {
          if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix && this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.left || this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix && this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.suffix) {
            leftAr.push(this.settings.negativeSignCharacter);
            this.caretFix = e5.type === "keydown";
          }
          if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix && this.settings.negativePositiveSignPlacement === _AutoNumeric.options.negativePositiveSignPlacement.right) {
            const signParts = this.settings.currencySymbol.split("");
            const escapeChr = ["\\", "^", "$", ".", "|", "?", "*", "+", "(", ")", "["];
            const escapedParts = [];
            signParts.forEach((i3, miniParts) => {
              miniParts = signParts[i3];
              if (AutoNumericHelper.isInArray(miniParts, escapeChr)) {
                escapedParts.push("\\" + miniParts);
              } else {
                escapedParts.push(miniParts);
              }
            });
            if (this.eventKey === AutoNumericEnum.keyName.Backspace && this.settings.negativeSignCharacter === "-") {
              escapedParts.push("-");
            }
            leftAr.push(escapedParts.join(""));
            this.caretFix = e5.type === "keydown";
          }
        }
      }
      for (let i3 = 0; i3 < leftAr.length; i3++) {
        if (!leftAr[i3].match("\\d")) {
          leftAr[i3] = "\\" + leftAr[i3];
        }
      }
      let leftReg;
      if (this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
        leftReg = new RegExp(`^.*?${leftAr.join(".*?")}`);
      } else {
        leftReg = new RegExp(`^.*?[${this.settings.currencySymbol}]*${leftAr.join(".*?")}`);
      }
      const newLeft = value.match(leftReg);
      if (newLeft) {
        position2 = newLeft[0].length;
        if (this.settings.showPositiveSign) {
          if (position2 === 0 && newLeft.input.charAt(0) === this.settings.positiveSignCharacter) {
            position2 = newLeft.input.indexOf(this.settings.currencySymbol) === 1 ? this.settings.currencySymbol.length + 1 : 1;
          }
          if (position2 === 0 && newLeft.input.charAt(this.settings.currencySymbol.length) === this.settings.positiveSignCharacter) {
            position2 = this.settings.currencySymbol.length + 1;
          }
        }
        if ((position2 === 0 && value.charAt(0) !== this.settings.negativeSignCharacter || position2 === 1 && value.charAt(0) === this.settings.negativeSignCharacter) && this.settings.currencySymbol && this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.prefix) {
          position2 = this.settings.currencySymbol.length + (AutoNumericHelper.isNegativeStrict(value, this.settings.negativeSignCharacter) ? 1 : 0);
        }
      } else {
        if (this.settings.currencySymbol && this.settings.currencySymbolPlacement === _AutoNumeric.options.currencySymbolPlacement.suffix) {
          position2 -= this.settings.currencySymbol.length;
        }
        if (this.settings.suffixText) {
          position2 -= this.settings.suffixText.length;
        }
      }
    }
    if (value !== elementValue) {
      this._setElementValue(value, false);
      this._setCaretPosition(position2);
    }
    this.formatted = true;
  }
  /**
   * Serialize the form child <input> element values to a string, or an Array.
   * The output format is defined with the `formatType` argument.
   * This is loosely based upon http://stackoverflow.com/a/40705993/2834898.
   *
   * @param {HTMLFormElement} form
   * @param {boolean} intoAnArray If `true`, instead of generating a string, it generates an Array.
   * @param {string} formatType If `'unformatted'`, then the AutoNumeric elements values are unformatted, if `'localized'`, then the AutoNumeric elements values are localized, and if `'formatted'`, then the AutoNumeric elements values are kept formatted. In either way, this function does not modify the value of each DOM element, but only affect the value that is returned by that serialize function.
   * @param {string} serializedSpaceCharacter Can either be the '+' character, or the '%20' string.
   * @param {string|null} forcedOutputFormat If set, then this is the format that is used for the localization, instead of the default `outputFormat` option.
   * @returns {string|Array}
   * @private
   */
  static _serialize(form, intoAnArray = false, formatType = "unformatted", serializedSpaceCharacter = "+", forcedOutputFormat = null) {
    const result2 = [];
    if (typeof form === "object" && form.nodeName.toLowerCase() === "form") {
      Array.prototype.slice.call(form.elements).forEach((element) => {
        if (element.name && !element.disabled && ["file", "reset", "submit", "button"].indexOf(element.type) === -1) {
          if (element.type === "select-multiple") {
            Array.prototype.slice.call(element.options).forEach((option2) => {
              if (option2.selected) {
                if (intoAnArray) {
                  result2.push({ name: element.name, value: option2.value });
                } else {
                  result2.push(`${encodeURIComponent(element.name)}=${encodeURIComponent(option2.value)}`);
                }
              }
            });
          } else if (["checkbox", "radio"].indexOf(element.type) === -1 || element.checked) {
            let valueResult;
            if (this.isManagedByAutoNumeric(element)) {
              let anObject2;
              switch (formatType) {
                case "unformatted":
                  anObject2 = this.getAutoNumericElement(element);
                  if (!AutoNumericHelper.isNull(anObject2)) {
                    valueResult = this.unformat(element, anObject2.getSettings());
                  }
                  break;
                case "localized":
                  anObject2 = this.getAutoNumericElement(element);
                  if (!AutoNumericHelper.isNull(anObject2)) {
                    const currentSettings = AutoNumericHelper.cloneObject(anObject2.getSettings());
                    if (!AutoNumericHelper.isNull(forcedOutputFormat)) {
                      currentSettings.outputFormat = forcedOutputFormat;
                    }
                    valueResult = this.localize(element, currentSettings);
                  }
                  break;
                case "formatted":
                default:
                  valueResult = element.value;
              }
            } else {
              valueResult = element.value;
            }
            if (AutoNumericHelper.isUndefined(valueResult)) {
              AutoNumericHelper.throwError("This error should never be hit. If it has, something really wrong happened!");
            }
            if (intoAnArray) {
              result2.push({ name: element.name, value: valueResult });
            } else {
              result2.push(`${encodeURIComponent(element.name)}=${encodeURIComponent(valueResult)}`);
            }
          }
        }
      });
    }
    let finalResult;
    if (intoAnArray) {
      finalResult = result2;
    } else {
      finalResult = result2.join("&");
      if ("+" === serializedSpaceCharacter) {
        finalResult = finalResult.replace(/%20/g, "+");
      }
    }
    return finalResult;
  }
  /**
   * Serialize the form values to a string, outputting numeric strings for each AutoNumeric-managed element values.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @returns {string}
   */
  static _serializeNumericString(form, serializedSpaceCharacter = "+") {
    return this._serialize(form, false, "unformatted", serializedSpaceCharacter);
  }
  /**
   * Serialize the form values to a string, outputting the formatted value as strings for each AutoNumeric-managed elements.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @returns {string}
   */
  static _serializeFormatted(form, serializedSpaceCharacter = "+") {
    return this._serialize(form, false, "formatted", serializedSpaceCharacter);
  }
  /**
   * Serialize the form values to a string, outputting localized strings for each AutoNumeric-managed element values.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @param {string|null} forcedOutputFormat If set, then this is the format that is used for the localization, instead of the default `outputFormat` option.
   * @returns {string}
   */
  static _serializeLocalized(form, serializedSpaceCharacter = "+", forcedOutputFormat = null) {
    return this._serialize(form, false, "localized", serializedSpaceCharacter, forcedOutputFormat);
  }
  /**
   * Generate an Array with the form values, outputting numeric strings for each AutoNumeric-managed element values.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @returns {Array}
   */
  static _serializeNumericStringArray(form, serializedSpaceCharacter = "+") {
    return this._serialize(form, true, "unformatted", serializedSpaceCharacter);
  }
  /**
   * Generate an Array with the form values, outputting the formatted value as strings for each AutoNumeric-managed elements.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @returns {Array}
   */
  static _serializeFormattedArray(form, serializedSpaceCharacter = "+") {
    return this._serialize(form, true, "formatted", serializedSpaceCharacter);
  }
  /**
   * Generate an Array with the form values, outputting localized strings for each AutoNumeric-managed element values.
   *
   * @param {HTMLFormElement} form
   * @param {string} serializedSpaceCharacter
   * @param {string|null} forcedOutputFormat If set, then this is the format that is used for the localization, instead of the default `outputFormat` option.
   * @returns {Array}
   */
  static _serializeLocalizedArray(form, serializedSpaceCharacter = "+", forcedOutputFormat = null) {
    return this._serialize(form, true, "localized", serializedSpaceCharacter, forcedOutputFormat);
  }
};
__publicField(_AutoNumeric, "options");
// Those static declarations are only used by the IDE, to prevent error messages not finding those fields declarations
__publicField(_AutoNumeric, "events");
__publicField(_AutoNumeric, "defaultSettings");
__publicField(_AutoNumeric, "predefinedOptions");
let AutoNumeric = _AutoNumeric;
AutoNumeric.multiple = (arg1, initialValue = null, options = null) => {
  const result2 = [];
  if (AutoNumericHelper.isObject(initialValue)) {
    options = initialValue;
    initialValue = null;
  }
  if (AutoNumericHelper.isString(arg1)) {
    arg1 = [...document.querySelectorAll(arg1)];
  } else if (AutoNumericHelper.isObject(arg1)) {
    if (!Object.prototype.hasOwnProperty.call(arg1, "rootElement")) {
      AutoNumericHelper.throwError(`The object passed to the 'multiple' function is invalid ; no 'rootElement' attribute found.`);
    }
    const elements = [...arg1.rootElement.querySelectorAll("input")];
    if (Object.prototype.hasOwnProperty.call(arg1, "exclude")) {
      if (!Array.isArray(arg1.exclude)) {
        AutoNumericHelper.throwError(`The 'exclude' array passed to the 'multiple' function is invalid.`);
      }
      arg1 = AutoNumericHelper.filterOut(elements, arg1.exclude);
    } else {
      arg1 = elements;
    }
  } else if (!AutoNumericHelper.isArray(arg1)) {
    AutoNumericHelper.throwError(`The given parameters to the 'multiple' function are invalid.`);
  }
  if (arg1.length === 0) {
    let showWarnings = true;
    if (!AutoNumericHelper.isNull(options) && AutoNumericHelper.isBoolean(options.showWarnings)) {
      showWarnings = options.showWarnings;
    }
    AutoNumericHelper.warning(`No valid DOM elements were given hence no AutoNumeric objects were instantiated.`, showWarnings);
    return [];
  }
  const isInitialValueArray = AutoNumericHelper.isArray(initialValue);
  const isInitialValueArrayAndNotEmpty = isInitialValueArray && initialValue.length >= 1;
  let secondArgumentIsInitialValueArray = false;
  let secondArgumentIsOptionArray = false;
  if (isInitialValueArrayAndNotEmpty) {
    const typeOfFirstArrayElement = typeof Number(initialValue[0]);
    secondArgumentIsInitialValueArray = typeOfFirstArrayElement === "number" && !isNaN(Number(initialValue[0]));
    if (!secondArgumentIsInitialValueArray) {
      if (typeOfFirstArrayElement === "string" || isNaN(typeOfFirstArrayElement) || typeOfFirstArrayElement === "object") {
        secondArgumentIsOptionArray = true;
      }
    }
  }
  const isOptionsArrayAndNotEmpty = AutoNumericHelper.isArray(options) && options.length >= 1;
  let thirdArgumentIsOptionArray = false;
  if (isOptionsArrayAndNotEmpty) {
    const typeOfFirstArrayElement = typeof options[0];
    if (typeOfFirstArrayElement === "string" || typeOfFirstArrayElement === "object") {
      thirdArgumentIsOptionArray = true;
    }
  }
  let optionsToUse;
  if (secondArgumentIsOptionArray) {
    optionsToUse = AutoNumeric.mergeOptions(initialValue);
  } else if (thirdArgumentIsOptionArray) {
    optionsToUse = AutoNumeric.mergeOptions(options);
  } else {
    optionsToUse = options;
  }
  const isInitialValueNumber = AutoNumericHelper.isNumber(initialValue);
  let initialValueArraySize;
  if (secondArgumentIsInitialValueArray) {
    initialValueArraySize = initialValue.length;
  }
  arg1.forEach((domElement, index2) => {
    if (isInitialValueNumber) {
      result2.push(new AutoNumeric(domElement, initialValue, optionsToUse));
    } else if (secondArgumentIsInitialValueArray && index2 <= initialValueArraySize) {
      result2.push(new AutoNumeric(domElement, initialValue[index2], optionsToUse));
    } else {
      result2.push(new AutoNumeric(domElement, null, optionsToUse));
    }
  });
  return result2;
};
AutoNumeric.events = {
  correctedValue: "autoNumeric:correctedValue",
  initialized: "autoNumeric:initialized",
  invalidFormula: "autoNumeric:invalidFormula",
  invalidValue: "autoNumeric:invalidValue",
  formatted: "autoNumeric:formatted",
  rawValueModified: "autoNumeric:rawValueModified",
  minRangeExceeded: "autoNumeric:minExceeded",
  maxRangeExceeded: "autoNumeric:maxExceeded",
  native: {
    input: "input",
    change: "change"
  },
  validFormula: "autoNumeric:validFormula"
};
Object.freeze(AutoNumeric.events.native);
Object.freeze(AutoNumeric.events);
Object.defineProperty(AutoNumeric, "events", { configurable: false, writable: false });
AutoNumeric.options = {
  /* Defines if the decimal places should be padded with zeroes
   * `true`     : always pad decimals with zeros (ie. '12.3400')
   * `false`    : never pad with zeros (ie. '12.34')
   * `'floats'` : pad with zeroes only when there are decimals (ie. '12' and '12.3400')
   * Note: setting allowDecimalPadding to 'false' will override the 'decimalPlaces' setting.
   */
  allowDecimalPadding: {
    always: true,
    never: false,
    floats: "floats"
  },
  /* Defines if the decimal character or decimal character alternative should be accepted when there is already a decimal character shown in the element.
   * If set to `true`, any decimal character input will be accepted and will subsequently modify the decimal character position, as well as the `rawValue`.
   * If set to `false`, the decimal character and its alternative key will be dropped as before. This is the default setting.
   */
  alwaysAllowDecimalCharacter: {
    alwaysAllow: true,
    doNotAllow: false
  },
  /* Defines where should be positioned the caret on focus
   * null : Do not enforce any caret positioning on focus (this is needed when using `selectOnFocus`)
   * `'start'` : put the caret of the far left side of the value (excluding the positive/negative sign and currency symbol, if any)
   * `'end'` : put the caret of the far right side of the value (excluding the positive/negative sign and currency symbol, if any)
   * `'decimalLeft'` : put the caret of the left of the decimal character if any
   * `'decimalRight'` : put the caret of the right of the decimal character if any
   */
  caretPositionOnFocus: {
    start: "start",
    end: "end",
    decimalLeft: "decimalLeft",
    decimalRight: "decimalRight",
    doNoForceCaretPosition: null
  },
  /* Defines if a local list of AutoNumeric objects should be kept when initializing this object.
   * This list is used by the `global.*` functions.
   */
  createLocalList: {
    createList: true,
    doNotCreateList: false
  },
  /* Defines the currency symbol string.
   * It can be a string of more than one character (allowing for instance to use a space on either side of it, example: '$ ' or ' $')
   * cf. https://en.wikipedia.org/wiki/Currency_symbol
   */
  currencySymbol: {
    none: "",
    currencySign: "¤",
    austral: "₳",
    // ARA
    australCentavo: "¢",
    baht: "฿",
    // THB
    cedi: "₵",
    // GHS
    cent: "¢",
    colon: "₡",
    // CRC
    cruzeiro: "₢",
    // BRB - Not used anymore since 1993
    dollar: "$",
    dong: "₫",
    // VND
    drachma: "₯",
    // GRD (or 'Δρχ.' or 'Δρ.')
    dram: "​֏",
    // AMD
    european: "₠",
    // XEU (old currency before the Euro)
    euro: "€",
    // EUR
    florin: "ƒ",
    franc: "₣",
    // FRF
    guarani: "₲",
    // PYG
    hryvnia: "₴",
    // грн
    kip: "₭",
    // LAK
    att: "ອັດ",
    // cents of the Kip
    lepton: "Λ.",
    // cents of the Drachma
    lira: "₺",
    // TRY
    liraOld: "₤",
    lari: "₾",
    // GEL
    mark: "ℳ",
    mill: "₥",
    naira: "₦",
    // NGN
    peseta: "₧",
    peso: "₱",
    // PHP
    pfennig: "₰",
    // cents of the Mark
    pound: "£",
    real: "R$ ",
    // Brazilian real
    riel: "៛",
    // KHR
    ruble: "₽",
    // RUB
    rupee: "₹",
    // INR
    rupeeOld: "₨",
    shekel: "₪",
    shekelAlt: "ש״ח‎‎",
    taka: "৳",
    // BDT
    tenge: "₸",
    // KZT
    togrog: "₮",
    // MNT
    won: "₩",
    yen: "¥"
  },
  /* Defines where the currency symbol should be placed (before of after the numbers)
   * for prefix currencySymbolPlacement: "p" (default)
   * for suffix currencySymbolPlacement: "s"
   */
  currencySymbolPlacement: {
    prefix: "p",
    suffix: "s"
  },
  /* Defines what decimal separator character is used
   */
  decimalCharacter: {
    comma: ",",
    dot: ".",
    middleDot: "·",
    arabicDecimalSeparator: "٫",
    decimalSeparatorKeySymbol: "⎖"
  },
  /* Allow to declare an alternative decimal separator which is automatically replaced by `decimalCharacter` when typed.
   * This is used by countries that use a comma ',' as the decimal character and have keyboards with a numeric pads that have
   * a period 'full stop' as the decimal character (France or Spain for instance).
   */
  decimalCharacterAlternative: {
    none: null,
    comma: ",",
    dot: "."
  },
  /* Defines the default number of decimal places to show on the formatted value, and keep for the precision.
   * Incidentally, since we need to be able to show that many decimal places, this also defines the raw value precision by default.
   */
  decimalPlaces: {
    none: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6
  },
  /* Defines how many decimal places should be kept for the raw value (ie. This is the precision for float values).
   *
   * If this option is set to `null` (which is the default), then the value of `decimalPlaces` is used for `decimalPlacesRawValue` as well.
   * Note: Setting this to a lower number of decimal places than the one to be shown will lead to confusion for the users.
   */
  decimalPlacesRawValue: {
    useDefault: null,
    none: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6
  },
  /* Defines how many decimal places should be visible when the element is unfocused.
   * If this is set to `null`, then this option is ignored, and the `decimalPlaces` option value will be used instead.
   * This means this is optional ; if omitted the decimal places will be the same when the input has the focus.
   *
   * This option can be used in conjonction with the two other `scale*` options, which allows to display a different formatted value when the element is unfocused, while another formatted value is shown when focused.
   * For those `scale*` options to have any effect, `divisorWhenUnfocused` must not be `null`.
   */
  decimalPlacesShownOnBlur: {
    useDefault: null,
    none: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6
  },
  /* Defines how many decimal places should be visible when the element has the focus.
   * If this is set to `null`, then this option is ignored, and the `decimalPlaces` option value will be used instead.
   *
   * Example:
   * For instance if `decimalPlacesShownOnFocus` is set to `5` and the default number of decimal places is `2`, then on focus `1,000.12345` will be shown, while without focus `1,000.12` will be set back.
   * Note 1: the results depends on the rounding method used.
   * Note 2: the `getNumericString()` method returns the extended decimal places
   */
  decimalPlacesShownOnFocus: {
    useDefault: null,
    none: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6
  },
  /* Helper option for ASP.NET postback
   * This should be set as the value of the unformatted default value
   * examples:
   * no default value="" {defaultValueOverride: ""}
   * value=1234.56 {defaultValueOverride: '1234.56'}
   */
  defaultValueOverride: {
    doNotOverride: null
  },
  /* Defines how many numbers should be grouped together (usually for the thousand separator)
   * - "2",  results in 99,99,99,99 Group by two
   * - "2t", results in 99,99,99,999 India's lakhs
   * - "2s", results in 99,999,99,99,999 India's lakhs scaled
   * - "3",  results in 999,999,999 (default)
   * - "4",  results in 9999,9999,9999 used in some Asian countries
   * Note: This option does not accept other grouping choice.
   */
  digitalGroupSpacing: {
    two: "2",
    twoThree: "2t",
    twoScaled: "2s",
    three: "3",
    four: "4"
  },
  /* Defines the thousand grouping separator character
   * Example : If `'.'` is set, then you'll get `'1.234.567'`
   */
  digitGroupSeparator: {
    comma: ",",
    dot: ".",
    normalSpace: " ",
    thinSpace: " ",
    narrowNoBreakSpace: " ",
    noBreakSpace: " ",
    noSeparator: "",
    apostrophe: `'`,
    arabicThousandsSeparator: "٬",
    dotAbove: "˙",
    privateUseTwo: "’"
    // \u0092
  },
  /* The `divisorWhenUnfocused` divide the element value on focus.
   * On blur, the element value is multiplied back.
   *
   * Example : Display percentages using { divisorWhenUnfocused: 100 } (or directly in the Html with `<input data-divisor-when-unfocused="100">`)
   * The divisor value does not need to be an integer, but please understand that Javascript has limited accuracy in math ; use with caution.
   * Note: The `getNumericString` method returns the full value, including the 'hidden' decimals.
   */
  divisorWhenUnfocused: {
    none: null,
    percentage: 100,
    permille: 1e3,
    basisPoint: 1e4
  },
  /* Defines what should be displayed in the element if the raw value is an empty string ('').
   * - 'focus'  : The currency sign is displayed when the input receives focus (default)
   * - 'press'  : The currency sign is displayed whenever a key is being pressed
   * - 'always' : The currency sign is always displayed
   * - 'zero'   : A zero is displayed ('rounded' with or without a currency sign) if the input has no value on focus out
   * - 'min'    : The minimum value is displayed if the input has no value on focus out
   * - 'max'    : The maximum value is displayed if the input has no value on focus out
   * - 'null'   : When the element is empty, the `rawValue` and the element value/text is set to `null`. This also allows to set the value to `null` using `anElement.set(null)`.
   */
  emptyInputBehavior: {
    focus: "focus",
    press: "press",
    always: "always",
    zero: "zero",
    min: "min",
    max: "max",
    null: "null"
  },
  /* Defines if the custom and native events triggered by AutoNumeric should bubble up or not.
   */
  eventBubbles: {
    bubbles: true,
    doesNotBubble: false
  },
  /* Defines if the custom and native events triggered by AutoNumeric should be cancelable.
   */
  eventIsCancelable: {
    isCancelable: true,
    isNotCancelable: false
  },
  /* This option is the 'strict mode' (aka 'debug' mode), which allows autoNumeric to strictly analyse the options passed, and fails if an unknown options is used in the settings object.
   * You should set that to `true` if you want to make sure you are only using 'pure' autoNumeric settings objects in your code.
   * If you see uncaught errors in the console and your code starts to fail, this means somehow those options gets polluted by another program (which usually happens when using frameworks).
   */
  failOnUnknownOption: {
    fail: true,
    ignore: false
  },
  /* Determine if the default value will be formatted on initialization.
   */
  formatOnPageLoad: {
    format: true,
    // automatically formats the default value on initialization
    doNotFormat: false
    // will not format the default value on initialization
  },
  /* Defines if the 'formula mode' can be activated by the user.
   * If set to `true`, then the user can enter the formula mode by entering the '=' character.
   * He will then be allowed to enter any simple math formula using numeric characters as well as the following operators +, -, *, /, ( and ).
   * The formula mode is closed when the user either validate their math expression using the `Enter` key, or when the element is blurred.
   * If the formula is invalid, the previous valid `rawValue` is set back, and the `autoNumeric:invalidFormula` event is sent.
   * When a valid formula is accepted, then its result is `set()`, and the `autoNumeric:validFormula` event is sent.
   *
   * By default, this mode is disabled.
   */
  formulaMode: {
    enabled: true,
    disabled: false
  },
  /* Set the undo/redo history table size.
   * Each record keeps the raw value as well and the last known caret/selection positions.
   */
  historySize: {
    verySmall: 5,
    small: 10,
    medium: 20,
    large: 50,
    veryLarge: 100,
    insane: Number.MAX_SAFE_INTEGER
  },
  /* Defines the name of the CSS class to use on contenteditable-enabled elements when the value is invalid
   * This is not used when the HTML element used is an input.
   */
  invalidClass: "an-invalid",
  /* Allow the user to 'cancel' and undo the changes he made to the given autonumeric-managed element, by pressing the 'Escape' key.
   * Whenever the user 'validate' the input (either by hitting 'Enter', or blurring the element), the new value is saved for subsequent 'cancellation'.
   *
   * The process :
   *   - save the input value on focus
   *   - if the user change the input value, and hit `Escape`, then the initial value saved on focus is set back
   *   - on the other hand if the user either have used `Enter` to validate (`Enter` throws a change event) his entries, or if the input value has been changed by another script in the mean time, then we save the new input value
   *   - on a successful 'cancel', select the whole value (while respecting the `selectNumberOnly` option)
   *   - bonus; if the value has not changed, hitting 'Esc' just select all the input value (while respecting the `selectNumberOnly` option)
   */
  isCancellable: {
    cancellable: true,
    notCancellable: false
  },
  /* Controls the leading zero behavior
   * - 'allow' : allows leading zeros to be entered. Zeros will be truncated when entering additional digits. On focusout zeros will be deleted
   * - 'deny'  : allows only one leading zero on values that are between 1 and -1
   * - 'keep'  : allows leading zeros to be entered. on focusout zeros will be retained
   */
  leadingZero: {
    allow: "allow",
    deny: "deny",
    keep: "keep"
  },
  /* Defines the maximum possible value a user can enter.
   * Notes:
   * - this value must be a string and use the period for the decimal point
   * - this value needs to be larger than `minimumValue`
   */
  maximumValue: {
    tenTrillions: "10000000000000",
    // 10000 billions
    oneBillion: "1000000000",
    zero: "0"
  },
  /* Defines the minimum possible value a user can enter.
   * Notes:
   * - this value must be a string and use the period for the decimal point
   * - this value needs to be smaller than `maximumValue`
   * - if this is superior to 0, then you'll effectively prevent your user to entirely delete the content of your element
   */
  minimumValue: {
    tenTrillions: "-10000000000000",
    // 10000 billions
    oneBillion: "-1000000000",
    zero: "0"
  },
  /* Allows the user to increment or decrement the element value with the up and down arrow keys.
   * The behavior is similar to the mouse wheel one.
   * The up and down arrow keys behavior can be modified by the `upDownStep` option.
   * This `upDownStep` option can be used in two ways, either by setting:
   * - a 'fixed' step value (`upDownStep : 1000`), or
   * - the 'progressive' string (`upDownStep : 'progressive'`), which will then activate a special mode where the step is automatically calculated based on the element value size.
   */
  modifyValueOnUpDownArrow: {
    modifyValue: true,
    doNothing: false
  },
  /* Allows the user to increment or decrement the element value with the mouse wheel.
   * The behavior is similar to the up/down arrow one.
   * The wheel behavior can be modified by the `wheelStep` option.
   * This `wheelStep` option can be used in two ways, either by setting:
   * - a 'fixed' step value (`wheelStep : 1000`), or
   * - the 'progressive' string (`wheelStep : 'progressive'`), which will then activate a special mode where the step is automatically calculated based on the element value size.
   *
   * Note :
   * You can activate/deactivate the wheel event for each `wheelOn` option value by using the 'Shift' modifier key while using the mouse wheel.
   */
  modifyValueOnWheel: {
    modifyValue: true,
    doNothing: false
  },
  /* Adds brackets on negative values (ie. transforms '-$ 999.99' to '($999.99)')
   * Those brackets are visible only when the field does NOT have the focus.
   * The left and right symbols should be enclosed in quotes and separated by a comma.
   */
  negativeBracketsTypeOnBlur: {
    parentheses: "(,)",
    brackets: "[,]",
    chevrons: "<,>",
    curlyBraces: "{,}",
    angleBrackets: "〈,〉",
    japaneseQuotationMarks: "｢,｣",
    halfBrackets: "⸤,⸥",
    whiteSquareBrackets: "⟦,⟧",
    quotationMarks: "‹,›",
    guillemets: "«,»",
    none: null
    // This is the default value, which deactivate this feature
  },
  /* Placement of the negative/positive sign relative to the `currencySymbol` option.
   *
   * Example:
   * // Default values
   * -1,234.56  => default no options required
   * $-1,234.56 => {currencySymbol: "$", negativePositiveSignPlacement: "r"} // Default if negativePositiveSignPlacement is 'null' and currencySymbol is not empty
   *
   * // Sign on the left hand side of the whole number
   * -$1,234.56 => {currencySymbol: "$"} or {currencySymbol: "$", negativePositiveSignPlacement: "l"}
   * -1,234.56$ => {currencySymbol: "$", currencySymbolPlacement: "s", negativePositiveSignPlacement: "p"} // Default if negativePositiveSignPlacement is 'null' and currencySymbol is not empty
   *
   * // Sign on the right hand side of the whole number
   * 1,234.56-  => {negativePositiveSignPlacement: "s"}
   * $1,234.56- => {currencySymbol: "$", negativePositiveSignPlacement: "s"}
   * 1,234.56-$ => {currencySymbol: "$", currencySymbolPlacement: "s"}
   * 1,234.56$- => {currencySymbol: "$", currencySymbolPlacement: "s", negativePositiveSignPlacement: "r"}
   */
  negativePositiveSignPlacement: {
    prefix: "p",
    suffix: "s",
    left: "l",
    right: "r",
    none: null
  },
  /* Defines the negative sign symbol.
   * It can be a string of only one character.
   */
  negativeSignCharacter: {
    hyphen: "-",
    minus: "−",
    heavyMinus: "➖",
    fullWidthHyphen: "－",
    circledMinus: "⊖",
    squaredMinus: "⊟",
    triangleMinus: "⨺",
    plusMinus: "±",
    minusPlus: "∓",
    dotMinus: "∸",
    minusTilde: "≂",
    not: "¬"
  },
  /*
   * Defines if the negative sign should be toggled when hitting the negative or positive key multiple times.
   * When `toggle` is used, using the same '-' on '+' key will toggle between a positive and negative value.
   * When `doNotToggle` is used, using '-' will always set the value negative, and '+' will always set the value positive.
   */
  negativePositiveSignBehavior: {
    toggle: true,
    doNotToggle: false
  },
  /* Defines if the element should have event listeners activated on it.
   * By default, those event listeners are only added to <input> elements and html element with the `contenteditable` attribute set to `true`, but not on the other html tags.
   * This allows to initialize elements without any event listeners.
   * Warning: Since AutoNumeric will not check the input content after its initialization, using some autoNumeric methods afterwards *will* probably leads to formatting problems.
   */
  noEventListeners: {
    noEvents: true,
    addEvents: false
  },
  /* Manage how autoNumeric react when the user tries to paste an invalid number.
   * - 'error'    : (This is the default behavior) The input value is not changed and an error is output in the console.
   * - 'ignore'   : idem than 'error', but fail silently without outputting any error/warning in the console.
   * - 'clamp'    : if the pasted value is either too small or too big regarding the minimumValue and maximumValue range, then the result is clamped to those limits.
   * - 'truncate' : autoNumeric will insert as many pasted numbers it can at the initial caret/selection, until everything is pasted, or the range limit is hit.
   *                The non-pasted numbers are dropped and therefore not used at all.
   * - 'replace'  : autoNumeric will first insert as many pasted numbers it can at the initial caret/selection, then if the range limit is hit, it will try
   *                to replace one by one the remaining initial numbers (on the right side of the caret) with the rest of the pasted numbers.
   *
   * Note 1 : A paste content starting with a negative sign '-' will be accepted anywhere in the input, and will set the resulting value as a negative number
   * Note 2 : A paste content starting with a number will be accepted, even if the rest is gibberish (ie. '123foobar456').
   *          Only the first number will be used (here '123').
   * Note 3 : The paste event works with the `decimalPlacesShownOnFocus` option too.
   */
  onInvalidPaste: {
    error: "error",
    ignore: "ignore",
    clamp: "clamp",
    truncate: "truncate",
    replace: "replace"
  },
  /* Defines how the value should be formatted when wanting a 'localized' version of it.
   * - null or 'string' => 'nnnn.nn' or '-nnnn.nn' as text type. This is the default behavior.
   * - 'number'         => nnnn.nn or -nnnn.nn as a Number (Warning: this works only for integers inferior to Number.MAX_SAFE_INTEGER)
   * - ',' or '-,'      => 'nnnn,nn' or '-nnnn,nn'
   * - '.-'             => 'nnnn.nn' or 'nnnn.nn-'
   * - ',-'             => 'nnnn,nn' or 'nnnn,nn-'
   *
   * Note: The hyphen '-' is translated to the custom negative sign defined in `negativeSignCharacter`
   */
  outputFormat: {
    string: "string",
    number: "number",
    dot: ".",
    negativeDot: "-.",
    comma: ",",
    negativeComma: "-,",
    dotNegative: ".-",
    commaNegative: ",-",
    none: null
  },
  /* Defines if AutoNumeric should let the user override the minimum and/or maximum limits when he types numbers in the element.
   * - 'ceiling' Strictly adheres to `maximumValue` and ignores the `minimumValue` settings
   *             It allows the user to enter anything between -∞ `and maximumValue`
   *             If `maximumValue` is less than 0, then it will prevent the user emptying the field or typing value above `maximumValue`, making sure the value entered is always valid
   * - 'floor'   Strictly adheres to `minimumValue` and ignores the `maximumValue` settings
   *             It allows the user to enter anything between `minimumValue` and +∞
   *             If `minimumValue` is higher than 0, then it will prevent the user emptying the field or typing value below `minimumValue`, making sure the value entered is always valid
   * - 'ignore'  Ignores both the `minimumValue` and `maximumValue` settings
   *             When using this option, the field will always be valid range-wise
   * - 'invalid' The user can temporarily type out-of-bound values. In doing so, the invalid state is set on the field.
   *             Whenever an invalid value is typed, an 'autoNumeric:invalidValue' event is sent
   *             When the value is correctly set back within the limit boundaries, the invalid state is removed, and the 'autoNumeric:correctedValue' event is sent
   * - 'doNotOverride' Strictly adheres to the `maximumValue` and `minimumValue` settings
   *                   This is the default behavior
   *                   If `0` is out of the min/max range, this will prevent the user clearing the input field, making sure the value entered is always valid
   */
  overrideMinMaxLimits: {
    ceiling: "ceiling",
    floor: "floor",
    ignore: "ignore",
    invalid: "invalid",
    doNotOverride: null
  },
  /* Defines the positive sign symbol.
   * It can be a string of only one character.
   * This is shown only if `showPositiveSign` is set to `true`.
   */
  positiveSignCharacter: {
    plus: "+",
    fullWidthPlus: "＋",
    heavyPlus: "➕",
    doublePlus: "⧺",
    triplePlus: "⧻",
    circledPlus: "⊕",
    squaredPlus: "⊞",
    trianglePlus: "⨹",
    plusMinus: "±",
    minusPlus: "∓",
    dotPlus: "∔",
    altHebrewPlus: "﬩",
    normalSpace: " ",
    thinSpace: " ",
    narrowNoBreakSpace: " ",
    noBreakSpace: " "
  },
  /* The `rawValueDivisor` divides the formatted value shown in the AutoNumeric element and store the result in `rawValue`.
   * @example { rawValueDivisor: '100' } or <input data-raw-value-divisor="100">
   * Given the `0.01234` raw value, the formatted value will be displayed as `'1.234'`.
   * This is useful when displaying percentage for instance, and avoid the need to divide/multiply by 100 between the number shown and the raw value.
   */
  rawValueDivisor: {
    none: null,
    percentage: 100,
    permille: 1e3,
    basisPoint: 1e4
  },
  /* Defines if the element (`<input>` or another allowed html tag) should be set as read-only on initialization.
   * When set to `true`, then:
   * - the `readonly` html property is added to the <input> element on initialization, or
   * - the `contenteditable` attribute is set to `false` on non-input elements.
   */
  readOnly: {
    readOnly: true,
    readWrite: false
  },
  /* Defines the rounding method to use.
   * roundingMethod: "S", Round-Half-Up Symmetric (default)
   * roundingMethod: "A", Round-Half-Up Asymmetric
   * roundingMethod: "s", Round-Half-Down Symmetric (lower case s)
   * roundingMethod: "a", Round-Half-Down Asymmetric (lower case a)
   * roundingMethod: "B", Round-Half-Even "Bankers Rounding"
   * roundingMethod: "U", Round Up "Round-Away-From-Zero"
   * roundingMethod: "D", Round Down "Round-Toward-Zero" - same as truncate
   * roundingMethod: "C", Round to Ceiling "Toward Positive Infinity"
   * roundingMethod: "F", Round to Floor "Toward Negative Infinity"
   * roundingMethod: "N05" Rounds to the nearest .05 => same as "CHF" used in 1.9X and still valid
   * roundingMethod: "U05" Rounds up to next .05
   * roundingMethod: "D05" Rounds down to next .05
   */
  roundingMethod: {
    halfUpSymmetric: "S",
    halfUpAsymmetric: "A",
    halfDownSymmetric: "s",
    halfDownAsymmetric: "a",
    halfEvenBankersRounding: "B",
    upRoundAwayFromZero: "U",
    downRoundTowardZero: "D",
    toCeilingTowardPositiveInfinity: "C",
    toFloorTowardNegativeInfinity: "F",
    toNearest05: "N05",
    toNearest05Alt: "CHF",
    upToNext05: "U05",
    downToNext05: "D05"
  },
  /* Set to `true` to allow the `decimalPlacesShownOnFocus` value to be saved with sessionStorage
   * If IE 6 or 7 is detected, the value will be saved as a session cookie.
   */
  saveValueToSessionStorage: {
    save: true,
    doNotSave: false
  },
  /* Determine if the select all keyboard command will select the complete input text, or only the input numeric value
   * Note : If the currency symbol is between the numeric value and the negative sign, only the numeric value will be selected
   */
  selectNumberOnly: {
    selectNumbersOnly: true,
    selectAll: false
  },
  /* Defines if the element value should be selected on focus.
   * Note: The selection is done using the `selectNumberOnly` option.
   */
  selectOnFocus: {
    select: true,
    doNotSelect: false
  },
  /* Defines how the serialize functions should treat the spaces.
   * Those spaces ' ' can either be converted to the plus sign '+', which is the default, or to '%20'.
   * Both values being valid per the spec (http://www.w3.org/Addressing/URL/uri-spec.html).
   * Also see the summed up answer on http://stackoverflow.com/a/33939287.
   *
   * tl;dr : Spaces should be converted to '%20' before the '?' sign, then converted to '+' after.
   * In our case since we serialize the query, we use '+' as the default (but allow the user to get back the old *wrong* behavior).
   */
  serializeSpaces: {
    plus: "+",
    percent: "%20"
  },
  /* Defines if the element value should be converted to the raw value on focus (and back to the formatted on blur).
   * If set to `true`, then autoNumeric remove the thousand separator, currency symbol and suffix on focus.
   * Example:
   * If the input value is '$ 1,999.88 suffix', on focus it becomes '1999.88' and back to '$ 1,999.88 suffix' on blur.
   */
  showOnlyNumbersOnFocus: {
    onlyNumbers: true,
    showAll: false
  },
  /* Allow the positive sign symbol `+` to be displayed for positive numbers.
   * By default, this positive sign is not shown.
   * The sign placement is controlled by the 'negativePositiveSignPlacement' option, mimicking the negative sign placement rules.
   */
  showPositiveSign: {
    show: true,
    hide: false
  },
  /* Defines if warnings should be shown in the console.
   * Those warnings can be ignored, but are usually printed when something could be improved by the user (ie. option conflicts).
   */
  showWarnings: {
    show: true,
    // All warning are shown
    hide: false
    // No warnings are shown, only the thrown errors
  },
  /* Defines the rules that calculate the CSS class(es) to apply on the element, based on the raw unformatted value.
   * This can also be used to call callbacks whenever the `rawValue` is updated.
   * Important: all callbacks must return `null` if no ranges/userDefined classes are selected
   * @example
   * {
   *     positive   : 'autoNumeric-positive', // Or `null` to not use it
   *     negative   : 'autoNumeric-negative',
   *     ranges     : [
   *         { min: 0, max: 25, class: 'autoNumeric-red' },
   *         { min: 25, max: 50, class: 'autoNumeric-orange' },
   *         { min: 50, max: 75, class: 'autoNumeric-yellow' },
   *         { min: 75, max: Number.MAX_SAFE_INTEGER, class: 'autoNumeric-green' },
   *     ],
   *     userDefined: [
   *         // If 'classes' is a string, set it if `true`, remove it if `false`
   *         { callback: rawValue => { return true; }, classes: 'thisIsTrue' },
   *         // If 'classes' is an array with only 2 elements, set the first class if `true`, the second if `false`
   *         { callback: rawValue => rawValue % 2 === 0, classes: ['autoNumeric-even', 'autoNumeric-odd'] },
   *         // Return only one index to use on the `classes` array (here, 'class3')
   *         { callback: rawValue => { return 2; }, classes: ['class1', 'class2', 'class3'] },
   *         // Return an array of indexes to use on the `classes` array (here, 'class1' and 'class3')
   *         { callback: rawValue => { return [0, 2]; }, classes: ['class1', 'class2', 'class3'] },
   *         // If 'classes' is `undefined` or `null`, then the callback is called with the AutoNumeric object passed as a parameter
   *         { callback: anElement => { return anElement.getFormatted(); } },
   *     ],
   * }
   */
  styleRules: {
    none: null,
    positiveNegative: {
      positive: "autoNumeric-positive",
      negative: "autoNumeric-negative"
    },
    range0To100With4Steps: {
      ranges: [
        { min: 0, max: 25, class: "autoNumeric-red" },
        { min: 25, max: 50, class: "autoNumeric-orange" },
        { min: 50, max: 75, class: "autoNumeric-yellow" },
        { min: 75, max: 100, class: "autoNumeric-green" }
      ]
    },
    evenOdd: {
      userDefined: [
        { callback: (rawValue) => rawValue % 2 === 0, classes: ["autoNumeric-even", "autoNumeric-odd"] }
      ]
    },
    rangeSmallAndZero: {
      userDefined: [
        {
          callback: (rawValue) => {
            if (rawValue >= -1 && rawValue < 0) {
              return 0;
            }
            if (Number(rawValue) === 0) {
              return 1;
            }
            if (rawValue > 0 && rawValue <= 1) {
              return 2;
            }
            return null;
          },
          classes: [
            "autoNumeric-small-negative",
            "autoNumeric-zero",
            "autoNumeric-small-positive"
          ]
        }
      ]
    }
  },
  /* Add a text on the right hand side of the element value.
   * This suffix text can have any characters in its string, except numeric characters and the negative/positive sign.
   * Example: ' dollars'
   */
  suffixText: {
    none: "",
    percentage: "%",
    permille: "‰",
    basisPoint: "‱"
  },
  /* The three options (divisorWhenUnfocused, decimalPlacesShownOnBlur & symbolWhenUnfocused) handle scaling of the input when the input does not have focus
   * Please note that the non-scaled value is held in data and it is advised that you use the `saveValueToSessionStorage` option to ensure retaining the value
   * ["divisor", "decimal places", "symbol"]
   * Example: with the following options set {divisorWhenUnfocused: '1000', decimalPlacesShownOnBlur: '1', symbolWhenUnfocused: ' K'}
   * Example: focusin value "1,111.11" focusout value "1.1 K"
   */
  /* The `symbolWhenUnfocused` option is a symbol placed as a suffix when not in focus.
   * This is optional too.
   */
  symbolWhenUnfocused: {
    none: null,
    percentage: "%",
    permille: "‰",
    basisPoint: "‱"
  },
  /* Defines if the element value should be unformatted when the user hover his mouse over it while holding the `Alt` key.
   * Unformatting there means that this removes any non-number characters and displays the *raw* value, as understood by Javascript (ie. `12.34` is a valid number, while `12,34` is not).
   *
   * We reformat back before anything else if :
   * - the user focus on the element by tabbing or clicking into it,
   * - the user releases the `Alt` key, and
   * - if we detect a mouseleave event.
   *
   * We unformat again if :
   * - while the mouse is over the element, the user hit `Alt` again
   */
  unformatOnHover: {
    unformat: true,
    doNotUnformat: false
    //TODO Rename to `keepFormat`
  },
  /* Removes the formatting and use the raw value in each autoNumeric elements of the parent form element, on the form `submit` event.
   * The output format is a numeric string (nnnn.nn or -nnnn.nn).
   */
  unformatOnSubmit: {
    unformat: true,
    keepCurrentValue: false
  },
  /* That option is linked to the `modifyValueOnUpDownArrow` one and will only be used if the latter is set to `true`.
   * This option will modify the up/down arrow behavior and can be used in two ways, either by setting :
   * - a 'fixed' step value (a positive float or integer number (ex: `1000`)), or
   * - the `'progressive'` string.
   *
   * The 'fixed' mode always increment/decrement the element value by that amount, while respecting the `minimumValue` and `maximumValue` settings.
   * The 'progressive' mode will increment/decrement the element value based on its current value. The bigger the number, the bigger the step, and vice versa.
   */
  upDownStep: {
    progressive: "progressive"
  },
  /* Provides a way for automatically replacing the formatted value with a pre-defined string, when the raw value is equal to a specific value
   * Here you can specify as many 'conversion' as needed.
   */
  valuesToStrings: {
    none: null,
    zeroDash: {
      0: "-"
    },
    oneAroundZero: {
      "-1": "Min",
      1: "Max"
    }
  },
  /* Defines if the AutoNumeric element should watch external changes made without using `.set()`, but by using the basic `aNElement.node().value = 42` notation.
   * If set to `watch`, then AutoNumeric will format the new value using `.set()` internally.
   * Otherwise it will neither format it, nor save it in the history.
   */
  watchExternalChanges: {
    watch: true,
    doNotWatch: false
  },
  /* Defines when the wheel event will increment or decrement the element value.
   * When set to `'focus'`, the AutoNumeric-managed element needs to be focused for the wheel event to change the value.
   * When set to `'hover'`, using the wheel event while the mouse is hovering the element is sufficient (no focus needed).
   *
   * Note :
   * When `wheelOn` is set to `'focus'`, you can use the 'Shift' modifier key while using the mouse wheel in order to temporarily activate the increment/decrement feature even if the element is not focused.
   * When `wheelOn` is set to `'hover'`, you can use the 'Shift' modifier key while using the mouse wheel in order to temporarily disable the increment/decrement feature even if the element is not hovered.
   */
  wheelOn: {
    focus: "focus",
    hover: "hover"
  },
  /* That option is linked to the `modifyValueOnWheel` one and will only be used if the latter is set to `true`.
   * This option will modify the wheel behavior and can be used in two ways, either by setting :
   * - a 'fixed' step value (a positive float or integer (ex: number `1000`)), or
   * - the `'progressive'` string.
   *
   * The 'fixed' mode always increment/decrement the element value by that amount, while respecting the `minimumValue` and `maximumValue` settings.
   * The 'progressive' mode will increment/decrement the element value based on its current value. The bigger the number, the bigger the step, and vice versa.
   */
  wheelStep: {
    progressive: "progressive"
  }
};
function freezeOptions(options) {
  Object.getOwnPropertyNames(options).forEach((optionName) => {
    if (optionName === "valuesToStrings") {
      const vsProps = Object.getOwnPropertyNames(options.valuesToStrings);
      vsProps.forEach((valuesToStringObjectName) => {
        if (options.valuesToStrings[valuesToStringObjectName] !== null) {
          Object.freeze(options.valuesToStrings[valuesToStringObjectName]);
        }
      });
    } else if (optionName !== "styleRules") {
      if (options[optionName] !== null) {
        Object.freeze(options[optionName]);
      }
    }
  });
  return Object.freeze(options);
}
freezeOptions(AutoNumeric.options);
Object.defineProperty(AutoNumeric, "options", { configurable: false, writable: false });
AutoNumeric.defaultSettings = {
  allowDecimalPadding: AutoNumeric.options.allowDecimalPadding.always,
  alwaysAllowDecimalCharacter: AutoNumeric.options.alwaysAllowDecimalCharacter.doNotAllow,
  caretPositionOnFocus: AutoNumeric.options.caretPositionOnFocus.doNoForceCaretPosition,
  createLocalList: AutoNumeric.options.createLocalList.createList,
  currencySymbol: AutoNumeric.options.currencySymbol.none,
  currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.prefix,
  decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
  decimalCharacterAlternative: AutoNumeric.options.decimalCharacterAlternative.none,
  decimalPlaces: AutoNumeric.options.decimalPlaces.two,
  decimalPlacesRawValue: AutoNumeric.options.decimalPlacesRawValue.useDefault,
  decimalPlacesShownOnBlur: AutoNumeric.options.decimalPlacesShownOnBlur.useDefault,
  decimalPlacesShownOnFocus: AutoNumeric.options.decimalPlacesShownOnFocus.useDefault,
  defaultValueOverride: AutoNumeric.options.defaultValueOverride.doNotOverride,
  digitalGroupSpacing: AutoNumeric.options.digitalGroupSpacing.three,
  digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.comma,
  divisorWhenUnfocused: AutoNumeric.options.divisorWhenUnfocused.none,
  emptyInputBehavior: AutoNumeric.options.emptyInputBehavior.focus,
  eventBubbles: AutoNumeric.options.eventBubbles.bubbles,
  eventIsCancelable: AutoNumeric.options.eventIsCancelable.isCancelable,
  failOnUnknownOption: AutoNumeric.options.failOnUnknownOption.ignore,
  formatOnPageLoad: AutoNumeric.options.formatOnPageLoad.format,
  formulaMode: AutoNumeric.options.formulaMode.disabled,
  historySize: AutoNumeric.options.historySize.medium,
  invalidClass: AutoNumeric.options.invalidClass,
  isCancellable: AutoNumeric.options.isCancellable.cancellable,
  leadingZero: AutoNumeric.options.leadingZero.deny,
  maximumValue: AutoNumeric.options.maximumValue.tenTrillions,
  minimumValue: AutoNumeric.options.minimumValue.tenTrillions,
  modifyValueOnUpDownArrow: AutoNumeric.options.modifyValueOnUpDownArrow.modifyValue,
  modifyValueOnWheel: AutoNumeric.options.modifyValueOnWheel.modifyValue,
  negativeBracketsTypeOnBlur: AutoNumeric.options.negativeBracketsTypeOnBlur.none,
  negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.none,
  negativeSignCharacter: AutoNumeric.options.negativeSignCharacter.hyphen,
  negativePositiveSignBehavior: AutoNumeric.options.negativePositiveSignBehavior.doNotToggle,
  noEventListeners: AutoNumeric.options.noEventListeners.addEvents,
  //TODO Shouldn't we use `truncate` as the default value?
  onInvalidPaste: AutoNumeric.options.onInvalidPaste.error,
  outputFormat: AutoNumeric.options.outputFormat.none,
  overrideMinMaxLimits: AutoNumeric.options.overrideMinMaxLimits.doNotOverride,
  positiveSignCharacter: AutoNumeric.options.positiveSignCharacter.plus,
  rawValueDivisor: AutoNumeric.options.rawValueDivisor.none,
  readOnly: AutoNumeric.options.readOnly.readWrite,
  roundingMethod: AutoNumeric.options.roundingMethod.halfUpSymmetric,
  saveValueToSessionStorage: AutoNumeric.options.saveValueToSessionStorage.doNotSave,
  selectNumberOnly: AutoNumeric.options.selectNumberOnly.selectNumbersOnly,
  selectOnFocus: AutoNumeric.options.selectOnFocus.select,
  serializeSpaces: AutoNumeric.options.serializeSpaces.plus,
  showOnlyNumbersOnFocus: AutoNumeric.options.showOnlyNumbersOnFocus.showAll,
  showPositiveSign: AutoNumeric.options.showPositiveSign.hide,
  showWarnings: AutoNumeric.options.showWarnings.show,
  styleRules: AutoNumeric.options.styleRules.none,
  suffixText: AutoNumeric.options.suffixText.none,
  symbolWhenUnfocused: AutoNumeric.options.symbolWhenUnfocused.none,
  unformatOnHover: AutoNumeric.options.unformatOnHover.unformat,
  unformatOnSubmit: AutoNumeric.options.unformatOnSubmit.keepCurrentValue,
  upDownStep: "1",
  // To mimic the behavior of 'numeric'-typed input
  valuesToStrings: AutoNumeric.options.valuesToStrings.none,
  watchExternalChanges: AutoNumeric.options.watchExternalChanges.doNotWatch,
  wheelOn: AutoNumeric.options.wheelOn.focus,
  wheelStep: AutoNumeric.options.wheelStep.progressive
};
Object.freeze(AutoNumeric.defaultSettings);
Object.defineProperty(AutoNumeric, "defaultSettings", { configurable: false, writable: false });
const euro = {
  // Français
  digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.dot,
  // or '\u202f'
  decimalCharacter: AutoNumeric.options.decimalCharacter.comma,
  decimalCharacterAlternative: AutoNumeric.options.decimalCharacterAlternative.dot,
  currencySymbol: " €",
  currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.suffix,
  negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.prefix
};
const dollar = {
  digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.comma,
  decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
  currencySymbol: AutoNumeric.options.currencySymbol.dollar,
  currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.prefix,
  negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.right
};
const japanese = {
  // 日本語
  digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.comma,
  decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
  currencySymbol: AutoNumeric.options.currencySymbol.yen,
  currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.prefix,
  negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.right
};
const euroF = AutoNumericHelper.cloneObject(euro);
euroF.formulaMode = AutoNumeric.options.formulaMode.enabled;
const euroPos = AutoNumericHelper.cloneObject(euro);
euroPos.minimumValue = 0;
const euroNeg = AutoNumericHelper.cloneObject(euro);
euroNeg.maximumValue = 0;
euroNeg.negativePositiveSignPlacement = AutoNumeric.options.negativePositiveSignPlacement.prefix;
const euroSpace = AutoNumericHelper.cloneObject(euro);
euroSpace.digitGroupSeparator = AutoNumeric.options.digitGroupSeparator.normalSpace;
const euroSpacePos = AutoNumericHelper.cloneObject(euroSpace);
euroSpacePos.minimumValue = 0;
const euroSpaceNeg = AutoNumericHelper.cloneObject(euroSpace);
euroSpaceNeg.maximumValue = 0;
euroSpaceNeg.negativePositiveSignPlacement = AutoNumeric.options.negativePositiveSignPlacement.prefix;
const percentageEU2dec = AutoNumericHelper.cloneObject(euro);
percentageEU2dec.currencySymbol = AutoNumeric.options.currencySymbol.none;
percentageEU2dec.suffixText = ` ${AutoNumeric.options.suffixText.percentage}`;
percentageEU2dec.wheelStep = 1e-4;
percentageEU2dec.rawValueDivisor = AutoNumeric.options.rawValueDivisor.percentage;
const percentageEU2decPos = AutoNumericHelper.cloneObject(percentageEU2dec);
percentageEU2decPos.minimumValue = 0;
const percentageEU2decNeg = AutoNumericHelper.cloneObject(percentageEU2dec);
percentageEU2decNeg.maximumValue = 0;
percentageEU2decNeg.negativePositiveSignPlacement = AutoNumeric.options.negativePositiveSignPlacement.prefix;
const percentageEU3dec = AutoNumericHelper.cloneObject(percentageEU2dec);
percentageEU3dec.decimalPlaces = 3;
const percentageEU3decPos = AutoNumericHelper.cloneObject(percentageEU2decPos);
percentageEU3decPos.decimalPlaces = 3;
const percentageEU3decNeg = AutoNumericHelper.cloneObject(percentageEU2decNeg);
percentageEU3decNeg.decimalPlaces = 3;
const dollarF = AutoNumericHelper.cloneObject(dollar);
dollarF.formulaMode = AutoNumeric.options.formulaMode.enabled;
const dollarPos = AutoNumericHelper.cloneObject(dollar);
dollarPos.minimumValue = 0;
const dollarNeg = AutoNumericHelper.cloneObject(dollar);
dollarNeg.maximumValue = 0;
dollarNeg.negativePositiveSignPlacement = AutoNumeric.options.negativePositiveSignPlacement.prefix;
const dollarNegBrackets = AutoNumericHelper.cloneObject(dollarNeg);
dollarNegBrackets.negativeBracketsTypeOnBlur = AutoNumeric.options.negativeBracketsTypeOnBlur.parentheses;
const percentageUS2dec = AutoNumericHelper.cloneObject(dollar);
percentageUS2dec.currencySymbol = AutoNumeric.options.currencySymbol.none;
percentageUS2dec.suffixText = AutoNumeric.options.suffixText.percentage;
percentageUS2dec.wheelStep = 1e-4;
percentageUS2dec.rawValueDivisor = AutoNumeric.options.rawValueDivisor.percentage;
const percentageUS2decPos = AutoNumericHelper.cloneObject(percentageUS2dec);
percentageUS2decPos.minimumValue = 0;
const percentageUS2decNeg = AutoNumericHelper.cloneObject(percentageUS2dec);
percentageUS2decNeg.maximumValue = 0;
percentageUS2decNeg.negativePositiveSignPlacement = AutoNumeric.options.negativePositiveSignPlacement.prefix;
const percentageUS3dec = AutoNumericHelper.cloneObject(percentageUS2dec);
percentageUS3dec.decimalPlaces = 3;
const percentageUS3decPos = AutoNumericHelper.cloneObject(percentageUS2decPos);
percentageUS3decPos.decimalPlaces = 3;
const percentageUS3decNeg = AutoNumericHelper.cloneObject(percentageUS2decNeg);
percentageUS3decNeg.decimalPlaces = 3;
const turkish = AutoNumericHelper.cloneObject(euro);
turkish.currencySymbol = AutoNumeric.options.currencySymbol.lira;
AutoNumeric.predefinedOptions = {
  euro,
  euroPos,
  euroNeg,
  euroSpace,
  euroSpacePos,
  euroSpaceNeg,
  percentageEU2dec,
  percentageEU2decPos,
  percentageEU2decNeg,
  percentageEU3dec,
  percentageEU3decPos,
  percentageEU3decNeg,
  dollar,
  dollarPos,
  dollarNeg,
  dollarNegBrackets,
  percentageUS2dec,
  percentageUS2decPos,
  percentageUS2decNeg,
  percentageUS3dec,
  percentageUS3decPos,
  percentageUS3decNeg,
  French: euro,
  // Français
  Spanish: euro,
  // Español
  NorthAmerican: dollar,
  British: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.comma,
    decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
    currencySymbol: AutoNumeric.options.currencySymbol.pound,
    currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.prefix,
    negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.right
  },
  Swiss: {
    // Suisse
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.apostrophe,
    decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
    currencySymbol: " CHF",
    currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.suffix,
    negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.prefix
  },
  Japanese: japanese,
  // 日本語
  Chinese: japanese,
  // 中国語 (Chinese)
  Brazilian: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.dot,
    decimalCharacter: AutoNumeric.options.decimalCharacter.comma,
    currencySymbol: AutoNumeric.options.currencySymbol.real,
    currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.prefix,
    negativePositiveSignPlacement: AutoNumeric.options.negativePositiveSignPlacement.right
  },
  Turkish: turkish,
  dotDecimalCharCommaSeparator: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.comma,
    decimalCharacter: AutoNumeric.options.decimalCharacter.dot
  },
  commaDecimalCharDotSeparator: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.dot,
    decimalCharacter: AutoNumeric.options.decimalCharacter.comma,
    decimalCharacterAlternative: AutoNumeric.options.decimalCharacterAlternative.dot
  },
  integer: {
    decimalPlaces: 0
  },
  integerPos: {
    minimumValue: AutoNumeric.options.minimumValue.zero,
    decimalPlaces: 0
  },
  integerNeg: {
    maximumValue: AutoNumeric.options.maximumValue.zero,
    decimalPlaces: 0
  },
  float: {
    allowDecimalPadding: AutoNumeric.options.allowDecimalPadding.never
  },
  floatPos: {
    allowDecimalPadding: AutoNumeric.options.allowDecimalPadding.never,
    minimumValue: AutoNumeric.options.minimumValue.zero,
    maximumValue: AutoNumeric.options.maximumValue.tenTrillions
  },
  floatNeg: {
    allowDecimalPadding: AutoNumeric.options.allowDecimalPadding.never,
    minimumValue: AutoNumeric.options.minimumValue.tenTrillions,
    maximumValue: AutoNumeric.options.maximumValue.zero
  },
  numeric: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.noSeparator,
    decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
    currencySymbol: AutoNumeric.options.currencySymbol.none
  },
  numericPos: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.noSeparator,
    decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
    currencySymbol: AutoNumeric.options.currencySymbol.none,
    minimumValue: AutoNumeric.options.minimumValue.zero,
    maximumValue: AutoNumeric.options.maximumValue.tenTrillions
  },
  numericNeg: {
    digitGroupSeparator: AutoNumeric.options.digitGroupSeparator.noSeparator,
    decimalCharacter: AutoNumeric.options.decimalCharacter.dot,
    currencySymbol: AutoNumeric.options.currencySymbol.none,
    minimumValue: AutoNumeric.options.minimumValue.tenTrillions,
    maximumValue: AutoNumeric.options.maximumValue.zero
  }
};
Object.getOwnPropertyNames(AutoNumeric.predefinedOptions).forEach((optionName) => {
  Object.freeze(AutoNumeric.predefinedOptions[optionName]);
});
Object.freeze(AutoNumeric.predefinedOptions);
Object.defineProperty(AutoNumeric, "predefinedOptions", { configurable: false, writable: false });
var numeral$1 = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function(module2) {
  (function(global2, factory2) {
    if (module2.exports) {
      module2.exports = factory2();
    } else {
      global2.numeral = factory2();
    }
  })(commonjsGlobal, function() {
    var numeral2, _2, VERSION = "2.0.6", formats2 = {}, locales2 = {}, defaults2 = {
      currentLocale: "en",
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: "0,0",
      scalePercentBy100: true
    }, options = {
      currentLocale: defaults2.currentLocale,
      zeroFormat: defaults2.zeroFormat,
      nullFormat: defaults2.nullFormat,
      defaultFormat: defaults2.defaultFormat,
      scalePercentBy100: defaults2.scalePercentBy100
    };
    function Numeral(input, number) {
      this._input = input;
      this._value = number;
    }
    numeral2 = function(input) {
      var value, kind, unformatFunction, regexp;
      if (numeral2.isNumeral(input)) {
        value = input.value();
      } else if (input === 0 || typeof input === "undefined") {
        value = 0;
      } else if (input === null || _2.isNaN(input)) {
        value = null;
      } else if (typeof input === "string") {
        if (options.zeroFormat && input === options.zeroFormat) {
          value = 0;
        } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, "").length) {
          value = null;
        } else {
          for (kind in formats2) {
            regexp = typeof formats2[kind].regexps.unformat === "function" ? formats2[kind].regexps.unformat() : formats2[kind].regexps.unformat;
            if (regexp && input.match(regexp)) {
              unformatFunction = formats2[kind].unformat;
              break;
            }
          }
          unformatFunction = unformatFunction || numeral2._.stringToNumber;
          value = unformatFunction(input);
        }
      } else {
        value = Number(input) || null;
      }
      return new Numeral(input, value);
    };
    numeral2.version = VERSION;
    numeral2.isNumeral = function(obj) {
      return obj instanceof Numeral;
    };
    numeral2._ = _2 = {
      // formats numbers separators, decimals places, signs, abbreviations
      numberToFormat: function(value, format3, roundingFunction) {
        var locale2 = locales2[numeral2.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = "", trillion = 1e12, billion = 1e9, million = 1e6, thousand = 1e3, decimal2 = "", neg = false, abbrForce, abs2, int, precision, signed, thousands, output;
        value = value || 0;
        abs2 = Math.abs(value);
        if (numeral2._.includes(format3, "(")) {
          negP = true;
          format3 = format3.replace(/[\(|\)]/g, "");
        } else if (numeral2._.includes(format3, "+") || numeral2._.includes(format3, "-")) {
          signed = numeral2._.includes(format3, "+") ? format3.indexOf("+") : value < 0 ? format3.indexOf("-") : -1;
          format3 = format3.replace(/[\+|\-]/g, "");
        }
        if (numeral2._.includes(format3, "a")) {
          abbrForce = format3.match(/a(k|m|b|t)?/);
          abbrForce = abbrForce ? abbrForce[1] : false;
          if (numeral2._.includes(format3, " a")) {
            abbr = " ";
          }
          format3 = format3.replace(new RegExp(abbr + "a[kmbt]?"), "");
          if (abs2 >= trillion && !abbrForce || abbrForce === "t") {
            abbr += locale2.abbreviations.trillion;
            value = value / trillion;
          } else if (abs2 < trillion && abs2 >= billion && !abbrForce || abbrForce === "b") {
            abbr += locale2.abbreviations.billion;
            value = value / billion;
          } else if (abs2 < billion && abs2 >= million && !abbrForce || abbrForce === "m") {
            abbr += locale2.abbreviations.million;
            value = value / million;
          } else if (abs2 < million && abs2 >= thousand && !abbrForce || abbrForce === "k") {
            abbr += locale2.abbreviations.thousand;
            value = value / thousand;
          }
        }
        if (numeral2._.includes(format3, "[.]")) {
          optDec = true;
          format3 = format3.replace("[.]", ".");
        }
        int = value.toString().split(".")[0];
        precision = format3.split(".")[1];
        thousands = format3.indexOf(",");
        leadingCount = (format3.split(".")[0].split(",")[0].match(/0/g) || []).length;
        if (precision) {
          if (numeral2._.includes(precision, "[")) {
            precision = precision.replace("]", "");
            precision = precision.split("[");
            decimal2 = numeral2._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
          } else {
            decimal2 = numeral2._.toFixed(value, precision.length, roundingFunction);
          }
          int = decimal2.split(".")[0];
          if (numeral2._.includes(decimal2, ".")) {
            decimal2 = locale2.delimiters.decimal + decimal2.split(".")[1];
          } else {
            decimal2 = "";
          }
          if (optDec && Number(decimal2.slice(1)) === 0) {
            decimal2 = "";
          }
        } else {
          int = numeral2._.toFixed(value, 0, roundingFunction);
        }
        if (abbr && !abbrForce && Number(int) >= 1e3 && abbr !== locale2.abbreviations.trillion) {
          int = String(Number(int) / 1e3);
          switch (abbr) {
            case locale2.abbreviations.thousand:
              abbr = locale2.abbreviations.million;
              break;
            case locale2.abbreviations.million:
              abbr = locale2.abbreviations.billion;
              break;
            case locale2.abbreviations.billion:
              abbr = locale2.abbreviations.trillion;
              break;
          }
        }
        if (numeral2._.includes(int, "-")) {
          int = int.slice(1);
          neg = true;
        }
        if (int.length < leadingCount) {
          for (var i3 = leadingCount - int.length; i3 > 0; i3--) {
            int = "0" + int;
          }
        }
        if (thousands > -1) {
          int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + locale2.delimiters.thousands);
        }
        if (format3.indexOf(".") === 0) {
          int = "";
        }
        output = int + decimal2 + (abbr ? abbr : "");
        if (negP) {
          output = (negP && neg ? "(" : "") + output + (negP && neg ? ")" : "");
        } else {
          if (signed >= 0) {
            output = signed === 0 ? (neg ? "-" : "+") + output : output + (neg ? "-" : "+");
          } else if (neg) {
            output = "-" + output;
          }
        }
        return output;
      },
      // unformats numbers separators, decimals places, signs, abbreviations
      stringToNumber: function(string3) {
        var locale2 = locales2[options.currentLocale], stringOriginal = string3, abbreviations = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        }, abbreviation, value, regexp;
        if (options.zeroFormat && string3 === options.zeroFormat) {
          value = 0;
        } else if (options.nullFormat && string3 === options.nullFormat || !string3.replace(/[^0-9]+/g, "").length) {
          value = null;
        } else {
          value = 1;
          if (locale2.delimiters.decimal !== ".") {
            string3 = string3.replace(/\./g, "").replace(locale2.delimiters.decimal, ".");
          }
          for (abbreviation in abbreviations) {
            regexp = new RegExp("[^a-zA-Z]" + locale2.abbreviations[abbreviation] + "(?:\\)|(\\" + locale2.currency.symbol + ")?(?:\\))?)?$");
            if (stringOriginal.match(regexp)) {
              value *= Math.pow(10, abbreviations[abbreviation]);
              break;
            }
          }
          value *= (string3.split("-").length + Math.min(string3.split("(").length - 1, string3.split(")").length - 1)) % 2 ? 1 : -1;
          string3 = string3.replace(/[^0-9\.]+/g, "");
          value *= Number(string3);
        }
        return value;
      },
      isNaN: function(value) {
        return typeof value === "number" && isNaN(value);
      },
      includes: function(string3, search) {
        return string3.indexOf(search) !== -1;
      },
      insert: function(string3, subString, start2) {
        return string3.slice(0, start2) + subString + string3.slice(start2);
      },
      reduce: function(array, callback) {
        if (this === null) {
          throw new TypeError("Array.prototype.reduce called on null or undefined");
        }
        if (typeof callback !== "function") {
          throw new TypeError(callback + " is not a function");
        }
        var t3 = Object(array), len = t3.length >>> 0, k3 = 0, value;
        if (arguments.length === 3) {
          value = arguments[2];
        } else {
          while (k3 < len && !(k3 in t3)) {
            k3++;
          }
          if (k3 >= len) {
            throw new TypeError("Reduce of empty array with no initial value");
          }
          value = t3[k3++];
        }
        for (; k3 < len; k3++) {
          if (k3 in t3) {
            value = callback(value, t3[k3], k3, t3);
          }
        }
        return value;
      },
      /**
       * Computes the multiplier necessary to make x >= 1,
       * effectively eliminating miscalculations caused by
       * finite precision.
       */
      multiplier: function(x3) {
        var parts = x3.toString().split(".");
        return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
      },
      /**
       * Given a variable number of arguments, returns the maximum
       * multiplier that must be used to normalize an operation involving
       * all of them.
       */
      correctionFactor: function() {
        var args = Array.prototype.slice.call(arguments);
        return args.reduce(function(accum, next3) {
          var mn2 = _2.multiplier(next3);
          return accum > mn2 ? accum : mn2;
        }, 1);
      },
      /**
       * Implementation of toFixed() that treats floats more like decimals
       *
       * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
       * problems for accounting- and finance-related software.
       */
      toFixed: function(value, maxDecimals, roundingFunction, optionals) {
        var splitValue = value.toString().split("."), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
        if (splitValue.length === 2) {
          boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
        } else {
          boundedPrecision = minDecimals;
        }
        power = Math.pow(10, boundedPrecision);
        output = (roundingFunction(value + "e+" + boundedPrecision) / power).toFixed(boundedPrecision);
        if (optionals > maxDecimals - boundedPrecision) {
          optionalsRegExp = new RegExp("\\.?0{1," + (optionals - (maxDecimals - boundedPrecision)) + "}$");
          output = output.replace(optionalsRegExp, "");
        }
        return output;
      }
    };
    numeral2.options = options;
    numeral2.formats = formats2;
    numeral2.locales = locales2;
    numeral2.locale = function(key2) {
      if (key2) {
        options.currentLocale = key2.toLowerCase();
      }
      return options.currentLocale;
    };
    numeral2.localeData = function(key2) {
      if (!key2) {
        return locales2[options.currentLocale];
      }
      key2 = key2.toLowerCase();
      if (!locales2[key2]) {
        throw new Error("Unknown locale : " + key2);
      }
      return locales2[key2];
    };
    numeral2.reset = function() {
      for (var property2 in defaults2) {
        options[property2] = defaults2[property2];
      }
    };
    numeral2.zeroFormat = function(format3) {
      options.zeroFormat = typeof format3 === "string" ? format3 : null;
    };
    numeral2.nullFormat = function(format3) {
      options.nullFormat = typeof format3 === "string" ? format3 : null;
    };
    numeral2.defaultFormat = function(format3) {
      options.defaultFormat = typeof format3 === "string" ? format3 : "0.0";
    };
    numeral2.register = function(type2, name2, format3) {
      name2 = name2.toLowerCase();
      if (this[type2 + "s"][name2]) {
        throw new TypeError(name2 + " " + type2 + " already registered.");
      }
      this[type2 + "s"][name2] = format3;
      return format3;
    };
    numeral2.validate = function(val, culture) {
      var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData2, temp;
      if (typeof val !== "string") {
        val += "";
        if (console.warn) {
          console.warn("Numeral.js: Value is not string. It has been co-erced to: ", val);
        }
      }
      val = val.trim();
      if (!!val.match(/^\d+$/)) {
        return true;
      }
      if (val === "") {
        return false;
      }
      try {
        localeData2 = numeral2.localeData(culture);
      } catch (e5) {
        localeData2 = numeral2.localeData(numeral2.locale());
      }
      _currSymbol = localeData2.currency.symbol;
      _abbrObj = localeData2.abbreviations;
      _decimalSep = localeData2.delimiters.decimal;
      if (localeData2.delimiters.thousands === ".") {
        _thousandSep = "\\.";
      } else {
        _thousandSep = localeData2.delimiters.thousands;
      }
      temp = val.match(/^[^\d]+/);
      if (temp !== null) {
        val = val.substr(1);
        if (temp[0] !== _currSymbol) {
          return false;
        }
      }
      temp = val.match(/[^\d]+$/);
      if (temp !== null) {
        val = val.slice(0, -1);
        if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
          return false;
        }
      }
      _thousandRegEx = new RegExp(_thousandSep + "{2}");
      if (!val.match(/[^\d.,]/g)) {
        _valArray = val.split(_decimalSep);
        if (_valArray.length > 2) {
          return false;
        } else {
          if (_valArray.length < 2) {
            return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
          } else {
            if (_valArray[0].length === 1) {
              return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
            } else {
              return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
            }
          }
        }
      }
      return false;
    };
    numeral2.fn = Numeral.prototype = {
      clone: function() {
        return numeral2(this);
      },
      format: function(inputString, roundingFunction) {
        var value = this._value, format3 = inputString || options.defaultFormat, kind, output, formatFunction;
        roundingFunction = roundingFunction || Math.round;
        if (value === 0 && options.zeroFormat !== null) {
          output = options.zeroFormat;
        } else if (value === null && options.nullFormat !== null) {
          output = options.nullFormat;
        } else {
          for (kind in formats2) {
            if (format3.match(formats2[kind].regexps.format)) {
              formatFunction = formats2[kind].format;
              break;
            }
          }
          formatFunction = formatFunction || numeral2._.numberToFormat;
          output = formatFunction(value, format3, roundingFunction);
        }
        return output;
      },
      value: function() {
        return this._value;
      },
      input: function() {
        return this._input;
      },
      set: function(value) {
        this._value = Number(value);
        return this;
      },
      add: function(value) {
        var corrFactor = _2.correctionFactor.call(null, this._value, value);
        function cback(accum, curr, currI, O3) {
          return accum + Math.round(corrFactor * curr);
        }
        this._value = _2.reduce([this._value, value], cback, 0) / corrFactor;
        return this;
      },
      subtract: function(value) {
        var corrFactor = _2.correctionFactor.call(null, this._value, value);
        function cback(accum, curr, currI, O3) {
          return accum - Math.round(corrFactor * curr);
        }
        this._value = _2.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
        return this;
      },
      multiply: function(value) {
        function cback(accum, curr, currI, O3) {
          var corrFactor = _2.correctionFactor(accum, curr);
          return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
        }
        this._value = _2.reduce([this._value, value], cback, 1);
        return this;
      },
      divide: function(value) {
        function cback(accum, curr, currI, O3) {
          var corrFactor = _2.correctionFactor(accum, curr);
          return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
        }
        this._value = _2.reduce([this._value, value], cback);
        return this;
      },
      difference: function(value) {
        return Math.abs(numeral2(this._value).subtract(value).value());
      }
    };
    numeral2.register("locale", "en", {
      delimiters: {
        thousands: ",",
        decimal: "."
      },
      abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
      },
      ordinal: function(number) {
        var b3 = number % 10;
        return ~~(number % 100 / 10) === 1 ? "th" : b3 === 1 ? "st" : b3 === 2 ? "nd" : b3 === 3 ? "rd" : "th";
      },
      currency: {
        symbol: "$"
      }
    });
    (function() {
      numeral2.register("format", "bps", {
        regexps: {
          format: /(BPS)/,
          unformat: /(BPS)/
        },
        format: function(value, format3, roundingFunction) {
          var space2 = numeral2._.includes(format3, " BPS") ? " " : "", output;
          value = value * 1e4;
          format3 = format3.replace(/\s?BPS/, "");
          output = numeral2._.numberToFormat(value, format3, roundingFunction);
          if (numeral2._.includes(output, ")")) {
            output = output.split("");
            output.splice(-1, 0, space2 + "BPS");
            output = output.join("");
          } else {
            output = output + space2 + "BPS";
          }
          return output;
        },
        unformat: function(string3) {
          return +(numeral2._.stringToNumber(string3) * 1e-4).toFixed(15);
        }
      });
    })();
    (function() {
      var decimal2 = {
        base: 1e3,
        suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }, binary = {
        base: 1024,
        suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      };
      var allSuffixes = decimal2.suffixes.concat(binary.suffixes.filter(function(item) {
        return decimal2.suffixes.indexOf(item) < 0;
      }));
      var unformatRegex = allSuffixes.join("|");
      unformatRegex = "(" + unformatRegex.replace("B", "B(?!PS)") + ")";
      numeral2.register("format", "bytes", {
        regexps: {
          format: /([0\s]i?b)/,
          unformat: new RegExp(unformatRegex)
        },
        format: function(value, format3, roundingFunction) {
          var output, bytes = numeral2._.includes(format3, "ib") ? binary : decimal2, suffix = numeral2._.includes(format3, " b") || numeral2._.includes(format3, " ib") ? " " : "", power, min2, max2;
          format3 = format3.replace(/\s?i?b/, "");
          for (power = 0; power <= bytes.suffixes.length; power++) {
            min2 = Math.pow(bytes.base, power);
            max2 = Math.pow(bytes.base, power + 1);
            if (value === null || value === 0 || value >= min2 && value < max2) {
              suffix += bytes.suffixes[power];
              if (min2 > 0) {
                value = value / min2;
              }
              break;
            }
          }
          output = numeral2._.numberToFormat(value, format3, roundingFunction);
          return output + suffix;
        },
        unformat: function(string3) {
          var value = numeral2._.stringToNumber(string3), power, bytesMultiplier;
          if (value) {
            for (power = decimal2.suffixes.length - 1; power >= 0; power--) {
              if (numeral2._.includes(string3, decimal2.suffixes[power])) {
                bytesMultiplier = Math.pow(decimal2.base, power);
                break;
              }
              if (numeral2._.includes(string3, binary.suffixes[power])) {
                bytesMultiplier = Math.pow(binary.base, power);
                break;
              }
            }
            value *= bytesMultiplier || 1;
          }
          return value;
        }
      });
    })();
    (function() {
      numeral2.register("format", "currency", {
        regexps: {
          format: /(\$)/
        },
        format: function(value, format3, roundingFunction) {
          var locale2 = numeral2.locales[numeral2.options.currentLocale], symbols2 = {
            before: format3.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: format3.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          }, output, symbol2, i3;
          format3 = format3.replace(/\s?\$\s?/, "");
          output = numeral2._.numberToFormat(value, format3, roundingFunction);
          if (value >= 0) {
            symbols2.before = symbols2.before.replace(/[\-\(]/, "");
            symbols2.after = symbols2.after.replace(/[\-\)]/, "");
          } else if (value < 0 && (!numeral2._.includes(symbols2.before, "-") && !numeral2._.includes(symbols2.before, "("))) {
            symbols2.before = "-" + symbols2.before;
          }
          for (i3 = 0; i3 < symbols2.before.length; i3++) {
            symbol2 = symbols2.before[i3];
            switch (symbol2) {
              case "$":
                output = numeral2._.insert(output, locale2.currency.symbol, i3);
                break;
              case " ":
                output = numeral2._.insert(output, " ", i3 + locale2.currency.symbol.length - 1);
                break;
            }
          }
          for (i3 = symbols2.after.length - 1; i3 >= 0; i3--) {
            symbol2 = symbols2.after[i3];
            switch (symbol2) {
              case "$":
                output = i3 === symbols2.after.length - 1 ? output + locale2.currency.symbol : numeral2._.insert(output, locale2.currency.symbol, -(symbols2.after.length - (1 + i3)));
                break;
              case " ":
                output = i3 === symbols2.after.length - 1 ? output + " " : numeral2._.insert(output, " ", -(symbols2.after.length - (1 + i3) + locale2.currency.symbol.length - 1));
                break;
            }
          }
          return output;
        }
      });
    })();
    (function() {
      numeral2.register("format", "exponential", {
        regexps: {
          format: /(e\+|e-)/,
          unformat: /(e\+|e-)/
        },
        format: function(value, format3, roundingFunction) {
          var output, exponential = typeof value === "number" && !numeral2._.isNaN(value) ? value.toExponential() : "0e+0", parts = exponential.split("e");
          format3 = format3.replace(/e[\+|\-]{1}0/, "");
          output = numeral2._.numberToFormat(Number(parts[0]), format3, roundingFunction);
          return output + "e" + parts[1];
        },
        unformat: function(string3) {
          var parts = numeral2._.includes(string3, "e+") ? string3.split("e+") : string3.split("e-"), value = Number(parts[0]), power = Number(parts[1]);
          power = numeral2._.includes(string3, "e-") ? power *= -1 : power;
          function cback(accum, curr, currI, O3) {
            var corrFactor = numeral2._.correctionFactor(accum, curr), num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
            return num;
          }
          return numeral2._.reduce([value, Math.pow(10, power)], cback, 1);
        }
      });
    })();
    (function() {
      numeral2.register("format", "ordinal", {
        regexps: {
          format: /(o)/
        },
        format: function(value, format3, roundingFunction) {
          var locale2 = numeral2.locales[numeral2.options.currentLocale], output, ordinal2 = numeral2._.includes(format3, " o") ? " " : "";
          format3 = format3.replace(/\s?o/, "");
          ordinal2 += locale2.ordinal(value);
          output = numeral2._.numberToFormat(value, format3, roundingFunction);
          return output + ordinal2;
        }
      });
    })();
    (function() {
      numeral2.register("format", "percentage", {
        regexps: {
          format: /(%)/,
          unformat: /(%)/
        },
        format: function(value, format3, roundingFunction) {
          var space2 = numeral2._.includes(format3, " %") ? " " : "", output;
          if (numeral2.options.scalePercentBy100) {
            value = value * 100;
          }
          format3 = format3.replace(/\s?\%/, "");
          output = numeral2._.numberToFormat(value, format3, roundingFunction);
          if (numeral2._.includes(output, ")")) {
            output = output.split("");
            output.splice(-1, 0, space2 + "%");
            output = output.join("");
          } else {
            output = output + space2 + "%";
          }
          return output;
        },
        unformat: function(string3) {
          var number = numeral2._.stringToNumber(string3);
          if (numeral2.options.scalePercentBy100) {
            return number * 0.01;
          }
          return number;
        }
      });
    })();
    (function() {
      numeral2.register("format", "time", {
        regexps: {
          format: /(:)/,
          unformat: /(:)/
        },
        format: function(value, format3, roundingFunction) {
          var hours2 = Math.floor(value / 60 / 60), minutes2 = Math.floor((value - hours2 * 60 * 60) / 60), seconds2 = Math.round(value - hours2 * 60 * 60 - minutes2 * 60);
          return hours2 + ":" + (minutes2 < 10 ? "0" + minutes2 : minutes2) + ":" + (seconds2 < 10 ? "0" + seconds2 : seconds2);
        },
        unformat: function(string3) {
          var timeArray = string3.split(":"), seconds2 = 0;
          if (timeArray.length === 3) {
            seconds2 = seconds2 + Number(timeArray[0]) * 60 * 60;
            seconds2 = seconds2 + Number(timeArray[1]) * 60;
            seconds2 = seconds2 + Number(timeArray[2]);
          } else if (timeArray.length === 2) {
            seconds2 = seconds2 + Number(timeArray[0]) * 60;
            seconds2 = seconds2 + Number(timeArray[1]);
          }
          return Number(seconds2);
        }
      });
    })();
    return numeral2;
  });
})(numeral$1);
var numeralExports = numeral$1.exports;
const numeral = /* @__PURE__ */ getDefaultExportFromCjs$1(numeralExports);
const styles$r = () => ({
  numericInput: {
    textAlign: "right",
    fontSize: 14,
    fontFamily: "inherit",
    fontWeight: "normal",
    boxSizing: "border-box",
    padding: 11,
    outline: "none",
    background: "transparent",
    color: "inherit",
    margin: 0,
    border: "1px solid rgba(0, 0, 0, 0.33)",
    borderRadius: 0,
    width: "100%",
    backgroundColor: "white"
  },
  negative: {
    color: "red"
  }
});
class NumericInput extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "inputRef", React__default.createRef());
    __publicField(this, "state", {
      value: this.props.value
    });
    __publicField(this, "handleChange", (event) => {
      const temp = numeral(event.target.value).value();
      const value = temp === null ? void 0 : temp;
      this.setState({ value });
      this.props.onChange(value);
    });
    __publicField(this, "isNegative", () => this.state.value < 0);
  }
  componentDidMount() {
    this.inputRef.current.value = String(this.state.value);
    new AutoNumeric(this.inputRef.current);
  }
  render() {
    const { classes, ...otherProps } = this.props;
    return /* @__PURE__ */ jsx$1(
      "input",
      {
        ref: this.inputRef,
        className: classNames(
          classes.numericInput,
          this.isNegative() && classes.negative
        ),
        ...otherProps
      }
    );
  }
}
const NumericInput$1 = injectSheet(styles$r)(NumericInput);
function isObject$d(thing) {
  if (typeof File !== "undefined" && thing instanceof File) {
    return false;
  }
  if (typeof Date !== "undefined" && thing instanceof Date) {
    return false;
  }
  return typeof thing === "object" && thing !== null && !Array.isArray(thing);
}
function allowAdditionalItems(schema) {
  if (schema.additionalItems === true) {
    console.warn("additionalItems=true is currently not supported");
  }
  return isObject$d(schema.additionalItems);
}
function asNumber$1(value) {
  if (value === "") {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  if (/\.$/.test(value)) {
    return value;
  }
  if (/\.0$/.test(value)) {
    return value;
  }
  if (/\.\d*0$/.test(value)) {
    return value;
  }
  const n2 = Number(value);
  const valid = typeof n2 === "number" && !Number.isNaN(n2);
  return valid ? n2 : value;
}
const ADDITIONAL_PROPERTY_FLAG = "__additional_property";
const ADDITIONAL_PROPERTIES_KEY = "additionalProperties";
const ALL_OF_KEY = "allOf";
const ANY_OF_KEY = "anyOf";
const CONST_KEY = "const";
const DEFAULT_KEY = "default";
const DEPENDENCIES_KEY = "dependencies";
const ENUM_KEY = "enum";
const ERRORS_KEY = "__errors";
const ID_KEY = "$id";
const IF_KEY = "if";
const ITEMS_KEY = "items";
const JUNK_OPTION_ID = "_$junk_option_schema_id$_";
const NAME_KEY = "$name";
const ONE_OF_KEY = "oneOf";
const PROPERTIES_KEY = "properties";
const REQUIRED_KEY = "required";
const SUBMIT_BTN_OPTIONS_KEY = "submitButtonOptions";
const REF_KEY = "$ref";
const RJSF_ADDITIONAL_PROPERTIES_FLAG = "__rjsf_additionalProperties";
const ROOT_SCHEMA_PREFIX = "__rjsf_rootSchema";
const UI_FIELD_KEY = "ui:field";
const UI_WIDGET_KEY = "ui:widget";
const UI_OPTIONS_KEY = "ui:options";
const UI_GLOBAL_OPTIONS_KEY = "ui:globalOptions";
function getUiOptions(uiSchema = {}, globalOptions = {}) {
  return Object.keys(uiSchema).filter((key2) => key2.indexOf("ui:") === 0).reduce((options, key2) => {
    const value = uiSchema[key2];
    if (key2 === UI_WIDGET_KEY && isObject$d(value)) {
      console.error("Setting options via ui:widget object is no longer supported, use ui:options instead");
      return options;
    }
    if (key2 === UI_OPTIONS_KEY && isObject$d(value)) {
      return { ...options, ...value };
    }
    return { ...options, [key2.substring(3)]: value };
  }, { ...globalOptions });
}
function canExpand(schema, uiSchema = {}, formData) {
  if (!schema.additionalProperties) {
    return false;
  }
  const { expandable = true } = getUiOptions(uiSchema);
  if (expandable === false) {
    return expandable;
  }
  if (schema.maxProperties !== void 0 && formData) {
    return Object.keys(formData).length < schema.maxProperties;
  }
  return true;
}
function overArg$2(func, transform2) {
  return function(arg) {
    return func(transform2(arg));
  };
}
var _overArg = overArg$2;
var overArg$1 = _overArg;
var getPrototype$4 = overArg$1(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$4;
var baseGetTag$7 = _baseGetTag, getPrototype$3 = _getPrototype, isObjectLike$a = isObjectLike_1;
var objectTag$4 = "[object Object]";
var funcProto$2 = Function.prototype, objectProto$g = Object.prototype;
var funcToString$2 = funcProto$2.toString;
var hasOwnProperty$e = objectProto$g.hasOwnProperty;
var objectCtorString = funcToString$2.call(Object);
function isPlainObject$6(value) {
  if (!isObjectLike$a(value) || baseGetTag$7(value) != objectTag$4) {
    return false;
  }
  var proto2 = getPrototype$3(value);
  if (proto2 === null) {
    return true;
  }
  var Ctor = hasOwnProperty$e.call(proto2, "constructor") && proto2.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}
var isPlainObject_1 = isPlainObject$6;
const isPlainObject$7 = /* @__PURE__ */ getDefaultExportFromCjs$1(isPlainObject_1);
function createErrorHandler(formData) {
  const handler = {
    // We store the list of errors for this node in a property named __errors
    // to avoid name collision with a possible sub schema field named
    // 'errors' (see `utils.toErrorSchema`).
    [ERRORS_KEY]: [],
    addError(message2) {
      this[ERRORS_KEY].push(message2);
    }
  };
  if (Array.isArray(formData)) {
    return formData.reduce((acc, value, key2) => {
      return { ...acc, [key2]: createErrorHandler(value) };
    }, handler);
  }
  if (isPlainObject$7(formData)) {
    const formObject = formData;
    return Object.keys(formObject).reduce((acc, key2) => {
      return { ...acc, [key2]: createErrorHandler(formObject[key2]) };
    }, handler);
  }
  return handler;
}
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$6(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$6;
var eq$5 = eq_1;
function assocIndexOf$4(array, key2) {
  var length = array.length;
  while (length--) {
    if (eq$5(array[length][0], key2)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto$1 = Array.prototype;
var splice$1 = arrayProto$1.splice;
function listCacheDelete$1(key2) {
  var data = this.__data__, index2 = assocIndexOf$3(data, key2);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index2, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key2) {
  var data = this.__data__, index2 = assocIndexOf$2(data, key2);
  return index2 < 0 ? void 0 : data[index2][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key2) {
  return assocIndexOf$1(this.__data__, key2) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key2, value) {
  var data = this.__data__, index2 = assocIndexOf(data, key2);
  if (index2 < 0) {
    ++this.size;
    data.push([key2, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var ListCache$3 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$3();
  this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key2) {
  var data = this.__data__, result2 = data["delete"](key2);
  this.size = data.size;
  return result2;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key2) {
  return this.__data__.get(key2);
}
var _stackGet = stackGet$1;
function stackHas$1(key2) {
  return this.__data__.has(key2);
}
var _stackHas = stackHas$1;
var baseGetTag$6 = _baseGetTag, isObject$c = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$a(value) {
  if (!isObject$c(value)) {
    return false;
  }
  var tag2 = baseGetTag$6(value);
  return tag2 == funcTag$2 || tag2 == genTag$1 || tag2 == asyncTag || tag2 == proxyTag;
}
var isFunction_1 = isFunction$a;
var root$6 = _root;
var coreJsData$1 = root$6["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid2 = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid2 ? "Symbol(src)_1." + uid2 : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e5) {
    }
    try {
      return func + "";
    } catch (e5) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$9 = isFunction_1, isMasked = _isMasked, isObject$b = isObject_1, toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$f = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$d = objectProto$f.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$d).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject$b(value) || isMasked(value)) {
    return false;
  }
  var pattern2 = isFunction$9(value) ? reIsNative : reIsHostCtor;
  return pattern2.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$2(object, key2) {
  return object == null ? void 0 : object[key2];
}
var _getValue = getValue$2;
var baseIsNative = _baseIsNative, getValue$1 = _getValue;
function getNative$7(object, key2) {
  var value = getValue$1(object, key2);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$7;
var getNative$6 = _getNative, root$5 = _root;
var Map$4 = getNative$6(root$5, "Map");
var _Map = Map$4;
var getNative$5 = _getNative;
var nativeCreate$4 = getNative$5(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key2) {
  var result2 = this.has(key2) && delete this.__data__[key2];
  this.size -= result2 ? 1 : 0;
  return result2;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$e = Object.prototype;
var hasOwnProperty$c = objectProto$e.hasOwnProperty;
function hashGet$1(key2) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result2 = data[key2];
    return result2 === HASH_UNDEFINED$2 ? void 0 : result2;
  }
  return hasOwnProperty$c.call(data, key2) ? data[key2] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$d = Object.prototype;
var hasOwnProperty$b = objectProto$d.hasOwnProperty;
function hashHas$1(key2) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key2] !== void 0 : hasOwnProperty$b.call(data, key2);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key2, value) {
  var data = this.__data__;
  this.size += this.has(key2) ? 0 : 1;
  data[key2] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
var Hash = _Hash, ListCache$2 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache$2)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type2 = typeof value;
  return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map2, key2) {
  var data = map2.__data__;
  return isKeyable(key2) ? data[typeof key2 == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key2) {
  var result2 = getMapData$3(this, key2)["delete"](key2);
  this.size -= result2 ? 1 : 0;
  return result2;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key2) {
  return getMapData$2(this, key2).get(key2);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key2) {
  return getMapData$1(this, key2).has(key2);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key2, value) {
  var data = getMapData(this, key2), size2 = data.size;
  data.set(key2, value);
  this.size += data.size == size2 ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype["delete"] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;
var ListCache$1 = _ListCache, Map$2 = _Map, MapCache$2 = _MapCache;
var LARGE_ARRAY_SIZE$2 = 200;
function stackSet$1(key2, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$2 - 1) {
      pairs.push([key2, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key2, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$4(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack$4.prototype.clear = stackClear;
Stack$4.prototype["delete"] = stackDelete;
Stack$4.prototype.get = stackGet;
Stack$4.prototype.has = stackHas;
Stack$4.prototype.set = stackSet;
var _Stack = Stack$4;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache$1 = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$4(values) {
  var index2 = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache$1();
  while (++index2 < length) {
    this.add(values[index2]);
  }
}
SetCache$4.prototype.add = SetCache$4.prototype.push = setCacheAdd;
SetCache$4.prototype.has = setCacheHas;
var _SetCache = SetCache$4;
function arraySome$1(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (predicate(array[index2], index2, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;
function cacheHas$4(cache2, key2) {
  return cache2.has(key2);
}
var _cacheHas = cacheHas$4;
var SetCache$3 = _SetCache, arraySome = _arraySome, cacheHas$3 = _cacheHas;
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache$3() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index2 < arrLength) {
    var arrValue = array[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result2 = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas$3(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result2 = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result2 = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result2;
}
var _equalArrays = equalArrays$2;
var root$4 = _root;
var Uint8Array$3 = root$4.Uint8Array;
var _Uint8Array = Uint8Array$3;
function mapToArray$1(map2) {
  var index2 = -1, result2 = Array(map2.size);
  map2.forEach(function(value, key2) {
    result2[++index2] = [key2, value];
  });
  return result2;
}
var _mapToArray = mapToArray$1;
function setToArray$3(set2) {
  var index2 = -1, result2 = Array(set2.size);
  set2.forEach(function(value) {
    result2[++index2] = value;
  });
  return result2;
}
var _setToArray = setToArray$3;
var Symbol$4 = _Symbol, Uint8Array$2 = _Uint8Array, eq$4 = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray$2 = _setToArray;
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag$4 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", mapTag$6 = "[object Map]", numberTag$4 = "[object Number]", regexpTag$3 = "[object RegExp]", setTag$6 = "[object Set]", stringTag$4 = "[object String]", symbolTag$2 = "[object Symbol]";
var arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]";
var symbolProto$2 = Symbol$4 ? Symbol$4.prototype : void 0, symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;
function equalByTag$1(object, other, tag2, bitmask, customizer, equalFunc, stack) {
  switch (tag2) {
    case dataViewTag$4:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag$3:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }
      return true;
    case boolTag$4:
    case dateTag$3:
    case numberTag$4:
      return eq$4(+object, +other);
    case errorTag$2:
      return object.name == other.name && object.message == other.message;
    case regexpTag$3:
    case stringTag$4:
      return object == other + "";
    case mapTag$6:
      var convert2 = mapToArray;
    case setTag$6:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert2 || (convert2 = setToArray$2);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object, other);
      var result2 = equalArrays$1(convert2(object), convert2(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result2;
    case symbolTag$2:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;
function arrayPush$3(array, values) {
  var index2 = -1, length = values.length, offset2 = array.length;
  while (++index2 < length) {
    array[offset2 + index2] = values[index2];
  }
  return array;
}
var _arrayPush = arrayPush$3;
var isArray$o = Array.isArray;
var isArray_1 = isArray$o;
var arrayPush$2 = _arrayPush, isArray$n = isArray_1;
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result2 = keysFunc(object);
  return isArray$n(object) ? result2 : arrayPush$2(result2, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$2;
function arrayFilter$1(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
  while (++index2 < length) {
    var value = array[index2];
    if (predicate(value, index2, array)) {
      result2[resIndex++] = value;
    }
  }
  return result2;
}
var _arrayFilter = arrayFilter$1;
function stubArray$2() {
  return [];
}
var stubArray_1 = stubArray$2;
var arrayFilter = _arrayFilter, stubArray$1 = stubArray_1;
var objectProto$c = Object.prototype;
var propertyIsEnumerable$1 = objectProto$c.propertyIsEnumerable;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol2) {
    return propertyIsEnumerable$1.call(object, symbol2);
  });
};
var _getSymbols = getSymbols$3;
function baseTimes$2(n2, iteratee) {
  var index2 = -1, result2 = Array(n2);
  while (++index2 < n2) {
    result2[index2] = iteratee(index2);
  }
  return result2;
}
var _baseTimes = baseTimes$2;
var baseGetTag$5 = _baseGetTag, isObjectLike$9 = isObjectLike_1;
var argsTag$3 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$9(value) && baseGetTag$5(value) == argsTag$3;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$8 = isObjectLike_1;
var objectProto$b = Object.prototype;
var hasOwnProperty$a = objectProto$b.hasOwnProperty;
var propertyIsEnumerable2 = objectProto$b.propertyIsEnumerable;
var isArguments$8 = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$8(value) && hasOwnProperty$a.call(value, "callee") && !propertyIsEnumerable2.call(value, "callee");
};
var isArguments_1 = isArguments$8;
var isBuffer$8 = { exports: {} };
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
isBuffer$8.exports;
(function(module2, exports) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer2 = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  module2.exports = isBuffer2;
})(isBuffer$8, isBuffer$8.exports);
var isBufferExports = isBuffer$8.exports;
var MAX_SAFE_INTEGER$2 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$4(value, length) {
  var type2 = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$2 : length;
  return !!length && (type2 == "number" || type2 != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var _isIndex = isIndex$4;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength$3(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}
var isLength_1 = isLength$3;
var baseGetTag$4 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$7 = isObjectLike_1;
var argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$3 = "[object Boolean]", dateTag$2 = "[object Date]", errorTag$1 = "[object Error]", funcTag$1 = "[object Function]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", objectTag$3 = "[object Object]", regexpTag$2 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", weakMapTag$2 = "[object WeakMap]";
var arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$3 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$2] = typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$2] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$7(value) && isLength$2(value.length) && !!typedArrayTags[baseGetTag$4(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$7(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$7;
var _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(module2, exports) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types2 = freeModule && freeModule.require && freeModule.require("util").types;
      if (types2) {
        return types2;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e5) {
    }
  }();
  module2.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports;
var baseIsTypedArray = _baseIsTypedArray, baseUnary$6 = _baseUnary, nodeUtil$2 = _nodeUtilExports;
var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;
var isTypedArray$5 = nodeIsTypedArray ? baseUnary$6(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$5;
var baseTimes$1 = _baseTimes, isArguments$7 = isArguments_1, isArray$m = isArray_1, isBuffer$7 = isBufferExports, isIndex$3 = _isIndex, isTypedArray$4 = isTypedArray_1;
var objectProto$a = Object.prototype;
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$m(value), isArg = !isArr && isArguments$7(value), isBuff = !isArr && !isArg && isBuffer$7(value), isType = !isArr && !isArg && !isBuff && isTypedArray$4(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes$1(value.length, String) : [], length = result2.length;
  for (var key2 in value) {
    if ((inherited || hasOwnProperty$9.call(value, key2)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key2 == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key2 == "offset" || key2 == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key2 == "buffer" || key2 == "byteLength" || key2 == "byteOffset") || // Skip index properties.
    isIndex$3(key2, length)))) {
      result2.push(key2);
    }
  }
  return result2;
}
var _arrayLikeKeys = arrayLikeKeys$2;
var objectProto$9 = Object.prototype;
function isPrototype$4(value) {
  var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto$9;
  return value === proto2;
}
var _isPrototype = isPrototype$4;
var overArg = _overArg;
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype$3 = _isPrototype, nativeKeys = _nativeKeys;
var objectProto$8 = Object.prototype;
var hasOwnProperty$8 = objectProto$8.hasOwnProperty;
function baseKeys$2(object) {
  if (!isPrototype$3(object)) {
    return nativeKeys(object);
  }
  var result2 = [];
  for (var key2 in Object(object)) {
    if (hasOwnProperty$8.call(object, key2) && key2 != "constructor") {
      result2.push(key2);
    }
  }
  return result2;
}
var _baseKeys = baseKeys$2;
var isFunction$8 = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$7(value) {
  return value != null && isLength$1(value.length) && !isFunction$8(value);
}
var isArrayLike_1 = isArrayLike$7;
var arrayLikeKeys$1 = _arrayLikeKeys, baseKeys$1 = _baseKeys, isArrayLike$6 = isArrayLike_1;
function keys$d(object) {
  return isArrayLike$6(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
}
var keys_1 = keys$d;
var baseGetAllKeys$1 = _baseGetAllKeys, getSymbols$2 = _getSymbols, keys$c = keys_1;
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$c, getSymbols$2);
}
var _getAllKeys = getAllKeys$2;
var getAllKeys$1 = _getAllKeys;
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$7 = Object.prototype;
var hasOwnProperty$7 = objectProto$7.hasOwnProperty;
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys$1(object), objLength = objProps.length, othProps = getAllKeys$1(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key2 = objProps[index2];
    if (!(isPartial ? key2 in other : hasOwnProperty$7.call(other, key2))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result2 = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key2 = objProps[index2];
    var objValue = object[key2], othValue = other[key2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key2, other, object, stack) : customizer(objValue, othValue, key2, object, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result2 = false;
      break;
    }
    skipCtor || (skipCtor = key2 == "constructor");
  }
  if (result2 && !skipCtor) {
    var objCtor = object.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result2 = false;
    }
  }
  stack["delete"](object);
  stack["delete"](other);
  return result2;
}
var _equalObjects = equalObjects$1;
var getNative$4 = _getNative, root$3 = _root;
var DataView$2 = getNative$4(root$3, "DataView");
var _DataView = DataView$2;
var getNative$3 = _getNative, root$2 = _root;
var Promise$2 = getNative$3(root$2, "Promise");
var _Promise = Promise$2;
var getNative$2 = _getNative, root$1 = _root;
var Set$3 = getNative$2(root$1, "Set");
var _Set = Set$3;
var getNative$1 = _getNative, root = _root;
var WeakMap$2 = getNative$1(root, "WeakMap");
var _WeakMap = WeakMap$2;
var DataView$1 = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$2 = _Set, WeakMap$1 = _WeakMap, baseGetTag$3 = _baseGetTag, toSource = _toSource;
var mapTag$4 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$4 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$2 = "[object DataView]";
var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$1);
var getTag$5 = baseGetTag$3;
if (DataView$1 && getTag$5(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2 || Map$1 && getTag$5(new Map$1()) != mapTag$4 || Promise$1 && getTag$5(Promise$1.resolve()) != promiseTag || Set$2 && getTag$5(new Set$2()) != setTag$4 || WeakMap$1 && getTag$5(new WeakMap$1()) != weakMapTag$1) {
  getTag$5 = function(value) {
    var result2 = baseGetTag$3(value), Ctor = result2 == objectTag$2 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;
        case mapCtorString:
          return mapTag$4;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$4;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result2;
  };
}
var _getTag = getTag$5;
var Stack$3 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag$4 = _getTag, isArray$l = isArray_1, isBuffer$6 = isBufferExports, isTypedArray$3 = isTypedArray_1;
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", objectTag$1 = "[object Object]";
var objectProto$6 = Object.prototype;
var hasOwnProperty$6 = objectProto$6.hasOwnProperty;
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$l(object), othIsArr = isArray$l(other), objTag = objIsArr ? arrayTag$1 : getTag$4(object), othTag = othIsArr ? arrayTag$1 : getTag$4(other);
  objTag = objTag == argsTag$1 ? objectTag$1 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$1 : othTag;
  var objIsObj = objTag == objectTag$1, othIsObj = othTag == objectTag$1, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$6(object)) {
    if (!isBuffer$6(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$3());
    return objIsArr || isTypedArray$3(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$6.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$6.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$3());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$3());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike$6 = isObjectLike_1;
function baseIsEqual$4(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike$6(value) && !isObjectLike$6(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$4, stack);
}
var _baseIsEqual = baseIsEqual$4;
var baseIsEqual$3 = _baseIsEqual;
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == "function" ? customizer : void 0;
  var result2 = customizer ? customizer(value, other) : void 0;
  return result2 === void 0 ? baseIsEqual$3(value, other, void 0, customizer) : !!result2;
}
var isEqualWith_1 = isEqualWith;
const isEqualWith$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(isEqualWith_1);
function deepEquals(a4, b3) {
  return isEqualWith$1(a4, b3, (obj, other) => {
    if (typeof obj === "function" && typeof other === "function") {
      return true;
    }
    return void 0;
  });
}
var isArray$k = isArray_1, isSymbol$4 = isSymbol_1;
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(value, object) {
  if (isArray$k(value)) {
    return false;
  }
  var type2 = typeof value;
  if (type2 == "number" || type2 == "symbol" || type2 == "boolean" || value == null || isSymbol$4(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var _isKey = isKey$3;
var MapCache = _MapCache;
var FUNC_ERROR_TEXT = "Expected a function";
function memoize$1(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key2 = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key2)) {
      return cache2.get(key2);
    }
    var result2 = func.apply(this, args);
    memoized.cache = cache2.set(key2, result2) || cache2;
    return result2;
  };
  memoized.cache = new (memoize$1.Cache || MapCache)();
  return memoized;
}
memoize$1.Cache = MapCache;
var memoize_1 = memoize$1;
var memoize = memoize_1;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func) {
  var result2 = memoize(func, function(key2) {
    if (cache2.size === MAX_MEMOIZE_SIZE) {
      cache2.clear();
    }
    return key2;
  });
  var cache2 = result2.cache;
  return result2;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar$1 = /\\(\\)?/g;
var stringToPath$3 = memoizeCapped(function(string3) {
  var result2 = [];
  if (string3.charCodeAt(0) === 46) {
    result2.push("");
  }
  string3.replace(rePropName$1, function(match5, number, quote, subString) {
    result2.push(quote ? subString.replace(reEscapeChar$1, "$1") : number || match5);
  });
  return result2;
});
var _stringToPath = stringToPath$3;
function arrayMap$9(array, iteratee) {
  var index2 = -1, length = array == null ? 0 : array.length, result2 = Array(length);
  while (++index2 < length) {
    result2[index2] = iteratee(array[index2], index2, array);
  }
  return result2;
}
var _arrayMap = arrayMap$9;
var Symbol$3 = _Symbol, arrayMap$8 = _arrayMap, isArray$j = isArray_1, isSymbol$3 = isSymbol_1;
var INFINITY$4 = 1 / 0;
var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$j(value)) {
    return arrayMap$8(value, baseToString$1) + "";
  }
  if (isSymbol$3(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result2 = value + "";
  return result2 == "0" && 1 / value == -INFINITY$4 ? "-0" : result2;
}
var _baseToString = baseToString$1;
var baseToString = _baseToString;
function toString$6(value) {
  return value == null ? "" : baseToString(value);
}
var toString_1 = toString$6;
var isArray$i = isArray_1, isKey$2 = _isKey, stringToPath$2 = _stringToPath, toString$5 = toString_1;
function castPath$6(value, object) {
  if (isArray$i(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath$2(toString$5(value));
}
var _castPath = castPath$6;
var isSymbol$2 = isSymbol_1;
var INFINITY$3 = 1 / 0;
function toKey$7(value) {
  if (typeof value == "string" || isSymbol$2(value)) {
    return value;
  }
  var result2 = value + "";
  return result2 == "0" && 1 / value == -INFINITY$3 ? "-0" : result2;
}
var _toKey = toKey$7;
var castPath$5 = _castPath, toKey$6 = _toKey;
function baseGet$5(object, path3) {
  path3 = castPath$5(path3, object);
  var index2 = 0, length = path3.length;
  while (object != null && index2 < length) {
    object = object[toKey$6(path3[index2++])];
  }
  return index2 && index2 == length ? object : void 0;
}
var _baseGet = baseGet$5;
var baseGet$4 = _baseGet;
function get$5(object, path3, defaultValue) {
  var result2 = object == null ? void 0 : baseGet$4(object, path3);
  return result2 === void 0 ? defaultValue : result2;
}
var get_1 = get$5;
const get$6 = /* @__PURE__ */ getDefaultExportFromCjs$1(get_1);
var baseKeys = _baseKeys, getTag$3 = _getTag, isArguments$6 = isArguments_1, isArray$h = isArray_1, isArrayLike$5 = isArrayLike_1, isBuffer$5 = isBufferExports, isPrototype$2 = _isPrototype, isTypedArray$2 = isTypedArray_1;
var mapTag$3 = "[object Map]", setTag$3 = "[object Set]";
var objectProto$5 = Object.prototype;
var hasOwnProperty$5 = objectProto$5.hasOwnProperty;
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike$5(value) && (isArray$h(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer$5(value) || isTypedArray$2(value) || isArguments$6(value))) {
    return !value.length;
  }
  var tag2 = getTag$3(value);
  if (tag2 == mapTag$3 || tag2 == setTag$3) {
    return !value.size;
  }
  if (isPrototype$2(value)) {
    return !baseKeys(value).length;
  }
  for (var key2 in value) {
    if (hasOwnProperty$5.call(value, key2)) {
      return false;
    }
  }
  return true;
}
var isEmpty_1 = isEmpty;
const _isEmpty = /* @__PURE__ */ getDefaultExportFromCjs$1(isEmpty_1);
var jsonpointer = {};
var hasExcape = /~/;
var escapeMatcher = /~[01]/g;
function escapeReplacer(m4) {
  switch (m4) {
    case "~1":
      return "/";
    case "~0":
      return "~";
  }
  throw new Error("Invalid tilde escape: " + m4);
}
function untilde(str) {
  if (!hasExcape.test(str)) return str;
  return str.replace(escapeMatcher, escapeReplacer);
}
function setter(obj, pointer, value) {
  var part;
  var hasNextPart;
  for (var p2 = 1, len = pointer.length; p2 < len; ) {
    if (pointer[p2] === "constructor" || pointer[p2] === "prototype" || pointer[p2] === "__proto__") return obj;
    part = untilde(pointer[p2++]);
    hasNextPart = len > p2;
    if (typeof obj[part] === "undefined") {
      if (Array.isArray(obj) && part === "-") {
        part = obj.length;
      }
      if (hasNextPart) {
        if (pointer[p2] !== "" && pointer[p2] < Infinity || pointer[p2] === "-") obj[part] = [];
        else obj[part] = {};
      }
    }
    if (!hasNextPart) break;
    obj = obj[part];
  }
  var oldValue = obj[part];
  if (value === void 0) delete obj[part];
  else obj[part] = value;
  return oldValue;
}
function compilePointer(pointer) {
  if (typeof pointer === "string") {
    pointer = pointer.split("/");
    if (pointer[0] === "") return pointer;
    throw new Error("Invalid JSON pointer.");
  } else if (Array.isArray(pointer)) {
    for (const part of pointer) {
      if (typeof part !== "string" && typeof part !== "number") {
        throw new Error("Invalid JSON pointer. Must be of type string or number.");
      }
    }
    return pointer;
  }
  throw new Error("Invalid JSON pointer.");
}
function get$4(obj, pointer) {
  if (typeof obj !== "object") throw new Error("Invalid input object.");
  pointer = compilePointer(pointer);
  var len = pointer.length;
  if (len === 1) return obj;
  for (var p2 = 1; p2 < len; ) {
    obj = obj[untilde(pointer[p2++])];
    if (len === p2) return obj;
    if (typeof obj !== "object" || obj === null) return void 0;
  }
}
function set$4(obj, pointer, value) {
  if (typeof obj !== "object") throw new Error("Invalid input object.");
  pointer = compilePointer(pointer);
  if (pointer.length === 0) throw new Error("Invalid JSON pointer for set.");
  return setter(obj, pointer, value);
}
function compile$1(pointer) {
  var compiled = compilePointer(pointer);
  return {
    get: function(object) {
      return get$4(object, compiled);
    },
    set: function(object, value) {
      return set$4(object, compiled, value);
    }
  };
}
jsonpointer.get = get$4;
jsonpointer.set = set$4;
jsonpointer.compile = compile$1;
function arrayEach$3(array, iteratee) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (iteratee(array[index2], index2, array) === false) {
      break;
    }
  }
  return array;
}
var _arrayEach = arrayEach$3;
var getNative = _getNative;
var defineProperty$6 = function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e5) {
  }
}();
var _defineProperty$1 = defineProperty$6;
var defineProperty$5 = _defineProperty$1;
function baseAssignValue$3(object, key2, value) {
  if (key2 == "__proto__" && defineProperty$5) {
    defineProperty$5(object, key2, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object[key2] = value;
  }
}
var _baseAssignValue = baseAssignValue$3;
var baseAssignValue$2 = _baseAssignValue, eq$3 = eq_1;
var objectProto$4 = Object.prototype;
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
function assignValue$3(object, key2, value) {
  var objValue = object[key2];
  if (!(hasOwnProperty$4.call(object, key2) && eq$3(objValue, value)) || value === void 0 && !(key2 in object)) {
    baseAssignValue$2(object, key2, value);
  }
}
var _assignValue = assignValue$3;
var assignValue$2 = _assignValue, baseAssignValue$1 = _baseAssignValue;
function copyObject$6(source, props2, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index2 = -1, length = props2.length;
  while (++index2 < length) {
    var key2 = props2[index2];
    var newValue = customizer ? customizer(object[key2], source[key2], key2, object, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key2];
    }
    if (isNew) {
      baseAssignValue$1(object, key2, newValue);
    } else {
      assignValue$2(object, key2, newValue);
    }
  }
  return object;
}
var _copyObject = copyObject$6;
var copyObject$5 = _copyObject, keys$b = keys_1;
function baseAssign$1(object, source) {
  return object && copyObject$5(source, keys$b(source), object);
}
var _baseAssign = baseAssign$1;
function nativeKeysIn$1(object) {
  var result2 = [];
  if (object != null) {
    for (var key2 in Object(object)) {
      result2.push(key2);
    }
  }
  return result2;
}
var _nativeKeysIn = nativeKeysIn$1;
var isObject$a = isObject_1, isPrototype$1 = _isPrototype, nativeKeysIn = _nativeKeysIn;
var objectProto$3 = Object.prototype;
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function baseKeysIn$1(object) {
  if (!isObject$a(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object), result2 = [];
  for (var key2 in object) {
    if (!(key2 == "constructor" && (isProto || !hasOwnProperty$3.call(object, key2)))) {
      result2.push(key2);
    }
  }
  return result2;
}
var _baseKeysIn = baseKeysIn$1;
var arrayLikeKeys = _arrayLikeKeys, baseKeysIn = _baseKeysIn, isArrayLike$4 = isArrayLike_1;
function keysIn$6(object) {
  return isArrayLike$4(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
var keysIn_1 = keysIn$6;
var copyObject$4 = _copyObject, keysIn$5 = keysIn_1;
function baseAssignIn$1(object, source) {
  return object && copyObject$4(source, keysIn$5(source), object);
}
var _baseAssignIn = baseAssignIn$1;
var _cloneBuffer = { exports: {} };
_cloneBuffer.exports;
(function(module2, exports) {
  var root2 = _root;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer2 = moduleExports ? root2.Buffer : void 0, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : void 0;
  function cloneBuffer2(buffer2, isDeep) {
    if (isDeep) {
      return buffer2.slice();
    }
    var length = buffer2.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer2.constructor(length);
    buffer2.copy(result2);
    return result2;
  }
  module2.exports = cloneBuffer2;
})(_cloneBuffer, _cloneBuffer.exports);
var _cloneBufferExports = _cloneBuffer.exports;
function copyArray$4(source, array) {
  var index2 = -1, length = source.length;
  array || (array = Array(length));
  while (++index2 < length) {
    array[index2] = source[index2];
  }
  return array;
}
var _copyArray = copyArray$4;
var copyObject$3 = _copyObject, getSymbols$1 = _getSymbols;
function copySymbols$1(source, object) {
  return copyObject$3(source, getSymbols$1(source), object);
}
var _copySymbols = copySymbols$1;
var arrayPush$1 = _arrayPush, getPrototype$2 = _getPrototype, getSymbols = _getSymbols, stubArray = stubArray_1;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result2 = [];
  while (object) {
    arrayPush$1(result2, getSymbols(object));
    object = getPrototype$2(object);
  }
  return result2;
};
var _getSymbolsIn = getSymbolsIn$2;
var copyObject$2 = _copyObject, getSymbolsIn$1 = _getSymbolsIn;
function copySymbolsIn$1(source, object) {
  return copyObject$2(source, getSymbolsIn$1(source), object);
}
var _copySymbolsIn = copySymbolsIn$1;
var baseGetAllKeys = _baseGetAllKeys, getSymbolsIn = _getSymbolsIn, keysIn$4 = keysIn_1;
function getAllKeysIn$2(object) {
  return baseGetAllKeys(object, keysIn$4, getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn$2;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function initCloneArray$1(array) {
  var length = array.length, result2 = new array.constructor(length);
  if (length && typeof array[0] == "string" && hasOwnProperty$2.call(array, "index")) {
    result2.index = array.index;
    result2.input = array.input;
  }
  return result2;
}
var _initCloneArray = initCloneArray$1;
var Uint8Array$1 = _Uint8Array;
function cloneArrayBuffer$3(arrayBuffer) {
  var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result2).set(new Uint8Array$1(arrayBuffer));
  return result2;
}
var _cloneArrayBuffer = cloneArrayBuffer$3;
var cloneArrayBuffer$2 = _cloneArrayBuffer;
function cloneDataView$1(dataView, isDeep) {
  var buffer2 = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer2, dataView.byteOffset, dataView.byteLength);
}
var _cloneDataView = cloneDataView$1;
var reFlags = /\w*$/;
function cloneRegExp$1(regexp) {
  var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result2.lastIndex = regexp.lastIndex;
  return result2;
}
var _cloneRegExp = cloneRegExp$1;
var Symbol$2 = _Symbol;
var symbolProto = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function cloneSymbol$1(symbol2) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol2)) : {};
}
var _cloneSymbol = cloneSymbol$1;
var cloneArrayBuffer$1 = _cloneArrayBuffer;
function cloneTypedArray$2(typedArray, isDeep) {
  var buffer2 = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer2, typedArray.byteOffset, typedArray.length);
}
var _cloneTypedArray = cloneTypedArray$2;
var cloneArrayBuffer = _cloneArrayBuffer, cloneDataView = _cloneDataView, cloneRegExp = _cloneRegExp, cloneSymbol = _cloneSymbol, cloneTypedArray$1 = _cloneTypedArray;
var boolTag$2 = "[object Boolean]", dateTag$1 = "[object Date]", mapTag$2 = "[object Map]", numberTag$2 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$2 = "[object String]", symbolTag$1 = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag$1(object, tag2, isDeep) {
  var Ctor = object.constructor;
  switch (tag2) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);
    case boolTag$2:
    case dateTag$1:
      return new Ctor(+object);
    case dataViewTag$1:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray$1(object, isDeep);
    case mapTag$2:
      return new Ctor();
    case numberTag$2:
    case stringTag$2:
      return new Ctor(object);
    case regexpTag$1:
      return cloneRegExp(object);
    case setTag$2:
      return new Ctor();
    case symbolTag$1:
      return cloneSymbol(object);
  }
}
var _initCloneByTag = initCloneByTag$1;
var isObject$9 = isObject_1;
var objectCreate = Object.create;
var baseCreate$2 = /* @__PURE__ */ function() {
  function object() {
  }
  return function(proto2) {
    if (!isObject$9(proto2)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto2);
    }
    object.prototype = proto2;
    var result2 = new object();
    object.prototype = void 0;
    return result2;
  };
}();
var _baseCreate = baseCreate$2;
var baseCreate$1 = _baseCreate, getPrototype$1 = _getPrototype, isPrototype = _isPrototype;
function initCloneObject$2(object) {
  return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate$1(getPrototype$1(object)) : {};
}
var _initCloneObject = initCloneObject$2;
var getTag$2 = _getTag, isObjectLike$5 = isObjectLike_1;
var mapTag$1 = "[object Map]";
function baseIsMap$1(value) {
  return isObjectLike$5(value) && getTag$2(value) == mapTag$1;
}
var _baseIsMap = baseIsMap$1;
var baseIsMap = _baseIsMap, baseUnary$5 = _baseUnary, nodeUtil$1 = _nodeUtilExports;
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;
var isMap$1 = nodeIsMap ? baseUnary$5(nodeIsMap) : baseIsMap;
var isMap_1 = isMap$1;
var getTag$1 = _getTag, isObjectLike$4 = isObjectLike_1;
var setTag$1 = "[object Set]";
function baseIsSet$1(value) {
  return isObjectLike$4(value) && getTag$1(value) == setTag$1;
}
var _baseIsSet = baseIsSet$1;
var baseIsSet = _baseIsSet, baseUnary$4 = _baseUnary, nodeUtil = _nodeUtilExports;
var nodeIsSet = nodeUtil && nodeUtil.isSet;
var isSet$1 = nodeIsSet ? baseUnary$4(nodeIsSet) : baseIsSet;
var isSet_1 = isSet$1;
var Stack$2 = _Stack, arrayEach$2 = _arrayEach, assignValue$1 = _assignValue, baseAssign = _baseAssign, baseAssignIn = _baseAssignIn, cloneBuffer$1 = _cloneBufferExports, copyArray$3 = _copyArray, copySymbols = _copySymbols, copySymbolsIn = _copySymbolsIn, getAllKeys = _getAllKeys, getAllKeysIn$1 = _getAllKeysIn, getTag = _getTag, initCloneArray = _initCloneArray, initCloneByTag = _initCloneByTag, initCloneObject$1 = _initCloneObject, isArray$g = isArray_1, isBuffer$4 = isBufferExports, isMap = isMap_1, isObject$8 = isObject_1, isSet = isSet_1, keys$a = keys_1, keysIn$3 = keysIn_1;
var CLONE_DEEP_FLAG$2 = 1, CLONE_FLAT_FLAG$1 = 2, CLONE_SYMBOLS_FLAG$2 = 4;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag$1 = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag$1 = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag$1 = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag$1] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag$1] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag$1] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
function baseClone$2(value, bitmask, customizer, key2, object, stack) {
  var result2, isDeep = bitmask & CLONE_DEEP_FLAG$2, isFlat = bitmask & CLONE_FLAT_FLAG$1, isFull = bitmask & CLONE_SYMBOLS_FLAG$2;
  if (customizer) {
    result2 = object ? customizer(value, key2, object, stack) : customizer(value);
  }
  if (result2 !== void 0) {
    return result2;
  }
  if (!isObject$8(value)) {
    return value;
  }
  var isArr = isArray$g(value);
  if (isArr) {
    result2 = initCloneArray(value);
    if (!isDeep) {
      return copyArray$3(value, result2);
    }
  } else {
    var tag2 = getTag(value), isFunc = tag2 == funcTag || tag2 == genTag;
    if (isBuffer$4(value)) {
      return cloneBuffer$1(value, isDeep);
    }
    if (tag2 == objectTag || tag2 == argsTag || isFunc && !object) {
      result2 = isFlat || isFunc ? {} : initCloneObject$1(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
      }
    } else {
      if (!cloneableTags[tag2]) {
        return object ? value : {};
      }
      result2 = initCloneByTag(value, tag2, isDeep);
    }
  }
  stack || (stack = new Stack$2());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result2);
  if (isSet(value)) {
    value.forEach(function(subValue) {
      result2.add(baseClone$2(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key3) {
      result2.set(key3, baseClone$2(subValue, bitmask, customizer, key3, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn$1 : getAllKeys : isFlat ? keysIn$3 : keys$a;
  var props2 = isArr ? void 0 : keysFunc(value);
  arrayEach$2(props2 || value, function(subValue, key3) {
    if (props2) {
      key3 = subValue;
      subValue = value[key3];
    }
    assignValue$1(result2, key3, baseClone$2(subValue, bitmask, customizer, key3, value, stack));
  });
  return result2;
}
var _baseClone = baseClone$2;
function last$2(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
var last_1 = last$2;
function baseSlice$1(array, start2, end2) {
  var index2 = -1, length = array.length;
  if (start2 < 0) {
    start2 = -start2 > length ? 0 : length + start2;
  }
  end2 = end2 > length ? length : end2;
  if (end2 < 0) {
    end2 += length;
  }
  length = start2 > end2 ? 0 : end2 - start2 >>> 0;
  start2 >>>= 0;
  var result2 = Array(length);
  while (++index2 < length) {
    result2[index2] = array[index2 + start2];
  }
  return result2;
}
var _baseSlice = baseSlice$1;
var baseGet$3 = _baseGet, baseSlice = _baseSlice;
function parent$1(object, path3) {
  return path3.length < 2 ? object : baseGet$3(object, baseSlice(path3, 0, -1));
}
var _parent = parent$1;
var castPath$4 = _castPath, last$1 = last_1, parent2 = _parent, toKey$5 = _toKey;
function baseUnset$2(object, path3) {
  path3 = castPath$4(path3, object);
  object = parent2(object, path3);
  return object == null || delete object[toKey$5(last$1(path3))];
}
var _baseUnset = baseUnset$2;
var isPlainObject$5 = isPlainObject_1;
function customOmitClone$1(value) {
  return isPlainObject$5(value) ? void 0 : value;
}
var _customOmitClone = customOmitClone$1;
var Symbol$1 = _Symbol, isArguments$5 = isArguments_1, isArray$f = isArray_1;
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
function isFlattenable$1(value) {
  return isArray$f(value) || isArguments$5(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
var _isFlattenable = isFlattenable$1;
var arrayPush = _arrayPush, isFlattenable = _isFlattenable;
function baseFlatten$4(array, depth, predicate, isStrict, result2) {
  var index2 = -1, length = array.length;
  predicate || (predicate = isFlattenable);
  result2 || (result2 = []);
  while (++index2 < length) {
    var value = array[index2];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten$4(value, depth - 1, predicate, isStrict, result2);
      } else {
        arrayPush(result2, value);
      }
    } else if (!isStrict) {
      result2[result2.length] = value;
    }
  }
  return result2;
}
var _baseFlatten = baseFlatten$4;
var baseFlatten$3 = _baseFlatten;
function flatten$3(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten$3(array, 1) : [];
}
var flatten_1 = flatten$3;
function apply$2(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var _apply = apply$2;
var apply$1 = _apply;
var nativeMax = Math.max;
function overRest$2(func, start2, transform2) {
  start2 = nativeMax(start2 === void 0 ? func.length - 1 : start2, 0);
  return function() {
    var args = arguments, index2 = -1, length = nativeMax(args.length - start2, 0), array = Array(length);
    while (++index2 < length) {
      array[index2] = args[start2 + index2];
    }
    index2 = -1;
    var otherArgs = Array(start2 + 1);
    while (++index2 < start2) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start2] = transform2(array);
    return apply$1(func, this, otherArgs);
  };
}
var _overRest = overRest$2;
function constant$1(value) {
  return function() {
    return value;
  };
}
var constant_1 = constant$1;
function identity$5(value) {
  return value;
}
var identity_1 = identity$5;
var constant = constant_1, defineProperty$4 = _defineProperty$1, identity$4 = identity_1;
var baseSetToString$1 = !defineProperty$4 ? identity$4 : function(func, string3) {
  return defineProperty$4(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string3),
    "writable": true
  });
};
var _baseSetToString = baseSetToString$1;
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut$1(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(void 0, arguments);
  };
}
var _shortOut = shortOut$1;
var baseSetToString = _baseSetToString, shortOut = _shortOut;
var setToString$2 = shortOut(baseSetToString);
var _setToString = setToString$2;
var flatten$2 = flatten_1, overRest$1 = _overRest, setToString$1 = _setToString;
function flatRest$2(func) {
  return setToString$1(overRest$1(func, void 0, flatten$2), func + "");
}
var _flatRest = flatRest$2;
var arrayMap$7 = _arrayMap, baseClone$1 = _baseClone, baseUnset$1 = _baseUnset, castPath$3 = _castPath, copyObject$1 = _copyObject, customOmitClone = _customOmitClone, flatRest$1 = _flatRest, getAllKeysIn = _getAllKeysIn;
var CLONE_DEEP_FLAG$1 = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG$1 = 4;
var omit = flatRest$1(function(object, paths) {
  var result2 = {};
  if (object == null) {
    return result2;
  }
  var isDeep = false;
  paths = arrayMap$7(paths, function(path3) {
    path3 = castPath$3(path3, object);
    isDeep || (isDeep = path3.length > 1);
    return path3;
  });
  copyObject$1(object, getAllKeysIn(object), result2);
  if (isDeep) {
    result2 = baseClone$1(result2, CLONE_DEEP_FLAG$1 | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG$1, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset$1(result2, paths[length]);
  }
  return result2;
});
var omit_1 = omit;
const omit$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(omit_1);
function splitKeyElementFromObject(key2, object) {
  const value = object[key2];
  const remaining = omit$1(object, [key2]);
  return [remaining, value];
}
function findSchemaDefinitionRecursive($ref, rootSchema = {}, recurseList = []) {
  const ref2 = $ref || "";
  let decodedRef;
  if (ref2.startsWith("#")) {
    decodedRef = decodeURIComponent(ref2.substring(1));
  } else {
    throw new Error(`Could not find a definition for ${$ref}.`);
  }
  const current2 = jsonpointer.get(rootSchema, decodedRef);
  if (current2 === void 0) {
    throw new Error(`Could not find a definition for ${$ref}.`);
  }
  const nextRef = current2[REF_KEY];
  if (nextRef) {
    if (recurseList.includes(nextRef)) {
      if (recurseList.length === 1) {
        throw new Error(`Definition for ${$ref} is a circular reference`);
      }
      const [firstRef, ...restRefs] = recurseList;
      const circularPath = [...restRefs, ref2, firstRef].join(" -> ");
      throw new Error(`Definition for ${firstRef} contains a circular reference through ${circularPath}`);
    }
    const [remaining, theRef] = splitKeyElementFromObject(REF_KEY, current2);
    const subSchema = findSchemaDefinitionRecursive(theRef, rootSchema, [...recurseList, ref2]);
    if (Object.keys(remaining).length > 0) {
      return { ...remaining, ...subSchema };
    }
    return subSchema;
  }
  return current2;
}
function findSchemaDefinition($ref, rootSchema = {}) {
  const recurseList = [];
  return findSchemaDefinitionRecursive($ref, rootSchema, recurseList);
}
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function baseHas$1(object, key2) {
  return object != null && hasOwnProperty$1.call(object, key2);
}
var _baseHas = baseHas$1;
var castPath$2 = _castPath, isArguments$4 = isArguments_1, isArray$e = isArray_1, isIndex$2 = _isIndex, isLength = isLength_1, toKey$4 = _toKey;
function hasPath$2(object, path3, hasFunc) {
  path3 = castPath$2(path3, object);
  var index2 = -1, length = path3.length, result2 = false;
  while (++index2 < length) {
    var key2 = toKey$4(path3[index2]);
    if (!(result2 = object != null && hasFunc(object, key2))) {
      break;
    }
    object = object[key2];
  }
  if (result2 || ++index2 != length) {
    return result2;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex$2(key2, length) && (isArray$e(object) || isArguments$4(object));
}
var _hasPath = hasPath$2;
var baseHas = _baseHas, hasPath$1 = _hasPath;
function has$4(object, path3) {
  return object != null && hasPath$1(object, path3, baseHas);
}
var has_1 = has$4;
const has$5 = /* @__PURE__ */ getDefaultExportFromCjs$1(has_1);
var baseGetTag$2 = _baseGetTag, isObjectLike$3 = isObjectLike_1;
var numberTag = "[object Number]";
function isNumber$3(value) {
  return typeof value == "number" || isObjectLike$3(value) && baseGetTag$2(value) == numberTag;
}
var isNumber_1 = isNumber$3;
const isNumber$4 = /* @__PURE__ */ getDefaultExportFromCjs$1(isNumber_1);
var baseGetTag$1 = _baseGetTag, isArray$d = isArray_1, isObjectLike$2 = isObjectLike_1;
var stringTag = "[object String]";
function isString$2(value) {
  return typeof value == "string" || !isArray$d(value) && isObjectLike$2(value) && baseGetTag$1(value) == stringTag;
}
var isString_1 = isString$2;
const isString$3 = /* @__PURE__ */ getDefaultExportFromCjs$1(isString_1);
function arrayReduce$1(array, iteratee, accumulator, initAccum) {
  var index2 = -1, length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[++index2];
  }
  while (++index2 < length) {
    accumulator = iteratee(accumulator, array[index2], index2, array);
  }
  return accumulator;
}
var _arrayReduce = arrayReduce$1;
function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object), props2 = keysFunc(object), length = props2.length;
    while (length--) {
      var key2 = props2[fromRight ? length : ++index2];
      if (iteratee(iterable[key2], key2, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var _createBaseFor = createBaseFor$1;
var createBaseFor = _createBaseFor;
var baseFor$2 = createBaseFor();
var _baseFor = baseFor$2;
var baseFor$1 = _baseFor, keys$9 = keys_1;
function baseForOwn$2(object, iteratee) {
  return object && baseFor$1(object, iteratee, keys$9);
}
var _baseForOwn = baseForOwn$2;
var isArrayLike$3 = isArrayLike_1;
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$3(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length, index2 = fromRight ? length : -1, iterable = Object(collection);
    while (fromRight ? index2-- : ++index2 < length) {
      if (iteratee(iterable[index2], index2, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var _createBaseEach = createBaseEach$1;
var baseForOwn$1 = _baseForOwn, createBaseEach = _createBaseEach;
var baseEach$3 = createBaseEach(baseForOwn$1);
var _baseEach = baseEach$3;
var Stack$1 = _Stack, baseIsEqual$2 = _baseIsEqual;
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(object, source, matchData, customizer) {
  var index2 = matchData.length, length = index2, noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index2--) {
    var data = matchData[index2];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index2 < length) {
    data = matchData[index2];
    var key2 = data[0], objValue = object[key2], srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === void 0 && !(key2 in object)) {
        return false;
      }
    } else {
      var stack = new Stack$1();
      if (customizer) {
        var result2 = customizer(objValue, srcValue, key2, object, source, stack);
      }
      if (!(result2 === void 0 ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result2)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$1;
var isObject$7 = isObject_1;
function isStrictComparable$2(value) {
  return value === value && !isObject$7(value);
}
var _isStrictComparable = isStrictComparable$2;
var isStrictComparable$1 = _isStrictComparable, keys$8 = keys_1;
function getMatchData$1(object) {
  var result2 = keys$8(object), length = result2.length;
  while (length--) {
    var key2 = result2[length], value = object[key2];
    result2[length] = [key2, value, isStrictComparable$1(value)];
  }
  return result2;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(key2, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key2] === srcValue && (srcValue !== void 0 || key2 in Object(object));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2;
var baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}
var _baseMatches = baseMatches$1;
function baseHasIn$1(object, key2) {
  return object != null && key2 in Object(object);
}
var _baseHasIn = baseHasIn$1;
var baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$2(object, path3) {
  return object != null && hasPath(object, path3, baseHasIn);
}
var hasIn_1 = hasIn$2;
var baseIsEqual$1 = _baseIsEqual, get$3 = get_1, hasIn$1 = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$3 = _toKey;
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(path3, srcValue) {
  if (isKey$1(path3) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$3(path3), srcValue);
  }
  return function(object) {
    var objValue = get$3(object, path3);
    return objValue === void 0 && objValue === srcValue ? hasIn$1(object, path3) : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function baseProperty$1(key2) {
  return function(object) {
    return object == null ? void 0 : object[key2];
  };
}
var _baseProperty = baseProperty$1;
var baseGet$2 = _baseGet;
function basePropertyDeep$1(path3) {
  return function(object) {
    return baseGet$2(object, path3);
  };
}
var _basePropertyDeep = basePropertyDeep$1;
var baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey$2 = _toKey;
function property$1(path3) {
  return isKey(path3) ? baseProperty(toKey$2(path3)) : basePropertyDeep(path3);
}
var property_1 = property$1;
var baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity$3 = identity_1, isArray$c = isArray_1, property = property_1;
function baseIteratee$3(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity$3;
  }
  if (typeof value == "object") {
    return isArray$c(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
var _baseIteratee = baseIteratee$3;
function baseReduce$1(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index2, collection2) {
    accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
  });
  return accumulator;
}
var _baseReduce = baseReduce$1;
var arrayReduce = _arrayReduce, baseEach$2 = _baseEach, baseIteratee$2 = _baseIteratee, baseReduce = _baseReduce, isArray$b = isArray_1;
function reduce(collection, iteratee, accumulator) {
  var func = isArray$b(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
  return func(collection, baseIteratee$2(iteratee), accumulator, initAccum, baseEach$2);
}
var reduce_1 = reduce;
const reduce$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(reduce_1);
var identity$2 = identity_1;
function castFunction$2(value) {
  return typeof value == "function" ? value : identity$2;
}
var _castFunction = castFunction$2;
var toNumber = toNumber_1;
var INFINITY$2 = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY$2 || value === -INFINITY$2) {
    var sign2 = value < 0 ? -1 : 1;
    return sign2 * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
var toFinite_1 = toFinite$1;
var toFinite = toFinite_1;
function toInteger$2(value) {
  var result2 = toFinite(value), remainder = result2 % 1;
  return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
}
var toInteger_1 = toInteger$2;
var baseTimes = _baseTimes, castFunction$1 = _castFunction, toInteger$1 = toInteger_1;
var MAX_SAFE_INTEGER = 9007199254740991;
var MAX_ARRAY_LENGTH = 4294967295;
var nativeMin$1 = Math.min;
function times$1(n2, iteratee) {
  n2 = toInteger$1(n2);
  if (n2 < 1 || n2 > MAX_SAFE_INTEGER) {
    return [];
  }
  var index2 = MAX_ARRAY_LENGTH, length = nativeMin$1(n2, MAX_ARRAY_LENGTH);
  iteratee = castFunction$1(iteratee);
  n2 -= MAX_ARRAY_LENGTH;
  var result2 = baseTimes(length, iteratee);
  while (++index2 < n2) {
    iteratee(index2);
  }
  return result2;
}
var times_1 = times$1;
const times$2 = /* @__PURE__ */ getDefaultExportFromCjs$1(times_1);
function getOptionMatchingSimpleDiscriminator(formData, options, discriminatorField) {
  var _a2;
  if (formData && discriminatorField) {
    const value = get$6(formData, discriminatorField);
    if (value === void 0) {
      return;
    }
    for (let i3 = 0; i3 < options.length; i3++) {
      const option2 = options[i3];
      const discriminator2 = get$6(option2, [PROPERTIES_KEY, discriminatorField], {});
      if (discriminator2.type === "object" || discriminator2.type === "array") {
        continue;
      }
      if (discriminator2.const === value) {
        return i3;
      }
      if ((_a2 = discriminator2.enum) === null || _a2 === void 0 ? void 0 : _a2.includes(value)) {
        return i3;
      }
    }
  }
  return;
}
function getMatchingOption(validator2, formData, options, rootSchema, discriminatorField) {
  if (formData === void 0) {
    return 0;
  }
  const simpleDiscriminatorMatch = getOptionMatchingSimpleDiscriminator(formData, options, discriminatorField);
  if (isNumber$4(simpleDiscriminatorMatch)) {
    return simpleDiscriminatorMatch;
  }
  for (let i3 = 0; i3 < options.length; i3++) {
    const option2 = options[i3];
    if (discriminatorField && has$5(option2, [PROPERTIES_KEY, discriminatorField])) {
      const value = get$6(formData, discriminatorField);
      const discriminator2 = get$6(option2, [PROPERTIES_KEY, discriminatorField], {});
      if (validator2.isValid(discriminator2, value, rootSchema)) {
        return i3;
      }
    } else if (option2[PROPERTIES_KEY]) {
      const requiresAnyOf = {
        anyOf: Object.keys(option2[PROPERTIES_KEY]).map((key2) => ({
          required: [key2]
        }))
      };
      let augmentedSchema;
      if (option2.anyOf) {
        const { ...shallowClone } = option2;
        if (!shallowClone.allOf) {
          shallowClone.allOf = [];
        } else {
          shallowClone.allOf = shallowClone.allOf.slice();
        }
        shallowClone.allOf.push(requiresAnyOf);
        augmentedSchema = shallowClone;
      } else {
        augmentedSchema = Object.assign({}, option2, requiresAnyOf);
      }
      delete augmentedSchema.required;
      if (validator2.isValid(augmentedSchema, formData, rootSchema)) {
        return i3;
      }
    } else if (validator2.isValid(option2, formData, rootSchema)) {
      return i3;
    }
  }
  return 0;
}
function getFirstMatchingOption(validator2, formData, options, rootSchema, discriminatorField) {
  return getMatchingOption(validator2, formData, options, rootSchema, discriminatorField);
}
var baseIsEqual = _baseIsEqual;
function isEqual$3(value, other) {
  return baseIsEqual(value, other);
}
var isEqual_1 = isEqual$3;
const isEqual$4 = /* @__PURE__ */ getDefaultExportFromCjs$1(isEqual_1);
var assignValue = _assignValue, castPath$1 = _castPath, isIndex$1 = _isIndex, isObject$6 = isObject_1, toKey$1 = _toKey;
function baseSet$2(object, path3, value, customizer) {
  if (!isObject$6(object)) {
    return object;
  }
  path3 = castPath$1(path3, object);
  var index2 = -1, length = path3.length, lastIndex = length - 1, nested = object;
  while (nested != null && ++index2 < length) {
    var key2 = toKey$1(path3[index2]), newValue = value;
    if (key2 === "__proto__" || key2 === "constructor" || key2 === "prototype") {
      return object;
    }
    if (index2 != lastIndex) {
      var objValue = nested[key2];
      newValue = customizer ? customizer(objValue, key2, nested) : void 0;
      if (newValue === void 0) {
        newValue = isObject$6(objValue) ? objValue : isIndex$1(path3[index2 + 1]) ? [] : {};
      }
    }
    assignValue(nested, key2, newValue);
    nested = nested[key2];
  }
  return object;
}
var _baseSet = baseSet$2;
var baseSet$1 = _baseSet;
function set$2(object, path3, value) {
  return object == null ? object : baseSet$1(object, path3, value);
}
var set_1 = set$2;
const set$3 = /* @__PURE__ */ getDefaultExportFromCjs$1(set_1);
var arrayEach$1 = _arrayEach, baseCreate = _baseCreate, baseForOwn = _baseForOwn, baseIteratee$1 = _baseIteratee, getPrototype = _getPrototype, isArray$a = isArray_1, isBuffer$3 = isBufferExports, isFunction$7 = isFunction_1, isObject$5 = isObject_1, isTypedArray$1 = isTypedArray_1;
function transform(object, iteratee, accumulator) {
  var isArr = isArray$a(object), isArrLike = isArr || isBuffer$3(object) || isTypedArray$1(object);
  iteratee = baseIteratee$1(iteratee);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor() : [];
    } else if (isObject$5(object)) {
      accumulator = isFunction$7(Ctor) ? baseCreate(getPrototype(object)) : {};
    } else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach$1 : baseForOwn)(object, function(value, index2, object2) {
    return iteratee(accumulator, value, index2, object2);
  });
  return accumulator;
}
var transform_1 = transform;
const transform$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(transform_1);
var baseAssignValue = _baseAssignValue, eq$2 = eq_1;
function assignMergeValue$2(object, key2, value) {
  if (value !== void 0 && !eq$2(object[key2], value) || value === void 0 && !(key2 in object)) {
    baseAssignValue(object, key2, value);
  }
}
var _assignMergeValue = assignMergeValue$2;
var isArrayLike$2 = isArrayLike_1, isObjectLike$1 = isObjectLike_1;
function isArrayLikeObject$4(value) {
  return isObjectLike$1(value) && isArrayLike$2(value);
}
var isArrayLikeObject_1 = isArrayLikeObject$4;
function safeGet$2(object, key2) {
  if (key2 === "constructor" && typeof object[key2] === "function") {
    return;
  }
  if (key2 == "__proto__") {
    return;
  }
  return object[key2];
}
var _safeGet = safeGet$2;
var copyObject = _copyObject, keysIn$2 = keysIn_1;
function toPlainObject$1(value) {
  return copyObject(value, keysIn$2(value));
}
var toPlainObject_1 = toPlainObject$1;
var assignMergeValue$1 = _assignMergeValue, cloneBuffer = _cloneBufferExports, cloneTypedArray = _cloneTypedArray, copyArray$2 = _copyArray, initCloneObject = _initCloneObject, isArguments$3 = isArguments_1, isArray$9 = isArray_1, isArrayLikeObject$3 = isArrayLikeObject_1, isBuffer$2 = isBufferExports, isFunction$6 = isFunction_1, isObject$4 = isObject_1, isPlainObject$4 = isPlainObject_1, isTypedArray = isTypedArray_1, safeGet$1 = _safeGet, toPlainObject = toPlainObject_1;
function baseMergeDeep$1(object, source, key2, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet$1(object, key2), srcValue = safeGet$1(source, key2), stacked = stack.get(srcValue);
  if (stacked) {
    assignMergeValue$1(object, key2, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key2 + "", object, source, stack) : void 0;
  var isCommon = newValue === void 0;
  if (isCommon) {
    var isArr = isArray$9(srcValue), isBuff = !isArr && isBuffer$2(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$9(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject$3(objValue)) {
        newValue = copyArray$2(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject$4(srcValue) || isArguments$3(srcValue)) {
      newValue = objValue;
      if (isArguments$3(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject$4(objValue) || isFunction$6(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack["delete"](srcValue);
  }
  assignMergeValue$1(object, key2, newValue);
}
var _baseMergeDeep = baseMergeDeep$1;
var Stack = _Stack, assignMergeValue = _assignMergeValue, baseFor = _baseFor, baseMergeDeep = _baseMergeDeep, isObject$3 = isObject_1, keysIn$1 = keysIn_1, safeGet = _safeGet;
function baseMerge$3(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key2) {
    stack || (stack = new Stack());
    if (isObject$3(srcValue)) {
      baseMergeDeep(object, source, key2, srcIndex, baseMerge$3, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key2), srcValue, key2 + "", object, source, stack) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object, key2, newValue);
    }
  }, keysIn$1);
}
var _baseMerge = baseMerge$3;
var identity$1 = identity_1, overRest = _overRest, setToString = _setToString;
function baseRest$8(func, start2) {
  return setToString(overRest(func, start2, identity$1), func + "");
}
var _baseRest = baseRest$8;
var eq$1 = eq_1, isArrayLike$1 = isArrayLike_1, isIndex = _isIndex, isObject$2 = isObject_1;
function isIterateeCall$3(value, index2, object) {
  if (!isObject$2(object)) {
    return false;
  }
  var type2 = typeof index2;
  if (type2 == "number" ? isArrayLike$1(object) && isIndex(index2, object.length) : type2 == "string" && index2 in object) {
    return eq$1(object[index2], value);
  }
  return false;
}
var _isIterateeCall = isIterateeCall$3;
var baseRest$7 = _baseRest, isIterateeCall$2 = _isIterateeCall;
function createAssigner$2(assigner) {
  return baseRest$7(function(object, sources) {
    var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
    customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
    if (guard && isIterateeCall$2(sources[0], sources[1], guard)) {
      customizer = length < 3 ? void 0 : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index2 < length) {
      var source = sources[index2];
      if (source) {
        assigner(object, source, index2, customizer);
      }
    }
    return object;
  });
}
var _createAssigner = createAssigner$2;
var baseMerge$2 = _baseMerge, createAssigner$1 = _createAssigner;
var merge = createAssigner$1(function(object, source, srcIndex) {
  baseMerge$2(object, source, srcIndex);
});
var merge_1 = merge;
const merge$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(merge_1);
var baseFlatten$2 = _baseFlatten;
var INFINITY$1 = 1 / 0;
function flattenDeep$2(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten$2(array, INFINITY$1) : [];
}
var flattenDeep_1 = flattenDeep$2;
const flattenDeep$3 = /* @__PURE__ */ getDefaultExportFromCjs$1(flattenDeep_1);
function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index2-- : ++index2 < length) {
    if (predicate(array[index2], index2, array)) {
      return index2;
    }
  }
  return -1;
}
var _baseFindIndex = baseFindIndex$1;
function baseIsNaN$1(value) {
  return value !== value;
}
var _baseIsNaN = baseIsNaN$1;
function strictIndexOf$1(array, value, fromIndex) {
  var index2 = fromIndex - 1, length = array.length;
  while (++index2 < length) {
    if (array[index2] === value) {
      return index2;
    }
  }
  return -1;
}
var _strictIndexOf = strictIndexOf$1;
var baseFindIndex = _baseFindIndex, baseIsNaN = _baseIsNaN, strictIndexOf = _strictIndexOf;
function baseIndexOf$2(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
var _baseIndexOf = baseIndexOf$2;
var baseIndexOf$1 = _baseIndexOf;
function arrayIncludes$3(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf$1(array, value, 0) > -1;
}
var _arrayIncludes = arrayIncludes$3;
function arrayIncludesWith$3(array, value, comparator) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (comparator(value, array[index2])) {
      return true;
    }
  }
  return false;
}
var _arrayIncludesWith = arrayIncludesWith$3;
function noop$2() {
}
var noop_1 = noop$2;
var Set$1 = _Set, noop$1 = noop_1, setToArray$1 = _setToArray;
var INFINITY = 1 / 0;
var createSet$1 = !(Set$1 && 1 / setToArray$1(new Set$1([, -0]))[1] == INFINITY) ? noop$1 : function(values) {
  return new Set$1(values);
};
var _createSet = createSet$1;
var SetCache$2 = _SetCache, arrayIncludes$2 = _arrayIncludes, arrayIncludesWith$2 = _arrayIncludesWith, cacheHas$2 = _cacheHas, createSet = _createSet, setToArray = _setToArray;
var LARGE_ARRAY_SIZE$1 = 200;
function baseUniq$3(array, iteratee, comparator) {
  var index2 = -1, includes = arrayIncludes$2, length = array.length, isCommon = true, result2 = [], seen = result2;
  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith$2;
  } else if (length >= LARGE_ARRAY_SIZE$1) {
    var set2 = iteratee ? null : createSet(array);
    if (set2) {
      return setToArray(set2);
    }
    isCommon = false;
    includes = cacheHas$2;
    seen = new SetCache$2();
  } else {
    seen = iteratee ? [] : result2;
  }
  outer:
    while (++index2 < length) {
      var value = array[index2], computed = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed === computed) {
        var seenIndex = seen.length;
        while (seenIndex--) {
          if (seen[seenIndex] === computed) {
            continue outer;
          }
        }
        if (iteratee) {
          seen.push(computed);
        }
        result2.push(value);
      } else if (!includes(seen, computed, comparator)) {
        if (seen !== result2) {
          seen.push(computed);
        }
        result2.push(value);
      }
    }
  return result2;
}
var _baseUniq = baseUniq$3;
var baseUniq$2 = _baseUniq;
function uniq$3(array) {
  return array && array.length ? baseUniq$2(array) : [];
}
var uniq_1 = uniq$3;
const uniq$4 = /* @__PURE__ */ getDefaultExportFromCjs$1(uniq_1);
var baseClone = _baseClone;
var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
function cloneDeep$1(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
var cloneDeep_1 = cloneDeep$1;
const cloneDeep$2 = /* @__PURE__ */ getDefaultExportFromCjs$1(cloneDeep_1);
var baseEach$1 = _baseEach, isArrayLike = isArrayLike_1;
function baseMap$1(collection, iteratee) {
  var index2 = -1, result2 = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach$1(collection, function(value, key2, collection2) {
    result2[++index2] = iteratee(value, key2, collection2);
  });
  return result2;
}
var _baseMap = baseMap$1;
function baseSortBy$1(array, comparer) {
  var length = array.length;
  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}
var _baseSortBy = baseSortBy$1;
var isSymbol$1 = isSymbol_1;
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol$1(value);
    var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol$1(other);
    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}
var _compareAscending = compareAscending$1;
var compareAscending = _compareAscending;
function compareMultiple$1(object, other, orders) {
  var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
  while (++index2 < length) {
    var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
    if (result2) {
      if (index2 >= ordersLength) {
        return result2;
      }
      var order2 = orders[index2];
      return result2 * (order2 == "desc" ? -1 : 1);
    }
  }
  return object.index - other.index;
}
var _compareMultiple = compareMultiple$1;
var arrayMap$6 = _arrayMap, baseGet$1 = _baseGet, baseIteratee = _baseIteratee, baseMap = _baseMap, baseSortBy = _baseSortBy, baseUnary$3 = _baseUnary, compareMultiple = _compareMultiple, identity = identity_1, isArray$8 = isArray_1;
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap$6(iteratees, function(iteratee) {
      if (isArray$8(iteratee)) {
        return function(value) {
          return baseGet$1(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }
  var index2 = -1;
  iteratees = arrayMap$6(iteratees, baseUnary$3(baseIteratee));
  var result2 = baseMap(collection, function(value, key2, collection2) {
    var criteria = arrayMap$6(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { "criteria": criteria, "index": ++index2, "value": value };
  });
  return baseSortBy(result2, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}
var _baseOrderBy = baseOrderBy$1;
var baseFlatten$1 = _baseFlatten, baseOrderBy = _baseOrderBy, baseRest$6 = _baseRest, isIterateeCall$1 = _isIterateeCall;
var sortBy$2 = baseRest$6(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall$1(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall$1(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten$1(iteratees, 1), []);
});
var sortBy_1 = sortBy$2;
var baseUniq$1 = _baseUniq;
function uniqWith$5(array, comparator) {
  comparator = typeof comparator == "function" ? comparator : void 0;
  return array && array.length ? baseUniq$1(array, void 0, comparator) : [];
}
var uniqWith_1 = uniqWith$5;
var baseRest$5 = _baseRest, eq = eq_1, isIterateeCall = _isIterateeCall, keysIn = keysIn_1;
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var defaults$5 = baseRest$5(function(object, sources) {
  object = Object(object);
  var index2 = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : void 0;
  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }
  while (++index2 < length) {
    var source = sources[index2];
    var props2 = keysIn(source);
    var propsIndex = -1;
    var propsLength = props2.length;
    while (++propsIndex < propsLength) {
      var key2 = props2[propsIndex];
      var value = object[key2];
      if (value === void 0 || eq(value, objectProto[key2]) && !hasOwnProperty.call(object, key2)) {
        object[key2] = source[key2];
      }
    }
  }
  return object;
});
var defaults_1$1 = defaults$5;
var SetCache$1 = _SetCache, arrayIncludes$1 = _arrayIncludes, arrayIncludesWith$1 = _arrayIncludesWith, arrayMap$5 = _arrayMap, baseUnary$2 = _baseUnary, cacheHas$1 = _cacheHas;
var nativeMin = Math.min;
function baseIntersection$2(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith$1 : arrayIncludes$1, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result2 = [];
  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap$5(array, baseUnary$2(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache$1(othIndex && array) : void 0;
  }
  array = arrays[0];
  var index2 = -1, seen = caches[0];
  outer:
    while (++index2 < length && result2.length < maxLength) {
      var value = array[index2], computed = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (!(seen ? cacheHas$1(seen, computed) : includes(result2, computed, comparator))) {
        othIndex = othLength;
        while (--othIndex) {
          var cache2 = caches[othIndex];
          if (!(cache2 ? cacheHas$1(cache2, computed) : includes(arrays[othIndex], computed, comparator))) {
            continue outer;
          }
        }
        if (seen) {
          seen.push(computed);
        }
        result2.push(value);
      }
    }
  return result2;
}
var _baseIntersection = baseIntersection$2;
var isArrayLikeObject$2 = isArrayLikeObject_1;
function castArrayLikeObject$2(value) {
  return isArrayLikeObject$2(value) ? value : [];
}
var _castArrayLikeObject = castArrayLikeObject$2;
var arrayMap$4 = _arrayMap, baseIntersection$1 = _baseIntersection, baseRest$4 = _baseRest, castArrayLikeObject$1 = _castArrayLikeObject, last = last_1;
var intersectionWith$2 = baseRest$4(function(arrays) {
  var comparator = last(arrays), mapped = arrayMap$4(arrays, castArrayLikeObject$1);
  comparator = typeof comparator == "function" ? comparator : void 0;
  if (comparator) {
    mapped.pop();
  }
  return mapped.length && mapped[0] === arrays[0] ? baseIntersection$1(mapped, void 0, comparator) : [];
});
var intersectionWith_1 = intersectionWith$2;
var baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1;
var boolTag = "[object Boolean]";
function isBoolean$1(value) {
  return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
}
var isBoolean_1 = isBoolean$1;
var isEqual$2 = isEqual_1;
var sortBy$1 = sortBy_1;
var uniq$2 = uniq_1;
var uniqWith$4 = uniqWith_1;
var defaults$4 = defaults_1$1;
var intersectionWith$1 = intersectionWith_1;
var isPlainObject$3 = isPlainObject_1;
var isBoolean = isBoolean_1;
var normalizeArray = (val) => Array.isArray(val) ? val : [val];
var undef = (val) => val === void 0;
var keys$7 = (obj) => isPlainObject$3(obj) || Array.isArray(obj) ? Object.keys(obj) : [];
var has$3 = (obj, key2) => obj.hasOwnProperty(key2);
var stringArray$1 = (arr) => sortBy$1(uniq$2(arr));
var undefEmpty = (val) => undef(val) || Array.isArray(val) && val.length === 0;
var keyValEqual = (a4, b3, key2, compare2) => b3 && has$3(b3, key2) && a4 && has$3(a4, key2) && compare2(a4[key2], b3[key2]);
var undefAndZero = (a4, b3) => undef(a4) && b3 === 0 || undef(b3) && a4 === 0 || isEqual$2(a4, b3);
var falseUndefined = (a4, b3) => undef(a4) && b3 === false || undef(b3) && a4 === false || isEqual$2(a4, b3);
var emptySchema = (schema) => undef(schema) || isEqual$2(schema, {}) || schema === true;
var emptyObjUndef = (schema) => undef(schema) || isEqual$2(schema, {});
var isSchema$3 = (val) => undef(val) || isPlainObject$3(val) || val === true || val === false;
function undefArrayEqual(a4, b3) {
  if (undefEmpty(a4) && undefEmpty(b3)) {
    return true;
  } else {
    return isEqual$2(stringArray$1(a4), stringArray$1(b3));
  }
}
function unsortedNormalizedArray(a4, b3) {
  a4 = normalizeArray(a4);
  b3 = normalizeArray(b3);
  return isEqual$2(stringArray$1(a4), stringArray$1(b3));
}
function schemaGroup(a4, b3, key2, compare2) {
  var allProps = uniq$2(keys$7(a4).concat(keys$7(b3)));
  if (emptyObjUndef(a4) && emptyObjUndef(b3)) {
    return true;
  } else if (emptyObjUndef(a4) && keys$7(b3).length) {
    return false;
  } else if (emptyObjUndef(b3) && keys$7(a4).length) {
    return false;
  }
  return allProps.every(function(key3) {
    var aVal = a4[key3];
    var bVal = b3[key3];
    if (Array.isArray(aVal) && Array.isArray(bVal)) {
      return isEqual$2(stringArray$1(a4), stringArray$1(b3));
    } else if (Array.isArray(aVal) && !Array.isArray(bVal)) {
      return false;
    } else if (Array.isArray(bVal) && !Array.isArray(aVal)) {
      return false;
    }
    return keyValEqual(a4, b3, key3, compare2);
  });
}
function items$2(a4, b3, key2, compare2) {
  if (isPlainObject$3(a4) && isPlainObject$3(b3)) {
    return compare2(a4, b3);
  } else if (Array.isArray(a4) && Array.isArray(b3)) {
    return schemaGroup(a4, b3, key2, compare2);
  } else {
    return isEqual$2(a4, b3);
  }
}
function unsortedArray(a4, b3, key2, compare2) {
  var uniqueA = uniqWith$4(a4, compare2);
  var uniqueB = uniqWith$4(b3, compare2);
  var inter = intersectionWith$1(uniqueA, uniqueB, compare2);
  return inter.length === Math.max(uniqueA.length, uniqueB.length);
}
var comparers = {
  title: isEqual$2,
  uniqueItems: falseUndefined,
  minLength: undefAndZero,
  minItems: undefAndZero,
  minProperties: undefAndZero,
  required: undefArrayEqual,
  enum: undefArrayEqual,
  type: unsortedNormalizedArray,
  items: items$2,
  anyOf: unsortedArray,
  allOf: unsortedArray,
  oneOf: unsortedArray,
  properties: schemaGroup,
  patternProperties: schemaGroup,
  dependencies: schemaGroup
};
var acceptsUndefined = [
  "properties",
  "patternProperties",
  "dependencies",
  "uniqueItems",
  "minLength",
  "minItems",
  "minProperties",
  "required"
];
var schemaProps$1 = ["additionalProperties", "additionalItems", "contains", "propertyNames", "not"];
function compare$3(a4, b3, options) {
  options = defaults$4(options, {
    ignore: []
  });
  if (emptySchema(a4) && emptySchema(b3)) {
    return true;
  }
  if (!isSchema$3(a4) || !isSchema$3(b3)) {
    throw new Error("Either of the values are not a JSON schema.");
  }
  if (a4 === b3) {
    return true;
  }
  if (isBoolean(a4) && isBoolean(b3)) {
    return a4 === b3;
  }
  if (a4 === void 0 && b3 === false || b3 === void 0 && a4 === false) {
    return false;
  }
  if (undef(a4) && !undef(b3) || !undef(a4) && undef(b3)) {
    return false;
  }
  var allKeys = uniq$2(Object.keys(a4).concat(Object.keys(b3)));
  if (options.ignore.length) {
    allKeys = allKeys.filter((k3) => options.ignore.indexOf(k3) === -1);
  }
  if (!allKeys.length) {
    return true;
  }
  function innerCompare(a5, b4) {
    return compare$3(a5, b4, options);
  }
  return allKeys.every(function(key2) {
    var aValue = a4[key2];
    var bValue = b3[key2];
    if (schemaProps$1.indexOf(key2) !== -1) {
      return compare$3(aValue, bValue, options);
    }
    var comparer = comparers[key2];
    if (!comparer) {
      comparer = isEqual$2;
    }
    if (isEqual$2(aValue, bValue)) {
      return true;
    }
    if (acceptsUndefined.indexOf(key2) === -1) {
      if (!has$3(a4, key2) && has$3(b3, key2) || has$3(a4, key2) && !has$3(b3, key2)) {
        return aValue === bValue;
      }
    }
    var result2 = comparer(aValue, bValue, key2, innerCompare);
    if (!isBoolean(result2)) {
      throw new Error("Comparer must return true or false");
    }
    return result2;
  });
}
var src$1 = compare$3;
function isArray$7(value) {
  return Object.prototype.toString.call(value) === "[object Array]";
}
var lib$8 = Array.isArray || isArray$7;
function isNumber$2(value) {
  return (typeof value === "number" || Object.prototype.toString.call(value) === "[object Number]") && value.valueOf() === value.valueOf();
}
var lib$7 = isNumber$2;
var isNumber$1 = lib$7;
function isInteger$1(value) {
  return isNumber$1(value) && value % 1 === 0;
}
var lib$6 = isInteger$1;
var isArray$6 = lib$8, isInteger = lib$6;
function isIntegerArray$2(value) {
  var len;
  if (!isArray$6(value)) {
    return false;
  }
  len = value.length;
  if (!len) {
    return false;
  }
  for (var i3 = 0; i3 < len; i3++) {
    if (!isInteger(value[i3])) {
      return false;
    }
  }
  return true;
}
var lib$5 = isIntegerArray$2;
function isFunction$5(value) {
  return typeof value === "function";
}
var lib$4 = isFunction$5;
var isArray$5 = lib$8, isIntegerArray$1 = lib$5, isFunction$4 = lib$4;
var MAXINT = Math.pow(2, 31) - 1;
function gcd$1(a4, b3) {
  var k3 = 1, t3;
  if (a4 === 0) {
    return b3;
  }
  if (b3 === 0) {
    return a4;
  }
  while (a4 % 2 === 0 && b3 % 2 === 0) {
    a4 = a4 / 2;
    b3 = b3 / 2;
    k3 = k3 * 2;
  }
  while (a4 % 2 === 0) {
    a4 = a4 / 2;
  }
  while (b3) {
    while (b3 % 2 === 0) {
      b3 = b3 / 2;
    }
    if (a4 > b3) {
      t3 = b3;
      b3 = a4;
      a4 = t3;
    }
    b3 = b3 - a4;
  }
  return k3 * a4;
}
function bitwise(a4, b3) {
  var k3 = 0, t3;
  if (a4 === 0) {
    return b3;
  }
  if (b3 === 0) {
    return a4;
  }
  while ((a4 & 1) === 0 && (b3 & 1) === 0) {
    a4 >>>= 1;
    b3 >>>= 1;
    k3++;
  }
  while ((a4 & 1) === 0) {
    a4 >>>= 1;
  }
  while (b3) {
    while ((b3 & 1) === 0) {
      b3 >>>= 1;
    }
    if (a4 > b3) {
      t3 = b3;
      b3 = a4;
      a4 = t3;
    }
    b3 = b3 - a4;
  }
  return a4 << k3;
}
function compute() {
  var nargs = arguments.length, args, clbk, arr, len, a4, b3, i3;
  args = new Array(nargs);
  for (i3 = 0; i3 < nargs; i3++) {
    args[i3] = arguments[i3];
  }
  if (isIntegerArray$1(args)) {
    if (nargs === 2) {
      a4 = args[0];
      b3 = args[1];
      if (a4 < 0) {
        a4 = -a4;
      }
      if (b3 < 0) {
        b3 = -b3;
      }
      if (a4 <= MAXINT && b3 <= MAXINT) {
        return bitwise(a4, b3);
      } else {
        return gcd$1(a4, b3);
      }
    }
    arr = args;
  } else if (!isArray$5(args[0])) {
    throw new TypeError("gcd()::invalid input argument. Must provide an array of integers. Value: `" + args[0] + "`.");
  } else if (nargs > 1) {
    arr = args[0];
    clbk = args[1];
    if (!isFunction$4(clbk)) {
      throw new TypeError("gcd()::invalid input argument. Accessor must be a function. Value: `" + clbk + "`.");
    }
  } else {
    arr = args[0];
  }
  len = arr.length;
  if (len < 2) {
    return null;
  }
  if (clbk) {
    a4 = new Array(len);
    for (i3 = 0; i3 < len; i3++) {
      a4[i3] = clbk(arr[i3], i3);
    }
    arr = a4;
  }
  if (nargs < 3) {
    if (!isIntegerArray$1(arr)) {
      throw new TypeError("gcd()::invalid input argument. Accessed array values must be integers. Value: `" + arr + "`.");
    }
  }
  for (i3 = 0; i3 < len; i3++) {
    a4 = arr[i3];
    if (a4 < 0) {
      arr[i3] = -a4;
    }
  }
  a4 = arr[0];
  for (i3 = 1; i3 < len; i3++) {
    b3 = arr[i3];
    if (b3 <= MAXINT && a4 <= MAXINT) {
      a4 = bitwise(a4, b3);
    } else {
      a4 = gcd$1(a4, b3);
    }
  }
  return a4;
}
var lib$3 = compute;
var gcd = lib$3, isArray$4 = lib$8, isIntegerArray = lib$5, isFunction$3 = lib$4;
function lcm() {
  var nargs = arguments.length, args, clbk, arr, len, a4, b3, i3;
  args = new Array(nargs);
  for (i3 = 0; i3 < nargs; i3++) {
    args[i3] = arguments[i3];
  }
  if (isIntegerArray(args)) {
    if (nargs === 2) {
      a4 = args[0];
      b3 = args[1];
      if (a4 < 0) {
        a4 = -a4;
      }
      if (b3 < 0) {
        b3 = -b3;
      }
      if (a4 === 0 || b3 === 0) {
        return 0;
      }
      return a4 / gcd(a4, b3) * b3;
    }
    arr = args;
  } else if (!isArray$4(args[0])) {
    throw new TypeError("lcm()::invalid input argument. Must provide an array of integers. Value: `" + args[0] + "`.");
  } else if (nargs > 1) {
    arr = args[0];
    clbk = args[1];
    if (!isFunction$3(clbk)) {
      throw new TypeError("lcm()::invalid input argument. Accessor must be a function. Value: `" + clbk + "`.");
    }
  } else {
    arr = args[0];
  }
  len = arr.length;
  if (len < 2) {
    return null;
  }
  if (clbk) {
    a4 = new Array(len);
    for (i3 = 0; i3 < len; i3++) {
      a4[i3] = clbk(arr[i3], i3);
    }
    arr = a4;
  }
  if (nargs < 3) {
    if (!isIntegerArray(arr)) {
      throw new TypeError("lcm()::invalid input argument. Accessed array values must be integers. Value: `" + arr + "`.");
    }
  }
  for (i3 = 0; i3 < len; i3++) {
    a4 = arr[i3];
    if (a4 < 0) {
      arr[i3] = -a4;
    }
  }
  a4 = arr[0];
  for (i3 = 1; i3 < len; i3++) {
    b3 = arr[i3];
    if (a4 === 0 || b3 === 0) {
      return 0;
    }
    a4 = a4 / gcd(a4, b3) * b3;
  }
  return a4;
}
var lib$2 = lcm;
var baseMerge$1 = _baseMerge, isObject$1 = isObject_1;
function customDefaultsMerge$1(objValue, srcValue, key2, object, source, stack) {
  if (isObject$1(objValue) && isObject$1(srcValue)) {
    stack.set(srcValue, objValue);
    baseMerge$1(objValue, srcValue, void 0, customDefaultsMerge$1, stack);
    stack["delete"](srcValue);
  }
  return objValue;
}
var _customDefaultsMerge = customDefaultsMerge$1;
var baseMerge = _baseMerge, createAssigner = _createAssigner;
var mergeWith$1 = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});
var mergeWith_1 = mergeWith$1;
var apply = _apply, baseRest$3 = _baseRest, customDefaultsMerge = _customDefaultsMerge, mergeWith = mergeWith_1;
var defaultsDeep$1 = baseRest$3(function(args) {
  args.push(void 0, customDefaultsMerge);
  return apply(mergeWith, void 0, args);
});
var defaultsDeep_1 = defaultsDeep$1;
var arrayMap$3 = _arrayMap, baseIntersection = _baseIntersection, baseRest$2 = _baseRest, castArrayLikeObject = _castArrayLikeObject;
var intersection$1 = baseRest$2(function(arrays) {
  var mapped = arrayMap$3(arrays, castArrayLikeObject);
  return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
});
var intersection_1 = intersection$1;
function baseIndexOfWith$1(array, value, fromIndex, comparator) {
  var index2 = fromIndex - 1, length = array.length;
  while (++index2 < length) {
    if (comparator(array[index2], value)) {
      return index2;
    }
  }
  return -1;
}
var _baseIndexOfWith = baseIndexOfWith$1;
var arrayMap$2 = _arrayMap, baseIndexOf = _baseIndexOf, baseIndexOfWith = _baseIndexOfWith, baseUnary$1 = _baseUnary, copyArray$1 = _copyArray;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function basePullAll$1(array, values, iteratee, comparator) {
  var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length = values.length, seen = array;
  if (array === values) {
    values = copyArray$1(values);
  }
  if (iteratee) {
    seen = arrayMap$2(array, baseUnary$1(iteratee));
  }
  while (++index2 < length) {
    var fromIndex = 0, value = values[index2], computed = iteratee ? iteratee(value) : value;
    while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}
var _basePullAll = basePullAll$1;
var basePullAll = _basePullAll;
function pullAll$1(array, values) {
  return array && array.length && values && values.length ? basePullAll(array, values) : array;
}
var pullAll_1 = pullAll$1;
var arrayEach = _arrayEach, baseEach = _baseEach, castFunction = _castFunction, isArray$3 = isArray_1;
function forEach$2(collection, iteratee) {
  var func = isArray$3(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}
var forEach_1 = forEach$2;
var SetCache = _SetCache, arrayIncludes = _arrayIncludes, arrayIncludesWith = _arrayIncludesWith, arrayMap$1 = _arrayMap, baseUnary = _baseUnary, cacheHas = _cacheHas;
var LARGE_ARRAY_SIZE = 200;
function baseDifference$1(array, values, iteratee, comparator) {
  var index2 = -1, includes = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values.length;
  if (!length) {
    return result2;
  }
  if (iteratee) {
    values = arrayMap$1(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  } else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
    while (++index2 < length) {
      var value = array[index2], computed = iteratee == null ? value : iteratee(value);
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed === computed) {
        var valuesIndex = valuesLength;
        while (valuesIndex--) {
          if (values[valuesIndex] === computed) {
            continue outer;
          }
        }
        result2.push(value);
      } else if (!includes(values, computed, comparator)) {
        result2.push(value);
      }
    }
  return result2;
}
var _baseDifference = baseDifference$1;
var baseDifference = _baseDifference, baseRest$1 = _baseRest, isArrayLikeObject$1 = isArrayLikeObject_1;
var without$1 = baseRest$1(function(array, values) {
  return isArrayLikeObject$1(array) ? baseDifference(array, values) : [];
});
var without_1 = without$1;
const flatten$1 = flatten_1;
const flattenDeep$1 = flattenDeep_1;
const isPlainObject$2 = isPlainObject_1;
const uniq$1 = uniq_1;
const uniqWith$3 = uniqWith_1;
const without = without_1;
function deleteUndefinedProps$2(returnObject) {
  for (const prop in returnObject) {
    if (has$2(returnObject, prop) && isEmptySchema(returnObject[prop])) {
      delete returnObject[prop];
    }
  }
  return returnObject;
}
const allUniqueKeys$3 = (arr) => uniq$1(flattenDeep$1(arr.map(keys$6)));
const getValues$2 = (schemas, key2) => schemas.map((schema) => schema && schema[key2]);
const has$2 = (obj, propName) => Object.prototype.hasOwnProperty.call(obj, propName);
const keys$6 = (obj) => {
  if (isPlainObject$2(obj) || Array.isArray(obj)) {
    return Object.keys(obj);
  } else {
    return [];
  }
};
const notUndefined$3 = (val) => val !== void 0;
const isSchema$2 = (val) => isPlainObject$2(val) || val === true || val === false;
const isEmptySchema = (obj) => !keys$6(obj).length && obj !== false && obj !== true;
const withoutArr$1 = (arr, ...rest) => without.apply(null, [arr].concat(flatten$1(rest)));
var common = {
  allUniqueKeys: allUniqueKeys$3,
  deleteUndefinedProps: deleteUndefinedProps$2,
  getValues: getValues$2,
  has: has$2,
  isEmptySchema,
  isSchema: isSchema$2,
  keys: keys$6,
  notUndefined: notUndefined$3,
  uniqWith: uniqWith$3,
  withoutArr: withoutArr$1
};
const compare$2 = src$1;
const forEach$1 = forEach_1;
const {
  allUniqueKeys: allUniqueKeys$2,
  deleteUndefinedProps: deleteUndefinedProps$1,
  getValues: getValues$1,
  keys: keys$5,
  notUndefined: notUndefined$2,
  uniqWith: uniqWith$2,
  withoutArr
} = common;
function removeFalseSchemas(target) {
  forEach$1(target, function(schema, prop) {
    if (schema === false) {
      delete target[prop];
    }
  });
}
function mergeSchemaGroup(group, mergeSchemas2) {
  const allKeys = allUniqueKeys$2(group);
  return allKeys.reduce(function(all, key2) {
    const schemas = getValues$1(group, key2);
    const compacted = uniqWith$2(schemas.filter(notUndefined$2), compare$2);
    all[key2] = mergeSchemas2(compacted, key2);
    return all;
  }, {});
}
var properties$3 = {
  keywords: ["properties", "patternProperties", "additionalProperties"],
  resolver(values, parents, mergers, options) {
    if (!options.ignoreAdditionalProperties) {
      values.forEach(function(subSchema) {
        const otherSubSchemas = values.filter((s4) => s4 !== subSchema);
        const ownKeys2 = keys$5(subSchema.properties);
        const ownPatternKeys = keys$5(subSchema.patternProperties);
        const ownPatterns = ownPatternKeys.map((k3) => new RegExp(k3));
        otherSubSchemas.forEach(function(other) {
          const allOtherKeys = keys$5(other.properties);
          const keysMatchingPattern = allOtherKeys.filter((k3) => ownPatterns.some((pk) => pk.test(k3)));
          const additionalKeys = withoutArr(allOtherKeys, ownKeys2, keysMatchingPattern);
          additionalKeys.forEach(function(key2) {
            other.properties[key2] = mergers.properties([
              other.properties[key2],
              subSchema.additionalProperties
            ], key2);
          });
        });
      });
      values.forEach(function(subSchema) {
        const otherSubSchemas = values.filter((s4) => s4 !== subSchema);
        const ownPatternKeys = keys$5(subSchema.patternProperties);
        if (subSchema.additionalProperties === false) {
          otherSubSchemas.forEach(function(other) {
            const allOtherPatterns = keys$5(other.patternProperties);
            const additionalPatternKeys = withoutArr(allOtherPatterns, ownPatternKeys);
            additionalPatternKeys.forEach((key2) => delete other.patternProperties[key2]);
          });
        }
      });
    }
    const returnObject = {
      additionalProperties: mergers.additionalProperties(values.map((s4) => s4.additionalProperties)),
      patternProperties: mergeSchemaGroup(values.map((s4) => s4.patternProperties), mergers.patternProperties),
      properties: mergeSchemaGroup(values.map((s4) => s4.properties), mergers.properties)
    };
    if (returnObject.additionalProperties === false) {
      removeFalseSchemas(returnObject.properties);
    }
    return deleteUndefinedProps$1(returnObject);
  }
};
const compare$1 = src$1;
const forEach = forEach_1;
const {
  allUniqueKeys: allUniqueKeys$1,
  deleteUndefinedProps,
  has: has$1,
  isSchema: isSchema$1,
  notUndefined: notUndefined$1,
  uniqWith: uniqWith$1
} = common;
function removeFalseSchemasFromArray(target) {
  forEach(target, function(schema, index2) {
    if (schema === false) {
      target.splice(index2, 1);
    }
  });
}
function getItemSchemas(subSchemas, key2) {
  return subSchemas.map(function(sub) {
    if (!sub) {
      return void 0;
    }
    if (Array.isArray(sub.items)) {
      const schemaAtPos = sub.items[key2];
      if (isSchema$1(schemaAtPos)) {
        return schemaAtPos;
      } else if (has$1(sub, "additionalItems")) {
        return sub.additionalItems;
      }
    } else {
      return sub.items;
    }
    return void 0;
  });
}
function getAdditionalSchemas(subSchemas) {
  return subSchemas.map(function(sub) {
    if (!sub) {
      return void 0;
    }
    if (Array.isArray(sub.items)) {
      return sub.additionalItems;
    }
    return sub.items;
  });
}
function mergeItems(group, mergeSchemas2, items2) {
  const allKeys = allUniqueKeys$1(items2);
  return allKeys.reduce(function(all, key2) {
    const schemas = getItemSchemas(group, key2);
    const compacted = uniqWith$1(schemas.filter(notUndefined$1), compare$1);
    all[key2] = mergeSchemas2(compacted, key2);
    return all;
  }, []);
}
var items$1 = {
  keywords: ["items", "additionalItems"],
  resolver(values, parents, mergers) {
    const items2 = values.map((s4) => s4.items);
    const itemsCompacted = items2.filter(notUndefined$1);
    const returnObject = {};
    if (itemsCompacted.every(isSchema$1)) {
      returnObject.items = mergers.items(items2);
    } else {
      returnObject.items = mergeItems(values, mergers.items, items2);
    }
    let schemasAtLastPos;
    if (itemsCompacted.every(Array.isArray)) {
      schemasAtLastPos = values.map((s4) => s4.additionalItems);
    } else if (itemsCompacted.some(Array.isArray)) {
      schemasAtLastPos = getAdditionalSchemas(values);
    }
    if (schemasAtLastPos) {
      returnObject.additionalItems = mergers.additionalItems(schemasAtLastPos);
    }
    if (returnObject.additionalItems === false && Array.isArray(returnObject.items)) {
      removeFalseSchemasFromArray(returnObject.items);
    }
    return deleteUndefinedProps(returnObject);
  }
};
const cloneDeep = cloneDeep_1;
const compare = src$1;
const computeLcm = lib$2;
const defaultsDeep = defaultsDeep_1;
const flatten = flatten_1;
const flattenDeep = flattenDeep_1;
const intersection = intersection_1;
const intersectionWith = intersectionWith_1;
const isEqual$1 = isEqual_1;
const isPlainObject$1 = isPlainObject_1;
const pullAll = pullAll_1;
const sortBy = sortBy_1;
const uniq = uniq_1;
const uniqWith = uniqWith_1;
const propertiesResolver = properties$3;
const itemsResolver = items$1;
const contains$1 = (arr, val) => arr.indexOf(val) !== -1;
const isSchema = (val) => isPlainObject$1(val) || val === true || val === false;
const isFalse = (val) => val === false;
const isTrue = (val) => val === true;
const schemaResolver = (compacted, key2, mergeSchemas2) => mergeSchemas2(compacted);
const stringArray = (values) => sortBy(uniq(flattenDeep(values)));
const notUndefined = (val) => val !== void 0;
const allUniqueKeys = (arr) => uniq(flattenDeep(arr.map(keys$4)));
const first = (compacted) => compacted[0];
const required$2 = (compacted) => stringArray(compacted);
const maximumValue = (compacted) => Math.max.apply(Math, compacted);
const minimumValue = (compacted) => Math.min.apply(Math, compacted);
const uniqueItems$1 = (compacted) => compacted.some(isTrue);
const examples = (compacted) => uniqWith(flatten(compacted), isEqual$1);
function compareProp(key2) {
  return function(a4, b3) {
    return compare({
      [key2]: a4
    }, { [key2]: b3 });
  };
}
function getAllOf(schema) {
  let { allOf: allOf2 = [], ...copy2 } = schema;
  copy2 = isPlainObject$1(schema) ? copy2 : schema;
  return [copy2, ...allOf2.map(getAllOf)];
}
function getValues(schemas, key2) {
  return schemas.map((schema) => schema && schema[key2]);
}
function tryMergeSchemaGroups(schemaGroups, mergeSchemas2) {
  return schemaGroups.map(function(schemas, index2) {
    try {
      return mergeSchemas2(schemas, index2);
    } catch (e5) {
      return void 0;
    }
  }).filter(notUndefined);
}
function keys$4(obj) {
  if (isPlainObject$1(obj) || Array.isArray(obj)) {
    return Object.keys(obj);
  } else {
    return [];
  }
}
function getAnyOfCombinations(arrOfArrays, combinations) {
  combinations = combinations || [];
  if (!arrOfArrays.length) {
    return combinations;
  }
  const values = arrOfArrays.slice(0).shift();
  const rest = arrOfArrays.slice(1);
  if (combinations.length) {
    return getAnyOfCombinations(rest, flatten(combinations.map((combination) => values.map((item) => [item].concat(combination)))));
  }
  return getAnyOfCombinations(rest, values.map((item) => item));
}
function throwIncompatible(values, paths) {
  let asJSON;
  try {
    asJSON = values.map(function(val) {
      return JSON.stringify(val, null, 2);
    }).join("\n");
  } catch (variable) {
    asJSON = values.join(", ");
  }
  throw new Error('Could not resolve values for path:"' + paths.join(".") + '". They are probably incompatible. Values: \n' + asJSON);
}
function callGroupResolver(complexKeywords, resolverName, schemas, mergeSchemas2, options, parents) {
  if (complexKeywords.length) {
    const resolverConfig = options.complexResolvers[resolverName];
    if (!resolverConfig || !resolverConfig.resolver) {
      throw new Error("No resolver found for " + resolverName);
    }
    const extractedKeywordsOnly = schemas.map((schema) => complexKeywords.reduce((all, key2) => {
      if (schema[key2] !== void 0) all[key2] = schema[key2];
      return all;
    }, {}));
    const unique = uniqWith(extractedKeywordsOnly, compare);
    const mergers = resolverConfig.keywords.reduce((all, key2) => ({
      ...all,
      [key2]: (schemas2, extraKey = []) => mergeSchemas2(schemas2, null, parents.concat(key2, extraKey))
    }), {});
    const result2 = resolverConfig.resolver(unique, parents.concat(resolverName), mergers, options);
    if (!isPlainObject$1(result2)) {
      throwIncompatible(unique, parents.concat(resolverName));
    }
    return result2;
  }
}
function createRequiredMetaArray(arr) {
  return { required: arr };
}
const schemaGroupProps = ["properties", "patternProperties", "definitions", "dependencies"];
const schemaArrays = ["anyOf", "oneOf"];
const schemaProps = [
  "additionalProperties",
  "additionalItems",
  "contains",
  "propertyNames",
  "not",
  "items"
];
const defaultResolvers = {
  type(compacted) {
    if (compacted.some(Array.isArray)) {
      const normalized = compacted.map(function(val) {
        return Array.isArray(val) ? val : [val];
      });
      const common2 = intersection.apply(null, normalized);
      if (common2.length === 1) {
        return common2[0];
      } else if (common2.length > 1) {
        return uniq(common2);
      }
    }
  },
  dependencies(compacted, paths, mergeSchemas2) {
    const allChildren = allUniqueKeys(compacted);
    return allChildren.reduce(function(all, childKey) {
      const childSchemas = getValues(compacted, childKey);
      let innerCompacted = uniqWith(childSchemas.filter(notUndefined), isEqual$1);
      const innerArrays = innerCompacted.filter(Array.isArray);
      if (innerArrays.length) {
        if (innerArrays.length === innerCompacted.length) {
          all[childKey] = stringArray(innerCompacted);
        } else {
          const innerSchemas = innerCompacted.filter(isSchema);
          const arrayMetaScheams = innerArrays.map(createRequiredMetaArray);
          all[childKey] = mergeSchemas2(innerSchemas.concat(arrayMetaScheams), childKey);
        }
        return all;
      }
      innerCompacted = uniqWith(innerCompacted, compare);
      all[childKey] = mergeSchemas2(innerCompacted, childKey);
      return all;
    }, {});
  },
  oneOf(compacted, paths, mergeSchemas2) {
    const combinations = getAnyOfCombinations(cloneDeep(compacted));
    const result2 = tryMergeSchemaGroups(combinations, mergeSchemas2);
    const unique = uniqWith(result2, compare);
    if (unique.length) {
      return unique;
    }
  },
  not(compacted) {
    return { anyOf: compacted };
  },
  pattern(compacted) {
    return compacted.map((r2) => "(?=" + r2 + ")").join("");
  },
  multipleOf(compacted) {
    let integers = compacted.slice(0);
    let factor = 1;
    while (integers.some((n2) => !Number.isInteger(n2))) {
      integers = integers.map((n2) => n2 * 10);
      factor = factor * 10;
    }
    return computeLcm(integers) / factor;
  },
  enum(compacted) {
    const enums = intersectionWith.apply(null, compacted.concat(isEqual$1));
    if (enums.length) {
      return sortBy(enums);
    }
  }
};
defaultResolvers.$id = first;
defaultResolvers.$ref = first;
defaultResolvers.$schema = first;
defaultResolvers.additionalItems = schemaResolver;
defaultResolvers.additionalProperties = schemaResolver;
defaultResolvers.anyOf = defaultResolvers.oneOf;
defaultResolvers.contains = schemaResolver;
defaultResolvers.default = first;
defaultResolvers.definitions = defaultResolvers.dependencies;
defaultResolvers.description = first;
defaultResolvers.examples = examples;
defaultResolvers.exclusiveMaximum = minimumValue;
defaultResolvers.exclusiveMinimum = maximumValue;
defaultResolvers.items = itemsResolver;
defaultResolvers.maximum = minimumValue;
defaultResolvers.maxItems = minimumValue;
defaultResolvers.maxLength = minimumValue;
defaultResolvers.maxProperties = minimumValue;
defaultResolvers.minimum = maximumValue;
defaultResolvers.minItems = maximumValue;
defaultResolvers.minLength = maximumValue;
defaultResolvers.minProperties = maximumValue;
defaultResolvers.properties = propertiesResolver;
defaultResolvers.propertyNames = schemaResolver;
defaultResolvers.required = required$2;
defaultResolvers.title = first;
defaultResolvers.uniqueItems = uniqueItems$1;
const defaultComplexResolvers = {
  properties: propertiesResolver,
  items: itemsResolver
};
function merger(rootSchema, options, totalSchemas) {
  options = defaultsDeep(options, {
    ignoreAdditionalProperties: false,
    resolvers: defaultResolvers,
    complexResolvers: defaultComplexResolvers,
    deep: true
  });
  const complexResolvers = Object.entries(options.complexResolvers);
  function mergeSchemas2(schemas, base, parents) {
    schemas = cloneDeep(schemas.filter(notUndefined));
    parents = parents || [];
    const merged2 = isPlainObject$1(base) ? base : {};
    if (!schemas.length) {
      return;
    }
    if (schemas.some(isFalse)) {
      return false;
    }
    if (schemas.every(isTrue)) {
      return true;
    }
    schemas = schemas.filter(isPlainObject$1);
    const allKeys = allUniqueKeys(schemas);
    if (options.deep && contains$1(allKeys, "allOf")) {
      return merger({
        allOf: schemas
      }, options);
    }
    const complexKeysArr = complexResolvers.map(([mainKeyWord, resolverConf]) => allKeys.filter((k3) => resolverConf.keywords.includes(k3)));
    complexKeysArr.forEach((keys4) => pullAll(allKeys, keys4));
    allKeys.forEach(function(key2) {
      const values = getValues(schemas, key2);
      const compacted = uniqWith(values.filter(notUndefined), compareProp(key2));
      if (compacted.length === 1 && contains$1(schemaArrays, key2)) {
        merged2[key2] = compacted[0].map((schema) => mergeSchemas2([schema], schema));
      } else if (compacted.length === 1 && !contains$1(schemaGroupProps, key2) && !contains$1(schemaProps, key2)) {
        merged2[key2] = compacted[0];
      } else {
        const resolver = options.resolvers[key2] || options.resolvers.defaultResolver;
        if (!resolver) throw new Error("No resolver found for key " + key2 + ". You can provide a resolver for this keyword in the options, or provide a default resolver.");
        const merger2 = (schemas2, extraKey = []) => mergeSchemas2(schemas2, null, parents.concat(key2, extraKey));
        merged2[key2] = resolver(compacted, parents.concat(key2), merger2, options);
        if (merged2[key2] === void 0) {
          throwIncompatible(compacted, parents.concat(key2));
        } else if (merged2[key2] === void 0) {
          delete merged2[key2];
        }
      }
    });
    return complexResolvers.reduce((all, [resolverKeyword, config], index2) => ({
      ...all,
      ...callGroupResolver(complexKeysArr[index2], resolverKeyword, schemas, mergeSchemas2, options, parents)
    }), merged2);
  }
  const allSchemas = flattenDeep(getAllOf(rootSchema));
  const merged = mergeSchemas2(allSchemas);
  return merged;
}
merger.options = {
  resolvers: defaultResolvers
};
var src = merger;
const mergeAllOf = /* @__PURE__ */ getDefaultExportFromCjs$1(src);
function getDiscriminatorFieldFromSchema(schema) {
  let discriminator2;
  const maybeString = get$6(schema, "discriminator.propertyName", void 0);
  if (isString$3(maybeString)) {
    discriminator2 = maybeString;
  } else if (maybeString !== void 0) {
    console.warn(`Expecting discriminator to be a string, got "${typeof maybeString}" instead`);
  }
  return discriminator2;
}
function guessType$1(value) {
  if (Array.isArray(value)) {
    return "array";
  }
  if (typeof value === "string") {
    return "string";
  }
  if (value == null) {
    return "null";
  }
  if (typeof value === "boolean") {
    return "boolean";
  }
  if (!isNaN(value)) {
    return "number";
  }
  if (typeof value === "object") {
    return "object";
  }
  return "string";
}
var baseFlatten = _baseFlatten, baseRest = _baseRest, baseUniq = _baseUniq, isArrayLikeObject = isArrayLikeObject_1;
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});
var union_1 = union;
const union$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(union_1);
function getSchemaType(schema) {
  let { type: type2 } = schema;
  if (!type2 && schema.const) {
    return guessType$1(schema.const);
  }
  if (!type2 && schema.enum) {
    return "string";
  }
  if (!type2 && (schema.properties || schema.additionalProperties)) {
    return "object";
  }
  if (Array.isArray(type2)) {
    if (type2.length === 2 && type2.includes("null")) {
      type2 = type2.find((type3) => type3 !== "null");
    } else {
      type2 = type2[0];
    }
  }
  return type2;
}
function mergeSchemas(obj1, obj2) {
  const acc = Object.assign({}, obj1);
  return Object.keys(obj2).reduce((acc2, key2) => {
    const left = obj1 ? obj1[key2] : {}, right = obj2[key2];
    if (obj1 && key2 in obj1 && isObject$d(right)) {
      acc2[key2] = mergeSchemas(left, right);
    } else if (obj1 && obj2 && (getSchemaType(obj1) === "object" || getSchemaType(obj2) === "object") && key2 === REQUIRED_KEY && Array.isArray(left) && Array.isArray(right)) {
      acc2[key2] = union$1(left, right);
    } else {
      acc2[key2] = right;
    }
    return acc2;
  }, acc);
}
function retrieveSchema(validator2, schema, rootSchema = {}, rawFormData) {
  return retrieveSchemaInternal(validator2, schema, rootSchema, rawFormData)[0];
}
function resolveCondition(validator2, schema, rootSchema, expandAllBranches, recurseList, formData) {
  const { if: expression, then, else: otherwise, ...resolvedSchemaLessConditional } = schema;
  const conditionValue = validator2.isValid(expression, formData || {}, rootSchema);
  let resolvedSchemas = [resolvedSchemaLessConditional];
  let schemas = [];
  if (expandAllBranches) {
    if (then && typeof then !== "boolean") {
      schemas = schemas.concat(retrieveSchemaInternal(validator2, then, rootSchema, formData, expandAllBranches, recurseList));
    }
    if (otherwise && typeof otherwise !== "boolean") {
      schemas = schemas.concat(retrieveSchemaInternal(validator2, otherwise, rootSchema, formData, expandAllBranches, recurseList));
    }
  } else {
    const conditionalSchema = conditionValue ? then : otherwise;
    if (conditionalSchema && typeof conditionalSchema !== "boolean") {
      schemas = schemas.concat(retrieveSchemaInternal(validator2, conditionalSchema, rootSchema, formData, expandAllBranches, recurseList));
    }
  }
  if (schemas.length) {
    resolvedSchemas = schemas.map((s4) => mergeSchemas(resolvedSchemaLessConditional, s4));
  }
  return resolvedSchemas.flatMap((s4) => retrieveSchemaInternal(validator2, s4, rootSchema, formData, expandAllBranches, recurseList));
}
function getAllPermutationsOfXxxOf(listOfLists) {
  const allPermutations = listOfLists.reduce(
    (permutations, list) => {
      if (list.length > 1) {
        return list.flatMap((element) => times$2(permutations.length, (i3) => [...permutations[i3]].concat(element)));
      }
      permutations.forEach((permutation) => permutation.push(list[0]));
      return permutations;
    },
    [[]]
    // Start with an empty list
  );
  return allPermutations;
}
function resolveSchema$1(validator2, schema, rootSchema, expandAllBranches, recurseList, formData) {
  const updatedSchemas = resolveReference(validator2, schema, rootSchema, expandAllBranches, recurseList, formData);
  if (updatedSchemas.length > 1 || updatedSchemas[0] !== schema) {
    return updatedSchemas;
  }
  if (DEPENDENCIES_KEY in schema) {
    const resolvedSchemas = resolveDependencies(validator2, schema, rootSchema, expandAllBranches, recurseList, formData);
    return resolvedSchemas.flatMap((s4) => {
      return retrieveSchemaInternal(validator2, s4, rootSchema, formData, expandAllBranches, recurseList);
    });
  }
  if (ALL_OF_KEY in schema && Array.isArray(schema.allOf)) {
    const allOfSchemaElements = schema.allOf.map((allOfSubschema) => retrieveSchemaInternal(validator2, allOfSubschema, rootSchema, formData, expandAllBranches, recurseList));
    const allPermutations = getAllPermutationsOfXxxOf(allOfSchemaElements);
    return allPermutations.map((permutation) => ({ ...schema, allOf: permutation }));
  }
  return [schema];
}
function resolveReference(validator2, schema, rootSchema, expandAllBranches, recurseList, formData) {
  const updatedSchema = resolveAllReferences(schema, rootSchema, recurseList);
  if (updatedSchema !== schema) {
    return retrieveSchemaInternal(validator2, updatedSchema, rootSchema, formData, expandAllBranches, recurseList);
  }
  return [schema];
}
function resolveAllReferences(schema, rootSchema, recurseList) {
  if (!isObject$d(schema)) {
    return schema;
  }
  let resolvedSchema = schema;
  if (REF_KEY in resolvedSchema) {
    const { $ref, ...localSchema } = resolvedSchema;
    if (recurseList.includes($ref)) {
      return resolvedSchema;
    }
    recurseList.push($ref);
    const refSchema = findSchemaDefinition($ref, rootSchema);
    resolvedSchema = { ...refSchema, ...localSchema };
  }
  if (PROPERTIES_KEY in resolvedSchema) {
    const childrenLists = [];
    const updatedProps = transform$1(resolvedSchema[PROPERTIES_KEY], (result2, value, key2) => {
      const childList = [...recurseList];
      result2[key2] = resolveAllReferences(value, rootSchema, childList);
      childrenLists.push(childList);
    }, {});
    merge$1(recurseList, uniq$4(flattenDeep$3(childrenLists)));
    resolvedSchema = { ...resolvedSchema, [PROPERTIES_KEY]: updatedProps };
  }
  if (ITEMS_KEY in resolvedSchema && !Array.isArray(resolvedSchema.items) && typeof resolvedSchema.items !== "boolean") {
    resolvedSchema = {
      ...resolvedSchema,
      items: resolveAllReferences(resolvedSchema.items, rootSchema, recurseList)
    };
  }
  return isEqual$4(schema, resolvedSchema) ? schema : resolvedSchema;
}
function stubExistingAdditionalProperties(validator2, theSchema, rootSchema, aFormData) {
  const schema = {
    ...theSchema,
    properties: { ...theSchema.properties }
  };
  const formData = aFormData && isObject$d(aFormData) ? aFormData : {};
  Object.keys(formData).forEach((key2) => {
    if (key2 in schema.properties) {
      return;
    }
    let additionalProperties2 = {};
    if (typeof schema.additionalProperties !== "boolean") {
      if (REF_KEY in schema.additionalProperties) {
        additionalProperties2 = retrieveSchema(validator2, { $ref: get$6(schema.additionalProperties, [REF_KEY]) }, rootSchema, formData);
      } else if ("type" in schema.additionalProperties) {
        additionalProperties2 = { ...schema.additionalProperties };
      } else if (ANY_OF_KEY in schema.additionalProperties || ONE_OF_KEY in schema.additionalProperties) {
        additionalProperties2 = {
          type: "object",
          ...schema.additionalProperties
        };
      } else {
        additionalProperties2 = { type: guessType$1(get$6(formData, [key2])) };
      }
    } else {
      additionalProperties2 = { type: guessType$1(get$6(formData, [key2])) };
    }
    schema.properties[key2] = additionalProperties2;
    set$3(schema.properties, [key2, ADDITIONAL_PROPERTY_FLAG], true);
  });
  return schema;
}
function retrieveSchemaInternal(validator2, schema, rootSchema, rawFormData, expandAllBranches = false, recurseList = []) {
  if (!isObject$d(schema)) {
    return [{}];
  }
  const resolvedSchemas = resolveSchema$1(validator2, schema, rootSchema, expandAllBranches, recurseList, rawFormData);
  return resolvedSchemas.flatMap((s4) => {
    let resolvedSchema = s4;
    if (IF_KEY in resolvedSchema) {
      return resolveCondition(validator2, resolvedSchema, rootSchema, expandAllBranches, recurseList, rawFormData);
    }
    if (ALL_OF_KEY in resolvedSchema) {
      if (expandAllBranches) {
        const { allOf: allOf2, ...restOfSchema } = resolvedSchema;
        return [...allOf2, restOfSchema];
      }
      try {
        resolvedSchema = mergeAllOf(resolvedSchema, {
          deep: false
        });
      } catch (e5) {
        console.warn("could not merge subschemas in allOf:\n", e5);
        const { allOf: allOf2, ...resolvedSchemaWithoutAllOf } = resolvedSchema;
        return resolvedSchemaWithoutAllOf;
      }
    }
    const hasAdditionalProperties = ADDITIONAL_PROPERTIES_KEY in resolvedSchema && resolvedSchema.additionalProperties !== false;
    if (hasAdditionalProperties) {
      return stubExistingAdditionalProperties(validator2, resolvedSchema, rootSchema, rawFormData);
    }
    return resolvedSchema;
  });
}
function resolveAnyOrOneOfSchemas(validator2, schema, rootSchema, expandAllBranches, rawFormData) {
  let anyOrOneOf;
  const { oneOf: oneOf2, anyOf: anyOf2, ...remaining } = schema;
  if (Array.isArray(oneOf2)) {
    anyOrOneOf = oneOf2;
  } else if (Array.isArray(anyOf2)) {
    anyOrOneOf = anyOf2;
  }
  if (anyOrOneOf) {
    const formData = rawFormData === void 0 && expandAllBranches ? {} : rawFormData;
    const discriminator2 = getDiscriminatorFieldFromSchema(schema);
    anyOrOneOf = anyOrOneOf.map((s4) => {
      return resolveAllReferences(s4, rootSchema, []);
    });
    const option2 = getFirstMatchingOption(validator2, formData, anyOrOneOf, rootSchema, discriminator2);
    if (expandAllBranches) {
      return anyOrOneOf.map((item) => mergeSchemas(remaining, item));
    }
    schema = mergeSchemas(remaining, anyOrOneOf[option2]);
  }
  return [schema];
}
function resolveDependencies(validator2, schema, rootSchema, expandAllBranches, recurseList, formData) {
  const { dependencies: dependencies2, ...remainingSchema } = schema;
  const resolvedSchemas = resolveAnyOrOneOfSchemas(validator2, remainingSchema, rootSchema, expandAllBranches, formData);
  return resolvedSchemas.flatMap((resolvedSchema) => processDependencies(validator2, dependencies2, resolvedSchema, rootSchema, expandAllBranches, recurseList, formData));
}
function processDependencies(validator2, dependencies2, resolvedSchema, rootSchema, expandAllBranches, recurseList, formData) {
  let schemas = [resolvedSchema];
  for (const dependencyKey in dependencies2) {
    if (!expandAllBranches && get$6(formData, [dependencyKey]) === void 0) {
      continue;
    }
    if (resolvedSchema.properties && !(dependencyKey in resolvedSchema.properties)) {
      continue;
    }
    const [remainingDependencies, dependencyValue] = splitKeyElementFromObject(dependencyKey, dependencies2);
    if (Array.isArray(dependencyValue)) {
      schemas[0] = withDependentProperties(resolvedSchema, dependencyValue);
    } else if (isObject$d(dependencyValue)) {
      schemas = withDependentSchema(validator2, resolvedSchema, rootSchema, dependencyKey, dependencyValue, expandAllBranches, recurseList, formData);
    }
    return schemas.flatMap((schema) => processDependencies(validator2, remainingDependencies, schema, rootSchema, expandAllBranches, recurseList, formData));
  }
  return schemas;
}
function withDependentProperties(schema, additionallyRequired) {
  if (!additionallyRequired) {
    return schema;
  }
  const required2 = Array.isArray(schema.required) ? Array.from(/* @__PURE__ */ new Set([...schema.required, ...additionallyRequired])) : additionallyRequired;
  return { ...schema, required: required2 };
}
function withDependentSchema(validator2, schema, rootSchema, dependencyKey, dependencyValue, expandAllBranches, recurseList, formData) {
  const dependentSchemas = retrieveSchemaInternal(validator2, dependencyValue, rootSchema, formData, expandAllBranches, recurseList);
  return dependentSchemas.flatMap((dependent) => {
    const { oneOf: oneOf2, ...dependentSchema } = dependent;
    schema = mergeSchemas(schema, dependentSchema);
    if (oneOf2 === void 0) {
      return schema;
    }
    const resolvedOneOfs = oneOf2.map((subschema2) => {
      if (typeof subschema2 === "boolean" || !(REF_KEY in subschema2)) {
        return [subschema2];
      }
      return resolveReference(validator2, subschema2, rootSchema, expandAllBranches, recurseList, formData);
    });
    const allPermutations = getAllPermutationsOfXxxOf(resolvedOneOfs);
    return allPermutations.flatMap((resolvedOneOf) => withExactlyOneSubschema(validator2, schema, rootSchema, dependencyKey, resolvedOneOf, expandAllBranches, recurseList, formData));
  });
}
function withExactlyOneSubschema(validator2, schema, rootSchema, dependencyKey, oneOf2, expandAllBranches, recurseList, formData) {
  const validSubschemas = oneOf2.filter((subschema2) => {
    if (typeof subschema2 === "boolean" || !subschema2 || !subschema2.properties) {
      return false;
    }
    const { [dependencyKey]: conditionPropertySchema } = subschema2.properties;
    if (conditionPropertySchema) {
      const conditionSchema = {
        type: "object",
        properties: {
          [dependencyKey]: conditionPropertySchema
        }
      };
      return validator2.isValid(conditionSchema, formData, rootSchema) || expandAllBranches;
    }
    return false;
  });
  if (!expandAllBranches && validSubschemas.length !== 1) {
    console.warn("ignoring oneOf in dependencies because there isn't exactly one subschema that is valid");
    return [schema];
  }
  return validSubschemas.flatMap((s4) => {
    const subschema2 = s4;
    const [dependentSubschema] = splitKeyElementFromObject(dependencyKey, subschema2.properties);
    const dependentSchema = { ...subschema2, properties: dependentSubschema };
    const schemas = retrieveSchemaInternal(validator2, dependentSchema, rootSchema, formData, expandAllBranches, recurseList);
    return schemas.map((s5) => mergeSchemas(schema, s5));
  });
}
const JUNK_OPTION = {
  type: "object",
  $id: JUNK_OPTION_ID,
  properties: {
    __not_really_there__: {
      type: "number"
    }
  }
};
function calculateIndexScore(validator2, rootSchema, schema, formData = {}) {
  let totalScore = 0;
  if (schema) {
    if (isObject$j(schema.properties)) {
      totalScore += reduce$1(schema.properties, (score, value, key2) => {
        const formValue = get$6(formData, key2);
        if (typeof value === "boolean") {
          return score;
        }
        if (has$5(value, REF_KEY)) {
          const newSchema = retrieveSchema(validator2, value, rootSchema, formValue);
          return score + calculateIndexScore(validator2, rootSchema, newSchema, formValue || {});
        }
        if ((has$5(value, ONE_OF_KEY) || has$5(value, ANY_OF_KEY)) && formValue) {
          const key3 = has$5(value, ONE_OF_KEY) ? ONE_OF_KEY : ANY_OF_KEY;
          const discriminator2 = getDiscriminatorFieldFromSchema(value);
          return score + getClosestMatchingOption(validator2, rootSchema, formValue, get$6(value, key3), -1, discriminator2);
        }
        if (value.type === "object") {
          return score + calculateIndexScore(validator2, rootSchema, value, formValue || {});
        }
        if (value.type === guessType$1(formValue)) {
          let newScore = score + 1;
          if (value.default) {
            newScore += formValue === value.default ? 1 : -1;
          } else if (value.const) {
            newScore += formValue === value.const ? 1 : -1;
          }
          return newScore;
        }
        return score;
      }, 0);
    } else if (isString$3(schema.type) && schema.type === guessType$1(formData)) {
      totalScore += 1;
    }
  }
  return totalScore;
}
function getClosestMatchingOption(validator2, rootSchema, formData, options, selectedOption = -1, discriminatorField) {
  const resolvedOptions = options.map((option2) => {
    return resolveAllReferences(option2, rootSchema, []);
  });
  const simpleDiscriminatorMatch = getOptionMatchingSimpleDiscriminator(formData, options, discriminatorField);
  if (isNumber$4(simpleDiscriminatorMatch)) {
    return simpleDiscriminatorMatch;
  }
  const allValidIndexes = resolvedOptions.reduce((validList, option2, index2) => {
    const testOptions = [JUNK_OPTION, option2];
    const match5 = getFirstMatchingOption(validator2, formData, testOptions, rootSchema, discriminatorField);
    if (match5 === 1) {
      validList.push(index2);
    }
    return validList;
  }, []);
  if (allValidIndexes.length === 1) {
    return allValidIndexes[0];
  }
  if (!allValidIndexes.length) {
    times$2(resolvedOptions.length, (i3) => allValidIndexes.push(i3));
  }
  const scoreCount = /* @__PURE__ */ new Set();
  const { bestIndex } = allValidIndexes.reduce((scoreData, index2) => {
    const { bestScore } = scoreData;
    const option2 = resolvedOptions[index2];
    const score = calculateIndexScore(validator2, rootSchema, option2, formData);
    scoreCount.add(score);
    if (score > bestScore) {
      return { bestIndex: index2, bestScore: score };
    }
    return scoreData;
  }, { bestIndex: selectedOption, bestScore: 0 });
  if (scoreCount.size === 1 && selectedOption >= 0) {
    return selectedOption;
  }
  return bestIndex;
}
function isFixedItems(schema) {
  return Array.isArray(schema.items) && schema.items.length > 0 && schema.items.every((item) => isObject$d(item));
}
function mergeDefaultsWithFormData(defaults2, formData, mergeExtraArrayDefaults = false) {
  if (Array.isArray(formData)) {
    const defaultsArray = Array.isArray(defaults2) ? defaults2 : [];
    const mapped = formData.map((value, idx) => {
      if (defaultsArray[idx]) {
        return mergeDefaultsWithFormData(defaultsArray[idx], value, mergeExtraArrayDefaults);
      }
      return value;
    });
    if (mergeExtraArrayDefaults && mapped.length < defaultsArray.length) {
      mapped.push(...defaultsArray.slice(mapped.length));
    }
    return mapped;
  }
  if (isObject$d(formData)) {
    const acc = Object.assign({}, defaults2);
    return Object.keys(formData).reduce((acc2, key2) => {
      acc2[key2] = mergeDefaultsWithFormData(defaults2 ? get$6(defaults2, key2) : {}, get$6(formData, key2), mergeExtraArrayDefaults);
      return acc2;
    }, acc);
  }
  return formData;
}
function mergeObjects(obj1, obj2, concatArrays = false) {
  return Object.keys(obj2).reduce((acc, key2) => {
    const left = obj1 ? obj1[key2] : {}, right = obj2[key2];
    if (obj1 && key2 in obj1 && isObject$d(right)) {
      acc[key2] = mergeObjects(left, right, concatArrays);
    } else if (concatArrays && Array.isArray(left) && Array.isArray(right)) {
      let toMerge = right;
      if (concatArrays === "preventDuplicates") {
        toMerge = right.reduce((result2, value) => {
          if (!left.includes(value)) {
            result2.push(value);
          }
          return result2;
        }, []);
      }
      acc[key2] = left.concat(toMerge);
    } else {
      acc[key2] = right;
    }
    return acc;
  }, Object.assign({}, obj1));
}
function isConstant(schema) {
  return Array.isArray(schema.enum) && schema.enum.length === 1 || CONST_KEY in schema;
}
function isSelect(validator2, theSchema, rootSchema = {}) {
  const schema = retrieveSchema(validator2, theSchema, rootSchema, void 0);
  const altSchemas = schema.oneOf || schema.anyOf;
  if (Array.isArray(schema.enum)) {
    return true;
  }
  if (Array.isArray(altSchemas)) {
    return altSchemas.every((altSchemas2) => typeof altSchemas2 !== "boolean" && isConstant(altSchemas2));
  }
  return false;
}
function isMultiSelect(validator2, schema, rootSchema) {
  if (!schema.uniqueItems || !schema.items || typeof schema.items === "boolean") {
    return false;
  }
  return isSelect(validator2, schema.items, rootSchema);
}
var AdditionalItemsHandling;
(function(AdditionalItemsHandling2) {
  AdditionalItemsHandling2[AdditionalItemsHandling2["Ignore"] = 0] = "Ignore";
  AdditionalItemsHandling2[AdditionalItemsHandling2["Invert"] = 1] = "Invert";
  AdditionalItemsHandling2[AdditionalItemsHandling2["Fallback"] = 2] = "Fallback";
})(AdditionalItemsHandling || (AdditionalItemsHandling = {}));
function getInnerSchemaForArrayItem(schema, additionalItems2 = AdditionalItemsHandling.Ignore, idx = -1) {
  if (idx >= 0) {
    if (Array.isArray(schema.items) && idx < schema.items.length) {
      const item = schema.items[idx];
      if (typeof item !== "boolean") {
        return item;
      }
    }
  } else if (schema.items && !Array.isArray(schema.items) && typeof schema.items !== "boolean") {
    return schema.items;
  }
  if (additionalItems2 !== AdditionalItemsHandling.Ignore && isObject$d(schema.additionalItems)) {
    return schema.additionalItems;
  }
  return {};
}
function maybeAddDefaultToObject(obj, key2, computedDefault, includeUndefinedValues, isParentRequired, requiredFields = [], experimental_defaultFormStateBehavior = {}) {
  const { emptyObjectFields = "populateAllDefaults" } = experimental_defaultFormStateBehavior;
  if (includeUndefinedValues) {
    obj[key2] = computedDefault;
  } else if (emptyObjectFields !== "skipDefaults") {
    if (isObject$d(computedDefault)) {
      const isSelfOrParentRequired = isParentRequired === void 0 ? requiredFields.includes(key2) : isParentRequired;
      if (emptyObjectFields === "skipEmptyDefaults") {
        if (!_isEmpty(computedDefault)) {
          obj[key2] = computedDefault;
        }
      } else if ((!_isEmpty(computedDefault) || requiredFields.includes(key2)) && (isSelfOrParentRequired || emptyObjectFields !== "populateRequiredDefaults")) {
        obj[key2] = computedDefault;
      }
    } else if (
      // Store computedDefault if it's a defined primitive (e.g., true) and satisfies certain conditions
      // Condition 1: computedDefault is not undefined
      // Condition 2: If emptyObjectFields is 'populateAllDefaults' or 'skipEmptyDefaults) or if the key is a required field
      computedDefault !== void 0 && (emptyObjectFields === "populateAllDefaults" || emptyObjectFields === "skipEmptyDefaults" || requiredFields.includes(key2))
    ) {
      obj[key2] = computedDefault;
    }
  }
}
function computeDefaults(validator2, rawSchema, { parentDefaults, rawFormData, rootSchema = {}, includeUndefinedValues = false, _recurseList = [], experimental_defaultFormStateBehavior = void 0, required: required2 } = {}) {
  var _a2, _b2, _c2, _d2;
  const formData = isObject$d(rawFormData) ? rawFormData : {};
  const schema = isObject$d(rawSchema) ? rawSchema : {};
  let defaults2 = parentDefaults;
  let schemaToCompute = null;
  let updatedRecurseList = _recurseList;
  if (isObject$d(defaults2) && isObject$d(schema.default)) {
    defaults2 = mergeObjects(defaults2, schema.default);
  } else if (DEFAULT_KEY in schema) {
    defaults2 = schema.default;
  } else if (REF_KEY in schema) {
    const refName = schema[REF_KEY];
    if (!_recurseList.includes(refName)) {
      updatedRecurseList = _recurseList.concat(refName);
      schemaToCompute = findSchemaDefinition(refName, rootSchema);
    }
  } else if (DEPENDENCIES_KEY in schema) {
    const resolvedSchema = resolveDependencies(validator2, schema, rootSchema, false, [], formData);
    schemaToCompute = resolvedSchema[0];
  } else if (isFixedItems(schema)) {
    defaults2 = schema.items.map((itemSchema, idx) => computeDefaults(validator2, itemSchema, {
      rootSchema,
      includeUndefinedValues,
      _recurseList,
      experimental_defaultFormStateBehavior,
      parentDefaults: Array.isArray(parentDefaults) ? parentDefaults[idx] : void 0,
      rawFormData: formData,
      required: required2
    }));
  } else if (ONE_OF_KEY in schema) {
    const { oneOf: oneOf2, ...remaining } = schema;
    if (oneOf2.length === 0) {
      return void 0;
    }
    const discriminator2 = getDiscriminatorFieldFromSchema(schema);
    schemaToCompute = oneOf2[getClosestMatchingOption(validator2, rootSchema, _isEmpty(formData) ? void 0 : formData, oneOf2, 0, discriminator2)];
    schemaToCompute = mergeSchemas(remaining, schemaToCompute);
  } else if (ANY_OF_KEY in schema) {
    const { anyOf: anyOf2, ...remaining } = schema;
    if (anyOf2.length === 0) {
      return void 0;
    }
    const discriminator2 = getDiscriminatorFieldFromSchema(schema);
    schemaToCompute = anyOf2[getClosestMatchingOption(validator2, rootSchema, _isEmpty(formData) ? void 0 : formData, anyOf2, 0, discriminator2)];
    schemaToCompute = mergeSchemas(remaining, schemaToCompute);
  }
  if (schemaToCompute) {
    return computeDefaults(validator2, schemaToCompute, {
      rootSchema,
      includeUndefinedValues,
      _recurseList: updatedRecurseList,
      experimental_defaultFormStateBehavior,
      parentDefaults: defaults2,
      rawFormData: formData,
      required: required2
    });
  }
  if (defaults2 === void 0) {
    defaults2 = schema.default;
  }
  switch (getSchemaType(schema)) {
    case "object": {
      const retrievedSchema = (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.allOf) === "populateDefaults" && ALL_OF_KEY in schema ? retrieveSchema(validator2, schema, rootSchema, formData) : schema;
      const objectDefaults = Object.keys(retrievedSchema.properties || {}).reduce((acc, key2) => {
        var _a3;
        const computedDefault = computeDefaults(validator2, get$6(retrievedSchema, [PROPERTIES_KEY, key2]), {
          rootSchema,
          _recurseList,
          experimental_defaultFormStateBehavior,
          includeUndefinedValues: includeUndefinedValues === true,
          parentDefaults: get$6(defaults2, [key2]),
          rawFormData: get$6(formData, [key2]),
          required: (_a3 = retrievedSchema.required) === null || _a3 === void 0 ? void 0 : _a3.includes(key2)
        });
        maybeAddDefaultToObject(acc, key2, computedDefault, includeUndefinedValues, required2, retrievedSchema.required, experimental_defaultFormStateBehavior);
        return acc;
      }, {});
      if (retrievedSchema.additionalProperties) {
        const additionalPropertiesSchema = isObject$d(retrievedSchema.additionalProperties) ? retrievedSchema.additionalProperties : {};
        const keys4 = /* @__PURE__ */ new Set();
        if (isObject$d(defaults2)) {
          Object.keys(defaults2).filter((key2) => !retrievedSchema.properties || !retrievedSchema.properties[key2]).forEach((key2) => keys4.add(key2));
        }
        const formDataRequired = [];
        Object.keys(formData).filter((key2) => !retrievedSchema.properties || !retrievedSchema.properties[key2]).forEach((key2) => {
          keys4.add(key2);
          formDataRequired.push(key2);
        });
        keys4.forEach((key2) => {
          var _a3;
          const computedDefault = computeDefaults(validator2, additionalPropertiesSchema, {
            rootSchema,
            _recurseList,
            experimental_defaultFormStateBehavior,
            includeUndefinedValues: includeUndefinedValues === true,
            parentDefaults: get$6(defaults2, [key2]),
            rawFormData: get$6(formData, [key2]),
            required: (_a3 = retrievedSchema.required) === null || _a3 === void 0 ? void 0 : _a3.includes(key2)
          });
          maybeAddDefaultToObject(objectDefaults, key2, computedDefault, includeUndefinedValues, required2, formDataRequired);
        });
      }
      return objectDefaults;
    }
    case "array": {
      const neverPopulate = ((_a2 = experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.arrayMinItems) === null || _a2 === void 0 ? void 0 : _a2.populate) === "never";
      const ignoreMinItemsFlagSet = ((_b2 = experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.arrayMinItems) === null || _b2 === void 0 ? void 0 : _b2.populate) === "requiredOnly";
      const isSkipEmptyDefaults = (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.emptyObjectFields) === "skipEmptyDefaults";
      const computeSkipPopulate = (_d2 = (_c2 = experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.arrayMinItems) === null || _c2 === void 0 ? void 0 : _c2.computeSkipPopulate) !== null && _d2 !== void 0 ? _d2 : () => false;
      const emptyDefault = isSkipEmptyDefaults ? void 0 : [];
      if (Array.isArray(defaults2)) {
        defaults2 = defaults2.map((item, idx) => {
          const schemaItem = getInnerSchemaForArrayItem(schema, AdditionalItemsHandling.Fallback, idx);
          return computeDefaults(validator2, schemaItem, {
            rootSchema,
            _recurseList,
            experimental_defaultFormStateBehavior,
            parentDefaults: item,
            required: required2
          });
        });
      }
      if (Array.isArray(rawFormData)) {
        const schemaItem = getInnerSchemaForArrayItem(schema);
        if (neverPopulate) {
          defaults2 = rawFormData;
        } else {
          defaults2 = rawFormData.map((item, idx) => {
            return computeDefaults(validator2, schemaItem, {
              rootSchema,
              _recurseList,
              experimental_defaultFormStateBehavior,
              rawFormData: item,
              parentDefaults: get$6(defaults2, [idx]),
              required: required2
            });
          });
        }
      }
      if (neverPopulate) {
        return defaults2 !== null && defaults2 !== void 0 ? defaults2 : emptyDefault;
      }
      if (ignoreMinItemsFlagSet && !required2) {
        return defaults2 ? defaults2 : void 0;
      }
      const defaultsLength = Array.isArray(defaults2) ? defaults2.length : 0;
      if (!schema.minItems || isMultiSelect(validator2, schema, rootSchema) || computeSkipPopulate(validator2, schema, rootSchema) || schema.minItems <= defaultsLength) {
        return defaults2 ? defaults2 : emptyDefault;
      }
      const defaultEntries = defaults2 || [];
      const fillerSchema = getInnerSchemaForArrayItem(schema, AdditionalItemsHandling.Invert);
      const fillerDefault = fillerSchema.default;
      const fillerEntries = new Array(schema.minItems - defaultsLength).fill(computeDefaults(validator2, fillerSchema, {
        parentDefaults: fillerDefault,
        rootSchema,
        _recurseList,
        experimental_defaultFormStateBehavior,
        required: required2
      }));
      return defaultEntries.concat(fillerEntries);
    }
  }
  return defaults2;
}
function getDefaultFormState(validator2, theSchema, formData, rootSchema, includeUndefinedValues = false, experimental_defaultFormStateBehavior) {
  if (!isObject$d(theSchema)) {
    throw new Error("Invalid schema: " + theSchema);
  }
  const schema = retrieveSchema(validator2, theSchema, rootSchema, formData);
  const defaults2 = computeDefaults(validator2, schema, {
    rootSchema,
    includeUndefinedValues,
    experimental_defaultFormStateBehavior,
    rawFormData: formData
  });
  if (formData === void 0 || formData === null || typeof formData === "number" && isNaN(formData)) {
    return defaults2;
  }
  const { mergeExtraDefaults } = (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.arrayMinItems) || {};
  if (isObject$d(formData)) {
    return mergeDefaultsWithFormData(defaults2, formData, mergeExtraDefaults);
  }
  if (Array.isArray(formData)) {
    return mergeDefaultsWithFormData(defaults2, formData, mergeExtraDefaults);
  }
  return formData;
}
function isCustomWidget(uiSchema = {}) {
  return (
    // TODO: Remove the `&& uiSchema['ui:widget'] !== 'hidden'` once we support hidden widgets for arrays.
    // https://rjsf-team.github.io/react-jsonschema-form/docs/usage/widgets/#hidden-widgets
    "widget" in getUiOptions(uiSchema) && getUiOptions(uiSchema)["widget"] !== "hidden"
  );
}
function isFilesArray(validator2, schema, uiSchema = {}, rootSchema) {
  if (uiSchema[UI_WIDGET_KEY] === "files") {
    return true;
  }
  if (schema.items) {
    const itemsSchema = retrieveSchema(validator2, schema.items, rootSchema);
    return itemsSchema.type === "string" && itemsSchema.format === "data-url";
  }
  return false;
}
function getDisplayLabel(validator2, schema, uiSchema = {}, rootSchema, globalOptions) {
  const uiOptions = getUiOptions(uiSchema, globalOptions);
  const { label = true } = uiOptions;
  let displayLabel = !!label;
  const schemaType = getSchemaType(schema);
  if (schemaType === "array") {
    displayLabel = isMultiSelect(validator2, schema, rootSchema) || isFilesArray(validator2, schema, uiSchema, rootSchema) || isCustomWidget(uiSchema);
  }
  if (schemaType === "object") {
    displayLabel = false;
  }
  if (schemaType === "boolean" && !uiSchema[UI_WIDGET_KEY]) {
    displayLabel = false;
  }
  if (uiSchema[UI_FIELD_KEY]) {
    displayLabel = false;
  }
  return displayLabel;
}
function mergeValidationData(validator2, validationData, additionalErrorSchema) {
  if (!additionalErrorSchema) {
    return validationData;
  }
  const { errors: oldErrors, errorSchema: oldErrorSchema } = validationData;
  let errors2 = validator2.toErrorList(additionalErrorSchema);
  let errorSchema = additionalErrorSchema;
  if (!_isEmpty(oldErrorSchema)) {
    errorSchema = mergeObjects(oldErrorSchema, additionalErrorSchema, true);
    errors2 = [...oldErrors].concat(errors2);
  }
  return { errorSchema, errors: errors2 };
}
const NO_VALUE = Symbol("no Value");
function sanitizeDataForNewSchema(validator2, rootSchema, newSchema, oldSchema, data = {}) {
  let newFormData;
  if (has$5(newSchema, PROPERTIES_KEY)) {
    const removeOldSchemaData = {};
    if (has$5(oldSchema, PROPERTIES_KEY)) {
      const properties2 = get$6(oldSchema, PROPERTIES_KEY, {});
      Object.keys(properties2).forEach((key2) => {
        if (has$5(data, key2)) {
          removeOldSchemaData[key2] = void 0;
        }
      });
    }
    const keys4 = Object.keys(get$6(newSchema, PROPERTIES_KEY, {}));
    const nestedData = {};
    keys4.forEach((key2) => {
      const formValue = get$6(data, key2);
      let oldKeyedSchema = get$6(oldSchema, [PROPERTIES_KEY, key2], {});
      let newKeyedSchema = get$6(newSchema, [PROPERTIES_KEY, key2], {});
      if (has$5(oldKeyedSchema, REF_KEY)) {
        oldKeyedSchema = retrieveSchema(validator2, oldKeyedSchema, rootSchema, formValue);
      }
      if (has$5(newKeyedSchema, REF_KEY)) {
        newKeyedSchema = retrieveSchema(validator2, newKeyedSchema, rootSchema, formValue);
      }
      const oldSchemaTypeForKey = get$6(oldKeyedSchema, "type");
      const newSchemaTypeForKey = get$6(newKeyedSchema, "type");
      if (!oldSchemaTypeForKey || oldSchemaTypeForKey === newSchemaTypeForKey) {
        if (has$5(removeOldSchemaData, key2)) {
          delete removeOldSchemaData[key2];
        }
        if (newSchemaTypeForKey === "object" || newSchemaTypeForKey === "array" && Array.isArray(formValue)) {
          const itemData = sanitizeDataForNewSchema(validator2, rootSchema, newKeyedSchema, oldKeyedSchema, formValue);
          if (itemData !== void 0 || newSchemaTypeForKey === "array") {
            nestedData[key2] = itemData;
          }
        } else {
          const newOptionDefault = get$6(newKeyedSchema, "default", NO_VALUE);
          const oldOptionDefault = get$6(oldKeyedSchema, "default", NO_VALUE);
          if (newOptionDefault !== NO_VALUE && newOptionDefault !== formValue) {
            if (oldOptionDefault === formValue) {
              removeOldSchemaData[key2] = newOptionDefault;
            } else if (get$6(newKeyedSchema, "readOnly") === true) {
              removeOldSchemaData[key2] = void 0;
            }
          }
          const newOptionConst = get$6(newKeyedSchema, "const", NO_VALUE);
          const oldOptionConst = get$6(oldKeyedSchema, "const", NO_VALUE);
          if (newOptionConst !== NO_VALUE && newOptionConst !== formValue) {
            removeOldSchemaData[key2] = oldOptionConst === formValue ? newOptionConst : void 0;
          }
        }
      }
    });
    newFormData = {
      ...typeof data == "string" || Array.isArray(data) ? void 0 : data,
      ...removeOldSchemaData,
      ...nestedData
    };
  } else if (get$6(oldSchema, "type") === "array" && get$6(newSchema, "type") === "array" && Array.isArray(data)) {
    let oldSchemaItems = get$6(oldSchema, "items");
    let newSchemaItems = get$6(newSchema, "items");
    if (typeof oldSchemaItems === "object" && typeof newSchemaItems === "object" && !Array.isArray(oldSchemaItems) && !Array.isArray(newSchemaItems)) {
      if (has$5(oldSchemaItems, REF_KEY)) {
        oldSchemaItems = retrieveSchema(validator2, oldSchemaItems, rootSchema, data);
      }
      if (has$5(newSchemaItems, REF_KEY)) {
        newSchemaItems = retrieveSchema(validator2, newSchemaItems, rootSchema, data);
      }
      const oldSchemaType = get$6(oldSchemaItems, "type");
      const newSchemaType = get$6(newSchemaItems, "type");
      if (!oldSchemaType || oldSchemaType === newSchemaType) {
        const maxItems = get$6(newSchema, "maxItems", -1);
        if (newSchemaType === "object") {
          newFormData = data.reduce((newValue, aValue) => {
            const itemValue = sanitizeDataForNewSchema(validator2, rootSchema, newSchemaItems, oldSchemaItems, aValue);
            if (itemValue !== void 0 && (maxItems < 0 || newValue.length < maxItems)) {
              newValue.push(itemValue);
            }
            return newValue;
          }, []);
        } else {
          newFormData = maxItems > 0 && data.length > maxItems ? data.slice(0, maxItems) : data;
        }
      }
    } else if (typeof oldSchemaItems === "boolean" && typeof newSchemaItems === "boolean" && oldSchemaItems === newSchemaItems) {
      newFormData = data;
    }
  }
  return newFormData;
}
function toIdSchemaInternal(validator2, schema, idPrefix, idSeparator, id2, rootSchema, formData, _recurseList = []) {
  if (REF_KEY in schema || DEPENDENCIES_KEY in schema || ALL_OF_KEY in schema) {
    const _schema = retrieveSchema(validator2, schema, rootSchema, formData);
    const sameSchemaIndex = _recurseList.findIndex((item) => isEqual$4(item, _schema));
    if (sameSchemaIndex === -1) {
      return toIdSchemaInternal(validator2, _schema, idPrefix, idSeparator, id2, rootSchema, formData, _recurseList.concat(_schema));
    }
  }
  if (ITEMS_KEY in schema && !get$6(schema, [ITEMS_KEY, REF_KEY])) {
    return toIdSchemaInternal(validator2, get$6(schema, ITEMS_KEY), idPrefix, idSeparator, id2, rootSchema, formData, _recurseList);
  }
  const $id2 = id2 || idPrefix;
  const idSchema = { $id: $id2 };
  if (getSchemaType(schema) === "object" && PROPERTIES_KEY in schema) {
    for (const name2 in schema.properties) {
      const field = get$6(schema, [PROPERTIES_KEY, name2]);
      const fieldId = idSchema[ID_KEY] + idSeparator + name2;
      idSchema[name2] = toIdSchemaInternal(
        validator2,
        isObject$d(field) ? field : {},
        idPrefix,
        idSeparator,
        fieldId,
        rootSchema,
        // It's possible that formData is not an object -- this can happen if an
        // array item has just been added, but not populated with data yet
        get$6(formData, [name2]),
        _recurseList
      );
    }
  }
  return idSchema;
}
function toIdSchema(validator2, schema, id2, rootSchema, formData, idPrefix = "root", idSeparator = "_") {
  return toIdSchemaInternal(validator2, schema, idPrefix, idSeparator, id2, rootSchema, formData);
}
function toPathSchemaInternal(validator2, schema, name2, rootSchema, formData, _recurseList = []) {
  if (REF_KEY in schema || DEPENDENCIES_KEY in schema || ALL_OF_KEY in schema) {
    const _schema = retrieveSchema(validator2, schema, rootSchema, formData);
    const sameSchemaIndex = _recurseList.findIndex((item) => isEqual$4(item, _schema));
    if (sameSchemaIndex === -1) {
      return toPathSchemaInternal(validator2, _schema, name2, rootSchema, formData, _recurseList.concat(_schema));
    }
  }
  let pathSchema = {
    [NAME_KEY]: name2.replace(/^\./, "")
  };
  if (ONE_OF_KEY in schema || ANY_OF_KEY in schema) {
    const xxxOf = ONE_OF_KEY in schema ? schema.oneOf : schema.anyOf;
    const discriminator2 = getDiscriminatorFieldFromSchema(schema);
    const index2 = getClosestMatchingOption(validator2, rootSchema, formData, xxxOf, 0, discriminator2);
    const _schema = xxxOf[index2];
    pathSchema = {
      ...pathSchema,
      ...toPathSchemaInternal(validator2, _schema, name2, rootSchema, formData, _recurseList)
    };
  }
  if (ADDITIONAL_PROPERTIES_KEY in schema && schema[ADDITIONAL_PROPERTIES_KEY] !== false) {
    set$3(pathSchema, RJSF_ADDITIONAL_PROPERTIES_FLAG, true);
  }
  if (ITEMS_KEY in schema && Array.isArray(formData)) {
    const { items: schemaItems, additionalItems: schemaAdditionalItems } = schema;
    if (Array.isArray(schemaItems)) {
      formData.forEach((element, i3) => {
        if (schemaItems[i3]) {
          pathSchema[i3] = toPathSchemaInternal(validator2, schemaItems[i3], `${name2}.${i3}`, rootSchema, element, _recurseList);
        } else if (schemaAdditionalItems) {
          pathSchema[i3] = toPathSchemaInternal(validator2, schemaAdditionalItems, `${name2}.${i3}`, rootSchema, element, _recurseList);
        } else {
          console.warn(`Unable to generate path schema for "${name2}.${i3}". No schema defined for it`);
        }
      });
    } else {
      formData.forEach((element, i3) => {
        pathSchema[i3] = toPathSchemaInternal(validator2, schemaItems, `${name2}.${i3}`, rootSchema, element, _recurseList);
      });
    }
  } else if (PROPERTIES_KEY in schema) {
    for (const property2 in schema.properties) {
      const field = get$6(schema, [PROPERTIES_KEY, property2]);
      pathSchema[property2] = toPathSchemaInternal(
        validator2,
        field,
        `${name2}.${property2}`,
        rootSchema,
        // It's possible that formData is not an object -- this can happen if an
        // array item has just been added, but not populated with data yet
        get$6(formData, [property2]),
        _recurseList
      );
    }
  }
  return pathSchema;
}
function toPathSchema(validator2, schema, name2 = "", rootSchema, formData) {
  return toPathSchemaInternal(validator2, schema, name2, rootSchema, formData);
}
class SchemaUtils {
  /** Constructs the `SchemaUtils` instance with the given `validator` and `rootSchema` stored as instance variables
   *
   * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
   * @param rootSchema - The root schema that will be forwarded to all the APIs
   * @param experimental_defaultFormStateBehavior - Configuration flags to allow users to override default form state behavior
   */
  constructor(validator2, rootSchema, experimental_defaultFormStateBehavior) {
    this.rootSchema = rootSchema;
    this.validator = validator2;
    this.experimental_defaultFormStateBehavior = experimental_defaultFormStateBehavior;
  }
  /** Returns the `ValidatorType` in the `SchemaUtilsType`
   *
   * @returns - The `ValidatorType`
   */
  getValidator() {
    return this.validator;
  }
  /** Determines whether either the `validator` and `rootSchema` differ from the ones associated with this instance of
   * the `SchemaUtilsType`. If either `validator` or `rootSchema` are falsy, then return false to prevent the creation
   * of a new `SchemaUtilsType` with incomplete properties.
   *
   * @param validator - An implementation of the `ValidatorType` interface that will be compared against the current one
   * @param rootSchema - The root schema that will be compared against the current one
   * @param [experimental_defaultFormStateBehavior] Optional configuration object, if provided, allows users to override default form state behavior
   * @returns - True if the `SchemaUtilsType` differs from the given `validator` or `rootSchema`
   */
  doesSchemaUtilsDiffer(validator2, rootSchema, experimental_defaultFormStateBehavior = {}) {
    if (!validator2 || !rootSchema) {
      return false;
    }
    return this.validator !== validator2 || !deepEquals(this.rootSchema, rootSchema) || !deepEquals(this.experimental_defaultFormStateBehavior, experimental_defaultFormStateBehavior);
  }
  /** Returns the superset of `formData` that includes the given set updated to include any missing fields that have
   * computed to have defaults provided in the `schema`.
   *
   * @param schema - The schema for which the default state is desired
   * @param [formData] - The current formData, if any, onto which to provide any missing defaults
   * @param [includeUndefinedValues=false] - Optional flag, if true, cause undefined values to be added as defaults.
   *          If "excludeObjectChildren", pass `includeUndefinedValues` as false when computing defaults for any nested
   *          object properties.
   * @returns - The resulting `formData` with all the defaults provided
   */
  getDefaultFormState(schema, formData, includeUndefinedValues = false) {
    return getDefaultFormState(this.validator, schema, formData, this.rootSchema, includeUndefinedValues, this.experimental_defaultFormStateBehavior);
  }
  /** Determines whether the combination of `schema` and `uiSchema` properties indicates that the label for the `schema`
   * should be displayed in a UI.
   *
   * @param schema - The schema for which the display label flag is desired
   * @param [uiSchema] - The UI schema from which to derive potentially displayable information
   * @param [globalOptions={}] - The optional Global UI Schema from which to get any fallback `xxx` options
   * @returns - True if the label should be displayed or false if it should not
   */
  getDisplayLabel(schema, uiSchema, globalOptions) {
    return getDisplayLabel(this.validator, schema, uiSchema, this.rootSchema, globalOptions);
  }
  /** Determines which of the given `options` provided most closely matches the `formData`.
   * Returns the index of the option that is valid and is the closest match, or 0 if there is no match.
   *
   * The closest match is determined using the number of matching properties, and more heavily favors options with
   * matching readOnly, default, or const values.
   *
   * @param formData - The form data associated with the schema
   * @param options - The list of options that can be selected from
   * @param [selectedOption] - The index of the currently selected option, defaulted to -1 if not specified
   * @param [discriminatorField] - The optional name of the field within the options object whose value is used to
   *          determine which option is selected
   * @returns - The index of the option that is the closest match to the `formData` or the `selectedOption` if no match
   */
  getClosestMatchingOption(formData, options, selectedOption, discriminatorField) {
    return getClosestMatchingOption(this.validator, this.rootSchema, formData, options, selectedOption, discriminatorField);
  }
  /** Given the `formData` and list of `options`, attempts to find the index of the first option that matches the data.
   * Always returns the first option if there is nothing that matches.
   *
   * @param formData - The current formData, if any, used to figure out a match
   * @param options - The list of options to find a matching options from
   * @param [discriminatorField] - The optional name of the field within the options object whose value is used to
   *          determine which option is selected
   * @returns - The firstindex of the matched option or 0 if none is available
   */
  getFirstMatchingOption(formData, options, discriminatorField) {
    return getFirstMatchingOption(this.validator, formData, options, this.rootSchema, discriminatorField);
  }
  /** Given the `formData` and list of `options`, attempts to find the index of the option that best matches the data.
   * Deprecated, use `getFirstMatchingOption()` instead.
   *
   * @param formData - The current formData, if any, onto which to provide any missing defaults
   * @param options - The list of options to find a matching options from
   * @param [discriminatorField] - The optional name of the field within the options object whose value is used to
   *          determine which option is selected
   * @returns - The index of the matched option or 0 if none is available
   * @deprecated
   */
  getMatchingOption(formData, options, discriminatorField) {
    return getMatchingOption(this.validator, formData, options, this.rootSchema, discriminatorField);
  }
  /** Checks to see if the `schema` and `uiSchema` combination represents an array of files
   *
   * @param schema - The schema for which check for array of files flag is desired
   * @param [uiSchema] - The UI schema from which to check the widget
   * @returns - True if schema/uiSchema contains an array of files, otherwise false
   */
  isFilesArray(schema, uiSchema) {
    return isFilesArray(this.validator, schema, uiSchema, this.rootSchema);
  }
  /** Checks to see if the `schema` combination represents a multi-select
   *
   * @param schema - The schema for which check for a multi-select flag is desired
   * @returns - True if schema contains a multi-select, otherwise false
   */
  isMultiSelect(schema) {
    return isMultiSelect(this.validator, schema, this.rootSchema);
  }
  /** Checks to see if the `schema` combination represents a select
   *
   * @param schema - The schema for which check for a select flag is desired
   * @returns - True if schema contains a select, otherwise false
   */
  isSelect(schema) {
    return isSelect(this.validator, schema, this.rootSchema);
  }
  /** Merges the errors in `additionalErrorSchema` into the existing `validationData` by combining the hierarchies in
   * the two `ErrorSchema`s and then appending the error list from the `additionalErrorSchema` obtained by calling
   * `getValidator().toErrorList()` onto the `errors` in the `validationData`. If no `additionalErrorSchema` is passed,
   * then `validationData` is returned.
   *
   * @param validationData - The current `ValidationData` into which to merge the additional errors
   * @param [additionalErrorSchema] - The additional set of errors
   * @returns - The `validationData` with the additional errors from `additionalErrorSchema` merged into it, if provided.
   * @deprecated - Use the `validationDataMerge()` function exported from `@rjsf/utils` instead. This function will be
   *        removed in the next major release.
   */
  mergeValidationData(validationData, additionalErrorSchema) {
    return mergeValidationData(this.validator, validationData, additionalErrorSchema);
  }
  /** Retrieves an expanded schema that has had all of its conditions, additional properties, references and
   * dependencies resolved and merged into the `schema` given a `rawFormData` that is used to do the potentially
   * recursive resolution.
   *
   * @param schema - The schema for which retrieving a schema is desired
   * @param [rawFormData] - The current formData, if any, to assist retrieving a schema
   * @returns - The schema having its conditions, additional properties, references and dependencies resolved
   */
  retrieveSchema(schema, rawFormData) {
    return retrieveSchema(this.validator, schema, this.rootSchema, rawFormData);
  }
  /** Sanitize the `data` associated with the `oldSchema` so it is considered appropriate for the `newSchema`. If the
   * new schema does not contain any properties, then `undefined` is returned to clear all the form data. Due to the
   * nature of schemas, this sanitization happens recursively for nested objects of data. Also, any properties in the
   * old schemas that are non-existent in the new schema are set to `undefined`.
   *
   * @param [newSchema] - The new schema for which the data is being sanitized
   * @param [oldSchema] - The old schema from which the data originated
   * @param [data={}] - The form data associated with the schema, defaulting to an empty object when undefined
   * @returns - The new form data, with all the fields uniquely associated with the old schema set
   *      to `undefined`. Will return `undefined` if the new schema is not an object containing properties.
   */
  sanitizeDataForNewSchema(newSchema, oldSchema, data) {
    return sanitizeDataForNewSchema(this.validator, this.rootSchema, newSchema, oldSchema, data);
  }
  /** Generates an `IdSchema` object for the `schema`, recursively
   *
   * @param schema - The schema for which the display label flag is desired
   * @param [id] - The base id for the schema
   * @param [formData] - The current formData, if any, onto which to provide any missing defaults
   * @param [idPrefix='root'] - The prefix to use for the id
   * @param [idSeparator='_'] - The separator to use for the path segments in the id
   * @returns - The `IdSchema` object for the `schema`
   */
  toIdSchema(schema, id2, formData, idPrefix = "root", idSeparator = "_") {
    return toIdSchema(this.validator, schema, id2, this.rootSchema, formData, idPrefix, idSeparator);
  }
  /** Generates an `PathSchema` object for the `schema`, recursively
   *
   * @param schema - The schema for which the display label flag is desired
   * @param [name] - The base name for the schema
   * @param [formData] - The current formData, if any, onto which to provide any missing defaults
   * @returns - The `PathSchema` object for the `schema`
   */
  toPathSchema(schema, name2, formData) {
    return toPathSchema(this.validator, schema, name2, this.rootSchema, formData);
  }
}
function createSchemaUtils(validator2, rootSchema, experimental_defaultFormStateBehavior = {}) {
  return new SchemaUtils(validator2, rootSchema, experimental_defaultFormStateBehavior);
}
function dataURItoBlob(dataURILike) {
  var _a2;
  if (dataURILike.indexOf("data:") === -1) {
    throw new Error("File is invalid: URI must be a dataURI");
  }
  const dataURI = dataURILike.slice(5);
  const splitted = dataURI.split(";base64,");
  if (splitted.length !== 2) {
    throw new Error("File is invalid: dataURI must be base64");
  }
  const [media, base64] = splitted;
  const [mime, ...mediaparams] = media.split(";");
  const type2 = mime || "";
  const name2 = decodeURI(
    // parse the parameters into key-value pairs, find a key, and extract a value
    // if no key is found, then the name is unknown
    ((_a2 = mediaparams.map((param) => param.split("=")).find(([key2]) => key2 === "name")) === null || _a2 === void 0 ? void 0 : _a2[1]) || "unknown"
  );
  try {
    const binary = atob(base64);
    const array = new Array(binary.length);
    for (let i3 = 0; i3 < binary.length; i3++) {
      array[i3] = binary.charCodeAt(i3);
    }
    const blob = new window.Blob([new Uint8Array(array)], { type: type2 });
    return { blob, name: name2 };
  } catch (error2) {
    throw new Error("File is invalid: " + error2.message);
  }
}
function replaceStringParameters(inputString, params) {
  let output = inputString;
  if (Array.isArray(params)) {
    const parts = output.split(/(%\d)/);
    params.forEach((param, index2) => {
      const partIndex = parts.findIndex((part) => part === `%${index2 + 1}`);
      if (partIndex >= 0) {
        parts[partIndex] = param;
      }
    });
    output = parts.join("");
  }
  return output;
}
function englishStringTranslator(stringToTranslate, params) {
  return replaceStringParameters(stringToTranslate, params);
}
function enumOptionsValueForIndex(valueIndex, allEnumOptions = [], emptyValue) {
  if (Array.isArray(valueIndex)) {
    return valueIndex.map((index3) => enumOptionsValueForIndex(index3, allEnumOptions)).filter((val) => val !== emptyValue);
  }
  const index2 = valueIndex === "" || valueIndex === null ? -1 : Number(valueIndex);
  const option2 = allEnumOptions[index2];
  return option2 ? option2.value : emptyValue;
}
function enumOptionsDeselectValue(valueIndex, selected, allEnumOptions = []) {
  const value = enumOptionsValueForIndex(valueIndex, allEnumOptions);
  if (Array.isArray(selected)) {
    return selected.filter((v2) => !isEqual$4(v2, value));
  }
  return isEqual$4(value, selected) ? void 0 : selected;
}
function enumOptionsIsSelected(value, selected) {
  if (Array.isArray(selected)) {
    return selected.some((sel) => isEqual$4(sel, value));
  }
  return isEqual$4(selected, value);
}
function enumOptionsIndexForValue(value, allEnumOptions = [], multiple = false) {
  const selectedIndexes = allEnumOptions.map((opt, index2) => enumOptionsIsSelected(opt.value, value) ? String(index2) : void 0).filter((opt) => typeof opt !== "undefined");
  if (!multiple) {
    return selectedIndexes[0];
  }
  return selectedIndexes;
}
function isNil(value) {
  return value == null;
}
var isNil_1 = isNil;
const isNil$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(isNil_1);
function enumOptionsSelectValue(valueIndex, selected, allEnumOptions = []) {
  const value = enumOptionsValueForIndex(valueIndex, allEnumOptions);
  if (!isNil$1(value)) {
    const index2 = allEnumOptions.findIndex((opt) => value === opt.value);
    const all = allEnumOptions.map(({ value: val }) => val);
    const updated = selected.slice(0, index2).concat(value, selected.slice(index2));
    return updated.sort((a4, b3) => Number(all.indexOf(a4) > all.indexOf(b3)));
  }
  return selected;
}
class ErrorSchemaBuilder {
  /** Construct an `ErrorSchemaBuilder` with an optional initial set of errors in an `ErrorSchema`.
   *
   * @param [initialSchema] - The optional set of initial errors, that will be cloned into the class
   */
  constructor(initialSchema) {
    this.errorSchema = {};
    this.resetAllErrors(initialSchema);
  }
  /** Returns the `ErrorSchema` that has been updated by the methods of the `ErrorSchemaBuilder`
   */
  get ErrorSchema() {
    return this.errorSchema;
  }
  /** Will get an existing `ErrorSchema` at the specified `pathOfError` or create and return one.
   *
   * @param [pathOfError] - The optional path into the `ErrorSchema` at which to add the error(s)
   * @returns - The error block for the given `pathOfError` or the root if not provided
   * @private
   */
  getOrCreateErrorBlock(pathOfError) {
    const hasPath2 = Array.isArray(pathOfError) && pathOfError.length > 0 || typeof pathOfError === "string";
    let errorBlock = hasPath2 ? get$6(this.errorSchema, pathOfError) : this.errorSchema;
    if (!errorBlock && pathOfError) {
      errorBlock = {};
      set$3(this.errorSchema, pathOfError, errorBlock);
    }
    return errorBlock;
  }
  /** Resets all errors in the `ErrorSchemaBuilder` back to the `initialSchema` if provided, otherwise an empty set.
   *
   * @param [initialSchema] - The optional set of initial errors, that will be cloned into the class
   * @returns - The `ErrorSchemaBuilder` object for chaining purposes
   */
  resetAllErrors(initialSchema) {
    this.errorSchema = initialSchema ? cloneDeep$2(initialSchema) : {};
    return this;
  }
  /** Adds the `errorOrList` to the list of errors in the `ErrorSchema` at either the root level or the location within
   * the schema described by the `pathOfError`. For more information about how to specify the path see the
   * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
   *
   * @param errorOrList - The error or list of errors to add into the `ErrorSchema`
   * @param [pathOfError] - The optional path into the `ErrorSchema` at which to add the error(s)
   * @returns - The `ErrorSchemaBuilder` object for chaining purposes
   */
  addErrors(errorOrList, pathOfError) {
    const errorBlock = this.getOrCreateErrorBlock(pathOfError);
    let errorsList = get$6(errorBlock, ERRORS_KEY);
    if (!Array.isArray(errorsList)) {
      errorsList = [];
      errorBlock[ERRORS_KEY] = errorsList;
    }
    if (Array.isArray(errorOrList)) {
      errorsList.push(...errorOrList);
    } else {
      errorsList.push(errorOrList);
    }
    return this;
  }
  /** Sets/replaces the `errorOrList` as the error(s) in the `ErrorSchema` at either the root level or the location
   * within the schema described by the `pathOfError`. For more information about how to specify the path see the
   * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
   *
   * @param errorOrList - The error or list of errors to set into the `ErrorSchema`
   * @param [pathOfError] - The optional path into the `ErrorSchema` at which to set the error(s)
   * @returns - The `ErrorSchemaBuilder` object for chaining purposes
   */
  setErrors(errorOrList, pathOfError) {
    const errorBlock = this.getOrCreateErrorBlock(pathOfError);
    const listToAdd = Array.isArray(errorOrList) ? [...errorOrList] : [errorOrList];
    set$3(errorBlock, ERRORS_KEY, listToAdd);
    return this;
  }
  /** Clears the error(s) in the `ErrorSchema` at either the root level or the location within the schema described by
   * the `pathOfError`. For more information about how to specify the path see the
   * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
   *
   * @param [pathOfError] - The optional path into the `ErrorSchema` at which to clear the error(s)
   * @returns - The `ErrorSchemaBuilder` object for chaining purposes
   */
  clearErrors(pathOfError) {
    const errorBlock = this.getOrCreateErrorBlock(pathOfError);
    set$3(errorBlock, ERRORS_KEY, []);
    return this;
  }
}
function getDateElementProps(date, time2, yearRange = [1900, (/* @__PURE__ */ new Date()).getFullYear() + 2], format3 = "YMD") {
  const { day, month, year, hour, minute, second } = date;
  const dayObj = { type: "day", range: [1, 31], value: day };
  const monthObj = { type: "month", range: [1, 12], value: month };
  const yearObj = { type: "year", range: yearRange, value: year };
  const dateElementProp = [];
  switch (format3) {
    case "MDY":
      dateElementProp.push(monthObj, dayObj, yearObj);
      break;
    case "DMY":
      dateElementProp.push(dayObj, monthObj, yearObj);
      break;
    case "YMD":
    default:
      dateElementProp.push(yearObj, monthObj, dayObj);
  }
  if (time2) {
    dateElementProp.push({ type: "hour", range: [0, 23], value: hour }, { type: "minute", range: [0, 59], value: minute }, { type: "second", range: [0, 59], value: second });
  }
  return dateElementProp;
}
function rangeSpec(schema) {
  const spec = {};
  if (schema.multipleOf) {
    spec.step = schema.multipleOf;
  }
  if (schema.minimum || schema.minimum === 0) {
    spec.min = schema.minimum;
  }
  if (schema.maximum || schema.maximum === 0) {
    spec.max = schema.maximum;
  }
  return spec;
}
function getInputProps(schema, defaultType, options = {}, autoDefaultStepAny = true) {
  const inputProps = {
    type: defaultType || "text",
    ...rangeSpec(schema)
  };
  if (options.inputType) {
    inputProps.type = options.inputType;
  } else if (!defaultType) {
    if (schema.type === "number") {
      inputProps.type = "number";
      if (autoDefaultStepAny && inputProps.step === void 0) {
        inputProps.step = "any";
      }
    } else if (schema.type === "integer") {
      inputProps.type = "number";
      if (inputProps.step === void 0) {
        inputProps.step = 1;
      }
    }
  }
  if (options.autocomplete) {
    inputProps.autoComplete = options.autocomplete;
  }
  return inputProps;
}
const DEFAULT_OPTIONS = {
  props: {
    disabled: false
  },
  submitText: "Submit",
  norender: false
};
function getSubmitButtonOptions(uiSchema = {}) {
  const uiOptions = getUiOptions(uiSchema);
  if (uiOptions && uiOptions[SUBMIT_BTN_OPTIONS_KEY]) {
    const options = uiOptions[SUBMIT_BTN_OPTIONS_KEY];
    return { ...DEFAULT_OPTIONS, ...options };
  }
  return DEFAULT_OPTIONS;
}
function getTemplate(name2, registry, uiOptions = {}) {
  const { templates: templates2 } = registry;
  if (name2 === "ButtonTemplates") {
    return templates2[name2];
  }
  return (
    // Evaluating uiOptions[name] results in TS2590: Expression produces a union type that is too complex to represent
    // To avoid that, we cast uiOptions to `any` before accessing the name field
    uiOptions[name2] || templates2[name2]
  );
}
var reactIs = { exports: {} };
var reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b3 = Symbol.for("react.element"), c3 = Symbol.for("react.portal"), d4 = Symbol.for("react.fragment"), e5 = Symbol.for("react.strict_mode"), f2 = Symbol.for("react.profiler"), g2 = Symbol.for("react.provider"), h4 = Symbol.for("react.context"), k3 = Symbol.for("react.server_context"), l2 = Symbol.for("react.forward_ref"), m4 = Symbol.for("react.suspense"), n2 = Symbol.for("react.suspense_list"), p2 = Symbol.for("react.memo"), q3 = Symbol.for("react.lazy"), t3 = Symbol.for("react.offscreen"), u3;
  u3 = Symbol.for("react.module.reference");
  function v2(a4) {
    if ("object" === typeof a4 && null !== a4) {
      var r2 = a4.$$typeof;
      switch (r2) {
        case b3:
          switch (a4 = a4.type, a4) {
            case d4:
            case f2:
            case e5:
            case m4:
            case n2:
              return a4;
            default:
              switch (a4 = a4 && a4.$$typeof, a4) {
                case k3:
                case h4:
                case l2:
                case q3:
                case p2:
                case g2:
                  return a4;
                default:
                  return r2;
              }
          }
        case c3:
          return r2;
      }
    }
  }
  reactIs_production_min.ContextConsumer = h4;
  reactIs_production_min.ContextProvider = g2;
  reactIs_production_min.Element = b3;
  reactIs_production_min.ForwardRef = l2;
  reactIs_production_min.Fragment = d4;
  reactIs_production_min.Lazy = q3;
  reactIs_production_min.Memo = p2;
  reactIs_production_min.Portal = c3;
  reactIs_production_min.Profiler = f2;
  reactIs_production_min.StrictMode = e5;
  reactIs_production_min.Suspense = m4;
  reactIs_production_min.SuspenseList = n2;
  reactIs_production_min.isAsyncMode = function() {
    return false;
  };
  reactIs_production_min.isConcurrentMode = function() {
    return false;
  };
  reactIs_production_min.isContextConsumer = function(a4) {
    return v2(a4) === h4;
  };
  reactIs_production_min.isContextProvider = function(a4) {
    return v2(a4) === g2;
  };
  reactIs_production_min.isElement = function(a4) {
    return "object" === typeof a4 && null !== a4 && a4.$$typeof === b3;
  };
  reactIs_production_min.isForwardRef = function(a4) {
    return v2(a4) === l2;
  };
  reactIs_production_min.isFragment = function(a4) {
    return v2(a4) === d4;
  };
  reactIs_production_min.isLazy = function(a4) {
    return v2(a4) === q3;
  };
  reactIs_production_min.isMemo = function(a4) {
    return v2(a4) === p2;
  };
  reactIs_production_min.isPortal = function(a4) {
    return v2(a4) === c3;
  };
  reactIs_production_min.isProfiler = function(a4) {
    return v2(a4) === f2;
  };
  reactIs_production_min.isStrictMode = function(a4) {
    return v2(a4) === e5;
  };
  reactIs_production_min.isSuspense = function(a4) {
    return v2(a4) === m4;
  };
  reactIs_production_min.isSuspenseList = function(a4) {
    return v2(a4) === n2;
  };
  reactIs_production_min.isValidElementType = function(a4) {
    return "string" === typeof a4 || "function" === typeof a4 || a4 === d4 || a4 === f2 || a4 === e5 || a4 === m4 || a4 === n2 || a4 === t3 || "object" === typeof a4 && null !== a4 && (a4.$$typeof === q3 || a4.$$typeof === p2 || a4.$$typeof === g2 || a4.$$typeof === h4 || a4.$$typeof === l2 || a4.$$typeof === u3 || void 0 !== a4.getModuleId) ? true : false;
  };
  reactIs_production_min.typeOf = v2;
  return reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process$1$1.env.NODE_ENV !== "production") {
    (function() {
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type2) {
        if (typeof type2 === "string" || typeof type2 === "function") {
          return true;
        }
        if (type2 === REACT_FRAGMENT_TYPE || type2 === REACT_PROFILER_TYPE || enableDebugTracing || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type2 === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type2 === "object" && type2 !== null) {
          if (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type2.$$typeof === REACT_MODULE_REFERENCE || type2.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type2 = object.type;
              switch (type2) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_SERVER_CONTEXT_TYPE:
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isConcurrentMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true;
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
      }
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal2;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.SuspenseList = SuspenseList;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement2;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isSuspenseList = isSuspenseList;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
if (process$1$1.env.NODE_ENV === "production") {
  reactIs.exports = requireReactIs_production_min();
} else {
  reactIs.exports = requireReactIs_development();
}
var reactIsExports = reactIs.exports;
const ReactIs$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(reactIsExports);
const widgetMap = {
  boolean: {
    checkbox: "CheckboxWidget",
    radio: "RadioWidget",
    select: "SelectWidget",
    hidden: "HiddenWidget"
  },
  string: {
    text: "TextWidget",
    password: "PasswordWidget",
    email: "EmailWidget",
    hostname: "TextWidget",
    ipv4: "TextWidget",
    ipv6: "TextWidget",
    uri: "URLWidget",
    "data-url": "FileWidget",
    radio: "RadioWidget",
    select: "SelectWidget",
    textarea: "TextareaWidget",
    hidden: "HiddenWidget",
    date: "DateWidget",
    datetime: "DateTimeWidget",
    "date-time": "DateTimeWidget",
    "alt-date": "AltDateWidget",
    "alt-datetime": "AltDateTimeWidget",
    time: "TimeWidget",
    color: "ColorWidget",
    file: "FileWidget"
  },
  number: {
    text: "TextWidget",
    select: "SelectWidget",
    updown: "UpDownWidget",
    range: "RangeWidget",
    radio: "RadioWidget",
    hidden: "HiddenWidget"
  },
  integer: {
    text: "TextWidget",
    select: "SelectWidget",
    updown: "UpDownWidget",
    range: "RangeWidget",
    radio: "RadioWidget",
    hidden: "HiddenWidget"
  },
  array: {
    select: "SelectWidget",
    checkboxes: "CheckboxesWidget",
    files: "FileWidget",
    hidden: "HiddenWidget"
  }
};
function mergeWidgetOptions(AWidget) {
  let MergedWidget = get$6(AWidget, "MergedWidget");
  if (!MergedWidget) {
    const defaultOptions2 = AWidget.defaultProps && AWidget.defaultProps.options || {};
    MergedWidget = ({ options, ...props2 }) => {
      return jsx$1(AWidget, { options: { ...defaultOptions2, ...options }, ...props2 });
    };
    set$3(AWidget, "MergedWidget", MergedWidget);
  }
  return MergedWidget;
}
function getWidget(schema, widget, registeredWidgets = {}) {
  const type2 = getSchemaType(schema);
  if (typeof widget === "function" || widget && ReactIs$1.isForwardRef(createElement$2(widget)) || ReactIs$1.isMemo(widget)) {
    return mergeWidgetOptions(widget);
  }
  if (typeof widget !== "string") {
    throw new Error(`Unsupported widget definition: ${typeof widget}`);
  }
  if (widget in registeredWidgets) {
    const registeredWidget = registeredWidgets[widget];
    return getWidget(schema, registeredWidget, registeredWidgets);
  }
  if (typeof type2 === "string") {
    if (!(type2 in widgetMap)) {
      throw new Error(`No widget for type '${type2}'`);
    }
    if (widget in widgetMap[type2]) {
      const registeredWidget = registeredWidgets[widgetMap[type2][widget]];
      return getWidget(schema, registeredWidget, registeredWidgets);
    }
  }
  throw new Error(`No widget '${widget}' for type '${type2}'`);
}
function hashString(string3) {
  let hash = 0;
  for (let i3 = 0; i3 < string3.length; i3 += 1) {
    const chr = string3.charCodeAt(i3);
    hash = (hash << 5) - hash + chr;
    hash = hash & hash;
  }
  return hash.toString(16);
}
function hashForSchema(schema) {
  const allKeys = /* @__PURE__ */ new Set();
  JSON.stringify(schema, (key2, value) => (allKeys.add(key2), value));
  return hashString(JSON.stringify(schema, Array.from(allKeys).sort()));
}
function hasWidget(schema, widget, registeredWidgets = {}) {
  try {
    getWidget(schema, widget, registeredWidgets);
    return true;
  } catch (e5) {
    const err = e5;
    if (err.message && (err.message.startsWith("No widget") || err.message.startsWith("Unsupported widget"))) {
      return false;
    }
    throw e5;
  }
}
function idGenerator(id2, suffix) {
  const theId = isString$3(id2) ? id2 : id2[ID_KEY];
  return `${theId}__${suffix}`;
}
function descriptionId(id2) {
  return idGenerator(id2, "description");
}
function errorId(id2) {
  return idGenerator(id2, "error");
}
function examplesId(id2) {
  return idGenerator(id2, "examples");
}
function helpId(id2) {
  return idGenerator(id2, "help");
}
function titleId(id2) {
  return idGenerator(id2, "title");
}
function ariaDescribedByIds(id2, includeExamples = false) {
  const examples2 = includeExamples ? ` ${examplesId(id2)}` : "";
  return `${errorId(id2)} ${descriptionId(id2)} ${helpId(id2)}${examples2}`;
}
function optionId(id2, optionIndex) {
  return `${id2}-${optionIndex}`;
}
function labelValue(label, hideLabel, fallback) {
  return hideLabel ? fallback : label;
}
function localToUTC(dateString) {
  return dateString ? new Date(dateString).toJSON() : void 0;
}
function toConstant(schema) {
  if (ENUM_KEY in schema && Array.isArray(schema.enum) && schema.enum.length === 1) {
    return schema.enum[0];
  }
  if (CONST_KEY in schema) {
    return schema.const;
  }
  throw new Error("schema cannot be inferred as a constant");
}
function optionsList(schema) {
  const schemaWithEnumNames = schema;
  if (schemaWithEnumNames.enumNames && process$1$1.env.NODE_ENV !== "production") {
    console.warn("The enumNames property is deprecated and may be removed in a future major release.");
  }
  if (schema.enum) {
    return schema.enum.map((value, i3) => {
      const label = schemaWithEnumNames.enumNames && schemaWithEnumNames.enumNames[i3] || String(value);
      return { label, value };
    });
  }
  const altSchemas = schema.oneOf || schema.anyOf;
  return altSchemas && altSchemas.map((aSchemaDef) => {
    const aSchema = aSchemaDef;
    const value = toConstant(aSchema);
    const label = aSchema.title || String(value);
    return {
      schema: aSchema,
      label,
      value
    };
  });
}
function orderProperties(properties2, order2) {
  if (!Array.isArray(order2)) {
    return properties2;
  }
  const arrayToHash = (arr) => arr.reduce((prev, curr) => {
    prev[curr] = true;
    return prev;
  }, {});
  const errorPropList = (arr) => arr.length > 1 ? `properties '${arr.join("', '")}'` : `property '${arr[0]}'`;
  const propertyHash = arrayToHash(properties2);
  const orderFiltered = order2.filter((prop) => prop === "*" || propertyHash[prop]);
  const orderHash = arrayToHash(orderFiltered);
  const rest = properties2.filter((prop) => !orderHash[prop]);
  const restIndex = orderFiltered.indexOf("*");
  if (restIndex === -1) {
    if (rest.length) {
      throw new Error(`uiSchema order list does not contain ${errorPropList(rest)}`);
    }
    return orderFiltered;
  }
  if (restIndex !== orderFiltered.lastIndexOf("*")) {
    throw new Error("uiSchema order list contains more than one wildcard item");
  }
  const complete = [...orderFiltered];
  complete.splice(restIndex, 1, ...rest);
  return complete;
}
function pad(num, width) {
  let s4 = String(num);
  while (s4.length < width) {
    s4 = "0" + s4;
  }
  return s4;
}
function parseDateString(dateString, includeTime = true) {
  if (!dateString) {
    return {
      year: -1,
      month: -1,
      day: -1,
      hour: includeTime ? -1 : 0,
      minute: includeTime ? -1 : 0,
      second: includeTime ? -1 : 0
    };
  }
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    throw new Error("Unable to parse date " + dateString);
  }
  return {
    year: date.getUTCFullYear(),
    month: date.getUTCMonth() + 1,
    day: date.getUTCDate(),
    hour: includeTime ? date.getUTCHours() : 0,
    minute: includeTime ? date.getUTCMinutes() : 0,
    second: includeTime ? date.getUTCSeconds() : 0
  };
}
function schemaRequiresTrueValue(schema) {
  if (schema.const) {
    return true;
  }
  if (schema.enum && schema.enum.length === 1 && schema.enum[0] === true) {
    return true;
  }
  if (schema.anyOf && schema.anyOf.length === 1) {
    return schemaRequiresTrueValue(schema.anyOf[0]);
  }
  if (schema.oneOf && schema.oneOf.length === 1) {
    return schemaRequiresTrueValue(schema.oneOf[0]);
  }
  if (schema.allOf) {
    const schemaSome = (subSchema) => schemaRequiresTrueValue(subSchema);
    return schema.allOf.some(schemaSome);
  }
  return false;
}
function shouldRender(component, nextProps, nextState) {
  const { props: props2, state } = component;
  return !deepEquals(props2, nextProps) || !deepEquals(state, nextState);
}
function toDateString(dateObject, time2 = true) {
  const { year, month, day, hour = 0, minute = 0, second = 0 } = dateObject;
  const utcTime = Date.UTC(year, month - 1, day, hour, minute, second);
  const datetime = new Date(utcTime).toJSON();
  return time2 ? datetime : datetime.slice(0, 10);
}
function toErrorList(errorSchema, fieldPath = []) {
  if (!errorSchema) {
    return [];
  }
  let errorList = [];
  if (ERRORS_KEY in errorSchema) {
    errorList = errorList.concat(errorSchema[ERRORS_KEY].map((message2) => {
      const property2 = `.${fieldPath.join(".")}`;
      return {
        property: property2,
        message: message2,
        stack: `${property2} ${message2}`
      };
    }));
  }
  return Object.keys(errorSchema).reduce((acc, key2) => {
    if (key2 !== ERRORS_KEY) {
      const childSchema = errorSchema[key2];
      if (isPlainObject$7(childSchema)) {
        acc = acc.concat(toErrorList(childSchema, [...fieldPath, key2]));
      }
    }
    return acc;
  }, errorList);
}
var arrayMap = _arrayMap, copyArray = _copyArray, isArray$2 = isArray_1, isSymbol = isSymbol_1, stringToPath$1 = _stringToPath, toKey = _toKey, toString$4 = toString_1;
function toPath(value) {
  if (isArray$2(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath$1(toString$4(value)));
}
var toPath_1 = toPath;
const _toPath = /* @__PURE__ */ getDefaultExportFromCjs$1(toPath_1);
function toErrorSchema(errors2) {
  const builder = new ErrorSchemaBuilder();
  if (errors2.length) {
    errors2.forEach((error2) => {
      const { property: property2, message: message2 } = error2;
      const path3 = property2 === "." ? [] : _toPath(property2);
      if (path3.length > 0 && path3[0] === "") {
        path3.splice(0, 1);
      }
      if (message2) {
        builder.addErrors(message2, path3);
      }
    });
  }
  return builder.ErrorSchema;
}
function unwrapErrorHandler(errorHandler) {
  return Object.keys(errorHandler).reduce((acc, key2) => {
    if (key2 === "addError") {
      return acc;
    } else {
      const childSchema = errorHandler[key2];
      if (isPlainObject$7(childSchema)) {
        return {
          ...acc,
          [key2]: unwrapErrorHandler(childSchema)
        };
      }
      return { ...acc, [key2]: childSchema };
    }
  }, {});
}
function utcToLocal(jsonDate) {
  if (!jsonDate) {
    return "";
  }
  const date = new Date(jsonDate);
  const yyyy = pad(date.getFullYear(), 4);
  const MM = pad(date.getMonth() + 1, 2);
  const dd = pad(date.getDate(), 2);
  const hh = pad(date.getHours(), 2);
  const mm = pad(date.getMinutes(), 2);
  const ss = pad(date.getSeconds(), 2);
  const SSS = pad(date.getMilliseconds(), 3);
  return `${yyyy}-${MM}-${dd}T${hh}:${mm}:${ss}.${SSS}`;
}
function validationDataMerge(validationData, additionalErrorSchema) {
  if (!additionalErrorSchema) {
    return validationData;
  }
  const { errors: oldErrors, errorSchema: oldErrorSchema } = validationData;
  let errors2 = toErrorList(additionalErrorSchema);
  let errorSchema = additionalErrorSchema;
  if (!_isEmpty(oldErrorSchema)) {
    errorSchema = mergeObjects(oldErrorSchema, additionalErrorSchema, true);
    errors2 = [...oldErrors].concat(errors2);
  }
  return { errorSchema, errors: errors2 };
}
function withIdRefPrefixObject(node3) {
  for (const key2 in node3) {
    const realObj = node3;
    const value = realObj[key2];
    if (key2 === REF_KEY && typeof value === "string" && value.startsWith("#")) {
      realObj[key2] = ROOT_SCHEMA_PREFIX + value;
    } else {
      realObj[key2] = withIdRefPrefix(value);
    }
  }
  return node3;
}
function withIdRefPrefixArray(node3) {
  for (let i3 = 0; i3 < node3.length; i3++) {
    node3[i3] = withIdRefPrefix(node3[i3]);
  }
  return node3;
}
function withIdRefPrefix(schemaNode) {
  if (Array.isArray(schemaNode)) {
    return withIdRefPrefixArray([...schemaNode]);
  }
  if (isObject$j(schemaNode)) {
    return withIdRefPrefixObject({ ...schemaNode });
  }
  return schemaNode;
}
var TranslatableString;
(function(TranslatableString2) {
  TranslatableString2["ArrayItemTitle"] = "Item";
  TranslatableString2["MissingItems"] = "Missing items definition";
  TranslatableString2["YesLabel"] = "Yes";
  TranslatableString2["NoLabel"] = "No";
  TranslatableString2["CloseLabel"] = "Close";
  TranslatableString2["ErrorsLabel"] = "Errors";
  TranslatableString2["NewStringDefault"] = "New Value";
  TranslatableString2["AddButton"] = "Add";
  TranslatableString2["AddItemButton"] = "Add Item";
  TranslatableString2["CopyButton"] = "Copy";
  TranslatableString2["MoveDownButton"] = "Move down";
  TranslatableString2["MoveUpButton"] = "Move up";
  TranslatableString2["RemoveButton"] = "Remove";
  TranslatableString2["NowLabel"] = "Now";
  TranslatableString2["ClearLabel"] = "Clear";
  TranslatableString2["AriaDateLabel"] = "Select a date";
  TranslatableString2["PreviewLabel"] = "Preview";
  TranslatableString2["DecrementAriaLabel"] = "Decrease value by 1";
  TranslatableString2["IncrementAriaLabel"] = "Increase value by 1";
  TranslatableString2["UnknownFieldType"] = "Unknown field type %1";
  TranslatableString2["OptionPrefix"] = "Option %1";
  TranslatableString2["TitleOptionPrefix"] = "%1 option %2";
  TranslatableString2["KeyLabel"] = "%1 Key";
  TranslatableString2["InvalidObjectField"] = 'Invalid "%1" object field configuration: <em>%2</em>.';
  TranslatableString2["UnsupportedField"] = "Unsupported field schema.";
  TranslatableString2["UnsupportedFieldWithId"] = "Unsupported field schema for field <code>%1</code>.";
  TranslatableString2["UnsupportedFieldWithReason"] = "Unsupported field schema: <em>%1</em>.";
  TranslatableString2["UnsupportedFieldWithIdAndReason"] = "Unsupported field schema for field <code>%1</code>: <em>%2</em>.";
  TranslatableString2["FilesInfo"] = "**%1** (%2, %3 bytes)";
})(TranslatableString || (TranslatableString = {}));
var baseGet = _baseGet, baseSet = _baseSet, castPath = _castPath;
function basePickBy$1(object, paths, predicate) {
  var index2 = -1, length = paths.length, result2 = {};
  while (++index2 < length) {
    var path3 = paths[index2], value = baseGet(object, path3);
    if (predicate(value, path3)) {
      baseSet(result2, castPath(path3, object), value);
    }
  }
  return result2;
}
var _basePickBy = basePickBy$1;
var basePickBy = _basePickBy, hasIn = hasIn_1;
function basePick$1(object, paths) {
  return basePickBy(object, paths, function(value, path3) {
    return hasIn(object, path3);
  });
}
var _basePick = basePick$1;
var basePick = _basePick, flatRest = _flatRest;
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});
var pick_1 = pick;
const _pick = /* @__PURE__ */ getDefaultExportFromCjs$1(pick_1);
let nanoid = (size2 = 21) => crypto.getRandomValues(new Uint8Array(size2)).reduce((id2, byte) => {
  byte &= 63;
  if (byte < 36) {
    id2 += byte.toString(36);
  } else if (byte < 62) {
    id2 += (byte - 26).toString(36).toUpperCase();
  } else if (byte > 62) {
    id2 += "-";
  } else {
    id2 += "_";
  }
  return id2;
}, "");
function generateRowId() {
  return nanoid();
}
function generateKeyedFormData(formData) {
  return !Array.isArray(formData) ? [] : formData.map((item) => {
    return {
      key: generateRowId(),
      item
    };
  });
}
function keyedToPlainFormData(keyedFormData) {
  if (Array.isArray(keyedFormData)) {
    return keyedFormData.map((keyedItem) => keyedItem.item);
  }
  return [];
}
let ArrayField$2 = class ArrayField extends Component {
  /** Constructs an `ArrayField` from the `props`, generating the initial keyed data from the `formData`
   *
   * @param props - The `FieldProps` for this template
   */
  constructor(props2) {
    super(props2);
    this._getNewFormDataRow = () => {
      const { schema, registry } = this.props;
      const { schemaUtils } = registry;
      let itemSchema = schema.items;
      if (isFixedItems(schema) && allowAdditionalItems(schema)) {
        itemSchema = schema.additionalItems;
      }
      return schemaUtils.getDefaultFormState(itemSchema);
    };
    this.onAddClick = (event) => {
      this._handleAddClick(event);
    };
    this.onAddIndexClick = (index2) => {
      return (event) => {
        this._handleAddClick(event, index2);
      };
    };
    this.onCopyIndexClick = (index2) => {
      return (event) => {
        if (event) {
          event.preventDefault();
        }
        const { onChange, errorSchema } = this.props;
        const { keyedFormData: keyedFormData2 } = this.state;
        let newErrorSchema;
        if (errorSchema) {
          newErrorSchema = {};
          for (const idx in errorSchema) {
            const i3 = parseInt(idx);
            if (i3 <= index2) {
              set$3(newErrorSchema, [i3], errorSchema[idx]);
            } else if (i3 > index2) {
              set$3(newErrorSchema, [i3 + 1], errorSchema[idx]);
            }
          }
        }
        const newKeyedFormDataRow = {
          key: generateRowId(),
          item: cloneDeep$2(keyedFormData2[index2].item)
        };
        const newKeyedFormData = [...keyedFormData2];
        if (index2 !== void 0) {
          newKeyedFormData.splice(index2 + 1, 0, newKeyedFormDataRow);
        } else {
          newKeyedFormData.push(newKeyedFormDataRow);
        }
        this.setState({
          keyedFormData: newKeyedFormData,
          updatedKeyedFormData: true
        }, () => onChange(keyedToPlainFormData(newKeyedFormData), newErrorSchema));
      };
    };
    this.onDropIndexClick = (index2) => {
      return (event) => {
        if (event) {
          event.preventDefault();
        }
        const { onChange, errorSchema } = this.props;
        const { keyedFormData: keyedFormData2 } = this.state;
        let newErrorSchema;
        if (errorSchema) {
          newErrorSchema = {};
          for (const idx in errorSchema) {
            const i3 = parseInt(idx);
            if (i3 < index2) {
              set$3(newErrorSchema, [i3], errorSchema[idx]);
            } else if (i3 > index2) {
              set$3(newErrorSchema, [i3 - 1], errorSchema[idx]);
            }
          }
        }
        const newKeyedFormData = keyedFormData2.filter((_2, i3) => i3 !== index2);
        this.setState({
          keyedFormData: newKeyedFormData,
          updatedKeyedFormData: true
        }, () => onChange(keyedToPlainFormData(newKeyedFormData), newErrorSchema));
      };
    };
    this.onReorderClick = (index2, newIndex) => {
      return (event) => {
        if (event) {
          event.preventDefault();
          event.currentTarget.blur();
        }
        const { onChange, errorSchema } = this.props;
        let newErrorSchema;
        if (errorSchema) {
          newErrorSchema = {};
          for (const idx in errorSchema) {
            const i3 = parseInt(idx);
            if (i3 == index2) {
              set$3(newErrorSchema, [newIndex], errorSchema[index2]);
            } else if (i3 == newIndex) {
              set$3(newErrorSchema, [index2], errorSchema[newIndex]);
            } else {
              set$3(newErrorSchema, [idx], errorSchema[i3]);
            }
          }
        }
        const { keyedFormData: keyedFormData2 } = this.state;
        function reOrderArray() {
          const _newKeyedFormData = keyedFormData2.slice();
          _newKeyedFormData.splice(index2, 1);
          _newKeyedFormData.splice(newIndex, 0, keyedFormData2[index2]);
          return _newKeyedFormData;
        }
        const newKeyedFormData = reOrderArray();
        this.setState({
          keyedFormData: newKeyedFormData
        }, () => onChange(keyedToPlainFormData(newKeyedFormData), newErrorSchema));
      };
    };
    this.onChangeForIndex = (index2) => {
      return (value, newErrorSchema, id2) => {
        const { formData: formData2, onChange, errorSchema } = this.props;
        const arrayData = Array.isArray(formData2) ? formData2 : [];
        const newFormData = arrayData.map((item, i3) => {
          const jsonValue = typeof value === "undefined" ? null : value;
          return index2 === i3 ? jsonValue : item;
        });
        onChange(newFormData, errorSchema && errorSchema && {
          ...errorSchema,
          [index2]: newErrorSchema
        }, id2);
      };
    };
    this.onSelectChange = (value) => {
      const { onChange, idSchema } = this.props;
      onChange(value, void 0, idSchema && idSchema.$id);
    };
    const { formData = [] } = props2;
    const keyedFormData = generateKeyedFormData(formData);
    this.state = {
      keyedFormData,
      updatedKeyedFormData: false
    };
  }
  /** React lifecycle method that is called when the props are about to change allowing the state to be updated. It
   * regenerates the keyed form data and returns it
   *
   * @param nextProps - The next set of props data
   * @param prevState - The previous set of state data
   */
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.updatedKeyedFormData) {
      return {
        updatedKeyedFormData: false
      };
    }
    const nextFormData = Array.isArray(nextProps.formData) ? nextProps.formData : [];
    const previousKeyedFormData = prevState.keyedFormData || [];
    const newKeyedFormData = nextFormData.length === previousKeyedFormData.length ? previousKeyedFormData.map((previousKeyedFormDatum, index2) => {
      return {
        key: previousKeyedFormDatum.key,
        item: nextFormData[index2]
      };
    }) : generateKeyedFormData(nextFormData);
    return {
      keyedFormData: newKeyedFormData
    };
  }
  /** Returns the appropriate title for an item by getting first the title from the schema.items, then falling back to
   * the description from the schema.items, and finally the string "Item"
   */
  get itemTitle() {
    const { schema, registry } = this.props;
    const { translateString } = registry;
    return get$6(schema, [ITEMS_KEY, "title"], get$6(schema, [ITEMS_KEY, "description"], translateString(TranslatableString.ArrayItemTitle)));
  }
  /** Determines whether the item described in the schema is always required, which is determined by whether any item
   * may be null.
   *
   * @param itemSchema - The schema for the item
   * @return - True if the item schema type does not contain the "null" type
   */
  isItemRequired(itemSchema) {
    if (Array.isArray(itemSchema.type)) {
      return !itemSchema.type.includes("null");
    }
    return itemSchema.type !== "null";
  }
  /** Determines whether more items can be added to the array. If the uiSchema indicates the array doesn't allow adding
   * then false is returned. Otherwise, if the schema indicates that there are a maximum number of items and the
   * `formData` matches that value, then false is returned, otherwise true is returned.
   *
   * @param formItems - The list of items in the form
   * @returns - True if the item is addable otherwise false
   */
  canAddItem(formItems) {
    const { schema, uiSchema, registry } = this.props;
    let { addable } = getUiOptions(uiSchema, registry.globalUiOptions);
    if (addable !== false) {
      if (schema.maxItems !== void 0) {
        addable = formItems.length < schema.maxItems;
      } else {
        addable = true;
      }
    }
    return addable;
  }
  /** Callback handler for when the user clicks on the add or add at index buttons. Creates a new row of keyed form data
   * either at the end of the list (when index is not specified) or inserted at the `index` when it is, adding it into
   * the state, and then returning `onChange()` with the plain form data converted from the keyed data
   *
   * @param event - The event for the click
   * @param [index] - The optional index at which to add the new data
   */
  _handleAddClick(event, index2) {
    if (event) {
      event.preventDefault();
    }
    const { onChange, errorSchema } = this.props;
    const { keyedFormData } = this.state;
    let newErrorSchema;
    if (errorSchema) {
      newErrorSchema = {};
      for (const idx in errorSchema) {
        const i3 = parseInt(idx);
        if (index2 === void 0 || i3 < index2) {
          set$3(newErrorSchema, [i3], errorSchema[idx]);
        } else if (i3 >= index2) {
          set$3(newErrorSchema, [i3 + 1], errorSchema[idx]);
        }
      }
    }
    const newKeyedFormDataRow = {
      key: generateRowId(),
      item: this._getNewFormDataRow()
    };
    const newKeyedFormData = [...keyedFormData];
    if (index2 !== void 0) {
      newKeyedFormData.splice(index2, 0, newKeyedFormDataRow);
    } else {
      newKeyedFormData.push(newKeyedFormDataRow);
    }
    this.setState({
      keyedFormData: newKeyedFormData,
      updatedKeyedFormData: true
    }, () => onChange(keyedToPlainFormData(newKeyedFormData), newErrorSchema));
  }
  /** Renders the `ArrayField` depending on the specific needs of the schema and uischema elements
   */
  render() {
    const { schema, uiSchema, idSchema, registry } = this.props;
    const { schemaUtils, translateString } = registry;
    if (!(ITEMS_KEY in schema)) {
      const uiOptions = getUiOptions(uiSchema);
      const UnsupportedFieldTemplate = getTemplate("UnsupportedFieldTemplate", registry, uiOptions);
      return jsx$1(UnsupportedFieldTemplate, { schema, idSchema, reason: translateString(TranslatableString.MissingItems), registry });
    }
    if (schemaUtils.isMultiSelect(schema)) {
      return this.renderMultiSelect();
    }
    if (isCustomWidget(uiSchema)) {
      return this.renderCustomWidget();
    }
    if (isFixedItems(schema)) {
      return this.renderFixedArray();
    }
    if (schemaUtils.isFilesArray(schema, uiSchema)) {
      return this.renderFiles();
    }
    return this.renderNormalArray();
  }
  /** Renders a normal array without any limitations of length
   */
  renderNormalArray() {
    const { schema, uiSchema = {}, errorSchema, idSchema, name: name2, title: title2, disabled = false, readonly = false, autofocus = false, required: required2 = false, registry, onBlur, onFocus, idPrefix, idSeparator = "_", rawErrors } = this.props;
    const { keyedFormData } = this.state;
    const fieldTitle = schema.title || title2 || name2;
    const { schemaUtils, formContext } = registry;
    const uiOptions = getUiOptions(uiSchema);
    const _schemaItems = isObject$j(schema.items) ? schema.items : {};
    const itemsSchema = schemaUtils.retrieveSchema(_schemaItems);
    const formData = keyedToPlainFormData(this.state.keyedFormData);
    const canAdd = this.canAddItem(formData);
    const arrayProps = {
      canAdd,
      items: keyedFormData.map((keyedItem, index2) => {
        const { key: key2, item } = keyedItem;
        const itemCast = item;
        const itemSchema = schemaUtils.retrieveSchema(_schemaItems, itemCast);
        const itemErrorSchema = errorSchema ? errorSchema[index2] : void 0;
        const itemIdPrefix = idSchema.$id + idSeparator + index2;
        const itemIdSchema = schemaUtils.toIdSchema(itemSchema, itemIdPrefix, itemCast, idPrefix, idSeparator);
        return this.renderArrayFieldItem({
          key: key2,
          index: index2,
          name: name2 && `${name2}-${index2}`,
          title: fieldTitle ? `${fieldTitle}-${index2 + 1}` : void 0,
          canAdd,
          canMoveUp: index2 > 0,
          canMoveDown: index2 < formData.length - 1,
          itemSchema,
          itemIdSchema,
          itemErrorSchema,
          itemData: itemCast,
          itemUiSchema: uiSchema.items,
          autofocus: autofocus && index2 === 0,
          onBlur,
          onFocus,
          rawErrors,
          totalItems: keyedFormData.length
        });
      }),
      className: `field field-array field-array-of-${itemsSchema.type}`,
      disabled,
      idSchema,
      uiSchema,
      onAddClick: this.onAddClick,
      readonly,
      required: required2,
      schema,
      title: fieldTitle,
      formContext,
      formData,
      rawErrors,
      registry
    };
    const Template = getTemplate("ArrayFieldTemplate", registry, uiOptions);
    return jsx$1(Template, { ...arrayProps });
  }
  /** Renders an array using the custom widget provided by the user in the `uiSchema`
   */
  renderCustomWidget() {
    var _a2;
    const { schema, idSchema, uiSchema, disabled = false, readonly = false, autofocus = false, required: required2 = false, hideError, placeholder, onBlur, onFocus, formData: items2 = [], registry, rawErrors, name: name2 } = this.props;
    const { widgets: widgets2, formContext, globalUiOptions, schemaUtils } = registry;
    const { widget, title: uiTitle, ...options } = getUiOptions(uiSchema, globalUiOptions);
    const Widget = getWidget(schema, widget, widgets2);
    const label = (_a2 = uiTitle !== null && uiTitle !== void 0 ? uiTitle : schema.title) !== null && _a2 !== void 0 ? _a2 : name2;
    const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
    return jsx$1(Widget, { id: idSchema.$id, name: name2, multiple: true, onChange: this.onSelectChange, onBlur, onFocus, options, schema, uiSchema, registry, value: items2, disabled, readonly, hideError, required: required2, label, hideLabel: !displayLabel, placeholder, formContext, autofocus, rawErrors });
  }
  /** Renders an array as a set of checkboxes
   */
  renderMultiSelect() {
    var _a2;
    const { schema, idSchema, uiSchema, formData: items2 = [], disabled = false, readonly = false, autofocus = false, required: required2 = false, placeholder, onBlur, onFocus, registry, rawErrors, name: name2 } = this.props;
    const { widgets: widgets2, schemaUtils, formContext, globalUiOptions } = registry;
    const itemsSchema = schemaUtils.retrieveSchema(schema.items, items2);
    const enumOptions = optionsList(itemsSchema);
    const { widget = "select", title: uiTitle, ...options } = getUiOptions(uiSchema, globalUiOptions);
    const Widget = getWidget(schema, widget, widgets2);
    const label = (_a2 = uiTitle !== null && uiTitle !== void 0 ? uiTitle : schema.title) !== null && _a2 !== void 0 ? _a2 : name2;
    const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
    return jsx$1(Widget, { id: idSchema.$id, name: name2, multiple: true, onChange: this.onSelectChange, onBlur, onFocus, options: { ...options, enumOptions }, schema, uiSchema, registry, value: items2, disabled, readonly, required: required2, label, hideLabel: !displayLabel, placeholder, formContext, autofocus, rawErrors });
  }
  /** Renders an array of files using the `FileWidget`
   */
  renderFiles() {
    var _a2;
    const { schema, uiSchema, idSchema, name: name2, disabled = false, readonly = false, autofocus = false, required: required2 = false, onBlur, onFocus, registry, formData: items2 = [], rawErrors } = this.props;
    const { widgets: widgets2, formContext, globalUiOptions, schemaUtils } = registry;
    const { widget = "files", title: uiTitle, ...options } = getUiOptions(uiSchema, globalUiOptions);
    const Widget = getWidget(schema, widget, widgets2);
    const label = (_a2 = uiTitle !== null && uiTitle !== void 0 ? uiTitle : schema.title) !== null && _a2 !== void 0 ? _a2 : name2;
    const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
    return jsx$1(Widget, { options, id: idSchema.$id, name: name2, multiple: true, onChange: this.onSelectChange, onBlur, onFocus, schema, uiSchema, value: items2, disabled, readonly, required: required2, registry, formContext, autofocus, rawErrors, label, hideLabel: !displayLabel });
  }
  /** Renders an array that has a maximum limit of items
   */
  renderFixedArray() {
    const { schema, uiSchema = {}, formData = [], errorSchema, idPrefix, idSeparator = "_", idSchema, name: name2, title: title2, disabled = false, readonly = false, autofocus = false, required: required2 = false, registry, onBlur, onFocus, rawErrors } = this.props;
    const { keyedFormData } = this.state;
    let { formData: items2 = [] } = this.props;
    const fieldTitle = schema.title || title2 || name2;
    const uiOptions = getUiOptions(uiSchema);
    const { schemaUtils, formContext } = registry;
    const _schemaItems = isObject$j(schema.items) ? schema.items : [];
    const itemSchemas = _schemaItems.map((item, index2) => schemaUtils.retrieveSchema(item, formData[index2]));
    const additionalSchema = isObject$j(schema.additionalItems) ? schemaUtils.retrieveSchema(schema.additionalItems, formData) : null;
    if (!items2 || items2.length < itemSchemas.length) {
      items2 = items2 || [];
      items2 = items2.concat(new Array(itemSchemas.length - items2.length));
    }
    const canAdd = this.canAddItem(items2) && !!additionalSchema;
    const arrayProps = {
      canAdd,
      className: "field field-array field-array-fixed-items",
      disabled,
      idSchema,
      formData,
      items: keyedFormData.map((keyedItem, index2) => {
        const { key: key2, item } = keyedItem;
        const itemCast = item;
        const additional = index2 >= itemSchemas.length;
        const itemSchema = (additional && isObject$j(schema.additionalItems) ? schemaUtils.retrieveSchema(schema.additionalItems, itemCast) : itemSchemas[index2]) || {};
        const itemIdPrefix = idSchema.$id + idSeparator + index2;
        const itemIdSchema = schemaUtils.toIdSchema(itemSchema, itemIdPrefix, itemCast, idPrefix, idSeparator);
        const itemUiSchema = additional ? uiSchema.additionalItems || {} : Array.isArray(uiSchema.items) ? uiSchema.items[index2] : uiSchema.items || {};
        const itemErrorSchema = errorSchema ? errorSchema[index2] : void 0;
        return this.renderArrayFieldItem({
          key: key2,
          index: index2,
          name: name2 && `${name2}-${index2}`,
          title: fieldTitle ? `${fieldTitle}-${index2 + 1}` : void 0,
          canAdd,
          canRemove: additional,
          canMoveUp: index2 >= itemSchemas.length + 1,
          canMoveDown: additional && index2 < items2.length - 1,
          itemSchema,
          itemData: itemCast,
          itemUiSchema,
          itemIdSchema,
          itemErrorSchema,
          autofocus: autofocus && index2 === 0,
          onBlur,
          onFocus,
          rawErrors,
          totalItems: keyedFormData.length
        });
      }),
      onAddClick: this.onAddClick,
      readonly,
      required: required2,
      registry,
      schema,
      uiSchema,
      title: fieldTitle,
      formContext,
      errorSchema,
      rawErrors
    };
    const Template = getTemplate("ArrayFieldTemplate", registry, uiOptions);
    return jsx$1(Template, { ...arrayProps });
  }
  /** Renders the individual array item using a `SchemaField` along with the additional properties required to be send
   * back to the `ArrayFieldItemTemplate`.
   *
   * @param props - The props for the individual array item to be rendered
   */
  renderArrayFieldItem(props2) {
    const { key: key2, index: index2, name: name2, canAdd, canRemove = true, canMoveUp, canMoveDown, itemSchema, itemData, itemUiSchema, itemIdSchema, itemErrorSchema, autofocus, onBlur, onFocus, rawErrors, totalItems, title: title2 } = props2;
    const { disabled, hideError, idPrefix, idSeparator, readonly, uiSchema, registry, formContext } = this.props;
    const { fields: { ArraySchemaField, SchemaField: SchemaField2 }, globalUiOptions } = registry;
    const ItemSchemaField = ArraySchemaField || SchemaField2;
    const { orderable = true, removable = true, copyable = false } = getUiOptions(uiSchema, globalUiOptions);
    const has2 = {
      moveUp: orderable && canMoveUp,
      moveDown: orderable && canMoveDown,
      copy: copyable && canAdd,
      remove: removable && canRemove,
      toolbar: false
    };
    has2.toolbar = Object.keys(has2).some((key3) => has2[key3]);
    return {
      children: jsx$1(ItemSchemaField, { name: name2, title: title2, index: index2, schema: itemSchema, uiSchema: itemUiSchema, formData: itemData, formContext, errorSchema: itemErrorSchema, idPrefix, idSeparator, idSchema: itemIdSchema, required: this.isItemRequired(itemSchema), onChange: this.onChangeForIndex(index2), onBlur, onFocus, registry, disabled, readonly, hideError, autofocus, rawErrors }),
      className: "array-item",
      disabled,
      canAdd,
      hasCopy: has2.copy,
      hasToolbar: has2.toolbar,
      hasMoveUp: has2.moveUp,
      hasMoveDown: has2.moveDown,
      hasRemove: has2.remove,
      index: index2,
      totalItems,
      key: key2,
      onAddIndexClick: this.onAddIndexClick,
      onCopyIndexClick: this.onCopyIndexClick,
      onDropIndexClick: this.onDropIndexClick,
      onReorderClick: this.onReorderClick,
      readonly,
      registry,
      schema: itemSchema,
      uiSchema: itemUiSchema
    };
  }
};
function BooleanField(props2) {
  var _a2, _b2, _c2;
  const { schema, name: name2, uiSchema, idSchema, formData, registry, required: required2, disabled, readonly, hideError, autofocus, title: title2, onChange, onFocus, onBlur, rawErrors } = props2;
  const { title: schemaTitle } = schema;
  const { widgets: widgets2, formContext, translateString, globalUiOptions } = registry;
  const {
    widget = "checkbox",
    title: uiTitle,
    // Unlike the other fields, don't use `getDisplayLabel()` since it always returns false for the boolean type
    label: displayLabel = true,
    ...options
  } = getUiOptions(uiSchema, globalUiOptions);
  const Widget = getWidget(schema, widget, widgets2);
  const yes = translateString(TranslatableString.YesLabel);
  const no = translateString(TranslatableString.NoLabel);
  let enumOptions;
  const label = (_b2 = (_a2 = uiTitle !== null && uiTitle !== void 0 ? uiTitle : schemaTitle) !== null && _a2 !== void 0 ? _a2 : title2) !== null && _b2 !== void 0 ? _b2 : name2;
  if (Array.isArray(schema.oneOf)) {
    enumOptions = optionsList({
      oneOf: schema.oneOf.map((option2) => {
        if (isObject$j(option2)) {
          return {
            ...option2,
            title: option2.title || (option2.const === true ? yes : no)
          };
        }
        return void 0;
      }).filter((o2) => o2)
      // cast away the error that typescript can't grok is fixed
    });
  } else {
    const schemaWithEnumNames = schema;
    const enums = (_c2 = schema.enum) !== null && _c2 !== void 0 ? _c2 : [true, false];
    if (!schemaWithEnumNames.enumNames && enums.length === 2 && enums.every((v2) => typeof v2 === "boolean")) {
      enumOptions = [
        {
          value: enums[0],
          label: enums[0] ? yes : no
        },
        {
          value: enums[1],
          label: enums[1] ? yes : no
        }
      ];
    } else {
      enumOptions = optionsList({
        enum: enums,
        // NOTE: enumNames is deprecated, but still supported for now.
        enumNames: schemaWithEnumNames.enumNames
      });
    }
  }
  return jsx$1(Widget, { options: { ...options, enumOptions }, schema, uiSchema, id: idSchema.$id, name: name2, onChange, onFocus, onBlur, label, hideLabel: !displayLabel, value: formData, required: required2, disabled, readonly, hideError, registry, formContext, autofocus, rawErrors });
}
class AnyOfField extends Component {
  /** Constructs an `AnyOfField` with the given `props` to initialize the initially selected option in state
   *
   * @param props - The `FieldProps` for this template
   */
  constructor(props2) {
    super(props2);
    this.onOptionChange = (option2) => {
      const { selectedOption, retrievedOptions: retrievedOptions2 } = this.state;
      const { formData: formData2, onChange, registry } = this.props;
      const { schemaUtils: schemaUtils2 } = registry;
      const intOption = option2 !== void 0 ? parseInt(option2, 10) : -1;
      if (intOption === selectedOption) {
        return;
      }
      const newOption = intOption >= 0 ? retrievedOptions2[intOption] : void 0;
      const oldOption = selectedOption >= 0 ? retrievedOptions2[selectedOption] : void 0;
      let newFormData = schemaUtils2.sanitizeDataForNewSchema(newOption, oldOption, formData2);
      if (newFormData && newOption) {
        newFormData = schemaUtils2.getDefaultFormState(newOption, newFormData, "excludeObjectChildren");
      }
      onChange(newFormData, void 0, this.getFieldId());
      this.setState({ selectedOption: intOption });
    };
    const { formData, options, registry: { schemaUtils } } = this.props;
    const retrievedOptions = options.map((opt) => schemaUtils.retrieveSchema(opt, formData));
    this.state = {
      retrievedOptions,
      selectedOption: this.getMatchingOption(0, formData, retrievedOptions)
    };
  }
  /** React lifecycle method that is called when the props and/or state for this component is updated. It recomputes the
   * currently selected option based on the overall `formData`
   *
   * @param prevProps - The previous `FieldProps` for this template
   * @param prevState - The previous `AnyOfFieldState` for this template
   */
  componentDidUpdate(prevProps, prevState) {
    const { formData, options, idSchema } = this.props;
    const { selectedOption } = this.state;
    let newState = this.state;
    if (!deepEquals(prevProps.options, options)) {
      const { registry: { schemaUtils } } = this.props;
      const retrievedOptions = options.map((opt) => schemaUtils.retrieveSchema(opt, formData));
      newState = { selectedOption, retrievedOptions };
    }
    if (!deepEquals(formData, prevProps.formData) && idSchema.$id === prevProps.idSchema.$id) {
      const { retrievedOptions } = newState;
      const matchingOption = this.getMatchingOption(selectedOption, formData, retrievedOptions);
      if (prevState && matchingOption !== selectedOption) {
        newState = { selectedOption: matchingOption, retrievedOptions };
      }
    }
    if (newState !== this.state) {
      this.setState(newState);
    }
  }
  /** Determines the best matching option for the given `formData` and `options`.
   *
   * @param formData - The new formData
   * @param options - The list of options to choose from
   * @return - The index of the `option` that best matches the `formData`
   */
  getMatchingOption(selectedOption, formData, options) {
    const { schema, registry: { schemaUtils } } = this.props;
    const discriminator2 = getDiscriminatorFieldFromSchema(schema);
    const option2 = schemaUtils.getClosestMatchingOption(formData, options, selectedOption, discriminator2);
    return option2;
  }
  getFieldId() {
    const { idSchema, schema } = this.props;
    return `${idSchema.$id}${schema.oneOf ? "__oneof_select" : "__anyof_select"}`;
  }
  /** Renders the `AnyOfField` selector along with a `SchemaField` for the value of the `formData`
   */
  render() {
    const { name: name2, disabled = false, errorSchema = {}, formContext, onBlur, onFocus, registry, schema, uiSchema } = this.props;
    const { widgets: widgets2, fields: fields2, translateString, globalUiOptions, schemaUtils } = registry;
    const { SchemaField: _SchemaField } = fields2;
    const { selectedOption, retrievedOptions } = this.state;
    const { widget = "select", placeholder, autofocus, autocomplete, title: title2 = schema.title, ...uiOptions } = getUiOptions(uiSchema, globalUiOptions);
    const Widget = getWidget({ type: "number" }, widget, widgets2);
    const rawErrors = get$6(errorSchema, ERRORS_KEY, []);
    const fieldErrorSchema = omit$1(errorSchema, [ERRORS_KEY]);
    const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
    const option2 = selectedOption >= 0 ? retrievedOptions[selectedOption] || null : null;
    let optionSchema;
    if (option2) {
      const { required: required2 } = schema;
      optionSchema = required2 ? mergeSchemas({ required: required2 }, option2) : option2;
    }
    let optionsUiSchema = [];
    if (ONE_OF_KEY in schema && uiSchema && ONE_OF_KEY in uiSchema) {
      if (Array.isArray(uiSchema[ONE_OF_KEY])) {
        optionsUiSchema = uiSchema[ONE_OF_KEY];
      } else {
        console.warn(`uiSchema.oneOf is not an array for "${title2 || name2}"`);
      }
    } else if (ANY_OF_KEY in schema && uiSchema && ANY_OF_KEY in uiSchema) {
      if (Array.isArray(uiSchema[ANY_OF_KEY])) {
        optionsUiSchema = uiSchema[ANY_OF_KEY];
      } else {
        console.warn(`uiSchema.anyOf is not an array for "${title2 || name2}"`);
      }
    }
    let optionUiSchema = uiSchema;
    if (selectedOption >= 0 && optionsUiSchema.length > selectedOption) {
      optionUiSchema = optionsUiSchema[selectedOption];
    }
    const translateEnum = title2 ? TranslatableString.TitleOptionPrefix : TranslatableString.OptionPrefix;
    const translateParams = title2 ? [title2] : [];
    const enumOptions = retrievedOptions.map((opt, index2) => {
      const { title: uiTitle = opt.title } = getUiOptions(optionsUiSchema[index2]);
      return {
        label: uiTitle || translateString(translateEnum, translateParams.concat(String(index2 + 1))),
        value: index2
      };
    });
    return jsxs("div", { className: "panel panel-default panel-body", children: [jsx$1("div", { className: "form-group", children: jsx$1(Widget, { id: this.getFieldId(), name: `${name2}${schema.oneOf ? "__oneof_select" : "__anyof_select"}`, schema: { type: "number", default: 0 }, onChange: this.onOptionChange, onBlur, onFocus, disabled: disabled || _isEmpty(enumOptions), multiple: false, rawErrors, errorSchema: fieldErrorSchema, value: selectedOption >= 0 ? selectedOption : void 0, options: { enumOptions, ...uiOptions }, registry, formContext, placeholder, autocomplete, autofocus, label: title2 !== null && title2 !== void 0 ? title2 : name2, hideLabel: !displayLabel }) }), optionSchema && jsx$1(_SchemaField, { ...this.props, schema: optionSchema, uiSchema: optionUiSchema })] });
  }
}
const trailingCharMatcherWithPrefix = /\.([0-9]*0)*$/;
const trailingCharMatcher = /[0.]0*$/;
function NumberField(props2) {
  const { registry, onChange, formData, value: initialValue } = props2;
  const [lastValue, setLastValue] = useState(initialValue);
  const { StringField: StringField2 } = registry.fields;
  let value = formData;
  const handleChange = useCallback((value2) => {
    setLastValue(value2);
    if (`${value2}`.charAt(0) === ".") {
      value2 = `0${value2}`;
    }
    const processed = typeof value2 === "string" && value2.match(trailingCharMatcherWithPrefix) ? asNumber$1(value2.replace(trailingCharMatcher, "")) : asNumber$1(value2);
    onChange(processed);
  }, [onChange]);
  if (typeof lastValue === "string" && typeof value === "number") {
    const re2 = new RegExp(`^(${String(value).replace(".", "\\.")})?\\.?0*$`);
    if (lastValue.match(re2)) {
      value = lastValue;
    }
  }
  return jsx$1(StringField2, { ...props2, formData: value, onChange: handleChange });
}
function n() {
  return n = Object.assign ? Object.assign.bind() : function(e5) {
    for (var n2 = 1; n2 < arguments.length; n2++) {
      var t3 = arguments[n2];
      for (var r2 in t3) Object.prototype.hasOwnProperty.call(t3, r2) && (e5[r2] = t3[r2]);
    }
    return e5;
  }, n.apply(this, arguments);
}
const t = ["children", "options"];
var r, i;
!function(e5) {
  e5.blockQuote = "0", e5.breakLine = "1", e5.breakThematic = "2", e5.codeBlock = "3", e5.codeFenced = "4", e5.codeInline = "5", e5.footnote = "6", e5.footnoteReference = "7", e5.gfmTask = "8", e5.heading = "9", e5.headingSetext = "10", e5.htmlBlock = "11", e5.htmlComment = "12", e5.htmlSelfClosing = "13", e5.image = "14", e5.link = "15", e5.linkAngleBraceStyleDetector = "16", e5.linkBareUrlDetector = "17", e5.linkMailtoDetector = "18", e5.newlineCoalescer = "19", e5.orderedList = "20", e5.paragraph = "21", e5.ref = "22", e5.refImage = "23", e5.refLink = "24", e5.table = "25", e5.tableSeparator = "26", e5.text = "27", e5.textBolded = "28", e5.textEmphasized = "29", e5.textEscaped = "30", e5.textMarked = "31", e5.textStrikethroughed = "32", e5.unorderedList = "33";
}(r || (r = {})), function(e5) {
  e5[e5.MAX = 0] = "MAX", e5[e5.HIGH = 1] = "HIGH", e5[e5.MED = 2] = "MED", e5[e5.LOW = 3] = "LOW", e5[e5.MIN = 4] = "MIN";
}(i || (i = {}));
const l = ["allowFullScreen", "allowTransparency", "autoComplete", "autoFocus", "autoPlay", "cellPadding", "cellSpacing", "charSet", "className", "classId", "colSpan", "contentEditable", "contextMenu", "crossOrigin", "encType", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "frameBorder", "hrefLang", "inputMode", "keyParams", "keyType", "marginHeight", "marginWidth", "maxLength", "mediaGroup", "minLength", "noValidate", "radioGroup", "readOnly", "rowSpan", "spellCheck", "srcDoc", "srcLang", "srcSet", "tabIndex", "useMap"].reduce((e5, n2) => (e5[n2.toLowerCase()] = n2, e5), { for: "htmlFor" }), o = { amp: "&", apos: "'", gt: ">", lt: "<", nbsp: " ", quot: "“" }, c = ["style", "script"], a = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, s = /mailto:/i, d = /\n{2,}$/, u = /^(\s*>[\s\S]*?)(?=\n{2,})/, p = /^ *> ?/gm, f = /^ {2,}\n/, h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, k = /^(?:\n *)*\n/, x = /\r\n?/g, v = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, b = /^\[\^([^\]]+)]/, $ = /\f/g, E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, w = /^\s*?\[(x|\s)\]/, S = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, C = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, A = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, O = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, L = /^<!--[\s\S]*?(?:-->)/, R = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, z = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, M = /^\{.*\}$/, I = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, U = /^<([^ >]+@[^ >]+)>/, j = /^<([^ >]+:\/[^ >]+)>/, B = /-([a-z])?/gi, N = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, _ = /(\[|\])/g, F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, W = /\t/g, G = /(^ *\||\| *$)/g, Z = /^ *:-+: *$/, q = /^ *:-+ *$/, V = /^ *-+: *$/, X = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", Q = new RegExp(`^([*_])\\1${X}\\1\\1(?!\\1)`), J = new RegExp(`^([*_])${X}\\1(?!\\1|\\w)`), K = new RegExp(`^==${X}==`), Y = new RegExp(`^~~${X}~~`), ee = /^\\([^0-9A-Za-z\s])/, ne$1 = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, te = /^\n+/, re = /^([ \t]*)/, ie$1 = /\\([^\\])/g, le$1 = / *\n+$/, oe$1 = /(?:^|\n)( *)$/, ce$1 = "(?:\\d+\\.)", ae$1 = "(?:[*+-])";
function se$1(e5) {
  return "( *)(" + (1 === e5 ? ce$1 : ae$1) + ") +";
}
const de$1 = se$1(1), ue$1 = se$1(2);
function pe$1(e5) {
  return new RegExp("^" + (1 === e5 ? de$1 : ue$1));
}
const fe$1 = pe$1(1), he$1 = pe$1(2);
function me$1(e5) {
  return new RegExp("^" + (1 === e5 ? de$1 : ue$1) + "[^\\n]*(?:\\n(?!\\1" + (1 === e5 ? ce$1 : ae$1) + " )[^\\n]*)*(\\n|$)", "gm");
}
const ge$1 = me$1(1), ye$1 = me$1(2);
function ke$1(e5) {
  const n2 = 1 === e5 ? ce$1 : ae$1;
  return new RegExp("^( *)(" + n2 + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n2 + " (?!" + n2 + " ))\\n*|\\s*\\n*$)");
}
const xe$1 = ke$1(1), ve$1 = ke$1(2);
function be$1(e5, n2) {
  const t3 = 1 === n2, r2 = t3 ? xe$1 : ve$1, i3 = t3 ? ge$1 : ye$1, l2 = t3 ? fe$1 : he$1;
  return { match(e6, n3, t4) {
    const i4 = oe$1.exec(t4);
    return i4 && (n3.list || !n3.inline && !n3.simple) ? r2.exec(e6 = i4[1] + e6) : null;
  }, order: 1, parse(e6, n3, r3) {
    const o2 = t3 ? +e6[2] : void 0, c3 = e6[0].replace(d, "\n").match(i3);
    let a4 = false;
    return { items: c3.map(function(e7, t4) {
      const i4 = l2.exec(e7)[0].length, o3 = new RegExp("^ {1," + i4 + "}", "gm"), s4 = e7.replace(o3, "").replace(l2, ""), d4 = t4 === c3.length - 1, u3 = -1 !== s4.indexOf("\n\n") || d4 && a4;
      a4 = u3;
      const p2 = r3.inline, f2 = r3.list;
      let h4;
      r3.list = true, u3 ? (r3.inline = false, h4 = s4.replace(le$1, "\n\n")) : (r3.inline = true, h4 = s4.replace(le$1, ""));
      const m4 = n3(h4, r3);
      return r3.inline = p2, r3.list = f2, m4;
    }), ordered: t3, start: o2 };
  }, render: (n3, t4, r3) => e5(n3.ordered ? "ol" : "ul", { key: r3.key, start: "20" === n3.type ? n3.start : void 0 }, n3.items.map(function(n4, i4) {
    return e5("li", { key: i4 }, t4(n4, r3));
  })) };
}
const $e$1 = new RegExp(`^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['"]([\\s\\S]*?)['"])?\\s*\\)`), Ee$1 = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, we$1 = [u, m, g, S, A, C, L, N, ge$1, xe$1, ye$1, ve$1], Se$1 = [...we$1, /^[^\n]+(?:  \n|\n{2,})/, O, z];
function Ce$1(e5) {
  return e5.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function Ae(e5) {
  return V.test(e5) ? "right" : Z.test(e5) ? "center" : q.test(e5) ? "left" : null;
}
function Oe$1(e5, n2, t3, r2) {
  const i3 = t3.inTable;
  t3.inTable = true;
  let l2 = e5.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e6, i4) => ("|" === i4.trim() ? e6.push(r2 ? { type: "26" } : { type: "27", text: i4 }) : "" !== i4 && e6.push.apply(e6, n2(i4, t3)), e6), []);
  t3.inTable = i3;
  let o2 = [[]];
  return l2.forEach(function(e6, n3) {
    "26" === e6.type ? 0 !== n3 && n3 !== l2.length - 1 && o2.push([]) : ("27" !== e6.type || null != l2[n3 + 1] && "26" !== l2[n3 + 1].type || (e6.text = e6.text.trimEnd()), o2[o2.length - 1].push(e6));
  }), o2;
}
function Te$1(e5, n2, t3) {
  t3.inline = true;
  const r2 = e5[2] ? e5[2].replace(G, "").split("|").map(Ae) : [], i3 = e5[3] ? function(e6, n3, t4) {
    return e6.trim().split("\n").map(function(e7) {
      return Oe$1(e7, n3, t4, true);
    });
  }(e5[3], n2, t3) : [], l2 = Oe$1(e5[1], n2, t3, !!i3.length);
  return t3.inline = false, i3.length ? { align: r2, cells: i3, header: l2, type: "25" } : { children: l2, type: "21" };
}
function Le$1(e5, n2) {
  return null == e5.align[n2] ? {} : { textAlign: e5.align[n2] };
}
function Re$1(e5) {
  return function(n2, t3) {
    return t3.inline ? e5.exec(n2) : null;
  };
}
function ze$1(e5) {
  return function(n2, t3) {
    return t3.inline || t3.simple ? e5.exec(n2) : null;
  };
}
function Me$1(e5) {
  return function(n2, t3) {
    return t3.inline || t3.simple ? null : e5.exec(n2);
  };
}
function Ie$1(e5) {
  return function(n2) {
    return e5.exec(n2);
  };
}
function Ue$1(e5, n2, t3) {
  if (n2.inline || n2.simple) return null;
  if (t3 && !t3.endsWith("\n")) return null;
  let r2 = "";
  e5.split("\n").every((e6) => !we$1.some((n3) => n3.test(e6)) && (r2 += e6 + "\n", e6.trim()));
  const i3 = r2.trimEnd();
  return "" == i3 ? null : [r2, i3];
}
function je$1(e5) {
  try {
    if (decodeURIComponent(e5).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
  } catch (e6) {
    return null;
  }
  return e5;
}
function Be$1(e5) {
  return e5.replace(ie$1, "$1");
}
function Ne$1(e5, n2, t3) {
  const r2 = t3.inline || false, i3 = t3.simple || false;
  t3.inline = true, t3.simple = true;
  const l2 = e5(n2, t3);
  return t3.inline = r2, t3.simple = i3, l2;
}
function He$1(e5, n2, t3) {
  const r2 = t3.inline || false, i3 = t3.simple || false;
  t3.inline = false, t3.simple = true;
  const l2 = e5(n2, t3);
  return t3.inline = r2, t3.simple = i3, l2;
}
function De$1(e5, n2, t3) {
  const r2 = t3.inline || false;
  t3.inline = false;
  const i3 = e5(n2, t3);
  return t3.inline = r2, i3;
}
const Pe$1 = (e5, n2, t3) => ({ children: Ne$1(n2, e5[1], t3) });
function _e$1() {
  return {};
}
function Fe$1() {
  return null;
}
function We$1(...e5) {
  return e5.filter(Boolean).join(" ");
}
function Ge$1(e5, n2, t3) {
  let r2 = e5;
  const i3 = n2.split(".");
  for (; i3.length && (r2 = r2[i3[0]], void 0 !== r2); ) i3.shift();
  return r2 || t3;
}
function Ze$1(t3 = "", r2 = {}) {
  r2.overrides = r2.overrides || {}, r2.slugify = r2.slugify || Ce$1, r2.namedCodesToUnicode = r2.namedCodesToUnicode ? n({}, o, r2.namedCodesToUnicode) : o;
  const i3 = r2.createElement || React$2.createElement;
  function d4(e5, t4, ...l2) {
    const o2 = Ge$1(r2.overrides, `${e5}.props`, {});
    return i3(function(e6, n2) {
      const t5 = Ge$1(n2, e6);
      return t5 ? "function" == typeof t5 || "object" == typeof t5 && "render" in t5 ? t5 : Ge$1(n2, `${e6}.component`, e6) : e6;
    }(e5, r2.overrides), n({}, t4, o2, { className: We$1(null == t4 ? void 0 : t4.className, o2.className) || void 0 }), ...l2);
  }
  function G3(n2) {
    n2 = n2.replace(E, "");
    let t4 = false;
    r2.forceInline ? t4 = true : r2.forceBlock || (t4 = false === F.test(n2));
    const i4 = le2(ie2(t4 ? n2 : `${n2.trimEnd().replace(te, "")}

`, { inline: t4 }));
    for (; "string" == typeof i4[i4.length - 1] && !i4[i4.length - 1].trim(); ) i4.pop();
    if (null === r2.wrapper) return i4;
    const l2 = r2.wrapper || (t4 ? "span" : "div");
    let o2;
    if (i4.length > 1 || r2.forceWrapper) o2 = i4;
    else {
      if (1 === i4.length) return o2 = i4[0], "string" == typeof o2 ? d4("span", { key: "outer" }, o2) : o2;
      o2 = null;
    }
    return React$2.createElement(l2, { key: "outer" }, o2);
  }
  function Z2(n2) {
    const t4 = n2.match(a);
    return t4 ? t4.reduce(function(n3, t5, r3) {
      const i4 = t5.indexOf("=");
      if (-1 !== i4) {
        const o2 = function(e5) {
          return -1 !== e5.indexOf("-") && null === e5.match(R) && (e5 = e5.replace(B, function(e6, n4) {
            return n4.toUpperCase();
          })), e5;
        }(t5.slice(0, i4)).trim(), c3 = function(e5) {
          const n4 = e5[0];
          return ('"' === n4 || "'" === n4) && e5.length >= 2 && e5[e5.length - 1] === n4 ? e5.slice(1, -1) : e5;
        }(t5.slice(i4 + 1).trim()), a4 = l[o2] || o2, s4 = n3[a4] = function(e5, n4) {
          return "style" === e5 ? n4.split(/;\s?/).reduce(function(e6, n5) {
            const t6 = n5.slice(0, n5.indexOf(":"));
            return e6[t6.trim().replace(/(-[a-z])/g, (e7) => e7[1].toUpperCase())] = n5.slice(t6.length + 1).trim(), e6;
          }, {}) : "href" === e5 || "src" === e5 ? je$1(n4) : (n4.match(M) && (n4 = n4.slice(1, n4.length - 1)), "true" === n4 || "false" !== n4 && n4);
        }(o2, c3);
        "string" == typeof s4 && (O.test(s4) || z.test(s4)) && (n3[a4] = React$2.cloneElement(G3(s4.trim()), { key: r3 }));
      } else "style" !== t5 && (n3[l[t5] || t5] = true);
      return n3;
    }, {}) : null;
  }
  const q3 = [], V2 = {}, X3 = { 0: { match: Me$1(u), order: 1, parse: (e5, n2, t4) => ({ children: n2(e5[0].replace(p, ""), t4) }), render: (e5, n2, t4) => d4("blockquote", { key: t4.key }, n2(e5.children, t4)) }, 1: { match: Ie$1(f), order: 1, parse: _e$1, render: (e5, n2, t4) => d4("br", { key: t4.key }) }, 2: { match: Me$1(h), order: 1, parse: _e$1, render: (e5, n2, t4) => d4("hr", { key: t4.key }) }, 3: { match: Me$1(g), order: 0, parse: (e5) => ({ lang: void 0, text: e5[0].replace(/^ {4}/gm, "").replace(/\n+$/, "") }), render: (e5, t4, r3) => d4("pre", { key: r3.key }, d4("code", n({}, e5.attrs, { className: e5.lang ? `lang-${e5.lang}` : "" }), e5.text)) }, 4: { match: Me$1(m), order: 0, parse: (e5) => ({ attrs: Z2(e5[3] || ""), lang: e5[2] || void 0, text: e5[4], type: "3" }) }, 5: { match: ze$1(y), order: 3, parse: (e5) => ({ text: e5[2] }), render: (e5, n2, t4) => d4("code", { key: t4.key }, e5.text) }, 6: { match: Me$1(v), order: 0, parse: (e5) => (q3.push({ footnote: e5[2], identifier: e5[1] }), {}), render: Fe$1 }, 7: { match: Re$1(b), order: 1, parse: (e5) => ({ target: `#${r2.slugify(e5[1])}`, text: e5[1] }), render: (e5, n2, t4) => d4("a", { key: t4.key, href: je$1(e5.target) }, d4("sup", { key: t4.key }, e5.text)) }, 8: { match: Re$1(w), order: 1, parse: (e5) => ({ completed: "x" === e5[1].toLowerCase() }), render: (e5, n2, t4) => d4("input", { checked: e5.completed, key: t4.key, readOnly: true, type: "checkbox" }) }, 9: { match: Me$1(r2.enforceAtxHeadings ? C : S), order: 1, parse: (e5, n2, t4) => ({ children: Ne$1(n2, e5[2], t4), id: r2.slugify(e5[2]), level: e5[1].length }), render: (e5, n2, t4) => d4(`h${e5.level}`, { id: e5.id, key: t4.key }, n2(e5.children, t4)) }, 10: { match: Me$1(A), order: 0, parse: (e5, n2, t4) => ({ children: Ne$1(n2, e5[1], t4), level: "=" === e5[2] ? 1 : 2, type: "9" }) }, 11: { match: Ie$1(O), order: 1, parse(e5, n2, t4) {
    const [, r3] = e5[3].match(re), i4 = new RegExp(`^${r3}`, "gm"), l2 = e5[3].replace(i4, ""), o2 = (a4 = l2, Se$1.some((e6) => e6.test(a4)) ? De$1 : Ne$1);
    var a4;
    const s4 = e5[1].toLowerCase(), d5 = -1 !== c.indexOf(s4), u3 = { attrs: Z2(e5[2]), noInnerParse: d5, tag: (d5 ? s4 : e5[1]).trim() };
    return t4.inAnchor = t4.inAnchor || "a" === s4, d5 ? u3.text = e5[3] : u3.children = o2(n2, l2, t4), t4.inAnchor = false, u3;
  }, render: (e5, t4, r3) => d4(e5.tag, n({ key: r3.key }, e5.attrs), e5.text || t4(e5.children, r3)) }, 13: { match: Ie$1(z), order: 1, parse: (e5) => ({ attrs: Z2(e5[2] || ""), tag: e5[1].trim() }), render: (e5, t4, r3) => d4(e5.tag, n({}, e5.attrs, { key: r3.key })) }, 12: { match: Ie$1(L), order: 1, parse: () => ({}), render: Fe$1 }, 14: { match: ze$1(Ee$1), order: 1, parse: (e5) => ({ alt: e5[1], target: Be$1(e5[2]), title: e5[3] }), render: (e5, n2, t4) => d4("img", { key: t4.key, alt: e5.alt || void 0, title: e5.title || void 0, src: je$1(e5.target) }) }, 15: { match: Re$1($e$1), order: 3, parse: (e5, n2, t4) => ({ children: He$1(n2, e5[1], t4), target: Be$1(e5[2]), title: e5[3] }), render: (e5, n2, t4) => d4("a", { key: t4.key, href: je$1(e5.target), title: e5.title }, n2(e5.children, t4)) }, 16: { match: Re$1(j), order: 0, parse: (e5) => ({ children: [{ text: e5[1], type: "27" }], target: e5[1], type: "15" }) }, 17: { match: (e5, n2) => n2.inAnchor ? null : Re$1(I)(e5, n2), order: 0, parse: (e5) => ({ children: [{ text: e5[1], type: "27" }], target: e5[1], title: void 0, type: "15" }) }, 18: { match: Re$1(U), order: 0, parse(e5) {
    let n2 = e5[1], t4 = e5[1];
    return s.test(t4) || (t4 = "mailto:" + t4), { children: [{ text: n2.replace("mailto:", ""), type: "27" }], target: t4, type: "15" };
  } }, 20: be$1(d4, 1), 33: be$1(d4, 2), 19: { match: Me$1(k), order: 3, parse: _e$1, render: () => "\n" }, 21: { match: Ue$1, order: 3, parse: Pe$1, render: (e5, n2, t4) => d4("p", { key: t4.key }, n2(e5.children, t4)) }, 22: { match: Re$1(H), order: 0, parse: (e5) => (V2[e5[1]] = { target: e5[2], title: e5[4] }, {}), render: Fe$1 }, 23: { match: ze$1(D), order: 0, parse: (e5) => ({ alt: e5[1] || void 0, ref: e5[2] }), render: (e5, n2, t4) => V2[e5.ref] ? d4("img", { key: t4.key, alt: e5.alt, src: je$1(V2[e5.ref].target), title: V2[e5.ref].title }) : null }, 24: { match: Re$1(P), order: 0, parse: (e5, n2, t4) => ({ children: n2(e5[1], t4), fallbackChildren: n2(e5[0].replace(_, "\\$1"), t4), ref: e5[2] }), render: (e5, n2, t4) => V2[e5.ref] ? d4("a", { key: t4.key, href: je$1(V2[e5.ref].target), title: V2[e5.ref].title }, n2(e5.children, t4)) : d4("span", { key: t4.key }, n2(e5.fallbackChildren, t4)) }, 25: { match: Me$1(N), order: 1, parse: Te$1, render(e5, n2, t4) {
    const r3 = e5;
    return d4("table", { key: t4.key }, d4("thead", null, d4("tr", null, r3.header.map(function(e6, i4) {
      return d4("th", { key: i4, style: Le$1(r3, i4) }, n2(e6, t4));
    }))), d4("tbody", null, r3.cells.map(function(e6, i4) {
      return d4("tr", { key: i4 }, e6.map(function(e7, i5) {
        return d4("td", { key: i5, style: Le$1(r3, i5) }, n2(e7, t4));
      }));
    })));
  } }, 27: { match: Ie$1(ne$1), order: 4, parse: (e5) => ({ text: e5[0].replace(T, (e6, n2) => r2.namedCodesToUnicode[n2] ? r2.namedCodesToUnicode[n2] : e6) }), render: (e5) => e5.text }, 28: { match: ze$1(Q), order: 2, parse: (e5, n2, t4) => ({ children: n2(e5[2], t4) }), render: (e5, n2, t4) => d4("strong", { key: t4.key }, n2(e5.children, t4)) }, 29: { match: ze$1(J), order: 3, parse: (e5, n2, t4) => ({ children: n2(e5[2], t4) }), render: (e5, n2, t4) => d4("em", { key: t4.key }, n2(e5.children, t4)) }, 30: { match: ze$1(ee), order: 1, parse: (e5) => ({ text: e5[1], type: "27" }) }, 31: { match: ze$1(K), order: 3, parse: Pe$1, render: (e5, n2, t4) => d4("mark", { key: t4.key }, n2(e5.children, t4)) }, 32: { match: ze$1(Y), order: 3, parse: Pe$1, render: (e5, n2, t4) => d4("del", { key: t4.key }, n2(e5.children, t4)) } };
  true === r2.disableParsingRawHTML && (delete X3[11], delete X3[13]);
  const ie2 = function(e5) {
    let n2 = Object.keys(e5);
    function t4(r3, i4) {
      let l2 = [], o2 = "";
      for (; r3; ) {
        let c3 = 0;
        for (; c3 < n2.length; ) {
          const a4 = n2[c3], s4 = e5[a4], d5 = s4.match(r3, i4, o2);
          if (d5) {
            const e6 = d5[0];
            r3 = r3.substring(e6.length);
            const n3 = s4.parse(d5, t4, i4);
            null == n3.type && (n3.type = a4), l2.push(n3), o2 = e6;
            break;
          }
          c3++;
        }
      }
      return l2;
    }
    return n2.sort(function(n3, t5) {
      let r3 = e5[n3].order, i4 = e5[t5].order;
      return r3 !== i4 ? r3 - i4 : n3 < t5 ? -1 : 1;
    }), function(e6, n3) {
      return t4(function(e7) {
        return e7.replace(x, "\n").replace($, "").replace(W, "    ");
      }(e6), n3);
    };
  }(X3), le2 = (oe2 = /* @__PURE__ */ function(e5, n2) {
    return function(t4, r3, i4) {
      const l2 = e5[t4.type].render;
      return n2 ? n2(() => l2(t4, r3, i4), t4, r3, i4) : l2(t4, r3, i4);
    };
  }(X3, r2.renderRule), function e5(n2, t4 = {}) {
    if (Array.isArray(n2)) {
      const r3 = t4.key, i4 = [];
      let l2 = false;
      for (let r4 = 0; r4 < n2.length; r4++) {
        t4.key = r4;
        const o2 = e5(n2[r4], t4), c3 = "string" == typeof o2;
        c3 && l2 ? i4[i4.length - 1] += o2 : null !== o2 && i4.push(o2), l2 = c3;
      }
      return t4.key = r3, i4;
    }
    return oe2(n2, e5, t4);
  });
  var oe2;
  const ce2 = G3(t3);
  return q3.length ? d4("div", null, ce2, d4("footer", { key: "footer" }, q3.map(function(e5) {
    return d4("div", { id: r2.slugify(e5.identifier), key: e5.identifier }, e5.identifier, le2(ie2(e5.footnote, { inline: true })));
  }))) : ce2;
}
const Markdown$1 = (n2) => {
  let { children: r2 = "", options: i3 } = n2, l2 = function(e5, n3) {
    if (null == e5) return {};
    var t3, r3, i4 = {}, l3 = Object.keys(e5);
    for (r3 = 0; r3 < l3.length; r3++) n3.indexOf(t3 = l3[r3]) >= 0 || (i4[t3] = e5[t3]);
    return i4;
  }(n2, t);
  return React$2.cloneElement(Ze$1(r2, i3), l2);
};
var baseUnset = _baseUnset;
function unset(object, path3) {
  return object == null ? true : baseUnset(object, path3);
}
var unset_1 = unset;
const unset$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(unset_1);
class ObjectField extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      wasPropertyKeyModified: false,
      additionalProperties: {}
    };
    this.onPropertyChange = (name2, addedByAdditionalProperties = false) => {
      return (value, newErrorSchema, id2) => {
        const { formData, onChange, errorSchema } = this.props;
        if (value === void 0 && addedByAdditionalProperties) {
          value = "";
        }
        const newFormData = { ...formData, [name2]: value };
        onChange(newFormData, errorSchema && errorSchema && {
          ...errorSchema,
          [name2]: newErrorSchema
        }, id2);
      };
    };
    this.onDropPropertyClick = (key2) => {
      return (event) => {
        event.preventDefault();
        const { onChange, formData } = this.props;
        const copiedFormData = { ...formData };
        unset$1(copiedFormData, key2);
        onChange(copiedFormData);
      };
    };
    this.getAvailableKey = (preferredKey, formData) => {
      const { uiSchema, registry } = this.props;
      const { duplicateKeySuffixSeparator = "-" } = getUiOptions(uiSchema, registry.globalUiOptions);
      let index2 = 0;
      let newKey = preferredKey;
      while (has$5(formData, newKey)) {
        newKey = `${preferredKey}${duplicateKeySuffixSeparator}${++index2}`;
      }
      return newKey;
    };
    this.onKeyChange = (oldValue) => {
      return (value, newErrorSchema) => {
        if (oldValue === value) {
          return;
        }
        const { formData, onChange, errorSchema } = this.props;
        value = this.getAvailableKey(value, formData);
        const newFormData = {
          ...formData
        };
        const newKeys = { [oldValue]: value };
        const keyValues = Object.keys(newFormData).map((key2) => {
          const newKey = newKeys[key2] || key2;
          return { [newKey]: newFormData[key2] };
        });
        const renamedObj = Object.assign({}, ...keyValues);
        this.setState({ wasPropertyKeyModified: true });
        onChange(renamedObj, errorSchema && errorSchema && {
          ...errorSchema,
          [value]: newErrorSchema
        });
      };
    };
    this.handleAddClick = (schema) => () => {
      if (!schema.additionalProperties) {
        return;
      }
      const { formData, onChange, registry } = this.props;
      const newFormData = { ...formData };
      let type2 = void 0;
      let defaultValue = void 0;
      if (isObject$j(schema.additionalProperties)) {
        type2 = schema.additionalProperties.type;
        defaultValue = schema.additionalProperties.default;
        let apSchema = schema.additionalProperties;
        if (REF_KEY in apSchema) {
          const { schemaUtils } = registry;
          apSchema = schemaUtils.retrieveSchema({ $ref: apSchema[REF_KEY] }, formData);
          type2 = apSchema.type;
          defaultValue = apSchema.default;
        }
        if (!type2 && (ANY_OF_KEY in apSchema || ONE_OF_KEY in apSchema)) {
          type2 = "object";
        }
      }
      const newKey = this.getAvailableKey("newKey", newFormData);
      set$3(newFormData, newKey, defaultValue !== null && defaultValue !== void 0 ? defaultValue : this.getDefaultValue(type2));
      onChange(newFormData);
    };
  }
  /** Returns a flag indicating whether the `name` field is required in the object schema
   *
   * @param name - The name of the field to check for required-ness
   * @returns - True if the field `name` is required, false otherwise
   */
  isRequired(name2) {
    const { schema } = this.props;
    return Array.isArray(schema.required) && schema.required.indexOf(name2) !== -1;
  }
  /** Returns a default value to be used for a new additional schema property of the given `type`
   *
   * @param type - The type of the new additional schema property
   */
  getDefaultValue(type2) {
    const { registry: { translateString } } = this.props;
    switch (type2) {
      case "array":
        return [];
      case "boolean":
        return false;
      case "null":
        return null;
      case "number":
        return 0;
      case "object":
        return {};
      case "string":
      default:
        return translateString(TranslatableString.NewStringDefault);
    }
  }
  /** Renders the `ObjectField` from the given props
   */
  render() {
    var _a2, _b2, _c2, _d2;
    const { schema: rawSchema, uiSchema = {}, formData, errorSchema, idSchema, name: name2, required: required2 = false, disabled, readonly, hideError, idPrefix, idSeparator, onBlur, onFocus, registry, title: title2 } = this.props;
    const { fields: fields2, formContext, schemaUtils, translateString, globalUiOptions } = registry;
    const { SchemaField: SchemaField2 } = fields2;
    const schema = schemaUtils.retrieveSchema(rawSchema, formData);
    const uiOptions = getUiOptions(uiSchema, globalUiOptions);
    const { properties: schemaProperties2 = {} } = schema;
    const templateTitle = (_c2 = (_b2 = (_a2 = uiOptions.title) !== null && _a2 !== void 0 ? _a2 : schema.title) !== null && _b2 !== void 0 ? _b2 : title2) !== null && _c2 !== void 0 ? _c2 : name2;
    const description2 = (_d2 = uiOptions.description) !== null && _d2 !== void 0 ? _d2 : schema.description;
    let orderedProperties;
    try {
      const properties2 = Object.keys(schemaProperties2);
      orderedProperties = orderProperties(properties2, uiOptions.order);
    } catch (err) {
      return jsxs("div", { children: [jsx$1("p", { className: "config-error", style: { color: "red" }, children: jsx$1(Markdown$1, { children: translateString(TranslatableString.InvalidObjectField, [name2 || "root", err.message]) }) }), jsx$1("pre", { children: JSON.stringify(schema) })] });
    }
    const Template = getTemplate("ObjectFieldTemplate", registry, uiOptions);
    const templateProps = {
      // getDisplayLabel() always returns false for object types, so just check the `uiOptions.label`
      title: uiOptions.label === false ? "" : templateTitle,
      description: uiOptions.label === false ? void 0 : description2,
      properties: orderedProperties.map((name3) => {
        const addedByAdditionalProperties = has$5(schema, [PROPERTIES_KEY, name3, ADDITIONAL_PROPERTY_FLAG]);
        const fieldUiSchema = addedByAdditionalProperties ? uiSchema.additionalProperties : uiSchema[name3];
        const hidden = getUiOptions(fieldUiSchema).widget === "hidden";
        const fieldIdSchema = get$6(idSchema, [name3], {});
        return {
          content: jsx$1(SchemaField2, { name: name3, required: this.isRequired(name3), schema: get$6(schema, [PROPERTIES_KEY, name3], {}), uiSchema: fieldUiSchema, errorSchema: get$6(errorSchema, name3), idSchema: fieldIdSchema, idPrefix, idSeparator, formData: get$6(formData, name3), formContext, wasPropertyKeyModified: this.state.wasPropertyKeyModified, onKeyChange: this.onKeyChange(name3), onChange: this.onPropertyChange(name3, addedByAdditionalProperties), onBlur, onFocus, registry, disabled, readonly, hideError, onDropPropertyClick: this.onDropPropertyClick }, name3),
          name: name3,
          readonly,
          disabled,
          required: required2,
          hidden
        };
      }),
      readonly,
      disabled,
      required: required2,
      idSchema,
      uiSchema,
      errorSchema,
      schema,
      formData,
      formContext,
      registry
    };
    return jsx$1(Template, { ...templateProps, onAddClick: this.handleAddClick });
  }
}
const COMPONENT_TYPES = {
  array: "ArrayField",
  boolean: "BooleanField",
  integer: "NumberField",
  number: "NumberField",
  object: "ObjectField",
  string: "StringField",
  null: "NullField"
};
function getFieldComponent(schema, uiOptions, idSchema, registry) {
  const field = uiOptions.field;
  const { fields: fields2, translateString } = registry;
  if (typeof field === "function") {
    return field;
  }
  if (typeof field === "string" && field in fields2) {
    return fields2[field];
  }
  const schemaType = getSchemaType(schema);
  const type2 = Array.isArray(schemaType) ? schemaType[0] : schemaType || "";
  const schemaId = schema.$id;
  let componentName = COMPONENT_TYPES[type2];
  if (schemaId && schemaId in fields2) {
    componentName = schemaId;
  }
  if (!componentName && (schema.anyOf || schema.oneOf)) {
    return () => null;
  }
  return componentName in fields2 ? fields2[componentName] : () => {
    const UnsupportedFieldTemplate = getTemplate("UnsupportedFieldTemplate", registry, uiOptions);
    return jsx$1(UnsupportedFieldTemplate, { schema, idSchema, reason: translateString(TranslatableString.UnknownFieldType, [String(schema.type)]), registry });
  };
}
function SchemaFieldRender(props2) {
  var _a2, _b2, _c2, _d2, _e3;
  const { schema: _schema, idSchema: _idSchema, uiSchema, formData, errorSchema, idPrefix, idSeparator, name: name2, onChange, onKeyChange, onDropPropertyClick, required: required2, registry, wasPropertyKeyModified = false } = props2;
  const { formContext, schemaUtils, globalUiOptions } = registry;
  const uiOptions = getUiOptions(uiSchema, globalUiOptions);
  const FieldTemplate2 = getTemplate("FieldTemplate", registry, uiOptions);
  const DescriptionFieldTemplate = getTemplate("DescriptionFieldTemplate", registry, uiOptions);
  const FieldHelpTemplate2 = getTemplate("FieldHelpTemplate", registry, uiOptions);
  const FieldErrorTemplate2 = getTemplate("FieldErrorTemplate", registry, uiOptions);
  const schema = schemaUtils.retrieveSchema(_schema, formData);
  const fieldId = _idSchema[ID_KEY];
  const idSchema = mergeObjects(schemaUtils.toIdSchema(schema, fieldId, formData, idPrefix, idSeparator), _idSchema);
  const handleFieldComponentChange = useCallback((formData2, newErrorSchema, id3) => {
    const theId = id3 || fieldId;
    return onChange(formData2, newErrorSchema, theId);
  }, [fieldId, onChange]);
  const FieldComponent = getFieldComponent(schema, uiOptions, idSchema, registry);
  const disabled = Boolean((_a2 = uiOptions.disabled) !== null && _a2 !== void 0 ? _a2 : props2.disabled);
  const readonly = Boolean((_d2 = (_c2 = (_b2 = uiOptions.readonly) !== null && _b2 !== void 0 ? _b2 : props2.readonly) !== null && _c2 !== void 0 ? _c2 : props2.schema.readOnly) !== null && _d2 !== void 0 ? _d2 : schema.readOnly);
  const uiSchemaHideError = uiOptions.hideError;
  const hideError = uiSchemaHideError === void 0 ? props2.hideError : Boolean(uiSchemaHideError);
  const autofocus = Boolean((_e3 = uiOptions.autofocus) !== null && _e3 !== void 0 ? _e3 : props2.autofocus);
  if (Object.keys(schema).length === 0) {
    return null;
  }
  const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
  const { __errors, ...fieldErrorSchema } = errorSchema || {};
  const fieldUiSchema = omit$1(uiSchema, ["ui:classNames", "classNames", "ui:style"]);
  if (UI_OPTIONS_KEY in fieldUiSchema) {
    fieldUiSchema[UI_OPTIONS_KEY] = omit$1(fieldUiSchema[UI_OPTIONS_KEY], ["classNames", "style"]);
  }
  const field = jsx$1(FieldComponent, { ...props2, onChange: handleFieldComponentChange, idSchema, schema, uiSchema: fieldUiSchema, disabled, readonly, hideError, autofocus, errorSchema: fieldErrorSchema, formContext, rawErrors: __errors });
  const id2 = idSchema[ID_KEY];
  let label;
  if (wasPropertyKeyModified) {
    label = name2;
  } else {
    label = ADDITIONAL_PROPERTY_FLAG in schema ? name2 : uiOptions.title || props2.schema.title || schema.title || props2.title || name2;
  }
  const description2 = uiOptions.description || props2.schema.description || schema.description || "";
  const richDescription = uiOptions.enableMarkdownInDescription ? jsx$1(Markdown$1, { children: description2 }) : description2;
  const help = uiOptions.help;
  const hidden = uiOptions.widget === "hidden";
  const classNames2 = ["form-group", "field", `field-${getSchemaType(schema)}`];
  if (!hideError && __errors && __errors.length > 0) {
    classNames2.push("field-error has-error has-danger");
  }
  if (uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema.classNames) {
    if (process$1$1.env.NODE_ENV !== "production") {
      console.warn("'uiSchema.classNames' is deprecated and may be removed in a major release; Use 'ui:classNames' instead.");
    }
    classNames2.push(uiSchema.classNames);
  }
  if (uiOptions.classNames) {
    classNames2.push(uiOptions.classNames);
  }
  const helpComponent = jsx$1(FieldHelpTemplate2, { help, idSchema, schema, uiSchema, hasErrors: !hideError && __errors && __errors.length > 0, registry });
  const errorsComponent = hideError || (schema.anyOf || schema.oneOf) && !schemaUtils.isSelect(schema) ? void 0 : jsx$1(FieldErrorTemplate2, { errors: __errors, errorSchema, idSchema, schema, uiSchema, registry });
  const fieldProps = {
    description: jsx$1(DescriptionFieldTemplate, { id: descriptionId(id2), description: richDescription, schema, uiSchema, registry }),
    rawDescription: description2,
    help: helpComponent,
    rawHelp: typeof help === "string" ? help : void 0,
    errors: errorsComponent,
    rawErrors: hideError ? void 0 : __errors,
    id: id2,
    label,
    hidden,
    onChange,
    onKeyChange,
    onDropPropertyClick,
    required: required2,
    disabled,
    readonly,
    hideError,
    displayLabel,
    classNames: classNames2.join(" ").trim(),
    style: uiOptions.style,
    formContext,
    formData,
    schema,
    uiSchema,
    registry
  };
  const _AnyOfField = registry.fields.AnyOfField;
  const _OneOfField = registry.fields.OneOfField;
  const isReplacingAnyOrOneOf = (uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema["ui:field"]) && (uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema["ui:fieldReplacesAnyOrOneOf"]) === true;
  return jsx$1(FieldTemplate2, { ...fieldProps, children: jsxs(Fragment$1, { children: [field, schema.anyOf && !isReplacingAnyOrOneOf && !schemaUtils.isSelect(schema) && jsx$1(_AnyOfField, { name: name2, disabled, readonly, hideError, errorSchema, formData, formContext, idPrefix, idSchema, idSeparator, onBlur: props2.onBlur, onChange: props2.onChange, onFocus: props2.onFocus, options: schema.anyOf.map((_schema2) => schemaUtils.retrieveSchema(isObject$j(_schema2) ? _schema2 : {}, formData)), registry, schema, uiSchema }), schema.oneOf && !isReplacingAnyOrOneOf && !schemaUtils.isSelect(schema) && jsx$1(_OneOfField, { name: name2, disabled, readonly, hideError, errorSchema, formData, formContext, idPrefix, idSchema, idSeparator, onBlur: props2.onBlur, onChange: props2.onChange, onFocus: props2.onFocus, options: schema.oneOf.map((_schema2) => schemaUtils.retrieveSchema(isObject$j(_schema2) ? _schema2 : {}, formData)), registry, schema, uiSchema })] }) });
}
class SchemaField extends Component {
  shouldComponentUpdate(nextProps) {
    return !deepEquals(this.props, nextProps);
  }
  render() {
    return jsx$1(SchemaFieldRender, { ...this.props });
  }
}
function StringField(props2) {
  var _a2;
  const { schema, name: name2, uiSchema, idSchema, formData, required: required2, disabled = false, readonly = false, autofocus = false, onChange, onBlur, onFocus, registry, rawErrors, hideError } = props2;
  const { title: title2, format: format3 } = schema;
  const { widgets: widgets2, formContext, schemaUtils, globalUiOptions } = registry;
  const enumOptions = schemaUtils.isSelect(schema) ? optionsList(schema) : void 0;
  let defaultWidget = enumOptions ? "select" : "text";
  if (format3 && hasWidget(schema, format3, widgets2)) {
    defaultWidget = format3;
  }
  const { widget = defaultWidget, placeholder = "", title: uiTitle, ...options } = getUiOptions(uiSchema);
  const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
  const label = (_a2 = uiTitle !== null && uiTitle !== void 0 ? uiTitle : title2) !== null && _a2 !== void 0 ? _a2 : name2;
  const Widget = getWidget(schema, widget, widgets2);
  return jsx$1(Widget, { options: { ...options, enumOptions }, schema, uiSchema, id: idSchema.$id, name: name2, label, hideLabel: !displayLabel, hideError, value: formData, onChange, onBlur, onFocus, required: required2, disabled, readonly, formContext, autofocus, registry, placeholder, rawErrors });
}
function NullField(props2) {
  const { formData, onChange } = props2;
  useEffect(() => {
    if (formData === void 0) {
      onChange(null);
    }
  }, [formData, onChange]);
  return null;
}
function fields$2() {
  return {
    AnyOfField,
    ArrayField: ArrayField$2,
    // ArrayField falls back to SchemaField if ArraySchemaField is not defined, which it isn't by default
    BooleanField,
    NumberField,
    ObjectField,
    OneOfField: AnyOfField,
    SchemaField,
    StringField,
    NullField
  };
}
function ArrayFieldDescriptionTemplate(props2) {
  const { idSchema, description: description2, registry, schema, uiSchema } = props2;
  const options = getUiOptions(uiSchema, registry.globalUiOptions);
  const { label: displayLabel = true } = options;
  if (!description2 || !displayLabel) {
    return null;
  }
  const DescriptionFieldTemplate = getTemplate("DescriptionFieldTemplate", registry, options);
  return jsx$1(DescriptionFieldTemplate, { id: descriptionId(idSchema), description: description2, schema, uiSchema, registry });
}
function ArrayFieldItemTemplate(props2) {
  const { children, className, disabled, hasToolbar, hasMoveDown, hasMoveUp, hasRemove, hasCopy, index: index2, onCopyIndexClick, onDropIndexClick, onReorderClick, readonly, registry, uiSchema } = props2;
  const { CopyButton: CopyButton2, MoveDownButton: MoveDownButton2, MoveUpButton: MoveUpButton2, RemoveButton: RemoveButton2 } = registry.templates.ButtonTemplates;
  const btnStyle = {
    flex: 1,
    paddingLeft: 6,
    paddingRight: 6,
    fontWeight: "bold"
  };
  return jsxs("div", { className, children: [jsx$1("div", { className: hasToolbar ? "col-xs-9" : "col-xs-12", children }), hasToolbar && jsx$1("div", { className: "col-xs-3 array-item-toolbox", children: jsxs("div", { className: "btn-group", style: {
    display: "flex",
    justifyContent: "space-around"
  }, children: [(hasMoveUp || hasMoveDown) && jsx$1(MoveUpButton2, { style: btnStyle, disabled: disabled || readonly || !hasMoveUp, onClick: onReorderClick(index2, index2 - 1), uiSchema, registry }), (hasMoveUp || hasMoveDown) && jsx$1(MoveDownButton2, { style: btnStyle, disabled: disabled || readonly || !hasMoveDown, onClick: onReorderClick(index2, index2 + 1), uiSchema, registry }), hasCopy && jsx$1(CopyButton2, { style: btnStyle, disabled: disabled || readonly, onClick: onCopyIndexClick(index2), uiSchema, registry }), hasRemove && jsx$1(RemoveButton2, { style: btnStyle, disabled: disabled || readonly, onClick: onDropIndexClick(index2), uiSchema, registry })] }) })] });
}
function ArrayFieldTemplate$2(props2) {
  const { canAdd, className, disabled, idSchema, uiSchema, items: items2, onAddClick, readonly, registry, required: required2, schema, title: title2 } = props2;
  const uiOptions = getUiOptions(uiSchema);
  const ArrayFieldDescriptionTemplate2 = getTemplate("ArrayFieldDescriptionTemplate", registry, uiOptions);
  const ArrayFieldItemTemplate2 = getTemplate("ArrayFieldItemTemplate", registry, uiOptions);
  const ArrayFieldTitleTemplate2 = getTemplate("ArrayFieldTitleTemplate", registry, uiOptions);
  const { ButtonTemplates: { AddButton: AddButton2 } } = registry.templates;
  return jsxs("fieldset", { className, id: idSchema.$id, children: [jsx$1(ArrayFieldTitleTemplate2, { idSchema, title: uiOptions.title || title2, required: required2, schema, uiSchema, registry }), jsx$1(ArrayFieldDescriptionTemplate2, { idSchema, description: uiOptions.description || schema.description, schema, uiSchema, registry }), jsx$1("div", { className: "row array-item-list", children: items2 && items2.map(({ key: key2, ...itemProps }) => jsx$1(ArrayFieldItemTemplate2, { ...itemProps }, key2)) }), canAdd && jsx$1(AddButton2, { className: "array-item-add", onClick: onAddClick, disabled: disabled || readonly, uiSchema, registry })] });
}
function ArrayFieldTitleTemplate(props2) {
  const { idSchema, title: title2, schema, uiSchema, required: required2, registry } = props2;
  const options = getUiOptions(uiSchema, registry.globalUiOptions);
  const { label: displayLabel = true } = options;
  if (!title2 || !displayLabel) {
    return null;
  }
  const TitleFieldTemplate = getTemplate("TitleFieldTemplate", registry, options);
  return jsx$1(TitleFieldTemplate, { id: titleId(idSchema), title: title2, required: required2, schema, uiSchema, registry });
}
function BaseInputTemplate(props2) {
  const {
    id: id2,
    name: name2,
    // remove this from ...rest
    value,
    readonly,
    disabled,
    autofocus,
    onBlur,
    onFocus,
    onChange,
    onChangeOverride,
    options,
    schema,
    uiSchema,
    formContext,
    registry,
    rawErrors,
    type: type2,
    hideLabel,
    // remove this from ...rest
    hideError,
    // remove this from ...rest
    ...rest
  } = props2;
  if (!id2) {
    console.log("No id for", props2);
    throw new Error(`no id for props ${JSON.stringify(props2)}`);
  }
  const inputProps = {
    ...rest,
    ...getInputProps(schema, type2, options)
  };
  let inputValue;
  if (inputProps.type === "number" || inputProps.type === "integer") {
    inputValue = value || value === 0 ? value : "";
  } else {
    inputValue = value == null ? "" : value;
  }
  const _onChange = useCallback(({ target: { value: value2 } }) => onChange(value2 === "" ? options.emptyValue : value2), [onChange, options]);
  const _onBlur = useCallback(({ target }) => onBlur(id2, target && target.value), [onBlur, id2]);
  const _onFocus = useCallback(({ target }) => onFocus(id2, target && target.value), [onFocus, id2]);
  return jsxs(Fragment$1, { children: [jsx$1("input", { id: id2, name: id2, className: "form-control", readOnly: readonly, disabled, autoFocus: autofocus, value: inputValue, ...inputProps, list: schema.examples ? examplesId(id2) : void 0, onChange: onChangeOverride || _onChange, onBlur: _onBlur, onFocus: _onFocus, "aria-describedby": ariaDescribedByIds(id2, !!schema.examples) }), Array.isArray(schema.examples) && jsx$1("datalist", { id: examplesId(id2), children: schema.examples.concat(schema.default && !schema.examples.includes(schema.default) ? [schema.default] : []).map((example) => {
    return jsx$1("option", { value: example }, example);
  }) }, `datalist_${id2}`)] });
}
function SubmitButton({ uiSchema }) {
  const { submitText, norender, props: submitButtonProps = {} } = getSubmitButtonOptions(uiSchema);
  if (norender) {
    return null;
  }
  return jsx$1("div", { children: jsx$1("button", { type: "submit", ...submitButtonProps, className: `btn btn-info ${submitButtonProps.className || ""}`, children: submitText }) });
}
function IconButton(props2) {
  const { iconType = "default", icon: icon2, className, uiSchema, registry, ...otherProps } = props2;
  return jsx$1("button", { type: "button", className: `btn btn-${iconType} ${className}`, ...otherProps, children: jsx$1("i", { className: `glyphicon glyphicon-${icon2}` }) });
}
function CopyButton(props2) {
  const { registry: { translateString } } = props2;
  return jsx$1(IconButton, { title: translateString(TranslatableString.CopyButton), className: "array-item-copy", ...props2, icon: "copy" });
}
function MoveDownButton(props2) {
  const { registry: { translateString } } = props2;
  return jsx$1(IconButton, { title: translateString(TranslatableString.MoveDownButton), className: "array-item-move-down", ...props2, icon: "arrow-down" });
}
function MoveUpButton(props2) {
  const { registry: { translateString } } = props2;
  return jsx$1(IconButton, { title: translateString(TranslatableString.MoveUpButton), className: "array-item-move-up", ...props2, icon: "arrow-up" });
}
function RemoveButton(props2) {
  const { registry: { translateString } } = props2;
  return jsx$1(IconButton, { title: translateString(TranslatableString.RemoveButton), className: "array-item-remove", ...props2, iconType: "danger", icon: "remove" });
}
function AddButton({ className, onClick, disabled, registry }) {
  const { translateString } = registry;
  return jsx$1("div", { className: "row", children: jsx$1("p", { className: `col-xs-3 col-xs-offset-9 text-right ${className}`, children: jsx$1(IconButton, { iconType: "info", icon: "plus", className: "btn-add col-xs-12", title: translateString(TranslatableString.AddButton), onClick, disabled, registry }) }) });
}
function buttonTemplates() {
  return {
    SubmitButton,
    AddButton,
    CopyButton,
    MoveDownButton,
    MoveUpButton,
    RemoveButton
  };
}
function DescriptionField(props2) {
  const { id: id2, description: description2 } = props2;
  if (!description2) {
    return null;
  }
  if (typeof description2 === "string") {
    return jsx$1("p", { id: id2, className: "field-description", children: description2 });
  } else {
    return jsx$1("div", { id: id2, className: "field-description", children: description2 });
  }
}
function ErrorList({ errors: errors2, registry }) {
  const { translateString } = registry;
  return jsxs("div", { className: "panel panel-danger errors", children: [jsx$1("div", { className: "panel-heading", children: jsx$1("h3", { className: "panel-title", children: translateString(TranslatableString.ErrorsLabel) }) }), jsx$1("ul", { className: "list-group", children: errors2.map((error2, i3) => {
    return jsx$1("li", { className: "list-group-item text-danger", children: error2.stack }, i3);
  }) })] });
}
const REQUIRED_FIELD_SYMBOL$1 = "*";
function Label$2(props2) {
  const { label, required: required2, id: id2 } = props2;
  if (!label) {
    return null;
  }
  return jsxs("label", { className: "control-label", htmlFor: id2, children: [label, required2 && jsx$1("span", { className: "required", children: REQUIRED_FIELD_SYMBOL$1 })] });
}
function FieldTemplate$2(props2) {
  const { id: id2, label, children, errors: errors2, help, description: description2, hidden, required: required2, displayLabel, registry, uiSchema } = props2;
  const uiOptions = getUiOptions(uiSchema);
  const WrapIfAdditionalTemplate2 = getTemplate("WrapIfAdditionalTemplate", registry, uiOptions);
  if (hidden) {
    return jsx$1("div", { className: "hidden", children });
  }
  return jsxs(WrapIfAdditionalTemplate2, { ...props2, children: [displayLabel && jsx$1(Label$2, { label, required: required2, id: id2 }), displayLabel && description2 ? description2 : null, children, errors2, help] });
}
function FieldErrorTemplate(props2) {
  const { errors: errors2 = [], idSchema } = props2;
  if (errors2.length === 0) {
    return null;
  }
  const id2 = errorId(idSchema);
  return jsx$1("div", { children: jsx$1("ul", { id: id2, className: "error-detail bs-callout bs-callout-info", children: errors2.filter((elem) => !!elem).map((error2, index2) => {
    return jsx$1("li", { className: "text-danger", children: error2 }, index2);
  }) }) });
}
function FieldHelpTemplate(props2) {
  const { idSchema, help } = props2;
  if (!help) {
    return null;
  }
  const id2 = helpId(idSchema);
  if (typeof help === "string") {
    return jsx$1("p", { id: id2, className: "help-block", children: help });
  }
  return jsx$1("div", { id: id2, className: "help-block", children: help });
}
function ObjectFieldTemplate$1(props2) {
  const { description: description2, disabled, formData, idSchema, onAddClick, properties: properties2, readonly, registry, required: required2, schema, title: title2, uiSchema } = props2;
  const options = getUiOptions(uiSchema);
  const TitleFieldTemplate = getTemplate("TitleFieldTemplate", registry, options);
  const DescriptionFieldTemplate = getTemplate("DescriptionFieldTemplate", registry, options);
  const { ButtonTemplates: { AddButton: AddButton2 } } = registry.templates;
  return jsxs("fieldset", { id: idSchema.$id, children: [title2 && jsx$1(TitleFieldTemplate, { id: titleId(idSchema), title: title2, required: required2, schema, uiSchema, registry }), description2 && jsx$1(DescriptionFieldTemplate, { id: descriptionId(idSchema), description: description2, schema, uiSchema, registry }), properties2.map((prop) => prop.content), canExpand(schema, uiSchema, formData) && jsx$1(AddButton2, { className: "object-property-expand", onClick: onAddClick(schema), disabled: disabled || readonly, uiSchema, registry })] });
}
const REQUIRED_FIELD_SYMBOL = "*";
function TitleField$1(props2) {
  const { id: id2, title: title2, required: required2 } = props2;
  return jsxs("legend", { id: id2, children: [title2, required2 && jsx$1("span", { className: "required", children: REQUIRED_FIELD_SYMBOL })] });
}
function UnsupportedField(props2) {
  const { schema, idSchema, reason, registry } = props2;
  const { translateString } = registry;
  let translateEnum = TranslatableString.UnsupportedField;
  const translateParams = [];
  if (idSchema && idSchema.$id) {
    translateEnum = TranslatableString.UnsupportedFieldWithId;
    translateParams.push(idSchema.$id);
  }
  if (reason) {
    translateEnum = translateEnum === TranslatableString.UnsupportedField ? TranslatableString.UnsupportedFieldWithReason : TranslatableString.UnsupportedFieldWithIdAndReason;
    translateParams.push(reason);
  }
  return jsxs("div", { className: "unsupported-field", children: [jsx$1("p", { children: jsx$1(Markdown$1, { children: translateString(translateEnum, translateParams) }) }), schema && jsx$1("pre", { children: JSON.stringify(schema, null, 2) })] });
}
function WrapIfAdditionalTemplate(props2) {
  const { id: id2, classNames: classNames2, style: style2, disabled, label, onKeyChange, onDropPropertyClick, readonly, required: required2, schema, children, uiSchema, registry } = props2;
  const { templates: templates2, translateString } = registry;
  const { RemoveButton: RemoveButton2 } = templates2.ButtonTemplates;
  const keyLabel = translateString(TranslatableString.KeyLabel, [label]);
  const additional = ADDITIONAL_PROPERTY_FLAG in schema;
  if (!additional) {
    return jsx$1("div", { className: classNames2, style: style2, children });
  }
  return jsx$1("div", { className: classNames2, style: style2, children: jsxs("div", { className: "row", children: [jsx$1("div", { className: "col-xs-5 form-additional", children: jsxs("div", { className: "form-group", children: [jsx$1(Label$2, { label: keyLabel, required: required2, id: `${id2}-key` }), jsx$1("input", { className: "form-control", type: "text", id: `${id2}-key`, onBlur: ({ target }) => onKeyChange(target && target.value), defaultValue: label })] }) }), jsx$1("div", { className: "form-additional form-group col-xs-5", children }), jsx$1("div", { className: "col-xs-2", children: jsx$1(RemoveButton2, { className: "array-item-remove btn-block", style: { border: "0" }, disabled: disabled || readonly, onClick: onDropPropertyClick(label), uiSchema, registry }) })] }) });
}
function templates() {
  return {
    ArrayFieldDescriptionTemplate,
    ArrayFieldItemTemplate,
    ArrayFieldTemplate: ArrayFieldTemplate$2,
    ArrayFieldTitleTemplate,
    ButtonTemplates: buttonTemplates(),
    BaseInputTemplate,
    DescriptionFieldTemplate: DescriptionField,
    ErrorListTemplate: ErrorList,
    FieldTemplate: FieldTemplate$2,
    FieldErrorTemplate,
    FieldHelpTemplate,
    ObjectFieldTemplate: ObjectFieldTemplate$1,
    TitleFieldTemplate: TitleField$1,
    UnsupportedFieldTemplate: UnsupportedField,
    WrapIfAdditionalTemplate
  };
}
function rangeOptions(start2, stop) {
  const options = [];
  for (let i3 = start2; i3 <= stop; i3++) {
    options.push({ value: i3, label: pad(i3, 2) });
  }
  return options;
}
function readyForChange(state) {
  return Object.values(state).every((value) => value !== -1);
}
function DateElement({ type: type2, range: range2, value, select: select2, rootId, name: name2, disabled, readonly, autofocus, registry, onBlur, onFocus }) {
  const id2 = rootId + "_" + type2;
  const { SelectWidget: SelectWidget2 } = registry.widgets;
  return jsx$1(SelectWidget2, { schema: { type: "integer" }, id: id2, name: name2, className: "form-control", options: { enumOptions: rangeOptions(range2[0], range2[1]) }, placeholder: type2, value, disabled, readonly, autofocus, onChange: (value2) => select2(type2, value2), onBlur, onFocus, registry, label: "", "aria-describedby": ariaDescribedByIds(rootId) });
}
function AltDateWidget({ time: time2 = false, disabled = false, readonly = false, autofocus = false, options, id: id2, name: name2, registry, onBlur, onFocus, onChange, value }) {
  const { translateString } = registry;
  const [lastValue, setLastValue] = useState(value);
  const [state, setState] = useReducer((state2, action) => {
    return { ...state2, ...action };
  }, parseDateString(value, time2));
  useEffect(() => {
    const stateValue = toDateString(state, time2);
    if (readyForChange(state) && stateValue !== value) {
      onChange(stateValue);
    } else if (lastValue !== value) {
      setLastValue(value);
      setState(parseDateString(value, time2));
    }
  }, [time2, value, onChange, state, lastValue]);
  const handleChange = useCallback((property2, value2) => {
    setState({ [property2]: value2 });
  }, []);
  const handleSetNow = useCallback((event) => {
    event.preventDefault();
    if (disabled || readonly) {
      return;
    }
    const nextState = parseDateString((/* @__PURE__ */ new Date()).toJSON(), time2);
    onChange(toDateString(nextState, time2));
  }, [disabled, readonly, time2]);
  const handleClear = useCallback((event) => {
    event.preventDefault();
    if (disabled || readonly) {
      return;
    }
    onChange(void 0);
  }, [disabled, readonly, onChange]);
  return jsxs("ul", { className: "list-inline", children: [getDateElementProps(state, time2, options.yearsRange, options.format).map((elemProps, i3) => jsx$1("li", { className: "list-inline-item", children: jsx$1(DateElement, { rootId: id2, name: name2, select: handleChange, ...elemProps, disabled, readonly, registry, onBlur, onFocus, autofocus: autofocus && i3 === 0 }) }, i3)), (options.hideNowButton !== "undefined" ? !options.hideNowButton : true) && jsx$1("li", { className: "list-inline-item", children: jsx$1("a", { href: "#", className: "btn btn-info btn-now", onClick: handleSetNow, children: translateString(TranslatableString.NowLabel) }) }), (options.hideClearButton !== "undefined" ? !options.hideClearButton : true) && jsx$1("li", { className: "list-inline-item", children: jsx$1("a", { href: "#", className: "btn btn-warning btn-clear", onClick: handleClear, children: translateString(TranslatableString.ClearLabel) }) })] });
}
function AltDateTimeWidget({ time: time2 = true, ...props2 }) {
  const { AltDateWidget: AltDateWidget2 } = props2.registry.widgets;
  return jsx$1(AltDateWidget2, { time: time2, ...props2 });
}
function CheckboxWidget$3({ schema, uiSchema, options, id: id2, value, disabled, readonly, label, hideLabel, autofocus = false, onBlur, onFocus, onChange, registry }) {
  var _a2;
  const DescriptionFieldTemplate = getTemplate("DescriptionFieldTemplate", registry, options);
  const required2 = schemaRequiresTrueValue(schema);
  const handleChange = useCallback((event) => onChange(event.target.checked), [onChange]);
  const handleBlur = useCallback((event) => onBlur(id2, event.target.checked), [onBlur, id2]);
  const handleFocus = useCallback((event) => onFocus(id2, event.target.checked), [onFocus, id2]);
  const description2 = (_a2 = options.description) !== null && _a2 !== void 0 ? _a2 : schema.description;
  return jsxs("div", { className: `checkbox ${disabled || readonly ? "disabled" : ""}`, children: [!hideLabel && !!description2 && jsx$1(DescriptionFieldTemplate, { id: descriptionId(id2), description: description2, schema, uiSchema, registry }), jsxs("label", { children: [jsx$1("input", { type: "checkbox", id: id2, name: id2, checked: typeof value === "undefined" ? false : value, required: required2, disabled: disabled || readonly, autoFocus: autofocus, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, "aria-describedby": ariaDescribedByIds(id2) }), labelValue(jsx$1("span", { children: label }), hideLabel)] })] });
}
function CheckboxesWidget$4({ id: id2, disabled, options: { inline = false, enumOptions, enumDisabled, emptyValue }, value, autofocus = false, readonly, onChange, onBlur, onFocus }) {
  const checkboxesValues = Array.isArray(value) ? value : [value];
  const handleBlur = useCallback(({ target }) => onBlur(id2, enumOptionsValueForIndex(target && target.value, enumOptions, emptyValue)), [onBlur, id2]);
  const handleFocus = useCallback(({ target }) => onFocus(id2, enumOptionsValueForIndex(target && target.value, enumOptions, emptyValue)), [onFocus, id2]);
  return jsx$1("div", { className: "checkboxes", id: id2, children: Array.isArray(enumOptions) && enumOptions.map((option2, index2) => {
    const checked = enumOptionsIsSelected(option2.value, checkboxesValues);
    const itemDisabled = Array.isArray(enumDisabled) && enumDisabled.indexOf(option2.value) !== -1;
    const disabledCls = disabled || itemDisabled || readonly ? "disabled" : "";
    const handleChange = (event) => {
      if (event.target.checked) {
        onChange(enumOptionsSelectValue(index2, checkboxesValues, enumOptions));
      } else {
        onChange(enumOptionsDeselectValue(index2, checkboxesValues, enumOptions));
      }
    };
    const checkbox = jsxs("span", { children: [jsx$1("input", { type: "checkbox", id: optionId(id2, index2), name: id2, checked, value: String(index2), disabled: disabled || itemDisabled || readonly, autoFocus: autofocus && index2 === 0, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, "aria-describedby": ariaDescribedByIds(id2) }), jsx$1("span", { children: option2.label })] });
    return inline ? jsx$1("label", { className: `checkbox-inline ${disabledCls}`, children: checkbox }, index2) : jsx$1("div", { className: `checkbox ${disabledCls}`, children: jsx$1("label", { children: checkbox }) }, index2);
  }) });
}
function ColorWidget(props2) {
  const { disabled, readonly, options, registry } = props2;
  const BaseInputTemplate2 = getTemplate("BaseInputTemplate", registry, options);
  return jsx$1(BaseInputTemplate2, { type: "color", ...props2, disabled: disabled || readonly });
}
function DateWidget$1(props2) {
  const { onChange, options, registry } = props2;
  const BaseInputTemplate2 = getTemplate("BaseInputTemplate", registry, options);
  const handleChange = useCallback((value) => onChange(value || void 0), [onChange]);
  return jsx$1(BaseInputTemplate2, { type: "date", ...props2, onChange: handleChange });
}
function DateTimeWidget(props2) {
  const { onChange, value, options, registry } = props2;
  const BaseInputTemplate2 = getTemplate("BaseInputTemplate", registry, options);
  return jsx$1(BaseInputTemplate2, { type: "datetime-local", ...props2, value: utcToLocal(value), onChange: (value2) => onChange(localToUTC(value2)) });
}
function EmailWidget(props2) {
  const { options, registry } = props2;
  const BaseInputTemplate2 = getTemplate("BaseInputTemplate", registry, options);
  return jsx$1(BaseInputTemplate2, { type: "email", ...props2 });
}
function addNameToDataURL(dataURL, name2) {
  if (dataURL === null) {
    return null;
  }
  return dataURL.replace(";base64", `;name=${encodeURIComponent(name2)};base64`);
}
function processFile(file) {
  const { name: name2, size: size2, type: type2 } = file;
  return new Promise((resolve3, reject) => {
    const reader = new window.FileReader();
    reader.onerror = reject;
    reader.onload = (event) => {
      var _a2;
      if (typeof ((_a2 = event.target) === null || _a2 === void 0 ? void 0 : _a2.result) === "string") {
        resolve3({
          dataURL: addNameToDataURL(event.target.result, name2),
          name: name2,
          size: size2,
          type: type2
        });
      } else {
        resolve3({
          dataURL: null,
          name: name2,
          size: size2,
          type: type2
        });
      }
    };
    reader.readAsDataURL(file);
  });
}
function processFiles(files) {
  return Promise.all(Array.from(files).map(processFile));
}
function FileInfoPreview({ fileInfo, registry }) {
  const { translateString } = registry;
  const { dataURL, type: type2, name: name2 } = fileInfo;
  if (!dataURL) {
    return null;
  }
  if (["image/jpeg", "image/png"].includes(type2)) {
    return jsx$1("img", { src: dataURL, style: { maxWidth: "100%" }, className: "file-preview" });
  }
  return jsxs(Fragment$1, { children: [" ", jsx$1("a", { download: `preview-${name2}`, href: dataURL, className: "file-download", children: translateString(TranslatableString.PreviewLabel) })] });
}
function FilesInfo({ filesInfo, registry, preview, onRemove, options }) {
  if (filesInfo.length === 0) {
    return null;
  }
  const { translateString } = registry;
  const { RemoveButton: RemoveButton2 } = getTemplate("ButtonTemplates", registry, options);
  return jsx$1("ul", { className: "file-info", children: filesInfo.map((fileInfo, key2) => {
    const { name: name2, size: size2, type: type2 } = fileInfo;
    const handleRemove = () => onRemove(key2);
    return jsxs("li", { children: [jsx$1(Markdown$1, { children: translateString(TranslatableString.FilesInfo, [name2, type2, String(size2)]) }), preview && jsx$1(FileInfoPreview, { fileInfo, registry }), jsx$1(RemoveButton2, { onClick: handleRemove, registry })] }, key2);
  }) });
}
function extractFileInfo(dataURLs) {
  return dataURLs.reduce((acc, dataURL) => {
    if (!dataURL) {
      return acc;
    }
    try {
      const { blob, name: name2 } = dataURItoBlob(dataURL);
      return [
        ...acc,
        {
          dataURL,
          name: name2,
          size: blob.size,
          type: blob.type
        }
      ];
    } catch (e5) {
      return acc;
    }
  }, []);
}
function FileWidget(props2) {
  const { disabled, readonly, required: required2, multiple, onChange, value, options, registry } = props2;
  const BaseInputTemplate2 = getTemplate("BaseInputTemplate", registry, options);
  const handleChange = useCallback((event) => {
    if (!event.target.files) {
      return;
    }
    processFiles(event.target.files).then((filesInfoEvent) => {
      const newValue = filesInfoEvent.map((fileInfo) => fileInfo.dataURL);
      if (multiple) {
        onChange(value.concat(newValue[0]));
      } else {
        onChange(newValue[0]);
      }
    });
  }, [multiple, value, onChange]);
  const filesInfo = useMemo(() => extractFileInfo(Array.isArray(value) ? value : [value]), [value]);
  const rmFile = useCallback((index2) => {
    if (multiple) {
      const newValue = value.filter((_2, i3) => i3 !== index2);
      onChange(newValue);
    } else {
      onChange(void 0);
    }
  }, [multiple, value, onChange]);
  return jsxs("div", { children: [jsx$1(BaseInputTemplate2, { ...props2, disabled: disabled || readonly, type: "file", required: value ? false : required2, onChangeOverride: handleChange, value: "", accept: options.accept ? String(options.accept) : void 0 }), jsx$1(FilesInfo, { filesInfo, onRemove: rmFile, registry, preview: options.filePreview, options })] });
}
function HiddenWidget({ id: id2, value }) {
  return jsx$1("input", { type: "hidden", id: id2, name: id2, value: typeof value === "undefined" ? "" : value });
}
function PasswordWidget(props2) {
  const { options, registry } = props2;
  const BaseInputTemplate2 = getTemplate("BaseInputTemplate", registry, options);
  return jsx$1(BaseInputTemplate2, { type: "password", ...props2 });
}
function RadioWidget({ options, value, required: required2, disabled, readonly, autofocus = false, onBlur, onFocus, onChange, id: id2 }) {
  const { enumOptions, enumDisabled, inline, emptyValue } = options;
  const handleBlur = useCallback(({ target }) => onBlur(id2, enumOptionsValueForIndex(target && target.value, enumOptions, emptyValue)), [onBlur, id2]);
  const handleFocus = useCallback(({ target }) => onFocus(id2, enumOptionsValueForIndex(target && target.value, enumOptions, emptyValue)), [onFocus, id2]);
  return jsx$1("div", { className: "field-radio-group", id: id2, children: Array.isArray(enumOptions) && enumOptions.map((option2, i3) => {
    const checked = enumOptionsIsSelected(option2.value, value);
    const itemDisabled = Array.isArray(enumDisabled) && enumDisabled.indexOf(option2.value) !== -1;
    const disabledCls = disabled || itemDisabled || readonly ? "disabled" : "";
    const handleChange = () => onChange(option2.value);
    const radio = jsxs("span", { children: [jsx$1("input", { type: "radio", id: optionId(id2, i3), checked, name: id2, required: required2, value: String(i3), disabled: disabled || itemDisabled || readonly, autoFocus: autofocus && i3 === 0, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, "aria-describedby": ariaDescribedByIds(id2) }), jsx$1("span", { children: option2.label })] });
    return inline ? jsx$1("label", { className: `radio-inline ${disabledCls}`, children: radio }, i3) : jsx$1("div", { className: `radio ${disabledCls}`, children: jsx$1("label", { children: radio }) }, i3);
  }) });
}
function RangeWidget(props2) {
  const { value, registry: { templates: { BaseInputTemplate: BaseInputTemplate2 } } } = props2;
  return jsxs("div", { className: "field-range-wrapper", children: [jsx$1(BaseInputTemplate2, { type: "range", ...props2 }), jsx$1("span", { className: "range-view", children: value })] });
}
function getValue(event, multiple) {
  if (multiple) {
    return Array.from(event.target.options).slice().filter((o2) => o2.selected).map((o2) => o2.value);
  }
  return event.target.value;
}
function SelectWidget({ schema, id: id2, options, value, required: required2, disabled, readonly, multiple = false, autofocus = false, onChange, onBlur, onFocus, placeholder }) {
  const { enumOptions, enumDisabled, emptyValue: optEmptyVal } = options;
  const emptyValue = multiple ? [] : "";
  const handleFocus = useCallback((event) => {
    const newValue = getValue(event, multiple);
    return onFocus(id2, enumOptionsValueForIndex(newValue, enumOptions, optEmptyVal));
  }, [onFocus, id2, schema, multiple, options]);
  const handleBlur = useCallback((event) => {
    const newValue = getValue(event, multiple);
    return onBlur(id2, enumOptionsValueForIndex(newValue, enumOptions, optEmptyVal));
  }, [onBlur, id2, schema, multiple, options]);
  const handleChange = useCallback((event) => {
    const newValue = getValue(event, multiple);
    return onChange(enumOptionsValueForIndex(newValue, enumOptions, optEmptyVal));
  }, [onChange, schema, multiple, options]);
  const selectedIndexes = enumOptionsIndexForValue(value, enumOptions, multiple);
  return jsxs("select", { id: id2, name: id2, multiple, className: "form-control", value: typeof selectedIndexes === "undefined" ? emptyValue : selectedIndexes, required: required2, disabled: disabled || readonly, autoFocus: autofocus, onBlur: handleBlur, onFocus: handleFocus, onChange: handleChange, "aria-describedby": ariaDescribedByIds(id2), children: [!multiple && schema.default === void 0 && jsx$1("option", { value: "", children: placeholder }), Array.isArray(enumOptions) && enumOptions.map(({ value: value2, label }, i3) => {
    const disabled2 = enumDisabled && enumDisabled.indexOf(value2) !== -1;
    return jsx$1("option", { value: String(i3), disabled: disabled2, children: label }, i3);
  })] });
}
function TextareaWidget({ id: id2, options = {}, placeholder, value, required: required2, disabled, readonly, autofocus = false, onChange, onBlur, onFocus }) {
  const handleChange = useCallback(({ target: { value: value2 } }) => onChange(value2 === "" ? options.emptyValue : value2), [onChange, options.emptyValue]);
  const handleBlur = useCallback(({ target }) => onBlur(id2, target && target.value), [onBlur, id2]);
  const handleFocus = useCallback(({ target }) => onFocus(id2, target && target.value), [id2, onFocus]);
  return jsx$1("textarea", { id: id2, name: id2, className: "form-control", value: value ? value : "", placeholder, required: required2, disabled, readOnly: readonly, autoFocus: autofocus, rows: options.rows, onBlur: handleBlur, onFocus: handleFocus, onChange: handleChange, "aria-describedby": ariaDescribedByIds(id2) });
}
TextareaWidget.defaultProps = {
  autofocus: false,
  options: {}
};
function TextWidget$2(props2) {
  const { options, registry } = props2;
  const BaseInputTemplate2 = getTemplate("BaseInputTemplate", registry, options);
  return jsx$1(BaseInputTemplate2, { ...props2 });
}
function TimeWidget(props2) {
  const { onChange, options, registry } = props2;
  const BaseInputTemplate2 = getTemplate("BaseInputTemplate", registry, options);
  const handleChange = useCallback((value) => onChange(value ? `${value}:00` : void 0), [onChange]);
  return jsx$1(BaseInputTemplate2, { type: "time", ...props2, onChange: handleChange });
}
function URLWidget(props2) {
  const { options, registry } = props2;
  const BaseInputTemplate2 = getTemplate("BaseInputTemplate", registry, options);
  return jsx$1(BaseInputTemplate2, { type: "url", ...props2 });
}
function UpDownWidget(props2) {
  const { options, registry } = props2;
  const BaseInputTemplate2 = getTemplate("BaseInputTemplate", registry, options);
  return jsx$1(BaseInputTemplate2, { type: "number", ...props2 });
}
function widgets$2() {
  return {
    AltDateWidget,
    AltDateTimeWidget,
    CheckboxWidget: CheckboxWidget$3,
    CheckboxesWidget: CheckboxesWidget$4,
    ColorWidget,
    DateWidget: DateWidget$1,
    DateTimeWidget,
    EmailWidget,
    FileWidget,
    HiddenWidget,
    PasswordWidget,
    RadioWidget,
    RangeWidget,
    SelectWidget,
    TextWidget: TextWidget$2,
    TextareaWidget,
    TimeWidget,
    UpDownWidget,
    URLWidget
  };
}
function getDefaultRegistry() {
  return {
    fields: fields$2(),
    templates: templates(),
    widgets: widgets$2(),
    rootSchema: {},
    formContext: {},
    translateString: englishStringTranslator
  };
}
class Form extends Component {
  /** Constructs the `Form` from the `props`. Will setup the initial state from the props. It will also call the
   * `onChange` handler if the initially provided `formData` is modified to add missing default values as part of the
   * state construction.
   *
   * @param props - The initial props for the `Form`
   */
  constructor(props2) {
    super(props2);
    this.getUsedFormData = (formData, fields2) => {
      if (fields2.length === 0 && typeof formData !== "object") {
        return formData;
      }
      const data = _pick(formData, fields2);
      if (Array.isArray(formData)) {
        return Object.keys(data).map((key2) => data[key2]);
      }
      return data;
    };
    this.getFieldNames = (pathSchema, formData) => {
      const getAllPaths = (_obj, acc = [], paths = [[]]) => {
        Object.keys(_obj).forEach((key2) => {
          if (typeof _obj[key2] === "object") {
            const newPaths = paths.map((path3) => [...path3, key2]);
            if (_obj[key2][RJSF_ADDITIONAL_PROPERTIES_FLAG] && _obj[key2][NAME_KEY] !== "") {
              acc.push(_obj[key2][NAME_KEY]);
            } else {
              getAllPaths(_obj[key2], acc, newPaths);
            }
          } else if (key2 === NAME_KEY && _obj[key2] !== "") {
            paths.forEach((path3) => {
              const formValue = get$6(formData, path3);
              if (typeof formValue !== "object" || _isEmpty(formValue) || Array.isArray(formValue) && formValue.every((val) => typeof val !== "object")) {
                acc.push(path3);
              }
            });
          }
        });
        return acc;
      };
      return getAllPaths(pathSchema);
    };
    this.onChange = (formData, newErrorSchema, id2) => {
      const { extraErrors, omitExtraData, liveOmit, noValidate, liveValidate, onChange } = this.props;
      const { schemaUtils, schema, retrievedSchema } = this.state;
      if (isObject$d(formData) || Array.isArray(formData)) {
        const newState = this.getStateFromProps(this.props, formData, retrievedSchema);
        formData = newState.formData;
      }
      const mustValidate = !noValidate && liveValidate;
      let state = { formData, schema };
      let newFormData = formData;
      let _retrievedSchema;
      if (omitExtraData === true && liveOmit === true) {
        _retrievedSchema = schemaUtils.retrieveSchema(schema, formData);
        const pathSchema = schemaUtils.toPathSchema(_retrievedSchema, "", formData);
        const fieldNames = this.getFieldNames(pathSchema, formData);
        newFormData = this.getUsedFormData(formData, fieldNames);
        state = {
          formData: newFormData
        };
      }
      if (mustValidate) {
        const schemaValidation = this.validate(newFormData, schema, schemaUtils, retrievedSchema);
        let errors2 = schemaValidation.errors;
        let errorSchema = schemaValidation.errorSchema;
        const schemaValidationErrors = errors2;
        const schemaValidationErrorSchema = errorSchema;
        if (extraErrors) {
          const merged = validationDataMerge(schemaValidation, extraErrors);
          errorSchema = merged.errorSchema;
          errors2 = merged.errors;
        }
        state = {
          formData: newFormData,
          errors: errors2,
          errorSchema,
          schemaValidationErrors,
          schemaValidationErrorSchema
        };
      } else if (!noValidate && newErrorSchema) {
        const errorSchema = extraErrors ? mergeObjects(newErrorSchema, extraErrors, "preventDuplicates") : newErrorSchema;
        state = {
          formData: newFormData,
          errorSchema,
          errors: toErrorList(errorSchema)
        };
      }
      if (_retrievedSchema) {
        state.retrievedSchema = _retrievedSchema;
      }
      this.setState(state, () => onChange && onChange({ ...this.state, ...state }, id2));
    };
    this.reset = () => {
      const { onChange } = this.props;
      const newState = this.getStateFromProps(this.props, void 0);
      const newFormData = newState.formData;
      const state = {
        formData: newFormData,
        errorSchema: {},
        errors: [],
        schemaValidationErrors: [],
        schemaValidationErrorSchema: {}
      };
      this.setState(state, () => onChange && onChange({ ...this.state, ...state }));
    };
    this.onBlur = (id2, data) => {
      const { onBlur } = this.props;
      if (onBlur) {
        onBlur(id2, data);
      }
    };
    this.onFocus = (id2, data) => {
      const { onFocus } = this.props;
      if (onFocus) {
        onFocus(id2, data);
      }
    };
    this.onSubmit = (event) => {
      event.preventDefault();
      if (event.target !== event.currentTarget) {
        return;
      }
      event.persist();
      const { omitExtraData, extraErrors, noValidate, onSubmit } = this.props;
      let { formData: newFormData } = this.state;
      const { schema, schemaUtils } = this.state;
      if (omitExtraData === true) {
        const retrievedSchema = schemaUtils.retrieveSchema(schema, newFormData);
        const pathSchema = schemaUtils.toPathSchema(retrievedSchema, "", newFormData);
        const fieldNames = this.getFieldNames(pathSchema, newFormData);
        newFormData = this.getUsedFormData(newFormData, fieldNames);
      }
      if (noValidate || this.validateForm()) {
        const errorSchema = extraErrors || {};
        const errors2 = extraErrors ? toErrorList(extraErrors) : [];
        this.setState({
          formData: newFormData,
          errors: errors2,
          errorSchema,
          schemaValidationErrors: [],
          schemaValidationErrorSchema: {}
        }, () => {
          if (onSubmit) {
            onSubmit({ ...this.state, formData: newFormData, status: "submitted" }, event);
          }
        });
      }
    };
    this.submit = () => {
      if (this.formElement.current) {
        const submitCustomEvent = new CustomEvent("submit", {
          cancelable: true
        });
        submitCustomEvent.preventDefault();
        this.formElement.current.dispatchEvent(submitCustomEvent);
        this.formElement.current.requestSubmit();
      }
    };
    if (!props2.validator) {
      throw new Error("A validator is required for Form functionality to work");
    }
    this.state = this.getStateFromProps(props2, props2.formData);
    if (this.props.onChange && !deepEquals(this.state.formData, this.props.formData)) {
      this.props.onChange(this.state);
    }
    this.formElement = createRef();
  }
  /**
   * `getSnapshotBeforeUpdate` is a React lifecycle method that is invoked right before the most recently rendered
   * output is committed to the DOM. It enables your component to capture current values (e.g., scroll position) before
   * they are potentially changed.
   *
   * In this case, it checks if the props have changed since the last render. If they have, it computes the next state
   * of the component using `getStateFromProps` method and returns it along with a `shouldUpdate` flag set to `true` IF
   * the `nextState` and `prevState` are different, otherwise `false`. This ensures that we have the most up-to-date
   * state ready to be applied in `componentDidUpdate`.
   *
   * If `formData` hasn't changed, it simply returns an object with `shouldUpdate` set to `false`, indicating that a
   * state update is not necessary.
   *
   * @param prevProps - The previous set of props before the update.
   * @param prevState - The previous state before the update.
   * @returns Either an object containing the next state and a flag indicating that an update should occur, or an object
   *        with a flag indicating that an update is not necessary.
   */
  getSnapshotBeforeUpdate(prevProps, prevState) {
    if (!deepEquals(this.props, prevProps)) {
      const isSchemaChanged = !deepEquals(prevProps.schema, this.props.schema);
      const isFormDataChanged = !deepEquals(prevProps.formData, this.props.formData);
      const nextState = this.getStateFromProps(
        this.props,
        this.props.formData,
        // If the `schema` has changed, we need to update the retrieved schema.
        // Or if the `formData` changes, for example in the case of a schema with dependencies that need to
        //  match one of the subSchemas, the retrieved schema must be updated.
        isSchemaChanged || isFormDataChanged ? void 0 : this.state.retrievedSchema,
        isSchemaChanged
      );
      const shouldUpdate3 = !deepEquals(nextState, prevState);
      return { nextState, shouldUpdate: shouldUpdate3 };
    }
    return { shouldUpdate: false };
  }
  /**
   * `componentDidUpdate` is a React lifecycle method that is invoked immediately after updating occurs. This method is
   * not called for the initial render.
   *
   * Here, it checks if an update is necessary based on the `shouldUpdate` flag received from `getSnapshotBeforeUpdate`.
   * If an update is required, it applies the next state and, if needed, triggers the `onChange` handler to inform about
   * changes.
   *
   * This method effectively replaces the deprecated `UNSAFE_componentWillReceiveProps`, providing a safer alternative
   * to handle prop changes and state updates.
   *
   * @param _ - The previous set of props.
   * @param prevState - The previous state of the component before the update.
   * @param snapshot - The value returned from `getSnapshotBeforeUpdate`.
   */
  componentDidUpdate(_2, prevState, snapshot) {
    if (snapshot.shouldUpdate) {
      const { nextState } = snapshot;
      if (!deepEquals(nextState.formData, this.props.formData) && !deepEquals(nextState.formData, prevState.formData) && this.props.onChange) {
        this.props.onChange(nextState);
      }
      this.setState(nextState);
    }
  }
  /** Extracts the updated state from the given `props` and `inputFormData`. As part of this process, the
   * `inputFormData` is first processed to add any missing required defaults. After that, the data is run through the
   * validation process IF required by the `props`.
   *
   * @param props - The props passed to the `Form`
   * @param inputFormData - The new or current data for the `Form`
   * @param retrievedSchema - An expanded schema, if not provided, it will be retrieved from the `schema` and `formData`.
   * @param isSchemaChanged - A flag indicating whether the schema has changed.
   * @returns - The new state for the `Form`
   */
  getStateFromProps(props2, inputFormData, retrievedSchema, isSchemaChanged = false) {
    const state = this.state || {};
    const schema = "schema" in props2 ? props2.schema : this.props.schema;
    const uiSchema = ("uiSchema" in props2 ? props2.uiSchema : this.props.uiSchema) || {};
    const edit = typeof inputFormData !== "undefined";
    const liveValidate = "liveValidate" in props2 ? props2.liveValidate : this.props.liveValidate;
    const mustValidate = edit && !props2.noValidate && liveValidate;
    const rootSchema = schema;
    const experimental_defaultFormStateBehavior = "experimental_defaultFormStateBehavior" in props2 ? props2.experimental_defaultFormStateBehavior : this.props.experimental_defaultFormStateBehavior;
    let schemaUtils = state.schemaUtils;
    if (!schemaUtils || schemaUtils.doesSchemaUtilsDiffer(props2.validator, rootSchema, experimental_defaultFormStateBehavior)) {
      schemaUtils = createSchemaUtils(props2.validator, rootSchema, experimental_defaultFormStateBehavior);
    }
    const formData = schemaUtils.getDefaultFormState(schema, inputFormData);
    const _retrievedSchema = retrievedSchema !== null && retrievedSchema !== void 0 ? retrievedSchema : schemaUtils.retrieveSchema(schema, formData);
    const getCurrentErrors = () => {
      if (props2.noValidate || isSchemaChanged) {
        return { errors: [], errorSchema: {} };
      } else if (!props2.liveValidate) {
        return {
          errors: state.schemaValidationErrors || [],
          errorSchema: state.schemaValidationErrorSchema || {}
        };
      }
      return {
        errors: state.errors || [],
        errorSchema: state.errorSchema || {}
      };
    };
    let errors2;
    let errorSchema;
    let schemaValidationErrors = state.schemaValidationErrors;
    let schemaValidationErrorSchema = state.schemaValidationErrorSchema;
    if (mustValidate) {
      const schemaValidation = this.validate(formData, schema, schemaUtils, _retrievedSchema);
      errors2 = schemaValidation.errors;
      errorSchema = schemaValidation.errorSchema;
      schemaValidationErrors = errors2;
      schemaValidationErrorSchema = errorSchema;
    } else {
      const currentErrors = getCurrentErrors();
      errors2 = currentErrors.errors;
      errorSchema = currentErrors.errorSchema;
    }
    if (props2.extraErrors) {
      const merged = validationDataMerge({ errorSchema, errors: errors2 }, props2.extraErrors);
      errorSchema = merged.errorSchema;
      errors2 = merged.errors;
    }
    const idSchema = schemaUtils.toIdSchema(_retrievedSchema, uiSchema["ui:rootFieldId"], formData, props2.idPrefix, props2.idSeparator);
    const nextState = {
      schemaUtils,
      schema,
      uiSchema,
      idSchema,
      formData,
      edit,
      errors: errors2,
      errorSchema,
      schemaValidationErrors,
      schemaValidationErrorSchema,
      retrievedSchema: _retrievedSchema
    };
    return nextState;
  }
  /** React lifecycle method that is used to determine whether component should be updated.
   *
   * @param nextProps - The next version of the props
   * @param nextState - The next version of the state
   * @returns - True if the component should be updated, false otherwise
   */
  shouldComponentUpdate(nextProps, nextState) {
    return shouldRender(this, nextProps, nextState);
  }
  /** Validates the `formData` against the `schema` using the `altSchemaUtils` (if provided otherwise it uses the
   * `schemaUtils` in the state), returning the results.
   *
   * @param formData - The new form data to validate
   * @param schema - The schema used to validate against
   * @param altSchemaUtils - The alternate schemaUtils to use for validation
   */
  validate(formData, schema = this.props.schema, altSchemaUtils, retrievedSchema) {
    const schemaUtils = altSchemaUtils ? altSchemaUtils : this.state.schemaUtils;
    const { customValidate, transformErrors, uiSchema } = this.props;
    const resolvedSchema = retrievedSchema !== null && retrievedSchema !== void 0 ? retrievedSchema : schemaUtils.retrieveSchema(schema, formData);
    return schemaUtils.getValidator().validateFormData(formData, resolvedSchema, customValidate, transformErrors, uiSchema);
  }
  /** Renders any errors contained in the `state` in using the `ErrorList`, if not disabled by `showErrorList`. */
  renderErrors(registry) {
    const { errors: errors2, errorSchema, schema, uiSchema } = this.state;
    const { formContext } = this.props;
    const options = getUiOptions(uiSchema);
    const ErrorListTemplate = getTemplate("ErrorListTemplate", registry, options);
    if (errors2 && errors2.length) {
      return jsx$1(ErrorListTemplate, { errors: errors2, errorSchema: errorSchema || {}, schema, uiSchema, formContext, registry });
    }
    return null;
  }
  /** Returns the registry for the form */
  getRegistry() {
    var _a2;
    const { translateString: customTranslateString, uiSchema = {} } = this.props;
    const { schemaUtils } = this.state;
    const { fields: fields2, templates: templates2, widgets: widgets2, formContext, translateString } = getDefaultRegistry();
    return {
      fields: { ...fields2, ...this.props.fields },
      templates: {
        ...templates2,
        ...this.props.templates,
        ButtonTemplates: {
          ...templates2.ButtonTemplates,
          ...(_a2 = this.props.templates) === null || _a2 === void 0 ? void 0 : _a2.ButtonTemplates
        }
      },
      widgets: { ...widgets2, ...this.props.widgets },
      rootSchema: this.props.schema,
      formContext: this.props.formContext || formContext,
      schemaUtils,
      translateString: customTranslateString || translateString,
      globalUiOptions: uiSchema[UI_GLOBAL_OPTIONS_KEY]
    };
  }
  /** Attempts to focus on the field associated with the `error`. Uses the `property` field to compute path of the error
   * field, then, using the `idPrefix` and `idSeparator` converts that path into an id. Then the input element with that
   * id is attempted to be found using the `formElement` ref. If it is located, then it is focused.
   *
   * @param error - The error on which to focus
   */
  focusOnError(error2) {
    const { idPrefix = "root", idSeparator = "_" } = this.props;
    const { property: property2 } = error2;
    const path3 = _toPath(property2);
    if (path3[0] === "") {
      path3[0] = idPrefix;
    } else {
      path3.unshift(idPrefix);
    }
    const elementId = path3.join(idSeparator);
    let field = this.formElement.current.elements[elementId];
    if (!field) {
      field = this.formElement.current.querySelector(`input[id^=${elementId}`);
    }
    if (field && field.length) {
      field = field[0];
    }
    if (field) {
      field.focus();
    }
  }
  /** Programmatically validate the form. If `onError` is provided, then it will be called with the list of errors the
   * same way as would happen on form submission.
   *
   * @returns - True if the form is valid, false otherwise.
   */
  validateForm() {
    const { extraErrors, extraErrorsBlockSubmit, focusOnFirstError, onError } = this.props;
    const { formData, errors: prevErrors } = this.state;
    const schemaValidation = this.validate(formData);
    let errors2 = schemaValidation.errors;
    let errorSchema = schemaValidation.errorSchema;
    const schemaValidationErrors = errors2;
    const schemaValidationErrorSchema = errorSchema;
    const hasError = errors2.length > 0 || extraErrors && extraErrorsBlockSubmit;
    if (hasError) {
      if (extraErrors) {
        const merged = validationDataMerge(schemaValidation, extraErrors);
        errorSchema = merged.errorSchema;
        errors2 = merged.errors;
      }
      if (focusOnFirstError) {
        if (typeof focusOnFirstError === "function") {
          focusOnFirstError(errors2[0]);
        } else {
          this.focusOnError(errors2[0]);
        }
      }
      this.setState({
        errors: errors2,
        errorSchema,
        schemaValidationErrors,
        schemaValidationErrorSchema
      }, () => {
        if (onError) {
          onError(errors2);
        } else {
          console.error("Form validation failed", errors2);
        }
      });
    } else if (prevErrors.length > 0) {
      this.setState({
        errors: [],
        errorSchema: {},
        schemaValidationErrors: [],
        schemaValidationErrorSchema: {}
      });
    }
    return !hasError;
  }
  /** Renders the `Form` fields inside the <form> | `tagName` or `_internalFormWrapper`, rendering any errors if
   * needed along with the submit button or any children of the form.
   */
  render() {
    const { children, id: id2, idPrefix, idSeparator, className = "", tagName, name: name2, method, target, action, autoComplete, enctype, acceptcharset, acceptCharset, noHtml5Validate = false, disabled, readonly, formContext, showErrorList = "top", _internalFormWrapper } = this.props;
    const { schema, uiSchema, formData, errorSchema, idSchema } = this.state;
    const registry = this.getRegistry();
    const { SchemaField: _SchemaField } = registry.fields;
    const { SubmitButton: SubmitButton2 } = registry.templates.ButtonTemplates;
    const as2 = _internalFormWrapper ? tagName : void 0;
    const FormTag = _internalFormWrapper || tagName || "form";
    let { [SUBMIT_BTN_OPTIONS_KEY]: submitOptions = {} } = getUiOptions(uiSchema);
    if (disabled) {
      submitOptions = { ...submitOptions, props: { ...submitOptions.props, disabled: true } };
    }
    const submitUiSchema = { [UI_OPTIONS_KEY]: { [SUBMIT_BTN_OPTIONS_KEY]: submitOptions } };
    return jsxs(FormTag, { className: className ? className : "rjsf", id: id2, name: name2, method, target, action, autoComplete, encType: enctype, acceptCharset: acceptCharset || acceptcharset, noValidate: noHtml5Validate, onSubmit: this.onSubmit, as: as2, ref: this.formElement, children: [showErrorList === "top" && this.renderErrors(registry), jsx$1(_SchemaField, { name: "", schema, uiSchema, errorSchema, idSchema, idPrefix, idSeparator, formContext, formData, onChange: this.onChange, onBlur: this.onBlur, onFocus: this.onFocus, registry, disabled, readonly }), children ? children : jsx$1(SubmitButton2, { uiSchema: submitUiSchema, registry }), showErrorList === "bottom" && this.renderErrors(registry)] });
  }
}
var ajv = { exports: {} };
var core$3 = {};
var validate$1 = {};
var boolSchema = {};
var errors = {};
var codegen = {};
var code$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.regexpCode = exports.getEsmExportName = exports.getProperty = exports.safeStringify = exports.stringify = exports.strConcat = exports.addCodeArg = exports.str = exports._ = exports.nil = exports._Code = exports.Name = exports.IDENTIFIER = exports._CodeOrName = void 0;
  class _CodeOrName {
  }
  exports._CodeOrName = _CodeOrName;
  exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
  class Name extends _CodeOrName {
    constructor(s4) {
      super();
      if (!exports.IDENTIFIER.test(s4))
        throw new Error("CodeGen: name must be a valid identifier");
      this.str = s4;
    }
    toString() {
      return this.str;
    }
    emptyStr() {
      return false;
    }
    get names() {
      return { [this.str]: 1 };
    }
  }
  exports.Name = Name;
  class _Code extends _CodeOrName {
    constructor(code2) {
      super();
      this._items = typeof code2 === "string" ? [code2] : code2;
    }
    toString() {
      return this.str;
    }
    emptyStr() {
      if (this._items.length > 1)
        return false;
      const item = this._items[0];
      return item === "" || item === '""';
    }
    get str() {
      var _a2;
      return (_a2 = this._str) !== null && _a2 !== void 0 ? _a2 : this._str = this._items.reduce((s4, c3) => `${s4}${c3}`, "");
    }
    get names() {
      var _a2;
      return (_a2 = this._names) !== null && _a2 !== void 0 ? _a2 : this._names = this._items.reduce((names2, c3) => {
        if (c3 instanceof Name)
          names2[c3.str] = (names2[c3.str] || 0) + 1;
        return names2;
      }, {});
    }
  }
  exports._Code = _Code;
  exports.nil = new _Code("");
  function _2(strs, ...args) {
    const code2 = [strs[0]];
    let i3 = 0;
    while (i3 < args.length) {
      addCodeArg(code2, args[i3]);
      code2.push(strs[++i3]);
    }
    return new _Code(code2);
  }
  exports._ = _2;
  const plus = new _Code("+");
  function str(strs, ...args) {
    const expr = [safeStringify(strs[0])];
    let i3 = 0;
    while (i3 < args.length) {
      expr.push(plus);
      addCodeArg(expr, args[i3]);
      expr.push(plus, safeStringify(strs[++i3]));
    }
    optimize(expr);
    return new _Code(expr);
  }
  exports.str = str;
  function addCodeArg(code2, arg) {
    if (arg instanceof _Code)
      code2.push(...arg._items);
    else if (arg instanceof Name)
      code2.push(arg);
    else
      code2.push(interpolate(arg));
  }
  exports.addCodeArg = addCodeArg;
  function optimize(expr) {
    let i3 = 1;
    while (i3 < expr.length - 1) {
      if (expr[i3] === plus) {
        const res = mergeExprItems(expr[i3 - 1], expr[i3 + 1]);
        if (res !== void 0) {
          expr.splice(i3 - 1, 3, res);
          continue;
        }
        expr[i3++] = "+";
      }
      i3++;
    }
  }
  function mergeExprItems(a4, b3) {
    if (b3 === '""')
      return a4;
    if (a4 === '""')
      return b3;
    if (typeof a4 == "string") {
      if (b3 instanceof Name || a4[a4.length - 1] !== '"')
        return;
      if (typeof b3 != "string")
        return `${a4.slice(0, -1)}${b3}"`;
      if (b3[0] === '"')
        return a4.slice(0, -1) + b3.slice(1);
      return;
    }
    if (typeof b3 == "string" && b3[0] === '"' && !(a4 instanceof Name))
      return `"${a4}${b3.slice(1)}`;
    return;
  }
  function strConcat(c1, c22) {
    return c22.emptyStr() ? c1 : c1.emptyStr() ? c22 : str`${c1}${c22}`;
  }
  exports.strConcat = strConcat;
  function interpolate(x3) {
    return typeof x3 == "number" || typeof x3 == "boolean" || x3 === null ? x3 : safeStringify(Array.isArray(x3) ? x3.join(",") : x3);
  }
  function stringify3(x3) {
    return new _Code(safeStringify(x3));
  }
  exports.stringify = stringify3;
  function safeStringify(x3) {
    return JSON.stringify(x3).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
  }
  exports.safeStringify = safeStringify;
  function getProperty3(key2) {
    return typeof key2 == "string" && exports.IDENTIFIER.test(key2) ? new _Code(`.${key2}`) : _2`[${key2}]`;
  }
  exports.getProperty = getProperty3;
  function getEsmExportName(key2) {
    if (typeof key2 == "string" && exports.IDENTIFIER.test(key2)) {
      return new _Code(`${key2}`);
    }
    throw new Error(`CodeGen: invalid export name: ${key2}, use explicit $id name mapping`);
  }
  exports.getEsmExportName = getEsmExportName;
  function regexpCode(rx) {
    return new _Code(rx.toString());
  }
  exports.regexpCode = regexpCode;
})(code$1);
var scope = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.ValueScope = exports.ValueScopeName = exports.Scope = exports.varKinds = exports.UsedValueState = void 0;
  const code_12 = code$1;
  class ValueError extends Error {
    constructor(name2) {
      super(`CodeGen: "code" for ${name2} not defined`);
      this.value = name2.value;
    }
  }
  var UsedValueState;
  (function(UsedValueState2) {
    UsedValueState2[UsedValueState2["Started"] = 0] = "Started";
    UsedValueState2[UsedValueState2["Completed"] = 1] = "Completed";
  })(UsedValueState || (exports.UsedValueState = UsedValueState = {}));
  exports.varKinds = {
    const: new code_12.Name("const"),
    let: new code_12.Name("let"),
    var: new code_12.Name("var")
  };
  class Scope {
    constructor({ prefixes, parent: parent3 } = {}) {
      this._names = {};
      this._prefixes = prefixes;
      this._parent = parent3;
    }
    toName(nameOrPrefix) {
      return nameOrPrefix instanceof code_12.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix2) {
      return new code_12.Name(this._newName(prefix2));
    }
    _newName(prefix2) {
      const ng = this._names[prefix2] || this._nameGroup(prefix2);
      return `${prefix2}${ng.index++}`;
    }
    _nameGroup(prefix2) {
      var _a2, _b2;
      if (((_b2 = (_a2 = this._parent) === null || _a2 === void 0 ? void 0 : _a2._prefixes) === null || _b2 === void 0 ? void 0 : _b2.has(prefix2)) || this._prefixes && !this._prefixes.has(prefix2)) {
        throw new Error(`CodeGen: prefix "${prefix2}" is not allowed in this scope`);
      }
      return this._names[prefix2] = { prefix: prefix2, index: 0 };
    }
  }
  exports.Scope = Scope;
  class ValueScopeName extends code_12.Name {
    constructor(prefix2, nameStr) {
      super(nameStr);
      this.prefix = prefix2;
    }
    setValue(value, { property: property2, itemIndex }) {
      this.value = value;
      this.scopePath = (0, code_12._)`.${new code_12.Name(property2)}[${itemIndex}]`;
    }
  }
  exports.ValueScopeName = ValueScopeName;
  const line = (0, code_12._)`\n`;
  class ValueScope extends Scope {
    constructor(opts) {
      super(opts);
      this._values = {};
      this._scope = opts.scope;
      this.opts = { ...opts, _n: opts.lines ? line : code_12.nil };
    }
    get() {
      return this._scope;
    }
    name(prefix2) {
      return new ValueScopeName(prefix2, this._newName(prefix2));
    }
    value(nameOrPrefix, value) {
      var _a2;
      if (value.ref === void 0)
        throw new Error("CodeGen: ref must be passed in value");
      const name2 = this.toName(nameOrPrefix);
      const { prefix: prefix2 } = name2;
      const valueKey = (_a2 = value.key) !== null && _a2 !== void 0 ? _a2 : value.ref;
      let vs = this._values[prefix2];
      if (vs) {
        const _name = vs.get(valueKey);
        if (_name)
          return _name;
      } else {
        vs = this._values[prefix2] = /* @__PURE__ */ new Map();
      }
      vs.set(valueKey, name2);
      const s4 = this._scope[prefix2] || (this._scope[prefix2] = []);
      const itemIndex = s4.length;
      s4[itemIndex] = value.ref;
      name2.setValue(value, { property: prefix2, itemIndex });
      return name2;
    }
    getValue(prefix2, keyOrRef) {
      const vs = this._values[prefix2];
      if (!vs)
        return;
      return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
      return this._reduceValues(values, (name2) => {
        if (name2.scopePath === void 0)
          throw new Error(`CodeGen: name "${name2}" has no value`);
        return (0, code_12._)`${scopeName}${name2.scopePath}`;
      });
    }
    scopeCode(values = this._values, usedValues, getCode) {
      return this._reduceValues(values, (name2) => {
        if (name2.value === void 0)
          throw new Error(`CodeGen: name "${name2}" has no value`);
        return name2.value.code;
      }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
      let code2 = code_12.nil;
      for (const prefix2 in values) {
        const vs = values[prefix2];
        if (!vs)
          continue;
        const nameSet = usedValues[prefix2] = usedValues[prefix2] || /* @__PURE__ */ new Map();
        vs.forEach((name2) => {
          if (nameSet.has(name2))
            return;
          nameSet.set(name2, UsedValueState.Started);
          let c3 = valueCode(name2);
          if (c3) {
            const def2 = this.opts.es5 ? exports.varKinds.var : exports.varKinds.const;
            code2 = (0, code_12._)`${code2}${def2} ${name2} = ${c3};${this.opts._n}`;
          } else if (c3 = getCode === null || getCode === void 0 ? void 0 : getCode(name2)) {
            code2 = (0, code_12._)`${code2}${c3}${this.opts._n}`;
          } else {
            throw new ValueError(name2);
          }
          nameSet.set(name2, UsedValueState.Completed);
        });
      }
      return code2;
    }
  }
  exports.ValueScope = ValueScope;
})(scope);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.or = exports.and = exports.not = exports.CodeGen = exports.operators = exports.varKinds = exports.ValueScopeName = exports.ValueScope = exports.Scope = exports.Name = exports.regexpCode = exports.stringify = exports.getProperty = exports.nil = exports.strConcat = exports.str = exports._ = void 0;
  const code_12 = code$1;
  const scope_1 = scope;
  var code_2 = code$1;
  Object.defineProperty(exports, "_", { enumerable: true, get: function() {
    return code_2._;
  } });
  Object.defineProperty(exports, "str", { enumerable: true, get: function() {
    return code_2.str;
  } });
  Object.defineProperty(exports, "strConcat", { enumerable: true, get: function() {
    return code_2.strConcat;
  } });
  Object.defineProperty(exports, "nil", { enumerable: true, get: function() {
    return code_2.nil;
  } });
  Object.defineProperty(exports, "getProperty", { enumerable: true, get: function() {
    return code_2.getProperty;
  } });
  Object.defineProperty(exports, "stringify", { enumerable: true, get: function() {
    return code_2.stringify;
  } });
  Object.defineProperty(exports, "regexpCode", { enumerable: true, get: function() {
    return code_2.regexpCode;
  } });
  Object.defineProperty(exports, "Name", { enumerable: true, get: function() {
    return code_2.Name;
  } });
  var scope_2 = scope;
  Object.defineProperty(exports, "Scope", { enumerable: true, get: function() {
    return scope_2.Scope;
  } });
  Object.defineProperty(exports, "ValueScope", { enumerable: true, get: function() {
    return scope_2.ValueScope;
  } });
  Object.defineProperty(exports, "ValueScopeName", { enumerable: true, get: function() {
    return scope_2.ValueScopeName;
  } });
  Object.defineProperty(exports, "varKinds", { enumerable: true, get: function() {
    return scope_2.varKinds;
  } });
  exports.operators = {
    GT: new code_12._Code(">"),
    GTE: new code_12._Code(">="),
    LT: new code_12._Code("<"),
    LTE: new code_12._Code("<="),
    EQ: new code_12._Code("==="),
    NEQ: new code_12._Code("!=="),
    NOT: new code_12._Code("!"),
    OR: new code_12._Code("||"),
    AND: new code_12._Code("&&"),
    ADD: new code_12._Code("+")
  };
  class Node2 {
    optimizeNodes() {
      return this;
    }
    optimizeNames(_names, _constants) {
      return this;
    }
  }
  class Def extends Node2 {
    constructor(varKind, name2, rhs) {
      super();
      this.varKind = varKind;
      this.name = name2;
      this.rhs = rhs;
    }
    render({ es5, _n: _n2 }) {
      const varKind = es5 ? scope_1.varKinds.var : this.varKind;
      const rhs = this.rhs === void 0 ? "" : ` = ${this.rhs}`;
      return `${varKind} ${this.name}${rhs};` + _n2;
    }
    optimizeNames(names2, constants) {
      if (!names2[this.name.str])
        return;
      if (this.rhs)
        this.rhs = optimizeExpr(this.rhs, names2, constants);
      return this;
    }
    get names() {
      return this.rhs instanceof code_12._CodeOrName ? this.rhs.names : {};
    }
  }
  class Assign extends Node2 {
    constructor(lhs, rhs, sideEffects) {
      super();
      this.lhs = lhs;
      this.rhs = rhs;
      this.sideEffects = sideEffects;
    }
    render({ _n: _n2 }) {
      return `${this.lhs} = ${this.rhs};` + _n2;
    }
    optimizeNames(names2, constants) {
      if (this.lhs instanceof code_12.Name && !names2[this.lhs.str] && !this.sideEffects)
        return;
      this.rhs = optimizeExpr(this.rhs, names2, constants);
      return this;
    }
    get names() {
      const names2 = this.lhs instanceof code_12.Name ? {} : { ...this.lhs.names };
      return addExprNames(names2, this.rhs);
    }
  }
  class AssignOp extends Assign {
    constructor(lhs, op, rhs, sideEffects) {
      super(lhs, rhs, sideEffects);
      this.op = op;
    }
    render({ _n: _n2 }) {
      return `${this.lhs} ${this.op}= ${this.rhs};` + _n2;
    }
  }
  class Label2 extends Node2 {
    constructor(label) {
      super();
      this.label = label;
      this.names = {};
    }
    render({ _n: _n2 }) {
      return `${this.label}:` + _n2;
    }
  }
  class Break extends Node2 {
    constructor(label) {
      super();
      this.label = label;
      this.names = {};
    }
    render({ _n: _n2 }) {
      const label = this.label ? ` ${this.label}` : "";
      return `break${label};` + _n2;
    }
  }
  class Throw extends Node2 {
    constructor(error2) {
      super();
      this.error = error2;
    }
    render({ _n: _n2 }) {
      return `throw ${this.error};` + _n2;
    }
    get names() {
      return this.error.names;
    }
  }
  class AnyCode extends Node2 {
    constructor(code2) {
      super();
      this.code = code2;
    }
    render({ _n: _n2 }) {
      return `${this.code};` + _n2;
    }
    optimizeNodes() {
      return `${this.code}` ? this : void 0;
    }
    optimizeNames(names2, constants) {
      this.code = optimizeExpr(this.code, names2, constants);
      return this;
    }
    get names() {
      return this.code instanceof code_12._CodeOrName ? this.code.names : {};
    }
  }
  class ParentNode extends Node2 {
    constructor(nodes2 = []) {
      super();
      this.nodes = nodes2;
    }
    render(opts) {
      return this.nodes.reduce((code2, n2) => code2 + n2.render(opts), "");
    }
    optimizeNodes() {
      const { nodes: nodes2 } = this;
      let i3 = nodes2.length;
      while (i3--) {
        const n2 = nodes2[i3].optimizeNodes();
        if (Array.isArray(n2))
          nodes2.splice(i3, 1, ...n2);
        else if (n2)
          nodes2[i3] = n2;
        else
          nodes2.splice(i3, 1);
      }
      return nodes2.length > 0 ? this : void 0;
    }
    optimizeNames(names2, constants) {
      const { nodes: nodes2 } = this;
      let i3 = nodes2.length;
      while (i3--) {
        const n2 = nodes2[i3];
        if (n2.optimizeNames(names2, constants))
          continue;
        subtractNames(names2, n2.names);
        nodes2.splice(i3, 1);
      }
      return nodes2.length > 0 ? this : void 0;
    }
    get names() {
      return this.nodes.reduce((names2, n2) => addNames(names2, n2.names), {});
    }
  }
  class BlockNode extends ParentNode {
    render(opts) {
      return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
  }
  class Root2 extends ParentNode {
  }
  class Else extends BlockNode {
  }
  Else.kind = "else";
  class If extends BlockNode {
    constructor(condition, nodes2) {
      super(nodes2);
      this.condition = condition;
    }
    render(opts) {
      let code2 = `if(${this.condition})` + super.render(opts);
      if (this.else)
        code2 += "else " + this.else.render(opts);
      return code2;
    }
    optimizeNodes() {
      super.optimizeNodes();
      const cond = this.condition;
      if (cond === true)
        return this.nodes;
      let e5 = this.else;
      if (e5) {
        const ns2 = e5.optimizeNodes();
        e5 = this.else = Array.isArray(ns2) ? new Else(ns2) : ns2;
      }
      if (e5) {
        if (cond === false)
          return e5 instanceof If ? e5 : e5.nodes;
        if (this.nodes.length)
          return this;
        return new If(not2(cond), e5 instanceof If ? [e5] : e5.nodes);
      }
      if (cond === false || !this.nodes.length)
        return void 0;
      return this;
    }
    optimizeNames(names2, constants) {
      var _a2;
      this.else = (_a2 = this.else) === null || _a2 === void 0 ? void 0 : _a2.optimizeNames(names2, constants);
      if (!(super.optimizeNames(names2, constants) || this.else))
        return;
      this.condition = optimizeExpr(this.condition, names2, constants);
      return this;
    }
    get names() {
      const names2 = super.names;
      addExprNames(names2, this.condition);
      if (this.else)
        addNames(names2, this.else.names);
      return names2;
    }
  }
  If.kind = "if";
  class For extends BlockNode {
  }
  For.kind = "for";
  class ForLoop extends For {
    constructor(iteration) {
      super();
      this.iteration = iteration;
    }
    render(opts) {
      return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names2, constants) {
      if (!super.optimizeNames(names2, constants))
        return;
      this.iteration = optimizeExpr(this.iteration, names2, constants);
      return this;
    }
    get names() {
      return addNames(super.names, this.iteration.names);
    }
  }
  class ForRange extends For {
    constructor(varKind, name2, from2, to2) {
      super();
      this.varKind = varKind;
      this.name = name2;
      this.from = from2;
      this.to = to2;
    }
    render(opts) {
      const varKind = opts.es5 ? scope_1.varKinds.var : this.varKind;
      const { name: name2, from: from2, to: to2 } = this;
      return `for(${varKind} ${name2}=${from2}; ${name2}<${to2}; ${name2}++)` + super.render(opts);
    }
    get names() {
      const names2 = addExprNames(super.names, this.from);
      return addExprNames(names2, this.to);
    }
  }
  class ForIter extends For {
    constructor(loop, varKind, name2, iterable) {
      super();
      this.loop = loop;
      this.varKind = varKind;
      this.name = name2;
      this.iterable = iterable;
    }
    render(opts) {
      return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names2, constants) {
      if (!super.optimizeNames(names2, constants))
        return;
      this.iterable = optimizeExpr(this.iterable, names2, constants);
      return this;
    }
    get names() {
      return addNames(super.names, this.iterable.names);
    }
  }
  class Func extends BlockNode {
    constructor(name2, args, async) {
      super();
      this.name = name2;
      this.args = args;
      this.async = async;
    }
    render(opts) {
      const _async = this.async ? "async " : "";
      return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
  }
  Func.kind = "func";
  class Return2 extends ParentNode {
    render(opts) {
      return "return " + super.render(opts);
    }
  }
  Return2.kind = "return";
  class Try extends BlockNode {
    render(opts) {
      let code2 = "try" + super.render(opts);
      if (this.catch)
        code2 += this.catch.render(opts);
      if (this.finally)
        code2 += this.finally.render(opts);
      return code2;
    }
    optimizeNodes() {
      var _a2, _b2;
      super.optimizeNodes();
      (_a2 = this.catch) === null || _a2 === void 0 ? void 0 : _a2.optimizeNodes();
      (_b2 = this.finally) === null || _b2 === void 0 ? void 0 : _b2.optimizeNodes();
      return this;
    }
    optimizeNames(names2, constants) {
      var _a2, _b2;
      super.optimizeNames(names2, constants);
      (_a2 = this.catch) === null || _a2 === void 0 ? void 0 : _a2.optimizeNames(names2, constants);
      (_b2 = this.finally) === null || _b2 === void 0 ? void 0 : _b2.optimizeNames(names2, constants);
      return this;
    }
    get names() {
      const names2 = super.names;
      if (this.catch)
        addNames(names2, this.catch.names);
      if (this.finally)
        addNames(names2, this.finally.names);
      return names2;
    }
  }
  class Catch extends BlockNode {
    constructor(error2) {
      super();
      this.error = error2;
    }
    render(opts) {
      return `catch(${this.error})` + super.render(opts);
    }
  }
  Catch.kind = "catch";
  class Finally extends BlockNode {
    render(opts) {
      return "finally" + super.render(opts);
    }
  }
  Finally.kind = "finally";
  class CodeGen {
    constructor(extScope, opts = {}) {
      this._values = {};
      this._blockStarts = [];
      this._constants = {};
      this.opts = { ...opts, _n: opts.lines ? "\n" : "" };
      this._extScope = extScope;
      this._scope = new scope_1.Scope({ parent: extScope });
      this._nodes = [new Root2()];
    }
    toString() {
      return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix2) {
      return this._scope.name(prefix2);
    }
    // reserves unique name in the external scope
    scopeName(prefix2) {
      return this._extScope.name(prefix2);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
      const name2 = this._extScope.value(prefixOrName, value);
      const vs = this._values[name2.prefix] || (this._values[name2.prefix] = /* @__PURE__ */ new Set());
      vs.add(name2);
      return name2;
    }
    getScopeValue(prefix2, keyOrRef) {
      return this._extScope.getValue(prefix2, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
      return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
      return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant2) {
      const name2 = this._scope.toName(nameOrPrefix);
      if (rhs !== void 0 && constant2)
        this._constants[name2.str] = rhs;
      this._leafNode(new Def(varKind, name2, rhs));
      return name2;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
      return this._def(scope_1.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
      return this._def(scope_1.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
      return this._def(scope_1.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
      return this._leafNode(new Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
      return this._leafNode(new AssignOp(lhs, exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c3) {
      if (typeof c3 == "function")
        c3();
      else if (c3 !== code_12.nil)
        this._leafNode(new AnyCode(c3));
      return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
      const code2 = ["{"];
      for (const [key2, value] of keyValues) {
        if (code2.length > 1)
          code2.push(",");
        code2.push(key2);
        if (key2 !== value || this.opts.es5) {
          code2.push(":");
          (0, code_12.addCodeArg)(code2, value);
        }
      }
      code2.push("}");
      return new code_12._Code(code2);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
      this._blockNode(new If(condition));
      if (thenBody && elseBody) {
        this.code(thenBody).else().code(elseBody).endIf();
      } else if (thenBody) {
        this.code(thenBody).endIf();
      } else if (elseBody) {
        throw new Error('CodeGen: "else" body without "then" body');
      }
      return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
      return this._elseNode(new If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
      return this._elseNode(new Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
      return this._endBlockNode(If, Else);
    }
    _for(node3, forBody) {
      this._blockNode(node3);
      if (forBody)
        this.code(forBody).endFor();
      return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
      return this._for(new ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from2, to2, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.let) {
      const name2 = this._scope.toName(nameOrPrefix);
      return this._for(new ForRange(varKind, name2, from2, to2), () => forBody(name2));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = scope_1.varKinds.const) {
      const name2 = this._scope.toName(nameOrPrefix);
      if (this.opts.es5) {
        const arr = iterable instanceof code_12.Name ? iterable : this.var("_arr", iterable);
        return this.forRange("_i", 0, (0, code_12._)`${arr}.length`, (i3) => {
          this.var(name2, (0, code_12._)`${arr}[${i3}]`);
          forBody(name2);
        });
      }
      return this._for(new ForIter("of", varKind, name2, iterable), () => forBody(name2));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.const) {
      if (this.opts.ownProperties) {
        return this.forOf(nameOrPrefix, (0, code_12._)`Object.keys(${obj})`, forBody);
      }
      const name2 = this._scope.toName(nameOrPrefix);
      return this._for(new ForIter("in", varKind, name2, obj), () => forBody(name2));
    }
    // end `for` loop
    endFor() {
      return this._endBlockNode(For);
    }
    // `label` statement
    label(label) {
      return this._leafNode(new Label2(label));
    }
    // `break` statement
    break(label) {
      return this._leafNode(new Break(label));
    }
    // `return` statement
    return(value) {
      const node3 = new Return2();
      this._blockNode(node3);
      this.code(value);
      if (node3.nodes.length !== 1)
        throw new Error('CodeGen: "return" should have one node');
      return this._endBlockNode(Return2);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
      if (!catchCode && !finallyCode)
        throw new Error('CodeGen: "try" without "catch" and "finally"');
      const node3 = new Try();
      this._blockNode(node3);
      this.code(tryBody);
      if (catchCode) {
        const error2 = this.name("e");
        this._currNode = node3.catch = new Catch(error2);
        catchCode(error2);
      }
      if (finallyCode) {
        this._currNode = node3.finally = new Finally();
        this.code(finallyCode);
      }
      return this._endBlockNode(Catch, Finally);
    }
    // `throw` statement
    throw(error2) {
      return this._leafNode(new Throw(error2));
    }
    // start self-balancing block
    block(body, nodeCount) {
      this._blockStarts.push(this._nodes.length);
      if (body)
        this.code(body).endBlock(nodeCount);
      return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
      const len = this._blockStarts.pop();
      if (len === void 0)
        throw new Error("CodeGen: not in self-balancing block");
      const toClose = this._nodes.length - len;
      if (toClose < 0 || nodeCount !== void 0 && toClose !== nodeCount) {
        throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
      }
      this._nodes.length = len;
      return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name2, args = code_12.nil, async, funcBody) {
      this._blockNode(new Func(name2, args, async));
      if (funcBody)
        this.code(funcBody).endFunc();
      return this;
    }
    // end function definition
    endFunc() {
      return this._endBlockNode(Func);
    }
    optimize(n2 = 1) {
      while (n2-- > 0) {
        this._root.optimizeNodes();
        this._root.optimizeNames(this._root.names, this._constants);
      }
    }
    _leafNode(node3) {
      this._currNode.nodes.push(node3);
      return this;
    }
    _blockNode(node3) {
      this._currNode.nodes.push(node3);
      this._nodes.push(node3);
    }
    _endBlockNode(N1, N2) {
      const n2 = this._currNode;
      if (n2 instanceof N1 || N2 && n2 instanceof N2) {
        this._nodes.pop();
        return this;
      }
      throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node3) {
      const n2 = this._currNode;
      if (!(n2 instanceof If)) {
        throw new Error('CodeGen: "else" without "if"');
      }
      this._currNode = n2.else = node3;
      return this;
    }
    get _root() {
      return this._nodes[0];
    }
    get _currNode() {
      const ns2 = this._nodes;
      return ns2[ns2.length - 1];
    }
    set _currNode(node3) {
      const ns2 = this._nodes;
      ns2[ns2.length - 1] = node3;
    }
  }
  exports.CodeGen = CodeGen;
  function addNames(names2, from2) {
    for (const n2 in from2)
      names2[n2] = (names2[n2] || 0) + (from2[n2] || 0);
    return names2;
  }
  function addExprNames(names2, from2) {
    return from2 instanceof code_12._CodeOrName ? addNames(names2, from2.names) : names2;
  }
  function optimizeExpr(expr, names2, constants) {
    if (expr instanceof code_12.Name)
      return replaceName(expr);
    if (!canOptimize(expr))
      return expr;
    return new code_12._Code(expr._items.reduce((items2, c3) => {
      if (c3 instanceof code_12.Name)
        c3 = replaceName(c3);
      if (c3 instanceof code_12._Code)
        items2.push(...c3._items);
      else
        items2.push(c3);
      return items2;
    }, []));
    function replaceName(n2) {
      const c3 = constants[n2.str];
      if (c3 === void 0 || names2[n2.str] !== 1)
        return n2;
      delete names2[n2.str];
      return c3;
    }
    function canOptimize(e5) {
      return e5 instanceof code_12._Code && e5._items.some((c3) => c3 instanceof code_12.Name && names2[c3.str] === 1 && constants[c3.str] !== void 0);
    }
  }
  function subtractNames(names2, from2) {
    for (const n2 in from2)
      names2[n2] = (names2[n2] || 0) - (from2[n2] || 0);
  }
  function not2(x3) {
    return typeof x3 == "boolean" || typeof x3 == "number" || x3 === null ? !x3 : (0, code_12._)`!${par(x3)}`;
  }
  exports.not = not2;
  const andCode = mappend(exports.operators.AND);
  function and(...args) {
    return args.reduce(andCode);
  }
  exports.and = and;
  const orCode = mappend(exports.operators.OR);
  function or2(...args) {
    return args.reduce(orCode);
  }
  exports.or = or2;
  function mappend(op) {
    return (x3, y4) => x3 === code_12.nil ? y4 : y4 === code_12.nil ? x3 : (0, code_12._)`${par(x3)} ${op} ${par(y4)}`;
  }
  function par(x3) {
    return x3 instanceof code_12.Name ? x3 : (0, code_12._)`(${x3})`;
  }
})(codegen);
var util = {};
Object.defineProperty(util, "__esModule", { value: true });
util.checkStrictMode = util.getErrorPath = util.Type = util.useFunc = util.setEvaluated = util.evaluatedPropsToName = util.mergeEvaluated = util.eachItem = util.unescapeJsonPointer = util.escapeJsonPointer = util.escapeFragment = util.unescapeFragment = util.schemaRefOrVal = util.schemaHasRulesButRef = util.schemaHasRules = util.checkUnknownRules = util.alwaysValidSchema = util.toHash = void 0;
const codegen_1$v = codegen;
const code_1$a = code$1;
function toHash(arr) {
  const hash = {};
  for (const item of arr)
    hash[item] = true;
  return hash;
}
util.toHash = toHash;
function alwaysValidSchema(it2, schema) {
  if (typeof schema == "boolean")
    return schema;
  if (Object.keys(schema).length === 0)
    return true;
  checkUnknownRules(it2, schema);
  return !schemaHasRules(schema, it2.self.RULES.all);
}
util.alwaysValidSchema = alwaysValidSchema;
function checkUnknownRules(it2, schema = it2.schema) {
  const { opts, self: self2 } = it2;
  if (!opts.strictSchema)
    return;
  if (typeof schema === "boolean")
    return;
  const rules2 = self2.RULES.keywords;
  for (const key2 in schema) {
    if (!rules2[key2])
      checkStrictMode(it2, `unknown keyword: "${key2}"`);
  }
}
util.checkUnknownRules = checkUnknownRules;
function schemaHasRules(schema, rules2) {
  if (typeof schema == "boolean")
    return !schema;
  for (const key2 in schema)
    if (rules2[key2])
      return true;
  return false;
}
util.schemaHasRules = schemaHasRules;
function schemaHasRulesButRef(schema, RULES) {
  if (typeof schema == "boolean")
    return !schema;
  for (const key2 in schema)
    if (key2 !== "$ref" && RULES.all[key2])
      return true;
  return false;
}
util.schemaHasRulesButRef = schemaHasRulesButRef;
function schemaRefOrVal({ topSchemaRef, schemaPath }, schema, keyword2, $data) {
  if (!$data) {
    if (typeof schema == "number" || typeof schema == "boolean")
      return schema;
    if (typeof schema == "string")
      return (0, codegen_1$v._)`${schema}`;
  }
  return (0, codegen_1$v._)`${topSchemaRef}${schemaPath}${(0, codegen_1$v.getProperty)(keyword2)}`;
}
util.schemaRefOrVal = schemaRefOrVal;
function unescapeFragment(str) {
  return unescapeJsonPointer(decodeURIComponent(str));
}
util.unescapeFragment = unescapeFragment;
function escapeFragment(str) {
  return encodeURIComponent(escapeJsonPointer(str));
}
util.escapeFragment = escapeFragment;
function escapeJsonPointer(str) {
  if (typeof str == "number")
    return `${str}`;
  return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
util.escapeJsonPointer = escapeJsonPointer;
function unescapeJsonPointer(str) {
  return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
util.unescapeJsonPointer = unescapeJsonPointer;
function eachItem(xs, f2) {
  if (Array.isArray(xs)) {
    for (const x3 of xs)
      f2(x3);
  } else {
    f2(xs);
  }
}
util.eachItem = eachItem;
function makeMergeEvaluated({ mergeNames, mergeToName, mergeValues, resultToName }) {
  return (gen, from2, to2, toName) => {
    const res = to2 === void 0 ? from2 : to2 instanceof codegen_1$v.Name ? (from2 instanceof codegen_1$v.Name ? mergeNames(gen, from2, to2) : mergeToName(gen, from2, to2), to2) : from2 instanceof codegen_1$v.Name ? (mergeToName(gen, to2, from2), from2) : mergeValues(from2, to2);
    return toName === codegen_1$v.Name && !(res instanceof codegen_1$v.Name) ? resultToName(gen, res) : res;
  };
}
util.mergeEvaluated = {
  props: makeMergeEvaluated({
    mergeNames: (gen, from2, to2) => gen.if((0, codegen_1$v._)`${to2} !== true && ${from2} !== undefined`, () => {
      gen.if((0, codegen_1$v._)`${from2} === true`, () => gen.assign(to2, true), () => gen.assign(to2, (0, codegen_1$v._)`${to2} || {}`).code((0, codegen_1$v._)`Object.assign(${to2}, ${from2})`));
    }),
    mergeToName: (gen, from2, to2) => gen.if((0, codegen_1$v._)`${to2} !== true`, () => {
      if (from2 === true) {
        gen.assign(to2, true);
      } else {
        gen.assign(to2, (0, codegen_1$v._)`${to2} || {}`);
        setEvaluated(gen, to2, from2);
      }
    }),
    mergeValues: (from2, to2) => from2 === true ? true : { ...from2, ...to2 },
    resultToName: evaluatedPropsToName
  }),
  items: makeMergeEvaluated({
    mergeNames: (gen, from2, to2) => gen.if((0, codegen_1$v._)`${to2} !== true && ${from2} !== undefined`, () => gen.assign(to2, (0, codegen_1$v._)`${from2} === true ? true : ${to2} > ${from2} ? ${to2} : ${from2}`)),
    mergeToName: (gen, from2, to2) => gen.if((0, codegen_1$v._)`${to2} !== true`, () => gen.assign(to2, from2 === true ? true : (0, codegen_1$v._)`${to2} > ${from2} ? ${to2} : ${from2}`)),
    mergeValues: (from2, to2) => from2 === true ? true : Math.max(from2, to2),
    resultToName: (gen, items2) => gen.var("items", items2)
  })
};
function evaluatedPropsToName(gen, ps) {
  if (ps === true)
    return gen.var("props", true);
  const props2 = gen.var("props", (0, codegen_1$v._)`{}`);
  if (ps !== void 0)
    setEvaluated(gen, props2, ps);
  return props2;
}
util.evaluatedPropsToName = evaluatedPropsToName;
function setEvaluated(gen, props2, ps) {
  Object.keys(ps).forEach((p2) => gen.assign((0, codegen_1$v._)`${props2}${(0, codegen_1$v.getProperty)(p2)}`, true));
}
util.setEvaluated = setEvaluated;
const snippets = {};
function useFunc(gen, f2) {
  return gen.scopeValue("func", {
    ref: f2,
    code: snippets[f2.code] || (snippets[f2.code] = new code_1$a._Code(f2.code))
  });
}
util.useFunc = useFunc;
var Type;
(function(Type2) {
  Type2[Type2["Num"] = 0] = "Num";
  Type2[Type2["Str"] = 1] = "Str";
})(Type || (util.Type = Type = {}));
function getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
  if (dataProp instanceof codegen_1$v.Name) {
    const isNumber2 = dataPropType === Type.Num;
    return jsPropertySyntax ? isNumber2 ? (0, codegen_1$v._)`"[" + ${dataProp} + "]"` : (0, codegen_1$v._)`"['" + ${dataProp} + "']"` : isNumber2 ? (0, codegen_1$v._)`"/" + ${dataProp}` : (0, codegen_1$v._)`"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`;
  }
  return jsPropertySyntax ? (0, codegen_1$v.getProperty)(dataProp).toString() : "/" + escapeJsonPointer(dataProp);
}
util.getErrorPath = getErrorPath;
function checkStrictMode(it2, msg2, mode = it2.opts.strictSchema) {
  if (!mode)
    return;
  msg2 = `strict mode: ${msg2}`;
  if (mode === true)
    throw new Error(msg2);
  it2.self.logger.warn(msg2);
}
util.checkStrictMode = checkStrictMode;
var names$1 = {};
Object.defineProperty(names$1, "__esModule", { value: true });
const codegen_1$u = codegen;
const names = {
  // validation function arguments
  data: new codegen_1$u.Name("data"),
  // data passed to validation function
  // args passed from referencing schema
  valCxt: new codegen_1$u.Name("valCxt"),
  // validation/data context - should not be used directly, it is destructured to the names below
  instancePath: new codegen_1$u.Name("instancePath"),
  parentData: new codegen_1$u.Name("parentData"),
  parentDataProperty: new codegen_1$u.Name("parentDataProperty"),
  rootData: new codegen_1$u.Name("rootData"),
  // root data - same as the data passed to the first/top validation function
  dynamicAnchors: new codegen_1$u.Name("dynamicAnchors"),
  // used to support recursiveRef and dynamicRef
  // function scoped variables
  vErrors: new codegen_1$u.Name("vErrors"),
  // null or array of validation errors
  errors: new codegen_1$u.Name("errors"),
  // counter of validation errors
  this: new codegen_1$u.Name("this"),
  // "globals"
  self: new codegen_1$u.Name("self"),
  scope: new codegen_1$u.Name("scope"),
  // JTD serialize/parse name for JSON string and position
  json: new codegen_1$u.Name("json"),
  jsonPos: new codegen_1$u.Name("jsonPos"),
  jsonLen: new codegen_1$u.Name("jsonLen"),
  jsonPart: new codegen_1$u.Name("jsonPart")
};
names$1.default = names;
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.extendErrors = exports.resetErrorsCount = exports.reportExtraError = exports.reportError = exports.keyword$DataError = exports.keywordError = void 0;
  const codegen_12 = codegen;
  const util_12 = util;
  const names_12 = names$1;
  exports.keywordError = {
    message: ({ keyword: keyword2 }) => (0, codegen_12.str)`must pass "${keyword2}" keyword validation`
  };
  exports.keyword$DataError = {
    message: ({ keyword: keyword2, schemaType }) => schemaType ? (0, codegen_12.str)`"${keyword2}" keyword must be ${schemaType} ($data)` : (0, codegen_12.str)`"${keyword2}" keyword is invalid ($data)`
  };
  function reportError(cxt, error2 = exports.keywordError, errorPaths, overrideAllErrors) {
    const { it: it2 } = cxt;
    const { gen, compositeRule, allErrors } = it2;
    const errObj = errorObjectCode(cxt, error2, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) {
      addError(gen, errObj);
    } else {
      returnErrors(it2, (0, codegen_12._)`[${errObj}]`);
    }
  }
  exports.reportError = reportError;
  function reportExtraError(cxt, error2 = exports.keywordError, errorPaths) {
    const { it: it2 } = cxt;
    const { gen, compositeRule, allErrors } = it2;
    const errObj = errorObjectCode(cxt, error2, errorPaths);
    addError(gen, errObj);
    if (!(compositeRule || allErrors)) {
      returnErrors(it2, names_12.default.vErrors);
    }
  }
  exports.reportExtraError = reportExtraError;
  function resetErrorsCount(gen, errsCount) {
    gen.assign(names_12.default.errors, errsCount);
    gen.if((0, codegen_12._)`${names_12.default.vErrors} !== null`, () => gen.if(errsCount, () => gen.assign((0, codegen_12._)`${names_12.default.vErrors}.length`, errsCount), () => gen.assign(names_12.default.vErrors, null)));
  }
  exports.resetErrorsCount = resetErrorsCount;
  function extendErrors({ gen, keyword: keyword2, schemaValue, data, errsCount, it: it2 }) {
    if (errsCount === void 0)
      throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, names_12.default.errors, (i3) => {
      gen.const(err, (0, codegen_12._)`${names_12.default.vErrors}[${i3}]`);
      gen.if((0, codegen_12._)`${err}.instancePath === undefined`, () => gen.assign((0, codegen_12._)`${err}.instancePath`, (0, codegen_12.strConcat)(names_12.default.instancePath, it2.errorPath)));
      gen.assign((0, codegen_12._)`${err}.schemaPath`, (0, codegen_12.str)`${it2.errSchemaPath}/${keyword2}`);
      if (it2.opts.verbose) {
        gen.assign((0, codegen_12._)`${err}.schema`, schemaValue);
        gen.assign((0, codegen_12._)`${err}.data`, data);
      }
    });
  }
  exports.extendErrors = extendErrors;
  function addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, codegen_12._)`${names_12.default.vErrors} === null`, () => gen.assign(names_12.default.vErrors, (0, codegen_12._)`[${err}]`), (0, codegen_12._)`${names_12.default.vErrors}.push(${err})`);
    gen.code((0, codegen_12._)`${names_12.default.errors}++`);
  }
  function returnErrors(it2, errs) {
    const { gen, validateName, schemaEnv } = it2;
    if (schemaEnv.$async) {
      gen.throw((0, codegen_12._)`new ${it2.ValidationError}(${errs})`);
    } else {
      gen.assign((0, codegen_12._)`${validateName}.errors`, errs);
      gen.return(false);
    }
  }
  const E3 = {
    keyword: new codegen_12.Name("keyword"),
    schemaPath: new codegen_12.Name("schemaPath"),
    // also used in JTD errors
    params: new codegen_12.Name("params"),
    propertyName: new codegen_12.Name("propertyName"),
    message: new codegen_12.Name("message"),
    schema: new codegen_12.Name("schema"),
    parentSchema: new codegen_12.Name("parentSchema")
  };
  function errorObjectCode(cxt, error2, errorPaths) {
    const { createErrors } = cxt.it;
    if (createErrors === false)
      return (0, codegen_12._)`{}`;
    return errorObject(cxt, error2, errorPaths);
  }
  function errorObject(cxt, error2, errorPaths = {}) {
    const { gen, it: it2 } = cxt;
    const keyValues = [
      errorInstancePath(it2, errorPaths),
      errorSchemaPath(cxt, errorPaths)
    ];
    extraErrorProps(cxt, error2, keyValues);
    return gen.object(...keyValues);
  }
  function errorInstancePath({ errorPath }, { instancePath }) {
    const instPath = instancePath ? (0, codegen_12.str)`${errorPath}${(0, util_12.getErrorPath)(instancePath, util_12.Type.Str)}` : errorPath;
    return [names_12.default.instancePath, (0, codegen_12.strConcat)(names_12.default.instancePath, instPath)];
  }
  function errorSchemaPath({ keyword: keyword2, it: { errSchemaPath } }, { schemaPath, parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, codegen_12.str)`${errSchemaPath}/${keyword2}`;
    if (schemaPath) {
      schPath = (0, codegen_12.str)`${schPath}${(0, util_12.getErrorPath)(schemaPath, util_12.Type.Str)}`;
    }
    return [E3.schemaPath, schPath];
  }
  function extraErrorProps(cxt, { params, message: message2 }, keyValues) {
    const { keyword: keyword2, data, schemaValue, it: it2 } = cxt;
    const { opts, propertyName, topSchemaRef, schemaPath } = it2;
    keyValues.push([E3.keyword, keyword2], [E3.params, typeof params == "function" ? params(cxt) : params || (0, codegen_12._)`{}`]);
    if (opts.messages) {
      keyValues.push([E3.message, typeof message2 == "function" ? message2(cxt) : message2]);
    }
    if (opts.verbose) {
      keyValues.push([E3.schema, schemaValue], [E3.parentSchema, (0, codegen_12._)`${topSchemaRef}${schemaPath}`], [names_12.default.data, data]);
    }
    if (propertyName)
      keyValues.push([E3.propertyName, propertyName]);
  }
})(errors);
Object.defineProperty(boolSchema, "__esModule", { value: true });
boolSchema.boolOrEmptySchema = boolSchema.topBoolOrEmptySchema = void 0;
const errors_1$3 = errors;
const codegen_1$t = codegen;
const names_1$6 = names$1;
const boolError = {
  message: "boolean schema is false"
};
function topBoolOrEmptySchema(it2) {
  const { gen, schema, validateName } = it2;
  if (schema === false) {
    falseSchemaError(it2, false);
  } else if (typeof schema == "object" && schema.$async === true) {
    gen.return(names_1$6.default.data);
  } else {
    gen.assign((0, codegen_1$t._)`${validateName}.errors`, null);
    gen.return(true);
  }
}
boolSchema.topBoolOrEmptySchema = topBoolOrEmptySchema;
function boolOrEmptySchema(it2, valid) {
  const { gen, schema } = it2;
  if (schema === false) {
    gen.var(valid, false);
    falseSchemaError(it2);
  } else {
    gen.var(valid, true);
  }
}
boolSchema.boolOrEmptySchema = boolOrEmptySchema;
function falseSchemaError(it2, overrideAllErrors) {
  const { gen, data } = it2;
  const cxt = {
    gen,
    keyword: "false schema",
    data,
    schema: false,
    schemaCode: false,
    schemaValue: false,
    params: {},
    it: it2
  };
  (0, errors_1$3.reportError)(cxt, boolError, void 0, overrideAllErrors);
}
var dataType = {};
var rules = {};
Object.defineProperty(rules, "__esModule", { value: true });
rules.getRules = rules.isJSONType = void 0;
const _jsonTypes = ["string", "number", "integer", "boolean", "null", "object", "array"];
const jsonTypes = new Set(_jsonTypes);
function isJSONType(x3) {
  return typeof x3 == "string" && jsonTypes.has(x3);
}
rules.isJSONType = isJSONType;
function getRules() {
  const groups = {
    number: { type: "number", rules: [] },
    string: { type: "string", rules: [] },
    array: { type: "array", rules: [] },
    object: { type: "object", rules: [] }
  };
  return {
    types: { ...groups, integer: true, boolean: true, null: true },
    rules: [{ rules: [] }, groups.number, groups.string, groups.array, groups.object],
    post: { rules: [] },
    all: {},
    keywords: {}
  };
}
rules.getRules = getRules;
var applicability = {};
Object.defineProperty(applicability, "__esModule", { value: true });
applicability.shouldUseRule = applicability.shouldUseGroup = applicability.schemaHasRulesForType = void 0;
function schemaHasRulesForType({ schema, self: self2 }, type2) {
  const group = self2.RULES.types[type2];
  return group && group !== true && shouldUseGroup(schema, group);
}
applicability.schemaHasRulesForType = schemaHasRulesForType;
function shouldUseGroup(schema, group) {
  return group.rules.some((rule) => shouldUseRule(schema, rule));
}
applicability.shouldUseGroup = shouldUseGroup;
function shouldUseRule(schema, rule) {
  var _a2;
  return schema[rule.keyword] !== void 0 || ((_a2 = rule.definition.implements) === null || _a2 === void 0 ? void 0 : _a2.some((kwd) => schema[kwd] !== void 0));
}
applicability.shouldUseRule = shouldUseRule;
Object.defineProperty(dataType, "__esModule", { value: true });
dataType.reportTypeError = dataType.checkDataTypes = dataType.checkDataType = dataType.coerceAndCheckDataType = dataType.getJSONTypes = dataType.getSchemaTypes = dataType.DataType = void 0;
const rules_1 = rules;
const applicability_1$1 = applicability;
const errors_1$2 = errors;
const codegen_1$s = codegen;
const util_1$q = util;
var DataType;
(function(DataType2) {
  DataType2[DataType2["Correct"] = 0] = "Correct";
  DataType2[DataType2["Wrong"] = 1] = "Wrong";
})(DataType || (dataType.DataType = DataType = {}));
function getSchemaTypes(schema) {
  const types2 = getJSONTypes(schema.type);
  const hasNull = types2.includes("null");
  if (hasNull) {
    if (schema.nullable === false)
      throw new Error("type: null contradicts nullable: false");
  } else {
    if (!types2.length && schema.nullable !== void 0) {
      throw new Error('"nullable" cannot be used without "type"');
    }
    if (schema.nullable === true)
      types2.push("null");
  }
  return types2;
}
dataType.getSchemaTypes = getSchemaTypes;
function getJSONTypes(ts) {
  const types2 = Array.isArray(ts) ? ts : ts ? [ts] : [];
  if (types2.every(rules_1.isJSONType))
    return types2;
  throw new Error("type must be JSONType or JSONType[]: " + types2.join(","));
}
dataType.getJSONTypes = getJSONTypes;
function coerceAndCheckDataType(it2, types2) {
  const { gen, data, opts } = it2;
  const coerceTo = coerceToTypes(types2, opts.coerceTypes);
  const checkTypes = types2.length > 0 && !(coerceTo.length === 0 && types2.length === 1 && (0, applicability_1$1.schemaHasRulesForType)(it2, types2[0]));
  if (checkTypes) {
    const wrongType = checkDataTypes(types2, data, opts.strictNumbers, DataType.Wrong);
    gen.if(wrongType, () => {
      if (coerceTo.length)
        coerceData(it2, types2, coerceTo);
      else
        reportTypeError(it2);
    });
  }
  return checkTypes;
}
dataType.coerceAndCheckDataType = coerceAndCheckDataType;
const COERCIBLE = /* @__PURE__ */ new Set(["string", "number", "integer", "boolean", "null"]);
function coerceToTypes(types2, coerceTypes) {
  return coerceTypes ? types2.filter((t3) => COERCIBLE.has(t3) || coerceTypes === "array" && t3 === "array") : [];
}
function coerceData(it2, types2, coerceTo) {
  const { gen, data, opts } = it2;
  const dataType2 = gen.let("dataType", (0, codegen_1$s._)`typeof ${data}`);
  const coerced = gen.let("coerced", (0, codegen_1$s._)`undefined`);
  if (opts.coerceTypes === "array") {
    gen.if((0, codegen_1$s._)`${dataType2} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, () => gen.assign(data, (0, codegen_1$s._)`${data}[0]`).assign(dataType2, (0, codegen_1$s._)`typeof ${data}`).if(checkDataTypes(types2, data, opts.strictNumbers), () => gen.assign(coerced, data)));
  }
  gen.if((0, codegen_1$s._)`${coerced} !== undefined`);
  for (const t3 of coerceTo) {
    if (COERCIBLE.has(t3) || t3 === "array" && opts.coerceTypes === "array") {
      coerceSpecificType(t3);
    }
  }
  gen.else();
  reportTypeError(it2);
  gen.endIf();
  gen.if((0, codegen_1$s._)`${coerced} !== undefined`, () => {
    gen.assign(data, coerced);
    assignParentData(it2, coerced);
  });
  function coerceSpecificType(t3) {
    switch (t3) {
      case "string":
        gen.elseIf((0, codegen_1$s._)`${dataType2} == "number" || ${dataType2} == "boolean"`).assign(coerced, (0, codegen_1$s._)`"" + ${data}`).elseIf((0, codegen_1$s._)`${data} === null`).assign(coerced, (0, codegen_1$s._)`""`);
        return;
      case "number":
        gen.elseIf((0, codegen_1$s._)`${dataType2} == "boolean" || ${data} === null
              || (${dataType2} == "string" && ${data} && ${data} == +${data})`).assign(coerced, (0, codegen_1$s._)`+${data}`);
        return;
      case "integer":
        gen.elseIf((0, codegen_1$s._)`${dataType2} === "boolean" || ${data} === null
              || (${dataType2} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`).assign(coerced, (0, codegen_1$s._)`+${data}`);
        return;
      case "boolean":
        gen.elseIf((0, codegen_1$s._)`${data} === "false" || ${data} === 0 || ${data} === null`).assign(coerced, false).elseIf((0, codegen_1$s._)`${data} === "true" || ${data} === 1`).assign(coerced, true);
        return;
      case "null":
        gen.elseIf((0, codegen_1$s._)`${data} === "" || ${data} === 0 || ${data} === false`);
        gen.assign(coerced, null);
        return;
      case "array":
        gen.elseIf((0, codegen_1$s._)`${dataType2} === "string" || ${dataType2} === "number"
              || ${dataType2} === "boolean" || ${data} === null`).assign(coerced, (0, codegen_1$s._)`[${data}]`);
    }
  }
}
function assignParentData({ gen, parentData, parentDataProperty }, expr) {
  gen.if((0, codegen_1$s._)`${parentData} !== undefined`, () => gen.assign((0, codegen_1$s._)`${parentData}[${parentDataProperty}]`, expr));
}
function checkDataType(dataType2, data, strictNums, correct = DataType.Correct) {
  const EQ = correct === DataType.Correct ? codegen_1$s.operators.EQ : codegen_1$s.operators.NEQ;
  let cond;
  switch (dataType2) {
    case "null":
      return (0, codegen_1$s._)`${data} ${EQ} null`;
    case "array":
      cond = (0, codegen_1$s._)`Array.isArray(${data})`;
      break;
    case "object":
      cond = (0, codegen_1$s._)`${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
      break;
    case "integer":
      cond = numCond((0, codegen_1$s._)`!(${data} % 1) && !isNaN(${data})`);
      break;
    case "number":
      cond = numCond();
      break;
    default:
      return (0, codegen_1$s._)`typeof ${data} ${EQ} ${dataType2}`;
  }
  return correct === DataType.Correct ? cond : (0, codegen_1$s.not)(cond);
  function numCond(_cond = codegen_1$s.nil) {
    return (0, codegen_1$s.and)((0, codegen_1$s._)`typeof ${data} == "number"`, _cond, strictNums ? (0, codegen_1$s._)`isFinite(${data})` : codegen_1$s.nil);
  }
}
dataType.checkDataType = checkDataType;
function checkDataTypes(dataTypes, data, strictNums, correct) {
  if (dataTypes.length === 1) {
    return checkDataType(dataTypes[0], data, strictNums, correct);
  }
  let cond;
  const types2 = (0, util_1$q.toHash)(dataTypes);
  if (types2.array && types2.object) {
    const notObj = (0, codegen_1$s._)`typeof ${data} != "object"`;
    cond = types2.null ? notObj : (0, codegen_1$s._)`!${data} || ${notObj}`;
    delete types2.null;
    delete types2.array;
    delete types2.object;
  } else {
    cond = codegen_1$s.nil;
  }
  if (types2.number)
    delete types2.integer;
  for (const t3 in types2)
    cond = (0, codegen_1$s.and)(cond, checkDataType(t3, data, strictNums, correct));
  return cond;
}
dataType.checkDataTypes = checkDataTypes;
const typeError = {
  message: ({ schema }) => `must be ${schema}`,
  params: ({ schema, schemaValue }) => typeof schema == "string" ? (0, codegen_1$s._)`{type: ${schema}}` : (0, codegen_1$s._)`{type: ${schemaValue}}`
};
function reportTypeError(it2) {
  const cxt = getTypeErrorContext(it2);
  (0, errors_1$2.reportError)(cxt, typeError);
}
dataType.reportTypeError = reportTypeError;
function getTypeErrorContext(it2) {
  const { gen, data, schema } = it2;
  const schemaCode = (0, util_1$q.schemaRefOrVal)(it2, schema, "type");
  return {
    gen,
    keyword: "type",
    data,
    schema: schema.type,
    schemaCode,
    schemaValue: schemaCode,
    parentSchema: schema,
    params: {},
    it: it2
  };
}
var defaults$3 = {};
Object.defineProperty(defaults$3, "__esModule", { value: true });
defaults$3.assignDefaults = void 0;
const codegen_1$r = codegen;
const util_1$p = util;
function assignDefaults(it2, ty) {
  const { properties: properties2, items: items2 } = it2.schema;
  if (ty === "object" && properties2) {
    for (const key2 in properties2) {
      assignDefault(it2, key2, properties2[key2].default);
    }
  } else if (ty === "array" && Array.isArray(items2)) {
    items2.forEach((sch, i3) => assignDefault(it2, i3, sch.default));
  }
}
defaults$3.assignDefaults = assignDefaults;
function assignDefault(it2, prop, defaultValue) {
  const { gen, compositeRule, data, opts } = it2;
  if (defaultValue === void 0)
    return;
  const childData = (0, codegen_1$r._)`${data}${(0, codegen_1$r.getProperty)(prop)}`;
  if (compositeRule) {
    (0, util_1$p.checkStrictMode)(it2, `default is ignored for: ${childData}`);
    return;
  }
  let condition = (0, codegen_1$r._)`${childData} === undefined`;
  if (opts.useDefaults === "empty") {
    condition = (0, codegen_1$r._)`${condition} || ${childData} === null || ${childData} === ""`;
  }
  gen.if(condition, (0, codegen_1$r._)`${childData} = ${(0, codegen_1$r.stringify)(defaultValue)}`);
}
var keyword = {};
var code = {};
Object.defineProperty(code, "__esModule", { value: true });
code.validateUnion = code.validateArray = code.usePattern = code.callValidateCode = code.schemaProperties = code.allSchemaProperties = code.noPropertyInData = code.propertyInData = code.isOwnProperty = code.hasPropFunc = code.reportMissingProp = code.checkMissingProp = code.checkReportMissingProp = void 0;
const codegen_1$q = codegen;
const util_1$o = util;
const names_1$5 = names$1;
const util_2$1 = util;
function checkReportMissingProp(cxt, prop) {
  const { gen, data, it: it2 } = cxt;
  gen.if(noPropertyInData(gen, data, prop, it2.opts.ownProperties), () => {
    cxt.setParams({ missingProperty: (0, codegen_1$q._)`${prop}` }, true);
    cxt.error();
  });
}
code.checkReportMissingProp = checkReportMissingProp;
function checkMissingProp({ gen, data, it: { opts } }, properties2, missing) {
  return (0, codegen_1$q.or)(...properties2.map((prop) => (0, codegen_1$q.and)(noPropertyInData(gen, data, prop, opts.ownProperties), (0, codegen_1$q._)`${missing} = ${prop}`)));
}
code.checkMissingProp = checkMissingProp;
function reportMissingProp(cxt, missing) {
  cxt.setParams({ missingProperty: missing }, true);
  cxt.error();
}
code.reportMissingProp = reportMissingProp;
function hasPropFunc(gen) {
  return gen.scopeValue("func", {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    ref: Object.prototype.hasOwnProperty,
    code: (0, codegen_1$q._)`Object.prototype.hasOwnProperty`
  });
}
code.hasPropFunc = hasPropFunc;
function isOwnProperty(gen, data, property2) {
  return (0, codegen_1$q._)`${hasPropFunc(gen)}.call(${data}, ${property2})`;
}
code.isOwnProperty = isOwnProperty;
function propertyInData(gen, data, property2, ownProperties) {
  const cond = (0, codegen_1$q._)`${data}${(0, codegen_1$q.getProperty)(property2)} !== undefined`;
  return ownProperties ? (0, codegen_1$q._)`${cond} && ${isOwnProperty(gen, data, property2)}` : cond;
}
code.propertyInData = propertyInData;
function noPropertyInData(gen, data, property2, ownProperties) {
  const cond = (0, codegen_1$q._)`${data}${(0, codegen_1$q.getProperty)(property2)} === undefined`;
  return ownProperties ? (0, codegen_1$q.or)(cond, (0, codegen_1$q.not)(isOwnProperty(gen, data, property2))) : cond;
}
code.noPropertyInData = noPropertyInData;
function allSchemaProperties(schemaMap) {
  return schemaMap ? Object.keys(schemaMap).filter((p2) => p2 !== "__proto__") : [];
}
code.allSchemaProperties = allSchemaProperties;
function schemaProperties(it2, schemaMap) {
  return allSchemaProperties(schemaMap).filter((p2) => !(0, util_1$o.alwaysValidSchema)(it2, schemaMap[p2]));
}
code.schemaProperties = schemaProperties;
function callValidateCode({ schemaCode, data, it: { gen, topSchemaRef, schemaPath, errorPath }, it: it2 }, func, context, passSchema) {
  const dataAndSchema = passSchema ? (0, codegen_1$q._)`${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
  const valCxt = [
    [names_1$5.default.instancePath, (0, codegen_1$q.strConcat)(names_1$5.default.instancePath, errorPath)],
    [names_1$5.default.parentData, it2.parentData],
    [names_1$5.default.parentDataProperty, it2.parentDataProperty],
    [names_1$5.default.rootData, names_1$5.default.rootData]
  ];
  if (it2.opts.dynamicRef)
    valCxt.push([names_1$5.default.dynamicAnchors, names_1$5.default.dynamicAnchors]);
  const args = (0, codegen_1$q._)`${dataAndSchema}, ${gen.object(...valCxt)}`;
  return context !== codegen_1$q.nil ? (0, codegen_1$q._)`${func}.call(${context}, ${args})` : (0, codegen_1$q._)`${func}(${args})`;
}
code.callValidateCode = callValidateCode;
const newRegExp = (0, codegen_1$q._)`new RegExp`;
function usePattern({ gen, it: { opts } }, pattern2) {
  const u3 = opts.unicodeRegExp ? "u" : "";
  const { regExp } = opts.code;
  const rx = regExp(pattern2, u3);
  return gen.scopeValue("pattern", {
    key: rx.toString(),
    ref: rx,
    code: (0, codegen_1$q._)`${regExp.code === "new RegExp" ? newRegExp : (0, util_2$1.useFunc)(gen, regExp)}(${pattern2}, ${u3})`
  });
}
code.usePattern = usePattern;
function validateArray(cxt) {
  const { gen, data, keyword: keyword2, it: it2 } = cxt;
  const valid = gen.name("valid");
  if (it2.allErrors) {
    const validArr = gen.let("valid", true);
    validateItems(() => gen.assign(validArr, false));
    return validArr;
  }
  gen.var(valid, true);
  validateItems(() => gen.break());
  return valid;
  function validateItems(notValid) {
    const len = gen.const("len", (0, codegen_1$q._)`${data}.length`);
    gen.forRange("i", 0, len, (i3) => {
      cxt.subschema({
        keyword: keyword2,
        dataProp: i3,
        dataPropType: util_1$o.Type.Num
      }, valid);
      gen.if((0, codegen_1$q.not)(valid), notValid);
    });
  }
}
code.validateArray = validateArray;
function validateUnion(cxt) {
  const { gen, schema, keyword: keyword2, it: it2 } = cxt;
  if (!Array.isArray(schema))
    throw new Error("ajv implementation error");
  const alwaysValid = schema.some((sch) => (0, util_1$o.alwaysValidSchema)(it2, sch));
  if (alwaysValid && !it2.opts.unevaluated)
    return;
  const valid = gen.let("valid", false);
  const schValid = gen.name("_valid");
  gen.block(() => schema.forEach((_sch, i3) => {
    const schCxt = cxt.subschema({
      keyword: keyword2,
      schemaProp: i3,
      compositeRule: true
    }, schValid);
    gen.assign(valid, (0, codegen_1$q._)`${valid} || ${schValid}`);
    const merged = cxt.mergeValidEvaluated(schCxt, schValid);
    if (!merged)
      gen.if((0, codegen_1$q.not)(valid));
  }));
  cxt.result(valid, () => cxt.reset(), () => cxt.error(true));
}
code.validateUnion = validateUnion;
Object.defineProperty(keyword, "__esModule", { value: true });
keyword.validateKeywordUsage = keyword.validSchemaType = keyword.funcKeywordCode = keyword.macroKeywordCode = void 0;
const codegen_1$p = codegen;
const names_1$4 = names$1;
const code_1$9 = code;
const errors_1$1 = errors;
function macroKeywordCode(cxt, def2) {
  const { gen, keyword: keyword2, schema, parentSchema, it: it2 } = cxt;
  const macroSchema = def2.macro.call(it2.self, schema, parentSchema, it2);
  const schemaRef = useKeyword(gen, keyword2, macroSchema);
  if (it2.opts.validateSchema !== false)
    it2.self.validateSchema(macroSchema, true);
  const valid = gen.name("valid");
  cxt.subschema({
    schema: macroSchema,
    schemaPath: codegen_1$p.nil,
    errSchemaPath: `${it2.errSchemaPath}/${keyword2}`,
    topSchemaRef: schemaRef,
    compositeRule: true
  }, valid);
  cxt.pass(valid, () => cxt.error(true));
}
keyword.macroKeywordCode = macroKeywordCode;
function funcKeywordCode(cxt, def2) {
  var _a2;
  const { gen, keyword: keyword2, schema, parentSchema, $data, it: it2 } = cxt;
  checkAsyncKeyword(it2, def2);
  const validate2 = !$data && def2.compile ? def2.compile.call(it2.self, schema, parentSchema, it2) : def2.validate;
  const validateRef = useKeyword(gen, keyword2, validate2);
  const valid = gen.let("valid");
  cxt.block$data(valid, validateKeyword);
  cxt.ok((_a2 = def2.valid) !== null && _a2 !== void 0 ? _a2 : valid);
  function validateKeyword() {
    if (def2.errors === false) {
      assignValid();
      if (def2.modifying)
        modifyData(cxt);
      reportErrs(() => cxt.error());
    } else {
      const ruleErrs = def2.async ? validateAsync() : validateSync();
      if (def2.modifying)
        modifyData(cxt);
      reportErrs(() => addErrs(cxt, ruleErrs));
    }
  }
  function validateAsync() {
    const ruleErrs = gen.let("ruleErrs", null);
    gen.try(() => assignValid((0, codegen_1$p._)`await `), (e5) => gen.assign(valid, false).if((0, codegen_1$p._)`${e5} instanceof ${it2.ValidationError}`, () => gen.assign(ruleErrs, (0, codegen_1$p._)`${e5}.errors`), () => gen.throw(e5)));
    return ruleErrs;
  }
  function validateSync() {
    const validateErrs = (0, codegen_1$p._)`${validateRef}.errors`;
    gen.assign(validateErrs, null);
    assignValid(codegen_1$p.nil);
    return validateErrs;
  }
  function assignValid(_await = def2.async ? (0, codegen_1$p._)`await ` : codegen_1$p.nil) {
    const passCxt = it2.opts.passContext ? names_1$4.default.this : names_1$4.default.self;
    const passSchema = !("compile" in def2 && !$data || def2.schema === false);
    gen.assign(valid, (0, codegen_1$p._)`${_await}${(0, code_1$9.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def2.modifying);
  }
  function reportErrs(errors2) {
    var _a3;
    gen.if((0, codegen_1$p.not)((_a3 = def2.valid) !== null && _a3 !== void 0 ? _a3 : valid), errors2);
  }
}
keyword.funcKeywordCode = funcKeywordCode;
function modifyData(cxt) {
  const { gen, data, it: it2 } = cxt;
  gen.if(it2.parentData, () => gen.assign(data, (0, codegen_1$p._)`${it2.parentData}[${it2.parentDataProperty}]`));
}
function addErrs(cxt, errs) {
  const { gen } = cxt;
  gen.if((0, codegen_1$p._)`Array.isArray(${errs})`, () => {
    gen.assign(names_1$4.default.vErrors, (0, codegen_1$p._)`${names_1$4.default.vErrors} === null ? ${errs} : ${names_1$4.default.vErrors}.concat(${errs})`).assign(names_1$4.default.errors, (0, codegen_1$p._)`${names_1$4.default.vErrors}.length`);
    (0, errors_1$1.extendErrors)(cxt);
  }, () => cxt.error());
}
function checkAsyncKeyword({ schemaEnv }, def2) {
  if (def2.async && !schemaEnv.$async)
    throw new Error("async keyword in sync schema");
}
function useKeyword(gen, keyword2, result2) {
  if (result2 === void 0)
    throw new Error(`keyword "${keyword2}" failed to compile`);
  return gen.scopeValue("keyword", typeof result2 == "function" ? { ref: result2 } : { ref: result2, code: (0, codegen_1$p.stringify)(result2) });
}
function validSchemaType(schema, schemaType, allowUndefined = false) {
  return !schemaType.length || schemaType.some((st2) => st2 === "array" ? Array.isArray(schema) : st2 === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st2 || allowUndefined && typeof schema == "undefined");
}
keyword.validSchemaType = validSchemaType;
function validateKeywordUsage({ schema, opts, self: self2, errSchemaPath }, def2, keyword2) {
  if (Array.isArray(def2.keyword) ? !def2.keyword.includes(keyword2) : def2.keyword !== keyword2) {
    throw new Error("ajv implementation error");
  }
  const deps = def2.dependencies;
  if (deps === null || deps === void 0 ? void 0 : deps.some((kwd) => !Object.prototype.hasOwnProperty.call(schema, kwd))) {
    throw new Error(`parent schema must have dependencies of ${keyword2}: ${deps.join(",")}`);
  }
  if (def2.validateSchema) {
    const valid = def2.validateSchema(schema[keyword2]);
    if (!valid) {
      const msg2 = `keyword "${keyword2}" value is invalid at path "${errSchemaPath}": ` + self2.errorsText(def2.validateSchema.errors);
      if (opts.validateSchema === "log")
        self2.logger.error(msg2);
      else
        throw new Error(msg2);
    }
  }
}
keyword.validateKeywordUsage = validateKeywordUsage;
var subschema = {};
Object.defineProperty(subschema, "__esModule", { value: true });
subschema.extendSubschemaMode = subschema.extendSubschemaData = subschema.getSubschema = void 0;
const codegen_1$o = codegen;
const util_1$n = util;
function getSubschema(it2, { keyword: keyword2, schemaProp, schema, schemaPath, errSchemaPath, topSchemaRef }) {
  if (keyword2 !== void 0 && schema !== void 0) {
    throw new Error('both "keyword" and "schema" passed, only one allowed');
  }
  if (keyword2 !== void 0) {
    const sch = it2.schema[keyword2];
    return schemaProp === void 0 ? {
      schema: sch,
      schemaPath: (0, codegen_1$o._)`${it2.schemaPath}${(0, codegen_1$o.getProperty)(keyword2)}`,
      errSchemaPath: `${it2.errSchemaPath}/${keyword2}`
    } : {
      schema: sch[schemaProp],
      schemaPath: (0, codegen_1$o._)`${it2.schemaPath}${(0, codegen_1$o.getProperty)(keyword2)}${(0, codegen_1$o.getProperty)(schemaProp)}`,
      errSchemaPath: `${it2.errSchemaPath}/${keyword2}/${(0, util_1$n.escapeFragment)(schemaProp)}`
    };
  }
  if (schema !== void 0) {
    if (schemaPath === void 0 || errSchemaPath === void 0 || topSchemaRef === void 0) {
      throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
    }
    return {
      schema,
      schemaPath,
      topSchemaRef,
      errSchemaPath
    };
  }
  throw new Error('either "keyword" or "schema" must be passed');
}
subschema.getSubschema = getSubschema;
function extendSubschemaData(subschema2, it2, { dataProp, dataPropType: dpType, data, dataTypes, propertyName }) {
  if (data !== void 0 && dataProp !== void 0) {
    throw new Error('both "data" and "dataProp" passed, only one allowed');
  }
  const { gen } = it2;
  if (dataProp !== void 0) {
    const { errorPath, dataPathArr, opts } = it2;
    const nextData = gen.let("data", (0, codegen_1$o._)`${it2.data}${(0, codegen_1$o.getProperty)(dataProp)}`, true);
    dataContextProps(nextData);
    subschema2.errorPath = (0, codegen_1$o.str)`${errorPath}${(0, util_1$n.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
    subschema2.parentDataProperty = (0, codegen_1$o._)`${dataProp}`;
    subschema2.dataPathArr = [...dataPathArr, subschema2.parentDataProperty];
  }
  if (data !== void 0) {
    const nextData = data instanceof codegen_1$o.Name ? data : gen.let("data", data, true);
    dataContextProps(nextData);
    if (propertyName !== void 0)
      subschema2.propertyName = propertyName;
  }
  if (dataTypes)
    subschema2.dataTypes = dataTypes;
  function dataContextProps(_nextData) {
    subschema2.data = _nextData;
    subschema2.dataLevel = it2.dataLevel + 1;
    subschema2.dataTypes = [];
    it2.definedProperties = /* @__PURE__ */ new Set();
    subschema2.parentData = it2.data;
    subschema2.dataNames = [...it2.dataNames, _nextData];
  }
}
subschema.extendSubschemaData = extendSubschemaData;
function extendSubschemaMode(subschema2, { jtdDiscriminator, jtdMetadata, compositeRule, createErrors, allErrors }) {
  if (compositeRule !== void 0)
    subschema2.compositeRule = compositeRule;
  if (createErrors !== void 0)
    subschema2.createErrors = createErrors;
  if (allErrors !== void 0)
    subschema2.allErrors = allErrors;
  subschema2.jtdDiscriminator = jtdDiscriminator;
  subschema2.jtdMetadata = jtdMetadata;
}
subschema.extendSubschemaMode = extendSubschemaMode;
var resolve$1 = {};
var fastDeepEqual = function equal(a4, b3) {
  if (a4 === b3) return true;
  if (a4 && b3 && typeof a4 == "object" && typeof b3 == "object") {
    if (a4.constructor !== b3.constructor) return false;
    var length, i3, keys4;
    if (Array.isArray(a4)) {
      length = a4.length;
      if (length != b3.length) return false;
      for (i3 = length; i3-- !== 0; )
        if (!equal(a4[i3], b3[i3])) return false;
      return true;
    }
    if (a4.constructor === RegExp) return a4.source === b3.source && a4.flags === b3.flags;
    if (a4.valueOf !== Object.prototype.valueOf) return a4.valueOf() === b3.valueOf();
    if (a4.toString !== Object.prototype.toString) return a4.toString() === b3.toString();
    keys4 = Object.keys(a4);
    length = keys4.length;
    if (length !== Object.keys(b3).length) return false;
    for (i3 = length; i3-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b3, keys4[i3])) return false;
    for (i3 = length; i3-- !== 0; ) {
      var key2 = keys4[i3];
      if (!equal(a4[key2], b3[key2])) return false;
    }
    return true;
  }
  return a4 !== a4 && b3 !== b3;
};
var jsonSchemaTraverse = { exports: {} };
var traverse$1 = jsonSchemaTraverse.exports = function(schema, opts, cb) {
  if (typeof opts == "function") {
    cb = opts;
    opts = {};
  }
  cb = opts.cb || cb;
  var pre = typeof cb == "function" ? cb : cb.pre || function() {
  };
  var post = cb.post || function() {
  };
  _traverse(opts, pre, post, schema, "", schema);
};
traverse$1.keywords = {
  additionalItems: true,
  items: true,
  contains: true,
  additionalProperties: true,
  propertyNames: true,
  not: true,
  if: true,
  then: true,
  else: true
};
traverse$1.arrayKeywords = {
  items: true,
  allOf: true,
  anyOf: true,
  oneOf: true
};
traverse$1.propsKeywords = {
  $defs: true,
  definitions: true,
  properties: true,
  patternProperties: true,
  dependencies: true
};
traverse$1.skipKeywords = {
  default: true,
  enum: true,
  const: true,
  required: true,
  maximum: true,
  minimum: true,
  exclusiveMaximum: true,
  exclusiveMinimum: true,
  multipleOf: true,
  maxLength: true,
  minLength: true,
  pattern: true,
  format: true,
  maxItems: true,
  minItems: true,
  uniqueItems: true,
  maxProperties: true,
  minProperties: true
};
function _traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
  if (schema && typeof schema == "object" && !Array.isArray(schema)) {
    pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    for (var key2 in schema) {
      var sch = schema[key2];
      if (Array.isArray(sch)) {
        if (key2 in traverse$1.arrayKeywords) {
          for (var i3 = 0; i3 < sch.length; i3++)
            _traverse(opts, pre, post, sch[i3], jsonPtr + "/" + key2 + "/" + i3, rootSchema, jsonPtr, key2, schema, i3);
        }
      } else if (key2 in traverse$1.propsKeywords) {
        if (sch && typeof sch == "object") {
          for (var prop in sch)
            _traverse(opts, pre, post, sch[prop], jsonPtr + "/" + key2 + "/" + escapeJsonPtr(prop), rootSchema, jsonPtr, key2, schema, prop);
        }
      } else if (key2 in traverse$1.keywords || opts.allKeys && !(key2 in traverse$1.skipKeywords)) {
        _traverse(opts, pre, post, sch, jsonPtr + "/" + key2, rootSchema, jsonPtr, key2, schema);
      }
    }
    post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
  }
}
function escapeJsonPtr(str) {
  return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
var jsonSchemaTraverseExports = jsonSchemaTraverse.exports;
Object.defineProperty(resolve$1, "__esModule", { value: true });
resolve$1.getSchemaRefs = resolve$1.resolveUrl = resolve$1.normalizeId = resolve$1._getFullPath = resolve$1.getFullPath = resolve$1.inlineRef = void 0;
const util_1$m = util;
const equal$2 = fastDeepEqual;
const traverse = jsonSchemaTraverseExports;
const SIMPLE_INLINED = /* @__PURE__ */ new Set([
  "type",
  "format",
  "pattern",
  "maxLength",
  "minLength",
  "maxProperties",
  "minProperties",
  "maxItems",
  "minItems",
  "maximum",
  "minimum",
  "uniqueItems",
  "multipleOf",
  "required",
  "enum",
  "const"
]);
function inlineRef(schema, limit2 = true) {
  if (typeof schema == "boolean")
    return true;
  if (limit2 === true)
    return !hasRef(schema);
  if (!limit2)
    return false;
  return countKeys(schema) <= limit2;
}
resolve$1.inlineRef = inlineRef;
const REF_KEYWORDS = /* @__PURE__ */ new Set([
  "$ref",
  "$recursiveRef",
  "$recursiveAnchor",
  "$dynamicRef",
  "$dynamicAnchor"
]);
function hasRef(schema) {
  for (const key2 in schema) {
    if (REF_KEYWORDS.has(key2))
      return true;
    const sch = schema[key2];
    if (Array.isArray(sch) && sch.some(hasRef))
      return true;
    if (typeof sch == "object" && hasRef(sch))
      return true;
  }
  return false;
}
function countKeys(schema) {
  let count = 0;
  for (const key2 in schema) {
    if (key2 === "$ref")
      return Infinity;
    count++;
    if (SIMPLE_INLINED.has(key2))
      continue;
    if (typeof schema[key2] == "object") {
      (0, util_1$m.eachItem)(schema[key2], (sch) => count += countKeys(sch));
    }
    if (count === Infinity)
      return Infinity;
  }
  return count;
}
function getFullPath(resolver, id2 = "", normalize4) {
  if (normalize4 !== false)
    id2 = normalizeId(id2);
  const p2 = resolver.parse(id2);
  return _getFullPath(resolver, p2);
}
resolve$1.getFullPath = getFullPath;
function _getFullPath(resolver, p2) {
  const serialized = resolver.serialize(p2);
  return serialized.split("#")[0] + "#";
}
resolve$1._getFullPath = _getFullPath;
const TRAILING_SLASH_HASH = /#\/?$/;
function normalizeId(id2) {
  return id2 ? id2.replace(TRAILING_SLASH_HASH, "") : "";
}
resolve$1.normalizeId = normalizeId;
function resolveUrl(resolver, baseId, id2) {
  id2 = normalizeId(id2);
  return resolver.resolve(baseId, id2);
}
resolve$1.resolveUrl = resolveUrl;
const ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function getSchemaRefs(schema, baseId) {
  if (typeof schema == "boolean")
    return {};
  const { schemaId, uriResolver } = this.opts;
  const schId = normalizeId(schema[schemaId] || baseId);
  const baseIds = { "": schId };
  const pathPrefix = getFullPath(uriResolver, schId, false);
  const localRefs = {};
  const schemaRefs = /* @__PURE__ */ new Set();
  traverse(schema, { allKeys: true }, (sch, jsonPtr, _2, parentJsonPtr) => {
    if (parentJsonPtr === void 0)
      return;
    const fullPath = pathPrefix + jsonPtr;
    let innerBaseId = baseIds[parentJsonPtr];
    if (typeof sch[schemaId] == "string")
      innerBaseId = addRef.call(this, sch[schemaId]);
    addAnchor.call(this, sch.$anchor);
    addAnchor.call(this, sch.$dynamicAnchor);
    baseIds[jsonPtr] = innerBaseId;
    function addRef(ref2) {
      const _resolve = this.opts.uriResolver.resolve;
      ref2 = normalizeId(innerBaseId ? _resolve(innerBaseId, ref2) : ref2);
      if (schemaRefs.has(ref2))
        throw ambiguos(ref2);
      schemaRefs.add(ref2);
      let schOrRef = this.refs[ref2];
      if (typeof schOrRef == "string")
        schOrRef = this.refs[schOrRef];
      if (typeof schOrRef == "object") {
        checkAmbiguosRef(sch, schOrRef.schema, ref2);
      } else if (ref2 !== normalizeId(fullPath)) {
        if (ref2[0] === "#") {
          checkAmbiguosRef(sch, localRefs[ref2], ref2);
          localRefs[ref2] = sch;
        } else {
          this.refs[ref2] = fullPath;
        }
      }
      return ref2;
    }
    function addAnchor(anchor) {
      if (typeof anchor == "string") {
        if (!ANCHOR.test(anchor))
          throw new Error(`invalid anchor "${anchor}"`);
        addRef.call(this, `#${anchor}`);
      }
    }
  });
  return localRefs;
  function checkAmbiguosRef(sch1, sch2, ref2) {
    if (sch2 !== void 0 && !equal$2(sch1, sch2))
      throw ambiguos(ref2);
  }
  function ambiguos(ref2) {
    return new Error(`reference "${ref2}" resolves to more than one schema`);
  }
}
resolve$1.getSchemaRefs = getSchemaRefs;
Object.defineProperty(validate$1, "__esModule", { value: true });
validate$1.getData = validate$1.KeywordCxt = validate$1.validateFunctionCode = void 0;
const boolSchema_1 = boolSchema;
const dataType_1$1 = dataType;
const applicability_1 = applicability;
const dataType_2 = dataType;
const defaults_1 = defaults$3;
const keyword_1 = keyword;
const subschema_1 = subschema;
const codegen_1$n = codegen;
const names_1$3 = names$1;
const resolve_1$2 = resolve$1;
const util_1$l = util;
const errors_1 = errors;
function validateFunctionCode(it2) {
  if (isSchemaObj(it2)) {
    checkKeywords(it2);
    if (schemaCxtHasRules(it2)) {
      topSchemaObjCode(it2);
      return;
    }
  }
  validateFunction(it2, () => (0, boolSchema_1.topBoolOrEmptySchema)(it2));
}
validate$1.validateFunctionCode = validateFunctionCode;
function validateFunction({ gen, validateName, schema, schemaEnv, opts }, body) {
  if (opts.code.es5) {
    gen.func(validateName, (0, codegen_1$n._)`${names_1$3.default.data}, ${names_1$3.default.valCxt}`, schemaEnv.$async, () => {
      gen.code((0, codegen_1$n._)`"use strict"; ${funcSourceUrl(schema, opts)}`);
      destructureValCxtES5(gen, opts);
      gen.code(body);
    });
  } else {
    gen.func(validateName, (0, codegen_1$n._)`${names_1$3.default.data}, ${destructureValCxt(opts)}`, schemaEnv.$async, () => gen.code(funcSourceUrl(schema, opts)).code(body));
  }
}
function destructureValCxt(opts) {
  return (0, codegen_1$n._)`{${names_1$3.default.instancePath}="", ${names_1$3.default.parentData}, ${names_1$3.default.parentDataProperty}, ${names_1$3.default.rootData}=${names_1$3.default.data}${opts.dynamicRef ? (0, codegen_1$n._)`, ${names_1$3.default.dynamicAnchors}={}` : codegen_1$n.nil}}={}`;
}
function destructureValCxtES5(gen, opts) {
  gen.if(names_1$3.default.valCxt, () => {
    gen.var(names_1$3.default.instancePath, (0, codegen_1$n._)`${names_1$3.default.valCxt}.${names_1$3.default.instancePath}`);
    gen.var(names_1$3.default.parentData, (0, codegen_1$n._)`${names_1$3.default.valCxt}.${names_1$3.default.parentData}`);
    gen.var(names_1$3.default.parentDataProperty, (0, codegen_1$n._)`${names_1$3.default.valCxt}.${names_1$3.default.parentDataProperty}`);
    gen.var(names_1$3.default.rootData, (0, codegen_1$n._)`${names_1$3.default.valCxt}.${names_1$3.default.rootData}`);
    if (opts.dynamicRef)
      gen.var(names_1$3.default.dynamicAnchors, (0, codegen_1$n._)`${names_1$3.default.valCxt}.${names_1$3.default.dynamicAnchors}`);
  }, () => {
    gen.var(names_1$3.default.instancePath, (0, codegen_1$n._)`""`);
    gen.var(names_1$3.default.parentData, (0, codegen_1$n._)`undefined`);
    gen.var(names_1$3.default.parentDataProperty, (0, codegen_1$n._)`undefined`);
    gen.var(names_1$3.default.rootData, names_1$3.default.data);
    if (opts.dynamicRef)
      gen.var(names_1$3.default.dynamicAnchors, (0, codegen_1$n._)`{}`);
  });
}
function topSchemaObjCode(it2) {
  const { schema, opts, gen } = it2;
  validateFunction(it2, () => {
    if (opts.$comment && schema.$comment)
      commentKeyword(it2);
    checkNoDefault(it2);
    gen.let(names_1$3.default.vErrors, null);
    gen.let(names_1$3.default.errors, 0);
    if (opts.unevaluated)
      resetEvaluated(it2);
    typeAndKeywords(it2);
    returnResults(it2);
  });
  return;
}
function resetEvaluated(it2) {
  const { gen, validateName } = it2;
  it2.evaluated = gen.const("evaluated", (0, codegen_1$n._)`${validateName}.evaluated`);
  gen.if((0, codegen_1$n._)`${it2.evaluated}.dynamicProps`, () => gen.assign((0, codegen_1$n._)`${it2.evaluated}.props`, (0, codegen_1$n._)`undefined`));
  gen.if((0, codegen_1$n._)`${it2.evaluated}.dynamicItems`, () => gen.assign((0, codegen_1$n._)`${it2.evaluated}.items`, (0, codegen_1$n._)`undefined`));
}
function funcSourceUrl(schema, opts) {
  const schId = typeof schema == "object" && schema[opts.schemaId];
  return schId && (opts.code.source || opts.code.process) ? (0, codegen_1$n._)`/*# sourceURL=${schId} */` : codegen_1$n.nil;
}
function subschemaCode(it2, valid) {
  if (isSchemaObj(it2)) {
    checkKeywords(it2);
    if (schemaCxtHasRules(it2)) {
      subSchemaObjCode(it2, valid);
      return;
    }
  }
  (0, boolSchema_1.boolOrEmptySchema)(it2, valid);
}
function schemaCxtHasRules({ schema, self: self2 }) {
  if (typeof schema == "boolean")
    return !schema;
  for (const key2 in schema)
    if (self2.RULES.all[key2])
      return true;
  return false;
}
function isSchemaObj(it2) {
  return typeof it2.schema != "boolean";
}
function subSchemaObjCode(it2, valid) {
  const { schema, gen, opts } = it2;
  if (opts.$comment && schema.$comment)
    commentKeyword(it2);
  updateContext(it2);
  checkAsyncSchema(it2);
  const errsCount = gen.const("_errs", names_1$3.default.errors);
  typeAndKeywords(it2, errsCount);
  gen.var(valid, (0, codegen_1$n._)`${errsCount} === ${names_1$3.default.errors}`);
}
function checkKeywords(it2) {
  (0, util_1$l.checkUnknownRules)(it2);
  checkRefsAndKeywords(it2);
}
function typeAndKeywords(it2, errsCount) {
  if (it2.opts.jtd)
    return schemaKeywords(it2, [], false, errsCount);
  const types2 = (0, dataType_1$1.getSchemaTypes)(it2.schema);
  const checkedTypes = (0, dataType_1$1.coerceAndCheckDataType)(it2, types2);
  schemaKeywords(it2, types2, !checkedTypes, errsCount);
}
function checkRefsAndKeywords(it2) {
  const { schema, errSchemaPath, opts, self: self2 } = it2;
  if (schema.$ref && opts.ignoreKeywordsWithRef && (0, util_1$l.schemaHasRulesButRef)(schema, self2.RULES)) {
    self2.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
  }
}
function checkNoDefault(it2) {
  const { schema, opts } = it2;
  if (schema.default !== void 0 && opts.useDefaults && opts.strictSchema) {
    (0, util_1$l.checkStrictMode)(it2, "default is ignored in the schema root");
  }
}
function updateContext(it2) {
  const schId = it2.schema[it2.opts.schemaId];
  if (schId)
    it2.baseId = (0, resolve_1$2.resolveUrl)(it2.opts.uriResolver, it2.baseId, schId);
}
function checkAsyncSchema(it2) {
  if (it2.schema.$async && !it2.schemaEnv.$async)
    throw new Error("async schema in sync schema");
}
function commentKeyword({ gen, schemaEnv, schema, errSchemaPath, opts }) {
  const msg2 = schema.$comment;
  if (opts.$comment === true) {
    gen.code((0, codegen_1$n._)`${names_1$3.default.self}.logger.log(${msg2})`);
  } else if (typeof opts.$comment == "function") {
    const schemaPath = (0, codegen_1$n.str)`${errSchemaPath}/$comment`;
    const rootName = gen.scopeValue("root", { ref: schemaEnv.root });
    gen.code((0, codegen_1$n._)`${names_1$3.default.self}.opts.$comment(${msg2}, ${schemaPath}, ${rootName}.schema)`);
  }
}
function returnResults(it2) {
  const { gen, schemaEnv, validateName, ValidationError: ValidationError2, opts } = it2;
  if (schemaEnv.$async) {
    gen.if((0, codegen_1$n._)`${names_1$3.default.errors} === 0`, () => gen.return(names_1$3.default.data), () => gen.throw((0, codegen_1$n._)`new ${ValidationError2}(${names_1$3.default.vErrors})`));
  } else {
    gen.assign((0, codegen_1$n._)`${validateName}.errors`, names_1$3.default.vErrors);
    if (opts.unevaluated)
      assignEvaluated(it2);
    gen.return((0, codegen_1$n._)`${names_1$3.default.errors} === 0`);
  }
}
function assignEvaluated({ gen, evaluated, props: props2, items: items2 }) {
  if (props2 instanceof codegen_1$n.Name)
    gen.assign((0, codegen_1$n._)`${evaluated}.props`, props2);
  if (items2 instanceof codegen_1$n.Name)
    gen.assign((0, codegen_1$n._)`${evaluated}.items`, items2);
}
function schemaKeywords(it2, types2, typeErrors, errsCount) {
  const { gen, schema, data, allErrors, opts, self: self2 } = it2;
  const { RULES } = self2;
  if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, util_1$l.schemaHasRulesButRef)(schema, RULES))) {
    gen.block(() => keywordCode(it2, "$ref", RULES.all.$ref.definition));
    return;
  }
  if (!opts.jtd)
    checkStrictTypes(it2, types2);
  gen.block(() => {
    for (const group of RULES.rules)
      groupKeywords(group);
    groupKeywords(RULES.post);
  });
  function groupKeywords(group) {
    if (!(0, applicability_1.shouldUseGroup)(schema, group))
      return;
    if (group.type) {
      gen.if((0, dataType_2.checkDataType)(group.type, data, opts.strictNumbers));
      iterateKeywords(it2, group);
      if (types2.length === 1 && types2[0] === group.type && typeErrors) {
        gen.else();
        (0, dataType_2.reportTypeError)(it2);
      }
      gen.endIf();
    } else {
      iterateKeywords(it2, group);
    }
    if (!allErrors)
      gen.if((0, codegen_1$n._)`${names_1$3.default.errors} === ${errsCount || 0}`);
  }
}
function iterateKeywords(it2, group) {
  const { gen, schema, opts: { useDefaults } } = it2;
  if (useDefaults)
    (0, defaults_1.assignDefaults)(it2, group.type);
  gen.block(() => {
    for (const rule of group.rules) {
      if ((0, applicability_1.shouldUseRule)(schema, rule)) {
        keywordCode(it2, rule.keyword, rule.definition, group.type);
      }
    }
  });
}
function checkStrictTypes(it2, types2) {
  if (it2.schemaEnv.meta || !it2.opts.strictTypes)
    return;
  checkContextTypes(it2, types2);
  if (!it2.opts.allowUnionTypes)
    checkMultipleTypes(it2, types2);
  checkKeywordTypes(it2, it2.dataTypes);
}
function checkContextTypes(it2, types2) {
  if (!types2.length)
    return;
  if (!it2.dataTypes.length) {
    it2.dataTypes = types2;
    return;
  }
  types2.forEach((t3) => {
    if (!includesType(it2.dataTypes, t3)) {
      strictTypesError(it2, `type "${t3}" not allowed by context "${it2.dataTypes.join(",")}"`);
    }
  });
  narrowSchemaTypes(it2, types2);
}
function checkMultipleTypes(it2, ts) {
  if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) {
    strictTypesError(it2, "use allowUnionTypes to allow union type keyword");
  }
}
function checkKeywordTypes(it2, ts) {
  const rules2 = it2.self.RULES.all;
  for (const keyword2 in rules2) {
    const rule = rules2[keyword2];
    if (typeof rule == "object" && (0, applicability_1.shouldUseRule)(it2.schema, rule)) {
      const { type: type2 } = rule.definition;
      if (type2.length && !type2.some((t3) => hasApplicableType(ts, t3))) {
        strictTypesError(it2, `missing type "${type2.join(",")}" for keyword "${keyword2}"`);
      }
    }
  }
}
function hasApplicableType(schTs, kwdT) {
  return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}
function includesType(ts, t3) {
  return ts.includes(t3) || t3 === "integer" && ts.includes("number");
}
function narrowSchemaTypes(it2, withTypes) {
  const ts = [];
  for (const t3 of it2.dataTypes) {
    if (includesType(withTypes, t3))
      ts.push(t3);
    else if (withTypes.includes("integer") && t3 === "number")
      ts.push("integer");
  }
  it2.dataTypes = ts;
}
function strictTypesError(it2, msg2) {
  const schemaPath = it2.schemaEnv.baseId + it2.errSchemaPath;
  msg2 += ` at "${schemaPath}" (strictTypes)`;
  (0, util_1$l.checkStrictMode)(it2, msg2, it2.opts.strictTypes);
}
class KeywordCxt {
  constructor(it2, def2, keyword2) {
    (0, keyword_1.validateKeywordUsage)(it2, def2, keyword2);
    this.gen = it2.gen;
    this.allErrors = it2.allErrors;
    this.keyword = keyword2;
    this.data = it2.data;
    this.schema = it2.schema[keyword2];
    this.$data = def2.$data && it2.opts.$data && this.schema && this.schema.$data;
    this.schemaValue = (0, util_1$l.schemaRefOrVal)(it2, this.schema, keyword2, this.$data);
    this.schemaType = def2.schemaType;
    this.parentSchema = it2.schema;
    this.params = {};
    this.it = it2;
    this.def = def2;
    if (this.$data) {
      this.schemaCode = it2.gen.const("vSchema", getData(this.$data, it2));
    } else {
      this.schemaCode = this.schemaValue;
      if (!(0, keyword_1.validSchemaType)(this.schema, def2.schemaType, def2.allowUndefined)) {
        throw new Error(`${keyword2} value must be ${JSON.stringify(def2.schemaType)}`);
      }
    }
    if ("code" in def2 ? def2.trackErrors : def2.errors !== false) {
      this.errsCount = it2.gen.const("_errs", names_1$3.default.errors);
    }
  }
  result(condition, successAction, failAction) {
    this.failResult((0, codegen_1$n.not)(condition), successAction, failAction);
  }
  failResult(condition, successAction, failAction) {
    this.gen.if(condition);
    if (failAction)
      failAction();
    else
      this.error();
    if (successAction) {
      this.gen.else();
      successAction();
      if (this.allErrors)
        this.gen.endIf();
    } else {
      if (this.allErrors)
        this.gen.endIf();
      else
        this.gen.else();
    }
  }
  pass(condition, failAction) {
    this.failResult((0, codegen_1$n.not)(condition), void 0, failAction);
  }
  fail(condition) {
    if (condition === void 0) {
      this.error();
      if (!this.allErrors)
        this.gen.if(false);
      return;
    }
    this.gen.if(condition);
    this.error();
    if (this.allErrors)
      this.gen.endIf();
    else
      this.gen.else();
  }
  fail$data(condition) {
    if (!this.$data)
      return this.fail(condition);
    const { schemaCode } = this;
    this.fail((0, codegen_1$n._)`${schemaCode} !== undefined && (${(0, codegen_1$n.or)(this.invalid$data(), condition)})`);
  }
  error(append, errorParams, errorPaths) {
    if (errorParams) {
      this.setParams(errorParams);
      this._error(append, errorPaths);
      this.setParams({});
      return;
    }
    this._error(append, errorPaths);
  }
  _error(append, errorPaths) {
    (append ? errors_1.reportExtraError : errors_1.reportError)(this, this.def.error, errorPaths);
  }
  $dataError() {
    (0, errors_1.reportError)(this, this.def.$dataError || errors_1.keyword$DataError);
  }
  reset() {
    if (this.errsCount === void 0)
      throw new Error('add "trackErrors" to keyword definition');
    (0, errors_1.resetErrorsCount)(this.gen, this.errsCount);
  }
  ok(cond) {
    if (!this.allErrors)
      this.gen.if(cond);
  }
  setParams(obj, assign2) {
    if (assign2)
      Object.assign(this.params, obj);
    else
      this.params = obj;
  }
  block$data(valid, codeBlock, $dataValid = codegen_1$n.nil) {
    this.gen.block(() => {
      this.check$data(valid, $dataValid);
      codeBlock();
    });
  }
  check$data(valid = codegen_1$n.nil, $dataValid = codegen_1$n.nil) {
    if (!this.$data)
      return;
    const { gen, schemaCode, schemaType, def: def2 } = this;
    gen.if((0, codegen_1$n.or)((0, codegen_1$n._)`${schemaCode} === undefined`, $dataValid));
    if (valid !== codegen_1$n.nil)
      gen.assign(valid, true);
    if (schemaType.length || def2.validateSchema) {
      gen.elseIf(this.invalid$data());
      this.$dataError();
      if (valid !== codegen_1$n.nil)
        gen.assign(valid, false);
    }
    gen.else();
  }
  invalid$data() {
    const { gen, schemaCode, schemaType, def: def2, it: it2 } = this;
    return (0, codegen_1$n.or)(wrong$DataType(), invalid$DataSchema());
    function wrong$DataType() {
      if (schemaType.length) {
        if (!(schemaCode instanceof codegen_1$n.Name))
          throw new Error("ajv implementation error");
        const st2 = Array.isArray(schemaType) ? schemaType : [schemaType];
        return (0, codegen_1$n._)`${(0, dataType_2.checkDataTypes)(st2, schemaCode, it2.opts.strictNumbers, dataType_2.DataType.Wrong)}`;
      }
      return codegen_1$n.nil;
    }
    function invalid$DataSchema() {
      if (def2.validateSchema) {
        const validateSchemaRef = gen.scopeValue("validate$data", { ref: def2.validateSchema });
        return (0, codegen_1$n._)`!${validateSchemaRef}(${schemaCode})`;
      }
      return codegen_1$n.nil;
    }
  }
  subschema(appl, valid) {
    const subschema2 = (0, subschema_1.getSubschema)(this.it, appl);
    (0, subschema_1.extendSubschemaData)(subschema2, this.it, appl);
    (0, subschema_1.extendSubschemaMode)(subschema2, appl);
    const nextContext = { ...this.it, ...subschema2, items: void 0, props: void 0 };
    subschemaCode(nextContext, valid);
    return nextContext;
  }
  mergeEvaluated(schemaCxt, toName) {
    const { it: it2, gen } = this;
    if (!it2.opts.unevaluated)
      return;
    if (it2.props !== true && schemaCxt.props !== void 0) {
      it2.props = util_1$l.mergeEvaluated.props(gen, schemaCxt.props, it2.props, toName);
    }
    if (it2.items !== true && schemaCxt.items !== void 0) {
      it2.items = util_1$l.mergeEvaluated.items(gen, schemaCxt.items, it2.items, toName);
    }
  }
  mergeValidEvaluated(schemaCxt, valid) {
    const { it: it2, gen } = this;
    if (it2.opts.unevaluated && (it2.props !== true || it2.items !== true)) {
      gen.if(valid, () => this.mergeEvaluated(schemaCxt, codegen_1$n.Name));
      return true;
    }
  }
}
validate$1.KeywordCxt = KeywordCxt;
function keywordCode(it2, keyword2, def2, ruleType) {
  const cxt = new KeywordCxt(it2, def2, keyword2);
  if ("code" in def2) {
    def2.code(cxt, ruleType);
  } else if (cxt.$data && def2.validate) {
    (0, keyword_1.funcKeywordCode)(cxt, def2);
  } else if ("macro" in def2) {
    (0, keyword_1.macroKeywordCode)(cxt, def2);
  } else if (def2.compile || def2.validate) {
    (0, keyword_1.funcKeywordCode)(cxt, def2);
  }
}
const JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function getData($data, { dataLevel, dataNames, dataPathArr }) {
  let jsonPointer;
  let data;
  if ($data === "")
    return names_1$3.default.rootData;
  if ($data[0] === "/") {
    if (!JSON_POINTER.test($data))
      throw new Error(`Invalid JSON-pointer: ${$data}`);
    jsonPointer = $data;
    data = names_1$3.default.rootData;
  } else {
    const matches2 = RELATIVE_JSON_POINTER.exec($data);
    if (!matches2)
      throw new Error(`Invalid JSON-pointer: ${$data}`);
    const up = +matches2[1];
    jsonPointer = matches2[2];
    if (jsonPointer === "#") {
      if (up >= dataLevel)
        throw new Error(errorMsg("property/index", up));
      return dataPathArr[dataLevel - up];
    }
    if (up > dataLevel)
      throw new Error(errorMsg("data", up));
    data = dataNames[dataLevel - up];
    if (!jsonPointer)
      return data;
  }
  let expr = data;
  const segments = jsonPointer.split("/");
  for (const segment of segments) {
    if (segment) {
      data = (0, codegen_1$n._)`${data}${(0, codegen_1$n.getProperty)((0, util_1$l.unescapeJsonPointer)(segment))}`;
      expr = (0, codegen_1$n._)`${expr} && ${data}`;
    }
  }
  return expr;
  function errorMsg(pointerType, up) {
    return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
  }
}
validate$1.getData = getData;
var validation_error = {};
Object.defineProperty(validation_error, "__esModule", { value: true });
class ValidationError extends Error {
  constructor(errors2) {
    super("validation failed");
    this.errors = errors2;
    this.ajv = this.validation = true;
  }
}
validation_error.default = ValidationError;
var ref_error = {};
Object.defineProperty(ref_error, "__esModule", { value: true });
const resolve_1$1 = resolve$1;
class MissingRefError extends Error {
  constructor(resolver, baseId, ref2, msg2) {
    super(msg2 || `can't resolve reference ${ref2} from id ${baseId}`);
    this.missingRef = (0, resolve_1$1.resolveUrl)(resolver, baseId, ref2);
    this.missingSchema = (0, resolve_1$1.normalizeId)((0, resolve_1$1.getFullPath)(resolver, this.missingRef));
  }
}
ref_error.default = MissingRefError;
var compile = {};
Object.defineProperty(compile, "__esModule", { value: true });
compile.resolveSchema = compile.getCompilingSchema = compile.resolveRef = compile.compileSchema = compile.SchemaEnv = void 0;
const codegen_1$m = codegen;
const validation_error_1 = validation_error;
const names_1$2 = names$1;
const resolve_1 = resolve$1;
const util_1$k = util;
const validate_1$1 = validate$1;
class SchemaEnv {
  constructor(env) {
    var _a2;
    this.refs = {};
    this.dynamicAnchors = {};
    let schema;
    if (typeof env.schema == "object")
      schema = env.schema;
    this.schema = env.schema;
    this.schemaId = env.schemaId;
    this.root = env.root || this;
    this.baseId = (_a2 = env.baseId) !== null && _a2 !== void 0 ? _a2 : (0, resolve_1.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
    this.schemaPath = env.schemaPath;
    this.localRefs = env.localRefs;
    this.meta = env.meta;
    this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
    this.refs = {};
  }
}
compile.SchemaEnv = SchemaEnv;
function compileSchema(sch) {
  const _sch = getCompilingSchema.call(this, sch);
  if (_sch)
    return _sch;
  const rootId = (0, resolve_1.getFullPath)(this.opts.uriResolver, sch.root.baseId);
  const { es5, lines } = this.opts.code;
  const { ownProperties } = this.opts;
  const gen = new codegen_1$m.CodeGen(this.scope, { es5, lines, ownProperties });
  let _ValidationError;
  if (sch.$async) {
    _ValidationError = gen.scopeValue("Error", {
      ref: validation_error_1.default,
      code: (0, codegen_1$m._)`require("ajv/dist/runtime/validation_error").default`
    });
  }
  const validateName = gen.scopeName("validate");
  sch.validateName = validateName;
  const schemaCxt = {
    gen,
    allErrors: this.opts.allErrors,
    data: names_1$2.default.data,
    parentData: names_1$2.default.parentData,
    parentDataProperty: names_1$2.default.parentDataProperty,
    dataNames: [names_1$2.default.data],
    dataPathArr: [codegen_1$m.nil],
    // TODO can its length be used as dataLevel if nil is removed?
    dataLevel: 0,
    dataTypes: [],
    definedProperties: /* @__PURE__ */ new Set(),
    topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true ? { ref: sch.schema, code: (0, codegen_1$m.stringify)(sch.schema) } : { ref: sch.schema }),
    validateName,
    ValidationError: _ValidationError,
    schema: sch.schema,
    schemaEnv: sch,
    rootId,
    baseId: sch.baseId || rootId,
    schemaPath: codegen_1$m.nil,
    errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
    errorPath: (0, codegen_1$m._)`""`,
    opts: this.opts,
    self: this
  };
  let sourceCode;
  try {
    this._compilations.add(sch);
    (0, validate_1$1.validateFunctionCode)(schemaCxt);
    gen.optimize(this.opts.code.optimize);
    const validateCode = gen.toString();
    sourceCode = `${gen.scopeRefs(names_1$2.default.scope)}return ${validateCode}`;
    if (this.opts.code.process)
      sourceCode = this.opts.code.process(sourceCode, sch);
    const makeValidate = new Function(`${names_1$2.default.self}`, `${names_1$2.default.scope}`, sourceCode);
    const validate2 = makeValidate(this, this.scope.get());
    this.scope.value(validateName, { ref: validate2 });
    validate2.errors = null;
    validate2.schema = sch.schema;
    validate2.schemaEnv = sch;
    if (sch.$async)
      validate2.$async = true;
    if (this.opts.code.source === true) {
      validate2.source = { validateName, validateCode, scopeValues: gen._values };
    }
    if (this.opts.unevaluated) {
      const { props: props2, items: items2 } = schemaCxt;
      validate2.evaluated = {
        props: props2 instanceof codegen_1$m.Name ? void 0 : props2,
        items: items2 instanceof codegen_1$m.Name ? void 0 : items2,
        dynamicProps: props2 instanceof codegen_1$m.Name,
        dynamicItems: items2 instanceof codegen_1$m.Name
      };
      if (validate2.source)
        validate2.source.evaluated = (0, codegen_1$m.stringify)(validate2.evaluated);
    }
    sch.validate = validate2;
    return sch;
  } catch (e5) {
    delete sch.validate;
    delete sch.validateName;
    if (sourceCode)
      this.logger.error("Error compiling schema, function code:", sourceCode);
    throw e5;
  } finally {
    this._compilations.delete(sch);
  }
}
compile.compileSchema = compileSchema;
function resolveRef(root2, baseId, ref2) {
  var _a2;
  ref2 = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, ref2);
  const schOrFunc = root2.refs[ref2];
  if (schOrFunc)
    return schOrFunc;
  let _sch = resolve.call(this, root2, ref2);
  if (_sch === void 0) {
    const schema = (_a2 = root2.localRefs) === null || _a2 === void 0 ? void 0 : _a2[ref2];
    const { schemaId } = this.opts;
    if (schema)
      _sch = new SchemaEnv({ schema, schemaId, root: root2, baseId });
  }
  if (_sch === void 0)
    return;
  return root2.refs[ref2] = inlineOrCompile.call(this, _sch);
}
compile.resolveRef = resolveRef;
function inlineOrCompile(sch) {
  if ((0, resolve_1.inlineRef)(sch.schema, this.opts.inlineRefs))
    return sch.schema;
  return sch.validate ? sch : compileSchema.call(this, sch);
}
function getCompilingSchema(schEnv) {
  for (const sch of this._compilations) {
    if (sameSchemaEnv(sch, schEnv))
      return sch;
  }
}
compile.getCompilingSchema = getCompilingSchema;
function sameSchemaEnv(s1, s22) {
  return s1.schema === s22.schema && s1.root === s22.root && s1.baseId === s22.baseId;
}
function resolve(root2, ref2) {
  let sch;
  while (typeof (sch = this.refs[ref2]) == "string")
    ref2 = sch;
  return sch || this.schemas[ref2] || resolveSchema.call(this, root2, ref2);
}
function resolveSchema(root2, ref2) {
  const p2 = this.opts.uriResolver.parse(ref2);
  const refPath = (0, resolve_1._getFullPath)(this.opts.uriResolver, p2);
  let baseId = (0, resolve_1.getFullPath)(this.opts.uriResolver, root2.baseId, void 0);
  if (Object.keys(root2.schema).length > 0 && refPath === baseId) {
    return getJsonPointer.call(this, p2, root2);
  }
  const id2 = (0, resolve_1.normalizeId)(refPath);
  const schOrRef = this.refs[id2] || this.schemas[id2];
  if (typeof schOrRef == "string") {
    const sch = resolveSchema.call(this, root2, schOrRef);
    if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object")
      return;
    return getJsonPointer.call(this, p2, sch);
  }
  if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object")
    return;
  if (!schOrRef.validate)
    compileSchema.call(this, schOrRef);
  if (id2 === (0, resolve_1.normalizeId)(ref2)) {
    const { schema } = schOrRef;
    const { schemaId } = this.opts;
    const schId = schema[schemaId];
    if (schId)
      baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
    return new SchemaEnv({ schema, schemaId, root: root2, baseId });
  }
  return getJsonPointer.call(this, p2, schOrRef);
}
compile.resolveSchema = resolveSchema;
const PREVENT_SCOPE_CHANGE = /* @__PURE__ */ new Set([
  "properties",
  "patternProperties",
  "enum",
  "dependencies",
  "definitions"
]);
function getJsonPointer(parsedRef, { baseId, schema, root: root2 }) {
  var _a2;
  if (((_a2 = parsedRef.fragment) === null || _a2 === void 0 ? void 0 : _a2[0]) !== "/")
    return;
  for (const part of parsedRef.fragment.slice(1).split("/")) {
    if (typeof schema === "boolean")
      return;
    const partSchema = schema[(0, util_1$k.unescapeFragment)(part)];
    if (partSchema === void 0)
      return;
    schema = partSchema;
    const schId = typeof schema === "object" && schema[this.opts.schemaId];
    if (!PREVENT_SCOPE_CHANGE.has(part) && schId) {
      baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
    }
  }
  let env;
  if (typeof schema != "boolean" && schema.$ref && !(0, util_1$k.schemaHasRulesButRef)(schema, this.RULES)) {
    const $ref = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
    env = resolveSchema.call(this, root2, $ref);
  }
  const { schemaId } = this.opts;
  env = env || new SchemaEnv({ schema, schemaId, root: root2, baseId });
  if (env.schema !== env.root.schema)
    return env;
  return void 0;
}
const $id$1 = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#";
const description = "Meta-schema for $data reference (JSON AnySchema extension proposal)";
const type$3 = "object";
const required$1 = [
  "$data"
];
const properties$2 = {
  $data: {
    type: "string",
    anyOf: [
      {
        format: "relative-json-pointer"
      },
      {
        format: "json-pointer"
      }
    ]
  }
};
const additionalProperties$1 = false;
const require$$9 = {
  $id: $id$1,
  description,
  type: type$3,
  required: required$1,
  properties: properties$2,
  additionalProperties: additionalProperties$1
};
var uri$2 = {};
var uri_all = { exports: {} };
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
(function(module2, exports) {
  (function(global2, factory2) {
    factory2(exports);
  })(commonjsGlobal, function(exports2) {
    function merge2() {
      for (var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++) {
        sets[_key] = arguments[_key];
      }
      if (sets.length > 1) {
        sets[0] = sets[0].slice(0, -1);
        var xl = sets.length - 1;
        for (var x3 = 1; x3 < xl; ++x3) {
          sets[x3] = sets[x3].slice(1, -1);
        }
        sets[xl] = sets[xl].slice(1);
        return sets.join("");
      } else {
        return sets[0];
      }
    }
    function subexp(str) {
      return "(?:" + str + ")";
    }
    function typeOf(o2) {
      return o2 === void 0 ? "undefined" : o2 === null ? "null" : Object.prototype.toString.call(o2).split(" ").pop().split("]").shift().toLowerCase();
    }
    function toUpperCase(str) {
      return str.toUpperCase();
    }
    function toArray2(obj) {
      return obj !== void 0 && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [obj] : Array.prototype.slice.call(obj) : [];
    }
    function assign2(target, source) {
      var obj = target;
      if (source) {
        for (var key2 in source) {
          obj[key2] = source[key2];
        }
      }
      return obj;
    }
    function buildExps(isIRI) {
      var ALPHA$$ = "[A-Za-z]", DIGIT$$ = "[0-9]", HEXDIG$$2 = merge2(DIGIT$$, "[A-Fa-f]"), PCT_ENCODED$2 = subexp(subexp("%[EFef]" + HEXDIG$$2 + "%" + HEXDIG$$2 + HEXDIG$$2 + "%" + HEXDIG$$2 + HEXDIG$$2) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$2 + "%" + HEXDIG$$2 + HEXDIG$$2) + "|" + subexp("%" + HEXDIG$$2 + HEXDIG$$2)), GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge2(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]", UNRESERVED$$2 = merge2(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$);
      subexp(ALPHA$$ + merge2(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*");
      subexp(subexp(PCT_ENCODED$2 + "|" + merge2(UNRESERVED$$2, SUB_DELIMS$$, "[\\:]")) + "*");
      var DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$2 + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), IPV6ADDRESS$ = subexp([IPV6ADDRESS1$, IPV6ADDRESS2$, IPV6ADDRESS3$, IPV6ADDRESS4$, IPV6ADDRESS5$, IPV6ADDRESS6$, IPV6ADDRESS7$, IPV6ADDRESS8$, IPV6ADDRESS9$].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$2 + "|" + PCT_ENCODED$2) + "+");
      subexp("[vV]" + HEXDIG$$2 + "+\\." + merge2(UNRESERVED$$2, SUB_DELIMS$$, "[\\:]") + "+");
      subexp(subexp(PCT_ENCODED$2 + "|" + merge2(UNRESERVED$$2, SUB_DELIMS$$)) + "*");
      var PCHAR$ = subexp(PCT_ENCODED$2 + "|" + merge2(UNRESERVED$$2, SUB_DELIMS$$, "[\\:\\@]"));
      subexp(subexp(PCT_ENCODED$2 + "|" + merge2(UNRESERVED$$2, SUB_DELIMS$$, "[\\@]")) + "+");
      subexp(subexp(PCHAR$ + "|" + merge2("[\\/\\?]", IPRIVATE$$)) + "*");
      return {
        NOT_SCHEME: new RegExp(merge2("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
        NOT_USERINFO: new RegExp(merge2("[^\\%\\:]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
        NOT_HOST: new RegExp(merge2("[^\\%\\[\\]\\:]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
        NOT_PATH: new RegExp(merge2("[^\\%\\/\\:\\@]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
        NOT_PATH_NOSCHEME: new RegExp(merge2("[^\\%\\/\\@]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
        NOT_QUERY: new RegExp(merge2("[^\\%]", UNRESERVED$$2, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
        NOT_FRAGMENT: new RegExp(merge2("[^\\%]", UNRESERVED$$2, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
        ESCAPE: new RegExp(merge2("[^]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
        UNRESERVED: new RegExp(UNRESERVED$$2, "g"),
        OTHER_CHARS: new RegExp(merge2("[^\\%]", UNRESERVED$$2, RESERVED$$), "g"),
        PCT_ENCODED: new RegExp(PCT_ENCODED$2, "g"),
        IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
        IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$2 + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$")
        //RFC 6874, with relaxed parsing rules
      };
    }
    var URI_PROTOCOL = buildExps(false);
    var IRI_PROTOCOL = buildExps(true);
    var slicedToArray = /* @__PURE__ */ function() {
      function sliceIterator(arr, i3) {
        var _arr = [];
        var _n2 = true;
        var _d2 = false;
        var _e3 = void 0;
        try {
          for (var _i2 = arr[Symbol.iterator](), _s; !(_n2 = (_s = _i2.next()).done); _n2 = true) {
            _arr.push(_s.value);
            if (i3 && _arr.length === i3) break;
          }
        } catch (err) {
          _d2 = true;
          _e3 = err;
        } finally {
          try {
            if (!_n2 && _i2["return"]) _i2["return"]();
          } finally {
            if (_d2) throw _e3;
          }
        }
        return _arr;
      }
      return function(arr, i3) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i3);
        } else {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
      };
    }();
    var toConsumableArray = function(arr) {
      if (Array.isArray(arr)) {
        for (var i3 = 0, arr2 = Array(arr.length); i3 < arr.length; i3++) arr2[i3] = arr[i3];
        return arr2;
      } else {
        return Array.from(arr);
      }
    };
    var maxInt = 2147483647;
    var base = 36;
    var tMin = 1;
    var tMax = 26;
    var skew = 38;
    var damp = 700;
    var initialBias = 72;
    var initialN = 128;
    var delimiter = "-";
    var regexPunycode = /^xn--/;
    var regexNonASCII = /[^\0-\x7E]/;
    var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g;
    var errors2 = {
      "overflow": "Overflow: input needs wider integers to process",
      "not-basic": "Illegal input >= 0x80 (not a basic code point)",
      "invalid-input": "Invalid input"
    };
    var baseMinusTMin = base - tMin;
    var floor2 = Math.floor;
    var stringFromCharCode = String.fromCharCode;
    function error$12(type2) {
      throw new RangeError(errors2[type2]);
    }
    function map2(array, fn2) {
      var result2 = [];
      var length = array.length;
      while (length--) {
        result2[length] = fn2(array[length]);
      }
      return result2;
    }
    function mapDomain(string3, fn2) {
      var parts = string3.split("@");
      var result2 = "";
      if (parts.length > 1) {
        result2 = parts[0] + "@";
        string3 = parts[1];
      }
      string3 = string3.replace(regexSeparators, ".");
      var labels = string3.split(".");
      var encoded = map2(labels, fn2).join(".");
      return result2 + encoded;
    }
    function ucs2decode(string3) {
      var output = [];
      var counter2 = 0;
      var length = string3.length;
      while (counter2 < length) {
        var value = string3.charCodeAt(counter2++);
        if (value >= 55296 && value <= 56319 && counter2 < length) {
          var extra = string3.charCodeAt(counter2++);
          if ((extra & 64512) == 56320) {
            output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
          } else {
            output.push(value);
            counter2--;
          }
        } else {
          output.push(value);
        }
      }
      return output;
    }
    var ucs2encode = function ucs2encode2(array) {
      return String.fromCodePoint.apply(String, toConsumableArray(array));
    };
    var basicToDigit = function basicToDigit2(codePoint) {
      if (codePoint - 48 < 10) {
        return codePoint - 22;
      }
      if (codePoint - 65 < 26) {
        return codePoint - 65;
      }
      if (codePoint - 97 < 26) {
        return codePoint - 97;
      }
      return base;
    };
    var digitToBasic = function digitToBasic2(digit, flag) {
      return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    };
    var adapt = function adapt2(delta, numPoints, firstTime) {
      var k3 = 0;
      delta = firstTime ? floor2(delta / damp) : delta >> 1;
      delta += floor2(delta / numPoints);
      for (
        ;
        /* no initialization */
        delta > baseMinusTMin * tMax >> 1;
        k3 += base
      ) {
        delta = floor2(delta / baseMinusTMin);
      }
      return floor2(k3 + (baseMinusTMin + 1) * delta / (delta + skew));
    };
    var decode2 = function decode3(input) {
      var output = [];
      var inputLength = input.length;
      var i3 = 0;
      var n2 = initialN;
      var bias = initialBias;
      var basic = input.lastIndexOf(delimiter);
      if (basic < 0) {
        basic = 0;
      }
      for (var j2 = 0; j2 < basic; ++j2) {
        if (input.charCodeAt(j2) >= 128) {
          error$12("not-basic");
        }
        output.push(input.charCodeAt(j2));
      }
      for (var index2 = basic > 0 ? basic + 1 : 0; index2 < inputLength; ) {
        var oldi = i3;
        for (
          var w3 = 1, k3 = base;
          ;
          /* no condition */
          k3 += base
        ) {
          if (index2 >= inputLength) {
            error$12("invalid-input");
          }
          var digit = basicToDigit(input.charCodeAt(index2++));
          if (digit >= base || digit > floor2((maxInt - i3) / w3)) {
            error$12("overflow");
          }
          i3 += digit * w3;
          var t3 = k3 <= bias ? tMin : k3 >= bias + tMax ? tMax : k3 - bias;
          if (digit < t3) {
            break;
          }
          var baseMinusT = base - t3;
          if (w3 > floor2(maxInt / baseMinusT)) {
            error$12("overflow");
          }
          w3 *= baseMinusT;
        }
        var out = output.length + 1;
        bias = adapt(i3 - oldi, out, oldi == 0);
        if (floor2(i3 / out) > maxInt - n2) {
          error$12("overflow");
        }
        n2 += floor2(i3 / out);
        i3 %= out;
        output.splice(i3++, 0, n2);
      }
      return String.fromCodePoint.apply(String, output);
    };
    var encode = function encode2(input) {
      var output = [];
      input = ucs2decode(input);
      var inputLength = input.length;
      var n2 = initialN;
      var delta = 0;
      var bias = initialBias;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = void 0;
      try {
        for (var _iterator3 = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator3.next()).done); _iteratorNormalCompletion = true) {
          var _currentValue2 = _step.value;
          if (_currentValue2 < 128) {
            output.push(stringFromCharCode(_currentValue2));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
      var basicLength = output.length;
      var handledCPCount = basicLength;
      if (basicLength) {
        output.push(delimiter);
      }
      while (handledCPCount < inputLength) {
        var m4 = maxInt;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = void 0;
        try {
          for (var _iterator22 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator22.next()).done); _iteratorNormalCompletion2 = true) {
            var currentValue = _step2.value;
            if (currentValue >= n2 && currentValue < m4) {
              m4 = currentValue;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator22.return) {
              _iterator22.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m4 - n2 > floor2((maxInt - delta) / handledCPCountPlusOne)) {
          error$12("overflow");
        }
        delta += (m4 - n2) * handledCPCountPlusOne;
        n2 = m4;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = void 0;
        try {
          for (var _iterator32 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator32.next()).done); _iteratorNormalCompletion3 = true) {
            var _currentValue = _step3.value;
            if (_currentValue < n2 && ++delta > maxInt) {
              error$12("overflow");
            }
            if (_currentValue == n2) {
              var q3 = delta;
              for (
                var k3 = base;
                ;
                /* no condition */
                k3 += base
              ) {
                var t3 = k3 <= bias ? tMin : k3 >= bias + tMax ? tMax : k3 - bias;
                if (q3 < t3) {
                  break;
                }
                var qMinusT = q3 - t3;
                var baseMinusT = base - t3;
                output.push(stringFromCharCode(digitToBasic(t3 + qMinusT % baseMinusT, 0)));
                q3 = floor2(qMinusT / baseMinusT);
              }
              output.push(stringFromCharCode(digitToBasic(q3, 0)));
              bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
              delta = 0;
              ++handledCPCount;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator32.return) {
              _iterator32.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
        ++delta;
        ++n2;
      }
      return output.join("");
    };
    var toUnicode = function toUnicode2(input) {
      return mapDomain(input, function(string3) {
        return regexPunycode.test(string3) ? decode2(string3.slice(4).toLowerCase()) : string3;
      });
    };
    var toASCII = function toASCII2(input) {
      return mapDomain(input, function(string3) {
        return regexNonASCII.test(string3) ? "xn--" + encode(string3) : string3;
      });
    };
    var punycode = {
      /**
       * A string representing the current Punycode.js version number.
       * @memberOf punycode
       * @type String
       */
      "version": "2.1.0",
      /**
       * An object of methods to convert from JavaScript's internal character
       * representation (UCS-2) to Unicode code points, and back.
       * @see <https://mathiasbynens.be/notes/javascript-encoding>
       * @memberOf punycode
       * @type Object
       */
      "ucs2": {
        "decode": ucs2decode,
        "encode": ucs2encode
      },
      "decode": decode2,
      "encode": encode,
      "toASCII": toASCII,
      "toUnicode": toUnicode
    };
    var SCHEMES = {};
    function pctEncChar(chr) {
      var c3 = chr.charCodeAt(0);
      var e5 = void 0;
      if (c3 < 16) e5 = "%0" + c3.toString(16).toUpperCase();
      else if (c3 < 128) e5 = "%" + c3.toString(16).toUpperCase();
      else if (c3 < 2048) e5 = "%" + (c3 >> 6 | 192).toString(16).toUpperCase() + "%" + (c3 & 63 | 128).toString(16).toUpperCase();
      else e5 = "%" + (c3 >> 12 | 224).toString(16).toUpperCase() + "%" + (c3 >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c3 & 63 | 128).toString(16).toUpperCase();
      return e5;
    }
    function pctDecChars(str) {
      var newStr = "";
      var i3 = 0;
      var il = str.length;
      while (i3 < il) {
        var c3 = parseInt(str.substr(i3 + 1, 2), 16);
        if (c3 < 128) {
          newStr += String.fromCharCode(c3);
          i3 += 3;
        } else if (c3 >= 194 && c3 < 224) {
          if (il - i3 >= 6) {
            var c22 = parseInt(str.substr(i3 + 4, 2), 16);
            newStr += String.fromCharCode((c3 & 31) << 6 | c22 & 63);
          } else {
            newStr += str.substr(i3, 6);
          }
          i3 += 6;
        } else if (c3 >= 224) {
          if (il - i3 >= 9) {
            var _c2 = parseInt(str.substr(i3 + 4, 2), 16);
            var c32 = parseInt(str.substr(i3 + 7, 2), 16);
            newStr += String.fromCharCode((c3 & 15) << 12 | (_c2 & 63) << 6 | c32 & 63);
          } else {
            newStr += str.substr(i3, 9);
          }
          i3 += 9;
        } else {
          newStr += str.substr(i3, 3);
          i3 += 3;
        }
      }
      return newStr;
    }
    function _normalizeComponentEncoding(components, protocol) {
      function decodeUnreserved2(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(protocol.UNRESERVED) ? str : decStr;
      }
      if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved2).toLowerCase().replace(protocol.NOT_SCHEME, "");
      if (components.userinfo !== void 0) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
      if (components.host !== void 0) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved2).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
      if (components.path !== void 0) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
      if (components.query !== void 0) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
      if (components.fragment !== void 0) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
      return components;
    }
    function _stripLeadingZeros(str) {
      return str.replace(/^0*(.*)/, "$1") || "0";
    }
    function _normalizeIPv4(host, protocol) {
      var matches2 = host.match(protocol.IPV4ADDRESS) || [];
      var _matches = slicedToArray(matches2, 2), address = _matches[1];
      if (address) {
        return address.split(".").map(_stripLeadingZeros).join(".");
      } else {
        return host;
      }
    }
    function _normalizeIPv6(host, protocol) {
      var matches2 = host.match(protocol.IPV6ADDRESS) || [];
      var _matches2 = slicedToArray(matches2, 3), address = _matches2[1], zone = _matches2[2];
      if (address) {
        var _address$toLowerCase$ = address.toLowerCase().split("::").reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last2 = _address$toLowerCase$2[0], first2 = _address$toLowerCase$2[1];
        var firstFields = first2 ? first2.split(":").map(_stripLeadingZeros) : [];
        var lastFields = last2.split(":").map(_stripLeadingZeros);
        var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
        var fieldCount = isLastFieldIPv4Address ? 7 : 8;
        var lastFieldsStart = lastFields.length - fieldCount;
        var fields2 = Array(fieldCount);
        for (var x3 = 0; x3 < fieldCount; ++x3) {
          fields2[x3] = firstFields[x3] || lastFields[lastFieldsStart + x3] || "";
        }
        if (isLastFieldIPv4Address) {
          fields2[fieldCount - 1] = _normalizeIPv4(fields2[fieldCount - 1], protocol);
        }
        var allZeroFields = fields2.reduce(function(acc, field, index2) {
          if (!field || field === "0") {
            var lastLongest = acc[acc.length - 1];
            if (lastLongest && lastLongest.index + lastLongest.length === index2) {
              lastLongest.length++;
            } else {
              acc.push({ index: index2, length: 1 });
            }
          }
          return acc;
        }, []);
        var longestZeroFields = allZeroFields.sort(function(a4, b3) {
          return b3.length - a4.length;
        })[0];
        var newHost = void 0;
        if (longestZeroFields && longestZeroFields.length > 1) {
          var newFirst = fields2.slice(0, longestZeroFields.index);
          var newLast = fields2.slice(longestZeroFields.index + longestZeroFields.length);
          newHost = newFirst.join(":") + "::" + newLast.join(":");
        } else {
          newHost = fields2.join(":");
        }
        if (zone) {
          newHost += "%" + zone;
        }
        return newHost;
      } else {
        return host;
      }
    }
    var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
    var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === void 0;
    function parse3(uriString) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var components = {};
      var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
      if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
      var matches2 = uriString.match(URI_PARSE);
      if (matches2) {
        if (NO_MATCH_IS_UNDEFINED) {
          components.scheme = matches2[1];
          components.userinfo = matches2[3];
          components.host = matches2[4];
          components.port = parseInt(matches2[5], 10);
          components.path = matches2[6] || "";
          components.query = matches2[7];
          components.fragment = matches2[8];
          if (isNaN(components.port)) {
            components.port = matches2[5];
          }
        } else {
          components.scheme = matches2[1] || void 0;
          components.userinfo = uriString.indexOf("@") !== -1 ? matches2[3] : void 0;
          components.host = uriString.indexOf("//") !== -1 ? matches2[4] : void 0;
          components.port = parseInt(matches2[5], 10);
          components.path = matches2[6] || "";
          components.query = uriString.indexOf("?") !== -1 ? matches2[7] : void 0;
          components.fragment = uriString.indexOf("#") !== -1 ? matches2[8] : void 0;
          if (isNaN(components.port)) {
            components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches2[4] : void 0;
          }
        }
        if (components.host) {
          components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
        }
        if (components.scheme === void 0 && components.userinfo === void 0 && components.host === void 0 && components.port === void 0 && !components.path && components.query === void 0) {
          components.reference = "same-document";
        } else if (components.scheme === void 0) {
          components.reference = "relative";
        } else if (components.fragment === void 0) {
          components.reference = "absolute";
        } else {
          components.reference = "uri";
        }
        if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) {
          components.error = components.error || "URI is not a " + options.reference + " reference.";
        }
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
          if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) {
            try {
              components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
            } catch (e5) {
              components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e5;
            }
          }
          _normalizeComponentEncoding(components, URI_PROTOCOL);
        } else {
          _normalizeComponentEncoding(components, protocol);
        }
        if (schemeHandler && schemeHandler.parse) {
          schemeHandler.parse(components, options);
        }
      } else {
        components.error = components.error || "URI can not be parsed.";
      }
      return components;
    }
    function _recomposeAuthority(components, options) {
      var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
      var uriTokens = [];
      if (components.userinfo !== void 0) {
        uriTokens.push(components.userinfo);
        uriTokens.push("@");
      }
      if (components.host !== void 0) {
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_2, $1, $2) {
          return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
      }
      if (typeof components.port === "number" || typeof components.port === "string") {
        uriTokens.push(":");
        uriTokens.push(String(components.port));
      }
      return uriTokens.length ? uriTokens.join("") : void 0;
    }
    var RDS1 = /^\.\.?\//;
    var RDS2 = /^\/\.(\/|$)/;
    var RDS3 = /^\/\.\.(\/|$)/;
    var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
    function removeDotSegments(input) {
      var output = [];
      while (input.length) {
        if (input.match(RDS1)) {
          input = input.replace(RDS1, "");
        } else if (input.match(RDS2)) {
          input = input.replace(RDS2, "/");
        } else if (input.match(RDS3)) {
          input = input.replace(RDS3, "/");
          output.pop();
        } else if (input === "." || input === "..") {
          input = "";
        } else {
          var im = input.match(RDS5);
          if (im) {
            var s4 = im[0];
            input = input.slice(s4.length);
            output.push(s4);
          } else {
            throw new Error("Unexpected dot segment condition");
          }
        }
      }
      return output.join("");
    }
    function serialize(components) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
      var uriTokens = [];
      var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
      if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
      if (components.host) {
        if (protocol.IPV6ADDRESS.test(components.host)) ;
        else if (options.domainHost || schemeHandler && schemeHandler.domainHost) {
          try {
            components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
          } catch (e5) {
            components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e5;
          }
        }
      }
      _normalizeComponentEncoding(components, protocol);
      if (options.reference !== "suffix" && components.scheme) {
        uriTokens.push(components.scheme);
        uriTokens.push(":");
      }
      var authority = _recomposeAuthority(components, options);
      if (authority !== void 0) {
        if (options.reference !== "suffix") {
          uriTokens.push("//");
        }
        uriTokens.push(authority);
        if (components.path && components.path.charAt(0) !== "/") {
          uriTokens.push("/");
        }
      }
      if (components.path !== void 0) {
        var s4 = components.path;
        if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) {
          s4 = removeDotSegments(s4);
        }
        if (authority === void 0) {
          s4 = s4.replace(/^\/\//, "/%2F");
        }
        uriTokens.push(s4);
      }
      if (components.query !== void 0) {
        uriTokens.push("?");
        uriTokens.push(components.query);
      }
      if (components.fragment !== void 0) {
        uriTokens.push("#");
        uriTokens.push(components.fragment);
      }
      return uriTokens.join("");
    }
    function resolveComponents(base2, relative2) {
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var skipNormalization = arguments[3];
      var target = {};
      if (!skipNormalization) {
        base2 = parse3(serialize(base2, options), options);
        relative2 = parse3(serialize(relative2, options), options);
      }
      options = options || {};
      if (!options.tolerant && relative2.scheme) {
        target.scheme = relative2.scheme;
        target.userinfo = relative2.userinfo;
        target.host = relative2.host;
        target.port = relative2.port;
        target.path = removeDotSegments(relative2.path || "");
        target.query = relative2.query;
      } else {
        if (relative2.userinfo !== void 0 || relative2.host !== void 0 || relative2.port !== void 0) {
          target.userinfo = relative2.userinfo;
          target.host = relative2.host;
          target.port = relative2.port;
          target.path = removeDotSegments(relative2.path || "");
          target.query = relative2.query;
        } else {
          if (!relative2.path) {
            target.path = base2.path;
            if (relative2.query !== void 0) {
              target.query = relative2.query;
            } else {
              target.query = base2.query;
            }
          } else {
            if (relative2.path.charAt(0) === "/") {
              target.path = removeDotSegments(relative2.path);
            } else {
              if ((base2.userinfo !== void 0 || base2.host !== void 0 || base2.port !== void 0) && !base2.path) {
                target.path = "/" + relative2.path;
              } else if (!base2.path) {
                target.path = relative2.path;
              } else {
                target.path = base2.path.slice(0, base2.path.lastIndexOf("/") + 1) + relative2.path;
              }
              target.path = removeDotSegments(target.path);
            }
            target.query = relative2.query;
          }
          target.userinfo = base2.userinfo;
          target.host = base2.host;
          target.port = base2.port;
        }
        target.scheme = base2.scheme;
      }
      target.fragment = relative2.fragment;
      return target;
    }
    function resolve3(baseURI, relativeURI, options) {
      var schemelessOptions = assign2({ scheme: "null" }, options);
      return serialize(resolveComponents(parse3(baseURI, schemelessOptions), parse3(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
    }
    function normalize4(uri2, options) {
      if (typeof uri2 === "string") {
        uri2 = serialize(parse3(uri2, options), options);
      } else if (typeOf(uri2) === "object") {
        uri2 = parse3(serialize(uri2, options), options);
      }
      return uri2;
    }
    function equal3(uriA, uriB, options) {
      if (typeof uriA === "string") {
        uriA = serialize(parse3(uriA, options), options);
      } else if (typeOf(uriA) === "object") {
        uriA = serialize(uriA, options);
      }
      if (typeof uriB === "string") {
        uriB = serialize(parse3(uriB, options), options);
      } else if (typeOf(uriB) === "object") {
        uriB = serialize(uriB, options);
      }
      return uriA === uriB;
    }
    function escapeComponent(str, options) {
      return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
    }
    function unescapeComponent(str, options) {
      return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
    }
    var handler = {
      scheme: "http",
      domainHost: true,
      parse: function parse4(components, options) {
        if (!components.host) {
          components.error = components.error || "HTTP URIs must have a host.";
        }
        return components;
      },
      serialize: function serialize2(components, options) {
        var secure = String(components.scheme).toLowerCase() === "https";
        if (components.port === (secure ? 443 : 80) || components.port === "") {
          components.port = void 0;
        }
        if (!components.path) {
          components.path = "/";
        }
        return components;
      }
    };
    var handler$1 = {
      scheme: "https",
      domainHost: handler.domainHost,
      parse: handler.parse,
      serialize: handler.serialize
    };
    function isSecure(wsComponents) {
      return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
    }
    var handler$2 = {
      scheme: "ws",
      domainHost: true,
      parse: function parse4(components, options) {
        var wsComponents = components;
        wsComponents.secure = isSecure(wsComponents);
        wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
        wsComponents.path = void 0;
        wsComponents.query = void 0;
        return wsComponents;
      },
      serialize: function serialize2(wsComponents, options) {
        if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") {
          wsComponents.port = void 0;
        }
        if (typeof wsComponents.secure === "boolean") {
          wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
          wsComponents.secure = void 0;
        }
        if (wsComponents.resourceName) {
          var _wsComponents$resourc = wsComponents.resourceName.split("?"), _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2), path3 = _wsComponents$resourc2[0], query = _wsComponents$resourc2[1];
          wsComponents.path = path3 && path3 !== "/" ? path3 : void 0;
          wsComponents.query = query;
          wsComponents.resourceName = void 0;
        }
        wsComponents.fragment = void 0;
        return wsComponents;
      }
    };
    var handler$3 = {
      scheme: "wss",
      domainHost: handler$2.domainHost,
      parse: handler$2.parse,
      serialize: handler$2.serialize
    };
    var O3 = {};
    var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]";
    var HEXDIG$$ = "[0-9A-Fa-f]";
    var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$));
    var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
    var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
    var VCHAR$$ = merge2(QTEXT$$, '[\\"\\\\]');
    var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
    var UNRESERVED = new RegExp(UNRESERVED$$, "g");
    var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
    var NOT_LOCAL_PART = new RegExp(merge2("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
    var NOT_HFNAME = new RegExp(merge2("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
    var NOT_HFVALUE = NOT_HFNAME;
    function decodeUnreserved(str) {
      var decStr = pctDecChars(str);
      return !decStr.match(UNRESERVED) ? str : decStr;
    }
    var handler$4 = {
      scheme: "mailto",
      parse: function parse$$1(components, options) {
        var mailtoComponents = components;
        var to2 = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
        mailtoComponents.path = void 0;
        if (mailtoComponents.query) {
          var unknownHeaders = false;
          var headers = {};
          var hfields = mailtoComponents.query.split("&");
          for (var x3 = 0, xl = hfields.length; x3 < xl; ++x3) {
            var hfield = hfields[x3].split("=");
            switch (hfield[0]) {
              case "to":
                var toAddrs = hfield[1].split(",");
                for (var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x) {
                  to2.push(toAddrs[_x]);
                }
                break;
              case "subject":
                mailtoComponents.subject = unescapeComponent(hfield[1], options);
                break;
              case "body":
                mailtoComponents.body = unescapeComponent(hfield[1], options);
                break;
              default:
                unknownHeaders = true;
                headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                break;
            }
          }
          if (unknownHeaders) mailtoComponents.headers = headers;
        }
        mailtoComponents.query = void 0;
        for (var _x2 = 0, _xl2 = to2.length; _x2 < _xl2; ++_x2) {
          var addr = to2[_x2].split("@");
          addr[0] = unescapeComponent(addr[0]);
          if (!options.unicodeSupport) {
            try {
              addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
            } catch (e5) {
              mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e5;
            }
          } else {
            addr[1] = unescapeComponent(addr[1], options).toLowerCase();
          }
          to2[_x2] = addr.join("@");
        }
        return mailtoComponents;
      },
      serialize: function serialize$$1(mailtoComponents, options) {
        var components = mailtoComponents;
        var to2 = toArray2(mailtoComponents.to);
        if (to2) {
          for (var x3 = 0, xl = to2.length; x3 < xl; ++x3) {
            var toAddr = String(to2[x3]);
            var atIdx = toAddr.lastIndexOf("@");
            var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
            var domain = toAddr.slice(atIdx + 1);
            try {
              domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
            } catch (e5) {
              components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e5;
            }
            to2[x3] = localPart + "@" + domain;
          }
          components.path = to2.join(",");
        }
        var headers = mailtoComponents.headers = mailtoComponents.headers || {};
        if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
        if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
        var fields2 = [];
        for (var name2 in headers) {
          if (headers[name2] !== O3[name2]) {
            fields2.push(name2.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name2].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
          }
        }
        if (fields2.length) {
          components.query = fields2.join("&");
        }
        return components;
      }
    };
    var URN_PARSE = /^([^\:]+)\:(.*)/;
    var handler$5 = {
      scheme: "urn",
      parse: function parse$$1(components, options) {
        var matches2 = components.path && components.path.match(URN_PARSE);
        var urnComponents = components;
        if (matches2) {
          var scheme = options.scheme || urnComponents.scheme || "urn";
          var nid = matches2[1].toLowerCase();
          var nss = matches2[2];
          var urnScheme = scheme + ":" + (options.nid || nid);
          var schemeHandler = SCHEMES[urnScheme];
          urnComponents.nid = nid;
          urnComponents.nss = nss;
          urnComponents.path = void 0;
          if (schemeHandler) {
            urnComponents = schemeHandler.parse(urnComponents, options);
          }
        } else {
          urnComponents.error = urnComponents.error || "URN can not be parsed.";
        }
        return urnComponents;
      },
      serialize: function serialize$$1(urnComponents, options) {
        var scheme = options.scheme || urnComponents.scheme || "urn";
        var nid = urnComponents.nid;
        var urnScheme = scheme + ":" + (options.nid || nid);
        var schemeHandler = SCHEMES[urnScheme];
        if (schemeHandler) {
          urnComponents = schemeHandler.serialize(urnComponents, options);
        }
        var uriComponents = urnComponents;
        var nss = urnComponents.nss;
        uriComponents.path = (nid || options.nid) + ":" + nss;
        return uriComponents;
      }
    };
    var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
    var handler$6 = {
      scheme: "urn:uuid",
      parse: function parse4(urnComponents, options) {
        var uuidComponents = urnComponents;
        uuidComponents.uuid = uuidComponents.nss;
        uuidComponents.nss = void 0;
        if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) {
          uuidComponents.error = uuidComponents.error || "UUID is not valid.";
        }
        return uuidComponents;
      },
      serialize: function serialize2(uuidComponents, options) {
        var urnComponents = uuidComponents;
        urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
        return urnComponents;
      }
    };
    SCHEMES[handler.scheme] = handler;
    SCHEMES[handler$1.scheme] = handler$1;
    SCHEMES[handler$2.scheme] = handler$2;
    SCHEMES[handler$3.scheme] = handler$3;
    SCHEMES[handler$4.scheme] = handler$4;
    SCHEMES[handler$5.scheme] = handler$5;
    SCHEMES[handler$6.scheme] = handler$6;
    exports2.SCHEMES = SCHEMES;
    exports2.pctEncChar = pctEncChar;
    exports2.pctDecChars = pctDecChars;
    exports2.parse = parse3;
    exports2.removeDotSegments = removeDotSegments;
    exports2.serialize = serialize;
    exports2.resolveComponents = resolveComponents;
    exports2.resolve = resolve3;
    exports2.normalize = normalize4;
    exports2.equal = equal3;
    exports2.escapeComponent = escapeComponent;
    exports2.unescapeComponent = unescapeComponent;
    Object.defineProperty(exports2, "__esModule", { value: true });
  });
})(uri_all, uri_all.exports);
var uri_allExports = uri_all.exports;
Object.defineProperty(uri$2, "__esModule", { value: true });
const uri$1 = uri_allExports;
uri$1.code = 'require("ajv/dist/runtime/uri").default';
uri$2.default = uri$1;
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;
  var validate_12 = validate$1;
  Object.defineProperty(exports, "KeywordCxt", { enumerable: true, get: function() {
    return validate_12.KeywordCxt;
  } });
  var codegen_12 = codegen;
  Object.defineProperty(exports, "_", { enumerable: true, get: function() {
    return codegen_12._;
  } });
  Object.defineProperty(exports, "str", { enumerable: true, get: function() {
    return codegen_12.str;
  } });
  Object.defineProperty(exports, "stringify", { enumerable: true, get: function() {
    return codegen_12.stringify;
  } });
  Object.defineProperty(exports, "nil", { enumerable: true, get: function() {
    return codegen_12.nil;
  } });
  Object.defineProperty(exports, "Name", { enumerable: true, get: function() {
    return codegen_12.Name;
  } });
  Object.defineProperty(exports, "CodeGen", { enumerable: true, get: function() {
    return codegen_12.CodeGen;
  } });
  const validation_error_12 = validation_error;
  const ref_error_12 = ref_error;
  const rules_12 = rules;
  const compile_12 = compile;
  const codegen_2 = codegen;
  const resolve_12 = resolve$1;
  const dataType_12 = dataType;
  const util_12 = util;
  const $dataRefSchema = require$$9;
  const uri_1 = uri$2;
  const defaultRegExp = (str, flags3) => new RegExp(str, flags3);
  defaultRegExp.code = "new RegExp";
  const META_IGNORE_OPTIONS = ["removeAdditional", "useDefaults", "coerceTypes"];
  const EXT_SCOPE_NAMES = /* @__PURE__ */ new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
  ]);
  const removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
  };
  const deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
  };
  const MAX_EXPRESSION = 200;
  function requiredOptions(o2) {
    var _a2, _b2, _c2, _d2, _e3, _f2, _g2, _h2, _j, _k, _l, _m, _o, _p, _q, _r2, _s, _t2, _u, _v, _w, _x, _y, _z, _0;
    const s4 = o2.strict;
    const _optz = (_a2 = o2.code) === null || _a2 === void 0 ? void 0 : _a2.optimize;
    const optimize = _optz === true || _optz === void 0 ? 1 : _optz || 0;
    const regExp = (_c2 = (_b2 = o2.code) === null || _b2 === void 0 ? void 0 : _b2.regExp) !== null && _c2 !== void 0 ? _c2 : defaultRegExp;
    const uriResolver = (_d2 = o2.uriResolver) !== null && _d2 !== void 0 ? _d2 : uri_1.default;
    return {
      strictSchema: (_f2 = (_e3 = o2.strictSchema) !== null && _e3 !== void 0 ? _e3 : s4) !== null && _f2 !== void 0 ? _f2 : true,
      strictNumbers: (_h2 = (_g2 = o2.strictNumbers) !== null && _g2 !== void 0 ? _g2 : s4) !== null && _h2 !== void 0 ? _h2 : true,
      strictTypes: (_k = (_j = o2.strictTypes) !== null && _j !== void 0 ? _j : s4) !== null && _k !== void 0 ? _k : "log",
      strictTuples: (_m = (_l = o2.strictTuples) !== null && _l !== void 0 ? _l : s4) !== null && _m !== void 0 ? _m : "log",
      strictRequired: (_p = (_o = o2.strictRequired) !== null && _o !== void 0 ? _o : s4) !== null && _p !== void 0 ? _p : false,
      code: o2.code ? { ...o2.code, optimize, regExp } : { optimize, regExp },
      loopRequired: (_q = o2.loopRequired) !== null && _q !== void 0 ? _q : MAX_EXPRESSION,
      loopEnum: (_r2 = o2.loopEnum) !== null && _r2 !== void 0 ? _r2 : MAX_EXPRESSION,
      meta: (_s = o2.meta) !== null && _s !== void 0 ? _s : true,
      messages: (_t2 = o2.messages) !== null && _t2 !== void 0 ? _t2 : true,
      inlineRefs: (_u = o2.inlineRefs) !== null && _u !== void 0 ? _u : true,
      schemaId: (_v = o2.schemaId) !== null && _v !== void 0 ? _v : "$id",
      addUsedSchema: (_w = o2.addUsedSchema) !== null && _w !== void 0 ? _w : true,
      validateSchema: (_x = o2.validateSchema) !== null && _x !== void 0 ? _x : true,
      validateFormats: (_y = o2.validateFormats) !== null && _y !== void 0 ? _y : true,
      unicodeRegExp: (_z = o2.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
      int32range: (_0 = o2.int32range) !== null && _0 !== void 0 ? _0 : true,
      uriResolver
    };
  }
  class Ajv2 {
    constructor(opts = {}) {
      this.schemas = {};
      this.refs = {};
      this.formats = {};
      this._compilations = /* @__PURE__ */ new Set();
      this._loading = {};
      this._cache = /* @__PURE__ */ new Map();
      opts = this.opts = { ...opts, ...requiredOptions(opts) };
      const { es5, lines } = this.opts.code;
      this.scope = new codegen_2.ValueScope({ scope: {}, prefixes: EXT_SCOPE_NAMES, es5, lines });
      this.logger = getLogger(opts.logger);
      const formatOpt = opts.validateFormats;
      opts.validateFormats = false;
      this.RULES = (0, rules_12.getRules)();
      checkOptions.call(this, removedOptions, opts, "NOT SUPPORTED");
      checkOptions.call(this, deprecatedOptions, opts, "DEPRECATED", "warn");
      this._metaOpts = getMetaSchemaOptions.call(this);
      if (opts.formats)
        addInitialFormats.call(this);
      this._addVocabularies();
      this._addDefaultMetaSchema();
      if (opts.keywords)
        addInitialKeywords.call(this, opts.keywords);
      if (typeof opts.meta == "object")
        this.addMetaSchema(opts.meta);
      addInitialSchemas.call(this);
      opts.validateFormats = formatOpt;
    }
    _addVocabularies() {
      this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
      const { $data, meta: meta2, schemaId } = this.opts;
      let _dataRefSchema = $dataRefSchema;
      if (schemaId === "id") {
        _dataRefSchema = { ...$dataRefSchema };
        _dataRefSchema.id = _dataRefSchema.$id;
        delete _dataRefSchema.$id;
      }
      if (meta2 && $data)
        this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
      const { meta: meta2, schemaId } = this.opts;
      return this.opts.defaultMeta = typeof meta2 == "object" ? meta2[schemaId] || meta2 : void 0;
    }
    validate(schemaKeyRef, data) {
      let v2;
      if (typeof schemaKeyRef == "string") {
        v2 = this.getSchema(schemaKeyRef);
        if (!v2)
          throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
      } else {
        v2 = this.compile(schemaKeyRef);
      }
      const valid = v2(data);
      if (!("$async" in v2))
        this.errors = v2.errors;
      return valid;
    }
    compile(schema, _meta2) {
      const sch = this._addSchema(schema, _meta2);
      return sch.validate || this._compileSchemaEnv(sch);
    }
    compileAsync(schema, meta2) {
      if (typeof this.opts.loadSchema != "function") {
        throw new Error("options.loadSchema should be a function");
      }
      const { loadSchema } = this.opts;
      return runCompileAsync.call(this, schema, meta2);
      async function runCompileAsync(_schema, _meta2) {
        await loadMetaSchema.call(this, _schema.$schema);
        const sch = this._addSchema(_schema, _meta2);
        return sch.validate || _compileAsync.call(this, sch);
      }
      async function loadMetaSchema($ref) {
        if ($ref && !this.getSchema($ref)) {
          await runCompileAsync.call(this, { $ref }, true);
        }
      }
      async function _compileAsync(sch) {
        try {
          return this._compileSchemaEnv(sch);
        } catch (e5) {
          if (!(e5 instanceof ref_error_12.default))
            throw e5;
          checkLoaded.call(this, e5);
          await loadMissingSchema.call(this, e5.missingSchema);
          return _compileAsync.call(this, sch);
        }
      }
      function checkLoaded({ missingSchema: ref2, missingRef }) {
        if (this.refs[ref2]) {
          throw new Error(`AnySchema ${ref2} is loaded but ${missingRef} cannot be resolved`);
        }
      }
      async function loadMissingSchema(ref2) {
        const _schema = await _loadSchema.call(this, ref2);
        if (!this.refs[ref2])
          await loadMetaSchema.call(this, _schema.$schema);
        if (!this.refs[ref2])
          this.addSchema(_schema, ref2, meta2);
      }
      async function _loadSchema(ref2) {
        const p2 = this._loading[ref2];
        if (p2)
          return p2;
        try {
          return await (this._loading[ref2] = loadSchema(ref2));
        } finally {
          delete this._loading[ref2];
        }
      }
    }
    // Adds schema to the instance
    addSchema(schema, key2, _meta2, _validateSchema = this.opts.validateSchema) {
      if (Array.isArray(schema)) {
        for (const sch of schema)
          this.addSchema(sch, void 0, _meta2, _validateSchema);
        return this;
      }
      let id2;
      if (typeof schema === "object") {
        const { schemaId } = this.opts;
        id2 = schema[schemaId];
        if (id2 !== void 0 && typeof id2 != "string") {
          throw new Error(`schema ${schemaId} must be string`);
        }
      }
      key2 = (0, resolve_12.normalizeId)(key2 || id2);
      this._checkUnique(key2);
      this.schemas[key2] = this._addSchema(schema, _meta2, key2, _validateSchema, true);
      return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key2, _validateSchema = this.opts.validateSchema) {
      this.addSchema(schema, key2, true, _validateSchema);
      return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
      if (typeof schema == "boolean")
        return true;
      let $schema2;
      $schema2 = schema.$schema;
      if ($schema2 !== void 0 && typeof $schema2 != "string") {
        throw new Error("$schema must be a string");
      }
      $schema2 = $schema2 || this.opts.defaultMeta || this.defaultMeta();
      if (!$schema2) {
        this.logger.warn("meta-schema not available");
        this.errors = null;
        return true;
      }
      const valid = this.validate($schema2, schema);
      if (!valid && throwOrLogError) {
        const message2 = "schema is invalid: " + this.errorsText();
        if (this.opts.validateSchema === "log")
          this.logger.error(message2);
        else
          throw new Error(message2);
      }
      return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
      let sch;
      while (typeof (sch = getSchEnv.call(this, keyRef)) == "string")
        keyRef = sch;
      if (sch === void 0) {
        const { schemaId } = this.opts;
        const root2 = new compile_12.SchemaEnv({ schema: {}, schemaId });
        sch = compile_12.resolveSchema.call(this, root2, keyRef);
        if (!sch)
          return;
        this.refs[keyRef] = sch;
      }
      return sch.validate || this._compileSchemaEnv(sch);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
      if (schemaKeyRef instanceof RegExp) {
        this._removeAllSchemas(this.schemas, schemaKeyRef);
        this._removeAllSchemas(this.refs, schemaKeyRef);
        return this;
      }
      switch (typeof schemaKeyRef) {
        case "undefined":
          this._removeAllSchemas(this.schemas);
          this._removeAllSchemas(this.refs);
          this._cache.clear();
          return this;
        case "string": {
          const sch = getSchEnv.call(this, schemaKeyRef);
          if (typeof sch == "object")
            this._cache.delete(sch.schema);
          delete this.schemas[schemaKeyRef];
          delete this.refs[schemaKeyRef];
          return this;
        }
        case "object": {
          const cacheKey = schemaKeyRef;
          this._cache.delete(cacheKey);
          let id2 = schemaKeyRef[this.opts.schemaId];
          if (id2) {
            id2 = (0, resolve_12.normalizeId)(id2);
            delete this.schemas[id2];
            delete this.refs[id2];
          }
          return this;
        }
        default:
          throw new Error("ajv.removeSchema: invalid parameter");
      }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions2) {
      for (const def2 of definitions2)
        this.addKeyword(def2);
      return this;
    }
    addKeyword(kwdOrDef, def2) {
      let keyword2;
      if (typeof kwdOrDef == "string") {
        keyword2 = kwdOrDef;
        if (typeof def2 == "object") {
          this.logger.warn("these parameters are deprecated, see docs for addKeyword");
          def2.keyword = keyword2;
        }
      } else if (typeof kwdOrDef == "object" && def2 === void 0) {
        def2 = kwdOrDef;
        keyword2 = def2.keyword;
        if (Array.isArray(keyword2) && !keyword2.length) {
          throw new Error("addKeywords: keyword must be string or non-empty array");
        }
      } else {
        throw new Error("invalid addKeywords parameters");
      }
      checkKeyword.call(this, keyword2, def2);
      if (!def2) {
        (0, util_12.eachItem)(keyword2, (kwd) => addRule.call(this, kwd));
        return this;
      }
      keywordMetaschema.call(this, def2);
      const definition = {
        ...def2,
        type: (0, dataType_12.getJSONTypes)(def2.type),
        schemaType: (0, dataType_12.getJSONTypes)(def2.schemaType)
      };
      (0, util_12.eachItem)(keyword2, definition.type.length === 0 ? (k3) => addRule.call(this, k3, definition) : (k3) => definition.type.forEach((t3) => addRule.call(this, k3, definition, t3)));
      return this;
    }
    getKeyword(keyword2) {
      const rule = this.RULES.all[keyword2];
      return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword2) {
      const { RULES } = this;
      delete RULES.keywords[keyword2];
      delete RULES.all[keyword2];
      for (const group of RULES.rules) {
        const i3 = group.rules.findIndex((rule) => rule.keyword === keyword2);
        if (i3 >= 0)
          group.rules.splice(i3, 1);
      }
      return this;
    }
    // Add format
    addFormat(name2, format3) {
      if (typeof format3 == "string")
        format3 = new RegExp(format3);
      this.formats[name2] = format3;
      return this;
    }
    errorsText(errors2 = this.errors, { separator = ", ", dataVar = "data" } = {}) {
      if (!errors2 || errors2.length === 0)
        return "No errors";
      return errors2.map((e5) => `${dataVar}${e5.instancePath} ${e5.message}`).reduce((text, msg2) => text + separator + msg2);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
      const rules2 = this.RULES.all;
      metaSchema = JSON.parse(JSON.stringify(metaSchema));
      for (const jsonPointer of keywordsJsonPointers) {
        const segments = jsonPointer.split("/").slice(1);
        let keywords = metaSchema;
        for (const seg of segments)
          keywords = keywords[seg];
        for (const key2 in rules2) {
          const rule = rules2[key2];
          if (typeof rule != "object")
            continue;
          const { $data } = rule.definition;
          const schema = keywords[key2];
          if ($data && schema)
            keywords[key2] = schemaOrData(schema);
        }
      }
      return metaSchema;
    }
    _removeAllSchemas(schemas, regex2) {
      for (const keyRef in schemas) {
        const sch = schemas[keyRef];
        if (!regex2 || regex2.test(keyRef)) {
          if (typeof sch == "string") {
            delete schemas[keyRef];
          } else if (sch && !sch.meta) {
            this._cache.delete(sch.schema);
            delete schemas[keyRef];
          }
        }
      }
    }
    _addSchema(schema, meta2, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
      let id2;
      const { schemaId } = this.opts;
      if (typeof schema == "object") {
        id2 = schema[schemaId];
      } else {
        if (this.opts.jtd)
          throw new Error("schema must be object");
        else if (typeof schema != "boolean")
          throw new Error("schema must be object or boolean");
      }
      let sch = this._cache.get(schema);
      if (sch !== void 0)
        return sch;
      baseId = (0, resolve_12.normalizeId)(id2 || baseId);
      const localRefs = resolve_12.getSchemaRefs.call(this, schema, baseId);
      sch = new compile_12.SchemaEnv({ schema, schemaId, meta: meta2, baseId, localRefs });
      this._cache.set(sch.schema, sch);
      if (addSchema && !baseId.startsWith("#")) {
        if (baseId)
          this._checkUnique(baseId);
        this.refs[baseId] = sch;
      }
      if (validateSchema)
        this.validateSchema(schema, true);
      return sch;
    }
    _checkUnique(id2) {
      if (this.schemas[id2] || this.refs[id2]) {
        throw new Error(`schema with key or id "${id2}" already exists`);
      }
    }
    _compileSchemaEnv(sch) {
      if (sch.meta)
        this._compileMetaSchema(sch);
      else
        compile_12.compileSchema.call(this, sch);
      if (!sch.validate)
        throw new Error("ajv implementation error");
      return sch.validate;
    }
    _compileMetaSchema(sch) {
      const currentOpts = this.opts;
      this.opts = this._metaOpts;
      try {
        compile_12.compileSchema.call(this, sch);
      } finally {
        this.opts = currentOpts;
      }
    }
  }
  Ajv2.ValidationError = validation_error_12.default;
  Ajv2.MissingRefError = ref_error_12.default;
  exports.default = Ajv2;
  function checkOptions(checkOpts, options, msg2, log = "error") {
    for (const key2 in checkOpts) {
      const opt = key2;
      if (opt in options)
        this.logger[log](`${msg2}: option ${key2}. ${checkOpts[opt]}`);
    }
  }
  function getSchEnv(keyRef) {
    keyRef = (0, resolve_12.normalizeId)(keyRef);
    return this.schemas[keyRef] || this.refs[keyRef];
  }
  function addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas)
      return;
    if (Array.isArray(optsSchemas))
      this.addSchema(optsSchemas);
    else
      for (const key2 in optsSchemas)
        this.addSchema(optsSchemas[key2], key2);
  }
  function addInitialFormats() {
    for (const name2 in this.opts.formats) {
      const format3 = this.opts.formats[name2];
      if (format3)
        this.addFormat(name2, format3);
    }
  }
  function addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
      this.addVocabulary(defs);
      return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for (const keyword2 in defs) {
      const def2 = defs[keyword2];
      if (!def2.keyword)
        def2.keyword = keyword2;
      this.addKeyword(def2);
    }
  }
  function getMetaSchemaOptions() {
    const metaOpts = { ...this.opts };
    for (const opt of META_IGNORE_OPTIONS)
      delete metaOpts[opt];
    return metaOpts;
  }
  const noLogs = { log() {
  }, warn() {
  }, error() {
  } };
  function getLogger(logger) {
    if (logger === false)
      return noLogs;
    if (logger === void 0)
      return console;
    if (logger.log && logger.warn && logger.error)
      return logger;
    throw new Error("logger must implement log, warn and error methods");
  }
  const KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
  function checkKeyword(keyword2, def2) {
    const { RULES } = this;
    (0, util_12.eachItem)(keyword2, (kwd) => {
      if (RULES.keywords[kwd])
        throw new Error(`Keyword ${kwd} is already defined`);
      if (!KEYWORD_NAME.test(kwd))
        throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def2)
      return;
    if (def2.$data && !("code" in def2 || "validate" in def2)) {
      throw new Error('$data keyword must have "code" or "validate" function');
    }
  }
  function addRule(keyword2, definition, dataType2) {
    var _a2;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType2 && post)
      throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t3 }) => t3 === dataType2);
    if (!ruleGroup) {
      ruleGroup = { type: dataType2, rules: [] };
      RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword2] = true;
    if (!definition)
      return;
    const rule = {
      keyword: keyword2,
      definition: {
        ...definition,
        type: (0, dataType_12.getJSONTypes)(definition.type),
        schemaType: (0, dataType_12.getJSONTypes)(definition.schemaType)
      }
    };
    if (definition.before)
      addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else
      ruleGroup.rules.push(rule);
    RULES.all[keyword2] = rule;
    (_a2 = definition.implements) === null || _a2 === void 0 ? void 0 : _a2.forEach((kwd) => this.addKeyword(kwd));
  }
  function addBeforeRule(ruleGroup, rule, before3) {
    const i3 = ruleGroup.rules.findIndex((_rule) => _rule.keyword === before3);
    if (i3 >= 0) {
      ruleGroup.rules.splice(i3, 0, rule);
    } else {
      ruleGroup.rules.push(rule);
      this.logger.warn(`rule ${before3} is not defined`);
    }
  }
  function keywordMetaschema(def2) {
    let { metaSchema } = def2;
    if (metaSchema === void 0)
      return;
    if (def2.$data && this.opts.$data)
      metaSchema = schemaOrData(metaSchema);
    def2.validateSchema = this.compile(metaSchema, true);
  }
  const $dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
  };
  function schemaOrData(schema) {
    return { anyOf: [schema, $dataRef] };
  }
})(core$3);
var draft7 = {};
var core$2 = {};
var id = {};
Object.defineProperty(id, "__esModule", { value: true });
const def$s = {
  keyword: "id",
  code() {
    throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
  }
};
id.default = def$s;
var ref$1 = {};
Object.defineProperty(ref$1, "__esModule", { value: true });
ref$1.callRef = ref$1.getValidate = void 0;
const ref_error_1$1 = ref_error;
const code_1$8 = code;
const codegen_1$l = codegen;
const names_1$1 = names$1;
const compile_1$1 = compile;
const util_1$j = util;
const def$r = {
  keyword: "$ref",
  schemaType: "string",
  code(cxt) {
    const { gen, schema: $ref, it: it2 } = cxt;
    const { baseId, schemaEnv: env, validateName, opts, self: self2 } = it2;
    const { root: root2 } = env;
    if (($ref === "#" || $ref === "#/") && baseId === root2.baseId)
      return callRootRef();
    const schOrEnv = compile_1$1.resolveRef.call(self2, root2, baseId, $ref);
    if (schOrEnv === void 0)
      throw new ref_error_1$1.default(it2.opts.uriResolver, baseId, $ref);
    if (schOrEnv instanceof compile_1$1.SchemaEnv)
      return callValidate(schOrEnv);
    return inlineRefSchema(schOrEnv);
    function callRootRef() {
      if (env === root2)
        return callRef(cxt, validateName, env, env.$async);
      const rootName = gen.scopeValue("root", { ref: root2 });
      return callRef(cxt, (0, codegen_1$l._)`${rootName}.validate`, root2, root2.$async);
    }
    function callValidate(sch) {
      const v2 = getValidate(cxt, sch);
      callRef(cxt, v2, sch, sch.$async);
    }
    function inlineRefSchema(sch) {
      const schName = gen.scopeValue("schema", opts.code.source === true ? { ref: sch, code: (0, codegen_1$l.stringify)(sch) } : { ref: sch });
      const valid = gen.name("valid");
      const schCxt = cxt.subschema({
        schema: sch,
        dataTypes: [],
        schemaPath: codegen_1$l.nil,
        topSchemaRef: schName,
        errSchemaPath: $ref
      }, valid);
      cxt.mergeEvaluated(schCxt);
      cxt.ok(valid);
    }
  }
};
function getValidate(cxt, sch) {
  const { gen } = cxt;
  return sch.validate ? gen.scopeValue("validate", { ref: sch.validate }) : (0, codegen_1$l._)`${gen.scopeValue("wrapper", { ref: sch })}.validate`;
}
ref$1.getValidate = getValidate;
function callRef(cxt, v2, sch, $async) {
  const { gen, it: it2 } = cxt;
  const { allErrors, schemaEnv: env, opts } = it2;
  const passCxt = opts.passContext ? names_1$1.default.this : codegen_1$l.nil;
  if ($async)
    callAsyncRef();
  else
    callSyncRef();
  function callAsyncRef() {
    if (!env.$async)
      throw new Error("async schema referenced by sync schema");
    const valid = gen.let("valid");
    gen.try(() => {
      gen.code((0, codegen_1$l._)`await ${(0, code_1$8.callValidateCode)(cxt, v2, passCxt)}`);
      addEvaluatedFrom(v2);
      if (!allErrors)
        gen.assign(valid, true);
    }, (e5) => {
      gen.if((0, codegen_1$l._)`!(${e5} instanceof ${it2.ValidationError})`, () => gen.throw(e5));
      addErrorsFrom(e5);
      if (!allErrors)
        gen.assign(valid, false);
    });
    cxt.ok(valid);
  }
  function callSyncRef() {
    cxt.result((0, code_1$8.callValidateCode)(cxt, v2, passCxt), () => addEvaluatedFrom(v2), () => addErrorsFrom(v2));
  }
  function addErrorsFrom(source) {
    const errs = (0, codegen_1$l._)`${source}.errors`;
    gen.assign(names_1$1.default.vErrors, (0, codegen_1$l._)`${names_1$1.default.vErrors} === null ? ${errs} : ${names_1$1.default.vErrors}.concat(${errs})`);
    gen.assign(names_1$1.default.errors, (0, codegen_1$l._)`${names_1$1.default.vErrors}.length`);
  }
  function addEvaluatedFrom(source) {
    var _a2;
    if (!it2.opts.unevaluated)
      return;
    const schEvaluated = (_a2 = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a2 === void 0 ? void 0 : _a2.evaluated;
    if (it2.props !== true) {
      if (schEvaluated && !schEvaluated.dynamicProps) {
        if (schEvaluated.props !== void 0) {
          it2.props = util_1$j.mergeEvaluated.props(gen, schEvaluated.props, it2.props);
        }
      } else {
        const props2 = gen.var("props", (0, codegen_1$l._)`${source}.evaluated.props`);
        it2.props = util_1$j.mergeEvaluated.props(gen, props2, it2.props, codegen_1$l.Name);
      }
    }
    if (it2.items !== true) {
      if (schEvaluated && !schEvaluated.dynamicItems) {
        if (schEvaluated.items !== void 0) {
          it2.items = util_1$j.mergeEvaluated.items(gen, schEvaluated.items, it2.items);
        }
      } else {
        const items2 = gen.var("items", (0, codegen_1$l._)`${source}.evaluated.items`);
        it2.items = util_1$j.mergeEvaluated.items(gen, items2, it2.items, codegen_1$l.Name);
      }
    }
  }
}
ref$1.callRef = callRef;
ref$1.default = def$r;
Object.defineProperty(core$2, "__esModule", { value: true });
const id_1 = id;
const ref_1 = ref$1;
const core$1 = [
  "$schema",
  "$id",
  "$defs",
  "$vocabulary",
  { keyword: "$comment" },
  "definitions",
  id_1.default,
  ref_1.default
];
core$2.default = core$1;
var validation$1 = {};
var limitNumber = {};
Object.defineProperty(limitNumber, "__esModule", { value: true });
const codegen_1$k = codegen;
const ops = codegen_1$k.operators;
const KWDs = {
  maximum: { okStr: "<=", ok: ops.LTE, fail: ops.GT },
  minimum: { okStr: ">=", ok: ops.GTE, fail: ops.LT },
  exclusiveMaximum: { okStr: "<", ok: ops.LT, fail: ops.GTE },
  exclusiveMinimum: { okStr: ">", ok: ops.GT, fail: ops.LTE }
};
const error$i = {
  message: ({ keyword: keyword2, schemaCode }) => (0, codegen_1$k.str)`must be ${KWDs[keyword2].okStr} ${schemaCode}`,
  params: ({ keyword: keyword2, schemaCode }) => (0, codegen_1$k._)`{comparison: ${KWDs[keyword2].okStr}, limit: ${schemaCode}}`
};
const def$q = {
  keyword: Object.keys(KWDs),
  type: "number",
  schemaType: "number",
  $data: true,
  error: error$i,
  code(cxt) {
    const { keyword: keyword2, data, schemaCode } = cxt;
    cxt.fail$data((0, codegen_1$k._)`${data} ${KWDs[keyword2].fail} ${schemaCode} || isNaN(${data})`);
  }
};
limitNumber.default = def$q;
var multipleOf = {};
Object.defineProperty(multipleOf, "__esModule", { value: true });
const codegen_1$j = codegen;
const error$h = {
  message: ({ schemaCode }) => (0, codegen_1$j.str)`must be multiple of ${schemaCode}`,
  params: ({ schemaCode }) => (0, codegen_1$j._)`{multipleOf: ${schemaCode}}`
};
const def$p = {
  keyword: "multipleOf",
  type: "number",
  schemaType: "number",
  $data: true,
  error: error$h,
  code(cxt) {
    const { gen, data, schemaCode, it: it2 } = cxt;
    const prec = it2.opts.multipleOfPrecision;
    const res = gen.let("res");
    const invalid2 = prec ? (0, codegen_1$j._)`Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}` : (0, codegen_1$j._)`${res} !== parseInt(${res})`;
    cxt.fail$data((0, codegen_1$j._)`(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid2}))`);
  }
};
multipleOf.default = def$p;
var limitLength = {};
var ucs2length$1 = {};
Object.defineProperty(ucs2length$1, "__esModule", { value: true });
function ucs2length(str) {
  const len = str.length;
  let length = 0;
  let pos = 0;
  let value;
  while (pos < len) {
    length++;
    value = str.charCodeAt(pos++);
    if (value >= 55296 && value <= 56319 && pos < len) {
      value = str.charCodeAt(pos);
      if ((value & 64512) === 56320)
        pos++;
    }
  }
  return length;
}
ucs2length$1.default = ucs2length;
ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
Object.defineProperty(limitLength, "__esModule", { value: true });
const codegen_1$i = codegen;
const util_1$i = util;
const ucs2length_1 = ucs2length$1;
const error$g = {
  message({ keyword: keyword2, schemaCode }) {
    const comp = keyword2 === "maxLength" ? "more" : "fewer";
    return (0, codegen_1$i.str)`must NOT have ${comp} than ${schemaCode} characters`;
  },
  params: ({ schemaCode }) => (0, codegen_1$i._)`{limit: ${schemaCode}}`
};
const def$o = {
  keyword: ["maxLength", "minLength"],
  type: "string",
  schemaType: "number",
  $data: true,
  error: error$g,
  code(cxt) {
    const { keyword: keyword2, data, schemaCode, it: it2 } = cxt;
    const op = keyword2 === "maxLength" ? codegen_1$i.operators.GT : codegen_1$i.operators.LT;
    const len = it2.opts.unicode === false ? (0, codegen_1$i._)`${data}.length` : (0, codegen_1$i._)`${(0, util_1$i.useFunc)(cxt.gen, ucs2length_1.default)}(${data})`;
    cxt.fail$data((0, codegen_1$i._)`${len} ${op} ${schemaCode}`);
  }
};
limitLength.default = def$o;
var pattern = {};
Object.defineProperty(pattern, "__esModule", { value: true });
const code_1$7 = code;
const codegen_1$h = codegen;
const error$f = {
  message: ({ schemaCode }) => (0, codegen_1$h.str)`must match pattern "${schemaCode}"`,
  params: ({ schemaCode }) => (0, codegen_1$h._)`{pattern: ${schemaCode}}`
};
const def$n = {
  keyword: "pattern",
  type: "string",
  schemaType: "string",
  $data: true,
  error: error$f,
  code(cxt) {
    const { data, $data, schema, schemaCode, it: it2 } = cxt;
    const u3 = it2.opts.unicodeRegExp ? "u" : "";
    const regExp = $data ? (0, codegen_1$h._)`(new RegExp(${schemaCode}, ${u3}))` : (0, code_1$7.usePattern)(cxt, schema);
    cxt.fail$data((0, codegen_1$h._)`!${regExp}.test(${data})`);
  }
};
pattern.default = def$n;
var limitProperties = {};
Object.defineProperty(limitProperties, "__esModule", { value: true });
const codegen_1$g = codegen;
const error$e = {
  message({ keyword: keyword2, schemaCode }) {
    const comp = keyword2 === "maxProperties" ? "more" : "fewer";
    return (0, codegen_1$g.str)`must NOT have ${comp} than ${schemaCode} properties`;
  },
  params: ({ schemaCode }) => (0, codegen_1$g._)`{limit: ${schemaCode}}`
};
const def$m = {
  keyword: ["maxProperties", "minProperties"],
  type: "object",
  schemaType: "number",
  $data: true,
  error: error$e,
  code(cxt) {
    const { keyword: keyword2, data, schemaCode } = cxt;
    const op = keyword2 === "maxProperties" ? codegen_1$g.operators.GT : codegen_1$g.operators.LT;
    cxt.fail$data((0, codegen_1$g._)`Object.keys(${data}).length ${op} ${schemaCode}`);
  }
};
limitProperties.default = def$m;
var required = {};
Object.defineProperty(required, "__esModule", { value: true });
const code_1$6 = code;
const codegen_1$f = codegen;
const util_1$h = util;
const error$d = {
  message: ({ params: { missingProperty } }) => (0, codegen_1$f.str)`must have required property '${missingProperty}'`,
  params: ({ params: { missingProperty } }) => (0, codegen_1$f._)`{missingProperty: ${missingProperty}}`
};
const def$l = {
  keyword: "required",
  type: "object",
  schemaType: "array",
  $data: true,
  error: error$d,
  code(cxt) {
    const { gen, schema, schemaCode, data, $data, it: it2 } = cxt;
    const { opts } = it2;
    if (!$data && schema.length === 0)
      return;
    const useLoop = schema.length >= opts.loopRequired;
    if (it2.allErrors)
      allErrorsMode();
    else
      exitOnErrorMode();
    if (opts.strictRequired) {
      const props2 = cxt.parentSchema.properties;
      const { definedProperties } = cxt.it;
      for (const requiredKey of schema) {
        if ((props2 === null || props2 === void 0 ? void 0 : props2[requiredKey]) === void 0 && !definedProperties.has(requiredKey)) {
          const schemaPath = it2.schemaEnv.baseId + it2.errSchemaPath;
          const msg2 = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
          (0, util_1$h.checkStrictMode)(it2, msg2, it2.opts.strictRequired);
        }
      }
    }
    function allErrorsMode() {
      if (useLoop || $data) {
        cxt.block$data(codegen_1$f.nil, loopAllRequired);
      } else {
        for (const prop of schema) {
          (0, code_1$6.checkReportMissingProp)(cxt, prop);
        }
      }
    }
    function exitOnErrorMode() {
      const missing = gen.let("missing");
      if (useLoop || $data) {
        const valid = gen.let("valid", true);
        cxt.block$data(valid, () => loopUntilMissing(missing, valid));
        cxt.ok(valid);
      } else {
        gen.if((0, code_1$6.checkMissingProp)(cxt, schema, missing));
        (0, code_1$6.reportMissingProp)(cxt, missing);
        gen.else();
      }
    }
    function loopAllRequired() {
      gen.forOf("prop", schemaCode, (prop) => {
        cxt.setParams({ missingProperty: prop });
        gen.if((0, code_1$6.noPropertyInData)(gen, data, prop, opts.ownProperties), () => cxt.error());
      });
    }
    function loopUntilMissing(missing, valid) {
      cxt.setParams({ missingProperty: missing });
      gen.forOf(missing, schemaCode, () => {
        gen.assign(valid, (0, code_1$6.propertyInData)(gen, data, missing, opts.ownProperties));
        gen.if((0, codegen_1$f.not)(valid), () => {
          cxt.error();
          gen.break();
        });
      }, codegen_1$f.nil);
    }
  }
};
required.default = def$l;
var limitItems = {};
Object.defineProperty(limitItems, "__esModule", { value: true });
const codegen_1$e = codegen;
const error$c = {
  message({ keyword: keyword2, schemaCode }) {
    const comp = keyword2 === "maxItems" ? "more" : "fewer";
    return (0, codegen_1$e.str)`must NOT have ${comp} than ${schemaCode} items`;
  },
  params: ({ schemaCode }) => (0, codegen_1$e._)`{limit: ${schemaCode}}`
};
const def$k = {
  keyword: ["maxItems", "minItems"],
  type: "array",
  schemaType: "number",
  $data: true,
  error: error$c,
  code(cxt) {
    const { keyword: keyword2, data, schemaCode } = cxt;
    const op = keyword2 === "maxItems" ? codegen_1$e.operators.GT : codegen_1$e.operators.LT;
    cxt.fail$data((0, codegen_1$e._)`${data}.length ${op} ${schemaCode}`);
  }
};
limitItems.default = def$k;
var uniqueItems = {};
var equal$1 = {};
Object.defineProperty(equal$1, "__esModule", { value: true });
const equal2 = fastDeepEqual;
equal2.code = 'require("ajv/dist/runtime/equal").default';
equal$1.default = equal2;
Object.defineProperty(uniqueItems, "__esModule", { value: true });
const dataType_1 = dataType;
const codegen_1$d = codegen;
const util_1$g = util;
const equal_1$2 = equal$1;
const error$b = {
  message: ({ params: { i: i3, j: j2 } }) => (0, codegen_1$d.str)`must NOT have duplicate items (items ## ${j2} and ${i3} are identical)`,
  params: ({ params: { i: i3, j: j2 } }) => (0, codegen_1$d._)`{i: ${i3}, j: ${j2}}`
};
const def$j = {
  keyword: "uniqueItems",
  type: "array",
  schemaType: "boolean",
  $data: true,
  error: error$b,
  code(cxt) {
    const { gen, data, $data, schema, parentSchema, schemaCode, it: it2 } = cxt;
    if (!$data && !schema)
      return;
    const valid = gen.let("valid");
    const itemTypes = parentSchema.items ? (0, dataType_1.getSchemaTypes)(parentSchema.items) : [];
    cxt.block$data(valid, validateUniqueItems, (0, codegen_1$d._)`${schemaCode} === false`);
    cxt.ok(valid);
    function validateUniqueItems() {
      const i3 = gen.let("i", (0, codegen_1$d._)`${data}.length`);
      const j2 = gen.let("j");
      cxt.setParams({ i: i3, j: j2 });
      gen.assign(valid, true);
      gen.if((0, codegen_1$d._)`${i3} > 1`, () => (canOptimize() ? loopN : loopN2)(i3, j2));
    }
    function canOptimize() {
      return itemTypes.length > 0 && !itemTypes.some((t3) => t3 === "object" || t3 === "array");
    }
    function loopN(i3, j2) {
      const item = gen.name("item");
      const wrongType = (0, dataType_1.checkDataTypes)(itemTypes, item, it2.opts.strictNumbers, dataType_1.DataType.Wrong);
      const indices2 = gen.const("indices", (0, codegen_1$d._)`{}`);
      gen.for((0, codegen_1$d._)`;${i3}--;`, () => {
        gen.let(item, (0, codegen_1$d._)`${data}[${i3}]`);
        gen.if(wrongType, (0, codegen_1$d._)`continue`);
        if (itemTypes.length > 1)
          gen.if((0, codegen_1$d._)`typeof ${item} == "string"`, (0, codegen_1$d._)`${item} += "_"`);
        gen.if((0, codegen_1$d._)`typeof ${indices2}[${item}] == "number"`, () => {
          gen.assign(j2, (0, codegen_1$d._)`${indices2}[${item}]`);
          cxt.error();
          gen.assign(valid, false).break();
        }).code((0, codegen_1$d._)`${indices2}[${item}] = ${i3}`);
      });
    }
    function loopN2(i3, j2) {
      const eql = (0, util_1$g.useFunc)(gen, equal_1$2.default);
      const outer = gen.name("outer");
      gen.label(outer).for((0, codegen_1$d._)`;${i3}--;`, () => gen.for((0, codegen_1$d._)`${j2} = ${i3}; ${j2}--;`, () => gen.if((0, codegen_1$d._)`${eql}(${data}[${i3}], ${data}[${j2}])`, () => {
        cxt.error();
        gen.assign(valid, false).break(outer);
      })));
    }
  }
};
uniqueItems.default = def$j;
var _const = {};
Object.defineProperty(_const, "__esModule", { value: true });
const codegen_1$c = codegen;
const util_1$f = util;
const equal_1$1 = equal$1;
const error$a = {
  message: "must be equal to constant",
  params: ({ schemaCode }) => (0, codegen_1$c._)`{allowedValue: ${schemaCode}}`
};
const def$i = {
  keyword: "const",
  $data: true,
  error: error$a,
  code(cxt) {
    const { gen, data, $data, schemaCode, schema } = cxt;
    if ($data || schema && typeof schema == "object") {
      cxt.fail$data((0, codegen_1$c._)`!${(0, util_1$f.useFunc)(gen, equal_1$1.default)}(${data}, ${schemaCode})`);
    } else {
      cxt.fail((0, codegen_1$c._)`${schema} !== ${data}`);
    }
  }
};
_const.default = def$i;
var _enum = {};
Object.defineProperty(_enum, "__esModule", { value: true });
const codegen_1$b = codegen;
const util_1$e = util;
const equal_1 = equal$1;
const error$9 = {
  message: "must be equal to one of the allowed values",
  params: ({ schemaCode }) => (0, codegen_1$b._)`{allowedValues: ${schemaCode}}`
};
const def$h = {
  keyword: "enum",
  schemaType: "array",
  $data: true,
  error: error$9,
  code(cxt) {
    const { gen, data, $data, schema, schemaCode, it: it2 } = cxt;
    if (!$data && schema.length === 0)
      throw new Error("enum must have non-empty array");
    const useLoop = schema.length >= it2.opts.loopEnum;
    let eql;
    const getEql = () => eql !== null && eql !== void 0 ? eql : eql = (0, util_1$e.useFunc)(gen, equal_1.default);
    let valid;
    if (useLoop || $data) {
      valid = gen.let("valid");
      cxt.block$data(valid, loopEnum);
    } else {
      if (!Array.isArray(schema))
        throw new Error("ajv implementation error");
      const vSchema = gen.const("vSchema", schemaCode);
      valid = (0, codegen_1$b.or)(...schema.map((_x, i3) => equalCode(vSchema, i3)));
    }
    cxt.pass(valid);
    function loopEnum() {
      gen.assign(valid, false);
      gen.forOf("v", schemaCode, (v2) => gen.if((0, codegen_1$b._)`${getEql()}(${data}, ${v2})`, () => gen.assign(valid, true).break()));
    }
    function equalCode(vSchema, i3) {
      const sch = schema[i3];
      return typeof sch === "object" && sch !== null ? (0, codegen_1$b._)`${getEql()}(${data}, ${vSchema}[${i3}])` : (0, codegen_1$b._)`${data} === ${sch}`;
    }
  }
};
_enum.default = def$h;
Object.defineProperty(validation$1, "__esModule", { value: true });
const limitNumber_1 = limitNumber;
const multipleOf_1 = multipleOf;
const limitLength_1 = limitLength;
const pattern_1 = pattern;
const limitProperties_1 = limitProperties;
const required_1 = required;
const limitItems_1 = limitItems;
const uniqueItems_1 = uniqueItems;
const const_1 = _const;
const enum_1 = _enum;
const validation = [
  // number
  limitNumber_1.default,
  multipleOf_1.default,
  // string
  limitLength_1.default,
  pattern_1.default,
  // object
  limitProperties_1.default,
  required_1.default,
  // array
  limitItems_1.default,
  uniqueItems_1.default,
  // any
  { keyword: "type", schemaType: ["string", "array"] },
  { keyword: "nullable", schemaType: "boolean" },
  const_1.default,
  enum_1.default
];
validation$1.default = validation;
var applicator = {};
var additionalItems = {};
Object.defineProperty(additionalItems, "__esModule", { value: true });
additionalItems.validateAdditionalItems = void 0;
const codegen_1$a = codegen;
const util_1$d = util;
const error$8 = {
  message: ({ params: { len } }) => (0, codegen_1$a.str)`must NOT have more than ${len} items`,
  params: ({ params: { len } }) => (0, codegen_1$a._)`{limit: ${len}}`
};
const def$g = {
  keyword: "additionalItems",
  type: "array",
  schemaType: ["boolean", "object"],
  before: "uniqueItems",
  error: error$8,
  code(cxt) {
    const { parentSchema, it: it2 } = cxt;
    const { items: items2 } = parentSchema;
    if (!Array.isArray(items2)) {
      (0, util_1$d.checkStrictMode)(it2, '"additionalItems" is ignored when "items" is not an array of schemas');
      return;
    }
    validateAdditionalItems(cxt, items2);
  }
};
function validateAdditionalItems(cxt, items2) {
  const { gen, schema, data, keyword: keyword2, it: it2 } = cxt;
  it2.items = true;
  const len = gen.const("len", (0, codegen_1$a._)`${data}.length`);
  if (schema === false) {
    cxt.setParams({ len: items2.length });
    cxt.pass((0, codegen_1$a._)`${len} <= ${items2.length}`);
  } else if (typeof schema == "object" && !(0, util_1$d.alwaysValidSchema)(it2, schema)) {
    const valid = gen.var("valid", (0, codegen_1$a._)`${len} <= ${items2.length}`);
    gen.if((0, codegen_1$a.not)(valid), () => validateItems(valid));
    cxt.ok(valid);
  }
  function validateItems(valid) {
    gen.forRange("i", items2.length, len, (i3) => {
      cxt.subschema({ keyword: keyword2, dataProp: i3, dataPropType: util_1$d.Type.Num }, valid);
      if (!it2.allErrors)
        gen.if((0, codegen_1$a.not)(valid), () => gen.break());
    });
  }
}
additionalItems.validateAdditionalItems = validateAdditionalItems;
additionalItems.default = def$g;
var prefixItems = {};
var items = {};
Object.defineProperty(items, "__esModule", { value: true });
items.validateTuple = void 0;
const codegen_1$9 = codegen;
const util_1$c = util;
const code_1$5 = code;
const def$f = {
  keyword: "items",
  type: "array",
  schemaType: ["object", "array", "boolean"],
  before: "uniqueItems",
  code(cxt) {
    const { schema, it: it2 } = cxt;
    if (Array.isArray(schema))
      return validateTuple(cxt, "additionalItems", schema);
    it2.items = true;
    if ((0, util_1$c.alwaysValidSchema)(it2, schema))
      return;
    cxt.ok((0, code_1$5.validateArray)(cxt));
  }
};
function validateTuple(cxt, extraItems, schArr = cxt.schema) {
  const { gen, parentSchema, data, keyword: keyword2, it: it2 } = cxt;
  checkStrictTuple(parentSchema);
  if (it2.opts.unevaluated && schArr.length && it2.items !== true) {
    it2.items = util_1$c.mergeEvaluated.items(gen, schArr.length, it2.items);
  }
  const valid = gen.name("valid");
  const len = gen.const("len", (0, codegen_1$9._)`${data}.length`);
  schArr.forEach((sch, i3) => {
    if ((0, util_1$c.alwaysValidSchema)(it2, sch))
      return;
    gen.if((0, codegen_1$9._)`${len} > ${i3}`, () => cxt.subschema({
      keyword: keyword2,
      schemaProp: i3,
      dataProp: i3
    }, valid));
    cxt.ok(valid);
  });
  function checkStrictTuple(sch) {
    const { opts, errSchemaPath } = it2;
    const l2 = schArr.length;
    const fullTuple = l2 === sch.minItems && (l2 === sch.maxItems || sch[extraItems] === false);
    if (opts.strictTuples && !fullTuple) {
      const msg2 = `"${keyword2}" is ${l2}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
      (0, util_1$c.checkStrictMode)(it2, msg2, opts.strictTuples);
    }
  }
}
items.validateTuple = validateTuple;
items.default = def$f;
Object.defineProperty(prefixItems, "__esModule", { value: true });
const items_1$1 = items;
const def$e = {
  keyword: "prefixItems",
  type: "array",
  schemaType: ["array"],
  before: "uniqueItems",
  code: (cxt) => (0, items_1$1.validateTuple)(cxt, "items")
};
prefixItems.default = def$e;
var items2020 = {};
Object.defineProperty(items2020, "__esModule", { value: true });
const codegen_1$8 = codegen;
const util_1$b = util;
const code_1$4 = code;
const additionalItems_1$1 = additionalItems;
const error$7 = {
  message: ({ params: { len } }) => (0, codegen_1$8.str)`must NOT have more than ${len} items`,
  params: ({ params: { len } }) => (0, codegen_1$8._)`{limit: ${len}}`
};
const def$d = {
  keyword: "items",
  type: "array",
  schemaType: ["object", "boolean"],
  before: "uniqueItems",
  error: error$7,
  code(cxt) {
    const { schema, parentSchema, it: it2 } = cxt;
    const { prefixItems: prefixItems2 } = parentSchema;
    it2.items = true;
    if ((0, util_1$b.alwaysValidSchema)(it2, schema))
      return;
    if (prefixItems2)
      (0, additionalItems_1$1.validateAdditionalItems)(cxt, prefixItems2);
    else
      cxt.ok((0, code_1$4.validateArray)(cxt));
  }
};
items2020.default = def$d;
var contains = {};
Object.defineProperty(contains, "__esModule", { value: true });
const codegen_1$7 = codegen;
const util_1$a = util;
const error$6 = {
  message: ({ params: { min: min2, max: max2 } }) => max2 === void 0 ? (0, codegen_1$7.str)`must contain at least ${min2} valid item(s)` : (0, codegen_1$7.str)`must contain at least ${min2} and no more than ${max2} valid item(s)`,
  params: ({ params: { min: min2, max: max2 } }) => max2 === void 0 ? (0, codegen_1$7._)`{minContains: ${min2}}` : (0, codegen_1$7._)`{minContains: ${min2}, maxContains: ${max2}}`
};
const def$c = {
  keyword: "contains",
  type: "array",
  schemaType: ["object", "boolean"],
  before: "uniqueItems",
  trackErrors: true,
  error: error$6,
  code(cxt) {
    const { gen, schema, parentSchema, data, it: it2 } = cxt;
    let min2;
    let max2;
    const { minContains, maxContains } = parentSchema;
    if (it2.opts.next) {
      min2 = minContains === void 0 ? 1 : minContains;
      max2 = maxContains;
    } else {
      min2 = 1;
    }
    const len = gen.const("len", (0, codegen_1$7._)`${data}.length`);
    cxt.setParams({ min: min2, max: max2 });
    if (max2 === void 0 && min2 === 0) {
      (0, util_1$a.checkStrictMode)(it2, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
      return;
    }
    if (max2 !== void 0 && min2 > max2) {
      (0, util_1$a.checkStrictMode)(it2, `"minContains" > "maxContains" is always invalid`);
      cxt.fail();
      return;
    }
    if ((0, util_1$a.alwaysValidSchema)(it2, schema)) {
      let cond = (0, codegen_1$7._)`${len} >= ${min2}`;
      if (max2 !== void 0)
        cond = (0, codegen_1$7._)`${cond} && ${len} <= ${max2}`;
      cxt.pass(cond);
      return;
    }
    it2.items = true;
    const valid = gen.name("valid");
    if (max2 === void 0 && min2 === 1) {
      validateItems(valid, () => gen.if(valid, () => gen.break()));
    } else if (min2 === 0) {
      gen.let(valid, true);
      if (max2 !== void 0)
        gen.if((0, codegen_1$7._)`${data}.length > 0`, validateItemsWithCount);
    } else {
      gen.let(valid, false);
      validateItemsWithCount();
    }
    cxt.result(valid, () => cxt.reset());
    function validateItemsWithCount() {
      const schValid = gen.name("_valid");
      const count = gen.let("count", 0);
      validateItems(schValid, () => gen.if(schValid, () => checkLimits(count)));
    }
    function validateItems(_valid, block) {
      gen.forRange("i", 0, len, (i3) => {
        cxt.subschema({
          keyword: "contains",
          dataProp: i3,
          dataPropType: util_1$a.Type.Num,
          compositeRule: true
        }, _valid);
        block();
      });
    }
    function checkLimits(count) {
      gen.code((0, codegen_1$7._)`${count}++`);
      if (max2 === void 0) {
        gen.if((0, codegen_1$7._)`${count} >= ${min2}`, () => gen.assign(valid, true).break());
      } else {
        gen.if((0, codegen_1$7._)`${count} > ${max2}`, () => gen.assign(valid, false).break());
        if (min2 === 1)
          gen.assign(valid, true);
        else
          gen.if((0, codegen_1$7._)`${count} >= ${min2}`, () => gen.assign(valid, true));
      }
    }
  }
};
contains.default = def$c;
var dependencies = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.validateSchemaDeps = exports.validatePropertyDeps = exports.error = void 0;
  const codegen_12 = codegen;
  const util_12 = util;
  const code_12 = code;
  exports.error = {
    message: ({ params: { property: property2, depsCount, deps } }) => {
      const property_ies = depsCount === 1 ? "property" : "properties";
      return (0, codegen_12.str)`must have ${property_ies} ${deps} when property ${property2} is present`;
    },
    params: ({ params: { property: property2, depsCount, deps, missingProperty } }) => (0, codegen_12._)`{property: ${property2},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`
    // TODO change to reference
  };
  const def2 = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: exports.error,
    code(cxt) {
      const [propDeps, schDeps] = splitDependencies(cxt);
      validatePropertyDeps(cxt, propDeps);
      validateSchemaDeps(cxt, schDeps);
    }
  };
  function splitDependencies({ schema }) {
    const propertyDeps = {};
    const schemaDeps = {};
    for (const key2 in schema) {
      if (key2 === "__proto__")
        continue;
      const deps = Array.isArray(schema[key2]) ? propertyDeps : schemaDeps;
      deps[key2] = schema[key2];
    }
    return [propertyDeps, schemaDeps];
  }
  function validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
    const { gen, data, it: it2 } = cxt;
    if (Object.keys(propertyDeps).length === 0)
      return;
    const missing = gen.let("missing");
    for (const prop in propertyDeps) {
      const deps = propertyDeps[prop];
      if (deps.length === 0)
        continue;
      const hasProperty = (0, code_12.propertyInData)(gen, data, prop, it2.opts.ownProperties);
      cxt.setParams({
        property: prop,
        depsCount: deps.length,
        deps: deps.join(", ")
      });
      if (it2.allErrors) {
        gen.if(hasProperty, () => {
          for (const depProp of deps) {
            (0, code_12.checkReportMissingProp)(cxt, depProp);
          }
        });
      } else {
        gen.if((0, codegen_12._)`${hasProperty} && (${(0, code_12.checkMissingProp)(cxt, deps, missing)})`);
        (0, code_12.reportMissingProp)(cxt, missing);
        gen.else();
      }
    }
  }
  exports.validatePropertyDeps = validatePropertyDeps;
  function validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
    const { gen, data, keyword: keyword2, it: it2 } = cxt;
    const valid = gen.name("valid");
    for (const prop in schemaDeps) {
      if ((0, util_12.alwaysValidSchema)(it2, schemaDeps[prop]))
        continue;
      gen.if(
        (0, code_12.propertyInData)(gen, data, prop, it2.opts.ownProperties),
        () => {
          const schCxt = cxt.subschema({ keyword: keyword2, schemaProp: prop }, valid);
          cxt.mergeValidEvaluated(schCxt, valid);
        },
        () => gen.var(valid, true)
        // TODO var
      );
      cxt.ok(valid);
    }
  }
  exports.validateSchemaDeps = validateSchemaDeps;
  exports.default = def2;
})(dependencies);
var propertyNames = {};
Object.defineProperty(propertyNames, "__esModule", { value: true });
const codegen_1$6 = codegen;
const util_1$9 = util;
const error$5 = {
  message: "property name must be valid",
  params: ({ params }) => (0, codegen_1$6._)`{propertyName: ${params.propertyName}}`
};
const def$b = {
  keyword: "propertyNames",
  type: "object",
  schemaType: ["object", "boolean"],
  error: error$5,
  code(cxt) {
    const { gen, schema, data, it: it2 } = cxt;
    if ((0, util_1$9.alwaysValidSchema)(it2, schema))
      return;
    const valid = gen.name("valid");
    gen.forIn("key", data, (key2) => {
      cxt.setParams({ propertyName: key2 });
      cxt.subschema({
        keyword: "propertyNames",
        data: key2,
        dataTypes: ["string"],
        propertyName: key2,
        compositeRule: true
      }, valid);
      gen.if((0, codegen_1$6.not)(valid), () => {
        cxt.error(true);
        if (!it2.allErrors)
          gen.break();
      });
    });
    cxt.ok(valid);
  }
};
propertyNames.default = def$b;
var additionalProperties = {};
Object.defineProperty(additionalProperties, "__esModule", { value: true });
const code_1$3 = code;
const codegen_1$5 = codegen;
const names_1 = names$1;
const util_1$8 = util;
const error$4 = {
  message: "must NOT have additional properties",
  params: ({ params }) => (0, codegen_1$5._)`{additionalProperty: ${params.additionalProperty}}`
};
const def$a = {
  keyword: "additionalProperties",
  type: ["object"],
  schemaType: ["boolean", "object"],
  allowUndefined: true,
  trackErrors: true,
  error: error$4,
  code(cxt) {
    const { gen, schema, parentSchema, data, errsCount, it: it2 } = cxt;
    if (!errsCount)
      throw new Error("ajv implementation error");
    const { allErrors, opts } = it2;
    it2.props = true;
    if (opts.removeAdditional !== "all" && (0, util_1$8.alwaysValidSchema)(it2, schema))
      return;
    const props2 = (0, code_1$3.allSchemaProperties)(parentSchema.properties);
    const patProps = (0, code_1$3.allSchemaProperties)(parentSchema.patternProperties);
    checkAdditionalProperties();
    cxt.ok((0, codegen_1$5._)`${errsCount} === ${names_1.default.errors}`);
    function checkAdditionalProperties() {
      gen.forIn("key", data, (key2) => {
        if (!props2.length && !patProps.length)
          additionalPropertyCode(key2);
        else
          gen.if(isAdditional(key2), () => additionalPropertyCode(key2));
      });
    }
    function isAdditional(key2) {
      let definedProp;
      if (props2.length > 8) {
        const propsSchema = (0, util_1$8.schemaRefOrVal)(it2, parentSchema.properties, "properties");
        definedProp = (0, code_1$3.isOwnProperty)(gen, propsSchema, key2);
      } else if (props2.length) {
        definedProp = (0, codegen_1$5.or)(...props2.map((p2) => (0, codegen_1$5._)`${key2} === ${p2}`));
      } else {
        definedProp = codegen_1$5.nil;
      }
      if (patProps.length) {
        definedProp = (0, codegen_1$5.or)(definedProp, ...patProps.map((p2) => (0, codegen_1$5._)`${(0, code_1$3.usePattern)(cxt, p2)}.test(${key2})`));
      }
      return (0, codegen_1$5.not)(definedProp);
    }
    function deleteAdditional(key2) {
      gen.code((0, codegen_1$5._)`delete ${data}[${key2}]`);
    }
    function additionalPropertyCode(key2) {
      if (opts.removeAdditional === "all" || opts.removeAdditional && schema === false) {
        deleteAdditional(key2);
        return;
      }
      if (schema === false) {
        cxt.setParams({ additionalProperty: key2 });
        cxt.error();
        if (!allErrors)
          gen.break();
        return;
      }
      if (typeof schema == "object" && !(0, util_1$8.alwaysValidSchema)(it2, schema)) {
        const valid = gen.name("valid");
        if (opts.removeAdditional === "failing") {
          applyAdditionalSchema(key2, valid, false);
          gen.if((0, codegen_1$5.not)(valid), () => {
            cxt.reset();
            deleteAdditional(key2);
          });
        } else {
          applyAdditionalSchema(key2, valid);
          if (!allErrors)
            gen.if((0, codegen_1$5.not)(valid), () => gen.break());
        }
      }
    }
    function applyAdditionalSchema(key2, valid, errors2) {
      const subschema2 = {
        keyword: "additionalProperties",
        dataProp: key2,
        dataPropType: util_1$8.Type.Str
      };
      if (errors2 === false) {
        Object.assign(subschema2, {
          compositeRule: true,
          createErrors: false,
          allErrors: false
        });
      }
      cxt.subschema(subschema2, valid);
    }
  }
};
additionalProperties.default = def$a;
var properties$1 = {};
Object.defineProperty(properties$1, "__esModule", { value: true });
const validate_1 = validate$1;
const code_1$2 = code;
const util_1$7 = util;
const additionalProperties_1$1 = additionalProperties;
const def$9 = {
  keyword: "properties",
  type: "object",
  schemaType: "object",
  code(cxt) {
    const { gen, schema, parentSchema, data, it: it2 } = cxt;
    if (it2.opts.removeAdditional === "all" && parentSchema.additionalProperties === void 0) {
      additionalProperties_1$1.default.code(new validate_1.KeywordCxt(it2, additionalProperties_1$1.default, "additionalProperties"));
    }
    const allProps = (0, code_1$2.allSchemaProperties)(schema);
    for (const prop of allProps) {
      it2.definedProperties.add(prop);
    }
    if (it2.opts.unevaluated && allProps.length && it2.props !== true) {
      it2.props = util_1$7.mergeEvaluated.props(gen, (0, util_1$7.toHash)(allProps), it2.props);
    }
    const properties2 = allProps.filter((p2) => !(0, util_1$7.alwaysValidSchema)(it2, schema[p2]));
    if (properties2.length === 0)
      return;
    const valid = gen.name("valid");
    for (const prop of properties2) {
      if (hasDefault(prop)) {
        applyPropertySchema(prop);
      } else {
        gen.if((0, code_1$2.propertyInData)(gen, data, prop, it2.opts.ownProperties));
        applyPropertySchema(prop);
        if (!it2.allErrors)
          gen.else().var(valid, true);
        gen.endIf();
      }
      cxt.it.definedProperties.add(prop);
      cxt.ok(valid);
    }
    function hasDefault(prop) {
      return it2.opts.useDefaults && !it2.compositeRule && schema[prop].default !== void 0;
    }
    function applyPropertySchema(prop) {
      cxt.subschema({
        keyword: "properties",
        schemaProp: prop,
        dataProp: prop
      }, valid);
    }
  }
};
properties$1.default = def$9;
var patternProperties = {};
Object.defineProperty(patternProperties, "__esModule", { value: true });
const code_1$1 = code;
const codegen_1$4 = codegen;
const util_1$6 = util;
const util_2 = util;
const def$8 = {
  keyword: "patternProperties",
  type: "object",
  schemaType: "object",
  code(cxt) {
    const { gen, schema, data, parentSchema, it: it2 } = cxt;
    const { opts } = it2;
    const patterns2 = (0, code_1$1.allSchemaProperties)(schema);
    const alwaysValidPatterns = patterns2.filter((p2) => (0, util_1$6.alwaysValidSchema)(it2, schema[p2]));
    if (patterns2.length === 0 || alwaysValidPatterns.length === patterns2.length && (!it2.opts.unevaluated || it2.props === true)) {
      return;
    }
    const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
    const valid = gen.name("valid");
    if (it2.props !== true && !(it2.props instanceof codegen_1$4.Name)) {
      it2.props = (0, util_2.evaluatedPropsToName)(gen, it2.props);
    }
    const { props: props2 } = it2;
    validatePatternProperties();
    function validatePatternProperties() {
      for (const pat of patterns2) {
        if (checkProperties)
          checkMatchingProperties(pat);
        if (it2.allErrors) {
          validateProperties(pat);
        } else {
          gen.var(valid, true);
          validateProperties(pat);
          gen.if(valid);
        }
      }
    }
    function checkMatchingProperties(pat) {
      for (const prop in checkProperties) {
        if (new RegExp(pat).test(prop)) {
          (0, util_1$6.checkStrictMode)(it2, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
        }
      }
    }
    function validateProperties(pat) {
      gen.forIn("key", data, (key2) => {
        gen.if((0, codegen_1$4._)`${(0, code_1$1.usePattern)(cxt, pat)}.test(${key2})`, () => {
          const alwaysValid = alwaysValidPatterns.includes(pat);
          if (!alwaysValid) {
            cxt.subschema({
              keyword: "patternProperties",
              schemaProp: pat,
              dataProp: key2,
              dataPropType: util_2.Type.Str
            }, valid);
          }
          if (it2.opts.unevaluated && props2 !== true) {
            gen.assign((0, codegen_1$4._)`${props2}[${key2}]`, true);
          } else if (!alwaysValid && !it2.allErrors) {
            gen.if((0, codegen_1$4.not)(valid), () => gen.break());
          }
        });
      });
    }
  }
};
patternProperties.default = def$8;
var not$1 = {};
Object.defineProperty(not$1, "__esModule", { value: true });
const util_1$5 = util;
const def$7 = {
  keyword: "not",
  schemaType: ["object", "boolean"],
  trackErrors: true,
  code(cxt) {
    const { gen, schema, it: it2 } = cxt;
    if ((0, util_1$5.alwaysValidSchema)(it2, schema)) {
      cxt.fail();
      return;
    }
    const valid = gen.name("valid");
    cxt.subschema({
      keyword: "not",
      compositeRule: true,
      createErrors: false,
      allErrors: false
    }, valid);
    cxt.failResult(valid, () => cxt.reset(), () => cxt.error());
  },
  error: { message: "must NOT be valid" }
};
not$1.default = def$7;
var anyOf = {};
Object.defineProperty(anyOf, "__esModule", { value: true });
const code_1 = code;
const def$6 = {
  keyword: "anyOf",
  schemaType: "array",
  trackErrors: true,
  code: code_1.validateUnion,
  error: { message: "must match a schema in anyOf" }
};
anyOf.default = def$6;
var oneOf = {};
Object.defineProperty(oneOf, "__esModule", { value: true });
const codegen_1$3 = codegen;
const util_1$4 = util;
const error$3 = {
  message: "must match exactly one schema in oneOf",
  params: ({ params }) => (0, codegen_1$3._)`{passingSchemas: ${params.passing}}`
};
const def$5 = {
  keyword: "oneOf",
  schemaType: "array",
  trackErrors: true,
  error: error$3,
  code(cxt) {
    const { gen, schema, parentSchema, it: it2 } = cxt;
    if (!Array.isArray(schema))
      throw new Error("ajv implementation error");
    if (it2.opts.discriminator && parentSchema.discriminator)
      return;
    const schArr = schema;
    const valid = gen.let("valid", false);
    const passing = gen.let("passing", null);
    const schValid = gen.name("_valid");
    cxt.setParams({ passing });
    gen.block(validateOneOf);
    cxt.result(valid, () => cxt.reset(), () => cxt.error(true));
    function validateOneOf() {
      schArr.forEach((sch, i3) => {
        let schCxt;
        if ((0, util_1$4.alwaysValidSchema)(it2, sch)) {
          gen.var(schValid, true);
        } else {
          schCxt = cxt.subschema({
            keyword: "oneOf",
            schemaProp: i3,
            compositeRule: true
          }, schValid);
        }
        if (i3 > 0) {
          gen.if((0, codegen_1$3._)`${schValid} && ${valid}`).assign(valid, false).assign(passing, (0, codegen_1$3._)`[${passing}, ${i3}]`).else();
        }
        gen.if(schValid, () => {
          gen.assign(valid, true);
          gen.assign(passing, i3);
          if (schCxt)
            cxt.mergeEvaluated(schCxt, codegen_1$3.Name);
        });
      });
    }
  }
};
oneOf.default = def$5;
var allOf = {};
Object.defineProperty(allOf, "__esModule", { value: true });
const util_1$3 = util;
const def$4 = {
  keyword: "allOf",
  schemaType: "array",
  code(cxt) {
    const { gen, schema, it: it2 } = cxt;
    if (!Array.isArray(schema))
      throw new Error("ajv implementation error");
    const valid = gen.name("valid");
    schema.forEach((sch, i3) => {
      if ((0, util_1$3.alwaysValidSchema)(it2, sch))
        return;
      const schCxt = cxt.subschema({ keyword: "allOf", schemaProp: i3 }, valid);
      cxt.ok(valid);
      cxt.mergeEvaluated(schCxt);
    });
  }
};
allOf.default = def$4;
var _if = {};
Object.defineProperty(_if, "__esModule", { value: true });
const codegen_1$2 = codegen;
const util_1$2 = util;
const error$2 = {
  message: ({ params }) => (0, codegen_1$2.str)`must match "${params.ifClause}" schema`,
  params: ({ params }) => (0, codegen_1$2._)`{failingKeyword: ${params.ifClause}}`
};
const def$3 = {
  keyword: "if",
  schemaType: ["object", "boolean"],
  trackErrors: true,
  error: error$2,
  code(cxt) {
    const { gen, parentSchema, it: it2 } = cxt;
    if (parentSchema.then === void 0 && parentSchema.else === void 0) {
      (0, util_1$2.checkStrictMode)(it2, '"if" without "then" and "else" is ignored');
    }
    const hasThen = hasSchema(it2, "then");
    const hasElse = hasSchema(it2, "else");
    if (!hasThen && !hasElse)
      return;
    const valid = gen.let("valid", true);
    const schValid = gen.name("_valid");
    validateIf();
    cxt.reset();
    if (hasThen && hasElse) {
      const ifClause = gen.let("ifClause");
      cxt.setParams({ ifClause });
      gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
    } else if (hasThen) {
      gen.if(schValid, validateClause("then"));
    } else {
      gen.if((0, codegen_1$2.not)(schValid), validateClause("else"));
    }
    cxt.pass(valid, () => cxt.error(true));
    function validateIf() {
      const schCxt = cxt.subschema({
        keyword: "if",
        compositeRule: true,
        createErrors: false,
        allErrors: false
      }, schValid);
      cxt.mergeEvaluated(schCxt);
    }
    function validateClause(keyword2, ifClause) {
      return () => {
        const schCxt = cxt.subschema({ keyword: keyword2 }, schValid);
        gen.assign(valid, schValid);
        cxt.mergeValidEvaluated(schCxt, valid);
        if (ifClause)
          gen.assign(ifClause, (0, codegen_1$2._)`${keyword2}`);
        else
          cxt.setParams({ ifClause: keyword2 });
      };
    }
  }
};
function hasSchema(it2, keyword2) {
  const schema = it2.schema[keyword2];
  return schema !== void 0 && !(0, util_1$2.alwaysValidSchema)(it2, schema);
}
_if.default = def$3;
var thenElse = {};
Object.defineProperty(thenElse, "__esModule", { value: true });
const util_1$1 = util;
const def$2 = {
  keyword: ["then", "else"],
  schemaType: ["object", "boolean"],
  code({ keyword: keyword2, parentSchema, it: it2 }) {
    if (parentSchema.if === void 0)
      (0, util_1$1.checkStrictMode)(it2, `"${keyword2}" without "if" is ignored`);
  }
};
thenElse.default = def$2;
Object.defineProperty(applicator, "__esModule", { value: true });
const additionalItems_1 = additionalItems;
const prefixItems_1 = prefixItems;
const items_1 = items;
const items2020_1 = items2020;
const contains_1 = contains;
const dependencies_1 = dependencies;
const propertyNames_1 = propertyNames;
const additionalProperties_1 = additionalProperties;
const properties_1 = properties$1;
const patternProperties_1 = patternProperties;
const not_1 = not$1;
const anyOf_1 = anyOf;
const oneOf_1 = oneOf;
const allOf_1 = allOf;
const if_1 = _if;
const thenElse_1 = thenElse;
function getApplicator(draft2020 = false) {
  const applicator2 = [
    // any
    not_1.default,
    anyOf_1.default,
    oneOf_1.default,
    allOf_1.default,
    if_1.default,
    thenElse_1.default,
    // object
    propertyNames_1.default,
    additionalProperties_1.default,
    dependencies_1.default,
    properties_1.default,
    patternProperties_1.default
  ];
  if (draft2020)
    applicator2.push(prefixItems_1.default, items2020_1.default);
  else
    applicator2.push(additionalItems_1.default, items_1.default);
  applicator2.push(contains_1.default);
  return applicator2;
}
applicator.default = getApplicator;
var format$5 = {};
var format$4 = {};
Object.defineProperty(format$4, "__esModule", { value: true });
const codegen_1$1 = codegen;
const error$1 = {
  message: ({ schemaCode }) => (0, codegen_1$1.str)`must match format "${schemaCode}"`,
  params: ({ schemaCode }) => (0, codegen_1$1._)`{format: ${schemaCode}}`
};
const def$1 = {
  keyword: "format",
  type: ["number", "string"],
  schemaType: "string",
  $data: true,
  error: error$1,
  code(cxt, ruleType) {
    const { gen, data, $data, schema, schemaCode, it: it2 } = cxt;
    const { opts, errSchemaPath, schemaEnv, self: self2 } = it2;
    if (!opts.validateFormats)
      return;
    if ($data)
      validate$DataFormat();
    else
      validateFormat();
    function validate$DataFormat() {
      const fmts = gen.scopeValue("formats", {
        ref: self2.formats,
        code: opts.code.formats
      });
      const fDef = gen.const("fDef", (0, codegen_1$1._)`${fmts}[${schemaCode}]`);
      const fType = gen.let("fType");
      const format3 = gen.let("format");
      gen.if((0, codegen_1$1._)`typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, () => gen.assign(fType, (0, codegen_1$1._)`${fDef}.type || "string"`).assign(format3, (0, codegen_1$1._)`${fDef}.validate`), () => gen.assign(fType, (0, codegen_1$1._)`"string"`).assign(format3, fDef));
      cxt.fail$data((0, codegen_1$1.or)(unknownFmt(), invalidFmt()));
      function unknownFmt() {
        if (opts.strictSchema === false)
          return codegen_1$1.nil;
        return (0, codegen_1$1._)`${schemaCode} && !${format3}`;
      }
      function invalidFmt() {
        const callFormat = schemaEnv.$async ? (0, codegen_1$1._)`(${fDef}.async ? await ${format3}(${data}) : ${format3}(${data}))` : (0, codegen_1$1._)`${format3}(${data})`;
        const validData = (0, codegen_1$1._)`(typeof ${format3} == "function" ? ${callFormat} : ${format3}.test(${data}))`;
        return (0, codegen_1$1._)`${format3} && ${format3} !== true && ${fType} === ${ruleType} && !${validData}`;
      }
    }
    function validateFormat() {
      const formatDef = self2.formats[schema];
      if (!formatDef) {
        unknownFormat();
        return;
      }
      if (formatDef === true)
        return;
      const [fmtType, format3, fmtRef] = getFormat(formatDef);
      if (fmtType === ruleType)
        cxt.pass(validCondition());
      function unknownFormat() {
        if (opts.strictSchema === false) {
          self2.logger.warn(unknownMsg());
          return;
        }
        throw new Error(unknownMsg());
        function unknownMsg() {
          return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
        }
      }
      function getFormat(fmtDef) {
        const code2 = fmtDef instanceof RegExp ? (0, codegen_1$1.regexpCode)(fmtDef) : opts.code.formats ? (0, codegen_1$1._)`${opts.code.formats}${(0, codegen_1$1.getProperty)(schema)}` : void 0;
        const fmt = gen.scopeValue("formats", { key: schema, ref: fmtDef, code: code2 });
        if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) {
          return [fmtDef.type || "string", fmtDef.validate, (0, codegen_1$1._)`${fmt}.validate`];
        }
        return ["string", fmtDef, fmt];
      }
      function validCondition() {
        if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
          if (!schemaEnv.$async)
            throw new Error("async format in sync schema");
          return (0, codegen_1$1._)`await ${fmtRef}(${data})`;
        }
        return typeof format3 == "function" ? (0, codegen_1$1._)`${fmtRef}(${data})` : (0, codegen_1$1._)`${fmtRef}.test(${data})`;
      }
    }
  }
};
format$4.default = def$1;
Object.defineProperty(format$5, "__esModule", { value: true });
const format_1$1 = format$4;
const format$3 = [format_1$1.default];
format$5.default = format$3;
var metadata = {};
Object.defineProperty(metadata, "__esModule", { value: true });
metadata.contentVocabulary = metadata.metadataVocabulary = void 0;
metadata.metadataVocabulary = [
  "title",
  "description",
  "default",
  "deprecated",
  "readOnly",
  "writeOnly",
  "examples"
];
metadata.contentVocabulary = [
  "contentMediaType",
  "contentEncoding",
  "contentSchema"
];
Object.defineProperty(draft7, "__esModule", { value: true });
const core_1 = core$2;
const validation_1 = validation$1;
const applicator_1 = applicator;
const format_1 = format$5;
const metadata_1 = metadata;
const draft7Vocabularies = [
  core_1.default,
  validation_1.default,
  (0, applicator_1.default)(),
  format_1.default,
  metadata_1.metadataVocabulary,
  metadata_1.contentVocabulary
];
draft7.default = draft7Vocabularies;
var discriminator = {};
var types = {};
Object.defineProperty(types, "__esModule", { value: true });
types.DiscrError = void 0;
var DiscrError;
(function(DiscrError2) {
  DiscrError2["Tag"] = "tag";
  DiscrError2["Mapping"] = "mapping";
})(DiscrError || (types.DiscrError = DiscrError = {}));
Object.defineProperty(discriminator, "__esModule", { value: true });
const codegen_1 = codegen;
const types_1 = types;
const compile_1 = compile;
const ref_error_1 = ref_error;
const util_1 = util;
const error = {
  message: ({ params: { discrError, tagName } }) => discrError === types_1.DiscrError.Tag ? `tag "${tagName}" must be string` : `value of tag "${tagName}" must be in oneOf`,
  params: ({ params: { discrError, tag: tag2, tagName } }) => (0, codegen_1._)`{error: ${discrError}, tag: ${tagName}, tagValue: ${tag2}}`
};
const def = {
  keyword: "discriminator",
  type: "object",
  schemaType: "object",
  error,
  code(cxt) {
    const { gen, data, schema, parentSchema, it: it2 } = cxt;
    const { oneOf: oneOf2 } = parentSchema;
    if (!it2.opts.discriminator) {
      throw new Error("discriminator: requires discriminator option");
    }
    const tagName = schema.propertyName;
    if (typeof tagName != "string")
      throw new Error("discriminator: requires propertyName");
    if (schema.mapping)
      throw new Error("discriminator: mapping is not supported");
    if (!oneOf2)
      throw new Error("discriminator: requires oneOf keyword");
    const valid = gen.let("valid", false);
    const tag2 = gen.const("tag", (0, codegen_1._)`${data}${(0, codegen_1.getProperty)(tagName)}`);
    gen.if((0, codegen_1._)`typeof ${tag2} == "string"`, () => validateMapping(), () => cxt.error(false, { discrError: types_1.DiscrError.Tag, tag: tag2, tagName }));
    cxt.ok(valid);
    function validateMapping() {
      const mapping = getMapping();
      gen.if(false);
      for (const tagValue in mapping) {
        gen.elseIf((0, codegen_1._)`${tag2} === ${tagValue}`);
        gen.assign(valid, applyTagSchema(mapping[tagValue]));
      }
      gen.else();
      cxt.error(false, { discrError: types_1.DiscrError.Mapping, tag: tag2, tagName });
      gen.endIf();
    }
    function applyTagSchema(schemaProp) {
      const _valid = gen.name("valid");
      const schCxt = cxt.subschema({ keyword: "oneOf", schemaProp }, _valid);
      cxt.mergeEvaluated(schCxt, codegen_1.Name);
      return _valid;
    }
    function getMapping() {
      var _a2;
      const oneOfMapping = {};
      const topRequired = hasRequired(parentSchema);
      let tagRequired = true;
      for (let i3 = 0; i3 < oneOf2.length; i3++) {
        let sch = oneOf2[i3];
        if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, util_1.schemaHasRulesButRef)(sch, it2.self.RULES)) {
          const ref2 = sch.$ref;
          sch = compile_1.resolveRef.call(it2.self, it2.schemaEnv.root, it2.baseId, ref2);
          if (sch instanceof compile_1.SchemaEnv)
            sch = sch.schema;
          if (sch === void 0)
            throw new ref_error_1.default(it2.opts.uriResolver, it2.baseId, ref2);
        }
        const propSch = (_a2 = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a2 === void 0 ? void 0 : _a2[tagName];
        if (typeof propSch != "object") {
          throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
        }
        tagRequired = tagRequired && (topRequired || hasRequired(sch));
        addMappings(propSch, i3);
      }
      if (!tagRequired)
        throw new Error(`discriminator: "${tagName}" must be required`);
      return oneOfMapping;
      function hasRequired({ required: required2 }) {
        return Array.isArray(required2) && required2.includes(tagName);
      }
      function addMappings(sch, i3) {
        if (sch.const) {
          addMapping(sch.const, i3);
        } else if (sch.enum) {
          for (const tagValue of sch.enum) {
            addMapping(tagValue, i3);
          }
        } else {
          throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
        }
      }
      function addMapping(tagValue, i3) {
        if (typeof tagValue != "string" || tagValue in oneOfMapping) {
          throw new Error(`discriminator: "${tagName}" values must be unique strings`);
        }
        oneOfMapping[tagValue] = i3;
      }
    }
  }
};
discriminator.default = def;
const $schema = "http://json-schema.org/draft-07/schema#";
const $id = "http://json-schema.org/draft-07/schema#";
const title = "Core schema meta-schema";
const definitions = {
  schemaArray: {
    type: "array",
    minItems: 1,
    items: {
      $ref: "#"
    }
  },
  nonNegativeInteger: {
    type: "integer",
    minimum: 0
  },
  nonNegativeIntegerDefault0: {
    allOf: [
      {
        $ref: "#/definitions/nonNegativeInteger"
      },
      {
        "default": 0
      }
    ]
  },
  simpleTypes: {
    "enum": [
      "array",
      "boolean",
      "integer",
      "null",
      "number",
      "object",
      "string"
    ]
  },
  stringArray: {
    type: "array",
    items: {
      type: "string"
    },
    uniqueItems: true,
    "default": []
  }
};
const type$2 = [
  "object",
  "boolean"
];
const properties = {
  $id: {
    type: "string",
    format: "uri-reference"
  },
  $schema: {
    type: "string",
    format: "uri"
  },
  $ref: {
    type: "string",
    format: "uri-reference"
  },
  $comment: {
    type: "string"
  },
  title: {
    type: "string"
  },
  description: {
    type: "string"
  },
  "default": true,
  readOnly: {
    type: "boolean",
    "default": false
  },
  examples: {
    type: "array",
    items: true
  },
  multipleOf: {
    type: "number",
    exclusiveMinimum: 0
  },
  maximum: {
    type: "number"
  },
  exclusiveMaximum: {
    type: "number"
  },
  minimum: {
    type: "number"
  },
  exclusiveMinimum: {
    type: "number"
  },
  maxLength: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minLength: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  pattern: {
    type: "string",
    format: "regex"
  },
  additionalItems: {
    $ref: "#"
  },
  items: {
    anyOf: [
      {
        $ref: "#"
      },
      {
        $ref: "#/definitions/schemaArray"
      }
    ],
    "default": true
  },
  maxItems: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minItems: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  uniqueItems: {
    type: "boolean",
    "default": false
  },
  contains: {
    $ref: "#"
  },
  maxProperties: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minProperties: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  required: {
    $ref: "#/definitions/stringArray"
  },
  additionalProperties: {
    $ref: "#"
  },
  definitions: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    "default": {}
  },
  properties: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    "default": {}
  },
  patternProperties: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    propertyNames: {
      format: "regex"
    },
    "default": {}
  },
  dependencies: {
    type: "object",
    additionalProperties: {
      anyOf: [
        {
          $ref: "#"
        },
        {
          $ref: "#/definitions/stringArray"
        }
      ]
    }
  },
  propertyNames: {
    $ref: "#"
  },
  "const": true,
  "enum": {
    type: "array",
    items: true,
    minItems: 1,
    uniqueItems: true
  },
  type: {
    anyOf: [
      {
        $ref: "#/definitions/simpleTypes"
      },
      {
        type: "array",
        items: {
          $ref: "#/definitions/simpleTypes"
        },
        minItems: 1,
        uniqueItems: true
      }
    ]
  },
  format: {
    type: "string"
  },
  contentMediaType: {
    type: "string"
  },
  contentEncoding: {
    type: "string"
  },
  "if": {
    $ref: "#"
  },
  then: {
    $ref: "#"
  },
  "else": {
    $ref: "#"
  },
  allOf: {
    $ref: "#/definitions/schemaArray"
  },
  anyOf: {
    $ref: "#/definitions/schemaArray"
  },
  oneOf: {
    $ref: "#/definitions/schemaArray"
  },
  not: {
    $ref: "#"
  }
};
const require$$3 = {
  $schema,
  $id,
  title,
  definitions,
  type: type$2,
  properties,
  "default": true
};
(function(module2, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = exports.Ajv = void 0;
  const core_12 = core$3;
  const draft7_1 = draft7;
  const discriminator_1 = discriminator;
  const draft7MetaSchema = require$$3;
  const META_SUPPORT_DATA = ["/properties"];
  const META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
  class Ajv2 extends core_12.default {
    _addVocabularies() {
      super._addVocabularies();
      draft7_1.default.forEach((v2) => this.addVocabulary(v2));
      if (this.opts.discriminator)
        this.addKeyword(discriminator_1.default);
    }
    _addDefaultMetaSchema() {
      super._addDefaultMetaSchema();
      if (!this.opts.meta)
        return;
      const metaSchema = this.opts.$data ? this.$dataMetaSchema(draft7MetaSchema, META_SUPPORT_DATA) : draft7MetaSchema;
      this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
      this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
      return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : void 0);
    }
  }
  exports.Ajv = Ajv2;
  module2.exports = exports = Ajv2;
  module2.exports.Ajv = Ajv2;
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.default = Ajv2;
  var validate_12 = validate$1;
  Object.defineProperty(exports, "KeywordCxt", { enumerable: true, get: function() {
    return validate_12.KeywordCxt;
  } });
  var codegen_12 = codegen;
  Object.defineProperty(exports, "_", { enumerable: true, get: function() {
    return codegen_12._;
  } });
  Object.defineProperty(exports, "str", { enumerable: true, get: function() {
    return codegen_12.str;
  } });
  Object.defineProperty(exports, "stringify", { enumerable: true, get: function() {
    return codegen_12.stringify;
  } });
  Object.defineProperty(exports, "nil", { enumerable: true, get: function() {
    return codegen_12.nil;
  } });
  Object.defineProperty(exports, "Name", { enumerable: true, get: function() {
    return codegen_12.Name;
  } });
  Object.defineProperty(exports, "CodeGen", { enumerable: true, get: function() {
    return codegen_12.CodeGen;
  } });
  var validation_error_12 = validation_error;
  Object.defineProperty(exports, "ValidationError", { enumerable: true, get: function() {
    return validation_error_12.default;
  } });
  var ref_error_12 = ref_error;
  Object.defineProperty(exports, "MissingRefError", { enumerable: true, get: function() {
    return ref_error_12.default;
  } });
})(ajv, ajv.exports);
var ajvExports = ajv.exports;
const Ajv = /* @__PURE__ */ getDefaultExportFromCjs$1(ajvExports);
var dist$1 = { exports: {} };
var formats = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.formatNames = exports.fastFormats = exports.fullFormats = void 0;
  function fmtDef(validate2, compare2) {
    return { validate: validate2, compare: compare2 };
  }
  exports.fullFormats = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: fmtDef(date, compareDate),
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: fmtDef(time2, compareTime),
    "date-time": fmtDef(date_time, compareDateTime),
    // duration: https://tools.ietf.org/html/rfc3339#appendix-A
    duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
    uri: uri2,
    "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
    // uri-template: https://tools.ietf.org/html/rfc6570
    "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
    // For the source: https://gist.github.com/dperini/729294
    // For test cases: https://mathiasbynens.be/demo/url-regex
    url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
    regex: regex2,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
    "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
    // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
    // byte: https://github.com/miguelmota/is-base64
    byte,
    // signed 32 bit integer
    int32: { type: "number", validate: validateInt32 },
    // signed 64 bit integer
    int64: { type: "number", validate: validateInt64 },
    // C-type float
    float: { type: "number", validate: validateNumber },
    // C-type double
    double: { type: "number", validate: validateNumber },
    // hint to the UI to hide input strings
    password: true,
    // unchecked string payload
    binary: true
  };
  exports.fastFormats = {
    ...exports.fullFormats,
    date: fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, compareDate),
    time: fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, compareTime),
    "date-time": fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, compareDateTime),
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
  };
  exports.formatNames = Object.keys(exports.fullFormats);
  function isLeapYear2(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  }
  const DATE2 = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
  const DAYS = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  function date(str) {
    const matches2 = DATE2.exec(str);
    if (!matches2)
      return false;
    const year = +matches2[1];
    const month = +matches2[2];
    const day = +matches2[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month === 2 && isLeapYear2(year) ? 29 : DAYS[month]);
  }
  function compareDate(d1, d22) {
    if (!(d1 && d22))
      return void 0;
    if (d1 > d22)
      return 1;
    if (d1 < d22)
      return -1;
    return 0;
  }
  const TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
  function time2(str, withTimeZone) {
    const matches2 = TIME.exec(str);
    if (!matches2)
      return false;
    const hour = +matches2[1];
    const minute = +matches2[2];
    const second = +matches2[3];
    const timeZone = matches2[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour === 23 && minute === 59 && second === 60) && (!withTimeZone || timeZone !== "");
  }
  function compareTime(t1, t22) {
    if (!(t1 && t22))
      return void 0;
    const a1 = TIME.exec(t1);
    const a22 = TIME.exec(t22);
    if (!(a1 && a22))
      return void 0;
    t1 = a1[1] + a1[2] + a1[3] + (a1[4] || "");
    t22 = a22[1] + a22[2] + a22[3] + (a22[4] || "");
    if (t1 > t22)
      return 1;
    if (t1 < t22)
      return -1;
    return 0;
  }
  const DATE_TIME_SEPARATOR = /t|\s/i;
  function date_time(str) {
    const dateTime = str.split(DATE_TIME_SEPARATOR);
    return dateTime.length === 2 && date(dateTime[0]) && time2(dateTime[1], true);
  }
  function compareDateTime(dt1, dt2) {
    if (!(dt1 && dt2))
      return void 0;
    const [d1, t1] = dt1.split(DATE_TIME_SEPARATOR);
    const [d22, t22] = dt2.split(DATE_TIME_SEPARATOR);
    const res = compareDate(d1, d22);
    if (res === void 0)
      return void 0;
    return res || compareTime(t1, t22);
  }
  const NOT_URI_FRAGMENT = /\/|:/;
  const URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
  function uri2(str) {
    return NOT_URI_FRAGMENT.test(str) && URI.test(str);
  }
  const BYTE = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
  function byte(str) {
    BYTE.lastIndex = 0;
    return BYTE.test(str);
  }
  const MIN_INT32 = -(2 ** 31);
  const MAX_INT32 = 2 ** 31 - 1;
  function validateInt32(value) {
    return Number.isInteger(value) && value <= MAX_INT32 && value >= MIN_INT32;
  }
  function validateInt64(value) {
    return Number.isInteger(value);
  }
  function validateNumber() {
    return true;
  }
  const Z_ANCHOR = /[^\\]\\Z/;
  function regex2(str) {
    if (Z_ANCHOR.test(str))
      return false;
    try {
      new RegExp(str);
      return true;
    } catch (e5) {
      return false;
    }
  }
})(formats);
var limit = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.formatLimitDefinition = void 0;
  const ajv_1 = ajvExports;
  const codegen_12 = codegen;
  const ops2 = codegen_12.operators;
  const KWDs2 = {
    formatMaximum: { okStr: "<=", ok: ops2.LTE, fail: ops2.GT },
    formatMinimum: { okStr: ">=", ok: ops2.GTE, fail: ops2.LT },
    formatExclusiveMaximum: { okStr: "<", ok: ops2.LT, fail: ops2.GTE },
    formatExclusiveMinimum: { okStr: ">", ok: ops2.GT, fail: ops2.LTE }
  };
  const error2 = {
    message: ({ keyword: keyword2, schemaCode }) => codegen_12.str`should be ${KWDs2[keyword2].okStr} ${schemaCode}`,
    params: ({ keyword: keyword2, schemaCode }) => codegen_12._`{comparison: ${KWDs2[keyword2].okStr}, limit: ${schemaCode}}`
  };
  exports.formatLimitDefinition = {
    keyword: Object.keys(KWDs2),
    type: "string",
    schemaType: "string",
    $data: true,
    error: error2,
    code(cxt) {
      const { gen, data, schemaCode, keyword: keyword2, it: it2 } = cxt;
      const { opts, self: self2 } = it2;
      if (!opts.validateFormats)
        return;
      const fCxt = new ajv_1.KeywordCxt(it2, self2.RULES.all.format.definition, "format");
      if (fCxt.$data)
        validate$DataFormat();
      else
        validateFormat();
      function validate$DataFormat() {
        const fmts = gen.scopeValue("formats", {
          ref: self2.formats,
          code: opts.code.formats
        });
        const fmt = gen.const("fmt", codegen_12._`${fmts}[${fCxt.schemaCode}]`);
        cxt.fail$data(codegen_12.or(codegen_12._`typeof ${fmt} != "object"`, codegen_12._`${fmt} instanceof RegExp`, codegen_12._`typeof ${fmt}.compare != "function"`, compareCode(fmt)));
      }
      function validateFormat() {
        const format3 = fCxt.schema;
        const fmtDef = self2.formats[format3];
        if (!fmtDef || fmtDef === true)
          return;
        if (typeof fmtDef != "object" || fmtDef instanceof RegExp || typeof fmtDef.compare != "function") {
          throw new Error(`"${keyword2}": format "${format3}" does not define "compare" function`);
        }
        const fmt = gen.scopeValue("formats", {
          key: format3,
          ref: fmtDef,
          code: opts.code.formats ? codegen_12._`${opts.code.formats}${codegen_12.getProperty(format3)}` : void 0
        });
        cxt.fail$data(compareCode(fmt));
      }
      function compareCode(fmt) {
        return codegen_12._`${fmt}.compare(${data}, ${schemaCode}) ${KWDs2[keyword2].fail} 0`;
      }
    },
    dependencies: ["format"]
  };
  const formatLimitPlugin = (ajv2) => {
    ajv2.addKeyword(exports.formatLimitDefinition);
    return ajv2;
  };
  exports.default = formatLimitPlugin;
})(limit);
(function(module2, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  const formats_1 = formats;
  const limit_1 = limit;
  const codegen_12 = codegen;
  const fullName = new codegen_12.Name("fullFormats");
  const fastName = new codegen_12.Name("fastFormats");
  const formatsPlugin = (ajv2, opts = { keywords: true }) => {
    if (Array.isArray(opts)) {
      addFormats2(ajv2, opts, formats_1.fullFormats, fullName);
      return ajv2;
    }
    const [formats2, exportName] = opts.mode === "fast" ? [formats_1.fastFormats, fastName] : [formats_1.fullFormats, fullName];
    const list = opts.formats || formats_1.formatNames;
    addFormats2(ajv2, list, formats2, exportName);
    if (opts.keywords)
      limit_1.default(ajv2);
    return ajv2;
  };
  formatsPlugin.get = (name2, mode = "full") => {
    const formats2 = mode === "fast" ? formats_1.fastFormats : formats_1.fullFormats;
    const f2 = formats2[name2];
    if (!f2)
      throw new Error(`Unknown format "${name2}"`);
    return f2;
  };
  function addFormats2(ajv2, list, fs, exportName) {
    var _a2;
    var _b2;
    (_a2 = (_b2 = ajv2.opts.code).formats) !== null && _a2 !== void 0 ? _a2 : _b2.formats = codegen_12._`require("ajv-formats/dist/formats").${exportName}`;
    for (const f2 of list)
      ajv2.addFormat(f2, fs[f2]);
  }
  module2.exports = exports = formatsPlugin;
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.default = formatsPlugin;
})(dist$1, dist$1.exports);
var distExports = dist$1.exports;
const addFormats = /* @__PURE__ */ getDefaultExportFromCjs$1(distExports);
const AJV_CONFIG = {
  allErrors: true,
  multipleOfPrecision: 8,
  strict: false,
  verbose: true
};
const COLOR_FORMAT_REGEX = /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/;
const DATA_URL_FORMAT_REGEX = /^data:([a-z]+\/[a-z0-9-+.]+)?;(?:name=(.*);)?base64,(.*)$/;
function createAjvInstance(additionalMetaSchemas, customFormats, ajvOptionsOverrides = {}, ajvFormatOptions, AjvClass = Ajv) {
  const ajv2 = new AjvClass({ ...AJV_CONFIG, ...ajvOptionsOverrides });
  if (ajvFormatOptions) {
    addFormats(ajv2, ajvFormatOptions);
  } else if (ajvFormatOptions !== false) {
    addFormats(ajv2);
  }
  ajv2.addFormat("data-url", DATA_URL_FORMAT_REGEX);
  ajv2.addFormat("color", COLOR_FORMAT_REGEX);
  ajv2.addKeyword(ADDITIONAL_PROPERTY_FLAG);
  ajv2.addKeyword(RJSF_ADDITIONAL_PROPERTIES_FLAG);
  if (Array.isArray(additionalMetaSchemas)) {
    ajv2.addMetaSchema(additionalMetaSchemas);
  }
  if (isObject$j(customFormats)) {
    Object.keys(customFormats).forEach((formatName) => {
      ajv2.addFormat(formatName, customFormats[formatName]);
    });
  }
  return ajv2;
}
function transformRJSFValidationErrors(errors2 = [], uiSchema) {
  return errors2.map((e5) => {
    const { instancePath, keyword: keyword2, params, schemaPath, parentSchema, ...rest } = e5;
    let { message: message2 = "" } = rest;
    let property2 = instancePath.replace(/\//g, ".");
    let stack = `${property2} ${message2}`.trim();
    if ("missingProperty" in params) {
      property2 = property2 ? `${property2}.${params.missingProperty}` : params.missingProperty;
      const currentProperty = params.missingProperty;
      const uiSchemaTitle = getUiOptions(get$6(uiSchema, `${property2.replace(/^\./, "")}`)).title;
      if (uiSchemaTitle) {
        message2 = message2.replace(currentProperty, uiSchemaTitle);
      } else {
        const parentSchemaTitle = get$6(parentSchema, [PROPERTIES_KEY, currentProperty, "title"]);
        if (parentSchemaTitle) {
          message2 = message2.replace(currentProperty, parentSchemaTitle);
        }
      }
      stack = message2;
    } else {
      const uiSchemaTitle = getUiOptions(get$6(uiSchema, `${property2.replace(/^\./, "")}`)).title;
      if (uiSchemaTitle) {
        stack = `'${uiSchemaTitle}' ${message2}`.trim();
      } else {
        const parentSchemaTitle = parentSchema === null || parentSchema === void 0 ? void 0 : parentSchema.title;
        if (parentSchemaTitle) {
          stack = `'${parentSchemaTitle}' ${message2}`.trim();
        }
      }
    }
    return {
      name: keyword2,
      property: property2,
      message: message2,
      params,
      stack,
      schemaPath
    };
  });
}
function processRawValidationErrors(validator2, rawErrors, formData, schema, customValidate, transformErrors, uiSchema) {
  const { validationError: invalidSchemaError } = rawErrors;
  let errors2 = transformRJSFValidationErrors(rawErrors.errors, uiSchema);
  if (invalidSchemaError) {
    errors2 = [...errors2, { stack: invalidSchemaError.message }];
  }
  if (typeof transformErrors === "function") {
    errors2 = transformErrors(errors2, uiSchema);
  }
  let errorSchema = toErrorSchema(errors2);
  if (invalidSchemaError) {
    errorSchema = {
      ...errorSchema,
      $schema: {
        __errors: [invalidSchemaError.message]
      }
    };
  }
  if (typeof customValidate !== "function") {
    return { errors: errors2, errorSchema };
  }
  const newFormData = getDefaultFormState(validator2, schema, formData, schema, true);
  const errorHandler = customValidate(newFormData, createErrorHandler(newFormData), uiSchema);
  const userErrorSchema = unwrapErrorHandler(errorHandler);
  return validationDataMerge({ errors: errors2, errorSchema }, userErrorSchema);
}
class AJV8Validator {
  /** Constructs an `AJV8Validator` instance using the `options`
   *
   * @param options - The `CustomValidatorOptionsType` options that are used to create the AJV instance
   * @param [localizer] - If provided, is used to localize a list of Ajv `ErrorObject`s
   */
  constructor(options, localizer) {
    const { additionalMetaSchemas, customFormats, ajvOptionsOverrides, ajvFormatOptions, AjvClass } = options;
    this.ajv = createAjvInstance(additionalMetaSchemas, customFormats, ajvOptionsOverrides, ajvFormatOptions, AjvClass);
    this.localizer = localizer;
  }
  /** Converts an `errorSchema` into a list of `RJSFValidationErrors`
   *
   * @param errorSchema - The `ErrorSchema` instance to convert
   * @param [fieldPath=[]] - The current field path, defaults to [] if not specified
   * @deprecated - Use the `toErrorList()` function provided by `@rjsf/utils` instead. This function will be removed in
   *        the next major release.
   */
  toErrorList(errorSchema, fieldPath = []) {
    return toErrorList(errorSchema, fieldPath);
  }
  /** Runs the pure validation of the `schema` and `formData` without any of the RJSF functionality. Provided for use
   * by the playground. Returns the `errors` from the validation
   *
   * @param schema - The schema against which to validate the form data   * @param schema
   * @param formData - The form data to validate
   */
  rawValidation(schema, formData) {
    let compilationError = void 0;
    let compiledValidator;
    if (schema[ID_KEY]) {
      compiledValidator = this.ajv.getSchema(schema[ID_KEY]);
    }
    try {
      if (compiledValidator === void 0) {
        compiledValidator = this.ajv.compile(schema);
      }
      compiledValidator(formData);
    } catch (err) {
      compilationError = err;
    }
    let errors2;
    if (compiledValidator) {
      if (typeof this.localizer === "function") {
        this.localizer(compiledValidator.errors);
      }
      errors2 = compiledValidator.errors || void 0;
      compiledValidator.errors = null;
    }
    return {
      errors: errors2,
      validationError: compilationError
    };
  }
  /** This function processes the `formData` with an optional user contributed `customValidate` function, which receives
   * the form data and a `errorHandler` function that will be used to add custom validation errors for each field. Also
   * supports a `transformErrors` function that will take the raw AJV validation errors, prior to custom validation and
   * transform them in what ever way it chooses.
   *
   * @param formData - The form data to validate
   * @param schema - The schema against which to validate the form data
   * @param [customValidate] - An optional function that is used to perform custom validation
   * @param [transformErrors] - An optional function that is used to transform errors after AJV validation
   * @param [uiSchema] - An optional uiSchema that is passed to `transformErrors` and `customValidate`
   */
  validateFormData(formData, schema, customValidate, transformErrors, uiSchema) {
    const rawErrors = this.rawValidation(schema, formData);
    return processRawValidationErrors(this, rawErrors, formData, schema, customValidate, transformErrors, uiSchema);
  }
  /**
   * This function checks if a schema needs to be added and if the root schemas don't match it removes the old root schema from the ajv instance and adds the new one.
   * @param rootSchema - The root schema used to provide $ref resolutions
   */
  handleSchemaUpdate(rootSchema) {
    var _a2, _b2;
    const rootSchemaId = (_a2 = rootSchema[ID_KEY]) !== null && _a2 !== void 0 ? _a2 : ROOT_SCHEMA_PREFIX;
    if (this.ajv.getSchema(rootSchemaId) === void 0) {
      this.ajv.addSchema(rootSchema, rootSchemaId);
    } else if (!deepEquals(rootSchema, (_b2 = this.ajv.getSchema(rootSchemaId)) === null || _b2 === void 0 ? void 0 : _b2.schema)) {
      this.ajv.removeSchema(rootSchemaId);
      this.ajv.addSchema(rootSchema, rootSchemaId);
    }
  }
  /** Validates data against a schema, returning true if the data is valid, or
   * false otherwise. If the schema is invalid, then this function will return
   * false.
   *
   * @param schema - The schema against which to validate the form data
   * @param formData - The form data to validate
   * @param rootSchema - The root schema used to provide $ref resolutions
   */
  isValid(schema, formData, rootSchema) {
    var _a2;
    try {
      this.handleSchemaUpdate(rootSchema);
      const schemaWithIdRefPrefix = withIdRefPrefix(schema);
      const schemaId = (_a2 = schemaWithIdRefPrefix[ID_KEY]) !== null && _a2 !== void 0 ? _a2 : hashForSchema(schemaWithIdRefPrefix);
      let compiledValidator;
      compiledValidator = this.ajv.getSchema(schemaId);
      if (compiledValidator === void 0) {
        compiledValidator = this.ajv.addSchema(schemaWithIdRefPrefix, schemaId).getSchema(schemaId) || this.ajv.compile(schemaWithIdRefPrefix);
      }
      const result2 = compiledValidator(formData);
      return result2;
    } catch (e5) {
      console.warn("Error encountered compiling schema:", e5);
      return false;
    }
  }
}
function customizeValidator(options = {}, localizer) {
  return new AJV8Validator(options, localizer);
}
const validator = customizeValidator();
const WIDGET_TYPE_FILE_UPLOAD = "FileUploadField";
const UI_FIELD = "ui:field";
const UI_ORDER = "ui:order";
const validateUpload = ({
  name: name2,
  required: required2,
  formData,
  errors: errors2
}) => {
  if (formData && formData[name2]) {
    const fileData = formData[name2];
    if (required2 && fileData.length === 0) {
      errors2[name2].addError("at least one file must be uploaded");
    }
    if (fileData.some((file) => file.uploading === true)) {
      errors2[name2].addError("all files must complete uploading");
    }
    if (fileData.some((file) => file.error === true)) {
      errors2[name2].addError("failed files must be removed");
    }
  }
};
const validationMap = {
  [WIDGET_TYPE_FILE_UPLOAD]: validateUpload
};
const validate = (schema, uiSchema) => (formData, errors2) => {
  Object.keys(uiSchema).filter((x3) => x3 !== UI_ORDER).forEach((formFieldName) => {
    const required2 = schema.required && schema.required.includes(formFieldName);
    const fieldType = uiSchema[formFieldName][UI_FIELD];
    const validator2 = validationMap[fieldType];
    if (typeof validator2 === "function")
      validator2({ name: formFieldName, required: required2, formData, errors: errors2 });
  });
  return errors2;
};
var hasOwn$1 = Object.prototype.hasOwnProperty;
var toStr$4 = Object.prototype.toString;
var defineProperty$3 = Object.defineProperty;
var gOPD$4 = Object.getOwnPropertyDescriptor;
var isArray$1 = function isArray2(arr) {
  if (typeof Array.isArray === "function") {
    return Array.isArray(arr);
  }
  return toStr$4.call(arr) === "[object Array]";
};
var isPlainObject2 = function isPlainObject3(obj) {
  if (!obj || toStr$4.call(obj) !== "[object Object]") {
    return false;
  }
  var hasOwnConstructor = hasOwn$1.call(obj, "constructor");
  var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn$1.call(obj.constructor.prototype, "isPrototypeOf");
  if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
    return false;
  }
  var key2;
  for (key2 in obj) {
  }
  return typeof key2 === "undefined" || hasOwn$1.call(obj, key2);
};
var setProperty = function setProperty2(target, options) {
  if (defineProperty$3 && options.name === "__proto__") {
    defineProperty$3(target, options.name, {
      enumerable: true,
      configurable: true,
      value: options.newValue,
      writable: true
    });
  } else {
    target[options.name] = options.newValue;
  }
};
var getProperty = function getProperty2(obj, name2) {
  if (name2 === "__proto__") {
    if (!hasOwn$1.call(obj, name2)) {
      return void 0;
    } else if (gOPD$4) {
      return gOPD$4(obj, name2).value;
    }
  }
  return obj[name2];
};
var extend$2 = function extend() {
  var options, name2, src2, copy2, copyIsArray, clone2;
  var target = arguments[0];
  var i3 = 1;
  var length = arguments.length;
  var deep = false;
  if (typeof target === "boolean") {
    deep = target;
    target = arguments[1] || {};
    i3 = 2;
  }
  if (target == null || typeof target !== "object" && typeof target !== "function") {
    target = {};
  }
  for (; i3 < length; ++i3) {
    options = arguments[i3];
    if (options != null) {
      for (name2 in options) {
        src2 = getProperty(target, name2);
        copy2 = getProperty(options, name2);
        if (target !== copy2) {
          if (deep && copy2 && (isPlainObject2(copy2) || (copyIsArray = isArray$1(copy2)))) {
            if (copyIsArray) {
              copyIsArray = false;
              clone2 = src2 && isArray$1(src2) ? src2 : [];
            } else {
              clone2 = src2 && isPlainObject2(src2) ? src2 : {};
            }
            setProperty(target, { name: name2, newValue: extend(deep, clone2, copy2) });
          } else if (typeof copy2 !== "undefined") {
            setProperty(target, { name: name2, newValue: copy2 });
          }
        }
      }
    }
  }
  return target;
};
var bail_1 = bail$1;
function bail$1(err) {
  if (err) {
    throw err;
  }
}
var own$3 = {}.hasOwnProperty;
var unistUtilStringifyPosition = stringify$1;
function stringify$1(value) {
  if (!value || typeof value !== "object") {
    return null;
  }
  if (own$3.call(value, "position") || own$3.call(value, "type")) {
    return position(value.position);
  }
  if (own$3.call(value, "start") || own$3.call(value, "end")) {
    return position(value);
  }
  if (own$3.call(value, "line") || own$3.call(value, "column")) {
    return point2(value);
  }
  return null;
}
function point2(point3) {
  if (!point3 || typeof point3 !== "object") {
    point3 = {};
  }
  return index$1(point3.line) + ":" + index$1(point3.column);
}
function position(pos) {
  if (!pos || typeof pos !== "object") {
    pos = {};
  }
  return point2(pos.start) + "-" + point2(pos.end);
}
function index$1(value) {
  return value && typeof value === "number" ? value : 1;
}
var stringify2 = unistUtilStringifyPosition;
var vfileMessage = VMessage$1;
function VMessagePrototype() {
}
VMessagePrototype.prototype = Error.prototype;
VMessage$1.prototype = new VMessagePrototype();
var proto$6 = VMessage$1.prototype;
proto$6.file = "";
proto$6.name = "";
proto$6.reason = "";
proto$6.message = "";
proto$6.stack = "";
proto$6.fatal = null;
proto$6.column = null;
proto$6.line = null;
function VMessage$1(reason, position2, origin) {
  var parts;
  var range2;
  var location;
  if (typeof position2 === "string") {
    origin = position2;
    position2 = null;
  }
  parts = parseOrigin(origin);
  range2 = stringify2(position2) || "1:1";
  location = {
    start: { line: null, column: null },
    end: { line: null, column: null }
  };
  if (position2 && position2.position) {
    position2 = position2.position;
  }
  if (position2) {
    if (position2.start) {
      location = position2;
      position2 = position2.start;
    } else {
      location.start = position2;
    }
  }
  if (reason.stack) {
    this.stack = reason.stack;
    reason = reason.message;
  }
  this.message = reason;
  this.name = range2;
  this.reason = reason;
  this.line = position2 ? position2.line : null;
  this.column = position2 ? position2.column : null;
  this.location = location;
  this.source = parts[0];
  this.ruleId = parts[1];
}
function parseOrigin(origin) {
  var result2 = [null, null];
  var index2;
  if (typeof origin === "string") {
    index2 = origin.indexOf(":");
    if (index2 === -1) {
      result2[1] = origin;
    } else {
      result2[0] = origin.slice(0, index2);
      result2[1] = origin.slice(index2 + 1);
    }
  }
  return result2;
}
function assertPath$1(path3) {
  if (typeof path3 !== "string") {
    throw new TypeError("Path must be a string. Received " + JSON.stringify(path3));
  }
}
function normalizeStringPosix(path3, allowAboveRoot) {
  var res = "";
  var lastSegmentLength = 0;
  var lastSlash = -1;
  var dots = 0;
  var code2;
  for (var i3 = 0; i3 <= path3.length; ++i3) {
    if (i3 < path3.length)
      code2 = path3.charCodeAt(i3);
    else if (code2 === 47)
      break;
    else
      code2 = 47;
    if (code2 === 47) {
      if (lastSlash === i3 - 1 || dots === 1) ;
      else if (lastSlash !== i3 - 1 && dots === 2) {
        if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
          if (res.length > 2) {
            var lastSlashIndex = res.lastIndexOf("/");
            if (lastSlashIndex !== res.length - 1) {
              if (lastSlashIndex === -1) {
                res = "";
                lastSegmentLength = 0;
              } else {
                res = res.slice(0, lastSlashIndex);
                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
              }
              lastSlash = i3;
              dots = 0;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = "";
            lastSegmentLength = 0;
            lastSlash = i3;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          if (res.length > 0)
            res += "/..";
          else
            res = "..";
          lastSegmentLength = 2;
        }
      } else {
        if (res.length > 0)
          res += "/" + path3.slice(lastSlash + 1, i3);
        else
          res = path3.slice(lastSlash + 1, i3);
        lastSegmentLength = i3 - lastSlash - 1;
      }
      lastSlash = i3;
      dots = 0;
    } else if (code2 === 46 && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }
  return res;
}
function _format(sep, pathObject) {
  var dir = pathObject.dir || pathObject.root;
  var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
  if (!dir) {
    return base;
  }
  if (dir === pathObject.root) {
    return dir + base;
  }
  return dir + sep + base;
}
var posix = {
  // path.resolve([from ...], to)
  resolve: function resolve2() {
    var resolvedPath = "";
    var resolvedAbsolute = false;
    var cwd;
    for (var i3 = arguments.length - 1; i3 >= -1 && !resolvedAbsolute; i3--) {
      var path3;
      if (i3 >= 0)
        path3 = arguments[i3];
      else {
        if (cwd === void 0)
          cwd = process$1$1.cwd();
        path3 = cwd;
      }
      assertPath$1(path3);
      if (path3.length === 0) {
        continue;
      }
      resolvedPath = path3 + "/" + resolvedPath;
      resolvedAbsolute = path3.charCodeAt(0) === 47;
    }
    resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);
    if (resolvedAbsolute) {
      if (resolvedPath.length > 0)
        return "/" + resolvedPath;
      else
        return "/";
    } else if (resolvedPath.length > 0) {
      return resolvedPath;
    } else {
      return ".";
    }
  },
  normalize: function normalize3(path3) {
    assertPath$1(path3);
    if (path3.length === 0) return ".";
    var isAbsolute2 = path3.charCodeAt(0) === 47;
    var trailingSeparator = path3.charCodeAt(path3.length - 1) === 47;
    path3 = normalizeStringPosix(path3, !isAbsolute2);
    if (path3.length === 0 && !isAbsolute2) path3 = ".";
    if (path3.length > 0 && trailingSeparator) path3 += "/";
    if (isAbsolute2) return "/" + path3;
    return path3;
  },
  isAbsolute: function isAbsolute(path3) {
    assertPath$1(path3);
    return path3.length > 0 && path3.charCodeAt(0) === 47;
  },
  join: function join() {
    if (arguments.length === 0)
      return ".";
    var joined;
    for (var i3 = 0; i3 < arguments.length; ++i3) {
      var arg = arguments[i3];
      assertPath$1(arg);
      if (arg.length > 0) {
        if (joined === void 0)
          joined = arg;
        else
          joined += "/" + arg;
      }
    }
    if (joined === void 0)
      return ".";
    return posix.normalize(joined);
  },
  relative: function relative(from2, to2) {
    assertPath$1(from2);
    assertPath$1(to2);
    if (from2 === to2) return "";
    from2 = posix.resolve(from2);
    to2 = posix.resolve(to2);
    if (from2 === to2) return "";
    var fromStart = 1;
    for (; fromStart < from2.length; ++fromStart) {
      if (from2.charCodeAt(fromStart) !== 47)
        break;
    }
    var fromEnd = from2.length;
    var fromLen = fromEnd - fromStart;
    var toStart = 1;
    for (; toStart < to2.length; ++toStart) {
      if (to2.charCodeAt(toStart) !== 47)
        break;
    }
    var toEnd = to2.length;
    var toLen = toEnd - toStart;
    var length = fromLen < toLen ? fromLen : toLen;
    var lastCommonSep = -1;
    var i3 = 0;
    for (; i3 <= length; ++i3) {
      if (i3 === length) {
        if (toLen > length) {
          if (to2.charCodeAt(toStart + i3) === 47) {
            return to2.slice(toStart + i3 + 1);
          } else if (i3 === 0) {
            return to2.slice(toStart + i3);
          }
        } else if (fromLen > length) {
          if (from2.charCodeAt(fromStart + i3) === 47) {
            lastCommonSep = i3;
          } else if (i3 === 0) {
            lastCommonSep = 0;
          }
        }
        break;
      }
      var fromCode = from2.charCodeAt(fromStart + i3);
      var toCode = to2.charCodeAt(toStart + i3);
      if (fromCode !== toCode)
        break;
      else if (fromCode === 47)
        lastCommonSep = i3;
    }
    var out = "";
    for (i3 = fromStart + lastCommonSep + 1; i3 <= fromEnd; ++i3) {
      if (i3 === fromEnd || from2.charCodeAt(i3) === 47) {
        if (out.length === 0)
          out += "..";
        else
          out += "/..";
      }
    }
    if (out.length > 0)
      return out + to2.slice(toStart + lastCommonSep);
    else {
      toStart += lastCommonSep;
      if (to2.charCodeAt(toStart) === 47)
        ++toStart;
      return to2.slice(toStart);
    }
  },
  _makeLong: function _makeLong(path3) {
    return path3;
  },
  dirname: function dirname(path3) {
    assertPath$1(path3);
    if (path3.length === 0) return ".";
    var code2 = path3.charCodeAt(0);
    var hasRoot = code2 === 47;
    var end2 = -1;
    var matchedSlash = true;
    for (var i3 = path3.length - 1; i3 >= 1; --i3) {
      code2 = path3.charCodeAt(i3);
      if (code2 === 47) {
        if (!matchedSlash) {
          end2 = i3;
          break;
        }
      } else {
        matchedSlash = false;
      }
    }
    if (end2 === -1) return hasRoot ? "/" : ".";
    if (hasRoot && end2 === 1) return "//";
    return path3.slice(0, end2);
  },
  basename: function basename(path3, ext) {
    if (ext !== void 0 && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    assertPath$1(path3);
    var start2 = 0;
    var end2 = -1;
    var matchedSlash = true;
    var i3;
    if (ext !== void 0 && ext.length > 0 && ext.length <= path3.length) {
      if (ext.length === path3.length && ext === path3) return "";
      var extIdx = ext.length - 1;
      var firstNonSlashEnd = -1;
      for (i3 = path3.length - 1; i3 >= 0; --i3) {
        var code2 = path3.charCodeAt(i3);
        if (code2 === 47) {
          if (!matchedSlash) {
            start2 = i3 + 1;
            break;
          }
        } else {
          if (firstNonSlashEnd === -1) {
            matchedSlash = false;
            firstNonSlashEnd = i3 + 1;
          }
          if (extIdx >= 0) {
            if (code2 === ext.charCodeAt(extIdx)) {
              if (--extIdx === -1) {
                end2 = i3;
              }
            } else {
              extIdx = -1;
              end2 = firstNonSlashEnd;
            }
          }
        }
      }
      if (start2 === end2) end2 = firstNonSlashEnd;
      else if (end2 === -1) end2 = path3.length;
      return path3.slice(start2, end2);
    } else {
      for (i3 = path3.length - 1; i3 >= 0; --i3) {
        if (path3.charCodeAt(i3) === 47) {
          if (!matchedSlash) {
            start2 = i3 + 1;
            break;
          }
        } else if (end2 === -1) {
          matchedSlash = false;
          end2 = i3 + 1;
        }
      }
      if (end2 === -1) return "";
      return path3.slice(start2, end2);
    }
  },
  extname: function extname(path3) {
    assertPath$1(path3);
    var startDot = -1;
    var startPart = 0;
    var end2 = -1;
    var matchedSlash = true;
    var preDotState = 0;
    for (var i3 = path3.length - 1; i3 >= 0; --i3) {
      var code2 = path3.charCodeAt(i3);
      if (code2 === 47) {
        if (!matchedSlash) {
          startPart = i3 + 1;
          break;
        }
        continue;
      }
      if (end2 === -1) {
        matchedSlash = false;
        end2 = i3 + 1;
      }
      if (code2 === 46) {
        if (startDot === -1)
          startDot = i3;
        else if (preDotState !== 1)
          preDotState = 1;
      } else if (startDot !== -1) {
        preDotState = -1;
      }
    }
    if (startDot === -1 || end2 === -1 || // We saw a non-dot character immediately before the dot
    preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
    preDotState === 1 && startDot === end2 - 1 && startDot === startPart + 1) {
      return "";
    }
    return path3.slice(startDot, end2);
  },
  format: function format(pathObject) {
    if (pathObject === null || typeof pathObject !== "object") {
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
    }
    return _format("/", pathObject);
  },
  parse: function parse(path3) {
    assertPath$1(path3);
    var ret = { root: "", dir: "", base: "", ext: "", name: "" };
    if (path3.length === 0) return ret;
    var code2 = path3.charCodeAt(0);
    var isAbsolute2 = code2 === 47;
    var start2;
    if (isAbsolute2) {
      ret.root = "/";
      start2 = 1;
    } else {
      start2 = 0;
    }
    var startDot = -1;
    var startPart = 0;
    var end2 = -1;
    var matchedSlash = true;
    var i3 = path3.length - 1;
    var preDotState = 0;
    for (; i3 >= start2; --i3) {
      code2 = path3.charCodeAt(i3);
      if (code2 === 47) {
        if (!matchedSlash) {
          startPart = i3 + 1;
          break;
        }
        continue;
      }
      if (end2 === -1) {
        matchedSlash = false;
        end2 = i3 + 1;
      }
      if (code2 === 46) {
        if (startDot === -1) startDot = i3;
        else if (preDotState !== 1) preDotState = 1;
      } else if (startDot !== -1) {
        preDotState = -1;
      }
    }
    if (startDot === -1 || end2 === -1 || // We saw a non-dot character immediately before the dot
    preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
    preDotState === 1 && startDot === end2 - 1 && startDot === startPart + 1) {
      if (end2 !== -1) {
        if (startPart === 0 && isAbsolute2) ret.base = ret.name = path3.slice(1, end2);
        else ret.base = ret.name = path3.slice(startPart, end2);
      }
    } else {
      if (startPart === 0 && isAbsolute2) {
        ret.name = path3.slice(1, startDot);
        ret.base = path3.slice(1, end2);
      } else {
        ret.name = path3.slice(startPart, startDot);
        ret.base = path3.slice(startPart, end2);
      }
      ret.ext = path3.slice(startDot, end2);
    }
    if (startPart > 0) ret.dir = path3.slice(0, startPart - 1);
    else if (isAbsolute2) ret.dir = "/";
    return ret;
  },
  sep: "/",
  delimiter: ":",
  win32: null,
  posix: null
};
posix.posix = posix;
var pathBrowserify = posix;
var path$1 = pathBrowserify;
function replaceExt(npath, ext) {
  if (typeof npath !== "string") {
    return npath;
  }
  if (npath.length === 0) {
    return npath;
  }
  var nFileName = path$1.basename(npath, path$1.extname(npath)) + ext;
  return path$1.join(path$1.dirname(npath), nFileName);
}
var replaceExt_1 = replaceExt;
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var isBuffer_1 = function(obj) {
  return obj != null && (isBuffer$1(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};
function isBuffer$1(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer$1(obj.slice(0, 0));
}
var path2 = pathBrowserify;
var replace = replaceExt_1;
var buffer = isBuffer_1;
var core = VFile$1;
var own$2 = {}.hasOwnProperty;
var proto$5 = VFile$1.prototype;
proto$5.toString = toString$3;
var order = [
  "history",
  "path",
  "basename",
  "stem",
  "extname",
  "dirname"
];
function VFile$1(options) {
  var prop;
  var index2;
  var length;
  if (!options) {
    options = {};
  } else if (typeof options === "string" || buffer(options)) {
    options = { contents: options };
  } else if ("message" in options && "messages" in options) {
    return options;
  }
  if (!(this instanceof VFile$1)) {
    return new VFile$1(options);
  }
  this.data = {};
  this.messages = [];
  this.history = [];
  this.cwd = process$1$1.cwd();
  index2 = -1;
  length = order.length;
  while (++index2 < length) {
    prop = order[index2];
    if (own$2.call(options, prop)) {
      this[prop] = options[prop];
    }
  }
  for (prop in options) {
    if (order.indexOf(prop) === -1) {
      this[prop] = options[prop];
    }
  }
}
Object.defineProperty(proto$5, "path", {
  get: function() {
    return this.history[this.history.length - 1];
  },
  set: function(path3) {
    assertNonEmpty(path3, "path");
    if (path3 !== this.path) {
      this.history.push(path3);
    }
  }
});
Object.defineProperty(proto$5, "dirname", {
  get: function() {
    return typeof this.path === "string" ? path2.dirname(this.path) : void 0;
  },
  set: function(dirname2) {
    assertPath(this.path, "dirname");
    this.path = path2.join(dirname2 || "", this.basename);
  }
});
Object.defineProperty(proto$5, "basename", {
  get: function() {
    return typeof this.path === "string" ? path2.basename(this.path) : void 0;
  },
  set: function(basename2) {
    assertNonEmpty(basename2, "basename");
    assertPart(basename2, "basename");
    this.path = path2.join(this.dirname || "", basename2);
  }
});
Object.defineProperty(proto$5, "extname", {
  get: function() {
    return typeof this.path === "string" ? path2.extname(this.path) : void 0;
  },
  set: function(extname2) {
    var ext = extname2 || "";
    assertPart(ext, "extname");
    assertPath(this.path, "extname");
    if (ext) {
      if (ext.charAt(0) !== ".") {
        throw new Error("`extname` must start with `.`");
      }
      if (ext.indexOf(".", 1) !== -1) {
        throw new Error("`extname` cannot contain multiple dots");
      }
    }
    this.path = replace(this.path, ext);
  }
});
Object.defineProperty(proto$5, "stem", {
  get: function() {
    return typeof this.path === "string" ? path2.basename(this.path, this.extname) : void 0;
  },
  set: function(stem) {
    assertNonEmpty(stem, "stem");
    assertPart(stem, "stem");
    this.path = path2.join(this.dirname || "", stem + (this.extname || ""));
  }
});
function toString$3(encoding) {
  var value = this.contents || "";
  return buffer(value) ? value.toString(encoding) : String(value);
}
function assertPart(part, name2) {
  if (part.indexOf(path2.sep) !== -1) {
    throw new Error("`" + name2 + "` cannot be a path: did not expect `" + path2.sep + "`");
  }
}
function assertNonEmpty(part, name2) {
  if (!part) {
    throw new Error("`" + name2 + "` cannot be empty");
  }
}
function assertPath(path3, name2) {
  if (!path3) {
    throw new Error("Setting `" + name2 + "` requires `path` to be set too");
  }
}
var VMessage = vfileMessage;
var VFile = core;
var vfile$1 = VFile;
var proto$4 = VFile.prototype;
proto$4.message = message;
proto$4.info = info;
proto$4.fail = fail;
proto$4.warn = message;
function message(reason, position2, origin) {
  var filePath = this.path;
  var message2 = new VMessage(reason, position2, origin);
  if (filePath) {
    message2.name = filePath + ":" + message2.name;
    message2.file = filePath;
  }
  message2.fatal = false;
  this.messages.push(message2);
  return message2;
}
function fail() {
  var message2 = this.message.apply(this, arguments);
  message2.fatal = true;
  throw message2;
}
function info() {
  var message2 = this.message.apply(this, arguments);
  message2.fatal = null;
  return message2;
}
var slice$3 = [].slice;
var wrap_1 = wrap$2;
function wrap$2(fn2, callback) {
  var invoked;
  return wrapped;
  function wrapped() {
    var params = slice$3.call(arguments, 0);
    var callback2 = fn2.length > params.length;
    var result2;
    if (callback2) {
      params.push(done);
    }
    try {
      result2 = fn2.apply(null, params);
    } catch (error2) {
      if (callback2 && invoked) {
        throw error2;
      }
      return done(error2);
    }
    if (!callback2) {
      if (result2 && typeof result2.then === "function") {
        result2.then(then, done);
      } else if (result2 instanceof Error) {
        done(result2);
      } else {
        then(result2);
      }
    }
  }
  function done() {
    if (!invoked) {
      invoked = true;
      callback.apply(null, arguments);
    }
  }
  function then(value) {
    done(null, value);
  }
}
var wrap$1 = wrap_1;
var trough_1 = trough$1;
trough$1.wrap = wrap$1;
var slice$2 = [].slice;
function trough$1() {
  var fns = [];
  var middleware = {};
  middleware.run = run;
  middleware.use = use;
  return middleware;
  function run() {
    var index2 = -1;
    var input = slice$2.call(arguments, 0, -1);
    var done = arguments[arguments.length - 1];
    if (typeof done !== "function") {
      throw new Error("Expected function as last argument, not " + done);
    }
    next3.apply(null, [null].concat(input));
    function next3(err) {
      var fn2 = fns[++index2];
      var params = slice$2.call(arguments, 0);
      var values = params.slice(1);
      var length = input.length;
      var pos = -1;
      if (err) {
        done(err);
        return;
      }
      while (++pos < length) {
        if (values[pos] === null || values[pos] === void 0) {
          values[pos] = input[pos];
        }
      }
      input = values;
      if (fn2) {
        wrap$1(fn2, next3).apply(null, input);
      } else {
        done.apply(null, [null].concat(input));
      }
    }
  }
  function use(fn2) {
    if (typeof fn2 !== "function") {
      throw new Error("Expected `fn` to be a function, not " + fn2);
    }
    fns.push(fn2);
    return middleware;
  }
}
var toString$2 = Object.prototype.toString;
var xIsString = isString$1;
function isString$1(obj) {
  return toString$2.call(obj) === "[object String]";
}
var toString$1 = Object.prototype.toString;
var isPlainObj = function(x3) {
  var prototype;
  return toString$1.call(x3) === "[object Object]" && (prototype = Object.getPrototypeOf(x3), prototype === null || prototype === Object.getPrototypeOf({}));
};
var extend$1 = extend$2;
var bail = bail_1;
var vfile = vfile$1;
var trough = trough_1;
var string2 = xIsString;
var plain = isPlainObj;
var unified_1 = unified$1().freeze();
var slice$1 = [].slice;
var own$1 = {}.hasOwnProperty;
var pipeline = trough().use(pipelineParse).use(pipelineRun).use(pipelineStringify);
function pipelineParse(p2, ctx2) {
  ctx2.tree = p2.parse(ctx2.file);
}
function pipelineRun(p2, ctx2, next3) {
  p2.run(ctx2.tree, ctx2.file, done);
  function done(err, tree, file) {
    if (err) {
      next3(err);
    } else {
      ctx2.tree = tree;
      ctx2.file = file;
      next3();
    }
  }
}
function pipelineStringify(p2, ctx2) {
  ctx2.file.contents = p2.stringify(ctx2.tree, ctx2.file);
}
function unified$1() {
  var attachers = [];
  var transformers = trough();
  var namespace = {};
  var frozen = false;
  var freezeIndex = -1;
  processor.data = data;
  processor.freeze = freeze2;
  processor.attachers = attachers;
  processor.use = use;
  processor.parse = parse3;
  processor.stringify = stringify3;
  processor.run = run;
  processor.runSync = runSync;
  processor.process = process2;
  processor.processSync = processSync;
  return processor;
  function processor() {
    var destination = unified$1();
    var length = attachers.length;
    var index2 = -1;
    while (++index2 < length) {
      destination.use.apply(null, attachers[index2]);
    }
    destination.data(extend$1(true, {}, namespace));
    return destination;
  }
  function freeze2() {
    var values;
    var plugin;
    var options;
    var transformer;
    if (frozen) {
      return processor;
    }
    while (++freezeIndex < attachers.length) {
      values = attachers[freezeIndex];
      plugin = values[0];
      options = values[1];
      transformer = null;
      if (options === false) {
        continue;
      }
      if (options === true) {
        values[1] = void 0;
      }
      transformer = plugin.apply(processor, values.slice(1));
      if (typeof transformer === "function") {
        transformers.use(transformer);
      }
    }
    frozen = true;
    freezeIndex = Infinity;
    return processor;
  }
  function data(key2, value) {
    if (string2(key2)) {
      if (arguments.length === 2) {
        assertUnfrozen("data", frozen);
        namespace[key2] = value;
        return processor;
      }
      return own$1.call(namespace, key2) && namespace[key2] || null;
    }
    if (key2) {
      assertUnfrozen("data", frozen);
      namespace = key2;
      return processor;
    }
    return namespace;
  }
  function use(value) {
    var settings;
    assertUnfrozen("use", frozen);
    if (value === null || value === void 0) ;
    else if (typeof value === "function") {
      addPlugin.apply(null, arguments);
    } else if (typeof value === "object") {
      if ("length" in value) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new Error("Expected usable value, not `" + value + "`");
    }
    if (settings) {
      namespace.settings = extend$1(namespace.settings || {}, settings);
    }
    return processor;
    function addPreset(result2) {
      addList(result2.plugins);
      if (result2.settings) {
        settings = extend$1(settings || {}, result2.settings);
      }
    }
    function add2(value2) {
      if (typeof value2 === "function") {
        addPlugin(value2);
      } else if (typeof value2 === "object") {
        if ("length" in value2) {
          addPlugin.apply(null, value2);
        } else {
          addPreset(value2);
        }
      } else {
        throw new Error("Expected usable value, not `" + value2 + "`");
      }
    }
    function addList(plugins2) {
      var length;
      var index2;
      if (plugins2 === null || plugins2 === void 0) ;
      else if (typeof plugins2 === "object" && "length" in plugins2) {
        length = plugins2.length;
        index2 = -1;
        while (++index2 < length) {
          add2(plugins2[index2]);
        }
      } else {
        throw new Error("Expected a list of plugins, not `" + plugins2 + "`");
      }
    }
    function addPlugin(plugin, value2) {
      var entry = find2(plugin);
      if (entry) {
        if (plain(entry[1]) && plain(value2)) {
          value2 = extend$1(entry[1], value2);
        }
        entry[1] = value2;
      } else {
        attachers.push(slice$1.call(arguments));
      }
    }
  }
  function find2(plugin) {
    var length = attachers.length;
    var index2 = -1;
    var entry;
    while (++index2 < length) {
      entry = attachers[index2];
      if (entry[0] === plugin) {
        return entry;
      }
    }
  }
  function parse3(doc) {
    var file = vfile(doc);
    var Parser3;
    freeze2();
    Parser3 = processor.Parser;
    assertParser("parse", Parser3);
    if (newable(Parser3)) {
      return new Parser3(String(file), file).parse();
    }
    return Parser3(String(file), file);
  }
  function run(node3, file, cb) {
    assertNode(node3);
    freeze2();
    if (!cb && typeof file === "function") {
      cb = file;
      file = null;
    }
    if (!cb) {
      return new Promise(executor);
    }
    executor(null, cb);
    function executor(resolve3, reject) {
      transformers.run(node3, vfile(file), done);
      function done(err, tree, file2) {
        tree = tree || node3;
        if (err) {
          reject(err);
        } else if (resolve3) {
          resolve3(tree);
        } else {
          cb(null, tree, file2);
        }
      }
    }
  }
  function runSync(node3, file) {
    var complete = false;
    var result2;
    run(node3, file, done);
    assertDone("runSync", "run", complete);
    return result2;
    function done(err, tree) {
      complete = true;
      bail(err);
      result2 = tree;
    }
  }
  function stringify3(node3, doc) {
    var file = vfile(doc);
    var Compiler;
    freeze2();
    Compiler = processor.Compiler;
    assertCompiler("stringify", Compiler);
    assertNode(node3);
    if (newable(Compiler)) {
      return new Compiler(node3, file).compile();
    }
    return Compiler(node3, file);
  }
  function process2(doc, cb) {
    freeze2();
    assertParser("process", processor.Parser);
    assertCompiler("process", processor.Compiler);
    if (!cb) {
      return new Promise(executor);
    }
    executor(null, cb);
    function executor(resolve3, reject) {
      var file = vfile(doc);
      pipeline.run(processor, { file }, done);
      function done(err) {
        if (err) {
          reject(err);
        } else if (resolve3) {
          resolve3(file);
        } else {
          cb(null, file);
        }
      }
    }
  }
  function processSync(doc) {
    var complete = false;
    var file;
    freeze2();
    assertParser("processSync", processor.Parser);
    assertCompiler("processSync", processor.Compiler);
    file = vfile(doc);
    process2(file, done);
    assertDone("processSync", "process", complete);
    return file;
    function done(err) {
      complete = true;
      bail(err);
    }
  }
}
function newable(value) {
  return typeof value === "function" && keys$3(value.prototype);
}
function keys$3(value) {
  var key2;
  for (key2 in value) {
    return true;
  }
  return false;
}
function assertParser(name2, Parser3) {
  if (typeof Parser3 !== "function") {
    throw new Error("Cannot `" + name2 + "` without `Parser`");
  }
}
function assertCompiler(name2, Compiler) {
  if (typeof Compiler !== "function") {
    throw new Error("Cannot `" + name2 + "` without `Compiler`");
  }
}
function assertUnfrozen(name2, frozen) {
  if (frozen) {
    throw new Error(
      [
        "Cannot invoke `" + name2 + "` on a frozen processor.\nCreate a new ",
        "processor first, by invoking it: use `processor()` instead of ",
        "`processor`."
      ].join("")
    );
  }
}
function assertNode(node3) {
  if (!node3 || !string2(node3.type)) {
    throw new Error("Expected node, got `" + node3 + "`");
  }
}
function assertDone(name2, asyncName, complete) {
  if (!complete) {
    throw new Error(
      "`" + name2 + "` finished async. Use `" + asyncName + "` instead"
    );
  }
}
var inherits_browser = { exports: {} };
if (typeof Object.create === "function") {
  inherits_browser.exports = function inherits2(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    }
  };
} else {
  inherits_browser.exports = function inherits2(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function() {
      };
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    }
  };
}
var inherits_browserExports = inherits_browser.exports;
var xtend$6 = immutable;
var inherits = inherits_browserExports;
var unherit_1 = unherit$1;
function unherit$1(Super) {
  var result2;
  var key2;
  var value;
  inherits(Of, Super);
  inherits(From, Of);
  result2 = Of.prototype;
  for (key2 in result2) {
    value = result2[key2];
    if (value && typeof value === "object") {
      result2[key2] = "concat" in value ? value.concat() : xtend$6(value);
    }
  }
  return Of;
  function From(parameters) {
    return Super.apply(this, parameters);
  }
  function Of() {
    if (!(this instanceof Of)) {
      return new From(arguments);
    }
    return Super.apply(this, arguments);
  }
}
var stateToggle = factory$4;
function factory$4(key2, state, ctx2) {
  return enter;
  function enter() {
    var context = ctx2 || this;
    var current2 = context[key2];
    context[key2] = !state;
    return exit;
    function exit() {
      context[key2] = current2;
    }
  }
}
var vfileLocation$1 = factory$3;
function factory$3(file) {
  var contents = indices(String(file));
  return {
    toPosition: offsetToPositionFactory(contents),
    toOffset: positionToOffsetFactory(contents)
  };
}
function offsetToPositionFactory(indices2) {
  return offsetToPosition;
  function offsetToPosition(offset2) {
    var index2 = -1;
    var length = indices2.length;
    if (offset2 < 0) {
      return {};
    }
    while (++index2 < length) {
      if (indices2[index2] > offset2) {
        return {
          line: index2 + 1,
          column: offset2 - (indices2[index2 - 1] || 0) + 1,
          offset: offset2
        };
      }
    }
    return {};
  }
}
function positionToOffsetFactory(indices2) {
  return positionToOffset;
  function positionToOffset(position2) {
    var line = position2 && position2.line;
    var column = position2 && position2.column;
    if (!isNaN(line) && !isNaN(column) && line - 1 in indices2) {
      return (indices2[line - 2] || 0) + column - 1 || 0;
    }
    return -1;
  }
}
function indices(value) {
  var result2 = [];
  var index2 = value.indexOf("\n");
  while (index2 !== -1) {
    result2.push(index2 + 1);
    index2 = value.indexOf("\n", index2 + 1);
  }
  result2.push(value.length + 1);
  return result2;
}
var _unescape = factory$2;
function factory$2(ctx2, key2) {
  return unescape2;
  function unescape2(value) {
    var prev = 0;
    var index2 = value.indexOf("\\");
    var escape = ctx2[key2];
    var queue2 = [];
    var character;
    while (index2 !== -1) {
      queue2.push(value.slice(prev, index2));
      prev = index2 + 1;
      character = value.charAt(prev);
      if (!character || escape.indexOf(character) === -1) {
        queue2.push("\\");
      }
      index2 = value.indexOf("\\", prev);
    }
    queue2.push(value.slice(prev));
    return queue2.join("");
  }
}
const AElig = "Æ";
const AMP = "&";
const Aacute = "Á";
const Acirc = "Â";
const Agrave = "À";
const Aring = "Å";
const Atilde = "Ã";
const Auml = "Ä";
const COPY = "©";
const Ccedil = "Ç";
const ETH = "Ð";
const Eacute = "É";
const Ecirc = "Ê";
const Egrave = "È";
const Euml = "Ë";
const GT = ">";
const Iacute = "Í";
const Icirc = "Î";
const Igrave = "Ì";
const Iuml = "Ï";
const LT = "<";
const Ntilde = "Ñ";
const Oacute = "Ó";
const Ocirc = "Ô";
const Ograve = "Ò";
const Oslash = "Ø";
const Otilde = "Õ";
const Ouml = "Ö";
const QUOT = '"';
const REG = "®";
const THORN = "Þ";
const Uacute = "Ú";
const Ucirc = "Û";
const Ugrave = "Ù";
const Uuml = "Ü";
const Yacute = "Ý";
const aacute = "á";
const acirc = "â";
const acute = "´";
const aelig = "æ";
const agrave = "à";
const amp = "&";
const aring = "å";
const atilde = "ã";
const auml = "ä";
const brvbar = "¦";
const ccedil = "ç";
const cedil = "¸";
const cent = "¢";
const copy = "©";
const curren = "¤";
const deg = "°";
const divide = "÷";
const eacute = "é";
const ecirc = "ê";
const egrave = "è";
const eth = "ð";
const euml = "ë";
const frac12 = "½";
const frac14 = "¼";
const frac34 = "¾";
const gt$1 = ">";
const iacute = "í";
const icirc = "î";
const iexcl = "¡";
const igrave = "ì";
const iquest = "¿";
const iuml = "ï";
const laquo = "«";
const lt$1 = "<";
const macr = "¯";
const micro = "µ";
const middot = "·";
const nbsp = " ";
const not = "¬";
const ntilde = "ñ";
const oacute = "ó";
const ocirc = "ô";
const ograve = "ò";
const ordf = "ª";
const ordm = "º";
const oslash = "ø";
const otilde = "õ";
const ouml = "ö";
const para = "¶";
const plusmn = "±";
const pound = "£";
const quot = '"';
const raquo = "»";
const reg = "®";
const sect = "§";
const shy = "­";
const sup1 = "¹";
const sup2 = "²";
const sup3 = "³";
const szlig = "ß";
const thorn = "þ";
const times = "×";
const uacute = "ú";
const ucirc = "û";
const ugrave = "ù";
const uml = "¨";
const uuml = "ü";
const yacute = "ý";
const yen = "¥";
const yuml = "ÿ";
const require$$0$2 = {
  AElig,
  AMP,
  Aacute,
  Acirc,
  Agrave,
  Aring,
  Atilde,
  Auml,
  COPY,
  Ccedil,
  ETH,
  Eacute,
  Ecirc,
  Egrave,
  Euml,
  GT,
  Iacute,
  Icirc,
  Igrave,
  Iuml,
  LT,
  Ntilde,
  Oacute,
  Ocirc,
  Ograve,
  Oslash,
  Otilde,
  Ouml,
  QUOT,
  REG,
  THORN,
  Uacute,
  Ucirc,
  Ugrave,
  Uuml,
  Yacute,
  aacute,
  acirc,
  acute,
  aelig,
  agrave,
  amp,
  aring,
  atilde,
  auml,
  brvbar,
  ccedil,
  cedil,
  cent,
  copy,
  curren,
  deg,
  divide,
  eacute,
  ecirc,
  egrave,
  eth,
  euml,
  frac12,
  frac14,
  frac34,
  gt: gt$1,
  iacute,
  icirc,
  iexcl,
  igrave,
  iquest,
  iuml,
  laquo,
  lt: lt$1,
  macr,
  micro,
  middot,
  nbsp,
  not,
  ntilde,
  oacute,
  ocirc,
  ograve,
  ordf,
  ordm,
  oslash,
  otilde,
  ouml,
  para,
  plusmn,
  pound,
  quot,
  raquo,
  reg,
  sect,
  shy,
  sup1,
  sup2,
  sup3,
  szlig,
  thorn,
  times,
  uacute,
  ucirc,
  ugrave,
  uml,
  uuml,
  yacute,
  yen,
  yuml
};
const require$$1 = {
  "0": "�",
  "128": "€",
  "130": "‚",
  "131": "ƒ",
  "132": "„",
  "133": "…",
  "134": "†",
  "135": "‡",
  "136": "ˆ",
  "137": "‰",
  "138": "Š",
  "139": "‹",
  "140": "Œ",
  "142": "Ž",
  "145": "‘",
  "146": "’",
  "147": "“",
  "148": "”",
  "149": "•",
  "150": "–",
  "151": "—",
  "152": "˜",
  "153": "™",
  "154": "š",
  "155": "›",
  "156": "œ",
  "158": "ž",
  "159": "Ÿ"
};
var isDecimal = decimal$2;
function decimal$2(character) {
  var code2 = typeof character === "string" ? character.charCodeAt(0) : character;
  return code2 >= 48 && code2 <= 57;
}
var isHexadecimal = hexadecimal$1;
function hexadecimal$1(character) {
  var code2 = typeof character === "string" ? character.charCodeAt(0) : character;
  return code2 >= 97 && code2 <= 102 || code2 >= 65 && code2 <= 70 || code2 >= 48 && code2 <= 57;
}
var isAlphabetical;
var hasRequiredIsAlphabetical;
function requireIsAlphabetical() {
  if (hasRequiredIsAlphabetical) return isAlphabetical;
  hasRequiredIsAlphabetical = 1;
  isAlphabetical = alphabetical2;
  function alphabetical2(character) {
    var code2 = typeof character === "string" ? character.charCodeAt(0) : character;
    return code2 >= 97 && code2 <= 122 || code2 >= 65 && code2 <= 90;
  }
  return isAlphabetical;
}
var alphabetical = requireIsAlphabetical();
var decimal$1 = isDecimal;
var isAlphanumerical = alphanumerical$1;
function alphanumerical$1(character) {
  return alphabetical(character) || decimal$1(character);
}
var el;
var semicolon$1 = 59;
var decodeEntity_browser = decodeEntity$1;
function decodeEntity$1(characters2) {
  var entity = "&" + characters2 + ";";
  var char;
  el = el || document.createElement("i");
  el.innerHTML = entity;
  char = el.textContent;
  if (char.charCodeAt(char.length - 1) === semicolon$1 && characters2 !== "semi") {
    return false;
  }
  return char === entity ? false : char;
}
var legacy = require$$0$2;
var invalid = require$$1;
var decimal = isDecimal;
var hexadecimal = isHexadecimal;
var alphanumerical = isAlphanumerical;
var decodeEntity = decodeEntity_browser;
var parseEntities_1 = parseEntities;
var own = {}.hasOwnProperty;
var fromCharCode = String.fromCharCode;
var noop = Function.prototype;
var defaults$2 = {
  warning: null,
  reference: null,
  text: null,
  warningContext: null,
  referenceContext: null,
  textContext: null,
  position: {},
  additional: null,
  attribute: false,
  nonTerminated: true
};
var tab = 9;
var lineFeed = 10;
var formFeed = 12;
var space = 32;
var ampersand = 38;
var semicolon = 59;
var lessThan = 60;
var equalsTo = 61;
var numberSign = 35;
var uppercaseX = 88;
var lowercaseX = 120;
var replacementCharacter = 65533;
var name = "named";
var hexa = "hexadecimal";
var deci = "decimal";
var bases = {};
bases[hexa] = 16;
bases[deci] = 10;
var tests = {};
tests[name] = alphanumerical;
tests[deci] = decimal;
tests[hexa] = hexadecimal;
var namedNotTerminated = 1;
var numericNotTerminated = 2;
var namedEmpty = 3;
var numericEmpty = 4;
var namedUnknown = 5;
var numericDisallowed = 6;
var numericProhibited = 7;
var messages = {};
messages[namedNotTerminated] = "Named character references must be terminated by a semicolon";
messages[numericNotTerminated] = "Numeric character references must be terminated by a semicolon";
messages[namedEmpty] = "Named character references cannot be empty";
messages[numericEmpty] = "Numeric character references cannot be empty";
messages[namedUnknown] = "Named character references must be known";
messages[numericDisallowed] = "Numeric character references cannot be disallowed";
messages[numericProhibited] = "Numeric character references cannot be outside the permissible Unicode range";
function parseEntities(value, options) {
  var settings = {};
  var option2;
  var key2;
  if (!options) {
    options = {};
  }
  for (key2 in defaults$2) {
    option2 = options[key2];
    settings[key2] = option2 === null || option2 === void 0 ? defaults$2[key2] : option2;
  }
  if (settings.position.indent || settings.position.start) {
    settings.indent = settings.position.indent || [];
    settings.position = settings.position.start;
  }
  return parse$3(value, settings);
}
function parse$3(value, settings) {
  var additional = settings.additional;
  var nonTerminated = settings.nonTerminated;
  var handleText = settings.text;
  var handleReference = settings.reference;
  var handleWarning = settings.warning;
  var textContext = settings.textContext;
  var referenceContext = settings.referenceContext;
  var warningContext = settings.warningContext;
  var pos = settings.position;
  var indent = settings.indent || [];
  var length = value.length;
  var index2 = 0;
  var lines = -1;
  var column = pos.column || 1;
  var line = pos.line || 1;
  var queue2 = "";
  var result2 = [];
  var entityCharacters;
  var namedEntity;
  var terminated;
  var characters2;
  var character;
  var reference;
  var following;
  var warning2;
  var reason;
  var output;
  var entity;
  var begin;
  var start2;
  var type2;
  var test2;
  var prev;
  var next3;
  var diff2;
  var end2;
  if (typeof additional === "string") {
    additional = additional.charCodeAt(0);
  }
  prev = now2();
  warning2 = handleWarning ? parseError : noop;
  index2--;
  length++;
  while (++index2 < length) {
    if (character === lineFeed) {
      column = indent[lines] || 1;
    }
    character = value.charCodeAt(index2);
    if (character === ampersand) {
      following = value.charCodeAt(index2 + 1);
      if (following === tab || following === lineFeed || following === formFeed || following === space || following === ampersand || following === lessThan || following !== following || additional && following === additional) {
        queue2 += fromCharCode(character);
        column++;
        continue;
      }
      start2 = index2 + 1;
      begin = start2;
      end2 = start2;
      if (following === numberSign) {
        end2 = ++begin;
        following = value.charCodeAt(end2);
        if (following === uppercaseX || following === lowercaseX) {
          type2 = hexa;
          end2 = ++begin;
        } else {
          type2 = deci;
        }
      } else {
        type2 = name;
      }
      entityCharacters = "";
      entity = "";
      characters2 = "";
      test2 = tests[type2];
      end2--;
      while (++end2 < length) {
        following = value.charCodeAt(end2);
        if (!test2(following)) {
          break;
        }
        characters2 += fromCharCode(following);
        if (type2 === name && own.call(legacy, characters2)) {
          entityCharacters = characters2;
          entity = legacy[characters2];
        }
      }
      terminated = value.charCodeAt(end2) === semicolon;
      if (terminated) {
        end2++;
        namedEntity = type2 === name ? decodeEntity(characters2) : false;
        if (namedEntity) {
          entityCharacters = characters2;
          entity = namedEntity;
        }
      }
      diff2 = 1 + end2 - start2;
      if (!terminated && !nonTerminated) ;
      else if (!characters2) {
        if (type2 !== name) {
          warning2(numericEmpty, diff2);
        }
      } else if (type2 === name) {
        if (terminated && !entity) {
          warning2(namedUnknown, 1);
        } else {
          if (entityCharacters !== characters2) {
            end2 = begin + entityCharacters.length;
            diff2 = 1 + end2 - begin;
            terminated = false;
          }
          if (!terminated) {
            reason = entityCharacters ? namedNotTerminated : namedEmpty;
            if (settings.attribute) {
              following = value.charCodeAt(end2);
              if (following === equalsTo) {
                warning2(reason, diff2);
                entity = null;
              } else if (alphanumerical(following)) {
                entity = null;
              } else {
                warning2(reason, diff2);
              }
            } else {
              warning2(reason, diff2);
            }
          }
        }
        reference = entity;
      } else {
        if (!terminated) {
          warning2(numericNotTerminated, diff2);
        }
        reference = parseInt(characters2, bases[type2]);
        if (prohibited(reference)) {
          warning2(numericProhibited, diff2);
          reference = fromCharCode(replacementCharacter);
        } else if (reference in invalid) {
          warning2(numericDisallowed, diff2);
          reference = invalid[reference];
        } else {
          output = "";
          if (disallowed(reference)) {
            warning2(numericDisallowed, diff2);
          }
          if (reference > 65535) {
            reference -= 65536;
            output += fromCharCode(reference >>> (10 & 1023) | 55296);
            reference = 56320 | reference & 1023;
          }
          reference = output + fromCharCode(reference);
        }
      }
      if (reference) {
        flush();
        prev = now2();
        index2 = end2 - 1;
        column += end2 - start2 + 1;
        result2.push(reference);
        next3 = now2();
        next3.offset++;
        if (handleReference) {
          handleReference.call(
            referenceContext,
            reference,
            { start: prev, end: next3 },
            value.slice(start2 - 1, end2)
          );
        }
        prev = next3;
      } else {
        characters2 = value.slice(start2 - 1, end2);
        queue2 += characters2;
        column += characters2.length;
        index2 = end2 - 1;
      }
    } else {
      if (character === 10) {
        line++;
        lines++;
        column = 0;
      }
      if (character === character) {
        queue2 += fromCharCode(character);
        column++;
      } else {
        flush();
      }
    }
  }
  return result2.join("");
  function now2() {
    return {
      line,
      column,
      offset: index2 + (pos.offset || 0)
    };
  }
  function parseError(code2, offset2) {
    var position2 = now2();
    position2.column += offset2;
    position2.offset += offset2;
    handleWarning.call(warningContext, messages[code2], position2, code2);
  }
  function flush() {
    if (queue2) {
      result2.push(queue2);
      if (handleText) {
        handleText.call(textContext, queue2, { start: prev, end: now2() });
      }
      queue2 = "";
    }
  }
}
function prohibited(code2) {
  return code2 >= 55296 && code2 <= 57343 || code2 > 1114111;
}
function disallowed(code2) {
  return code2 >= 1 && code2 <= 8 || code2 === 11 || code2 >= 13 && code2 <= 31 || code2 >= 127 && code2 <= 159 || code2 >= 64976 && code2 <= 65007 || (code2 & 65535) === 65535 || (code2 & 65535) === 65534;
}
var xtend$5 = immutable;
var entities = parseEntities_1;
var decode$1 = factory$1;
function factory$1(ctx2) {
  decoder.raw = decodeRaw;
  return decoder;
  function normalize4(position2) {
    var offsets = ctx2.offset;
    var line = position2.line;
    var result2 = [];
    while (++line) {
      if (!(line in offsets)) {
        break;
      }
      result2.push((offsets[line] || 0) + 1);
    }
    return {
      start: position2,
      indent: result2
    };
  }
  function handleWarning(reason, position2, code2) {
    if (code2 === 3) {
      return;
    }
    ctx2.file.message(reason, position2);
  }
  function decoder(value, position2, handler) {
    entities(value, {
      position: normalize4(position2),
      warning: handleWarning,
      text: handler,
      reference: handler,
      textContext: ctx2,
      referenceContext: ctx2
    });
  }
  function decodeRaw(value, position2, options) {
    return entities(value, xtend$5(options, {
      position: normalize4(position2),
      warning: handleWarning
    }));
  }
}
var tokenizer$1 = factory;
var MERGEABLE_NODES = {
  text: mergeText,
  blockquote: mergeBlockquote
};
function mergeable(node3) {
  var start2;
  var end2;
  if (node3.type !== "text" || !node3.position) {
    return true;
  }
  start2 = node3.position.start;
  end2 = node3.position.end;
  return start2.line !== end2.line || end2.column - start2.column === node3.value.length;
}
function mergeText(prev, node3) {
  prev.value += node3.value;
  return prev;
}
function mergeBlockquote(prev, node3) {
  if (this.options.commonmark) {
    return node3;
  }
  prev.children = prev.children.concat(node3.children);
  return prev;
}
function factory(type2) {
  return tokenize;
  function tokenize(value, location) {
    var self2 = this;
    var offset2 = self2.offset;
    var tokens2 = [];
    var methods = self2[type2 + "Methods"];
    var tokenizers = self2[type2 + "Tokenizers"];
    var line = location.line;
    var column = location.column;
    var index2;
    var length;
    var method;
    var name2;
    var matched;
    var valueLength;
    if (!value) {
      return tokens2;
    }
    eat.now = now2;
    eat.file = self2.file;
    updatePosition("");
    while (value) {
      index2 = -1;
      length = methods.length;
      matched = false;
      while (++index2 < length) {
        name2 = methods[index2];
        method = tokenizers[name2];
        if (method && /* istanbul ignore next */
        (!method.onlyAtStart || self2.atStart) && (!method.notInList || !self2.inList) && (!method.notInBlock || !self2.inBlock) && (!method.notInLink || !self2.inLink)) {
          valueLength = value.length;
          method.apply(self2, [eat, value]);
          matched = valueLength !== value.length;
          if (matched) {
            break;
          }
        }
      }
      if (!matched) {
        self2.file.fail(new Error("Infinite loop"), eat.now());
      }
    }
    self2.eof = now2();
    return tokens2;
    function updatePosition(subvalue) {
      var lastIndex = -1;
      var index3 = subvalue.indexOf("\n");
      while (index3 !== -1) {
        line++;
        lastIndex = index3;
        index3 = subvalue.indexOf("\n", index3 + 1);
      }
      if (lastIndex === -1) {
        column += subvalue.length;
      } else {
        column = subvalue.length - lastIndex;
      }
      if (line in offset2) {
        if (lastIndex !== -1) {
          column += offset2[line];
        } else if (column <= offset2[line]) {
          column = offset2[line] + 1;
        }
      }
    }
    function getOffset() {
      var indentation = [];
      var pos = line + 1;
      return function() {
        var last2 = line + 1;
        while (pos < last2) {
          indentation.push((offset2[pos] || 0) + 1);
          pos++;
        }
        return indentation;
      };
    }
    function now2() {
      var pos = { line, column };
      pos.offset = self2.toOffset(pos);
      return pos;
    }
    function Position(start2) {
      this.start = start2;
      this.end = now2();
    }
    function validateEat(subvalue) {
      if (value.substring(0, subvalue.length) !== subvalue) {
        self2.file.fail(
          new Error(
            "Incorrectly eaten value: please report this warning on http://git.io/vg5Ft"
          ),
          now2()
        );
      }
    }
    function position2() {
      var before3 = now2();
      return update2;
      function update2(node3, indent) {
        var prev = node3.position;
        var start2 = prev ? prev.start : before3;
        var combined = [];
        var n2 = prev && prev.end.line;
        var l2 = before3.line;
        node3.position = new Position(start2);
        if (prev && indent && prev.indent) {
          combined = prev.indent;
          if (n2 < l2) {
            while (++n2 < l2) {
              combined.push((offset2[n2] || 0) + 1);
            }
            combined.push(before3.column);
          }
          indent = combined.concat(indent);
        }
        node3.position.indent = indent || [];
        return node3;
      }
    }
    function add2(node3, parent3) {
      var children = parent3 ? parent3.children : tokens2;
      var prev = children[children.length - 1];
      if (prev && node3.type === prev.type && node3.type in MERGEABLE_NODES && mergeable(prev) && mergeable(node3)) {
        node3 = MERGEABLE_NODES[node3.type].call(self2, prev, node3);
      }
      if (node3 !== prev) {
        children.push(node3);
      }
      if (self2.atStart && tokens2.length !== 0) {
        self2.exitStart();
      }
      return node3;
    }
    function eat(subvalue) {
      var indent = getOffset();
      var pos = position2();
      var current2 = now2();
      validateEat(subvalue);
      apply2.reset = reset2;
      reset2.test = test2;
      apply2.test = test2;
      value = value.substring(subvalue.length);
      updatePosition(subvalue);
      indent = indent();
      return apply2;
      function apply2(node3, parent3) {
        return pos(add2(pos(node3), parent3), indent);
      }
      function reset2() {
        var node3 = apply2.apply(null, arguments);
        line = current2.line;
        column = current2.column;
        value = subvalue + value;
        return node3;
      }
      function test2() {
        var result2 = pos({});
        line = current2.line;
        column = current2.column;
        value = subvalue + value;
        return result2.position;
      }
    }
  }
}
var markdownEscapes;
var hasRequiredMarkdownEscapes;
function requireMarkdownEscapes() {
  if (hasRequiredMarkdownEscapes) return markdownEscapes;
  hasRequiredMarkdownEscapes = 1;
  markdownEscapes = escapes;
  var defaults2 = [
    "\\",
    "`",
    "*",
    "{",
    "}",
    "[",
    "]",
    "(",
    ")",
    "#",
    "+",
    "-",
    ".",
    "!",
    "_",
    ">"
  ];
  var gfm = defaults2.concat(["~", "|"]);
  var commonmark = gfm.concat([
    "\n",
    '"',
    "$",
    "%",
    "&",
    "'",
    ",",
    "/",
    ":",
    ";",
    "<",
    "=",
    "?",
    "@",
    "^"
  ]);
  escapes.default = defaults2;
  escapes.gfm = gfm;
  escapes.commonmark = commonmark;
  function escapes(options) {
    var settings = options || {};
    if (settings.commonmark) {
      return commonmark;
    }
    return settings.gfm ? gfm : defaults2;
  }
  return markdownEscapes;
}
const require$$0$1 = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "meta",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "pre",
  "section",
  "source",
  "title",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
];
var defaults$1;
var hasRequiredDefaults;
function requireDefaults() {
  if (hasRequiredDefaults) return defaults$1;
  hasRequiredDefaults = 1;
  defaults$1 = {
    position: true,
    gfm: true,
    commonmark: false,
    footnotes: false,
    pedantic: false,
    blocks: require$$0$1
  };
  return defaults$1;
}
var setOptions_1;
var hasRequiredSetOptions;
function requireSetOptions() {
  if (hasRequiredSetOptions) return setOptions_1;
  hasRequiredSetOptions = 1;
  var xtend2 = immutable;
  var escapes = requireMarkdownEscapes();
  var defaults2 = requireDefaults();
  setOptions_1 = setOptions;
  function setOptions(options) {
    var self2 = this;
    var current2 = self2.options;
    var key2;
    var value;
    if (options == null) {
      options = {};
    } else if (typeof options === "object") {
      options = xtend2(options);
    } else {
      throw new Error(
        "Invalid value `" + options + "` for setting `options`"
      );
    }
    for (key2 in defaults2) {
      value = options[key2];
      if (value == null) {
        value = current2[key2];
      }
      if (key2 !== "blocks" && typeof value !== "boolean" || key2 === "blocks" && typeof value !== "object") {
        throw new Error("Invalid value `" + value + "` for setting `options." + key2 + "`");
      }
      options[key2] = value;
    }
    self2.options = options;
    self2.escape = escapes(options);
    return self2;
  }
  return setOptions_1;
}
var convert_1$1;
var hasRequiredConvert;
function requireConvert() {
  if (hasRequiredConvert) return convert_1$1;
  hasRequiredConvert = 1;
  convert_1$1 = convert2;
  function convert2(test2) {
    if (typeof test2 === "string") {
      return typeFactory2(test2);
    }
    if (test2 === null || test2 === void 0) {
      return ok2;
    }
    if (typeof test2 === "object") {
      return ("length" in test2 ? anyFactory2 : matchesFactory2)(test2);
    }
    if (typeof test2 === "function") {
      return test2;
    }
    throw new Error("Expected function, string, or object as test");
  }
  function convertAll2(tests2) {
    var results = [];
    var length = tests2.length;
    var index2 = -1;
    while (++index2 < length) {
      results[index2] = convert2(tests2[index2]);
    }
    return results;
  }
  function matchesFactory2(test2) {
    return matches2;
    function matches2(node3) {
      var key2;
      for (key2 in test2) {
        if (node3[key2] !== test2[key2]) {
          return false;
        }
      }
      return true;
    }
  }
  function anyFactory2(tests2) {
    var checks = convertAll2(tests2);
    var length = checks.length;
    return matches2;
    function matches2() {
      var index2 = -1;
      while (++index2 < length) {
        if (checks[index2].apply(this, arguments)) {
          return true;
        }
      }
      return false;
    }
  }
  function typeFactory2(test2) {
    return type2;
    function type2(node3) {
      return Boolean(node3 && node3.type === test2);
    }
  }
  function ok2() {
    return true;
  }
  return convert_1$1;
}
var unistUtilVisitParents$2;
var hasRequiredUnistUtilVisitParents;
function requireUnistUtilVisitParents() {
  if (hasRequiredUnistUtilVisitParents) return unistUtilVisitParents$2;
  hasRequiredUnistUtilVisitParents = 1;
  unistUtilVisitParents$2 = visitParents2;
  var convert2 = requireConvert();
  var CONTINUE2 = true;
  var SKIP2 = "skip";
  var EXIT2 = false;
  visitParents2.CONTINUE = CONTINUE2;
  visitParents2.SKIP = SKIP2;
  visitParents2.EXIT = EXIT2;
  function visitParents2(tree, test2, visitor, reverse) {
    var is3;
    if (typeof test2 === "function" && typeof visitor !== "function") {
      reverse = visitor;
      visitor = test2;
      test2 = null;
    }
    is3 = convert2(test2);
    one(tree, null, []);
    function one(node3, index2, parents) {
      var result2 = [];
      var subresult;
      if (!test2 || is3(node3, index2, parents[parents.length - 1] || null)) {
        result2 = toResult2(visitor(node3, parents));
        if (result2[0] === EXIT2) {
          return result2;
        }
      }
      if (node3.children && result2[0] !== SKIP2) {
        subresult = toResult2(all(node3.children, parents.concat(node3)));
        return subresult[0] === EXIT2 ? subresult : result2;
      }
      return result2;
    }
    function all(children, parents) {
      var min2 = -1;
      var step2 = reverse ? -1 : 1;
      var index2 = (reverse ? children.length : min2) + step2;
      var result2;
      while (index2 > min2 && index2 < children.length) {
        result2 = one(children[index2], index2, parents);
        if (result2[0] === EXIT2) {
          return result2;
        }
        index2 = typeof result2[1] === "number" ? result2[1] : index2 + step2;
      }
    }
  }
  function toResult2(value) {
    if (value !== null && typeof value === "object" && "length" in value) {
      return value;
    }
    if (typeof value === "number") {
      return [CONTINUE2, value];
    }
    return [value];
  }
  return unistUtilVisitParents$2;
}
var unistUtilVisit$1;
var hasRequiredUnistUtilVisit;
function requireUnistUtilVisit() {
  if (hasRequiredUnistUtilVisit) return unistUtilVisit$1;
  hasRequiredUnistUtilVisit = 1;
  unistUtilVisit$1 = visit2;
  var visitParents2 = requireUnistUtilVisitParents();
  var CONTINUE2 = visitParents2.CONTINUE;
  var SKIP2 = visitParents2.SKIP;
  var EXIT2 = visitParents2.EXIT;
  visit2.CONTINUE = CONTINUE2;
  visit2.SKIP = SKIP2;
  visit2.EXIT = EXIT2;
  function visit2(tree, test2, visitor, reverse) {
    if (typeof test2 === "function" && typeof visitor !== "function") {
      reverse = visitor;
      visitor = test2;
      test2 = null;
    }
    visitParents2(tree, test2, overload, reverse);
    function overload(node3, parents) {
      var parent3 = parents[parents.length - 1];
      var index2 = parent3 ? parent3.children.indexOf(node3) : null;
      return visitor(node3, index2, parent3);
    }
  }
  return unistUtilVisit$1;
}
var unistUtilRemovePosition;
var hasRequiredUnistUtilRemovePosition;
function requireUnistUtilRemovePosition() {
  if (hasRequiredUnistUtilRemovePosition) return unistUtilRemovePosition;
  hasRequiredUnistUtilRemovePosition = 1;
  var visit2 = requireUnistUtilVisit();
  unistUtilRemovePosition = removePosition;
  function removePosition(node3, force) {
    visit2(node3, force ? hard : soft);
    return node3;
  }
  function hard(node3) {
    delete node3.position;
  }
  function soft(node3) {
    node3.position = void 0;
  }
  return unistUtilRemovePosition;
}
var parse_1;
var hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse_1;
  hasRequiredParse = 1;
  var xtend2 = immutable;
  var removePosition = requireUnistUtilRemovePosition();
  parse_1 = parse3;
  var C_NEWLINE = "\n";
  var EXPRESSION_LINE_BREAKS = /\r\n|\r/g;
  function parse3() {
    var self2 = this;
    var value = String(self2.file);
    var start2 = { line: 1, column: 1, offset: 0 };
    var content = xtend2(start2);
    var node3;
    value = value.replace(EXPRESSION_LINE_BREAKS, C_NEWLINE);
    if (value.charCodeAt(0) === 65279) {
      value = value.slice(1);
      content.column++;
      content.offset++;
    }
    node3 = {
      type: "root",
      children: self2.tokenizeBlock(value, content),
      position: {
        start: start2,
        end: self2.eof || xtend2(start2)
      }
    };
    if (!self2.options.position) {
      removePosition(node3, true);
    }
    return node3;
  }
  return parse_1;
}
var isWhitespaceCharacter;
var hasRequiredIsWhitespaceCharacter;
function requireIsWhitespaceCharacter() {
  if (hasRequiredIsWhitespaceCharacter) return isWhitespaceCharacter;
  hasRequiredIsWhitespaceCharacter = 1;
  isWhitespaceCharacter = whitespace;
  var fromCode = String.fromCharCode;
  var re2 = /\s/;
  function whitespace(character) {
    return re2.test(
      typeof character === "number" ? fromCode(character) : character.charAt(0)
    );
  }
  return isWhitespaceCharacter;
}
var newline_1;
var hasRequiredNewline;
function requireNewline() {
  if (hasRequiredNewline) return newline_1;
  hasRequiredNewline = 1;
  var whitespace = requireIsWhitespaceCharacter();
  newline_1 = newline;
  function newline(eat, value, silent) {
    var character = value.charAt(0);
    var length;
    var subvalue;
    var queue2;
    var index2;
    if (character !== "\n") {
      return;
    }
    if (silent) {
      return true;
    }
    index2 = 1;
    length = value.length;
    subvalue = character;
    queue2 = "";
    while (index2 < length) {
      character = value.charAt(index2);
      if (!whitespace(character)) {
        break;
      }
      queue2 += character;
      if (character === "\n") {
        subvalue += queue2;
        queue2 = "";
      }
      index2++;
    }
    eat(subvalue);
  }
  return newline_1;
}
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */
var repeatString;
var hasRequiredRepeatString;
function requireRepeatString() {
  if (hasRequiredRepeatString) return repeatString;
  hasRequiredRepeatString = 1;
  var res = "";
  var cache2;
  repeatString = repeat;
  function repeat(str, num) {
    if (typeof str !== "string") {
      throw new TypeError("expected a string");
    }
    if (num === 1) return str;
    if (num === 2) return str + str;
    var max2 = str.length * num;
    if (cache2 !== str || typeof cache2 === "undefined") {
      cache2 = str;
      res = "";
    } else if (res.length >= max2) {
      return res.substr(0, max2);
    }
    while (max2 > res.length && num > 1) {
      if (num & 1) {
        res += str;
      }
      num >>= 1;
      str += str;
    }
    res += str;
    res = res.substr(0, max2);
    return res;
  }
  return repeatString;
}
var trimTrailingLines_1;
var hasRequiredTrimTrailingLines;
function requireTrimTrailingLines() {
  if (hasRequiredTrimTrailingLines) return trimTrailingLines_1;
  hasRequiredTrimTrailingLines = 1;
  trimTrailingLines_1 = trimTrailingLines;
  function trimTrailingLines(value) {
    return String(value).replace(/\n+$/, "");
  }
  return trimTrailingLines_1;
}
var codeIndented;
var hasRequiredCodeIndented;
function requireCodeIndented() {
  if (hasRequiredCodeIndented) return codeIndented;
  hasRequiredCodeIndented = 1;
  var repeat = requireRepeatString();
  var trim2 = requireTrimTrailingLines();
  codeIndented = indentedCode;
  var C_NEWLINE = "\n";
  var C_TAB = "	";
  var C_SPACE = " ";
  var CODE_INDENT_COUNT = 4;
  var CODE_INDENT = repeat(C_SPACE, CODE_INDENT_COUNT);
  function indentedCode(eat, value, silent) {
    var index2 = -1;
    var length = value.length;
    var subvalue = "";
    var content = "";
    var subvalueQueue = "";
    var contentQueue = "";
    var character;
    var blankQueue;
    var indent;
    while (++index2 < length) {
      character = value.charAt(index2);
      if (indent) {
        indent = false;
        subvalue += subvalueQueue;
        content += contentQueue;
        subvalueQueue = "";
        contentQueue = "";
        if (character === C_NEWLINE) {
          subvalueQueue = character;
          contentQueue = character;
        } else {
          subvalue += character;
          content += character;
          while (++index2 < length) {
            character = value.charAt(index2);
            if (!character || character === C_NEWLINE) {
              contentQueue = character;
              subvalueQueue = character;
              break;
            }
            subvalue += character;
            content += character;
          }
        }
      } else if (character === C_SPACE && value.charAt(index2 + 1) === character && value.charAt(index2 + 2) === character && value.charAt(index2 + 3) === character) {
        subvalueQueue += CODE_INDENT;
        index2 += 3;
        indent = true;
      } else if (character === C_TAB) {
        subvalueQueue += character;
        indent = true;
      } else {
        blankQueue = "";
        while (character === C_TAB || character === C_SPACE) {
          blankQueue += character;
          character = value.charAt(++index2);
        }
        if (character !== C_NEWLINE) {
          break;
        }
        subvalueQueue += blankQueue + character;
        contentQueue += character;
      }
    }
    if (content) {
      if (silent) {
        return true;
      }
      return eat(subvalue)({
        type: "code",
        lang: null,
        value: trim2(content)
      });
    }
  }
  return codeIndented;
}
var codeFenced;
var hasRequiredCodeFenced;
function requireCodeFenced() {
  if (hasRequiredCodeFenced) return codeFenced;
  hasRequiredCodeFenced = 1;
  var trim2 = requireTrimTrailingLines();
  codeFenced = fencedCode;
  var C_NEWLINE = "\n";
  var C_TAB = "	";
  var C_SPACE = " ";
  var C_TILDE = "~";
  var C_TICK = "`";
  var MIN_FENCE_COUNT = 3;
  var CODE_INDENT_COUNT = 4;
  function fencedCode(eat, value, silent) {
    var self2 = this;
    var settings = self2.options;
    var length = value.length + 1;
    var index2 = 0;
    var subvalue = "";
    var fenceCount;
    var marker;
    var character;
    var flag;
    var queue2;
    var content;
    var exdentedContent;
    var closing;
    var exdentedClosing;
    var indent;
    var now2;
    if (!settings.gfm) {
      return;
    }
    while (index2 < length) {
      character = value.charAt(index2);
      if (character !== C_SPACE && character !== C_TAB) {
        break;
      }
      subvalue += character;
      index2++;
    }
    indent = index2;
    character = value.charAt(index2);
    if (character !== C_TILDE && character !== C_TICK) {
      return;
    }
    index2++;
    marker = character;
    fenceCount = 1;
    subvalue += character;
    while (index2 < length) {
      character = value.charAt(index2);
      if (character !== marker) {
        break;
      }
      subvalue += character;
      fenceCount++;
      index2++;
    }
    if (fenceCount < MIN_FENCE_COUNT) {
      return;
    }
    while (index2 < length) {
      character = value.charAt(index2);
      if (character !== C_SPACE && character !== C_TAB) {
        break;
      }
      subvalue += character;
      index2++;
    }
    flag = "";
    queue2 = "";
    while (index2 < length) {
      character = value.charAt(index2);
      if (character === C_NEWLINE || character === C_TILDE || character === C_TICK) {
        break;
      }
      if (character === C_SPACE || character === C_TAB) {
        queue2 += character;
      } else {
        flag += queue2 + character;
        queue2 = "";
      }
      index2++;
    }
    character = value.charAt(index2);
    if (character && character !== C_NEWLINE) {
      return;
    }
    if (silent) {
      return true;
    }
    now2 = eat.now();
    now2.column += subvalue.length;
    now2.offset += subvalue.length;
    subvalue += flag;
    flag = self2.decode.raw(self2.unescape(flag), now2);
    if (queue2) {
      subvalue += queue2;
    }
    queue2 = "";
    closing = "";
    exdentedClosing = "";
    content = "";
    exdentedContent = "";
    while (index2 < length) {
      character = value.charAt(index2);
      content += closing;
      exdentedContent += exdentedClosing;
      closing = "";
      exdentedClosing = "";
      if (character !== C_NEWLINE) {
        content += character;
        exdentedClosing += character;
        index2++;
        continue;
      }
      if (content) {
        closing += character;
        exdentedClosing += character;
      } else {
        subvalue += character;
      }
      queue2 = "";
      index2++;
      while (index2 < length) {
        character = value.charAt(index2);
        if (character !== C_SPACE) {
          break;
        }
        queue2 += character;
        index2++;
      }
      closing += queue2;
      exdentedClosing += queue2.slice(indent);
      if (queue2.length >= CODE_INDENT_COUNT) {
        continue;
      }
      queue2 = "";
      while (index2 < length) {
        character = value.charAt(index2);
        if (character !== marker) {
          break;
        }
        queue2 += character;
        index2++;
      }
      closing += queue2;
      exdentedClosing += queue2;
      if (queue2.length < fenceCount) {
        continue;
      }
      queue2 = "";
      while (index2 < length) {
        character = value.charAt(index2);
        if (character !== C_SPACE && character !== C_TAB) {
          break;
        }
        closing += character;
        exdentedClosing += character;
        index2++;
      }
      if (!character || character === C_NEWLINE) {
        break;
      }
    }
    subvalue += content + closing;
    return eat(subvalue)({
      type: "code",
      lang: flag || null,
      value: trim2(exdentedContent)
    });
  }
  return codeFenced;
}
var trim = { exports: {} };
var hasRequiredTrim;
function requireTrim() {
  if (hasRequiredTrim) return trim.exports;
  hasRequiredTrim = 1;
  (function(module2, exports) {
    exports = module2.exports = trim2;
    function trim2(str) {
      return str.replace(/^\s*|\s*$/g, "");
    }
    exports.left = function(str) {
      return str.replace(/^\s*/, "");
    };
    exports.right = function(str) {
      return str.replace(/\s*$/, "");
    };
  })(trim, trim.exports);
  return trim.exports;
}
var interrupt_1;
var hasRequiredInterrupt;
function requireInterrupt() {
  if (hasRequiredInterrupt) return interrupt_1;
  hasRequiredInterrupt = 1;
  interrupt_1 = interrupt;
  function interrupt(interruptors, tokenizers, ctx2, params) {
    var bools = ["pedantic", "commonmark"];
    var count = bools.length;
    var length = interruptors.length;
    var index2 = -1;
    var interruptor;
    var config;
    var fn2;
    var offset2;
    var bool;
    var ignore;
    while (++index2 < length) {
      interruptor = interruptors[index2];
      config = interruptor[1] || {};
      fn2 = interruptor[0];
      offset2 = -1;
      ignore = false;
      while (++offset2 < count) {
        bool = bools[offset2];
        if (config[bool] !== void 0 && config[bool] !== ctx2.options[bool]) {
          ignore = true;
          break;
        }
      }
      if (ignore) {
        continue;
      }
      if (tokenizers[fn2].apply(ctx2, params)) {
        return true;
      }
    }
    return false;
  }
  return interrupt_1;
}
var blockquote_1;
var hasRequiredBlockquote;
function requireBlockquote() {
  if (hasRequiredBlockquote) return blockquote_1;
  hasRequiredBlockquote = 1;
  var trim2 = requireTrim();
  var interrupt = requireInterrupt();
  blockquote_1 = blockquote;
  var C_NEWLINE = "\n";
  var C_TAB = "	";
  var C_SPACE = " ";
  var C_GT = ">";
  function blockquote(eat, value, silent) {
    var self2 = this;
    var offsets = self2.offset;
    var tokenizers = self2.blockTokenizers;
    var interruptors = self2.interruptBlockquote;
    var now2 = eat.now();
    var currentLine = now2.line;
    var length = value.length;
    var values = [];
    var contents = [];
    var indents = [];
    var add2;
    var index2 = 0;
    var character;
    var rest;
    var nextIndex;
    var content;
    var line;
    var startIndex;
    var prefixed;
    var exit;
    while (index2 < length) {
      character = value.charAt(index2);
      if (character !== C_SPACE && character !== C_TAB) {
        break;
      }
      index2++;
    }
    if (value.charAt(index2) !== C_GT) {
      return;
    }
    if (silent) {
      return true;
    }
    index2 = 0;
    while (index2 < length) {
      nextIndex = value.indexOf(C_NEWLINE, index2);
      startIndex = index2;
      prefixed = false;
      if (nextIndex === -1) {
        nextIndex = length;
      }
      while (index2 < length) {
        character = value.charAt(index2);
        if (character !== C_SPACE && character !== C_TAB) {
          break;
        }
        index2++;
      }
      if (value.charAt(index2) === C_GT) {
        index2++;
        prefixed = true;
        if (value.charAt(index2) === C_SPACE) {
          index2++;
        }
      } else {
        index2 = startIndex;
      }
      content = value.slice(index2, nextIndex);
      if (!prefixed && !trim2(content)) {
        index2 = startIndex;
        break;
      }
      if (!prefixed) {
        rest = value.slice(index2);
        if (interrupt(interruptors, tokenizers, self2, [eat, rest, true])) {
          break;
        }
      }
      line = startIndex === index2 ? content : value.slice(startIndex, nextIndex);
      indents.push(index2 - startIndex);
      values.push(line);
      contents.push(content);
      index2 = nextIndex + 1;
    }
    index2 = -1;
    length = indents.length;
    add2 = eat(values.join(C_NEWLINE));
    while (++index2 < length) {
      offsets[currentLine] = (offsets[currentLine] || 0) + indents[index2];
      currentLine++;
    }
    exit = self2.enterBlock();
    contents = self2.tokenizeBlock(contents.join(C_NEWLINE), now2);
    exit();
    return add2({
      type: "blockquote",
      children: contents
    });
  }
  return blockquote_1;
}
var headingAtx;
var hasRequiredHeadingAtx;
function requireHeadingAtx() {
  if (hasRequiredHeadingAtx) return headingAtx;
  hasRequiredHeadingAtx = 1;
  headingAtx = atxHeading;
  var C_NEWLINE = "\n";
  var C_TAB = "	";
  var C_SPACE = " ";
  var C_HASH = "#";
  var MAX_ATX_COUNT = 6;
  function atxHeading(eat, value, silent) {
    var self2 = this;
    var settings = self2.options;
    var length = value.length + 1;
    var index2 = -1;
    var now2 = eat.now();
    var subvalue = "";
    var content = "";
    var character;
    var queue2;
    var depth;
    while (++index2 < length) {
      character = value.charAt(index2);
      if (character !== C_SPACE && character !== C_TAB) {
        index2--;
        break;
      }
      subvalue += character;
    }
    depth = 0;
    while (++index2 <= length) {
      character = value.charAt(index2);
      if (character !== C_HASH) {
        index2--;
        break;
      }
      subvalue += character;
      depth++;
    }
    if (depth > MAX_ATX_COUNT) {
      return;
    }
    if (!depth || !settings.pedantic && value.charAt(index2 + 1) === C_HASH) {
      return;
    }
    length = value.length + 1;
    queue2 = "";
    while (++index2 < length) {
      character = value.charAt(index2);
      if (character !== C_SPACE && character !== C_TAB) {
        index2--;
        break;
      }
      queue2 += character;
    }
    if (!settings.pedantic && queue2.length === 0 && character && character !== C_NEWLINE) {
      return;
    }
    if (silent) {
      return true;
    }
    subvalue += queue2;
    queue2 = "";
    content = "";
    while (++index2 < length) {
      character = value.charAt(index2);
      if (!character || character === C_NEWLINE) {
        break;
      }
      if (character !== C_SPACE && character !== C_TAB && character !== C_HASH) {
        content += queue2 + character;
        queue2 = "";
        continue;
      }
      while (character === C_SPACE || character === C_TAB) {
        queue2 += character;
        character = value.charAt(++index2);
      }
      while (character === C_HASH) {
        queue2 += character;
        character = value.charAt(++index2);
      }
      while (character === C_SPACE || character === C_TAB) {
        queue2 += character;
        character = value.charAt(++index2);
      }
      index2--;
    }
    now2.column += subvalue.length;
    now2.offset += subvalue.length;
    subvalue += content + queue2;
    return eat(subvalue)({
      type: "heading",
      depth,
      children: self2.tokenizeInline(content, now2)
    });
  }
  return headingAtx;
}
var thematicBreak_1;
var hasRequiredThematicBreak;
function requireThematicBreak() {
  if (hasRequiredThematicBreak) return thematicBreak_1;
  hasRequiredThematicBreak = 1;
  thematicBreak_1 = thematicBreak;
  var C_NEWLINE = "\n";
  var C_TAB = "	";
  var C_SPACE = " ";
  var C_ASTERISK = "*";
  var C_UNDERSCORE = "_";
  var C_DASH = "-";
  var THEMATIC_BREAK_MARKER_COUNT = 3;
  function thematicBreak(eat, value, silent) {
    var index2 = -1;
    var length = value.length + 1;
    var subvalue = "";
    var character;
    var marker;
    var markerCount;
    var queue2;
    while (++index2 < length) {
      character = value.charAt(index2);
      if (character !== C_TAB && character !== C_SPACE) {
        break;
      }
      subvalue += character;
    }
    if (character !== C_ASTERISK && character !== C_DASH && character !== C_UNDERSCORE) {
      return;
    }
    marker = character;
    subvalue += character;
    markerCount = 1;
    queue2 = "";
    while (++index2 < length) {
      character = value.charAt(index2);
      if (character === marker) {
        markerCount++;
        subvalue += queue2 + marker;
        queue2 = "";
      } else if (character === C_SPACE) {
        queue2 += character;
      } else if (markerCount >= THEMATIC_BREAK_MARKER_COUNT && (!character || character === C_NEWLINE)) {
        subvalue += queue2;
        if (silent) {
          return true;
        }
        return eat(subvalue)({ type: "thematicBreak" });
      } else {
        return;
      }
    }
  }
  return thematicBreak_1;
}
var getIndentation;
var hasRequiredGetIndentation;
function requireGetIndentation() {
  if (hasRequiredGetIndentation) return getIndentation;
  hasRequiredGetIndentation = 1;
  getIndentation = indentation;
  var characters2 = { " ": 1, "	": 4 };
  function indentation(value) {
    var index2 = 0;
    var indent = 0;
    var character = value.charAt(index2);
    var stops = {};
    var size2;
    while (character in characters2) {
      size2 = characters2[character];
      indent += size2;
      if (size2 > 1) {
        indent = Math.floor(indent / size2) * size2;
      }
      stops[indent] = index2;
      character = value.charAt(++index2);
    }
    return { indent, stops };
  }
  return getIndentation;
}
var removeIndentation;
var hasRequiredRemoveIndentation;
function requireRemoveIndentation() {
  if (hasRequiredRemoveIndentation) return removeIndentation;
  hasRequiredRemoveIndentation = 1;
  var trim2 = requireTrim();
  var repeat = requireRepeatString();
  var getIndent = requireGetIndentation();
  removeIndentation = indentation;
  var C_SPACE = " ";
  var C_NEWLINE = "\n";
  var C_TAB = "	";
  function indentation(value, maximum) {
    var values = value.split(C_NEWLINE);
    var position2 = values.length + 1;
    var minIndent = Infinity;
    var matrix = [];
    var index2;
    var indentation2;
    var stops;
    var padding;
    values.unshift(repeat(C_SPACE, maximum) + "!");
    while (position2--) {
      indentation2 = getIndent(values[position2]);
      matrix[position2] = indentation2.stops;
      if (trim2(values[position2]).length === 0) {
        continue;
      }
      if (indentation2.indent) {
        if (indentation2.indent > 0 && indentation2.indent < minIndent) {
          minIndent = indentation2.indent;
        }
      } else {
        minIndent = Infinity;
        break;
      }
    }
    if (minIndent !== Infinity) {
      position2 = values.length;
      while (position2--) {
        stops = matrix[position2];
        index2 = minIndent;
        while (index2 && !(index2 in stops)) {
          index2--;
        }
        if (trim2(values[position2]).length !== 0 && minIndent && index2 !== minIndent) {
          padding = C_TAB;
        } else {
          padding = "";
        }
        values[position2] = padding + values[position2].slice(
          index2 in stops ? stops[index2] + 1 : 0
        );
      }
    }
    values.shift();
    return values.join(C_NEWLINE);
  }
  return removeIndentation;
}
var list_1;
var hasRequiredList;
function requireList() {
  if (hasRequiredList) return list_1;
  hasRequiredList = 1;
  var trim2 = requireTrim();
  var repeat = requireRepeatString();
  var decimal2 = isDecimal;
  var getIndent = requireGetIndentation();
  var removeIndent = requireRemoveIndentation();
  var interrupt = requireInterrupt();
  list_1 = list;
  var C_ASTERISK = "*";
  var C_UNDERSCORE = "_";
  var C_PLUS = "+";
  var C_DASH = "-";
  var C_DOT = ".";
  var C_SPACE = " ";
  var C_NEWLINE = "\n";
  var C_TAB = "	";
  var C_PAREN_CLOSE = ")";
  var C_X_LOWER = "x";
  var TAB_SIZE = 4;
  var EXPRESSION_LOOSE_LIST_ITEM = /\n\n(?!\s*$)/;
  var EXPRESSION_TASK_ITEM = /^\[([ \t]|x|X)][ \t]/;
  var EXPRESSION_BULLET = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
  var EXPRESSION_PEDANTIC_BULLET = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
  var EXPRESSION_INITIAL_INDENT = /^( {1,4}|\t)?/gm;
  var LIST_UNORDERED_MARKERS = {};
  LIST_UNORDERED_MARKERS[C_ASTERISK] = true;
  LIST_UNORDERED_MARKERS[C_PLUS] = true;
  LIST_UNORDERED_MARKERS[C_DASH] = true;
  var LIST_ORDERED_MARKERS = {};
  LIST_ORDERED_MARKERS[C_DOT] = true;
  var LIST_ORDERED_COMMONMARK_MARKERS = {};
  LIST_ORDERED_COMMONMARK_MARKERS[C_DOT] = true;
  LIST_ORDERED_COMMONMARK_MARKERS[C_PAREN_CLOSE] = true;
  function list(eat, value, silent) {
    var self2 = this;
    var commonmark = self2.options.commonmark;
    var pedantic = self2.options.pedantic;
    var tokenizers = self2.blockTokenizers;
    var interuptors = self2.interruptList;
    var markers;
    var index2 = 0;
    var length = value.length;
    var start2 = null;
    var size2 = 0;
    var queue2;
    var ordered;
    var character;
    var marker;
    var nextIndex;
    var startIndex;
    var prefixed;
    var currentMarker;
    var content;
    var line;
    var prevEmpty;
    var empty;
    var items2;
    var allLines;
    var emptyLines;
    var item;
    var enterTop;
    var exitBlockquote;
    var isLoose;
    var node3;
    var now2;
    var end2;
    var indented;
    while (index2 < length) {
      character = value.charAt(index2);
      if (character === C_TAB) {
        size2 += TAB_SIZE - size2 % TAB_SIZE;
      } else if (character === C_SPACE) {
        size2++;
      } else {
        break;
      }
      index2++;
    }
    if (size2 >= TAB_SIZE) {
      return;
    }
    character = value.charAt(index2);
    markers = commonmark ? LIST_ORDERED_COMMONMARK_MARKERS : LIST_ORDERED_MARKERS;
    if (LIST_UNORDERED_MARKERS[character] === true) {
      marker = character;
      ordered = false;
    } else {
      ordered = true;
      queue2 = "";
      while (index2 < length) {
        character = value.charAt(index2);
        if (!decimal2(character)) {
          break;
        }
        queue2 += character;
        index2++;
      }
      character = value.charAt(index2);
      if (!queue2 || markers[character] !== true) {
        return;
      }
      start2 = parseInt(queue2, 10);
      marker = character;
    }
    character = value.charAt(++index2);
    if (character !== C_SPACE && character !== C_TAB) {
      return;
    }
    if (silent) {
      return true;
    }
    index2 = 0;
    items2 = [];
    allLines = [];
    emptyLines = [];
    while (index2 < length) {
      nextIndex = value.indexOf(C_NEWLINE, index2);
      startIndex = index2;
      prefixed = false;
      indented = false;
      if (nextIndex === -1) {
        nextIndex = length;
      }
      end2 = index2 + TAB_SIZE;
      size2 = 0;
      while (index2 < length) {
        character = value.charAt(index2);
        if (character === C_TAB) {
          size2 += TAB_SIZE - size2 % TAB_SIZE;
        } else if (character === C_SPACE) {
          size2++;
        } else {
          break;
        }
        index2++;
      }
      if (size2 >= TAB_SIZE) {
        indented = true;
      }
      if (item && size2 >= item.indent) {
        indented = true;
      }
      character = value.charAt(index2);
      currentMarker = null;
      if (!indented) {
        if (LIST_UNORDERED_MARKERS[character] === true) {
          currentMarker = character;
          index2++;
          size2++;
        } else {
          queue2 = "";
          while (index2 < length) {
            character = value.charAt(index2);
            if (!decimal2(character)) {
              break;
            }
            queue2 += character;
            index2++;
          }
          character = value.charAt(index2);
          index2++;
          if (queue2 && markers[character] === true) {
            currentMarker = character;
            size2 += queue2.length + 1;
          }
        }
        if (currentMarker) {
          character = value.charAt(index2);
          if (character === C_TAB) {
            size2 += TAB_SIZE - size2 % TAB_SIZE;
            index2++;
          } else if (character === C_SPACE) {
            end2 = index2 + TAB_SIZE;
            while (index2 < end2) {
              if (value.charAt(index2) !== C_SPACE) {
                break;
              }
              index2++;
              size2++;
            }
            if (index2 === end2 && value.charAt(index2) === C_SPACE) {
              index2 -= TAB_SIZE - 1;
              size2 -= TAB_SIZE - 1;
            }
          } else if (character !== C_NEWLINE && character !== "") {
            currentMarker = null;
          }
        }
      }
      if (currentMarker) {
        if (!pedantic && marker !== currentMarker) {
          break;
        }
        prefixed = true;
      } else {
        if (!commonmark && !indented && value.charAt(startIndex) === C_SPACE) {
          indented = true;
        } else if (commonmark && item) {
          indented = size2 >= item.indent || size2 > TAB_SIZE;
        }
        prefixed = false;
        index2 = startIndex;
      }
      line = value.slice(startIndex, nextIndex);
      content = startIndex === index2 ? line : value.slice(index2, nextIndex);
      if (currentMarker === C_ASTERISK || currentMarker === C_UNDERSCORE || currentMarker === C_DASH) {
        if (tokenizers.thematicBreak.call(self2, eat, line, true)) {
          break;
        }
      }
      prevEmpty = empty;
      empty = !trim2(content).length;
      if (indented && item) {
        item.value = item.value.concat(emptyLines, line);
        allLines = allLines.concat(emptyLines, line);
        emptyLines = [];
      } else if (prefixed) {
        if (emptyLines.length !== 0) {
          item.value.push("");
          item.trail = emptyLines.concat();
        }
        item = {
          value: [line],
          indent: size2,
          trail: []
        };
        items2.push(item);
        allLines = allLines.concat(emptyLines, line);
        emptyLines = [];
      } else if (empty) {
        if (prevEmpty) {
          break;
        }
        emptyLines.push(line);
      } else {
        if (prevEmpty) {
          break;
        }
        if (interrupt(interuptors, tokenizers, self2, [eat, line, true])) {
          break;
        }
        item.value = item.value.concat(emptyLines, line);
        allLines = allLines.concat(emptyLines, line);
        emptyLines = [];
      }
      index2 = nextIndex + 1;
    }
    node3 = eat(allLines.join(C_NEWLINE)).reset({
      type: "list",
      ordered,
      start: start2,
      loose: null,
      children: []
    });
    enterTop = self2.enterList();
    exitBlockquote = self2.enterBlock();
    isLoose = false;
    index2 = -1;
    length = items2.length;
    while (++index2 < length) {
      item = items2[index2].value.join(C_NEWLINE);
      now2 = eat.now();
      item = eat(item)(listItem(self2, item, now2), node3);
      if (item.loose) {
        isLoose = true;
      }
      item = items2[index2].trail.join(C_NEWLINE);
      if (index2 !== length - 1) {
        item += C_NEWLINE;
      }
      eat(item);
    }
    enterTop();
    exitBlockquote();
    node3.loose = isLoose;
    return node3;
  }
  function listItem(ctx2, value, position2) {
    var offsets = ctx2.offset;
    var fn2 = ctx2.options.pedantic ? pedanticListItem : normalListItem;
    var checked = null;
    var task;
    var indent;
    value = fn2.apply(null, arguments);
    if (ctx2.options.gfm) {
      task = value.match(EXPRESSION_TASK_ITEM);
      if (task) {
        indent = task[0].length;
        checked = task[1].toLowerCase() === C_X_LOWER;
        offsets[position2.line] += indent;
        value = value.slice(indent);
      }
    }
    return {
      type: "listItem",
      loose: EXPRESSION_LOOSE_LIST_ITEM.test(value) || value.charAt(value.length - 1) === C_NEWLINE,
      checked,
      children: ctx2.tokenizeBlock(value, position2)
    };
  }
  function pedanticListItem(ctx2, value, position2) {
    var offsets = ctx2.offset;
    var line = position2.line;
    value = value.replace(EXPRESSION_PEDANTIC_BULLET, replacer);
    line = position2.line;
    return value.replace(EXPRESSION_INITIAL_INDENT, replacer);
    function replacer($0) {
      offsets[line] = (offsets[line] || 0) + $0.length;
      line++;
      return "";
    }
  }
  function normalListItem(ctx2, value, position2) {
    var offsets = ctx2.offset;
    var line = position2.line;
    var max2;
    var bullet;
    var rest;
    var lines;
    var trimmedLines;
    var index2;
    var length;
    value = value.replace(EXPRESSION_BULLET, replacer);
    lines = value.split(C_NEWLINE);
    trimmedLines = removeIndent(value, getIndent(max2).indent).split(C_NEWLINE);
    trimmedLines[0] = rest;
    offsets[line] = (offsets[line] || 0) + bullet.length;
    line++;
    index2 = 0;
    length = lines.length;
    while (++index2 < length) {
      offsets[line] = (offsets[line] || 0) + lines[index2].length - trimmedLines[index2].length;
      line++;
    }
    return trimmedLines.join(C_NEWLINE);
    function replacer($0, $1, $2, $3, $4) {
      bullet = $1 + $2 + $3;
      rest = $4;
      if (Number($2) < 10 && bullet.length % 2 === 1) {
        $2 = C_SPACE + $2;
      }
      max2 = $1 + repeat(C_SPACE, $2.length) + $3;
      return max2 + rest;
    }
  }
  return list_1;
}
var headingSetext;
var hasRequiredHeadingSetext;
function requireHeadingSetext() {
  if (hasRequiredHeadingSetext) return headingSetext;
  hasRequiredHeadingSetext = 1;
  headingSetext = setextHeading;
  var C_NEWLINE = "\n";
  var C_TAB = "	";
  var C_SPACE = " ";
  var C_EQUALS = "=";
  var C_DASH = "-";
  var MAX_HEADING_INDENT = 3;
  var SETEXT_MARKERS = {};
  SETEXT_MARKERS[C_EQUALS] = 1;
  SETEXT_MARKERS[C_DASH] = 2;
  function setextHeading(eat, value, silent) {
    var self2 = this;
    var now2 = eat.now();
    var length = value.length;
    var index2 = -1;
    var subvalue = "";
    var content;
    var queue2;
    var character;
    var marker;
    var depth;
    while (++index2 < length) {
      character = value.charAt(index2);
      if (character !== C_SPACE || index2 >= MAX_HEADING_INDENT) {
        index2--;
        break;
      }
      subvalue += character;
    }
    content = "";
    queue2 = "";
    while (++index2 < length) {
      character = value.charAt(index2);
      if (character === C_NEWLINE) {
        index2--;
        break;
      }
      if (character === C_SPACE || character === C_TAB) {
        queue2 += character;
      } else {
        content += queue2 + character;
        queue2 = "";
      }
    }
    now2.column += subvalue.length;
    now2.offset += subvalue.length;
    subvalue += content + queue2;
    character = value.charAt(++index2);
    marker = value.charAt(++index2);
    if (character !== C_NEWLINE || !SETEXT_MARKERS[marker]) {
      return;
    }
    subvalue += character;
    queue2 = marker;
    depth = SETEXT_MARKERS[marker];
    while (++index2 < length) {
      character = value.charAt(index2);
      if (character !== marker) {
        if (character !== C_NEWLINE) {
          return;
        }
        index2--;
        break;
      }
      queue2 += character;
    }
    if (silent) {
      return true;
    }
    return eat(subvalue + queue2)({
      type: "heading",
      depth,
      children: self2.tokenizeInline(content, now2)
    });
  }
  return headingSetext;
}
var html = {};
var hasRequiredHtml;
function requireHtml() {
  if (hasRequiredHtml) return html;
  hasRequiredHtml = 1;
  var attributeName = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
  var unquoted = "[^\"'=<>`\\u0000-\\u0020]+";
  var singleQuoted = "'[^']*'";
  var doubleQuoted = '"[^"]*"';
  var attributeValue = "(?:" + unquoted + "|" + singleQuoted + "|" + doubleQuoted + ")";
  var attribute = "(?:\\s+" + attributeName + "(?:\\s*=\\s*" + attributeValue + ")?)";
  var openTag = "<[A-Za-z][A-Za-z0-9\\-]*" + attribute + "*\\s*\\/?>";
  var closeTag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
  var comment = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
  var processing = "<[?].*?[?]>";
  var declaration = "<![A-Za-z]+\\s+[^>]*>";
  var cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
  html.openCloseTag = new RegExp("^(?:" + openTag + "|" + closeTag + ")");
  html.tag = new RegExp("^(?:" + openTag + "|" + closeTag + "|" + comment + "|" + processing + "|" + declaration + "|" + cdata + ")");
  return html;
}
var htmlBlock;
var hasRequiredHtmlBlock;
function requireHtmlBlock() {
  if (hasRequiredHtmlBlock) return htmlBlock;
  hasRequiredHtmlBlock = 1;
  var openCloseTag = requireHtml().openCloseTag;
  htmlBlock = blockHTML;
  var C_TAB = "	";
  var C_SPACE = " ";
  var C_NEWLINE = "\n";
  var C_LT = "<";
  function blockHTML(eat, value, silent) {
    var self2 = this;
    var blocks = self2.options.blocks;
    var length = value.length;
    var index2 = 0;
    var next3;
    var line;
    var offset2;
    var character;
    var count;
    var sequence;
    var subvalue;
    var sequences = [
      [/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true],
      [/^<!--/, /-->/, true],
      [/^<\?/, /\?>/, true],
      [/^<![A-Za-z]/, />/, true],
      [/^<!\[CDATA\[/, /\]\]>/, true],
      [new RegExp("^</?(" + blocks.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, true],
      [new RegExp(openCloseTag.source + "\\s*$"), /^$/, false]
    ];
    while (index2 < length) {
      character = value.charAt(index2);
      if (character !== C_TAB && character !== C_SPACE) {
        break;
      }
      index2++;
    }
    if (value.charAt(index2) !== C_LT) {
      return;
    }
    next3 = value.indexOf(C_NEWLINE, index2 + 1);
    next3 = next3 === -1 ? length : next3;
    line = value.slice(index2, next3);
    offset2 = -1;
    count = sequences.length;
    while (++offset2 < count) {
      if (sequences[offset2][0].test(line)) {
        sequence = sequences[offset2];
        break;
      }
    }
    if (!sequence) {
      return;
    }
    if (silent) {
      return sequence[2];
    }
    index2 = next3;
    if (!sequence[1].test(line)) {
      while (index2 < length) {
        next3 = value.indexOf(C_NEWLINE, index2 + 1);
        next3 = next3 === -1 ? length : next3;
        line = value.slice(index2 + 1, next3);
        if (sequence[1].test(line)) {
          if (line) {
            index2 = next3;
          }
          break;
        }
        index2 = next3;
      }
    }
    subvalue = value.slice(0, index2);
    return eat(subvalue)({ type: "html", value: subvalue });
  }
  return htmlBlock;
}
var collapseWhiteSpace;
var hasRequiredCollapseWhiteSpace;
function requireCollapseWhiteSpace() {
  if (hasRequiredCollapseWhiteSpace) return collapseWhiteSpace;
  hasRequiredCollapseWhiteSpace = 1;
  collapseWhiteSpace = collapse3;
  function collapse3(value) {
    return String(value).replace(/\s+/g, " ");
  }
  return collapseWhiteSpace;
}
var normalize_1;
var hasRequiredNormalize;
function requireNormalize() {
  if (hasRequiredNormalize) return normalize_1;
  hasRequiredNormalize = 1;
  var collapseWhiteSpace2 = requireCollapseWhiteSpace();
  normalize_1 = normalize4;
  function normalize4(value) {
    return collapseWhiteSpace2(value).toLowerCase();
  }
  return normalize_1;
}
var footnoteDefinition_1;
var hasRequiredFootnoteDefinition;
function requireFootnoteDefinition() {
  if (hasRequiredFootnoteDefinition) return footnoteDefinition_1;
  hasRequiredFootnoteDefinition = 1;
  var whitespace = requireIsWhitespaceCharacter();
  var normalize4 = requireNormalize();
  footnoteDefinition_1 = footnoteDefinition;
  footnoteDefinition.notInList = true;
  footnoteDefinition.notInBlock = true;
  var C_BACKSLASH = "\\";
  var C_NEWLINE = "\n";
  var C_TAB = "	";
  var C_SPACE = " ";
  var C_BRACKET_OPEN = "[";
  var C_BRACKET_CLOSE = "]";
  var C_CARET = "^";
  var C_COLON = ":";
  var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;
  function footnoteDefinition(eat, value, silent) {
    var self2 = this;
    var offsets = self2.offset;
    var index2;
    var length;
    var subvalue;
    var now2;
    var currentLine;
    var content;
    var queue2;
    var subqueue;
    var character;
    var identifier;
    var add2;
    var exit;
    if (!self2.options.footnotes) {
      return;
    }
    index2 = 0;
    length = value.length;
    subvalue = "";
    now2 = eat.now();
    currentLine = now2.line;
    while (index2 < length) {
      character = value.charAt(index2);
      if (!whitespace(character)) {
        break;
      }
      subvalue += character;
      index2++;
    }
    if (value.charAt(index2) !== C_BRACKET_OPEN || value.charAt(index2 + 1) !== C_CARET) {
      return;
    }
    subvalue += C_BRACKET_OPEN + C_CARET;
    index2 = subvalue.length;
    queue2 = "";
    while (index2 < length) {
      character = value.charAt(index2);
      if (character === C_BRACKET_CLOSE) {
        break;
      } else if (character === C_BACKSLASH) {
        queue2 += character;
        index2++;
        character = value.charAt(index2);
      }
      queue2 += character;
      index2++;
    }
    if (!queue2 || value.charAt(index2) !== C_BRACKET_CLOSE || value.charAt(index2 + 1) !== C_COLON) {
      return;
    }
    if (silent) {
      return true;
    }
    identifier = normalize4(queue2);
    subvalue += queue2 + C_BRACKET_CLOSE + C_COLON;
    index2 = subvalue.length;
    while (index2 < length) {
      character = value.charAt(index2);
      if (character !== C_TAB && character !== C_SPACE) {
        break;
      }
      subvalue += character;
      index2++;
    }
    now2.column += subvalue.length;
    now2.offset += subvalue.length;
    queue2 = "";
    content = "";
    subqueue = "";
    while (index2 < length) {
      character = value.charAt(index2);
      if (character === C_NEWLINE) {
        subqueue = character;
        index2++;
        while (index2 < length) {
          character = value.charAt(index2);
          if (character !== C_NEWLINE) {
            break;
          }
          subqueue += character;
          index2++;
        }
        queue2 += subqueue;
        subqueue = "";
        while (index2 < length) {
          character = value.charAt(index2);
          if (character !== C_SPACE) {
            break;
          }
          subqueue += character;
          index2++;
        }
        if (subqueue.length === 0) {
          break;
        }
        queue2 += subqueue;
      }
      if (queue2) {
        content += queue2;
        queue2 = "";
      }
      content += character;
      index2++;
    }
    subvalue += content;
    content = content.replace(EXPRESSION_INITIAL_TAB, function(line) {
      offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
      currentLine++;
      return "";
    });
    add2 = eat(subvalue);
    exit = self2.enterBlock();
    content = self2.tokenizeBlock(content, now2);
    exit();
    return add2({
      type: "footnoteDefinition",
      identifier,
      children: content
    });
  }
  return footnoteDefinition_1;
}
var definition_1;
var hasRequiredDefinition;
function requireDefinition() {
  if (hasRequiredDefinition) return definition_1;
  hasRequiredDefinition = 1;
  var whitespace = requireIsWhitespaceCharacter();
  var normalize4 = requireNormalize();
  definition_1 = definition;
  definition.notInList = true;
  definition.notInBlock = true;
  var C_DOUBLE_QUOTE = '"';
  var C_SINGLE_QUOTE = "'";
  var C_BACKSLASH = "\\";
  var C_NEWLINE = "\n";
  var C_TAB = "	";
  var C_SPACE = " ";
  var C_BRACKET_OPEN = "[";
  var C_BRACKET_CLOSE = "]";
  var C_PAREN_OPEN = "(";
  var C_PAREN_CLOSE = ")";
  var C_COLON = ":";
  var C_LT = "<";
  var C_GT = ">";
  function definition(eat, value, silent) {
    var self2 = this;
    var commonmark = self2.options.commonmark;
    var index2 = 0;
    var length = value.length;
    var subvalue = "";
    var beforeURL;
    var beforeTitle;
    var queue2;
    var character;
    var test2;
    var identifier;
    var url2;
    var title2;
    while (index2 < length) {
      character = value.charAt(index2);
      if (character !== C_SPACE && character !== C_TAB) {
        break;
      }
      subvalue += character;
      index2++;
    }
    character = value.charAt(index2);
    if (character !== C_BRACKET_OPEN) {
      return;
    }
    index2++;
    subvalue += character;
    queue2 = "";
    while (index2 < length) {
      character = value.charAt(index2);
      if (character === C_BRACKET_CLOSE) {
        break;
      } else if (character === C_BACKSLASH) {
        queue2 += character;
        index2++;
        character = value.charAt(index2);
      }
      queue2 += character;
      index2++;
    }
    if (!queue2 || value.charAt(index2) !== C_BRACKET_CLOSE || value.charAt(index2 + 1) !== C_COLON) {
      return;
    }
    identifier = queue2;
    subvalue += queue2 + C_BRACKET_CLOSE + C_COLON;
    index2 = subvalue.length;
    queue2 = "";
    while (index2 < length) {
      character = value.charAt(index2);
      if (character !== C_TAB && character !== C_SPACE && character !== C_NEWLINE) {
        break;
      }
      subvalue += character;
      index2++;
    }
    character = value.charAt(index2);
    queue2 = "";
    beforeURL = subvalue;
    if (character === C_LT) {
      index2++;
      while (index2 < length) {
        character = value.charAt(index2);
        if (!isEnclosedURLCharacter(character)) {
          break;
        }
        queue2 += character;
        index2++;
      }
      character = value.charAt(index2);
      if (character === isEnclosedURLCharacter.delimiter) {
        subvalue += C_LT + queue2 + character;
        index2++;
      } else {
        if (commonmark) {
          return;
        }
        index2 -= queue2.length + 1;
        queue2 = "";
      }
    }
    if (!queue2) {
      while (index2 < length) {
        character = value.charAt(index2);
        if (!isUnclosedURLCharacter(character)) {
          break;
        }
        queue2 += character;
        index2++;
      }
      subvalue += queue2;
    }
    if (!queue2) {
      return;
    }
    url2 = queue2;
    queue2 = "";
    while (index2 < length) {
      character = value.charAt(index2);
      if (character !== C_TAB && character !== C_SPACE && character !== C_NEWLINE) {
        break;
      }
      queue2 += character;
      index2++;
    }
    character = value.charAt(index2);
    test2 = null;
    if (character === C_DOUBLE_QUOTE) {
      test2 = C_DOUBLE_QUOTE;
    } else if (character === C_SINGLE_QUOTE) {
      test2 = C_SINGLE_QUOTE;
    } else if (character === C_PAREN_OPEN) {
      test2 = C_PAREN_CLOSE;
    }
    if (!test2) {
      queue2 = "";
      index2 = subvalue.length;
    } else if (queue2) {
      subvalue += queue2 + character;
      index2 = subvalue.length;
      queue2 = "";
      while (index2 < length) {
        character = value.charAt(index2);
        if (character === test2) {
          break;
        }
        if (character === C_NEWLINE) {
          index2++;
          character = value.charAt(index2);
          if (character === C_NEWLINE || character === test2) {
            return;
          }
          queue2 += C_NEWLINE;
        }
        queue2 += character;
        index2++;
      }
      character = value.charAt(index2);
      if (character !== test2) {
        return;
      }
      beforeTitle = subvalue;
      subvalue += queue2 + character;
      index2++;
      title2 = queue2;
      queue2 = "";
    } else {
      return;
    }
    while (index2 < length) {
      character = value.charAt(index2);
      if (character !== C_TAB && character !== C_SPACE) {
        break;
      }
      subvalue += character;
      index2++;
    }
    character = value.charAt(index2);
    if (!character || character === C_NEWLINE) {
      if (silent) {
        return true;
      }
      beforeURL = eat(beforeURL).test().end;
      url2 = self2.decode.raw(self2.unescape(url2), beforeURL, { nonTerminated: false });
      if (title2) {
        beforeTitle = eat(beforeTitle).test().end;
        title2 = self2.decode.raw(self2.unescape(title2), beforeTitle);
      }
      return eat(subvalue)({
        type: "definition",
        identifier: normalize4(identifier),
        title: title2 || null,
        url: url2
      });
    }
  }
  function isEnclosedURLCharacter(character) {
    return character !== C_GT && character !== C_BRACKET_OPEN && character !== C_BRACKET_CLOSE;
  }
  isEnclosedURLCharacter.delimiter = C_GT;
  function isUnclosedURLCharacter(character) {
    return character !== C_BRACKET_OPEN && character !== C_BRACKET_CLOSE && !whitespace(character);
  }
  return definition_1;
}
var table_1;
var hasRequiredTable;
function requireTable() {
  if (hasRequiredTable) return table_1;
  hasRequiredTable = 1;
  var whitespace = requireIsWhitespaceCharacter();
  table_1 = table;
  var C_BACKSLASH = "\\";
  var C_TICK = "`";
  var C_DASH = "-";
  var C_PIPE = "|";
  var C_COLON = ":";
  var C_SPACE = " ";
  var C_NEWLINE = "\n";
  var C_TAB = "	";
  var MIN_TABLE_COLUMNS = 1;
  var MIN_TABLE_ROWS = 2;
  var TABLE_ALIGN_LEFT = "left";
  var TABLE_ALIGN_CENTER = "center";
  var TABLE_ALIGN_RIGHT = "right";
  var TABLE_ALIGN_NONE = null;
  function table(eat, value, silent) {
    var self2 = this;
    var index2;
    var alignments;
    var alignment;
    var subvalue;
    var row;
    var length;
    var lines;
    var queue2;
    var character;
    var hasDash;
    var align;
    var cell;
    var preamble;
    var count;
    var opening;
    var now2;
    var position2;
    var lineCount;
    var line;
    var rows;
    var table2;
    var lineIndex;
    var pipeIndex;
    var first2;
    if (!self2.options.gfm) {
      return;
    }
    index2 = 0;
    lineCount = 0;
    length = value.length + 1;
    lines = [];
    while (index2 < length) {
      lineIndex = value.indexOf(C_NEWLINE, index2);
      pipeIndex = value.indexOf(C_PIPE, index2 + 1);
      if (lineIndex === -1) {
        lineIndex = value.length;
      }
      if (pipeIndex === -1 || pipeIndex > lineIndex) {
        if (lineCount < MIN_TABLE_ROWS) {
          return;
        }
        break;
      }
      lines.push(value.slice(index2, lineIndex));
      lineCount++;
      index2 = lineIndex + 1;
    }
    subvalue = lines.join(C_NEWLINE);
    alignments = lines.splice(1, 1)[0] || [];
    index2 = 0;
    length = alignments.length;
    lineCount--;
    alignment = false;
    align = [];
    while (index2 < length) {
      character = alignments.charAt(index2);
      if (character === C_PIPE) {
        hasDash = null;
        if (alignment === false) {
          if (first2 === false) {
            return;
          }
        } else {
          align.push(alignment);
          alignment = false;
        }
        first2 = false;
      } else if (character === C_DASH) {
        hasDash = true;
        alignment = alignment || TABLE_ALIGN_NONE;
      } else if (character === C_COLON) {
        if (alignment === TABLE_ALIGN_LEFT) {
          alignment = TABLE_ALIGN_CENTER;
        } else if (hasDash && alignment === TABLE_ALIGN_NONE) {
          alignment = TABLE_ALIGN_RIGHT;
        } else {
          alignment = TABLE_ALIGN_LEFT;
        }
      } else if (!whitespace(character)) {
        return;
      }
      index2++;
    }
    if (alignment !== false) {
      align.push(alignment);
    }
    if (align.length < MIN_TABLE_COLUMNS) {
      return;
    }
    if (silent) {
      return true;
    }
    position2 = -1;
    rows = [];
    table2 = eat(subvalue).reset({
      type: "table",
      align,
      children: rows
    });
    while (++position2 < lineCount) {
      line = lines[position2];
      row = { type: "tableRow", children: [] };
      if (position2) {
        eat(C_NEWLINE);
      }
      eat(line).reset(row, table2);
      length = line.length + 1;
      index2 = 0;
      queue2 = "";
      cell = "";
      preamble = true;
      count = null;
      opening = null;
      while (index2 < length) {
        character = line.charAt(index2);
        if (character === C_TAB || character === C_SPACE) {
          if (cell) {
            queue2 += character;
          } else {
            eat(character);
          }
          index2++;
          continue;
        }
        if (character === "" || character === C_PIPE) {
          if (preamble) {
            eat(character);
          } else {
            if (character && opening) {
              queue2 += character;
              index2++;
              continue;
            }
            if ((cell || character) && !preamble) {
              subvalue = cell;
              if (queue2.length > 1) {
                if (character) {
                  subvalue += queue2.slice(0, queue2.length - 1);
                  queue2 = queue2.charAt(queue2.length - 1);
                } else {
                  subvalue += queue2;
                  queue2 = "";
                }
              }
              now2 = eat.now();
              eat(subvalue)({
                type: "tableCell",
                children: self2.tokenizeInline(cell, now2)
              }, row);
            }
            eat(queue2 + character);
            queue2 = "";
            cell = "";
          }
        } else {
          if (queue2) {
            cell += queue2;
            queue2 = "";
          }
          cell += character;
          if (character === C_BACKSLASH && index2 !== length - 2) {
            cell += line.charAt(index2 + 1);
            index2++;
          }
          if (character === C_TICK) {
            count = 1;
            while (line.charAt(index2 + 1) === character) {
              cell += character;
              index2++;
              count++;
            }
            if (!opening) {
              opening = count;
            } else if (count >= opening) {
              opening = 0;
            }
          }
        }
        preamble = false;
        index2++;
      }
      if (!position2) {
        eat(C_NEWLINE + alignments);
      }
    }
    return table2;
  }
  return table_1;
}
var paragraph_1;
var hasRequiredParagraph;
function requireParagraph() {
  if (hasRequiredParagraph) return paragraph_1;
  hasRequiredParagraph = 1;
  var trim2 = requireTrim();
  var decimal2 = isDecimal;
  var trimTrailingLines = requireTrimTrailingLines();
  var interrupt = requireInterrupt();
  paragraph_1 = paragraph;
  var C_NEWLINE = "\n";
  var C_TAB = "	";
  var C_SPACE = " ";
  var TAB_SIZE = 4;
  function paragraph(eat, value, silent) {
    var self2 = this;
    var settings = self2.options;
    var commonmark = settings.commonmark;
    var gfm = settings.gfm;
    var tokenizers = self2.blockTokenizers;
    var interruptors = self2.interruptParagraph;
    var index2 = value.indexOf(C_NEWLINE);
    var length = value.length;
    var position2;
    var subvalue;
    var character;
    var size2;
    var now2;
    while (index2 < length) {
      if (index2 === -1) {
        index2 = length;
        break;
      }
      if (value.charAt(index2 + 1) === C_NEWLINE) {
        break;
      }
      if (commonmark) {
        size2 = 0;
        position2 = index2 + 1;
        while (position2 < length) {
          character = value.charAt(position2);
          if (character === C_TAB) {
            size2 = TAB_SIZE;
            break;
          } else if (character === C_SPACE) {
            size2++;
          } else {
            break;
          }
          position2++;
        }
        if (size2 >= TAB_SIZE) {
          index2 = value.indexOf(C_NEWLINE, index2 + 1);
          continue;
        }
      }
      subvalue = value.slice(index2 + 1);
      if (interrupt(interruptors, tokenizers, self2, [eat, subvalue, true])) {
        break;
      }
      if (tokenizers.list.call(self2, eat, subvalue, true) && (self2.inList || commonmark || gfm && !decimal2(trim2.left(subvalue).charAt(0)))) {
        break;
      }
      position2 = index2;
      index2 = value.indexOf(C_NEWLINE, index2 + 1);
      if (index2 !== -1 && trim2(value.slice(position2, index2)) === "") {
        index2 = position2;
        break;
      }
    }
    subvalue = value.slice(0, index2);
    if (trim2(subvalue) === "") {
      eat(subvalue);
      return null;
    }
    if (silent) {
      return true;
    }
    now2 = eat.now();
    subvalue = trimTrailingLines(subvalue);
    return eat(subvalue)({
      type: "paragraph",
      children: self2.tokenizeInline(subvalue, now2)
    });
  }
  return paragraph_1;
}
var _escape$1;
var hasRequired_escape$1;
function require_escape$1() {
  if (hasRequired_escape$1) return _escape$1;
  hasRequired_escape$1 = 1;
  _escape$1 = locate;
  function locate(value, fromIndex) {
    return value.indexOf("\\", fromIndex);
  }
  return _escape$1;
}
var _escape;
var hasRequired_escape;
function require_escape() {
  if (hasRequired_escape) return _escape;
  hasRequired_escape = 1;
  var locate = require_escape$1();
  _escape = escape;
  escape.locator = locate;
  function escape(eat, value, silent) {
    var self2 = this;
    var character;
    var node3;
    if (value.charAt(0) === "\\") {
      character = value.charAt(1);
      if (self2.escape.indexOf(character) !== -1) {
        if (silent) {
          return true;
        }
        if (character === "\n") {
          node3 = { type: "break" };
        } else {
          node3 = {
            type: "text",
            value: character
          };
        }
        return eat("\\" + character)(node3);
      }
    }
  }
  return _escape;
}
var tag;
var hasRequiredTag;
function requireTag() {
  if (hasRequiredTag) return tag;
  hasRequiredTag = 1;
  tag = locate;
  function locate(value, fromIndex) {
    return value.indexOf("<", fromIndex);
  }
  return tag;
}
var autoLink_1;
var hasRequiredAutoLink;
function requireAutoLink() {
  if (hasRequiredAutoLink) return autoLink_1;
  hasRequiredAutoLink = 1;
  var whitespace = requireIsWhitespaceCharacter();
  var decode2 = parseEntities_1;
  var locate = requireTag();
  autoLink_1 = autoLink;
  autoLink.locator = locate;
  autoLink.notInLink = true;
  var C_LT = "<";
  var C_GT = ">";
  var C_AT_SIGN = "@";
  var C_SLASH = "/";
  var MAILTO = "mailto:";
  var MAILTO_LENGTH = MAILTO.length;
  function autoLink(eat, value, silent) {
    var self2;
    var subvalue;
    var length;
    var index2;
    var queue2;
    var character;
    var hasAtCharacter;
    var link2;
    var now2;
    var content;
    var tokenizers;
    var exit;
    if (value.charAt(0) !== C_LT) {
      return;
    }
    self2 = this;
    subvalue = "";
    length = value.length;
    index2 = 0;
    queue2 = "";
    hasAtCharacter = false;
    link2 = "";
    index2++;
    subvalue = C_LT;
    while (index2 < length) {
      character = value.charAt(index2);
      if (whitespace(character) || character === C_GT || character === C_AT_SIGN || character === ":" && value.charAt(index2 + 1) === C_SLASH) {
        break;
      }
      queue2 += character;
      index2++;
    }
    if (!queue2) {
      return;
    }
    link2 += queue2;
    queue2 = "";
    character = value.charAt(index2);
    link2 += character;
    index2++;
    if (character === C_AT_SIGN) {
      hasAtCharacter = true;
    } else {
      if (character !== ":" || value.charAt(index2 + 1) !== C_SLASH) {
        return;
      }
      link2 += C_SLASH;
      index2++;
    }
    while (index2 < length) {
      character = value.charAt(index2);
      if (whitespace(character) || character === C_GT) {
        break;
      }
      queue2 += character;
      index2++;
    }
    character = value.charAt(index2);
    if (!queue2 || character !== C_GT) {
      return;
    }
    if (silent) {
      return true;
    }
    link2 += queue2;
    content = link2;
    subvalue += link2 + character;
    now2 = eat.now();
    now2.column++;
    now2.offset++;
    if (hasAtCharacter) {
      if (link2.slice(0, MAILTO_LENGTH).toLowerCase() === MAILTO) {
        content = content.substr(MAILTO_LENGTH);
        now2.column += MAILTO_LENGTH;
        now2.offset += MAILTO_LENGTH;
      } else {
        link2 = MAILTO + link2;
      }
    }
    tokenizers = self2.inlineTokenizers;
    self2.inlineTokenizers = { text: tokenizers.text };
    exit = self2.enterLink();
    content = self2.tokenizeInline(content, now2);
    self2.inlineTokenizers = tokenizers;
    exit();
    return eat(subvalue)({
      type: "link",
      title: null,
      url: decode2(link2, { nonTerminated: false }),
      children: content
    });
  }
  return autoLink_1;
}
var url;
var hasRequiredUrl$1;
function requireUrl$1() {
  if (hasRequiredUrl$1) return url;
  hasRequiredUrl$1 = 1;
  url = locate;
  var PROTOCOLS = ["https://", "http://", "mailto:"];
  function locate(value, fromIndex) {
    var length = PROTOCOLS.length;
    var index2 = -1;
    var min2 = -1;
    var position2;
    if (!this.options.gfm) {
      return -1;
    }
    while (++index2 < length) {
      position2 = value.indexOf(PROTOCOLS[index2], fromIndex);
      if (position2 !== -1 && (position2 < min2 || min2 === -1)) {
        min2 = position2;
      }
    }
    return min2;
  }
  return url;
}
var url_1;
var hasRequiredUrl;
function requireUrl() {
  if (hasRequiredUrl) return url_1;
  hasRequiredUrl = 1;
  var decode2 = parseEntities_1;
  var whitespace = requireIsWhitespaceCharacter();
  var locate = requireUrl$1();
  url_1 = url2;
  url2.locator = locate;
  url2.notInLink = true;
  var C_BRACKET_OPEN = "[";
  var C_BRACKET_CLOSE = "]";
  var C_PAREN_OPEN = "(";
  var C_PAREN_CLOSE = ")";
  var C_LT = "<";
  var C_AT_SIGN = "@";
  var HTTP_PROTOCOL = "http://";
  var HTTPS_PROTOCOL = "https://";
  var MAILTO_PROTOCOL = "mailto:";
  var PROTOCOLS = [
    HTTP_PROTOCOL,
    HTTPS_PROTOCOL,
    MAILTO_PROTOCOL
  ];
  var PROTOCOLS_LENGTH = PROTOCOLS.length;
  function url2(eat, value, silent) {
    var self2 = this;
    var subvalue;
    var content;
    var character;
    var index2;
    var position2;
    var protocol;
    var match5;
    var length;
    var queue2;
    var parenCount;
    var nextCharacter;
    var exit;
    if (!self2.options.gfm) {
      return;
    }
    subvalue = "";
    index2 = -1;
    length = PROTOCOLS_LENGTH;
    while (++index2 < length) {
      protocol = PROTOCOLS[index2];
      match5 = value.slice(0, protocol.length);
      if (match5.toLowerCase() === protocol) {
        subvalue = match5;
        break;
      }
    }
    if (!subvalue) {
      return;
    }
    index2 = subvalue.length;
    length = value.length;
    queue2 = "";
    parenCount = 0;
    while (index2 < length) {
      character = value.charAt(index2);
      if (whitespace(character) || character === C_LT) {
        break;
      }
      if (character === "." || character === "," || character === ":" || character === ";" || character === '"' || character === "'" || character === ")" || character === "]") {
        nextCharacter = value.charAt(index2 + 1);
        if (!nextCharacter || whitespace(nextCharacter)) {
          break;
        }
      }
      if (character === C_PAREN_OPEN || character === C_BRACKET_OPEN) {
        parenCount++;
      }
      if (character === C_PAREN_CLOSE || character === C_BRACKET_CLOSE) {
        parenCount--;
        if (parenCount < 0) {
          break;
        }
      }
      queue2 += character;
      index2++;
    }
    if (!queue2) {
      return;
    }
    subvalue += queue2;
    content = subvalue;
    if (protocol === MAILTO_PROTOCOL) {
      position2 = queue2.indexOf(C_AT_SIGN);
      if (position2 === -1 || position2 === length - 1) {
        return;
      }
      content = content.substr(MAILTO_PROTOCOL.length);
    }
    if (silent) {
      return true;
    }
    exit = self2.enterLink();
    content = self2.tokenizeInline(content, eat.now());
    exit();
    return eat(subvalue)({
      type: "link",
      title: null,
      url: decode2(subvalue, { nonTerminated: false }),
      children: content
    });
  }
  return url_1;
}
var htmlInline;
var hasRequiredHtmlInline;
function requireHtmlInline() {
  if (hasRequiredHtmlInline) return htmlInline;
  hasRequiredHtmlInline = 1;
  var alphabetical2 = requireIsAlphabetical();
  var locate = requireTag();
  var tag2 = requireHtml().tag;
  htmlInline = inlineHTML;
  inlineHTML.locator = locate;
  var EXPRESSION_HTML_LINK_OPEN = /^<a /i;
  var EXPRESSION_HTML_LINK_CLOSE = /^<\/a>/i;
  function inlineHTML(eat, value, silent) {
    var self2 = this;
    var length = value.length;
    var character;
    var subvalue;
    if (value.charAt(0) !== "<" || length < 3) {
      return;
    }
    character = value.charAt(1);
    if (!alphabetical2(character) && character !== "?" && character !== "!" && character !== "/") {
      return;
    }
    subvalue = value.match(tag2);
    if (!subvalue) {
      return;
    }
    if (silent) {
      return true;
    }
    subvalue = subvalue[0];
    if (!self2.inLink && EXPRESSION_HTML_LINK_OPEN.test(subvalue)) {
      self2.inLink = true;
    } else if (self2.inLink && EXPRESSION_HTML_LINK_CLOSE.test(subvalue)) {
      self2.inLink = false;
    }
    return eat(subvalue)({ type: "html", value: subvalue });
  }
  return htmlInline;
}
var link;
var hasRequiredLink$1;
function requireLink$1() {
  if (hasRequiredLink$1) return link;
  hasRequiredLink$1 = 1;
  link = locate;
  function locate(value, fromIndex) {
    var link2 = value.indexOf("[", fromIndex);
    var image = value.indexOf("![", fromIndex);
    if (image === -1) {
      return link2;
    }
    return link2 < image ? link2 : image;
  }
  return link;
}
var link_1;
var hasRequiredLink;
function requireLink() {
  if (hasRequiredLink) return link_1;
  hasRequiredLink = 1;
  var whitespace = requireIsWhitespaceCharacter();
  var locate = requireLink$1();
  link_1 = link2;
  link2.locator = locate;
  var own2 = {}.hasOwnProperty;
  var C_BACKSLASH = "\\";
  var C_BRACKET_OPEN = "[";
  var C_BRACKET_CLOSE = "]";
  var C_PAREN_OPEN = "(";
  var C_PAREN_CLOSE = ")";
  var C_LT = "<";
  var C_GT = ">";
  var C_TICK = "`";
  var C_DOUBLE_QUOTE = '"';
  var C_SINGLE_QUOTE = "'";
  var LINK_MARKERS = {};
  LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
  LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
  var COMMONMARK_LINK_MARKERS = {};
  COMMONMARK_LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
  COMMONMARK_LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
  COMMONMARK_LINK_MARKERS[C_PAREN_OPEN] = C_PAREN_CLOSE;
  function link2(eat, value, silent) {
    var self2 = this;
    var subvalue = "";
    var index2 = 0;
    var character = value.charAt(0);
    var pedantic = self2.options.pedantic;
    var commonmark = self2.options.commonmark;
    var gfm = self2.options.gfm;
    var closed;
    var count;
    var opening;
    var beforeURL;
    var beforeTitle;
    var subqueue;
    var hasMarker;
    var markers;
    var isImage;
    var content;
    var marker;
    var length;
    var title2;
    var depth;
    var queue2;
    var url2;
    var now2;
    var exit;
    var node3;
    if (character === "!") {
      isImage = true;
      subvalue = character;
      character = value.charAt(++index2);
    }
    if (character !== C_BRACKET_OPEN) {
      return;
    }
    if (!isImage && self2.inLink) {
      return;
    }
    subvalue += character;
    queue2 = "";
    index2++;
    length = value.length;
    now2 = eat.now();
    depth = 0;
    now2.column += index2;
    now2.offset += index2;
    while (index2 < length) {
      character = value.charAt(index2);
      subqueue = character;
      if (character === C_TICK) {
        count = 1;
        while (value.charAt(index2 + 1) === C_TICK) {
          subqueue += character;
          index2++;
          count++;
        }
        if (!opening) {
          opening = count;
        } else if (count >= opening) {
          opening = 0;
        }
      } else if (character === C_BACKSLASH) {
        index2++;
        subqueue += value.charAt(index2);
      } else if ((!opening || gfm) && character === C_BRACKET_OPEN) {
        depth++;
      } else if ((!opening || gfm) && character === C_BRACKET_CLOSE) {
        if (depth) {
          depth--;
        } else {
          if (!pedantic) {
            while (index2 < length) {
              character = value.charAt(index2 + 1);
              if (!whitespace(character)) {
                break;
              }
              subqueue += character;
              index2++;
            }
          }
          if (value.charAt(index2 + 1) !== C_PAREN_OPEN) {
            return;
          }
          subqueue += C_PAREN_OPEN;
          closed = true;
          index2++;
          break;
        }
      }
      queue2 += subqueue;
      subqueue = "";
      index2++;
    }
    if (!closed) {
      return;
    }
    content = queue2;
    subvalue += queue2 + subqueue;
    index2++;
    while (index2 < length) {
      character = value.charAt(index2);
      if (!whitespace(character)) {
        break;
      }
      subvalue += character;
      index2++;
    }
    character = value.charAt(index2);
    markers = commonmark ? COMMONMARK_LINK_MARKERS : LINK_MARKERS;
    queue2 = "";
    beforeURL = subvalue;
    if (character === C_LT) {
      index2++;
      beforeURL += C_LT;
      while (index2 < length) {
        character = value.charAt(index2);
        if (character === C_GT) {
          break;
        }
        if (commonmark && character === "\n") {
          return;
        }
        queue2 += character;
        index2++;
      }
      if (value.charAt(index2) !== C_GT) {
        return;
      }
      subvalue += C_LT + queue2 + C_GT;
      url2 = queue2;
      index2++;
    } else {
      character = null;
      subqueue = "";
      while (index2 < length) {
        character = value.charAt(index2);
        if (subqueue && own2.call(markers, character)) {
          break;
        }
        if (whitespace(character)) {
          if (!pedantic) {
            break;
          }
          subqueue += character;
        } else {
          if (character === C_PAREN_OPEN) {
            depth++;
          } else if (character === C_PAREN_CLOSE) {
            if (depth === 0) {
              break;
            }
            depth--;
          }
          queue2 += subqueue;
          subqueue = "";
          if (character === C_BACKSLASH) {
            queue2 += C_BACKSLASH;
            character = value.charAt(++index2);
          }
          queue2 += character;
        }
        index2++;
      }
      subvalue += queue2;
      url2 = queue2;
      index2 = subvalue.length;
    }
    queue2 = "";
    while (index2 < length) {
      character = value.charAt(index2);
      if (!whitespace(character)) {
        break;
      }
      queue2 += character;
      index2++;
    }
    character = value.charAt(index2);
    subvalue += queue2;
    if (queue2 && own2.call(markers, character)) {
      index2++;
      subvalue += character;
      queue2 = "";
      marker = markers[character];
      beforeTitle = subvalue;
      if (commonmark) {
        while (index2 < length) {
          character = value.charAt(index2);
          if (character === marker) {
            break;
          }
          if (character === C_BACKSLASH) {
            queue2 += C_BACKSLASH;
            character = value.charAt(++index2);
          }
          index2++;
          queue2 += character;
        }
        character = value.charAt(index2);
        if (character !== marker) {
          return;
        }
        title2 = queue2;
        subvalue += queue2 + character;
        index2++;
        while (index2 < length) {
          character = value.charAt(index2);
          if (!whitespace(character)) {
            break;
          }
          subvalue += character;
          index2++;
        }
      } else {
        subqueue = "";
        while (index2 < length) {
          character = value.charAt(index2);
          if (character === marker) {
            if (hasMarker) {
              queue2 += marker + subqueue;
              subqueue = "";
            }
            hasMarker = true;
          } else if (!hasMarker) {
            queue2 += character;
          } else if (character === C_PAREN_CLOSE) {
            subvalue += queue2 + marker + subqueue;
            title2 = queue2;
            break;
          } else if (whitespace(character)) {
            subqueue += character;
          } else {
            queue2 += marker + subqueue + character;
            subqueue = "";
            hasMarker = false;
          }
          index2++;
        }
      }
    }
    if (value.charAt(index2) !== C_PAREN_CLOSE) {
      return;
    }
    if (silent) {
      return true;
    }
    subvalue += C_PAREN_CLOSE;
    url2 = self2.decode.raw(self2.unescape(url2), eat(beforeURL).test().end, { nonTerminated: false });
    if (title2) {
      beforeTitle = eat(beforeTitle).test().end;
      title2 = self2.decode.raw(self2.unescape(title2), beforeTitle);
    }
    node3 = {
      type: isImage ? "image" : "link",
      title: title2 || null,
      url: url2
    };
    if (isImage) {
      node3.alt = self2.decode.raw(self2.unescape(content), now2) || null;
    } else {
      exit = self2.enterLink();
      node3.children = self2.tokenizeInline(content, now2);
      exit();
    }
    return eat(subvalue)(node3);
  }
  return link_1;
}
var reference_1;
var hasRequiredReference;
function requireReference() {
  if (hasRequiredReference) return reference_1;
  hasRequiredReference = 1;
  var whitespace = requireIsWhitespaceCharacter();
  var locate = requireLink$1();
  var normalize4 = requireNormalize();
  reference_1 = reference;
  reference.locator = locate;
  var T_LINK = "link";
  var T_IMAGE = "image";
  var T_FOOTNOTE = "footnote";
  var REFERENCE_TYPE_SHORTCUT = "shortcut";
  var REFERENCE_TYPE_COLLAPSED = "collapsed";
  var REFERENCE_TYPE_FULL = "full";
  var C_CARET = "^";
  var C_BACKSLASH = "\\";
  var C_BRACKET_OPEN = "[";
  var C_BRACKET_CLOSE = "]";
  function reference(eat, value, silent) {
    var self2 = this;
    var character = value.charAt(0);
    var index2 = 0;
    var length = value.length;
    var subvalue = "";
    var intro = "";
    var type2 = T_LINK;
    var referenceType = REFERENCE_TYPE_SHORTCUT;
    var content;
    var identifier;
    var now2;
    var node3;
    var exit;
    var queue2;
    var bracketed;
    var depth;
    if (character === "!") {
      type2 = T_IMAGE;
      intro = character;
      character = value.charAt(++index2);
    }
    if (character !== C_BRACKET_OPEN) {
      return;
    }
    index2++;
    intro += character;
    queue2 = "";
    if (self2.options.footnotes && value.charAt(index2) === C_CARET) {
      if (type2 === T_IMAGE) {
        return;
      }
      intro += C_CARET;
      index2++;
      type2 = T_FOOTNOTE;
    }
    depth = 0;
    while (index2 < length) {
      character = value.charAt(index2);
      if (character === C_BRACKET_OPEN) {
        bracketed = true;
        depth++;
      } else if (character === C_BRACKET_CLOSE) {
        if (!depth) {
          break;
        }
        depth--;
      }
      if (character === C_BACKSLASH) {
        queue2 += C_BACKSLASH;
        character = value.charAt(++index2);
      }
      queue2 += character;
      index2++;
    }
    subvalue = queue2;
    content = queue2;
    character = value.charAt(index2);
    if (character !== C_BRACKET_CLOSE) {
      return;
    }
    index2++;
    subvalue += character;
    queue2 = "";
    while (index2 < length) {
      character = value.charAt(index2);
      if (!whitespace(character)) {
        break;
      }
      queue2 += character;
      index2++;
    }
    character = value.charAt(index2);
    if (type2 !== T_FOOTNOTE && character === C_BRACKET_OPEN) {
      identifier = "";
      queue2 += character;
      index2++;
      while (index2 < length) {
        character = value.charAt(index2);
        if (character === C_BRACKET_OPEN || character === C_BRACKET_CLOSE) {
          break;
        }
        if (character === C_BACKSLASH) {
          identifier += C_BACKSLASH;
          character = value.charAt(++index2);
        }
        identifier += character;
        index2++;
      }
      character = value.charAt(index2);
      if (character === C_BRACKET_CLOSE) {
        referenceType = identifier ? REFERENCE_TYPE_FULL : REFERENCE_TYPE_COLLAPSED;
        queue2 += identifier + character;
        index2++;
      } else {
        identifier = "";
      }
      subvalue += queue2;
      queue2 = "";
    } else {
      if (!content) {
        return;
      }
      identifier = content;
    }
    if (referenceType !== REFERENCE_TYPE_FULL && bracketed) {
      return;
    }
    subvalue = intro + subvalue;
    if (type2 === T_LINK && self2.inLink) {
      return null;
    }
    if (silent) {
      return true;
    }
    if (type2 === T_FOOTNOTE && content.indexOf(" ") !== -1) {
      return eat(subvalue)({
        type: "footnote",
        children: this.tokenizeInline(content, eat.now())
      });
    }
    now2 = eat.now();
    now2.column += intro.length;
    now2.offset += intro.length;
    identifier = referenceType === REFERENCE_TYPE_FULL ? identifier : content;
    node3 = {
      type: type2 + "Reference",
      identifier: normalize4(identifier)
    };
    if (type2 === T_LINK || type2 === T_IMAGE) {
      node3.referenceType = referenceType;
    }
    if (type2 === T_LINK) {
      exit = self2.enterLink();
      node3.children = self2.tokenizeInline(content, now2);
      exit();
    } else if (type2 === T_IMAGE) {
      node3.alt = self2.decode.raw(self2.unescape(content), now2) || null;
    }
    return eat(subvalue)(node3);
  }
  return reference_1;
}
var strong;
var hasRequiredStrong$1;
function requireStrong$1() {
  if (hasRequiredStrong$1) return strong;
  hasRequiredStrong$1 = 1;
  strong = locate;
  function locate(value, fromIndex) {
    var asterisk = value.indexOf("**", fromIndex);
    var underscore = value.indexOf("__", fromIndex);
    if (underscore === -1) {
      return asterisk;
    }
    if (asterisk === -1) {
      return underscore;
    }
    return underscore < asterisk ? underscore : asterisk;
  }
  return strong;
}
var strong_1;
var hasRequiredStrong;
function requireStrong() {
  if (hasRequiredStrong) return strong_1;
  hasRequiredStrong = 1;
  var trim2 = requireTrim();
  var whitespace = requireIsWhitespaceCharacter();
  var locate = requireStrong$1();
  strong_1 = strong2;
  strong2.locator = locate;
  var C_ASTERISK = "*";
  var C_UNDERSCORE = "_";
  function strong2(eat, value, silent) {
    var self2 = this;
    var index2 = 0;
    var character = value.charAt(index2);
    var now2;
    var pedantic;
    var marker;
    var queue2;
    var subvalue;
    var length;
    var prev;
    if (character !== C_ASTERISK && character !== C_UNDERSCORE || value.charAt(++index2) !== character) {
      return;
    }
    pedantic = self2.options.pedantic;
    marker = character;
    subvalue = marker + marker;
    length = value.length;
    index2++;
    queue2 = "";
    character = "";
    if (pedantic && whitespace(value.charAt(index2))) {
      return;
    }
    while (index2 < length) {
      prev = character;
      character = value.charAt(index2);
      if (character === marker && value.charAt(index2 + 1) === marker && (!pedantic || !whitespace(prev))) {
        character = value.charAt(index2 + 2);
        if (character !== marker) {
          if (!trim2(queue2)) {
            return;
          }
          if (silent) {
            return true;
          }
          now2 = eat.now();
          now2.column += 2;
          now2.offset += 2;
          return eat(subvalue + queue2 + subvalue)({
            type: "strong",
            children: self2.tokenizeInline(queue2, now2)
          });
        }
      }
      if (!pedantic && character === "\\") {
        queue2 += character;
        character = value.charAt(++index2);
      }
      queue2 += character;
      index2++;
    }
  }
  return strong_1;
}
var isWordCharacter2;
var hasRequiredIsWordCharacter;
function requireIsWordCharacter() {
  if (hasRequiredIsWordCharacter) return isWordCharacter2;
  hasRequiredIsWordCharacter = 1;
  isWordCharacter2 = wordCharacter;
  var fromCode = String.fromCharCode;
  var re2 = /\w/;
  function wordCharacter(character) {
    return re2.test(
      typeof character === "number" ? fromCode(character) : character.charAt(0)
    );
  }
  return isWordCharacter2;
}
var emphasis;
var hasRequiredEmphasis$1;
function requireEmphasis$1() {
  if (hasRequiredEmphasis$1) return emphasis;
  hasRequiredEmphasis$1 = 1;
  emphasis = locate;
  function locate(value, fromIndex) {
    var asterisk = value.indexOf("*", fromIndex);
    var underscore = value.indexOf("_", fromIndex);
    if (underscore === -1) {
      return asterisk;
    }
    if (asterisk === -1) {
      return underscore;
    }
    return underscore < asterisk ? underscore : asterisk;
  }
  return emphasis;
}
var emphasis_1;
var hasRequiredEmphasis;
function requireEmphasis() {
  if (hasRequiredEmphasis) return emphasis_1;
  hasRequiredEmphasis = 1;
  var trim2 = requireTrim();
  var word = requireIsWordCharacter();
  var whitespace = requireIsWhitespaceCharacter();
  var locate = requireEmphasis$1();
  emphasis_1 = emphasis2;
  emphasis2.locator = locate;
  var C_ASTERISK = "*";
  var C_UNDERSCORE = "_";
  function emphasis2(eat, value, silent) {
    var self2 = this;
    var index2 = 0;
    var character = value.charAt(index2);
    var now2;
    var pedantic;
    var marker;
    var queue2;
    var subvalue;
    var length;
    var prev;
    if (character !== C_ASTERISK && character !== C_UNDERSCORE) {
      return;
    }
    pedantic = self2.options.pedantic;
    subvalue = character;
    marker = character;
    length = value.length;
    index2++;
    queue2 = "";
    character = "";
    if (pedantic && whitespace(value.charAt(index2))) {
      return;
    }
    while (index2 < length) {
      prev = character;
      character = value.charAt(index2);
      if (character === marker && (!pedantic || !whitespace(prev))) {
        character = value.charAt(++index2);
        if (character !== marker) {
          if (!trim2(queue2) || prev === marker) {
            return;
          }
          if (!pedantic && marker === C_UNDERSCORE && word(character)) {
            queue2 += marker;
            continue;
          }
          if (silent) {
            return true;
          }
          now2 = eat.now();
          now2.column++;
          now2.offset++;
          return eat(subvalue + queue2 + marker)({
            type: "emphasis",
            children: self2.tokenizeInline(queue2, now2)
          });
        }
        queue2 += marker;
      }
      if (!pedantic && character === "\\") {
        queue2 += character;
        character = value.charAt(++index2);
      }
      queue2 += character;
      index2++;
    }
  }
  return emphasis_1;
}
var _delete$1;
var hasRequired_delete$1;
function require_delete$1() {
  if (hasRequired_delete$1) return _delete$1;
  hasRequired_delete$1 = 1;
  _delete$1 = locate;
  function locate(value, fromIndex) {
    return value.indexOf("~~", fromIndex);
  }
  return _delete$1;
}
var _delete;
var hasRequired_delete;
function require_delete() {
  if (hasRequired_delete) return _delete;
  hasRequired_delete = 1;
  var whitespace = requireIsWhitespaceCharacter();
  var locate = require_delete$1();
  _delete = strikethrough;
  strikethrough.locator = locate;
  var C_TILDE = "~";
  var DOUBLE = "~~";
  function strikethrough(eat, value, silent) {
    var self2 = this;
    var character = "";
    var previous3 = "";
    var preceding = "";
    var subvalue = "";
    var index2;
    var length;
    var now2;
    if (!self2.options.gfm || value.charAt(0) !== C_TILDE || value.charAt(1) !== C_TILDE || whitespace(value.charAt(2))) {
      return;
    }
    index2 = 1;
    length = value.length;
    now2 = eat.now();
    now2.column += 2;
    now2.offset += 2;
    while (++index2 < length) {
      character = value.charAt(index2);
      if (character === C_TILDE && previous3 === C_TILDE && (!preceding || !whitespace(preceding))) {
        if (silent) {
          return true;
        }
        return eat(DOUBLE + subvalue + DOUBLE)({
          type: "delete",
          children: self2.tokenizeInline(subvalue, now2)
        });
      }
      subvalue += previous3;
      preceding = previous3;
      previous3 = character;
    }
  }
  return _delete;
}
var codeInline$1;
var hasRequiredCodeInline$1;
function requireCodeInline$1() {
  if (hasRequiredCodeInline$1) return codeInline$1;
  hasRequiredCodeInline$1 = 1;
  codeInline$1 = locate;
  function locate(value, fromIndex) {
    return value.indexOf("`", fromIndex);
  }
  return codeInline$1;
}
var codeInline;
var hasRequiredCodeInline;
function requireCodeInline() {
  if (hasRequiredCodeInline) return codeInline;
  hasRequiredCodeInline = 1;
  var whitespace = requireIsWhitespaceCharacter();
  var locate = requireCodeInline$1();
  codeInline = inlineCode;
  inlineCode.locator = locate;
  var C_TICK = "`";
  function inlineCode(eat, value, silent) {
    var length = value.length;
    var index2 = 0;
    var queue2 = "";
    var tickQueue = "";
    var contentQueue;
    var subqueue;
    var count;
    var openingCount;
    var subvalue;
    var character;
    var found;
    var next3;
    while (index2 < length) {
      if (value.charAt(index2) !== C_TICK) {
        break;
      }
      queue2 += C_TICK;
      index2++;
    }
    if (!queue2) {
      return;
    }
    subvalue = queue2;
    openingCount = index2;
    queue2 = "";
    next3 = value.charAt(index2);
    count = 0;
    while (index2 < length) {
      character = next3;
      next3 = value.charAt(index2 + 1);
      if (character === C_TICK) {
        count++;
        tickQueue += character;
      } else {
        count = 0;
        queue2 += character;
      }
      if (count && next3 !== C_TICK) {
        if (count === openingCount) {
          subvalue += queue2 + tickQueue;
          found = true;
          break;
        }
        queue2 += tickQueue;
        tickQueue = "";
      }
      index2++;
    }
    if (!found) {
      if (openingCount % 2 !== 0) {
        return;
      }
      queue2 = "";
    }
    if (silent) {
      return true;
    }
    contentQueue = "";
    subqueue = "";
    length = queue2.length;
    index2 = -1;
    while (++index2 < length) {
      character = queue2.charAt(index2);
      if (whitespace(character)) {
        subqueue += character;
        continue;
      }
      if (subqueue) {
        if (contentQueue) {
          contentQueue += subqueue;
        }
        subqueue = "";
      }
      contentQueue += character;
    }
    return eat(subvalue)({
      type: "inlineCode",
      value: contentQueue
    });
  }
  return codeInline;
}
var _break$1;
var hasRequired_break$1;
function require_break$1() {
  if (hasRequired_break$1) return _break$1;
  hasRequired_break$1 = 1;
  _break$1 = locate;
  function locate(value, fromIndex) {
    var index2 = value.indexOf("\n", fromIndex);
    while (index2 > fromIndex) {
      if (value.charAt(index2 - 1) !== " ") {
        break;
      }
      index2--;
    }
    return index2;
  }
  return _break$1;
}
var _break;
var hasRequired_break;
function require_break() {
  if (hasRequired_break) return _break;
  hasRequired_break = 1;
  var locate = require_break$1();
  _break = hardBreak;
  hardBreak.locator = locate;
  var MIN_BREAK_LENGTH = 2;
  function hardBreak(eat, value, silent) {
    var length = value.length;
    var index2 = -1;
    var queue2 = "";
    var character;
    while (++index2 < length) {
      character = value.charAt(index2);
      if (character === "\n") {
        if (index2 < MIN_BREAK_LENGTH) {
          return;
        }
        if (silent) {
          return true;
        }
        queue2 += character;
        return eat(queue2)({ type: "break" });
      }
      if (character !== " ") {
        return;
      }
      queue2 += character;
    }
  }
  return _break;
}
var text_1;
var hasRequiredText;
function requireText() {
  if (hasRequiredText) return text_1;
  hasRequiredText = 1;
  text_1 = text;
  function text(eat, value, silent) {
    var self2 = this;
    var methods;
    var tokenizers;
    var index2;
    var length;
    var subvalue;
    var position2;
    var tokenizer2;
    var name2;
    var min2;
    var now2;
    if (silent) {
      return true;
    }
    methods = self2.inlineMethods;
    length = methods.length;
    tokenizers = self2.inlineTokenizers;
    index2 = -1;
    min2 = value.length;
    while (++index2 < length) {
      name2 = methods[index2];
      if (name2 === "text" || !tokenizers[name2]) {
        continue;
      }
      tokenizer2 = tokenizers[name2].locator;
      if (!tokenizer2) {
        eat.file.fail("Missing locator: `" + name2 + "`");
      }
      position2 = tokenizer2.call(self2, value, 1);
      if (position2 !== -1 && position2 < min2) {
        min2 = position2;
      }
    }
    subvalue = value.slice(0, min2);
    now2 = eat.now();
    self2.decode(subvalue, now2, function(content, position3, source) {
      eat(source || content)({
        type: "text",
        value: content
      });
    });
  }
  return text_1;
}
var xtend$4 = immutable;
var toggle = stateToggle;
var vfileLocation = vfileLocation$1;
var unescape = _unescape;
var decode = decode$1;
var tokenizer = tokenizer$1;
var parser = Parser$2;
function Parser$2(doc, file) {
  this.file = file;
  this.offset = {};
  this.options = xtend$4(this.options);
  this.setOptions({});
  this.inList = false;
  this.inBlock = false;
  this.inLink = false;
  this.atStart = true;
  this.toOffset = vfileLocation(file).toOffset;
  this.unescape = unescape(this, "escape");
  this.decode = decode(this);
}
var proto$3 = Parser$2.prototype;
proto$3.setOptions = requireSetOptions();
proto$3.parse = requireParse();
proto$3.options = requireDefaults();
proto$3.exitStart = toggle("atStart", true);
proto$3.enterList = toggle("inList", false);
proto$3.enterLink = toggle("inLink", false);
proto$3.enterBlock = toggle("inBlock", false);
proto$3.interruptParagraph = [
  ["thematicBreak"],
  ["atxHeading"],
  ["fencedCode"],
  ["blockquote"],
  ["html"],
  ["setextHeading", { commonmark: false }],
  ["definition", { commonmark: false }],
  ["footnote", { commonmark: false }]
];
proto$3.interruptList = [
  ["atxHeading", { pedantic: false }],
  ["fencedCode", { pedantic: false }],
  ["thematicBreak", { pedantic: false }],
  ["definition", { commonmark: false }],
  ["footnote", { commonmark: false }]
];
proto$3.interruptBlockquote = [
  ["indentedCode", { commonmark: true }],
  ["fencedCode", { commonmark: true }],
  ["atxHeading", { commonmark: true }],
  ["setextHeading", { commonmark: true }],
  ["thematicBreak", { commonmark: true }],
  ["html", { commonmark: true }],
  ["list", { commonmark: true }],
  ["definition", { commonmark: false }],
  ["footnote", { commonmark: false }]
];
proto$3.blockTokenizers = {
  newline: requireNewline(),
  indentedCode: requireCodeIndented(),
  fencedCode: requireCodeFenced(),
  blockquote: requireBlockquote(),
  atxHeading: requireHeadingAtx(),
  thematicBreak: requireThematicBreak(),
  list: requireList(),
  setextHeading: requireHeadingSetext(),
  html: requireHtmlBlock(),
  footnote: requireFootnoteDefinition(),
  definition: requireDefinition(),
  table: requireTable(),
  paragraph: requireParagraph()
};
proto$3.inlineTokenizers = {
  escape: require_escape(),
  autoLink: requireAutoLink(),
  url: requireUrl(),
  html: requireHtmlInline(),
  link: requireLink(),
  reference: requireReference(),
  strong: requireStrong(),
  emphasis: requireEmphasis(),
  deletion: require_delete(),
  code: requireCodeInline(),
  break: require_break(),
  text: requireText()
};
proto$3.blockMethods = keys$2(proto$3.blockTokenizers);
proto$3.inlineMethods = keys$2(proto$3.inlineTokenizers);
proto$3.tokenizeBlock = tokenizer("block");
proto$3.tokenizeInline = tokenizer("inline");
proto$3.tokenizeFactory = tokenizer;
function keys$2(value) {
  var result2 = [];
  var key2;
  for (key2 in value) {
    result2.push(key2);
  }
  return result2;
}
var unherit = unherit_1;
var xtend$3 = immutable;
var Parser$1 = parser;
var remarkParse = parse$2;
parse$2.Parser = Parser$1;
function parse$2(options) {
  var Local = unherit(Parser$1);
  Local.prototype.options = xtend$3(Local.prototype.options, this.data("settings"), options);
  this.Parser = Local;
}
var unistUtilVisitParents$1 = visitParents$2;
function visitParents$2(tree, type2, visitor) {
  var stack = [];
  if (typeof type2 === "function") {
    visitor = type2;
    type2 = null;
  }
  one(tree);
  function one(node3) {
    var result2;
    if (!type2 || node3.type === type2) {
      result2 = visitor(node3, stack.concat());
    }
    if (node3.children && result2 !== false) {
      return all(node3.children, node3);
    }
    return result2;
  }
  function all(children, parent3) {
    var length = children.length;
    var index2 = -1;
    var child;
    stack.push(parent3);
    while (++index2 < length) {
      child = children[index2];
      if (child && one(child) === false) {
        return false;
      }
    }
    stack.pop();
    return true;
  }
}
var visitWithParents = unistUtilVisitParents$1;
function addListMetadata$1() {
  return function(ast) {
    visitWithParents(ast, "list", function(listNode, parents) {
      var depth = 0, i3, n2;
      for (i3 = 0, n2 = parents.length; i3 < n2; i3++) {
        if (parents[i3].type === "list") depth += 1;
      }
      for (i3 = 0, n2 = listNode.children.length; i3 < n2; i3++) {
        var child = listNode.children[i3];
        child.index = i3;
        child.ordered = listNode.ordered;
      }
      listNode.depth = depth;
    });
    return ast;
  };
}
var mdastAddListMetadata = addListMetadata$1;
var convert_1 = convert$1;
function convert$1(test2) {
  if (typeof test2 === "string") {
    return typeFactory(test2);
  }
  if (test2 === null || test2 === void 0) {
    return ok;
  }
  if (typeof test2 === "object") {
    return ("length" in test2 ? anyFactory : matchesFactory)(test2);
  }
  if (typeof test2 === "function") {
    return test2;
  }
  throw new Error("Expected function, string, or object as test");
}
function convertAll(tests2) {
  var results = [];
  var length = tests2.length;
  var index2 = -1;
  while (++index2 < length) {
    results[index2] = convert$1(tests2[index2]);
  }
  return results;
}
function matchesFactory(test2) {
  return matches2;
  function matches2(node3) {
    var key2;
    for (key2 in test2) {
      if (node3[key2] !== test2[key2]) {
        return false;
      }
    }
    return true;
  }
}
function anyFactory(tests2) {
  var checks = convertAll(tests2);
  var length = checks.length;
  return matches2;
  function matches2() {
    var index2 = -1;
    while (++index2 < length) {
      if (checks[index2].apply(this, arguments)) {
        return true;
      }
    }
    return false;
  }
}
function typeFactory(test2) {
  return type2;
  function type2(node3) {
    return Boolean(node3 && node3.type === test2);
  }
}
function ok() {
  return true;
}
var unistUtilVisitParents = visitParents$1;
var convert = convert_1;
var CONTINUE$1 = true;
var SKIP$1 = "skip";
var EXIT$1 = false;
visitParents$1.CONTINUE = CONTINUE$1;
visitParents$1.SKIP = SKIP$1;
visitParents$1.EXIT = EXIT$1;
function visitParents$1(tree, test2, visitor, reverse) {
  var is3;
  if (typeof test2 === "function" && typeof visitor !== "function") {
    reverse = visitor;
    visitor = test2;
    test2 = null;
  }
  is3 = convert(test2);
  one(tree, null, []);
  function one(node3, index2, parents) {
    var result2 = [];
    var subresult;
    if (!test2 || is3(node3, index2, parents[parents.length - 1] || null)) {
      result2 = toResult(visitor(node3, parents));
      if (result2[0] === EXIT$1) {
        return result2;
      }
    }
    if (node3.children && result2[0] !== SKIP$1) {
      subresult = toResult(all(node3.children, parents.concat(node3)));
      return subresult[0] === EXIT$1 ? subresult : result2;
    }
    return result2;
  }
  function all(children, parents) {
    var min2 = -1;
    var step2 = reverse ? -1 : 1;
    var index2 = (reverse ? children.length : min2) + step2;
    var result2;
    while (index2 > min2 && index2 < children.length) {
      result2 = one(children[index2], index2, parents);
      if (result2[0] === EXIT$1) {
        return result2;
      }
      index2 = typeof result2[1] === "number" ? result2[1] : index2 + step2;
    }
  }
}
function toResult(value) {
  if (value !== null && typeof value === "object" && "length" in value) {
    return value;
  }
  if (typeof value === "number") {
    return [CONTINUE$1, value];
  }
  return [value];
}
var unistUtilVisit = visit$3;
var visitParents = unistUtilVisitParents;
var CONTINUE = visitParents.CONTINUE;
var SKIP = visitParents.SKIP;
var EXIT = visitParents.EXIT;
visit$3.CONTINUE = CONTINUE;
visit$3.SKIP = SKIP;
visit$3.EXIT = EXIT;
function visit$3(tree, test2, visitor, reverse) {
  if (typeof test2 === "function" && typeof visitor !== "function") {
    reverse = visitor;
    visitor = test2;
    test2 = null;
  }
  visitParents(tree, test2, overload, reverse);
  function overload(node3, parents) {
    var parent3 = parents[parents.length - 1];
    var index2 = parent3 ? parent3.children.indexOf(node3) : null;
    return visitor(node3, index2, parent3);
  }
}
var visit$2 = unistUtilVisit;
var type$1 = "virtualHtml";
var selfClosingRe = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i;
var simpleTagRe = /^<(\/?)([a-z]+)\s*>$/;
var naiveHtml$1 = function(tree) {
  var open;
  var currentParent;
  visit$2(
    tree,
    "html",
    function(node3, index2, parent3) {
      if (currentParent !== parent3) {
        open = [];
        currentParent = parent3;
      }
      var selfClosing = getSelfClosing(node3);
      if (selfClosing) {
        parent3.children.splice(index2, 1, {
          type: type$1,
          tag: selfClosing,
          position: node3.position
        });
        return true;
      }
      var current2 = getSimpleTag(node3);
      if (!current2) {
        return true;
      }
      var matching = findAndPull(open, current2.tag);
      if (matching) {
        parent3.children.splice(index2, 0, virtual(current2, matching, parent3));
      } else if (!current2.opening) {
        open.push(current2);
      }
      return true;
    },
    true
    // Iterate in reverse
  );
  return tree;
};
function findAndPull(open, matchingTag) {
  var i3 = open.length;
  while (i3--) {
    if (open[i3].tag === matchingTag) {
      return open.splice(i3, 1)[0];
    }
  }
  return false;
}
function getSimpleTag(node3, parent3) {
  var match5 = node3.value.match(simpleTagRe);
  return match5 ? {
    tag: match5[2],
    opening: !match5[1],
    node: node3
  } : false;
}
function getSelfClosing(node3) {
  var match5 = node3.value.match(selfClosingRe);
  return match5 ? match5[1] : false;
}
function virtual(fromNode, toNode, parent3) {
  var fromIndex = parent3.children.indexOf(fromNode.node);
  var toIndex = parent3.children.indexOf(toNode.node);
  var extracted = parent3.children.splice(fromIndex, toIndex - fromIndex + 1);
  var children = extracted.slice(1, -1);
  return {
    type: type$1,
    children,
    tag: fromNode.tag,
    position: {
      start: fromNode.node.position.start,
      end: toNode.node.position.end,
      indent: []
    }
  };
}
var disallowNode$1 = {};
var visit$1 = unistUtilVisit;
disallowNode$1.ofType = function(types2, mode) {
  return function(node3) {
    types2.forEach(function(type2) {
      return visit$1(node3, type2, disallow, true);
    });
    return node3;
  };
  function disallow(node3, index2, parent3) {
    if (parent3) {
      untangle(node3, index2, parent3, mode);
    }
  }
};
disallowNode$1.ifNotMatch = function(allowNode, mode) {
  return function(node3) {
    visit$1(node3, disallow, true);
    return node3;
  };
  function disallow(node3, index2, parent3) {
    if (parent3 && !allowNode(node3, index2, parent3)) {
      untangle(node3, index2, parent3, mode);
    }
  }
};
function untangle(node3, index2, parent3, mode) {
  if (mode === "remove") {
    parent3.children.splice(index2, 1);
  } else if (mode === "unwrap") {
    var args = [index2, 1];
    if (node3.children) {
      args = args.concat(node3.children);
    }
    Array.prototype.splice.apply(parent3.children, args);
  }
}
var React$1 = React__default;
var xtend$2 = immutable;
var ReactIs = requireReactIs();
var defaultNodePosition = {
  start: {
    line: 1,
    column: 1,
    offset: 0
  },
  end: {
    line: 1,
    column: 1,
    offset: 0
  }
};
function astToReact$1(node3, options) {
  var parent3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var index2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  var renderer = options.renderers[node3.type];
  if (node3.position === void 0) {
    node3.position = parent3.node && parent3.node.position || defaultNodePosition;
  }
  var pos = node3.position.start;
  var key2 = [node3.type, pos.line, pos.column, index2].join("-");
  if (!ReactIs.isValidElementType(renderer)) {
    throw new Error("Renderer for type `".concat(node3.type, "` not defined or is not renderable"));
  }
  var nodeProps = getNodeProps(node3, key2, options, renderer, parent3, index2);
  return React$1.createElement(renderer, nodeProps, nodeProps.children || resolveChildren() || void 0);
  function resolveChildren() {
    return node3.children && node3.children.map(function(childNode, i3) {
      return astToReact$1(childNode, options, {
        node: node3,
        props: nodeProps
      }, i3);
    });
  }
}
function getNodeProps(node3, key2, opts, renderer, parent3, index2) {
  var props2 = {
    key: key2
  };
  var isTagRenderer = typeof renderer === "string";
  if (opts.sourcePos && node3.position) {
    props2["data-sourcepos"] = flattenPosition(node3.position);
  }
  if (opts.rawSourcePos && !isTagRenderer) {
    props2.sourcePosition = node3.position;
  }
  if (opts.includeNodeIndex && parent3.node && parent3.node.children && !isTagRenderer) {
    props2.index = parent3.node.children.indexOf(node3);
    props2.parentChildCount = parent3.node.children.length;
  }
  var ref2 = node3.identifier !== null && node3.identifier !== void 0 ? opts.definitions[node3.identifier] || {} : null;
  switch (node3.type) {
    case "root":
      assignDefined(props2, {
        className: opts.className
      });
      break;
    case "text":
      props2.nodeKey = key2;
      props2.children = node3.value;
      break;
    case "heading":
      props2.level = node3.depth;
      break;
    case "list":
      props2.start = node3.start;
      props2.ordered = node3.ordered;
      props2.tight = !node3.loose;
      props2.depth = node3.depth;
      break;
    case "listItem":
      props2.checked = node3.checked;
      props2.tight = !node3.loose;
      props2.ordered = node3.ordered;
      props2.index = node3.index;
      props2.children = getListItemChildren(node3, parent3).map(function(childNode, i3) {
        return astToReact$1(childNode, opts, {
          node: node3,
          props: props2
        }, i3);
      });
      break;
    case "definition":
      assignDefined(props2, {
        identifier: node3.identifier,
        title: node3.title,
        url: node3.url
      });
      break;
    case "code":
      assignDefined(props2, {
        language: node3.lang && node3.lang.split(/\s/, 1)[0]
      });
      break;
    case "inlineCode":
      props2.children = node3.value;
      props2.inline = true;
      break;
    case "link":
      assignDefined(props2, {
        title: node3.title || void 0,
        target: typeof opts.linkTarget === "function" ? opts.linkTarget(node3.url, node3.children, node3.title) : opts.linkTarget,
        href: opts.transformLinkUri ? opts.transformLinkUri(node3.url, node3.children, node3.title) : node3.url
      });
      break;
    case "image":
      assignDefined(props2, {
        alt: node3.alt || void 0,
        title: node3.title || void 0,
        src: opts.transformImageUri ? opts.transformImageUri(node3.url, node3.children, node3.title, node3.alt) : node3.url
      });
      break;
    case "linkReference":
      assignDefined(props2, xtend$2(ref2, {
        href: opts.transformLinkUri ? opts.transformLinkUri(ref2.href) : ref2.href
      }));
      break;
    case "imageReference":
      assignDefined(props2, {
        src: opts.transformImageUri && ref2.href ? opts.transformImageUri(ref2.href, node3.children, ref2.title, node3.alt) : ref2.href,
        title: ref2.title || void 0,
        alt: node3.alt || void 0
      });
      break;
    case "table":
    case "tableHead":
    case "tableBody":
      props2.columnAlignment = node3.align;
      break;
    case "tableRow":
      props2.isHeader = parent3.node.type === "tableHead";
      props2.columnAlignment = parent3.props.columnAlignment;
      break;
    case "tableCell":
      assignDefined(props2, {
        isHeader: parent3.props.isHeader,
        align: parent3.props.columnAlignment[index2]
      });
      break;
    case "virtualHtml":
      props2.tag = node3.tag;
      break;
    case "html":
      props2.isBlock = node3.position.start.line !== node3.position.end.line;
      props2.escapeHtml = opts.escapeHtml;
      props2.skipHtml = opts.skipHtml;
      break;
    case "parsedHtml": {
      var parsedChildren;
      if (node3.children) {
        parsedChildren = node3.children.map(function(child, i3) {
          return astToReact$1(child, opts, {
            node: node3,
            props: props2
          }, i3);
        });
      }
      props2.escapeHtml = opts.escapeHtml;
      props2.skipHtml = opts.skipHtml;
      props2.element = mergeNodeChildren(node3, parsedChildren);
      break;
    }
    default:
      assignDefined(props2, xtend$2(node3, {
        type: void 0,
        position: void 0,
        children: void 0
      }));
  }
  if (!isTagRenderer && node3.value) {
    props2.value = node3.value;
  }
  return props2;
}
function assignDefined(target, attrs) {
  for (var key2 in attrs) {
    if (typeof attrs[key2] !== "undefined") {
      target[key2] = attrs[key2];
    }
  }
}
function mergeNodeChildren(node3, parsedChildren) {
  var el2 = node3.element;
  if (Array.isArray(el2)) {
    var Fragment2 = React$1.Fragment || "div";
    return React$1.createElement(Fragment2, null, el2);
  }
  if (el2.props.children || parsedChildren) {
    var children = React$1.Children.toArray(el2.props.children).concat(parsedChildren);
    return React$1.cloneElement(el2, null, children);
  }
  return React$1.cloneElement(el2, null);
}
function flattenPosition(pos) {
  return [pos.start.line, ":", pos.start.column, "-", pos.end.line, ":", pos.end.column].map(String).join("");
}
function getListItemChildren(node3, parent3) {
  if (node3.loose) {
    return node3.children;
  }
  if (parent3.node && node3.index > 0 && parent3.node.children[node3.index - 1].loose) {
    return node3.children;
  }
  return unwrapParagraphs(node3);
}
function unwrapParagraphs(node3) {
  return node3.children.reduce(function(array, child) {
    return array.concat(child.type === "paragraph" ? child.children || [] : [child]);
  }, []);
}
var astToReact_1 = astToReact$1;
var visit = unistUtilVisit;
var wrapTableRows$1 = function(node3) {
  visit(node3, "table", wrap);
  return node3;
};
function wrap(table) {
  var children = table.children;
  table.children = [{
    type: "tableHead",
    align: table.align,
    children: [children[0]],
    position: children[0].position
  }];
  if (children.length > 1) {
    table.children.push({
      type: "tableBody",
      align: table.align,
      children: children.slice(1),
      position: {
        start: children[1].position.start,
        end: children[children.length - 1].position.end
      }
    });
  }
}
var getDefinitions$1 = function getDefinitions(node3) {
  var defs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return (node3.children || []).reduce(function(definitions2, child) {
    if (child.type === "definition") {
      definitions2[child.identifier] = {
        href: child.url,
        title: child.title
      };
    }
    return getDefinitions(child, definitions2);
  }, defs);
};
var protocols = ["http", "https", "mailto", "tel"];
var uriTransformer$1 = function uriTransformer(uri2) {
  var url2 = (uri2 || "").trim();
  var first2 = url2.charAt(0);
  if (first2 === "#" || first2 === "/") {
    return url2;
  }
  var colon = url2.indexOf(":");
  if (colon === -1) {
    return url2;
  }
  var length = protocols.length;
  var index2 = -1;
  while (++index2 < length) {
    var protocol = protocols[index2];
    if (colon === protocol.length && url2.slice(0, protocol.length).toLowerCase() === protocol) {
      return url2;
    }
  }
  index2 = url2.indexOf("?");
  if (index2 !== -1 && colon > index2) {
    return url2;
  }
  index2 = url2.indexOf("#");
  if (index2 !== -1 && colon > index2) {
    return url2;
  }
  return "javascript:void(0)";
};
var xtend$1 = immutable;
var React = React__default;
var supportsStringRender = parseInt((React.version || "16").slice(0, 2), 10) >= 16;
var createElement = React.createElement;
var renderers = {
  break: "br",
  paragraph: "p",
  emphasis: "em",
  strong: "strong",
  thematicBreak: "hr",
  blockquote: "blockquote",
  delete: "del",
  link: "a",
  image: "img",
  linkReference: "a",
  imageReference: "img",
  table: SimpleRenderer.bind(null, "table"),
  tableHead: SimpleRenderer.bind(null, "thead"),
  tableBody: SimpleRenderer.bind(null, "tbody"),
  tableRow: SimpleRenderer.bind(null, "tr"),
  tableCell: TableCell,
  root: Root,
  text: TextRenderer,
  list: List,
  listItem: ListItem,
  definition: NullRenderer,
  heading: Heading,
  inlineCode: InlineCode,
  code: CodeBlock,
  html: Html,
  virtualHtml: VirtualHtml,
  parsedHtml: ParsedHtml
};
function TextRenderer(props2) {
  return supportsStringRender ? props2.children : createElement("span", null, props2.children);
}
function Root(props2) {
  var useFragment = !props2.className;
  var root2 = useFragment ? React.Fragment || "div" : "div";
  return createElement(root2, useFragment ? null : props2, props2.children);
}
function SimpleRenderer(tag2, props2) {
  return createElement(tag2, getCoreProps(props2), props2.children);
}
function TableCell(props2) {
  var style2 = props2.align ? {
    textAlign: props2.align
  } : void 0;
  var coreProps = getCoreProps(props2);
  return createElement(props2.isHeader ? "th" : "td", style2 ? xtend$1({
    style: style2
  }, coreProps) : coreProps, props2.children);
}
function Heading(props2) {
  return createElement("h".concat(props2.level), getCoreProps(props2), props2.children);
}
function List(props2) {
  var attrs = getCoreProps(props2);
  if (props2.start !== null && props2.start !== 1 && props2.start !== void 0) {
    attrs.start = props2.start.toString();
  }
  return createElement(props2.ordered ? "ol" : "ul", attrs, props2.children);
}
function ListItem(props2) {
  var checkbox = null;
  if (props2.checked !== null && props2.checked !== void 0) {
    var checked = props2.checked;
    checkbox = createElement("input", {
      type: "checkbox",
      checked,
      readOnly: true
    });
  }
  return createElement("li", getCoreProps(props2), checkbox, props2.children);
}
function CodeBlock(props2) {
  var className = props2.language && "language-".concat(props2.language);
  var code2 = createElement("code", className ? {
    className
  } : null, props2.value);
  return createElement("pre", getCoreProps(props2), code2);
}
function InlineCode(props2) {
  return createElement("code", getCoreProps(props2), props2.children);
}
function Html(props2) {
  if (props2.skipHtml) {
    return null;
  }
  var tag2 = props2.isBlock ? "div" : "span";
  if (props2.escapeHtml) {
    var comp = React.Fragment || tag2;
    return createElement(comp, null, props2.value);
  }
  var nodeProps = {
    dangerouslySetInnerHTML: {
      __html: props2.value
    }
  };
  return createElement(tag2, nodeProps);
}
function ParsedHtml(props2) {
  return props2["data-sourcepos"] ? React.cloneElement(props2.element, {
    "data-sourcepos": props2["data-sourcepos"]
  }) : props2.element;
}
function VirtualHtml(props2) {
  return createElement(props2.tag, getCoreProps(props2), props2.children);
}
function NullRenderer() {
  return null;
}
function getCoreProps(props2) {
  return props2["data-sourcepos"] ? {
    "data-sourcepos": props2["data-sourcepos"]
  } : {};
}
var symbols$1 = {};
var HtmlParser = "__RMD_HTML_PARSER__";
symbols$1.HtmlParser = typeof Symbol === "undefined" ? HtmlParser : Symbol(HtmlParser);
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i3 = 0, arr2 = new Array(arr.length); i3 < arr.length; i3++) {
      arr2[i3] = arr[i3];
    }
    return arr2;
  }
}
var xtend = immutable;
var unified = unified_1;
var parse$1 = remarkParse;
var PropTypes = propTypesExports;
var addListMetadata = mdastAddListMetadata;
var naiveHtml = naiveHtml$1;
var disallowNode = disallowNode$1;
var astToReact = astToReact_1;
var wrapTableRows = wrapTableRows$1;
var getDefinitions2 = getDefinitions$1;
var uriTransformer2 = uriTransformer$1;
var defaultRenderers = renderers;
var symbols = symbols$1;
var allTypes = Object.keys(defaultRenderers);
var ReactMarkdown = function ReactMarkdown2(props2) {
  var src2 = props2.source || props2.children || "";
  var parserOptions = props2.parserOptions;
  if (props2.allowedTypes && props2.disallowedTypes) {
    throw new Error("Only one of `allowedTypes` and `disallowedTypes` should be defined");
  }
  var renderers2 = xtend(defaultRenderers, props2.renderers);
  var plugins2 = [[parse$1, parserOptions]].concat(props2.plugins || []);
  var parser2 = plugins2.reduce(applyParserPlugin, unified());
  var rawAst = parser2.parse(src2);
  var renderProps = xtend(props2, {
    renderers: renderers2,
    definitions: getDefinitions2(rawAst)
  });
  var astPlugins = determineAstPlugins(props2);
  var transformedAst = parser2.runSync(rawAst);
  var ast = astPlugins.reduce(function(node3, plugin) {
    return plugin(node3, renderProps);
  }, transformedAst);
  return astToReact(ast, renderProps);
};
function applyParserPlugin(parser2, plugin) {
  return Array.isArray(plugin) ? parser2.use.apply(parser2, _toConsumableArray$1(plugin)) : parser2.use(plugin);
}
function determineAstPlugins(props2) {
  var plugins2 = [wrapTableRows, addListMetadata()];
  var disallowedTypes = props2.disallowedTypes;
  if (props2.allowedTypes) {
    disallowedTypes = allTypes.filter(function(type2) {
      return type2 !== "root" && props2.allowedTypes.indexOf(type2) === -1;
    });
  }
  var removalMethod = props2.unwrapDisallowed ? "unwrap" : "remove";
  if (disallowedTypes && disallowedTypes.length > 0) {
    plugins2.push(disallowNode.ofType(disallowedTypes, removalMethod));
  }
  if (props2.allowNode) {
    plugins2.push(disallowNode.ifNotMatch(props2.allowNode, removalMethod));
  }
  var renderHtml = !props2.escapeHtml && !props2.skipHtml;
  var hasHtmlParser = (props2.astPlugins || []).some(function(item) {
    var plugin = Array.isArray(item) ? item[0] : item;
    return plugin.identity === symbols.HtmlParser;
  });
  if (renderHtml && !hasHtmlParser) {
    plugins2.push(naiveHtml);
  }
  return props2.astPlugins ? plugins2.concat(props2.astPlugins) : plugins2;
}
ReactMarkdown.defaultProps = {
  renderers: {},
  escapeHtml: true,
  skipHtml: false,
  sourcePos: false,
  rawSourcePos: false,
  transformLinkUri: uriTransformer2,
  astPlugins: [],
  plugins: [],
  parserOptions: {}
};
ReactMarkdown.propTypes = {
  className: PropTypes.string,
  source: PropTypes.string,
  children: PropTypes.string,
  sourcePos: PropTypes.bool,
  rawSourcePos: PropTypes.bool,
  escapeHtml: PropTypes.bool,
  skipHtml: PropTypes.bool,
  allowNode: PropTypes.func,
  allowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
  disallowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
  transformLinkUri: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  linkTarget: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  transformImageUri: PropTypes.func,
  astPlugins: PropTypes.arrayOf(PropTypes.func),
  unwrapDisallowed: PropTypes.bool,
  renderers: PropTypes.object,
  plugins: PropTypes.array,
  parserOptions: PropTypes.object
};
ReactMarkdown.types = allTypes;
ReactMarkdown.renderers = defaultRenderers;
ReactMarkdown.uriTransformer = uriTransformer2;
var reactMarkdown = ReactMarkdown;
const Markdown = /* @__PURE__ */ getDefaultExportFromCjs$1(reactMarkdown);
const getFieldPath = (formId = "root", fieldId) => {
  if (formId === fieldId) return "";
  return fieldId.substr(formId.length + 1);
};
const canLink = (path3) => !path3.includes("_");
const isLockedWidget = (id2, links) => {
  if (!links) return false;
  const { id: formId, isMainForm, lockedPaths = [], linkedPaths = [] } = links;
  const fieldPath = getFieldPath(formId, id2);
  return !isMainForm && (lockedPaths.includes(fieldPath) || linkedPaths.includes(fieldPath));
};
const styles$q = (theme2) => ({
  fieldWrapper: {
    marginBottom: 20
  },
  field: {
    marginBottom: 3
  },
  rawDescription: {
    fontSize: 12
  },
  rawHelp: {
    fontSize: 12
  },
  labelWrapper: {
    paddingBottom: 8,
    display: "inline-flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    width: "100%",
    position: "relative",
    backgroundColor: "inherit",
    maxWidth: "90%"
  },
  label: {
    color: theme2.grey1,
    fontSize: 16,
    fontWeight: 600,
    letterSpacing: 0,
    '&[data-input-is-required="true"]::after': {
      content: '" *"',
      color: theme2.warningRed
    },
    '&[data-is-large="true"]': {
      flexGrow: 1
    }
  },
  lockIconClose: {
    // extend: iconStyle,
    marginLeft: 5,
    color: theme2.grey5,
    '&[data-is-clickable="true"]': {
      color: theme2.grey1,
      cursor: "pointer"
    }
  },
  lockIconOpen: {
    // extend: iconStyle,
    marginLeft: 5,
    color: theme2.grey4,
    cursor: "pointer"
  },
  linkIcon: {
    // extend: iconStyle,
    color: theme2.indigo3,
    cursor: "pointer"
  },
  unlinkIcon: {
    // extend: iconStyle,
    color: theme2.grey1,
    cursor: "pointer"
  }
});
const lockFieldTooltip = "Persist this value across forms";
const unlockFieldTooltip = "Disable persistence of this value across forms";
const lockedFieldTooltip = "This field is locked across all forms. To make this field's value unique, disable the persistence lock from the main form.";
const linkFieldTooltip = "Persist this value from the main form";
const unlinkFieldTooltip = "Disable persistence of this value from the main form";
let Field$1 = (_h = class extends PureComponent {
  renderDescription() {
    const { classes, schema, rawDescription } = this.props;
    if (rawDescription && schema.type !== "object")
      return /* @__PURE__ */ jsx$1("div", { className: classes.rawDescription, children: /* @__PURE__ */ jsx$1(Markdown, { source: rawDescription }) });
    return null;
  }
  renderLinkIcon() {
    const { classes, id: id2, formContext = {} } = this.props;
    const { links } = formContext;
    const {
      id: formId,
      isMainForm,
      onClickLock,
      lockedPaths = [],
      onClickLink,
      linkedPaths = []
    } = links || {};
    const fieldPath = getFieldPath(formId, id2);
    const isLockedField = lockedPaths.includes(fieldPath);
    const isLinkedField = !isLockedField && linkedPaths.includes(fieldPath);
    const canLinkField = canLink(fieldPath);
    let linkIcon = null;
    if (links && canLinkField) {
      if (isMainForm) {
        const onClick = () => onClickLock(fieldPath);
        linkIcon = isLockedField ? /* @__PURE__ */ jsx$1(
          "div",
          {
            className: classes.lockIconClose,
            "data-is-clickable": true,
            onClick,
            title: unlockFieldTooltip,
            "data-cy": "unlock",
            children: /* @__PURE__ */ jsx$1(Icon$2, { name: "PadlockCloseFill", size: 20 })
          }
        ) : /* @__PURE__ */ jsx$1(
          "div",
          {
            className: classes.lockIconOpen,
            onClick,
            title: lockFieldTooltip,
            "data-cy": "lock",
            children: /* @__PURE__ */ jsx$1(Icon$2, { name: "PadlockOpen", size: 20 })
          }
        );
      } else if (isLockedField) {
        linkIcon = /* @__PURE__ */ jsx$1("div", { className: classes.lockIconClose, title: lockedFieldTooltip, children: /* @__PURE__ */ jsx$1(Icon$2, { name: "PadlockCloseFill", size: 20 }) });
      } else {
        const onClick = () => onClickLink(fieldPath);
        linkIcon = isLinkedField ? /* @__PURE__ */ jsx$1(
          "div",
          {
            className: classes.unlinkIcon,
            onClick,
            title: unlinkFieldTooltip,
            "data-cy": "unlink",
            children: /* @__PURE__ */ jsx$1(Icon$2, { name: "DuplicateFill", size: 20 })
          }
        ) : /* @__PURE__ */ jsx$1(
          "div",
          {
            className: classes.linkIcon,
            onClick,
            title: linkFieldTooltip,
            "data-cy": "link",
            children: /* @__PURE__ */ jsx$1(Icon$2, { name: "Duplicate", size: 20 })
          }
        );
      }
    }
    return {
      linkIcon,
      isLargeLabel: !isMainForm && !isLockedField
    };
  }
  render() {
    const {
      classes,
      id: id2,
      label,
      children,
      rawHelp,
      hidden,
      required: required2,
      displayLabel
    } = this.props;
    if (hidden) return children;
    const { linkIcon, isLargeLabel } = this.renderLinkIcon();
    const labelProps = {
      className: classes.label,
      htmlFor: id2,
      "data-input-is-required": required2,
      "data-is-large": isLargeLabel
    };
    return /* @__PURE__ */ jsxs("div", { className: classes.fieldWrapper, children: [
      /* @__PURE__ */ jsxs("div", { className: classes.field, children: [
        displayLabel && label && /* @__PURE__ */ jsxs("div", { className: classes.labelWrapper, children: [
          /* @__PURE__ */ jsx$1("label", { ...labelProps, children: /* @__PURE__ */ jsx$1("span", { children: label }) }),
          linkIcon
        ] }),
        this.renderDescription(),
        children
      ] }),
      rawHelp && /* @__PURE__ */ jsxs("div", { className: classes.rawHelp, children: [
        " ",
        rawHelp
      ] })
    ] });
  }
}, __publicField(_h, "defaultProps", {
  label: void 0,
  rawDescription: void 0,
  rawErrors: [],
  rawHelp: "",
  hidden: false,
  required: false,
  readonly: false,
  disabled: false,
  displayLabel: true
}), _h);
const FieldTemplate$1 = injectSheet(styles$q)(Field$1);
const styles$p = () => ({
  button: {
    fontSize: 14,
    textAlign: "left",
    backgroundColor: "inherit",
    border: "none",
    cursor: "pointer",
    outline: "none",
    padding: 0
  }
});
const Button = ({
  classes,
  className = "",
  children,
  onClick,
  type: type2 = "button"
}) => /* @__PURE__ */ jsx$1(
  "button",
  {
    onClick,
    className: classNames(classes.button, className),
    type: type2,
    children
  }
);
const Button$1 = injectSheet(styles$p)(Button);
const styles$o = (theme2) => ({
  root: {
    padding: 10,
    border: `1px solid ${theme2.grey5}`,
    "&[data-has-error=true]": {
      border: `1px solid ${theme2.error}`
    },
    borderRadius: 5
  },
  fieldWrapper: {
    marginBottom: 20,
    padding: 14,
    backgroundColor: theme2.grey9,
    border: `1px solid ${theme2.grey5}`,
    borderRadius: 5
  },
  styledDiv: {
    color: "#34323A",
    fontWeight: 600,
    letterSpacing: 0,
    fontSize: 16,
    marginBottom: 10
  },
  styledBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end"
  }
});
let ArrayField$1 = (_i = class extends PureComponent {
  render() {
    const { classes, title: title2, items: items2, canAdd, onAddClick, rawErrors } = this.props;
    const error2 = rawErrors && rawErrors.length > 0;
    return /* @__PURE__ */ jsxs("div", { className: classes.root, "data-has-error": error2, children: [
      /* @__PURE__ */ jsx$1("div", { className: classes.styledDiv, children: title2 }),
      items2.map((item) => /* @__PURE__ */ jsxs("div", { className: classes.fieldWrapper, children: [
        item.children,
        item.hasRemove && /* @__PURE__ */ jsx$1("div", { className: classes.styledBox, children: /* @__PURE__ */ jsx$1(
          Button$1,
          {
            onClick: (e5) => {
              item.onDropIndexClick(item.index)(e5);
            },
            children: /* @__PURE__ */ jsx$1(Icon$2, { name: "Trash", size: 25 })
          }
        ) })
      ] }, item.index)),
      canAdd && /* @__PURE__ */ jsx$1(Button$1, { onClick: onAddClick, children: /* @__PURE__ */ jsx$1(Icon$2, { name: "CirclePlus", size: 25 }) })
    ] });
  }
}, __publicField(_i, "defaultProps", {
  rawErrors: []
}), _i);
const ArrayFieldTemplate$1 = injectSheet(styles$o)(ArrayField$1);
const styles$n = (theme2) => ({
  styledBox: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 20
  },
  styledText: {
    lineHeight: "normal",
    fontWeight: 600,
    fontSize: 17
  },
  styledDiv: {
    marginBottom: 10,
    fontSize: 12,
    color: theme2.grey2
  },
  descriptionMarkdown: {
    lineHeight: 1.4,
    fontSize: 12,
    "&:first-child": {
      marginTop: 0
    },
    "&:last-child": {
      marginBottom: 0
    }
  }
});
const ObjectFieldWriter = ({
  classes,
  title: title2,
  description: description2,
  properties: properties2
}) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
  (title2 || description2) && /* @__PURE__ */ jsxs("div", { className: classes.styledBox, children: [
    title2 && /* @__PURE__ */ jsx$1("p", { className: classes.styledText, children: title2 }),
    description2 && /* @__PURE__ */ jsx$1("div", { className: classes.styledDiv, children: /* @__PURE__ */ jsx$1(Markdown, { className: "descriptionMarkdown", source: description2 }) })
  ] }),
  properties2.map((property2) => property2.content)
] });
const ObjectFieldTemplate = injectSheet(styles$n)(ObjectFieldWriter);
const ObjectFieldReader = ({
  classes,
  description: description2,
  properties: properties2
}) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
  description2 && /* @__PURE__ */ jsx$1("div", { className: classes.styledBox, children: /* @__PURE__ */ jsx$1("div", { className: classes.styledDiv, children: /* @__PURE__ */ jsx$1(Markdown, { className: "descriptionMarkdown", source: description2 }) }) }),
  properties2.map((property2) => property2.content)
] });
const ObjectFieldReaderTemplate = injectSheet(styles$n)(ObjectFieldReader);
const withInlineValidation = (WrappedComponent) => (props2) => {
  const {
    label,
    schema: { title: title2 },
    formContext: { blurredFields, onErrorTriggered, onBlur },
    rawErrors
  } = props2;
  const handleBlur = () => label && setTimeout(() => onBlur(label.replace(" ", "_").toLowerCase()), 0);
  const invalid2 = rawErrors && rawErrors.length > 0 && (label && blurredFields.includes(label.toLowerCase().replace(" ", "_")) || onErrorTriggered);
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx$1("div", { onBlur: handleBlur, children: /* @__PURE__ */ jsx$1(WrappedComponent, { invalid: invalid2, ...props2 }) }),
    invalid2 && /* @__PURE__ */ jsx$1(ErrorMessage$1, { text: `${label || title2} ${rawErrors[0]}` })
  ] });
};
class TextInput extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleChange", ({
      target: { value }
    }) => {
      this.props.onChange(value === "" ? this.props.options.emptyValue : value);
    });
  }
  render() {
    const {
      id: id2,
      label,
      placeholder,
      value,
      disabled,
      options,
      invalid: invalid2,
      formContext
    } = this.props;
    const type2 = options.inputType || "text";
    const isLocked = isLockedWidget(id2, formContext.links);
    const FieldTextProps = {
      value: value === null ? "" : value.toString(),
      id: id2,
      label,
      placeholder,
      disabled: disabled || isLocked,
      handleChange: this.handleChange,
      type: type2,
      status: invalid2 ? "invalid" : null
    };
    return /* @__PURE__ */ jsx$1(Textinput$1, { ...FieldTextProps, hideLabel: true });
  }
}
__publicField(TextInput, "defaultProps", {
  id: "",
  label: "",
  value: "",
  placeholder: null,
  required: false,
  disabled: false,
  onChange: () => {
  }
});
const TextInput$1 = withInlineValidation(TextInput);
class TextArea extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleChange", (event) => this.props.onChange(event.target.value));
  }
  render() {
    const { id: id2, value, placeholder, required: required2, disabled, invalid: invalid2, formContext } = this.props;
    const isLocked = isLockedWidget(id2, formContext.links);
    const textAreaProps = {
      value,
      id: id2,
      placeholder,
      disabled: disabled || isLocked,
      handleChange: this.handleChange,
      required: required2,
      status: invalid2 ? "invalid" : null
    };
    return /* @__PURE__ */ jsx$1(Textarea, { ...textAreaProps, hideErrorMessage: true });
  }
}
__publicField(TextArea, "defaultProps", {
  id: "",
  label: "",
  value: "",
  placeholder: null,
  required: false,
  disabled: false,
  onChange: () => {
  }
});
const TextArea$1 = withInlineValidation(TextArea);
const guessType = (value) => {
  if (Array.isArray(value)) {
    return "array";
  }
  if (typeof value === "string") {
    return "string";
  }
  if (value === null) {
    return "null";
  }
  if (typeof value === "boolean") {
    return "boolean";
  }
  if (!Number.isNaN(value)) {
    return "number";
  }
  if (typeof value === "object") {
    return "object";
  }
  return "string";
};
const asNumber = (value) => {
  if (value === "") {
    return void 0;
  }
  if (/\.$/.test(value)) {
    return value;
  }
  if (/\.0$/.test(value)) {
    return value;
  }
  const n2 = Number(value);
  const valid = typeof n2 === "number" && !Number.isNaN(n2);
  if (/\.\d*0$/.test(value)) {
    return value;
  }
  return valid ? n2 : value;
};
const nums = /* @__PURE__ */ new Set(["number", "integer"]);
const SelectMenu = ({
  id: id2,
  options,
  onChange,
  schema,
  value = "",
  disabled = false,
  invalid: invalid2,
  formContext
}) => {
  const inputOptions = useMemo(() => {
    const optionsMapped = options.enumOptions.map(({ value: value2, label }) => ({
      label,
      value: value2
    }));
    return optionsMapped;
  }, [options]);
  const processValue = (value2) => {
    if (value2 === void 0) return void 0;
    const { type: type2, items: items2 } = schema;
    if (value2 === "") {
      return void 0;
    }
    if (type2 === "array" && items2 && nums.has(items2.type)) {
      return value2.map(asNumber);
    }
    if (type2 === "boolean") {
      return value2 === "true";
    }
    if (type2 === "number") {
      return asNumber(value2);
    }
    if (schema.enum) {
      if (schema.enum.every((x3) => guessType(x3) === "number")) {
        return asNumber(value2);
      }
      if (schema.enum.every((x3) => guessType(x3) === "boolean")) {
        return value2 === "true";
      }
    }
    return value2;
  };
  const handleChange = (newValue) => onChange(processValue(newValue));
  const isLocked = isLockedWidget(id2, formContext.links);
  return /* @__PURE__ */ jsx$1(
    SmartDropdown$1,
    {
      id: id2,
      options: inputOptions,
      value,
      onSelect: handleChange,
      label: schema.title,
      disabled: disabled || isLocked,
      invalid: invalid2
    }
  );
};
const SelectMenu$1 = withInlineValidation(SelectMenu);
const styles$m = () => ({
  root: {
    height: 35
  }
});
const styles$l = (theme2) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    "&[data-is-inline=true]": {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center"
    }
  },
  title: {
    color: theme2.grey1,
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 13,
    letterSpacing: 0
  },
  selectAllCheck: {
    marginBottom: 12
  },
  checkboxWrapper: {
    marginBottom: 12,
    "& label": {
      alignItems: "unset",
      marginLeft: 20
    },
    "& checkbox": {
      marginTop: 2
    }
  }
});
const arraysMatch = (arr1, arr2) => {
  for (let i3 = 0; i3 < arr1.length; i3 += 1) {
    if (!arr2.includes(arr1[i3])) return false;
  }
  return true;
};
const selectValue = (value, selected, all) => {
  const updated = [...selected, value];
  const sorted = updated.sort(
    (a4, b3) => all.indexOf(a4) > all.indexOf(b3) ? 1 : -1
  );
  return sorted;
};
const deselectValue = (value, selected) => selected.filter((v2) => v2 !== value);
const CheckboxesWidget$2 = (props2) => {
  const {
    classes,
    disabled,
    options: { enumOptions, enumDisabled, inline = false, largeLabel },
    value,
    readonly,
    onChange,
    id: id2,
    formContext
  } = props2;
  const enumOptionsValues = Object.values(enumOptions).map(
    (e5) => e5.value
  );
  const [tempEnumOptions, setTempEnumOptions] = React__default.useState(enumOptionsValues);
  if (!arraysMatch(enumOptionsValues, tempEnumOptions)) {
    setTempEnumOptions(enumOptionsValues);
    onChange([]);
  }
  const handleSingleCheck = (event, optionValue) => {
    const all = enumOptions.map(({ value: value2 }) => value2);
    if (event.target.checked) {
      return onChange(selectValue(optionValue, value, all));
    }
    return onChange(deselectValue(optionValue, value));
  };
  const handleAllChecked = () => {
    const all = enumOptions.map(({ value: value2 }) => value2);
    if (arraysMatch(enumOptionsValues, value)) {
      return onChange([]);
    }
    return onChange(all);
  };
  const rootProps = {
    className: classes.root,
    "data-is-inline": inline
  };
  const isLocked = isLockedWidget(id2, formContext.links);
  const allDisabled = disabled || readonly || isLocked;
  return /* @__PURE__ */ jsxs("div", { ...rootProps, children: [
    enumOptions.length > 1 && /* @__PURE__ */ jsx$1("div", { className: classes.selectAllCheck, children: /* @__PURE__ */ jsx$1(
      Check,
      {
        showLabel: true,
        checked: arraysMatch(enumOptionsValues, value),
        disabled: allDisabled,
        handleChange: handleAllChecked,
        label: "Select all",
        darkLabel: true,
        largeLabel,
        bold: true
      }
    ) }),
    enumOptions.map(({ value: optionValue, label }) => {
      const checked = value.indexOf(optionValue) !== -1;
      const itemDisabled = enumDisabled && enumDisabled.indexOf(optionValue) !== -1;
      return /* @__PURE__ */ jsx$1("div", { className: classes.checkboxWrapper, children: /* @__PURE__ */ jsx$1(
        Check,
        {
          showLabel: true,
          checked,
          disabled: allDisabled || itemDisabled,
          handleChange: (e5) => handleSingleCheck(e5, optionValue),
          label,
          darkLabel: true,
          largeLabel
        }
      ) }, optionValue);
    })
  ] });
};
const CheckboxesWidget$3 = compose(
  withInlineValidation,
  injectSheet(styles$l)
)(CheckboxesWidget$2);
const MultiSelectMenu = ({
  classes,
  id: id2,
  options,
  onChange,
  value,
  disabled = false,
  invalid: invalid2,
  formContext
}) => {
  const enumOptionsValues = Object.values(options.enumOptions).map(
    (e5) => e5.value
  );
  const [tempEnumOptions, setTempEnumOptions] = useState(enumOptionsValues);
  if (!arraysMatch(enumOptionsValues, tempEnumOptions)) {
    setTempEnumOptions(enumOptionsValues);
    onChange([]);
  }
  const isLocked = isLockedWidget(id2, formContext.links);
  return /* @__PURE__ */ jsx$1("div", { className: classes.root, children: /* @__PURE__ */ jsx$1(
    MultiSelect$1,
    {
      displayValue: options.itemName || "item",
      id: id2,
      options: options.enumOptions,
      selectedValues: value,
      onSelect: onChange,
      disabled: disabled || isLocked,
      invalid: invalid2
    }
  ) });
};
const MultiSelectMenu$1 = compose(
  withInlineValidation,
  injectSheet(styles$m)
)(MultiSelectMenu);
function _typeof(o2) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof(o2);
}
function requiredArgs(required2, args) {
  if (args.length < required2) {
    throw new TypeError(required2 + " argument" + (required2 > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
function isDate$2(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function toDate$1(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof(argument) === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return /* @__PURE__ */ new Date(NaN);
  }
}
function isValid$3(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate$2(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date = toDate$1(dirtyDate);
  return !isNaN(Number(date));
}
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate$1(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY$1 = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate$1(dirtyDate);
  var day = date.getUTCDay();
  var diff2 = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff2);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
var MILLISECONDS_IN_WEEK$2 = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var diff2 = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff2 / MILLISECONDS_IN_WEEK$2) + 1;
}
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate$1(dirtyDate);
  var day = date.getUTCDay();
  var diff2 = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff2);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var diff2 = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff2 / MILLISECONDS_IN_WEEK$1) + 1;
}
function addLeadingZeros(number, targetLength) {
  var sign2 = number < 0 ? "-" : "";
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign2 + output;
}
var formatters$1 = {
  // Year
  y: function y2(date, token2) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token2 === "yy" ? year % 100 : year, token2.length);
  },
  // Month
  M: function M2(date, token2) {
    var month = date.getUTCMonth();
    return token2 === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d2(date, token2) {
    return addLeadingZeros(date.getUTCDate(), token2.length);
  },
  // AM or PM
  a: function a2(date, token2) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function h2(date, token2) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token2.length);
  },
  // Hour [0-23]
  H: function H2(date, token2) {
    return addLeadingZeros(date.getUTCHours(), token2.length);
  },
  // Minute
  m: function m2(date, token2) {
    return addLeadingZeros(date.getUTCMinutes(), token2.length);
  },
  // Second
  s: function s2(date, token2) {
    return addLeadingZeros(date.getUTCSeconds(), token2.length);
  },
  // Fraction of second
  S: function S2(date, token2) {
    var numberOfDigits = token2.length;
    var milliseconds2 = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds2 * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token2.length);
  }
};
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters = {
  // Era
  G: function G2(date, token2, localize2) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token2) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  },
  // Year
  y: function y3(date, token2, localize2) {
    if (token2 === "yo") {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$1.y(date, token2);
  },
  // Local week-numbering year
  Y: function Y2(date, token2, localize2, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token2 === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token2 === "Yo") {
      return localize2.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros(weekYear, token2.length);
  },
  // ISO week-numbering year
  R: function R2(date, token2) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token2.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u2(date, token2) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token2.length);
  },
  // Quarter
  Q: function Q2(date, token2, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token2) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function q2(date, token2, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token2) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function M3(date, token2, localize2) {
    var month = date.getUTCMonth();
    switch (token2) {
      case "M":
      case "MM":
        return formatters$1.M(date, token2);
      case "Mo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function L2(date, token2, localize2) {
    var month = date.getUTCMonth();
    switch (token2) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function w2(date, token2, localize2, options) {
    var week = getUTCWeek(date, options);
    if (token2 === "wo") {
      return localize2.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros(week, token2.length);
  },
  // ISO week of year
  I: function I2(date, token2, localize2) {
    var isoWeek = getUTCISOWeek(date);
    if (token2 === "Io") {
      return localize2.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token2.length);
  },
  // Day of the month
  d: function d3(date, token2, localize2) {
    if (token2 === "do") {
      return localize2.ordinalNumber(date.getUTCDate(), {
        unit: "date"
      });
    }
    return formatters$1.d(date, token2);
  },
  // Day of year
  D: function D2(date, token2, localize2) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token2 === "Do") {
      return localize2.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token2.length);
  },
  // Day of week
  E: function E2(date, token2, localize2) {
    var dayOfWeek = date.getUTCDay();
    switch (token2) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function e4(date, token2, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function c2(date, token2, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token2.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function i2(date, token2, localize2) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token2) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token2.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function a3(date, token2, localize2) {
    var hours2 = date.getUTCHours();
    var dayPeriodEnumValue = hours2 / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b2(date, token2, localize2) {
    var hours2 = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours2 === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours2 === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours2 / 12 >= 1 ? "pm" : "am";
    }
    switch (token2) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B2(date, token2, localize2) {
    var hours2 = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours2 >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours2 >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours2 >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token2) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function h3(date, token2, localize2) {
    if (token2 === "ho") {
      var hours2 = date.getUTCHours() % 12;
      if (hours2 === 0) hours2 = 12;
      return localize2.ordinalNumber(hours2, {
        unit: "hour"
      });
    }
    return formatters$1.h(date, token2);
  },
  // Hour [0-23]
  H: function H3(date, token2, localize2) {
    if (token2 === "Ho") {
      return localize2.ordinalNumber(date.getUTCHours(), {
        unit: "hour"
      });
    }
    return formatters$1.H(date, token2);
  },
  // Hour [0-11]
  K: function K2(date, token2, localize2) {
    var hours2 = date.getUTCHours() % 12;
    if (token2 === "Ko") {
      return localize2.ordinalNumber(hours2, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours2, token2.length);
  },
  // Hour [1-24]
  k: function k2(date, token2, localize2) {
    var hours2 = date.getUTCHours();
    if (hours2 === 0) hours2 = 24;
    if (token2 === "ko") {
      return localize2.ordinalNumber(hours2, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours2, token2.length);
  },
  // Minute
  m: function m3(date, token2, localize2) {
    if (token2 === "mo") {
      return localize2.ordinalNumber(date.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return formatters$1.m(date, token2);
  },
  // Second
  s: function s3(date, token2, localize2) {
    if (token2 === "so") {
      return localize2.ordinalNumber(date.getUTCSeconds(), {
        unit: "second"
      });
    }
    return formatters$1.s(date, token2);
  },
  // Fraction of second
  S: function S3(date, token2) {
    return formatters$1.S(date, token2);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X2(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token2) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x2(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function O2(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function z2(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function t2(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token2.length);
  },
  // Milliseconds timestamp
  T: function T2(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token2.length);
  }
};
function formatTimezoneShort(offset2, dirtyDelimiter) {
  var sign2 = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours2 = Math.floor(absOffset / 60);
  var minutes2 = absOffset % 60;
  if (minutes2 === 0) {
    return sign2 + String(hours2);
  }
  var delimiter = dirtyDelimiter;
  return sign2 + String(hours2) + delimiter + addLeadingZeros(minutes2, 2);
}
function formatTimezoneWithOptionalMinutes(offset2, dirtyDelimiter) {
  if (offset2 % 60 === 0) {
    var sign2 = offset2 > 0 ? "-" : "+";
    return sign2 + addLeadingZeros(Math.abs(offset2) / 60, 2);
  }
  return formatTimezone(offset2, dirtyDelimiter);
}
function formatTimezone(offset2, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign2 = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours2 = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes2 = addLeadingZeros(absOffset % 60, 2);
  return sign2 + hours2 + delimiter + minutes2;
}
var dateLongFormatter = function dateLongFormatter2(pattern2, formatLong2) {
  switch (pattern2) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
};
var timeLongFormatter = function timeLongFormatter2(pattern2, formatLong2) {
  switch (pattern2) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter2(pattern2, formatLong2) {
  var matchResult = pattern2.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern2, formatLong2);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token2) {
  return protectedDayOfYearTokens.indexOf(token2) !== -1;
}
function isProtectedWeekYearToken(token2) {
  return protectedWeekYearTokens.indexOf(token2) !== -1;
}
function throwProtectedError(token2, format3, input) {
  if (token2 === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format3, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format3, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format3, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format3, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance$1 = function formatDistance(token2, count, options) {
  var result2;
  var tokenValue = formatDistanceLocale$1[token2];
  if (typeof tokenValue === "string") {
    result2 = tokenValue;
  } else if (count === 1) {
    result2 = tokenValue.one;
  } else {
    result2 = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result2;
    } else {
      return result2 + " ago";
    }
  }
  return result2;
};
function buildFormatLongFn(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format3 = args.formats[width] || args.formats[args.defaultWidth];
    return format3;
  };
}
var dateFormats$1 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats$1 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong$1 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: "full"
  })
};
var formatRelativeLocale$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative$1 = function formatRelative(token2, _date, _baseDate, _options) {
  return formatRelativeLocale$1[token2];
};
function buildLocalizeFn(args) {
  return function(dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index2];
  };
}
var eraValues$1 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues$1 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues$1 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber$1 = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize$1 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return function(string3) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string3.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key2 = Array.isArray(parsePatterns) ? findIndex$1(parsePatterns, function(pattern2) {
      return pattern2.test(matchedString);
    }) : findKey(parsePatterns, function(pattern2) {
      return pattern2.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key2) : key2;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string3.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey(object, predicate) {
  for (var key2 in object) {
    if (object.hasOwnProperty(key2) && predicate(object[key2])) {
      return key2;
    }
  }
  return void 0;
}
function findIndex$1(array, predicate) {
  for (var key2 = 0; key2 < array.length; key2++) {
    if (predicate(array[key2])) {
      return key2;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return function(string3) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string3.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string3.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string3.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
var matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns$1 = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns$1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: "any",
    valueCallback: function valueCallback2(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: "any"
  })
};
var locale$2 = {
  code: "en-US",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function format$2(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions2 = getDefaultOptions();
  var locale2 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : locale$2;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale2.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale2.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate$1(dirtyDate);
  if (!isValid$3(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2,
    _originalDate: originalDate
  };
  var result2 = formatStr.match(longFormattingTokensRegExp$1).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$1).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }
    var formatter = formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale2.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result2;
}
function cleanEscapedString$1(input) {
  var matched = input.match(escapedStringRegExp$1);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp$1, "'");
}
var MILLISECONDS_IN_MINUTE = 6e4;
function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}
var MILLISECONDS_IN_HOUR = 36e5;
function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}
function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days2 = amount * 7;
  return addDays(dirtyDate, days2);
}
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  var dayOfMonth = date.getDate();
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth2 = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth2) {
    return endOfDesiredMonth;
  } else {
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}
function subWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addWeeks(dirtyDate, -amount);
}
function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}
function subYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}
function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var seconds2 = date.getSeconds();
  return seconds2;
}
function getMinutes(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var minutes2 = date.getMinutes();
  return minutes2;
}
function getHours(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var hours2 = date.getHours();
  return hours2;
}
function getDay$1(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var day = date.getDay();
  return day;
}
function getDate(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate$1(dirtyDate);
  var day = date.getDay();
  var diff2 = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff2);
  date.setHours(0, 0, 0, 0);
  return date;
}
function getWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getWeekYear(dirtyDate, options);
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date = startOfWeek(firstWeek, options);
  return date;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var diff2 = startOfWeek(date, options).getTime() - startOfWeekYear(date, options).getTime();
  return Math.round(diff2 / MILLISECONDS_IN_WEEK) + 1;
}
function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var month = date.getMonth();
  return month;
}
function getQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}
function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate$1(dirtyDate).getFullYear();
}
function getTime$1(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}
function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var seconds2 = toInteger(dirtySeconds);
  date.setSeconds(seconds2);
  return date;
}
function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var minutes2 = toInteger(dirtyMinutes);
  date.setMinutes(minutes2);
  return date;
}
function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var hours2 = toInteger(dirtyHours);
  date.setHours(hours2);
  return date;
}
function getDaysInMonth$1(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = /* @__PURE__ */ new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
function setMonth$1(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = /* @__PURE__ */ new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth2 = getDaysInMonth$1(dateWithDesiredMonth);
  date.setMonth(month, Math.min(day, daysInMonth2));
  return date;
}
function setQuarter(dirtyDate, dirtyQuarter) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var quarter = toInteger(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff2 = quarter - oldQuarter;
  return setMonth$1(date, date.getMonth() + diff2 * 3);
}
function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var year = toInteger(dirtyYear);
  if (isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  date.setFullYear(year);
  return date;
}
function min$1(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") {
    datesArray = dirtyDatesArray;
  } else if (_typeof(dirtyDatesArray) === "object" && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
  var result2;
  datesArray.forEach(function(dirtyDate) {
    var currentDate = toDate$1(dirtyDate);
    if (result2 === void 0 || result2 > currentDate || isNaN(currentDate.getDate())) {
      result2 = currentDate;
    }
  });
  return result2 || /* @__PURE__ */ new Date(NaN);
}
function max$2(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") {
    datesArray = dirtyDatesArray;
  } else if (_typeof(dirtyDatesArray) === "object" && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
  var result2;
  datesArray.forEach(function(dirtyDate) {
    var currentDate = toDate$1(dirtyDate);
    if (result2 === void 0 || result2 < currentDate || isNaN(Number(currentDate))) {
      result2 = currentDate;
    }
  });
  return result2 || /* @__PURE__ */ new Date(NaN);
}
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
var MILLISECONDS_IN_DAY = 864e5;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff2 = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff2;
}
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate$1(dirtyDate);
  var date = /* @__PURE__ */ new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}
function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate$1(dirtyLeftDate);
  var dateRight = toDate$1(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate$1(dirtyDateLeft);
  var dateRight = toDate$1(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}
function isAfter$1(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var dateToCompare = toDate$1(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}
function isBefore$1(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var dateToCompare = toDate$1(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}
function isWithinInterval(dirtyDate, interval) {
  requiredArgs(2, arguments);
  var time2 = toDate$1(dirtyDate).getTime();
  var startTime = toDate$1(interval.start).getTime();
  var endTime = toDate$1(interval.end).getTime();
  if (!(startTime <= endTime)) {
    throw new RangeError("Invalid interval");
  }
  return time2 >= startTime && time2 <= endTime;
}
function _arrayLikeToArray(r2, a4) {
  (null == a4 || a4 > r2.length) && (a4 = r2.length);
  for (var e5 = 0, n2 = Array(a4); e5 < a4; e5++) n2[e5] = r2[e5];
  return n2;
}
function _unsupportedIterableToArray(r2, a4) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray(r2, a4);
    var t3 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t3 && r2.constructor && (t3 = r2.constructor.name), "Map" === t3 || "Set" === t3 ? Array.from(r2) : "Arguments" === t3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t3) ? _arrayLikeToArray(r2, a4) : void 0;
  }
}
function _createForOfIteratorHelper(r2, e5) {
  var t3 = "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (!t3) {
    if (Array.isArray(r2) || (t3 = _unsupportedIterableToArray(r2)) || e5) {
      t3 && (r2 = t3);
      var _n2 = 0, F2 = function F3() {
      };
      return {
        s: F2,
        n: function n2() {
          return _n2 >= r2.length ? {
            done: true
          } : {
            done: false,
            value: r2[_n2++]
          };
        },
        e: function e6(r3) {
          throw r3;
        },
        f: F2
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o2, a4 = true, u3 = false;
  return {
    s: function s4() {
      t3 = t3.call(r2);
    },
    n: function n2() {
      var r3 = t3.next();
      return a4 = r3.done, r3;
    },
    e: function e6(r3) {
      u3 = true, o2 = r3;
    },
    f: function f2() {
      try {
        a4 || null == t3["return"] || t3["return"]();
      } finally {
        if (u3) throw o2;
      }
    }
  };
}
function assign(target, object) {
  if (target == null) {
    throw new TypeError("assign requires that input parameter not be null or undefined");
  }
  for (var property2 in object) {
    if (Object.prototype.hasOwnProperty.call(object, property2)) {
      target[property2] = object[property2];
    }
  }
  return target;
}
function _assertThisInitialized$1(e5) {
  if (void 0 === e5) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e5;
}
function _setPrototypeOf$1(t3, e5) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t4, e6) {
    return t4.__proto__ = e6, t4;
  }, _setPrototypeOf$1(t3, e5);
}
function _inherits$1(t3, e5) {
  if ("function" != typeof e5 && null !== e5) throw new TypeError("Super expression must either be null or a function");
  t3.prototype = Object.create(e5 && e5.prototype, {
    constructor: {
      value: t3,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t3, "prototype", {
    writable: false
  }), e5 && _setPrototypeOf$1(t3, e5);
}
function _getPrototypeOf(t3) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t4) {
    return t4.__proto__ || Object.getPrototypeOf(t4);
  }, _getPrototypeOf(t3);
}
function _isNativeReflectConstruct() {
  try {
    var t3 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t4) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t3;
  })();
}
function _possibleConstructorReturn$1(t3, e5) {
  if (e5 && ("object" == _typeof(e5) || "function" == typeof e5)) return e5;
  if (void 0 !== e5) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(t3);
}
function _createSuper(t3) {
  var r2 = _isNativeReflectConstruct();
  return function() {
    var e5, o2 = _getPrototypeOf(t3);
    if (r2) {
      var s4 = _getPrototypeOf(this).constructor;
      e5 = Reflect.construct(o2, arguments, s4);
    } else e5 = o2.apply(this, arguments);
    return _possibleConstructorReturn$1(this, e5);
  };
}
function _classCallCheck$1(a4, n2) {
  if (!(a4 instanceof n2)) throw new TypeError("Cannot call a class as a function");
}
function toPrimitive(t3, r2) {
  if ("object" != _typeof(t3) || !t3) return t3;
  var e5 = t3[Symbol.toPrimitive];
  if (void 0 !== e5) {
    var i3 = e5.call(t3, r2 || "default");
    if ("object" != _typeof(i3)) return i3;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t3);
}
function toPropertyKey(t3) {
  var i3 = toPrimitive(t3, "string");
  return "symbol" == _typeof(i3) ? i3 : i3 + "";
}
function _defineProperties(e5, r2) {
  for (var t3 = 0; t3 < r2.length; t3++) {
    var o2 = r2[t3];
    o2.enumerable = o2.enumerable || false, o2.configurable = true, "value" in o2 && (o2.writable = true), Object.defineProperty(e5, toPropertyKey(o2.key), o2);
  }
}
function _createClass$1(e5, r2, t3) {
  return r2 && _defineProperties(e5.prototype, r2), Object.defineProperty(e5, "prototype", {
    writable: false
  }), e5;
}
function _defineProperty(e5, r2, t3) {
  return (r2 = toPropertyKey(r2)) in e5 ? Object.defineProperty(e5, r2, {
    value: t3,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e5[r2] = t3, e5;
}
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /* @__PURE__ */ function() {
  function Setter2() {
    _classCallCheck$1(this, Setter2);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", 0);
  }
  _createClass$1(Setter2, [{
    key: "validate",
    value: function validate2(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter2;
}();
var ValueSetter = /* @__PURE__ */ function(_Setter) {
  _inherits$1(ValueSetter2, _Setter);
  var _super = _createSuper(ValueSetter2);
  function ValueSetter2(value, validateValue, setValue, priority, subPriority) {
    var _this;
    _classCallCheck$1(this, ValueSetter2);
    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  _createClass$1(ValueSetter2, [{
    key: "validate",
    value: function validate2(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set2(utcDate, flags3, options) {
      return this.setValue(utcDate, flags3, this.value, options);
    }
  }]);
  return ValueSetter2;
}(Setter);
var DateToSystemTimezoneSetter = /* @__PURE__ */ function(_Setter2) {
  _inherits$1(DateToSystemTimezoneSetter2, _Setter2);
  var _super2 = _createSuper(DateToSystemTimezoneSetter2);
  function DateToSystemTimezoneSetter2() {
    var _this2;
    _classCallCheck$1(this, DateToSystemTimezoneSetter2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
    _defineProperty(_assertThisInitialized$1(_this2), "subPriority", -1);
    return _this2;
  }
  _createClass$1(DateToSystemTimezoneSetter2, [{
    key: "set",
    value: function set2(date, flags3) {
      if (flags3.timestampIsSet) {
        return date;
      }
      var convertedDate = /* @__PURE__ */ new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter2;
}(Setter);
var Parser2 = /* @__PURE__ */ function() {
  function Parser3() {
    _classCallCheck$1(this, Parser3);
    _defineProperty(this, "incompatibleTokens", void 0);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", void 0);
  }
  _createClass$1(Parser3, [{
    key: "run",
    value: function run(dateString, token2, match5, options) {
      var result2 = this.parse(dateString, token2, match5, options);
      if (!result2) {
        return null;
      }
      return {
        setter: new ValueSetter(result2.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result2.rest
      };
    }
  }, {
    key: "validate",
    value: function validate2(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser3;
}();
var EraParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(EraParser2, _Parser);
  var _super = _createSuper(EraParser2);
  function EraParser2() {
    var _this;
    _classCallCheck$1(this, EraParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 140);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["R", "u", "t", "T"]);
    return _this;
  }
  _createClass$1(EraParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "G":
        case "GG":
        case "GGG":
          return match5.era(dateString, {
            width: "abbreviated"
          }) || match5.era(dateString, {
            width: "narrow"
          });
        case "GGGGG":
          return match5.era(dateString, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return match5.era(dateString, {
            width: "wide"
          }) || match5.era(dateString, {
            width: "abbreviated"
          }) || match5.era(dateString, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags3, value) {
      flags3.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser2;
}(Parser2);
var millisecondsInMinute = 6e4;
var millisecondsInHour = 36e5;
var millisecondsInSecond = 1e3;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern2, dateString) {
  var matchResult = dateString.match(pattern2);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern2, dateString) {
  var matchResult = dateString.match(pattern2);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign2 = matchResult[1] === "+" ? 1 : -1;
  var hours2 = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes2 = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds2 = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign2 * (hours2 * millisecondsInHour + minutes2 * millisecondsInMinute + seconds2 * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n2 + "}"), dateString);
  }
}
function parseNDigitsSigned(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n2 + "}"), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result2;
  if (absCurrentYear <= 50) {
    result2 = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result2 = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result2 : 1 - result2;
}
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
var YearParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(YearParser2, _Parser);
  var _super = _createSuper(YearParser2);
  function YearParser2() {
    var _this;
    _classCallCheck$1(this, YearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(YearParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      var valueCallback5 = function valueCallback6(year) {
        return {
          year,
          isTwoDigitYear: token2 === "yy"
        };
      };
      switch (token2) {
        case "y":
          return mapValue(parseNDigits(4, dateString), valueCallback5);
        case "yo":
          return mapValue(match5.ordinalNumber(dateString, {
            unit: "year"
          }), valueCallback5);
        default:
          return mapValue(parseNDigits(token2.length, dateString), valueCallback5);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set2(date, flags3, value) {
      var currentYear = date.getUTCFullYear();
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !("era" in flags3) || flags3.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser2;
}(Parser2);
var LocalWeekYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(LocalWeekYearParser2, _Parser);
  var _super = _createSuper(LocalWeekYearParser2);
  function LocalWeekYearParser2() {
    var _this;
    _classCallCheck$1(this, LocalWeekYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this;
  }
  _createClass$1(LocalWeekYearParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      var valueCallback5 = function valueCallback6(year) {
        return {
          year,
          isTwoDigitYear: token2 === "YY"
        };
      };
      switch (token2) {
        case "Y":
          return mapValue(parseNDigits(4, dateString), valueCallback5);
        case "Yo":
          return mapValue(match5.ordinalNumber(dateString, {
            unit: "year"
          }), valueCallback5);
        default:
          return mapValue(parseNDigits(token2.length, dateString), valueCallback5);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set2(date, flags3, value, options) {
      var currentYear = getUTCWeekYear(date, options);
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }
      var year = !("era" in flags3) || flags3.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    }
  }]);
  return LocalWeekYearParser2;
}(Parser2);
var ISOWeekYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(ISOWeekYearParser2, _Parser);
  var _super = _createSuper(ISOWeekYearParser2);
  function ISOWeekYearParser2() {
    var _this;
    _classCallCheck$1(this, ISOWeekYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(ISOWeekYearParser2, [{
    key: "parse",
    value: function parse3(dateString, token2) {
      if (token2 === "R") {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token2.length, dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value) {
      var firstWeekOfYear = /* @__PURE__ */ new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser2;
}(Parser2);
var ExtendedYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(ExtendedYearParser2, _Parser);
  var _super = _createSuper(ExtendedYearParser2);
  function ExtendedYearParser2() {
    var _this;
    _classCallCheck$1(this, ExtendedYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(ExtendedYearParser2, [{
    key: "parse",
    value: function parse3(dateString, token2) {
      if (token2 === "u") {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token2.length, dateString);
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser2;
}(Parser2);
var QuarterParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(QuarterParser2, _Parser);
  var _super = _createSuper(QuarterParser2);
  function QuarterParser2() {
    var _this;
    _classCallCheck$1(this, QuarterParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 120);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(QuarterParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "Q":
        case "QQ":
          return parseNDigits(token2.length, dateString);
        case "Qo":
          return match5.ordinalNumber(dateString, {
            unit: "quarter"
          });
        case "QQQ":
          return match5.quarter(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return match5.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return match5.quarter(dateString, {
            width: "wide",
            context: "formatting"
          }) || match5.quarter(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser2;
}(Parser2);
var StandAloneQuarterParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(StandAloneQuarterParser2, _Parser);
  var _super = _createSuper(StandAloneQuarterParser2);
  function StandAloneQuarterParser2() {
    var _this;
    _classCallCheck$1(this, StandAloneQuarterParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 120);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(StandAloneQuarterParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "q":
        case "qq":
          return parseNDigits(token2.length, dateString);
        case "qo":
          return match5.ordinalNumber(dateString, {
            unit: "quarter"
          });
        case "qqq":
          return match5.quarter(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match5.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return match5.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return match5.quarter(dateString, {
            width: "wide",
            context: "standalone"
          }) || match5.quarter(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match5.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser2;
}(Parser2);
var MonthParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(MonthParser2, _Parser);
  var _super = _createSuper(MonthParser2);
  function MonthParser2() {
    var _this;
    _classCallCheck$1(this, MonthParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]);
    _defineProperty(_assertThisInitialized$1(_this), "priority", 110);
    return _this;
  }
  _createClass$1(MonthParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      var valueCallback5 = function valueCallback6(value) {
        return value - 1;
      };
      switch (token2) {
        case "M":
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback5);
        case "MM":
          return mapValue(parseNDigits(2, dateString), valueCallback5);
        case "Mo":
          return mapValue(match5.ordinalNumber(dateString, {
            unit: "month"
          }), valueCallback5);
        case "MMM":
          return match5.month(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return match5.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return match5.month(dateString, {
            width: "wide",
            context: "formatting"
          }) || match5.month(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser2;
}(Parser2);
var StandAloneMonthParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(StandAloneMonthParser2, _Parser);
  var _super = _createSuper(StandAloneMonthParser2);
  function StandAloneMonthParser2() {
    var _this;
    _classCallCheck$1(this, StandAloneMonthParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 110);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(StandAloneMonthParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      var valueCallback5 = function valueCallback6(value) {
        return value - 1;
      };
      switch (token2) {
        case "L":
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback5);
        case "LL":
          return mapValue(parseNDigits(2, dateString), valueCallback5);
        case "Lo":
          return mapValue(match5.ordinalNumber(dateString, {
            unit: "month"
          }), valueCallback5);
        case "LLL":
          return match5.month(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match5.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return match5.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return match5.month(dateString, {
            width: "wide",
            context: "standalone"
          }) || match5.month(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match5.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser2;
}(Parser2);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff2 = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff2 * 7);
  return date;
}
var LocalWeekParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(LocalWeekParser2, _Parser);
  var _super = _createSuper(LocalWeekParser2);
  function LocalWeekParser2() {
    var _this;
    _classCallCheck$1(this, LocalWeekParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 100);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this;
  }
  _createClass$1(LocalWeekParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "w":
          return parseNumericPattern(numericPatterns.week, dateString);
        case "wo":
          return match5.ordinalNumber(dateString, {
            unit: "week"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    }
  }]);
  return LocalWeekParser2;
}(Parser2);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate$1(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff2 = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff2 * 7);
  return date;
}
var ISOWeekParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(ISOWeekParser2, _Parser);
  var _super = _createSuper(ISOWeekParser2);
  function ISOWeekParser2() {
    var _this;
    _classCallCheck$1(this, ISOWeekParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 100);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(ISOWeekParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "I":
          return parseNumericPattern(numericPatterns.week, dateString);
        case "Io":
          return match5.ordinalNumber(dateString, {
            unit: "week"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value));
    }
  }]);
  return ISOWeekParser2;
}(Parser2);
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DateParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(DateParser2, _Parser);
  var _super = _createSuper(DateParser2);
  function DateParser2() {
    var _this;
    _classCallCheck$1(this, DateParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "subPriority", 1);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(DateParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "d":
          return parseNumericPattern(numericPatterns.date, dateString);
        case "do":
          return match5.ordinalNumber(dateString, {
            unit: "date"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear2 = isLeapYearIndex$1(year);
      var month = date.getUTCMonth();
      if (isLeapYear2) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser2;
}(Parser2);
var DayOfYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(DayOfYearParser2, _Parser);
  var _super = _createSuper(DayOfYearParser2);
  function DayOfYearParser2() {
    var _this;
    _classCallCheck$1(this, DayOfYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "subpriority", 1);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(DayOfYearParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "D":
        case "DD":
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);
        case "Do":
          return match5.ordinalNumber(dateString, {
            unit: "date"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear2 = isLeapYearIndex$1(year);
      if (isLeapYear2) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser2;
}(Parser2);
function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate$1(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff2 = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff2);
  return date;
}
var DayParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(DayParser2, _Parser);
  var _super = _createSuper(DayParser2);
  function DayParser2() {
    var _this;
    _classCallCheck$1(this, DayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(DayParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "E":
        case "EE":
        case "EEE":
          return match5.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return match5.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser2;
}(Parser2);
var LocalDayParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(LocalDayParser2, _Parser);
  var _super = _createSuper(LocalDayParser2);
  function LocalDayParser2() {
    var _this;
    _classCallCheck$1(this, LocalDayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(LocalDayParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5, options) {
      var valueCallback5 = function valueCallback6(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token2) {
        case "e":
        case "ee":
          return mapValue(parseNDigits(token2.length, dateString), valueCallback5);
        case "eo":
          return mapValue(match5.ordinalNumber(dateString, {
            unit: "day"
          }), valueCallback5);
        case "eee":
          return match5.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return match5.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser2;
}(Parser2);
var StandAloneLocalDayParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(StandAloneLocalDayParser2, _Parser);
  var _super = _createSuper(StandAloneLocalDayParser2);
  function StandAloneLocalDayParser2() {
    var _this;
    _classCallCheck$1(this, StandAloneLocalDayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]);
    return _this;
  }
  _createClass$1(StandAloneLocalDayParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5, options) {
      var valueCallback5 = function valueCallback6(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token2) {
        case "c":
        case "cc":
          return mapValue(parseNDigits(token2.length, dateString), valueCallback5);
        case "co":
          return mapValue(match5.ordinalNumber(dateString, {
            unit: "day"
          }), valueCallback5);
        case "ccc":
          return match5.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match5.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return match5.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return match5.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return match5.day(dateString, {
            width: "wide",
            context: "standalone"
          }) || match5.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match5.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser2;
}(Parser2);
function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = toDate$1(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff2 = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff2);
  return date;
}
var ISODayParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(ISODayParser2, _Parser);
  var _super = _createSuper(ISODayParser2);
  function ISODayParser2() {
    var _this;
    _classCallCheck$1(this, ISODayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass$1(ISODayParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      var valueCallback5 = function valueCallback6(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token2) {
        case "i":
        case "ii":
          return parseNDigits(token2.length, dateString);
        case "io":
          return match5.ordinalNumber(dateString, {
            unit: "day"
          });
        case "iii":
          return mapValue(match5.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback5);
        case "iiiii":
          return mapValue(match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback5);
        case "iiiiii":
          return mapValue(match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback5);
        case "iiii":
        default:
          return mapValue(match5.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match5.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback5);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser2;
}(Parser2);
var AMPMParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(AMPMParser2, _Parser);
  var _super = _createSuper(AMPMParser2);
  function AMPMParser2() {
    var _this;
    _classCallCheck$1(this, AMPMParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass$1(AMPMParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "a":
        case "aa":
        case "aaa":
          return match5.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return match5.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return match5.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match5.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser2;
}(Parser2);
var AMPMMidnightParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(AMPMMidnightParser2, _Parser);
  var _super = _createSuper(AMPMMidnightParser2);
  function AMPMMidnightParser2() {
    var _this;
    _classCallCheck$1(this, AMPMMidnightParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass$1(AMPMMidnightParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "b":
        case "bb":
        case "bbb":
          return match5.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return match5.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return match5.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match5.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser2;
}(Parser2);
var DayPeriodParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(DayPeriodParser2, _Parser);
  var _super = _createSuper(DayPeriodParser2);
  function DayPeriodParser2() {
    var _this;
    _classCallCheck$1(this, DayPeriodParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 80);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["a", "b", "t", "T"]);
    return _this;
  }
  _createClass$1(DayPeriodParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "B":
        case "BB":
        case "BBB":
          return match5.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return match5.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return match5.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match5.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match5.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser2;
}(Parser2);
var Hour1to12Parser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(Hour1to12Parser2, _Parser);
  var _super = _createSuper(Hour1to12Parser2);
  function Hour1to12Parser2() {
    var _this;
    _classCallCheck$1(this, Hour1to12Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["H", "K", "k", "t", "T"]);
    return _this;
  }
  _createClass$1(Hour1to12Parser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "h":
          return parseNumericPattern(numericPatterns.hour12h, dateString);
        case "ho":
          return match5.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser2;
}(Parser2);
var Hour0to23Parser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(Hour0to23Parser2, _Parser);
  var _super = _createSuper(Hour0to23Parser2);
  function Hour0to23Parser2() {
    var _this;
    _classCallCheck$1(this, Hour0to23Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
    return _this;
  }
  _createClass$1(Hour0to23Parser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "H":
          return parseNumericPattern(numericPatterns.hour23h, dateString);
        case "Ho":
          return match5.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser2;
}(Parser2);
var Hour0To11Parser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(Hour0To11Parser2, _Parser);
  var _super = _createSuper(Hour0To11Parser2);
  function Hour0To11Parser2() {
    var _this;
    _classCallCheck$1(this, Hour0To11Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["h", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass$1(Hour0To11Parser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "K":
          return parseNumericPattern(numericPatterns.hour11h, dateString);
        case "Ko":
          return match5.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser2;
}(Parser2);
var Hour1To24Parser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(Hour1To24Parser2, _Parser);
  var _super = _createSuper(Hour1To24Parser2);
  function Hour1To24Parser2() {
    var _this;
    _classCallCheck$1(this, Hour1To24Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
    return _this;
  }
  _createClass$1(Hour1To24Parser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "k":
          return parseNumericPattern(numericPatterns.hour24h, dateString);
        case "ko":
          return match5.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      var hours2 = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours2, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser2;
}(Parser2);
var MinuteParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(MinuteParser2, _Parser);
  var _super = _createSuper(MinuteParser2);
  function MinuteParser2() {
    var _this;
    _classCallCheck$1(this, MinuteParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 60);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass$1(MinuteParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "m":
          return parseNumericPattern(numericPatterns.minute, dateString);
        case "mo":
          return match5.ordinalNumber(dateString, {
            unit: "minute"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);
  return MinuteParser2;
}(Parser2);
var SecondParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(SecondParser2, _Parser);
  var _super = _createSuper(SecondParser2);
  function SecondParser2() {
    var _this;
    _classCallCheck$1(this, SecondParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 50);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass$1(SecondParser2, [{
    key: "parse",
    value: function parse3(dateString, token2, match5) {
      switch (token2) {
        case "s":
          return parseNumericPattern(numericPatterns.second, dateString);
        case "so":
          return match5.ordinalNumber(dateString, {
            unit: "second"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);
  return SecondParser2;
}(Parser2);
var FractionOfSecondParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(FractionOfSecondParser2, _Parser);
  var _super = _createSuper(FractionOfSecondParser2);
  function FractionOfSecondParser2() {
    var _this;
    _classCallCheck$1(this, FractionOfSecondParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 30);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass$1(FractionOfSecondParser2, [{
    key: "parse",
    value: function parse3(dateString, token2) {
      var valueCallback5 = function valueCallback6(value) {
        return Math.floor(value * Math.pow(10, -token2.length + 3));
      };
      return mapValue(parseNDigits(token2.length, dateString), valueCallback5);
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);
  return FractionOfSecondParser2;
}(Parser2);
var ISOTimezoneWithZParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(ISOTimezoneWithZParser2, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser2);
  function ISOTimezoneWithZParser2() {
    var _this;
    _classCallCheck$1(this, ISOTimezoneWithZParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 10);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T", "x"]);
    return _this;
  }
  _createClass$1(ISOTimezoneWithZParser2, [{
    key: "parse",
    value: function parse3(dateString, token2) {
      switch (token2) {
        case "X":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case "XX":
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case "XXXX":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case "XXXXX":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case "XXX":
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags3, value) {
      if (flags3.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneWithZParser2;
}(Parser2);
var ISOTimezoneParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(ISOTimezoneParser2, _Parser);
  var _super = _createSuper(ISOTimezoneParser2);
  function ISOTimezoneParser2() {
    var _this;
    _classCallCheck$1(this, ISOTimezoneParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 10);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ["t", "T", "X"]);
    return _this;
  }
  _createClass$1(ISOTimezoneParser2, [{
    key: "parse",
    value: function parse3(dateString, token2) {
      switch (token2) {
        case "x":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case "xx":
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case "xxxx":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case "xxxxx":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case "xxx":
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags3, value) {
      if (flags3.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneParser2;
}(Parser2);
var TimestampSecondsParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(TimestampSecondsParser2, _Parser);
  var _super = _createSuper(TimestampSecondsParser2);
  function TimestampSecondsParser2() {
    var _this;
    _classCallCheck$1(this, TimestampSecondsParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 40);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", "*");
    return _this;
  }
  _createClass$1(TimestampSecondsParser2, [{
    key: "parse",
    value: function parse3(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value) {
      return [new Date(value * 1e3), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser2;
}(Parser2);
var TimestampMillisecondsParser = /* @__PURE__ */ function(_Parser) {
  _inherits$1(TimestampMillisecondsParser2, _Parser);
  var _super = _createSuper(TimestampMillisecondsParser2);
  function TimestampMillisecondsParser2() {
    var _this;
    _classCallCheck$1(this, TimestampMillisecondsParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized$1(_this), "priority", 20);
    _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", "*");
    return _this;
  }
  _createClass$1(TimestampMillisecondsParser2, [{
    key: "parse",
    value: function parse3(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser2;
}(Parser2);
var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse2(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions2 = getDefaultOptions();
  var locale2 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : locale$2;
  if (!locale2.match) {
    throw new RangeError("locale must contain match property");
  }
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (formatString === "") {
    if (dateString === "") {
      return toDate$1(dirtyReferenceDate);
    } else {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2
  };
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens2 = formatString.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters) {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp);
  var usedTokens = [];
  var _iterator3 = _createForOfIteratorHelper(tokens2), _step;
  try {
    var _loop = function _loop2() {
      var token2 = _step.value;
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token2)) {
        throwProtectedError(token2, formatString, dirtyDateString);
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token2)) {
        throwProtectedError(token2, formatString, dirtyDateString);
      }
      var firstCharacter = token2[0];
      var parser2 = parsers[firstCharacter];
      if (parser2) {
        var incompatibleTokens = parser2.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function(usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token2, "` at the same time"));
          }
        } else if (parser2.incompatibleTokens === "*" && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token2, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token2
        });
        var parseResult = parser2.run(dateString, token2, locale2.match, subFnOptions);
        if (!parseResult) {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        }
        if (token2 === "''") {
          token2 = "'";
        } else if (firstCharacter === "'") {
          token2 = cleanEscapedString(token2);
        }
        if (dateString.indexOf(token2) === 0) {
          dateString = dateString.slice(token2.length);
        } else {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
      }
    };
    for (_iterator3.s(); !(_step = _iterator3.n()).done; ) {
      var _ret = _loop();
      if (_typeof(_ret) === "object") return _ret.v;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function(setter3) {
    return setter3.priority;
  }).sort(function(a4, b3) {
    return b3 - a4;
  }).filter(function(priority, index2, array) {
    return array.indexOf(priority) === index2;
  }).map(function(priority) {
    return setters.filter(function(setter3) {
      return setter3.priority === priority;
    }).sort(function(a4, b3) {
      return b3.subPriority - a4.subPriority;
    });
  }).map(function(setterArray) {
    return setterArray[0];
  });
  var date = toDate$1(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags3 = {};
  var _iterator22 = _createForOfIteratorHelper(uniquePrioritySetters), _step2;
  try {
    for (_iterator22.s(); !(_step2 = _iterator22.n()).done; ) {
      var setter2 = _step2.value;
      if (!setter2.validate(utcDate, subFnOptions)) {
        return /* @__PURE__ */ new Date(NaN);
      }
      var result2 = setter2.set(utcDate, flags3, subFnOptions);
      if (Array.isArray(result2)) {
        utcDate = result2[0];
        assign(flags3, result2[1]);
      } else {
        utcDate = result2;
      }
    }
  } catch (err) {
    _iterator22.e(err);
  } finally {
    _iterator22.f();
  }
  return utcDate;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
function parseISO(argument, options) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = void 0) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  }
  if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var timestamp = date.getTime();
  var time2 = 0;
  var offset2;
  if (dateStrings.time) {
    time2 = parseTime(dateStrings.time);
    if (isNaN(time2)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset2 = parseTimezone(dateStrings.timezone);
    if (isNaN(offset2)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time2);
    var result2 = /* @__PURE__ */ new Date(0);
    result2.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result2.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result2;
  }
  return new Date(timestamp + time2 + offset2);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token2 = patterns.timezone.exec(timeString);
    if (token2) {
      dateStrings.time = timeString.replace(token2[1], "");
      dateStrings.timezone = token2[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex2 = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
  var captures = dateString.match(regex2);
  if (!captures) return {
    year: NaN,
    restDateString: ""
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  if (year === null) return /* @__PURE__ */ new Date(NaN);
  var captures = dateString.match(dateRegex);
  if (!captures) return /* @__PURE__ */ new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = /* @__PURE__ */ new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN;
  var hours2 = parseTimeUnit(captures[1]);
  var minutes2 = parseTimeUnit(captures[2]);
  var seconds2 = parseTimeUnit(captures[3]);
  if (!validateTime(hours2, minutes2, seconds2)) {
    return NaN;
  }
  return hours2 * millisecondsInHour + minutes2 * millisecondsInMinute + seconds2 * 1e3;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign2 = captures[1] === "+" ? -1 : 1;
  var hours2 = parseInt(captures[2]);
  var minutes2 = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours2, minutes2)) {
    return NaN;
  }
  return sign2 * (hours2 * millisecondsInHour + minutes2 * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = /* @__PURE__ */ new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff2 = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff2);
  return date;
}
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours2, minutes2, seconds2) {
  if (hours2 === 24) {
    return minutes2 === 0 && seconds2 === 0;
  }
  return seconds2 >= 0 && seconds2 < 60 && minutes2 >= 0 && minutes2 < 60 && hours2 >= 0 && hours2 < 25;
}
function validateTimezone(_hours, minutes2) {
  return minutes2 >= 0 && minutes2 <= 59;
}
function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf3(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i3;
  for (i3 = 0; i3 < sourceKeys.length; i3++) {
    key2 = sourceKeys[i3];
    if (excluded.indexOf(key2) >= 0) continue;
    target[key2] = source[key2];
  }
  return target;
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function isNodeFound(current2, componentNode, ignoreClass) {
  if (current2 === componentNode) {
    return true;
  }
  if (current2.correspondingElement) {
    return current2.correspondingElement.classList.contains(ignoreClass);
  }
  return current2.classList.contains(ignoreClass);
}
function findHighest(current2, componentNode, ignoreClass) {
  if (current2 === componentNode) {
    return true;
  }
  while (current2.parentNode || current2.host) {
    if (current2.parentNode && isNodeFound(current2, componentNode, ignoreClass)) {
      return true;
    }
    current2 = current2.parentNode || current2.host;
  }
  return current2;
}
function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}
var testPassiveEventSupport = function testPassiveEventSupport2() {
  if (typeof window === "undefined" || typeof window.addEventListener !== "function") {
    return;
  }
  var passive = false;
  var options = Object.defineProperty({}, "passive", {
    get: function get2() {
      passive = true;
    }
  });
  var noop2 = function noop3() {
  };
  window.addEventListener("testPassiveEventSupport", noop2, options);
  window.removeEventListener("testPassiveEventSupport", noop2, options);
  return passive;
};
function autoInc(seed2) {
  if (seed2 === void 0) {
    seed2 = 0;
  }
  return function() {
    return ++seed2;
  };
}
var uid = autoInc();
var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ["touchstart", "touchmove"];
var IGNORE_CLASS_NAME = "ignore-react-onclickoutside";
function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent2 = touchEvents.indexOf(eventName) !== -1;
  if (isTouchEvent2 && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }
  return handlerOptions;
}
function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;
  var componentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
  return _temp = _class = /* @__PURE__ */ function(_Component) {
    _inheritsLoose$1(onClickOutside, _Component);
    function onClickOutside(props2) {
      var _this;
      _this = _Component.call(this, props2) || this;
      _this.__outsideClickHandler = function(event) {
        if (typeof _this.__clickOutsideHandlerProp === "function") {
          _this.__clickOutsideHandlerProp(event);
          return;
        }
        var instance = _this.getInstance();
        if (typeof instance.props.handleClickOutside === "function") {
          instance.props.handleClickOutside(event);
          return;
        }
        if (typeof instance.handleClickOutside === "function") {
          instance.handleClickOutside(event);
          return;
        }
        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };
      _this.__getComponentNode = function() {
        var instance = _this.getInstance();
        if (typeof instance.setClickOutsideRef === "function") {
          return instance.setClickOutsideRef();
        }
        return findDOMNode(instance);
      };
      _this.enableOnClickOutside = function() {
        if (typeof document === "undefined" || enabledInstances[_this._uid]) {
          return;
        }
        if (typeof passiveEventSupport === "undefined") {
          passiveEventSupport = testPassiveEventSupport();
        }
        enabledInstances[_this._uid] = true;
        var events2 = _this.props.eventTypes;
        if (!events2.forEach) {
          events2 = [events2];
        }
        handlersMap[_this._uid] = function(event) {
          if (_this.componentNode === null) return;
          if (_this.initTimeStamp > event.timeStamp) return;
          if (_this.props.preventDefault) {
            event.preventDefault();
          }
          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }
          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current2 = event.composed && event.composedPath && event.composedPath().shift() || event.target;
          if (findHighest(current2, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }
          _this.__outsideClickHandler(event);
        };
        events2.forEach(function(eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };
      _this.disableOnClickOutside = function() {
        delete enabledInstances[_this._uid];
        var fn2 = handlersMap[_this._uid];
        if (fn2 && typeof document !== "undefined") {
          var events2 = _this.props.eventTypes;
          if (!events2.forEach) {
            events2 = [events2];
          }
          events2.forEach(function(eventName) {
            return document.removeEventListener(eventName, fn2, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };
      _this.getRef = function(ref2) {
        return _this.instanceRef = ref2;
      };
      _this._uid = uid();
      _this.initTimeStamp = performance.now();
      return _this;
    }
    var _proto = onClickOutside.prototype;
    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }
      var ref2 = this.instanceRef;
      return ref2.getInstance ? ref2.getInstance() : ref2;
    };
    _proto.componentDidMount = function componentDidMount() {
      if (typeof document === "undefined" || !document.createElement) {
        return;
      }
      this.getInstance();
      this.componentNode = this.__getComponentNode();
      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    _proto.render = function render() {
      var _this$props = this.props;
      _this$props.excludeScrollbar;
      var props2 = _objectWithoutPropertiesLoose$1(_this$props, ["excludeScrollbar"]);
      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props2.ref = this.getRef;
      } else {
        props2.wrappedRef = this.getRef;
      }
      props2.disableOnClickOutside = this.disableOnClickOutside;
      props2.enableOnClickOutside = this.enableOnClickOutside;
      return createElement$2(WrappedComponent, props2);
    };
    return onClickOutside;
  }(Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function() {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}
function _objectWithoutPropertiesLoose(r2, e5) {
  if (null == r2) return {};
  var t3 = {};
  for (var n2 in r2) if ({}.hasOwnProperty.call(r2, n2)) {
    if (e5.indexOf(n2) >= 0) continue;
    t3[n2] = r2[n2];
  }
  return t3;
}
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e5 = 1; e5 < arguments.length; e5++) {
      var t3 = arguments[e5];
      for (var r2 in t3) ({}).hasOwnProperty.call(t3, r2) && (n2[r2] = t3[r2]);
    }
    return n2;
  }, _extends$2.apply(null, arguments);
}
function _inheritsLoose(t3, o2) {
  t3.prototype = Object.create(o2.prototype), t3.prototype.constructor = t3, _setPrototypeOf$1(t3, o2);
}
var toStr$3 = Object.prototype.toString;
var isArguments$2 = function isArguments(value) {
  var str = toStr$3.call(value);
  var isArgs2 = str === "[object Arguments]";
  if (!isArgs2) {
    isArgs2 = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && toStr$3.call(value.callee) === "[object Function]";
  }
  return isArgs2;
};
var implementation$9;
var hasRequiredImplementation;
function requireImplementation() {
  if (hasRequiredImplementation) return implementation$9;
  hasRequiredImplementation = 1;
  var keysShim2;
  if (!Object.keys) {
    var has2 = Object.prototype.hasOwnProperty;
    var toStr2 = Object.prototype.toString;
    var isArgs2 = isArguments$2;
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({ toString: null }, "toString");
    var hasProtoEnumBug = isEnumerable.call(function() {
    }, "prototype");
    var dontEnums = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ];
    var equalsConstructorPrototype = function(o2) {
      var ctor = o2.constructor;
      return ctor && ctor.prototype === o2;
    };
    var excludedKeys = {
      $applicationCache: true,
      $console: true,
      $external: true,
      $frame: true,
      $frameElement: true,
      $frames: true,
      $innerHeight: true,
      $innerWidth: true,
      $onmozfullscreenchange: true,
      $onmozfullscreenerror: true,
      $outerHeight: true,
      $outerWidth: true,
      $pageXOffset: true,
      $pageYOffset: true,
      $parent: true,
      $scrollLeft: true,
      $scrollTop: true,
      $scrollX: true,
      $scrollY: true,
      $self: true,
      $webkitIndexedDB: true,
      $webkitStorageInfo: true,
      $window: true
    };
    var hasAutomationEqualityBug = function() {
      if (typeof window === "undefined") {
        return false;
      }
      for (var k3 in window) {
        try {
          if (!excludedKeys["$" + k3] && has2.call(window, k3) && window[k3] !== null && typeof window[k3] === "object") {
            try {
              equalsConstructorPrototype(window[k3]);
            } catch (e5) {
              return true;
            }
          }
        } catch (e5) {
          return true;
        }
      }
      return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function(o2) {
      if (typeof window === "undefined" || !hasAutomationEqualityBug) {
        return equalsConstructorPrototype(o2);
      }
      try {
        return equalsConstructorPrototype(o2);
      } catch (e5) {
        return false;
      }
    };
    keysShim2 = function keys4(object) {
      var isObject3 = object !== null && typeof object === "object";
      var isFunction2 = toStr2.call(object) === "[object Function]";
      var isArguments5 = isArgs2(object);
      var isString2 = isObject3 && toStr2.call(object) === "[object String]";
      var theKeys = [];
      if (!isObject3 && !isFunction2 && !isArguments5) {
        throw new TypeError("Object.keys called on a non-object");
      }
      var skipProto = hasProtoEnumBug && isFunction2;
      if (isString2 && object.length > 0 && !has2.call(object, 0)) {
        for (var i3 = 0; i3 < object.length; ++i3) {
          theKeys.push(String(i3));
        }
      }
      if (isArguments5 && object.length > 0) {
        for (var j2 = 0; j2 < object.length; ++j2) {
          theKeys.push(String(j2));
        }
      } else {
        for (var name2 in object) {
          if (!(skipProto && name2 === "prototype") && has2.call(object, name2)) {
            theKeys.push(String(name2));
          }
        }
      }
      if (hasDontEnumBug) {
        var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
        for (var k3 = 0; k3 < dontEnums.length; ++k3) {
          if (!(skipConstructor && dontEnums[k3] === "constructor") && has2.call(object, dontEnums[k3])) {
            theKeys.push(dontEnums[k3]);
          }
        }
      }
      return theKeys;
    };
  }
  implementation$9 = keysShim2;
  return implementation$9;
}
var slice = Array.prototype.slice;
var isArgs = isArguments$2;
var origKeys = Object.keys;
var keysShim = origKeys ? function keys2(o2) {
  return origKeys(o2);
} : requireImplementation();
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
  if (Object.keys) {
    var keysWorksWithArguments = function() {
      var args = Object.keys(arguments);
      return args && args.length === arguments.length;
    }(1, 2);
    if (!keysWorksWithArguments) {
      Object.keys = function keys4(object) {
        if (isArgs(object)) {
          return originalKeys(slice.call(object));
        }
        return originalKeys(object);
      };
    }
  } else {
    Object.keys = keysShim;
  }
  return Object.keys || keysShim;
};
var objectKeys$1 = keysShim;
var shams$1 = function hasSymbols() {
  if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
    return false;
  }
  if (typeof Symbol.iterator === "symbol") {
    return true;
  }
  var obj = {};
  var sym = Symbol("test");
  var symObj = Object(sym);
  if (typeof sym === "string") {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
    return false;
  }
  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  }
  if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === "function") {
    var descriptor2 = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor2.value !== symVal || descriptor2.enumerable !== true) {
      return false;
    }
  }
  return true;
};
var hasSymbols$3 = shams$1;
var shams = function hasToStringTagShams() {
  return hasSymbols$3() && !!Symbol.toStringTag;
};
var esErrors = Error;
var _eval = EvalError;
var range = RangeError;
var ref = ReferenceError;
var syntax = SyntaxError;
var type = TypeError;
var uri = URIError;
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = shams$1;
var hasSymbols$2 = function hasNativeSymbols() {
  if (typeof origSymbol !== "function") {
    return false;
  }
  if (typeof Symbol !== "function") {
    return false;
  }
  if (typeof origSymbol("foo") !== "symbol") {
    return false;
  }
  if (typeof Symbol("bar") !== "symbol") {
    return false;
  }
  return hasSymbolSham();
};
var test = {
  __proto__: null,
  foo: {}
};
var $Object$1 = Object;
var hasProto$1 = function hasProto() {
  return { __proto__: test }.foo === test.foo && !(test instanceof $Object$1);
};
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var toStr$2 = Object.prototype.toString;
var max$1 = Math.max;
var funcType = "[object Function]";
var concatty = function concatty2(a4, b3) {
  var arr = [];
  for (var i3 = 0; i3 < a4.length; i3 += 1) {
    arr[i3] = a4[i3];
  }
  for (var j2 = 0; j2 < b3.length; j2 += 1) {
    arr[j2 + a4.length] = b3[j2];
  }
  return arr;
};
var slicy = function slicy2(arrLike, offset2) {
  var arr = [];
  for (var i3 = offset2, j2 = 0; i3 < arrLike.length; i3 += 1, j2 += 1) {
    arr[j2] = arrLike[i3];
  }
  return arr;
};
var joiny = function(arr, joiner) {
  var str = "";
  for (var i3 = 0; i3 < arr.length; i3 += 1) {
    str += arr[i3];
    if (i3 + 1 < arr.length) {
      str += joiner;
    }
  }
  return str;
};
var implementation$8 = function bind(that) {
  var target = this;
  if (typeof target !== "function" || toStr$2.apply(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slicy(arguments, 1);
  var bound;
  var binder = function() {
    if (this instanceof bound) {
      var result2 = target.apply(
        this,
        concatty(args, arguments)
      );
      if (Object(result2) === result2) {
        return result2;
      }
      return this;
    }
    return target.apply(
      that,
      concatty(args, arguments)
    );
  };
  var boundLength = max$1(0, target.length - args.length);
  var boundArgs = [];
  for (var i3 = 0; i3 < boundLength; i3++) {
    boundArgs[i3] = "$" + i3;
  }
  bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
  if (target.prototype) {
    var Empty2 = function Empty3() {
    };
    Empty2.prototype = target.prototype;
    bound.prototype = new Empty2();
    Empty2.prototype = null;
  }
  return bound;
};
var implementation$7 = implementation$8;
var functionBind = Function.prototype.bind || implementation$7;
var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind$1 = functionBind;
var hasown = bind$1.call(call, $hasOwn);
var undefined$1;
var $Error = esErrors;
var $EvalError = _eval;
var $RangeError = range;
var $ReferenceError = ref;
var $SyntaxError$1 = syntax;
var $TypeError$4 = type;
var $URIError = uri;
var $Function = Function;
var getEvalledConstructor = function(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
  } catch (e5) {
  }
};
var $gOPD$2 = Object.getOwnPropertyDescriptor;
if ($gOPD$2) {
  try {
    $gOPD$2({}, "");
  } catch (e5) {
    $gOPD$2 = null;
  }
}
var throwTypeError = function() {
  throw new $TypeError$4();
};
var ThrowTypeError = $gOPD$2 ? function() {
  try {
    arguments.callee;
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      return $gOPD$2(arguments, "callee").get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols$1 = hasSymbols$2();
var hasProto2 = hasProto$1();
var getProto$1 = Object.getPrototypeOf || (hasProto2 ? function(x3) {
  return x3.__proto__;
} : null);
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto$1 ? undefined$1 : getProto$1(Uint8Array);
var INTRINSICS = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols$1 && getProto$1 ? getProto$1([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": $Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": $EvalError,
  "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols$1 && getProto$1 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
  "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols$1 || !getProto$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
  "%RangeError%": $RangeError,
  "%ReferenceError%": $ReferenceError,
  "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols$1 || !getProto$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols$1 && getProto$1 ? getProto$1(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols$1 ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError$1,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$4,
  "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
  "%URIError%": $URIError,
  "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
};
if (getProto$1) {
  try {
    null.error;
  } catch (e5) {
    var errorProto = getProto$1(getProto$1(e5));
    INTRINSICS["%Error.prototype%"] = errorProto;
  }
}
var doEval = function doEval2(name2) {
  var value;
  if (name2 === "%AsyncFunction%") {
    value = getEvalledConstructor("async function () {}");
  } else if (name2 === "%GeneratorFunction%") {
    value = getEvalledConstructor("function* () {}");
  } else if (name2 === "%AsyncGeneratorFunction%") {
    value = getEvalledConstructor("async function* () {}");
  } else if (name2 === "%AsyncGenerator%") {
    var fn2 = doEval2("%AsyncGeneratorFunction%");
    if (fn2) {
      value = fn2.prototype;
    }
  } else if (name2 === "%AsyncIteratorPrototype%") {
    var gen = doEval2("%AsyncGenerator%");
    if (gen && getProto$1) {
      value = getProto$1(gen.prototype);
    }
  }
  INTRINSICS[name2] = value;
  return value;
};
var LEGACY_ALIASES = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
};
var bind2 = functionBind;
var hasOwn = hasown;
var $concat = bind2.call(Function.call, Array.prototype.concat);
var $spliceApply = bind2.call(Function.apply, Array.prototype.splice);
var $replace = bind2.call(Function.call, String.prototype.replace);
var $strSlice = bind2.call(Function.call, String.prototype.slice);
var $exec$1 = bind2.call(Function.call, RegExp.prototype.exec);
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = function stringToPath2(string3) {
  var first2 = $strSlice(string3, 0, 1);
  var last2 = $strSlice(string3, -1);
  if (first2 === "%" && last2 !== "%") {
    throw new $SyntaxError$1("invalid intrinsic syntax, expected closing `%`");
  } else if (last2 === "%" && first2 !== "%") {
    throw new $SyntaxError$1("invalid intrinsic syntax, expected opening `%`");
  }
  var result2 = [];
  $replace(string3, rePropName, function(match5, number, quote, subString) {
    result2[result2.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match5;
  });
  return result2;
};
var getBaseIntrinsic = function getBaseIntrinsic2(name2, allowMissing) {
  var intrinsicName = name2;
  var alias;
  if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = "%" + alias[0] + "%";
  }
  if (hasOwn(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];
    if (value === needsEval) {
      value = doEval(intrinsicName);
    }
    if (typeof value === "undefined" && !allowMissing) {
      throw new $TypeError$4("intrinsic " + name2 + " exists, but is not available. Please file an issue!");
    }
    return {
      alias,
      name: intrinsicName,
      value
    };
  }
  throw new $SyntaxError$1("intrinsic " + name2 + " does not exist!");
};
var getIntrinsic = function GetIntrinsic(name2, allowMissing) {
  if (typeof name2 !== "string" || name2.length === 0) {
    throw new $TypeError$4("intrinsic name must be a non-empty string");
  }
  if (arguments.length > 1 && typeof allowMissing !== "boolean") {
    throw new $TypeError$4('"allowMissing" argument must be a boolean');
  }
  if ($exec$1(/^%?[^%]*%?$/, name2) === null) {
    throw new $SyntaxError$1("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  }
  var parts = stringToPath(name2);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
  var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat([0, 1], alias));
  }
  for (var i3 = 1, isOwn = true; i3 < parts.length; i3 += 1) {
    var part = parts[i3];
    var first2 = $strSlice(part, 0, 1);
    var last2 = $strSlice(part, -1);
    if ((first2 === '"' || first2 === "'" || first2 === "`" || (last2 === '"' || last2 === "'" || last2 === "`")) && first2 !== last2) {
      throw new $SyntaxError$1("property names with quotes must have matching quotes");
    }
    if (part === "constructor" || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += "." + part;
    intrinsicRealName = "%" + intrinsicBaseName + "%";
    if (hasOwn(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError$4("base intrinsic for " + name2 + " exists, but the property is not available.");
        }
        return void 0;
      }
      if ($gOPD$2 && i3 + 1 >= parts.length) {
        var desc = $gOPD$2(value, part);
        isOwn = !!desc;
        if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn(value, part);
        value = value[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }
  return value;
};
var callBind$3 = { exports: {} };
var GetIntrinsic$3 = getIntrinsic;
var $defineProperty$2 = GetIntrinsic$3("%Object.defineProperty%", true) || false;
if ($defineProperty$2) {
  try {
    $defineProperty$2({}, "a", { value: 1 });
  } catch (e5) {
    $defineProperty$2 = false;
  }
}
var esDefineProperty = $defineProperty$2;
var GetIntrinsic$2 = getIntrinsic;
var $gOPD$1 = GetIntrinsic$2("%Object.getOwnPropertyDescriptor%", true);
if ($gOPD$1) {
  try {
    $gOPD$1([], "length");
  } catch (e5) {
    $gOPD$1 = null;
  }
}
var gopd$1 = $gOPD$1;
var $defineProperty$1 = esDefineProperty;
var $SyntaxError = syntax;
var $TypeError$3 = type;
var gopd = gopd$1;
var defineDataProperty$1 = function defineDataProperty(obj, property2, value) {
  if (!obj || typeof obj !== "object" && typeof obj !== "function") {
    throw new $TypeError$3("`obj` must be an object or a function`");
  }
  if (typeof property2 !== "string" && typeof property2 !== "symbol") {
    throw new $TypeError$3("`property` must be a string or a symbol`");
  }
  if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) {
    throw new $TypeError$3("`nonEnumerable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) {
    throw new $TypeError$3("`nonWritable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) {
    throw new $TypeError$3("`nonConfigurable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 6 && typeof arguments[6] !== "boolean") {
    throw new $TypeError$3("`loose`, if provided, must be a boolean");
  }
  var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
  var nonWritable = arguments.length > 4 ? arguments[4] : null;
  var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
  var loose = arguments.length > 6 ? arguments[6] : false;
  var desc = !!gopd && gopd(obj, property2);
  if ($defineProperty$1) {
    $defineProperty$1(obj, property2, {
      configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
      enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
      value,
      writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
  } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
    obj[property2] = value;
  } else {
    throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }
};
var $defineProperty = esDefineProperty;
var hasPropertyDescriptors = function hasPropertyDescriptors2() {
  return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
  if (!$defineProperty) {
    return null;
  }
  try {
    return $defineProperty([], "length", { value: 1 }).length !== 1;
  } catch (e5) {
    return true;
  }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors;
var GetIntrinsic$1 = getIntrinsic;
var define$4 = defineDataProperty$1;
var hasDescriptors$1 = hasPropertyDescriptors_1();
var gOPD$3 = gopd$1;
var $TypeError$2 = type;
var $floor = GetIntrinsic$1("%Math.floor%");
var setFunctionLength = function setFunctionLength2(fn2, length) {
  if (typeof fn2 !== "function") {
    throw new $TypeError$2("`fn` is not a function");
  }
  if (typeof length !== "number" || length < 0 || length > 4294967295 || $floor(length) !== length) {
    throw new $TypeError$2("`length` must be a positive 32-bit integer");
  }
  var loose = arguments.length > 2 && !!arguments[2];
  var functionLengthIsConfigurable = true;
  var functionLengthIsWritable = true;
  if ("length" in fn2 && gOPD$3) {
    var desc = gOPD$3(fn2, "length");
    if (desc && !desc.configurable) {
      functionLengthIsConfigurable = false;
    }
    if (desc && !desc.writable) {
      functionLengthIsWritable = false;
    }
  }
  if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
    if (hasDescriptors$1) {
      define$4(
        /** @type {Parameters<define>[0]} */
        fn2,
        "length",
        length,
        true,
        true
      );
    } else {
      define$4(
        /** @type {Parameters<define>[0]} */
        fn2,
        "length",
        length
      );
    }
  }
  return fn2;
};
(function(module2) {
  var bind3 = functionBind;
  var GetIntrinsic3 = getIntrinsic;
  var setFunctionLength$1 = setFunctionLength;
  var $TypeError2 = type;
  var $apply = GetIntrinsic3("%Function.prototype.apply%");
  var $call = GetIntrinsic3("%Function.prototype.call%");
  var $reflectApply = GetIntrinsic3("%Reflect.apply%", true) || bind3.call($call, $apply);
  var $defineProperty2 = esDefineProperty;
  var $max = GetIntrinsic3("%Math.max%");
  module2.exports = function callBind2(originalFunction) {
    if (typeof originalFunction !== "function") {
      throw new $TypeError2("a function is required");
    }
    var func = $reflectApply(bind3, $call, arguments);
    return setFunctionLength$1(
      func,
      1 + $max(0, originalFunction.length - (arguments.length - 1)),
      true
    );
  };
  var applyBind = function applyBind2() {
    return $reflectApply(bind3, $apply, arguments);
  };
  if ($defineProperty2) {
    $defineProperty2(module2.exports, "apply", { value: applyBind });
  } else {
    module2.exports.apply = applyBind;
  }
})(callBind$3);
var callBindExports = callBind$3.exports;
var GetIntrinsic2 = getIntrinsic;
var callBind$2 = callBindExports;
var $indexOf = callBind$2(GetIntrinsic2("String.prototype.indexOf"));
var callBound$2 = function callBoundIntrinsic(name2, allowMissing) {
  var intrinsic = GetIntrinsic2(name2, !!allowMissing);
  if (typeof intrinsic === "function" && $indexOf(name2, ".prototype.") > -1) {
    return callBind$2(intrinsic);
  }
  return intrinsic;
};
var hasToStringTag$2 = shams();
var callBound$1 = callBound$2;
var $toString$1 = callBound$1("Object.prototype.toString");
var isStandardArguments = function isArguments2(value) {
  if (hasToStringTag$2 && value && typeof value === "object" && Symbol.toStringTag in value) {
    return false;
  }
  return $toString$1(value) === "[object Arguments]";
};
var isLegacyArguments = function isArguments3(value) {
  if (isStandardArguments(value)) {
    return true;
  }
  return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString$1(value) !== "[object Array]" && $toString$1(value.callee) === "[object Function]";
};
var supportsStandardArguments = function() {
  return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments;
var isArguments$1 = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
var keys$1 = objectKeys$1;
var hasSymbols2 = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var toStr$1 = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty2 = defineDataProperty$1;
var isFunction$2 = function(fn2) {
  return typeof fn2 === "function" && toStr$1.call(fn2) === "[object Function]";
};
var supportsDescriptors$2 = hasPropertyDescriptors_1();
var defineProperty$2 = function(object, name2, value, predicate) {
  if (name2 in object) {
    if (predicate === true) {
      if (object[name2] === value) {
        return;
      }
    } else if (!isFunction$2(predicate) || !predicate()) {
      return;
    }
  }
  if (supportsDescriptors$2) {
    defineDataProperty2(object, name2, value, true);
  } else {
    defineDataProperty2(object, name2, value);
  }
};
var defineProperties3 = function(object, map2) {
  var predicates = arguments.length > 2 ? arguments[2] : {};
  var props2 = keys$1(map2);
  if (hasSymbols2) {
    props2 = concat.call(props2, Object.getOwnPropertySymbols(map2));
  }
  for (var i3 = 0; i3 < props2.length; i3 += 1) {
    defineProperty$2(object, props2[i3], map2[props2[i3]], predicates[props2[i3]]);
  }
};
defineProperties3.supportsDescriptors = !!supportsDescriptors$2;
var defineProperties_1 = defineProperties3;
var numberIsNaN = function(value) {
  return value !== value;
};
var implementation$6 = function is(a4, b3) {
  if (a4 === 0 && b3 === 0) {
    return 1 / a4 === 1 / b3;
  }
  if (a4 === b3) {
    return true;
  }
  if (numberIsNaN(a4) && numberIsNaN(b3)) {
    return true;
  }
  return false;
};
var implementation$5 = implementation$6;
var polyfill$2 = function getPolyfill() {
  return typeof Object.is === "function" ? Object.is : implementation$5;
};
var getPolyfill$3 = polyfill$2;
var define$3 = defineProperties_1;
var shim$3 = function shimObjectIs() {
  var polyfill2 = getPolyfill$3();
  define$3(Object, { is: polyfill2 }, {
    is: function testObjectIs() {
      return Object.is !== polyfill2;
    }
  });
  return polyfill2;
};
var define$2 = defineProperties_1;
var callBind$1 = callBindExports;
var implementation$4 = implementation$6;
var getPolyfill$2 = polyfill$2;
var shim$2 = shim$3;
var polyfill$1 = callBind$1(getPolyfill$2(), Object);
define$2(polyfill$1, {
  getPolyfill: getPolyfill$2,
  implementation: implementation$4,
  shim: shim$2
});
var objectIs = polyfill$1;
var callBound = callBound$2;
var hasToStringTag$1 = shams();
var has;
var $exec;
var isRegexMarker;
var badStringifier;
if (hasToStringTag$1) {
  has = callBound("Object.prototype.hasOwnProperty");
  $exec = callBound("RegExp.prototype.exec");
  isRegexMarker = {};
  var throwRegexMarker = function() {
    throw isRegexMarker;
  };
  badStringifier = {
    toString: throwRegexMarker,
    valueOf: throwRegexMarker
  };
  if (typeof Symbol.toPrimitive === "symbol") {
    badStringifier[Symbol.toPrimitive] = throwRegexMarker;
  }
}
var $toString = callBound("Object.prototype.toString");
var gOPD$2 = Object.getOwnPropertyDescriptor;
var regexClass = "[object RegExp]";
var isRegex$1 = hasToStringTag$1 ? function isRegex(value) {
  if (!value || typeof value !== "object") {
    return false;
  }
  var descriptor2 = gOPD$2(value, "lastIndex");
  var hasLastIndexDataProperty = descriptor2 && has(descriptor2, "value");
  if (!hasLastIndexDataProperty) {
    return false;
  }
  try {
    $exec(value, badStringifier);
  } catch (e5) {
    return e5 === isRegexMarker;
  }
} : function isRegex2(value) {
  if (!value || typeof value !== "object" && typeof value !== "function") {
    return false;
  }
  return $toString(value) === regexClass;
};
var functionsHaveNames = function functionsHaveNames2() {
  return typeof (function f2() {
  }).name === "string";
};
var gOPD$1 = Object.getOwnPropertyDescriptor;
if (gOPD$1) {
  try {
    gOPD$1([], "length");
  } catch (e5) {
    gOPD$1 = null;
  }
}
functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
  if (!functionsHaveNames() || !gOPD$1) {
    return false;
  }
  var desc = gOPD$1(function() {
  }, "name");
  return !!desc && !!desc.configurable;
};
var $bind = Function.prototype.bind;
functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
  return functionsHaveNames() && typeof $bind === "function" && (function f2() {
  }).bind().name !== "";
};
var functionsHaveNames_1 = functionsHaveNames;
var define$1 = defineDataProperty$1;
var hasDescriptors = hasPropertyDescriptors_1();
var functionsHaveConfigurableNames2 = functionsHaveNames_1.functionsHaveConfigurableNames();
var $TypeError$1 = type;
var setFunctionName$1 = function setFunctionName(fn2, name2) {
  if (typeof fn2 !== "function") {
    throw new $TypeError$1("`fn` is not a function");
  }
  var loose = arguments.length > 2 && !!arguments[2];
  if (!loose || functionsHaveConfigurableNames2) {
    if (hasDescriptors) {
      define$1(
        /** @type {Parameters<define>[0]} */
        fn2,
        "name",
        name2,
        true,
        true
      );
    } else {
      define$1(
        /** @type {Parameters<define>[0]} */
        fn2,
        "name",
        name2
      );
    }
  }
  return fn2;
};
var setFunctionName2 = setFunctionName$1;
var $TypeError = type;
var $Object = Object;
var implementation$3 = setFunctionName2(function flags() {
  if (this == null || this !== $Object(this)) {
    throw new $TypeError("RegExp.prototype.flags getter called on non-object");
  }
  var result2 = "";
  if (this.hasIndices) {
    result2 += "d";
  }
  if (this.global) {
    result2 += "g";
  }
  if (this.ignoreCase) {
    result2 += "i";
  }
  if (this.multiline) {
    result2 += "m";
  }
  if (this.dotAll) {
    result2 += "s";
  }
  if (this.unicode) {
    result2 += "u";
  }
  if (this.unicodeSets) {
    result2 += "v";
  }
  if (this.sticky) {
    result2 += "y";
  }
  return result2;
}, "get flags", true);
var implementation$2 = implementation$3;
var supportsDescriptors$1 = defineProperties_1.supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
var polyfill = function getPolyfill2() {
  if (supportsDescriptors$1 && /a/mig.flags === "gim") {
    var descriptor2 = $gOPD(RegExp.prototype, "flags");
    if (descriptor2 && typeof descriptor2.get === "function" && typeof RegExp.prototype.dotAll === "boolean" && typeof RegExp.prototype.hasIndices === "boolean") {
      var calls = "";
      var o2 = {};
      Object.defineProperty(o2, "hasIndices", {
        get: function() {
          calls += "d";
        }
      });
      Object.defineProperty(o2, "sticky", {
        get: function() {
          calls += "y";
        }
      });
      if (calls === "dy") {
        return descriptor2.get;
      }
    }
  }
  return implementation$2;
};
var supportsDescriptors = defineProperties_1.supportsDescriptors;
var getPolyfill$1 = polyfill;
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty$1 = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;
var shim$1 = function shimFlags() {
  if (!supportsDescriptors || !getProto) {
    throw new TypeErr("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
  }
  var polyfill2 = getPolyfill$1();
  var proto2 = getProto(regex);
  var descriptor2 = gOPD(proto2, "flags");
  if (!descriptor2 || descriptor2.get !== polyfill2) {
    defineProperty$1(proto2, "flags", {
      configurable: true,
      enumerable: false,
      get: polyfill2
    });
  }
  return polyfill2;
};
var define = defineProperties_1;
var callBind = callBindExports;
var implementation$1 = implementation$3;
var getPolyfill3 = polyfill;
var shim = shim$1;
var flagsBound = callBind(getPolyfill3());
define(flagsBound, {
  getPolyfill: getPolyfill3,
  implementation: implementation$1,
  shim
});
var regexp_prototype_flags = flagsBound;
var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
  try {
    getDay.call(value);
    return true;
  } catch (e5) {
    return false;
  }
};
var toStr = Object.prototype.toString;
var dateClass = "[object Date]";
var hasToStringTag = shams();
var isDateObject = function isDateObject2(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};
var objectKeys = objectKeys$1;
var isArguments4 = isArguments$1;
var is2 = objectIs;
var isRegex3 = isRegex$1;
var flags2 = regexp_prototype_flags;
var isDate$1 = isDateObject;
var getTime = Date.prototype.getTime;
function deepEqual(actual, expected, options) {
  var opts = options || {};
  if (opts.strict ? is2(actual, expected) : actual === expected) {
    return true;
  }
  if (!actual || !expected || typeof actual !== "object" && typeof expected !== "object") {
    return opts.strict ? is2(actual, expected) : actual == expected;
  }
  return objEquiv(actual, expected, opts);
}
function isUndefinedOrNull(value) {
  return value === null || value === void 0;
}
function isBuffer(x3) {
  if (!x3 || typeof x3 !== "object" || typeof x3.length !== "number") {
    return false;
  }
  if (typeof x3.copy !== "function" || typeof x3.slice !== "function") {
    return false;
  }
  if (x3.length > 0 && typeof x3[0] !== "number") {
    return false;
  }
  return true;
}
function objEquiv(a4, b3, opts) {
  var i3, key2;
  if (typeof a4 !== typeof b3) {
    return false;
  }
  if (isUndefinedOrNull(a4) || isUndefinedOrNull(b3)) {
    return false;
  }
  if (a4.prototype !== b3.prototype) {
    return false;
  }
  if (isArguments4(a4) !== isArguments4(b3)) {
    return false;
  }
  var aIsRegex = isRegex3(a4);
  var bIsRegex = isRegex3(b3);
  if (aIsRegex !== bIsRegex) {
    return false;
  }
  if (aIsRegex || bIsRegex) {
    return a4.source === b3.source && flags2(a4) === flags2(b3);
  }
  if (isDate$1(a4) && isDate$1(b3)) {
    return getTime.call(a4) === getTime.call(b3);
  }
  var aIsBuffer = isBuffer(a4);
  var bIsBuffer = isBuffer(b3);
  if (aIsBuffer !== bIsBuffer) {
    return false;
  }
  if (aIsBuffer || bIsBuffer) {
    if (a4.length !== b3.length) {
      return false;
    }
    for (i3 = 0; i3 < a4.length; i3++) {
      if (a4[i3] !== b3[i3]) {
        return false;
      }
    }
    return true;
  }
  if (typeof a4 !== typeof b3) {
    return false;
  }
  try {
    var ka2 = objectKeys(a4);
    var kb = objectKeys(b3);
  } catch (e5) {
    return false;
  }
  if (ka2.length !== kb.length) {
    return false;
  }
  ka2.sort();
  kb.sort();
  for (i3 = ka2.length - 1; i3 >= 0; i3--) {
    if (ka2[i3] != kb[i3]) {
      return false;
    }
  }
  for (i3 = ka2.length - 1; i3 >= 0; i3--) {
    key2 = ka2[i3];
    if (!deepEqual(a4[key2], b3[key2], opts)) {
      return false;
    }
  }
  return true;
}
var deepEqual_1 = deepEqual;
const deepEqual$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(deepEqual_1);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== "undefined";
var timeoutDuration = function() {
  var longerTimeoutBrowsers = ["Edge", "Trident", "Firefox"];
  for (var i3 = 0; i3 < longerTimeoutBrowsers.length; i3 += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i3]) >= 0) {
      return 1;
    }
  }
  return 0;
}();
function microtaskDebounce(fn2) {
  var called = false;
  return function() {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function() {
      called = false;
      fn2();
    });
  };
}
function taskDebounce(fn2) {
  var scheduled2 = false;
  return function() {
    if (!scheduled2) {
      scheduled2 = true;
      setTimeout(function() {
        scheduled2 = false;
        fn2();
      }, timeoutDuration);
    }
  };
}
var supportsMicroTasks = isBrowser && window.Promise;
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
function isFunction$1(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
}
function getStyleComputedProperty(element, property2) {
  if (element.nodeType !== 1) {
    return [];
  }
  var window2 = element.ownerDocument.defaultView;
  var css = window2.getComputedStyle(element, null);
  return property2 ? css[property2] : css;
}
function getParentNode(element) {
  if (element.nodeName === "HTML") {
    return element;
  }
  return element.parentNode || element.host;
}
function getScrollParent(element) {
  if (!element) {
    return document.body;
  }
  switch (element.nodeName) {
    case "HTML":
    case "BODY":
      return element.ownerDocument.body;
    case "#document":
      return element.body;
  }
  var _getStyleComputedProp = getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }
  return getScrollParent(getParentNode(element));
}
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
function isIE(version2) {
  if (version2 === 11) {
    return isIE11;
  }
  if (version2 === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }
  var noOffsetParent = isIE(10) ? document.body : null;
  var offsetParent = element.offsetParent || null;
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }
  var nodeName = offsetParent && offsetParent.nodeName;
  if (!nodeName || nodeName === "BODY" || nodeName === "HTML") {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }
  if (["TH", "TD", "TABLE"].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, "position") === "static") {
    return getOffsetParent(offsetParent);
  }
  return offsetParent;
}
function isOffsetContainer(element) {
  var nodeName = element.nodeName;
  if (nodeName === "BODY") {
    return false;
  }
  return nodeName === "HTML" || getOffsetParent(element.firstElementChild) === element;
}
function getRoot(node3) {
  if (node3.parentNode !== null) {
    return getRoot(node3.parentNode);
  }
  return node3;
}
function findCommonOffsetParent(element1, element2) {
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }
  var order2 = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start2 = order2 ? element1 : element2;
  var end2 = order2 ? element2 : element1;
  var range2 = document.createRange();
  range2.setStart(start2, 0);
  range2.setEnd(end2, 0);
  var commonAncestorContainer = range2.commonAncestorContainer;
  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start2.contains(end2)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }
    return getOffsetParent(commonAncestorContainer);
  }
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top";
  var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
  var nodeName = element.nodeName;
  if (nodeName === "BODY" || nodeName === "HTML") {
    var html2 = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html2;
    return scrollingElement[upperSide];
  }
  return element[upperSide];
}
function includeScroll(rect, element) {
  var subtract2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var scrollTop = getScroll(element, "top");
  var scrollLeft = getScroll(element, "left");
  var modifier = subtract2 ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}
function getBordersSize(styles2, axis) {
  var sideA = axis === "x" ? "Left" : "Top";
  var sideB = sideA === "Left" ? "Right" : "Bottom";
  return parseFloat(styles2["border" + sideA + "Width"]) + parseFloat(styles2["border" + sideB + "Width"]);
}
function getSize(axis, body, html2, computedStyle) {
  return Math.max(body["offset" + axis], body["scroll" + axis], html2["client" + axis], html2["offset" + axis], html2["scroll" + axis], isIE(10) ? parseInt(html2["offset" + axis]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Top" : "Left")]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")]) : 0);
}
function getWindowSizes(document2) {
  var body = document2.body;
  var html2 = document2.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html2);
  return {
    height: getSize("Height", body, html2, computedStyle),
    width: getSize("Width", body, html2, computedStyle)
  };
}
var classCallCheck = function(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = /* @__PURE__ */ function() {
  function defineProperties4(target, props2) {
    for (var i3 = 0; i3 < props2.length; i3++) {
      var descriptor2 = props2[i3];
      descriptor2.enumerable = descriptor2.enumerable || false;
      descriptor2.configurable = true;
      if ("value" in descriptor2) descriptor2.writable = true;
      Object.defineProperty(target, descriptor2.key, descriptor2);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties4(Constructor.prototype, protoProps);
    if (staticProps) defineProperties4(Constructor, staticProps);
    return Constructor;
  };
}();
var defineProperty3 = function(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
};
var _extends$1 = Object.assign || function(target) {
  for (var i3 = 1; i3 < arguments.length; i3++) {
    var source = arguments[i3];
    for (var key2 in source) {
      if (Object.prototype.hasOwnProperty.call(source, key2)) {
        target[key2] = source[key2];
      }
    }
  }
  return target;
};
function getClientRect(offsets) {
  return _extends$1({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}
function getBoundingClientRect(element) {
  var rect = {};
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, "top");
      var scrollLeft = getScroll(element, "left");
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e5) {
  }
  var result2 = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
  var sizes = element.nodeName === "HTML" ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result2.width;
  var height = sizes.height || element.clientHeight || result2.height;
  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;
  if (horizScrollbar || vertScrollbar) {
    var styles2 = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles2, "x");
    vertScrollbar -= getBordersSize(styles2, "y");
    result2.width -= horizScrollbar;
    result2.height -= vertScrollbar;
  }
  return getClientRect(result2);
}
function getOffsetRectRelativeToArbitraryNode(children, parent3) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var isIE102 = isIE(10);
  var isHTML = parent3.nodeName === "HTML";
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent3);
  var scrollParent = getScrollParent(children);
  var styles2 = getStyleComputedProperty(parent3);
  var borderTopWidth = parseFloat(styles2.borderTopWidth);
  var borderLeftWidth = parseFloat(styles2.borderLeftWidth);
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;
  if (!isIE102 && isHTML) {
    var marginTop = parseFloat(styles2.marginTop);
    var marginLeft = parseFloat(styles2.marginLeft);
    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }
  if (isIE102 && !fixedPosition ? parent3.contains(scrollParent) : parent3 === scrollParent && scrollParent.nodeName !== "BODY") {
    offsets = includeScroll(offsets, parent3);
  }
  return offsets;
}
function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var html2 = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html2);
  var width = Math.max(html2.clientWidth, window.innerWidth || 0);
  var height = Math.max(html2.clientHeight, window.innerHeight || 0);
  var scrollTop = !excludeScroll ? getScroll(html2) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html2, "left") : 0;
  var offset2 = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width,
    height
  };
  return getClientRect(offset2);
}
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === "BODY" || nodeName === "HTML") {
    return false;
  }
  if (getStyleComputedProperty(element, "position") === "fixed") {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}
function getFixedPositionOffsetParent(element) {
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el2 = element.parentElement;
  while (el2 && getStyleComputedProperty(el2, "transform") === "none") {
    el2 = el2.parentElement;
  }
  return el2 || document.documentElement;
}
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  if (boundariesElement === "viewport") {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    var boundariesNode = void 0;
    if (boundariesElement === "scrollParent") {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === "BODY") {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === "window") {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }
    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
    if (boundariesNode.nodeName === "HTML" && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      boundaries = offsets;
    }
  }
  padding = padding || 0;
  var isPaddingNumber = typeof padding === "number";
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
  return boundaries;
}
function getArea(_ref) {
  var width = _ref.width, height = _ref.height;
  return width * height;
}
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (placement.indexOf("auto") === -1) {
    return placement;
  }
  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };
  var sortedAreas = Object.keys(rects).map(function(key2) {
    return _extends$1({
      key: key2
    }, rects[key2], {
      area: getArea(rects[key2])
    });
  }).sort(function(a4, b3) {
    return b3.area - a4.area;
  });
  var filteredAreas = sortedAreas.filter(function(_ref2) {
    var width = _ref2.width, height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });
  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
  var variation = placement.split("-")[1];
  return computedPlacement + (variation ? "-" + variation : "");
}
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
function getOuterSizes(element) {
  var window2 = element.ownerDocument.defaultView;
  var styles2 = window2.getComputedStyle(element);
  var x3 = parseFloat(styles2.marginTop || 0) + parseFloat(styles2.marginBottom || 0);
  var y4 = parseFloat(styles2.marginLeft || 0) + parseFloat(styles2.marginRight || 0);
  var result2 = {
    width: element.offsetWidth + y4,
    height: element.offsetHeight + x3
  };
  return result2;
}
function getOppositePlacement(placement) {
  var hash = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash[matched];
  });
}
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split("-")[0];
  var popperRect = getOuterSizes(popper);
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };
  var isHoriz = ["right", "left"].indexOf(placement) !== -1;
  var mainSide = isHoriz ? "top" : "left";
  var secondarySide = isHoriz ? "left" : "top";
  var measurement = isHoriz ? "height" : "width";
  var secondaryMeasurement = !isHoriz ? "height" : "width";
  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }
  return popperOffsets;
}
function find(arr, check) {
  if (Array.prototype.find) {
    return arr.find(check);
  }
  return arr.filter(check)[0];
}
function findIndex(arr, prop, value) {
  if (Array.prototype.findIndex) {
    return arr.findIndex(function(cur) {
      return cur[prop] === value;
    });
  }
  var match5 = find(arr, function(obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match5);
}
function runModifiers(modifiers2, data, ends) {
  var modifiersToRun = ends === void 0 ? modifiers2 : modifiers2.slice(0, findIndex(modifiers2, "name", ends));
  modifiersToRun.forEach(function(modifier) {
    if (modifier["function"]) {
      console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    }
    var fn2 = modifier["function"] || modifier.fn;
    if (modifier.enabled && isFunction$1(fn2)) {
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);
      data = fn2(data, modifier);
    }
  });
  return data;
}
function update() {
  if (this.state.isDestroyed) {
    return;
  }
  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
  data.originalPlacement = data.placement;
  data.positionFixed = this.options.positionFixed;
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
  data = runModifiers(this.modifiers, data);
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}
function isModifierEnabled(modifiers2, modifierName) {
  return modifiers2.some(function(_ref) {
    var name2 = _ref.name, enabled = _ref.enabled;
    return enabled && name2 === modifierName;
  });
}
function getSupportedPropertyName(property2) {
  var prefixes = [false, "ms", "Webkit", "Moz", "O"];
  var upperProp = property2.charAt(0).toUpperCase() + property2.slice(1);
  for (var i3 = 0; i3 < prefixes.length; i3++) {
    var prefix2 = prefixes[i3];
    var toCheck = prefix2 ? "" + prefix2 + upperProp : property2;
    if (typeof document.body.style[toCheck] !== "undefined") {
      return toCheck;
    }
  }
  return null;
}
function destroy() {
  this.state.isDestroyed = true;
  if (isModifierEnabled(this.modifiers, "applyStyle")) {
    this.popper.removeAttribute("x-placement");
    this.popper.style.position = "";
    this.popper.style.top = "";
    this.popper.style.left = "";
    this.popper.style.right = "";
    this.popper.style.bottom = "";
    this.popper.style.willChange = "";
    this.popper.style[getSupportedPropertyName("transform")] = "";
  }
  this.disableEventListeners();
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}
function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === "BODY";
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });
  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}
function setupEventListeners(reference, options, state, updateBound) {
  state.updateBound = updateBound;
  getWindow(reference).addEventListener("resize", state.updateBound, { passive: true });
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;
  return state;
}
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}
function removeEventListeners(reference, state) {
  getWindow(reference).removeEventListener("resize", state.updateBound);
  state.scrollParents.forEach(function(target) {
    target.removeEventListener("scroll", state.updateBound);
  });
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}
function isNumeric(n2) {
  return n2 !== "" && !isNaN(parseFloat(n2)) && isFinite(n2);
}
function setStyles(element, styles2) {
  Object.keys(styles2).forEach(function(prop) {
    var unit = "";
    if (["width", "height", "top", "right", "bottom", "left"].indexOf(prop) !== -1 && isNumeric(styles2[prop])) {
      unit = "px";
    }
    element.style[prop] = styles2[prop] + unit;
  });
}
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function(prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}
function applyStyle(data) {
  setStyles(data.instance.popper, data.styles);
  setAttributes(data.instance.popper, data.attributes);
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }
  return data;
}
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
  popper.setAttribute("x-placement", placement);
  setStyles(popper, { position: options.positionFixed ? "fixed" : "absolute" });
  return options;
}
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var round2 = Math.round, floor2 = Math.floor;
  var noRound = function noRound2(v2) {
    return v2;
  };
  var referenceWidth = round2(reference.width);
  var popperWidth = round2(popper.width);
  var isVertical = ["left", "right"].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf("-") !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round2 : floor2;
  var verticalToInteger = !shouldRound ? noRound : round2;
  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}
var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
function computeStyle(data, options) {
  var x3 = options.x, y4 = options.y;
  var popper = data.offsets.popper;
  var legacyGpuAccelerationOption = find(data.instance.modifiers, function(modifier) {
    return modifier.name === "applyStyle";
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== void 0) {
    console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== void 0 ? legacyGpuAccelerationOption : options.gpuAcceleration;
  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);
  var styles2 = {
    position: popper.position
  };
  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
  var sideA = x3 === "bottom" ? "top" : "bottom";
  var sideB = y4 === "right" ? "left" : "right";
  var prefixedProperty = getSupportedPropertyName("transform");
  var left = void 0, top = void 0;
  if (sideA === "bottom") {
    if (offsetParent.nodeName === "HTML") {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === "right") {
    if (offsetParent.nodeName === "HTML") {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles2[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
    styles2[sideA] = 0;
    styles2[sideB] = 0;
    styles2.willChange = "transform";
  } else {
    var invertTop = sideA === "bottom" ? -1 : 1;
    var invertLeft = sideB === "right" ? -1 : 1;
    styles2[sideA] = top * invertTop;
    styles2[sideB] = left * invertLeft;
    styles2.willChange = sideA + ", " + sideB;
  }
  var attributes = {
    "x-placement": data.placement
  };
  data.attributes = _extends$1({}, attributes, data.attributes);
  data.styles = _extends$1({}, styles2, data.styles);
  data.arrowStyles = _extends$1({}, data.offsets.arrow, data.arrowStyles);
  return data;
}
function isModifierRequired(modifiers2, requestingName, requestedName) {
  var requesting = find(modifiers2, function(_ref) {
    var name2 = _ref.name;
    return name2 === requestingName;
  });
  var isRequired = !!requesting && modifiers2.some(function(modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });
  if (!isRequired) {
    var _requesting = "`" + requestingName + "`";
    var requested = "`" + requestedName + "`";
    console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
  }
  return isRequired;
}
function arrow(data, options) {
  var _data$offsets$arrow;
  if (!isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) {
    return data;
  }
  var arrowElement = options.element;
  if (typeof arrowElement === "string") {
    arrowElement = data.instance.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return data;
    }
  } else {
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn("WARNING: `arrow.element` must be child of its popper element!");
      return data;
    }
  }
  var placement = data.placement.split("-")[0];
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var isVertical = ["left", "right"].indexOf(placement) !== -1;
  var len = isVertical ? "height" : "width";
  var sideCapitalized = isVertical ? "Top" : "Left";
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? "left" : "top";
  var opSide = isVertical ? "bottom" : "right";
  var arrowElementSize = getOuterSizes(arrowElement)[len];
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css["margin" + sideCapitalized]);
  var popperBorderSide = parseFloat(css["border" + sideCapitalized + "Width"]);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty3(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty3(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
  return data;
}
function getOppositeVariation(variation) {
  if (variation === "end") {
    return "start";
  } else if (variation === "start") {
    return "end";
  }
  return variation;
}
var placements = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"];
var validPlacements = placements.slice(3);
function clockwise(placement) {
  var counter2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var index2 = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index2 + 1).concat(validPlacements.slice(0, index2));
  return counter2 ? arr.reverse() : arr;
}
var BEHAVIORS = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function flip(data, options) {
  if (isModifierEnabled(data.instance.modifiers, "inner")) {
    return data;
  }
  if (data.flipped && data.placement === data.originalPlacement) {
    return data;
  }
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
  var placement = data.placement.split("-")[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split("-")[1] || "";
  var flipOrder = [];
  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }
  flipOrder.forEach(function(step2, index2) {
    if (placement !== step2 || flipOrder.length === index2 + 1) {
      return data;
    }
    placement = data.placement.split("-")[0];
    placementOpposite = getOppositePlacement(placement);
    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;
    var floor2 = Math.floor;
    var overlapsRef = placement === "left" && floor2(popperOffsets.right) > floor2(refOffsets.left) || placement === "right" && floor2(popperOffsets.left) < floor2(refOffsets.right) || placement === "top" && floor2(popperOffsets.bottom) > floor2(refOffsets.top) || placement === "bottom" && floor2(popperOffsets.top) < floor2(refOffsets.bottom);
    var overflowsLeft = floor2(popperOffsets.left) < floor2(boundaries.left);
    var overflowsRight = floor2(popperOffsets.right) > floor2(boundaries.right);
    var overflowsTop = floor2(popperOffsets.top) < floor2(boundaries.top);
    var overflowsBottom = floor2(popperOffsets.bottom) > floor2(boundaries.bottom);
    var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
    var isVertical = ["top", "bottom"].indexOf(placement) !== -1;
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === "start" && overflowsRight || isVertical && variation === "end" && overflowsLeft || !isVertical && variation === "start" && overflowsBottom || !isVertical && variation === "end" && overflowsTop);
    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      data.flipped = true;
      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index2 + 1];
      }
      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }
      data.placement = placement + (variation ? "-" + variation : "");
      data.offsets.popper = _extends$1({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
      data = runModifiers(data.instance.modifiers, data, "flip");
    }
  });
  return data;
}
function keepTogether(data) {
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var placement = data.placement.split("-")[0];
  var floor2 = Math.floor;
  var isVertical = ["top", "bottom"].indexOf(placement) !== -1;
  var side = isVertical ? "right" : "bottom";
  var opSide = isVertical ? "left" : "top";
  var measurement = isVertical ? "width" : "height";
  if (popper[side] < floor2(reference[opSide])) {
    data.offsets.popper[opSide] = floor2(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor2(reference[side])) {
    data.offsets.popper[opSide] = floor2(reference[side]);
  }
  return data;
}
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];
  if (!value) {
    return str;
  }
  if (unit.indexOf("%") === 0) {
    var element = void 0;
    switch (unit) {
      case "%p":
        element = popperOffsets;
        break;
      case "%":
      case "%r":
      default:
        element = referenceOffsets;
    }
    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === "vh" || unit === "vw") {
    var size2 = void 0;
    if (unit === "vh") {
      size2 = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size2 = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size2 / 100 * value;
  } else {
    return value;
  }
}
function parseOffset(offset2, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];
  var useHeight = ["right", "left"].indexOf(basePlacement) !== -1;
  var fragments = offset2.split(/(\+|\-)/).map(function(frag) {
    return frag.trim();
  });
  var divider = fragments.indexOf(find(fragments, function(frag) {
    return frag.search(/,|\s/) !== -1;
  }));
  if (fragments[divider] && fragments[divider].indexOf(",") === -1) {
    console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  }
  var splitRegex = /\s*,\s*|\s+/;
  var ops2 = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
  ops2 = ops2.map(function(op, index2) {
    var measurement = (index2 === 1 ? !useHeight : useHeight) ? "height" : "width";
    var mergeWithPrevious = false;
    return op.reduce(function(a4, b3) {
      if (a4[a4.length - 1] === "" && ["+", "-"].indexOf(b3) !== -1) {
        a4[a4.length - 1] = b3;
        mergeWithPrevious = true;
        return a4;
      } else if (mergeWithPrevious) {
        a4[a4.length - 1] += b3;
        mergeWithPrevious = false;
        return a4;
      } else {
        return a4.concat(b3);
      }
    }, []).map(function(str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });
  ops2.forEach(function(op, index2) {
    op.forEach(function(frag, index22) {
      if (isNumeric(frag)) {
        offsets[index2] += frag * (op[index22 - 1] === "-" ? -1 : 1);
      }
    });
  });
  return offsets;
}
function offset$1(data, _ref) {
  var offset2 = _ref.offset;
  var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var basePlacement = placement.split("-")[0];
  var offsets = void 0;
  if (isNumeric(+offset2)) {
    offsets = [+offset2, 0];
  } else {
    offsets = parseOffset(offset2, popper, reference, basePlacement);
  }
  if (basePlacement === "left") {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === "right") {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === "top") {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === "bottom") {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }
  data.popper = popper;
  return data;
}
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }
  var transformProp = getSupportedPropertyName("transform");
  var popperStyles = data.instance.popper.style;
  var top = popperStyles.top, left = popperStyles.left, transform2 = popperStyles[transformProp];
  popperStyles.top = "";
  popperStyles.left = "";
  popperStyles[transformProp] = "";
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform2;
  options.boundaries = boundaries;
  var order2 = options.priority;
  var popper = data.offsets.popper;
  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty3({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === "right" ? "left" : "top";
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
      }
      return defineProperty3({}, mainSide, value);
    }
  };
  order2.forEach(function(placement) {
    var side = ["left", "top"].indexOf(placement) !== -1 ? "primary" : "secondary";
    popper = _extends$1({}, popper, check[side](placement));
  });
  data.offsets.popper = popper;
  return data;
}
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split("-")[0];
  var shiftvariation = placement.split("-")[1];
  if (shiftvariation) {
    var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
    var isVertical = ["bottom", "top"].indexOf(basePlacement) !== -1;
    var side = isVertical ? "left" : "top";
    var measurement = isVertical ? "width" : "height";
    var shiftOffsets = {
      start: defineProperty3({}, side, reference[side]),
      end: defineProperty3({}, side, reference[side] + reference[measurement] - popper[measurement])
    };
    data.offsets.popper = _extends$1({}, popper, shiftOffsets[shiftvariation]);
  }
  return data;
}
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) {
    return data;
  }
  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function(modifier) {
    return modifier.name === "preventOverflow";
  }).boundaries;
  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    if (data.hide === true) {
      return data;
    }
    data.hide = true;
    data.attributes["x-out-of-boundaries"] = "";
  } else {
    if (data.hide === false) {
      return data;
    }
    data.hide = false;
    data.attributes["x-out-of-boundaries"] = false;
  }
  return data;
}
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split("-")[0];
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var isHoriz = ["left", "right"].indexOf(basePlacement) !== -1;
  var subtractLength = ["top", "left"].indexOf(basePlacement) === -1;
  popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);
  return data;
}
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset$1,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
};
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers
};
var Popper$1 = function() {
  function Popper2(reference, popper) {
    var _this = this;
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    classCallCheck(this, Popper2);
    this.scheduleUpdate = function() {
      return requestAnimationFrame(_this.update);
    };
    this.update = debounce(this.update.bind(this));
    this.options = _extends$1({}, Popper2.Defaults, options);
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;
    this.options.modifiers = {};
    Object.keys(_extends$1({}, Popper2.Defaults.modifiers, options.modifiers)).forEach(function(name2) {
      _this.options.modifiers[name2] = _extends$1({}, Popper2.Defaults.modifiers[name2] || {}, options.modifiers ? options.modifiers[name2] : {});
    });
    this.modifiers = Object.keys(this.options.modifiers).map(function(name2) {
      return _extends$1({
        name: name2
      }, _this.options.modifiers[name2]);
    }).sort(function(a4, b3) {
      return a4.order - b3.order;
    });
    this.modifiers.forEach(function(modifierOptions) {
      if (modifierOptions.enabled && isFunction$1(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });
    this.update();
    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      this.enableEventListeners();
    }
    this.state.eventsEnabled = eventsEnabled;
  }
  createClass(Popper2, [{
    key: "update",
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: "destroy",
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]);
  return Popper2;
}();
Popper$1.Utils = (typeof window !== "undefined" ? window : global$7).PopperUtils;
Popper$1.placements = placements;
Popper$1.Defaults = Defaults;
var lib$1 = { exports: {} };
var implementation = { exports: {} };
var key = "__global_unique_id__";
var gud = function() {
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
};
var __DEV__$1 = process$1$1.env.NODE_ENV !== "production";
var warning$2 = function() {
};
if (__DEV__$1) {
  var printWarning$1 = function printWarning(format3, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key2 = 1; key2 < len; key2++) {
      args[key2 - 1] = arguments[key2];
    }
    var argIndex = 0;
    var message2 = "Warning: " + format3.replace(/%s/g, function() {
      return args[argIndex++];
    });
    if (typeof console !== "undefined") {
      console.error(message2);
    }
    try {
      throw new Error(message2);
    } catch (x3) {
    }
  };
  warning$2 = function(condition, format3, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key2 = 2; key2 < len; key2++) {
      args[key2 - 2] = arguments[key2];
    }
    if (format3 === void 0) {
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    }
    if (!condition) {
      printWarning$1.apply(null, [format3].concat(args));
    }
  };
}
var warning_1$1 = warning$2;
(function(module2, exports) {
  exports.__esModule = true;
  var _react2 = React__default;
  _interopRequireDefault2(_react2);
  var _propTypes = propTypesExports;
  var _propTypes2 = _interopRequireDefault2(_propTypes);
  var _gud = gud;
  var _gud2 = _interopRequireDefault2(_gud);
  var _warning3 = warning_1$1;
  var _warning22 = _interopRequireDefault2(_warning3);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn4(self2, call2) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
  }
  function _inherits4(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MAX_SIGNED_31_BIT_INT = 1073741823;
  function objectIs2(x3, y4) {
    if (x3 === y4) {
      return x3 !== 0 || 1 / x3 === 1 / y4;
    } else {
      return x3 !== x3 && y4 !== y4;
    }
  }
  function createEventEmitter(value) {
    var handlers = [];
    return {
      on: function on2(handler) {
        handlers.push(handler);
      },
      off: function off(handler) {
        handlers = handlers.filter(function(h4) {
          return h4 !== handler;
        });
      },
      get: function get2() {
        return value;
      },
      set: function set2(newValue, changedBits) {
        value = newValue;
        handlers.forEach(function(handler) {
          return handler(value, changedBits);
        });
      }
    };
  }
  function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
  }
  function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + (0, _gud2.default)() + "__";
    var Provider = function(_Component) {
      _inherits4(Provider2, _Component);
      function Provider2() {
        var _temp, _this, _ret;
        _classCallCheck4(this, Provider2);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn4(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn4(_this, _ret);
      }
      Provider2.prototype.getChildContext = function getChildContext() {
        var _ref;
        return _ref = {}, _ref[contextProp] = this.emitter, _ref;
      };
      Provider2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
          var oldValue = this.props.value;
          var newValue = nextProps.value;
          var changedBits = void 0;
          if (objectIs2(oldValue, newValue)) {
            changedBits = 0;
          } else {
            changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            if (process$1$1.env.NODE_ENV !== "production") {
              (0, _warning22.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, "calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", changedBits);
            }
            changedBits |= 0;
            if (changedBits !== 0) {
              this.emitter.set(nextProps.value, changedBits);
            }
          }
        }
      };
      Provider2.prototype.render = function render() {
        return this.props.children;
      };
      return Provider2;
    }(_react2.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function(_Component2) {
      _inherits4(Consumer2, _Component2);
      function Consumer2() {
        var _temp2, _this2, _ret2;
        _classCallCheck4(this, Consumer2);
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn4(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
          value: _this2.getValue()
        }, _this2.onUpdate = function(newValue, changedBits) {
          var observedBits = _this2.observedBits | 0;
          if ((observedBits & changedBits) !== 0) {
            _this2.setState({ value: _this2.getValue() });
          }
        }, _temp2), _possibleConstructorReturn4(_this2, _ret2);
      }
      Consumer2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var observedBits = nextProps.observedBits;
        this.observedBits = observedBits === void 0 || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
      };
      Consumer2.prototype.componentDidMount = function componentDidMount() {
        if (this.context[contextProp]) {
          this.context[contextProp].on(this.onUpdate);
        }
        var observedBits = this.props.observedBits;
        this.observedBits = observedBits === void 0 || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
      };
      Consumer2.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.context[contextProp]) {
          this.context[contextProp].off(this.onUpdate);
        }
      };
      Consumer2.prototype.getValue = function getValue2() {
        if (this.context[contextProp]) {
          return this.context[contextProp].get();
        } else {
          return defaultValue;
        }
      };
      Consumer2.prototype.render = function render() {
        return onlyChild(this.props.children)(this.state.value);
      };
      return Consumer2;
    }(_react2.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
    return {
      Provider,
      Consumer
    };
  }
  exports.default = createReactContext;
  module2.exports = exports["default"];
})(implementation, implementation.exports);
var implementationExports = implementation.exports;
(function(module2, exports) {
  exports.__esModule = true;
  var _react2 = React__default;
  var _react22 = _interopRequireDefault2(_react2);
  var _implementation = implementationExports;
  var _implementation2 = _interopRequireDefault2(_implementation);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  exports.default = _react22.default.createContext || _implementation2.default;
  module2.exports = exports["default"];
})(lib$1, lib$1.exports);
var libExports$1 = lib$1.exports;
const createContext = /* @__PURE__ */ getDefaultExportFromCjs$1(libExports$1);
var ManagerReferenceNodeContext = createContext();
var ManagerReferenceNodeSetterContext = createContext();
var Manager = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(Manager2, _React$Component);
  function Manager2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "referenceNode", void 0);
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "setReferenceNode", function(newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;
        _this.forceUpdate();
      }
    });
    return _this;
  }
  var _proto = Manager2.prototype;
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };
  _proto.render = function render() {
    return React$2.createElement(ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, React$2.createElement(ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };
  return Manager2;
}(React$2.Component);
var unwrapArray = function unwrapArray2(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke2(fn2) {
  if (typeof fn2 === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return fn2.apply(void 0, args);
  }
};
var shallowEqual = function shallowEqual2(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  if (bKeys.length !== aKeys.length) {
    return false;
  }
  for (var i3 = 0; i3 < bKeys.length; i3++) {
    var key2 = aKeys[i3];
    if (objA[key2] !== objB[key2]) {
      return false;
    }
  }
  return true;
};
var setRef = function setRef2(ref2, node3) {
  if (typeof ref2 === "function") {
    return safeInvoke(ref2, node3);
  } else if (ref2 != null) {
    ref2.current = node3;
  }
};
var initialStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: "none"
};
var initialArrowStyle = {};
var InnerPopper = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(InnerPopper2, _React$Component);
  function InnerPopper2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "state", {
      data: void 0,
      placement: void 0
    });
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "popperInstance", void 0);
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "popperNode", null);
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "arrowNode", null);
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "setPopperNode", function(popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      setRef(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;
      _this.updatePopperInstance();
    });
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "setArrowNode", function(arrowNode) {
      _this.arrowNode = arrowNode;
    });
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn2(data) {
        var placement = data.placement;
        _this.setState({
          data,
          placement
        });
        return data;
      }
    });
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getOptions", function() {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: _extends$2({}, _this.props.modifiers, {
          arrow: _extends$2({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getPopperStyle", function() {
      return !_this.popperNode || !_this.state.data ? initialStyle : _extends$2({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getPopperPlacement", function() {
      return !_this.state.data ? void 0 : _this.state.placement;
    });
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getArrowStyle", function() {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "getOutOfBoundariesState", function() {
      return _this.state.data ? _this.state.data.hide : void 0;
    });
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "destroyPopperInstance", function() {
      if (!_this.popperInstance) return;
      _this.popperInstance.destroy();
      _this.popperInstance = null;
    });
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "updatePopperInstance", function() {
      _this.destroyPopperInstance();
      var _assertThisInitialize = _assertThisInitialized$1(_assertThisInitialized$1(_this)), popperNode = _assertThisInitialize.popperNode;
      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new Popper$1(referenceElement, popperNode, _this.getOptions());
    });
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "scheduleUpdate", function() {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });
    return _this;
  }
  var _proto = InnerPopper2.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !deepEqual$1(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      if (process$1$1.env.NODE_ENV === "development") {
        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && shallowEqual(this.props.modifiers, prevProps.modifiers)) {
          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
        }
      }
      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    }
    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
    this.destroyPopperInstance();
  };
  _proto.render = function render() {
    return unwrapArray(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };
  return InnerPopper2;
}(React$2.Component);
_defineProperty(InnerPopper, "defaultProps", {
  placement: "bottom",
  eventsEnabled: true,
  referenceElement: void 0,
  positionFixed: false
});
Popper$1.placements;
function Popper(_ref) {
  var referenceElement = _ref.referenceElement, props2 = _objectWithoutPropertiesLoose(_ref, ["referenceElement"]);
  return React$2.createElement(ManagerReferenceNodeContext.Consumer, null, function(referenceNode) {
    return React$2.createElement(InnerPopper, _extends$2({
      referenceElement: referenceElement !== void 0 ? referenceElement : referenceNode
    }, props2));
  });
}
var __DEV__ = process$1$1.env.NODE_ENV !== "production";
var warning = function() {
};
if (__DEV__) {
  var printWarning = function printWarning2(format3, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key2 = 1; key2 < len; key2++) {
      args[key2 - 1] = arguments[key2];
    }
    var argIndex = 0;
    var message2 = "Warning: " + format3.replace(/%s/g, function() {
      return args[argIndex++];
    });
    if (typeof console !== "undefined") {
      console.error(message2);
    }
    try {
      throw new Error(message2);
    } catch (x3) {
    }
  };
  warning = function(condition, format3, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key2 = 2; key2 < len; key2++) {
      args[key2 - 2] = arguments[key2];
    }
    if (format3 === void 0) {
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    }
    if (!condition) {
      printWarning.apply(null, [format3].concat(args));
    }
  };
}
var warning_1 = warning;
const warning$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(warning_1);
var InnerReference = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(InnerReference2, _React$Component);
  function InnerReference2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _defineProperty(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "refHandler", function(node3) {
      setRef(_this.props.innerRef, node3);
      safeInvoke(_this.props.setReferenceNode, node3);
    });
    return _this;
  }
  var _proto = InnerReference2.prototype;
  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
  };
  _proto.render = function render() {
    warning$1(Boolean(this.props.setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    return unwrapArray(this.props.children)({
      ref: this.refHandler
    });
  };
  return InnerReference2;
}(React$2.Component);
function Reference(props2) {
  return React$2.createElement(ManagerReferenceNodeSetterContext.Consumer, null, function(setReferenceNode) {
    return React$2.createElement(InnerReference, _extends$2({
      setReferenceNode
    }, props2));
  });
}
function ne(e5) {
  return (ne = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e6) {
    return typeof e6;
  } : function(e6) {
    return e6 && "function" == typeof Symbol && e6.constructor === Symbol && e6 !== Symbol.prototype ? "symbol" : typeof e6;
  })(e5);
}
function oe(e5, t3) {
  if (!(e5 instanceof t3)) throw new TypeError("Cannot call a class as a function");
}
function ae(e5, t3) {
  for (var r2 = 0; r2 < t3.length; r2++) {
    var n2 = t3[r2];
    n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e5, n2.key, n2);
  }
}
function se(e5, t3, r2) {
  return t3 && ae(e5.prototype, t3), r2 && ae(e5, r2), e5;
}
function pe(e5, t3, r2) {
  return t3 in e5 ? Object.defineProperty(e5, t3, { value: r2, enumerable: true, configurable: true, writable: true }) : e5[t3] = r2, e5;
}
function ie() {
  return (ie = Object.assign || function(e5) {
    for (var t3 = 1; t3 < arguments.length; t3++) {
      var r2 = arguments[t3];
      for (var n2 in r2) Object.prototype.hasOwnProperty.call(r2, n2) && (e5[n2] = r2[n2]);
    }
    return e5;
  }).apply(this, arguments);
}
function ce(e5, t3) {
  var r2 = Object.keys(e5);
  if (Object.getOwnPropertySymbols) {
    var n2 = Object.getOwnPropertySymbols(e5);
    t3 && (n2 = n2.filter(function(t4) {
      return Object.getOwnPropertyDescriptor(e5, t4).enumerable;
    })), r2.push.apply(r2, n2);
  }
  return r2;
}
function le(e5) {
  for (var t3 = 1; t3 < arguments.length; t3++) {
    var r2 = null != arguments[t3] ? arguments[t3] : {};
    t3 % 2 ? ce(Object(r2), true).forEach(function(t4) {
      pe(e5, t4, r2[t4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(r2)) : ce(Object(r2)).forEach(function(t4) {
      Object.defineProperty(e5, t4, Object.getOwnPropertyDescriptor(r2, t4));
    });
  }
  return e5;
}
function de(e5, t3) {
  if ("function" != typeof t3 && null !== t3) throw new TypeError("Super expression must either be null or a function");
  e5.prototype = Object.create(t3 && t3.prototype, { constructor: { value: e5, writable: true, configurable: true } }), t3 && he(e5, t3);
}
function ue(e5) {
  return (ue = Object.setPrototypeOf ? Object.getPrototypeOf : function(e6) {
    return e6.__proto__ || Object.getPrototypeOf(e6);
  })(e5);
}
function he(e5, t3) {
  return (he = Object.setPrototypeOf || function(e6, t4) {
    return e6.__proto__ = t4, e6;
  })(e5, t3);
}
function me(e5) {
  if (void 0 === e5) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e5;
}
function fe(e5, t3) {
  return !t3 || "object" != typeof t3 && "function" != typeof t3 ? me(e5) : t3;
}
function ve(e5) {
  var t3 = function() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" == typeof Proxy) return true;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), true;
    } catch (e6) {
      return false;
    }
  }();
  return function() {
    var r2, n2 = ue(e5);
    if (t3) {
      var o2 = ue(this).constructor;
      r2 = Reflect.construct(n2, arguments, o2);
    } else r2 = n2.apply(this, arguments);
    return fe(this, r2);
  };
}
function ye(e5, t3) {
  switch (e5) {
    case "P":
      return t3.date({ width: "short" });
    case "PP":
      return t3.date({ width: "medium" });
    case "PPP":
      return t3.date({ width: "long" });
    case "PPPP":
    default:
      return t3.date({ width: "full" });
  }
}
function De(e5, t3) {
  switch (e5) {
    case "p":
      return t3.time({ width: "short" });
    case "pp":
      return t3.time({ width: "medium" });
    case "ppp":
      return t3.time({ width: "long" });
    case "pppp":
    default:
      return t3.time({ width: "full" });
  }
}
var we = { p: De, P: function(e5, t3) {
  var r2, n2 = e5.match(/(P+)(p+)?/), o2 = n2[1], a4 = n2[2];
  if (!a4) return ye(e5, t3);
  switch (o2) {
    case "P":
      r2 = t3.dateTime({ width: "short" });
      break;
    case "PP":
      r2 = t3.dateTime({ width: "medium" });
      break;
    case "PPP":
      r2 = t3.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      r2 = t3.dateTime({ width: "full" });
  }
  return r2.replace("{{date}}", ye(o2, t3)).replace("{{time}}", De(a4, t3));
} }, ke = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function ge(e5) {
  var t3 = e5 ? "string" == typeof e5 || e5 instanceof String ? parseISO(e5) : toDate$1(e5) : /* @__PURE__ */ new Date();
  return Ce(t3) ? t3 : null;
}
function be(e5, t3, r2, n2) {
  var a4 = null, s4 = je(r2) || Be(), p2 = true;
  return Array.isArray(t3) ? (t3.forEach(function(t4) {
    var r3 = parse2(e5, t4, /* @__PURE__ */ new Date(), { locale: s4 });
    n2 && (p2 = Ce(r3) && e5 === format$2(r3, t4, { awareOfUnicodeTokens: true })), Ce(r3) && p2 && (a4 = r3);
  }), a4) : (a4 = parse2(e5, t3, /* @__PURE__ */ new Date(), { locale: s4 }), n2 ? p2 = Ce(a4) && e5 === format$2(a4, t3, { awareOfUnicodeTokens: true }) : Ce(a4) || (t3 = t3.match(ke).map(function(e6) {
    var t4 = e6[0];
    return "p" === t4 || "P" === t4 ? s4 ? (0, we[t4])(e6, s4.formatLong) : t4 : e6;
  }).join(""), e5.length > 0 && (a4 = parse2(e5, t3.slice(0, e5.length), /* @__PURE__ */ new Date())), Ce(a4) || (a4 = new Date(e5))), Ce(a4) && p2 ? a4 : null);
}
function Ce(e5) {
  return isValid$3(e5) && isAfter$1(e5, /* @__PURE__ */ new Date("1/1/1000"));
}
function _e2(e5, t3, r2) {
  if ("en" === r2) return format$2(e5, t3, { awareOfUnicodeTokens: true });
  var n2 = je(r2);
  return r2 && !n2 && console.warn('A locale object was not found for the provided string ["'.concat(r2, '"].')), !n2 && Be() && je(Be()) && (n2 = je(Be())), format$2(e5, t3, { locale: n2 || null, awareOfUnicodeTokens: true });
}
function Se(e5, t3) {
  var r2 = t3.hour, n2 = void 0 === r2 ? 0 : r2, o2 = t3.minute, a4 = void 0 === o2 ? 0 : o2, s4 = t3.second;
  return setHours(setMinutes(setSeconds(e5, void 0 === s4 ? 0 : s4), a4), n2);
}
function Me(e5, t3) {
  var r2 = t3 && je(t3) || Be() && je(Be());
  return getWeek(e5, r2 ? { locale: r2 } : null);
}
function Pe(e5, t3) {
  return _e2(e5, "ddd", t3);
}
function Ee(e5) {
  return startOfDay(e5);
}
function Ne(e5, t3) {
  var r2 = je(t3 || Be());
  return startOfWeek(e5, { locale: r2 });
}
function Oe(e5) {
  return startOfMonth(e5);
}
function xe(e5) {
  return startOfQuarter(e5);
}
function Ye(e5, t3) {
  return e5 && t3 ? isSameYear(e5, t3) : !e5 && !t3;
}
function Te(e5, t3) {
  return e5 && t3 ? isSameMonth(e5, t3) : !e5 && !t3;
}
function Le(e5, t3) {
  return e5 && t3 ? isSameQuarter(e5, t3) : !e5 && !t3;
}
function Ie(e5, t3) {
  return e5 && t3 ? isSameDay(e5, t3) : !e5 && !t3;
}
function Fe(e5, t3) {
  return e5 && t3 ? isEqual(e5, t3) : !e5 && !t3;
}
function Re(e5, t3, r2) {
  var n2, o2 = startOfDay(t3), a4 = endOfDay(r2);
  try {
    n2 = isWithinInterval(e5, { start: o2, end: a4 });
  } catch (e6) {
    n2 = false;
  }
  return n2;
}
function We(e5, t3) {
  var r2 = "undefined" != typeof window ? window : global$7;
  r2.__localeData__ || (r2.__localeData__ = {}), r2.__localeData__[e5] = t3;
}
function Be() {
  return ("undefined" != typeof window ? window : global$7).__localeId__;
}
function je(e5) {
  if ("string" == typeof e5) {
    var t3 = "undefined" != typeof window ? window : global$7;
    return t3.__localeData__ ? t3.__localeData__[e5] : null;
  }
  return e5;
}
function Ke(e5, t3) {
  return _e2(setMonth$1(ge(), e5), "LLLL", t3);
}
function He(e5, t3) {
  return _e2(setMonth$1(ge(), e5), "LLL", t3);
}
function Qe(e5, t3) {
  return _e2(setQuarter(ge(), e5), "QQQ", t3);
}
function Ve(e5) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.minDate, n2 = t3.maxDate, o2 = t3.excludeDates, a4 = t3.includeDates, s4 = t3.filterDate;
  return Je(e5, { minDate: r2, maxDate: n2 }) || o2 && o2.some(function(t4) {
    return Ie(e5, t4);
  }) || a4 && !a4.some(function(t4) {
    return Ie(e5, t4);
  }) || s4 && !s4(ge(e5)) || false;
}
function qe(e5) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.excludeDates;
  return r2 && r2.some(function(t4) {
    return Ie(e5, t4);
  }) || false;
}
function Ue(e5) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.minDate, n2 = t3.maxDate, o2 = t3.excludeDates, a4 = t3.includeDates, s4 = t3.filterDate;
  return Je(e5, { minDate: r2, maxDate: n2 }) || o2 && o2.some(function(t4) {
    return Te(e5, t4);
  }) || a4 && !a4.some(function(t4) {
    return Te(e5, t4);
  }) || s4 && !s4(ge(e5)) || false;
}
function $e(e5, t3, r2, n2) {
  var o2 = getYear(e5), a4 = getMonth(e5), s4 = getYear(t3), p2 = getMonth(t3), i3 = getYear(n2);
  return o2 === s4 && o2 === i3 ? a4 <= r2 && r2 <= p2 : o2 < s4 ? i3 === o2 && a4 <= r2 || i3 === s4 && p2 >= r2 || i3 < s4 && i3 > o2 : void 0;
}
function ze(e5) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.minDate, n2 = t3.maxDate, o2 = t3.excludeDates, a4 = t3.includeDates, s4 = t3.filterDate;
  return Je(e5, { minDate: r2, maxDate: n2 }) || o2 && o2.some(function(t4) {
    return Le(e5, t4);
  }) || a4 && !a4.some(function(t4) {
    return Le(e5, t4);
  }) || s4 && !s4(ge(e5)) || false;
}
function Ge(e5, t3, r2, n2) {
  var o2 = getYear(e5), a4 = getQuarter(e5), s4 = getYear(t3), p2 = getQuarter(t3), i3 = getYear(n2);
  return o2 === s4 && o2 === i3 ? a4 <= r2 && r2 <= p2 : o2 < s4 ? i3 === o2 && a4 <= r2 || i3 === s4 && p2 >= r2 || i3 < s4 && i3 > o2 : void 0;
}
function Je(e5) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.minDate, n2 = t3.maxDate;
  return r2 && differenceInCalendarDays(e5, r2) < 0 || n2 && differenceInCalendarDays(e5, n2) > 0;
}
function Xe(e5, t3) {
  for (var r2 = t3.length, n2 = 0; n2 < r2; n2++) if (getHours(t3[n2]) === getHours(e5) && getMinutes(t3[n2]) === getMinutes(e5)) return true;
  return false;
}
function Ze(e5, t3) {
  var r2 = t3.minTime, n2 = t3.maxTime;
  if (!r2 || !n2) throw new Error("Both minTime and maxTime props required");
  var o2, a4 = ge(), s4 = setHours(setMinutes(a4, getMinutes(e5)), getHours(e5)), p2 = setHours(setMinutes(a4, getMinutes(r2)), getHours(r2)), i3 = setHours(setMinutes(a4, getMinutes(n2)), getHours(n2));
  try {
    o2 = !isWithinInterval(s4, { start: p2, end: i3 });
  } catch (e6) {
    o2 = false;
  }
  return o2;
}
function et(e5) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.minDate, n2 = t3.includeDates, o2 = subMonths(e5, 1);
  return r2 && differenceInCalendarMonths(r2, o2) > 0 || n2 && n2.every(function(e6) {
    return differenceInCalendarMonths(e6, o2) > 0;
  }) || false;
}
function tt(e5) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.maxDate, n2 = t3.includeDates, o2 = addMonths(e5, 1);
  return r2 && differenceInCalendarMonths(o2, r2) > 0 || n2 && n2.every(function(e6) {
    return differenceInCalendarMonths(o2, e6) > 0;
  }) || false;
}
function rt(e5) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.minDate, n2 = t3.includeDates, o2 = subYears(e5, 1);
  return r2 && differenceInCalendarYears(r2, o2) > 0 || n2 && n2.every(function(e6) {
    return differenceInCalendarYears(e6, o2) > 0;
  }) || false;
}
function nt(e5) {
  var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3.maxDate, n2 = t3.includeDates, o2 = addYears(e5, 1);
  return r2 && differenceInCalendarYears(o2, r2) > 0 || n2 && n2.every(function(e6) {
    return differenceInCalendarYears(o2, e6) > 0;
  }) || false;
}
function ot(e5) {
  var t3 = e5.minDate, r2 = e5.includeDates;
  if (r2 && t3) {
    var n2 = r2.filter(function(e6) {
      return differenceInCalendarDays(e6, t3) >= 0;
    });
    return min$1(n2);
  }
  return r2 ? min$1(r2) : t3;
}
function at(e5) {
  var t3 = e5.maxDate, r2 = e5.includeDates;
  if (r2 && t3) {
    var n2 = r2.filter(function(e6) {
      return differenceInCalendarDays(e6, t3) <= 0;
    });
    return max$2(n2);
  }
  return r2 ? max$2(r2) : t3;
}
function st() {
  for (var e5 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", n2 = /* @__PURE__ */ new Map(), o2 = 0, a4 = e5.length; o2 < a4; o2++) {
    var s4 = e5[o2];
    if (isDate$2(s4)) {
      var p2 = _e2(s4, "MM.dd.yyyy"), i3 = n2.get(p2) || [];
      i3.includes(t3) || (i3.push(t3), n2.set(p2, i3));
    } else if ("object" === ne(s4)) {
      var c3 = Object.keys(s4), l2 = c3[0], d4 = s4[c3[0]];
      if ("string" == typeof l2 && d4.constructor === Array) for (var u3 = 0, h4 = d4.length; u3 < h4; u3++) {
        var m4 = _e2(d4[u3], "MM.dd.yyyy"), f2 = n2.get(m4) || [];
        f2.includes(l2) || (f2.push(l2), n2.set(m4, f2));
      }
    }
  }
  return n2;
}
function pt(e5, t3, r2, n2, o2) {
  for (var p2 = o2.length, i3 = [], c3 = 0; c3 < p2; c3++) {
    var l2 = addMinutes(addHours(e5, getHours(o2[c3])), getMinutes(o2[c3])), d4 = addMinutes(e5, (r2 + 1) * n2);
    isAfter$1(l2, t3) && isBefore$1(l2, d4) && i3.push(o2[c3]);
  }
  return i3;
}
function it(e5) {
  return e5 < 10 ? "0".concat(e5) : "".concat(e5);
}
function ct(e5, t3, r2, n2) {
  for (var o2 = [], a4 = 0; a4 < 2 * t3 + 1; a4++) {
    var s4 = e5 + t3 - a4, p2 = true;
    r2 && (p2 = getYear(r2) <= s4), n2 && p2 && (p2 = getYear(n2) >= s4), p2 && o2.push(s4);
  }
  return o2;
}
var lt = onClickOutsideHOC(function(r2) {
  de(o2, React__default.Component);
  var n2 = ve(o2);
  function o2(t3) {
    var r3;
    oe(this, o2), pe(me(r3 = n2.call(this, t3)), "renderOptions", function() {
      var t4 = r3.props.year, n3 = r3.state.yearsList.map(function(n4) {
        return React__default.createElement("div", { className: t4 === n4 ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: n4, onClick: r3.onChange.bind(me(r3), n4) }, t4 === n4 ? React__default.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", n4);
      }), o3 = r3.props.minDate ? getYear(r3.props.minDate) : null, a5 = r3.props.maxDate ? getYear(r3.props.maxDate) : null;
      return a5 && r3.state.yearsList.find(function(e5) {
        return e5 === a5;
      }) || n3.unshift(React__default.createElement("div", { className: "react-datepicker__year-option", key: "upcoming", onClick: r3.incrementYears }, React__default.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), o3 && r3.state.yearsList.find(function(e5) {
        return e5 === o3;
      }) || n3.push(React__default.createElement("div", { className: "react-datepicker__year-option", key: "previous", onClick: r3.decrementYears }, React__default.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), n3;
    }), pe(me(r3), "onChange", function(e5) {
      r3.props.onChange(e5);
    }), pe(me(r3), "handleClickOutside", function() {
      r3.props.onCancel();
    }), pe(me(r3), "shiftYears", function(e5) {
      var t4 = r3.state.yearsList.map(function(t5) {
        return t5 + e5;
      });
      r3.setState({ yearsList: t4 });
    }), pe(me(r3), "incrementYears", function() {
      return r3.shiftYears(1);
    }), pe(me(r3), "decrementYears", function() {
      return r3.shiftYears(-1);
    });
    var a4 = t3.yearDropdownItemNumber, s4 = t3.scrollableYearDropdown, p2 = a4 || (s4 ? 10 : 5);
    return r3.state = { yearsList: ct(r3.props.year, p2, r3.props.minDate, r3.props.maxDate) }, r3;
  }
  return se(o2, [{ key: "render", value: function() {
    var r3 = classNames({ "react-datepicker__year-dropdown": true, "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown });
    return React__default.createElement("div", { className: r3 }, this.renderOptions());
  } }]), o2;
}()), dt = function(t3) {
  de(n2, React__default.Component);
  var r2 = ve(n2);
  function n2() {
    var t4;
    oe(this, n2);
    for (var o2 = arguments.length, a4 = new Array(o2), s4 = 0; s4 < o2; s4++) a4[s4] = arguments[s4];
    return pe(me(t4 = r2.call.apply(r2, [this].concat(a4))), "state", { dropdownVisible: false }), pe(me(t4), "renderSelectOptions", function() {
      for (var r3 = t4.props.minDate ? getYear(t4.props.minDate) : 1900, n3 = t4.props.maxDate ? getYear(t4.props.maxDate) : 2100, o3 = [], a5 = r3; a5 <= n3; a5++) o3.push(React__default.createElement("option", { key: a5, value: a5 }, a5));
      return o3;
    }), pe(me(t4), "onSelectChange", function(e5) {
      t4.onChange(e5.target.value);
    }), pe(me(t4), "renderSelectMode", function() {
      return React__default.createElement("select", { value: t4.props.year, className: "react-datepicker__year-select", onChange: t4.onSelectChange }, t4.renderSelectOptions());
    }), pe(me(t4), "renderReadView", function(r3) {
      return React__default.createElement("div", { key: "read", style: { visibility: r3 ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(e5) {
        return t4.toggleDropdown(e5);
      } }, React__default.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), React__default.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, t4.props.year));
    }), pe(me(t4), "renderDropdown", function() {
      return React__default.createElement(lt, { key: "dropdown", year: t4.props.year, onChange: t4.onChange, onCancel: t4.toggleDropdown, minDate: t4.props.minDate, maxDate: t4.props.maxDate, scrollableYearDropdown: t4.props.scrollableYearDropdown, yearDropdownItemNumber: t4.props.yearDropdownItemNumber });
    }), pe(me(t4), "renderScrollMode", function() {
      var e5 = t4.state.dropdownVisible, r3 = [t4.renderReadView(!e5)];
      return e5 && r3.unshift(t4.renderDropdown()), r3;
    }), pe(me(t4), "onChange", function(e5) {
      t4.toggleDropdown(), e5 !== t4.props.year && t4.props.onChange(e5);
    }), pe(me(t4), "toggleDropdown", function(e5) {
      t4.setState({ dropdownVisible: !t4.state.dropdownVisible }, function() {
        t4.props.adjustDateOnChange && t4.handleYearChange(t4.props.date, e5);
      });
    }), pe(me(t4), "handleYearChange", function(e5, r3) {
      t4.onSelect(e5, r3), t4.setOpen();
    }), pe(me(t4), "onSelect", function(e5, r3) {
      t4.props.onSelect && t4.props.onSelect(e5, r3);
    }), pe(me(t4), "setOpen", function() {
      t4.props.setOpen && t4.props.setOpen(true);
    }), t4;
  }
  return se(n2, [{ key: "render", value: function() {
    var t4;
    switch (this.props.dropdownMode) {
      case "scroll":
        t4 = this.renderScrollMode();
        break;
      case "select":
        t4 = this.renderSelectMode();
    }
    return React__default.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, t4);
  } }]), n2;
}(), ut = onClickOutsideHOC(function(t3) {
  de(n2, React__default.Component);
  var r2 = ve(n2);
  function n2() {
    var t4;
    oe(this, n2);
    for (var o2 = arguments.length, a4 = new Array(o2), s4 = 0; s4 < o2; s4++) a4[s4] = arguments[s4];
    return pe(me(t4 = r2.call.apply(r2, [this].concat(a4))), "renderOptions", function() {
      return t4.props.monthNames.map(function(r3, n3) {
        return React__default.createElement("div", { className: t4.props.month === n3 ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: r3, onClick: t4.onChange.bind(me(t4), n3) }, t4.props.month === n3 ? React__default.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", r3);
      });
    }), pe(me(t4), "onChange", function(e5) {
      return t4.props.onChange(e5);
    }), pe(me(t4), "handleClickOutside", function() {
      return t4.props.onCancel();
    }), t4;
  }
  return se(n2, [{ key: "render", value: function() {
    return React__default.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
  } }]), n2;
}()), ht = function(t3) {
  de(n2, React__default.Component);
  var r2 = ve(n2);
  function n2() {
    var t4;
    oe(this, n2);
    for (var o2 = arguments.length, a4 = new Array(o2), s4 = 0; s4 < o2; s4++) a4[s4] = arguments[s4];
    return pe(me(t4 = r2.call.apply(r2, [this].concat(a4))), "state", { dropdownVisible: false }), pe(me(t4), "renderSelectOptions", function(t5) {
      return t5.map(function(t6, r3) {
        return React__default.createElement("option", { key: r3, value: r3 }, t6);
      });
    }), pe(me(t4), "renderSelectMode", function(r3) {
      return React__default.createElement("select", { value: t4.props.month, className: "react-datepicker__month-select", onChange: function(e5) {
        return t4.onChange(e5.target.value);
      } }, t4.renderSelectOptions(r3));
    }), pe(me(t4), "renderReadView", function(r3, n3) {
      return React__default.createElement("div", { key: "read", style: { visibility: r3 ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: t4.toggleDropdown }, React__default.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), React__default.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, n3[t4.props.month]));
    }), pe(me(t4), "renderDropdown", function(r3) {
      return React__default.createElement(ut, { key: "dropdown", month: t4.props.month, monthNames: r3, onChange: t4.onChange, onCancel: t4.toggleDropdown });
    }), pe(me(t4), "renderScrollMode", function(e5) {
      var r3 = t4.state.dropdownVisible, n3 = [t4.renderReadView(!r3, e5)];
      return r3 && n3.unshift(t4.renderDropdown(e5)), n3;
    }), pe(me(t4), "onChange", function(e5) {
      t4.toggleDropdown(), e5 !== t4.props.month && t4.props.onChange(e5);
    }), pe(me(t4), "toggleDropdown", function() {
      return t4.setState({ dropdownVisible: !t4.state.dropdownVisible });
    }), t4;
  }
  return se(n2, [{ key: "render", value: function() {
    var t4, r3 = this, n3 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(e5) {
      return He(e5, r3.props.locale);
    } : function(e5) {
      return Ke(e5, r3.props.locale);
    });
    switch (this.props.dropdownMode) {
      case "scroll":
        t4 = this.renderScrollMode(n3);
        break;
      case "select":
        t4 = this.renderSelectMode(n3);
    }
    return React__default.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, t4);
  } }]), n2;
}();
function mt(e5, t3) {
  for (var r2 = [], n2 = Oe(e5), o2 = Oe(t3); !isAfter$1(n2, o2); ) r2.push(ge(n2)), n2 = addMonths(n2, 1);
  return r2;
}
var ft = onClickOutsideHOC(function(r2) {
  de(o2, React__default.Component);
  var n2 = ve(o2);
  function o2(t3) {
    var r3;
    return oe(this, o2), pe(me(r3 = n2.call(this, t3)), "renderOptions", function() {
      return r3.state.monthYearsList.map(function(t4) {
        var n3 = getTime$1(t4), o3 = Ye(r3.props.date, t4) && Te(r3.props.date, t4);
        return React__default.createElement("div", { className: o3 ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option", key: n3, onClick: r3.onChange.bind(me(r3), n3) }, o3 ? React__default.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", _e2(t4, r3.props.dateFormat));
      });
    }), pe(me(r3), "onChange", function(e5) {
      return r3.props.onChange(e5);
    }), pe(me(r3), "handleClickOutside", function() {
      r3.props.onCancel();
    }), r3.state = { monthYearsList: mt(r3.props.minDate, r3.props.maxDate) }, r3;
  }
  return se(o2, [{ key: "render", value: function() {
    var r3 = classNames({ "react-datepicker__month-year-dropdown": true, "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown });
    return React__default.createElement("div", { className: r3 }, this.renderOptions());
  } }]), o2;
}()), vt = function(t3) {
  de(n2, React__default.Component);
  var r2 = ve(n2);
  function n2() {
    var t4;
    oe(this, n2);
    for (var o2 = arguments.length, a4 = new Array(o2), s4 = 0; s4 < o2; s4++) a4[s4] = arguments[s4];
    return pe(me(t4 = r2.call.apply(r2, [this].concat(a4))), "state", { dropdownVisible: false }), pe(me(t4), "renderSelectOptions", function() {
      for (var r3 = Oe(t4.props.minDate), n3 = Oe(t4.props.maxDate), o3 = []; !isAfter$1(r3, n3); ) {
        var a5 = getTime$1(r3);
        o3.push(React__default.createElement("option", { key: a5, value: a5 }, _e2(r3, t4.props.dateFormat, t4.props.locale))), r3 = addMonths(r3, 1);
      }
      return o3;
    }), pe(me(t4), "onSelectChange", function(e5) {
      t4.onChange(e5.target.value);
    }), pe(me(t4), "renderSelectMode", function() {
      return React__default.createElement("select", { value: getTime$1(Oe(t4.props.date)), className: "react-datepicker__month-year-select", onChange: t4.onSelectChange }, t4.renderSelectOptions());
    }), pe(me(t4), "renderReadView", function(r3) {
      var n3 = _e2(t4.props.date, t4.props.dateFormat, t4.props.locale);
      return React__default.createElement("div", { key: "read", style: { visibility: r3 ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: function(e5) {
        return t4.toggleDropdown(e5);
      } }, React__default.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), React__default.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, n3));
    }), pe(me(t4), "renderDropdown", function() {
      return React__default.createElement(ft, { key: "dropdown", date: t4.props.date, dateFormat: t4.props.dateFormat, onChange: t4.onChange, onCancel: t4.toggleDropdown, minDate: t4.props.minDate, maxDate: t4.props.maxDate, scrollableMonthYearDropdown: t4.props.scrollableMonthYearDropdown });
    }), pe(me(t4), "renderScrollMode", function() {
      var e5 = t4.state.dropdownVisible, r3 = [t4.renderReadView(!e5)];
      return e5 && r3.unshift(t4.renderDropdown()), r3;
    }), pe(me(t4), "onChange", function(e5) {
      t4.toggleDropdown();
      var r3 = ge(parseInt(e5));
      Ye(t4.props.date, r3) && Te(t4.props.date, r3) || t4.props.onChange(r3);
    }), pe(me(t4), "toggleDropdown", function() {
      return t4.setState({ dropdownVisible: !t4.state.dropdownVisible });
    }), t4;
  }
  return se(n2, [{ key: "render", value: function() {
    var t4;
    switch (this.props.dropdownMode) {
      case "scroll":
        t4 = this.renderScrollMode();
        break;
      case "select":
        t4 = this.renderSelectMode();
    }
    return React__default.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, t4);
  } }]), n2;
}(), yt = function(r2) {
  de(o2, React__default.Component);
  var n2 = ve(o2);
  function o2() {
    var r3;
    oe(this, o2);
    for (var a4 = arguments.length, s4 = new Array(a4), p2 = 0; p2 < a4; p2++) s4[p2] = arguments[p2];
    return pe(me(r3 = n2.call.apply(n2, [this].concat(s4))), "dayEl", React__default.createRef()), pe(me(r3), "handleClick", function(e5) {
      !r3.isDisabled() && r3.props.onClick && r3.props.onClick(e5);
    }), pe(me(r3), "handleMouseEnter", function(e5) {
      !r3.isDisabled() && r3.props.onMouseEnter && r3.props.onMouseEnter(e5);
    }), pe(me(r3), "handleOnKeyDown", function(e5) {
      " " === e5.key && (e5.preventDefault(), e5.key = "Enter"), r3.props.handleOnKeyDown(e5);
    }), pe(me(r3), "isSameDay", function(e5) {
      return Ie(r3.props.day, e5);
    }), pe(me(r3), "isKeyboardSelected", function() {
      return !r3.props.disabledKeyboardNavigation && !r3.props.inline && !r3.isSameDay(r3.props.selected) && r3.isSameDay(r3.props.preSelection);
    }), pe(me(r3), "isDisabled", function() {
      return Ve(r3.props.day, r3.props);
    }), pe(me(r3), "isExcluded", function() {
      return qe(r3.props.day, r3.props);
    }), pe(me(r3), "getHighLightedClass", function(e5) {
      var t3 = r3.props, n3 = t3.day, o3 = t3.highlightDates;
      if (!o3) return false;
      var a5 = _e2(n3, "MM.dd.yyyy");
      return o3.get(a5);
    }), pe(me(r3), "isInRange", function() {
      var e5 = r3.props, t3 = e5.day, n3 = e5.startDate, o3 = e5.endDate;
      return !(!n3 || !o3) && Re(t3, n3, o3);
    }), pe(me(r3), "isInSelectingRange", function() {
      var e5 = r3.props, t3 = e5.day, n3 = e5.selectsStart, o3 = e5.selectsEnd, a5 = e5.selectingDate, s5 = e5.startDate, p3 = e5.endDate;
      return !(!n3 && !o3 || !a5 || r3.isDisabled()) && (n3 && p3 && (isBefore$1(a5, p3) || Fe(a5, p3)) ? Re(t3, a5, p3) : !(!o3 || !s5 || !isAfter$1(a5, s5) && !Fe(a5, s5)) && Re(t3, s5, a5));
    }), pe(me(r3), "isSelectingRangeStart", function() {
      if (!r3.isInSelectingRange()) return false;
      var e5 = r3.props, t3 = e5.day, n3 = e5.selectingDate, o3 = e5.startDate;
      return Ie(t3, e5.selectsStart ? n3 : o3);
    }), pe(me(r3), "isSelectingRangeEnd", function() {
      if (!r3.isInSelectingRange()) return false;
      var e5 = r3.props, t3 = e5.day, n3 = e5.selectingDate, o3 = e5.endDate;
      return Ie(t3, e5.selectsEnd ? n3 : o3);
    }), pe(me(r3), "isRangeStart", function() {
      var e5 = r3.props, t3 = e5.day, n3 = e5.startDate, o3 = e5.endDate;
      return !(!n3 || !o3) && Ie(n3, t3);
    }), pe(me(r3), "isRangeEnd", function() {
      var e5 = r3.props, t3 = e5.day, n3 = e5.startDate, o3 = e5.endDate;
      return !(!n3 || !o3) && Ie(o3, t3);
    }), pe(me(r3), "isWeekend", function() {
      var e5 = getDay$1(r3.props.day);
      return 0 === e5 || 6 === e5;
    }), pe(me(r3), "isOutsideMonth", function() {
      return void 0 !== r3.props.month && r3.props.month !== getMonth(r3.props.day);
    }), pe(me(r3), "getClassNames", function(e5) {
      var n3 = r3.props.dayClassName ? r3.props.dayClassName(e5) : void 0;
      return classNames("react-datepicker__day", n3, "react-datepicker__day--" + Pe(r3.props.day), { "react-datepicker__day--disabled": r3.isDisabled(), "react-datepicker__day--excluded": r3.isExcluded(), "react-datepicker__day--selected": r3.isSameDay(r3.props.selected), "react-datepicker__day--keyboard-selected": r3.isKeyboardSelected(), "react-datepicker__day--range-start": r3.isRangeStart(), "react-datepicker__day--range-end": r3.isRangeEnd(), "react-datepicker__day--in-range": r3.isInRange(), "react-datepicker__day--in-selecting-range": r3.isInSelectingRange(), "react-datepicker__day--selecting-range-start": r3.isSelectingRangeStart(), "react-datepicker__day--selecting-range-end": r3.isSelectingRangeEnd(), "react-datepicker__day--today": r3.isSameDay(ge()), "react-datepicker__day--weekend": r3.isWeekend(), "react-datepicker__day--outside-month": r3.isOutsideMonth() }, r3.getHighLightedClass("react-datepicker__day--highlighted"));
    }), pe(me(r3), "getAriaLabel", function() {
      var e5 = r3.props, t3 = e5.day, n3 = e5.ariaLabelPrefixWhenEnabled, o3 = void 0 === n3 ? "Choose" : n3, a5 = e5.ariaLabelPrefixWhenDisabled, s5 = void 0 === a5 ? "Not available" : a5, p3 = r3.isDisabled() || r3.isExcluded() ? s5 : o3;
      return "".concat(p3, " ").concat(_e2(t3, "PPPP"));
    }), pe(me(r3), "getTabIndex", function(e5, t3) {
      var n3 = e5 || r3.props.selected, o3 = t3 || r3.props.preSelection;
      return r3.isKeyboardSelected() || r3.isSameDay(n3) && Ie(o3, n3) ? 0 : -1;
    }), pe(me(r3), "handleFocusDay", function() {
      var e5 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t3 = false;
      0 === r3.getTabIndex() && !e5.isInputFocused && r3.isSameDay(r3.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (t3 = true), r3.props.containerRef && r3.props.containerRef.current && r3.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (t3 = true)), t3 && r3.dayEl.current.focus();
    }), pe(me(r3), "render", function() {
      return React__default.createElement("div", { ref: r3.dayEl, className: r3.getClassNames(r3.props.day), onKeyDown: r3.handleOnKeyDown, onClick: r3.handleClick, onMouseEnter: r3.handleMouseEnter, tabIndex: r3.getTabIndex(), "aria-label": r3.getAriaLabel(), role: "button", "aria-disabled": r3.isDisabled() }, r3.props.renderDayContents ? r3.props.renderDayContents(getDate(r3.props.day), r3.props.day) : getDate(r3.props.day));
    }), r3;
  }
  return se(o2, [{ key: "componentDidMount", value: function() {
    this.handleFocusDay();
  } }, { key: "componentDidUpdate", value: function(e5) {
    this.handleFocusDay(e5);
  } }]), o2;
}(), Dt = function(r2) {
  de(o2, React__default.Component);
  var n2 = ve(o2);
  function o2() {
    var e5;
    oe(this, o2);
    for (var t3 = arguments.length, r3 = new Array(t3), a4 = 0; a4 < t3; a4++) r3[a4] = arguments[a4];
    return pe(me(e5 = n2.call.apply(n2, [this].concat(r3))), "handleClick", function(t4) {
      e5.props.onClick && e5.props.onClick(t4);
    }), e5;
  }
  return se(o2, [{ key: "render", value: function() {
    var r3 = this.props, n3 = r3.weekNumber, o3 = r3.ariaLabelPrefix, a4 = void 0 === o3 ? "week " : o3, s4 = { "react-datepicker__week-number": true, "react-datepicker__week-number--clickable": !!r3.onClick };
    return React__default.createElement("div", { className: classNames(s4), "aria-label": "".concat(a4, " ").concat(this.props.weekNumber), onClick: this.handleClick }, n3);
  } }]), o2;
}(), wt = function(t3) {
  de(n2, React__default.Component);
  var r2 = ve(n2);
  function n2() {
    var t4;
    oe(this, n2);
    for (var o2 = arguments.length, a4 = new Array(o2), s4 = 0; s4 < o2; s4++) a4[s4] = arguments[s4];
    return pe(me(t4 = r2.call.apply(r2, [this].concat(a4))), "handleDayClick", function(e5, r3) {
      t4.props.onDayClick && t4.props.onDayClick(e5, r3);
    }), pe(me(t4), "handleDayMouseEnter", function(e5) {
      t4.props.onDayMouseEnter && t4.props.onDayMouseEnter(e5);
    }), pe(me(t4), "handleWeekClick", function(e5, r3, n3) {
      "function" == typeof t4.props.onWeekSelect && t4.props.onWeekSelect(e5, r3, n3), t4.props.shouldCloseOnSelect && t4.props.setOpen(false);
    }), pe(me(t4), "formatWeekNumber", function(e5) {
      return t4.props.formatWeekNumber ? t4.props.formatWeekNumber(e5) : Me(e5, t4.props.locale);
    }), pe(me(t4), "renderDays", function() {
      var r3 = Ne(t4.props.day, t4.props.locale), n3 = [], o3 = t4.formatWeekNumber(r3);
      if (t4.props.showWeekNumber) {
        var a5 = t4.props.onWeekSelect ? t4.handleWeekClick.bind(me(t4), r3, o3) : void 0;
        n3.push(React__default.createElement(Dt, { key: "W", weekNumber: o3, onClick: a5, ariaLabelPrefix: t4.props.ariaLabelPrefix }));
      }
      return n3.concat([0, 1, 2, 3, 4, 5, 6].map(function(n4) {
        var o4 = addDays(r3, n4);
        return React__default.createElement(yt, { ariaLabelPrefixWhenEnabled: t4.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: t4.props.disabledDayAriaLabelPrefix, key: o4.valueOf(), day: o4, month: t4.props.month, onClick: t4.handleDayClick.bind(me(t4), o4), onMouseEnter: t4.handleDayMouseEnter.bind(me(t4), o4), minDate: t4.props.minDate, maxDate: t4.props.maxDate, excludeDates: t4.props.excludeDates, includeDates: t4.props.includeDates, inline: t4.props.inline, highlightDates: t4.props.highlightDates, selectingDate: t4.props.selectingDate, filterDate: t4.props.filterDate, preSelection: t4.props.preSelection, selected: t4.props.selected, selectsStart: t4.props.selectsStart, selectsEnd: t4.props.selectsEnd, startDate: t4.props.startDate, endDate: t4.props.endDate, dayClassName: t4.props.dayClassName, renderDayContents: t4.props.renderDayContents, disabledKeyboardNavigation: t4.props.disabledKeyboardNavigation, handleOnKeyDown: t4.props.handleOnKeyDown, isInputFocused: t4.props.isInputFocused, containerRef: t4.props.containerRef });
      }));
    }), t4;
  }
  return se(n2, [{ key: "render", value: function() {
    return React__default.createElement("div", { className: "react-datepicker__week" }, this.renderDays());
  } }], [{ key: "defaultProps", get: function() {
    return { shouldCloseOnSelect: true };
  } }]), n2;
}(), kt = function(r2) {
  de(o2, React__default.Component);
  var n2 = ve(o2);
  function o2() {
    var r3;
    oe(this, o2);
    for (var a4 = arguments.length, s4 = new Array(a4), c3 = 0; c3 < a4; c3++) s4[c3] = arguments[c3];
    return pe(me(r3 = n2.call.apply(n2, [this].concat(s4))), "handleDayClick", function(e5, t3) {
      r3.props.onDayClick && r3.props.onDayClick(e5, t3, r3.props.orderInDisplay);
    }), pe(me(r3), "handleDayMouseEnter", function(e5) {
      r3.props.onDayMouseEnter && r3.props.onDayMouseEnter(e5);
    }), pe(me(r3), "handleMouseLeave", function() {
      r3.props.onMouseLeave && r3.props.onMouseLeave();
    }), pe(me(r3), "isRangeStartMonth", function(e5) {
      var t3 = r3.props, n3 = t3.day, o3 = t3.startDate, a5 = t3.endDate;
      return !(!o3 || !a5) && Te(setMonth$1(n3, e5), o3);
    }), pe(me(r3), "isRangeStartQuarter", function(e5) {
      var t3 = r3.props, n3 = t3.day, o3 = t3.startDate, a5 = t3.endDate;
      return !(!o3 || !a5) && Le(setQuarter(n3, e5), o3);
    }), pe(me(r3), "isRangeEndMonth", function(e5) {
      var t3 = r3.props, n3 = t3.day, o3 = t3.startDate, a5 = t3.endDate;
      return !(!o3 || !a5) && Te(setMonth$1(n3, e5), a5);
    }), pe(me(r3), "isRangeEndQuarter", function(e5) {
      var t3 = r3.props, n3 = t3.day, o3 = t3.startDate, a5 = t3.endDate;
      return !(!o3 || !a5) && Le(setQuarter(n3, e5), a5);
    }), pe(me(r3), "isWeekInMonth", function(e5) {
      var t3 = r3.props.day, n3 = addDays(e5, 6);
      return Te(e5, t3) || Te(n3, t3);
    }), pe(me(r3), "renderWeeks", function() {
      for (var t3 = [], n3 = r3.props.fixedHeight, o3 = Ne(Oe(r3.props.day), r3.props.locale), a5 = 0, s5 = false; t3.push(React__default.createElement(wt, { ariaLabelPrefix: r3.props.weekAriaLabelPrefix, chooseDayAriaLabelPrefix: r3.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: r3.props.disabledDayAriaLabelPrefix, key: a5, day: o3, month: getMonth(r3.props.day), onDayClick: r3.handleDayClick, onDayMouseEnter: r3.handleDayMouseEnter, onWeekSelect: r3.props.onWeekSelect, formatWeekNumber: r3.props.formatWeekNumber, locale: r3.props.locale, minDate: r3.props.minDate, maxDate: r3.props.maxDate, excludeDates: r3.props.excludeDates, includeDates: r3.props.includeDates, inline: r3.props.inline, highlightDates: r3.props.highlightDates, selectingDate: r3.props.selectingDate, filterDate: r3.props.filterDate, preSelection: r3.props.preSelection, selected: r3.props.selected, selectsStart: r3.props.selectsStart, selectsEnd: r3.props.selectsEnd, showWeekNumber: r3.props.showWeekNumbers, startDate: r3.props.startDate, endDate: r3.props.endDate, dayClassName: r3.props.dayClassName, setOpen: r3.props.setOpen, shouldCloseOnSelect: r3.props.shouldCloseOnSelect, disabledKeyboardNavigation: r3.props.disabledKeyboardNavigation, renderDayContents: r3.props.renderDayContents, handleOnKeyDown: r3.props.handleOnKeyDown, isInputFocused: r3.props.isInputFocused, containerRef: r3.props.containerRef })), !s5; ) {
        a5++, o3 = addWeeks(o3, 1);
        var p2 = n3 && a5 >= 6, c4 = !n3 && !r3.isWeekInMonth(o3);
        if (p2 || c4) {
          if (!r3.props.peekNextMonth) break;
          s5 = true;
        }
      }
      return t3;
    }), pe(me(r3), "onMonthClick", function(e5, t3) {
      r3.handleDayClick(Oe(setMonth$1(r3.props.day, t3)), e5);
    }), pe(me(r3), "onQuarterClick", function(e5, t3) {
      r3.handleDayClick(xe(setQuarter(r3.props.day, t3)), e5);
    }), pe(me(r3), "getMonthClassNames", function(e5) {
      var n3 = r3.props, o3 = n3.day, a5 = n3.startDate, s5 = n3.endDate, p2 = n3.selected, i3 = n3.minDate, c4 = n3.maxDate;
      return classNames("react-datepicker__month-text", "react-datepicker__month-".concat(e5), { "react-datepicker__month--disabled": (i3 || c4) && Ue(setMonth$1(o3, e5), r3.props), "react-datepicker__month--selected": getMonth(o3) === e5 && getYear(o3) === getYear(p2), "react-datepicker__month--in-range": $e(a5, s5, e5, o3), "react-datepicker__month--range-start": r3.isRangeStartMonth(e5), "react-datepicker__month--range-end": r3.isRangeEndMonth(e5) });
    }), pe(me(r3), "getQuarterClassNames", function(e5) {
      var n3 = r3.props, o3 = n3.day, a5 = n3.startDate, s5 = n3.endDate, p2 = n3.selected, i3 = n3.minDate, c4 = n3.maxDate;
      return classNames("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(e5), { "react-datepicker__quarter--disabled": (i3 || c4) && ze(setQuarter(o3, e5), r3.props), "react-datepicker__quarter--selected": getQuarter(o3) === e5 && getYear(o3) === getYear(p2), "react-datepicker__quarter--in-range": Ge(a5, s5, e5, o3), "react-datepicker__quarter--range-start": r3.isRangeStartQuarter(e5), "react-datepicker__quarter--range-end": r3.isRangeEndQuarter(e5) });
    }), pe(me(r3), "renderMonths", function() {
      var t3 = r3.props, n3 = t3.showFullMonthYearPicker, o3 = t3.locale;
      return [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]].map(function(t4, a5) {
        return React__default.createElement("div", { className: "react-datepicker__month-wrapper", key: a5 }, t4.map(function(t5, a6) {
          return React__default.createElement("div", { key: a6, onClick: function(e5) {
            r3.onMonthClick(e5, t5);
          }, className: r3.getMonthClassNames(t5) }, n3 ? Ke(t5, o3) : He(t5, o3));
        }));
      });
    }), pe(me(r3), "renderQuarters", function() {
      return React__default.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [1, 2, 3, 4].map(function(t3, n3) {
        return React__default.createElement("div", { key: n3, onClick: function(e5) {
          r3.onQuarterClick(e5, t3);
        }, className: r3.getQuarterClassNames(t3) }, Qe(t3, r3.props.locale));
      }));
    }), pe(me(r3), "getClassNames", function() {
      var e5 = r3.props, n3 = e5.selectingDate, o3 = e5.selectsStart, a5 = e5.selectsEnd, s5 = e5.showMonthYearPicker, p2 = e5.showQuarterYearPicker;
      return classNames("react-datepicker__month", { "react-datepicker__month--selecting-range": n3 && (o3 || a5) }, { "react-datepicker__monthPicker": s5 }, { "react-datepicker__quarterPicker": p2 });
    }), r3;
  }
  return se(o2, [{ key: "render", value: function() {
    var t3 = this.props, r3 = t3.showMonthYearPicker, n3 = t3.showQuarterYearPicker, o3 = t3.day, a4 = t3.ariaLabelPrefix, s4 = void 0 === a4 ? "month " : a4;
    return React__default.createElement("div", { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, "aria-label": "".concat(s4, " ").concat(_e2(o3, "yyyy-MM")) }, r3 ? this.renderMonths() : n3 ? this.renderQuarters() : this.renderWeeks());
  } }]), o2;
}(), gt = function(t3) {
  de(n2, React__default.Component);
  var r2 = ve(n2);
  function n2() {
    var t4;
    oe(this, n2);
    for (var o2 = arguments.length, s4 = new Array(o2), p2 = 0; p2 < o2; p2++) s4[p2] = arguments[p2];
    return pe(me(t4 = r2.call.apply(r2, [this].concat(s4))), "state", { height: null }), pe(me(t4), "handleClick", function(e5) {
      (t4.props.minTime || t4.props.maxTime) && Ze(e5, t4.props) || t4.props.excludeTimes && Xe(e5, t4.props.excludeTimes) || t4.props.includeTimes && !Xe(e5, t4.props.includeTimes) || t4.props.onChange(e5);
    }), pe(me(t4), "liClasses", function(e5, r3, n3) {
      var o3 = ["react-datepicker__time-list-item", t4.props.timeClassName ? t4.props.timeClassName(e5, r3, n3) : void 0];
      return t4.props.selected && r3 === getHours(e5) && n3 === getMinutes(e5) && o3.push("react-datepicker__time-list-item--selected"), ((t4.props.minTime || t4.props.maxTime) && Ze(e5, t4.props) || t4.props.excludeTimes && Xe(e5, t4.props.excludeTimes) || t4.props.includeTimes && !Xe(e5, t4.props.includeTimes)) && o3.push("react-datepicker__time-list-item--disabled"), t4.props.injectTimes && (60 * getHours(e5) + getMinutes(e5)) % t4.props.intervals != 0 && o3.push("react-datepicker__time-list-item--injected"), o3.join(" ");
    }), pe(me(t4), "renderTimes", function() {
      for (var r3 = [], n3 = t4.props.format ? t4.props.format : "p", o3 = t4.props.intervals, s5 = t4.props.selected || t4.props.openToDate || ge(), p3 = getHours(s5), i3 = getMinutes(s5), c3 = Ee(ge()), l2 = 1440 / o3, d4 = t4.props.injectTimes && t4.props.injectTimes.sort(function(e5, t5) {
        return e5 - t5;
      }), u3 = 0; u3 < l2; u3++) {
        var h4 = addMinutes(c3, u3 * o3);
        if (r3.push(h4), d4) {
          var m4 = pt(c3, h4, u3, o3, d4);
          r3 = r3.concat(m4);
        }
      }
      return r3.map(function(r4, o4) {
        return React__default.createElement("li", { key: o4, onClick: t4.handleClick.bind(me(t4), r4), className: t4.liClasses(r4, p3, i3), ref: function(e5) {
          p3 === getHours(r4) && i3 >= getMinutes(r4) && (t4.centerLi = e5);
        } }, _e2(r4, n3, t4.props.locale));
      });
    }), t4;
  }
  return se(n2, [{ key: "componentDidMount", value: function() {
    this.list.scrollTop = n2.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
  } }, { key: "render", value: function() {
    var t4 = this, r3 = this.state.height;
    return React__default.createElement("div", { className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "") }, React__default.createElement("div", { className: "react-datepicker__header react-datepicker__header--time", ref: function(e5) {
      t4.header = e5;
    } }, React__default.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)), React__default.createElement("div", { className: "react-datepicker__time" }, React__default.createElement("div", { className: "react-datepicker__time-box" }, React__default.createElement("ul", { className: "react-datepicker__time-list", ref: function(e5) {
      t4.list = e5;
    }, style: r3 ? { height: r3 } : {} }, this.renderTimes()))));
  } }], [{ key: "defaultProps", get: function() {
    return { intervals: 30, onTimeChange: function() {
    }, todayButton: null, timeCaption: "Time" };
  } }]), n2;
}();
pe(gt, "calcCenterPosition", function(e5, t3) {
  return t3.offsetTop - (e5 / 2 - t3.clientHeight / 2);
});
var bt = function(t3) {
  de(n2, React__default.Component);
  var r2 = ve(n2);
  function n2(e5) {
    var t4;
    return oe(this, n2), pe(me(t4 = r2.call(this, e5)), "handleYearClick", function(e6, r3) {
      t4.props.onDayClick && t4.props.onDayClick(e6, r3);
    }), pe(me(t4), "onYearClick", function(e6, r3) {
      var n3;
      t4.handleYearClick((n3 = setYear(t4.props.date, r3), startOfYear(n3)), e6);
    }), t4;
  }
  return se(n2, [{ key: "render", value: function() {
    for (var t4 = this, r3 = [], n3 = this.props.date, o2 = function(n4, o3) {
      r3.push(React__default.createElement("div", { onClick: function(e5) {
        t4.onYearClick(e5, n4);
      }, className: "react-datepicker__year-container-text", key: n4 }, n4));
    }, a4 = getYear(n3) - 11, s4 = 0; a4 <= getYear(n3); a4++, s4++) o2(a4);
    return React__default.createElement("div", { className: "react-datepicker__year-container" }, r3);
  } }]), n2;
}(), Ct = function(t3) {
  de(n2, React__default.Component);
  var r2 = ve(n2);
  function n2(t4) {
    var o2;
    return oe(this, n2), pe(me(o2 = r2.call(this, t4)), "onTimeChange", function(e5) {
      o2.setState({ time: e5 });
      var t5 = /* @__PURE__ */ new Date();
      t5.setHours(e5.split(":")[0]), t5.setMinutes(e5.split(":")[1]), o2.props.onChange(t5);
    }), pe(me(o2), "renderTimeInput", function() {
      var t5 = o2.state.time, r3 = o2.props, n3 = r3.timeString, a4 = r3.customTimeInput;
      return a4 ? React__default.cloneElement(a4, { value: t5, onChange: o2.onTimeChange }) : React__default.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: true, value: t5, onChange: function(e5) {
        o2.onTimeChange(e5.target.value || n3);
      } });
    }), o2.state = { time: o2.props.timeString }, o2;
  }
  return se(n2, [{ key: "render", value: function() {
    return React__default.createElement("div", { className: "react-datepicker__input-time-container" }, React__default.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), React__default.createElement("div", { className: "react-datepicker-time__input-container" }, React__default.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
  } }]), n2;
}();
function _t(t3) {
  var r2 = t3.className, n2 = t3.children, o2 = t3.showPopperArrow, a4 = t3.arrowProps, s4 = void 0 === a4 ? {} : a4;
  return React__default.createElement("div", { className: r2 }, o2 && React__default.createElement("div", ie({ className: "react-datepicker__triangle" }, s4)), n2);
}
var St = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], Mt = function(r2) {
  de(o2, React__default.Component);
  var n2 = ve(o2);
  function o2(r3) {
    var a4;
    return oe(this, o2), pe(me(a4 = n2.call(this, r3)), "handleClickOutside", function(e5) {
      a4.props.onClickOutside(e5);
    }), pe(me(a4), "setClickOutsideRef", function() {
      return a4.containerRef.current;
    }), pe(me(a4), "handleDropdownFocus", function(e5) {
      (function() {
        var e6 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t3 = (e6.className || "").split(/\s+/);
        return St.some(function(e7) {
          return t3.indexOf(e7) >= 0;
        });
      })(e5.target) && a4.props.onDropdownFocus();
    }), pe(me(a4), "getDateInView", function() {
      var e5 = a4.props, t3 = e5.preSelection, r4 = e5.selected, n3 = e5.openToDate, o3 = ot(a4.props), s4 = at(a4.props), p2 = ge(), i3 = n3 || r4 || t3;
      return i3 || (o3 && isBefore$1(p2, o3) ? o3 : s4 && isAfter$1(p2, s4) ? s4 : p2);
    }), pe(me(a4), "increaseMonth", function() {
      a4.setState(function(e5) {
        var t3 = e5.date;
        return { date: addMonths(t3, 1) };
      }, function() {
        return a4.handleMonthChange(a4.state.date);
      });
    }), pe(me(a4), "decreaseMonth", function() {
      a4.setState(function(e5) {
        var t3 = e5.date;
        return { date: subMonths(t3, 1) };
      }, function() {
        return a4.handleMonthChange(a4.state.date);
      });
    }), pe(me(a4), "handleDayClick", function(e5, t3, r4) {
      return a4.props.onSelect(e5, t3, r4);
    }), pe(me(a4), "handleDayMouseEnter", function(e5) {
      a4.setState({ selectingDate: e5 }), a4.props.onDayMouseEnter && a4.props.onDayMouseEnter(e5);
    }), pe(me(a4), "handleMonthMouseLeave", function() {
      a4.setState({ selectingDate: null }), a4.props.onMonthMouseLeave && a4.props.onMonthMouseLeave();
    }), pe(me(a4), "handleYearChange", function(e5) {
      a4.props.onYearChange && a4.props.onYearChange(e5);
    }), pe(me(a4), "handleMonthChange", function(e5) {
      a4.props.onMonthChange && a4.props.onMonthChange(e5), a4.props.adjustDateOnChange && (a4.props.onSelect && a4.props.onSelect(e5), a4.props.setOpen && a4.props.setOpen(true)), a4.props.setPreSelection && a4.props.setPreSelection(e5);
    }), pe(me(a4), "handleMonthYearChange", function(e5) {
      a4.handleYearChange(e5), a4.handleMonthChange(e5);
    }), pe(me(a4), "changeYear", function(e5) {
      a4.setState(function(t3) {
        var r4 = t3.date;
        return { date: setYear(r4, e5) };
      }, function() {
        return a4.handleYearChange(a4.state.date);
      });
    }), pe(me(a4), "changeMonth", function(e5) {
      a4.setState(function(t3) {
        var r4 = t3.date;
        return { date: setMonth$1(r4, e5) };
      }, function() {
        return a4.handleMonthChange(a4.state.date);
      });
    }), pe(me(a4), "changeMonthYear", function(e5) {
      a4.setState(function(t3) {
        var r4 = t3.date;
        return { date: setYear(setMonth$1(r4, getMonth(e5)), getYear(e5)) };
      }, function() {
        return a4.handleMonthYearChange(a4.state.date);
      });
    }), pe(me(a4), "header", function() {
      var r4 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a4.state.date, n3 = Ne(r4, a4.props.locale), o3 = [];
      return a4.props.showWeekNumbers && o3.push(React__default.createElement("div", { key: "W", className: "react-datepicker__day-name" }, a4.props.weekLabel || "#")), o3.concat([0, 1, 2, 3, 4, 5, 6].map(function(r5) {
        var o4 = addDays(n3, r5), s4 = a4.formatWeekday(o4, a4.props.locale), i3 = a4.props.weekDayClassName ? a4.props.weekDayClassName(o4) : void 0;
        return React__default.createElement("div", { key: r5, className: classNames("react-datepicker__day-name", i3) }, s4);
      }));
    }), pe(me(a4), "formatWeekday", function(e5, t3) {
      return a4.props.formatWeekDay ? function(e6, t4, r4) {
        return t4(_e2(e6, "EEEE", r4));
      }(e5, a4.props.formatWeekDay, t3) : a4.props.useWeekdaysShort ? function(e6, t4) {
        return _e2(e6, "EEE", t4);
      }(e5, t3) : function(e6, t4) {
        return _e2(e6, "EEEEEE", t4);
      }(e5, t3);
    }), pe(me(a4), "decreaseYear", function() {
      a4.setState(function(e5) {
        var t3 = e5.date;
        return { date: subYears(t3, a4.props.showYearPicker ? 11 : 1) };
      }, function() {
        return a4.handleYearChange(a4.state.date);
      });
    }), pe(me(a4), "renderPreviousButton", function() {
      if (!a4.props.renderCustomHeader) {
        var t3 = a4.props.showMonthYearPicker ? rt(a4.state.date, a4.props) : et(a4.state.date, a4.props);
        if ((a4.props.forceShowMonthNavigation || a4.props.showDisabledMonthNavigation || !t3) && !a4.props.showTimeSelectOnly) {
          var r4 = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], n3 = a4.decreaseMonth;
          (a4.props.showMonthYearPicker || a4.props.showQuarterYearPicker || a4.props.showYearPicker) && (n3 = a4.decreaseYear), t3 && a4.props.showDisabledMonthNavigation && (r4.push("react-datepicker__navigation--previous--disabled"), n3 = null);
          var o3 = a4.props.showMonthYearPicker || a4.props.showQuarterYearPicker, s4 = a4.props, p2 = s4.previousMonthAriaLabel, i3 = void 0 === p2 ? "Previous Month" : p2, c3 = s4.previousYearAriaLabel, l2 = void 0 === c3 ? "Previous Year" : c3;
          return React__default.createElement("button", { type: "button", className: r4.join(" "), onClick: n3, "aria-label": o3 ? l2 : i3 }, o3 ? a4.props.previousYearButtonLabel : a4.props.previousMonthButtonLabel);
        }
      }
    }), pe(me(a4), "increaseYear", function() {
      a4.setState(function(e5) {
        var t3 = e5.date;
        return { date: addYears(t3, a4.props.showYearPicker ? 11 : 1) };
      }, function() {
        return a4.handleYearChange(a4.state.date);
      });
    }), pe(me(a4), "renderNextButton", function() {
      if (!a4.props.renderCustomHeader) {
        var t3 = a4.props.showMonthYearPicker ? nt(a4.state.date, a4.props) : tt(a4.state.date, a4.props);
        if ((a4.props.forceShowMonthNavigation || a4.props.showDisabledMonthNavigation || !t3) && !a4.props.showTimeSelectOnly) {
          var r4 = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          a4.props.showTimeSelect && r4.push("react-datepicker__navigation--next--with-time"), a4.props.todayButton && r4.push("react-datepicker__navigation--next--with-today-button");
          var n3 = a4.increaseMonth;
          (a4.props.showMonthYearPicker || a4.props.showQuarterYearPicker || a4.props.showYearPicker) && (n3 = a4.increaseYear), t3 && a4.props.showDisabledMonthNavigation && (r4.push("react-datepicker__navigation--next--disabled"), n3 = null);
          var o3 = a4.props.showMonthYearPicker || a4.props.showQuarterYearPicker, s4 = a4.props, p2 = s4.nextMonthAriaLabel, i3 = void 0 === p2 ? "Next Month" : p2, c3 = s4.nextYearAriaLabel, l2 = void 0 === c3 ? "Next Year" : c3;
          return React__default.createElement("button", { type: "button", className: r4.join(" "), onClick: n3, "aria-label": o3 ? l2 : i3 }, o3 ? a4.props.nextYearButtonLabel : a4.props.nextMonthButtonLabel);
        }
      }
    }), pe(me(a4), "renderCurrentMonth", function() {
      var t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a4.state.date, r4 = ["react-datepicker__current-month"];
      return a4.props.showYearDropdown && r4.push("react-datepicker__current-month--hasYearDropdown"), a4.props.showMonthDropdown && r4.push("react-datepicker__current-month--hasMonthDropdown"), a4.props.showMonthYearDropdown && r4.push("react-datepicker__current-month--hasMonthYearDropdown"), React__default.createElement("div", { className: r4.join(" ") }, _e2(t3, a4.props.dateFormat, a4.props.locale));
    }), pe(me(a4), "renderYearDropdown", function() {
      var t3 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      if (a4.props.showYearDropdown && !t3) return React__default.createElement(dt, { adjustDateOnChange: a4.props.adjustDateOnChange, date: a4.state.date, onSelect: a4.props.onSelect, setOpen: a4.props.setOpen, dropdownMode: a4.props.dropdownMode, onChange: a4.changeYear, minDate: a4.props.minDate, maxDate: a4.props.maxDate, year: getYear(a4.state.date), scrollableYearDropdown: a4.props.scrollableYearDropdown, yearDropdownItemNumber: a4.props.yearDropdownItemNumber });
    }), pe(me(a4), "renderMonthDropdown", function() {
      var t3 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      if (a4.props.showMonthDropdown && !t3) return React__default.createElement(ht, { dropdownMode: a4.props.dropdownMode, locale: a4.props.locale, onChange: a4.changeMonth, month: getMonth(a4.state.date), useShortMonthInDropdown: a4.props.useShortMonthInDropdown });
    }), pe(me(a4), "renderMonthYearDropdown", function() {
      var t3 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      if (a4.props.showMonthYearDropdown && !t3) return React__default.createElement(vt, { dropdownMode: a4.props.dropdownMode, locale: a4.props.locale, dateFormat: a4.props.dateFormat, onChange: a4.changeMonthYear, minDate: a4.props.minDate, maxDate: a4.props.maxDate, date: a4.state.date, scrollableMonthYearDropdown: a4.props.scrollableMonthYearDropdown });
    }), pe(me(a4), "renderTodayButton", function() {
      if (a4.props.todayButton && !a4.props.showTimeSelectOnly) return React__default.createElement("div", { className: "react-datepicker__today-button", onClick: function(e5) {
        return a4.props.onSelect(startOfDay(ge()), e5);
      } }, a4.props.todayButton);
    }), pe(me(a4), "renderDefaultHeader", function(t3) {
      var r4 = t3.monthDate, n3 = t3.i;
      return React__default.createElement("div", { className: "react-datepicker__header" }, a4.renderCurrentMonth(r4), React__default.createElement("div", { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a4.props.dropdownMode), onFocus: a4.handleDropdownFocus }, a4.renderMonthDropdown(0 !== n3), a4.renderMonthYearDropdown(0 !== n3), a4.renderYearDropdown(0 !== n3)), React__default.createElement("div", { className: "react-datepicker__day-names" }, a4.header(r4)));
    }), pe(me(a4), "renderCustomHeader", function() {
      var t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r4 = t3.monthDate, n3 = t3.i;
      if (0 !== n3 && void 0 !== n3) return null;
      var o3 = et(a4.state.date, a4.props), s4 = tt(a4.state.date, a4.props), p2 = rt(a4.state.date, a4.props), i3 = nt(a4.state.date, a4.props), c3 = !a4.props.showMonthYearPicker && !a4.props.showQuarterYearPicker && !a4.props.showYearPicker;
      return React__default.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: a4.props.onDropdownFocus }, a4.props.renderCustomHeader(le(le({}, a4.state), {}, { changeMonth: a4.changeMonth, changeYear: a4.changeYear, decreaseMonth: a4.decreaseMonth, increaseMonth: a4.increaseMonth, decreaseYear: a4.decreaseYear, increaseYear: a4.increaseYear, prevMonthButtonDisabled: o3, nextMonthButtonDisabled: s4, prevYearButtonDisabled: p2, nextYearButtonDisabled: i3 })), c3 && React__default.createElement("div", { className: "react-datepicker__day-names" }, a4.header(r4)));
    }), pe(me(a4), "renderYearHeader", function() {
      return React__default.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, a4.props.showYearPicker ? "".concat(getYear(a4.state.date) - 11, " - ").concat(getYear(a4.state.date)) : getYear(a4.state.date));
    }), pe(me(a4), "renderHeader", function(e5) {
      switch (true) {
        case void 0 !== a4.props.renderCustomHeader:
          return a4.renderCustomHeader(e5);
        case (a4.props.showMonthYearPicker || a4.props.showQuarterYearPicker || a4.props.showYearPicker):
          return a4.renderYearHeader(e5);
        default:
          return a4.renderDefaultHeader(e5);
      }
    }), pe(me(a4), "renderMonths", function() {
      if (!a4.props.showTimeSelectOnly && !a4.props.showYearPicker) {
        for (var t3 = [], r4 = a4.props.showPreviousMonths ? a4.props.monthsShown - 1 : 0, n3 = subMonths(a4.state.date, r4), o3 = 0; o3 < a4.props.monthsShown; ++o3) {
          var s4 = o3 - a4.props.monthSelectedIn, p2 = addMonths(n3, s4), i3 = "month-".concat(o3);
          t3.push(React__default.createElement("div", { key: i3, ref: function(e5) {
            a4.monthContainer = e5;
          }, className: "react-datepicker__month-container" }, a4.renderHeader({ monthDate: p2, i: o3 }), React__default.createElement(kt, { chooseDayAriaLabelPrefix: a4.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: a4.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: a4.props.weekAriaLabelPrefix, onChange: a4.changeMonthYear, day: p2, dayClassName: a4.props.dayClassName, monthClassName: a4.props.monthClassName, onDayClick: a4.handleDayClick, handleOnKeyDown: a4.props.handleOnKeyDown, onDayMouseEnter: a4.handleDayMouseEnter, onMouseLeave: a4.handleMonthMouseLeave, onWeekSelect: a4.props.onWeekSelect, orderInDisplay: o3, formatWeekNumber: a4.props.formatWeekNumber, locale: a4.props.locale, minDate: a4.props.minDate, maxDate: a4.props.maxDate, excludeDates: a4.props.excludeDates, highlightDates: a4.props.highlightDates, selectingDate: a4.state.selectingDate, includeDates: a4.props.includeDates, inline: a4.props.inline, fixedHeight: a4.props.fixedHeight, filterDate: a4.props.filterDate, preSelection: a4.props.preSelection, selected: a4.props.selected, selectsStart: a4.props.selectsStart, selectsEnd: a4.props.selectsEnd, showWeekNumbers: a4.props.showWeekNumbers, startDate: a4.props.startDate, endDate: a4.props.endDate, peekNextMonth: a4.props.peekNextMonth, setOpen: a4.props.setOpen, shouldCloseOnSelect: a4.props.shouldCloseOnSelect, renderDayContents: a4.props.renderDayContents, disabledKeyboardNavigation: a4.props.disabledKeyboardNavigation, showMonthYearPicker: a4.props.showMonthYearPicker, showFullMonthYearPicker: a4.props.showFullMonthYearPicker, showYearPicker: a4.props.showYearPicker, showQuarterYearPicker: a4.props.showQuarterYearPicker, isInputFocused: a4.props.isInputFocused, containerRef: a4.containerRef })));
        }
        return t3;
      }
    }), pe(me(a4), "renderYears", function() {
      if (!a4.props.showTimeSelectOnly) return a4.props.showYearPicker ? React__default.createElement("div", { className: "react-datepicker__year" }, a4.renderHeader(), React__default.createElement(bt, { onDayClick: a4.handleDayClick, date: a4.state.date })) : void 0;
    }), pe(me(a4), "renderTimeSection", function() {
      if (a4.props.showTimeSelect && (a4.state.monthContainer || a4.props.showTimeSelectOnly)) return React__default.createElement(gt, { selected: a4.props.selected, openToDate: a4.props.openToDate, onChange: a4.props.onTimeChange, timeClassName: a4.props.timeClassName, format: a4.props.timeFormat, includeTimes: a4.props.includeTimes, intervals: a4.props.timeIntervals, minTime: a4.props.minTime, maxTime: a4.props.maxTime, excludeTimes: a4.props.excludeTimes, timeCaption: a4.props.timeCaption, todayButton: a4.props.todayButton, showMonthDropdown: a4.props.showMonthDropdown, showMonthYearDropdown: a4.props.showMonthYearDropdown, showYearDropdown: a4.props.showYearDropdown, withPortal: a4.props.withPortal, monthRef: a4.state.monthContainer, injectTimes: a4.props.injectTimes, locale: a4.props.locale });
    }), pe(me(a4), "renderInputTimeSection", function() {
      var t3 = new Date(a4.props.selected), r4 = "".concat(it(t3.getHours()), ":").concat(it(t3.getMinutes()));
      if (a4.props.showTimeInput) return React__default.createElement(Ct, { timeString: r4, timeInputLabel: a4.props.timeInputLabel, onChange: a4.props.onTimeChange, customTimeInput: a4.props.customTimeInput });
    }), a4.containerRef = React__default.createRef(), a4.state = { date: a4.getDateInView(), selectingDate: null, monthContainer: null }, a4;
  }
  return se(o2, null, [{ key: "defaultProps", get: function() {
    return { onDropdownFocus: function() {
    }, monthsShown: 1, monthSelectedIn: 0, forceShowMonthNavigation: false, timeCaption: "Time", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", customTimeInput: null };
  } }]), se(o2, [{ key: "componentDidMount", value: function() {
    var e5 = this;
    this.props.showTimeSelect && (this.assignMonthContainer = void e5.setState({ monthContainer: e5.monthContainer }));
  } }, { key: "componentDidUpdate", value: function(e5) {
    this.props.preSelection && !Ie(this.props.preSelection, e5.preSelection) ? this.setState({ date: this.props.preSelection }) : this.props.openToDate && !Ie(this.props.openToDate, e5.openToDate) && this.setState({ date: this.props.openToDate });
  } }, { key: "render", value: function() {
    var r3 = this.props.container || _t;
    return React__default.createElement("div", { ref: this.containerRef }, React__default.createElement(r3, { className: classNames("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }), showPopperArrow: this.props.showPopperArrow }, this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.props.children));
  } }]), o2;
}(), Pt = function(e5) {
  return !e5.disabled && -1 !== e5.tabIndex;
}, Et = function(t3) {
  de(n2, React__default.Component);
  var r2 = ve(n2);
  function n2(t4) {
    var o2;
    return oe(this, n2), pe(me(o2 = r2.call(this, t4)), "getTabChildren", function() {
      return Array.prototype.slice.call(o2.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(Pt);
    }), pe(me(o2), "handleFocusStart", function(e5) {
      var t5 = o2.getTabChildren();
      t5 && t5.length > 1 && t5[t5.length - 1].focus();
    }), pe(me(o2), "handleFocusEnd", function(e5) {
      var t5 = o2.getTabChildren();
      t5 && t5.length > 1 && t5[0].focus();
    }), o2.tabLoopRef = React__default.createRef(), o2;
  }
  return se(n2, null, [{ key: "defaultProps", get: function() {
    return { enableTabLoop: true };
  } }]), se(n2, [{ key: "render", value: function() {
    return this.props.enableTabLoop ? React__default.createElement("div", { className: "react-datepicker__tab-loop", ref: this.tabLoopRef }, React__default.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: "0", onFocus: this.handleFocusStart }), this.props.children, React__default.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: "0", onFocus: this.handleFocusEnd })) : this.props.children;
  } }]), n2;
}(), Nt = function(r2) {
  de(o2, React__default.Component);
  var n2 = ve(o2);
  function o2() {
    return oe(this, o2), n2.apply(this, arguments);
  }
  return se(o2, [{ key: "render", value: function() {
    var r3, n3 = this.props, o3 = n3.className, a4 = n3.wrapperClassName, s4 = n3.hidePopper, p2 = n3.popperComponent, i3 = n3.popperModifiers, c3 = n3.popperPlacement, l2 = n3.popperProps, d4 = n3.targetComponent, u3 = n3.enableTabLoop, h4 = n3.popperOnKeyDown;
    if (!s4) {
      var m4 = classNames("react-datepicker-popper", o3);
      r3 = React__default.createElement(Popper, ie({ modifiers: i3, placement: c3 }, l2), function(t3) {
        var r4 = t3.ref, n4 = t3.style, o4 = t3.placement, a5 = t3.arrowProps;
        return React__default.createElement(Et, { enableTabLoop: u3 }, React__default.createElement("div", ie({ ref: r4, style: n4 }, { className: m4, "data-placement": o4, onKeyDown: h4 }), React__default.cloneElement(p2, { arrowProps: a5 })));
      });
    }
    this.props.popperContainer && (r3 = React__default.createElement(this.props.popperContainer, {}, r3));
    var f2 = classNames("react-datepicker-wrapper", a4);
    return React__default.createElement(Manager, { className: "react-datepicker-manager" }, React__default.createElement(Reference, null, function(t3) {
      var r4 = t3.ref;
      return React__default.createElement("div", { ref: r4, className: f2 }, d4);
    }), r3);
  } }], [{ key: "defaultProps", get: function() {
    return { hidePopper: true, popperModifiers: { preventOverflow: { enabled: true, escapeWithReference: true, boundariesElement: "viewport" } }, popperProps: {}, popperPlacement: "bottom-start" };
  } }]), o2;
}(), Ot = onClickOutsideHOC(Mt);
var xt = function(n2) {
  de(a4, React__default.Component);
  var o2 = ve(a4);
  function a4(n3) {
    var s4;
    return oe(this, a4), pe(me(s4 = o2.call(this, n3)), "getPreSelection", function() {
      return s4.props.openToDate ? s4.props.openToDate : s4.props.selectsEnd && s4.props.startDate ? s4.props.startDate : s4.props.selectsStart && s4.props.endDate ? s4.props.endDate : ge();
    }), pe(me(s4), "calcInitialState", function() {
      var e5 = s4.getPreSelection(), t3 = ot(s4.props), r2 = at(s4.props), n4 = t3 && isBefore$1(e5, t3) ? t3 : r2 && isAfter$1(e5, r2) ? r2 : e5;
      return { open: s4.props.startOpen || false, preventFocus: false, preSelection: s4.props.selected ? s4.props.selected : n4, highlightDates: st(s4.props.highlightDates), focused: false };
    }), pe(me(s4), "clearPreventFocusTimeout", function() {
      s4.preventFocusTimeout && clearTimeout(s4.preventFocusTimeout);
    }), pe(me(s4), "setFocus", function() {
      s4.input && s4.input.focus && s4.input.focus();
    }), pe(me(s4), "setBlur", function() {
      s4.input && s4.input.blur && s4.input.blur(), s4.cancelFocusInput();
    }), pe(me(s4), "setOpen", function(e5) {
      var t3 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      s4.setState({ open: e5, preSelection: e5 && s4.state.open ? s4.state.preSelection : s4.calcInitialState().preSelection, lastPreSelectChange: Tt }, function() {
        e5 || s4.setState(function(e6) {
          return { focused: !!t3 && e6.focused };
        }, function() {
          !t3 && s4.setBlur(), s4.setState({ inputValue: null });
        });
      });
    }), pe(me(s4), "inputOk", function() {
      return isDate$2(s4.state.preSelection);
    }), pe(me(s4), "isCalendarOpen", function() {
      return void 0 === s4.props.open ? s4.state.open && !s4.props.disabled && !s4.props.readOnly : s4.props.open;
    }), pe(me(s4), "handleFocus", function(e5) {
      s4.state.preventFocus || (s4.props.onFocus(e5), s4.props.preventOpenOnFocus || s4.props.readOnly || s4.setOpen(true)), s4.setState({ focused: true });
    }), pe(me(s4), "cancelFocusInput", function() {
      clearTimeout(s4.inputFocusTimeout), s4.inputFocusTimeout = null;
    }), pe(me(s4), "deferFocusInput", function() {
      s4.cancelFocusInput(), s4.inputFocusTimeout = setTimeout(function() {
        return s4.setFocus();
      }, 1);
    }), pe(me(s4), "handleDropdownFocus", function() {
      s4.cancelFocusInput();
    }), pe(me(s4), "handleBlur", function(e5) {
      (!s4.state.open || s4.props.withPortal || s4.props.showTimeInput) && s4.props.onBlur(e5), s4.setState({ focused: false });
    }), pe(me(s4), "handleCalendarClickOutside", function(e5) {
      s4.props.inline || s4.setOpen(false), s4.props.onClickOutside(e5), s4.props.withPortal && e5.preventDefault();
    }), pe(me(s4), "handleChange", function() {
      for (var e5 = arguments.length, t3 = new Array(e5), r2 = 0; r2 < e5; r2++) t3[r2] = arguments[r2];
      var n4 = t3[0];
      if (!s4.props.onChangeRaw || (s4.props.onChangeRaw.apply(me(s4), t3), "function" == typeof n4.isDefaultPrevented && !n4.isDefaultPrevented())) {
        s4.setState({ inputValue: n4.target.value, lastPreSelectChange: Yt });
        var o3 = be(n4.target.value, s4.props.dateFormat, s4.props.locale, s4.props.strictParsing);
        !o3 && n4.target.value || s4.setSelected(o3, n4, true);
      }
    }), pe(me(s4), "handleSelect", function(e5, t3, r2) {
      s4.setState({ preventFocus: true }, function() {
        return s4.preventFocusTimeout = setTimeout(function() {
          return s4.setState({ preventFocus: false });
        }, 50), s4.preventFocusTimeout;
      }), s4.setSelected(e5, t3, false, r2), !s4.props.shouldCloseOnSelect || s4.props.showTimeSelect ? s4.setPreSelection(e5) : s4.props.inline || s4.setOpen(false);
    }), pe(me(s4), "setSelected", function(e5, t3, r2, n4) {
      var o3 = e5;
      null !== o3 && Ve(o3, s4.props) || (Fe(s4.props.selected, o3) && !s4.props.allowSameDay || (null !== o3 && (!s4.props.selected || r2 && (s4.props.showTimeSelect || s4.props.showTimeSelectOnly || s4.props.showTimeInput) || (o3 = Se(o3, { hour: getHours(s4.props.selected), minute: getMinutes(s4.props.selected), second: getSeconds(s4.props.selected) })), s4.props.inline || s4.setState({ preSelection: o3 }), s4.props.inline && s4.props.monthsShown > 1 && !s4.props.inlineFocusSelectedMonth && s4.setState({ monthSelectedIn: n4 })), s4.props.onChange(o3, t3)), s4.props.onSelect(o3, t3), r2 || s4.setState({ inputValue: null }));
    }), pe(me(s4), "setPreSelection", function(e5) {
      var t3 = void 0 !== s4.props.minDate, r2 = void 0 !== s4.props.maxDate, n4 = true;
      e5 && (t3 && r2 ? n4 = Re(e5, s4.props.minDate, s4.props.maxDate) : t3 ? n4 = isAfter$1(e5, s4.props.minDate) : r2 && (n4 = isBefore$1(e5, s4.props.maxDate))), n4 && s4.setState({ preSelection: e5 });
    }), pe(me(s4), "handleTimeChange", function(e5) {
      var t3 = Se(s4.props.selected ? s4.props.selected : s4.getPreSelection(), { hour: getHours(e5), minute: getMinutes(e5) });
      s4.setState({ preSelection: t3 }), s4.props.onChange(t3), s4.props.shouldCloseOnSelect && s4.setOpen(false), s4.props.showTimeInput && s4.setOpen(true), s4.setState({ inputValue: null });
    }), pe(me(s4), "onInputClick", function() {
      s4.props.disabled || s4.props.readOnly || s4.setOpen(true), s4.props.onInputClick();
    }), pe(me(s4), "onInputKeyDown", function(e5) {
      s4.props.onKeyDown(e5);
      var t3 = e5.key;
      if (s4.state.open || s4.props.inline || s4.props.preventOpenOnFocus) {
        if (s4.state.open) {
          if ("ArrowDown" === t3 || "ArrowUp" === t3) {
            e5.preventDefault();
            var r2 = s4.calendar.componentNode && s4.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
            return void (r2 && r2.focus());
          }
          var n4 = ge(s4.state.preSelection);
          "Enter" === t3 ? (e5.preventDefault(), s4.inputOk() && s4.state.lastPreSelectChange === Tt ? (s4.handleSelect(n4, e5), !s4.props.shouldCloseOnSelect && s4.setPreSelection(n4)) : s4.setOpen(false)) : "Escape" === t3 && (e5.preventDefault(), s4.setOpen(false)), s4.inputOk() || s4.props.onInputError({ code: 1, msg: "Date input not valid." });
        }
      } else "ArrowDown" !== t3 && "ArrowUp" !== t3 && "Enter" !== t3 || s4.onInputClick();
    }), pe(me(s4), "onDayKeyDown", function(e5) {
      s4.props.onKeyDown(e5);
      var t3 = e5.key, r2 = ge(s4.state.preSelection);
      if ("Enter" === t3) e5.preventDefault(), s4.handleSelect(r2, e5), !s4.props.shouldCloseOnSelect && s4.setPreSelection(r2);
      else if ("Escape" === t3) e5.preventDefault(), s4.setOpen(false), s4.inputOk() || s4.props.onInputError({ code: 1, msg: "Date input not valid." });
      else if (!s4.props.disabledKeyboardNavigation) {
        var n4;
        switch (t3) {
          case "ArrowLeft":
            n4 = subDays(r2, 1);
            break;
          case "ArrowRight":
            n4 = addDays(r2, 1);
            break;
          case "ArrowUp":
            n4 = subWeeks(r2, 1);
            break;
          case "ArrowDown":
            n4 = addWeeks(r2, 1);
            break;
          case "PageUp":
            n4 = subMonths(r2, 1);
            break;
          case "PageDown":
            n4 = addMonths(r2, 1);
            break;
          case "Home":
            n4 = subYears(r2, 1);
            break;
          case "End":
            n4 = addYears(r2, 1);
        }
        if (!n4) return void (s4.props.onInputError && s4.props.onInputError({ code: 1, msg: "Date input not valid." }));
        e5.preventDefault(), s4.setState({ lastPreSelectChange: Tt }), s4.props.adjustDateOnChange && s4.setSelected(n4), s4.setPreSelection(n4);
      }
    }), pe(me(s4), "onPopperKeyDown", function(e5) {
      "Escape" === e5.key && (e5.preventDefault(), s4.setState({ preventFocus: true }, function() {
        s4.setOpen(false), setTimeout(function() {
          s4.setFocus(), s4.setState({ preventFocus: false });
        });
      }));
    }), pe(me(s4), "onClearClick", function(e5) {
      e5 && e5.preventDefault && e5.preventDefault(), s4.props.onChange(null, e5), s4.setState({ inputValue: null });
    }), pe(me(s4), "clear", function() {
      s4.onClearClick();
    }), pe(me(s4), "renderCalendar", function() {
      return s4.props.inline || s4.isCalendarOpen() ? React__default.createElement(Ot, { ref: function(e5) {
        s4.calendar = e5;
      }, locale: s4.props.locale, chooseDayAriaLabelPrefix: s4.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: s4.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: s4.props.weekAriaLabelPrefix, adjustDateOnChange: s4.props.adjustDateOnChange, setOpen: s4.setOpen, shouldCloseOnSelect: s4.props.shouldCloseOnSelect, dateFormat: s4.props.dateFormatCalendar, useWeekdaysShort: s4.props.useWeekdaysShort, formatWeekDay: s4.props.formatWeekDay, dropdownMode: s4.props.dropdownMode, selected: s4.props.selected, preSelection: s4.state.preSelection, onSelect: s4.handleSelect, onWeekSelect: s4.props.onWeekSelect, openToDate: s4.props.openToDate, minDate: s4.props.minDate, maxDate: s4.props.maxDate, selectsStart: s4.props.selectsStart, selectsEnd: s4.props.selectsEnd, startDate: s4.props.startDate, endDate: s4.props.endDate, excludeDates: s4.props.excludeDates, filterDate: s4.props.filterDate, onClickOutside: s4.handleCalendarClickOutside, formatWeekNumber: s4.props.formatWeekNumber, highlightDates: s4.state.highlightDates, includeDates: s4.props.includeDates, includeTimes: s4.props.includeTimes, injectTimes: s4.props.injectTimes, inline: s4.props.inline, peekNextMonth: s4.props.peekNextMonth, showMonthDropdown: s4.props.showMonthDropdown, showPreviousMonths: s4.props.showPreviousMonths, useShortMonthInDropdown: s4.props.useShortMonthInDropdown, showMonthYearDropdown: s4.props.showMonthYearDropdown, showWeekNumbers: s4.props.showWeekNumbers, showYearDropdown: s4.props.showYearDropdown, withPortal: s4.props.withPortal, forceShowMonthNavigation: s4.props.forceShowMonthNavigation, showDisabledMonthNavigation: s4.props.showDisabledMonthNavigation, scrollableYearDropdown: s4.props.scrollableYearDropdown, scrollableMonthYearDropdown: s4.props.scrollableMonthYearDropdown, todayButton: s4.props.todayButton, weekLabel: s4.props.weekLabel, outsideClickIgnoreClass: "react-datepicker-ignore-onclickoutside", fixedHeight: s4.props.fixedHeight, monthsShown: s4.props.monthsShown, monthSelectedIn: s4.state.monthSelectedIn, onDropdownFocus: s4.handleDropdownFocus, onMonthChange: s4.props.onMonthChange, onYearChange: s4.props.onYearChange, dayClassName: s4.props.dayClassName, weekDayClassName: s4.props.weekDayClassName, monthClassName: s4.props.monthClassName, timeClassName: s4.props.timeClassName, showTimeSelect: s4.props.showTimeSelect, showTimeSelectOnly: s4.props.showTimeSelectOnly, onTimeChange: s4.handleTimeChange, timeFormat: s4.props.timeFormat, timeIntervals: s4.props.timeIntervals, minTime: s4.props.minTime, maxTime: s4.props.maxTime, excludeTimes: s4.props.excludeTimes, timeCaption: s4.props.timeCaption, className: s4.props.calendarClassName, container: s4.props.calendarContainer, yearDropdownItemNumber: s4.props.yearDropdownItemNumber, previousMonthButtonLabel: s4.props.previousMonthButtonLabel, nextMonthButtonLabel: s4.props.nextMonthButtonLabel, previousYearButtonLabel: s4.props.previousYearButtonLabel, nextYearButtonLabel: s4.props.nextYearButtonLabel, timeInputLabel: s4.props.timeInputLabel, disabledKeyboardNavigation: s4.props.disabledKeyboardNavigation, renderCustomHeader: s4.props.renderCustomHeader, popperProps: s4.props.popperProps, renderDayContents: s4.props.renderDayContents, onDayMouseEnter: s4.props.onDayMouseEnter, onMonthMouseLeave: s4.props.onMonthMouseLeave, showTimeInput: s4.props.showTimeInput, showMonthYearPicker: s4.props.showMonthYearPicker, showFullMonthYearPicker: s4.props.showFullMonthYearPicker, showYearPicker: s4.props.showYearPicker, showQuarterYearPicker: s4.props.showQuarterYearPicker, showPopperArrow: s4.props.showPopperArrow, excludeScrollbar: s4.props.excludeScrollbar, handleOnKeyDown: s4.onDayKeyDown, isInputFocused: s4.state.focused, customTimeInput: s4.props.customTimeInput, setPreSelection: s4.setPreSelection }, s4.props.children) : null;
    }), pe(me(s4), "renderDateInput", function() {
      var r2, n4, o3, a5, p2, i3 = classNames(s4.props.className, pe({}, "react-datepicker-ignore-onclickoutside", s4.state.open)), c3 = s4.props.customInput || React__default.createElement("input", { type: "text" }), l2 = s4.props.customInputRef || "ref", d4 = "string" == typeof s4.props.value ? s4.props.value : "string" == typeof s4.state.inputValue ? s4.state.inputValue : (n4 = s4.props.selected, o3 = s4.props, a5 = o3.dateFormat, p2 = o3.locale, n4 && _e2(n4, Array.isArray(a5) ? a5[0] : a5, p2) || "");
      return React__default.cloneElement(c3, (pe(r2 = {}, l2, function(e5) {
        s4.input = e5;
      }), pe(r2, "value", d4), pe(r2, "onBlur", s4.handleBlur), pe(r2, "onChange", s4.handleChange), pe(r2, "onClick", s4.onInputClick), pe(r2, "onFocus", s4.handleFocus), pe(r2, "onKeyDown", s4.onInputKeyDown), pe(r2, "id", s4.props.id), pe(r2, "name", s4.props.name), pe(r2, "autoFocus", s4.props.autoFocus), pe(r2, "placeholder", s4.props.placeholderText), pe(r2, "disabled", s4.props.disabled), pe(r2, "autoComplete", s4.props.autoComplete), pe(r2, "className", classNames(c3.props.className, i3)), pe(r2, "title", s4.props.title), pe(r2, "readOnly", s4.props.readOnly), pe(r2, "required", s4.props.required), pe(r2, "tabIndex", s4.props.tabIndex), pe(r2, "aria-labelledby", s4.props.ariaLabelledBy), r2));
    }), pe(me(s4), "renderClearButton", function() {
      var t3 = s4.props, r2 = t3.isClearable, n4 = t3.selected, o3 = t3.clearButtonTitle, a5 = t3.ariaLabelClose, p2 = void 0 === a5 ? "Close" : a5;
      return r2 && null != n4 ? React__default.createElement("button", { type: "button", className: "react-datepicker__close-icon", "aria-label": p2, onClick: s4.onClearClick, title: o3, tabIndex: -1 }) : null;
    }), s4.state = s4.calcInitialState(), s4;
  }
  return se(a4, null, [{ key: "defaultProps", get: function() {
    return { allowSameDay: false, dateFormat: "MM/dd/yyyy", dateFormatCalendar: "LLLL yyyy", onChange: function() {
    }, disabled: false, disabledKeyboardNavigation: false, dropdownMode: "scroll", onFocus: function() {
    }, onBlur: function() {
    }, onKeyDown: function() {
    }, onInputClick: function() {
    }, onSelect: function() {
    }, onClickOutside: function() {
    }, onMonthChange: function() {
    }, onCalendarOpen: function() {
    }, onCalendarClose: function() {
    }, preventOpenOnFocus: false, onYearChange: function() {
    }, onInputError: function() {
    }, monthsShown: 1, readOnly: false, withPortal: false, shouldCloseOnSelect: true, showTimeSelect: false, showTimeInput: false, showPreviousMonths: false, showMonthYearPicker: false, showFullMonthYearPicker: false, showYearPicker: false, showQuarterYearPicker: false, strictParsing: false, timeIntervals: 30, timeCaption: "Time", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", timeInputLabel: "Time", enableTabLoop: true, renderDayContents: function(e5) {
      return e5;
    }, inlineFocusSelectedMonth: false, showPopperArrow: true, excludeScrollbar: true, customTimeInput: null };
  } }]), se(a4, [{ key: "componentDidUpdate", value: function(e5, t3) {
    var r2, n3;
    e5.inline && (r2 = e5.selected, n3 = this.props.selected, r2 && n3 ? getMonth(r2) !== getMonth(n3) || getYear(r2) !== getYear(n3) : r2 !== n3) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e5.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), e5.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: st(this.props.highlightDates) }), t3.focused || Fe(e5.selected, this.props.selected) || this.setState({ inputValue: null }), t3.open !== this.state.open && (false === t3.open && true === this.state.open && this.props.onCalendarOpen(), true === t3.open && false === this.state.open && this.props.onCalendarClose());
  } }, { key: "componentWillUnmount", value: function() {
    this.clearPreventFocusTimeout();
  } }, { key: "render", value: function() {
    var t3 = this.renderCalendar();
    return this.props.inline && !this.props.withPortal ? t3 : this.props.withPortal ? React__default.createElement("div", null, this.props.inline ? null : React__default.createElement("div", { className: "react-datepicker__input-container" }, this.renderDateInput(), this.renderClearButton()), this.state.open || this.props.inline ? React__default.createElement("div", { className: "react-datepicker__portal" }, t3) : null) : React__default.createElement(Nt, { className: this.props.popperClassName, wrapperClassName: this.props.wrapperClassName, hidePopper: !this.isCalendarOpen(), popperModifiers: this.props.popperModifiers, targetComponent: React__default.createElement("div", { className: "react-datepicker__input-container" }, this.renderDateInput(), this.renderClearButton()), popperContainer: this.props.popperContainer, popperComponent: t3, popperPlacement: this.props.popperPlacement, popperProps: this.props.popperProps, popperOnKeyDown: this.onPopperKeyDown, enableTabLoop: this.props.enableTabLoop });
  } }]), a4;
}(), Yt = "input", Tt = "navigate";
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
};
var formatDistance2 = function formatDistance3(token2, count, options) {
  var result2;
  var form = formatDistanceLocale[token2];
  if (typeof form === "string") {
    result2 = form;
  } else if (count === 1) {
    result2 = form.one;
  } else {
    result2 = form.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "dans " + result2;
    } else {
      return "il y a " + result2;
    }
  }
  return result2;
};
var dateFormats = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
};
var timeFormats = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var formatRelativeLocale = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
};
var formatRelative2 = function formatRelative3(token2, _date, _baseDate, _options) {
  return formatRelativeLocale[token2];
};
var eraValues = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
};
var quarterValues = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
  wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
};
var dayValues = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
};
var dayPeriodValues = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
};
var ordinalNumber2 = function ordinalNumber3(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  if (number === 0) return "0";
  var feminineUnits = ["year", "week", "hour", "minute", "second"];
  var suffix;
  if (number === 1) {
    suffix = unit && feminineUnits.includes(unit) ? "ère" : "er";
  } else {
    suffix = "ème";
  }
  return number + suffix;
};
var localize = {
  ordinalNumber: ordinalNumber2,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback2(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide"
  })
};
var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var parseEraPatterns = {
  any: [/^av/i, /^ap/i]
};
var matchQuarterPatterns = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback3(value) {
      return parseInt(value);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function valueCallback4(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
var locale$1 = {
  code: "fr",
  formatDistance: formatDistance2,
  formatLong,
  formatRelative: formatRelative2,
  localize,
  match,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const styles$k = (theme2) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    maxWidth: 250,
    "& label": {
      fontFamily: "EuclidCircularB",
      fontWeight: 600,
      fontSize: 16,
      padding: "8px 0",
      "& strong": {
        color: theme2.warningRed,
        paddingRight: 5
      }
    },
    "& .react-datepicker__triangle": {
      display: "none"
    },
    "& .react-datepicker-wrapper": {
      position: "absolute",
      width: 0
    },
    "& .react-datepicker__current-month": {
      fontSize: 13,
      fontWeight: 800,
      fontFamily: "EuclidCircularB",
      letterSpacing: "0.26px",
      color: theme2.grey1,
      lineHeight: "16px",
      marginBottom: 10
    },
    "& .react-datepicker__header": {
      backgroundColor: theme2.grey9,
      borderBottom: `1px solid ${theme2.grey7}`
    },
    "& .react-datepicker__day-names": {
      fontSize: 13,
      fontWeight: 500,
      fontFamily: "EuclidCircularB",
      color: "#000080",
      borderTop: `1px solid ${theme2.grey7}`
    },
    "& .react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name": {
      margin: "0 2.3px"
    },
    "& .react-datepicker__week": {
      fontFamily: "EuclidCircularB",
      fontSize: 14,
      lineHeight: "34px"
    },
    "& .react-datepicker__day": {
      padding: 0,
      margin: 0,
      width: 34,
      height: 32,
      "&:hover": {
        borderRadius: "50%"
      }
    },
    "& .react-datepicker__day--selected": {
      backgroundColor: theme2.blue50,
      color: theme2.blue800,
      borderRadius: "50%",
      fontWeight: 700,
      fontFamily: "EuclidCircularB",
      "&:hover": {
        backgroundColor: theme2.blue50
      }
    },
    "& .react-datepicker__month": {
      margin: 0
    },
    "& .react-datepicker__day--keyboard-selected, & .react-datepicker__month-text--keyboard-selected, & .react-datepicker__quarter-text--keyboard-selected": {
      borderRadius: "50%",
      backgroundColor: theme2.indigo3,
      "&:hover": {
        backgroundColor: theme2.indigo2
      }
    },
    "& .react-datepicker__navigation": {
      border: `solid #999999`,
      borderWidth: "0 2px 2px 0",
      display: "inline-block",
      outline: "none",
      top: 12
    },
    "& .react-datepicker__navigation--previous": {
      left: 60,
      transform: "rotate(135deg)"
      // -webkit-transform: 'rotate(135deg)'
    },
    "& .react-datepicker__navigation--next": {
      right: 60,
      transform: "rotate(-45deg)"
      // -webkit-transform: rotate(-45deg),
    },
    "& .react-datepicker__day--outside-month": {
      opacity: 0
    }
  },
  dateWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start"
  },
  dateInput: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    '& [type="date"]': {
      height: 34,
      border: `1px solid ${theme2.grey5}`,
      borderRadius: 5,
      padding: 5,
      fontSize: 14,
      letterSpacing: 0.28,
      textTransform: "uppercase",
      color: theme2.grey1,
      backgroundColor: "transparent",
      outline: "none",
      width: 135,
      textAlign: "center",
      transition: "border 0.3s cubic-bezier(0.19, 1, 0.22, 1)",
      "&[data-disabled=false]:focus": {
        color: theme2.grey4
      },
      "&[data-error=true]": {
        border: `1px solid ${theme2.warningRed}`
      },
      "&[data-disabled=true]": {
        opacity: 0.3
      },
      "&::-webkit-inner-spin-button, &::-webkit-calendar-picker-indicator": {
        display: "none"
      },
      "::-webkit-input-placeholder": {
        visibility: "hidden !important"
      }
    }
  },
  dateToday: {
    color: theme2.indigo3,
    fontSize: 14,
    width: 100,
    cursor: "pointer",
    paddingLeft: 56
  },
  iconInput: {
    color: theme2.indigo2,
    position: "relative",
    left: 148,
    width: 32,
    height: 32,
    cursor: "pointer"
  },
  calendar: {
    margin: 0,
    marginBlock: "5px",
    position: "relative",
    backgroundColor: theme2.white1,
    border: `1px solid ${theme2.grey5}`
  },
  calendarPuppet: {
    position: "relative !important",
    transform: "none !important",
    transition: "all 0.2s cubic-bezier(0.19, 1, 0.22, 1)",
    height: 275
  }
});
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var hookCallback;
function hooks() {
  return hookCallback.apply(null, arguments);
}
function setHookCallback(callback) {
  hookCallback = callback;
}
function isArray3(input) {
  return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
}
function isObject2(input) {
  return input != null && Object.prototype.toString.call(input) === "[object Object]";
}
function hasOwnProp(a4, b3) {
  return Object.prototype.hasOwnProperty.call(a4, b3);
}
function isObjectEmpty(obj) {
  if (Object.getOwnPropertyNames) {
    return Object.getOwnPropertyNames(obj).length === 0;
  } else {
    var k3;
    for (k3 in obj) {
      if (hasOwnProp(obj, k3)) {
        return false;
      }
    }
    return true;
  }
}
function isUndefined(input) {
  return input === void 0;
}
function isNumber(input) {
  return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
}
function isDate(input) {
  return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
}
function map(arr, fn2) {
  var res = [], i3, arrLen = arr.length;
  for (i3 = 0; i3 < arrLen; ++i3) {
    res.push(fn2(arr[i3], i3));
  }
  return res;
}
function extend2(a4, b3) {
  for (var i3 in b3) {
    if (hasOwnProp(b3, i3)) {
      a4[i3] = b3[i3];
    }
  }
  if (hasOwnProp(b3, "toString")) {
    a4.toString = b3.toString;
  }
  if (hasOwnProp(b3, "valueOf")) {
    a4.valueOf = b3.valueOf;
  }
  return a4;
}
function createUTC(input, format3, locale2, strict) {
  return createLocalOrUTC(input, format3, locale2, strict, true).utc();
}
function defaultParsingFlags() {
  return {
    empty: false,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: false,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: false,
    userInvalidated: false,
    iso: false,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: false,
    weekdayMismatch: false
  };
}
function getParsingFlags(m4) {
  if (m4._pf == null) {
    m4._pf = defaultParsingFlags();
  }
  return m4._pf;
}
var some;
if (Array.prototype.some) {
  some = Array.prototype.some;
} else {
  some = function(fun) {
    var t3 = Object(this), len = t3.length >>> 0, i3;
    for (i3 = 0; i3 < len; i3++) {
      if (i3 in t3 && fun.call(this, t3[i3], i3, t3)) {
        return true;
      }
    }
    return false;
  };
}
function isValid$1(m4) {
  var flags3 = null, parsedParts = false, isNowValid = m4._d && !isNaN(m4._d.getTime());
  if (isNowValid) {
    flags3 = getParsingFlags(m4);
    parsedParts = some.call(flags3.parsedDateParts, function(i3) {
      return i3 != null;
    });
    isNowValid = flags3.overflow < 0 && !flags3.empty && !flags3.invalidEra && !flags3.invalidMonth && !flags3.invalidWeekday && !flags3.weekdayMismatch && !flags3.nullInput && !flags3.invalidFormat && !flags3.userInvalidated && (!flags3.meridiem || flags3.meridiem && parsedParts);
    if (m4._strict) {
      isNowValid = isNowValid && flags3.charsLeftOver === 0 && flags3.unusedTokens.length === 0 && flags3.bigHour === void 0;
    }
  }
  if (Object.isFrozen == null || !Object.isFrozen(m4)) {
    m4._isValid = isNowValid;
  } else {
    return isNowValid;
  }
  return m4._isValid;
}
function createInvalid(flags3) {
  var m4 = createUTC(NaN);
  if (flags3 != null) {
    extend2(getParsingFlags(m4), flags3);
  } else {
    getParsingFlags(m4).userInvalidated = true;
  }
  return m4;
}
var momentProperties = hooks.momentProperties = [], updateInProgress = false;
function copyConfig(to2, from2) {
  var i3, prop, val, momentPropertiesLen = momentProperties.length;
  if (!isUndefined(from2._isAMomentObject)) {
    to2._isAMomentObject = from2._isAMomentObject;
  }
  if (!isUndefined(from2._i)) {
    to2._i = from2._i;
  }
  if (!isUndefined(from2._f)) {
    to2._f = from2._f;
  }
  if (!isUndefined(from2._l)) {
    to2._l = from2._l;
  }
  if (!isUndefined(from2._strict)) {
    to2._strict = from2._strict;
  }
  if (!isUndefined(from2._tzm)) {
    to2._tzm = from2._tzm;
  }
  if (!isUndefined(from2._isUTC)) {
    to2._isUTC = from2._isUTC;
  }
  if (!isUndefined(from2._offset)) {
    to2._offset = from2._offset;
  }
  if (!isUndefined(from2._pf)) {
    to2._pf = getParsingFlags(from2);
  }
  if (!isUndefined(from2._locale)) {
    to2._locale = from2._locale;
  }
  if (momentPropertiesLen > 0) {
    for (i3 = 0; i3 < momentPropertiesLen; i3++) {
      prop = momentProperties[i3];
      val = from2[prop];
      if (!isUndefined(val)) {
        to2[prop] = val;
      }
    }
  }
  return to2;
}
function Moment(config) {
  copyConfig(this, config);
  this._d = new Date(config._d != null ? config._d.getTime() : NaN);
  if (!this.isValid()) {
    this._d = /* @__PURE__ */ new Date(NaN);
  }
  if (updateInProgress === false) {
    updateInProgress = true;
    hooks.updateOffset(this);
    updateInProgress = false;
  }
}
function isMoment(obj) {
  return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
}
function warn(msg2) {
  if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
    console.warn("Deprecation warning: " + msg2);
  }
}
function deprecate(msg2, fn2) {
  var firstTime = true;
  return extend2(function() {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(null, msg2);
    }
    if (firstTime) {
      var args = [], arg, i3, key2, argLen = arguments.length;
      for (i3 = 0; i3 < argLen; i3++) {
        arg = "";
        if (typeof arguments[i3] === "object") {
          arg += "\n[" + i3 + "] ";
          for (key2 in arguments[0]) {
            if (hasOwnProp(arguments[0], key2)) {
              arg += key2 + ": " + arguments[0][key2] + ", ";
            }
          }
          arg = arg.slice(0, -2);
        } else {
          arg = arguments[i3];
        }
        args.push(arg);
      }
      warn(
        msg2 + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack
      );
      firstTime = false;
    }
    return fn2.apply(this, arguments);
  }, fn2);
}
var deprecations = {};
function deprecateSimple(name2, msg2) {
  if (hooks.deprecationHandler != null) {
    hooks.deprecationHandler(name2, msg2);
  }
  if (!deprecations[name2]) {
    warn(msg2);
    deprecations[name2] = true;
  }
}
hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;
function isFunction(input) {
  return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
}
function set(config) {
  var prop, i3;
  for (i3 in config) {
    if (hasOwnProp(config, i3)) {
      prop = config[i3];
      if (isFunction(prop)) {
        this[i3] = prop;
      } else {
        this["_" + i3] = prop;
      }
    }
  }
  this._config = config;
  this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function mergeConfigs(parentConfig, childConfig) {
  var res = extend2({}, parentConfig), prop;
  for (prop in childConfig) {
    if (hasOwnProp(childConfig, prop)) {
      if (isObject2(parentConfig[prop]) && isObject2(childConfig[prop])) {
        res[prop] = {};
        extend2(res[prop], parentConfig[prop]);
        extend2(res[prop], childConfig[prop]);
      } else if (childConfig[prop] != null) {
        res[prop] = childConfig[prop];
      } else {
        delete res[prop];
      }
    }
  }
  for (prop in parentConfig) {
    if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject2(parentConfig[prop])) {
      res[prop] = extend2({}, res[prop]);
    }
  }
  return res;
}
function Locale(config) {
  if (config != null) {
    this.set(config);
  }
}
var keys3;
if (Object.keys) {
  keys3 = Object.keys;
} else {
  keys3 = function(obj) {
    var i3, res = [];
    for (i3 in obj) {
      if (hasOwnProp(obj, i3)) {
        res.push(i3);
      }
    }
    return res;
  };
}
var defaultCalendar = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function calendar(key2, mom, now2) {
  var output = this._calendar[key2] || this._calendar["sameElse"];
  return isFunction(output) ? output.call(mom, now2) : output;
}
function zeroFill(number, targetLength, forceSign) {
  var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign2 = number >= 0;
  return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
function addFormatToken(token2, padded, ordinal2, callback) {
  var func = callback;
  if (typeof callback === "string") {
    func = function() {
      return this[callback]();
    };
  }
  if (token2) {
    formatTokenFunctions[token2] = func;
  }
  if (padded) {
    formatTokenFunctions[padded[0]] = function() {
      return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
    };
  }
  if (ordinal2) {
    formatTokenFunctions[ordinal2] = function() {
      return this.localeData().ordinal(
        func.apply(this, arguments),
        token2
      );
    };
  }
}
function removeFormattingTokens(input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|\]$/g, "");
  }
  return input.replace(/\\/g, "");
}
function makeFormatFunction(format3) {
  var array = format3.match(formattingTokens), i3, length;
  for (i3 = 0, length = array.length; i3 < length; i3++) {
    if (formatTokenFunctions[array[i3]]) {
      array[i3] = formatTokenFunctions[array[i3]];
    } else {
      array[i3] = removeFormattingTokens(array[i3]);
    }
  }
  return function(mom) {
    var output = "", i4;
    for (i4 = 0; i4 < length; i4++) {
      output += isFunction(array[i4]) ? array[i4].call(mom, format3) : array[i4];
    }
    return output;
  };
}
function formatMoment(m4, format3) {
  if (!m4.isValid()) {
    return m4.localeData().invalidDate();
  }
  format3 = expandFormat(format3, m4.localeData());
  formatFunctions[format3] = formatFunctions[format3] || makeFormatFunction(format3);
  return formatFunctions[format3](m4);
}
function expandFormat(format3, locale2) {
  var i3 = 5;
  function replaceLongDateFormatTokens(input) {
    return locale2.longDateFormat(input) || input;
  }
  localFormattingTokens.lastIndex = 0;
  while (i3 >= 0 && localFormattingTokens.test(format3)) {
    format3 = format3.replace(
      localFormattingTokens,
      replaceLongDateFormatTokens
    );
    localFormattingTokens.lastIndex = 0;
    i3 -= 1;
  }
  return format3;
}
var defaultLongDateFormat = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function longDateFormat(key2) {
  var format3 = this._longDateFormat[key2], formatUpper = this._longDateFormat[key2.toUpperCase()];
  if (format3 || !formatUpper) {
    return format3;
  }
  this._longDateFormat[key2] = formatUpper.match(formattingTokens).map(function(tok) {
    if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
      return tok.slice(1);
    }
    return tok;
  }).join("");
  return this._longDateFormat[key2];
}
var defaultInvalidDate = "Invalid date";
function invalidDate() {
  return this._invalidDate;
}
var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal(number) {
  return this._ordinal.replace("%d", number);
}
var defaultRelativeTime = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function relativeTime(number, withoutSuffix, string3, isFuture) {
  var output = this._relativeTime[string3];
  return isFunction(output) ? output(number, withoutSuffix, string3, isFuture) : output.replace(/%d/i, number);
}
function pastFuture(diff2, output) {
  var format3 = this._relativeTime[diff2 > 0 ? "future" : "past"];
  return isFunction(format3) ? format3(output) : format3.replace(/%s/i, output);
}
var aliases = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function normalizeUnits(units) {
  return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : void 0;
}
function normalizeObjectUnits(inputObject) {
  var normalizedInput = {}, normalizedProp, prop;
  for (prop in inputObject) {
    if (hasOwnProp(inputObject, prop)) {
      normalizedProp = normalizeUnits(prop);
      if (normalizedProp) {
        normalizedInput[normalizedProp] = inputObject[prop];
      }
    }
  }
  return normalizedInput;
}
var priorities = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function getPrioritizedUnits(unitsObj) {
  var units = [], u3;
  for (u3 in unitsObj) {
    if (hasOwnProp(unitsObj, u3)) {
      units.push({ unit: u3, priority: priorities[u3] });
    }
  }
  units.sort(function(a4, b3) {
    return a4.priority - b3.priority;
  });
  return units;
}
var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
regexes = {};
function addRegexToken(token2, regex2, strictRegex) {
  regexes[token2] = isFunction(regex2) ? regex2 : function(isStrict, localeData2) {
    return isStrict && strictRegex ? strictRegex : regex2;
  };
}
function getParseRegexForToken(token2, config) {
  if (!hasOwnProp(regexes, token2)) {
    return new RegExp(unescapeFormat(token2));
  }
  return regexes[token2](config._strict, config._locale);
}
function unescapeFormat(s4) {
  return regexEscape(
    s4.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }
    )
  );
}
function regexEscape(s4) {
  return s4.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function absFloor(number) {
  if (number < 0) {
    return Math.ceil(number) || 0;
  } else {
    return Math.floor(number);
  }
}
function toInt(argumentForCoercion) {
  var coercedNumber = +argumentForCoercion, value = 0;
  if (coercedNumber !== 0 && isFinite(coercedNumber)) {
    value = absFloor(coercedNumber);
  }
  return value;
}
var tokens = {};
function addParseToken(token2, callback) {
  var i3, func = callback, tokenLen;
  if (typeof token2 === "string") {
    token2 = [token2];
  }
  if (isNumber(callback)) {
    func = function(input, array) {
      array[callback] = toInt(input);
    };
  }
  tokenLen = token2.length;
  for (i3 = 0; i3 < tokenLen; i3++) {
    tokens[token2[i3]] = func;
  }
}
function addWeekParseToken(token2, callback) {
  addParseToken(token2, function(input, array, config, token3) {
    config._w = config._w || {};
    callback(input, config._w, config, token3);
  });
}
function addTimeToArrayFromToken(token2, input, config) {
  if (input != null && hasOwnProp(tokens, token2)) {
    tokens[token2](input, config._a, config, token2);
  }
}
function isLeapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
addFormatToken("Y", 0, 0, function() {
  var y4 = this.year();
  return y4 <= 9999 ? zeroFill(y4, 4) : "+" + y4;
});
addFormatToken(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
addFormatToken(0, ["YYYY", 4], 0, "year");
addFormatToken(0, ["YYYYY", 5], 0, "year");
addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
addRegexToken("Y", matchSigned);
addRegexToken("YY", match1to2, match2);
addRegexToken("YYYY", match1to4, match4);
addRegexToken("YYYYY", match1to6, match6);
addRegexToken("YYYYYY", match1to6, match6);
addParseToken(["YYYYY", "YYYYYY"], YEAR);
addParseToken("YYYY", function(input, array) {
  array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken("YY", function(input, array) {
  array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken("Y", function(input, array) {
  array[YEAR] = parseInt(input, 10);
});
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
hooks.parseTwoDigitYear = function(input) {
  return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
};
var getSetYear = makeGetSet("FullYear", true);
function getIsLeapYear() {
  return isLeapYear(this.year());
}
function makeGetSet(unit, keepTime) {
  return function(value) {
    if (value != null) {
      set$1(this, unit, value);
      hooks.updateOffset(this, keepTime);
      return this;
    } else {
      return get$1(this, unit);
    }
  };
}
function get$1(mom, unit) {
  if (!mom.isValid()) {
    return NaN;
  }
  var d4 = mom._d, isUTC = mom._isUTC;
  switch (unit) {
    case "Milliseconds":
      return isUTC ? d4.getUTCMilliseconds() : d4.getMilliseconds();
    case "Seconds":
      return isUTC ? d4.getUTCSeconds() : d4.getSeconds();
    case "Minutes":
      return isUTC ? d4.getUTCMinutes() : d4.getMinutes();
    case "Hours":
      return isUTC ? d4.getUTCHours() : d4.getHours();
    case "Date":
      return isUTC ? d4.getUTCDate() : d4.getDate();
    case "Day":
      return isUTC ? d4.getUTCDay() : d4.getDay();
    case "Month":
      return isUTC ? d4.getUTCMonth() : d4.getMonth();
    case "FullYear":
      return isUTC ? d4.getUTCFullYear() : d4.getFullYear();
    default:
      return NaN;
  }
}
function set$1(mom, unit, value) {
  var d4, isUTC, year, month, date;
  if (!mom.isValid() || isNaN(value)) {
    return;
  }
  d4 = mom._d;
  isUTC = mom._isUTC;
  switch (unit) {
    case "Milliseconds":
      return void (isUTC ? d4.setUTCMilliseconds(value) : d4.setMilliseconds(value));
    case "Seconds":
      return void (isUTC ? d4.setUTCSeconds(value) : d4.setSeconds(value));
    case "Minutes":
      return void (isUTC ? d4.setUTCMinutes(value) : d4.setMinutes(value));
    case "Hours":
      return void (isUTC ? d4.setUTCHours(value) : d4.setHours(value));
    case "Date":
      return void (isUTC ? d4.setUTCDate(value) : d4.setDate(value));
    case "FullYear":
      break;
    default:
      return;
  }
  year = value;
  month = mom.month();
  date = mom.date();
  date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
  void (isUTC ? d4.setUTCFullYear(year, month, date) : d4.setFullYear(year, month, date));
}
function stringGet(units) {
  units = normalizeUnits(units);
  if (isFunction(this[units])) {
    return this[units]();
  }
  return this;
}
function stringSet(units, value) {
  if (typeof units === "object") {
    units = normalizeObjectUnits(units);
    var prioritized = getPrioritizedUnits(units), i3, prioritizedLen = prioritized.length;
    for (i3 = 0; i3 < prioritizedLen; i3++) {
      this[prioritized[i3].unit](units[prioritized[i3].unit]);
    }
  } else {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
      return this[units](value);
    }
  }
  return this;
}
function mod(n2, x3) {
  return (n2 % x3 + x3) % x3;
}
var indexOf;
if (Array.prototype.indexOf) {
  indexOf = Array.prototype.indexOf;
} else {
  indexOf = function(o2) {
    var i3;
    for (i3 = 0; i3 < this.length; ++i3) {
      if (this[i3] === o2) {
        return i3;
      }
    }
    return -1;
  };
}
function daysInMonth(year, month) {
  if (isNaN(year) || isNaN(month)) {
    return NaN;
  }
  var modMonth = mod(month, 12);
  year += (month - modMonth) / 12;
  return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
}
addFormatToken("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
addFormatToken("MMM", 0, 0, function(format3) {
  return this.localeData().monthsShort(this, format3);
});
addFormatToken("MMMM", 0, 0, function(format3) {
  return this.localeData().months(this, format3);
});
addRegexToken("M", match1to2, match1to2NoLeadingZero);
addRegexToken("MM", match1to2, match2);
addRegexToken("MMM", function(isStrict, locale2) {
  return locale2.monthsShortRegex(isStrict);
});
addRegexToken("MMMM", function(isStrict, locale2) {
  return locale2.monthsRegex(isStrict);
});
addParseToken(["M", "MM"], function(input, array) {
  array[MONTH] = toInt(input) - 1;
});
addParseToken(["MMM", "MMMM"], function(input, array, config, token2) {
  var month = config._locale.monthsParse(input, token2, config._strict);
  if (month != null) {
    array[MONTH] = month;
  } else {
    getParsingFlags(config).invalidMonth = input;
  }
});
var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
function localeMonths(m4, format3) {
  if (!m4) {
    return isArray3(this._months) ? this._months : this._months["standalone"];
  }
  return isArray3(this._months) ? this._months[m4.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format3) ? "format" : "standalone"][m4.month()];
}
function localeMonthsShort(m4, format3) {
  if (!m4) {
    return isArray3(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
  }
  return isArray3(this._monthsShort) ? this._monthsShort[m4.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format3) ? "format" : "standalone"][m4.month()];
}
function handleStrictParse(monthName, format3, strict) {
  var i3, ii, mom, llc = monthName.toLocaleLowerCase();
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
    for (i3 = 0; i3 < 12; ++i3) {
      mom = createUTC([2e3, i3]);
      this._shortMonthsParse[i3] = this.monthsShort(
        mom,
        ""
      ).toLocaleLowerCase();
      this._longMonthsParse[i3] = this.months(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format3 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format3 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeMonthsParse(monthName, format3, strict) {
  var i3, mom, regex2;
  if (this._monthsParseExact) {
    return handleStrictParse.call(this, monthName, format3, strict);
  }
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
  }
  for (i3 = 0; i3 < 12; i3++) {
    mom = createUTC([2e3, i3]);
    if (strict && !this._longMonthsParse[i3]) {
      this._longMonthsParse[i3] = new RegExp(
        "^" + this.months(mom, "").replace(".", "") + "$",
        "i"
      );
      this._shortMonthsParse[i3] = new RegExp(
        "^" + this.monthsShort(mom, "").replace(".", "") + "$",
        "i"
      );
    }
    if (!strict && !this._monthsParse[i3]) {
      regex2 = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
      this._monthsParse[i3] = new RegExp(regex2.replace(".", ""), "i");
    }
    if (strict && format3 === "MMMM" && this._longMonthsParse[i3].test(monthName)) {
      return i3;
    } else if (strict && format3 === "MMM" && this._shortMonthsParse[i3].test(monthName)) {
      return i3;
    } else if (!strict && this._monthsParse[i3].test(monthName)) {
      return i3;
    }
  }
}
function setMonth(mom, value) {
  if (!mom.isValid()) {
    return mom;
  }
  if (typeof value === "string") {
    if (/^\d+$/.test(value)) {
      value = toInt(value);
    } else {
      value = mom.localeData().monthsParse(value);
      if (!isNumber(value)) {
        return mom;
      }
    }
  }
  var month = value, date = mom.date();
  date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
  void (mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date));
  return mom;
}
function getSetMonth(value) {
  if (value != null) {
    setMonth(this, value);
    hooks.updateOffset(this, true);
    return this;
  } else {
    return get$1(this, "Month");
  }
}
function getDaysInMonth() {
  return daysInMonth(this.year(), this.month());
}
function monthsShortRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsShortStrictRegex;
    } else {
      return this._monthsShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsShortRegex")) {
      this._monthsShortRegex = defaultMonthsShortRegex;
    }
    return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
  }
}
function monthsRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsStrictRegex;
    } else {
      return this._monthsRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsRegex")) {
      this._monthsRegex = defaultMonthsRegex;
    }
    return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
  }
}
function computeMonthsParse() {
  function cmpLenRev(a4, b3) {
    return b3.length - a4.length;
  }
  var shortPieces = [], longPieces = [], mixedPieces = [], i3, mom, shortP, longP;
  for (i3 = 0; i3 < 12; i3++) {
    mom = createUTC([2e3, i3]);
    shortP = regexEscape(this.monthsShort(mom, ""));
    longP = regexEscape(this.months(mom, ""));
    shortPieces.push(shortP);
    longPieces.push(longP);
    mixedPieces.push(longP);
    mixedPieces.push(shortP);
  }
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._monthsShortRegex = this._monthsRegex;
  this._monthsStrictRegex = new RegExp(
    "^(" + longPieces.join("|") + ")",
    "i"
  );
  this._monthsShortStrictRegex = new RegExp(
    "^(" + shortPieces.join("|") + ")",
    "i"
  );
}
function createDate(y4, m4, d4, h4, M4, s4, ms) {
  var date;
  if (y4 < 100 && y4 >= 0) {
    date = new Date(y4 + 400, m4, d4, h4, M4, s4, ms);
    if (isFinite(date.getFullYear())) {
      date.setFullYear(y4);
    }
  } else {
    date = new Date(y4, m4, d4, h4, M4, s4, ms);
  }
  return date;
}
function createUTCDate(y4) {
  var date, args;
  if (y4 < 100 && y4 >= 0) {
    args = Array.prototype.slice.call(arguments);
    args[0] = y4 + 400;
    date = new Date(Date.UTC.apply(null, args));
    if (isFinite(date.getUTCFullYear())) {
      date.setUTCFullYear(y4);
    }
  } else {
    date = new Date(Date.UTC.apply(null, arguments));
  }
  return date;
}
function firstWeekOffset(year, dow, doy) {
  var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
  return -fwdlw + fwd - 1;
}
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
  var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
  if (dayOfYear <= 0) {
    resYear = year - 1;
    resDayOfYear = daysInYear(resYear) + dayOfYear;
  } else if (dayOfYear > daysInYear(year)) {
    resYear = year + 1;
    resDayOfYear = dayOfYear - daysInYear(year);
  } else {
    resYear = year;
    resDayOfYear = dayOfYear;
  }
  return {
    year: resYear,
    dayOfYear: resDayOfYear
  };
}
function weekOfYear(mom, dow, doy) {
  var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
  if (week < 1) {
    resYear = mom.year() - 1;
    resWeek = week + weeksInYear(resYear, dow, doy);
  } else if (week > weeksInYear(mom.year(), dow, doy)) {
    resWeek = week - weeksInYear(mom.year(), dow, doy);
    resYear = mom.year() + 1;
  } else {
    resYear = mom.year();
    resWeek = week;
  }
  return {
    week: resWeek,
    year: resYear
  };
}
function weeksInYear(year, dow, doy) {
  var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
  return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}
addFormatToken("w", ["ww", 2], "wo", "week");
addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
addRegexToken("w", match1to2, match1to2NoLeadingZero);
addRegexToken("ww", match1to2, match2);
addRegexToken("W", match1to2, match1to2NoLeadingZero);
addRegexToken("WW", match1to2, match2);
addWeekParseToken(
  ["w", "ww", "W", "WW"],
  function(input, week, config, token2) {
    week[token2.substr(0, 1)] = toInt(input);
  }
);
function localeWeek(mom) {
  return weekOfYear(mom, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function localeFirstDayOfWeek() {
  return this._week.dow;
}
function localeFirstDayOfYear() {
  return this._week.doy;
}
function getSetWeek(input) {
  var week = this.localeData().week(this);
  return input == null ? week : this.add((input - week) * 7, "d");
}
function getSetISOWeek(input) {
  var week = weekOfYear(this, 1, 4).week;
  return input == null ? week : this.add((input - week) * 7, "d");
}
addFormatToken("d", 0, "do", "day");
addFormatToken("dd", 0, 0, function(format3) {
  return this.localeData().weekdaysMin(this, format3);
});
addFormatToken("ddd", 0, 0, function(format3) {
  return this.localeData().weekdaysShort(this, format3);
});
addFormatToken("dddd", 0, 0, function(format3) {
  return this.localeData().weekdays(this, format3);
});
addFormatToken("e", 0, 0, "weekday");
addFormatToken("E", 0, 0, "isoWeekday");
addRegexToken("d", match1to2);
addRegexToken("e", match1to2);
addRegexToken("E", match1to2);
addRegexToken("dd", function(isStrict, locale2) {
  return locale2.weekdaysMinRegex(isStrict);
});
addRegexToken("ddd", function(isStrict, locale2) {
  return locale2.weekdaysShortRegex(isStrict);
});
addRegexToken("dddd", function(isStrict, locale2) {
  return locale2.weekdaysRegex(isStrict);
});
addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config, token2) {
  var weekday = config._locale.weekdaysParse(input, token2, config._strict);
  if (weekday != null) {
    week.d = weekday;
  } else {
    getParsingFlags(config).invalidWeekday = input;
  }
});
addWeekParseToken(["d", "e", "E"], function(input, week, config, token2) {
  week[token2] = toInt(input);
});
function parseWeekday(input, locale2) {
  if (typeof input !== "string") {
    return input;
  }
  if (!isNaN(input)) {
    return parseInt(input, 10);
  }
  input = locale2.weekdaysParse(input);
  if (typeof input === "number") {
    return input;
  }
  return null;
}
function parseIsoWeekday(input, locale2) {
  if (typeof input === "string") {
    return locale2.weekdaysParse(input) % 7 || 7;
  }
  return isNaN(input) ? null : input;
}
function shiftWeekdays(ws, n2) {
  return ws.slice(n2, 7).concat(ws.slice(0, n2));
}
var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
function localeWeekdays(m4, format3) {
  var weekdays = isArray3(this._weekdays) ? this._weekdays : this._weekdays[m4 && m4 !== true && this._weekdays.isFormat.test(format3) ? "format" : "standalone"];
  return m4 === true ? shiftWeekdays(weekdays, this._week.dow) : m4 ? weekdays[m4.day()] : weekdays;
}
function localeWeekdaysShort(m4) {
  return m4 === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m4 ? this._weekdaysShort[m4.day()] : this._weekdaysShort;
}
function localeWeekdaysMin(m4) {
  return m4 === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m4 ? this._weekdaysMin[m4.day()] : this._weekdaysMin;
}
function handleStrictParse$1(weekdayName, format3, strict) {
  var i3, ii, mom, llc = weekdayName.toLocaleLowerCase();
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._minWeekdaysParse = [];
    for (i3 = 0; i3 < 7; ++i3) {
      mom = createUTC([2e3, 1]).day(i3);
      this._minWeekdaysParse[i3] = this.weekdaysMin(
        mom,
        ""
      ).toLocaleLowerCase();
      this._shortWeekdaysParse[i3] = this.weekdaysShort(
        mom,
        ""
      ).toLocaleLowerCase();
      this._weekdaysParse[i3] = this.weekdays(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format3 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format3 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format3 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format3 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeWeekdaysParse(weekdayName, format3, strict) {
  var i3, mom, regex2;
  if (this._weekdaysParseExact) {
    return handleStrictParse$1.call(this, weekdayName, format3, strict);
  }
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._minWeekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._fullWeekdaysParse = [];
  }
  for (i3 = 0; i3 < 7; i3++) {
    mom = createUTC([2e3, 1]).day(i3);
    if (strict && !this._fullWeekdaysParse[i3]) {
      this._fullWeekdaysParse[i3] = new RegExp(
        "^" + this.weekdays(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
      this._shortWeekdaysParse[i3] = new RegExp(
        "^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
      this._minWeekdaysParse[i3] = new RegExp(
        "^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
    }
    if (!this._weekdaysParse[i3]) {
      regex2 = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
      this._weekdaysParse[i3] = new RegExp(regex2.replace(".", ""), "i");
    }
    if (strict && format3 === "dddd" && this._fullWeekdaysParse[i3].test(weekdayName)) {
      return i3;
    } else if (strict && format3 === "ddd" && this._shortWeekdaysParse[i3].test(weekdayName)) {
      return i3;
    } else if (strict && format3 === "dd" && this._minWeekdaysParse[i3].test(weekdayName)) {
      return i3;
    } else if (!strict && this._weekdaysParse[i3].test(weekdayName)) {
      return i3;
    }
  }
}
function getSetDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var day = get$1(this, "Day");
  if (input != null) {
    input = parseWeekday(input, this.localeData());
    return this.add(input - day, "d");
  } else {
    return day;
  }
}
function getSetLocaleDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return input == null ? weekday : this.add(input - weekday, "d");
}
function getSetISODayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    var weekday = parseIsoWeekday(input, this.localeData());
    return this.day(this.day() % 7 ? weekday : weekday - 7);
  } else {
    return this.day() || 7;
  }
}
function weekdaysRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysStrictRegex;
    } else {
      return this._weekdaysRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      this._weekdaysRegex = defaultWeekdaysRegex;
    }
    return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
  }
}
function weekdaysShortRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysShortStrictRegex;
    } else {
      return this._weekdaysShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysShortRegex")) {
      this._weekdaysShortRegex = defaultWeekdaysShortRegex;
    }
    return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
  }
}
function weekdaysMinRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysMinStrictRegex;
    } else {
      return this._weekdaysMinRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysMinRegex")) {
      this._weekdaysMinRegex = defaultWeekdaysMinRegex;
    }
    return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
  }
}
function computeWeekdaysParse() {
  function cmpLenRev(a4, b3) {
    return b3.length - a4.length;
  }
  var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i3, mom, minp, shortp, longp;
  for (i3 = 0; i3 < 7; i3++) {
    mom = createUTC([2e3, 1]).day(i3);
    minp = regexEscape(this.weekdaysMin(mom, ""));
    shortp = regexEscape(this.weekdaysShort(mom, ""));
    longp = regexEscape(this.weekdays(mom, ""));
    minPieces.push(minp);
    shortPieces.push(shortp);
    longPieces.push(longp);
    mixedPieces.push(minp);
    mixedPieces.push(shortp);
    mixedPieces.push(longp);
  }
  minPieces.sort(cmpLenRev);
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._weekdaysShortRegex = this._weekdaysRegex;
  this._weekdaysMinRegex = this._weekdaysRegex;
  this._weekdaysStrictRegex = new RegExp(
    "^(" + longPieces.join("|") + ")",
    "i"
  );
  this._weekdaysShortStrictRegex = new RegExp(
    "^(" + shortPieces.join("|") + ")",
    "i"
  );
  this._weekdaysMinStrictRegex = new RegExp(
    "^(" + minPieces.join("|") + ")",
    "i"
  );
}
function hFormat() {
  return this.hours() % 12 || 12;
}
function kFormat() {
  return this.hours() || 24;
}
addFormatToken("H", ["HH", 2], 0, "hour");
addFormatToken("h", ["hh", 2], 0, hFormat);
addFormatToken("k", ["kk", 2], 0, kFormat);
addFormatToken("hmm", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken("hmmss", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
addFormatToken("Hmm", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken("Hmmss", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
function meridiem(token2, lowercase) {
  addFormatToken(token2, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      lowercase
    );
  });
}
meridiem("a", true);
meridiem("A", false);
function matchMeridiem(isStrict, locale2) {
  return locale2._meridiemParse;
}
addRegexToken("a", matchMeridiem);
addRegexToken("A", matchMeridiem);
addRegexToken("H", match1to2, match1to2HasZero);
addRegexToken("h", match1to2, match1to2NoLeadingZero);
addRegexToken("k", match1to2, match1to2NoLeadingZero);
addRegexToken("HH", match1to2, match2);
addRegexToken("hh", match1to2, match2);
addRegexToken("kk", match1to2, match2);
addRegexToken("hmm", match3to4);
addRegexToken("hmmss", match5to6);
addRegexToken("Hmm", match3to4);
addRegexToken("Hmmss", match5to6);
addParseToken(["H", "HH"], HOUR);
addParseToken(["k", "kk"], function(input, array, config) {
  var kInput = toInt(input);
  array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(["a", "A"], function(input, array, config) {
  config._isPm = config._locale.isPM(input);
  config._meridiem = input;
});
addParseToken(["h", "hh"], function(input, array, config) {
  array[HOUR] = toInt(input);
  getParsingFlags(config).bigHour = true;
});
addParseToken("hmm", function(input, array, config) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
  getParsingFlags(config).bigHour = true;
});
addParseToken("hmmss", function(input, array, config) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
  getParsingFlags(config).bigHour = true;
});
addParseToken("Hmm", function(input, array, config) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
});
addParseToken("Hmmss", function(input, array, config) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
});
function localeIsPM(input) {
  return (input + "").toLowerCase().charAt(0) === "p";
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
function localeMeridiem(hours2, minutes2, isLower) {
  if (hours2 > 11) {
    return isLower ? "pm" : "PM";
  } else {
    return isLower ? "am" : "AM";
  }
}
var baseConfig = {
  calendar: defaultCalendar,
  longDateFormat: defaultLongDateFormat,
  invalidDate: defaultInvalidDate,
  ordinal: defaultOrdinal,
  dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
  relativeTime: defaultRelativeTime,
  months: defaultLocaleMonths,
  monthsShort: defaultLocaleMonthsShort,
  week: defaultLocaleWeek,
  weekdays: defaultLocaleWeekdays,
  weekdaysMin: defaultLocaleWeekdaysMin,
  weekdaysShort: defaultLocaleWeekdaysShort,
  meridiemParse: defaultLocaleMeridiemParse
};
var locales = {}, localeFamilies = {}, globalLocale;
function commonPrefix(arr1, arr2) {
  var i3, minl = Math.min(arr1.length, arr2.length);
  for (i3 = 0; i3 < minl; i3 += 1) {
    if (arr1[i3] !== arr2[i3]) {
      return i3;
    }
  }
  return minl;
}
function normalizeLocale(key2) {
  return key2 ? key2.toLowerCase().replace("_", "-") : key2;
}
function chooseLocale(names2) {
  var i3 = 0, j2, next3, locale2, split;
  while (i3 < names2.length) {
    split = normalizeLocale(names2[i3]).split("-");
    j2 = split.length;
    next3 = normalizeLocale(names2[i3 + 1]);
    next3 = next3 ? next3.split("-") : null;
    while (j2 > 0) {
      locale2 = loadLocale(split.slice(0, j2).join("-"));
      if (locale2) {
        return locale2;
      }
      if (next3 && next3.length >= j2 && commonPrefix(split, next3) >= j2 - 1) {
        break;
      }
      j2--;
    }
    i3++;
  }
  return globalLocale;
}
function isLocaleNameSane(name2) {
  return !!(name2 && name2.match("^[^/\\\\]*$"));
}
function loadLocale(name2) {
  var oldLocale = null, aliasedRequire;
  if (locales[name2] === void 0 && typeof module !== "undefined" && module && module.exports && isLocaleNameSane(name2)) {
    try {
      oldLocale = globalLocale._abbr;
      aliasedRequire = require;
      aliasedRequire("./locale/" + name2);
      getSetGlobalLocale(oldLocale);
    } catch (e5) {
      locales[name2] = null;
    }
  }
  return locales[name2];
}
function getSetGlobalLocale(key2, values) {
  var data;
  if (key2) {
    if (isUndefined(values)) {
      data = getLocale(key2);
    } else {
      data = defineLocale(key2, values);
    }
    if (data) {
      globalLocale = data;
    } else {
      if (typeof console !== "undefined" && console.warn) {
        console.warn(
          "Locale " + key2 + " not found. Did you forget to load it?"
        );
      }
    }
  }
  return globalLocale._abbr;
}
function defineLocale(name2, config) {
  if (config !== null) {
    var locale2, parentConfig = baseConfig;
    config.abbr = name2;
    if (locales[name2] != null) {
      deprecateSimple(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      );
      parentConfig = locales[name2]._config;
    } else if (config.parentLocale != null) {
      if (locales[config.parentLocale] != null) {
        parentConfig = locales[config.parentLocale]._config;
      } else {
        locale2 = loadLocale(config.parentLocale);
        if (locale2 != null) {
          parentConfig = locale2._config;
        } else {
          if (!localeFamilies[config.parentLocale]) {
            localeFamilies[config.parentLocale] = [];
          }
          localeFamilies[config.parentLocale].push({
            name: name2,
            config
          });
          return null;
        }
      }
    }
    locales[name2] = new Locale(mergeConfigs(parentConfig, config));
    if (localeFamilies[name2]) {
      localeFamilies[name2].forEach(function(x3) {
        defineLocale(x3.name, x3.config);
      });
    }
    getSetGlobalLocale(name2);
    return locales[name2];
  } else {
    delete locales[name2];
    return null;
  }
}
function updateLocale(name2, config) {
  if (config != null) {
    var locale2, tmpLocale, parentConfig = baseConfig;
    if (locales[name2] != null && locales[name2].parentLocale != null) {
      locales[name2].set(mergeConfigs(locales[name2]._config, config));
    } else {
      tmpLocale = loadLocale(name2);
      if (tmpLocale != null) {
        parentConfig = tmpLocale._config;
      }
      config = mergeConfigs(parentConfig, config);
      if (tmpLocale == null) {
        config.abbr = name2;
      }
      locale2 = new Locale(config);
      locale2.parentLocale = locales[name2];
      locales[name2] = locale2;
    }
    getSetGlobalLocale(name2);
  } else {
    if (locales[name2] != null) {
      if (locales[name2].parentLocale != null) {
        locales[name2] = locales[name2].parentLocale;
        if (name2 === getSetGlobalLocale()) {
          getSetGlobalLocale(name2);
        }
      } else if (locales[name2] != null) {
        delete locales[name2];
      }
    }
  }
  return locales[name2];
}
function getLocale(key2) {
  var locale2;
  if (key2 && key2._locale && key2._locale._abbr) {
    key2 = key2._locale._abbr;
  }
  if (!key2) {
    return globalLocale;
  }
  if (!isArray3(key2)) {
    locale2 = loadLocale(key2);
    if (locale2) {
      return locale2;
    }
    key2 = [key2];
  }
  return chooseLocale(key2);
}
function listLocales() {
  return keys3(locales);
}
function checkOverflow(m4) {
  var overflow, a4 = m4._a;
  if (a4 && getParsingFlags(m4).overflow === -2) {
    overflow = a4[MONTH] < 0 || a4[MONTH] > 11 ? MONTH : a4[DATE] < 1 || a4[DATE] > daysInMonth(a4[YEAR], a4[MONTH]) ? DATE : a4[HOUR] < 0 || a4[HOUR] > 24 || a4[HOUR] === 24 && (a4[MINUTE] !== 0 || a4[SECOND] !== 0 || a4[MILLISECOND] !== 0) ? HOUR : a4[MINUTE] < 0 || a4[MINUTE] > 59 ? MINUTE : a4[SECOND] < 0 || a4[SECOND] > 59 ? SECOND : a4[MILLISECOND] < 0 || a4[MILLISECOND] > 999 ? MILLISECOND : -1;
    if (getParsingFlags(m4)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
      overflow = DATE;
    }
    if (getParsingFlags(m4)._overflowWeeks && overflow === -1) {
      overflow = WEEK;
    }
    if (getParsingFlags(m4)._overflowWeekday && overflow === -1) {
      overflow = WEEKDAY;
    }
    getParsingFlags(m4).overflow = overflow;
  }
  return m4;
}
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, false],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, false],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, false],
  ["YYYY", /\d{4}/, false]
], isoTimes = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function configFromISO(config) {
  var i3, l2, string3 = config._i, match5 = extendedIsoRegex.exec(string3) || basicIsoRegex.exec(string3), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
  if (match5) {
    getParsingFlags(config).iso = true;
    for (i3 = 0, l2 = isoDatesLen; i3 < l2; i3++) {
      if (isoDates[i3][1].exec(match5[1])) {
        dateFormat = isoDates[i3][0];
        allowTime = isoDates[i3][2] !== false;
        break;
      }
    }
    if (dateFormat == null) {
      config._isValid = false;
      return;
    }
    if (match5[3]) {
      for (i3 = 0, l2 = isoTimesLen; i3 < l2; i3++) {
        if (isoTimes[i3][1].exec(match5[3])) {
          timeFormat = (match5[2] || " ") + isoTimes[i3][0];
          break;
        }
      }
      if (timeFormat == null) {
        config._isValid = false;
        return;
      }
    }
    if (!allowTime && timeFormat != null) {
      config._isValid = false;
      return;
    }
    if (match5[4]) {
      if (tzRegex.exec(match5[4])) {
        tzFormat = "Z";
      } else {
        config._isValid = false;
        return;
      }
    }
    config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
    configFromStringAndFormat(config);
  } else {
    config._isValid = false;
  }
}
function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result2 = [
    untruncateYear(yearStr),
    defaultLocaleMonthsShort.indexOf(monthStr),
    parseInt(dayStr, 10),
    parseInt(hourStr, 10),
    parseInt(minuteStr, 10)
  ];
  if (secondStr) {
    result2.push(parseInt(secondStr, 10));
  }
  return result2;
}
function untruncateYear(yearStr) {
  var year = parseInt(yearStr, 10);
  if (year <= 49) {
    return 2e3 + year;
  } else if (year <= 999) {
    return 1900 + year;
  }
  return year;
}
function preprocessRFC2822(s4) {
  return s4.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function checkWeekday(weekdayStr, parsedInput, config) {
  if (weekdayStr) {
    var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(
      parsedInput[0],
      parsedInput[1],
      parsedInput[2]
    ).getDay();
    if (weekdayProvided !== weekdayActual) {
      getParsingFlags(config).weekdayMismatch = true;
      config._isValid = false;
      return false;
    }
  }
  return true;
}
function calculateOffset(obsOffset, militaryOffset, numOffset) {
  if (obsOffset) {
    return obsOffsets[obsOffset];
  } else if (militaryOffset) {
    return 0;
  } else {
    var hm = parseInt(numOffset, 10), m4 = hm % 100, h4 = (hm - m4) / 100;
    return h4 * 60 + m4;
  }
}
function configFromRFC2822(config) {
  var match5 = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
  if (match5) {
    parsedArray = extractFromRFC2822Strings(
      match5[4],
      match5[3],
      match5[2],
      match5[5],
      match5[6],
      match5[7]
    );
    if (!checkWeekday(match5[1], parsedArray, config)) {
      return;
    }
    config._a = parsedArray;
    config._tzm = calculateOffset(match5[8], match5[9], match5[10]);
    config._d = createUTCDate.apply(null, config._a);
    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    getParsingFlags(config).rfc2822 = true;
  } else {
    config._isValid = false;
  }
}
function configFromString(config) {
  var matched = aspNetJsonRegex.exec(config._i);
  if (matched !== null) {
    config._d = /* @__PURE__ */ new Date(+matched[1]);
    return;
  }
  configFromISO(config);
  if (config._isValid === false) {
    delete config._isValid;
  } else {
    return;
  }
  configFromRFC2822(config);
  if (config._isValid === false) {
    delete config._isValid;
  } else {
    return;
  }
  if (config._strict) {
    config._isValid = false;
  } else {
    hooks.createFromInputFallback(config);
  }
}
hooks.createFromInputFallback = deprecate(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(config) {
    config._d = /* @__PURE__ */ new Date(config._i + (config._useUTC ? " UTC" : ""));
  }
);
function defaults(a4, b3, c3) {
  if (a4 != null) {
    return a4;
  }
  if (b3 != null) {
    return b3;
  }
  return c3;
}
function currentDateArray(config) {
  var nowValue = new Date(hooks.now());
  if (config._useUTC) {
    return [
      nowValue.getUTCFullYear(),
      nowValue.getUTCMonth(),
      nowValue.getUTCDate()
    ];
  }
  return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}
function configFromArray(config) {
  var i3, date, input = [], currentDate, expectedWeekday, yearToUse;
  if (config._d) {
    return;
  }
  currentDate = currentDateArray(config);
  if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
    dayOfYearFromWeekInfo(config);
  }
  if (config._dayOfYear != null) {
    yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
    if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
      getParsingFlags(config)._overflowDayOfYear = true;
    }
    date = createUTCDate(yearToUse, 0, config._dayOfYear);
    config._a[MONTH] = date.getUTCMonth();
    config._a[DATE] = date.getUTCDate();
  }
  for (i3 = 0; i3 < 3 && config._a[i3] == null; ++i3) {
    config._a[i3] = input[i3] = currentDate[i3];
  }
  for (; i3 < 7; i3++) {
    config._a[i3] = input[i3] = config._a[i3] == null ? i3 === 2 ? 1 : 0 : config._a[i3];
  }
  if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
    config._nextDay = true;
    config._a[HOUR] = 0;
  }
  config._d = (config._useUTC ? createUTCDate : createDate).apply(
    null,
    input
  );
  expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
  if (config._tzm != null) {
    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
  }
  if (config._nextDay) {
    config._a[HOUR] = 24;
  }
  if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) {
    getParsingFlags(config).weekdayMismatch = true;
  }
}
function dayOfYearFromWeekInfo(config) {
  var w3, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
  w3 = config._w;
  if (w3.GG != null || w3.W != null || w3.E != null) {
    dow = 1;
    doy = 4;
    weekYear = defaults(
      w3.GG,
      config._a[YEAR],
      weekOfYear(createLocal(), 1, 4).year
    );
    week = defaults(w3.W, 1);
    weekday = defaults(w3.E, 1);
    if (weekday < 1 || weekday > 7) {
      weekdayOverflow = true;
    }
  } else {
    dow = config._locale._week.dow;
    doy = config._locale._week.doy;
    curWeek = weekOfYear(createLocal(), dow, doy);
    weekYear = defaults(w3.gg, config._a[YEAR], curWeek.year);
    week = defaults(w3.w, curWeek.week);
    if (w3.d != null) {
      weekday = w3.d;
      if (weekday < 0 || weekday > 6) {
        weekdayOverflow = true;
      }
    } else if (w3.e != null) {
      weekday = w3.e + dow;
      if (w3.e < 0 || w3.e > 6) {
        weekdayOverflow = true;
      }
    } else {
      weekday = dow;
    }
  }
  if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
    getParsingFlags(config)._overflowWeeks = true;
  } else if (weekdayOverflow != null) {
    getParsingFlags(config)._overflowWeekday = true;
  } else {
    temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
    config._a[YEAR] = temp.year;
    config._dayOfYear = temp.dayOfYear;
  }
}
hooks.ISO_8601 = function() {
};
hooks.RFC_2822 = function() {
};
function configFromStringAndFormat(config) {
  if (config._f === hooks.ISO_8601) {
    configFromISO(config);
    return;
  }
  if (config._f === hooks.RFC_2822) {
    configFromRFC2822(config);
    return;
  }
  config._a = [];
  getParsingFlags(config).empty = true;
  var string3 = "" + config._i, i3, parsedInput, tokens2, token2, skipped, stringLength = string3.length, totalParsedInputLength = 0, era, tokenLen;
  tokens2 = expandFormat(config._f, config._locale).match(formattingTokens) || [];
  tokenLen = tokens2.length;
  for (i3 = 0; i3 < tokenLen; i3++) {
    token2 = tokens2[i3];
    parsedInput = (string3.match(getParseRegexForToken(token2, config)) || [])[0];
    if (parsedInput) {
      skipped = string3.substr(0, string3.indexOf(parsedInput));
      if (skipped.length > 0) {
        getParsingFlags(config).unusedInput.push(skipped);
      }
      string3 = string3.slice(
        string3.indexOf(parsedInput) + parsedInput.length
      );
      totalParsedInputLength += parsedInput.length;
    }
    if (formatTokenFunctions[token2]) {
      if (parsedInput) {
        getParsingFlags(config).empty = false;
      } else {
        getParsingFlags(config).unusedTokens.push(token2);
      }
      addTimeToArrayFromToken(token2, parsedInput, config);
    } else if (config._strict && !parsedInput) {
      getParsingFlags(config).unusedTokens.push(token2);
    }
  }
  getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
  if (string3.length > 0) {
    getParsingFlags(config).unusedInput.push(string3);
  }
  if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
    getParsingFlags(config).bigHour = void 0;
  }
  getParsingFlags(config).parsedDateParts = config._a.slice(0);
  getParsingFlags(config).meridiem = config._meridiem;
  config._a[HOUR] = meridiemFixWrap(
    config._locale,
    config._a[HOUR],
    config._meridiem
  );
  era = getParsingFlags(config).era;
  if (era !== null) {
    config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
  }
  configFromArray(config);
  checkOverflow(config);
}
function meridiemFixWrap(locale2, hour, meridiem2) {
  var isPm;
  if (meridiem2 == null) {
    return hour;
  }
  if (locale2.meridiemHour != null) {
    return locale2.meridiemHour(hour, meridiem2);
  } else if (locale2.isPM != null) {
    isPm = locale2.isPM(meridiem2);
    if (isPm && hour < 12) {
      hour += 12;
    }
    if (!isPm && hour === 12) {
      hour = 0;
    }
    return hour;
  } else {
    return hour;
  }
}
function configFromStringAndArray(config) {
  var tempConfig, bestMoment, scoreToBeat, i3, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
  if (configfLen === 0) {
    getParsingFlags(config).invalidFormat = true;
    config._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (i3 = 0; i3 < configfLen; i3++) {
    currentScore = 0;
    validFormatFound = false;
    tempConfig = copyConfig({}, config);
    if (config._useUTC != null) {
      tempConfig._useUTC = config._useUTC;
    }
    tempConfig._f = config._f[i3];
    configFromStringAndFormat(tempConfig);
    if (isValid$1(tempConfig)) {
      validFormatFound = true;
    }
    currentScore += getParsingFlags(tempConfig).charsLeftOver;
    currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
    getParsingFlags(tempConfig).score = currentScore;
    if (!bestFormatIsValid) {
      if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
        if (validFormatFound) {
          bestFormatIsValid = true;
        }
      }
    } else {
      if (currentScore < scoreToBeat) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
      }
    }
  }
  extend2(config, bestMoment || tempConfig);
}
function configFromObject(config) {
  if (config._d) {
    return;
  }
  var i3 = normalizeObjectUnits(config._i), dayOrDate = i3.day === void 0 ? i3.date : i3.day;
  config._a = map(
    [i3.year, i3.month, dayOrDate, i3.hour, i3.minute, i3.second, i3.millisecond],
    function(obj) {
      return obj && parseInt(obj, 10);
    }
  );
  configFromArray(config);
}
function createFromConfig(config) {
  var res = new Moment(checkOverflow(prepareConfig(config)));
  if (res._nextDay) {
    res.add(1, "d");
    res._nextDay = void 0;
  }
  return res;
}
function prepareConfig(config) {
  var input = config._i, format3 = config._f;
  config._locale = config._locale || getLocale(config._l);
  if (input === null || format3 === void 0 && input === "") {
    return createInvalid({ nullInput: true });
  }
  if (typeof input === "string") {
    config._i = input = config._locale.preparse(input);
  }
  if (isMoment(input)) {
    return new Moment(checkOverflow(input));
  } else if (isDate(input)) {
    config._d = input;
  } else if (isArray3(format3)) {
    configFromStringAndArray(config);
  } else if (format3) {
    configFromStringAndFormat(config);
  } else {
    configFromInput(config);
  }
  if (!isValid$1(config)) {
    config._d = null;
  }
  return config;
}
function configFromInput(config) {
  var input = config._i;
  if (isUndefined(input)) {
    config._d = new Date(hooks.now());
  } else if (isDate(input)) {
    config._d = new Date(input.valueOf());
  } else if (typeof input === "string") {
    configFromString(config);
  } else if (isArray3(input)) {
    config._a = map(input.slice(0), function(obj) {
      return parseInt(obj, 10);
    });
    configFromArray(config);
  } else if (isObject2(input)) {
    configFromObject(config);
  } else if (isNumber(input)) {
    config._d = new Date(input);
  } else {
    hooks.createFromInputFallback(config);
  }
}
function createLocalOrUTC(input, format3, locale2, strict, isUTC) {
  var c3 = {};
  if (format3 === true || format3 === false) {
    strict = format3;
    format3 = void 0;
  }
  if (locale2 === true || locale2 === false) {
    strict = locale2;
    locale2 = void 0;
  }
  if (isObject2(input) && isObjectEmpty(input) || isArray3(input) && input.length === 0) {
    input = void 0;
  }
  c3._isAMomentObject = true;
  c3._useUTC = c3._isUTC = isUTC;
  c3._l = locale2;
  c3._i = input;
  c3._f = format3;
  c3._strict = strict;
  return createFromConfig(c3);
}
function createLocal(input, format3, locale2, strict) {
  return createLocalOrUTC(input, format3, locale2, strict, false);
}
var prototypeMin = deprecate(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
      return other < this ? this : other;
    } else {
      return createInvalid();
    }
  }
), prototypeMax = deprecate(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
      return other > this ? this : other;
    } else {
      return createInvalid();
    }
  }
);
function pickBy(fn2, moments) {
  var res, i3;
  if (moments.length === 1 && isArray3(moments[0])) {
    moments = moments[0];
  }
  if (!moments.length) {
    return createLocal();
  }
  res = moments[0];
  for (i3 = 1; i3 < moments.length; ++i3) {
    if (!moments[i3].isValid() || moments[i3][fn2](res)) {
      res = moments[i3];
    }
  }
  return res;
}
function min() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isBefore", args);
}
function max() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isAfter", args);
}
var now = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
};
var ordering = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function isDurationValid(m4) {
  var key2, unitHasDecimal = false, i3, orderLen = ordering.length;
  for (key2 in m4) {
    if (hasOwnProp(m4, key2) && !(indexOf.call(ordering, key2) !== -1 && (m4[key2] == null || !isNaN(m4[key2])))) {
      return false;
    }
  }
  for (i3 = 0; i3 < orderLen; ++i3) {
    if (m4[ordering[i3]]) {
      if (unitHasDecimal) {
        return false;
      }
      if (parseFloat(m4[ordering[i3]]) !== toInt(m4[ordering[i3]])) {
        unitHasDecimal = true;
      }
    }
  }
  return true;
}
function isValid$1$1() {
  return this._isValid;
}
function createInvalid$1() {
  return createDuration(NaN);
}
function Duration(duration) {
  var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
  this._isValid = isDurationValid(normalizedInput);
  this._milliseconds = +milliseconds2 + seconds2 * 1e3 + // 1000
  minutes2 * 6e4 + // 1000 * 60
  hours2 * 1e3 * 60 * 60;
  this._days = +days2 + weeks2 * 7;
  this._months = +months2 + quarters * 3 + years2 * 12;
  this._data = {};
  this._locale = getLocale();
  this._bubble();
}
function isDuration(obj) {
  return obj instanceof Duration;
}
function absRound(number) {
  if (number < 0) {
    return Math.round(-1 * number) * -1;
  } else {
    return Math.round(number);
  }
}
function compareArrays(array1, array2, dontConvert) {
  var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i3;
  for (i3 = 0; i3 < len; i3++) {
    if (toInt(array1[i3]) !== toInt(array2[i3])) {
      diffs++;
    }
  }
  return diffs + lengthDiff;
}
function offset(token2, separator) {
  addFormatToken(token2, 0, 0, function() {
    var offset2 = this.utcOffset(), sign2 = "+";
    if (offset2 < 0) {
      offset2 = -offset2;
      sign2 = "-";
    }
    return sign2 + zeroFill(~~(offset2 / 60), 2) + separator + zeroFill(~~offset2 % 60, 2);
  });
}
offset("Z", ":");
offset("ZZ", "");
addRegexToken("Z", matchShortOffset);
addRegexToken("ZZ", matchShortOffset);
addParseToken(["Z", "ZZ"], function(input, array, config) {
  config._useUTC = true;
  config._tzm = offsetFromString(matchShortOffset, input);
});
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(matcher, string3) {
  var matches2 = (string3 || "").match(matcher), chunk, parts, minutes2;
  if (matches2 === null) {
    return null;
  }
  chunk = matches2[matches2.length - 1] || [];
  parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
  minutes2 = +(parts[1] * 60) + toInt(parts[2]);
  return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
}
function cloneWithOffset(input, model) {
  var res, diff2;
  if (model._isUTC) {
    res = model.clone();
    diff2 = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
    res._d.setTime(res._d.valueOf() + diff2);
    hooks.updateOffset(res, false);
    return res;
  } else {
    return createLocal(input).local();
  }
}
function getDateOffset(m4) {
  return -Math.round(m4._d.getTimezoneOffset());
}
hooks.updateOffset = function() {
};
function getSetOffset(input, keepLocalTime, keepMinutes) {
  var offset2 = this._offset || 0, localAdjust;
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    if (typeof input === "string") {
      input = offsetFromString(matchShortOffset, input);
      if (input === null) {
        return this;
      }
    } else if (Math.abs(input) < 16 && !keepMinutes) {
      input = input * 60;
    }
    if (!this._isUTC && keepLocalTime) {
      localAdjust = getDateOffset(this);
    }
    this._offset = input;
    this._isUTC = true;
    if (localAdjust != null) {
      this.add(localAdjust, "m");
    }
    if (offset2 !== input) {
      if (!keepLocalTime || this._changeInProgress) {
        addSubtract(
          this,
          createDuration(input - offset2, "m"),
          1,
          false
        );
      } else if (!this._changeInProgress) {
        this._changeInProgress = true;
        hooks.updateOffset(this, true);
        this._changeInProgress = null;
      }
    }
    return this;
  } else {
    return this._isUTC ? offset2 : getDateOffset(this);
  }
}
function getSetZone(input, keepLocalTime) {
  if (input != null) {
    if (typeof input !== "string") {
      input = -input;
    }
    this.utcOffset(input, keepLocalTime);
    return this;
  } else {
    return -this.utcOffset();
  }
}
function setOffsetToUTC(keepLocalTime) {
  return this.utcOffset(0, keepLocalTime);
}
function setOffsetToLocal(keepLocalTime) {
  if (this._isUTC) {
    this.utcOffset(0, keepLocalTime);
    this._isUTC = false;
    if (keepLocalTime) {
      this.subtract(getDateOffset(this), "m");
    }
  }
  return this;
}
function setOffsetToParsedOffset() {
  if (this._tzm != null) {
    this.utcOffset(this._tzm, false, true);
  } else if (typeof this._i === "string") {
    var tZone = offsetFromString(matchOffset, this._i);
    if (tZone != null) {
      this.utcOffset(tZone);
    } else {
      this.utcOffset(0, true);
    }
  }
  return this;
}
function hasAlignedHourOffset(input) {
  if (!this.isValid()) {
    return false;
  }
  input = input ? createLocal(input).utcOffset() : 0;
  return (this.utcOffset() - input) % 60 === 0;
}
function isDaylightSavingTime() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function isDaylightSavingTimeShifted() {
  if (!isUndefined(this._isDSTShifted)) {
    return this._isDSTShifted;
  }
  var c3 = {}, other;
  copyConfig(c3, this);
  c3 = prepareConfig(c3);
  if (c3._a) {
    other = c3._isUTC ? createUTC(c3._a) : createLocal(c3._a);
    this._isDSTShifted = this.isValid() && compareArrays(c3._a, other.toArray()) > 0;
  } else {
    this._isDSTShifted = false;
  }
  return this._isDSTShifted;
}
function isLocal() {
  return this.isValid() ? !this._isUTC : false;
}
function isUtcOffset() {
  return this.isValid() ? this._isUTC : false;
}
function isUtc() {
  return this.isValid() ? this._isUTC && this._offset === 0 : false;
}
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(input, key2) {
  var duration = input, match5 = null, sign2, ret, diffRes;
  if (isDuration(input)) {
    duration = {
      ms: input._milliseconds,
      d: input._days,
      M: input._months
    };
  } else if (isNumber(input) || !isNaN(+input)) {
    duration = {};
    if (key2) {
      duration[key2] = +input;
    } else {
      duration.milliseconds = +input;
    }
  } else if (match5 = aspNetRegex.exec(input)) {
    sign2 = match5[1] === "-" ? -1 : 1;
    duration = {
      y: 0,
      d: toInt(match5[DATE]) * sign2,
      h: toInt(match5[HOUR]) * sign2,
      m: toInt(match5[MINUTE]) * sign2,
      s: toInt(match5[SECOND]) * sign2,
      ms: toInt(absRound(match5[MILLISECOND] * 1e3)) * sign2
      // the millisecond decimal point is included in the match
    };
  } else if (match5 = isoRegex.exec(input)) {
    sign2 = match5[1] === "-" ? -1 : 1;
    duration = {
      y: parseIso(match5[2], sign2),
      M: parseIso(match5[3], sign2),
      w: parseIso(match5[4], sign2),
      d: parseIso(match5[5], sign2),
      h: parseIso(match5[6], sign2),
      m: parseIso(match5[7], sign2),
      s: parseIso(match5[8], sign2)
    };
  } else if (duration == null) {
    duration = {};
  } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
    diffRes = momentsDifference(
      createLocal(duration.from),
      createLocal(duration.to)
    );
    duration = {};
    duration.ms = diffRes.milliseconds;
    duration.M = diffRes.months;
  }
  ret = new Duration(duration);
  if (isDuration(input) && hasOwnProp(input, "_locale")) {
    ret._locale = input._locale;
  }
  if (isDuration(input) && hasOwnProp(input, "_isValid")) {
    ret._isValid = input._isValid;
  }
  return ret;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(inp, sign2) {
  var res = inp && parseFloat(inp.replace(",", "."));
  return (isNaN(res) ? 0 : res) * sign2;
}
function positiveMomentsDifference(base, other) {
  var res = {};
  res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
  if (base.clone().add(res.months, "M").isAfter(other)) {
    --res.months;
  }
  res.milliseconds = +other - +base.clone().add(res.months, "M");
  return res;
}
function momentsDifference(base, other) {
  var res;
  if (!(base.isValid() && other.isValid())) {
    return { milliseconds: 0, months: 0 };
  }
  other = cloneWithOffset(other, base);
  if (base.isBefore(other)) {
    res = positiveMomentsDifference(base, other);
  } else {
    res = positiveMomentsDifference(other, base);
    res.milliseconds = -res.milliseconds;
    res.months = -res.months;
  }
  return res;
}
function createAdder(direction2, name2) {
  return function(val, period) {
    var dur, tmp;
    if (period !== null && !isNaN(+period)) {
      deprecateSimple(
        name2,
        "moment()." + name2 + "(period, number) is deprecated. Please use moment()." + name2 + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
      );
      tmp = val;
      val = period;
      period = tmp;
    }
    dur = createDuration(val, period);
    addSubtract(this, dur, direction2);
    return this;
  };
}
function addSubtract(mom, duration, isAdding, updateOffset) {
  var milliseconds2 = duration._milliseconds, days2 = absRound(duration._days), months2 = absRound(duration._months);
  if (!mom.isValid()) {
    return;
  }
  updateOffset = updateOffset == null ? true : updateOffset;
  if (months2) {
    setMonth(mom, get$1(mom, "Month") + months2 * isAdding);
  }
  if (days2) {
    set$1(mom, "Date", get$1(mom, "Date") + days2 * isAdding);
  }
  if (milliseconds2) {
    mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
  }
  if (updateOffset) {
    hooks.updateOffset(mom, days2 || months2);
  }
}
var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
function isString(input) {
  return typeof input === "string" || input instanceof String;
}
function isMomentInput(input) {
  return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === void 0;
}
function isMomentInputObject(input) {
  var objectTest = isObject2(input) && !isObjectEmpty(input), propertyTest = false, properties2 = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i3, property2, propertyLen = properties2.length;
  for (i3 = 0; i3 < propertyLen; i3 += 1) {
    property2 = properties2[i3];
    propertyTest = propertyTest || hasOwnProp(input, property2);
  }
  return objectTest && propertyTest;
}
function isNumberOrStringArray(input) {
  var arrayTest = isArray3(input), dataTypeTest = false;
  if (arrayTest) {
    dataTypeTest = input.filter(function(item) {
      return !isNumber(item) && isString(input);
    }).length === 0;
  }
  return arrayTest && dataTypeTest;
}
function isCalendarSpec(input) {
  var objectTest = isObject2(input) && !isObjectEmpty(input), propertyTest = false, properties2 = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i3, property2;
  for (i3 = 0; i3 < properties2.length; i3 += 1) {
    property2 = properties2[i3];
    propertyTest = propertyTest || hasOwnProp(input, property2);
  }
  return objectTest && propertyTest;
}
function getCalendarFormat(myMoment, now2) {
  var diff2 = myMoment.diff(now2, "days", true);
  return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
}
function calendar$1(time2, formats2) {
  if (arguments.length === 1) {
    if (!arguments[0]) {
      time2 = void 0;
      formats2 = void 0;
    } else if (isMomentInput(arguments[0])) {
      time2 = arguments[0];
      formats2 = void 0;
    } else if (isCalendarSpec(arguments[0])) {
      formats2 = arguments[0];
      time2 = void 0;
    }
  }
  var now2 = time2 || createLocal(), sod = cloneWithOffset(now2, this).startOf("day"), format3 = hooks.calendarFormat(this, sod) || "sameElse", output = formats2 && (isFunction(formats2[format3]) ? formats2[format3].call(this, now2) : formats2[format3]);
  return this.format(
    output || this.localeData().calendar(format3, this, createLocal(now2))
  );
}
function clone() {
  return new Moment(this);
}
function isAfter(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() > localInput.valueOf();
  } else {
    return localInput.valueOf() < this.clone().startOf(units).valueOf();
  }
}
function isBefore(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() < localInput.valueOf();
  } else {
    return this.clone().endOf(units).valueOf() < localInput.valueOf();
  }
}
function isBetween(from2, to2, units, inclusivity) {
  var localFrom = isMoment(from2) ? from2 : createLocal(from2), localTo = isMoment(to2) ? to2 : createLocal(to2);
  if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
    return false;
  }
  inclusivity = inclusivity || "()";
  return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
}
function isSame(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input), inputMs;
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() === localInput.valueOf();
  } else {
    inputMs = localInput.valueOf();
    return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
  }
}
function isSameOrAfter(input, units) {
  return this.isSame(input, units) || this.isAfter(input, units);
}
function isSameOrBefore(input, units) {
  return this.isSame(input, units) || this.isBefore(input, units);
}
function diff(input, units, asFloat) {
  var that, zoneDelta, output;
  if (!this.isValid()) {
    return NaN;
  }
  that = cloneWithOffset(input, this);
  if (!that.isValid()) {
    return NaN;
  }
  zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
  units = normalizeUnits(units);
  switch (units) {
    case "year":
      output = monthDiff(this, that) / 12;
      break;
    case "month":
      output = monthDiff(this, that);
      break;
    case "quarter":
      output = monthDiff(this, that) / 3;
      break;
    case "second":
      output = (this - that) / 1e3;
      break;
    case "minute":
      output = (this - that) / 6e4;
      break;
    case "hour":
      output = (this - that) / 36e5;
      break;
    case "day":
      output = (this - that - zoneDelta) / 864e5;
      break;
    case "week":
      output = (this - that - zoneDelta) / 6048e5;
      break;
    default:
      output = this - that;
  }
  return asFloat ? output : absFloor(output);
}
function monthDiff(a4, b3) {
  if (a4.date() < b3.date()) {
    return -monthDiff(b3, a4);
  }
  var wholeMonthDiff = (b3.year() - a4.year()) * 12 + (b3.month() - a4.month()), anchor = a4.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
  if (b3 - anchor < 0) {
    anchor2 = a4.clone().add(wholeMonthDiff - 1, "months");
    adjust = (b3 - anchor) / (anchor - anchor2);
  } else {
    anchor2 = a4.clone().add(wholeMonthDiff + 1, "months");
    adjust = (b3 - anchor) / (anchor2 - anchor);
  }
  return -(wholeMonthDiff + adjust) || 0;
}
hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function toString() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function toISOString(keepOffset) {
  if (!this.isValid()) {
    return null;
  }
  var utc = keepOffset !== true, m4 = utc ? this.clone().utc() : this;
  if (m4.year() < 0 || m4.year() > 9999) {
    return formatMoment(
      m4,
      utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
    );
  }
  if (isFunction(Date.prototype.toISOString)) {
    if (utc) {
      return this.toDate().toISOString();
    } else {
      return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m4, "Z"));
    }
  }
  return formatMoment(
    m4,
    utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function inspect() {
  if (!this.isValid()) {
    return "moment.invalid(/* " + this._i + " */)";
  }
  var func = "moment", zone = "", prefix2, year, datetime, suffix;
  if (!this.isLocal()) {
    func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
    zone = "Z";
  }
  prefix2 = "[" + func + '("]';
  year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
  datetime = "-MM-DD[T]HH:mm:ss.SSS";
  suffix = zone + '[")]';
  return this.format(prefix2 + year + datetime + suffix);
}
function format$1(inputString) {
  if (!inputString) {
    inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
  }
  var output = formatMoment(this, inputString);
  return this.localeData().postformat(output);
}
function from(time2, withoutSuffix) {
  if (this.isValid() && (isMoment(time2) && time2.isValid() || createLocal(time2).isValid())) {
    return createDuration({ to: this, from: time2 }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function fromNow(withoutSuffix) {
  return this.from(createLocal(), withoutSuffix);
}
function to(time2, withoutSuffix) {
  if (this.isValid() && (isMoment(time2) && time2.isValid() || createLocal(time2).isValid())) {
    return createDuration({ from: this, to: time2 }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function toNow(withoutSuffix) {
  return this.to(createLocal(), withoutSuffix);
}
function locale(key2) {
  var newLocaleData;
  if (key2 === void 0) {
    return this._locale._abbr;
  } else {
    newLocaleData = getLocale(key2);
    if (newLocaleData != null) {
      this._locale = newLocaleData;
    }
    return this;
  }
}
var lang = deprecate(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(key2) {
    if (key2 === void 0) {
      return this.localeData();
    } else {
      return this.locale(key2);
    }
  }
);
function localeData() {
  return this._locale;
}
var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
function mod$1(dividend, divisor) {
  return (dividend % divisor + divisor) % divisor;
}
function localStartOfDate(y4, m4, d4) {
  if (y4 < 100 && y4 >= 0) {
    return new Date(y4 + 400, m4, d4) - MS_PER_400_YEARS;
  } else {
    return new Date(y4, m4, d4).valueOf();
  }
}
function utcStartOfDate(y4, m4, d4) {
  if (y4 < 100 && y4 >= 0) {
    return Date.UTC(y4 + 400, m4, d4) - MS_PER_400_YEARS;
  } else {
    return Date.UTC(y4, m4, d4);
  }
}
function startOf(units) {
  var time2, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time2 = startOfDate(this.year(), 0, 1);
      break;
    case "quarter":
      time2 = startOfDate(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      time2 = startOfDate(this.year(), this.month(), 1);
      break;
    case "week":
      time2 = startOfDate(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      time2 = startOfDate(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      time2 = startOfDate(this.year(), this.month(), this.date());
      break;
    case "hour":
      time2 = this._d.valueOf();
      time2 -= mod$1(
        time2 + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      );
      break;
    case "minute":
      time2 = this._d.valueOf();
      time2 -= mod$1(time2, MS_PER_MINUTE);
      break;
    case "second":
      time2 = this._d.valueOf();
      time2 -= mod$1(time2, MS_PER_SECOND);
      break;
  }
  this._d.setTime(time2);
  hooks.updateOffset(this, true);
  return this;
}
function endOf(units) {
  var time2, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time2 = startOfDate(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      time2 = startOfDate(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      time2 = startOfDate(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      time2 = startOfDate(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      time2 = startOfDate(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      time2 = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      time2 = this._d.valueOf();
      time2 += MS_PER_HOUR - mod$1(
        time2 + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      ) - 1;
      break;
    case "minute":
      time2 = this._d.valueOf();
      time2 += MS_PER_MINUTE - mod$1(time2, MS_PER_MINUTE) - 1;
      break;
    case "second":
      time2 = this._d.valueOf();
      time2 += MS_PER_SECOND - mod$1(time2, MS_PER_SECOND) - 1;
      break;
  }
  this._d.setTime(time2);
  hooks.updateOffset(this, true);
  return this;
}
function valueOf() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function unix() {
  return Math.floor(this.valueOf() / 1e3);
}
function toDate() {
  return new Date(this.valueOf());
}
function toArray() {
  var m4 = this;
  return [
    m4.year(),
    m4.month(),
    m4.date(),
    m4.hour(),
    m4.minute(),
    m4.second(),
    m4.millisecond()
  ];
}
function toObject() {
  var m4 = this;
  return {
    years: m4.year(),
    months: m4.month(),
    date: m4.date(),
    hours: m4.hours(),
    minutes: m4.minutes(),
    seconds: m4.seconds(),
    milliseconds: m4.milliseconds()
  };
}
function toJSON() {
  return this.isValid() ? this.toISOString() : null;
}
function isValid$2() {
  return isValid$1(this);
}
function parsingFlags() {
  return extend2({}, getParsingFlags(this));
}
function invalidAt() {
  return getParsingFlags(this).overflow;
}
function creationData() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
addFormatToken("N", 0, 0, "eraAbbr");
addFormatToken("NN", 0, 0, "eraAbbr");
addFormatToken("NNN", 0, 0, "eraAbbr");
addFormatToken("NNNN", 0, 0, "eraName");
addFormatToken("NNNNN", 0, 0, "eraNarrow");
addFormatToken("y", ["y", 1], "yo", "eraYear");
addFormatToken("y", ["yy", 2], 0, "eraYear");
addFormatToken("y", ["yyy", 3], 0, "eraYear");
addFormatToken("y", ["yyyy", 4], 0, "eraYear");
addRegexToken("N", matchEraAbbr);
addRegexToken("NN", matchEraAbbr);
addRegexToken("NNN", matchEraAbbr);
addRegexToken("NNNN", matchEraName);
addRegexToken("NNNNN", matchEraNarrow);
addParseToken(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(input, array, config, token2) {
    var era = config._locale.erasParse(input, token2, config._strict);
    if (era) {
      getParsingFlags(config).era = era;
    } else {
      getParsingFlags(config).invalidEra = input;
    }
  }
);
addRegexToken("y", matchUnsigned);
addRegexToken("yy", matchUnsigned);
addRegexToken("yyy", matchUnsigned);
addRegexToken("yyyy", matchUnsigned);
addRegexToken("yo", matchEraYearOrdinal);
addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
addParseToken(["yo"], function(input, array, config, token2) {
  var match5;
  if (config._locale._eraYearOrdinalRegex) {
    match5 = input.match(config._locale._eraYearOrdinalRegex);
  }
  if (config._locale.eraYearOrdinalParse) {
    array[YEAR] = config._locale.eraYearOrdinalParse(input, match5);
  } else {
    array[YEAR] = parseInt(input, 10);
  }
});
function localeEras(m4, format3) {
  var i3, l2, date, eras = this._eras || getLocale("en")._eras;
  for (i3 = 0, l2 = eras.length; i3 < l2; ++i3) {
    switch (typeof eras[i3].since) {
      case "string":
        date = hooks(eras[i3].since).startOf("day");
        eras[i3].since = date.valueOf();
        break;
    }
    switch (typeof eras[i3].until) {
      case "undefined":
        eras[i3].until = Infinity;
        break;
      case "string":
        date = hooks(eras[i3].until).startOf("day").valueOf();
        eras[i3].until = date.valueOf();
        break;
    }
  }
  return eras;
}
function localeErasParse(eraName, format3, strict) {
  var i3, l2, eras = this.eras(), name2, abbr, narrow;
  eraName = eraName.toUpperCase();
  for (i3 = 0, l2 = eras.length; i3 < l2; ++i3) {
    name2 = eras[i3].name.toUpperCase();
    abbr = eras[i3].abbr.toUpperCase();
    narrow = eras[i3].narrow.toUpperCase();
    if (strict) {
      switch (format3) {
        case "N":
        case "NN":
        case "NNN":
          if (abbr === eraName) {
            return eras[i3];
          }
          break;
        case "NNNN":
          if (name2 === eraName) {
            return eras[i3];
          }
          break;
        case "NNNNN":
          if (narrow === eraName) {
            return eras[i3];
          }
          break;
      }
    } else if ([name2, abbr, narrow].indexOf(eraName) >= 0) {
      return eras[i3];
    }
  }
}
function localeErasConvertYear(era, year) {
  var dir = era.since <= era.until ? 1 : -1;
  if (year === void 0) {
    return hooks(era.since).year();
  } else {
    return hooks(era.since).year() + (year - era.offset) * dir;
  }
}
function getEraName() {
  var i3, l2, val, eras = this.localeData().eras();
  for (i3 = 0, l2 = eras.length; i3 < l2; ++i3) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i3].since <= val && val <= eras[i3].until) {
      return eras[i3].name;
    }
    if (eras[i3].until <= val && val <= eras[i3].since) {
      return eras[i3].name;
    }
  }
  return "";
}
function getEraNarrow() {
  var i3, l2, val, eras = this.localeData().eras();
  for (i3 = 0, l2 = eras.length; i3 < l2; ++i3) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i3].since <= val && val <= eras[i3].until) {
      return eras[i3].narrow;
    }
    if (eras[i3].until <= val && val <= eras[i3].since) {
      return eras[i3].narrow;
    }
  }
  return "";
}
function getEraAbbr() {
  var i3, l2, val, eras = this.localeData().eras();
  for (i3 = 0, l2 = eras.length; i3 < l2; ++i3) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i3].since <= val && val <= eras[i3].until) {
      return eras[i3].abbr;
    }
    if (eras[i3].until <= val && val <= eras[i3].since) {
      return eras[i3].abbr;
    }
  }
  return "";
}
function getEraYear() {
  var i3, l2, dir, val, eras = this.localeData().eras();
  for (i3 = 0, l2 = eras.length; i3 < l2; ++i3) {
    dir = eras[i3].since <= eras[i3].until ? 1 : -1;
    val = this.clone().startOf("day").valueOf();
    if (eras[i3].since <= val && val <= eras[i3].until || eras[i3].until <= val && val <= eras[i3].since) {
      return (this.year() - hooks(eras[i3].since).year()) * dir + eras[i3].offset;
    }
  }
  return this.year();
}
function erasNameRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNameRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNameRegex : this._erasRegex;
}
function erasAbbrRegex(isStrict) {
  if (!hasOwnProp(this, "_erasAbbrRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasAbbrRegex : this._erasRegex;
}
function erasNarrowRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNarrowRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNarrowRegex : this._erasRegex;
}
function matchEraAbbr(isStrict, locale2) {
  return locale2.erasAbbrRegex(isStrict);
}
function matchEraName(isStrict, locale2) {
  return locale2.erasNameRegex(isStrict);
}
function matchEraNarrow(isStrict, locale2) {
  return locale2.erasNarrowRegex(isStrict);
}
function matchEraYearOrdinal(isStrict, locale2) {
  return locale2._eraYearOrdinalRegex || matchUnsigned;
}
function computeErasParse() {
  var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i3, l2, erasName, erasAbbr, erasNarrow, eras = this.eras();
  for (i3 = 0, l2 = eras.length; i3 < l2; ++i3) {
    erasName = regexEscape(eras[i3].name);
    erasAbbr = regexEscape(eras[i3].abbr);
    erasNarrow = regexEscape(eras[i3].narrow);
    namePieces.push(erasName);
    abbrPieces.push(erasAbbr);
    narrowPieces.push(erasNarrow);
    mixedPieces.push(erasName);
    mixedPieces.push(erasAbbr);
    mixedPieces.push(erasNarrow);
  }
  this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
  this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
  this._erasNarrowRegex = new RegExp(
    "^(" + narrowPieces.join("|") + ")",
    "i"
  );
}
addFormatToken(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
addFormatToken(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(token2, getter) {
  addFormatToken(0, [token2, token2.length], 0, getter);
}
addWeekYearFormatToken("gggg", "weekYear");
addWeekYearFormatToken("ggggg", "weekYear");
addWeekYearFormatToken("GGGG", "isoWeekYear");
addWeekYearFormatToken("GGGGG", "isoWeekYear");
addRegexToken("G", matchSigned);
addRegexToken("g", matchSigned);
addRegexToken("GG", match1to2, match2);
addRegexToken("gg", match1to2, match2);
addRegexToken("GGGG", match1to4, match4);
addRegexToken("gggg", match1to4, match4);
addRegexToken("GGGGG", match1to6, match6);
addRegexToken("ggggg", match1to6, match6);
addWeekParseToken(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(input, week, config, token2) {
    week[token2.substr(0, 2)] = toInt(input);
  }
);
addWeekParseToken(["gg", "GG"], function(input, week, config, token2) {
  week[token2] = hooks.parseTwoDigitYear(input);
});
function getSetWeekYear(input) {
  return getSetWeekYearHelper.call(
    this,
    input,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function getSetISOWeekYear(input) {
  return getSetWeekYearHelper.call(
    this,
    input,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function getISOWeeksInYear() {
  return weeksInYear(this.year(), 1, 4);
}
function getISOWeeksInISOWeekYear() {
  return weeksInYear(this.isoWeekYear(), 1, 4);
}
function getWeeksInYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}
function getWeeksInWeekYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
}
function getSetWeekYearHelper(input, week, weekday, dow, doy) {
  var weeksTarget;
  if (input == null) {
    return weekOfYear(this, dow, doy).year;
  } else {
    weeksTarget = weeksInYear(input, dow, doy);
    if (week > weeksTarget) {
      week = weeksTarget;
    }
    return setWeekAll.call(this, input, week, weekday, dow, doy);
  }
}
function setWeekAll(weekYear, week, weekday, dow, doy) {
  var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
  this.year(date.getUTCFullYear());
  this.month(date.getUTCMonth());
  this.date(date.getUTCDate());
  return this;
}
addFormatToken("Q", 0, "Qo", "quarter");
addRegexToken("Q", match1);
addParseToken("Q", function(input, array) {
  array[MONTH] = (toInt(input) - 1) * 3;
});
function getSetQuarter(input) {
  return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}
addFormatToken("D", ["DD", 2], "Do", "date");
addRegexToken("D", match1to2, match1to2NoLeadingZero);
addRegexToken("DD", match1to2, match2);
addRegexToken("Do", function(isStrict, locale2) {
  return isStrict ? locale2._dayOfMonthOrdinalParse || locale2._ordinalParse : locale2._dayOfMonthOrdinalParseLenient;
});
addParseToken(["D", "DD"], DATE);
addParseToken("Do", function(input, array) {
  array[DATE] = toInt(input.match(match1to2)[0]);
});
var getSetDayOfMonth = makeGetSet("Date", true);
addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
addRegexToken("DDD", match1to3);
addRegexToken("DDDD", match3);
addParseToken(["DDD", "DDDD"], function(input, array, config) {
  config._dayOfYear = toInt(input);
});
function getSetDayOfYear(input) {
  var dayOfYear = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
}
addFormatToken("m", ["mm", 2], 0, "minute");
addRegexToken("m", match1to2, match1to2HasZero);
addRegexToken("mm", match1to2, match2);
addParseToken(["m", "mm"], MINUTE);
var getSetMinute = makeGetSet("Minutes", false);
addFormatToken("s", ["ss", 2], 0, "second");
addRegexToken("s", match1to2, match1to2HasZero);
addRegexToken("ss", match1to2, match2);
addParseToken(["s", "ss"], SECOND);
var getSetSecond = makeGetSet("Seconds", false);
addFormatToken("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
addFormatToken(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
addFormatToken(0, ["SSS", 3], 0, "millisecond");
addFormatToken(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
addFormatToken(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
addFormatToken(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
addFormatToken(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
addRegexToken("S", match1to3, match1);
addRegexToken("SS", match1to3, match2);
addRegexToken("SSS", match1to3, match3);
var token, getSetMillisecond;
for (token = "SSSS"; token.length <= 9; token += "S") {
  addRegexToken(token, matchUnsigned);
}
function parseMs(input, array) {
  array[MILLISECOND] = toInt(("0." + input) * 1e3);
}
for (token = "S"; token.length <= 9; token += "S") {
  addParseToken(token, parseMs);
}
getSetMillisecond = makeGetSet("Milliseconds", false);
addFormatToken("z", 0, 0, "zoneAbbr");
addFormatToken("zz", 0, 0, "zoneName");
function getZoneAbbr() {
  return this._isUTC ? "UTC" : "";
}
function getZoneName() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var proto = Moment.prototype;
proto.add = add;
proto.calendar = calendar$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format$1;
proto.from = from;
proto.fromNow = fromNow;
proto.to = to;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2;
proto.lang = lang;
proto.locale = locale;
proto.localeData = localeData;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract;
proto.toArray = toArray;
proto.toObject = toObject;
proto.toDate = toDate;
proto.toISOString = toISOString;
proto.inspect = inspect;
if (typeof Symbol !== "undefined" && Symbol.for != null) {
  proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
    return "Moment<" + this.format() + ">";
  };
}
proto.toJSON = toJSON;
proto.toString = toString;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.eraName = getEraName;
proto.eraNarrow = getEraNarrow;
proto.eraAbbr = getEraAbbr;
proto.eraYear = getEraYear;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.weeksInWeekYear = getWeeksInWeekYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate(
  "dates accessor is deprecated. Use date instead.",
  getSetDayOfMonth
);
proto.months = deprecate(
  "months accessor is deprecated. Use month instead",
  getSetMonth
);
proto.years = deprecate(
  "years accessor is deprecated. Use year instead",
  getSetYear
);
proto.zone = deprecate(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  getSetZone
);
proto.isDSTShifted = deprecate(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  isDaylightSavingTimeShifted
);
function createUnix(input) {
  return createLocal(input * 1e3);
}
function createInZone() {
  return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(string3) {
  return string3;
}
var proto$1 = Locale.prototype;
proto$1.calendar = calendar;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set;
proto$1.eras = localeEras;
proto$1.erasParse = localeErasParse;
proto$1.erasConvertYear = localeErasConvertYear;
proto$1.erasAbbrRegex = erasAbbrRegex;
proto$1.erasNameRegex = erasNameRegex;
proto$1.erasNarrowRegex = erasNarrowRegex;
proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;
proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;
function get$1$1(format3, index2, field, setter2) {
  var locale2 = getLocale(), utc = createUTC().set(setter2, index2);
  return locale2[field](utc, format3);
}
function listMonthsImpl(format3, index2, field) {
  if (isNumber(format3)) {
    index2 = format3;
    format3 = void 0;
  }
  format3 = format3 || "";
  if (index2 != null) {
    return get$1$1(format3, index2, field, "month");
  }
  var i3, out = [];
  for (i3 = 0; i3 < 12; i3++) {
    out[i3] = get$1$1(format3, i3, field, "month");
  }
  return out;
}
function listWeekdaysImpl(localeSorted, format3, index2, field) {
  if (typeof localeSorted === "boolean") {
    if (isNumber(format3)) {
      index2 = format3;
      format3 = void 0;
    }
    format3 = format3 || "";
  } else {
    format3 = localeSorted;
    index2 = format3;
    localeSorted = false;
    if (isNumber(format3)) {
      index2 = format3;
      format3 = void 0;
    }
    format3 = format3 || "";
  }
  var locale2 = getLocale(), shift2 = localeSorted ? locale2._week.dow : 0, i3, out = [];
  if (index2 != null) {
    return get$1$1(format3, (index2 + shift2) % 7, field, "day");
  }
  for (i3 = 0; i3 < 7; i3++) {
    out[i3] = get$1$1(format3, (i3 + shift2) % 7, field, "day");
  }
  return out;
}
function listMonths(format3, index2) {
  return listMonthsImpl(format3, index2, "months");
}
function listMonthsShort(format3, index2) {
  return listMonthsImpl(format3, index2, "monthsShort");
}
function listWeekdays(localeSorted, format3, index2) {
  return listWeekdaysImpl(localeSorted, format3, index2, "weekdays");
}
function listWeekdaysShort(localeSorted, format3, index2) {
  return listWeekdaysImpl(localeSorted, format3, index2, "weekdaysShort");
}
function listWeekdaysMin(localeSorted, format3, index2) {
  return listWeekdaysImpl(localeSorted, format3, index2, "weekdaysMin");
}
getSetGlobalLocale("en", {
  eras: [
    {
      since: "0001-01-01",
      until: Infinity,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -Infinity,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(number) {
    var b3 = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b3 === 1 ? "st" : b3 === 2 ? "nd" : b3 === 3 ? "rd" : "th";
    return number + output;
  }
});
hooks.lang = deprecate(
  "moment.lang is deprecated. Use moment.locale instead.",
  getSetGlobalLocale
);
hooks.langData = deprecate(
  "moment.langData is deprecated. Use moment.localeData instead.",
  getLocale
);
var mathAbs = Math.abs;
function abs() {
  var data = this._data;
  this._milliseconds = mathAbs(this._milliseconds);
  this._days = mathAbs(this._days);
  this._months = mathAbs(this._months);
  data.milliseconds = mathAbs(data.milliseconds);
  data.seconds = mathAbs(data.seconds);
  data.minutes = mathAbs(data.minutes);
  data.hours = mathAbs(data.hours);
  data.months = mathAbs(data.months);
  data.years = mathAbs(data.years);
  return this;
}
function addSubtract$1(duration, input, value, direction2) {
  var other = createDuration(input, value);
  duration._milliseconds += direction2 * other._milliseconds;
  duration._days += direction2 * other._days;
  duration._months += direction2 * other._months;
  return duration._bubble();
}
function add$1(input, value) {
  return addSubtract$1(this, input, value, 1);
}
function subtract$1(input, value) {
  return addSubtract$1(this, input, value, -1);
}
function absCeil(number) {
  if (number < 0) {
    return Math.floor(number);
  } else {
    return Math.ceil(number);
  }
}
function bubble() {
  var milliseconds2 = this._milliseconds, days2 = this._days, months2 = this._months, data = this._data, seconds2, minutes2, hours2, years2, monthsFromDays;
  if (!(milliseconds2 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months2 <= 0)) {
    milliseconds2 += absCeil(monthsToDays(months2) + days2) * 864e5;
    days2 = 0;
    months2 = 0;
  }
  data.milliseconds = milliseconds2 % 1e3;
  seconds2 = absFloor(milliseconds2 / 1e3);
  data.seconds = seconds2 % 60;
  minutes2 = absFloor(seconds2 / 60);
  data.minutes = minutes2 % 60;
  hours2 = absFloor(minutes2 / 60);
  data.hours = hours2 % 24;
  days2 += absFloor(hours2 / 24);
  monthsFromDays = absFloor(daysToMonths(days2));
  months2 += monthsFromDays;
  days2 -= absCeil(monthsToDays(monthsFromDays));
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  data.days = days2;
  data.months = months2;
  data.years = years2;
  return this;
}
function daysToMonths(days2) {
  return days2 * 4800 / 146097;
}
function monthsToDays(months2) {
  return months2 * 146097 / 4800;
}
function as(units) {
  if (!this.isValid()) {
    return NaN;
  }
  var days2, months2, milliseconds2 = this._milliseconds;
  units = normalizeUnits(units);
  if (units === "month" || units === "quarter" || units === "year") {
    days2 = this._days + milliseconds2 / 864e5;
    months2 = this._months + daysToMonths(days2);
    switch (units) {
      case "month":
        return months2;
      case "quarter":
        return months2 / 3;
      case "year":
        return months2 / 12;
    }
  } else {
    days2 = this._days + Math.round(monthsToDays(this._months));
    switch (units) {
      case "week":
        return days2 / 7 + milliseconds2 / 6048e5;
      case "day":
        return days2 + milliseconds2 / 864e5;
      case "hour":
        return days2 * 24 + milliseconds2 / 36e5;
      case "minute":
        return days2 * 1440 + milliseconds2 / 6e4;
      case "second":
        return days2 * 86400 + milliseconds2 / 1e3;
      case "millisecond":
        return Math.floor(days2 * 864e5) + milliseconds2;
      default:
        throw new Error("Unknown unit " + units);
    }
  }
}
function makeAs(alias) {
  return function() {
    return this.as(alias);
  };
}
var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
function clone$1() {
  return createDuration(this);
}
function get$2(units) {
  units = normalizeUnits(units);
  return this.isValid() ? this[units + "s"]() : NaN;
}
function makeGetter(name2) {
  return function() {
    return this.isValid() ? this._data[name2] : NaN;
  };
}
var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
function weeks() {
  return absFloor(this.days() / 7);
}
var round = Math.round, thresholds = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function substituteTimeAgo(string3, number, withoutSuffix, isFuture, locale2) {
  return locale2.relativeTime(number || 1, !!withoutSuffix, string3, isFuture);
}
function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale2) {
  var duration = createDuration(posNegDuration).abs(), seconds2 = round(duration.as("s")), minutes2 = round(duration.as("m")), hours2 = round(duration.as("h")), days2 = round(duration.as("d")), months2 = round(duration.as("M")), weeks2 = round(duration.as("w")), years2 = round(duration.as("y")), a4 = seconds2 <= thresholds2.ss && ["s", seconds2] || seconds2 < thresholds2.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
  if (thresholds2.w != null) {
    a4 = a4 || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
  }
  a4 = a4 || months2 <= 1 && ["M"] || months2 < thresholds2.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
  a4[2] = withoutSuffix;
  a4[3] = +posNegDuration > 0;
  a4[4] = locale2;
  return substituteTimeAgo.apply(null, a4);
}
function getSetRelativeTimeRounding(roundingFunction) {
  if (roundingFunction === void 0) {
    return round;
  }
  if (typeof roundingFunction === "function") {
    round = roundingFunction;
    return true;
  }
  return false;
}
function getSetRelativeTimeThreshold(threshold, limit2) {
  if (thresholds[threshold] === void 0) {
    return false;
  }
  if (limit2 === void 0) {
    return thresholds[threshold];
  }
  thresholds[threshold] = limit2;
  if (threshold === "s") {
    thresholds.ss = limit2 - 1;
  }
  return true;
}
function humanize(argWithSuffix, argThresholds) {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var withSuffix = false, th = thresholds, locale2, output;
  if (typeof argWithSuffix === "object") {
    argThresholds = argWithSuffix;
    argWithSuffix = false;
  }
  if (typeof argWithSuffix === "boolean") {
    withSuffix = argWithSuffix;
  }
  if (typeof argThresholds === "object") {
    th = Object.assign({}, thresholds, argThresholds);
    if (argThresholds.s != null && argThresholds.ss == null) {
      th.ss = argThresholds.s - 1;
    }
  }
  locale2 = this.localeData();
  output = relativeTime$1(this, !withSuffix, th, locale2);
  if (withSuffix) {
    output = locale2.pastFuture(+this, output);
  }
  return locale2.postformat(output);
}
var abs$1 = Math.abs;
function sign(x3) {
  return (x3 > 0) - (x3 < 0) || +x3;
}
function toISOString$1() {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var seconds2 = abs$1(this._milliseconds) / 1e3, days2 = abs$1(this._days), months2 = abs$1(this._months), minutes2, hours2, years2, s4, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
  if (!total) {
    return "P0D";
  }
  minutes2 = absFloor(seconds2 / 60);
  hours2 = absFloor(minutes2 / 60);
  seconds2 %= 60;
  minutes2 %= 60;
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  s4 = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
  totalSign = total < 0 ? "-" : "";
  ymSign = sign(this._months) !== sign(total) ? "-" : "";
  daysSign = sign(this._days) !== sign(total) ? "-" : "";
  hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
  return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months2 ? ymSign + months2 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds2 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds2 ? hmsSign + s4 + "S" : "");
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1$1;
proto$2.abs = abs;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  toISOString$1
);
proto$2.lang = lang;
addFormatToken("X", 0, 0, "unix");
addFormatToken("x", 0, 0, "valueOf");
addRegexToken("x", matchSigned);
addRegexToken("X", matchTimestamp);
addParseToken("X", function(input, array, config) {
  config._d = new Date(parseFloat(input) * 1e3);
});
addParseToken("x", function(input, array, config) {
  config._d = new Date(toInt(input));
});
//! moment.js
hooks.version = "2.30.1";
setHookCallback(createLocal);
hooks.fn = proto;
hooks.min = min;
hooks.max = max;
hooks.now = now;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;
hooks.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const validYMD = (date) => {
  const ymd = hooks(date, "YYYY-MM-DD", true);
  const ydm = hooks(date, "YYYY-DD-MM", true);
  const dmy = hooks(date, "DD-MM-YYYY", true);
  const mdy = hooks(date, "MM-DD-YYYY", true);
  const ymd2 = hooks(date, "YYYY/MM/DD", true);
  const ydm2 = hooks(date, "YYYY/DD/MM", true);
  const dmy2 = hooks(date, "DD/MM/YYYY", true);
  const mdy2 = hooks(date, "MM/DD/YYYY", true);
  if (ymd.isValid() || ydm.isValid() || dmy.isValid() || mdy.isValid() || ymd2.isValid() || ydm2.isValid() || dmy2.isValid() || mdy2.isValid()) {
    return true;
  }
  return false;
};
const convertToYMD = (date) => {
  const newDate = hooks(date).format("YYYY-MM-DD");
  return newDate;
};
const convertToDate = (date) => {
  const convertedDate = hooks(date).format("YYYY-MM-DD");
  const newDate = hooks(convertedDate, hooks.defaultFormat).toDate();
  return newDate;
};
const getTodayDateStr = () => {
  const today = hooks.utc();
  return today.format("YYYY-MM-DD");
};
We("en", locale$1);
const DateEntry = ({
  classes,
  label,
  required: required2,
  readOnly = false,
  todayVisible = true,
  hideLabel = true,
  id: id2 = "",
  onChange = () => {
  },
  value = "",
  formContext = {}
}) => {
  const error2 = !!value && !validYMD(value);
  const isLocked = isLockedWidget(id2, formContext.links);
  const [activeCalendar, setActiveCalendar] = useState(false);
  const calendarRef = useRef(null);
  useLayoutEffect(() => {
    if (!isLocked) calendarRef.current.setOpen(activeCalendar);
  }, [activeCalendar, isLocked]);
  const handleDatePickerChange = (newDateStr) => {
    onChange(convertToYMD(newDateStr));
    return setActiveCalendar(false);
  };
  const setToday = () => {
    if (readOnly) return;
    onChange(getTodayDateStr());
  };
  const CustomInput = forwardRef((_props2, ref2) => /* @__PURE__ */ jsx$1(
    "div",
    {
      className: classes.iconInput,
      onClick: () => readOnly ? null : setActiveCalendar(!activeCalendar),
      "data-cy": "forms-js-calendar",
      children: /* @__PURE__ */ jsx$1(
        Icon$2,
        {
          name: activeCalendar ? "CalendarFill" : "Calendar",
          size: 32,
          ref: ref2
        }
      )
    }
  ));
  const disabled = readOnly || isLocked;
  return /* @__PURE__ */ jsxs("div", { className: classes.root, children: [
    !hideLabel && /* @__PURE__ */ jsxs("label", { htmlFor: id2, children: [
      required2 && /* @__PURE__ */ jsx$1("strong", { children: "*" }),
      label
    ] }),
    /* @__PURE__ */ jsxs("div", { className: classes.dateWrapper, children: [
      /* @__PURE__ */ jsxs("div", { className: classes.dateInput, children: [
        /* @__PURE__ */ jsx$1(
          "input",
          {
            id: id2,
            type: "date",
            value,
            onChange: (e5) => onChange(e5.target.value),
            readOnly: disabled,
            onClick: (e5) => e5.preventDefault(),
            "data-error": error2,
            "data-disabled": disabled,
            required: required2,
            "data-cy": "forms-js-date-manual"
          }
        ),
        !isLocked && todayVisible && /* @__PURE__ */ jsx$1(
          "p",
          {
            className: classes.dateToday,
            onClick: setToday,
            "data-cy": "forms-js-date-today",
            children: "Today"
          }
        )
      ] }),
      !isLocked && /* @__PURE__ */ jsx$1(
        xt,
        {
          selected: value && !error2 ? convertToDate(value) : null,
          onChange: handleDatePickerChange,
          dateFormat: "dd/MM/yyyy",
          calendarClassName: classes.calendar,
          showPopperArrow: false,
          shouldCloseOnSelect: true,
          locale: "en",
          popperClassName: classes.calendarPuppet,
          readOnly,
          ref: calendarRef,
          onClickOutside: () => setActiveCalendar(false),
          placeholderText: "dd/mm/yyyy",
          customInput: /* @__PURE__ */ jsx$1(CustomInput, {}),
          disabledKeyboardNavigation: true
        }
      )
    ] })
  ] });
};
const DateEntry$1 = compose(withInlineValidation, injectSheet(styles$k))(DateEntry);
const styles$j = () => ({
  radioBtnWrapper: {
    display: "flex",
    flexDirection: "column",
    "&[data-is-inline=true]": {
      flexDirection: "row"
    }
  },
  radioBtn: {
    padding: 7
  }
});
const Radio$1 = (props2) => {
  const {
    classes,
    id: id2,
    options,
    value = "",
    disabled,
    readonly,
    onChange,
    formContext
  } = props2;
  const { enumOptions, enumDisabled, inline } = options;
  const isLocked = isLockedWidget(id2, formContext.links);
  const disabledGroup = disabled || readonly || isLocked;
  const radioBtnWrapperProps = {
    className: classes.radioBtnWrapper,
    "data-is-inline": inline
  };
  return /* @__PURE__ */ jsx$1("div", { ...radioBtnWrapperProps, children: enumOptions.map((option2) => {
    const disabledOption = enumDisabled && enumDisabled.indexOf(option2.value) !== -1;
    if (enumOptions.length < 2)
      console.error(
        "Minimum 2 options should be added to radio buttons within the JSONSchema"
      );
    return /* @__PURE__ */ jsx$1("div", { className: classes.radioBtn, children: /* @__PURE__ */ jsx$1(
      RadioButton$1,
      {
        showLabel: true,
        label: option2.label,
        value: option2.label,
        disabled: disabledGroup || disabledOption,
        handleChange: () => onChange(option2.value),
        checked: option2.value === value
      }
    ) }, option2.label);
  }) });
};
const Radio$2 = compose(withInlineValidation, injectSheet(styles$j))(Radio$1);
class NumericInputWidget extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "handleFocus", ({ target: { value } }) => {
      this.props.onFocus(this.props.id, value);
    });
    __publicField(this, "handleBlur", ({ target: { value } }) => {
      this.props.onBlur(this.props.id, value);
    });
    __publicField(this, "handleChange", (value) => {
      this.props.onChange(value !== null ? value : "");
    });
  }
  render() {
    const {
      id: id2,
      placeholder,
      value,
      disabled,
      readonly: readOnly,
      autofocus: autoFocus
    } = this.props;
    const numericInputProps = {
      id: id2,
      placeholder,
      value,
      disabled,
      readOnly,
      autoFocus,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus
    };
    return /* @__PURE__ */ jsx$1(NumericInput$1, { ...numericInputProps });
  }
}
__publicField(NumericInputWidget, "defaultProps", {
  value: "",
  placeholder: "",
  required: false,
  disabled: false,
  readonly: false,
  autofocus: false,
  onChange: () => {
  },
  onBlur: () => {
  },
  onFocus: () => {
  }
});
const NumericWidget$2 = withInlineValidation(NumericInputWidget);
const CheckboxWidget$2 = ({ label, value, disabled, readonly, onChange, id: id2, formContext }) => /* @__PURE__ */ jsx$1(
  Check,
  {
    showLabel: true,
    label,
    checked: typeof value === "undefined" ? false : value,
    disabled: disabled || readonly || isLockedWidget(id2, formContext.links),
    handleChange: (event) => onChange(event.target.checked)
  }
);
const styles$i = (theme2) => ({
  richEditor: {},
  title: {
    fontSize: 16,
    fontWeight: 600,
    color: theme2.grey3,
    marginBottom: 3
  }
});
const isJson = (string3) => {
  try {
    JSON.parse(string3);
    return true;
  } catch (error2) {
    return false;
  }
};
const SlateReaderWidget = ({
  classes,
  value = "",
  label = "Comment",
  options = {
    withSubject: false,
    withMentions: false
  },
  formContext
}) => {
  const isJSON = isJson(value);
  if (label === "Answer") {
    return /* @__PURE__ */ jsx$1(
      RichEditor$1,
      {
        initialValue: value,
        withSubject: isJSON && options.withSubject,
        withMentions: isJSON && options.withMentions,
        readOnly: true,
        className: classes.richEditor,
        downloadImage: formContext.downloadImage
      }
    );
  }
  return /* @__PURE__ */ jsx$1(KeyValue$1, { label, children: /* @__PURE__ */ jsx$1(
    RichEditor$1,
    {
      initialValue: value,
      withSubject: isJSON && options.withSubject,
      withMentions: isJSON && options.withMentions,
      readOnly: true,
      className: classes.richEditor,
      downloadImage: formContext.downloadImage
    }
  ) });
};
const SlateReaderWidget$1 = injectSheet(styles$i)(SlateReaderWidget);
const styles$h = (theme2) => ({
  readerWrapper: {
    overflowY: "auto",
    minHeight: 84,
    maxHeight: 152,
    opacity: 0.5,
    border: `1px solid ${theme2.grey5}`,
    borderRadius: 2,
    padding: "8px 11px 9px 11px"
  }
});
const SlateWidget = ({
  classes,
  id: id2,
  value,
  formContext,
  placeholder,
  onChange,
  options = {
    withSubject: true,
    withMentions: false
  }
}) => {
  const isLocked = isLockedWidget(id2, formContext.links);
  if (isLocked)
    return /* @__PURE__ */ jsx$1("div", { className: classes.readerWrapper, children: /* @__PURE__ */ jsx$1(
      SlateReaderWidget$1,
      {
        downloadImage: formContext.downloadImage,
        value,
        schema: {}
      }
    ) });
  return /* @__PURE__ */ jsx$1(
    RichEditor$1,
    {
      subjectPlaceholder: placeholder || "Subject",
      placeholder: placeholder || "Enter your comment here.",
      initialValue: value,
      onChange,
      withSubject: options.withSubject,
      withMentions: options.withMentions,
      workflowContext: formContext.workflowContext,
      uploadImage: formContext.uploadImage,
      downloadImage: formContext.downloadImage
    }
  );
};
const SlateWidget$1 = withInlineValidation(injectSheet(styles$h)(SlateWidget));
const buildSelectableGroupsList = (workflowContext, options) => {
  const { includeAuthorGroup, blacklist = [] } = options || {};
  const { groups, author } = workflowContext;
  const filteredGroups = groups.filter(
    (group) => !blacklist.includes(group.label) && !(group.name && blacklist.includes(group.name)) && author && (includeAuthorGroup || group.label !== author.label)
  );
  return filteredGroups;
};
const getSelectedGroupDetails = (workflowContext, label) => {
  const { groups } = workflowContext;
  return groups.find((group) => group.label === label);
};
const workflowGroupCustomFormat = (workflowContext) => (value) => {
  if (!workflowContext) return true;
  const validGroups = buildSelectableGroupsList(workflowContext, {
    includeAuthorGroup: true
  });
  return !!validGroups.find((group) => group.label === value);
};
const GroupSelection = ({
  id: id2,
  onChange,
  value = "",
  disabled = false,
  invalid: invalid2 = false,
  formContext,
  schema
}) => {
  const isLocked = isLockedWidget(id2, formContext.links);
  const inputOptions = useMemo(() => {
    const groups = buildSelectableGroupsList(
      formContext.workflowContext,
      schema.formatOptions
    );
    return groups.map(({ label, name: name2, avatar }) => ({
      value: label,
      label: name2,
      prefix: /* @__PURE__ */ jsx$1(AvatarGroup$1, { src: avatar, size: 22 })
    }));
  }, [formContext.workflowContext, schema.formatOptions]);
  return /* @__PURE__ */ jsx$1(
    SmartDropdown$1,
    {
      id: id2,
      options: inputOptions,
      value,
      onSelect: onChange,
      label: schema.title,
      disabled: disabled || isLocked,
      invalid: invalid2,
      shadows: true
    }
  );
};
const GroupSelection$1 = withInlineValidation(memo(GroupSelection));
const widgets$1 = {
  CheckboxWidget: CheckboxWidget$2,
  CheckboxesWidget: CheckboxesWidget$3,
  draft: SlateWidget$1,
  NumericWidget: NumericWidget$2,
  RadioWidget: Radio$2,
  SelectWidget: SelectMenu$1,
  MultiSelectWidget: MultiSelectMenu$1,
  textarea: TextArea$1,
  TextWidget: TextInput$1,
  "alt-date": DateEntry$1,
  "workflow-group": GroupSelection$1
};
var dist = function(t3) {
  function n2(e5) {
    if (r2[e5]) return r2[e5].exports;
    var o2 = r2[e5] = { i: e5, l: false, exports: {} };
    return t3[e5].call(o2.exports, o2, o2.exports, n2), o2.l = true, o2.exports;
  }
  var r2 = {};
  return n2.m = t3, n2.c = r2, n2.d = function(t4, r3, e5) {
    n2.o(t4, r3) || Object.defineProperty(t4, r3, { configurable: false, enumerable: true, get: e5 });
  }, n2.n = function(t4) {
    var r3 = t4 && t4.__esModule ? function() {
      return t4.default;
    } : function() {
      return t4;
    };
    return n2.d(r3, "a", r3), r3;
  }, n2.o = function(t4, n3) {
    return Object.prototype.hasOwnProperty.call(t4, n3);
  }, n2.p = "", n2(n2.s = 13);
}([function(t3, n2) {
  var r2 = t3.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
  "number" == typeof __g && (__g = r2);
}, function(t3, n2) {
  t3.exports = function(t4) {
    return "object" == typeof t4 ? null !== t4 : "function" == typeof t4;
  };
}, function(t3, n2) {
  var r2 = t3.exports = { version: "2.5.0" };
  "number" == typeof __e && (__e = r2);
}, function(t3, n2, r2) {
  t3.exports = !r2(4)(function() {
    return 7 != Object.defineProperty({}, "a", { get: function() {
      return 7;
    } }).a;
  });
}, function(t3, n2) {
  t3.exports = function(t4) {
    try {
      return !!t4();
    } catch (t5) {
      return true;
    }
  };
}, function(t3, n2) {
  var r2 = {}.toString;
  t3.exports = function(t4) {
    return r2.call(t4).slice(8, -1);
  };
}, function(t3, n2, r2) {
  var e5 = r2(32)("wks"), o2 = r2(9), i3 = r2(0).Symbol, u3 = "function" == typeof i3;
  (t3.exports = function(t4) {
    return e5[t4] || (e5[t4] = u3 && i3[t4] || (u3 ? i3 : o2)("Symbol." + t4));
  }).store = e5;
}, function(t3, n2, r2) {
  var e5 = r2(0), o2 = r2(2), i3 = r2(8), u3 = r2(22), c3 = r2(10), f2 = function(t4, n3, r3) {
    var a4, s4, p2, l2, v2 = t4 & f2.F, y4 = t4 & f2.G, h4 = t4 & f2.S, d4 = t4 & f2.P, x3 = t4 & f2.B, g2 = y4 ? e5 : h4 ? e5[n3] || (e5[n3] = {}) : (e5[n3] || {}).prototype, m4 = y4 ? o2 : o2[n3] || (o2[n3] = {}), b3 = m4.prototype || (m4.prototype = {});
    y4 && (r3 = n3);
    for (a4 in r3) s4 = !v2 && g2 && void 0 !== g2[a4], p2 = (s4 ? g2 : r3)[a4], l2 = x3 && s4 ? c3(p2, e5) : d4 && "function" == typeof p2 ? c3(Function.call, p2) : p2, g2 && u3(g2, a4, p2, t4 & f2.U), m4[a4] != p2 && i3(m4, a4, l2), d4 && b3[a4] != p2 && (b3[a4] = p2);
  };
  e5.core = o2, f2.F = 1, f2.G = 2, f2.S = 4, f2.P = 8, f2.B = 16, f2.W = 32, f2.U = 64, f2.R = 128, t3.exports = f2;
}, function(t3, n2, r2) {
  var e5 = r2(16), o2 = r2(21);
  t3.exports = r2(3) ? function(t4, n3, r3) {
    return e5.f(t4, n3, o2(1, r3));
  } : function(t4, n3, r3) {
    return t4[n3] = r3, t4;
  };
}, function(t3, n2) {
  var r2 = 0, e5 = Math.random();
  t3.exports = function(t4) {
    return "Symbol(".concat(void 0 === t4 ? "" : t4, ")_", (++r2 + e5).toString(36));
  };
}, function(t3, n2, r2) {
  var e5 = r2(24);
  t3.exports = function(t4, n3, r3) {
    if (e5(t4), void 0 === n3) return t4;
    switch (r3) {
      case 1:
        return function(r4) {
          return t4.call(n3, r4);
        };
      case 2:
        return function(r4, e6) {
          return t4.call(n3, r4, e6);
        };
      case 3:
        return function(r4, e6, o2) {
          return t4.call(n3, r4, e6, o2);
        };
    }
    return function() {
      return t4.apply(n3, arguments);
    };
  };
}, function(t3, n2) {
  t3.exports = function(t4) {
    if (void 0 == t4) throw TypeError("Can't call method on  " + t4);
    return t4;
  };
}, function(t3, n2, r2) {
  var e5 = r2(28), o2 = Math.min;
  t3.exports = function(t4) {
    return t4 > 0 ? o2(e5(t4), 9007199254740991) : 0;
  };
}, function(t3, n2, r2) {
  n2.__esModule = true, n2.default = function(t4, n3) {
    if (t4 && n3) {
      var r3 = Array.isArray(n3) ? n3 : n3.split(","), e5 = t4.name || "", o2 = t4.type || "", i3 = o2.replace(/\/.*$/, "");
      return r3.some(function(t5) {
        var n4 = t5.trim();
        return "." === n4.charAt(0) ? e5.toLowerCase().endsWith(n4.toLowerCase()) : n4.endsWith("/*") ? i3 === n4.replace(/\/.*$/, "") : o2 === n4;
      });
    }
    return true;
  }, r2(14), r2(34);
}, function(t3, n2, r2) {
  r2(15), t3.exports = r2(2).Array.some;
}, function(t3, n2, r2) {
  var e5 = r2(7), o2 = r2(25)(3);
  e5(e5.P + e5.F * !r2(33)([].some, true), "Array", { some: function(t4) {
    return o2(this, t4, arguments[1]);
  } });
}, function(t3, n2, r2) {
  var e5 = r2(17), o2 = r2(18), i3 = r2(20), u3 = Object.defineProperty;
  n2.f = r2(3) ? Object.defineProperty : function(t4, n3, r3) {
    if (e5(t4), n3 = i3(n3, true), e5(r3), o2) try {
      return u3(t4, n3, r3);
    } catch (t5) {
    }
    if ("get" in r3 || "set" in r3) throw TypeError("Accessors not supported!");
    return "value" in r3 && (t4[n3] = r3.value), t4;
  };
}, function(t3, n2, r2) {
  var e5 = r2(1);
  t3.exports = function(t4) {
    if (!e5(t4)) throw TypeError(t4 + " is not an object!");
    return t4;
  };
}, function(t3, n2, r2) {
  t3.exports = !r2(3) && !r2(4)(function() {
    return 7 != Object.defineProperty(r2(19)("div"), "a", { get: function() {
      return 7;
    } }).a;
  });
}, function(t3, n2, r2) {
  var e5 = r2(1), o2 = r2(0).document, i3 = e5(o2) && e5(o2.createElement);
  t3.exports = function(t4) {
    return i3 ? o2.createElement(t4) : {};
  };
}, function(t3, n2, r2) {
  var e5 = r2(1);
  t3.exports = function(t4, n3) {
    if (!e5(t4)) return t4;
    var r3, o2;
    if (n3 && "function" == typeof (r3 = t4.toString) && !e5(o2 = r3.call(t4))) return o2;
    if ("function" == typeof (r3 = t4.valueOf) && !e5(o2 = r3.call(t4))) return o2;
    if (!n3 && "function" == typeof (r3 = t4.toString) && !e5(o2 = r3.call(t4))) return o2;
    throw TypeError("Can't convert object to primitive value");
  };
}, function(t3, n2) {
  t3.exports = function(t4, n3) {
    return { enumerable: !(1 & t4), configurable: !(2 & t4), writable: !(4 & t4), value: n3 };
  };
}, function(t3, n2, r2) {
  var e5 = r2(0), o2 = r2(8), i3 = r2(23), u3 = r2(9)("src"), c3 = Function.toString, f2 = ("" + c3).split("toString");
  r2(2).inspectSource = function(t4) {
    return c3.call(t4);
  }, (t3.exports = function(t4, n3, r3, c4) {
    var a4 = "function" == typeof r3;
    a4 && (i3(r3, "name") || o2(r3, "name", n3)), t4[n3] !== r3 && (a4 && (i3(r3, u3) || o2(r3, u3, t4[n3] ? "" + t4[n3] : f2.join(String(n3)))), t4 === e5 ? t4[n3] = r3 : c4 ? t4[n3] ? t4[n3] = r3 : o2(t4, n3, r3) : (delete t4[n3], o2(t4, n3, r3)));
  })(Function.prototype, "toString", function() {
    return "function" == typeof this && this[u3] || c3.call(this);
  });
}, function(t3, n2) {
  var r2 = {}.hasOwnProperty;
  t3.exports = function(t4, n3) {
    return r2.call(t4, n3);
  };
}, function(t3, n2) {
  t3.exports = function(t4) {
    if ("function" != typeof t4) throw TypeError(t4 + " is not a function!");
    return t4;
  };
}, function(t3, n2, r2) {
  var e5 = r2(10), o2 = r2(26), i3 = r2(27), u3 = r2(12), c3 = r2(29);
  t3.exports = function(t4, n3) {
    var r3 = 1 == t4, f2 = 2 == t4, a4 = 3 == t4, s4 = 4 == t4, p2 = 6 == t4, l2 = 5 == t4 || p2, v2 = n3 || c3;
    return function(n4, c4, y4) {
      for (var h4, d4, x3 = i3(n4), g2 = o2(x3), m4 = e5(c4, y4, 3), b3 = u3(g2.length), _2 = 0, w3 = r3 ? v2(n4, b3) : f2 ? v2(n4, 0) : void 0; b3 > _2; _2++) if ((l2 || _2 in g2) && (h4 = g2[_2], d4 = m4(h4, _2, x3), t4)) {
        if (r3) w3[_2] = d4;
        else if (d4) switch (t4) {
          case 3:
            return true;
          case 5:
            return h4;
          case 6:
            return _2;
          case 2:
            w3.push(h4);
        }
        else if (s4) return false;
      }
      return p2 ? -1 : a4 || s4 ? s4 : w3;
    };
  };
}, function(t3, n2, r2) {
  var e5 = r2(5);
  t3.exports = Object("z").propertyIsEnumerable(0) ? Object : function(t4) {
    return "String" == e5(t4) ? t4.split("") : Object(t4);
  };
}, function(t3, n2, r2) {
  var e5 = r2(11);
  t3.exports = function(t4) {
    return Object(e5(t4));
  };
}, function(t3, n2) {
  var r2 = Math.ceil, e5 = Math.floor;
  t3.exports = function(t4) {
    return isNaN(t4 = +t4) ? 0 : (t4 > 0 ? e5 : r2)(t4);
  };
}, function(t3, n2, r2) {
  var e5 = r2(30);
  t3.exports = function(t4, n3) {
    return new (e5(t4))(n3);
  };
}, function(t3, n2, r2) {
  var e5 = r2(1), o2 = r2(31), i3 = r2(6)("species");
  t3.exports = function(t4) {
    var n3;
    return o2(t4) && (n3 = t4.constructor, "function" != typeof n3 || n3 !== Array && !o2(n3.prototype) || (n3 = void 0), e5(n3) && null === (n3 = n3[i3]) && (n3 = void 0)), void 0 === n3 ? Array : n3;
  };
}, function(t3, n2, r2) {
  var e5 = r2(5);
  t3.exports = Array.isArray || function(t4) {
    return "Array" == e5(t4);
  };
}, function(t3, n2, r2) {
  var e5 = r2(0), o2 = e5["__core-js_shared__"] || (e5["__core-js_shared__"] = {});
  t3.exports = function(t4) {
    return o2[t4] || (o2[t4] = {});
  };
}, function(t3, n2, r2) {
  var e5 = r2(4);
  t3.exports = function(t4, n3) {
    return !!t4 && e5(function() {
      n3 ? t4.call(null, function() {
      }, 1) : t4.call(null);
    });
  };
}, function(t3, n2, r2) {
  r2(35), t3.exports = r2(2).String.endsWith;
}, function(t3, n2, r2) {
  var e5 = r2(7), o2 = r2(12), i3 = r2(36), u3 = "".endsWith;
  e5(e5.P + e5.F * r2(38)("endsWith"), "String", { endsWith: function(t4) {
    var n3 = i3(this, t4, "endsWith"), r3 = arguments.length > 1 ? arguments[1] : void 0, e6 = o2(n3.length), c3 = void 0 === r3 ? e6 : Math.min(o2(r3), e6), f2 = String(t4);
    return u3 ? u3.call(n3, f2, c3) : n3.slice(c3 - f2.length, c3) === f2;
  } });
}, function(t3, n2, r2) {
  var e5 = r2(37), o2 = r2(11);
  t3.exports = function(t4, n3, r3) {
    if (e5(n3)) throw TypeError("String#" + r3 + " doesn't accept regex!");
    return String(o2(t4));
  };
}, function(t3, n2, r2) {
  var e5 = r2(1), o2 = r2(5), i3 = r2(6)("match");
  t3.exports = function(t4) {
    var n3;
    return e5(t4) && (void 0 !== (n3 = t4[i3]) ? !!n3 : "RegExp" == o2(t4));
  };
}, function(t3, n2, r2) {
  var e5 = r2(6)("match");
  t3.exports = function(t4) {
    var n3 = /./;
    try {
      "/./"[t4](n3);
    } catch (r3) {
      try {
        return n3[e5] = false, !"/./"[t4](n3);
      } catch (t5) {
      }
    }
    return true;
  };
}]);
const accepts = /* @__PURE__ */ getDefaultExportFromCjs$1(dist);
var supportMultiple = typeof document !== "undefined" && document && document.createElement ? "multiple" in document.createElement("input") : true;
function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt2 = event.dataTransfer;
    if (dt2.files && dt2.files.length) {
      dataTransferItemsList = dt2.files;
    } else if (dt2.items && dt2.items.length) {
      dataTransferItemsList = dt2.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }
  return Array.prototype.slice.call(dataTransferItemsList);
}
function fileAccepted(file, accept) {
  return file.type === "application/x-moz-file" || accepts(file, accept);
}
function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}
function allFilesAccepted(files, accept) {
  return files.every(function(file) {
    return fileAccepted(file, accept);
  });
}
function onDocumentDragOver(evt) {
  evt.preventDefault();
}
function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
const styles$g = {
  rejected: {
    borderStyle: "solid",
    borderColor: "#c66",
    backgroundColor: "#eee"
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: "solid",
    borderColor: "#6c6",
    backgroundColor: "#eee"
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: "#666",
    borderStyle: "dashed",
    borderRadius: 5
  }
};
var _extends = Object.assign || function(target) {
  for (var i3 = 1; i3 < arguments.length; i3++) {
    var source = arguments[i3];
    for (var key2 in source) {
      if (Object.prototype.hasOwnProperty.call(source, key2)) {
        target[key2] = source[key2];
      }
    }
  }
  return target;
};
var _createClass = /* @__PURE__ */ function() {
  function defineProperties4(target, props2) {
    for (var i3 = 0; i3 < props2.length; i3++) {
      var descriptor2 = props2[i3];
      descriptor2.enumerable = descriptor2.enumerable || false;
      descriptor2.configurable = true;
      if ("value" in descriptor2) descriptor2.writable = true;
      Object.defineProperty(target, descriptor2.key, descriptor2);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties4(Constructor.prototype, protoProps);
    if (staticProps) defineProperties4(Constructor, staticProps);
    return Constructor;
  };
}();
function _objectWithoutProperties(obj, keys4) {
  var target = {};
  for (var i3 in obj) {
    if (keys4.indexOf(i3) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i3)) continue;
    target[i3] = obj[i3];
  }
  return target;
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i3 = 0, arr2 = Array(arr.length); i3 < arr.length; i3++) {
      arr2[i3] = arr[i3];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Dropzone = function(_React$Component) {
  _inherits(Dropzone2, _React$Component);
  function Dropzone2(props2, context) {
    _classCallCheck(this, Dropzone2);
    var _this = _possibleConstructorReturn(this, (Dropzone2.__proto__ || Object.getPrototypeOf(Dropzone2)).call(this, props2, context));
    _this.renderChildren = function(children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === "function") {
        return children(_extends({}, _this.state, {
          isDragActive,
          isDragAccept,
          isDragReject
        }));
      }
      return children;
    };
    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);
    _this.isFileDialogActive = false;
    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }
  _createClass(Dropzone2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;
      this.dragTargets = [];
      if (preventDropOnDocument) {
        document.addEventListener("dragover", onDocumentDragOver, false);
        document.addEventListener("drop", this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener("click", this.onInputElementClick, false);
      window.addEventListener("focus", this.onFileDialogCancel, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener("click", this.onInputElementClick, false);
      }
      window.removeEventListener("focus", this.onFileDialogCancel, false);
    }
  }, {
    key: "composeHandlers",
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }
      return handler;
    }
  }, {
    key: "onDocumentDrop",
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: "onDragEnter",
    value: function onDragEnter(evt) {
      var _this2 = this;
      evt.preventDefault();
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }
      Promise.resolve(this.props.getDataTransferItems(evt)).then(function(draggedFiles) {
        _this2.setState({
          isDragActive: true,
          // Do not rely on files for the drag state. It doesn't work in Safari.
          draggedFiles
        });
      });
      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: "onDragOver",
    value: function onDragOver(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      try {
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? "none" : "copy";
      } catch (err) {
      }
      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: "onDragLeave",
    value: function onDragLeave(evt) {
      var _this3 = this;
      evt.preventDefault();
      this.dragTargets = this.dragTargets.filter(function(el2) {
        return el2 !== evt.target && _this3.node.contains(el2);
      });
      if (this.dragTargets.length > 0) {
        return;
      }
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });
      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: "onDrop",
    value: function onDrop(evt) {
      var _this4 = this;
      var _props2 = this.props, onDrop2 = _props2.onDrop, onDropAccepted = _props2.onDropAccepted, onDropRejected = _props2.onDropRejected, multiple = _props2.multiple, disablePreview = _props2.disablePreview, accept = _props2.accept, getDataTransferItems2 = _props2.getDataTransferItems;
      evt.preventDefault();
      this.dragTargets = [];
      this.isFileDialogActive = false;
      this.draggedFiles = null;
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });
      Promise.resolve(getDataTransferItems2(evt)).then(function(fileList) {
        var acceptedFiles = [];
        var rejectedFiles = [];
        fileList.forEach(function(file) {
          if (!disablePreview) {
            try {
              file.preview = window.URL.createObjectURL(file);
            } catch (err) {
              if (process$1$1.env.NODE_ENV !== "production") {
                console.error("Failed to generate preview for file", file, err);
              }
            }
          }
          if (fileAccepted(file, accept) && fileMatchSize(file, _this4.props.maxSize, _this4.props.minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });
        if (!multiple) {
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
        }
        if (onDrop2) {
          onDrop2.call(_this4, acceptedFiles, rejectedFiles, evt);
        }
        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected.call(_this4, rejectedFiles, evt);
        }
        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted.call(_this4, acceptedFiles, evt);
        }
      });
    }
  }, {
    key: "onClick",
    value: function onClick(evt) {
      var _props2 = this.props, onClick2 = _props2.onClick, disableClick = _props2.disableClick;
      if (!disableClick) {
        evt.stopPropagation();
        if (onClick2) {
          onClick2.call(this, evt);
        }
        if (isIeOrEdge()) {
          setTimeout(this.open.bind(this), 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: "onInputElementClick",
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: "onFileDialogCancel",
    value: function onFileDialogCancel() {
      var _this5 = this;
      var onFileDialogCancel2 = this.props.onFileDialogCancel;
      if (this.isFileDialogActive) {
        setTimeout(function() {
          if (_this5.fileInputEl != null) {
            var files = _this5.fileInputEl.files;
            if (!files.length) {
              _this5.isFileDialogActive = false;
            }
          }
          if (typeof onFileDialogCancel2 === "function") {
            onFileDialogCancel2();
          }
        }, 300);
      }
    }
  }, {
    key: "setRef",
    value: function setRef3(ref2) {
      this.node = ref2;
    }
  }, {
    key: "setRefs",
    value: function setRefs(ref2) {
      this.fileInputEl = ref2;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */
  }, {
    key: "open",
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props, accept = _props3.accept, acceptClassName = _props3.acceptClassName, activeClassName = _props3.activeClassName, children = _props3.children, disabled = _props3.disabled, disabledClassName = _props3.disabledClassName, inputProps = _props3.inputProps, multiple = _props3.multiple, name2 = _props3.name, rejectClassName = _props3.rejectClassName, rest = _objectWithoutProperties(_props3, ["accept", "acceptClassName", "activeClassName", "children", "disabled", "disabledClassName", "inputProps", "multiple", "name", "rejectClassName"]);
      var acceptStyle = rest.acceptStyle, activeStyle = rest.activeStyle, _rest$className = rest.className, className = _rest$className === void 0 ? "" : _rest$className, disabledStyle = rest.disabledStyle, rejectStyle = rest.rejectStyle, style2 = rest.style, props2 = _objectWithoutProperties(rest, ["acceptStyle", "activeStyle", "className", "disabledStyle", "rejectStyle", "style"]);
      var _state = this.state, isDragActive = _state.isDragActive, draggedFiles = _state.draggedFiles;
      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && allFilesAccepted(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style2 && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;
      if (isDragActive && activeClassName) {
        className += " " + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += " " + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += " " + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += " " + disabledClassName;
      }
      if (noStyles) {
        style2 = styles$g.default;
        activeStyle = styles$g.active;
        acceptStyle = styles$g.active;
        rejectStyle = styles$g.rejected;
        disabledStyle = styles$g.disabled;
      }
      var appliedStyle = _extends({ position: "relative" }, style2);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }
      var inputAttributes = {
        accept,
        disabled,
        type: "file",
        style: _extends({
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 1e-5,
          pointerEvents: "none"
        }, inputProps.style),
        multiple: supportMultiple && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: "off"
      };
      if (name2 && name2.length) {
        inputAttributes.name = name2;
      }
      props2.acceptedFiles;
      props2.preventDropOnDocument;
      props2.disablePreview;
      props2.disableClick;
      props2.onDropAccepted;
      props2.onDropRejected;
      props2.onFileDialogCancel;
      props2.maxSize;
      props2.minSize;
      props2.getDataTransferItems;
      var divProps = _objectWithoutProperties(props2, ["acceptedFiles", "preventDropOnDocument", "disablePreview", "disableClick", "onDropAccepted", "onDropRejected", "onFileDialogCancel", "maxSize", "minSize", "getDataTransferItems"]);
      return React__default.createElement(
        "div",
        _extends({
          className,
          style: appliedStyle
        }, divProps, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          "aria-disabled": disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        React__default.createElement("input", _extends({}, inputProps, inputAttributes))
      );
    }
  }]);
  return Dropzone2;
}(React__default.Component);
Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(PropTypes$1.string)]),
  /**
   * Contents of the dropzone
   */
  children: PropTypes$1.oneOfType([PropTypes$1.node, PropTypes$1.func]),
  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: PropTypes$1.bool,
  /**
   * Enable/disable the dropzone entirely
   */
  disabled: PropTypes$1.bool,
  /**
   * Enable/disable preview generation
   */
  disablePreview: PropTypes$1.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes$1.bool,
  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: PropTypes$1.object,
  /**
   * Allow dropping multiple files
   */
  multiple: PropTypes$1.bool,
  /**
   * `name` attribute for the input tag
   */
  name: PropTypes$1.string,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes$1.number,
  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes$1.number,
  /**
   * className
   */
  className: PropTypes$1.string,
  /**
   * className to apply when drag is active
   */
  activeClassName: PropTypes$1.string,
  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: PropTypes$1.string,
  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: PropTypes$1.string,
  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: PropTypes$1.string,
  /**
   * CSS styles to apply
   */
  style: PropTypes$1.object,
  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: PropTypes$1.object,
  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: PropTypes$1.object,
  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: PropTypes$1.object,
  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: PropTypes$1.object,
  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: PropTypes$1.func,
  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: PropTypes$1.func,
  /**
   * onDrop callback
   */
  onDrop: PropTypes$1.func,
  /**
   * onDropAccepted callback
   */
  onDropAccepted: PropTypes$1.func,
  /**
   * onDropRejected callback
   */
  onDropRejected: PropTypes$1.func,
  /**
   * onDragStart callback
   */
  onDragStart: PropTypes$1.func,
  /**
   * onDragEnter callback
   */
  onDragEnter: PropTypes$1.func,
  /**
   * onDragOver callback
   */
  onDragOver: PropTypes$1.func,
  /**
   * onDragLeave callback
   */
  onDragLeave: PropTypes$1.func,
  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: PropTypes$1.func
};
Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems
};
var filesize_min = { exports: {} };
/*!
 2020 Jason Mulligan <jason.mulligan@avoidwork.com>
 @version 6.4.0
*/
(function(module2, exports) {
  !function(e5, i3) {
    module2.exports = i3();
  }(commonjsGlobal, function() {
    var e5 = /^(b|B)$/, i3 = { iec: { bits: ["b", "Kib", "Mib", "Gib", "Tib", "Pib", "Eib", "Zib", "Yib"], bytes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"] }, jedec: { bits: ["b", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb"], bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] } }, t3 = { iec: ["", "kibi", "mebi", "gibi", "tebi", "pebi", "exbi", "zebi", "yobi"], jedec: ["", "kilo", "mega", "giga", "tera", "peta", "exa", "zetta", "yotta"] }, o2 = { floor: Math.floor, ceil: Math.ceil };
    function n2(n3) {
      var r2, a4, b3, l2, s4, c3, d4, f2, p2, u3, B3, h4, g2, y4, M4, m4, v2, x3, N2, j2, T3, E3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, w3 = [], P2 = 0;
      if (isNaN(n3)) throw new TypeError("Invalid number");
      if (b3 = true === E3.bits, M4 = true === E3.unix, h4 = true === E3.pad, a4 = E3.base || 2, g2 = void 0 !== E3.round ? E3.round : M4 ? 1 : 2, d4 = void 0 !== E3.locale ? E3.locale : "", f2 = E3.localeOptions || {}, m4 = void 0 !== E3.separator ? E3.separator : "", v2 = void 0 !== E3.spacer ? E3.spacer : M4 ? "" : " ", N2 = E3.symbols || {}, x3 = 2 === a4 && E3.standard || "jedec", B3 = E3.output || "string", s4 = true === E3.fullform, c3 = E3.fullforms instanceof Array ? E3.fullforms : [], r2 = void 0 !== E3.exponent ? E3.exponent : -1, j2 = o2[E3.roundingMethod] || Math.round, p2 = (u3 = Number(n3)) < 0, l2 = a4 > 2 ? 1e3 : 1024, T3 = false === isNaN(E3.precision) ? parseInt(E3.precision, 10) : 0, p2 && (u3 = -u3), (-1 === r2 || isNaN(r2)) && (r2 = Math.floor(Math.log(u3) / Math.log(l2))) < 0 && (r2 = 0), r2 > 8 && (T3 > 0 && (T3 += 8 - r2), r2 = 8), "exponent" === B3) return r2;
      if (0 === u3) w3[0] = 0, y4 = w3[1] = M4 ? "" : i3[x3][b3 ? "bits" : "bytes"][r2];
      else {
        P2 = u3 / (2 === a4 ? Math.pow(2, 10 * r2) : Math.pow(1e3, r2)), b3 && (P2 *= 8) >= l2 && r2 < 8 && (P2 /= l2, r2++);
        var k3 = Math.pow(10, r2 > 0 ? g2 : 0);
        w3[0] = j2(P2 * k3) / k3, w3[0] === l2 && r2 < 8 && void 0 === E3.exponent && (w3[0] = 1, r2++), y4 = w3[1] = 10 === a4 && 1 === r2 ? b3 ? "kb" : "kB" : i3[x3][b3 ? "bits" : "bytes"][r2], M4 && (w3[1] = "jedec" === x3 ? w3[1].charAt(0) : r2 > 0 ? w3[1].replace(/B$/, "") : w3[1], e5.test(w3[1]) && (w3[0] = Math.floor(w3[0]), w3[1] = ""));
      }
      if (p2 && (w3[0] = -w3[0]), T3 > 0 && (w3[0] = w3[0].toPrecision(T3)), w3[1] = N2[w3[1]] || w3[1], true === d4 ? w3[0] = w3[0].toLocaleString() : d4.length > 0 ? w3[0] = w3[0].toLocaleString(d4, f2) : m4.length > 0 && (w3[0] = w3[0].toString().replace(".", m4)), h4 && false === Number.isInteger(w3[0]) && g2 > 0) {
        var G3 = m4 || ".", K3 = w3[0].toString().split(G3), S4 = K3[1] || "", Y3 = S4.length, Z2 = g2 - Y3;
        w3[0] = "".concat(K3[0]).concat(G3).concat(S4.padEnd(Y3 + Z2, "0"));
      }
      return s4 && (w3[1] = c3[r2] ? c3[r2] : t3[x3][r2] + (b3 ? "bit" : "byte") + (1 === w3[0] ? "" : "s")), "array" === B3 ? w3 : "object" === B3 ? { value: w3[0], symbol: w3[1], exponent: r2, unit: y4 } : w3.join(v2);
    }
    return n2.partial = function(e6) {
      return function(i4) {
        return n2(i4, e6);
      };
    }, n2;
  });
})(filesize_min);
var filesize_minExports = filesize_min.exports;
const filesize = /* @__PURE__ */ getDefaultExportFromCjs$1(filesize_minExports);
var lib = { exports: {} };
var seed = 1;
function getNextValue() {
  seed = (seed * 9301 + 49297) % 233280;
  return seed / 233280;
}
function setSeed$1(_seed_) {
  seed = _seed_;
}
var randomFromSeed$1 = {
  nextValue: getNextValue,
  seed: setSeed$1
};
var randomFromSeed = randomFromSeed$1;
var ORIGINAL = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-";
var alphabet$2;
var previousSeed;
var shuffled;
function reset() {
  shuffled = false;
}
function setCharacters(_alphabet_) {
  if (!_alphabet_) {
    if (alphabet$2 !== ORIGINAL) {
      alphabet$2 = ORIGINAL;
      reset();
    }
    return;
  }
  if (_alphabet_ === alphabet$2) {
    return;
  }
  if (_alphabet_.length !== ORIGINAL.length) {
    throw new Error("Custom alphabet for shortid must be " + ORIGINAL.length + " unique characters. You submitted " + _alphabet_.length + " characters: " + _alphabet_);
  }
  var unique = _alphabet_.split("").filter(function(item, ind, arr) {
    return ind !== arr.lastIndexOf(item);
  });
  if (unique.length) {
    throw new Error("Custom alphabet for shortid must be " + ORIGINAL.length + " unique characters. These characters were not unique: " + unique.join(", "));
  }
  alphabet$2 = _alphabet_;
  reset();
}
function characters(_alphabet_) {
  setCharacters(_alphabet_);
  return alphabet$2;
}
function setSeed(seed2) {
  randomFromSeed.seed(seed2);
  if (previousSeed !== seed2) {
    reset();
    previousSeed = seed2;
  }
}
function shuffle() {
  if (!alphabet$2) {
    setCharacters(ORIGINAL);
  }
  var sourceArray = alphabet$2.split("");
  var targetArray = [];
  var r2 = randomFromSeed.nextValue();
  var characterIndex;
  while (sourceArray.length > 0) {
    r2 = randomFromSeed.nextValue();
    characterIndex = Math.floor(r2 * sourceArray.length);
    targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
  }
  return targetArray.join("");
}
function getShuffled() {
  if (shuffled) {
    return shuffled;
  }
  shuffled = shuffle();
  return shuffled;
}
function lookup(index2) {
  var alphabetShuffled = getShuffled();
  return alphabetShuffled[index2];
}
function get() {
  return alphabet$2 || ORIGINAL;
}
var alphabet_1 = {
  get,
  characters,
  seed: setSeed,
  lookup,
  shuffled: getShuffled
};
var crypto$1 = typeof window === "object" && (window.crypto || window.msCrypto);
var randomByte;
if (!crypto$1 || !crypto$1.getRandomValues) {
  randomByte = function(size2) {
    var bytes = [];
    for (var i3 = 0; i3 < size2; i3++) {
      bytes.push(Math.floor(Math.random() * 256));
    }
    return bytes;
  };
} else {
  randomByte = function(size2) {
    return crypto$1.getRandomValues(new Uint8Array(size2));
  };
}
var randomByteBrowser = randomByte;
var format_browser = function(random2, alphabet2, size2) {
  var mask = (2 << Math.log(alphabet2.length - 1) / Math.LN2) - 1;
  var step2 = -~(1.6 * mask * size2 / alphabet2.length);
  var id2 = "";
  while (true) {
    var bytes = random2(step2);
    var i3 = step2;
    while (i3--) {
      id2 += alphabet2[bytes[i3] & mask] || "";
      if (id2.length === +size2) return id2;
    }
  }
};
var alphabet$1 = alphabet_1;
var random = randomByteBrowser;
var format2 = format_browser;
function generate$1(number) {
  var loopCounter = 0;
  var done;
  var str = "";
  while (!done) {
    str = str + format2(random, alphabet$1.get(), 1);
    done = number < Math.pow(16, loopCounter + 1);
    loopCounter++;
  }
  return str;
}
var generate_1 = generate$1;
var generate = generate_1;
var REDUCE_TIME = 1567752802062;
var version = 7;
var counter;
var previousSeconds;
function build(clusterWorkerId) {
  var str = "";
  var seconds2 = Math.floor((Date.now() - REDUCE_TIME) * 1e-3);
  if (seconds2 === previousSeconds) {
    counter++;
  } else {
    counter = 0;
    previousSeconds = seconds2;
  }
  str = str + generate(version);
  str = str + generate(clusterWorkerId);
  if (counter > 0) {
    str = str + generate(counter);
  }
  str = str + generate(seconds2);
  return str;
}
var build_1 = build;
var alphabet = alphabet_1;
function isShortId(id2) {
  if (!id2 || typeof id2 !== "string" || id2.length < 6) {
    return false;
  }
  var nonAlphabetic = new RegExp("[^" + alphabet.get().replace(/[|\\{}()[\]^$+*?.-]/g, "\\$&") + "]");
  return !nonAlphabetic.test(id2);
}
var isValid = isShortId;
(function(module2) {
  var alphabet2 = alphabet_1;
  var build2 = build_1;
  var isValid$12 = isValid;
  var clusterWorkerId = 0;
  function seed2(seedValue) {
    alphabet2.seed(seedValue);
    return module2.exports;
  }
  function worker(workerId) {
    clusterWorkerId = workerId;
    return module2.exports;
  }
  function characters2(newCharacters) {
    if (newCharacters !== void 0) {
      alphabet2.characters(newCharacters);
    }
    return alphabet2.shuffled();
  }
  function generate2() {
    return build2(clusterWorkerId);
  }
  module2.exports = generate2;
  module2.exports.generate = generate2;
  module2.exports.seed = seed2;
  module2.exports.worker = worker;
  module2.exports.characters = characters2;
  module2.exports.isValid = isValid$12;
})(lib);
var libExports = lib.exports;
var shortid = libExports;
const shortid$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(shortid);
var mimeTypes = {};
const require$$0 = {
  "application/1d-interleaved-parityfec": {
    source: "iana"
  },
  "application/3gpdash-qoe-report+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/3gpp-ims+xml": {
    source: "iana",
    compressible: true
  },
  "application/3gpphal+json": {
    source: "iana",
    compressible: true
  },
  "application/3gpphalforms+json": {
    source: "iana",
    compressible: true
  },
  "application/a2l": {
    source: "iana"
  },
  "application/ace+cbor": {
    source: "iana"
  },
  "application/activemessage": {
    source: "iana"
  },
  "application/activity+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-costmap+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-costmapfilter+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-directory+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-endpointcost+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-endpointcostparams+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-endpointprop+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-endpointpropparams+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-error+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-networkmap+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-networkmapfilter+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-updatestreamcontrol+json": {
    source: "iana",
    compressible: true
  },
  "application/alto-updatestreamparams+json": {
    source: "iana",
    compressible: true
  },
  "application/aml": {
    source: "iana"
  },
  "application/andrew-inset": {
    source: "iana",
    extensions: [
      "ez"
    ]
  },
  "application/applefile": {
    source: "iana"
  },
  "application/applixware": {
    source: "apache",
    extensions: [
      "aw"
    ]
  },
  "application/at+jwt": {
    source: "iana"
  },
  "application/atf": {
    source: "iana"
  },
  "application/atfx": {
    source: "iana"
  },
  "application/atom+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "atom"
    ]
  },
  "application/atomcat+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "atomcat"
    ]
  },
  "application/atomdeleted+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "atomdeleted"
    ]
  },
  "application/atomicmail": {
    source: "iana"
  },
  "application/atomsvc+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "atomsvc"
    ]
  },
  "application/atsc-dwd+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "dwd"
    ]
  },
  "application/atsc-dynamic-event-message": {
    source: "iana"
  },
  "application/atsc-held+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "held"
    ]
  },
  "application/atsc-rdt+json": {
    source: "iana",
    compressible: true
  },
  "application/atsc-rsat+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rsat"
    ]
  },
  "application/atxml": {
    source: "iana"
  },
  "application/auth-policy+xml": {
    source: "iana",
    compressible: true
  },
  "application/bacnet-xdd+zip": {
    source: "iana",
    compressible: false
  },
  "application/batch-smtp": {
    source: "iana"
  },
  "application/bdoc": {
    compressible: false,
    extensions: [
      "bdoc"
    ]
  },
  "application/beep+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/calendar+json": {
    source: "iana",
    compressible: true
  },
  "application/calendar+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xcs"
    ]
  },
  "application/call-completion": {
    source: "iana"
  },
  "application/cals-1840": {
    source: "iana"
  },
  "application/captive+json": {
    source: "iana",
    compressible: true
  },
  "application/cbor": {
    source: "iana"
  },
  "application/cbor-seq": {
    source: "iana"
  },
  "application/cccex": {
    source: "iana"
  },
  "application/ccmp+xml": {
    source: "iana",
    compressible: true
  },
  "application/ccxml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "ccxml"
    ]
  },
  "application/cdfx+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "cdfx"
    ]
  },
  "application/cdmi-capability": {
    source: "iana",
    extensions: [
      "cdmia"
    ]
  },
  "application/cdmi-container": {
    source: "iana",
    extensions: [
      "cdmic"
    ]
  },
  "application/cdmi-domain": {
    source: "iana",
    extensions: [
      "cdmid"
    ]
  },
  "application/cdmi-object": {
    source: "iana",
    extensions: [
      "cdmio"
    ]
  },
  "application/cdmi-queue": {
    source: "iana",
    extensions: [
      "cdmiq"
    ]
  },
  "application/cdni": {
    source: "iana"
  },
  "application/cea": {
    source: "iana"
  },
  "application/cea-2018+xml": {
    source: "iana",
    compressible: true
  },
  "application/cellml+xml": {
    source: "iana",
    compressible: true
  },
  "application/cfw": {
    source: "iana"
  },
  "application/city+json": {
    source: "iana",
    compressible: true
  },
  "application/clr": {
    source: "iana"
  },
  "application/clue+xml": {
    source: "iana",
    compressible: true
  },
  "application/clue_info+xml": {
    source: "iana",
    compressible: true
  },
  "application/cms": {
    source: "iana"
  },
  "application/cnrp+xml": {
    source: "iana",
    compressible: true
  },
  "application/coap-group+json": {
    source: "iana",
    compressible: true
  },
  "application/coap-payload": {
    source: "iana"
  },
  "application/commonground": {
    source: "iana"
  },
  "application/conference-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/cose": {
    source: "iana"
  },
  "application/cose-key": {
    source: "iana"
  },
  "application/cose-key-set": {
    source: "iana"
  },
  "application/cpl+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "cpl"
    ]
  },
  "application/csrattrs": {
    source: "iana"
  },
  "application/csta+xml": {
    source: "iana",
    compressible: true
  },
  "application/cstadata+xml": {
    source: "iana",
    compressible: true
  },
  "application/csvm+json": {
    source: "iana",
    compressible: true
  },
  "application/cu-seeme": {
    source: "apache",
    extensions: [
      "cu"
    ]
  },
  "application/cwt": {
    source: "iana"
  },
  "application/cybercash": {
    source: "iana"
  },
  "application/dart": {
    compressible: true
  },
  "application/dash+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mpd"
    ]
  },
  "application/dash-patch+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mpp"
    ]
  },
  "application/dashdelta": {
    source: "iana"
  },
  "application/davmount+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "davmount"
    ]
  },
  "application/dca-rft": {
    source: "iana"
  },
  "application/dcd": {
    source: "iana"
  },
  "application/dec-dx": {
    source: "iana"
  },
  "application/dialog-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/dicom": {
    source: "iana"
  },
  "application/dicom+json": {
    source: "iana",
    compressible: true
  },
  "application/dicom+xml": {
    source: "iana",
    compressible: true
  },
  "application/dii": {
    source: "iana"
  },
  "application/dit": {
    source: "iana"
  },
  "application/dns": {
    source: "iana"
  },
  "application/dns+json": {
    source: "iana",
    compressible: true
  },
  "application/dns-message": {
    source: "iana"
  },
  "application/docbook+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "dbk"
    ]
  },
  "application/dots+cbor": {
    source: "iana"
  },
  "application/dskpp+xml": {
    source: "iana",
    compressible: true
  },
  "application/dssc+der": {
    source: "iana",
    extensions: [
      "dssc"
    ]
  },
  "application/dssc+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xdssc"
    ]
  },
  "application/dvcs": {
    source: "iana"
  },
  "application/ecmascript": {
    source: "iana",
    compressible: true,
    extensions: [
      "es",
      "ecma"
    ]
  },
  "application/edi-consent": {
    source: "iana"
  },
  "application/edi-x12": {
    source: "iana",
    compressible: false
  },
  "application/edifact": {
    source: "iana",
    compressible: false
  },
  "application/efi": {
    source: "iana"
  },
  "application/elm+json": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/elm+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.cap+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/emergencycalldata.comment+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.control+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.deviceinfo+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.ecall.msd": {
    source: "iana"
  },
  "application/emergencycalldata.providerinfo+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.serviceinfo+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.subscriberinfo+xml": {
    source: "iana",
    compressible: true
  },
  "application/emergencycalldata.veds+xml": {
    source: "iana",
    compressible: true
  },
  "application/emma+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "emma"
    ]
  },
  "application/emotionml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "emotionml"
    ]
  },
  "application/encaprtp": {
    source: "iana"
  },
  "application/epp+xml": {
    source: "iana",
    compressible: true
  },
  "application/epub+zip": {
    source: "iana",
    compressible: false,
    extensions: [
      "epub"
    ]
  },
  "application/eshop": {
    source: "iana"
  },
  "application/exi": {
    source: "iana",
    extensions: [
      "exi"
    ]
  },
  "application/expect-ct-report+json": {
    source: "iana",
    compressible: true
  },
  "application/express": {
    source: "iana",
    extensions: [
      "exp"
    ]
  },
  "application/fastinfoset": {
    source: "iana"
  },
  "application/fastsoap": {
    source: "iana"
  },
  "application/fdt+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "fdt"
    ]
  },
  "application/fhir+json": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/fhir+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/fido.trusted-apps+json": {
    compressible: true
  },
  "application/fits": {
    source: "iana"
  },
  "application/flexfec": {
    source: "iana"
  },
  "application/font-sfnt": {
    source: "iana"
  },
  "application/font-tdpfr": {
    source: "iana",
    extensions: [
      "pfr"
    ]
  },
  "application/font-woff": {
    source: "iana",
    compressible: false
  },
  "application/framework-attributes+xml": {
    source: "iana",
    compressible: true
  },
  "application/geo+json": {
    source: "iana",
    compressible: true,
    extensions: [
      "geojson"
    ]
  },
  "application/geo+json-seq": {
    source: "iana"
  },
  "application/geopackage+sqlite3": {
    source: "iana"
  },
  "application/geoxacml+xml": {
    source: "iana",
    compressible: true
  },
  "application/gltf-buffer": {
    source: "iana"
  },
  "application/gml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "gml"
    ]
  },
  "application/gpx+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "gpx"
    ]
  },
  "application/gxf": {
    source: "apache",
    extensions: [
      "gxf"
    ]
  },
  "application/gzip": {
    source: "iana",
    compressible: false,
    extensions: [
      "gz"
    ]
  },
  "application/h224": {
    source: "iana"
  },
  "application/held+xml": {
    source: "iana",
    compressible: true
  },
  "application/hjson": {
    extensions: [
      "hjson"
    ]
  },
  "application/http": {
    source: "iana"
  },
  "application/hyperstudio": {
    source: "iana",
    extensions: [
      "stk"
    ]
  },
  "application/ibe-key-request+xml": {
    source: "iana",
    compressible: true
  },
  "application/ibe-pkg-reply+xml": {
    source: "iana",
    compressible: true
  },
  "application/ibe-pp-data": {
    source: "iana"
  },
  "application/iges": {
    source: "iana"
  },
  "application/im-iscomposing+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/index": {
    source: "iana"
  },
  "application/index.cmd": {
    source: "iana"
  },
  "application/index.obj": {
    source: "iana"
  },
  "application/index.response": {
    source: "iana"
  },
  "application/index.vnd": {
    source: "iana"
  },
  "application/inkml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "ink",
      "inkml"
    ]
  },
  "application/iotp": {
    source: "iana"
  },
  "application/ipfix": {
    source: "iana",
    extensions: [
      "ipfix"
    ]
  },
  "application/ipp": {
    source: "iana"
  },
  "application/isup": {
    source: "iana"
  },
  "application/its+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "its"
    ]
  },
  "application/java-archive": {
    source: "apache",
    compressible: false,
    extensions: [
      "jar",
      "war",
      "ear"
    ]
  },
  "application/java-serialized-object": {
    source: "apache",
    compressible: false,
    extensions: [
      "ser"
    ]
  },
  "application/java-vm": {
    source: "apache",
    compressible: false,
    extensions: [
      "class"
    ]
  },
  "application/javascript": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "js",
      "mjs"
    ]
  },
  "application/jf2feed+json": {
    source: "iana",
    compressible: true
  },
  "application/jose": {
    source: "iana"
  },
  "application/jose+json": {
    source: "iana",
    compressible: true
  },
  "application/jrd+json": {
    source: "iana",
    compressible: true
  },
  "application/jscalendar+json": {
    source: "iana",
    compressible: true
  },
  "application/json": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "json",
      "map"
    ]
  },
  "application/json-patch+json": {
    source: "iana",
    compressible: true
  },
  "application/json-seq": {
    source: "iana"
  },
  "application/json5": {
    extensions: [
      "json5"
    ]
  },
  "application/jsonml+json": {
    source: "apache",
    compressible: true,
    extensions: [
      "jsonml"
    ]
  },
  "application/jwk+json": {
    source: "iana",
    compressible: true
  },
  "application/jwk-set+json": {
    source: "iana",
    compressible: true
  },
  "application/jwt": {
    source: "iana"
  },
  "application/kpml-request+xml": {
    source: "iana",
    compressible: true
  },
  "application/kpml-response+xml": {
    source: "iana",
    compressible: true
  },
  "application/ld+json": {
    source: "iana",
    compressible: true,
    extensions: [
      "jsonld"
    ]
  },
  "application/lgr+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "lgr"
    ]
  },
  "application/link-format": {
    source: "iana"
  },
  "application/load-control+xml": {
    source: "iana",
    compressible: true
  },
  "application/lost+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "lostxml"
    ]
  },
  "application/lostsync+xml": {
    source: "iana",
    compressible: true
  },
  "application/lpf+zip": {
    source: "iana",
    compressible: false
  },
  "application/lxf": {
    source: "iana"
  },
  "application/mac-binhex40": {
    source: "iana",
    extensions: [
      "hqx"
    ]
  },
  "application/mac-compactpro": {
    source: "apache",
    extensions: [
      "cpt"
    ]
  },
  "application/macwriteii": {
    source: "iana"
  },
  "application/mads+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mads"
    ]
  },
  "application/manifest+json": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "webmanifest"
    ]
  },
  "application/marc": {
    source: "iana",
    extensions: [
      "mrc"
    ]
  },
  "application/marcxml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mrcx"
    ]
  },
  "application/mathematica": {
    source: "iana",
    extensions: [
      "ma",
      "nb",
      "mb"
    ]
  },
  "application/mathml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mathml"
    ]
  },
  "application/mathml-content+xml": {
    source: "iana",
    compressible: true
  },
  "application/mathml-presentation+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-associated-procedure-description+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-deregister+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-envelope+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-msk+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-msk-response+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-protection-description+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-reception-report+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-register+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-register-response+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-schedule+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbms-user-service-description+xml": {
    source: "iana",
    compressible: true
  },
  "application/mbox": {
    source: "iana",
    extensions: [
      "mbox"
    ]
  },
  "application/media-policy-dataset+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mpf"
    ]
  },
  "application/media_control+xml": {
    source: "iana",
    compressible: true
  },
  "application/mediaservercontrol+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mscml"
    ]
  },
  "application/merge-patch+json": {
    source: "iana",
    compressible: true
  },
  "application/metalink+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "metalink"
    ]
  },
  "application/metalink4+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "meta4"
    ]
  },
  "application/mets+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mets"
    ]
  },
  "application/mf4": {
    source: "iana"
  },
  "application/mikey": {
    source: "iana"
  },
  "application/mipc": {
    source: "iana"
  },
  "application/missing-blocks+cbor-seq": {
    source: "iana"
  },
  "application/mmt-aei+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "maei"
    ]
  },
  "application/mmt-usd+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "musd"
    ]
  },
  "application/mods+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mods"
    ]
  },
  "application/moss-keys": {
    source: "iana"
  },
  "application/moss-signature": {
    source: "iana"
  },
  "application/mosskey-data": {
    source: "iana"
  },
  "application/mosskey-request": {
    source: "iana"
  },
  "application/mp21": {
    source: "iana",
    extensions: [
      "m21",
      "mp21"
    ]
  },
  "application/mp4": {
    source: "iana",
    extensions: [
      "mp4s",
      "m4p"
    ]
  },
  "application/mpeg4-generic": {
    source: "iana"
  },
  "application/mpeg4-iod": {
    source: "iana"
  },
  "application/mpeg4-iod-xmt": {
    source: "iana"
  },
  "application/mrb-consumer+xml": {
    source: "iana",
    compressible: true
  },
  "application/mrb-publish+xml": {
    source: "iana",
    compressible: true
  },
  "application/msc-ivr+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/msc-mixer+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/msword": {
    source: "iana",
    compressible: false,
    extensions: [
      "doc",
      "dot"
    ]
  },
  "application/mud+json": {
    source: "iana",
    compressible: true
  },
  "application/multipart-core": {
    source: "iana"
  },
  "application/mxf": {
    source: "iana",
    extensions: [
      "mxf"
    ]
  },
  "application/n-quads": {
    source: "iana",
    extensions: [
      "nq"
    ]
  },
  "application/n-triples": {
    source: "iana",
    extensions: [
      "nt"
    ]
  },
  "application/nasdata": {
    source: "iana"
  },
  "application/news-checkgroups": {
    source: "iana",
    charset: "US-ASCII"
  },
  "application/news-groupinfo": {
    source: "iana",
    charset: "US-ASCII"
  },
  "application/news-transmission": {
    source: "iana"
  },
  "application/nlsml+xml": {
    source: "iana",
    compressible: true
  },
  "application/node": {
    source: "iana",
    extensions: [
      "cjs"
    ]
  },
  "application/nss": {
    source: "iana"
  },
  "application/oauth-authz-req+jwt": {
    source: "iana"
  },
  "application/oblivious-dns-message": {
    source: "iana"
  },
  "application/ocsp-request": {
    source: "iana"
  },
  "application/ocsp-response": {
    source: "iana"
  },
  "application/octet-stream": {
    source: "iana",
    compressible: false,
    extensions: [
      "bin",
      "dms",
      "lrf",
      "mar",
      "so",
      "dist",
      "distz",
      "pkg",
      "bpk",
      "dump",
      "elc",
      "deploy",
      "exe",
      "dll",
      "deb",
      "dmg",
      "iso",
      "img",
      "msi",
      "msp",
      "msm",
      "buffer"
    ]
  },
  "application/oda": {
    source: "iana",
    extensions: [
      "oda"
    ]
  },
  "application/odm+xml": {
    source: "iana",
    compressible: true
  },
  "application/odx": {
    source: "iana"
  },
  "application/oebps-package+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "opf"
    ]
  },
  "application/ogg": {
    source: "iana",
    compressible: false,
    extensions: [
      "ogx"
    ]
  },
  "application/omdoc+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "omdoc"
    ]
  },
  "application/onenote": {
    source: "apache",
    extensions: [
      "onetoc",
      "onetoc2",
      "onetmp",
      "onepkg"
    ]
  },
  "application/opc-nodeset+xml": {
    source: "iana",
    compressible: true
  },
  "application/oscore": {
    source: "iana"
  },
  "application/oxps": {
    source: "iana",
    extensions: [
      "oxps"
    ]
  },
  "application/p21": {
    source: "iana"
  },
  "application/p21+zip": {
    source: "iana",
    compressible: false
  },
  "application/p2p-overlay+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "relo"
    ]
  },
  "application/parityfec": {
    source: "iana"
  },
  "application/passport": {
    source: "iana"
  },
  "application/patch-ops-error+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xer"
    ]
  },
  "application/pdf": {
    source: "iana",
    compressible: false,
    extensions: [
      "pdf"
    ]
  },
  "application/pdx": {
    source: "iana"
  },
  "application/pem-certificate-chain": {
    source: "iana"
  },
  "application/pgp-encrypted": {
    source: "iana",
    compressible: false,
    extensions: [
      "pgp"
    ]
  },
  "application/pgp-keys": {
    source: "iana",
    extensions: [
      "asc"
    ]
  },
  "application/pgp-signature": {
    source: "iana",
    extensions: [
      "asc",
      "sig"
    ]
  },
  "application/pics-rules": {
    source: "apache",
    extensions: [
      "prf"
    ]
  },
  "application/pidf+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/pidf-diff+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/pkcs10": {
    source: "iana",
    extensions: [
      "p10"
    ]
  },
  "application/pkcs12": {
    source: "iana"
  },
  "application/pkcs7-mime": {
    source: "iana",
    extensions: [
      "p7m",
      "p7c"
    ]
  },
  "application/pkcs7-signature": {
    source: "iana",
    extensions: [
      "p7s"
    ]
  },
  "application/pkcs8": {
    source: "iana",
    extensions: [
      "p8"
    ]
  },
  "application/pkcs8-encrypted": {
    source: "iana"
  },
  "application/pkix-attr-cert": {
    source: "iana",
    extensions: [
      "ac"
    ]
  },
  "application/pkix-cert": {
    source: "iana",
    extensions: [
      "cer"
    ]
  },
  "application/pkix-crl": {
    source: "iana",
    extensions: [
      "crl"
    ]
  },
  "application/pkix-pkipath": {
    source: "iana",
    extensions: [
      "pkipath"
    ]
  },
  "application/pkixcmp": {
    source: "iana",
    extensions: [
      "pki"
    ]
  },
  "application/pls+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "pls"
    ]
  },
  "application/poc-settings+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/postscript": {
    source: "iana",
    compressible: true,
    extensions: [
      "ai",
      "eps",
      "ps"
    ]
  },
  "application/ppsp-tracker+json": {
    source: "iana",
    compressible: true
  },
  "application/problem+json": {
    source: "iana",
    compressible: true
  },
  "application/problem+xml": {
    source: "iana",
    compressible: true
  },
  "application/provenance+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "provx"
    ]
  },
  "application/prs.alvestrand.titrax-sheet": {
    source: "iana"
  },
  "application/prs.cww": {
    source: "iana",
    extensions: [
      "cww"
    ]
  },
  "application/prs.cyn": {
    source: "iana",
    charset: "7-BIT"
  },
  "application/prs.hpub+zip": {
    source: "iana",
    compressible: false
  },
  "application/prs.nprend": {
    source: "iana"
  },
  "application/prs.plucker": {
    source: "iana"
  },
  "application/prs.rdf-xml-crypt": {
    source: "iana"
  },
  "application/prs.xsf+xml": {
    source: "iana",
    compressible: true
  },
  "application/pskc+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "pskcxml"
    ]
  },
  "application/pvd+json": {
    source: "iana",
    compressible: true
  },
  "application/qsig": {
    source: "iana"
  },
  "application/raml+yaml": {
    compressible: true,
    extensions: [
      "raml"
    ]
  },
  "application/raptorfec": {
    source: "iana"
  },
  "application/rdap+json": {
    source: "iana",
    compressible: true
  },
  "application/rdf+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rdf",
      "owl"
    ]
  },
  "application/reginfo+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rif"
    ]
  },
  "application/relax-ng-compact-syntax": {
    source: "iana",
    extensions: [
      "rnc"
    ]
  },
  "application/remote-printing": {
    source: "iana"
  },
  "application/reputon+json": {
    source: "iana",
    compressible: true
  },
  "application/resource-lists+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rl"
    ]
  },
  "application/resource-lists-diff+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rld"
    ]
  },
  "application/rfc+xml": {
    source: "iana",
    compressible: true
  },
  "application/riscos": {
    source: "iana"
  },
  "application/rlmi+xml": {
    source: "iana",
    compressible: true
  },
  "application/rls-services+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rs"
    ]
  },
  "application/route-apd+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rapd"
    ]
  },
  "application/route-s-tsid+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "sls"
    ]
  },
  "application/route-usd+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rusd"
    ]
  },
  "application/rpki-ghostbusters": {
    source: "iana",
    extensions: [
      "gbr"
    ]
  },
  "application/rpki-manifest": {
    source: "iana",
    extensions: [
      "mft"
    ]
  },
  "application/rpki-publication": {
    source: "iana"
  },
  "application/rpki-roa": {
    source: "iana",
    extensions: [
      "roa"
    ]
  },
  "application/rpki-updown": {
    source: "iana"
  },
  "application/rsd+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "rsd"
    ]
  },
  "application/rss+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "rss"
    ]
  },
  "application/rtf": {
    source: "iana",
    compressible: true,
    extensions: [
      "rtf"
    ]
  },
  "application/rtploopback": {
    source: "iana"
  },
  "application/rtx": {
    source: "iana"
  },
  "application/samlassertion+xml": {
    source: "iana",
    compressible: true
  },
  "application/samlmetadata+xml": {
    source: "iana",
    compressible: true
  },
  "application/sarif+json": {
    source: "iana",
    compressible: true
  },
  "application/sarif-external-properties+json": {
    source: "iana",
    compressible: true
  },
  "application/sbe": {
    source: "iana"
  },
  "application/sbml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "sbml"
    ]
  },
  "application/scaip+xml": {
    source: "iana",
    compressible: true
  },
  "application/scim+json": {
    source: "iana",
    compressible: true
  },
  "application/scvp-cv-request": {
    source: "iana",
    extensions: [
      "scq"
    ]
  },
  "application/scvp-cv-response": {
    source: "iana",
    extensions: [
      "scs"
    ]
  },
  "application/scvp-vp-request": {
    source: "iana",
    extensions: [
      "spq"
    ]
  },
  "application/scvp-vp-response": {
    source: "iana",
    extensions: [
      "spp"
    ]
  },
  "application/sdp": {
    source: "iana",
    extensions: [
      "sdp"
    ]
  },
  "application/secevent+jwt": {
    source: "iana"
  },
  "application/senml+cbor": {
    source: "iana"
  },
  "application/senml+json": {
    source: "iana",
    compressible: true
  },
  "application/senml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "senmlx"
    ]
  },
  "application/senml-etch+cbor": {
    source: "iana"
  },
  "application/senml-etch+json": {
    source: "iana",
    compressible: true
  },
  "application/senml-exi": {
    source: "iana"
  },
  "application/sensml+cbor": {
    source: "iana"
  },
  "application/sensml+json": {
    source: "iana",
    compressible: true
  },
  "application/sensml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "sensmlx"
    ]
  },
  "application/sensml-exi": {
    source: "iana"
  },
  "application/sep+xml": {
    source: "iana",
    compressible: true
  },
  "application/sep-exi": {
    source: "iana"
  },
  "application/session-info": {
    source: "iana"
  },
  "application/set-payment": {
    source: "iana"
  },
  "application/set-payment-initiation": {
    source: "iana",
    extensions: [
      "setpay"
    ]
  },
  "application/set-registration": {
    source: "iana"
  },
  "application/set-registration-initiation": {
    source: "iana",
    extensions: [
      "setreg"
    ]
  },
  "application/sgml": {
    source: "iana"
  },
  "application/sgml-open-catalog": {
    source: "iana"
  },
  "application/shf+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "shf"
    ]
  },
  "application/sieve": {
    source: "iana",
    extensions: [
      "siv",
      "sieve"
    ]
  },
  "application/simple-filter+xml": {
    source: "iana",
    compressible: true
  },
  "application/simple-message-summary": {
    source: "iana"
  },
  "application/simplesymbolcontainer": {
    source: "iana"
  },
  "application/sipc": {
    source: "iana"
  },
  "application/slate": {
    source: "iana"
  },
  "application/smil": {
    source: "iana"
  },
  "application/smil+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "smi",
      "smil"
    ]
  },
  "application/smpte336m": {
    source: "iana"
  },
  "application/soap+fastinfoset": {
    source: "iana"
  },
  "application/soap+xml": {
    source: "iana",
    compressible: true
  },
  "application/sparql-query": {
    source: "iana",
    extensions: [
      "rq"
    ]
  },
  "application/sparql-results+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "srx"
    ]
  },
  "application/spdx+json": {
    source: "iana",
    compressible: true
  },
  "application/spirits-event+xml": {
    source: "iana",
    compressible: true
  },
  "application/sql": {
    source: "iana"
  },
  "application/srgs": {
    source: "iana",
    extensions: [
      "gram"
    ]
  },
  "application/srgs+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "grxml"
    ]
  },
  "application/sru+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "sru"
    ]
  },
  "application/ssdl+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "ssdl"
    ]
  },
  "application/ssml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "ssml"
    ]
  },
  "application/stix+json": {
    source: "iana",
    compressible: true
  },
  "application/swid+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "swidtag"
    ]
  },
  "application/tamp-apex-update": {
    source: "iana"
  },
  "application/tamp-apex-update-confirm": {
    source: "iana"
  },
  "application/tamp-community-update": {
    source: "iana"
  },
  "application/tamp-community-update-confirm": {
    source: "iana"
  },
  "application/tamp-error": {
    source: "iana"
  },
  "application/tamp-sequence-adjust": {
    source: "iana"
  },
  "application/tamp-sequence-adjust-confirm": {
    source: "iana"
  },
  "application/tamp-status-query": {
    source: "iana"
  },
  "application/tamp-status-response": {
    source: "iana"
  },
  "application/tamp-update": {
    source: "iana"
  },
  "application/tamp-update-confirm": {
    source: "iana"
  },
  "application/tar": {
    compressible: true
  },
  "application/taxii+json": {
    source: "iana",
    compressible: true
  },
  "application/td+json": {
    source: "iana",
    compressible: true
  },
  "application/tei+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "tei",
      "teicorpus"
    ]
  },
  "application/tetra_isi": {
    source: "iana"
  },
  "application/thraud+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "tfi"
    ]
  },
  "application/timestamp-query": {
    source: "iana"
  },
  "application/timestamp-reply": {
    source: "iana"
  },
  "application/timestamped-data": {
    source: "iana",
    extensions: [
      "tsd"
    ]
  },
  "application/tlsrpt+gzip": {
    source: "iana"
  },
  "application/tlsrpt+json": {
    source: "iana",
    compressible: true
  },
  "application/tnauthlist": {
    source: "iana"
  },
  "application/token-introspection+jwt": {
    source: "iana"
  },
  "application/toml": {
    compressible: true,
    extensions: [
      "toml"
    ]
  },
  "application/trickle-ice-sdpfrag": {
    source: "iana"
  },
  "application/trig": {
    source: "iana",
    extensions: [
      "trig"
    ]
  },
  "application/ttml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "ttml"
    ]
  },
  "application/tve-trigger": {
    source: "iana"
  },
  "application/tzif": {
    source: "iana"
  },
  "application/tzif-leap": {
    source: "iana"
  },
  "application/ubjson": {
    compressible: false,
    extensions: [
      "ubj"
    ]
  },
  "application/ulpfec": {
    source: "iana"
  },
  "application/urc-grpsheet+xml": {
    source: "iana",
    compressible: true
  },
  "application/urc-ressheet+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "rsheet"
    ]
  },
  "application/urc-targetdesc+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "td"
    ]
  },
  "application/urc-uisocketdesc+xml": {
    source: "iana",
    compressible: true
  },
  "application/vcard+json": {
    source: "iana",
    compressible: true
  },
  "application/vcard+xml": {
    source: "iana",
    compressible: true
  },
  "application/vemmi": {
    source: "iana"
  },
  "application/vividence.scriptfile": {
    source: "apache"
  },
  "application/vnd.1000minds.decision-model+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "1km"
    ]
  },
  "application/vnd.3gpp-prose+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp-prose-pc3ch+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp-v2x-local-service-information": {
    source: "iana"
  },
  "application/vnd.3gpp.5gnas": {
    source: "iana"
  },
  "application/vnd.3gpp.access-transfer-events+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.bsf+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.gmop+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.gtpc": {
    source: "iana"
  },
  "application/vnd.3gpp.interworking-data": {
    source: "iana"
  },
  "application/vnd.3gpp.lpp": {
    source: "iana"
  },
  "application/vnd.3gpp.mc-signalling-ear": {
    source: "iana"
  },
  "application/vnd.3gpp.mcdata-affiliation-command+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcdata-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcdata-payload": {
    source: "iana"
  },
  "application/vnd.3gpp.mcdata-service-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcdata-signalling": {
    source: "iana"
  },
  "application/vnd.3gpp.mcdata-ue-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcdata-user-profile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-affiliation-command+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-floor-request+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-location-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-mbms-usage-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-service-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-signed+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-ue-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-ue-init-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcptt-user-profile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-affiliation-command+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-affiliation-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-location-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-mbms-usage-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-service-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-transmission-request+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-ue-config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mcvideo-user-profile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.mid-call+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.ngap": {
    source: "iana"
  },
  "application/vnd.3gpp.pfcp": {
    source: "iana"
  },
  "application/vnd.3gpp.pic-bw-large": {
    source: "iana",
    extensions: [
      "plb"
    ]
  },
  "application/vnd.3gpp.pic-bw-small": {
    source: "iana",
    extensions: [
      "psb"
    ]
  },
  "application/vnd.3gpp.pic-bw-var": {
    source: "iana",
    extensions: [
      "pvb"
    ]
  },
  "application/vnd.3gpp.s1ap": {
    source: "iana"
  },
  "application/vnd.3gpp.sms": {
    source: "iana"
  },
  "application/vnd.3gpp.sms+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.srvcc-ext+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.srvcc-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.state-and-event-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp.ussd+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp2.bcmcsinfo+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.3gpp2.sms": {
    source: "iana"
  },
  "application/vnd.3gpp2.tcap": {
    source: "iana",
    extensions: [
      "tcap"
    ]
  },
  "application/vnd.3lightssoftware.imagescal": {
    source: "iana"
  },
  "application/vnd.3m.post-it-notes": {
    source: "iana",
    extensions: [
      "pwn"
    ]
  },
  "application/vnd.accpac.simply.aso": {
    source: "iana",
    extensions: [
      "aso"
    ]
  },
  "application/vnd.accpac.simply.imp": {
    source: "iana",
    extensions: [
      "imp"
    ]
  },
  "application/vnd.acucobol": {
    source: "iana",
    extensions: [
      "acu"
    ]
  },
  "application/vnd.acucorp": {
    source: "iana",
    extensions: [
      "atc",
      "acutc"
    ]
  },
  "application/vnd.adobe.air-application-installer-package+zip": {
    source: "apache",
    compressible: false,
    extensions: [
      "air"
    ]
  },
  "application/vnd.adobe.flash.movie": {
    source: "iana"
  },
  "application/vnd.adobe.formscentral.fcdt": {
    source: "iana",
    extensions: [
      "fcdt"
    ]
  },
  "application/vnd.adobe.fxp": {
    source: "iana",
    extensions: [
      "fxp",
      "fxpl"
    ]
  },
  "application/vnd.adobe.partial-upload": {
    source: "iana"
  },
  "application/vnd.adobe.xdp+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xdp"
    ]
  },
  "application/vnd.adobe.xfdf": {
    source: "iana",
    extensions: [
      "xfdf"
    ]
  },
  "application/vnd.aether.imp": {
    source: "iana"
  },
  "application/vnd.afpc.afplinedata": {
    source: "iana"
  },
  "application/vnd.afpc.afplinedata-pagedef": {
    source: "iana"
  },
  "application/vnd.afpc.cmoca-cmresource": {
    source: "iana"
  },
  "application/vnd.afpc.foca-charset": {
    source: "iana"
  },
  "application/vnd.afpc.foca-codedfont": {
    source: "iana"
  },
  "application/vnd.afpc.foca-codepage": {
    source: "iana"
  },
  "application/vnd.afpc.modca": {
    source: "iana"
  },
  "application/vnd.afpc.modca-cmtable": {
    source: "iana"
  },
  "application/vnd.afpc.modca-formdef": {
    source: "iana"
  },
  "application/vnd.afpc.modca-mediummap": {
    source: "iana"
  },
  "application/vnd.afpc.modca-objectcontainer": {
    source: "iana"
  },
  "application/vnd.afpc.modca-overlay": {
    source: "iana"
  },
  "application/vnd.afpc.modca-pagesegment": {
    source: "iana"
  },
  "application/vnd.age": {
    source: "iana",
    extensions: [
      "age"
    ]
  },
  "application/vnd.ah-barcode": {
    source: "iana"
  },
  "application/vnd.ahead.space": {
    source: "iana",
    extensions: [
      "ahead"
    ]
  },
  "application/vnd.airzip.filesecure.azf": {
    source: "iana",
    extensions: [
      "azf"
    ]
  },
  "application/vnd.airzip.filesecure.azs": {
    source: "iana",
    extensions: [
      "azs"
    ]
  },
  "application/vnd.amadeus+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.amazon.ebook": {
    source: "apache",
    extensions: [
      "azw"
    ]
  },
  "application/vnd.amazon.mobi8-ebook": {
    source: "iana"
  },
  "application/vnd.americandynamics.acc": {
    source: "iana",
    extensions: [
      "acc"
    ]
  },
  "application/vnd.amiga.ami": {
    source: "iana",
    extensions: [
      "ami"
    ]
  },
  "application/vnd.amundsen.maze+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.android.ota": {
    source: "iana"
  },
  "application/vnd.android.package-archive": {
    source: "apache",
    compressible: false,
    extensions: [
      "apk"
    ]
  },
  "application/vnd.anki": {
    source: "iana"
  },
  "application/vnd.anser-web-certificate-issue-initiation": {
    source: "iana",
    extensions: [
      "cii"
    ]
  },
  "application/vnd.anser-web-funds-transfer-initiation": {
    source: "apache",
    extensions: [
      "fti"
    ]
  },
  "application/vnd.antix.game-component": {
    source: "iana",
    extensions: [
      "atx"
    ]
  },
  "application/vnd.apache.arrow.file": {
    source: "iana"
  },
  "application/vnd.apache.arrow.stream": {
    source: "iana"
  },
  "application/vnd.apache.thrift.binary": {
    source: "iana"
  },
  "application/vnd.apache.thrift.compact": {
    source: "iana"
  },
  "application/vnd.apache.thrift.json": {
    source: "iana"
  },
  "application/vnd.api+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.aplextor.warrp+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.apothekende.reservation+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.apple.installer+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mpkg"
    ]
  },
  "application/vnd.apple.keynote": {
    source: "iana",
    extensions: [
      "key"
    ]
  },
  "application/vnd.apple.mpegurl": {
    source: "iana",
    extensions: [
      "m3u8"
    ]
  },
  "application/vnd.apple.numbers": {
    source: "iana",
    extensions: [
      "numbers"
    ]
  },
  "application/vnd.apple.pages": {
    source: "iana",
    extensions: [
      "pages"
    ]
  },
  "application/vnd.apple.pkpass": {
    compressible: false,
    extensions: [
      "pkpass"
    ]
  },
  "application/vnd.arastra.swi": {
    source: "iana"
  },
  "application/vnd.aristanetworks.swi": {
    source: "iana",
    extensions: [
      "swi"
    ]
  },
  "application/vnd.artisan+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.artsquare": {
    source: "iana"
  },
  "application/vnd.astraea-software.iota": {
    source: "iana",
    extensions: [
      "iota"
    ]
  },
  "application/vnd.audiograph": {
    source: "iana",
    extensions: [
      "aep"
    ]
  },
  "application/vnd.autopackage": {
    source: "iana"
  },
  "application/vnd.avalon+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.avistar+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.balsamiq.bmml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "bmml"
    ]
  },
  "application/vnd.balsamiq.bmpr": {
    source: "iana"
  },
  "application/vnd.banana-accounting": {
    source: "iana"
  },
  "application/vnd.bbf.usp.error": {
    source: "iana"
  },
  "application/vnd.bbf.usp.msg": {
    source: "iana"
  },
  "application/vnd.bbf.usp.msg+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.bekitzur-stech+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.bint.med-content": {
    source: "iana"
  },
  "application/vnd.biopax.rdf+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.blink-idb-value-wrapper": {
    source: "iana"
  },
  "application/vnd.blueice.multipass": {
    source: "iana",
    extensions: [
      "mpm"
    ]
  },
  "application/vnd.bluetooth.ep.oob": {
    source: "iana"
  },
  "application/vnd.bluetooth.le.oob": {
    source: "iana"
  },
  "application/vnd.bmi": {
    source: "iana",
    extensions: [
      "bmi"
    ]
  },
  "application/vnd.bpf": {
    source: "iana"
  },
  "application/vnd.bpf3": {
    source: "iana"
  },
  "application/vnd.businessobjects": {
    source: "iana",
    extensions: [
      "rep"
    ]
  },
  "application/vnd.byu.uapi+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.cab-jscript": {
    source: "iana"
  },
  "application/vnd.canon-cpdl": {
    source: "iana"
  },
  "application/vnd.canon-lips": {
    source: "iana"
  },
  "application/vnd.capasystems-pg+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.cendio.thinlinc.clientconf": {
    source: "iana"
  },
  "application/vnd.century-systems.tcp_stream": {
    source: "iana"
  },
  "application/vnd.chemdraw+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "cdxml"
    ]
  },
  "application/vnd.chess-pgn": {
    source: "iana"
  },
  "application/vnd.chipnuts.karaoke-mmd": {
    source: "iana",
    extensions: [
      "mmd"
    ]
  },
  "application/vnd.ciedi": {
    source: "iana"
  },
  "application/vnd.cinderella": {
    source: "iana",
    extensions: [
      "cdy"
    ]
  },
  "application/vnd.cirpack.isdn-ext": {
    source: "iana"
  },
  "application/vnd.citationstyles.style+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "csl"
    ]
  },
  "application/vnd.claymore": {
    source: "iana",
    extensions: [
      "cla"
    ]
  },
  "application/vnd.cloanto.rp9": {
    source: "iana",
    extensions: [
      "rp9"
    ]
  },
  "application/vnd.clonk.c4group": {
    source: "iana",
    extensions: [
      "c4g",
      "c4d",
      "c4f",
      "c4p",
      "c4u"
    ]
  },
  "application/vnd.cluetrust.cartomobile-config": {
    source: "iana",
    extensions: [
      "c11amc"
    ]
  },
  "application/vnd.cluetrust.cartomobile-config-pkg": {
    source: "iana",
    extensions: [
      "c11amz"
    ]
  },
  "application/vnd.coffeescript": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.document": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.document-template": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.presentation": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.presentation-template": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.spreadsheet": {
    source: "iana"
  },
  "application/vnd.collabio.xodocuments.spreadsheet-template": {
    source: "iana"
  },
  "application/vnd.collection+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.collection.doc+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.collection.next+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.comicbook+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.comicbook-rar": {
    source: "iana"
  },
  "application/vnd.commerce-battelle": {
    source: "iana"
  },
  "application/vnd.commonspace": {
    source: "iana",
    extensions: [
      "csp"
    ]
  },
  "application/vnd.contact.cmsg": {
    source: "iana",
    extensions: [
      "cdbcmsg"
    ]
  },
  "application/vnd.coreos.ignition+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.cosmocaller": {
    source: "iana",
    extensions: [
      "cmc"
    ]
  },
  "application/vnd.crick.clicker": {
    source: "iana",
    extensions: [
      "clkx"
    ]
  },
  "application/vnd.crick.clicker.keyboard": {
    source: "iana",
    extensions: [
      "clkk"
    ]
  },
  "application/vnd.crick.clicker.palette": {
    source: "iana",
    extensions: [
      "clkp"
    ]
  },
  "application/vnd.crick.clicker.template": {
    source: "iana",
    extensions: [
      "clkt"
    ]
  },
  "application/vnd.crick.clicker.wordbank": {
    source: "iana",
    extensions: [
      "clkw"
    ]
  },
  "application/vnd.criticaltools.wbs+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "wbs"
    ]
  },
  "application/vnd.cryptii.pipe+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.crypto-shade-file": {
    source: "iana"
  },
  "application/vnd.cryptomator.encrypted": {
    source: "iana"
  },
  "application/vnd.cryptomator.vault": {
    source: "iana"
  },
  "application/vnd.ctc-posml": {
    source: "iana",
    extensions: [
      "pml"
    ]
  },
  "application/vnd.ctct.ws+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.cups-pdf": {
    source: "iana"
  },
  "application/vnd.cups-postscript": {
    source: "iana"
  },
  "application/vnd.cups-ppd": {
    source: "iana",
    extensions: [
      "ppd"
    ]
  },
  "application/vnd.cups-raster": {
    source: "iana"
  },
  "application/vnd.cups-raw": {
    source: "iana"
  },
  "application/vnd.curl": {
    source: "iana"
  },
  "application/vnd.curl.car": {
    source: "apache",
    extensions: [
      "car"
    ]
  },
  "application/vnd.curl.pcurl": {
    source: "apache",
    extensions: [
      "pcurl"
    ]
  },
  "application/vnd.cyan.dean.root+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.cybank": {
    source: "iana"
  },
  "application/vnd.cyclonedx+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.cyclonedx+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.d2l.coursepackage1p0+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.d3m-dataset": {
    source: "iana"
  },
  "application/vnd.d3m-problem": {
    source: "iana"
  },
  "application/vnd.dart": {
    source: "iana",
    compressible: true,
    extensions: [
      "dart"
    ]
  },
  "application/vnd.data-vision.rdz": {
    source: "iana",
    extensions: [
      "rdz"
    ]
  },
  "application/vnd.datapackage+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dataresource+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dbf": {
    source: "iana",
    extensions: [
      "dbf"
    ]
  },
  "application/vnd.debian.binary-package": {
    source: "iana"
  },
  "application/vnd.dece.data": {
    source: "iana",
    extensions: [
      "uvf",
      "uvvf",
      "uvd",
      "uvvd"
    ]
  },
  "application/vnd.dece.ttml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "uvt",
      "uvvt"
    ]
  },
  "application/vnd.dece.unspecified": {
    source: "iana",
    extensions: [
      "uvx",
      "uvvx"
    ]
  },
  "application/vnd.dece.zip": {
    source: "iana",
    extensions: [
      "uvz",
      "uvvz"
    ]
  },
  "application/vnd.denovo.fcselayout-link": {
    source: "iana",
    extensions: [
      "fe_launch"
    ]
  },
  "application/vnd.desmume.movie": {
    source: "iana"
  },
  "application/vnd.dir-bi.plate-dl-nosuffix": {
    source: "iana"
  },
  "application/vnd.dm.delegation+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dna": {
    source: "iana",
    extensions: [
      "dna"
    ]
  },
  "application/vnd.document+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dolby.mlp": {
    source: "apache",
    extensions: [
      "mlp"
    ]
  },
  "application/vnd.dolby.mobile.1": {
    source: "iana"
  },
  "application/vnd.dolby.mobile.2": {
    source: "iana"
  },
  "application/vnd.doremir.scorecloud-binary-document": {
    source: "iana"
  },
  "application/vnd.dpgraph": {
    source: "iana",
    extensions: [
      "dpg"
    ]
  },
  "application/vnd.dreamfactory": {
    source: "iana",
    extensions: [
      "dfac"
    ]
  },
  "application/vnd.drive+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ds-keypoint": {
    source: "apache",
    extensions: [
      "kpxx"
    ]
  },
  "application/vnd.dtg.local": {
    source: "iana"
  },
  "application/vnd.dtg.local.flash": {
    source: "iana"
  },
  "application/vnd.dtg.local.html": {
    source: "iana"
  },
  "application/vnd.dvb.ait": {
    source: "iana",
    extensions: [
      "ait"
    ]
  },
  "application/vnd.dvb.dvbisl+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.dvbj": {
    source: "iana"
  },
  "application/vnd.dvb.esgcontainer": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcdftnotifaccess": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcesgaccess": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcesgaccess2": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcesgpdd": {
    source: "iana"
  },
  "application/vnd.dvb.ipdcroaming": {
    source: "iana"
  },
  "application/vnd.dvb.iptv.alfec-base": {
    source: "iana"
  },
  "application/vnd.dvb.iptv.alfec-enhancement": {
    source: "iana"
  },
  "application/vnd.dvb.notif-aggregate-root+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.notif-container+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.notif-generic+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.notif-ia-msglist+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.notif-ia-registration-request+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.notif-ia-registration-response+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.notif-init+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.dvb.pfr": {
    source: "iana"
  },
  "application/vnd.dvb.service": {
    source: "iana",
    extensions: [
      "svc"
    ]
  },
  "application/vnd.dxr": {
    source: "iana"
  },
  "application/vnd.dynageo": {
    source: "iana",
    extensions: [
      "geo"
    ]
  },
  "application/vnd.dzr": {
    source: "iana"
  },
  "application/vnd.easykaraoke.cdgdownload": {
    source: "iana"
  },
  "application/vnd.ecdis-update": {
    source: "iana"
  },
  "application/vnd.ecip.rlp": {
    source: "iana"
  },
  "application/vnd.eclipse.ditto+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ecowin.chart": {
    source: "iana",
    extensions: [
      "mag"
    ]
  },
  "application/vnd.ecowin.filerequest": {
    source: "iana"
  },
  "application/vnd.ecowin.fileupdate": {
    source: "iana"
  },
  "application/vnd.ecowin.series": {
    source: "iana"
  },
  "application/vnd.ecowin.seriesrequest": {
    source: "iana"
  },
  "application/vnd.ecowin.seriesupdate": {
    source: "iana"
  },
  "application/vnd.efi.img": {
    source: "iana"
  },
  "application/vnd.efi.iso": {
    source: "iana"
  },
  "application/vnd.emclient.accessrequest+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.enliven": {
    source: "iana",
    extensions: [
      "nml"
    ]
  },
  "application/vnd.enphase.envoy": {
    source: "iana"
  },
  "application/vnd.eprints.data+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.epson.esf": {
    source: "iana",
    extensions: [
      "esf"
    ]
  },
  "application/vnd.epson.msf": {
    source: "iana",
    extensions: [
      "msf"
    ]
  },
  "application/vnd.epson.quickanime": {
    source: "iana",
    extensions: [
      "qam"
    ]
  },
  "application/vnd.epson.salt": {
    source: "iana",
    extensions: [
      "slt"
    ]
  },
  "application/vnd.epson.ssf": {
    source: "iana",
    extensions: [
      "ssf"
    ]
  },
  "application/vnd.ericsson.quickcall": {
    source: "iana"
  },
  "application/vnd.espass-espass+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.eszigno3+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "es3",
      "et3"
    ]
  },
  "application/vnd.etsi.aoc+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.asic-e+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.etsi.asic-s+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.etsi.cug+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvcommand+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvdiscovery+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvprofile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvsad-bc+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvsad-cod+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvsad-npvr+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvservice+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvsync+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.iptvueprofile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.mcid+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.mheg5": {
    source: "iana"
  },
  "application/vnd.etsi.overload-control-policy-dataset+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.pstn+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.sci+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.simservs+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.timestamp-token": {
    source: "iana"
  },
  "application/vnd.etsi.tsl+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.etsi.tsl.der": {
    source: "iana"
  },
  "application/vnd.eu.kasparian.car+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.eudora.data": {
    source: "iana"
  },
  "application/vnd.evolv.ecig.profile": {
    source: "iana"
  },
  "application/vnd.evolv.ecig.settings": {
    source: "iana"
  },
  "application/vnd.evolv.ecig.theme": {
    source: "iana"
  },
  "application/vnd.exstream-empower+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.exstream-package": {
    source: "iana"
  },
  "application/vnd.ezpix-album": {
    source: "iana",
    extensions: [
      "ez2"
    ]
  },
  "application/vnd.ezpix-package": {
    source: "iana",
    extensions: [
      "ez3"
    ]
  },
  "application/vnd.f-secure.mobile": {
    source: "iana"
  },
  "application/vnd.familysearch.gedcom+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.fastcopy-disk-image": {
    source: "iana"
  },
  "application/vnd.fdf": {
    source: "iana",
    extensions: [
      "fdf"
    ]
  },
  "application/vnd.fdsn.mseed": {
    source: "iana",
    extensions: [
      "mseed"
    ]
  },
  "application/vnd.fdsn.seed": {
    source: "iana",
    extensions: [
      "seed",
      "dataless"
    ]
  },
  "application/vnd.ffsns": {
    source: "iana"
  },
  "application/vnd.ficlab.flb+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.filmit.zfc": {
    source: "iana"
  },
  "application/vnd.fints": {
    source: "iana"
  },
  "application/vnd.firemonkeys.cloudcell": {
    source: "iana"
  },
  "application/vnd.flographit": {
    source: "iana",
    extensions: [
      "gph"
    ]
  },
  "application/vnd.fluxtime.clip": {
    source: "iana",
    extensions: [
      "ftc"
    ]
  },
  "application/vnd.font-fontforge-sfd": {
    source: "iana"
  },
  "application/vnd.framemaker": {
    source: "iana",
    extensions: [
      "fm",
      "frame",
      "maker",
      "book"
    ]
  },
  "application/vnd.frogans.fnc": {
    source: "iana",
    extensions: [
      "fnc"
    ]
  },
  "application/vnd.frogans.ltf": {
    source: "iana",
    extensions: [
      "ltf"
    ]
  },
  "application/vnd.fsc.weblaunch": {
    source: "iana",
    extensions: [
      "fsc"
    ]
  },
  "application/vnd.fujifilm.fb.docuworks": {
    source: "iana"
  },
  "application/vnd.fujifilm.fb.docuworks.binder": {
    source: "iana"
  },
  "application/vnd.fujifilm.fb.docuworks.container": {
    source: "iana"
  },
  "application/vnd.fujifilm.fb.jfi+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.fujitsu.oasys": {
    source: "iana",
    extensions: [
      "oas"
    ]
  },
  "application/vnd.fujitsu.oasys2": {
    source: "iana",
    extensions: [
      "oa2"
    ]
  },
  "application/vnd.fujitsu.oasys3": {
    source: "iana",
    extensions: [
      "oa3"
    ]
  },
  "application/vnd.fujitsu.oasysgp": {
    source: "iana",
    extensions: [
      "fg5"
    ]
  },
  "application/vnd.fujitsu.oasysprs": {
    source: "iana",
    extensions: [
      "bh2"
    ]
  },
  "application/vnd.fujixerox.art-ex": {
    source: "iana"
  },
  "application/vnd.fujixerox.art4": {
    source: "iana"
  },
  "application/vnd.fujixerox.ddd": {
    source: "iana",
    extensions: [
      "ddd"
    ]
  },
  "application/vnd.fujixerox.docuworks": {
    source: "iana",
    extensions: [
      "xdw"
    ]
  },
  "application/vnd.fujixerox.docuworks.binder": {
    source: "iana",
    extensions: [
      "xbd"
    ]
  },
  "application/vnd.fujixerox.docuworks.container": {
    source: "iana"
  },
  "application/vnd.fujixerox.hbpl": {
    source: "iana"
  },
  "application/vnd.fut-misnet": {
    source: "iana"
  },
  "application/vnd.futoin+cbor": {
    source: "iana"
  },
  "application/vnd.futoin+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.fuzzysheet": {
    source: "iana",
    extensions: [
      "fzs"
    ]
  },
  "application/vnd.genomatix.tuxedo": {
    source: "iana",
    extensions: [
      "txd"
    ]
  },
  "application/vnd.gentics.grd+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.geo+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.geocube+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.geogebra.file": {
    source: "iana",
    extensions: [
      "ggb"
    ]
  },
  "application/vnd.geogebra.slides": {
    source: "iana"
  },
  "application/vnd.geogebra.tool": {
    source: "iana",
    extensions: [
      "ggt"
    ]
  },
  "application/vnd.geometry-explorer": {
    source: "iana",
    extensions: [
      "gex",
      "gre"
    ]
  },
  "application/vnd.geonext": {
    source: "iana",
    extensions: [
      "gxt"
    ]
  },
  "application/vnd.geoplan": {
    source: "iana",
    extensions: [
      "g2w"
    ]
  },
  "application/vnd.geospace": {
    source: "iana",
    extensions: [
      "g3w"
    ]
  },
  "application/vnd.gerber": {
    source: "iana"
  },
  "application/vnd.globalplatform.card-content-mgt": {
    source: "iana"
  },
  "application/vnd.globalplatform.card-content-mgt-response": {
    source: "iana"
  },
  "application/vnd.gmx": {
    source: "iana",
    extensions: [
      "gmx"
    ]
  },
  "application/vnd.google-apps.document": {
    compressible: false,
    extensions: [
      "gdoc"
    ]
  },
  "application/vnd.google-apps.presentation": {
    compressible: false,
    extensions: [
      "gslides"
    ]
  },
  "application/vnd.google-apps.spreadsheet": {
    compressible: false,
    extensions: [
      "gsheet"
    ]
  },
  "application/vnd.google-earth.kml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "kml"
    ]
  },
  "application/vnd.google-earth.kmz": {
    source: "iana",
    compressible: false,
    extensions: [
      "kmz"
    ]
  },
  "application/vnd.gov.sk.e-form+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.gov.sk.e-form+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.gov.sk.xmldatacontainer+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.grafeq": {
    source: "iana",
    extensions: [
      "gqf",
      "gqs"
    ]
  },
  "application/vnd.gridmp": {
    source: "iana"
  },
  "application/vnd.groove-account": {
    source: "iana",
    extensions: [
      "gac"
    ]
  },
  "application/vnd.groove-help": {
    source: "iana",
    extensions: [
      "ghf"
    ]
  },
  "application/vnd.groove-identity-message": {
    source: "iana",
    extensions: [
      "gim"
    ]
  },
  "application/vnd.groove-injector": {
    source: "iana",
    extensions: [
      "grv"
    ]
  },
  "application/vnd.groove-tool-message": {
    source: "iana",
    extensions: [
      "gtm"
    ]
  },
  "application/vnd.groove-tool-template": {
    source: "iana",
    extensions: [
      "tpl"
    ]
  },
  "application/vnd.groove-vcard": {
    source: "iana",
    extensions: [
      "vcg"
    ]
  },
  "application/vnd.hal+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.hal+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "hal"
    ]
  },
  "application/vnd.handheld-entertainment+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "zmm"
    ]
  },
  "application/vnd.hbci": {
    source: "iana",
    extensions: [
      "hbci"
    ]
  },
  "application/vnd.hc+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.hcl-bireports": {
    source: "iana"
  },
  "application/vnd.hdt": {
    source: "iana"
  },
  "application/vnd.heroku+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.hhe.lesson-player": {
    source: "iana",
    extensions: [
      "les"
    ]
  },
  "application/vnd.hl7cda+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/vnd.hl7v2+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/vnd.hp-hpgl": {
    source: "iana",
    extensions: [
      "hpgl"
    ]
  },
  "application/vnd.hp-hpid": {
    source: "iana",
    extensions: [
      "hpid"
    ]
  },
  "application/vnd.hp-hps": {
    source: "iana",
    extensions: [
      "hps"
    ]
  },
  "application/vnd.hp-jlyt": {
    source: "iana",
    extensions: [
      "jlt"
    ]
  },
  "application/vnd.hp-pcl": {
    source: "iana",
    extensions: [
      "pcl"
    ]
  },
  "application/vnd.hp-pclxl": {
    source: "iana",
    extensions: [
      "pclxl"
    ]
  },
  "application/vnd.httphone": {
    source: "iana"
  },
  "application/vnd.hydrostatix.sof-data": {
    source: "iana",
    extensions: [
      "sfd-hdstx"
    ]
  },
  "application/vnd.hyper+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.hyper-item+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.hyperdrive+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.hzn-3d-crossword": {
    source: "iana"
  },
  "application/vnd.ibm.afplinedata": {
    source: "iana"
  },
  "application/vnd.ibm.electronic-media": {
    source: "iana"
  },
  "application/vnd.ibm.minipay": {
    source: "iana",
    extensions: [
      "mpy"
    ]
  },
  "application/vnd.ibm.modcap": {
    source: "iana",
    extensions: [
      "afp",
      "listafp",
      "list3820"
    ]
  },
  "application/vnd.ibm.rights-management": {
    source: "iana",
    extensions: [
      "irm"
    ]
  },
  "application/vnd.ibm.secure-container": {
    source: "iana",
    extensions: [
      "sc"
    ]
  },
  "application/vnd.iccprofile": {
    source: "iana",
    extensions: [
      "icc",
      "icm"
    ]
  },
  "application/vnd.ieee.1905": {
    source: "iana"
  },
  "application/vnd.igloader": {
    source: "iana",
    extensions: [
      "igl"
    ]
  },
  "application/vnd.imagemeter.folder+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.imagemeter.image+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.immervision-ivp": {
    source: "iana",
    extensions: [
      "ivp"
    ]
  },
  "application/vnd.immervision-ivu": {
    source: "iana",
    extensions: [
      "ivu"
    ]
  },
  "application/vnd.ims.imsccv1p1": {
    source: "iana"
  },
  "application/vnd.ims.imsccv1p2": {
    source: "iana"
  },
  "application/vnd.ims.imsccv1p3": {
    source: "iana"
  },
  "application/vnd.ims.lis.v2.result+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ims.lti.v2.toolconsumerprofile+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ims.lti.v2.toolproxy+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ims.lti.v2.toolproxy.id+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ims.lti.v2.toolsettings+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ims.lti.v2.toolsettings.simple+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.informedcontrol.rms+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.informix-visionary": {
    source: "iana"
  },
  "application/vnd.infotech.project": {
    source: "iana"
  },
  "application/vnd.infotech.project+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.innopath.wamp.notification": {
    source: "iana"
  },
  "application/vnd.insors.igm": {
    source: "iana",
    extensions: [
      "igm"
    ]
  },
  "application/vnd.intercon.formnet": {
    source: "iana",
    extensions: [
      "xpw",
      "xpx"
    ]
  },
  "application/vnd.intergeo": {
    source: "iana",
    extensions: [
      "i2g"
    ]
  },
  "application/vnd.intertrust.digibox": {
    source: "iana"
  },
  "application/vnd.intertrust.nncp": {
    source: "iana"
  },
  "application/vnd.intu.qbo": {
    source: "iana",
    extensions: [
      "qbo"
    ]
  },
  "application/vnd.intu.qfx": {
    source: "iana",
    extensions: [
      "qfx"
    ]
  },
  "application/vnd.iptc.g2.catalogitem+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.iptc.g2.conceptitem+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.iptc.g2.knowledgeitem+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.iptc.g2.newsitem+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.iptc.g2.newsmessage+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.iptc.g2.packageitem+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.iptc.g2.planningitem+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ipunplugged.rcprofile": {
    source: "iana",
    extensions: [
      "rcprofile"
    ]
  },
  "application/vnd.irepository.package+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "irp"
    ]
  },
  "application/vnd.is-xpr": {
    source: "iana",
    extensions: [
      "xpr"
    ]
  },
  "application/vnd.isac.fcs": {
    source: "iana",
    extensions: [
      "fcs"
    ]
  },
  "application/vnd.iso11783-10+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.jam": {
    source: "iana",
    extensions: [
      "jam"
    ]
  },
  "application/vnd.japannet-directory-service": {
    source: "iana"
  },
  "application/vnd.japannet-jpnstore-wakeup": {
    source: "iana"
  },
  "application/vnd.japannet-payment-wakeup": {
    source: "iana"
  },
  "application/vnd.japannet-registration": {
    source: "iana"
  },
  "application/vnd.japannet-registration-wakeup": {
    source: "iana"
  },
  "application/vnd.japannet-setstore-wakeup": {
    source: "iana"
  },
  "application/vnd.japannet-verification": {
    source: "iana"
  },
  "application/vnd.japannet-verification-wakeup": {
    source: "iana"
  },
  "application/vnd.jcp.javame.midlet-rms": {
    source: "iana",
    extensions: [
      "rms"
    ]
  },
  "application/vnd.jisp": {
    source: "iana",
    extensions: [
      "jisp"
    ]
  },
  "application/vnd.joost.joda-archive": {
    source: "iana",
    extensions: [
      "joda"
    ]
  },
  "application/vnd.jsk.isdn-ngn": {
    source: "iana"
  },
  "application/vnd.kahootz": {
    source: "iana",
    extensions: [
      "ktz",
      "ktr"
    ]
  },
  "application/vnd.kde.karbon": {
    source: "iana",
    extensions: [
      "karbon"
    ]
  },
  "application/vnd.kde.kchart": {
    source: "iana",
    extensions: [
      "chrt"
    ]
  },
  "application/vnd.kde.kformula": {
    source: "iana",
    extensions: [
      "kfo"
    ]
  },
  "application/vnd.kde.kivio": {
    source: "iana",
    extensions: [
      "flw"
    ]
  },
  "application/vnd.kde.kontour": {
    source: "iana",
    extensions: [
      "kon"
    ]
  },
  "application/vnd.kde.kpresenter": {
    source: "iana",
    extensions: [
      "kpr",
      "kpt"
    ]
  },
  "application/vnd.kde.kspread": {
    source: "iana",
    extensions: [
      "ksp"
    ]
  },
  "application/vnd.kde.kword": {
    source: "iana",
    extensions: [
      "kwd",
      "kwt"
    ]
  },
  "application/vnd.kenameaapp": {
    source: "iana",
    extensions: [
      "htke"
    ]
  },
  "application/vnd.kidspiration": {
    source: "iana",
    extensions: [
      "kia"
    ]
  },
  "application/vnd.kinar": {
    source: "iana",
    extensions: [
      "kne",
      "knp"
    ]
  },
  "application/vnd.koan": {
    source: "iana",
    extensions: [
      "skp",
      "skd",
      "skt",
      "skm"
    ]
  },
  "application/vnd.kodak-descriptor": {
    source: "iana",
    extensions: [
      "sse"
    ]
  },
  "application/vnd.las": {
    source: "iana"
  },
  "application/vnd.las.las+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.las.las+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "lasxml"
    ]
  },
  "application/vnd.laszip": {
    source: "iana"
  },
  "application/vnd.leap+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.liberty-request+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.llamagraphics.life-balance.desktop": {
    source: "iana",
    extensions: [
      "lbd"
    ]
  },
  "application/vnd.llamagraphics.life-balance.exchange+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "lbe"
    ]
  },
  "application/vnd.logipipe.circuit+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.loom": {
    source: "iana"
  },
  "application/vnd.lotus-1-2-3": {
    source: "iana",
    extensions: [
      "123"
    ]
  },
  "application/vnd.lotus-approach": {
    source: "iana",
    extensions: [
      "apr"
    ]
  },
  "application/vnd.lotus-freelance": {
    source: "iana",
    extensions: [
      "pre"
    ]
  },
  "application/vnd.lotus-notes": {
    source: "iana",
    extensions: [
      "nsf"
    ]
  },
  "application/vnd.lotus-organizer": {
    source: "iana",
    extensions: [
      "org"
    ]
  },
  "application/vnd.lotus-screencam": {
    source: "iana",
    extensions: [
      "scm"
    ]
  },
  "application/vnd.lotus-wordpro": {
    source: "iana",
    extensions: [
      "lwp"
    ]
  },
  "application/vnd.macports.portpkg": {
    source: "iana",
    extensions: [
      "portpkg"
    ]
  },
  "application/vnd.mapbox-vector-tile": {
    source: "iana",
    extensions: [
      "mvt"
    ]
  },
  "application/vnd.marlin.drm.actiontoken+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.marlin.drm.conftoken+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.marlin.drm.license+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.marlin.drm.mdcf": {
    source: "iana"
  },
  "application/vnd.mason+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.maxar.archive.3tz+zip": {
    source: "iana",
    compressible: false
  },
  "application/vnd.maxmind.maxmind-db": {
    source: "iana"
  },
  "application/vnd.mcd": {
    source: "iana",
    extensions: [
      "mcd"
    ]
  },
  "application/vnd.medcalcdata": {
    source: "iana",
    extensions: [
      "mc1"
    ]
  },
  "application/vnd.mediastation.cdkey": {
    source: "iana",
    extensions: [
      "cdkey"
    ]
  },
  "application/vnd.meridian-slingshot": {
    source: "iana"
  },
  "application/vnd.mfer": {
    source: "iana",
    extensions: [
      "mwf"
    ]
  },
  "application/vnd.mfmp": {
    source: "iana",
    extensions: [
      "mfm"
    ]
  },
  "application/vnd.micro+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.micrografx.flo": {
    source: "iana",
    extensions: [
      "flo"
    ]
  },
  "application/vnd.micrografx.igx": {
    source: "iana",
    extensions: [
      "igx"
    ]
  },
  "application/vnd.microsoft.portable-executable": {
    source: "iana"
  },
  "application/vnd.microsoft.windows.thumbnail-cache": {
    source: "iana"
  },
  "application/vnd.miele+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.mif": {
    source: "iana",
    extensions: [
      "mif"
    ]
  },
  "application/vnd.minisoft-hp3000-save": {
    source: "iana"
  },
  "application/vnd.mitsubishi.misty-guard.trustweb": {
    source: "iana"
  },
  "application/vnd.mobius.daf": {
    source: "iana",
    extensions: [
      "daf"
    ]
  },
  "application/vnd.mobius.dis": {
    source: "iana",
    extensions: [
      "dis"
    ]
  },
  "application/vnd.mobius.mbk": {
    source: "iana",
    extensions: [
      "mbk"
    ]
  },
  "application/vnd.mobius.mqy": {
    source: "iana",
    extensions: [
      "mqy"
    ]
  },
  "application/vnd.mobius.msl": {
    source: "iana",
    extensions: [
      "msl"
    ]
  },
  "application/vnd.mobius.plc": {
    source: "iana",
    extensions: [
      "plc"
    ]
  },
  "application/vnd.mobius.txf": {
    source: "iana",
    extensions: [
      "txf"
    ]
  },
  "application/vnd.mophun.application": {
    source: "iana",
    extensions: [
      "mpn"
    ]
  },
  "application/vnd.mophun.certificate": {
    source: "iana",
    extensions: [
      "mpc"
    ]
  },
  "application/vnd.motorola.flexsuite": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.adsi": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.fis": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.gotap": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.kmr": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.ttc": {
    source: "iana"
  },
  "application/vnd.motorola.flexsuite.wem": {
    source: "iana"
  },
  "application/vnd.motorola.iprm": {
    source: "iana"
  },
  "application/vnd.mozilla.xul+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xul"
    ]
  },
  "application/vnd.ms-3mfdocument": {
    source: "iana"
  },
  "application/vnd.ms-artgalry": {
    source: "iana",
    extensions: [
      "cil"
    ]
  },
  "application/vnd.ms-asf": {
    source: "iana"
  },
  "application/vnd.ms-cab-compressed": {
    source: "iana",
    extensions: [
      "cab"
    ]
  },
  "application/vnd.ms-color.iccprofile": {
    source: "apache"
  },
  "application/vnd.ms-excel": {
    source: "iana",
    compressible: false,
    extensions: [
      "xls",
      "xlm",
      "xla",
      "xlc",
      "xlt",
      "xlw"
    ]
  },
  "application/vnd.ms-excel.addin.macroenabled.12": {
    source: "iana",
    extensions: [
      "xlam"
    ]
  },
  "application/vnd.ms-excel.sheet.binary.macroenabled.12": {
    source: "iana",
    extensions: [
      "xlsb"
    ]
  },
  "application/vnd.ms-excel.sheet.macroenabled.12": {
    source: "iana",
    extensions: [
      "xlsm"
    ]
  },
  "application/vnd.ms-excel.template.macroenabled.12": {
    source: "iana",
    extensions: [
      "xltm"
    ]
  },
  "application/vnd.ms-fontobject": {
    source: "iana",
    compressible: true,
    extensions: [
      "eot"
    ]
  },
  "application/vnd.ms-htmlhelp": {
    source: "iana",
    extensions: [
      "chm"
    ]
  },
  "application/vnd.ms-ims": {
    source: "iana",
    extensions: [
      "ims"
    ]
  },
  "application/vnd.ms-lrm": {
    source: "iana",
    extensions: [
      "lrm"
    ]
  },
  "application/vnd.ms-office.activex+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ms-officetheme": {
    source: "iana",
    extensions: [
      "thmx"
    ]
  },
  "application/vnd.ms-opentype": {
    source: "apache",
    compressible: true
  },
  "application/vnd.ms-outlook": {
    compressible: false,
    extensions: [
      "msg"
    ]
  },
  "application/vnd.ms-package.obfuscated-opentype": {
    source: "apache"
  },
  "application/vnd.ms-pki.seccat": {
    source: "apache",
    extensions: [
      "cat"
    ]
  },
  "application/vnd.ms-pki.stl": {
    source: "apache",
    extensions: [
      "stl"
    ]
  },
  "application/vnd.ms-playready.initiator+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ms-powerpoint": {
    source: "iana",
    compressible: false,
    extensions: [
      "ppt",
      "pps",
      "pot"
    ]
  },
  "application/vnd.ms-powerpoint.addin.macroenabled.12": {
    source: "iana",
    extensions: [
      "ppam"
    ]
  },
  "application/vnd.ms-powerpoint.presentation.macroenabled.12": {
    source: "iana",
    extensions: [
      "pptm"
    ]
  },
  "application/vnd.ms-powerpoint.slide.macroenabled.12": {
    source: "iana",
    extensions: [
      "sldm"
    ]
  },
  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": {
    source: "iana",
    extensions: [
      "ppsm"
    ]
  },
  "application/vnd.ms-powerpoint.template.macroenabled.12": {
    source: "iana",
    extensions: [
      "potm"
    ]
  },
  "application/vnd.ms-printdevicecapabilities+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ms-printing.printticket+xml": {
    source: "apache",
    compressible: true
  },
  "application/vnd.ms-printschematicket+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ms-project": {
    source: "iana",
    extensions: [
      "mpp",
      "mpt"
    ]
  },
  "application/vnd.ms-tnef": {
    source: "iana"
  },
  "application/vnd.ms-windows.devicepairing": {
    source: "iana"
  },
  "application/vnd.ms-windows.nwprinting.oob": {
    source: "iana"
  },
  "application/vnd.ms-windows.printerpairing": {
    source: "iana"
  },
  "application/vnd.ms-windows.wsd.oob": {
    source: "iana"
  },
  "application/vnd.ms-wmdrm.lic-chlg-req": {
    source: "iana"
  },
  "application/vnd.ms-wmdrm.lic-resp": {
    source: "iana"
  },
  "application/vnd.ms-wmdrm.meter-chlg-req": {
    source: "iana"
  },
  "application/vnd.ms-wmdrm.meter-resp": {
    source: "iana"
  },
  "application/vnd.ms-word.document.macroenabled.12": {
    source: "iana",
    extensions: [
      "docm"
    ]
  },
  "application/vnd.ms-word.template.macroenabled.12": {
    source: "iana",
    extensions: [
      "dotm"
    ]
  },
  "application/vnd.ms-works": {
    source: "iana",
    extensions: [
      "wps",
      "wks",
      "wcm",
      "wdb"
    ]
  },
  "application/vnd.ms-wpl": {
    source: "iana",
    extensions: [
      "wpl"
    ]
  },
  "application/vnd.ms-xpsdocument": {
    source: "iana",
    compressible: false,
    extensions: [
      "xps"
    ]
  },
  "application/vnd.msa-disk-image": {
    source: "iana"
  },
  "application/vnd.mseq": {
    source: "iana",
    extensions: [
      "mseq"
    ]
  },
  "application/vnd.msign": {
    source: "iana"
  },
  "application/vnd.multiad.creator": {
    source: "iana"
  },
  "application/vnd.multiad.creator.cif": {
    source: "iana"
  },
  "application/vnd.music-niff": {
    source: "iana"
  },
  "application/vnd.musician": {
    source: "iana",
    extensions: [
      "mus"
    ]
  },
  "application/vnd.muvee.style": {
    source: "iana",
    extensions: [
      "msty"
    ]
  },
  "application/vnd.mynfc": {
    source: "iana",
    extensions: [
      "taglet"
    ]
  },
  "application/vnd.nacamar.ybrid+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.ncd.control": {
    source: "iana"
  },
  "application/vnd.ncd.reference": {
    source: "iana"
  },
  "application/vnd.nearst.inv+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nebumind.line": {
    source: "iana"
  },
  "application/vnd.nervana": {
    source: "iana"
  },
  "application/vnd.netfpx": {
    source: "iana"
  },
  "application/vnd.neurolanguage.nlu": {
    source: "iana",
    extensions: [
      "nlu"
    ]
  },
  "application/vnd.nimn": {
    source: "iana"
  },
  "application/vnd.nintendo.nitro.rom": {
    source: "iana"
  },
  "application/vnd.nintendo.snes.rom": {
    source: "iana"
  },
  "application/vnd.nitf": {
    source: "iana",
    extensions: [
      "ntf",
      "nitf"
    ]
  },
  "application/vnd.noblenet-directory": {
    source: "iana",
    extensions: [
      "nnd"
    ]
  },
  "application/vnd.noblenet-sealer": {
    source: "iana",
    extensions: [
      "nns"
    ]
  },
  "application/vnd.noblenet-web": {
    source: "iana",
    extensions: [
      "nnw"
    ]
  },
  "application/vnd.nokia.catalogs": {
    source: "iana"
  },
  "application/vnd.nokia.conml+wbxml": {
    source: "iana"
  },
  "application/vnd.nokia.conml+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nokia.iptv.config+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nokia.isds-radio-presets": {
    source: "iana"
  },
  "application/vnd.nokia.landmark+wbxml": {
    source: "iana"
  },
  "application/vnd.nokia.landmark+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nokia.landmarkcollection+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nokia.n-gage.ac+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "ac"
    ]
  },
  "application/vnd.nokia.n-gage.data": {
    source: "iana",
    extensions: [
      "ngdat"
    ]
  },
  "application/vnd.nokia.n-gage.symbian.install": {
    source: "iana",
    extensions: [
      "n-gage"
    ]
  },
  "application/vnd.nokia.ncd": {
    source: "iana"
  },
  "application/vnd.nokia.pcd+wbxml": {
    source: "iana"
  },
  "application/vnd.nokia.pcd+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.nokia.radio-preset": {
    source: "iana",
    extensions: [
      "rpst"
    ]
  },
  "application/vnd.nokia.radio-presets": {
    source: "iana",
    extensions: [
      "rpss"
    ]
  },
  "application/vnd.novadigm.edm": {
    source: "iana",
    extensions: [
      "edm"
    ]
  },
  "application/vnd.novadigm.edx": {
    source: "iana",
    extensions: [
      "edx"
    ]
  },
  "application/vnd.novadigm.ext": {
    source: "iana",
    extensions: [
      "ext"
    ]
  },
  "application/vnd.ntt-local.content-share": {
    source: "iana"
  },
  "application/vnd.ntt-local.file-transfer": {
    source: "iana"
  },
  "application/vnd.ntt-local.ogw_remote-access": {
    source: "iana"
  },
  "application/vnd.ntt-local.sip-ta_remote": {
    source: "iana"
  },
  "application/vnd.ntt-local.sip-ta_tcp_stream": {
    source: "iana"
  },
  "application/vnd.oasis.opendocument.chart": {
    source: "iana",
    extensions: [
      "odc"
    ]
  },
  "application/vnd.oasis.opendocument.chart-template": {
    source: "iana",
    extensions: [
      "otc"
    ]
  },
  "application/vnd.oasis.opendocument.database": {
    source: "iana",
    extensions: [
      "odb"
    ]
  },
  "application/vnd.oasis.opendocument.formula": {
    source: "iana",
    extensions: [
      "odf"
    ]
  },
  "application/vnd.oasis.opendocument.formula-template": {
    source: "iana",
    extensions: [
      "odft"
    ]
  },
  "application/vnd.oasis.opendocument.graphics": {
    source: "iana",
    compressible: false,
    extensions: [
      "odg"
    ]
  },
  "application/vnd.oasis.opendocument.graphics-template": {
    source: "iana",
    extensions: [
      "otg"
    ]
  },
  "application/vnd.oasis.opendocument.image": {
    source: "iana",
    extensions: [
      "odi"
    ]
  },
  "application/vnd.oasis.opendocument.image-template": {
    source: "iana",
    extensions: [
      "oti"
    ]
  },
  "application/vnd.oasis.opendocument.presentation": {
    source: "iana",
    compressible: false,
    extensions: [
      "odp"
    ]
  },
  "application/vnd.oasis.opendocument.presentation-template": {
    source: "iana",
    extensions: [
      "otp"
    ]
  },
  "application/vnd.oasis.opendocument.spreadsheet": {
    source: "iana",
    compressible: false,
    extensions: [
      "ods"
    ]
  },
  "application/vnd.oasis.opendocument.spreadsheet-template": {
    source: "iana",
    extensions: [
      "ots"
    ]
  },
  "application/vnd.oasis.opendocument.text": {
    source: "iana",
    compressible: false,
    extensions: [
      "odt"
    ]
  },
  "application/vnd.oasis.opendocument.text-master": {
    source: "iana",
    extensions: [
      "odm"
    ]
  },
  "application/vnd.oasis.opendocument.text-template": {
    source: "iana",
    extensions: [
      "ott"
    ]
  },
  "application/vnd.oasis.opendocument.text-web": {
    source: "iana",
    extensions: [
      "oth"
    ]
  },
  "application/vnd.obn": {
    source: "iana"
  },
  "application/vnd.ocf+cbor": {
    source: "iana"
  },
  "application/vnd.oci.image.manifest.v1+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oftn.l10n+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.contentaccessdownload+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.contentaccessstreaming+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.cspg-hexbinary": {
    source: "iana"
  },
  "application/vnd.oipf.dae.svg+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.dae.xhtml+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.mippvcontrolmessage+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.pae.gem": {
    source: "iana"
  },
  "application/vnd.oipf.spdiscovery+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.spdlist+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.ueprofile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oipf.userprofile+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.olpc-sugar": {
    source: "iana",
    extensions: [
      "xo"
    ]
  },
  "application/vnd.oma-scws-config": {
    source: "iana"
  },
  "application/vnd.oma-scws-http-request": {
    source: "iana"
  },
  "application/vnd.oma-scws-http-response": {
    source: "iana"
  },
  "application/vnd.oma.bcast.associated-procedure-parameter+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.bcast.drm-trigger+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.bcast.imd+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.bcast.ltkm": {
    source: "iana"
  },
  "application/vnd.oma.bcast.notification+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.bcast.provisioningtrigger": {
    source: "iana"
  },
  "application/vnd.oma.bcast.sgboot": {
    source: "iana"
  },
  "application/vnd.oma.bcast.sgdd+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.bcast.sgdu": {
    source: "iana"
  },
  "application/vnd.oma.bcast.simple-symbol-container": {
    source: "iana"
  },
  "application/vnd.oma.bcast.smartcard-trigger+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.bcast.sprov+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.bcast.stkm": {
    source: "iana"
  },
  "application/vnd.oma.cab-address-book+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.cab-feature-handler+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.cab-pcc+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.cab-subs-invite+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.cab-user-prefs+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.dcd": {
    source: "iana"
  },
  "application/vnd.oma.dcdc": {
    source: "iana"
  },
  "application/vnd.oma.dd2+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "dd2"
    ]
  },
  "application/vnd.oma.drm.risd+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.group-usage-list+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.lwm2m+cbor": {
    source: "iana"
  },
  "application/vnd.oma.lwm2m+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.lwm2m+tlv": {
    source: "iana"
  },
  "application/vnd.oma.pal+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.poc.detailed-progress-report+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.poc.final-report+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.poc.groups+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.poc.invocation-descriptor+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.poc.optimized-progress-report+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.push": {
    source: "iana"
  },
  "application/vnd.oma.scidm.messages+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oma.xcap-directory+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.omads-email+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/vnd.omads-file+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/vnd.omads-folder+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/vnd.omaloc-supl-init": {
    source: "iana"
  },
  "application/vnd.onepager": {
    source: "iana"
  },
  "application/vnd.onepagertamp": {
    source: "iana"
  },
  "application/vnd.onepagertamx": {
    source: "iana"
  },
  "application/vnd.onepagertat": {
    source: "iana"
  },
  "application/vnd.onepagertatp": {
    source: "iana"
  },
  "application/vnd.onepagertatx": {
    source: "iana"
  },
  "application/vnd.openblox.game+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "obgx"
    ]
  },
  "application/vnd.openblox.game-binary": {
    source: "iana"
  },
  "application/vnd.openeye.oeb": {
    source: "iana"
  },
  "application/vnd.openofficeorg.extension": {
    source: "apache",
    extensions: [
      "oxt"
    ]
  },
  "application/vnd.openstreetmap.data+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "osm"
    ]
  },
  "application/vnd.opentimestamps.ots": {
    source: "iana"
  },
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.customxmlproperties+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawing+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.comments+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
    source: "iana",
    compressible: false,
    extensions: [
      "pptx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.presprops+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slide": {
    source: "iana",
    extensions: [
      "sldx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slide+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": {
    source: "iana",
    extensions: [
      "ppsx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.tags+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.template": {
    source: "iana",
    extensions: [
      "potx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.presentationml.template.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
    source: "iana",
    compressible: false,
    extensions: [
      "xlsx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": {
    source: "iana",
    extensions: [
      "xltx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.theme+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.themeoverride+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.vmldrawing": {
    source: "iana"
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
    source: "iana",
    compressible: false,
    extensions: [
      "docx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": {
    source: "iana",
    extensions: [
      "dotx"
    ]
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-package.core-properties+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.openxmlformats-package.relationships+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oracle.resource+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.orange.indata": {
    source: "iana"
  },
  "application/vnd.osa.netdeploy": {
    source: "iana"
  },
  "application/vnd.osgeo.mapguide.package": {
    source: "iana",
    extensions: [
      "mgp"
    ]
  },
  "application/vnd.osgi.bundle": {
    source: "iana"
  },
  "application/vnd.osgi.dp": {
    source: "iana",
    extensions: [
      "dp"
    ]
  },
  "application/vnd.osgi.subsystem": {
    source: "iana",
    extensions: [
      "esa"
    ]
  },
  "application/vnd.otps.ct-kip+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.oxli.countgraph": {
    source: "iana"
  },
  "application/vnd.pagerduty+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.palm": {
    source: "iana",
    extensions: [
      "pdb",
      "pqa",
      "oprc"
    ]
  },
  "application/vnd.panoply": {
    source: "iana"
  },
  "application/vnd.paos.xml": {
    source: "iana"
  },
  "application/vnd.patentdive": {
    source: "iana"
  },
  "application/vnd.patientecommsdoc": {
    source: "iana"
  },
  "application/vnd.pawaafile": {
    source: "iana",
    extensions: [
      "paw"
    ]
  },
  "application/vnd.pcos": {
    source: "iana"
  },
  "application/vnd.pg.format": {
    source: "iana",
    extensions: [
      "str"
    ]
  },
  "application/vnd.pg.osasli": {
    source: "iana",
    extensions: [
      "ei6"
    ]
  },
  "application/vnd.piaccess.application-licence": {
    source: "iana"
  },
  "application/vnd.picsel": {
    source: "iana",
    extensions: [
      "efif"
    ]
  },
  "application/vnd.pmi.widget": {
    source: "iana",
    extensions: [
      "wg"
    ]
  },
  "application/vnd.poc.group-advertisement+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.pocketlearn": {
    source: "iana",
    extensions: [
      "plf"
    ]
  },
  "application/vnd.powerbuilder6": {
    source: "iana",
    extensions: [
      "pbd"
    ]
  },
  "application/vnd.powerbuilder6-s": {
    source: "iana"
  },
  "application/vnd.powerbuilder7": {
    source: "iana"
  },
  "application/vnd.powerbuilder7-s": {
    source: "iana"
  },
  "application/vnd.powerbuilder75": {
    source: "iana"
  },
  "application/vnd.powerbuilder75-s": {
    source: "iana"
  },
  "application/vnd.preminet": {
    source: "iana"
  },
  "application/vnd.previewsystems.box": {
    source: "iana",
    extensions: [
      "box"
    ]
  },
  "application/vnd.proteus.magazine": {
    source: "iana",
    extensions: [
      "mgz"
    ]
  },
  "application/vnd.psfs": {
    source: "iana"
  },
  "application/vnd.publishare-delta-tree": {
    source: "iana",
    extensions: [
      "qps"
    ]
  },
  "application/vnd.pvi.ptid1": {
    source: "iana",
    extensions: [
      "ptid"
    ]
  },
  "application/vnd.pwg-multiplexed": {
    source: "iana"
  },
  "application/vnd.pwg-xhtml-print+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.qualcomm.brew-app-res": {
    source: "iana"
  },
  "application/vnd.quarantainenet": {
    source: "iana"
  },
  "application/vnd.quark.quarkxpress": {
    source: "iana",
    extensions: [
      "qxd",
      "qxt",
      "qwd",
      "qwt",
      "qxl",
      "qxb"
    ]
  },
  "application/vnd.quobject-quoxdocument": {
    source: "iana"
  },
  "application/vnd.radisys.moml+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-audit+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-audit-conf+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-audit-conn+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-audit-dialog+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-audit-stream+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-conf+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog-base+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog-fax-detect+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog-fax-sendrecv+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog-group+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog-speech+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.radisys.msml-dialog-transform+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.rainstor.data": {
    source: "iana"
  },
  "application/vnd.rapid": {
    source: "iana"
  },
  "application/vnd.rar": {
    source: "iana",
    extensions: [
      "rar"
    ]
  },
  "application/vnd.realvnc.bed": {
    source: "iana",
    extensions: [
      "bed"
    ]
  },
  "application/vnd.recordare.musicxml": {
    source: "iana",
    extensions: [
      "mxl"
    ]
  },
  "application/vnd.recordare.musicxml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "musicxml"
    ]
  },
  "application/vnd.renlearn.rlprint": {
    source: "iana"
  },
  "application/vnd.resilient.logic": {
    source: "iana"
  },
  "application/vnd.restful+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.rig.cryptonote": {
    source: "iana",
    extensions: [
      "cryptonote"
    ]
  },
  "application/vnd.rim.cod": {
    source: "apache",
    extensions: [
      "cod"
    ]
  },
  "application/vnd.rn-realmedia": {
    source: "apache",
    extensions: [
      "rm"
    ]
  },
  "application/vnd.rn-realmedia-vbr": {
    source: "apache",
    extensions: [
      "rmvb"
    ]
  },
  "application/vnd.route66.link66+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "link66"
    ]
  },
  "application/vnd.rs-274x": {
    source: "iana"
  },
  "application/vnd.ruckus.download": {
    source: "iana"
  },
  "application/vnd.s3sms": {
    source: "iana"
  },
  "application/vnd.sailingtracker.track": {
    source: "iana",
    extensions: [
      "st"
    ]
  },
  "application/vnd.sar": {
    source: "iana"
  },
  "application/vnd.sbm.cid": {
    source: "iana"
  },
  "application/vnd.sbm.mid2": {
    source: "iana"
  },
  "application/vnd.scribus": {
    source: "iana"
  },
  "application/vnd.sealed.3df": {
    source: "iana"
  },
  "application/vnd.sealed.csf": {
    source: "iana"
  },
  "application/vnd.sealed.doc": {
    source: "iana"
  },
  "application/vnd.sealed.eml": {
    source: "iana"
  },
  "application/vnd.sealed.mht": {
    source: "iana"
  },
  "application/vnd.sealed.net": {
    source: "iana"
  },
  "application/vnd.sealed.ppt": {
    source: "iana"
  },
  "application/vnd.sealed.tiff": {
    source: "iana"
  },
  "application/vnd.sealed.xls": {
    source: "iana"
  },
  "application/vnd.sealedmedia.softseal.html": {
    source: "iana"
  },
  "application/vnd.sealedmedia.softseal.pdf": {
    source: "iana"
  },
  "application/vnd.seemail": {
    source: "iana",
    extensions: [
      "see"
    ]
  },
  "application/vnd.seis+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.sema": {
    source: "iana",
    extensions: [
      "sema"
    ]
  },
  "application/vnd.semd": {
    source: "iana",
    extensions: [
      "semd"
    ]
  },
  "application/vnd.semf": {
    source: "iana",
    extensions: [
      "semf"
    ]
  },
  "application/vnd.shade-save-file": {
    source: "iana"
  },
  "application/vnd.shana.informed.formdata": {
    source: "iana",
    extensions: [
      "ifm"
    ]
  },
  "application/vnd.shana.informed.formtemplate": {
    source: "iana",
    extensions: [
      "itp"
    ]
  },
  "application/vnd.shana.informed.interchange": {
    source: "iana",
    extensions: [
      "iif"
    ]
  },
  "application/vnd.shana.informed.package": {
    source: "iana",
    extensions: [
      "ipk"
    ]
  },
  "application/vnd.shootproof+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.shopkick+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.shp": {
    source: "iana"
  },
  "application/vnd.shx": {
    source: "iana"
  },
  "application/vnd.sigrok.session": {
    source: "iana"
  },
  "application/vnd.simtech-mindmapper": {
    source: "iana",
    extensions: [
      "twd",
      "twds"
    ]
  },
  "application/vnd.siren+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.smaf": {
    source: "iana",
    extensions: [
      "mmf"
    ]
  },
  "application/vnd.smart.notebook": {
    source: "iana"
  },
  "application/vnd.smart.teacher": {
    source: "iana",
    extensions: [
      "teacher"
    ]
  },
  "application/vnd.snesdev-page-table": {
    source: "iana"
  },
  "application/vnd.software602.filler.form+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "fo"
    ]
  },
  "application/vnd.software602.filler.form-xml-zip": {
    source: "iana"
  },
  "application/vnd.solent.sdkm+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "sdkm",
      "sdkd"
    ]
  },
  "application/vnd.spotfire.dxp": {
    source: "iana",
    extensions: [
      "dxp"
    ]
  },
  "application/vnd.spotfire.sfs": {
    source: "iana",
    extensions: [
      "sfs"
    ]
  },
  "application/vnd.sqlite3": {
    source: "iana"
  },
  "application/vnd.sss-cod": {
    source: "iana"
  },
  "application/vnd.sss-dtf": {
    source: "iana"
  },
  "application/vnd.sss-ntf": {
    source: "iana"
  },
  "application/vnd.stardivision.calc": {
    source: "apache",
    extensions: [
      "sdc"
    ]
  },
  "application/vnd.stardivision.draw": {
    source: "apache",
    extensions: [
      "sda"
    ]
  },
  "application/vnd.stardivision.impress": {
    source: "apache",
    extensions: [
      "sdd"
    ]
  },
  "application/vnd.stardivision.math": {
    source: "apache",
    extensions: [
      "smf"
    ]
  },
  "application/vnd.stardivision.writer": {
    source: "apache",
    extensions: [
      "sdw",
      "vor"
    ]
  },
  "application/vnd.stardivision.writer-global": {
    source: "apache",
    extensions: [
      "sgl"
    ]
  },
  "application/vnd.stepmania.package": {
    source: "iana",
    extensions: [
      "smzip"
    ]
  },
  "application/vnd.stepmania.stepchart": {
    source: "iana",
    extensions: [
      "sm"
    ]
  },
  "application/vnd.street-stream": {
    source: "iana"
  },
  "application/vnd.sun.wadl+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "wadl"
    ]
  },
  "application/vnd.sun.xml.calc": {
    source: "apache",
    extensions: [
      "sxc"
    ]
  },
  "application/vnd.sun.xml.calc.template": {
    source: "apache",
    extensions: [
      "stc"
    ]
  },
  "application/vnd.sun.xml.draw": {
    source: "apache",
    extensions: [
      "sxd"
    ]
  },
  "application/vnd.sun.xml.draw.template": {
    source: "apache",
    extensions: [
      "std"
    ]
  },
  "application/vnd.sun.xml.impress": {
    source: "apache",
    extensions: [
      "sxi"
    ]
  },
  "application/vnd.sun.xml.impress.template": {
    source: "apache",
    extensions: [
      "sti"
    ]
  },
  "application/vnd.sun.xml.math": {
    source: "apache",
    extensions: [
      "sxm"
    ]
  },
  "application/vnd.sun.xml.writer": {
    source: "apache",
    extensions: [
      "sxw"
    ]
  },
  "application/vnd.sun.xml.writer.global": {
    source: "apache",
    extensions: [
      "sxg"
    ]
  },
  "application/vnd.sun.xml.writer.template": {
    source: "apache",
    extensions: [
      "stw"
    ]
  },
  "application/vnd.sus-calendar": {
    source: "iana",
    extensions: [
      "sus",
      "susp"
    ]
  },
  "application/vnd.svd": {
    source: "iana",
    extensions: [
      "svd"
    ]
  },
  "application/vnd.swiftview-ics": {
    source: "iana"
  },
  "application/vnd.sycle+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.syft+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.symbian.install": {
    source: "apache",
    extensions: [
      "sis",
      "sisx"
    ]
  },
  "application/vnd.syncml+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "xsm"
    ]
  },
  "application/vnd.syncml.dm+wbxml": {
    source: "iana",
    charset: "UTF-8",
    extensions: [
      "bdm"
    ]
  },
  "application/vnd.syncml.dm+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "xdm"
    ]
  },
  "application/vnd.syncml.dm.notification": {
    source: "iana"
  },
  "application/vnd.syncml.dmddf+wbxml": {
    source: "iana"
  },
  "application/vnd.syncml.dmddf+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "ddf"
    ]
  },
  "application/vnd.syncml.dmtnds+wbxml": {
    source: "iana"
  },
  "application/vnd.syncml.dmtnds+xml": {
    source: "iana",
    charset: "UTF-8",
    compressible: true
  },
  "application/vnd.syncml.ds.notification": {
    source: "iana"
  },
  "application/vnd.tableschema+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.tao.intent-module-archive": {
    source: "iana",
    extensions: [
      "tao"
    ]
  },
  "application/vnd.tcpdump.pcap": {
    source: "iana",
    extensions: [
      "pcap",
      "cap",
      "dmp"
    ]
  },
  "application/vnd.think-cell.ppttc+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.tmd.mediaflex.api+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.tml": {
    source: "iana"
  },
  "application/vnd.tmobile-livetv": {
    source: "iana",
    extensions: [
      "tmo"
    ]
  },
  "application/vnd.tri.onesource": {
    source: "iana"
  },
  "application/vnd.trid.tpt": {
    source: "iana",
    extensions: [
      "tpt"
    ]
  },
  "application/vnd.triscape.mxs": {
    source: "iana",
    extensions: [
      "mxs"
    ]
  },
  "application/vnd.trueapp": {
    source: "iana",
    extensions: [
      "tra"
    ]
  },
  "application/vnd.truedoc": {
    source: "iana"
  },
  "application/vnd.ubisoft.webplayer": {
    source: "iana"
  },
  "application/vnd.ufdl": {
    source: "iana",
    extensions: [
      "ufd",
      "ufdl"
    ]
  },
  "application/vnd.uiq.theme": {
    source: "iana",
    extensions: [
      "utz"
    ]
  },
  "application/vnd.umajin": {
    source: "iana",
    extensions: [
      "umj"
    ]
  },
  "application/vnd.unity": {
    source: "iana",
    extensions: [
      "unityweb"
    ]
  },
  "application/vnd.uoml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "uoml"
    ]
  },
  "application/vnd.uplanet.alert": {
    source: "iana"
  },
  "application/vnd.uplanet.alert-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.bearer-choice": {
    source: "iana"
  },
  "application/vnd.uplanet.bearer-choice-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.cacheop": {
    source: "iana"
  },
  "application/vnd.uplanet.cacheop-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.channel": {
    source: "iana"
  },
  "application/vnd.uplanet.channel-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.list": {
    source: "iana"
  },
  "application/vnd.uplanet.list-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.listcmd": {
    source: "iana"
  },
  "application/vnd.uplanet.listcmd-wbxml": {
    source: "iana"
  },
  "application/vnd.uplanet.signal": {
    source: "iana"
  },
  "application/vnd.uri-map": {
    source: "iana"
  },
  "application/vnd.valve.source.material": {
    source: "iana"
  },
  "application/vnd.vcx": {
    source: "iana",
    extensions: [
      "vcx"
    ]
  },
  "application/vnd.vd-study": {
    source: "iana"
  },
  "application/vnd.vectorworks": {
    source: "iana"
  },
  "application/vnd.vel+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.verimatrix.vcas": {
    source: "iana"
  },
  "application/vnd.veritone.aion+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.veryant.thin": {
    source: "iana"
  },
  "application/vnd.ves.encrypted": {
    source: "iana"
  },
  "application/vnd.vidsoft.vidconference": {
    source: "iana"
  },
  "application/vnd.visio": {
    source: "iana",
    extensions: [
      "vsd",
      "vst",
      "vss",
      "vsw"
    ]
  },
  "application/vnd.visionary": {
    source: "iana",
    extensions: [
      "vis"
    ]
  },
  "application/vnd.vividence.scriptfile": {
    source: "iana"
  },
  "application/vnd.vsf": {
    source: "iana",
    extensions: [
      "vsf"
    ]
  },
  "application/vnd.wap.sic": {
    source: "iana"
  },
  "application/vnd.wap.slc": {
    source: "iana"
  },
  "application/vnd.wap.wbxml": {
    source: "iana",
    charset: "UTF-8",
    extensions: [
      "wbxml"
    ]
  },
  "application/vnd.wap.wmlc": {
    source: "iana",
    extensions: [
      "wmlc"
    ]
  },
  "application/vnd.wap.wmlscriptc": {
    source: "iana",
    extensions: [
      "wmlsc"
    ]
  },
  "application/vnd.webturbo": {
    source: "iana",
    extensions: [
      "wtb"
    ]
  },
  "application/vnd.wfa.dpp": {
    source: "iana"
  },
  "application/vnd.wfa.p2p": {
    source: "iana"
  },
  "application/vnd.wfa.wsc": {
    source: "iana"
  },
  "application/vnd.windows.devicepairing": {
    source: "iana"
  },
  "application/vnd.wmc": {
    source: "iana"
  },
  "application/vnd.wmf.bootstrap": {
    source: "iana"
  },
  "application/vnd.wolfram.mathematica": {
    source: "iana"
  },
  "application/vnd.wolfram.mathematica.package": {
    source: "iana"
  },
  "application/vnd.wolfram.player": {
    source: "iana",
    extensions: [
      "nbp"
    ]
  },
  "application/vnd.wordperfect": {
    source: "iana",
    extensions: [
      "wpd"
    ]
  },
  "application/vnd.wqd": {
    source: "iana",
    extensions: [
      "wqd"
    ]
  },
  "application/vnd.wrq-hp3000-labelled": {
    source: "iana"
  },
  "application/vnd.wt.stf": {
    source: "iana",
    extensions: [
      "stf"
    ]
  },
  "application/vnd.wv.csp+wbxml": {
    source: "iana"
  },
  "application/vnd.wv.csp+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.wv.ssp+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.xacml+json": {
    source: "iana",
    compressible: true
  },
  "application/vnd.xara": {
    source: "iana",
    extensions: [
      "xar"
    ]
  },
  "application/vnd.xfdl": {
    source: "iana",
    extensions: [
      "xfdl"
    ]
  },
  "application/vnd.xfdl.webform": {
    source: "iana"
  },
  "application/vnd.xmi+xml": {
    source: "iana",
    compressible: true
  },
  "application/vnd.xmpie.cpkg": {
    source: "iana"
  },
  "application/vnd.xmpie.dpkg": {
    source: "iana"
  },
  "application/vnd.xmpie.plan": {
    source: "iana"
  },
  "application/vnd.xmpie.ppkg": {
    source: "iana"
  },
  "application/vnd.xmpie.xlim": {
    source: "iana"
  },
  "application/vnd.yamaha.hv-dic": {
    source: "iana",
    extensions: [
      "hvd"
    ]
  },
  "application/vnd.yamaha.hv-script": {
    source: "iana",
    extensions: [
      "hvs"
    ]
  },
  "application/vnd.yamaha.hv-voice": {
    source: "iana",
    extensions: [
      "hvp"
    ]
  },
  "application/vnd.yamaha.openscoreformat": {
    source: "iana",
    extensions: [
      "osf"
    ]
  },
  "application/vnd.yamaha.openscoreformat.osfpvg+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "osfpvg"
    ]
  },
  "application/vnd.yamaha.remote-setup": {
    source: "iana"
  },
  "application/vnd.yamaha.smaf-audio": {
    source: "iana",
    extensions: [
      "saf"
    ]
  },
  "application/vnd.yamaha.smaf-phrase": {
    source: "iana",
    extensions: [
      "spf"
    ]
  },
  "application/vnd.yamaha.through-ngn": {
    source: "iana"
  },
  "application/vnd.yamaha.tunnel-udpencap": {
    source: "iana"
  },
  "application/vnd.yaoweme": {
    source: "iana"
  },
  "application/vnd.yellowriver-custom-menu": {
    source: "iana",
    extensions: [
      "cmp"
    ]
  },
  "application/vnd.youtube.yt": {
    source: "iana"
  },
  "application/vnd.zul": {
    source: "iana",
    extensions: [
      "zir",
      "zirz"
    ]
  },
  "application/vnd.zzazz.deck+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "zaz"
    ]
  },
  "application/voicexml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "vxml"
    ]
  },
  "application/voucher-cms+json": {
    source: "iana",
    compressible: true
  },
  "application/vq-rtcpxr": {
    source: "iana"
  },
  "application/wasm": {
    source: "iana",
    compressible: true,
    extensions: [
      "wasm"
    ]
  },
  "application/watcherinfo+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "wif"
    ]
  },
  "application/webpush-options+json": {
    source: "iana",
    compressible: true
  },
  "application/whoispp-query": {
    source: "iana"
  },
  "application/whoispp-response": {
    source: "iana"
  },
  "application/widget": {
    source: "iana",
    extensions: [
      "wgt"
    ]
  },
  "application/winhlp": {
    source: "apache",
    extensions: [
      "hlp"
    ]
  },
  "application/wita": {
    source: "iana"
  },
  "application/wordperfect5.1": {
    source: "iana"
  },
  "application/wsdl+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "wsdl"
    ]
  },
  "application/wspolicy+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "wspolicy"
    ]
  },
  "application/x-7z-compressed": {
    source: "apache",
    compressible: false,
    extensions: [
      "7z"
    ]
  },
  "application/x-abiword": {
    source: "apache",
    extensions: [
      "abw"
    ]
  },
  "application/x-ace-compressed": {
    source: "apache",
    extensions: [
      "ace"
    ]
  },
  "application/x-amf": {
    source: "apache"
  },
  "application/x-apple-diskimage": {
    source: "apache",
    extensions: [
      "dmg"
    ]
  },
  "application/x-arj": {
    compressible: false,
    extensions: [
      "arj"
    ]
  },
  "application/x-authorware-bin": {
    source: "apache",
    extensions: [
      "aab",
      "x32",
      "u32",
      "vox"
    ]
  },
  "application/x-authorware-map": {
    source: "apache",
    extensions: [
      "aam"
    ]
  },
  "application/x-authorware-seg": {
    source: "apache",
    extensions: [
      "aas"
    ]
  },
  "application/x-bcpio": {
    source: "apache",
    extensions: [
      "bcpio"
    ]
  },
  "application/x-bdoc": {
    compressible: false,
    extensions: [
      "bdoc"
    ]
  },
  "application/x-bittorrent": {
    source: "apache",
    extensions: [
      "torrent"
    ]
  },
  "application/x-blorb": {
    source: "apache",
    extensions: [
      "blb",
      "blorb"
    ]
  },
  "application/x-bzip": {
    source: "apache",
    compressible: false,
    extensions: [
      "bz"
    ]
  },
  "application/x-bzip2": {
    source: "apache",
    compressible: false,
    extensions: [
      "bz2",
      "boz"
    ]
  },
  "application/x-cbr": {
    source: "apache",
    extensions: [
      "cbr",
      "cba",
      "cbt",
      "cbz",
      "cb7"
    ]
  },
  "application/x-cdlink": {
    source: "apache",
    extensions: [
      "vcd"
    ]
  },
  "application/x-cfs-compressed": {
    source: "apache",
    extensions: [
      "cfs"
    ]
  },
  "application/x-chat": {
    source: "apache",
    extensions: [
      "chat"
    ]
  },
  "application/x-chess-pgn": {
    source: "apache",
    extensions: [
      "pgn"
    ]
  },
  "application/x-chrome-extension": {
    extensions: [
      "crx"
    ]
  },
  "application/x-cocoa": {
    source: "nginx",
    extensions: [
      "cco"
    ]
  },
  "application/x-compress": {
    source: "apache"
  },
  "application/x-conference": {
    source: "apache",
    extensions: [
      "nsc"
    ]
  },
  "application/x-cpio": {
    source: "apache",
    extensions: [
      "cpio"
    ]
  },
  "application/x-csh": {
    source: "apache",
    extensions: [
      "csh"
    ]
  },
  "application/x-deb": {
    compressible: false
  },
  "application/x-debian-package": {
    source: "apache",
    extensions: [
      "deb",
      "udeb"
    ]
  },
  "application/x-dgc-compressed": {
    source: "apache",
    extensions: [
      "dgc"
    ]
  },
  "application/x-director": {
    source: "apache",
    extensions: [
      "dir",
      "dcr",
      "dxr",
      "cst",
      "cct",
      "cxt",
      "w3d",
      "fgd",
      "swa"
    ]
  },
  "application/x-doom": {
    source: "apache",
    extensions: [
      "wad"
    ]
  },
  "application/x-dtbncx+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "ncx"
    ]
  },
  "application/x-dtbook+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "dtb"
    ]
  },
  "application/x-dtbresource+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "res"
    ]
  },
  "application/x-dvi": {
    source: "apache",
    compressible: false,
    extensions: [
      "dvi"
    ]
  },
  "application/x-envoy": {
    source: "apache",
    extensions: [
      "evy"
    ]
  },
  "application/x-eva": {
    source: "apache",
    extensions: [
      "eva"
    ]
  },
  "application/x-font-bdf": {
    source: "apache",
    extensions: [
      "bdf"
    ]
  },
  "application/x-font-dos": {
    source: "apache"
  },
  "application/x-font-framemaker": {
    source: "apache"
  },
  "application/x-font-ghostscript": {
    source: "apache",
    extensions: [
      "gsf"
    ]
  },
  "application/x-font-libgrx": {
    source: "apache"
  },
  "application/x-font-linux-psf": {
    source: "apache",
    extensions: [
      "psf"
    ]
  },
  "application/x-font-pcf": {
    source: "apache",
    extensions: [
      "pcf"
    ]
  },
  "application/x-font-snf": {
    source: "apache",
    extensions: [
      "snf"
    ]
  },
  "application/x-font-speedo": {
    source: "apache"
  },
  "application/x-font-sunos-news": {
    source: "apache"
  },
  "application/x-font-type1": {
    source: "apache",
    extensions: [
      "pfa",
      "pfb",
      "pfm",
      "afm"
    ]
  },
  "application/x-font-vfont": {
    source: "apache"
  },
  "application/x-freearc": {
    source: "apache",
    extensions: [
      "arc"
    ]
  },
  "application/x-futuresplash": {
    source: "apache",
    extensions: [
      "spl"
    ]
  },
  "application/x-gca-compressed": {
    source: "apache",
    extensions: [
      "gca"
    ]
  },
  "application/x-glulx": {
    source: "apache",
    extensions: [
      "ulx"
    ]
  },
  "application/x-gnumeric": {
    source: "apache",
    extensions: [
      "gnumeric"
    ]
  },
  "application/x-gramps-xml": {
    source: "apache",
    extensions: [
      "gramps"
    ]
  },
  "application/x-gtar": {
    source: "apache",
    extensions: [
      "gtar"
    ]
  },
  "application/x-gzip": {
    source: "apache"
  },
  "application/x-hdf": {
    source: "apache",
    extensions: [
      "hdf"
    ]
  },
  "application/x-httpd-php": {
    compressible: true,
    extensions: [
      "php"
    ]
  },
  "application/x-install-instructions": {
    source: "apache",
    extensions: [
      "install"
    ]
  },
  "application/x-iso9660-image": {
    source: "apache",
    extensions: [
      "iso"
    ]
  },
  "application/x-iwork-keynote-sffkey": {
    extensions: [
      "key"
    ]
  },
  "application/x-iwork-numbers-sffnumbers": {
    extensions: [
      "numbers"
    ]
  },
  "application/x-iwork-pages-sffpages": {
    extensions: [
      "pages"
    ]
  },
  "application/x-java-archive-diff": {
    source: "nginx",
    extensions: [
      "jardiff"
    ]
  },
  "application/x-java-jnlp-file": {
    source: "apache",
    compressible: false,
    extensions: [
      "jnlp"
    ]
  },
  "application/x-javascript": {
    compressible: true
  },
  "application/x-keepass2": {
    extensions: [
      "kdbx"
    ]
  },
  "application/x-latex": {
    source: "apache",
    compressible: false,
    extensions: [
      "latex"
    ]
  },
  "application/x-lua-bytecode": {
    extensions: [
      "luac"
    ]
  },
  "application/x-lzh-compressed": {
    source: "apache",
    extensions: [
      "lzh",
      "lha"
    ]
  },
  "application/x-makeself": {
    source: "nginx",
    extensions: [
      "run"
    ]
  },
  "application/x-mie": {
    source: "apache",
    extensions: [
      "mie"
    ]
  },
  "application/x-mobipocket-ebook": {
    source: "apache",
    extensions: [
      "prc",
      "mobi"
    ]
  },
  "application/x-mpegurl": {
    compressible: false
  },
  "application/x-ms-application": {
    source: "apache",
    extensions: [
      "application"
    ]
  },
  "application/x-ms-shortcut": {
    source: "apache",
    extensions: [
      "lnk"
    ]
  },
  "application/x-ms-wmd": {
    source: "apache",
    extensions: [
      "wmd"
    ]
  },
  "application/x-ms-wmz": {
    source: "apache",
    extensions: [
      "wmz"
    ]
  },
  "application/x-ms-xbap": {
    source: "apache",
    extensions: [
      "xbap"
    ]
  },
  "application/x-msaccess": {
    source: "apache",
    extensions: [
      "mdb"
    ]
  },
  "application/x-msbinder": {
    source: "apache",
    extensions: [
      "obd"
    ]
  },
  "application/x-mscardfile": {
    source: "apache",
    extensions: [
      "crd"
    ]
  },
  "application/x-msclip": {
    source: "apache",
    extensions: [
      "clp"
    ]
  },
  "application/x-msdos-program": {
    extensions: [
      "exe"
    ]
  },
  "application/x-msdownload": {
    source: "apache",
    extensions: [
      "exe",
      "dll",
      "com",
      "bat",
      "msi"
    ]
  },
  "application/x-msmediaview": {
    source: "apache",
    extensions: [
      "mvb",
      "m13",
      "m14"
    ]
  },
  "application/x-msmetafile": {
    source: "apache",
    extensions: [
      "wmf",
      "wmz",
      "emf",
      "emz"
    ]
  },
  "application/x-msmoney": {
    source: "apache",
    extensions: [
      "mny"
    ]
  },
  "application/x-mspublisher": {
    source: "apache",
    extensions: [
      "pub"
    ]
  },
  "application/x-msschedule": {
    source: "apache",
    extensions: [
      "scd"
    ]
  },
  "application/x-msterminal": {
    source: "apache",
    extensions: [
      "trm"
    ]
  },
  "application/x-mswrite": {
    source: "apache",
    extensions: [
      "wri"
    ]
  },
  "application/x-netcdf": {
    source: "apache",
    extensions: [
      "nc",
      "cdf"
    ]
  },
  "application/x-ns-proxy-autoconfig": {
    compressible: true,
    extensions: [
      "pac"
    ]
  },
  "application/x-nzb": {
    source: "apache",
    extensions: [
      "nzb"
    ]
  },
  "application/x-perl": {
    source: "nginx",
    extensions: [
      "pl",
      "pm"
    ]
  },
  "application/x-pilot": {
    source: "nginx",
    extensions: [
      "prc",
      "pdb"
    ]
  },
  "application/x-pkcs12": {
    source: "apache",
    compressible: false,
    extensions: [
      "p12",
      "pfx"
    ]
  },
  "application/x-pkcs7-certificates": {
    source: "apache",
    extensions: [
      "p7b",
      "spc"
    ]
  },
  "application/x-pkcs7-certreqresp": {
    source: "apache",
    extensions: [
      "p7r"
    ]
  },
  "application/x-pki-message": {
    source: "iana"
  },
  "application/x-rar-compressed": {
    source: "apache",
    compressible: false,
    extensions: [
      "rar"
    ]
  },
  "application/x-redhat-package-manager": {
    source: "nginx",
    extensions: [
      "rpm"
    ]
  },
  "application/x-research-info-systems": {
    source: "apache",
    extensions: [
      "ris"
    ]
  },
  "application/x-sea": {
    source: "nginx",
    extensions: [
      "sea"
    ]
  },
  "application/x-sh": {
    source: "apache",
    compressible: true,
    extensions: [
      "sh"
    ]
  },
  "application/x-shar": {
    source: "apache",
    extensions: [
      "shar"
    ]
  },
  "application/x-shockwave-flash": {
    source: "apache",
    compressible: false,
    extensions: [
      "swf"
    ]
  },
  "application/x-silverlight-app": {
    source: "apache",
    extensions: [
      "xap"
    ]
  },
  "application/x-sql": {
    source: "apache",
    extensions: [
      "sql"
    ]
  },
  "application/x-stuffit": {
    source: "apache",
    compressible: false,
    extensions: [
      "sit"
    ]
  },
  "application/x-stuffitx": {
    source: "apache",
    extensions: [
      "sitx"
    ]
  },
  "application/x-subrip": {
    source: "apache",
    extensions: [
      "srt"
    ]
  },
  "application/x-sv4cpio": {
    source: "apache",
    extensions: [
      "sv4cpio"
    ]
  },
  "application/x-sv4crc": {
    source: "apache",
    extensions: [
      "sv4crc"
    ]
  },
  "application/x-t3vm-image": {
    source: "apache",
    extensions: [
      "t3"
    ]
  },
  "application/x-tads": {
    source: "apache",
    extensions: [
      "gam"
    ]
  },
  "application/x-tar": {
    source: "apache",
    compressible: true,
    extensions: [
      "tar"
    ]
  },
  "application/x-tcl": {
    source: "apache",
    extensions: [
      "tcl",
      "tk"
    ]
  },
  "application/x-tex": {
    source: "apache",
    extensions: [
      "tex"
    ]
  },
  "application/x-tex-tfm": {
    source: "apache",
    extensions: [
      "tfm"
    ]
  },
  "application/x-texinfo": {
    source: "apache",
    extensions: [
      "texinfo",
      "texi"
    ]
  },
  "application/x-tgif": {
    source: "apache",
    extensions: [
      "obj"
    ]
  },
  "application/x-ustar": {
    source: "apache",
    extensions: [
      "ustar"
    ]
  },
  "application/x-virtualbox-hdd": {
    compressible: true,
    extensions: [
      "hdd"
    ]
  },
  "application/x-virtualbox-ova": {
    compressible: true,
    extensions: [
      "ova"
    ]
  },
  "application/x-virtualbox-ovf": {
    compressible: true,
    extensions: [
      "ovf"
    ]
  },
  "application/x-virtualbox-vbox": {
    compressible: true,
    extensions: [
      "vbox"
    ]
  },
  "application/x-virtualbox-vbox-extpack": {
    compressible: false,
    extensions: [
      "vbox-extpack"
    ]
  },
  "application/x-virtualbox-vdi": {
    compressible: true,
    extensions: [
      "vdi"
    ]
  },
  "application/x-virtualbox-vhd": {
    compressible: true,
    extensions: [
      "vhd"
    ]
  },
  "application/x-virtualbox-vmdk": {
    compressible: true,
    extensions: [
      "vmdk"
    ]
  },
  "application/x-wais-source": {
    source: "apache",
    extensions: [
      "src"
    ]
  },
  "application/x-web-app-manifest+json": {
    compressible: true,
    extensions: [
      "webapp"
    ]
  },
  "application/x-www-form-urlencoded": {
    source: "iana",
    compressible: true
  },
  "application/x-x509-ca-cert": {
    source: "iana",
    extensions: [
      "der",
      "crt",
      "pem"
    ]
  },
  "application/x-x509-ca-ra-cert": {
    source: "iana"
  },
  "application/x-x509-next-ca-cert": {
    source: "iana"
  },
  "application/x-xfig": {
    source: "apache",
    extensions: [
      "fig"
    ]
  },
  "application/x-xliff+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "xlf"
    ]
  },
  "application/x-xpinstall": {
    source: "apache",
    compressible: false,
    extensions: [
      "xpi"
    ]
  },
  "application/x-xz": {
    source: "apache",
    extensions: [
      "xz"
    ]
  },
  "application/x-zmachine": {
    source: "apache",
    extensions: [
      "z1",
      "z2",
      "z3",
      "z4",
      "z5",
      "z6",
      "z7",
      "z8"
    ]
  },
  "application/x400-bp": {
    source: "iana"
  },
  "application/xacml+xml": {
    source: "iana",
    compressible: true
  },
  "application/xaml+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "xaml"
    ]
  },
  "application/xcap-att+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xav"
    ]
  },
  "application/xcap-caps+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xca"
    ]
  },
  "application/xcap-diff+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xdf"
    ]
  },
  "application/xcap-el+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xel"
    ]
  },
  "application/xcap-error+xml": {
    source: "iana",
    compressible: true
  },
  "application/xcap-ns+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xns"
    ]
  },
  "application/xcon-conference-info+xml": {
    source: "iana",
    compressible: true
  },
  "application/xcon-conference-info-diff+xml": {
    source: "iana",
    compressible: true
  },
  "application/xenc+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xenc"
    ]
  },
  "application/xhtml+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xhtml",
      "xht"
    ]
  },
  "application/xhtml-voice+xml": {
    source: "apache",
    compressible: true
  },
  "application/xliff+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xlf"
    ]
  },
  "application/xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xml",
      "xsl",
      "xsd",
      "rng"
    ]
  },
  "application/xml-dtd": {
    source: "iana",
    compressible: true,
    extensions: [
      "dtd"
    ]
  },
  "application/xml-external-parsed-entity": {
    source: "iana"
  },
  "application/xml-patch+xml": {
    source: "iana",
    compressible: true
  },
  "application/xmpp+xml": {
    source: "iana",
    compressible: true
  },
  "application/xop+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xop"
    ]
  },
  "application/xproc+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "xpl"
    ]
  },
  "application/xslt+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xsl",
      "xslt"
    ]
  },
  "application/xspf+xml": {
    source: "apache",
    compressible: true,
    extensions: [
      "xspf"
    ]
  },
  "application/xv+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "mxml",
      "xhvml",
      "xvml",
      "xvm"
    ]
  },
  "application/yang": {
    source: "iana",
    extensions: [
      "yang"
    ]
  },
  "application/yang-data+json": {
    source: "iana",
    compressible: true
  },
  "application/yang-data+xml": {
    source: "iana",
    compressible: true
  },
  "application/yang-patch+json": {
    source: "iana",
    compressible: true
  },
  "application/yang-patch+xml": {
    source: "iana",
    compressible: true
  },
  "application/yin+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "yin"
    ]
  },
  "application/zip": {
    source: "iana",
    compressible: false,
    extensions: [
      "zip"
    ]
  },
  "application/zlib": {
    source: "iana"
  },
  "application/zstd": {
    source: "iana"
  },
  "audio/1d-interleaved-parityfec": {
    source: "iana"
  },
  "audio/32kadpcm": {
    source: "iana"
  },
  "audio/3gpp": {
    source: "iana",
    compressible: false,
    extensions: [
      "3gpp"
    ]
  },
  "audio/3gpp2": {
    source: "iana"
  },
  "audio/aac": {
    source: "iana"
  },
  "audio/ac3": {
    source: "iana"
  },
  "audio/adpcm": {
    source: "apache",
    extensions: [
      "adp"
    ]
  },
  "audio/amr": {
    source: "iana",
    extensions: [
      "amr"
    ]
  },
  "audio/amr-wb": {
    source: "iana"
  },
  "audio/amr-wb+": {
    source: "iana"
  },
  "audio/aptx": {
    source: "iana"
  },
  "audio/asc": {
    source: "iana"
  },
  "audio/atrac-advanced-lossless": {
    source: "iana"
  },
  "audio/atrac-x": {
    source: "iana"
  },
  "audio/atrac3": {
    source: "iana"
  },
  "audio/basic": {
    source: "iana",
    compressible: false,
    extensions: [
      "au",
      "snd"
    ]
  },
  "audio/bv16": {
    source: "iana"
  },
  "audio/bv32": {
    source: "iana"
  },
  "audio/clearmode": {
    source: "iana"
  },
  "audio/cn": {
    source: "iana"
  },
  "audio/dat12": {
    source: "iana"
  },
  "audio/dls": {
    source: "iana"
  },
  "audio/dsr-es201108": {
    source: "iana"
  },
  "audio/dsr-es202050": {
    source: "iana"
  },
  "audio/dsr-es202211": {
    source: "iana"
  },
  "audio/dsr-es202212": {
    source: "iana"
  },
  "audio/dv": {
    source: "iana"
  },
  "audio/dvi4": {
    source: "iana"
  },
  "audio/eac3": {
    source: "iana"
  },
  "audio/encaprtp": {
    source: "iana"
  },
  "audio/evrc": {
    source: "iana"
  },
  "audio/evrc-qcp": {
    source: "iana"
  },
  "audio/evrc0": {
    source: "iana"
  },
  "audio/evrc1": {
    source: "iana"
  },
  "audio/evrcb": {
    source: "iana"
  },
  "audio/evrcb0": {
    source: "iana"
  },
  "audio/evrcb1": {
    source: "iana"
  },
  "audio/evrcnw": {
    source: "iana"
  },
  "audio/evrcnw0": {
    source: "iana"
  },
  "audio/evrcnw1": {
    source: "iana"
  },
  "audio/evrcwb": {
    source: "iana"
  },
  "audio/evrcwb0": {
    source: "iana"
  },
  "audio/evrcwb1": {
    source: "iana"
  },
  "audio/evs": {
    source: "iana"
  },
  "audio/flexfec": {
    source: "iana"
  },
  "audio/fwdred": {
    source: "iana"
  },
  "audio/g711-0": {
    source: "iana"
  },
  "audio/g719": {
    source: "iana"
  },
  "audio/g722": {
    source: "iana"
  },
  "audio/g7221": {
    source: "iana"
  },
  "audio/g723": {
    source: "iana"
  },
  "audio/g726-16": {
    source: "iana"
  },
  "audio/g726-24": {
    source: "iana"
  },
  "audio/g726-32": {
    source: "iana"
  },
  "audio/g726-40": {
    source: "iana"
  },
  "audio/g728": {
    source: "iana"
  },
  "audio/g729": {
    source: "iana"
  },
  "audio/g7291": {
    source: "iana"
  },
  "audio/g729d": {
    source: "iana"
  },
  "audio/g729e": {
    source: "iana"
  },
  "audio/gsm": {
    source: "iana"
  },
  "audio/gsm-efr": {
    source: "iana"
  },
  "audio/gsm-hr-08": {
    source: "iana"
  },
  "audio/ilbc": {
    source: "iana"
  },
  "audio/ip-mr_v2.5": {
    source: "iana"
  },
  "audio/isac": {
    source: "apache"
  },
  "audio/l16": {
    source: "iana"
  },
  "audio/l20": {
    source: "iana"
  },
  "audio/l24": {
    source: "iana",
    compressible: false
  },
  "audio/l8": {
    source: "iana"
  },
  "audio/lpc": {
    source: "iana"
  },
  "audio/melp": {
    source: "iana"
  },
  "audio/melp1200": {
    source: "iana"
  },
  "audio/melp2400": {
    source: "iana"
  },
  "audio/melp600": {
    source: "iana"
  },
  "audio/mhas": {
    source: "iana"
  },
  "audio/midi": {
    source: "apache",
    extensions: [
      "mid",
      "midi",
      "kar",
      "rmi"
    ]
  },
  "audio/mobile-xmf": {
    source: "iana",
    extensions: [
      "mxmf"
    ]
  },
  "audio/mp3": {
    compressible: false,
    extensions: [
      "mp3"
    ]
  },
  "audio/mp4": {
    source: "iana",
    compressible: false,
    extensions: [
      "m4a",
      "mp4a"
    ]
  },
  "audio/mp4a-latm": {
    source: "iana"
  },
  "audio/mpa": {
    source: "iana"
  },
  "audio/mpa-robust": {
    source: "iana"
  },
  "audio/mpeg": {
    source: "iana",
    compressible: false,
    extensions: [
      "mpga",
      "mp2",
      "mp2a",
      "mp3",
      "m2a",
      "m3a"
    ]
  },
  "audio/mpeg4-generic": {
    source: "iana"
  },
  "audio/musepack": {
    source: "apache"
  },
  "audio/ogg": {
    source: "iana",
    compressible: false,
    extensions: [
      "oga",
      "ogg",
      "spx",
      "opus"
    ]
  },
  "audio/opus": {
    source: "iana"
  },
  "audio/parityfec": {
    source: "iana"
  },
  "audio/pcma": {
    source: "iana"
  },
  "audio/pcma-wb": {
    source: "iana"
  },
  "audio/pcmu": {
    source: "iana"
  },
  "audio/pcmu-wb": {
    source: "iana"
  },
  "audio/prs.sid": {
    source: "iana"
  },
  "audio/qcelp": {
    source: "iana"
  },
  "audio/raptorfec": {
    source: "iana"
  },
  "audio/red": {
    source: "iana"
  },
  "audio/rtp-enc-aescm128": {
    source: "iana"
  },
  "audio/rtp-midi": {
    source: "iana"
  },
  "audio/rtploopback": {
    source: "iana"
  },
  "audio/rtx": {
    source: "iana"
  },
  "audio/s3m": {
    source: "apache",
    extensions: [
      "s3m"
    ]
  },
  "audio/scip": {
    source: "iana"
  },
  "audio/silk": {
    source: "apache",
    extensions: [
      "sil"
    ]
  },
  "audio/smv": {
    source: "iana"
  },
  "audio/smv-qcp": {
    source: "iana"
  },
  "audio/smv0": {
    source: "iana"
  },
  "audio/sofa": {
    source: "iana"
  },
  "audio/sp-midi": {
    source: "iana"
  },
  "audio/speex": {
    source: "iana"
  },
  "audio/t140c": {
    source: "iana"
  },
  "audio/t38": {
    source: "iana"
  },
  "audio/telephone-event": {
    source: "iana"
  },
  "audio/tetra_acelp": {
    source: "iana"
  },
  "audio/tetra_acelp_bb": {
    source: "iana"
  },
  "audio/tone": {
    source: "iana"
  },
  "audio/tsvcis": {
    source: "iana"
  },
  "audio/uemclip": {
    source: "iana"
  },
  "audio/ulpfec": {
    source: "iana"
  },
  "audio/usac": {
    source: "iana"
  },
  "audio/vdvi": {
    source: "iana"
  },
  "audio/vmr-wb": {
    source: "iana"
  },
  "audio/vnd.3gpp.iufp": {
    source: "iana"
  },
  "audio/vnd.4sb": {
    source: "iana"
  },
  "audio/vnd.audiokoz": {
    source: "iana"
  },
  "audio/vnd.celp": {
    source: "iana"
  },
  "audio/vnd.cisco.nse": {
    source: "iana"
  },
  "audio/vnd.cmles.radio-events": {
    source: "iana"
  },
  "audio/vnd.cns.anp1": {
    source: "iana"
  },
  "audio/vnd.cns.inf1": {
    source: "iana"
  },
  "audio/vnd.dece.audio": {
    source: "iana",
    extensions: [
      "uva",
      "uvva"
    ]
  },
  "audio/vnd.digital-winds": {
    source: "iana",
    extensions: [
      "eol"
    ]
  },
  "audio/vnd.dlna.adts": {
    source: "iana"
  },
  "audio/vnd.dolby.heaac.1": {
    source: "iana"
  },
  "audio/vnd.dolby.heaac.2": {
    source: "iana"
  },
  "audio/vnd.dolby.mlp": {
    source: "iana"
  },
  "audio/vnd.dolby.mps": {
    source: "iana"
  },
  "audio/vnd.dolby.pl2": {
    source: "iana"
  },
  "audio/vnd.dolby.pl2x": {
    source: "iana"
  },
  "audio/vnd.dolby.pl2z": {
    source: "iana"
  },
  "audio/vnd.dolby.pulse.1": {
    source: "iana"
  },
  "audio/vnd.dra": {
    source: "iana",
    extensions: [
      "dra"
    ]
  },
  "audio/vnd.dts": {
    source: "iana",
    extensions: [
      "dts"
    ]
  },
  "audio/vnd.dts.hd": {
    source: "iana",
    extensions: [
      "dtshd"
    ]
  },
  "audio/vnd.dts.uhd": {
    source: "iana"
  },
  "audio/vnd.dvb.file": {
    source: "iana"
  },
  "audio/vnd.everad.plj": {
    source: "iana"
  },
  "audio/vnd.hns.audio": {
    source: "iana"
  },
  "audio/vnd.lucent.voice": {
    source: "iana",
    extensions: [
      "lvp"
    ]
  },
  "audio/vnd.ms-playready.media.pya": {
    source: "iana",
    extensions: [
      "pya"
    ]
  },
  "audio/vnd.nokia.mobile-xmf": {
    source: "iana"
  },
  "audio/vnd.nortel.vbk": {
    source: "iana"
  },
  "audio/vnd.nuera.ecelp4800": {
    source: "iana",
    extensions: [
      "ecelp4800"
    ]
  },
  "audio/vnd.nuera.ecelp7470": {
    source: "iana",
    extensions: [
      "ecelp7470"
    ]
  },
  "audio/vnd.nuera.ecelp9600": {
    source: "iana",
    extensions: [
      "ecelp9600"
    ]
  },
  "audio/vnd.octel.sbc": {
    source: "iana"
  },
  "audio/vnd.presonus.multitrack": {
    source: "iana"
  },
  "audio/vnd.qcelp": {
    source: "iana"
  },
  "audio/vnd.rhetorex.32kadpcm": {
    source: "iana"
  },
  "audio/vnd.rip": {
    source: "iana",
    extensions: [
      "rip"
    ]
  },
  "audio/vnd.rn-realaudio": {
    compressible: false
  },
  "audio/vnd.sealedmedia.softseal.mpeg": {
    source: "iana"
  },
  "audio/vnd.vmx.cvsd": {
    source: "iana"
  },
  "audio/vnd.wave": {
    compressible: false
  },
  "audio/vorbis": {
    source: "iana",
    compressible: false
  },
  "audio/vorbis-config": {
    source: "iana"
  },
  "audio/wav": {
    compressible: false,
    extensions: [
      "wav"
    ]
  },
  "audio/wave": {
    compressible: false,
    extensions: [
      "wav"
    ]
  },
  "audio/webm": {
    source: "apache",
    compressible: false,
    extensions: [
      "weba"
    ]
  },
  "audio/x-aac": {
    source: "apache",
    compressible: false,
    extensions: [
      "aac"
    ]
  },
  "audio/x-aiff": {
    source: "apache",
    extensions: [
      "aif",
      "aiff",
      "aifc"
    ]
  },
  "audio/x-caf": {
    source: "apache",
    compressible: false,
    extensions: [
      "caf"
    ]
  },
  "audio/x-flac": {
    source: "apache",
    extensions: [
      "flac"
    ]
  },
  "audio/x-m4a": {
    source: "nginx",
    extensions: [
      "m4a"
    ]
  },
  "audio/x-matroska": {
    source: "apache",
    extensions: [
      "mka"
    ]
  },
  "audio/x-mpegurl": {
    source: "apache",
    extensions: [
      "m3u"
    ]
  },
  "audio/x-ms-wax": {
    source: "apache",
    extensions: [
      "wax"
    ]
  },
  "audio/x-ms-wma": {
    source: "apache",
    extensions: [
      "wma"
    ]
  },
  "audio/x-pn-realaudio": {
    source: "apache",
    extensions: [
      "ram",
      "ra"
    ]
  },
  "audio/x-pn-realaudio-plugin": {
    source: "apache",
    extensions: [
      "rmp"
    ]
  },
  "audio/x-realaudio": {
    source: "nginx",
    extensions: [
      "ra"
    ]
  },
  "audio/x-tta": {
    source: "apache"
  },
  "audio/x-wav": {
    source: "apache",
    extensions: [
      "wav"
    ]
  },
  "audio/xm": {
    source: "apache",
    extensions: [
      "xm"
    ]
  },
  "chemical/x-cdx": {
    source: "apache",
    extensions: [
      "cdx"
    ]
  },
  "chemical/x-cif": {
    source: "apache",
    extensions: [
      "cif"
    ]
  },
  "chemical/x-cmdf": {
    source: "apache",
    extensions: [
      "cmdf"
    ]
  },
  "chemical/x-cml": {
    source: "apache",
    extensions: [
      "cml"
    ]
  },
  "chemical/x-csml": {
    source: "apache",
    extensions: [
      "csml"
    ]
  },
  "chemical/x-pdb": {
    source: "apache"
  },
  "chemical/x-xyz": {
    source: "apache",
    extensions: [
      "xyz"
    ]
  },
  "font/collection": {
    source: "iana",
    extensions: [
      "ttc"
    ]
  },
  "font/otf": {
    source: "iana",
    compressible: true,
    extensions: [
      "otf"
    ]
  },
  "font/sfnt": {
    source: "iana"
  },
  "font/ttf": {
    source: "iana",
    compressible: true,
    extensions: [
      "ttf"
    ]
  },
  "font/woff": {
    source: "iana",
    extensions: [
      "woff"
    ]
  },
  "font/woff2": {
    source: "iana",
    extensions: [
      "woff2"
    ]
  },
  "image/aces": {
    source: "iana",
    extensions: [
      "exr"
    ]
  },
  "image/apng": {
    compressible: false,
    extensions: [
      "apng"
    ]
  },
  "image/avci": {
    source: "iana",
    extensions: [
      "avci"
    ]
  },
  "image/avcs": {
    source: "iana",
    extensions: [
      "avcs"
    ]
  },
  "image/avif": {
    source: "iana",
    compressible: false,
    extensions: [
      "avif"
    ]
  },
  "image/bmp": {
    source: "iana",
    compressible: true,
    extensions: [
      "bmp"
    ]
  },
  "image/cgm": {
    source: "iana",
    extensions: [
      "cgm"
    ]
  },
  "image/dicom-rle": {
    source: "iana",
    extensions: [
      "drle"
    ]
  },
  "image/emf": {
    source: "iana",
    extensions: [
      "emf"
    ]
  },
  "image/fits": {
    source: "iana",
    extensions: [
      "fits"
    ]
  },
  "image/g3fax": {
    source: "iana",
    extensions: [
      "g3"
    ]
  },
  "image/gif": {
    source: "iana",
    compressible: false,
    extensions: [
      "gif"
    ]
  },
  "image/heic": {
    source: "iana",
    extensions: [
      "heic"
    ]
  },
  "image/heic-sequence": {
    source: "iana",
    extensions: [
      "heics"
    ]
  },
  "image/heif": {
    source: "iana",
    extensions: [
      "heif"
    ]
  },
  "image/heif-sequence": {
    source: "iana",
    extensions: [
      "heifs"
    ]
  },
  "image/hej2k": {
    source: "iana",
    extensions: [
      "hej2"
    ]
  },
  "image/hsj2": {
    source: "iana",
    extensions: [
      "hsj2"
    ]
  },
  "image/ief": {
    source: "iana",
    extensions: [
      "ief"
    ]
  },
  "image/jls": {
    source: "iana",
    extensions: [
      "jls"
    ]
  },
  "image/jp2": {
    source: "iana",
    compressible: false,
    extensions: [
      "jp2",
      "jpg2"
    ]
  },
  "image/jpeg": {
    source: "iana",
    compressible: false,
    extensions: [
      "jpeg",
      "jpg",
      "jpe"
    ]
  },
  "image/jph": {
    source: "iana",
    extensions: [
      "jph"
    ]
  },
  "image/jphc": {
    source: "iana",
    extensions: [
      "jhc"
    ]
  },
  "image/jpm": {
    source: "iana",
    compressible: false,
    extensions: [
      "jpm"
    ]
  },
  "image/jpx": {
    source: "iana",
    compressible: false,
    extensions: [
      "jpx",
      "jpf"
    ]
  },
  "image/jxr": {
    source: "iana",
    extensions: [
      "jxr"
    ]
  },
  "image/jxra": {
    source: "iana",
    extensions: [
      "jxra"
    ]
  },
  "image/jxrs": {
    source: "iana",
    extensions: [
      "jxrs"
    ]
  },
  "image/jxs": {
    source: "iana",
    extensions: [
      "jxs"
    ]
  },
  "image/jxsc": {
    source: "iana",
    extensions: [
      "jxsc"
    ]
  },
  "image/jxsi": {
    source: "iana",
    extensions: [
      "jxsi"
    ]
  },
  "image/jxss": {
    source: "iana",
    extensions: [
      "jxss"
    ]
  },
  "image/ktx": {
    source: "iana",
    extensions: [
      "ktx"
    ]
  },
  "image/ktx2": {
    source: "iana",
    extensions: [
      "ktx2"
    ]
  },
  "image/naplps": {
    source: "iana"
  },
  "image/pjpeg": {
    compressible: false
  },
  "image/png": {
    source: "iana",
    compressible: false,
    extensions: [
      "png"
    ]
  },
  "image/prs.btif": {
    source: "iana",
    extensions: [
      "btif"
    ]
  },
  "image/prs.pti": {
    source: "iana",
    extensions: [
      "pti"
    ]
  },
  "image/pwg-raster": {
    source: "iana"
  },
  "image/sgi": {
    source: "apache",
    extensions: [
      "sgi"
    ]
  },
  "image/svg+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "svg",
      "svgz"
    ]
  },
  "image/t38": {
    source: "iana",
    extensions: [
      "t38"
    ]
  },
  "image/tiff": {
    source: "iana",
    compressible: false,
    extensions: [
      "tif",
      "tiff"
    ]
  },
  "image/tiff-fx": {
    source: "iana",
    extensions: [
      "tfx"
    ]
  },
  "image/vnd.adobe.photoshop": {
    source: "iana",
    compressible: true,
    extensions: [
      "psd"
    ]
  },
  "image/vnd.airzip.accelerator.azv": {
    source: "iana",
    extensions: [
      "azv"
    ]
  },
  "image/vnd.cns.inf2": {
    source: "iana"
  },
  "image/vnd.dece.graphic": {
    source: "iana",
    extensions: [
      "uvi",
      "uvvi",
      "uvg",
      "uvvg"
    ]
  },
  "image/vnd.djvu": {
    source: "iana",
    extensions: [
      "djvu",
      "djv"
    ]
  },
  "image/vnd.dvb.subtitle": {
    source: "iana",
    extensions: [
      "sub"
    ]
  },
  "image/vnd.dwg": {
    source: "iana",
    extensions: [
      "dwg"
    ]
  },
  "image/vnd.dxf": {
    source: "iana",
    extensions: [
      "dxf"
    ]
  },
  "image/vnd.fastbidsheet": {
    source: "iana",
    extensions: [
      "fbs"
    ]
  },
  "image/vnd.fpx": {
    source: "iana",
    extensions: [
      "fpx"
    ]
  },
  "image/vnd.fst": {
    source: "iana",
    extensions: [
      "fst"
    ]
  },
  "image/vnd.fujixerox.edmics-mmr": {
    source: "iana",
    extensions: [
      "mmr"
    ]
  },
  "image/vnd.fujixerox.edmics-rlc": {
    source: "iana",
    extensions: [
      "rlc"
    ]
  },
  "image/vnd.globalgraphics.pgb": {
    source: "iana"
  },
  "image/vnd.microsoft.icon": {
    source: "iana",
    compressible: true,
    extensions: [
      "ico"
    ]
  },
  "image/vnd.mix": {
    source: "iana"
  },
  "image/vnd.mozilla.apng": {
    source: "iana"
  },
  "image/vnd.ms-dds": {
    compressible: true,
    extensions: [
      "dds"
    ]
  },
  "image/vnd.ms-modi": {
    source: "iana",
    extensions: [
      "mdi"
    ]
  },
  "image/vnd.ms-photo": {
    source: "apache",
    extensions: [
      "wdp"
    ]
  },
  "image/vnd.net-fpx": {
    source: "iana",
    extensions: [
      "npx"
    ]
  },
  "image/vnd.pco.b16": {
    source: "iana",
    extensions: [
      "b16"
    ]
  },
  "image/vnd.radiance": {
    source: "iana"
  },
  "image/vnd.sealed.png": {
    source: "iana"
  },
  "image/vnd.sealedmedia.softseal.gif": {
    source: "iana"
  },
  "image/vnd.sealedmedia.softseal.jpg": {
    source: "iana"
  },
  "image/vnd.svf": {
    source: "iana"
  },
  "image/vnd.tencent.tap": {
    source: "iana",
    extensions: [
      "tap"
    ]
  },
  "image/vnd.valve.source.texture": {
    source: "iana",
    extensions: [
      "vtf"
    ]
  },
  "image/vnd.wap.wbmp": {
    source: "iana",
    extensions: [
      "wbmp"
    ]
  },
  "image/vnd.xiff": {
    source: "iana",
    extensions: [
      "xif"
    ]
  },
  "image/vnd.zbrush.pcx": {
    source: "iana",
    extensions: [
      "pcx"
    ]
  },
  "image/webp": {
    source: "apache",
    extensions: [
      "webp"
    ]
  },
  "image/wmf": {
    source: "iana",
    extensions: [
      "wmf"
    ]
  },
  "image/x-3ds": {
    source: "apache",
    extensions: [
      "3ds"
    ]
  },
  "image/x-cmu-raster": {
    source: "apache",
    extensions: [
      "ras"
    ]
  },
  "image/x-cmx": {
    source: "apache",
    extensions: [
      "cmx"
    ]
  },
  "image/x-freehand": {
    source: "apache",
    extensions: [
      "fh",
      "fhc",
      "fh4",
      "fh5",
      "fh7"
    ]
  },
  "image/x-icon": {
    source: "apache",
    compressible: true,
    extensions: [
      "ico"
    ]
  },
  "image/x-jng": {
    source: "nginx",
    extensions: [
      "jng"
    ]
  },
  "image/x-mrsid-image": {
    source: "apache",
    extensions: [
      "sid"
    ]
  },
  "image/x-ms-bmp": {
    source: "nginx",
    compressible: true,
    extensions: [
      "bmp"
    ]
  },
  "image/x-pcx": {
    source: "apache",
    extensions: [
      "pcx"
    ]
  },
  "image/x-pict": {
    source: "apache",
    extensions: [
      "pic",
      "pct"
    ]
  },
  "image/x-portable-anymap": {
    source: "apache",
    extensions: [
      "pnm"
    ]
  },
  "image/x-portable-bitmap": {
    source: "apache",
    extensions: [
      "pbm"
    ]
  },
  "image/x-portable-graymap": {
    source: "apache",
    extensions: [
      "pgm"
    ]
  },
  "image/x-portable-pixmap": {
    source: "apache",
    extensions: [
      "ppm"
    ]
  },
  "image/x-rgb": {
    source: "apache",
    extensions: [
      "rgb"
    ]
  },
  "image/x-tga": {
    source: "apache",
    extensions: [
      "tga"
    ]
  },
  "image/x-xbitmap": {
    source: "apache",
    extensions: [
      "xbm"
    ]
  },
  "image/x-xcf": {
    compressible: false
  },
  "image/x-xpixmap": {
    source: "apache",
    extensions: [
      "xpm"
    ]
  },
  "image/x-xwindowdump": {
    source: "apache",
    extensions: [
      "xwd"
    ]
  },
  "message/cpim": {
    source: "iana"
  },
  "message/delivery-status": {
    source: "iana"
  },
  "message/disposition-notification": {
    source: "iana",
    extensions: [
      "disposition-notification"
    ]
  },
  "message/external-body": {
    source: "iana"
  },
  "message/feedback-report": {
    source: "iana"
  },
  "message/global": {
    source: "iana",
    extensions: [
      "u8msg"
    ]
  },
  "message/global-delivery-status": {
    source: "iana",
    extensions: [
      "u8dsn"
    ]
  },
  "message/global-disposition-notification": {
    source: "iana",
    extensions: [
      "u8mdn"
    ]
  },
  "message/global-headers": {
    source: "iana",
    extensions: [
      "u8hdr"
    ]
  },
  "message/http": {
    source: "iana",
    compressible: false
  },
  "message/imdn+xml": {
    source: "iana",
    compressible: true
  },
  "message/news": {
    source: "iana"
  },
  "message/partial": {
    source: "iana",
    compressible: false
  },
  "message/rfc822": {
    source: "iana",
    compressible: true,
    extensions: [
      "eml",
      "mime"
    ]
  },
  "message/s-http": {
    source: "iana"
  },
  "message/sip": {
    source: "iana"
  },
  "message/sipfrag": {
    source: "iana"
  },
  "message/tracking-status": {
    source: "iana"
  },
  "message/vnd.si.simp": {
    source: "iana"
  },
  "message/vnd.wfa.wsc": {
    source: "iana",
    extensions: [
      "wsc"
    ]
  },
  "model/3mf": {
    source: "iana",
    extensions: [
      "3mf"
    ]
  },
  "model/e57": {
    source: "iana"
  },
  "model/gltf+json": {
    source: "iana",
    compressible: true,
    extensions: [
      "gltf"
    ]
  },
  "model/gltf-binary": {
    source: "iana",
    compressible: true,
    extensions: [
      "glb"
    ]
  },
  "model/iges": {
    source: "iana",
    compressible: false,
    extensions: [
      "igs",
      "iges"
    ]
  },
  "model/mesh": {
    source: "iana",
    compressible: false,
    extensions: [
      "msh",
      "mesh",
      "silo"
    ]
  },
  "model/mtl": {
    source: "iana",
    extensions: [
      "mtl"
    ]
  },
  "model/obj": {
    source: "iana",
    extensions: [
      "obj"
    ]
  },
  "model/step": {
    source: "iana"
  },
  "model/step+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "stpx"
    ]
  },
  "model/step+zip": {
    source: "iana",
    compressible: false,
    extensions: [
      "stpz"
    ]
  },
  "model/step-xml+zip": {
    source: "iana",
    compressible: false,
    extensions: [
      "stpxz"
    ]
  },
  "model/stl": {
    source: "iana",
    extensions: [
      "stl"
    ]
  },
  "model/vnd.collada+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "dae"
    ]
  },
  "model/vnd.dwf": {
    source: "iana",
    extensions: [
      "dwf"
    ]
  },
  "model/vnd.flatland.3dml": {
    source: "iana"
  },
  "model/vnd.gdl": {
    source: "iana",
    extensions: [
      "gdl"
    ]
  },
  "model/vnd.gs-gdl": {
    source: "apache"
  },
  "model/vnd.gs.gdl": {
    source: "iana"
  },
  "model/vnd.gtw": {
    source: "iana",
    extensions: [
      "gtw"
    ]
  },
  "model/vnd.moml+xml": {
    source: "iana",
    compressible: true
  },
  "model/vnd.mts": {
    source: "iana",
    extensions: [
      "mts"
    ]
  },
  "model/vnd.opengex": {
    source: "iana",
    extensions: [
      "ogex"
    ]
  },
  "model/vnd.parasolid.transmit.binary": {
    source: "iana",
    extensions: [
      "x_b"
    ]
  },
  "model/vnd.parasolid.transmit.text": {
    source: "iana",
    extensions: [
      "x_t"
    ]
  },
  "model/vnd.pytha.pyox": {
    source: "iana"
  },
  "model/vnd.rosette.annotated-data-model": {
    source: "iana"
  },
  "model/vnd.sap.vds": {
    source: "iana",
    extensions: [
      "vds"
    ]
  },
  "model/vnd.usdz+zip": {
    source: "iana",
    compressible: false,
    extensions: [
      "usdz"
    ]
  },
  "model/vnd.valve.source.compiled-map": {
    source: "iana",
    extensions: [
      "bsp"
    ]
  },
  "model/vnd.vtu": {
    source: "iana",
    extensions: [
      "vtu"
    ]
  },
  "model/vrml": {
    source: "iana",
    compressible: false,
    extensions: [
      "wrl",
      "vrml"
    ]
  },
  "model/x3d+binary": {
    source: "apache",
    compressible: false,
    extensions: [
      "x3db",
      "x3dbz"
    ]
  },
  "model/x3d+fastinfoset": {
    source: "iana",
    extensions: [
      "x3db"
    ]
  },
  "model/x3d+vrml": {
    source: "apache",
    compressible: false,
    extensions: [
      "x3dv",
      "x3dvz"
    ]
  },
  "model/x3d+xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "x3d",
      "x3dz"
    ]
  },
  "model/x3d-vrml": {
    source: "iana",
    extensions: [
      "x3dv"
    ]
  },
  "multipart/alternative": {
    source: "iana",
    compressible: false
  },
  "multipart/appledouble": {
    source: "iana"
  },
  "multipart/byteranges": {
    source: "iana"
  },
  "multipart/digest": {
    source: "iana"
  },
  "multipart/encrypted": {
    source: "iana",
    compressible: false
  },
  "multipart/form-data": {
    source: "iana",
    compressible: false
  },
  "multipart/header-set": {
    source: "iana"
  },
  "multipart/mixed": {
    source: "iana"
  },
  "multipart/multilingual": {
    source: "iana"
  },
  "multipart/parallel": {
    source: "iana"
  },
  "multipart/related": {
    source: "iana",
    compressible: false
  },
  "multipart/report": {
    source: "iana"
  },
  "multipart/signed": {
    source: "iana",
    compressible: false
  },
  "multipart/vnd.bint.med-plus": {
    source: "iana"
  },
  "multipart/voice-message": {
    source: "iana"
  },
  "multipart/x-mixed-replace": {
    source: "iana"
  },
  "text/1d-interleaved-parityfec": {
    source: "iana"
  },
  "text/cache-manifest": {
    source: "iana",
    compressible: true,
    extensions: [
      "appcache",
      "manifest"
    ]
  },
  "text/calendar": {
    source: "iana",
    extensions: [
      "ics",
      "ifb"
    ]
  },
  "text/calender": {
    compressible: true
  },
  "text/cmd": {
    compressible: true
  },
  "text/coffeescript": {
    extensions: [
      "coffee",
      "litcoffee"
    ]
  },
  "text/cql": {
    source: "iana"
  },
  "text/cql-expression": {
    source: "iana"
  },
  "text/cql-identifier": {
    source: "iana"
  },
  "text/css": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "css"
    ]
  },
  "text/csv": {
    source: "iana",
    compressible: true,
    extensions: [
      "csv"
    ]
  },
  "text/csv-schema": {
    source: "iana"
  },
  "text/directory": {
    source: "iana"
  },
  "text/dns": {
    source: "iana"
  },
  "text/ecmascript": {
    source: "iana"
  },
  "text/encaprtp": {
    source: "iana"
  },
  "text/enriched": {
    source: "iana"
  },
  "text/fhirpath": {
    source: "iana"
  },
  "text/flexfec": {
    source: "iana"
  },
  "text/fwdred": {
    source: "iana"
  },
  "text/gff3": {
    source: "iana"
  },
  "text/grammar-ref-list": {
    source: "iana"
  },
  "text/html": {
    source: "iana",
    compressible: true,
    extensions: [
      "html",
      "htm",
      "shtml"
    ]
  },
  "text/jade": {
    extensions: [
      "jade"
    ]
  },
  "text/javascript": {
    source: "iana",
    compressible: true
  },
  "text/jcr-cnd": {
    source: "iana"
  },
  "text/jsx": {
    compressible: true,
    extensions: [
      "jsx"
    ]
  },
  "text/less": {
    compressible: true,
    extensions: [
      "less"
    ]
  },
  "text/markdown": {
    source: "iana",
    compressible: true,
    extensions: [
      "markdown",
      "md"
    ]
  },
  "text/mathml": {
    source: "nginx",
    extensions: [
      "mml"
    ]
  },
  "text/mdx": {
    compressible: true,
    extensions: [
      "mdx"
    ]
  },
  "text/mizar": {
    source: "iana"
  },
  "text/n3": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "n3"
    ]
  },
  "text/parameters": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/parityfec": {
    source: "iana"
  },
  "text/plain": {
    source: "iana",
    compressible: true,
    extensions: [
      "txt",
      "text",
      "conf",
      "def",
      "list",
      "log",
      "in",
      "ini"
    ]
  },
  "text/provenance-notation": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/prs.fallenstein.rst": {
    source: "iana"
  },
  "text/prs.lines.tag": {
    source: "iana",
    extensions: [
      "dsc"
    ]
  },
  "text/prs.prop.logic": {
    source: "iana"
  },
  "text/raptorfec": {
    source: "iana"
  },
  "text/red": {
    source: "iana"
  },
  "text/rfc822-headers": {
    source: "iana"
  },
  "text/richtext": {
    source: "iana",
    compressible: true,
    extensions: [
      "rtx"
    ]
  },
  "text/rtf": {
    source: "iana",
    compressible: true,
    extensions: [
      "rtf"
    ]
  },
  "text/rtp-enc-aescm128": {
    source: "iana"
  },
  "text/rtploopback": {
    source: "iana"
  },
  "text/rtx": {
    source: "iana"
  },
  "text/sgml": {
    source: "iana",
    extensions: [
      "sgml",
      "sgm"
    ]
  },
  "text/shaclc": {
    source: "iana"
  },
  "text/shex": {
    source: "iana",
    extensions: [
      "shex"
    ]
  },
  "text/slim": {
    extensions: [
      "slim",
      "slm"
    ]
  },
  "text/spdx": {
    source: "iana",
    extensions: [
      "spdx"
    ]
  },
  "text/strings": {
    source: "iana"
  },
  "text/stylus": {
    extensions: [
      "stylus",
      "styl"
    ]
  },
  "text/t140": {
    source: "iana"
  },
  "text/tab-separated-values": {
    source: "iana",
    compressible: true,
    extensions: [
      "tsv"
    ]
  },
  "text/troff": {
    source: "iana",
    extensions: [
      "t",
      "tr",
      "roff",
      "man",
      "me",
      "ms"
    ]
  },
  "text/turtle": {
    source: "iana",
    charset: "UTF-8",
    extensions: [
      "ttl"
    ]
  },
  "text/ulpfec": {
    source: "iana"
  },
  "text/uri-list": {
    source: "iana",
    compressible: true,
    extensions: [
      "uri",
      "uris",
      "urls"
    ]
  },
  "text/vcard": {
    source: "iana",
    compressible: true,
    extensions: [
      "vcard"
    ]
  },
  "text/vnd.a": {
    source: "iana"
  },
  "text/vnd.abc": {
    source: "iana"
  },
  "text/vnd.ascii-art": {
    source: "iana"
  },
  "text/vnd.curl": {
    source: "iana",
    extensions: [
      "curl"
    ]
  },
  "text/vnd.curl.dcurl": {
    source: "apache",
    extensions: [
      "dcurl"
    ]
  },
  "text/vnd.curl.mcurl": {
    source: "apache",
    extensions: [
      "mcurl"
    ]
  },
  "text/vnd.curl.scurl": {
    source: "apache",
    extensions: [
      "scurl"
    ]
  },
  "text/vnd.debian.copyright": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/vnd.dmclientscript": {
    source: "iana"
  },
  "text/vnd.dvb.subtitle": {
    source: "iana",
    extensions: [
      "sub"
    ]
  },
  "text/vnd.esmertec.theme-descriptor": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/vnd.familysearch.gedcom": {
    source: "iana",
    extensions: [
      "ged"
    ]
  },
  "text/vnd.ficlab.flt": {
    source: "iana"
  },
  "text/vnd.fly": {
    source: "iana",
    extensions: [
      "fly"
    ]
  },
  "text/vnd.fmi.flexstor": {
    source: "iana",
    extensions: [
      "flx"
    ]
  },
  "text/vnd.gml": {
    source: "iana"
  },
  "text/vnd.graphviz": {
    source: "iana",
    extensions: [
      "gv"
    ]
  },
  "text/vnd.hans": {
    source: "iana"
  },
  "text/vnd.hgl": {
    source: "iana"
  },
  "text/vnd.in3d.3dml": {
    source: "iana",
    extensions: [
      "3dml"
    ]
  },
  "text/vnd.in3d.spot": {
    source: "iana",
    extensions: [
      "spot"
    ]
  },
  "text/vnd.iptc.newsml": {
    source: "iana"
  },
  "text/vnd.iptc.nitf": {
    source: "iana"
  },
  "text/vnd.latex-z": {
    source: "iana"
  },
  "text/vnd.motorola.reflex": {
    source: "iana"
  },
  "text/vnd.ms-mediapackage": {
    source: "iana"
  },
  "text/vnd.net2phone.commcenter.command": {
    source: "iana"
  },
  "text/vnd.radisys.msml-basic-layout": {
    source: "iana"
  },
  "text/vnd.senx.warpscript": {
    source: "iana"
  },
  "text/vnd.si.uricatalogue": {
    source: "iana"
  },
  "text/vnd.sosi": {
    source: "iana"
  },
  "text/vnd.sun.j2me.app-descriptor": {
    source: "iana",
    charset: "UTF-8",
    extensions: [
      "jad"
    ]
  },
  "text/vnd.trolltech.linguist": {
    source: "iana",
    charset: "UTF-8"
  },
  "text/vnd.wap.si": {
    source: "iana"
  },
  "text/vnd.wap.sl": {
    source: "iana"
  },
  "text/vnd.wap.wml": {
    source: "iana",
    extensions: [
      "wml"
    ]
  },
  "text/vnd.wap.wmlscript": {
    source: "iana",
    extensions: [
      "wmls"
    ]
  },
  "text/vtt": {
    source: "iana",
    charset: "UTF-8",
    compressible: true,
    extensions: [
      "vtt"
    ]
  },
  "text/x-asm": {
    source: "apache",
    extensions: [
      "s",
      "asm"
    ]
  },
  "text/x-c": {
    source: "apache",
    extensions: [
      "c",
      "cc",
      "cxx",
      "cpp",
      "h",
      "hh",
      "dic"
    ]
  },
  "text/x-component": {
    source: "nginx",
    extensions: [
      "htc"
    ]
  },
  "text/x-fortran": {
    source: "apache",
    extensions: [
      "f",
      "for",
      "f77",
      "f90"
    ]
  },
  "text/x-gwt-rpc": {
    compressible: true
  },
  "text/x-handlebars-template": {
    extensions: [
      "hbs"
    ]
  },
  "text/x-java-source": {
    source: "apache",
    extensions: [
      "java"
    ]
  },
  "text/x-jquery-tmpl": {
    compressible: true
  },
  "text/x-lua": {
    extensions: [
      "lua"
    ]
  },
  "text/x-markdown": {
    compressible: true,
    extensions: [
      "mkd"
    ]
  },
  "text/x-nfo": {
    source: "apache",
    extensions: [
      "nfo"
    ]
  },
  "text/x-opml": {
    source: "apache",
    extensions: [
      "opml"
    ]
  },
  "text/x-org": {
    compressible: true,
    extensions: [
      "org"
    ]
  },
  "text/x-pascal": {
    source: "apache",
    extensions: [
      "p",
      "pas"
    ]
  },
  "text/x-processing": {
    compressible: true,
    extensions: [
      "pde"
    ]
  },
  "text/x-sass": {
    extensions: [
      "sass"
    ]
  },
  "text/x-scss": {
    extensions: [
      "scss"
    ]
  },
  "text/x-setext": {
    source: "apache",
    extensions: [
      "etx"
    ]
  },
  "text/x-sfv": {
    source: "apache",
    extensions: [
      "sfv"
    ]
  },
  "text/x-suse-ymp": {
    compressible: true,
    extensions: [
      "ymp"
    ]
  },
  "text/x-uuencode": {
    source: "apache",
    extensions: [
      "uu"
    ]
  },
  "text/x-vcalendar": {
    source: "apache",
    extensions: [
      "vcs"
    ]
  },
  "text/x-vcard": {
    source: "apache",
    extensions: [
      "vcf"
    ]
  },
  "text/xml": {
    source: "iana",
    compressible: true,
    extensions: [
      "xml"
    ]
  },
  "text/xml-external-parsed-entity": {
    source: "iana"
  },
  "text/yaml": {
    compressible: true,
    extensions: [
      "yaml",
      "yml"
    ]
  },
  "video/1d-interleaved-parityfec": {
    source: "iana"
  },
  "video/3gpp": {
    source: "iana",
    extensions: [
      "3gp",
      "3gpp"
    ]
  },
  "video/3gpp-tt": {
    source: "iana"
  },
  "video/3gpp2": {
    source: "iana",
    extensions: [
      "3g2"
    ]
  },
  "video/av1": {
    source: "iana"
  },
  "video/bmpeg": {
    source: "iana"
  },
  "video/bt656": {
    source: "iana"
  },
  "video/celb": {
    source: "iana"
  },
  "video/dv": {
    source: "iana"
  },
  "video/encaprtp": {
    source: "iana"
  },
  "video/ffv1": {
    source: "iana"
  },
  "video/flexfec": {
    source: "iana"
  },
  "video/h261": {
    source: "iana",
    extensions: [
      "h261"
    ]
  },
  "video/h263": {
    source: "iana",
    extensions: [
      "h263"
    ]
  },
  "video/h263-1998": {
    source: "iana"
  },
  "video/h263-2000": {
    source: "iana"
  },
  "video/h264": {
    source: "iana",
    extensions: [
      "h264"
    ]
  },
  "video/h264-rcdo": {
    source: "iana"
  },
  "video/h264-svc": {
    source: "iana"
  },
  "video/h265": {
    source: "iana"
  },
  "video/iso.segment": {
    source: "iana",
    extensions: [
      "m4s"
    ]
  },
  "video/jpeg": {
    source: "iana",
    extensions: [
      "jpgv"
    ]
  },
  "video/jpeg2000": {
    source: "iana"
  },
  "video/jpm": {
    source: "apache",
    extensions: [
      "jpm",
      "jpgm"
    ]
  },
  "video/jxsv": {
    source: "iana"
  },
  "video/mj2": {
    source: "iana",
    extensions: [
      "mj2",
      "mjp2"
    ]
  },
  "video/mp1s": {
    source: "iana"
  },
  "video/mp2p": {
    source: "iana"
  },
  "video/mp2t": {
    source: "iana",
    extensions: [
      "ts"
    ]
  },
  "video/mp4": {
    source: "iana",
    compressible: false,
    extensions: [
      "mp4",
      "mp4v",
      "mpg4"
    ]
  },
  "video/mp4v-es": {
    source: "iana"
  },
  "video/mpeg": {
    source: "iana",
    compressible: false,
    extensions: [
      "mpeg",
      "mpg",
      "mpe",
      "m1v",
      "m2v"
    ]
  },
  "video/mpeg4-generic": {
    source: "iana"
  },
  "video/mpv": {
    source: "iana"
  },
  "video/nv": {
    source: "iana"
  },
  "video/ogg": {
    source: "iana",
    compressible: false,
    extensions: [
      "ogv"
    ]
  },
  "video/parityfec": {
    source: "iana"
  },
  "video/pointer": {
    source: "iana"
  },
  "video/quicktime": {
    source: "iana",
    compressible: false,
    extensions: [
      "qt",
      "mov"
    ]
  },
  "video/raptorfec": {
    source: "iana"
  },
  "video/raw": {
    source: "iana"
  },
  "video/rtp-enc-aescm128": {
    source: "iana"
  },
  "video/rtploopback": {
    source: "iana"
  },
  "video/rtx": {
    source: "iana"
  },
  "video/scip": {
    source: "iana"
  },
  "video/smpte291": {
    source: "iana"
  },
  "video/smpte292m": {
    source: "iana"
  },
  "video/ulpfec": {
    source: "iana"
  },
  "video/vc1": {
    source: "iana"
  },
  "video/vc2": {
    source: "iana"
  },
  "video/vnd.cctv": {
    source: "iana"
  },
  "video/vnd.dece.hd": {
    source: "iana",
    extensions: [
      "uvh",
      "uvvh"
    ]
  },
  "video/vnd.dece.mobile": {
    source: "iana",
    extensions: [
      "uvm",
      "uvvm"
    ]
  },
  "video/vnd.dece.mp4": {
    source: "iana"
  },
  "video/vnd.dece.pd": {
    source: "iana",
    extensions: [
      "uvp",
      "uvvp"
    ]
  },
  "video/vnd.dece.sd": {
    source: "iana",
    extensions: [
      "uvs",
      "uvvs"
    ]
  },
  "video/vnd.dece.video": {
    source: "iana",
    extensions: [
      "uvv",
      "uvvv"
    ]
  },
  "video/vnd.directv.mpeg": {
    source: "iana"
  },
  "video/vnd.directv.mpeg-tts": {
    source: "iana"
  },
  "video/vnd.dlna.mpeg-tts": {
    source: "iana"
  },
  "video/vnd.dvb.file": {
    source: "iana",
    extensions: [
      "dvb"
    ]
  },
  "video/vnd.fvt": {
    source: "iana",
    extensions: [
      "fvt"
    ]
  },
  "video/vnd.hns.video": {
    source: "iana"
  },
  "video/vnd.iptvforum.1dparityfec-1010": {
    source: "iana"
  },
  "video/vnd.iptvforum.1dparityfec-2005": {
    source: "iana"
  },
  "video/vnd.iptvforum.2dparityfec-1010": {
    source: "iana"
  },
  "video/vnd.iptvforum.2dparityfec-2005": {
    source: "iana"
  },
  "video/vnd.iptvforum.ttsavc": {
    source: "iana"
  },
  "video/vnd.iptvforum.ttsmpeg2": {
    source: "iana"
  },
  "video/vnd.motorola.video": {
    source: "iana"
  },
  "video/vnd.motorola.videop": {
    source: "iana"
  },
  "video/vnd.mpegurl": {
    source: "iana",
    extensions: [
      "mxu",
      "m4u"
    ]
  },
  "video/vnd.ms-playready.media.pyv": {
    source: "iana",
    extensions: [
      "pyv"
    ]
  },
  "video/vnd.nokia.interleaved-multimedia": {
    source: "iana"
  },
  "video/vnd.nokia.mp4vr": {
    source: "iana"
  },
  "video/vnd.nokia.videovoip": {
    source: "iana"
  },
  "video/vnd.objectvideo": {
    source: "iana"
  },
  "video/vnd.radgamettools.bink": {
    source: "iana"
  },
  "video/vnd.radgamettools.smacker": {
    source: "iana"
  },
  "video/vnd.sealed.mpeg1": {
    source: "iana"
  },
  "video/vnd.sealed.mpeg4": {
    source: "iana"
  },
  "video/vnd.sealed.swf": {
    source: "iana"
  },
  "video/vnd.sealedmedia.softseal.mov": {
    source: "iana"
  },
  "video/vnd.uvvu.mp4": {
    source: "iana",
    extensions: [
      "uvu",
      "uvvu"
    ]
  },
  "video/vnd.vivo": {
    source: "iana",
    extensions: [
      "viv"
    ]
  },
  "video/vnd.youtube.yt": {
    source: "iana"
  },
  "video/vp8": {
    source: "iana"
  },
  "video/vp9": {
    source: "iana"
  },
  "video/webm": {
    source: "apache",
    compressible: false,
    extensions: [
      "webm"
    ]
  },
  "video/x-f4v": {
    source: "apache",
    extensions: [
      "f4v"
    ]
  },
  "video/x-fli": {
    source: "apache",
    extensions: [
      "fli"
    ]
  },
  "video/x-flv": {
    source: "apache",
    compressible: false,
    extensions: [
      "flv"
    ]
  },
  "video/x-m4v": {
    source: "apache",
    extensions: [
      "m4v"
    ]
  },
  "video/x-matroska": {
    source: "apache",
    compressible: false,
    extensions: [
      "mkv",
      "mk3d",
      "mks"
    ]
  },
  "video/x-mng": {
    source: "apache",
    extensions: [
      "mng"
    ]
  },
  "video/x-ms-asf": {
    source: "apache",
    extensions: [
      "asf",
      "asx"
    ]
  },
  "video/x-ms-vob": {
    source: "apache",
    extensions: [
      "vob"
    ]
  },
  "video/x-ms-wm": {
    source: "apache",
    extensions: [
      "wm"
    ]
  },
  "video/x-ms-wmv": {
    source: "apache",
    compressible: false,
    extensions: [
      "wmv"
    ]
  },
  "video/x-ms-wmx": {
    source: "apache",
    extensions: [
      "wmx"
    ]
  },
  "video/x-ms-wvx": {
    source: "apache",
    extensions: [
      "wvx"
    ]
  },
  "video/x-msvideo": {
    source: "apache",
    extensions: [
      "avi"
    ]
  },
  "video/x-sgi-movie": {
    source: "apache",
    extensions: [
      "movie"
    ]
  },
  "video/x-smv": {
    source: "apache",
    extensions: [
      "smv"
    ]
  },
  "x-conference/x-cooltalk": {
    source: "apache",
    extensions: [
      "ice"
    ]
  },
  "x-shader/x-fragment": {
    compressible: true
  },
  "x-shader/x-vertex": {
    compressible: true
  }
};
/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */
var mimeDb = require$$0;
/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
(function(exports) {
  var db = mimeDb;
  var extname2 = pathBrowserify.extname;
  var EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/;
  var TEXT_TYPE_REGEXP = /^text\//i;
  exports.charset = charset;
  exports.charsets = { lookup: charset };
  exports.contentType = contentType;
  exports.extension = extension2;
  exports.extensions = /* @__PURE__ */ Object.create(null);
  exports.lookup = lookup2;
  exports.types = /* @__PURE__ */ Object.create(null);
  populateMaps(exports.extensions, exports.types);
  function charset(type2) {
    if (!type2 || typeof type2 !== "string") {
      return false;
    }
    var match5 = EXTRACT_TYPE_REGEXP.exec(type2);
    var mime = match5 && db[match5[1].toLowerCase()];
    if (mime && mime.charset) {
      return mime.charset;
    }
    if (match5 && TEXT_TYPE_REGEXP.test(match5[1])) {
      return "UTF-8";
    }
    return false;
  }
  function contentType(str) {
    if (!str || typeof str !== "string") {
      return false;
    }
    var mime = str.indexOf("/") === -1 ? exports.lookup(str) : str;
    if (!mime) {
      return false;
    }
    if (mime.indexOf("charset") === -1) {
      var charset2 = exports.charset(mime);
      if (charset2) mime += "; charset=" + charset2.toLowerCase();
    }
    return mime;
  }
  function extension2(type2) {
    if (!type2 || typeof type2 !== "string") {
      return false;
    }
    var match5 = EXTRACT_TYPE_REGEXP.exec(type2);
    var exts = match5 && exports.extensions[match5[1].toLowerCase()];
    if (!exts || !exts.length) {
      return false;
    }
    return exts[0];
  }
  function lookup2(path3) {
    if (!path3 || typeof path3 !== "string") {
      return false;
    }
    var extension3 = extname2("x." + path3).toLowerCase().substr(1);
    if (!extension3) {
      return false;
    }
    return exports.types[extension3] || false;
  }
  function populateMaps(extensions, types2) {
    var preference = ["nginx", "apache", void 0, "iana"];
    Object.keys(db).forEach(function forEachMimeType(type2) {
      var mime = db[type2];
      var exts = mime.extensions;
      if (!exts || !exts.length) {
        return;
      }
      extensions[type2] = exts;
      for (var i3 = 0; i3 < exts.length; i3++) {
        var extension3 = exts[i3];
        if (types2[extension3]) {
          var from2 = preference.indexOf(db[types2[extension3]].source);
          var to2 = preference.indexOf(mime.source);
          if (types2[extension3] !== "application/octet-stream" && (from2 > to2 || from2 === to2 && types2[extension3].substr(0, 12) === "application/")) {
            continue;
          }
        }
        types2[extension3] = type2;
      }
    });
  }
})(mimeTypes);
const mimetype = /* @__PURE__ */ getDefaultExportFromCjs$1(mimeTypes);
const extension = (fileName) => {
  const type2 = mimetype.contentType(fileName);
  if (!type2) return fileName.split(".").pop();
  return mimetype.extension(type2);
};
const styles$f = (theme2) => ({
  root: {
    display: "flex",
    width: "100%",
    maxWidth: 195,
    alignItems: "baseline"
  },
  fullBar: {
    display: "flex",
    height: 8,
    width: "100%",
    backgroundColor: theme2.grey8,
    borderRadius: 10
  },
  dynamicBar: {
    height: "100%",
    width: (props2) => `${props2.completed}%` || 0,
    background: "linear-gradient(90deg, #30CECA 0%, #6BEDD8 100%)",
    borderRadius: "inherit",
    transition: "width 200ms linear"
  },
  labelWrapper: {
    display: "inline-flex",
    marginLeft: 5,
    "& span:last-child": {
      "&:first-letter": {
        textTransform: "uppercase"
      }
    }
  },
  progressWrapper: {
    display: "inline-flex",
    marginRight: 3,
    fontWeight: 600,
    "& span:first-child": {
      width: 15,
      textAlign: "right"
    }
  }
});
const ProgressBar = ({
  classes,
  completed,
  step: step2 = "uploading"
}) => /* @__PURE__ */ jsxs("div", { className: classes.root, "data-cy": "forms-js-progress-bar", children: [
  /* @__PURE__ */ jsx$1("div", { className: classes.fullBar, children: /* @__PURE__ */ jsx$1("div", { className: classes.dynamicBar }) }),
  /* @__PURE__ */ jsxs("div", { className: classes.labelWrapper, children: [
    /* @__PURE__ */ jsxs("div", { className: classes.progressWrapper, children: [
      /* @__PURE__ */ jsx$1("span", { children: String(completed) }),
      /* @__PURE__ */ jsx$1("span", { children: "%" })
    ] }),
    /* @__PURE__ */ jsxs("span", { children: [
      "(",
      step2,
      "...)"
    ] })
  ] })
] });
ProgressBar.defaultProps = {
  completed: void 0,
  step: void 0
};
const ProgressBar$1 = injectSheet(styles$f)(React__default.memo(ProgressBar));
const styles$e = (theme2) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 17,
    marginRight: 20,
    gap: "10px",
    color: theme2.grey1,
    "&[data-is-error=true]": {
      color: "#BD0024"
    }
  },
  fileWrapper: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "hidden",
    flexFlow: "row nowrap",
    gap: "7px"
  },
  name: {
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "15px",
    color: theme2.grey1,
    flexGrow: 1,
    overflow: "hidden"
  },
  fileDetails: {
    display: "flex",
    alignItems: "center",
    fontSize: 10,
    color: theme2.grey4,
    gap: "5px"
  },
  checkIcon: {
    color: theme2.validGreenDark
  },
  errorMessage: {
    color: theme2.warningRed
  },
  deleteBtn: {
    outline: "none",
    color: theme2.grey1,
    cursor: "pointer",
    transition: "color 100ms linear",
    "&:focus": {
      color: theme2.indigo3
    },
    "&:hover": {
      color: theme2.indigo3
    }
  }
});
const File$1 = ({
  classes,
  file,
  handleDeleteFile,
  maxFileSize,
  disabled
}) => {
  const { id: id2, name: name2, size: size2, uploadPercent, errorType } = file;
  const isUploading = uploadPercent >= 0;
  const renderSize = React__default.useCallback(
    () => isUploading ? /* @__PURE__ */ jsx$1(ProgressBar$1, { completed: uploadPercent }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
      filesize(size2, { round: 1 }),
      /* @__PURE__ */ jsx$1("div", { className: classes.checkIcon, children: /* @__PURE__ */ jsx$1(Icon$2, { name: "Tick", size: 16 }) })
    ] }),
    [isUploading, uploadPercent, size2, classes.checkIcon]
  );
  const renderError = React__default.useCallback(() => {
    switch (errorType) {
      case "size":
        return /* @__PURE__ */ jsxs("div", { "data-cy": "forms-js-file-error", className: classes.errorMessage, children: [
          "File size error: this file is over the ",
          filesize(maxFileSize),
          " ",
          "limit."
        ] });
      case "extension":
        return /* @__PURE__ */ jsxs("div", { "data-cy": "forms-js-file-error", className: classes.errorMessage, children: [
          "File type error:",
          " ",
          `.${extension(name2)} files are not supported in
                Trace.`
        ] });
      default:
        return /* @__PURE__ */ jsx$1("div", { "data-cy": "forms-js-file-error", className: classes.errorMessage, children: "File error." });
    }
  }, [classes.errorMessage, errorType, maxFileSize, name2]);
  return /* @__PURE__ */ jsxs(
    "li",
    {
      className: classes.root,
      "data-is-uploading": isUploading,
      "data-is-error": !!errorType,
      "data-cy": "forms-js-file",
      children: [
        /* @__PURE__ */ jsxs("div", { className: classes.fileWrapper, children: [
          /* @__PURE__ */ jsx$1(TextEllipsis$1, { className: classes.name, text: name2, middleEllipsis: true }),
          /* @__PURE__ */ jsx$1("div", { className: classes.fileDetails, children: !errorType ? renderSize() : renderError() })
        ] }),
        !disabled && /* @__PURE__ */ jsx$1(
          "button",
          {
            "data-cy": "forms-js-delete-file",
            className: classes.deleteBtn,
            title: "delete file",
            type: "button",
            onClick: () => handleDeleteFile(id2),
            children: /* @__PURE__ */ jsx$1(Icon$2, { name: "Cross", size: 16 })
          }
        )
      ]
    },
    id2
  );
};
const File$2 = injectSheet(styles$e)(React__default.memo(File$1));
const styles$d = (theme2) => ({
  root: {
    display: "inline-flex",
    justifyContent: "flex-end",
    marginBottom: 15,
    width: "10%"
  },
  filesInfo: {
    display: "flex",
    fontWeight: "normal",
    fontSize: 12,
    lineHeight: "15px"
  },
  errorsCount: {
    display: "inline-flex",
    paddingRight: 10,
    color: theme2.warningRed,
    "& span:last-child": {
      paddingLeft: 3
    }
  },
  filesCount: {
    display: "inline-flex",
    width: "100%",
    color: theme2.indigoPastel1,
    "& span:last-child": {
      paddingLeft: 3
    }
  }
});
const Label = ({
  classes,
  filesCount = 0,
  errorsCount = 0
}) => /* @__PURE__ */ jsx$1("div", { className: classes.root, children: /* @__PURE__ */ jsxs("div", { className: classes.filesInfo, children: [
  errorsCount > 0 && /* @__PURE__ */ jsxs("span", { className: classes.errorsCount, children: [
    /* @__PURE__ */ jsx$1("span", { children: String(errorsCount) }),
    /* @__PURE__ */ jsxs("span", { children: [
      " error",
      errorsCount > 1 && "s"
    ] })
  ] }),
  /* @__PURE__ */ jsxs("span", { className: classes.filesCount, children: [
    /* @__PURE__ */ jsx$1("span", { children: String(filesCount) }),
    /* @__PURE__ */ jsxs("span", { children: [
      " file",
      filesCount > 1 && "s"
    ] })
  ] })
] }) });
const Label$1 = injectSheet(styles$d)(React__default.memo(Label));
const styles$c = (theme2) => ({
  root: {
    "& h5": {
      marginBottom: 10,
      fontWeight: 600,
      fontSize: 11,
      lineHeight: " 14px",
      color: theme2.grey1,
      "&::first-letter": {
        textTransform: "uppercase"
      }
    },
    "& li": {
      fontWeight: "normal",
      fontSize: 10,
      lineHeight: " 13px",
      color: theme2.grey1,
      "&:not(:last-child)": {
        marginBottom: 5
      },
      "&::first-letter": {
        textTransform: "uppercase"
      },
      "& span": {
        paddingLeft: 2,
        color: theme2.grey4,
        '&[data-has-more-extension="true"]': {
          "&::after": {
            content: "'...'"
          }
        }
      }
    },
    "&[data-is-responsive=true]": {
      marginTop: 20,
      textAlign: "center"
    }
  }
});
const AcceptedFilesDescription = ({
  classes,
  fileExtensionWhitelistMap,
  responsive,
  filesLength
}) => {
  if (!fileExtensionWhitelistMap) return null;
  const fileExtensionsWhiteList = Object.entries(
    fileExtensionWhitelistMap
  );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classes.root,
      style: { marginBottom: responsive && filesLength > 0 ? "14px" : 0 },
      "data-is-responsive": responsive,
      children: [
        /* @__PURE__ */ jsx$1("h5", { children: "accepted file types" }),
        /* @__PURE__ */ jsx$1("ul", { children: fileExtensionsWhiteList.map(([category, extensionsList]) => {
          const extensionLength = extensionsList.length;
          return /* @__PURE__ */ jsxs("li", { children: [
            category,
            extensionsList.map((extension2, index2) => {
              if (index2 < 3) return /* @__PURE__ */ jsxs("span", { children: [
                extension2,
                ","
              ] }, extension2);
              if (index2 === 3 && extensionLength > 3)
                return /* @__PURE__ */ jsx$1(
                  "span",
                  {
                    "data-has-more-extension": extensionLength > 4,
                    title: extensionsList.slice(index2 + 1),
                    children: extension2
                  },
                  extension2
                );
              return null;
            })
          ] }, category);
        }) })
      ]
    }
  );
};
const AcceptedFilesDescription$1 = injectSheet(styles$c)(React__default.memo(AcceptedFilesDescription));
const ADD_FILES = "add_files";
const REMOVE_FILE = "remove_file";
const ERROR = "error";
const PROGRESS = "progress";
const SUCCESS = "success";
const ERROR_TYPE_SIZE = "size";
const ERROR_TYPE_EXTENSION = "extension";
const ERROR_TYPE_DEFAULT = "default";
const reducer = (files, { type: type2, payload }) => {
  const idx = !Array.isArray(files) ? -1 : files.findIndex((f2) => payload.id === f2.id);
  switch (type2) {
    case ADD_FILES: {
      return [...files, ...payload.mergedFiles];
    }
    case REMOVE_FILE: {
      return [...files.filter((p2) => p2.id !== payload.id)];
    }
    case PROGRESS: {
      if (idx === -1) return files;
      const fileUploading = {
        ...files[idx],
        uploading: true,
        // safeguard from submitting a file in progress
        uploadPercent: payload.percentage
      };
      return [...files.slice(0, idx), fileUploading, ...files.slice(idx + 1)];
    }
    case ERROR: {
      if (idx === -1) return files;
      const fileError = {
        ...files[idx],
        error: true,
        // safeguard from submitting a file error
        errorType: ERROR_TYPE_DEFAULT
      };
      return [...files.slice(0, idx), fileError, ...files.slice(idx + 1)];
    }
    case SUCCESS: {
      if (idx === -1) return files;
      const fileSuccess = {
        ...payload.file,
        uploading: false,
        error: false
      };
      return [...files.slice(0, idx), fileSuccess, ...files.slice(idx + 1)];
    }
    default: {
      return files;
    }
  }
};
const applyFilesChange = (files, action, onChange) => {
  const newFiles = reducer(files, action);
  onChange(newFiles);
};
const styles$b = (theme2) => ({
  root: {
    position: "relative",
    border: `1px solid ${theme2.grey5}`,
    borderRadius: 10,
    backgroundColor: theme2.white1,
    transition: "200ms ease-out",
    "&[data-drag-enter=true]": {
      border: `1px solid ${theme2.indigo2}`
    }
  },
  dropzoneWrapper: {
    display: "flex",
    flexDirection: "column",
    padding: "20px 5px",
    transition: "200ms ease-out",
    "&[data-drag-enter=true]": {
      opacity: 0.2
    },
    "&[data-is-responsive=true]": {
      padding: "15px 15px 0 15px"
    }
  },
  dropzoneBody: {
    display: "flex",
    "&[data-is-responsive=true]": {
      height: "100%"
    },
    "@media (max-width: 960px)": {
      flexDirection: "column"
    }
  },
  leftColumn: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    flex: "2 2 20em",
    height: "100%",
    paddingRight: 25,
    borderRight: `1px solid ${theme2.grey5}`,
    "@media (max-width: 1170px)": {
      paddingLeft: 10,
      paddingRight: 10,
      borderLeft: "none",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    },
    "@media (max-width: 960px)": {
      borderRight: "none",
      borderBottom: `1px solid ${theme2.grey5}`
    }
  },
  leftColumnContent: {
    position: "relative",
    zIndex: 2,
    minHeight: "inherit",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    opacity: 1,
    transition: "opacity 200ms linear 100ms",
    minWidth: 170
  },
  rightColumn: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 20em",
    height: "100%",
    overflowX: "hidden",
    overflowY: "auto",
    marginLeft: 10,
    "&[data-is-responsive=true]": {
      marginTop: 20,
      maxHeight: 185,
      order: 2,
      marginLeft: 0,
      "&[data-is-disabled=true]": {
        marginTop: 0
      }
    }
  },
  dropzoneLabel: {
    fontSize: 14,
    color: theme2.grey1,
    marginBottom: 10,
    textAlign: "center",
    "& p": {
      lineHeight: "18px"
    },
    "& p:first-child": {
      marginBottom: 10
    }
  },
  dropzoneIcon: {
    color: theme2.indigo3,
    position: "absolute",
    top: "calc(50% - 14px)",
    left: "calc(50% - 14px)",
    opacity: 0,
    transform: "translateY(-28px)",
    transition: "opacity 200ms linear, transform 0ms linear 300ms",
    "&[data-drag-enter=true]": {
      zIndex: 2,
      opacity: 1,
      transform: "translateY(0)",
      transition: "opacity 200ms linear 200ms, transform 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275) 200ms"
    }
  },
  fileSelectBtn: {
    color: theme2.grey3,
    backgroundColor: "transparent",
    border: `1px solid ${theme2.grey5}`,
    borderRadius: 4,
    padding: "7px 15px",
    fontWeight: 700,
    fontSize: 11,
    lineHeight: "14px",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    cursor: "pointer",
    transition: "color 100ms linear",
    marginBottom: 1,
    "&:focus": {
      outline: "none",
      color: theme2.indigo3
    },
    "&:hover": {
      color: theme2.indigo3
    }
  },
  sizeWarning: {
    color: theme2.grey4,
    fontSize: 10,
    letterSpacing: "0.24px",
    padding: "10px 0"
  },
  answersFileUpload: {
    display: "none"
  }
});
const BATCHED_FORM_WIDTH = 375;
const FileUploadField$1 = (props2) => {
  var _a2, _b2;
  const {
    classes,
    schema: { title: title2 },
    formContext: { uploadFile, uploadConfig: uploadConfig2, links },
    formData,
    onChange,
    required: required2,
    idSchema,
    uiSchema
  } = props2;
  const filesRef = React__default.useRef([]);
  filesRef.current = formData || [];
  const fieldId = idSchema.$id;
  const isLocked = isLockedWidget(fieldId, links);
  const [dropzoneActive, setDropzoneActive] = React__default.useState(false);
  let dropzoneRef = React__default.useRef(null);
  const container = React__default.useRef();
  const [measureRef, bounds] = useMeasure(container, 0);
  const filesCount = filesRef.current.length;
  const errorsCount = filesRef.current.filter((f2) => f2.error).length;
  const responsive = bounds.width <= BATCHED_FORM_WIDTH;
  const maxFileSize = uploadConfig2 && uploadConfig2.maxFileSize || 1024 * 1024 * 10;
  const fileExtensionWhitelistMap = uploadConfig2 && uploadConfig2.fileExtensionWhitelistMap || null;
  const handleNewFiles = React__default.useCallback(
    (acceptedFiles) => {
      if (isLocked) return;
      const fileExtensionWhitelist = uploadConfig2 && uploadConfig2.fileExtensionWhitelistMap && Object.values(uploadConfig2.fileExtensionWhitelistMap).flat(
        1
      ) || [];
      const newFiles = acceptedFiles.filter(
        (f2) => !filesRef.current.find((i3) => f2.name === i3.name)
      );
      onDragLeave();
      if (!newFiles.length) return;
      const forbiddenFileExtensions = acceptedFiles.filter(
        (file) => fileExtensionWhitelist.length > 0 && !fileExtensionWhitelist.includes(extension(file.name))
      );
      const exceedSizeLimit = acceptedFiles.filter(
        (file) => file.size > maxFileSize && !forbiddenFileExtensions.includes(file)
      );
      const readyToUpload = acceptedFiles.filter(
        (el2) => !exceedSizeLimit.includes(el2) && !forbiddenFileExtensions.includes(el2)
      );
      const onFileSuccess = (id2) => (file) => applyFilesChange(
        filesRef.current,
        {
          type: SUCCESS,
          payload: { id: id2, file }
        },
        onChange
      );
      const onFileError = (id2) => () => applyFilesChange(
        filesRef.current,
        { type: ERROR, payload: { id: id2 } },
        onChange
      );
      const onFileProgress = (id2, percentage) => applyFilesChange(
        filesRef.current,
        {
          type: PROGRESS,
          payload: { id: id2, percentage }
        },
        onChange
      );
      const uploading = readyToUpload.map((file) => {
        const id2 = `valid-${shortid$1.generate()}`;
        uploadFile(
          file,
          onFileSuccess(id2),
          onFileError(id2),
          (progress) => onFileProgress(id2, progress.uploadPercent)
        );
        return {
          id: id2,
          name: file.name,
          size: file.size,
          uploading: true,
          uploadPercent: 0
        };
      });
      const errorsExceedSizeLimit = exceedSizeLimit.map((file) => {
        const id2 = `err-too-big-${shortid$1.generate()}`;
        return {
          id: id2,
          name: file.name,
          size: file.size,
          error: true,
          errorType: ERROR_TYPE_SIZE,
          uploading: false
        };
      });
      const errorsForbiddenExtension = forbiddenFileExtensions.map((file) => {
        const id2 = `err-wrong-ext-${shortid$1.generate()}`;
        return {
          id: id2,
          name: file.name,
          size: file.size,
          error: true,
          errorType: ERROR_TYPE_EXTENSION,
          uploading: false
        };
      });
      const errors2 = [...errorsExceedSizeLimit, ...errorsForbiddenExtension];
      const mergedFiles = [...uploading, ...errors2];
      applyFilesChange(
        filesRef.current,
        { type: ADD_FILES, payload: { mergedFiles } },
        onChange
      );
    },
    [isLocked, maxFileSize, onChange, uploadFile, uploadConfig2]
  );
  const handleDeleteFile = React__default.useCallback(
    (id2) => applyFilesChange(
      filesRef.current,
      { type: REMOVE_FILE, payload: { id: id2 } },
      onChange
    ),
    [onChange]
  );
  const onDragEnter = () => !isLocked && setDropzoneActive(true);
  const onDragLeave = () => setDropzoneActive(false);
  const handleFileButtonClick = () => dropzoneRef.open();
  const renderUploadedFiles = React__default.useMemo(() => {
    if (filesRef.current.length === 0) return null;
    return filesRef.current.map((file) => /* @__PURE__ */ jsx$1(
      File$2,
      {
        file,
        handleDeleteFile,
        maxFileSize,
        disabled: isLocked
      },
      file.id
    ));
  }, [handleDeleteFile, maxFileSize, isLocked]);
  const showSwitch = !!((_a2 = uiSchema["ui:options"]) == null ? void 0 : _a2.visibilitySwitchLabel);
  const switchLabel = (_b2 = uiSchema["ui:options"]) == null ? void 0 : _b2.visibilitySwitchLabel;
  const [showUpload, setShowUpload] = useState(!showSwitch);
  const handleSwitchClick = () => {
    setShowUpload((prevState) => !prevState);
  };
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    showSwitch && /* @__PURE__ */ jsx$1(
      Switch$1,
      {
        label: switchLabel,
        on: showUpload,
        handleChange: handleSwitchClick,
        showLabel: true
      }
    ),
    showUpload && /* @__PURE__ */ jsxs(FieldTemplate$1, { id: fieldId, label: title2, ...props2, children: [
      /* @__PURE__ */ jsx$1(Label$1, { filesCount, errorsCount }),
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: classes.root,
          "data-drag-enter": dropzoneActive,
          ref: measureRef,
          children: [
            /* @__PURE__ */ jsx$1(
              Dropzone,
              {
                className: classes.dropzoneWrapper,
                "data-is-responsive": responsive,
                onDragEnter,
                onDragLeave,
                onDrop: handleNewFiles,
                inputProps: { required: required2 },
                "data-drag-enter": dropzoneActive,
                multiple: true,
                disableClick: true,
                ref: (e5) => {
                  dropzoneRef = e5;
                },
                children: /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: classes.dropzoneBody,
                    "data-is-responsive": responsive,
                    children: [
                      !isLocked && /* @__PURE__ */ jsxs(
                        "div",
                        {
                          className: classes.leftColumn,
                          "data-is-responsive": responsive,
                          children: [
                            /* @__PURE__ */ jsxs(
                              "div",
                              {
                                className: classes.leftColumnContent,
                                "data-drag-enter": dropzoneActive,
                                "data-has-files": filesCount > 0,
                                "data-cy": "forms-js-dropzone-fileupload",
                                children: [
                                  /* @__PURE__ */ jsxs("div", { className: classes.dropzoneLabel, children: [
                                    /* @__PURE__ */ jsx$1("p", { children: "Drop files here" }),
                                    /* @__PURE__ */ jsx$1("p", { children: "or" })
                                  ] }),
                                  /* @__PURE__ */ jsx$1(
                                    "button",
                                    {
                                      className: classes.fileSelectBtn,
                                      type: "button",
                                      onClick: handleFileButtonClick,
                                      "data-cy": "forms-js-select-fileupload",
                                      children: "Select files"
                                    }
                                  ),
                                  maxFileSize && /* @__PURE__ */ jsx$1("span", { className: classes.sizeWarning, children: `Maximum file size is ${filesize(maxFileSize)}` })
                                ]
                              }
                            ),
                            /* @__PURE__ */ jsx$1(
                              AcceptedFilesDescription$1,
                              {
                                fileExtensionWhitelistMap,
                                responsive,
                                filesLength: filesRef.current.length
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ jsx$1(
                        "ul",
                        {
                          className: classes.rightColumn,
                          "data-is-responsive": responsive,
                          "data-is-disabled": isLocked,
                          children: renderUploadedFiles
                        }
                      )
                    ]
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx$1(
              "div",
              {
                className: classes.dropzoneIcon,
                "data-drag-enter": dropzoneActive,
                children: /* @__PURE__ */ jsx$1(Icon$2, { name: "ArrowDown", size: 22 })
              }
            )
          ]
        }
      )
    ] })
  ] });
};
const FileUploadField$2 = compose(
  withInlineValidation,
  injectSheet(styles$b)
)(React__default.memo(FileUploadField$1));
const fields$1 = {
  FileUploadField: FileUploadField$2
};
const styles$a = () => ({
  root: {
    width: "100%"
  },
  buttonWrapper: {
    display: "flex",
    padding: "14",
    flexGrow: 1,
    justifyContent: "flex-end"
  },
  button: {
    marginLeft: 14
  }
});
class FormWriter extends React__default.PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      onErrorTriggered: false,
      blurredFields: []
    });
    __publicField(this, "validate", validate(this.props.schema, this.props.uiSchema));
    __publicField(this, "resetBlurredFields", () => this.setState({ blurredFields: [] }));
    __publicField(this, "onError", (errors2) => {
      const { formData, onChange } = this.props;
      onChange({ formData, errors: errors2 });
      this.setState({ onErrorTriggered: true });
      const onErrorProp = this.props.onError;
      if (onErrorProp) onErrorProp(errors2);
    });
    __publicField(this, "onSubmit", (value) => {
      const { onSubmit } = this.props;
      onSubmit(value);
      this.resetBlurredFields();
    });
    __publicField(this, "transformErrors", (errors2) => errors2.map((error2) => {
      if (error2.name === "pattern") error2.message = "should match the format";
      return error2;
    }));
    __publicField(this, "onBlurHandler", (id2) => {
      const { blurredFields } = this.state;
      const newBlurredFields = [...blurredFields];
      if (!newBlurredFields.includes(id2)) {
        newBlurredFields.push(id2);
        this.setState({ blurredFields: newBlurredFields });
      }
    });
  }
  render() {
    const {
      classes,
      className,
      id: id2,
      schema,
      uiSchema,
      disabled,
      children,
      formData,
      onChange,
      uploadFile,
      uploadImage,
      uploadConfig: uploadConfig2,
      downloadImage,
      links,
      workflowContext
    } = this.props;
    const { blurredFields, onErrorTriggered } = this.state;
    const context = {
      uploadFile,
      uploadImage,
      uploadConfig: uploadConfig2,
      downloadImage,
      onErrorTriggered,
      blurredFields,
      onBlur: this.onBlurHandler,
      links,
      workflowContext
    };
    const customFormats = {
      "workflow-group": workflowGroupCustomFormat(workflowContext)
    };
    const validator2 = customizeValidator({ customFormats });
    return /* @__PURE__ */ jsx$1(Fragment$1, { children: /* @__PURE__ */ jsx$1("div", { className: classNames(className, classes.root), children: /* @__PURE__ */ jsx$1(
      Form,
      {
        id: id2,
        idPrefix: id2,
        schema,
        uiSchema,
        widgets: widgets$1,
        fields: fields$1,
        templates: {
          FieldTemplate: FieldTemplate$1,
          ObjectFieldTemplate,
          ArrayFieldTemplate: ArrayFieldTemplate$1
        },
        formData: formData || {},
        formContext: context,
        disabled,
        noHtml5Validate: true,
        onError: this.onError,
        transformErrors: this.transformErrors,
        liveValidate: true,
        customValidate: this.validate,
        validator: validator2,
        showErrorList: false,
        onChange,
        onSubmit: this.onSubmit,
        children
      }
    ) }) });
  }
}
__publicField(FormWriter, "defaultProps", {
  className: "",
  // Pass empty div to disable submit button by default
  children: /* @__PURE__ */ jsx$1("div", {}),
  formData: {},
  disabled: false
});
const index = injectSheet(styles$a)(FormWriter);
const styles$9 = {
  root: {
    "&[data-is-bottom-margin=true]": {
      marginBottom: 15
    }
  },
  styledDiv: {
    color: "#333333",
    fontSize: 18,
    weight: "bolder",
    marginBottom: 10
  }
};
const fieldTypes = /* @__PURE__ */ new Set(["string", "boolean", "number", "integer", "array"]);
const Field = ({ classes, children, schema, uiSchema }) => {
  const [marginBottom, setMarginBottom] = useState(false);
  const {
    props: { children: childrenProps }
  } = children;
  useEffect(() => {
    if (fieldTypes.has(schema.type)) {
      setMarginBottom(true);
    }
  }, [schema.type]);
  const uiWidget = uiSchema == null ? void 0 : uiSchema["ui:widget"];
  if (uiWidget === "hidden") return null;
  const hasValue = Children$1.toArray(childrenProps).reduce(
    (acc, { props: { formData } }) => acc !== (typeof formData === "undefined"),
    true
  );
  return hasValue && uiWidget !== "hidden" ? /* @__PURE__ */ jsx$1("div", { className: classes.root, "data-is-bottom-margin": marginBottom, children }) : null;
};
const FieldTemplate = injectSheet(styles$9)(Field);
const styles$8 = (theme2) => ({
  fieldWrapper: {
    paddingTop: 14
  },
  fieldWrapperWithBorder: {
    borderLeft: `2px solid ${theme2.grey7}`,
    paddingLeft: 16,
    "&:hover": {
      borderColor: theme2.blue900
    }
  },
  text: {
    color: theme2.grey1,
    fontSize: 14,
    weight: 600,
    marginBlock: 10
  }
});
class ArrayField2 extends React__default.PureComponent {
  render() {
    const { classes, title: title2, items: items2 } = this.props;
    const arrayLength = items2.length;
    if (!arrayLength) return null;
    const hasMultipleItems = arrayLength > 1;
    return /* @__PURE__ */ jsx$1(
      KeyValue$1,
      {
        label: title2 ? `${title2} (${arrayLength} item${arrayLength === 1 ? "" : "s"})` : void 0,
        children: items2.map((item, index2) => /* @__PURE__ */ jsx$1(
          "div",
          {
            className: classNames({
              [classes.fieldWrapper]: true,
              [classes.fieldWrapperWithBorder]: hasMultipleItems
            }),
            style: { marginBottom: index2 < items2.length - 1 ? "20px" : "" },
            children: item.children
          },
          item.index
        ))
      }
    );
  }
}
const ArrayFieldTemplate = injectSheet(styles$8)(ArrayField2);
const TitleField = ({ title: title2 = "" }) => title2 ? /* @__PURE__ */ jsx$1("p", { children: title2 }) : null;
const styles$7 = (theme2) => ({
  root: {
    width: "100%",
    position: "relative"
  },
  attachment: {
    width: "100%",
    overflow: "hidden",
    position: "relative"
  },
  attachmentContainer: {
    minHeight: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme2.grey4
  },
  icon: {
    width: 42,
    height: 42
  },
  fileInfo: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 1,
    backgroundColor: theme2.grey8,
    opacity: 0,
    transition: "opacity 100ms linear",
    padding: 7,
    lineHeight: 1.4,
    fontSize: 12,
    color: theme2.grey2,
    "&[aria-hidden=false]": {
      opacity: 1
    }
  },
  fileName: {
    fontWeight: 700,
    wordBreak: "break-word",
    marginBottom: 3
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: 28,
    backgroundColor: theme2.grey6,
    display: "flex",
    paddingLeft: 7
  },
  label: {
    lineHeight: "28px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    minWidth: 0,
    flexGrow: 1,
    fontSize: 12,
    fontWeight: 400,
    color: theme2.grey2,
    marginRight: 7,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    "& span": {
      color: theme2.grey4
    }
  },
  labelActive: {
    display: "flex",
    alignItems: "center",
    color: theme2.indigo3
  },
  labelIcon: {
    width: 17,
    height: 17,
    marginRight: 7,
    borderRadius: 2,
    background: "#4B35D2",
    color: "#fff"
  },
  labelTickIcon: {
    width: 17,
    height: 17,
    marginRight: 7,
    borderRadius: 2,
    color: "#4B35D2",
    border: "1px #4B35D2 solid",
    padding: 2
  },
  fileExt: {
    height: "inherit",
    fontSize: 12,
    fontWeight: 700,
    color: theme2.grey2,
    lineHeight: "28px",
    paddingLeft: 7,
    paddingRight: 7,
    textTransform: "uppercase",
    backgroundColor: theme2.grey8
  }
});
const Item = ({ classes, file, downloadFile }) => {
  const [hovered, setHovered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [downloadResponse, setDownloadResponse] = useState(null);
  const handleMouseEnter = useCallback(() => setHovered(true), [hovered]);
  const handleMouseLeave = useCallback(() => setHovered(false), [hovered]);
  const renderDownloadStatus = () => downloadResponse === null ? /* @__PURE__ */ jsx$1(lib$a.Download, { className: classes.labelIcon }) : /* @__PURE__ */ jsx$1(lib$a.CheckboxTick, { className: classes.labelTickIcon });
  const renderDownloadFile = () => {
    var _a2;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        "data-cy": "download-file",
        className: classes.label,
        onClick: () => downloadFile(file, setIsLoading, isLoading, setDownloadResponse),
        children: [
          renderDownloadStatus(),
          /* @__PURE__ */ jsxs("p", { children: [
            file.name,
            " ",
            /* @__PURE__ */ jsx$1("span", { children: (_a2 = filesize(file.size)) == null ? void 0 : _a2.split(" ").join("") })
          ] })
        ]
      }
    );
  };
  return /* @__PURE__ */ jsx$1(
    "div",
    {
      "data-cy": "file-wrapper",
      className: classes.root,
      title: file.name,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      children: /* @__PURE__ */ jsx$1("div", { className: classes.attachment, children: renderDownloadFile() })
    }
  );
};
const Item$1 = injectSheet(styles$7)(withSnackbarsContext(React__default.memo(Item)));
const styles$6 = (theme2) => ({
  root: {
    paddingTop: 3
  },
  title: {
    fontFamily: "EuclidCircularB",
    fontSize: 16,
    fontWeight: 600,
    color: theme2.grey1
  },
  file: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 3,
    paddingBottom: 3,
    fontSize: 12,
    lineHeight: "18px",
    fontWeight: 400,
    color: theme2.grey2,
    "& > small": {
      fontSize: "inherit",
      color: theme2.grey3
    }
  },
  header: {
    display: "flex",
    justifyContent: "space-between"
  },
  count: {
    fontSize: 13,
    fontWeight: 700,
    color: theme2.grey1
  },
  downloadAll: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "5px",
    fontSize: 12,
    backgroundColor: theme2.blue50,
    color: theme2.blue800,
    flexShrink: 0,
    padding: "3px 10px",
    margin: "-10px 0 -10px 20px",
    borderRadius: 14,
    transition: "background-color 0.1s",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: theme2.blue100
    }
  }
});
const FileField = ({
  classes,
  formData,
  schema,
  formContext,
  uiSchema
}) => {
  const { downloadFile } = formContext || {};
  const options = uiSchema["ui:options"];
  return /* @__PURE__ */ jsx$1("div", { className: classes.keyValueContainer, children: /* @__PURE__ */ jsx$1(KeyValue$1, { label: !(options == null ? void 0 : options.noLabel) ? schema.title : void 0, children: /* @__PURE__ */ jsx$1("ul", { className: classes.root, children: formData.map((file) => /* @__PURE__ */ jsx$1("li", { className: classes.file, children: /* @__PURE__ */ jsx$1(Item$1, { file, downloadFile }) }, file.name)) }) }) });
};
const FileUploadField = injectSheet(styles$6)(FileField);
const fields = {
  FileUploadField,
  TitleField
};
const styles$5 = (theme2) => ({
  wrapper: {
    display: "flex",
    fontSize: 14,
    color: theme2.grey1
  },
  emDash: {
    display: "inline-flex",
    alignSelf: "center",
    paddingTop: 1,
    marginRight: 4,
    width: 7,
    backgroundColor: theme2.grey1
  }
});
const CheckboxWidget = ({ label, value, options }) => {
  const { enumOptions } = options;
  const selectedOption = enumOptions.find((option2) => option2.value === value) || {
    label: value
  };
  return /* @__PURE__ */ jsx$1(KeyValue$1, { label, children: selectedOption.label && /* @__PURE__ */ jsx$1("span", { children: selectedOption.label }) });
};
const CheckboxWidget$1 = injectSheet(styles$5)(CheckboxWidget);
const styles$4 = (theme2) => {
  const labelColor = theme2.grey1;
  return {
    labelWrapper: {
      display: "flex",
      flexDirection: "column",
      "&[data-is-inline=true]": {
        flexDirection: "row"
      }
    },
    title: {
      fontSize: 16,
      fontWeight: 600,
      color: theme2.grey3,
      marginBottom: 3
    },
    label: {
      display: "flex",
      fontSize: 14,
      color: labelColor,
      "&[data-is-inline=true]": {
        marginRight: 7
      }
    },
    gdprTitle: {
      fontSize: 10,
      fontWeight: 600,
      color: theme2.grey3,
      marginBottom: 3
    },
    gdprLabel: {
      display: "flex",
      fontSize: 9,
      color: labelColor,
      "&[data-is-inline=true]": {
        marginRight: 7
      }
    },
    emDash: {
      display: "inline-flex",
      alignSelf: "center",
      paddingTop: 1,
      marginRight: 4,
      width: 7,
      backgroundColor: labelColor
    }
  };
};
const CheckboxesWidget = ({
  schema: { title: title2 },
  options,
  value
}) => {
  const { enumOptions } = options;
  const hasGDPR = title2 === "GDPR regulation";
  const checkedItems = enumOptions.filter((option2) => value.indexOf(option2.value) !== -1 && option2.label).map((option2) => option2.label);
  return /* @__PURE__ */ jsx$1(KeyValue$1, { label: title2, children: !hasGDPR ? /* @__PURE__ */ jsx$1(ProseList$1, { items: checkedItems }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
    " ",
    checkedItems[0],
    " "
  ] }) });
};
CheckboxesWidget.defaultProps = {
  options: {
    inline: false
  }
};
const CheckboxesWidget$1 = injectSheet(styles$4)(CheckboxesWidget);
const formatNumber = (nbInput, formatDesc) => {
  const nb = Number(nbInput);
  if (Number.isNaN(nb)) return "";
  const usedFormat = typeof formatDesc === "object" ? formatDesc : {};
  const { locale: locale2, options } = usedFormat;
  const language = locale2 || navigator && navigator.language || "en-US";
  return nb.toLocaleString(language, options);
};
const styles$3 = (theme2) => ({
  label: {
    fontSize: 16,
    fontWeight: 600,
    color: theme2.grey3,
    marginBottom: 3
  },
  value: {
    display: "flex",
    fontSize: 14,
    color: theme2.grey1
  },
  title: {
    color: theme2.blue900,
    fontSize: 10,
    lineHeight: "12px",
    letterSpacing: "0.5px",
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textTransform: "uppercase",
    marginBottom: 3
  },
  valueContainer: {
    padding: "0 16px",
    marginLeft: 9,
    borderLeft: `2px solid ${theme2.grey7}`
  },
  externalLink: {
    color: theme2.blue900
  }
});
const TextWidget = ({
  classes,
  label = "",
  value = ""
}) => {
  if (label === "Answer") {
    return /* @__PURE__ */ jsx$1("div", { className: classes.value, children: !value && Number(value) ? formatNumber(value, {}) : value });
  }
  const formatTextValue = (value2) => {
    if (typeof value2 === "string" && (value2.startsWith("http://") || value2.startsWith("https://"))) {
      return /* @__PURE__ */ jsx$1(
        "a",
        {
          className: classes.externalLink,
          href: value2,
          target: "_blank",
          rel: "noopener noreferrer",
          children: value2
        }
      );
    }
    return !value2 && Number(value2) ? formatNumber(value2, {}) : value2;
  };
  return /* @__PURE__ */ jsx$1(KeyValue$1, { label, children: formatTextValue(value) });
};
const TextWidget$1 = injectSheet(styles$3)(TextWidget);
const DEFAULT_DISPLAY_FORMAT = "DD/MM/YYYY";
const DateWidget = ({
  value = "",
  options,
  ...props2
}) => {
  if (!value) return null;
  const date = hooks(value);
  console.log("options?.dateFormat: ", options == null ? void 0 : options.dateFormat);
  const dateFormat = (options == null ? void 0 : options.dateFormat) || DEFAULT_DISPLAY_FORMAT;
  return /* @__PURE__ */ jsx$1(TextWidget$1, { value: date.format(dateFormat), ...props2 });
};
const styles$2 = (theme2) => ({
  root: {
    fontSize: 16,
    color: theme2.grey4,
    "&[data-is-error=true]": {
      color: "red"
    }
  }
});
const NumericWidget = ({ classes, value = "" }) => {
  const error2 = value && value < 0;
  return /* @__PURE__ */ jsx$1("div", { className: classes.root, "data-is-error": error2, children: value !== null ? numeral(value).format("0,0.00") : "" });
};
const NumericWidget$1 = injectSheet(styles$2)(NumericWidget);
const Radio = ({ value = "", ...rest }) => {
  const { enumOptions } = rest.options;
  const selectedOption = enumOptions.find((option2) => option2.value === value) || {
    label: value
  };
  return /* @__PURE__ */ jsx$1(TextWidget$1, { value: selectedOption.label, ...rest });
};
const styles$1 = () => ({
  groupLabel: {
    display: "flex",
    flexFlow: "row nowrap",
    alignItems: "center"
  },
  groupAvatar: {
    marginRight: 8,
    flexShrink: 0
  }
});
const WorkflowGroup = ({
  classes,
  name: name2,
  avatar = null
}) => /* @__PURE__ */ jsxs("div", { className: classes.groupLabel, children: [
  avatar && /* @__PURE__ */ jsx$1("div", { className: classes.groupAvatar, children: /* @__PURE__ */ jsx$1(AvatarGroup$1, { src: avatar, size: 22 }) }),
  name2
] });
const WorkflowGroup$1 = injectSheet(styles$1)(React__default.memo(WorkflowGroup));
const styles = (theme2) => ({
  label: {
    fontSize: 16,
    fontWeight: 600,
    color: theme2.grey3,
    marginBottom: 3
  },
  value: {
    display: "flex",
    fontSize: 14,
    color: theme2.grey1
  }
});
const GroupWidget = ({
  classes,
  label = "",
  value = "",
  formContext
}) => {
  const selectedGroup = getSelectedGroupDetails(
    formContext.workflowContext,
    value
  );
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx$1("div", { className: classes.label, children: label }),
    /* @__PURE__ */ jsx$1("div", { className: classes.value, children: selectedGroup ? /* @__PURE__ */ jsx$1(
      WorkflowGroup$1,
      {
        name: selectedGroup.name || value,
        avatar: selectedGroup.avatar
      }
    ) : value })
  ] });
};
const GroupWidget$1 = injectSheet(styles)(GroupWidget);
const widgets = {
  TextWidget: TextWidget$1,
  NumericWidget: NumericWidget$1,
  CheckboxWidget: CheckboxWidget$1,
  CheckboxesWidget: CheckboxesWidget$1,
  draft: SlateReaderWidget$1,
  TextareaWidget: TextWidget$1,
  SelectWidget: TextWidget$1,
  RadioWidget: Radio,
  "alt-date": DateWidget,
  "workflow-group": GroupWidget$1,
  MultiSelectWidget: CheckboxesWidget$1
};
const FormReader = ({
  schema,
  uiSchema,
  formData,
  downloadFile,
  downloadImage,
  workflowContext,
  downloadAllFiles
}) => /* @__PURE__ */ jsx$1(
  Form,
  {
    disabled: true,
    schema,
    uiSchema,
    formData,
    widgets,
    fields,
    templates: {
      FieldTemplate,
      ObjectFieldTemplate: ObjectFieldReaderTemplate,
      ArrayFieldTemplate
    },
    showErrorList: false,
    formContext: {
      downloadFile,
      downloadImage,
      workflowContext,
      downloadAllFiles
    },
    noValidate: true,
    noHtml5Validate: true,
    validator,
    children: /* @__PURE__ */ jsx$1("button", { type: "submit", style: { display: "none" } })
  }
);
FormReader.defaultProps = {
  workflowContext: void 0
};
const dummyDownloadFile = (digest) => Promise.resolve(new File([], digest));
const dummyUploadFile = () => async (file, onSuccess, onError, onProgress) => {
  const id2 = shortid$1.generate();
  let success = {
    id: id2,
    name: "",
    digest: shortid$1.generate(),
    size: 600,
    mimetype: "",
    downloadUri: "",
    createdAt: ""
  };
  if (typeof file === "string") {
    success = {
      ...success,
      name: "file",
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      mimetype: "image/png",
      downloadUri: file
    };
  } else {
    success = {
      ...success,
      name: file.name,
      size: file.size,
      mimetype: file.type,
      downloadUri: file.name,
      createdAt: new Date(file.lastModified).toISOString()
    };
  }
  const dummyFileSize = 600;
  const final = success;
  if (onProgress) {
    for (let loaded = 0; loaded < dummyFileSize; loaded++) {
      await new Promise((res) => setTimeout(res, 1));
      onProgress({
        uploadBytes: loaded,
        uploadPercent: Math.round(loaded * 100 / dummyFileSize),
        totalPercent: 50 + Math.round(loaded * 50 / dummyFileSize)
      });
    }
  }
  return onSuccess(final);
};
const delay = async (ms) => new Promise((resolve3) => setTimeout(resolve3, ms));
const getFileFromUrl = async (url2, name2, defaultType = "image/jpeg") => {
  const response = await fetch(url2);
  const data = await response.blob();
  return new File([data], name2, {
    type: data.type || defaultType
  });
};
const isBase64 = (str) => {
  const base64Pattern = /^(?:[A-Za-z0-9+/]{4})*?(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
  return base64Pattern.test(str);
};
const base64ToFile = (base64, name2, defaultType = "image/jpeg") => {
  const byteString = atob(base64.split(",")[1]);
  const mimeString = base64.split(",")[0].split(":")[1].split(";")[0] || defaultType;
  const ab = new ArrayBuffer(byteString.length);
  const ia2 = new Uint8Array(ab);
  for (let i3 = 0; i3 < byteString.length; i3 += 1) {
    ia2[i3] = byteString.charCodeAt(i3);
  }
  return new File([ab], name2, { type: mimeString });
};
const dummyDownloadImage = async (data, onError, setLoading, loading, getResponse) => {
  if (loading) return;
  setLoading(true);
  await delay(2e3);
  if (isBase64(data.downloadUri)) {
    const file = base64ToFile(data, "image");
    if (getResponse) getResponse(file);
    setLoading(false);
  } else {
    getFileFromUrl(data.downloadUri, "image").then((res) => {
      if (getResponse) getResponse(res);
      setLoading(false);
    });
  }
};
const uploadConfig = {
  // Data Size Limit to upload files to S3 bucket
  MAX_FILE_SIZE: 1024 * 1024 * 100,
  // 100MB in bytes
  // Files with an extensions not in this list should be rejected
  FILE_EXTENSION_WHITELIST_MAP: {
    documents: [
      "doc",
      "txt",
      "pdf",
      "xml",
      "dot",
      "eml",
      "json",
      "msg",
      "odt",
      "oft",
      "one",
      "pages",
      "rtf",
      "xps",
      "docm",
      "docx"
    ],
    images: ["jpg", "png", "gif", "bmp", "ico", "jpeg", "tif", "tiff"],
    presentations: ["ppt", "pptx", "pps", "ppsx"],
    spreadsheets: ["xls", "csv", "numbers", "xlsm", "xlsx"],
    archives: ["zip", "rar", "tar", "gz", "tgz", "zipx"]
  }
};
export {
  ATC$1 as ATC,
  ATCGroup$1 as ATCGroup,
  Avatar$1 as Avatar,
  AvatarButton$1 as AvatarButton,
  AvatarGroup$1 as AvatarGroup,
  AvatarGroupButton$1 as AvatarGroupButton,
  index$9 as BreadCrumbs,
  Button$3 as Button,
  Check,
  index$n as Checkbox,
  index$k as ClickablePicture,
  Collection$1 as Collection,
  CollectionDescription$1 as CollectionDescription,
  CollectionItem$1 as CollectionItem,
  CollectionTitle$1 as CollectionTitle,
  index$8 as ConfirmationModal,
  DateRange$1 as DateRange,
  index$m as Dialog,
  Directory$1 as Directory,
  DirectoryRow$1 as DirectoryRow,
  Dropdown,
  Dumblabel$1 as Dumblabel,
  EditableLabelField$1 as EditableLabelField,
  EditableText$1 as EditableText,
  ErrorMessage$1 as ErrorMessage,
  FieldPasswordCompact,
  FieldSearchCompact,
  FieldSelectCompact,
  FieldText,
  FieldTextAreaCompact,
  FieldTextCompact,
  FieldTextarea,
  FormReader,
  index as FormWriter,
  header as Header,
  HeaderSection$1 as HeaderSection,
  header_section_item as HeaderSectionItem,
  Icon$2 as Icon,
  Iconbutton,
  IconbuttonAdd,
  IconbuttonClose,
  index$f as IdentityLogomark,
  InfoTooltip$1 as InfoTooltip,
  index$l as InputCollection,
  isolate as Isolate,
  isolate_header as IsolateHeader,
  isolate_main as IsolateMain,
  KeyValue$1 as KeyValue,
  kanban as LayoutKanban,
  kanban_aside as LayoutKanbanAside,
  kanban_header as LayoutKanbanHeader,
  kanban_main as LayoutKanbanMain,
  LoaderTraceLogo$1 as LoaderTraceLogo,
  loader_unsure as LoaderUnsure,
  logo as Logo,
  LogoMark$1 as LogoMark,
  LogoText$1 as LogoText,
  logo_triangle as LogoTriangle,
  menu as Menu,
  menu_item as MenuItem,
  menu_item_href as MenuItemHref,
  index$3 as MessageModal,
  Modal$1 as Modal,
  ModalActions$1 as ModalActions,
  ModalContent$1 as ModalContent,
  MultiSelect$1 as MultiSelect,
  navbar as Navbar,
  NavbarLink$1 as NavbarLink,
  NavbarSection$1 as NavbarSection,
  notFound as NotFound,
  oops as Oops,
  option as Option,
  OptionDrop,
  index$c as OrganisationAvatar,
  Popover,
  PopoverMenuItem$1 as PopoverMenuItem,
  index$a as Profile,
  ProfileAvatar$1 as ProfileAvatar,
  index$2 as ProfileButton,
  index$j as ProfileInfo,
  Prose$1 as Prose,
  ProseList$1 as ProseList,
  Pulldown,
  pulldown_menu_item as PulldownMenuItem,
  Pushbutton$1 as Pushbutton,
  index$5 as PushbuttonHref,
  pushtext as Pushtext,
  pushtext_href as PushtextHref,
  RadioButton$1 as RadioButton,
  RichEditor$1 as RichEditor,
  SmartDropdown$1 as SmartDropdown,
  Smartlabel$1 as Smartlabel,
  index$7 as Snackbars,
  SnackbarsContext,
  stage as Stage,
  stage_item as StageItem,
  StratumnLogomark,
  Switch$1 as Switch,
  index$6 as Tabs,
  tally as Tally,
  TextEllipsis$1 as TextEllipsis,
  Textarea,
  Textinput$1 as Textinput,
  tile as Tile,
  index$i as Title,
  todo as Todo,
  todo_item as TodoItem,
  index$b as ToggleIconFilter,
  index$g as TraceLogo,
  index$h as TraceLogomark,
  index$4 as Tray,
  uicon_arrow_down as UiconArrowDown,
  uicon_arrow_incoming as UiconArrowIncoming,
  uicon_arrow_incoming_fill as UiconArrowIncomingFill,
  uicon_arrow_light_left as UiconArrowLightLeft,
  uicon_arrow_light_right as UiconArrowLightRight,
  uicon_arrow_min_down as UiconArrowMinDown,
  uicon_arrow_min_top as UiconArrowMinTop,
  uicon_arrow_outgoing as UiconArrowOutgoing,
  uicon_arrow_outgoing_fill as UiconArrowOutgoingFill,
  uicon_arrow_simple_left as UiconArrowSimpleLeft,
  uicon_arrow_simple_right as UiconArrowSimpleRight,
  uicon_bullets as UiconBullets,
  uicon_bullets_fill as UiconBulletsFill,
  uicon_calendar as UiconCalendar,
  uicon_check_circle as UiconCheckCircle,
  uicon_check_circle_fill as UiconCheckCircleFill,
  uicon_check_shield as UiconCheckShield,
  uicon_circle_cross as UiconCircleCross,
  uicon_circle_cross_fill as UiconCircleCrossFill,
  uicon_circle_info as UiconCircleInfo,
  uicon_circle_info_fill as UiconCircleInfoFill,
  uicon_circle_plus as UiconCirclePlus,
  uicon_circle_plus_fill as UiconCirclePlusFill,
  uicon_circle_profile as UiconCircleProfile,
  uicon_circle_profile_fill as UiconCircleProfileFill,
  uicon_circle_tick as UiconCircleTick,
  uicon_circle_tick_fill as UiconCircleTickFill,
  uicon_clipboard as UiconClipboard,
  uicon_doc as UiconDoc,
  uicon_doc_download as UiconDocDownload,
  uicon_doc_download_fill as UiconDocDownloadFill,
  uicon_doc_eye as UiconDocEye,
  uicon_doc_eye_fill as UiconDocEyeFill,
  uicon_doc_fill as UiconDocFill,
  uicon_doc_pen as UiconDocPen,
  uicon_doc_pen_fill as UiconDocPenFill,
  uicon_doc_plus as UiconDocPlus,
  uicon_doc_plus_fill as UiconDocPlusFill,
  uicon_doc_search as UiconDocSearch,
  uicon_doc_search_fill as UiconDocSearchFill,
  uicon_doc_tick as UiconDocTick,
  uicon_doc_tick_fill as UiconDocTickFill,
  uicon_doc_upload as UiconDocUpload,
  uicon_doc_upload_fill as UiconDocUploadFill,
  uicon_download as UiconDownload,
  uicon_filter as UiconFilter,
  uicon_flag_fill as UiconFlagFill,
  uicon_key_horizontal as UiconKeyHorizontal,
  uicon_link as UiconLink,
  uicon_link_fill as UiconLinkFill,
  uicon_link_horizontal as UiconLinkHorizontal,
  uicon_loupe as UiconLoupe,
  uicon_upload as UiconUpload,
  index$d as UrlSelector,
  index$e as ViewTitle,
  dummyDownloadFile,
  dummyDownloadImage,
  dummyUploadFile,
  getStringFromValue as getStringFromValueFromRichTextEditor,
  icons,
  theme,
  uploadConfig,
  useKeyPress,
  useMeasure,
  useOnClickOutside,
  withSnackbarsContext
};
//# sourceMappingURL=main.js.map
